/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(9);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _common = __webpack_require__(204);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _components = __webpack_require__(362);
	
	var _components2 = _interopRequireDefault(_components);
	
	var _app = __webpack_require__(200);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _app3 = __webpack_require__(201);
	
	var _app4 = _interopRequireDefault(_app3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Importando componentes base
	var root = _angular2.default.module('app', [_app4.default, _common2.default, _components2.default]).component('app', _app2.default).constant().name;
	
	// Bootstrap the app.
	document.addEventListener('DOMContentLoaded', function () {
	    return _angular2.default.bootstrap(document, ['app']);
	});
	
	exports.default = root;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	var __spreadArrays = (this && this.__spreadArrays) || function () {
	    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	    for (var r = Array(s), k = 0, i = 0; i < il; i++)
	        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	            r[k] = a[j];
	    return r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.silentRejection = exports.silenceUncaughtInPromise = exports._extend = exports.copy = exports.tail = exports.applyPairs = exports.arrayTuples = exports.pairs = exports.assertFn = exports.assertMap = exports.assertPredicate = exports.flatten = exports.unnest = exports.uniqR = exports.pushR = exports.flattenR = exports.unnestR = exports.anyTrueR = exports.allTrueR = exports.values = exports.map = exports.mapObj = exports.find = exports.filter = exports.pluck = exports.omit = exports.pick = exports.ancestors = exports.mergeR = exports.defaults = exports.deregAll = exports._pushTo = exports.pushTo = exports._removeFrom = exports.removeFrom = exports._inArray = exports.inArray = exports.inherit = exports.createProxyFunctions = exports.noop = exports.identity = exports.equals = exports.extend = exports.forEach = exports.toJson = exports.fromJson = exports.root = void 0;
	/**
	 * Random utility functions used in the UI-Router code
	 *
	 * These functions are exported, but are subject to change without notice.
	 *
	 * @packageDocumentation
	 * @preferred
	 */
	var predicates_1 = __webpack_require__(2);
	var hof_1 = __webpack_require__(3);
	var coreservices_1 = __webpack_require__(5);
	exports.root = (typeof self === 'object' && self.self === self && self) ||
	    (typeof global === 'object' && global.global === global && global) ||
	    this;
	var angular = exports.root.angular || {};
	exports.fromJson = angular.fromJson || JSON.parse.bind(JSON);
	exports.toJson = angular.toJson || JSON.stringify.bind(JSON);
	exports.forEach = angular.forEach || _forEach;
	exports.extend = Object.assign || _extend;
	exports.equals = angular.equals || _equals;
	function identity(x) {
	    return x;
	}
	exports.identity = identity;
	function noop() { }
	exports.noop = noop;
	/**
	 * Builds proxy functions on the `to` object which pass through to the `from` object.
	 *
	 * For each key in `fnNames`, creates a proxy function on the `to` object.
	 * The proxy function calls the real function on the `from` object.
	 *
	 *
	 * #### Example:
	 * This example creates an new class instance whose functions are prebound to the new'd object.
	 * ```js
	 * class Foo {
	 *   constructor(data) {
	 *     // Binds all functions from Foo.prototype to 'this',
	 *     // then copies them to 'this'
	 *     bindFunctions(Foo.prototype, this, this);
	 *     this.data = data;
	 *   }
	 *
	 *   log() {
	 *     console.log(this.data);
	 *   }
	 * }
	 *
	 * let myFoo = new Foo([1,2,3]);
	 * var logit = myFoo.log;
	 * logit(); // logs [1, 2, 3] from the myFoo 'this' instance
	 * ```
	 *
	 * #### Example:
	 * This example creates a bound version of a service function, and copies it to another object
	 * ```
	 *
	 * var SomeService = {
	 *   this.data = [3, 4, 5];
	 *   this.log = function() {
	 *     console.log(this.data);
	 *   }
	 * }
	 *
	 * // Constructor fn
	 * function OtherThing() {
	 *   // Binds all functions from SomeService to SomeService,
	 *   // then copies them to 'this'
	 *   bindFunctions(SomeService, this, SomeService);
	 * }
	 *
	 * let myOtherThing = new OtherThing();
	 * myOtherThing.log(); // logs [3, 4, 5] from SomeService's 'this'
	 * ```
	 *
	 * @param source A function that returns the source object which contains the original functions to be bound
	 * @param target A function that returns the target object which will receive the bound functions
	 * @param bind A function that returns the object which the functions will be bound to
	 * @param fnNames The function names which will be bound (Defaults to all the functions found on the 'from' object)
	 * @param latebind If true, the binding of the function is delayed until the first time it's invoked
	 */
	function createProxyFunctions(source, target, bind, fnNames, latebind) {
	    if (latebind === void 0) { latebind = false; }
	    var bindFunction = function (fnName) { return source()[fnName].bind(bind()); };
	    var makeLateRebindFn = function (fnName) {
	        return function lateRebindFunction() {
	            target[fnName] = bindFunction(fnName);
	            return target[fnName].apply(null, arguments);
	        };
	    };
	    fnNames = fnNames || Object.keys(source());
	    return fnNames.reduce(function (acc, name) {
	        acc[name] = latebind ? makeLateRebindFn(name) : bindFunction(name);
	        return acc;
	    }, target);
	}
	exports.createProxyFunctions = createProxyFunctions;
	/**
	 * prototypal inheritance helper.
	 * Creates a new object which has `parent` object as its prototype, and then copies the properties from `extra` onto it
	 */
	exports.inherit = function (parent, extra) { return exports.extend(Object.create(parent), extra); };
	/** Given an array, returns true if the object is found in the array, (using indexOf) */
	exports.inArray = hof_1.curry(_inArray);
	function _inArray(array, obj) {
	    return array.indexOf(obj) !== -1;
	}
	exports._inArray = _inArray;
	/**
	 * Given an array, and an item, if the item is found in the array, it removes it (in-place).
	 * The same array is returned
	 */
	exports.removeFrom = hof_1.curry(_removeFrom);
	function _removeFrom(array, obj) {
	    var idx = array.indexOf(obj);
	    if (idx >= 0)
	        array.splice(idx, 1);
	    return array;
	}
	exports._removeFrom = _removeFrom;
	/** pushes a values to an array and returns the value */
	exports.pushTo = hof_1.curry(_pushTo);
	function _pushTo(arr, val) {
	    return arr.push(val), val;
	}
	exports._pushTo = _pushTo;
	/** Given an array of (deregistration) functions, calls all functions and removes each one from the source array */
	exports.deregAll = function (functions) {
	    return functions.slice().forEach(function (fn) {
	        typeof fn === 'function' && fn();
	        exports.removeFrom(functions, fn);
	    });
	};
	/**
	 * Applies a set of defaults to an options object.  The options object is filtered
	 * to only those properties of the objects in the defaultsList.
	 * Earlier objects in the defaultsList take precedence when applying defaults.
	 */
	function defaults(opts) {
	    var defaultsList = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        defaultsList[_i - 1] = arguments[_i];
	    }
	    var defaultVals = exports.extend.apply(void 0, __spreadArrays([{}], defaultsList.reverse()));
	    return exports.extend(defaultVals, pick(opts || {}, Object.keys(defaultVals)));
	}
	exports.defaults = defaults;
	/** Reduce function that merges each element of the list into a single object, using extend */
	exports.mergeR = function (memo, item) { return exports.extend(memo, item); };
	/**
	 * Finds the common ancestor path between two states.
	 *
	 * @param {Object} first The first state.
	 * @param {Object} second The second state.
	 * @return {Array} Returns an array of state names in descending order, not including the root.
	 */
	function ancestors(first, second) {
	    var path = [];
	    // tslint:disable-next-line:forin
	    for (var n in first.path) {
	        if (first.path[n] !== second.path[n])
	            break;
	        path.push(first.path[n]);
	    }
	    return path;
	}
	exports.ancestors = ancestors;
	/**
	 * Return a copy of the object only containing the whitelisted properties.
	 *
	 * #### Example:
	 * ```
	 * var foo = { a: 1, b: 2, c: 3 };
	 * var ab = pick(foo, ['a', 'b']); // { a: 1, b: 2 }
	 * ```
	 * @param obj the source object
	 * @param propNames an Array of strings, which are the whitelisted property names
	 */
	function pick(obj, propNames) {
	    var objCopy = {};
	    for (var _prop in obj) {
	        if (propNames.indexOf(_prop) !== -1) {
	            objCopy[_prop] = obj[_prop];
	        }
	    }
	    return objCopy;
	}
	exports.pick = pick;
	/**
	 * Return a copy of the object omitting the blacklisted properties.
	 *
	 * @example
	 * ```
	 *
	 * var foo = { a: 1, b: 2, c: 3 };
	 * var ab = omit(foo, ['a', 'b']); // { c: 3 }
	 * ```
	 * @param obj the source object
	 * @param propNames an Array of strings, which are the blacklisted property names
	 */
	function omit(obj, propNames) {
	    return Object.keys(obj)
	        .filter(hof_1.not(exports.inArray(propNames)))
	        .reduce(function (acc, key) { return ((acc[key] = obj[key]), acc); }, {});
	}
	exports.omit = omit;
	/**
	 * Maps an array, or object to a property (by name)
	 */
	function pluck(collection, propName) {
	    return map(collection, hof_1.prop(propName));
	}
	exports.pluck = pluck;
	/** Filters an Array or an Object's properties based on a predicate */
	function filter(collection, callback) {
	    var arr = predicates_1.isArray(collection), result = arr ? [] : {};
	    var accept = arr ? function (x) { return result.push(x); } : function (x, key) { return (result[key] = x); };
	    exports.forEach(collection, function (item, i) {
	        if (callback(item, i))
	            accept(item, i);
	    });
	    return result;
	}
	exports.filter = filter;
	/** Finds an object from an array, or a property of an object, that matches a predicate */
	function find(collection, callback) {
	    var result;
	    exports.forEach(collection, function (item, i) {
	        if (result)
	            return;
	        if (callback(item, i))
	            result = item;
	    });
	    return result;
	}
	exports.find = find;
	/** Given an object, returns a new object, where each property is transformed by the callback function */
	exports.mapObj = map;
	/** Maps an array or object properties using a callback function */
	function map(collection, callback, target) {
	    target = target || (predicates_1.isArray(collection) ? [] : {});
	    exports.forEach(collection, function (item, i) { return (target[i] = callback(item, i)); });
	    return target;
	}
	exports.map = map;
	/**
	 * Given an object, return its enumerable property values
	 *
	 * @example
	 * ```
	 *
	 * let foo = { a: 1, b: 2, c: 3 }
	 * let vals = values(foo); // [ 1, 2, 3 ]
	 * ```
	 */
	exports.values = function (obj) { return Object.keys(obj).map(function (key) { return obj[key]; }); };
	/**
	 * Reduce function that returns true if all of the values are truthy.
	 *
	 * @example
	 * ```
	 *
	 * let vals = [ 1, true, {}, "hello world"];
	 * vals.reduce(allTrueR, true); // true
	 *
	 * vals.push(0);
	 * vals.reduce(allTrueR, true); // false
	 * ```
	 */
	exports.allTrueR = function (memo, elem) { return memo && elem; };
	/**
	 * Reduce function that returns true if any of the values are truthy.
	 *
	 *  * @example
	 * ```
	 *
	 * let vals = [ 0, null, undefined ];
	 * vals.reduce(anyTrueR, true); // false
	 *
	 * vals.push("hello world");
	 * vals.reduce(anyTrueR, true); // true
	 * ```
	 */
	exports.anyTrueR = function (memo, elem) { return memo || elem; };
	/**
	 * Reduce function which un-nests a single level of arrays
	 * @example
	 * ```
	 *
	 * let input = [ [ "a", "b" ], [ "c", "d" ], [ [ "double", "nested" ] ] ];
	 * input.reduce(unnestR, []) // [ "a", "b", "c", "d", [ "double, "nested" ] ]
	 * ```
	 */
	exports.unnestR = function (memo, elem) { return memo.concat(elem); };
	/**
	 * Reduce function which recursively un-nests all arrays
	 *
	 * @example
	 * ```
	 *
	 * let input = [ [ "a", "b" ], [ "c", "d" ], [ [ "double", "nested" ] ] ];
	 * input.reduce(unnestR, []) // [ "a", "b", "c", "d", "double, "nested" ]
	 * ```
	 */
	exports.flattenR = function (memo, elem) {
	    return predicates_1.isArray(elem) ? memo.concat(elem.reduce(exports.flattenR, [])) : pushR(memo, elem);
	};
	/**
	 * Reduce function that pushes an object to an array, then returns the array.
	 * Mostly just for [[flattenR]] and [[uniqR]]
	 */
	function pushR(arr, obj) {
	    arr.push(obj);
	    return arr;
	}
	exports.pushR = pushR;
	/** Reduce function that filters out duplicates */
	exports.uniqR = function (acc, token) { return (exports.inArray(acc, token) ? acc : pushR(acc, token)); };
	/**
	 * Return a new array with a single level of arrays unnested.
	 *
	 * @example
	 * ```
	 *
	 * let input = [ [ "a", "b" ], [ "c", "d" ], [ [ "double", "nested" ] ] ];
	 * unnest(input) // [ "a", "b", "c", "d", [ "double, "nested" ] ]
	 * ```
	 */
	exports.unnest = function (arr) { return arr.reduce(exports.unnestR, []); };
	/**
	 * Return a completely flattened version of an array.
	 *
	 * @example
	 * ```
	 *
	 * let input = [ [ "a", "b" ], [ "c", "d" ], [ [ "double", "nested" ] ] ];
	 * flatten(input) // [ "a", "b", "c", "d", "double, "nested" ]
	 * ```
	 */
	exports.flatten = function (arr) { return arr.reduce(exports.flattenR, []); };
	/**
	 * Given a .filter Predicate, builds a .filter Predicate which throws an error if any elements do not pass.
	 * @example
	 * ```
	 *
	 * let isNumber = (obj) => typeof(obj) === 'number';
	 * let allNumbers = [ 1, 2, 3, 4, 5 ];
	 * allNumbers.filter(assertPredicate(isNumber)); //OK
	 *
	 * let oneString = [ 1, 2, 3, 4, "5" ];
	 * oneString.filter(assertPredicate(isNumber, "Not all numbers")); // throws Error(""Not all numbers"");
	 * ```
	 */
	exports.assertPredicate = assertFn;
	/**
	 * Given a .map function, builds a .map function which throws an error if any mapped elements do not pass a truthyness test.
	 * @example
	 * ```
	 *
	 * var data = { foo: 1, bar: 2 };
	 *
	 * let keys = [ 'foo', 'bar' ]
	 * let values = keys.map(assertMap(key => data[key], "Key not found"));
	 * // values is [1, 2]
	 *
	 * let keys = [ 'foo', 'bar', 'baz' ]
	 * let values = keys.map(assertMap(key => data[key], "Key not found"));
	 * // throws Error("Key not found")
	 * ```
	 */
	exports.assertMap = assertFn;
	function assertFn(predicateOrMap, errMsg) {
	    if (errMsg === void 0) { errMsg = 'assert failure'; }
	    return function (obj) {
	        var result = predicateOrMap(obj);
	        if (!result) {
	            throw new Error(predicates_1.isFunction(errMsg) ? errMsg(obj) : errMsg);
	        }
	        return result;
	    };
	}
	exports.assertFn = assertFn;
	/**
	 * Like _.pairs: Given an object, returns an array of key/value pairs
	 *
	 * @example
	 * ```
	 *
	 * pairs({ foo: "FOO", bar: "BAR }) // [ [ "foo", "FOO" ], [ "bar": "BAR" ] ]
	 * ```
	 */
	exports.pairs = function (obj) { return Object.keys(obj).map(function (key) { return [key, obj[key]]; }); };
	/**
	 * Given two or more parallel arrays, returns an array of tuples where
	 * each tuple is composed of [ a[i], b[i], ... z[i] ]
	 *
	 * @example
	 * ```
	 *
	 * let foo = [ 0, 2, 4, 6 ];
	 * let bar = [ 1, 3, 5, 7 ];
	 * let baz = [ 10, 30, 50, 70 ];
	 * arrayTuples(foo, bar);       // [ [0, 1], [2, 3], [4, 5], [6, 7] ]
	 * arrayTuples(foo, bar, baz);  // [ [0, 1, 10], [2, 3, 30], [4, 5, 50], [6, 7, 70] ]
	 * ```
	 */
	function arrayTuples() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    if (args.length === 0)
	        return [];
	    var maxArrayLen = args.reduce(function (min, arr) { return Math.min(arr.length, min); }, 9007199254740991); // aka 2^53 − 1 aka Number.MAX_SAFE_INTEGER
	    var result = [];
	    var _loop_1 = function (i) {
	        // This is a hot function
	        // Unroll when there are 1-4 arguments
	        switch (args.length) {
	            case 1:
	                result.push([args[0][i]]);
	                break;
	            case 2:
	                result.push([args[0][i], args[1][i]]);
	                break;
	            case 3:
	                result.push([args[0][i], args[1][i], args[2][i]]);
	                break;
	            case 4:
	                result.push([args[0][i], args[1][i], args[2][i], args[3][i]]);
	                break;
	            default:
	                result.push(args.map(function (array) { return array[i]; }));
	                break;
	        }
	    };
	    for (var i = 0; i < maxArrayLen; i++) {
	        _loop_1(i);
	    }
	    return result;
	}
	exports.arrayTuples = arrayTuples;
	/**
	 * Reduce function which builds an object from an array of [key, value] pairs.
	 *
	 * Each iteration sets the key/val pair on the memo object, then returns the memo for the next iteration.
	 *
	 * Each keyValueTuple should be an array with values [ key: string, value: any ]
	 *
	 * @example
	 * ```
	 *
	 * var pairs = [ ["fookey", "fooval"], ["barkey", "barval"] ]
	 *
	 * var pairsToObj = pairs.reduce((memo, pair) => applyPairs(memo, pair), {})
	 * // pairsToObj == { fookey: "fooval", barkey: "barval" }
	 *
	 * // Or, more simply:
	 * var pairsToObj = pairs.reduce(applyPairs, {})
	 * // pairsToObj == { fookey: "fooval", barkey: "barval" }
	 * ```
	 */
	function applyPairs(memo, keyValTuple) {
	    var key, value;
	    if (predicates_1.isArray(keyValTuple))
	        key = keyValTuple[0], value = keyValTuple[1];
	    if (!predicates_1.isString(key))
	        throw new Error('invalid parameters to applyPairs');
	    memo[key] = value;
	    return memo;
	}
	exports.applyPairs = applyPairs;
	/** Get the last element of an array */
	function tail(arr) {
	    return (arr.length && arr[arr.length - 1]) || undefined;
	}
	exports.tail = tail;
	/**
	 * shallow copy from src to dest
	 */
	function copy(src, dest) {
	    if (dest)
	        Object.keys(dest).forEach(function (key) { return delete dest[key]; });
	    if (!dest)
	        dest = {};
	    return exports.extend(dest, src);
	}
	exports.copy = copy;
	/** Naive forEach implementation works with Objects or Arrays */
	function _forEach(obj, cb, _this) {
	    if (predicates_1.isArray(obj))
	        return obj.forEach(cb, _this);
	    Object.keys(obj).forEach(function (key) { return cb(obj[key], key); });
	}
	function _extend(toObj) {
	    for (var i = 1; i < arguments.length; i++) {
	        var obj = arguments[i];
	        if (!obj)
	            continue;
	        var keys = Object.keys(obj);
	        for (var j = 0; j < keys.length; j++) {
	            toObj[keys[j]] = obj[keys[j]];
	        }
	    }
	    return toObj;
	}
	exports._extend = _extend;
	function _equals(o1, o2) {
	    if (o1 === o2)
	        return true;
	    if (o1 === null || o2 === null)
	        return false;
	    if (o1 !== o1 && o2 !== o2)
	        return true; // NaN === NaN
	    var t1 = typeof o1, t2 = typeof o2;
	    if (t1 !== t2 || t1 !== 'object')
	        return false;
	    var tup = [o1, o2];
	    if (hof_1.all(predicates_1.isArray)(tup))
	        return _arraysEq(o1, o2);
	    if (hof_1.all(predicates_1.isDate)(tup))
	        return o1.getTime() === o2.getTime();
	    if (hof_1.all(predicates_1.isRegExp)(tup))
	        return o1.toString() === o2.toString();
	    if (hof_1.all(predicates_1.isFunction)(tup))
	        return true; // meh
	    var predicates = [predicates_1.isFunction, predicates_1.isArray, predicates_1.isDate, predicates_1.isRegExp];
	    if (predicates.map(hof_1.any).reduce(function (b, fn) { return b || !!fn(tup); }, false))
	        return false;
	    var keys = {};
	    // tslint:disable-next-line:forin
	    for (var key in o1) {
	        if (!_equals(o1[key], o2[key]))
	            return false;
	        keys[key] = true;
	    }
	    for (var key in o2) {
	        if (!keys[key])
	            return false;
	    }
	    return true;
	}
	function _arraysEq(a1, a2) {
	    if (a1.length !== a2.length)
	        return false;
	    return arrayTuples(a1, a2).reduce(function (b, t) { return b && _equals(t[0], t[1]); }, true);
	}
	// issue #2676
	exports.silenceUncaughtInPromise = function (promise) { return promise.catch(function (e) { return 0; }) && promise; };
	exports.silentRejection = function (error) { return exports.silenceUncaughtInPromise(coreservices_1.services.$q.reject(error)); };
	//# sourceMappingURL=common.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.isPromise = exports.isInjectable = exports.isRegExp = exports.isDate = exports.isArray = exports.isObject = exports.isString = exports.isNumber = exports.isFunction = exports.isNullOrUndefined = exports.isNull = exports.isDefined = exports.isUndefined = void 0;
	/**
	 * Predicates
	 *
	 * These predicates return true/false based on the input.
	 * Although these functions are exported, they are subject to change without notice.
	 *
	 * @packageDocumentation
	 */
	var hof_1 = __webpack_require__(3);
	var toStr = Object.prototype.toString;
	var tis = function (t) { return function (x) { return typeof x === t; }; };
	exports.isUndefined = tis('undefined');
	exports.isDefined = hof_1.not(exports.isUndefined);
	exports.isNull = function (o) { return o === null; };
	exports.isNullOrUndefined = hof_1.or(exports.isNull, exports.isUndefined);
	exports.isFunction = tis('function');
	exports.isNumber = tis('number');
	exports.isString = tis('string');
	exports.isObject = function (x) { return x !== null && typeof x === 'object'; };
	exports.isArray = Array.isArray;
	exports.isDate = (function (x) { return toStr.call(x) === '[object Date]'; });
	exports.isRegExp = (function (x) { return toStr.call(x) === '[object RegExp]'; });
	/**
	 * Predicate which checks if a value is injectable
	 *
	 * A value is "injectable" if it is a function, or if it is an ng1 array-notation-style array
	 * where all the elements in the array are Strings, except the last one, which is a Function
	 */
	function isInjectable(val) {
	    if (exports.isArray(val) && val.length) {
	        var head = val.slice(0, -1), tail = val.slice(-1);
	        return !(head.filter(hof_1.not(exports.isString)).length || tail.filter(hof_1.not(exports.isFunction)).length);
	    }
	    return exports.isFunction(val);
	}
	exports.isInjectable = isInjectable;
	/**
	 * Predicate which checks if a value looks like a Promise
	 *
	 * It is probably a Promise if it's an object, and it has a `then` property which is a Function
	 */
	exports.isPromise = hof_1.and(exports.isObject, hof_1.pipe(hof_1.prop('then'), exports.isFunction));
	//# sourceMappingURL=predicates.js.map

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Higher order functions
	 *
	 * These utility functions are exported, but are subject to change without notice.
	 *
	 * @packageDocumentation
	 */
	var __spreadArrays = (this && this.__spreadArrays) || function () {
	    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	    for (var r = Array(s), k = 0, i = 0; i < il; i++)
	        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	            r[k] = a[j];
	    return r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.pattern = exports.invoke = exports.val = exports.eq = exports.is = exports.any = exports.all = exports.or = exports.and = exports.not = exports.parse = exports.propEq = exports.prop = exports.pipe = exports.compose = exports.curry = void 0;
	/**
	 * Returns a new function for [Partial Application](https://en.wikipedia.org/wiki/Partial_application) of the original function.
	 *
	 * Given a function with N parameters, returns a new function that supports partial application.
	 * The new function accepts anywhere from 1 to N parameters.  When that function is called with M parameters,
	 * where M is less than N, it returns a new function that accepts the remaining parameters.  It continues to
	 * accept more parameters until all N parameters have been supplied.
	 *
	 *
	 * This contrived example uses a partially applied function as an predicate, which returns true
	 * if an object is found in both arrays.
	 * @example
	 * ```
	 * // returns true if an object is in both of the two arrays
	 * function inBoth(array1, array2, object) {
	 *   return array1.indexOf(object) !== -1 &&
	 *          array2.indexOf(object) !== 1;
	 * }
	 * let obj1, obj2, obj3, obj4, obj5, obj6, obj7
	 * let foos = [obj1, obj3]
	 * let bars = [obj3, obj4, obj5]
	 *
	 * // A curried "copy" of inBoth
	 * let curriedInBoth = curry(inBoth);
	 * // Partially apply both the array1 and array2
	 * let inFoosAndBars = curriedInBoth(foos, bars);
	 *
	 * // Supply the final argument; since all arguments are
	 * // supplied, the original inBoth function is then called.
	 * let obj1InBoth = inFoosAndBars(obj1); // false
	 *
	 * // Use the inFoosAndBars as a predicate.
	 * // Filter, on each iteration, supplies the final argument
	 * let allObjs = [ obj1, obj2, obj3, obj4, obj5, obj6, obj7 ];
	 * let foundInBoth = allObjs.filter(inFoosAndBars); // [ obj3 ]
	 *
	 * ```
	 *
	 * @param fn
	 * @returns {*|function(): (*|any)}
	 */
	function curry(fn) {
	    return function curried() {
	        if (arguments.length >= fn.length) {
	            return fn.apply(this, arguments);
	        }
	        var args = Array.prototype.slice.call(arguments);
	        return curried.bind.apply(curried, __spreadArrays([this], args));
	    };
	}
	exports.curry = curry;
	/**
	 * Given a varargs list of functions, returns a function that composes the argument functions, right-to-left
	 * given: f(x), g(x), h(x)
	 * let composed = compose(f,g,h)
	 * then, composed is: f(g(h(x)))
	 */
	function compose() {
	    var args = arguments;
	    var start = args.length - 1;
	    return function () {
	        var i = start, result = args[start].apply(this, arguments);
	        while (i--)
	            result = args[i].call(this, result);
	        return result;
	    };
	}
	exports.compose = compose;
	/**
	 * Given a varargs list of functions, returns a function that is composes the argument functions, left-to-right
	 * given: f(x), g(x), h(x)
	 * let piped = pipe(f,g,h);
	 * then, piped is: h(g(f(x)))
	 */
	function pipe() {
	    var funcs = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        funcs[_i] = arguments[_i];
	    }
	    return compose.apply(null, [].slice.call(arguments).reverse());
	}
	exports.pipe = pipe;
	/**
	 * Given a property name, returns a function that returns that property from an object
	 * let obj = { foo: 1, name: "blarg" };
	 * let getName = prop("name");
	 * getName(obj) === "blarg"
	 */
	exports.prop = function (name) { return function (obj) { return obj && obj[name]; }; };
	/**
	 * Given a property name and a value, returns a function that returns a boolean based on whether
	 * the passed object has a property that matches the value
	 * let obj = { foo: 1, name: "blarg" };
	 * let getName = propEq("name", "blarg");
	 * getName(obj) === true
	 */
	exports.propEq = curry(function (name, _val, obj) { return obj && obj[name] === _val; });
	/**
	 * Given a dotted property name, returns a function that returns a nested property from an object, or undefined
	 * let obj = { id: 1, nestedObj: { foo: 1, name: "blarg" }, };
	 * let getName = prop("nestedObj.name");
	 * getName(obj) === "blarg"
	 * let propNotFound = prop("this.property.doesnt.exist");
	 * propNotFound(obj) === undefined
	 */
	exports.parse = function (name) { return pipe.apply(null, name.split('.').map(exports.prop)); };
	/**
	 * Given a function that returns a truthy or falsey value, returns a
	 * function that returns the opposite (falsey or truthy) value given the same inputs
	 */
	exports.not = function (fn) { return function () {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    return !fn.apply(null, args);
	}; };
	/**
	 * Given two functions that return truthy or falsey values, returns a function that returns truthy
	 * if both functions return truthy for the given arguments
	 */
	function and(fn1, fn2) {
	    return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        return fn1.apply(null, args) && fn2.apply(null, args);
	    };
	}
	exports.and = and;
	/**
	 * Given two functions that return truthy or falsey values, returns a function that returns truthy
	 * if at least one of the functions returns truthy for the given arguments
	 */
	function or(fn1, fn2) {
	    return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        return fn1.apply(null, args) || fn2.apply(null, args);
	    };
	}
	exports.or = or;
	/**
	 * Check if all the elements of an array match a predicate function
	 *
	 * @param fn1 a predicate function `fn1`
	 * @returns a function which takes an array and returns true if `fn1` is true for all elements of the array
	 */
	exports.all = function (fn1) { return function (arr) { return arr.reduce(function (b, x) { return b && !!fn1(x); }, true); }; };
	// tslint:disable-next-line:variable-name
	exports.any = function (fn1) { return function (arr) { return arr.reduce(function (b, x) { return b || !!fn1(x); }, false); }; };
	/** Given a class, returns a Predicate function that returns true if the object is of that class */
	exports.is = function (ctor) { return function (obj) {
	    return (obj != null && obj.constructor === ctor) || obj instanceof ctor;
	}; };
	/** Given a value, returns a Predicate function that returns true if another value is === equal to the original value */
	exports.eq = function (value) { return function (other) { return value === other; }; };
	/** Given a value, returns a function which returns the value */
	exports.val = function (v) { return function () { return v; }; };
	function invoke(fnName, args) {
	    return function (obj) { return obj[fnName].apply(obj, args); };
	}
	exports.invoke = invoke;
	/**
	 * Sorta like Pattern Matching (a functional programming conditional construct)
	 *
	 * See http://c2.com/cgi/wiki?PatternMatching
	 *
	 * This is a conditional construct which allows a series of predicates and output functions
	 * to be checked and then applied.  Each predicate receives the input.  If the predicate
	 * returns truthy, then its matching output function (mapping function) is provided with
	 * the input and, then the result is returned.
	 *
	 * Each combination (2-tuple) of predicate + output function should be placed in an array
	 * of size 2: [ predicate, mapFn ]
	 *
	 * These 2-tuples should be put in an outer array.
	 *
	 * @example
	 * ```
	 *
	 * // Here's a 2-tuple where the first element is the isString predicate
	 * // and the second element is a function that returns a description of the input
	 * let firstTuple = [ angular.isString, (input) => `Heres your string ${input}` ];
	 *
	 * // Second tuple: predicate "isNumber", mapfn returns a description
	 * let secondTuple = [ angular.isNumber, (input) => `(${input}) That's a number!` ];
	 *
	 * let third = [ (input) => input === null,  (input) => `Oh, null...` ];
	 *
	 * let fourth = [ (input) => input === undefined,  (input) => `notdefined` ];
	 *
	 * let descriptionOf = pattern([ firstTuple, secondTuple, third, fourth ]);
	 *
	 * console.log(descriptionOf(undefined)); // 'notdefined'
	 * console.log(descriptionOf(55)); // '(55) That's a number!'
	 * console.log(descriptionOf("foo")); // 'Here's your string foo'
	 * ```
	 *
	 * @param struct A 2D array.  Each element of the array should be an array, a 2-tuple,
	 * with a Predicate and a mapping/output function
	 * @returns {function(any): *}
	 */
	function pattern(struct) {
	    return function (x) {
	        for (var i = 0; i < struct.length; i++) {
	            if (struct[i][0](x))
	                return struct[i][1](x);
	        }
	    };
	}
	exports.pattern = pattern;
	//# sourceMappingURL=hof.js.map

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (this && this.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(__webpack_require__(1), exports);
	__exportStar(__webpack_require__(5), exports);
	__exportStar(__webpack_require__(32), exports);
	__exportStar(__webpack_require__(3), exports);
	__exportStar(__webpack_require__(2), exports);
	__exportStar(__webpack_require__(33), exports);
	__exportStar(__webpack_require__(6), exports);
	__exportStar(__webpack_require__(8), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.services = exports.makeStub = void 0;
	var noImpl = function (fnname) { return function () {
	    throw new Error("No implementation for " + fnname + ". The framework specific code did not implement this method.");
	}; };
	exports.makeStub = function (service, methods) {
	    return methods.reduce(function (acc, key) { return ((acc[key] = noImpl(service + "." + key + "()")), acc); }, {});
	};
	var services = {
	    $q: undefined,
	    $injector: undefined,
	};
	exports.services = services;
	//# sourceMappingURL=coreservices.js.map

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Functions that manipulate strings
	 *
	 * Although these functions are exported, they are subject to change without notice.
	 *
	 * @packageDocumentation
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.joinNeighborsR = exports.splitOnDelim = exports.trimHashVal = exports.splitEqual = exports.splitQuery = exports.splitHash = exports.stripLastPathElement = exports.hostRegex = exports.beforeAfterSubstr = exports.stringify = exports.fnToString = exports.functionToString = exports.kebobString = exports.padString = exports.maxLength = void 0;
	var predicates_1 = __webpack_require__(2);
	var rejectFactory_1 = __webpack_require__(12);
	var common_1 = __webpack_require__(1);
	var hof_1 = __webpack_require__(3);
	/**
	 * Returns a string shortened to a maximum length
	 *
	 * If the string is already less than the `max` length, return the string.
	 * Else return the string, shortened to `max - 3` and append three dots ("...").
	 *
	 * @param max the maximum length of the string to return
	 * @param str the input string
	 */
	function maxLength(max, str) {
	    if (str.length <= max)
	        return str;
	    return str.substr(0, max - 3) + '...';
	}
	exports.maxLength = maxLength;
	/**
	 * Returns a string, with spaces added to the end, up to a desired str length
	 *
	 * If the string is already longer than the desired length, return the string.
	 * Else returns the string, with extra spaces on the end, such that it reaches `length` characters.
	 *
	 * @param length the desired length of the string to return
	 * @param str the input string
	 */
	function padString(length, str) {
	    while (str.length < length)
	        str += ' ';
	    return str;
	}
	exports.padString = padString;
	function kebobString(camelCase) {
	    return camelCase
	        .replace(/^([A-Z])/, function ($1) { return $1.toLowerCase(); }) // replace first char
	        .replace(/([A-Z])/g, function ($1) { return '-' + $1.toLowerCase(); }); // replace rest
	}
	exports.kebobString = kebobString;
	function functionToString(fn) {
	    var fnStr = fnToString(fn);
	    var namedFunctionMatch = fnStr.match(/^(function [^ ]+\([^)]*\))/);
	    var toStr = namedFunctionMatch ? namedFunctionMatch[1] : fnStr;
	    var fnName = fn['name'] || '';
	    if (fnName && toStr.match(/function \(/)) {
	        return 'function ' + fnName + toStr.substr(9);
	    }
	    return toStr;
	}
	exports.functionToString = functionToString;
	function fnToString(fn) {
	    var _fn = predicates_1.isArray(fn) ? fn.slice(-1)[0] : fn;
	    return (_fn && _fn.toString()) || 'undefined';
	}
	exports.fnToString = fnToString;
	function stringify(o) {
	    var seen = [];
	    var isRejection = rejectFactory_1.Rejection.isRejectionPromise;
	    var hasToString = function (obj) {
	        return predicates_1.isObject(obj) && !predicates_1.isArray(obj) && obj.constructor !== Object && predicates_1.isFunction(obj.toString);
	    };
	    var stringifyPattern = hof_1.pattern([
	        [predicates_1.isUndefined, hof_1.val('undefined')],
	        [predicates_1.isNull, hof_1.val('null')],
	        [predicates_1.isPromise, hof_1.val('[Promise]')],
	        [isRejection, function (x) { return x._transitionRejection.toString(); }],
	        [hasToString, function (x) { return x.toString(); }],
	        [predicates_1.isInjectable, functionToString],
	        [hof_1.val(true), common_1.identity],
	    ]);
	    function format(value) {
	        if (predicates_1.isObject(value)) {
	            if (seen.indexOf(value) !== -1)
	                return '[circular ref]';
	            seen.push(value);
	        }
	        return stringifyPattern(value);
	    }
	    if (predicates_1.isUndefined(o)) {
	        // Workaround for IE & Edge Spec incompatibility where replacer function would not be called when JSON.stringify
	        // is given `undefined` as value. To work around that, we simply detect `undefined` and bail out early by
	        // manually stringifying it.
	        return format(o);
	    }
	    return JSON.stringify(o, function (key, value) { return format(value); }).replace(/\\"/g, '"');
	}
	exports.stringify = stringify;
	/** Returns a function that splits a string on a character or substring */
	exports.beforeAfterSubstr = function (char) {
	    return function (str) {
	        if (!str)
	            return ['', ''];
	        var idx = str.indexOf(char);
	        if (idx === -1)
	            return [str, ''];
	        return [str.substr(0, idx), str.substr(idx + 1)];
	    };
	};
	exports.hostRegex = new RegExp('^(?:[a-z]+:)?//[^/]+/');
	exports.stripLastPathElement = function (str) { return str.replace(/\/[^/]*$/, ''); };
	exports.splitHash = exports.beforeAfterSubstr('#');
	exports.splitQuery = exports.beforeAfterSubstr('?');
	exports.splitEqual = exports.beforeAfterSubstr('=');
	exports.trimHashVal = function (str) { return (str ? str.replace(/^#/, '') : ''); };
	/**
	 * Splits on a delimiter, but returns the delimiters in the array
	 *
	 * #### Example:
	 * ```js
	 * var splitOnSlashes = splitOnDelim('/');
	 * splitOnSlashes("/foo"); // ["/", "foo"]
	 * splitOnSlashes("/foo/"); // ["/", "foo", "/"]
	 * ```
	 */
	function splitOnDelim(delim) {
	    var re = new RegExp('(' + delim + ')', 'g');
	    return function (str) { return str.split(re).filter(common_1.identity); };
	}
	exports.splitOnDelim = splitOnDelim;
	/**
	 * Reduce fn that joins neighboring strings
	 *
	 * Given an array of strings, returns a new array
	 * where all neighboring strings have been joined.
	 *
	 * #### Example:
	 * ```js
	 * let arr = ["foo", "bar", 1, "baz", "", "qux" ];
	 * arr.reduce(joinNeighborsR, []) // ["foobar", 1, "bazqux" ]
	 * ```
	 */
	function joinNeighborsR(acc, x) {
	    if (predicates_1.isString(common_1.tail(acc)) && predicates_1.isString(x))
	        return acc.slice(0, -1).concat(common_1.tail(acc) + x);
	    return common_1.pushR(acc, x);
	}
	exports.joinNeighborsR = joinNeighborsR;
	//# sourceMappingURL=strings.js.map

/***/ }),
/* 7 */,
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.trace = exports.Trace = exports.Category = void 0;
	/**
	 * # Transition tracing (debug)
	 *
	 * Enable transition tracing to print transition information to the console,
	 * in order to help debug your application.
	 * Tracing logs detailed information about each Transition to your console.
	 *
	 * To enable tracing, import the [[Trace]] singleton and enable one or more categories.
	 *
	 * ### ES6
	 * ```js
	 * import {trace} from "@uirouter/core";
	 * trace.enable(1, 5); // TRANSITION and VIEWCONFIG
	 * ```
	 *
	 * ### CJS
	 * ```js
	 * let trace = require("@uirouter/core").trace;
	 * trace.enable("TRANSITION", "VIEWCONFIG");
	 * ```
	 *
	 * ### Globals
	 * ```js
	 * let trace = window["@uirouter/core"].trace;
	 * trace.enable(); // Trace everything (very verbose)
	 * ```
	 *
	 * ### Angular 1:
	 * ```js
	 * app.run($trace => $trace.enable());
	 * ```
	 *
	 * @packageDocumentation
	 */
	var hof_1 = __webpack_require__(3);
	var predicates_1 = __webpack_require__(2);
	var strings_1 = __webpack_require__(6);
	var safeConsole_1 = __webpack_require__(48);
	function uiViewString(uiview) {
	    if (!uiview)
	        return 'ui-view (defunct)';
	    var state = uiview.creationContext ? uiview.creationContext.name || '(root)' : '(none)';
	    return "[ui-view#" + uiview.id + " " + uiview.$type + ":" + uiview.fqn + " (" + uiview.name + "@" + state + ")]";
	}
	var viewConfigString = function (viewConfig) {
	    var view = viewConfig.viewDecl;
	    var state = view.$context.name || '(root)';
	    return "[View#" + viewConfig.$id + " from '" + state + "' state]: target ui-view: '" + view.$uiViewName + "@" + view.$uiViewContextAnchor + "'";
	};
	function normalizedCat(input) {
	    return predicates_1.isNumber(input) ? Category[input] : Category[Category[input]];
	}
	/**
	 * Trace categories Enum
	 *
	 * Enable or disable a category using [[Trace.enable]] or [[Trace.disable]]
	 *
	 * `trace.enable(Category.TRANSITION)`
	 *
	 * These can also be provided using a matching string, or position ordinal
	 *
	 * `trace.enable("TRANSITION")`
	 *
	 * `trace.enable(1)`
	 */
	var Category;
	(function (Category) {
	    Category[Category["RESOLVE"] = 0] = "RESOLVE";
	    Category[Category["TRANSITION"] = 1] = "TRANSITION";
	    Category[Category["HOOK"] = 2] = "HOOK";
	    Category[Category["UIVIEW"] = 3] = "UIVIEW";
	    Category[Category["VIEWCONFIG"] = 4] = "VIEWCONFIG";
	})(Category || (Category = {}));
	exports.Category = Category;
	var _tid = hof_1.parse('$id');
	var _rid = hof_1.parse('router.$id');
	var transLbl = function (trans) { return "Transition #" + _tid(trans) + "-" + _rid(trans); };
	/**
	 * Prints UI-Router Transition trace information to the console.
	 */
	var Trace = /** @class */ (function () {
	    /** @internal */
	    function Trace() {
	        /** @internal */
	        this._enabled = {};
	        this.approximateDigests = 0;
	    }
	    /** @internal */
	    Trace.prototype._set = function (enabled, categories) {
	        var _this = this;
	        if (!categories.length) {
	            categories = Object.keys(Category)
	                .map(function (k) { return parseInt(k, 10); })
	                .filter(function (k) { return !isNaN(k); })
	                .map(function (key) { return Category[key]; });
	        }
	        categories.map(normalizedCat).forEach(function (category) { return (_this._enabled[category] = enabled); });
	    };
	    Trace.prototype.enable = function () {
	        var categories = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            categories[_i] = arguments[_i];
	        }
	        this._set(true, categories);
	    };
	    Trace.prototype.disable = function () {
	        var categories = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            categories[_i] = arguments[_i];
	        }
	        this._set(false, categories);
	    };
	    /**
	     * Retrieves the enabled stateus of a [[Category]]
	     *
	     * ```js
	     * trace.enabled("VIEWCONFIG"); // true or false
	     * ```
	     *
	     * @returns boolean true if the category is enabled
	     */
	    Trace.prototype.enabled = function (category) {
	        return !!this._enabled[normalizedCat(category)];
	    };
	    /** @internal called by ui-router code */
	    Trace.prototype.traceTransitionStart = function (trans) {
	        if (!this.enabled(Category.TRANSITION))
	            return;
	        safeConsole_1.safeConsole.log(transLbl(trans) + ": Started  -> " + strings_1.stringify(trans));
	    };
	    /** @internal called by ui-router code */
	    Trace.prototype.traceTransitionIgnored = function (trans) {
	        if (!this.enabled(Category.TRANSITION))
	            return;
	        safeConsole_1.safeConsole.log(transLbl(trans) + ": Ignored  <> " + strings_1.stringify(trans));
	    };
	    /** @internal called by ui-router code */
	    Trace.prototype.traceHookInvocation = function (step, trans, options) {
	        if (!this.enabled(Category.HOOK))
	            return;
	        var event = hof_1.parse('traceData.hookType')(options) || 'internal', context = hof_1.parse('traceData.context.state.name')(options) || hof_1.parse('traceData.context')(options) || 'unknown', name = strings_1.functionToString(step.registeredHook.callback);
	        safeConsole_1.safeConsole.log(transLbl(trans) + ":   Hook -> " + event + " context: " + context + ", " + strings_1.maxLength(200, name));
	    };
	    /** @internal called by ui-router code */
	    Trace.prototype.traceHookResult = function (hookResult, trans, transitionOptions) {
	        if (!this.enabled(Category.HOOK))
	            return;
	        safeConsole_1.safeConsole.log(transLbl(trans) + ":   <- Hook returned: " + strings_1.maxLength(200, strings_1.stringify(hookResult)));
	    };
	    /** @internal called by ui-router code */
	    Trace.prototype.traceResolvePath = function (path, when, trans) {
	        if (!this.enabled(Category.RESOLVE))
	            return;
	        safeConsole_1.safeConsole.log(transLbl(trans) + ":         Resolving " + path + " (" + when + ")");
	    };
	    /** @internal called by ui-router code */
	    Trace.prototype.traceResolvableResolved = function (resolvable, trans) {
	        if (!this.enabled(Category.RESOLVE))
	            return;
	        safeConsole_1.safeConsole.log(transLbl(trans) + ":               <- Resolved  " + resolvable + " to: " + strings_1.maxLength(200, strings_1.stringify(resolvable.data)));
	    };
	    /** @internal called by ui-router code */
	    Trace.prototype.traceError = function (reason, trans) {
	        if (!this.enabled(Category.TRANSITION))
	            return;
	        safeConsole_1.safeConsole.log(transLbl(trans) + ": <- Rejected " + strings_1.stringify(trans) + ", reason: " + reason);
	    };
	    /** @internal called by ui-router code */
	    Trace.prototype.traceSuccess = function (finalState, trans) {
	        if (!this.enabled(Category.TRANSITION))
	            return;
	        safeConsole_1.safeConsole.log(transLbl(trans) + ": <- Success  " + strings_1.stringify(trans) + ", final state: " + finalState.name);
	    };
	    /** @internal called by ui-router code */
	    Trace.prototype.traceUIViewEvent = function (event, viewData, extra) {
	        if (extra === void 0) { extra = ''; }
	        if (!this.enabled(Category.UIVIEW))
	            return;
	        safeConsole_1.safeConsole.log("ui-view: " + strings_1.padString(30, event) + " " + uiViewString(viewData) + extra);
	    };
	    /** @internal called by ui-router code */
	    Trace.prototype.traceUIViewConfigUpdated = function (viewData, context) {
	        if (!this.enabled(Category.UIVIEW))
	            return;
	        this.traceUIViewEvent('Updating', viewData, " with ViewConfig from context='" + context + "'");
	    };
	    /** @internal called by ui-router code */
	    Trace.prototype.traceUIViewFill = function (viewData, html) {
	        if (!this.enabled(Category.UIVIEW))
	            return;
	        this.traceUIViewEvent('Fill', viewData, " with: " + strings_1.maxLength(200, html));
	    };
	    /** @internal called by ui-router code */
	    Trace.prototype.traceViewSync = function (pairs) {
	        if (!this.enabled(Category.VIEWCONFIG))
	            return;
	        var uivheader = 'uiview component fqn';
	        var cfgheader = 'view config state (view name)';
	        var mapping = pairs
	            .map(function (_a) {
	            var _b;
	            var uiView = _a.uiView, viewConfig = _a.viewConfig;
	            var uiv = uiView && uiView.fqn;
	            var cfg = viewConfig && viewConfig.viewDecl.$context.name + ": (" + viewConfig.viewDecl.$name + ")";
	            return _b = {}, _b[uivheader] = uiv, _b[cfgheader] = cfg, _b;
	        })
	            .sort(function (a, b) { return (a[uivheader] || '').localeCompare(b[uivheader] || ''); });
	        safeConsole_1.safeConsole.table(mapping);
	    };
	    /** @internal called by ui-router code */
	    Trace.prototype.traceViewServiceEvent = function (event, viewConfig) {
	        if (!this.enabled(Category.VIEWCONFIG))
	            return;
	        safeConsole_1.safeConsole.log("VIEWCONFIG: " + event + " " + viewConfigString(viewConfig));
	    };
	    /** @internal called by ui-router code */
	    Trace.prototype.traceViewServiceUIViewEvent = function (event, viewData) {
	        if (!this.enabled(Category.VIEWCONFIG))
	            return;
	        safeConsole_1.safeConsole.log("VIEWCONFIG: " + event + " " + uiViewString(viewData));
	    };
	    return Trace;
	}());
	exports.Trace = Trace;
	/**
	 * The [[Trace]] singleton
	 *
	 * #### Example:
	 * ```js
	 * import {trace} from "@uirouter/core";
	 * trace.enable(1, 5);
	 * ```
	 */
	var trace = new Trace();
	exports.trace = trace;
	//# sourceMappingURL=trace.js.map

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(138);
	module.exports = angular;


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(44)
	var ieee754 = __webpack_require__(45)
	var isArray = __webpack_require__(26)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 11 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.TransitionHookScope = exports.TransitionHookPhase = void 0;
	var TransitionHookPhase;
	(function (TransitionHookPhase) {
	    TransitionHookPhase[TransitionHookPhase["CREATE"] = 0] = "CREATE";
	    TransitionHookPhase[TransitionHookPhase["BEFORE"] = 1] = "BEFORE";
	    TransitionHookPhase[TransitionHookPhase["RUN"] = 2] = "RUN";
	    TransitionHookPhase[TransitionHookPhase["SUCCESS"] = 3] = "SUCCESS";
	    TransitionHookPhase[TransitionHookPhase["ERROR"] = 4] = "ERROR";
	})(TransitionHookPhase || (TransitionHookPhase = {}));
	exports.TransitionHookPhase = TransitionHookPhase;
	var TransitionHookScope;
	(function (TransitionHookScope) {
	    TransitionHookScope[TransitionHookScope["TRANSITION"] = 0] = "TRANSITION";
	    TransitionHookScope[TransitionHookScope["STATE"] = 1] = "STATE";
	})(TransitionHookScope || (TransitionHookScope = {}));
	exports.TransitionHookScope = TransitionHookScope;
	//# sourceMappingURL=interface.js.map

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Rejection = exports.RejectType = void 0;
	var common_1 = __webpack_require__(1);
	var strings_1 = __webpack_require__(6);
	var hof_1 = __webpack_require__(3);
	/** An enum for Transition Rejection reasons */
	var RejectType;
	(function (RejectType) {
	    /**
	     * A new transition superseded this one.
	     *
	     * While this transition was running, a new transition started.
	     * This transition is cancelled because it was superseded by new transition.
	     */
	    RejectType[RejectType["SUPERSEDED"] = 2] = "SUPERSEDED";
	    /**
	     * The transition was aborted
	     *
	     * The transition was aborted by a hook which returned `false`
	     */
	    RejectType[RejectType["ABORTED"] = 3] = "ABORTED";
	    /**
	     * The transition was invalid
	     *
	     * The transition was never started because it was invalid
	     */
	    RejectType[RejectType["INVALID"] = 4] = "INVALID";
	    /**
	     * The transition was ignored
	     *
	     * The transition was ignored because it would have no effect.
	     *
	     * Either:
	     *
	     * - The transition is targeting the current state and parameter values
	     * - The transition is targeting the same state and parameter values as the currently running transition.
	     */
	    RejectType[RejectType["IGNORED"] = 5] = "IGNORED";
	    /**
	     * The transition errored.
	     *
	     * This generally means a hook threw an error or returned a rejected promise
	     */
	    RejectType[RejectType["ERROR"] = 6] = "ERROR";
	})(RejectType || (RejectType = {}));
	exports.RejectType = RejectType;
	/** @internal */
	var id = 0;
	var Rejection = /** @class */ (function () {
	    function Rejection(type, message, detail) {
	        /** @internal */
	        this.$id = id++;
	        this.type = type;
	        this.message = message;
	        this.detail = detail;
	    }
	    /** Returns true if the obj is a rejected promise created from the `asPromise` factory */
	    Rejection.isRejectionPromise = function (obj) {
	        return obj && typeof obj.then === 'function' && hof_1.is(Rejection)(obj._transitionRejection);
	    };
	    /** Returns a Rejection due to transition superseded */
	    Rejection.superseded = function (detail, options) {
	        var message = 'The transition has been superseded by a different transition';
	        var rejection = new Rejection(RejectType.SUPERSEDED, message, detail);
	        if (options && options.redirected) {
	            rejection.redirected = true;
	        }
	        return rejection;
	    };
	    /** Returns a Rejection due to redirected transition */
	    Rejection.redirected = function (detail) {
	        return Rejection.superseded(detail, { redirected: true });
	    };
	    /** Returns a Rejection due to invalid transition */
	    Rejection.invalid = function (detail) {
	        var message = 'This transition is invalid';
	        return new Rejection(RejectType.INVALID, message, detail);
	    };
	    /** Returns a Rejection due to ignored transition */
	    Rejection.ignored = function (detail) {
	        var message = 'The transition was ignored';
	        return new Rejection(RejectType.IGNORED, message, detail);
	    };
	    /** Returns a Rejection due to aborted transition */
	    Rejection.aborted = function (detail) {
	        var message = 'The transition has been aborted';
	        return new Rejection(RejectType.ABORTED, message, detail);
	    };
	    /** Returns a Rejection due to aborted transition */
	    Rejection.errored = function (detail) {
	        var message = 'The transition errored';
	        return new Rejection(RejectType.ERROR, message, detail);
	    };
	    /**
	     * Returns a Rejection
	     *
	     * Normalizes a value as a Rejection.
	     * If the value is already a Rejection, returns it.
	     * Otherwise, wraps and returns the value as a Rejection (Rejection type: ERROR).
	     *
	     * @returns `detail` if it is already a `Rejection`, else returns an ERROR Rejection.
	     */
	    Rejection.normalize = function (detail) {
	        return hof_1.is(Rejection)(detail) ? detail : Rejection.errored(detail);
	    };
	    Rejection.prototype.toString = function () {
	        var detailString = function (d) { return (d && d.toString !== Object.prototype.toString ? d.toString() : strings_1.stringify(d)); };
	        var detail = detailString(this.detail);
	        var _a = this, $id = _a.$id, type = _a.type, message = _a.message;
	        return "Transition Rejection($id: " + $id + " type: " + type + ", message: " + message + ", detail: " + detail + ")";
	    };
	    Rejection.prototype.toPromise = function () {
	        return common_1.extend(common_1.silentRejection(this), { _transitionRejection: this });
	    };
	    return Rejection;
	}());
	exports.Rejection = Rejection;
	//# sourceMappingURL=rejectFactory.js.map

/***/ }),
/* 13 */,
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Param = exports.DefType = void 0;
	var common_1 = __webpack_require__(1);
	var hof_1 = __webpack_require__(3);
	var predicates_1 = __webpack_require__(2);
	var coreservices_1 = __webpack_require__(5);
	var paramType_1 = __webpack_require__(35);
	var hasOwn = Object.prototype.hasOwnProperty;
	var isShorthand = function (cfg) {
	    return ['value', 'type', 'squash', 'array', 'dynamic'].filter(hasOwn.bind(cfg || {})).length === 0;
	};
	var DefType;
	(function (DefType) {
	    DefType[DefType["PATH"] = 0] = "PATH";
	    DefType[DefType["SEARCH"] = 1] = "SEARCH";
	    DefType[DefType["CONFIG"] = 2] = "CONFIG";
	})(DefType || (DefType = {}));
	exports.DefType = DefType;
	function getParamDeclaration(paramName, location, state) {
	    var noReloadOnSearch = (state.reloadOnSearch === false && location === DefType.SEARCH) || undefined;
	    var dynamic = common_1.find([state.dynamic, noReloadOnSearch], predicates_1.isDefined);
	    var defaultConfig = predicates_1.isDefined(dynamic) ? { dynamic: dynamic } : {};
	    var paramConfig = unwrapShorthand(state && state.params && state.params[paramName]);
	    return common_1.extend(defaultConfig, paramConfig);
	}
	function unwrapShorthand(cfg) {
	    cfg = isShorthand(cfg) ? { value: cfg } : cfg;
	    getStaticDefaultValue['__cacheable'] = true;
	    function getStaticDefaultValue() {
	        return cfg.value;
	    }
	    var $$fn = predicates_1.isInjectable(cfg.value) ? cfg.value : getStaticDefaultValue;
	    return common_1.extend(cfg, { $$fn: $$fn });
	}
	function getType(cfg, urlType, location, id, paramTypes) {
	    if (cfg.type && urlType && urlType.name !== 'string')
	        throw new Error("Param '" + id + "' has two type configurations.");
	    if (cfg.type && urlType && urlType.name === 'string' && paramTypes.type(cfg.type))
	        return paramTypes.type(cfg.type);
	    if (urlType)
	        return urlType;
	    if (!cfg.type) {
	        var type = location === DefType.CONFIG
	            ? 'any'
	            : location === DefType.PATH
	                ? 'path'
	                : location === DefType.SEARCH
	                    ? 'query'
	                    : 'string';
	        return paramTypes.type(type);
	    }
	    return cfg.type instanceof paramType_1.ParamType ? cfg.type : paramTypes.type(cfg.type);
	}
	/** returns false, true, or the squash value to indicate the "default parameter url squash policy". */
	function getSquashPolicy(config, isOptional, defaultPolicy) {
	    var squash = config.squash;
	    if (!isOptional || squash === false)
	        return false;
	    if (!predicates_1.isDefined(squash) || squash == null)
	        return defaultPolicy;
	    if (squash === true || predicates_1.isString(squash))
	        return squash;
	    throw new Error("Invalid squash policy: '" + squash + "'. Valid policies: false, true, or arbitrary string");
	}
	function getReplace(config, arrayMode, isOptional, squash) {
	    var defaultPolicy = [
	        { from: '', to: isOptional || arrayMode ? undefined : '' },
	        { from: null, to: isOptional || arrayMode ? undefined : '' },
	    ];
	    var replace = predicates_1.isArray(config.replace) ? config.replace : [];
	    if (predicates_1.isString(squash))
	        replace.push({ from: squash, to: undefined });
	    var configuredKeys = common_1.map(replace, hof_1.prop('from'));
	    return common_1.filter(defaultPolicy, function (item) { return configuredKeys.indexOf(item.from) === -1; }).concat(replace);
	}
	var Param = /** @class */ (function () {
	    function Param(id, type, location, urlConfig, state) {
	        var config = getParamDeclaration(id, location, state);
	        type = getType(config, type, location, id, urlConfig.paramTypes);
	        var arrayMode = getArrayMode();
	        type = arrayMode ? type.$asArray(arrayMode, location === DefType.SEARCH) : type;
	        var isOptional = config.value !== undefined || location === DefType.SEARCH;
	        var dynamic = predicates_1.isDefined(config.dynamic) ? !!config.dynamic : !!type.dynamic;
	        var raw = predicates_1.isDefined(config.raw) ? !!config.raw : !!type.raw;
	        var squash = getSquashPolicy(config, isOptional, urlConfig.defaultSquashPolicy());
	        var replace = getReplace(config, arrayMode, isOptional, squash);
	        var inherit = predicates_1.isDefined(config.inherit) ? !!config.inherit : !!type.inherit;
	        // array config: param name (param[]) overrides default settings.  explicit config overrides param name.
	        function getArrayMode() {
	            var arrayDefaults = { array: location === DefType.SEARCH ? 'auto' : false };
	            var arrayParamNomenclature = id.match(/\[\]$/) ? { array: true } : {};
	            return common_1.extend(arrayDefaults, arrayParamNomenclature, config).array;
	        }
	        common_1.extend(this, { id: id, type: type, location: location, isOptional: isOptional, dynamic: dynamic, raw: raw, squash: squash, replace: replace, inherit: inherit, array: arrayMode, config: config });
	    }
	    Param.values = function (params, values) {
	        if (values === void 0) { values = {}; }
	        var paramValues = {};
	        for (var _i = 0, params_1 = params; _i < params_1.length; _i++) {
	            var param = params_1[_i];
	            paramValues[param.id] = param.value(values[param.id]);
	        }
	        return paramValues;
	    };
	    /**
	     * Finds [[Param]] objects which have different param values
	     *
	     * Filters a list of [[Param]] objects to only those whose parameter values differ in two param value objects
	     *
	     * @param params: The list of Param objects to filter
	     * @param values1: The first set of parameter values
	     * @param values2: the second set of parameter values
	     *
	     * @returns any Param objects whose values were different between values1 and values2
	     */
	    Param.changed = function (params, values1, values2) {
	        if (values1 === void 0) { values1 = {}; }
	        if (values2 === void 0) { values2 = {}; }
	        return params.filter(function (param) { return !param.type.equals(values1[param.id], values2[param.id]); });
	    };
	    /**
	     * Checks if two param value objects are equal (for a set of [[Param]] objects)
	     *
	     * @param params The list of [[Param]] objects to check
	     * @param values1 The first set of param values
	     * @param values2 The second set of param values
	     *
	     * @returns true if the param values in values1 and values2 are equal
	     */
	    Param.equals = function (params, values1, values2) {
	        if (values1 === void 0) { values1 = {}; }
	        if (values2 === void 0) { values2 = {}; }
	        return Param.changed(params, values1, values2).length === 0;
	    };
	    /** Returns true if a the parameter values are valid, according to the Param definitions */
	    Param.validates = function (params, values) {
	        if (values === void 0) { values = {}; }
	        return params.map(function (param) { return param.validates(values[param.id]); }).reduce(common_1.allTrueR, true);
	    };
	    Param.prototype.isDefaultValue = function (value) {
	        return this.isOptional && this.type.equals(this.value(), value);
	    };
	    /**
	     * [Internal] Gets the decoded representation of a value if the value is defined, otherwise, returns the
	     * default value, which may be the result of an injectable function.
	     */
	    Param.prototype.value = function (value) {
	        var _this = this;
	        /**
	         * [Internal] Get the default value of a parameter, which may be an injectable function.
	         */
	        var getDefaultValue = function () {
	            if (_this._defaultValueCache)
	                return _this._defaultValueCache.defaultValue;
	            if (!coreservices_1.services.$injector)
	                throw new Error('Injectable functions cannot be called at configuration time');
	            var defaultValue = coreservices_1.services.$injector.invoke(_this.config.$$fn);
	            if (defaultValue !== null && defaultValue !== undefined && !_this.type.is(defaultValue))
	                throw new Error("Default value (" + defaultValue + ") for parameter '" + _this.id + "' is not an instance of ParamType (" + _this.type.name + ")");
	            if (_this.config.$$fn['__cacheable']) {
	                _this._defaultValueCache = { defaultValue: defaultValue };
	            }
	            return defaultValue;
	        };
	        var replaceSpecialValues = function (val) {
	            for (var _i = 0, _a = _this.replace; _i < _a.length; _i++) {
	                var tuple = _a[_i];
	                if (tuple.from === val)
	                    return tuple.to;
	            }
	            return val;
	        };
	        value = replaceSpecialValues(value);
	        return predicates_1.isUndefined(value) ? getDefaultValue() : this.type.$normalize(value);
	    };
	    Param.prototype.isSearch = function () {
	        return this.location === DefType.SEARCH;
	    };
	    Param.prototype.validates = function (value) {
	        // There was no parameter value, but the param is optional
	        if ((predicates_1.isUndefined(value) || value === null) && this.isOptional)
	            return true;
	        // The value was not of the correct ParamType, and could not be decoded to the correct ParamType
	        var normalized = this.type.$normalize(value);
	        if (!this.type.is(normalized))
	            return false;
	        // The value was of the correct type, but when encoded, did not match the ParamType's regexp
	        var encoded = this.type.encode(normalized);
	        return !(predicates_1.isString(encoded) && !this.type.pattern.exec(encoded));
	    };
	    Param.prototype.toString = function () {
	        return "{Param:" + this.id + " " + this.type + " squash: '" + this.squash + "' optional: " + this.isOptional + "}";
	    };
	    return Param;
	}());
	exports.Param = Param;
	//# sourceMappingURL=param.js.map

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.TargetState = void 0;
	var predicates_1 = __webpack_require__(2);
	var strings_1 = __webpack_require__(6);
	var common_1 = __webpack_require__(4);
	/**
	 * Encapsulate the target (destination) state/params/options of a [[Transition]].
	 *
	 * This class is frequently used to redirect a transition to a new destination.
	 *
	 * See:
	 *
	 * - [[HookResult]]
	 * - [[TransitionHookFn]]
	 * - [[TransitionService.onStart]]
	 *
	 * To create a `TargetState`, use [[StateService.target]].
	 *
	 * ---
	 *
	 * This class wraps:
	 *
	 * 1) an identifier for a state
	 * 2) a set of parameters
	 * 3) and transition options
	 * 4) the registered state object (the [[StateDeclaration]])
	 *
	 * Many UI-Router APIs such as [[StateService.go]] take a [[StateOrName]] argument which can
	 * either be a *state object* (a [[StateDeclaration]] or [[StateObject]]) or a *state name* (a string).
	 * The `TargetState` class normalizes those options.
	 *
	 * A `TargetState` may be valid (the state being targeted exists in the registry)
	 * or invalid (the state being targeted is not registered).
	 */
	var TargetState = /** @class */ (function () {
	    /**
	     * The TargetState constructor
	     *
	     * Note: Do not construct a `TargetState` manually.
	     * To create a `TargetState`, use the [[StateService.target]] factory method.
	     *
	     * @param _stateRegistry The StateRegistry to use to look up the _definition
	     * @param _identifier An identifier for a state.
	     *    Either a fully-qualified state name, or the object used to define the state.
	     * @param _params Parameters for the target state
	     * @param _options Transition options.
	     *
	     * @internal
	     */
	    function TargetState(_stateRegistry, _identifier, _params, _options) {
	        this._stateRegistry = _stateRegistry;
	        this._identifier = _identifier;
	        this._identifier = _identifier;
	        this._params = common_1.extend({}, _params || {});
	        this._options = common_1.extend({}, _options || {});
	        this._definition = _stateRegistry.matcher.find(_identifier, this._options.relative);
	    }
	    /** The name of the state this object targets */
	    TargetState.prototype.name = function () {
	        return (this._definition && this._definition.name) || this._identifier;
	    };
	    /** The identifier used when creating this TargetState */
	    TargetState.prototype.identifier = function () {
	        return this._identifier;
	    };
	    /** The target parameter values */
	    TargetState.prototype.params = function () {
	        return this._params;
	    };
	    /** The internal state object (if it was found) */
	    TargetState.prototype.$state = function () {
	        return this._definition;
	    };
	    /** The internal state declaration (if it was found) */
	    TargetState.prototype.state = function () {
	        return this._definition && this._definition.self;
	    };
	    /** The target options */
	    TargetState.prototype.options = function () {
	        return this._options;
	    };
	    /** True if the target state was found */
	    TargetState.prototype.exists = function () {
	        return !!(this._definition && this._definition.self);
	    };
	    /** True if the object is valid */
	    TargetState.prototype.valid = function () {
	        return !this.error();
	    };
	    /** If the object is invalid, returns the reason why */
	    TargetState.prototype.error = function () {
	        var base = this.options().relative;
	        if (!this._definition && !!base) {
	            var stateName = base.name ? base.name : base;
	            return "Could not resolve '" + this.name() + "' from state '" + stateName + "'";
	        }
	        if (!this._definition)
	            return "No such state '" + this.name() + "'";
	        if (!this._definition.self)
	            return "State '" + this.name() + "' has an invalid definition";
	    };
	    TargetState.prototype.toString = function () {
	        return "'" + this.name() + "'" + strings_1.stringify(this.params());
	    };
	    /**
	     * Returns a copy of this TargetState which targets a different state.
	     * The new TargetState has the same parameter values and transition options.
	     *
	     * @param state The new state that should be targeted
	     */
	    TargetState.prototype.withState = function (state) {
	        return new TargetState(this._stateRegistry, state, this._params, this._options);
	    };
	    /**
	     * Returns a copy of this TargetState, using the specified parameter values.
	     *
	     * @param params the new parameter values to use
	     * @param replace When false (default) the new parameter values will be merged with the current values.
	     *                When true the parameter values will be used instead of the current values.
	     */
	    TargetState.prototype.withParams = function (params, replace) {
	        if (replace === void 0) { replace = false; }
	        var newParams = replace ? params : common_1.extend({}, this._params, params);
	        return new TargetState(this._stateRegistry, this._identifier, newParams, this._options);
	    };
	    /**
	     * Returns a copy of this TargetState, using the specified Transition Options.
	     *
	     * @param options the new options to use
	     * @param replace When false (default) the new options will be merged with the current options.
	     *                When true the options will be used instead of the current options.
	     */
	    TargetState.prototype.withOptions = function (options, replace) {
	        if (replace === void 0) { replace = false; }
	        var newOpts = replace ? options : common_1.extend({}, this._options, options);
	        return new TargetState(this._stateRegistry, this._identifier, this._params, newOpts);
	    };
	    /** Returns true if the object has a state property that might be a state or state name */
	    TargetState.isDef = function (obj) {
	        return obj && obj.state && (predicates_1.isString(obj.state) || (predicates_1.isObject(obj.state) && predicates_1.isString(obj.state.name)));
	    };
	    return TargetState;
	}());
	exports.TargetState = TargetState;
	//# sourceMappingURL=targetState.js.map

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.TransitionHook = void 0;
	var interface_1 = __webpack_require__(11);
	var common_1 = __webpack_require__(1);
	var strings_1 = __webpack_require__(6);
	var predicates_1 = __webpack_require__(2);
	var hof_1 = __webpack_require__(3);
	var trace_1 = __webpack_require__(8);
	var coreservices_1 = __webpack_require__(5);
	var rejectFactory_1 = __webpack_require__(12);
	var targetState_1 = __webpack_require__(15);
	var defaultOptions = {
	    current: common_1.noop,
	    transition: null,
	    traceData: {},
	    bind: null,
	};
	var TransitionHook = /** @class */ (function () {
	    function TransitionHook(transition, stateContext, registeredHook, options) {
	        var _this = this;
	        this.transition = transition;
	        this.stateContext = stateContext;
	        this.registeredHook = registeredHook;
	        this.options = options;
	        this.isSuperseded = function () { return _this.type.hookPhase === interface_1.TransitionHookPhase.RUN && !_this.options.transition.isActive(); };
	        this.options = common_1.defaults(options, defaultOptions);
	        this.type = registeredHook.eventType;
	    }
	    /**
	     * Chains together an array of TransitionHooks.
	     *
	     * Given a list of [[TransitionHook]] objects, chains them together.
	     * Each hook is invoked after the previous one completes.
	     *
	     * #### Example:
	     * ```js
	     * var hooks: TransitionHook[] = getHooks();
	     * let promise: Promise<any> = TransitionHook.chain(hooks);
	     *
	     * promise.then(handleSuccess, handleError);
	     * ```
	     *
	     * @param hooks the list of hooks to chain together
	     * @param waitFor if provided, the chain is `.then()`'ed off this promise
	     * @returns a `Promise` for sequentially invoking the hooks (in order)
	     */
	    TransitionHook.chain = function (hooks, waitFor) {
	        // Chain the next hook off the previous
	        var createHookChainR = function (prev, nextHook) { return prev.then(function () { return nextHook.invokeHook(); }); };
	        return hooks.reduce(createHookChainR, waitFor || coreservices_1.services.$q.when());
	    };
	    /**
	     * Invokes all the provided TransitionHooks, in order.
	     * Each hook's return value is checked.
	     * If any hook returns a promise, then the rest of the hooks are chained off that promise, and the promise is returned.
	     * If no hook returns a promise, then all hooks are processed synchronously.
	     *
	     * @param hooks the list of TransitionHooks to invoke
	     * @param doneCallback a callback that is invoked after all the hooks have successfully completed
	     *
	     * @returns a promise for the async result, or the result of the callback
	     */
	    TransitionHook.invokeHooks = function (hooks, doneCallback) {
	        for (var idx = 0; idx < hooks.length; idx++) {
	            var hookResult = hooks[idx].invokeHook();
	            if (predicates_1.isPromise(hookResult)) {
	                var remainingHooks = hooks.slice(idx + 1);
	                return TransitionHook.chain(remainingHooks, hookResult).then(doneCallback);
	            }
	        }
	        return doneCallback();
	    };
	    /**
	     * Run all TransitionHooks, ignoring their return value.
	     */
	    TransitionHook.runAllHooks = function (hooks) {
	        hooks.forEach(function (hook) { return hook.invokeHook(); });
	    };
	    TransitionHook.prototype.logError = function (err) {
	        this.transition.router.stateService.defaultErrorHandler()(err);
	    };
	    TransitionHook.prototype.invokeHook = function () {
	        var _this = this;
	        var hook = this.registeredHook;
	        if (hook._deregistered)
	            return;
	        var notCurrent = this.getNotCurrentRejection();
	        if (notCurrent)
	            return notCurrent;
	        var options = this.options;
	        trace_1.trace.traceHookInvocation(this, this.transition, options);
	        var invokeCallback = function () { return hook.callback.call(options.bind, _this.transition, _this.stateContext); };
	        var normalizeErr = function (err) { return rejectFactory_1.Rejection.normalize(err).toPromise(); };
	        var handleError = function (err) { return hook.eventType.getErrorHandler(_this)(err); };
	        var handleResult = function (result) { return hook.eventType.getResultHandler(_this)(result); };
	        try {
	            var result = invokeCallback();
	            if (!this.type.synchronous && predicates_1.isPromise(result)) {
	                return result.catch(normalizeErr).then(handleResult, handleError);
	            }
	            else {
	                return handleResult(result);
	            }
	        }
	        catch (err) {
	            // If callback throws (synchronously)
	            return handleError(rejectFactory_1.Rejection.normalize(err));
	        }
	        finally {
	            if (hook.invokeLimit && ++hook.invokeCount >= hook.invokeLimit) {
	                hook.deregister();
	            }
	        }
	    };
	    /**
	     * This method handles the return value of a Transition Hook.
	     *
	     * A hook can return false (cancel), a TargetState (redirect),
	     * or a promise (which may later resolve to false or a redirect)
	     *
	     * This also handles "transition superseded" -- when a new transition
	     * was started while the hook was still running
	     */
	    TransitionHook.prototype.handleHookResult = function (result) {
	        var _this = this;
	        var notCurrent = this.getNotCurrentRejection();
	        if (notCurrent)
	            return notCurrent;
	        // Hook returned a promise
	        if (predicates_1.isPromise(result)) {
	            // Wait for the promise, then reprocess with the resulting value
	            return result.then(function (val) { return _this.handleHookResult(val); });
	        }
	        trace_1.trace.traceHookResult(result, this.transition, this.options);
	        // Hook returned false
	        if (result === false) {
	            // Abort this Transition
	            return rejectFactory_1.Rejection.aborted('Hook aborted transition').toPromise();
	        }
	        var isTargetState = hof_1.is(targetState_1.TargetState);
	        // hook returned a TargetState
	        if (isTargetState(result)) {
	            // Halt the current Transition and redirect (a new Transition) to the TargetState.
	            return rejectFactory_1.Rejection.redirected(result).toPromise();
	        }
	    };
	    /**
	     * Return a Rejection promise if the transition is no longer current due
	     * to a stopped router (disposed), or a new transition has started and superseded this one.
	     */
	    TransitionHook.prototype.getNotCurrentRejection = function () {
	        var router = this.transition.router;
	        // The router is stopped
	        if (router._disposed) {
	            return rejectFactory_1.Rejection.aborted("UIRouter instance #" + router.$id + " has been stopped (disposed)").toPromise();
	        }
	        if (this.transition._aborted) {
	            return rejectFactory_1.Rejection.aborted().toPromise();
	        }
	        // This transition is no longer current.
	        // Another transition started while this hook was still running.
	        if (this.isSuperseded()) {
	            // Abort this transition
	            return rejectFactory_1.Rejection.superseded(this.options.current()).toPromise();
	        }
	    };
	    TransitionHook.prototype.toString = function () {
	        var _a = this, options = _a.options, registeredHook = _a.registeredHook;
	        var event = hof_1.parse('traceData.hookType')(options) || 'internal', context = hof_1.parse('traceData.context.state.name')(options) || hof_1.parse('traceData.context')(options) || 'unknown', name = strings_1.fnToString(registeredHook.callback);
	        return event + " context: " + context + ", " + strings_1.maxLength(200, name);
	    };
	    /**
	     * These GetResultHandler(s) are used by [[invokeHook]] below
	     * Each HookType chooses a GetResultHandler (See: [[TransitionService._defineCoreEvents]])
	     */
	    TransitionHook.HANDLE_RESULT = function (hook) { return function (result) {
	        return hook.handleHookResult(result);
	    }; };
	    /**
	     * If the result is a promise rejection, log it.
	     * Otherwise, ignore the result.
	     */
	    TransitionHook.LOG_REJECTED_RESULT = function (hook) { return function (result) {
	        predicates_1.isPromise(result) && result.catch(function (err) { return hook.logError(rejectFactory_1.Rejection.normalize(err)); });
	        return undefined;
	    }; };
	    /**
	     * These GetErrorHandler(s) are used by [[invokeHook]] below
	     * Each HookType chooses a GetErrorHandler (See: [[TransitionService._defineCoreEvents]])
	     */
	    TransitionHook.LOG_ERROR = function (hook) { return function (error) { return hook.logError(error); }; };
	    TransitionHook.REJECT_ERROR = function (hook) { return function (error) { return common_1.silentRejection(error); }; };
	    TransitionHook.THROW_ERROR = function (hook) { return function (error) {
	        throw error;
	    }; };
	    return TransitionHook;
	}());
	exports.TransitionHook = TransitionHook;
	//# sourceMappingURL=transitionHook.js.map

/***/ }),
/* 17 */,
/* 18 */,
/* 19 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var IntegracionService = function () {
	  IntegracionService.$inject = ["$http", "apiUrlSiga", "DataService", "$log"];
	  function IntegracionService($http, apiUrlSiga, DataService, $log) {
	    'ngInject';
	
	    _classCallCheck(this, IntegracionService);
	
	    this.$http = $http;
	    this.apiUrlSiga = apiUrlSiga;
	    this.DataService = DataService;
	    this.$log = $log;
	  }
	
	  _createClass(IntegracionService, [{
	    key: 'listaProyectos',
	    value: function listaProyectos() {
	      //return this.$http.get(this.apiUrlSiga + `6_listaProyectos`,{params:datos,});
	      return this.$http.get(this.apiUrlSiga + '6_listaProyectos');
	    }
	  }, {
	    key: 'importacionComputosMetricos',
	    value: function importacionComputosMetricos(dts) {
	      this.$log.log('ENTRA AL SERVICIOS=======>');
	      //this.$log.log(tipo) ;
	      //this.$log.log(datos) ;
	      //return this.$http.post(this.apiUrlSiga + `10_recepcionarchivocsv/${dts}/${id}/${archivo}`);
	      //return this.$http.post(this.apiUrlSiga + `10_recepcionarchivocsv/`,dts,{ responseType: 'arraybuffer' });
	      //return this.$http.post(this.apiUrlSiga + `10_recepcionarchivocsv/`,dts,{ responseType: 'json' });
	      return this.$http.post(this.apiUrlSiga + '10_recepcionarchivocsv/', dts);
	    }
	  }, {
	    key: 'eliminaComputosMetricos',
	    value: function eliminaComputosMetricos(id_supervision, id_item) {
	      this.$log.log('ENTRA AL SERVICIOS PARA ELIMINAR COMPUTOS METRICOS=======>');
	      return this.$http.get(this.apiUrlSiga + ('10_eliminar_computos_metricos/' + id_supervision + '/' + id_item));
	    }
	  }, {
	    key: 'cambioEstadoProyecto',
	    value: function cambioEstadoProyecto(operacion, id_proyecto, id_usuario, id_rol) {
	      this.$log.log('ENTRA AL SERVICIOS PARA CAMBIAR ESTADO A DOCUMENTACION DE LA EMPRESA=======>');
	      return this.$http.get(this.apiUrlSiga + ('10_cambio_estado_proyecto/' + operacion + '/' + id_proyecto + '/' + id_usuario + '/' + id_rol));
	    }
	  }, {
	    key: 'registrarPlazoPropuesta',
	    value: function registrarPlazoPropuesta(id_proyecto) {
	      this.$log.log('ENTRA AL SERVICIOS PARA REGISTRAR PLAZO PROPUESTA=======>');
	      return this.$http.get(this.apiUrlSiga + ('10_registraPlazoPropuesta/' + id_proyecto));
	    }
	  }, {
	    key: 'resetMail',
	    value: function resetMail(dts) {
	      this.$log.log('ENTRA AL SERVICIO MAIL=======>');
	      //return dts;
	      return this.$http.get(this.apiUrlSiga + '6_resetMail', { params: dts });
	    }
	  }]);
	
	  return IntegracionService;
	}();
	
	exports.default = IntegracionService;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.PathUtils = void 0;
	var common_1 = __webpack_require__(1);
	var hof_1 = __webpack_require__(3);
	var targetState_1 = __webpack_require__(15);
	var pathNode_1 = __webpack_require__(36);
	/**
	 * This class contains functions which convert TargetStates, Nodes and paths from one type to another.
	 */
	var PathUtils = /** @class */ (function () {
	    function PathUtils() {
	    }
	    /** Given a PathNode[], create an TargetState */
	    PathUtils.makeTargetState = function (registry, path) {
	        var state = common_1.tail(path).state;
	        return new targetState_1.TargetState(registry, state, path.map(hof_1.prop('paramValues')).reduce(common_1.mergeR, {}), {});
	    };
	    PathUtils.buildPath = function (targetState) {
	        var toParams = targetState.params();
	        return targetState.$state().path.map(function (state) { return new pathNode_1.PathNode(state).applyRawParams(toParams); });
	    };
	    /** Given a fromPath: PathNode[] and a TargetState, builds a toPath: PathNode[] */
	    PathUtils.buildToPath = function (fromPath, targetState) {
	        var toPath = PathUtils.buildPath(targetState);
	        if (targetState.options().inherit) {
	            return PathUtils.inheritParams(fromPath, toPath, Object.keys(targetState.params()));
	        }
	        return toPath;
	    };
	    /**
	     * Creates ViewConfig objects and adds to nodes.
	     *
	     * On each [[PathNode]], creates ViewConfig objects from the views: property of the node's state
	     */
	    PathUtils.applyViewConfigs = function ($view, path, states) {
	        // Only apply the viewConfigs to the nodes for the given states
	        path
	            .filter(function (node) { return common_1.inArray(states, node.state); })
	            .forEach(function (node) {
	            var viewDecls = common_1.values(node.state.views || {});
	            var subPath = PathUtils.subPath(path, function (n) { return n === node; });
	            var viewConfigs = viewDecls.map(function (view) { return $view.createViewConfig(subPath, view); });
	            node.views = viewConfigs.reduce(common_1.unnestR, []);
	        });
	    };
	    /**
	     * Given a fromPath and a toPath, returns a new to path which inherits parameters from the fromPath
	     *
	     * For a parameter in a node to be inherited from the from path:
	     * - The toPath's node must have a matching node in the fromPath (by state).
	     * - The parameter name must not be found in the toKeys parameter array.
	     *
	     * Note: the keys provided in toKeys are intended to be those param keys explicitly specified by some
	     * caller, for instance, $state.transitionTo(..., toParams).  If a key was found in toParams,
	     * it is not inherited from the fromPath.
	     */
	    PathUtils.inheritParams = function (fromPath, toPath, toKeys) {
	        if (toKeys === void 0) { toKeys = []; }
	        function nodeParamVals(path, state) {
	            var node = common_1.find(path, hof_1.propEq('state', state));
	            return common_1.extend({}, node && node.paramValues);
	        }
	        var noInherit = fromPath
	            .map(function (node) { return node.paramSchema; })
	            .reduce(common_1.unnestR, [])
	            .filter(function (param) { return !param.inherit; })
	            .map(hof_1.prop('id'));
	        /**
	         * Given an [[PathNode]] "toNode", return a new [[PathNode]] with param values inherited from the
	         * matching node in fromPath.  Only inherit keys that aren't found in "toKeys" from the node in "fromPath""
	         */
	        function makeInheritedParamsNode(toNode) {
	            // All param values for the node (may include default key/vals, when key was not found in toParams)
	            var toParamVals = common_1.extend({}, toNode && toNode.paramValues);
	            // limited to only those keys found in toParams
	            var incomingParamVals = common_1.pick(toParamVals, toKeys);
	            toParamVals = common_1.omit(toParamVals, toKeys);
	            var fromParamVals = common_1.omit(nodeParamVals(fromPath, toNode.state) || {}, noInherit);
	            // extend toParamVals with any fromParamVals, then override any of those those with incomingParamVals
	            var ownParamVals = common_1.extend(toParamVals, fromParamVals, incomingParamVals);
	            return new pathNode_1.PathNode(toNode.state).applyRawParams(ownParamVals);
	        }
	        // The param keys specified by the incoming toParams
	        return toPath.map(makeInheritedParamsNode);
	    };
	    /**
	     * Computes the tree changes (entering, exiting) between a fromPath and toPath.
	     */
	    PathUtils.treeChanges = function (fromPath, toPath, reloadState) {
	        var max = Math.min(fromPath.length, toPath.length);
	        var keep = 0;
	        var nodesMatch = function (node1, node2) { return node1.equals(node2, PathUtils.nonDynamicParams); };
	        while (keep < max && fromPath[keep].state !== reloadState && nodesMatch(fromPath[keep], toPath[keep])) {
	            keep++;
	        }
	        /** Given a retained node, return a new node which uses the to node's param values */
	        function applyToParams(retainedNode, idx) {
	            var cloned = retainedNode.clone();
	            cloned.paramValues = toPath[idx].paramValues;
	            return cloned;
	        }
	        var from, retained, exiting, entering, to;
	        from = fromPath;
	        retained = from.slice(0, keep);
	        exiting = from.slice(keep);
	        // Create a new retained path (with shallow copies of nodes) which have the params of the toPath mapped
	        var retainedWithToParams = retained.map(applyToParams);
	        entering = toPath.slice(keep);
	        to = retainedWithToParams.concat(entering);
	        return { from: from, to: to, retained: retained, retainedWithToParams: retainedWithToParams, exiting: exiting, entering: entering };
	    };
	    /**
	     * Returns a new path which is: the subpath of the first path which matches the second path.
	     *
	     * The new path starts from root and contains any nodes that match the nodes in the second path.
	     * It stops before the first non-matching node.
	     *
	     * Nodes are compared using their state property and their parameter values.
	     * If a `paramsFn` is provided, only the [[Param]] returned by the function will be considered when comparing nodes.
	     *
	     * @param pathA the first path
	     * @param pathB the second path
	     * @param paramsFn a function which returns the parameters to consider when comparing
	     *
	     * @returns an array of PathNodes from the first path which match the nodes in the second path
	     */
	    PathUtils.matching = function (pathA, pathB, paramsFn) {
	        var done = false;
	        var tuples = common_1.arrayTuples(pathA, pathB);
	        return tuples.reduce(function (matching, _a) {
	            var nodeA = _a[0], nodeB = _a[1];
	            done = done || !nodeA.equals(nodeB, paramsFn);
	            return done ? matching : matching.concat(nodeA);
	        }, []);
	    };
	    /**
	     * Returns true if two paths are identical.
	     *
	     * @param pathA
	     * @param pathB
	     * @param paramsFn a function which returns the parameters to consider when comparing
	     * @returns true if the the states and parameter values for both paths are identical
	     */
	    PathUtils.equals = function (pathA, pathB, paramsFn) {
	        return pathA.length === pathB.length && PathUtils.matching(pathA, pathB, paramsFn).length === pathA.length;
	    };
	    /**
	     * Return a subpath of a path, which stops at the first matching node
	     *
	     * Given an array of nodes, returns a subset of the array starting from the first node,
	     * stopping when the first node matches the predicate.
	     *
	     * @param path a path of [[PathNode]]s
	     * @param predicate a [[Predicate]] fn that matches [[PathNode]]s
	     * @returns a subpath up to the matching node, or undefined if no match is found
	     */
	    PathUtils.subPath = function (path, predicate) {
	        var node = common_1.find(path, predicate);
	        var elementIdx = path.indexOf(node);
	        return elementIdx === -1 ? undefined : path.slice(0, elementIdx + 1);
	    };
	    PathUtils.nonDynamicParams = function (node) {
	        return node.state.parameters({ inherit: false }).filter(function (param) { return !param.dynamic; });
	    };
	    /** Gets the raw parameter values from a path */
	    PathUtils.paramValues = function (path) { return path.reduce(function (acc, node) { return common_1.extend(acc, node.paramValues); }, {}); };
	    return PathUtils;
	}());
	exports.PathUtils = PathUtils;
	//# sourceMappingURL=pathUtils.js.map

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Resolvable = exports.defaultResolvePolicy = void 0;
	var common_1 = __webpack_require__(1);
	var coreservices_1 = __webpack_require__(5);
	var trace_1 = __webpack_require__(8);
	var strings_1 = __webpack_require__(6);
	var predicates_1 = __webpack_require__(2);
	var predicates_2 = __webpack_require__(2);
	// TODO: explicitly make this user configurable
	exports.defaultResolvePolicy = {
	    when: 'LAZY',
	    async: 'WAIT',
	};
	/**
	 * The basic building block for the resolve system.
	 *
	 * Resolvables encapsulate a state's resolve's resolveFn, the resolveFn's declared dependencies, the wrapped (.promise),
	 * and the unwrapped-when-complete (.data) result of the resolveFn.
	 *
	 * Resolvable.get() either retrieves the Resolvable's existing promise, or else invokes resolve() (which invokes the
	 * resolveFn) and returns the resulting promise.
	 *
	 * Resolvable.get() and Resolvable.resolve() both execute within a context path, which is passed as the first
	 * parameter to those fns.
	 */
	var Resolvable = /** @class */ (function () {
	    function Resolvable(arg1, resolveFn, deps, policy, data) {
	        this.resolved = false;
	        this.promise = undefined;
	        if (arg1 instanceof Resolvable) {
	            common_1.extend(this, arg1);
	        }
	        else if (predicates_1.isFunction(resolveFn)) {
	            if (predicates_2.isNullOrUndefined(arg1))
	                throw new Error('new Resolvable(): token argument is required');
	            if (!predicates_1.isFunction(resolveFn))
	                throw new Error('new Resolvable(): resolveFn argument must be a function');
	            this.token = arg1;
	            this.policy = policy;
	            this.resolveFn = resolveFn;
	            this.deps = deps || [];
	            this.data = data;
	            this.resolved = data !== undefined;
	            this.promise = this.resolved ? coreservices_1.services.$q.when(this.data) : undefined;
	        }
	        else if (predicates_1.isObject(arg1) && arg1.token && (arg1.hasOwnProperty('resolveFn') || arg1.hasOwnProperty('data'))) {
	            var literal = arg1;
	            return new Resolvable(literal.token, literal.resolveFn, literal.deps, literal.policy, literal.data);
	        }
	    }
	    Resolvable.prototype.getPolicy = function (state) {
	        var thisPolicy = this.policy || {};
	        var statePolicy = (state && state.resolvePolicy) || {};
	        return {
	            when: thisPolicy.when || statePolicy.when || exports.defaultResolvePolicy.when,
	            async: thisPolicy.async || statePolicy.async || exports.defaultResolvePolicy.async,
	        };
	    };
	    /**
	     * Asynchronously resolve this Resolvable's data
	     *
	     * Given a ResolveContext that this Resolvable is found in:
	     * Wait for this Resolvable's dependencies, then invoke this Resolvable's function
	     * and update the Resolvable's state
	     */
	    Resolvable.prototype.resolve = function (resolveContext, trans) {
	        var _this = this;
	        var $q = coreservices_1.services.$q;
	        // Gets all dependencies from ResolveContext and wait for them to be resolved
	        var getResolvableDependencies = function () {
	            return $q.all(resolveContext.getDependencies(_this).map(function (resolvable) { return resolvable.get(resolveContext, trans); }));
	        };
	        // Invokes the resolve function passing the resolved dependencies as arguments
	        var invokeResolveFn = function (resolvedDeps) { return _this.resolveFn.apply(null, resolvedDeps); };
	        var node = resolveContext.findNode(this);
	        var state = node && node.state;
	        var asyncPolicy = this.getPolicy(state).async;
	        var customAsyncPolicy = predicates_1.isFunction(asyncPolicy) ? asyncPolicy : common_1.identity;
	        // After the final value has been resolved, update the state of the Resolvable
	        var applyResolvedValue = function (resolvedValue) {
	            _this.data = resolvedValue;
	            _this.resolved = true;
	            _this.resolveFn = null;
	            trace_1.trace.traceResolvableResolved(_this, trans);
	            return _this.data;
	        };
	        // Sets the promise property first, then getsResolvableDependencies in the context of the promise chain. Always waits one tick.
	        return (this.promise = $q
	            .when()
	            .then(getResolvableDependencies)
	            .then(invokeResolveFn)
	            .then(customAsyncPolicy)
	            .then(applyResolvedValue));
	    };
	    /**
	     * Gets a promise for this Resolvable's data.
	     *
	     * Fetches the data and returns a promise.
	     * Returns the existing promise if it has already been fetched once.
	     */
	    Resolvable.prototype.get = function (resolveContext, trans) {
	        return this.promise || this.resolve(resolveContext, trans);
	    };
	    Resolvable.prototype.toString = function () {
	        return "Resolvable(token: " + strings_1.stringify(this.token) + ", requires: [" + this.deps.map(strings_1.stringify) + "])";
	    };
	    Resolvable.prototype.clone = function () {
	        return new Resolvable(this);
	    };
	    Resolvable.fromData = function (token, data) { return new Resolvable(token, function () { return data; }, null, null, data); };
	    return Resolvable;
	}());
	exports.Resolvable = Resolvable;
	//# sourceMappingURL=resolvable.js.map

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ResolveContext = exports.NATIVE_INJECTOR_TOKEN = void 0;
	var common_1 = __webpack_require__(1);
	var hof_1 = __webpack_require__(3);
	var trace_1 = __webpack_require__(8);
	var coreservices_1 = __webpack_require__(5);
	var interface_1 = __webpack_require__(53);
	var resolvable_1 = __webpack_require__(21);
	var pathUtils_1 = __webpack_require__(20);
	var strings_1 = __webpack_require__(6);
	var common_2 = __webpack_require__(4);
	var whens = interface_1.resolvePolicies.when;
	var ALL_WHENS = [whens.EAGER, whens.LAZY];
	var EAGER_WHENS = [whens.EAGER];
	// tslint:disable-next-line:no-inferrable-types
	exports.NATIVE_INJECTOR_TOKEN = 'Native Injector';
	/**
	 * Encapsulates Dependency Injection for a path of nodes
	 *
	 * UI-Router states are organized as a tree.
	 * A nested state has a path of ancestors to the root of the tree.
	 * When a state is being activated, each element in the path is wrapped as a [[PathNode]].
	 * A `PathNode` is a stateful object that holds things like parameters and resolvables for the state being activated.
	 *
	 * The ResolveContext closes over the [[PathNode]]s, and provides DI for the last node in the path.
	 */
	var ResolveContext = /** @class */ (function () {
	    function ResolveContext(_path) {
	        this._path = _path;
	    }
	    /** Gets all the tokens found in the resolve context, de-duplicated */
	    ResolveContext.prototype.getTokens = function () {
	        return this._path.reduce(function (acc, node) { return acc.concat(node.resolvables.map(function (r) { return r.token; })); }, []).reduce(common_1.uniqR, []);
	    };
	    /**
	     * Gets the Resolvable that matches the token
	     *
	     * Gets the last Resolvable that matches the token in this context, or undefined.
	     * Throws an error if it doesn't exist in the ResolveContext
	     */
	    ResolveContext.prototype.getResolvable = function (token) {
	        var matching = this._path
	            .map(function (node) { return node.resolvables; })
	            .reduce(common_1.unnestR, [])
	            .filter(function (r) { return r.token === token; });
	        return common_1.tail(matching);
	    };
	    /** Returns the [[ResolvePolicy]] for the given [[Resolvable]] */
	    ResolveContext.prototype.getPolicy = function (resolvable) {
	        var node = this.findNode(resolvable);
	        return resolvable.getPolicy(node.state);
	    };
	    /**
	     * Returns a ResolveContext that includes a portion of this one
	     *
	     * Given a state, this method creates a new ResolveContext from this one.
	     * The new context starts at the first node (root) and stops at the node for the `state` parameter.
	     *
	     * #### Why
	     *
	     * When a transition is created, the nodes in the "To Path" are injected from a ResolveContext.
	     * A ResolveContext closes over a path of [[PathNode]]s and processes the resolvables.
	     * The "To State" can inject values from its own resolvables, as well as those from all its ancestor state's (node's).
	     * This method is used to create a narrower context when injecting ancestor nodes.
	     *
	     * @example
	     * `let ABCD = new ResolveContext([A, B, C, D]);`
	     *
	     * Given a path `[A, B, C, D]`, where `A`, `B`, `C` and `D` are nodes for states `a`, `b`, `c`, `d`:
	     * When injecting `D`, `D` should have access to all resolvables from `A`, `B`, `C`, `D`.
	     * However, `B` should only be able to access resolvables from `A`, `B`.
	     *
	     * When resolving for the `B` node, first take the full "To Path" Context `[A,B,C,D]` and limit to the subpath `[A,B]`.
	     * `let AB = ABCD.subcontext(a)`
	     */
	    ResolveContext.prototype.subContext = function (state) {
	        return new ResolveContext(pathUtils_1.PathUtils.subPath(this._path, function (node) { return node.state === state; }));
	    };
	    /**
	     * Adds Resolvables to the node that matches the state
	     *
	     * This adds a [[Resolvable]] (generally one created on the fly; not declared on a [[StateDeclaration.resolve]] block).
	     * The resolvable is added to the node matching the `state` parameter.
	     *
	     * These new resolvables are not automatically fetched.
	     * The calling code should either fetch them, fetch something that depends on them,
	     * or rely on [[resolvePath]] being called when some state is being entered.
	     *
	     * Note: each resolvable's [[ResolvePolicy]] is merged with the state's policy, and the global default.
	     *
	     * @param newResolvables the new Resolvables
	     * @param state Used to find the node to put the resolvable on
	     */
	    ResolveContext.prototype.addResolvables = function (newResolvables, state) {
	        var node = common_1.find(this._path, hof_1.propEq('state', state));
	        var keys = newResolvables.map(function (r) { return r.token; });
	        node.resolvables = node.resolvables.filter(function (r) { return keys.indexOf(r.token) === -1; }).concat(newResolvables);
	    };
	    /**
	     * Returns a promise for an array of resolved path Element promises
	     *
	     * @param when
	     * @param trans
	     * @returns {Promise<any>|any}
	     */
	    ResolveContext.prototype.resolvePath = function (when, trans) {
	        var _this = this;
	        if (when === void 0) { when = 'LAZY'; }
	        // This option determines which 'when' policy Resolvables we are about to fetch.
	        var whenOption = common_1.inArray(ALL_WHENS, when) ? when : 'LAZY';
	        // If the caller specified EAGER, only the EAGER Resolvables are fetched.
	        // if the caller specified LAZY, both EAGER and LAZY Resolvables are fetched.`
	        var matchedWhens = whenOption === interface_1.resolvePolicies.when.EAGER ? EAGER_WHENS : ALL_WHENS;
	        // get the subpath to the state argument, if provided
	        trace_1.trace.traceResolvePath(this._path, when, trans);
	        var matchesPolicy = function (acceptedVals, whenOrAsync) { return function (resolvable) {
	            return common_1.inArray(acceptedVals, _this.getPolicy(resolvable)[whenOrAsync]);
	        }; };
	        // Trigger all the (matching) Resolvables in the path
	        // Reduce all the "WAIT" Resolvables into an array
	        var promises = this._path.reduce(function (acc, node) {
	            var nodeResolvables = node.resolvables.filter(matchesPolicy(matchedWhens, 'when'));
	            var nowait = nodeResolvables.filter(matchesPolicy(['NOWAIT'], 'async'));
	            var wait = nodeResolvables.filter(hof_1.not(matchesPolicy(['NOWAIT'], 'async')));
	            // For the matching Resolvables, start their async fetch process.
	            var subContext = _this.subContext(node.state);
	            var getResult = function (r) {
	                return r
	                    .get(subContext, trans)
	                    // Return a tuple that includes the Resolvable's token
	                    .then(function (value) { return ({ token: r.token, value: value }); });
	            };
	            nowait.forEach(getResult);
	            return acc.concat(wait.map(getResult));
	        }, []);
	        // Wait for all the "WAIT" resolvables
	        return coreservices_1.services.$q.all(promises);
	    };
	    ResolveContext.prototype.injector = function () {
	        return this._injector || (this._injector = new UIInjectorImpl(this));
	    };
	    ResolveContext.prototype.findNode = function (resolvable) {
	        return common_1.find(this._path, function (node) { return common_1.inArray(node.resolvables, resolvable); });
	    };
	    /**
	     * Gets the async dependencies of a Resolvable
	     *
	     * Given a Resolvable, returns its dependencies as a Resolvable[]
	     */
	    ResolveContext.prototype.getDependencies = function (resolvable) {
	        var _this = this;
	        var node = this.findNode(resolvable);
	        // Find which other resolvables are "visible" to the `resolvable` argument
	        // subpath stopping at resolvable's node, or the whole path (if the resolvable isn't in the path)
	        var subPath = pathUtils_1.PathUtils.subPath(this._path, function (x) { return x === node; }) || this._path;
	        var availableResolvables = subPath
	            .reduce(function (acc, _node) { return acc.concat(_node.resolvables); }, []) // all of subpath's resolvables
	            .filter(function (res) { return res !== resolvable; }); // filter out the `resolvable` argument
	        var getDependency = function (token) {
	            var matching = availableResolvables.filter(function (r) { return r.token === token; });
	            if (matching.length)
	                return common_1.tail(matching);
	            var fromInjector = _this.injector().getNative(token);
	            if (common_2.isUndefined(fromInjector)) {
	                throw new Error('Could not find Dependency Injection token: ' + strings_1.stringify(token));
	            }
	            return new resolvable_1.Resolvable(token, function () { return fromInjector; }, [], fromInjector);
	        };
	        return resolvable.deps.map(getDependency);
	    };
	    return ResolveContext;
	}());
	exports.ResolveContext = ResolveContext;
	/** @internal */
	var UIInjectorImpl = /** @class */ (function () {
	    function UIInjectorImpl(context) {
	        this.context = context;
	        this.native = this.get(exports.NATIVE_INJECTOR_TOKEN) || coreservices_1.services.$injector;
	    }
	    UIInjectorImpl.prototype.get = function (token) {
	        var resolvable = this.context.getResolvable(token);
	        if (resolvable) {
	            if (this.context.getPolicy(resolvable).async === 'NOWAIT') {
	                return resolvable.get(this.context);
	            }
	            if (!resolvable.resolved) {
	                throw new Error('Resolvable async .get() not complete:' + strings_1.stringify(resolvable.token));
	            }
	            return resolvable.data;
	        }
	        return this.getNative(token);
	    };
	    UIInjectorImpl.prototype.getAsync = function (token) {
	        var resolvable = this.context.getResolvable(token);
	        if (resolvable)
	            return resolvable.get(this.context);
	        return coreservices_1.services.$q.when(this.native.get(token));
	    };
	    UIInjectorImpl.prototype.getNative = function (token) {
	        return this.native && this.native.get(token);
	    };
	    return UIInjectorImpl;
	}());
	//# sourceMappingURL=resolveContext.js.map

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.UrlMatcher = void 0;
	var common_1 = __webpack_require__(1);
	var hof_1 = __webpack_require__(3);
	var predicates_1 = __webpack_require__(2);
	var param_1 = __webpack_require__(14);
	var strings_1 = __webpack_require__(6);
	var common_2 = __webpack_require__(4);
	function quoteRegExp(str, param) {
	    var surroundPattern = ['', ''], result = str.replace(/[\\\[\]\^$*+?.()|{}]/g, '\\$&');
	    if (!param)
	        return result;
	    switch (param.squash) {
	        case false:
	            surroundPattern = ['(', ')' + (param.isOptional ? '?' : '')];
	            break;
	        case true:
	            result = result.replace(/\/$/, '');
	            surroundPattern = ['(?:/(', ')|/)?'];
	            break;
	        default:
	            surroundPattern = ["(" + param.squash + "|", ')?'];
	            break;
	    }
	    return result + surroundPattern[0] + param.type.pattern.source + surroundPattern[1];
	}
	var memoizeTo = function (obj, _prop, fn) { return (obj[_prop] = obj[_prop] || fn()); };
	var splitOnSlash = strings_1.splitOnDelim('/');
	var defaultConfig = {
	    state: { params: {} },
	    strict: true,
	    caseInsensitive: true,
	    decodeParams: true,
	};
	/**
	 * Matches URLs against patterns.
	 *
	 * Matches URLs against patterns and extracts named parameters from the path or the search
	 * part of the URL.
	 *
	 * A URL pattern consists of a path pattern, optionally followed by '?' and a list of search (query)
	 * parameters. Multiple search parameter names are separated by '&'. Search parameters
	 * do not influence whether or not a URL is matched, but their values are passed through into
	 * the matched parameters returned by [[UrlMatcher.exec]].
	 *
	 * - *Path parameters* are defined using curly brace placeholders (`/somepath/{param}`)
	 * or colon placeholders (`/somePath/:param`).
	 *
	 * - *A parameter RegExp* may be defined for a param after a colon
	 * (`/somePath/{param:[a-zA-Z0-9]+}`) in a curly brace placeholder.
	 * The regexp must match for the url to be matched.
	 * Should the regexp itself contain curly braces, they must be in matched pairs or escaped with a backslash.
	 *
	 * Note: a RegExp parameter will encode its value using either [[ParamTypes.path]] or [[ParamTypes.query]].
	 *
	 * - *Custom parameter types* may also be specified after a colon (`/somePath/{param:int}`) in curly brace parameters.
	 *   See [[UrlMatcherFactory.type]] for more information.
	 *
	 * - *Catch-all parameters* are defined using an asterisk placeholder (`/somepath/*catchallparam`).
	 *   A catch-all * parameter value will contain the remainder of the URL.
	 *
	 * ---
	 *
	 * Parameter names may contain only word characters (latin letters, digits, and underscore) and
	 * must be unique within the pattern (across both path and search parameters).
	 * A path parameter matches any number of characters other than '/'. For catch-all
	 * placeholders the path parameter matches any number of characters.
	 *
	 * Examples:
	 *
	 * * `'/hello/'` - Matches only if the path is exactly '/hello/'. There is no special treatment for
	 *   trailing slashes, and patterns have to match the entire path, not just a prefix.
	 * * `'/user/:id'` - Matches '/user/bob' or '/user/1234!!!' or even '/user/' but not '/user' or
	 *   '/user/bob/details'. The second path segment will be captured as the parameter 'id'.
	 * * `'/user/{id}'` - Same as the previous example, but using curly brace syntax.
	 * * `'/user/{id:[^/]*}'` - Same as the previous example.
	 * * `'/user/{id:[0-9a-fA-F]{1,8}}'` - Similar to the previous example, but only matches if the id
	 *   parameter consists of 1 to 8 hex digits.
	 * * `'/files/{path:.*}'` - Matches any URL starting with '/files/' and captures the rest of the
	 *   path into the parameter 'path'.
	 * * `'/files/*path'` - ditto.
	 * * `'/calendar/{start:date}'` - Matches "/calendar/2014-11-12" (because the pattern defined
	 *   in the built-in  `date` ParamType matches `2014-11-12`) and provides a Date object in $stateParams.start
	 *
	 */
	var UrlMatcher = /** @class */ (function () {
	    /**
	     * @param pattern The pattern to compile into a matcher.
	     * @param paramTypes The [[ParamTypes]] registry
	     * @param paramFactory A [[ParamFactory]] object
	     * @param config  A [[UrlMatcherCompileConfig]] configuration object
	     */
	    function UrlMatcher(pattern, paramTypes, paramFactory, config) {
	        var _this = this;
	        /** @internal */
	        this._cache = { path: [this] };
	        /** @internal */
	        this._children = [];
	        /** @internal */
	        this._params = [];
	        /** @internal */
	        this._segments = [];
	        /** @internal */
	        this._compiled = [];
	        this.config = config = common_2.defaults(config, defaultConfig);
	        this.pattern = pattern;
	        // Find all placeholders and create a compiled pattern, using either classic or curly syntax:
	        //   '*' name
	        //   ':' name
	        //   '{' name '}'
	        //   '{' name ':' regexp '}'
	        // The regular expression is somewhat complicated due to the need to allow curly braces
	        // inside the regular expression. The placeholder regexp breaks down as follows:
	        //    ([:*])([\w\[\]]+)              - classic placeholder ($1 / $2) (search version has - for snake-case)
	        //    \{([\w\[\]]+)(?:\:\s*( ... ))?\}  - curly brace placeholder ($3) with optional regexp/type ... ($4) (search version has - for snake-case
	        //    (?: ... | ... | ... )+         - the regexp consists of any number of atoms, an atom being either
	        //    [^{}\\]+                       - anything other than curly braces or backslash
	        //    \\.                            - a backslash escape
	        //    \{(?:[^{}\\]+|\\.)*\}          - a matched set of curly braces containing other atoms
	        var placeholder = /([:*])([\w\[\]]+)|\{([\w\[\]]+)(?:\:\s*((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g;
	        var searchPlaceholder = /([:]?)([\w\[\].-]+)|\{([\w\[\].-]+)(?:\:\s*((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g;
	        var patterns = [];
	        var last = 0;
	        var matchArray;
	        var checkParamErrors = function (id) {
	            if (!UrlMatcher.nameValidator.test(id))
	                throw new Error("Invalid parameter name '" + id + "' in pattern '" + pattern + "'");
	            if (common_1.find(_this._params, hof_1.propEq('id', id)))
	                throw new Error("Duplicate parameter name '" + id + "' in pattern '" + pattern + "'");
	        };
	        // Split into static segments separated by path parameter placeholders.
	        // The number of segments is always 1 more than the number of parameters.
	        var matchDetails = function (m, isSearch) {
	            // IE[78] returns '' for unmatched groups instead of null
	            var id = m[2] || m[3];
	            var regexp = isSearch ? m[4] : m[4] || (m[1] === '*' ? '[\\s\\S]*' : null);
	            var makeRegexpType = function (str) {
	                return common_1.inherit(paramTypes.type(isSearch ? 'query' : 'path'), {
	                    pattern: new RegExp(str, _this.config.caseInsensitive ? 'i' : undefined),
	                });
	            };
	            return {
	                id: id,
	                regexp: regexp,
	                segment: pattern.substring(last, m.index),
	                type: !regexp ? null : paramTypes.type(regexp) || makeRegexpType(regexp),
	            };
	        };
	        var details;
	        var segment;
	        // tslint:disable-next-line:no-conditional-assignment
	        while ((matchArray = placeholder.exec(pattern))) {
	            details = matchDetails(matchArray, false);
	            if (details.segment.indexOf('?') >= 0)
	                break; // we're into the search part
	            checkParamErrors(details.id);
	            this._params.push(paramFactory.fromPath(details.id, details.type, config.state));
	            this._segments.push(details.segment);
	            patterns.push([details.segment, common_1.tail(this._params)]);
	            last = placeholder.lastIndex;
	        }
	        segment = pattern.substring(last);
	        // Find any search parameter names and remove them from the last segment
	        var i = segment.indexOf('?');
	        if (i >= 0) {
	            var search = segment.substring(i);
	            segment = segment.substring(0, i);
	            if (search.length > 0) {
	                last = 0;
	                // tslint:disable-next-line:no-conditional-assignment
	                while ((matchArray = searchPlaceholder.exec(search))) {
	                    details = matchDetails(matchArray, true);
	                    checkParamErrors(details.id);
	                    this._params.push(paramFactory.fromSearch(details.id, details.type, config.state));
	                    last = placeholder.lastIndex;
	                    // check if ?&
	                }
	            }
	        }
	        this._segments.push(segment);
	        this._compiled = patterns.map(function (_pattern) { return quoteRegExp.apply(null, _pattern); }).concat(quoteRegExp(segment));
	    }
	    /** @internal */
	    UrlMatcher.encodeDashes = function (str) {
	        // Replace dashes with encoded "\-"
	        return encodeURIComponent(str).replace(/-/g, function (c) { return "%5C%" + c.charCodeAt(0).toString(16).toUpperCase(); });
	    };
	    /** @internal Given a matcher, return an array with the matcher's path segments and path params, in order */
	    UrlMatcher.pathSegmentsAndParams = function (matcher) {
	        var staticSegments = matcher._segments;
	        var pathParams = matcher._params.filter(function (p) { return p.location === param_1.DefType.PATH; });
	        return common_1.arrayTuples(staticSegments, pathParams.concat(undefined))
	            .reduce(common_1.unnestR, [])
	            .filter(function (x) { return x !== '' && predicates_1.isDefined(x); });
	    };
	    /** @internal Given a matcher, return an array with the matcher's query params */
	    UrlMatcher.queryParams = function (matcher) {
	        return matcher._params.filter(function (p) { return p.location === param_1.DefType.SEARCH; });
	    };
	    /**
	     * Compare two UrlMatchers
	     *
	     * This comparison function converts a UrlMatcher into static and dynamic path segments.
	     * Each static path segment is a static string between a path separator (slash character).
	     * Each dynamic segment is a path parameter.
	     *
	     * The comparison function sorts static segments before dynamic ones.
	     */
	    UrlMatcher.compare = function (a, b) {
	        /**
	         * Turn a UrlMatcher and all its parent matchers into an array
	         * of slash literals '/', string literals, and Param objects
	         *
	         * This example matcher matches strings like "/foo/:param/tail":
	         * var matcher = $umf.compile("/foo").append($umf.compile("/:param")).append($umf.compile("/")).append($umf.compile("tail"));
	         * var result = segments(matcher); // [ '/', 'foo', '/', Param, '/', 'tail' ]
	         *
	         * Caches the result as `matcher._cache.segments`
	         */
	        var segments = function (matcher) {
	            return (matcher._cache.segments =
	                matcher._cache.segments ||
	                    matcher._cache.path
	                        .map(UrlMatcher.pathSegmentsAndParams)
	                        .reduce(common_1.unnestR, [])
	                        .reduce(strings_1.joinNeighborsR, [])
	                        .map(function (x) { return (predicates_1.isString(x) ? splitOnSlash(x) : x); })
	                        .reduce(common_1.unnestR, []));
	        };
	        /**
	         * Gets the sort weight for each segment of a UrlMatcher
	         *
	         * Caches the result as `matcher._cache.weights`
	         */
	        var weights = function (matcher) {
	            return (matcher._cache.weights =
	                matcher._cache.weights ||
	                    segments(matcher).map(function (segment) {
	                        // Sort slashes first, then static strings, the Params
	                        if (segment === '/')
	                            return 1;
	                        if (predicates_1.isString(segment))
	                            return 2;
	                        if (segment instanceof param_1.Param)
	                            return 3;
	                    }));
	        };
	        /**
	         * Pads shorter array in-place (mutates)
	         */
	        var padArrays = function (l, r, padVal) {
	            var len = Math.max(l.length, r.length);
	            while (l.length < len)
	                l.push(padVal);
	            while (r.length < len)
	                r.push(padVal);
	        };
	        var weightsA = weights(a), weightsB = weights(b);
	        padArrays(weightsA, weightsB, 0);
	        var _pairs = common_1.arrayTuples(weightsA, weightsB);
	        var cmp, i;
	        for (i = 0; i < _pairs.length; i++) {
	            cmp = _pairs[i][0] - _pairs[i][1];
	            if (cmp !== 0)
	                return cmp;
	        }
	        return 0;
	    };
	    /**
	     * Creates a new concatenated UrlMatcher
	     *
	     * Builds a new UrlMatcher by appending another UrlMatcher to this one.
	     *
	     * @param url A `UrlMatcher` instance to append as a child of the current `UrlMatcher`.
	     */
	    UrlMatcher.prototype.append = function (url) {
	        this._children.push(url);
	        url._cache = {
	            path: this._cache.path.concat(url),
	            parent: this,
	            pattern: null,
	        };
	        return url;
	    };
	    /** @internal */
	    UrlMatcher.prototype.isRoot = function () {
	        return this._cache.path[0] === this;
	    };
	    /** Returns the input pattern string */
	    UrlMatcher.prototype.toString = function () {
	        return this.pattern;
	    };
	    UrlMatcher.prototype._getDecodedParamValue = function (value, param) {
	        if (predicates_1.isDefined(value)) {
	            if (this.config.decodeParams && !param.type.raw) {
	                if (predicates_1.isArray(value)) {
	                    value = value.map(function (paramValue) { return decodeURIComponent(paramValue); });
	                }
	                else {
	                    value = decodeURIComponent(value);
	                }
	            }
	            value = param.type.decode(value);
	        }
	        return param.value(value);
	    };
	    /**
	     * Tests the specified url/path against this matcher.
	     *
	     * Tests if the given url matches this matcher's pattern, and returns an object containing the captured
	     * parameter values.  Returns null if the path does not match.
	     *
	     * The returned object contains the values
	     * of any search parameters that are mentioned in the pattern, but their value may be null if
	     * they are not present in `search`. This means that search parameters are always treated
	     * as optional.
	     *
	     * #### Example:
	     * ```js
	     * new UrlMatcher('/user/{id}?q&r').exec('/user/bob', {
	     *   x: '1', q: 'hello'
	     * });
	     * // returns { id: 'bob', q: 'hello', r: null }
	     * ```
	     *
	     * @param path    The URL path to match, e.g. `$location.path()`.
	     * @param search  URL search parameters, e.g. `$location.search()`.
	     * @param hash    URL hash e.g. `$location.hash()`.
	     * @param options
	     *
	     * @returns The captured parameter values.
	     */
	    UrlMatcher.prototype.exec = function (path, search, hash, options) {
	        var _this = this;
	        if (search === void 0) { search = {}; }
	        if (options === void 0) { options = {}; }
	        var match = memoizeTo(this._cache, 'pattern', function () {
	            return new RegExp([
	                '^',
	                common_1.unnest(_this._cache.path.map(hof_1.prop('_compiled'))).join(''),
	                _this.config.strict === false ? '/?' : '',
	                '$',
	            ].join(''), _this.config.caseInsensitive ? 'i' : undefined);
	        }).exec(path);
	        if (!match)
	            return null;
	        // options = defaults(options, { isolate: false });
	        var allParams = this.parameters(), pathParams = allParams.filter(function (param) { return !param.isSearch(); }), searchParams = allParams.filter(function (param) { return param.isSearch(); }), nPathSegments = this._cache.path.map(function (urlm) { return urlm._segments.length - 1; }).reduce(function (a, x) { return a + x; }), values = {};
	        if (nPathSegments !== match.length - 1)
	            throw new Error("Unbalanced capture group in route '" + this.pattern + "'");
	        function decodePathArray(paramVal) {
	            var reverseString = function (str) { return str.split('').reverse().join(''); };
	            var unquoteDashes = function (str) { return str.replace(/\\-/g, '-'); };
	            var split = reverseString(paramVal).split(/-(?!\\)/);
	            var allReversed = common_1.map(split, reverseString);
	            return common_1.map(allReversed, unquoteDashes).reverse();
	        }
	        for (var i = 0; i < nPathSegments; i++) {
	            var param = pathParams[i];
	            var value = match[i + 1];
	            // if the param value matches a pre-replace pair, replace the value before decoding.
	            for (var j = 0; j < param.replace.length; j++) {
	                if (param.replace[j].from === value)
	                    value = param.replace[j].to;
	            }
	            if (value && param.array === true)
	                value = decodePathArray(value);
	            values[param.id] = this._getDecodedParamValue(value, param);
	        }
	        searchParams.forEach(function (param) {
	            var value = search[param.id];
	            for (var j = 0; j < param.replace.length; j++) {
	                if (param.replace[j].from === value)
	                    value = param.replace[j].to;
	            }
	            values[param.id] = _this._getDecodedParamValue(value, param);
	        });
	        if (hash)
	            values['#'] = hash;
	        return values;
	    };
	    /**
	     * @internal
	     * Returns all the [[Param]] objects of all path and search parameters of this pattern in order of appearance.
	     *
	     * @returns {Array.<Param>}  An array of [[Param]] objects. Must be treated as read-only. If the
	     *    pattern has no parameters, an empty array is returned.
	     */
	    UrlMatcher.prototype.parameters = function (opts) {
	        if (opts === void 0) { opts = {}; }
	        if (opts.inherit === false)
	            return this._params;
	        return common_1.unnest(this._cache.path.map(function (matcher) { return matcher._params; }));
	    };
	    /**
	     * @internal
	     * Returns a single parameter from this UrlMatcher by id
	     *
	     * @param id
	     * @param opts
	     * @returns {T|Param|any|boolean|UrlMatcher|null}
	     */
	    UrlMatcher.prototype.parameter = function (id, opts) {
	        var _this = this;
	        if (opts === void 0) { opts = {}; }
	        var findParam = function () {
	            for (var _i = 0, _a = _this._params; _i < _a.length; _i++) {
	                var param = _a[_i];
	                if (param.id === id)
	                    return param;
	            }
	        };
	        var parent = this._cache.parent;
	        return findParam() || (opts.inherit !== false && parent && parent.parameter(id, opts)) || null;
	    };
	    /**
	     * Validates the input parameter values against this UrlMatcher
	     *
	     * Checks an object hash of parameters to validate their correctness according to the parameter
	     * types of this `UrlMatcher`.
	     *
	     * @param params The object hash of parameters to validate.
	     * @returns Returns `true` if `params` validates, otherwise `false`.
	     */
	    UrlMatcher.prototype.validates = function (params) {
	        var validParamVal = function (param, val) { return !param || param.validates(val); };
	        params = params || {};
	        // I'm not sure why this checks only the param keys passed in, and not all the params known to the matcher
	        var paramSchema = this.parameters().filter(function (paramDef) { return params.hasOwnProperty(paramDef.id); });
	        return paramSchema.map(function (paramDef) { return validParamVal(paramDef, params[paramDef.id]); }).reduce(common_1.allTrueR, true);
	    };
	    /**
	     * Given a set of parameter values, creates a URL from this UrlMatcher.
	     *
	     * Creates a URL that matches this pattern by substituting the specified values
	     * for the path and search parameters.
	     *
	     * #### Example:
	     * ```js
	     * new UrlMatcher('/user/{id}?q').format({ id:'bob', q:'yes' });
	     * // returns '/user/bob?q=yes'
	     * ```
	     *
	     * @param values  the values to substitute for the parameters in this pattern.
	     * @returns the formatted URL (path and optionally search part).
	     */
	    UrlMatcher.prototype.format = function (values) {
	        if (values === void 0) { values = {}; }
	        // Build the full path of UrlMatchers (including all parent UrlMatchers)
	        var urlMatchers = this._cache.path;
	        // Extract all the static segments and Params (processed as ParamDetails)
	        // into an ordered array
	        var pathSegmentsAndParams = urlMatchers
	            .map(UrlMatcher.pathSegmentsAndParams)
	            .reduce(common_1.unnestR, [])
	            .map(function (x) { return (predicates_1.isString(x) ? x : getDetails(x)); });
	        // Extract the query params into a separate array
	        var queryParams = urlMatchers
	            .map(UrlMatcher.queryParams)
	            .reduce(common_1.unnestR, [])
	            .map(getDetails);
	        var isInvalid = function (param) { return param.isValid === false; };
	        if (pathSegmentsAndParams.concat(queryParams).filter(isInvalid).length) {
	            return null;
	        }
	        /**
	         * Given a Param, applies the parameter value, then returns detailed information about it
	         */
	        function getDetails(param) {
	            // Normalize to typed value
	            var value = param.value(values[param.id]);
	            var isValid = param.validates(value);
	            var isDefaultValue = param.isDefaultValue(value);
	            // Check if we're in squash mode for the parameter
	            var squash = isDefaultValue ? param.squash : false;
	            // Allow the Parameter's Type to encode the value
	            var encoded = param.type.encode(value);
	            return { param: param, value: value, isValid: isValid, isDefaultValue: isDefaultValue, squash: squash, encoded: encoded };
	        }
	        // Build up the path-portion from the list of static segments and parameters
	        var pathString = pathSegmentsAndParams.reduce(function (acc, x) {
	            // The element is a static segment (a raw string); just append it
	            if (predicates_1.isString(x))
	                return acc + x;
	            // Otherwise, it's a ParamDetails.
	            var squash = x.squash, encoded = x.encoded, param = x.param;
	            // If squash is === true, try to remove a slash from the path
	            if (squash === true)
	                return acc.match(/\/$/) ? acc.slice(0, -1) : acc;
	            // If squash is a string, use the string for the param value
	            if (predicates_1.isString(squash))
	                return acc + squash;
	            if (squash !== false)
	                return acc; // ?
	            if (encoded == null)
	                return acc;
	            // If this parameter value is an array, encode the value using encodeDashes
	            if (predicates_1.isArray(encoded))
	                return acc + common_1.map(encoded, UrlMatcher.encodeDashes).join('-');
	            // If the parameter type is "raw", then do not encodeURIComponent
	            if (param.raw)
	                return acc + encoded;
	            // Encode the value
	            return acc + encodeURIComponent(encoded);
	        }, '');
	        // Build the query string by applying parameter values (array or regular)
	        // then mapping to key=value, then flattening and joining using "&"
	        var queryString = queryParams
	            .map(function (paramDetails) {
	            var param = paramDetails.param, squash = paramDetails.squash, encoded = paramDetails.encoded, isDefaultValue = paramDetails.isDefaultValue;
	            if (encoded == null || (isDefaultValue && squash !== false))
	                return;
	            if (!predicates_1.isArray(encoded))
	                encoded = [encoded];
	            if (encoded.length === 0)
	                return;
	            if (!param.raw)
	                encoded = common_1.map(encoded, encodeURIComponent);
	            return encoded.map(function (val) { return param.id + "=" + val; });
	        })
	            .filter(common_1.identity)
	            .reduce(common_1.unnestR, [])
	            .join('&');
	        // Concat the pathstring with the queryString (if exists) and the hashString (if exists)
	        return pathString + (queryString ? "?" + queryString : '') + (values['#'] ? '#' + values['#'] : '');
	    };
	    /** @internal */
	    UrlMatcher.nameValidator = /^\w+([-.]+\w+)*(?:\[\])?$/;
	    return UrlMatcher;
	}());
	exports.UrlMatcher = UrlMatcher;
	//# sourceMappingURL=urlMatcher.js.map

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.BaseLocationServices = void 0;
	var common_1 = __webpack_require__(4);
	var utils_1 = __webpack_require__(43);
	/** A base `LocationServices` */
	var BaseLocationServices = /** @class */ (function () {
	    function BaseLocationServices(router, fireAfterUpdate) {
	        var _this = this;
	        this.fireAfterUpdate = fireAfterUpdate;
	        this._listeners = [];
	        this._listener = function (evt) { return _this._listeners.forEach(function (cb) { return cb(evt); }); };
	        this.hash = function () { return utils_1.parseUrl(_this._get()).hash; };
	        this.path = function () { return utils_1.parseUrl(_this._get()).path; };
	        this.search = function () { return utils_1.getParams(utils_1.parseUrl(_this._get()).search); };
	        this._location = common_1.root.location;
	        this._history = common_1.root.history;
	    }
	    BaseLocationServices.prototype.url = function (url, replace) {
	        if (replace === void 0) { replace = true; }
	        if (common_1.isDefined(url) && url !== this._get()) {
	            this._set(null, null, url, replace);
	            if (this.fireAfterUpdate) {
	                this._listeners.forEach(function (cb) { return cb({ url: url }); });
	            }
	        }
	        return utils_1.buildUrl(this);
	    };
	    BaseLocationServices.prototype.onChange = function (cb) {
	        var _this = this;
	        this._listeners.push(cb);
	        return function () { return common_1.removeFrom(_this._listeners, cb); };
	    };
	    BaseLocationServices.prototype.dispose = function (router) {
	        common_1.deregAll(this._listeners);
	    };
	    return BaseLocationServices;
	}());
	exports.BaseLocationServices = BaseLocationServices;
	//# sourceMappingURL=baseLocationService.js.map

/***/ }),
/* 25 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 26 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(520);
	
	var MODULE_NAME = 'ui.bootstrap.module.position';
	
	angular.module(MODULE_NAME, ['ui.bootstrap.position']);
	
	module.exports = MODULE_NAME;

/***/ }),
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 32 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Glob = void 0;
	/**
	 * Matches state names using glob-like pattern strings.
	 *
	 * Globs can be used in specific APIs including:
	 *
	 * - [[StateService.is]]
	 * - [[StateService.includes]]
	 * - The first argument to Hook Registration functions like [[TransitionService.onStart]]
	 *    - [[HookMatchCriteria]] and [[HookMatchCriterion]]
	 *
	 * A `Glob` string is a pattern which matches state names.
	 * Nested state names are split into segments (separated by a dot) when processing.
	 * The state named `foo.bar.baz` is split into three segments ['foo', 'bar', 'baz']
	 *
	 * Globs work according to the following rules:
	 *
	 * ### Exact match:
	 *
	 * The glob `'A.B'` matches the state named exactly `'A.B'`.
	 *
	 * | Glob        |Matches states named|Does not match state named|
	 * |:------------|:--------------------|:---------------------|
	 * | `'A'`       | `'A'`               | `'B'` , `'A.C'`      |
	 * | `'A.B'`     | `'A.B'`             | `'A'` , `'A.B.C'`    |
	 * | `'foo'`     | `'foo'`             | `'FOO'` , `'foo.bar'`|
	 *
	 * ### Single star (`*`)
	 *
	 * A single star (`*`) is a wildcard that matches exactly one segment.
	 *
	 * | Glob        |Matches states named  |Does not match state named |
	 * |:------------|:---------------------|:--------------------------|
	 * | `'*'`       | `'A'` , `'Z'`        | `'A.B'` , `'Z.Y.X'`       |
	 * | `'A.*'`     | `'A.B'` , `'A.C'`    | `'A'` , `'A.B.C'`         |
	 * | `'A.*.*'`   | `'A.B.C'` , `'A.X.Y'`| `'A'`, `'A.B'` , `'Z.Y.X'`|
	 *
	 * ### Double star (`**`)
	 *
	 * A double star (`'**'`) is a wildcard that matches *zero or more segments*
	 *
	 * | Glob        |Matches states named                           |Does not match state named         |
	 * |:------------|:----------------------------------------------|:----------------------------------|
	 * | `'**'`      | `'A'` , `'A.B'`, `'Z.Y.X'`                    | (matches all states)              |
	 * | `'A.**'`    | `'A'` , `'A.B'` , `'A.C.X'`                   | `'Z.Y.X'`                         |
	 * | `'**.X'`    | `'X'` , `'A.X'` , `'Z.Y.X'`                   | `'A'` , `'A.login.Z'`             |
	 * | `'A.**.X'`  | `'A.X'` , `'A.B.X'` , `'A.B.C.X'`             | `'A'` , `'A.B.C'`                 |
	 *
	 * @packageDocumentation
	 */
	var Glob = /** @class */ (function () {
	    function Glob(text) {
	        this.text = text;
	        this.glob = text.split('.');
	        var regexpString = this.text
	            .split('.')
	            .map(function (seg) {
	            if (seg === '**')
	                return '(?:|(?:\\.[^.]*)*)';
	            if (seg === '*')
	                return '\\.[^.]*';
	            return '\\.' + seg;
	        })
	            .join('');
	        this.regexp = new RegExp('^' + regexpString + '$');
	    }
	    /** Returns true if the string has glob-like characters in it */
	    Glob.is = function (text) {
	        return !!/[!,*]+/.exec(text);
	    };
	    /** Returns a glob from the string, or null if the string isn't Glob-like */
	    Glob.fromString = function (text) {
	        return Glob.is(text) ? new Glob(text) : null;
	    };
	    Glob.prototype.matches = function (name) {
	        return this.regexp.test('.' + name);
	    };
	    return Glob;
	}());
	exports.Glob = Glob;
	//# sourceMappingURL=glob.js.map

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Queue = void 0;
	var common_1 = __webpack_require__(1);
	var Queue = /** @class */ (function () {
	    function Queue(_items, _limit) {
	        if (_items === void 0) { _items = []; }
	        if (_limit === void 0) { _limit = null; }
	        this._items = _items;
	        this._limit = _limit;
	        this._evictListeners = [];
	        this.onEvict = common_1.pushTo(this._evictListeners);
	    }
	    Queue.prototype.enqueue = function (item) {
	        var items = this._items;
	        items.push(item);
	        if (this._limit && items.length > this._limit)
	            this.evict();
	        return item;
	    };
	    Queue.prototype.evict = function () {
	        var item = this._items.shift();
	        this._evictListeners.forEach(function (fn) { return fn(item); });
	        return item;
	    };
	    Queue.prototype.dequeue = function () {
	        if (this.size())
	            return this._items.splice(0, 1)[0];
	    };
	    Queue.prototype.clear = function () {
	        var current = this._items;
	        this._items = [];
	        return current;
	    };
	    Queue.prototype.size = function () {
	        return this._items.length;
	    };
	    Queue.prototype.remove = function (item) {
	        var idx = this._items.indexOf(item);
	        return idx > -1 && this._items.splice(idx, 1)[0];
	    };
	    Queue.prototype.peekTail = function () {
	        return this._items[this._items.length - 1];
	    };
	    Queue.prototype.peekHead = function () {
	        if (this.size())
	            return this._items[0];
	    };
	    return Queue;
	}());
	exports.Queue = Queue;
	//# sourceMappingURL=queue.js.map

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (this && this.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * This module contains code for State Parameters.
	 *
	 * See [[ParamDeclaration]]
	 *
	 * @packageDocumentation @preferred
	 */
	__exportStar(__webpack_require__(107), exports);
	__exportStar(__webpack_require__(14), exports);
	__exportStar(__webpack_require__(108), exports);
	__exportStar(__webpack_require__(51), exports);
	__exportStar(__webpack_require__(35), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ParamType = void 0;
	var common_1 = __webpack_require__(1);
	var predicates_1 = __webpack_require__(2);
	/**
	 * An internal class which implements [[ParamTypeDefinition]].
	 *
	 * A [[ParamTypeDefinition]] is a plain javascript object used to register custom parameter types.
	 * When a param type definition is registered, an instance of this class is created internally.
	 *
	 * This class has naive implementations for all the [[ParamTypeDefinition]] methods.
	 *
	 * Used by [[UrlMatcher]] when matching or formatting URLs, or comparing and validating parameter values.
	 *
	 * #### Example:
	 * ```js
	 * var paramTypeDef = {
	 *   decode: function(val) { return parseInt(val, 10); },
	 *   encode: function(val) { return val && val.toString(); },
	 *   equals: function(a, b) { return this.is(a) && a === b; },
	 *   is: function(val) { return angular.isNumber(val) && isFinite(val) && val % 1 === 0; },
	 *   pattern: /\d+/
	 * }
	 *
	 * var paramType = new ParamType(paramTypeDef);
	 * ```
	 */
	var ParamType = /** @class */ (function () {
	    /**
	     * @param def  A configuration object which contains the custom type definition.  The object's
	     *        properties will override the default methods and/or pattern in `ParamType`'s public interface.
	     * @returns a new ParamType object
	     */
	    function ParamType(def) {
	        /** @inheritdoc */
	        this.pattern = /.*/;
	        /** @inheritdoc */
	        this.inherit = true;
	        common_1.extend(this, def);
	    }
	    // consider these four methods to be "abstract methods" that should be overridden
	    /** @inheritdoc */
	    ParamType.prototype.is = function (val, key) {
	        return true;
	    };
	    /** @inheritdoc */
	    ParamType.prototype.encode = function (val, key) {
	        return val;
	    };
	    /** @inheritdoc */
	    ParamType.prototype.decode = function (val, key) {
	        return val;
	    };
	    /** @inheritdoc */
	    ParamType.prototype.equals = function (a, b) {
	        // tslint:disable-next-line:triple-equals
	        return a == b;
	    };
	    ParamType.prototype.$subPattern = function () {
	        var sub = this.pattern.toString();
	        return sub.substr(1, sub.length - 2);
	    };
	    ParamType.prototype.toString = function () {
	        return "{ParamType:" + this.name + "}";
	    };
	    /** Given an encoded string, or a decoded object, returns a decoded object */
	    ParamType.prototype.$normalize = function (val) {
	        return this.is(val) ? val : this.decode(val);
	    };
	    /**
	     * Wraps an existing custom ParamType as an array of ParamType, depending on 'mode'.
	     * e.g.:
	     * - urlmatcher pattern "/path?{queryParam[]:int}"
	     * - url: "/path?queryParam=1&queryParam=2
	     * - $stateParams.queryParam will be [1, 2]
	     * if `mode` is "auto", then
	     * - url: "/path?queryParam=1 will create $stateParams.queryParam: 1
	     * - url: "/path?queryParam=1&queryParam=2 will create $stateParams.queryParam: [1, 2]
	     */
	    ParamType.prototype.$asArray = function (mode, isSearch) {
	        if (!mode)
	            return this;
	        if (mode === 'auto' && !isSearch)
	            throw new Error("'auto' array mode is for query parameters only");
	        return new ArrayType(this, mode);
	    };
	    return ParamType;
	}());
	exports.ParamType = ParamType;
	/** Wraps up a `ParamType` object to handle array values. */
	function ArrayType(type, mode) {
	    var _this = this;
	    // Wrap non-array value as array
	    function arrayWrap(val) {
	        return predicates_1.isArray(val) ? val : predicates_1.isDefined(val) ? [val] : [];
	    }
	    // Unwrap array value for "auto" mode. Return undefined for empty array.
	    function arrayUnwrap(val) {
	        switch (val.length) {
	            case 0:
	                return undefined;
	            case 1:
	                return mode === 'auto' ? val[0] : val;
	            default:
	                return val;
	        }
	    }
	    // Wraps type (.is/.encode/.decode) functions to operate on each value of an array
	    function arrayHandler(callback, allTruthyMode) {
	        return function handleArray(val) {
	            if (predicates_1.isArray(val) && val.length === 0)
	                return val;
	            var arr = arrayWrap(val);
	            var result = common_1.map(arr, callback);
	            return allTruthyMode === true ? common_1.filter(result, function (x) { return !x; }).length === 0 : arrayUnwrap(result);
	        };
	    }
	    // Wraps type (.equals) functions to operate on each value of an array
	    function arrayEqualsHandler(callback) {
	        return function handleArray(val1, val2) {
	            var left = arrayWrap(val1), right = arrayWrap(val2);
	            if (left.length !== right.length)
	                return false;
	            for (var i = 0; i < left.length; i++) {
	                if (!callback(left[i], right[i]))
	                    return false;
	            }
	            return true;
	        };
	    }
	    ['encode', 'decode', 'equals', '$normalize'].forEach(function (name) {
	        var paramTypeFn = type[name].bind(type);
	        var wrapperFn = name === 'equals' ? arrayEqualsHandler : arrayHandler;
	        _this[name] = wrapperFn(paramTypeFn);
	    });
	    common_1.extend(this, {
	        dynamic: type.dynamic,
	        name: type.name,
	        pattern: type.pattern,
	        inherit: type.inherit,
	        raw: type.raw,
	        is: arrayHandler(type.is.bind(type), true),
	        $arrayMode: mode,
	    });
	}
	//# sourceMappingURL=paramType.js.map

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.PathNode = void 0;
	var common_1 = __webpack_require__(1);
	var hof_1 = __webpack_require__(3);
	var param_1 = __webpack_require__(14);
	/**
	 * A node in a [[TreeChanges]] path
	 *
	 * For a [[TreeChanges]] path, this class holds the stateful information for a single node in the path.
	 * Each PathNode corresponds to a state being entered, exited, or retained.
	 * The stateful information includes parameter values and resolve data.
	 */
	var PathNode = /** @class */ (function () {
	    function PathNode(stateOrNode) {
	        if (stateOrNode instanceof PathNode) {
	            var node = stateOrNode;
	            this.state = node.state;
	            this.paramSchema = node.paramSchema.slice();
	            this.paramValues = common_1.extend({}, node.paramValues);
	            this.resolvables = node.resolvables.slice();
	            this.views = node.views && node.views.slice();
	        }
	        else {
	            var state = stateOrNode;
	            this.state = state;
	            this.paramSchema = state.parameters({ inherit: false });
	            this.paramValues = {};
	            this.resolvables = state.resolvables.map(function (res) { return res.clone(); });
	        }
	    }
	    PathNode.prototype.clone = function () {
	        return new PathNode(this);
	    };
	    /** Sets [[paramValues]] for the node, from the values of an object hash */
	    PathNode.prototype.applyRawParams = function (params) {
	        var getParamVal = function (paramDef) { return [paramDef.id, paramDef.value(params[paramDef.id])]; };
	        this.paramValues = this.paramSchema.reduce(function (memo, pDef) { return common_1.applyPairs(memo, getParamVal(pDef)); }, {});
	        return this;
	    };
	    /** Gets a specific [[Param]] metadata that belongs to the node */
	    PathNode.prototype.parameter = function (name) {
	        return common_1.find(this.paramSchema, hof_1.propEq('id', name));
	    };
	    /**
	     * @returns true if the state and parameter values for another PathNode are
	     * equal to the state and param values for this PathNode
	     */
	    PathNode.prototype.equals = function (node, paramsFn) {
	        var diff = this.diff(node, paramsFn);
	        return diff && diff.length === 0;
	    };
	    /**
	     * Finds Params with different parameter values on another PathNode.
	     *
	     * Given another node (of the same state), finds the parameter values which differ.
	     * Returns the [[Param]] (schema objects) whose parameter values differ.
	     *
	     * Given another node for a different state, returns `false`
	     *
	     * @param node The node to compare to
	     * @param paramsFn A function that returns which parameters should be compared.
	     * @returns The [[Param]]s which differ, or null if the two nodes are for different states
	     */
	    PathNode.prototype.diff = function (node, paramsFn) {
	        if (this.state !== node.state)
	            return false;
	        var params = paramsFn ? paramsFn(this) : this.paramSchema;
	        return param_1.Param.changed(params, this.paramValues, node.paramValues);
	    };
	    /**
	     * Returns a clone of the PathNode
	     * @deprecated use instance method `node.clone()`
	     */
	    PathNode.clone = function (node) { return node.clone(); };
	    return PathNode;
	}());
	exports.PathNode = PathNode;
	//# sourceMappingURL=pathNode.js.map

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (this && this.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * # The state subsystem
	 *
	 * This subsystem implements the ui-router state tree
	 *
	 * - The [[StateService]] has state-related service methods such as:
	 *   - [[StateService.get]]: Get a registered [[StateDeclaration]] object
	 *   - [[StateService.go]]: Transition from the current state to a new state
	 *   - [[StateService.reload]]: Reload the current state
	 *   - [[StateService.target]]: Get a [[TargetState]] (useful when redirecting from a Transition Hook)
	 *   - [[StateService.onInvalid]]: Register a callback for when a transition to an invalid state is started
	 *   - [[StateService.defaultErrorHandler]]: Register a global callback for when a transition errors
	 * - The [[StateDeclaration]] interface defines the shape of a state declaration
	 * - The [[StateRegistry]] contains all the registered states
	 *   - States can be added/removed using the [[StateRegistry.register]] and [[StateRegistry.deregister]]
	 *     - Note: Bootstrap state registration differs by front-end framework.
	 *   - Get notified of state registration/deregistration using [[StateRegistry.onStatesChanged]].
	 *
	 * @packageDocumentation
	 */
	__exportStar(__webpack_require__(110), exports);
	__exportStar(__webpack_require__(55), exports);
	__exportStar(__webpack_require__(38), exports);
	__exportStar(__webpack_require__(56), exports);
	__exportStar(__webpack_require__(57), exports);
	__exportStar(__webpack_require__(58), exports);
	__exportStar(__webpack_require__(59), exports);
	__exportStar(__webpack_require__(15), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.StateObject = void 0;
	var common_1 = __webpack_require__(1);
	var hof_1 = __webpack_require__(3);
	var glob_1 = __webpack_require__(32);
	var predicates_1 = __webpack_require__(2);
	/**
	 * Internal representation of a UI-Router state.
	 *
	 * Instances of this class are created when a [[StateDeclaration]] is registered with the [[StateRegistry]].
	 *
	 * A registered [[StateDeclaration]] is augmented with a getter ([[StateDeclaration.$$state]]) which returns the corresponding [[StateObject]] object.
	 *
	 * This class prototypally inherits from the corresponding [[StateDeclaration]].
	 * Each of its own properties (i.e., `hasOwnProperty`) are built using builders from the [[StateBuilder]].
	 */
	var StateObject = /** @class */ (function () {
	    /** @deprecated use State.create() */
	    function StateObject(config) {
	        return StateObject.create(config || {});
	    }
	    /**
	     * Create a state object to put the private/internal implementation details onto.
	     * The object's prototype chain looks like:
	     * (Internal State Object) -> (Copy of State.prototype) -> (State Declaration object) -> (State Declaration's prototype...)
	     *
	     * @param stateDecl the user-supplied State Declaration
	     * @returns {StateObject} an internal State object
	     */
	    StateObject.create = function (stateDecl) {
	        stateDecl = StateObject.isStateClass(stateDecl) ? new stateDecl() : stateDecl;
	        var state = common_1.inherit(common_1.inherit(stateDecl, StateObject.prototype));
	        stateDecl.$$state = function () { return state; };
	        state.self = stateDecl;
	        state.__stateObjectCache = {
	            nameGlob: glob_1.Glob.fromString(state.name),
	        };
	        return state;
	    };
	    /**
	     * Returns true if the provided parameter is the same state.
	     *
	     * Compares the identity of the state against the passed value, which is either an object
	     * reference to the actual `State` instance, the original definition object passed to
	     * `$stateProvider.state()`, or the fully-qualified name.
	     *
	     * @param ref Can be one of (a) a `State` instance, (b) an object that was passed
	     *        into `$stateProvider.state()`, (c) the fully-qualified name of a state as a string.
	     * @returns Returns `true` if `ref` matches the current `State` instance.
	     */
	    StateObject.prototype.is = function (ref) {
	        return this === ref || this.self === ref || this.fqn() === ref;
	    };
	    /**
	     * @deprecated this does not properly handle dot notation
	     * @returns Returns a dot-separated name of the state.
	     */
	    StateObject.prototype.fqn = function () {
	        if (!this.parent || !(this.parent instanceof this.constructor))
	            return this.name;
	        var name = this.parent.fqn();
	        return name ? name + '.' + this.name : this.name;
	    };
	    /**
	     * Returns the root node of this state's tree.
	     *
	     * @returns The root of this state's tree.
	     */
	    StateObject.prototype.root = function () {
	        return (this.parent && this.parent.root()) || this;
	    };
	    /**
	     * Gets the state's `Param` objects
	     *
	     * Gets the list of [[Param]] objects owned by the state.
	     * If `opts.inherit` is true, it also includes the ancestor states' [[Param]] objects.
	     * If `opts.matchingKeys` exists, returns only `Param`s whose `id` is a key on the `matchingKeys` object
	     *
	     * @param opts options
	     */
	    StateObject.prototype.parameters = function (opts) {
	        opts = common_1.defaults(opts, { inherit: true, matchingKeys: null });
	        var inherited = (opts.inherit && this.parent && this.parent.parameters()) || [];
	        return inherited
	            .concat(common_1.values(this.params))
	            .filter(function (param) { return !opts.matchingKeys || opts.matchingKeys.hasOwnProperty(param.id); });
	    };
	    /**
	     * Returns a single [[Param]] that is owned by the state
	     *
	     * If `opts.inherit` is true, it also searches the ancestor states` [[Param]]s.
	     * @param id the name of the [[Param]] to return
	     * @param opts options
	     */
	    StateObject.prototype.parameter = function (id, opts) {
	        if (opts === void 0) { opts = {}; }
	        return ((this.url && this.url.parameter(id, opts)) ||
	            common_1.find(common_1.values(this.params), hof_1.propEq('id', id)) ||
	            (opts.inherit && this.parent && this.parent.parameter(id)));
	    };
	    StateObject.prototype.toString = function () {
	        return this.fqn();
	    };
	    /** Predicate which returns true if the object is an class with @State() decorator */
	    StateObject.isStateClass = function (stateDecl) {
	        return predicates_1.isFunction(stateDecl) && stateDecl['__uiRouterState'] === true;
	    };
	    /** Predicate which returns true if the object is a [[StateDeclaration]] object */
	    StateObject.isStateDeclaration = function (obj) { return predicates_1.isFunction(obj['$$state']); };
	    /** Predicate which returns true if the object is an internal [[StateObject]] object */
	    StateObject.isState = function (obj) { return predicates_1.isObject(obj['__stateObjectCache']); };
	    return StateObject;
	}());
	exports.StateObject = StateObject;
	//# sourceMappingURL=stateObject.js.map

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.makeEvent = exports.RegisteredHook = exports.matchState = void 0;
	var common_1 = __webpack_require__(4);
	var interface_1 = __webpack_require__(11);
	/**
	 * Determines if the given state matches the matchCriteria
	 *
	 * @internal
	 *
	 * @param state a State Object to test against
	 * @param criterion
	 * - If a string, matchState uses the string as a glob-matcher against the state name
	 * - If an array (of strings), matchState uses each string in the array as a glob-matchers against the state name
	 *   and returns a positive match if any of the globs match.
	 * - If a function, matchState calls the function with the state and returns true if the function's result is truthy.
	 * @returns {boolean}
	 */
	function matchState(state, criterion, transition) {
	    var toMatch = common_1.isString(criterion) ? [criterion] : criterion;
	    function matchGlobs(_state) {
	        var globStrings = toMatch;
	        for (var i = 0; i < globStrings.length; i++) {
	            var glob = new common_1.Glob(globStrings[i]);
	            if ((glob && glob.matches(_state.name)) || (!glob && globStrings[i] === _state.name)) {
	                return true;
	            }
	        }
	        return false;
	    }
	    var matchFn = (common_1.isFunction(toMatch) ? toMatch : matchGlobs);
	    return !!matchFn(state, transition);
	}
	exports.matchState = matchState;
	/**
	 * The registration data for a registered transition hook
	 */
	var RegisteredHook = /** @class */ (function () {
	    function RegisteredHook(tranSvc, eventType, callback, matchCriteria, removeHookFromRegistry, options) {
	        if (options === void 0) { options = {}; }
	        this.tranSvc = tranSvc;
	        this.eventType = eventType;
	        this.callback = callback;
	        this.matchCriteria = matchCriteria;
	        this.removeHookFromRegistry = removeHookFromRegistry;
	        this.invokeCount = 0;
	        this._deregistered = false;
	        this.priority = options.priority || 0;
	        this.bind = options.bind || null;
	        this.invokeLimit = options.invokeLimit;
	    }
	    /**
	     * Gets the matching [[PathNode]]s
	     *
	     * Given an array of [[PathNode]]s, and a [[HookMatchCriterion]], returns an array containing
	     * the [[PathNode]]s that the criteria matches, or `null` if there were no matching nodes.
	     *
	     * Returning `null` is significant to distinguish between the default
	     * "match-all criterion value" of `true` compared to a `() => true` function,
	     * when the nodes is an empty array.
	     *
	     * This is useful to allow a transition match criteria of `entering: true`
	     * to still match a transition, even when `entering === []`.  Contrast that
	     * with `entering: (state) => true` which only matches when a state is actually
	     * being entered.
	     */
	    RegisteredHook.prototype._matchingNodes = function (nodes, criterion, transition) {
	        if (criterion === true)
	            return nodes;
	        var matching = nodes.filter(function (node) { return matchState(node.state, criterion, transition); });
	        return matching.length ? matching : null;
	    };
	    /**
	     * Gets the default match criteria (all `true`)
	     *
	     * Returns an object which has all the criteria match paths as keys and `true` as values, i.e.:
	     *
	     * ```js
	     * {
	     *   to: true,
	     *   from: true,
	     *   entering: true,
	     *   exiting: true,
	     *   retained: true,
	     * }
	     */
	    RegisteredHook.prototype._getDefaultMatchCriteria = function () {
	        return common_1.mapObj(this.tranSvc._pluginapi._getPathTypes(), function () { return true; });
	    };
	    /**
	     * Gets matching nodes as [[IMatchingNodes]]
	     *
	     * Create a IMatchingNodes object from the TransitionHookTypes that is roughly equivalent to:
	     *
	     * ```js
	     * let matches: IMatchingNodes = {
	     *   to:       _matchingNodes([tail(treeChanges.to)],   mc.to),
	     *   from:     _matchingNodes([tail(treeChanges.from)], mc.from),
	     *   exiting:  _matchingNodes(treeChanges.exiting,      mc.exiting),
	     *   retained: _matchingNodes(treeChanges.retained,     mc.retained),
	     *   entering: _matchingNodes(treeChanges.entering,     mc.entering),
	     * };
	     * ```
	     */
	    RegisteredHook.prototype._getMatchingNodes = function (treeChanges, transition) {
	        var _this = this;
	        var criteria = common_1.extend(this._getDefaultMatchCriteria(), this.matchCriteria);
	        var paths = common_1.values(this.tranSvc._pluginapi._getPathTypes());
	        return paths.reduce(function (mn, pathtype) {
	            // STATE scope criteria matches against every node in the path.
	            // TRANSITION scope criteria matches against only the last node in the path
	            var isStateHook = pathtype.scope === interface_1.TransitionHookScope.STATE;
	            var path = treeChanges[pathtype.name] || [];
	            var nodes = isStateHook ? path : [common_1.tail(path)];
	            mn[pathtype.name] = _this._matchingNodes(nodes, criteria[pathtype.name], transition);
	            return mn;
	        }, {});
	    };
	    /**
	     * Determines if this hook's [[matchCriteria]] match the given [[TreeChanges]]
	     *
	     * @returns an IMatchingNodes object, or null. If an IMatchingNodes object is returned, its values
	     * are the matching [[PathNode]]s for each [[HookMatchCriterion]] (to, from, exiting, retained, entering)
	     */
	    RegisteredHook.prototype.matches = function (treeChanges, transition) {
	        var matches = this._getMatchingNodes(treeChanges, transition);
	        // Check if all the criteria matched the TreeChanges object
	        var allMatched = common_1.values(matches).every(common_1.identity);
	        return allMatched ? matches : null;
	    };
	    RegisteredHook.prototype.deregister = function () {
	        this.removeHookFromRegistry(this);
	        this._deregistered = true;
	    };
	    return RegisteredHook;
	}());
	exports.RegisteredHook = RegisteredHook;
	/** Return a registration function of the requested type. */
	function makeEvent(registry, transitionService, eventType) {
	    // Create the object which holds the registered transition hooks.
	    var _registeredHooks = (registry._registeredHooks = registry._registeredHooks || {});
	    var hooks = (_registeredHooks[eventType.name] = []);
	    var removeHookFn = common_1.removeFrom(hooks);
	    // Create hook registration function on the IHookRegistry for the event
	    registry[eventType.name] = hookRegistrationFn;
	    function hookRegistrationFn(matchObject, callback, options) {
	        if (options === void 0) { options = {}; }
	        var registeredHook = new RegisteredHook(transitionService, eventType, callback, matchObject, removeHookFn, options);
	        hooks.push(registeredHook);
	        return registeredHook.deregister.bind(registeredHook);
	    }
	    return hookRegistrationFn;
	}
	exports.makeEvent = makeEvent;
	//# sourceMappingURL=hookRegistry.js.map

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Transition = void 0;
	var trace_1 = __webpack_require__(8);
	var coreservices_1 = __webpack_require__(5);
	var strings_1 = __webpack_require__(6);
	var common_1 = __webpack_require__(1);
	var predicates_1 = __webpack_require__(2);
	var hof_1 = __webpack_require__(3);
	var interface_1 = __webpack_require__(11); // has or is using
	var transitionHook_1 = __webpack_require__(16);
	var hookRegistry_1 = __webpack_require__(39);
	var hookBuilder_1 = __webpack_require__(60);
	var pathUtils_1 = __webpack_require__(20);
	var param_1 = __webpack_require__(14);
	var resolvable_1 = __webpack_require__(21);
	var resolveContext_1 = __webpack_require__(22);
	var rejectFactory_1 = __webpack_require__(12);
	var common_2 = __webpack_require__(4);
	/** @internal */
	var stateSelf = hof_1.prop('self');
	/**
	 * Represents a transition between two states.
	 *
	 * When navigating to a state, we are transitioning **from** the current state **to** the new state.
	 *
	 * This object contains all contextual information about the to/from states, parameters, resolves.
	 * It has information about all states being entered and exited as a result of the transition.
	 */
	var Transition = /** @class */ (function () {
	    /**
	     * Creates a new Transition object.
	     *
	     * If the target state is not valid, an error is thrown.
	     *
	     * @internal
	     *
	     * @param fromPath The path of [[PathNode]]s from which the transition is leaving.  The last node in the `fromPath`
	     *        encapsulates the "from state".
	     * @param targetState The target state and parameters being transitioned to (also, the transition options)
	     * @param router The [[UIRouter]] instance
	     * @internal
	     */
	    function Transition(fromPath, targetState, router) {
	        var _this = this;
	        /** @internal */
	        this._deferred = coreservices_1.services.$q.defer();
	        /**
	         * This promise is resolved or rejected based on the outcome of the Transition.
	         *
	         * When the transition is successful, the promise is resolved
	         * When the transition is unsuccessful, the promise is rejected with the [[Rejection]] or javascript error
	         */
	        this.promise = this._deferred.promise;
	        /** @internal Holds the hook registration functions such as those passed to Transition.onStart() */
	        this._registeredHooks = {};
	        /** @internal */
	        this._hookBuilder = new hookBuilder_1.HookBuilder(this);
	        /** Checks if this transition is currently active/running. */
	        this.isActive = function () { return _this.router.globals.transition === _this; };
	        this.router = router;
	        this._targetState = targetState;
	        if (!targetState.valid()) {
	            throw new Error(targetState.error());
	        }
	        // current() is assumed to come from targetState.options, but provide a naive implementation otherwise.
	        this._options = common_1.extend({ current: hof_1.val(this) }, targetState.options());
	        this.$id = router.transitionService._transitionCount++;
	        var toPath = pathUtils_1.PathUtils.buildToPath(fromPath, targetState);
	        this._treeChanges = pathUtils_1.PathUtils.treeChanges(fromPath, toPath, this._options.reloadState);
	        this.createTransitionHookRegFns();
	        var onCreateHooks = this._hookBuilder.buildHooksForPhase(interface_1.TransitionHookPhase.CREATE);
	        transitionHook_1.TransitionHook.invokeHooks(onCreateHooks, function () { return null; });
	        this.applyViewConfigs(router);
	    }
	    /** @internal */
	    Transition.prototype.onBefore = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    Transition.prototype.onStart = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    Transition.prototype.onExit = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    Transition.prototype.onRetain = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    Transition.prototype.onEnter = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    Transition.prototype.onFinish = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    Transition.prototype.onSuccess = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    Transition.prototype.onError = function (criteria, callback, options) {
	        return;
	    };
	    /** @internal
	     * Creates the transition-level hook registration functions
	     * (which can then be used to register hooks)
	     */
	    Transition.prototype.createTransitionHookRegFns = function () {
	        var _this = this;
	        this.router.transitionService._pluginapi
	            ._getEvents()
	            .filter(function (type) { return type.hookPhase !== interface_1.TransitionHookPhase.CREATE; })
	            .forEach(function (type) { return hookRegistry_1.makeEvent(_this, _this.router.transitionService, type); });
	    };
	    /** @internal */
	    Transition.prototype.getHooks = function (hookName) {
	        return this._registeredHooks[hookName];
	    };
	    Transition.prototype.applyViewConfigs = function (router) {
	        var enteringStates = this._treeChanges.entering.map(function (node) { return node.state; });
	        pathUtils_1.PathUtils.applyViewConfigs(router.transitionService.$view, this._treeChanges.to, enteringStates);
	    };
	    /**
	     * @internal
	     * @returns the internal from [State] object
	     */
	    Transition.prototype.$from = function () {
	        return common_1.tail(this._treeChanges.from).state;
	    };
	    /**
	     * @internal
	     * @returns the internal to [State] object
	     */
	    Transition.prototype.$to = function () {
	        return common_1.tail(this._treeChanges.to).state;
	    };
	    /**
	     * Returns the "from state"
	     *
	     * Returns the state that the transition is coming *from*.
	     *
	     * @returns The state declaration object for the Transition's ("from state").
	     */
	    Transition.prototype.from = function () {
	        return this.$from().self;
	    };
	    /**
	     * Returns the "to state"
	     *
	     * Returns the state that the transition is going *to*.
	     *
	     * @returns The state declaration object for the Transition's target state ("to state").
	     */
	    Transition.prototype.to = function () {
	        return this.$to().self;
	    };
	    /**
	     * Gets the Target State
	     *
	     * A transition's [[TargetState]] encapsulates the [[to]] state, the [[params]], and the [[options]] as a single object.
	     *
	     * @returns the [[TargetState]] of this Transition
	     */
	    Transition.prototype.targetState = function () {
	        return this._targetState;
	    };
	    /**
	     * Determines whether two transitions are equivalent.
	     * @deprecated
	     */
	    Transition.prototype.is = function (compare) {
	        if (compare instanceof Transition) {
	            // TODO: Also compare parameters
	            return this.is({ to: compare.$to().name, from: compare.$from().name });
	        }
	        return !((compare.to && !hookRegistry_1.matchState(this.$to(), compare.to, this)) ||
	            (compare.from && !hookRegistry_1.matchState(this.$from(), compare.from, this)));
	    };
	    Transition.prototype.params = function (pathname) {
	        if (pathname === void 0) { pathname = 'to'; }
	        return Object.freeze(this._treeChanges[pathname].map(hof_1.prop('paramValues')).reduce(common_1.mergeR, {}));
	    };
	    Transition.prototype.paramsChanged = function () {
	        var fromParams = this.params('from');
	        var toParams = this.params('to');
	        // All the parameters declared on both the "to" and "from" paths
	        var allParamDescriptors = []
	            .concat(this._treeChanges.to)
	            .concat(this._treeChanges.from)
	            .map(function (pathNode) { return pathNode.paramSchema; })
	            .reduce(common_2.flattenR, [])
	            .reduce(common_2.uniqR, []);
	        var changedParamDescriptors = param_1.Param.changed(allParamDescriptors, fromParams, toParams);
	        return changedParamDescriptors.reduce(function (changedValues, descriptor) {
	            changedValues[descriptor.id] = toParams[descriptor.id];
	            return changedValues;
	        }, {});
	    };
	    /**
	     * Creates a [[UIInjector]] Dependency Injector
	     *
	     * Returns a Dependency Injector for the Transition's target state (to state).
	     * The injector provides resolve values which the target state has access to.
	     *
	     * The `UIInjector` can also provide values from the native root/global injector (ng1/ng2).
	     *
	     * #### Example:
	     * ```js
	     * .onEnter({ entering: 'myState' }, trans => {
	     *   var myResolveValue = trans.injector().get('myResolve');
	     *   // Inject a global service from the global/native injector (if it exists)
	     *   var MyService = trans.injector().get('MyService');
	     * })
	     * ```
	     *
	     * In some cases (such as `onBefore`), you may need access to some resolve data but it has not yet been fetched.
	     * You can use [[UIInjector.getAsync]] to get a promise for the data.
	     * #### Example:
	     * ```js
	     * .onBefore({}, trans => {
	     *   return trans.injector().getAsync('myResolve').then(myResolveValue =>
	     *     return myResolveValue !== 'ABORT';
	     *   });
	     * });
	     * ```
	     *
	     * If a `state` is provided, the injector that is returned will be limited to resolve values that the provided state has access to.
	     * This can be useful if both a parent state `foo` and a child state `foo.bar` have both defined a resolve such as `data`.
	     * #### Example:
	     * ```js
	     * .onEnter({ to: 'foo.bar' }, trans => {
	     *   // returns result of `foo` state's `myResolve` resolve
	     *   // even though `foo.bar` also has a `myResolve` resolve
	     *   var fooData = trans.injector('foo').get('myResolve');
	     * });
	     * ```
	     *
	     * If you need resolve data from the exiting states, pass `'from'` as `pathName`.
	     * The resolve data from the `from` path will be returned.
	     * #### Example:
	     * ```js
	     * .onExit({ exiting: 'foo.bar' }, trans => {
	     *   // Gets the resolve value of `myResolve` from the state being exited
	     *   var fooData = trans.injector(null, 'from').get('myResolve');
	     * });
	     * ```
	     *
	     *
	     * @param state Limits the resolves provided to only the resolves the provided state has access to.
	     * @param pathName Default: `'to'`: Chooses the path for which to create the injector. Use this to access resolves for `exiting` states.
	     *
	     * @returns a [[UIInjector]]
	     */
	    Transition.prototype.injector = function (state, pathName) {
	        if (pathName === void 0) { pathName = 'to'; }
	        var path = this._treeChanges[pathName];
	        if (state)
	            path = pathUtils_1.PathUtils.subPath(path, function (node) { return node.state === state || node.state.name === state; });
	        return new resolveContext_1.ResolveContext(path).injector();
	    };
	    /**
	     * Gets all available resolve tokens (keys)
	     *
	     * This method can be used in conjunction with [[injector]] to inspect the resolve values
	     * available to the Transition.
	     *
	     * This returns all the tokens defined on [[StateDeclaration.resolve]] blocks, for the states
	     * in the Transition's [[TreeChanges.to]] path.
	     *
	     * #### Example:
	     * This example logs all resolve values
	     * ```js
	     * let tokens = trans.getResolveTokens();
	     * tokens.forEach(token => console.log(token + " = " + trans.injector().get(token)));
	     * ```
	     *
	     * #### Example:
	     * This example creates promises for each resolve value.
	     * This triggers fetches of resolves (if any have not yet been fetched).
	     * When all promises have all settled, it logs the resolve values.
	     * ```js
	     * let tokens = trans.getResolveTokens();
	     * let promise = tokens.map(token => trans.injector().getAsync(token));
	     * Promise.all(promises).then(values => console.log("Resolved values: " + values));
	     * ```
	     *
	     * Note: Angular 1 users whould use `$q.all()`
	     *
	     * @param pathname resolve context's path name (e.g., `to` or `from`)
	     *
	     * @returns an array of resolve tokens (keys)
	     */
	    Transition.prototype.getResolveTokens = function (pathname) {
	        if (pathname === void 0) { pathname = 'to'; }
	        return new resolveContext_1.ResolveContext(this._treeChanges[pathname]).getTokens();
	    };
	    /**
	     * Dynamically adds a new [[Resolvable]] (i.e., [[StateDeclaration.resolve]]) to this transition.
	     *
	     * Allows a transition hook to dynamically add a Resolvable to this Transition.
	     *
	     * Use the [[Transition.injector]] to retrieve the resolved data in subsequent hooks ([[UIInjector.get]]).
	     *
	     * If a `state` argument is provided, the Resolvable is processed when that state is being entered.
	     * If no `state` is provided then the root state is used.
	     * If the given `state` has already been entered, the Resolvable is processed when any child state is entered.
	     * If no child states will be entered, the Resolvable is processed during the `onFinish` phase of the Transition.
	     *
	     * The `state` argument also scopes the resolved data.
	     * The resolved data is available from the injector for that `state` and any children states.
	     *
	     * #### Example:
	     * ```js
	     * transitionService.onBefore({}, transition => {
	     *   transition.addResolvable({
	     *     token: 'myResolve',
	     *     deps: ['MyService'],
	     *     resolveFn: myService => myService.getData()
	     *   });
	     * });
	     * ```
	     *
	     * @param resolvable a [[ResolvableLiteral]] object (or a [[Resolvable]])
	     * @param state the state in the "to path" which should receive the new resolve (otherwise, the root state)
	     */
	    Transition.prototype.addResolvable = function (resolvable, state) {
	        if (state === void 0) { state = ''; }
	        resolvable = hof_1.is(resolvable_1.Resolvable)(resolvable) ? resolvable : new resolvable_1.Resolvable(resolvable);
	        var stateName = typeof state === 'string' ? state : state.name;
	        var topath = this._treeChanges.to;
	        var targetNode = common_1.find(topath, function (node) { return node.state.name === stateName; });
	        var resolveContext = new resolveContext_1.ResolveContext(topath);
	        resolveContext.addResolvables([resolvable], targetNode.state);
	    };
	    /**
	     * Gets the transition from which this transition was redirected.
	     *
	     * If the current transition is a redirect, this method returns the transition that was redirected.
	     *
	     * #### Example:
	     * ```js
	     * let transitionA = $state.go('A').transition
	     * transitionA.onStart({}, () => $state.target('B'));
	     * $transitions.onSuccess({ to: 'B' }, (trans) => {
	     *   trans.to().name === 'B'; // true
	     *   trans.redirectedFrom() === transitionA; // true
	     * });
	     * ```
	     *
	     * @returns The previous Transition, or null if this Transition is not the result of a redirection
	     */
	    Transition.prototype.redirectedFrom = function () {
	        return this._options.redirectedFrom || null;
	    };
	    /**
	     * Gets the original transition in a redirect chain
	     *
	     * A transition might belong to a long chain of multiple redirects.
	     * This method walks the [[redirectedFrom]] chain back to the original (first) transition in the chain.
	     *
	     * #### Example:
	     * ```js
	     * // states
	     * registry.register({ name: 'A', redirectTo: 'B' });
	     * registry.register({ name: 'B', redirectTo: 'C' });
	     * registry.register({ name: 'C', redirectTo: 'D' });
	     * registry.register({ name: 'D' });
	     *
	     * let transitionA = $state.go('A').transition
	     *
	     * $transitions.onSuccess({ to: 'D' }, (trans) => {
	     *   trans.to().name === 'D'; // true
	     *   trans.redirectedFrom().to().name === 'C'; // true
	     *   trans.originalTransition() === transitionA; // true
	     *   trans.originalTransition().to().name === 'A'; // true
	     * });
	     * ```
	     *
	     * @returns The original Transition that started a redirect chain
	     */
	    Transition.prototype.originalTransition = function () {
	        var rf = this.redirectedFrom();
	        return (rf && rf.originalTransition()) || this;
	    };
	    /**
	     * Get the transition options
	     *
	     * @returns the options for this Transition.
	     */
	    Transition.prototype.options = function () {
	        return this._options;
	    };
	    /**
	     * Gets the states being entered.
	     *
	     * @returns an array of states that will be entered during this transition.
	     */
	    Transition.prototype.entering = function () {
	        return common_1.map(this._treeChanges.entering, hof_1.prop('state')).map(stateSelf);
	    };
	    /**
	     * Gets the states being exited.
	     *
	     * @returns an array of states that will be exited during this transition.
	     */
	    Transition.prototype.exiting = function () {
	        return common_1.map(this._treeChanges.exiting, hof_1.prop('state')).map(stateSelf).reverse();
	    };
	    /**
	     * Gets the states being retained.
	     *
	     * @returns an array of states that are already entered from a previous Transition, that will not be
	     *    exited during this Transition
	     */
	    Transition.prototype.retained = function () {
	        return common_1.map(this._treeChanges.retained, hof_1.prop('state')).map(stateSelf);
	    };
	    /**
	     * Get the [[ViewConfig]]s associated with this Transition
	     *
	     * Each state can define one or more views (template/controller), which are encapsulated as `ViewConfig` objects.
	     * This method fetches the `ViewConfigs` for a given path in the Transition (e.g., "to" or "entering").
	     *
	     * @param pathname the name of the path to fetch views for:
	     *   (`'to'`, `'from'`, `'entering'`, `'exiting'`, `'retained'`)
	     * @param state If provided, only returns the `ViewConfig`s for a single state in the path
	     *
	     * @returns a list of ViewConfig objects for the given path.
	     */
	    Transition.prototype.views = function (pathname, state) {
	        if (pathname === void 0) { pathname = 'entering'; }
	        var path = this._treeChanges[pathname];
	        path = !state ? path : path.filter(hof_1.propEq('state', state));
	        return path.map(hof_1.prop('views')).filter(common_1.identity).reduce(common_1.unnestR, []);
	    };
	    Transition.prototype.treeChanges = function (pathname) {
	        return pathname ? this._treeChanges[pathname] : this._treeChanges;
	    };
	    /**
	     * Creates a new transition that is a redirection of the current one.
	     *
	     * This transition can be returned from a [[TransitionService]] hook to
	     * redirect a transition to a new state and/or set of parameters.
	     *
	     * @internal
	     *
	     * @returns Returns a new [[Transition]] instance.
	     */
	    Transition.prototype.redirect = function (targetState) {
	        var redirects = 1, trans = this;
	        // tslint:disable-next-line:no-conditional-assignment
	        while ((trans = trans.redirectedFrom()) != null) {
	            if (++redirects > 20)
	                throw new Error("Too many consecutive Transition redirects (20+)");
	        }
	        var redirectOpts = { redirectedFrom: this, source: 'redirect' };
	        // If the original transition was caused by URL sync, then use { location: 'replace' }
	        // on the new transition (unless the target state explicitly specifies location: false).
	        // This causes the original url to be replaced with the url for the redirect target
	        // so the original url disappears from the browser history.
	        if (this.options().source === 'url' && targetState.options().location !== false) {
	            redirectOpts.location = 'replace';
	        }
	        var newOptions = common_1.extend({}, this.options(), targetState.options(), redirectOpts);
	        targetState = targetState.withOptions(newOptions, true);
	        var newTransition = this.router.transitionService.create(this._treeChanges.from, targetState);
	        var originalEnteringNodes = this._treeChanges.entering;
	        var redirectEnteringNodes = newTransition._treeChanges.entering;
	        // --- Re-use resolve data from original transition ---
	        // When redirecting from a parent state to a child state where the parent parameter values haven't changed
	        // (because of the redirect), the resolves fetched by the original transition are still valid in the
	        // redirected transition.
	        //
	        // This allows you to define a redirect on a parent state which depends on an async resolve value.
	        // You can wait for the resolve, then redirect to a child state based on the result.
	        // The redirected transition does not have to re-fetch the resolve.
	        // ---------------------------------------------------------
	        var nodeIsReloading = function (reloadState) { return function (node) {
	            return reloadState && node.state.includes[reloadState.name];
	        }; };
	        // Find any "entering" nodes in the redirect path that match the original path and aren't being reloaded
	        var matchingEnteringNodes = pathUtils_1.PathUtils.matching(redirectEnteringNodes, originalEnteringNodes, pathUtils_1.PathUtils.nonDynamicParams).filter(hof_1.not(nodeIsReloading(targetState.options().reloadState)));
	        // Use the existing (possibly pre-resolved) resolvables for the matching entering nodes.
	        matchingEnteringNodes.forEach(function (node, idx) {
	            node.resolvables = originalEnteringNodes[idx].resolvables;
	        });
	        return newTransition;
	    };
	    /** @internal If a transition doesn't exit/enter any states, returns any [[Param]] whose value changed */
	    Transition.prototype._changedParams = function () {
	        var tc = this._treeChanges;
	        /** Return undefined if it's not a "dynamic" transition, for the following reasons */
	        // If user explicitly wants a reload
	        if (this._options.reload)
	            return undefined;
	        // If any states are exiting or entering
	        if (tc.exiting.length || tc.entering.length)
	            return undefined;
	        // If to/from path lengths differ
	        if (tc.to.length !== tc.from.length)
	            return undefined;
	        // If the to/from paths are different
	        var pathsDiffer = common_1.arrayTuples(tc.to, tc.from)
	            .map(function (tuple) { return tuple[0].state !== tuple[1].state; })
	            .reduce(common_1.anyTrueR, false);
	        if (pathsDiffer)
	            return undefined;
	        // Find any parameter values that differ
	        var nodeSchemas = tc.to.map(function (node) { return node.paramSchema; });
	        var _a = [tc.to, tc.from].map(function (path) { return path.map(function (x) { return x.paramValues; }); }), toValues = _a[0], fromValues = _a[1];
	        var tuples = common_1.arrayTuples(nodeSchemas, toValues, fromValues);
	        return tuples.map(function (_a) {
	            var schema = _a[0], toVals = _a[1], fromVals = _a[2];
	            return param_1.Param.changed(schema, toVals, fromVals);
	        }).reduce(common_1.unnestR, []);
	    };
	    /**
	     * Returns true if the transition is dynamic.
	     *
	     * A transition is dynamic if no states are entered nor exited, but at least one dynamic parameter has changed.
	     *
	     * @returns true if the Transition is dynamic
	     */
	    Transition.prototype.dynamic = function () {
	        var changes = this._changedParams();
	        return !changes ? false : changes.map(function (x) { return x.dynamic; }).reduce(common_1.anyTrueR, false);
	    };
	    /**
	     * Returns true if the transition is ignored.
	     *
	     * A transition is ignored if no states are entered nor exited, and no parameter values have changed.
	     *
	     * @returns true if the Transition is ignored.
	     */
	    Transition.prototype.ignored = function () {
	        return !!this._ignoredReason();
	    };
	    /** @internal */
	    Transition.prototype._ignoredReason = function () {
	        var pending = this.router.globals.transition;
	        var reloadState = this._options.reloadState;
	        var same = function (pathA, pathB) {
	            if (pathA.length !== pathB.length)
	                return false;
	            var matching = pathUtils_1.PathUtils.matching(pathA, pathB);
	            return pathA.length === matching.filter(function (node) { return !reloadState || !node.state.includes[reloadState.name]; }).length;
	        };
	        var newTC = this.treeChanges();
	        var pendTC = pending && pending.treeChanges();
	        if (pendTC && same(pendTC.to, newTC.to) && same(pendTC.exiting, newTC.exiting))
	            return 'SameAsPending';
	        if (newTC.exiting.length === 0 && newTC.entering.length === 0 && same(newTC.from, newTC.to))
	            return 'SameAsCurrent';
	    };
	    /**
	     * Runs the transition
	     *
	     * This method is generally called from the [[StateService.transitionTo]]
	     *
	     * @internal
	     *
	     * @returns a promise for a successful transition.
	     */
	    Transition.prototype.run = function () {
	        var _this = this;
	        var runAllHooks = transitionHook_1.TransitionHook.runAllHooks;
	        // Gets transition hooks array for the given phase
	        var getHooksFor = function (phase) { return _this._hookBuilder.buildHooksForPhase(phase); };
	        // When the chain is complete, then resolve or reject the deferred
	        var transitionSuccess = function () {
	            trace_1.trace.traceSuccess(_this.$to(), _this);
	            _this.success = true;
	            _this._deferred.resolve(_this.to());
	            runAllHooks(getHooksFor(interface_1.TransitionHookPhase.SUCCESS));
	        };
	        var transitionError = function (reason) {
	            trace_1.trace.traceError(reason, _this);
	            _this.success = false;
	            _this._deferred.reject(reason);
	            _this._error = reason;
	            runAllHooks(getHooksFor(interface_1.TransitionHookPhase.ERROR));
	        };
	        var runTransition = function () {
	            // Wait to build the RUN hook chain until the BEFORE hooks are done
	            // This allows a BEFORE hook to dynamically add additional RUN hooks via the Transition object.
	            var allRunHooks = getHooksFor(interface_1.TransitionHookPhase.RUN);
	            var done = function () { return coreservices_1.services.$q.when(undefined); };
	            return transitionHook_1.TransitionHook.invokeHooks(allRunHooks, done);
	        };
	        var startTransition = function () {
	            var globals = _this.router.globals;
	            globals.lastStartedTransitionId = _this.$id;
	            globals.transition = _this;
	            globals.transitionHistory.enqueue(_this);
	            trace_1.trace.traceTransitionStart(_this);
	            return coreservices_1.services.$q.when(undefined);
	        };
	        var allBeforeHooks = getHooksFor(interface_1.TransitionHookPhase.BEFORE);
	        transitionHook_1.TransitionHook.invokeHooks(allBeforeHooks, startTransition)
	            .then(runTransition)
	            .then(transitionSuccess, transitionError);
	        return this.promise;
	    };
	    /**
	     * Checks if the Transition is valid
	     *
	     * @returns true if the Transition is valid
	     */
	    Transition.prototype.valid = function () {
	        return !this.error() || this.success !== undefined;
	    };
	    /**
	     * Aborts this transition
	     *
	     * Imperative API to abort a Transition.
	     * This only applies to Transitions that are not yet complete.
	     */
	    Transition.prototype.abort = function () {
	        // Do not set flag if the transition is already complete
	        if (predicates_1.isUndefined(this.success)) {
	            this._aborted = true;
	        }
	    };
	    /**
	     * The Transition error reason.
	     *
	     * If the transition is invalid (and could not be run), returns the reason the transition is invalid.
	     * If the transition was valid and ran, but was not successful, returns the reason the transition failed.
	     *
	     * @returns a transition rejection explaining why the transition is invalid, or the reason the transition failed.
	     */
	    Transition.prototype.error = function () {
	        var state = this.$to();
	        if (state.self.abstract) {
	            return rejectFactory_1.Rejection.invalid("Cannot transition to abstract state '" + state.name + "'");
	        }
	        var paramDefs = state.parameters();
	        var values = this.params();
	        var invalidParams = paramDefs.filter(function (param) { return !param.validates(values[param.id]); });
	        if (invalidParams.length) {
	            var invalidValues = invalidParams.map(function (param) { return "[" + param.id + ":" + strings_1.stringify(values[param.id]) + "]"; }).join(', ');
	            var detail = "The following parameter values are not valid for state '" + state.name + "': " + invalidValues;
	            return rejectFactory_1.Rejection.invalid(detail);
	        }
	        if (this.success === false)
	            return this._error;
	    };
	    /**
	     * A string representation of the Transition
	     *
	     * @returns A string representation of the Transition
	     */
	    Transition.prototype.toString = function () {
	        var fromStateOrName = this.from();
	        var toStateOrName = this.to();
	        var avoidEmptyHash = function (params) {
	            return params['#'] !== null && params['#'] !== undefined ? params : common_1.omit(params, ['#']);
	        };
	        // (X) means the to state is invalid.
	        var id = this.$id, from = predicates_1.isObject(fromStateOrName) ? fromStateOrName.name : fromStateOrName, fromParams = strings_1.stringify(avoidEmptyHash(this._treeChanges.from.map(hof_1.prop('paramValues')).reduce(common_1.mergeR, {}))), toValid = this.valid() ? '' : '(X) ', to = predicates_1.isObject(toStateOrName) ? toStateOrName.name : toStateOrName, toParams = strings_1.stringify(avoidEmptyHash(this.params()));
	        return "Transition#" + id + "( '" + from + "'" + fromParams + " -> " + toValid + "'" + to + "'" + toParams + " )";
	    };
	    /** @internal */
	    Transition.diToken = Transition;
	    return Transition;
	}());
	exports.Transition = Transition;
	//# sourceMappingURL=transition.js.map

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.TransitionService = exports.defaultTransOpts = void 0;
	var interface_1 = __webpack_require__(11);
	var transition_1 = __webpack_require__(40);
	var hookRegistry_1 = __webpack_require__(39);
	var coreResolvables_1 = __webpack_require__(96);
	var redirectTo_1 = __webpack_require__(100);
	var onEnterExitRetain_1 = __webpack_require__(99);
	var resolve_1 = __webpack_require__(101);
	var views_1 = __webpack_require__(104);
	var updateGlobals_1 = __webpack_require__(102);
	var url_1 = __webpack_require__(103);
	var lazyLoad_1 = __webpack_require__(50);
	var transitionEventType_1 = __webpack_require__(61);
	var transitionHook_1 = __webpack_require__(16);
	var predicates_1 = __webpack_require__(2);
	var common_1 = __webpack_require__(1);
	var hof_1 = __webpack_require__(3);
	var ignoredTransition_1 = __webpack_require__(97);
	var invalidTransition_1 = __webpack_require__(98);
	/**
	 * The default [[Transition]] options.
	 *
	 * Include this object when applying custom defaults:
	 * let reloadOpts = { reload: true, notify: true }
	 * let options = defaults(theirOpts, customDefaults, defaultOptions);
	 */
	exports.defaultTransOpts = {
	    location: true,
	    relative: null,
	    inherit: false,
	    notify: true,
	    reload: false,
	    supercede: true,
	    custom: {},
	    current: function () { return null; },
	    source: 'unknown',
	};
	/**
	 * This class provides services related to Transitions.
	 *
	 * - Most importantly, it allows global Transition Hooks to be registered.
	 * - It allows the default transition error handler to be set.
	 * - It also has a factory function for creating new [[Transition]] objects, (used internally by the [[StateService]]).
	 *
	 * At bootstrap, [[UIRouter]] creates a single instance (singleton) of this class.
	 *
	 * This API is located at `router.transitionService` ([[UIRouter.transitionService]])
	 */
	var TransitionService = /** @class */ (function () {
	    /** @internal */
	    function TransitionService(_router) {
	        /** @internal */
	        this._transitionCount = 0;
	        /** The transition hook types, such as `onEnter`, `onStart`, etc */
	        this._eventTypes = [];
	        /** @internal The registered transition hooks */
	        this._registeredHooks = {};
	        /** The  paths on a criteria object */
	        this._criteriaPaths = {};
	        this._router = _router;
	        this.$view = _router.viewService;
	        this._deregisterHookFns = {};
	        this._pluginapi = (common_1.createProxyFunctions(hof_1.val(this), {}, hof_1.val(this), [
	            '_definePathType',
	            '_defineEvent',
	            '_getPathTypes',
	            '_getEvents',
	            'getHooks',
	        ]));
	        this._defineCorePaths();
	        this._defineCoreEvents();
	        this._registerCoreTransitionHooks();
	        _router.globals.successfulTransitions.onEvict(coreResolvables_1.treeChangesCleanup);
	    }
	    /**
	     * Registers a [[TransitionHookFn]], called *while a transition is being constructed*.
	     *
	     * Registers a transition lifecycle hook, which is invoked during transition construction.
	     *
	     * This low level hook should only be used by plugins.
	     * This can be a useful time for plugins to add resolves or mutate the transition as needed.
	     * The Sticky States plugin uses this hook to modify the treechanges.
	     *
	     * ### Lifecycle
	     *
	     * `onCreate` hooks are invoked *while a transition is being constructed*.
	     *
	     * ### Return value
	     *
	     * The hook's return value is ignored
	     *
	     * @internal
	     * @param criteria defines which Transitions the Hook should be invoked for.
	     * @param callback the hook function which will be invoked.
	     * @param options the registration options
	     * @returns a function which deregisters the hook.
	     */
	    TransitionService.prototype.onCreate = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    TransitionService.prototype.onBefore = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    TransitionService.prototype.onStart = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    TransitionService.prototype.onExit = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    TransitionService.prototype.onRetain = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    TransitionService.prototype.onEnter = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    TransitionService.prototype.onFinish = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    TransitionService.prototype.onSuccess = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    TransitionService.prototype.onError = function (criteria, callback, options) {
	        return;
	    };
	    /**
	     * dispose
	     * @internal
	     */
	    TransitionService.prototype.dispose = function (router) {
	        common_1.values(this._registeredHooks).forEach(function (hooksArray) {
	            return hooksArray.forEach(function (hook) {
	                hook._deregistered = true;
	                common_1.removeFrom(hooksArray, hook);
	            });
	        });
	    };
	    /**
	     * Creates a new [[Transition]] object
	     *
	     * This is a factory function for creating new Transition objects.
	     * It is used internally by the [[StateService]] and should generally not be called by application code.
	     *
	     * @internal
	     * @param fromPath the path to the current state (the from state)
	     * @param targetState the target state (destination)
	     * @returns a Transition
	     */
	    TransitionService.prototype.create = function (fromPath, targetState) {
	        return new transition_1.Transition(fromPath, targetState, this._router);
	    };
	    /** @internal */
	    TransitionService.prototype._defineCoreEvents = function () {
	        var Phase = interface_1.TransitionHookPhase;
	        var TH = transitionHook_1.TransitionHook;
	        var paths = this._criteriaPaths;
	        var NORMAL_SORT = false, REVERSE_SORT = true;
	        var SYNCHRONOUS = true;
	        this._defineEvent('onCreate', Phase.CREATE, 0, paths.to, NORMAL_SORT, TH.LOG_REJECTED_RESULT, TH.THROW_ERROR, SYNCHRONOUS);
	        this._defineEvent('onBefore', Phase.BEFORE, 0, paths.to);
	        this._defineEvent('onStart', Phase.RUN, 0, paths.to);
	        this._defineEvent('onExit', Phase.RUN, 100, paths.exiting, REVERSE_SORT);
	        this._defineEvent('onRetain', Phase.RUN, 200, paths.retained);
	        this._defineEvent('onEnter', Phase.RUN, 300, paths.entering);
	        this._defineEvent('onFinish', Phase.RUN, 400, paths.to);
	        this._defineEvent('onSuccess', Phase.SUCCESS, 0, paths.to, NORMAL_SORT, TH.LOG_REJECTED_RESULT, TH.LOG_ERROR, SYNCHRONOUS);
	        this._defineEvent('onError', Phase.ERROR, 0, paths.to, NORMAL_SORT, TH.LOG_REJECTED_RESULT, TH.LOG_ERROR, SYNCHRONOUS);
	    };
	    /** @internal */
	    TransitionService.prototype._defineCorePaths = function () {
	        var STATE = interface_1.TransitionHookScope.STATE, TRANSITION = interface_1.TransitionHookScope.TRANSITION;
	        this._definePathType('to', TRANSITION);
	        this._definePathType('from', TRANSITION);
	        this._definePathType('exiting', STATE);
	        this._definePathType('retained', STATE);
	        this._definePathType('entering', STATE);
	    };
	    /** @internal */
	    TransitionService.prototype._defineEvent = function (name, hookPhase, hookOrder, criteriaMatchPath, reverseSort, getResultHandler, getErrorHandler, synchronous) {
	        if (reverseSort === void 0) { reverseSort = false; }
	        if (getResultHandler === void 0) { getResultHandler = transitionHook_1.TransitionHook.HANDLE_RESULT; }
	        if (getErrorHandler === void 0) { getErrorHandler = transitionHook_1.TransitionHook.REJECT_ERROR; }
	        if (synchronous === void 0) { synchronous = false; }
	        var eventType = new transitionEventType_1.TransitionEventType(name, hookPhase, hookOrder, criteriaMatchPath, reverseSort, getResultHandler, getErrorHandler, synchronous);
	        this._eventTypes.push(eventType);
	        hookRegistry_1.makeEvent(this, this, eventType);
	    };
	    /** @internal */
	    TransitionService.prototype._getEvents = function (phase) {
	        var transitionHookTypes = predicates_1.isDefined(phase)
	            ? this._eventTypes.filter(function (type) { return type.hookPhase === phase; })
	            : this._eventTypes.slice();
	        return transitionHookTypes.sort(function (l, r) {
	            var cmpByPhase = l.hookPhase - r.hookPhase;
	            return cmpByPhase === 0 ? l.hookOrder - r.hookOrder : cmpByPhase;
	        });
	    };
	    /**
	     * Adds a Path to be used as a criterion against a TreeChanges path
	     *
	     * For example: the `exiting` path in [[HookMatchCriteria]] is a STATE scoped path.
	     * It was defined by calling `defineTreeChangesCriterion('exiting', TransitionHookScope.STATE)`
	     * Each state in the exiting path is checked against the criteria and returned as part of the match.
	     *
	     * Another example: the `to` path in [[HookMatchCriteria]] is a TRANSITION scoped path.
	     * It was defined by calling `defineTreeChangesCriterion('to', TransitionHookScope.TRANSITION)`
	     * Only the tail of the `to` path is checked against the criteria and returned as part of the match.
	     *
	     * @internal
	     */
	    TransitionService.prototype._definePathType = function (name, hookScope) {
	        this._criteriaPaths[name] = { name: name, scope: hookScope };
	    };
	    /** @internal */
	    // tslint:disable-next-line
	    TransitionService.prototype._getPathTypes = function () {
	        return this._criteriaPaths;
	    };
	    /** @internal */
	    TransitionService.prototype.getHooks = function (hookName) {
	        return this._registeredHooks[hookName];
	    };
	    /** @internal */
	    TransitionService.prototype._registerCoreTransitionHooks = function () {
	        var fns = this._deregisterHookFns;
	        fns.addCoreResolves = coreResolvables_1.registerAddCoreResolvables(this);
	        fns.ignored = ignoredTransition_1.registerIgnoredTransitionHook(this);
	        fns.invalid = invalidTransition_1.registerInvalidTransitionHook(this);
	        // Wire up redirectTo hook
	        fns.redirectTo = redirectTo_1.registerRedirectToHook(this);
	        // Wire up onExit/Retain/Enter state hooks
	        fns.onExit = onEnterExitRetain_1.registerOnExitHook(this);
	        fns.onRetain = onEnterExitRetain_1.registerOnRetainHook(this);
	        fns.onEnter = onEnterExitRetain_1.registerOnEnterHook(this);
	        // Wire up Resolve hooks
	        fns.eagerResolve = resolve_1.registerEagerResolvePath(this);
	        fns.lazyResolve = resolve_1.registerLazyResolveState(this);
	        fns.resolveAll = resolve_1.registerResolveRemaining(this);
	        // Wire up the View management hooks
	        fns.loadViews = views_1.registerLoadEnteringViews(this);
	        fns.activateViews = views_1.registerActivateViews(this);
	        // Updates global state after a transition
	        fns.updateGlobals = updateGlobals_1.registerUpdateGlobalState(this);
	        // After globals.current is updated at priority: 10000
	        fns.updateUrl = url_1.registerUpdateUrl(this);
	        // Lazy load state trees
	        fns.lazyLoad = lazyLoad_1.registerLazyLoadHook(this);
	    };
	    return TransitionService;
	}());
	exports.TransitionService = TransitionService;
	//# sourceMappingURL=transitionService.js.map

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.BaseUrlRule = exports.UrlRuleFactory = void 0;
	var urlMatcher_1 = __webpack_require__(23);
	var predicates_1 = __webpack_require__(2);
	var common_1 = __webpack_require__(1);
	var hof_1 = __webpack_require__(3);
	var stateObject_1 = __webpack_require__(38);
	/**
	 * Creates a [[UrlRule]]
	 *
	 * Creates a [[UrlRule]] from a:
	 *
	 * - `string`
	 * - [[UrlMatcher]]
	 * - `RegExp`
	 * - [[StateObject]]
	 */
	var UrlRuleFactory = /** @class */ (function () {
	    function UrlRuleFactory(router) {
	        this.router = router;
	    }
	    UrlRuleFactory.prototype.compile = function (str) {
	        return this.router.urlMatcherFactory.compile(str);
	    };
	    UrlRuleFactory.prototype.create = function (what, handler) {
	        var _this = this;
	        var isState = stateObject_1.StateObject.isState, isStateDeclaration = stateObject_1.StateObject.isStateDeclaration;
	        var makeRule = hof_1.pattern([
	            [predicates_1.isString, function (_what) { return makeRule(_this.compile(_what)); }],
	            [hof_1.is(urlMatcher_1.UrlMatcher), function (_what) { return _this.fromUrlMatcher(_what, handler); }],
	            [hof_1.or(isState, isStateDeclaration), function (_what) { return _this.fromState(_what, _this.router); }],
	            [hof_1.is(RegExp), function (_what) { return _this.fromRegExp(_what, handler); }],
	            [predicates_1.isFunction, function (_what) { return new BaseUrlRule(_what, handler); }],
	        ]);
	        var rule = makeRule(what);
	        if (!rule)
	            throw new Error("invalid 'what' in when()");
	        return rule;
	    };
	    /**
	     * A UrlRule which matches based on a UrlMatcher
	     *
	     * The `handler` may be either a `string`, a [[UrlRuleHandlerFn]] or another [[UrlMatcher]]
	     *
	     * ## Handler as a function
	     *
	     * If `handler` is a function, the function is invoked with:
	     *
	     * - matched parameter values ([[RawParams]] from [[UrlMatcher.exec]])
	     * - url: the current Url ([[UrlParts]])
	     * - router: the router object ([[UIRouter]])
	     *
	     * #### Example:
	     * ```js
	     * var urlMatcher = $umf.compile("/foo/:fooId/:barId");
	     * var rule = factory.fromUrlMatcher(urlMatcher, match => "/home/" + match.fooId + "/" + match.barId);
	     * var match = rule.match('/foo/123/456'); // results in { fooId: '123', barId: '456' }
	     * var result = rule.handler(match); // '/home/123/456'
	     * ```
	     *
	     * ## Handler as UrlMatcher
	     *
	     * If `handler` is a UrlMatcher, the handler matcher is used to create the new url.
	     * The `handler` UrlMatcher is formatted using the matched param from the first matcher.
	     * The url is replaced with the result.
	     *
	     * #### Example:
	     * ```js
	     * var urlMatcher = $umf.compile("/foo/:fooId/:barId");
	     * var handler = $umf.compile("/home/:fooId/:barId");
	     * var rule = factory.fromUrlMatcher(urlMatcher, handler);
	     * var match = rule.match('/foo/123/456'); // results in { fooId: '123', barId: '456' }
	     * var result = rule.handler(match); // '/home/123/456'
	     * ```
	     */
	    UrlRuleFactory.prototype.fromUrlMatcher = function (urlMatcher, handler) {
	        var _handler = handler;
	        if (predicates_1.isString(handler))
	            handler = this.router.urlMatcherFactory.compile(handler);
	        if (hof_1.is(urlMatcher_1.UrlMatcher)(handler))
	            _handler = function (match) { return handler.format(match); };
	        function matchUrlParamters(url) {
	            var params = urlMatcher.exec(url.path, url.search, url.hash);
	            return urlMatcher.validates(params) && params;
	        }
	        // Prioritize URLs, lowest to highest:
	        // - Some optional URL parameters, but none matched
	        // - No optional parameters in URL
	        // - Some optional parameters, some matched
	        // - Some optional parameters, all matched
	        function matchPriority(params) {
	            var optional = urlMatcher.parameters().filter(function (param) { return param.isOptional; });
	            if (!optional.length)
	                return 0.000001;
	            var matched = optional.filter(function (param) { return params[param.id]; });
	            return matched.length / optional.length;
	        }
	        var details = { urlMatcher: urlMatcher, matchPriority: matchPriority, type: 'URLMATCHER' };
	        return common_1.extend(new BaseUrlRule(matchUrlParamters, _handler), details);
	    };
	    /**
	     * A UrlRule which matches a state by its url
	     *
	     * #### Example:
	     * ```js
	     * var rule = factory.fromState($state.get('foo'), router);
	     * var match = rule.match('/foo/123/456'); // results in { fooId: '123', barId: '456' }
	     * var result = rule.handler(match);
	     * // Starts a transition to 'foo' with params: { fooId: '123', barId: '456' }
	     * ```
	     */
	    UrlRuleFactory.prototype.fromState = function (stateOrDecl, router) {
	        var state = stateObject_1.StateObject.isStateDeclaration(stateOrDecl) ? stateOrDecl.$$state() : stateOrDecl;
	        /**
	         * Handles match by transitioning to matched state
	         *
	         * First checks if the router should start a new transition.
	         * A new transition is not required if the current state's URL
	         * and the new URL are already identical
	         */
	        var handler = function (match) {
	            var $state = router.stateService;
	            var globals = router.globals;
	            if ($state.href(state, match) !== $state.href(globals.current, globals.params)) {
	                $state.transitionTo(state, match, { inherit: true, source: 'url' });
	            }
	        };
	        var details = { state: state, type: 'STATE' };
	        return common_1.extend(this.fromUrlMatcher(state.url, handler), details);
	    };
	    /**
	     * A UrlRule which matches based on a regular expression
	     *
	     * The `handler` may be either a [[UrlRuleHandlerFn]] or a string.
	     *
	     * ## Handler as a function
	     *
	     * If `handler` is a function, the function is invoked with:
	     *
	     * - regexp match array (from `regexp`)
	     * - url: the current Url ([[UrlParts]])
	     * - router: the router object ([[UIRouter]])
	     *
	     * #### Example:
	     * ```js
	     * var rule = factory.fromRegExp(/^\/foo\/(bar|baz)$/, match => "/home/" + match[1])
	     * var match = rule.match('/foo/bar'); // results in [ '/foo/bar', 'bar' ]
	     * var result = rule.handler(match); // '/home/bar'
	     * ```
	     *
	     * ## Handler as string
	     *
	     * If `handler` is a string, the url is *replaced by the string* when the Rule is invoked.
	     * The string is first interpolated using `string.replace()` style pattern.
	     *
	     * #### Example:
	     * ```js
	     * var rule = factory.fromRegExp(/^\/foo\/(bar|baz)$/, "/home/$1")
	     * var match = rule.match('/foo/bar'); // results in [ '/foo/bar', 'bar' ]
	     * var result = rule.handler(match); // '/home/bar'
	     * ```
	     */
	    UrlRuleFactory.prototype.fromRegExp = function (regexp, handler) {
	        if (regexp.global || regexp.sticky)
	            throw new Error('Rule RegExp must not be global or sticky');
	        /**
	         * If handler is a string, the url will be replaced by the string.
	         * If the string has any String.replace() style variables in it (like `$2`),
	         * they will be replaced by the captures from [[match]]
	         */
	        var redirectUrlTo = function (match) {
	            // Interpolates matched values into $1 $2, etc using a String.replace()-style pattern
	            return handler.replace(/\$(\$|\d{1,2})/, function (m, what) { return match[what === '$' ? 0 : Number(what)]; });
	        };
	        var _handler = predicates_1.isString(handler) ? redirectUrlTo : handler;
	        var matchParamsFromRegexp = function (url) { return regexp.exec(url.path); };
	        var details = { regexp: regexp, type: 'REGEXP' };
	        return common_1.extend(new BaseUrlRule(matchParamsFromRegexp, _handler), details);
	    };
	    UrlRuleFactory.isUrlRule = function (obj) { return obj && ['type', 'match', 'handler'].every(function (key) { return predicates_1.isDefined(obj[key]); }); };
	    return UrlRuleFactory;
	}());
	exports.UrlRuleFactory = UrlRuleFactory;
	/**
	 * A base rule which calls `match`
	 *
	 * The value from the `match` function is passed through to the `handler`.
	 * @internal
	 */
	var BaseUrlRule = /** @class */ (function () {
	    function BaseUrlRule(match, handler) {
	        var _this = this;
	        this.match = match;
	        this.type = 'RAW';
	        this.matchPriority = function (match) { return 0 - _this.$id; };
	        this.handler = handler || common_1.identity;
	    }
	    return BaseUrlRule;
	}());
	exports.BaseUrlRule = BaseUrlRule;
	//# sourceMappingURL=urlRule.js.map

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.locationPluginFactory = exports.buildUrl = exports.parseUrl = exports.getParams = exports.keyValsToObjectR = void 0;
	var common_1 = __webpack_require__(4);
	exports.keyValsToObjectR = function (accum, _a) {
	    var key = _a[0], val = _a[1];
	    if (!accum.hasOwnProperty(key)) {
	        accum[key] = val;
	    }
	    else if (common_1.isArray(accum[key])) {
	        accum[key].push(val);
	    }
	    else {
	        accum[key] = [accum[key], val];
	    }
	    return accum;
	};
	exports.getParams = function (queryString) {
	    return queryString.split('&').filter(common_1.identity).map(common_1.splitEqual).reduce(exports.keyValsToObjectR, {});
	};
	function parseUrl(url) {
	    var orEmptyString = function (x) { return x || ''; };
	    var _a = common_1.splitHash(url).map(orEmptyString), beforehash = _a[0], hash = _a[1];
	    var _b = common_1.splitQuery(beforehash).map(orEmptyString), path = _b[0], search = _b[1];
	    return { path: path, search: search, hash: hash, url: url };
	}
	exports.parseUrl = parseUrl;
	exports.buildUrl = function (loc) {
	    var path = loc.path();
	    var searchObject = loc.search();
	    var hash = loc.hash();
	    var search = Object.keys(searchObject)
	        .map(function (key) {
	        var param = searchObject[key];
	        var vals = common_1.isArray(param) ? param : [param];
	        return vals.map(function (val) { return key + '=' + val; });
	    })
	        .reduce(common_1.unnestR, [])
	        .join('&');
	    return path + (search ? '?' + search : '') + (hash ? '#' + hash : '');
	};
	function locationPluginFactory(name, isHtml5, serviceClass, configurationClass) {
	    return function (uiRouter) {
	        var service = (uiRouter.locationService = new serviceClass(uiRouter));
	        var configuration = (uiRouter.locationConfig = new configurationClass(uiRouter, isHtml5));
	        function dispose(router) {
	            router.dispose(service);
	            router.dispose(configuration);
	        }
	        return { name: name, service: service, configuration: configuration, dispose: dispose };
	    };
	}
	exports.locationPluginFactory = locationPluginFactory;
	//# sourceMappingURL=utils.js.map

/***/ }),
/* 44 */
/***/ (function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function getLens (b64) {
	  var len = b64.length
	
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // Trim off extra bytes after placeholder bytes are found
	  // See: https://github.com/beatgammit/base64-js/issues/42
	  var validLen = b64.indexOf('=')
	  if (validLen === -1) validLen = len
	
	  var placeHoldersLen = validLen === len
	    ? 0
	    : 4 - (validLen % 4)
	
	  return [validLen, placeHoldersLen]
	}
	
	// base64 is 4/3 + up to two characters of the original data
	function byteLength (b64) {
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function _byteLength (b64, validLen, placeHoldersLen) {
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function toByteArray (b64) {
	  var tmp
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	
	  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))
	
	  var curByte = 0
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  var len = placeHoldersLen > 0
	    ? validLen - 4
	    : validLen
	
	  var i
	  for (i = 0; i < len; i += 4) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 18) |
	      (revLookup[b64.charCodeAt(i + 1)] << 12) |
	      (revLookup[b64.charCodeAt(i + 2)] << 6) |
	      revLookup[b64.charCodeAt(i + 3)]
	    arr[curByte++] = (tmp >> 16) & 0xFF
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 2) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 2) |
	      (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 1) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 10) |
	      (revLookup[b64.charCodeAt(i + 1)] << 4) |
	      (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] +
	    lookup[num >> 12 & 0x3F] +
	    lookup[num >> 6 & 0x3F] +
	    lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp =
	      ((uint8[i] << 16) & 0xFF0000) +
	      ((uint8[i + 1] << 8) & 0xFF00) +
	      (uint8[i + 2] & 0xFF)
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 2] +
	      lookup[(tmp << 4) & 0x3F] +
	      '=='
	    )
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 10] +
	      lookup[(tmp >> 4) & 0x3F] +
	      lookup[(tmp << 2) & 0x3F] +
	      '='
	    )
	  }
	
	  return parts.join('')
	}


/***/ }),
/* 45 */
/***/ (function(module, exports) {

	/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = ((value * c) - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ }),
/* 46 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ArchivoModalController = function () {
	  ArchivoModalController.$inject = ["$uibModalInstance", "data", "title", "icon", "DataService", "Message", "labelOk", "apiUrl"];
	  function ArchivoModalController($uibModalInstance, data, title, icon, DataService, Message, labelOk, apiUrl) {
	    'ngInject';
	
	    _classCallCheck(this, ArchivoModalController);
	
	    this.$uibModalInstance = $uibModalInstance;
	    this.data = data;
	    this.title = title;
	    this.icon = icon;
	    this.DataService = DataService;
	    this.Message = Message;
	    this.labelOk = labelOk;
	    this.apiUrl = apiUrl;
	  }
	
	  _createClass(ArchivoModalController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.descargas = {
	        manual: {
	          ruta: this.apiUrl + 'items/csv/manuales?archivo=manual_ods',
	          nombre: 'Manual ods'
	        },
	        modelo: {
	          ruta: this.apiUrl + 'items/csv/manuales?archivo=items&tipo=ods',
	          nombre: 'Modelo items'
	        }
	      };
	    }
	  }, {
	    key: 'registrar',
	    value: function registrar() {
	      this.$uibModalInstance.close(this.archivo);
	    }
	  }, {
	    key: 'cerrar',
	    value: function cerrar() {
	      this.$uibModalInstance.dismiss('cancel');
	    }
	  }]);
	
	  return ArchivoModalController;
	}();
	
	exports.default = ArchivoModalController;

/***/ }),
/* 47 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\"><i class=\"fa {{$ctrl.icon}}\"></i> {{$ctrl.title}}</h5>\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cerrar()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<div class=\"modal-body\">\n  <div class=\"alert alert-info\" ng-if=\"$ctrl.data.mensajeInformacion\">\n    <i class=\"fa fa-info-circle\"></i>\n    <span ng-bind-html=\"$ctrl.data.mensajeInformacion\"></span>\n  </div>\n  <div ng-if=\"$ctrl.data.cargarItems\">\n\n    <button md-effect type=\"button\" class=\"btn btn-success btn-sm mr-1\" uib-tooltip=\"Descargar archivo modelo .ods de items\"\n    download-file=\"{{$ctrl.descargas.modelo.ruta}}\" file-name=\"{{$ctrl.descargas.modelo.nombre}}\" download-type=\"ods\">\n    <i class=\"fa fa-download\"></i> Modelo ODS</button>\n\n    <button md-effect type=\"button\" class=\"btn btn-success btn-sm\" uib-tooltip=\"Descargar manual para crear un archivo .ods de items\"\n    download-file=\"{{$ctrl.descargas.manual.ruta}}\" file-name=\"{{$ctrl.descargas.manual.nombre}}\">\n    <i class=\"fa fa-download\"></i> Manual ODS</button>\n  </div>\n\n  <ng-form name=\"formItem\">\n    <div class=\"row\">\n\n      <div class=\"md-input-group col-md-12\">\n        <ui-input-file name=\"doc_resmin_cife\"\n          file-base64=\"$ctrl.archivo\"\n          types=\"{{$ctrl.data.formatos}}\"\n          mime-types=\"{{$ctrl.data.tipos}}\"\n          maxfiles=\"1\" maxsize=\"20MB\"\n          ng-required=\"true\">\n        </ui-input-file>\n      </div>\n\n    </div>\n  </ng-form>\n</div>\n<div class=\"modal-footer\">\n  <button type=\"button\" md-effect class=\"btn btn-secondary\" ng-click=\"$ctrl.cerrar()\">\n    <i class=\"fa fa-close\"></i> Cancelar\n  </button>\n  <button type=\"button\" md-effect class=\"btn btn-primary\" validar-formulario=\"formItem\"\n    ng-click=\"$ctrl.registrar()\">\n    <i class=\"fa fa-upload\"></i> {{$ctrl.labelOk}}\n  </button>\n</div>\n"

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.safeConsole = void 0;
	/**
	 * workaround for missing console object in IE9 when dev tools haven't been opened o_O
	 * @packageDocumentation
	 */
	/* tslint:disable:no-console */
	var common_1 = __webpack_require__(1);
	var noopConsoleStub = { log: common_1.noop, error: common_1.noop, table: common_1.noop };
	function ie9Console(console) {
	    var bound = function (fn) { return Function.prototype.bind.call(fn, console); };
	    return {
	        log: bound(console.log),
	        error: bound(console.log),
	        table: bound(console.log),
	    };
	}
	function fallbackConsole(console) {
	    var log = console.log.bind(console);
	    var error = console.error ? console.error.bind(console) : log;
	    var table = console.table ? console.table.bind(console) : log;
	    return { log: log, error: error, table: table };
	}
	function getSafeConsole() {
	    // @ts-ignore
	    var isIE9 = typeof document !== 'undefined' && document.documentMode && document.documentMode === 9;
	    if (isIE9) {
	        return window && window.console ? ie9Console(window.console) : noopConsoleStub;
	    }
	    else if (!console.table || !console.error) {
	        return fallbackConsole(console);
	    }
	    else {
	        return console;
	    }
	}
	exports.safeConsole = getSafeConsole();
	//# sourceMappingURL=safeConsole.js.map

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.UIRouterGlobals = void 0;
	var stateParams_1 = __webpack_require__(51);
	var queue_1 = __webpack_require__(33);
	/**
	 * Global router state
	 *
	 * This is where we hold the global mutable state such as current state, current
	 * params, current transition, etc.
	 */
	var UIRouterGlobals = /** @class */ (function () {
	    function UIRouterGlobals() {
	        /**
	         * Current parameter values
	         *
	         * The parameter values from the latest successful transition
	         */
	        this.params = new stateParams_1.StateParams();
	        /** @internal */
	        this.lastStartedTransitionId = -1;
	        /** @internal */
	        this.transitionHistory = new queue_1.Queue([], 1);
	        /** @internal */
	        this.successfulTransitions = new queue_1.Queue([], 1);
	    }
	    UIRouterGlobals.prototype.dispose = function () {
	        this.transitionHistory.clear();
	        this.successfulTransitions.clear();
	        this.transition = null;
	    };
	    return UIRouterGlobals;
	}());
	exports.UIRouterGlobals = UIRouterGlobals;
	//# sourceMappingURL=globals.js.map

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.lazyLoadState = exports.registerLazyLoadHook = void 0;
	var coreservices_1 = __webpack_require__(5);
	/**
	 * A [[TransitionHookFn]] that performs lazy loading
	 *
	 * When entering a state "abc" which has a `lazyLoad` function defined:
	 * - Invoke the `lazyLoad` function (unless it is already in process)
	 *   - Flag the hook function as "in process"
	 *   - The function should return a promise (that resolves when lazy loading is complete)
	 * - Wait for the promise to settle
	 *   - If the promise resolves to a [[LazyLoadResult]], then register those states
	 *   - Flag the hook function as "not in process"
	 * - If the hook was successful
	 *   - Remove the `lazyLoad` function from the state declaration
	 * - If all the hooks were successful
	 *   - Retry the transition (by returning a TargetState)
	 *
	 * ```
	 * .state('abc', {
	 *   component: 'fooComponent',
	 *   lazyLoad: () => import('./fooComponent')
	 *   });
	 * ```
	 *
	 * See [[StateDeclaration.lazyLoad]]
	 */
	var lazyLoadHook = function (transition) {
	    var router = transition.router;
	    function retryTransition() {
	        if (transition.originalTransition().options().source !== 'url') {
	            // The original transition was not triggered via url sync
	            // The lazy state should be loaded now, so re-try the original transition
	            var orig = transition.targetState();
	            return router.stateService.target(orig.identifier(), orig.params(), orig.options());
	        }
	        // The original transition was triggered via url sync
	        // Run the URL rules and find the best match
	        var $url = router.urlService;
	        var result = $url.match($url.parts());
	        var rule = result && result.rule;
	        // If the best match is a state, redirect the transition (instead
	        // of calling sync() which supersedes the current transition)
	        if (rule && rule.type === 'STATE') {
	            var state = rule.state;
	            var params = result.match;
	            return router.stateService.target(state, params, transition.options());
	        }
	        // No matching state found, so let .sync() choose the best non-state match/otherwise
	        router.urlService.sync();
	    }
	    var promises = transition
	        .entering()
	        .filter(function (state) { return !!state.$$state().lazyLoad; })
	        .map(function (state) { return lazyLoadState(transition, state); });
	    return coreservices_1.services.$q.all(promises).then(retryTransition);
	};
	exports.registerLazyLoadHook = function (transitionService) {
	    return transitionService.onBefore({ entering: function (state) { return !!state.lazyLoad; } }, lazyLoadHook);
	};
	/**
	 * Invokes a state's lazy load function
	 *
	 * @param transition a Transition context
	 * @param state the state to lazy load
	 * @returns A promise for the lazy load result
	 */
	function lazyLoadState(transition, state) {
	    var lazyLoadFn = state.$$state().lazyLoad;
	    // Store/get the lazy load promise on/from the hookfn so it doesn't get re-invoked
	    var promise = lazyLoadFn['_promise'];
	    if (!promise) {
	        var success = function (result) {
	            delete state.lazyLoad;
	            delete state.$$state().lazyLoad;
	            delete lazyLoadFn['_promise'];
	            return result;
	        };
	        var error = function (err) {
	            delete lazyLoadFn['_promise'];
	            return coreservices_1.services.$q.reject(err);
	        };
	        promise = lazyLoadFn['_promise'] = coreservices_1.services.$q
	            .when(lazyLoadFn(transition, state))
	            .then(updateStateRegistry)
	            .then(success, error);
	    }
	    /** Register any lazy loaded state definitions */
	    function updateStateRegistry(result) {
	        if (result && Array.isArray(result.states)) {
	            result.states.forEach(function (_state) { return transition.router.stateRegistry.register(_state); });
	        }
	        return result;
	    }
	    return promise;
	}
	exports.lazyLoadState = lazyLoadState;
	//# sourceMappingURL=lazyLoad.js.map

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.StateParams = void 0;
	var common_1 = __webpack_require__(1);
	var StateParams = /** @class */ (function () {
	    function StateParams(params) {
	        if (params === void 0) { params = {}; }
	        common_1.extend(this, params);
	    }
	    /**
	     * Merges a set of parameters with all parameters inherited between the common parents of the
	     * current state and a given destination state.
	     *
	     * @param {Object} newParams The set of parameters which will be composited with inherited params.
	     * @param {Object} $current Internal definition of object representing the current state.
	     * @param {Object} $to Internal definition of object representing state to transition to.
	     */
	    StateParams.prototype.$inherit = function (newParams, $current, $to) {
	        var parentParams;
	        var parents = common_1.ancestors($current, $to), inherited = {}, inheritList = [];
	        for (var i in parents) {
	            if (!parents[i] || !parents[i].params)
	                continue;
	            parentParams = Object.keys(parents[i].params);
	            if (!parentParams.length)
	                continue;
	            for (var j in parentParams) {
	                if (inheritList.indexOf(parentParams[j]) >= 0)
	                    continue;
	                inheritList.push(parentParams[j]);
	                inherited[parentParams[j]] = this[parentParams[j]];
	            }
	        }
	        return common_1.extend({}, inherited, newParams);
	    };
	    return StateParams;
	}());
	exports.StateParams = StateParams;
	//# sourceMappingURL=stateParams.js.map

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (this && this.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(__webpack_require__(53), exports);
	__exportStar(__webpack_require__(21), exports);
	__exportStar(__webpack_require__(22), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 53 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.resolvePolicies = void 0;
	exports.resolvePolicies = {
	    when: {
	        LAZY: 'LAZY',
	        EAGER: 'EAGER',
	    },
	    async: {
	        WAIT: 'WAIT',
	        NOWAIT: 'NOWAIT',
	    },
	};
	//# sourceMappingURL=interface.js.map

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.UIRouter = void 0;
	var urlMatcherFactory_1 = __webpack_require__(63);
	var urlRouter_1 = __webpack_require__(64);
	var transitionService_1 = __webpack_require__(41);
	var view_1 = __webpack_require__(74);
	var stateRegistry_1 = __webpack_require__(58);
	var stateService_1 = __webpack_require__(59);
	var globals_1 = __webpack_require__(49);
	var common_1 = __webpack_require__(1);
	var predicates_1 = __webpack_require__(2);
	var urlService_1 = __webpack_require__(66);
	var trace_1 = __webpack_require__(8);
	var common_2 = __webpack_require__(4);
	/** @internal */
	var _routerInstance = 0;
	/** @internal */
	var locSvcFns = ['url', 'path', 'search', 'hash', 'onChange'];
	/** @internal */
	var locCfgFns = ['port', 'protocol', 'host', 'baseHref', 'html5Mode', 'hashPrefix'];
	/** @internal */
	var locationServiceStub = common_2.makeStub('LocationServices', locSvcFns);
	/** @internal */
	var locationConfigStub = common_2.makeStub('LocationConfig', locCfgFns);
	/**
	 * An instance of UI-Router.
	 *
	 * This object contains references to service APIs which define your application's routing behavior.
	 */
	var UIRouter = /** @class */ (function () {
	    /**
	     * Creates a new `UIRouter` object
	     *
	     * @param locationService a [[LocationServices]] implementation
	     * @param locationConfig a [[LocationConfig]] implementation
	     * @internal
	     */
	    function UIRouter(locationService, locationConfig) {
	        if (locationService === void 0) { locationService = locationServiceStub; }
	        if (locationConfig === void 0) { locationConfig = locationConfigStub; }
	        this.locationService = locationService;
	        this.locationConfig = locationConfig;
	        /** @internal */ this.$id = _routerInstance++;
	        /** @internal */ this._disposed = false;
	        /** @internal */ this._disposables = [];
	        /** Enable/disable tracing to the javascript console */
	        this.trace = trace_1.trace;
	        /** Provides services related to ui-view synchronization */
	        this.viewService = new view_1.ViewService(this);
	        /** An object that contains global router state, such as the current state and params */
	        this.globals = new globals_1.UIRouterGlobals();
	        /** A service that exposes global Transition Hooks */
	        this.transitionService = new transitionService_1.TransitionService(this);
	        /**
	         * Deprecated for public use. Use [[urlService]] instead.
	         * @deprecated Use [[urlService]] instead
	         */
	        this.urlMatcherFactory = new urlMatcherFactory_1.UrlMatcherFactory(this);
	        /**
	         * Deprecated for public use. Use [[urlService]] instead.
	         * @deprecated Use [[urlService]] instead
	         */
	        this.urlRouter = new urlRouter_1.UrlRouter(this);
	        /** Provides services related to the URL */
	        this.urlService = new urlService_1.UrlService(this);
	        /** Provides a registry for states, and related registration services */
	        this.stateRegistry = new stateRegistry_1.StateRegistry(this);
	        /** Provides services related to states */
	        this.stateService = new stateService_1.StateService(this);
	        /** @internal plugin instances are registered here */
	        this._plugins = {};
	        this.viewService._pluginapi._rootViewContext(this.stateRegistry.root());
	        this.globals.$current = this.stateRegistry.root();
	        this.globals.current = this.globals.$current.self;
	        this.disposable(this.globals);
	        this.disposable(this.stateService);
	        this.disposable(this.stateRegistry);
	        this.disposable(this.transitionService);
	        this.disposable(this.urlService);
	        this.disposable(locationService);
	        this.disposable(locationConfig);
	    }
	    /** Registers an object to be notified when the router is disposed */
	    UIRouter.prototype.disposable = function (disposable) {
	        this._disposables.push(disposable);
	    };
	    /**
	     * Disposes this router instance
	     *
	     * When called, clears resources retained by the router by calling `dispose(this)` on all
	     * registered [[disposable]] objects.
	     *
	     * Or, if a `disposable` object is provided, calls `dispose(this)` on that object only.
	     *
	     * @internal
	     * @param disposable (optional) the disposable to dispose
	     */
	    UIRouter.prototype.dispose = function (disposable) {
	        var _this = this;
	        if (disposable && predicates_1.isFunction(disposable.dispose)) {
	            disposable.dispose(this);
	            return undefined;
	        }
	        this._disposed = true;
	        this._disposables.slice().forEach(function (d) {
	            try {
	                typeof d.dispose === 'function' && d.dispose(_this);
	                common_1.removeFrom(_this._disposables, d);
	            }
	            catch (ignored) { }
	        });
	    };
	    /**
	     * Adds a plugin to UI-Router
	     *
	     * This method adds a UI-Router Plugin.
	     * A plugin can enhance or change UI-Router behavior using any public API.
	     *
	     * #### Example:
	     * ```js
	     * import { MyCoolPlugin } from "ui-router-cool-plugin";
	     *
	     * var plugin = router.addPlugin(MyCoolPlugin);
	     * ```
	     *
	     * ### Plugin authoring
	     *
	     * A plugin is simply a class (or constructor function) which accepts a [[UIRouter]] instance and (optionally) an options object.
	     *
	     * The plugin can implement its functionality using any of the public APIs of [[UIRouter]].
	     * For example, it may configure router options or add a Transition Hook.
	     *
	     * The plugin can then be published as a separate module.
	     *
	     * #### Example:
	     * ```js
	     * export class MyAuthPlugin implements UIRouterPlugin {
	     *   constructor(router: UIRouter, options: any) {
	     *     this.name = "MyAuthPlugin";
	     *     let $transitions = router.transitionService;
	     *     let $state = router.stateService;
	     *
	     *     let authCriteria = {
	     *       to: (state) => state.data && state.data.requiresAuth
	     *     };
	     *
	     *     function authHook(transition: Transition) {
	     *       let authService = transition.injector().get('AuthService');
	     *       if (!authService.isAuthenticated()) {
	     *         return $state.target('login');
	     *       }
	     *     }
	     *
	     *     $transitions.onStart(authCriteria, authHook);
	     *   }
	     * }
	     * ```
	     *
	     * @param plugin one of:
	     *        - a plugin class which implements [[UIRouterPlugin]]
	     *        - a constructor function for a [[UIRouterPlugin]] which accepts a [[UIRouter]] instance
	     *        - a factory function which accepts a [[UIRouter]] instance and returns a [[UIRouterPlugin]] instance
	     * @param options options to pass to the plugin class/factory
	     * @returns the registered plugin instance
	     */
	    UIRouter.prototype.plugin = function (plugin, options) {
	        if (options === void 0) { options = {}; }
	        var pluginInstance = new plugin(this, options);
	        if (!pluginInstance.name)
	            throw new Error('Required property `name` missing on plugin: ' + pluginInstance);
	        this._disposables.push(pluginInstance);
	        return (this._plugins[pluginInstance.name] = pluginInstance);
	    };
	    UIRouter.prototype.getPlugin = function (pluginName) {
	        return pluginName ? this._plugins[pluginName] : common_1.values(this._plugins);
	    };
	    return UIRouter;
	}());
	exports.UIRouter = UIRouter;
	//# sourceMappingURL=router.js.map

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.StateBuilder = exports.resolvablesBuilder = void 0;
	var common_1 = __webpack_require__(1);
	var predicates_1 = __webpack_require__(2);
	var strings_1 = __webpack_require__(6);
	var hof_1 = __webpack_require__(3);
	var resolvable_1 = __webpack_require__(21);
	var coreservices_1 = __webpack_require__(5);
	var parseUrl = function (url) {
	    if (!predicates_1.isString(url))
	        return false;
	    var root = url.charAt(0) === '^';
	    return { val: root ? url.substring(1) : url, root: root };
	};
	function nameBuilder(state) {
	    return state.name;
	}
	function selfBuilder(state) {
	    state.self.$$state = function () { return state; };
	    return state.self;
	}
	function dataBuilder(state) {
	    if (state.parent && state.parent.data) {
	        state.data = state.self.data = common_1.inherit(state.parent.data, state.data);
	    }
	    return state.data;
	}
	var getUrlBuilder = function ($urlMatcherFactoryProvider, root) {
	    return function urlBuilder(stateObject) {
	        var stateDec = stateObject.self;
	        // For future states, i.e., states whose name ends with `.**`,
	        // match anything that starts with the url prefix
	        if (stateDec && stateDec.url && stateDec.name && stateDec.name.match(/\.\*\*$/)) {
	            var newStateDec = {};
	            common_1.copy(stateDec, newStateDec);
	            newStateDec.url += '{remainder:any}'; // match any path (.*)
	            stateDec = newStateDec;
	        }
	        var parent = stateObject.parent;
	        var parsed = parseUrl(stateDec.url);
	        var url = !parsed ? stateDec.url : $urlMatcherFactoryProvider.compile(parsed.val, { state: stateDec });
	        if (!url)
	            return null;
	        if (!$urlMatcherFactoryProvider.isMatcher(url))
	            throw new Error("Invalid url '" + url + "' in state '" + stateObject + "'");
	        return parsed && parsed.root ? url : ((parent && parent.navigable) || root()).url.append(url);
	    };
	};
	var getNavigableBuilder = function (isRoot) {
	    return function navigableBuilder(state) {
	        return !isRoot(state) && state.url ? state : state.parent ? state.parent.navigable : null;
	    };
	};
	var getParamsBuilder = function (paramFactory) {
	    return function paramsBuilder(state) {
	        var makeConfigParam = function (config, id) { return paramFactory.fromConfig(id, null, state.self); };
	        var urlParams = (state.url && state.url.parameters({ inherit: false })) || [];
	        var nonUrlParams = common_1.values(common_1.mapObj(common_1.omit(state.params || {}, urlParams.map(hof_1.prop('id'))), makeConfigParam));
	        return urlParams
	            .concat(nonUrlParams)
	            .map(function (p) { return [p.id, p]; })
	            .reduce(common_1.applyPairs, {});
	    };
	};
	function pathBuilder(state) {
	    return state.parent ? state.parent.path.concat(state) : /*root*/ [state];
	}
	function includesBuilder(state) {
	    var includes = state.parent ? common_1.extend({}, state.parent.includes) : {};
	    includes[state.name] = true;
	    return includes;
	}
	/**
	 * This is a [[StateBuilder.builder]] function for the `resolve:` block on a [[StateDeclaration]].
	 *
	 * When the [[StateBuilder]] builds a [[StateObject]] object from a raw [[StateDeclaration]], this builder
	 * validates the `resolve` property and converts it to a [[Resolvable]] array.
	 *
	 * resolve: input value can be:
	 *
	 * {
	 *   // analyzed but not injected
	 *   myFooResolve: function() { return "myFooData"; },
	 *
	 *   // function.toString() parsed, "DependencyName" dep as string (not min-safe)
	 *   myBarResolve: function(DependencyName) { return DependencyName.fetchSomethingAsPromise() },
	 *
	 *   // Array split; "DependencyName" dep as string
	 *   myBazResolve: [ "DependencyName", function(dep) { return dep.fetchSomethingAsPromise() },
	 *
	 *   // Array split; DependencyType dep as token (compared using ===)
	 *   myQuxResolve: [ DependencyType, function(dep) { return dep.fetchSometingAsPromise() },
	 *
	 *   // val.$inject used as deps
	 *   // where:
	 *   //     corgeResolve.$inject = ["DependencyName"];
	 *   //     function corgeResolve(dep) { dep.fetchSometingAsPromise() }
	 *   // then "DependencyName" dep as string
	 *   myCorgeResolve: corgeResolve,
	 *
	 *  // inject service by name
	 *  // When a string is found, desugar creating a resolve that injects the named service
	 *   myGraultResolve: "SomeService"
	 * }
	 *
	 * or:
	 *
	 * [
	 *   new Resolvable("myFooResolve", function() { return "myFooData" }),
	 *   new Resolvable("myBarResolve", function(dep) { return dep.fetchSomethingAsPromise() }, [ "DependencyName" ]),
	 *   { provide: "myBazResolve", useFactory: function(dep) { dep.fetchSomethingAsPromise() }, deps: [ "DependencyName" ] }
	 * ]
	 */
	function resolvablesBuilder(state) {
	    /** convert resolve: {} and resolvePolicy: {} objects to an array of tuples */
	    var objects2Tuples = function (resolveObj, resolvePolicies) {
	        return Object.keys(resolveObj || {}).map(function (token) { return ({
	            token: token,
	            val: resolveObj[token],
	            deps: undefined,
	            policy: resolvePolicies[token],
	        }); });
	    };
	    /** fetch DI annotations from a function or ng1-style array */
	    var annotate = function (fn) {
	        var $injector = coreservices_1.services.$injector;
	        // ng1 doesn't have an $injector until runtime.
	        // If the $injector doesn't exist, use "deferred" literal as a
	        // marker indicating they should be annotated when runtime starts
	        return fn['$inject'] || ($injector && $injector.annotate(fn, $injector.strictDi)) || 'deferred';
	    };
	    /** true if the object has both `token` and `resolveFn`, and is probably a [[ResolveLiteral]] */
	    var isResolveLiteral = function (obj) { return !!(obj.token && obj.resolveFn); };
	    /** true if the object looks like a provide literal, or a ng2 Provider */
	    var isLikeNg2Provider = function (obj) {
	        return !!((obj.provide || obj.token) && (obj.useValue || obj.useFactory || obj.useExisting || obj.useClass));
	    };
	    /** true if the object looks like a tuple from obj2Tuples */
	    var isTupleFromObj = function (obj) {
	        return !!(obj && obj.val && (predicates_1.isString(obj.val) || predicates_1.isArray(obj.val) || predicates_1.isFunction(obj.val)));
	    };
	    /** extracts the token from a Provider or provide literal */
	    var getToken = function (p) { return p.provide || p.token; };
	    // prettier-ignore: Given a literal resolve or provider object, returns a Resolvable
	    var literal2Resolvable = hof_1.pattern([
	        [hof_1.prop('resolveFn'), function (p) { return new resolvable_1.Resolvable(getToken(p), p.resolveFn, p.deps, p.policy); }],
	        [hof_1.prop('useFactory'), function (p) { return new resolvable_1.Resolvable(getToken(p), p.useFactory, p.deps || p.dependencies, p.policy); }],
	        [hof_1.prop('useClass'), function (p) { return new resolvable_1.Resolvable(getToken(p), function () { return new p.useClass(); }, [], p.policy); }],
	        [hof_1.prop('useValue'), function (p) { return new resolvable_1.Resolvable(getToken(p), function () { return p.useValue; }, [], p.policy, p.useValue); }],
	        [hof_1.prop('useExisting'), function (p) { return new resolvable_1.Resolvable(getToken(p), common_1.identity, [p.useExisting], p.policy); }],
	    ]);
	    // prettier-ignore
	    var tuple2Resolvable = hof_1.pattern([
	        [hof_1.pipe(hof_1.prop('val'), predicates_1.isString), function (tuple) { return new resolvable_1.Resolvable(tuple.token, common_1.identity, [tuple.val], tuple.policy); }],
	        [hof_1.pipe(hof_1.prop('val'), predicates_1.isArray), function (tuple) { return new resolvable_1.Resolvable(tuple.token, common_1.tail(tuple.val), tuple.val.slice(0, -1), tuple.policy); }],
	        [hof_1.pipe(hof_1.prop('val'), predicates_1.isFunction), function (tuple) { return new resolvable_1.Resolvable(tuple.token, tuple.val, annotate(tuple.val), tuple.policy); }],
	    ]);
	    // prettier-ignore
	    var item2Resolvable = hof_1.pattern([
	        [hof_1.is(resolvable_1.Resolvable), function (r) { return r; }],
	        [isResolveLiteral, literal2Resolvable],
	        [isLikeNg2Provider, literal2Resolvable],
	        [isTupleFromObj, tuple2Resolvable],
	        [hof_1.val(true), function (obj) { throw new Error('Invalid resolve value: ' + strings_1.stringify(obj)); },],
	    ]);
	    // If resolveBlock is already an array, use it as-is.
	    // Otherwise, assume it's an object and convert to an Array of tuples
	    var decl = state.resolve;
	    var items = predicates_1.isArray(decl) ? decl : objects2Tuples(decl, state.resolvePolicy || {});
	    return items.map(item2Resolvable);
	}
	exports.resolvablesBuilder = resolvablesBuilder;
	/**
	 * A internal global service
	 *
	 * StateBuilder is a factory for the internal [[StateObject]] objects.
	 *
	 * When you register a state with the [[StateRegistry]], you register a plain old javascript object which
	 * conforms to the [[StateDeclaration]] interface.  This factory takes that object and builds the corresponding
	 * [[StateObject]] object, which has an API and is used internally.
	 *
	 * Custom properties or API may be added to the internal [[StateObject]] object by registering a decorator function
	 * using the [[builder]] method.
	 */
	var StateBuilder = /** @class */ (function () {
	    function StateBuilder(matcher, urlMatcherFactory) {
	        this.matcher = matcher;
	        var self = this;
	        var root = function () { return matcher.find(''); };
	        var isRoot = function (state) { return state.name === ''; };
	        function parentBuilder(state) {
	            if (isRoot(state))
	                return null;
	            return matcher.find(self.parentName(state)) || root();
	        }
	        this.builders = {
	            name: [nameBuilder],
	            self: [selfBuilder],
	            parent: [parentBuilder],
	            data: [dataBuilder],
	            // Build a URLMatcher if necessary, either via a relative or absolute URL
	            url: [getUrlBuilder(urlMatcherFactory, root)],
	            // Keep track of the closest ancestor state that has a URL (i.e. is navigable)
	            navigable: [getNavigableBuilder(isRoot)],
	            params: [getParamsBuilder(urlMatcherFactory.paramFactory)],
	            // Each framework-specific ui-router implementation should define its own `views` builder
	            // e.g., src/ng1/statebuilders/views.ts
	            views: [],
	            // Keep a full path from the root down to this state as this is needed for state activation.
	            path: [pathBuilder],
	            // Speed up $state.includes() as it's used a lot
	            includes: [includesBuilder],
	            resolvables: [resolvablesBuilder],
	        };
	    }
	    StateBuilder.prototype.builder = function (name, fn) {
	        var builders = this.builders;
	        var array = builders[name] || [];
	        // Backwards compat: if only one builder exists, return it, else return whole arary.
	        if (predicates_1.isString(name) && !predicates_1.isDefined(fn))
	            return array.length > 1 ? array : array[0];
	        if (!predicates_1.isString(name) || !predicates_1.isFunction(fn))
	            return;
	        builders[name] = array;
	        builders[name].push(fn);
	        return function () { return builders[name].splice(builders[name].indexOf(fn, 1)) && null; };
	    };
	    /**
	     * Builds all of the properties on an essentially blank State object, returning a State object which has all its
	     * properties and API built.
	     *
	     * @param state an uninitialized State object
	     * @returns the built State object
	     */
	    StateBuilder.prototype.build = function (state) {
	        var _a = this, matcher = _a.matcher, builders = _a.builders;
	        var parent = this.parentName(state);
	        if (parent && !matcher.find(parent, undefined, false)) {
	            return null;
	        }
	        for (var key in builders) {
	            if (!builders.hasOwnProperty(key))
	                continue;
	            var chain = builders[key].reduce(function (parentFn, step) { return function (_state) { return step(_state, parentFn); }; }, common_1.noop);
	            state[key] = chain(state);
	        }
	        return state;
	    };
	    StateBuilder.prototype.parentName = function (state) {
	        // name = 'foo.bar.baz.**'
	        var name = state.name || '';
	        // segments = ['foo', 'bar', 'baz', '.**']
	        var segments = name.split('.');
	        // segments = ['foo', 'bar', 'baz']
	        var lastSegment = segments.pop();
	        // segments = ['foo', 'bar'] (ignore .** segment for future states)
	        if (lastSegment === '**')
	            segments.pop();
	        if (segments.length) {
	            if (state.parent) {
	                throw new Error("States that specify the 'parent:' property should not have a '.' in their name (" + name + ")");
	            }
	            // 'foo.bar'
	            return segments.join('.');
	        }
	        if (!state.parent)
	            return '';
	        return predicates_1.isString(state.parent) ? state.parent : state.parent.name;
	    };
	    StateBuilder.prototype.name = function (state) {
	        var name = state.name;
	        if (name.indexOf('.') !== -1 || !state.parent)
	            return name;
	        var parentName = predicates_1.isString(state.parent) ? state.parent : state.parent.name;
	        return parentName ? parentName + '.' + name : name;
	    };
	    return StateBuilder;
	}());
	exports.StateBuilder = StateBuilder;
	//# sourceMappingURL=stateBuilder.js.map

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.StateMatcher = void 0;
	var predicates_1 = __webpack_require__(2);
	var common_1 = __webpack_require__(1);
	var safeConsole_1 = __webpack_require__(48);
	var StateMatcher = /** @class */ (function () {
	    function StateMatcher(_states) {
	        this._states = _states;
	    }
	    StateMatcher.prototype.isRelative = function (stateName) {
	        stateName = stateName || '';
	        return stateName.indexOf('.') === 0 || stateName.indexOf('^') === 0;
	    };
	    StateMatcher.prototype.find = function (stateOrName, base, matchGlob) {
	        if (matchGlob === void 0) { matchGlob = true; }
	        if (!stateOrName && stateOrName !== '')
	            return undefined;
	        var isStr = predicates_1.isString(stateOrName);
	        var name = isStr ? stateOrName : stateOrName.name;
	        if (this.isRelative(name))
	            name = this.resolvePath(name, base);
	        var state = this._states[name];
	        if (state && (isStr || (!isStr && (state === stateOrName || state.self === stateOrName)))) {
	            return state;
	        }
	        else if (isStr && matchGlob) {
	            var _states = common_1.values(this._states);
	            var matches = _states.filter(function (_state) { return _state.__stateObjectCache.nameGlob && _state.__stateObjectCache.nameGlob.matches(name); });
	            if (matches.length > 1) {
	                safeConsole_1.safeConsole.error("stateMatcher.find: Found multiple matches for " + name + " using glob: ", matches.map(function (match) { return match.name; }));
	            }
	            return matches[0];
	        }
	        return undefined;
	    };
	    StateMatcher.prototype.resolvePath = function (name, base) {
	        if (!base)
	            throw new Error("No reference point given for path '" + name + "'");
	        var baseState = this.find(base);
	        var splitName = name.split('.');
	        var pathLength = splitName.length;
	        var i = 0, current = baseState;
	        for (; i < pathLength; i++) {
	            if (splitName[i] === '' && i === 0) {
	                current = baseState;
	                continue;
	            }
	            if (splitName[i] === '^') {
	                if (!current.parent)
	                    throw new Error("Path '" + name + "' not valid for state '" + baseState.name + "'");
	                current = current.parent;
	                continue;
	            }
	            break;
	        }
	        var relName = splitName.slice(i).join('.');
	        return current.name + (current.name && relName ? '.' : '') + relName;
	    };
	    return StateMatcher;
	}());
	exports.StateMatcher = StateMatcher;
	//# sourceMappingURL=stateMatcher.js.map

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.StateQueueManager = void 0;
	var common_1 = __webpack_require__(4);
	var stateObject_1 = __webpack_require__(38);
	var StateQueueManager = /** @class */ (function () {
	    function StateQueueManager(router, states, builder, listeners) {
	        this.router = router;
	        this.states = states;
	        this.builder = builder;
	        this.listeners = listeners;
	        this.queue = [];
	    }
	    StateQueueManager.prototype.dispose = function () {
	        this.queue = [];
	    };
	    StateQueueManager.prototype.register = function (stateDecl) {
	        var queue = this.queue;
	        var state = stateObject_1.StateObject.create(stateDecl);
	        var name = state.name;
	        if (!common_1.isString(name))
	            throw new Error('State must have a valid name');
	        if (this.states.hasOwnProperty(name) || common_1.inArray(queue.map(common_1.prop('name')), name))
	            throw new Error("State '" + name + "' is already defined");
	        queue.push(state);
	        this.flush();
	        return state;
	    };
	    StateQueueManager.prototype.flush = function () {
	        var _this = this;
	        var _a = this, queue = _a.queue, states = _a.states, builder = _a.builder;
	        var registered = [], // states that got registered
	        orphans = [], // states that don't yet have a parent registered
	        previousQueueLength = {}; // keep track of how long the queue when an orphan was first encountered
	        var getState = function (name) { return _this.states.hasOwnProperty(name) && _this.states[name]; };
	        var notifyListeners = function () {
	            if (registered.length) {
	                _this.listeners.forEach(function (listener) {
	                    return listener('registered', registered.map(function (s) { return s.self; }));
	                });
	            }
	        };
	        while (queue.length > 0) {
	            var state = queue.shift();
	            var name_1 = state.name;
	            var result = builder.build(state);
	            var orphanIdx = orphans.indexOf(state);
	            if (result) {
	                var existingState = getState(name_1);
	                if (existingState && existingState.name === name_1) {
	                    throw new Error("State '" + name_1 + "' is already defined");
	                }
	                var existingFutureState = getState(name_1 + '.**');
	                if (existingFutureState) {
	                    // Remove future state of the same name
	                    this.router.stateRegistry.deregister(existingFutureState);
	                }
	                states[name_1] = state;
	                this.attachRoute(state);
	                if (orphanIdx >= 0)
	                    orphans.splice(orphanIdx, 1);
	                registered.push(state);
	                continue;
	            }
	            var prev = previousQueueLength[name_1];
	            previousQueueLength[name_1] = queue.length;
	            if (orphanIdx >= 0 && prev === queue.length) {
	                // Wait until two consecutive iterations where no additional states were dequeued successfully.
	                // throw new Error(`Cannot register orphaned state '${name}'`);
	                queue.push(state);
	                notifyListeners();
	                return states;
	            }
	            else if (orphanIdx < 0) {
	                orphans.push(state);
	            }
	            queue.push(state);
	        }
	        notifyListeners();
	        return states;
	    };
	    StateQueueManager.prototype.attachRoute = function (state) {
	        if (state.abstract || !state.url)
	            return;
	        var rulesApi = this.router.urlService.rules;
	        rulesApi.rule(rulesApi.urlRuleFactory.create(state));
	    };
	    return StateQueueManager;
	}());
	exports.StateQueueManager = StateQueueManager;
	//# sourceMappingURL=stateQueueManager.js.map

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.StateRegistry = void 0;
	var stateMatcher_1 = __webpack_require__(56);
	var stateBuilder_1 = __webpack_require__(55);
	var stateQueueManager_1 = __webpack_require__(57);
	var common_1 = __webpack_require__(1);
	var hof_1 = __webpack_require__(3);
	/**
	 * A registry for all of the application's [[StateDeclaration]]s
	 *
	 * This API is found at `router.stateRegistry` ([[UIRouter.stateRegistry]])
	 */
	var StateRegistry = /** @class */ (function () {
	    /** @internal */
	    function StateRegistry(router) {
	        this.router = router;
	        this.states = {};
	        /** @internal */
	        this.listeners = [];
	        this.matcher = new stateMatcher_1.StateMatcher(this.states);
	        this.builder = new stateBuilder_1.StateBuilder(this.matcher, router.urlMatcherFactory);
	        this.stateQueue = new stateQueueManager_1.StateQueueManager(router, this.states, this.builder, this.listeners);
	        this._registerRoot();
	    }
	    /** @internal */
	    StateRegistry.prototype._registerRoot = function () {
	        var rootStateDef = {
	            name: '',
	            url: '^',
	            views: null,
	            params: {
	                '#': { value: null, type: 'hash', dynamic: true },
	            },
	            abstract: true,
	        };
	        var _root = (this._root = this.stateQueue.register(rootStateDef));
	        _root.navigable = null;
	    };
	    /** @internal */
	    StateRegistry.prototype.dispose = function () {
	        var _this = this;
	        this.stateQueue.dispose();
	        this.listeners = [];
	        this.get().forEach(function (state) { return _this.get(state) && _this.deregister(state); });
	    };
	    /**
	     * Listen for a State Registry events
	     *
	     * Adds a callback that is invoked when states are registered or deregistered with the StateRegistry.
	     *
	     * #### Example:
	     * ```js
	     * let allStates = registry.get();
	     *
	     * // Later, invoke deregisterFn() to remove the listener
	     * let deregisterFn = registry.onStatesChanged((event, states) => {
	     *   switch(event) {
	     *     case: 'registered':
	     *       states.forEach(state => allStates.push(state));
	     *       break;
	     *     case: 'deregistered':
	     *       states.forEach(state => {
	     *         let idx = allStates.indexOf(state);
	     *         if (idx !== -1) allStates.splice(idx, 1);
	     *       });
	     *       break;
	     *   }
	     * });
	     * ```
	     *
	     * @param listener a callback function invoked when the registered states changes.
	     *        The function receives two parameters, `event` and `state`.
	     *        See [[StateRegistryListener]]
	     * @return a function that deregisters the listener
	     */
	    StateRegistry.prototype.onStatesChanged = function (listener) {
	        this.listeners.push(listener);
	        return function deregisterListener() {
	            common_1.removeFrom(this.listeners)(listener);
	        }.bind(this);
	    };
	    /**
	     * Gets the implicit root state
	     *
	     * Gets the root of the state tree.
	     * The root state is implicitly created by UI-Router.
	     * Note: this returns the internal [[StateObject]] representation, not a [[StateDeclaration]]
	     *
	     * @return the root [[StateObject]]
	     */
	    StateRegistry.prototype.root = function () {
	        return this._root;
	    };
	    /**
	     * Adds a state to the registry
	     *
	     * Registers a [[StateDeclaration]] or queues it for registration.
	     *
	     * Note: a state will be queued if the state's parent isn't yet registered.
	     *
	     * @param stateDefinition the definition of the state to register.
	     * @returns the internal [[StateObject]] object.
	     *          If the state was successfully registered, then the object is fully built (See: [[StateBuilder]]).
	     *          If the state was only queued, then the object is not fully built.
	     */
	    StateRegistry.prototype.register = function (stateDefinition) {
	        return this.stateQueue.register(stateDefinition);
	    };
	    /** @internal */
	    StateRegistry.prototype._deregisterTree = function (state) {
	        var _this = this;
	        var all = this.get().map(function (s) { return s.$$state(); });
	        var getChildren = function (states) {
	            var _children = all.filter(function (s) { return states.indexOf(s.parent) !== -1; });
	            return _children.length === 0 ? _children : _children.concat(getChildren(_children));
	        };
	        var children = getChildren([state]);
	        var deregistered = [state].concat(children).reverse();
	        deregistered.forEach(function (_state) {
	            var rulesApi = _this.router.urlService.rules;
	            // Remove URL rule
	            rulesApi
	                .rules()
	                .filter(hof_1.propEq('state', _state))
	                .forEach(function (rule) { return rulesApi.removeRule(rule); });
	            // Remove state from registry
	            delete _this.states[_state.name];
	        });
	        return deregistered;
	    };
	    /**
	     * Removes a state from the registry
	     *
	     * This removes a state from the registry.
	     * If the state has children, they are are also removed from the registry.
	     *
	     * @param stateOrName the state's name or object representation
	     * @returns {StateObject[]} a list of removed states
	     */
	    StateRegistry.prototype.deregister = function (stateOrName) {
	        var _state = this.get(stateOrName);
	        if (!_state)
	            throw new Error("Can't deregister state; not found: " + stateOrName);
	        var deregisteredStates = this._deregisterTree(_state.$$state());
	        this.listeners.forEach(function (listener) {
	            return listener('deregistered', deregisteredStates.map(function (s) { return s.self; }));
	        });
	        return deregisteredStates;
	    };
	    StateRegistry.prototype.get = function (stateOrName, base) {
	        var _this = this;
	        if (arguments.length === 0)
	            return Object.keys(this.states).map(function (name) { return _this.states[name].self; });
	        var found = this.matcher.find(stateOrName, base);
	        return (found && found.self) || null;
	    };
	    /**
	     * Registers a [[BuilderFunction]] for a specific [[StateObject]] property (e.g., `parent`, `url`, or `path`).
	     * More than one BuilderFunction can be registered for a given property.
	     *
	     * The BuilderFunction(s) will be used to define the property on any subsequently built [[StateObject]] objects.
	     *
	     * @param property The name of the State property being registered for.
	     * @param builderFunction The BuilderFunction which will be used to build the State property
	     * @returns a function which deregisters the BuilderFunction
	     */
	    StateRegistry.prototype.decorator = function (property, builderFunction) {
	        return this.builder.builder(property, builderFunction);
	    };
	    return StateRegistry;
	}());
	exports.StateRegistry = StateRegistry;
	//# sourceMappingURL=stateRegistry.js.map

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.StateService = void 0;
	var common_1 = __webpack_require__(1);
	var predicates_1 = __webpack_require__(2);
	var queue_1 = __webpack_require__(33);
	var coreservices_1 = __webpack_require__(5);
	var pathUtils_1 = __webpack_require__(20);
	var pathNode_1 = __webpack_require__(36);
	var transitionService_1 = __webpack_require__(41);
	var rejectFactory_1 = __webpack_require__(12);
	var targetState_1 = __webpack_require__(15);
	var param_1 = __webpack_require__(14);
	var glob_1 = __webpack_require__(32);
	var resolveContext_1 = __webpack_require__(22);
	var lazyLoad_1 = __webpack_require__(50);
	var hof_1 = __webpack_require__(3);
	/**
	 * Provides services related to ui-router states.
	 *
	 * This API is located at `router.stateService` ([[UIRouter.stateService]])
	 */
	var StateService = /** @class */ (function () {
	    /** @internal */
	    function StateService(/** @internal */ router) {
	        this.router = router;
	        /** @internal */
	        this.invalidCallbacks = [];
	        /** @internal */
	        this._defaultErrorHandler = function $defaultErrorHandler($error$) {
	            if ($error$ instanceof Error && $error$.stack) {
	                console.error($error$);
	                console.error($error$.stack);
	            }
	            else if ($error$ instanceof rejectFactory_1.Rejection) {
	                console.error($error$.toString());
	                if ($error$.detail && $error$.detail.stack)
	                    console.error($error$.detail.stack);
	            }
	            else {
	                console.error($error$);
	            }
	        };
	        var getters = ['current', '$current', 'params', 'transition'];
	        var boundFns = Object.keys(StateService.prototype).filter(hof_1.not(common_1.inArray(getters)));
	        common_1.createProxyFunctions(hof_1.val(StateService.prototype), this, hof_1.val(this), boundFns);
	    }
	    Object.defineProperty(StateService.prototype, "transition", {
	        /**
	         * The [[Transition]] currently in progress (or null)
	         *
	         * @deprecated This is a passthrough through to [[UIRouterGlobals.transition]]
	         */
	        get: function () {
	            return this.router.globals.transition;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(StateService.prototype, "params", {
	        /**
	         * The latest successful state parameters
	         *
	         * @deprecated This is a passthrough through to [[UIRouterGlobals.params]]
	         */
	        get: function () {
	            return this.router.globals.params;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(StateService.prototype, "current", {
	        /**
	         * The current [[StateDeclaration]]
	         *
	         * @deprecated This is a passthrough through to [[UIRouterGlobals.current]]
	         */
	        get: function () {
	            return this.router.globals.current;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(StateService.prototype, "$current", {
	        /**
	         * The current [[StateObject]] (an internal API)
	         *
	         * @deprecated This is a passthrough through to [[UIRouterGlobals.$current]]
	         */
	        get: function () {
	            return this.router.globals.$current;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    /** @internal */
	    StateService.prototype.dispose = function () {
	        this.defaultErrorHandler(common_1.noop);
	        this.invalidCallbacks = [];
	    };
	    /**
	     * Handler for when [[transitionTo]] is called with an invalid state.
	     *
	     * Invokes the [[onInvalid]] callbacks, in natural order.
	     * Each callback's return value is checked in sequence until one of them returns an instance of TargetState.
	     * The results of the callbacks are wrapped in $q.when(), so the callbacks may return promises.
	     *
	     * If a callback returns an TargetState, then it is used as arguments to $state.transitionTo() and the result returned.
	     *
	     * @internal
	     */
	    StateService.prototype._handleInvalidTargetState = function (fromPath, toState) {
	        var _this = this;
	        var fromState = pathUtils_1.PathUtils.makeTargetState(this.router.stateRegistry, fromPath);
	        var globals = this.router.globals;
	        var latestThing = function () { return globals.transitionHistory.peekTail(); };
	        var latest = latestThing();
	        var callbackQueue = new queue_1.Queue(this.invalidCallbacks.slice());
	        var injector = new resolveContext_1.ResolveContext(fromPath).injector();
	        var checkForRedirect = function (result) {
	            if (!(result instanceof targetState_1.TargetState)) {
	                return;
	            }
	            var target = result;
	            // Recreate the TargetState, in case the state is now defined.
	            target = _this.target(target.identifier(), target.params(), target.options());
	            if (!target.valid()) {
	                return rejectFactory_1.Rejection.invalid(target.error()).toPromise();
	            }
	            if (latestThing() !== latest) {
	                return rejectFactory_1.Rejection.superseded().toPromise();
	            }
	            return _this.transitionTo(target.identifier(), target.params(), target.options());
	        };
	        function invokeNextCallback() {
	            var nextCallback = callbackQueue.dequeue();
	            if (nextCallback === undefined)
	                return rejectFactory_1.Rejection.invalid(toState.error()).toPromise();
	            var callbackResult = coreservices_1.services.$q.when(nextCallback(toState, fromState, injector));
	            return callbackResult.then(checkForRedirect).then(function (result) { return result || invokeNextCallback(); });
	        }
	        return invokeNextCallback();
	    };
	    /**
	     * Registers an Invalid State handler
	     *
	     * Registers a [[OnInvalidCallback]] function to be invoked when [[StateService.transitionTo]]
	     * has been called with an invalid state reference parameter
	     *
	     * Example:
	     * ```js
	     * stateService.onInvalid(function(to, from, injector) {
	     *   if (to.name() === 'foo') {
	     *     let lazyLoader = injector.get('LazyLoadService');
	     *     return lazyLoader.load('foo')
	     *         .then(() => stateService.target('foo'));
	     *   }
	     * });
	     * ```
	     *
	     * @param {function} callback invoked when the toState is invalid
	     *   This function receives the (invalid) toState, the fromState, and an injector.
	     *   The function may optionally return a [[TargetState]] or a Promise for a TargetState.
	     *   If one is returned, it is treated as a redirect.
	     *
	     * @returns a function which deregisters the callback
	     */
	    StateService.prototype.onInvalid = function (callback) {
	        this.invalidCallbacks.push(callback);
	        return function deregisterListener() {
	            common_1.removeFrom(this.invalidCallbacks)(callback);
	        }.bind(this);
	    };
	    /**
	     * Reloads the current state
	     *
	     * A method that force reloads the current state, or a partial state hierarchy.
	     * All resolves are re-resolved, and components reinstantiated.
	     *
	     * #### Example:
	     * ```js
	     * let app angular.module('app', ['ui.router']);
	     *
	     * app.controller('ctrl', function ($scope, $state) {
	     *   $scope.reload = function(){
	     *     $state.reload();
	     *   }
	     * });
	     * ```
	     *
	     * Note: `reload()` is just an alias for:
	     *
	     * ```js
	     * $state.transitionTo($state.current, $state.params, {
	     *   reload: true, inherit: false
	     * });
	     * ```
	     *
	     * @param reloadState A state name or a state object.
	     *    If present, this state and all its children will be reloaded, but ancestors will not reload.
	     *
	     * #### Example:
	     * ```js
	     * //assuming app application consists of 3 states: 'contacts', 'contacts.detail', 'contacts.detail.item'
	     * //and current state is 'contacts.detail.item'
	     * let app angular.module('app', ['ui.router']);
	     *
	     * app.controller('ctrl', function ($scope, $state) {
	     *   $scope.reload = function(){
	     *     //will reload 'contact.detail' and nested 'contact.detail.item' states
	     *     $state.reload('contact.detail');
	     *   }
	     * });
	     * ```
	     *
	     * @returns A promise representing the state of the new transition. See [[StateService.go]]
	     */
	    StateService.prototype.reload = function (reloadState) {
	        return this.transitionTo(this.current, this.params, {
	            reload: predicates_1.isDefined(reloadState) ? reloadState : true,
	            inherit: false,
	            notify: false,
	        });
	    };
	    /**
	     * Transition to a different state and/or parameters
	     *
	     * Convenience method for transitioning to a new state.
	     *
	     * `$state.go` calls `$state.transitionTo` internally but automatically sets options to
	     * `{ location: true, inherit: true, relative: router.globals.$current, notify: true }`.
	     * This allows you to use either an absolute or relative `to` argument (because of `relative: router.globals.$current`).
	     * It also allows you to specify * only the parameters you'd like to update, while letting unspecified parameters
	     * inherit from the current parameter values (because of `inherit: true`).
	     *
	     * #### Example:
	     * ```js
	     * let app = angular.module('app', ['ui.router']);
	     *
	     * app.controller('ctrl', function ($scope, $state) {
	     *   $scope.changeState = function () {
	     *     $state.go('contact.detail');
	     *   };
	     * });
	     * ```
	     *
	     * @param to Absolute state name, state object, or relative state path (relative to current state).
	     *
	     * Some examples:
	     *
	     * - `$state.go('contact.detail')` - will go to the `contact.detail` state
	     * - `$state.go('^')` - will go to the parent state
	     * - `$state.go('^.sibling')` - if current state is `home.child`, will go to the `home.sibling` state
	     * - `$state.go('.child.grandchild')` - if current state is home, will go to the `home.child.grandchild` state
	     *
	     * @param params A map of the parameters that will be sent to the state, will populate $stateParams.
	     *
	     *    Any parameters that are not specified will be inherited from current parameter values (because of `inherit: true`).
	     *    This allows, for example, going to a sibling state that shares parameters defined by a parent state.
	     *
	     * @param options Transition options
	     *
	     * @returns {promise} A promise representing the state of the new transition.
	     */
	    StateService.prototype.go = function (to, params, options) {
	        var defautGoOpts = { relative: this.$current, inherit: true };
	        var transOpts = common_1.defaults(options, defautGoOpts, transitionService_1.defaultTransOpts);
	        return this.transitionTo(to, params, transOpts);
	    };
	    /**
	     * Creates a [[TargetState]]
	     *
	     * This is a factory method for creating a TargetState
	     *
	     * This may be returned from a Transition Hook to redirect a transition, for example.
	     */
	    StateService.prototype.target = function (identifier, params, options) {
	        if (options === void 0) { options = {}; }
	        // If we're reloading, find the state object to reload from
	        if (predicates_1.isObject(options.reload) && !options.reload.name)
	            throw new Error('Invalid reload state object');
	        var reg = this.router.stateRegistry;
	        options.reloadState =
	            options.reload === true ? reg.root() : reg.matcher.find(options.reload, options.relative);
	        if (options.reload && !options.reloadState)
	            throw new Error("No such reload state '" + (predicates_1.isString(options.reload) ? options.reload : options.reload.name) + "'");
	        return new targetState_1.TargetState(this.router.stateRegistry, identifier, params, options);
	    };
	    /** @internal */
	    StateService.prototype.getCurrentPath = function () {
	        var _this = this;
	        var globals = this.router.globals;
	        var latestSuccess = globals.successfulTransitions.peekTail();
	        var rootPath = function () { return [new pathNode_1.PathNode(_this.router.stateRegistry.root())]; };
	        return latestSuccess ? latestSuccess.treeChanges().to : rootPath();
	    };
	    /**
	     * Low-level method for transitioning to a new state.
	     *
	     * The [[go]] method (which uses `transitionTo` internally) is recommended in most situations.
	     *
	     * #### Example:
	     * ```js
	     * let app = angular.module('app', ['ui.router']);
	     *
	     * app.controller('ctrl', function ($scope, $state) {
	     *   $scope.changeState = function () {
	     *     $state.transitionTo('contact.detail');
	     *   };
	     * });
	     * ```
	     *
	     * @param to State name or state object.
	     * @param toParams A map of the parameters that will be sent to the state,
	     *      will populate $stateParams.
	     * @param options Transition options
	     *
	     * @returns A promise representing the state of the new transition. See [[go]]
	     */
	    StateService.prototype.transitionTo = function (to, toParams, options) {
	        var _this = this;
	        if (toParams === void 0) { toParams = {}; }
	        if (options === void 0) { options = {}; }
	        var router = this.router;
	        var globals = router.globals;
	        options = common_1.defaults(options, transitionService_1.defaultTransOpts);
	        var getCurrent = function () { return globals.transition; };
	        options = common_1.extend(options, { current: getCurrent });
	        var ref = this.target(to, toParams, options);
	        var currentPath = this.getCurrentPath();
	        if (!ref.exists())
	            return this._handleInvalidTargetState(currentPath, ref);
	        if (!ref.valid())
	            return common_1.silentRejection(ref.error());
	        if (options.supercede === false && getCurrent()) {
	            return (rejectFactory_1.Rejection.ignored('Another transition is in progress and supercede has been set to false in TransitionOptions for the transition. So the transition was ignored in favour of the existing one in progress.').toPromise());
	        }
	        /**
	         * Special handling for Ignored, Aborted, and Redirected transitions
	         *
	         * The semantics for the transition.run() promise and the StateService.transitionTo()
	         * promise differ. For instance, the run() promise may be rejected because it was
	         * IGNORED, but the transitionTo() promise is resolved because from the user perspective
	         * no error occurred.  Likewise, the transition.run() promise may be rejected because of
	         * a Redirect, but the transitionTo() promise is chained to the new Transition's promise.
	         */
	        var rejectedTransitionHandler = function (trans) { return function (error) {
	            if (error instanceof rejectFactory_1.Rejection) {
	                var isLatest = router.globals.lastStartedTransitionId <= trans.$id;
	                if (error.type === rejectFactory_1.RejectType.IGNORED) {
	                    isLatest && router.urlRouter.update();
	                    // Consider ignored `Transition.run()` as a successful `transitionTo`
	                    return coreservices_1.services.$q.when(globals.current);
	                }
	                var detail = error.detail;
	                if (error.type === rejectFactory_1.RejectType.SUPERSEDED && error.redirected && detail instanceof targetState_1.TargetState) {
	                    // If `Transition.run()` was redirected, allow the `transitionTo()` promise to resolve successfully
	                    // by returning the promise for the new (redirect) `Transition.run()`.
	                    var redirect = trans.redirect(detail);
	                    return redirect.run().catch(rejectedTransitionHandler(redirect));
	                }
	                if (error.type === rejectFactory_1.RejectType.ABORTED) {
	                    isLatest && router.urlRouter.update();
	                    return coreservices_1.services.$q.reject(error);
	                }
	            }
	            var errorHandler = _this.defaultErrorHandler();
	            errorHandler(error);
	            return coreservices_1.services.$q.reject(error);
	        }; };
	        var transition = this.router.transitionService.create(currentPath, ref);
	        var transitionToPromise = transition.run().catch(rejectedTransitionHandler(transition));
	        common_1.silenceUncaughtInPromise(transitionToPromise); // issue #2676
	        // Return a promise for the transition, which also has the transition object on it.
	        return common_1.extend(transitionToPromise, { transition: transition });
	    };
	    /**
	     * Checks if the current state *is* the provided state
	     *
	     * Similar to [[includes]] but only checks for the full state name.
	     * If params is supplied then it will be tested for strict equality against the current
	     * active params object, so all params must match with none missing and no extras.
	     *
	     * #### Example:
	     * ```js
	     * $state.$current.name = 'contacts.details.item';
	     *
	     * // absolute name
	     * $state.is('contact.details.item'); // returns true
	     * $state.is(contactDetailItemStateObject); // returns true
	     * ```
	     *
	     * // relative name (. and ^), typically from a template
	     * // E.g. from the 'contacts.details' template
	     * ```html
	     * <div ng-class="{highlighted: $state.is('.item')}">Item</div>
	     * ```
	     *
	     * @param stateOrName The state name (absolute or relative) or state object you'd like to check.
	     * @param params A param object, e.g. `{sectionId: section.id}`, that you'd like
	     * to test against the current active state.
	     * @param options An options object. The options are:
	     *   - `relative`: If `stateOrName` is a relative state name and `options.relative` is set, .is will
	     *     test relative to `options.relative` state (or name).
	     *
	     * @returns Returns true if it is the state.
	     */
	    StateService.prototype.is = function (stateOrName, params, options) {
	        options = common_1.defaults(options, { relative: this.$current });
	        var state = this.router.stateRegistry.matcher.find(stateOrName, options.relative);
	        if (!predicates_1.isDefined(state))
	            return undefined;
	        if (this.$current !== state)
	            return false;
	        if (!params)
	            return true;
	        var schema = state.parameters({ inherit: true, matchingKeys: params });
	        return param_1.Param.equals(schema, param_1.Param.values(schema, params), this.params);
	    };
	    /**
	     * Checks if the current state *includes* the provided state
	     *
	     * A method to determine if the current active state is equal to or is the child of the
	     * state stateName. If any params are passed then they will be tested for a match as well.
	     * Not all the parameters need to be passed, just the ones you'd like to test for equality.
	     *
	     * #### Example when `$state.$current.name === 'contacts.details.item'`
	     * ```js
	     * // Using partial names
	     * $state.includes("contacts"); // returns true
	     * $state.includes("contacts.details"); // returns true
	     * $state.includes("contacts.details.item"); // returns true
	     * $state.includes("contacts.list"); // returns false
	     * $state.includes("about"); // returns false
	     * ```
	     *
	     * #### Glob Examples when `* $state.$current.name === 'contacts.details.item.url'`:
	     * ```js
	     * $state.includes("*.details.*.*"); // returns true
	     * $state.includes("*.details.**"); // returns true
	     * $state.includes("**.item.**"); // returns true
	     * $state.includes("*.details.item.url"); // returns true
	     * $state.includes("*.details.*.url"); // returns true
	     * $state.includes("*.details.*"); // returns false
	     * $state.includes("item.**"); // returns false
	     * ```
	     *
	     * @param stateOrName A partial name, relative name, glob pattern,
	     *   or state object to be searched for within the current state name.
	     * @param params A param object, e.g. `{sectionId: section.id}`,
	     *   that you'd like to test against the current active state.
	     * @param options An options object. The options are:
	     *   - `relative`: If `stateOrName` is a relative state name and `options.relative` is set, .is will
	     *     test relative to `options.relative` state (or name).
	     *
	     * @returns {boolean} Returns true if it does include the state
	     */
	    StateService.prototype.includes = function (stateOrName, params, options) {
	        options = common_1.defaults(options, { relative: this.$current });
	        var glob = predicates_1.isString(stateOrName) && glob_1.Glob.fromString(stateOrName);
	        if (glob) {
	            if (!glob.matches(this.$current.name))
	                return false;
	            stateOrName = this.$current.name;
	        }
	        var state = this.router.stateRegistry.matcher.find(stateOrName, options.relative), include = this.$current.includes;
	        if (!predicates_1.isDefined(state))
	            return undefined;
	        if (!predicates_1.isDefined(include[state.name]))
	            return false;
	        if (!params)
	            return true;
	        var schema = state.parameters({ inherit: true, matchingKeys: params });
	        return param_1.Param.equals(schema, param_1.Param.values(schema, params), this.params);
	    };
	    /**
	     * Generates a URL for a state and parameters
	     *
	     * Returns the url for the given state populated with the given params.
	     *
	     * #### Example:
	     * ```js
	     * expect($state.href("about.person", { person: "bob" })).toEqual("/about/bob");
	     * ```
	     *
	     * @param stateOrName The state name or state object you'd like to generate a url from.
	     * @param params An object of parameter values to fill the state's required parameters.
	     * @param options Options object. The options are:
	     *
	     * @returns {string} compiled state url
	     */
	    StateService.prototype.href = function (stateOrName, params, options) {
	        var defaultHrefOpts = {
	            lossy: true,
	            inherit: true,
	            absolute: false,
	            relative: this.$current,
	        };
	        options = common_1.defaults(options, defaultHrefOpts);
	        params = params || {};
	        var state = this.router.stateRegistry.matcher.find(stateOrName, options.relative);
	        if (!predicates_1.isDefined(state))
	            return null;
	        if (options.inherit)
	            params = this.params.$inherit(params, this.$current, state);
	        var nav = state && options.lossy ? state.navigable : state;
	        if (!nav || nav.url === undefined || nav.url === null) {
	            return null;
	        }
	        return this.router.urlRouter.href(nav.url, params, { absolute: options.absolute });
	    };
	    /**
	     * Sets or gets the default [[transitionTo]] error handler.
	     *
	     * The error handler is called when a [[Transition]] is rejected or when any error occurred during the Transition.
	     * This includes errors caused by resolves and transition hooks.
	     *
	     * Note:
	     * This handler does not receive certain Transition rejections.
	     * Redirected and Ignored Transitions are not considered to be errors by [[StateService.transitionTo]].
	     *
	     * The built-in default error handler logs the error to the console.
	     *
	     * You can provide your own custom handler.
	     *
	     * #### Example:
	     * ```js
	     * stateService.defaultErrorHandler(function() {
	     *   // Do not log transitionTo errors
	     * });
	     * ```
	     *
	     * @param handler a global error handler function
	     * @returns the current global error handler
	     */
	    StateService.prototype.defaultErrorHandler = function (handler) {
	        return (this._defaultErrorHandler = handler || this._defaultErrorHandler);
	    };
	    StateService.prototype.get = function (stateOrName, base) {
	        var reg = this.router.stateRegistry;
	        if (arguments.length === 0)
	            return reg.get();
	        return reg.get(stateOrName, base || this.$current);
	    };
	    /**
	     * Lazy loads a state
	     *
	     * Explicitly runs a state's [[StateDeclaration.lazyLoad]] function.
	     *
	     * @param stateOrName the state that should be lazy loaded
	     * @param transition the optional Transition context to use (if the lazyLoad function requires an injector, etc)
	     * Note: If no transition is provided, a noop transition is created using the from the current state to the current state.
	     * This noop transition is not actually run.
	     *
	     * @returns a promise to lazy load
	     */
	    StateService.prototype.lazyLoad = function (stateOrName, transition) {
	        var state = this.get(stateOrName);
	        if (!state || !state.lazyLoad)
	            throw new Error('Can not lazy load ' + stateOrName);
	        var currentPath = this.getCurrentPath();
	        var target = pathUtils_1.PathUtils.makeTargetState(this.router.stateRegistry, currentPath);
	        transition = transition || this.router.transitionService.create(currentPath, target);
	        return lazyLoad_1.lazyLoadState(transition, state);
	    };
	    return StateService;
	}());
	exports.StateService = StateService;
	//# sourceMappingURL=stateService.js.map

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.HookBuilder = void 0;
	var common_1 = __webpack_require__(1);
	var predicates_1 = __webpack_require__(2);
	var interface_1 = __webpack_require__(11);
	var transitionHook_1 = __webpack_require__(16);
	/**
	 * This class returns applicable TransitionHooks for a specific Transition instance.
	 *
	 * Hooks ([[RegisteredHook]]) may be registered globally, e.g., $transitions.onEnter(...), or locally, e.g.
	 * myTransition.onEnter(...).  The HookBuilder finds matching RegisteredHooks (where the match criteria is
	 * determined by the type of hook)
	 *
	 * The HookBuilder also converts RegisteredHooks objects to TransitionHook objects, which are used to run a Transition.
	 *
	 * The HookBuilder constructor is given the $transitions service and a Transition instance.  Thus, a HookBuilder
	 * instance may only be used for one specific Transition object. (side note: the _treeChanges accessor is private
	 * in the Transition class, so we must also provide the Transition's _treeChanges)
	 */
	var HookBuilder = /** @class */ (function () {
	    function HookBuilder(transition) {
	        this.transition = transition;
	    }
	    HookBuilder.prototype.buildHooksForPhase = function (phase) {
	        var _this = this;
	        var $transitions = this.transition.router.transitionService;
	        return $transitions._pluginapi
	            ._getEvents(phase)
	            .map(function (type) { return _this.buildHooks(type); })
	            .reduce(common_1.unnestR, [])
	            .filter(common_1.identity);
	    };
	    /**
	     * Returns an array of newly built TransitionHook objects.
	     *
	     * - Finds all RegisteredHooks registered for the given `hookType` which matched the transition's [[TreeChanges]].
	     * - Finds [[PathNode]] (or `PathNode[]`) to use as the TransitionHook context(s)
	     * - For each of the [[PathNode]]s, creates a TransitionHook
	     *
	     * @param hookType the type of the hook registration function, e.g., 'onEnter', 'onFinish'.
	     */
	    HookBuilder.prototype.buildHooks = function (hookType) {
	        var transition = this.transition;
	        var treeChanges = transition.treeChanges();
	        // Find all the matching registered hooks for a given hook type
	        var matchingHooks = this.getMatchingHooks(hookType, treeChanges, transition);
	        if (!matchingHooks)
	            return [];
	        var baseHookOptions = {
	            transition: transition,
	            current: transition.options().current,
	        };
	        var makeTransitionHooks = function (hook) {
	            // Fetch the Nodes that caused this hook to match.
	            var matches = hook.matches(treeChanges, transition);
	            // Select the PathNode[] that will be used as TransitionHook context objects
	            var matchingNodes = matches[hookType.criteriaMatchPath.name];
	            // Return an array of HookTuples
	            return matchingNodes.map(function (node) {
	                var _options = common_1.extend({
	                    bind: hook.bind,
	                    traceData: { hookType: hookType.name, context: node },
	                }, baseHookOptions);
	                var state = hookType.criteriaMatchPath.scope === interface_1.TransitionHookScope.STATE ? node.state.self : null;
	                var transitionHook = new transitionHook_1.TransitionHook(transition, state, hook, _options);
	                return { hook: hook, node: node, transitionHook: transitionHook };
	            });
	        };
	        return matchingHooks
	            .map(makeTransitionHooks)
	            .reduce(common_1.unnestR, [])
	            .sort(tupleSort(hookType.reverseSort))
	            .map(function (tuple) { return tuple.transitionHook; });
	    };
	    /**
	     * Finds all RegisteredHooks from:
	     * - The Transition object instance hook registry
	     * - The TransitionService ($transitions) global hook registry
	     *
	     * which matched:
	     * - the eventType
	     * - the matchCriteria (to, from, exiting, retained, entering)
	     *
	     * @returns an array of matched [[RegisteredHook]]s
	     */
	    HookBuilder.prototype.getMatchingHooks = function (hookType, treeChanges, transition) {
	        var isCreate = hookType.hookPhase === interface_1.TransitionHookPhase.CREATE;
	        // Instance and Global hook registries
	        var $transitions = this.transition.router.transitionService;
	        var registries = isCreate ? [$transitions] : [this.transition, $transitions];
	        return registries
	            .map(function (reg) { return reg.getHooks(hookType.name); }) // Get named hooks from registries
	            .filter(common_1.assertPredicate(predicates_1.isArray, "broken event named: " + hookType.name)) // Sanity check
	            .reduce(common_1.unnestR, []) // Un-nest RegisteredHook[][] to RegisteredHook[] array
	            .filter(function (hook) { return hook.matches(treeChanges, transition); }); // Only those satisfying matchCriteria
	    };
	    return HookBuilder;
	}());
	exports.HookBuilder = HookBuilder;
	/**
	 * A factory for a sort function for HookTuples.
	 *
	 * The sort function first compares the PathNode depth (how deep in the state tree a node is), then compares
	 * the EventHook priority.
	 *
	 * @param reverseDepthSort a boolean, when true, reverses the sort order for the node depth
	 * @returns a tuple sort function
	 */
	function tupleSort(reverseDepthSort) {
	    if (reverseDepthSort === void 0) { reverseDepthSort = false; }
	    return function nodeDepthThenPriority(l, r) {
	        var factor = reverseDepthSort ? -1 : 1;
	        var depthDelta = (l.node.state.path.length - r.node.state.path.length) * factor;
	        return depthDelta !== 0 ? depthDelta : r.hook.priority - l.hook.priority;
	    };
	}
	//# sourceMappingURL=hookBuilder.js.map

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.TransitionEventType = void 0;
	var transitionHook_1 = __webpack_require__(16);
	/**
	 * This class defines a type of hook, such as `onBefore` or `onEnter`.
	 * Plugins can define custom hook types, such as sticky states does for `onInactive`.
	 */
	var TransitionEventType = /** @class */ (function () {
	    /* tslint:disable:no-inferrable-types */
	    function TransitionEventType(name, hookPhase, hookOrder, criteriaMatchPath, reverseSort, getResultHandler, getErrorHandler, synchronous) {
	        if (reverseSort === void 0) { reverseSort = false; }
	        if (getResultHandler === void 0) { getResultHandler = transitionHook_1.TransitionHook.HANDLE_RESULT; }
	        if (getErrorHandler === void 0) { getErrorHandler = transitionHook_1.TransitionHook.REJECT_ERROR; }
	        if (synchronous === void 0) { synchronous = false; }
	        this.name = name;
	        this.hookPhase = hookPhase;
	        this.hookOrder = hookOrder;
	        this.criteriaMatchPath = criteriaMatchPath;
	        this.reverseSort = reverseSort;
	        this.getResultHandler = getResultHandler;
	        this.getErrorHandler = getErrorHandler;
	        this.synchronous = synchronous;
	    }
	    return TransitionEventType;
	}());
	exports.TransitionEventType = TransitionEventType;
	//# sourceMappingURL=transitionEventType.js.map

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.UrlConfig = void 0;
	var params_1 = __webpack_require__(34);
	var common_1 = __webpack_require__(4);
	/**
	 * An API to customize the URL behavior and retrieve URL configuration
	 *
	 * This API is used to customize the behavior of the URL.
	 * This includes optional trailing slashes ([[strictMode]]), case sensitivity ([[caseInsensitive]]),
	 * and custom parameter encoding (custom [[type]]).
	 *
	 * It also has information about the location (url) configuration such as [[port]] and [[baseHref]].
	 * This information can be used to build absolute URLs, such as
	 * `https://example.com:443/basepath/state/substate?param1=a#hashvalue`;
	 *
	 * This API is found at `router.urlService.config` (see: [[UIRouter.urlService]], [[URLService.config]])
	 */
	var UrlConfig = /** @class */ (function () {
	    /** @internal */ function UrlConfig(/** @internal */ router) {
	        var _this = this;
	        this.router = router;
	        /** @internal */ this.paramTypes = new params_1.ParamTypes();
	        /** @internal */ this._decodeParams = true;
	        /** @internal */ this._isCaseInsensitive = false;
	        /** @internal */ this._isStrictMode = true;
	        /** @internal */ this._defaultSquashPolicy = false;
	        /** @internal */ this.dispose = function () { return _this.paramTypes.dispose(); };
	        // Delegate these calls to the current LocationConfig implementation
	        /**
	         * Gets the base Href, e.g., `http://localhost/approot/`
	         *
	         * @return the application's base href
	         */
	        this.baseHref = function () { return _this.router.locationConfig.baseHref(); };
	        /**
	         * Gets or sets the hashPrefix
	         *
	         * This only applies when not running in [[html5Mode]] (pushstate mode)
	         *
	         * If the current url is `http://localhost/app#!/uirouter/path/#anchor`, it returns `!` which is the prefix for the "hashbang" portion.
	         *
	         * @return the hash prefix
	         */
	        this.hashPrefix = function (newprefix) { return _this.router.locationConfig.hashPrefix(newprefix); };
	        /**
	         * Gets the host, e.g., `localhost`
	         *
	         * @return the protocol
	         */
	        this.host = function () { return _this.router.locationConfig.host(); };
	        /**
	         * Returns true when running in pushstate mode
	         *
	         * @return true when running in html5 mode (pushstate mode).
	         */
	        this.html5Mode = function () { return _this.router.locationConfig.html5Mode(); };
	        /**
	         * Gets the port, e.g., `80`
	         *
	         * @return the port number
	         */
	        this.port = function () { return _this.router.locationConfig.port(); };
	        /**
	         * Gets the protocol, e.g., `http`
	         *
	         * @return the protocol
	         */
	        this.protocol = function () { return _this.router.locationConfig.protocol(); };
	    }
	    /**
	     * Defines whether URL matching should be case sensitive (the default behavior), or not.
	     *
	     * #### Example:
	     * ```js
	     * // Allow case insensitive url matches
	     * urlService.config.caseInsensitive(true);
	     * ```
	     *
	     * @param value `false` to match URL in a case sensitive manner; otherwise `true`;
	     * @returns the current value of caseInsensitive
	     */
	    UrlConfig.prototype.caseInsensitive = function (value) {
	        return (this._isCaseInsensitive = common_1.isDefined(value) ? value : this._isCaseInsensitive);
	    };
	    /**
	     * Sets the default behavior when generating or matching URLs with default parameter values.
	     *
	     * #### Example:
	     * ```js
	     * // Remove default parameter values from the url
	     * urlService.config.defaultSquashPolicy(true);
	     * ```
	     *
	     * @param value A string that defines the default parameter URL squashing behavior.
	     *    - `nosquash`: When generating an href with a default parameter value, do not squash the parameter value from the URL
	     *    - `slash`: When generating an href with a default parameter value, squash (remove) the parameter value, and, if the
	     *      parameter is surrounded by slashes, squash (remove) one slash from the URL
	     *    - any other string, e.g. "~": When generating an href with a default parameter value, squash (remove)
	     *      the parameter value from the URL and replace it with this string.
	     * @returns the current value of defaultSquashPolicy
	     */
	    UrlConfig.prototype.defaultSquashPolicy = function (value) {
	        if (common_1.isDefined(value) && value !== true && value !== false && !common_1.isString(value))
	            throw new Error("Invalid squash policy: " + value + ". Valid policies: false, true, arbitrary-string");
	        return (this._defaultSquashPolicy = common_1.isDefined(value) ? value : this._defaultSquashPolicy);
	    };
	    /**
	     * Defines whether URLs should match trailing slashes, or not (the default behavior).
	     *
	     * #### Example:
	     * ```js
	     * // Allow optional trailing slashes
	     * urlService.config.strictMode(false);
	     * ```
	     *
	     * @param value `false` to match trailing slashes in URLs, otherwise `true`.
	     * @returns the current value of strictMode
	     */
	    UrlConfig.prototype.strictMode = function (value) {
	        return (this._isStrictMode = common_1.isDefined(value) ? value : this._isStrictMode);
	    };
	    /**
	     * Creates and registers a custom [[ParamType]] object
	     *
	     * A custom parameter type can be used to generate URLs with typed parameters or custom encoding/decoding.
	     *
	     * #### Note: Register custom types *before using them* in a state definition.
	     *
	     * #### Example:
	     * ```js
	     * // Encode object parameter as JSON string
	     * urlService.config.type('myjson', {
	     *   encode: (obj) => JSON.stringify(obj),
	     *   decode: (str) => JSON.parse(str),
	     *   is: (val) => typeof(val) === 'object',
	     *   pattern: /[^/]+/,
	     *   equals: (a, b) => _.isEqual(a, b),
	     * });
	     * ```
	     *
	     * See [[ParamTypeDefinition]] for more examples
	     *
	     * @param name The type name.
	     * @param definition The type definition. See [[ParamTypeDefinition]] for information on the values accepted.
	     * @param definitionFn A function that is injected before the app runtime starts.
	     *        The result of this function should be a [[ParamTypeDefinition]].
	     *        The result is merged into the existing `definition`.
	     *        See [[ParamType]] for information on the values accepted.
	     *
	     * @returns if only the `name` parameter was specified: the currently registered [[ParamType]] object, or undefined
	     */
	    UrlConfig.prototype.type = function (name, definition, definitionFn) {
	        var type = this.paramTypes.type(name, definition, definitionFn);
	        return !common_1.isDefined(definition) ? type : this;
	    };
	    return UrlConfig;
	}());
	exports.UrlConfig = UrlConfig;
	//# sourceMappingURL=urlConfig.js.map

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.UrlMatcherFactory = exports.ParamFactory = void 0;
	var common_1 = __webpack_require__(4);
	var urlMatcher_1 = __webpack_require__(23);
	var params_1 = __webpack_require__(34);
	var ParamFactory = /** @class */ (function () {
	    function ParamFactory(router) {
	        this.router = router;
	    }
	    ParamFactory.prototype.fromConfig = function (id, type, state) {
	        return new params_1.Param(id, type, params_1.DefType.CONFIG, this.router.urlService.config, state);
	    };
	    ParamFactory.prototype.fromPath = function (id, type, state) {
	        return new params_1.Param(id, type, params_1.DefType.PATH, this.router.urlService.config, state);
	    };
	    ParamFactory.prototype.fromSearch = function (id, type, state) {
	        return new params_1.Param(id, type, params_1.DefType.SEARCH, this.router.urlService.config, state);
	    };
	    return ParamFactory;
	}());
	exports.ParamFactory = ParamFactory;
	/**
	 * Factory for [[UrlMatcher]] instances.
	 *
	 * The factory is available to ng1 services as
	 * `$urlMatcherFactory` or ng1 providers as `$urlMatcherFactoryProvider`.
	 */
	var UrlMatcherFactory = /** @class */ (function () {
	    // TODO: move implementations to UrlConfig (urlService.config)
	    function UrlMatcherFactory(/** @internal */ router) {
	        var _this = this;
	        this.router = router;
	        /** Creates a new [[Param]] for a given location (DefType) */
	        this.paramFactory = new ParamFactory(this.router);
	        // TODO: Check if removal of this will break anything, then remove these
	        this.UrlMatcher = urlMatcher_1.UrlMatcher;
	        this.Param = params_1.Param;
	        /** @deprecated use [[UrlConfig.caseInsensitive]] */
	        this.caseInsensitive = function (value) { return _this.router.urlService.config.caseInsensitive(value); };
	        /** @deprecated use [[UrlConfig.defaultSquashPolicy]] */
	        this.defaultSquashPolicy = function (value) { return _this.router.urlService.config.defaultSquashPolicy(value); };
	        /** @deprecated use [[UrlConfig.strictMode]] */
	        this.strictMode = function (value) { return _this.router.urlService.config.strictMode(value); };
	        /** @deprecated use [[UrlConfig.type]] */
	        this.type = function (name, definition, definitionFn) {
	            return _this.router.urlService.config.type(name, definition, definitionFn) || _this;
	        };
	    }
	    /**
	     * Creates a [[UrlMatcher]] for the specified pattern.
	     *
	     * @param pattern  The URL pattern.
	     * @param config  The config object hash.
	     * @returns The UrlMatcher.
	     */
	    UrlMatcherFactory.prototype.compile = function (pattern, config) {
	        var urlConfig = this.router.urlService.config;
	        // backward-compatible support for config.params -> config.state.params
	        var params = config && !config.state && config.params;
	        config = params ? __assign({ state: { params: params } }, config) : config;
	        var globalConfig = {
	            strict: urlConfig._isStrictMode,
	            caseInsensitive: urlConfig._isCaseInsensitive,
	            decodeParams: urlConfig._decodeParams,
	        };
	        return new urlMatcher_1.UrlMatcher(pattern, urlConfig.paramTypes, this.paramFactory, common_1.extend(globalConfig, config));
	    };
	    /**
	     * Returns true if the specified object is a [[UrlMatcher]], or false otherwise.
	     *
	     * @param object  The object to perform the type check against.
	     * @returns `true` if the object matches the `UrlMatcher` interface, by
	     *          implementing all the same methods.
	     */
	    UrlMatcherFactory.prototype.isMatcher = function (object) {
	        // TODO: typeof?
	        if (!common_1.isObject(object))
	            return false;
	        var result = true;
	        common_1.forEach(urlMatcher_1.UrlMatcher.prototype, function (val, name) {
	            if (common_1.isFunction(val))
	                result = result && common_1.isDefined(object[name]) && common_1.isFunction(object[name]);
	        });
	        return result;
	    };
	    /** @internal */
	    UrlMatcherFactory.prototype.$get = function () {
	        var urlConfig = this.router.urlService.config;
	        urlConfig.paramTypes.enqueue = false;
	        urlConfig.paramTypes._flushTypeQueue();
	        return this;
	    };
	    return UrlMatcherFactory;
	}());
	exports.UrlMatcherFactory = UrlMatcherFactory;
	//# sourceMappingURL=urlMatcherFactory.js.map

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.UrlRouter = void 0;
	var common_1 = __webpack_require__(4);
	var urlRule_1 = __webpack_require__(42);
	function appendBasePath(url, isHtml5, absolute, baseHref) {
	    if (baseHref === '/')
	        return url;
	    if (isHtml5)
	        return common_1.stripLastPathElement(baseHref) + url;
	    if (absolute)
	        return baseHref.slice(1) + url;
	    return url;
	}
	/**
	 * Updates URL and responds to URL changes
	 *
	 * ### Deprecation warning:
	 * This class is now considered to be an internal API
	 * Use the [[UrlService]] instead.
	 * For configuring URL rules, use the [[UrlRules]] which can be found as [[UrlService.rules]].
	 */
	var UrlRouter = /** @class */ (function () {
	    /** @internal */
	    function UrlRouter(/** @internal */ router) {
	        var _this = this;
	        this.router = router;
	        // Delegate these calls to [[UrlService]]
	        /** @deprecated use [[UrlService.sync]]*/
	        this.sync = function (evt) { return _this.router.urlService.sync(evt); };
	        /** @deprecated use [[UrlService.listen]]*/
	        this.listen = function (enabled) { return _this.router.urlService.listen(enabled); };
	        /** @deprecated use [[UrlService.deferIntercept]]*/
	        this.deferIntercept = function (defer) { return _this.router.urlService.deferIntercept(defer); };
	        /** @deprecated use [[UrlService.match]]*/
	        this.match = function (urlParts) { return _this.router.urlService.match(urlParts); };
	        // Delegate these calls to [[UrlRules]]
	        /** @deprecated use [[UrlRules.initial]]*/
	        this.initial = function (handler) {
	            return _this.router.urlService.rules.initial(handler);
	        };
	        /** @deprecated use [[UrlRules.otherwise]]*/
	        this.otherwise = function (handler) {
	            return _this.router.urlService.rules.otherwise(handler);
	        };
	        /** @deprecated use [[UrlRules.removeRule]]*/
	        this.removeRule = function (rule) { return _this.router.urlService.rules.removeRule(rule); };
	        /** @deprecated use [[UrlRules.rule]]*/
	        this.rule = function (rule) { return _this.router.urlService.rules.rule(rule); };
	        /** @deprecated use [[UrlRules.rules]]*/
	        this.rules = function () { return _this.router.urlService.rules.rules(); };
	        /** @deprecated use [[UrlRules.sort]]*/
	        this.sort = function (compareFn) { return _this.router.urlService.rules.sort(compareFn); };
	        /** @deprecated use [[UrlRules.when]]*/
	        this.when = function (matcher, handler, options) { return _this.router.urlService.rules.when(matcher, handler, options); };
	        this.urlRuleFactory = new urlRule_1.UrlRuleFactory(router);
	    }
	    /** Internal API. */
	    UrlRouter.prototype.update = function (read) {
	        var $url = this.router.locationService;
	        if (read) {
	            this.location = $url.url();
	            return;
	        }
	        if ($url.url() === this.location)
	            return;
	        $url.url(this.location, true);
	    };
	    /**
	     * Internal API.
	     *
	     * Pushes a new location to the browser history.
	     *
	     * @internal
	     * @param urlMatcher
	     * @param params
	     * @param options
	     */
	    UrlRouter.prototype.push = function (urlMatcher, params, options) {
	        var replace = options && !!options.replace;
	        this.router.urlService.url(urlMatcher.format(params || {}), replace);
	    };
	    /**
	     * Builds and returns a URL with interpolated parameters
	     *
	     * #### Example:
	     * ```js
	     * matcher = $umf.compile("/about/:person");
	     * params = { person: "bob" };
	     * $bob = $urlRouter.href(matcher, params);
	     * // $bob == "/about/bob";
	     * ```
	     *
	     * @param urlMatcher The [[UrlMatcher]] object which is used as the template of the URL to generate.
	     * @param params An object of parameter values to fill the matcher's required parameters.
	     * @param options Options object. The options are:
	     *
	     * - **`absolute`** - {boolean=false},  If true will generate an absolute url, e.g. "http://www.example.com/fullurl".
	     *
	     * @returns Returns the fully compiled URL, or `null` if `params` fail validation against `urlMatcher`
	     */
	    UrlRouter.prototype.href = function (urlMatcher, params, options) {
	        var url = urlMatcher.format(params);
	        if (url == null)
	            return null;
	        options = options || { absolute: false };
	        var cfg = this.router.urlService.config;
	        var isHtml5 = cfg.html5Mode();
	        if (!isHtml5 && url !== null) {
	            url = '#' + cfg.hashPrefix() + url;
	        }
	        url = appendBasePath(url, isHtml5, options.absolute, cfg.baseHref());
	        if (!options.absolute || !url) {
	            return url;
	        }
	        var slash = !isHtml5 && url ? '/' : '';
	        var cfgPort = cfg.port();
	        var port = (cfgPort === 80 || cfgPort === 443 ? '' : ':' + cfgPort);
	        return [cfg.protocol(), '://', cfg.host(), port, slash, url].join('');
	    };
	    Object.defineProperty(UrlRouter.prototype, "interceptDeferred", {
	        /** @deprecated use [[UrlService.interceptDeferred]]*/
	        get: function () {
	            return this.router.urlService.interceptDeferred;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    return UrlRouter;
	}());
	exports.UrlRouter = UrlRouter;
	//# sourceMappingURL=urlRouter.js.map

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.UrlRules = void 0;
	var state_1 = __webpack_require__(37);
	var urlMatcher_1 = __webpack_require__(23);
	var common_1 = __webpack_require__(4);
	var urlRule_1 = __webpack_require__(42);
	var prioritySort = function (a, b) { return (b.priority || 0) - (a.priority || 0); };
	var typeSort = function (a, b) {
	    var weights = { STATE: 4, URLMATCHER: 4, REGEXP: 3, RAW: 2, OTHER: 1 };
	    return (weights[a.type] || 0) - (weights[b.type] || 0);
	};
	var urlMatcherSort = function (a, b) {
	    return !a.urlMatcher || !b.urlMatcher ? 0 : urlMatcher_1.UrlMatcher.compare(a.urlMatcher, b.urlMatcher);
	};
	var idSort = function (a, b) {
	    // Identically sorted STATE and URLMATCHER best rule will be chosen by `matchPriority` after each rule matches the URL
	    var useMatchPriority = { STATE: true, URLMATCHER: true };
	    var equal = useMatchPriority[a.type] && useMatchPriority[b.type];
	    return equal ? 0 : (a.$id || 0) - (b.$id || 0);
	};
	/**
	 * Default rule priority sorting function.
	 *
	 * Sorts rules by:
	 *
	 * - Explicit priority (set rule priority using [[UrlRules.when]])
	 * - Rule type (STATE: 4, URLMATCHER: 4, REGEXP: 3, RAW: 2, OTHER: 1)
	 * - `UrlMatcher` specificity ([[UrlMatcher.compare]]): works for STATE and URLMATCHER types to pick the most specific rule.
	 * - Rule registration order (for rule types other than STATE and URLMATCHER)
	 *   - Equally sorted State and UrlMatcher rules will each match the URL.
	 *     Then, the *best* match is chosen based on how many parameter values were matched.
	 */
	var defaultRuleSortFn;
	defaultRuleSortFn = function (a, b) {
	    var cmp = prioritySort(a, b);
	    if (cmp !== 0)
	        return cmp;
	    cmp = typeSort(a, b);
	    if (cmp !== 0)
	        return cmp;
	    cmp = urlMatcherSort(a, b);
	    if (cmp !== 0)
	        return cmp;
	    return idSort(a, b);
	};
	function getHandlerFn(handler) {
	    if (!common_1.isFunction(handler) && !common_1.isString(handler) && !common_1.is(state_1.TargetState)(handler) && !state_1.TargetState.isDef(handler)) {
	        throw new Error("'handler' must be a string, function, TargetState, or have a state: 'newtarget' property");
	    }
	    return common_1.isFunction(handler) ? handler : common_1.val(handler);
	}
	/**
	 * API for managing URL rules
	 *
	 * This API is used to create and manage URL rules.
	 * URL rules are a mechanism to respond to specific URL patterns.
	 *
	 * The most commonly used methods are [[otherwise]] and [[when]].
	 *
	 * This API is found at `router.urlService.rules` (see: [[UIRouter.urlService]], [[URLService.rules]])
	 */
	var UrlRules = /** @class */ (function () {
	    /** @internal */
	    function UrlRules(/** @internal */ router) {
	        this.router = router;
	        /** @internal */ this._sortFn = defaultRuleSortFn;
	        /** @internal */ this._rules = [];
	        /** @internal */ this._id = 0;
	        this.urlRuleFactory = new urlRule_1.UrlRuleFactory(router);
	    }
	    /** @internal */
	    UrlRules.prototype.dispose = function (router) {
	        this._rules = [];
	        delete this._otherwiseFn;
	    };
	    /**
	     * Defines the initial state, path, or behavior to use when the app starts.
	     *
	     * This rule defines the initial/starting state for the application.
	     *
	     * This rule is triggered the first time the URL is checked (when the app initially loads).
	     * The rule is triggered only when the url matches either `""` or `"/"`.
	     *
	     * Note: The rule is intended to be used when the root of the application is directly linked to.
	     * When the URL is *not* `""` or `"/"` and doesn't match other rules, the [[otherwise]] rule is triggered.
	     * This allows 404-like behavior when an unknown URL is deep-linked.
	     *
	     * #### Example:
	     * Start app at `home` state.
	     * ```js
	     * .initial({ state: 'home' });
	     * ```
	     *
	     * #### Example:
	     * Start app at `/home` (by url)
	     * ```js
	     * .initial('/home');
	     * ```
	     *
	     * #### Example:
	     * When no other url rule matches, go to `home` state
	     * ```js
	     * .initial((matchValue, url, router) => {
	     *   console.log('initial state');
	     *   return { state: 'home' };
	     * })
	     * ```
	     *
	     * @param handler The initial state or url path, or a function which returns the state or url path (or performs custom logic).
	     */
	    UrlRules.prototype.initial = function (handler) {
	        var handlerFn = getHandlerFn(handler);
	        var matchFn = function (urlParts, router) {
	            return router.globals.transitionHistory.size() === 0 && !!/^\/?$/.exec(urlParts.path);
	        };
	        this.rule(this.urlRuleFactory.create(matchFn, handlerFn));
	    };
	    /**
	     * Defines the state, url, or behavior to use when no other rule matches the URL.
	     *
	     * This rule is matched when *no other rule* matches.
	     * It is generally used to handle unknown URLs (similar to "404" behavior, but on the client side).
	     *
	     * - If `handler` a string, it is treated as a url redirect
	     *
	     * #### Example:
	     * When no other url rule matches, redirect to `/index`
	     * ```js
	     * .otherwise('/index');
	     * ```
	     *
	     * - If `handler` is an object with a `state` property, the state is activated.
	     *
	     * #### Example:
	     * When no other url rule matches, redirect to `home` and provide a `dashboard` parameter value.
	     * ```js
	     * .otherwise({ state: 'home', params: { dashboard: 'default' } });
	     * ```
	     *
	     * - If `handler` is a function, the function receives the current url ([[UrlParts]]) and the [[UIRouter]] object.
	     *   The function can perform actions, and/or return a value.
	     *
	     * #### Example:
	     * When no other url rule matches, manually trigger a transition to the `home` state
	     * ```js
	     * .otherwise((matchValue, urlParts, router) => {
	     *   router.stateService.go('home');
	     * });
	     * ```
	     *
	     * #### Example:
	     * When no other url rule matches, go to `home` state
	     * ```js
	     * .otherwise((matchValue, urlParts, router) => {
	     *   return { state: 'home' };
	     * });
	     * ```
	     *
	     * @param handler The url path to redirect to, or a function which returns the url path (or performs custom logic).
	     */
	    UrlRules.prototype.otherwise = function (handler) {
	        var handlerFn = getHandlerFn(handler);
	        this._otherwiseFn = this.urlRuleFactory.create(common_1.val(true), handlerFn);
	        this._sorted = false;
	    };
	    /**
	     * Remove a rule previously registered
	     *
	     * @param rule the matcher rule that was previously registered using [[rule]]
	     */
	    UrlRules.prototype.removeRule = function (rule) {
	        common_1.removeFrom(this._rules, rule);
	    };
	    /**
	     * Manually adds a URL Rule.
	     *
	     * Usually, a url rule is added using [[StateDeclaration.url]] or [[when]].
	     * This api can be used directly for more control (to register a [[BaseUrlRule]], for example).
	     * Rules can be created using [[urlRuleFactory]], or created manually as simple objects.
	     *
	     * A rule should have a `match` function which returns truthy if the rule matched.
	     * It should also have a `handler` function which is invoked if the rule is the best match.
	     *
	     * @return a function that deregisters the rule
	     */
	    UrlRules.prototype.rule = function (rule) {
	        var _this = this;
	        if (!urlRule_1.UrlRuleFactory.isUrlRule(rule))
	            throw new Error('invalid rule');
	        rule.$id = this._id++;
	        rule.priority = rule.priority || 0;
	        this._rules.push(rule);
	        this._sorted = false;
	        return function () { return _this.removeRule(rule); };
	    };
	    /**
	     * Gets all registered rules
	     *
	     * @returns an array of all the registered rules
	     */
	    UrlRules.prototype.rules = function () {
	        this.ensureSorted();
	        return this._rules.concat(this._otherwiseFn ? [this._otherwiseFn] : []);
	    };
	    /**
	     * Defines URL Rule priorities
	     *
	     * More than one rule ([[UrlRule]]) might match a given URL.
	     * This `compareFn` is used to sort the rules by priority.
	     * Higher priority rules should sort earlier.
	     *
	     * The [[defaultRuleSortFn]] is used by default.
	     *
	     * You only need to call this function once.
	     * The `compareFn` will be used to sort the rules as each is registered.
	     *
	     * If called without any parameter, it will re-sort the rules.
	     *
	     * ---
	     *
	     * Url rules may come from multiple sources: states's urls ([[StateDeclaration.url]]), [[when]], and [[rule]].
	     * Each rule has a (user-provided) [[UrlRule.priority]], a [[UrlRule.type]], and a [[UrlRule.$id]]
	     * The `$id` is is the order in which the rule was registered.
	     *
	     * The sort function should use these data, or data found on a specific type
	     * of [[UrlRule]] (such as [[StateRule.state]]), to order the rules as desired.
	     *
	     * #### Example:
	     * This compare function prioritizes rules by the order in which the rules were registered.
	     * A rule registered earlier has higher priority.
	     *
	     * ```js
	     * function compareFn(a, b) {
	     *   return a.$id - b.$id;
	     * }
	     * ```
	     *
	     * @param compareFn a function that compares to [[UrlRule]] objects.
	     *    The `compareFn` should abide by the `Array.sort` compare function rules.
	     *    Given two rules, `a` and `b`, return a negative number if `a` should be higher priority.
	     *    Return a positive number if `b` should be higher priority.
	     *    Return `0` if the rules are identical.
	     *
	     *    See the [mozilla reference](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/sort#Description)
	     *    for details.
	     */
	    UrlRules.prototype.sort = function (compareFn) {
	        var sorted = this.stableSort(this._rules, (this._sortFn = compareFn || this._sortFn));
	        // precompute _sortGroup values and apply to each rule
	        var group = 0;
	        for (var i = 0; i < sorted.length; i++) {
	            sorted[i]._group = group;
	            if (i < sorted.length - 1 && this._sortFn(sorted[i], sorted[i + 1]) !== 0) {
	                group++;
	            }
	        }
	        this._rules = sorted;
	        this._sorted = true;
	    };
	    /** @internal */
	    UrlRules.prototype.ensureSorted = function () {
	        this._sorted || this.sort();
	    };
	    /** @internal */
	    UrlRules.prototype.stableSort = function (arr, compareFn) {
	        var arrOfWrapper = arr.map(function (elem, idx) { return ({ elem: elem, idx: idx }); });
	        arrOfWrapper.sort(function (wrapperA, wrapperB) {
	            var cmpDiff = compareFn(wrapperA.elem, wrapperB.elem);
	            return cmpDiff === 0 ? wrapperA.idx - wrapperB.idx : cmpDiff;
	        });
	        return arrOfWrapper.map(function (wrapper) { return wrapper.elem; });
	    };
	    /**
	     * Registers a `matcher` and `handler` for custom URLs handling.
	     *
	     * The `matcher` can be:
	     *
	     * - a [[UrlMatcher]]: See: [[UrlMatcherFactory.compile]]
	     * - a `string`: The string is compiled to a [[UrlMatcher]]
	     * - a `RegExp`: The regexp is used to match the url.
	     *
	     * The `handler` can be:
	     *
	     * - a string: The url is redirected to the value of the string.
	     * - a function: The url is redirected to the return value of the function.
	     *
	     * ---
	     *
	     * When the `handler` is a `string` and the `matcher` is a `UrlMatcher` (or string), the redirect
	     * string is interpolated with parameter values.
	     *
	     * #### Example:
	     * When the URL is `/foo/123` the rule will redirect to `/bar/123`.
	     * ```js
	     * .when("/foo/:param1", "/bar/:param1")
	     * ```
	     *
	     * ---
	     *
	     * When the `handler` is a string and the `matcher` is a `RegExp`, the redirect string is
	     * interpolated with capture groups from the RegExp.
	     *
	     * #### Example:
	     * When the URL is `/foo/123` the rule will redirect to `/bar/123`.
	     * ```js
	     * .when(new RegExp("^/foo/(.*)$"), "/bar/$1");
	     * ```
	     *
	     * ---
	     *
	     * When the handler is a function, it receives the matched value, the current URL, and the `UIRouter` object (See [[UrlRuleHandlerFn]]).
	     * The "matched value" differs based on the `matcher`.
	     * For [[UrlMatcher]]s, it will be the matched state params.
	     * For `RegExp`, it will be the match array from `regexp.exec()`.
	     *
	     * If the handler returns a string, the URL is redirected to the string.
	     *
	     * #### Example:
	     * When the URL is `/foo/123` the rule will redirect to `/bar/123`.
	     * ```js
	     * .when(new RegExp("^/foo/(.*)$"), match => "/bar/" + match[1]);
	     * ```
	     *
	     * Note: the `handler` may also invoke arbitrary code, such as `$state.go()`
	     *
	     * @param matcher A pattern `string` to match, compiled as a [[UrlMatcher]], or a `RegExp`.
	     * @param handler The path to redirect to, or a function that returns the path.
	     * @param options `{ priority: number }`
	     *
	     * @return the registered [[UrlRule]]
	     */
	    UrlRules.prototype.when = function (matcher, handler, options) {
	        var rule = this.urlRuleFactory.create(matcher, handler);
	        if (common_1.isDefined(options && options.priority))
	            rule.priority = options.priority;
	        this.rule(rule);
	        return rule;
	    };
	    return UrlRules;
	}());
	exports.UrlRules = UrlRules;
	//# sourceMappingURL=urlRules.js.map

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.UrlService = void 0;
	var common_1 = __webpack_require__(4);
	var urlRules_1 = __webpack_require__(65);
	var urlConfig_1 = __webpack_require__(62);
	var state_1 = __webpack_require__(37);
	/**
	 * API for URL management
	 */
	var UrlService = /** @class */ (function () {
	    /** @internal */
	    function UrlService(/** @internal */ router) {
	        var _this = this;
	        this.router = router;
	        /** @internal */ this.interceptDeferred = false;
	        /**
	         * The nested [[UrlRules]] API for managing URL rules and rewrites
	         *
	         * See: [[UrlRules]] for details
	         */
	        this.rules = new urlRules_1.UrlRules(this.router);
	        /**
	         * The nested [[UrlConfig]] API to configure the URL and retrieve URL information
	         *
	         * See: [[UrlConfig]] for details
	         */
	        this.config = new urlConfig_1.UrlConfig(this.router);
	        // Delegate these calls to the current LocationServices implementation
	        /**
	         * Gets the current url, or updates the url
	         *
	         * ### Getting the current URL
	         *
	         * When no arguments are passed, returns the current URL.
	         * The URL is normalized using the internal [[path]]/[[search]]/[[hash]] values.
	         *
	         * For example, the URL may be stored in the hash ([[HashLocationServices]]) or
	         * have a base HREF prepended ([[PushStateLocationServices]]).
	         *
	         * The raw URL in the browser might be:
	         *
	         * ```
	         * http://mysite.com/somepath/index.html#/internal/path/123?param1=foo#anchor
	         * ```
	         *
	         * or
	         *
	         * ```
	         * http://mysite.com/basepath/internal/path/123?param1=foo#anchor
	         * ```
	         *
	         * then this method returns:
	         *
	         * ```
	         * /internal/path/123?param1=foo#anchor
	         * ```
	         *
	         *
	         * #### Example:
	         * ```js
	         * locationServices.url(); // "/some/path?query=value#anchor"
	         * ```
	         *
	         * ### Updating the URL
	         *
	         * When `newurl` arguments is provided, changes the URL to reflect `newurl`
	         *
	         * #### Example:
	         * ```js
	         * locationServices.url("/some/path?query=value#anchor", true);
	         * ```
	         *
	         * @param newurl The new value for the URL.
	         *               This url should reflect only the new internal [[path]], [[search]], and [[hash]] values.
	         *               It should not include the protocol, site, port, or base path of an absolute HREF.
	         * @param replace When true, replaces the current history entry (instead of appending it) with this new url
	         * @param state The history's state object, i.e., pushState (if the LocationServices implementation supports it)
	         *
	         * @return the url (after potentially being processed)
	         */
	        this.url = function (newurl, replace, state) {
	            return _this.router.locationService.url(newurl, replace, state);
	        };
	        /**
	         * Gets the path part of the current url
	         *
	         * If the current URL is `/some/path?query=value#anchor`, this returns `/some/path`
	         *
	         * @return the path portion of the url
	         */
	        this.path = function () { return _this.router.locationService.path(); };
	        /**
	         * Gets the search part of the current url as an object
	         *
	         * If the current URL is `/some/path?query=value#anchor`, this returns `{ query: 'value' }`
	         *
	         * @return the search (query) portion of the url, as an object
	         */
	        this.search = function () { return _this.router.locationService.search(); };
	        /**
	         * Gets the hash part of the current url
	         *
	         * If the current URL is `/some/path?query=value#anchor`, this returns `anchor`
	         *
	         * @return the hash (anchor) portion of the url
	         */
	        this.hash = function () { return _this.router.locationService.hash(); };
	        /**
	         * @internal
	         *
	         * Registers a low level url change handler
	         *
	         * Note: Because this is a low level handler, it's not recommended for general use.
	         *
	         * #### Example:
	         * ```js
	         * let deregisterFn = locationServices.onChange((evt) => console.log("url change", evt));
	         * ```
	         *
	         * @param callback a function that will be called when the url is changing
	         * @return a function that de-registers the callback
	         */
	        this.onChange = function (callback) { return _this.router.locationService.onChange(callback); };
	    }
	    /** @internal */
	    UrlService.prototype.dispose = function () {
	        this.listen(false);
	        this.rules.dispose();
	    };
	    /**
	     * Gets the current URL parts
	     *
	     * This method returns the different parts of the current URL (the [[path]], [[search]], and [[hash]]) as a [[UrlParts]] object.
	     */
	    UrlService.prototype.parts = function () {
	        return { path: this.path(), search: this.search(), hash: this.hash() };
	    };
	    /**
	     * Activates the best rule for the current URL
	     *
	     * Checks the current URL for a matching [[UrlRule]], then invokes that rule's handler.
	     * This method is called internally any time the URL has changed.
	     *
	     * This effectively activates the state (or redirect, etc) which matches the current URL.
	     *
	     * #### Example:
	     * ```js
	     * urlService.deferIntercept();
	     *
	     * fetch('/states.json').then(resp => resp.json()).then(data => {
	     *   data.forEach(state => $stateRegistry.register(state));
	     *   urlService.listen();
	     *   // Find the matching URL and invoke the handler.
	     *   urlService.sync();
	     * });
	     * ```
	     */
	    UrlService.prototype.sync = function (evt) {
	        if (evt && evt.defaultPrevented)
	            return;
	        var _a = this.router, urlService = _a.urlService, stateService = _a.stateService;
	        var url = { path: urlService.path(), search: urlService.search(), hash: urlService.hash() };
	        var best = this.match(url);
	        var applyResult = common_1.pattern([
	            [common_1.isString, function (newurl) { return urlService.url(newurl, true); }],
	            [state_1.TargetState.isDef, function (def) { return stateService.go(def.state, def.params, def.options); }],
	            [common_1.is(state_1.TargetState), function (target) { return stateService.go(target.state(), target.params(), target.options()); }],
	        ]);
	        applyResult(best && best.rule.handler(best.match, url, this.router));
	    };
	    /**
	     * Starts or stops listening for URL changes
	     *
	     * Call this sometime after calling [[deferIntercept]] to start monitoring the url.
	     * This causes UI-Router to start listening for changes to the URL, if it wasn't already listening.
	     *
	     * If called with `false`, UI-Router will stop listening (call listen(true) to start listening again).
	     *
	     * #### Example:
	     * ```js
	     * urlService.deferIntercept();
	     *
	     * fetch('/states.json').then(resp => resp.json()).then(data => {
	     *   data.forEach(state => $stateRegistry.register(state));
	     *   // Start responding to URL changes
	     *   urlService.listen();
	     *   urlService.sync();
	     * });
	     * ```
	     *
	     * @param enabled `true` or `false` to start or stop listening to URL changes
	     */
	    UrlService.prototype.listen = function (enabled) {
	        var _this = this;
	        if (enabled === false) {
	            this._stopListeningFn && this._stopListeningFn();
	            delete this._stopListeningFn;
	        }
	        else {
	            return (this._stopListeningFn =
	                this._stopListeningFn || this.router.urlService.onChange(function (evt) { return _this.sync(evt); }));
	        }
	    };
	    /**
	     * Disables monitoring of the URL.
	     *
	     * Call this method before UI-Router has bootstrapped.
	     * It will stop UI-Router from performing the initial url sync.
	     *
	     * This can be useful to perform some asynchronous initialization before the router starts.
	     * Once the initialization is complete, call [[listen]] to tell UI-Router to start watching and synchronizing the URL.
	     *
	     * #### Example:
	     * ```js
	     * // Prevent UI-Router from automatically intercepting URL changes when it starts;
	     * urlService.deferIntercept();
	     *
	     * fetch('/states.json').then(resp => resp.json()).then(data => {
	     *   data.forEach(state => $stateRegistry.register(state));
	     *   urlService.listen();
	     *   urlService.sync();
	     * });
	     * ```
	     *
	     * @param defer Indicates whether to defer location change interception.
	     *        Passing no parameter is equivalent to `true`.
	     */
	    UrlService.prototype.deferIntercept = function (defer) {
	        if (defer === undefined)
	            defer = true;
	        this.interceptDeferred = defer;
	    };
	    /**
	     * Matches a URL
	     *
	     * Given a URL (as a [[UrlParts]] object), check all rules and determine the best matching rule.
	     * Return the result as a [[MatchResult]].
	     */
	    UrlService.prototype.match = function (url) {
	        var _this = this;
	        url = common_1.extend({ path: '', search: {}, hash: '' }, url);
	        var rules = this.rules.rules();
	        // Checks a single rule. Returns { rule: rule, match: match, weight: weight } if it matched, or undefined
	        var checkRule = function (rule) {
	            var match = rule.match(url, _this.router);
	            return match && { match: match, rule: rule, weight: rule.matchPriority(match) };
	        };
	        // The rules are pre-sorted.
	        // - Find the first matching rule.
	        // - Find any other matching rule that sorted *exactly the same*, according to `.sort()`.
	        // - Choose the rule with the highest match weight.
	        var best;
	        for (var i = 0; i < rules.length; i++) {
	            // Stop when there is a 'best' rule and the next rule sorts differently than it.
	            if (best && best.rule._group !== rules[i]._group)
	                break;
	            var current = checkRule(rules[i]);
	            // Pick the best MatchResult
	            best = !best || (current && current.weight > best.weight) ? current : best;
	        }
	        return best;
	    };
	    return UrlService;
	}());
	exports.UrlService = UrlService;
	//# sourceMappingURL=urlService.js.map

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.BrowserLocationConfig = void 0;
	var predicates_1 = __webpack_require__(2);
	/** A `LocationConfig` that delegates to the browser's `location` object */
	var BrowserLocationConfig = /** @class */ (function () {
	    function BrowserLocationConfig(router, _isHtml5) {
	        if (_isHtml5 === void 0) { _isHtml5 = false; }
	        this._isHtml5 = _isHtml5;
	        this._baseHref = undefined;
	        this._hashPrefix = '';
	    }
	    BrowserLocationConfig.prototype.port = function () {
	        if (location.port) {
	            return Number(location.port);
	        }
	        return this.protocol() === 'https' ? 443 : 80;
	    };
	    BrowserLocationConfig.prototype.protocol = function () {
	        return location.protocol.replace(/:/g, '');
	    };
	    BrowserLocationConfig.prototype.host = function () {
	        return location.hostname;
	    };
	    BrowserLocationConfig.prototype.html5Mode = function () {
	        return this._isHtml5;
	    };
	    BrowserLocationConfig.prototype.hashPrefix = function (newprefix) {
	        return predicates_1.isDefined(newprefix) ? (this._hashPrefix = newprefix) : this._hashPrefix;
	    };
	    BrowserLocationConfig.prototype.baseHref = function (href) {
	        if (predicates_1.isDefined(href))
	            this._baseHref = href;
	        if (predicates_1.isUndefined(this._baseHref))
	            this._baseHref = this.getBaseHref();
	        return this._baseHref;
	    };
	    BrowserLocationConfig.prototype.getBaseHref = function () {
	        var baseTag = document.getElementsByTagName('base')[0];
	        if (baseTag && baseTag.href) {
	            return baseTag.href.replace(/^([^/:]*:)?\/\/[^/]*/, '');
	        }
	        return this._isHtml5 ? '/' : location.pathname || '/';
	    };
	    BrowserLocationConfig.prototype.dispose = function () { };
	    return BrowserLocationConfig;
	}());
	exports.BrowserLocationConfig = BrowserLocationConfig;
	//# sourceMappingURL=browserLocationConfig.js.map

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.HashLocationService = void 0;
	var common_1 = __webpack_require__(4);
	var baseLocationService_1 = __webpack_require__(24);
	/** A `LocationServices` that uses the browser hash "#" to get/set the current location */
	var HashLocationService = /** @class */ (function (_super) {
	    __extends(HashLocationService, _super);
	    function HashLocationService(router) {
	        var _this = _super.call(this, router, false) || this;
	        common_1.root.addEventListener('hashchange', _this._listener, false);
	        return _this;
	    }
	    HashLocationService.prototype._get = function () {
	        return common_1.trimHashVal(this._location.hash);
	    };
	    HashLocationService.prototype._set = function (state, title, url, replace) {
	        this._location.hash = url;
	    };
	    HashLocationService.prototype.dispose = function (router) {
	        _super.prototype.dispose.call(this, router);
	        common_1.root.removeEventListener('hashchange', this._listener);
	    };
	    return HashLocationService;
	}(baseLocationService_1.BaseLocationServices));
	exports.HashLocationService = HashLocationService;
	//# sourceMappingURL=hashLocationService.js.map

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.$injector = void 0;
	var index_1 = __webpack_require__(4);
	// globally available injectables
	var globals = {};
	var STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/gm;
	var ARGUMENT_NAMES = /([^\s,]+)/g;
	/**
	 * A basic angular1-like injector api
	 *
	 * This object implements four methods similar to the
	 * [angular 1 dependency injector](https://docs.angularjs.org/api/auto/service/$injector)
	 *
	 * UI-Router evolved from an angular 1 library to a framework agnostic library.
	 * However, some of the `@uirouter/core` code uses these ng1 style APIs to support ng1 style dependency injection.
	 *
	 * This object provides a naive implementation of a globally scoped dependency injection system.
	 * It supports the following DI approaches:
	 *
	 * ### Function parameter names
	 *
	 * A function's `.toString()` is called, and the parameter names are parsed.
	 * This only works when the parameter names aren't "mangled" by a minifier such as UglifyJS.
	 *
	 * ```js
	 * function injectedFunction(FooService, BarService) {
	 *   // FooService and BarService are injected
	 * }
	 * ```
	 *
	 * ### Function annotation
	 *
	 * A function may be annotated with an array of dependency names as the `$inject` property.
	 *
	 * ```js
	 * injectedFunction.$inject = [ 'FooService', 'BarService' ];
	 * function injectedFunction(fs, bs) {
	 *   // FooService and BarService are injected as fs and bs parameters
	 * }
	 * ```
	 *
	 * ### Array notation
	 *
	 * An array provides the names of the dependencies to inject (as strings).
	 * The function is the last element of the array.
	 *
	 * ```js
	 * [ 'FooService', 'BarService', function (fs, bs) {
	 *   // FooService and BarService are injected as fs and bs parameters
	 * }]
	 * ```
	 *
	 * @type {$InjectorLike}
	 */
	exports.$injector = {
	    /** Gets an object from DI based on a string token */
	    get: function (name) { return globals[name]; },
	    /** Returns true if an object named `name` exists in global DI */
	    has: function (name) { return exports.$injector.get(name) != null; },
	    /**
	     * Injects a function
	     *
	     * @param fn the function to inject
	     * @param context the function's `this` binding
	     * @param locals An object with additional DI tokens and values, such as `{ someToken: { foo: 1 } }`
	     */
	    invoke: function (fn, context, locals) {
	        var all = index_1.extend({}, globals, locals || {});
	        var params = exports.$injector.annotate(fn);
	        var ensureExist = index_1.assertPredicate(function (key) { return all.hasOwnProperty(key); }, function (key) { return "DI can't find injectable: '" + key + "'"; });
	        var args = params.filter(ensureExist).map(function (x) { return all[x]; });
	        if (index_1.isFunction(fn))
	            return fn.apply(context, args);
	        else
	            return fn.slice(-1)[0].apply(context, args);
	    },
	    /**
	     * Returns a function's dependencies
	     *
	     * Analyzes a function (or array) and returns an array of DI tokens that the function requires.
	     * @return an array of `string`s
	     */
	    annotate: function (fn) {
	        if (!index_1.isInjectable(fn))
	            throw new Error("Not an injectable function: " + fn);
	        if (fn && fn.$inject)
	            return fn.$inject;
	        if (index_1.isArray(fn))
	            return fn.slice(0, -1);
	        var fnStr = fn.toString().replace(STRIP_COMMENTS, '');
	        var result = fnStr.slice(fnStr.indexOf('(') + 1, fnStr.indexOf(')')).match(ARGUMENT_NAMES);
	        return result || [];
	    },
	};
	//# sourceMappingURL=injector.js.map

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.MemoryLocationConfig = void 0;
	var predicates_1 = __webpack_require__(2);
	var common_1 = __webpack_require__(1);
	/** A `LocationConfig` mock that gets/sets all config from an in-memory object */
	var MemoryLocationConfig = /** @class */ (function () {
	    function MemoryLocationConfig() {
	        var _this = this;
	        this.dispose = common_1.noop;
	        this._baseHref = '';
	        this._port = 80;
	        this._protocol = 'http';
	        this._host = 'localhost';
	        this._hashPrefix = '';
	        this.port = function () { return _this._port; };
	        this.protocol = function () { return _this._protocol; };
	        this.host = function () { return _this._host; };
	        this.baseHref = function () { return _this._baseHref; };
	        this.html5Mode = function () { return false; };
	        this.hashPrefix = function (newval) { return (predicates_1.isDefined(newval) ? (_this._hashPrefix = newval) : _this._hashPrefix); };
	    }
	    return MemoryLocationConfig;
	}());
	exports.MemoryLocationConfig = MemoryLocationConfig;
	//# sourceMappingURL=memoryLocationConfig.js.map

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.MemoryLocationService = void 0;
	var baseLocationService_1 = __webpack_require__(24);
	/** A `LocationServices` that gets/sets the current location from an in-memory object */
	var MemoryLocationService = /** @class */ (function (_super) {
	    __extends(MemoryLocationService, _super);
	    function MemoryLocationService(router) {
	        return _super.call(this, router, true) || this;
	    }
	    MemoryLocationService.prototype._get = function () {
	        return this._url;
	    };
	    MemoryLocationService.prototype._set = function (state, title, url, replace) {
	        this._url = url;
	    };
	    return MemoryLocationService;
	}(baseLocationService_1.BaseLocationServices));
	exports.MemoryLocationService = MemoryLocationService;
	//# sourceMappingURL=memoryLocationService.js.map

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.PushStateLocationService = void 0;
	var baseLocationService_1 = __webpack_require__(24);
	var common_1 = __webpack_require__(4);
	/**
	 * A `LocationServices` that gets/sets the current location using the browser's `location` and `history` apis
	 *
	 * Uses `history.pushState` and `history.replaceState`
	 */
	var PushStateLocationService = /** @class */ (function (_super) {
	    __extends(PushStateLocationService, _super);
	    function PushStateLocationService(router) {
	        var _this = _super.call(this, router, true) || this;
	        _this._config = router.urlService.config;
	        common_1.root.addEventListener('popstate', _this._listener, false);
	        return _this;
	    }
	    /**
	     * Gets the base prefix without:
	     * - trailing slash
	     * - trailing filename
	     * - protocol and hostname
	     *
	     * If <base href='/base/'>, this returns '/base'.
	     * If <base href='/foo/base/'>, this returns '/foo/base'.
	     * If <base href='/base/index.html'>, this returns '/base'.
	     * If <base href='http://localhost:8080/base/index.html'>, this returns '/base'.
	     * If <base href='/base'>, this returns ''.
	     * If <base href='http://localhost:8080'>, this returns ''.
	     * If <base href='http://localhost:8080/'>, this returns ''.
	     *
	     * See: https://html.spec.whatwg.org/dev/semantics.html#the-base-element
	     */
	    PushStateLocationService.prototype._getBasePrefix = function () {
	        return common_1.stripLastPathElement(this._config.baseHref());
	    };
	    PushStateLocationService.prototype._get = function () {
	        var _a = this._location, pathname = _a.pathname, hash = _a.hash, search = _a.search;
	        search = common_1.splitQuery(search)[1]; // strip ? if found
	        hash = common_1.splitHash(hash)[1]; // strip # if found
	        var basePrefix = this._getBasePrefix();
	        var exactBaseHrefMatch = pathname === this._config.baseHref();
	        var startsWithBase = pathname.substr(0, basePrefix.length) === basePrefix;
	        pathname = exactBaseHrefMatch ? '/' : startsWithBase ? pathname.substring(basePrefix.length) : pathname;
	        return pathname + (search ? '?' + search : '') + (hash ? '#' + hash : '');
	    };
	    PushStateLocationService.prototype._set = function (state, title, url, replace) {
	        var basePrefix = this._getBasePrefix();
	        var slash = url && url[0] !== '/' ? '/' : '';
	        var fullUrl = url === '' || url === '/' ? this._config.baseHref() : basePrefix + slash + url;
	        if (replace) {
	            this._history.replaceState(state, title, fullUrl);
	        }
	        else {
	            this._history.pushState(state, title, fullUrl);
	        }
	    };
	    PushStateLocationService.prototype.dispose = function (router) {
	        _super.prototype.dispose.call(this, router);
	        common_1.root.removeEventListener('popstate', this._listener);
	    };
	    return PushStateLocationService;
	}(baseLocationService_1.BaseLocationServices));
	exports.PushStateLocationService = PushStateLocationService;
	//# sourceMappingURL=pushStateLocationService.js.map

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.$q = void 0;
	var index_1 = __webpack_require__(4);
	/**
	 * An angular1-like promise api
	 *
	 * This object implements four methods similar to the
	 * [angular 1 promise api](https://docs.angularjs.org/api/ng/service/$q)
	 *
	 * UI-Router evolved from an angular 1 library to a framework agnostic library.
	 * However, some of the `@uirouter/core` code uses these ng1 style APIs to support ng1 style dependency injection.
	 *
	 * This API provides native ES6 promise support wrapped as a $q-like API.
	 * Internally, UI-Router uses this $q object to perform promise operations.
	 * The `angular-ui-router` (ui-router for angular 1) uses the $q API provided by angular.
	 *
	 * $q-like promise api
	 */
	exports.$q = {
	    /** Normalizes a value as a promise */
	    when: function (val) { return new Promise(function (resolve, reject) { return resolve(val); }); },
	    /** Normalizes a value as a promise rejection */
	    reject: function (val) {
	        return new Promise(function (resolve, reject) {
	            reject(val);
	        });
	    },
	    /** @returns a deferred object, which has `resolve` and `reject` functions */
	    defer: function () {
	        var deferred = {};
	        deferred.promise = new Promise(function (resolve, reject) {
	            deferred.resolve = resolve;
	            deferred.reject = reject;
	        });
	        return deferred;
	    },
	    /** Like Promise.all(), but also supports object key/promise notation like $q */
	    all: function (promises) {
	        if (index_1.isArray(promises)) {
	            return Promise.all(promises);
	        }
	        if (index_1.isObject(promises)) {
	            // Convert promises map to promises array.
	            // When each promise resolves, map it to a tuple { key: key, val: val }
	            var chain = Object.keys(promises).map(function (key) { return promises[key].then(function (val) { return ({ key: key, val: val }); }); });
	            // Then wait for all promises to resolve, and convert them back to an object
	            return exports.$q.all(chain).then(function (values) {
	                return values.reduce(function (acc, tuple) {
	                    acc[tuple.key] = tuple.val;
	                    return acc;
	                }, {});
	            });
	        }
	    },
	};
	//# sourceMappingURL=q.js.map

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ViewService = void 0;
	var common_1 = __webpack_require__(1);
	var hof_1 = __webpack_require__(3);
	var predicates_1 = __webpack_require__(2);
	var trace_1 = __webpack_require__(8);
	/**
	 * The View service
	 *
	 * This service pairs existing `ui-view` components (which live in the DOM)
	 * with view configs (from the state declaration objects: [[StateDeclaration.views]]).
	 *
	 * - After a successful Transition, the views from the newly entered states are activated via [[activateViewConfig]].
	 *   The views from exited states are deactivated via [[deactivateViewConfig]].
	 *   (See: the [[registerActivateViews]] Transition Hook)
	 *
	 * - As `ui-view` components pop in and out of existence, they register themselves using [[registerUIView]].
	 *
	 * - When the [[sync]] function is called, the registered `ui-view`(s) ([[ActiveUIView]])
	 * are configured with the matching [[ViewConfig]](s)
	 *
	 */
	var ViewService = /** @class */ (function () {
	    /** @internal */
	    function ViewService(/** @internal */ router) {
	        var _this = this;
	        this.router = router;
	        /** @internal */ this._uiViews = [];
	        /** @internal */ this._viewConfigs = [];
	        /** @internal */ this._viewConfigFactories = {};
	        /** @internal */ this._listeners = [];
	        /** @internal */
	        this._pluginapi = {
	            _rootViewContext: this._rootViewContext.bind(this),
	            _viewConfigFactory: this._viewConfigFactory.bind(this),
	            _registeredUIView: function (id) { return common_1.find(_this._uiViews, function (view) { return _this.router.$id + "." + view.id === id; }); },
	            _registeredUIViews: function () { return _this._uiViews; },
	            _activeViewConfigs: function () { return _this._viewConfigs; },
	            _onSync: function (listener) {
	                _this._listeners.push(listener);
	                return function () { return common_1.removeFrom(_this._listeners, listener); };
	            },
	        };
	    }
	    /**
	     * Normalizes a view's name from a state.views configuration block.
	     *
	     * This should be used by a framework implementation to calculate the values for
	     * [[_ViewDeclaration.$uiViewName]] and [[_ViewDeclaration.$uiViewContextAnchor]].
	     *
	     * @param context the context object (state declaration) that the view belongs to
	     * @param rawViewName the name of the view, as declared in the [[StateDeclaration.views]]
	     *
	     * @returns the normalized uiViewName and uiViewContextAnchor that the view targets
	     */
	    ViewService.normalizeUIViewTarget = function (context, rawViewName) {
	        if (rawViewName === void 0) { rawViewName = ''; }
	        // TODO: Validate incoming view name with a regexp to allow:
	        // ex: "view.name@foo.bar" , "^.^.view.name" , "view.name@^.^" , "" ,
	        // "@" , "$default@^" , "!$default.$default" , "!foo.bar"
	        var viewAtContext = rawViewName.split('@');
	        var uiViewName = viewAtContext[0] || '$default'; // default to unnamed view
	        var uiViewContextAnchor = predicates_1.isString(viewAtContext[1]) ? viewAtContext[1] : '^'; // default to parent context
	        // Handle relative view-name sugar syntax.
	        // Matches rawViewName "^.^.^.foo.bar" into array: ["^.^.^.foo.bar", "^.^.^", "foo.bar"],
	        var relativeViewNameSugar = /^(\^(?:\.\^)*)\.(.*$)/.exec(uiViewName);
	        if (relativeViewNameSugar) {
	            // Clobbers existing contextAnchor (rawViewName validation will fix this)
	            uiViewContextAnchor = relativeViewNameSugar[1]; // set anchor to "^.^.^"
	            uiViewName = relativeViewNameSugar[2]; // set view-name to "foo.bar"
	        }
	        if (uiViewName.charAt(0) === '!') {
	            uiViewName = uiViewName.substr(1);
	            uiViewContextAnchor = ''; // target absolutely from root
	        }
	        // handle parent relative targeting "^.^.^"
	        var relativeMatch = /^(\^(?:\.\^)*)$/;
	        if (relativeMatch.exec(uiViewContextAnchor)) {
	            var anchorState = uiViewContextAnchor.split('.').reduce(function (anchor, x) { return anchor.parent; }, context);
	            uiViewContextAnchor = anchorState.name;
	        }
	        else if (uiViewContextAnchor === '.') {
	            uiViewContextAnchor = context.name;
	        }
	        return { uiViewName: uiViewName, uiViewContextAnchor: uiViewContextAnchor };
	    };
	    /** @internal */
	    ViewService.prototype._rootViewContext = function (context) {
	        return (this._rootContext = context || this._rootContext);
	    };
	    /** @internal */
	    ViewService.prototype._viewConfigFactory = function (viewType, factory) {
	        this._viewConfigFactories[viewType] = factory;
	    };
	    ViewService.prototype.createViewConfig = function (path, decl) {
	        var cfgFactory = this._viewConfigFactories[decl.$type];
	        if (!cfgFactory)
	            throw new Error('ViewService: No view config factory registered for type ' + decl.$type);
	        var cfgs = cfgFactory(path, decl);
	        return predicates_1.isArray(cfgs) ? cfgs : [cfgs];
	    };
	    /**
	     * Deactivates a ViewConfig.
	     *
	     * This function deactivates a `ViewConfig`.
	     * After calling [[sync]], it will un-pair from any `ui-view` with which it is currently paired.
	     *
	     * @param viewConfig The ViewConfig view to deregister.
	     */
	    ViewService.prototype.deactivateViewConfig = function (viewConfig) {
	        trace_1.trace.traceViewServiceEvent('<- Removing', viewConfig);
	        common_1.removeFrom(this._viewConfigs, viewConfig);
	    };
	    ViewService.prototype.activateViewConfig = function (viewConfig) {
	        trace_1.trace.traceViewServiceEvent('-> Registering', viewConfig);
	        this._viewConfigs.push(viewConfig);
	    };
	    ViewService.prototype.sync = function () {
	        var _this = this;
	        var uiViewsByFqn = this._uiViews.map(function (uiv) { return [uiv.fqn, uiv]; }).reduce(common_1.applyPairs, {});
	        // Return a weighted depth value for a uiView.
	        // The depth is the nesting depth of ui-views (based on FQN; times 10,000)
	        // plus the depth of the state that is populating the uiView
	        function uiViewDepth(uiView) {
	            var stateDepth = function (context) { return (context && context.parent ? stateDepth(context.parent) + 1 : 1); };
	            return uiView.fqn.split('.').length * 10000 + stateDepth(uiView.creationContext);
	        }
	        // Return the ViewConfig's context's depth in the context tree.
	        function viewConfigDepth(config) {
	            var context = config.viewDecl.$context, count = 0;
	            while (++count && context.parent)
	                context = context.parent;
	            return count;
	        }
	        // Given a depth function, returns a compare function which can return either ascending or descending order
	        var depthCompare = hof_1.curry(function (depthFn, posNeg, left, right) { return posNeg * (depthFn(left) - depthFn(right)); });
	        var matchingConfigPair = function (uiView) {
	            var matchingConfigs = _this._viewConfigs.filter(ViewService.matches(uiViewsByFqn, uiView));
	            if (matchingConfigs.length > 1) {
	                // This is OK.  Child states can target a ui-view that the parent state also targets (the child wins)
	                // Sort by depth and return the match from the deepest child
	                // console.log(`Multiple matching view configs for ${uiView.fqn}`, matchingConfigs);
	                matchingConfigs.sort(depthCompare(viewConfigDepth, -1)); // descending
	            }
	            return { uiView: uiView, viewConfig: matchingConfigs[0] };
	        };
	        var configureUIView = function (tuple) {
	            // If a parent ui-view is reconfigured, it could destroy child ui-views.
	            // Before configuring a child ui-view, make sure it's still in the active uiViews array.
	            if (_this._uiViews.indexOf(tuple.uiView) !== -1)
	                tuple.uiView.configUpdated(tuple.viewConfig);
	        };
	        // Sort views by FQN and state depth. Process uiviews nearest the root first.
	        var uiViewTuples = this._uiViews.sort(depthCompare(uiViewDepth, 1)).map(matchingConfigPair);
	        var matchedViewConfigs = uiViewTuples.map(function (tuple) { return tuple.viewConfig; });
	        var unmatchedConfigTuples = this._viewConfigs
	            .filter(function (config) { return !common_1.inArray(matchedViewConfigs, config); })
	            .map(function (viewConfig) { return ({ uiView: undefined, viewConfig: viewConfig }); });
	        uiViewTuples.forEach(configureUIView);
	        var allTuples = uiViewTuples.concat(unmatchedConfigTuples);
	        this._listeners.forEach(function (cb) { return cb(allTuples); });
	        trace_1.trace.traceViewSync(allTuples);
	    };
	    /**
	     * Registers a `ui-view` component
	     *
	     * When a `ui-view` component is created, it uses this method to register itself.
	     * After registration the [[sync]] method is used to ensure all `ui-view` are configured with the proper [[ViewConfig]].
	     *
	     * Note: the `ui-view` component uses the `ViewConfig` to determine what view should be loaded inside the `ui-view`,
	     * and what the view's state context is.
	     *
	     * Note: There is no corresponding `deregisterUIView`.
	     *       A `ui-view` should hang on to the return value of `registerUIView` and invoke it to deregister itself.
	     *
	     * @param uiView The metadata for a UIView
	     * @return a de-registration function used when the view is destroyed.
	     */
	    ViewService.prototype.registerUIView = function (uiView) {
	        trace_1.trace.traceViewServiceUIViewEvent('-> Registering', uiView);
	        var uiViews = this._uiViews;
	        var fqnAndTypeMatches = function (uiv) { return uiv.fqn === uiView.fqn && uiv.$type === uiView.$type; };
	        if (uiViews.filter(fqnAndTypeMatches).length)
	            trace_1.trace.traceViewServiceUIViewEvent('!!!! duplicate uiView named:', uiView);
	        uiViews.push(uiView);
	        this.sync();
	        return function () {
	            var idx = uiViews.indexOf(uiView);
	            if (idx === -1) {
	                trace_1.trace.traceViewServiceUIViewEvent('Tried removing non-registered uiView', uiView);
	                return;
	            }
	            trace_1.trace.traceViewServiceUIViewEvent('<- Deregistering', uiView);
	            common_1.removeFrom(uiViews)(uiView);
	        };
	    };
	    /**
	     * Returns the list of views currently available on the page, by fully-qualified name.
	     *
	     * @return {Array} Returns an array of fully-qualified view names.
	     */
	    ViewService.prototype.available = function () {
	        return this._uiViews.map(hof_1.prop('fqn'));
	    };
	    /**
	     * Returns the list of views on the page containing loaded content.
	     *
	     * @return {Array} Returns an array of fully-qualified view names.
	     */
	    ViewService.prototype.active = function () {
	        return this._uiViews.filter(hof_1.prop('$config')).map(hof_1.prop('name'));
	    };
	    /**
	     * Given a ui-view and a ViewConfig, determines if they "match".
	     *
	     * A ui-view has a fully qualified name (fqn) and a context object.  The fqn is built from its overall location in
	     * the DOM, describing its nesting relationship to any parent ui-view tags it is nested inside of.
	     *
	     * A ViewConfig has a target ui-view name and a context anchor.  The ui-view name can be a simple name, or
	     * can be a segmented ui-view path, describing a portion of a ui-view fqn.
	     *
	     * In order for a ui-view to match ViewConfig, ui-view's $type must match the ViewConfig's $type
	     *
	     * If the ViewConfig's target ui-view name is a simple name (no dots), then a ui-view matches if:
	     * - the ui-view's name matches the ViewConfig's target name
	     * - the ui-view's context matches the ViewConfig's anchor
	     *
	     * If the ViewConfig's target ui-view name is a segmented name (with dots), then a ui-view matches if:
	     * - There exists a parent ui-view where:
	     *    - the parent ui-view's name matches the first segment (index 0) of the ViewConfig's target name
	     *    - the parent ui-view's context matches the ViewConfig's anchor
	     * - And the remaining segments (index 1..n) of the ViewConfig's target name match the tail of the ui-view's fqn
	     *
	     * Example:
	     *
	     * DOM:
	     * <ui-view>                        <!-- created in the root context (name: "") -->
	     *   <ui-view name="foo">                <!-- created in the context named: "A"      -->
	     *     <ui-view>                    <!-- created in the context named: "A.B"    -->
	     *       <ui-view name="bar">            <!-- created in the context named: "A.B.C"  -->
	     *       </ui-view>
	     *     </ui-view>
	     *   </ui-view>
	     * </ui-view>
	     *
	     * uiViews: [
	     *  { fqn: "$default",                  creationContext: { name: "" } },
	     *  { fqn: "$default.foo",              creationContext: { name: "A" } },
	     *  { fqn: "$default.foo.$default",     creationContext: { name: "A.B" } }
	     *  { fqn: "$default.foo.$default.bar", creationContext: { name: "A.B.C" } }
	     * ]
	     *
	     * These four view configs all match the ui-view with the fqn: "$default.foo.$default.bar":
	     *
	     * - ViewConfig1: { uiViewName: "bar",                       uiViewContextAnchor: "A.B.C" }
	     * - ViewConfig2: { uiViewName: "$default.bar",              uiViewContextAnchor: "A.B" }
	     * - ViewConfig3: { uiViewName: "foo.$default.bar",          uiViewContextAnchor: "A" }
	     * - ViewConfig4: { uiViewName: "$default.foo.$default.bar", uiViewContextAnchor: "" }
	     *
	     * Using ViewConfig3 as an example, it matches the ui-view with fqn "$default.foo.$default.bar" because:
	     * - The ViewConfig's segmented target name is: [ "foo", "$default", "bar" ]
	     * - There exists a parent ui-view (which has fqn: "$default.foo") where:
	     *    - the parent ui-view's name "foo" matches the first segment "foo" of the ViewConfig's target name
	     *    - the parent ui-view's context "A" matches the ViewConfig's anchor context "A"
	     * - And the remaining segments [ "$default", "bar" ].join("."_ of the ViewConfig's target name match
	     *   the tail of the ui-view's fqn "default.bar"
	     *
	     * @internal
	     */
	    ViewService.matches = function (uiViewsByFqn, uiView) { return function (viewConfig) {
	        // Don't supply an ng1 ui-view with an ng2 ViewConfig, etc
	        if (uiView.$type !== viewConfig.viewDecl.$type)
	            return false;
	        // Split names apart from both viewConfig and uiView into segments
	        var vc = viewConfig.viewDecl;
	        var vcSegments = vc.$uiViewName.split('.');
	        var uivSegments = uiView.fqn.split('.');
	        // Check if the tails of the segment arrays match. ex, these arrays' tails match:
	        // vc: ["foo", "bar"], uiv fqn: ["$default", "foo", "bar"]
	        if (!common_1.equals(vcSegments, uivSegments.slice(0 - vcSegments.length)))
	            return false;
	        // Now check if the fqn ending at the first segment of the viewConfig matches the context:
	        // ["$default", "foo"].join(".") == "$default.foo", does the ui-view $default.foo context match?
	        var negOffset = 1 - vcSegments.length || undefined;
	        var fqnToFirstSegment = uivSegments.slice(0, negOffset).join('.');
	        var uiViewContext = uiViewsByFqn[fqnToFirstSegment].creationContext;
	        return vc.$uiViewContextAnchor === (uiViewContext && uiViewContext.name);
	    }; };
	    return ViewService;
	}());
	exports.ViewService = ViewService;
	//# sourceMappingURL=view.js.map

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	* angular-formly JavaScript Library v8.4.1
	*
	* @license MIT (http://license.angular-formly.com)
	*
	* built with ♥ by Astrism <astrisms@gmail.com>, Kent C. Dodds <kent@doddsfamily.us>
	* (ó ì_í)=óò=(ì_í ò)
	*/
	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(9), __webpack_require__(76));
		else if(typeof define === 'function' && define.amd)
			define(["angular", "api-check"], factory);
		else if(typeof exports === 'object')
			exports["ngFormly"] = factory(require("angular"), require("api-check"));
		else
			root["ngFormly"] = factory(root["angular"], root["apiCheck"]);
	})(this, function(__WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_5__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var _indexCommon = __webpack_require__(1);
	
		var _indexCommon2 = _interopRequireDefault(_indexCommon);
	
		exports['default'] = _indexCommon2['default'];
		module.exports = exports['default'];
	
	/***/ },
	/* 1 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var _angularFix = __webpack_require__(2);
	
		var _angularFix2 = _interopRequireDefault(_angularFix);
	
		var _providersFormlyApiCheck = __webpack_require__(4);
	
		var _providersFormlyApiCheck2 = _interopRequireDefault(_providersFormlyApiCheck);
	
		var _otherDocsBaseUrl = __webpack_require__(6);
	
		var _otherDocsBaseUrl2 = _interopRequireDefault(_otherDocsBaseUrl);
	
		var _providersFormlyUsability = __webpack_require__(7);
	
		var _providersFormlyUsability2 = _interopRequireDefault(_providersFormlyUsability);
	
		var _providersFormlyConfig = __webpack_require__(8);
	
		var _providersFormlyConfig2 = _interopRequireDefault(_providersFormlyConfig);
	
		var _providersFormlyValidationMessages = __webpack_require__(10);
	
		var _providersFormlyValidationMessages2 = _interopRequireDefault(_providersFormlyValidationMessages);
	
		var _servicesFormlyUtil = __webpack_require__(11);
	
		var _servicesFormlyUtil2 = _interopRequireDefault(_servicesFormlyUtil);
	
		var _servicesFormlyWarn = __webpack_require__(12);
	
		var _servicesFormlyWarn2 = _interopRequireDefault(_servicesFormlyWarn);
	
		var _directivesFormlyCustomValidation = __webpack_require__(13);
	
		var _directivesFormlyCustomValidation2 = _interopRequireDefault(_directivesFormlyCustomValidation);
	
		var _directivesFormlyField = __webpack_require__(14);
	
		var _directivesFormlyField2 = _interopRequireDefault(_directivesFormlyField);
	
		var _directivesFormlyFocus = __webpack_require__(15);
	
		var _directivesFormlyFocus2 = _interopRequireDefault(_directivesFormlyFocus);
	
		var _directivesFormlyForm = __webpack_require__(16);
	
		var _directivesFormlyForm2 = _interopRequireDefault(_directivesFormlyForm);
	
		var _directivesFormlyFormController = __webpack_require__(17);
	
		var _directivesFormlyFormController2 = _interopRequireDefault(_directivesFormlyFormController);
	
		var _runFormlyNgModelAttrsManipulator = __webpack_require__(18);
	
		var _runFormlyNgModelAttrsManipulator2 = _interopRequireDefault(_runFormlyNgModelAttrsManipulator);
	
		var _runFormlyCustomTags = __webpack_require__(19);
	
		var _runFormlyCustomTags2 = _interopRequireDefault(_runFormlyCustomTags);
	
		var ngModuleName = 'formly';
	
		exports['default'] = ngModuleName;
	
		var ngModule = _angularFix2['default'].module(ngModuleName, []);
	
		ngModule.constant('formlyApiCheck', _providersFormlyApiCheck2['default']);
		ngModule.constant('formlyErrorAndWarningsUrlPrefix', _otherDocsBaseUrl2['default']);
		ngModule.constant('formlyVersion', ("8.4.1")); // <-- webpack variable
	
		ngModule.provider('formlyUsability', _providersFormlyUsability2['default']);
		ngModule.provider('formlyConfig', _providersFormlyConfig2['default']);
	
		ngModule.factory('formlyValidationMessages', _providersFormlyValidationMessages2['default']);
		ngModule.factory('formlyUtil', _servicesFormlyUtil2['default']);
		ngModule.factory('formlyWarn', _servicesFormlyWarn2['default']);
	
		ngModule.directive('formlyCustomValidation', _directivesFormlyCustomValidation2['default']);
		ngModule.directive('formlyField', _directivesFormlyField2['default']);
		ngModule.directive('formlyFocus', _directivesFormlyFocus2['default']);
		ngModule.directive('formlyForm', _directivesFormlyForm2['default']);
		ngModule.controller('FormlyFormController', _directivesFormlyFormController2['default']);
	
		ngModule.run(_runFormlyNgModelAttrsManipulator2['default']);
		ngModule.run(_runFormlyCustomTags2['default']);
		module.exports = exports['default'];
	
	/***/ },
	/* 2 */
	/***/ function(module, exports, __webpack_require__) {
	
		// some versions of angular don't export the angular module properly,
		// so we get it from window in this case.
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
		var angular = __webpack_require__(3);
	
		/* istanbul ignore next */
		if (!angular.version) {
		  angular = window.angular;
		}
		exports['default'] = angular;
		module.exports = exports['default'];
	
	/***/ },
	/* 3 */
	/***/ function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_3__;
	
	/***/ },
	/* 4 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var _angularFix = __webpack_require__(2);
	
		var _angularFix2 = _interopRequireDefault(_angularFix);
	
		var _apiCheck = __webpack_require__(5);
	
		var _apiCheck2 = _interopRequireDefault(_apiCheck);
	
		var apiCheck = (0, _apiCheck2['default'])({
		  output: {
		    prefix: 'angular-formly:',
		    docsBaseUrl: __webpack_require__(6)
		  }
		});
	
		function shapeRequiredIfNot(otherProps, propChecker) {
		  if (!_angularFix2['default'].isArray(otherProps)) {
		    otherProps = [otherProps];
		  }
		  var type = 'specified if these are not specified: `' + otherProps.join(', ') + '` (otherwise it\'s optional)';
	
		  function shapeRequiredIfNotDefinition(prop, propName, location, obj) {
		    var propExists = obj && obj.hasOwnProperty(propName);
		    var otherPropsExist = otherProps.some(function (otherProp) {
		      return obj && obj.hasOwnProperty(otherProp);
		    });
		    if (!otherPropsExist && !propExists) {
		      return apiCheck.utils.getError(propName, location, type);
		    } else if (propExists) {
		      return propChecker(prop, propName, location, obj);
		    }
		  }
	
		  shapeRequiredIfNotDefinition.type = type;
		  return apiCheck.utils.checkerHelpers.setupChecker(shapeRequiredIfNotDefinition);
		}
	
		var formlyExpression = apiCheck.oneOfType([apiCheck.string, apiCheck.func]);
		var specifyWrapperType = apiCheck.typeOrArrayOf(apiCheck.string).nullable;
	
		var apiCheckProperty = apiCheck.func;
	
		var apiCheckInstanceProperty = apiCheck.shape.onlyIf('apiCheck', apiCheck.func.withProperties({
		  warn: apiCheck.func,
		  'throw': apiCheck.func,
		  shape: apiCheck.func
		}));
	
		var apiCheckFunctionProperty = apiCheck.shape.onlyIf('apiCheck', apiCheck.oneOf(['throw', 'warn']));
	
		var formlyWrapperType = apiCheck.shape({
		  name: shapeRequiredIfNot('types', apiCheck.string).optional,
		  template: apiCheck.shape.ifNot('templateUrl', apiCheck.string).optional,
		  templateUrl: apiCheck.shape.ifNot('template', apiCheck.string).optional,
		  types: apiCheck.typeOrArrayOf(apiCheck.string).optional,
		  overwriteOk: apiCheck.bool.optional,
		  apiCheck: apiCheckProperty.optional,
		  apiCheckInstance: apiCheckInstanceProperty.optional,
		  apiCheckFunction: apiCheckFunctionProperty.optional,
		  apiCheckOptions: apiCheck.object.optional
		}).strict;
	
		var expressionProperties = apiCheck.objectOf(apiCheck.oneOfType([formlyExpression, apiCheck.shape({
		  expression: formlyExpression,
		  message: formlyExpression.optional
		}).strict]));
	
		var modelChecker = apiCheck.oneOfType([apiCheck.string, apiCheck.object]);
	
		var templateManipulators = apiCheck.shape({
		  preWrapper: apiCheck.arrayOf(apiCheck.func).nullable.optional,
		  postWrapper: apiCheck.arrayOf(apiCheck.func).nullable.optional
		}).strict.nullable;
	
		var validatorChecker = apiCheck.objectOf(apiCheck.oneOfType([formlyExpression, apiCheck.shape({
		  expression: formlyExpression,
		  message: formlyExpression.optional
		}).strict]));
	
		var watcherChecker = apiCheck.typeOrArrayOf(apiCheck.shape({
		  expression: formlyExpression.optional,
		  listener: formlyExpression.optional,
		  runFieldExpressions: apiCheck.bool.optional
		}));
	
		var fieldOptionsApiShape = {
		  $$hashKey: apiCheck.any.optional,
		  type: apiCheck.shape.ifNot(['template', 'templateUrl'], apiCheck.string).optional,
		  template: apiCheck.shape.ifNot(['type', 'templateUrl'], apiCheck.oneOfType([apiCheck.string, apiCheck.func])).optional,
		  templateUrl: apiCheck.shape.ifNot(['type', 'template'], apiCheck.oneOfType([apiCheck.string, apiCheck.func])).optional,
		  key: apiCheck.oneOfType([apiCheck.string, apiCheck.number]).optional,
		  model: modelChecker.optional,
		  originalModel: modelChecker.optional,
		  className: apiCheck.string.optional,
		  id: apiCheck.string.optional,
		  name: apiCheck.string.optional,
		  expressionProperties: expressionProperties.optional,
		  extras: apiCheck.shape({
		    validateOnModelChange: apiCheck.bool.optional,
		    skipNgModelAttrsManipulator: apiCheck.oneOfType([apiCheck.string, apiCheck.bool]).optional
		  }).strict.optional,
		  data: apiCheck.object.optional,
		  templateOptions: apiCheck.object.optional,
		  wrapper: specifyWrapperType.optional,
		  modelOptions: apiCheck.shape({
		    updateOn: apiCheck.string.optional,
		    debounce: apiCheck.oneOfType([apiCheck.objectOf(apiCheck.number), apiCheck.number]).optional,
		    allowInvalid: apiCheck.bool.optional,
		    getterSetter: apiCheck.bool.optional,
		    timezone: apiCheck.string.optional
		  }).optional,
		  watcher: watcherChecker.optional,
		  validators: validatorChecker.optional,
		  asyncValidators: validatorChecker.optional,
		  parsers: apiCheck.arrayOf(formlyExpression).optional,
		  formatters: apiCheck.arrayOf(formlyExpression).optional,
		  noFormControl: apiCheck.bool.optional,
		  hide: apiCheck.bool.optional,
		  hideExpression: formlyExpression.optional,
		  ngModelElAttrs: apiCheck.objectOf(apiCheck.string).optional,
		  ngModelAttrs: apiCheck.objectOf(apiCheck.shape({
		    statement: apiCheck.shape.ifNot(['value', 'attribute', 'bound', 'boolean'], apiCheck.any).optional,
		    value: apiCheck.shape.ifNot('statement', apiCheck.any).optional,
		    attribute: apiCheck.shape.ifNot('statement', apiCheck.any).optional,
		    bound: apiCheck.shape.ifNot('statement', apiCheck.any).optional,
		    boolean: apiCheck.shape.ifNot('statement', apiCheck.any).optional
		  }).strict).optional,
		  elementAttributes: apiCheck.objectOf(apiCheck.string).optional,
		  optionsTypes: apiCheck.typeOrArrayOf(apiCheck.string).optional,
		  link: apiCheck.func.optional,
		  controller: apiCheck.oneOfType([apiCheck.string, apiCheck.func, apiCheck.array]).optional,
		  validation: apiCheck.shape({
		    show: apiCheck.bool.nullable.optional,
		    messages: apiCheck.objectOf(formlyExpression).optional,
		    errorExistsAndShouldBeVisible: apiCheck.bool.optional
		  }).optional,
		  formControl: apiCheck.typeOrArrayOf(apiCheck.object).optional,
		  value: apiCheck.func.optional,
		  runExpressions: apiCheck.func.optional,
		  templateManipulators: templateManipulators.optional,
		  resetModel: apiCheck.func.optional,
		  updateInitialValue: apiCheck.func.optional,
		  initialValue: apiCheck.any.optional,
		  defaultValue: apiCheck.any.optional
		};
	
		var formlyFieldOptions = apiCheck.shape(fieldOptionsApiShape).strict;
	
		var formOptionsApi = apiCheck.shape({
		  formState: apiCheck.object.optional,
		  resetModel: apiCheck.func.optional,
		  updateInitialValue: apiCheck.func.optional,
		  removeChromeAutoComplete: apiCheck.bool.optional,
		  parseKeyArrays: apiCheck.bool.optional,
		  templateManipulators: templateManipulators.optional,
		  manualModelWatcher: apiCheck.oneOfType([apiCheck.bool, apiCheck.func]).optional,
		  watchAllExpressions: apiCheck.bool.optional,
		  wrapper: specifyWrapperType.optional,
		  fieldTransform: apiCheck.oneOfType([apiCheck.func, apiCheck.array]).optional,
		  data: apiCheck.object.optional
		}).strict;
	
		var fieldGroup = apiCheck.shape({
		  $$hashKey: apiCheck.any.optional,
		  key: apiCheck.oneOfType([apiCheck.string, apiCheck.number]).optional,
		  // danger. Nested field groups wont get api-checked...
		  fieldGroup: apiCheck.arrayOf(apiCheck.oneOfType([formlyFieldOptions, apiCheck.object])),
		  className: apiCheck.string.optional,
		  options: formOptionsApi.optional,
		  templateOptions: apiCheck.object.optional,
		  wrapper: specifyWrapperType.optional,
		  watcher: watcherChecker.optional,
		  hide: apiCheck.bool.optional,
		  hideExpression: formlyExpression.optional,
		  data: apiCheck.object.optional,
		  model: modelChecker.optional,
		  form: apiCheck.object.optional,
		  elementAttributes: apiCheck.objectOf(apiCheck.string).optional
		}).strict;
	
		var typeOptionsDefaultOptions = _angularFix2['default'].copy(fieldOptionsApiShape);
		typeOptionsDefaultOptions.key = apiCheck.string.optional;
	
		var formlyTypeOptions = apiCheck.shape({
		  name: apiCheck.string,
		  template: apiCheck.shape.ifNot('templateUrl', apiCheck.oneOfType([apiCheck.string, apiCheck.func])).optional,
		  templateUrl: apiCheck.shape.ifNot('template', apiCheck.oneOfType([apiCheck.string, apiCheck.func])).optional,
		  controller: apiCheck.oneOfType([apiCheck.func, apiCheck.string, apiCheck.array]).optional,
		  link: apiCheck.func.optional,
		  defaultOptions: apiCheck.oneOfType([apiCheck.func, apiCheck.shape(typeOptionsDefaultOptions)]).optional,
		  'extends': apiCheck.string.optional,
		  wrapper: specifyWrapperType.optional,
		  data: apiCheck.object.optional,
		  apiCheck: apiCheckProperty.optional,
		  apiCheckInstance: apiCheckInstanceProperty.optional,
		  apiCheckFunction: apiCheckFunctionProperty.optional,
		  apiCheckOptions: apiCheck.object.optional,
		  overwriteOk: apiCheck.bool.optional
		}).strict;
	
		_angularFix2['default'].extend(apiCheck, {
		  formlyTypeOptions: formlyTypeOptions, formlyFieldOptions: formlyFieldOptions, formlyExpression: formlyExpression, formlyWrapperType: formlyWrapperType, fieldGroup: fieldGroup, formOptionsApi: formOptionsApi
		});
	
		exports['default'] = apiCheck;
		module.exports = exports['default'];
	
	/***/ },
	/* 5 */
	/***/ function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_5__;
	
	/***/ },
	/* 6 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports["default"] = "https://github.com/formly-js/angular-formly/blob/" + ("8.4.1") + "/other/ERRORS_AND_WARNINGS.md#";
		module.exports = exports["default"];
	
	/***/ },
	/* 7 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		formlyUsability.$inject = ["formlyApiCheck", "formlyErrorAndWarningsUrlPrefix"];
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var _angularFix = __webpack_require__(2);
	
		var _angularFix2 = _interopRequireDefault(_angularFix);
	
		exports['default'] = formlyUsability;
	
		// @ngInject
		function formlyUsability(formlyApiCheck, formlyErrorAndWarningsUrlPrefix) {
		  var _this = this;
	
		  _angularFix2['default'].extend(this, {
		    getFormlyError: getFormlyError,
		    getFieldError: getFieldError,
		    checkWrapper: checkWrapper,
		    checkWrapperTemplate: checkWrapperTemplate,
		    getErrorMessage: getErrorMessage,
		    $get: function $get() {
		      return _this;
		    }
		  });
	
		  function getFieldError(errorInfoSlug, message, field) {
		    if (arguments.length < 3) {
		      field = message;
		      message = errorInfoSlug;
		      errorInfoSlug = null;
		    }
		    return new Error(getErrorMessage(errorInfoSlug, message) + (' Field definition: ' + _angularFix2['default'].toJson(field)));
		  }
	
		  function getFormlyError(errorInfoSlug, message) {
		    if (!message) {
		      message = errorInfoSlug;
		      errorInfoSlug = null;
		    }
		    return new Error(getErrorMessage(errorInfoSlug, message));
		  }
	
		  function getErrorMessage(errorInfoSlug, message) {
		    var url = '';
		    if (errorInfoSlug !== null) {
		      url = '' + formlyErrorAndWarningsUrlPrefix + errorInfoSlug;
		    }
		    return 'Formly Error: ' + message + '. ' + url;
		  }
	
		  function checkWrapper(wrapper) {
		    formlyApiCheck['throw'](formlyApiCheck.formlyWrapperType, wrapper, {
		      prefix: 'formlyConfig.setWrapper',
		      urlSuffix: 'setwrapper-validation-failed'
		    });
		  }
	
		  function checkWrapperTemplate(template, additionalInfo) {
		    var formlyTransclude = '<formly-transclude></formly-transclude>';
		    if (template.indexOf(formlyTransclude) === -1) {
		      throw getFormlyError('Template wrapper templates must use "' + formlyTransclude + '" somewhere in them. ' + ('This one does not have "<formly-transclude></formly-transclude>" in it: ' + template) + '\n' + ('Additional information: ' + JSON.stringify(additionalInfo)));
		    }
		  }
		}
		module.exports = exports['default'];
	
	/***/ },
	/* 8 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		formlyConfig.$inject = ["formlyUsabilityProvider", "formlyErrorAndWarningsUrlPrefix", "formlyApiCheck"];
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }
	
		var _angularFix = __webpack_require__(2);
	
		var _angularFix2 = _interopRequireDefault(_angularFix);
	
		var _otherUtils = __webpack_require__(9);
	
		var _otherUtils2 = _interopRequireDefault(_otherUtils);
	
		exports['default'] = formlyConfig;
	
		// @ngInject
		function formlyConfig(formlyUsabilityProvider, formlyErrorAndWarningsUrlPrefix, formlyApiCheck) {
		  var _this2 = this;
	
		  var typeMap = {};
		  var templateWrappersMap = {};
		  var defaultWrapperName = 'default';
		  var _this = this;
		  var getError = formlyUsabilityProvider.getFormlyError;
	
		  _angularFix2['default'].extend(this, {
		    setType: setType,
		    getType: getType,
		    getTypes: getTypes,
		    getTypeHeritage: getTypeHeritage,
		    setWrapper: setWrapper,
		    getWrapper: getWrapper,
		    getWrapperByType: getWrapperByType,
		    removeWrapperByName: removeWrapperByName,
		    removeWrappersForType: removeWrappersForType,
		    disableWarnings: false,
		    extras: {
		      disableNgModelAttrsManipulator: false,
		      fieldTransform: [],
		      ngModelAttrsManipulatorPreferUnbound: false,
		      removeChromeAutoComplete: false,
		      parseKeyArrays: false,
		      defaultHideDirective: 'ng-if',
		      getFieldId: null
		    },
		    templateManipulators: {
		      preWrapper: [],
		      postWrapper: []
		    },
		    $get: function $get() {
		      return _this2;
		    }
		  });
	
		  function setType(options) {
		    if (_angularFix2['default'].isArray(options)) {
		      var _ret = (function () {
		        var allTypes = [];
		        _angularFix2['default'].forEach(options, function (item) {
		          allTypes.push(setType(item));
		        });
		        return {
		          v: allTypes
		        };
		      })();
	
		      if (typeof _ret === 'object') return _ret.v;
		    } else if (_angularFix2['default'].isObject(options)) {
		      checkType(options);
		      if (options['extends']) {
		        extendTypeOptions(options);
		      }
		      typeMap[options.name] = options;
		      return typeMap[options.name];
		    } else {
		      throw getError('You must provide an object or array for setType. You provided: ' + JSON.stringify(arguments));
		    }
		  }
	
		  function checkType(options) {
		    formlyApiCheck['throw'](formlyApiCheck.formlyTypeOptions, options, {
		      prefix: 'formlyConfig.setType',
		      url: 'settype-validation-failed'
		    });
		    if (!options.overwriteOk) {
		      checkOverwrite(options.name, typeMap, options, 'types');
		    } else {
		      options.overwriteOk = undefined;
		    }
		  }
	
		  function extendTypeOptions(options) {
		    var extendsType = getType(options['extends'], true, options);
		    extendTypeControllerFunction(options, extendsType);
		    extendTypeLinkFunction(options, extendsType);
		    extendTypeDefaultOptions(options, extendsType);
		    _otherUtils2['default'].reverseDeepMerge(options, extendsType);
		    extendTemplate(options, extendsType);
		  }
	
		  function extendTemplate(options, extendsType) {
		    if (options.template && extendsType.templateUrl) {
		      delete options.templateUrl;
		    } else if (options.templateUrl && extendsType.template) {
		      delete options.template;
		    }
		  }
	
		  function extendTypeControllerFunction(options, extendsType) {
		    var extendsCtrl = extendsType.controller;
		    if (!_angularFix2['default'].isDefined(extendsCtrl)) {
		      return;
		    }
		    var optionsCtrl = options.controller;
		    if (_angularFix2['default'].isDefined(optionsCtrl)) {
		      options.controller = function ($scope, $controller) {
		        $controller(extendsCtrl, { $scope: $scope });
		        $controller(optionsCtrl, { $scope: $scope });
		      };
		      options.controller.$inject = ['$scope', '$controller'];
		    } else {
		      options.controller = extendsCtrl;
		    }
		  }
	
		  function extendTypeLinkFunction(options, extendsType) {
		    var extendsFn = extendsType.link;
		    if (!_angularFix2['default'].isDefined(extendsFn)) {
		      return;
		    }
		    var optionsFn = options.link;
		    if (_angularFix2['default'].isDefined(optionsFn)) {
		      options.link = function () {
		        extendsFn.apply(undefined, arguments);
		        optionsFn.apply(undefined, arguments);
		      };
		    } else {
		      options.link = extendsFn;
		    }
		  }
	
		  function extendTypeDefaultOptions(options, extendsType) {
		    var extendsDO = extendsType.defaultOptions;
		    if (!_angularFix2['default'].isDefined(extendsDO)) {
		      return;
		    }
		    var optionsDO = options.defaultOptions || {};
		    var optionsDOIsFn = _angularFix2['default'].isFunction(optionsDO);
		    var extendsDOIsFn = _angularFix2['default'].isFunction(extendsDO);
		    if (extendsDOIsFn) {
		      options.defaultOptions = function defaultOptions(opts, scope) {
		        var extendsDefaultOptions = extendsDO(opts, scope);
		        var mergedDefaultOptions = {};
		        _otherUtils2['default'].reverseDeepMerge(mergedDefaultOptions, opts, extendsDefaultOptions);
		        var extenderOptionsDefaultOptions = optionsDO;
		        if (optionsDOIsFn) {
		          extenderOptionsDefaultOptions = extenderOptionsDefaultOptions(mergedDefaultOptions, scope);
		        }
		        _otherUtils2['default'].reverseDeepMerge(extenderOptionsDefaultOptions, extendsDefaultOptions);
		        return extenderOptionsDefaultOptions;
		      };
		    } else if (optionsDOIsFn) {
		      options.defaultOptions = function defaultOptions(opts, scope) {
		        var newDefaultOptions = {};
		        _otherUtils2['default'].reverseDeepMerge(newDefaultOptions, opts, extendsDO);
		        return optionsDO(newDefaultOptions, scope);
		      };
		    }
		  }
	
		  function getType(name, throwError, errorContext) {
		    if (!name) {
		      return undefined;
		    }
		    var type = typeMap[name];
		    if (!type && throwError === true) {
		      throw getError('There is no type by the name of "' + name + '": ' + JSON.stringify(errorContext));
		    } else {
		      return type;
		    }
		  }
	
		  function getTypes() {
		    return typeMap;
		  }
	
		  function getTypeHeritage(parent) {
		    var heritage = [];
		    var type = parent;
		    if (_angularFix2['default'].isString(type)) {
		      type = getType(parent);
		    }
		    parent = type['extends'];
		    while (parent) {
		      type = getType(parent);
		      heritage.push(type);
		      parent = type['extends'];
		    }
		    return heritage;
		  }
	
		  function setWrapper(_x, _x2) {
		    var _again = true;
	
		    _function: while (_again) {
		      var options = _x,
		          name = _x2;
		      _again = false;
	
		      if (_angularFix2['default'].isArray(options)) {
		        return options.map(function (wrapperOptions) {
		          return setWrapper(wrapperOptions);
		        });
		      } else if (_angularFix2['default'].isObject(options)) {
		        options.types = getOptionsTypes(options);
		        options.name = getOptionsName(options, name);
		        checkWrapperAPI(options);
		        templateWrappersMap[options.name] = options;
		        return options;
		      } else if (_angularFix2['default'].isString(options)) {
		        _x = {
		          template: options,
		          name: name
		        };
		        _x2 = undefined;
		        _again = true;
		        continue _function;
		      }
		    }
		  }
	
		  function getOptionsTypes(options) {
		    if (_angularFix2['default'].isString(options.types)) {
		      return [options.types];
		    }
		    if (!_angularFix2['default'].isDefined(options.types)) {
		      return [];
		    } else {
		      return options.types;
		    }
		  }
	
		  function getOptionsName(options, name) {
		    return options.name || name || options.types.join(' ') || defaultWrapperName;
		  }
	
		  function checkWrapperAPI(options) {
		    formlyUsabilityProvider.checkWrapper(options);
		    if (options.template) {
		      formlyUsabilityProvider.checkWrapperTemplate(options.template, options);
		    }
		    if (!options.overwriteOk) {
		      checkOverwrite(options.name, templateWrappersMap, options, 'templateWrappers');
		    } else {
		      delete options.overwriteOk;
		    }
		    checkWrapperTypes(options);
		  }
	
		  function checkWrapperTypes(options) {
		    var shouldThrow = !_angularFix2['default'].isArray(options.types) || !options.types.every(_angularFix2['default'].isString);
		    if (shouldThrow) {
		      throw getError('Attempted to create a template wrapper with types that is not a string or an array of strings');
		    }
		  }
	
		  function checkOverwrite(property, object, newValue, objectName) {
		    if (object.hasOwnProperty(property)) {
		      warn('overwriting-types-or-wrappers', ['Attempting to overwrite ' + property + ' on ' + objectName + ' which is currently', JSON.stringify(object[property]) + ' with ' + JSON.stringify(newValue), 'To supress this warning, specify the property "overwriteOk: true"'].join(' '));
		    }
		  }
	
		  function getWrapper(name) {
		    return templateWrappersMap[name || defaultWrapperName];
		  }
	
		  function getWrapperByType(type) {
		    /* eslint prefer-const:0 */
		    var wrappers = [];
		    for (var _name in templateWrappersMap) {
		      if (templateWrappersMap.hasOwnProperty(_name)) {
		        if (templateWrappersMap[_name].types && templateWrappersMap[_name].types.indexOf(type) !== -1) {
		          wrappers.push(templateWrappersMap[_name]);
		        }
		      }
		    }
		    return wrappers;
		  }
	
		  function removeWrapperByName(name) {
		    var wrapper = templateWrappersMap[name];
		    delete templateWrappersMap[name];
		    return wrapper;
		  }
	
		  function removeWrappersForType(type) {
		    var wrappers = getWrapperByType(type);
		    if (!wrappers) {
		      return undefined;
		    }
		    if (!_angularFix2['default'].isArray(wrappers)) {
		      return removeWrapperByName(wrappers.name);
		    } else {
		      wrappers.forEach(function (wrapper) {
		        return removeWrapperByName(wrapper.name);
		      });
		      return wrappers;
		    }
		  }
	
		  function warn() {
		    if (!_this.disableWarnings && console.warn) {
		      /* eslint no-console:0 */
		      var args = Array.prototype.slice.call(arguments);
		      var warnInfoSlug = args.shift();
		      args.unshift('Formly Warning:');
		      args.push('' + formlyErrorAndWarningsUrlPrefix + warnInfoSlug);
		      console.warn.apply(console, _toConsumableArray(args));
		    }
		  }
		}
		module.exports = exports['default'];
	
	/***/ },
	/* 9 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var _angularFix = __webpack_require__(2);
	
		var _angularFix2 = _interopRequireDefault(_angularFix);
	
		exports['default'] = {
		  containsSelector: containsSelector, containsSpecialChar: containsSpecialChar, formlyEval: formlyEval, getFieldId: getFieldId, reverseDeepMerge: reverseDeepMerge, findByNodeName: findByNodeName,
		  arrayify: arrayify, extendFunction: extendFunction, extendArray: extendArray, startsWith: startsWith, contains: contains
		};
	
		function containsSelector(string) {
		  return containsSpecialChar(string, '.') || containsSpecialChar(string, '[') && containsSpecialChar(string, ']');
		}
	
		function containsSpecialChar(a, b) {
		  if (!a || !a.indexOf) {
		    return false;
		  }
		  return a.indexOf(b) !== -1;
		}
	
		function formlyEval(scope, expression, $modelValue, $viewValue, extraLocals) {
		  if (_angularFix2['default'].isFunction(expression)) {
		    return expression($viewValue, $modelValue, scope, extraLocals);
		  } else {
		    return scope.$eval(expression, _angularFix2['default'].extend({ $viewValue: $viewValue, $modelValue: $modelValue }, extraLocals));
		  }
		}
	
		function getFieldId(formId, options, index) {
		  if (options.id) {
		    return options.id;
		  }
		  var type = options.type;
		  if (!type && options.template) {
		    type = 'template';
		  } else if (!type && options.templateUrl) {
		    type = 'templateUrl';
		  }
	
		  return [formId, type, options.key, index].join('_');
		}
	
		function reverseDeepMerge(dest) {
		  _angularFix2['default'].forEach(arguments, function (src, index) {
		    if (!index) {
		      return;
		    }
		    _angularFix2['default'].forEach(src, function (val, prop) {
		      if (!_angularFix2['default'].isDefined(dest[prop])) {
		        dest[prop] = _angularFix2['default'].copy(val);
		      } else if (objAndSameType(dest[prop], val)) {
		        reverseDeepMerge(dest[prop], val);
		      }
		    });
		  });
		  return dest;
		}
	
		function objAndSameType(obj1, obj2) {
		  return _angularFix2['default'].isObject(obj1) && _angularFix2['default'].isObject(obj2) && Object.getPrototypeOf(obj1) === Object.getPrototypeOf(obj2);
		}
	
		// recurse down a node tree to find a node with matching nodeName, for custom tags jQuery.find doesn't work in IE8
		function findByNodeName(el, nodeName) {
		  if (!el.prop) {
		    // not a jQuery or jqLite object -> wrap it
		    el = _angularFix2['default'].element(el);
		  }
	
		  if (el.prop('nodeName') === nodeName.toUpperCase()) {
		    return el;
		  }
	
		  var c = el.children();
		  for (var i = 0; c && i < c.length; i++) {
		    var node = findByNodeName(c[i], nodeName);
		    if (node) {
		      return node;
		    }
		  }
		}
	
		function arrayify(obj) {
		  if (obj && !_angularFix2['default'].isArray(obj)) {
		    obj = [obj];
		  } else if (!obj) {
		    obj = [];
		  }
		  return obj;
		}
	
		function extendFunction() {
		  for (var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++) {
		    fns[_key] = arguments[_key];
		  }
	
		  return function extendedFunction() {
		    var args = arguments;
		    fns.forEach(function (fn) {
		      return fn.apply(null, args);
		    });
		  };
		}
	
		function extendArray(primary, secondary, property) {
		  if (property) {
		    primary = primary[property];
		    secondary = secondary[property];
		  }
		  if (secondary && primary) {
		    _angularFix2['default'].forEach(secondary, function (item) {
		      if (primary.indexOf(item) === -1) {
		        primary.push(item);
		      }
		    });
		    return primary;
		  } else if (secondary) {
		    return secondary;
		  } else {
		    return primary;
		  }
		}
	
		function startsWith(str, search) {
		  if (_angularFix2['default'].isString(str) && _angularFix2['default'].isString(search)) {
		    return str.length >= search.length && str.substring(0, search.length) === search;
		  } else {
		    return false;
		  }
		}
	
		function contains(str, search) {
		  if (_angularFix2['default'].isString(str) && _angularFix2['default'].isString(search)) {
		    return str.length >= search.length && str.indexOf(search) !== -1;
		  } else {
		    return false;
		  }
		}
		module.exports = exports['default'];
	
	/***/ },
	/* 10 */
	/***/ function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
		exports['default'] = formlyValidationMessages;
	
		// @ngInject
		function formlyValidationMessages() {
	
		  var validationMessages = {
		    addTemplateOptionValueMessage: addTemplateOptionValueMessage,
		    addStringMessage: addStringMessage,
		    messages: {}
		  };
	
		  return validationMessages;
	
		  function addTemplateOptionValueMessage(name, prop, prefix, suffix, alternate) {
		    validationMessages.messages[name] = templateOptionValue(prop, prefix, suffix, alternate);
		  }
	
		  function addStringMessage(name, string) {
		    validationMessages.messages[name] = function () {
		      return string;
		    };
		  }
	
		  function templateOptionValue(prop, prefix, suffix, alternate) {
		    return function getValidationMessage(viewValue, modelValue, scope) {
		      if (typeof scope.options.templateOptions[prop] !== 'undefined') {
		        return prefix + ' ' + scope.options.templateOptions[prop] + ' ' + suffix;
		      } else {
		        return alternate;
		      }
		    };
		  }
		}
		module.exports = exports['default'];
	
	/***/ },
	/* 11 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var _otherUtils = __webpack_require__(9);
	
		var _otherUtils2 = _interopRequireDefault(_otherUtils);
	
		exports['default'] = formlyUtil;
	
		// @ngInject
		function formlyUtil() {
		  return _otherUtils2['default'];
		}
		module.exports = exports['default'];
	
	/***/ },
	/* 12 */
	/***/ function(module, exports) {
	
		'use strict';
	
		formlyWarn.$inject = ["formlyConfig", "formlyErrorAndWarningsUrlPrefix", "$log"];
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }
	
		exports['default'] = formlyWarn;
	
		// @ngInject
		function formlyWarn(formlyConfig, formlyErrorAndWarningsUrlPrefix, $log) {
		  return function warn() {
		    if (!formlyConfig.disableWarnings) {
		      var args = Array.prototype.slice.call(arguments);
		      var warnInfoSlug = args.shift();
		      args.unshift('Formly Warning:');
		      args.push('' + formlyErrorAndWarningsUrlPrefix + warnInfoSlug);
		      $log.warn.apply($log, _toConsumableArray(args));
		    }
		  };
		}
		module.exports = exports['default'];
	
	/***/ },
	/* 13 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		formlyCustomValidation.$inject = ["formlyUtil"];
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var _angularFix = __webpack_require__(2);
	
		var _angularFix2 = _interopRequireDefault(_angularFix);
	
		exports['default'] = formlyCustomValidation;
	
		// @ngInject
		function formlyCustomValidation(formlyUtil) {
		  return {
		    restrict: 'A',
		    require: 'ngModel',
		    link: function formlyCustomValidationLink(scope, el, attrs, ctrl) {
		      var opts = scope.options;
		      opts.validation.messages = opts.validation.messages || {};
		      _angularFix2['default'].forEach(opts.validation.messages, function (message, key) {
		        opts.validation.messages[key] = function () {
		          return formlyUtil.formlyEval(scope, message, ctrl.$modelValue, ctrl.$viewValue);
		        };
		      });
	
		      var useNewValidatorsApi = ctrl.hasOwnProperty('$validators') && !attrs.hasOwnProperty('useParsers');
		      _angularFix2['default'].forEach(opts.validators, _angularFix2['default'].bind(null, addValidatorToPipeline, false));
		      _angularFix2['default'].forEach(opts.asyncValidators, _angularFix2['default'].bind(null, addValidatorToPipeline, true));
	
		      function addValidatorToPipeline(isAsync, validator, name) {
		        setupMessage(validator, name);
		        validator = _angularFix2['default'].isObject(validator) ? validator.expression : validator;
		        if (useNewValidatorsApi) {
		          setupWithValidators(validator, name, isAsync);
		        } else {
		          setupWithParsers(validator, name, isAsync);
		        }
		      }
	
		      function setupMessage(validator, name) {
		        var message = validator.message;
		        if (message) {
		          opts.validation.messages[name] = function () {
		            return formlyUtil.formlyEval(scope, message, ctrl.$modelValue, ctrl.$viewValue);
		          };
		        }
		      }
	
		      function setupWithValidators(validator, name, isAsync) {
		        var validatorCollection = isAsync ? '$asyncValidators' : '$validators';
	
		        ctrl[validatorCollection][name] = function evalValidity(modelValue, viewValue) {
		          return formlyUtil.formlyEval(scope, validator, modelValue, viewValue);
		        };
		      }
	
		      function setupWithParsers(validator, name, isAsync) {
		        var inFlightValidator = undefined;
		        ctrl.$parsers.unshift(function evalValidityOfParser(viewValue) {
		          var isValid = formlyUtil.formlyEval(scope, validator, ctrl.$modelValue, viewValue);
		          if (isAsync) {
		            ctrl.$pending = ctrl.$pending || {};
		            ctrl.$pending[name] = true;
		            inFlightValidator = isValid;
		            isValid.then(function () {
		              if (inFlightValidator === isValid) {
		                ctrl.$setValidity(name, true);
		              }
		            })['catch'](function () {
		              if (inFlightValidator === isValid) {
		                ctrl.$setValidity(name, false);
		              }
		            })['finally'](function () {
		              var $pending = ctrl.$pending || {};
		              if (Object.keys($pending).length === 1) {
		                delete ctrl.$pending;
		              } else {
		                delete ctrl.$pending[name];
		              }
		            });
		          } else {
		            ctrl.$setValidity(name, isValid);
		          }
		          return viewValue;
		        });
		      }
		    }
		  };
		}
		module.exports = exports['default'];
	
	/***/ },
	/* 14 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		formlyField.$inject = ["$http", "$q", "$compile", "$templateCache", "$interpolate", "formlyConfig", "formlyApiCheck", "formlyUtil", "formlyUsability", "formlyWarn"];
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }
	
		var _angularFix = __webpack_require__(2);
	
		var _angularFix2 = _interopRequireDefault(_angularFix);
	
		var _apiCheck = __webpack_require__(5);
	
		var _apiCheck2 = _interopRequireDefault(_apiCheck);
	
		exports['default'] = formlyField;
	
		/**
		 * @ngdoc directive
		 * @name formlyField
		 * @restrict AE
		 */
		// @ngInject
		function formlyField($http, $q, $compile, $templateCache, $interpolate, formlyConfig, formlyApiCheck, formlyUtil, formlyUsability, formlyWarn) {
		  FormlyFieldController.$inject = ["$scope", "$timeout", "$parse", "$controller", "formlyValidationMessages"];
		  var arrayify = formlyUtil.arrayify;
	
		  return {
		    restrict: 'AE',
		    transclude: true,
		    require: '?^formlyForm',
		    scope: {
		      options: '=',
		      model: '=',
		      originalModel: '=?',
		      formId: '@', // TODO remove formId in a breaking release
		      index: '=?',
		      fields: '=?',
		      formState: '=?',
		      formOptions: '=?',
		      form: '=?' },
		    // TODO require form in a breaking release
		    controller: FormlyFieldController,
		    link: fieldLink
		  };
	
		  // @ngInject
		  function FormlyFieldController($scope, $timeout, $parse, $controller, formlyValidationMessages) {
		    /* eslint max-statements:[2, 37] */
		    if ($scope.options.fieldGroup) {
		      setupFieldGroup();
		      return;
		    }
	
		    var fieldType = getFieldType($scope.options);
		    simplifyLife($scope.options);
		    mergeFieldOptionsWithTypeDefaults($scope.options, fieldType);
		    extendOptionsWithDefaults($scope.options, $scope.index);
		    checkApi($scope.options);
		    // set field id to link labels and fields
	
		    // initalization
		    setFieldIdAndName();
		    setDefaultValue();
		    setInitialValue();
		    runExpressions();
		    watchExpressions();
		    addValidationMessages($scope.options);
		    invokeControllers($scope, $scope.options, fieldType);
	
		    // function definitions
		    function runExpressions() {
		      var deferred = $q.defer();
		      // must run on next tick to make sure that the current value is correct.
		      $timeout(function runExpressionsOnNextTick() {
		        var promises = [];
		        var field = $scope.options;
		        var currentValue = valueGetterSetter();
		        _angularFix2['default'].forEach(field.expressionProperties, function runExpression(expression, prop) {
		          var setter = $parse(prop).assign;
		          var promise = $q.when(formlyUtil.formlyEval($scope, expression, currentValue, currentValue)).then(function setFieldValue(value) {
		            setter(field, value);
		          });
		          promises.push(promise);
		        });
		        $q.all(promises).then(function () {
		          deferred.resolve();
		        });
		      }, 0, false);
		      return deferred.promise;
		    }
	
		    function watchExpressions() {
		      if ($scope.formOptions.watchAllExpressions) {
		        (function () {
		          var field = $scope.options;
		          var currentValue = valueGetterSetter();
		          _angularFix2['default'].forEach(field.expressionProperties, function watchExpression(expression, prop) {
		            var setter = $parse(prop).assign;
		            $scope.$watch(function expressionPropertyWatcher() {
		              return formlyUtil.formlyEval($scope, expression, currentValue, currentValue);
		            }, function expressionPropertyListener(value) {
		              setter(field, value);
		            }, true);
		          });
		        })();
		      }
		    }
	
		    function valueGetterSetter(newVal) {
		      if (!$scope.model || !$scope.options.key) {
		        return undefined;
		      }
		      if (_angularFix2['default'].isDefined(newVal)) {
		        parseSet($scope.options.key, $scope.model, newVal);
		      }
		      return parseGet($scope.options.key, $scope.model);
		    }
	
		    function shouldNotUseParseKey(key) {
		      return _angularFix2['default'].isNumber(key) || !formlyUtil.containsSelector(key);
		    }
	
		    function keyContainsArrays(key) {
		      return (/\[\d{1,}\]/.test(key)
		      );
		    }
	
		    function deepAssign(obj, prop, value) {
		      if (_angularFix2['default'].isString(prop)) {
		        prop = prop.replace(/\[(\w+)\]/g, '.$1').split('.');
		      }
	
		      if (prop.length > 1) {
		        var e = prop.shift();
		        obj[e] = obj[e] || isNaN(prop[0]) ? {} : [];
		        deepAssign(obj[e], prop, value);
		      } else {
		        obj[prop[0]] = value;
		      }
		    }
	
		    function parseSet(key, model, newVal) {
		      // If either of these are null/undefined then just return undefined
		      if (!key && key !== 0 || !model) {
		        return;
		      }
		      // If we are working with a number then $parse wont work, default back to the old way for now
		      if (shouldNotUseParseKey(key)) {
		        // TODO: Fix this so we can get several levels instead of just one with properties that are numeric
		        model[key] = newVal;
		      } else if (formlyConfig.extras.parseKeyArrays && keyContainsArrays(key)) {
		        deepAssign($scope.model, key, newVal);
		      } else {
		        var setter = $parse($scope.options.key).assign;
		        if (setter) {
		          setter($scope.model, newVal);
		        }
		      }
		    }
	
		    function parseGet(key, model) {
		      // If either of these are null/undefined then just return undefined
		      if (!key && key !== 0 || !model) {
		        return undefined;
		      }
	
		      // If we are working with a number then $parse wont work, default back to the old way for now
		      if (shouldNotUseParseKey(key)) {
		        // TODO: Fix this so we can get several levels instead of just one with properties that are numeric
		        return model[key];
		      } else {
		        return $parse(key)(model);
		      }
		    }
	
		    function simplifyLife(options) {
		      // add a few empty objects (if they don't already exist) so you don't have to undefined check everywhere
		      formlyUtil.reverseDeepMerge(options, {
		        originalModel: options.model,
		        extras: {},
		        data: {},
		        templateOptions: {},
		        validation: {}
		      });
		      // create $scope.to so template authors can reference to instead of $scope.options.templateOptions
		      $scope.to = $scope.options.templateOptions;
		      $scope.formOptions = $scope.formOptions || {};
		    }
	
		    function setFieldIdAndName() {
		      if (_angularFix2['default'].isFunction(formlyConfig.extras.getFieldId)) {
		        $scope.id = formlyConfig.extras.getFieldId($scope.options, $scope.model, $scope);
		      } else {
		        var formName = $scope.form && $scope.form.$name || $scope.formId;
		        $scope.id = formlyUtil.getFieldId(formName, $scope.options, $scope.index);
		      }
		      $scope.options.id = $scope.id;
		      $scope.name = $scope.options.name || $scope.options.id;
		      $scope.options.name = $scope.name;
		    }
	
		    function setDefaultValue() {
		      if (_angularFix2['default'].isDefined($scope.options.defaultValue) && !_angularFix2['default'].isDefined(parseGet($scope.options.key, $scope.model))) {
		        parseSet($scope.options.key, $scope.model, $scope.options.defaultValue);
		      }
		    }
	
		    function setInitialValue() {
		      $scope.options.initialValue = $scope.model && parseGet($scope.options.key, $scope.model);
		    }
	
		    function mergeFieldOptionsWithTypeDefaults(options, type) {
		      if (type) {
		        mergeOptions(options, type.defaultOptions);
		      }
		      var properOrder = arrayify(options.optionsTypes).reverse(); // so the right things are overridden
		      _angularFix2['default'].forEach(properOrder, function (typeName) {
		        mergeOptions(options, formlyConfig.getType(typeName, true, options).defaultOptions);
		      });
		    }
	
		    function mergeOptions(options, extraOptions) {
		      if (extraOptions) {
		        if (_angularFix2['default'].isFunction(extraOptions)) {
		          extraOptions = extraOptions(options, $scope);
		        }
		        formlyUtil.reverseDeepMerge(options, extraOptions);
		      }
		    }
	
		    function extendOptionsWithDefaults(options, index) {
		      var key = options.key || index || 0;
		      _angularFix2['default'].extend(options, {
		        // attach the key in case the formly-field directive is used directly
		        key: key,
		        value: options.value || valueGetterSetter,
		        runExpressions: runExpressions,
		        resetModel: resetModel,
		        updateInitialValue: updateInitialValue
		      });
		    }
	
		    function resetModel() {
		      parseSet($scope.options.key, $scope.model, $scope.options.initialValue);
		      if ($scope.options.formControl) {
		        if (_angularFix2['default'].isArray($scope.options.formControl)) {
		          _angularFix2['default'].forEach($scope.options.formControl, function (formControl) {
		            resetFormControl(formControl, true);
		          });
		        } else {
		          resetFormControl($scope.options.formControl);
		        }
		      }
		      if ($scope.form) {
		        $scope.form.$setUntouched && $scope.form.$setUntouched();
		        $scope.form.$setPristine();
		      }
		    }
	
		    function resetFormControl(formControl, isMultiNgModel) {
		      if (!isMultiNgModel) {
		        formControl.$setViewValue(parseGet($scope.options.key, $scope.model));
		      }
	
		      formControl.$render();
		      formControl.$setUntouched && formControl.$setUntouched();
		      formControl.$setPristine();
	
		      // To prevent breaking change requiring a digest to reset $viewModel
		      if (!$scope.$root.$$phase) {
		        $scope.$digest();
		      }
		    }
	
		    function updateInitialValue() {
		      $scope.options.initialValue = parseGet($scope.options.key, $scope.model);
		    }
	
		    function addValidationMessages(options) {
		      options.validation.messages = options.validation.messages || {};
		      _angularFix2['default'].forEach(formlyValidationMessages.messages, function createFunctionForMessage(expression, name) {
		        if (!options.validation.messages[name]) {
		          options.validation.messages[name] = function evaluateMessage(viewValue, modelValue, scope) {
		            return formlyUtil.formlyEval(scope, expression, modelValue, viewValue);
		          };
		        }
		      });
		    }
	
		    function invokeControllers(scope) {
		      var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
		      var type = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];
	
		      _angularFix2['default'].forEach([type.controller, options.controller], function (controller) {
		        if (controller) {
		          $controller(controller, { $scope: scope });
		        }
		      });
		    }
	
		    function setupFieldGroup() {
		      $scope.options.options = $scope.options.options || {};
		      $scope.options.options.formState = $scope.formState;
		      $scope.to = $scope.options.templateOptions;
		    }
		  }
	
		  // link function
		  function fieldLink(scope, el, attrs, formlyFormCtrl) {
		    if (scope.options.fieldGroup) {
		      setFieldGroupTemplate();
		      return;
		    }
	
		    // watch the field model (if exists) if there is no parent formly-form directive (that would watch it instead)
		    if (!formlyFormCtrl && scope.options.model) {
		      scope.$watch('options.model', function () {
		        return scope.options.runExpressions();
		      }, true);
		    }
	
		    addAttributes();
		    addClasses();
	
		    var type = getFieldType(scope.options);
		    var args = arguments;
		    var thusly = this;
		    var fieldCount = 0;
		    var fieldManipulators = getManipulators(scope.options, scope.formOptions);
		    getFieldTemplate(scope.options).then(runManipulators(fieldManipulators.preWrapper)).then(transcludeInWrappers(scope.options, scope.formOptions)).then(runManipulators(fieldManipulators.postWrapper)).then(setElementTemplate).then(watchFormControl).then(callLinkFunctions)['catch'](function (error) {
		      formlyWarn('there-was-a-problem-setting-the-template-for-this-field', 'There was a problem setting the template for this field ', scope.options, error);
		    });
	
		    function setFieldGroupTemplate() {
		      checkFieldGroupApi(scope.options);
		      el.addClass('formly-field-group');
		      var extraAttributes = '';
		      if (scope.options.elementAttributes) {
		        extraAttributes = Object.keys(scope.options.elementAttributes).map(function (key) {
		          return key + '="' + scope.options.elementAttributes[key] + '"';
		        }).join(' ');
		      }
		      var modelValue = 'model';
		      scope.options.form = scope.form;
		      if (scope.options.key) {
		        modelValue = 'model[\'' + scope.options.key + '\']';
		      }
		      getTemplate('\n          <formly-form model="' + modelValue + '"\n                       fields="options.fieldGroup"\n                       options="options.options"\n                       form="options.form"\n                       class="' + scope.options.className + '"\n                       ' + extraAttributes + '\n                       is-field-group>\n          </formly-form>\n        ').then(transcludeInWrappers(scope.options, scope.formOptions)).then(setElementTemplate);
		    }
	
		    function addAttributes() {
		      if (scope.options.elementAttributes) {
		        el.attr(scope.options.elementAttributes);
		      }
		    }
	
		    function addClasses() {
		      if (scope.options.className) {
		        el.addClass(scope.options.className);
		      }
		      if (scope.options.type) {
		        el.addClass('formly-field-' + scope.options.type);
		      }
		    }
	
		    function setElementTemplate(templateString) {
		      el.html(asHtml(templateString));
		      $compile(el.contents())(scope);
		      return templateString;
		    }
	
		    function watchFormControl(templateString) {
		      var stopWatchingShowError = _angularFix2['default'].noop;
		      if (scope.options.noFormControl) {
		        return;
		      }
		      var templateEl = _angularFix2['default'].element('<div>' + templateString + '</div>');
		      var ngModelNodes = templateEl[0].querySelectorAll('[ng-model],[data-ng-model]');
	
		      if (ngModelNodes.length) {
		        _angularFix2['default'].forEach(ngModelNodes, function (ngModelNode) {
		          fieldCount++;
		          watchFieldNameOrExistence(ngModelNode.getAttribute('name'));
		        });
		      }
	
		      function watchFieldNameOrExistence(name) {
		        var nameExpressionRegex = /\{\{(.*?)}}/;
		        var nameExpression = nameExpressionRegex.exec(name);
		        if (nameExpression) {
		          name = $interpolate(name)(scope);
		        }
		        watchFieldExistence(name);
		      }
	
		      function watchFieldExistence(name) {
		        scope.$watch('form["' + name + '"]', function formControlChange(formControl) {
		          if (formControl) {
		            if (fieldCount > 1) {
		              if (!scope.options.formControl) {
		                scope.options.formControl = [];
		              }
		              scope.options.formControl.push(formControl);
		            } else {
		              scope.options.formControl = formControl;
		            }
		            scope.fc = scope.options.formControl; // shortcut for template authors
		            stopWatchingShowError();
		            addShowMessagesWatcher();
		            addParsers();
		            addFormatters();
		          }
		        });
		      }
	
		      function addShowMessagesWatcher() {
		        stopWatchingShowError = scope.$watch(function watchShowValidationChange() {
		          var customExpression = formlyConfig.extras.errorExistsAndShouldBeVisibleExpression;
		          var options = scope.options;
		          var formControls = arrayify(scope.fc);
		          if (!formControls.some(function (fc) {
		            return fc.$invalid;
		          })) {
		            return false;
		          } else if (typeof options.validation.show === 'boolean') {
		            return options.validation.show;
		          } else if (customExpression) {
		            return formControls.some(function (fc) {
		              return formlyUtil.formlyEval(scope, customExpression, fc.$modelValue, fc.$viewValue);
		            });
		          } else {
		            return formControls.some(function (fc) {
		              var noTouchedButDirty = _angularFix2['default'].isUndefined(fc.$touched) && fc.$dirty;
		              return fc.$touched || noTouchedButDirty;
		            });
		          }
		        }, function onShowValidationChange(show) {
		          scope.options.validation.errorExistsAndShouldBeVisible = show;
		          scope.showError = show; // shortcut for template authors
		        });
		      }
	
		      function addParsers() {
		        setParsersOrFormatters('parsers');
		      }
	
		      function addFormatters() {
		        setParsersOrFormatters('formatters');
		        var ctrl = scope.fc;
		        var formWasPristine = scope.form.$pristine;
		        if (scope.options.formatters) {
		          (function () {
		            var value = ctrl.$modelValue;
		            ctrl.$formatters.forEach(function (formatter) {
		              value = formatter(value);
		            });
	
		            ctrl.$setViewValue(value);
		            ctrl.$render();
		            ctrl.$setPristine();
		            if (formWasPristine) {
		              scope.form.$setPristine();
		            }
		          })();
		        }
		      }
	
		      function setParsersOrFormatters(which) {
		        var originalThingProp = 'originalParser';
		        if (which === 'formatters') {
		          originalThingProp = 'originalFormatter';
		        }
	
		        // init with type's parsers
		        var things = getThingsFromType(type);
	
		        // get optionsTypes things
		        things = formlyUtil.extendArray(things, getThingsFromOptionsTypes(scope.options.optionsTypes));
	
		        // get field's things
		        things = formlyUtil.extendArray(things, scope.options[which]);
	
		        // convert things into formlyExpression things
		        _angularFix2['default'].forEach(things, function (thing, index) {
		          things[index] = getFormlyExpressionThing(thing);
		        });
	
		        var ngModelCtrls = scope.fc;
		        if (!_angularFix2['default'].isArray(ngModelCtrls)) {
		          ngModelCtrls = [ngModelCtrls];
		        }
	
		        _angularFix2['default'].forEach(ngModelCtrls, function (ngModelCtrl) {
		          var _ngModelCtrl;
	
		          ngModelCtrl['$' + which] = (_ngModelCtrl = ngModelCtrl['$' + which]).concat.apply(_ngModelCtrl, _toConsumableArray(things));
		        });
	
		        function getThingsFromType(theType) {
		          if (!theType) {
		            return [];
		          }
		          if (_angularFix2['default'].isString(theType)) {
		            theType = formlyConfig.getType(theType, true, scope.options);
		          }
		          var typeThings = [];
	
		          // get things from parent
		          if (theType['extends']) {
		            typeThings = formlyUtil.extendArray(typeThings, getThingsFromType(theType['extends']));
		          }
	
		          // get own type's things
		          typeThings = formlyUtil.extendArray(typeThings, getDefaultOptionsProperty(theType, which, []));
	
		          // get things from optionsTypes
		          typeThings = formlyUtil.extendArray(typeThings, getThingsFromOptionsTypes(getDefaultOptionsOptionsTypes(theType)));
	
		          return typeThings;
		        }
	
		        function getThingsFromOptionsTypes() {
		          var optionsTypes = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];
	
		          var optionsTypesThings = [];
		          _angularFix2['default'].forEach(_angularFix2['default'].copy(arrayify(optionsTypes)).reverse(), function (optionsTypeName) {
		            optionsTypesThings = formlyUtil.extendArray(optionsTypesThings, getThingsFromType(optionsTypeName));
		          });
		          return optionsTypesThings;
		        }
	
		        function getFormlyExpressionThing(thing) {
		          formlyExpressionParserOrFormatterFunction[originalThingProp] = thing;
		          return formlyExpressionParserOrFormatterFunction;
	
		          function formlyExpressionParserOrFormatterFunction($viewValue) {
		            var $modelValue = scope.options.value();
		            return formlyUtil.formlyEval(scope, thing, $modelValue, $viewValue);
		          }
		        }
		      }
		    }
	
		    function callLinkFunctions() {
		      if (type && type.link) {
		        type.link.apply(thusly, args);
		      }
		      if (scope.options.link) {
		        scope.options.link.apply(thusly, args);
		      }
		    }
	
		    function runManipulators(manipulators) {
		      return function runManipulatorsOnTemplate(templateToManipulate) {
		        var chain = $q.when(templateToManipulate);
		        _angularFix2['default'].forEach(manipulators, function (manipulator) {
		          chain = chain.then(function (template) {
		            return $q.when(manipulator(template, scope.options, scope)).then(function (newTemplate) {
		              return _angularFix2['default'].isString(newTemplate) ? newTemplate : asHtml(newTemplate);
		            });
		          });
		        });
		        return chain;
		      };
		    }
		  }
	
		  // sort-of stateless util functions
		  function asHtml(el) {
		    var wrapper = _angularFix2['default'].element('<a></a>');
		    return wrapper.append(el).html();
		  }
	
		  function getFieldType(options) {
		    return options.type && formlyConfig.getType(options.type);
		  }
	
		  function getManipulators(options, formOptions) {
		    var preWrapper = [];
		    var postWrapper = [];
		    addManipulators(options.templateManipulators);
		    addManipulators(formOptions.templateManipulators);
		    addManipulators(formlyConfig.templateManipulators);
		    return { preWrapper: preWrapper, postWrapper: postWrapper };
	
		    function addManipulators(manipulators) {
		      /* eslint-disable */ // it doesn't understand this :-(
	
		      var _ref = manipulators || {};
	
		      var _ref$preWrapper = _ref.preWrapper;
		      var pre = _ref$preWrapper === undefined ? [] : _ref$preWrapper;
		      var _ref$postWrapper = _ref.postWrapper;
		      var post = _ref$postWrapper === undefined ? [] : _ref$postWrapper;
	
		      preWrapper = preWrapper.concat(pre);
		      postWrapper = postWrapper.concat(post);
		      /* eslint-enable */
		    }
		  }
	
		  function getFieldTemplate(options) {
		    function fromOptionsOrType(key, fieldType) {
		      if (_angularFix2['default'].isDefined(options[key])) {
		        return options[key];
		      } else if (fieldType && _angularFix2['default'].isDefined(fieldType[key])) {
		        return fieldType[key];
		      }
		    }
	
		    var type = formlyConfig.getType(options.type, true, options);
		    var template = fromOptionsOrType('template', type);
		    var templateUrl = fromOptionsOrType('templateUrl', type);
		    if (_angularFix2['default'].isUndefined(template) && !templateUrl) {
		      throw formlyUsability.getFieldError('type-type-has-no-template', 'Type \'' + options.type + '\' has no template. On element:', options);
		    }
	
		    return getTemplate(templateUrl || template, _angularFix2['default'].isUndefined(template), options);
		  }
	
		  function getTemplate(template, isUrl, options) {
		    var templatePromise = undefined;
		    if (_angularFix2['default'].isFunction(template)) {
		      templatePromise = $q.when(template(options));
		    } else {
		      templatePromise = $q.when(template);
		    }
	
		    if (!isUrl) {
		      return templatePromise;
		    } else {
		      var _ret3 = (function () {
		        var httpOptions = { cache: $templateCache };
		        return {
		          v: templatePromise.then(function (url) {
		            return $http.get(url, httpOptions);
		          }).then(function (response) {
		            return response.data;
		          })['catch'](function handleErrorGettingATemplate(error) {
		            formlyWarn('problem-loading-template-for-templateurl', 'Problem loading template for ' + template, error);
		          })
		        };
		      })();
	
		      if (typeof _ret3 === 'object') return _ret3.v;
		    }
		  }
	
		  function transcludeInWrappers(options, formOptions) {
		    var wrapper = getWrapperOption(options, formOptions);
	
		    return function transcludeTemplate(template) {
		      if (!wrapper.length) {
		        return $q.when(template);
		      }
	
		      wrapper.forEach(function (aWrapper) {
		        formlyUsability.checkWrapper(aWrapper, options);
		        runApiCheck(aWrapper, options);
		      });
		      var promises = wrapper.map(function (w) {
		        return getTemplate(w.template || w.templateUrl, !w.template);
		      });
		      return $q.all(promises).then(function (wrappersTemplates) {
		        wrappersTemplates.forEach(function (wrapperTemplate, index) {
		          formlyUsability.checkWrapperTemplate(wrapperTemplate, wrapper[index]);
		        });
		        wrappersTemplates.reverse(); // wrapper 0 is wrapped in wrapper 1 and so on...
		        var totalWrapper = wrappersTemplates.shift();
		        wrappersTemplates.forEach(function (wrapperTemplate) {
		          totalWrapper = doTransclusion(totalWrapper, wrapperTemplate);
		        });
		        return doTransclusion(totalWrapper, template);
		      });
		    };
		  }
	
		  function doTransclusion(wrapper, template) {
		    var superWrapper = _angularFix2['default'].element('<a></a>'); // this allows people not have to have a single root in wrappers
		    superWrapper.append(wrapper);
		    var transcludeEl = superWrapper.find('formly-transclude');
		    if (!transcludeEl.length) {
		      // try it using our custom find function
		      transcludeEl = formlyUtil.findByNodeName(superWrapper, 'formly-transclude');
		    }
		    transcludeEl.replaceWith(template);
		    return superWrapper.html();
		  }
	
		  function getWrapperOption(options, formOptions) {
		    /* eslint complexity:[2, 6] */
		    var wrapper = options.wrapper;
		    // explicit null means no wrapper
		    if (wrapper === null) {
		      return [];
		    }
	
		    // nothing specified means use the default wrapper for the type
		    if (!wrapper) {
		      // get all wrappers that specify they apply to this type
		      wrapper = arrayify(formlyConfig.getWrapperByType(options.type));
		    } else {
		      wrapper = arrayify(wrapper).map(formlyConfig.getWrapper);
		    }
	
		    // get all wrappers for that the type specified that it uses.
		    var type = formlyConfig.getType(options.type, true, options);
		    if (type && type.wrapper) {
		      var typeWrappers = arrayify(type.wrapper).map(formlyConfig.getWrapper);
		      wrapper = wrapper.concat(typeWrappers);
		    }
	
		    // add form wrappers
		    if (formOptions.wrapper) {
		      var formWrappers = arrayify(formOptions.wrapper).map(formlyConfig.getWrapper);
		      wrapper = wrapper.concat(formWrappers);
		    }
	
		    // add the default wrapper last
		    var defaultWrapper = formlyConfig.getWrapper();
		    if (defaultWrapper) {
		      wrapper.push(defaultWrapper);
		    }
		    return wrapper;
		  }
	
		  function checkApi(options) {
		    formlyApiCheck['throw'](formlyApiCheck.formlyFieldOptions, options, {
		      prefix: 'formly-field directive',
		      url: 'formly-field-directive-validation-failed'
		    });
		    // validate with the type
		    var type = options.type && formlyConfig.getType(options.type);
		    if (type) {
		      runApiCheck(type, options, true);
		    }
		    if (options.expressionProperties && options.expressionProperties.hide) {
		      formlyWarn('dont-use-expressionproperties.hide-use-hideexpression-instead', 'You have specified `hide` in `expressionProperties`. Use `hideExpression` instead', options);
		    }
		  }
	
		  function checkFieldGroupApi(options) {
		    formlyApiCheck['throw'](formlyApiCheck.fieldGroup, options, {
		      prefix: 'formly-field directive',
		      url: 'formly-field-directive-validation-failed'
		    });
		  }
	
		  function runApiCheck(_ref2, options, forType) {
		    var apiCheck = _ref2.apiCheck;
		    var apiCheckInstance = _ref2.apiCheckInstance;
		    var apiCheckFunction = _ref2.apiCheckFunction;
		    var apiCheckOptions = _ref2.apiCheckOptions;
	
		    runApiCheckForType(apiCheck, apiCheckInstance, apiCheckFunction, apiCheckOptions, options);
		    if (forType && options.type) {
		      _angularFix2['default'].forEach(formlyConfig.getTypeHeritage(options.type), function (type) {
		        runApiCheckForType(type.apiCheck, type.apiCheckInstance, type.apiCheckFunction, type.apiCheckOptions, options);
		      });
		    }
		  }
	
		  function runApiCheckForType(apiCheck, apiCheckInstance, apiCheckFunction, apiCheckOptions, options) {
		    /* eslint complexity:[2, 9] */
		    if (!apiCheck) {
		      return;
		    }
		    var instance = apiCheckInstance || formlyConfig.extras.apiCheckInstance || formlyApiCheck;
		    if (instance.config.disabled || _apiCheck2['default'].globalConfig.disabled) {
		      return;
		    }
		    var fn = apiCheckFunction || 'warn';
		    // this is the new API
		    var checkerObjects = apiCheck(instance);
		    _angularFix2['default'].forEach(checkerObjects, function (shape, name) {
		      var checker = instance.shape(shape);
		      var checkOptions = _angularFix2['default'].extend({
		        prefix: 'formly-field type ' + options.type + ' for property ' + name,
		        url: formlyApiCheck.config.output.docsBaseUrl + 'formly-field-type-apicheck-failed'
		      }, apiCheckOptions);
		      instance[fn](checker, options[name], checkOptions);
		    });
		  }
		}
	
		// Stateless util functions
		function getDefaultOptionsOptionsTypes(type) {
		  return getDefaultOptionsProperty(type, 'optionsTypes', []);
		}
	
		function getDefaultOptionsProperty(type, prop, defaultValue) {
		  return type.defaultOptions && type.defaultOptions[prop] || defaultValue;
		}
		module.exports = exports['default'];
	
	/***/ },
	/* 15 */
	/***/ function(module, exports) {
	
		'use strict';
	
		formlyFocus.$inject = ["$timeout", "$document"];
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
		exports['default'] = formlyFocus;
	
		// @ngInject
		function formlyFocus($timeout, $document) {
		  return {
		    restrict: 'A',
		    link: function formlyFocusLink(scope, element, attrs) {
		      var previousEl = null;
		      var el = element[0];
		      var doc = $document[0];
		      attrs.$observe('formlyFocus', function respondToFocusExpressionChange(value) {
		        /* eslint no-bitwise:0 */ // I know what I'm doing. I promise...
		        if (value === 'true') {
		          $timeout(function setElementFocus() {
		            previousEl = doc.activeElement;
		            el.focus();
		          }, ~ ~attrs.focusWait);
		        } else if (value === 'false') {
		          if (doc.activeElement === el) {
		            el.blur();
		            if (attrs.hasOwnProperty('refocus') && previousEl) {
		              previousEl.focus();
		            }
		          }
		        }
		      });
		    }
		  };
		}
		module.exports = exports['default'];
	
	/***/ },
	/* 16 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		formlyForm.$inject = ["formlyUsability", "formlyWarn", "$parse", "formlyConfig", "$interpolate"];
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var _angularFix = __webpack_require__(2);
	
		var _angularFix2 = _interopRequireDefault(_angularFix);
	
		exports['default'] = formlyForm;
	
		/**
		 * @ngdoc directive
		 * @name formlyForm
		 * @restrict AE
		 */
		// @ngInject
		function formlyForm(formlyUsability, formlyWarn, $parse, formlyConfig, $interpolate) {
		  var currentFormId = 1;
		  return {
		    restrict: 'AE',
		    template: formlyFormGetTemplate,
		    replace: true,
		    transclude: true,
		    scope: {
		      fields: '=',
		      model: '=',
		      form: '=?',
		      options: '=?'
		    },
		    controller: 'FormlyFormController',
		    link: formlyFormLink
		  };
	
		  function formlyFormGetTemplate(el, attrs) {
		    var rootEl = getRootEl();
		    var fieldRootEl = getFieldRootEl();
		    var formId = 'formly_' + currentFormId++;
		    var parentFormAttributes = '';
		    if (attrs.hasOwnProperty('isFieldGroup') && el.parent().parent().hasClass('formly')) {
		      parentFormAttributes = copyAttributes(el.parent().parent()[0].attributes);
		    }
		    return '\n        <' + rootEl + ' class="formly"\n                 name="' + getFormName() + '"\n                 role="form" ' + parentFormAttributes + '>\n          <' + fieldRootEl + ' formly-field\n               ng-repeat="field in fields ' + getTrackBy() + '"\n               ' + getHideDirective() + '="!field.hide"\n               class="formly-field"\n               options="field"\n               model="field.model || model"\n               original-model="model"\n               fields="fields"\n               form="theFormlyForm"\n               form-id="' + getFormName() + '"\n               form-state="options.formState"\n               form-options="options"\n               index="$index">\n          </' + fieldRootEl + '>\n          <div ng-transclude class="' + getTranscludeClass() + '"></div>\n        </' + rootEl + '>\n      ';
	
		    function getRootEl() {
		      return attrs.rootEl || 'ng-form';
		    }
	
		    function getFieldRootEl() {
		      return attrs.fieldRootEl || 'div';
		    }
	
		    function getHideDirective() {
		      return attrs.hideDirective || formlyConfig.extras.defaultHideDirective || 'ng-if';
		    }
	
		    function getTrackBy() {
		      if (!attrs.trackBy) {
		        return '';
		      } else {
		        return 'track by ' + attrs.trackBy;
		      }
		    }
	
		    function getFormName() {
		      var formName = formId;
		      var bindName = attrs.bindName;
		      if (bindName) {
		        if (_angularFix2['default'].version.minor < 3) {
		          throw formlyUsability.getFormlyError('bind-name attribute on formly-form not allowed in < angular 1.3');
		        }
		        // we can do a one-time binding here because we know we're in 1.3.x territory
		        formName = $interpolate.startSymbol() + '::\'formly_\' + ' + bindName + $interpolate.endSymbol();
		      }
		      return formName;
		    }
	
		    function getTranscludeClass() {
		      return attrs.transcludeClass || '';
		    }
	
		    function copyAttributes(attributes) {
		      var excluded = ['model', 'form', 'fields', 'options', 'name', 'role', 'class', 'data-model', 'data-form', 'data-fields', 'data-options', 'data-name'];
		      var arrayAttrs = [];
		      _angularFix2['default'].forEach(attributes, function (_ref) {
		        var nodeName = _ref.nodeName;
		        var value = _ref.value;
	
		        if (nodeName !== 'undefined' && excluded.indexOf(nodeName) === -1) {
		          arrayAttrs.push(toKebabCase(nodeName) + '="' + value + '"');
		        }
		      });
		      return arrayAttrs.join(' ');
		    }
		  }
	
		  function formlyFormLink(scope, el, attrs) {
		    setFormController();
		    fixChromeAutocomplete();
	
		    function setFormController() {
		      var formId = attrs.name;
		      scope.formId = formId;
		      scope.theFormlyForm = scope[formId];
		      if (attrs.form) {
		        var getter = $parse(attrs.form);
		        var setter = getter.assign;
		        var parentForm = getter(scope.$parent);
		        if (parentForm) {
		          scope.theFormlyForm = parentForm;
		          if (scope[formId]) {
		            scope.theFormlyForm.$removeControl(scope[formId]);
		          }
	
		          // this next line is probably one of the more dangerous things that angular-formly does to improve the
		          // API for angular-formly forms. It ensures that the NgModelControllers inside of formly-form will be
		          // attached to the form that is passed to formly-form rather than the one that formly-form creates
		          // this is necessary because it's confusing to have a step between the form you pass in
		          // and the fields in that form. It also is because angular doesn't propagate properties like $submitted down
		          // to children forms :-( This line was added to solve this issue:
		          // https://github.com/formly-js/angular-formly/issues/287
		          // luckily, this is how the formController has been accessed by the NgModelController since angular 1.0.0
		          // so I expect it will remain this way for the life of angular 1.x
		          el.removeData('$formController');
		        } else {
		          setter(scope.$parent, scope[formId]);
		        }
		      }
		      if (!scope.theFormlyForm && !formlyConfig.disableWarnings) {
		        /* eslint no-console:0 */
		        formlyWarn('formly-form-has-no-formcontroller', 'Your formly-form does not have a `form` property. Many functions of the form (like validation) may not work', el, scope);
		      }
		    }
	
		    /*
		     * chrome autocomplete lameness
		     * see https://code.google.com/p/chromium/issues/detail?id=468153#c14
		     * ლ(ಠ益ಠლ)   (╯°□°)╯︵ ┻━┻    (◞‸◟；)
		     */
		    function fixChromeAutocomplete() {
		      var global = formlyConfig.extras.removeChromeAutoComplete === true;
		      var offInstance = scope.options && scope.options.removeChromeAutoComplete === false;
		      var onInstance = scope.options && scope.options.removeChromeAutoComplete === true;
		      if (global && !offInstance || onInstance) {
		        var input = document.createElement('input');
		        input.setAttribute('autocomplete', 'address-level4');
		        input.setAttribute('hidden', 'true');
		        el[0].appendChild(input);
		      }
		    }
		  }
	
		  // stateless util functions
		  function toKebabCase(string) {
		    if (string) {
		      return string.replace(/([A-Z])/g, function ($1) {
		        return '-' + $1.toLowerCase();
		      });
		    } else {
		      return '';
		    }
		  }
		}
		module.exports = exports['default'];
	
	/***/ },
	/* 17 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		FormlyFormController.$inject = ["formlyUsability", "formlyWarn", "formlyConfig", "$parse", "$scope", "formlyApiCheck", "formlyUtil"];
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
		var _slice = Array.prototype.slice;
		exports['default'] = FormlyFormController;
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }
	
		var _angularFix = __webpack_require__(2);
	
		var _angularFix2 = _interopRequireDefault(_angularFix);
	
		function isFieldGroup(field) {
		  return field && !!field.fieldGroup;
		}
	
		// @ngInject
	
		function FormlyFormController(formlyUsability, formlyWarn, formlyConfig, $parse, $scope, formlyApiCheck, formlyUtil) {
	
		  setupOptions();
		  $scope.model = $scope.model || {};
		  setupFields();
	
		  // watch the model and evaluate watch expressions that depend on it.
		  if (!$scope.options.manualModelWatcher) {
		    $scope.$watch('model', onModelOrFormStateChange, true);
		  } else if (_angularFix2['default'].isFunction($scope.options.manualModelWatcher)) {
		    $scope.$watch($scope.options.manualModelWatcher, onModelOrFormStateChange, true);
		  }
	
		  if ($scope.options.formState) {
		    $scope.$watch('options.formState', onModelOrFormStateChange, true);
		  }
	
		  function onModelOrFormStateChange() {
		    _angularFix2['default'].forEach($scope.fields, runFieldExpressionProperties);
		  }
	
		  function validateFormControl(formControl, promise) {
		    var validate = formControl.$validate;
		    if (promise) {
		      promise.then(function () {
		        return validate.apply(formControl);
		      });
		    } else {
		      validate();
		    }
		  }
	
		  function runFieldExpressionProperties(field, index) {
		    var model = field.model || $scope.model;
		    var promise = field.runExpressions && field.runExpressions();
		    if (field.hideExpression) {
		      // can't use hide with expressionProperties reliably
		      var val = model[field.key];
		      field.hide = evalCloseToFormlyExpression(field.hideExpression, val, field, index, { model: model });
		    }
		    if (field.extras && field.extras.validateOnModelChange && field.formControl) {
		      if (_angularFix2['default'].isArray(field.formControl)) {
		        _angularFix2['default'].forEach(field.formControl, function (formControl) {
		          validateFormControl(formControl, promise);
		        });
		      } else {
		        validateFormControl(field.formControl, promise);
		      }
		    }
		  }
	
		  function setupFields() {
		    $scope.fields = $scope.fields || [];
	
		    checkDeprecatedOptions($scope.options);
	
		    var fieldTransforms = $scope.options.fieldTransform || formlyConfig.extras.fieldTransform;
	
		    if (!_angularFix2['default'].isArray(fieldTransforms)) {
		      fieldTransforms = [fieldTransforms];
		    }
	
		    _angularFix2['default'].forEach(fieldTransforms, function transformFields(fieldTransform) {
		      if (fieldTransform) {
		        $scope.fields = fieldTransform($scope.fields, $scope.model, $scope.options, $scope.form);
		        if (!$scope.fields) {
		          throw formlyUsability.getFormlyError('fieldTransform must return an array of fields');
		        }
		      }
		    });
	
		    setupModels();
	
		    if ($scope.options.watchAllExpressions) {
		      _angularFix2['default'].forEach($scope.fields, setupHideExpressionWatcher);
		    }
	
		    _angularFix2['default'].forEach($scope.fields, attachKey); // attaches a key based on the index if a key isn't specified
		    _angularFix2['default'].forEach($scope.fields, setupWatchers); // setup watchers for all fields
		  }
	
		  function checkDeprecatedOptions(options) {
		    if (formlyConfig.extras.fieldTransform && _angularFix2['default'].isFunction(formlyConfig.extras.fieldTransform)) {
		      formlyWarn('fieldtransform-as-a-function-deprecated', 'fieldTransform as a function has been deprecated.', 'Attempted for formlyConfig.extras: ' + formlyConfig.extras.fieldTransform.name, formlyConfig.extras);
		    } else if (options.fieldTransform && _angularFix2['default'].isFunction(options.fieldTransform)) {
		      formlyWarn('fieldtransform-as-a-function-deprecated', 'fieldTransform as a function has been deprecated.', 'Attempted for form', options);
		    }
		  }
	
		  function setupOptions() {
		    formlyApiCheck['throw']([formlyApiCheck.formOptionsApi.optional], [$scope.options], { prefix: 'formly-form options check' });
		    $scope.options = $scope.options || {};
		    $scope.options.formState = $scope.options.formState || {};
	
		    _angularFix2['default'].extend($scope.options, {
		      updateInitialValue: updateInitialValue,
		      resetModel: resetModel
		    });
		  }
	
		  function updateInitialValue() {
		    _angularFix2['default'].forEach($scope.fields, function (field) {
		      if (isFieldGroup(field) && field.options) {
		        field.options.updateInitialValue();
		      } else {
		        field.updateInitialValue();
		      }
		    });
		  }
	
		  function resetModel() {
		    _angularFix2['default'].forEach($scope.fields, function (field) {
		      if (isFieldGroup(field) && field.options) {
		        field.options.resetModel();
		      } else if (field.resetModel) {
		        field.resetModel();
		      }
		    });
		  }
	
		  function setupModels() {
		    // a set of field models that are already watched (the $scope.model will have its own watcher)
		    var watchedModels = [$scope.model];
		    // we will not set up automatic model watchers if manual mode is set
		    var manualModelWatcher = $scope.options.manualModelWatcher;
	
		    if ($scope.options.formState) {
		      // $scope.options.formState will have its own watcher
		      watchedModels.push($scope.options.formState);
		    }
	
		    _angularFix2['default'].forEach($scope.fields, function (field) {
		      var isNewModel = initModel(field);
	
		      if (field.model && isNewModel && watchedModels.indexOf(field.model) === -1 && !manualModelWatcher) {
		        $scope.$watch(function () {
		          return field.model;
		        }, onModelOrFormStateChange, true);
		        watchedModels.push(field.model);
		      }
		    });
		  }
	
		  function setupHideExpressionWatcher(field, index) {
		    if (field.hideExpression) {
		      (function () {
		        // can't use hide with expressionProperties reliably
		        var model = field.model || $scope.model;
		        $scope.$watch(function hideExpressionWatcher() {
		          var val = model[field.key];
		          return evalCloseToFormlyExpression(field.hideExpression, val, field, index, { model: model });
		        }, function (hide) {
		          return field.hide = hide;
		        }, true);
		      })();
		    }
		  }
	
		  function initModel(field) {
		    var isNewModel = true;
	
		    if (_angularFix2['default'].isString(field.model)) {
		      (function () {
		        var expression = field.model;
	
		        isNewModel = !referencesCurrentlyWatchedModel(expression);
	
		        field.model = resolveStringModel(expression);
	
		        $scope.$watch(function () {
		          return resolveStringModel(expression);
		        }, function (model) {
		          return field.model = model;
		        });
		      })();
		    }
	
		    return isNewModel;
	
		    function resolveStringModel(expression) {
		      var index = $scope.fields.indexOf(field);
		      var model = evalCloseToFormlyExpression(expression, undefined, field, index, { model: $scope.model });
	
		      if (!model) {
		        throw formlyUsability.getFieldError('field-model-must-be-initialized', 'Field model must be initialized. When specifying a model as a string for a field, the result of the' + ' expression must have been initialized ahead of time.', field);
		      }
	
		      return model;
		    }
		  }
	
		  function referencesCurrentlyWatchedModel(expression) {
		    return ['model', 'formState'].some(function (item) {
		      return formlyUtil.startsWith(expression, item + '.') || formlyUtil.startsWith(expression, item + '[');
		    });
		  }
	
		  function attachKey(field, index) {
		    if (!isFieldGroup(field)) {
		      field.key = field.key || index || 0;
		    }
		  }
	
		  function setupWatchers(field, index) {
		    if (!_angularFix2['default'].isDefined(field.watcher)) {
		      return;
		    }
		    var watchers = field.watcher;
		    if (!_angularFix2['default'].isArray(watchers)) {
		      watchers = [watchers];
		    }
		    _angularFix2['default'].forEach(watchers, function setupWatcher(watcher) {
		      if (!_angularFix2['default'].isDefined(watcher.listener) && !watcher.runFieldExpressions) {
		        throw formlyUsability.getFieldError('all-field-watchers-must-have-a-listener', 'All field watchers must have a listener', field);
		      }
		      var watchExpression = getWatchExpression(watcher, field, index);
		      var watchListener = getWatchListener(watcher, field, index);
	
		      var type = watcher.type || '$watch';
		      watcher.stopWatching = $scope[type](watchExpression, watchListener, watcher.watchDeep);
		    });
		  }
	
		  function getWatchExpression(watcher, field, index) {
		    var watchExpression = undefined;
		    if (!_angularFix2['default'].isUndefined(watcher.expression)) {
		      watchExpression = watcher.expression;
		    } else if (field.key) {
		      watchExpression = 'model[\'' + field.key.toString().split('.').join('\'][\'') + '\']';
		    }
		    if (_angularFix2['default'].isFunction(watchExpression)) {
		      (function () {
		        // wrap the field's watch expression so we can call it with the field as the first arg
		        // and the stop function as the last arg as a helper
		        var originalExpression = watchExpression;
		        watchExpression = function formlyWatchExpression() {
		          var args = modifyArgs.apply(undefined, [watcher, index].concat(_slice.call(arguments)));
		          return originalExpression.apply(undefined, _toConsumableArray(args));
		        };
		        watchExpression.displayName = 'Formly Watch Expression for field for ' + field.key;
		      })();
		    } else if (field.model) {
		      watchExpression = $parse(watchExpression).bind(null, $scope, { model: field.model });
		    }
		    return watchExpression;
		  }
	
		  function getWatchListener(watcher, field, index) {
		    var watchListener = watcher.listener;
		    if (_angularFix2['default'].isFunction(watchListener) || watcher.runFieldExpressions) {
		      (function () {
		        // wrap the field's watch listener so we can call it with the field as the first arg
		        // and the stop function as the last arg as a helper
		        var originalListener = watchListener;
		        watchListener = function formlyWatchListener() {
		          var value = undefined;
		          if (originalListener) {
		            var args = modifyArgs.apply(undefined, [watcher, index].concat(_slice.call(arguments)));
		            value = originalListener.apply(undefined, _toConsumableArray(args));
		          }
		          if (watcher.runFieldExpressions) {
		            runFieldExpressionProperties(field, index);
		          }
		          return value;
		        };
		        watchListener.displayName = 'Formly Watch Listener for field for ' + field.key;
		      })();
		    }
		    return watchListener;
		  }
	
		  function modifyArgs(watcher, index) {
		    for (var _len = arguments.length, originalArgs = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
		      originalArgs[_key - 2] = arguments[_key];
		    }
	
		    return [$scope.fields[index]].concat(originalArgs, [watcher.stopWatching]);
		  }
	
		  function evalCloseToFormlyExpression(expression, val, field, index) {
		    var extraLocals = arguments.length <= 4 || arguments[4] === undefined ? {} : arguments[4];
	
		    extraLocals = _angularFix2['default'].extend(getFormlyFieldLikeLocals(field, index), extraLocals);
		    return formlyUtil.formlyEval($scope, expression, val, val, extraLocals);
		  }
	
		  function getFormlyFieldLikeLocals(field, index) {
		    // this makes it closer to what a regular formlyExpression would be
		    return {
		      model: field.model,
		      options: field,
		      index: index,
		      formState: $scope.options.formState,
		      originalModel: $scope.model,
		      formOptions: $scope.options,
		      formId: $scope.formId
		    };
		  }
		}
	
		module.exports = exports['default'];
	
	/***/ },
	/* 18 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		addFormlyNgModelAttrsManipulator.$inject = ["formlyConfig", "$interpolate"];
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var _angularFix = __webpack_require__(2);
	
		var _angularFix2 = _interopRequireDefault(_angularFix);
	
		var _otherUtils = __webpack_require__(9);
	
		exports['default'] = addFormlyNgModelAttrsManipulator;
	
		// @ngInject
		function addFormlyNgModelAttrsManipulator(formlyConfig, $interpolate) {
		  if (formlyConfig.extras.disableNgModelAttrsManipulator) {
		    return;
		  }
		  formlyConfig.templateManipulators.preWrapper.push(ngModelAttrsManipulator);
	
		  function ngModelAttrsManipulator(template, options, scope) {
		    var node = document.createElement('div');
		    var skip = options.extras && options.extras.skipNgModelAttrsManipulator;
		    if (skip === true) {
		      return template;
		    }
		    node.innerHTML = template;
	
		    var modelNodes = getNgModelNodes(node, skip);
		    if (!modelNodes || !modelNodes.length) {
		      return template;
		    }
	
		    addIfNotPresent(modelNodes, 'id', scope.id);
		    addIfNotPresent(modelNodes, 'name', scope.name || scope.id);
	
		    addValidation();
		    alterNgModelAttr();
		    addModelOptions();
		    addTemplateOptionsAttrs();
		    addNgModelElAttrs();
	
		    return node.innerHTML;
	
		    function addValidation() {
		      if (_angularFix2['default'].isDefined(options.validators) || _angularFix2['default'].isDefined(options.validation.messages)) {
		        addIfNotPresent(modelNodes, 'formly-custom-validation', '');
		      }
		    }
	
		    function alterNgModelAttr() {
		      if (isPropertyAccessor(options.key)) {
		        addRegardlessOfPresence(modelNodes, 'ng-model', 'model.' + options.key);
		      }
		    }
	
		    function addModelOptions() {
		      if (_angularFix2['default'].isDefined(options.modelOptions)) {
		        addIfNotPresent(modelNodes, 'ng-model-options', 'options.modelOptions');
		        if (options.modelOptions.getterSetter) {
		          addRegardlessOfPresence(modelNodes, 'ng-model', 'options.value');
		        }
		      }
		    }
	
		    function addTemplateOptionsAttrs() {
		      if (!options.templateOptions && !options.expressionProperties) {
		        // no need to run these if there are no templateOptions or expressionProperties
		        return;
		      }
		      var to = options.templateOptions || {};
		      var ep = options.expressionProperties || {};
	
		      var ngModelAttributes = getBuiltInAttributes();
	
		      // extend with the user's specifications winning
		      _angularFix2['default'].extend(ngModelAttributes, options.ngModelAttrs);
	
		      // Feel free to make this more simple :-)
		      _angularFix2['default'].forEach(ngModelAttributes, function (val, name) {
		        /* eslint complexity:[2, 14] */
		        var attrVal = undefined,
		            attrName = undefined;
		        var ref = 'options.templateOptions[\'' + name + '\']';
		        var toVal = to[name];
		        var epVal = getEpValue(ep, name);
	
		        var inTo = _angularFix2['default'].isDefined(toVal);
		        var inEp = _angularFix2['default'].isDefined(epVal);
		        if (val.value) {
		          // I realize this looks backwards, but it's right, trust me...
		          attrName = val.value;
		          attrVal = name;
		        } else if (val.statement && inTo) {
		          attrName = val.statement;
		          if (_angularFix2['default'].isString(to[name])) {
		            attrVal = '$eval(' + ref + ')';
		          } else if (_angularFix2['default'].isFunction(to[name])) {
		            attrVal = ref + '(model[options.key], options, this, $event)';
		          } else {
		            throw new Error('options.templateOptions.' + name + ' must be a string or function: ' + JSON.stringify(options));
		          }
		        } else if (val.bound && inEp) {
		          attrName = val.bound;
		          attrVal = ref;
		        } else if ((val.attribute || val.boolean) && inEp) {
		          attrName = val.attribute || val.boolean;
		          attrVal = '' + $interpolate.startSymbol() + ref + $interpolate.endSymbol();
		        } else if (val.attribute && inTo) {
		          attrName = val.attribute;
		          attrVal = toVal;
		        } else if (val.boolean) {
		          if (inTo && !inEp && toVal) {
		            attrName = val.boolean;
		            attrVal = true;
		          } else {
		            /* eslint no-empty:0 */
		            // empty to illustrate that a boolean will not be added via val.bound
		            // if you want it added via val.bound, then put it in expressionProperties
		          }
		        } else if (val.bound && inTo) {
		            attrName = val.bound;
		            attrVal = ref;
		          }
	
		        if (_angularFix2['default'].isDefined(attrName) && _angularFix2['default'].isDefined(attrVal)) {
		          addIfNotPresent(modelNodes, attrName, attrVal);
		        }
		      });
		    }
	
		    function addNgModelElAttrs() {
		      _angularFix2['default'].forEach(options.ngModelElAttrs, function (val, name) {
		        addRegardlessOfPresence(modelNodes, name, val);
		      });
		    }
		  }
	
		  // Utility functions
		  function getNgModelNodes(node, skip) {
		    var selectorNot = _angularFix2['default'].isString(skip) ? ':not(' + skip + ')' : '';
		    var skipNot = ':not([formly-skip-ng-model-attrs-manipulator])';
		    var query = '[ng-model]' + selectorNot + skipNot + ', [data-ng-model]' + selectorNot + skipNot;
		    try {
		      return node.querySelectorAll(query);
		    } catch (e) {
		      //this code is needed for IE8, as it does not support the CSS3 ':not' selector
		      //it should be removed when IE8 support is dropped
		      return getNgModelNodesFallback(node, skip);
		    }
		  }
	
		  function getNgModelNodesFallback(node, skip) {
		    var allNgModelNodes = node.querySelectorAll('[ng-model], [data-ng-model]');
		    var matchingNgModelNodes = [];
	
		    //make sure this array is compatible with NodeList type by adding an 'item' function
		    matchingNgModelNodes.item = function (i) {
		      return this[i];
		    };
	
		    for (var i = 0; i < allNgModelNodes.length; i++) {
		      var ngModelNode = allNgModelNodes[i];
		      if (!ngModelNode.hasAttribute('formly-skip-ng-model-attrs-manipulator') && !(_angularFix2['default'].isString(skip) && nodeMatches(ngModelNode, skip))) {
		        matchingNgModelNodes.push(ngModelNode);
		      }
		    }
	
		    return matchingNgModelNodes;
		  }
	
		  function nodeMatches(node, selector) {
		    var div = document.createElement('div');
		    div.innerHTML = node.outerHTML;
		    return div.querySelector(selector);
		  }
	
		  function getBuiltInAttributes() {
		    var ngModelAttributes = {
		      focus: {
		        attribute: 'formly-focus'
		      }
		    };
		    var boundOnly = [];
		    var bothBooleanAndBound = ['required', 'disabled'];
		    var bothAttributeAndBound = ['pattern', 'minlength'];
		    var statementOnly = ['change', 'keydown', 'keyup', 'keypress', 'click', 'focus', 'blur'];
		    var attributeOnly = ['placeholder', 'min', 'max', 'step', 'tabindex', 'type'];
		    if (formlyConfig.extras.ngModelAttrsManipulatorPreferUnbound) {
		      bothAttributeAndBound.push('maxlength');
		    } else {
		      boundOnly.push('maxlength');
		    }
	
		    _angularFix2['default'].forEach(boundOnly, function (item) {
		      ngModelAttributes[item] = { bound: 'ng-' + item };
		    });
	
		    _angularFix2['default'].forEach(bothBooleanAndBound, function (item) {
		      ngModelAttributes[item] = { boolean: item, bound: 'ng-' + item };
		    });
	
		    _angularFix2['default'].forEach(bothAttributeAndBound, function (item) {
		      ngModelAttributes[item] = { attribute: item, bound: 'ng-' + item };
		    });
	
		    _angularFix2['default'].forEach(statementOnly, function (item) {
		      var propName = 'on' + item.substr(0, 1).toUpperCase() + item.substr(1);
		      ngModelAttributes[propName] = { statement: 'ng-' + item };
		    });
	
		    _angularFix2['default'].forEach(attributeOnly, function (item) {
		      ngModelAttributes[item] = { attribute: item };
		    });
		    return ngModelAttributes;
		  }
	
		  function getEpValue(ep, name) {
		    return ep['templateOptions.' + name] || ep['templateOptions[\'' + name + '\']'] || ep['templateOptions["' + name + '"]'];
		  }
	
		  function addIfNotPresent(nodes, attr, val) {
		    _angularFix2['default'].forEach(nodes, function (node) {
		      if (!node.getAttribute(attr)) {
		        node.setAttribute(attr, val);
		      }
		    });
		  }
	
		  function addRegardlessOfPresence(nodes, attr, val) {
		    _angularFix2['default'].forEach(nodes, function (node) {
		      node.setAttribute(attr, val);
		    });
		  }
	
		  function isPropertyAccessor(key) {
		    return (0, _otherUtils.contains)(key, '.') || (0, _otherUtils.contains)(key, '[') && (0, _otherUtils.contains)(key, ']');
		  }
		}
		module.exports = exports['default'];
	
	/***/ },
	/* 19 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		addCustomTags.$inject = ["$document"];
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var _angularFix = __webpack_require__(2);
	
		var _angularFix2 = _interopRequireDefault(_angularFix);
	
		exports['default'] = addCustomTags;
	
		// @ngInject
		function addCustomTags($document) {
		  // IE8 check ->
		  // https://msdn.microsoft.com/en-us/library/cc196988(v=vs.85).aspx
		  if ($document && $document.documentMode < 9) {
		    (function () {
		      var document = $document.get(0);
		      // add the custom elements that we need for formly
		      var customElements = ['formly-field', 'formly-form'];
		      _angularFix2['default'].forEach(customElements, function (el) {
		        document.createElement(el);
		      });
		    })();
		  }
		}
		module.exports = exports['default'];
	
	/***/ }
	/******/ ])
	});
	;

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	//! api-check version 7.5.5 built with ♥ by Kent C. Dodds <kent@doddsfamily.us> (http://kent.doddsfamily.us) (ó ì_í)=óò=(ì_í ò)
	
	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory();
		else if(typeof define === 'function' && define.amd)
			define(factory);
		else if(typeof exports === 'object')
			exports["apiCheck"] = factory();
		else
			root["apiCheck"] = factory();
	})(this, function() {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var _apiCheck = __webpack_require__(1);
	
		var _apiCheck2 = _interopRequireDefault(_apiCheck);
	
		exports['default'] = _apiCheck2['default'];
		module.exports = exports['default'];
	
	/***/ },
	/* 1 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var stringify = __webpack_require__(2);
		var apiCheckUtil = __webpack_require__(3);
		var each = apiCheckUtil.each;
		var isError = apiCheckUtil.isError;
		var t = apiCheckUtil.t;
		var arrayify = apiCheckUtil.arrayify;
		var getCheckerDisplay = apiCheckUtil.getCheckerDisplay;
		var typeOf = apiCheckUtil.typeOf;
		var getError = apiCheckUtil.getError;
	
		var checkers = __webpack_require__(4);
		var apiCheckApis = getApiCheckApis();
	
		module.exports = getApiCheckInstance;
		module.exports.VERSION = ("7.5.5");
		module.exports.utils = apiCheckUtil;
		module.exports.globalConfig = {
		  verbose: false,
		  disabled: false
		};
	
		var apiCheckApiCheck = getApiCheckInstance({
		  output: { prefix: 'apiCheck' }
		});
		module.exports.internalChecker = apiCheckApiCheck;
	
		each(checkers, function (checker, name) {
		  return module.exports[name] = checker;
		});
	
		function getApiCheckInstance() {
		  var config = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
		  var extraCheckers = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
		  /* eslint complexity:[2, 6] */
		  if (apiCheckApiCheck && arguments.length) {
		    apiCheckApiCheck['throw'](apiCheckApis.getApiCheckInstanceCheckers, arguments, {
		      prefix: 'creating an apiCheck instance'
		    });
		  }
	
		  var additionalProperties = {
		    'throw': getApiCheck(true),
		    warn: getApiCheck(false),
		    getErrorMessage: getErrorMessage,
		    handleErrorMessage: handleErrorMessage,
		    config: {
		      output: config.output || {
		        prefix: '',
		        suffix: '',
		        docsBaseUrl: ''
		      },
		      verbose: config.verbose || false,
		      disabled: config.disabled || false
		    },
		    utils: apiCheckUtil
		  };
	
		  each(additionalProperties, function (wrapper, name) {
		    return apiCheck[name] = wrapper;
		  });
	
		  var disabled = apiCheck.disabled || module.exports.globalConfig.disabled;
		  each(checkers.getCheckers(disabled), function (checker, name) {
		    return apiCheck[name] = checker;
		  });
		  each(extraCheckers, function (checker, name) {
		    return apiCheck[name] = checker;
		  });
	
		  return apiCheck;
	
		  /**
		   * This is the instance function. Other things are attached to this see additional properties above.
		   * @param {Array} api - the checkers to check with
		   * @param {Array} args - the args to check
		   * @param {Object} output - output options
		   * @returns {Object} - if this has a failed = true property, then it failed
		   */
		  function apiCheck(api, args, output) {
		    /* eslint complexity:[2, 8] */
		    if (apiCheck.config.disabled || module.exports.globalConfig.disabled) {
		      return {
		        apiTypes: {}, argTypes: {},
		        passed: true, message: '',
		        failed: false
		      }; // empty version of what is normally returned
		    }
		    checkApiCheckApi(arguments);
		    if (!Array.isArray(api)) {
		      api = [api];
		      args = [args];
		    } else {
		      // turn arguments into an array
		      args = Array.prototype.slice.call(args);
		    }
		    var messages = checkEnoughArgs(api, args);
		    if (!messages.length) {
		      // this is where we actually go perform the checks.
		      messages = checkApiWithArgs(api, args);
		    }
	
		    var returnObject = getTypes(api, args);
		    returnObject.args = args;
		    if (messages.length) {
		      returnObject.message = apiCheck.getErrorMessage(api, args, messages, output);
		      returnObject.failed = true;
		      returnObject.passed = false;
		    } else {
		      returnObject.message = '';
		      returnObject.failed = false;
		      returnObject.passed = true;
		    }
		    return returnObject;
		  }
	
		  /**
		   * checkApiCheckApi, should be read like: check apiCheck api. As in, check the api for apiCheck :-)
		   * @param {Array} checkApiArgs - args provided to apiCheck function
		   */
		  function checkApiCheckApi(checkApiArgs) {
		    var api = checkApiArgs[0];
		    var args = checkApiArgs[1];
		    var isArrayOrArgs = Array.isArray(args) || args && typeof args === 'object' && typeof args.length === 'number';
	
		    if (Array.isArray(api) && !isArrayOrArgs) {
		      throw new Error(getErrorMessage(api, [args], ['If an array is provided for the api, an array must be provided for the args as well.'], { prefix: 'apiCheck' }));
		    }
		    // dog fooding here
		    var errors = checkApiWithArgs(apiCheckApis.checkApiCheckApi, checkApiArgs);
		    if (errors.length) {
		      var message = apiCheck.getErrorMessage(apiCheckApis.checkApiCheckApi, checkApiArgs, errors, {
		        prefix: 'apiCheck'
		      });
		      apiCheck.handleErrorMessage(message, true);
		    }
		  }
	
		  function getApiCheck(shouldThrow) {
		    return function apiCheckWrapper(api, args, output) {
		      var result = apiCheck(api, args, output);
		      apiCheck.handleErrorMessage(result.message, shouldThrow);
		      return result; // wont get here if an error is thrown
		    };
		  }
	
		  function handleErrorMessage(message, shouldThrow) {
		    if (shouldThrow && message) {
		      throw new Error(message);
		    } else if (message) {
		      /* eslint no-console:0 */
		      console.warn(message);
		    }
		  }
	
		  function getErrorMessage(api, args) {
		    var messages = arguments.length <= 2 || arguments[2] === undefined ? [] : arguments[2];
		    var output = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	
		    var gOut = apiCheck.config.output || {};
		    var prefix = getPrefix();
		    var suffix = getSuffix();
		    var url = getUrl();
		    var message = 'apiCheck failed! ' + messages.join(', ');
		    var passedAndShouldHavePassed = '\n\n' + buildMessageFromApiAndArgs(api, args);
		    return (prefix + ' ' + message + ' ' + suffix + ' ' + (url || '') + passedAndShouldHavePassed).trim();
	
		    function getPrefix() {
		      var p = output.onlyPrefix;
		      if (!p) {
		        p = ((gOut.prefix || '') + ' ' + (output.prefix || '')).trim();
		      }
		      return p;
		    }
	
		    function getSuffix() {
		      var s = output.onlySuffix;
		      if (!s) {
		        s = ((output.suffix || '') + ' ' + (gOut.suffix || '')).trim();
		      }
		      return s;
		    }
	
		    function getUrl() {
		      var u = output.url;
		      if (!u) {
		        u = gOut.docsBaseUrl && output.urlSuffix && ('' + gOut.docsBaseUrl + output.urlSuffix).trim();
		      }
		      return u;
		    }
		  }
	
		  function buildMessageFromApiAndArgs(api, args) {
		    var _getTypes = getTypes(api, args);
	
		    var apiTypes = _getTypes.apiTypes;
		    var argTypes = _getTypes.argTypes;
	
		    var copy = Array.prototype.slice.call(args || []);
		    var replacedItems = [];
		    replaceFunctionWithName(copy);
		    var passedArgs = getObjectString(copy);
		    argTypes = getObjectString(argTypes);
		    apiTypes = getObjectString(apiTypes);
	
		    return generateMessage();
	
		    // functions
	
		    function replaceFunctionWithName(obj) {
		      each(obj, function (val, name) {
		        /* eslint complexity:[2, 6] */
		        if (replacedItems.indexOf(val) === -1) {
		          // avoid recursive problems
		          replacedItems.push(val);
		          if (typeof val === 'object') {
		            replaceFunctionWithName(obj);
		          } else if (typeof val === 'function') {
		            obj[name] = val.displayName || val.name || 'anonymous function';
		          }
		        }
		      });
		    }
	
		    function getObjectString(types) {
		      if (!types || !types.length) {
		        return 'nothing';
		      } else if (types && types.length === 1) {
		        types = types[0];
		      }
		      return stringify(types, null, 2);
		    }
	
		    function generateMessage() {
		      var n = '\n';
		      var useS = true;
		      if (args && args.length === 1) {
		        if (typeof args[0] === 'object' && args[0] !== null) {
		          useS = !!Object.keys(args[0]).length;
		        } else {
		          useS = false;
		        }
		      }
		      var types = 'type' + (useS ? 's' : '');
		      var newLine = n + n;
		      return 'You passed:' + n + passedArgs + newLine + ('With the ' + types + ':' + n + argTypes + newLine) + ('The API calls for:' + n + apiTypes);
		    }
		  }
	
		  function getTypes(api, args) {
		    api = arrayify(api);
		    args = arrayify(args);
		    var apiTypes = api.map(function (checker, index) {
		      var specified = module.exports.globalConfig.hasOwnProperty('verbose');
		      return getCheckerDisplay(checker, {
		        terse: specified ? !module.exports.globalConfig.verbose : !apiCheck.config.verbose,
		        obj: args[index],
		        addHelpers: true
		      });
		    });
		    var argTypes = args.map(function (arg) {
		      return getArgDisplay(arg, []);
		    });
		    return { argTypes: argTypes, apiTypes: apiTypes };
		  }
		}
	
		// STATELESS FUNCTIONS
	
		/**
		 * This is where the magic happens for actually checking the arguments with the api.
		 * @param {Array} api - checkers
		 * @param  {Array} args - and arguments object
		 * @returns {Array} - the error messages
		 */
		function checkApiWithArgs(api, args) {
		  /* eslint complexity:[2, 7] */
		  var messages = [];
		  var failed = false;
		  var checkerIndex = 0;
		  var argIndex = 0;
		  var arg = undefined,
		      checker = undefined,
		      res = undefined,
		      lastChecker = undefined,
		      argName = undefined,
		      argFailed = undefined,
		      skipPreviousChecker = undefined;
		  /* jshint -W084 */
		  while ((checker = api[checkerIndex++]) && argIndex < args.length) {
		    arg = args[argIndex++];
		    argName = 'Argument ' + argIndex + (checker.isOptional ? ' (optional)' : '');
		    res = checker(arg, 'value', argName);
		    argFailed = isError(res);
		    lastChecker = checkerIndex >= api.length;
		    skipPreviousChecker = checkerIndex > 1 && api[checkerIndex - 1].isOptional;
		    if (argFailed && lastChecker || argFailed && !lastChecker && !checker.isOptional && !skipPreviousChecker) {
		      failed = true;
		      messages.push(getCheckerErrorMessage(res, checker, arg));
		    } else if (argFailed && checker.isOptional) {
		      argIndex--;
		    } else {
		      messages.push(t(argName) + ' passed');
		    }
		  }
		  return failed ? messages : [];
		}
	
		checkerTypeType.type = 'function with __apiCheckData property and `${function.type}` property';
		function checkerTypeType(checkerType, name, location) {
		  var apiCheckDataChecker = checkers.shape({
		    type: checkers.string,
		    optional: checkers.bool
		  });
		  var asFunc = checkers.func.withProperties({ __apiCheckData: apiCheckDataChecker });
		  var asShape = checkers.shape({ __apiCheckData: apiCheckDataChecker });
		  var wrongShape = checkers.oneOfType([asFunc, asShape])(checkerType, name, location);
		  if (isError(wrongShape)) {
		    return wrongShape;
		  }
		  if (typeof checkerType !== 'function' && !checkerType.hasOwnProperty(checkerType.__apiCheckData.type)) {
		    return getError(name, location, checkerTypeType.type);
		  }
		}
	
		function getCheckerErrorMessage(res, checker, val) {
		  var checkerHelp = getCheckerHelp(checker, val);
		  checkerHelp = checkerHelp ? ' - ' + checkerHelp : '';
		  return res.message + checkerHelp;
		}
	
		function getCheckerHelp(_ref, val) {
		  var help = _ref.help;
	
		  if (!help) {
		    return '';
		  }
		  if (typeof help === 'function') {
		    help = help(val);
		  }
		  return help;
		}
	
		function checkEnoughArgs(api, args) {
		  var requiredArgs = api.filter(function (a) {
		    return !a.isOptional;
		  });
		  if (args.length < requiredArgs.length) {
		    return ['Not enough arguments specified. Requires `' + requiredArgs.length + '`, you passed `' + args.length + '`'];
		  } else {
		    return [];
		  }
		}
	
		function getArgDisplay(arg, gottenArgs) {
		  /* eslint complexity:[2, 7] */
		  var cName = arg && arg.constructor && arg.constructor.name;
		  var type = typeOf(arg);
		  if (type === 'function') {
		    if (hasKeys()) {
		      var properties = stringify(getDisplayIfNotGotten());
		      return cName + ' (with properties: ' + properties + ')';
		    }
		    return cName;
		  }
	
		  if (arg === null) {
		    return 'null';
		  }
	
		  if (type !== 'array' && type !== 'object') {
		    return type;
		  }
	
		  if (hasKeys()) {
		    return getDisplayIfNotGotten();
		  }
	
		  return cName;
	
		  // utility functions
		  function hasKeys() {
		    return arg && Object.keys(arg).length;
		  }
	
		  function getDisplayIfNotGotten() {
		    if (gottenArgs.indexOf(arg) !== -1) {
		      return '[Circular]';
		    }
		    gottenArgs.push(arg);
		    return getDisplay(arg, gottenArgs);
		  }
		}
	
		function getDisplay(obj, gottenArgs) {
		  var argDisplay = {};
		  each(obj, function (v, k) {
		    return argDisplay[k] = getArgDisplay(v, gottenArgs);
		  });
		  return argDisplay;
		}
	
		function getApiCheckApis() {
		  var os = checkers.string.optional;
	
		  var checkerFnChecker = checkers.func.withProperties({
		    type: checkers.oneOfType([checkers.string, checkerTypeType]).optional,
		    displayName: checkers.string.optional,
		    shortType: checkers.string.optional,
		    notOptional: checkers.bool.optional,
		    notRequired: checkers.bool.optional
		  });
	
		  var getApiCheckInstanceCheckers = [checkers.shape({
		    output: checkers.shape({
		      prefix: checkers.string.optional,
		      suffix: checkers.string.optional,
		      docsBaseUrl: checkers.string.optional
		    }).strict.optional,
		    verbose: checkers.bool.optional,
		    disabled: checkers.bool.optional
		  }).strict.optional, checkers.objectOf(checkerFnChecker).optional];
	
		  var checkApiCheckApi = [checkers.typeOrArrayOf(checkerFnChecker), checkers.any.optional, checkers.shape({
		    prefix: os, suffix: os, urlSuffix: os, // appended case
		    onlyPrefix: os, onlySuffix: os, url: os // override case
		  }).strict.optional];
	
		  return {
		    checkerFnChecker: checkerFnChecker,
		    getApiCheckInstanceCheckers: getApiCheckInstanceCheckers,
		    checkApiCheckApi: checkApiCheckApi
		  };
		}
	
	/***/ },
	/* 2 */
	/***/ function(module, exports) {
	
		module.exports = stringify;
	
		function getSerialize (fn, decycle) {
		  var seen = [], keys = [];
		  decycle = decycle || function(key, value) {
		    return '[Circular ' + getPath(value, seen, keys) + ']'
		  };
		  return function(key, value) {
		    var ret = value;
		    if (typeof value === 'object' && value) {
		      if (seen.indexOf(value) !== -1)
		        ret = decycle(key, value);
		      else {
		        seen.push(value);
		        keys.push(key);
		      }
		    }
		    if (fn) ret = fn(key, ret);
		    return ret;
		  }
		}
	
		function getPath (value, seen, keys) {
		  var index = seen.indexOf(value);
		  var path = [ keys[index] ];
		  for (index--; index >= 0; index--) {
		    if (seen[index][ path[0] ] === value) {
		      value = seen[index];
		      path.unshift(keys[index]);
		    }
		  }
		  return '~' + path.join('.');
		}
	
		function stringify(obj, fn, spaces, decycle) {
		  return JSON.stringify(obj, getSerialize(fn, decycle), spaces);
		}
	
		stringify.getSerialize = getSerialize;
	
	
	/***/ },
	/* 3 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
		var stringify = __webpack_require__(2);
		var checkerHelpers = {
		  addOptional: addOptional, getRequiredVersion: getRequiredVersion, setupChecker: setupChecker, addNullable: addNullable
		};
	
		module.exports = {
		  each: each, copy: copy, typeOf: typeOf, arrayify: arrayify, getCheckerDisplay: getCheckerDisplay,
		  isError: isError, list: list, getError: getError, nAtL: nAtL, t: t, undef: undef, checkerHelpers: checkerHelpers,
		  noop: noop
		};
	
		function copy(obj) {
		  var type = typeOf(obj);
		  var daCopy = undefined;
		  if (type === 'array') {
		    daCopy = [];
		  } else if (type === 'object') {
		    daCopy = {};
		  } else {
		    return obj;
		  }
		  each(obj, function (val, key) {
		    daCopy[key] = val; // cannot single-line this because we don't want to abort the each
		  });
		  return daCopy;
		}
	
		function typeOf(obj) {
		  if (Array.isArray(obj)) {
		    return 'array';
		  } else if (obj instanceof RegExp) {
		    return 'object';
		  } else {
		    return typeof obj;
		  }
		}
	
		function getCheckerDisplay(checker, options) {
		  /* eslint complexity:[2, 7] */
		  var display = undefined;
		  var short = options && options.short;
		  if (short && checker.shortType) {
		    display = checker.shortType;
		  } else if (!short && typeof checker.type === 'object' || checker.type === 'function') {
		    display = getCheckerType(checker, options);
		  } else {
		    display = getCheckerType(checker, options) || checker.displayName || checker.name;
		  }
		  return display;
		}
	
		function getCheckerType(_ref, options) {
		  var type = _ref.type;
	
		  if (typeof type === 'function') {
		    var __apiCheckData = type.__apiCheckData;
		    var typeTypes = type(options);
		    type = _defineProperty({
		      __apiCheckData: __apiCheckData
		    }, __apiCheckData.type, typeTypes);
		  }
		  return type;
		}
	
		function arrayify(obj) {
		  if (!obj) {
		    return [];
		  } else if (Array.isArray(obj)) {
		    return obj;
		  } else {
		    return [obj];
		  }
		}
	
		function each(obj, iterator, context) {
		  if (Array.isArray(obj)) {
		    return eachArry(obj, iterator, context);
		  } else {
		    return eachObj(obj, iterator, context);
		  }
		}
	
		function eachObj(obj, iterator, context) {
		  var ret = undefined;
		  var hasOwn = Object.prototype.hasOwnProperty;
		  /* eslint prefer-const:0 */ // some weird eslint bug?
		  for (var key in obj) {
		    if (hasOwn.call(obj, key)) {
		      ret = iterator.call(context, obj[key], key, obj);
		      if (ret === false) {
		        return ret;
		      }
		    }
		  }
		  return true;
		}
	
		function eachArry(obj, iterator, context) {
		  var ret = undefined;
		  var length = obj.length;
		  for (var i = 0; i < length; i++) {
		    ret = iterator.call(context, obj[i], i, obj);
		    if (ret === false) {
		      return ret;
		    }
		  }
		  return true;
		}
	
		function isError(obj) {
		  return obj instanceof Error;
		}
	
		function list(arry, join, finalJoin) {
		  arry = arrayify(arry);
		  var copy = arry.slice();
		  var last = copy.pop();
		  if (copy.length === 1) {
		    join = ' ';
		  }
		  return copy.join(join) + ('' + (copy.length ? join + finalJoin : '') + last);
		}
	
		function getError(name, location, checkerType) {
		  if (typeof checkerType === 'function') {
		    checkerType = checkerType({ short: true });
		  }
		  var stringType = typeof checkerType !== 'object' ? checkerType : stringify(checkerType);
		  return new Error(nAtL(name, location) + ' must be ' + t(stringType));
		}
	
		function nAtL(name, location) {
		  var tName = t(name || 'value');
		  var tLocation = !location ? '' : ' at ' + t(location);
		  return '' + tName + tLocation;
		}
	
		function t(thing) {
		  return '`' + thing + '`';
		}
	
		function undef(thing) {
		  return typeof thing === 'undefined';
		}
	
		/**
		 * This will set up the checker with all of the defaults that most checkers want like required by default and an
		 * optional version
		 *
		 * @param {Function} checker - the checker to setup with properties
		 * @param {Object} properties - properties to add to the checker
		 * @param {boolean} disabled - when set to true, this will set the checker to a no-op function
		 * @returns {Function} checker - the setup checker
		 */
		function setupChecker(checker, properties, disabled) {
		  /* eslint complexity:[2, 9] */
		  if (disabled) {
		    // swap out the checker for its own copy of noop
		    checker = getNoop();
		    checker.isNoop = true;
		  }
	
		  if (typeof checker.type === 'string') {
		    checker.shortType = checker.type;
		  }
	
		  // assign all properties given
		  each(properties, function (prop, name) {
		    return checker[name] = prop;
		  });
	
		  if (!checker.displayName) {
		    checker.displayName = 'apiCheck ' + t(checker.shortType || checker.type || checker.name) + ' type checker';
		  }
	
		  if (!checker.notRequired) {
		    checker = getRequiredVersion(checker, disabled);
		  }
	
		  if (!checker.notNullable) {
		    addNullable(checker, disabled);
		  }
	
		  if (!checker.notOptional) {
		    addOptional(checker, disabled);
		  }
	
		  return checker;
		}
	
		function getRequiredVersion(checker, disabled) {
		  var requiredChecker = disabled ? getNoop() : function requiredChecker(val, name, location, obj) {
		    if (undef(val) && !checker.isOptional) {
		      var tLocation = location ? ' in ' + t(location) : '';
		      var type = getCheckerDisplay(checker, { short: true });
		      var stringType = typeof type !== 'object' ? type : stringify(type);
		      return new Error('Required ' + t(name) + ' not specified' + tLocation + '. Must be ' + t(stringType));
		    } else {
		      return checker(val, name, location, obj);
		    }
		  };
		  copyProps(checker, requiredChecker);
		  requiredChecker.originalChecker = checker;
		  return requiredChecker;
		}
	
		function addOptional(checker, disabled) {
		  var optionalCheck = disabled ? getNoop() : function optionalCheck(val, name, location, obj) {
		    if (!undef(val)) {
		      return checker(val, name, location, obj);
		    }
		  };
		  // inherit all properties on the original checker
		  copyProps(checker, optionalCheck);
	
		  optionalCheck.isOptional = true;
		  optionalCheck.displayName = checker.displayName + ' (optional)';
		  optionalCheck.originalChecker = checker;
	
		  // the magic line that allows you to add .optional to the end of the checkers
		  checker.optional = optionalCheck;
	
		  fixType(checker, checker.optional);
		}
	
		function addNullable(checker, disabled) {
		  var nullableCheck = disabled ? getNoop() : function nullableCheck(val, name, location, obj) {
		    if (val !== null) {
		      return checker(val, name, location, obj);
		    }
		  };
		  // inherit all properties on the original checker
		  copyProps(checker, nullableCheck);
	
		  nullableCheck.isNullable = true;
		  nullableCheck.displayName = checker.displayName + ' (nullable)';
		  nullableCheck.originalChecker = checker;
	
		  // the magic line that allows you to add .nullable to the end of the checkers
		  checker.nullable = nullableCheck;
	
		  fixType(checker, checker.nullable);
		  if (!checker.notOptional) {
		    addOptional(checker.nullable, disabled);
		  }
		}
	
		function fixType(checker, checkerCopy) {
		  // fix type, because it's not a straight copy...
		  // the reason is we need to specify type.__apiCheckData.optional as true for the terse/verbose option.
		  // we also want to add "(optional)" to the types with a string
		  if (typeof checkerCopy.type === 'object') {
		    checkerCopy.type = copy(checkerCopy.type); // make our own copy of this
		  } else if (typeof checkerCopy.type === 'function') {
		      checkerCopy.type = function () {
		        return checker.type.apply(checker, arguments);
		      };
		    } else {
		      checkerCopy.type += ' (optional)';
		      return;
		    }
		  checkerCopy.type.__apiCheckData = copy(checker.type.__apiCheckData) || {}; // and this
		  checkerCopy.type.__apiCheckData.optional = true;
		}
	
		// UTILS
	
		function copyProps(src, dest) {
		  each(Object.keys(src), function (key) {
		    return dest[key] = src[key];
		  });
		}
	
		function noop() {}
	
		function getNoop() {
		  /* eslint no-shadow:0 */
		  /* istanbul ignore next */
		  return function noop() {};
		}
	
	/***/ },
	/* 4 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var stringify = __webpack_require__(2);
	
		var _require = __webpack_require__(3);
	
		var typeOf = _require.typeOf;
		var each = _require.each;
		var copy = _require.copy;
		var getCheckerDisplay = _require.getCheckerDisplay;
		var isError = _require.isError;
		var arrayify = _require.arrayify;
		var list = _require.list;
		var getError = _require.getError;
		var nAtL = _require.nAtL;
		var t = _require.t;
		var checkerHelpers = _require.checkerHelpers;
		var undef = _require.undef;
		var setupChecker = checkerHelpers.setupChecker;
	
		var checkers = module.exports = getCheckers();
		module.exports.getCheckers = getCheckers;
	
		function getCheckers(disabled) {
		  return {
		    array: typeOfCheckGetter('Array'),
		    bool: typeOfCheckGetter('Boolean'),
		    number: typeOfCheckGetter('Number'),
		    string: typeOfCheckGetter('String'),
		    func: funcCheckGetter(),
		    object: objectCheckGetter(),
	
		    emptyObject: emptyObjectCheckGetter(),
	
		    instanceOf: instanceCheckGetter,
		    oneOf: oneOfCheckGetter,
		    oneOfType: oneOfTypeCheckGetter,
	
		    arrayOf: arrayOfCheckGetter,
		    objectOf: objectOfCheckGetter,
		    typeOrArrayOf: typeOrArrayOfCheckGetter,
	
		    range: rangeCheckGetter,
		    lessThan: lessThanCheckGetter,
		    greaterThan: greaterThanCheckGetter,
	
		    shape: getShapeCheckGetter(),
		    args: argumentsCheckerGetter(),
	
		    any: anyCheckGetter(),
		    'null': nullCheckGetter()
	
		  };
	
		  function typeOfCheckGetter(type) {
		    var lType = type.toLowerCase();
		    return setupChecker(function typeOfCheckerDefinition(val, name, location) {
		      if (typeOf(val) !== lType) {
		        return getError(name, location, type);
		      }
		    }, { type: type }, disabled);
		  }
	
		  function funcCheckGetter() {
		    var type = 'Function';
		    var functionChecker = setupChecker(function functionCheckerDefinition(val, name, location) {
		      if (typeOf(val) !== 'function') {
		        return getError(name, location, type);
		      }
		    }, { type: type }, disabled);
	
		    functionChecker.withProperties = function getWithPropertiesChecker(properties) {
		      var apiError = checkers.objectOf(checkers.func)(properties, 'properties', 'apiCheck.func.withProperties');
		      if (isError(apiError)) {
		        throw apiError;
		      }
		      var shapeChecker = checkers.shape(properties, true);
		      shapeChecker.type.__apiCheckData.type = 'func.withProperties';
	
		      return setupChecker(function functionWithPropertiesChecker(val, name, location) {
		        var notFunction = checkers.func(val, name, location);
		        if (isError(notFunction)) {
		          return notFunction;
		        }
		        return shapeChecker(val, name, location);
		      }, { type: shapeChecker.type, shortType: 'func.withProperties' }, disabled);
		    };
		    return functionChecker;
		  }
	
		  function objectCheckGetter() {
		    var type = 'Object';
		    var nullType = 'Object (null ok)';
		    var objectNullOkChecker = setupChecker(function objectNullOkCheckerDefinition(val, name, location) {
		      if (typeOf(val) !== 'object') {
		        return getError(name, location, nullType);
		      }
		    }, { type: nullType }, disabled);
	
		    var objectChecker = setupChecker(function objectCheckerDefinition(val, name, location) {
		      if (val === null || isError(objectNullOkChecker(val, name, location))) {
		        return getError(name, location, objectChecker.type);
		      }
		    }, { type: type, nullOk: objectNullOkChecker }, disabled);
	
		    return objectChecker;
		  }
	
		  function instanceCheckGetter(classToCheck) {
		    return setupChecker(function instanceCheckerDefinition(val, name, location) {
		      if (!(val instanceof classToCheck)) {
		        return getError(name, location, classToCheck.name);
		      }
		    }, { type: classToCheck.name }, disabled);
		  }
	
		  function oneOfCheckGetter(enums) {
		    var type = {
		      __apiCheckData: { optional: false, type: 'enum' },
		      'enum': enums
		    };
		    var shortType = 'oneOf[' + enums.map(function (enm) {
		      return stringify(enm);
		    }).join(', ') + ']';
		    return setupChecker(function oneOfCheckerDefinition(val, name, location) {
		      if (!enums.some(function (enm) {
		        return enm === val;
		      })) {
		        return getError(name, location, shortType);
		      }
		    }, { type: type, shortType: shortType }, disabled);
		  }
	
		  function oneOfTypeCheckGetter(typeCheckers) {
		    var checkersDisplay = typeCheckers.map(function (checker) {
		      return getCheckerDisplay(checker, { short: true });
		    });
		    var shortType = 'oneOfType[' + checkersDisplay.join(', ') + ']';
		    function type(options) {
		      if (options && options.short) {
		        return shortType;
		      }
		      return typeCheckers.map(function (checker) {
		        return getCheckerDisplay(checker, options);
		      });
		    }
		    type.__apiCheckData = { optional: false, type: 'oneOfType' };
		    return setupChecker(function oneOfTypeCheckerDefinition(val, name, location) {
		      if (!typeCheckers.some(function (checker) {
		        return !isError(checker(val, name, location));
		      })) {
		        return getError(name, location, shortType);
		      }
		    }, { type: type, shortType: shortType }, disabled);
		  }
	
		  function arrayOfCheckGetter(checker) {
		    var shortCheckerDisplay = getCheckerDisplay(checker, { short: true });
		    var shortType = 'arrayOf[' + shortCheckerDisplay + ']';
	
		    function type(options) {
		      if (options && options.short) {
		        return shortType;
		      }
		      return getCheckerDisplay(checker, options);
		    }
		    type.__apiCheckData = { optional: false, type: 'arrayOf' };
	
		    return setupChecker(function arrayOfCheckerDefinition(val, name, location) {
		      if (isError(checkers.array(val)) || !val.every(function (item) {
		        return !isError(checker(item));
		      })) {
		        return getError(name, location, shortType);
		      }
		    }, { type: type, shortType: shortType }, disabled);
		  }
	
		  function objectOfCheckGetter(checker) {
		    var checkerDisplay = getCheckerDisplay(checker, { short: true });
		    var shortType = 'objectOf[' + checkerDisplay + ']';
	
		    function type(options) {
		      if (options && options.short) {
		        return shortType;
		      }
		      return getCheckerDisplay(checker, options);
		    }
		    type.__apiCheckData = { optional: false, type: 'objectOf' };
	
		    return setupChecker(function objectOfCheckerDefinition(val, name, location) {
		      var notObject = checkers.object(val, name, location);
		      if (isError(notObject)) {
		        return notObject;
		      }
		      var allTypesSuccess = each(val, function (item, key) {
		        if (isError(checker(item, key, name))) {
		          return false;
		        }
		      });
		      if (!allTypesSuccess) {
		        return getError(name, location, shortType);
		      }
		    }, { type: type, shortType: shortType }, disabled);
		  }
	
		  function typeOrArrayOfCheckGetter(checker) {
		    var checkerDisplay = getCheckerDisplay(checker, { short: true });
		    var shortType = 'typeOrArrayOf[' + checkerDisplay + ']';
	
		    function type(options) {
		      if (options && options.short) {
		        return shortType;
		      }
		      return getCheckerDisplay(checker, options);
		    }
	
		    type.__apiCheckData = { optional: false, type: 'typeOrArrayOf' };
		    return setupChecker(function typeOrArrayOfDefinition(val, name, location, obj) {
		      if (isError(checkers.oneOfType([checker, checkers.arrayOf(checker)])(val, name, location, obj))) {
		        return getError(name, location, shortType);
		      }
		    }, { type: type, shortType: shortType }, disabled);
		  }
	
		  function getShapeCheckGetter() {
		    function shapeCheckGetter(shape, nonObject) {
		      var shapeTypes = {};
		      each(shape, function (checker, prop) {
		        shapeTypes[prop] = getCheckerDisplay(checker);
		      });
		      function type() {
		        var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
		        var ret = {};
		        var terse = options.terse;
		        var obj = options.obj;
		        var addHelpers = options.addHelpers;
	
		        var parentRequired = options.required;
		        each(shape, function (checker, prop) {
		          /* eslint complexity:[2, 6] */
		          var specified = obj && obj.hasOwnProperty(prop);
		          var required = undef(parentRequired) ? !checker.isOptional : parentRequired;
		          if (!terse || (specified || !checker.isOptional)) {
		            ret[prop] = getCheckerDisplay(checker, { terse: terse, obj: obj && obj[prop], required: required, addHelpers: addHelpers });
		          }
		          if (addHelpers) {
		            modifyTypeDisplayToHelpOut(ret, prop, specified, checker, required);
		          }
		        });
		        return ret;
	
		        function modifyTypeDisplayToHelpOut(theRet, prop, specified, checker, required) {
		          if (!specified && required && !checker.isOptional) {
		            var item = 'ITEM';
		            if (checker.type && checker.type.__apiCheckData) {
		              item = checker.type.__apiCheckData.type.toUpperCase();
		            }
		            addHelper('missing', 'MISSING THIS ' + item, ' <-- YOU ARE MISSING THIS');
		          } else if (specified) {
		            var error = checker(obj[prop], prop, null, obj);
		            if (isError(error)) {
		              addHelper('error', 'THIS IS THE PROBLEM: ' + error.message, ' <-- THIS IS THE PROBLEM: ' + error.message);
		            }
		          }
	
		          function addHelper(property, objectMessage, stringMessage) {
		            if (typeof theRet[prop] === 'string') {
		              theRet[prop] += stringMessage;
		            } else {
		              theRet[prop].__apiCheckData[property] = objectMessage;
		            }
		          }
		        }
		      }
	
		      type.__apiCheckData = { strict: false, optional: false, type: 'shape' };
		      var shapeChecker = setupChecker(function shapeCheckerDefinition(val, name, location) {
		        /* eslint complexity:[2, 6] */
		        var isObject = !nonObject && checkers.object(val, name, location);
		        if (isError(isObject)) {
		          return isObject;
		        }
		        var shapePropError = undefined;
		        location = location ? location + (name ? '/' : '') : '';
		        name = name || '';
		        each(shape, function (checker, prop) {
		          if (val.hasOwnProperty(prop) || !checker.isOptional) {
		            shapePropError = checker(val[prop], prop, '' + location + name, val);
		            return !isError(shapePropError);
		          }
		        });
		        if (isError(shapePropError)) {
		          return shapePropError;
		        }
		      }, { type: type, shortType: 'shape' }, disabled);
	
		      function strictType() {
		        return type.apply(undefined, arguments);
		      }
	
		      strictType.__apiCheckData = copy(shapeChecker.type.__apiCheckData);
		      strictType.__apiCheckData.strict = true;
		      shapeChecker.strict = setupChecker(function strictShapeCheckerDefinition(val, name, location) {
		        var shapeError = shapeChecker(val, name, location);
		        if (isError(shapeError)) {
		          return shapeError;
		        }
		        var allowedProperties = Object.keys(shape);
		        var extraProps = Object.keys(val).filter(function (prop) {
		          return allowedProperties.indexOf(prop) === -1;
		        });
		        if (extraProps.length) {
		          return new Error(nAtL(name, location) + ' cannot have extra properties: ' + t(extraProps.join('`, `')) + '.' + ('It is limited to ' + t(allowedProperties.join('`, `'))));
		        }
		      }, { type: strictType, shortType: 'strict shape' }, disabled);
	
		      return shapeChecker;
		    }
	
		    shapeCheckGetter.ifNot = function ifNot(otherProps, propChecker) {
		      if (!Array.isArray(otherProps)) {
		        otherProps = [otherProps];
		      }
		      var description = undefined;
		      if (otherProps.length === 1) {
		        description = 'specified only if ' + otherProps[0] + ' is not specified';
		      } else {
		        description = 'specified only if none of the following are specified: [' + list(otherProps, ', ', 'and ') + ']';
		      }
		      var shortType = 'ifNot[' + otherProps.join(', ') + ']';
		      var type = getTypeForShapeChild(propChecker, description, shortType);
		      return setupChecker(function ifNotChecker(prop, propName, location, obj) {
		        var propExists = obj && obj.hasOwnProperty(propName);
		        var otherPropsExist = otherProps.some(function (otherProp) {
		          return obj && obj.hasOwnProperty(otherProp);
		        });
		        if (propExists === otherPropsExist) {
		          return getError(propName, location, type);
		        } else if (propExists) {
		          return propChecker(prop, propName, location, obj);
		        }
		      }, { notRequired: true, type: type, shortType: shortType }, disabled);
		    };
	
		    shapeCheckGetter.onlyIf = function onlyIf(otherProps, propChecker) {
		      otherProps = arrayify(otherProps);
		      var description = undefined;
		      if (otherProps.length === 1) {
		        description = 'specified only if ' + otherProps[0] + ' is also specified';
		      } else {
		        description = 'specified only if all of the following are specified: [' + list(otherProps, ', ', 'and ') + ']';
		      }
		      var shortType = 'onlyIf[' + otherProps.join(', ') + ']';
		      var type = getTypeForShapeChild(propChecker, description, shortType);
		      return setupChecker(function onlyIfCheckerDefinition(prop, propName, location, obj) {
		        var othersPresent = otherProps.every(function (property) {
		          return obj.hasOwnProperty(property);
		        });
		        if (!othersPresent) {
		          return getError(propName, location, type);
		        } else {
		          return propChecker(prop, propName, location, obj);
		        }
		      }, { type: type, shortType: shortType }, disabled);
		    };
	
		    shapeCheckGetter.requiredIfNot = function shapeRequiredIfNot(otherProps, propChecker) {
		      if (!Array.isArray(otherProps)) {
		        otherProps = [otherProps];
		      }
		      return getRequiredIfNotChecker(false, otherProps, propChecker);
		    };
	
		    shapeCheckGetter.requiredIfNot.all = function shapeRequiredIfNotAll(otherProps, propChecker) {
		      if (!Array.isArray(otherProps)) {
		        throw new Error('requiredIfNot.all must be passed an array');
		      }
		      return getRequiredIfNotChecker(true, otherProps, propChecker);
		    };
	
		    function getRequiredIfNotChecker(all, otherProps, propChecker) {
		      var props = t(otherProps.join(', '));
		      var ifProps = 'if ' + (all ? 'all of' : 'at least one of');
		      var description = 'specified ' + ifProps + ' these are not specified: ' + props + ' (otherwise it\'s optional)';
		      var shortType = 'requiredIfNot' + (all ? '.all' : '') + '[' + otherProps.join(', ') + '}]';
		      var type = getTypeForShapeChild(propChecker, description, shortType);
		      return setupChecker(function shapeRequiredIfNotDefinition(prop, propName, location, obj) {
		        var propExists = obj && obj.hasOwnProperty(propName);
		        var iteration = all ? 'every' : 'some';
		        var otherPropsExist = otherProps[iteration](function (otherProp) {
		          return obj && obj.hasOwnProperty(otherProp);
		        });
		        if (!otherPropsExist && !propExists) {
		          return getError(propName, location, type);
		        } else if (propExists) {
		          return propChecker(prop, propName, location, obj);
		        }
		      }, { type: type, notRequired: true }, disabled);
		    }
	
		    return shapeCheckGetter;
	
		    function getTypeForShapeChild(propChecker, description, shortType) {
		      function type(options) {
		        if (options && options.short) {
		          return shortType;
		        }
		        return getCheckerDisplay(propChecker);
		      }
		      type.__apiCheckData = { optional: false, type: 'ifNot', description: description };
		      return type;
		    }
		  }
	
		  function argumentsCheckerGetter() {
		    var type = 'function arguments';
		    return setupChecker(function argsCheckerDefinition(val, name, location) {
		      if (Array.isArray(val) || isError(checkers.object(val)) || isError(checkers.number(val.length))) {
		        return getError(name, location, type);
		      }
		    }, { type: type }, disabled);
		  }
	
		  function anyCheckGetter() {
		    return setupChecker(function anyCheckerDefinition() {
		      // don't do anything
		    }, { type: 'any' }, disabled);
		  }
	
		  function nullCheckGetter() {
		    var type = 'null';
		    return setupChecker(function nullChecker(val, name, location) {
		      if (val !== null) {
		        return getError(name, location, type);
		      }
		    }, { type: type }, disabled);
		  }
	
		  function rangeCheckGetter(min, max) {
		    var type = 'Range (' + min + ' - ' + max + ')';
		    return setupChecker(function rangeChecker(val, name, location) {
		      if (typeof val !== 'number' || val < min || val > max) {
		        return getError(name, location, type);
		      }
		    }, { type: type }, disabled);
		  }
	
		  function lessThanCheckGetter(min) {
		    var type = 'lessThan[' + min + ']';
		    return setupChecker(function lessThanChecker(val, name, location) {
		      if (typeof val !== 'number' || val > min) {
		        return getError(name, location, type);
		      }
		    }, { type: type }, disabled);
		  }
	
		  function greaterThanCheckGetter(max) {
		    var type = 'greaterThan[' + max + ']';
		    return setupChecker(function greaterThanChecker(val, name, location) {
		      if (typeof val !== 'number' || val < max) {
		        return getError(name, location, type);
		      }
		    }, { type: type }, disabled);
		  }
	
		  function emptyObjectCheckGetter() {
		    var type = 'empty object';
		    return setupChecker(function emptyObjectChecker(val, name, location) {
		      if (typeOf(val) !== 'object' || val === null || Object.keys(val).length) {
		        return getError(name, location, type);
		      }
		    }, { type: type }, disabled);
		  }
		}
	
	/***/ }
	/******/ ])
	});
	;

/***/ }),
/* 77 */,
/* 78 */
25,
/* 79 */
25,
/* 80 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReconfirmacionUsuarioController = function () {
	  ReconfirmacionUsuarioController.$inject = ["$uibModalInstance", "DataService", "_", "Util", "Message", "data", "Integracion"];
	  function ReconfirmacionUsuarioController($uibModalInstance, DataService, _, Util, Message, data, Integracion) {
	    'ngInject';
	
	    _classCallCheck(this, ReconfirmacionUsuarioController);
	
	    this.$uibModalInstance = $uibModalInstance;
	    this.DataService = DataService;
	    this._ = _;
	    this.Util = Util;
	    this.Message = Message;
	    this.usuario = data.usuario;
	    this.apiExtra = data.apiExtra;
	    this.Integracion = Integracion;
	  }
	
	  _createClass(ReconfirmacionUsuarioController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.url = this.apiExtra ? this.apiExtra : 'usuario/reenviar-confirmacion';
	    }
	  }, {
	    key: 'reenviarCorreo',
	    value: function reenviarCorreo() {
	      var _this = this;
	
	      var reset = {
	        usuario: this.usuario.id_usuario,
	        name: this.usuario.usuario || this.usuario.persona.numero_documento,
	        pass: Array.from(window.crypto.getRandomValues(new window.Uint8Array(10))).map(function (x) {
	          return (x % 36).toString(36);
	        }).join(''),
	        mail: this.usuario.persona.correo
	
	        // console.log('datos usuario',this.usuario);
	        // console.log('datos usuario2',reset);
	
	
	      };var dts = this.Integracion.resetMail(reset);
	      dts.then(function successCallback(respuesta) {
	        return respuesta.data;
	      }).then(function (dts) {
	        if (dts.estado == 'CORRECTO') {
	          _this.Message.success('Se remitio el correo de forma correcta');
	          _this.$uibModalInstance.close(true);
	        }
	        //console.log('respuesta ',dts); 
	        //this.Message.warning(dts,`Importacion Cómputos Metricos`,12000);
	      });
	
	      // this.DataService.post(this.url, {correo: this.usuario.persona.correo, id_usuario: this.usuario.id_usuario}).then(response => {
	      //   if (response && response.finalizado) {
	      //     this.Message.success(response.mensaje);
	      //     this.$uibModalInstance.close(true);
	      //   }
	      // });
	    }
	  }, {
	    key: 'cerrar',
	    value: function cerrar() {
	      this.$uibModalInstance.close(false);
	    }
	  }]);
	
	  return ReconfirmacionUsuarioController;
	}();
	
	exports.default = ReconfirmacionUsuarioController;

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(502);
	__webpack_require__(511);
	__webpack_require__(534);
	__webpack_require__(535);
	__webpack_require__(536);
	__webpack_require__(537);
	__webpack_require__(503);
	
	var MODULE_NAME = 'ui.bootstrap.module.datepicker';
	
	angular.module(MODULE_NAME, ['ui.bootstrap.datepicker', 'uib/template/datepicker/datepicker.html', 'uib/template/datepicker/day.html', 'uib/template/datepicker/month.html', 'uib/template/datepicker/year.html']);
	
	module.exports = MODULE_NAME;

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(516);

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(521);
	
	var MODULE_NAME = 'ui.bootstrap.module.stackedMap';
	
	angular.module(MODULE_NAME, ['ui.bootstrap.stackedMap']);
	
	module.exports = MODULE_NAME;

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(27);
	__webpack_require__(83);
	__webpack_require__(547);
	__webpack_require__(546);
	__webpack_require__(548);
	__webpack_require__(530);
	
	var MODULE_NAME = 'ui.bootstrap.module.tooltip';
	
	angular.module(MODULE_NAME, ['ui.bootstrap.tooltip', 'uib/template/tooltip/tooltip-popup.html', 'uib/template/tooltip/tooltip-html-popup.html', 'uib/template/tooltip/tooltip-template-popup.html']);
	
	module.exports = MODULE_NAME;

/***/ }),
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\">\n    <i class=\"fa fa-plus-circle\"></i> Enviar Credenciales al Correo\n  </h5>\n  <button\n    type=\"button\"\n    class=\"close\"\n    data-dismiss=\"modal\"\n    ng-click=\"$ctrl.cerrar()\"\n  >\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<div class=\"modal-body\">\n  <p>Usuario/a: <strong>{{$ctrl.usuario.persona | nombreUnido}}</strong></p>\n\n  <ng-form name=\"formUsuario\">\n    <div class=\"row\">\n      <div class=\"md-input-group col-md-12\">\n        <c-input\n          name=\"correo_miembro\"\n          label=\"Correo Electrónico\"\n          ng-model=\"$ctrl.usuario.persona.correo\"\n          ng-validation=\"correo\"\n          ng-required=\"true\"\n        ></c-input>\n      </div>\n    </div>\n  </ng-form>\n  <div class=\"alert alert-info\">\n    <i class=\"fa fa-info-circle\"></i> Tome en cuenta que al reenviar el correo\n    de confirmación la contraseña del usuario se actualizará a una generada por\n    el sistema.\n  </div>\n</div>\n\n<div class=\"modal-footer\">\n  <button\n    type=\"button\"\n    md-effect\n    class=\"btn btn-secondary\"\n    ng-click=\"$ctrl.cerrar()\"\n  >\n    <i class=\"fa fa-close\"></i> Cancelar\n  </button>\n  <button\n    type=\"submit\"\n    md-effect\n    class=\"btn btn-primary\"\n    ng-click=\"$ctrl.reenviarCorreo()\"\n    validar-formulario=\"formUsuario\"\n  >\n    <i class=\"fa fa-send\"></i> Reenviar correo\n  </button>\n</div>\n"

/***/ }),
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * State-based routing for AngularJS 1.x
	 * This bundle requires the ui-router-core.js bundle from the @uirouter/core package.
	 * @version v1.0.30
	 * @link https://ui-router.github.io
	 * @license MIT License, http://www.opensource.org/licenses/MIT
	 */
	(function (global, factory) {
	     true ? factory(exports, __webpack_require__(9), __webpack_require__(105)) :
	    typeof define === 'function' && define.amd ? define(['exports', 'angular', '@uirouter/core'], factory) :
	    (global = global || self, factory(global['@uirouter/angularjs'] = {}, global.angular, global['@uirouter/core']));
	}(this, (function (exports, ng_from_import, core) { 'use strict';
	
	    /** @publicapi @module ng1 */ /** */
	    /** @hidden */ var ng_from_global = angular;
	    /** @hidden */ var ng = ng_from_import && ng_from_import.module ? ng_from_import : ng_from_global;
	
	    /** @publicapi @module ng1 */ /** */
	    /** @internalapi */
	    function getNg1ViewConfigFactory() {
	        var templateFactory = null;
	        return function (path, view) {
	            templateFactory = templateFactory || core.services.$injector.get('$templateFactory');
	            return [new Ng1ViewConfig(path, view, templateFactory)];
	        };
	    }
	    /** @internalapi */
	    var hasAnyKey = function (keys, obj) { return keys.reduce(function (acc, key) { return acc || core.isDefined(obj[key]); }, false); };
	    /**
	     * This is a [[StateBuilder.builder]] function for angular1 `views`.
	     *
	     * When the [[StateBuilder]] builds a [[StateObject]] object from a raw [[StateDeclaration]], this builder
	     * handles the `views` property with logic specific to @uirouter/angularjs (ng1).
	     *
	     * If no `views: {}` property exists on the [[StateDeclaration]], then it creates the `views` object
	     * and applies the state-level configuration to a view named `$default`.
	     *
	     * @internalapi
	     */
	    function ng1ViewsBuilder(state) {
	        // Do not process root state
	        if (!state.parent)
	            return {};
	        var tplKeys = ['templateProvider', 'templateUrl', 'template', 'notify', 'async'], ctrlKeys = ['controller', 'controllerProvider', 'controllerAs', 'resolveAs'], compKeys = ['component', 'bindings', 'componentProvider'], nonCompKeys = tplKeys.concat(ctrlKeys), allViewKeys = compKeys.concat(nonCompKeys);
	        // Do not allow a state to have both state-level props and also a `views: {}` property.
	        // A state without a `views: {}` property can declare properties for the `$default` view as properties of the state.
	        // However, the `$default` approach should not be mixed with a separate `views: ` block.
	        if (core.isDefined(state.views) && hasAnyKey(allViewKeys, state)) {
	            throw new Error("State '" + state.name + "' has a 'views' object. " +
	                "It cannot also have \"view properties\" at the state level.  " +
	                "Move the following properties into a view (in the 'views' object): " +
	                (" " + allViewKeys.filter(function (key) { return core.isDefined(state[key]); }).join(', ')));
	        }
	        var views = {}, viewsObject = state.views || { $default: core.pick(state, allViewKeys) };
	        core.forEach(viewsObject, function (config, name) {
	            // Account for views: { "": { template... } }
	            name = name || '$default';
	            // Account for views: { header: "headerComponent" }
	            if (core.isString(config))
	                config = { component: config };
	            // Make a shallow copy of the config object
	            config = core.extend({}, config);
	            // Do not allow a view to mix props for component-style view with props for template/controller-style view
	            if (hasAnyKey(compKeys, config) && hasAnyKey(nonCompKeys, config)) {
	                throw new Error("Cannot combine: " + compKeys.join('|') + " with: " + nonCompKeys.join('|') + " in stateview: '" + name + "@" + state.name + "'");
	            }
	            config.resolveAs = config.resolveAs || '$resolve';
	            config.$type = 'ng1';
	            config.$context = state;
	            config.$name = name;
	            var normalized = core.ViewService.normalizeUIViewTarget(config.$context, config.$name);
	            config.$uiViewName = normalized.uiViewName;
	            config.$uiViewContextAnchor = normalized.uiViewContextAnchor;
	            views[name] = config;
	        });
	        return views;
	    }
	    /** @hidden */
	    var id = 0;
	    /** @internalapi */
	    var Ng1ViewConfig = /** @class */ (function () {
	        function Ng1ViewConfig(path, viewDecl, factory) {
	            var _this = this;
	            this.path = path;
	            this.viewDecl = viewDecl;
	            this.factory = factory;
	            this.$id = id++;
	            this.loaded = false;
	            this.getTemplate = function (uiView, context) {
	                return _this.component
	                    ? _this.factory.makeComponentTemplate(uiView, context, _this.component, _this.viewDecl.bindings)
	                    : _this.template;
	            };
	        }
	        Ng1ViewConfig.prototype.load = function () {
	            var _this = this;
	            var $q = core.services.$q;
	            var context = new core.ResolveContext(this.path);
	            var params = this.path.reduce(function (acc, node) { return core.extend(acc, node.paramValues); }, {});
	            var promises = {
	                template: $q.when(this.factory.fromConfig(this.viewDecl, params, context)),
	                controller: $q.when(this.getController(context)),
	            };
	            return $q.all(promises).then(function (results) {
	                core.trace.traceViewServiceEvent('Loaded', _this);
	                _this.controller = results.controller;
	                core.extend(_this, results.template); // Either { template: "tpl" } or { component: "cmpName" }
	                return _this;
	            });
	        };
	        /**
	         * Gets the controller for a view configuration.
	         *
	         * @returns {Function|Promise.<Function>} Returns a controller, or a promise that resolves to a controller.
	         */
	        Ng1ViewConfig.prototype.getController = function (context) {
	            var provider = this.viewDecl.controllerProvider;
	            if (!core.isInjectable(provider))
	                return this.viewDecl.controller;
	            var deps = core.services.$injector.annotate(provider);
	            var providerFn = core.isArray(provider) ? core.tail(provider) : provider;
	            var resolvable = new core.Resolvable('', providerFn, deps);
	            return resolvable.get(context);
	        };
	        return Ng1ViewConfig;
	    }());
	
	    /** @publicapi @module view */ /** */
	    /**
	     * Service which manages loading of templates from a ViewConfig.
	     */
	    var TemplateFactory = /** @class */ (function () {
	        function TemplateFactory() {
	            var _this = this;
	            /** @hidden */ this._useHttp = ng.version.minor < 3;
	            /** @hidden */ this.$get = [
	                '$http',
	                '$templateCache',
	                '$injector',
	                function ($http, $templateCache, $injector) {
	                    _this.$templateRequest = $injector.has && $injector.has('$templateRequest') && $injector.get('$templateRequest');
	                    _this.$http = $http;
	                    _this.$templateCache = $templateCache;
	                    return _this;
	                },
	            ];
	        }
	        /** @hidden */
	        TemplateFactory.prototype.useHttpService = function (value) {
	            this._useHttp = value;
	        };
	        /**
	         * Creates a template from a configuration object.
	         *
	         * @param config Configuration object for which to load a template.
	         * The following properties are search in the specified order, and the first one
	         * that is defined is used to create the template:
	         *
	         * @param params  Parameters to pass to the template function.
	         * @param context The resolve context associated with the template's view
	         *
	         * @return {string|object}  The template html as a string, or a promise for
	         * that string,or `null` if no template is configured.
	         */
	        TemplateFactory.prototype.fromConfig = function (config, params, context) {
	            var defaultTemplate = '<ui-view></ui-view>';
	            var asTemplate = function (result) { return core.services.$q.when(result).then(function (str) { return ({ template: str }); }); };
	            var asComponent = function (result) { return core.services.$q.when(result).then(function (str) { return ({ component: str }); }); };
	            return core.isDefined(config.template)
	                ? asTemplate(this.fromString(config.template, params))
	                : core.isDefined(config.templateUrl)
	                    ? asTemplate(this.fromUrl(config.templateUrl, params))
	                    : core.isDefined(config.templateProvider)
	                        ? asTemplate(this.fromProvider(config.templateProvider, params, context))
	                        : core.isDefined(config.component)
	                            ? asComponent(config.component)
	                            : core.isDefined(config.componentProvider)
	                                ? asComponent(this.fromComponentProvider(config.componentProvider, params, context))
	                                : asTemplate(defaultTemplate);
	        };
	        /**
	         * Creates a template from a string or a function returning a string.
	         *
	         * @param template html template as a string or function that returns an html template as a string.
	         * @param params Parameters to pass to the template function.
	         *
	         * @return {string|object} The template html as a string, or a promise for that
	         * string.
	         */
	        TemplateFactory.prototype.fromString = function (template, params) {
	            return core.isFunction(template) ? template(params) : template;
	        };
	        /**
	         * Loads a template from the a URL via `$http` and `$templateCache`.
	         *
	         * @param {string|Function} url url of the template to load, or a function
	         * that returns a url.
	         * @param {Object} params Parameters to pass to the url function.
	         * @return {string|Promise.<string>} The template html as a string, or a promise
	         * for that string.
	         */
	        TemplateFactory.prototype.fromUrl = function (url, params) {
	            if (core.isFunction(url))
	                url = url(params);
	            if (url == null)
	                return null;
	            if (this._useHttp) {
	                return this.$http
	                    .get(url, { cache: this.$templateCache, headers: { Accept: 'text/html' } })
	                    .then(function (response) {
	                    return response.data;
	                });
	            }
	            return this.$templateRequest(url);
	        };
	        /**
	         * Creates a template by invoking an injectable provider function.
	         *
	         * @param provider Function to invoke via `locals`
	         * @param {Function} injectFn a function used to invoke the template provider
	         * @return {string|Promise.<string>} The template html as a string, or a promise
	         * for that string.
	         */
	        TemplateFactory.prototype.fromProvider = function (provider, params, context) {
	            var deps = core.services.$injector.annotate(provider);
	            var providerFn = core.isArray(provider) ? core.tail(provider) : provider;
	            var resolvable = new core.Resolvable('', providerFn, deps);
	            return resolvable.get(context);
	        };
	        /**
	         * Creates a component's template by invoking an injectable provider function.
	         *
	         * @param provider Function to invoke via `locals`
	         * @param {Function} injectFn a function used to invoke the template provider
	         * @return {string} The template html as a string: "<component-name input1='::$resolve.foo'></component-name>".
	         */
	        TemplateFactory.prototype.fromComponentProvider = function (provider, params, context) {
	            var deps = core.services.$injector.annotate(provider);
	            var providerFn = core.isArray(provider) ? core.tail(provider) : provider;
	            var resolvable = new core.Resolvable('', providerFn, deps);
	            return resolvable.get(context);
	        };
	        /**
	         * Creates a template from a component's name
	         *
	         * This implements route-to-component.
	         * It works by retrieving the component (directive) metadata from the injector.
	         * It analyses the component's bindings, then constructs a template that instantiates the component.
	         * The template wires input and output bindings to resolves or from the parent component.
	         *
	         * @param uiView {object} The parent ui-view (for binding outputs to callbacks)
	         * @param context The ResolveContext (for binding outputs to callbacks returned from resolves)
	         * @param component {string} Component's name in camel case.
	         * @param bindings An object defining the component's bindings: {foo: '<'}
	         * @return {string} The template as a string: "<component-name input1='::$resolve.foo'></component-name>".
	         */
	        TemplateFactory.prototype.makeComponentTemplate = function (uiView, context, component, bindings) {
	            bindings = bindings || {};
	            // Bind once prefix
	            var prefix = ng.version.minor >= 3 ? '::' : '';
	            // Convert to kebob name. Add x- prefix if the string starts with `x-` or `data-`
	            var kebob = function (camelCase) {
	                var kebobed = core.kebobString(camelCase);
	                return /^(x|data)-/.exec(kebobed) ? "x-" + kebobed : kebobed;
	            };
	            var attributeTpl = function (input) {
	                var name = input.name, type = input.type;
	                var attrName = kebob(name);
	                // If the ui-view has an attribute which matches a binding on the routed component
	                // then pass that attribute through to the routed component template.
	                // Prefer ui-view wired mappings to resolve data, unless the resolve was explicitly bound using `bindings:`
	                if (uiView.attr(attrName) && !bindings[name])
	                    return attrName + "='" + uiView.attr(attrName) + "'";
	                var resolveName = bindings[name] || name;
	                // Pre-evaluate the expression for "@" bindings by enclosing in {{ }}
	                // some-attr="{{ ::$resolve.someResolveName }}"
	                if (type === '@')
	                    return attrName + "='{{" + prefix + "$resolve." + resolveName + "}}'";
	                // Wire "&" callbacks to resolves that return a callback function
	                // Get the result of the resolve (should be a function) and annotate it to get its arguments.
	                // some-attr="$resolve.someResolveResultName(foo, bar)"
	                if (type === '&') {
	                    var res = context.getResolvable(resolveName);
	                    var fn = res && res.data;
	                    var args = (fn && core.services.$injector.annotate(fn)) || [];
	                    // account for array style injection, i.e., ['foo', function(foo) {}]
	                    var arrayIdxStr = core.isArray(fn) ? "[" + (fn.length - 1) + "]" : '';
	                    return attrName + "='$resolve." + resolveName + arrayIdxStr + "(" + args.join(',') + ")'";
	                }
	                // some-attr="::$resolve.someResolveName"
	                return attrName + "='" + prefix + "$resolve." + resolveName + "'";
	            };
	            var attrs = getComponentBindings(component).map(attributeTpl).join(' ');
	            var kebobName = kebob(component);
	            return "<" + kebobName + " " + attrs + "></" + kebobName + ">";
	        };
	        return TemplateFactory;
	    }());
	    // Gets all the directive(s)' inputs ('@', '=', and '<') and outputs ('&')
	    function getComponentBindings(name) {
	        var cmpDefs = core.services.$injector.get(name + 'Directive'); // could be multiple
	        if (!cmpDefs || !cmpDefs.length)
	            throw new Error("Unable to find component named '" + name + "'");
	        return cmpDefs.map(getBindings).reduce(core.unnestR, []);
	    }
	    // Given a directive definition, find its object input attributes
	    // Use different properties, depending on the type of directive (component, bindToController, normal)
	    var getBindings = function (def) {
	        if (core.isObject(def.bindToController))
	            return scopeBindings(def.bindToController);
	        return scopeBindings(def.scope);
	    };
	    // for ng 1.2 style, process the scope: { input: "=foo" }
	    // for ng 1.3 through ng 1.5, process the component's bindToController: { input: "=foo" } object
	    var scopeBindings = function (bindingsObj) {
	        return Object.keys(bindingsObj || {})
	            // [ 'input', [ '=foo', '=', 'foo' ] ]
	            .map(function (key) { return [key, /^([=<@&])[?]?(.*)/.exec(bindingsObj[key])]; })
	            // skip malformed values
	            .filter(function (tuple) { return core.isDefined(tuple) && core.isArray(tuple[1]); })
	            // { name: ('foo' || 'input'), type: '=' }
	            .map(function (tuple) { return ({ name: tuple[1][2] || tuple[0], type: tuple[1][1] }); });
	    };
	
	    /** @publicapi @module ng1 */ /** */
	    /**
	     * The Angular 1 `StateProvider`
	     *
	     * The `$stateProvider` works similar to Angular's v1 router, but it focuses purely
	     * on state.
	     *
	     * A state corresponds to a "place" in the application in terms of the overall UI and
	     * navigation. A state describes (via the controller / template / view properties) what
	     * the UI looks like and does at that place.
	     *
	     * States often have things in common, and the primary way of factoring out these
	     * commonalities in this model is via the state hierarchy, i.e. parent/child states aka
	     * nested states.
	     *
	     * The `$stateProvider` provides interfaces to declare these states for your app.
	     */
	    var StateProvider = /** @class */ (function () {
	        function StateProvider(stateRegistry, stateService) {
	            this.stateRegistry = stateRegistry;
	            this.stateService = stateService;
	            core.createProxyFunctions(core.val(StateProvider.prototype), this, core.val(this));
	        }
	        /**
	         * Decorates states when they are registered
	         *
	         * Allows you to extend (carefully) or override (at your own peril) the
	         * `stateBuilder` object used internally by [[StateRegistry]].
	         * This can be used to add custom functionality to ui-router,
	         * for example inferring templateUrl based on the state name.
	         *
	         * When passing only a name, it returns the current (original or decorated) builder
	         * function that matches `name`.
	         *
	         * The builder functions that can be decorated are listed below. Though not all
	         * necessarily have a good use case for decoration, that is up to you to decide.
	         *
	         * In addition, users can attach custom decorators, which will generate new
	         * properties within the state's internal definition. There is currently no clear
	         * use-case for this beyond accessing internal states (i.e. $state.$current),
	         * however, expect this to become increasingly relevant as we introduce additional
	         * meta-programming features.
	         *
	         * **Warning**: Decorators should not be interdependent because the order of
	         * execution of the builder functions in non-deterministic. Builder functions
	         * should only be dependent on the state definition object and super function.
	         *
	         *
	         * Existing builder functions and current return values:
	         *
	         * - **parent** `{object}` - returns the parent state object.
	         * - **data** `{object}` - returns state data, including any inherited data that is not
	         *   overridden by own values (if any).
	         * - **url** `{object}` - returns a {@link ui.router.util.type:UrlMatcher UrlMatcher}
	         *   or `null`.
	         * - **navigable** `{object}` - returns closest ancestor state that has a URL (aka is
	         *   navigable).
	         * - **params** `{object}` - returns an array of state params that are ensured to
	         *   be a super-set of parent's params.
	         * - **views** `{object}` - returns a views object where each key is an absolute view
	         *   name (i.e. "viewName@stateName") and each value is the config object
	         *   (template, controller) for the view. Even when you don't use the views object
	         *   explicitly on a state config, one is still created for you internally.
	         *   So by decorating this builder function you have access to decorating template
	         *   and controller properties.
	         * - **ownParams** `{object}` - returns an array of params that belong to the state,
	         *   not including any params defined by ancestor states.
	         * - **path** `{string}` - returns the full path from the root down to this state.
	         *   Needed for state activation.
	         * - **includes** `{object}` - returns an object that includes every state that
	         *   would pass a `$state.includes()` test.
	         *
	         * #### Example:
	         * Override the internal 'views' builder with a function that takes the state
	         * definition, and a reference to the internal function being overridden:
	         * ```js
	         * $stateProvider.decorator('views', function (state, parent) {
	         *   let result = {},
	         *       views = parent(state);
	         *
	         *   angular.forEach(views, function (config, name) {
	         *     let autoName = (state.name + '.' + name).replace('.', '/');
	         *     config.templateUrl = config.templateUrl || '/partials/' + autoName + '.html';
	         *     result[name] = config;
	         *   });
	         *   return result;
	         * });
	         *
	         * $stateProvider.state('home', {
	         *   views: {
	         *     'contact.list': { controller: 'ListController' },
	         *     'contact.item': { controller: 'ItemController' }
	         *   }
	         * });
	         * ```
	         *
	         *
	         * ```js
	         * // Auto-populates list and item views with /partials/home/contact/list.html,
	         * // and /partials/home/contact/item.html, respectively.
	         * $state.go('home');
	         * ```
	         *
	         * @param {string} name The name of the builder function to decorate.
	         * @param {object} func A function that is responsible for decorating the original
	         * builder function. The function receives two parameters:
	         *
	         *   - `{object}` - state - The state config object.
	         *   - `{object}` - super - The original builder function.
	         *
	         * @return {object} $stateProvider - $stateProvider instance
	         */
	        StateProvider.prototype.decorator = function (name, func) {
	            return this.stateRegistry.decorator(name, func) || this;
	        };
	        StateProvider.prototype.state = function (name, definition) {
	            if (core.isObject(name)) {
	                definition = name;
	            }
	            else {
	                definition.name = name;
	            }
	            this.stateRegistry.register(definition);
	            return this;
	        };
	        /**
	         * Registers an invalid state handler
	         *
	         * This is a passthrough to [[StateService.onInvalid]] for ng1.
	         */
	        StateProvider.prototype.onInvalid = function (callback) {
	            return this.stateService.onInvalid(callback);
	        };
	        return StateProvider;
	    }());
	
	    /** @publicapi @module ng1 */ /** */
	    /**
	     * This is a [[StateBuilder.builder]] function for angular1 `onEnter`, `onExit`,
	     * `onRetain` callback hooks on a [[Ng1StateDeclaration]].
	     *
	     * When the [[StateBuilder]] builds a [[StateObject]] object from a raw [[StateDeclaration]], this builder
	     * ensures that those hooks are injectable for @uirouter/angularjs (ng1).
	     *
	     * @internalapi
	     */
	    var getStateHookBuilder = function (hookName) {
	        return function stateHookBuilder(stateObject) {
	            var hook = stateObject[hookName];
	            var pathname = hookName === 'onExit' ? 'from' : 'to';
	            function decoratedNg1Hook(trans, state) {
	                var resolveContext = new core.ResolveContext(trans.treeChanges(pathname));
	                var subContext = resolveContext.subContext(state.$$state());
	                var locals = core.extend(getLocals(subContext), { $state$: state, $transition$: trans });
	                return core.services.$injector.invoke(hook, this, locals);
	            }
	            return hook ? decoratedNg1Hook : undefined;
	        };
	    };
	
	    /** @publicapi @module ng1 */ /** */
	    /**
	     * Implements UI-Router LocationServices and LocationConfig using Angular 1's $location service
	     * @internalapi
	     */
	    var Ng1LocationServices = /** @class */ (function () {
	        function Ng1LocationServices($locationProvider) {
	            // .onChange() registry
	            this._urlListeners = [];
	            this.$locationProvider = $locationProvider;
	            var _lp = core.val($locationProvider);
	            core.createProxyFunctions(_lp, this, _lp, ['hashPrefix']);
	        }
	        /**
	         * Applys ng1-specific path parameter encoding
	         *
	         * The Angular 1 `$location` service is a bit weird.
	         * It doesn't allow slashes to be encoded/decoded bi-directionally.
	         *
	         * See the writeup at https://github.com/angular-ui/ui-router/issues/2598
	         *
	         * This code patches the `path` parameter type so it encoded/decodes slashes as ~2F
	         *
	         * @param router
	         */
	        Ng1LocationServices.monkeyPatchPathParameterType = function (router) {
	            var pathType = router.urlMatcherFactory.type('path');
	            pathType.encode = function (x) {
	                return x != null ? x.toString().replace(/(~|\/)/g, function (m) { return ({ '~': '~~', '/': '~2F' }[m]); }) : x;
	            };
	            pathType.decode = function (x) {
	                return x != null ? x.toString().replace(/(~~|~2F)/g, function (m) { return ({ '~~': '~', '~2F': '/' }[m]); }) : x;
	            };
	        };
	        // eslint-disable-next-line @typescript-eslint/no-empty-function
	        Ng1LocationServices.prototype.dispose = function () { };
	        Ng1LocationServices.prototype.onChange = function (callback) {
	            var _this = this;
	            this._urlListeners.push(callback);
	            return function () { return core.removeFrom(_this._urlListeners)(callback); };
	        };
	        Ng1LocationServices.prototype.html5Mode = function () {
	            var html5Mode = this.$locationProvider.html5Mode();
	            html5Mode = core.isObject(html5Mode) ? html5Mode.enabled : html5Mode;
	            return html5Mode && this.$sniffer.history;
	        };
	        Ng1LocationServices.prototype.baseHref = function () {
	            return this._baseHref || (this._baseHref = this.$browser.baseHref() || this.$window.location.pathname);
	        };
	        Ng1LocationServices.prototype.url = function (newUrl, replace, state) {
	            if (replace === void 0) { replace = false; }
	            if (core.isDefined(newUrl))
	                this.$location.url(newUrl);
	            if (replace)
	                this.$location.replace();
	            if (state)
	                this.$location.state(state);
	            return this.$location.url();
	        };
	        Ng1LocationServices.prototype._runtimeServices = function ($rootScope, $location, $sniffer, $browser, $window) {
	            var _this = this;
	            this.$location = $location;
	            this.$sniffer = $sniffer;
	            this.$browser = $browser;
	            this.$window = $window;
	            // Bind $locationChangeSuccess to the listeners registered in LocationService.onChange
	            $rootScope.$on('$locationChangeSuccess', function (evt) { return _this._urlListeners.forEach(function (fn) { return fn(evt); }); });
	            var _loc = core.val($location);
	            // Bind these LocationService functions to $location
	            core.createProxyFunctions(_loc, this, _loc, ['replace', 'path', 'search', 'hash']);
	            // Bind these LocationConfig functions to $location
	            core.createProxyFunctions(_loc, this, _loc, ['port', 'protocol', 'host']);
	        };
	        return Ng1LocationServices;
	    }());
	
	    /** @publicapi @module url */ /** */
	    /**
	     * Manages rules for client-side URL
	     *
	     * ### Deprecation warning:
	     * This class is now considered to be an internal API
	     * Use the [[UrlService]] instead.
	     * For configuring URL rules, use the [[UrlRulesApi]] which can be found as [[UrlService.rules]].
	     *
	     * This class manages the router rules for what to do when the URL changes.
	     *
	     * This provider remains for backwards compatibility.
	     *
	     * @internalapi
	     * @deprecated
	     */
	    var UrlRouterProvider = /** @class */ (function () {
	        /** @hidden */
	        function UrlRouterProvider(/** @hidden */ router) {
	            this.router = router;
	        }
	        UrlRouterProvider.injectableHandler = function (router, handler) {
	            return function (match) { return core.services.$injector.invoke(handler, null, { $match: match, $stateParams: router.globals.params }); };
	        };
	        /** @hidden */
	        UrlRouterProvider.prototype.$get = function () {
	            var urlService = this.router.urlService;
	            this.router.urlRouter.update(true);
	            if (!urlService.interceptDeferred)
	                urlService.listen();
	            return this.router.urlRouter;
	        };
	        /**
	         * Registers a url handler function.
	         *
	         * Registers a low level url handler (a `rule`).
	         * A rule detects specific URL patterns and returns a redirect, or performs some action.
	         *
	         * If a rule returns a string, the URL is replaced with the string, and all rules are fired again.
	         *
	         * #### Example:
	         * ```js
	         * var app = angular.module('app', ['ui.router.router']);
	         *
	         * app.config(function ($urlRouterProvider) {
	         *   // Here's an example of how you might allow case insensitive urls
	         *   $urlRouterProvider.rule(function ($injector, $location) {
	         *     var path = $location.path(),
	         *         normalized = path.toLowerCase();
	         *
	         *     if (path !== normalized) {
	         *       return normalized;
	         *     }
	         *   });
	         * });
	         * ```
	         *
	         * @param ruleFn
	         * Handler function that takes `$injector` and `$location` services as arguments.
	         * You can use them to detect a url and return a different url as a string.
	         *
	         * @return [[UrlRouterProvider]] (`this`)
	         */
	        UrlRouterProvider.prototype.rule = function (ruleFn) {
	            var _this = this;
	            if (!core.isFunction(ruleFn))
	                throw new Error("'rule' must be a function");
	            var match = function () { return ruleFn(core.services.$injector, _this.router.locationService); };
	            var rule = new core.BaseUrlRule(match, core.identity);
	            this.router.urlService.rules.rule(rule);
	            return this;
	        };
	        /**
	         * Defines the path or behavior to use when no url can be matched.
	         *
	         * #### Example:
	         * ```js
	         * var app = angular.module('app', ['ui.router.router']);
	         *
	         * app.config(function ($urlRouterProvider) {
	         *   // if the path doesn't match any of the urls you configured
	         *   // otherwise will take care of routing the user to the
	         *   // specified url
	         *   $urlRouterProvider.otherwise('/index');
	         *
	         *   // Example of using function rule as param
	         *   $urlRouterProvider.otherwise(function ($injector, $location) {
	         *     return '/a/valid/url';
	         *   });
	         * });
	         * ```
	         *
	         * @param rule
	         * The url path you want to redirect to or a function rule that returns the url path or performs a `$state.go()`.
	         * The function version is passed two params: `$injector` and `$location` services, and should return a url string.
	         *
	         * @return {object} `$urlRouterProvider` - `$urlRouterProvider` instance
	         */
	        UrlRouterProvider.prototype.otherwise = function (rule) {
	            var _this = this;
	            var urlRules = this.router.urlService.rules;
	            if (core.isString(rule)) {
	                urlRules.otherwise(rule);
	            }
	            else if (core.isFunction(rule)) {
	                urlRules.otherwise(function () { return rule(core.services.$injector, _this.router.locationService); });
	            }
	            else {
	                throw new Error("'rule' must be a string or function");
	            }
	            return this;
	        };
	        /**
	         * Registers a handler for a given url matching.
	         *
	         * If the handler is a string, it is
	         * treated as a redirect, and is interpolated according to the syntax of match
	         * (i.e. like `String.replace()` for `RegExp`, or like a `UrlMatcher` pattern otherwise).
	         *
	         * If the handler is a function, it is injectable.
	         * It gets invoked if `$location` matches.
	         * You have the option of inject the match object as `$match`.
	         *
	         * The handler can return
	         *
	         * - **falsy** to indicate that the rule didn't match after all, then `$urlRouter`
	         *   will continue trying to find another one that matches.
	         * - **string** which is treated as a redirect and passed to `$location.url()`
	         * - **void** or any **truthy** value tells `$urlRouter` that the url was handled.
	         *
	         * #### Example:
	         * ```js
	         * var app = angular.module('app', ['ui.router.router']);
	         *
	         * app.config(function ($urlRouterProvider) {
	         *   $urlRouterProvider.when($state.url, function ($match, $stateParams) {
	         *     if ($state.$current.navigable !== state ||
	         *         !equalForKeys($match, $stateParams) {
	         *      $state.transitionTo(state, $match, false);
	         *     }
	         *   });
	         * });
	         * ```
	         *
	         * @param what A pattern string to match, compiled as a [[UrlMatcher]].
	         * @param handler The path (or function that returns a path) that you want to redirect your user to.
	         * @param ruleCallback [optional] A callback that receives the `rule` registered with [[UrlMatcher.rule]]
	         *
	         * Note: the handler may also invoke arbitrary code, such as `$state.go()`
	         */
	        UrlRouterProvider.prototype.when = function (what, handler) {
	            if (core.isArray(handler) || core.isFunction(handler)) {
	                handler = UrlRouterProvider.injectableHandler(this.router, handler);
	            }
	            this.router.urlService.rules.when(what, handler);
	            return this;
	        };
	        /**
	         * Disables monitoring of the URL.
	         *
	         * Call this method before UI-Router has bootstrapped.
	         * It will stop UI-Router from performing the initial url sync.
	         *
	         * This can be useful to perform some asynchronous initialization before the router starts.
	         * Once the initialization is complete, call [[listen]] to tell UI-Router to start watching and synchronizing the URL.
	         *
	         * #### Example:
	         * ```js
	         * var app = angular.module('app', ['ui.router']);
	         *
	         * app.config(function ($urlRouterProvider) {
	         *   // Prevent $urlRouter from automatically intercepting URL changes;
	         *   $urlRouterProvider.deferIntercept();
	         * })
	         *
	         * app.run(function (MyService, $urlRouter, $http) {
	         *   $http.get("/stuff").then(function(resp) {
	         *     MyService.doStuff(resp.data);
	         *     $urlRouter.listen();
	         *     $urlRouter.sync();
	         *   });
	         * });
	         * ```
	         *
	         * @param defer Indicates whether to defer location change interception.
	         *        Passing no parameter is equivalent to `true`.
	         */
	        UrlRouterProvider.prototype.deferIntercept = function (defer) {
	            this.router.urlService.deferIntercept(defer);
	        };
	        return UrlRouterProvider;
	    }());
	
	    /* eslint-disable @typescript-eslint/no-empty-function */
	    ng.module('ui.router.angular1', []);
	    var mod_init = ng.module('ui.router.init', ['ng']);
	    var mod_util = ng.module('ui.router.util', ['ui.router.init']);
	    var mod_rtr = ng.module('ui.router.router', ['ui.router.util']);
	    var mod_state = ng.module('ui.router.state', ['ui.router.router', 'ui.router.util', 'ui.router.angular1']);
	    var mod_main = ng.module('ui.router', ['ui.router.init', 'ui.router.state', 'ui.router.angular1']);
	    var mod_cmpt = ng.module('ui.router.compat', ['ui.router']);
	    var router = null;
	    $uiRouterProvider.$inject = ['$locationProvider'];
	    /** This angular 1 provider instantiates a Router and exposes its services via the angular injector */
	    function $uiRouterProvider($locationProvider) {
	        // Create a new instance of the Router when the $uiRouterProvider is initialized
	        router = this.router = new core.UIRouter();
	        router.stateProvider = new StateProvider(router.stateRegistry, router.stateService);
	        // Apply ng1 specific StateBuilder code for `views`, `resolve`, and `onExit/Retain/Enter` properties
	        router.stateRegistry.decorator('views', ng1ViewsBuilder);
	        router.stateRegistry.decorator('onExit', getStateHookBuilder('onExit'));
	        router.stateRegistry.decorator('onRetain', getStateHookBuilder('onRetain'));
	        router.stateRegistry.decorator('onEnter', getStateHookBuilder('onEnter'));
	        router.viewService._pluginapi._viewConfigFactory('ng1', getNg1ViewConfigFactory());
	        // Disable decoding of params by UrlMatcherFactory because $location already handles this
	        router.urlService.config._decodeParams = false;
	        var ng1LocationService = (router.locationService = router.locationConfig = new Ng1LocationServices($locationProvider));
	        Ng1LocationServices.monkeyPatchPathParameterType(router);
	        // backwards compat: also expose router instance as $uiRouterProvider.router
	        router['router'] = router;
	        router['$get'] = $get;
	        $get.$inject = ['$location', '$browser', '$window', '$sniffer', '$rootScope', '$http', '$templateCache'];
	        function $get($location, $browser, $window, $sniffer, $rootScope, $http, $templateCache) {
	            ng1LocationService._runtimeServices($rootScope, $location, $sniffer, $browser, $window);
	            delete router['router'];
	            delete router['$get'];
	            return router;
	        }
	        return router;
	    }
	    var getProviderFor = function (serviceName) { return [
	        '$uiRouterProvider',
	        function ($urp) {
	            var service = $urp.router[serviceName];
	            service['$get'] = function () { return service; };
	            return service;
	        },
	    ]; };
	    // This effectively calls $get() on `$uiRouterProvider` to trigger init (when ng enters runtime)
	    runBlock.$inject = ['$injector', '$q', '$uiRouter'];
	    function runBlock($injector, $q, $uiRouter) {
	        core.services.$injector = $injector;
	        core.services.$q = $q;
	        // https://github.com/angular-ui/ui-router/issues/3678
	        if (!Object.prototype.hasOwnProperty.call($injector, 'strictDi')) {
	            try {
	                $injector.invoke(function (checkStrictDi) { });
	            }
	            catch (error) {
	                $injector.strictDi = !!/strict mode/.exec(error && error.toString());
	            }
	        }
	        // The $injector is now available.
	        // Find any resolvables that had dependency annotation deferred
	        $uiRouter.stateRegistry
	            .get()
	            .map(function (x) { return x.$$state().resolvables; })
	            .reduce(core.unnestR, [])
	            .filter(function (x) { return x.deps === 'deferred'; })
	            .forEach(function (resolvable) { return (resolvable.deps = $injector.annotate(resolvable.resolveFn, $injector.strictDi)); });
	    }
	    // $urlRouter service and $urlRouterProvider
	    var getUrlRouterProvider = function (uiRouter) { return (uiRouter.urlRouterProvider = new UrlRouterProvider(uiRouter)); };
	    // $state service and $stateProvider
	    // $urlRouter service and $urlRouterProvider
	    var getStateProvider = function () { return core.extend(router.stateProvider, { $get: function () { return router.stateService; } }); };
	    watchDigests.$inject = ['$rootScope'];
	    function watchDigests($rootScope) {
	        $rootScope.$watch(function () {
	            core.trace.approximateDigests++;
	        });
	    }
	    mod_init.provider('$uiRouter', $uiRouterProvider);
	    mod_rtr.provider('$urlRouter', ['$uiRouterProvider', getUrlRouterProvider]);
	    mod_util.provider('$urlService', getProviderFor('urlService'));
	    mod_util.provider('$urlMatcherFactory', ['$uiRouterProvider', function () { return router.urlMatcherFactory; }]);
	    mod_util.provider('$templateFactory', function () { return new TemplateFactory(); });
	    mod_state.provider('$stateRegistry', getProviderFor('stateRegistry'));
	    mod_state.provider('$uiRouterGlobals', getProviderFor('globals'));
	    mod_state.provider('$transitions', getProviderFor('transitionService'));
	    mod_state.provider('$state', ['$uiRouterProvider', getStateProvider]);
	    mod_state.factory('$stateParams', ['$uiRouter', function ($uiRouter) { return $uiRouter.globals.params; }]);
	    mod_main.factory('$view', function () { return router.viewService; });
	    mod_main.service('$trace', function () { return core.trace; });
	    mod_main.run(watchDigests);
	    mod_util.run(['$urlMatcherFactory', function ($urlMatcherFactory) { }]);
	    mod_state.run(['$state', function ($state) { }]);
	    mod_rtr.run(['$urlRouter', function ($urlRouter) { }]);
	    mod_init.run(runBlock);
	    /** @hidden TODO: find a place to move this */
	    var getLocals = function (ctx) {
	        var tokens = ctx.getTokens().filter(core.isString);
	        var tuples = tokens.map(function (key) {
	            var resolvable = ctx.getResolvable(key);
	            var waitPolicy = ctx.getPolicy(resolvable).async;
	            return [key, waitPolicy === 'NOWAIT' ? resolvable.promise : resolvable.data];
	        });
	        return tuples.reduce(core.applyPairs, {});
	    };
	
	    /* eslint-disable @typescript-eslint/no-empty-interface */
	    /** @hidden */
	    function parseStateRef(ref) {
	        var paramsOnly = ref.match(/^\s*({[^}]*})\s*$/);
	        if (paramsOnly)
	            ref = '(' + paramsOnly[1] + ')';
	        var parsed = ref.replace(/\n/g, ' ').match(/^\s*([^(]*?)\s*(\((.*)\))?\s*$/);
	        if (!parsed || parsed.length !== 4)
	            throw new Error("Invalid state ref '" + ref + "'");
	        return { state: parsed[1] || null, paramExpr: parsed[3] || null };
	    }
	    /** @hidden */
	    function stateContext(el) {
	        var $uiView = el.parent().inheritedData('$uiView');
	        var path = core.parse('$cfg.path')($uiView);
	        return path ? core.tail(path).state.name : undefined;
	    }
	    /** @hidden */
	    function processedDef($state, $element, def) {
	        var uiState = def.uiState || $state.current.name;
	        var uiStateOpts = core.extend(defaultOpts($element, $state), def.uiStateOpts || {});
	        var href = $state.href(uiState, def.uiStateParams, uiStateOpts);
	        return { uiState: uiState, uiStateParams: def.uiStateParams, uiStateOpts: uiStateOpts, href: href };
	    }
	    /** @hidden */
	    function getTypeInfo(el) {
	        // SVGAElement does not use the href attribute, but rather the 'xlinkHref' attribute.
	        var isSvg = Object.prototype.toString.call(el.prop('href')) === '[object SVGAnimatedString]';
	        var isForm = el[0].nodeName === 'FORM';
	        return {
	            attr: isForm ? 'action' : isSvg ? 'xlink:href' : 'href',
	            isAnchor: el.prop('tagName').toUpperCase() === 'A',
	            clickable: !isForm,
	        };
	    }
	    /** @hidden */
	    function clickHook(el, $state, $timeout, type, getDef) {
	        return function (e) {
	            var button = e.which || e.button, target = getDef();
	            if (!(button > 1 || e.ctrlKey || e.metaKey || e.shiftKey || e.altKey || el.attr('target'))) {
	                // HACK: This is to allow ng-clicks to be processed before the transition is initiated:
	                var transition_1 = $timeout(function () {
	                    if (!el.attr('disabled')) {
	                        $state.go(target.uiState, target.uiStateParams, target.uiStateOpts);
	                    }
	                });
	                e.preventDefault();
	                // if the state has no URL, ignore one preventDefault from the <a> directive.
	                var ignorePreventDefaultCount_1 = type.isAnchor && !target.href ? 1 : 0;
	                e.preventDefault = function () {
	                    if (ignorePreventDefaultCount_1-- <= 0)
	                        $timeout.cancel(transition_1);
	                };
	            }
	        };
	    }
	    /** @hidden */
	    function defaultOpts(el, $state) {
	        return {
	            relative: stateContext(el) || $state.$current,
	            inherit: true,
	            source: 'sref',
	        };
	    }
	    /** @hidden */
	    function bindEvents(element, scope, hookFn, uiStateOpts) {
	        var events;
	        if (uiStateOpts) {
	            events = uiStateOpts.events;
	        }
	        if (!core.isArray(events)) {
	            events = ['click'];
	        }
	        var on = element.on ? 'on' : 'bind';
	        for (var _i = 0, events_1 = events; _i < events_1.length; _i++) {
	            var event_1 = events_1[_i];
	            element[on](event_1, hookFn);
	        }
	        scope.$on('$destroy', function () {
	            var off = element.off ? 'off' : 'unbind';
	            for (var _i = 0, events_2 = events; _i < events_2.length; _i++) {
	                var event_2 = events_2[_i];
	                element[off](event_2, hookFn);
	            }
	        });
	    }
	    /**
	     * `ui-sref`: A directive for linking to a state
	     *
	     * A directive which links to a state (and optionally, parameters).
	     * When clicked, this directive activates the linked state with the supplied parameter values.
	     *
	     * ### Linked State
	     * The attribute value of the `ui-sref` is the name of the state to link to.
	     *
	     * #### Example:
	     * This will activate the `home` state when the link is clicked.
	     * ```html
	     * <a ui-sref="home">Home</a>
	     * ```
	     *
	     * ### Relative Links
	     * You can also use relative state paths within `ui-sref`, just like a relative path passed to `$state.go()` ([[StateService.go]]).
	     * You just need to be aware that the path is relative to the state that *created* the link.
	     * This allows a state to create a relative `ui-sref` which always targets the same destination.
	     *
	     * #### Example:
	     * Both these links are relative to the parent state, even when a child state is currently active.
	     * ```html
	     * <a ui-sref=".child1">child 1 state</a>
	     * <a ui-sref=".child2">child 2 state</a>
	     * ```
	     *
	     * This link activates the parent state.
	     * ```html
	     * <a ui-sref="^">Return</a>
	     * ```
	     *
	     * ### hrefs
	     * If the linked state has a URL, the directive will automatically generate and
	     * update the `href` attribute (using the [[StateService.href]]  method).
	     *
	     * #### Example:
	     * Assuming the `users` state has a url of `/users/`
	     * ```html
	     * <a ui-sref="users" href="/users/">Users</a>
	     * ```
	     *
	     * ### Parameter Values
	     * In addition to the state name, a `ui-sref` can include parameter values which are applied when activating the state.
	     * Param values can be provided in the `ui-sref` value after the state name, enclosed by parentheses.
	     * The content inside the parentheses is an expression, evaluated to the parameter values.
	     *
	     * #### Example:
	     * This example renders a list of links to users.
	     * The state's `userId` parameter value comes from each user's `user.id` property.
	     * ```html
	     * <li ng-repeat="user in users">
	     *   <a ui-sref="users.detail({ userId: user.id })">{{ user.displayName }}</a>
	     * </li>
	     * ```
	     *
	     * Note:
	     * The parameter values expression is `$watch`ed for updates.
	     *
	     * ### Transition Options
	     * You can specify [[TransitionOptions]] to pass to [[StateService.go]] by using the `ui-sref-opts` attribute.
	     * Options are restricted to `location`, `inherit`, and `reload`.
	     *
	     * #### Example:
	     * ```html
	     * <a ui-sref="home" ui-sref-opts="{ reload: true }">Home</a>
	     * ```
	     *
	     * ### Other DOM Events
	     *
	     * You can also customize which DOM events to respond to (instead of `click`) by
	     * providing an `events` array in the `ui-sref-opts` attribute.
	     *
	     * #### Example:
	     * ```html
	     * <input type="text" ui-sref="contacts" ui-sref-opts="{ events: ['change', 'blur'] }">
	     * ```
	     *
	     * ### Highlighting the active link
	     * This directive can be used in conjunction with [[uiSrefActive]] to highlight the active link.
	     *
	     * ### Examples
	     * If you have the following template:
	     *
	     * ```html
	     * <a ui-sref="home">Home</a>
	     * <a ui-sref="about">About</a>
	     * <a ui-sref="{page: 2}">Next page</a>
	     *
	     * <ul>
	     *     <li ng-repeat="contact in contacts">
	     *         <a ui-sref="contacts.detail({ id: contact.id })">{{ contact.name }}</a>
	     *     </li>
	     * </ul>
	     * ```
	     *
	     * Then (assuming the current state is `contacts`) the rendered html including hrefs would be:
	     *
	     * ```html
	     * <a href="#/home" ui-sref="home">Home</a>
	     * <a href="#/about" ui-sref="about">About</a>
	     * <a href="#/contacts?page=2" ui-sref="{page: 2}">Next page</a>
	     *
	     * <ul>
	     *     <li ng-repeat="contact in contacts">
	     *         <a href="#/contacts/1" ui-sref="contacts.detail({ id: contact.id })">Joe</a>
	     *     </li>
	     *     <li ng-repeat="contact in contacts">
	     *         <a href="#/contacts/2" ui-sref="contacts.detail({ id: contact.id })">Alice</a>
	     *     </li>
	     *     <li ng-repeat="contact in contacts">
	     *         <a href="#/contacts/3" ui-sref="contacts.detail({ id: contact.id })">Bob</a>
	     *     </li>
	     * </ul>
	     *
	     * <a href="#/home" ui-sref="home" ui-sref-opts="{reload: true}">Home</a>
	     * ```
	     *
	     * ### Notes
	     *
	     * - You can use `ui-sref` to change **only the parameter values** by omitting the state name and parentheses.
	     * #### Example:
	     * Sets the `lang` parameter to `en` and remains on the same state.
	     *
	     * ```html
	     * <a ui-sref="{ lang: 'en' }">English</a>
	     * ```
	     *
	     * - A middle-click, right-click, or ctrl-click is handled (natively) by the browser to open the href in a new window, for example.
	     *
	     * - Unlike the parameter values expression, the state name is not `$watch`ed (for performance reasons).
	     * If you need to dynamically update the state being linked to, use the fully dynamic [[uiState]] directive.
	     */
	    var uiSrefDirective;
	    uiSrefDirective = [
	        '$uiRouter',
	        '$timeout',
	        function $StateRefDirective($uiRouter, $timeout) {
	            var $state = $uiRouter.stateService;
	            return {
	                restrict: 'A',
	                require: ['?^uiSrefActive', '?^uiSrefActiveEq'],
	                link: function (scope, element, attrs, uiSrefActive) {
	                    var type = getTypeInfo(element);
	                    var active = uiSrefActive[1] || uiSrefActive[0];
	                    var unlinkInfoFn = null;
	                    var rawDef = {};
	                    var getDef = function () { return processedDef($state, element, rawDef); };
	                    var ref = parseStateRef(attrs.uiSref);
	                    rawDef.uiState = ref.state;
	                    rawDef.uiStateOpts = attrs.uiSrefOpts ? scope.$eval(attrs.uiSrefOpts) : {};
	                    function update() {
	                        var def = getDef();
	                        if (unlinkInfoFn)
	                            unlinkInfoFn();
	                        if (active)
	                            unlinkInfoFn = active.$$addStateInfo(def.uiState, def.uiStateParams);
	                        if (def.href != null)
	                            attrs.$set(type.attr, def.href);
	                    }
	                    if (ref.paramExpr) {
	                        scope.$watch(ref.paramExpr, function (val) {
	                            rawDef.uiStateParams = core.extend({}, val);
	                            update();
	                        }, true);
	                        rawDef.uiStateParams = core.extend({}, scope.$eval(ref.paramExpr));
	                    }
	                    update();
	                    scope.$on('$destroy', $uiRouter.stateRegistry.onStatesChanged(update));
	                    scope.$on('$destroy', $uiRouter.transitionService.onSuccess({}, update));
	                    if (!type.clickable)
	                        return;
	                    var hookFn = clickHook(element, $state, $timeout, type, getDef);
	                    bindEvents(element, scope, hookFn, rawDef.uiStateOpts);
	                },
	            };
	        },
	    ];
	    /**
	     * `ui-state`: A fully dynamic directive for linking to a state
	     *
	     * A directive which links to a state (and optionally, parameters).
	     * When clicked, this directive activates the linked state with the supplied parameter values.
	     *
	     * **This directive is very similar to [[uiSref]], but it `$observe`s and `$watch`es/evaluates all its inputs.**
	     *
	     * A directive which links to a state (and optionally, parameters).
	     * When clicked, this directive activates the linked state with the supplied parameter values.
	     *
	     * ### Linked State
	     * The attribute value of `ui-state` is an expression which is `$watch`ed and evaluated as the state to link to.
	     * **This is in contrast with `ui-sref`, which takes a state name as a string literal.**
	     *
	     * #### Example:
	     * Create a list of links.
	     * ```html
	     * <li ng-repeat="link in navlinks">
	     *   <a ui-state="link.state">{{ link.displayName }}</a>
	     * </li>
	     * ```
	     *
	     * ### Relative Links
	     * If the expression evaluates to a relative path, it is processed like [[uiSref]].
	     * You just need to be aware that the path is relative to the state that *created* the link.
	     * This allows a state to create relative `ui-state` which always targets the same destination.
	     *
	     * ### hrefs
	     * If the linked state has a URL, the directive will automatically generate and
	     * update the `href` attribute (using the [[StateService.href]]  method).
	     *
	     * ### Parameter Values
	     * In addition to the state name expression, a `ui-state` can include parameter values which are applied when activating the state.
	     * Param values should be provided using the `ui-state-params` attribute.
	     * The `ui-state-params` attribute value is `$watch`ed and evaluated as an expression.
	     *
	     * #### Example:
	     * This example renders a list of links with param values.
	     * The state's `userId` parameter value comes from each user's `user.id` property.
	     * ```html
	     * <li ng-repeat="link in navlinks">
	     *   <a ui-state="link.state" ui-state-params="link.params">{{ link.displayName }}</a>
	     * </li>
	     * ```
	     *
	     * ### Transition Options
	     * You can specify [[TransitionOptions]] to pass to [[StateService.go]] by using the `ui-state-opts` attribute.
	     * Options are restricted to `location`, `inherit`, and `reload`.
	     * The value of the `ui-state-opts` is `$watch`ed and evaluated as an expression.
	     *
	     * #### Example:
	     * ```html
	     * <a ui-state="returnto.state" ui-state-opts="{ reload: true }">Home</a>
	     * ```
	     *
	     * ### Other DOM Events
	     *
	     * You can also customize which DOM events to respond to (instead of `click`) by
	     * providing an `events` array in the `ui-state-opts` attribute.
	     *
	     * #### Example:
	     * ```html
	     * <input type="text" ui-state="contacts" ui-state-opts="{ events: ['change', 'blur'] }">
	     * ```
	     *
	     * ### Highlighting the active link
	     * This directive can be used in conjunction with [[uiSrefActive]] to highlight the active link.
	     *
	     * ### Notes
	     *
	     * - You can use `ui-params` to change **only the parameter values** by omitting the state name and supplying only `ui-state-params`.
	     *   However, it might be simpler to use [[uiSref]] parameter-only links.
	     *
	     * #### Example:
	     * Sets the `lang` parameter to `en` and remains on the same state.
	     *
	     * ```html
	     * <a ui-state="" ui-state-params="{ lang: 'en' }">English</a>
	     * ```
	     *
	     * - A middle-click, right-click, or ctrl-click is handled (natively) by the browser to open the href in a new window, for example.
	     * ```
	     */
	    var uiStateDirective;
	    uiStateDirective = [
	        '$uiRouter',
	        '$timeout',
	        function $StateRefDynamicDirective($uiRouter, $timeout) {
	            var $state = $uiRouter.stateService;
	            return {
	                restrict: 'A',
	                require: ['?^uiSrefActive', '?^uiSrefActiveEq'],
	                link: function (scope, element, attrs, uiSrefActive) {
	                    var type = getTypeInfo(element);
	                    var active = uiSrefActive[1] || uiSrefActive[0];
	                    var unlinkInfoFn = null;
	                    var hookFn;
	                    var rawDef = {};
	                    var getDef = function () { return processedDef($state, element, rawDef); };
	                    var inputAttrs = ['uiState', 'uiStateParams', 'uiStateOpts'];
	                    var watchDeregFns = inputAttrs.reduce(function (acc, attr) { return ((acc[attr] = core.noop), acc); }, {});
	                    function update() {
	                        var def = getDef();
	                        if (unlinkInfoFn)
	                            unlinkInfoFn();
	                        if (active)
	                            unlinkInfoFn = active.$$addStateInfo(def.uiState, def.uiStateParams);
	                        if (def.href != null)
	                            attrs.$set(type.attr, def.href);
	                    }
	                    inputAttrs.forEach(function (field) {
	                        rawDef[field] = attrs[field] ? scope.$eval(attrs[field]) : null;
	                        attrs.$observe(field, function (expr) {
	                            watchDeregFns[field]();
	                            watchDeregFns[field] = scope.$watch(expr, function (newval) {
	                                rawDef[field] = newval;
	                                update();
	                            }, true);
	                        });
	                    });
	                    update();
	                    scope.$on('$destroy', $uiRouter.stateRegistry.onStatesChanged(update));
	                    scope.$on('$destroy', $uiRouter.transitionService.onSuccess({}, update));
	                    if (!type.clickable)
	                        return;
	                    hookFn = clickHook(element, $state, $timeout, type, getDef);
	                    bindEvents(element, scope, hookFn, rawDef.uiStateOpts);
	                },
	            };
	        },
	    ];
	    /**
	     * `ui-sref-active` and `ui-sref-active-eq`: A directive that adds a CSS class when a `ui-sref` is active
	     *
	     * A directive working alongside [[uiSref]] and [[uiState]] to add classes to an element when the
	     * related directive's state is active (and remove them when it is inactive).
	     *
	     * The primary use-case is to highlight the active link in navigation menus,
	     * distinguishing it from the inactive menu items.
	     *
	     * ### Linking to a `ui-sref` or `ui-state`
	     * `ui-sref-active` can live on the same element as `ui-sref`/`ui-state`, or it can be on a parent element.
	     * If a `ui-sref-active` is a parent to more than one `ui-sref`/`ui-state`, it will apply the CSS class when **any of the links are active**.
	     *
	     * ### Matching
	     *
	     * The `ui-sref-active` directive applies the CSS class when the `ui-sref`/`ui-state`'s target state **or any child state is active**.
	     * This is a "fuzzy match" which uses [[StateService.includes]].
	     *
	     * The `ui-sref-active-eq` directive applies the CSS class when the `ui-sref`/`ui-state`'s target state is directly active (not when child states are active).
	     * This is an "exact match" which uses [[StateService.is]].
	     *
	     * ### Parameter values
	     * If the `ui-sref`/`ui-state` includes parameter values, the current parameter values must match the link's values for the link to be highlighted.
	     * This allows a list of links to the same state with different parameters to be rendered, and the correct one highlighted.
	     *
	     * #### Example:
	     * ```html
	     * <li ng-repeat="user in users" ui-sref-active="active">
	     *   <a ui-sref="user.details({ userId: user.id })">{{ user.lastName }}</a>
	     * </li>
	     * ```
	     *
	     * ### Examples
	     *
	     * Given the following template:
	     * #### Example:
	     * ```html
	     * <ul>
	     *   <li ui-sref-active="active" class="item">
	     *     <a href ui-sref="app.user({user: 'bilbobaggins'})">@bilbobaggins</a>
	     *   </li>
	     * </ul>
	     * ```
	     *
	     * When the app state is `app.user` (or any child state),
	     * and contains the state parameter "user" with value "bilbobaggins",
	     * the resulting HTML will appear as (note the 'active' class):
	     *
	     * ```html
	     * <ul>
	     *   <li ui-sref-active="active" class="item active">
	     *     <a ui-sref="app.user({user: 'bilbobaggins'})" href="/users/bilbobaggins">@bilbobaggins</a>
	     *   </li>
	     * </ul>
	     * ```
	     *
	     * ### Glob mode
	     *
	     * It is possible to pass `ui-sref-active` an expression that evaluates to an object.
	     * The objects keys represent active class names and values represent the respective state names/globs.
	     * `ui-sref-active` will match if the current active state **includes** any of
	     * the specified state names/globs, even the abstract ones.
	     *
	     * #### Example:
	     * Given the following template, with "admin" being an abstract state:
	     * ```html
	     * <div ui-sref-active="{'active': 'admin.**'}">
	     *   <a ui-sref-active="active" ui-sref="admin.roles">Roles</a>
	     * </div>
	     * ```
	     *
	     * Arrays are also supported as values in the `ngClass`-like interface.
	     * This allows multiple states to add `active` class.
	     *
	     * #### Example:
	     * Given the following template, with "admin.roles" being the current state, the class will be added too:
	     * ```html
	     * <div ui-sref-active="{'active': ['owner.**', 'admin.**']}">
	     *   <a ui-sref-active="active" ui-sref="admin.roles">Roles</a>
	     * </div>
	     * ```
	     *
	     * When the current state is "admin.roles" the "active" class will be applied to both the `<div>` and `<a>` elements.
	     * It is important to note that the state names/globs passed to `ui-sref-active` override any state provided by a linked `ui-sref`.
	     *
	     * ### Notes:
	     *
	     * - The class name is interpolated **once** during the directives link time (any further changes to the
	     * interpolated value are ignored).
	     *
	     * - Multiple classes may be specified in a space-separated format: `ui-sref-active='class1 class2 class3'`
	     */
	    var uiSrefActiveDirective;
	    uiSrefActiveDirective = [
	        '$state',
	        '$stateParams',
	        '$interpolate',
	        '$uiRouter',
	        function $StateRefActiveDirective($state, $stateParams, $interpolate, $uiRouter) {
	            return {
	                restrict: 'A',
	                controller: [
	                    '$scope',
	                    '$element',
	                    '$attrs',
	                    function ($scope, $element, $attrs) {
	                        var states = [];
	                        var activeEqClass;
	                        var uiSrefActive;
	                        // There probably isn't much point in $observing this
	                        // uiSrefActive and uiSrefActiveEq share the same directive object with some
	                        // slight difference in logic routing
	                        activeEqClass = $interpolate($attrs.uiSrefActiveEq || '', false)($scope);
	                        try {
	                            uiSrefActive = $scope.$eval($attrs.uiSrefActive);
	                        }
	                        catch (e) {
	                            // Do nothing. uiSrefActive is not a valid expression.
	                            // Fall back to using $interpolate below
	                        }
	                        uiSrefActive = uiSrefActive || $interpolate($attrs.uiSrefActive || '', false)($scope);
	                        setStatesFromDefinitionObject(uiSrefActive);
	                        // Allow uiSref to communicate with uiSrefActive[Equals]
	                        this.$$addStateInfo = function (newState, newParams) {
	                            // we already got an explicit state provided by ui-sref-active, so we
	                            // shadow the one that comes from ui-sref
	                            if (core.isObject(uiSrefActive) && states.length > 0) {
	                                return;
	                            }
	                            var deregister = addState(newState, newParams, uiSrefActive);
	                            update();
	                            return deregister;
	                        };
	                        function updateAfterTransition(trans) {
	                            trans.promise.then(update, core.noop);
	                        }
	                        $scope.$on('$destroy', setupEventListeners());
	                        if ($uiRouter.globals.transition) {
	                            updateAfterTransition($uiRouter.globals.transition);
	                        }
	                        function setupEventListeners() {
	                            var deregisterStatesChangedListener = $uiRouter.stateRegistry.onStatesChanged(handleStatesChanged);
	                            var deregisterOnStartListener = $uiRouter.transitionService.onStart({}, updateAfterTransition);
	                            var deregisterStateChangeSuccessListener = $scope.$on('$stateChangeSuccess', update);
	                            return function cleanUp() {
	                                deregisterStatesChangedListener();
	                                deregisterOnStartListener();
	                                deregisterStateChangeSuccessListener();
	                            };
	                        }
	                        function handleStatesChanged() {
	                            setStatesFromDefinitionObject(uiSrefActive);
	                        }
	                        function setStatesFromDefinitionObject(statesDefinition) {
	                            if (core.isObject(statesDefinition)) {
	                                states = [];
	                                core.forEach(statesDefinition, function (stateOrName, activeClass) {
	                                    // Helper function to abstract adding state.
	                                    var addStateForClass = function (stateOrName, activeClass) {
	                                        var ref = parseStateRef(stateOrName);
	                                        addState(ref.state, $scope.$eval(ref.paramExpr), activeClass);
	                                    };
	                                    if (core.isString(stateOrName)) {
	                                        // If state is string, just add it.
	                                        addStateForClass(stateOrName, activeClass);
	                                    }
	                                    else if (core.isArray(stateOrName)) {
	                                        // If state is an array, iterate over it and add each array item individually.
	                                        core.forEach(stateOrName, function (stateOrName) {
	                                            addStateForClass(stateOrName, activeClass);
	                                        });
	                                    }
	                                });
	                            }
	                        }
	                        function addState(stateName, stateParams, activeClass) {
	                            var state = $state.get(stateName, stateContext($element));
	                            var stateInfo = {
	                                state: state || { name: stateName },
	                                params: stateParams,
	                                activeClass: activeClass,
	                            };
	                            states.push(stateInfo);
	                            return function removeState() {
	                                core.removeFrom(states)(stateInfo);
	                            };
	                        }
	                        // Update route state
	                        function update() {
	                            var splitClasses = function (str) { return str.split(/\s/).filter(core.identity); };
	                            var getClasses = function (stateList) {
	                                return stateList
	                                    .map(function (x) { return x.activeClass; })
	                                    .map(splitClasses)
	                                    .reduce(core.unnestR, []);
	                            };
	                            var allClasses = getClasses(states).concat(splitClasses(activeEqClass)).reduce(core.uniqR, []);
	                            var fuzzyClasses = getClasses(states.filter(function (x) { return $state.includes(x.state.name, x.params); }));
	                            var exactlyMatchesAny = !!states.filter(function (x) { return $state.is(x.state.name, x.params); }).length;
	                            var exactClasses = exactlyMatchesAny ? splitClasses(activeEqClass) : [];
	                            var addClasses = fuzzyClasses.concat(exactClasses).reduce(core.uniqR, []);
	                            var removeClasses = allClasses.filter(function (cls) { return !core.inArray(addClasses, cls); });
	                            $scope.$evalAsync(function () {
	                                addClasses.forEach(function (className) { return $element.addClass(className); });
	                                removeClasses.forEach(function (className) { return $element.removeClass(className); });
	                            });
	                        }
	                        update();
	                    },
	                ],
	            };
	        },
	    ];
	    ng
	        .module('ui.router.state')
	        .directive('uiSref', uiSrefDirective)
	        .directive('uiSrefActive', uiSrefActiveDirective)
	        .directive('uiSrefActiveEq', uiSrefActiveDirective)
	        .directive('uiState', uiStateDirective);
	
	    /** @publicapi @module ng1 */ /** */
	    /**
	     * `isState` Filter: truthy if the current state is the parameter
	     *
	     * Translates to [[StateService.is]] `$state.is("stateName")`.
	     *
	     * #### Example:
	     * ```html
	     * <div ng-if="'stateName' | isState">show if state is 'stateName'</div>
	     * ```
	     */
	    $IsStateFilter.$inject = ['$state'];
	    function $IsStateFilter($state) {
	        var isFilter = function (state, params, options) {
	            return $state.is(state, params, options);
	        };
	        isFilter.$stateful = true;
	        return isFilter;
	    }
	    /**
	     * `includedByState` Filter: truthy if the current state includes the parameter
	     *
	     * Translates to [[StateService.includes]]` $state.is("fullOrPartialStateName")`.
	     *
	     * #### Example:
	     * ```html
	     * <div ng-if="'fullOrPartialStateName' | includedByState">show if state includes 'fullOrPartialStateName'</div>
	     * ```
	     */
	    $IncludedByStateFilter.$inject = ['$state'];
	    function $IncludedByStateFilter($state) {
	        var includesFilter = function (state, params, options) {
	            return $state.includes(state, params, options);
	        };
	        includesFilter.$stateful = true;
	        return includesFilter;
	    }
	    ng.module('ui.router.state').filter('isState', $IsStateFilter).filter('includedByState', $IncludedByStateFilter);
	
	    /** @publicapi @module directives */ /** */
	    /**
	     * `ui-view`: A viewport directive which is filled in by a view from the active state.
	     *
	     * ### Attributes
	     *
	     * - `name`: (Optional) A view name.
	     *   The name should be unique amongst the other views in the same state.
	     *   You can have views of the same name that live in different states.
	     *   The ui-view can be targeted in a View using the name ([[Ng1StateDeclaration.views]]).
	     *
	     * - `autoscroll`: an expression. When it evaluates to true, the `ui-view` will be scrolled into view when it is activated.
	     *   Uses [[$uiViewScroll]] to do the scrolling.
	     *
	     * - `onload`: Expression to evaluate whenever the view updates.
	     *
	     * #### Example:
	     * A view can be unnamed or named.
	     * ```html
	     * <!-- Unnamed -->
	     * <div ui-view></div>
	     *
	     * <!-- Named -->
	     * <div ui-view="viewName"></div>
	     *
	     * <!-- Named (different style) -->
	     * <ui-view name="viewName"></ui-view>
	     * ```
	     *
	     * You can only have one unnamed view within any template (or root html). If you are only using a
	     * single view and it is unnamed then you can populate it like so:
	     *
	     * ```html
	     * <div ui-view></div>
	     * $stateProvider.state("home", {
	     *   template: "<h1>HELLO!</h1>"
	     * })
	     * ```
	     *
	     * The above is a convenient shortcut equivalent to specifying your view explicitly with the
	     * [[Ng1StateDeclaration.views]] config property, by name, in this case an empty name:
	     *
	     * ```js
	     * $stateProvider.state("home", {
	     *   views: {
	     *     "": {
	     *       template: "<h1>HELLO!</h1>"
	     *     }
	     *   }
	     * })
	     * ```
	     *
	     * But typically you'll only use the views property if you name your view or have more than one view
	     * in the same template. There's not really a compelling reason to name a view if its the only one,
	     * but you could if you wanted, like so:
	     *
	     * ```html
	     * <div ui-view="main"></div>
	     * ```
	     *
	     * ```js
	     * $stateProvider.state("home", {
	     *   views: {
	     *     "main": {
	     *       template: "<h1>HELLO!</h1>"
	     *     }
	     *   }
	     * })
	     * ```
	     *
	     * Really though, you'll use views to set up multiple views:
	     *
	     * ```html
	     * <div ui-view></div>
	     * <div ui-view="chart"></div>
	     * <div ui-view="data"></div>
	     * ```
	     *
	     * ```js
	     * $stateProvider.state("home", {
	     *   views: {
	     *     "": {
	     *       template: "<h1>HELLO!</h1>"
	     *     },
	     *     "chart": {
	     *       template: "<chart_thing/>"
	     *     },
	     *     "data": {
	     *       template: "<data_thing/>"
	     *     }
	     *   }
	     * })
	     * ```
	     *
	     * #### Examples for `autoscroll`:
	     * ```html
	     * <!-- If autoscroll present with no expression,
	     *      then scroll ui-view into view -->
	     * <ui-view autoscroll/>
	     *
	     * <!-- If autoscroll present with valid expression,
	     *      then scroll ui-view into view if expression evaluates to true -->
	     * <ui-view autoscroll='true'/>
	     * <ui-view autoscroll='false'/>
	     * <ui-view autoscroll='scopeVariable'/>
	     * ```
	     *
	     * Resolve data:
	     *
	     * The resolved data from the state's `resolve` block is placed on the scope as `$resolve` (this
	     * can be customized using [[Ng1ViewDeclaration.resolveAs]]).  This can be then accessed from the template.
	     *
	     * Note that when `controllerAs` is being used, `$resolve` is set on the controller instance *after* the
	     * controller is instantiated.  The `$onInit()` hook can be used to perform initialization code which
	     * depends on `$resolve` data.
	     *
	     * #### Example:
	     * ```js
	     * $stateProvider.state('home', {
	     *   template: '<my-component user="$resolve.user"></my-component>',
	     *   resolve: {
	     *     user: function(UserService) { return UserService.fetchUser(); }
	     *   }
	     * });
	     * ```
	     */
	    var uiView;
	    // eslint-disable-next-line prefer-const
	    uiView = [
	        '$view',
	        '$animate',
	        '$uiViewScroll',
	        '$interpolate',
	        '$q',
	        function $ViewDirective($view, $animate, $uiViewScroll, $interpolate, $q) {
	            function getRenderer() {
	                return {
	                    enter: function (element, target, cb) {
	                        if (ng.version.minor > 2) {
	                            $animate.enter(element, null, target).then(cb);
	                        }
	                        else {
	                            $animate.enter(element, null, target, cb);
	                        }
	                    },
	                    leave: function (element, cb) {
	                        if (ng.version.minor > 2) {
	                            $animate.leave(element).then(cb);
	                        }
	                        else {
	                            $animate.leave(element, cb);
	                        }
	                    },
	                };
	            }
	            function configsEqual(config1, config2) {
	                return config1 === config2;
	            }
	            var rootData = {
	                $cfg: { viewDecl: { $context: $view._pluginapi._rootViewContext() } },
	                $uiView: {},
	            };
	            var directive = {
	                count: 0,
	                restrict: 'ECA',
	                terminal: true,
	                priority: 400,
	                transclude: 'element',
	                compile: function (tElement, tAttrs, $transclude) {
	                    return function (scope, $element, attrs) {
	                        var onloadExp = attrs['onload'] || '', autoScrollExp = attrs['autoscroll'], renderer = getRenderer(), inherited = $element.inheritedData('$uiView') || rootData, name = $interpolate(attrs['uiView'] || attrs['name'] || '')(scope) || '$default';
	                        var previousEl, currentEl, currentScope, viewConfig;
	                        var activeUIView = {
	                            $type: 'ng1',
	                            id: directive.count++,
	                            name: name,
	                            fqn: inherited.$uiView.fqn ? inherited.$uiView.fqn + '.' + name : name,
	                            config: null,
	                            configUpdated: configUpdatedCallback,
	                            get creationContext() {
	                                // The context in which this ui-view "tag" was created
	                                var fromParentTagConfig = core.parse('$cfg.viewDecl.$context')(inherited);
	                                // Allow <ui-view name="foo"><ui-view name="bar"></ui-view></ui-view>
	                                // See https://github.com/angular-ui/ui-router/issues/3355
	                                var fromParentTag = core.parse('$uiView.creationContext')(inherited);
	                                return fromParentTagConfig || fromParentTag;
	                            },
	                        };
	                        core.trace.traceUIViewEvent('Linking', activeUIView);
	                        function configUpdatedCallback(config) {
	                            if (config && !(config instanceof Ng1ViewConfig))
	                                return;
	                            if (configsEqual(viewConfig, config))
	                                return;
	                            core.trace.traceUIViewConfigUpdated(activeUIView, config && config.viewDecl && config.viewDecl.$context);
	                            viewConfig = config;
	                            updateView(config);
	                        }
	                        $element.data('$uiView', { $uiView: activeUIView });
	                        updateView();
	                        var unregister = $view.registerUIView(activeUIView);
	                        scope.$on('$destroy', function () {
	                            core.trace.traceUIViewEvent('Destroying/Unregistering', activeUIView);
	                            unregister();
	                        });
	                        function cleanupLastView() {
	                            if (previousEl) {
	                                core.trace.traceUIViewEvent('Removing (previous) el', previousEl.data('$uiView'));
	                                previousEl.remove();
	                                previousEl = null;
	                            }
	                            if (currentScope) {
	                                core.trace.traceUIViewEvent('Destroying scope', activeUIView);
	                                currentScope.$destroy();
	                                currentScope = null;
	                            }
	                            if (currentEl) {
	                                var _viewData_1 = currentEl.data('$uiViewAnim');
	                                core.trace.traceUIViewEvent('Animate out', _viewData_1);
	                                renderer.leave(currentEl, function () {
	                                    _viewData_1.$$animLeave.resolve();
	                                    previousEl = null;
	                                });
	                                previousEl = currentEl;
	                                currentEl = null;
	                            }
	                        }
	                        function updateView(config) {
	                            var newScope = scope.$new();
	                            var animEnter = $q.defer(), animLeave = $q.defer();
	                            var $uiViewData = {
	                                $cfg: config,
	                                $uiView: activeUIView,
	                            };
	                            var $uiViewAnim = {
	                                $animEnter: animEnter.promise,
	                                $animLeave: animLeave.promise,
	                                $$animLeave: animLeave,
	                            };
	                            /**
	                             * @ngdoc event
	                             * @name ui.router.state.directive:ui-view#$viewContentLoading
	                             * @eventOf ui.router.state.directive:ui-view
	                             * @eventType emits on ui-view directive scope
	                             * @description
	                             *
	                             * Fired once the view **begins loading**, *before* the DOM is rendered.
	                             *
	                             * @param {Object} event Event object.
	                             * @param {string} viewName Name of the view.
	                             */
	                            newScope.$emit('$viewContentLoading', name);
	                            var cloned = $transclude(newScope, function (clone) {
	                                clone.data('$uiViewAnim', $uiViewAnim);
	                                clone.data('$uiView', $uiViewData);
	                                renderer.enter(clone, $element, function onUIViewEnter() {
	                                    animEnter.resolve();
	                                    if (currentScope)
	                                        currentScope.$emit('$viewContentAnimationEnded');
	                                    if ((core.isDefined(autoScrollExp) && !autoScrollExp) || scope.$eval(autoScrollExp)) {
	                                        $uiViewScroll(clone);
	                                    }
	                                });
	                                cleanupLastView();
	                            });
	                            currentEl = cloned;
	                            currentScope = newScope;
	                            /**
	                             * @ngdoc event
	                             * @name ui.router.state.directive:ui-view#$viewContentLoaded
	                             * @eventOf ui.router.state.directive:ui-view
	                             * @eventType emits on ui-view directive scope
	                             * @description           *
	                             * Fired once the view is **loaded**, *after* the DOM is rendered.
	                             *
	                             * @param {Object} event Event object.
	                             */
	                            currentScope.$emit('$viewContentLoaded', config || viewConfig);
	                            currentScope.$eval(onloadExp);
	                        }
	                    };
	                },
	            };
	            return directive;
	        },
	    ];
	    $ViewDirectiveFill.$inject = ['$compile', '$controller', '$transitions', '$view', '$q'];
	    /** @hidden */
	    function $ViewDirectiveFill($compile, $controller, $transitions, $view, $q) {
	        var getControllerAs = core.parse('viewDecl.controllerAs');
	        var getResolveAs = core.parse('viewDecl.resolveAs');
	        return {
	            restrict: 'ECA',
	            priority: -400,
	            compile: function (tElement) {
	                var initial = tElement.html();
	                tElement.empty();
	                return function (scope, $element) {
	                    var data = $element.data('$uiView');
	                    if (!data) {
	                        $element.html(initial);
	                        $compile($element.contents())(scope);
	                        return;
	                    }
	                    var cfg = data.$cfg || { viewDecl: {}, getTemplate: core.noop };
	                    var resolveCtx = cfg.path && new core.ResolveContext(cfg.path);
	                    $element.html(cfg.getTemplate($element, resolveCtx) || initial);
	                    core.trace.traceUIViewFill(data.$uiView, $element.html());
	                    var link = $compile($element.contents());
	                    var controller = cfg.controller;
	                    var controllerAs = getControllerAs(cfg);
	                    var resolveAs = getResolveAs(cfg);
	                    var locals = resolveCtx && getLocals(resolveCtx);
	                    scope[resolveAs] = locals;
	                    if (controller) {
	                        var controllerInstance = ($controller(controller, core.extend({}, locals, { $scope: scope, $element: $element })));
	                        if (controllerAs) {
	                            scope[controllerAs] = controllerInstance;
	                            scope[controllerAs][resolveAs] = locals;
	                        }
	                        // TODO: Use $view service as a central point for registering component-level hooks
	                        // Then, when a component is created, tell the $view service, so it can invoke hooks
	                        // $view.componentLoaded(controllerInstance, { $scope: scope, $element: $element });
	                        // scope.$on('$destroy', () => $view.componentUnloaded(controllerInstance, { $scope: scope, $element: $element }));
	                        $element.data('$ngControllerController', controllerInstance);
	                        $element.children().data('$ngControllerController', controllerInstance);
	                        registerControllerCallbacks($q, $transitions, controllerInstance, scope, cfg);
	                    }
	                    // Wait for the component to appear in the DOM
	                    if (core.isString(cfg.component)) {
	                        var kebobName = core.kebobString(cfg.component);
	                        var tagRegexp_1 = new RegExp("^(x-|data-)?" + kebobName + "$", 'i');
	                        var getComponentController = function () {
	                            var directiveEl = [].slice
	                                .call($element[0].children)
	                                .filter(function (el) { return el && el.tagName && tagRegexp_1.exec(el.tagName); });
	                            return directiveEl && ng.element(directiveEl).data("$" + cfg.component + "Controller");
	                        };
	                        var deregisterWatch_1 = scope.$watch(getComponentController, function (ctrlInstance) {
	                            if (!ctrlInstance)
	                                return;
	                            registerControllerCallbacks($q, $transitions, ctrlInstance, scope, cfg);
	                            deregisterWatch_1();
	                        });
	                    }
	                    link(scope);
	                };
	            },
	        };
	    }
	    /** @hidden */
	    var hasComponentImpl = typeof ng.module('ui.router')['component'] === 'function';
	    /** @hidden incrementing id */
	    var _uiCanExitId = 0;
	    /** @hidden TODO: move these callbacks to $view and/or `/hooks/components.ts` or something */
	    function registerControllerCallbacks($q, $transitions, controllerInstance, $scope, cfg) {
	        // Call $onInit() ASAP
	        if (core.isFunction(controllerInstance.$onInit) &&
	            !((cfg.viewDecl.component || cfg.viewDecl.componentProvider) && hasComponentImpl)) {
	            controllerInstance.$onInit();
	        }
	        var viewState = core.tail(cfg.path).state.self;
	        var hookOptions = { bind: controllerInstance };
	        // Add component-level hook for onUiParamsChanged
	        if (core.isFunction(controllerInstance.uiOnParamsChanged)) {
	            var resolveContext = new core.ResolveContext(cfg.path);
	            var viewCreationTrans_1 = resolveContext.getResolvable('$transition$').data;
	            // Fire callback on any successful transition
	            var paramsUpdated = function ($transition$) {
	                // Exit early if the $transition$ is the same as the view was created within.
	                // Exit early if the $transition$ will exit the state the view is for.
	                if ($transition$ === viewCreationTrans_1 || $transition$.exiting().indexOf(viewState) !== -1)
	                    return;
	                var toParams = $transition$.params('to');
	                var fromParams = $transition$.params('from');
	                var getNodeSchema = function (node) { return node.paramSchema; };
	                var toSchema = $transition$.treeChanges('to').map(getNodeSchema).reduce(core.unnestR, []);
	                var fromSchema = $transition$.treeChanges('from').map(getNodeSchema).reduce(core.unnestR, []);
	                // Find the to params that have different values than the from params
	                var changedToParams = toSchema.filter(function (param) {
	                    var idx = fromSchema.indexOf(param);
	                    return idx === -1 || !fromSchema[idx].type.equals(toParams[param.id], fromParams[param.id]);
	                });
	                // Only trigger callback if a to param has changed or is new
	                if (changedToParams.length) {
	                    var changedKeys_1 = changedToParams.map(function (x) { return x.id; });
	                    // Filter the params to only changed/new to params.  `$transition$.params()` may be used to get all params.
	                    var newValues = core.filter(toParams, function (val, key) { return changedKeys_1.indexOf(key) !== -1; });
	                    controllerInstance.uiOnParamsChanged(newValues, $transition$);
	                }
	            };
	            $scope.$on('$destroy', $transitions.onSuccess({}, paramsUpdated, hookOptions));
	        }
	        // Add component-level hook for uiCanExit
	        if (core.isFunction(controllerInstance.uiCanExit)) {
	            var id_1 = _uiCanExitId++;
	            var cacheProp_1 = '_uiCanExitIds';
	            // Returns true if a redirect transition already answered truthy
	            var prevTruthyAnswer_1 = function (trans) {
	                return !!trans && ((trans[cacheProp_1] && trans[cacheProp_1][id_1] === true) || prevTruthyAnswer_1(trans.redirectedFrom()));
	            };
	            // If a user answered yes, but the transition was later redirected, don't also ask for the new redirect transition
	            var wrappedHook = function (trans) {
	                var promise;
	                var ids = (trans[cacheProp_1] = trans[cacheProp_1] || {});
	                if (!prevTruthyAnswer_1(trans)) {
	                    promise = $q.when(controllerInstance.uiCanExit(trans));
	                    promise.then(function (val) { return (ids[id_1] = val !== false); });
	                }
	                return promise;
	            };
	            var criteria = { exiting: viewState.name };
	            $scope.$on('$destroy', $transitions.onBefore(criteria, wrappedHook, hookOptions));
	        }
	    }
	    ng.module('ui.router.state').directive('uiView', uiView);
	    ng.module('ui.router.state').directive('uiView', $ViewDirectiveFill);
	
	    /** @publicapi @module ng1 */ /** */
	    /** @hidden */
	    function $ViewScrollProvider() {
	        var useAnchorScroll = false;
	        this.useAnchorScroll = function () {
	            useAnchorScroll = true;
	        };
	        this.$get = [
	            '$anchorScroll',
	            '$timeout',
	            function ($anchorScroll, $timeout) {
	                if (useAnchorScroll) {
	                    return $anchorScroll;
	                }
	                return function ($element) {
	                    return $timeout(function () {
	                        $element[0].scrollIntoView();
	                    }, 0, false);
	                };
	            },
	        ];
	    }
	    ng.module('ui.router.state').provider('$uiViewScroll', $ViewScrollProvider);
	
	    /**
	     * Main entry point for angular 1.x build
	     * @publicapi @module ng1
	     */ /** */
	    var index = 'ui.router';
	
	    Object.keys(core).forEach(function (k) {
	        if (k !== 'default') Object.defineProperty(exports, k, {
	            enumerable: true,
	            get: function () {
	                return core[k];
	            }
	        });
	    });
	    exports.core = core;
	    exports.Ng1ViewConfig = Ng1ViewConfig;
	    exports.StateProvider = StateProvider;
	    exports.UrlRouterProvider = UrlRouterProvider;
	    exports.default = index;
	    exports.getLocals = getLocals;
	    exports.getNg1ViewConfigFactory = getNg1ViewConfigFactory;
	    exports.ng1ViewsBuilder = ng1ViewsBuilder;
	    exports.watchDigests = watchDigests;
	
	    Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=ui-router-angularjs.js.map


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.treeChangesCleanup = exports.registerAddCoreResolvables = void 0;
	var transition_1 = __webpack_require__(40);
	var router_1 = __webpack_require__(54);
	var resolve_1 = __webpack_require__(52);
	var common_1 = __webpack_require__(4);
	function addCoreResolvables(trans) {
	    trans.addResolvable(resolve_1.Resolvable.fromData(router_1.UIRouter, trans.router), '');
	    trans.addResolvable(resolve_1.Resolvable.fromData(transition_1.Transition, trans), '');
	    trans.addResolvable(resolve_1.Resolvable.fromData('$transition$', trans), '');
	    trans.addResolvable(resolve_1.Resolvable.fromData('$stateParams', trans.params()), '');
	    trans.entering().forEach(function (state) {
	        trans.addResolvable(resolve_1.Resolvable.fromData('$state$', state), state);
	    });
	}
	exports.registerAddCoreResolvables = function (transitionService) {
	    return transitionService.onCreate({}, addCoreResolvables);
	};
	var TRANSITION_TOKENS = ['$transition$', transition_1.Transition];
	var isTransition = common_1.inArray(TRANSITION_TOKENS);
	// References to Transition in the treeChanges pathnodes makes all
	// previous Transitions reachable in memory, causing a memory leak
	// This function removes resolves for '$transition$' and `Transition` from the treeChanges.
	// Do not use this on current transitions, only on old ones.
	exports.treeChangesCleanup = function (trans) {
	    var nodes = common_1.values(trans.treeChanges()).reduce(common_1.unnestR, []).reduce(common_1.uniqR, []);
	    // If the resolvable is a Transition, return a new resolvable with null data
	    var replaceTransitionWithNull = function (r) {
	        return isTransition(r.token) ? resolve_1.Resolvable.fromData(r.token, null) : r;
	    };
	    nodes.forEach(function (node) {
	        node.resolvables = node.resolvables.map(replaceTransitionWithNull);
	    });
	};
	//# sourceMappingURL=coreResolvables.js.map

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.registerIgnoredTransitionHook = void 0;
	var trace_1 = __webpack_require__(8);
	var rejectFactory_1 = __webpack_require__(12);
	/**
	 * A [[TransitionHookFn]] that skips a transition if it should be ignored
	 *
	 * This hook is invoked at the end of the onBefore phase.
	 *
	 * If the transition should be ignored (because no parameter or states changed)
	 * then the transition is ignored and not processed.
	 */
	function ignoredHook(trans) {
	    var ignoredReason = trans._ignoredReason();
	    if (!ignoredReason)
	        return;
	    trace_1.trace.traceTransitionIgnored(trans);
	    var pending = trans.router.globals.transition;
	    // The user clicked a link going back to the *current state* ('A')
	    // However, there is also a pending transition in flight (to 'B')
	    // Abort the transition to 'B' because the user now wants to be back at 'A'.
	    if (ignoredReason === 'SameAsCurrent' && pending) {
	        pending.abort();
	    }
	    return rejectFactory_1.Rejection.ignored().toPromise();
	}
	exports.registerIgnoredTransitionHook = function (transitionService) {
	    return transitionService.onBefore({}, ignoredHook, { priority: -9999 });
	};
	//# sourceMappingURL=ignoredTransition.js.map

/***/ }),
/* 98 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.registerInvalidTransitionHook = void 0;
	/**
	 * A [[TransitionHookFn]] that rejects the Transition if it is invalid
	 *
	 * This hook is invoked at the end of the onBefore phase.
	 * If the transition is invalid (for example, param values do not validate)
	 * then the transition is rejected.
	 */
	function invalidTransitionHook(trans) {
	    if (!trans.valid()) {
	        throw new Error(trans.error().toString());
	    }
	}
	exports.registerInvalidTransitionHook = function (transitionService) {
	    return transitionService.onBefore({}, invalidTransitionHook, { priority: -10000 });
	};
	//# sourceMappingURL=invalidTransition.js.map

/***/ }),
/* 99 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.registerOnEnterHook = exports.registerOnRetainHook = exports.registerOnExitHook = void 0;
	/**
	 * A factory which creates an onEnter, onExit or onRetain transition hook function
	 *
	 * The returned function invokes the (for instance) state.onEnter hook when the
	 * state is being entered.
	 */
	function makeEnterExitRetainHook(hookName) {
	    return function (transition, state) {
	        var _state = state.$$state();
	        var hookFn = _state[hookName];
	        return hookFn(transition, state);
	    };
	}
	/**
	 * The [[TransitionStateHookFn]] for onExit
	 *
	 * When the state is being exited, the state's .onExit function is invoked.
	 *
	 * Registered using `transitionService.onExit({ exiting: (state) => !!state.onExit }, onExitHook);`
	 *
	 * See: [[IHookRegistry.onExit]]
	 */
	var onExitHook = makeEnterExitRetainHook('onExit');
	exports.registerOnExitHook = function (transitionService) {
	    return transitionService.onExit({ exiting: function (state) { return !!state.onExit; } }, onExitHook);
	};
	/**
	 * The [[TransitionStateHookFn]] for onRetain
	 *
	 * When the state was already entered, and is not being exited or re-entered, the state's .onRetain function is invoked.
	 *
	 * Registered using `transitionService.onRetain({ retained: (state) => !!state.onRetain }, onRetainHook);`
	 *
	 * See: [[IHookRegistry.onRetain]]
	 */
	var onRetainHook = makeEnterExitRetainHook('onRetain');
	exports.registerOnRetainHook = function (transitionService) {
	    return transitionService.onRetain({ retained: function (state) { return !!state.onRetain; } }, onRetainHook);
	};
	/**
	 * The [[TransitionStateHookFn]] for onEnter
	 *
	 * When the state is being entered, the state's .onEnter function is invoked.
	 *
	 * Registered using `transitionService.onEnter({ entering: (state) => !!state.onEnter }, onEnterHook);`
	 *
	 * See: [[IHookRegistry.onEnter]]
	 */
	var onEnterHook = makeEnterExitRetainHook('onEnter');
	exports.registerOnEnterHook = function (transitionService) {
	    return transitionService.onEnter({ entering: function (state) { return !!state.onEnter; } }, onEnterHook);
	};
	//# sourceMappingURL=onEnterExitRetain.js.map

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.registerRedirectToHook = void 0;
	var predicates_1 = __webpack_require__(2);
	var coreservices_1 = __webpack_require__(5);
	var targetState_1 = __webpack_require__(15);
	/**
	 * A [[TransitionHookFn]] that redirects to a different state or params
	 *
	 * Registered using `transitionService.onStart({ to: (state) => !!state.redirectTo }, redirectHook);`
	 *
	 * See [[StateDeclaration.redirectTo]]
	 */
	var redirectToHook = function (trans) {
	    var redirect = trans.to().redirectTo;
	    if (!redirect)
	        return;
	    var $state = trans.router.stateService;
	    function handleResult(result) {
	        if (!result)
	            return;
	        if (result instanceof targetState_1.TargetState)
	            return result;
	        if (predicates_1.isString(result))
	            return $state.target(result, trans.params(), trans.options());
	        if (result['state'] || result['params'])
	            return $state.target(result['state'] || trans.to(), result['params'] || trans.params(), trans.options());
	    }
	    if (predicates_1.isFunction(redirect)) {
	        return coreservices_1.services.$q.when(redirect(trans)).then(handleResult);
	    }
	    return handleResult(redirect);
	};
	exports.registerRedirectToHook = function (transitionService) {
	    return transitionService.onStart({ to: function (state) { return !!state.redirectTo; } }, redirectToHook);
	};
	//# sourceMappingURL=redirectTo.js.map

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.registerResolveRemaining = exports.registerLazyResolveState = exports.registerEagerResolvePath = exports.RESOLVE_HOOK_PRIORITY = void 0;
	var common_1 = __webpack_require__(1);
	var resolveContext_1 = __webpack_require__(22);
	var hof_1 = __webpack_require__(3);
	exports.RESOLVE_HOOK_PRIORITY = 1000;
	/**
	 * A [[TransitionHookFn]] which resolves all EAGER Resolvables in the To Path
	 *
	 * Registered using `transitionService.onStart({}, eagerResolvePath, { priority: 1000 });`
	 *
	 * When a Transition starts, this hook resolves all the EAGER Resolvables, which the transition then waits for.
	 *
	 * See [[StateDeclaration.resolve]]
	 */
	var eagerResolvePath = function (trans) {
	    return new resolveContext_1.ResolveContext(trans.treeChanges().to).resolvePath('EAGER', trans).then(common_1.noop);
	};
	exports.registerEagerResolvePath = function (transitionService) {
	    return transitionService.onStart({}, eagerResolvePath, { priority: exports.RESOLVE_HOOK_PRIORITY });
	};
	/**
	 * A [[TransitionHookFn]] which resolves all LAZY Resolvables for the state (and all its ancestors) in the To Path
	 *
	 * Registered using `transitionService.onEnter({ entering: () => true }, lazyResolveState, { priority: 1000 });`
	 *
	 * When a State is being entered, this hook resolves all the Resolvables for this state, which the transition then waits for.
	 *
	 * See [[StateDeclaration.resolve]]
	 */
	var lazyResolveState = function (trans, state) {
	    return new resolveContext_1.ResolveContext(trans.treeChanges().to).subContext(state.$$state()).resolvePath('LAZY', trans).then(common_1.noop);
	};
	exports.registerLazyResolveState = function (transitionService) {
	    return transitionService.onEnter({ entering: hof_1.val(true) }, lazyResolveState, { priority: exports.RESOLVE_HOOK_PRIORITY });
	};
	/**
	 * A [[TransitionHookFn]] which resolves any dynamically added (LAZY or EAGER) Resolvables.
	 *
	 * Registered using `transitionService.onFinish({}, eagerResolvePath, { priority: 1000 });`
	 *
	 * After all entering states have been entered, this hook resolves any remaining Resolvables.
	 * These are typically dynamic resolves which were added by some Transition Hook using [[Transition.addResolvable]].
	 *
	 * See [[StateDeclaration.resolve]]
	 */
	var resolveRemaining = function (trans) {
	    return new resolveContext_1.ResolveContext(trans.treeChanges().to).resolvePath('LAZY', trans).then(common_1.noop);
	};
	exports.registerResolveRemaining = function (transitionService) {
	    return transitionService.onFinish({}, resolveRemaining, { priority: exports.RESOLVE_HOOK_PRIORITY });
	};
	//# sourceMappingURL=resolve.js.map

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.registerUpdateGlobalState = void 0;
	var common_1 = __webpack_require__(1);
	/**
	 * A [[TransitionHookFn]] which updates global UI-Router state
	 *
	 * Registered using `transitionService.onBefore({}, updateGlobalState);`
	 *
	 * Before a [[Transition]] starts, updates the global value of "the current transition" ([[Globals.transition]]).
	 * After a successful [[Transition]], updates the global values of "the current state"
	 * ([[Globals.current]] and [[Globals.$current]]) and "the current param values" ([[Globals.params]]).
	 *
	 * See also the deprecated properties:
	 * [[StateService.transition]], [[StateService.current]], [[StateService.params]]
	 */
	var updateGlobalState = function (trans) {
	    var globals = trans.router.globals;
	    var transitionSuccessful = function () {
	        globals.successfulTransitions.enqueue(trans);
	        globals.$current = trans.$to();
	        globals.current = globals.$current.self;
	        common_1.copy(trans.params(), globals.params);
	    };
	    var clearCurrentTransition = function () {
	        // Do not clear globals.transition if a different transition has started in the meantime
	        if (globals.transition === trans)
	            globals.transition = null;
	    };
	    trans.onSuccess({}, transitionSuccessful, { priority: 10000 });
	    trans.promise.then(clearCurrentTransition, clearCurrentTransition);
	};
	exports.registerUpdateGlobalState = function (transitionService) {
	    return transitionService.onCreate({}, updateGlobalState);
	};
	//# sourceMappingURL=updateGlobals.js.map

/***/ }),
/* 103 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.registerUpdateUrl = void 0;
	/**
	 * A [[TransitionHookFn]] which updates the URL after a successful transition
	 *
	 * Registered using `transitionService.onSuccess({}, updateUrl);`
	 */
	var updateUrl = function (transition) {
	    var options = transition.options();
	    var $state = transition.router.stateService;
	    var $urlRouter = transition.router.urlRouter;
	    // Dont update the url in these situations:
	    // The transition was triggered by a URL sync (options.source === 'url')
	    // The user doesn't want the url to update (options.location === false)
	    // The destination state, and all parents have no navigable url
	    if (options.source !== 'url' && options.location && $state.$current.navigable) {
	        var urlOptions = { replace: options.location === 'replace' };
	        $urlRouter.push($state.$current.navigable.url, $state.params, urlOptions);
	    }
	    $urlRouter.update(true);
	};
	exports.registerUpdateUrl = function (transitionService) {
	    return transitionService.onSuccess({}, updateUrl, { priority: 9999 });
	};
	//# sourceMappingURL=url.js.map

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.registerActivateViews = exports.registerLoadEnteringViews = void 0;
	var common_1 = __webpack_require__(1);
	var coreservices_1 = __webpack_require__(5);
	/**
	 * A [[TransitionHookFn]] which waits for the views to load
	 *
	 * Registered using `transitionService.onStart({}, loadEnteringViews);`
	 *
	 * Allows the views to do async work in [[ViewConfig.load]] before the transition continues.
	 * In angular 1, this includes loading the templates.
	 */
	var loadEnteringViews = function (transition) {
	    var $q = coreservices_1.services.$q;
	    var enteringViews = transition.views('entering');
	    if (!enteringViews.length)
	        return;
	    return $q.all(enteringViews.map(function (view) { return $q.when(view.load()); })).then(common_1.noop);
	};
	exports.registerLoadEnteringViews = function (transitionService) {
	    return transitionService.onFinish({}, loadEnteringViews);
	};
	/**
	 * A [[TransitionHookFn]] which activates the new views when a transition is successful.
	 *
	 * Registered using `transitionService.onSuccess({}, activateViews);`
	 *
	 * After a transition is complete, this hook deactivates the old views from the previous state,
	 * and activates the new views from the destination state.
	 *
	 * See [[ViewService]]
	 */
	var activateViews = function (transition) {
	    var enteringViews = transition.views('entering');
	    var exitingViews = transition.views('exiting');
	    if (!enteringViews.length && !exitingViews.length)
	        return;
	    var $view = transition.router.viewService;
	    exitingViews.forEach(function (vc) { return $view.deactivateViewConfig(vc); });
	    enteringViews.forEach(function (vc) { return $view.activateViewConfig(vc); });
	    $view.sync();
	};
	exports.registerActivateViews = function (transitionService) {
	    return transitionService.onSuccess({}, activateViews);
	};
	//# sourceMappingURL=views.js.map

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (this && this.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(__webpack_require__(4), exports);
	__exportStar(__webpack_require__(34), exports);
	__exportStar(__webpack_require__(109), exports);
	__exportStar(__webpack_require__(52), exports);
	__exportStar(__webpack_require__(37), exports);
	__exportStar(__webpack_require__(111), exports);
	__exportStar(__webpack_require__(112), exports);
	__exportStar(__webpack_require__(118), exports);
	__exportStar(__webpack_require__(49), exports);
	__exportStar(__webpack_require__(54), exports);
	__exportStar(__webpack_require__(114), exports);
	__exportStar(__webpack_require__(106), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 106 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.UIRouterPluginBase = void 0;
	var UIRouterPluginBase = /** @class */ (function () {
	    function UIRouterPluginBase() {
	    }
	    UIRouterPluginBase.prototype.dispose = function (router) { };
	    return UIRouterPluginBase;
	}());
	exports.UIRouterPluginBase = UIRouterPluginBase;
	//# sourceMappingURL=interface.js.map

/***/ }),
/* 107 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	//# sourceMappingURL=interface.js.map

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ParamTypes = void 0;
	var common_1 = __webpack_require__(1);
	var predicates_1 = __webpack_require__(2);
	var hof_1 = __webpack_require__(3);
	var coreservices_1 = __webpack_require__(5);
	var paramType_1 = __webpack_require__(35);
	/**
	 * A registry for parameter types.
	 *
	 * This registry manages the built-in (and custom) parameter types.
	 *
	 * The built-in parameter types are:
	 *
	 * - [[string]]
	 * - [[path]]
	 * - [[query]]
	 * - [[hash]]
	 * - [[int]]
	 * - [[bool]]
	 * - [[date]]
	 * - [[json]]
	 * - [[any]]
	 *
	 * To register custom parameter types, use [[UrlConfig.type]], i.e.,
	 *
	 * ```js
	 * router.urlService.config.type(customType)
	 * ```
	 */
	var ParamTypes = /** @class */ (function () {
	    function ParamTypes() {
	        this.enqueue = true;
	        this.typeQueue = [];
	        this.defaultTypes = common_1.pick(ParamTypes.prototype, [
	            'hash',
	            'string',
	            'query',
	            'path',
	            'int',
	            'bool',
	            'date',
	            'json',
	            'any',
	        ]);
	        // Register default types. Store them in the prototype of this.types.
	        var makeType = function (definition, name) { return new paramType_1.ParamType(common_1.extend({ name: name }, definition)); };
	        this.types = common_1.inherit(common_1.map(this.defaultTypes, makeType), {});
	    }
	    ParamTypes.prototype.dispose = function () {
	        this.types = {};
	    };
	    /**
	     * Registers a parameter type
	     *
	     * End users should call [[UrlMatcherFactory.type]], which delegates to this method.
	     */
	    ParamTypes.prototype.type = function (name, definition, definitionFn) {
	        if (!predicates_1.isDefined(definition))
	            return this.types[name];
	        if (this.types.hasOwnProperty(name))
	            throw new Error("A type named '" + name + "' has already been defined.");
	        this.types[name] = new paramType_1.ParamType(common_1.extend({ name: name }, definition));
	        if (definitionFn) {
	            this.typeQueue.push({ name: name, def: definitionFn });
	            if (!this.enqueue)
	                this._flushTypeQueue();
	        }
	        return this;
	    };
	    ParamTypes.prototype._flushTypeQueue = function () {
	        while (this.typeQueue.length) {
	            var type = this.typeQueue.shift();
	            if (type.pattern)
	                throw new Error("You cannot override a type's .pattern at runtime.");
	            common_1.extend(this.types[type.name], coreservices_1.services.$injector.invoke(type.def));
	        }
	    };
	    return ParamTypes;
	}());
	exports.ParamTypes = ParamTypes;
	function initDefaultTypes() {
	    var makeDefaultType = function (def) {
	        var valToString = function (val) { return (val != null ? val.toString() : val); };
	        var defaultTypeBase = {
	            encode: valToString,
	            decode: valToString,
	            is: hof_1.is(String),
	            pattern: /.*/,
	            // tslint:disable-next-line:triple-equals
	            equals: function (a, b) { return a == b; },
	        };
	        return common_1.extend({}, defaultTypeBase, def);
	    };
	    // Default Parameter Type Definitions
	    common_1.extend(ParamTypes.prototype, {
	        string: makeDefaultType({}),
	        path: makeDefaultType({
	            pattern: /[^/]*/,
	        }),
	        query: makeDefaultType({}),
	        hash: makeDefaultType({
	            inherit: false,
	        }),
	        int: makeDefaultType({
	            decode: function (val) { return parseInt(val, 10); },
	            is: function (val) {
	                return !predicates_1.isNullOrUndefined(val) && this.decode(val.toString()) === val;
	            },
	            pattern: /-?\d+/,
	        }),
	        bool: makeDefaultType({
	            encode: function (val) { return (val && 1) || 0; },
	            decode: function (val) { return parseInt(val, 10) !== 0; },
	            is: hof_1.is(Boolean),
	            pattern: /0|1/,
	        }),
	        date: makeDefaultType({
	            encode: function (val) {
	                return !this.is(val)
	                    ? undefined
	                    : [val.getFullYear(), ('0' + (val.getMonth() + 1)).slice(-2), ('0' + val.getDate()).slice(-2)].join('-');
	            },
	            decode: function (val) {
	                if (this.is(val))
	                    return val;
	                var match = this.capture.exec(val);
	                return match ? new Date(match[1], match[2] - 1, match[3]) : undefined;
	            },
	            is: function (val) { return val instanceof Date && !isNaN(val.valueOf()); },
	            equals: function (l, r) {
	                return ['getFullYear', 'getMonth', 'getDate'].reduce(function (acc, fn) { return acc && l[fn]() === r[fn](); }, true);
	            },
	            pattern: /[0-9]{4}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[1-2][0-9]|3[0-1])/,
	            capture: /([0-9]{4})-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])/,
	        }),
	        json: makeDefaultType({
	            encode: common_1.toJson,
	            decode: common_1.fromJson,
	            is: hof_1.is(Object),
	            equals: common_1.equals,
	            pattern: /[^/]*/,
	        }),
	        // does not encode/decode
	        any: makeDefaultType({
	            encode: common_1.identity,
	            decode: common_1.identity,
	            is: function () { return true; },
	            equals: common_1.equals,
	        }),
	    });
	}
	initDefaultTypes();
	//# sourceMappingURL=paramTypes.js.map

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (this && this.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(__webpack_require__(36), exports);
	__exportStar(__webpack_require__(20), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 110 */
107,
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (this && this.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * # Transition subsystem
	 *
	 * This module contains APIs related to a Transition.
	 *
	 * See:
	 * - [[TransitionService]]
	 * - [[Transition]]
	 * - [[HookFn]], [[TransitionHookFn]], [[TransitionStateHookFn]], [[HookMatchCriteria]], [[HookResult]]
	 *
	 * @packageDocumentation @preferred
	 */
	__exportStar(__webpack_require__(11), exports);
	__exportStar(__webpack_require__(60), exports);
	__exportStar(__webpack_require__(39), exports);
	__exportStar(__webpack_require__(12), exports);
	__exportStar(__webpack_require__(40), exports);
	__exportStar(__webpack_require__(16), exports);
	__exportStar(__webpack_require__(61), exports);
	__exportStar(__webpack_require__(41), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (this && this.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(__webpack_require__(113), exports);
	__exportStar(__webpack_require__(23), exports);
	__exportStar(__webpack_require__(63), exports);
	__exportStar(__webpack_require__(64), exports);
	__exportStar(__webpack_require__(42), exports);
	__exportStar(__webpack_require__(66), exports);
	var urlRules_1 = __webpack_require__(65);
	Object.defineProperty(exports, "UrlRules", { enumerable: true, get: function () { return urlRules_1.UrlRules; } });
	var urlConfig_1 = __webpack_require__(62);
	Object.defineProperty(exports, "UrlConfig", { enumerable: true, get: function () { return urlConfig_1.UrlConfig; } });
	//# sourceMappingURL=index.js.map

/***/ }),
/* 113 */
107,
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (this && this.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(__webpack_require__(115), exports);
	//# sourceMappingURL=vanilla.js.map

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (this && this.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Naive, pure JS implementation of core ui-router services
	 *
	 * @packageDocumentation
	 */
	__exportStar(__webpack_require__(116), exports);
	__exportStar(__webpack_require__(73), exports);
	__exportStar(__webpack_require__(69), exports);
	__exportStar(__webpack_require__(24), exports);
	__exportStar(__webpack_require__(68), exports);
	__exportStar(__webpack_require__(71), exports);
	__exportStar(__webpack_require__(72), exports);
	__exportStar(__webpack_require__(70), exports);
	__exportStar(__webpack_require__(67), exports);
	__exportStar(__webpack_require__(43), exports);
	__exportStar(__webpack_require__(117), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 116 */
107,
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.memoryLocationPlugin = exports.pushStateLocationPlugin = exports.hashLocationPlugin = exports.servicesPlugin = void 0;
	var browserLocationConfig_1 = __webpack_require__(67);
	var hashLocationService_1 = __webpack_require__(68);
	var utils_1 = __webpack_require__(43);
	var pushStateLocationService_1 = __webpack_require__(72);
	var memoryLocationService_1 = __webpack_require__(71);
	var memoryLocationConfig_1 = __webpack_require__(70);
	var injector_1 = __webpack_require__(69);
	var q_1 = __webpack_require__(73);
	var coreservices_1 = __webpack_require__(5);
	function servicesPlugin(router) {
	    coreservices_1.services.$injector = injector_1.$injector;
	    coreservices_1.services.$q = q_1.$q;
	    return { name: 'vanilla.services', $q: q_1.$q, $injector: injector_1.$injector, dispose: function () { return null; } };
	}
	exports.servicesPlugin = servicesPlugin;
	/** A `UIRouterPlugin` uses the browser hash to get/set the current location */
	exports.hashLocationPlugin = utils_1.locationPluginFactory('vanilla.hashBangLocation', false, hashLocationService_1.HashLocationService, browserLocationConfig_1.BrowserLocationConfig);
	/** A `UIRouterPlugin` that gets/sets the current location using the browser's `location` and `history` apis */
	exports.pushStateLocationPlugin = utils_1.locationPluginFactory('vanilla.pushStateLocation', true, pushStateLocationService_1.PushStateLocationService, browserLocationConfig_1.BrowserLocationConfig);
	/** A `UIRouterPlugin` that gets/sets the current location from an in-memory object */
	exports.memoryLocationPlugin = utils_1.locationPluginFactory('vanilla.memoryLocation', false, memoryLocationService_1.MemoryLocationService, memoryLocationConfig_1.MemoryLocationConfig);
	//# sourceMappingURL=plugins.js.map

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (this && this.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(__webpack_require__(119), exports);
	__exportStar(__webpack_require__(74), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 119 */
107,
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 angular-file-upload v2.6.1
	 https://github.com/nervgh/angular-file-upload
	*/
	
	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory();
		else if(typeof define === 'function' && define.amd)
			define([], factory);
		else if(typeof exports === 'object')
			exports["angular-file-upload"] = factory();
		else
			root["angular-file-upload"] = factory();
	})(this, function() {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	/******/
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
		
		var _config = __webpack_require__(1);
		
		var _config2 = _interopRequireDefault(_config);
		
		var _options = __webpack_require__(2);
		
		var _options2 = _interopRequireDefault(_options);
		
		var _FileUploader = __webpack_require__(3);
		
		var _FileUploader2 = _interopRequireDefault(_FileUploader);
		
		var _FileLikeObject = __webpack_require__(4);
		
		var _FileLikeObject2 = _interopRequireDefault(_FileLikeObject);
		
		var _FileItem = __webpack_require__(5);
		
		var _FileItem2 = _interopRequireDefault(_FileItem);
		
		var _FileDirective = __webpack_require__(6);
		
		var _FileDirective2 = _interopRequireDefault(_FileDirective);
		
		var _FileSelect = __webpack_require__(7);
		
		var _FileSelect2 = _interopRequireDefault(_FileSelect);
		
		var _Pipeline = __webpack_require__(8);
		
		var _Pipeline2 = _interopRequireDefault(_Pipeline);
		
		var _FileDrop = __webpack_require__(9);
		
		var _FileDrop2 = _interopRequireDefault(_FileDrop);
		
		var _FileOver = __webpack_require__(10);
		
		var _FileOver2 = _interopRequireDefault(_FileOver);
		
		var _FileSelect3 = __webpack_require__(11);
		
		var _FileSelect4 = _interopRequireDefault(_FileSelect3);
		
		var _FileDrop3 = __webpack_require__(12);
		
		var _FileDrop4 = _interopRequireDefault(_FileDrop3);
		
		var _FileOver3 = __webpack_require__(13);
		
		var _FileOver4 = _interopRequireDefault(_FileOver3);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		angular.module(_config2.default.name, []).value('fileUploaderOptions', _options2.default).factory('FileUploader', _FileUploader2.default).factory('FileLikeObject', _FileLikeObject2.default).factory('FileItem', _FileItem2.default).factory('FileDirective', _FileDirective2.default).factory('FileSelect', _FileSelect2.default).factory('FileDrop', _FileDrop2.default).factory('FileOver', _FileOver2.default).factory('Pipeline', _Pipeline2.default).directive('nvFileSelect', _FileSelect4.default).directive('nvFileDrop', _FileDrop4.default).directive('nvFileOver', _FileOver4.default).run(['FileUploader', 'FileLikeObject', 'FileItem', 'FileDirective', 'FileSelect', 'FileDrop', 'FileOver', 'Pipeline', function (FileUploader, FileLikeObject, FileItem, FileDirective, FileSelect, FileDrop, FileOver, Pipeline) {
		    // only for compatibility
		    FileUploader.FileLikeObject = FileLikeObject;
		    FileUploader.FileItem = FileItem;
		    FileUploader.FileDirective = FileDirective;
		    FileUploader.FileSelect = FileSelect;
		    FileUploader.FileDrop = FileDrop;
		    FileUploader.FileOver = FileOver;
		    FileUploader.Pipeline = Pipeline;
		}]);
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports) {
	
		module.exports = {"name":"angularFileUpload"}
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
		exports.default = {
		    url: '/',
		    alias: 'file',
		    headers: {},
		    queue: [],
		    progress: 0,
		    autoUpload: false,
		    removeAfterUpload: false,
		    method: 'POST',
		    filters: [],
		    formData: [],
		    queueLimit: Number.MAX_VALUE,
		    withCredentials: false,
		    disableMultipart: false
		};
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
		
		var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
		
		exports.default = __identity;
		
		var _config = __webpack_require__(1);
		
		var _config2 = _interopRequireDefault(_config);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
		
		var _angular = angular,
		    bind = _angular.bind,
		    copy = _angular.copy,
		    extend = _angular.extend,
		    forEach = _angular.forEach,
		    isObject = _angular.isObject,
		    isNumber = _angular.isNumber,
		    isDefined = _angular.isDefined,
		    isArray = _angular.isArray,
		    isUndefined = _angular.isUndefined,
		    element = _angular.element;
		function __identity(fileUploaderOptions, $rootScope, $http, $window, $timeout, FileLikeObject, FileItem, Pipeline) {
		    var File = $window.File,
		        FormData = $window.FormData;
		
		    var FileUploader = function () {
		        /**********************
		         * PUBLIC
		         **********************/
		        /**
		         * Creates an instance of FileUploader
		         * @param {Object} [options]
		         * @constructor
		         */
		        function FileUploader(options) {
		            _classCallCheck(this, FileUploader);
		
		            var settings = copy(fileUploaderOptions);
		
		            extend(this, settings, options, {
		                isUploading: false,
		                _nextIndex: 0,
		                _directives: { select: [], drop: [], over: [] }
		            });
		
		            // add default filters
		            this.filters.unshift({ name: 'queueLimit', fn: this._queueLimitFilter });
		            this.filters.unshift({ name: 'folder', fn: this._folderFilter });
		        }
		        /**
		         * Adds items to the queue
		         * @param {File|HTMLInputElement|Object|FileList|Array<Object>} files
		         * @param {Object} [options]
		         * @param {Array<Function>|String} filters
		         */
		
		
		        FileUploader.prototype.addToQueue = function addToQueue(files, options, filters) {
		            var _this = this;
		
		            var incomingQueue = this.isArrayLikeObject(files) ? Array.prototype.slice.call(files) : [files];
		            var arrayOfFilters = this._getFilters(filters);
		            var count = this.queue.length;
		            var addedFileItems = [];
		
		            var next = function next() {
		                var something = incomingQueue.shift();
		
		                if (isUndefined(something)) {
		                    return done();
		                }
		
		                var fileLikeObject = _this.isFile(something) ? something : new FileLikeObject(something);
		                var pipes = _this._convertFiltersToPipes(arrayOfFilters);
		                var pipeline = new Pipeline(pipes);
		                var onThrown = function onThrown(err) {
		                    var originalFilter = err.pipe.originalFilter;
		
		                    var _err$args = _slicedToArray(err.args, 2),
		                        fileLikeObject = _err$args[0],
		                        options = _err$args[1];
		
		                    _this._onWhenAddingFileFailed(fileLikeObject, originalFilter, options);
		                    next();
		                };
		                var onSuccessful = function onSuccessful(fileLikeObject, options) {
		                    var fileItem = new FileItem(_this, fileLikeObject, options);
		                    addedFileItems.push(fileItem);
		                    _this.queue.push(fileItem);
		                    _this._onAfterAddingFile(fileItem);
		                    next();
		                };
		                pipeline.onThrown = onThrown;
		                pipeline.onSuccessful = onSuccessful;
		                pipeline.exec(fileLikeObject, options);
		            };
		
		            var done = function done() {
		                if (_this.queue.length !== count) {
		                    _this._onAfterAddingAll(addedFileItems);
		                    _this.progress = _this._getTotalProgress();
		                }
		
		                _this._render();
		                if (_this.autoUpload) _this.uploadAll();
		            };
		
		            next();
		        };
		        /**
		         * Remove items from the queue. Remove last: index = -1
		         * @param {FileItem|Number} value
		         */
		
		
		        FileUploader.prototype.removeFromQueue = function removeFromQueue(value) {
		            var index = this.getIndexOfItem(value);
		            var item = this.queue[index];
		            if (item.isUploading) item.cancel();
		            this.queue.splice(index, 1);
		            item._destroy();
		            this.progress = this._getTotalProgress();
		        };
		        /**
		         * Clears the queue
		         */
		
		
		        FileUploader.prototype.clearQueue = function clearQueue() {
		            while (this.queue.length) {
		                this.queue[0].remove();
		            }
		            this.progress = 0;
		        };
		        /**
		         * Uploads a item from the queue
		         * @param {FileItem|Number} value
		         */
		
		
		        FileUploader.prototype.uploadItem = function uploadItem(value) {
		            var index = this.getIndexOfItem(value);
		            var item = this.queue[index];
		            var transport = this.isHTML5 ? '_xhrTransport' : '_iframeTransport';
		
		            item._prepareToUploading();
		            if (this.isUploading) return;
		
		            this._onBeforeUploadItem(item);
		            if (item.isCancel) return;
		
		            item.isUploading = true;
		            this.isUploading = true;
		            this[transport](item);
		            this._render();
		        };
		        /**
		         * Cancels uploading of item from the queue
		         * @param {FileItem|Number} value
		         */
		
		
		        FileUploader.prototype.cancelItem = function cancelItem(value) {
		            var _this2 = this;
		
		            var index = this.getIndexOfItem(value);
		            var item = this.queue[index];
		            var prop = this.isHTML5 ? '_xhr' : '_form';
		            if (!item) return;
		            item.isCancel = true;
		            if (item.isUploading) {
		                // It will call this._onCancelItem() & this._onCompleteItem() asynchronously
		                item[prop].abort();
		            } else {
		                var dummy = [undefined, 0, {}];
		                var onNextTick = function onNextTick() {
		                    _this2._onCancelItem.apply(_this2, [item].concat(dummy));
		                    _this2._onCompleteItem.apply(_this2, [item].concat(dummy));
		                };
		                $timeout(onNextTick); // Trigger callbacks asynchronously (setImmediate emulation)
		            }
		        };
		        /**
		         * Uploads all not uploaded items of queue
		         */
		
		
		        FileUploader.prototype.uploadAll = function uploadAll() {
		            var items = this.getNotUploadedItems().filter(function (item) {
		                return !item.isUploading;
		            });
		            if (!items.length) return;
		
		            forEach(items, function (item) {
		                return item._prepareToUploading();
		            });
		            items[0].upload();
		        };
		        /**
		         * Cancels all uploads
		         */
		
		
		        FileUploader.prototype.cancelAll = function cancelAll() {
		            var items = this.getNotUploadedItems();
		            forEach(items, function (item) {
		                return item.cancel();
		            });
		        };
		        /**
		         * Returns "true" if value an instance of File
		         * @param {*} value
		         * @returns {Boolean}
		         * @private
		         */
		
		
		        FileUploader.prototype.isFile = function isFile(value) {
		            return this.constructor.isFile(value);
		        };
		        /**
		         * Returns "true" if value an instance of FileLikeObject
		         * @param {*} value
		         * @returns {Boolean}
		         * @private
		         */
		
		
		        FileUploader.prototype.isFileLikeObject = function isFileLikeObject(value) {
		            return this.constructor.isFileLikeObject(value);
		        };
		        /**
		         * Returns "true" if value is array like object
		         * @param {*} value
		         * @returns {Boolean}
		         */
		
		
		        FileUploader.prototype.isArrayLikeObject = function isArrayLikeObject(value) {
		            return this.constructor.isArrayLikeObject(value);
		        };
		        /**
		         * Returns a index of item from the queue
		         * @param {Item|Number} value
		         * @returns {Number}
		         */
		
		
		        FileUploader.prototype.getIndexOfItem = function getIndexOfItem(value) {
		            return isNumber(value) ? value : this.queue.indexOf(value);
		        };
		        /**
		         * Returns not uploaded items
		         * @returns {Array}
		         */
		
		
		        FileUploader.prototype.getNotUploadedItems = function getNotUploadedItems() {
		            return this.queue.filter(function (item) {
		                return !item.isUploaded;
		            });
		        };
		        /**
		         * Returns items ready for upload
		         * @returns {Array}
		         */
		
		
		        FileUploader.prototype.getReadyItems = function getReadyItems() {
		            return this.queue.filter(function (item) {
		                return item.isReady && !item.isUploading;
		            }).sort(function (item1, item2) {
		                return item1.index - item2.index;
		            });
		        };
		        /**
		         * Destroys instance of FileUploader
		         */
		
		
		        FileUploader.prototype.destroy = function destroy() {
		            var _this3 = this;
		
		            forEach(this._directives, function (key) {
		                forEach(_this3._directives[key], function (object) {
		                    object.destroy();
		                });
		            });
		        };
		        /**
		         * Callback
		         * @param {Array} fileItems
		         */
		
		
		        FileUploader.prototype.onAfterAddingAll = function onAfterAddingAll(fileItems) {};
		        /**
		         * Callback
		         * @param {FileItem} fileItem
		         */
		
		
		        FileUploader.prototype.onAfterAddingFile = function onAfterAddingFile(fileItem) {};
		        /**
		         * Callback
		         * @param {File|Object} item
		         * @param {Object} filter
		         * @param {Object} options
		         */
		
		
		        FileUploader.prototype.onWhenAddingFileFailed = function onWhenAddingFileFailed(item, filter, options) {};
		        /**
		         * Callback
		         * @param {FileItem} fileItem
		         */
		
		
		        FileUploader.prototype.onBeforeUploadItem = function onBeforeUploadItem(fileItem) {};
		        /**
		         * Callback
		         * @param {FileItem} fileItem
		         * @param {Number} progress
		         */
		
		
		        FileUploader.prototype.onProgressItem = function onProgressItem(fileItem, progress) {};
		        /**
		         * Callback
		         * @param {Number} progress
		         */
		
		
		        FileUploader.prototype.onProgressAll = function onProgressAll(progress) {};
		        /**
		         * Callback
		         * @param {FileItem} item
		         * @param {*} response
		         * @param {Number} status
		         * @param {Object} headers
		         */
		
		
		        FileUploader.prototype.onSuccessItem = function onSuccessItem(item, response, status, headers) {};
		        /**
		         * Callback
		         * @param {FileItem} item
		         * @param {*} response
		         * @param {Number} status
		         * @param {Object} headers
		         */
		
		
		        FileUploader.prototype.onErrorItem = function onErrorItem(item, response, status, headers) {};
		        /**
		         * Callback
		         * @param {FileItem} item
		         * @param {*} response
		         * @param {Number} status
		         * @param {Object} headers
		         */
		
		
		        FileUploader.prototype.onCancelItem = function onCancelItem(item, response, status, headers) {};
		        /**
		         * Callback
		         * @param {FileItem} item
		         * @param {*} response
		         * @param {Number} status
		         * @param {Object} headers
		         */
		
		
		        FileUploader.prototype.onCompleteItem = function onCompleteItem(item, response, status, headers) {};
		        /**
		         * Callback
		         * @param {FileItem} item
		         */
		
		
		        FileUploader.prototype.onTimeoutItem = function onTimeoutItem(item) {};
		        /**
		         * Callback
		         */
		
		
		        FileUploader.prototype.onCompleteAll = function onCompleteAll() {};
		        /**********************
		         * PRIVATE
		         **********************/
		        /**
		         * Returns the total progress
		         * @param {Number} [value]
		         * @returns {Number}
		         * @private
		         */
		
		
		        FileUploader.prototype._getTotalProgress = function _getTotalProgress(value) {
		            if (this.removeAfterUpload) return value || 0;
		
		            var notUploaded = this.getNotUploadedItems().length;
		            var uploaded = notUploaded ? this.queue.length - notUploaded : this.queue.length;
		            var ratio = 100 / this.queue.length;
		            var current = (value || 0) * ratio / 100;
		
		            return Math.round(uploaded * ratio + current);
		        };
		        /**
		         * Returns array of filters
		         * @param {Array<Function>|String} filters
		         * @returns {Array<Function>}
		         * @private
		         */
		
		
		        FileUploader.prototype._getFilters = function _getFilters(filters) {
		            if (!filters) return this.filters;
		            if (isArray(filters)) return filters;
		            var names = filters.match(/[^\s,]+/g);
		            return this.filters.filter(function (filter) {
		                return names.indexOf(filter.name) !== -1;
		            });
		        };
		        /**
		        * @param {Array<Function>} filters
		        * @returns {Array<Function>}
		        * @private
		        */
		
		
		        FileUploader.prototype._convertFiltersToPipes = function _convertFiltersToPipes(filters) {
		            var _this4 = this;
		
		            return filters.map(function (filter) {
		                var fn = bind(_this4, filter.fn);
		                fn.isAsync = filter.fn.length === 3;
		                fn.originalFilter = filter;
		                return fn;
		            });
		        };
		        /**
		         * Updates html
		         * @private
		         */
		
		
		        FileUploader.prototype._render = function _render() {
		            if (!$rootScope.$$phase) $rootScope.$apply();
		        };
		        /**
		         * Returns "true" if item is a file (not folder)
		         * @param {File|FileLikeObject} item
		         * @returns {Boolean}
		         * @private
		         */
		
		
		        FileUploader.prototype._folderFilter = function _folderFilter(item) {
		            return !!(item.size || item.type);
		        };
		        /**
		         * Returns "true" if the limit has not been reached
		         * @returns {Boolean}
		         * @private
		         */
		
		
		        FileUploader.prototype._queueLimitFilter = function _queueLimitFilter() {
		            return this.queue.length < this.queueLimit;
		        };
		        /**
		         * Checks whether upload successful
		         * @param {Number} status
		         * @returns {Boolean}
		         * @private
		         */
		
		
		        FileUploader.prototype._isSuccessCode = function _isSuccessCode(status) {
		            return status >= 200 && status < 300 || status === 304;
		        };
		        /**
		         * Transforms the server response
		         * @param {*} response
		         * @param {Object} headers
		         * @returns {*}
		         * @private
		         */
		
		
		        FileUploader.prototype._transformResponse = function _transformResponse(response, headers) {
		            var headersGetter = this._headersGetter(headers);
		            forEach($http.defaults.transformResponse, function (transformFn) {
		                response = transformFn(response, headersGetter);
		            });
		            return response;
		        };
		        /**
		         * Parsed response headers
		         * @param headers
		         * @returns {Object}
		         * @see https://github.com/angular/angular.js/blob/master/src/ng/http.js
		         * @private
		         */
		
		
		        FileUploader.prototype._parseHeaders = function _parseHeaders(headers) {
		            var parsed = {},
		                key,
		                val,
		                i;
		
		            if (!headers) return parsed;
		
		            forEach(headers.split('\n'), function (line) {
		                i = line.indexOf(':');
		                key = line.slice(0, i).trim().toLowerCase();
		                val = line.slice(i + 1).trim();
		
		                if (key) {
		                    parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
		                }
		            });
		
		            return parsed;
		        };
		        /**
		         * Returns function that returns headers
		         * @param {Object} parsedHeaders
		         * @returns {Function}
		         * @private
		         */
		
		
		        FileUploader.prototype._headersGetter = function _headersGetter(parsedHeaders) {
		            return function (name) {
		                if (name) {
		                    return parsedHeaders[name.toLowerCase()] || null;
		                }
		                return parsedHeaders;
		            };
		        };
		        /**
		         * The XMLHttpRequest transport
		         * @param {FileItem} item
		         * @private
		         */
		
		
		        FileUploader.prototype._xhrTransport = function _xhrTransport(item) {
		            var _this5 = this;
		
		            var xhr = item._xhr = new XMLHttpRequest();
		            var sendable;
		
		            if (!item.disableMultipart) {
		                sendable = new FormData();
		                forEach(item.formData, function (obj) {
		                    forEach(obj, function (value, key) {
		                        sendable.append(key, value);
		                    });
		                });
		
		                sendable.append(item.alias, item._file, item.file.name);
		            } else {
		                sendable = item._file;
		            }
		
		            if (typeof item._file.size != 'number') {
		                throw new TypeError('The file specified is no longer valid');
		            }
		
		            xhr.upload.onprogress = function (event) {
		                var progress = Math.round(event.lengthComputable ? event.loaded * 100 / event.total : 0);
		                _this5._onProgressItem(item, progress);
		            };
		
		            xhr.onload = function () {
		                var headers = _this5._parseHeaders(xhr.getAllResponseHeaders());
		                var response = _this5._transformResponse(xhr.response, headers);
		                var gist = _this5._isSuccessCode(xhr.status) ? 'Success' : 'Error';
		                var method = '_on' + gist + 'Item';
		                _this5[method](item, response, xhr.status, headers);
		                _this5._onCompleteItem(item, response, xhr.status, headers);
		            };
		
		            xhr.onerror = function () {
		                var headers = _this5._parseHeaders(xhr.getAllResponseHeaders());
		                var response = _this5._transformResponse(xhr.response, headers);
		                _this5._onErrorItem(item, response, xhr.status, headers);
		                _this5._onCompleteItem(item, response, xhr.status, headers);
		            };
		
		            xhr.onabort = function () {
		                var headers = _this5._parseHeaders(xhr.getAllResponseHeaders());
		                var response = _this5._transformResponse(xhr.response, headers);
		                _this5._onCancelItem(item, response, xhr.status, headers);
		                _this5._onCompleteItem(item, response, xhr.status, headers);
		            };
		
		            xhr.ontimeout = function (e) {
		                var headers = _this5._parseHeaders(xhr.getAllResponseHeaders());
		                var response = "Request Timeout.";
		                _this5._onTimeoutItem(item);
		                _this5._onCompleteItem(item, response, 408, headers);
		            };
		
		            xhr.open(item.method, item.url, true);
		
		            xhr.timeout = item.timeout || 0;
		            xhr.withCredentials = item.withCredentials;
		
		            forEach(item.headers, function (value, name) {
		                xhr.setRequestHeader(name, value);
		            });
		
		            xhr.send(sendable);
		        };
		        /**
		         * The IFrame transport
		         * @param {FileItem} item
		         * @private
		         */
		
		
		        FileUploader.prototype._iframeTransport = function _iframeTransport(item) {
		            var _this6 = this;
		
		            var form = element('<form style="display: none;" />');
		            var iframe = element('<iframe name="iframeTransport' + Date.now() + '">');
		            var input = item._input;
		
		            var timeout = 0;
		            var timer = null;
		            var isTimedOut = false;
		
		            if (item._form) item._form.replaceWith(input); // remove old form
		            item._form = form; // save link to new form
		
		            input.prop('name', item.alias);
		
		            forEach(item.formData, function (obj) {
		                forEach(obj, function (value, key) {
		                    var element_ = element('<input type="hidden" name="' + key + '" />');
		                    element_.val(value);
		                    form.append(element_);
		                });
		            });
		
		            form.prop({
		                action: item.url,
		                method: 'POST',
		                target: iframe.prop('name'),
		                enctype: 'multipart/form-data',
		                encoding: 'multipart/form-data' // old IE
		            });
		
		            iframe.bind('load', function () {
		                var html = '';
		                var status = 200;
		
		                try {
		                    // Fix for legacy IE browsers that loads internal error page
		                    // when failed WS response received. In consequence iframe
		                    // content access denied error is thrown becouse trying to
		                    // access cross domain page. When such thing occurs notifying
		                    // with empty response object. See more info at:
		                    // http://stackoverflow.com/questions/151362/access-is-denied-error-on-accessing-iframe-document-object
		                    // Note that if non standard 4xx or 5xx error code returned
		                    // from WS then response content can be accessed without error
		                    // but 'XHR' status becomes 200. In order to avoid confusion
		                    // returning response via same 'success' event handler.
		
		                    // fixed angular.contents() for iframes
		                    html = iframe[0].contentDocument.body.innerHTML;
		                } catch (e) {
		                    // in case we run into the access-is-denied error or we have another error on the server side
		                    // (intentional 500,40... errors), we at least say 'something went wrong' -> 500
		                    status = 500;
		                }
		
		                if (timer) {
		                    clearTimeout(timer);
		                }
		                timer = null;
		
		                if (isTimedOut) {
		                    return false; //throw 'Request Timeout'
		                }
		
		                var xhr = { response: html, status: status, dummy: true };
		                var headers = {};
		                var response = _this6._transformResponse(xhr.response, headers);
		
		                _this6._onSuccessItem(item, response, xhr.status, headers);
		                _this6._onCompleteItem(item, response, xhr.status, headers);
		            });
		
		            form.abort = function () {
		                var xhr = { status: 0, dummy: true };
		                var headers = {};
		                var response;
		
		                iframe.unbind('load').prop('src', 'javascript:false;');
		                form.replaceWith(input);
		
		                _this6._onCancelItem(item, response, xhr.status, headers);
		                _this6._onCompleteItem(item, response, xhr.status, headers);
		            };
		
		            input.after(form);
		            form.append(input).append(iframe);
		
		            timeout = item.timeout || 0;
		            timer = null;
		
		            if (timeout) {
		                timer = setTimeout(function () {
		                    isTimedOut = true;
		
		                    item.isCancel = true;
		                    if (item.isUploading) {
		                        iframe.unbind('load').prop('src', 'javascript:false;');
		                        form.replaceWith(input);
		                    }
		
		                    var headers = {};
		                    var response = "Request Timeout.";
		                    _this6._onTimeoutItem(item);
		                    _this6._onCompleteItem(item, response, 408, headers);
		                }, timeout);
		            }
		
		            form[0].submit();
		        };
		        /**
		         * Inner callback
		         * @param {File|Object} item
		         * @param {Object} filter
		         * @param {Object} options
		         * @private
		         */
		
		
		        FileUploader.prototype._onWhenAddingFileFailed = function _onWhenAddingFileFailed(item, filter, options) {
		            this.onWhenAddingFileFailed(item, filter, options);
		        };
		        /**
		         * Inner callback
		         * @param {FileItem} item
		         */
		
		
		        FileUploader.prototype._onAfterAddingFile = function _onAfterAddingFile(item) {
		            this.onAfterAddingFile(item);
		        };
		        /**
		         * Inner callback
		         * @param {Array<FileItem>} items
		         */
		
		
		        FileUploader.prototype._onAfterAddingAll = function _onAfterAddingAll(items) {
		            this.onAfterAddingAll(items);
		        };
		        /**
		         *  Inner callback
		         * @param {FileItem} item
		         * @private
		         */
		
		
		        FileUploader.prototype._onBeforeUploadItem = function _onBeforeUploadItem(item) {
		            item._onBeforeUpload();
		            this.onBeforeUploadItem(item);
		        };
		        /**
		         * Inner callback
		         * @param {FileItem} item
		         * @param {Number} progress
		         * @private
		         */
		
		
		        FileUploader.prototype._onProgressItem = function _onProgressItem(item, progress) {
		            var total = this._getTotalProgress(progress);
		            this.progress = total;
		            item._onProgress(progress);
		            this.onProgressItem(item, progress);
		            this.onProgressAll(total);
		            this._render();
		        };
		        /**
		         * Inner callback
		         * @param {FileItem} item
		         * @param {*} response
		         * @param {Number} status
		         * @param {Object} headers
		         * @private
		         */
		
		
		        FileUploader.prototype._onSuccessItem = function _onSuccessItem(item, response, status, headers) {
		            item._onSuccess(response, status, headers);
		            this.onSuccessItem(item, response, status, headers);
		        };
		        /**
		         * Inner callback
		         * @param {FileItem} item
		         * @param {*} response
		         * @param {Number} status
		         * @param {Object} headers
		         * @private
		         */
		
		
		        FileUploader.prototype._onErrorItem = function _onErrorItem(item, response, status, headers) {
		            item._onError(response, status, headers);
		            this.onErrorItem(item, response, status, headers);
		        };
		        /**
		         * Inner callback
		         * @param {FileItem} item
		         * @param {*} response
		         * @param {Number} status
		         * @param {Object} headers
		         * @private
		         */
		
		
		        FileUploader.prototype._onCancelItem = function _onCancelItem(item, response, status, headers) {
		            item._onCancel(response, status, headers);
		            this.onCancelItem(item, response, status, headers);
		        };
		        /**
		         * Inner callback
		         * @param {FileItem} item
		         * @param {*} response
		         * @param {Number} status
		         * @param {Object} headers
		         * @private
		         */
		
		
		        FileUploader.prototype._onCompleteItem = function _onCompleteItem(item, response, status, headers) {
		            item._onComplete(response, status, headers);
		            this.onCompleteItem(item, response, status, headers);
		
		            var nextItem = this.getReadyItems()[0];
		            this.isUploading = false;
		
		            if (isDefined(nextItem)) {
		                nextItem.upload();
		                return;
		            }
		
		            this.onCompleteAll();
		            this.progress = this._getTotalProgress();
		            this._render();
		        };
		        /**
		         * Inner callback
		         * @param {FileItem} item
		         * @private
		         */
		
		
		        FileUploader.prototype._onTimeoutItem = function _onTimeoutItem(item) {
		            item._onTimeout();
		            this.onTimeoutItem(item);
		        };
		        /**********************
		         * STATIC
		         **********************/
		        /**
		         * Returns "true" if value an instance of File
		         * @param {*} value
		         * @returns {Boolean}
		         * @private
		         */
		
		
		        FileUploader.isFile = function isFile(value) {
		            return File && value instanceof File;
		        };
		        /**
		         * Returns "true" if value an instance of FileLikeObject
		         * @param {*} value
		         * @returns {Boolean}
		         * @private
		         */
		
		
		        FileUploader.isFileLikeObject = function isFileLikeObject(value) {
		            return value instanceof FileLikeObject;
		        };
		        /**
		         * Returns "true" if value is array like object
		         * @param {*} value
		         * @returns {Boolean}
		         */
		
		
		        FileUploader.isArrayLikeObject = function isArrayLikeObject(value) {
		            return isObject(value) && 'length' in value;
		        };
		        /**
		         * Inherits a target (Class_1) by a source (Class_2)
		         * @param {Function} target
		         * @param {Function} source
		         */
		
		
		        FileUploader.inherit = function inherit(target, source) {
		            target.prototype = Object.create(source.prototype);
		            target.prototype.constructor = target;
		            target.super_ = source;
		        };
		
		        return FileUploader;
		    }();
		
		    /**********************
		     * PUBLIC
		     **********************/
		    /**
		     * Checks a support the html5 uploader
		     * @returns {Boolean}
		     * @readonly
		     */
		
		
		    FileUploader.prototype.isHTML5 = !!(File && FormData);
		    /**********************
		     * STATIC
		     **********************/
		    /**
		     * @borrows FileUploader.prototype.isHTML5
		     */
		    FileUploader.isHTML5 = FileUploader.prototype.isHTML5;
		
		    return FileUploader;
		}
		
		__identity.$inject = ['fileUploaderOptions', '$rootScope', '$http', '$window', '$timeout', 'FileLikeObject', 'FileItem', 'Pipeline'];
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
		exports.default = __identity;
		
		var _config = __webpack_require__(1);
		
		var _config2 = _interopRequireDefault(_config);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
		
		var _angular = angular,
		    copy = _angular.copy,
		    isElement = _angular.isElement,
		    isString = _angular.isString;
		function __identity() {
		
		    return function () {
		        /**
		         * Creates an instance of FileLikeObject
		         * @param {File|HTMLInputElement|Object} fileOrInput
		         * @constructor
		         */
		        function FileLikeObject(fileOrInput) {
		            _classCallCheck(this, FileLikeObject);
		
		            var isInput = isElement(fileOrInput);
		            var fakePathOrObject = isInput ? fileOrInput.value : fileOrInput;
		            var postfix = isString(fakePathOrObject) ? 'FakePath' : 'Object';
		            var method = '_createFrom' + postfix;
		            this[method](fakePathOrObject, fileOrInput);
		        }
		        /**
		         * Creates file like object from fake path string
		         * @param {String} path
		         * @private
		         */
		
		
		        FileLikeObject.prototype._createFromFakePath = function _createFromFakePath(path, input) {
		            this.lastModifiedDate = null;
		            this.size = null;
		            this.type = 'like/' + path.slice(path.lastIndexOf('.') + 1).toLowerCase();
		            this.name = path.slice(path.lastIndexOf('/') + path.lastIndexOf('\\') + 2);
		            this.input = input;
		        };
		        /**
		         * Creates file like object from object
		         * @param {File|FileLikeObject} object
		         * @private
		         */
		
		
		        FileLikeObject.prototype._createFromObject = function _createFromObject(object) {
		            this.lastModifiedDate = copy(object.lastModifiedDate);
		            this.size = object.size;
		            this.type = object.type;
		            this.name = object.name;
		            this.input = object.input;
		        };
		
		        return FileLikeObject;
		    }();
		}
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = __identity;
		
		var _config = __webpack_require__(1);
		
		var _config2 = _interopRequireDefault(_config);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
		
		var _angular = angular,
		    copy = _angular.copy,
		    extend = _angular.extend,
		    element = _angular.element,
		    isElement = _angular.isElement;
		function __identity($compile, FileLikeObject) {
		
		  return function () {
		    /**
		     * Creates an instance of FileItem
		     * @param {FileUploader} uploader
		     * @param {File|HTMLInputElement|Object} some
		     * @param {Object} options
		     * @constructor
		     */
		    function FileItem(uploader, some, options) {
		      _classCallCheck(this, FileItem);
		
		      var isInput = !!some.input;
		      var input = isInput ? element(some.input) : null;
		      var file = !isInput ? some : null;
		
		      extend(this, {
		        url: uploader.url,
		        alias: uploader.alias,
		        headers: copy(uploader.headers),
		        formData: copy(uploader.formData),
		        removeAfterUpload: uploader.removeAfterUpload,
		        withCredentials: uploader.withCredentials,
		        disableMultipart: uploader.disableMultipart,
		        method: uploader.method,
		        timeout: uploader.timeout
		      }, options, {
		        uploader: uploader,
		        file: new FileLikeObject(some),
		        isReady: false,
		        isUploading: false,
		        isUploaded: false,
		        isSuccess: false,
		        isCancel: false,
		        isError: false,
		        progress: 0,
		        index: null,
		        _file: file,
		        _input: input
		      });
		
		      if (input) this._replaceNode(input);
		    }
		    /**********************
		     * PUBLIC
		     **********************/
		    /**
		     * Uploads a FileItem
		     */
		
		
		    FileItem.prototype.upload = function upload() {
		      try {
		        this.uploader.uploadItem(this);
		      } catch (e) {
		        var message = e.name + ':' + e.message;
		        this.uploader._onCompleteItem(this, message, e.code, []);
		        this.uploader._onErrorItem(this, message, e.code, []);
		      }
		    };
		    /**
		     * Cancels uploading of FileItem
		     */
		
		
		    FileItem.prototype.cancel = function cancel() {
		      this.uploader.cancelItem(this);
		    };
		    /**
		     * Removes a FileItem
		     */
		
		
		    FileItem.prototype.remove = function remove() {
		      this.uploader.removeFromQueue(this);
		    };
		    /**
		     * Callback
		     * @private
		     */
		
		
		    FileItem.prototype.onBeforeUpload = function onBeforeUpload() {};
		    /**
		     * Callback
		     * @param {Number} progress
		     * @private
		     */
		
		
		    FileItem.prototype.onProgress = function onProgress(progress) {};
		    /**
		     * Callback
		     * @param {*} response
		     * @param {Number} status
		     * @param {Object} headers
		     */
		
		
		    FileItem.prototype.onSuccess = function onSuccess(response, status, headers) {};
		    /**
		     * Callback
		     * @param {*} response
		     * @param {Number} status
		     * @param {Object} headers
		     */
		
		
		    FileItem.prototype.onError = function onError(response, status, headers) {};
		    /**
		     * Callback
		     * @param {*} response
		     * @param {Number} status
		     * @param {Object} headers
		     */
		
		
		    FileItem.prototype.onCancel = function onCancel(response, status, headers) {};
		    /**
		     * Callback
		     * @param {*} response
		     * @param {Number} status
		     * @param {Object} headers
		     */
		
		
		    FileItem.prototype.onComplete = function onComplete(response, status, headers) {};
		    /**
		     * Callback         
		     */
		
		
		    FileItem.prototype.onTimeout = function onTimeout() {};
		    /**********************
		     * PRIVATE
		     **********************/
		    /**
		     * Inner callback
		     */
		
		
		    FileItem.prototype._onBeforeUpload = function _onBeforeUpload() {
		      this.isReady = true;
		      this.isUploading = false;
		      this.isUploaded = false;
		      this.isSuccess = false;
		      this.isCancel = false;
		      this.isError = false;
		      this.progress = 0;
		      this.onBeforeUpload();
		    };
		    /**
		     * Inner callback
		     * @param {Number} progress
		     * @private
		     */
		
		
		    FileItem.prototype._onProgress = function _onProgress(progress) {
		      this.progress = progress;
		      this.onProgress(progress);
		    };
		    /**
		     * Inner callback
		     * @param {*} response
		     * @param {Number} status
		     * @param {Object} headers
		     * @private
		     */
		
		
		    FileItem.prototype._onSuccess = function _onSuccess(response, status, headers) {
		      this.isReady = false;
		      this.isUploading = false;
		      this.isUploaded = true;
		      this.isSuccess = true;
		      this.isCancel = false;
		      this.isError = false;
		      this.progress = 100;
		      this.index = null;
		      this.onSuccess(response, status, headers);
		    };
		    /**
		     * Inner callback
		     * @param {*} response
		     * @param {Number} status
		     * @param {Object} headers
		     * @private
		     */
		
		
		    FileItem.prototype._onError = function _onError(response, status, headers) {
		      this.isReady = false;
		      this.isUploading = false;
		      this.isUploaded = true;
		      this.isSuccess = false;
		      this.isCancel = false;
		      this.isError = true;
		      this.progress = 0;
		      this.index = null;
		      this.onError(response, status, headers);
		    };
		    /**
		     * Inner callback
		     * @param {*} response
		     * @param {Number} status
		     * @param {Object} headers
		     * @private
		     */
		
		
		    FileItem.prototype._onCancel = function _onCancel(response, status, headers) {
		      this.isReady = false;
		      this.isUploading = false;
		      this.isUploaded = false;
		      this.isSuccess = false;
		      this.isCancel = true;
		      this.isError = false;
		      this.progress = 0;
		      this.index = null;
		      this.onCancel(response, status, headers);
		    };
		    /**
		     * Inner callback
		     * @param {*} response
		     * @param {Number} status
		     * @param {Object} headers
		     * @private
		     */
		
		
		    FileItem.prototype._onComplete = function _onComplete(response, status, headers) {
		      this.onComplete(response, status, headers);
		      if (this.removeAfterUpload) this.remove();
		    };
		    /**
		     * Inner callback         
		     * @private
		     */
		
		
		    FileItem.prototype._onTimeout = function _onTimeout() {
		      this.isReady = false;
		      this.isUploading = false;
		      this.isUploaded = false;
		      this.isSuccess = false;
		      this.isCancel = false;
		      this.isError = true;
		      this.progress = 0;
		      this.index = null;
		      this.onTimeout();
		    };
		    /**
		     * Destroys a FileItem
		     */
		
		
		    FileItem.prototype._destroy = function _destroy() {
		      if (this._input) this._input.remove();
		      if (this._form) this._form.remove();
		      delete this._form;
		      delete this._input;
		    };
		    /**
		     * Prepares to uploading
		     * @private
		     */
		
		
		    FileItem.prototype._prepareToUploading = function _prepareToUploading() {
		      this.index = this.index || ++this.uploader._nextIndex;
		      this.isReady = true;
		    };
		    /**
		     * Replaces input element on his clone
		     * @param {JQLite|jQuery} input
		     * @private
		     */
		
		
		    FileItem.prototype._replaceNode = function _replaceNode(input) {
		      var clone = $compile(input.clone())(input.scope());
		      clone.prop('value', null); // FF fix
		      input.css('display', 'none');
		      input.after(clone); // remove jquery dependency
		    };
		
		    return FileItem;
		  }();
		}
		
		__identity.$inject = ['$compile', 'FileLikeObject'];
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
		exports.default = __identity;
		
		var _config = __webpack_require__(1);
		
		var _config2 = _interopRequireDefault(_config);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
		
		var _angular = angular,
		    extend = _angular.extend;
		function __identity() {
		    var FileDirective = function () {
		        /**
		         * Creates instance of {FileDirective} object
		         * @param {Object} options
		         * @param {Object} options.uploader
		         * @param {HTMLElement} options.element
		         * @param {Object} options.events
		         * @param {String} options.prop
		         * @constructor
		         */
		        function FileDirective(options) {
		            _classCallCheck(this, FileDirective);
		
		            extend(this, options);
		            this.uploader._directives[this.prop].push(this);
		            this._saveLinks();
		            this.bind();
		        }
		        /**
		         * Binds events handles
		         */
		
		
		        FileDirective.prototype.bind = function bind() {
		            for (var key in this.events) {
		                var prop = this.events[key];
		                this.element.bind(key, this[prop]);
		            }
		        };
		        /**
		         * Unbinds events handles
		         */
		
		
		        FileDirective.prototype.unbind = function unbind() {
		            for (var key in this.events) {
		                this.element.unbind(key, this.events[key]);
		            }
		        };
		        /**
		         * Destroys directive
		         */
		
		
		        FileDirective.prototype.destroy = function destroy() {
		            var index = this.uploader._directives[this.prop].indexOf(this);
		            this.uploader._directives[this.prop].splice(index, 1);
		            this.unbind();
		            // this.element = null;
		        };
		        /**
		         * Saves links to functions
		         * @private
		         */
		
		
		        FileDirective.prototype._saveLinks = function _saveLinks() {
		            for (var key in this.events) {
		                var prop = this.events[key];
		                this[prop] = this[prop].bind(this);
		            }
		        };
		
		        return FileDirective;
		    }();
		
		    /**
		     * Map of events
		     * @type {Object}
		     */
		
		
		    FileDirective.prototype.events = {};
		
		    return FileDirective;
		}
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
		exports.default = __identity;
		
		var _config = __webpack_require__(1);
		
		var _config2 = _interopRequireDefault(_config);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
		
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
		
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
		
		var _angular = angular,
		    extend = _angular.extend;
		function __identity($compile, FileDirective) {
		
		    return function (_FileDirective) {
		        _inherits(FileSelect, _FileDirective);
		
		        /**
		         * Creates instance of {FileSelect} object
		         * @param {Object} options
		         * @constructor
		         */
		        function FileSelect(options) {
		            _classCallCheck(this, FileSelect);
		
		            var extendedOptions = extend(options, {
		                // Map of events
		                events: {
		                    $destroy: 'destroy',
		                    change: 'onChange'
		                },
		                // Name of property inside uploader._directive object
		                prop: 'select'
		            });
		
		            var _this = _possibleConstructorReturn(this, _FileDirective.call(this, extendedOptions));
		
		            if (!_this.uploader.isHTML5) {
		                _this.element.removeAttr('multiple');
		            }
		            _this.element.prop('value', null); // FF fix
		            return _this;
		        }
		        /**
		         * Returns options
		         * @return {Object|undefined}
		         */
		
		
		        FileSelect.prototype.getOptions = function getOptions() {};
		        /**
		         * Returns filters
		         * @return {Array<Function>|String|undefined}
		         */
		
		
		        FileSelect.prototype.getFilters = function getFilters() {};
		        /**
		         * If returns "true" then HTMLInputElement will be cleared
		         * @returns {Boolean}
		         */
		
		
		        FileSelect.prototype.isEmptyAfterSelection = function isEmptyAfterSelection() {
		            return !!this.element.attr('multiple');
		        };
		        /**
		         * Event handler
		         */
		
		
		        FileSelect.prototype.onChange = function onChange() {
		            var files = this.uploader.isHTML5 ? this.element[0].files : this.element[0];
		            var options = this.getOptions();
		            var filters = this.getFilters();
		
		            if (!this.uploader.isHTML5) this.destroy();
		            this.uploader.addToQueue(files, options, filters);
		            if (this.isEmptyAfterSelection()) {
		                this.element.prop('value', null);
		                this.element.replaceWith($compile(this.element.clone())(this.scope)); // IE fix
		            }
		        };
		
		        return FileSelect;
		    }(FileDirective);
		}
		
		__identity.$inject = ['$compile', 'FileDirective'];
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = __identity;
		
		function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
		
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
		
		var _angular = angular,
		    bind = _angular.bind,
		    isUndefined = _angular.isUndefined;
		function __identity($q) {
		
		  return function () {
		    /**
		     * @param {Array<Function>} pipes
		     */
		    function Pipeline() {
		      var pipes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
		
		      _classCallCheck(this, Pipeline);
		
		      this.pipes = pipes;
		    }
		
		    Pipeline.prototype.next = function next(args) {
		      var pipe = this.pipes.shift();
		      if (isUndefined(pipe)) {
		        this.onSuccessful.apply(this, _toConsumableArray(args));
		        return;
		      }
		      var err = new Error('The filter has not passed');
		      err.pipe = pipe;
		      err.args = args;
		      if (pipe.isAsync) {
		        var deferred = $q.defer();
		        var onFulfilled = bind(this, this.next, args);
		        var onRejected = bind(this, this.onThrown, err);
		        deferred.promise.then(onFulfilled, onRejected);
		        pipe.apply(undefined, _toConsumableArray(args).concat([deferred]));
		      } else {
		        var isDone = Boolean(pipe.apply(undefined, _toConsumableArray(args)));
		        if (isDone) {
		          this.next(args);
		        } else {
		          this.onThrown(err);
		        }
		      }
		    };
		
		    Pipeline.prototype.exec = function exec() {
		      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
		        args[_key] = arguments[_key];
		      }
		
		      this.next(args);
		    };
		
		    Pipeline.prototype.onThrown = function onThrown(err) {};
		
		    Pipeline.prototype.onSuccessful = function onSuccessful() {};
		
		    return Pipeline;
		  }();
		}
		
		__identity.$inject = ['$q'];
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
		exports.default = __identity;
		
		var _config = __webpack_require__(1);
		
		var _config2 = _interopRequireDefault(_config);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
		
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
		
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
		
		var _angular = angular,
		    extend = _angular.extend,
		    forEach = _angular.forEach;
		function __identity(FileDirective) {
		
		    return function (_FileDirective) {
		        _inherits(FileDrop, _FileDirective);
		
		        /**
		         * Creates instance of {FileDrop} object
		         * @param {Object} options
		         * @constructor
		         */
		        function FileDrop(options) {
		            _classCallCheck(this, FileDrop);
		
		            var extendedOptions = extend(options, {
		                // Map of events
		                events: {
		                    $destroy: 'destroy',
		                    drop: 'onDrop',
		                    dragover: 'onDragOver',
		                    dragleave: 'onDragLeave'
		                },
		                // Name of property inside uploader._directive object
		                prop: 'drop'
		            });
		
		            return _possibleConstructorReturn(this, _FileDirective.call(this, extendedOptions));
		        }
		        /**
		         * Returns options
		         * @return {Object|undefined}
		         */
		
		
		        FileDrop.prototype.getOptions = function getOptions() {};
		        /**
		         * Returns filters
		         * @return {Array<Function>|String|undefined}
		         */
		
		
		        FileDrop.prototype.getFilters = function getFilters() {};
		        /**
		         * Event handler
		         */
		
		
		        FileDrop.prototype.onDrop = function onDrop(event) {
		            var transfer = this._getTransfer(event);
		            if (!transfer) return;
		            var options = this.getOptions();
		            var filters = this.getFilters();
		            this._preventAndStop(event);
		            forEach(this.uploader._directives.over, this._removeOverClass, this);
		            this.uploader.addToQueue(transfer.files, options, filters);
		        };
		        /**
		         * Event handler
		         */
		
		
		        FileDrop.prototype.onDragOver = function onDragOver(event) {
		            var transfer = this._getTransfer(event);
		            if (!this._haveFiles(transfer.types)) return;
		            transfer.dropEffect = 'copy';
		            this._preventAndStop(event);
		            forEach(this.uploader._directives.over, this._addOverClass, this);
		        };
		        /**
		         * Event handler
		         */
		
		
		        FileDrop.prototype.onDragLeave = function onDragLeave(event) {
		            if (event.currentTarget === this.element[0]) return;
		            this._preventAndStop(event);
		            forEach(this.uploader._directives.over, this._removeOverClass, this);
		        };
		        /**
		         * Helper
		         */
		
		
		        FileDrop.prototype._getTransfer = function _getTransfer(event) {
		            return event.dataTransfer ? event.dataTransfer : event.originalEvent.dataTransfer; // jQuery fix;
		        };
		        /**
		         * Helper
		         */
		
		
		        FileDrop.prototype._preventAndStop = function _preventAndStop(event) {
		            event.preventDefault();
		            event.stopPropagation();
		        };
		        /**
		         * Returns "true" if types contains files
		         * @param {Object} types
		         */
		
		
		        FileDrop.prototype._haveFiles = function _haveFiles(types) {
		            if (!types) return false;
		            if (types.indexOf) {
		                return types.indexOf('Files') !== -1;
		            } else if (types.contains) {
		                return types.contains('Files');
		            } else {
		                return false;
		            }
		        };
		        /**
		         * Callback
		         */
		
		
		        FileDrop.prototype._addOverClass = function _addOverClass(item) {
		            item.addOverClass();
		        };
		        /**
		         * Callback
		         */
		
		
		        FileDrop.prototype._removeOverClass = function _removeOverClass(item) {
		            item.removeOverClass();
		        };
		
		        return FileDrop;
		    }(FileDirective);
		}
		
		__identity.$inject = ['FileDirective'];
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
		exports.default = __identity;
		
		var _config = __webpack_require__(1);
		
		var _config2 = _interopRequireDefault(_config);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
		
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
		
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
		
		var _angular = angular,
		    extend = _angular.extend;
		function __identity(FileDirective) {
		
		    return function (_FileDirective) {
		        _inherits(FileOver, _FileDirective);
		
		        /**
		         * Creates instance of {FileDrop} object
		         * @param {Object} options
		         * @constructor
		         */
		        function FileOver(options) {
		            _classCallCheck(this, FileOver);
		
		            var extendedOptions = extend(options, {
		                // Map of events
		                events: {
		                    $destroy: 'destroy'
		                },
		                // Name of property inside uploader._directive object
		                prop: 'over',
		                // Over class
		                overClass: 'nv-file-over'
		            });
		
		            return _possibleConstructorReturn(this, _FileDirective.call(this, extendedOptions));
		        }
		        /**
		         * Adds over class
		         */
		
		
		        FileOver.prototype.addOverClass = function addOverClass() {
		            this.element.addClass(this.getOverClass());
		        };
		        /**
		         * Removes over class
		         */
		
		
		        FileOver.prototype.removeOverClass = function removeOverClass() {
		            this.element.removeClass(this.getOverClass());
		        };
		        /**
		         * Returns over class
		         * @returns {String}
		         */
		
		
		        FileOver.prototype.getOverClass = function getOverClass() {
		            return this.overClass;
		        };
		
		        return FileOver;
		    }(FileDirective);
		}
		
		__identity.$inject = ['FileDirective'];
	
	/***/ }),
	/* 11 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
		exports.default = __identity;
		
		var _config = __webpack_require__(1);
		
		var _config2 = _interopRequireDefault(_config);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		function __identity($parse, FileUploader, FileSelect) {
		
		    return {
		        link: function link(scope, element, attributes) {
		            var uploader = scope.$eval(attributes.uploader);
		
		            if (!(uploader instanceof FileUploader)) {
		                throw new TypeError('"Uploader" must be an instance of FileUploader');
		            }
		
		            var object = new FileSelect({
		                uploader: uploader,
		                element: element,
		                scope: scope
		            });
		
		            object.getOptions = $parse(attributes.options).bind(object, scope);
		            object.getFilters = function () {
		                return attributes.filters;
		            };
		        }
		    };
		}
		
		__identity.$inject = ['$parse', 'FileUploader', 'FileSelect'];
	
	/***/ }),
	/* 12 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
		exports.default = __identity;
		
		var _config = __webpack_require__(1);
		
		var _config2 = _interopRequireDefault(_config);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		function __identity($parse, FileUploader, FileDrop) {
		
		    return {
		        link: function link(scope, element, attributes) {
		            var uploader = scope.$eval(attributes.uploader);
		
		            if (!(uploader instanceof FileUploader)) {
		                throw new TypeError('"Uploader" must be an instance of FileUploader');
		            }
		
		            if (!uploader.isHTML5) return;
		
		            var object = new FileDrop({
		                uploader: uploader,
		                element: element
		            });
		
		            object.getOptions = $parse(attributes.options).bind(object, scope);
		            object.getFilters = function () {
		                return attributes.filters;
		            };
		        }
		    };
		}
		
		__identity.$inject = ['$parse', 'FileUploader', 'FileDrop'];
	
	/***/ }),
	/* 13 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
		exports.default = __identity;
		
		var _config = __webpack_require__(1);
		
		var _config2 = _interopRequireDefault(_config);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		function __identity(FileUploader, FileOver) {
		
		    return {
		        link: function link(scope, element, attributes) {
		            var uploader = scope.$eval(attributes.uploader);
		
		            if (!(uploader instanceof FileUploader)) {
		                throw new TypeError('"Uploader" must be an instance of FileUploader');
		            }
		
		            var object = new FileOver({
		                uploader: uploader,
		                element: element
		            });
		
		            object.getOverClass = function () {
		                return attributes.overClass || object.overClass;
		            };
		        }
		    };
		}
		
		__identity.$inject = ['FileUploader', 'FileOver'];
	
	/***/ })
	/******/ ])
	});
	;
	//# sourceMappingURL=angular-file-upload.js.map

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	//! angular-formly-templates-bootstrap version 6.5.1 built with ♥ by Astrism <astrisms@gmail.com>, Kent C. Dodds <kent@doddsfamily.us> (ó ì_í)=óò=(ì_í ò)
	
	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(9), __webpack_require__(75), __webpack_require__(76));
		else if(typeof define === 'function' && define.amd)
			define(["angular", "angular-formly", "api-check"], factory);
		else if(typeof exports === 'object')
			exports["ngFormlyTemplatesBootstrap"] = factory(require("angular"), require("angular-formly"), require("api-check"));
		else
			root["ngFormlyTemplatesBootstrap"] = factory(root["angular"], root["ngFormly"], root["apiCheck"]);
	})(this, function(__WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_5__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		module.exports = __webpack_require__(1);
	
	/***/ },
	/* 1 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
		var ngModuleName = 'formlyBootstrap';
		var angular = __webpack_require__(2);
		var ngModule = angular.module(ngModuleName, [__webpack_require__(4)]);
		ngModule.constant('formlyBootstrapApiCheck', __webpack_require__(5)({
		  output: {
		    prefix: 'angular-formly-bootstrap'
		  }
		}));
		ngModule.constant('formlyBootstrapVersion', ("6.5.1"));
	
		__webpack_require__(6)(ngModule);
		__webpack_require__(9)(ngModule);
		__webpack_require__(19)(ngModule);
	
		exports['default'] = ngModuleName;
		module.exports = exports['default'];
	
	/***/ },
	/* 2 */
	/***/ function(module, exports, __webpack_require__) {
	
		// some versions of angular don't export the angular module properly,
		// so we get it from window in this case.
		'use strict';
	
		var angular = __webpack_require__(3);
		if (!angular.version) {
		  angular = window.angular;
		}
		module.exports = angular;
	
	/***/ },
	/* 3 */
	/***/ function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_3__;
	
	/***/ },
	/* 4 */
	/***/ function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_4__;
	
	/***/ },
	/* 5 */
	/***/ function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_5__;
	
	/***/ },
	/* 6 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		exports['default'] = function (ngModule) {
		  ngModule.config(addWrappers);
	
		  function addWrappers(formlyConfigProvider) {
		    formlyConfigProvider.setWrapper([{
		      name: 'bootstrapLabel',
		      template: __webpack_require__(7),
		      apiCheck: function apiCheck(check) {
		        return {
		          templateOptions: {
		            label: check.string.optional,
		            required: check.bool.optional,
		            labelSrOnly: check.bool.optional
		          }
		        };
		      }
		    }, { name: 'bootstrapHasError', template: __webpack_require__(8) }]);
		  }
		  addWrappers.$inject = ["formlyConfigProvider"];
		};
	
		module.exports = exports['default'];
	
	/***/ },
	/* 7 */
	/***/ function(module, exports) {
	
		module.exports = "<div>\n  <label for=\"{{id}}\" class=\"control-label {{to.labelSrOnly ? 'sr-only' : ''}}\" ng-if=\"to.label\">\n    {{to.label}}\n    {{to.required ? '*' : ''}}\n  </label>\n  <formly-transclude></formly-transclude>\n</div>\n"
	
	/***/ },
	/* 8 */
	/***/ function(module, exports) {
	
		module.exports = "<div class=\"form-group\" ng-class=\"{'has-error': showError}\">\n  <formly-transclude></formly-transclude>\n</div>\n"
	
	/***/ },
	/* 9 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		exports['default'] = function (ngModule) {
		  __webpack_require__(10)(ngModule);
		  __webpack_require__(12)(ngModule);
		  __webpack_require__(14)(ngModule);
		  __webpack_require__(15)(ngModule);
		  __webpack_require__(17)(ngModule);
		  __webpack_require__(18)(ngModule);
		};
	
		module.exports = exports['default'];
	
	/***/ },
	/* 10 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		exports['default'] = function (ngModule) {
		  ngModule.config(addCheckboxType);
	
		  function addCheckboxType(formlyConfigProvider) {
		    formlyConfigProvider.setType({
		      name: 'checkbox',
		      template: __webpack_require__(11),
		      wrapper: ['bootstrapHasError'],
		      apiCheck: function apiCheck(check) {
		        return {
		          templateOptions: {
		            label: check.string
		          }
		        };
		      }
		    });
		  }
		  addCheckboxType.$inject = ["formlyConfigProvider"];
		};
	
		module.exports = exports['default'];
	
	/***/ },
	/* 11 */
	/***/ function(module, exports) {
	
		module.exports = "<div class=\"checkbox\">\n\t<label>\n\t\t<input type=\"checkbox\"\n           class=\"formly-field-checkbox\"\n\t\t       ng-model=\"model[options.key]\">\n\t\t{{to.label}}\n\t\t{{to.required ? '*' : ''}}\n\t</label>\n</div>\n"
	
	/***/ },
	/* 12 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		exports['default'] = function (ngModule) {
		  ngModule.config(addCheckboxType);
	
		  function addCheckboxType(formlyConfigProvider) {
		    formlyConfigProvider.setType({
		      name: 'multiCheckbox',
		      template: __webpack_require__(13),
		      wrapper: ['bootstrapLabel', 'bootstrapHasError'],
		      apiCheck: function apiCheck(check) {
		        return {
		          templateOptions: {
		            options: check.arrayOf(check.object),
		            labelProp: check.string.optional,
		            valueProp: check.string.optional
		          }
		        };
		      },
		      defaultOptions: {
		        noFormControl: false,
		        ngModelAttrs: {
		          required: {
		            attribute: '',
		            bound: ''
		          }
		        }
		      },
		      controller: /* @ngInject */["$scope", function controller($scope) {
		        var to = $scope.to;
		        var opts = $scope.options;
		        $scope.multiCheckbox = {
		          checked: [],
		          change: setModel
		        };
	
		        // initialize the checkboxes check property
		        $scope.$watch('model', function modelWatcher(newModelValue) {
		          var modelValue, valueProp;
	
		          if (Object.keys(newModelValue).length) {
		            modelValue = newModelValue[opts.key];
	
		            $scope.$watch('to.options', function optionsWatcher(newOptionsValues) {
		              if (newOptionsValues && Array.isArray(newOptionsValues) && Array.isArray(modelValue)) {
		                valueProp = to.valueProp || 'value';
		                for (var index = 0; index < newOptionsValues.length; index++) {
		                  $scope.multiCheckbox.checked[index] = modelValue.indexOf(newOptionsValues[index][valueProp]) !== -1;
		                }
		              }
		            });
		          }
		        }, true);
	
		        function checkValidity(expressionValue) {
		          var valid;
	
		          if ($scope.to.required) {
		            valid = angular.isArray($scope.model[opts.key]) && $scope.model[opts.key].length > 0 && expressionValue;
	
		            $scope.fc.$setValidity('required', valid);
		          }
		        }
	
		        function setModel() {
		          $scope.model[opts.key] = [];
		          angular.forEach($scope.multiCheckbox.checked, function (checkbox, index) {
		            if (checkbox) {
		              $scope.model[opts.key].push(to.options[index][to.valueProp || 'value']);
		            }
		          });
	
		          // Must make sure we mark as touched because only the last checkbox due to a bug in angular.
		          $scope.fc.$setTouched();
		          checkValidity(true);
	
		          if ($scope.to.onChange) {
		            $scope.to.onChange();
		          }
		        }
	
		        if (opts.expressionProperties && opts.expressionProperties['templateOptions.required']) {
		          $scope.$watch(function () {
		            return $scope.to.required;
		          }, function (newValue) {
		            checkValidity(newValue);
		          });
		        }
	
		        if ($scope.to.required) {
		          var unwatchFormControl = $scope.$watch('fc', function (newValue) {
		            if (!newValue) {
		              return;
		            }
		            checkValidity(true);
		            unwatchFormControl();
		          });
		        }
		      }]
		    });
		  }
		  addCheckboxType.$inject = ["formlyConfigProvider"];
		};
	
		module.exports = exports['default'];
	
	/***/ },
	/* 13 */
	/***/ function(module, exports) {
	
		module.exports = "<div class=\"radio-group\">\n  <div ng-repeat=\"(key, option) in to.options\" class=\"checkbox\">\n    <label>\n      <input type=\"checkbox\"\n             id=\"{{id + '_'+ $index}}\"\n             ng-model=\"multiCheckbox.checked[$index]\"\n             ng-change=\"multiCheckbox.change()\">\n      {{option[to.labelProp || 'name']}}\n    </label>\n  </div>\n</div>\n"
	
	/***/ },
	/* 14 */
	/***/ function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		exports['default'] = function (ngModule) {
		  ngModule.config(addInputType);
	
		  function addInputType(formlyConfigProvider) {
		    formlyConfigProvider.setType({
		      name: 'input',
		      template: '<input class="form-control" ng-model="model[options.key]">',
		      wrapper: ['bootstrapLabel', 'bootstrapHasError']
		    });
		  }
		  addInputType.$inject = ["formlyConfigProvider"];
		};
	
		module.exports = exports['default'];
	
	/***/ },
	/* 15 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		exports['default'] = function (ngModule) {
		  ngModule.config(addRadioType);
	
		  function addRadioType(formlyConfigProvider) {
		    formlyConfigProvider.setType({
		      name: 'radio',
		      template: __webpack_require__(16),
		      wrapper: ['bootstrapLabel', 'bootstrapHasError'],
		      defaultOptions: {
		        noFormControl: false
		      },
		      apiCheck: function apiCheck(check) {
		        return {
		          templateOptions: {
		            options: check.arrayOf(check.object),
		            labelProp: check.string.optional,
		            valueProp: check.string.optional,
		            inline: check.bool.optional
		          }
		        };
		      }
		    });
		  }
		  addRadioType.$inject = ["formlyConfigProvider"];
		};
	
		module.exports = exports['default'];
	
	/***/ },
	/* 16 */
	/***/ function(module, exports) {
	
		module.exports = "<div class=\"radio-group\">\n  <div ng-repeat=\"(key, option) in to.options\" ng-class=\"{ 'radio': !to.inline, 'radio-inline': to.inline }\">\n    <label>\n      <input type=\"radio\"\n             id=\"{{id + '_'+ $index}}\"\n             tabindex=\"0\"\n             ng-value=\"option[to.valueProp || 'value']\"\n             ng-model=\"model[options.key]\">\n      {{option[to.labelProp || 'name']}}\n    </label>\n  </div>\n</div>\n"
	
	/***/ },
	/* 17 */
	/***/ function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
		exports['default'] = function (ngModule) {
		  ngModule.config(addSelectType);
	
		  var template = '<select class="form-control" ng-model="model[options.key]">\n      <option ng-hide="to.notNull" value="">{{to.nullDisplay}}</option>\n  </select>';
	
		  function addSelectType(formlyConfigProvider) {
		    formlyConfigProvider.setType({
		      name: 'select',
		      template: template,
		      wrapper: ['bootstrapLabel', 'bootstrapHasError'],
		      defaultOptions: function defaultOptions(options) {
		        /* jshint maxlen:195 */
		        var ngOptions = options.templateOptions.ngOptions || 'option[to.valueProp || \'value\'] as option[to.labelProp || \'name\'] group by option[to.groupProp || \'group\'] for option in to.options';
		        return {
		          ngModelAttrs: _defineProperty({}, ngOptions, {
		            value: options.templateOptions.optionsAttr || 'ng-options'
		          })
		        };
		      },
		      apiCheck: function apiCheck(check) {
		        return {
		          templateOptions: {
		            options: check.arrayOf(check.object),
		            optionsAttr: check.string.optional,
		            labelProp: check.string.optional,
		            valueProp: check.string.optional,
		            groupProp: check.string.optional,
		            notNull: check.bool.optional,
		            nullDisplay: check.string.optional
		          }
		        };
		      }
		    });
		  }
		  addSelectType.$inject = ["formlyConfigProvider"];
		};
	
		module.exports = exports['default'];
	
	/***/ },
	/* 18 */
	/***/ function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		exports['default'] = function (ngModule) {
		  ngModule.config(addTextareaType);
	
		  function addTextareaType(formlyConfigProvider) {
		    formlyConfigProvider.setType({
		      name: 'textarea',
		      template: '<textarea class="form-control" ng-model="model[options.key]"></textarea>',
		      wrapper: ['bootstrapLabel', 'bootstrapHasError'],
		      defaultOptions: {
		        ngModelAttrs: {
		          rows: { attribute: 'rows' },
		          cols: { attribute: 'cols' }
		        }
		      },
		      apiCheck: function apiCheck(check) {
		        return {
		          templateOptions: {
		            rows: check.number.optional,
		            cols: check.number.optional
		          }
		        };
		      }
		    });
		  }
		  addTextareaType.$inject = ["formlyConfigProvider"];
		};
	
		module.exports = exports['default'];
	
	/***/ },
	/* 19 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var _addons = __webpack_require__(20);
	
		var _addons2 = _interopRequireDefault(_addons);
	
		var _description = __webpack_require__(22);
	
		var _description2 = _interopRequireDefault(_description);
	
		exports['default'] = function (ngModule) {
		  (0, _addons2['default'])(ngModule);
		  (0, _description2['default'])(ngModule);
		};
	
		module.exports = exports['default'];
	
	/***/ },
	/* 20 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		exports['default'] = function (ngModule) {
		  ngModule.run(addAddonsManipulator);
	
		  function addAddonsManipulator(formlyConfig, formlyBootstrapApiCheck) {
		    var addonTemplate = __webpack_require__(21);
		    var addonChecker = formlyBootstrapApiCheck.shape({
		      'class': formlyBootstrapApiCheck.string.optional,
		      text: formlyBootstrapApiCheck.string.optional,
		      onClick: formlyBootstrapApiCheck.func.optional
		    }).strict.optional;
		    var api = formlyBootstrapApiCheck.shape({
		      templateOptions: formlyBootstrapApiCheck.shape({
		        addonLeft: addonChecker,
		        addonRight: addonChecker
		      })
		    });
		    formlyConfig.templateManipulators.preWrapper.push(function (template, options) {
		      if (!options.templateOptions.addonLeft && !options.templateOptions.addonRight) {
		        return template;
		      }
		      formlyBootstrapApiCheck.warn([api], [options]);
		      return addonTemplate.replace('<formly-transclude></formly-transclude>', template);
		    });
		  }
		  addAddonsManipulator.$inject = ["formlyConfig", "formlyBootstrapApiCheck"];
		};
	
		module.exports = exports['default'];
	
	/***/ },
	/* 21 */
	/***/ function(module, exports) {
	
		module.exports = "<div ng-class=\"{'input-group': to.addonLeft || to.addonRight}\">\n    <div class=\"input-group-addon\"\n         ng-if=\"to.addonLeft\"\n         ng-style=\"{cursor: to.addonLeft.onClick ? 'pointer' : 'inherit'}\"\n         ng-click=\"to.addonLeft.onClick(options, this, $event)\">\n        <i class=\"{{to.addonLeft.class}}\" ng-if=\"to.addonLeft.class\"></i>\n        <span ng-if=\"to.addonLeft.text\">{{to.addonLeft.text}}</span>\n    </div>\n    <formly-transclude></formly-transclude>\n    <div class=\"input-group-addon\"\n         ng-if=\"to.addonRight\"\n         ng-style=\"{cursor: to.addonRight.onClick ? 'pointer' : 'inherit'}\"\n         ng-click=\"to.addonRight.onClick(options, this, $event)\">\n        <i class=\"{{to.addonRight.class}}\" ng-if=\"to.addonRight.class\"></i>\n        <span ng-if=\"to.addonRight.text\">{{to.addonRight.text}}</span>\n    </div>\n</div>\n"
	
	/***/ },
	/* 22 */
	/***/ function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		exports['default'] = function (ngModule) {
		  ngModule.run(addDescriptionManipulator);
	
		  function addDescriptionManipulator(formlyConfig) {
		    formlyConfig.templateManipulators.preWrapper.push(function ariaDescribedBy(template, options, scope) {
		      if (angular.isDefined(options.templateOptions.description)) {
		        var el = document.createElement('div');
		        el.appendChild(angular.element(template)[0]);
		        el.appendChild(angular.element('<p id="' + scope.id + '_description"' + 'class="help-block"' + 'ng-if="to.description">' + '{{to.description}}' + '</p>')[0]);
		        var modelEls = angular.element(el.querySelectorAll('[ng-model]'));
		        if (modelEls) {
		          modelEls.attr('aria-describedby', scope.id + '_description');
		        }
		        return el.innerHTML;
		      } else {
		        return template;
		      }
		    });
		  }
		  addDescriptionManipulator.$inject = ["formlyConfig"];
		};
	
		module.exports = exports['default'];
	
	/***/ }
	/******/ ])
	});
	;

/***/ }),
/* 122 */
/***/ (function(module, exports) {

	/*! 
	 * angular-loading-bar v0.9.0
	 * https://chieffancypants.github.io/angular-loading-bar
	 * Copyright (c) 2016 Wes Cruver
	 * License: MIT
	 */
	/*
	 * angular-loading-bar
	 *
	 * intercepts XHR requests and creates a loading bar.
	 * Based on the excellent nprogress work by rstacruz (more info in readme)
	 *
	 * (c) 2013 Wes Cruver
	 * License: MIT
	 */
	
	
	(function() {
	
	'use strict';
	
	// Alias the loading bar for various backwards compatibilities since the project has matured:
	angular.module('angular-loading-bar', ['cfp.loadingBarInterceptor']);
	angular.module('chieffancypants.loadingBar', ['cfp.loadingBarInterceptor']);
	
	
	/**
	 * loadingBarInterceptor service
	 *
	 * Registers itself as an Angular interceptor and listens for XHR requests.
	 */
	angular.module('cfp.loadingBarInterceptor', ['cfp.loadingBar'])
	  .config(['$httpProvider', function ($httpProvider) {
	
	    var interceptor = ['$q', '$cacheFactory', '$timeout', '$rootScope', '$log', 'cfpLoadingBar', function ($q, $cacheFactory, $timeout, $rootScope, $log, cfpLoadingBar) {
	
	      /**
	       * The total number of requests made
	       */
	      var reqsTotal = 0;
	
	      /**
	       * The number of requests completed (either successfully or not)
	       */
	      var reqsCompleted = 0;
	
	      /**
	       * The amount of time spent fetching before showing the loading bar
	       */
	      var latencyThreshold = cfpLoadingBar.latencyThreshold;
	
	      /**
	       * $timeout handle for latencyThreshold
	       */
	      var startTimeout;
	
	
	      /**
	       * calls cfpLoadingBar.complete() which removes the
	       * loading bar from the DOM.
	       */
	      function setComplete() {
	        $timeout.cancel(startTimeout);
	        cfpLoadingBar.complete();
	        reqsCompleted = 0;
	        reqsTotal = 0;
	      }
	
	      /**
	       * Determine if the response has already been cached
	       * @param  {Object}  config the config option from the request
	       * @return {Boolean} retrns true if cached, otherwise false
	       */
	      function isCached(config) {
	        var cache;
	        var defaultCache = $cacheFactory.get('$http');
	        var defaults = $httpProvider.defaults;
	
	        // Choose the proper cache source. Borrowed from angular: $http service
	        if ((config.cache || defaults.cache) && config.cache !== false &&
	          (config.method === 'GET' || config.method === 'JSONP')) {
	            cache = angular.isObject(config.cache) ? config.cache
	              : angular.isObject(defaults.cache) ? defaults.cache
	              : defaultCache;
	        }
	
	        var cached = cache !== undefined ?
	          cache.get(config.url) !== undefined : false;
	
	        if (config.cached !== undefined && cached !== config.cached) {
	          return config.cached;
	        }
	        config.cached = cached;
	        return cached;
	      }
	
	
	      return {
	        'request': function(config) {
	          // Check to make sure this request hasn't already been cached and that
	          // the requester didn't explicitly ask us to ignore this request:
	          if (!config.ignoreLoadingBar && !isCached(config)) {
	            $rootScope.$broadcast('cfpLoadingBar:loading', {url: config.url});
	            if (reqsTotal === 0) {
	              startTimeout = $timeout(function() {
	                cfpLoadingBar.start();
	              }, latencyThreshold);
	            }
	            reqsTotal++;
	            cfpLoadingBar.set(reqsCompleted / reqsTotal);
	          }
	          return config;
	        },
	
	        'response': function(response) {
	          if (!response || !response.config) {
	            $log.error('Broken interceptor detected: Config object not supplied in response:\n https://github.com/chieffancypants/angular-loading-bar/pull/50');
	            return response;
	          }
	
	          if (!response.config.ignoreLoadingBar && !isCached(response.config)) {
	            reqsCompleted++;
	            $rootScope.$broadcast('cfpLoadingBar:loaded', {url: response.config.url, result: response});
	            if (reqsCompleted >= reqsTotal) {
	              setComplete();
	            } else {
	              cfpLoadingBar.set(reqsCompleted / reqsTotal);
	            }
	          }
	          return response;
	        },
	
	        'responseError': function(rejection) {
	          if (!rejection || !rejection.config) {
	            $log.error('Broken interceptor detected: Config object not supplied in rejection:\n https://github.com/chieffancypants/angular-loading-bar/pull/50');
	            return $q.reject(rejection);
	          }
	
	          if (!rejection.config.ignoreLoadingBar && !isCached(rejection.config)) {
	            reqsCompleted++;
	            $rootScope.$broadcast('cfpLoadingBar:loaded', {url: rejection.config.url, result: rejection});
	            if (reqsCompleted >= reqsTotal) {
	              setComplete();
	            } else {
	              cfpLoadingBar.set(reqsCompleted / reqsTotal);
	            }
	          }
	          return $q.reject(rejection);
	        }
	      };
	    }];
	
	    $httpProvider.interceptors.push(interceptor);
	  }]);
	
	
	/**
	 * Loading Bar
	 *
	 * This service handles adding and removing the actual element in the DOM.
	 * Generally, best practices for DOM manipulation is to take place in a
	 * directive, but because the element itself is injected in the DOM only upon
	 * XHR requests, and it's likely needed on every view, the best option is to
	 * use a service.
	 */
	angular.module('cfp.loadingBar', [])
	  .provider('cfpLoadingBar', function() {
	
	    this.autoIncrement = true;
	    this.includeSpinner = true;
	    this.includeBar = true;
	    this.latencyThreshold = 100;
	    this.startSize = 0.02;
	    this.parentSelector = 'body';
	    this.spinnerTemplate = '<div id="loading-bar-spinner"><div class="spinner-icon"></div></div>';
	    this.loadingBarTemplate = '<div id="loading-bar"><div class="bar"><div class="peg"></div></div></div>';
	
	    this.$get = ['$injector', '$document', '$timeout', '$rootScope', function ($injector, $document, $timeout, $rootScope) {
	      var $animate;
	      var $parentSelector = this.parentSelector,
	        loadingBarContainer = angular.element(this.loadingBarTemplate),
	        loadingBar = loadingBarContainer.find('div').eq(0),
	        spinner = angular.element(this.spinnerTemplate);
	
	      var incTimeout,
	        completeTimeout,
	        started = false,
	        status = 0;
	
	      var autoIncrement = this.autoIncrement;
	      var includeSpinner = this.includeSpinner;
	      var includeBar = this.includeBar;
	      var startSize = this.startSize;
	
	      /**
	       * Inserts the loading bar element into the dom, and sets it to 2%
	       */
	      function _start() {
	        if (!$animate) {
	          $animate = $injector.get('$animate');
	        }
	
	        $timeout.cancel(completeTimeout);
	
	        // do not continually broadcast the started event:
	        if (started) {
	          return;
	        }
	
	        var document = $document[0];
	        var parent = document.querySelector ?
	          document.querySelector($parentSelector)
	          : $document.find($parentSelector)[0]
	        ;
	
	        if (! parent) {
	          parent = document.getElementsByTagName('body')[0];
	        }
	
	        var $parent = angular.element(parent);
	        var $after = parent.lastChild && angular.element(parent.lastChild);
	
	        $rootScope.$broadcast('cfpLoadingBar:started');
	        started = true;
	
	        if (includeBar) {
	          $animate.enter(loadingBarContainer, $parent, $after);
	        }
	
	        if (includeSpinner) {
	          $animate.enter(spinner, $parent, loadingBarContainer);
	        }
	
	        _set(startSize);
	      }
	
	      /**
	       * Set the loading bar's width to a certain percent.
	       *
	       * @param n any value between 0 and 1
	       */
	      function _set(n) {
	        if (!started) {
	          return;
	        }
	        var pct = (n * 100) + '%';
	        loadingBar.css('width', pct);
	        status = n;
	
	        // increment loadingbar to give the illusion that there is always
	        // progress but make sure to cancel the previous timeouts so we don't
	        // have multiple incs running at the same time.
	        if (autoIncrement) {
	          $timeout.cancel(incTimeout);
	          incTimeout = $timeout(function() {
	            _inc();
	          }, 250);
	        }
	      }
	
	      /**
	       * Increments the loading bar by a random amount
	       * but slows down as it progresses
	       */
	      function _inc() {
	        if (_status() >= 1) {
	          return;
	        }
	
	        var rnd = 0;
	
	        // TODO: do this mathmatically instead of through conditions
	
	        var stat = _status();
	        if (stat >= 0 && stat < 0.25) {
	          // Start out between 3 - 6% increments
	          rnd = (Math.random() * (5 - 3 + 1) + 3) / 100;
	        } else if (stat >= 0.25 && stat < 0.65) {
	          // increment between 0 - 3%
	          rnd = (Math.random() * 3) / 100;
	        } else if (stat >= 0.65 && stat < 0.9) {
	          // increment between 0 - 2%
	          rnd = (Math.random() * 2) / 100;
	        } else if (stat >= 0.9 && stat < 0.99) {
	          // finally, increment it .5 %
	          rnd = 0.005;
	        } else {
	          // after 99%, don't increment:
	          rnd = 0;
	        }
	
	        var pct = _status() + rnd;
	        _set(pct);
	      }
	
	      function _status() {
	        return status;
	      }
	
	      function _completeAnimation() {
	        status = 0;
	        started = false;
	      }
	
	      function _complete() {
	        if (!$animate) {
	          $animate = $injector.get('$animate');
	        }
	
	        $rootScope.$broadcast('cfpLoadingBar:completed');
	        _set(1);
	
	        $timeout.cancel(completeTimeout);
	
	        // Attempt to aggregate any start/complete calls within 500ms:
	        completeTimeout = $timeout(function() {
	          var promise = $animate.leave(loadingBarContainer, _completeAnimation);
	          if (promise && promise.then) {
	            promise.then(_completeAnimation);
	          }
	          $animate.leave(spinner);
	        }, 500);
	      }
	
	      return {
	        start            : _start,
	        set              : _set,
	        status           : _status,
	        inc              : _inc,
	        complete         : _complete,
	        autoIncrement    : this.autoIncrement,
	        includeSpinner   : this.includeSpinner,
	        latencyThreshold : this.latencyThreshold,
	        parentSelector   : this.parentSelector,
	        startSize        : this.startSize
	      };
	
	
	    }];     //
	  });       // wtf javascript. srsly
	})();       //


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(122);
	module.exports = 'angular-loading-bar';


/***/ }),
/* 124 */
/***/ (function(module, exports) {

	/**
	 * @license AngularJS v1.8.3
	 * (c) 2010-2020 Google LLC. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular) {'use strict';
	
	var forEach;
	var isArray;
	var isString;
	var jqLite;
	
	/**
	 * @ngdoc module
	 * @name ngMessages
	 * @description
	 *
	 * The `ngMessages` module provides enhanced support for displaying messages within templates
	 * (typically within forms or when rendering message objects that return key/value data).
	 * Instead of relying on JavaScript code and/or complex ng-if statements within your form template to
	 * show and hide error messages specific to the state of an input field, the `ngMessages` and
	 * `ngMessage` directives are designed to handle the complexity, inheritance and priority
	 * sequencing based on the order of how the messages are defined in the template.
	 *
	 * Currently, the ngMessages module only contains the code for the `ngMessages`, `ngMessagesInclude`
	 * `ngMessage`, `ngMessageExp` and `ngMessageDefault` directives.
	 *
	 * ## Usage
	 * The `ngMessages` directive allows keys in a key/value collection to be associated with a child element
	 * (or 'message') that will show or hide based on the truthiness of that key's value in the collection. A common use
	 * case for `ngMessages` is to display error messages for inputs using the `$error` object exposed by the
	 * {@link ngModel ngModel} directive.
	 *
	 * The child elements of the `ngMessages` directive are matched to the collection keys by a `ngMessage` or
	 * `ngMessageExp` directive. The value of these attributes must match a key in the collection that is provided by
	 * the `ngMessages` directive.
	 *
	 * Consider the following example, which illustrates a typical use case of `ngMessages`. Within the form `myForm` we
	 * have a text input named `myField` which is bound to the scope variable `field` using the {@link ngModel ngModel}
	 * directive.
	 *
	 * The `myField` field is a required input of type `email` with a maximum length of 15 characters.
	 *
	 * ```html
	 * <form name="myForm">
	 *   <label>
	 *     Enter text:
	 *     <input type="email" ng-model="field" name="myField" required maxlength="15" />
	 *   </label>
	 *   <div ng-messages="myForm.myField.$error" role="alert">
	 *     <div ng-message="required">Please enter a value for this field.</div>
	 *     <div ng-message="email">This field must be a valid email address.</div>
	 *     <div ng-message="maxlength">This field can be at most 15 characters long.</div>
	 *   </div>
	 * </form>
	 * ```
	 *
	 * In order to show error messages corresponding to `myField` we first create an element with an `ngMessages` attribute
	 * set to the `$error` object owned by the `myField` input in our `myForm` form.
	 *
	 * Within this element we then create separate elements for each of the possible errors that `myField` could have.
	 * The `ngMessage` attribute is used to declare which element(s) will appear for which error - for example,
	 * setting `ng-message="required"` specifies that this particular element should be displayed when there
	 * is no value present for the required field `myField` (because the key `required` will be `true` in the object
	 * `myForm.myField.$error`).
	 *
	 * ### Message order
	 *
	 * By default, `ngMessages` will only display one message for a particular key/value collection at any time. If more
	 * than one message (or error) key is currently true, then which message is shown is determined by the order of messages
	 * in the HTML template code (messages declared first are prioritised). This mechanism means the developer does not have
	 * to prioritize messages using custom JavaScript code.
	 *
	 * Given the following error object for our example (which informs us that the field `myField` currently has both the
	 * `required` and `email` errors):
	 *
	 * ```javascript
	 * <!-- keep in mind that ngModel automatically sets these error flags -->
	 * myField.$error = { required : true, email: true, maxlength: false };
	 * ```
	 * The `required` message will be displayed to the user since it appears before the `email` message in the DOM.
	 * Once the user types a single character, the `required` message will disappear (since the field now has a value)
	 * but the `email` message will be visible because it is still applicable.
	 *
	 * ### Displaying multiple messages at the same time
	 *
	 * While `ngMessages` will by default only display one error element at a time, the `ng-messages-multiple` attribute can
	 * be applied to the `ngMessages` container element to cause it to display all applicable error messages at once:
	 *
	 * ```html
	 * <!-- attribute-style usage -->
	 * <div ng-messages="myForm.myField.$error" ng-messages-multiple>...</div>
	 *
	 * <!-- element-style usage -->
	 * <ng-messages for="myForm.myField.$error" multiple>...</ng-messages>
	 * ```
	 *
	 * ## Reusing and Overriding Messages
	 * In addition to prioritization, ngMessages also allows for including messages from a remote or an inline
	 * template. This allows for generic collection of messages to be reused across multiple parts of an
	 * application.
	 *
	 * ```html
	 * <script type="text/ng-template" id="error-messages">
	 *   <div ng-message="required">This field is required</div>
	 *   <div ng-message="minlength">This field is too short</div>
	 * </script>
	 *
	 * <div ng-messages="myForm.myField.$error" role="alert">
	 *   <div ng-messages-include="error-messages"></div>
	 * </div>
	 * ```
	 *
	 * However, including generic messages may not be useful enough to match all input fields, therefore,
	 * `ngMessages` provides the ability to override messages defined in the remote template by redefining
	 * them within the directive container.
	 *
	 * ```html
	 * <!-- a generic template of error messages known as "my-custom-messages" -->
	 * <script type="text/ng-template" id="my-custom-messages">
	 *   <div ng-message="required">This field is required</div>
	 *   <div ng-message="minlength">This field is too short</div>
	 * </script>
	 *
	 * <form name="myForm">
	 *   <label>
	 *     Email address
	 *     <input type="email"
	 *            id="email"
	 *            name="myEmail"
	 *            ng-model="email"
	 *            minlength="5"
	 *            required />
	 *   </label>
	 *   <!-- any ng-message elements that appear BEFORE the ng-messages-include will
	 *        override the messages present in the ng-messages-include template -->
	 *   <div ng-messages="myForm.myEmail.$error" role="alert">
	 *     <!-- this required message has overridden the template message -->
	 *     <div ng-message="required">You did not enter your email address</div>
	 *
	 *     <!-- this is a brand new message and will appear last in the prioritization -->
	 *     <div ng-message="email">Your email address is invalid</div>
	 *
	 *     <!-- and here are the generic error messages -->
	 *     <div ng-messages-include="my-custom-messages"></div>
	 *   </div>
	 * </form>
	 * ```
	 *
	 * In the example HTML code above the message that is set on required will override the corresponding
	 * required message defined within the remote template. Therefore, with particular input fields (such
	 * email addresses, date fields, autocomplete inputs, etc...), specialized error messages can be applied
	 * while more generic messages can be used to handle other, more general input errors.
	 *
	 * ## Dynamic Messaging
	 * ngMessages also supports using expressions to dynamically change key values. Using arrays and
	 * repeaters to list messages is also supported. This means that the code below will be able to
	 * fully adapt itself and display the appropriate message when any of the expression data changes:
	 *
	 * ```html
	 * <form name="myForm">
	 *   <label>
	 *     Email address
	 *     <input type="email"
	 *            name="myEmail"
	 *            ng-model="email"
	 *            minlength="5"
	 *            required />
	 *   </label>
	 *   <div ng-messages="myForm.myEmail.$error" role="alert">
	 *     <div ng-message="required">You did not enter your email address</div>
	 *     <div ng-repeat="errorMessage in errorMessages">
	 *       <!-- use ng-message-exp for a message whose key is given by an expression -->
	 *       <div ng-message-exp="errorMessage.type">{{ errorMessage.text }}</div>
	 *     </div>
	 *   </div>
	 * </form>
	 * ```
	 *
	 * The `errorMessage.type` expression can be a string value or it can be an array so
	 * that multiple errors can be associated with a single error message:
	 *
	 * ```html
	 *   <label>
	 *     Email address
	 *     <input type="email"
	 *            ng-model="data.email"
	 *            name="myEmail"
	 *            ng-minlength="5"
	 *            ng-maxlength="100"
	 *            required />
	 *   </label>
	 *   <div ng-messages="myForm.myEmail.$error" role="alert">
	 *     <div ng-message-exp="'required'">You did not enter your email address</div>
	 *     <div ng-message-exp="['minlength', 'maxlength']">
	 *       Your email must be between 5 and 100 characters long
	 *     </div>
	 *   </div>
	 * ```
	 *
	 * Feel free to use other structural directives such as ng-if and ng-switch to further control
	 * what messages are active and when. Be careful, if you place ng-message on the same element
	 * as these structural directives, AngularJS may not be able to determine if a message is active
	 * or not. Therefore it is best to place the ng-message on a child element of the structural
	 * directive.
	 *
	 * ```html
	 * <div ng-messages="myForm.myEmail.$error" role="alert">
	 *   <div ng-if="showRequiredError">
	 *     <div ng-message="required">Please enter something</div>
	 *   </div>
	 * </div>
	 * ```
	 *
	 * ## Animations
	 * If the `ngAnimate` module is active within the application then the `ngMessages`, `ngMessage` and
	 * `ngMessageExp` directives will trigger animations whenever any messages are added and removed from
	 * the DOM by the `ngMessages` directive.
	 *
	 * Whenever the `ngMessages` directive contains one or more visible messages then the `.ng-active` CSS
	 * class will be added to the element. The `.ng-inactive` CSS class will be applied when there are no
	 * messages present. Therefore, CSS transitions and keyframes as well as JavaScript animations can
	 * hook into the animations whenever these classes are added/removed.
	 *
	 * Let's say that our HTML code for our messages container looks like so:
	 *
	 * ```html
	 * <div ng-messages="myMessages" class="my-messages" role="alert">
	 *   <div ng-message="alert" class="some-message">...</div>
	 *   <div ng-message="fail" class="some-message">...</div>
	 * </div>
	 * ```
	 *
	 * Then the CSS animation code for the message container looks like so:
	 *
	 * ```css
	 * .my-messages {
	 *   transition:1s linear all;
	 * }
	 * .my-messages.ng-active {
	 *   // messages are visible
	 * }
	 * .my-messages.ng-inactive {
	 *   // messages are hidden
	 * }
	 * ```
	 *
	 * Whenever an inner message is attached (becomes visible) or removed (becomes hidden) then the enter
	 * and leave animation is triggered for each particular element bound to the `ngMessage` directive.
	 *
	 * Therefore, the CSS code for the inner messages looks like so:
	 *
	 * ```css
	 * .some-message {
	 *   transition:1s linear all;
	 * }
	 *
	 * .some-message.ng-enter {}
	 * .some-message.ng-enter.ng-enter-active {}
	 *
	 * .some-message.ng-leave {}
	 * .some-message.ng-leave.ng-leave-active {}
	 * ```
	 *
	 * {@link ngAnimate See the ngAnimate docs} to learn how to use JavaScript animations or to learn
	 * more about ngAnimate.
	 *
	 * ## Displaying a default message
	 * If the ngMessages renders no inner ngMessage directive (i.e. when none of the truthy
	 * keys are matched by a defined message), then it will render a default message
	 * using the {@link ngMessageDefault} directive.
	 * Note that matched messages will always take precedence over unmatched messages. That means
	 * the default message will not be displayed when another message is matched. This is also
	 * true for `ng-messages-multiple`.
	 *
	 * ```html
	 * <div ng-messages="myForm.myField.$error" role="alert">
	 *   <div ng-message="required">This field is required</div>
	 *   <div ng-message="minlength">This field is too short</div>
	 *   <div ng-message-default>This field has an input error</div>
	 * </div>
	 * ```
	 *
	
	 */
	angular.module('ngMessages', [], function initAngularHelpers() {
	  // Access helpers from AngularJS core.
	  // Do it inside a `config` block to ensure `window.angular` is available.
	  forEach = angular.forEach;
	  isArray = angular.isArray;
	  isString = angular.isString;
	  jqLite = angular.element;
	})
	  .info({ angularVersion: '1.8.3' })
	
	  /**
	   * @ngdoc directive
	   * @module ngMessages
	   * @name ngMessages
	   * @restrict AE
	   *
	   * @description
	   * `ngMessages` is a directive that is designed to show and hide messages based on the state
	   * of a key/value object that it listens on. The directive itself complements error message
	   * reporting with the `ngModel` $error object (which stores a key/value state of validation errors).
	   *
	   * `ngMessages` manages the state of internal messages within its container element. The internal
	   * messages use the `ngMessage` directive and will be inserted/removed from the page depending
	   * on if they're present within the key/value object. By default, only one message will be displayed
	   * at a time and this depends on the prioritization of the messages within the template. (This can
	   * be changed by using the `ng-messages-multiple` or `multiple` attribute on the directive container.)
	   *
	   * A remote template can also be used (With {@link ngMessagesInclude}) to promote message
	   * reusability and messages can also be overridden.
	   *
	   * A default message can also be displayed when no `ngMessage` directive is inserted, using the
	   * {@link ngMessageDefault} directive.
	   *
	   * {@link module:ngMessages Click here} to learn more about `ngMessages` and `ngMessage`.
	   *
	   * @usage
	   * ```html
	   * <!-- using attribute directives -->
	   * <ANY ng-messages="expression" role="alert">
	   *   <ANY ng-message="stringValue">...</ANY>
	   *   <ANY ng-message="stringValue1, stringValue2, ...">...</ANY>
	   *   <ANY ng-message-exp="expressionValue">...</ANY>
	   *   <ANY ng-message-default>...</ANY>
	   * </ANY>
	   *
	   * <!-- or by using element directives -->
	   * <ng-messages for="expression" role="alert">
	   *   <ng-message when="stringValue">...</ng-message>
	   *   <ng-message when="stringValue1, stringValue2, ...">...</ng-message>
	   *   <ng-message when-exp="expressionValue">...</ng-message>
	   *   <ng-message-default>...</ng-message-default>
	   * </ng-messages>
	   * ```
	   *
	   * @param {string} ngMessages an AngularJS expression evaluating to a key/value object
	   *                 (this is typically the $error object on an ngModel instance).
	   * @param {string=} ngMessagesMultiple|multiple when set, all messages will be displayed with true
	   *
	   * @example
	   * <example name="ngMessages-directive" module="ngMessagesExample"
	   *          deps="angular-messages.js"
	   *          animations="true" fixBase="true">
	   *   <file name="index.html">
	   *     <form name="myForm">
	   *       <label>
	   *         Enter your name:
	   *         <input type="text"
	   *                name="myName"
	   *                ng-model="name"
	   *                ng-minlength="5"
	   *                ng-maxlength="20"
	   *                required />
	   *       </label>
	   *       <pre>myForm.myName.$error = {{ myForm.myName.$error | json }}</pre>
	   *
	   *       <div ng-messages="myForm.myName.$error" style="color:maroon" role="alert">
	   *         <div ng-message="required">You did not enter a field</div>
	   *         <div ng-message="minlength">Your field is too short</div>
	   *         <div ng-message="maxlength">Your field is too long</div>
	   *         <div ng-message-default>This field has an input error</div>
	   *       </div>
	   *     </form>
	   *   </file>
	   *   <file name="script.js">
	   *     angular.module('ngMessagesExample', ['ngMessages']);
	   *   </file>
	   * </example>
	   */
	  .directive('ngMessages', ['$animate', function($animate) {
	    var ACTIVE_CLASS = 'ng-active';
	    var INACTIVE_CLASS = 'ng-inactive';
	
	    return {
	      require: 'ngMessages',
	      restrict: 'AE',
	      controller: ['$element', '$scope', '$attrs', function NgMessagesCtrl($element, $scope, $attrs) {
	        var ctrl = this;
	        var latestKey = 0;
	        var nextAttachId = 0;
	
	        this.getAttachId = function getAttachId() { return nextAttachId++; };
	
	        var messages = this.messages = {};
	        var renderLater, cachedCollection;
	
	        this.render = function(collection) {
	          collection = collection || {};
	
	          renderLater = false;
	          cachedCollection = collection;
	
	          // this is true if the attribute is empty or if the attribute value is truthy
	          var multiple = isAttrTruthy($scope, $attrs.ngMessagesMultiple) ||
	                         isAttrTruthy($scope, $attrs.multiple);
	
	          var unmatchedMessages = [];
	          var matchedKeys = {};
	          var truthyKeys = 0;
	          var messageItem = ctrl.head;
	          var messageFound = false;
	          var totalMessages = 0;
	
	          // we use != instead of !== to allow for both undefined and null values
	          while (messageItem != null) {
	            totalMessages++;
	            var messageCtrl = messageItem.message;
	
	            var messageUsed = false;
	            if (!messageFound) {
	              forEach(collection, function(value, key) {
	                if (truthy(value) && !messageUsed) {
	                  truthyKeys++;
	
	                  if (messageCtrl.test(key)) {
	                    // this is to prevent the same error name from showing up twice
	                    if (matchedKeys[key]) return;
	                    matchedKeys[key] = true;
	
	                    messageUsed = true;
	                    messageCtrl.attach();
	                  }
	                }
	              });
	            }
	
	            if (messageUsed) {
	              // unless we want to display multiple messages then we should
	              // set a flag here to avoid displaying the next message in the list
	              messageFound = !multiple;
	            } else {
	              unmatchedMessages.push(messageCtrl);
	            }
	
	            messageItem = messageItem.next;
	          }
	
	          forEach(unmatchedMessages, function(messageCtrl) {
	            messageCtrl.detach();
	          });
	
	          var messageMatched = unmatchedMessages.length !== totalMessages;
	          var attachDefault = ctrl.default && !messageMatched && truthyKeys > 0;
	
	          if (attachDefault) {
	            ctrl.default.attach();
	          } else if (ctrl.default) {
	            ctrl.default.detach();
	          }
	
	          if (messageMatched || attachDefault) {
	            $animate.setClass($element, ACTIVE_CLASS, INACTIVE_CLASS);
	          } else {
	            $animate.setClass($element, INACTIVE_CLASS, ACTIVE_CLASS);
	          }
	        };
	
	        $scope.$watchCollection($attrs.ngMessages || $attrs['for'], ctrl.render);
	
	        this.reRender = function() {
	          if (!renderLater) {
	            renderLater = true;
	            $scope.$evalAsync(function() {
	              if (renderLater && cachedCollection) {
	                ctrl.render(cachedCollection);
	              }
	            });
	          }
	        };
	
	        this.register = function(comment, messageCtrl, isDefault) {
	          if (isDefault) {
	            ctrl.default = messageCtrl;
	          } else {
	            var nextKey = latestKey.toString();
	            messages[nextKey] = {
	              message: messageCtrl
	            };
	            insertMessageNode($element[0], comment, nextKey);
	            comment.$$ngMessageNode = nextKey;
	            latestKey++;
	          }
	
	          ctrl.reRender();
	        };
	
	        this.deregister = function(comment, isDefault) {
	          if (isDefault) {
	            delete ctrl.default;
	          } else {
	            var key = comment.$$ngMessageNode;
	            delete comment.$$ngMessageNode;
	            removeMessageNode($element[0], comment, key);
	            delete messages[key];
	          }
	          ctrl.reRender();
	        };
	
	        function findPreviousMessage(parent, comment) {
	          var prevNode = comment;
	          var parentLookup = [];
	
	          while (prevNode && prevNode !== parent) {
	            var prevKey = prevNode.$$ngMessageNode;
	            if (prevKey && prevKey.length) {
	              return messages[prevKey];
	            }
	
	            // dive deeper into the DOM and examine its children for any ngMessage
	            // comments that may be in an element that appears deeper in the list
	            if (prevNode.childNodes.length && parentLookup.indexOf(prevNode) === -1) {
	              parentLookup.push(prevNode);
	              prevNode = prevNode.childNodes[prevNode.childNodes.length - 1];
	            } else if (prevNode.previousSibling) {
	              prevNode = prevNode.previousSibling;
	            } else {
	              prevNode = prevNode.parentNode;
	              parentLookup.push(prevNode);
	            }
	          }
	        }
	
	        function insertMessageNode(parent, comment, key) {
	          var messageNode = messages[key];
	          if (!ctrl.head) {
	            ctrl.head = messageNode;
	          } else {
	            var match = findPreviousMessage(parent, comment);
	            if (match) {
	              messageNode.next = match.next;
	              match.next = messageNode;
	            } else {
	              messageNode.next = ctrl.head;
	              ctrl.head = messageNode;
	            }
	          }
	        }
	
	        function removeMessageNode(parent, comment, key) {
	          var messageNode = messages[key];
	
	          // This message node may have already been removed by a call to deregister()
	          if (!messageNode) return;
	
	          var match = findPreviousMessage(parent, comment);
	          if (match) {
	            match.next = messageNode.next;
	          } else {
	            ctrl.head = messageNode.next;
	          }
	        }
	      }]
	    };
	
	    function isAttrTruthy(scope, attr) {
	     return (isString(attr) && attr.length === 0) || //empty attribute
	            truthy(scope.$eval(attr));
	    }
	
	    function truthy(val) {
	      return isString(val) ? val.length : !!val;
	    }
	  }])
	
	  /**
	   * @ngdoc directive
	   * @name ngMessagesInclude
	   * @restrict AE
	   * @scope
	   *
	   * @description
	   * `ngMessagesInclude` is a directive with the purpose to import existing ngMessage template
	   * code from a remote template and place the downloaded template code into the exact spot
	   * that the ngMessagesInclude directive is placed within the ngMessages container. This allows
	   * for a series of pre-defined messages to be reused and also allows for the developer to
	   * determine what messages are overridden due to the placement of the ngMessagesInclude directive.
	   *
	   * @usage
	   * ```html
	   * <!-- using attribute directives -->
	   * <ANY ng-messages="expression" role="alert">
	   *   <ANY ng-messages-include="remoteTplString">...</ANY>
	   * </ANY>
	   *
	   * <!-- or by using element directives -->
	   * <ng-messages for="expression" role="alert">
	   *   <ng-messages-include src="expressionValue1">...</ng-messages-include>
	   * </ng-messages>
	   * ```
	   *
	   * {@link module:ngMessages Click here} to learn more about `ngMessages` and `ngMessage`.
	   *
	   * @param {string} ngMessagesInclude|src a string value corresponding to the remote template.
	   */
	  .directive('ngMessagesInclude',
	    ['$templateRequest', '$document', '$compile', function($templateRequest, $document, $compile) {
	
	    return {
	      restrict: 'AE',
	      require: '^^ngMessages', // we only require this for validation sake
	      link: function($scope, element, attrs) {
	        var src = attrs.ngMessagesInclude || attrs.src;
	        $templateRequest(src).then(function(html) {
	          if ($scope.$$destroyed) return;
	
	          if (isString(html) && !html.trim()) {
	            // Empty template - nothing to compile
	            replaceElementWithMarker(element, src);
	          } else {
	            // Non-empty template - compile and link
	            $compile(html)($scope, function(contents) {
	              element.after(contents);
	              replaceElementWithMarker(element, src);
	            });
	          }
	        });
	      }
	    };
	
	    // Helpers
	    function replaceElementWithMarker(element, src) {
	      // A comment marker is placed for debugging purposes
	      var comment = $compile.$$createComment ?
	          $compile.$$createComment('ngMessagesInclude', src) :
	          $document[0].createComment(' ngMessagesInclude: ' + src + ' ');
	      var marker = jqLite(comment);
	      element.after(marker);
	
	      // Don't pollute the DOM anymore by keeping an empty directive element
	      element.remove();
	    }
	  }])
	
	  /**
	   * @ngdoc directive
	   * @name ngMessage
	   * @restrict AE
	   * @scope
	   * @priority 1
	   *
	   * @description
	   * `ngMessage` is a directive with the purpose to show and hide a particular message.
	   * For `ngMessage` to operate, a parent `ngMessages` directive on a parent DOM element
	   * must be situated since it determines which messages are visible based on the state
	   * of the provided key/value map that `ngMessages` listens on.
	   *
	   * More information about using `ngMessage` can be found in the
	   * {@link module:ngMessages `ngMessages` module documentation}.
	   *
	   * @usage
	   * ```html
	   * <!-- using attribute directives -->
	   * <ANY ng-messages="expression" role="alert">
	   *   <ANY ng-message="stringValue">...</ANY>
	   *   <ANY ng-message="stringValue1, stringValue2, ...">...</ANY>
	   * </ANY>
	   *
	   * <!-- or by using element directives -->
	   * <ng-messages for="expression" role="alert">
	   *   <ng-message when="stringValue">...</ng-message>
	   *   <ng-message when="stringValue1, stringValue2, ...">...</ng-message>
	   * </ng-messages>
	   * ```
	   *
	   * @param {expression} ngMessage|when a string value corresponding to the message key.
	   */
	  .directive('ngMessage', ngMessageDirectiveFactory())
	
	
	  /**
	   * @ngdoc directive
	   * @name ngMessageExp
	   * @restrict AE
	   * @priority 1
	   * @scope
	   *
	   * @description
	   * `ngMessageExp` is the same as {@link directive:ngMessage `ngMessage`}, but instead of a static
	   * value, it accepts an expression to be evaluated for the message key.
	   *
	   * @usage
	   * ```html
	   * <!-- using attribute directives -->
	   * <ANY ng-messages="expression">
	   *   <ANY ng-message-exp="expressionValue">...</ANY>
	   * </ANY>
	   *
	   * <!-- or by using element directives -->
	   * <ng-messages for="expression">
	   *   <ng-message when-exp="expressionValue">...</ng-message>
	   * </ng-messages>
	   * ```
	   *
	   * {@link module:ngMessages Click here} to learn more about `ngMessages` and `ngMessage`.
	   *
	   * @param {expression} ngMessageExp|whenExp an expression value corresponding to the message key.
	   */
	  .directive('ngMessageExp', ngMessageDirectiveFactory())
	
	  /**
	   * @ngdoc directive
	   * @name ngMessageDefault
	   * @restrict AE
	   * @scope
	   *
	   * @description
	   * `ngMessageDefault` is a directive with the purpose to show and hide a default message for
	   * {@link directive:ngMessages}, when none of provided messages matches.
	   *
	   * More information about using `ngMessageDefault` can be found in the
	   * {@link module:ngMessages `ngMessages` module documentation}.
	   *
	   * @usage
	   * ```html
	   * <!-- using attribute directives -->
	   * <ANY ng-messages="expression" role="alert">
	   *   <ANY ng-message="stringValue">...</ANY>
	   *   <ANY ng-message="stringValue1, stringValue2, ...">...</ANY>
	   *   <ANY ng-message-default>...</ANY>
	   * </ANY>
	   *
	   * <!-- or by using element directives -->
	   * <ng-messages for="expression" role="alert">
	   *   <ng-message when="stringValue">...</ng-message>
	   *   <ng-message when="stringValue1, stringValue2, ...">...</ng-message>
	   *   <ng-message-default>...</ng-message-default>
	   * </ng-messages>
	   *
	  */
	  .directive('ngMessageDefault', ngMessageDirectiveFactory(true));
	
	function ngMessageDirectiveFactory(isDefault) {
	  return ['$animate', function($animate) {
	    return {
	      restrict: 'AE',
	      transclude: 'element',
	      priority: 1, // must run before ngBind, otherwise the text is set on the comment
	      terminal: true,
	      require: '^^ngMessages',
	      link: function(scope, element, attrs, ngMessagesCtrl, $transclude) {
	        var commentNode, records, staticExp, dynamicExp;
	
	        if (!isDefault) {
	          commentNode = element[0];
	          staticExp = attrs.ngMessage || attrs.when;
	          dynamicExp = attrs.ngMessageExp || attrs.whenExp;
	
	          var assignRecords = function(items) {
	            records = items
	                ? (isArray(items)
	                      ? items
	                      : items.split(/[\s,]+/))
	                : null;
	            ngMessagesCtrl.reRender();
	          };
	
	          if (dynamicExp) {
	            assignRecords(scope.$eval(dynamicExp));
	            scope.$watchCollection(dynamicExp, assignRecords);
	          } else {
	            assignRecords(staticExp);
	          }
	        }
	
	        var currentElement, messageCtrl;
	        ngMessagesCtrl.register(commentNode, messageCtrl = {
	          test: function(name) {
	            return contains(records, name);
	          },
	          attach: function() {
	            if (!currentElement) {
	              $transclude(function(elm, newScope) {
	                $animate.enter(elm, null, element);
	                currentElement = elm;
	
	                // Each time we attach this node to a message we get a new id that we can match
	                // when we are destroying the node later.
	                var $$attachId = currentElement.$$attachId = ngMessagesCtrl.getAttachId();
	
	                // in the event that the element or a parent element is destroyed
	                // by another structural directive then it's time
	                // to deregister the message from the controller
	                currentElement.on('$destroy', function() {
	                  // If the message element was removed via a call to `detach` then `currentElement` will be null
	                  // So this handler only handles cases where something else removed the message element.
	                  if (currentElement && currentElement.$$attachId === $$attachId) {
	                    ngMessagesCtrl.deregister(commentNode, isDefault);
	                    messageCtrl.detach();
	                  }
	                  newScope.$destroy();
	                });
	              });
	            }
	          },
	          detach: function() {
	            if (currentElement) {
	              var elm = currentElement;
	              currentElement = null;
	              $animate.leave(elm);
	            }
	          }
	        }, isDefault);
	
	        // We need to ensure that this directive deregisters itself when it no longer exists
	        // Normally this is done when the attached element is destroyed; but if this directive
	        // gets removed before we attach the message to the DOM there is nothing to watch
	        // in which case we must deregister when the containing scope is destroyed.
	        scope.$on('$destroy', function() {
	          ngMessagesCtrl.deregister(commentNode, isDefault);
	        });
	      }
	    };
	  }];
	
	  function contains(collection, key) {
	    if (collection) {
	      return isArray(collection)
	          ? collection.indexOf(key) >= 0
	          : collection.hasOwnProperty(key);
	    }
	  }
	}
	
	
	})(window, window.angular);


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(124);
	module.exports = 'ngMessages';


/***/ }),
/* 126 */
/***/ (function(module, exports) {

	/**
	 * @license AngularJS v1.8.3
	 * (c) 2010-2020 Google LLC. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular) {'use strict';
	
	var $resourceMinErr = angular.$$minErr('$resource');
	
	// Helper functions and regex to lookup a dotted path on an object
	// stopping at undefined/null.  The path must be composed of ASCII
	// identifiers (just like $parse)
	var MEMBER_NAME_REGEX = /^(\.[a-zA-Z_$@][0-9a-zA-Z_$@]*)+$/;
	
	function isValidDottedPath(path) {
	  return (path != null && path !== '' && path !== 'hasOwnProperty' &&
	      MEMBER_NAME_REGEX.test('.' + path));
	}
	
	function lookupDottedPath(obj, path) {
	  if (!isValidDottedPath(path)) {
	    throw $resourceMinErr('badmember', 'Dotted member path "@{0}" is invalid.', path);
	  }
	  var keys = path.split('.');
	  for (var i = 0, ii = keys.length; i < ii && angular.isDefined(obj); i++) {
	    var key = keys[i];
	    obj = (obj !== null) ? obj[key] : undefined;
	  }
	  return obj;
	}
	
	/**
	 * Create a shallow copy of an object and clear other fields from the destination
	 */
	function shallowClearAndCopy(src, dst) {
	  dst = dst || {};
	
	  angular.forEach(dst, function(value, key) {
	    delete dst[key];
	  });
	
	  for (var key in src) {
	    if (src.hasOwnProperty(key) && !(key.charAt(0) === '$' && key.charAt(1) === '$')) {
	      dst[key] = src[key];
	    }
	  }
	
	  return dst;
	}
	
	/**
	 * @ngdoc module
	 * @name ngResource
	 * @description
	 *
	 * The `ngResource` module provides interaction support with RESTful services
	 * via the $resource service.
	 *
	 * See {@link ngResource.$resourceProvider} and {@link ngResource.$resource} for usage.
	 */
	
	/**
	 * @ngdoc provider
	 * @name $resourceProvider
	 *
	 * @description
	 *
	 * Use `$resourceProvider` to change the default behavior of the {@link ngResource.$resource}
	 * service.
	 *
	 * ## Dependencies
	 * Requires the {@link ngResource } module to be installed.
	 *
	 */
	
	/**
	 * @ngdoc service
	 * @name $resource
	 * @requires $http
	 * @requires ng.$log
	 * @requires $q
	 * @requires ng.$timeout
	 *
	 * @description
	 * A factory which creates a resource object that lets you interact with
	 * [RESTful](http://en.wikipedia.org/wiki/Representational_State_Transfer) server-side data sources.
	 *
	 * The returned resource object has action methods which provide high-level behaviors without
	 * the need to interact with the low level {@link ng.$http $http} service.
	 *
	 * Requires the {@link ngResource `ngResource`} module to be installed.
	 *
	 * By default, trailing slashes will be stripped from the calculated URLs,
	 * which can pose problems with server backends that do not expect that
	 * behavior.  This can be disabled by configuring the `$resourceProvider` like
	 * this:
	 *
	 * ```js
	     app.config(['$resourceProvider', function($resourceProvider) {
	       // Don't strip trailing slashes from calculated URLs
	       $resourceProvider.defaults.stripTrailingSlashes = false;
	     }]);
	 * ```
	 *
	 * @param {string} url A parameterized URL template with parameters prefixed by `:` as in
	 *   `/user/:username`. If you are using a URL with a port number (e.g.
	 *   `http://example.com:8080/api`), it will be respected.
	 *
	 *   If you are using a url with a suffix, just add the suffix, like this:
	 *   `$resource('http://example.com/resource.json')` or `$resource('http://example.com/:id.json')`
	 *   or even `$resource('http://example.com/resource/:resource_id.:format')`
	 *   If the parameter before the suffix is empty, :resource_id in this case, then the `/.` will be
	 *   collapsed down to a single `.`.  If you need this sequence to appear and not collapse then you
	 *   can escape it with `/\.`.
	 *
	 * @param {Object=} paramDefaults Default values for `url` parameters. These can be overridden in
	 *   `actions` methods. If a parameter value is a function, it will be called every time
	 *   a param value needs to be obtained for a request (unless the param was overridden). The
	 *   function will be passed the current data value as an argument.
	 *
	 *   Each key value in the parameter object is first bound to url template if present and then any
	 *   excess keys are appended to the url search query after the `?`.
	 *
	 *   Given a template `/path/:verb` and parameter `{verb: 'greet', salutation: 'Hello'}` results in
	 *   URL `/path/greet?salutation=Hello`.
	 *
	 *   If the parameter value is prefixed with `@`, then the value for that parameter will be
	 *   extracted from the corresponding property on the `data` object (provided when calling actions
	 *   with a request body).
	 *   For example, if the `defaultParam` object is `{someParam: '@someProp'}` then the value of
	 *   `someParam` will be `data.someProp`.
	 *   Note that the parameter will be ignored, when calling a "GET" action method (i.e. an action
	 *   method that does not accept a request body).
	 *
	 * @param {Object.<Object>=} actions Hash with declaration of custom actions that will be available
	 *   in addition to the default set of resource actions (see below). If a custom action has the same
	 *   key as a default action (e.g. `save`), then the default action will be *overwritten*, and not
	 *   extended.
	 *
	 *   The declaration should be created in the format of {@link ng.$http#usage $http.config}:
	 *
	 *       {
	 *         action1: {method:?, params:?, isArray:?, headers:?, ...},
	 *         action2: {method:?, params:?, isArray:?, headers:?, ...},
	 *         ...
	 *       }
	 *
	 *   Where:
	 *
	 *   - **`action`** – {string} – The name of action. This name becomes the name of the method on
	 *     your resource object.
	 *   - **`method`** – {string} – Case insensitive HTTP method (e.g. `GET`, `POST`, `PUT`,
	 *     `DELETE`, `JSONP`, etc).
	 *   - **`params`** – {Object=} – Optional set of pre-bound parameters for this action. If any of
	 *     the parameter value is a function, it will be called every time when a param value needs to
	 *     be obtained for a request (unless the param was overridden). The function will be passed the
	 *     current data value as an argument.
	 *   - **`url`** – {string} – Action specific `url` override. The url templating is supported just
	 *     like for the resource-level urls.
	 *   - **`isArray`** – {boolean=} – If true then the returned object for this action is an array,
	 *     see `returns` section.
	 *   - **`transformRequest`** –
	 *     `{function(data, headersGetter)|Array.<function(data, headersGetter)>}` –
	 *     Transform function or an array of such functions. The transform function takes the http
	 *     request body and headers and returns its transformed (typically serialized) version.
	 *     By default, transformRequest will contain one function that checks if the request data is
	 *     an object and serializes it using `angular.toJson`. To prevent this behavior, set
	 *     `transformRequest` to an empty array: `transformRequest: []`
	 *   - **`transformResponse`** –
	 *     `{function(data, headersGetter, status)|Array.<function(data, headersGetter, status)>}` –
	 *     Transform function or an array of such functions. The transform function takes the HTTP
	 *     response body, headers and status and returns its transformed (typically deserialized)
	 *     version.
	 *     By default, transformResponse will contain one function that checks if the response looks
	 *     like a JSON string and deserializes it using `angular.fromJson`. To prevent this behavior,
	 *     set `transformResponse` to an empty array: `transformResponse: []`
	 *   - **`cache`** – `{boolean|Cache}` – A boolean value or object created with
	 *     {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of the HTTP response.
	 *     See {@link $http#caching $http Caching} for more information.
	 *   - **`timeout`** – `{number}` – Timeout in milliseconds.<br />
	 *     **Note:** In contrast to {@link ng.$http#usage $http.config}, {@link ng.$q promises} are
	 *     **not** supported in `$resource`, because the same value would be used for multiple requests.
	 *     If you are looking for a way to cancel requests, you should use the `cancellable` option.
	 *   - **`cancellable`** – `{boolean}` – If true, the request made by a "non-instance" call will be
	 *     cancelled (if not already completed) by calling `$cancelRequest()` on the call's return
	 *     value. Calling `$cancelRequest()` for a non-cancellable or an already completed/cancelled
	 *     request will have no effect.
	 *   - **`withCredentials`** – `{boolean}` – Whether to set the `withCredentials` flag on the
	 *     XHR object. See
	 *     [XMLHttpRequest.withCredentials](https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/withCredentials)
	 *     for more information.
	 *   - **`responseType`** – `{string}` – See
	 *     [XMLHttpRequest.responseType](https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/responseType).
	 *   - **`interceptor`** – `{Object=}` – The interceptor object has four optional methods -
	 *     `request`, `requestError`, `response`, and `responseError`. See
	 *     {@link ng.$http#interceptors $http interceptors} for details. Note that
	 *     `request`/`requestError` interceptors are applied before calling `$http`, thus before any
	 *     global `$http` interceptors. Also, rejecting or throwing an error inside the `request`
	 *     interceptor will result in calling the `responseError` interceptor.
	 *     The resource instance or collection is available on the `resource` property of the
	 *     `http response` object passed to `response`/`responseError` interceptors.
	 *     Keep in mind that the associated promise will be resolved with the value returned by the
	 *     response interceptors. Make sure you return an appropriate value and not the `response`
	 *     object passed as input. For reference, the default `response` interceptor (which gets applied
	 *     if you don't specify a custom one) returns `response.resource`.<br />
	 *     See {@link ngResource.$resource#using-interceptors below} for an example of using
	 *     interceptors in `$resource`.
	 *   - **`hasBody`** – `{boolean}` – If true, then the request will have a body.
	 *     If not specified, then only POST, PUT and PATCH requests will have a body. *
	 * @param {Object} options Hash with custom settings that should extend the
	 *   default `$resourceProvider` behavior.  The supported options are:
	 *
	 *   - **`stripTrailingSlashes`** – {boolean} – If true then the trailing
	 *   slashes from any calculated URL will be stripped. (Defaults to true.)
	 *   - **`cancellable`** – {boolean} – If true, the request made by a "non-instance" call will be
	 *   cancelled (if not already completed) by calling `$cancelRequest()` on the call's return value.
	 *   This can be overwritten per action. (Defaults to false.)
	 *
	 * @returns {Object} A resource "class" object with methods for the default set of resource actions
	 *   optionally extended with custom `actions`. The default set contains these actions:
	 *   ```js
	 *   {
	 *     'get':    {method: 'GET'},
	 *     'save':   {method: 'POST'},
	 *     'query':  {method: 'GET', isArray: true},
	 *     'remove': {method: 'DELETE'},
	 *     'delete': {method: 'DELETE'}
	 *   }
	 *   ```
	 *
	 *   Calling these methods invoke {@link ng.$http} with the specified http method, destination and
	 *   parameters. When the data is returned from the server then the object is an instance of the
	 *   resource class. The actions `save`, `remove` and `delete` are available on it as methods with
	 *   the `$` prefix. This allows you to easily perform CRUD operations (create, read, update,
	 *   delete) on server-side data like this:
	 *   ```js
	 *   var User = $resource('/user/:userId', {userId: '@id'});
	 *   User.get({userId: 123}).$promise.then(function(user) {
	 *     user.abc = true;
	 *     user.$save();
	 *   });
	 *   ```
	 *
	 *   It is important to realize that invoking a `$resource` object method immediately returns an
	 *   empty reference (object or array depending on `isArray`). Once the data is returned from the
	 *   server the existing reference is populated with the actual data. This is a useful trick since
	 *   usually the resource is assigned to a model which is then rendered by the view. Having an empty
	 *   object results in no rendering, once the data arrives from the server then the object is
	 *   populated with the data and the view automatically re-renders itself showing the new data. This
	 *   means that in most cases one never has to write a callback function for the action methods.
	 *
	 *   The action methods on the class object or instance object can be invoked with the following
	 *   parameters:
	 *
	 *   - "class" actions without a body: `Resource.action([parameters], [success], [error])`
	 *   - "class" actions with a body: `Resource.action([parameters], postData, [success], [error])`
	 *   - instance actions: `instance.$action([parameters], [success], [error])`
	 *
	 *
	 *   When calling instance methods, the instance itself is used as the request body (if the action
	 *   should have a body). By default, only actions using `POST`, `PUT` or `PATCH` have request
	 *   bodies, but you can use the `hasBody` configuration option to specify whether an action
	 *   should have a body or not (regardless of its HTTP method).
	 *
	 *
	 *   Success callback is called with (value (Object|Array), responseHeaders (Function),
	 *   status (number), statusText (string)) arguments, where `value` is the populated resource
	 *   instance or collection object. The error callback is called with (httpResponse) argument.
	 *
	 *   Class actions return an empty instance (with the additional properties listed below).
	 *   Instance actions return a promise for the operation.
	 *
	 *   The Resource instances and collections have these additional properties:
	 *
	 *   - `$promise`: The {@link ng.$q promise} of the original server interaction that created this
	 *     instance or collection.
	 *
	 *     On success, the promise is resolved with the same resource instance or collection object,
	 *     updated with data from server. This makes it easy to use in the
	 *     {@link ngRoute.$routeProvider `resolve` section of `$routeProvider.when()`} to defer view
	 *     rendering until the resource(s) are loaded.
	 *
	 *     On failure, the promise is rejected with the {@link ng.$http http response} object.
	 *
	 *     If an interceptor object was provided, the promise will instead be resolved with the value
	 *     returned by the response interceptor (on success) or responceError interceptor (on failure).
	 *
	 *   - `$resolved`: `true` after first server interaction is completed (either with success or
	 *      rejection), `false` before that. Knowing if the Resource has been resolved is useful in
	 *      data-binding. If there is a response/responseError interceptor and it returns a promise,
	 *      `$resolved` will wait for that too.
	 *
	 *   The Resource instances and collections have these additional methods:
	 *
	 *   - `$cancelRequest`: If there is a cancellable, pending request related to the instance or
	 *      collection, calling this method will abort the request.
	 *
	 *   The Resource instances have these additional methods:
	 *
	 *   - `toJSON`: It returns a simple object without any of the extra properties added as part of
	 *     the Resource API. This object can be serialized through {@link angular.toJson} safely
	 *     without attaching AngularJS-specific fields. Notice that `JSON.stringify` (and
	 *     `angular.toJson`) automatically use this method when serializing a Resource instance
	 *     (see [MDN](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/JSON/stringify#toJSON%28%29_behavior)).
	 *
	 * @example
	 *
	 * ### Basic usage
	 *
	   ```js
	     // Define a CreditCard class
	     var CreditCard = $resource('/users/:userId/cards/:cardId',
	       {userId: 123, cardId: '@id'}, {
	         charge: {method: 'POST', params: {charge: true}}
	       });
	
	     // We can retrieve a collection from the server
	     var cards = CreditCard.query();
	         // GET: /users/123/cards
	         // server returns: [{id: 456, number: '1234', name: 'Smith'}]
	
	     // Wait for the request to complete
	     cards.$promise.then(function() {
	       var card = cards[0];
	
	       // Each item is an instance of CreditCard
	       expect(card instanceof CreditCard).toEqual(true);
	
	       // Non-GET methods are mapped onto the instances
	       card.name = 'J. Smith';
	       card.$save();
	           // POST: /users/123/cards/456 {id: 456, number: '1234', name: 'J. Smith'}
	           // server returns: {id: 456, number: '1234', name: 'J. Smith'}
	
	       // Our custom method is mapped as well (since it uses POST)
	       card.$charge({amount: 9.99});
	           // POST: /users/123/cards/456?amount=9.99&charge=true {id: 456, number: '1234', name: 'J. Smith'}
	     });
	
	     // We can create an instance as well
	     var newCard = new CreditCard({number: '0123'});
	     newCard.name = 'Mike Smith';
	
	     var savePromise = newCard.$save();
	         // POST: /users/123/cards {number: '0123', name: 'Mike Smith'}
	         // server returns: {id: 789, number: '0123', name: 'Mike Smith'}
	
	     savePromise.then(function() {
	       // Once the promise is resolved, the created instance
	       // is populated with the data returned by the server
	       expect(newCard.id).toEqual(789);
	     });
	   ```
	 *
	 * The object returned from a call to `$resource` is a resource "class" which has one "static"
	 * method for each action in the definition.
	 *
	 * Calling these methods invokes `$http` on the `url` template with the given HTTP `method`,
	 * `params` and `headers`.
	 *
	 * @example
	 *
	 * ### Accessing the response
	 *
	 * When the data is returned from the server then the object is an instance of the resource type and
	 * all of the non-GET methods are available with `$` prefix. This allows you to easily support CRUD
	 * operations (create, read, update, delete) on server-side data.
	 *
	   ```js
	     var User = $resource('/users/:userId', {userId: '@id'});
	     User.get({userId: 123}).$promise.then(function(user) {
	       user.abc = true;
	       user.$save();
	     });
	   ```
	 *
	 * It's worth noting that the success callback for `get`, `query` and other methods gets called with
	 * the resource instance (populated with the data that came from the server) as well as an `$http`
	 * header getter function, the HTTP status code and the response status text. So one could rewrite
	 * the above example and get access to HTTP headers as follows:
	 *
	   ```js
	     var User = $resource('/users/:userId', {userId: '@id'});
	     User.get({userId: 123}, function(user, getResponseHeaders) {
	       user.abc = true;
	       user.$save(function(user, putResponseHeaders) {
	         // `user` => saved `User` object
	         // `putResponseHeaders` => `$http` header getter
	       });
	     });
	   ```
	 *
	 * @example
	 *
	 * ### Creating custom actions
	 *
	 * In this example we create a custom method on our resource to make a PUT request:
	 *
	   ```js
	      var app = angular.module('app', ['ngResource']);
	
	      // Some APIs expect a PUT request in the format URL/object/ID
	      // Here we are creating an 'update' method
	      app.factory('Notes', ['$resource', function($resource) {
	        return $resource('/notes/:id', {id: '@id'}, {
	          update: {method: 'PUT'}
	        });
	      }]);
	
	      // In our controller we get the ID from the URL using `$location`
	      app.controller('NotesCtrl', ['$location', 'Notes', function($location, Notes) {
	        // First, retrieve the corresponding `Note` object from the server
	        // (Assuming a URL of the form `.../notes?id=XYZ`)
	        var noteId = $location.search().id;
	        var note = Notes.get({id: noteId});
	
	        note.$promise.then(function() {
	          note.content = 'Hello, world!';
	
	          // Now call `update` to save the changes on the server
	          Notes.update(note);
	              // This will PUT /notes/ID with the note object as the request payload
	
	          // Since `update` is a non-GET method, it will also be available on the instance
	          // (prefixed with `$`), so we could replace the `Note.update()` call with:
	          //note.$update();
	        });
	      }]);
	   ```
	 *
	 * @example
	 *
	 * ### Cancelling requests
	 *
	 * If an action's configuration specifies that it is cancellable, you can cancel the request related
	 * to an instance or collection (as long as it is a result of a "non-instance" call):
	 *
	   ```js
	     // ...defining the `Hotel` resource...
	     var Hotel = $resource('/api/hotels/:id', {id: '@id'}, {
	       // Let's make the `query()` method cancellable
	       query: {method: 'get', isArray: true, cancellable: true}
	     });
	
	     // ...somewhere in the PlanVacationController...
	     ...
	     this.onDestinationChanged = function onDestinationChanged(destination) {
	       // We don't care about any pending request for hotels
	       // in a different destination any more
	       if (this.availableHotels) {
	         this.availableHotels.$cancelRequest();
	       }
	
	       // Let's query for hotels in `destination`
	       // (calls: /api/hotels?location=<destination>)
	       this.availableHotels = Hotel.query({location: destination});
	     };
	   ```
	 *
	 * @example
	 *
	 * ### Using interceptors
	 *
	 * You can use interceptors to transform the request or response, perform additional operations, and
	 * modify the returned instance/collection. The following example, uses `request` and `response`
	 * interceptors to augment the returned instance with additional info:
	 *
	   ```js
	     var Thing = $resource('/api/things/:id', {id: '@id'}, {
	       save: {
	         method: 'POST',
	         interceptor: {
	           request: function(config) {
	             // Before the request is sent out, store a timestamp on the request config
	             config.requestTimestamp = Date.now();
	             return config;
	           },
	           response: function(response) {
	             // Get the instance from the response object
	             var instance = response.resource;
	
	             // Augment the instance with a custom `saveLatency` property, computed as the time
	             // between sending the request and receiving the response.
	             instance.saveLatency = Date.now() - response.config.requestTimestamp;
	
	             // Return the instance
	             return instance;
	           }
	         }
	       }
	     });
	
	     Thing.save({foo: 'bar'}).$promise.then(function(thing) {
	       console.log('That thing was saved in ' + thing.saveLatency + 'ms.');
	     });
	   ```
	 *
	 */
	angular.module('ngResource', ['ng']).
	  info({ angularVersion: '1.8.3' }).
	  provider('$resource', function ResourceProvider() {
	    var PROTOCOL_AND_IPV6_REGEX = /^https?:\/\/\[[^\]]*][^/]*/;
	
	    var provider = this;
	
	    /**
	     * @ngdoc property
	     * @name $resourceProvider#defaults
	     * @description
	     * Object containing default options used when creating `$resource` instances.
	     *
	     * The default values satisfy a wide range of usecases, but you may choose to overwrite any of
	     * them to further customize your instances. The available properties are:
	     *
	     * - **stripTrailingSlashes** – `{boolean}` – If true, then the trailing slashes from any
	     *   calculated URL will be stripped.<br />
	     *   (Defaults to true.)
	     * - **cancellable** – `{boolean}` – If true, the request made by a "non-instance" call will be
	     *   cancelled (if not already completed) by calling `$cancelRequest()` on the call's return
	     *   value. For more details, see {@link ngResource.$resource}. This can be overwritten per
	     *   resource class or action.<br />
	     *   (Defaults to false.)
	     * - **actions** - `{Object.<Object>}` - A hash with default actions declarations. Actions are
	     *   high-level methods corresponding to RESTful actions/methods on resources. An action may
	     *   specify what HTTP method to use, what URL to hit, if the return value will be a single
	     *   object or a collection (array) of objects etc. For more details, see
	     *   {@link ngResource.$resource}. The actions can also be enhanced or overwritten per resource
	     *   class.<br />
	     *   The default actions are:
	     *   ```js
	     *   {
	     *     get: {method: 'GET'},
	     *     save: {method: 'POST'},
	     *     query: {method: 'GET', isArray: true},
	     *     remove: {method: 'DELETE'},
	     *     delete: {method: 'DELETE'}
	     *   }
	     *   ```
	     *
	     * #### Example
	     *
	     * For example, you can specify a new `update` action that uses the `PUT` HTTP verb:
	     *
	     * ```js
	     *   angular.
	     *     module('myApp').
	     *     config(['$resourceProvider', function ($resourceProvider) {
	     *       $resourceProvider.defaults.actions.update = {
	     *         method: 'PUT'
	     *       };
	     *     }]);
	     * ```
	     *
	     * Or you can even overwrite the whole `actions` list and specify your own:
	     *
	     * ```js
	     *   angular.
	     *     module('myApp').
	     *     config(['$resourceProvider', function ($resourceProvider) {
	     *       $resourceProvider.defaults.actions = {
	     *         create: {method: 'POST'},
	     *         get:    {method: 'GET'},
	     *         getAll: {method: 'GET', isArray:true},
	     *         update: {method: 'PUT'},
	     *         delete: {method: 'DELETE'}
	     *       };
	     *     });
	     * ```
	     *
	     */
	    this.defaults = {
	      // Strip slashes by default
	      stripTrailingSlashes: true,
	
	      // Make non-instance requests cancellable (via `$cancelRequest()`)
	      cancellable: false,
	
	      // Default actions configuration
	      actions: {
	        'get': {method: 'GET'},
	        'save': {method: 'POST'},
	        'query': {method: 'GET', isArray: true},
	        'remove': {method: 'DELETE'},
	        'delete': {method: 'DELETE'}
	      }
	    };
	
	    this.$get = ['$http', '$log', '$q', '$timeout', function($http, $log, $q, $timeout) {
	
	      var noop = angular.noop,
	          forEach = angular.forEach,
	          extend = angular.extend,
	          copy = angular.copy,
	          isArray = angular.isArray,
	          isDefined = angular.isDefined,
	          isFunction = angular.isFunction,
	          isNumber = angular.isNumber,
	          encodeUriQuery = angular.$$encodeUriQuery,
	          encodeUriSegment = angular.$$encodeUriSegment;
	
	      function Route(template, defaults) {
	        this.template = template;
	        this.defaults = extend({}, provider.defaults, defaults);
	        this.urlParams = {};
	      }
	
	      Route.prototype = {
	        setUrlParams: function(config, params, actionUrl) {
	          var self = this,
	            url = actionUrl || self.template,
	            val,
	            encodedVal,
	            protocolAndIpv6 = '';
	
	          var urlParams = self.urlParams = Object.create(null);
	          forEach(url.split(/\W/), function(param) {
	            if (param === 'hasOwnProperty') {
	              throw $resourceMinErr('badname', 'hasOwnProperty is not a valid parameter name.');
	            }
	            if (!(new RegExp('^\\d+$').test(param)) && param &&
	              (new RegExp('(^|[^\\\\]):' + param + '(\\W|$)').test(url))) {
	              urlParams[param] = {
	                isQueryParamValue: (new RegExp('\\?.*=:' + param + '(?:\\W|$)')).test(url)
	              };
	            }
	          });
	          url = url.replace(/\\:/g, ':');
	          url = url.replace(PROTOCOL_AND_IPV6_REGEX, function(match) {
	            protocolAndIpv6 = match;
	            return '';
	          });
	
	          params = params || {};
	          forEach(self.urlParams, function(paramInfo, urlParam) {
	            val = params.hasOwnProperty(urlParam) ? params[urlParam] : self.defaults[urlParam];
	            if (isDefined(val) && val !== null) {
	              if (paramInfo.isQueryParamValue) {
	                encodedVal = encodeUriQuery(val, true);
	              } else {
	                encodedVal = encodeUriSegment(val);
	              }
	              url = url.replace(new RegExp(':' + urlParam + '(\\W|$)', 'g'), function(match, p1) {
	                return encodedVal + p1;
	              });
	            } else {
	              url = url.replace(new RegExp('(/?):' + urlParam + '(\\W|$)', 'g'), function(match,
	                  leadingSlashes, tail) {
	                if (tail.charAt(0) === '/') {
	                  return tail;
	                } else {
	                  return leadingSlashes + tail;
	                }
	              });
	            }
	          });
	
	          // strip trailing slashes and set the url (unless this behavior is specifically disabled)
	          if (self.defaults.stripTrailingSlashes) {
	            url = url.replace(/\/+$/, '') || '/';
	          }
	
	          // Collapse `/.` if found in the last URL path segment before the query.
	          // E.g. `http://url.com/id/.format?q=x` becomes `http://url.com/id.format?q=x`.
	          url = url.replace(/\/\.(?=\w+($|\?))/, '.');
	          // Replace escaped `/\.` with `/.`.
	          // (If `\.` comes from a param value, it will be encoded as `%5C.`.)
	          config.url = protocolAndIpv6 + url.replace(/\/(\\|%5C)\./, '/.');
	
	
	          // set params - delegate param encoding to $http
	          forEach(params, function(value, key) {
	            if (!self.urlParams[key]) {
	              config.params = config.params || {};
	              config.params[key] = value;
	            }
	          });
	        }
	      };
	
	
	      function resourceFactory(url, paramDefaults, actions, options) {
	        var route = new Route(url, options);
	
	        actions = extend({}, provider.defaults.actions, actions);
	
	        function extractParams(data, actionParams) {
	          var ids = {};
	          actionParams = extend({}, paramDefaults, actionParams);
	          forEach(actionParams, function(value, key) {
	            if (isFunction(value)) { value = value(data); }
	            ids[key] = value && value.charAt && value.charAt(0) === '@' ?
	              lookupDottedPath(data, value.substr(1)) : value;
	          });
	          return ids;
	        }
	
	        function defaultResponseInterceptor(response) {
	          return response.resource;
	        }
	
	        function Resource(value) {
	          shallowClearAndCopy(value || {}, this);
	        }
	
	        Resource.prototype.toJSON = function() {
	          var data = extend({}, this);
	          delete data.$promise;
	          delete data.$resolved;
	          delete data.$cancelRequest;
	          return data;
	        };
	
	        forEach(actions, function(action, name) {
	          var hasBody = action.hasBody === true || (action.hasBody !== false && /^(POST|PUT|PATCH)$/i.test(action.method));
	          var numericTimeout = action.timeout;
	          var cancellable = isDefined(action.cancellable) ?
	              action.cancellable : route.defaults.cancellable;
	
	          if (numericTimeout && !isNumber(numericTimeout)) {
	            $log.debug('ngResource:\n' +
	                       '  Only numeric values are allowed as `timeout`.\n' +
	                       '  Promises are not supported in $resource, because the same value would ' +
	                       'be used for multiple requests. If you are looking for a way to cancel ' +
	                       'requests, you should use the `cancellable` option.');
	            delete action.timeout;
	            numericTimeout = null;
	          }
	
	          Resource[name] = function(a1, a2, a3, a4) {
	            var params = {}, data, onSuccess, onError;
	
	            switch (arguments.length) {
	              case 4:
	                onError = a4;
	                onSuccess = a3;
	                // falls through
	              case 3:
	              case 2:
	                if (isFunction(a2)) {
	                  if (isFunction(a1)) {
	                    onSuccess = a1;
	                    onError = a2;
	                    break;
	                  }
	
	                  onSuccess = a2;
	                  onError = a3;
	                  // falls through
	                } else {
	                  params = a1;
	                  data = a2;
	                  onSuccess = a3;
	                  break;
	                }
	                // falls through
	              case 1:
	                if (isFunction(a1)) onSuccess = a1;
	                else if (hasBody) data = a1;
	                else params = a1;
	                break;
	              case 0: break;
	              default:
	                throw $resourceMinErr('badargs',
	                  'Expected up to 4 arguments [params, data, success, error], got {0} arguments',
	                  arguments.length);
	            }
	
	            var isInstanceCall = this instanceof Resource;
	            var value = isInstanceCall ? data : (action.isArray ? [] : new Resource(data));
	            var httpConfig = {};
	            var requestInterceptor = action.interceptor && action.interceptor.request || undefined;
	            var requestErrorInterceptor = action.interceptor && action.interceptor.requestError ||
	              undefined;
	            var responseInterceptor = action.interceptor && action.interceptor.response ||
	              defaultResponseInterceptor;
	            var responseErrorInterceptor = action.interceptor && action.interceptor.responseError ||
	              $q.reject;
	            var successCallback = onSuccess ? function(val) {
	              onSuccess(val, response.headers, response.status, response.statusText);
	            } : undefined;
	            var errorCallback = onError || undefined;
	            var timeoutDeferred;
	            var numericTimeoutPromise;
	            var response;
	
	            forEach(action, function(value, key) {
	              switch (key) {
	                default:
	                  httpConfig[key] = copy(value);
	                  break;
	                case 'params':
	                case 'isArray':
	                case 'interceptor':
	                case 'cancellable':
	                  break;
	              }
	            });
	
	            if (!isInstanceCall && cancellable) {
	              timeoutDeferred = $q.defer();
	              httpConfig.timeout = timeoutDeferred.promise;
	
	              if (numericTimeout) {
	                numericTimeoutPromise = $timeout(timeoutDeferred.resolve, numericTimeout);
	              }
	            }
	
	            if (hasBody) httpConfig.data = data;
	            route.setUrlParams(httpConfig,
	              extend({}, extractParams(data, action.params || {}), params),
	              action.url);
	
	            // Start the promise chain
	            var promise = $q.
	              resolve(httpConfig).
	              then(requestInterceptor).
	              catch(requestErrorInterceptor).
	              then($http);
	
	            promise = promise.then(function(resp) {
	              var data = resp.data;
	
	              if (data) {
	                // Need to convert action.isArray to boolean in case it is undefined
	                if (isArray(data) !== (!!action.isArray)) {
	                  throw $resourceMinErr('badcfg',
	                      'Error in resource configuration for action `{0}`. Expected response to ' +
	                      'contain an {1} but got an {2} (Request: {3} {4})', name, action.isArray ? 'array' : 'object',
	                    isArray(data) ? 'array' : 'object', httpConfig.method, httpConfig.url);
	                }
	                if (action.isArray) {
	                  value.length = 0;
	                  forEach(data, function(item) {
	                    if (typeof item === 'object') {
	                      value.push(new Resource(item));
	                    } else {
	                      // Valid JSON values may be string literals, and these should not be converted
	                      // into objects. These items will not have access to the Resource prototype
	                      // methods, but unfortunately there
	                      value.push(item);
	                    }
	                  });
	                } else {
	                  var promise = value.$promise;     // Save the promise
	                  shallowClearAndCopy(data, value);
	                  value.$promise = promise;         // Restore the promise
	                }
	              }
	
	              resp.resource = value;
	              response = resp;
	              return responseInterceptor(resp);
	            }, function(rejectionOrResponse) {
	              rejectionOrResponse.resource = value;
	              response = rejectionOrResponse;
	              return responseErrorInterceptor(rejectionOrResponse);
	            });
	
	            promise = promise['finally'](function() {
	              value.$resolved = true;
	              if (!isInstanceCall && cancellable) {
	                value.$cancelRequest = noop;
	                $timeout.cancel(numericTimeoutPromise);
	                timeoutDeferred = numericTimeoutPromise = httpConfig.timeout = null;
	              }
	            });
	
	            // Run the `success`/`error` callbacks, but do not let them affect the returned promise.
	            promise.then(successCallback, errorCallback);
	
	            if (!isInstanceCall) {
	              // we are creating instance / collection
	              // - set the initial promise
	              // - return the instance / collection
	              value.$promise = promise;
	              value.$resolved = false;
	              if (cancellable) value.$cancelRequest = cancelRequest;
	
	              return value;
	            }
	
	            // instance call
	            return promise;
	
	            function cancelRequest(value) {
	              promise.catch(noop);
	              if (timeoutDeferred !== null) {
	                timeoutDeferred.resolve(value);
	              }
	            }
	          };
	
	
	          Resource.prototype['$' + name] = function(params, success, error) {
	            if (isFunction(params)) {
	              error = success; success = params; params = {};
	            }
	            var result = Resource[name].call(this, params, this, success, error);
	            return result.$promise || result;
	          };
	        });
	
	        return Resource;
	      }
	
	      return resourceFactory;
	    }];
	  });
	
	
	})(window, window.angular);


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(126);
	module.exports = 'ngResource';


/***/ }),
/* 128 */
/***/ (function(module, exports) {

	/**
	 * @license AngularJS v1.8.3
	 * (c) 2010-2020 Google LLC. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular) {'use strict';
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	var $sanitizeMinErr = angular.$$minErr('$sanitize');
	var bind;
	var extend;
	var forEach;
	var isArray;
	var isDefined;
	var lowercase;
	var noop;
	var nodeContains;
	var htmlParser;
	var htmlSanitizeWriter;
	
	/**
	 * @ngdoc module
	 * @name ngSanitize
	 * @description
	 *
	 * The `ngSanitize` module provides functionality to sanitize HTML.
	 *
	 * See {@link ngSanitize.$sanitize `$sanitize`} for usage.
	 */
	
	/**
	 * @ngdoc service
	 * @name $sanitize
	 * @kind function
	 *
	 * @description
	 *   Sanitizes an html string by stripping all potentially dangerous tokens.
	 *
	 *   The input is sanitized by parsing the HTML into tokens. All safe tokens (from a trusted URI list) are
	 *   then serialized back to a properly escaped HTML string. This means that no unsafe input can make
	 *   it into the returned string.
	 *
	 *   The trusted URIs for URL sanitization of attribute values is configured using the functions
	 *   `aHrefSanitizationTrustedUrlList` and `imgSrcSanitizationTrustedUrlList` of {@link $compileProvider}.
	 *
	 *   The input may also contain SVG markup if this is enabled via {@link $sanitizeProvider}.
	 *
	 * @param {string} html HTML input.
	 * @returns {string} Sanitized HTML.
	 *
	 * @example
	   <example module="sanitizeExample" deps="angular-sanitize.js" name="sanitize-service">
	   <file name="index.html">
	     <script>
	         angular.module('sanitizeExample', ['ngSanitize'])
	           .controller('ExampleController', ['$scope', '$sce', function($scope, $sce) {
	             $scope.snippet =
	               '<p style="color:blue">an html\n' +
	               '<em onmouseover="this.textContent=\'PWN3D!\'">click here</em>\n' +
	               'snippet</p>';
	             $scope.deliberatelyTrustDangerousSnippet = function() {
	               return $sce.trustAsHtml($scope.snippet);
	             };
	           }]);
	     </script>
	     <div ng-controller="ExampleController">
	        Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
	       <table>
	         <tr>
	           <td>Directive</td>
	           <td>How</td>
	           <td>Source</td>
	           <td>Rendered</td>
	         </tr>
	         <tr id="bind-html-with-sanitize">
	           <td>ng-bind-html</td>
	           <td>Automatically uses $sanitize</td>
	           <td><pre>&lt;div ng-bind-html="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
	           <td><div ng-bind-html="snippet"></div></td>
	         </tr>
	         <tr id="bind-html-with-trust">
	           <td>ng-bind-html</td>
	           <td>Bypass $sanitize by explicitly trusting the dangerous value</td>
	           <td>
	           <pre>&lt;div ng-bind-html="deliberatelyTrustDangerousSnippet()"&gt;
	&lt;/div&gt;</pre>
	           </td>
	           <td><div ng-bind-html="deliberatelyTrustDangerousSnippet()"></div></td>
	         </tr>
	         <tr id="bind-default">
	           <td>ng-bind</td>
	           <td>Automatically escapes</td>
	           <td><pre>&lt;div ng-bind="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
	           <td><div ng-bind="snippet"></div></td>
	         </tr>
	       </table>
	       </div>
	   </file>
	   <file name="protractor.js" type="protractor">
	     it('should sanitize the html snippet by default', function() {
	       expect(element(by.css('#bind-html-with-sanitize div')).getAttribute('innerHTML')).
	         toBe('<p>an html\n<em>click here</em>\nsnippet</p>');
	     });
	
	     it('should inline raw snippet if bound to a trusted value', function() {
	       expect(element(by.css('#bind-html-with-trust div')).getAttribute('innerHTML')).
	         toBe("<p style=\"color:blue\">an html\n" +
	              "<em onmouseover=\"this.textContent='PWN3D!'\">click here</em>\n" +
	              "snippet</p>");
	     });
	
	     it('should escape snippet without any filter', function() {
	       expect(element(by.css('#bind-default div')).getAttribute('innerHTML')).
	         toBe("&lt;p style=\"color:blue\"&gt;an html\n" +
	              "&lt;em onmouseover=\"this.textContent='PWN3D!'\"&gt;click here&lt;/em&gt;\n" +
	              "snippet&lt;/p&gt;");
	     });
	
	     it('should update', function() {
	       element(by.model('snippet')).clear();
	       element(by.model('snippet')).sendKeys('new <b onclick="alert(1)">text</b>');
	       expect(element(by.css('#bind-html-with-sanitize div')).getAttribute('innerHTML')).
	         toBe('new <b>text</b>');
	       expect(element(by.css('#bind-html-with-trust div')).getAttribute('innerHTML')).toBe(
	         'new <b onclick="alert(1)">text</b>');
	       expect(element(by.css('#bind-default div')).getAttribute('innerHTML')).toBe(
	         "new &lt;b onclick=\"alert(1)\"&gt;text&lt;/b&gt;");
	     });
	   </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc provider
	 * @name $sanitizeProvider
	 * @this
	 *
	 * @description
	 * Creates and configures {@link $sanitize} instance.
	 */
	function $SanitizeProvider() {
	  var hasBeenInstantiated = false;
	  var svgEnabled = false;
	
	  this.$get = ['$$sanitizeUri', function($$sanitizeUri) {
	    hasBeenInstantiated = true;
	    if (svgEnabled) {
	      extend(validElements, svgElements);
	    }
	    return function(html) {
	      var buf = [];
	      htmlParser(html, htmlSanitizeWriter(buf, function(uri, isImage) {
	        return !/^unsafe:/.test($$sanitizeUri(uri, isImage));
	      }));
	      return buf.join('');
	    };
	  }];
	
	
	  /**
	   * @ngdoc method
	   * @name $sanitizeProvider#enableSvg
	   * @kind function
	   *
	   * @description
	   * Enables a subset of svg to be supported by the sanitizer.
	   *
	   * <div class="alert alert-warning">
	   *   <p>By enabling this setting without taking other precautions, you might expose your
	   *   application to click-hijacking attacks. In these attacks, sanitized svg elements could be positioned
	   *   outside of the containing element and be rendered over other elements on the page (e.g. a login
	   *   link). Such behavior can then result in phishing incidents.</p>
	   *
	   *   <p>To protect against these, explicitly setup `overflow: hidden` css rule for all potential svg
	   *   tags within the sanitized content:</p>
	   *
	   *   <br>
	   *
	   *   <pre><code>
	   *   .rootOfTheIncludedContent svg {
	   *     overflow: hidden !important;
	   *   }
	   *   </code></pre>
	   * </div>
	   *
	   * @param {boolean=} flag Enable or disable SVG support in the sanitizer.
	   * @returns {boolean|$sanitizeProvider} Returns the currently configured value if called
	   *    without an argument or self for chaining otherwise.
	   */
	  this.enableSvg = function(enableSvg) {
	    if (isDefined(enableSvg)) {
	      svgEnabled = enableSvg;
	      return this;
	    } else {
	      return svgEnabled;
	    }
	  };
	
	
	  /**
	   * @ngdoc method
	   * @name $sanitizeProvider#addValidElements
	   * @kind function
	   *
	   * @description
	   * Extends the built-in lists of valid HTML/SVG elements, i.e. elements that are considered safe
	   * and are not stripped off during sanitization. You can extend the following lists of elements:
	   *
	   * - `htmlElements`: A list of elements (tag names) to extend the current list of safe HTML
	   *   elements. HTML elements considered safe will not be removed during sanitization. All other
	   *   elements will be stripped off.
	   *
	   * - `htmlVoidElements`: This is similar to `htmlElements`, but marks the elements as
	   *   "void elements" (similar to HTML
	   *   [void elements](https://rawgit.com/w3c/html/html5.1-2/single-page.html#void-elements)). These
	   *   elements have no end tag and cannot have content.
	   *
	   * - `svgElements`: This is similar to `htmlElements`, but for SVG elements. This list is only
	   *   taken into account if SVG is {@link ngSanitize.$sanitizeProvider#enableSvg enabled} for
	   *   `$sanitize`.
	   *
	   * <div class="alert alert-info">
	   *   This method must be called during the {@link angular.Module#config config} phase. Once the
	   *   `$sanitize` service has been instantiated, this method has no effect.
	   * </div>
	   *
	   * <div class="alert alert-warning">
	   *   Keep in mind that extending the built-in lists of elements may expose your app to XSS or
	   *   other vulnerabilities. Be very mindful of the elements you add.
	   * </div>
	   *
	   * @param {Array<String>|Object} elements - A list of valid HTML elements or an object with one or
	   *   more of the following properties:
	   *   - **htmlElements** - `{Array<String>}` - A list of elements to extend the current list of
	   *     HTML elements.
	   *   - **htmlVoidElements** - `{Array<String>}` - A list of elements to extend the current list of
	   *     void HTML elements; i.e. elements that do not have an end tag.
	   *   - **svgElements** - `{Array<String>}` - A list of elements to extend the current list of SVG
	   *     elements. The list of SVG elements is only taken into account if SVG is
	   *     {@link ngSanitize.$sanitizeProvider#enableSvg enabled} for `$sanitize`.
	   *
	   * Passing an array (`[...]`) is equivalent to passing `{htmlElements: [...]}`.
	   *
	   * @return {$sanitizeProvider} Returns self for chaining.
	   */
	  this.addValidElements = function(elements) {
	    if (!hasBeenInstantiated) {
	      if (isArray(elements)) {
	        elements = {htmlElements: elements};
	      }
	
	      addElementsTo(svgElements, elements.svgElements);
	      addElementsTo(voidElements, elements.htmlVoidElements);
	      addElementsTo(validElements, elements.htmlVoidElements);
	      addElementsTo(validElements, elements.htmlElements);
	    }
	
	    return this;
	  };
	
	
	  /**
	   * @ngdoc method
	   * @name $sanitizeProvider#addValidAttrs
	   * @kind function
	   *
	   * @description
	   * Extends the built-in list of valid attributes, i.e. attributes that are considered safe and are
	   * not stripped off during sanitization.
	   *
	   * **Note**:
	   * The new attributes will not be treated as URI attributes, which means their values will not be
	   * sanitized as URIs using `$compileProvider`'s
	   * {@link ng.$compileProvider#aHrefSanitizationTrustedUrlList aHrefSanitizationTrustedUrlList} and
	   * {@link ng.$compileProvider#imgSrcSanitizationTrustedUrlList imgSrcSanitizationTrustedUrlList}.
	   *
	   * <div class="alert alert-info">
	   *   This method must be called during the {@link angular.Module#config config} phase. Once the
	   *   `$sanitize` service has been instantiated, this method has no effect.
	   * </div>
	   *
	   * <div class="alert alert-warning">
	   *   Keep in mind that extending the built-in list of attributes may expose your app to XSS or
	   *   other vulnerabilities. Be very mindful of the attributes you add.
	   * </div>
	   *
	   * @param {Array<String>} attrs - A list of valid attributes.
	   *
	   * @returns {$sanitizeProvider} Returns self for chaining.
	   */
	  this.addValidAttrs = function(attrs) {
	    if (!hasBeenInstantiated) {
	      extend(validAttrs, arrayToMap(attrs, true));
	    }
	    return this;
	  };
	
	  //////////////////////////////////////////////////////////////////////////////////////////////////
	  // Private stuff
	  //////////////////////////////////////////////////////////////////////////////////////////////////
	
	  bind = angular.bind;
	  extend = angular.extend;
	  forEach = angular.forEach;
	  isArray = angular.isArray;
	  isDefined = angular.isDefined;
	  lowercase = angular.$$lowercase;
	  noop = angular.noop;
	
	  htmlParser = htmlParserImpl;
	  htmlSanitizeWriter = htmlSanitizeWriterImpl;
	
	  nodeContains = window.Node.prototype.contains || /** @this */ function(arg) {
	    // eslint-disable-next-line no-bitwise
	    return !!(this.compareDocumentPosition(arg) & 16);
	  };
	
	  // Regular Expressions for parsing tags and attributes
	  var SURROGATE_PAIR_REGEXP = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g,
	    // Match everything outside of normal chars and " (quote character)
	    NON_ALPHANUMERIC_REGEXP = /([^#-~ |!])/g;
	
	
	  // Good source of info about elements and attributes
	  // http://dev.w3.org/html5/spec/Overview.html#semantics
	  // http://simon.html5.org/html-elements
	
	  // Safe Void Elements - HTML5
	  // http://dev.w3.org/html5/spec/Overview.html#void-elements
	  var voidElements = stringToMap('area,br,col,hr,img,wbr');
	
	  // Elements that you can, intentionally, leave open (and which close themselves)
	  // http://dev.w3.org/html5/spec/Overview.html#optional-tags
	  var optionalEndTagBlockElements = stringToMap('colgroup,dd,dt,li,p,tbody,td,tfoot,th,thead,tr'),
	      optionalEndTagInlineElements = stringToMap('rp,rt'),
	      optionalEndTagElements = extend({},
	                                              optionalEndTagInlineElements,
	                                              optionalEndTagBlockElements);
	
	  // Safe Block Elements - HTML5
	  var blockElements = extend({}, optionalEndTagBlockElements, stringToMap('address,article,' +
	          'aside,blockquote,caption,center,del,dir,div,dl,figure,figcaption,footer,h1,h2,h3,h4,h5,' +
	          'h6,header,hgroup,hr,ins,map,menu,nav,ol,pre,section,table,ul'));
	
	  // Inline Elements - HTML5
	  var inlineElements = extend({}, optionalEndTagInlineElements, stringToMap('a,abbr,acronym,b,' +
	          'bdi,bdo,big,br,cite,code,del,dfn,em,font,i,img,ins,kbd,label,map,mark,q,ruby,rp,rt,s,' +
	          'samp,small,span,strike,strong,sub,sup,time,tt,u,var'));
	
	  // SVG Elements
	  // https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Elements
	  // Note: the elements animate,animateColor,animateMotion,animateTransform,set are intentionally omitted.
	  // They can potentially allow for arbitrary javascript to be executed. See #11290
	  var svgElements = stringToMap('circle,defs,desc,ellipse,font-face,font-face-name,font-face-src,g,glyph,' +
	          'hkern,image,linearGradient,line,marker,metadata,missing-glyph,mpath,path,polygon,polyline,' +
	          'radialGradient,rect,stop,svg,switch,text,title,tspan');
	
	  // Blocked Elements (will be stripped)
	  var blockedElements = stringToMap('script,style');
	
	  var validElements = extend({},
	                                     voidElements,
	                                     blockElements,
	                                     inlineElements,
	                                     optionalEndTagElements);
	
	  //Attributes that have href and hence need to be sanitized
	  var uriAttrs = stringToMap('background,cite,href,longdesc,src,xlink:href,xml:base');
	
	  var htmlAttrs = stringToMap('abbr,align,alt,axis,bgcolor,border,cellpadding,cellspacing,class,clear,' +
	      'color,cols,colspan,compact,coords,dir,face,headers,height,hreflang,hspace,' +
	      'ismap,lang,language,nohref,nowrap,rel,rev,rows,rowspan,rules,' +
	      'scope,scrolling,shape,size,span,start,summary,tabindex,target,title,type,' +
	      'valign,value,vspace,width');
	
	  // SVG attributes (without "id" and "name" attributes)
	  // https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Attributes
	  var svgAttrs = stringToMap('accent-height,accumulate,additive,alphabetic,arabic-form,ascent,' +
	      'baseProfile,bbox,begin,by,calcMode,cap-height,class,color,color-rendering,content,' +
	      'cx,cy,d,dx,dy,descent,display,dur,end,fill,fill-rule,font-family,font-size,font-stretch,' +
	      'font-style,font-variant,font-weight,from,fx,fy,g1,g2,glyph-name,gradientUnits,hanging,' +
	      'height,horiz-adv-x,horiz-origin-x,ideographic,k,keyPoints,keySplines,keyTimes,lang,' +
	      'marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mathematical,' +
	      'max,min,offset,opacity,orient,origin,overline-position,overline-thickness,panose-1,' +
	      'path,pathLength,points,preserveAspectRatio,r,refX,refY,repeatCount,repeatDur,' +
	      'requiredExtensions,requiredFeatures,restart,rotate,rx,ry,slope,stemh,stemv,stop-color,' +
	      'stop-opacity,strikethrough-position,strikethrough-thickness,stroke,stroke-dasharray,' +
	      'stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,' +
	      'stroke-width,systemLanguage,target,text-anchor,to,transform,type,u1,u2,underline-position,' +
	      'underline-thickness,unicode,unicode-range,units-per-em,values,version,viewBox,visibility,' +
	      'width,widths,x,x-height,x1,x2,xlink:actuate,xlink:arcrole,xlink:role,xlink:show,xlink:title,' +
	      'xlink:type,xml:base,xml:lang,xml:space,xmlns,xmlns:xlink,y,y1,y2,zoomAndPan', true);
	
	  var validAttrs = extend({},
	                                  uriAttrs,
	                                  svgAttrs,
	                                  htmlAttrs);
	
	  function stringToMap(str, lowercaseKeys) {
	    return arrayToMap(str.split(','), lowercaseKeys);
	  }
	
	  function arrayToMap(items, lowercaseKeys) {
	    var obj = {}, i;
	    for (i = 0; i < items.length; i++) {
	      obj[lowercaseKeys ? lowercase(items[i]) : items[i]] = true;
	    }
	    return obj;
	  }
	
	  function addElementsTo(elementsMap, newElements) {
	    if (newElements && newElements.length) {
	      extend(elementsMap, arrayToMap(newElements));
	    }
	  }
	
	  /**
	   * Create an inert document that contains the dirty HTML that needs sanitizing.
	   * We use the DOMParser API by default and fall back to createHTMLDocument if DOMParser is not
	   * available.
	   */
	  var getInertBodyElement /* function(html: string): HTMLBodyElement */ = (function(window, document) {
	    if (isDOMParserAvailable()) {
	      return getInertBodyElement_DOMParser;
	    }
	
	    if (!document || !document.implementation) {
	      throw $sanitizeMinErr('noinert', 'Can\'t create an inert html document');
	    }
	    var inertDocument = document.implementation.createHTMLDocument('inert');
	    var inertBodyElement = (inertDocument.documentElement || inertDocument.getDocumentElement()).querySelector('body');
	    return getInertBodyElement_InertDocument;
	
	    function isDOMParserAvailable() {
	      try {
	        return !!getInertBodyElement_DOMParser('');
	      } catch (e) {
	        return false;
	      }
	    }
	
	    function getInertBodyElement_DOMParser(html) {
	      // We add this dummy element to ensure that the rest of the content is parsed as expected
	      // e.g. leading whitespace is maintained and tags like `<meta>` do not get hoisted to the `<head>` tag.
	      html = '<remove></remove>' + html;
	      try {
	        var body = new window.DOMParser().parseFromString(html, 'text/html').body;
	        body.firstChild.remove();
	        return body;
	      } catch (e) {
	        return undefined;
	      }
	    }
	
	    function getInertBodyElement_InertDocument(html) {
	      inertBodyElement.innerHTML = html;
	
	      // Support: IE 9-11 only
	      // strip custom-namespaced attributes on IE<=11
	      if (document.documentMode) {
	        stripCustomNsAttrs(inertBodyElement);
	      }
	
	      return inertBodyElement;
	    }
	  })(window, window.document);
	
	  /**
	   * @example
	   * htmlParser(htmlString, {
	   *     start: function(tag, attrs) {},
	   *     end: function(tag) {},
	   *     chars: function(text) {},
	   *     comment: function(text) {}
	   * });
	   *
	   * @param {string} html string
	   * @param {object} handler
	   */
	  function htmlParserImpl(html, handler) {
	    if (html === null || html === undefined) {
	      html = '';
	    } else if (typeof html !== 'string') {
	      html = '' + html;
	    }
	
	    var inertBodyElement = getInertBodyElement(html);
	    if (!inertBodyElement) return '';
	
	    //mXSS protection
	    var mXSSAttempts = 5;
	    do {
	      if (mXSSAttempts === 0) {
	        throw $sanitizeMinErr('uinput', 'Failed to sanitize html because the input is unstable');
	      }
	      mXSSAttempts--;
	
	      // trigger mXSS if it is going to happen by reading and writing the innerHTML
	      html = inertBodyElement.innerHTML;
	      inertBodyElement = getInertBodyElement(html);
	    } while (html !== inertBodyElement.innerHTML);
	
	    var node = inertBodyElement.firstChild;
	    while (node) {
	      switch (node.nodeType) {
	        case 1: // ELEMENT_NODE
	          handler.start(node.nodeName.toLowerCase(), attrToMap(node.attributes));
	          break;
	        case 3: // TEXT NODE
	          handler.chars(node.textContent);
	          break;
	      }
	
	      var nextNode;
	      if (!(nextNode = node.firstChild)) {
	        if (node.nodeType === 1) {
	          handler.end(node.nodeName.toLowerCase());
	        }
	        nextNode = getNonDescendant('nextSibling', node);
	        if (!nextNode) {
	          while (nextNode == null) {
	            node = getNonDescendant('parentNode', node);
	            if (node === inertBodyElement) break;
	            nextNode = getNonDescendant('nextSibling', node);
	            if (node.nodeType === 1) {
	              handler.end(node.nodeName.toLowerCase());
	            }
	          }
	        }
	      }
	      node = nextNode;
	    }
	
	    while ((node = inertBodyElement.firstChild)) {
	      inertBodyElement.removeChild(node);
	    }
	  }
	
	  function attrToMap(attrs) {
	    var map = {};
	    for (var i = 0, ii = attrs.length; i < ii; i++) {
	      var attr = attrs[i];
	      map[attr.name] = attr.value;
	    }
	    return map;
	  }
	
	
	  /**
	   * Escapes all potentially dangerous characters, so that the
	   * resulting string can be safely inserted into attribute or
	   * element text.
	   * @param value
	   * @returns {string} escaped text
	   */
	  function encodeEntities(value) {
	    return value.
	      replace(/&/g, '&amp;').
	      replace(SURROGATE_PAIR_REGEXP, function(value) {
	        var hi = value.charCodeAt(0);
	        var low = value.charCodeAt(1);
	        return '&#' + (((hi - 0xD800) * 0x400) + (low - 0xDC00) + 0x10000) + ';';
	      }).
	      replace(NON_ALPHANUMERIC_REGEXP, function(value) {
	        return '&#' + value.charCodeAt(0) + ';';
	      }).
	      replace(/</g, '&lt;').
	      replace(/>/g, '&gt;');
	  }
	
	  /**
	   * create an HTML/XML writer which writes to buffer
	   * @param {Array} buf use buf.join('') to get out sanitized html string
	   * @returns {object} in the form of {
	   *     start: function(tag, attrs) {},
	   *     end: function(tag) {},
	   *     chars: function(text) {},
	   *     comment: function(text) {}
	   * }
	   */
	  function htmlSanitizeWriterImpl(buf, uriValidator) {
	    var ignoreCurrentElement = false;
	    var out = bind(buf, buf.push);
	    return {
	      start: function(tag, attrs) {
	        tag = lowercase(tag);
	        if (!ignoreCurrentElement && blockedElements[tag]) {
	          ignoreCurrentElement = tag;
	        }
	        if (!ignoreCurrentElement && validElements[tag] === true) {
	          out('<');
	          out(tag);
	          forEach(attrs, function(value, key) {
	            var lkey = lowercase(key);
	            var isImage = (tag === 'img' && lkey === 'src') || (lkey === 'background');
	            if (validAttrs[lkey] === true &&
	              (uriAttrs[lkey] !== true || uriValidator(value, isImage))) {
	              out(' ');
	              out(key);
	              out('="');
	              out(encodeEntities(value));
	              out('"');
	            }
	          });
	          out('>');
	        }
	      },
	      end: function(tag) {
	        tag = lowercase(tag);
	        if (!ignoreCurrentElement && validElements[tag] === true && voidElements[tag] !== true) {
	          out('</');
	          out(tag);
	          out('>');
	        }
	        // eslint-disable-next-line eqeqeq
	        if (tag == ignoreCurrentElement) {
	          ignoreCurrentElement = false;
	        }
	      },
	      chars: function(chars) {
	        if (!ignoreCurrentElement) {
	          out(encodeEntities(chars));
	        }
	      }
	    };
	  }
	
	
	  /**
	   * When IE9-11 comes across an unknown namespaced attribute e.g. 'xlink:foo' it adds 'xmlns:ns1' attribute to declare
	   * ns1 namespace and prefixes the attribute with 'ns1' (e.g. 'ns1:xlink:foo'). This is undesirable since we don't want
	   * to allow any of these custom attributes. This method strips them all.
	   *
	   * @param node Root element to process
	   */
	  function stripCustomNsAttrs(node) {
	    while (node) {
	      if (node.nodeType === window.Node.ELEMENT_NODE) {
	        var attrs = node.attributes;
	        for (var i = 0, l = attrs.length; i < l; i++) {
	          var attrNode = attrs[i];
	          var attrName = attrNode.name.toLowerCase();
	          if (attrName === 'xmlns:ns1' || attrName.lastIndexOf('ns1:', 0) === 0) {
	            node.removeAttributeNode(attrNode);
	            i--;
	            l--;
	          }
	        }
	      }
	
	      var nextNode = node.firstChild;
	      if (nextNode) {
	        stripCustomNsAttrs(nextNode);
	      }
	
	      node = getNonDescendant('nextSibling', node);
	    }
	  }
	
	  function getNonDescendant(propName, node) {
	    // An element is clobbered if its `propName` property points to one of its descendants
	    var nextNode = node[propName];
	    if (nextNode && nodeContains.call(node, nextNode)) {
	      throw $sanitizeMinErr('elclob', 'Failed to sanitize html because the element is clobbered: {0}', node.outerHTML || node.outerText);
	    }
	    return nextNode;
	  }
	}
	
	function sanitizeText(chars) {
	  var buf = [];
	  var writer = htmlSanitizeWriter(buf, noop);
	  writer.chars(chars);
	  return buf.join('');
	}
	
	
	// define ngSanitize module and register $sanitize service
	angular.module('ngSanitize', [])
	  .provider('$sanitize', $SanitizeProvider)
	  .info({ angularVersion: '1.8.3' });
	
	/**
	 * @ngdoc filter
	 * @name linky
	 * @kind function
	 *
	 * @description
	 * Finds links in text input and turns them into html links. Supports `http/https/ftp/sftp/mailto` and
	 * plain email address links.
	 *
	 * Requires the {@link ngSanitize `ngSanitize`} module to be installed.
	 *
	 * @param {string} text Input text.
	 * @param {string} [target] Window (`_blank|_self|_parent|_top`) or named frame to open links in.
	 * @param {object|function(url)} [attributes] Add custom attributes to the link element.
	 *
	 *    Can be one of:
	 *
	 *    - `object`: A map of attributes
	 *    - `function`: Takes the url as a parameter and returns a map of attributes
	 *
	 *    If the map of attributes contains a value for `target`, it overrides the value of
	 *    the target parameter.
	 *
	 *
	 * @returns {string} Html-linkified and {@link $sanitize sanitized} text.
	 *
	 * @usage
	   <span ng-bind-html="linky_expression | linky"></span>
	 *
	 * @example
	   <example module="linkyExample" deps="angular-sanitize.js" name="linky-filter">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	       Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
	       <table>
	         <tr>
	           <th>Filter</th>
	           <th>Source</th>
	           <th>Rendered</th>
	         </tr>
	         <tr id="linky-filter">
	           <td>linky filter</td>
	           <td>
	             <pre>&lt;div ng-bind-html="snippet | linky"&gt;<br>&lt;/div&gt;</pre>
	           </td>
	           <td>
	             <div ng-bind-html="snippet | linky"></div>
	           </td>
	         </tr>
	         <tr id="linky-target">
	          <td>linky target</td>
	          <td>
	            <pre>&lt;div ng-bind-html="snippetWithSingleURL | linky:'_blank'"&gt;<br>&lt;/div&gt;</pre>
	          </td>
	          <td>
	            <div ng-bind-html="snippetWithSingleURL | linky:'_blank'"></div>
	          </td>
	         </tr>
	         <tr id="linky-custom-attributes">
	          <td>linky custom attributes</td>
	          <td>
	            <pre>&lt;div ng-bind-html="snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}"&gt;<br>&lt;/div&gt;</pre>
	          </td>
	          <td>
	            <div ng-bind-html="snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}"></div>
	          </td>
	         </tr>
	         <tr id="escaped-html">
	           <td>no filter</td>
	           <td><pre>&lt;div ng-bind="snippet"&gt;<br>&lt;/div&gt;</pre></td>
	           <td><div ng-bind="snippet"></div></td>
	         </tr>
	       </table>
	     </file>
	     <file name="script.js">
	       angular.module('linkyExample', ['ngSanitize'])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.snippet =
	             'Pretty text with some links:\n' +
	             'http://angularjs.org/,\n' +
	             'mailto:us@somewhere.org,\n' +
	             'another@somewhere.org,\n' +
	             'and one more: ftp://127.0.0.1/.';
	           $scope.snippetWithSingleURL = 'http://angularjs.org/';
	         }]);
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should linkify the snippet with urls', function() {
	         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
	             toBe('Pretty text with some links: http://angularjs.org/, us@somewhere.org, ' +
	                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
	         expect(element.all(by.css('#linky-filter a')).count()).toEqual(4);
	       });
	
	       it('should not linkify snippet without the linky filter', function() {
	         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText()).
	             toBe('Pretty text with some links: http://angularjs.org/, mailto:us@somewhere.org, ' +
	                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
	         expect(element.all(by.css('#escaped-html a')).count()).toEqual(0);
	       });
	
	       it('should update', function() {
	         element(by.model('snippet')).clear();
	         element(by.model('snippet')).sendKeys('new http://link.');
	         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
	             toBe('new http://link.');
	         expect(element.all(by.css('#linky-filter a')).count()).toEqual(1);
	         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText())
	             .toBe('new http://link.');
	       });
	
	       it('should work with the target property', function() {
	        expect(element(by.id('linky-target')).
	            element(by.binding("snippetWithSingleURL | linky:'_blank'")).getText()).
	            toBe('http://angularjs.org/');
	        expect(element(by.css('#linky-target a')).getAttribute('target')).toEqual('_blank');
	       });
	
	       it('should optionally add custom attributes', function() {
	        expect(element(by.id('linky-custom-attributes')).
	            element(by.binding("snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}")).getText()).
	            toBe('http://angularjs.org/');
	        expect(element(by.css('#linky-custom-attributes a')).getAttribute('rel')).toEqual('nofollow');
	       });
	     </file>
	   </example>
	 */
	angular.module('ngSanitize').filter('linky', ['$sanitize', function($sanitize) {
	  var LINKY_URL_REGEXP =
	        /((s?ftp|https?):\/\/|(www\.)|(mailto:)?[A-Za-z0-9._%+-]+@)\S*[^\s.;,(){}<>"\u201d\u2019]/i,
	      MAILTO_REGEXP = /^mailto:/i;
	
	  var linkyMinErr = angular.$$minErr('linky');
	  var isDefined = angular.isDefined;
	  var isFunction = angular.isFunction;
	  var isObject = angular.isObject;
	  var isString = angular.isString;
	
	  return function(text, target, attributes) {
	    if (text == null || text === '') return text;
	    if (!isString(text)) throw linkyMinErr('notstring', 'Expected string but received: {0}', text);
	
	    var attributesFn =
	      isFunction(attributes) ? attributes :
	      isObject(attributes) ? function getAttributesObject() {return attributes;} :
	      function getEmptyAttributesObject() {return {};};
	
	    var match;
	    var raw = text;
	    var html = [];
	    var url;
	    var i;
	    while ((match = raw.match(LINKY_URL_REGEXP))) {
	      // We can not end in these as they are sometimes found at the end of the sentence
	      url = match[0];
	      // if we did not match ftp/http/www/mailto then assume mailto
	      if (!match[2] && !match[4]) {
	        url = (match[3] ? 'http://' : 'mailto:') + url;
	      }
	      i = match.index;
	      addText(raw.substr(0, i));
	      addLink(url, match[0].replace(MAILTO_REGEXP, ''));
	      raw = raw.substring(i + match[0].length);
	    }
	    addText(raw);
	    return $sanitize(html.join(''));
	
	    function addText(text) {
	      if (!text) {
	        return;
	      }
	      html.push(sanitizeText(text));
	    }
	
	    function addLink(url, text) {
	      var key, linkAttributes = attributesFn(url);
	      html.push('<a ');
	
	      for (key in linkAttributes) {
	        html.push(key + '="' + linkAttributes[key] + '" ');
	      }
	
	      if (isDefined(target) && !('target' in linkAttributes)) {
	        html.push('target="',
	                  target,
	                  '" ');
	      }
	      html.push('href="',
	                url.replace(/"/g, '&quot;'),
	                '">');
	      addText(text);
	      html.push('</a>');
	    }
	  };
	}]);
	
	
	})(window, window.angular);


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(128);
	module.exports = 'ngSanitize';


/***/ }),
/* 130 */
/***/ (function(module, exports) {

	'use strict';
	angular.module('angular-timeline', []);// Source: src/timeline-badge-directive.js
	/**
	 * @ngdoc directive
	 * @name angular-timeline.directive:timeline-badge
	 * @restrict AE
	 *
	 * @description
	 * Shown in the centre pane (or left on narrow devices) to indicate the activity.
	 */
	angular.module('angular-timeline').directive('timelineBadge', function() {
	  return {
	    require: '^timelineEvent',
	    restrict: 'AE',
	    transclude: true,
	    template: '<div class="timeline-badge" ng-transclude></div>'
	  };
	});
	
	// Source: src/timeline-directive.js
	/**
	 * @ngdoc directive
	 * @name angular-timeline
	 * @restrict AE
	 *
	 * @description
	 * Primary container for displaying a vertical set of timeline events.
	 */
	angular.module('angular-timeline').directive('timeline', function() {
	  return {
	    restrict: 'AE',
	    transclude: true,
	    template: '<ul class="timeline" ng-transclude></ul>',
	    controller: function() {}
	  };
	});
	
	// Source: src/timeline-event-directive.js
	/**
	 * @ngdoc directive
	 * @name angular-timeline.directive:timeline
	 * @restrict AE
	 *
	 * @description
	 * Represents an event occuring at a point in time, displayed on the left or the right
	 * of the timeline line.
	 *
	 * You typically embed a `timeline-badge` and `timeline-panel` element within a `timeline-event`.
	 *
	 * @param {string=} side  Define the side of the element (i.e. side="left", side="right", or use an {{ expression }}).
	 */
	
	angular.module('angular-timeline').directive('timelineEvent', function() {
	  return {
	    require: '^timeline',
	    restrict: 'AE',
	    transclude: true,
	    template: '<li class="timeline-event" ng-class-odd="oddClass" ng-class-even="evenClass" ng-transclude></li>',
	    link: function(scope, element, attrs, controller) {
	
	      var checkClass = function(side, leftSide) {
	
	        var leftClass = '';
	        var rightClass = 'timeline-inverted';
	
	        if (side === 'left' || (!side && leftSide === true)) {
	          return leftClass;
	        }
	        else if ((side === 'alternate' || !side) && leftSide === false) {
	          return rightClass;
	        }
	        else if (side === 'right') {
	          return rightClass;
	        }
	        else {
	          return leftClass;
	        }
	      };
	
	      var updateRowClasses = function(value) {
	        scope.oddClass = checkClass(value, true);
	        scope.evenClass = checkClass(value, false);
	      };
	
	      attrs.$observe('side', function(newValue) {
	        updateRowClasses(newValue);
	      });
	
	      updateRowClasses(attrs.side);
	    }
	  };
	});
	
	// Source: src/timeline-footer-directive.js
	/**
	 * @ngdoc directive
	 * @name angular-timeline.directive:timeline-footer
	 * @restrict AE
	 *
	 * @description
	 * Optional element to add a footer section to the `timeline-panel` for links or other actions.
	 */
	angular.module('angular-timeline').directive('timelineFooter', function() {
	  return {
	    require: '^timelinePanel',
	    restrict: 'AE',
	    transclude: true,
	    template: '<div class="timeline-footer" ng-transclude></div>'
	  };
	});
	
	// Source: src/timeline-heading-directive.js
	/**
	 * @ngdoc directive
	 * @name angular-timeline.directive:timeline-heading
	 * @restrict AE
	 *
	 * @description
	 * Optional element to show the heading for a `timeline-panel`.
	 */
	angular.module('angular-timeline').directive('timelineHeading', function() {
	  return {
	    require: '^timelinePanel',
	    restrict: 'AE',
	    transclude: true,
	    template: '<div class="timeline-heading" ng-transclude></div>'
	  };
	});
	
	// Source: src/timeline-panel-directive.js
	/**
	 * @ngdoc directive
	 * @name angular-timeline.directive:timeline-panel
	 * @restrict AE
	 *
	 * @description
	 * An panel inside the `timeline-event` which shows detailed information about the event.
	 */
	angular.module('angular-timeline').directive('timelinePanel', function() {
	  return {
	    require: '^timeline',
	    restrict: 'AE',
	    transclude: true,
	    template: '<div class="timeline-panel" ng-transclude></div>'
	  };
	});


/***/ }),
/* 131 */
/***/ (function(module, exports) {

	(function() {
	  'use strict';
	
	  angular.module('toastr', [])
	    .factory('toastr', toastr);
	
	  toastr.$inject = ['$animate', '$injector', '$document', '$rootScope', '$sce', 'toastrConfig', '$q'];
	
	  function toastr($animate, $injector, $document, $rootScope, $sce, toastrConfig, $q) {
	    var container;
	    var index = 0;
	    var toasts = [];
	
	    var previousToastMessage = '';
	    var openToasts = {};
	
	    var containerDefer = $q.defer();
	
	    var toast = {
	      active: active,
	      clear: clear,
	      error: error,
	      info: info,
	      remove: remove,
	      success: success,
	      warning: warning,
	      refreshTimer: refreshTimer
	    };
	
	    return toast;
	
	    /* Public API */
	    function active() {
	      return toasts.length;
	    }
	
	    function clear(toast) {
	      // Bit of a hack, I will remove this soon with a BC
	      if (arguments.length === 1 && !toast) { return; }
	
	      if (toast) {
	        remove(toast.toastId);
	      } else {
	        for (var i = 0; i < toasts.length; i++) {
	          remove(toasts[i].toastId);
	        }
	      }
	    }
	
	    function error(message, title, optionsOverride) {
	      var type = _getOptions().iconClasses.error;
	      return _buildNotification(type, message, title, optionsOverride);
	    }
	
	    function info(message, title, optionsOverride) {
	      var type = _getOptions().iconClasses.info;
	      return _buildNotification(type, message, title, optionsOverride);
	    }
	
	    function success(message, title, optionsOverride) {
	      var type = _getOptions().iconClasses.success;
	      return _buildNotification(type, message, title, optionsOverride);
	    }
	
	    function warning(message, title, optionsOverride) {
	      var type = _getOptions().iconClasses.warning;
	      return _buildNotification(type, message, title, optionsOverride);
	    }
	
	    function refreshTimer(toast, newTime) {
	      if (toast && toast.isOpened && toasts.indexOf(toast) >= 0) {
	          toast.scope.refreshTimer(newTime);
	      }
	    }
	
	    function remove(toastId, wasClicked) {
	      var toast = findToast(toastId);
	
	      if (toast && ! toast.deleting) { // Avoid clicking when fading out
	        toast.deleting = true;
	        toast.isOpened = false;
	        $animate.leave(toast.el).then(function() {
	          if (toast.scope.options.onHidden) {
	            toast.scope.options.onHidden(!!wasClicked, toast);
	          }
	          toast.scope.$destroy();
	          var index = toasts.indexOf(toast);
	          delete openToasts[toast.scope.message];
	          toasts.splice(index, 1);
	          var maxOpened = toastrConfig.maxOpened;
	          if (maxOpened && toasts.length >= maxOpened) {
	            toasts[maxOpened - 1].open.resolve();
	          }
	          if (lastToast()) {
	            container.remove();
	            container = null;
	            containerDefer = $q.defer();
	          }
	        });
	      }
	
	      function findToast(toastId) {
	        for (var i = 0; i < toasts.length; i++) {
	          if (toasts[i].toastId === toastId) {
	            return toasts[i];
	          }
	        }
	      }
	
	      function lastToast() {
	        return !toasts.length;
	      }
	    }
	
	    /* Internal functions */
	    function _buildNotification(type, message, title, optionsOverride) {
	      if (angular.isObject(title)) {
	        optionsOverride = title;
	        title = null;
	      }
	
	      return _notify({
	        iconClass: type,
	        message: message,
	        optionsOverride: optionsOverride,
	        title: title
	      });
	    }
	
	    function _getOptions() {
	      return angular.extend({}, toastrConfig);
	    }
	
	    function _createOrGetContainer(options) {
	      if(container) { return containerDefer.promise; }
	
	      container = angular.element('<div></div>');
	      container.attr('id', options.containerId);
	      container.addClass(options.positionClass);
	      container.css({'pointer-events': 'auto'});
	
	      var target = angular.element(document.querySelector(options.target));
	
	      if ( ! target || ! target.length) {
	        throw 'Target for toasts doesn\'t exist';
	      }
	
	      $animate.enter(container, target).then(function() {
	        containerDefer.resolve();
	      });
	
	      return containerDefer.promise;
	    }
	
	    function _notify(map) {
	      var options = _getOptions();
	
	      if (shouldExit()) { return; }
	
	      var newToast = createToast();
	
	      toasts.push(newToast);
	
	      if (ifMaxOpenedAndAutoDismiss()) {
	        var oldToasts = toasts.slice(0, (toasts.length - options.maxOpened));
	        for (var i = 0, len = oldToasts.length; i < len; i++) {
	          remove(oldToasts[i].toastId);
	        }
	      }
	
	      if (maxOpenedNotReached()) {
	        newToast.open.resolve();
	      }
	
	      newToast.open.promise.then(function() {
	        _createOrGetContainer(options).then(function() {
	          newToast.isOpened = true;
	          if (options.newestOnTop) {
	            $animate.enter(newToast.el, container).then(function() {
	              newToast.scope.init();
	            });
	          } else {
	            var sibling = container[0].lastChild ? angular.element(container[0].lastChild) : null;
	            $animate.enter(newToast.el, container, sibling).then(function() {
	              newToast.scope.init();
	            });
	          }
	        });
	      });
	
	      return newToast;
	
	      function ifMaxOpenedAndAutoDismiss() {
	        return options.autoDismiss && options.maxOpened && toasts.length > options.maxOpened;
	      }
	
	      function createScope(toast, map, options) {
	        if (options.allowHtml) {
	          toast.scope.allowHtml = true;
	          toast.scope.title = $sce.trustAsHtml(map.title);
	          toast.scope.message = $sce.trustAsHtml(map.message);
	        } else {
	          toast.scope.title = map.title;
	          toast.scope.message = map.message;
	        }
	
	        toast.scope.toastType = toast.iconClass;
	        toast.scope.toastId = toast.toastId;
	        toast.scope.extraData = options.extraData;
	
	        toast.scope.options = {
	          extendedTimeOut: options.extendedTimeOut,
	          messageClass: options.messageClass,
	          onHidden: options.onHidden,
	          onShown: generateEvent('onShown'),
	          onTap: generateEvent('onTap'),
	          progressBar: options.progressBar,
	          tapToDismiss: options.tapToDismiss,
	          timeOut: options.timeOut,
	          titleClass: options.titleClass,
	          toastClass: options.toastClass
	        };
	
	        if (options.closeButton) {
	          toast.scope.options.closeHtml = options.closeHtml;
	        }
	
	        function generateEvent(event) {
	          if (options[event]) {
	            return function() {
	              options[event](toast);
	            };
	          }
	        }
	      }
	
	      function createToast() {
	        var newToast = {
	          toastId: index++,
	          isOpened: false,
	          scope: $rootScope.$new(),
	          open: $q.defer()
	        };
	        newToast.iconClass = map.iconClass;
	        if (map.optionsOverride) {
	          angular.extend(options, cleanOptionsOverride(map.optionsOverride));
	          newToast.iconClass = map.optionsOverride.iconClass || newToast.iconClass;
	        }
	
	        createScope(newToast, map, options);
	
	        newToast.el = createToastEl(newToast.scope);
	
	        return newToast;
	
	        function cleanOptionsOverride(options) {
	          var badOptions = ['containerId', 'iconClasses', 'maxOpened', 'newestOnTop',
	                            'positionClass', 'preventDuplicates', 'preventOpenDuplicates', 'templates'];
	          for (var i = 0, l = badOptions.length; i < l; i++) {
	            delete options[badOptions[i]];
	          }
	
	          return options;
	        }
	      }
	
	      function createToastEl(scope) {
	        var angularDomEl = angular.element('<div toast></div>'),
	          $compile = $injector.get('$compile');
	        return $compile(angularDomEl)(scope);
	      }
	
	      function maxOpenedNotReached() {
	        return options.maxOpened && toasts.length <= options.maxOpened || !options.maxOpened;
	      }
	
	      function shouldExit() {
	        var isDuplicateOfLast = options.preventDuplicates && map.message === previousToastMessage;
	        var isDuplicateOpen = options.preventOpenDuplicates && openToasts[map.message];
	
	        if (isDuplicateOfLast || isDuplicateOpen) {
	          return true;
	        }
	
	        previousToastMessage = map.message;
	        openToasts[map.message] = true;
	
	        return false;
	      }
	    }
	  }
	}());
	
	(function() {
	  'use strict';
	
	  angular.module('toastr')
	    .constant('toastrConfig', {
	      allowHtml: false,
	      autoDismiss: false,
	      closeButton: false,
	      closeHtml: '<button>&times;</button>',
	      containerId: 'toast-container',
	      extendedTimeOut: 1000,
	      iconClasses: {
	        error: 'toast-error',
	        info: 'toast-info',
	        success: 'toast-success',
	        warning: 'toast-warning'
	      },
	      maxOpened: 0,
	      messageClass: 'toast-message',
	      newestOnTop: true,
	      onHidden: null,
	      onShown: null,
	      onTap: null,
	      positionClass: 'toast-top-right',
	      preventDuplicates: false,
	      preventOpenDuplicates: false,
	      progressBar: false,
	      tapToDismiss: true,
	      target: 'body',
	      templates: {
	        toast: 'directives/toast/toast.html',
	        progressbar: 'directives/progressbar/progressbar.html'
	      },
	      timeOut: 5000,
	      titleClass: 'toast-title',
	      toastClass: 'toast'
	    });
	}());
	
	(function() {
	  'use strict';
	
	  angular.module('toastr')
	    .directive('progressBar', progressBar);
	
	  progressBar.$inject = ['toastrConfig'];
	
	  function progressBar(toastrConfig) {
	    return {
	      require: '^toast',
	      templateUrl: function() {
	        return toastrConfig.templates.progressbar;
	      },
	      link: linkFunction
	    };
	
	    function linkFunction(scope, element, attrs, toastCtrl) {
	      var intervalId, currentTimeOut, hideTime;
	
	      toastCtrl.progressBar = scope;
	
	      scope.start = function(duration) {
	        if (intervalId) {
	          clearInterval(intervalId);
	        }
	
	        currentTimeOut = parseFloat(duration);
	        hideTime = new Date().getTime() + currentTimeOut;
	        intervalId = setInterval(updateProgress, 10);
	      };
	
	      scope.stop = function() {
	        if (intervalId) {
	          clearInterval(intervalId);
	        }
	      };
	
	      function updateProgress() {
	        var percentage = ((hideTime - (new Date().getTime())) / currentTimeOut) * 100;
	        element.css('width', percentage + '%');
	      }
	
	      scope.$on('$destroy', function() {
	        // Failsafe stop
	        clearInterval(intervalId);
	      });
	    }
	  }
	}());
	
	(function() {
	  'use strict';
	
	  angular.module('toastr')
	    .controller('ToastController', ToastController);
	
	  function ToastController() {
	    this.progressBar = null;
	
	    this.startProgressBar = function(duration) {
	      if (this.progressBar) {
	        this.progressBar.start(duration);
	      }
	    };
	
	    this.stopProgressBar = function() {
	      if (this.progressBar) {
	        this.progressBar.stop();
	      }
	    };
	  }
	}());
	
	(function() {
	  'use strict';
	
	  angular.module('toastr')
	    .directive('toast', toast);
	
	  toast.$inject = ['$injector', '$interval', 'toastrConfig', 'toastr'];
	
	  function toast($injector, $interval, toastrConfig, toastr) {
	    return {
	      templateUrl: function() {
	        return toastrConfig.templates.toast;
	      },
	      controller: 'ToastController',
	      link: toastLinkFunction
	    };
	
	    function toastLinkFunction(scope, element, attrs, toastCtrl) {
	      var timeout;
	
	      scope.toastClass = scope.options.toastClass;
	      scope.titleClass = scope.options.titleClass;
	      scope.messageClass = scope.options.messageClass;
	      scope.progressBar = scope.options.progressBar;
	
	      if (wantsCloseButton()) {
	        var button = angular.element(scope.options.closeHtml),
	          $compile = $injector.get('$compile');
	        button.addClass('toast-close-button');
	        button.attr('ng-click', 'close(true, $event)');
	        $compile(button)(scope);
	        element.children().prepend(button);
	      }
	
	      scope.init = function() {
	        if (scope.options.timeOut) {
	          timeout = createTimeout(scope.options.timeOut);
	        }
	        if (scope.options.onShown) {
	          scope.options.onShown();
	        }
	      };
	
	      element.on('mouseenter', function() {
	        hideAndStopProgressBar();
	        if (timeout) {
	          $interval.cancel(timeout);
	        }
	      });
	
	      scope.tapToast = function () {
	        if (angular.isFunction(scope.options.onTap)) {
	          scope.options.onTap();
	        }
	        if (scope.options.tapToDismiss) {
	          scope.close(true);
	        }
	      };
	
	      scope.close = function (wasClicked, $event) {
	        if ($event && angular.isFunction($event.stopPropagation)) {
	          $event.stopPropagation();
	        }
	        toastr.remove(scope.toastId, wasClicked);
	      };
	      
	      scope.refreshTimer = function(newTime) {
	        if (timeout) {
	          $interval.cancel(timeout);
	          timeout = createTimeout(newTime || scope.options.timeOut);
	        }
	      };
	
	      element.on('mouseleave', function() {
	        if (scope.options.timeOut === 0 && scope.options.extendedTimeOut === 0) { return; }
	        scope.$apply(function() {
	          scope.progressBar = scope.options.progressBar;
	        });
	        timeout = createTimeout(scope.options.extendedTimeOut);
	      });
	
	      function createTimeout(time) {
	        toastCtrl.startProgressBar(time);
	        return $interval(function() {
	          toastCtrl.stopProgressBar();
	          toastr.remove(scope.toastId);
	        }, time, 1);
	      }
	
	      function hideAndStopProgressBar() {
	        scope.progressBar = false;
	        toastCtrl.stopProgressBar();
	      }
	
	      function wantsCloseButton() {
	        return scope.options.closeHtml;
	      }
	    }
	  }
	}());
	
	angular.module("toastr").run(["$templateCache", function($templateCache) {$templateCache.put("directives/progressbar/progressbar.html","<div class=\"toast-progress\"></div>\n");
	$templateCache.put("directives/toast/toast.html","<div class=\"{{toastClass}} {{toastType}}\" ng-click=\"tapToast()\">\n  <div ng-switch on=\"allowHtml\">\n    <div ng-switch-default ng-if=\"title\" class=\"{{titleClass}}\" aria-label=\"{{title}}\">{{title}}</div>\n    <div ng-switch-default class=\"{{messageClass}}\" aria-label=\"{{message}}\">{{message}}</div>\n    <div ng-switch-when=\"true\" ng-if=\"title\" class=\"{{titleClass}}\" ng-bind-html=\"title\"></div>\n    <div ng-switch-when=\"true\" class=\"{{messageClass}}\" ng-bind-html=\"message\"></div>\n  </div>\n  <progress-bar ng-if=\"progressBar\"></progress-bar>\n</div>\n");}]);

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(131);
	module.exports = 'toastr';
	


/***/ }),
/* 133 */
/***/ (function(module, exports) {

	/*!
	 * angular-ui-mask
	 * https://github.com/angular-ui/ui-mask
	 * Version: 1.8.7 - 2016-07-26T16:01:23.393Z
	 * License: MIT
	 */
	
	
	(function () { 
	'use strict';
	/*
	 Attaches input mask onto input element
	 */
	angular.module('ui.mask', [])
	        .value('uiMaskConfig', {
	            maskDefinitions: {
	                '9': /\d/,
	                'A': /[a-zA-Z]/,
	                '*': /[a-zA-Z0-9]/
	            },
	            clearOnBlur: true,
	            clearOnBlurPlaceholder: false,
	            escChar: '\\',
	            eventsToHandle: ['input', 'keyup', 'click', 'focus'],
	            addDefaultPlaceholder: true,
	            allowInvalidValue: false
	        })
	        .provider('uiMask.Config', function() {
	            var options = {};
	
	            this.maskDefinitions = function(maskDefinitions) {
	                return options.maskDefinitions = maskDefinitions;
	            };
	            this.clearOnBlur = function(clearOnBlur) {
	                return options.clearOnBlur = clearOnBlur;
	            };
	            this.clearOnBlurPlaceholder = function(clearOnBlurPlaceholder) {
	                return options.clearOnBlurPlaceholder = clearOnBlurPlaceholder;
	            };
	            this.eventsToHandle = function(eventsToHandle) {
	                return options.eventsToHandle = eventsToHandle;
	            };
	            this.addDefaultPlaceholder = function(addDefaultPlaceholder) {
	                return options.addDefaultPlaceholder = addDefaultPlaceholder;
	            };
	            this.allowInvalidValue = function(allowInvalidValue) {
	                return options.allowInvalidValue = allowInvalidValue;
	            };
	            this.$get = ['uiMaskConfig', function(uiMaskConfig) {
	                var tempOptions = uiMaskConfig;
	                for(var prop in options) {
	                    if (angular.isObject(options[prop]) && !angular.isArray(options[prop])) {
	                        angular.extend(tempOptions[prop], options[prop]);
	                    } else {
	                        tempOptions[prop] = options[prop];
	                    }
	                }
	
	                return tempOptions;
	            }];
	        })
	        .directive('uiMask', ['uiMask.Config', function(maskConfig) {
	                function isFocused (elem) {
	                  return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
	                }
	
	                return {
	                    priority: 100,
	                    require: 'ngModel',
	                    restrict: 'A',
	                    compile: function uiMaskCompilingFunction() {
	                        var options = angular.copy(maskConfig);
	
	                        return function uiMaskLinkingFunction(scope, iElement, iAttrs, controller) {
	                            var maskProcessed = false, eventsBound = false,
	                                    maskCaretMap, maskPatterns, maskPlaceholder, maskComponents,
	                                    // Minimum required length of the value to be considered valid
	                                    minRequiredLength,
	                                    value, valueMasked, isValid,
	                                    // Vars for initializing/uninitializing
	                                    originalPlaceholder = iAttrs.placeholder,
	                                    originalMaxlength = iAttrs.maxlength,
	                                    // Vars used exclusively in eventHandler()
	                                    oldValue, oldValueUnmasked, oldCaretPosition, oldSelectionLength,
	                                    // Used for communicating if a backspace operation should be allowed between
	                                    // keydownHandler and eventHandler
	                                    preventBackspace;
	
	                            var originalIsEmpty = controller.$isEmpty;
	                            controller.$isEmpty = function(value) {
	                                if (maskProcessed) {
	                                    return originalIsEmpty(unmaskValue(value || ''));
	                                } else {
	                                    return originalIsEmpty(value);
	                                }
	                            };
	
	                            function initialize(maskAttr) {
	                                if (!angular.isDefined(maskAttr)) {
	                                    return uninitialize();
	                                }
	                                processRawMask(maskAttr);
	                                if (!maskProcessed) {
	                                    return uninitialize();
	                                }
	                                initializeElement();
	                                bindEventListeners();
	                                return true;
	                            }
	
	                            function initPlaceholder(placeholderAttr) {
	                                if ( ! placeholderAttr) {
	                                    return;
	                                }
	
	                                maskPlaceholder = placeholderAttr;
	
	                                // If the mask is processed, then we need to update the value
	                                // but don't set the value if there is nothing entered into the element
	                                // and there is a placeholder attribute on the element because that
	                                // will only set the value as the blank maskPlaceholder
	                                // and override the placeholder on the element
	                                if (maskProcessed && !(iElement.val().length === 0 && angular.isDefined(iAttrs.placeholder))) {
	                                    iElement.val(maskValue(unmaskValue(iElement.val())));
	                                }
	                            }
	
	                            function initPlaceholderChar() {
	                                return initialize(iAttrs.uiMask);
	                            }
	
	                            var modelViewValue = false;
	                            iAttrs.$observe('modelViewValue', function(val) {
	                                if (val === 'true') {
	                                    modelViewValue = true;
	                                }
	                            });
	
	                            iAttrs.$observe('allowInvalidValue', function(val) {
	                                linkOptions.allowInvalidValue = val === ''
	                                    ? true
	                                    : !!val;
	                                formatter(controller.$modelValue);
	                            });
	
	                            function formatter(fromModelValue) {
	                                if (!maskProcessed) {
	                                    return fromModelValue;
	                                }
	                                value = unmaskValue(fromModelValue || '');
	                                isValid = validateValue(value);
	                                controller.$setValidity('mask', isValid);
	
	                                if (!value.length) return undefined;
	                                if (isValid || linkOptions.allowInvalidValue) {
	                                    return maskValue(value);
	                                } else {
	                                    return undefined;
	                                }
	                            }
	
	                            function parser(fromViewValue) {
	                                if (!maskProcessed) {
	                                    return fromViewValue;
	                                }
	                                value = unmaskValue(fromViewValue || '');
	                                isValid = validateValue(value);
	                                // We have to set viewValue manually as the reformatting of the input
	                                // value performed by eventHandler() doesn't happen until after
	                                // this parser is called, which causes what the user sees in the input
	                                // to be out-of-sync with what the controller's $viewValue is set to.
	                                controller.$viewValue = value.length ? maskValue(value) : '';
	                                controller.$setValidity('mask', isValid);
	
	                                if (isValid || linkOptions.allowInvalidValue) {
	                                    return modelViewValue ? controller.$viewValue : value;
	                                }
	                            }
	
	                            var linkOptions = {};
	
	                            if (iAttrs.uiOptions) {
	                                linkOptions = scope.$eval('[' + iAttrs.uiOptions + ']');
	                                if (angular.isObject(linkOptions[0])) {
	                                    // we can't use angular.copy nor angular.extend, they lack the power to do a deep merge
	                                    linkOptions = (function(original, current) {
	                                        for (var i in original) {
	                                            if (Object.prototype.hasOwnProperty.call(original, i)) {
	                                                if (current[i] === undefined) {
	                                                    current[i] = angular.copy(original[i]);
	                                                } else {
	                                                    if (angular.isObject(current[i]) && !angular.isArray(current[i])) {
	                                                        current[i] = angular.extend({}, original[i], current[i]);
	                                                    }
	                                                }
	                                            }
	                                        }
	                                        return current;
	                                    })(options, linkOptions[0]);
	                                } else {
	                                    linkOptions = options;  //gotta be a better way to do this..
	                                }
	                            } else {
	                                linkOptions = options;
	                            }
	
	                            iAttrs.$observe('uiMask', initialize);
	                            if (angular.isDefined(iAttrs.uiMaskPlaceholder)) {
	                                iAttrs.$observe('uiMaskPlaceholder', initPlaceholder);
	                            }
	                            else {
	                                iAttrs.$observe('placeholder', initPlaceholder);
	                            }
	                            if (angular.isDefined(iAttrs.uiMaskPlaceholderChar)) {
	                                iAttrs.$observe('uiMaskPlaceholderChar', initPlaceholderChar);
	                            }
	
	                            controller.$formatters.unshift(formatter);
	                            controller.$parsers.unshift(parser);
	
	                            function uninitialize() {
	                                maskProcessed = false;
	                                unbindEventListeners();
	
	                                if (angular.isDefined(originalPlaceholder)) {
	                                    iElement.attr('placeholder', originalPlaceholder);
	                                } else {
	                                    iElement.removeAttr('placeholder');
	                                }
	
	                                if (angular.isDefined(originalMaxlength)) {
	                                    iElement.attr('maxlength', originalMaxlength);
	                                } else {
	                                    iElement.removeAttr('maxlength');
	                                }
	
	                                iElement.val(controller.$modelValue);
	                                controller.$viewValue = controller.$modelValue;
	                                return false;
	                            }
	
	                            function initializeElement() {
	                                value = oldValueUnmasked = unmaskValue(controller.$modelValue || '');
	                                valueMasked = oldValue = maskValue(value);
	                                isValid = validateValue(value);
	                                if (iAttrs.maxlength) { // Double maxlength to allow pasting new val at end of mask
	                                    iElement.attr('maxlength', maskCaretMap[maskCaretMap.length - 1] * 2);
	                                }
	                                if ( ! originalPlaceholder && linkOptions.addDefaultPlaceholder) {
	                                    iElement.attr('placeholder', maskPlaceholder);
	                                }
	                                var viewValue = controller.$modelValue;
	                                var idx = controller.$formatters.length;
	                                while(idx--) {
	                                    viewValue = controller.$formatters[idx](viewValue);
	                                }
	                                controller.$viewValue = viewValue || '';
	                                controller.$render();
	                                // Not using $setViewValue so we don't clobber the model value and dirty the form
	                                // without any kind of user interaction.
	                            }
	
	                            function bindEventListeners() {
	                                if (eventsBound) {
	                                    return;
	                                }
	                                iElement.bind('blur', blurHandler);
	                                iElement.bind('mousedown mouseup', mouseDownUpHandler);
	                                iElement.bind('keydown', keydownHandler);
	                                iElement.bind(linkOptions.eventsToHandle.join(' '), eventHandler);
	                                eventsBound = true;
	                            }
	
	                            function unbindEventListeners() {
	                                if (!eventsBound) {
	                                    return;
	                                }
	                                iElement.unbind('blur', blurHandler);
	                                iElement.unbind('mousedown', mouseDownUpHandler);
	                                iElement.unbind('mouseup', mouseDownUpHandler);
	                                iElement.unbind('keydown', keydownHandler);
	                                iElement.unbind('input', eventHandler);
	                                iElement.unbind('keyup', eventHandler);
	                                iElement.unbind('click', eventHandler);
	                                iElement.unbind('focus', eventHandler);
	                                eventsBound = false;
	                            }
	
	                            function validateValue(value) {
	                                // Zero-length value validity is ngRequired's determination
	                                return value.length ? value.length >= minRequiredLength : true;
	                            }
	
	                            function unmaskValue(value) {
	                                var valueUnmasked = '',
	                                    input = iElement[0],
	                                    maskPatternsCopy = maskPatterns.slice(),
	                                    selectionStart = oldCaretPosition,
	                                    selectionEnd = selectionStart + getSelectionLength(input),
	                                    valueOffset, valueDelta, tempValue = '';
	                                // Preprocess by stripping mask components from value
	                                value = value.toString();
	                                valueOffset = 0;
	                                valueDelta = value.length - maskPlaceholder.length;
	                                angular.forEach(maskComponents, function(component) {
	                                    var position = component.position;
	                                    //Only try and replace the component if the component position is not within the selected range
	                                    //If component was in selected range then it was removed with the user input so no need to try and remove that component
	                                    if (!(position >= selectionStart && position < selectionEnd)) {
	                                        if (position >= selectionStart) {
	                                            position += valueDelta;
	                                        }
	                                        if (value.substring(position, position + component.value.length) === component.value) {
	                                            tempValue += value.slice(valueOffset, position);// + value.slice(position + component.value.length);
	                                            valueOffset = position + component.value.length;
	                                        }
	                                    }
	                                });
	                                value = tempValue + value.slice(valueOffset);
	                                angular.forEach(value.split(''), function(chr) {
	                                    if (maskPatternsCopy.length && maskPatternsCopy[0].test(chr)) {
	                                        valueUnmasked += chr;
	                                        maskPatternsCopy.shift();
	                                    }
	                                });
	
	                                return valueUnmasked;
	                            }
	
	                            function maskValue(unmaskedValue) {
	                                var valueMasked = '',
	                                        maskCaretMapCopy = maskCaretMap.slice();
	
	                                angular.forEach(maskPlaceholder.split(''), function(chr, i) {
	                                    if (unmaskedValue.length && i === maskCaretMapCopy[0]) {
	                                        valueMasked += unmaskedValue.charAt(0) || '_';
	                                        unmaskedValue = unmaskedValue.substr(1);
	                                        maskCaretMapCopy.shift();
	                                    }
	                                    else {
	                                        valueMasked += chr;
	                                    }
	                                });
	                                return valueMasked;
	                            }
	
	                            function getPlaceholderChar(i) {
	                                var placeholder = angular.isDefined(iAttrs.uiMaskPlaceholder) ? iAttrs.uiMaskPlaceholder : iAttrs.placeholder,
	                                    defaultPlaceholderChar;
	
	                                if (angular.isDefined(placeholder) && placeholder[i]) {
	                                    return placeholder[i];
	                                } else {
	                                    defaultPlaceholderChar = angular.isDefined(iAttrs.uiMaskPlaceholderChar) && iAttrs.uiMaskPlaceholderChar ? iAttrs.uiMaskPlaceholderChar : '_';
	                                    return (defaultPlaceholderChar.toLowerCase() === 'space') ? ' ' : defaultPlaceholderChar[0];
	                                }
	                            }
	
	                            // Generate array of mask components that will be stripped from a masked value
	                            // before processing to prevent mask components from being added to the unmasked value.
	                            // E.g., a mask pattern of '+7 9999' won't have the 7 bleed into the unmasked value.
	                            function getMaskComponents() {
	                                var maskPlaceholderChars = maskPlaceholder.split(''),
	                                        maskPlaceholderCopy, components;
	
	                                //maskCaretMap can have bad values if the input has the ui-mask attribute implemented as an obversable property, e.g. the demo page
	                                if (maskCaretMap && !isNaN(maskCaretMap[0])) {
	                                    //Instead of trying to manipulate the RegEx based on the placeholder characters
	                                    //we can simply replace the placeholder characters based on the already built
	                                    //maskCaretMap to underscores and leave the original working RegEx to get the proper
	                                    //mask components
	                                    angular.forEach(maskCaretMap, function(value) {
	                                        maskPlaceholderChars[value] = '_';
	                                    });
	                                }
	                                maskPlaceholderCopy = maskPlaceholderChars.join('');
	                                components = maskPlaceholderCopy.replace(/[_]+/g, '_').split('_');
	                                components = components.filter(function(s) {
	                                    return s !== '';
	                                });
	
	                                // need a string search offset in cases where the mask contains multiple identical components
	                                // E.g., a mask of 99.99.99-999.99
	                                var offset = 0;
	                                return components.map(function(c) {
	                                    var componentPosition = maskPlaceholderCopy.indexOf(c, offset);
	                                    offset = componentPosition + 1;
	                                    return {
	                                        value: c,
	                                        position: componentPosition
	                                    };
	                                });
	                            }
	
	                            function processRawMask(mask) {
	                                var characterCount = 0;
	
	                                maskCaretMap = [];
	                                maskPatterns = [];
	                                maskPlaceholder = '';
	
	                                if (angular.isString(mask)) {
	                                    minRequiredLength = 0;
	
	                                    var isOptional = false,
	                                            numberOfOptionalCharacters = 0,
	                                            splitMask = mask.split('');
	
	                                    var inEscape = false;
	                                    angular.forEach(splitMask, function(chr, i) {
	                                        if (inEscape) {
	                                            inEscape = false;
	                                            maskPlaceholder += chr;
	                                            characterCount++;
	                                        }
	                                        else if (linkOptions.escChar === chr) {
	                                            inEscape = true;
	                                        }
	                                        else if (linkOptions.maskDefinitions[chr]) {
	                                            maskCaretMap.push(characterCount);
	
	                                            maskPlaceholder += getPlaceholderChar(i - numberOfOptionalCharacters);
	                                            maskPatterns.push(linkOptions.maskDefinitions[chr]);
	
	                                            characterCount++;
	                                            if (!isOptional) {
	                                                minRequiredLength++;
	                                            }
	
	                                            isOptional = false;
	                                        }
	                                        else if (chr === '?') {
	                                            isOptional = true;
	                                            numberOfOptionalCharacters++;
	                                        }
	                                        else {
	                                            maskPlaceholder += chr;
	                                            characterCount++;
	                                        }
	                                    });
	                                }
	                                // Caret position immediately following last position is valid.
	                                maskCaretMap.push(maskCaretMap.slice().pop() + 1);
	
	                                maskComponents = getMaskComponents();
	                                maskProcessed = maskCaretMap.length > 1 ? true : false;
	                            }
	
	                            var prevValue = iElement.val();
	                            function blurHandler() {
	                                if (linkOptions.clearOnBlur || ((linkOptions.clearOnBlurPlaceholder) && (value.length === 0) && iAttrs.placeholder)) {
	                                    oldCaretPosition = 0;
	                                    oldSelectionLength = 0;
	                                    if (!isValid || value.length === 0) {
	                                        valueMasked = '';
	                                        iElement.val('');
	                                        scope.$apply(function() {
	                                            //only $setViewValue when not $pristine to avoid changing $pristine state.
	                                            if (!controller.$pristine) {
	                                                controller.$setViewValue('');
	                                            }
	                                        });
	                                    }
	                                }
	                                //Check for different value and trigger change.
	                                //Check for different value and trigger change.
	                                if (value !== prevValue) {
	                                    // #157 Fix the bug from the trigger when backspacing exactly on the first letter (emptying the field)
	                                    // and then blurring out.
	                                    // Angular uses html element and calls setViewValue(element.value.trim()), setting it to the trimmed mask
	                                    // when it should be empty
	                                    var currentVal = iElement.val();
	                                    var isTemporarilyEmpty = value === '' && currentVal && angular.isDefined(iAttrs.uiMaskPlaceholderChar) && iAttrs.uiMaskPlaceholderChar === 'space'; 
	                                    if(isTemporarilyEmpty) {
	                                        iElement.val('');
	                                    }
	                                    triggerChangeEvent(iElement[0]);
	                                    if(isTemporarilyEmpty) {
	                                        iElement.val(currentVal);
	                                    }
	                                }
	                                prevValue = value;
	                            }
	
	                            function triggerChangeEvent(element) {
	                                var change;
	                                if (angular.isFunction(window.Event) && !element.fireEvent) {
	                                    // modern browsers and Edge
	                                    change = new Event('change', {
	                                        view: window,
	                                        bubbles: true,
	                                        cancelable: false
	                                    });
	                                    element.dispatchEvent(change);
	                                } else if ('createEvent' in document) {
	                                    // older browsers
	                                    change = document.createEvent('HTMLEvents');
	                                    change.initEvent('change', false, true);
	                                    element.dispatchEvent(change);
	                                }
	                                else if (element.fireEvent) {
	                                    // IE <= 11
	                                    element.fireEvent('onchange');
	                                }
	                            }
	
	                            function mouseDownUpHandler(e) {
	                                if (e.type === 'mousedown') {
	                                    iElement.bind('mouseout', mouseoutHandler);
	                                } else {
	                                    iElement.unbind('mouseout', mouseoutHandler);
	                                }
	                            }
	
	                            iElement.bind('mousedown mouseup', mouseDownUpHandler);
	
	                            function mouseoutHandler() {
	                                /*jshint validthis: true */
	                                oldSelectionLength = getSelectionLength(this);
	                                iElement.unbind('mouseout', mouseoutHandler);
	                            }
	
	                            function keydownHandler(e) {
			              	/*jshint validthis: true */
					var isKeyBackspace = e.which === 8,
					caretPos = getCaretPosition(this) - 1 || 0, //value in keydown is pre change so bump caret position back to simulate post change
					isCtrlZ = e.which === 90 && e.ctrlKey; //ctrl+z pressed
			
					if (isKeyBackspace) {
						while(caretPos >= 0) {
							if (isValidCaretPosition(caretPos)) {
							//re-adjust the caret position.
							//Increment to account for the initial decrement to simulate post change caret position
							setCaretPosition(this, caretPos + 1);
							break;
							}
						caretPos--;
						}
					preventBackspace = caretPos === -1;
					}
					
					if (isCtrlZ) {
						// prevent IE bug - value should be returned to initial state
						iElement.val('');
						e.preventDefault();
					}
				}
	
	                            function eventHandler(e) {
	                                /*jshint validthis: true */
	                                e = e || {};
	                                // Allows more efficient minification
	                                var eventWhich = e.which,
	                                        eventType = e.type;
	
	                                // Prevent shift and ctrl from mucking with old values
	                                if (eventWhich === 16 || eventWhich === 91) {
	                                    return;
	                                }
	
	                                var val = iElement.val(),
	                                        valOld = oldValue,
	                                        valMasked,
	                                        valAltered = false,
	                                        valUnmasked = unmaskValue(val),
	                                        valUnmaskedOld = oldValueUnmasked,
	                                        caretPos = getCaretPosition(this) || 0,
	                                        caretPosOld = oldCaretPosition || 0,
	                                        caretPosDelta = caretPos - caretPosOld,
	                                        caretPosMin = maskCaretMap[0],
	                                        caretPosMax = maskCaretMap[valUnmasked.length] || maskCaretMap.slice().shift(),
	                                        selectionLenOld = oldSelectionLength || 0,
	                                        isSelected = getSelectionLength(this) > 0,
	                                        wasSelected = selectionLenOld > 0,
	                                        // Case: Typing a character to overwrite a selection
	                                        isAddition = (val.length > valOld.length) || (selectionLenOld && val.length > valOld.length - selectionLenOld),
	                                        // Case: Delete and backspace behave identically on a selection
	                                        isDeletion = (val.length < valOld.length) || (selectionLenOld && val.length === valOld.length - selectionLenOld),
	                                        isSelection = (eventWhich >= 37 && eventWhich <= 40) && e.shiftKey, // Arrow key codes
	
	                                        isKeyLeftArrow = eventWhich === 37,
	                                        // Necessary due to "input" event not providing a key code
	                                        isKeyBackspace = eventWhich === 8 || (eventType !== 'keyup' && isDeletion && (caretPosDelta === -1)),
	                                        isKeyDelete = eventWhich === 46 || (eventType !== 'keyup' && isDeletion && (caretPosDelta === 0) && !wasSelected),
	                                        // Handles cases where caret is moved and placed in front of invalid maskCaretMap position. Logic below
	                                        // ensures that, on click or leftward caret placement, caret is moved leftward until directly right of
	                                        // non-mask character. Also applied to click since users are (arguably) more likely to backspace
	                                        // a character when clicking within a filled input.
	                                        caretBumpBack = (isKeyLeftArrow || isKeyBackspace || eventType === 'click') && caretPos > caretPosMin;
	
	                                oldSelectionLength = getSelectionLength(this);
	
	                                // These events don't require any action
	                                if (isSelection || (isSelected && (eventType === 'click' || eventType === 'keyup' || eventType === 'focus'))) {
	                                    return;
	                                }
	
	                                if (isKeyBackspace && preventBackspace) {
	                                    iElement.val(maskPlaceholder);
	                                    // This shouldn't be needed but for some reason after aggressive backspacing the controller $viewValue is incorrect.
	                                    // This keeps the $viewValue updated and correct.
	                                    scope.$apply(function () {
	                                        controller.$setViewValue(''); // $setViewValue should be run in angular context, otherwise the changes will be invisible to angular and user code.
	                                    });
	                                    setCaretPosition(this, caretPosOld);
	                                    return;
	                                }
	
	                                // Value Handling
	                                // ==============
	
	                                // User attempted to delete but raw value was unaffected--correct this grievous offense
	                                if ((eventType === 'input') && isDeletion && !wasSelected && valUnmasked === valUnmaskedOld) {
	                                    while (isKeyBackspace && caretPos > caretPosMin && !isValidCaretPosition(caretPos)) {
	                                        caretPos--;
	                                    }
	                                    while (isKeyDelete && caretPos < caretPosMax && maskCaretMap.indexOf(caretPos) === -1) {
	                                        caretPos++;
	                                    }
	                                    var charIndex = maskCaretMap.indexOf(caretPos);
	                                    // Strip out non-mask character that user would have deleted if mask hadn't been in the way.
	                                    valUnmasked = valUnmasked.substring(0, charIndex) + valUnmasked.substring(charIndex + 1);
	
	                                    // If value has not changed, don't want to call $setViewValue, may be caused by IE raising input event due to placeholder
	                                    if (valUnmasked !== valUnmaskedOld)
	                                        valAltered = true;
	                                }
	
	                                // Update values
	                                valMasked = maskValue(valUnmasked);
	
	                                oldValue = valMasked;
	                                oldValueUnmasked = valUnmasked;
	
	                                //additional check to fix the problem where the viewValue is out of sync with the value of the element.
	                                //better fix for commit 2a83b5fb8312e71d220a497545f999fc82503bd9 (I think)
	                                if (!valAltered && val.length > valMasked.length)
	                                    valAltered = true;
	
	                                iElement.val(valMasked);
	
	                                //we need this check.  What could happen if you don't have it is that you'll set the model value without the user
	                                //actually doing anything.  Meaning, things like pristine and touched will be set.
	                                if (valAltered) {
	                                    scope.$apply(function () {
	                                        controller.$setViewValue(valMasked); // $setViewValue should be run in angular context, otherwise the changes will be invisible to angular and user code.
	                                    });
	                                }
	
	                                // Caret Repositioning
	                                // ===================
	
	                                // Ensure that typing always places caret ahead of typed character in cases where the first char of
	                                // the input is a mask char and the caret is placed at the 0 position.
	                                if (isAddition && (caretPos <= caretPosMin)) {
	                                    caretPos = caretPosMin + 1;
	                                }
	
	                                if (caretBumpBack) {
	                                    caretPos--;
	                                }
	
	                                // Make sure caret is within min and max position limits
	                                caretPos = caretPos > caretPosMax ? caretPosMax : caretPos < caretPosMin ? caretPosMin : caretPos;
	
	                                // Scoot the caret back or forth until it's in a non-mask position and within min/max position limits
	                                while (!isValidCaretPosition(caretPos) && caretPos > caretPosMin && caretPos < caretPosMax) {
	                                    caretPos += caretBumpBack ? -1 : 1;
	                                }
	
	                                if ((caretBumpBack && caretPos < caretPosMax) || (isAddition && !isValidCaretPosition(caretPosOld))) {
	                                    caretPos++;
	                                }
	                                oldCaretPosition = caretPos;
	                                setCaretPosition(this, caretPos);
	                            }
	
	                            function isValidCaretPosition(pos) {
	                                return maskCaretMap.indexOf(pos) > -1;
	                            }
	
	                            function getCaretPosition(input) {
	                                if (!input)
	                                    return 0;
	                                if (input.selectionStart !== undefined) {
	                                    return input.selectionStart;
	                                } else if (document.selection) {
	                                    if (isFocused(iElement[0])) {
	                                        // Curse you IE
	                                        input.focus();
	                                        var selection = document.selection.createRange();
	                                        selection.moveStart('character', input.value ? -input.value.length : 0);
	                                        return selection.text.length;
	                                    }
	                                }
	                                return 0;
	                            }
	
	                            function setCaretPosition(input, pos) {
	                                if (!input)
	                                    return 0;
	                                if (input.offsetWidth === 0 || input.offsetHeight === 0) {
	                                    return; // Input's hidden
	                                }
	                                if (input.setSelectionRange) {
	                                    if (isFocused(iElement[0])) {
	                                        input.focus();
	                                        input.setSelectionRange(pos, pos);
	                                    }
	                                }
	                                else if (input.createTextRange) {
	                                    // Curse you IE
	                                    var range = input.createTextRange();
	                                    range.collapse(true);
	                                    range.moveEnd('character', pos);
	                                    range.moveStart('character', pos);
	                                    range.select();
	                                }
	                            }
	
	                            function getSelectionLength(input) {
	                                if (!input)
	                                    return 0;
	                                if (input.selectionStart !== undefined) {
	                                    return (input.selectionEnd - input.selectionStart);
	                                }
	                                if (window.getSelection) {
	                                    return (window.getSelection().toString().length);
	                                }
	                                if (document.selection) {
	                                    return (document.selection.createRange().text.length);
	                                }
	                                return 0;
	                            }
	
	                            // https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Global_Objects/Array/indexOf
	                            if (!Array.prototype.indexOf) {
	                                Array.prototype.indexOf = function(searchElement /*, fromIndex */) {
	                                    if (this === null) {
	                                        throw new TypeError();
	                                    }
	                                    var t = Object(this);
	                                    var len = t.length >>> 0;
	                                    if (len === 0) {
	                                        return -1;
	                                    }
	                                    var n = 0;
	                                    if (arguments.length > 1) {
	                                        n = Number(arguments[1]);
	                                        if (n !== n) { // shortcut for verifying if it's NaN
	                                            n = 0;
	                                        } else if (n !== 0 && n !== Infinity && n !== -Infinity) {
	                                            n = (n > 0 || -1) * Math.floor(Math.abs(n));
	                                        }
	                                    }
	                                    if (n >= len) {
	                                        return -1;
	                                    }
	                                    var k = n >= 0 ? n : Math.max(len - Math.abs(n), 0);
	                                    for (; k < len; k++) {
	                                        if (k in t && t[k] === searchElement) {
	                                            return k;
	                                        }
	                                    }
	                                    return -1;
	                                };
	                            }
	
	                        };
	                    }
	                };
	            }
	        ]);
	
	}());

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	//https://github.com/angular/angular.js/pull/10732
	
	var angular = __webpack_require__(9);
	var mask = __webpack_require__(133);
	
	module.exports = 'ui.mask';


/***/ }),
/* 135 */
/***/ (function(module, exports) {

	/*!
	 * angular-ui-validate
	 * https://github.com/angular-ui/ui-validate
	 * Version: 1.2.3 - 2017-05-18T08:07:23.042Z
	 * License: MIT
	 */
	
	
	(function () { 
	'use strict';
	/**
	 * General-purpose validator for ngModel.
	 * angular.js comes with several built-in validation mechanism for input fields (ngRequired, ngPattern etc.) but using
	 * an arbitrary validation function requires creation of custom directives for interact with angular's validation mechanism.
	 * The ui-validate directive makes it easy to use any function(s) defined in scope as a validator function(s).
	 * A validator function will trigger validation on both model and input changes.
	 *
	 * This utility bring 'ui-validate' directives to handle regular validations and 'ui-validate-async' for asynchronous validations.
	 *
	 * @example <input ui-validate=" 'myValidatorFunction($value)' ">
	 * @example <input ui-validate="{ foo : '$value > anotherModel', bar : 'validateFoo($value)' }">
	 * @example <input ui-validate="{ foo : '$value > anotherModel' }" ui-validate-watch=" 'anotherModel' ">
	 * @example <input ui-validate="{ foo : '$value > anotherModel', bar : 'validateFoo($value)' }" ui-validate-watch=" { foo : 'anotherModel' } ">
	 * @example <input ui-validate-async=" 'myAsyncValidatorFunction($value)' ">
	 * @example <input ui-validate-async="{ foo: 'myAsyncValidatorFunction($value, anotherModel)' }" ui-validate-watch=" 'anotherModel' ">
	 *
	 * @param ui-validate {string|object literal} If strings is passed it should be a scope's function to be used as a validator.
	 * If an object literal is passed a key denotes a validation error key while a value should be a validator function.
	 * In both cases validator function should take a value to validate as its argument and should return true/false indicating a validation result.
	 * It is possible for a validator function to return a promise, however promises are better handled by ui-validate-async.
	 *
	 * @param ui-validate-async {string|object literal} If strings is passed it should be a scope's function to be used as a validator.
	 * If an object literal is passed a key denotes a validation error key while a value should be a validator function.
	 * Async validator function should take a value to validate as its argument and should return a promise that resolves if valid and reject if not,
	 * indicating a validation result.
	 * ui-validate-async supports non asyncronous validators. They are wrapped into a promise. Although is recomented to use ui-validate instead, since
	 * all validations declared in ui-validate-async are registered un ngModel.$asyncValidators that runs after ngModel.$validators if and only if
	 * all validators in ngModel.$validators reports as valid.
	 */
	angular.module('ui.validate',[])
	  .directive('uiValidate', ['$$uiValidateApplyWatch', '$$uiValidateApplyWatchCollection', function ($$uiValidateApplyWatch, $$uiValidateApplyWatchCollection) {
	
	  return {
	    restrict: 'A',
	    require: 'ngModel',
	    link: function(scope, elm, attrs, ctrl) {
	      var validateFn, validateExpr = scope.$eval(attrs.uiValidate);
	
	      if (!validateExpr) {
	        return;
	      }
	
	      if (angular.isString(validateExpr)) {
	        validateExpr = {
	          validator: validateExpr
	        };
	      }
	
	      angular.forEach(validateExpr, function(exprssn, key) {
	        validateFn = function(modelValue, viewValue) {
	          // $value is left for retrocompatibility
	          var expression = scope.$eval(exprssn, {
	            '$value': modelValue,
	            '$modelValue': modelValue,
	            '$viewValue': viewValue,
	            '$name': ctrl.$name
	          });
	          // Keep support for promises for retrocompatibility
	          if (angular.isObject(expression) && angular.isFunction(expression.then)) {
	            expression.then(function() {
	              ctrl.$setValidity(key, true);
	            }, function() {
	              ctrl.$setValidity(key, false);
	            });
	            // Return as valid for now. Validity is updated when promise resolves.
	            return true;
	          } else {
	            return !!expression; // Transform 'undefined' to false (to avoid corrupting the NgModelController and the FormController)
	          }
	        };
	        ctrl.$validators[key] = validateFn;
	      });
	
	      // Support for ui-validate-watch
	      if (attrs.uiValidateWatch) {
	        $$uiValidateApplyWatch(scope, ctrl, scope.$eval(attrs.uiValidateWatch), attrs.uiValidateWatchObjectEquality);
	      }
	      if (attrs.uiValidateWatchCollection) {
	        $$uiValidateApplyWatchCollection(scope, ctrl, scope.$eval(attrs.uiValidateWatchCollection));
	      }
	    }
	  };
	}])
	  .directive('uiValidateAsync', ['$$uiValidateApplyWatch', '$$uiValidateApplyWatchCollection', '$timeout', '$q', function ($$uiValidateApplyWatch, $$uiValidateApplyWatchCollection, $timeout, $q) {
	
	  return {
	    restrict: 'A',
	    require: 'ngModel',
	    link: function (scope, elm, attrs, ctrl) {
	      var validateFn, validateExpr = scope.$eval(attrs.uiValidateAsync);
	
	      if (!validateExpr){ return;}
	
	      if (angular.isString(validateExpr)) {
	        validateExpr = { validatorAsync: validateExpr };
	      }
	
	      angular.forEach(validateExpr, function (exprssn, key) {
	        validateFn = function(modelValue, viewValue) {
	          // $value is left for ease of use
	          var expression = scope.$eval(exprssn, {
	            '$value': modelValue,
	            '$modelValue': modelValue,
	            '$viewValue': viewValue,
	            '$name': ctrl.$name
	          });
	          // Check if it's a promise
	          if (angular.isObject(expression) && angular.isFunction(expression.then)) {
	            return expression;
	            // Support for validate non-async validators
	          } else {
	            return $q(function(resolve, reject) {
	              setTimeout(function() {
	                if (expression) {
	                  resolve();
	                } else {
	                  reject();
	                }
	              }, 0);
	            });
	          }
	        };
	        ctrl.$asyncValidators[key] = validateFn;
	      });
	
	      // Support for ui-validate-watch
	      if (attrs.uiValidateWatch){
	          $$uiValidateApplyWatch( scope, ctrl, scope.$eval(attrs.uiValidateWatch), attrs.uiValidateWatchObjectEquality);
	      }
	      if (attrs.uiValidateWatchCollection) {
	        $$uiValidateApplyWatchCollection(scope, ctrl, scope.$eval(attrs.uiValidateWatchCollection));
	      }
	    }
	  };
	}])
	  .service('$$uiValidateApplyWatch', function () {
	    return function (scope, ctrl, watch, objectEquality) {
	      var watchCallback = function () {
	        ctrl.$validate();
	      };
	
	      //string - update all validators on expression change
	      if (angular.isString(watch)) {
	        scope.$watch(watch, watchCallback, objectEquality);
	        //array - update all validators on change of any expression
	      } else if (angular.isArray(watch)) {
	        angular.forEach(watch, function (expression) {
	          scope.$watch(expression, watchCallback, objectEquality);
	        });
	        //object - update appropriate validator
	      } else if (angular.isObject(watch)) {
	        angular.forEach(watch, function (expression/*, validatorKey*/) {
	          //value is string - look after one expression
	          if (angular.isString(expression)) {
	            scope.$watch(expression, watchCallback, objectEquality);
	          }
	          //value is array - look after all expressions in array
	          if (angular.isArray(expression)) {
	            angular.forEach(expression, function (intExpression) {
	              scope.$watch(intExpression, watchCallback, objectEquality);
	            });
	          }
	        });
	      }
	    };
	  })
	  .service('$$uiValidateApplyWatchCollection', function () {
	    return function (scope, ctrl, watch) {
	      var watchCallback = function () {
	        ctrl.$validate();
	      };
	
	      //string - update all validators on expression change
	      if (angular.isString(watch)) {
	        scope.$watchCollection(watch, watchCallback);
	        //array - update all validators on change of any expression
	      } else if (angular.isArray(watch)) {
	        angular.forEach(watch, function (expression) {
	          scope.$watchCollection(expression, watchCallback);
	        });
	        //object - update appropriate validator
	      } else if (angular.isObject(watch)) {
	        angular.forEach(watch, function (expression/*, validatorKey*/) {
	          //value is string - look after one expression
	          if (angular.isString(expression)) {
	            scope.$watchCollection(expression, watchCallback);
	          }
	          //value is array - look after all expressions in array
	          if (angular.isArray(expression)) {
	            angular.forEach(expression, function (intExpression) {
	              scope.$watchCollection(intExpression, watchCallback);
	            });
	          }
	        });
	      }
	    };
	  });
	
	}());

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(135);
	module.exports = 'ui.validate';


/***/ }),
/* 137 */
/***/ (function(module, exports) {

	/**
	 * Easy to use Wizard library for Angular JS
	 * @version v1.1.1 - 2017-06-07 * @link https://github.com/mgonto/angular-wizard
	 * @author Martin Gontovnikas <martin@gon.to>
	 * @license MIT License, http://www.opensource.org/licenses/MIT
	 */
	angular.module('templates-angularwizard', ['step.html', 'wizard.html']);
	
	angular.module("step.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("step.html",
	    "<section ng-show=\"selected\" ng-class=\"{current: selected, done: completed}\" class=\"step\" ng-transclude>\n" +
	    "</section>");
	}]);
	
	angular.module("wizard.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("wizard.html",
	    "<div>\n" +
	    "    <h2 ng-show=\"selectedStep.wzHeadingTitle != ''\">{{ selectedStep.wzHeadingTitle }}</h2>\n" +
	    "\n" +
	    "    <div class=\"steps\" ng-if=\"indicatorsPosition === 'bottom'\" ng-transclude></div>\n" +
	    "    <ul class=\"steps-indicator steps-{{getEnabledSteps().length}}\" ng-if=\"!hideIndicators\">\n" +
	    "      <li ng-class=\"{default: !step.completed && !step.selected, current: step.selected && !step.completed, done: step.completed && !step.selected, editing: step.selected && step.completed}\" ng-repeat=\"step in getEnabledSteps()\">\n" +
	    "        <a ng-click=\"goTo(step)\">{{step.title || step.wzTitle}}</a>\n" +
	    "      </li>\n" +
	    "    </ul>\n" +
	    "    <div class=\"steps\" ng-if=\"indicatorsPosition === 'top'\" ng-transclude></div>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module('mgo-angular-wizard', ['templates-angularwizard']);
	
	angular.module('mgo-angular-wizard').directive('wzStep', function() {
	    return {
	        restrict: 'EA',
	        replace: true,
	        transclude: true,
	        scope: {
	            wzTitle: '@',
	            wzHeadingTitle: '@',
	            canenter : '=',
	            canexit : '=',
	            disabled: '@?wzDisabled',
	            description: '@',
	            wzData: '=',
	            wzOrder: '@?'
	        },
	        require: '^wizard',
	        templateUrl: function(element, attributes) {
	          return attributes.template || "step.html";
	        },
	        link: function ($scope, $element, $attrs, wizard) {
	            $attrs.$observe('wzTitle', function (value) {
	                $scope.title = $scope.wzTitle;
	            });
	            $scope.title = $scope.wzTitle;
	            wizard.addStep($scope);
	            $scope.$on('$destroy', function(){
	                wizard.removeStep($scope);
	            });
	        }
	    };
	});
	
	//wizard directive
	angular.module('mgo-angular-wizard').directive('wizard', function() {
	    return {
	        restrict: 'EA',
	        replace: true,
	        transclude: true,
	        scope: {
	            currentStep: '=',
	            onCancel: '&',
	            onFinish: '&',
	            hideIndicators: '=',
	            editMode: '=',
	            name: '@',
	            indicatorsPosition: '@?'
	        },
	        templateUrl: function(element, attributes) {
	            return attributes.template || "wizard.html";
	        },
	
	        //controller for wizard directive, treat this just like an angular controller
	        controller: ['$scope', '$element', '$log', 'WizardHandler', '$q', '$timeout', function ($scope, $element, $log, WizardHandler, $q, $timeout) {
	            //setting default step position if none declared.
	            if ($scope.indicatorsPosition == undefined) {
	                $scope.indicatorsPosition = 'bottom';
	            }
	            //this variable allows directive to load without having to pass any step validation
	            var firstRun = true;
	            //creating instance of wizard, passing this as second argument allows access to functions attached to this via Service
	            WizardHandler.addWizard($scope.name || WizardHandler.defaultName, this);
	
	            $scope.$on('$destroy', function() {
	                WizardHandler.removeWizard($scope.name || WizardHandler.defaultName);
	            });
	
	            //steps array where all the scopes of each step are added
	            $scope.steps = [];
	
	            var stepIdx = function(step) {
	                var idx = 0;
	                var res = -1;
	                angular.forEach($scope.getEnabledSteps(), function(currStep) {
	                  if (currStep === step) {
	                    res = idx;
	                  }
	                  idx++;
	                });
	                return res;
	            };
	
	            var stepByTitle = function(titleToFind) {
	              var foundStep = null;
	              angular.forEach($scope.getEnabledSteps(), function(step) {
	                if (step.wzTitle === titleToFind) {
	                  foundStep = step;
	                }
	              });
	              return foundStep;
	            };
	
	
	            //update completed state for each step based on the editMode and current step number
	            var handleEditModeChange = function() {
	                var editMode = $scope.editMode;
	                if (angular.isUndefined(editMode) || (editMode === null)) return;
	
	                //Set completed for all steps to the value of editMode
	                angular.forEach($scope.steps, function (step) {
	                    step.completed = editMode;
	                });
	
	                //If editMode is false, set ONLY ENABLED steps with index lower then completedIndex to completed
	                if (!editMode) {
	                    var completedStepsIndex = $scope.currentStepNumber() - 1;
	                    angular.forEach($scope.getEnabledSteps(), function(step, stepIndex) {
	                        if(stepIndex < completedStepsIndex) {
	                            step.completed = true;
	                        }
	                    });
	                }
	            };
	
	            //access to context object for step validation
	            $scope.context = {};
	
	            //watching changes to currentStep
	            $scope.$watch('currentStep', function(step) {
	                //checking to make sure currentStep is truthy value
	                if (!step) return;
	                //setting stepTitle equal to current step title or default title
	                var stepTitle = $scope.selectedStep.wzTitle;
	                if ($scope.selectedStep && stepTitle !== $scope.currentStep) {
	                    //invoking goTo() with step title as argument
	                    $scope.goTo(stepByTitle($scope.currentStep));
	                }
	            });
	
	            //watching steps array length and editMode value, if edit module is undefined or null the nothing is done
	            //if edit mode is truthy, then all steps are marked as completed
	            $scope.$watch('[editMode, steps.length]', function() {
	                handleEditModeChange();
	            }, true);
	
	            //called each time step directive is loaded
	            this.addStep = function(step) {
	                var wzOrder = (step.wzOrder >= 0 && !$scope.steps[step.wzOrder]) ? step.wzOrder : $scope.steps.length;
	                //adding the scope of directive onto step array
	                $scope.steps[wzOrder] = step;
	                //if this step is the new first then goTo it
	                if ($scope.getEnabledSteps()[0] === step) {
	                    //goTo first step
	                    $scope.goTo($scope.getEnabledSteps()[0]);
	                }
	            };
	
	            //called each time step directive is destroyed
	            this.removeStep = function (step) {
	                var index = $scope.steps.indexOf(step);
	                if (index > 0) {
	                    $scope.steps.splice(index, 1);
	                }
	            };
	
	            this.context = $scope.context;
	
	            $scope.getStepNumber = function(step) {
	                return stepIdx(step) + 1;
	            };
	
	            $scope.goTo = function(step) {
	                //if this is the first time the wizard is loading it bi-passes step validation
	                if(firstRun){
	                    //deselect all steps so you can set fresh below
	                    unselectAll();
	                    $scope.selectedStep = step;
	                    //making sure current step is not undefined
	                    if (!angular.isUndefined($scope.currentStep)) {
	                        $scope.currentStep = step.wzTitle;
	                    }
	                    //setting selected step to argument passed into goTo()
	                    step.selected = true;
	                    //emit event upwards with data on goTo() invoktion
	                    $scope.$emit('wizard:stepChanged', {step: step, index: stepIdx(step)});
	                    //setting variable to false so all other step changes must pass validation
	                    firstRun = false;
	                } else {
	                    //createing variables to capture current state that goTo() was invoked from and allow booleans
	                    var thisStep;
	                    //getting data for step you are transitioning out of
	                    if($scope.currentStepNumber() > 0){
	                        thisStep = $scope.currentStepNumber() - 1;
	                    } else if ($scope.currentStepNumber() === 0){
	                        thisStep = 0;
	                    }
	                    //$log.log('steps[thisStep] Data: ', $scope.getEnabledSteps()[thisStep].canexit);
	                    $q.all([canExitStep($scope.getEnabledSteps()[thisStep], step), canEnterStep(step)]).then(function(data) {
	                        if(data[0] && data[1]){
	                            //deselect all steps so you can set fresh below
	                            unselectAll();
	
	                            //$log.log('value for canExit argument: ', $scope.currentStep.canexit);
	                            $scope.selectedStep = step;
	                            //making sure current step is not undefined
	                            if(!angular.isUndefined($scope.currentStep)){
	                                $scope.currentStep = step.wzTitle;
	                            }
	                            //setting selected step to argument passed into goTo()
	                            step.selected = true;
	                            //emit event upwards with data on goTo() invoktion
	                            $scope.$emit('wizard:stepChanged', {step: step, index: stepIdx(step)});
	                            //$log.log('current step number: ', $scope.currentStepNumber());
	                        } else {
	                            $scope.$emit('wizard:stepChangeFailed', {step: step, index: _.indexOf($scope.getEnabledSteps(), step)});
	                        }
	                    });
	                }
	            };
	
	            function canEnterStep(step) {
	                var defer;
	                var canEnter;
	                //If no validation function is provided, allow the user to enter the step
	                if(step.canenter === undefined){
	                    return true;
	                }
	                //If canenter is a boolean value instead of a function, return the value
	                if(typeof step.canenter === 'boolean'){
	                    return step.canenter;
	                }
	                //If canenter is a string instead of a function, evaluate the function
	                if(typeof step.canenter === 'string'){
	                    var splitFunction = step.canenter.split('(');
	                    canEnter = eval('$scope.$parent.' + splitFunction[0] + '($scope.context' + splitFunction[1])
	                } else {
	                    canEnter = step.canenter($scope.context);
	                }
	                //Check to see if the canenter function is a promise which needs to be returned
	                if(angular.isFunction(canEnter.then)){
	                    defer = $q.defer();
	                    canEnter.then(function(response){
	                        defer.resolve(response);
	                    });
	                    return defer.promise;
	                } else {
	                    return canEnter === true;
	                }
	            }
	
	            function canExitStep(step, stepTo) {
	                var defer;
	                var canExit;
	                //Exiting the step should be allowed if no validation function was provided or if the user is moving backwards
	                if(typeof(step.canexit) === 'undefined' || $scope.getStepNumber(stepTo) < $scope.currentStepNumber()){
	                    return true;
	                }
	                //If canexit is a boolean value instead of a function, return the value
	                if(typeof step.canexit === 'boolean'){
	                    return step.canexit;
	                }
	                //If canenter is a string instead of a function, evaluate the function
	                if(typeof step.canexit === 'string'){
	                    var splitFunction = step.canexit.split('(');
	                    canExit = eval('$scope.$parent.' + splitFunction[0] + '($scope.context' + splitFunction[1])
	                } else {
	                    canExit = step.canexit($scope.context);
	                }
	                //Check to see if the canexit function is a promise which needs to be returned
	                if(angular.isFunction(canExit.then)){
	                    defer = $q.defer();
	                    canExit.then(function(response){
	                        defer.resolve(response);
	                    });
	                    return defer.promise;
	                } else {
	                    return canExit === true;
	                }
	            }
	
	            $scope.currentStepNumber = function() {
	                //retreive current step number
	                return stepIdx($scope.selectedStep) + 1;
	            };
	
	            $scope.getEnabledSteps = function() {
	                return $scope.steps.filter(function(step){
	                    return step && step.disabled !== 'true';
	                });
	            };
	
	            //unSelect All Steps
	            function unselectAll() {
	                //traverse steps array and set each "selected" property to false
	                angular.forEach($scope.getEnabledSteps(), function (step) {
	                    step.selected = false;
	                });
	                //set selectedStep variable to null
	                $scope.selectedStep = null;
	            }
	
	            //ALL METHODS ATTACHED TO this ARE ACCESSIBLE VIA WizardHandler.wizard().methodName()
	
	            this.currentStepTitle = function(){
	                return $scope.selectedStep.wzTitle;
	            };
	
	            this.currentStepDescription = function(){
	                return $scope.selectedStep.description;
	            };
	
	            this.currentStep = function(){
	                return $scope.selectedStep;
	            };
	
	            this.totalStepCount = function() {
	                return $scope.getEnabledSteps().length;
	            };
	
	            //Access to enabled steps from outside
	            this.getEnabledSteps = function(){
	                return $scope.getEnabledSteps();
	            };
	
	            //Access to current step number from outside
	            this.currentStepNumber = function(){
	                return $scope.currentStepNumber();
	            };
	            //method used for next button within step
	            this.next = function(callback) {
	                var enabledSteps = $scope.getEnabledSteps();
	                //setting variable equal to step  you were on when next() was invoked
	                var index = stepIdx($scope.selectedStep);
	                //checking to see if callback is a function
	                if(angular.isFunction(callback)){
	                   if(callback()){
	                        if (index === enabledSteps.length - 1) {
	                            this.finish();
	                        } else {
	                            //invoking goTo() with step number next in line
	                            $scope.goTo(enabledSteps[index + 1]);
	                        }
	                   } else {
	                        return;
	                   }
	                }
	                if (!callback) {
	                    //completed property set on scope which is used to add class/remove class from progress bar
	                    $scope.selectedStep.completed = true;
	                }
	                //checking to see if this is the last step.  If it is next behaves the same as finish()
	                if (index === enabledSteps.length - 1) {
	                    this.finish();
	                } else {
	                    //invoking goTo() with step number next in line
	                    $scope.goTo(enabledSteps[index + 1]);
	                }
	
	            };
	
	            //used to traverse to any step, step number placed as argument
	            this.goTo = function(step) {
	                //wrapped inside $timeout so newly enabled steps are included.
	                $timeout(function() {
	                    var enabledSteps = $scope.getEnabledSteps();
	                    var stepTo;
	                    //checking that step is a Number
	                    if (angular.isNumber(step)) {
	                        stepTo = enabledSteps[step];
	                    } else {
	                        //finding the step associated with the title entered as goTo argument
	                        stepTo = stepByTitle(step);
	                    }
	                    //going to step
	                    $scope.goTo(stepTo);
	                });
	            };
	
	            //calls finish() which calls onFinish() which is declared on an attribute and linked to controller via wizard directive.
	            this.finish = function() {
	                if ($scope.onFinish) {
	                    $scope.onFinish();
	                }
	            };
	
	            this.previous = function() {
	                //getting index of current step
	                var index = stepIdx($scope.selectedStep);
	                //ensuring you aren't trying to go back from the first step
	                if (index === 0) {
	                    throw new Error("Can't go back. It's already in step 0");
	                } else {
	                    //go back one step from current step
	                    $scope.goTo($scope.getEnabledSteps()[index - 1]);
	                }
	            };
	
	            //cancel is alias for previous.
	            this.cancel = function() {
	            	if ($scope.onCancel) {
	                    //onCancel is linked to controller via wizard directive:
	                    $scope.onCancel();
	                } else {
	                    //getting index of current step
	                    var index = stepIdx($scope.selectedStep);
	                    //ensuring you aren't trying to go back from the first step
	                    if (index === 0) {
	                        throw new Error("Can't go back. It's already in step 0");
	                    } else {
	                        //go back one step from current step
	                        $scope.goTo($scope.getEnabledSteps()[0]);
	                    }                	
	                }
	            };
	
	            //reset
	            this.reset = function(){
	                //traverse steps array and set each "completed" property to false
	                angular.forEach($scope.getEnabledSteps(), function (step) {
	                    step.completed = false;
	                });
	                //go to first step
	                this.goTo(0);
	            };
	
	            //change edit mode
	            this.setEditMode = function(mode) {
	                $scope.editMode = mode;
	                handleEditModeChange();
	            };
	        }]
	    };
	});
	
	function wizardButtonDirective(action) {
	    angular.module('mgo-angular-wizard')
	        .directive(action, function() {
	            return {
	                restrict: 'A',
	                replace: false,
	                require: '^wizard',
	                link: function($scope, $element, $attrs, wizard) {
	
	                    $element.on("click", function(e) {
	                        e.preventDefault();
	                        $scope.$apply(function() {
	                            $scope.$eval($attrs[action]);
	                            wizard[action.replace("wz", "").toLowerCase()]();
	                        });
	                    });
	                }
	            };
	        });
	}
	
	wizardButtonDirective('wzNext');
	wizardButtonDirective('wzPrevious');
	wizardButtonDirective('wzFinish');
	wizardButtonDirective('wzCancel');
	wizardButtonDirective('wzReset');
	
	angular.module('mgo-angular-wizard').factory('WizardHandler', function() {
	   var service = {};
	   
	   var wizards = {};
	   
	   service.defaultName = "defaultWizard";
	   
	   service.addWizard = function(name, wizard) {
	       wizards[name] = wizard;
	   };
	   
	   service.removeWizard = function(name) {
	       delete wizards[name];
	   };
	   
	   service.wizard = function(name) {
	       var nameToUse = name;
	       if (!name) {
	           nameToUse = service.defaultName;
	       }
	       
	       return wizards[nameToUse];
	   };
	   
	   return service;
	});


/***/ }),
/* 138 */
/***/ (function(module, exports) {

	/**
	 * @license AngularJS v1.8.3
	 * (c) 2010-2020 Google LLC. http://angularjs.org
	 * License: MIT
	 */
	(function(window) {'use strict';
	
	/* exported
	  minErrConfig,
	  errorHandlingConfig,
	  isValidObjectMaxDepth
	*/
	
	var minErrConfig = {
	  objectMaxDepth: 5,
	  urlErrorParamsEnabled: true
	};
	
	/**
	 * @ngdoc function
	 * @name angular.errorHandlingConfig
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Configure several aspects of error handling in AngularJS if used as a setter or return the
	 * current configuration if used as a getter. The following options are supported:
	 *
	 * - **objectMaxDepth**: The maximum depth to which objects are traversed when stringified for error messages.
	 *
	 * Omitted or undefined options will leave the corresponding configuration values unchanged.
	 *
	 * @param {Object=} config - The configuration object. May only contain the options that need to be
	 *     updated. Supported keys:
	 *
	 * * `objectMaxDepth`  **{Number}** - The max depth for stringifying objects. Setting to a
	 *   non-positive or non-numeric value, removes the max depth limit.
	 *   Default: 5
	 *
	 * * `urlErrorParamsEnabled`  **{Boolean}** - Specifies whether the generated error url will
	 *   contain the parameters of the thrown error. Disabling the parameters can be useful if the
	 *   generated error url is very long.
	 *
	 *   Default: true. When used without argument, it returns the current value.
	 */
	function errorHandlingConfig(config) {
	  if (isObject(config)) {
	    if (isDefined(config.objectMaxDepth)) {
	      minErrConfig.objectMaxDepth = isValidObjectMaxDepth(config.objectMaxDepth) ? config.objectMaxDepth : NaN;
	    }
	    if (isDefined(config.urlErrorParamsEnabled) && isBoolean(config.urlErrorParamsEnabled)) {
	      minErrConfig.urlErrorParamsEnabled = config.urlErrorParamsEnabled;
	    }
	  } else {
	    return minErrConfig;
	  }
	}
	
	/**
	 * @private
	 * @param {Number} maxDepth
	 * @return {boolean}
	 */
	function isValidObjectMaxDepth(maxDepth) {
	  return isNumber(maxDepth) && maxDepth > 0;
	}
	
	
	/**
	 * @description
	 *
	 * This object provides a utility for producing rich Error messages within
	 * AngularJS. It can be called as follows:
	 *
	 * var exampleMinErr = minErr('example');
	 * throw exampleMinErr('one', 'This {0} is {1}', foo, bar);
	 *
	 * The above creates an instance of minErr in the example namespace. The
	 * resulting error will have a namespaced error code of example.one.  The
	 * resulting error will replace {0} with the value of foo, and {1} with the
	 * value of bar. The object is not restricted in the number of arguments it can
	 * take.
	 *
	 * If fewer arguments are specified than necessary for interpolation, the extra
	 * interpolation markers will be preserved in the final string.
	 *
	 * Since data will be parsed statically during a build step, some restrictions
	 * are applied with respect to how minErr instances are created and called.
	 * Instances should have names of the form namespaceMinErr for a minErr created
	 * using minErr('namespace'). Error codes, namespaces and template strings
	 * should all be static strings, not variables or general expressions.
	 *
	 * @param {string} module The namespace to use for the new minErr instance.
	 * @param {function} ErrorConstructor Custom error constructor to be instantiated when returning
	 *   error from returned function, for cases when a particular type of error is useful.
	 * @returns {function(code:string, template:string, ...templateArgs): Error} minErr instance
	 */
	
	function minErr(module, ErrorConstructor) {
	  ErrorConstructor = ErrorConstructor || Error;
	
	  var url = 'https://errors.angularjs.org/1.8.3/';
	  var regex = url.replace('.', '\\.') + '[\\s\\S]*';
	  var errRegExp = new RegExp(regex, 'g');
	
	  return function() {
	    var code = arguments[0],
	      template = arguments[1],
	      message = '[' + (module ? module + ':' : '') + code + '] ',
	      templateArgs = sliceArgs(arguments, 2).map(function(arg) {
	        return toDebugString(arg, minErrConfig.objectMaxDepth);
	      }),
	      paramPrefix, i;
	
	    // A minErr message has two parts: the message itself and the url that contains the
	    // encoded message.
	    // The message's parameters can contain other error messages which also include error urls.
	    // To prevent the messages from getting too long, we strip the error urls from the parameters.
	
	    message += template.replace(/\{\d+\}/g, function(match) {
	      var index = +match.slice(1, -1);
	
	      if (index < templateArgs.length) {
	        return templateArgs[index].replace(errRegExp, '');
	      }
	
	      return match;
	    });
	
	    message += '\n' + url + (module ? module + '/' : '') + code;
	
	    if (minErrConfig.urlErrorParamsEnabled) {
	      for (i = 0, paramPrefix = '?'; i < templateArgs.length; i++, paramPrefix = '&') {
	        message += paramPrefix + 'p' + i + '=' + encodeURIComponent(templateArgs[i]);
	      }
	    }
	
	    return new ErrorConstructor(message);
	  };
	}
	
	/* We need to tell ESLint what variables are being exported */
	/* exported
	  angular,
	  msie,
	  jqLite,
	  jQuery,
	  slice,
	  splice,
	  push,
	  toString,
	  minErrConfig,
	  errorHandlingConfig,
	  isValidObjectMaxDepth,
	  ngMinErr,
	  angularModule,
	  uid,
	  REGEX_STRING_REGEXP,
	  VALIDITY_STATE_PROPERTY,
	
	  lowercase,
	  uppercase,
	  nodeName_,
	  isArrayLike,
	  forEach,
	  forEachSorted,
	  reverseParams,
	  nextUid,
	  setHashKey,
	  extend,
	  toInt,
	  inherit,
	  merge,
	  noop,
	  identity,
	  valueFn,
	  isUndefined,
	  isDefined,
	  isObject,
	  isBlankObject,
	  isString,
	  isNumber,
	  isNumberNaN,
	  isDate,
	  isError,
	  isArray,
	  isFunction,
	  isRegExp,
	  isWindow,
	  isScope,
	  isFile,
	  isFormData,
	  isBlob,
	  isBoolean,
	  isPromiseLike,
	  trim,
	  escapeForRegexp,
	  isElement,
	  makeMap,
	  includes,
	  arrayRemove,
	  copy,
	  simpleCompare,
	  equals,
	  csp,
	  jq,
	  concat,
	  sliceArgs,
	  bind,
	  toJsonReplacer,
	  toJson,
	  fromJson,
	  convertTimezoneToLocal,
	  timezoneToOffset,
	  addDateMinutes,
	  startingTag,
	  tryDecodeURIComponent,
	  parseKeyValue,
	  toKeyValue,
	  encodeUriSegment,
	  encodeUriQuery,
	  angularInit,
	  bootstrap,
	  getTestability,
	  snake_case,
	  bindJQuery,
	  assertArg,
	  assertArgFn,
	  assertNotHasOwnProperty,
	  getter,
	  getBlockNodes,
	  hasOwnProperty,
	  createMap,
	  stringify,
	  UNSAFE_restoreLegacyJqLiteXHTMLReplacement,
	
	  NODE_TYPE_ELEMENT,
	  NODE_TYPE_ATTRIBUTE,
	  NODE_TYPE_TEXT,
	  NODE_TYPE_COMMENT,
	  NODE_TYPE_DOCUMENT,
	  NODE_TYPE_DOCUMENT_FRAGMENT
	*/
	
	////////////////////////////////////
	
	/**
	 * @ngdoc module
	 * @name ng
	 * @module ng
	 * @installation
	 * @description
	 *
	 * The ng module is loaded by default when an AngularJS application is started. The module itself
	 * contains the essential components for an AngularJS application to function. The table below
	 * lists a high level breakdown of each of the services/factories, filters, directives and testing
	 * components available within this core module.
	 *
	 */
	
	var REGEX_STRING_REGEXP = /^\/(.+)\/([a-z]*)$/;
	
	// The name of a form control's ValidityState property.
	// This is used so that it's possible for internal tests to create mock ValidityStates.
	var VALIDITY_STATE_PROPERTY = 'validity';
	
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * @private
	 *
	 * @description Converts the specified string to lowercase.
	 * @param {string} string String to be converted to lowercase.
	 * @returns {string} Lowercased string.
	 */
	var lowercase = function(string) {return isString(string) ? string.toLowerCase() : string;};
	
	/**
	 * @private
	 *
	 * @description Converts the specified string to uppercase.
	 * @param {string} string String to be converted to uppercase.
	 * @returns {string} Uppercased string.
	 */
	var uppercase = function(string) {return isString(string) ? string.toUpperCase() : string;};
	
	
	var
	    msie,             // holds major version number for IE, or NaN if UA is not IE.
	    jqLite,           // delay binding since jQuery could be loaded after us.
	    jQuery,           // delay binding
	    slice             = [].slice,
	    splice            = [].splice,
	    push              = [].push,
	    toString          = Object.prototype.toString,
	    getPrototypeOf    = Object.getPrototypeOf,
	    ngMinErr          = minErr('ng'),
	
	    /** @name angular */
	    angular           = window.angular || (window.angular = {}),
	    angularModule,
	    uid               = 0;
	
	// Support: IE 9-11 only
	/**
	 * documentMode is an IE-only property
	 * http://msdn.microsoft.com/en-us/library/ie/cc196988(v=vs.85).aspx
	 */
	msie = window.document.documentMode;
	
	
	/**
	 * @private
	 * @param {*} obj
	 * @return {boolean} Returns true if `obj` is an array or array-like object (NodeList, Arguments,
	 *                   String ...)
	 */
	function isArrayLike(obj) {
	
	  // `null`, `undefined` and `window` are not array-like
	  if (obj == null || isWindow(obj)) return false;
	
	  // arrays, strings and jQuery/jqLite objects are array like
	  // * jqLite is either the jQuery or jqLite constructor function
	  // * we have to check the existence of jqLite first as this method is called
	  //   via the forEach method when constructing the jqLite object in the first place
	  if (isArray(obj) || isString(obj) || (jqLite && obj instanceof jqLite)) return true;
	
	  // Support: iOS 8.2 (not reproducible in simulator)
	  // "length" in obj used to prevent JIT error (gh-11508)
	  var length = 'length' in Object(obj) && obj.length;
	
	  // NodeList objects (with `item` method) and
	  // other objects with suitable length characteristics are array-like
	  return isNumber(length) && (length >= 0 && (length - 1) in obj || typeof obj.item === 'function');
	
	}
	
	/**
	 * @ngdoc function
	 * @name angular.forEach
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Invokes the `iterator` function once for each item in `obj` collection, which can be either an
	 * object or an array. The `iterator` function is invoked with `iterator(value, key, obj)`, where `value`
	 * is the value of an object property or an array element, `key` is the object property key or
	 * array element index and obj is the `obj` itself. Specifying a `context` for the function is optional.
	 *
	 * It is worth noting that `.forEach` does not iterate over inherited properties because it filters
	 * using the `hasOwnProperty` method.
	 *
	 * Unlike ES262's
	 * [Array.prototype.forEach](http://www.ecma-international.org/ecma-262/5.1/#sec-15.4.4.18),
	 * providing 'undefined' or 'null' values for `obj` will not throw a TypeError, but rather just
	 * return the value provided.
	 *
	   ```js
	     var values = {name: 'misko', gender: 'male'};
	     var log = [];
	     angular.forEach(values, function(value, key) {
	       this.push(key + ': ' + value);
	     }, log);
	     expect(log).toEqual(['name: misko', 'gender: male']);
	   ```
	 *
	 * @param {Object|Array} obj Object to iterate over.
	 * @param {Function} iterator Iterator function.
	 * @param {Object=} context Object to become context (`this`) for the iterator function.
	 * @returns {Object|Array} Reference to `obj`.
	 */
	
	function forEach(obj, iterator, context) {
	  var key, length;
	  if (obj) {
	    if (isFunction(obj)) {
	      for (key in obj) {
	        if (key !== 'prototype' && key !== 'length' && key !== 'name' && obj.hasOwnProperty(key)) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    } else if (isArray(obj) || isArrayLike(obj)) {
	      var isPrimitive = typeof obj !== 'object';
	      for (key = 0, length = obj.length; key < length; key++) {
	        if (isPrimitive || key in obj) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    } else if (obj.forEach && obj.forEach !== forEach) {
	        obj.forEach(iterator, context, obj);
	    } else if (isBlankObject(obj)) {
	      // createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
	      for (key in obj) {
	        iterator.call(context, obj[key], key, obj);
	      }
	    } else if (typeof obj.hasOwnProperty === 'function') {
	      // Slow path for objects inheriting Object.prototype, hasOwnProperty check needed
	      for (key in obj) {
	        if (obj.hasOwnProperty(key)) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    } else {
	      // Slow path for objects which do not have a method `hasOwnProperty`
	      for (key in obj) {
	        if (hasOwnProperty.call(obj, key)) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    }
	  }
	  return obj;
	}
	
	function forEachSorted(obj, iterator, context) {
	  var keys = Object.keys(obj).sort();
	  for (var i = 0; i < keys.length; i++) {
	    iterator.call(context, obj[keys[i]], keys[i]);
	  }
	  return keys;
	}
	
	
	/**
	 * when using forEach the params are value, key, but it is often useful to have key, value.
	 * @param {function(string, *)} iteratorFn
	 * @returns {function(*, string)}
	 */
	function reverseParams(iteratorFn) {
	  return function(value, key) {iteratorFn(key, value);};
	}
	
	/**
	 * A consistent way of creating unique IDs in angular.
	 *
	 * Using simple numbers allows us to generate 28.6 million unique ids per second for 10 years before
	 * we hit number precision issues in JavaScript.
	 *
	 * Math.pow(2,53) / 60 / 60 / 24 / 365 / 10 = 28.6M
	 *
	 * @returns {number} an unique alpha-numeric string
	 */
	function nextUid() {
	  return ++uid;
	}
	
	
	/**
	 * Set or clear the hashkey for an object.
	 * @param obj object
	 * @param h the hashkey (!truthy to delete the hashkey)
	 */
	function setHashKey(obj, h) {
	  if (h) {
	    obj.$$hashKey = h;
	  } else {
	    delete obj.$$hashKey;
	  }
	}
	
	
	function baseExtend(dst, objs, deep) {
	  var h = dst.$$hashKey;
	
	  for (var i = 0, ii = objs.length; i < ii; ++i) {
	    var obj = objs[i];
	    if (!isObject(obj) && !isFunction(obj)) continue;
	    var keys = Object.keys(obj);
	    for (var j = 0, jj = keys.length; j < jj; j++) {
	      var key = keys[j];
	      var src = obj[key];
	
	      if (deep && isObject(src)) {
	        if (isDate(src)) {
	          dst[key] = new Date(src.valueOf());
	        } else if (isRegExp(src)) {
	          dst[key] = new RegExp(src);
	        } else if (src.nodeName) {
	          dst[key] = src.cloneNode(true);
	        } else if (isElement(src)) {
	          dst[key] = src.clone();
	        } else {
	          if (key !== '__proto__') {
	            if (!isObject(dst[key])) dst[key] = isArray(src) ? [] : {};
	            baseExtend(dst[key], [src], true);
	          }
	        }
	      } else {
	        dst[key] = src;
	      }
	    }
	  }
	
	  setHashKey(dst, h);
	  return dst;
	}
	
	/**
	 * @ngdoc function
	 * @name angular.extend
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
	 * to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
	 * by passing an empty object as the target: `var object = angular.extend({}, object1, object2)`.
	 *
	 * **Note:** Keep in mind that `angular.extend` does not support recursive merge (deep copy). Use
	 * {@link angular.merge} for this.
	 *
	 * @param {Object} dst Destination object.
	 * @param {...Object} src Source object(s).
	 * @returns {Object} Reference to `dst`.
	 */
	function extend(dst) {
	  return baseExtend(dst, slice.call(arguments, 1), false);
	}
	
	
	/**
	* @ngdoc function
	* @name angular.merge
	* @module ng
	* @kind function
	*
	* @description
	* Deeply extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
	* to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
	* by passing an empty object as the target: `var object = angular.merge({}, object1, object2)`.
	*
	* Unlike {@link angular.extend extend()}, `merge()` recursively descends into object properties of source
	* objects, performing a deep copy.
	*
	* @deprecated
	* sinceVersion="1.6.5"
	* This function is deprecated, but will not be removed in the 1.x lifecycle.
	* There are edge cases (see {@link angular.merge#known-issues known issues}) that are not
	* supported by this function. We suggest using another, similar library for all-purpose merging,
	* such as [lodash's merge()](https://lodash.com/docs/4.17.4#merge).
	*
	* @knownIssue
	* This is a list of (known) object types that are not handled correctly by this function:
	* - [`Blob`](https://developer.mozilla.org/docs/Web/API/Blob)
	* - [`MediaStream`](https://developer.mozilla.org/docs/Web/API/MediaStream)
	* - [`CanvasGradient`](https://developer.mozilla.org/docs/Web/API/CanvasGradient)
	* - AngularJS {@link $rootScope.Scope scopes};
	*
	* `angular.merge` also does not support merging objects with circular references.
	*
	* @param {Object} dst Destination object.
	* @param {...Object} src Source object(s).
	* @returns {Object} Reference to `dst`.
	*/
	function merge(dst) {
	  return baseExtend(dst, slice.call(arguments, 1), true);
	}
	
	
	
	function toInt(str) {
	  return parseInt(str, 10);
	}
	
	var isNumberNaN = Number.isNaN || function isNumberNaN(num) {
	  // eslint-disable-next-line no-self-compare
	  return num !== num;
	};
	
	
	function inherit(parent, extra) {
	  return extend(Object.create(parent), extra);
	}
	
	/**
	 * @ngdoc function
	 * @name angular.noop
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * A function that performs no operations. This function can be useful when writing code in the
	 * functional style.
	   ```js
	     function foo(callback) {
	       var result = calculateResult();
	       (callback || angular.noop)(result);
	     }
	   ```
	 */
	function noop() {}
	noop.$inject = [];
	
	
	/**
	 * @ngdoc function
	 * @name angular.identity
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * A function that returns its first argument. This function is useful when writing code in the
	 * functional style.
	 *
	   ```js
	   function transformer(transformationFn, value) {
	     return (transformationFn || angular.identity)(value);
	   };
	
	   // E.g.
	   function getResult(fn, input) {
	     return (fn || angular.identity)(input);
	   };
	
	   getResult(function(n) { return n * 2; }, 21);   // returns 42
	   getResult(null, 21);                            // returns 21
	   getResult(undefined, 21);                       // returns 21
	   ```
	 *
	 * @param {*} value to be returned.
	 * @returns {*} the value passed in.
	 */
	function identity($) {return $;}
	identity.$inject = [];
	
	
	function valueFn(value) {return function valueRef() {return value;};}
	
	function hasCustomToString(obj) {
	  return isFunction(obj.toString) && obj.toString !== toString;
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isUndefined
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is undefined.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is undefined.
	 */
	function isUndefined(value) {return typeof value === 'undefined';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isDefined
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is defined.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is defined.
	 */
	function isDefined(value) {return typeof value !== 'undefined';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isObject
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is an `Object`. Unlike `typeof` in JavaScript, `null`s are not
	 * considered to be objects. Note that JavaScript arrays are objects.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is an `Object` but not `null`.
	 */
	function isObject(value) {
	  // http://jsperf.com/isobject4
	  return value !== null && typeof value === 'object';
	}
	
	
	/**
	 * Determine if a value is an object with a null prototype
	 *
	 * @returns {boolean} True if `value` is an `Object` with a null prototype
	 */
	function isBlankObject(value) {
	  return value !== null && typeof value === 'object' && !getPrototypeOf(value);
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isString
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a `String`.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `String`.
	 */
	function isString(value) {return typeof value === 'string';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isNumber
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a `Number`.
	 *
	 * This includes the "special" numbers `NaN`, `+Infinity` and `-Infinity`.
	 *
	 * If you wish to exclude these then you can use the native
	 * [`isFinite'](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/isFinite)
	 * method.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `Number`.
	 */
	function isNumber(value) {return typeof value === 'number';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isDate
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a value is a date.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `Date`.
	 */
	function isDate(value) {
	  return toString.call(value) === '[object Date]';
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isArray
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is an `Array`.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is an `Array`.
	 */
	function isArray(arr) {
	  return Array.isArray(arr) || arr instanceof Array;
	}
	
	/**
	 * @description
	 * Determines if a reference is an `Error`.
	 * Loosely based on https://www.npmjs.com/package/iserror
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is an `Error`.
	 */
	function isError(value) {
	  var tag = toString.call(value);
	  switch (tag) {
	    case '[object Error]': return true;
	    case '[object Exception]': return true;
	    case '[object DOMException]': return true;
	    default: return value instanceof Error;
	  }
	}
	
	/**
	 * @ngdoc function
	 * @name angular.isFunction
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a `Function`.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `Function`.
	 */
	function isFunction(value) {return typeof value === 'function';}
	
	
	/**
	 * Determines if a value is a regular expression object.
	 *
	 * @private
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `RegExp`.
	 */
	function isRegExp(value) {
	  return toString.call(value) === '[object RegExp]';
	}
	
	
	/**
	 * Checks if `obj` is a window object.
	 *
	 * @private
	 * @param {*} obj Object to check
	 * @returns {boolean} True if `obj` is a window obj.
	 */
	function isWindow(obj) {
	  return obj && obj.window === obj;
	}
	
	
	function isScope(obj) {
	  return obj && obj.$evalAsync && obj.$watch;
	}
	
	
	function isFile(obj) {
	  return toString.call(obj) === '[object File]';
	}
	
	
	function isFormData(obj) {
	  return toString.call(obj) === '[object FormData]';
	}
	
	
	function isBlob(obj) {
	  return toString.call(obj) === '[object Blob]';
	}
	
	
	function isBoolean(value) {
	  return typeof value === 'boolean';
	}
	
	
	function isPromiseLike(obj) {
	  return obj && isFunction(obj.then);
	}
	
	
	var TYPED_ARRAY_REGEXP = /^\[object (?:Uint8|Uint8Clamped|Uint16|Uint32|Int8|Int16|Int32|Float32|Float64)Array]$/;
	function isTypedArray(value) {
	  return value && isNumber(value.length) && TYPED_ARRAY_REGEXP.test(toString.call(value));
	}
	
	function isArrayBuffer(obj) {
	  return toString.call(obj) === '[object ArrayBuffer]';
	}
	
	
	var trim = function(value) {
	  return isString(value) ? value.trim() : value;
	};
	
	// Copied from:
	// http://docs.closure-library.googlecode.com/git/local_closure_goog_string_string.js.source.html#line1021
	// Prereq: s is a string.
	var escapeForRegexp = function(s) {
	  return s
	    .replace(/([-()[\]{}+?*.$^|,:#<!\\])/g, '\\$1')
	    // eslint-disable-next-line no-control-regex
	    .replace(/\x08/g, '\\x08');
	};
	
	
	/**
	 * @ngdoc function
	 * @name angular.isElement
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a DOM element (or wrapped jQuery element).
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a DOM element (or wrapped jQuery element).
	 */
	function isElement(node) {
	  return !!(node &&
	    (node.nodeName  // We are a direct element.
	    || (node.prop && node.attr && node.find)));  // We have an on and find method part of jQuery API.
	}
	
	/**
	 * @param str 'key1,key2,...'
	 * @returns {object} in the form of {key1:true, key2:true, ...}
	 */
	function makeMap(str) {
	  var obj = {}, items = str.split(','), i;
	  for (i = 0; i < items.length; i++) {
	    obj[items[i]] = true;
	  }
	  return obj;
	}
	
	
	function nodeName_(element) {
	  return lowercase(element.nodeName || (element[0] && element[0].nodeName));
	}
	
	function includes(array, obj) {
	  return Array.prototype.indexOf.call(array, obj) !== -1;
	}
	
	function arrayRemove(array, value) {
	  var index = array.indexOf(value);
	  if (index >= 0) {
	    array.splice(index, 1);
	  }
	  return index;
	}
	
	/**
	 * @ngdoc function
	 * @name angular.copy
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Creates a deep copy of `source`, which should be an object or an array. This functions is used
	 * internally, mostly in the change-detection code. It is not intended as an all-purpose copy
	 * function, and has several limitations (see below).
	 *
	 * * If no destination is supplied, a copy of the object or array is created.
	 * * If a destination is provided, all of its elements (for arrays) or properties (for objects)
	 *   are deleted and then all elements/properties from the source are copied to it.
	 * * If `source` is not an object or array (inc. `null` and `undefined`), `source` is returned.
	 * * If `source` is identical to `destination` an exception will be thrown.
	 *
	 * <br />
	 *
	 * <div class="alert alert-warning">
	 *   Only enumerable properties are taken into account. Non-enumerable properties (both on `source`
	 *   and on `destination`) will be ignored.
	 * </div>
	 *
	 * <div class="alert alert-warning">
	 *   `angular.copy` does not check if destination and source are of the same type. It's the
	 *   developer's responsibility to make sure they are compatible.
	 * </div>
	 *
	 * @knownIssue
	 * This is a non-exhaustive list of object types / features that are not handled correctly by
	 * `angular.copy`. Note that since this functions is used by the change detection code, this
	 * means binding or watching objects of these types (or that include these types) might not work
	 * correctly.
	 * - [`File`](https://developer.mozilla.org/docs/Web/API/File)
	 * - [`Map`](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Map)
	 * - [`ImageData`](https://developer.mozilla.org/docs/Web/API/ImageData)
	 * - [`MediaStream`](https://developer.mozilla.org/docs/Web/API/MediaStream)
	 * - [`Set`](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Set)
	 * - [`WeakMap`](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/WeakMap)
	 * - [`getter`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/get)/
	 *   [`setter`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/set)
	 *
	 * @param {*} source The source that will be used to make a copy. Can be any type, including
	 *     primitives, `null`, and `undefined`.
	 * @param {(Object|Array)=} destination Destination into which the source is copied. If provided,
	 *     must be of the same type as `source`.
	 * @returns {*} The copy or updated `destination`, if `destination` was specified.
	 *
	 * @example
	  <example module="copyExample" name="angular-copy">
	    <file name="index.html">
	      <div ng-controller="ExampleController">
	        <form novalidate class="simple-form">
	          <label>Name: <input type="text" ng-model="user.name" /></label><br />
	          <label>Age:  <input type="number" ng-model="user.age" /></label><br />
	          Gender: <label><input type="radio" ng-model="user.gender" value="male" />male</label>
	                  <label><input type="radio" ng-model="user.gender" value="female" />female</label><br />
	          <button ng-click="reset()">RESET</button>
	          <button ng-click="update(user)">SAVE</button>
	        </form>
	        <pre>form = {{user | json}}</pre>
	        <pre>leader = {{leader | json}}</pre>
	      </div>
	    </file>
	    <file name="script.js">
	      // Module: copyExample
	      angular.
	        module('copyExample', []).
	        controller('ExampleController', ['$scope', function($scope) {
	          $scope.leader = {};
	
	          $scope.reset = function() {
	            // Example with 1 argument
	            $scope.user = angular.copy($scope.leader);
	          };
	
	          $scope.update = function(user) {
	            // Example with 2 arguments
	            angular.copy(user, $scope.leader);
	          };
	
	          $scope.reset();
	        }]);
	    </file>
	  </example>
	 */
	function copy(source, destination, maxDepth) {
	  var stackSource = [];
	  var stackDest = [];
	  maxDepth = isValidObjectMaxDepth(maxDepth) ? maxDepth : NaN;
	
	  if (destination) {
	    if (isTypedArray(destination) || isArrayBuffer(destination)) {
	      throw ngMinErr('cpta', 'Can\'t copy! TypedArray destination cannot be mutated.');
	    }
	    if (source === destination) {
	      throw ngMinErr('cpi', 'Can\'t copy! Source and destination are identical.');
	    }
	
	    // Empty the destination object
	    if (isArray(destination)) {
	      destination.length = 0;
	    } else {
	      forEach(destination, function(value, key) {
	        if (key !== '$$hashKey') {
	          delete destination[key];
	        }
	      });
	    }
	
	    stackSource.push(source);
	    stackDest.push(destination);
	    return copyRecurse(source, destination, maxDepth);
	  }
	
	  return copyElement(source, maxDepth);
	
	  function copyRecurse(source, destination, maxDepth) {
	    maxDepth--;
	    if (maxDepth < 0) {
	      return '...';
	    }
	    var h = destination.$$hashKey;
	    var key;
	    if (isArray(source)) {
	      for (var i = 0, ii = source.length; i < ii; i++) {
	        destination.push(copyElement(source[i], maxDepth));
	      }
	    } else if (isBlankObject(source)) {
	      // createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
	      for (key in source) {
	        destination[key] = copyElement(source[key], maxDepth);
	      }
	    } else if (source && typeof source.hasOwnProperty === 'function') {
	      // Slow path, which must rely on hasOwnProperty
	      for (key in source) {
	        if (source.hasOwnProperty(key)) {
	          destination[key] = copyElement(source[key], maxDepth);
	        }
	      }
	    } else {
	      // Slowest path --- hasOwnProperty can't be called as a method
	      for (key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          destination[key] = copyElement(source[key], maxDepth);
	        }
	      }
	    }
	    setHashKey(destination, h);
	    return destination;
	  }
	
	  function copyElement(source, maxDepth) {
	    // Simple values
	    if (!isObject(source)) {
	      return source;
	    }
	
	    // Already copied values
	    var index = stackSource.indexOf(source);
	    if (index !== -1) {
	      return stackDest[index];
	    }
	
	    if (isWindow(source) || isScope(source)) {
	      throw ngMinErr('cpws',
	        'Can\'t copy! Making copies of Window or Scope instances is not supported.');
	    }
	
	    var needsRecurse = false;
	    var destination = copyType(source);
	
	    if (destination === undefined) {
	      destination = isArray(source) ? [] : Object.create(getPrototypeOf(source));
	      needsRecurse = true;
	    }
	
	    stackSource.push(source);
	    stackDest.push(destination);
	
	    return needsRecurse
	      ? copyRecurse(source, destination, maxDepth)
	      : destination;
	  }
	
	  function copyType(source) {
	    switch (toString.call(source)) {
	      case '[object Int8Array]':
	      case '[object Int16Array]':
	      case '[object Int32Array]':
	      case '[object Float32Array]':
	      case '[object Float64Array]':
	      case '[object Uint8Array]':
	      case '[object Uint8ClampedArray]':
	      case '[object Uint16Array]':
	      case '[object Uint32Array]':
	        return new source.constructor(copyElement(source.buffer), source.byteOffset, source.length);
	
	      case '[object ArrayBuffer]':
	        // Support: IE10
	        if (!source.slice) {
	          // If we're in this case we know the environment supports ArrayBuffer
	          /* eslint-disable no-undef */
	          var copied = new ArrayBuffer(source.byteLength);
	          new Uint8Array(copied).set(new Uint8Array(source));
	          /* eslint-enable */
	          return copied;
	        }
	        return source.slice(0);
	
	      case '[object Boolean]':
	      case '[object Number]':
	      case '[object String]':
	      case '[object Date]':
	        return new source.constructor(source.valueOf());
	
	      case '[object RegExp]':
	        var re = new RegExp(source.source, source.toString().match(/[^/]*$/)[0]);
	        re.lastIndex = source.lastIndex;
	        return re;
	
	      case '[object Blob]':
	        return new source.constructor([source], {type: source.type});
	    }
	
	    if (isFunction(source.cloneNode)) {
	      return source.cloneNode(true);
	    }
	  }
	}
	
	
	// eslint-disable-next-line no-self-compare
	function simpleCompare(a, b) { return a === b || (a !== a && b !== b); }
	
	
	/**
	 * @ngdoc function
	 * @name angular.equals
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if two objects or two values are equivalent. Supports value types, regular
	 * expressions, arrays and objects.
	 *
	 * Two objects or values are considered equivalent if at least one of the following is true:
	 *
	 * * Both objects or values pass `===` comparison.
	 * * Both objects or values are of the same type and all of their properties are equal by
	 *   comparing them with `angular.equals`.
	 * * Both values are NaN. (In JavaScript, NaN == NaN => false. But we consider two NaN as equal)
	 * * Both values represent the same regular expression (In JavaScript,
	 *   /abc/ == /abc/ => false. But we consider two regular expressions as equal when their textual
	 *   representation matches).
	 *
	 * During a property comparison, properties of `function` type and properties with names
	 * that begin with `$` are ignored.
	 *
	 * Scope and DOMWindow objects are being compared only by identify (`===`).
	 *
	 * @param {*} o1 Object or value to compare.
	 * @param {*} o2 Object or value to compare.
	 * @returns {boolean} True if arguments are equal.
	 *
	 * @example
	   <example module="equalsExample" name="equalsExample">
	     <file name="index.html">
	      <div ng-controller="ExampleController">
	        <form novalidate>
	          <h3>User 1</h3>
	          Name: <input type="text" ng-model="user1.name">
	          Age: <input type="number" ng-model="user1.age">
	
	          <h3>User 2</h3>
	          Name: <input type="text" ng-model="user2.name">
	          Age: <input type="number" ng-model="user2.age">
	
	          <div>
	            <br/>
	            <input type="button" value="Compare" ng-click="compare()">
	          </div>
	          User 1: <pre>{{user1 | json}}</pre>
	          User 2: <pre>{{user2 | json}}</pre>
	          Equal: <pre>{{result}}</pre>
	        </form>
	      </div>
	    </file>
	    <file name="script.js">
	        angular.module('equalsExample', []).controller('ExampleController', ['$scope', function($scope) {
	          $scope.user1 = {};
	          $scope.user2 = {};
	          $scope.compare = function() {
	            $scope.result = angular.equals($scope.user1, $scope.user2);
	          };
	        }]);
	    </file>
	  </example>
	 */
	function equals(o1, o2) {
	  if (o1 === o2) return true;
	  if (o1 === null || o2 === null) return false;
	  // eslint-disable-next-line no-self-compare
	  if (o1 !== o1 && o2 !== o2) return true; // NaN === NaN
	  var t1 = typeof o1, t2 = typeof o2, length, key, keySet;
	  if (t1 === t2 && t1 === 'object') {
	    if (isArray(o1)) {
	      if (!isArray(o2)) return false;
	      if ((length = o1.length) === o2.length) {
	        for (key = 0; key < length; key++) {
	          if (!equals(o1[key], o2[key])) return false;
	        }
	        return true;
	      }
	    } else if (isDate(o1)) {
	      if (!isDate(o2)) return false;
	      return simpleCompare(o1.getTime(), o2.getTime());
	    } else if (isRegExp(o1)) {
	      if (!isRegExp(o2)) return false;
	      return o1.toString() === o2.toString();
	    } else {
	      if (isScope(o1) || isScope(o2) || isWindow(o1) || isWindow(o2) ||
	        isArray(o2) || isDate(o2) || isRegExp(o2)) return false;
	      keySet = createMap();
	      for (key in o1) {
	        if (key.charAt(0) === '$' || isFunction(o1[key])) continue;
	        if (!equals(o1[key], o2[key])) return false;
	        keySet[key] = true;
	      }
	      for (key in o2) {
	        if (!(key in keySet) &&
	            key.charAt(0) !== '$' &&
	            isDefined(o2[key]) &&
	            !isFunction(o2[key])) return false;
	      }
	      return true;
	    }
	  }
	  return false;
	}
	
	var csp = function() {
	  if (!isDefined(csp.rules)) {
	
	
	    var ngCspElement = (window.document.querySelector('[ng-csp]') ||
	                    window.document.querySelector('[data-ng-csp]'));
	
	    if (ngCspElement) {
	      var ngCspAttribute = ngCspElement.getAttribute('ng-csp') ||
	                    ngCspElement.getAttribute('data-ng-csp');
	      csp.rules = {
	        noUnsafeEval: !ngCspAttribute || (ngCspAttribute.indexOf('no-unsafe-eval') !== -1),
	        noInlineStyle: !ngCspAttribute || (ngCspAttribute.indexOf('no-inline-style') !== -1)
	      };
	    } else {
	      csp.rules = {
	        noUnsafeEval: noUnsafeEval(),
	        noInlineStyle: false
	      };
	    }
	  }
	
	  return csp.rules;
	
	  function noUnsafeEval() {
	    try {
	      // eslint-disable-next-line no-new, no-new-func
	      new Function('');
	      return false;
	    } catch (e) {
	      return true;
	    }
	  }
	};
	
	/**
	 * @ngdoc directive
	 * @module ng
	 * @name ngJq
	 *
	 * @element ANY
	 * @param {string=} ngJq the name of the library available under `window`
	 * to be used for angular.element
	 * @description
	 * Use this directive to force the angular.element library.  This should be
	 * used to force either jqLite by leaving ng-jq blank or setting the name of
	 * the jquery variable under window (eg. jQuery).
	 *
	 * Since AngularJS looks for this directive when it is loaded (doesn't wait for the
	 * DOMContentLoaded event), it must be placed on an element that comes before the script
	 * which loads angular. Also, only the first instance of `ng-jq` will be used and all
	 * others ignored.
	 *
	 * @example
	 * This example shows how to force jqLite using the `ngJq` directive to the `html` tag.
	 ```html
	 <!doctype html>
	 <html ng-app ng-jq>
	 ...
	 ...
	 </html>
	 ```
	 * @example
	 * This example shows how to use a jQuery based library of a different name.
	 * The library name must be available at the top most 'window'.
	 ```html
	 <!doctype html>
	 <html ng-app ng-jq="jQueryLib">
	 ...
	 ...
	 </html>
	 ```
	 */
	var jq = function() {
	  if (isDefined(jq.name_)) return jq.name_;
	  var el;
	  var i, ii = ngAttrPrefixes.length, prefix, name;
	  for (i = 0; i < ii; ++i) {
	    prefix = ngAttrPrefixes[i];
	    el = window.document.querySelector('[' + prefix.replace(':', '\\:') + 'jq]');
	    if (el) {
	      name = el.getAttribute(prefix + 'jq');
	      break;
	    }
	  }
	
	  return (jq.name_ = name);
	};
	
	function concat(array1, array2, index) {
	  return array1.concat(slice.call(array2, index));
	}
	
	function sliceArgs(args, startIndex) {
	  return slice.call(args, startIndex || 0);
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.bind
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Returns a function which calls function `fn` bound to `self` (`self` becomes the `this` for
	 * `fn`). You can supply optional `args` that are prebound to the function. This feature is also
	 * known as [partial application](http://en.wikipedia.org/wiki/Partial_application), as
	 * distinguished from [function currying](http://en.wikipedia.org/wiki/Currying#Contrast_with_partial_function_application).
	 *
	 * @param {Object} self Context which `fn` should be evaluated in.
	 * @param {function()} fn Function to be bound.
	 * @param {...*} args Optional arguments to be prebound to the `fn` function call.
	 * @returns {function()} Function that wraps the `fn` with all the specified bindings.
	 */
	function bind(self, fn) {
	  var curryArgs = arguments.length > 2 ? sliceArgs(arguments, 2) : [];
	  if (isFunction(fn) && !(fn instanceof RegExp)) {
	    return curryArgs.length
	      ? function() {
	          return arguments.length
	            ? fn.apply(self, concat(curryArgs, arguments, 0))
	            : fn.apply(self, curryArgs);
	        }
	      : function() {
	          return arguments.length
	            ? fn.apply(self, arguments)
	            : fn.call(self);
	        };
	  } else {
	    // In IE, native methods are not functions so they cannot be bound (note: they don't need to be).
	    return fn;
	  }
	}
	
	
	function toJsonReplacer(key, value) {
	  var val = value;
	
	  if (typeof key === 'string' && key.charAt(0) === '$' && key.charAt(1) === '$') {
	    val = undefined;
	  } else if (isWindow(value)) {
	    val = '$WINDOW';
	  } else if (value &&  window.document === value) {
	    val = '$DOCUMENT';
	  } else if (isScope(value)) {
	    val = '$SCOPE';
	  }
	
	  return val;
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.toJson
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Serializes input into a JSON-formatted string. Properties with leading $$ characters will be
	 * stripped since AngularJS uses this notation internally.
	 *
	 * @param {Object|Array|Date|string|number|boolean} obj Input to be serialized into JSON.
	 * @param {boolean|number} [pretty=2] If set to true, the JSON output will contain newlines and whitespace.
	 *    If set to an integer, the JSON output will contain that many spaces per indentation.
	 * @returns {string|undefined} JSON-ified string representing `obj`.
	 * @knownIssue
	 *
	 * The Safari browser throws a `RangeError` instead of returning `null` when it tries to stringify a `Date`
	 * object with an invalid date value. The only reliable way to prevent this is to monkeypatch the
	 * `Date.prototype.toJSON` method as follows:
	 *
	 * ```
	 * var _DatetoJSON = Date.prototype.toJSON;
	 * Date.prototype.toJSON = function() {
	 *   try {
	 *     return _DatetoJSON.call(this);
	 *   } catch(e) {
	 *     if (e instanceof RangeError) {
	 *       return null;
	 *     }
	 *     throw e;
	 *   }
	 * };
	 * ```
	 *
	 * See https://github.com/angular/angular.js/pull/14221 for more information.
	 */
	function toJson(obj, pretty) {
	  if (isUndefined(obj)) return undefined;
	  if (!isNumber(pretty)) {
	    pretty = pretty ? 2 : null;
	  }
	  return JSON.stringify(obj, toJsonReplacer, pretty);
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.fromJson
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Deserializes a JSON string.
	 *
	 * @param {string} json JSON string to deserialize.
	 * @returns {Object|Array|string|number} Deserialized JSON string.
	 */
	function fromJson(json) {
	  return isString(json)
	      ? JSON.parse(json)
	      : json;
	}
	
	
	var ALL_COLONS = /:/g;
	function timezoneToOffset(timezone, fallback) {
	  // Support: IE 9-11 only, Edge 13-15+
	  // IE/Edge do not "understand" colon (`:`) in timezone
	  timezone = timezone.replace(ALL_COLONS, '');
	  var requestedTimezoneOffset = Date.parse('Jan 01, 1970 00:00:00 ' + timezone) / 60000;
	  return isNumberNaN(requestedTimezoneOffset) ? fallback : requestedTimezoneOffset;
	}
	
	
	function addDateMinutes(date, minutes) {
	  date = new Date(date.getTime());
	  date.setMinutes(date.getMinutes() + minutes);
	  return date;
	}
	
	
	function convertTimezoneToLocal(date, timezone, reverse) {
	  reverse = reverse ? -1 : 1;
	  var dateTimezoneOffset = date.getTimezoneOffset();
	  var timezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
	  return addDateMinutes(date, reverse * (timezoneOffset - dateTimezoneOffset));
	}
	
	
	/**
	 * @returns {string} Returns the string representation of the element.
	 */
	function startingTag(element) {
	  element = jqLite(element).clone().empty();
	  var elemHtml = jqLite('<div></div>').append(element).html();
	  try {
	    return element[0].nodeType === NODE_TYPE_TEXT ? lowercase(elemHtml) :
	        elemHtml.
	          match(/^(<[^>]+>)/)[1].
	          replace(/^<([\w-]+)/, function(match, nodeName) {return '<' + lowercase(nodeName);});
	  } catch (e) {
	    return lowercase(elemHtml);
	  }
	
	}
	
	
	/////////////////////////////////////////////////
	
	/**
	 * Tries to decode the URI component without throwing an exception.
	 *
	 * @private
	 * @param str value potential URI component to check.
	 * @returns {boolean} True if `value` can be decoded
	 * with the decodeURIComponent function.
	 */
	function tryDecodeURIComponent(value) {
	  try {
	    return decodeURIComponent(value);
	  } catch (e) {
	    // Ignore any invalid uri component.
	  }
	}
	
	
	/**
	 * Parses an escaped url query string into key-value pairs.
	 * @returns {Object.<string,boolean|Array>}
	 */
	function parseKeyValue(/**string*/keyValue) {
	  var obj = {};
	  forEach((keyValue || '').split('&'), function(keyValue) {
	    var splitPoint, key, val;
	    if (keyValue) {
	      key = keyValue = keyValue.replace(/\+/g,'%20');
	      splitPoint = keyValue.indexOf('=');
	      if (splitPoint !== -1) {
	        key = keyValue.substring(0, splitPoint);
	        val = keyValue.substring(splitPoint + 1);
	      }
	      key = tryDecodeURIComponent(key);
	      if (isDefined(key)) {
	        val = isDefined(val) ? tryDecodeURIComponent(val) : true;
	        if (!hasOwnProperty.call(obj, key)) {
	          obj[key] = val;
	        } else if (isArray(obj[key])) {
	          obj[key].push(val);
	        } else {
	          obj[key] = [obj[key],val];
	        }
	      }
	    }
	  });
	  return obj;
	}
	
	function toKeyValue(obj) {
	  var parts = [];
	  forEach(obj, function(value, key) {
	    if (isArray(value)) {
	      forEach(value, function(arrayValue) {
	        parts.push(encodeUriQuery(key, true) +
	                   (arrayValue === true ? '' : '=' + encodeUriQuery(arrayValue, true)));
	      });
	    } else {
	    parts.push(encodeUriQuery(key, true) +
	               (value === true ? '' : '=' + encodeUriQuery(value, true)));
	    }
	  });
	  return parts.length ? parts.join('&') : '';
	}
	
	
	/**
	 * We need our custom method because encodeURIComponent is too aggressive and doesn't follow
	 * http://www.ietf.org/rfc/rfc3986.txt with regards to the character set (pchar) allowed in path
	 * segments:
	 *    segment       = *pchar
	 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
	 *    pct-encoded   = "%" HEXDIG HEXDIG
	 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
	 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
	 *                     / "*" / "+" / "," / ";" / "="
	 */
	function encodeUriSegment(val) {
	  return encodeUriQuery(val, true).
	             replace(/%26/gi, '&').
	             replace(/%3D/gi, '=').
	             replace(/%2B/gi, '+');
	}
	
	
	/**
	 * This method is intended for encoding *key* or *value* parts of query component. We need a custom
	 * method because encodeURIComponent is too aggressive and encodes stuff that doesn't have to be
	 * encoded per http://tools.ietf.org/html/rfc3986:
	 *    query         = *( pchar / "/" / "?" )
	 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
	 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
	 *    pct-encoded   = "%" HEXDIG HEXDIG
	 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
	 *                     / "*" / "+" / "," / ";" / "="
	 */
	function encodeUriQuery(val, pctEncodeSpaces) {
	  return encodeURIComponent(val).
	             replace(/%40/gi, '@').
	             replace(/%3A/gi, ':').
	             replace(/%24/g, '$').
	             replace(/%2C/gi, ',').
	             replace(/%3B/gi, ';').
	             replace(/%20/g, (pctEncodeSpaces ? '%20' : '+'));
	}
	
	var ngAttrPrefixes = ['ng-', 'data-ng-', 'ng:', 'x-ng-'];
	
	function getNgAttribute(element, ngAttr) {
	  var attr, i, ii = ngAttrPrefixes.length;
	  for (i = 0; i < ii; ++i) {
	    attr = ngAttrPrefixes[i] + ngAttr;
	    if (isString(attr = element.getAttribute(attr))) {
	      return attr;
	    }
	  }
	  return null;
	}
	
	function allowAutoBootstrap(document) {
	  var script = document.currentScript;
	
	  if (!script) {
	    // Support: IE 9-11 only
	    // IE does not have `document.currentScript`
	    return true;
	  }
	
	  // If the `currentScript` property has been clobbered just return false, since this indicates a probable attack
	  if (!(script instanceof window.HTMLScriptElement || script instanceof window.SVGScriptElement)) {
	    return false;
	  }
	
	  var attributes = script.attributes;
	  var srcs = [attributes.getNamedItem('src'), attributes.getNamedItem('href'), attributes.getNamedItem('xlink:href')];
	
	  return srcs.every(function(src) {
	    if (!src) {
	      return true;
	    }
	    if (!src.value) {
	      return false;
	    }
	
	    var link = document.createElement('a');
	    link.href = src.value;
	
	    if (document.location.origin === link.origin) {
	      // Same-origin resources are always allowed, even for banned URL schemes.
	      return true;
	    }
	    // Disabled bootstrapping unless angular.js was loaded from a known scheme used on the web.
	    // This is to prevent angular.js bundled with browser extensions from being used to bypass the
	    // content security policy in web pages and other browser extensions.
	    switch (link.protocol) {
	      case 'http:':
	      case 'https:':
	      case 'ftp:':
	      case 'blob:':
	      case 'file:':
	      case 'data:':
	        return true;
	      default:
	        return false;
	    }
	  });
	}
	
	// Cached as it has to run during loading so that document.currentScript is available.
	var isAutoBootstrapAllowed = allowAutoBootstrap(window.document);
	
	/**
	 * @ngdoc directive
	 * @name ngApp
	 * @module ng
	 *
	 * @element ANY
	 * @param {angular.Module} ngApp an optional application
	 *   {@link angular.module module} name to load.
	 * @param {boolean=} ngStrictDi if this attribute is present on the app element, the injector will be
	 *   created in "strict-di" mode. This means that the application will fail to invoke functions which
	 *   do not use explicit function annotation (and are thus unsuitable for minification), as described
	 *   in {@link guide/di the Dependency Injection guide}, and useful debugging info will assist in
	 *   tracking down the root of these bugs.
	 *
	 * @description
	 *
	 * Use this directive to **auto-bootstrap** an AngularJS application. The `ngApp` directive
	 * designates the **root element** of the application and is typically placed near the root element
	 * of the page - e.g. on the `<body>` or `<html>` tags.
	 *
	 * There are a few things to keep in mind when using `ngApp`:
	 * - only one AngularJS application can be auto-bootstrapped per HTML document. The first `ngApp`
	 *   found in the document will be used to define the root element to auto-bootstrap as an
	 *   application. To run multiple applications in an HTML document you must manually bootstrap them using
	 *   {@link angular.bootstrap} instead.
	 * - AngularJS applications cannot be nested within each other.
	 * - Do not use a directive that uses {@link ng.$compile#transclusion transclusion} on the same element as `ngApp`.
	 *   This includes directives such as {@link ng.ngIf `ngIf`}, {@link ng.ngInclude `ngInclude`} and
	 *   {@link ngRoute.ngView `ngView`}.
	 *   Doing this misplaces the app {@link ng.$rootElement `$rootElement`} and the app's {@link auto.$injector injector},
	 *   causing animations to stop working and making the injector inaccessible from outside the app.
	 *
	 * You can specify an **AngularJS module** to be used as the root module for the application.  This
	 * module will be loaded into the {@link auto.$injector} when the application is bootstrapped. It
	 * should contain the application code needed or have dependencies on other modules that will
	 * contain the code. See {@link angular.module} for more information.
	 *
	 * In the example below if the `ngApp` directive were not placed on the `html` element then the
	 * document would not be compiled, the `AppController` would not be instantiated and the `{{ a+b }}`
	 * would not be resolved to `3`.
	 *
	 * @example
	 *
	 * ### Simple Usage
	 *
	 * `ngApp` is the easiest, and most common way to bootstrap an application.
	 *
	 <example module="ngAppDemo" name="ng-app">
	   <file name="index.html">
	   <div ng-controller="ngAppDemoController">
	     I can add: {{a}} + {{b}} =  {{ a+b }}
	   </div>
	   </file>
	   <file name="script.js">
	   angular.module('ngAppDemo', []).controller('ngAppDemoController', function($scope) {
	     $scope.a = 1;
	     $scope.b = 2;
	   });
	   </file>
	 </example>
	 *
	 * @example
	 *
	 * ### With `ngStrictDi`
	 *
	 * Using `ngStrictDi`, you would see something like this:
	 *
	 <example ng-app-included="true" name="strict-di">
	   <file name="index.html">
	   <div ng-app="ngAppStrictDemo" ng-strict-di>
	       <div ng-controller="GoodController1">
	           I can add: {{a}} + {{b}} =  {{ a+b }}
	
	           <p>This renders because the controller does not fail to
	              instantiate, by using explicit annotation style (see
	              script.js for details)
	           </p>
	       </div>
	
	       <div ng-controller="GoodController2">
	           Name: <input ng-model="name"><br />
	           Hello, {{name}}!
	
	           <p>This renders because the controller does not fail to
	              instantiate, by using explicit annotation style
	              (see script.js for details)
	           </p>
	       </div>
	
	       <div ng-controller="BadController">
	           I can add: {{a}} + {{b}} =  {{ a+b }}
	
	           <p>The controller could not be instantiated, due to relying
	              on automatic function annotations (which are disabled in
	              strict mode). As such, the content of this section is not
	              interpolated, and there should be an error in your web console.
	           </p>
	       </div>
	   </div>
	   </file>
	   <file name="script.js">
	   angular.module('ngAppStrictDemo', [])
	     // BadController will fail to instantiate, due to relying on automatic function annotation,
	     // rather than an explicit annotation
	     .controller('BadController', function($scope) {
	       $scope.a = 1;
	       $scope.b = 2;
	     })
	     // Unlike BadController, GoodController1 and GoodController2 will not fail to be instantiated,
	     // due to using explicit annotations using the array style and $inject property, respectively.
	     .controller('GoodController1', ['$scope', function($scope) {
	       $scope.a = 1;
	       $scope.b = 2;
	     }])
	     .controller('GoodController2', GoodController2);
	     function GoodController2($scope) {
	       $scope.name = 'World';
	     }
	     GoodController2.$inject = ['$scope'];
	   </file>
	   <file name="style.css">
	   div[ng-controller] {
	       margin-bottom: 1em;
	       -webkit-border-radius: 4px;
	       border-radius: 4px;
	       border: 1px solid;
	       padding: .5em;
	   }
	   div[ng-controller^=Good] {
	       border-color: #d6e9c6;
	       background-color: #dff0d8;
	       color: #3c763d;
	   }
	   div[ng-controller^=Bad] {
	       border-color: #ebccd1;
	       background-color: #f2dede;
	       color: #a94442;
	       margin-bottom: 0;
	   }
	   </file>
	 </example>
	 */
	function angularInit(element, bootstrap) {
	  var appElement,
	      module,
	      config = {};
	
	  // The element `element` has priority over any other element.
	  forEach(ngAttrPrefixes, function(prefix) {
	    var name = prefix + 'app';
	
	    if (!appElement && element.hasAttribute && element.hasAttribute(name)) {
	      appElement = element;
	      module = element.getAttribute(name);
	    }
	  });
	  forEach(ngAttrPrefixes, function(prefix) {
	    var name = prefix + 'app';
	    var candidate;
	
	    if (!appElement && (candidate = element.querySelector('[' + name.replace(':', '\\:') + ']'))) {
	      appElement = candidate;
	      module = candidate.getAttribute(name);
	    }
	  });
	  if (appElement) {
	    if (!isAutoBootstrapAllowed) {
	      window.console.error('AngularJS: disabling automatic bootstrap. <script> protocol indicates ' +
	          'an extension, document.location.href does not match.');
	      return;
	    }
	    config.strictDi = getNgAttribute(appElement, 'strict-di') !== null;
	    bootstrap(appElement, module ? [module] : [], config);
	  }
	}
	
	/**
	 * @ngdoc function
	 * @name angular.bootstrap
	 * @module ng
	 * @description
	 * Use this function to manually start up AngularJS application.
	 *
	 * For more information, see the {@link guide/bootstrap Bootstrap guide}.
	 *
	 * AngularJS will detect if it has been loaded into the browser more than once and only allow the
	 * first loaded script to be bootstrapped and will report a warning to the browser console for
	 * each of the subsequent scripts. This prevents strange results in applications, where otherwise
	 * multiple instances of AngularJS try to work on the DOM.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Protractor based end-to-end tests cannot use this function to bootstrap manually.
	 * They must use {@link ng.directive:ngApp ngApp}.
	 * </div>
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Do not bootstrap the app on an element with a directive that uses {@link ng.$compile#transclusion transclusion},
	 * such as {@link ng.ngIf `ngIf`}, {@link ng.ngInclude `ngInclude`} and {@link ngRoute.ngView `ngView`}.
	 * Doing this misplaces the app {@link ng.$rootElement `$rootElement`} and the app's {@link auto.$injector injector},
	 * causing animations to stop working and making the injector inaccessible from outside the app.
	 * </div>
	 *
	 * ```html
	 * <!doctype html>
	 * <html>
	 * <body>
	 * <div ng-controller="WelcomeController">
	 *   {{greeting}}
	 * </div>
	 *
	 * <script src="angular.js"></script>
	 * <script>
	 *   var app = angular.module('demo', [])
	 *   .controller('WelcomeController', function($scope) {
	 *       $scope.greeting = 'Welcome!';
	 *   });
	 *   angular.bootstrap(document, ['demo']);
	 * </script>
	 * </body>
	 * </html>
	 * ```
	 *
	 * @param {DOMElement} element DOM element which is the root of AngularJS application.
	 * @param {Array<String|Function|Array>=} modules an array of modules to load into the application.
	 *     Each item in the array should be the name of a predefined module or a (DI annotated)
	 *     function that will be invoked by the injector as a `config` block.
	 *     See: {@link angular.module modules}
	 * @param {Object=} config an object for defining configuration options for the application. The
	 *     following keys are supported:
	 *
	 * * `strictDi` - disable automatic function annotation for the application. This is meant to
	 *   assist in finding bugs which break minified code. Defaults to `false`.
	 *
	 * @returns {auto.$injector} Returns the newly created injector for this app.
	 */
	function bootstrap(element, modules, config) {
	  if (!isObject(config)) config = {};
	  var defaultConfig = {
	    strictDi: false
	  };
	  config = extend(defaultConfig, config);
	  var doBootstrap = function() {
	    element = jqLite(element);
	
	    if (element.injector()) {
	      var tag = (element[0] === window.document) ? 'document' : startingTag(element);
	      // Encode angle brackets to prevent input from being sanitized to empty string #8683.
	      throw ngMinErr(
	          'btstrpd',
	          'App already bootstrapped with this element \'{0}\'',
	          tag.replace(/</,'&lt;').replace(/>/,'&gt;'));
	    }
	
	    modules = modules || [];
	    modules.unshift(['$provide', function($provide) {
	      $provide.value('$rootElement', element);
	    }]);
	
	    if (config.debugInfoEnabled) {
	      // Pushing so that this overrides `debugInfoEnabled` setting defined in user's `modules`.
	      modules.push(['$compileProvider', function($compileProvider) {
	        $compileProvider.debugInfoEnabled(true);
	      }]);
	    }
	
	    modules.unshift('ng');
	    var injector = createInjector(modules, config.strictDi);
	    injector.invoke(['$rootScope', '$rootElement', '$compile', '$injector',
	       function bootstrapApply(scope, element, compile, injector) {
	        scope.$apply(function() {
	          element.data('$injector', injector);
	          compile(element)(scope);
	        });
	      }]
	    );
	    return injector;
	  };
	
	  var NG_ENABLE_DEBUG_INFO = /^NG_ENABLE_DEBUG_INFO!/;
	  var NG_DEFER_BOOTSTRAP = /^NG_DEFER_BOOTSTRAP!/;
	
	  if (window && NG_ENABLE_DEBUG_INFO.test(window.name)) {
	    config.debugInfoEnabled = true;
	    window.name = window.name.replace(NG_ENABLE_DEBUG_INFO, '');
	  }
	
	  if (window && !NG_DEFER_BOOTSTRAP.test(window.name)) {
	    return doBootstrap();
	  }
	
	  window.name = window.name.replace(NG_DEFER_BOOTSTRAP, '');
	  angular.resumeBootstrap = function(extraModules) {
	    forEach(extraModules, function(module) {
	      modules.push(module);
	    });
	    return doBootstrap();
	  };
	
	  if (isFunction(angular.resumeDeferredBootstrap)) {
	    angular.resumeDeferredBootstrap();
	  }
	}
	
	/**
	 * @ngdoc function
	 * @name angular.reloadWithDebugInfo
	 * @module ng
	 * @description
	 * Use this function to reload the current application with debug information turned on.
	 * This takes precedence over a call to `$compileProvider.debugInfoEnabled(false)`.
	 *
	 * See {@link ng.$compileProvider#debugInfoEnabled} for more.
	 */
	function reloadWithDebugInfo() {
	  window.name = 'NG_ENABLE_DEBUG_INFO!' + window.name;
	  window.location.reload();
	}
	
	/**
	 * @name angular.getTestability
	 * @module ng
	 * @description
	 * Get the testability service for the instance of AngularJS on the given
	 * element.
	 * @param {DOMElement} element DOM element which is the root of AngularJS application.
	 */
	function getTestability(rootElement) {
	  var injector = angular.element(rootElement).injector();
	  if (!injector) {
	    throw ngMinErr('test',
	      'no injector found for element argument to getTestability');
	  }
	  return injector.get('$$testability');
	}
	
	var SNAKE_CASE_REGEXP = /[A-Z]/g;
	function snake_case(name, separator) {
	  separator = separator || '_';
	  return name.replace(SNAKE_CASE_REGEXP, function(letter, pos) {
	    return (pos ? separator : '') + letter.toLowerCase();
	  });
	}
	
	var bindJQueryFired = false;
	function bindJQuery() {
	  var originalCleanData;
	
	  if (bindJQueryFired) {
	    return;
	  }
	
	  // bind to jQuery if present;
	  var jqName = jq();
	  jQuery = isUndefined(jqName) ? window.jQuery :   // use jQuery (if present)
	           !jqName             ? undefined     :   // use jqLite
	                                 window[jqName];   // use jQuery specified by `ngJq`
	
	  // Use jQuery if it exists with proper functionality, otherwise default to us.
	  // AngularJS 1.2+ requires jQuery 1.7+ for on()/off() support.
	  // AngularJS 1.3+ technically requires at least jQuery 2.1+ but it may work with older
	  // versions. It will not work for sure with jQuery <1.7, though.
	  if (jQuery && jQuery.fn.on) {
	    jqLite = jQuery;
	    extend(jQuery.fn, {
	      scope: JQLitePrototype.scope,
	      isolateScope: JQLitePrototype.isolateScope,
	      controller: /** @type {?} */ (JQLitePrototype).controller,
	      injector: JQLitePrototype.injector,
	      inheritedData: JQLitePrototype.inheritedData
	    });
	  } else {
	    jqLite = JQLite;
	  }
	
	  // All nodes removed from the DOM via various jqLite/jQuery APIs like .remove()
	  // are passed through jqLite/jQuery.cleanData. Monkey-patch this method to fire
	  // the $destroy event on all removed nodes.
	  originalCleanData = jqLite.cleanData;
	  jqLite.cleanData = function(elems) {
	    var events;
	    for (var i = 0, elem; (elem = elems[i]) != null; i++) {
	      events = (jqLite._data(elem) || {}).events;
	      if (events && events.$destroy) {
	        jqLite(elem).triggerHandler('$destroy');
	      }
	    }
	    originalCleanData(elems);
	  };
	
	  angular.element = jqLite;
	
	  // Prevent double-proxying.
	  bindJQueryFired = true;
	}
	
	/**
	 * @ngdoc function
	 * @name angular.UNSAFE_restoreLegacyJqLiteXHTMLReplacement
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Restores the pre-1.8 behavior of jqLite that turns XHTML-like strings like
	 * `<div /><span />` to `<div></div><span></span>` instead of `<div><span></span></div>`.
	 * The new behavior is a security fix. Thus, if you need to call this function, please try to adjust
	 * your code for this change and remove your use of this function as soon as possible.
	
	 * Note that this only patches jqLite. If you use jQuery 3.5.0 or newer, please read the
	 * [jQuery 3.5 upgrade guide](https://jquery.com/upgrade-guide/3.5/) for more details
	 * about the workarounds.
	 */
	function UNSAFE_restoreLegacyJqLiteXHTMLReplacement() {
	  JQLite.legacyXHTMLReplacement = true;
	}
	
	/**
	 * throw error if the argument is falsy.
	 */
	function assertArg(arg, name, reason) {
	  if (!arg) {
	    throw ngMinErr('areq', 'Argument \'{0}\' is {1}', (name || '?'), (reason || 'required'));
	  }
	  return arg;
	}
	
	function assertArgFn(arg, name, acceptArrayAnnotation) {
	  if (acceptArrayAnnotation && isArray(arg)) {
	      arg = arg[arg.length - 1];
	  }
	
	  assertArg(isFunction(arg), name, 'not a function, got ' +
	      (arg && typeof arg === 'object' ? arg.constructor.name || 'Object' : typeof arg));
	  return arg;
	}
	
	/**
	 * throw error if the name given is hasOwnProperty
	 * @param  {String} name    the name to test
	 * @param  {String} context the context in which the name is used, such as module or directive
	 */
	function assertNotHasOwnProperty(name, context) {
	  if (name === 'hasOwnProperty') {
	    throw ngMinErr('badname', 'hasOwnProperty is not a valid {0} name', context);
	  }
	}
	
	/**
	 * Return the value accessible from the object by path. Any undefined traversals are ignored
	 * @param {Object} obj starting object
	 * @param {String} path path to traverse
	 * @param {boolean} [bindFnToScope=true]
	 * @returns {Object} value as accessible by path
	 */
	//TODO(misko): this function needs to be removed
	function getter(obj, path, bindFnToScope) {
	  if (!path) return obj;
	  var keys = path.split('.');
	  var key;
	  var lastInstance = obj;
	  var len = keys.length;
	
	  for (var i = 0; i < len; i++) {
	    key = keys[i];
	    if (obj) {
	      obj = (lastInstance = obj)[key];
	    }
	  }
	  if (!bindFnToScope && isFunction(obj)) {
	    return bind(lastInstance, obj);
	  }
	  return obj;
	}
	
	/**
	 * Return the DOM siblings between the first and last node in the given array.
	 * @param {Array} array like object
	 * @returns {Array} the inputted object or a jqLite collection containing the nodes
	 */
	function getBlockNodes(nodes) {
	  // TODO(perf): update `nodes` instead of creating a new object?
	  var node = nodes[0];
	  var endNode = nodes[nodes.length - 1];
	  var blockNodes;
	
	  for (var i = 1; node !== endNode && (node = node.nextSibling); i++) {
	    if (blockNodes || nodes[i] !== node) {
	      if (!blockNodes) {
	        blockNodes = jqLite(slice.call(nodes, 0, i));
	      }
	      blockNodes.push(node);
	    }
	  }
	
	  return blockNodes || nodes;
	}
	
	
	/**
	 * Creates a new object without a prototype. This object is useful for lookup without having to
	 * guard against prototypically inherited properties via hasOwnProperty.
	 *
	 * Related micro-benchmarks:
	 * - http://jsperf.com/object-create2
	 * - http://jsperf.com/proto-map-lookup/2
	 * - http://jsperf.com/for-in-vs-object-keys2
	 *
	 * @returns {Object}
	 */
	function createMap() {
	  return Object.create(null);
	}
	
	function stringify(value) {
	  if (value == null) { // null || undefined
	    return '';
	  }
	  switch (typeof value) {
	    case 'string':
	      break;
	    case 'number':
	      value = '' + value;
	      break;
	    default:
	      if (hasCustomToString(value) && !isArray(value) && !isDate(value)) {
	        value = value.toString();
	      } else {
	        value = toJson(value);
	      }
	  }
	
	  return value;
	}
	
	var NODE_TYPE_ELEMENT = 1;
	var NODE_TYPE_ATTRIBUTE = 2;
	var NODE_TYPE_TEXT = 3;
	var NODE_TYPE_COMMENT = 8;
	var NODE_TYPE_DOCUMENT = 9;
	var NODE_TYPE_DOCUMENT_FRAGMENT = 11;
	
	/**
	 * @ngdoc type
	 * @name angular.Module
	 * @module ng
	 * @description
	 *
	 * Interface for configuring AngularJS {@link angular.module modules}.
	 */
	
	function setupModuleLoader(window) {
	
	  var $injectorMinErr = minErr('$injector');
	  var ngMinErr = minErr('ng');
	
	  function ensure(obj, name, factory) {
	    return obj[name] || (obj[name] = factory());
	  }
	
	  var angular = ensure(window, 'angular', Object);
	
	  // We need to expose `angular.$$minErr` to modules such as `ngResource` that reference it during bootstrap
	  angular.$$minErr = angular.$$minErr || minErr;
	
	  return ensure(angular, 'module', function() {
	    /** @type {Object.<string, angular.Module>} */
	    var modules = {};
	
	    /**
	     * @ngdoc function
	     * @name angular.module
	     * @module ng
	     * @description
	     *
	     * The `angular.module` is a global place for creating, registering and retrieving AngularJS
	     * modules.
	     * All modules (AngularJS core or 3rd party) that should be available to an application must be
	     * registered using this mechanism.
	     *
	     * Passing one argument retrieves an existing {@link angular.Module},
	     * whereas passing more than one argument creates a new {@link angular.Module}
	     *
	     *
	     * # Module
	     *
	     * A module is a collection of services, directives, controllers, filters, and configuration information.
	     * `angular.module` is used to configure the {@link auto.$injector $injector}.
	     *
	     * ```js
	     * // Create a new module
	     * var myModule = angular.module('myModule', []);
	     *
	     * // register a new service
	     * myModule.value('appName', 'MyCoolApp');
	     *
	     * // configure existing services inside initialization blocks.
	     * myModule.config(['$locationProvider', function($locationProvider) {
	     *   // Configure existing providers
	     *   $locationProvider.hashPrefix('!');
	     * }]);
	     * ```
	     *
	     * Then you can create an injector and load your modules like this:
	     *
	     * ```js
	     * var injector = angular.injector(['ng', 'myModule'])
	     * ```
	     *
	     * However it's more likely that you'll just use
	     * {@link ng.directive:ngApp ngApp} or
	     * {@link angular.bootstrap} to simplify this process for you.
	     *
	     * @param {!string} name The name of the module to create or retrieve.
	     * @param {!Array.<string>=} requires If specified then new module is being created. If
	     *        unspecified then the module is being retrieved for further configuration.
	     * @param {Function=} configFn Optional configuration function for the module. Same as
	     *        {@link angular.Module#config Module#config()}.
	     * @returns {angular.Module} new module with the {@link angular.Module} api.
	     */
	    return function module(name, requires, configFn) {
	
	      var info = {};
	
	      var assertNotHasOwnProperty = function(name, context) {
	        if (name === 'hasOwnProperty') {
	          throw ngMinErr('badname', 'hasOwnProperty is not a valid {0} name', context);
	        }
	      };
	
	      assertNotHasOwnProperty(name, 'module');
	      if (requires && modules.hasOwnProperty(name)) {
	        modules[name] = null;
	      }
	      return ensure(modules, name, function() {
	        if (!requires) {
	          throw $injectorMinErr('nomod', 'Module \'{0}\' is not available! You either misspelled ' +
	             'the module name or forgot to load it. If registering a module ensure that you ' +
	             'specify the dependencies as the second argument.', name);
	        }
	
	        /** @type {!Array.<Array.<*>>} */
	        var invokeQueue = [];
	
	        /** @type {!Array.<Function>} */
	        var configBlocks = [];
	
	        /** @type {!Array.<Function>} */
	        var runBlocks = [];
	
	        var config = invokeLater('$injector', 'invoke', 'push', configBlocks);
	
	        /** @type {angular.Module} */
	        var moduleInstance = {
	          // Private state
	          _invokeQueue: invokeQueue,
	          _configBlocks: configBlocks,
	          _runBlocks: runBlocks,
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#info
	           * @module ng
	           *
	           * @param {Object=} info Information about the module
	           * @returns {Object|Module} The current info object for this module if called as a getter,
	           *                          or `this` if called as a setter.
	           *
	           * @description
	           * Read and write custom information about this module.
	           * For example you could put the version of the module in here.
	           *
	           * ```js
	           * angular.module('myModule', []).info({ version: '1.0.0' });
	           * ```
	           *
	           * The version could then be read back out by accessing the module elsewhere:
	           *
	           * ```
	           * var version = angular.module('myModule').info().version;
	           * ```
	           *
	           * You can also retrieve this information during runtime via the
	           * {@link $injector#modules `$injector.modules`} property:
	           *
	           * ```js
	           * var version = $injector.modules['myModule'].info().version;
	           * ```
	           */
	          info: function(value) {
	            if (isDefined(value)) {
	              if (!isObject(value)) throw ngMinErr('aobj', 'Argument \'{0}\' must be an object', 'value');
	              info = value;
	              return this;
	            }
	            return info;
	          },
	
	          /**
	           * @ngdoc property
	           * @name angular.Module#requires
	           * @module ng
	           *
	           * @description
	           * Holds the list of modules which the injector will load before the current module is
	           * loaded.
	           */
	          requires: requires,
	
	          /**
	           * @ngdoc property
	           * @name angular.Module#name
	           * @module ng
	           *
	           * @description
	           * Name of the module.
	           */
	          name: name,
	
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#provider
	           * @module ng
	           * @param {string} name service name
	           * @param {Function} providerType Construction function for creating new instance of the
	           *                                service.
	           * @description
	           * See {@link auto.$provide#provider $provide.provider()}.
	           */
	          provider: invokeLaterAndSetModuleName('$provide', 'provider'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#factory
	           * @module ng
	           * @param {string} name service name
	           * @param {Function} providerFunction Function for creating new instance of the service.
	           * @description
	           * See {@link auto.$provide#factory $provide.factory()}.
	           */
	          factory: invokeLaterAndSetModuleName('$provide', 'factory'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#service
	           * @module ng
	           * @param {string} name service name
	           * @param {Function} constructor A constructor function that will be instantiated.
	           * @description
	           * See {@link auto.$provide#service $provide.service()}.
	           */
	          service: invokeLaterAndSetModuleName('$provide', 'service'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#value
	           * @module ng
	           * @param {string} name service name
	           * @param {*} object Service instance object.
	           * @description
	           * See {@link auto.$provide#value $provide.value()}.
	           */
	          value: invokeLater('$provide', 'value'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#constant
	           * @module ng
	           * @param {string} name constant name
	           * @param {*} object Constant value.
	           * @description
	           * Because the constants are fixed, they get applied before other provide methods.
	           * See {@link auto.$provide#constant $provide.constant()}.
	           */
	          constant: invokeLater('$provide', 'constant', 'unshift'),
	
	           /**
	           * @ngdoc method
	           * @name angular.Module#decorator
	           * @module ng
	           * @param {string} name The name of the service to decorate.
	           * @param {Function} decorFn This function will be invoked when the service needs to be
	           *                           instantiated and should return the decorated service instance.
	           * @description
	           * See {@link auto.$provide#decorator $provide.decorator()}.
	           */
	          decorator: invokeLaterAndSetModuleName('$provide', 'decorator', configBlocks),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#animation
	           * @module ng
	           * @param {string} name animation name
	           * @param {Function} animationFactory Factory function for creating new instance of an
	           *                                    animation.
	           * @description
	           *
	           * **NOTE**: animations take effect only if the **ngAnimate** module is loaded.
	           *
	           *
	           * Defines an animation hook that can be later used with
	           * {@link $animate $animate} service and directives that use this service.
	           *
	           * ```js
	           * module.animation('.animation-name', function($inject1, $inject2) {
	           *   return {
	           *     eventName : function(element, done) {
	           *       //code to run the animation
	           *       //once complete, then run done()
	           *       return function cancellationFunction(element) {
	           *         //code to cancel the animation
	           *       }
	           *     }
	           *   }
	           * })
	           * ```
	           *
	           * See {@link ng.$animateProvider#register $animateProvider.register()} and
	           * {@link ngAnimate ngAnimate module} for more information.
	           */
	          animation: invokeLaterAndSetModuleName('$animateProvider', 'register'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#filter
	           * @module ng
	           * @param {string} name Filter name - this must be a valid AngularJS expression identifier
	           * @param {Function} filterFactory Factory function for creating new instance of filter.
	           * @description
	           * See {@link ng.$filterProvider#register $filterProvider.register()}.
	           *
	           * <div class="alert alert-warning">
	           * **Note:** Filter names must be valid AngularJS {@link expression} identifiers, such as `uppercase` or `orderBy`.
	           * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
	           * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
	           * (`myapp_subsection_filterx`).
	           * </div>
	           */
	          filter: invokeLaterAndSetModuleName('$filterProvider', 'register'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#controller
	           * @module ng
	           * @param {string|Object} name Controller name, or an object map of controllers where the
	           *    keys are the names and the values are the constructors.
	           * @param {Function} constructor Controller constructor function.
	           * @description
	           * See {@link ng.$controllerProvider#register $controllerProvider.register()}.
	           */
	          controller: invokeLaterAndSetModuleName('$controllerProvider', 'register'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#directive
	           * @module ng
	           * @param {string|Object} name Directive name, or an object map of directives where the
	           *    keys are the names and the values are the factories.
	           * @param {Function} directiveFactory Factory function for creating new instance of
	           * directives.
	           * @description
	           * See {@link ng.$compileProvider#directive $compileProvider.directive()}.
	           */
	          directive: invokeLaterAndSetModuleName('$compileProvider', 'directive'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#component
	           * @module ng
	           * @param {string|Object} name Name of the component in camelCase (i.e. `myComp` which will match `<my-comp>`),
	           *    or an object map of components where the keys are the names and the values are the component definition objects.
	           * @param {Object} options Component definition object (a simplified
	           *    {@link ng.$compile#directive-definition-object directive definition object})
	           *
	           * @description
	           * See {@link ng.$compileProvider#component $compileProvider.component()}.
	           */
	          component: invokeLaterAndSetModuleName('$compileProvider', 'component'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#config
	           * @module ng
	           * @param {Function} configFn Execute this function on module load. Useful for service
	           *    configuration.
	           * @description
	           * Use this method to configure services by injecting their
	           * {@link angular.Module#provider `providers`}, e.g. for adding routes to the
	           * {@link ngRoute.$routeProvider $routeProvider}.
	           *
	           * Note that you can only inject {@link angular.Module#provider `providers`} and
	           * {@link angular.Module#constant `constants`} into this function.
	           *
	           * For more about how to configure services, see
	           * {@link providers#provider-recipe Provider Recipe}.
	           */
	          config: config,
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#run
	           * @module ng
	           * @param {Function} initializationFn Execute this function after injector creation.
	           *    Useful for application initialization.
	           * @description
	           * Use this method to register work which should be performed when the injector is done
	           * loading all modules.
	           */
	          run: function(block) {
	            runBlocks.push(block);
	            return this;
	          }
	        };
	
	        if (configFn) {
	          config(configFn);
	        }
	
	        return moduleInstance;
	
	        /**
	         * @param {string} provider
	         * @param {string} method
	         * @param {String=} insertMethod
	         * @returns {angular.Module}
	         */
	        function invokeLater(provider, method, insertMethod, queue) {
	          if (!queue) queue = invokeQueue;
	          return function() {
	            queue[insertMethod || 'push']([provider, method, arguments]);
	            return moduleInstance;
	          };
	        }
	
	        /**
	         * @param {string} provider
	         * @param {string} method
	         * @returns {angular.Module}
	         */
	        function invokeLaterAndSetModuleName(provider, method, queue) {
	          if (!queue) queue = invokeQueue;
	          return function(recipeName, factoryFunction) {
	            if (factoryFunction && isFunction(factoryFunction)) factoryFunction.$$moduleName = name;
	            queue.push([provider, method, arguments]);
	            return moduleInstance;
	          };
	        }
	      });
	    };
	  });
	
	}
	
	/* global shallowCopy: true */
	
	/**
	 * Creates a shallow copy of an object, an array or a primitive.
	 *
	 * Assumes that there are no proto properties for objects.
	 */
	function shallowCopy(src, dst) {
	  if (isArray(src)) {
	    dst = dst || [];
	
	    for (var i = 0, ii = src.length; i < ii; i++) {
	      dst[i] = src[i];
	    }
	  } else if (isObject(src)) {
	    dst = dst || {};
	
	    for (var key in src) {
	      if (!(key.charAt(0) === '$' && key.charAt(1) === '$')) {
	        dst[key] = src[key];
	      }
	    }
	  }
	
	  return dst || src;
	}
	
	/* exported toDebugString */
	
	function serializeObject(obj, maxDepth) {
	  var seen = [];
	
	  // There is no direct way to stringify object until reaching a specific depth
	  // and a very deep object can cause a performance issue, so we copy the object
	  // based on this specific depth and then stringify it.
	  if (isValidObjectMaxDepth(maxDepth)) {
	    // This file is also included in `angular-loader`, so `copy()` might not always be available in
	    // the closure. Therefore, it is lazily retrieved as `angular.copy()` when needed.
	    obj = angular.copy(obj, null, maxDepth);
	  }
	  return JSON.stringify(obj, function(key, val) {
	    val = toJsonReplacer(key, val);
	    if (isObject(val)) {
	
	      if (seen.indexOf(val) >= 0) return '...';
	
	      seen.push(val);
	    }
	    return val;
	  });
	}
	
	function toDebugString(obj, maxDepth) {
	  if (typeof obj === 'function') {
	    return obj.toString().replace(/ \{[\s\S]*$/, '');
	  } else if (isUndefined(obj)) {
	    return 'undefined';
	  } else if (typeof obj !== 'string') {
	    return serializeObject(obj, maxDepth);
	  }
	  return obj;
	}
	
	/* global angularModule: true,
	  version: true,
	
	  $CompileProvider,
	
	  htmlAnchorDirective,
	  inputDirective,
	  hiddenInputBrowserCacheDirective,
	  formDirective,
	  scriptDirective,
	  selectDirective,
	  optionDirective,
	  ngBindDirective,
	  ngBindHtmlDirective,
	  ngBindTemplateDirective,
	  ngClassDirective,
	  ngClassEvenDirective,
	  ngClassOddDirective,
	  ngCloakDirective,
	  ngControllerDirective,
	  ngFormDirective,
	  ngHideDirective,
	  ngIfDirective,
	  ngIncludeDirective,
	  ngIncludeFillContentDirective,
	  ngInitDirective,
	  ngNonBindableDirective,
	  ngPluralizeDirective,
	  ngRefDirective,
	  ngRepeatDirective,
	  ngShowDirective,
	  ngStyleDirective,
	  ngSwitchDirective,
	  ngSwitchWhenDirective,
	  ngSwitchDefaultDirective,
	  ngOptionsDirective,
	  ngTranscludeDirective,
	  ngModelDirective,
	  ngListDirective,
	  ngChangeDirective,
	  patternDirective,
	  patternDirective,
	  requiredDirective,
	  requiredDirective,
	  minlengthDirective,
	  minlengthDirective,
	  maxlengthDirective,
	  maxlengthDirective,
	  ngValueDirective,
	  ngModelOptionsDirective,
	  ngAttributeAliasDirectives,
	  ngEventDirectives,
	
	  $AnchorScrollProvider,
	  $AnimateProvider,
	  $CoreAnimateCssProvider,
	  $$CoreAnimateJsProvider,
	  $$CoreAnimateQueueProvider,
	  $$AnimateRunnerFactoryProvider,
	  $$AnimateAsyncRunFactoryProvider,
	  $BrowserProvider,
	  $CacheFactoryProvider,
	  $ControllerProvider,
	  $DateProvider,
	  $DocumentProvider,
	  $$IsDocumentHiddenProvider,
	  $ExceptionHandlerProvider,
	  $FilterProvider,
	  $$ForceReflowProvider,
	  $InterpolateProvider,
	  $$IntervalFactoryProvider,
	  $IntervalProvider,
	  $HttpProvider,
	  $HttpParamSerializerProvider,
	  $HttpParamSerializerJQLikeProvider,
	  $HttpBackendProvider,
	  $xhrFactoryProvider,
	  $jsonpCallbacksProvider,
	  $LocationProvider,
	  $LogProvider,
	  $$MapProvider,
	  $ParseProvider,
	  $RootScopeProvider,
	  $QProvider,
	  $$QProvider,
	  $$SanitizeUriProvider,
	  $SceProvider,
	  $SceDelegateProvider,
	  $SnifferProvider,
	  $$TaskTrackerFactoryProvider,
	  $TemplateCacheProvider,
	  $TemplateRequestProvider,
	  $$TestabilityProvider,
	  $TimeoutProvider,
	  $$RAFProvider,
	  $WindowProvider,
	  $$jqLiteProvider,
	  $$CookieReaderProvider
	*/
	
	
	/**
	 * @ngdoc object
	 * @name angular.version
	 * @module ng
	 * @description
	 * An object that contains information about the current AngularJS version.
	 *
	 * This object has the following properties:
	 *
	 * - `full` – `{string}` – Full version string, such as "0.9.18".
	 * - `major` – `{number}` – Major version number, such as "0".
	 * - `minor` – `{number}` – Minor version number, such as "9".
	 * - `dot` – `{number}` – Dot version number, such as "18".
	 * - `codeName` – `{string}` – Code name of the release, such as "jiggling-armfat".
	 */
	var version = {
	  // These placeholder strings will be replaced by grunt's `build` task.
	  // They need to be double- or single-quoted.
	  full: '1.8.3',
	  major: 1,
	  minor: 8,
	  dot: 3,
	  codeName: 'ultimate-farewell'
	};
	
	
	function publishExternalAPI(angular) {
	  extend(angular, {
	    'errorHandlingConfig': errorHandlingConfig,
	    'bootstrap': bootstrap,
	    'copy': copy,
	    'extend': extend,
	    'merge': merge,
	    'equals': equals,
	    'element': jqLite,
	    'forEach': forEach,
	    'injector': createInjector,
	    'noop': noop,
	    'bind': bind,
	    'toJson': toJson,
	    'fromJson': fromJson,
	    'identity': identity,
	    'isUndefined': isUndefined,
	    'isDefined': isDefined,
	    'isString': isString,
	    'isFunction': isFunction,
	    'isObject': isObject,
	    'isNumber': isNumber,
	    'isElement': isElement,
	    'isArray': isArray,
	    'version': version,
	    'isDate': isDate,
	    'callbacks': {$$counter: 0},
	    'getTestability': getTestability,
	    'reloadWithDebugInfo': reloadWithDebugInfo,
	    'UNSAFE_restoreLegacyJqLiteXHTMLReplacement': UNSAFE_restoreLegacyJqLiteXHTMLReplacement,
	    '$$minErr': minErr,
	    '$$csp': csp,
	    '$$encodeUriSegment': encodeUriSegment,
	    '$$encodeUriQuery': encodeUriQuery,
	    '$$lowercase': lowercase,
	    '$$stringify': stringify,
	    '$$uppercase': uppercase
	  });
	
	  angularModule = setupModuleLoader(window);
	
	  angularModule('ng', ['ngLocale'], ['$provide',
	    function ngModule($provide) {
	      // $$sanitizeUriProvider needs to be before $compileProvider as it is used by it.
	      $provide.provider({
	        $$sanitizeUri: $$SanitizeUriProvider
	      });
	      $provide.provider('$compile', $CompileProvider).
	        directive({
	            a: htmlAnchorDirective,
	            input: inputDirective,
	            textarea: inputDirective,
	            form: formDirective,
	            script: scriptDirective,
	            select: selectDirective,
	            option: optionDirective,
	            ngBind: ngBindDirective,
	            ngBindHtml: ngBindHtmlDirective,
	            ngBindTemplate: ngBindTemplateDirective,
	            ngClass: ngClassDirective,
	            ngClassEven: ngClassEvenDirective,
	            ngClassOdd: ngClassOddDirective,
	            ngCloak: ngCloakDirective,
	            ngController: ngControllerDirective,
	            ngForm: ngFormDirective,
	            ngHide: ngHideDirective,
	            ngIf: ngIfDirective,
	            ngInclude: ngIncludeDirective,
	            ngInit: ngInitDirective,
	            ngNonBindable: ngNonBindableDirective,
	            ngPluralize: ngPluralizeDirective,
	            ngRef: ngRefDirective,
	            ngRepeat: ngRepeatDirective,
	            ngShow: ngShowDirective,
	            ngStyle: ngStyleDirective,
	            ngSwitch: ngSwitchDirective,
	            ngSwitchWhen: ngSwitchWhenDirective,
	            ngSwitchDefault: ngSwitchDefaultDirective,
	            ngOptions: ngOptionsDirective,
	            ngTransclude: ngTranscludeDirective,
	            ngModel: ngModelDirective,
	            ngList: ngListDirective,
	            ngChange: ngChangeDirective,
	            pattern: patternDirective,
	            ngPattern: patternDirective,
	            required: requiredDirective,
	            ngRequired: requiredDirective,
	            minlength: minlengthDirective,
	            ngMinlength: minlengthDirective,
	            maxlength: maxlengthDirective,
	            ngMaxlength: maxlengthDirective,
	            ngValue: ngValueDirective,
	            ngModelOptions: ngModelOptionsDirective
	        }).
	        directive({
	          ngInclude: ngIncludeFillContentDirective,
	          input: hiddenInputBrowserCacheDirective
	        }).
	        directive(ngAttributeAliasDirectives).
	        directive(ngEventDirectives);
	      $provide.provider({
	        $anchorScroll: $AnchorScrollProvider,
	        $animate: $AnimateProvider,
	        $animateCss: $CoreAnimateCssProvider,
	        $$animateJs: $$CoreAnimateJsProvider,
	        $$animateQueue: $$CoreAnimateQueueProvider,
	        $$AnimateRunner: $$AnimateRunnerFactoryProvider,
	        $$animateAsyncRun: $$AnimateAsyncRunFactoryProvider,
	        $browser: $BrowserProvider,
	        $cacheFactory: $CacheFactoryProvider,
	        $controller: $ControllerProvider,
	        $document: $DocumentProvider,
	        $$isDocumentHidden: $$IsDocumentHiddenProvider,
	        $exceptionHandler: $ExceptionHandlerProvider,
	        $filter: $FilterProvider,
	        $$forceReflow: $$ForceReflowProvider,
	        $interpolate: $InterpolateProvider,
	        $interval: $IntervalProvider,
	        $$intervalFactory: $$IntervalFactoryProvider,
	        $http: $HttpProvider,
	        $httpParamSerializer: $HttpParamSerializerProvider,
	        $httpParamSerializerJQLike: $HttpParamSerializerJQLikeProvider,
	        $httpBackend: $HttpBackendProvider,
	        $xhrFactory: $xhrFactoryProvider,
	        $jsonpCallbacks: $jsonpCallbacksProvider,
	        $location: $LocationProvider,
	        $log: $LogProvider,
	        $parse: $ParseProvider,
	        $rootScope: $RootScopeProvider,
	        $q: $QProvider,
	        $$q: $$QProvider,
	        $sce: $SceProvider,
	        $sceDelegate: $SceDelegateProvider,
	        $sniffer: $SnifferProvider,
	        $$taskTrackerFactory: $$TaskTrackerFactoryProvider,
	        $templateCache: $TemplateCacheProvider,
	        $templateRequest: $TemplateRequestProvider,
	        $$testability: $$TestabilityProvider,
	        $timeout: $TimeoutProvider,
	        $window: $WindowProvider,
	        $$rAF: $$RAFProvider,
	        $$jqLite: $$jqLiteProvider,
	        $$Map: $$MapProvider,
	        $$cookieReader: $$CookieReaderProvider
	      });
	    }
	  ])
	  .info({ angularVersion: '1.8.3' });
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	/* global
	  JQLitePrototype: true,
	  BOOLEAN_ATTR: true,
	  ALIASED_ATTR: true
	*/
	
	//////////////////////////////////
	//JQLite
	//////////////////////////////////
	
	/**
	 * @ngdoc function
	 * @name angular.element
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Wraps a raw DOM element or HTML string as a [jQuery](http://jquery.com) element.
	 *
	 * If jQuery is available, `angular.element` is an alias for the
	 * [jQuery](http://api.jquery.com/jQuery/) function. If jQuery is not available, `angular.element`
	 * delegates to AngularJS's built-in subset of jQuery, called "jQuery lite" or **jqLite**.
	 *
	 * jqLite is a tiny, API-compatible subset of jQuery that allows
	 * AngularJS to manipulate the DOM in a cross-browser compatible way. jqLite implements only the most
	 * commonly needed functionality with the goal of having a very small footprint.
	 *
	 * To use `jQuery`, simply ensure it is loaded before the `angular.js` file. You can also use the
	 * {@link ngJq `ngJq`} directive to specify that jqlite should be used over jQuery, or to use a
	 * specific version of jQuery if multiple versions exist on the page.
	 *
	 * <div class="alert alert-info">**Note:** All element references in AngularJS are always wrapped with jQuery or
	 * jqLite (such as the element argument in a directive's compile / link function). They are never raw DOM references.</div>
	 *
	 * <div class="alert alert-warning">**Note:** Keep in mind that this function will not find elements
	 * by tag name / CSS selector. For lookups by tag name, try instead `angular.element(document).find(...)`
	 * or `$document.find()`, or use the standard DOM APIs, e.g. `document.querySelectorAll()`.</div>
	 *
	 * ## AngularJS's jqLite
	 * jqLite provides only the following jQuery methods:
	 *
	 * - [`addClass()`](http://api.jquery.com/addClass/) - Does not support a function as first argument
	 * - [`after()`](http://api.jquery.com/after/)
	 * - [`append()`](http://api.jquery.com/append/) - Contrary to jQuery, this doesn't clone elements
	 *   so will not work correctly when invoked on a jqLite object containing more than one DOM node
	 * - [`attr()`](http://api.jquery.com/attr/) - Does not support functions as parameters
	 * - [`bind()`](http://api.jquery.com/bind/) (_deprecated_, use [`on()`](http://api.jquery.com/on/)) - Does not support namespaces, selectors or eventData
	 * - [`children()`](http://api.jquery.com/children/) - Does not support selectors
	 * - [`clone()`](http://api.jquery.com/clone/)
	 * - [`contents()`](http://api.jquery.com/contents/)
	 * - [`css()`](http://api.jquery.com/css/) - Only retrieves inline-styles, does not call `getComputedStyle()`.
	 *   As a setter, does not convert numbers to strings or append 'px', and also does not have automatic property prefixing.
	 * - [`data()`](http://api.jquery.com/data/)
	 * - [`detach()`](http://api.jquery.com/detach/)
	 * - [`empty()`](http://api.jquery.com/empty/)
	 * - [`eq()`](http://api.jquery.com/eq/)
	 * - [`find()`](http://api.jquery.com/find/) - Limited to lookups by tag name
	 * - [`hasClass()`](http://api.jquery.com/hasClass/)
	 * - [`html()`](http://api.jquery.com/html/)
	 * - [`next()`](http://api.jquery.com/next/) - Does not support selectors
	 * - [`on()`](http://api.jquery.com/on/) - Does not support namespaces, selectors or eventData
	 * - [`off()`](http://api.jquery.com/off/) - Does not support namespaces, selectors or event object as parameter
	 * - [`one()`](http://api.jquery.com/one/) - Does not support namespaces or selectors
	 * - [`parent()`](http://api.jquery.com/parent/) - Does not support selectors
	 * - [`prepend()`](http://api.jquery.com/prepend/)
	 * - [`prop()`](http://api.jquery.com/prop/)
	 * - [`ready()`](http://api.jquery.com/ready/) (_deprecated_, use `angular.element(callback)` instead of `angular.element(document).ready(callback)`)
	 * - [`remove()`](http://api.jquery.com/remove/)
	 * - [`removeAttr()`](http://api.jquery.com/removeAttr/) - Does not support multiple attributes
	 * - [`removeClass()`](http://api.jquery.com/removeClass/) - Does not support a function as first argument
	 * - [`removeData()`](http://api.jquery.com/removeData/)
	 * - [`replaceWith()`](http://api.jquery.com/replaceWith/)
	 * - [`text()`](http://api.jquery.com/text/)
	 * - [`toggleClass()`](http://api.jquery.com/toggleClass/) - Does not support a function as first argument
	 * - [`triggerHandler()`](http://api.jquery.com/triggerHandler/) - Passes a dummy event object to handlers
	 * - [`unbind()`](http://api.jquery.com/unbind/) (_deprecated_, use [`off()`](http://api.jquery.com/off/)) - Does not support namespaces or event object as parameter
	 * - [`val()`](http://api.jquery.com/val/)
	 * - [`wrap()`](http://api.jquery.com/wrap/)
	 *
	 * jqLite also provides a method restoring pre-1.8 insecure treatment of XHTML-like tags.
	 * This legacy behavior turns input like `<div /><span />` to `<div></div><span></span>`
	 * instead of `<div><span></span></div>` like version 1.8 & newer do. To restore it, invoke:
	 * ```js
	 * angular.UNSAFE_restoreLegacyJqLiteXHTMLReplacement();
	 * ```
	 * Note that this only patches jqLite. If you use jQuery 3.5.0 or newer, please read the
	 * [jQuery 3.5 upgrade guide](https://jquery.com/upgrade-guide/3.5/) for more details
	 * about the workarounds.
	 *
	 * ## jQuery/jqLite Extras
	 * AngularJS also provides the following additional methods and events to both jQuery and jqLite:
	 *
	 * ### Events
	 * - `$destroy` - AngularJS intercepts all jqLite/jQuery's DOM destruction apis and fires this event
	 *    on all DOM nodes being removed.  This can be used to clean up any 3rd party bindings to the DOM
	 *    element before it is removed.
	 *
	 * ### Methods
	 * - `controller(name)` - retrieves the controller of the current element or its parent. By default
	 *   retrieves controller associated with the `ngController` directive. If `name` is provided as
	 *   camelCase directive name, then the controller for this directive will be retrieved (e.g.
	 *   `'ngModel'`).
	 * - `injector()` - retrieves the injector of the current element or its parent.
	 * - `scope()` - retrieves the {@link ng.$rootScope.Scope scope} of the current
	 *   element or its parent. Requires {@link guide/production#disabling-debug-data Debug Data} to
	 *   be enabled.
	 * - `isolateScope()` - retrieves an isolate {@link ng.$rootScope.Scope scope} if one is attached directly to the
	 *   current element. This getter should be used only on elements that contain a directive which starts a new isolate
	 *   scope. Calling `scope()` on this element always returns the original non-isolate scope.
	 *   Requires {@link guide/production#disabling-debug-data Debug Data} to be enabled.
	 * - `inheritedData()` - same as `data()`, but walks up the DOM until a value is found or the top
	 *   parent element is reached.
	 *
	 * @knownIssue You cannot spy on `angular.element` if you are using Jasmine version 1.x. See
	 * https://github.com/angular/angular.js/issues/14251 for more information.
	 *
	 * @param {string|DOMElement} element HTML string or DOMElement to be wrapped into jQuery.
	 * @returns {Object} jQuery object.
	 */
	
	JQLite.expando = 'ng339';
	
	var jqCache = JQLite.cache = {},
	    jqId = 1;
	
	/*
	 * !!! This is an undocumented "private" function !!!
	 */
	JQLite._data = function(node) {
	  //jQuery always returns an object on cache miss
	  return this.cache[node[this.expando]] || {};
	};
	
	function jqNextId() { return ++jqId; }
	
	
	var DASH_LOWERCASE_REGEXP = /-([a-z])/g;
	var MS_HACK_REGEXP = /^-ms-/;
	var MOUSE_EVENT_MAP = { mouseleave: 'mouseout', mouseenter: 'mouseover' };
	var jqLiteMinErr = minErr('jqLite');
	
	/**
	 * Converts kebab-case to camelCase.
	 * There is also a special case for the ms prefix starting with a lowercase letter.
	 * @param name Name to normalize
	 */
	function cssKebabToCamel(name) {
	    return kebabToCamel(name.replace(MS_HACK_REGEXP, 'ms-'));
	}
	
	function fnCamelCaseReplace(all, letter) {
	  return letter.toUpperCase();
	}
	
	/**
	 * Converts kebab-case to camelCase.
	 * @param name Name to normalize
	 */
	function kebabToCamel(name) {
	  return name
	    .replace(DASH_LOWERCASE_REGEXP, fnCamelCaseReplace);
	}
	
	var SINGLE_TAG_REGEXP = /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/;
	var HTML_REGEXP = /<|&#?\w+;/;
	var TAG_NAME_REGEXP = /<([\w:-]+)/;
	var XHTML_TAG_REGEXP = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi;
	
	// Table parts need to be wrapped with `<table>` or they're
	// stripped to their contents when put in a div.
	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do, so we cannot shorten
	// this by omitting <tbody> or other required elements.
	var wrapMap = {
	  thead: ['table'],
	  col: ['colgroup', 'table'],
	  tr: ['tbody', 'table'],
	  td: ['tr', 'tbody', 'table']
	};
	
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	// Support: IE <10 only
	// IE 9 requires an option wrapper & it needs to have the whole table structure
	// set up in advance; assigning `"<td></td>"` to `tr.innerHTML` doesn't work, etc.
	var wrapMapIE9 = {
	  option: [1, '<select multiple="multiple">', '</select>'],
	  _default: [0, '', '']
	};
	
	for (var key in wrapMap) {
	  var wrapMapValueClosing = wrapMap[key];
	  var wrapMapValue = wrapMapValueClosing.slice().reverse();
	  wrapMapIE9[key] = [wrapMapValue.length, '<' + wrapMapValue.join('><') + '>', '</' + wrapMapValueClosing.join('></') + '>'];
	}
	
	wrapMapIE9.optgroup = wrapMapIE9.option;
	
	function jqLiteIsTextNode(html) {
	  return !HTML_REGEXP.test(html);
	}
	
	function jqLiteAcceptsData(node) {
	  // The window object can accept data but has no nodeType
	  // Otherwise we are only interested in elements (1) and documents (9)
	  var nodeType = node.nodeType;
	  return nodeType === NODE_TYPE_ELEMENT || !nodeType || nodeType === NODE_TYPE_DOCUMENT;
	}
	
	function jqLiteHasData(node) {
	  for (var key in jqCache[node.ng339]) {
	    return true;
	  }
	  return false;
	}
	
	function jqLiteBuildFragment(html, context) {
	  var tmp, tag, wrap, finalHtml,
	      fragment = context.createDocumentFragment(),
	      nodes = [], i;
	
	  if (jqLiteIsTextNode(html)) {
	    // Convert non-html into a text node
	    nodes.push(context.createTextNode(html));
	  } else {
	    // Convert html into DOM nodes
	    tmp = fragment.appendChild(context.createElement('div'));
	    tag = (TAG_NAME_REGEXP.exec(html) || ['', ''])[1].toLowerCase();
	    finalHtml = JQLite.legacyXHTMLReplacement ?
	      html.replace(XHTML_TAG_REGEXP, '<$1></$2>') :
	      html;
	
	    if (msie < 10) {
	      wrap = wrapMapIE9[tag] || wrapMapIE9._default;
	      tmp.innerHTML = wrap[1] + finalHtml + wrap[2];
	
	      // Descend through wrappers to the right content
	      i = wrap[0];
	      while (i--) {
	        tmp = tmp.firstChild;
	      }
	    } else {
	      wrap = wrapMap[tag] || [];
	
	      // Create wrappers & descend into them
	      i = wrap.length;
	      while (--i > -1) {
	        tmp.appendChild(window.document.createElement(wrap[i]));
	        tmp = tmp.firstChild;
	      }
	
	      tmp.innerHTML = finalHtml;
	    }
	
	    nodes = concat(nodes, tmp.childNodes);
	
	    tmp = fragment.firstChild;
	    tmp.textContent = '';
	  }
	
	  // Remove wrapper from fragment
	  fragment.textContent = '';
	  fragment.innerHTML = ''; // Clear inner HTML
	  forEach(nodes, function(node) {
	    fragment.appendChild(node);
	  });
	
	  return fragment;
	}
	
	function jqLiteParseHTML(html, context) {
	  context = context || window.document;
	  var parsed;
	
	  if ((parsed = SINGLE_TAG_REGEXP.exec(html))) {
	    return [context.createElement(parsed[1])];
	  }
	
	  if ((parsed = jqLiteBuildFragment(html, context))) {
	    return parsed.childNodes;
	  }
	
	  return [];
	}
	
	function jqLiteWrapNode(node, wrapper) {
	  var parent = node.parentNode;
	
	  if (parent) {
	    parent.replaceChild(wrapper, node);
	  }
	
	  wrapper.appendChild(node);
	}
	
	
	// IE9-11 has no method "contains" in SVG element and in Node.prototype. Bug #10259.
	var jqLiteContains = window.Node.prototype.contains || /** @this */ function(arg) {
	  // eslint-disable-next-line no-bitwise
	  return !!(this.compareDocumentPosition(arg) & 16);
	};
	
	/////////////////////////////////////////////
	function JQLite(element) {
	  if (element instanceof JQLite) {
	    return element;
	  }
	
	  var argIsString;
	
	  if (isString(element)) {
	    element = trim(element);
	    argIsString = true;
	  }
	  if (!(this instanceof JQLite)) {
	    if (argIsString && element.charAt(0) !== '<') {
	      throw jqLiteMinErr('nosel', 'Looking up elements via selectors is not supported by jqLite! See: http://docs.angularjs.org/api/angular.element');
	    }
	    return new JQLite(element);
	  }
	
	  if (argIsString) {
	    jqLiteAddNodes(this, jqLiteParseHTML(element));
	  } else if (isFunction(element)) {
	    jqLiteReady(element);
	  } else {
	    jqLiteAddNodes(this, element);
	  }
	}
	
	function jqLiteClone(element) {
	  return element.cloneNode(true);
	}
	
	function jqLiteDealoc(element, onlyDescendants) {
	  if (!onlyDescendants && jqLiteAcceptsData(element)) jqLite.cleanData([element]);
	
	  if (element.querySelectorAll) {
	    jqLite.cleanData(element.querySelectorAll('*'));
	  }
	}
	
	function isEmptyObject(obj) {
	  var name;
	
	  for (name in obj) {
	    return false;
	  }
	  return true;
	}
	
	function removeIfEmptyData(element) {
	  var expandoId = element.ng339;
	  var expandoStore = expandoId && jqCache[expandoId];
	
	  var events = expandoStore && expandoStore.events;
	  var data = expandoStore && expandoStore.data;
	
	  if ((!data || isEmptyObject(data)) && (!events || isEmptyObject(events))) {
	    delete jqCache[expandoId];
	    element.ng339 = undefined; // don't delete DOM expandos. IE and Chrome don't like it
	  }
	}
	
	function jqLiteOff(element, type, fn, unsupported) {
	  if (isDefined(unsupported)) throw jqLiteMinErr('offargs', 'jqLite#off() does not support the `selector` argument');
	
	  var expandoStore = jqLiteExpandoStore(element);
	  var events = expandoStore && expandoStore.events;
	  var handle = expandoStore && expandoStore.handle;
	
	  if (!handle) return; //no listeners registered
	
	  if (!type) {
	    for (type in events) {
	      if (type !== '$destroy') {
	        element.removeEventListener(type, handle);
	      }
	      delete events[type];
	    }
	  } else {
	
	    var removeHandler = function(type) {
	      var listenerFns = events[type];
	      if (isDefined(fn)) {
	        arrayRemove(listenerFns || [], fn);
	      }
	      if (!(isDefined(fn) && listenerFns && listenerFns.length > 0)) {
	        element.removeEventListener(type, handle);
	        delete events[type];
	      }
	    };
	
	    forEach(type.split(' '), function(type) {
	      removeHandler(type);
	      if (MOUSE_EVENT_MAP[type]) {
	        removeHandler(MOUSE_EVENT_MAP[type]);
	      }
	    });
	  }
	
	  removeIfEmptyData(element);
	}
	
	function jqLiteRemoveData(element, name) {
	  var expandoId = element.ng339;
	  var expandoStore = expandoId && jqCache[expandoId];
	
	  if (expandoStore) {
	    if (name) {
	      delete expandoStore.data[name];
	    } else {
	      expandoStore.data = {};
	    }
	
	    removeIfEmptyData(element);
	  }
	}
	
	
	function jqLiteExpandoStore(element, createIfNecessary) {
	  var expandoId = element.ng339,
	      expandoStore = expandoId && jqCache[expandoId];
	
	  if (createIfNecessary && !expandoStore) {
	    element.ng339 = expandoId = jqNextId();
	    expandoStore = jqCache[expandoId] = {events: {}, data: {}, handle: undefined};
	  }
	
	  return expandoStore;
	}
	
	
	function jqLiteData(element, key, value) {
	  if (jqLiteAcceptsData(element)) {
	    var prop;
	
	    var isSimpleSetter = isDefined(value);
	    var isSimpleGetter = !isSimpleSetter && key && !isObject(key);
	    var massGetter = !key;
	    var expandoStore = jqLiteExpandoStore(element, !isSimpleGetter);
	    var data = expandoStore && expandoStore.data;
	
	    if (isSimpleSetter) { // data('key', value)
	      data[kebabToCamel(key)] = value;
	    } else {
	      if (massGetter) {  // data()
	        return data;
	      } else {
	        if (isSimpleGetter) { // data('key')
	          // don't force creation of expandoStore if it doesn't exist yet
	          return data && data[kebabToCamel(key)];
	        } else { // mass-setter: data({key1: val1, key2: val2})
	          for (prop in key) {
	            data[kebabToCamel(prop)] = key[prop];
	          }
	        }
	      }
	    }
	  }
	}
	
	function jqLiteHasClass(element, selector) {
	  if (!element.getAttribute) return false;
	  return ((' ' + (element.getAttribute('class') || '') + ' ').replace(/[\n\t]/g, ' ').
	      indexOf(' ' + selector + ' ') > -1);
	}
	
	function jqLiteRemoveClass(element, cssClasses) {
	  if (cssClasses && element.setAttribute) {
	    var existingClasses = (' ' + (element.getAttribute('class') || '') + ' ')
	                            .replace(/[\n\t]/g, ' ');
	    var newClasses = existingClasses;
	
	    forEach(cssClasses.split(' '), function(cssClass) {
	      cssClass = trim(cssClass);
	      newClasses = newClasses.replace(' ' + cssClass + ' ', ' ');
	    });
	
	    if (newClasses !== existingClasses) {
	      element.setAttribute('class', trim(newClasses));
	    }
	  }
	}
	
	function jqLiteAddClass(element, cssClasses) {
	  if (cssClasses && element.setAttribute) {
	    var existingClasses = (' ' + (element.getAttribute('class') || '') + ' ')
	                            .replace(/[\n\t]/g, ' ');
	    var newClasses = existingClasses;
	
	    forEach(cssClasses.split(' '), function(cssClass) {
	      cssClass = trim(cssClass);
	      if (newClasses.indexOf(' ' + cssClass + ' ') === -1) {
	        newClasses += cssClass + ' ';
	      }
	    });
	
	    if (newClasses !== existingClasses) {
	      element.setAttribute('class', trim(newClasses));
	    }
	  }
	}
	
	
	function jqLiteAddNodes(root, elements) {
	  // THIS CODE IS VERY HOT. Don't make changes without benchmarking.
	
	  if (elements) {
	
	    // if a Node (the most common case)
	    if (elements.nodeType) {
	      root[root.length++] = elements;
	    } else {
	      var length = elements.length;
	
	      // if an Array or NodeList and not a Window
	      if (typeof length === 'number' && elements.window !== elements) {
	        if (length) {
	          for (var i = 0; i < length; i++) {
	            root[root.length++] = elements[i];
	          }
	        }
	      } else {
	        root[root.length++] = elements;
	      }
	    }
	  }
	}
	
	
	function jqLiteController(element, name) {
	  return jqLiteInheritedData(element, '$' + (name || 'ngController') + 'Controller');
	}
	
	function jqLiteInheritedData(element, name, value) {
	  // if element is the document object work with the html element instead
	  // this makes $(document).scope() possible
	  if (element.nodeType === NODE_TYPE_DOCUMENT) {
	    element = element.documentElement;
	  }
	  var names = isArray(name) ? name : [name];
	
	  while (element) {
	    for (var i = 0, ii = names.length; i < ii; i++) {
	      if (isDefined(value = jqLite.data(element, names[i]))) return value;
	    }
	
	    // If dealing with a document fragment node with a host element, and no parent, use the host
	    // element as the parent. This enables directives within a Shadow DOM or polyfilled Shadow DOM
	    // to lookup parent controllers.
	    element = element.parentNode || (element.nodeType === NODE_TYPE_DOCUMENT_FRAGMENT && element.host);
	  }
	}
	
	function jqLiteEmpty(element) {
	  jqLiteDealoc(element, true);
	  while (element.firstChild) {
	    element.removeChild(element.firstChild);
	  }
	}
	
	function jqLiteRemove(element, keepData) {
	  if (!keepData) jqLiteDealoc(element);
	  var parent = element.parentNode;
	  if (parent) parent.removeChild(element);
	}
	
	
	function jqLiteDocumentLoaded(action, win) {
	  win = win || window;
	  if (win.document.readyState === 'complete') {
	    // Force the action to be run async for consistent behavior
	    // from the action's point of view
	    // i.e. it will definitely not be in a $apply
	    win.setTimeout(action);
	  } else {
	    // No need to unbind this handler as load is only ever called once
	    jqLite(win).on('load', action);
	  }
	}
	
	function jqLiteReady(fn) {
	  function trigger() {
	    window.document.removeEventListener('DOMContentLoaded', trigger);
	    window.removeEventListener('load', trigger);
	    fn();
	  }
	
	  // check if document is already loaded
	  if (window.document.readyState === 'complete') {
	    window.setTimeout(fn);
	  } else {
	    // We can not use jqLite since we are not done loading and jQuery could be loaded later.
	
	    // Works for modern browsers and IE9
	    window.document.addEventListener('DOMContentLoaded', trigger);
	
	    // Fallback to window.onload for others
	    window.addEventListener('load', trigger);
	  }
	}
	
	//////////////////////////////////////////
	// Functions which are declared directly.
	//////////////////////////////////////////
	var JQLitePrototype = JQLite.prototype = {
	  ready: jqLiteReady,
	  toString: function() {
	    var value = [];
	    forEach(this, function(e) { value.push('' + e);});
	    return '[' + value.join(', ') + ']';
	  },
	
	  eq: function(index) {
	      return (index >= 0) ? jqLite(this[index]) : jqLite(this[this.length + index]);
	  },
	
	  length: 0,
	  push: push,
	  sort: [].sort,
	  splice: [].splice
	};
	
	//////////////////////////////////////////
	// Functions iterating getter/setters.
	// these functions return self on setter and
	// value on get.
	//////////////////////////////////////////
	var BOOLEAN_ATTR = {};
	forEach('multiple,selected,checked,disabled,readOnly,required,open'.split(','), function(value) {
	  BOOLEAN_ATTR[lowercase(value)] = value;
	});
	var BOOLEAN_ELEMENTS = {};
	forEach('input,select,option,textarea,button,form,details'.split(','), function(value) {
	  BOOLEAN_ELEMENTS[value] = true;
	});
	var ALIASED_ATTR = {
	  'ngMinlength': 'minlength',
	  'ngMaxlength': 'maxlength',
	  'ngMin': 'min',
	  'ngMax': 'max',
	  'ngPattern': 'pattern',
	  'ngStep': 'step'
	};
	
	function getBooleanAttrName(element, name) {
	  // check dom last since we will most likely fail on name
	  var booleanAttr = BOOLEAN_ATTR[name.toLowerCase()];
	
	  // booleanAttr is here twice to minimize DOM access
	  return booleanAttr && BOOLEAN_ELEMENTS[nodeName_(element)] && booleanAttr;
	}
	
	function getAliasedAttrName(name) {
	  return ALIASED_ATTR[name];
	}
	
	forEach({
	  data: jqLiteData,
	  removeData: jqLiteRemoveData,
	  hasData: jqLiteHasData,
	  cleanData: function jqLiteCleanData(nodes) {
	    for (var i = 0, ii = nodes.length; i < ii; i++) {
	      jqLiteRemoveData(nodes[i]);
	      jqLiteOff(nodes[i]);
	    }
	  }
	}, function(fn, name) {
	  JQLite[name] = fn;
	});
	
	forEach({
	  data: jqLiteData,
	  inheritedData: jqLiteInheritedData,
	
	  scope: function(element) {
	    // Can't use jqLiteData here directly so we stay compatible with jQuery!
	    return jqLite.data(element, '$scope') || jqLiteInheritedData(element.parentNode || element, ['$isolateScope', '$scope']);
	  },
	
	  isolateScope: function(element) {
	    // Can't use jqLiteData here directly so we stay compatible with jQuery!
	    return jqLite.data(element, '$isolateScope') || jqLite.data(element, '$isolateScopeNoTemplate');
	  },
	
	  controller: jqLiteController,
	
	  injector: function(element) {
	    return jqLiteInheritedData(element, '$injector');
	  },
	
	  removeAttr: function(element, name) {
	    element.removeAttribute(name);
	  },
	
	  hasClass: jqLiteHasClass,
	
	  css: function(element, name, value) {
	    name = cssKebabToCamel(name);
	
	    if (isDefined(value)) {
	      element.style[name] = value;
	    } else {
	      return element.style[name];
	    }
	  },
	
	  attr: function(element, name, value) {
	    var ret;
	    var nodeType = element.nodeType;
	    if (nodeType === NODE_TYPE_TEXT || nodeType === NODE_TYPE_ATTRIBUTE || nodeType === NODE_TYPE_COMMENT ||
	      !element.getAttribute) {
	      return;
	    }
	
	    var lowercasedName = lowercase(name);
	    var isBooleanAttr = BOOLEAN_ATTR[lowercasedName];
	
	    if (isDefined(value)) {
	      // setter
	
	      if (value === null || (value === false && isBooleanAttr)) {
	        element.removeAttribute(name);
	      } else {
	        element.setAttribute(name, isBooleanAttr ? lowercasedName : value);
	      }
	    } else {
	      // getter
	
	      ret = element.getAttribute(name);
	
	      if (isBooleanAttr && ret !== null) {
	        ret = lowercasedName;
	      }
	      // Normalize non-existing attributes to undefined (as jQuery).
	      return ret === null ? undefined : ret;
	    }
	  },
	
	  prop: function(element, name, value) {
	    if (isDefined(value)) {
	      element[name] = value;
	    } else {
	      return element[name];
	    }
	  },
	
	  text: (function() {
	    getText.$dv = '';
	    return getText;
	
	    function getText(element, value) {
	      if (isUndefined(value)) {
	        var nodeType = element.nodeType;
	        return (nodeType === NODE_TYPE_ELEMENT || nodeType === NODE_TYPE_TEXT) ? element.textContent : '';
	      }
	      element.textContent = value;
	    }
	  })(),
	
	  val: function(element, value) {
	    if (isUndefined(value)) {
	      if (element.multiple && nodeName_(element) === 'select') {
	        var result = [];
	        forEach(element.options, function(option) {
	          if (option.selected) {
	            result.push(option.value || option.text);
	          }
	        });
	        return result;
	      }
	      return element.value;
	    }
	    element.value = value;
	  },
	
	  html: function(element, value) {
	    if (isUndefined(value)) {
	      return element.innerHTML;
	    }
	    jqLiteDealoc(element, true);
	    element.innerHTML = value;
	  },
	
	  empty: jqLiteEmpty
	}, function(fn, name) {
	  /**
	   * Properties: writes return selection, reads return first value
	   */
	  JQLite.prototype[name] = function(arg1, arg2) {
	    var i, key;
	    var nodeCount = this.length;
	
	    // jqLiteHasClass has only two arguments, but is a getter-only fn, so we need to special-case it
	    // in a way that survives minification.
	    // jqLiteEmpty takes no arguments but is a setter.
	    if (fn !== jqLiteEmpty &&
	        (isUndefined((fn.length === 2 && (fn !== jqLiteHasClass && fn !== jqLiteController)) ? arg1 : arg2))) {
	      if (isObject(arg1)) {
	
	        // we are a write, but the object properties are the key/values
	        for (i = 0; i < nodeCount; i++) {
	          if (fn === jqLiteData) {
	            // data() takes the whole object in jQuery
	            fn(this[i], arg1);
	          } else {
	            for (key in arg1) {
	              fn(this[i], key, arg1[key]);
	            }
	          }
	        }
	        // return self for chaining
	        return this;
	      } else {
	        // we are a read, so read the first child.
	        // TODO: do we still need this?
	        var value = fn.$dv;
	        // Only if we have $dv do we iterate over all, otherwise it is just the first element.
	        var jj = (isUndefined(value)) ? Math.min(nodeCount, 1) : nodeCount;
	        for (var j = 0; j < jj; j++) {
	          var nodeValue = fn(this[j], arg1, arg2);
	          value = value ? value + nodeValue : nodeValue;
	        }
	        return value;
	      }
	    } else {
	      // we are a write, so apply to all children
	      for (i = 0; i < nodeCount; i++) {
	        fn(this[i], arg1, arg2);
	      }
	      // return self for chaining
	      return this;
	    }
	  };
	});
	
	function createEventHandler(element, events) {
	  var eventHandler = function(event, type) {
	    // jQuery specific api
	    event.isDefaultPrevented = function() {
	      return event.defaultPrevented;
	    };
	
	    var eventFns = events[type || event.type];
	    var eventFnsLength = eventFns ? eventFns.length : 0;
	
	    if (!eventFnsLength) return;
	
	    if (isUndefined(event.immediatePropagationStopped)) {
	      var originalStopImmediatePropagation = event.stopImmediatePropagation;
	      event.stopImmediatePropagation = function() {
	        event.immediatePropagationStopped = true;
	
	        if (event.stopPropagation) {
	          event.stopPropagation();
	        }
	
	        if (originalStopImmediatePropagation) {
	          originalStopImmediatePropagation.call(event);
	        }
	      };
	    }
	
	    event.isImmediatePropagationStopped = function() {
	      return event.immediatePropagationStopped === true;
	    };
	
	    // Some events have special handlers that wrap the real handler
	    var handlerWrapper = eventFns.specialHandlerWrapper || defaultHandlerWrapper;
	
	    // Copy event handlers in case event handlers array is modified during execution.
	    if ((eventFnsLength > 1)) {
	      eventFns = shallowCopy(eventFns);
	    }
	
	    for (var i = 0; i < eventFnsLength; i++) {
	      if (!event.isImmediatePropagationStopped()) {
	        handlerWrapper(element, event, eventFns[i]);
	      }
	    }
	  };
	
	  // TODO: this is a hack for angularMocks/clearDataCache that makes it possible to deregister all
	  //       events on `element`
	  eventHandler.elem = element;
	  return eventHandler;
	}
	
	function defaultHandlerWrapper(element, event, handler) {
	  handler.call(element, event);
	}
	
	function specialMouseHandlerWrapper(target, event, handler) {
	  // Refer to jQuery's implementation of mouseenter & mouseleave
	  // Read about mouseenter and mouseleave:
	  // http://www.quirksmode.org/js/events_mouse.html#link8
	  var related = event.relatedTarget;
	  // For mousenter/leave call the handler if related is outside the target.
	  // NB: No relatedTarget if the mouse left/entered the browser window
	  if (!related || (related !== target && !jqLiteContains.call(target, related))) {
	    handler.call(target, event);
	  }
	}
	
	//////////////////////////////////////////
	// Functions iterating traversal.
	// These functions chain results into a single
	// selector.
	//////////////////////////////////////////
	forEach({
	  removeData: jqLiteRemoveData,
	
	  on: function jqLiteOn(element, type, fn, unsupported) {
	    if (isDefined(unsupported)) throw jqLiteMinErr('onargs', 'jqLite#on() does not support the `selector` or `eventData` parameters');
	
	    // Do not add event handlers to non-elements because they will not be cleaned up.
	    if (!jqLiteAcceptsData(element)) {
	      return;
	    }
	
	    var expandoStore = jqLiteExpandoStore(element, true);
	    var events = expandoStore.events;
	    var handle = expandoStore.handle;
	
	    if (!handle) {
	      handle = expandoStore.handle = createEventHandler(element, events);
	    }
	
	    // http://jsperf.com/string-indexof-vs-split
	    var types = type.indexOf(' ') >= 0 ? type.split(' ') : [type];
	    var i = types.length;
	
	    var addHandler = function(type, specialHandlerWrapper, noEventListener) {
	      var eventFns = events[type];
	
	      if (!eventFns) {
	        eventFns = events[type] = [];
	        eventFns.specialHandlerWrapper = specialHandlerWrapper;
	        if (type !== '$destroy' && !noEventListener) {
	          element.addEventListener(type, handle);
	        }
	      }
	
	      eventFns.push(fn);
	    };
	
	    while (i--) {
	      type = types[i];
	      if (MOUSE_EVENT_MAP[type]) {
	        addHandler(MOUSE_EVENT_MAP[type], specialMouseHandlerWrapper);
	        addHandler(type, undefined, true);
	      } else {
	        addHandler(type);
	      }
	    }
	  },
	
	  off: jqLiteOff,
	
	  one: function(element, type, fn) {
	    element = jqLite(element);
	
	    //add the listener twice so that when it is called
	    //you can remove the original function and still be
	    //able to call element.off(ev, fn) normally
	    element.on(type, function onFn() {
	      element.off(type, fn);
	      element.off(type, onFn);
	    });
	    element.on(type, fn);
	  },
	
	  replaceWith: function(element, replaceNode) {
	    var index, parent = element.parentNode;
	    jqLiteDealoc(element);
	    forEach(new JQLite(replaceNode), function(node) {
	      if (index) {
	        parent.insertBefore(node, index.nextSibling);
	      } else {
	        parent.replaceChild(node, element);
	      }
	      index = node;
	    });
	  },
	
	  children: function(element) {
	    var children = [];
	    forEach(element.childNodes, function(element) {
	      if (element.nodeType === NODE_TYPE_ELEMENT) {
	        children.push(element);
	      }
	    });
	    return children;
	  },
	
	  contents: function(element) {
	    return element.contentDocument || element.childNodes || [];
	  },
	
	  append: function(element, node) {
	    var nodeType = element.nodeType;
	    if (nodeType !== NODE_TYPE_ELEMENT && nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT) return;
	
	    node = new JQLite(node);
	
	    for (var i = 0, ii = node.length; i < ii; i++) {
	      var child = node[i];
	      element.appendChild(child);
	    }
	  },
	
	  prepend: function(element, node) {
	    if (element.nodeType === NODE_TYPE_ELEMENT) {
	      var index = element.firstChild;
	      forEach(new JQLite(node), function(child) {
	        element.insertBefore(child, index);
	      });
	    }
	  },
	
	  wrap: function(element, wrapNode) {
	    jqLiteWrapNode(element, jqLite(wrapNode).eq(0).clone()[0]);
	  },
	
	  remove: jqLiteRemove,
	
	  detach: function(element) {
	    jqLiteRemove(element, true);
	  },
	
	  after: function(element, newElement) {
	    var index = element, parent = element.parentNode;
	
	    if (parent) {
	      newElement = new JQLite(newElement);
	
	      for (var i = 0, ii = newElement.length; i < ii; i++) {
	        var node = newElement[i];
	        parent.insertBefore(node, index.nextSibling);
	        index = node;
	      }
	    }
	  },
	
	  addClass: jqLiteAddClass,
	  removeClass: jqLiteRemoveClass,
	
	  toggleClass: function(element, selector, condition) {
	    if (selector) {
	      forEach(selector.split(' '), function(className) {
	        var classCondition = condition;
	        if (isUndefined(classCondition)) {
	          classCondition = !jqLiteHasClass(element, className);
	        }
	        (classCondition ? jqLiteAddClass : jqLiteRemoveClass)(element, className);
	      });
	    }
	  },
	
	  parent: function(element) {
	    var parent = element.parentNode;
	    return parent && parent.nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT ? parent : null;
	  },
	
	  next: function(element) {
	    return element.nextElementSibling;
	  },
	
	  find: function(element, selector) {
	    if (element.getElementsByTagName) {
	      return element.getElementsByTagName(selector);
	    } else {
	      return [];
	    }
	  },
	
	  clone: jqLiteClone,
	
	  triggerHandler: function(element, event, extraParameters) {
	
	    var dummyEvent, eventFnsCopy, handlerArgs;
	    var eventName = event.type || event;
	    var expandoStore = jqLiteExpandoStore(element);
	    var events = expandoStore && expandoStore.events;
	    var eventFns = events && events[eventName];
	
	    if (eventFns) {
	      // Create a dummy event to pass to the handlers
	      dummyEvent = {
	        preventDefault: function() { this.defaultPrevented = true; },
	        isDefaultPrevented: function() { return this.defaultPrevented === true; },
	        stopImmediatePropagation: function() { this.immediatePropagationStopped = true; },
	        isImmediatePropagationStopped: function() { return this.immediatePropagationStopped === true; },
	        stopPropagation: noop,
	        type: eventName,
	        target: element
	      };
	
	      // If a custom event was provided then extend our dummy event with it
	      if (event.type) {
	        dummyEvent = extend(dummyEvent, event);
	      }
	
	      // Copy event handlers in case event handlers array is modified during execution.
	      eventFnsCopy = shallowCopy(eventFns);
	      handlerArgs = extraParameters ? [dummyEvent].concat(extraParameters) : [dummyEvent];
	
	      forEach(eventFnsCopy, function(fn) {
	        if (!dummyEvent.isImmediatePropagationStopped()) {
	          fn.apply(element, handlerArgs);
	        }
	      });
	    }
	  }
	}, function(fn, name) {
	  /**
	   * chaining functions
	   */
	  JQLite.prototype[name] = function(arg1, arg2, arg3) {
	    var value;
	
	    for (var i = 0, ii = this.length; i < ii; i++) {
	      if (isUndefined(value)) {
	        value = fn(this[i], arg1, arg2, arg3);
	        if (isDefined(value)) {
	          // any function which returns a value needs to be wrapped
	          value = jqLite(value);
	        }
	      } else {
	        jqLiteAddNodes(value, fn(this[i], arg1, arg2, arg3));
	      }
	    }
	    return isDefined(value) ? value : this;
	  };
	});
	
	// bind legacy bind/unbind to on/off
	JQLite.prototype.bind = JQLite.prototype.on;
	JQLite.prototype.unbind = JQLite.prototype.off;
	
	
	// Provider for private $$jqLite service
	/** @this */
	function $$jqLiteProvider() {
	  this.$get = function $$jqLite() {
	    return extend(JQLite, {
	      hasClass: function(node, classes) {
	        if (node.attr) node = node[0];
	        return jqLiteHasClass(node, classes);
	      },
	      addClass: function(node, classes) {
	        if (node.attr) node = node[0];
	        return jqLiteAddClass(node, classes);
	      },
	      removeClass: function(node, classes) {
	        if (node.attr) node = node[0];
	        return jqLiteRemoveClass(node, classes);
	      }
	    });
	  };
	}
	
	/**
	 * Computes a hash of an 'obj'.
	 * Hash of a:
	 *  string is string
	 *  number is number as string
	 *  object is either result of calling $$hashKey function on the object or uniquely generated id,
	 *         that is also assigned to the $$hashKey property of the object.
	 *
	 * @param obj
	 * @returns {string} hash string such that the same input will have the same hash string.
	 *         The resulting string key is in 'type:hashKey' format.
	 */
	function hashKey(obj, nextUidFn) {
	  var key = obj && obj.$$hashKey;
	
	  if (key) {
	    if (typeof key === 'function') {
	      key = obj.$$hashKey();
	    }
	    return key;
	  }
	
	  var objType = typeof obj;
	  if (objType === 'function' || (objType === 'object' && obj !== null)) {
	    key = obj.$$hashKey = objType + ':' + (nextUidFn || nextUid)();
	  } else {
	    key = objType + ':' + obj;
	  }
	
	  return key;
	}
	
	// A minimal ES2015 Map implementation.
	// Should be bug/feature equivalent to the native implementations of supported browsers
	// (for the features required in Angular).
	// See https://kangax.github.io/compat-table/es6/#test-Map
	var nanKey = Object.create(null);
	function NgMapShim() {
	  this._keys = [];
	  this._values = [];
	  this._lastKey = NaN;
	  this._lastIndex = -1;
	}
	NgMapShim.prototype = {
	  _idx: function(key) {
	    if (key !== this._lastKey) {
	      this._lastKey = key;
	      this._lastIndex = this._keys.indexOf(key);
	    }
	    return this._lastIndex;
	  },
	  _transformKey: function(key) {
	    return isNumberNaN(key) ? nanKey : key;
	  },
	  get: function(key) {
	    key = this._transformKey(key);
	    var idx = this._idx(key);
	    if (idx !== -1) {
	      return this._values[idx];
	    }
	  },
	  has: function(key) {
	    key = this._transformKey(key);
	    var idx = this._idx(key);
	    return idx !== -1;
	  },
	  set: function(key, value) {
	    key = this._transformKey(key);
	    var idx = this._idx(key);
	    if (idx === -1) {
	      idx = this._lastIndex = this._keys.length;
	    }
	    this._keys[idx] = key;
	    this._values[idx] = value;
	
	    // Support: IE11
	    // Do not `return this` to simulate the partial IE11 implementation
	  },
	  delete: function(key) {
	    key = this._transformKey(key);
	    var idx = this._idx(key);
	    if (idx === -1) {
	      return false;
	    }
	    this._keys.splice(idx, 1);
	    this._values.splice(idx, 1);
	    this._lastKey = NaN;
	    this._lastIndex = -1;
	    return true;
	  }
	};
	
	// For now, always use `NgMapShim`, even if `window.Map` is available. Some native implementations
	// are still buggy (often in subtle ways) and can cause hard-to-debug failures. When native `Map`
	// implementations get more stable, we can reconsider switching to `window.Map` (when available).
	var NgMap = NgMapShim;
	
	var $$MapProvider = [/** @this */function() {
	  this.$get = [function() {
	    return NgMap;
	  }];
	}];
	
	/**
	 * @ngdoc function
	 * @module ng
	 * @name angular.injector
	 * @kind function
	 *
	 * @description
	 * Creates an injector object that can be used for retrieving services as well as for
	 * dependency injection (see {@link guide/di dependency injection}).
	 *
	 * @param {Array.<string|Function>} modules A list of module functions or their aliases. See
	 *     {@link angular.module}. The `ng` module must be explicitly added.
	 * @param {boolean=} [strictDi=false] Whether the injector should be in strict mode, which
	 *     disallows argument name annotation inference.
	 * @returns {injector} Injector object. See {@link auto.$injector $injector}.
	 *
	 * @example
	 * Typical usage
	 * ```js
	 *   // create an injector
	 *   var $injector = angular.injector(['ng']);
	 *
	 *   // use the injector to kick off your application
	 *   // use the type inference to auto inject arguments, or use implicit injection
	 *   $injector.invoke(function($rootScope, $compile, $document) {
	 *     $compile($document)($rootScope);
	 *     $rootScope.$digest();
	 *   });
	 * ```
	 *
	 * Sometimes you want to get access to the injector of a currently running AngularJS app
	 * from outside AngularJS. Perhaps, you want to inject and compile some markup after the
	 * application has been bootstrapped. You can do this using the extra `injector()` added
	 * to JQuery/jqLite elements. See {@link angular.element}.
	 *
	 * *This is fairly rare but could be the case if a third party library is injecting the
	 * markup.*
	 *
	 * In the following example a new block of HTML containing a `ng-controller`
	 * directive is added to the end of the document body by JQuery. We then compile and link
	 * it into the current AngularJS scope.
	 *
	 * ```js
	 * var $div = $('<div ng-controller="MyCtrl">{{content.label}}</div>');
	 * $(document.body).append($div);
	 *
	 * angular.element(document).injector().invoke(function($compile) {
	 *   var scope = angular.element($div).scope();
	 *   $compile($div)(scope);
	 * });
	 * ```
	 */
	
	
	/**
	 * @ngdoc module
	 * @name auto
	 * @installation
	 * @description
	 *
	 * Implicit module which gets automatically added to each {@link auto.$injector $injector}.
	 */
	
	var ARROW_ARG = /^([^(]+?)=>/;
	var FN_ARGS = /^[^(]*\(\s*([^)]*)\)/m;
	var FN_ARG_SPLIT = /,/;
	var FN_ARG = /^\s*(_?)(\S+?)\1\s*$/;
	var STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg;
	var $injectorMinErr = minErr('$injector');
	
	function stringifyFn(fn) {
	  return Function.prototype.toString.call(fn);
	}
	
	function extractArgs(fn) {
	  var fnText = stringifyFn(fn).replace(STRIP_COMMENTS, ''),
	      args = fnText.match(ARROW_ARG) || fnText.match(FN_ARGS);
	  return args;
	}
	
	function anonFn(fn) {
	  // For anonymous functions, showing at the very least the function signature can help in
	  // debugging.
	  var args = extractArgs(fn);
	  if (args) {
	    return 'function(' + (args[1] || '').replace(/[\s\r\n]+/, ' ') + ')';
	  }
	  return 'fn';
	}
	
	function annotate(fn, strictDi, name) {
	  var $inject,
	      argDecl,
	      last;
	
	  if (typeof fn === 'function') {
	    if (!($inject = fn.$inject)) {
	      $inject = [];
	      if (fn.length) {
	        if (strictDi) {
	          if (!isString(name) || !name) {
	            name = fn.name || anonFn(fn);
	          }
	          throw $injectorMinErr('strictdi',
	            '{0} is not using explicit annotation and cannot be invoked in strict mode', name);
	        }
	        argDecl = extractArgs(fn);
	        forEach(argDecl[1].split(FN_ARG_SPLIT), function(arg) {
	          arg.replace(FN_ARG, function(all, underscore, name) {
	            $inject.push(name);
	          });
	        });
	      }
	      fn.$inject = $inject;
	    }
	  } else if (isArray(fn)) {
	    last = fn.length - 1;
	    assertArgFn(fn[last], 'fn');
	    $inject = fn.slice(0, last);
	  } else {
	    assertArgFn(fn, 'fn', true);
	  }
	  return $inject;
	}
	
	///////////////////////////////////////
	
	/**
	 * @ngdoc service
	 * @name $injector
	 *
	 * @description
	 *
	 * `$injector` is used to retrieve object instances as defined by
	 * {@link auto.$provide provider}, instantiate types, invoke methods,
	 * and load modules.
	 *
	 * The following always holds true:
	 *
	 * ```js
	 *   var $injector = angular.injector();
	 *   expect($injector.get('$injector')).toBe($injector);
	 *   expect($injector.invoke(function($injector) {
	 *     return $injector;
	 *   })).toBe($injector);
	 * ```
	 *
	 * ## Injection Function Annotation
	 *
	 * JavaScript does not have annotations, and annotations are needed for dependency injection. The
	 * following are all valid ways of annotating function with injection arguments and are equivalent.
	 *
	 * ```js
	 *   // inferred (only works if code not minified/obfuscated)
	 *   $injector.invoke(function(serviceA){});
	 *
	 *   // annotated
	 *   function explicit(serviceA) {};
	 *   explicit.$inject = ['serviceA'];
	 *   $injector.invoke(explicit);
	 *
	 *   // inline
	 *   $injector.invoke(['serviceA', function(serviceA){}]);
	 * ```
	 *
	 * ### Inference
	 *
	 * In JavaScript calling `toString()` on a function returns the function definition. The definition
	 * can then be parsed and the function arguments can be extracted. This method of discovering
	 * annotations is disallowed when the injector is in strict mode.
	 * *NOTE:* This does not work with minification, and obfuscation tools since these tools change the
	 * argument names.
	 *
	 * ### `$inject` Annotation
	 * By adding an `$inject` property onto a function the injection parameters can be specified.
	 *
	 * ### Inline
	 * As an array of injection names, where the last item in the array is the function to call.
	 */
	
	/**
	 * @ngdoc property
	 * @name $injector#modules
	 * @type {Object}
	 * @description
	 * A hash containing all the modules that have been loaded into the
	 * $injector.
	 *
	 * You can use this property to find out information about a module via the
	 * {@link angular.Module#info `myModule.info(...)`} method.
	 *
	 * For example:
	 *
	 * ```
	 * var info = $injector.modules['ngAnimate'].info();
	 * ```
	 *
	 * **Do not use this property to attempt to modify the modules after the application
	 * has been bootstrapped.**
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $injector#get
	 *
	 * @description
	 * Return an instance of the service.
	 *
	 * @param {string} name The name of the instance to retrieve.
	 * @param {string=} caller An optional string to provide the origin of the function call for error messages.
	 * @return {*} The instance.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#invoke
	 *
	 * @description
	 * Invoke the method and supply the method arguments from the `$injector`.
	 *
	 * @param {Function|Array.<string|Function>} fn The injectable function to invoke. Function parameters are
	 *   injected according to the {@link guide/di $inject Annotation} rules.
	 * @param {Object=} self The `this` for the invoked method.
	 * @param {Object=} locals Optional object. If preset then any argument names are read from this
	 *                         object first, before the `$injector` is consulted.
	 * @returns {*} the value returned by the invoked `fn` function.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#has
	 *
	 * @description
	 * Allows the user to query if the particular service exists.
	 *
	 * @param {string} name Name of the service to query.
	 * @returns {boolean} `true` if injector has given service.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#instantiate
	 * @description
	 * Create a new instance of JS type. The method takes a constructor function, invokes the new
	 * operator, and supplies all of the arguments to the constructor function as specified by the
	 * constructor annotation.
	 *
	 * @param {Function} Type Annotated constructor function.
	 * @param {Object=} locals Optional object. If preset then any argument names are read from this
	 * object first, before the `$injector` is consulted.
	 * @returns {Object} new instance of `Type`.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#annotate
	 *
	 * @description
	 * Returns an array of service names which the function is requesting for injection. This API is
	 * used by the injector to determine which services need to be injected into the function when the
	 * function is invoked. There are three ways in which the function can be annotated with the needed
	 * dependencies.
	 *
	 * #### Argument names
	 *
	 * The simplest form is to extract the dependencies from the arguments of the function. This is done
	 * by converting the function into a string using `toString()` method and extracting the argument
	 * names.
	 * ```js
	 *   // Given
	 *   function MyController($scope, $route) {
	 *     // ...
	 *   }
	 *
	 *   // Then
	 *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
	 * ```
	 *
	 * You can disallow this method by using strict injection mode.
	 *
	 * This method does not work with code minification / obfuscation. For this reason the following
	 * annotation strategies are supported.
	 *
	 * #### The `$inject` property
	 *
	 * If a function has an `$inject` property and its value is an array of strings, then the strings
	 * represent names of services to be injected into the function.
	 * ```js
	 *   // Given
	 *   var MyController = function(obfuscatedScope, obfuscatedRoute) {
	 *     // ...
	 *   }
	 *   // Define function dependencies
	 *   MyController['$inject'] = ['$scope', '$route'];
	 *
	 *   // Then
	 *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
	 * ```
	 *
	 * #### The array notation
	 *
	 * It is often desirable to inline Injected functions and that's when setting the `$inject` property
	 * is very inconvenient. In these situations using the array notation to specify the dependencies in
	 * a way that survives minification is a better choice:
	 *
	 * ```js
	 *   // We wish to write this (not minification / obfuscation safe)
	 *   injector.invoke(function($compile, $rootScope) {
	 *     // ...
	 *   });
	 *
	 *   // We are forced to write break inlining
	 *   var tmpFn = function(obfuscatedCompile, obfuscatedRootScope) {
	 *     // ...
	 *   };
	 *   tmpFn.$inject = ['$compile', '$rootScope'];
	 *   injector.invoke(tmpFn);
	 *
	 *   // To better support inline function the inline annotation is supported
	 *   injector.invoke(['$compile', '$rootScope', function(obfCompile, obfRootScope) {
	 *     // ...
	 *   }]);
	 *
	 *   // Therefore
	 *   expect(injector.annotate(
	 *      ['$compile', '$rootScope', function(obfus_$compile, obfus_$rootScope) {}])
	 *    ).toEqual(['$compile', '$rootScope']);
	 * ```
	 *
	 * @param {Function|Array.<string|Function>} fn Function for which dependent service names need to
	 * be retrieved as described above.
	 *
	 * @param {boolean=} [strictDi=false] Disallow argument name annotation inference.
	 *
	 * @returns {Array.<string>} The names of the services which the function requires.
	 */
	/**
	 * @ngdoc method
	 * @name $injector#loadNewModules
	 *
	 * @description
	 *
	 * **This is a dangerous API, which you use at your own risk!**
	 *
	 * Add the specified modules to the current injector.
	 *
	 * This method will add each of the injectables to the injector and execute all of the config and run
	 * blocks for each module passed to the method.
	 *
	 * If a module has already been loaded into the injector then it will not be loaded again.
	 *
	 * * The application developer is responsible for loading the code containing the modules; and for
	 * ensuring that lazy scripts are not downloaded and executed more often that desired.
	 * * Previously compiled HTML will not be affected by newly loaded directives, filters and components.
	 * * Modules cannot be unloaded.
	 *
	 * You can use {@link $injector#modules `$injector.modules`} to check whether a module has been loaded
	 * into the injector, which may indicate whether the script has been executed already.
	 *
	 * @example
	 * Here is an example of loading a bundle of modules, with a utility method called `getScript`:
	 *
	 * ```javascript
	 * app.factory('loadModule', function($injector) {
	 *   return function loadModule(moduleName, bundleUrl) {
	 *     return getScript(bundleUrl).then(function() { $injector.loadNewModules([moduleName]); });
	 *   };
	 * })
	 * ```
	 *
	 * @param {Array<String|Function|Array>=} mods an array of modules to load into the application.
	 *     Each item in the array should be the name of a predefined module or a (DI annotated)
	 *     function that will be invoked by the injector as a `config` block.
	 *     See: {@link angular.module modules}
	 */
	
	
	/**
	 * @ngdoc service
	 * @name $provide
	 *
	 * @description
	 *
	 * The {@link auto.$provide $provide} service has a number of methods for registering components
	 * with the {@link auto.$injector $injector}. Many of these functions are also exposed on
	 * {@link angular.Module}.
	 *
	 * An AngularJS **service** is a singleton object created by a **service factory**.  These **service
	 * factories** are functions which, in turn, are created by a **service provider**.
	 * The **service providers** are constructor functions. When instantiated they must contain a
	 * property called `$get`, which holds the **service factory** function.
	 *
	 * When you request a service, the {@link auto.$injector $injector} is responsible for finding the
	 * correct **service provider**, instantiating it and then calling its `$get` **service factory**
	 * function to get the instance of the **service**.
	 *
	 * Often services have no configuration options and there is no need to add methods to the service
	 * provider.  The provider will be no more than a constructor function with a `$get` property. For
	 * these cases the {@link auto.$provide $provide} service has additional helper methods to register
	 * services without specifying a provider.
	 *
	 * * {@link auto.$provide#provider provider(name, provider)} - registers a **service provider** with the
	 *     {@link auto.$injector $injector}
	 * * {@link auto.$provide#constant constant(name, obj)} - registers a value/object that can be accessed by
	 *     providers and services.
	 * * {@link auto.$provide#value value(name, obj)} - registers a value/object that can only be accessed by
	 *     services, not providers.
	 * * {@link auto.$provide#factory factory(name, fn)} - registers a service **factory function**
	 *     that will be wrapped in a **service provider** object, whose `$get` property will contain the
	 *     given factory function.
	 * * {@link auto.$provide#service service(name, Fn)} - registers a **constructor function**
	 *     that will be wrapped in a **service provider** object, whose `$get` property will instantiate
	 *      a new object using the given constructor function.
	 * * {@link auto.$provide#decorator decorator(name, decorFn)} - registers a **decorator function** that
	 *      will be able to modify or replace the implementation of another service.
	 *
	 * See the individual methods for more information and examples.
	 */
	
	/**
	 * @ngdoc method
	 * @name $provide#provider
	 * @description
	 *
	 * Register a **provider function** with the {@link auto.$injector $injector}. Provider functions
	 * are constructor functions, whose instances are responsible for "providing" a factory for a
	 * service.
	 *
	 * Service provider names start with the name of the service they provide followed by `Provider`.
	 * For example, the {@link ng.$log $log} service has a provider called
	 * {@link ng.$logProvider $logProvider}.
	 *
	 * Service provider objects can have additional methods which allow configuration of the provider
	 * and its service. Importantly, you can configure what kind of service is created by the `$get`
	 * method, or how that service will act. For example, the {@link ng.$logProvider $logProvider} has a
	 * method {@link ng.$logProvider#debugEnabled debugEnabled}
	 * which lets you specify whether the {@link ng.$log $log} service will log debug messages to the
	 * console or not.
	 *
	 * It is possible to inject other providers into the provider function,
	 * but the injected provider must have been defined before the one that requires it.
	 *
	 * @param {string} name The name of the instance. NOTE: the provider will be available under `name +
	                        'Provider'` key.
	 * @param {(Object|function())} provider If the provider is:
	 *
	 *   - `Object`: then it should have a `$get` method. The `$get` method will be invoked using
	 *     {@link auto.$injector#invoke $injector.invoke()} when an instance needs to be created.
	 *   - `Constructor`: a new instance of the provider will be created using
	 *     {@link auto.$injector#instantiate $injector.instantiate()}, then treated as `object`.
	 *
	 * @returns {Object} registered provider instance
	
	 * @example
	 *
	 * The following example shows how to create a simple event tracking service and register it using
	 * {@link auto.$provide#provider $provide.provider()}.
	 *
	 * ```js
	 *  // Define the eventTracker provider
	 *  function EventTrackerProvider() {
	 *    var trackingUrl = '/track';
	 *
	 *    // A provider method for configuring where the tracked events should been saved
	 *    this.setTrackingUrl = function(url) {
	 *      trackingUrl = url;
	 *    };
	 *
	 *    // The service factory function
	 *    this.$get = ['$http', function($http) {
	 *      var trackedEvents = {};
	 *      return {
	 *        // Call this to track an event
	 *        event: function(event) {
	 *          var count = trackedEvents[event] || 0;
	 *          count += 1;
	 *          trackedEvents[event] = count;
	 *          return count;
	 *        },
	 *        // Call this to save the tracked events to the trackingUrl
	 *        save: function() {
	 *          $http.post(trackingUrl, trackedEvents);
	 *        }
	 *      };
	 *    }];
	 *  }
	 *
	 *  describe('eventTracker', function() {
	 *    var postSpy;
	 *
	 *    beforeEach(module(function($provide) {
	 *      // Register the eventTracker provider
	 *      $provide.provider('eventTracker', EventTrackerProvider);
	 *    }));
	 *
	 *    beforeEach(module(function(eventTrackerProvider) {
	 *      // Configure eventTracker provider
	 *      eventTrackerProvider.setTrackingUrl('/custom-track');
	 *    }));
	 *
	 *    it('tracks events', inject(function(eventTracker) {
	 *      expect(eventTracker.event('login')).toEqual(1);
	 *      expect(eventTracker.event('login')).toEqual(2);
	 *    }));
	 *
	 *    it('saves to the tracking url', inject(function(eventTracker, $http) {
	 *      postSpy = spyOn($http, 'post');
	 *      eventTracker.event('login');
	 *      eventTracker.save();
	 *      expect(postSpy).toHaveBeenCalled();
	 *      expect(postSpy.mostRecentCall.args[0]).not.toEqual('/track');
	 *      expect(postSpy.mostRecentCall.args[0]).toEqual('/custom-track');
	 *      expect(postSpy.mostRecentCall.args[1]).toEqual({ 'login': 1 });
	 *    }));
	 *  });
	 * ```
	 */
	
	/**
	 * @ngdoc method
	 * @name $provide#factory
	 * @description
	 *
	 * Register a **service factory**, which will be called to return the service instance.
	 * This is short for registering a service where its provider consists of only a `$get` property,
	 * which is the given service factory function.
	 * You should use {@link auto.$provide#factory $provide.factory(getFn)} if you do not need to
	 * configure your service in a provider.
	 *
	 * @param {string} name The name of the instance.
	 * @param {Function|Array.<string|Function>} $getFn The injectable $getFn for the instance creation.
	 *                      Internally this is a short hand for `$provide.provider(name, {$get: $getFn})`.
	 * @returns {Object} registered provider instance
	 *
	 * @example
	 * Here is an example of registering a service
	 * ```js
	 *   $provide.factory('ping', ['$http', function($http) {
	 *     return function ping() {
	 *       return $http.send('/ping');
	 *     };
	 *   }]);
	 * ```
	 * You would then inject and use this service like this:
	 * ```js
	 *   someModule.controller('Ctrl', ['ping', function(ping) {
	 *     ping();
	 *   }]);
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#service
	 * @description
	 *
	 * Register a **service constructor**, which will be invoked with `new` to create the service
	 * instance.
	 * This is short for registering a service where its provider's `$get` property is a factory
	 * function that returns an instance instantiated by the injector from the service constructor
	 * function.
	 *
	 * Internally it looks a bit like this:
	 *
	 * ```
	 * {
	 *   $get: function() {
	 *     return $injector.instantiate(constructor);
	 *   }
	 * }
	 * ```
	 *
	 *
	 * You should use {@link auto.$provide#service $provide.service(class)} if you define your service
	 * as a type/class.
	 *
	 * @param {string} name The name of the instance.
	 * @param {Function|Array.<string|Function>} constructor An injectable class (constructor function)
	 *     that will be instantiated.
	 * @returns {Object} registered provider instance
	 *
	 * @example
	 * Here is an example of registering a service using
	 * {@link auto.$provide#service $provide.service(class)}.
	 * ```js
	 *   var Ping = function($http) {
	 *     this.$http = $http;
	 *   };
	 *
	 *   Ping.$inject = ['$http'];
	 *
	 *   Ping.prototype.send = function() {
	 *     return this.$http.get('/ping');
	 *   };
	 *   $provide.service('ping', Ping);
	 * ```
	 * You would then inject and use this service like this:
	 * ```js
	 *   someModule.controller('Ctrl', ['ping', function(ping) {
	 *     ping.send();
	 *   }]);
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#value
	 * @description
	 *
	 * Register a **value service** with the {@link auto.$injector $injector}, such as a string, a
	 * number, an array, an object or a function. This is short for registering a service where its
	 * provider's `$get` property is a factory function that takes no arguments and returns the **value
	 * service**. That also means it is not possible to inject other services into a value service.
	 *
	 * Value services are similar to constant services, except that they cannot be injected into a
	 * module configuration function (see {@link angular.Module#config}) but they can be overridden by
	 * an AngularJS {@link auto.$provide#decorator decorator}.
	 *
	 * @param {string} name The name of the instance.
	 * @param {*} value The value.
	 * @returns {Object} registered provider instance
	 *
	 * @example
	 * Here are some examples of creating value services.
	 * ```js
	 *   $provide.value('ADMIN_USER', 'admin');
	 *
	 *   $provide.value('RoleLookup', { admin: 0, writer: 1, reader: 2 });
	 *
	 *   $provide.value('halfOf', function(value) {
	 *     return value / 2;
	 *   });
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#constant
	 * @description
	 *
	 * Register a **constant service** with the {@link auto.$injector $injector}, such as a string,
	 * a number, an array, an object or a function. Like the {@link auto.$provide#value value}, it is not
	 * possible to inject other services into a constant.
	 *
	 * But unlike {@link auto.$provide#value value}, a constant can be
	 * injected into a module configuration function (see {@link angular.Module#config}) and it cannot
	 * be overridden by an AngularJS {@link auto.$provide#decorator decorator}.
	 *
	 * @param {string} name The name of the constant.
	 * @param {*} value The constant value.
	 * @returns {Object} registered instance
	 *
	 * @example
	 * Here a some examples of creating constants:
	 * ```js
	 *   $provide.constant('SHARD_HEIGHT', 306);
	 *
	 *   $provide.constant('MY_COLOURS', ['red', 'blue', 'grey']);
	 *
	 *   $provide.constant('double', function(value) {
	 *     return value * 2;
	 *   });
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#decorator
	 * @description
	 *
	 * Register a **decorator function** with the {@link auto.$injector $injector}. A decorator function
	 * intercepts the creation of a service, allowing it to override or modify the behavior of the
	 * service. The return value of the decorator function may be the original service, or a new service
	 * that replaces (or wraps and delegates to) the original service.
	 *
	 * You can find out more about using decorators in the {@link guide/decorators} guide.
	 *
	 * @param {string} name The name of the service to decorate.
	 * @param {Function|Array.<string|Function>} decorator This function will be invoked when the service needs to be
	 *    provided and should return the decorated service instance. The function is called using
	 *    the {@link auto.$injector#invoke injector.invoke} method and is therefore fully injectable.
	 *    Local injection arguments:
	 *
	 *    * `$delegate` - The original service instance, which can be replaced, monkey patched, configured,
	 *      decorated or delegated to.
	 *
	 * @example
	 * Here we decorate the {@link ng.$log $log} service to convert warnings to errors by intercepting
	 * calls to {@link ng.$log#error $log.warn()}.
	 * ```js
	 *   $provide.decorator('$log', ['$delegate', function($delegate) {
	 *     $delegate.warn = $delegate.error;
	 *     return $delegate;
	 *   }]);
	 * ```
	 */
	
	
	function createInjector(modulesToLoad, strictDi) {
	  strictDi = (strictDi === true);
	  var INSTANTIATING = {},
	      providerSuffix = 'Provider',
	      path = [],
	      loadedModules = new NgMap(),
	      providerCache = {
	        $provide: {
	            provider: supportObject(provider),
	            factory: supportObject(factory),
	            service: supportObject(service),
	            value: supportObject(value),
	            constant: supportObject(constant),
	            decorator: decorator
	          }
	      },
	      providerInjector = (providerCache.$injector =
	          createInternalInjector(providerCache, function(serviceName, caller) {
	            if (angular.isString(caller)) {
	              path.push(caller);
	            }
	            throw $injectorMinErr('unpr', 'Unknown provider: {0}', path.join(' <- '));
	          })),
	      instanceCache = {},
	      protoInstanceInjector =
	          createInternalInjector(instanceCache, function(serviceName, caller) {
	            var provider = providerInjector.get(serviceName + providerSuffix, caller);
	            return instanceInjector.invoke(
	                provider.$get, provider, undefined, serviceName);
	          }),
	      instanceInjector = protoInstanceInjector;
	
	  providerCache['$injector' + providerSuffix] = { $get: valueFn(protoInstanceInjector) };
	  instanceInjector.modules = providerInjector.modules = createMap();
	  var runBlocks = loadModules(modulesToLoad);
	  instanceInjector = protoInstanceInjector.get('$injector');
	  instanceInjector.strictDi = strictDi;
	  forEach(runBlocks, function(fn) { if (fn) instanceInjector.invoke(fn); });
	
	  instanceInjector.loadNewModules = function(mods) {
	    forEach(loadModules(mods), function(fn) { if (fn) instanceInjector.invoke(fn); });
	  };
	
	
	  return instanceInjector;
	
	  ////////////////////////////////////
	  // $provider
	  ////////////////////////////////////
	
	  function supportObject(delegate) {
	    return function(key, value) {
	      if (isObject(key)) {
	        forEach(key, reverseParams(delegate));
	      } else {
	        return delegate(key, value);
	      }
	    };
	  }
	
	  function provider(name, provider_) {
	    assertNotHasOwnProperty(name, 'service');
	    if (isFunction(provider_) || isArray(provider_)) {
	      provider_ = providerInjector.instantiate(provider_);
	    }
	    if (!provider_.$get) {
	      throw $injectorMinErr('pget', 'Provider \'{0}\' must define $get factory method.', name);
	    }
	    return (providerCache[name + providerSuffix] = provider_);
	  }
	
	  function enforceReturnValue(name, factory) {
	    return /** @this */ function enforcedReturnValue() {
	      var result = instanceInjector.invoke(factory, this);
	      if (isUndefined(result)) {
	        throw $injectorMinErr('undef', 'Provider \'{0}\' must return a value from $get factory method.', name);
	      }
	      return result;
	    };
	  }
	
	  function factory(name, factoryFn, enforce) {
	    return provider(name, {
	      $get: enforce !== false ? enforceReturnValue(name, factoryFn) : factoryFn
	    });
	  }
	
	  function service(name, constructor) {
	    return factory(name, ['$injector', function($injector) {
	      return $injector.instantiate(constructor);
	    }]);
	  }
	
	  function value(name, val) { return factory(name, valueFn(val), false); }
	
	  function constant(name, value) {
	    assertNotHasOwnProperty(name, 'constant');
	    providerCache[name] = value;
	    instanceCache[name] = value;
	  }
	
	  function decorator(serviceName, decorFn) {
	    var origProvider = providerInjector.get(serviceName + providerSuffix),
	        orig$get = origProvider.$get;
	
	    origProvider.$get = function() {
	      var origInstance = instanceInjector.invoke(orig$get, origProvider);
	      return instanceInjector.invoke(decorFn, null, {$delegate: origInstance});
	    };
	  }
	
	  ////////////////////////////////////
	  // Module Loading
	  ////////////////////////////////////
	  function loadModules(modulesToLoad) {
	    assertArg(isUndefined(modulesToLoad) || isArray(modulesToLoad), 'modulesToLoad', 'not an array');
	    var runBlocks = [], moduleFn;
	    forEach(modulesToLoad, function(module) {
	      if (loadedModules.get(module)) return;
	      loadedModules.set(module, true);
	
	      function runInvokeQueue(queue) {
	        var i, ii;
	        for (i = 0, ii = queue.length; i < ii; i++) {
	          var invokeArgs = queue[i],
	              provider = providerInjector.get(invokeArgs[0]);
	
	          provider[invokeArgs[1]].apply(provider, invokeArgs[2]);
	        }
	      }
	
	      try {
	        if (isString(module)) {
	          moduleFn = angularModule(module);
	          instanceInjector.modules[module] = moduleFn;
	          runBlocks = runBlocks.concat(loadModules(moduleFn.requires)).concat(moduleFn._runBlocks);
	          runInvokeQueue(moduleFn._invokeQueue);
	          runInvokeQueue(moduleFn._configBlocks);
	        } else if (isFunction(module)) {
	            runBlocks.push(providerInjector.invoke(module));
	        } else if (isArray(module)) {
	            runBlocks.push(providerInjector.invoke(module));
	        } else {
	          assertArgFn(module, 'module');
	        }
	      } catch (e) {
	        if (isArray(module)) {
	          module = module[module.length - 1];
	        }
	        if (e.message && e.stack && e.stack.indexOf(e.message) === -1) {
	          // Safari & FF's stack traces don't contain error.message content
	          // unlike those of Chrome and IE
	          // So if stack doesn't contain message, we create a new string that contains both.
	          // Since error.stack is read-only in Safari, I'm overriding e and not e.stack here.
	          // eslint-disable-next-line no-ex-assign
	          e = e.message + '\n' + e.stack;
	        }
	        throw $injectorMinErr('modulerr', 'Failed to instantiate module {0} due to:\n{1}',
	                  module, e.stack || e.message || e);
	      }
	    });
	    return runBlocks;
	  }
	
	  ////////////////////////////////////
	  // internal Injector
	  ////////////////////////////////////
	
	  function createInternalInjector(cache, factory) {
	
	    function getService(serviceName, caller) {
	      if (cache.hasOwnProperty(serviceName)) {
	        if (cache[serviceName] === INSTANTIATING) {
	          throw $injectorMinErr('cdep', 'Circular dependency found: {0}',
	                    serviceName + ' <- ' + path.join(' <- '));
	        }
	        return cache[serviceName];
	      } else {
	        try {
	          path.unshift(serviceName);
	          cache[serviceName] = INSTANTIATING;
	          cache[serviceName] = factory(serviceName, caller);
	          return cache[serviceName];
	        } catch (err) {
	          if (cache[serviceName] === INSTANTIATING) {
	            delete cache[serviceName];
	          }
	          throw err;
	        } finally {
	          path.shift();
	        }
	      }
	    }
	
	
	    function injectionArgs(fn, locals, serviceName) {
	      var args = [],
	          $inject = createInjector.$$annotate(fn, strictDi, serviceName);
	
	      for (var i = 0, length = $inject.length; i < length; i++) {
	        var key = $inject[i];
	        if (typeof key !== 'string') {
	          throw $injectorMinErr('itkn',
	                  'Incorrect injection token! Expected service name as string, got {0}', key);
	        }
	        args.push(locals && locals.hasOwnProperty(key) ? locals[key] :
	                                                         getService(key, serviceName));
	      }
	      return args;
	    }
	
	    function isClass(func) {
	      // Support: IE 9-11 only
	      // IE 9-11 do not support classes and IE9 leaks with the code below.
	      if (msie || typeof func !== 'function') {
	        return false;
	      }
	      var result = func.$$ngIsClass;
	      if (!isBoolean(result)) {
	        result = func.$$ngIsClass = /^class\b/.test(stringifyFn(func));
	      }
	      return result;
	    }
	
	    function invoke(fn, self, locals, serviceName) {
	      if (typeof locals === 'string') {
	        serviceName = locals;
	        locals = null;
	      }
	
	      var args = injectionArgs(fn, locals, serviceName);
	      if (isArray(fn)) {
	        fn = fn[fn.length - 1];
	      }
	
	      if (!isClass(fn)) {
	        // http://jsperf.com/angularjs-invoke-apply-vs-switch
	        // #5388
	        return fn.apply(self, args);
	      } else {
	        args.unshift(null);
	        return new (Function.prototype.bind.apply(fn, args))();
	      }
	    }
	
	
	    function instantiate(Type, locals, serviceName) {
	      // Check if Type is annotated and use just the given function at n-1 as parameter
	      // e.g. someModule.factory('greeter', ['$window', function(renamed$window) {}]);
	      var ctor = (isArray(Type) ? Type[Type.length - 1] : Type);
	      var args = injectionArgs(Type, locals, serviceName);
	      // Empty object at position 0 is ignored for invocation with `new`, but required.
	      args.unshift(null);
	      return new (Function.prototype.bind.apply(ctor, args))();
	    }
	
	
	    return {
	      invoke: invoke,
	      instantiate: instantiate,
	      get: getService,
	      annotate: createInjector.$$annotate,
	      has: function(name) {
	        return providerCache.hasOwnProperty(name + providerSuffix) || cache.hasOwnProperty(name);
	      }
	    };
	  }
	}
	
	createInjector.$$annotate = annotate;
	
	/**
	 * @ngdoc provider
	 * @name $anchorScrollProvider
	 * @this
	 *
	 * @description
	 * Use `$anchorScrollProvider` to disable automatic scrolling whenever
	 * {@link ng.$location#hash $location.hash()} changes.
	 */
	function $AnchorScrollProvider() {
	
	  var autoScrollingEnabled = true;
	
	  /**
	   * @ngdoc method
	   * @name $anchorScrollProvider#disableAutoScrolling
	   *
	   * @description
	   * By default, {@link ng.$anchorScroll $anchorScroll()} will automatically detect changes to
	   * {@link ng.$location#hash $location.hash()} and scroll to the element matching the new hash.<br />
	   * Use this method to disable automatic scrolling.
	   *
	   * If automatic scrolling is disabled, one must explicitly call
	   * {@link ng.$anchorScroll $anchorScroll()} in order to scroll to the element related to the
	   * current hash.
	   */
	  this.disableAutoScrolling = function() {
	    autoScrollingEnabled = false;
	  };
	
	  /**
	   * @ngdoc service
	   * @name $anchorScroll
	   * @kind function
	   * @requires $window
	   * @requires $location
	   * @requires $rootScope
	   *
	   * @description
	   * When called, it scrolls to the element related to the specified `hash` or (if omitted) to the
	   * current value of {@link ng.$location#hash $location.hash()}, according to the rules specified
	   * in the
	   * [HTML5 spec](http://www.w3.org/html/wg/drafts/html/master/browsers.html#an-indicated-part-of-the-document).
	   *
	   * It also watches the {@link ng.$location#hash $location.hash()} and automatically scrolls to
	   * match any anchor whenever it changes. This can be disabled by calling
	   * {@link ng.$anchorScrollProvider#disableAutoScrolling $anchorScrollProvider.disableAutoScrolling()}.
	   *
	   * Additionally, you can use its {@link ng.$anchorScroll#yOffset yOffset} property to specify a
	   * vertical scroll-offset (either fixed or dynamic).
	   *
	   * @param {string=} hash The hash specifying the element to scroll to. If omitted, the value of
	   *                       {@link ng.$location#hash $location.hash()} will be used.
	   *
	   * @property {(number|function|jqLite)} yOffset
	   * If set, specifies a vertical scroll-offset. This is often useful when there are fixed
	   * positioned elements at the top of the page, such as navbars, headers etc.
	   *
	   * `yOffset` can be specified in various ways:
	   * - **number**: A fixed number of pixels to be used as offset.<br /><br />
	   * - **function**: A getter function called everytime `$anchorScroll()` is executed. Must return
	   *   a number representing the offset (in pixels).<br /><br />
	   * - **jqLite**: A jqLite/jQuery element to be used for specifying the offset. The distance from
	   *   the top of the page to the element's bottom will be used as offset.<br />
	   *   **Note**: The element will be taken into account only as long as its `position` is set to
	   *   `fixed`. This option is useful, when dealing with responsive navbars/headers that adjust
	   *   their height and/or positioning according to the viewport's size.
	   *
	   * <br />
	   * <div class="alert alert-warning">
	   * In order for `yOffset` to work properly, scrolling should take place on the document's root and
	   * not some child element.
	   * </div>
	   *
	   * @example
	     <example module="anchorScrollExample" name="anchor-scroll">
	       <file name="index.html">
	         <div id="scrollArea" ng-controller="ScrollController">
	           <a ng-click="gotoBottom()">Go to bottom</a>
	           <a id="bottom"></a> You're at the bottom!
	         </div>
	       </file>
	       <file name="script.js">
	         angular.module('anchorScrollExample', [])
	           .controller('ScrollController', ['$scope', '$location', '$anchorScroll',
	             function($scope, $location, $anchorScroll) {
	               $scope.gotoBottom = function() {
	                 // set the location.hash to the id of
	                 // the element you wish to scroll to.
	                 $location.hash('bottom');
	
	                 // call $anchorScroll()
	                 $anchorScroll();
	               };
	             }]);
	       </file>
	       <file name="style.css">
	         #scrollArea {
	           height: 280px;
	           overflow: auto;
	         }
	
	         #bottom {
	           display: block;
	           margin-top: 2000px;
	         }
	       </file>
	     </example>
	   *
	   * <hr />
	   * The example below illustrates the use of a vertical scroll-offset (specified as a fixed value).
	   * See {@link ng.$anchorScroll#yOffset $anchorScroll.yOffset} for more details.
	   *
	   * @example
	     <example module="anchorScrollOffsetExample" name="anchor-scroll-offset">
	       <file name="index.html">
	         <div class="fixed-header" ng-controller="headerCtrl">
	           <a href="" ng-click="gotoAnchor(x)" ng-repeat="x in [1,2,3,4,5]">
	             Go to anchor {{x}}
	           </a>
	         </div>
	         <div id="anchor{{x}}" class="anchor" ng-repeat="x in [1,2,3,4,5]">
	           Anchor {{x}} of 5
	         </div>
	       </file>
	       <file name="script.js">
	         angular.module('anchorScrollOffsetExample', [])
	           .run(['$anchorScroll', function($anchorScroll) {
	             $anchorScroll.yOffset = 50;   // always scroll by 50 extra pixels
	           }])
	           .controller('headerCtrl', ['$anchorScroll', '$location', '$scope',
	             function($anchorScroll, $location, $scope) {
	               $scope.gotoAnchor = function(x) {
	                 var newHash = 'anchor' + x;
	                 if ($location.hash() !== newHash) {
	                   // set the $location.hash to `newHash` and
	                   // $anchorScroll will automatically scroll to it
	                   $location.hash('anchor' + x);
	                 } else {
	                   // call $anchorScroll() explicitly,
	                   // since $location.hash hasn't changed
	                   $anchorScroll();
	                 }
	               };
	             }
	           ]);
	       </file>
	       <file name="style.css">
	         body {
	           padding-top: 50px;
	         }
	
	         .anchor {
	           border: 2px dashed DarkOrchid;
	           padding: 10px 10px 200px 10px;
	         }
	
	         .fixed-header {
	           background-color: rgba(0, 0, 0, 0.2);
	           height: 50px;
	           position: fixed;
	           top: 0; left: 0; right: 0;
	         }
	
	         .fixed-header > a {
	           display: inline-block;
	           margin: 5px 15px;
	         }
	       </file>
	     </example>
	   */
	  this.$get = ['$window', '$location', '$rootScope', function($window, $location, $rootScope) {
	    var document = $window.document;
	
	    // Helper function to get first anchor from a NodeList
	    // (using `Array#some()` instead of `angular#forEach()` since it's more performant
	    //  and working in all supported browsers.)
	    function getFirstAnchor(list) {
	      var result = null;
	      Array.prototype.some.call(list, function(element) {
	        if (nodeName_(element) === 'a') {
	          result = element;
	          return true;
	        }
	      });
	      return result;
	    }
	
	    function getYOffset() {
	
	      var offset = scroll.yOffset;
	
	      if (isFunction(offset)) {
	        offset = offset();
	      } else if (isElement(offset)) {
	        var elem = offset[0];
	        var style = $window.getComputedStyle(elem);
	        if (style.position !== 'fixed') {
	          offset = 0;
	        } else {
	          offset = elem.getBoundingClientRect().bottom;
	        }
	      } else if (!isNumber(offset)) {
	        offset = 0;
	      }
	
	      return offset;
	    }
	
	    function scrollTo(elem) {
	      if (elem) {
	        elem.scrollIntoView();
	
	        var offset = getYOffset();
	
	        if (offset) {
	          // `offset` is the number of pixels we should scroll UP in order to align `elem` properly.
	          // This is true ONLY if the call to `elem.scrollIntoView()` initially aligns `elem` at the
	          // top of the viewport.
	          //
	          // IF the number of pixels from the top of `elem` to the end of the page's content is less
	          // than the height of the viewport, then `elem.scrollIntoView()` will align the `elem` some
	          // way down the page.
	          //
	          // This is often the case for elements near the bottom of the page.
	          //
	          // In such cases we do not need to scroll the whole `offset` up, just the difference between
	          // the top of the element and the offset, which is enough to align the top of `elem` at the
	          // desired position.
	          var elemTop = elem.getBoundingClientRect().top;
	          $window.scrollBy(0, elemTop - offset);
	        }
	      } else {
	        $window.scrollTo(0, 0);
	      }
	    }
	
	    function scroll(hash) {
	      // Allow numeric hashes
	      hash = isString(hash) ? hash : isNumber(hash) ? hash.toString() : $location.hash();
	      var elm;
	
	      // empty hash, scroll to the top of the page
	      if (!hash) scrollTo(null);
	
	      // element with given id
	      else if ((elm = document.getElementById(hash))) scrollTo(elm);
	
	      // first anchor with given name :-D
	      else if ((elm = getFirstAnchor(document.getElementsByName(hash)))) scrollTo(elm);
	
	      // no element and hash === 'top', scroll to the top of the page
	      else if (hash === 'top') scrollTo(null);
	    }
	
	    // does not scroll when user clicks on anchor link that is currently on
	    // (no url change, no $location.hash() change), browser native does scroll
	    if (autoScrollingEnabled) {
	      $rootScope.$watch(function autoScrollWatch() {return $location.hash();},
	        function autoScrollWatchAction(newVal, oldVal) {
	          // skip the initial scroll if $location.hash is empty
	          if (newVal === oldVal && newVal === '') return;
	
	          jqLiteDocumentLoaded(function() {
	            $rootScope.$evalAsync(scroll);
	          });
	        });
	    }
	
	    return scroll;
	  }];
	}
	
	var $animateMinErr = minErr('$animate');
	var ELEMENT_NODE = 1;
	var NG_ANIMATE_CLASSNAME = 'ng-animate';
	
	function mergeClasses(a,b) {
	  if (!a && !b) return '';
	  if (!a) return b;
	  if (!b) return a;
	  if (isArray(a)) a = a.join(' ');
	  if (isArray(b)) b = b.join(' ');
	  return a + ' ' + b;
	}
	
	function extractElementNode(element) {
	  for (var i = 0; i < element.length; i++) {
	    var elm = element[i];
	    if (elm.nodeType === ELEMENT_NODE) {
	      return elm;
	    }
	  }
	}
	
	function splitClasses(classes) {
	  if (isString(classes)) {
	    classes = classes.split(' ');
	  }
	
	  // Use createMap() to prevent class assumptions involving property names in
	  // Object.prototype
	  var obj = createMap();
	  forEach(classes, function(klass) {
	    // sometimes the split leaves empty string values
	    // incase extra spaces were applied to the options
	    if (klass.length) {
	      obj[klass] = true;
	    }
	  });
	  return obj;
	}
	
	// if any other type of options value besides an Object value is
	// passed into the $animate.method() animation then this helper code
	// will be run which will ignore it. While this patch is not the
	// greatest solution to this, a lot of existing plugins depend on
	// $animate to either call the callback (< 1.2) or return a promise
	// that can be changed. This helper function ensures that the options
	// are wiped clean incase a callback function is provided.
	function prepareAnimateOptions(options) {
	  return isObject(options)
	      ? options
	      : {};
	}
	
	var $$CoreAnimateJsProvider = /** @this */ function() {
	  this.$get = noop;
	};
	
	// this is prefixed with Core since it conflicts with
	// the animateQueueProvider defined in ngAnimate/animateQueue.js
	var $$CoreAnimateQueueProvider = /** @this */ function() {
	  var postDigestQueue = new NgMap();
	  var postDigestElements = [];
	
	  this.$get = ['$$AnimateRunner', '$rootScope',
	       function($$AnimateRunner,   $rootScope) {
	    return {
	      enabled: noop,
	      on: noop,
	      off: noop,
	      pin: noop,
	
	      push: function(element, event, options, domOperation) {
	        if (domOperation) {
	          domOperation();
	        }
	
	        options = options || {};
	        if (options.from) {
	          element.css(options.from);
	        }
	        if (options.to) {
	          element.css(options.to);
	        }
	
	        if (options.addClass || options.removeClass) {
	          addRemoveClassesPostDigest(element, options.addClass, options.removeClass);
	        }
	
	        var runner = new $$AnimateRunner();
	
	        // since there are no animations to run the runner needs to be
	        // notified that the animation call is complete.
	        runner.complete();
	        return runner;
	      }
	    };
	
	
	    function updateData(data, classes, value) {
	      var changed = false;
	      if (classes) {
	        classes = isString(classes) ? classes.split(' ') :
	                  isArray(classes) ? classes : [];
	        forEach(classes, function(className) {
	          if (className) {
	            changed = true;
	            data[className] = value;
	          }
	        });
	      }
	      return changed;
	    }
	
	    function handleCSSClassChanges() {
	      forEach(postDigestElements, function(element) {
	        var data = postDigestQueue.get(element);
	        if (data) {
	          var existing = splitClasses(element.attr('class'));
	          var toAdd = '';
	          var toRemove = '';
	          forEach(data, function(status, className) {
	            var hasClass = !!existing[className];
	            if (status !== hasClass) {
	              if (status) {
	                toAdd += (toAdd.length ? ' ' : '') + className;
	              } else {
	                toRemove += (toRemove.length ? ' ' : '') + className;
	              }
	            }
	          });
	
	          forEach(element, function(elm) {
	            if (toAdd) {
	              jqLiteAddClass(elm, toAdd);
	            }
	            if (toRemove) {
	              jqLiteRemoveClass(elm, toRemove);
	            }
	          });
	          postDigestQueue.delete(element);
	        }
	      });
	      postDigestElements.length = 0;
	    }
	
	
	    function addRemoveClassesPostDigest(element, add, remove) {
	      var data = postDigestQueue.get(element) || {};
	
	      var classesAdded = updateData(data, add, true);
	      var classesRemoved = updateData(data, remove, false);
	
	      if (classesAdded || classesRemoved) {
	
	        postDigestQueue.set(element, data);
	        postDigestElements.push(element);
	
	        if (postDigestElements.length === 1) {
	          $rootScope.$$postDigest(handleCSSClassChanges);
	        }
	      }
	    }
	  }];
	};
	
	/**
	 * @ngdoc provider
	 * @name $animateProvider
	 *
	 * @description
	 * Default implementation of $animate that doesn't perform any animations, instead just
	 * synchronously performs DOM updates and resolves the returned runner promise.
	 *
	 * In order to enable animations the `ngAnimate` module has to be loaded.
	 *
	 * To see the functional implementation check out `src/ngAnimate/animate.js`.
	 */
	var $AnimateProvider = ['$provide', /** @this */ function($provide) {
	  var provider = this;
	  var classNameFilter = null;
	  var customFilter = null;
	
	  this.$$registeredAnimations = Object.create(null);
	
	   /**
	   * @ngdoc method
	   * @name $animateProvider#register
	   *
	   * @description
	   * Registers a new injectable animation factory function. The factory function produces the
	   * animation object which contains callback functions for each event that is expected to be
	   * animated.
	   *
	   *   * `eventFn`: `function(element, ... , doneFunction, options)`
	   *   The element to animate, the `doneFunction` and the options fed into the animation. Depending
	   *   on the type of animation additional arguments will be injected into the animation function. The
	   *   list below explains the function signatures for the different animation methods:
	   *
	   *   - setClass: function(element, addedClasses, removedClasses, doneFunction, options)
	   *   - addClass: function(element, addedClasses, doneFunction, options)
	   *   - removeClass: function(element, removedClasses, doneFunction, options)
	   *   - enter, leave, move: function(element, doneFunction, options)
	   *   - animate: function(element, fromStyles, toStyles, doneFunction, options)
	   *
	   *   Make sure to trigger the `doneFunction` once the animation is fully complete.
	   *
	   * ```js
	   *   return {
	   *     //enter, leave, move signature
	   *     eventFn : function(element, done, options) {
	   *       //code to run the animation
	   *       //once complete, then run done()
	   *       return function endFunction(wasCancelled) {
	   *         //code to cancel the animation
	   *       }
	   *     }
	   *   }
	   * ```
	   *
	   * @param {string} name The name of the animation (this is what the class-based CSS value will be compared to).
	   * @param {Function} factory The factory function that will be executed to return the animation
	   *                           object.
	   */
	  this.register = function(name, factory) {
	    if (name && name.charAt(0) !== '.') {
	      throw $animateMinErr('notcsel', 'Expecting class selector starting with \'.\' got \'{0}\'.', name);
	    }
	
	    var key = name + '-animation';
	    provider.$$registeredAnimations[name.substr(1)] = key;
	    $provide.factory(key, factory);
	  };
	
	  /**
	   * @ngdoc method
	   * @name $animateProvider#customFilter
	   *
	   * @description
	   * Sets and/or returns the custom filter function that is used to "filter" animations, i.e.
	   * determine if an animation is allowed or not. When no filter is specified (the default), no
	   * animation will be blocked. Setting the `customFilter` value will only allow animations for
	   * which the filter function's return value is truthy.
	   *
	   * This allows to easily create arbitrarily complex rules for filtering animations, such as
	   * allowing specific events only, or enabling animations on specific subtrees of the DOM, etc.
	   * Filtering animations can also boost performance for low-powered devices, as well as
	   * applications containing a lot of structural operations.
	   *
	   * <div class="alert alert-success">
	   *   **Best Practice:**
	   *   Keep the filtering function as lean as possible, because it will be called for each DOM
	   *   action (e.g. insertion, removal, class change) performed by "animation-aware" directives.
	   *   See {@link guide/animations#which-directives-support-animations- here} for a list of built-in
	   *   directives that support animations.
	   *   Performing computationally expensive or time-consuming operations on each call of the
	   *   filtering function can make your animations sluggish.
	   * </div>
	   *
	   * **Note:** If present, `customFilter` will be checked before
	   * {@link $animateProvider#classNameFilter classNameFilter}.
	   *
	   * @param {Function=} filterFn - The filter function which will be used to filter all animations.
	   *   If a falsy value is returned, no animation will be performed. The function will be called
	   *   with the following arguments:
	   *   - **node** `{DOMElement}` - The DOM element to be animated.
	   *   - **event** `{String}` - The name of the animation event (e.g. `enter`, `leave`, `addClass`
	   *     etc).
	   *   - **options** `{Object}` - A collection of options/styles used for the animation.
	   * @return {Function} The current filter function or `null` if there is none set.
	   */
	  this.customFilter = function(filterFn) {
	    if (arguments.length === 1) {
	      customFilter = isFunction(filterFn) ? filterFn : null;
	    }
	
	    return customFilter;
	  };
	
	  /**
	   * @ngdoc method
	   * @name $animateProvider#classNameFilter
	   *
	   * @description
	   * Sets and/or returns the CSS class regular expression that is checked when performing
	   * an animation. Upon bootstrap the classNameFilter value is not set at all and will
	   * therefore enable $animate to attempt to perform an animation on any element that is triggered.
	   * When setting the `classNameFilter` value, animations will only be performed on elements
	   * that successfully match the filter expression. This in turn can boost performance
	   * for low-powered devices as well as applications containing a lot of structural operations.
	   *
	   * **Note:** If present, `classNameFilter` will be checked after
	   * {@link $animateProvider#customFilter customFilter}. If `customFilter` is present and returns
	   * false, `classNameFilter` will not be checked.
	   *
	   * @param {RegExp=} expression The className expression which will be checked against all animations
	   * @return {RegExp} The current CSS className expression value. If null then there is no expression value
	   */
	  this.classNameFilter = function(expression) {
	    if (arguments.length === 1) {
	      classNameFilter = (expression instanceof RegExp) ? expression : null;
	      if (classNameFilter) {
	        var reservedRegex = new RegExp('[(\\s|\\/)]' + NG_ANIMATE_CLASSNAME + '[(\\s|\\/)]');
	        if (reservedRegex.test(classNameFilter.toString())) {
	          classNameFilter = null;
	          throw $animateMinErr('nongcls', '$animateProvider.classNameFilter(regex) prohibits accepting a regex value which matches/contains the "{0}" CSS class.', NG_ANIMATE_CLASSNAME);
	        }
	      }
	    }
	    return classNameFilter;
	  };
	
	  this.$get = ['$$animateQueue', function($$animateQueue) {
	    function domInsert(element, parentElement, afterElement) {
	      // if for some reason the previous element was removed
	      // from the dom sometime before this code runs then let's
	      // just stick to using the parent element as the anchor
	      if (afterElement) {
	        var afterNode = extractElementNode(afterElement);
	        if (afterNode && !afterNode.parentNode && !afterNode.previousElementSibling) {
	          afterElement = null;
	        }
	      }
	      if (afterElement) {
	        afterElement.after(element);
	      } else {
	        parentElement.prepend(element);
	      }
	    }
	
	    /**
	     * @ngdoc service
	     * @name $animate
	     * @description The $animate service exposes a series of DOM utility methods that provide support
	     * for animation hooks. The default behavior is the application of DOM operations, however,
	     * when an animation is detected (and animations are enabled), $animate will do the heavy lifting
	     * to ensure that animation runs with the triggered DOM operation.
	     *
	     * By default $animate doesn't trigger any animations. This is because the `ngAnimate` module isn't
	     * included and only when it is active then the animation hooks that `$animate` triggers will be
	     * functional. Once active then all structural `ng-` directives will trigger animations as they perform
	     * their DOM-related operations (enter, leave and move). Other directives such as `ngClass`,
	     * `ngShow`, `ngHide` and `ngMessages` also provide support for animations.
	     *
	     * It is recommended that the`$animate` service is always used when executing DOM-related procedures within directives.
	     *
	     * To learn more about enabling animation support, click here to visit the
	     * {@link ngAnimate ngAnimate module page}.
	     */
	    return {
	      // we don't call it directly since non-existant arguments may
	      // be interpreted as null within the sub enabled function
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#on
	       * @kind function
	       * @description Sets up an event listener to fire whenever the animation event (enter, leave, move, etc...)
	       *    has fired on the given element or among any of its children. Once the listener is fired, the provided callback
	       *    is fired with the following params:
	       *
	       * ```js
	       * $animate.on('enter', container,
	       *    function callback(element, phase) {
	       *      // cool we detected an enter animation within the container
	       *    }
	       * );
	       * ```
	       *
	       * <div class="alert alert-warning">
	       * **Note**: Generally, the events that are fired correspond 1:1 to `$animate` method names,
	       * e.g. {@link ng.$animate#addClass addClass()} will fire `addClass`, and {@link ng.ngClass}
	       * will fire `addClass` if classes are added, and `removeClass` if classes are removed.
	       * However, there are two exceptions:
	       *
	       * <ul>
	       *   <li>if both an {@link ng.$animate#addClass addClass()} and a
	       *   {@link ng.$animate#removeClass removeClass()} action are performed during the same
	       *   animation, the event fired will be `setClass`. This is true even for `ngClass`.</li>
	       *   <li>an {@link ng.$animate#animate animate()} call that adds and removes classes will fire
	       *   the `setClass` event, but if it either removes or adds classes,
	       *   it will fire `animate` instead.</li>
	       * </ul>
	       *
	       * </div>
	       *
	       * @param {string} event the animation event that will be captured (e.g. enter, leave, move, addClass, removeClass, etc...)
	       * @param {DOMElement} container the container element that will capture each of the animation events that are fired on itself
	       *     as well as among its children
	       * @param {Function} callback the callback function that will be fired when the listener is triggered.
	       *
	       * The arguments present in the callback function are:
	       * * `element` - The captured DOM element that the animation was fired on.
	       * * `phase` - The phase of the animation. The two possible phases are **start** (when the animation starts) and **close** (when it ends).
	       * * `data` - an object with these properties:
	       *     * addClass - `{string|null}` - space-separated CSS classes to add to the element
	       *     * removeClass - `{string|null}` - space-separated CSS classes to remove from the element
	       *     * from - `{Object|null}` - CSS properties & values at the beginning of the animation
	       *     * to - `{Object|null}` - CSS properties & values at the end of the animation
	       *
	       * Note that the callback does not trigger a scope digest. Wrap your call into a
	       * {@link $rootScope.Scope#$apply scope.$apply} to propagate changes to the scope.
	       */
	      on: $$animateQueue.on,
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#off
	       * @kind function
	       * @description Deregisters an event listener based on the event which has been associated with the provided element. This method
	       * can be used in three different ways depending on the arguments:
	       *
	       * ```js
	       * // remove all the animation event listeners listening for `enter`
	       * $animate.off('enter');
	       *
	       * // remove listeners for all animation events from the container element
	       * $animate.off(container);
	       *
	       * // remove all the animation event listeners listening for `enter` on the given element and its children
	       * $animate.off('enter', container);
	       *
	       * // remove the event listener function provided by `callback` that is set
	       * // to listen for `enter` on the given `container` as well as its children
	       * $animate.off('enter', container, callback);
	       * ```
	       *
	       * @param {string|DOMElement} event|container the animation event (e.g. enter, leave, move,
	       * addClass, removeClass, etc...), or the container element. If it is the element, all other
	       * arguments are ignored.
	       * @param {DOMElement=} container the container element the event listener was placed on
	       * @param {Function=} callback the callback function that was registered as the listener
	       */
	      off: $$animateQueue.off,
	
	      /**
	       * @ngdoc method
	       * @name $animate#pin
	       * @kind function
	       * @description Associates the provided element with a host parent element to allow the element to be animated even if it exists
	       *    outside of the DOM structure of the AngularJS application. By doing so, any animation triggered via `$animate` can be issued on the
	       *    element despite being outside the realm of the application or within another application. Say for example if the application
	       *    was bootstrapped on an element that is somewhere inside of the `<body>` tag, but we wanted to allow for an element to be situated
	       *    as a direct child of `document.body`, then this can be achieved by pinning the element via `$animate.pin(element)`. Keep in mind
	       *    that calling `$animate.pin(element, parentElement)` will not actually insert into the DOM anywhere; it will just create the association.
	       *
	       *    Note that this feature is only active when the `ngAnimate` module is used.
	       *
	       * @param {DOMElement} element the external element that will be pinned
	       * @param {DOMElement} parentElement the host parent element that will be associated with the external element
	       */
	      pin: $$animateQueue.pin,
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#enabled
	       * @kind function
	       * @description Used to get and set whether animations are enabled or not on the entire application or on an element and its children. This
	       * function can be called in four ways:
	       *
	       * ```js
	       * // returns true or false
	       * $animate.enabled();
	       *
	       * // changes the enabled state for all animations
	       * $animate.enabled(false);
	       * $animate.enabled(true);
	       *
	       * // returns true or false if animations are enabled for an element
	       * $animate.enabled(element);
	       *
	       * // changes the enabled state for an element and its children
	       * $animate.enabled(element, true);
	       * $animate.enabled(element, false);
	       * ```
	       *
	       * @param {DOMElement=} element the element that will be considered for checking/setting the enabled state
	       * @param {boolean=} enabled whether or not the animations will be enabled for the element
	       *
	       * @return {boolean} whether or not animations are enabled
	       */
	      enabled: $$animateQueue.enabled,
	
	      /**
	       * @ngdoc method
	       * @name $animate#cancel
	       * @kind function
	       * @description Cancels the provided animation and applies the end state of the animation.
	       * Note that this does not cancel the underlying operation, e.g. the setting of classes or
	       * adding the element to the DOM.
	       *
	       * @param {animationRunner} animationRunner An animation runner returned by an $animate function.
	       *
	       * @example
	        <example module="animationExample" deps="angular-animate.js" animations="true" name="animate-cancel">
	          <file name="app.js">
	            angular.module('animationExample', ['ngAnimate']).component('cancelExample', {
	              templateUrl: 'template.html',
	              controller: function($element, $animate) {
	                this.runner = null;
	
	                this.addClass = function() {
	                  this.runner = $animate.addClass($element.find('div'), 'red');
	                  var ctrl = this;
	                  this.runner.finally(function() {
	                    ctrl.runner = null;
	                  });
	                };
	
	                this.removeClass = function() {
	                  this.runner = $animate.removeClass($element.find('div'), 'red');
	                  var ctrl = this;
	                  this.runner.finally(function() {
	                    ctrl.runner = null;
	                  });
	                };
	
	                this.cancel = function() {
	                  $animate.cancel(this.runner);
	                };
	              }
	            });
	          </file>
	          <file name="template.html">
	            <p>
	              <button id="add" ng-click="$ctrl.addClass()">Add</button>
	              <button ng-click="$ctrl.removeClass()">Remove</button>
	              <br>
	              <button id="cancel" ng-click="$ctrl.cancel()" ng-disabled="!$ctrl.runner">Cancel</button>
	              <br>
	              <div id="target">CSS-Animated Text</div>
	            </p>
	          </file>
	          <file name="index.html">
	            <cancel-example></cancel-example>
	          </file>
	          <file name="style.css">
	            .red-add, .red-remove {
	              transition: all 4s cubic-bezier(0.250, 0.460, 0.450, 0.940);
	            }
	
	            .red,
	            .red-add.red-add-active {
	              color: #FF0000;
	              font-size: 40px;
	            }
	
	            .red-remove.red-remove-active {
	              font-size: 10px;
	              color: black;
	            }
	
	          </file>
	        </example>
	       */
	      cancel: function(runner) {
	        if (runner.cancel) {
	          runner.cancel();
	        }
	      },
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#enter
	       * @kind function
	       * @description Inserts the element into the DOM either after the `after` element (if provided) or
	       *   as the first child within the `parent` element and then triggers an animation.
	       *   A promise is returned that will be resolved during the next digest once the animation
	       *   has completed.
	       *
	       * @param {DOMElement} element the element which will be inserted into the DOM
	       * @param {DOMElement} parent the parent element which will append the element as
	       *   a child (so long as the after element is not present)
	       * @param {DOMElement=} after the sibling element after which the element will be appended
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Runner} the animation runner
	       */
	      enter: function(element, parent, after, options) {
	        parent = parent && jqLite(parent);
	        after = after && jqLite(after);
	        parent = parent || after.parent();
	        domInsert(element, parent, after);
	        return $$animateQueue.push(element, 'enter', prepareAnimateOptions(options));
	      },
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#move
	       * @kind function
	       * @description Inserts (moves) the element into its new position in the DOM either after
	       *   the `after` element (if provided) or as the first child within the `parent` element
	       *   and then triggers an animation. A promise is returned that will be resolved
	       *   during the next digest once the animation has completed.
	       *
	       * @param {DOMElement} element the element which will be moved into the new DOM position
	       * @param {DOMElement} parent the parent element which will append the element as
	       *   a child (so long as the after element is not present)
	       * @param {DOMElement=} after the sibling element after which the element will be appended
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Runner} the animation runner
	       */
	      move: function(element, parent, after, options) {
	        parent = parent && jqLite(parent);
	        after = after && jqLite(after);
	        parent = parent || after.parent();
	        domInsert(element, parent, after);
	        return $$animateQueue.push(element, 'move', prepareAnimateOptions(options));
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#leave
	       * @kind function
	       * @description Triggers an animation and then removes the element from the DOM.
	       * When the function is called a promise is returned that will be resolved during the next
	       * digest once the animation has completed.
	       *
	       * @param {DOMElement} element the element which will be removed from the DOM
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Runner} the animation runner
	       */
	      leave: function(element, options) {
	        return $$animateQueue.push(element, 'leave', prepareAnimateOptions(options), function() {
	          element.remove();
	        });
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#addClass
	       * @kind function
	       *
	       * @description Triggers an addClass animation surrounding the addition of the provided CSS class(es). Upon
	       *   execution, the addClass operation will only be handled after the next digest and it will not trigger an
	       *   animation if element already contains the CSS class or if the class is removed at a later step.
	       *   Note that class-based animations are treated differently compared to structural animations
	       *   (like enter, move and leave) since the CSS classes may be added/removed at different points
	       *   depending if CSS or JavaScript animations are used.
	       *
	       * @param {DOMElement} element the element which the CSS classes will be applied to
	       * @param {string} className the CSS class(es) that will be added (multiple classes are separated via spaces)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Runner} animationRunner the animation runner
	       */
	      addClass: function(element, className, options) {
	        options = prepareAnimateOptions(options);
	        options.addClass = mergeClasses(options.addclass, className);
	        return $$animateQueue.push(element, 'addClass', options);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#removeClass
	       * @kind function
	       *
	       * @description Triggers a removeClass animation surrounding the removal of the provided CSS class(es). Upon
	       *   execution, the removeClass operation will only be handled after the next digest and it will not trigger an
	       *   animation if element does not contain the CSS class or if the class is added at a later step.
	       *   Note that class-based animations are treated differently compared to structural animations
	       *   (like enter, move and leave) since the CSS classes may be added/removed at different points
	       *   depending if CSS or JavaScript animations are used.
	       *
	       * @param {DOMElement} element the element which the CSS classes will be applied to
	       * @param {string} className the CSS class(es) that will be removed (multiple classes are separated via spaces)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Runner} the animation runner
	       */
	      removeClass: function(element, className, options) {
	        options = prepareAnimateOptions(options);
	        options.removeClass = mergeClasses(options.removeClass, className);
	        return $$animateQueue.push(element, 'removeClass', options);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#setClass
	       * @kind function
	       *
	       * @description Performs both the addition and removal of a CSS classes on an element and (during the process)
	       *    triggers an animation surrounding the class addition/removal. Much like `$animate.addClass` and
	       *    `$animate.removeClass`, `setClass` will only evaluate the classes being added/removed once a digest has
	       *    passed. Note that class-based animations are treated differently compared to structural animations
	       *    (like enter, move and leave) since the CSS classes may be added/removed at different points
	       *    depending if CSS or JavaScript animations are used.
	       *
	       * @param {DOMElement} element the element which the CSS classes will be applied to
	       * @param {string} add the CSS class(es) that will be added (multiple classes are separated via spaces)
	       * @param {string} remove the CSS class(es) that will be removed (multiple classes are separated via spaces)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Runner} the animation runner
	       */
	      setClass: function(element, add, remove, options) {
	        options = prepareAnimateOptions(options);
	        options.addClass = mergeClasses(options.addClass, add);
	        options.removeClass = mergeClasses(options.removeClass, remove);
	        return $$animateQueue.push(element, 'setClass', options);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#animate
	       * @kind function
	       *
	       * @description Performs an inline animation on the element which applies the provided to and from CSS styles to the element.
	       * If any detected CSS transition, keyframe or JavaScript matches the provided className value, then the animation will take
	       * on the provided styles. For example, if a transition animation is set for the given className, then the provided `from` and
	       * `to` styles will be applied alongside the given transition. If the CSS style provided in `from` does not have a corresponding
	       * style in `to`, the style in `from` is applied immediately, and no animation is run.
	       * If a JavaScript animation is detected then the provided styles will be given in as function parameters into the `animate`
	       * method (or as part of the `options` parameter):
	       *
	       * ```js
	       * ngModule.animation('.my-inline-animation', function() {
	       *   return {
	       *     animate : function(element, from, to, done, options) {
	       *       //animation
	       *       done();
	       *     }
	       *   }
	       * });
	       * ```
	       *
	       * @param {DOMElement} element the element which the CSS styles will be applied to
	       * @param {object} from the from (starting) CSS styles that will be applied to the element and across the animation.
	       * @param {object} to the to (destination) CSS styles that will be applied to the element and across the animation.
	       * @param {string=} className an optional CSS class that will be applied to the element for the duration of the animation. If
	       *    this value is left as empty then a CSS class of `ng-inline-animate` will be applied to the element.
	       *    (Note that if no animation is detected then this value will not be applied to the element.)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Runner} the animation runner
	       */
	      animate: function(element, from, to, className, options) {
	        options = prepareAnimateOptions(options);
	        options.from = options.from ? extend(options.from, from) : from;
	        options.to   = options.to   ? extend(options.to, to)     : to;
	
	        className = className || 'ng-inline-animate';
	        options.tempClasses = mergeClasses(options.tempClasses, className);
	        return $$animateQueue.push(element, 'animate', options);
	      }
	    };
	  }];
	}];
	
	var $$AnimateAsyncRunFactoryProvider = /** @this */ function() {
	  this.$get = ['$$rAF', function($$rAF) {
	    var waitQueue = [];
	
	    function waitForTick(fn) {
	      waitQueue.push(fn);
	      if (waitQueue.length > 1) return;
	      $$rAF(function() {
	        for (var i = 0; i < waitQueue.length; i++) {
	          waitQueue[i]();
	        }
	        waitQueue = [];
	      });
	    }
	
	    return function() {
	      var passed = false;
	      waitForTick(function() {
	        passed = true;
	      });
	      return function(callback) {
	        if (passed) {
	          callback();
	        } else {
	          waitForTick(callback);
	        }
	      };
	    };
	  }];
	};
	
	var $$AnimateRunnerFactoryProvider = /** @this */ function() {
	  this.$get = ['$q', '$sniffer', '$$animateAsyncRun', '$$isDocumentHidden', '$timeout',
	       function($q,   $sniffer,   $$animateAsyncRun,   $$isDocumentHidden,   $timeout) {
	
	    var INITIAL_STATE = 0;
	    var DONE_PENDING_STATE = 1;
	    var DONE_COMPLETE_STATE = 2;
	
	    AnimateRunner.chain = function(chain, callback) {
	      var index = 0;
	
	      next();
	      function next() {
	        if (index === chain.length) {
	          callback(true);
	          return;
	        }
	
	        chain[index](function(response) {
	          if (response === false) {
	            callback(false);
	            return;
	          }
	          index++;
	          next();
	        });
	      }
	    };
	
	    AnimateRunner.all = function(runners, callback) {
	      var count = 0;
	      var status = true;
	      forEach(runners, function(runner) {
	        runner.done(onProgress);
	      });
	
	      function onProgress(response) {
	        status = status && response;
	        if (++count === runners.length) {
	          callback(status);
	        }
	      }
	    };
	
	    function AnimateRunner(host) {
	      this.setHost(host);
	
	      var rafTick = $$animateAsyncRun();
	      var timeoutTick = function(fn) {
	        $timeout(fn, 0, false);
	      };
	
	      this._doneCallbacks = [];
	      this._tick = function(fn) {
	        if ($$isDocumentHidden()) {
	          timeoutTick(fn);
	        } else {
	          rafTick(fn);
	        }
	      };
	      this._state = 0;
	    }
	
	    AnimateRunner.prototype = {
	      setHost: function(host) {
	        this.host = host || {};
	      },
	
	      done: function(fn) {
	        if (this._state === DONE_COMPLETE_STATE) {
	          fn();
	        } else {
	          this._doneCallbacks.push(fn);
	        }
	      },
	
	      progress: noop,
	
	      getPromise: function() {
	        if (!this.promise) {
	          var self = this;
	          this.promise = $q(function(resolve, reject) {
	            self.done(function(status) {
	              if (status === false) {
	                reject();
	              } else {
	                resolve();
	              }
	            });
	          });
	        }
	        return this.promise;
	      },
	
	      then: function(resolveHandler, rejectHandler) {
	        return this.getPromise().then(resolveHandler, rejectHandler);
	      },
	
	      'catch': function(handler) {
	        return this.getPromise()['catch'](handler);
	      },
	
	      'finally': function(handler) {
	        return this.getPromise()['finally'](handler);
	      },
	
	      pause: function() {
	        if (this.host.pause) {
	          this.host.pause();
	        }
	      },
	
	      resume: function() {
	        if (this.host.resume) {
	          this.host.resume();
	        }
	      },
	
	      end: function() {
	        if (this.host.end) {
	          this.host.end();
	        }
	        this._resolve(true);
	      },
	
	      cancel: function() {
	        if (this.host.cancel) {
	          this.host.cancel();
	        }
	        this._resolve(false);
	      },
	
	      complete: function(response) {
	        var self = this;
	        if (self._state === INITIAL_STATE) {
	          self._state = DONE_PENDING_STATE;
	          self._tick(function() {
	            self._resolve(response);
	          });
	        }
	      },
	
	      _resolve: function(response) {
	        if (this._state !== DONE_COMPLETE_STATE) {
	          forEach(this._doneCallbacks, function(fn) {
	            fn(response);
	          });
	          this._doneCallbacks.length = 0;
	          this._state = DONE_COMPLETE_STATE;
	        }
	      }
	    };
	
	    return AnimateRunner;
	  }];
	};
	
	/* exported $CoreAnimateCssProvider */
	
	/**
	 * @ngdoc service
	 * @name $animateCss
	 * @kind object
	 * @this
	 *
	 * @description
	 * This is the core version of `$animateCss`. By default, only when the `ngAnimate` is included,
	 * then the `$animateCss` service will actually perform animations.
	 *
	 * Click here {@link ngAnimate.$animateCss to read the documentation for $animateCss}.
	 */
	var $CoreAnimateCssProvider = function() {
	  this.$get = ['$$rAF', '$q', '$$AnimateRunner', function($$rAF, $q, $$AnimateRunner) {
	
	    return function(element, initialOptions) {
	      // all of the animation functions should create
	      // a copy of the options data, however, if a
	      // parent service has already created a copy then
	      // we should stick to using that
	      var options = initialOptions || {};
	      if (!options.$$prepared) {
	        options = copy(options);
	      }
	
	      // there is no point in applying the styles since
	      // there is no animation that goes on at all in
	      // this version of $animateCss.
	      if (options.cleanupStyles) {
	        options.from = options.to = null;
	      }
	
	      if (options.from) {
	        element.css(options.from);
	        options.from = null;
	      }
	
	      var closed, runner = new $$AnimateRunner();
	      return {
	        start: run,
	        end: run
	      };
	
	      function run() {
	        $$rAF(function() {
	          applyAnimationContents();
	          if (!closed) {
	            runner.complete();
	          }
	          closed = true;
	        });
	        return runner;
	      }
	
	      function applyAnimationContents() {
	        if (options.addClass) {
	          element.addClass(options.addClass);
	          options.addClass = null;
	        }
	        if (options.removeClass) {
	          element.removeClass(options.removeClass);
	          options.removeClass = null;
	        }
	        if (options.to) {
	          element.css(options.to);
	          options.to = null;
	        }
	      }
	    };
	  }];
	};
	
	/* global getHash: true, stripHash: false */
	
	function getHash(url) {
	  var index = url.indexOf('#');
	  return index === -1 ? '' : url.substr(index);
	}
	
	function trimEmptyHash(url) {
	  return url.replace(/#$/, '');
	}
	
	/**
	 * ! This is a private undocumented service !
	 *
	 * @name $browser
	 * @requires $log
	 * @description
	 * This object has two goals:
	 *
	 * - hide all the global state in the browser caused by the window object
	 * - abstract away all the browser specific features and inconsistencies
	 *
	 * For tests we provide {@link ngMock.$browser mock implementation} of the `$browser`
	 * service, which can be used for convenient testing of the application without the interaction with
	 * the real browser apis.
	 */
	/**
	 * @param {object} window The global window object.
	 * @param {object} document jQuery wrapped document.
	 * @param {object} $log window.console or an object with the same interface.
	 * @param {object} $sniffer $sniffer service
	 */
	function Browser(window, document, $log, $sniffer, $$taskTrackerFactory) {
	  var self = this,
	      location = window.location,
	      history = window.history,
	      setTimeout = window.setTimeout,
	      clearTimeout = window.clearTimeout,
	      pendingDeferIds = {},
	      taskTracker = $$taskTrackerFactory($log);
	
	  self.isMock = false;
	
	  //////////////////////////////////////////////////////////////
	  // Task-tracking API
	  //////////////////////////////////////////////////////////////
	
	  // TODO(vojta): remove this temporary api
	  self.$$completeOutstandingRequest = taskTracker.completeTask;
	  self.$$incOutstandingRequestCount = taskTracker.incTaskCount;
	
	  // TODO(vojta): prefix this method with $$ ?
	  self.notifyWhenNoOutstandingRequests = taskTracker.notifyWhenNoPendingTasks;
	
	  //////////////////////////////////////////////////////////////
	  // URL API
	  //////////////////////////////////////////////////////////////
	
	  var cachedState, lastHistoryState,
	      lastBrowserUrl = location.href,
	      baseElement = document.find('base'),
	      pendingLocation = null,
	      getCurrentState = !$sniffer.history ? noop : function getCurrentState() {
	        try {
	          return history.state;
	        } catch (e) {
	          // MSIE can reportedly throw when there is no state (UNCONFIRMED).
	        }
	      };
	
	  cacheState();
	
	  /**
	   * @name $browser#url
	   *
	   * @description
	   * GETTER:
	   * Without any argument, this method just returns current value of `location.href` (with a
	   * trailing `#` stripped of if the hash is empty).
	   *
	   * SETTER:
	   * With at least one argument, this method sets url to new value.
	   * If html5 history api supported, `pushState`/`replaceState` is used, otherwise
	   * `location.href`/`location.replace` is used.
	   * Returns its own instance to allow chaining.
	   *
	   * NOTE: this api is intended for use only by the `$location` service. Please use the
	   * {@link ng.$location $location service} to change url.
	   *
	   * @param {string} url New url (when used as setter)
	   * @param {boolean=} replace Should new url replace current history record?
	   * @param {object=} state State object to use with `pushState`/`replaceState`
	   */
	  self.url = function(url, replace, state) {
	    // In modern browsers `history.state` is `null` by default; treating it separately
	    // from `undefined` would cause `$browser.url('/foo')` to change `history.state`
	    // to undefined via `pushState`. Instead, let's change `undefined` to `null` here.
	    if (isUndefined(state)) {
	      state = null;
	    }
	
	    // Android Browser BFCache causes location, history reference to become stale.
	    if (location !== window.location) location = window.location;
	    if (history !== window.history) history = window.history;
	
	    // setter
	    if (url) {
	      var sameState = lastHistoryState === state;
	
	      // Normalize the inputted URL
	      url = urlResolve(url).href;
	
	      // Don't change anything if previous and current URLs and states match. This also prevents
	      // IE<10 from getting into redirect loop when in LocationHashbangInHtml5Url mode.
	      // See https://github.com/angular/angular.js/commit/ffb2701
	      if (lastBrowserUrl === url && (!$sniffer.history || sameState)) {
	        return self;
	      }
	      var sameBase = lastBrowserUrl && stripHash(lastBrowserUrl) === stripHash(url);
	      lastBrowserUrl = url;
	      lastHistoryState = state;
	      // Don't use history API if only the hash changed
	      // due to a bug in IE10/IE11 which leads
	      // to not firing a `hashchange` nor `popstate` event
	      // in some cases (see #9143).
	      if ($sniffer.history && (!sameBase || !sameState)) {
	        history[replace ? 'replaceState' : 'pushState'](state, '', url);
	        cacheState();
	      } else {
	        if (!sameBase) {
	          pendingLocation = url;
	        }
	        if (replace) {
	          location.replace(url);
	        } else if (!sameBase) {
	          location.href = url;
	        } else {
	          location.hash = getHash(url);
	        }
	        if (location.href !== url) {
	          pendingLocation = url;
	        }
	      }
	      if (pendingLocation) {
	        pendingLocation = url;
	      }
	      return self;
	    // getter
	    } else {
	      // - pendingLocation is needed as browsers don't allow to read out
	      //   the new location.href if a reload happened or if there is a bug like in iOS 9 (see
	      //   https://openradar.appspot.com/22186109).
	      return trimEmptyHash(pendingLocation || location.href);
	    }
	  };
	
	  /**
	   * @name $browser#state
	   *
	   * @description
	   * This method is a getter.
	   *
	   * Return history.state or null if history.state is undefined.
	   *
	   * @returns {object} state
	   */
	  self.state = function() {
	    return cachedState;
	  };
	
	  var urlChangeListeners = [],
	      urlChangeInit = false;
	
	  function cacheStateAndFireUrlChange() {
	    pendingLocation = null;
	    fireStateOrUrlChange();
	  }
	
	  // This variable should be used *only* inside the cacheState function.
	  var lastCachedState = null;
	  function cacheState() {
	    // This should be the only place in $browser where `history.state` is read.
	    cachedState = getCurrentState();
	    cachedState = isUndefined(cachedState) ? null : cachedState;
	
	    // Prevent callbacks fo fire twice if both hashchange & popstate were fired.
	    if (equals(cachedState, lastCachedState)) {
	      cachedState = lastCachedState;
	    }
	
	    lastCachedState = cachedState;
	    lastHistoryState = cachedState;
	  }
	
	  function fireStateOrUrlChange() {
	    var prevLastHistoryState = lastHistoryState;
	    cacheState();
	
	    if (lastBrowserUrl === self.url() && prevLastHistoryState === cachedState) {
	      return;
	    }
	
	    lastBrowserUrl = self.url();
	    lastHistoryState = cachedState;
	    forEach(urlChangeListeners, function(listener) {
	      listener(self.url(), cachedState);
	    });
	  }
	
	  /**
	   * @name $browser#onUrlChange
	   *
	   * @description
	   * Register callback function that will be called, when url changes.
	   *
	   * It's only called when the url is changed from outside of AngularJS:
	   * - user types different url into address bar
	   * - user clicks on history (forward/back) button
	   * - user clicks on a link
	   *
	   * It's not called when url is changed by $browser.url() method
	   *
	   * The listener gets called with new url as parameter.
	   *
	   * NOTE: this api is intended for use only by the $location service. Please use the
	   * {@link ng.$location $location service} to monitor url changes in AngularJS apps.
	   *
	   * @param {function(string)} listener Listener function to be called when url changes.
	   * @return {function(string)} Returns the registered listener fn - handy if the fn is anonymous.
	   */
	  self.onUrlChange = function(callback) {
	    // TODO(vojta): refactor to use node's syntax for events
	    if (!urlChangeInit) {
	      // We listen on both (hashchange/popstate) when available, as some browsers don't
	      // fire popstate when user changes the address bar and don't fire hashchange when url
	      // changed by push/replaceState
	
	      // html5 history api - popstate event
	      if ($sniffer.history) jqLite(window).on('popstate', cacheStateAndFireUrlChange);
	      // hashchange event
	      jqLite(window).on('hashchange', cacheStateAndFireUrlChange);
	
	      urlChangeInit = true;
	    }
	
	    urlChangeListeners.push(callback);
	    return callback;
	  };
	
	  /**
	   * @private
	   * Remove popstate and hashchange handler from window.
	   *
	   * NOTE: this api is intended for use only by $rootScope.
	   */
	  self.$$applicationDestroyed = function() {
	    jqLite(window).off('hashchange popstate', cacheStateAndFireUrlChange);
	  };
	
	  /**
	   * Checks whether the url has changed outside of AngularJS.
	   * Needs to be exported to be able to check for changes that have been done in sync,
	   * as hashchange/popstate events fire in async.
	   */
	  self.$$checkUrlChange = fireStateOrUrlChange;
	
	  //////////////////////////////////////////////////////////////
	  // Misc API
	  //////////////////////////////////////////////////////////////
	
	  /**
	   * @name $browser#baseHref
	   *
	   * @description
	   * Returns current <base href>
	   * (always relative - without domain)
	   *
	   * @returns {string} The current base href
	   */
	  self.baseHref = function() {
	    var href = baseElement.attr('href');
	    return href ? href.replace(/^(https?:)?\/\/[^/]*/, '') : '';
	  };
	
	  /**
	   * @name $browser#defer
	   * @param {function()} fn A function, who's execution should be deferred.
	   * @param {number=} [delay=0] Number of milliseconds to defer the function execution.
	   * @param {string=} [taskType=DEFAULT_TASK_TYPE] The type of task that is deferred.
	   * @returns {*} DeferId that can be used to cancel the task via `$browser.defer.cancel()`.
	   *
	   * @description
	   * Executes a fn asynchronously via `setTimeout(fn, delay)`.
	   *
	   * Unlike when calling `setTimeout` directly, in test this function is mocked and instead of using
	   * `setTimeout` in tests, the fns are queued in an array, which can be programmatically flushed
	   * via `$browser.defer.flush()`.
	   *
	   */
	  self.defer = function(fn, delay, taskType) {
	    var timeoutId;
	
	    delay = delay || 0;
	    taskType = taskType || taskTracker.DEFAULT_TASK_TYPE;
	
	    taskTracker.incTaskCount(taskType);
	    timeoutId = setTimeout(function() {
	      delete pendingDeferIds[timeoutId];
	      taskTracker.completeTask(fn, taskType);
	    }, delay);
	    pendingDeferIds[timeoutId] = taskType;
	
	    return timeoutId;
	  };
	
	
	  /**
	   * @name $browser#defer.cancel
	   *
	   * @description
	   * Cancels a deferred task identified with `deferId`.
	   *
	   * @param {*} deferId Token returned by the `$browser.defer` function.
	   * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
	   *                    canceled.
	   */
	  self.defer.cancel = function(deferId) {
	    if (pendingDeferIds.hasOwnProperty(deferId)) {
	      var taskType = pendingDeferIds[deferId];
	      delete pendingDeferIds[deferId];
	      clearTimeout(deferId);
	      taskTracker.completeTask(noop, taskType);
	      return true;
	    }
	    return false;
	  };
	
	}
	
	/** @this */
	function $BrowserProvider() {
	  this.$get = ['$window', '$log', '$sniffer', '$document', '$$taskTrackerFactory',
	       function($window,   $log,   $sniffer,   $document,   $$taskTrackerFactory) {
	    return new Browser($window, $document, $log, $sniffer, $$taskTrackerFactory);
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $cacheFactory
	 * @this
	 *
	 * @description
	 * Factory that constructs {@link $cacheFactory.Cache Cache} objects and gives access to
	 * them.
	 *
	 * ```js
	 *
	 *  var cache = $cacheFactory('cacheId');
	 *  expect($cacheFactory.get('cacheId')).toBe(cache);
	 *  expect($cacheFactory.get('noSuchCacheId')).not.toBeDefined();
	 *
	 *  cache.put("key", "value");
	 *  cache.put("another key", "another value");
	 *
	 *  // We've specified no options on creation
	 *  expect(cache.info()).toEqual({id: 'cacheId', size: 2});
	 *
	 * ```
	 *
	 *
	 * @param {string} cacheId Name or id of the newly created cache.
	 * @param {object=} options Options object that specifies the cache behavior. Properties:
	 *
	 *   - `{number=}` `capacity` — turns the cache into LRU cache.
	 *
	 * @returns {object} Newly created cache object with the following set of methods:
	 *
	 * - `{object}` `info()` — Returns id, size, and options of cache.
	 * - `{{*}}` `put({string} key, {*} value)` — Puts a new key-value pair into the cache and returns
	 *   it.
	 * - `{{*}}` `get({string} key)` — Returns cached value for `key` or undefined for cache miss.
	 * - `{void}` `remove({string} key)` — Removes a key-value pair from the cache.
	 * - `{void}` `removeAll()` — Removes all cached values.
	 * - `{void}` `destroy()` — Removes references to this cache from $cacheFactory.
	 *
	 * @example
	   <example module="cacheExampleApp" name="cache-factory">
	     <file name="index.html">
	       <div ng-controller="CacheController">
	         <input ng-model="newCacheKey" placeholder="Key">
	         <input ng-model="newCacheValue" placeholder="Value">
	         <button ng-click="put(newCacheKey, newCacheValue)">Cache</button>
	
	         <p ng-if="keys.length">Cached Values</p>
	         <div ng-repeat="key in keys">
	           <span ng-bind="key"></span>
	           <span>: </span>
	           <b ng-bind="cache.get(key)"></b>
	         </div>
	
	         <p>Cache Info</p>
	         <div ng-repeat="(key, value) in cache.info()">
	           <span ng-bind="key"></span>
	           <span>: </span>
	           <b ng-bind="value"></b>
	         </div>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('cacheExampleApp', []).
	         controller('CacheController', ['$scope', '$cacheFactory', function($scope, $cacheFactory) {
	           $scope.keys = [];
	           $scope.cache = $cacheFactory('cacheId');
	           $scope.put = function(key, value) {
	             if (angular.isUndefined($scope.cache.get(key))) {
	               $scope.keys.push(key);
	             }
	             $scope.cache.put(key, angular.isUndefined(value) ? null : value);
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       p {
	         margin: 10px 0 3px;
	       }
	     </file>
	   </example>
	 */
	function $CacheFactoryProvider() {
	
	  this.$get = function() {
	    var caches = {};
	
	    function cacheFactory(cacheId, options) {
	      if (cacheId in caches) {
	        throw minErr('$cacheFactory')('iid', 'CacheId \'{0}\' is already taken!', cacheId);
	      }
	
	      var size = 0,
	          stats = extend({}, options, {id: cacheId}),
	          data = createMap(),
	          capacity = (options && options.capacity) || Number.MAX_VALUE,
	          lruHash = createMap(),
	          freshEnd = null,
	          staleEnd = null;
	
	      /**
	       * @ngdoc type
	       * @name $cacheFactory.Cache
	       *
	       * @description
	       * A cache object used to store and retrieve data, primarily used by
	       * {@link $templateRequest $templateRequest} and the {@link ng.directive:script script}
	       * directive to cache templates and other data.
	       *
	       * ```js
	       *  angular.module('superCache')
	       *    .factory('superCache', ['$cacheFactory', function($cacheFactory) {
	       *      return $cacheFactory('super-cache');
	       *    }]);
	       * ```
	       *
	       * Example test:
	       *
	       * ```js
	       *  it('should behave like a cache', inject(function(superCache) {
	       *    superCache.put('key', 'value');
	       *    superCache.put('another key', 'another value');
	       *
	       *    expect(superCache.info()).toEqual({
	       *      id: 'super-cache',
	       *      size: 2
	       *    });
	       *
	       *    superCache.remove('another key');
	       *    expect(superCache.get('another key')).toBeUndefined();
	       *
	       *    superCache.removeAll();
	       *    expect(superCache.info()).toEqual({
	       *      id: 'super-cache',
	       *      size: 0
	       *    });
	       *  }));
	       * ```
	       */
	      return (caches[cacheId] = {
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#put
	         * @kind function
	         *
	         * @description
	         * Inserts a named entry into the {@link $cacheFactory.Cache Cache} object to be
	         * retrieved later, and incrementing the size of the cache if the key was not already
	         * present in the cache. If behaving like an LRU cache, it will also remove stale
	         * entries from the set.
	         *
	         * It will not insert undefined values into the cache.
	         *
	         * @param {string} key the key under which the cached data is stored.
	         * @param {*} value the value to store alongside the key. If it is undefined, the key
	         *    will not be stored.
	         * @returns {*} the value stored.
	         */
	        put: function(key, value) {
	          if (isUndefined(value)) return;
	          if (capacity < Number.MAX_VALUE) {
	            var lruEntry = lruHash[key] || (lruHash[key] = {key: key});
	
	            refresh(lruEntry);
	          }
	
	          if (!(key in data)) size++;
	          data[key] = value;
	
	          if (size > capacity) {
	            this.remove(staleEnd.key);
	          }
	
	          return value;
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#get
	         * @kind function
	         *
	         * @description
	         * Retrieves named data stored in the {@link $cacheFactory.Cache Cache} object.
	         *
	         * @param {string} key the key of the data to be retrieved
	         * @returns {*} the value stored.
	         */
	        get: function(key) {
	          if (capacity < Number.MAX_VALUE) {
	            var lruEntry = lruHash[key];
	
	            if (!lruEntry) return;
	
	            refresh(lruEntry);
	          }
	
	          return data[key];
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#remove
	         * @kind function
	         *
	         * @description
	         * Removes an entry from the {@link $cacheFactory.Cache Cache} object.
	         *
	         * @param {string} key the key of the entry to be removed
	         */
	        remove: function(key) {
	          if (capacity < Number.MAX_VALUE) {
	            var lruEntry = lruHash[key];
	
	            if (!lruEntry) return;
	
	            if (lruEntry === freshEnd) freshEnd = lruEntry.p;
	            if (lruEntry === staleEnd) staleEnd = lruEntry.n;
	            link(lruEntry.n,lruEntry.p);
	
	            delete lruHash[key];
	          }
	
	          if (!(key in data)) return;
	
	          delete data[key];
	          size--;
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#removeAll
	         * @kind function
	         *
	         * @description
	         * Clears the cache object of any entries.
	         */
	        removeAll: function() {
	          data = createMap();
	          size = 0;
	          lruHash = createMap();
	          freshEnd = staleEnd = null;
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#destroy
	         * @kind function
	         *
	         * @description
	         * Destroys the {@link $cacheFactory.Cache Cache} object entirely,
	         * removing it from the {@link $cacheFactory $cacheFactory} set.
	         */
	        destroy: function() {
	          data = null;
	          stats = null;
	          lruHash = null;
	          delete caches[cacheId];
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#info
	         * @kind function
	         *
	         * @description
	         * Retrieve information regarding a particular {@link $cacheFactory.Cache Cache}.
	         *
	         * @returns {object} an object with the following properties:
	         *   <ul>
	         *     <li>**id**: the id of the cache instance</li>
	         *     <li>**size**: the number of entries kept in the cache instance</li>
	         *     <li>**...**: any additional properties from the options object when creating the
	         *       cache.</li>
	         *   </ul>
	         */
	        info: function() {
	          return extend({}, stats, {size: size});
	        }
	      });
	
	
	      /**
	       * makes the `entry` the freshEnd of the LRU linked list
	       */
	      function refresh(entry) {
	        if (entry !== freshEnd) {
	          if (!staleEnd) {
	            staleEnd = entry;
	          } else if (staleEnd === entry) {
	            staleEnd = entry.n;
	          }
	
	          link(entry.n, entry.p);
	          link(entry, freshEnd);
	          freshEnd = entry;
	          freshEnd.n = null;
	        }
	      }
	
	
	      /**
	       * bidirectionally links two entries of the LRU linked list
	       */
	      function link(nextEntry, prevEntry) {
	        if (nextEntry !== prevEntry) {
	          if (nextEntry) nextEntry.p = prevEntry; //p stands for previous, 'prev' didn't minify
	          if (prevEntry) prevEntry.n = nextEntry; //n stands for next, 'next' didn't minify
	        }
	      }
	    }
	
	
	  /**
	   * @ngdoc method
	   * @name $cacheFactory#info
	   *
	   * @description
	   * Get information about all the caches that have been created
	   *
	   * @returns {Object} - key-value map of `cacheId` to the result of calling `cache#info`
	   */
	    cacheFactory.info = function() {
	      var info = {};
	      forEach(caches, function(cache, cacheId) {
	        info[cacheId] = cache.info();
	      });
	      return info;
	    };
	
	
	  /**
	   * @ngdoc method
	   * @name $cacheFactory#get
	   *
	   * @description
	   * Get access to a cache object by the `cacheId` used when it was created.
	   *
	   * @param {string} cacheId Name or id of a cache to access.
	   * @returns {object} Cache object identified by the cacheId or undefined if no such cache.
	   */
	    cacheFactory.get = function(cacheId) {
	      return caches[cacheId];
	    };
	
	
	    return cacheFactory;
	  };
	}
	
	/**
	 * @ngdoc service
	 * @name $templateCache
	 * @this
	 *
	 * @description
	 * `$templateCache` is a {@link $cacheFactory.Cache Cache object} created by the
	 * {@link ng.$cacheFactory $cacheFactory}.
	 *
	 * The first time a template is used, it is loaded in the template cache for quick retrieval. You
	 * can load templates directly into the cache in a `script` tag, by using {@link $templateRequest},
	 * or by consuming the `$templateCache` service directly.
	 *
	 * Adding via the `script` tag:
	 *
	 * ```html
	 *   <script type="text/ng-template" id="templateId.html">
	 *     <p>This is the content of the template</p>
	 *   </script>
	 * ```
	 *
	 * **Note:** the `script` tag containing the template does not need to be included in the `head` of
	 * the document, but it must be a descendent of the {@link ng.$rootElement $rootElement} (e.g.
	 * element with {@link ngApp} attribute), otherwise the template will be ignored.
	 *
	 * Adding via the `$templateCache` service:
	 *
	 * ```js
	 * var myApp = angular.module('myApp', []);
	 * myApp.run(function($templateCache) {
	 *   $templateCache.put('templateId.html', 'This is the content of the template');
	 * });
	 * ```
	 *
	 * To retrieve the template later, simply use it in your component:
	 * ```js
	 * myApp.component('myComponent', {
	 *    templateUrl: 'templateId.html'
	 * });
	 * ```
	 *
	 * or get it via the `$templateCache` service:
	 * ```js
	 * $templateCache.get('templateId.html')
	 * ```
	 *
	 */
	function $TemplateCacheProvider() {
	  this.$get = ['$cacheFactory', function($cacheFactory) {
	    return $cacheFactory('templates');
	  }];
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables like document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	/* ! VARIABLE/FUNCTION NAMING CONVENTIONS THAT APPLY TO THIS FILE!
	 *
	 * DOM-related variables:
	 *
	 * - "node" - DOM Node
	 * - "element" - DOM Element or Node
	 * - "$node" or "$element" - jqLite-wrapped node or element
	 *
	 *
	 * Compiler related stuff:
	 *
	 * - "linkFn" - linking fn of a single directive
	 * - "nodeLinkFn" - function that aggregates all linking fns for a particular node
	 * - "childLinkFn" -  function that aggregates all linking fns for child nodes of a particular node
	 * - "compositeLinkFn" - function that aggregates all linking fns for a compilation root (nodeList)
	 */
	
	
	/**
	 * @ngdoc service
	 * @name $compile
	 * @kind function
	 *
	 * @description
	 * Compiles an HTML string or DOM into a template and produces a template function, which
	 * can then be used to link {@link ng.$rootScope.Scope `scope`} and the template together.
	 *
	 * The compilation is a process of walking the DOM tree and matching DOM elements to
	 * {@link ng.$compileProvider#directive directives}.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** This document is an in-depth reference of all directive options.
	 * For a gentle introduction to directives with examples of common use cases,
	 * see the {@link guide/directive directive guide}.
	 * </div>
	 *
	 * ## Comprehensive Directive API
	 *
	 * There are many different options for a directive.
	 *
	 * The difference resides in the return value of the factory function.
	 * You can either return a {@link $compile#directive-definition-object Directive Definition Object (see below)}
	 * that defines the directive properties, or just the `postLink` function (all other properties will have
	 * the default values).
	 *
	 * <div class="alert alert-success">
	 * **Best Practice:** It's recommended to use the "directive definition object" form.
	 * </div>
	 *
	 * Here's an example directive declared with a Directive Definition Object:
	 *
	 * ```js
	 *   var myModule = angular.module(...);
	 *
	 *   myModule.directive('directiveName', function factory(injectables) {
	 *     var directiveDefinitionObject = {
	 *       {@link $compile#-priority- priority}: 0,
	 *       {@link $compile#-template- template}: '<div></div>', // or // function(tElement, tAttrs) { ... },
	 *       // or
	 *       // {@link $compile#-templateurl- templateUrl}: 'directive.html', // or // function(tElement, tAttrs) { ... },
	 *       {@link $compile#-transclude- transclude}: false,
	 *       {@link $compile#-restrict- restrict}: 'A',
	 *       {@link $compile#-templatenamespace- templateNamespace}: 'html',
	 *       {@link $compile#-scope- scope}: false,
	 *       {@link $compile#-controller- controller}: function($scope, $element, $attrs, $transclude, otherInjectables) { ... },
	 *       {@link $compile#-controlleras- controllerAs}: 'stringIdentifier',
	 *       {@link $compile#-bindtocontroller- bindToController}: false,
	 *       {@link $compile#-require- require}: 'siblingDirectiveName', // or // ['^parentDirectiveName', '?optionalDirectiveName', '?^optionalParent'],
	 *       {@link $compile#-multielement- multiElement}: false,
	 *       {@link $compile#-compile- compile}: function compile(tElement, tAttrs, transclude) {
	 *         return {
	 *            {@link $compile#pre-linking-function pre}: function preLink(scope, iElement, iAttrs, controller) { ... },
	 *            {@link $compile#post-linking-function post}: function postLink(scope, iElement, iAttrs, controller) { ... }
	 *         }
	 *         // or
	 *         // return function postLink( ... ) { ... }
	 *       },
	 *       // or
	 *       // {@link $compile#-link- link}: {
	 *       //  {@link $compile#pre-linking-function pre}: function preLink(scope, iElement, iAttrs, controller) { ... },
	 *       //  {@link $compile#post-linking-function post}: function postLink(scope, iElement, iAttrs, controller) { ... }
	 *       // }
	 *       // or
	 *       // {@link $compile#-link- link}: function postLink( ... ) { ... }
	 *     };
	 *     return directiveDefinitionObject;
	 *   });
	 * ```
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Any unspecified options will use the default value. You can see the default values below.
	 * </div>
	 *
	 * Therefore the above can be simplified as:
	 *
	 * ```js
	 *   var myModule = angular.module(...);
	 *
	 *   myModule.directive('directiveName', function factory(injectables) {
	 *     var directiveDefinitionObject = {
	 *       link: function postLink(scope, iElement, iAttrs) { ... }
	 *     };
	 *     return directiveDefinitionObject;
	 *     // or
	 *     // return function postLink(scope, iElement, iAttrs) { ... }
	 *   });
	 * ```
	 *
	 * ### Life-cycle hooks
	 * Directive controllers can provide the following methods that are called by AngularJS at points in the life-cycle of the
	 * directive:
	 * * `$onInit()` - Called on each controller after all the controllers on an element have been constructed and
	 *   had their bindings initialized (and before the pre &amp; post linking functions for the directives on
	 *   this element). This is a good place to put initialization code for your controller.
	 * * `$onChanges(changesObj)` - Called whenever one-way (`<`) or interpolation (`@`) bindings are updated. The
	 *   `changesObj` is a hash whose keys are the names of the bound properties that have changed, and the values are an
	 *   object of the form `{ currentValue, previousValue, isFirstChange() }`. Use this hook to trigger updates within a
	 *   component such as cloning the bound value to prevent accidental mutation of the outer value. Note that this will
	 *   also be called when your bindings are initialized.
	 * * `$doCheck()` - Called on each turn of the digest cycle. Provides an opportunity to detect and act on
	 *   changes. Any actions that you wish to take in response to the changes that you detect must be
	 *   invoked from this hook; implementing this has no effect on when `$onChanges` is called. For example, this hook
	 *   could be useful if you wish to perform a deep equality check, or to check a Date object, changes to which would not
	 *   be detected by AngularJS's change detector and thus not trigger `$onChanges`. This hook is invoked with no arguments;
	 *   if detecting changes, you must store the previous value(s) for comparison to the current values.
	 * * `$onDestroy()` - Called on a controller when its containing scope is destroyed. Use this hook for releasing
	 *   external resources, watches and event handlers. Note that components have their `$onDestroy()` hooks called in
	 *   the same order as the `$scope.$broadcast` events are triggered, which is top down. This means that parent
	 *   components will have their `$onDestroy()` hook called before child components.
	 * * `$postLink()` - Called after this controller's element and its children have been linked. Similar to the post-link
	 *   function this hook can be used to set up DOM event handlers and do direct DOM manipulation.
	 *   Note that child elements that contain `templateUrl` directives will not have been compiled and linked since
	 *   they are waiting for their template to load asynchronously and their own compilation and linking has been
	 *   suspended until that occurs.
	 *
	 * #### Comparison with life-cycle hooks in the new Angular
	 * The new Angular also uses life-cycle hooks for its components. While the AngularJS life-cycle hooks are similar there are
	 * some differences that you should be aware of, especially when it comes to moving your code from AngularJS to Angular:
	 *
	 * * AngularJS hooks are prefixed with `$`, such as `$onInit`. Angular hooks are prefixed with `ng`, such as `ngOnInit`.
	 * * AngularJS hooks can be defined on the controller prototype or added to the controller inside its constructor.
	 *   In Angular you can only define hooks on the prototype of the Component class.
	 * * Due to the differences in change-detection, you may get many more calls to `$doCheck` in AngularJS than you would to
	 *   `ngDoCheck` in Angular.
	 * * Changes to the model inside `$doCheck` will trigger new turns of the digest loop, which will cause the changes to be
	 *   propagated throughout the application.
	 *   Angular does not allow the `ngDoCheck` hook to trigger a change outside of the component. It will either throw an
	 *   error or do nothing depending upon the state of `enableProdMode()`.
	 *
	 * #### Life-cycle hook examples
	 *
	 * This example shows how you can check for mutations to a Date object even though the identity of the object
	 * has not changed.
	 *
	 * <example name="doCheckDateExample" module="do-check-module">
	 *   <file name="app.js">
	 *     angular.module('do-check-module', [])
	 *       .component('app', {
	 *         template:
	 *           'Month: <input ng-model="$ctrl.month" ng-change="$ctrl.updateDate()">' +
	 *           'Date: {{ $ctrl.date }}' +
	 *           '<test date="$ctrl.date"></test>',
	 *         controller: function() {
	 *           this.date = new Date();
	 *           this.month = this.date.getMonth();
	 *           this.updateDate = function() {
	 *             this.date.setMonth(this.month);
	 *           };
	 *         }
	 *       })
	 *       .component('test', {
	 *         bindings: { date: '<' },
	 *         template:
	 *           '<pre>{{ $ctrl.log | json }}</pre>',
	 *         controller: function() {
	 *           var previousValue;
	 *           this.log = [];
	 *           this.$doCheck = function() {
	 *             var currentValue = this.date && this.date.valueOf();
	 *             if (previousValue !== currentValue) {
	 *               this.log.push('doCheck: date mutated: ' + this.date);
	 *               previousValue = currentValue;
	 *             }
	 *           };
	 *         }
	 *       });
	 *   </file>
	 *   <file name="index.html">
	 *     <app></app>
	 *   </file>
	 * </example>
	 *
	 * This example show how you might use `$doCheck` to trigger changes in your component's inputs even if the
	 * actual identity of the component doesn't change. (Be aware that cloning and deep equality checks on large
	 * arrays or objects can have a negative impact on your application performance.)
	 *
	 * <example name="doCheckArrayExample" module="do-check-module">
	 *   <file name="index.html">
	 *     <div ng-init="items = []">
	 *       <button ng-click="items.push(items.length)">Add Item</button>
	 *       <button ng-click="items = []">Reset Items</button>
	 *       <pre>{{ items }}</pre>
	 *       <test items="items"></test>
	 *     </div>
	 *   </file>
	 *   <file name="app.js">
	 *      angular.module('do-check-module', [])
	 *        .component('test', {
	 *          bindings: { items: '<' },
	 *          template:
	 *            '<pre>{{ $ctrl.log | json }}</pre>',
	 *          controller: function() {
	 *            this.log = [];
	 *
	 *            this.$doCheck = function() {
	 *              if (this.items_ref !== this.items) {
	 *                this.log.push('doCheck: items changed');
	 *                this.items_ref = this.items;
	 *              }
	 *              if (!angular.equals(this.items_clone, this.items)) {
	 *                this.log.push('doCheck: items mutated');
	 *                this.items_clone = angular.copy(this.items);
	 *              }
	 *            };
	 *          }
	 *        });
	 *   </file>
	 * </example>
	 *
	 *
	 * ### Directive Definition Object
	 *
	 * The directive definition object provides instructions to the {@link ng.$compile
	 * compiler}. The attributes are:
	 *
	 * #### `multiElement`
	 * When this property is set to true (default is `false`), the HTML compiler will collect DOM nodes between
	 * nodes with the attributes `directive-name-start` and `directive-name-end`, and group them
	 * together as the directive elements. It is recommended that this feature be used on directives
	 * which are not strictly behavioral (such as {@link ngClick}), and which
	 * do not manipulate or replace child nodes (such as {@link ngInclude}).
	 *
	 * #### `priority`
	 * When there are multiple directives defined on a single DOM element, sometimes it
	 * is necessary to specify the order in which the directives are applied. The `priority` is used
	 * to sort the directives before their `compile` functions get called. Priority is defined as a
	 * number. Directives with greater numerical `priority` are compiled first. Pre-link functions
	 * are also run in priority order, but post-link functions are run in reverse order. The order
	 * of directives with the same priority is undefined. The default priority is `0`.
	 *
	 * #### `terminal`
	 * If set to true then the current `priority` will be the last set of directives
	 * which will execute (any directives at the current priority will still execute
	 * as the order of execution on same `priority` is undefined). Note that expressions
	 * and other directives used in the directive's template will also be excluded from execution.
	 *
	 * #### `scope`
	 * The scope property can be `false`, `true`, or an object:
	 *
	 * * **`false` (default):** No scope will be created for the directive. The directive will use its
	 * parent's scope.
	 *
	 * * **`true`:** A new child scope that prototypically inherits from its parent will be created for
	 * the directive's element. If multiple directives on the same element request a new scope,
	 * only one new scope is created.
	 *
	 * * **`{...}` (an object hash):** A new "isolate" scope is created for the directive's template.
	 * The 'isolate' scope differs from normal scope in that it does not prototypically
	 * inherit from its parent scope. This is useful when creating reusable components, which should not
	 * accidentally read or modify data in the parent scope. Note that an isolate scope
	 * directive without a `template` or `templateUrl` will not apply the isolate scope
	 * to its children elements.
	 *
	 * The 'isolate' scope object hash defines a set of local scope properties derived from attributes on the
	 * directive's element. These local properties are useful for aliasing values for templates. The keys in
	 * the object hash map to the name of the property on the isolate scope; the values define how the property
	 * is bound to the parent scope, via matching attributes on the directive's element:
	 *
	 * * `@` or `@attr` - bind a local scope property to the value of DOM attribute. The result is
	 *   always a string since DOM attributes are strings. If no `attr` name is specified then the
	 *   attribute name is assumed to be the same as the local name. Given `<my-component
	 *   my-attr="hello {{name}}">` and the isolate scope definition `scope: { localName:'@myAttr' }`,
	 *   the directive's scope property `localName` will reflect the interpolated value of `hello
	 *   {{name}}`. As the `name` attribute changes so will the `localName` property on the directive's
	 *   scope. The `name` is read from the parent scope (not the directive's scope).
	 *
	 * * `=` or `=attr` - set up a bidirectional binding between a local scope property and an expression
	 *   passed via the attribute `attr`. The expression is evaluated in the context of the parent scope.
	 *   If no `attr` name is specified then the attribute name is assumed to be the same as the local
	 *   name. Given `<my-component my-attr="parentModel">` and the isolate scope definition `scope: {
	 *   localModel: '=myAttr' }`, the property `localModel` on the directive's scope will reflect the
	 *   value of `parentModel` on the parent scope. Changes to `parentModel` will be reflected in
	 *   `localModel` and vice versa. If the binding expression is non-assignable, or if the attribute
	 *   isn't  optional and doesn't exist, an exception
	 *   ({@link error/$compile/nonassign `$compile:nonassign`}) will be thrown upon discovering changes
	 *   to the local value, since it will be impossible to sync them back to the parent scope.
	 *
	 *   By default, the {@link ng.$rootScope.Scope#$watch `$watch`}
	 *   method is used for tracking changes, and the equality check is based on object identity.
	 *   However, if an object literal or an array literal is passed as the binding expression, the
	 *   equality check is done by value (using the {@link angular.equals} function). It's also possible
	 *   to watch the evaluated value shallowly with {@link ng.$rootScope.Scope#$watchCollection
	 *   `$watchCollection`}: use `=*` or `=*attr`
	 *
	  * * `<` or `<attr` - set up a one-way (one-directional) binding between a local scope property and an
	 *   expression passed via the attribute `attr`. The expression is evaluated in the context of the
	 *   parent scope. If no `attr` name is specified then the attribute name is assumed to be the same as the
	 *   local name.
	 *
	 *   For example, given `<my-component my-attr="parentModel">` and directive definition of
	 *   `scope: { localModel:'<myAttr' }`, then the isolated scope property `localModel` will reflect the
	 *   value of `parentModel` on the parent scope. Any changes to `parentModel` will be reflected
	 *   in `localModel`, but changes in `localModel` will not reflect in `parentModel`. There are however
	 *   two caveats:
	 *     1. one-way binding does not copy the value from the parent to the isolate scope, it simply
	 *     sets the same value. That means if your bound value is an object, changes to its properties
	 *     in the isolated scope will be reflected in the parent scope (because both reference the same object).
	 *     2. one-way binding watches changes to the **identity** of the parent value. That means the
	 *     {@link ng.$rootScope.Scope#$watch `$watch`} on the parent value only fires if the reference
	 *     to the value has changed. In most cases, this should not be of concern, but can be important
	 *     to know if you one-way bind to an object, and then replace that object in the isolated scope.
	 *     If you now change a property of the object in your parent scope, the change will not be
	 *     propagated to the isolated scope, because the identity of the object on the parent scope
	 *     has not changed. Instead you must assign a new object.
	 *
	 *   One-way binding is useful if you do not plan to propagate changes to your isolated scope bindings
	 *   back to the parent. However, it does not make this completely impossible.
	 *
	 *   By default, the {@link ng.$rootScope.Scope#$watch `$watch`}
	 *   method is used for tracking changes, and the equality check is based on object identity.
	 *   It's also possible to watch the evaluated value shallowly with
	 *   {@link ng.$rootScope.Scope#$watchCollection `$watchCollection`}: use `<*` or `<*attr`
	 *
	 * * `&` or `&attr` - provides a way to execute an expression in the context of the parent scope. If
	 *   no `attr` name is specified then the attribute name is assumed to be the same as the local name.
	 *   Given `<my-component my-attr="count = count + value">` and the isolate scope definition `scope: {
	 *   localFn:'&myAttr' }`, the isolate scope property `localFn` will point to a function wrapper for
	 *   the `count = count + value` expression. Often it's desirable to pass data from the isolated scope
	 *   via an expression to the parent scope. This can be done by passing a map of local variable names
	 *   and values into the expression wrapper fn. For example, if the expression is `increment(amount)`
	 *   then we can specify the amount value by calling the `localFn` as `localFn({amount: 22})`.
	 *
	 * All 4 kinds of bindings (`@`, `=`, `<`, and `&`) can be made optional by adding `?` to the expression.
	 * The marker must come after the mode and before the attribute name.
	 * See the {@link error/$compile/iscp Invalid Isolate Scope Definition error} for definition examples.
	 * This is useful to refine the interface directives provide.
	 * One subtle difference between optional and non-optional happens **when the binding attribute is not
	 * set**:
	 * - the binding is optional: the property will not be defined
	 * - the binding is not optional: the property is defined
	 *
	 * ```js
	 *app.directive('testDir', function() {
	    return {
	      scope: {
	        notoptional: '=',
	        optional: '=?',
	      },
	      bindToController: true,
	      controller: function() {
	        this.$onInit = function() {
	          console.log(this.hasOwnProperty('notoptional')) // true
	          console.log(this.hasOwnProperty('optional')) // false
	        }
	      }
	    }
	  })
	 *```
	 *
	 *
	 * ##### Combining directives with different scope defintions
	 *
	 * In general it's possible to apply more than one directive to one element, but there might be limitations
	 * depending on the type of scope required by the directives. The following points will help explain these limitations.
	 * For simplicity only two directives are taken into account, but it is also applicable for several directives:
	 *
	 * * **no scope** + **no scope** => Two directives which don't require their own scope will use their parent's scope
	 * * **child scope** + **no scope** =>  Both directives will share one single child scope
	 * * **child scope** + **child scope** =>  Both directives will share one single child scope
	 * * **isolated scope** + **no scope** =>  The isolated directive will use it's own created isolated scope. The other directive will use
	 * its parent's scope
	 * * **isolated scope** + **child scope** =>  **Won't work!** Only one scope can be related to one element. Therefore these directives cannot
	 * be applied to the same element.
	 * * **isolated scope** + **isolated scope**  =>  **Won't work!** Only one scope can be related to one element. Therefore these directives
	 * cannot be applied to the same element.
	 *
	 *
	 * #### `bindToController`
	 * This property is used to bind scope properties directly to the controller. It can be either
	 * `true` or an object hash with the same format as the `scope` property.
	 *
	 * When an isolate scope is used for a directive (see above), `bindToController: true` will
	 * allow a component to have its properties bound to the controller, rather than to scope.
	 *
	 * After the controller is instantiated, the initial values of the isolate scope bindings will be bound to the controller
	 * properties. You can access these bindings once they have been initialized by providing a controller method called
	 * `$onInit`, which is called after all the controllers on an element have been constructed and had their bindings
	 * initialized.
	 *
	 * It is also possible to set `bindToController` to an object hash with the same format as the `scope` property.
	 * This will set up the scope bindings to the controller directly. Note that `scope` can still be used
	 * to define which kind of scope is created. By default, no scope is created. Use `scope: {}` to create an isolate
	 * scope (useful for component directives).
	 *
	 * If both `bindToController` and `scope` are defined and have object hashes, `bindToController` overrides `scope`.
	 *
	 *
	 * #### `controller`
	 * Controller constructor function. The controller is instantiated before the
	 * pre-linking phase and can be accessed by other directives (see
	 * `require` attribute). This allows the directives to communicate with each other and augment
	 * each other's behavior. The controller is injectable (and supports bracket notation) with the following locals:
	 *
	 * * `$scope` - Current scope associated with the element
	 * * `$element` - Current element
	 * * `$attrs` - Current attributes object for the element
	 * * `$transclude` - A transclude linking function pre-bound to the correct transclusion scope:
	 *   `function([scope], cloneLinkingFn, futureParentElement, slotName)`:
	 *    * `scope`: (optional) override the scope.
	 *    * `cloneLinkingFn`: (optional) argument to create clones of the original transcluded content.
	 *    * `futureParentElement` (optional):
	 *        * defines the parent to which the `cloneLinkingFn` will add the cloned elements.
	 *        * default: `$element.parent()` resp. `$element` for `transclude:'element'` resp. `transclude:true`.
	 *        * only needed for transcludes that are allowed to contain non html elements (e.g. SVG elements)
	 *          and when the `cloneLinkingFn` is passed,
	 *          as those elements need to created and cloned in a special way when they are defined outside their
	 *          usual containers (e.g. like `<svg>`).
	 *        * See also the `directive.templateNamespace` property.
	 *    * `slotName`: (optional) the name of the slot to transclude. If falsy (e.g. `null`, `undefined` or `''`)
	 *      then the default transclusion is provided.
	 *    The `$transclude` function also has a method on it, `$transclude.isSlotFilled(slotName)`, which returns
	 *    `true` if the specified slot contains content (i.e. one or more DOM nodes).
	 *
	 * #### `require`
	 * Require another directive and inject its controller as the fourth argument to the linking function. The
	 * `require` property can be a string, an array or an object:
	 * * a **string** containing the name of the directive to pass to the linking function
	 * * an **array** containing the names of directives to pass to the linking function. The argument passed to the
	 * linking function will be an array of controllers in the same order as the names in the `require` property
	 * * an **object** whose property values are the names of the directives to pass to the linking function. The argument
	 * passed to the linking function will also be an object with matching keys, whose values will hold the corresponding
	 * controllers.
	 *
	 * If the `require` property is an object and `bindToController` is truthy, then the required controllers are
	 * bound to the controller using the keys of the `require` property. This binding occurs after all the controllers
	 * have been constructed but before `$onInit` is called.
	 * If the name of the required controller is the same as the local name (the key), the name can be
	 * omitted. For example, `{parentDir: '^^'}` is equivalent to `{parentDir: '^^parentDir'}`.
	 * See the {@link $compileProvider#component} helper for an example of how this can be used.
	 * If no such required directive(s) can be found, or if the directive does not have a controller, then an error is
	 * raised (unless no link function is specified and the required controllers are not being bound to the directive
	 * controller, in which case error checking is skipped). The name can be prefixed with:
	 *
	 * * (no prefix) - Locate the required controller on the current element. Throw an error if not found.
	 * * `?` - Attempt to locate the required controller or pass `null` to the `link` fn if not found.
	 * * `^` - Locate the required controller by searching the element and its parents. Throw an error if not found.
	 * * `^^` - Locate the required controller by searching the element's parents. Throw an error if not found.
	 * * `?^` - Attempt to locate the required controller by searching the element and its parents or pass
	 *   `null` to the `link` fn if not found.
	 * * `?^^` - Attempt to locate the required controller by searching the element's parents, or pass
	 *   `null` to the `link` fn if not found.
	 *
	 *
	 * #### `controllerAs`
	 * Identifier name for a reference to the controller in the directive's scope.
	 * This allows the controller to be referenced from the directive template. This is especially
	 * useful when a directive is used as component, i.e. with an `isolate` scope. It's also possible
	 * to use it in a directive without an `isolate` / `new` scope, but you need to be aware that the
	 * `controllerAs` reference might overwrite a property that already exists on the parent scope.
	 *
	 *
	 * #### `restrict`
	 * String of subset of `EACM` which restricts the directive to a specific directive
	 * declaration style. If omitted, the defaults (elements and attributes) are used.
	 *
	 * * `E` - Element name (default): `<my-directive></my-directive>`
	 * * `A` - Attribute (default): `<div my-directive="exp"></div>`
	 * * `C` - Class: `<div class="my-directive: exp;"></div>`
	 * * `M` - Comment: `<!-- directive: my-directive exp -->`
	 *
	 *
	 * #### `templateNamespace`
	 * String representing the document type used by the markup in the template.
	 * AngularJS needs this information as those elements need to be created and cloned
	 * in a special way when they are defined outside their usual containers like `<svg>` and `<math>`.
	 *
	 * * `html` - All root nodes in the template are HTML. Root nodes may also be
	 *   top-level elements such as `<svg>` or `<math>`.
	 * * `svg` - The root nodes in the template are SVG elements (excluding `<math>`).
	 * * `math` - The root nodes in the template are MathML elements (excluding `<svg>`).
	 *
	 * If no `templateNamespace` is specified, then the namespace is considered to be `html`.
	 *
	 * #### `template`
	 * HTML markup that may:
	 * * Replace the contents of the directive's element (default).
	 * * Replace the directive's element itself (if `replace` is true - DEPRECATED).
	 * * Wrap the contents of the directive's element (if `transclude` is true).
	 *
	 * Value may be:
	 *
	 * * A string. For example `<div red-on-hover>{{delete_str}}</div>`.
	 * * A function which takes two arguments `tElement` and `tAttrs` (described in the `compile`
	 *   function api below) and returns a string value.
	 *
	 *
	 * #### `templateUrl`
	 * This is similar to `template` but the template is loaded from the specified URL, asynchronously.
	 *
	 * Because template loading is asynchronous the compiler will suspend compilation of directives on that element
	 * for later when the template has been resolved.  In the meantime it will continue to compile and link
	 * sibling and parent elements as though this element had not contained any directives.
	 *
	 * The compiler does not suspend the entire compilation to wait for templates to be loaded because this
	 * would result in the whole app "stalling" until all templates are loaded asynchronously - even in the
	 * case when only one deeply nested directive has `templateUrl`.
	 *
	 * Template loading is asynchronous even if the template has been preloaded into the {@link $templateCache}.
	 *
	 * You can specify `templateUrl` as a string representing the URL or as a function which takes two
	 * arguments `tElement` and `tAttrs` (described in the `compile` function api below) and returns
	 * a string value representing the url.  In either case, the template URL is passed through {@link
	 * $sce#getTrustedResourceUrl $sce.getTrustedResourceUrl}.
	 *
	 *
	 * #### `replace`
	 * <div class="alert alert-danger">
	 * **Note:** `replace` is deprecated in AngularJS and has been removed in the new Angular (v2+).
	 * </div>
	 *
	 * Specifies what the template should replace. Defaults to `false`.
	 *
	 * * `true` - the template will replace the directive's element.
	 * * `false` - the template will replace the contents of the directive's element.
	 *
	 * The replacement process migrates all of the attributes / classes from the old element to the new
	 * one. See the {@link guide/directive#template-expanding-directive
	 * Directives Guide} for an example.
	 *
	 * There are very few scenarios where element replacement is required for the application function,
	 * the main one being reusable custom components that are used within SVG contexts
	 * (because SVG doesn't work with custom elements in the DOM tree).
	 *
	 * #### `transclude`
	 * Extract the contents of the element where the directive appears and make it available to the directive.
	 * The contents are compiled and provided to the directive as a **transclusion function**. See the
	 * {@link $compile#transclusion Transclusion} section below.
	 *
	 *
	 * #### `compile`
	 *
	 * ```js
	 *   function compile(tElement, tAttrs, transclude) { ... }
	 * ```
	 *
	 * The compile function deals with transforming the template DOM. Since most directives do not do
	 * template transformation, it is not used often. The compile function takes the following arguments:
	 *
	 *   * `tElement` - template element - The element where the directive has been declared. It is
	 *     safe to do template transformation on the element and child elements only.
	 *
	 *   * `tAttrs` - template attributes - Normalized list of attributes declared on this element shared
	 *     between all directive compile functions.
	 *
	 *   * `transclude` -  [*DEPRECATED*!] A transclude linking function: `function(scope, cloneLinkingFn)`
	 *
	 * <div class="alert alert-warning">
	 * **Note:** The template instance and the link instance may be different objects if the template has
	 * been cloned. For this reason it is **not** safe to do anything other than DOM transformations that
	 * apply to all cloned DOM nodes within the compile function. Specifically, DOM listener registration
	 * should be done in a linking function rather than in a compile function.
	 * </div>
	
	 * <div class="alert alert-warning">
	 * **Note:** The compile function cannot handle directives that recursively use themselves in their
	 * own templates or compile functions. Compiling these directives results in an infinite loop and
	 * stack overflow errors.
	 *
	 * This can be avoided by manually using `$compile` in the postLink function to imperatively compile
	 * a directive's template instead of relying on automatic template compilation via `template` or
	 * `templateUrl` declaration or manual compilation inside the compile function.
	 * </div>
	 *
	 * <div class="alert alert-danger">
	 * **Note:** The `transclude` function that is passed to the compile function is deprecated, as it
	 *   e.g. does not know about the right outer scope. Please use the transclude function that is passed
	 *   to the link function instead.
	 * </div>
	
	 * A compile function can have a return value which can be either a function or an object.
	 *
	 * * returning a (post-link) function - is equivalent to registering the linking function via the
	 *   `link` property of the config object when the compile function is empty.
	 *
	 * * returning an object with function(s) registered via `pre` and `post` properties - allows you to
	 *   control when a linking function should be called during the linking phase. See info about
	 *   pre-linking and post-linking functions below.
	 *
	 *
	 * #### `link`
	 * This property is used only if the `compile` property is not defined.
	 *
	 * ```js
	 *   function link(scope, iElement, iAttrs, controller, transcludeFn) { ... }
	 * ```
	 *
	 * The link function is responsible for registering DOM listeners as well as updating the DOM. It is
	 * executed after the template has been cloned. This is where most of the directive logic will be
	 * put.
	 *
	 *   * `scope` - {@link ng.$rootScope.Scope Scope} - The scope to be used by the
	 *     directive for registering {@link ng.$rootScope.Scope#$watch watches}.
	 *
	 *   * `iElement` - instance element - The element where the directive is to be used. It is safe to
	 *     manipulate the children of the element only in `postLink` function since the children have
	 *     already been linked.
	 *
	 *   * `iAttrs` - instance attributes - Normalized list of attributes declared on this element shared
	 *     between all directive linking functions.
	 *
	 *   * `controller` - the directive's required controller instance(s) - Instances are shared
	 *     among all directives, which allows the directives to use the controllers as a communication
	 *     channel. The exact value depends on the directive's `require` property:
	 *       * no controller(s) required: the directive's own controller, or `undefined` if it doesn't have one
	 *       * `string`: the controller instance
	 *       * `array`: array of controller instances
	 *
	 *     If a required controller cannot be found, and it is optional, the instance is `null`,
	 *     otherwise the {@link error:$compile:ctreq Missing Required Controller} error is thrown.
	 *
	 *     Note that you can also require the directive's own controller - it will be made available like
	 *     any other controller.
	 *
	 *   * `transcludeFn` - A transclude linking function pre-bound to the correct transclusion scope.
	 *     This is the same as the `$transclude` parameter of directive controllers,
	 *     see {@link ng.$compile#-controller- the controller section for details}.
	 *     `function([scope], cloneLinkingFn, futureParentElement)`.
	 *
	 * #### Pre-linking function
	 *
	 * Executed before the child elements are linked. Not safe to do DOM transformation since the
	 * compiler linking function will fail to locate the correct elements for linking.
	 *
	 * #### Post-linking function
	 *
	 * Executed after the child elements are linked.
	 *
	 * Note that child elements that contain `templateUrl` directives will not have been compiled
	 * and linked since they are waiting for their template to load asynchronously and their own
	 * compilation and linking has been suspended until that occurs.
	 *
	 * It is safe to do DOM transformation in the post-linking function on elements that are not waiting
	 * for their async templates to be resolved.
	 *
	 *
	 * ### Transclusion
	 *
	 * Transclusion is the process of extracting a collection of DOM elements from one part of the DOM and
	 * copying them to another part of the DOM, while maintaining their connection to the original AngularJS
	 * scope from where they were taken.
	 *
	 * Transclusion is used (often with {@link ngTransclude}) to insert the
	 * original contents of a directive's element into a specified place in the template of the directive.
	 * The benefit of transclusion, over simply moving the DOM elements manually, is that the transcluded
	 * content has access to the properties on the scope from which it was taken, even if the directive
	 * has isolated scope.
	 * See the {@link guide/directive#creating-a-directive-that-wraps-other-elements Directives Guide}.
	 *
	 * This makes it possible for the widget to have private state for its template, while the transcluded
	 * content has access to its originating scope.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** When testing an element transclude directive you must not place the directive at the root of the
	 * DOM fragment that is being compiled. See {@link guide/unit-testing#testing-transclusion-directives
	 * Testing Transclusion Directives}.
	 * </div>
	 *
	 * There are three kinds of transclusion depending upon whether you want to transclude just the contents of the
	 * directive's element, the entire element or multiple parts of the element contents:
	 *
	 * * `true` - transclude the content (i.e. the child nodes) of the directive's element.
	 * * `'element'` - transclude the whole of the directive's element including any directives on this
	 *   element that are defined at a lower priority than this directive. When used, the `template`
	 *   property is ignored.
	 * * **`{...}` (an object hash):** - map elements of the content onto transclusion "slots" in the template.
	 *
	 * **Multi-slot transclusion** is declared by providing an object for the `transclude` property.
	 *
	 * This object is a map where the keys are the name of the slot to fill and the value is an element selector
	 * used to match the HTML to the slot. The element selector should be in normalized form (e.g. `myElement`)
	 * and will match the standard element variants (e.g. `my-element`, `my:element`, `data-my-element`, etc).
	 *
	 * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}.
	 *
	 * If the element selector is prefixed with a `?` then that slot is optional.
	 *
	 * For example, the transclude object `{ slotA: '?myCustomElement' }` maps `<my-custom-element>` elements to
	 * the `slotA` slot, which can be accessed via the `$transclude` function or via the {@link ngTransclude} directive.
	 *
	 * Slots that are not marked as optional (`?`) will trigger a compile time error if there are no matching elements
	 * in the transclude content. If you wish to know if an optional slot was filled with content, then you can call
	 * `$transclude.isSlotFilled(slotName)` on the transclude function passed to the directive's link function and
	 * injectable into the directive's controller.
	 *
	 *
	 * #### Transclusion Functions
	 *
	 * When a directive requests transclusion, the compiler extracts its contents and provides a **transclusion
	 * function** to the directive's `link` function and `controller`. This transclusion function is a special
	 * **linking function** that will return the compiled contents linked to a new transclusion scope.
	 *
	 * <div class="alert alert-info">
	 * If you are just using {@link ngTransclude} then you don't need to worry about this function, since
	 * ngTransclude will deal with it for us.
	 * </div>
	 *
	 * If you want to manually control the insertion and removal of the transcluded content in your directive
	 * then you must use this transclude function. When you call a transclude function it returns a jqLite/JQuery
	 * object that contains the compiled DOM, which is linked to the correct transclusion scope.
	 *
	 * When you call a transclusion function you can pass in a **clone attach function**. This function accepts
	 * two parameters, `function(clone, scope) { ... }`, where the `clone` is a fresh compiled copy of your transcluded
	 * content and the `scope` is the newly created transclusion scope, which the clone will be linked to.
	 *
	 * <div class="alert alert-info">
	 * **Best Practice**: Always provide a `cloneFn` (clone attach function) when you call a transclude function
	 * since you then get a fresh clone of the original DOM and also have access to the new transclusion scope.
	 * </div>
	 *
	 * It is normal practice to attach your transcluded content (`clone`) to the DOM inside your **clone
	 * attach function**:
	 *
	 * ```js
	 * var transcludedContent, transclusionScope;
	 *
	 * $transclude(function(clone, scope) {
	 *   element.append(clone);
	 *   transcludedContent = clone;
	 *   transclusionScope = scope;
	 * });
	 * ```
	 *
	 * Later, if you want to remove the transcluded content from your DOM then you should also destroy the
	 * associated transclusion scope:
	 *
	 * ```js
	 * transcludedContent.remove();
	 * transclusionScope.$destroy();
	 * ```
	 *
	 * <div class="alert alert-info">
	 * **Best Practice**: if you intend to add and remove transcluded content manually in your directive
	 * (by calling the transclude function to get the DOM and calling `element.remove()` to remove it),
	 * then you are also responsible for calling `$destroy` on the transclusion scope.
	 * </div>
	 *
	 * The built-in DOM manipulation directives, such as {@link ngIf}, {@link ngSwitch} and {@link ngRepeat}
	 * automatically destroy their transcluded clones as necessary so you do not need to worry about this if
	 * you are simply using {@link ngTransclude} to inject the transclusion into your directive.
	 *
	 *
	 * #### Transclusion Scopes
	 *
	 * When you call a transclude function it returns a DOM fragment that is pre-bound to a **transclusion
	 * scope**. This scope is special, in that it is a child of the directive's scope (and so gets destroyed
	 * when the directive's scope gets destroyed) but it inherits the properties of the scope from which it
	 * was taken.
	 *
	 * For example consider a directive that uses transclusion and isolated scope. The DOM hierarchy might look
	 * like this:
	 *
	 * ```html
	 * <div ng-app>
	 *   <div isolate>
	 *     <div transclusion>
	 *     </div>
	 *   </div>
	 * </div>
	 * ```
	 *
	 * The `$parent` scope hierarchy will look like this:
	 *
	   ```
	   - $rootScope
	     - isolate
	       - transclusion
	   ```
	 *
	 * but the scopes will inherit prototypically from different scopes to their `$parent`.
	 *
	   ```
	   - $rootScope
	     - transclusion
	   - isolate
	   ```
	 *
	 *
	 * ### Attributes
	 *
	 * The {@link ng.$compile.directive.Attributes Attributes} object - passed as a parameter in the
	 * `link()` or `compile()` functions. It has a variety of uses.
	 *
	 * * *Accessing normalized attribute names:* Directives like `ngBind` can be expressed in many ways:
	 *   `ng:bind`, `data-ng-bind`, or `x-ng-bind`. The attributes object allows for normalized access
	 *   to the attributes.
	 *
	 * * *Directive inter-communication:* All directives share the same instance of the attributes
	 *   object which allows the directives to use the attributes object as inter directive
	 *   communication.
	 *
	 * * *Supports interpolation:* Interpolation attributes are assigned to the attribute object
	 *   allowing other directives to read the interpolated value.
	 *
	 * * *Observing interpolated attributes:* Use `$observe` to observe the value changes of attributes
	 *   that contain interpolation (e.g. `src="{{bar}}"`). Not only is this very efficient but it's also
	 *   the only way to easily get the actual value because during the linking phase the interpolation
	 *   hasn't been evaluated yet and so the value is at this time set to `undefined`.
	 *
	 * ```js
	 * function linkingFn(scope, elm, attrs, ctrl) {
	 *   // get the attribute value
	 *   console.log(attrs.ngModel);
	 *
	 *   // change the attribute
	 *   attrs.$set('ngModel', 'new value');
	 *
	 *   // observe changes to interpolated attribute
	 *   attrs.$observe('ngModel', function(value) {
	 *     console.log('ngModel has changed value to ' + value);
	 *   });
	 * }
	 * ```
	 *
	 * ## Example
	 *
	 * <div class="alert alert-warning">
	 * **Note**: Typically directives are registered with `module.directive`. The example below is
	 * to illustrate how `$compile` works.
	 * </div>
	 *
	 <example module="compileExample" name="compile">
	   <file name="index.html">
	    <script>
	      angular.module('compileExample', [], function($compileProvider) {
	        // Configure new 'compile' directive by passing a directive
	        // factory function. The factory function injects '$compile'.
	        $compileProvider.directive('compile', function($compile) {
	          // The directive factory creates a link function.
	          return function(scope, element, attrs) {
	            scope.$watch(
	              function(scope) {
	                // Watch the 'compile' expression for changes.
	                return scope.$eval(attrs.compile);
	              },
	              function(value) {
	                // When the 'compile' expression changes
	                // assign it into the current DOM.
	                element.html(value);
	
	                // Compile the new DOM and link it to the current scope.
	                // NOTE: we only compile '.childNodes' so that we
	                // don't get into an infinite loop compiling ourselves.
	                $compile(element.contents())(scope);
	              }
	            );
	          };
	        });
	      })
	      .controller('GreeterController', ['$scope', function($scope) {
	        $scope.name = 'AngularJS';
	        $scope.html = 'Hello {{name}}';
	      }]);
	    </script>
	    <div ng-controller="GreeterController">
	      <input ng-model="name"> <br/>
	      <textarea ng-model="html"></textarea> <br/>
	      <div compile="html"></div>
	    </div>
	   </file>
	   <file name="protractor.js" type="protractor">
	     it('should auto compile', function() {
	       var textarea = $('textarea');
	       var output = $('div[compile]');
	       // The initial state reads 'Hello AngularJS'.
	       expect(output.getText()).toBe('Hello AngularJS');
	       textarea.clear();
	       textarea.sendKeys('{{name}}!');
	       expect(output.getText()).toBe('AngularJS!');
	     });
	   </file>
	 </example>
	
	 *
	 *
	 * @param {string|DOMElement} element Element or HTML string to compile into a template function.
	 * @param {function(angular.Scope, cloneAttachFn=)} transclude function available to directives - DEPRECATED.
	 *
	 * <div class="alert alert-danger">
	 * **Note:** Passing a `transclude` function to the $compile function is deprecated, as it
	 *   e.g. will not use the right outer scope. Please pass the transclude function as a
	 *   `parentBoundTranscludeFn` to the link function instead.
	 * </div>
	 *
	 * @param {number} maxPriority only apply directives lower than given priority (Only effects the
	 *                 root element(s), not their children)
	 * @returns {function(scope, cloneAttachFn=, options=)} a link function which is used to bind template
	 * (a DOM element/tree) to a scope. Where:
	 *
	 *  * `scope` - A {@link ng.$rootScope.Scope Scope} to bind to.
	 *  * `cloneAttachFn` - If `cloneAttachFn` is provided, then the link function will clone the
	 *  `template` and call the `cloneAttachFn` function allowing the caller to attach the
	 *  cloned elements to the DOM document at the appropriate place. The `cloneAttachFn` is
	 *  called as: <br/> `cloneAttachFn(clonedElement, scope)` where:
	 *
	 *      * `clonedElement` - is a clone of the original `element` passed into the compiler.
	 *      * `scope` - is the current scope with which the linking function is working with.
	 *
	 *  * `options` - An optional object hash with linking options. If `options` is provided, then the following
	 *  keys may be used to control linking behavior:
	 *
	 *      * `parentBoundTranscludeFn` - the transclude function made available to
	 *        directives; if given, it will be passed through to the link functions of
	 *        directives found in `element` during compilation.
	 *      * `transcludeControllers` - an object hash with keys that map controller names
	 *        to a hash with the key `instance`, which maps to the controller instance;
	 *        if given, it will make the controllers available to directives on the compileNode:
	 *        ```
	 *        {
	 *          parent: {
	 *            instance: parentControllerInstance
	 *          }
	 *        }
	 *        ```
	 *      * `futureParentElement` - defines the parent to which the `cloneAttachFn` will add
	 *        the cloned elements; only needed for transcludes that are allowed to contain non HTML
	 *        elements (e.g. SVG elements). See also the `directive.controller` property.
	 *
	 * Calling the linking function returns the element of the template. It is either the original
	 * element passed in, or the clone of the element if the `cloneAttachFn` is provided.
	 *
	 * After linking the view is not updated until after a call to `$digest`, which typically is done by
	 * AngularJS automatically.
	 *
	 * If you need access to the bound view, there are two ways to do it:
	 *
	 * - If you are not asking the linking function to clone the template, create the DOM element(s)
	 *   before you send them to the compiler and keep this reference around.
	 *   ```js
	 *     var element = angular.element('<p>{{total}}</p>');
	 *     $compile(element)(scope);
	 *   ```
	 *
	 * - if on the other hand, you need the element to be cloned, the view reference from the original
	 *   example would not point to the clone, but rather to the original template that was cloned. In
	 *   this case, you can access the clone either via the `cloneAttachFn` or the value returned by the
	 *   linking function:
	 *   ```js
	 *     var templateElement = angular.element('<p>{{total}}</p>');
	 *     var clonedElement = $compile(templateElement)(scope, function(clonedElement, scope) {
	 *       // Attach the clone to DOM document at the right place.
	 *     });
	 *
	 *     // Now we have reference to the cloned DOM via `clonedElement`.
	 *     // NOTE: The `clonedElement` returned by the linking function is the same as the
	 *     //       `clonedElement` passed to `cloneAttachFn`.
	 *   ```
	 *
	 *
	 * For information on how the compiler works, see the
	 * {@link guide/compiler AngularJS HTML Compiler} section of the Developer Guide.
	 *
	 * @knownIssue
	 *
	 * ### Double Compilation
	 *
	   Double compilation occurs when an already compiled part of the DOM gets
	   compiled again. This is an undesired effect and can lead to misbehaving directives, performance issues,
	   and memory leaks. Refer to the Compiler Guide {@link guide/compiler#double-compilation-and-how-to-avoid-it
	   section on double compilation} for an in-depth explanation and ways to avoid it.
	
	 * @knownIssue
	
	   ### Issues with `replace: true`
	 *
	 * <div class="alert alert-danger">
	 *   **Note**: {@link $compile#-replace- `replace: true`} is deprecated and not recommended to use,
	 *   mainly due to the issues listed here. It has been completely removed in the new Angular.
	 * </div>
	 *
	 * #### Attribute values are not merged
	 *
	 * When a `replace` directive encounters the same attribute on the original and the replace node,
	 * it will simply deduplicate the attribute and join the values with a space or with a `;` in case of
	 * the `style` attribute.
	 * ```html
	 * Original Node: <span class="original" style="color: red;"></span>
	 * Replace Template: <span class="replaced" style="background: blue;"></span>
	 * Result: <span class="original replaced" style="color: red; background: blue;"></span>
	 * ```
	 *
	 * That means attributes that contain AngularJS expressions will not be merged correctly, e.g.
	 * {@link ngShow} or {@link ngClass} will cause a {@link $parse} error:
	 *
	 * ```html
	 * Original Node: <span ng-class="{'something': something}" ng-show="!condition"></span>
	 * Replace Template: <span ng-class="{'else': else}" ng-show="otherCondition"></span>
	 * Result: <span ng-class="{'something': something} {'else': else}" ng-show="!condition otherCondition"></span>
	 * ```
	 *
	 * See issue [#5695](https://github.com/angular/angular.js/issues/5695).
	 *
	 * #### Directives are not deduplicated before compilation
	 *
	 * When the original node and the replace template declare the same directive(s), they will be
	 * {@link guide/compiler#double-compilation-and-how-to-avoid-it compiled twice} because the compiler
	 * does not deduplicate them. In many cases, this is not noticeable, but e.g. {@link ngModel} will
	 * attach `$formatters` and `$parsers` twice.
	 *
	 * See issue [#2573](https://github.com/angular/angular.js/issues/2573).
	 *
	 * #### `transclude: element` in the replace template root can have unexpected effects
	 *
	 * When the replace template has a directive at the root node that uses
	 * {@link $compile#-transclude- `transclude: element`}, e.g.
	 * {@link ngIf} or {@link ngRepeat}, the DOM structure or scope inheritance can be incorrect.
	 * See the following issues:
	 *
	 * - Incorrect scope on replaced element:
	 * [#9837](https://github.com/angular/angular.js/issues/9837)
	 * - Different DOM between `template` and `templateUrl`:
	 * [#10612](https://github.com/angular/angular.js/issues/14326)
	 *
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngProp
	 * @restrict A
	 * @element ANY
	 *
	 * @usage
	 *
	 * ```html
	 * <ANY ng-prop-propname="expression">
	 * </ANY>
	 * ```
	 *
	 * or with uppercase letters in property (e.g. "propName"):
	 *
	 *
	 * ```html
	 * <ANY ng-prop-prop_name="expression">
	 * </ANY>
	 * ```
	 *
	 *
	 * @description
	 * The `ngProp` directive binds an expression to a DOM element property.
	 * `ngProp` allows writing to arbitrary properties by including
	 * the property name in the attribute, e.g. `ng-prop-value="'my value'"` binds 'my value' to
	 * the `value` property.
	 *
	 * Usually, it's not necessary to write to properties in AngularJS, as the built-in directives
	 * handle the most common use cases (instead of the above example, you would use {@link ngValue}).
	 *
	 * However, [custom elements](https://developer.mozilla.org/docs/Web/Web_Components/Using_custom_elements)
	 * often use custom properties to hold data, and `ngProp` can be used to provide input to these
	 * custom elements.
	 *
	 * ## Binding to camelCase properties
	 *
	 * Since HTML attributes are case-insensitive, camelCase properties like `innerHTML` must be escaped.
	 * AngularJS uses the underscore (_) in front of a character to indicate that it is uppercase, so
	 * `innerHTML`  must be written as `ng-prop-inner_h_t_m_l="expression"` (Note that this is just an
	 * example, and for binding HTML {@link ngBindHtml} should be used.
	 *
	 * ## Security
	 *
	 * Binding expressions to arbitrary properties poses a security risk, as  properties like `innerHTML`
	 * can insert potentially dangerous HTML into the application, e.g. script tags that execute
	 * malicious code.
	 * For this reason, `ngProp` applies Strict Contextual Escaping with the {@link ng.$sce $sce service}.
	 * This means vulnerable properties require their content to be "trusted", based on the
	 * context of the property. For example, the `innerHTML` is in the `HTML` context, and the
	 * `iframe.src` property is in the `RESOURCE_URL` context, which requires that values written to
	 * this property are trusted as a `RESOURCE_URL`.
	 *
	 * This can be set explicitly by calling $sce.trustAs(type, value) on the value that is
	 * trusted before passing it to the `ng-prop-*` directive. There are exist shorthand methods for
	 * each context type in the form of {@link ng.$sce#trustAsResourceUrl $sce.trustAsResourceUrl()} et al.
	 *
	 * In some cases you can also rely upon automatic sanitization of untrusted values - see below.
	 *
	 * Based on the context, other options may exist to mark a value as trusted / configure the behavior
	 * of {@link ng.$sce}. For example, to restrict the `RESOURCE_URL` context to specific origins, use
	 * the {@link $sceDelegateProvider#trustedResourceUrlList trustedResourceUrlList()}
	 * and {@link $sceDelegateProvider#bannedResourceUrlList bannedResourceUrlList()}.
	 *
	 * {@link ng.$sce#what-trusted-context-types-are-supported- Find out more about the different context types}.
	 *
	 * ### HTML Sanitization
	 *
	 * By default, `$sce` will throw an error if it detects untrusted HTML content, and will not bind the
	 * content.
	 * However, if you include the {@link ngSanitize ngSanitize module}, it will try to sanitize the
	 * potentially dangerous HTML, e.g. strip non-trusted tags and attributes when binding to
	 * `innerHTML`.
	 *
	 * @example
	 * ### Binding to different contexts
	 *
	 * <example name="ngProp" module="exampleNgProp">
	 *   <file name="app.js">
	 *     angular.module('exampleNgProp', [])
	 *       .component('main', {
	 *         templateUrl: 'main.html',
	 *         controller: function($sce) {
	 *           this.safeContent = '<strong>Safe content</strong>';
	 *           this.unsafeContent = '<button onclick="alert(\'Hello XSS!\')">Click for XSS</button>';
	 *           this.trustedUnsafeContent = $sce.trustAsHtml(this.unsafeContent);
	 *         }
	 *       });
	 *   </file>
	 *   <file name="main.html">
	 *     <div>
	 *       <div class="prop-unit">
	 *         Binding to a property without security context:
	 *         <div class="prop-binding" ng-prop-inner_text="$ctrl.safeContent"></div>
	 *         <span class="prop-note">innerText</span> (safeContent)
	 *       </div>
	 *
	 *       <div class="prop-unit">
	 *         "Safe" content that requires a security context will throw because the contents could potentially be dangerous ...
	 *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.safeContent"></div>
	 *         <span class="prop-note">innerHTML</span> (safeContent)
	 *       </div>
	 *
	 *       <div class="prop-unit">
	 *         ... so that actually dangerous content cannot be executed:
	 *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.unsafeContent"></div>
	 *         <span class="prop-note">innerHTML</span> (unsafeContent)
	 *       </div>
	 *
	 *       <div class="prop-unit">
	 *         ... but unsafe Content that has been trusted explicitly works - only do this if you are 100% sure!
	 *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.trustedUnsafeContent"></div>
	 *         <span class="prop-note">innerHTML</span> (trustedUnsafeContent)
	 *       </div>
	 *     </div>
	 *   </file>
	 *   <file name="index.html">
	 *     <main></main>
	 *   </file>
	 *   <file name="styles.css">
	 *     .prop-unit {
	 *       margin-bottom: 10px;
	 *     }
	 *
	 *     .prop-binding {
	 *       min-height: 30px;
	 *       border: 1px solid blue;
	 *     }
	 *
	 *     .prop-note {
	 *       font-family: Monospace;
	 *     }
	 *   </file>
	 * </example>
	 *
	 *
	 * @example
	 * ### Binding to innerHTML with ngSanitize
	 *
	 * <example name="ngProp" module="exampleNgProp" deps="angular-sanitize.js">
	 *   <file name="app.js">
	 *     angular.module('exampleNgProp', ['ngSanitize'])
	 *       .component('main', {
	 *         templateUrl: 'main.html',
	 *         controller: function($sce) {
	 *           this.safeContent = '<strong>Safe content</strong>';
	 *           this.unsafeContent = '<button onclick="alert(\'Hello XSS!\')">Click for XSS</button>';
	 *           this.trustedUnsafeContent = $sce.trustAsHtml(this.unsafeContent);
	 *         }
	 *       });
	 *   </file>
	 *   <file name="main.html">
	 *     <div>
	 *       <div class="prop-unit">
	 *         "Safe" content will be sanitized ...
	 *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.safeContent"></div>
	 *         <span class="prop-note">innerHTML</span> (safeContent)
	 *       </div>
	 *
	 *       <div class="prop-unit">
	 *         ... as will dangerous content:
	 *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.unsafeContent"></div>
	 *         <span class="prop-note">innerHTML</span> (unsafeContent)
	 *       </div>
	 *
	 *       <div class="prop-unit">
	 *         ... and content that has been trusted explicitly works the same as without ngSanitize:
	 *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.trustedUnsafeContent"></div>
	 *         <span class="prop-note">innerHTML</span> (trustedUnsafeContent)
	 *       </div>
	 *     </div>
	 *   </file>
	 *   <file name="index.html">
	 *     <main></main>
	 *   </file>
	 *   <file name="styles.css">
	 *     .prop-unit {
	 *       margin-bottom: 10px;
	 *     }
	 *
	 *     .prop-binding {
	 *       min-height: 30px;
	 *       border: 1px solid blue;
	 *     }
	 *
	 *     .prop-note {
	 *       font-family: Monospace;
	 *     }
	 *   </file>
	 * </example>
	 *
	 */
	
	/** @ngdoc directive
	 * @name ngOn
	 * @restrict A
	 * @element ANY
	 *
	 * @usage
	 *
	 * ```html
	 * <ANY ng-on-eventname="expression">
	 * </ANY>
	 * ```
	 *
	 * or with uppercase letters in property (e.g. "eventName"):
	 *
	 *
	 * ```html
	 * <ANY ng-on-event_name="expression">
	 * </ANY>
	 * ```
	 *
	 * @description
	 * The `ngOn` directive adds an event listener to a DOM element via
	 * {@link angular.element angular.element().on()}, and evaluates an expression when the event is
	 * fired.
	 * `ngOn` allows adding listeners for arbitrary events by including
	 * the event name in the attribute, e.g. `ng-on-drop="onDrop()"` executes the 'onDrop()' expression
	 * when the `drop` event is fired.
	 *
	 * AngularJS provides specific directives for many events, such as {@link ngClick}, so in most
	 * cases it is not necessary to use `ngOn`. However, AngularJS does not support all events
	 * (e.g. the `drop` event in the example above), and new events might be introduced in later DOM
	 * standards.
	 *
	 * Another use-case for `ngOn` is listening to
	 * [custom events](https://developer.mozilla.org/docs/Web/Guide/Events/Creating_and_triggering_events)
	 * fired by
	 * [custom elements](https://developer.mozilla.org/docs/Web/Web_Components/Using_custom_elements).
	 *
	 * ## Binding to camelCase properties
	 *
	 * Since HTML attributes are case-insensitive, camelCase properties like `myEvent` must be escaped.
	 * AngularJS uses the underscore (_) in front of a character to indicate that it is uppercase, so
	 * `myEvent` must be written as `ng-on-my_event="expression"`.
	 *
	 * @example
	 * ### Bind to built-in DOM events
	 *
	 * <example name="ngOn" module="exampleNgOn">
	 *   <file name="app.js">
	 *     angular.module('exampleNgOn', [])
	 *       .component('main', {
	 *         templateUrl: 'main.html',
	 *         controller: function() {
	 *           this.clickCount = 0;
	 *           this.mouseoverCount = 0;
	 *
	 *           this.loadingState = 0;
	 *         }
	 *       });
	 *   </file>
	 *   <file name="main.html">
	 *     <div>
	 *       This is equivalent to `ngClick` and `ngMouseover`:<br>
	 *       <button
	 *         ng-on-click="$ctrl.clickCount = $ctrl.clickCount + 1"
	 *         ng-on-mouseover="$ctrl.mouseoverCount = $ctrl.mouseoverCount + 1">Click or mouseover</button><br>
	 *       clickCount: {{$ctrl.clickCount}}<br>
	 *       mouseover: {{$ctrl.mouseoverCount}}
	 *
	 *       <hr>
	 *
	 *       For the `error` and `load` event on images no built-in AngularJS directives exist:<br>
	 *       <img src="thisimagedoesnotexist.png" ng-on-error="$ctrl.loadingState = -1" ng-on-load="$ctrl.loadingState = 1"><br>
	 *       <div ng-switch="$ctrl.loadingState">
	 *         <span ng-switch-when="0">Image is loading</span>
	 *         <span ng-switch-when="-1">Image load error</span>
	 *         <span ng-switch-when="1">Image loaded successfully</span>
	 *       </div>
	 *     </div>
	 *   </file>
	 *   <file name="index.html">
	 *     <main></main>
	 *   </file>
	 * </example>
	 *
	 *
	 * @example
	 * ### Bind to custom DOM events
	 *
	 * <example name="ngOnCustom" module="exampleNgOn">
	 *   <file name="app.js">
	 *     angular.module('exampleNgOn', [])
	 *       .component('main', {
	 *         templateUrl: 'main.html',
	 *         controller: function() {
	 *           this.eventLog = '';
	 *
	 *           this.listener = function($event) {
	 *             this.eventLog = 'Event with type "' + $event.type + '" fired at ' + $event.detail;
	 *           };
	 *         }
	 *       })
	 *       .component('childComponent', {
	 *         templateUrl: 'child.html',
	 *         controller: function($element) {
	 *           this.fireEvent = function() {
	 *             var event = new CustomEvent('customtype', { detail: new Date()});
	 *
	 *             $element[0].dispatchEvent(event);
	 *           };
	 *         }
	 *       });
	 *   </file>
	 *   <file name="main.html">
	 *     <child-component ng-on-customtype="$ctrl.listener($event)"></child-component><br>
	 *     <span>Event log: {{$ctrl.eventLog}}</span>
	 *   </file>
	 *   <file name="child.html">
	      <button ng-click="$ctrl.fireEvent()">Fire custom event</button>
	 *   </file>
	 *   <file name="index.html">
	 *     <main></main>
	 *   </file>
	 * </example>
	 */
	
	var $compileMinErr = minErr('$compile');
	
	function UNINITIALIZED_VALUE() {}
	var _UNINITIALIZED_VALUE = new UNINITIALIZED_VALUE();
	
	/**
	 * @ngdoc provider
	 * @name $compileProvider
	 *
	 * @description
	 */
	$CompileProvider.$inject = ['$provide', '$$sanitizeUriProvider'];
	/** @this */
	function $CompileProvider($provide, $$sanitizeUriProvider) {
	  var hasDirectives = {},
	      Suffix = 'Directive',
	      COMMENT_DIRECTIVE_REGEXP = /^\s*directive:\s*([\w-]+)\s+(.*)$/,
	      CLASS_DIRECTIVE_REGEXP = /(([\w-]+)(?::([^;]+))?;?)/,
	      ALL_OR_NOTHING_ATTRS = makeMap('ngSrc,ngSrcset,src,srcset'),
	      REQUIRE_PREFIX_REGEXP = /^(?:(\^\^?)?(\?)?(\^\^?)?)?/;
	
	  // Ref: http://developers.whatwg.org/webappapis.html#event-handler-idl-attributes
	  // The assumption is that future DOM event attribute names will begin with
	  // 'on' and be composed of only English letters.
	  var EVENT_HANDLER_ATTR_REGEXP = /^(on[a-z]+|formaction)$/;
	  var bindingCache = createMap();
	
	  function parseIsolateBindings(scope, directiveName, isController) {
	    var LOCAL_REGEXP = /^([@&]|[=<](\*?))(\??)\s*([\w$]*)$/;
	
	    var bindings = createMap();
	
	    forEach(scope, function(definition, scopeName) {
	      definition = definition.trim();
	
	      if (definition in bindingCache) {
	        bindings[scopeName] = bindingCache[definition];
	        return;
	      }
	      var match = definition.match(LOCAL_REGEXP);
	
	      if (!match) {
	        throw $compileMinErr('iscp',
	            'Invalid {3} for directive \'{0}\'.' +
	            ' Definition: {... {1}: \'{2}\' ...}',
	            directiveName, scopeName, definition,
	            (isController ? 'controller bindings definition' :
	            'isolate scope definition'));
	      }
	
	      bindings[scopeName] = {
	        mode: match[1][0],
	        collection: match[2] === '*',
	        optional: match[3] === '?',
	        attrName: match[4] || scopeName
	      };
	      if (match[4]) {
	        bindingCache[definition] = bindings[scopeName];
	      }
	    });
	
	    return bindings;
	  }
	
	  function parseDirectiveBindings(directive, directiveName) {
	    var bindings = {
	      isolateScope: null,
	      bindToController: null
	    };
	    if (isObject(directive.scope)) {
	      if (directive.bindToController === true) {
	        bindings.bindToController = parseIsolateBindings(directive.scope,
	                                                         directiveName, true);
	        bindings.isolateScope = {};
	      } else {
	        bindings.isolateScope = parseIsolateBindings(directive.scope,
	                                                     directiveName, false);
	      }
	    }
	    if (isObject(directive.bindToController)) {
	      bindings.bindToController =
	          parseIsolateBindings(directive.bindToController, directiveName, true);
	    }
	    if (bindings.bindToController && !directive.controller) {
	      // There is no controller
	      throw $compileMinErr('noctrl',
	            'Cannot bind to controller without directive \'{0}\'s controller.',
	            directiveName);
	    }
	    return bindings;
	  }
	
	  function assertValidDirectiveName(name) {
	    var letter = name.charAt(0);
	    if (!letter || letter !== lowercase(letter)) {
	      throw $compileMinErr('baddir', 'Directive/Component name \'{0}\' is invalid. The first character must be a lowercase letter', name);
	    }
	    if (name !== name.trim()) {
	      throw $compileMinErr('baddir',
	            'Directive/Component name \'{0}\' is invalid. The name should not contain leading or trailing whitespaces',
	            name);
	    }
	  }
	
	  function getDirectiveRequire(directive) {
	    var require = directive.require || (directive.controller && directive.name);
	
	    if (!isArray(require) && isObject(require)) {
	      forEach(require, function(value, key) {
	        var match = value.match(REQUIRE_PREFIX_REGEXP);
	        var name = value.substring(match[0].length);
	        if (!name) require[key] = match[0] + key;
	      });
	    }
	
	    return require;
	  }
	
	  function getDirectiveRestrict(restrict, name) {
	    if (restrict && !(isString(restrict) && /[EACM]/.test(restrict))) {
	      throw $compileMinErr('badrestrict',
	          'Restrict property \'{0}\' of directive \'{1}\' is invalid',
	          restrict,
	          name);
	    }
	
	    return restrict || 'EA';
	  }
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#directive
	   * @kind function
	   *
	   * @description
	   * Register a new directive with the compiler.
	   *
	   * @param {string|Object} name Name of the directive in camel-case (i.e. `ngBind` which will match
	   *    as `ng-bind`), or an object map of directives where the keys are the names and the values
	   *    are the factories.
	   * @param {Function|Array} directiveFactory An injectable directive factory function. See the
	   *    {@link guide/directive directive guide} and the {@link $compile compile API} for more info.
	   * @returns {ng.$compileProvider} Self for chaining.
	   */
	  this.directive = function registerDirective(name, directiveFactory) {
	    assertArg(name, 'name');
	    assertNotHasOwnProperty(name, 'directive');
	    if (isString(name)) {
	      assertValidDirectiveName(name);
	      assertArg(directiveFactory, 'directiveFactory');
	      if (!hasDirectives.hasOwnProperty(name)) {
	        hasDirectives[name] = [];
	        $provide.factory(name + Suffix, ['$injector', '$exceptionHandler',
	          function($injector, $exceptionHandler) {
	            var directives = [];
	            forEach(hasDirectives[name], function(directiveFactory, index) {
	              try {
	                var directive = $injector.invoke(directiveFactory);
	                if (isFunction(directive)) {
	                  directive = { compile: valueFn(directive) };
	                } else if (!directive.compile && directive.link) {
	                  directive.compile = valueFn(directive.link);
	                }
	                directive.priority = directive.priority || 0;
	                directive.index = index;
	                directive.name = directive.name || name;
	                directive.require = getDirectiveRequire(directive);
	                directive.restrict = getDirectiveRestrict(directive.restrict, name);
	                directive.$$moduleName = directiveFactory.$$moduleName;
	                directives.push(directive);
	              } catch (e) {
	                $exceptionHandler(e);
	              }
	            });
	            return directives;
	          }]);
	      }
	      hasDirectives[name].push(directiveFactory);
	    } else {
	      forEach(name, reverseParams(registerDirective));
	    }
	    return this;
	  };
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#component
	   * @module ng
	   * @param {string|Object} name Name of the component in camelCase (i.e. `myComp` which will match `<my-comp>`),
	   *    or an object map of components where the keys are the names and the values are the component definition objects.
	   * @param {Object} options Component definition object (a simplified
	   *    {@link ng.$compile#directive-definition-object directive definition object}),
	   *    with the following properties (all optional):
	   *
	   *    - `controller` – `{(string|function()=}` – controller constructor function that should be
	   *      associated with newly created scope or the name of a {@link ng.$compile#-controller-
	   *      registered controller} if passed as a string. An empty `noop` function by default.
	   *    - `controllerAs` – `{string=}` – identifier name for to reference the controller in the component's scope.
	   *      If present, the controller will be published to scope under the `controllerAs` name.
	   *      If not present, this will default to be `$ctrl`.
	   *    - `template` – `{string=|function()=}` – html template as a string or a function that
	   *      returns an html template as a string which should be used as the contents of this component.
	   *      Empty string by default.
	   *
	   *      If `template` is a function, then it is {@link auto.$injector#invoke injected} with
	   *      the following locals:
	   *
	   *      - `$element` - Current element
	   *      - `$attrs` - Current attributes object for the element
	   *
	   *    - `templateUrl` – `{string=|function()=}` – path or function that returns a path to an html
	   *      template that should be used  as the contents of this component.
	   *
	   *      If `templateUrl` is a function, then it is {@link auto.$injector#invoke injected} with
	   *      the following locals:
	   *
	   *      - `$element` - Current element
	   *      - `$attrs` - Current attributes object for the element
	   *
	   *    - `bindings` – `{object=}` – defines bindings between DOM attributes and component properties.
	   *      Component properties are always bound to the component controller and not to the scope.
	   *      See {@link ng.$compile#-bindtocontroller- `bindToController`}.
	   *    - `transclude` – `{boolean=}` – whether {@link $compile#transclusion content transclusion} is enabled.
	   *      Disabled by default.
	   *    - `require` - `{Object<string, string>=}` - requires the controllers of other directives and binds them to
	   *      this component's controller. The object keys specify the property names under which the required
	   *      controllers (object values) will be bound. See {@link ng.$compile#-require- `require`}.
	   *    - `$...` – additional properties to attach to the directive factory function and the controller
	   *      constructor function. (This is used by the component router to annotate)
	   *
	   * @returns {ng.$compileProvider} the compile provider itself, for chaining of function calls.
	   * @description
	   * Register a **component definition** with the compiler. This is a shorthand for registering a special
	   * type of directive, which represents a self-contained UI component in your application. Such components
	   * are always isolated (i.e. `scope: {}`) and are always restricted to elements (i.e. `restrict: 'E'`).
	   *
	   * Component definitions are very simple and do not require as much configuration as defining general
	   * directives. Component definitions usually consist only of a template and a controller backing it.
	   *
	   * In order to make the definition easier, components enforce best practices like use of `controllerAs`,
	   * `bindToController`. They always have **isolate scope** and are restricted to elements.
	   *
	   * Here are a few examples of how you would usually define components:
	   *
	   * ```js
	   *   var myMod = angular.module(...);
	   *   myMod.component('myComp', {
	   *     template: '<div>My name is {{$ctrl.name}}</div>',
	   *     controller: function() {
	   *       this.name = 'shahar';
	   *     }
	   *   });
	   *
	   *   myMod.component('myComp', {
	   *     template: '<div>My name is {{$ctrl.name}}</div>',
	   *     bindings: {name: '@'}
	   *   });
	   *
	   *   myMod.component('myComp', {
	   *     templateUrl: 'views/my-comp.html',
	   *     controller: 'MyCtrl',
	   *     controllerAs: 'ctrl',
	   *     bindings: {name: '@'}
	   *   });
	   *
	   * ```
	   * For more examples, and an in-depth guide, see the {@link guide/component component guide}.
	   *
	   * <br />
	   * See also {@link ng.$compileProvider#directive $compileProvider.directive()}.
	   */
	  this.component = function registerComponent(name, options) {
	    if (!isString(name)) {
	      forEach(name, reverseParams(bind(this, registerComponent)));
	      return this;
	    }
	
	    var controller = options.controller || function() {};
	
	    function factory($injector) {
	      function makeInjectable(fn) {
	        if (isFunction(fn) || isArray(fn)) {
	          return /** @this */ function(tElement, tAttrs) {
	            return $injector.invoke(fn, this, {$element: tElement, $attrs: tAttrs});
	          };
	        } else {
	          return fn;
	        }
	      }
	
	      var template = (!options.template && !options.templateUrl ? '' : options.template);
	      var ddo = {
	        controller: controller,
	        controllerAs: identifierForController(options.controller) || options.controllerAs || '$ctrl',
	        template: makeInjectable(template),
	        templateUrl: makeInjectable(options.templateUrl),
	        transclude: options.transclude,
	        scope: {},
	        bindToController: options.bindings || {},
	        restrict: 'E',
	        require: options.require
	      };
	
	      // Copy annotations (starting with $) over to the DDO
	      forEach(options, function(val, key) {
	        if (key.charAt(0) === '$') ddo[key] = val;
	      });
	
	      return ddo;
	    }
	
	    // TODO(pete) remove the following `forEach` before we release 1.6.0
	    // The component-router@0.2.0 looks for the annotations on the controller constructor
	    // Nothing in AngularJS looks for annotations on the factory function but we can't remove
	    // it from 1.5.x yet.
	
	    // Copy any annotation properties (starting with $) over to the factory and controller constructor functions
	    // These could be used by libraries such as the new component router
	    forEach(options, function(val, key) {
	      if (key.charAt(0) === '$') {
	        factory[key] = val;
	        // Don't try to copy over annotations to named controller
	        if (isFunction(controller)) controller[key] = val;
	      }
	    });
	
	    factory.$inject = ['$injector'];
	
	    return this.directive(name, factory);
	  };
	
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#aHrefSanitizationTrustedUrlList
	   * @kind function
	   *
	   * @description
	   * Retrieves or overrides the default regular expression that is used for determining trusted safe
	   * urls during a[href] sanitization.
	   *
	   * The sanitization is a security measure aimed at preventing XSS attacks via html links.
	   *
	   * Any url about to be assigned to a[href] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `aHrefSanitizationTrustedUrlList`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to trust urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.aHrefSanitizationTrustedUrlList = function(regexp) {
	    if (isDefined(regexp)) {
	      $$sanitizeUriProvider.aHrefSanitizationTrustedUrlList(regexp);
	      return this;
	    } else {
	      return $$sanitizeUriProvider.aHrefSanitizationTrustedUrlList();
	    }
	  };
	
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#aHrefSanitizationWhitelist
	   * @kind function
	   *
	   * @deprecated
	   * sinceVersion="1.8.1"
	   *
	   * This method is deprecated. Use {@link $compileProvider#aHrefSanitizationTrustedUrlList
	   * aHrefSanitizationTrustedUrlList} instead.
	   */
	  Object.defineProperty(this, 'aHrefSanitizationWhitelist', {
	    get: function() {
	      return this.aHrefSanitizationTrustedUrlList;
	    },
	    set: function(value) {
	      this.aHrefSanitizationTrustedUrlList = value;
	    }
	  });
	
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#imgSrcSanitizationTrustedUrlList
	   * @kind function
	   *
	   * @description
	   * Retrieves or overrides the default regular expression that is used for determining trusted safe
	   * urls during img[src] sanitization.
	   *
	   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
	   *
	   * Any url about to be assigned to img[src] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `imgSrcSanitizationTrustedUrlList`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to trust urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.imgSrcSanitizationTrustedUrlList = function(regexp) {
	    if (isDefined(regexp)) {
	      $$sanitizeUriProvider.imgSrcSanitizationTrustedUrlList(regexp);
	      return this;
	    } else {
	      return $$sanitizeUriProvider.imgSrcSanitizationTrustedUrlList();
	    }
	  };
	
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#imgSrcSanitizationWhitelist
	   * @kind function
	   *
	   * @deprecated
	   * sinceVersion="1.8.1"
	   *
	   * This method is deprecated. Use {@link $compileProvider#imgSrcSanitizationTrustedUrlList
	   * imgSrcSanitizationTrustedUrlList} instead.
	   */
	  Object.defineProperty(this, 'imgSrcSanitizationWhitelist', {
	    get: function() {
	      return this.imgSrcSanitizationTrustedUrlList;
	    },
	    set: function(value) {
	      this.imgSrcSanitizationTrustedUrlList = value;
	    }
	  });
	
	  /**
	   * @ngdoc method
	   * @name  $compileProvider#debugInfoEnabled
	   *
	   * @param {boolean=} enabled update the debugInfoEnabled state if provided, otherwise just return the
	   * current debugInfoEnabled state
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   *
	   * @kind function
	   *
	   * @description
	   * Call this method to enable/disable various debug runtime information in the compiler such as adding
	   * binding information and a reference to the current scope on to DOM elements.
	   * If enabled, the compiler will add the following to DOM elements that have been bound to the scope
	   * * `ng-binding` CSS class
	   * * `ng-scope` and `ng-isolated-scope` CSS classes
	   * * `$binding` data property containing an array of the binding expressions
	   * * Data properties used by the {@link angular.element#methods `scope()`/`isolateScope()` methods} to return
	   *   the element's scope.
	   * * Placeholder comments will contain information about what directive and binding caused the placeholder.
	   *   E.g. `<!-- ngIf: shouldShow() -->`.
	   *
	   * You may want to disable this in production for a significant performance boost. See
	   * {@link guide/production#disabling-debug-data Disabling Debug Data} for more.
	   *
	   * The default value is true.
	   */
	  var debugInfoEnabled = true;
	  this.debugInfoEnabled = function(enabled) {
	    if (isDefined(enabled)) {
	      debugInfoEnabled = enabled;
	      return this;
	    }
	    return debugInfoEnabled;
	  };
	
	  /**
	   * @ngdoc method
	   * @name  $compileProvider#strictComponentBindingsEnabled
	   *
	   * @param {boolean=} enabled update the strictComponentBindingsEnabled state if provided,
	   * otherwise return the current strictComponentBindingsEnabled state.
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   *
	   * @kind function
	   *
	   * @description
	   * Call this method to enable / disable the strict component bindings check. If enabled, the
	   * compiler will enforce that all scope / controller bindings of a
	   * {@link $compileProvider#directive directive} / {@link $compileProvider#component component}
	   * that are not set as optional with `?`, must be provided when the directive is instantiated.
	   * If not provided, the compiler will throw the
	   * {@link error/$compile/missingattr $compile:missingattr error}.
	   *
	   * The default value is false.
	   */
	  var strictComponentBindingsEnabled = false;
	  this.strictComponentBindingsEnabled = function(enabled) {
	    if (isDefined(enabled)) {
	      strictComponentBindingsEnabled = enabled;
	      return this;
	    }
	    return strictComponentBindingsEnabled;
	  };
	
	  var TTL = 10;
	  /**
	   * @ngdoc method
	   * @name $compileProvider#onChangesTtl
	   * @description
	   *
	   * Sets the number of times `$onChanges` hooks can trigger new changes before giving up and
	   * assuming that the model is unstable.
	   *
	   * The current default is 10 iterations.
	   *
	   * In complex applications it's possible that dependencies between `$onChanges` hooks and bindings will result
	   * in several iterations of calls to these hooks. However if an application needs more than the default 10
	   * iterations to stabilize then you should investigate what is causing the model to continuously change during
	   * the `$onChanges` hook execution.
	   *
	   * Increasing the TTL could have performance implications, so you should not change it without proper justification.
	   *
	   * @param {number} limit The number of `$onChanges` hook iterations.
	   * @returns {number|object} the current limit (or `this` if called as a setter for chaining)
	   */
	  this.onChangesTtl = function(value) {
	    if (arguments.length) {
	      TTL = value;
	      return this;
	    }
	    return TTL;
	  };
	
	  var commentDirectivesEnabledConfig = true;
	  /**
	   * @ngdoc method
	   * @name $compileProvider#commentDirectivesEnabled
	   * @description
	   *
	   * It indicates to the compiler
	   * whether or not directives on comments should be compiled.
	   * Defaults to `true`.
	   *
	   * Calling this function with false disables the compilation of directives
	   * on comments for the whole application.
	   * This results in a compilation performance gain,
	   * as the compiler doesn't have to check comments when looking for directives.
	   * This should however only be used if you are sure that no comment directives are used in
	   * the application (including any 3rd party directives).
	   *
	   * @param {boolean} enabled `false` if the compiler may ignore directives on comments
	   * @returns {boolean|object} the current value (or `this` if called as a setter for chaining)
	   */
	  this.commentDirectivesEnabled = function(value) {
	    if (arguments.length) {
	      commentDirectivesEnabledConfig = value;
	      return this;
	    }
	    return commentDirectivesEnabledConfig;
	  };
	
	
	  var cssClassDirectivesEnabledConfig = true;
	  /**
	   * @ngdoc method
	   * @name $compileProvider#cssClassDirectivesEnabled
	   * @description
	   *
	   * It indicates to the compiler
	   * whether or not directives on element classes should be compiled.
	   * Defaults to `true`.
	   *
	   * Calling this function with false disables the compilation of directives
	   * on element classes for the whole application.
	   * This results in a compilation performance gain,
	   * as the compiler doesn't have to check element classes when looking for directives.
	   * This should however only be used if you are sure that no class directives are used in
	   * the application (including any 3rd party directives).
	   *
	   * @param {boolean} enabled `false` if the compiler may ignore directives on element classes
	   * @returns {boolean|object} the current value (or `this` if called as a setter for chaining)
	   */
	  this.cssClassDirectivesEnabled = function(value) {
	    if (arguments.length) {
	      cssClassDirectivesEnabledConfig = value;
	      return this;
	    }
	    return cssClassDirectivesEnabledConfig;
	  };
	
	
	  /**
	   * The security context of DOM Properties.
	   * @private
	   */
	  var PROP_CONTEXTS = createMap();
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#addPropertySecurityContext
	   * @description
	   *
	   * Defines the security context for DOM properties bound by ng-prop-*.
	   *
	   * @param {string} elementName The element name or '*' to match any element.
	   * @param {string} propertyName The DOM property name.
	   * @param {string} ctx The {@link $sce} security context in which this value is safe for use, e.g. `$sce.URL`
	   * @returns {object} `this` for chaining
	   */
	  this.addPropertySecurityContext = function(elementName, propertyName, ctx) {
	    var key = (elementName.toLowerCase() + '|' + propertyName.toLowerCase());
	
	    if (key in PROP_CONTEXTS && PROP_CONTEXTS[key] !== ctx) {
	      throw $compileMinErr('ctxoverride', 'Property context \'{0}.{1}\' already set to \'{2}\', cannot override to \'{3}\'.', elementName, propertyName, PROP_CONTEXTS[key], ctx);
	    }
	
	    PROP_CONTEXTS[key] = ctx;
	    return this;
	  };
	
	  /* Default property contexts.
	   *
	   * Copy of https://github.com/angular/angular/blob/6.0.6/packages/compiler/src/schema/dom_security_schema.ts#L31-L58
	   * Changing:
	   * - SecurityContext.* => SCE_CONTEXTS/$sce.*
	   * - STYLE => CSS
	   * - various URL => MEDIA_URL
	   * - *|formAction, form|action URL => RESOURCE_URL (like the attribute)
	   */
	  (function registerNativePropertyContexts() {
	    function registerContext(ctx, values) {
	      forEach(values, function(v) { PROP_CONTEXTS[v.toLowerCase()] = ctx; });
	    }
	
	    registerContext(SCE_CONTEXTS.HTML, [
	      'iframe|srcdoc',
	      '*|innerHTML',
	      '*|outerHTML'
	    ]);
	    registerContext(SCE_CONTEXTS.CSS, ['*|style']);
	    registerContext(SCE_CONTEXTS.URL, [
	      'area|href',       'area|ping',
	      'a|href',          'a|ping',
	      'blockquote|cite',
	      'body|background',
	      'del|cite',
	      'input|src',
	      'ins|cite',
	      'q|cite'
	    ]);
	    registerContext(SCE_CONTEXTS.MEDIA_URL, [
	      'audio|src',
	      'img|src',    'img|srcset',
	      'source|src', 'source|srcset',
	      'track|src',
	      'video|src',  'video|poster'
	    ]);
	    registerContext(SCE_CONTEXTS.RESOURCE_URL, [
	      '*|formAction',
	      'applet|code',      'applet|codebase',
	      'base|href',
	      'embed|src',
	      'frame|src',
	      'form|action',
	      'head|profile',
	      'html|manifest',
	      'iframe|src',
	      'link|href',
	      'media|src',
	      'object|codebase',  'object|data',
	      'script|src'
	    ]);
	  })();
	
	
	  this.$get = [
	            '$injector', '$interpolate', '$exceptionHandler', '$templateRequest', '$parse',
	            '$controller', '$rootScope', '$sce', '$animate',
	    function($injector,   $interpolate,   $exceptionHandler,   $templateRequest,   $parse,
	             $controller,   $rootScope,   $sce,   $animate) {
	
	    var SIMPLE_ATTR_NAME = /^\w/;
	    var specialAttrHolder = window.document.createElement('div');
	
	
	    var commentDirectivesEnabled = commentDirectivesEnabledConfig;
	    var cssClassDirectivesEnabled = cssClassDirectivesEnabledConfig;
	
	
	    var onChangesTtl = TTL;
	    // The onChanges hooks should all be run together in a single digest
	    // When changes occur, the call to trigger their hooks will be added to this queue
	    var onChangesQueue;
	
	    // This function is called in a $$postDigest to trigger all the onChanges hooks in a single digest
	    function flushOnChangesQueue() {
	      try {
	        if (!(--onChangesTtl)) {
	          // We have hit the TTL limit so reset everything
	          onChangesQueue = undefined;
	          throw $compileMinErr('infchng', '{0} $onChanges() iterations reached. Aborting!\n', TTL);
	        }
	        // We must run this hook in an apply since the $$postDigest runs outside apply
	        $rootScope.$apply(function() {
	          for (var i = 0, ii = onChangesQueue.length; i < ii; ++i) {
	            try {
	              onChangesQueue[i]();
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	          // Reset the queue to trigger a new schedule next time there is a change
	          onChangesQueue = undefined;
	        });
	      } finally {
	        onChangesTtl++;
	      }
	    }
	
	
	    function sanitizeSrcset(value, invokeType) {
	      if (!value) {
	        return value;
	      }
	      if (!isString(value)) {
	        throw $compileMinErr('srcset', 'Can\'t pass trusted values to `{0}`: "{1}"', invokeType, value.toString());
	      }
	
	      // Such values are a bit too complex to handle automatically inside $sce.
	      // Instead, we sanitize each of the URIs individually, which works, even dynamically.
	
	      // It's not possible to work around this using `$sce.trustAsMediaUrl`.
	      // If you want to programmatically set explicitly trusted unsafe URLs, you should use
	      // `$sce.trustAsHtml` on the whole `img` tag and inject it into the DOM using the
	      // `ng-bind-html` directive.
	
	      var result = '';
	
	      // first check if there are spaces because it's not the same pattern
	      var trimmedSrcset = trim(value);
	      //                (   999x   ,|   999w   ,|   ,|,   )
	      var srcPattern = /(\s+\d+x\s*,|\s+\d+w\s*,|\s+,|,\s+)/;
	      var pattern = /\s/.test(trimmedSrcset) ? srcPattern : /(,)/;
	
	      // split srcset into tuple of uri and descriptor except for the last item
	      var rawUris = trimmedSrcset.split(pattern);
	
	      // for each tuples
	      var nbrUrisWith2parts = Math.floor(rawUris.length / 2);
	      for (var i = 0; i < nbrUrisWith2parts; i++) {
	        var innerIdx = i * 2;
	        // sanitize the uri
	        result += $sce.getTrustedMediaUrl(trim(rawUris[innerIdx]));
	        // add the descriptor
	        result += ' ' + trim(rawUris[innerIdx + 1]);
	      }
	
	      // split the last item into uri and descriptor
	      var lastTuple = trim(rawUris[i * 2]).split(/\s/);
	
	      // sanitize the last uri
	      result += $sce.getTrustedMediaUrl(trim(lastTuple[0]));
	
	      // and add the last descriptor if any
	      if (lastTuple.length === 2) {
	        result += (' ' + trim(lastTuple[1]));
	      }
	      return result;
	    }
	
	
	    function Attributes(element, attributesToCopy) {
	      if (attributesToCopy) {
	        var keys = Object.keys(attributesToCopy);
	        var i, l, key;
	
	        for (i = 0, l = keys.length; i < l; i++) {
	          key = keys[i];
	          this[key] = attributesToCopy[key];
	        }
	      } else {
	        this.$attr = {};
	      }
	
	      this.$$element = element;
	    }
	
	    Attributes.prototype = {
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$normalize
	       * @kind function
	       *
	       * @description
	       * Converts an attribute name (e.g. dash/colon/underscore-delimited string, optionally prefixed with `x-` or
	       * `data-`) to its normalized, camelCase form.
	       *
	       * Also there is special case for Moz prefix starting with upper case letter.
	       *
	       * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}
	       *
	       * @param {string} name Name to normalize
	       */
	      $normalize: directiveNormalize,
	
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$addClass
	       * @kind function
	       *
	       * @description
	       * Adds the CSS class value specified by the classVal parameter to the element. If animations
	       * are enabled then an animation will be triggered for the class addition.
	       *
	       * @param {string} classVal The className value that will be added to the element
	       */
	      $addClass: function(classVal) {
	        if (classVal && classVal.length > 0) {
	          $animate.addClass(this.$$element, classVal);
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$removeClass
	       * @kind function
	       *
	       * @description
	       * Removes the CSS class value specified by the classVal parameter from the element. If
	       * animations are enabled then an animation will be triggered for the class removal.
	       *
	       * @param {string} classVal The className value that will be removed from the element
	       */
	      $removeClass: function(classVal) {
	        if (classVal && classVal.length > 0) {
	          $animate.removeClass(this.$$element, classVal);
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$updateClass
	       * @kind function
	       *
	       * @description
	       * Adds and removes the appropriate CSS class values to the element based on the difference
	       * between the new and old CSS class values (specified as newClasses and oldClasses).
	       *
	       * @param {string} newClasses The current CSS className value
	       * @param {string} oldClasses The former CSS className value
	       */
	      $updateClass: function(newClasses, oldClasses) {
	        var toAdd = tokenDifference(newClasses, oldClasses);
	        if (toAdd && toAdd.length) {
	          $animate.addClass(this.$$element, toAdd);
	        }
	
	        var toRemove = tokenDifference(oldClasses, newClasses);
	        if (toRemove && toRemove.length) {
	          $animate.removeClass(this.$$element, toRemove);
	        }
	      },
	
	      /**
	       * Set a normalized attribute on the element in a way such that all directives
	       * can share the attribute. This function properly handles boolean attributes.
	       * @param {string} key Normalized key. (ie ngAttribute)
	       * @param {string|boolean} value The value to set. If `null` attribute will be deleted.
	       * @param {boolean=} writeAttr If false, does not write the value to DOM element attribute.
	       *     Defaults to true.
	       * @param {string=} attrName Optional none normalized name. Defaults to key.
	       */
	      $set: function(key, value, writeAttr, attrName) {
	        // TODO: decide whether or not to throw an error if "class"
	        // is set through this function since it may cause $updateClass to
	        // become unstable.
	
	        var node = this.$$element[0],
	            booleanKey = getBooleanAttrName(node, key),
	            aliasedKey = getAliasedAttrName(key),
	            observer = key,
	            nodeName;
	
	        if (booleanKey) {
	          this.$$element.prop(key, value);
	          attrName = booleanKey;
	        } else if (aliasedKey) {
	          this[aliasedKey] = value;
	          observer = aliasedKey;
	        }
	
	        this[key] = value;
	
	        // translate normalized key to actual key
	        if (attrName) {
	          this.$attr[key] = attrName;
	        } else {
	          attrName = this.$attr[key];
	          if (!attrName) {
	            this.$attr[key] = attrName = snake_case(key, '-');
	          }
	        }
	
	        nodeName = nodeName_(this.$$element);
	
	        // Sanitize img[srcset] values.
	        if (nodeName === 'img' && key === 'srcset') {
	          this[key] = value = sanitizeSrcset(value, '$set(\'srcset\', value)');
	        }
	
	        if (writeAttr !== false) {
	          if (value === null || isUndefined(value)) {
	            this.$$element.removeAttr(attrName);
	          } else {
	            if (SIMPLE_ATTR_NAME.test(attrName)) {
	              // jQuery skips special boolean attrs treatment in XML nodes for
	              // historical reasons and hence AngularJS cannot freely call
	              // `.attr(attrName, false) with such attributes. To avoid issues
	              // in XHTML, call `removeAttr` in such cases instead.
	              // See https://github.com/jquery/jquery/issues/4249
	              if (booleanKey && value === false) {
	                this.$$element.removeAttr(attrName);
	              } else {
	                this.$$element.attr(attrName, value);
	              }
	            } else {
	              setSpecialAttr(this.$$element[0], attrName, value);
	            }
	          }
	        }
	
	        // fire observers
	        var $$observers = this.$$observers;
	        if ($$observers) {
	          forEach($$observers[observer], function(fn) {
	            try {
	              fn(value);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          });
	        }
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$observe
	       * @kind function
	       *
	       * @description
	       * Observes an interpolated attribute.
	       *
	       * The observer function will be invoked once during the next `$digest` following
	       * compilation. The observer is then invoked whenever the interpolated value
	       * changes.
	       *
	       * @param {string} key Normalized key. (ie ngAttribute) .
	       * @param {function(interpolatedValue)} fn Function that will be called whenever
	                the interpolated value of the attribute changes.
	       *        See the {@link guide/interpolation#how-text-and-attribute-bindings-work Interpolation
	       *        guide} for more info.
	       * @returns {function()} Returns a deregistration function for this observer.
	       */
	      $observe: function(key, fn) {
	        var attrs = this,
	            $$observers = (attrs.$$observers || (attrs.$$observers = createMap())),
	            listeners = ($$observers[key] || ($$observers[key] = []));
	
	        listeners.push(fn);
	        $rootScope.$evalAsync(function() {
	          if (!listeners.$$inter && attrs.hasOwnProperty(key) && !isUndefined(attrs[key])) {
	            // no one registered attribute interpolation function, so lets call it manually
	            fn(attrs[key]);
	          }
	        });
	
	        return function() {
	          arrayRemove(listeners, fn);
	        };
	      }
	    };
	
	    function setSpecialAttr(element, attrName, value) {
	      // Attributes names that do not start with letters (such as `(click)`) cannot be set using `setAttribute`
	      // so we have to jump through some hoops to get such an attribute
	      // https://github.com/angular/angular.js/pull/13318
	      specialAttrHolder.innerHTML = '<span ' + attrName + '>';
	      var attributes = specialAttrHolder.firstChild.attributes;
	      var attribute = attributes[0];
	      // We have to remove the attribute from its container element before we can add it to the destination element
	      attributes.removeNamedItem(attribute.name);
	      attribute.value = value;
	      element.attributes.setNamedItem(attribute);
	    }
	
	    function safeAddClass($element, className) {
	      try {
	        $element.addClass(className);
	      } catch (e) {
	        // ignore, since it means that we are trying to set class on
	        // SVG element, where class name is read-only.
	      }
	    }
	
	
	    var startSymbol = $interpolate.startSymbol(),
	        endSymbol = $interpolate.endSymbol(),
	        denormalizeTemplate = (startSymbol === '{{' && endSymbol  === '}}')
	            ? identity
	            : function denormalizeTemplate(template) {
	              return template.replace(/\{\{/g, startSymbol).replace(/}}/g, endSymbol);
	        },
	        NG_PREFIX_BINDING = /^ng(Attr|Prop|On)([A-Z].*)$/;
	    var MULTI_ELEMENT_DIR_RE = /^(.+)Start$/;
	
	    compile.$$addBindingInfo = debugInfoEnabled ? function $$addBindingInfo($element, binding) {
	      var bindings = $element.data('$binding') || [];
	
	      if (isArray(binding)) {
	        bindings = bindings.concat(binding);
	      } else {
	        bindings.push(binding);
	      }
	
	      $element.data('$binding', bindings);
	    } : noop;
	
	    compile.$$addBindingClass = debugInfoEnabled ? function $$addBindingClass($element) {
	      safeAddClass($element, 'ng-binding');
	    } : noop;
	
	    compile.$$addScopeInfo = debugInfoEnabled ? function $$addScopeInfo($element, scope, isolated, noTemplate) {
	      var dataName = isolated ? (noTemplate ? '$isolateScopeNoTemplate' : '$isolateScope') : '$scope';
	      $element.data(dataName, scope);
	    } : noop;
	
	    compile.$$addScopeClass = debugInfoEnabled ? function $$addScopeClass($element, isolated) {
	      safeAddClass($element, isolated ? 'ng-isolate-scope' : 'ng-scope');
	    } : noop;
	
	    compile.$$createComment = function(directiveName, comment) {
	      var content = '';
	      if (debugInfoEnabled) {
	        content = ' ' + (directiveName || '') + ': ';
	        if (comment) content += comment + ' ';
	      }
	      return window.document.createComment(content);
	    };
	
	    return compile;
	
	    //================================
	
	    function compile($compileNodes, transcludeFn, maxPriority, ignoreDirective,
	                        previousCompileContext) {
	      if (!($compileNodes instanceof jqLite)) {
	        // jquery always rewraps, whereas we need to preserve the original selector so that we can
	        // modify it.
	        $compileNodes = jqLite($compileNodes);
	      }
	      var compositeLinkFn =
	              compileNodes($compileNodes, transcludeFn, $compileNodes,
	                           maxPriority, ignoreDirective, previousCompileContext);
	      compile.$$addScopeClass($compileNodes);
	      var namespace = null;
	      return function publicLinkFn(scope, cloneConnectFn, options) {
	        if (!$compileNodes) {
	          throw $compileMinErr('multilink', 'This element has already been linked.');
	        }
	        assertArg(scope, 'scope');
	
	        if (previousCompileContext && previousCompileContext.needsNewScope) {
	          // A parent directive did a replace and a directive on this element asked
	          // for transclusion, which caused us to lose a layer of element on which
	          // we could hold the new transclusion scope, so we will create it manually
	          // here.
	          scope = scope.$parent.$new();
	        }
	
	        options = options || {};
	        var parentBoundTranscludeFn = options.parentBoundTranscludeFn,
	          transcludeControllers = options.transcludeControllers,
	          futureParentElement = options.futureParentElement;
	
	        // When `parentBoundTranscludeFn` is passed, it is a
	        // `controllersBoundTransclude` function (it was previously passed
	        // as `transclude` to directive.link) so we must unwrap it to get
	        // its `boundTranscludeFn`
	        if (parentBoundTranscludeFn && parentBoundTranscludeFn.$$boundTransclude) {
	          parentBoundTranscludeFn = parentBoundTranscludeFn.$$boundTransclude;
	        }
	
	        if (!namespace) {
	          namespace = detectNamespaceForChildElements(futureParentElement);
	        }
	        var $linkNode;
	        if (namespace !== 'html') {
	          // When using a directive with replace:true and templateUrl the $compileNodes
	          // (or a child element inside of them)
	          // might change, so we need to recreate the namespace adapted compileNodes
	          // for call to the link function.
	          // Note: This will already clone the nodes...
	          $linkNode = jqLite(
	            wrapTemplate(namespace, jqLite('<div></div>').append($compileNodes).html())
	          );
	        } else if (cloneConnectFn) {
	          // important!!: we must call our jqLite.clone() since the jQuery one is trying to be smart
	          // and sometimes changes the structure of the DOM.
	          $linkNode = JQLitePrototype.clone.call($compileNodes);
	        } else {
	          $linkNode = $compileNodes;
	        }
	
	        if (transcludeControllers) {
	          for (var controllerName in transcludeControllers) {
	            $linkNode.data('$' + controllerName + 'Controller', transcludeControllers[controllerName].instance);
	          }
	        }
	
	        compile.$$addScopeInfo($linkNode, scope);
	
	        if (cloneConnectFn) cloneConnectFn($linkNode, scope);
	        if (compositeLinkFn) compositeLinkFn(scope, $linkNode, $linkNode, parentBoundTranscludeFn);
	
	        if (!cloneConnectFn) {
	          $compileNodes = compositeLinkFn = null;
	        }
	        return $linkNode;
	      };
	    }
	
	    function detectNamespaceForChildElements(parentElement) {
	      // TODO: Make this detect MathML as well...
	      var node = parentElement && parentElement[0];
	      if (!node) {
	        return 'html';
	      } else {
	        return nodeName_(node) !== 'foreignobject' && toString.call(node).match(/SVG/) ? 'svg' : 'html';
	      }
	    }
	
	    /**
	     * Compile function matches each node in nodeList against the directives. Once all directives
	     * for a particular node are collected their compile functions are executed. The compile
	     * functions return values - the linking functions - are combined into a composite linking
	     * function, which is the a linking function for the node.
	     *
	     * @param {NodeList} nodeList an array of nodes or NodeList to compile
	     * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
	     *        scope argument is auto-generated to the new child of the transcluded parent scope.
	     * @param {DOMElement=} $rootElement If the nodeList is the root of the compilation tree then
	     *        the rootElement must be set the jqLite collection of the compile root. This is
	     *        needed so that the jqLite collection items can be replaced with widgets.
	     * @param {number=} maxPriority Max directive priority.
	     * @returns {Function} A composite linking function of all of the matched directives or null.
	     */
	    function compileNodes(nodeList, transcludeFn, $rootElement, maxPriority, ignoreDirective,
	                            previousCompileContext) {
	      var linkFns = [],
	          // `nodeList` can be either an element's `.childNodes` (live NodeList)
	          // or a jqLite/jQuery collection or an array
	          notLiveList = isArray(nodeList) || (nodeList instanceof jqLite),
	          attrs, directives, nodeLinkFn, childNodes, childLinkFn, linkFnFound, nodeLinkFnFound;
	
	
	      for (var i = 0; i < nodeList.length; i++) {
	        attrs = new Attributes();
	
	        // Support: IE 11 only
	        // Workaround for #11781 and #14924
	        if (msie === 11) {
	          mergeConsecutiveTextNodes(nodeList, i, notLiveList);
	        }
	
	        // We must always refer to `nodeList[i]` hereafter,
	        // since the nodes can be replaced underneath us.
	        directives = collectDirectives(nodeList[i], [], attrs, i === 0 ? maxPriority : undefined,
	                                        ignoreDirective);
	
	        nodeLinkFn = (directives.length)
	            ? applyDirectivesToNode(directives, nodeList[i], attrs, transcludeFn, $rootElement,
	                                      null, [], [], previousCompileContext)
	            : null;
	
	        if (nodeLinkFn && nodeLinkFn.scope) {
	          compile.$$addScopeClass(attrs.$$element);
	        }
	
	        childLinkFn = (nodeLinkFn && nodeLinkFn.terminal ||
	                      !(childNodes = nodeList[i].childNodes) ||
	                      !childNodes.length)
	            ? null
	            : compileNodes(childNodes,
	                 nodeLinkFn ? (
	                  (nodeLinkFn.transcludeOnThisElement || !nodeLinkFn.templateOnThisElement)
	                     && nodeLinkFn.transclude) : transcludeFn);
	
	        if (nodeLinkFn || childLinkFn) {
	          linkFns.push(i, nodeLinkFn, childLinkFn);
	          linkFnFound = true;
	          nodeLinkFnFound = nodeLinkFnFound || nodeLinkFn;
	        }
	
	        //use the previous context only for the first element in the virtual group
	        previousCompileContext = null;
	      }
	
	      // return a linking function if we have found anything, null otherwise
	      return linkFnFound ? compositeLinkFn : null;
	
	      function compositeLinkFn(scope, nodeList, $rootElement, parentBoundTranscludeFn) {
	        var nodeLinkFn, childLinkFn, node, childScope, i, ii, idx, childBoundTranscludeFn;
	        var stableNodeList;
	
	
	        if (nodeLinkFnFound) {
	          // copy nodeList so that if a nodeLinkFn removes or adds an element at this DOM level our
	          // offsets don't get screwed up
	          var nodeListLength = nodeList.length;
	          stableNodeList = new Array(nodeListLength);
	
	          // create a sparse array by only copying the elements which have a linkFn
	          for (i = 0; i < linkFns.length; i += 3) {
	            idx = linkFns[i];
	            stableNodeList[idx] = nodeList[idx];
	          }
	        } else {
	          stableNodeList = nodeList;
	        }
	
	        for (i = 0, ii = linkFns.length; i < ii;) {
	          node = stableNodeList[linkFns[i++]];
	          nodeLinkFn = linkFns[i++];
	          childLinkFn = linkFns[i++];
	
	          if (nodeLinkFn) {
	            if (nodeLinkFn.scope) {
	              childScope = scope.$new();
	              compile.$$addScopeInfo(jqLite(node), childScope);
	            } else {
	              childScope = scope;
	            }
	
	            if (nodeLinkFn.transcludeOnThisElement) {
	              childBoundTranscludeFn = createBoundTranscludeFn(
	                  scope, nodeLinkFn.transclude, parentBoundTranscludeFn);
	
	            } else if (!nodeLinkFn.templateOnThisElement && parentBoundTranscludeFn) {
	              childBoundTranscludeFn = parentBoundTranscludeFn;
	
	            } else if (!parentBoundTranscludeFn && transcludeFn) {
	              childBoundTranscludeFn = createBoundTranscludeFn(scope, transcludeFn);
	
	            } else {
	              childBoundTranscludeFn = null;
	            }
	
	            nodeLinkFn(childLinkFn, childScope, node, $rootElement, childBoundTranscludeFn);
	
	          } else if (childLinkFn) {
	            childLinkFn(scope, node.childNodes, undefined, parentBoundTranscludeFn);
	          }
	        }
	      }
	    }
	
	    function mergeConsecutiveTextNodes(nodeList, idx, notLiveList) {
	      var node = nodeList[idx];
	      var parent = node.parentNode;
	      var sibling;
	
	      if (node.nodeType !== NODE_TYPE_TEXT) {
	        return;
	      }
	
	      while (true) {
	        sibling = parent ? node.nextSibling : nodeList[idx + 1];
	        if (!sibling || sibling.nodeType !== NODE_TYPE_TEXT) {
	          break;
	        }
	
	        node.nodeValue = node.nodeValue + sibling.nodeValue;
	
	        if (sibling.parentNode) {
	          sibling.parentNode.removeChild(sibling);
	        }
	        if (notLiveList && sibling === nodeList[idx + 1]) {
	          nodeList.splice(idx + 1, 1);
	        }
	      }
	    }
	
	    function createBoundTranscludeFn(scope, transcludeFn, previousBoundTranscludeFn) {
	      function boundTranscludeFn(transcludedScope, cloneFn, controllers, futureParentElement, containingScope) {
	
	        if (!transcludedScope) {
	          transcludedScope = scope.$new(false, containingScope);
	          transcludedScope.$$transcluded = true;
	        }
	
	        return transcludeFn(transcludedScope, cloneFn, {
	          parentBoundTranscludeFn: previousBoundTranscludeFn,
	          transcludeControllers: controllers,
	          futureParentElement: futureParentElement
	        });
	      }
	
	      // We need  to attach the transclusion slots onto the `boundTranscludeFn`
	      // so that they are available inside the `controllersBoundTransclude` function
	      var boundSlots = boundTranscludeFn.$$slots = createMap();
	      for (var slotName in transcludeFn.$$slots) {
	        if (transcludeFn.$$slots[slotName]) {
	          boundSlots[slotName] = createBoundTranscludeFn(scope, transcludeFn.$$slots[slotName], previousBoundTranscludeFn);
	        } else {
	          boundSlots[slotName] = null;
	        }
	      }
	
	      return boundTranscludeFn;
	    }
	
	    /**
	     * Looks for directives on the given node and adds them to the directive collection which is
	     * sorted.
	     *
	     * @param node Node to search.
	     * @param directives An array to which the directives are added to. This array is sorted before
	     *        the function returns.
	     * @param attrs The shared attrs object which is used to populate the normalized attributes.
	     * @param {number=} maxPriority Max directive priority.
	     */
	    function collectDirectives(node, directives, attrs, maxPriority, ignoreDirective) {
	      var nodeType = node.nodeType,
	          attrsMap = attrs.$attr,
	          match,
	          nodeName,
	          className;
	
	      switch (nodeType) {
	        case NODE_TYPE_ELEMENT: /* Element */
	
	          nodeName = nodeName_(node);
	
	          // use the node name: <directive>
	          addDirective(directives,
	              directiveNormalize(nodeName), 'E', maxPriority, ignoreDirective);
	
	          // iterate over the attributes
	          for (var attr, name, nName, value, ngPrefixMatch, nAttrs = node.attributes,
	                   j = 0, jj = nAttrs && nAttrs.length; j < jj; j++) {
	            var attrStartName = false;
	            var attrEndName = false;
	
	            var isNgAttr = false, isNgProp = false, isNgEvent = false;
	            var multiElementMatch;
	
	            attr = nAttrs[j];
	            name = attr.name;
	            value = attr.value;
	
	            nName = directiveNormalize(name.toLowerCase());
	
	            // Support ng-attr-*, ng-prop-* and ng-on-*
	            if ((ngPrefixMatch = nName.match(NG_PREFIX_BINDING))) {
	              isNgAttr = ngPrefixMatch[1] === 'Attr';
	              isNgProp = ngPrefixMatch[1] === 'Prop';
	              isNgEvent = ngPrefixMatch[1] === 'On';
	
	              // Normalize the non-prefixed name
	              name = name.replace(PREFIX_REGEXP, '')
	                .toLowerCase()
	                .substr(4 + ngPrefixMatch[1].length).replace(/_(.)/g, function(match, letter) {
	                  return letter.toUpperCase();
	                });
	
	            // Support *-start / *-end multi element directives
	            } else if ((multiElementMatch = nName.match(MULTI_ELEMENT_DIR_RE)) && directiveIsMultiElement(multiElementMatch[1])) {
	              attrStartName = name;
	              attrEndName = name.substr(0, name.length - 5) + 'end';
	              name = name.substr(0, name.length - 6);
	            }
	
	            if (isNgProp || isNgEvent) {
	              attrs[nName] = value;
	              attrsMap[nName] = attr.name;
	
	              if (isNgProp) {
	                addPropertyDirective(node, directives, nName, name);
	              } else {
	                addEventDirective(directives, nName, name);
	              }
	            } else {
	              // Update nName for cases where a prefix was removed
	              // NOTE: the .toLowerCase() is unnecessary and causes https://github.com/angular/angular.js/issues/16624 for ng-attr-*
	              nName = directiveNormalize(name.toLowerCase());
	              attrsMap[nName] = name;
	
	              if (isNgAttr || !attrs.hasOwnProperty(nName)) {
	                attrs[nName] = value;
	                if (getBooleanAttrName(node, nName)) {
	                  attrs[nName] = true; // presence means true
	                }
	              }
	
	              addAttrInterpolateDirective(node, directives, value, nName, isNgAttr);
	              addDirective(directives, nName, 'A', maxPriority, ignoreDirective, attrStartName,
	                            attrEndName);
	            }
	          }
	
	          if (nodeName === 'input' && node.getAttribute('type') === 'hidden') {
	            // Hidden input elements can have strange behaviour when navigating back to the page
	            // This tells the browser not to try to cache and reinstate previous values
	            node.setAttribute('autocomplete', 'off');
	          }
	
	          // use class as directive
	          if (!cssClassDirectivesEnabled) break;
	          className = node.className;
	          if (isObject(className)) {
	              // Maybe SVGAnimatedString
	              className = className.animVal;
	          }
	          if (isString(className) && className !== '') {
	            while ((match = CLASS_DIRECTIVE_REGEXP.exec(className))) {
	              nName = directiveNormalize(match[2]);
	              if (addDirective(directives, nName, 'C', maxPriority, ignoreDirective)) {
	                attrs[nName] = trim(match[3]);
	              }
	              className = className.substr(match.index + match[0].length);
	            }
	          }
	          break;
	        case NODE_TYPE_TEXT: /* Text Node */
	          addTextInterpolateDirective(directives, node.nodeValue);
	          break;
	        case NODE_TYPE_COMMENT: /* Comment */
	          if (!commentDirectivesEnabled) break;
	          collectCommentDirectives(node, directives, attrs, maxPriority, ignoreDirective);
	          break;
	      }
	
	      directives.sort(byPriority);
	      return directives;
	    }
	
	    function collectCommentDirectives(node, directives, attrs, maxPriority, ignoreDirective) {
	      // function created because of performance, try/catch disables
	      // the optimization of the whole function #14848
	      try {
	        var match = COMMENT_DIRECTIVE_REGEXP.exec(node.nodeValue);
	        if (match) {
	          var nName = directiveNormalize(match[1]);
	          if (addDirective(directives, nName, 'M', maxPriority, ignoreDirective)) {
	            attrs[nName] = trim(match[2]);
	          }
	        }
	      } catch (e) {
	        // turns out that under some circumstances IE9 throws errors when one attempts to read
	        // comment's node value.
	        // Just ignore it and continue. (Can't seem to reproduce in test case.)
	      }
	    }
	
	    /**
	     * Given a node with a directive-start it collects all of the siblings until it finds
	     * directive-end.
	     * @param node
	     * @param attrStart
	     * @param attrEnd
	     * @returns {*}
	     */
	    function groupScan(node, attrStart, attrEnd) {
	      var nodes = [];
	      var depth = 0;
	      if (attrStart && node.hasAttribute && node.hasAttribute(attrStart)) {
	        do {
	          if (!node) {
	            throw $compileMinErr('uterdir',
	                      'Unterminated attribute, found \'{0}\' but no matching \'{1}\' found.',
	                      attrStart, attrEnd);
	          }
	          if (node.nodeType === NODE_TYPE_ELEMENT) {
	            if (node.hasAttribute(attrStart)) depth++;
	            if (node.hasAttribute(attrEnd)) depth--;
	          }
	          nodes.push(node);
	          node = node.nextSibling;
	        } while (depth > 0);
	      } else {
	        nodes.push(node);
	      }
	
	      return jqLite(nodes);
	    }
	
	    /**
	     * Wrapper for linking function which converts normal linking function into a grouped
	     * linking function.
	     * @param linkFn
	     * @param attrStart
	     * @param attrEnd
	     * @returns {Function}
	     */
	    function groupElementsLinkFnWrapper(linkFn, attrStart, attrEnd) {
	      return function groupedElementsLink(scope, element, attrs, controllers, transcludeFn) {
	        element = groupScan(element[0], attrStart, attrEnd);
	        return linkFn(scope, element, attrs, controllers, transcludeFn);
	      };
	    }
	
	    /**
	     * A function generator that is used to support both eager and lazy compilation
	     * linking function.
	     * @param eager
	     * @param $compileNodes
	     * @param transcludeFn
	     * @param maxPriority
	     * @param ignoreDirective
	     * @param previousCompileContext
	     * @returns {Function}
	     */
	    function compilationGenerator(eager, $compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext) {
	      var compiled;
	
	      if (eager) {
	        return compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext);
	      }
	      return /** @this */ function lazyCompilation() {
	        if (!compiled) {
	          compiled = compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext);
	
	          // Null out all of these references in order to make them eligible for garbage collection
	          // since this is a potentially long lived closure
	          $compileNodes = transcludeFn = previousCompileContext = null;
	        }
	        return compiled.apply(this, arguments);
	      };
	    }
	
	    /**
	     * Once the directives have been collected, their compile functions are executed. This method
	     * is responsible for inlining directive templates as well as terminating the application
	     * of the directives if the terminal directive has been reached.
	     *
	     * @param {Array} directives Array of collected directives to execute their compile function.
	     *        this needs to be pre-sorted by priority order.
	     * @param {Node} compileNode The raw DOM node to apply the compile functions to
	     * @param {Object} templateAttrs The shared attribute function
	     * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
	     *                                                  scope argument is auto-generated to the new
	     *                                                  child of the transcluded parent scope.
	     * @param {JQLite} jqCollection If we are working on the root of the compile tree then this
	     *                              argument has the root jqLite array so that we can replace nodes
	     *                              on it.
	     * @param {Object=} originalReplaceDirective An optional directive that will be ignored when
	     *                                           compiling the transclusion.
	     * @param {Array.<Function>} preLinkFns
	     * @param {Array.<Function>} postLinkFns
	     * @param {Object} previousCompileContext Context used for previous compilation of the current
	     *                                        node
	     * @returns {Function} linkFn
	     */
	    function applyDirectivesToNode(directives, compileNode, templateAttrs, transcludeFn,
	                                   jqCollection, originalReplaceDirective, preLinkFns, postLinkFns,
	                                   previousCompileContext) {
	      previousCompileContext = previousCompileContext || {};
	
	      var terminalPriority = -Number.MAX_VALUE,
	          newScopeDirective = previousCompileContext.newScopeDirective,
	          controllerDirectives = previousCompileContext.controllerDirectives,
	          newIsolateScopeDirective = previousCompileContext.newIsolateScopeDirective,
	          templateDirective = previousCompileContext.templateDirective,
	          nonTlbTranscludeDirective = previousCompileContext.nonTlbTranscludeDirective,
	          hasTranscludeDirective = false,
	          hasTemplate = false,
	          hasElementTranscludeDirective = previousCompileContext.hasElementTranscludeDirective,
	          $compileNode = templateAttrs.$$element = jqLite(compileNode),
	          directive,
	          directiveName,
	          $template,
	          replaceDirective = originalReplaceDirective,
	          childTranscludeFn = transcludeFn,
	          linkFn,
	          didScanForMultipleTransclusion = false,
	          mightHaveMultipleTransclusionError = false,
	          directiveValue;
	
	      // executes all directives on the current element
	      for (var i = 0, ii = directives.length; i < ii; i++) {
	        directive = directives[i];
	        var attrStart = directive.$$start;
	        var attrEnd = directive.$$end;
	
	        // collect multiblock sections
	        if (attrStart) {
	          $compileNode = groupScan(compileNode, attrStart, attrEnd);
	        }
	        $template = undefined;
	
	        if (terminalPriority > directive.priority) {
	          break; // prevent further processing of directives
	        }
	
	        directiveValue = directive.scope;
	
	        if (directiveValue) {
	
	          // skip the check for directives with async templates, we'll check the derived sync
	          // directive when the template arrives
	          if (!directive.templateUrl) {
	            if (isObject(directiveValue)) {
	              // This directive is trying to add an isolated scope.
	              // Check that there is no scope of any kind already
	              assertNoDuplicate('new/isolated scope', newIsolateScopeDirective || newScopeDirective,
	                                directive, $compileNode);
	              newIsolateScopeDirective = directive;
	            } else {
	              // This directive is trying to add a child scope.
	              // Check that there is no isolated scope already
	              assertNoDuplicate('new/isolated scope', newIsolateScopeDirective, directive,
	                                $compileNode);
	            }
	          }
	
	          newScopeDirective = newScopeDirective || directive;
	        }
	
	        directiveName = directive.name;
	
	        // If we encounter a condition that can result in transclusion on the directive,
	        // then scan ahead in the remaining directives for others that may cause a multiple
	        // transclusion error to be thrown during the compilation process.  If a matching directive
	        // is found, then we know that when we encounter a transcluded directive, we need to eagerly
	        // compile the `transclude` function rather than doing it lazily in order to throw
	        // exceptions at the correct time
	        if (!didScanForMultipleTransclusion && ((directive.replace && (directive.templateUrl || directive.template))
	            || (directive.transclude && !directive.$$tlb))) {
	                var candidateDirective;
	
	                for (var scanningIndex = i + 1; (candidateDirective = directives[scanningIndex++]);) {
	                    if ((candidateDirective.transclude && !candidateDirective.$$tlb)
	                        || (candidateDirective.replace && (candidateDirective.templateUrl || candidateDirective.template))) {
	                        mightHaveMultipleTransclusionError = true;
	                        break;
	                    }
	                }
	
	                didScanForMultipleTransclusion = true;
	        }
	
	        if (!directive.templateUrl && directive.controller) {
	          controllerDirectives = controllerDirectives || createMap();
	          assertNoDuplicate('\'' + directiveName + '\' controller',
	              controllerDirectives[directiveName], directive, $compileNode);
	          controllerDirectives[directiveName] = directive;
	        }
	
	        directiveValue = directive.transclude;
	
	        if (directiveValue) {
	          hasTranscludeDirective = true;
	
	          // Special case ngIf and ngRepeat so that we don't complain about duplicate transclusion.
	          // This option should only be used by directives that know how to safely handle element transclusion,
	          // where the transcluded nodes are added or replaced after linking.
	          if (!directive.$$tlb) {
	            assertNoDuplicate('transclusion', nonTlbTranscludeDirective, directive, $compileNode);
	            nonTlbTranscludeDirective = directive;
	          }
	
	          if (directiveValue === 'element') {
	            hasElementTranscludeDirective = true;
	            terminalPriority = directive.priority;
	            $template = $compileNode;
	            $compileNode = templateAttrs.$$element =
	                jqLite(compile.$$createComment(directiveName, templateAttrs[directiveName]));
	            compileNode = $compileNode[0];
	            replaceWith(jqCollection, sliceArgs($template), compileNode);
	
	            childTranscludeFn = compilationGenerator(mightHaveMultipleTransclusionError, $template, transcludeFn, terminalPriority,
	                                        replaceDirective && replaceDirective.name, {
	                                          // Don't pass in:
	                                          // - controllerDirectives - otherwise we'll create duplicates controllers
	                                          // - newIsolateScopeDirective or templateDirective - combining templates with
	                                          //   element transclusion doesn't make sense.
	                                          //
	                                          // We need only nonTlbTranscludeDirective so that we prevent putting transclusion
	                                          // on the same element more than once.
	                                          nonTlbTranscludeDirective: nonTlbTranscludeDirective
	                                        });
	          } else {
	
	            var slots = createMap();
	
	            if (!isObject(directiveValue)) {
	              $template = jqLite(jqLiteClone(compileNode)).contents();
	            } else {
	
	              // We have transclusion slots,
	              // collect them up, compile them and store their transclusion functions
	              $template = window.document.createDocumentFragment();
	
	              var slotMap = createMap();
	              var filledSlots = createMap();
	
	              // Parse the element selectors
	              forEach(directiveValue, function(elementSelector, slotName) {
	                // If an element selector starts with a ? then it is optional
	                var optional = (elementSelector.charAt(0) === '?');
	                elementSelector = optional ? elementSelector.substring(1) : elementSelector;
	
	                slotMap[elementSelector] = slotName;
	
	                // We explicitly assign `null` since this implies that a slot was defined but not filled.
	                // Later when calling boundTransclusion functions with a slot name we only error if the
	                // slot is `undefined`
	                slots[slotName] = null;
	
	                // filledSlots contains `true` for all slots that are either optional or have been
	                // filled. This is used to check that we have not missed any required slots
	                filledSlots[slotName] = optional;
	              });
	
	              // Add the matching elements into their slot
	              forEach($compileNode.contents(), function(node) {
	                var slotName = slotMap[directiveNormalize(nodeName_(node))];
	                if (slotName) {
	                  filledSlots[slotName] = true;
	                  slots[slotName] = slots[slotName] || window.document.createDocumentFragment();
	                  slots[slotName].appendChild(node);
	                } else {
	                  $template.appendChild(node);
	                }
	              });
	
	              // Check for required slots that were not filled
	              forEach(filledSlots, function(filled, slotName) {
	                if (!filled) {
	                  throw $compileMinErr('reqslot', 'Required transclusion slot `{0}` was not filled.', slotName);
	                }
	              });
	
	              for (var slotName in slots) {
	                if (slots[slotName]) {
	                  // Only define a transclusion function if the slot was filled
	                  var slotCompileNodes = jqLite(slots[slotName].childNodes);
	                  slots[slotName] = compilationGenerator(mightHaveMultipleTransclusionError, slotCompileNodes, transcludeFn);
	                }
	              }
	
	              $template = jqLite($template.childNodes);
	            }
	
	            $compileNode.empty(); // clear contents
	            childTranscludeFn = compilationGenerator(mightHaveMultipleTransclusionError, $template, transcludeFn, undefined,
	                undefined, { needsNewScope: directive.$$isolateScope || directive.$$newScope});
	            childTranscludeFn.$$slots = slots;
	          }
	        }
	
	        if (directive.template) {
	          hasTemplate = true;
	          assertNoDuplicate('template', templateDirective, directive, $compileNode);
	          templateDirective = directive;
	
	          directiveValue = (isFunction(directive.template))
	              ? directive.template($compileNode, templateAttrs)
	              : directive.template;
	
	          directiveValue = denormalizeTemplate(directiveValue);
	
	          if (directive.replace) {
	            replaceDirective = directive;
	            if (jqLiteIsTextNode(directiveValue)) {
	              $template = [];
	            } else {
	              $template = removeComments(wrapTemplate(directive.templateNamespace, trim(directiveValue)));
	            }
	            compileNode = $template[0];
	
	            if ($template.length !== 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) {
	              throw $compileMinErr('tplrt',
	                  'Template for directive \'{0}\' must have exactly one root element. {1}',
	                  directiveName, '');
	            }
	
	            replaceWith(jqCollection, $compileNode, compileNode);
	
	            var newTemplateAttrs = {$attr: {}};
	
	            // combine directives from the original node and from the template:
	            // - take the array of directives for this element
	            // - split it into two parts, those that already applied (processed) and those that weren't (unprocessed)
	            // - collect directives from the template and sort them by priority
	            // - combine directives as: processed + template + unprocessed
	            var templateDirectives = collectDirectives(compileNode, [], newTemplateAttrs);
	            var unprocessedDirectives = directives.splice(i + 1, directives.length - (i + 1));
	
	            if (newIsolateScopeDirective || newScopeDirective) {
	              // The original directive caused the current element to be replaced but this element
	              // also needs to have a new scope, so we need to tell the template directives
	              // that they would need to get their scope from further up, if they require transclusion
	              markDirectiveScope(templateDirectives, newIsolateScopeDirective, newScopeDirective);
	            }
	            directives = directives.concat(templateDirectives).concat(unprocessedDirectives);
	            mergeTemplateAttributes(templateAttrs, newTemplateAttrs);
	
	            ii = directives.length;
	          } else {
	            $compileNode.html(directiveValue);
	          }
	        }
	
	        if (directive.templateUrl) {
	          hasTemplate = true;
	          assertNoDuplicate('template', templateDirective, directive, $compileNode);
	          templateDirective = directive;
	
	          if (directive.replace) {
	            replaceDirective = directive;
	          }
	
	          // eslint-disable-next-line no-func-assign
	          nodeLinkFn = compileTemplateUrl(directives.splice(i, directives.length - i), $compileNode,
	              templateAttrs, jqCollection, hasTranscludeDirective && childTranscludeFn, preLinkFns, postLinkFns, {
	                controllerDirectives: controllerDirectives,
	                newScopeDirective: (newScopeDirective !== directive) && newScopeDirective,
	                newIsolateScopeDirective: newIsolateScopeDirective,
	                templateDirective: templateDirective,
	                nonTlbTranscludeDirective: nonTlbTranscludeDirective
	              });
	          ii = directives.length;
	        } else if (directive.compile) {
	          try {
	            linkFn = directive.compile($compileNode, templateAttrs, childTranscludeFn);
	            var context = directive.$$originalDirective || directive;
	            if (isFunction(linkFn)) {
	              addLinkFns(null, bind(context, linkFn), attrStart, attrEnd);
	            } else if (linkFn) {
	              addLinkFns(bind(context, linkFn.pre), bind(context, linkFn.post), attrStart, attrEnd);
	            }
	          } catch (e) {
	            $exceptionHandler(e, startingTag($compileNode));
	          }
	        }
	
	        if (directive.terminal) {
	          nodeLinkFn.terminal = true;
	          terminalPriority = Math.max(terminalPriority, directive.priority);
	        }
	
	      }
	
	      nodeLinkFn.scope = newScopeDirective && newScopeDirective.scope === true;
	      nodeLinkFn.transcludeOnThisElement = hasTranscludeDirective;
	      nodeLinkFn.templateOnThisElement = hasTemplate;
	      nodeLinkFn.transclude = childTranscludeFn;
	
	      previousCompileContext.hasElementTranscludeDirective = hasElementTranscludeDirective;
	
	      // might be normal or delayed nodeLinkFn depending on if templateUrl is present
	      return nodeLinkFn;
	
	      ////////////////////
	
	      function addLinkFns(pre, post, attrStart, attrEnd) {
	        if (pre) {
	          if (attrStart) pre = groupElementsLinkFnWrapper(pre, attrStart, attrEnd);
	          pre.require = directive.require;
	          pre.directiveName = directiveName;
	          if (newIsolateScopeDirective === directive || directive.$$isolateScope) {
	            pre = cloneAndAnnotateFn(pre, {isolateScope: true});
	          }
	          preLinkFns.push(pre);
	        }
	        if (post) {
	          if (attrStart) post = groupElementsLinkFnWrapper(post, attrStart, attrEnd);
	          post.require = directive.require;
	          post.directiveName = directiveName;
	          if (newIsolateScopeDirective === directive || directive.$$isolateScope) {
	            post = cloneAndAnnotateFn(post, {isolateScope: true});
	          }
	          postLinkFns.push(post);
	        }
	      }
	
	      function nodeLinkFn(childLinkFn, scope, linkNode, $rootElement, boundTranscludeFn) {
	        var i, ii, linkFn, isolateScope, controllerScope, elementControllers, transcludeFn, $element,
	            attrs, scopeBindingInfo;
	
	        if (compileNode === linkNode) {
	          attrs = templateAttrs;
	          $element = templateAttrs.$$element;
	        } else {
	          $element = jqLite(linkNode);
	          attrs = new Attributes($element, templateAttrs);
	        }
	
	        controllerScope = scope;
	        if (newIsolateScopeDirective) {
	          isolateScope = scope.$new(true);
	        } else if (newScopeDirective) {
	          controllerScope = scope.$parent;
	        }
	
	        if (boundTranscludeFn) {
	          // track `boundTranscludeFn` so it can be unwrapped if `transcludeFn`
	          // is later passed as `parentBoundTranscludeFn` to `publicLinkFn`
	          transcludeFn = controllersBoundTransclude;
	          transcludeFn.$$boundTransclude = boundTranscludeFn;
	          // expose the slots on the `$transclude` function
	          transcludeFn.isSlotFilled = function(slotName) {
	            return !!boundTranscludeFn.$$slots[slotName];
	          };
	        }
	
	        if (controllerDirectives) {
	          elementControllers = setupControllers($element, attrs, transcludeFn, controllerDirectives, isolateScope, scope, newIsolateScopeDirective);
	        }
	
	        if (newIsolateScopeDirective) {
	          // Initialize isolate scope bindings for new isolate scope directive.
	          compile.$$addScopeInfo($element, isolateScope, true, !(templateDirective && (templateDirective === newIsolateScopeDirective ||
	              templateDirective === newIsolateScopeDirective.$$originalDirective)));
	          compile.$$addScopeClass($element, true);
	          isolateScope.$$isolateBindings =
	              newIsolateScopeDirective.$$isolateBindings;
	          scopeBindingInfo = initializeDirectiveBindings(scope, attrs, isolateScope,
	                                        isolateScope.$$isolateBindings,
	                                        newIsolateScopeDirective);
	          if (scopeBindingInfo.removeWatches) {
	            isolateScope.$on('$destroy', scopeBindingInfo.removeWatches);
	          }
	        }
	
	        // Initialize bindToController bindings
	        for (var name in elementControllers) {
	          var controllerDirective = controllerDirectives[name];
	          var controller = elementControllers[name];
	          var bindings = controllerDirective.$$bindings.bindToController;
	
	          controller.instance = controller();
	          $element.data('$' + controllerDirective.name + 'Controller', controller.instance);
	          controller.bindingInfo =
	            initializeDirectiveBindings(controllerScope, attrs, controller.instance, bindings, controllerDirective);
	          }
	
	        // Bind the required controllers to the controller, if `require` is an object and `bindToController` is truthy
	        forEach(controllerDirectives, function(controllerDirective, name) {
	          var require = controllerDirective.require;
	          if (controllerDirective.bindToController && !isArray(require) && isObject(require)) {
	            extend(elementControllers[name].instance, getControllers(name, require, $element, elementControllers));
	          }
	        });
	
	        // Handle the init and destroy lifecycle hooks on all controllers that have them
	        forEach(elementControllers, function(controller) {
	          var controllerInstance = controller.instance;
	          if (isFunction(controllerInstance.$onChanges)) {
	            try {
	              controllerInstance.$onChanges(controller.bindingInfo.initialChanges);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	          if (isFunction(controllerInstance.$onInit)) {
	            try {
	              controllerInstance.$onInit();
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	          if (isFunction(controllerInstance.$doCheck)) {
	            controllerScope.$watch(function() { controllerInstance.$doCheck(); });
	            controllerInstance.$doCheck();
	          }
	          if (isFunction(controllerInstance.$onDestroy)) {
	            controllerScope.$on('$destroy', function callOnDestroyHook() {
	              controllerInstance.$onDestroy();
	            });
	          }
	        });
	
	        // PRELINKING
	        for (i = 0, ii = preLinkFns.length; i < ii; i++) {
	          linkFn = preLinkFns[i];
	          invokeLinkFn(linkFn,
	              linkFn.isolateScope ? isolateScope : scope,
	              $element,
	              attrs,
	              linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers),
	              transcludeFn
	          );
	        }
	
	        // RECURSION
	        // We only pass the isolate scope, if the isolate directive has a template,
	        // otherwise the child elements do not belong to the isolate directive.
	        var scopeToChild = scope;
	        if (newIsolateScopeDirective && (newIsolateScopeDirective.template || newIsolateScopeDirective.templateUrl === null)) {
	          scopeToChild = isolateScope;
	        }
	        if (childLinkFn) {
	          childLinkFn(scopeToChild, linkNode.childNodes, undefined, boundTranscludeFn);
	        }
	
	        // POSTLINKING
	        for (i = postLinkFns.length - 1; i >= 0; i--) {
	          linkFn = postLinkFns[i];
	          invokeLinkFn(linkFn,
	              linkFn.isolateScope ? isolateScope : scope,
	              $element,
	              attrs,
	              linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers),
	              transcludeFn
	          );
	        }
	
	        // Trigger $postLink lifecycle hooks
	        forEach(elementControllers, function(controller) {
	          var controllerInstance = controller.instance;
	          if (isFunction(controllerInstance.$postLink)) {
	            controllerInstance.$postLink();
	          }
	        });
	
	        // This is the function that is injected as `$transclude`.
	        // Note: all arguments are optional!
	        function controllersBoundTransclude(scope, cloneAttachFn, futureParentElement, slotName) {
	          var transcludeControllers;
	          // No scope passed in:
	          if (!isScope(scope)) {
	            slotName = futureParentElement;
	            futureParentElement = cloneAttachFn;
	            cloneAttachFn = scope;
	            scope = undefined;
	          }
	
	          if (hasElementTranscludeDirective) {
	            transcludeControllers = elementControllers;
	          }
	          if (!futureParentElement) {
	            futureParentElement = hasElementTranscludeDirective ? $element.parent() : $element;
	          }
	          if (slotName) {
	            // slotTranscludeFn can be one of three things:
	            //  * a transclude function - a filled slot
	            //  * `null` - an optional slot that was not filled
	            //  * `undefined` - a slot that was not declared (i.e. invalid)
	            var slotTranscludeFn = boundTranscludeFn.$$slots[slotName];
	            if (slotTranscludeFn) {
	              return slotTranscludeFn(scope, cloneAttachFn, transcludeControllers, futureParentElement, scopeToChild);
	            } else if (isUndefined(slotTranscludeFn)) {
	              throw $compileMinErr('noslot',
	               'No parent directive that requires a transclusion with slot name "{0}". ' +
	               'Element: {1}',
	               slotName, startingTag($element));
	            }
	          } else {
	            return boundTranscludeFn(scope, cloneAttachFn, transcludeControllers, futureParentElement, scopeToChild);
	          }
	        }
	      }
	    }
	
	    function getControllers(directiveName, require, $element, elementControllers) {
	      var value;
	
	      if (isString(require)) {
	        var match = require.match(REQUIRE_PREFIX_REGEXP);
	        var name = require.substring(match[0].length);
	        var inheritType = match[1] || match[3];
	        var optional = match[2] === '?';
	
	        //If only parents then start at the parent element
	        if (inheritType === '^^') {
	          $element = $element.parent();
	        //Otherwise attempt getting the controller from elementControllers in case
	        //the element is transcluded (and has no data) and to avoid .data if possible
	        } else {
	          value = elementControllers && elementControllers[name];
	          value = value && value.instance;
	        }
	
	        if (!value) {
	          var dataName = '$' + name + 'Controller';
	
	          if (inheritType === '^^' && $element[0] && $element[0].nodeType === NODE_TYPE_DOCUMENT) {
	            // inheritedData() uses the documentElement when it finds the document, so we would
	            // require from the element itself.
	            value = null;
	          } else {
	            value = inheritType ? $element.inheritedData(dataName) : $element.data(dataName);
	          }
	        }
	
	        if (!value && !optional) {
	          throw $compileMinErr('ctreq',
	              'Controller \'{0}\', required by directive \'{1}\', can\'t be found!',
	              name, directiveName);
	        }
	      } else if (isArray(require)) {
	        value = [];
	        for (var i = 0, ii = require.length; i < ii; i++) {
	          value[i] = getControllers(directiveName, require[i], $element, elementControllers);
	        }
	      } else if (isObject(require)) {
	        value = {};
	        forEach(require, function(controller, property) {
	          value[property] = getControllers(directiveName, controller, $element, elementControllers);
	        });
	      }
	
	      return value || null;
	    }
	
	    function setupControllers($element, attrs, transcludeFn, controllerDirectives, isolateScope, scope, newIsolateScopeDirective) {
	      var elementControllers = createMap();
	      for (var controllerKey in controllerDirectives) {
	        var directive = controllerDirectives[controllerKey];
	        var locals = {
	          $scope: directive === newIsolateScopeDirective || directive.$$isolateScope ? isolateScope : scope,
	          $element: $element,
	          $attrs: attrs,
	          $transclude: transcludeFn
	        };
	
	        var controller = directive.controller;
	        if (controller === '@') {
	          controller = attrs[directive.name];
	        }
	
	        var controllerInstance = $controller(controller, locals, true, directive.controllerAs);
	
	        // For directives with element transclusion the element is a comment.
	        // In this case .data will not attach any data.
	        // Instead, we save the controllers for the element in a local hash and attach to .data
	        // later, once we have the actual element.
	        elementControllers[directive.name] = controllerInstance;
	        $element.data('$' + directive.name + 'Controller', controllerInstance.instance);
	      }
	      return elementControllers;
	    }
	
	    // Depending upon the context in which a directive finds itself it might need to have a new isolated
	    // or child scope created. For instance:
	    // * if the directive has been pulled into a template because another directive with a higher priority
	    // asked for element transclusion
	    // * if the directive itself asks for transclusion but it is at the root of a template and the original
	    // element was replaced. See https://github.com/angular/angular.js/issues/12936
	    function markDirectiveScope(directives, isolateScope, newScope) {
	      for (var j = 0, jj = directives.length; j < jj; j++) {
	        directives[j] = inherit(directives[j], {$$isolateScope: isolateScope, $$newScope: newScope});
	      }
	    }
	
	    /**
	     * looks up the directive and decorates it with exception handling and proper parameters. We
	     * call this the boundDirective.
	     *
	     * @param {string} name name of the directive to look up.
	     * @param {string} location The directive must be found in specific format.
	     *   String containing any of theses characters:
	     *
	     *   * `E`: element name
	     *   * `A': attribute
	     *   * `C`: class
	     *   * `M`: comment
	     * @returns {boolean} true if directive was added.
	     */
	    function addDirective(tDirectives, name, location, maxPriority, ignoreDirective, startAttrName,
	                          endAttrName) {
	      if (name === ignoreDirective) return null;
	      var match = null;
	      if (hasDirectives.hasOwnProperty(name)) {
	        for (var directive, directives = $injector.get(name + Suffix),
	            i = 0, ii = directives.length; i < ii; i++) {
	          directive = directives[i];
	          if ((isUndefined(maxPriority) || maxPriority > directive.priority) &&
	               directive.restrict.indexOf(location) !== -1) {
	            if (startAttrName) {
	              directive = inherit(directive, {$$start: startAttrName, $$end: endAttrName});
	            }
	            if (!directive.$$bindings) {
	              var bindings = directive.$$bindings =
	                  parseDirectiveBindings(directive, directive.name);
	              if (isObject(bindings.isolateScope)) {
	                directive.$$isolateBindings = bindings.isolateScope;
	              }
	            }
	            tDirectives.push(directive);
	            match = directive;
	          }
	        }
	      }
	      return match;
	    }
	
	
	    /**
	     * looks up the directive and returns true if it is a multi-element directive,
	     * and therefore requires DOM nodes between -start and -end markers to be grouped
	     * together.
	     *
	     * @param {string} name name of the directive to look up.
	     * @returns true if directive was registered as multi-element.
	     */
	    function directiveIsMultiElement(name) {
	      if (hasDirectives.hasOwnProperty(name)) {
	        for (var directive, directives = $injector.get(name + Suffix),
	            i = 0, ii = directives.length; i < ii; i++) {
	          directive = directives[i];
	          if (directive.multiElement) {
	            return true;
	          }
	        }
	      }
	      return false;
	    }
	
	    /**
	     * When the element is replaced with HTML template then the new attributes
	     * on the template need to be merged with the existing attributes in the DOM.
	     * The desired effect is to have both of the attributes present.
	     *
	     * @param {object} dst destination attributes (original DOM)
	     * @param {object} src source attributes (from the directive template)
	     */
	    function mergeTemplateAttributes(dst, src) {
	      var srcAttr = src.$attr,
	          dstAttr = dst.$attr;
	
	      // reapply the old attributes to the new element
	      forEach(dst, function(value, key) {
	        if (key.charAt(0) !== '$') {
	          if (src[key] && src[key] !== value) {
	            if (value.length) {
	              value += (key === 'style' ? ';' : ' ') + src[key];
	            } else {
	              value = src[key];
	            }
	          }
	          dst.$set(key, value, true, srcAttr[key]);
	        }
	      });
	
	      // copy the new attributes on the old attrs object
	      forEach(src, function(value, key) {
	        // Check if we already set this attribute in the loop above.
	        // `dst` will never contain hasOwnProperty as DOM parser won't let it.
	        // You will get an "InvalidCharacterError: DOM Exception 5" error if you
	        // have an attribute like "has-own-property" or "data-has-own-property", etc.
	        if (!dst.hasOwnProperty(key) && key.charAt(0) !== '$') {
	          dst[key] = value;
	
	          if (key !== 'class' && key !== 'style') {
	            dstAttr[key] = srcAttr[key];
	          }
	        }
	      });
	    }
	
	
	    function compileTemplateUrl(directives, $compileNode, tAttrs,
	        $rootElement, childTranscludeFn, preLinkFns, postLinkFns, previousCompileContext) {
	      var linkQueue = [],
	          afterTemplateNodeLinkFn,
	          afterTemplateChildLinkFn,
	          beforeTemplateCompileNode = $compileNode[0],
	          origAsyncDirective = directives.shift(),
	          derivedSyncDirective = inherit(origAsyncDirective, {
	            templateUrl: null, transclude: null, replace: null, $$originalDirective: origAsyncDirective
	          }),
	          templateUrl = (isFunction(origAsyncDirective.templateUrl))
	              ? origAsyncDirective.templateUrl($compileNode, tAttrs)
	              : origAsyncDirective.templateUrl,
	          templateNamespace = origAsyncDirective.templateNamespace;
	
	      $compileNode.empty();
	
	      $templateRequest(templateUrl)
	        .then(function(content) {
	          var compileNode, tempTemplateAttrs, $template, childBoundTranscludeFn;
	
	          content = denormalizeTemplate(content);
	
	          if (origAsyncDirective.replace) {
	            if (jqLiteIsTextNode(content)) {
	              $template = [];
	            } else {
	              $template = removeComments(wrapTemplate(templateNamespace, trim(content)));
	            }
	            compileNode = $template[0];
	
	            if ($template.length !== 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) {
	              throw $compileMinErr('tplrt',
	                  'Template for directive \'{0}\' must have exactly one root element. {1}',
	                  origAsyncDirective.name, templateUrl);
	            }
	
	            tempTemplateAttrs = {$attr: {}};
	            replaceWith($rootElement, $compileNode, compileNode);
	            var templateDirectives = collectDirectives(compileNode, [], tempTemplateAttrs);
	
	            if (isObject(origAsyncDirective.scope)) {
	              // the original directive that caused the template to be loaded async required
	              // an isolate scope
	              markDirectiveScope(templateDirectives, true);
	            }
	            directives = templateDirectives.concat(directives);
	            mergeTemplateAttributes(tAttrs, tempTemplateAttrs);
	          } else {
	            compileNode = beforeTemplateCompileNode;
	            $compileNode.html(content);
	          }
	
	          directives.unshift(derivedSyncDirective);
	
	          afterTemplateNodeLinkFn = applyDirectivesToNode(directives, compileNode, tAttrs,
	              childTranscludeFn, $compileNode, origAsyncDirective, preLinkFns, postLinkFns,
	              previousCompileContext);
	          forEach($rootElement, function(node, i) {
	            if (node === compileNode) {
	              $rootElement[i] = $compileNode[0];
	            }
	          });
	          afterTemplateChildLinkFn = compileNodes($compileNode[0].childNodes, childTranscludeFn);
	
	          while (linkQueue.length) {
	            var scope = linkQueue.shift(),
	                beforeTemplateLinkNode = linkQueue.shift(),
	                linkRootElement = linkQueue.shift(),
	                boundTranscludeFn = linkQueue.shift(),
	                linkNode = $compileNode[0];
	
	            if (scope.$$destroyed) continue;
	
	            if (beforeTemplateLinkNode !== beforeTemplateCompileNode) {
	              var oldClasses = beforeTemplateLinkNode.className;
	
	              if (!(previousCompileContext.hasElementTranscludeDirective &&
	                  origAsyncDirective.replace)) {
	                // it was cloned therefore we have to clone as well.
	                linkNode = jqLiteClone(compileNode);
	              }
	              replaceWith(linkRootElement, jqLite(beforeTemplateLinkNode), linkNode);
	
	              // Copy in CSS classes from original node
	              safeAddClass(jqLite(linkNode), oldClasses);
	            }
	            if (afterTemplateNodeLinkFn.transcludeOnThisElement) {
	              childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
	            } else {
	              childBoundTranscludeFn = boundTranscludeFn;
	            }
	            afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, linkNode, $rootElement,
	              childBoundTranscludeFn);
	          }
	          linkQueue = null;
	        }).catch(function(error) {
	          if (isError(error)) {
	            $exceptionHandler(error);
	          }
	        });
	
	      return function delayedNodeLinkFn(ignoreChildLinkFn, scope, node, rootElement, boundTranscludeFn) {
	        var childBoundTranscludeFn = boundTranscludeFn;
	        if (scope.$$destroyed) return;
	        if (linkQueue) {
	          linkQueue.push(scope,
	                         node,
	                         rootElement,
	                         childBoundTranscludeFn);
	        } else {
	          if (afterTemplateNodeLinkFn.transcludeOnThisElement) {
	            childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
	          }
	          afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, node, rootElement, childBoundTranscludeFn);
	        }
	      };
	    }
	
	
	    /**
	     * Sorting function for bound directives.
	     */
	    function byPriority(a, b) {
	      var diff = b.priority - a.priority;
	      if (diff !== 0) return diff;
	      if (a.name !== b.name) return (a.name < b.name) ? -1 : 1;
	      return a.index - b.index;
	    }
	
	    function assertNoDuplicate(what, previousDirective, directive, element) {
	
	      function wrapModuleNameIfDefined(moduleName) {
	        return moduleName ?
	          (' (module: ' + moduleName + ')') :
	          '';
	      }
	
	      if (previousDirective) {
	        throw $compileMinErr('multidir', 'Multiple directives [{0}{1}, {2}{3}] asking for {4} on: {5}',
	            previousDirective.name, wrapModuleNameIfDefined(previousDirective.$$moduleName),
	            directive.name, wrapModuleNameIfDefined(directive.$$moduleName), what, startingTag(element));
	      }
	    }
	
	
	    function addTextInterpolateDirective(directives, text) {
	      var interpolateFn = $interpolate(text, true);
	      if (interpolateFn) {
	        directives.push({
	          priority: 0,
	          compile: function textInterpolateCompileFn(templateNode) {
	            var templateNodeParent = templateNode.parent(),
	                hasCompileParent = !!templateNodeParent.length;
	
	            // When transcluding a template that has bindings in the root
	            // we don't have a parent and thus need to add the class during linking fn.
	            if (hasCompileParent) compile.$$addBindingClass(templateNodeParent);
	
	            return function textInterpolateLinkFn(scope, node) {
	              var parent = node.parent();
	              if (!hasCompileParent) compile.$$addBindingClass(parent);
	              compile.$$addBindingInfo(parent, interpolateFn.expressions);
	              scope.$watch(interpolateFn, function interpolateFnWatchAction(value) {
	                node[0].nodeValue = value;
	              });
	            };
	          }
	        });
	      }
	    }
	
	
	    function wrapTemplate(type, template) {
	      type = lowercase(type || 'html');
	      switch (type) {
	      case 'svg':
	      case 'math':
	        var wrapper = window.document.createElement('div');
	        wrapper.innerHTML = '<' + type + '>' + template + '</' + type + '>';
	        return wrapper.childNodes[0].childNodes;
	      default:
	        return template;
	      }
	    }
	
	
	    function getTrustedAttrContext(nodeName, attrNormalizedName) {
	      if (attrNormalizedName === 'srcdoc') {
	        return $sce.HTML;
	      }
	      // All nodes with src attributes require a RESOURCE_URL value, except for
	      // img and various html5 media nodes, which require the MEDIA_URL context.
	      if (attrNormalizedName === 'src' || attrNormalizedName === 'ngSrc') {
	        if (['img', 'video', 'audio', 'source', 'track'].indexOf(nodeName) === -1) {
	          return $sce.RESOURCE_URL;
	        }
	        return $sce.MEDIA_URL;
	      } else if (attrNormalizedName === 'xlinkHref') {
	        // Some xlink:href are okay, most aren't
	        if (nodeName === 'image') return $sce.MEDIA_URL;
	        if (nodeName === 'a') return $sce.URL;
	        return $sce.RESOURCE_URL;
	      } else if (
	          // Formaction
	          (nodeName === 'form' && attrNormalizedName === 'action') ||
	          // If relative URLs can go where they are not expected to, then
	          // all sorts of trust issues can arise.
	          (nodeName === 'base' && attrNormalizedName === 'href') ||
	          // links can be stylesheets or imports, which can run script in the current origin
	          (nodeName === 'link' && attrNormalizedName === 'href')
	      ) {
	        return $sce.RESOURCE_URL;
	      } else if (nodeName === 'a' && (attrNormalizedName === 'href' ||
	                                 attrNormalizedName === 'ngHref')) {
	        return $sce.URL;
	      }
	    }
	
	    function getTrustedPropContext(nodeName, propNormalizedName) {
	      var prop = propNormalizedName.toLowerCase();
	      return PROP_CONTEXTS[nodeName + '|' + prop] || PROP_CONTEXTS['*|' + prop];
	    }
	
	    function sanitizeSrcsetPropertyValue(value) {
	      return sanitizeSrcset($sce.valueOf(value), 'ng-prop-srcset');
	    }
	    function addPropertyDirective(node, directives, attrName, propName) {
	      if (EVENT_HANDLER_ATTR_REGEXP.test(propName)) {
	        throw $compileMinErr('nodomevents', 'Property bindings for HTML DOM event properties are disallowed');
	      }
	
	      var nodeName = nodeName_(node);
	      var trustedContext = getTrustedPropContext(nodeName, propName);
	
	      var sanitizer = identity;
	      // Sanitize img[srcset] + source[srcset] values.
	      if (propName === 'srcset' && (nodeName === 'img' || nodeName === 'source')) {
	        sanitizer = sanitizeSrcsetPropertyValue;
	      } else if (trustedContext) {
	        sanitizer = $sce.getTrusted.bind($sce, trustedContext);
	      }
	
	      directives.push({
	        priority: 100,
	        compile: function ngPropCompileFn(_, attr) {
	          var ngPropGetter = $parse(attr[attrName]);
	          var ngPropWatch = $parse(attr[attrName], function sceValueOf(val) {
	            // Unwrap the value to compare the actual inner safe value, not the wrapper object.
	            return $sce.valueOf(val);
	          });
	
	          return {
	            pre: function ngPropPreLinkFn(scope, $element) {
	              function applyPropValue() {
	                var propValue = ngPropGetter(scope);
	                $element[0][propName] = sanitizer(propValue);
	              }
	
	              applyPropValue();
	              scope.$watch(ngPropWatch, applyPropValue);
	            }
	          };
	        }
	      });
	    }
	
	    function addEventDirective(directives, attrName, eventName) {
	      directives.push(
	        createEventDirective($parse, $rootScope, $exceptionHandler, attrName, eventName, /*forceAsync=*/false)
	      );
	    }
	
	    function addAttrInterpolateDirective(node, directives, value, name, isNgAttr) {
	      var nodeName = nodeName_(node);
	      var trustedContext = getTrustedAttrContext(nodeName, name);
	      var mustHaveExpression = !isNgAttr;
	      var allOrNothing = ALL_OR_NOTHING_ATTRS[name] || isNgAttr;
	
	      var interpolateFn = $interpolate(value, mustHaveExpression, trustedContext, allOrNothing);
	
	      // no interpolation found -> ignore
	      if (!interpolateFn) return;
	
	      if (name === 'multiple' && nodeName === 'select') {
	        throw $compileMinErr('selmulti',
	            'Binding to the \'multiple\' attribute is not supported. Element: {0}',
	            startingTag(node));
	      }
	
	      if (EVENT_HANDLER_ATTR_REGEXP.test(name)) {
	        throw $compileMinErr('nodomevents', 'Interpolations for HTML DOM event attributes are disallowed');
	      }
	
	      directives.push({
	        priority: 100,
	        compile: function() {
	            return {
	              pre: function attrInterpolatePreLinkFn(scope, element, attr) {
	                var $$observers = (attr.$$observers || (attr.$$observers = createMap()));
	
	                // If the attribute has changed since last $interpolate()ed
	                var newValue = attr[name];
	                if (newValue !== value) {
	                  // we need to interpolate again since the attribute value has been updated
	                  // (e.g. by another directive's compile function)
	                  // ensure unset/empty values make interpolateFn falsy
	                  interpolateFn = newValue && $interpolate(newValue, true, trustedContext, allOrNothing);
	                  value = newValue;
	                }
	
	                // if attribute was updated so that there is no interpolation going on we don't want to
	                // register any observers
	                if (!interpolateFn) return;
	
	                // initialize attr object so that it's ready in case we need the value for isolate
	                // scope initialization, otherwise the value would not be available from isolate
	                // directive's linking fn during linking phase
	                attr[name] = interpolateFn(scope);
	
	                ($$observers[name] || ($$observers[name] = [])).$$inter = true;
	                (attr.$$observers && attr.$$observers[name].$$scope || scope).
	                  $watch(interpolateFn, function interpolateFnWatchAction(newValue, oldValue) {
	                    //special case for class attribute addition + removal
	                    //so that class changes can tap into the animation
	                    //hooks provided by the $animate service. Be sure to
	                    //skip animations when the first digest occurs (when
	                    //both the new and the old values are the same) since
	                    //the CSS classes are the non-interpolated values
	                    if (name === 'class' && newValue !== oldValue) {
	                      attr.$updateClass(newValue, oldValue);
	                    } else {
	                      attr.$set(name, newValue);
	                    }
	                  });
	              }
	            };
	          }
	      });
	    }
	
	
	    /**
	     * This is a special jqLite.replaceWith, which can replace items which
	     * have no parents, provided that the containing jqLite collection is provided.
	     *
	     * @param {JqLite=} $rootElement The root of the compile tree. Used so that we can replace nodes
	     *                               in the root of the tree.
	     * @param {JqLite} elementsToRemove The jqLite element which we are going to replace. We keep
	     *                                  the shell, but replace its DOM node reference.
	     * @param {Node} newNode The new DOM node.
	     */
	    function replaceWith($rootElement, elementsToRemove, newNode) {
	      var firstElementToRemove = elementsToRemove[0],
	          removeCount = elementsToRemove.length,
	          parent = firstElementToRemove.parentNode,
	          i, ii;
	
	      if ($rootElement) {
	        for (i = 0, ii = $rootElement.length; i < ii; i++) {
	          if ($rootElement[i] === firstElementToRemove) {
	            $rootElement[i++] = newNode;
	            for (var j = i, j2 = j + removeCount - 1,
	                     jj = $rootElement.length;
	                 j < jj; j++, j2++) {
	              if (j2 < jj) {
	                $rootElement[j] = $rootElement[j2];
	              } else {
	                delete $rootElement[j];
	              }
	            }
	            $rootElement.length -= removeCount - 1;
	
	            // If the replaced element is also the jQuery .context then replace it
	            // .context is a deprecated jQuery api, so we should set it only when jQuery set it
	            // http://api.jquery.com/context/
	            if ($rootElement.context === firstElementToRemove) {
	              $rootElement.context = newNode;
	            }
	            break;
	          }
	        }
	      }
	
	      if (parent) {
	        parent.replaceChild(newNode, firstElementToRemove);
	      }
	
	      // Append all the `elementsToRemove` to a fragment. This will...
	      // - remove them from the DOM
	      // - allow them to still be traversed with .nextSibling
	      // - allow a single fragment.qSA to fetch all elements being removed
	      var fragment = window.document.createDocumentFragment();
	      for (i = 0; i < removeCount; i++) {
	        fragment.appendChild(elementsToRemove[i]);
	      }
	
	      if (jqLite.hasData(firstElementToRemove)) {
	        // Copy over user data (that includes AngularJS's $scope etc.). Don't copy private
	        // data here because there's no public interface in jQuery to do that and copying over
	        // event listeners (which is the main use of private data) wouldn't work anyway.
	        jqLite.data(newNode, jqLite.data(firstElementToRemove));
	
	        // Remove $destroy event listeners from `firstElementToRemove`
	        jqLite(firstElementToRemove).off('$destroy');
	      }
	
	      // Cleanup any data/listeners on the elements and children.
	      // This includes invoking the $destroy event on any elements with listeners.
	      jqLite.cleanData(fragment.querySelectorAll('*'));
	
	      // Update the jqLite collection to only contain the `newNode`
	      for (i = 1; i < removeCount; i++) {
	        delete elementsToRemove[i];
	      }
	      elementsToRemove[0] = newNode;
	      elementsToRemove.length = 1;
	    }
	
	
	    function cloneAndAnnotateFn(fn, annotation) {
	      return extend(function() { return fn.apply(null, arguments); }, fn, annotation);
	    }
	
	
	    function invokeLinkFn(linkFn, scope, $element, attrs, controllers, transcludeFn) {
	      try {
	        linkFn(scope, $element, attrs, controllers, transcludeFn);
	      } catch (e) {
	        $exceptionHandler(e, startingTag($element));
	      }
	    }
	
	    function strictBindingsCheck(attrName, directiveName) {
	      if (strictComponentBindingsEnabled) {
	        throw $compileMinErr('missingattr',
	          'Attribute \'{0}\' of \'{1}\' is non-optional and must be set!',
	          attrName, directiveName);
	      }
	    }
	
	    // Set up $watches for isolate scope and controller bindings.
	    function initializeDirectiveBindings(scope, attrs, destination, bindings, directive) {
	      var removeWatchCollection = [];
	      var initialChanges = {};
	      var changes;
	
	      forEach(bindings, function initializeBinding(definition, scopeName) {
	        var attrName = definition.attrName,
	        optional = definition.optional,
	        mode = definition.mode, // @, =, <, or &
	        lastValue,
	        parentGet, parentSet, compare, removeWatch;
	
	        switch (mode) {
	
	          case '@':
	            if (!optional && !hasOwnProperty.call(attrs, attrName)) {
	              strictBindingsCheck(attrName, directive.name);
	              destination[scopeName] = attrs[attrName] = undefined;
	
	            }
	            removeWatch = attrs.$observe(attrName, function(value) {
	              if (isString(value) || isBoolean(value)) {
	                var oldValue = destination[scopeName];
	                recordChanges(scopeName, value, oldValue);
	                destination[scopeName] = value;
	              }
	            });
	            attrs.$$observers[attrName].$$scope = scope;
	            lastValue = attrs[attrName];
	            if (isString(lastValue)) {
	              // If the attribute has been provided then we trigger an interpolation to ensure
	              // the value is there for use in the link fn
	              destination[scopeName] = $interpolate(lastValue)(scope);
	            } else if (isBoolean(lastValue)) {
	              // If the attributes is one of the BOOLEAN_ATTR then AngularJS will have converted
	              // the value to boolean rather than a string, so we special case this situation
	              destination[scopeName] = lastValue;
	            }
	            initialChanges[scopeName] = new SimpleChange(_UNINITIALIZED_VALUE, destination[scopeName]);
	            removeWatchCollection.push(removeWatch);
	            break;
	
	          case '=':
	            if (!hasOwnProperty.call(attrs, attrName)) {
	              if (optional) break;
	              strictBindingsCheck(attrName, directive.name);
	              attrs[attrName] = undefined;
	            }
	            if (optional && !attrs[attrName]) break;
	
	            parentGet = $parse(attrs[attrName]);
	            if (parentGet.literal) {
	              compare = equals;
	            } else {
	              compare = simpleCompare;
	            }
	            parentSet = parentGet.assign || function() {
	              // reset the change, or we will throw this exception on every $digest
	              lastValue = destination[scopeName] = parentGet(scope);
	              throw $compileMinErr('nonassign',
	                  'Expression \'{0}\' in attribute \'{1}\' used with directive \'{2}\' is non-assignable!',
	                  attrs[attrName], attrName, directive.name);
	            };
	            lastValue = destination[scopeName] = parentGet(scope);
	            var parentValueWatch = function parentValueWatch(parentValue) {
	              if (!compare(parentValue, destination[scopeName])) {
	                // we are out of sync and need to copy
	                if (!compare(parentValue, lastValue)) {
	                  // parent changed and it has precedence
	                  destination[scopeName] = parentValue;
	                } else {
	                  // if the parent can be assigned then do so
	                  parentSet(scope, parentValue = destination[scopeName]);
	                }
	              }
	              lastValue = parentValue;
	              return lastValue;
	            };
	            parentValueWatch.$stateful = true;
	            if (definition.collection) {
	              removeWatch = scope.$watchCollection(attrs[attrName], parentValueWatch);
	            } else {
	              removeWatch = scope.$watch($parse(attrs[attrName], parentValueWatch), null, parentGet.literal);
	            }
	            removeWatchCollection.push(removeWatch);
	            break;
	
	          case '<':
	            if (!hasOwnProperty.call(attrs, attrName)) {
	              if (optional) break;
	              strictBindingsCheck(attrName, directive.name);
	              attrs[attrName] = undefined;
	            }
	            if (optional && !attrs[attrName]) break;
	
	            parentGet = $parse(attrs[attrName]);
	            var isLiteral = parentGet.literal;
	
	            var initialValue = destination[scopeName] = parentGet(scope);
	            initialChanges[scopeName] = new SimpleChange(_UNINITIALIZED_VALUE, destination[scopeName]);
	
	            removeWatch = scope[definition.collection ? '$watchCollection' : '$watch'](parentGet, function parentValueWatchAction(newValue, oldValue) {
	              if (oldValue === newValue) {
	                if (oldValue === initialValue || (isLiteral && equals(oldValue, initialValue))) {
	                  return;
	                }
	                oldValue = initialValue;
	              }
	              recordChanges(scopeName, newValue, oldValue);
	              destination[scopeName] = newValue;
	            });
	
	            removeWatchCollection.push(removeWatch);
	            break;
	
	          case '&':
	            if (!optional && !hasOwnProperty.call(attrs, attrName)) {
	              strictBindingsCheck(attrName, directive.name);
	            }
	            // Don't assign Object.prototype method to scope
	            parentGet = attrs.hasOwnProperty(attrName) ? $parse(attrs[attrName]) : noop;
	
	            // Don't assign noop to destination if expression is not valid
	            if (parentGet === noop && optional) break;
	
	            destination[scopeName] = function(locals) {
	              return parentGet(scope, locals);
	            };
	            break;
	        }
	      });
	
	      function recordChanges(key, currentValue, previousValue) {
	        if (isFunction(destination.$onChanges) && !simpleCompare(currentValue, previousValue)) {
	          // If we have not already scheduled the top level onChangesQueue handler then do so now
	          if (!onChangesQueue) {
	            scope.$$postDigest(flushOnChangesQueue);
	            onChangesQueue = [];
	          }
	          // If we have not already queued a trigger of onChanges for this controller then do so now
	          if (!changes) {
	            changes = {};
	            onChangesQueue.push(triggerOnChangesHook);
	          }
	          // If the has been a change on this property already then we need to reuse the previous value
	          if (changes[key]) {
	            previousValue = changes[key].previousValue;
	          }
	          // Store this change
	          changes[key] = new SimpleChange(previousValue, currentValue);
	        }
	      }
	
	      function triggerOnChangesHook() {
	        destination.$onChanges(changes);
	        // Now clear the changes so that we schedule onChanges when more changes arrive
	        changes = undefined;
	      }
	
	      return {
	        initialChanges: initialChanges,
	        removeWatches: removeWatchCollection.length && function removeWatches() {
	          for (var i = 0, ii = removeWatchCollection.length; i < ii; ++i) {
	            removeWatchCollection[i]();
	          }
	        }
	      };
	    }
	  }];
	}
	
	function SimpleChange(previous, current) {
	  this.previousValue = previous;
	  this.currentValue = current;
	}
	SimpleChange.prototype.isFirstChange = function() { return this.previousValue === _UNINITIALIZED_VALUE; };
	
	
	var PREFIX_REGEXP = /^((?:x|data)[:\-_])/i;
	var SPECIAL_CHARS_REGEXP = /[:\-_]+(.)/g;
	
	/**
	 * Converts all accepted directives format into proper directive name.
	 * @param name Name to normalize
	 */
	function directiveNormalize(name) {
	  return name
	    .replace(PREFIX_REGEXP, '')
	    .replace(SPECIAL_CHARS_REGEXP, function(_, letter, offset) {
	      return offset ? letter.toUpperCase() : letter;
	    });
	}
	
	/**
	 * @ngdoc type
	 * @name $compile.directive.Attributes
	 *
	 * @description
	 * A shared object between directive compile / linking functions which contains normalized DOM
	 * element attributes. The values reflect current binding state `{{ }}`. The normalization is
	 * needed since all of these are treated as equivalent in AngularJS:
	 *
	 * ```
	 *    <span ng:bind="a" ng-bind="a" data-ng-bind="a" x-ng-bind="a">
	 * ```
	 */
	
	/**
	 * @ngdoc property
	 * @name $compile.directive.Attributes#$attr
	 *
	 * @description
	 * A map of DOM element attribute names to the normalized name. This is
	 * needed to do reverse lookup from normalized name back to actual name.
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $compile.directive.Attributes#$set
	 * @kind function
	 *
	 * @description
	 * Set DOM element attribute value.
	 *
	 *
	 * @param {string} name Normalized element attribute name of the property to modify. The name is
	 *          reverse-translated using the {@link ng.$compile.directive.Attributes#$attr $attr}
	 *          property to the original name.
	 * @param {string} value Value to set the attribute to. The value can be an interpolated string.
	 */
	
	
	
	/**
	 * Closure compiler type information
	 */
	
	function nodesetLinkingFn(
	  /* angular.Scope */ scope,
	  /* NodeList */ nodeList,
	  /* Element */ rootElement,
	  /* function(Function) */ boundTranscludeFn
	) {}
	
	function directiveLinkingFn(
	  /* nodesetLinkingFn */ nodesetLinkingFn,
	  /* angular.Scope */ scope,
	  /* Node */ node,
	  /* Element */ rootElement,
	  /* function(Function) */ boundTranscludeFn
	) {}
	
	function tokenDifference(str1, str2) {
	  var values = '',
	      tokens1 = str1.split(/\s+/),
	      tokens2 = str2.split(/\s+/);
	
	  outer:
	  for (var i = 0; i < tokens1.length; i++) {
	    var token = tokens1[i];
	    for (var j = 0; j < tokens2.length; j++) {
	      if (token === tokens2[j]) continue outer;
	    }
	    values += (values.length > 0 ? ' ' : '') + token;
	  }
	  return values;
	}
	
	function removeComments(jqNodes) {
	  jqNodes = jqLite(jqNodes);
	  var i = jqNodes.length;
	
	  if (i <= 1) {
	    return jqNodes;
	  }
	
	  while (i--) {
	    var node = jqNodes[i];
	    if (node.nodeType === NODE_TYPE_COMMENT ||
	       (node.nodeType === NODE_TYPE_TEXT && node.nodeValue.trim() === '')) {
	         splice.call(jqNodes, i, 1);
	    }
	  }
	  return jqNodes;
	}
	
	var $controllerMinErr = minErr('$controller');
	
	
	var CNTRL_REG = /^(\S+)(\s+as\s+([\w$]+))?$/;
	function identifierForController(controller, ident) {
	  if (ident && isString(ident)) return ident;
	  if (isString(controller)) {
	    var match = CNTRL_REG.exec(controller);
	    if (match) return match[3];
	  }
	}
	
	
	/**
	 * @ngdoc provider
	 * @name $controllerProvider
	 * @this
	 *
	 * @description
	 * The {@link ng.$controller $controller service} is used by AngularJS to create new
	 * controllers.
	 *
	 * This provider allows controller registration via the
	 * {@link ng.$controllerProvider#register register} method.
	 */
	function $ControllerProvider() {
	  var controllers = {};
	
	  /**
	   * @ngdoc method
	   * @name $controllerProvider#has
	   * @param {string} name Controller name to check.
	   */
	  this.has = function(name) {
	    return controllers.hasOwnProperty(name);
	  };
	
	  /**
	   * @ngdoc method
	   * @name $controllerProvider#register
	   * @param {string|Object} name Controller name, or an object map of controllers where the keys are
	   *    the names and the values are the constructors.
	   * @param {Function|Array} constructor Controller constructor fn (optionally decorated with DI
	   *    annotations in the array notation).
	   */
	  this.register = function(name, constructor) {
	    assertNotHasOwnProperty(name, 'controller');
	    if (isObject(name)) {
	      extend(controllers, name);
	    } else {
	      controllers[name] = constructor;
	    }
	  };
	
	  this.$get = ['$injector', function($injector) {
	
	    /**
	     * @ngdoc service
	     * @name $controller
	     * @requires $injector
	     *
	     * @param {Function|string} constructor If called with a function then it's considered to be the
	     *    controller constructor function. Otherwise it's considered to be a string which is used
	     *    to retrieve the controller constructor using the following steps:
	     *
	     *    * check if a controller with given name is registered via `$controllerProvider`
	     *    * check if evaluating the string on the current scope returns a constructor
	     *
	     *    The string can use the `controller as property` syntax, where the controller instance is published
	     *    as the specified property on the `scope`; the `scope` must be injected into `locals` param for this
	     *    to work correctly.
	     *
	     * @param {Object} locals Injection locals for Controller.
	     * @return {Object} Instance of given controller.
	     *
	     * @description
	     * `$controller` service is responsible for instantiating controllers.
	     *
	     * It's just a simple call to {@link auto.$injector $injector}, but extracted into
	     * a service, so that one can override this service with [BC version](https://gist.github.com/1649788).
	     */
	    return function $controller(expression, locals, later, ident) {
	      // PRIVATE API:
	      //   param `later` --- indicates that the controller's constructor is invoked at a later time.
	      //                     If true, $controller will allocate the object with the correct
	      //                     prototype chain, but will not invoke the controller until a returned
	      //                     callback is invoked.
	      //   param `ident` --- An optional label which overrides the label parsed from the controller
	      //                     expression, if any.
	      var instance, match, constructor, identifier;
	      later = later === true;
	      if (ident && isString(ident)) {
	        identifier = ident;
	      }
	
	      if (isString(expression)) {
	        match = expression.match(CNTRL_REG);
	        if (!match) {
	          throw $controllerMinErr('ctrlfmt',
	            'Badly formed controller string \'{0}\'. ' +
	            'Must match `__name__ as __id__` or `__name__`.', expression);
	        }
	        constructor = match[1];
	        identifier = identifier || match[3];
	        expression = controllers.hasOwnProperty(constructor)
	            ? controllers[constructor]
	            : getter(locals.$scope, constructor, true);
	
	        if (!expression) {
	          throw $controllerMinErr('ctrlreg',
	            'The controller with the name \'{0}\' is not registered.', constructor);
	        }
	
	        assertArgFn(expression, constructor, true);
	      }
	
	      if (later) {
	        // Instantiate controller later:
	        // This machinery is used to create an instance of the object before calling the
	        // controller's constructor itself.
	        //
	        // This allows properties to be added to the controller before the constructor is
	        // invoked. Primarily, this is used for isolate scope bindings in $compile.
	        //
	        // This feature is not intended for use by applications, and is thus not documented
	        // publicly.
	        // Object creation: http://jsperf.com/create-constructor/2
	        var controllerPrototype = (isArray(expression) ?
	          expression[expression.length - 1] : expression).prototype;
	        instance = Object.create(controllerPrototype || null);
	
	        if (identifier) {
	          addIdentifier(locals, identifier, instance, constructor || expression.name);
	        }
	
	        return extend(function $controllerInit() {
	          var result = $injector.invoke(expression, instance, locals, constructor);
	          if (result !== instance && (isObject(result) || isFunction(result))) {
	            instance = result;
	            if (identifier) {
	              // If result changed, re-assign controllerAs value to scope.
	              addIdentifier(locals, identifier, instance, constructor || expression.name);
	            }
	          }
	          return instance;
	        }, {
	          instance: instance,
	          identifier: identifier
	        });
	      }
	
	      instance = $injector.instantiate(expression, locals, constructor);
	
	      if (identifier) {
	        addIdentifier(locals, identifier, instance, constructor || expression.name);
	      }
	
	      return instance;
	    };
	
	    function addIdentifier(locals, identifier, instance, name) {
	      if (!(locals && isObject(locals.$scope))) {
	        throw minErr('$controller')('noscp',
	          'Cannot export controller \'{0}\' as \'{1}\'! No $scope object provided via `locals`.',
	          name, identifier);
	      }
	
	      locals.$scope[identifier] = instance;
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $document
	 * @requires $window
	 * @this
	 *
	 * @description
	 * A {@link angular.element jQuery or jqLite} wrapper for the browser's `window.document` object.
	 *
	 * @example
	   <example module="documentExample" name="document">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <p>$document title: <b ng-bind="title"></b></p>
	         <p>window.document title: <b ng-bind="windowTitle"></b></p>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('documentExample', [])
	         .controller('ExampleController', ['$scope', '$document', function($scope, $document) {
	           $scope.title = $document[0].title;
	           $scope.windowTitle = angular.element(window.document)[0].title;
	         }]);
	     </file>
	   </example>
	 */
	function $DocumentProvider() {
	  this.$get = ['$window', function(window) {
	    return jqLite(window.document);
	  }];
	}
	
	
	/**
	 * @private
	 * @this
	 * Listens for document visibility change and makes the current status accessible.
	 */
	function $$IsDocumentHiddenProvider() {
	  this.$get = ['$document', '$rootScope', function($document, $rootScope) {
	    var doc = $document[0];
	    var hidden = doc && doc.hidden;
	
	    $document.on('visibilitychange', changeListener);
	
	    $rootScope.$on('$destroy', function() {
	      $document.off('visibilitychange', changeListener);
	    });
	
	    function changeListener() {
	      hidden = doc.hidden;
	    }
	
	    return function() {
	      return hidden;
	    };
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $exceptionHandler
	 * @requires ng.$log
	 * @this
	 *
	 * @description
	 * Any uncaught exception in AngularJS expressions is delegated to this service.
	 * The default implementation simply delegates to `$log.error` which logs it into
	 * the browser console.
	 *
	 * In unit tests, if `angular-mocks.js` is loaded, this service is overridden by
	 * {@link ngMock.$exceptionHandler mock $exceptionHandler} which aids in testing.
	 *
	 * ## Example:
	 *
	 * The example below will overwrite the default `$exceptionHandler` in order to (a) log uncaught
	 * errors to the backend for later inspection by the developers and (b) to use `$log.warn()` instead
	 * of `$log.error()`.
	 *
	 * ```js
	 *   angular.
	 *     module('exceptionOverwrite', []).
	 *     factory('$exceptionHandler', ['$log', 'logErrorsToBackend', function($log, logErrorsToBackend) {
	 *       return function myExceptionHandler(exception, cause) {
	 *         logErrorsToBackend(exception, cause);
	 *         $log.warn(exception, cause);
	 *       };
	 *     }]);
	 * ```
	 *
	 * <hr />
	 * Note, that code executed in event-listeners (even those registered using jqLite's `on`/`bind`
	 * methods) does not delegate exceptions to the {@link ng.$exceptionHandler $exceptionHandler}
	 * (unless executed during a digest).
	 *
	 * If you wish, you can manually delegate exceptions, e.g.
	 * `try { ... } catch(e) { $exceptionHandler(e); }`
	 *
	 * @param {Error} exception Exception associated with the error.
	 * @param {string=} cause Optional information about the context in which
	 *       the error was thrown.
	 *
	 */
	function $ExceptionHandlerProvider() {
	  this.$get = ['$log', function($log) {
	    return function(exception, cause) {
	      $log.error.apply($log, arguments);
	    };
	  }];
	}
	
	var $$ForceReflowProvider = /** @this */ function() {
	  this.$get = ['$document', function($document) {
	    return function(domNode) {
	      //the line below will force the browser to perform a repaint so
	      //that all the animated elements within the animation frame will
	      //be properly updated and drawn on screen. This is required to
	      //ensure that the preparation animation is properly flushed so that
	      //the active state picks up from there. DO NOT REMOVE THIS LINE.
	      //DO NOT OPTIMIZE THIS LINE. THE MINIFIER WILL REMOVE IT OTHERWISE WHICH
	      //WILL RESULT IN AN UNPREDICTABLE BUG THAT IS VERY HARD TO TRACK DOWN AND
	      //WILL TAKE YEARS AWAY FROM YOUR LIFE.
	      if (domNode) {
	        if (!domNode.nodeType && domNode instanceof jqLite) {
	          domNode = domNode[0];
	        }
	      } else {
	        domNode = $document[0].body;
	      }
	      return domNode.offsetWidth + 1;
	    };
	  }];
	};
	
	var APPLICATION_JSON = 'application/json';
	var CONTENT_TYPE_APPLICATION_JSON = {'Content-Type': APPLICATION_JSON + ';charset=utf-8'};
	var JSON_START = /^\[|^\{(?!\{)/;
	var JSON_ENDS = {
	  '[': /]$/,
	  '{': /}$/
	};
	var JSON_PROTECTION_PREFIX = /^\)]\}',?\n/;
	var $httpMinErr = minErr('$http');
	
	function serializeValue(v) {
	  if (isObject(v)) {
	    return isDate(v) ? v.toISOString() : toJson(v);
	  }
	  return v;
	}
	
	
	/** @this */
	function $HttpParamSerializerProvider() {
	  /**
	   * @ngdoc service
	   * @name $httpParamSerializer
	   * @description
	   *
	   * Default {@link $http `$http`} params serializer that converts objects to strings
	   * according to the following rules:
	   *
	   * * `{'foo': 'bar'}` results in `foo=bar`
	   * * `{'foo': Date.now()}` results in `foo=2015-04-01T09%3A50%3A49.262Z` (`toISOString()` and encoded representation of a Date object)
	   * * `{'foo': ['bar', 'baz']}` results in `foo=bar&foo=baz` (repeated key for each array element)
	   * * `{'foo': {'bar':'baz'}}` results in `foo=%7B%22bar%22%3A%22baz%22%7D` (stringified and encoded representation of an object)
	   *
	   * Note that serializer will sort the request parameters alphabetically.
	   */
	
	  this.$get = function() {
	    return function ngParamSerializer(params) {
	      if (!params) return '';
	      var parts = [];
	      forEachSorted(params, function(value, key) {
	        if (value === null || isUndefined(value) || isFunction(value)) return;
	        if (isArray(value)) {
	          forEach(value, function(v) {
	            parts.push(encodeUriQuery(key)  + '=' + encodeUriQuery(serializeValue(v)));
	          });
	        } else {
	          parts.push(encodeUriQuery(key) + '=' + encodeUriQuery(serializeValue(value)));
	        }
	      });
	
	      return parts.join('&');
	    };
	  };
	}
	
	/** @this */
	function $HttpParamSerializerJQLikeProvider() {
	  /**
	   * @ngdoc service
	   * @name $httpParamSerializerJQLike
	   *
	   * @description
	   *
	   * Alternative {@link $http `$http`} params serializer that follows
	   * jQuery's [`param()`](http://api.jquery.com/jquery.param/) method logic.
	   * The serializer will also sort the params alphabetically.
	   *
	   * To use it for serializing `$http` request parameters, set it as the `paramSerializer` property:
	   *
	   * ```js
	   * $http({
	   *   url: myUrl,
	   *   method: 'GET',
	   *   params: myParams,
	   *   paramSerializer: '$httpParamSerializerJQLike'
	   * });
	   * ```
	   *
	   * It is also possible to set it as the default `paramSerializer` in the
	   * {@link $httpProvider#defaults `$httpProvider`}.
	   *
	   * Additionally, you can inject the serializer and use it explicitly, for example to serialize
	   * form data for submission:
	   *
	   * ```js
	   * .controller(function($http, $httpParamSerializerJQLike) {
	   *   //...
	   *
	   *   $http({
	   *     url: myUrl,
	   *     method: 'POST',
	   *     data: $httpParamSerializerJQLike(myData),
	   *     headers: {
	   *       'Content-Type': 'application/x-www-form-urlencoded'
	   *     }
	   *   });
	   *
	   * });
	   * ```
	   *
	   */
	  this.$get = function() {
	    return function jQueryLikeParamSerializer(params) {
	      if (!params) return '';
	      var parts = [];
	      serialize(params, '', true);
	      return parts.join('&');
	
	      function serialize(toSerialize, prefix, topLevel) {
	        if (isArray(toSerialize)) {
	          forEach(toSerialize, function(value, index) {
	            serialize(value, prefix + '[' + (isObject(value) ? index : '') + ']');
	          });
	        } else if (isObject(toSerialize) && !isDate(toSerialize)) {
	          forEachSorted(toSerialize, function(value, key) {
	            serialize(value, prefix +
	                (topLevel ? '' : '[') +
	                key +
	                (topLevel ? '' : ']'));
	          });
	        } else {
	          if (isFunction(toSerialize)) {
	            toSerialize = toSerialize();
	          }
	          parts.push(encodeUriQuery(prefix) + '=' +
	              (toSerialize == null ? '' : encodeUriQuery(serializeValue(toSerialize))));
	        }
	      }
	    };
	  };
	}
	
	function defaultHttpResponseTransform(data, headers) {
	  if (isString(data)) {
	    // Strip json vulnerability protection prefix and trim whitespace
	    var tempData = data.replace(JSON_PROTECTION_PREFIX, '').trim();
	
	    if (tempData) {
	      var contentType = headers('Content-Type');
	      var hasJsonContentType = contentType && (contentType.indexOf(APPLICATION_JSON) === 0);
	
	      if (hasJsonContentType || isJsonLike(tempData)) {
	        try {
	          data = fromJson(tempData);
	        } catch (e) {
	          if (!hasJsonContentType) {
	            return data;
	          }
	          throw $httpMinErr('baddata', 'Data must be a valid JSON object. Received: "{0}". ' +
	          'Parse error: "{1}"', data, e);
	        }
	      }
	    }
	  }
	
	  return data;
	}
	
	function isJsonLike(str) {
	    var jsonStart = str.match(JSON_START);
	    return jsonStart && JSON_ENDS[jsonStart[0]].test(str);
	}
	
	/**
	 * Parse headers into key value object
	 *
	 * @param {string} headers Raw headers as a string
	 * @returns {Object} Parsed headers as key value object
	 */
	function parseHeaders(headers) {
	  var parsed = createMap(), i;
	
	  function fillInParsed(key, val) {
	    if (key) {
	      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	    }
	  }
	
	  if (isString(headers)) {
	    forEach(headers.split('\n'), function(line) {
	      i = line.indexOf(':');
	      fillInParsed(lowercase(trim(line.substr(0, i))), trim(line.substr(i + 1)));
	    });
	  } else if (isObject(headers)) {
	    forEach(headers, function(headerVal, headerKey) {
	      fillInParsed(lowercase(headerKey), trim(headerVal));
	    });
	  }
	
	  return parsed;
	}
	
	
	/**
	 * Returns a function that provides access to parsed headers.
	 *
	 * Headers are lazy parsed when first requested.
	 * @see parseHeaders
	 *
	 * @param {(string|Object)} headers Headers to provide access to.
	 * @returns {function(string=)} Returns a getter function which if called with:
	 *
	 *   - if called with an argument returns a single header value or null
	 *   - if called with no arguments returns an object containing all headers.
	 */
	function headersGetter(headers) {
	  var headersObj;
	
	  return function(name) {
	    if (!headersObj) headersObj =  parseHeaders(headers);
	
	    if (name) {
	      var value = headersObj[lowercase(name)];
	      if (value === undefined) {
	        value = null;
	      }
	      return value;
	    }
	
	    return headersObj;
	  };
	}
	
	
	/**
	 * Chain all given functions
	 *
	 * This function is used for both request and response transforming
	 *
	 * @param {*} data Data to transform.
	 * @param {function(string=)} headers HTTP headers getter fn.
	 * @param {number} status HTTP status code of the response.
	 * @param {(Function|Array.<Function>)} fns Function or an array of functions.
	 * @returns {*} Transformed data.
	 */
	function transformData(data, headers, status, fns) {
	  if (isFunction(fns)) {
	    return fns(data, headers, status);
	  }
	
	  forEach(fns, function(fn) {
	    data = fn(data, headers, status);
	  });
	
	  return data;
	}
	
	
	function isSuccess(status) {
	  return 200 <= status && status < 300;
	}
	
	
	/**
	 * @ngdoc provider
	 * @name $httpProvider
	 * @this
	 *
	 * @description
	 * Use `$httpProvider` to change the default behavior of the {@link ng.$http $http} service.
	 */
	function $HttpProvider() {
	  /**
	   * @ngdoc property
	   * @name $httpProvider#defaults
	   * @description
	   *
	   * Object containing default values for all {@link ng.$http $http} requests.
	   *
	   * - **`defaults.cache`** - {boolean|Object} - A boolean value or object created with
	   * {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of HTTP responses
	   * by default. See {@link $http#caching $http Caching} for more information.
	   *
	   * - **`defaults.headers`** - {Object} - Default headers for all $http requests.
	   * Refer to {@link ng.$http#setting-http-headers $http} for documentation on
	   * setting default headers.
	   *     - **`defaults.headers.common`**
	   *     - **`defaults.headers.post`**
	   *     - **`defaults.headers.put`**
	   *     - **`defaults.headers.patch`**
	   *
	   * - **`defaults.jsonpCallbackParam`** - `{string}` - the name of the query parameter that passes the name of the
	   * callback in a JSONP request. The value of this parameter will be replaced with the expression generated by the
	   * {@link $jsonpCallbacks} service. Defaults to `'callback'`.
	   *
	   * - **`defaults.paramSerializer`** - `{string|function(Object<string,string>):string}` - A function
	   *  used to the prepare string representation of request parameters (specified as an object).
	   *  If specified as string, it is interpreted as a function registered with the {@link auto.$injector $injector}.
	   *  Defaults to {@link ng.$httpParamSerializer $httpParamSerializer}.
	   *
	   * - **`defaults.transformRequest`** -
	   * `{Array<function(data, headersGetter)>|function(data, headersGetter)}` -
	   * An array of functions (or a single function) which are applied to the request data.
	   * By default, this is an array with one request transformation function:
	   *
	   *   - If the `data` property of the request configuration object contains an object, serialize it
	   *     into JSON format.
	   *
	   * - **`defaults.transformResponse`** -
	   * `{Array<function(data, headersGetter, status)>|function(data, headersGetter, status)}` -
	   * An array of functions (or a single function) which are applied to the response data. By default,
	   * this is an array which applies one response transformation function that does two things:
	   *
	   *  - If XSRF prefix is detected, strip it
	   *    (see {@link ng.$http#security-considerations Security Considerations in the $http docs}).
	   *  - If the `Content-Type` is `application/json` or the response looks like JSON,
	   *    deserialize it using a JSON parser.
	   *
	   * - **`defaults.xsrfCookieName`** - {string} - Name of cookie containing the XSRF token.
	   * Defaults value is `'XSRF-TOKEN'`.
	   *
	   * - **`defaults.xsrfHeaderName`** - {string} - Name of HTTP header to populate with the
	   * XSRF token. Defaults value is `'X-XSRF-TOKEN'`.
	   *
	   */
	  var defaults = this.defaults = {
	    // transform incoming response data
	    transformResponse: [defaultHttpResponseTransform],
	
	    // transform outgoing request data
	    transformRequest: [function(d) {
	      return isObject(d) && !isFile(d) && !isBlob(d) && !isFormData(d) ? toJson(d) : d;
	    }],
	
	    // default headers
	    headers: {
	      common: {
	        'Accept': 'application/json, text/plain, */*'
	      },
	      post:   shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
	      put:    shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
	      patch:  shallowCopy(CONTENT_TYPE_APPLICATION_JSON)
	    },
	
	    xsrfCookieName: 'XSRF-TOKEN',
	    xsrfHeaderName: 'X-XSRF-TOKEN',
	
	    paramSerializer: '$httpParamSerializer',
	
	    jsonpCallbackParam: 'callback'
	  };
	
	  var useApplyAsync = false;
	  /**
	   * @ngdoc method
	   * @name $httpProvider#useApplyAsync
	   * @description
	   *
	   * Configure $http service to combine processing of multiple http responses received at around
	   * the same time via {@link ng.$rootScope.Scope#$applyAsync $rootScope.$applyAsync}. This can result in
	   * significant performance improvement for bigger applications that make many HTTP requests
	   * concurrently (common during application bootstrap).
	   *
	   * Defaults to false. If no value is specified, returns the current configured value.
	   *
	   * @param {boolean=} value If true, when requests are loaded, they will schedule a deferred
	   *    "apply" on the next tick, giving time for subsequent requests in a roughly ~10ms window
	   *    to load and share the same digest cycle.
	   *
	   * @returns {boolean|Object} If a value is specified, returns the $httpProvider for chaining.
	   *    otherwise, returns the current configured value.
	   */
	  this.useApplyAsync = function(value) {
	    if (isDefined(value)) {
	      useApplyAsync = !!value;
	      return this;
	    }
	    return useApplyAsync;
	  };
	
	  /**
	   * @ngdoc property
	   * @name $httpProvider#interceptors
	   * @description
	   *
	   * Array containing service factories for all synchronous or asynchronous {@link ng.$http $http}
	   * pre-processing of request or postprocessing of responses.
	   *
	   * These service factories are ordered by request, i.e. they are applied in the same order as the
	   * array, on request, but reverse order, on response.
	   *
	   * {@link ng.$http#interceptors Interceptors detailed info}
	   */
	  var interceptorFactories = this.interceptors = [];
	
	  /**
	   * @ngdoc property
	   * @name $httpProvider#xsrfTrustedOrigins
	   * @description
	   *
	   * Array containing URLs whose origins are trusted to receive the XSRF token. See the
	   * {@link ng.$http#security-considerations Security Considerations} sections for more details on
	   * XSRF.
	   *
	   * **Note:** An "origin" consists of the [URI scheme](https://en.wikipedia.org/wiki/URI_scheme),
	   * the [hostname](https://en.wikipedia.org/wiki/Hostname) and the
	   * [port number](https://en.wikipedia.org/wiki/Port_(computer_networking). For `http:` and
	   * `https:`, the port number can be omitted if using th default ports (80 and 443 respectively).
	   * Examples: `http://example.com`, `https://api.example.com:9876`
	   *
	   * <div class="alert alert-warning">
	   *   It is not possible to trust specific URLs/paths. The `path`, `query` and `fragment` parts
	   *   of a URL will be ignored. For example, `https://foo.com/path/bar?query=baz#fragment` will be
	   *   treated as `https://foo.com`, meaning that **all** requests to URLs starting with
	   *   `https://foo.com/` will include the XSRF token.
	   * </div>
	   *
	   * @example
	   *
	   * ```js
	   * // App served from `https://example.com/`.
	   * angular.
	   *   module('xsrfTrustedOriginsExample', []).
	   *   config(['$httpProvider', function($httpProvider) {
	   *     $httpProvider.xsrfTrustedOrigins.push('https://api.example.com');
	   *   }]).
	   *   run(['$http', function($http) {
	   *     // The XSRF token will be sent.
	   *     $http.get('https://api.example.com/preferences').then(...);
	   *
	   *     // The XSRF token will NOT be sent.
	   *     $http.get('https://stats.example.com/activity').then(...);
	   *   }]);
	   * ```
	   */
	  var xsrfTrustedOrigins = this.xsrfTrustedOrigins = [];
	
	  /**
	   * @ngdoc property
	   * @name $httpProvider#xsrfWhitelistedOrigins
	   * @description
	   *
	   * @deprecated
	   * sinceVersion="1.8.1"
	   *
	   * This property is deprecated. Use {@link $httpProvider#xsrfTrustedOrigins xsrfTrustedOrigins}
	   * instead.
	   */
	  Object.defineProperty(this, 'xsrfWhitelistedOrigins', {
	    get: function() {
	      return this.xsrfTrustedOrigins;
	    },
	    set: function(origins) {
	      this.xsrfTrustedOrigins = origins;
	    }
	  });
	
	  this.$get = ['$browser', '$httpBackend', '$$cookieReader', '$cacheFactory', '$rootScope', '$q', '$injector', '$sce',
	      function($browser, $httpBackend, $$cookieReader, $cacheFactory, $rootScope, $q, $injector, $sce) {
	
	    var defaultCache = $cacheFactory('$http');
	
	    /**
	     * Make sure that default param serializer is exposed as a function
	     */
	    defaults.paramSerializer = isString(defaults.paramSerializer) ?
	      $injector.get(defaults.paramSerializer) : defaults.paramSerializer;
	
	    /**
	     * Interceptors stored in reverse order. Inner interceptors before outer interceptors.
	     * The reversal is needed so that we can build up the interception chain around the
	     * server request.
	     */
	    var reversedInterceptors = [];
	
	    forEach(interceptorFactories, function(interceptorFactory) {
	      reversedInterceptors.unshift(isString(interceptorFactory)
	          ? $injector.get(interceptorFactory) : $injector.invoke(interceptorFactory));
	    });
	
	    /**
	     * A function to check request URLs against a list of allowed origins.
	     */
	    var urlIsAllowedOrigin = urlIsAllowedOriginFactory(xsrfTrustedOrigins);
	
	    /**
	     * @ngdoc service
	     * @kind function
	     * @name $http
	     * @requires ng.$httpBackend
	     * @requires $cacheFactory
	     * @requires $rootScope
	     * @requires $q
	     * @requires $injector
	     *
	     * @description
	     * The `$http` service is a core AngularJS service that facilitates communication with the remote
	     * HTTP servers via the browser's [XMLHttpRequest](https://developer.mozilla.org/en/xmlhttprequest)
	     * object or via [JSONP](http://en.wikipedia.org/wiki/JSONP).
	     *
	     * For unit testing applications that use `$http` service, see
	     * {@link ngMock.$httpBackend $httpBackend mock}.
	     *
	     * For a higher level of abstraction, please check out the {@link ngResource.$resource
	     * $resource} service.
	     *
	     * The $http API is based on the {@link ng.$q deferred/promise APIs} exposed by
	     * the $q service. While for simple usage patterns this doesn't matter much, for advanced usage
	     * it is important to familiarize yourself with these APIs and the guarantees they provide.
	     *
	     *
	     * ## General usage
	     * The `$http` service is a function which takes a single argument — a {@link $http#usage configuration object} —
	     * that is used to generate an HTTP request and returns  a {@link ng.$q promise} that is
	     * resolved (request success) or rejected (request failure) with a
	     * {@link ng.$http#$http-returns response} object.
	     *
	     * ```js
	     *   // Simple GET request example:
	     *   $http({
	     *     method: 'GET',
	     *     url: '/someUrl'
	     *   }).then(function successCallback(response) {
	     *       // this callback will be called asynchronously
	     *       // when the response is available
	     *     }, function errorCallback(response) {
	     *       // called asynchronously if an error occurs
	     *       // or server returns response with an error status.
	     *     });
	     * ```
	     *
	     *
	     * ## Shortcut methods
	     *
	     * Shortcut methods are also available. All shortcut methods require passing in the URL, and
	     * request data must be passed in for POST/PUT requests. An optional config can be passed as the
	     * last argument.
	     *
	     * ```js
	     *   $http.get('/someUrl', config).then(successCallback, errorCallback);
	     *   $http.post('/someUrl', data, config).then(successCallback, errorCallback);
	     * ```
	     *
	     * Complete list of shortcut methods:
	     *
	     * - {@link ng.$http#get $http.get}
	     * - {@link ng.$http#head $http.head}
	     * - {@link ng.$http#post $http.post}
	     * - {@link ng.$http#put $http.put}
	     * - {@link ng.$http#delete $http.delete}
	     * - {@link ng.$http#jsonp $http.jsonp}
	     * - {@link ng.$http#patch $http.patch}
	     *
	     *
	     * ## Writing Unit Tests that use $http
	     * When unit testing (using {@link ngMock ngMock}), it is necessary to call
	     * {@link ngMock.$httpBackend#flush $httpBackend.flush()} to flush each pending
	     * request using trained responses.
	     *
	     * ```
	     * $httpBackend.expectGET(...);
	     * $http.get(...);
	     * $httpBackend.flush();
	     * ```
	     *
	     * ## Setting HTTP Headers
	     *
	     * The $http service will automatically add certain HTTP headers to all requests. These defaults
	     * can be fully configured by accessing the `$httpProvider.defaults.headers` configuration
	     * object, which currently contains this default configuration:
	     *
	     * - `$httpProvider.defaults.headers.common` (headers that are common for all requests):
	     *   - <code>Accept: application/json, text/plain, \*&#65279;/&#65279;\*</code>
	     * - `$httpProvider.defaults.headers.post`: (header defaults for POST requests)
	     *   - `Content-Type: application/json`
	     * - `$httpProvider.defaults.headers.put` (header defaults for PUT requests)
	     *   - `Content-Type: application/json`
	     *
	     * To add or overwrite these defaults, simply add or remove a property from these configuration
	     * objects. To add headers for an HTTP method other than POST or PUT, simply add a new object
	     * with the lowercased HTTP method name as the key, e.g.
	     * `$httpProvider.defaults.headers.get = { 'My-Header' : 'value' }`.
	     *
	     * The defaults can also be set at runtime via the `$http.defaults` object in the same
	     * fashion. For example:
	     *
	     * ```
	     * module.run(function($http) {
	     *   $http.defaults.headers.common.Authorization = 'Basic YmVlcDpib29w';
	     * });
	     * ```
	     *
	     * In addition, you can supply a `headers` property in the config object passed when
	     * calling `$http(config)`, which overrides the defaults without changing them globally.
	     *
	     * To explicitly remove a header automatically added via $httpProvider.defaults.headers on a per request basis,
	     * Use the `headers` property, setting the desired header to `undefined`. For example:
	     *
	     * ```js
	     * var req = {
	     *  method: 'POST',
	     *  url: 'http://example.com',
	     *  headers: {
	     *    'Content-Type': undefined
	     *  },
	     *  data: { test: 'test' }
	     * }
	     *
	     * $http(req).then(function(){...}, function(){...});
	     * ```
	     *
	     * ## Transforming Requests and Responses
	     *
	     * Both requests and responses can be transformed using transformation functions: `transformRequest`
	     * and `transformResponse`. These properties can be a single function that returns
	     * the transformed value (`function(data, headersGetter, status)`) or an array of such transformation functions,
	     * which allows you to `push` or `unshift` a new transformation function into the transformation chain.
	     *
	     * <div class="alert alert-warning">
	     * **Note:** AngularJS does not make a copy of the `data` parameter before it is passed into the `transformRequest` pipeline.
	     * That means changes to the properties of `data` are not local to the transform function (since Javascript passes objects by reference).
	     * For example, when calling `$http.get(url, $scope.myObject)`, modifications to the object's properties in a transformRequest
	     * function will be reflected on the scope and in any templates where the object is data-bound.
	     * To prevent this, transform functions should have no side-effects.
	     * If you need to modify properties, it is recommended to make a copy of the data, or create new object to return.
	     * </div>
	     *
	     * ### Default Transformations
	     *
	     * The `$httpProvider` provider and `$http` service expose `defaults.transformRequest` and
	     * `defaults.transformResponse` properties. If a request does not provide its own transformations
	     * then these will be applied.
	     *
	     * You can augment or replace the default transformations by modifying these properties by adding to or
	     * replacing the array.
	     *
	     * AngularJS provides the following default transformations:
	     *
	     * Request transformations (`$httpProvider.defaults.transformRequest` and `$http.defaults.transformRequest`) is
	     * an array with one function that does the following:
	     *
	     * - If the `data` property of the request configuration object contains an object, serialize it
	     *   into JSON format.
	     *
	     * Response transformations (`$httpProvider.defaults.transformResponse` and `$http.defaults.transformResponse`) is
	     * an array with one function that does the following:
	     *
	     *  - If XSRF prefix is detected, strip it (see Security Considerations section below).
	     *  - If the `Content-Type` is `application/json` or the response looks like JSON,
	   *      deserialize it using a JSON parser.
	     *
	     *
	     * ### Overriding the Default Transformations Per Request
	     *
	     * If you wish to override the request/response transformations only for a single request then provide
	     * `transformRequest` and/or `transformResponse` properties on the configuration object passed
	     * into `$http`.
	     *
	     * Note that if you provide these properties on the config object the default transformations will be
	     * overwritten. If you wish to augment the default transformations then you must include them in your
	     * local transformation array.
	     *
	     * The following code demonstrates adding a new response transformation to be run after the default response
	     * transformations have been run.
	     *
	     * ```js
	     * function appendTransform(defaults, transform) {
	     *
	     *   // We can't guarantee that the default transformation is an array
	     *   defaults = angular.isArray(defaults) ? defaults : [defaults];
	     *
	     *   // Append the new transformation to the defaults
	     *   return defaults.concat(transform);
	     * }
	     *
	     * $http({
	     *   url: '...',
	     *   method: 'GET',
	     *   transformResponse: appendTransform($http.defaults.transformResponse, function(value) {
	     *     return doTransform(value);
	     *   })
	     * });
	     * ```
	     *
	     *
	     * ## Caching
	     *
	     * {@link ng.$http `$http`} responses are not cached by default. To enable caching, you must
	     * set the config.cache value or the default cache value to TRUE or to a cache object (created
	     * with {@link ng.$cacheFactory `$cacheFactory`}). If defined, the value of config.cache takes
	     * precedence over the default cache value.
	     *
	     * In order to:
	     *   * cache all responses - set the default cache value to TRUE or to a cache object
	     *   * cache a specific response - set config.cache value to TRUE or to a cache object
	     *
	     * If caching is enabled, but neither the default cache nor config.cache are set to a cache object,
	     * then the default `$cacheFactory("$http")` object is used.
	     *
	     * The default cache value can be set by updating the
	     * {@link ng.$http#defaults `$http.defaults.cache`} property or the
	     * {@link $httpProvider#defaults `$httpProvider.defaults.cache`} property.
	     *
	     * When caching is enabled, {@link ng.$http `$http`} stores the response from the server using
	     * the relevant cache object. The next time the same request is made, the response is returned
	     * from the cache without sending a request to the server.
	     *
	     * Take note that:
	     *
	     *   * Only GET and JSONP requests are cached.
	     *   * The cache key is the request URL including search parameters; headers are not considered.
	     *   * Cached responses are returned asynchronously, in the same way as responses from the server.
	     *   * If multiple identical requests are made using the same cache, which is not yet populated,
	     *     one request will be made to the server and remaining requests will return the same response.
	     *   * A cache-control header on the response does not affect if or how responses are cached.
	     *
	     *
	     * ## Interceptors
	     *
	     * Before you start creating interceptors, be sure to understand the
	     * {@link ng.$q $q and deferred/promise APIs}.
	     *
	     * For purposes of global error handling, authentication, or any kind of synchronous or
	     * asynchronous pre-processing of request or postprocessing of responses, it is desirable to be
	     * able to intercept requests before they are handed to the server and
	     * responses before they are handed over to the application code that
	     * initiated these requests. The interceptors leverage the {@link ng.$q
	     * promise APIs} to fulfill this need for both synchronous and asynchronous pre-processing.
	     *
	     * The interceptors are service factories that are registered with the `$httpProvider` by
	     * adding them to the `$httpProvider.interceptors` array. The factory is called and
	     * injected with dependencies (if specified) and returns the interceptor.
	     *
	     * There are two kinds of interceptors (and two kinds of rejection interceptors):
	     *
	     *   * `request`: interceptors get called with a http {@link $http#usage config} object. The function is free to
	     *     modify the `config` object or create a new one. The function needs to return the `config`
	     *     object directly, or a promise containing the `config` or a new `config` object.
	     *   * `requestError`: interceptor gets called when a previous interceptor threw an error or
	     *     resolved with a rejection.
	     *   * `response`: interceptors get called with http `response` object. The function is free to
	     *     modify the `response` object or create a new one. The function needs to return the `response`
	     *     object directly, or as a promise containing the `response` or a new `response` object.
	     *   * `responseError`: interceptor gets called when a previous interceptor threw an error or
	     *     resolved with a rejection.
	     *
	     *
	     * ```js
	     *   // register the interceptor as a service
	     *   $provide.factory('myHttpInterceptor', function($q, dependency1, dependency2) {
	     *     return {
	     *       // optional method
	     *       'request': function(config) {
	     *         // do something on success
	     *         return config;
	     *       },
	     *
	     *       // optional method
	     *      'requestError': function(rejection) {
	     *         // do something on error
	     *         if (canRecover(rejection)) {
	     *           return responseOrNewPromise
	     *         }
	     *         return $q.reject(rejection);
	     *       },
	     *
	     *
	     *
	     *       // optional method
	     *       'response': function(response) {
	     *         // do something on success
	     *         return response;
	     *       },
	     *
	     *       // optional method
	     *      'responseError': function(rejection) {
	     *         // do something on error
	     *         if (canRecover(rejection)) {
	     *           return responseOrNewPromise
	     *         }
	     *         return $q.reject(rejection);
	     *       }
	     *     };
	     *   });
	     *
	     *   $httpProvider.interceptors.push('myHttpInterceptor');
	     *
	     *
	     *   // alternatively, register the interceptor via an anonymous factory
	     *   $httpProvider.interceptors.push(function($q, dependency1, dependency2) {
	     *     return {
	     *      'request': function(config) {
	     *          // same as above
	     *       },
	     *
	     *       'response': function(response) {
	     *          // same as above
	     *       }
	     *     };
	     *   });
	     * ```
	     *
	     * ## Security Considerations
	     *
	     * When designing web applications, consider security threats from:
	     *
	     * - [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
	     * - [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery)
	     *
	     * Both server and the client must cooperate in order to eliminate these threats. AngularJS comes
	     * pre-configured with strategies that address these issues, but for this to work backend server
	     * cooperation is required.
	     *
	     * ### JSON Vulnerability Protection
	     *
	     * A [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
	     * allows third party website to turn your JSON resource URL into
	     * [JSONP](http://en.wikipedia.org/wiki/JSONP) request under some conditions. To
	     * counter this your server can prefix all JSON requests with following string `")]}',\n"`.
	     * AngularJS will automatically strip the prefix before processing it as JSON.
	     *
	     * For example if your server needs to return:
	     * ```js
	     * ['one','two']
	     * ```
	     *
	     * which is vulnerable to attack, your server can return:
	     * ```js
	     * )]}',
	     * ['one','two']
	     * ```
	     *
	     * AngularJS will strip the prefix, before processing the JSON.
	     *
	     *
	     * ### Cross Site Request Forgery (XSRF) Protection
	     *
	     * [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery) is an attack technique by
	     * which the attacker can trick an authenticated user into unknowingly executing actions on your
	     * website. AngularJS provides a mechanism to counter XSRF. When performing XHR requests, the
	     * $http service reads a token from a cookie (by default, `XSRF-TOKEN`) and sets it as an HTTP
	     * header (by default `X-XSRF-TOKEN`). Since only JavaScript that runs on your domain could read
	     * the cookie, your server can be assured that the XHR came from JavaScript running on your
	     * domain.
	     *
	     * To take advantage of this, your server needs to set a token in a JavaScript readable session
	     * cookie called `XSRF-TOKEN` on the first HTTP GET request. On subsequent XHR requests the
	     * server can verify that the cookie matches the `X-XSRF-TOKEN` HTTP header, and therefore be
	     * sure that only JavaScript running on your domain could have sent the request. The token must
	     * be unique for each user and must be verifiable by the server (to prevent the JavaScript from
	     * making up its own tokens). We recommend that the token is a digest of your site's
	     * authentication cookie with a [salt](https://en.wikipedia.org/wiki/Salt_(cryptography&#41;)
	     * for added security.
	     *
	     * The header will &mdash; by default &mdash; **not** be set for cross-domain requests. This
	     * prevents unauthorized servers (e.g. malicious or compromised 3rd-party APIs) from gaining
	     * access to your users' XSRF tokens and exposing them to Cross Site Request Forgery. If you
	     * want to, you can trust additional origins to also receive the XSRF token, by adding them
	     * to {@link ng.$httpProvider#xsrfTrustedOrigins xsrfTrustedOrigins}. This might be
	     * useful, for example, if your application, served from `example.com`, needs to access your API
	     * at `api.example.com`.
	     * See {@link ng.$httpProvider#xsrfTrustedOrigins $httpProvider.xsrfTrustedOrigins} for
	     * more details.
	     *
	     * <div class="alert alert-danger">
	     *   **Warning**<br />
	     *   Only trusted origins that you have control over and make sure you understand the
	     *   implications of doing so.
	     * </div>
	     *
	     * The name of the cookie and the header can be specified using the `xsrfCookieName` and
	     * `xsrfHeaderName` properties of either `$httpProvider.defaults` at config-time,
	     * `$http.defaults` at run-time, or the per-request config object.
	     *
	     * In order to prevent collisions in environments where multiple AngularJS apps share the
	     * same domain or subdomain, we recommend that each application uses a unique cookie name.
	     *
	     *
	     * @param {object} config Object describing the request to be made and how it should be
	     *    processed. The object has following properties:
	     *
	     *    - **method** – `{string}` – HTTP method (e.g. 'GET', 'POST', etc)
	     *    - **url** – `{string|TrustedObject}` – Absolute or relative URL of the resource that is being requested;
	     *      or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     *    - **params** – `{Object.<string|Object>}` – Map of strings or objects which will be serialized
	     *      with the `paramSerializer` and appended as GET parameters.
	     *    - **data** – `{string|Object}` – Data to be sent as the request message data.
	     *    - **headers** – `{Object}` – Map of strings or functions which return strings representing
	     *      HTTP headers to send to the server. If the return value of a function is null, the
	     *      header will not be sent. Functions accept a config object as an argument.
	     *    - **eventHandlers** - `{Object}` - Event listeners to be bound to the XMLHttpRequest object.
	     *      To bind events to the XMLHttpRequest upload object, use `uploadEventHandlers`.
	     *      The handler will be called in the context of a `$apply` block.
	     *    - **uploadEventHandlers** - `{Object}` - Event listeners to be bound to the XMLHttpRequest upload
	     *      object. To bind events to the XMLHttpRequest object, use `eventHandlers`.
	     *      The handler will be called in the context of a `$apply` block.
	     *    - **xsrfHeaderName** – `{string}` – Name of HTTP header to populate with the XSRF token.
	     *    - **xsrfCookieName** – `{string}` – Name of cookie containing the XSRF token.
	     *    - **transformRequest** –
	     *      `{function(data, headersGetter)|Array.<function(data, headersGetter)>}` –
	     *      transform function or an array of such functions. The transform function takes the http
	     *      request body and headers and returns its transformed (typically serialized) version.
	     *      See {@link ng.$http#overriding-the-default-transformations-per-request
	     *      Overriding the Default Transformations}
	     *    - **transformResponse** –
	     *      `{function(data, headersGetter, status)|Array.<function(data, headersGetter, status)>}` –
	     *      transform function or an array of such functions. The transform function takes the http
	     *      response body, headers and status and returns its transformed (typically deserialized) version.
	     *      See {@link ng.$http#overriding-the-default-transformations-per-request
	     *      Overriding the Default Transformations}
	     *    - **paramSerializer** - `{string|function(Object<string,string>):string}` - A function used to
	     *      prepare the string representation of request parameters (specified as an object).
	     *      If specified as string, it is interpreted as function registered with the
	     *      {@link $injector $injector}, which means you can create your own serializer
	     *      by registering it as a {@link auto.$provide#service service}.
	     *      The default serializer is the {@link $httpParamSerializer $httpParamSerializer};
	     *      alternatively, you can use the {@link $httpParamSerializerJQLike $httpParamSerializerJQLike}
	     *    - **cache** – `{boolean|Object}` – A boolean value or object created with
	     *      {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of the HTTP response.
	     *      See {@link $http#caching $http Caching} for more information.
	     *    - **timeout** – `{number|Promise}` – timeout in milliseconds, or {@link ng.$q promise}
	     *      that should abort the request when resolved.
	     *
	     *      A numerical timeout or a promise returned from {@link ng.$timeout $timeout}, will set
	     *      the `xhrStatus` in the {@link $http#$http-returns response} to "timeout", and any other
	     *      resolved promise will set it to "abort", following standard XMLHttpRequest behavior.
	     *
	     *    - **withCredentials** - `{boolean}` - whether to set the `withCredentials` flag on the
	     *      XHR object. See [requests with credentials](https://developer.mozilla.org/docs/Web/HTTP/Access_control_CORS#Requests_with_credentials)
	     *      for more information.
	     *    - **responseType** - `{string}` - see
	     *      [XMLHttpRequest.responseType](https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest#xmlhttprequest-responsetype).
	     *
	     * @returns {HttpPromise} A {@link ng.$q `Promise}` that will be resolved (request success)
	     *   or rejected (request failure) with a response object.
	     *
	     *   The response object has these properties:
	     *
	     *   - **data** – `{string|Object}` – The response body transformed with
	     *     the transform functions.
	     *   - **status** – `{number}` – HTTP status code of the response.
	     *   - **headers** – `{function([headerName])}` – Header getter function.
	     *   - **config** – `{Object}` – The configuration object that was used
	     *     to generate the request.
	     *   - **statusText** – `{string}` – HTTP status text of the response.
	     *   - **xhrStatus** – `{string}` – Status of the XMLHttpRequest
	     *     (`complete`, `error`, `timeout` or `abort`).
	     *
	     *
	     *   A response status code between 200 and 299 is considered a success status
	     *   and will result in the success callback being called. Any response status
	     *   code outside of that range is considered an error status and will result
	     *   in the error callback being called.
	     *   Also, status codes less than -1 are normalized to zero. -1 usually means
	     *   the request was aborted, e.g. using a `config.timeout`. More information
	     *   about the status might be available in the `xhrStatus` property.
	     *
	     *   Note that if the response is a redirect, XMLHttpRequest will transparently
	     *   follow it, meaning that the outcome (success or error) will be determined
	     *   by the final response status code.
	     *
	     *
	     * @property {Array.<Object>} pendingRequests Array of config objects for currently pending
	     *   requests. This is primarily meant to be used for debugging purposes.
	     *
	     *
	     * @example
	<example module="httpExample" name="http-service">
	<file name="index.html">
	  <div ng-controller="FetchController">
	    <select ng-model="method" aria-label="Request method">
	      <option>GET</option>
	      <option>JSONP</option>
	    </select>
	    <input type="text" ng-model="url" size="80" aria-label="URL" />
	    <button id="fetchbtn" ng-click="fetch()">fetch</button><br>
	    <button id="samplegetbtn" ng-click="updateModel('GET', 'http-hello.html')">Sample GET</button>
	    <button id="samplejsonpbtn"
	      ng-click="updateModel('JSONP',
	                    'https://angularjs.org/greet.php?name=Super%20Hero')">
	      Sample JSONP
	    </button>
	    <button id="invalidjsonpbtn"
	      ng-click="updateModel('JSONP', 'https://angularjs.org/doesntexist')">
	        Invalid JSONP
	      </button>
	    <pre>http status code: {{status}}</pre>
	    <pre>http response data: {{data}}</pre>
	  </div>
	</file>
	<file name="script.js">
	  angular.module('httpExample', [])
	    .config(['$sceDelegateProvider', function($sceDelegateProvider) {
	      // We must add the JSONP endpoint that we are using to the trusted list to show that we trust it
	      $sceDelegateProvider.trustedResourceUrlList([
	        'self',
	        'https://angularjs.org/**'
	      ]);
	    }])
	    .controller('FetchController', ['$scope', '$http', '$templateCache',
	      function($scope, $http, $templateCache) {
	        $scope.method = 'GET';
	        $scope.url = 'http-hello.html';
	
	        $scope.fetch = function() {
	          $scope.code = null;
	          $scope.response = null;
	
	          $http({method: $scope.method, url: $scope.url, cache: $templateCache}).
	            then(function(response) {
	              $scope.status = response.status;
	              $scope.data = response.data;
	            }, function(response) {
	              $scope.data = response.data || 'Request failed';
	              $scope.status = response.status;
	          });
	        };
	
	        $scope.updateModel = function(method, url) {
	          $scope.method = method;
	          $scope.url = url;
	        };
	      }]);
	</file>
	<file name="http-hello.html">
	  Hello, $http!
	</file>
	<file name="protractor.js" type="protractor">
	  var status = element(by.binding('status'));
	  var data = element(by.binding('data'));
	  var fetchBtn = element(by.id('fetchbtn'));
	  var sampleGetBtn = element(by.id('samplegetbtn'));
	  var invalidJsonpBtn = element(by.id('invalidjsonpbtn'));
	
	  it('should make an xhr GET request', function() {
	    sampleGetBtn.click();
	    fetchBtn.click();
	    expect(status.getText()).toMatch('200');
	    expect(data.getText()).toMatch(/Hello, \$http!/);
	  });
	
	// Commented out due to flakes. See https://github.com/angular/angular.js/issues/9185
	// it('should make a JSONP request to angularjs.org', function() {
	//   var sampleJsonpBtn = element(by.id('samplejsonpbtn'));
	//   sampleJsonpBtn.click();
	//   fetchBtn.click();
	//   expect(status.getText()).toMatch('200');
	//   expect(data.getText()).toMatch(/Super Hero!/);
	// });
	
	  it('should make JSONP request to invalid URL and invoke the error handler',
	      function() {
	    invalidJsonpBtn.click();
	    fetchBtn.click();
	    expect(status.getText()).toMatch('0');
	    expect(data.getText()).toMatch('Request failed');
	  });
	</file>
	</example>
	     */
	    function $http(requestConfig) {
	
	      if (!isObject(requestConfig)) {
	        throw minErr('$http')('badreq', 'Http request configuration must be an object.  Received: {0}', requestConfig);
	      }
	
	      if (!isString($sce.valueOf(requestConfig.url))) {
	        throw minErr('$http')('badreq', 'Http request configuration url must be a string or a $sce trusted object.  Received: {0}', requestConfig.url);
	      }
	
	      var config = extend({
	        method: 'get',
	        transformRequest: defaults.transformRequest,
	        transformResponse: defaults.transformResponse,
	        paramSerializer: defaults.paramSerializer,
	        jsonpCallbackParam: defaults.jsonpCallbackParam
	      }, requestConfig);
	
	      config.headers = mergeHeaders(requestConfig);
	      config.method = uppercase(config.method);
	      config.paramSerializer = isString(config.paramSerializer) ?
	          $injector.get(config.paramSerializer) : config.paramSerializer;
	
	      $browser.$$incOutstandingRequestCount('$http');
	
	      var requestInterceptors = [];
	      var responseInterceptors = [];
	      var promise = $q.resolve(config);
	
	      // apply interceptors
	      forEach(reversedInterceptors, function(interceptor) {
	        if (interceptor.request || interceptor.requestError) {
	          requestInterceptors.unshift(interceptor.request, interceptor.requestError);
	        }
	        if (interceptor.response || interceptor.responseError) {
	          responseInterceptors.push(interceptor.response, interceptor.responseError);
	        }
	      });
	
	      promise = chainInterceptors(promise, requestInterceptors);
	      promise = promise.then(serverRequest);
	      promise = chainInterceptors(promise, responseInterceptors);
	      promise = promise.finally(completeOutstandingRequest);
	
	      return promise;
	
	
	      function chainInterceptors(promise, interceptors) {
	        for (var i = 0, ii = interceptors.length; i < ii;) {
	          var thenFn = interceptors[i++];
	          var rejectFn = interceptors[i++];
	
	          promise = promise.then(thenFn, rejectFn);
	        }
	
	        interceptors.length = 0;
	
	        return promise;
	      }
	
	      function completeOutstandingRequest() {
	        $browser.$$completeOutstandingRequest(noop, '$http');
	      }
	
	      function executeHeaderFns(headers, config) {
	        var headerContent, processedHeaders = {};
	
	        forEach(headers, function(headerFn, header) {
	          if (isFunction(headerFn)) {
	            headerContent = headerFn(config);
	            if (headerContent != null) {
	              processedHeaders[header] = headerContent;
	            }
	          } else {
	            processedHeaders[header] = headerFn;
	          }
	        });
	
	        return processedHeaders;
	      }
	
	      function mergeHeaders(config) {
	        var defHeaders = defaults.headers,
	            reqHeaders = extend({}, config.headers),
	            defHeaderName, lowercaseDefHeaderName, reqHeaderName;
	
	        defHeaders = extend({}, defHeaders.common, defHeaders[lowercase(config.method)]);
	
	        // using for-in instead of forEach to avoid unnecessary iteration after header has been found
	        defaultHeadersIteration:
	        for (defHeaderName in defHeaders) {
	          lowercaseDefHeaderName = lowercase(defHeaderName);
	
	          for (reqHeaderName in reqHeaders) {
	            if (lowercase(reqHeaderName) === lowercaseDefHeaderName) {
	              continue defaultHeadersIteration;
	            }
	          }
	
	          reqHeaders[defHeaderName] = defHeaders[defHeaderName];
	        }
	
	        // execute if header value is a function for merged headers
	        return executeHeaderFns(reqHeaders, shallowCopy(config));
	      }
	
	      function serverRequest(config) {
	        var headers = config.headers;
	        var reqData = transformData(config.data, headersGetter(headers), undefined, config.transformRequest);
	
	        // strip content-type if data is undefined
	        if (isUndefined(reqData)) {
	          forEach(headers, function(value, header) {
	            if (lowercase(header) === 'content-type') {
	              delete headers[header];
	            }
	          });
	        }
	
	        if (isUndefined(config.withCredentials) && !isUndefined(defaults.withCredentials)) {
	          config.withCredentials = defaults.withCredentials;
	        }
	
	        // send request
	        return sendReq(config, reqData).then(transformResponse, transformResponse);
	      }
	
	      function transformResponse(response) {
	        // make a copy since the response must be cacheable
	        var resp = extend({}, response);
	        resp.data = transformData(response.data, response.headers, response.status,
	                                  config.transformResponse);
	        return (isSuccess(response.status))
	          ? resp
	          : $q.reject(resp);
	      }
	    }
	
	    $http.pendingRequests = [];
	
	    /**
	     * @ngdoc method
	     * @name $http#get
	     *
	     * @description
	     * Shortcut method to perform `GET` request.
	     *
	     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
	     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
	     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
	     * See {@link ng.$http#$http-returns `$http()` return value}.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#delete
	     *
	     * @description
	     * Shortcut method to perform `DELETE` request.
	     *
	     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
	     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
	     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
	     * See {@link ng.$http#$http-returns `$http()` return value}.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#head
	     *
	     * @description
	     * Shortcut method to perform `HEAD` request.
	     *
	     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
	     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
	     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
	     * See {@link ng.$http#$http-returns `$http()` return value}.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#jsonp
	     *
	     * @description
	     * Shortcut method to perform `JSONP` request.
	     *
	     * Note that, since JSONP requests are sensitive because the response is given full access to the browser,
	     * the url must be declared, via {@link $sce} as a trusted resource URL.
	     * You can trust a URL by adding it to the trusted resource URL list via
	     * {@link $sceDelegateProvider#trustedResourceUrlList  `$sceDelegateProvider.trustedResourceUrlList`} or
	     * by explicitly trusting the URL via {@link $sce#trustAsResourceUrl `$sce.trustAsResourceUrl(url)`}.
	     *
	     * You should avoid generating the URL for the JSONP request from user provided data.
	     * Provide additional query parameters via `params` property of the `config` parameter, rather than
	     * modifying the URL itself.
	     *
	     * JSONP requests must specify a callback to be used in the response from the server. This callback
	     * is passed as a query parameter in the request. You must specify the name of this parameter by
	     * setting the `jsonpCallbackParam` property on the request config object.
	     *
	     * ```
	     * $http.jsonp('some/trusted/url', {jsonpCallbackParam: 'callback'})
	     * ```
	     *
	     * You can also specify a default callback parameter name in `$http.defaults.jsonpCallbackParam`.
	     * Initially this is set to `'callback'`.
	     *
	     * <div class="alert alert-danger">
	     * You can no longer use the `JSON_CALLBACK` string as a placeholder for specifying where the callback
	     * parameter value should go.
	     * </div>
	     *
	     * If you would like to customise where and how the callbacks are stored then try overriding
	     * or decorating the {@link $jsonpCallbacks} service.
	     *
	     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
	     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
	     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
	     * See {@link ng.$http#$http-returns `$http()` return value}.
	     */
	    createShortMethods('get', 'delete', 'head', 'jsonp');
	
	    /**
	     * @ngdoc method
	     * @name $http#post
	     *
	     * @description
	     * Shortcut method to perform `POST` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request
	     * @param {*} data Request content
	     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
	     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
	     * See {@link ng.$http#$http-returns `$http()` return value}.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#put
	     *
	     * @description
	     * Shortcut method to perform `PUT` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request
	     * @param {*} data Request content
	     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
	     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
	     * See {@link ng.$http#$http-returns `$http()` return value}.
	     */
	
	     /**
	      * @ngdoc method
	      * @name $http#patch
	      *
	      * @description
	      * Shortcut method to perform `PATCH` request.
	      *
	      * @param {string} url Relative or absolute URL specifying the destination of the request
	      * @param {*} data Request content
	      * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
	      * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
	      * See {@link ng.$http#$http-returns `$http()` return value}.
	      */
	    createShortMethodsWithData('post', 'put', 'patch');
	
	        /**
	         * @ngdoc property
	         * @name $http#defaults
	         *
	         * @description
	         * Runtime equivalent of the `$httpProvider.defaults` property. Allows configuration of
	         * default headers, withCredentials as well as request and response transformations.
	         *
	         * See "Setting HTTP Headers" and "Transforming Requests and Responses" sections above.
	         */
	    $http.defaults = defaults;
	
	
	    return $http;
	
	
	    function createShortMethods(names) {
	      forEach(arguments, function(name) {
	        $http[name] = function(url, config) {
	          return $http(extend({}, config || {}, {
	            method: name,
	            url: url
	          }));
	        };
	      });
	    }
	
	
	    function createShortMethodsWithData(name) {
	      forEach(arguments, function(name) {
	        $http[name] = function(url, data, config) {
	          return $http(extend({}, config || {}, {
	            method: name,
	            url: url,
	            data: data
	          }));
	        };
	      });
	    }
	
	
	    /**
	     * Makes the request.
	     *
	     * !!! ACCESSES CLOSURE VARS:
	     * $httpBackend, defaults, $log, $rootScope, defaultCache, $http.pendingRequests
	     */
	    function sendReq(config, reqData) {
	      var deferred = $q.defer(),
	          promise = deferred.promise,
	          cache,
	          cachedResp,
	          reqHeaders = config.headers,
	          isJsonp = lowercase(config.method) === 'jsonp',
	          url = config.url;
	
	      if (isJsonp) {
	        // JSONP is a pretty sensitive operation where we're allowing a script to have full access to
	        // our DOM and JS space.  So we require that the URL satisfies SCE.RESOURCE_URL.
	        url = $sce.getTrustedResourceUrl(url);
	      } else if (!isString(url)) {
	        // If it is not a string then the URL must be a $sce trusted object
	        url = $sce.valueOf(url);
	      }
	
	      url = buildUrl(url, config.paramSerializer(config.params));
	
	      if (isJsonp) {
	        // Check the url and add the JSONP callback placeholder
	        url = sanitizeJsonpCallbackParam(url, config.jsonpCallbackParam);
	      }
	
	      $http.pendingRequests.push(config);
	      promise.then(removePendingReq, removePendingReq);
	
	      if ((config.cache || defaults.cache) && config.cache !== false &&
	          (config.method === 'GET' || config.method === 'JSONP')) {
	        cache = isObject(config.cache) ? config.cache
	            : isObject(/** @type {?} */ (defaults).cache)
	              ? /** @type {?} */ (defaults).cache
	              : defaultCache;
	      }
	
	      if (cache) {
	        cachedResp = cache.get(url);
	        if (isDefined(cachedResp)) {
	          if (isPromiseLike(cachedResp)) {
	            // cached request has already been sent, but there is no response yet
	            cachedResp.then(resolvePromiseWithResult, resolvePromiseWithResult);
	          } else {
	            // serving from cache
	            if (isArray(cachedResp)) {
	              resolvePromise(cachedResp[1], cachedResp[0], shallowCopy(cachedResp[2]), cachedResp[3], cachedResp[4]);
	            } else {
	              resolvePromise(cachedResp, 200, {}, 'OK', 'complete');
	            }
	          }
	        } else {
	          // put the promise for the non-transformed response into cache as a placeholder
	          cache.put(url, promise);
	        }
	      }
	
	
	      // if we won't have the response in cache, set the xsrf headers and
	      // send the request to the backend
	      if (isUndefined(cachedResp)) {
	        var xsrfValue = urlIsAllowedOrigin(config.url)
	            ? $$cookieReader()[config.xsrfCookieName || defaults.xsrfCookieName]
	            : undefined;
	        if (xsrfValue) {
	          reqHeaders[(config.xsrfHeaderName || defaults.xsrfHeaderName)] = xsrfValue;
	        }
	
	        $httpBackend(config.method, url, reqData, done, reqHeaders, config.timeout,
	            config.withCredentials, config.responseType,
	            createApplyHandlers(config.eventHandlers),
	            createApplyHandlers(config.uploadEventHandlers));
	      }
	
	      return promise;
	
	      function createApplyHandlers(eventHandlers) {
	        if (eventHandlers) {
	          var applyHandlers = {};
	          forEach(eventHandlers, function(eventHandler, key) {
	            applyHandlers[key] = function(event) {
	              if (useApplyAsync) {
	                $rootScope.$applyAsync(callEventHandler);
	              } else if ($rootScope.$$phase) {
	                callEventHandler();
	              } else {
	                $rootScope.$apply(callEventHandler);
	              }
	
	              function callEventHandler() {
	                eventHandler(event);
	              }
	            };
	          });
	          return applyHandlers;
	        }
	      }
	
	
	      /**
	       * Callback registered to $httpBackend():
	       *  - caches the response if desired
	       *  - resolves the raw $http promise
	       *  - calls $apply
	       */
	      function done(status, response, headersString, statusText, xhrStatus) {
	        if (cache) {
	          if (isSuccess(status)) {
	            cache.put(url, [status, response, parseHeaders(headersString), statusText, xhrStatus]);
	          } else {
	            // remove promise from the cache
	            cache.remove(url);
	          }
	        }
	
	        function resolveHttpPromise() {
	          resolvePromise(response, status, headersString, statusText, xhrStatus);
	        }
	
	        if (useApplyAsync) {
	          $rootScope.$applyAsync(resolveHttpPromise);
	        } else {
	          resolveHttpPromise();
	          if (!$rootScope.$$phase) $rootScope.$apply();
	        }
	      }
	
	
	      /**
	       * Resolves the raw $http promise.
	       */
	      function resolvePromise(response, status, headers, statusText, xhrStatus) {
	        //status: HTTP response status code, 0, -1 (aborted by timeout / promise)
	        status = status >= -1 ? status : 0;
	
	        (isSuccess(status) ? deferred.resolve : deferred.reject)({
	          data: response,
	          status: status,
	          headers: headersGetter(headers),
	          config: config,
	          statusText: statusText,
	          xhrStatus: xhrStatus
	        });
	      }
	
	      function resolvePromiseWithResult(result) {
	        resolvePromise(result.data, result.status, shallowCopy(result.headers()), result.statusText, result.xhrStatus);
	      }
	
	      function removePendingReq() {
	        var idx = $http.pendingRequests.indexOf(config);
	        if (idx !== -1) $http.pendingRequests.splice(idx, 1);
	      }
	    }
	
	
	    function buildUrl(url, serializedParams) {
	      if (serializedParams.length > 0) {
	        url += ((url.indexOf('?') === -1) ? '?' : '&') + serializedParams;
	      }
	      return url;
	    }
	
	    function sanitizeJsonpCallbackParam(url, cbKey) {
	      var parts = url.split('?');
	      if (parts.length > 2) {
	        // Throw if the url contains more than one `?` query indicator
	        throw $httpMinErr('badjsonp', 'Illegal use more than one "?", in url, "{1}"', url);
	      }
	      var params = parseKeyValue(parts[1]);
	      forEach(params, function(value, key) {
	        if (value === 'JSON_CALLBACK') {
	          // Throw if the url already contains a reference to JSON_CALLBACK
	          throw $httpMinErr('badjsonp', 'Illegal use of JSON_CALLBACK in url, "{0}"', url);
	        }
	        if (key === cbKey) {
	          // Throw if the callback param was already provided
	          throw $httpMinErr('badjsonp', 'Illegal use of callback param, "{0}", in url, "{1}"', cbKey, url);
	        }
	      });
	
	      // Add in the JSON_CALLBACK callback param value
	      url += ((url.indexOf('?') === -1) ? '?' : '&') + cbKey + '=JSON_CALLBACK';
	
	      return url;
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $xhrFactory
	 * @this
	 *
	 * @description
	 * Factory function used to create XMLHttpRequest objects.
	 *
	 * Replace or decorate this service to create your own custom XMLHttpRequest objects.
	 *
	 * ```
	 * angular.module('myApp', [])
	 * .factory('$xhrFactory', function() {
	 *   return function createXhr(method, url) {
	 *     return new window.XMLHttpRequest({mozSystem: true});
	 *   };
	 * });
	 * ```
	 *
	 * @param {string} method HTTP method of the request (GET, POST, PUT, ..)
	 * @param {string} url URL of the request.
	 */
	function $xhrFactoryProvider() {
	  this.$get = function() {
	    return function createXhr() {
	      return new window.XMLHttpRequest();
	    };
	  };
	}
	
	/**
	 * @ngdoc service
	 * @name $httpBackend
	 * @requires $jsonpCallbacks
	 * @requires $document
	 * @requires $xhrFactory
	 * @this
	 *
	 * @description
	 * HTTP backend used by the {@link ng.$http service} that delegates to
	 * XMLHttpRequest object or JSONP and deals with browser incompatibilities.
	 *
	 * You should never need to use this service directly, instead use the higher-level abstractions:
	 * {@link ng.$http $http} or {@link ngResource.$resource $resource}.
	 *
	 * During testing this implementation is swapped with {@link ngMock.$httpBackend mock
	 * $httpBackend} which can be trained with responses.
	 */
	function $HttpBackendProvider() {
	  this.$get = ['$browser', '$jsonpCallbacks', '$document', '$xhrFactory', function($browser, $jsonpCallbacks, $document, $xhrFactory) {
	    return createHttpBackend($browser, $xhrFactory, $browser.defer, $jsonpCallbacks, $document[0]);
	  }];
	}
	
	function createHttpBackend($browser, createXhr, $browserDefer, callbacks, rawDocument) {
	  // TODO(vojta): fix the signature
	  return function(method, url, post, callback, headers, timeout, withCredentials, responseType, eventHandlers, uploadEventHandlers) {
	    url = url || $browser.url();
	
	    if (lowercase(method) === 'jsonp') {
	      var callbackPath = callbacks.createCallback(url);
	      var jsonpDone = jsonpReq(url, callbackPath, function(status, text) {
	        // jsonpReq only ever sets status to 200 (OK), 404 (ERROR) or -1 (WAITING)
	        var response = (status === 200) && callbacks.getResponse(callbackPath);
	        completeRequest(callback, status, response, '', text, 'complete');
	        callbacks.removeCallback(callbackPath);
	      });
	    } else {
	
	      var xhr = createXhr(method, url);
	      var abortedByTimeout = false;
	
	      xhr.open(method, url, true);
	      forEach(headers, function(value, key) {
	        if (isDefined(value)) {
	            xhr.setRequestHeader(key, value);
	        }
	      });
	
	      xhr.onload = function requestLoaded() {
	        var statusText = xhr.statusText || '';
	
	        // responseText is the old-school way of retrieving response (supported by IE9)
	        // response/responseType properties were introduced in XHR Level2 spec (supported by IE10)
	        var response = ('response' in xhr) ? xhr.response : xhr.responseText;
	
	        // normalize IE9 bug (http://bugs.jquery.com/ticket/1450)
	        var status = xhr.status === 1223 ? 204 : xhr.status;
	
	        // fix status code when it is 0 (0 status is undocumented).
	        // Occurs when accessing file resources or on Android 4.1 stock browser
	        // while retrieving files from application cache.
	        if (status === 0) {
	          status = response ? 200 : urlResolve(url).protocol === 'file' ? 404 : 0;
	        }
	
	        completeRequest(callback,
	            status,
	            response,
	            xhr.getAllResponseHeaders(),
	            statusText,
	            'complete');
	      };
	
	      var requestError = function() {
	        // The response is always empty
	        // See https://xhr.spec.whatwg.org/#request-error-steps and https://fetch.spec.whatwg.org/#concept-network-error
	        completeRequest(callback, -1, null, null, '', 'error');
	      };
	
	      var requestAborted = function() {
	        completeRequest(callback, -1, null, null, '', abortedByTimeout ? 'timeout' : 'abort');
	      };
	
	      var requestTimeout = function() {
	        // The response is always empty
	        // See https://xhr.spec.whatwg.org/#request-error-steps and https://fetch.spec.whatwg.org/#concept-network-error
	        completeRequest(callback, -1, null, null, '', 'timeout');
	      };
	
	      xhr.onerror = requestError;
	      xhr.ontimeout = requestTimeout;
	      xhr.onabort = requestAborted;
	
	      forEach(eventHandlers, function(value, key) {
	        xhr.addEventListener(key, value);
	      });
	
	      forEach(uploadEventHandlers, function(value, key) {
	        xhr.upload.addEventListener(key, value);
	      });
	
	      if (withCredentials) {
	        xhr.withCredentials = true;
	      }
	
	      if (responseType) {
	        try {
	          xhr.responseType = responseType;
	        } catch (e) {
	          // WebKit added support for the json responseType value on 09/03/2013
	          // https://bugs.webkit.org/show_bug.cgi?id=73648. Versions of Safari prior to 7 are
	          // known to throw when setting the value "json" as the response type. Other older
	          // browsers implementing the responseType
	          //
	          // The json response type can be ignored if not supported, because JSON payloads are
	          // parsed on the client-side regardless.
	          if (responseType !== 'json') {
	            throw e;
	          }
	        }
	      }
	
	      xhr.send(isUndefined(post) ? null : post);
	    }
	
	    // Since we are using xhr.abort() when a request times out, we have to set a flag that
	    // indicates to requestAborted if the request timed out or was aborted.
	    //
	    // http.timeout = numerical timeout   timeout
	    // http.timeout = $timeout            timeout
	    // http.timeout = promise             abort
	    // xhr.abort()                        abort (The xhr object is normally inaccessible, but
	    //                                    can be exposed with the xhrFactory)
	    if (timeout > 0) {
	      var timeoutId = $browserDefer(function() {
	        timeoutRequest('timeout');
	      }, timeout);
	    } else if (isPromiseLike(timeout)) {
	      timeout.then(function() {
	        timeoutRequest(isDefined(timeout.$$timeoutId) ? 'timeout' : 'abort');
	      });
	    }
	
	    function timeoutRequest(reason) {
	      abortedByTimeout = reason === 'timeout';
	      if (jsonpDone) {
	        jsonpDone();
	      }
	      if (xhr) {
	        xhr.abort();
	      }
	    }
	
	    function completeRequest(callback, status, response, headersString, statusText, xhrStatus) {
	      // cancel timeout and subsequent timeout promise resolution
	      if (isDefined(timeoutId)) {
	        $browserDefer.cancel(timeoutId);
	      }
	      jsonpDone = xhr = null;
	
	      callback(status, response, headersString, statusText, xhrStatus);
	    }
	  };
	
	  function jsonpReq(url, callbackPath, done) {
	    url = url.replace('JSON_CALLBACK', callbackPath);
	    // we can't use jQuery/jqLite here because jQuery does crazy stuff with script elements, e.g.:
	    // - fetches local scripts via XHR and evals them
	    // - adds and immediately removes script elements from the document
	    var script = rawDocument.createElement('script'), callback = null;
	    script.type = 'text/javascript';
	    script.src = url;
	    script.async = true;
	
	    callback = function(event) {
	      script.removeEventListener('load', callback);
	      script.removeEventListener('error', callback);
	      rawDocument.body.removeChild(script);
	      script = null;
	      var status = -1;
	      var text = 'unknown';
	
	      if (event) {
	        if (event.type === 'load' && !callbacks.wasCalled(callbackPath)) {
	          event = { type: 'error' };
	        }
	        text = event.type;
	        status = event.type === 'error' ? 404 : 200;
	      }
	
	      if (done) {
	        done(status, text);
	      }
	    };
	
	    script.addEventListener('load', callback);
	    script.addEventListener('error', callback);
	    rawDocument.body.appendChild(script);
	    return callback;
	  }
	}
	
	var $interpolateMinErr = angular.$interpolateMinErr = minErr('$interpolate');
	$interpolateMinErr.throwNoconcat = function(text) {
	  throw $interpolateMinErr('noconcat',
	      'Error while interpolating: {0}\nStrict Contextual Escaping disallows ' +
	      'interpolations that concatenate multiple expressions when a trusted value is ' +
	      'required.  See http://docs.angularjs.org/api/ng.$sce', text);
	};
	
	$interpolateMinErr.interr = function(text, err) {
	  return $interpolateMinErr('interr', 'Can\'t interpolate: {0}\n{1}', text, err.toString());
	};
	
	/**
	 * @ngdoc provider
	 * @name $interpolateProvider
	 * @this
	 *
	 * @description
	 *
	 * Used for configuring the interpolation markup. Defaults to `{{` and `}}`.
	 *
	 * <div class="alert alert-danger">
	 * This feature is sometimes used to mix different markup languages, e.g. to wrap an AngularJS
	 * template within a Python Jinja template (or any other template language). Mixing templating
	 * languages is **very dangerous**. The embedding template language will not safely escape AngularJS
	 * expressions, so any user-controlled values in the template will cause Cross Site Scripting (XSS)
	 * security bugs!
	 * </div>
	 *
	 * @example
	<example name="custom-interpolation-markup" module="customInterpolationApp">
	<file name="index.html">
	<script>
	  var customInterpolationApp = angular.module('customInterpolationApp', []);
	
	  customInterpolationApp.config(function($interpolateProvider) {
	    $interpolateProvider.startSymbol('//');
	    $interpolateProvider.endSymbol('//');
	  });
	
	
	  customInterpolationApp.controller('DemoController', function() {
	      this.label = "This binding is brought you by // interpolation symbols.";
	  });
	</script>
	<div ng-controller="DemoController as demo">
	    //demo.label//
	</div>
	</file>
	<file name="protractor.js" type="protractor">
	  it('should interpolate binding with custom symbols', function() {
	    expect(element(by.binding('demo.label')).getText()).toBe('This binding is brought you by // interpolation symbols.');
	  });
	</file>
	</example>
	 */
	function $InterpolateProvider() {
	  var startSymbol = '{{';
	  var endSymbol = '}}';
	
	  /**
	   * @ngdoc method
	   * @name $interpolateProvider#startSymbol
	   * @description
	   * Symbol to denote start of expression in the interpolated string. Defaults to `{{`.
	   *
	   * @param {string=} value new value to set the starting symbol to.
	   * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
	   */
	  this.startSymbol = function(value) {
	    if (value) {
	      startSymbol = value;
	      return this;
	    }
	    return startSymbol;
	  };
	
	  /**
	   * @ngdoc method
	   * @name $interpolateProvider#endSymbol
	   * @description
	   * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
	   *
	   * @param {string=} value new value to set the ending symbol to.
	   * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
	   */
	  this.endSymbol = function(value) {
	    if (value) {
	      endSymbol = value;
	      return this;
	    }
	    return endSymbol;
	  };
	
	
	  this.$get = ['$parse', '$exceptionHandler', '$sce', function($parse, $exceptionHandler, $sce) {
	    var startSymbolLength = startSymbol.length,
	        endSymbolLength = endSymbol.length,
	        escapedStartRegexp = new RegExp(startSymbol.replace(/./g, escape), 'g'),
	        escapedEndRegexp = new RegExp(endSymbol.replace(/./g, escape), 'g');
	
	    function escape(ch) {
	      return '\\\\\\' + ch;
	    }
	
	    function unescapeText(text) {
	      return text.replace(escapedStartRegexp, startSymbol).
	        replace(escapedEndRegexp, endSymbol);
	    }
	
	    // TODO: this is the same as the constantWatchDelegate in parse.js
	    function constantWatchDelegate(scope, listener, objectEquality, constantInterp) {
	      var unwatch = scope.$watch(function constantInterpolateWatch(scope) {
	        unwatch();
	        return constantInterp(scope);
	      }, listener, objectEquality);
	      return unwatch;
	    }
	
	    /**
	     * @ngdoc service
	     * @name $interpolate
	     * @kind function
	     *
	     * @requires $parse
	     * @requires $sce
	     *
	     * @description
	     *
	     * Compiles a string with markup into an interpolation function. This service is used by the
	     * HTML {@link ng.$compile $compile} service for data binding. See
	     * {@link ng.$interpolateProvider $interpolateProvider} for configuring the
	     * interpolation markup.
	     *
	     *
	     * ```js
	     *   var $interpolate = ...; // injected
	     *   var exp = $interpolate('Hello {{name | uppercase}}!');
	     *   expect(exp({name:'AngularJS'})).toEqual('Hello ANGULARJS!');
	     * ```
	     *
	     * `$interpolate` takes an optional fourth argument, `allOrNothing`. If `allOrNothing` is
	     * `true`, the interpolation function will return `undefined` unless all embedded expressions
	     * evaluate to a value other than `undefined`.
	     *
	     * ```js
	     *   var $interpolate = ...; // injected
	     *   var context = {greeting: 'Hello', name: undefined };
	     *
	     *   // default "forgiving" mode
	     *   var exp = $interpolate('{{greeting}} {{name}}!');
	     *   expect(exp(context)).toEqual('Hello !');
	     *
	     *   // "allOrNothing" mode
	     *   exp = $interpolate('{{greeting}} {{name}}!', false, null, true);
	     *   expect(exp(context)).toBeUndefined();
	     *   context.name = 'AngularJS';
	     *   expect(exp(context)).toEqual('Hello AngularJS!');
	     * ```
	     *
	     * `allOrNothing` is useful for interpolating URLs. `ngSrc` and `ngSrcset` use this behavior.
	     *
	     * #### Escaped Interpolation
	     * $interpolate provides a mechanism for escaping interpolation markers. Start and end markers
	     * can be escaped by preceding each of their characters with a REVERSE SOLIDUS U+005C (backslash).
	     * It will be rendered as a regular start/end marker, and will not be interpreted as an expression
	     * or binding.
	     *
	     * This enables web-servers to prevent script injection attacks and defacing attacks, to some
	     * degree, while also enabling code examples to work without relying on the
	     * {@link ng.directive:ngNonBindable ngNonBindable} directive.
	     *
	     * **For security purposes, it is strongly encouraged that web servers escape user-supplied data,
	     * replacing angle brackets (&lt;, &gt;) with &amp;lt; and &amp;gt; respectively, and replacing all
	     * interpolation start/end markers with their escaped counterparts.**
	     *
	     * Escaped interpolation markers are only replaced with the actual interpolation markers in rendered
	     * output when the $interpolate service processes the text. So, for HTML elements interpolated
	     * by {@link ng.$compile $compile}, or otherwise interpolated with the `mustHaveExpression` parameter
	     * set to `true`, the interpolated text must contain an unescaped interpolation expression. As such,
	     * this is typically useful only when user-data is used in rendering a template from the server, or
	     * when otherwise untrusted data is used by a directive.
	     *
	     * <example name="interpolation">
	     *  <file name="index.html">
	     *    <div ng-init="username='A user'">
	     *      <p ng-init="apptitle='Escaping demo'">{{apptitle}}: \{\{ username = "defaced value"; \}\}
	     *        </p>
	     *      <p><strong>{{username}}</strong> attempts to inject code which will deface the
	     *        application, but fails to accomplish their task, because the server has correctly
	     *        escaped the interpolation start/end markers with REVERSE SOLIDUS U+005C (backslash)
	     *        characters.</p>
	     *      <p>Instead, the result of the attempted script injection is visible, and can be removed
	     *        from the database by an administrator.</p>
	     *    </div>
	     *  </file>
	     * </example>
	     *
	     * @knownIssue
	     * It is currently not possible for an interpolated expression to contain the interpolation end
	     * symbol. For example, `{{ '}}' }}` will be incorrectly interpreted as `{{ ' }}` + `' }}`, i.e.
	     * an interpolated expression consisting of a single-quote (`'`) and the `' }}` string.
	     *
	     * @knownIssue
	     * All directives and components must use the standard `{{` `}}` interpolation symbols
	     * in their templates. If you change the application interpolation symbols the {@link $compile}
	     * service will attempt to denormalize the standard symbols to the custom symbols.
	     * The denormalization process is not clever enough to know not to replace instances of the standard
	     * symbols where they would not normally be treated as interpolation symbols. For example in the following
	     * code snippet the closing braces of the literal object will get incorrectly denormalized:
	     *
	     * ```
	     * <div data-context='{"context":{"id":3,"type":"page"}}">
	     * ```
	     *
	     * The workaround is to ensure that such instances are separated by whitespace:
	     * ```
	     * <div data-context='{"context":{"id":3,"type":"page"} }">
	     * ```
	     *
	     * See https://github.com/angular/angular.js/pull/14610#issuecomment-219401099 for more information.
	     *
	     * @param {string} text The text with markup to interpolate.
	     * @param {boolean=} mustHaveExpression if set to true then the interpolation string must have
	     *    embedded expression in order to return an interpolation function. Strings with no
	     *    embedded expression will return null for the interpolation function.
	     * @param {string=} trustedContext when provided, the returned function passes the interpolated
	     *    result through {@link ng.$sce#getTrusted $sce.getTrusted(interpolatedResult,
	     *    trustedContext)} before returning it.  Refer to the {@link ng.$sce $sce} service that
	     *    provides Strict Contextual Escaping for details.
	     * @param {boolean=} allOrNothing if `true`, then the returned function returns undefined
	     *    unless all embedded expressions evaluate to a value other than `undefined`.
	     * @returns {function(context)} an interpolation function which is used to compute the
	     *    interpolated string. The function has these parameters:
	     *
	     * - `context`: evaluation context for all expressions embedded in the interpolated text
	     */
	    function $interpolate(text, mustHaveExpression, trustedContext, allOrNothing) {
	      var contextAllowsConcatenation = trustedContext === $sce.URL || trustedContext === $sce.MEDIA_URL;
	
	      // Provide a quick exit and simplified result function for text with no interpolation
	      if (!text.length || text.indexOf(startSymbol) === -1) {
	        if (mustHaveExpression) return;
	
	        var unescapedText = unescapeText(text);
	        if (contextAllowsConcatenation) {
	          unescapedText = $sce.getTrusted(trustedContext, unescapedText);
	        }
	        var constantInterp = valueFn(unescapedText);
	        constantInterp.exp = text;
	        constantInterp.expressions = [];
	        constantInterp.$$watchDelegate = constantWatchDelegate;
	
	        return constantInterp;
	      }
	
	      allOrNothing = !!allOrNothing;
	      var startIndex,
	          endIndex,
	          index = 0,
	          expressions = [],
	          parseFns,
	          textLength = text.length,
	          exp,
	          concat = [],
	          expressionPositions = [],
	          singleExpression;
	
	
	      while (index < textLength) {
	        if (((startIndex = text.indexOf(startSymbol, index)) !== -1) &&
	             ((endIndex = text.indexOf(endSymbol, startIndex + startSymbolLength)) !== -1)) {
	          if (index !== startIndex) {
	            concat.push(unescapeText(text.substring(index, startIndex)));
	          }
	          exp = text.substring(startIndex + startSymbolLength, endIndex);
	          expressions.push(exp);
	          index = endIndex + endSymbolLength;
	          expressionPositions.push(concat.length);
	          concat.push(''); // Placeholder that will get replaced with the evaluated expression.
	        } else {
	          // we did not find an interpolation, so we have to add the remainder to the separators array
	          if (index !== textLength) {
	            concat.push(unescapeText(text.substring(index)));
	          }
	          break;
	        }
	      }
	
	      singleExpression = concat.length === 1 && expressionPositions.length === 1;
	      // Intercept expression if we need to stringify concatenated inputs, which may be SCE trusted
	      // objects rather than simple strings
	      // (we don't modify the expression if the input consists of only a single trusted input)
	      var interceptor = contextAllowsConcatenation && singleExpression ? undefined : parseStringifyInterceptor;
	      parseFns = expressions.map(function(exp) { return $parse(exp, interceptor); });
	
	      // Concatenating expressions makes it hard to reason about whether some combination of
	      // concatenated values are unsafe to use and could easily lead to XSS.  By requiring that a
	      // single expression be used for some $sce-managed secure contexts (RESOURCE_URLs mostly),
	      // we ensure that the value that's used is assigned or constructed by some JS code somewhere
	      // that is more testable or make it obvious that you bound the value to some user controlled
	      // value.  This helps reduce the load when auditing for XSS issues.
	
	      // Note that URL and MEDIA_URL $sce contexts do not need this, since `$sce` can sanitize the values
	      // passed to it. In that case, `$sce.getTrusted` will be called on either the single expression
	      // or on the overall concatenated string (losing trusted types used in the mix, by design).
	      // Both these methods will sanitize plain strings. Also, HTML could be included, but since it's
	      // only used in srcdoc attributes, this would not be very useful.
	
	      if (!mustHaveExpression || expressions.length) {
	        var compute = function(values) {
	          for (var i = 0, ii = expressions.length; i < ii; i++) {
	            if (allOrNothing && isUndefined(values[i])) return;
	            concat[expressionPositions[i]] = values[i];
	          }
	
	          if (contextAllowsConcatenation) {
	            // If `singleExpression` then `concat[0]` might be a "trusted" value or `null`, rather than a string
	            return $sce.getTrusted(trustedContext, singleExpression ? concat[0] : concat.join(''));
	          } else if (trustedContext && concat.length > 1) {
	            // This context does not allow more than one part, e.g. expr + string or exp + exp.
	            $interpolateMinErr.throwNoconcat(text);
	          }
	          // In an unprivileged context or only one part: just concatenate and return.
	          return concat.join('');
	        };
	
	        return extend(function interpolationFn(context) {
	            var i = 0;
	            var ii = expressions.length;
	            var values = new Array(ii);
	
	            try {
	              for (; i < ii; i++) {
	                values[i] = parseFns[i](context);
	              }
	
	              return compute(values);
	            } catch (err) {
	              $exceptionHandler($interpolateMinErr.interr(text, err));
	            }
	
	          }, {
	          // all of these properties are undocumented for now
	          exp: text, //just for compatibility with regular watchers created via $watch
	          expressions: expressions,
	          $$watchDelegate: function(scope, listener) {
	            var lastValue;
	            return scope.$watchGroup(parseFns, /** @this */ function interpolateFnWatcher(values, oldValues) {
	              var currValue = compute(values);
	              listener.call(this, currValue, values !== oldValues ? lastValue : currValue, scope);
	              lastValue = currValue;
	            });
	          }
	        });
	      }
	
	      function parseStringifyInterceptor(value) {
	        try {
	          // In concatenable contexts, getTrusted comes at the end, to avoid sanitizing individual
	          // parts of a full URL. We don't care about losing the trustedness here.
	          // In non-concatenable contexts, where there is only one expression, this interceptor is
	          // not applied to the expression.
	          value = (trustedContext && !contextAllowsConcatenation) ?
	                    $sce.getTrusted(trustedContext, value) :
	                    $sce.valueOf(value);
	          return allOrNothing && !isDefined(value) ? value : stringify(value);
	        } catch (err) {
	          $exceptionHandler($interpolateMinErr.interr(text, err));
	        }
	      }
	    }
	
	
	    /**
	     * @ngdoc method
	     * @name $interpolate#startSymbol
	     * @description
	     * Symbol to denote the start of expression in the interpolated string. Defaults to `{{`.
	     *
	     * Use {@link ng.$interpolateProvider#startSymbol `$interpolateProvider.startSymbol`} to change
	     * the symbol.
	     *
	     * @returns {string} start symbol.
	     */
	    $interpolate.startSymbol = function() {
	      return startSymbol;
	    };
	
	
	    /**
	     * @ngdoc method
	     * @name $interpolate#endSymbol
	     * @description
	     * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
	     *
	     * Use {@link ng.$interpolateProvider#endSymbol `$interpolateProvider.endSymbol`} to change
	     * the symbol.
	     *
	     * @returns {string} end symbol.
	     */
	    $interpolate.endSymbol = function() {
	      return endSymbol;
	    };
	
	    return $interpolate;
	  }];
	}
	
	var $intervalMinErr = minErr('$interval');
	
	/** @this */
	function $IntervalProvider() {
	  this.$get = ['$$intervalFactory', '$window',
	       function($$intervalFactory,   $window) {
	    var intervals = {};
	    var setIntervalFn = function(tick, delay, deferred) {
	      var id = $window.setInterval(tick, delay);
	      intervals[id] = deferred;
	      return id;
	    };
	    var clearIntervalFn = function(id) {
	      $window.clearInterval(id);
	      delete intervals[id];
	    };
	
	    /**
	     * @ngdoc service
	     * @name $interval
	     *
	     * @description
	     * AngularJS's wrapper for `window.setInterval`. The `fn` function is executed every `delay`
	     * milliseconds.
	     *
	     * The return value of registering an interval function is a promise. This promise will be
	     * notified upon each tick of the interval, and will be resolved after `count` iterations, or
	     * run indefinitely if `count` is not defined. The value of the notification will be the
	     * number of iterations that have run.
	     * To cancel an interval, call `$interval.cancel(promise)`.
	     *
	     * In tests you can use {@link ngMock.$interval#flush `$interval.flush(millis)`} to
	     * move forward by `millis` milliseconds and trigger any functions scheduled to run in that
	     * time.
	     *
	     * <div class="alert alert-warning">
	     * **Note**: Intervals created by this service must be explicitly destroyed when you are finished
	     * with them.  In particular they are not automatically destroyed when a controller's scope or a
	     * directive's element are destroyed.
	     * You should take this into consideration and make sure to always cancel the interval at the
	     * appropriate moment.  See the example below for more details on how and when to do this.
	     * </div>
	     *
	     * @param {function()} fn A function that should be called repeatedly. If no additional arguments
	     *   are passed (see below), the function is called with the current iteration count.
	     * @param {number} delay Number of milliseconds between each function call.
	     * @param {number=} [count=0] Number of times to repeat. If not set, or 0, will repeat
	     *   indefinitely.
	     * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
	     *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
	     * @param {...*=} Pass additional parameters to the executed function.
	     * @returns {promise} A promise which will be notified on each iteration. It will resolve once all iterations of the interval complete.
	     *
	     * @example
	     * <example module="intervalExample" name="interval-service">
	     * <file name="index.html">
	     *   <script>
	     *     angular.module('intervalExample', [])
	     *       .controller('ExampleController', ['$scope', '$interval',
	     *         function($scope, $interval) {
	     *           $scope.format = 'M/d/yy h:mm:ss a';
	     *           $scope.blood_1 = 100;
	     *           $scope.blood_2 = 120;
	     *
	     *           var stop;
	     *           $scope.fight = function() {
	     *             // Don't start a new fight if we are already fighting
	     *             if ( angular.isDefined(stop) ) return;
	     *
	     *             stop = $interval(function() {
	     *               if ($scope.blood_1 > 0 && $scope.blood_2 > 0) {
	     *                 $scope.blood_1 = $scope.blood_1 - 3;
	     *                 $scope.blood_2 = $scope.blood_2 - 4;
	     *               } else {
	     *                 $scope.stopFight();
	     *               }
	     *             }, 100);
	     *           };
	     *
	     *           $scope.stopFight = function() {
	     *             if (angular.isDefined(stop)) {
	     *               $interval.cancel(stop);
	     *               stop = undefined;
	     *             }
	     *           };
	     *
	     *           $scope.resetFight = function() {
	     *             $scope.blood_1 = 100;
	     *             $scope.blood_2 = 120;
	     *           };
	     *
	     *           $scope.$on('$destroy', function() {
	     *             // Make sure that the interval is destroyed too
	     *             $scope.stopFight();
	     *           });
	     *         }])
	     *       // Register the 'myCurrentTime' directive factory method.
	     *       // We inject $interval and dateFilter service since the factory method is DI.
	     *       .directive('myCurrentTime', ['$interval', 'dateFilter',
	     *         function($interval, dateFilter) {
	     *           // return the directive link function. (compile function not needed)
	     *           return function(scope, element, attrs) {
	     *             var format,  // date format
	     *                 stopTime; // so that we can cancel the time updates
	     *
	     *             // used to update the UI
	     *             function updateTime() {
	     *               element.text(dateFilter(new Date(), format));
	     *             }
	     *
	     *             // watch the expression, and update the UI on change.
	     *             scope.$watch(attrs.myCurrentTime, function(value) {
	     *               format = value;
	     *               updateTime();
	     *             });
	     *
	     *             stopTime = $interval(updateTime, 1000);
	     *
	     *             // listen on DOM destroy (removal) event, and cancel the next UI update
	     *             // to prevent updating time after the DOM element was removed.
	     *             element.on('$destroy', function() {
	     *               $interval.cancel(stopTime);
	     *             });
	     *           }
	     *         }]);
	     *   </script>
	     *
	     *   <div>
	     *     <div ng-controller="ExampleController">
	     *       <label>Date format: <input ng-model="format"></label> <hr/>
	     *       Current time is: <span my-current-time="format"></span>
	     *       <hr/>
	     *       Blood 1 : <font color='red'>{{blood_1}}</font>
	     *       Blood 2 : <font color='red'>{{blood_2}}</font>
	     *       <button type="button" data-ng-click="fight()">Fight</button>
	     *       <button type="button" data-ng-click="stopFight()">StopFight</button>
	     *       <button type="button" data-ng-click="resetFight()">resetFight</button>
	     *     </div>
	     *   </div>
	     *
	     * </file>
	     * </example>
	     */
	    var interval = $$intervalFactory(setIntervalFn, clearIntervalFn);
	
	    /**
	     * @ngdoc method
	     * @name $interval#cancel
	     *
	     * @description
	     * Cancels a task associated with the `promise`.
	     *
	     * @param {Promise=} promise returned by the `$interval` function.
	     * @returns {boolean} Returns `true` if the task was successfully canceled.
	     */
	    interval.cancel = function(promise) {
	      if (!promise) return false;
	
	      if (!promise.hasOwnProperty('$$intervalId')) {
	        throw $intervalMinErr('badprom',
	            '`$interval.cancel()` called with a promise that was not generated by `$interval()`.');
	      }
	
	      if (!intervals.hasOwnProperty(promise.$$intervalId)) return false;
	
	      var id = promise.$$intervalId;
	      var deferred = intervals[id];
	
	      // Interval cancels should not report an unhandled promise.
	      markQExceptionHandled(deferred.promise);
	      deferred.reject('canceled');
	      clearIntervalFn(id);
	
	      return true;
	    };
	
	    return interval;
	  }];
	}
	
	/** @this */
	function $$IntervalFactoryProvider() {
	  this.$get = ['$browser', '$q', '$$q', '$rootScope',
	       function($browser,   $q,   $$q,   $rootScope) {
	    return function intervalFactory(setIntervalFn, clearIntervalFn) {
	      return function intervalFn(fn, delay, count, invokeApply) {
	        var hasParams = arguments.length > 4,
	            args = hasParams ? sliceArgs(arguments, 4) : [],
	            iteration = 0,
	            skipApply = isDefined(invokeApply) && !invokeApply,
	            deferred = (skipApply ? $$q : $q).defer(),
	            promise = deferred.promise;
	
	        count = isDefined(count) ? count : 0;
	
	        function callback() {
	          if (!hasParams) {
	            fn(iteration);
	          } else {
	            fn.apply(null, args);
	          }
	        }
	
	        function tick() {
	          if (skipApply) {
	            $browser.defer(callback);
	          } else {
	            $rootScope.$evalAsync(callback);
	          }
	          deferred.notify(iteration++);
	
	          if (count > 0 && iteration >= count) {
	            deferred.resolve(iteration);
	            clearIntervalFn(promise.$$intervalId);
	          }
	
	          if (!skipApply) $rootScope.$apply();
	        }
	
	        promise.$$intervalId = setIntervalFn(tick, delay, deferred, skipApply);
	
	        return promise;
	      };
	    };
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $jsonpCallbacks
	 * @requires $window
	 * @description
	 * This service handles the lifecycle of callbacks to handle JSONP requests.
	 * Override this service if you wish to customise where the callbacks are stored and
	 * how they vary compared to the requested url.
	 */
	var $jsonpCallbacksProvider = /** @this */ function() {
	  this.$get = function() {
	    var callbacks = angular.callbacks;
	    var callbackMap = {};
	
	    function createCallback(callbackId) {
	      var callback = function(data) {
	        callback.data = data;
	        callback.called = true;
	      };
	      callback.id = callbackId;
	      return callback;
	    }
	
	    return {
	      /**
	       * @ngdoc method
	       * @name $jsonpCallbacks#createCallback
	       * @param {string} url the url of the JSONP request
	       * @returns {string} the callback path to send to the server as part of the JSONP request
	       * @description
	       * {@link $httpBackend} calls this method to create a callback and get hold of the path to the callback
	       * to pass to the server, which will be used to call the callback with its payload in the JSONP response.
	       */
	      createCallback: function(url) {
	        var callbackId = '_' + (callbacks.$$counter++).toString(36);
	        var callbackPath = 'angular.callbacks.' + callbackId;
	        var callback = createCallback(callbackId);
	        callbackMap[callbackPath] = callbacks[callbackId] = callback;
	        return callbackPath;
	      },
	      /**
	       * @ngdoc method
	       * @name $jsonpCallbacks#wasCalled
	       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
	       * @returns {boolean} whether the callback has been called, as a result of the JSONP response
	       * @description
	       * {@link $httpBackend} calls this method to find out whether the JSONP response actually called the
	       * callback that was passed in the request.
	       */
	      wasCalled: function(callbackPath) {
	        return callbackMap[callbackPath].called;
	      },
	      /**
	       * @ngdoc method
	       * @name $jsonpCallbacks#getResponse
	       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
	       * @returns {*} the data received from the response via the registered callback
	       * @description
	       * {@link $httpBackend} calls this method to get hold of the data that was provided to the callback
	       * in the JSONP response.
	       */
	      getResponse: function(callbackPath) {
	        return callbackMap[callbackPath].data;
	      },
	      /**
	       * @ngdoc method
	       * @name $jsonpCallbacks#removeCallback
	       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
	       * @description
	       * {@link $httpBackend} calls this method to remove the callback after the JSONP request has
	       * completed or timed-out.
	       */
	      removeCallback: function(callbackPath) {
	        var callback = callbackMap[callbackPath];
	        delete callbacks[callback.id];
	        delete callbackMap[callbackPath];
	      }
	    };
	  };
	};
	
	/**
	 * @ngdoc service
	 * @name $locale
	 *
	 * @description
	 * $locale service provides localization rules for various AngularJS components. As of right now the
	 * only public api is:
	 *
	 * * `id` – `{string}` – locale id formatted as `languageId-countryId` (e.g. `en-us`)
	 */
	
	/* global stripHash: true */
	
	var PATH_MATCH = /^([^?#]*)(\?([^#]*))?(#(.*))?$/,
	    DEFAULT_PORTS = {'http': 80, 'https': 443, 'ftp': 21};
	var $locationMinErr = minErr('$location');
	
	
	/**
	 * Encode path using encodeUriSegment, ignoring forward slashes
	 *
	 * @param {string} path Path to encode
	 * @returns {string}
	 */
	function encodePath(path) {
	  var segments = path.split('/'),
	      i = segments.length;
	
	  while (i--) {
	    // decode forward slashes to prevent them from being double encoded
	    segments[i] = encodeUriSegment(segments[i].replace(/%2F/g, '/'));
	  }
	
	  return segments.join('/');
	}
	
	function decodePath(path, html5Mode) {
	  var segments = path.split('/'),
	      i = segments.length;
	
	  while (i--) {
	    segments[i] = decodeURIComponent(segments[i]);
	    if (html5Mode) {
	      // encode forward slashes to prevent them from being mistaken for path separators
	      segments[i] = segments[i].replace(/\//g, '%2F');
	    }
	  }
	
	  return segments.join('/');
	}
	
	function normalizePath(pathValue, searchValue, hashValue) {
	  var search = toKeyValue(searchValue),
	    hash = hashValue ? '#' + encodeUriSegment(hashValue) : '',
	    path = encodePath(pathValue);
	
	  return path + (search ? '?' + search : '') + hash;
	}
	
	function parseAbsoluteUrl(absoluteUrl, locationObj) {
	  var parsedUrl = urlResolve(absoluteUrl);
	
	  locationObj.$$protocol = parsedUrl.protocol;
	  locationObj.$$host = parsedUrl.hostname;
	  locationObj.$$port = toInt(parsedUrl.port) || DEFAULT_PORTS[parsedUrl.protocol] || null;
	}
	
	var DOUBLE_SLASH_REGEX = /^\s*[\\/]{2,}/;
	function parseAppUrl(url, locationObj, html5Mode) {
	
	  if (DOUBLE_SLASH_REGEX.test(url)) {
	    throw $locationMinErr('badpath', 'Invalid url "{0}".', url);
	  }
	
	  var prefixed = (url.charAt(0) !== '/');
	  if (prefixed) {
	    url = '/' + url;
	  }
	  var match = urlResolve(url);
	  var path = prefixed && match.pathname.charAt(0) === '/' ? match.pathname.substring(1) : match.pathname;
	  locationObj.$$path = decodePath(path, html5Mode);
	  locationObj.$$search = parseKeyValue(match.search);
	  locationObj.$$hash = decodeURIComponent(match.hash);
	
	  // make sure path starts with '/';
	  if (locationObj.$$path && locationObj.$$path.charAt(0) !== '/') {
	    locationObj.$$path = '/' + locationObj.$$path;
	  }
	}
	
	function startsWith(str, search) {
	  return str.slice(0, search.length) === search;
	}
	
	/**
	 *
	 * @param {string} base
	 * @param {string} url
	 * @returns {string} returns text from `url` after `base` or `undefined` if it does not begin with
	 *                   the expected string.
	 */
	function stripBaseUrl(base, url) {
	  if (startsWith(url, base)) {
	    return url.substr(base.length);
	  }
	}
	
	function stripHash(url) {
	  var index = url.indexOf('#');
	  return index === -1 ? url : url.substr(0, index);
	}
	
	function stripFile(url) {
	  return url.substr(0, stripHash(url).lastIndexOf('/') + 1);
	}
	
	/* return the server only (scheme://host:port) */
	function serverBase(url) {
	  return url.substring(0, url.indexOf('/', url.indexOf('//') + 2));
	}
	
	
	/**
	 * LocationHtml5Url represents a URL
	 * This object is exposed as $location service when HTML5 mode is enabled and supported
	 *
	 * @constructor
	 * @param {string} appBase application base URL
	 * @param {string} appBaseNoFile application base URL stripped of any filename
	 * @param {string} basePrefix URL path prefix
	 */
	function LocationHtml5Url(appBase, appBaseNoFile, basePrefix) {
	  this.$$html5 = true;
	  basePrefix = basePrefix || '';
	  parseAbsoluteUrl(appBase, this);
	
	
	  /**
	   * Parse given HTML5 (regular) URL string into properties
	   * @param {string} url HTML5 URL
	   * @private
	   */
	  this.$$parse = function(url) {
	    var pathUrl = stripBaseUrl(appBaseNoFile, url);
	    if (!isString(pathUrl)) {
	      throw $locationMinErr('ipthprfx', 'Invalid url "{0}", missing path prefix "{1}".', url,
	          appBaseNoFile);
	    }
	
	    parseAppUrl(pathUrl, this, true);
	
	    if (!this.$$path) {
	      this.$$path = '/';
	    }
	
	    this.$$compose();
	  };
	
	  this.$$normalizeUrl = function(url) {
	    return appBaseNoFile + url.substr(1); // first char is always '/'
	  };
	
	  this.$$parseLinkUrl = function(url, relHref) {
	    if (relHref && relHref[0] === '#') {
	      // special case for links to hash fragments:
	      // keep the old url and only replace the hash fragment
	      this.hash(relHref.slice(1));
	      return true;
	    }
	    var appUrl, prevAppUrl;
	    var rewrittenUrl;
	
	
	    if (isDefined(appUrl = stripBaseUrl(appBase, url))) {
	      prevAppUrl = appUrl;
	      if (basePrefix && isDefined(appUrl = stripBaseUrl(basePrefix, appUrl))) {
	        rewrittenUrl = appBaseNoFile + (stripBaseUrl('/', appUrl) || appUrl);
	      } else {
	        rewrittenUrl = appBase + prevAppUrl;
	      }
	    } else if (isDefined(appUrl = stripBaseUrl(appBaseNoFile, url))) {
	      rewrittenUrl = appBaseNoFile + appUrl;
	    } else if (appBaseNoFile === url + '/') {
	      rewrittenUrl = appBaseNoFile;
	    }
	    if (rewrittenUrl) {
	      this.$$parse(rewrittenUrl);
	    }
	    return !!rewrittenUrl;
	  };
	}
	
	
	/**
	 * LocationHashbangUrl represents URL
	 * This object is exposed as $location service when developer doesn't opt into html5 mode.
	 * It also serves as the base class for html5 mode fallback on legacy browsers.
	 *
	 * @constructor
	 * @param {string} appBase application base URL
	 * @param {string} appBaseNoFile application base URL stripped of any filename
	 * @param {string} hashPrefix hashbang prefix
	 */
	function LocationHashbangUrl(appBase, appBaseNoFile, hashPrefix) {
	
	  parseAbsoluteUrl(appBase, this);
	
	
	  /**
	   * Parse given hashbang URL into properties
	   * @param {string} url Hashbang URL
	   * @private
	   */
	  this.$$parse = function(url) {
	    var withoutBaseUrl = stripBaseUrl(appBase, url) || stripBaseUrl(appBaseNoFile, url);
	    var withoutHashUrl;
	
	    if (!isUndefined(withoutBaseUrl) && withoutBaseUrl.charAt(0) === '#') {
	
	      // The rest of the URL starts with a hash so we have
	      // got either a hashbang path or a plain hash fragment
	      withoutHashUrl = stripBaseUrl(hashPrefix, withoutBaseUrl);
	      if (isUndefined(withoutHashUrl)) {
	        // There was no hashbang prefix so we just have a hash fragment
	        withoutHashUrl = withoutBaseUrl;
	      }
	
	    } else {
	      // There was no hashbang path nor hash fragment:
	      // If we are in HTML5 mode we use what is left as the path;
	      // Otherwise we ignore what is left
	      if (this.$$html5) {
	        withoutHashUrl = withoutBaseUrl;
	      } else {
	        withoutHashUrl = '';
	        if (isUndefined(withoutBaseUrl)) {
	          appBase = url;
	          /** @type {?} */ (this).replace();
	        }
	      }
	    }
	
	    parseAppUrl(withoutHashUrl, this, false);
	
	    this.$$path = removeWindowsDriveName(this.$$path, withoutHashUrl, appBase);
	
	    this.$$compose();
	
	    /*
	     * In Windows, on an anchor node on documents loaded from
	     * the filesystem, the browser will return a pathname
	     * prefixed with the drive name ('/C:/path') when a
	     * pathname without a drive is set:
	     *  * a.setAttribute('href', '/foo')
	     *   * a.pathname === '/C:/foo' //true
	     *
	     * Inside of AngularJS, we're always using pathnames that
	     * do not include drive names for routing.
	     */
	    function removeWindowsDriveName(path, url, base) {
	      /*
	      Matches paths for file protocol on windows,
	      such as /C:/foo/bar, and captures only /foo/bar.
	      */
	      var windowsFilePathExp = /^\/[A-Z]:(\/.*)/;
	
	      var firstPathSegmentMatch;
	
	      //Get the relative path from the input URL.
	      if (startsWith(url, base)) {
	        url = url.replace(base, '');
	      }
	
	      // The input URL intentionally contains a first path segment that ends with a colon.
	      if (windowsFilePathExp.exec(url)) {
	        return path;
	      }
	
	      firstPathSegmentMatch = windowsFilePathExp.exec(path);
	      return firstPathSegmentMatch ? firstPathSegmentMatch[1] : path;
	    }
	  };
	
	  this.$$normalizeUrl = function(url) {
	    return appBase + (url ? hashPrefix + url : '');
	  };
	
	  this.$$parseLinkUrl = function(url, relHref) {
	    if (stripHash(appBase) === stripHash(url)) {
	      this.$$parse(url);
	      return true;
	    }
	    return false;
	  };
	}
	
	
	/**
	 * LocationHashbangUrl represents URL
	 * This object is exposed as $location service when html5 history api is enabled but the browser
	 * does not support it.
	 *
	 * @constructor
	 * @param {string} appBase application base URL
	 * @param {string} appBaseNoFile application base URL stripped of any filename
	 * @param {string} hashPrefix hashbang prefix
	 */
	function LocationHashbangInHtml5Url(appBase, appBaseNoFile, hashPrefix) {
	  this.$$html5 = true;
	  LocationHashbangUrl.apply(this, arguments);
	
	  this.$$parseLinkUrl = function(url, relHref) {
	    if (relHref && relHref[0] === '#') {
	      // special case for links to hash fragments:
	      // keep the old url and only replace the hash fragment
	      this.hash(relHref.slice(1));
	      return true;
	    }
	
	    var rewrittenUrl;
	    var appUrl;
	
	    if (appBase === stripHash(url)) {
	      rewrittenUrl = url;
	    } else if ((appUrl = stripBaseUrl(appBaseNoFile, url))) {
	      rewrittenUrl = appBase + hashPrefix + appUrl;
	    } else if (appBaseNoFile === url + '/') {
	      rewrittenUrl = appBaseNoFile;
	    }
	    if (rewrittenUrl) {
	      this.$$parse(rewrittenUrl);
	    }
	    return !!rewrittenUrl;
	  };
	
	  this.$$normalizeUrl = function(url) {
	    // include hashPrefix in $$absUrl when $$url is empty so IE9 does not reload page because of removal of '#'
	    return appBase + hashPrefix + url;
	  };
	}
	
	
	var locationPrototype = {
	
	  /**
	   * Ensure absolute URL is initialized.
	   * @private
	   */
	  $$absUrl:'',
	
	  /**
	   * Are we in html5 mode?
	   * @private
	   */
	  $$html5: false,
	
	  /**
	   * Has any change been replacing?
	   * @private
	   */
	  $$replace: false,
	
	  /**
	   * Compose url and update `url` and `absUrl` property
	   * @private
	   */
	  $$compose: function() {
	    this.$$url = normalizePath(this.$$path, this.$$search, this.$$hash);
	    this.$$absUrl = this.$$normalizeUrl(this.$$url);
	    this.$$urlUpdatedByLocation = true;
	  },
	
	  /**
	   * @ngdoc method
	   * @name $location#absUrl
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return full URL representation with all segments encoded according to rules specified in
	   * [RFC 3986](http://www.ietf.org/rfc/rfc3986.txt).
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var absUrl = $location.absUrl();
	   * // => "http://example.com/#/some/path?foo=bar&baz=xoxo"
	   * ```
	   *
	   * @return {string} full URL
	   */
	  absUrl: locationGetter('$$absUrl'),
	
	  /**
	   * @ngdoc method
	   * @name $location#url
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return URL (e.g. `/path?a=b#hash`) when called without any parameter.
	   *
	   * Change path, search and hash, when called with parameter and return `$location`.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var url = $location.url();
	   * // => "/some/path?foo=bar&baz=xoxo"
	   * ```
	   *
	   * @param {string=} url New URL without base prefix (e.g. `/path?a=b#hash`)
	   * @return {string} url
	   */
	  url: function(url) {
	    if (isUndefined(url)) {
	      return this.$$url;
	    }
	
	    var match = PATH_MATCH.exec(url);
	    if (match[1] || url === '') this.path(decodeURIComponent(match[1]));
	    if (match[2] || match[1] || url === '') this.search(match[3] || '');
	    this.hash(match[5] || '');
	
	    return this;
	  },
	
	  /**
	   * @ngdoc method
	   * @name $location#protocol
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return protocol of current URL.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var protocol = $location.protocol();
	   * // => "http"
	   * ```
	   *
	   * @return {string} protocol of current URL
	   */
	  protocol: locationGetter('$$protocol'),
	
	  /**
	   * @ngdoc method
	   * @name $location#host
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return host of current URL.
	   *
	   * Note: compared to the non-AngularJS version `location.host` which returns `hostname:port`, this returns the `hostname` portion only.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var host = $location.host();
	   * // => "example.com"
	   *
	   * // given URL http://user:password@example.com:8080/#/some/path?foo=bar&baz=xoxo
	   * host = $location.host();
	   * // => "example.com"
	   * host = location.host;
	   * // => "example.com:8080"
	   * ```
	   *
	   * @return {string} host of current URL.
	   */
	  host: locationGetter('$$host'),
	
	  /**
	   * @ngdoc method
	   * @name $location#port
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return port of current URL.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var port = $location.port();
	   * // => 80
	   * ```
	   *
	   * @return {Number} port
	   */
	  port: locationGetter('$$port'),
	
	  /**
	   * @ngdoc method
	   * @name $location#path
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return path of current URL when called without any parameter.
	   *
	   * Change path when called with parameter and return `$location`.
	   *
	   * Note: Path should always begin with forward slash (/), this method will add the forward slash
	   * if it is missing.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var path = $location.path();
	   * // => "/some/path"
	   * ```
	   *
	   * @param {(string|number)=} path New path
	   * @return {(string|object)} path if called with no parameters, or `$location` if called with a parameter
	   */
	  path: locationGetterSetter('$$path', function(path) {
	    path = path !== null ? path.toString() : '';
	    return path.charAt(0) === '/' ? path : '/' + path;
	  }),
	
	  /**
	   * @ngdoc method
	   * @name $location#search
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return search part (as object) of current URL when called without any parameter.
	   *
	   * Change search part when called with parameter and return `$location`.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var searchObject = $location.search();
	   * // => {foo: 'bar', baz: 'xoxo'}
	   *
	   * // set foo to 'yipee'
	   * $location.search('foo', 'yipee');
	   * // $location.search() => {foo: 'yipee', baz: 'xoxo'}
	   * ```
	   *
	   * @param {string|Object.<string>|Object.<Array.<string>>} search New search params - string or
	   * hash object.
	   *
	   * When called with a single argument the method acts as a setter, setting the `search` component
	   * of `$location` to the specified value.
	   *
	   * If the argument is a hash object containing an array of values, these values will be encoded
	   * as duplicate search parameters in the URL.
	   *
	   * @param {(string|Number|Array<string>|boolean)=} paramValue If `search` is a string or number, then `paramValue`
	   * will override only a single search property.
	   *
	   * If `paramValue` is an array, it will override the property of the `search` component of
	   * `$location` specified via the first argument.
	   *
	   * If `paramValue` is `null`, the property specified via the first argument will be deleted.
	   *
	   * If `paramValue` is `true`, the property specified via the first argument will be added with no
	   * value nor trailing equal sign.
	   *
	   * @return {Object} If called with no arguments returns the parsed `search` object. If called with
	   * one or more arguments returns `$location` object itself.
	   */
	  search: function(search, paramValue) {
	    switch (arguments.length) {
	      case 0:
	        return this.$$search;
	      case 1:
	        if (isString(search) || isNumber(search)) {
	          search = search.toString();
	          this.$$search = parseKeyValue(search);
	        } else if (isObject(search)) {
	          search = copy(search, {});
	          // remove object undefined or null properties
	          forEach(search, function(value, key) {
	            if (value == null) delete search[key];
	          });
	
	          this.$$search = search;
	        } else {
	          throw $locationMinErr('isrcharg',
	              'The first argument of the `$location#search()` call must be a string or an object.');
	        }
	        break;
	      default:
	        if (isUndefined(paramValue) || paramValue === null) {
	          delete this.$$search[search];
	        } else {
	          this.$$search[search] = paramValue;
	        }
	    }
	
	    this.$$compose();
	    return this;
	  },
	
	  /**
	   * @ngdoc method
	   * @name $location#hash
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Returns the hash fragment when called without any parameters.
	   *
	   * Changes the hash fragment when called with a parameter and returns `$location`.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo#hashValue
	   * var hash = $location.hash();
	   * // => "hashValue"
	   * ```
	   *
	   * @param {(string|number)=} hash New hash fragment
	   * @return {string} hash
	   */
	  hash: locationGetterSetter('$$hash', function(hash) {
	    return hash !== null ? hash.toString() : '';
	  }),
	
	  /**
	   * @ngdoc method
	   * @name $location#replace
	   *
	   * @description
	   * If called, all changes to $location during the current `$digest` will replace the current history
	   * record, instead of adding a new one.
	   */
	  replace: function() {
	    this.$$replace = true;
	    return this;
	  }
	};
	
	forEach([LocationHashbangInHtml5Url, LocationHashbangUrl, LocationHtml5Url], function(Location) {
	  Location.prototype = Object.create(locationPrototype);
	
	  /**
	   * @ngdoc method
	   * @name $location#state
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return the history state object when called without any parameter.
	   *
	   * Change the history state object when called with one parameter and return `$location`.
	   * The state object is later passed to `pushState` or `replaceState`.
	   *
	   * NOTE: This method is supported only in HTML5 mode and only in browsers supporting
	   * the HTML5 History API (i.e. methods `pushState` and `replaceState`). If you need to support
	   * older browsers (like IE9 or Android < 4.0), don't use this method.
	   *
	   * @param {object=} state State object for pushState or replaceState
	   * @return {object} state
	   */
	  Location.prototype.state = function(state) {
	    if (!arguments.length) {
	      return this.$$state;
	    }
	
	    if (Location !== LocationHtml5Url || !this.$$html5) {
	      throw $locationMinErr('nostate', 'History API state support is available only ' +
	        'in HTML5 mode and only in browsers supporting HTML5 History API');
	    }
	    // The user might modify `stateObject` after invoking `$location.state(stateObject)`
	    // but we're changing the $$state reference to $browser.state() during the $digest
	    // so the modification window is narrow.
	    this.$$state = isUndefined(state) ? null : state;
	    this.$$urlUpdatedByLocation = true;
	
	    return this;
	  };
	});
	
	
	function locationGetter(property) {
	  return /** @this */ function() {
	    return this[property];
	  };
	}
	
	
	function locationGetterSetter(property, preprocess) {
	  return /** @this */ function(value) {
	    if (isUndefined(value)) {
	      return this[property];
	    }
	
	    this[property] = preprocess(value);
	    this.$$compose();
	
	    return this;
	  };
	}
	
	
	/**
	 * @ngdoc service
	 * @name $location
	 *
	 * @requires $rootElement
	 *
	 * @description
	 * The $location service parses the URL in the browser address bar (based on the
	 * [window.location](https://developer.mozilla.org/en/window.location)) and makes the URL
	 * available to your application. Changes to the URL in the address bar are reflected into
	 * $location service and changes to $location are reflected into the browser address bar.
	 *
	 * **The $location service:**
	 *
	 * - Exposes the current URL in the browser address bar, so you can
	 *   - Watch and observe the URL.
	 *   - Change the URL.
	 * - Synchronizes the URL with the browser when the user
	 *   - Changes the address bar.
	 *   - Clicks the back or forward button (or clicks a History link).
	 *   - Clicks on a link.
	 * - Represents the URL object as a set of methods (protocol, host, port, path, search, hash).
	 *
	 * For more information see {@link guide/$location Developer Guide: Using $location}
	 */
	
	/**
	 * @ngdoc provider
	 * @name $locationProvider
	 * @this
	 *
	 * @description
	 * Use the `$locationProvider` to configure how the application deep linking paths are stored.
	 */
	function $LocationProvider() {
	  var hashPrefix = '!',
	      html5Mode = {
	        enabled: false,
	        requireBase: true,
	        rewriteLinks: true
	      };
	
	  /**
	   * @ngdoc method
	   * @name $locationProvider#hashPrefix
	   * @description
	   * The default value for the prefix is `'!'`.
	   * @param {string=} prefix Prefix for hash part (containing path and search)
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   */
	  this.hashPrefix = function(prefix) {
	    if (isDefined(prefix)) {
	      hashPrefix = prefix;
	      return this;
	    } else {
	      return hashPrefix;
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name $locationProvider#html5Mode
	   * @description
	   * @param {(boolean|Object)=} mode If boolean, sets `html5Mode.enabled` to value.
	   *   If object, sets `enabled`, `requireBase` and `rewriteLinks` to respective values. Supported
	   *   properties:
	   *   - **enabled** – `{boolean}` – (default: false) If true, will rely on `history.pushState` to
	   *     change urls where supported. Will fall back to hash-prefixed paths in browsers that do not
	   *     support `pushState`.
	   *   - **requireBase** - `{boolean}` - (default: `true`) When html5Mode is enabled, specifies
	   *     whether or not a <base> tag is required to be present. If `enabled` and `requireBase` are
	   *     true, and a base tag is not present, an error will be thrown when `$location` is injected.
	   *     See the {@link guide/$location $location guide for more information}
	   *   - **rewriteLinks** - `{boolean|string}` - (default: `true`) When html5Mode is enabled,
	   *     enables/disables URL rewriting for relative links. If set to a string, URL rewriting will
	   *     only happen on links with an attribute that matches the given string. For example, if set
	   *     to `'internal-link'`, then the URL will only be rewritten for `<a internal-link>` links.
	   *     Note that [attribute name normalization](guide/directive#normalization) does not apply
	   *     here, so `'internalLink'` will **not** match `'internal-link'`.
	   *
	   * @returns {Object} html5Mode object if used as getter or itself (chaining) if used as setter
	   */
	  this.html5Mode = function(mode) {
	    if (isBoolean(mode)) {
	      html5Mode.enabled = mode;
	      return this;
	    } else if (isObject(mode)) {
	
	      if (isBoolean(mode.enabled)) {
	        html5Mode.enabled = mode.enabled;
	      }
	
	      if (isBoolean(mode.requireBase)) {
	        html5Mode.requireBase = mode.requireBase;
	      }
	
	      if (isBoolean(mode.rewriteLinks) || isString(mode.rewriteLinks)) {
	        html5Mode.rewriteLinks = mode.rewriteLinks;
	      }
	
	      return this;
	    } else {
	      return html5Mode;
	    }
	  };
	
	  /**
	   * @ngdoc event
	   * @name $location#$locationChangeStart
	   * @eventType broadcast on root scope
	   * @description
	   * Broadcasted before a URL will change.
	   *
	   * This change can be prevented by calling
	   * `preventDefault` method of the event. See {@link ng.$rootScope.Scope#$on} for more
	   * details about event object. Upon successful change
	   * {@link ng.$location#$locationChangeSuccess $locationChangeSuccess} is fired.
	   *
	   * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
	   * the browser supports the HTML5 History API.
	   *
	   * @param {Object} angularEvent Synthetic event object.
	   * @param {string} newUrl New URL
	   * @param {string=} oldUrl URL that was before it was changed.
	   * @param {string=} newState New history state object
	   * @param {string=} oldState History state object that was before it was changed.
	   */
	
	  /**
	   * @ngdoc event
	   * @name $location#$locationChangeSuccess
	   * @eventType broadcast on root scope
	   * @description
	   * Broadcasted after a URL was changed.
	   *
	   * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
	   * the browser supports the HTML5 History API.
	   *
	   * @param {Object} angularEvent Synthetic event object.
	   * @param {string} newUrl New URL
	   * @param {string=} oldUrl URL that was before it was changed.
	   * @param {string=} newState New history state object
	   * @param {string=} oldState History state object that was before it was changed.
	   */
	
	  this.$get = ['$rootScope', '$browser', '$sniffer', '$rootElement', '$window',
	      function($rootScope, $browser, $sniffer, $rootElement, $window) {
	    var $location,
	        LocationMode,
	        baseHref = $browser.baseHref(), // if base[href] is undefined, it defaults to ''
	        initialUrl = $browser.url(),
	        appBase;
	
	    if (html5Mode.enabled) {
	      if (!baseHref && html5Mode.requireBase) {
	        throw $locationMinErr('nobase',
	          '$location in HTML5 mode requires a <base> tag to be present!');
	      }
	      appBase = serverBase(initialUrl) + (baseHref || '/');
	      LocationMode = $sniffer.history ? LocationHtml5Url : LocationHashbangInHtml5Url;
	    } else {
	      appBase = stripHash(initialUrl);
	      LocationMode = LocationHashbangUrl;
	    }
	    var appBaseNoFile = stripFile(appBase);
	
	    $location = new LocationMode(appBase, appBaseNoFile, '#' + hashPrefix);
	    $location.$$parseLinkUrl(initialUrl, initialUrl);
	
	    $location.$$state = $browser.state();
	
	    var IGNORE_URI_REGEXP = /^\s*(javascript|mailto):/i;
	
	    // Determine if two URLs are equal despite potentially having different encoding/normalizing
	    //  such as $location.absUrl() vs $browser.url()
	    // See https://github.com/angular/angular.js/issues/16592
	    function urlsEqual(a, b) {
	      return a === b || urlResolve(a).href === urlResolve(b).href;
	    }
	
	    function setBrowserUrlWithFallback(url, replace, state) {
	      var oldUrl = $location.url();
	      var oldState = $location.$$state;
	      try {
	        $browser.url(url, replace, state);
	
	        // Make sure $location.state() returns referentially identical (not just deeply equal)
	        // state object; this makes possible quick checking if the state changed in the digest
	        // loop. Checking deep equality would be too expensive.
	        $location.$$state = $browser.state();
	      } catch (e) {
	        // Restore old values if pushState fails
	        $location.url(oldUrl);
	        $location.$$state = oldState;
	
	        throw e;
	      }
	    }
	
	    $rootElement.on('click', function(event) {
	      var rewriteLinks = html5Mode.rewriteLinks;
	      // TODO(vojta): rewrite link when opening in new tab/window (in legacy browser)
	      // currently we open nice url link and redirect then
	
	      if (!rewriteLinks || event.ctrlKey || event.metaKey || event.shiftKey || event.which === 2 || event.button === 2) return;
	
	      var elm = jqLite(event.target);
	
	      // traverse the DOM up to find first A tag
	      while (nodeName_(elm[0]) !== 'a') {
	        // ignore rewriting if no A tag (reached root element, or no parent - removed from document)
	        if (elm[0] === $rootElement[0] || !(elm = elm.parent())[0]) return;
	      }
	
	      if (isString(rewriteLinks) && isUndefined(elm.attr(rewriteLinks))) return;
	
	      var absHref = elm.prop('href');
	      // get the actual href attribute - see
	      // http://msdn.microsoft.com/en-us/library/ie/dd347148(v=vs.85).aspx
	      var relHref = elm.attr('href') || elm.attr('xlink:href');
	
	      if (isObject(absHref) && absHref.toString() === '[object SVGAnimatedString]') {
	        // SVGAnimatedString.animVal should be identical to SVGAnimatedString.baseVal, unless during
	        // an animation.
	        absHref = urlResolve(absHref.animVal).href;
	      }
	
	      // Ignore when url is started with javascript: or mailto:
	      if (IGNORE_URI_REGEXP.test(absHref)) return;
	
	      if (absHref && !elm.attr('target') && !event.isDefaultPrevented()) {
	        if ($location.$$parseLinkUrl(absHref, relHref)) {
	          // We do a preventDefault for all urls that are part of the AngularJS application,
	          // in html5mode and also without, so that we are able to abort navigation without
	          // getting double entries in the location history.
	          event.preventDefault();
	          // update location manually
	          if ($location.absUrl() !== $browser.url()) {
	            $rootScope.$apply();
	          }
	        }
	      }
	    });
	
	
	    // rewrite hashbang url <> html5 url
	    if ($location.absUrl() !== initialUrl) {
	      $browser.url($location.absUrl(), true);
	    }
	
	    var initializing = true;
	
	    // update $location when $browser url changes
	    $browser.onUrlChange(function(newUrl, newState) {
	
	      if (!startsWith(newUrl, appBaseNoFile)) {
	        // If we are navigating outside of the app then force a reload
	        $window.location.href = newUrl;
	        return;
	      }
	
	      $rootScope.$evalAsync(function() {
	        var oldUrl = $location.absUrl();
	        var oldState = $location.$$state;
	        var defaultPrevented;
	        $location.$$parse(newUrl);
	        $location.$$state = newState;
	
	        defaultPrevented = $rootScope.$broadcast('$locationChangeStart', newUrl, oldUrl,
	            newState, oldState).defaultPrevented;
	
	        // if the location was changed by a `$locationChangeStart` handler then stop
	        // processing this location change
	        if ($location.absUrl() !== newUrl) return;
	
	        if (defaultPrevented) {
	          $location.$$parse(oldUrl);
	          $location.$$state = oldState;
	          setBrowserUrlWithFallback(oldUrl, false, oldState);
	        } else {
	          initializing = false;
	          afterLocationChange(oldUrl, oldState);
	        }
	      });
	      if (!$rootScope.$$phase) $rootScope.$digest();
	    });
	
	    // update browser
	    $rootScope.$watch(function $locationWatch() {
	      if (initializing || $location.$$urlUpdatedByLocation) {
	        $location.$$urlUpdatedByLocation = false;
	
	        var oldUrl = $browser.url();
	        var newUrl = $location.absUrl();
	        var oldState = $browser.state();
	        var currentReplace = $location.$$replace;
	        var urlOrStateChanged = !urlsEqual(oldUrl, newUrl) ||
	          ($location.$$html5 && $sniffer.history && oldState !== $location.$$state);
	
	        if (initializing || urlOrStateChanged) {
	          initializing = false;
	
	          $rootScope.$evalAsync(function() {
	            var newUrl = $location.absUrl();
	            var defaultPrevented = $rootScope.$broadcast('$locationChangeStart', newUrl, oldUrl,
	                $location.$$state, oldState).defaultPrevented;
	
	            // if the location was changed by a `$locationChangeStart` handler then stop
	            // processing this location change
	            if ($location.absUrl() !== newUrl) return;
	
	            if (defaultPrevented) {
	              $location.$$parse(oldUrl);
	              $location.$$state = oldState;
	            } else {
	              if (urlOrStateChanged) {
	                setBrowserUrlWithFallback(newUrl, currentReplace,
	                                          oldState === $location.$$state ? null : $location.$$state);
	              }
	              afterLocationChange(oldUrl, oldState);
	            }
	          });
	        }
	      }
	
	      $location.$$replace = false;
	
	      // we don't need to return anything because $evalAsync will make the digest loop dirty when
	      // there is a change
	    });
	
	    return $location;
	
	    function afterLocationChange(oldUrl, oldState) {
	      $rootScope.$broadcast('$locationChangeSuccess', $location.absUrl(), oldUrl,
	        $location.$$state, oldState);
	    }
	}];
	}
	
	/**
	 * @ngdoc service
	 * @name $log
	 * @requires $window
	 *
	 * @description
	 * Simple service for logging. Default implementation safely writes the message
	 * into the browser's console (if present).
	 *
	 * The main purpose of this service is to simplify debugging and troubleshooting.
	 *
	 * To reveal the location of the calls to `$log` in the JavaScript console,
	 * you can "blackbox" the AngularJS source in your browser:
	 *
	 * [Mozilla description of blackboxing](https://developer.mozilla.org/en-US/docs/Tools/Debugger/How_to/Black_box_a_source).
	 * [Chrome description of blackboxing](https://developer.chrome.com/devtools/docs/blackboxing).
	 *
	 * Note: Not all browsers support blackboxing.
	 *
	 * The default is to log `debug` messages. You can use
	 * {@link ng.$logProvider ng.$logProvider#debugEnabled} to change this.
	 *
	 * @example
	   <example module="logExample" name="log-service">
	     <file name="script.js">
	       angular.module('logExample', [])
	         .controller('LogController', ['$scope', '$log', function($scope, $log) {
	           $scope.$log = $log;
	           $scope.message = 'Hello World!';
	         }]);
	     </file>
	     <file name="index.html">
	       <div ng-controller="LogController">
	         <p>Reload this page with open console, enter text and hit the log button...</p>
	         <label>Message:
	         <input type="text" ng-model="message" /></label>
	         <button ng-click="$log.log(message)">log</button>
	         <button ng-click="$log.warn(message)">warn</button>
	         <button ng-click="$log.info(message)">info</button>
	         <button ng-click="$log.error(message)">error</button>
	         <button ng-click="$log.debug(message)">debug</button>
	       </div>
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc provider
	 * @name $logProvider
	 * @this
	 *
	 * @description
	 * Use the `$logProvider` to configure how the application logs messages
	 */
	function $LogProvider() {
	  var debug = true,
	      self = this;
	
	  /**
	   * @ngdoc method
	   * @name $logProvider#debugEnabled
	   * @description
	   * @param {boolean=} flag enable or disable debug level messages
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   */
	  this.debugEnabled = function(flag) {
	    if (isDefined(flag)) {
	      debug = flag;
	      return this;
	    } else {
	      return debug;
	    }
	  };
	
	  this.$get = ['$window', function($window) {
	    // Support: IE 9-11, Edge 12-14+
	    // IE/Edge display errors in such a way that it requires the user to click in 4 places
	    // to see the stack trace. There is no way to feature-detect it so there's a chance
	    // of the user agent sniffing to go wrong but since it's only about logging, this shouldn't
	    // break apps. Other browsers display errors in a sensible way and some of them map stack
	    // traces along source maps if available so it makes sense to let browsers display it
	    // as they want.
	    var formatStackTrace = msie || /\bEdge\//.test($window.navigator && $window.navigator.userAgent);
	
	    return {
	      /**
	       * @ngdoc method
	       * @name $log#log
	       *
	       * @description
	       * Write a log message
	       */
	      log: consoleLog('log'),
	
	      /**
	       * @ngdoc method
	       * @name $log#info
	       *
	       * @description
	       * Write an information message
	       */
	      info: consoleLog('info'),
	
	      /**
	       * @ngdoc method
	       * @name $log#warn
	       *
	       * @description
	       * Write a warning message
	       */
	      warn: consoleLog('warn'),
	
	      /**
	       * @ngdoc method
	       * @name $log#error
	       *
	       * @description
	       * Write an error message
	       */
	      error: consoleLog('error'),
	
	      /**
	       * @ngdoc method
	       * @name $log#debug
	       *
	       * @description
	       * Write a debug message
	       */
	      debug: (function() {
	        var fn = consoleLog('debug');
	
	        return function() {
	          if (debug) {
	            fn.apply(self, arguments);
	          }
	        };
	      })()
	    };
	
	    function formatError(arg) {
	      if (isError(arg)) {
	        if (arg.stack && formatStackTrace) {
	          arg = (arg.message && arg.stack.indexOf(arg.message) === -1)
	              ? 'Error: ' + arg.message + '\n' + arg.stack
	              : arg.stack;
	        } else if (arg.sourceURL) {
	          arg = arg.message + '\n' + arg.sourceURL + ':' + arg.line;
	        }
	      }
	      return arg;
	    }
	
	    function consoleLog(type) {
	      var console = $window.console || {},
	          logFn = console[type] || console.log || noop;
	
	      return function() {
	        var args = [];
	        forEach(arguments, function(arg) {
	          args.push(formatError(arg));
	        });
	        // Support: IE 9 only
	        // console methods don't inherit from Function.prototype in IE 9 so we can't
	        // call `logFn.apply(console, args)` directly.
	        return Function.prototype.apply.call(logFn, console, args);
	      };
	    }
	  }];
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	var $parseMinErr = minErr('$parse');
	
	var objectValueOf = {}.constructor.prototype.valueOf;
	
	// Sandboxing AngularJS Expressions
	// ------------------------------
	// AngularJS expressions are no longer sandboxed. So it is now even easier to access arbitrary JS code by
	// various means such as obtaining a reference to native JS functions like the Function constructor.
	//
	// As an example, consider the following AngularJS expression:
	//
	//   {}.toString.constructor('alert("evil JS code")')
	//
	// It is important to realize that if you create an expression from a string that contains user provided
	// content then it is possible that your application contains a security vulnerability to an XSS style attack.
	//
	// See https://docs.angularjs.org/guide/security
	
	
	function getStringValue(name) {
	  // Property names must be strings. This means that non-string objects cannot be used
	  // as keys in an object. Any non-string object, including a number, is typecasted
	  // into a string via the toString method.
	  // -- MDN, https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Operators/Property_accessors#Property_names
	  //
	  // So, to ensure that we are checking the same `name` that JavaScript would use, we cast it
	  // to a string. It's not always possible. If `name` is an object and its `toString` method is
	  // 'broken' (doesn't return a string, isn't a function, etc.), an error will be thrown:
	  //
	  // TypeError: Cannot convert object to primitive value
	  //
	  // For performance reasons, we don't catch this error here and allow it to propagate up the call
	  // stack. Note that you'll get the same error in JavaScript if you try to access a property using
	  // such a 'broken' object as a key.
	  return name + '';
	}
	
	
	var OPERATORS = createMap();
	forEach('+ - * / % === !== == != < > <= >= && || ! = |'.split(' '), function(operator) { OPERATORS[operator] = true; });
	var ESCAPE = {'n':'\n', 'f':'\f', 'r':'\r', 't':'\t', 'v':'\v', '\'':'\'', '"':'"'};
	
	
	/////////////////////////////////////////
	
	
	/**
	 * @constructor
	 */
	var Lexer = function Lexer(options) {
	  this.options = options;
	};
	
	Lexer.prototype = {
	  constructor: Lexer,
	
	  lex: function(text) {
	    this.text = text;
	    this.index = 0;
	    this.tokens = [];
	
	    while (this.index < this.text.length) {
	      var ch = this.text.charAt(this.index);
	      if (ch === '"' || ch === '\'') {
	        this.readString(ch);
	      } else if (this.isNumber(ch) || ch === '.' && this.isNumber(this.peek())) {
	        this.readNumber();
	      } else if (this.isIdentifierStart(this.peekMultichar())) {
	        this.readIdent();
	      } else if (this.is(ch, '(){}[].,;:?')) {
	        this.tokens.push({index: this.index, text: ch});
	        this.index++;
	      } else if (this.isWhitespace(ch)) {
	        this.index++;
	      } else {
	        var ch2 = ch + this.peek();
	        var ch3 = ch2 + this.peek(2);
	        var op1 = OPERATORS[ch];
	        var op2 = OPERATORS[ch2];
	        var op3 = OPERATORS[ch3];
	        if (op1 || op2 || op3) {
	          var token = op3 ? ch3 : (op2 ? ch2 : ch);
	          this.tokens.push({index: this.index, text: token, operator: true});
	          this.index += token.length;
	        } else {
	          this.throwError('Unexpected next character ', this.index, this.index + 1);
	        }
	      }
	    }
	    return this.tokens;
	  },
	
	  is: function(ch, chars) {
	    return chars.indexOf(ch) !== -1;
	  },
	
	  peek: function(i) {
	    var num = i || 1;
	    return (this.index + num < this.text.length) ? this.text.charAt(this.index + num) : false;
	  },
	
	  isNumber: function(ch) {
	    return ('0' <= ch && ch <= '9') && typeof ch === 'string';
	  },
	
	  isWhitespace: function(ch) {
	    // IE treats non-breaking space as \u00A0
	    return (ch === ' ' || ch === '\r' || ch === '\t' ||
	            ch === '\n' || ch === '\v' || ch === '\u00A0');
	  },
	
	  isIdentifierStart: function(ch) {
	    return this.options.isIdentifierStart ?
	        this.options.isIdentifierStart(ch, this.codePointAt(ch)) :
	        this.isValidIdentifierStart(ch);
	  },
	
	  isValidIdentifierStart: function(ch) {
	    return ('a' <= ch && ch <= 'z' ||
	            'A' <= ch && ch <= 'Z' ||
	            '_' === ch || ch === '$');
	  },
	
	  isIdentifierContinue: function(ch) {
	    return this.options.isIdentifierContinue ?
	        this.options.isIdentifierContinue(ch, this.codePointAt(ch)) :
	        this.isValidIdentifierContinue(ch);
	  },
	
	  isValidIdentifierContinue: function(ch, cp) {
	    return this.isValidIdentifierStart(ch, cp) || this.isNumber(ch);
	  },
	
	  codePointAt: function(ch) {
	    if (ch.length === 1) return ch.charCodeAt(0);
	    // eslint-disable-next-line no-bitwise
	    return (ch.charCodeAt(0) << 10) + ch.charCodeAt(1) - 0x35FDC00;
	  },
	
	  peekMultichar: function() {
	    var ch = this.text.charAt(this.index);
	    var peek = this.peek();
	    if (!peek) {
	      return ch;
	    }
	    var cp1 = ch.charCodeAt(0);
	    var cp2 = peek.charCodeAt(0);
	    if (cp1 >= 0xD800 && cp1 <= 0xDBFF && cp2 >= 0xDC00 && cp2 <= 0xDFFF) {
	      return ch + peek;
	    }
	    return ch;
	  },
	
	  isExpOperator: function(ch) {
	    return (ch === '-' || ch === '+' || this.isNumber(ch));
	  },
	
	  throwError: function(error, start, end) {
	    end = end || this.index;
	    var colStr = (isDefined(start)
	            ? 's ' + start +  '-' + this.index + ' [' + this.text.substring(start, end) + ']'
	            : ' ' + end);
	    throw $parseMinErr('lexerr', 'Lexer Error: {0} at column{1} in expression [{2}].',
	        error, colStr, this.text);
	  },
	
	  readNumber: function() {
	    var number = '';
	    var start = this.index;
	    while (this.index < this.text.length) {
	      var ch = lowercase(this.text.charAt(this.index));
	      if (ch === '.' || this.isNumber(ch)) {
	        number += ch;
	      } else {
	        var peekCh = this.peek();
	        if (ch === 'e' && this.isExpOperator(peekCh)) {
	          number += ch;
	        } else if (this.isExpOperator(ch) &&
	            peekCh && this.isNumber(peekCh) &&
	            number.charAt(number.length - 1) === 'e') {
	          number += ch;
	        } else if (this.isExpOperator(ch) &&
	            (!peekCh || !this.isNumber(peekCh)) &&
	            number.charAt(number.length - 1) === 'e') {
	          this.throwError('Invalid exponent');
	        } else {
	          break;
	        }
	      }
	      this.index++;
	    }
	    this.tokens.push({
	      index: start,
	      text: number,
	      constant: true,
	      value: Number(number)
	    });
	  },
	
	  readIdent: function() {
	    var start = this.index;
	    this.index += this.peekMultichar().length;
	    while (this.index < this.text.length) {
	      var ch = this.peekMultichar();
	      if (!this.isIdentifierContinue(ch)) {
	        break;
	      }
	      this.index += ch.length;
	    }
	    this.tokens.push({
	      index: start,
	      text: this.text.slice(start, this.index),
	      identifier: true
	    });
	  },
	
	  readString: function(quote) {
	    var start = this.index;
	    this.index++;
	    var string = '';
	    var rawString = quote;
	    var escape = false;
	    while (this.index < this.text.length) {
	      var ch = this.text.charAt(this.index);
	      rawString += ch;
	      if (escape) {
	        if (ch === 'u') {
	          var hex = this.text.substring(this.index + 1, this.index + 5);
	          if (!hex.match(/[\da-f]{4}/i)) {
	            this.throwError('Invalid unicode escape [\\u' + hex + ']');
	          }
	          this.index += 4;
	          string += String.fromCharCode(parseInt(hex, 16));
	        } else {
	          var rep = ESCAPE[ch];
	          string = string + (rep || ch);
	        }
	        escape = false;
	      } else if (ch === '\\') {
	        escape = true;
	      } else if (ch === quote) {
	        this.index++;
	        this.tokens.push({
	          index: start,
	          text: rawString,
	          constant: true,
	          value: string
	        });
	        return;
	      } else {
	        string += ch;
	      }
	      this.index++;
	    }
	    this.throwError('Unterminated quote', start);
	  }
	};
	
	var AST = function AST(lexer, options) {
	  this.lexer = lexer;
	  this.options = options;
	};
	
	AST.Program = 'Program';
	AST.ExpressionStatement = 'ExpressionStatement';
	AST.AssignmentExpression = 'AssignmentExpression';
	AST.ConditionalExpression = 'ConditionalExpression';
	AST.LogicalExpression = 'LogicalExpression';
	AST.BinaryExpression = 'BinaryExpression';
	AST.UnaryExpression = 'UnaryExpression';
	AST.CallExpression = 'CallExpression';
	AST.MemberExpression = 'MemberExpression';
	AST.Identifier = 'Identifier';
	AST.Literal = 'Literal';
	AST.ArrayExpression = 'ArrayExpression';
	AST.Property = 'Property';
	AST.ObjectExpression = 'ObjectExpression';
	AST.ThisExpression = 'ThisExpression';
	AST.LocalsExpression = 'LocalsExpression';
	
	// Internal use only
	AST.NGValueParameter = 'NGValueParameter';
	
	AST.prototype = {
	  ast: function(text) {
	    this.text = text;
	    this.tokens = this.lexer.lex(text);
	
	    var value = this.program();
	
	    if (this.tokens.length !== 0) {
	      this.throwError('is an unexpected token', this.tokens[0]);
	    }
	
	    return value;
	  },
	
	  program: function() {
	    var body = [];
	    while (true) {
	      if (this.tokens.length > 0 && !this.peek('}', ')', ';', ']'))
	        body.push(this.expressionStatement());
	      if (!this.expect(';')) {
	        return { type: AST.Program, body: body};
	      }
	    }
	  },
	
	  expressionStatement: function() {
	    return { type: AST.ExpressionStatement, expression: this.filterChain() };
	  },
	
	  filterChain: function() {
	    var left = this.expression();
	    while (this.expect('|')) {
	      left = this.filter(left);
	    }
	    return left;
	  },
	
	  expression: function() {
	    return this.assignment();
	  },
	
	  assignment: function() {
	    var result = this.ternary();
	    if (this.expect('=')) {
	      if (!isAssignable(result)) {
	        throw $parseMinErr('lval', 'Trying to assign a value to a non l-value');
	      }
	
	      result = { type: AST.AssignmentExpression, left: result, right: this.assignment(), operator: '='};
	    }
	    return result;
	  },
	
	  ternary: function() {
	    var test = this.logicalOR();
	    var alternate;
	    var consequent;
	    if (this.expect('?')) {
	      alternate = this.expression();
	      if (this.consume(':')) {
	        consequent = this.expression();
	        return { type: AST.ConditionalExpression, test: test, alternate: alternate, consequent: consequent};
	      }
	    }
	    return test;
	  },
	
	  logicalOR: function() {
	    var left = this.logicalAND();
	    while (this.expect('||')) {
	      left = { type: AST.LogicalExpression, operator: '||', left: left, right: this.logicalAND() };
	    }
	    return left;
	  },
	
	  logicalAND: function() {
	    var left = this.equality();
	    while (this.expect('&&')) {
	      left = { type: AST.LogicalExpression, operator: '&&', left: left, right: this.equality()};
	    }
	    return left;
	  },
	
	  equality: function() {
	    var left = this.relational();
	    var token;
	    while ((token = this.expect('==','!=','===','!=='))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.relational() };
	    }
	    return left;
	  },
	
	  relational: function() {
	    var left = this.additive();
	    var token;
	    while ((token = this.expect('<', '>', '<=', '>='))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.additive() };
	    }
	    return left;
	  },
	
	  additive: function() {
	    var left = this.multiplicative();
	    var token;
	    while ((token = this.expect('+','-'))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.multiplicative() };
	    }
	    return left;
	  },
	
	  multiplicative: function() {
	    var left = this.unary();
	    var token;
	    while ((token = this.expect('*','/','%'))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.unary() };
	    }
	    return left;
	  },
	
	  unary: function() {
	    var token;
	    if ((token = this.expect('+', '-', '!'))) {
	      return { type: AST.UnaryExpression, operator: token.text, prefix: true, argument: this.unary() };
	    } else {
	      return this.primary();
	    }
	  },
	
	  primary: function() {
	    var primary;
	    if (this.expect('(')) {
	      primary = this.filterChain();
	      this.consume(')');
	    } else if (this.expect('[')) {
	      primary = this.arrayDeclaration();
	    } else if (this.expect('{')) {
	      primary = this.object();
	    } else if (this.selfReferential.hasOwnProperty(this.peek().text)) {
	      primary = copy(this.selfReferential[this.consume().text]);
	    } else if (this.options.literals.hasOwnProperty(this.peek().text)) {
	      primary = { type: AST.Literal, value: this.options.literals[this.consume().text]};
	    } else if (this.peek().identifier) {
	      primary = this.identifier();
	    } else if (this.peek().constant) {
	      primary = this.constant();
	    } else {
	      this.throwError('not a primary expression', this.peek());
	    }
	
	    var next;
	    while ((next = this.expect('(', '[', '.'))) {
	      if (next.text === '(') {
	        primary = {type: AST.CallExpression, callee: primary, arguments: this.parseArguments() };
	        this.consume(')');
	      } else if (next.text === '[') {
	        primary = { type: AST.MemberExpression, object: primary, property: this.expression(), computed: true };
	        this.consume(']');
	      } else if (next.text === '.') {
	        primary = { type: AST.MemberExpression, object: primary, property: this.identifier(), computed: false };
	      } else {
	        this.throwError('IMPOSSIBLE');
	      }
	    }
	    return primary;
	  },
	
	  filter: function(baseExpression) {
	    var args = [baseExpression];
	    var result = {type: AST.CallExpression, callee: this.identifier(), arguments: args, filter: true};
	
	    while (this.expect(':')) {
	      args.push(this.expression());
	    }
	
	    return result;
	  },
	
	  parseArguments: function() {
	    var args = [];
	    if (this.peekToken().text !== ')') {
	      do {
	        args.push(this.filterChain());
	      } while (this.expect(','));
	    }
	    return args;
	  },
	
	  identifier: function() {
	    var token = this.consume();
	    if (!token.identifier) {
	      this.throwError('is not a valid identifier', token);
	    }
	    return { type: AST.Identifier, name: token.text };
	  },
	
	  constant: function() {
	    // TODO check that it is a constant
	    return { type: AST.Literal, value: this.consume().value };
	  },
	
	  arrayDeclaration: function() {
	    var elements = [];
	    if (this.peekToken().text !== ']') {
	      do {
	        if (this.peek(']')) {
	          // Support trailing commas per ES5.1.
	          break;
	        }
	        elements.push(this.expression());
	      } while (this.expect(','));
	    }
	    this.consume(']');
	
	    return { type: AST.ArrayExpression, elements: elements };
	  },
	
	  object: function() {
	    var properties = [], property;
	    if (this.peekToken().text !== '}') {
	      do {
	        if (this.peek('}')) {
	          // Support trailing commas per ES5.1.
	          break;
	        }
	        property = {type: AST.Property, kind: 'init'};
	        if (this.peek().constant) {
	          property.key = this.constant();
	          property.computed = false;
	          this.consume(':');
	          property.value = this.expression();
	        } else if (this.peek().identifier) {
	          property.key = this.identifier();
	          property.computed = false;
	          if (this.peek(':')) {
	            this.consume(':');
	            property.value = this.expression();
	          } else {
	            property.value = property.key;
	          }
	        } else if (this.peek('[')) {
	          this.consume('[');
	          property.key = this.expression();
	          this.consume(']');
	          property.computed = true;
	          this.consume(':');
	          property.value = this.expression();
	        } else {
	          this.throwError('invalid key', this.peek());
	        }
	        properties.push(property);
	      } while (this.expect(','));
	    }
	    this.consume('}');
	
	    return {type: AST.ObjectExpression, properties: properties };
	  },
	
	  throwError: function(msg, token) {
	    throw $parseMinErr('syntax',
	        'Syntax Error: Token \'{0}\' {1} at column {2} of the expression [{3}] starting at [{4}].',
	          token.text, msg, (token.index + 1), this.text, this.text.substring(token.index));
	  },
	
	  consume: function(e1) {
	    if (this.tokens.length === 0) {
	      throw $parseMinErr('ueoe', 'Unexpected end of expression: {0}', this.text);
	    }
	
	    var token = this.expect(e1);
	    if (!token) {
	      this.throwError('is unexpected, expecting [' + e1 + ']', this.peek());
	    }
	    return token;
	  },
	
	  peekToken: function() {
	    if (this.tokens.length === 0) {
	      throw $parseMinErr('ueoe', 'Unexpected end of expression: {0}', this.text);
	    }
	    return this.tokens[0];
	  },
	
	  peek: function(e1, e2, e3, e4) {
	    return this.peekAhead(0, e1, e2, e3, e4);
	  },
	
	  peekAhead: function(i, e1, e2, e3, e4) {
	    if (this.tokens.length > i) {
	      var token = this.tokens[i];
	      var t = token.text;
	      if (t === e1 || t === e2 || t === e3 || t === e4 ||
	          (!e1 && !e2 && !e3 && !e4)) {
	        return token;
	      }
	    }
	    return false;
	  },
	
	  expect: function(e1, e2, e3, e4) {
	    var token = this.peek(e1, e2, e3, e4);
	    if (token) {
	      this.tokens.shift();
	      return token;
	    }
	    return false;
	  },
	
	  selfReferential: {
	    'this': {type: AST.ThisExpression },
	    '$locals': {type: AST.LocalsExpression }
	  }
	};
	
	function ifDefined(v, d) {
	  return typeof v !== 'undefined' ? v : d;
	}
	
	function plusFn(l, r) {
	  if (typeof l === 'undefined') return r;
	  if (typeof r === 'undefined') return l;
	  return l + r;
	}
	
	function isStateless($filter, filterName) {
	  var fn = $filter(filterName);
	  return !fn.$stateful;
	}
	
	var PURITY_ABSOLUTE = 1;
	var PURITY_RELATIVE = 2;
	
	// Detect nodes which could depend on non-shallow state of objects
	function isPure(node, parentIsPure) {
	  switch (node.type) {
	    // Computed members might invoke a stateful toString()
	    case AST.MemberExpression:
	      if (node.computed) {
	        return false;
	      }
	      break;
	
	    // Unary always convert to primative
	    case AST.UnaryExpression:
	      return PURITY_ABSOLUTE;
	
	    // The binary + operator can invoke a stateful toString().
	    case AST.BinaryExpression:
	      return node.operator !== '+' ? PURITY_ABSOLUTE : false;
	
	    // Functions / filters probably read state from within objects
	    case AST.CallExpression:
	      return false;
	  }
	
	  return (undefined === parentIsPure) ? PURITY_RELATIVE : parentIsPure;
	}
	
	function findConstantAndWatchExpressions(ast, $filter, parentIsPure) {
	  var allConstants;
	  var argsToWatch;
	  var isStatelessFilter;
	
	  var astIsPure = ast.isPure = isPure(ast, parentIsPure);
	
	  switch (ast.type) {
	  case AST.Program:
	    allConstants = true;
	    forEach(ast.body, function(expr) {
	      findConstantAndWatchExpressions(expr.expression, $filter, astIsPure);
	      allConstants = allConstants && expr.expression.constant;
	    });
	    ast.constant = allConstants;
	    break;
	  case AST.Literal:
	    ast.constant = true;
	    ast.toWatch = [];
	    break;
	  case AST.UnaryExpression:
	    findConstantAndWatchExpressions(ast.argument, $filter, astIsPure);
	    ast.constant = ast.argument.constant;
	    ast.toWatch = ast.argument.toWatch;
	    break;
	  case AST.BinaryExpression:
	    findConstantAndWatchExpressions(ast.left, $filter, astIsPure);
	    findConstantAndWatchExpressions(ast.right, $filter, astIsPure);
	    ast.constant = ast.left.constant && ast.right.constant;
	    ast.toWatch = ast.left.toWatch.concat(ast.right.toWatch);
	    break;
	  case AST.LogicalExpression:
	    findConstantAndWatchExpressions(ast.left, $filter, astIsPure);
	    findConstantAndWatchExpressions(ast.right, $filter, astIsPure);
	    ast.constant = ast.left.constant && ast.right.constant;
	    ast.toWatch = ast.constant ? [] : [ast];
	    break;
	  case AST.ConditionalExpression:
	    findConstantAndWatchExpressions(ast.test, $filter, astIsPure);
	    findConstantAndWatchExpressions(ast.alternate, $filter, astIsPure);
	    findConstantAndWatchExpressions(ast.consequent, $filter, astIsPure);
	    ast.constant = ast.test.constant && ast.alternate.constant && ast.consequent.constant;
	    ast.toWatch = ast.constant ? [] : [ast];
	    break;
	  case AST.Identifier:
	    ast.constant = false;
	    ast.toWatch = [ast];
	    break;
	  case AST.MemberExpression:
	    findConstantAndWatchExpressions(ast.object, $filter, astIsPure);
	    if (ast.computed) {
	      findConstantAndWatchExpressions(ast.property, $filter, astIsPure);
	    }
	    ast.constant = ast.object.constant && (!ast.computed || ast.property.constant);
	    ast.toWatch = ast.constant ? [] : [ast];
	    break;
	  case AST.CallExpression:
	    isStatelessFilter = ast.filter ? isStateless($filter, ast.callee.name) : false;
	    allConstants = isStatelessFilter;
	    argsToWatch = [];
	    forEach(ast.arguments, function(expr) {
	      findConstantAndWatchExpressions(expr, $filter, astIsPure);
	      allConstants = allConstants && expr.constant;
	      argsToWatch.push.apply(argsToWatch, expr.toWatch);
	    });
	    ast.constant = allConstants;
	    ast.toWatch = isStatelessFilter ? argsToWatch : [ast];
	    break;
	  case AST.AssignmentExpression:
	    findConstantAndWatchExpressions(ast.left, $filter, astIsPure);
	    findConstantAndWatchExpressions(ast.right, $filter, astIsPure);
	    ast.constant = ast.left.constant && ast.right.constant;
	    ast.toWatch = [ast];
	    break;
	  case AST.ArrayExpression:
	    allConstants = true;
	    argsToWatch = [];
	    forEach(ast.elements, function(expr) {
	      findConstantAndWatchExpressions(expr, $filter, astIsPure);
	      allConstants = allConstants && expr.constant;
	      argsToWatch.push.apply(argsToWatch, expr.toWatch);
	    });
	    ast.constant = allConstants;
	    ast.toWatch = argsToWatch;
	    break;
	  case AST.ObjectExpression:
	    allConstants = true;
	    argsToWatch = [];
	    forEach(ast.properties, function(property) {
	      findConstantAndWatchExpressions(property.value, $filter, astIsPure);
	      allConstants = allConstants && property.value.constant;
	      argsToWatch.push.apply(argsToWatch, property.value.toWatch);
	      if (property.computed) {
	        //`{[key]: value}` implicitly does `key.toString()` which may be non-pure
	        findConstantAndWatchExpressions(property.key, $filter, /*parentIsPure=*/false);
	        allConstants = allConstants && property.key.constant;
	        argsToWatch.push.apply(argsToWatch, property.key.toWatch);
	      }
	    });
	    ast.constant = allConstants;
	    ast.toWatch = argsToWatch;
	    break;
	  case AST.ThisExpression:
	    ast.constant = false;
	    ast.toWatch = [];
	    break;
	  case AST.LocalsExpression:
	    ast.constant = false;
	    ast.toWatch = [];
	    break;
	  }
	}
	
	function getInputs(body) {
	  if (body.length !== 1) return;
	  var lastExpression = body[0].expression;
	  var candidate = lastExpression.toWatch;
	  if (candidate.length !== 1) return candidate;
	  return candidate[0] !== lastExpression ? candidate : undefined;
	}
	
	function isAssignable(ast) {
	  return ast.type === AST.Identifier || ast.type === AST.MemberExpression;
	}
	
	function assignableAST(ast) {
	  if (ast.body.length === 1 && isAssignable(ast.body[0].expression)) {
	    return {type: AST.AssignmentExpression, left: ast.body[0].expression, right: {type: AST.NGValueParameter}, operator: '='};
	  }
	}
	
	function isLiteral(ast) {
	  return ast.body.length === 0 ||
	      ast.body.length === 1 && (
	      ast.body[0].expression.type === AST.Literal ||
	      ast.body[0].expression.type === AST.ArrayExpression ||
	      ast.body[0].expression.type === AST.ObjectExpression);
	}
	
	function isConstant(ast) {
	  return ast.constant;
	}
	
	function ASTCompiler($filter) {
	  this.$filter = $filter;
	}
	
	ASTCompiler.prototype = {
	  compile: function(ast) {
	    var self = this;
	    this.state = {
	      nextId: 0,
	      filters: {},
	      fn: {vars: [], body: [], own: {}},
	      assign: {vars: [], body: [], own: {}},
	      inputs: []
	    };
	    findConstantAndWatchExpressions(ast, self.$filter);
	    var extra = '';
	    var assignable;
	    this.stage = 'assign';
	    if ((assignable = assignableAST(ast))) {
	      this.state.computing = 'assign';
	      var result = this.nextId();
	      this.recurse(assignable, result);
	      this.return_(result);
	      extra = 'fn.assign=' + this.generateFunction('assign', 's,v,l');
	    }
	    var toWatch = getInputs(ast.body);
	    self.stage = 'inputs';
	    forEach(toWatch, function(watch, key) {
	      var fnKey = 'fn' + key;
	      self.state[fnKey] = {vars: [], body: [], own: {}};
	      self.state.computing = fnKey;
	      var intoId = self.nextId();
	      self.recurse(watch, intoId);
	      self.return_(intoId);
	      self.state.inputs.push({name: fnKey, isPure: watch.isPure});
	      watch.watchId = key;
	    });
	    this.state.computing = 'fn';
	    this.stage = 'main';
	    this.recurse(ast);
	    var fnString =
	      // The build and minification steps remove the string "use strict" from the code, but this is done using a regex.
	      // This is a workaround for this until we do a better job at only removing the prefix only when we should.
	      '"' + this.USE + ' ' + this.STRICT + '";\n' +
	      this.filterPrefix() +
	      'var fn=' + this.generateFunction('fn', 's,l,a,i') +
	      extra +
	      this.watchFns() +
	      'return fn;';
	
	    // eslint-disable-next-line no-new-func
	    var fn = (new Function('$filter',
	        'getStringValue',
	        'ifDefined',
	        'plus',
	        fnString))(
	          this.$filter,
	          getStringValue,
	          ifDefined,
	          plusFn);
	    this.state = this.stage = undefined;
	    return fn;
	  },
	
	  USE: 'use',
	
	  STRICT: 'strict',
	
	  watchFns: function() {
	    var result = [];
	    var inputs = this.state.inputs;
	    var self = this;
	    forEach(inputs, function(input) {
	      result.push('var ' + input.name + '=' + self.generateFunction(input.name, 's'));
	      if (input.isPure) {
	        result.push(input.name, '.isPure=' + JSON.stringify(input.isPure) + ';');
	      }
	    });
	    if (inputs.length) {
	      result.push('fn.inputs=[' + inputs.map(function(i) { return i.name; }).join(',') + '];');
	    }
	    return result.join('');
	  },
	
	  generateFunction: function(name, params) {
	    return 'function(' + params + '){' +
	        this.varsPrefix(name) +
	        this.body(name) +
	        '};';
	  },
	
	  filterPrefix: function() {
	    var parts = [];
	    var self = this;
	    forEach(this.state.filters, function(id, filter) {
	      parts.push(id + '=$filter(' + self.escape(filter) + ')');
	    });
	    if (parts.length) return 'var ' + parts.join(',') + ';';
	    return '';
	  },
	
	  varsPrefix: function(section) {
	    return this.state[section].vars.length ? 'var ' + this.state[section].vars.join(',') + ';' : '';
	  },
	
	  body: function(section) {
	    return this.state[section].body.join('');
	  },
	
	  recurse: function(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck) {
	    var left, right, self = this, args, expression, computed;
	    recursionFn = recursionFn || noop;
	    if (!skipWatchIdCheck && isDefined(ast.watchId)) {
	      intoId = intoId || this.nextId();
	      this.if_('i',
	        this.lazyAssign(intoId, this.computedMember('i', ast.watchId)),
	        this.lazyRecurse(ast, intoId, nameId, recursionFn, create, true)
	      );
	      return;
	    }
	    switch (ast.type) {
	    case AST.Program:
	      forEach(ast.body, function(expression, pos) {
	        self.recurse(expression.expression, undefined, undefined, function(expr) { right = expr; });
	        if (pos !== ast.body.length - 1) {
	          self.current().body.push(right, ';');
	        } else {
	          self.return_(right);
	        }
	      });
	      break;
	    case AST.Literal:
	      expression = this.escape(ast.value);
	      this.assign(intoId, expression);
	      recursionFn(intoId || expression);
	      break;
	    case AST.UnaryExpression:
	      this.recurse(ast.argument, undefined, undefined, function(expr) { right = expr; });
	      expression = ast.operator + '(' + this.ifDefined(right, 0) + ')';
	      this.assign(intoId, expression);
	      recursionFn(expression);
	      break;
	    case AST.BinaryExpression:
	      this.recurse(ast.left, undefined, undefined, function(expr) { left = expr; });
	      this.recurse(ast.right, undefined, undefined, function(expr) { right = expr; });
	      if (ast.operator === '+') {
	        expression = this.plus(left, right);
	      } else if (ast.operator === '-') {
	        expression = this.ifDefined(left, 0) + ast.operator + this.ifDefined(right, 0);
	      } else {
	        expression = '(' + left + ')' + ast.operator + '(' + right + ')';
	      }
	      this.assign(intoId, expression);
	      recursionFn(expression);
	      break;
	    case AST.LogicalExpression:
	      intoId = intoId || this.nextId();
	      self.recurse(ast.left, intoId);
	      self.if_(ast.operator === '&&' ? intoId : self.not(intoId), self.lazyRecurse(ast.right, intoId));
	      recursionFn(intoId);
	      break;
	    case AST.ConditionalExpression:
	      intoId = intoId || this.nextId();
	      self.recurse(ast.test, intoId);
	      self.if_(intoId, self.lazyRecurse(ast.alternate, intoId), self.lazyRecurse(ast.consequent, intoId));
	      recursionFn(intoId);
	      break;
	    case AST.Identifier:
	      intoId = intoId || this.nextId();
	      if (nameId) {
	        nameId.context = self.stage === 'inputs' ? 's' : this.assign(this.nextId(), this.getHasOwnProperty('l', ast.name) + '?l:s');
	        nameId.computed = false;
	        nameId.name = ast.name;
	      }
	      self.if_(self.stage === 'inputs' || self.not(self.getHasOwnProperty('l', ast.name)),
	        function() {
	          self.if_(self.stage === 'inputs' || 's', function() {
	            if (create && create !== 1) {
	              self.if_(
	                self.isNull(self.nonComputedMember('s', ast.name)),
	                self.lazyAssign(self.nonComputedMember('s', ast.name), '{}'));
	            }
	            self.assign(intoId, self.nonComputedMember('s', ast.name));
	          });
	        }, intoId && self.lazyAssign(intoId, self.nonComputedMember('l', ast.name))
	        );
	      recursionFn(intoId);
	      break;
	    case AST.MemberExpression:
	      left = nameId && (nameId.context = this.nextId()) || this.nextId();
	      intoId = intoId || this.nextId();
	      self.recurse(ast.object, left, undefined, function() {
	        self.if_(self.notNull(left), function() {
	          if (ast.computed) {
	            right = self.nextId();
	            self.recurse(ast.property, right);
	            self.getStringValue(right);
	            if (create && create !== 1) {
	              self.if_(self.not(self.computedMember(left, right)), self.lazyAssign(self.computedMember(left, right), '{}'));
	            }
	            expression = self.computedMember(left, right);
	            self.assign(intoId, expression);
	            if (nameId) {
	              nameId.computed = true;
	              nameId.name = right;
	            }
	          } else {
	            if (create && create !== 1) {
	              self.if_(self.isNull(self.nonComputedMember(left, ast.property.name)), self.lazyAssign(self.nonComputedMember(left, ast.property.name), '{}'));
	            }
	            expression = self.nonComputedMember(left, ast.property.name);
	            self.assign(intoId, expression);
	            if (nameId) {
	              nameId.computed = false;
	              nameId.name = ast.property.name;
	            }
	          }
	        }, function() {
	          self.assign(intoId, 'undefined');
	        });
	        recursionFn(intoId);
	      }, !!create);
	      break;
	    case AST.CallExpression:
	      intoId = intoId || this.nextId();
	      if (ast.filter) {
	        right = self.filter(ast.callee.name);
	        args = [];
	        forEach(ast.arguments, function(expr) {
	          var argument = self.nextId();
	          self.recurse(expr, argument);
	          args.push(argument);
	        });
	        expression = right + '(' + args.join(',') + ')';
	        self.assign(intoId, expression);
	        recursionFn(intoId);
	      } else {
	        right = self.nextId();
	        left = {};
	        args = [];
	        self.recurse(ast.callee, right, left, function() {
	          self.if_(self.notNull(right), function() {
	            forEach(ast.arguments, function(expr) {
	              self.recurse(expr, ast.constant ? undefined : self.nextId(), undefined, function(argument) {
	                args.push(argument);
	              });
	            });
	            if (left.name) {
	              expression = self.member(left.context, left.name, left.computed) + '(' + args.join(',') + ')';
	            } else {
	              expression = right + '(' + args.join(',') + ')';
	            }
	            self.assign(intoId, expression);
	          }, function() {
	            self.assign(intoId, 'undefined');
	          });
	          recursionFn(intoId);
	        });
	      }
	      break;
	    case AST.AssignmentExpression:
	      right = this.nextId();
	      left = {};
	      this.recurse(ast.left, undefined, left, function() {
	        self.if_(self.notNull(left.context), function() {
	          self.recurse(ast.right, right);
	          expression = self.member(left.context, left.name, left.computed) + ast.operator + right;
	          self.assign(intoId, expression);
	          recursionFn(intoId || expression);
	        });
	      }, 1);
	      break;
	    case AST.ArrayExpression:
	      args = [];
	      forEach(ast.elements, function(expr) {
	        self.recurse(expr, ast.constant ? undefined : self.nextId(), undefined, function(argument) {
	          args.push(argument);
	        });
	      });
	      expression = '[' + args.join(',') + ']';
	      this.assign(intoId, expression);
	      recursionFn(intoId || expression);
	      break;
	    case AST.ObjectExpression:
	      args = [];
	      computed = false;
	      forEach(ast.properties, function(property) {
	        if (property.computed) {
	          computed = true;
	        }
	      });
	      if (computed) {
	        intoId = intoId || this.nextId();
	        this.assign(intoId, '{}');
	        forEach(ast.properties, function(property) {
	          if (property.computed) {
	            left = self.nextId();
	            self.recurse(property.key, left);
	          } else {
	            left = property.key.type === AST.Identifier ?
	                       property.key.name :
	                       ('' + property.key.value);
	          }
	          right = self.nextId();
	          self.recurse(property.value, right);
	          self.assign(self.member(intoId, left, property.computed), right);
	        });
	      } else {
	        forEach(ast.properties, function(property) {
	          self.recurse(property.value, ast.constant ? undefined : self.nextId(), undefined, function(expr) {
	            args.push(self.escape(
	                property.key.type === AST.Identifier ? property.key.name :
	                  ('' + property.key.value)) +
	                ':' + expr);
	          });
	        });
	        expression = '{' + args.join(',') + '}';
	        this.assign(intoId, expression);
	      }
	      recursionFn(intoId || expression);
	      break;
	    case AST.ThisExpression:
	      this.assign(intoId, 's');
	      recursionFn(intoId || 's');
	      break;
	    case AST.LocalsExpression:
	      this.assign(intoId, 'l');
	      recursionFn(intoId || 'l');
	      break;
	    case AST.NGValueParameter:
	      this.assign(intoId, 'v');
	      recursionFn(intoId || 'v');
	      break;
	    }
	  },
	
	  getHasOwnProperty: function(element, property) {
	    var key = element + '.' + property;
	    var own = this.current().own;
	    if (!own.hasOwnProperty(key)) {
	      own[key] = this.nextId(false, element + '&&(' + this.escape(property) + ' in ' + element + ')');
	    }
	    return own[key];
	  },
	
	  assign: function(id, value) {
	    if (!id) return;
	    this.current().body.push(id, '=', value, ';');
	    return id;
	  },
	
	  filter: function(filterName) {
	    if (!this.state.filters.hasOwnProperty(filterName)) {
	      this.state.filters[filterName] = this.nextId(true);
	    }
	    return this.state.filters[filterName];
	  },
	
	  ifDefined: function(id, defaultValue) {
	    return 'ifDefined(' + id + ',' + this.escape(defaultValue) + ')';
	  },
	
	  plus: function(left, right) {
	    return 'plus(' + left + ',' + right + ')';
	  },
	
	  return_: function(id) {
	    this.current().body.push('return ', id, ';');
	  },
	
	  if_: function(test, alternate, consequent) {
	    if (test === true) {
	      alternate();
	    } else {
	      var body = this.current().body;
	      body.push('if(', test, '){');
	      alternate();
	      body.push('}');
	      if (consequent) {
	        body.push('else{');
	        consequent();
	        body.push('}');
	      }
	    }
	  },
	
	  not: function(expression) {
	    return '!(' + expression + ')';
	  },
	
	  isNull: function(expression) {
	    return expression + '==null';
	  },
	
	  notNull: function(expression) {
	    return expression + '!=null';
	  },
	
	  nonComputedMember: function(left, right) {
	    var SAFE_IDENTIFIER = /^[$_a-zA-Z][$_a-zA-Z0-9]*$/;
	    var UNSAFE_CHARACTERS = /[^$_a-zA-Z0-9]/g;
	    if (SAFE_IDENTIFIER.test(right)) {
	      return left + '.' + right;
	    } else {
	      return left  + '["' + right.replace(UNSAFE_CHARACTERS, this.stringEscapeFn) + '"]';
	    }
	  },
	
	  computedMember: function(left, right) {
	    return left + '[' + right + ']';
	  },
	
	  member: function(left, right, computed) {
	    if (computed) return this.computedMember(left, right);
	    return this.nonComputedMember(left, right);
	  },
	
	  getStringValue: function(item) {
	    this.assign(item, 'getStringValue(' + item + ')');
	  },
	
	  lazyRecurse: function(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck) {
	    var self = this;
	    return function() {
	      self.recurse(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck);
	    };
	  },
	
	  lazyAssign: function(id, value) {
	    var self = this;
	    return function() {
	      self.assign(id, value);
	    };
	  },
	
	  stringEscapeRegex: /[^ a-zA-Z0-9]/g,
	
	  stringEscapeFn: function(c) {
	    return '\\u' + ('0000' + c.charCodeAt(0).toString(16)).slice(-4);
	  },
	
	  escape: function(value) {
	    if (isString(value)) return '\'' + value.replace(this.stringEscapeRegex, this.stringEscapeFn) + '\'';
	    if (isNumber(value)) return value.toString();
	    if (value === true) return 'true';
	    if (value === false) return 'false';
	    if (value === null) return 'null';
	    if (typeof value === 'undefined') return 'undefined';
	
	    throw $parseMinErr('esc', 'IMPOSSIBLE');
	  },
	
	  nextId: function(skip, init) {
	    var id = 'v' + (this.state.nextId++);
	    if (!skip) {
	      this.current().vars.push(id + (init ? '=' + init : ''));
	    }
	    return id;
	  },
	
	  current: function() {
	    return this.state[this.state.computing];
	  }
	};
	
	
	function ASTInterpreter($filter) {
	  this.$filter = $filter;
	}
	
	ASTInterpreter.prototype = {
	  compile: function(ast) {
	    var self = this;
	    findConstantAndWatchExpressions(ast, self.$filter);
	    var assignable;
	    var assign;
	    if ((assignable = assignableAST(ast))) {
	      assign = this.recurse(assignable);
	    }
	    var toWatch = getInputs(ast.body);
	    var inputs;
	    if (toWatch) {
	      inputs = [];
	      forEach(toWatch, function(watch, key) {
	        var input = self.recurse(watch);
	        input.isPure = watch.isPure;
	        watch.input = input;
	        inputs.push(input);
	        watch.watchId = key;
	      });
	    }
	    var expressions = [];
	    forEach(ast.body, function(expression) {
	      expressions.push(self.recurse(expression.expression));
	    });
	    var fn = ast.body.length === 0 ? noop :
	             ast.body.length === 1 ? expressions[0] :
	             function(scope, locals) {
	               var lastValue;
	               forEach(expressions, function(exp) {
	                 lastValue = exp(scope, locals);
	               });
	               return lastValue;
	             };
	    if (assign) {
	      fn.assign = function(scope, value, locals) {
	        return assign(scope, locals, value);
	      };
	    }
	    if (inputs) {
	      fn.inputs = inputs;
	    }
	    return fn;
	  },
	
	  recurse: function(ast, context, create) {
	    var left, right, self = this, args;
	    if (ast.input) {
	      return this.inputs(ast.input, ast.watchId);
	    }
	    switch (ast.type) {
	    case AST.Literal:
	      return this.value(ast.value, context);
	    case AST.UnaryExpression:
	      right = this.recurse(ast.argument);
	      return this['unary' + ast.operator](right, context);
	    case AST.BinaryExpression:
	      left = this.recurse(ast.left);
	      right = this.recurse(ast.right);
	      return this['binary' + ast.operator](left, right, context);
	    case AST.LogicalExpression:
	      left = this.recurse(ast.left);
	      right = this.recurse(ast.right);
	      return this['binary' + ast.operator](left, right, context);
	    case AST.ConditionalExpression:
	      return this['ternary?:'](
	        this.recurse(ast.test),
	        this.recurse(ast.alternate),
	        this.recurse(ast.consequent),
	        context
	      );
	    case AST.Identifier:
	      return self.identifier(ast.name, context, create);
	    case AST.MemberExpression:
	      left = this.recurse(ast.object, false, !!create);
	      if (!ast.computed) {
	        right = ast.property.name;
	      }
	      if (ast.computed) right = this.recurse(ast.property);
	      return ast.computed ?
	        this.computedMember(left, right, context, create) :
	        this.nonComputedMember(left, right, context, create);
	    case AST.CallExpression:
	      args = [];
	      forEach(ast.arguments, function(expr) {
	        args.push(self.recurse(expr));
	      });
	      if (ast.filter) right = this.$filter(ast.callee.name);
	      if (!ast.filter) right = this.recurse(ast.callee, true);
	      return ast.filter ?
	        function(scope, locals, assign, inputs) {
	          var values = [];
	          for (var i = 0; i < args.length; ++i) {
	            values.push(args[i](scope, locals, assign, inputs));
	          }
	          var value = right.apply(undefined, values, inputs);
	          return context ? {context: undefined, name: undefined, value: value} : value;
	        } :
	        function(scope, locals, assign, inputs) {
	          var rhs = right(scope, locals, assign, inputs);
	          var value;
	          if (rhs.value != null) {
	            var values = [];
	            for (var i = 0; i < args.length; ++i) {
	              values.push(args[i](scope, locals, assign, inputs));
	            }
	            value = rhs.value.apply(rhs.context, values);
	          }
	          return context ? {value: value} : value;
	        };
	    case AST.AssignmentExpression:
	      left = this.recurse(ast.left, true, 1);
	      right = this.recurse(ast.right);
	      return function(scope, locals, assign, inputs) {
	        var lhs = left(scope, locals, assign, inputs);
	        var rhs = right(scope, locals, assign, inputs);
	        lhs.context[lhs.name] = rhs;
	        return context ? {value: rhs} : rhs;
	      };
	    case AST.ArrayExpression:
	      args = [];
	      forEach(ast.elements, function(expr) {
	        args.push(self.recurse(expr));
	      });
	      return function(scope, locals, assign, inputs) {
	        var value = [];
	        for (var i = 0; i < args.length; ++i) {
	          value.push(args[i](scope, locals, assign, inputs));
	        }
	        return context ? {value: value} : value;
	      };
	    case AST.ObjectExpression:
	      args = [];
	      forEach(ast.properties, function(property) {
	        if (property.computed) {
	          args.push({key: self.recurse(property.key),
	                     computed: true,
	                     value: self.recurse(property.value)
	          });
	        } else {
	          args.push({key: property.key.type === AST.Identifier ?
	                          property.key.name :
	                          ('' + property.key.value),
	                     computed: false,
	                     value: self.recurse(property.value)
	          });
	        }
	      });
	      return function(scope, locals, assign, inputs) {
	        var value = {};
	        for (var i = 0; i < args.length; ++i) {
	          if (args[i].computed) {
	            value[args[i].key(scope, locals, assign, inputs)] = args[i].value(scope, locals, assign, inputs);
	          } else {
	            value[args[i].key] = args[i].value(scope, locals, assign, inputs);
	          }
	        }
	        return context ? {value: value} : value;
	      };
	    case AST.ThisExpression:
	      return function(scope) {
	        return context ? {value: scope} : scope;
	      };
	    case AST.LocalsExpression:
	      return function(scope, locals) {
	        return context ? {value: locals} : locals;
	      };
	    case AST.NGValueParameter:
	      return function(scope, locals, assign) {
	        return context ? {value: assign} : assign;
	      };
	    }
	  },
	
	  'unary+': function(argument, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = argument(scope, locals, assign, inputs);
	      if (isDefined(arg)) {
	        arg = +arg;
	      } else {
	        arg = 0;
	      }
	      return context ? {value: arg} : arg;
	    };
	  },
	  'unary-': function(argument, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = argument(scope, locals, assign, inputs);
	      if (isDefined(arg)) {
	        arg = -arg;
	      } else {
	        arg = -0;
	      }
	      return context ? {value: arg} : arg;
	    };
	  },
	  'unary!': function(argument, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = !argument(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary+': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      var rhs = right(scope, locals, assign, inputs);
	      var arg = plusFn(lhs, rhs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary-': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      var rhs = right(scope, locals, assign, inputs);
	      var arg = (isDefined(lhs) ? lhs : 0) - (isDefined(rhs) ? rhs : 0);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary*': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) * right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary/': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) / right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary%': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) % right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary===': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) === right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary!==': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) !== right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary==': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      // eslint-disable-next-line eqeqeq
	      var arg = left(scope, locals, assign, inputs) == right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary!=': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      // eslint-disable-next-line eqeqeq
	      var arg = left(scope, locals, assign, inputs) != right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary<': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) < right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary>': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) > right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary<=': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) <= right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary>=': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) >= right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary&&': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) && right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary||': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) || right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'ternary?:': function(test, alternate, consequent, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = test(scope, locals, assign, inputs) ? alternate(scope, locals, assign, inputs) : consequent(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  value: function(value, context) {
	    return function() { return context ? {context: undefined, name: undefined, value: value} : value; };
	  },
	  identifier: function(name, context, create) {
	    return function(scope, locals, assign, inputs) {
	      var base = locals && (name in locals) ? locals : scope;
	      if (create && create !== 1 && base && base[name] == null) {
	        base[name] = {};
	      }
	      var value = base ? base[name] : undefined;
	      if (context) {
	        return {context: base, name: name, value: value};
	      } else {
	        return value;
	      }
	    };
	  },
	  computedMember: function(left, right, context, create) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      var rhs;
	      var value;
	      if (lhs != null) {
	        rhs = right(scope, locals, assign, inputs);
	        rhs = getStringValue(rhs);
	        if (create && create !== 1) {
	          if (lhs && !(lhs[rhs])) {
	            lhs[rhs] = {};
	          }
	        }
	        value = lhs[rhs];
	      }
	      if (context) {
	        return {context: lhs, name: rhs, value: value};
	      } else {
	        return value;
	      }
	    };
	  },
	  nonComputedMember: function(left, right, context, create) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      if (create && create !== 1) {
	        if (lhs && lhs[right] == null) {
	          lhs[right] = {};
	        }
	      }
	      var value = lhs != null ? lhs[right] : undefined;
	      if (context) {
	        return {context: lhs, name: right, value: value};
	      } else {
	        return value;
	      }
	    };
	  },
	  inputs: function(input, watchId) {
	    return function(scope, value, locals, inputs) {
	      if (inputs) return inputs[watchId];
	      return input(scope, value, locals);
	    };
	  }
	};
	
	/**
	 * @constructor
	 */
	function Parser(lexer, $filter, options) {
	  this.ast = new AST(lexer, options);
	  this.astCompiler = options.csp ? new ASTInterpreter($filter) :
	                                   new ASTCompiler($filter);
	}
	
	Parser.prototype = {
	  constructor: Parser,
	
	  parse: function(text) {
	    var ast = this.getAst(text);
	    var fn = this.astCompiler.compile(ast.ast);
	    fn.literal = isLiteral(ast.ast);
	    fn.constant = isConstant(ast.ast);
	    fn.oneTime = ast.oneTime;
	    return fn;
	  },
	
	  getAst: function(exp) {
	    var oneTime = false;
	    exp = exp.trim();
	
	    if (exp.charAt(0) === ':' && exp.charAt(1) === ':') {
	      oneTime = true;
	      exp = exp.substring(2);
	    }
	    return {
	      ast: this.ast.ast(exp),
	      oneTime: oneTime
	    };
	  }
	};
	
	function getValueOf(value) {
	  return isFunction(value.valueOf) ? value.valueOf() : objectValueOf.call(value);
	}
	
	///////////////////////////////////
	
	/**
	 * @ngdoc service
	 * @name $parse
	 * @kind function
	 *
	 * @description
	 *
	 * Converts AngularJS {@link guide/expression expression} into a function.
	 *
	 * ```js
	 *   var getter = $parse('user.name');
	 *   var setter = getter.assign;
	 *   var context = {user:{name:'AngularJS'}};
	 *   var locals = {user:{name:'local'}};
	 *
	 *   expect(getter(context)).toEqual('AngularJS');
	 *   setter(context, 'newValue');
	 *   expect(context.user.name).toEqual('newValue');
	 *   expect(getter(context, locals)).toEqual('local');
	 * ```
	 *
	 *
	 * @param {string} expression String expression to compile.
	 * @returns {function(context, locals)} a function which represents the compiled expression:
	 *
	 *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	 *      are evaluated against (typically a scope object).
	 *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	 *      `context`.
	 *
	 *    The returned function also has the following properties:
	 *      * `literal` – `{boolean}` – whether the expression's top-level node is a JavaScript
	 *        literal.
	 *      * `constant` – `{boolean}` – whether the expression is made entirely of JavaScript
	 *        constant literals.
	 *      * `assign` – `{?function(context, value)}` – if the expression is assignable, this will be
	 *        set to a function to change its value on the given context.
	 *
	 */
	
	
	/**
	 * @ngdoc provider
	 * @name $parseProvider
	 * @this
	 *
	 * @description
	 * `$parseProvider` can be used for configuring the default behavior of the {@link ng.$parse $parse}
	 *  service.
	 */
	function $ParseProvider() {
	  var cache = createMap();
	  var literals = {
	    'true': true,
	    'false': false,
	    'null': null,
	    'undefined': undefined
	  };
	  var identStart, identContinue;
	
	  /**
	   * @ngdoc method
	   * @name $parseProvider#addLiteral
	   * @description
	   *
	   * Configure $parse service to add literal values that will be present as literal at expressions.
	   *
	   * @param {string} literalName Token for the literal value. The literal name value must be a valid literal name.
	   * @param {*} literalValue Value for this literal. All literal values must be primitives or `undefined`.
	   *
	   **/
	  this.addLiteral = function(literalName, literalValue) {
	    literals[literalName] = literalValue;
	  };
	
	 /**
	  * @ngdoc method
	  * @name $parseProvider#setIdentifierFns
	  *
	  * @description
	  *
	  * Allows defining the set of characters that are allowed in AngularJS expressions. The function
	  * `identifierStart` will get called to know if a given character is a valid character to be the
	  * first character for an identifier. The function `identifierContinue` will get called to know if
	  * a given character is a valid character to be a follow-up identifier character. The functions
	  * `identifierStart` and `identifierContinue` will receive as arguments the single character to be
	  * identifier and the character code point. These arguments will be `string` and `numeric`. Keep in
	  * mind that the `string` parameter can be two characters long depending on the character
	  * representation. It is expected for the function to return `true` or `false`, whether that
	  * character is allowed or not.
	  *
	  * Since this function will be called extensively, keep the implementation of these functions fast,
	  * as the performance of these functions have a direct impact on the expressions parsing speed.
	  *
	  * @param {function=} identifierStart The function that will decide whether the given character is
	  *   a valid identifier start character.
	  * @param {function=} identifierContinue The function that will decide whether the given character is
	  *   a valid identifier continue character.
	  */
	  this.setIdentifierFns = function(identifierStart, identifierContinue) {
	    identStart = identifierStart;
	    identContinue = identifierContinue;
	    return this;
	  };
	
	  this.$get = ['$filter', function($filter) {
	    var noUnsafeEval = csp().noUnsafeEval;
	    var $parseOptions = {
	          csp: noUnsafeEval,
	          literals: copy(literals),
	          isIdentifierStart: isFunction(identStart) && identStart,
	          isIdentifierContinue: isFunction(identContinue) && identContinue
	        };
	    $parse.$$getAst = $$getAst;
	    return $parse;
	
	    function $parse(exp, interceptorFn) {
	      var parsedExpression, cacheKey;
	
	      switch (typeof exp) {
	        case 'string':
	          exp = exp.trim();
	          cacheKey = exp;
	
	          parsedExpression = cache[cacheKey];
	
	          if (!parsedExpression) {
	            var lexer = new Lexer($parseOptions);
	            var parser = new Parser(lexer, $filter, $parseOptions);
	            parsedExpression = parser.parse(exp);
	
	            cache[cacheKey] = addWatchDelegate(parsedExpression);
	          }
	          return addInterceptor(parsedExpression, interceptorFn);
	
	        case 'function':
	          return addInterceptor(exp, interceptorFn);
	
	        default:
	          return addInterceptor(noop, interceptorFn);
	      }
	    }
	
	    function $$getAst(exp) {
	      var lexer = new Lexer($parseOptions);
	      var parser = new Parser(lexer, $filter, $parseOptions);
	      return parser.getAst(exp).ast;
	    }
	
	    function expressionInputDirtyCheck(newValue, oldValueOfValue, compareObjectIdentity) {
	
	      if (newValue == null || oldValueOfValue == null) { // null/undefined
	        return newValue === oldValueOfValue;
	      }
	
	      if (typeof newValue === 'object') {
	
	        // attempt to convert the value to a primitive type
	        // TODO(docs): add a note to docs that by implementing valueOf even objects and arrays can
	        //             be cheaply dirty-checked
	        newValue = getValueOf(newValue);
	
	        if (typeof newValue === 'object' && !compareObjectIdentity) {
	          // objects/arrays are not supported - deep-watching them would be too expensive
	          return false;
	        }
	
	        // fall-through to the primitive equality check
	      }
	
	      //Primitive or NaN
	      // eslint-disable-next-line no-self-compare
	      return newValue === oldValueOfValue || (newValue !== newValue && oldValueOfValue !== oldValueOfValue);
	    }
	
	    function inputsWatchDelegate(scope, listener, objectEquality, parsedExpression, prettyPrintExpression) {
	      var inputExpressions = parsedExpression.inputs;
	      var lastResult;
	
	      if (inputExpressions.length === 1) {
	        var oldInputValueOf = expressionInputDirtyCheck; // init to something unique so that equals check fails
	        inputExpressions = inputExpressions[0];
	        return scope.$watch(function expressionInputWatch(scope) {
	          var newInputValue = inputExpressions(scope);
	          if (!expressionInputDirtyCheck(newInputValue, oldInputValueOf, inputExpressions.isPure)) {
	            lastResult = parsedExpression(scope, undefined, undefined, [newInputValue]);
	            oldInputValueOf = newInputValue && getValueOf(newInputValue);
	          }
	          return lastResult;
	        }, listener, objectEquality, prettyPrintExpression);
	      }
	
	      var oldInputValueOfValues = [];
	      var oldInputValues = [];
	      for (var i = 0, ii = inputExpressions.length; i < ii; i++) {
	        oldInputValueOfValues[i] = expressionInputDirtyCheck; // init to something unique so that equals check fails
	        oldInputValues[i] = null;
	      }
	
	      return scope.$watch(function expressionInputsWatch(scope) {
	        var changed = false;
	
	        for (var i = 0, ii = inputExpressions.length; i < ii; i++) {
	          var newInputValue = inputExpressions[i](scope);
	          if (changed || (changed = !expressionInputDirtyCheck(newInputValue, oldInputValueOfValues[i], inputExpressions[i].isPure))) {
	            oldInputValues[i] = newInputValue;
	            oldInputValueOfValues[i] = newInputValue && getValueOf(newInputValue);
	          }
	        }
	
	        if (changed) {
	          lastResult = parsedExpression(scope, undefined, undefined, oldInputValues);
	        }
	
	        return lastResult;
	      }, listener, objectEquality, prettyPrintExpression);
	    }
	
	    function oneTimeWatchDelegate(scope, listener, objectEquality, parsedExpression, prettyPrintExpression) {
	      var isDone = parsedExpression.literal ? isAllDefined : isDefined;
	      var unwatch, lastValue;
	
	      var exp = parsedExpression.$$intercepted || parsedExpression;
	      var post = parsedExpression.$$interceptor || identity;
	
	      var useInputs = parsedExpression.inputs && !exp.inputs;
	
	      // Propagate the literal/inputs/constant attributes
	      // ... but not oneTime since we are handling it
	      oneTimeWatch.literal = parsedExpression.literal;
	      oneTimeWatch.constant = parsedExpression.constant;
	      oneTimeWatch.inputs = parsedExpression.inputs;
	
	      // Allow other delegates to run on this wrapped expression
	      addWatchDelegate(oneTimeWatch);
	
	      unwatch = scope.$watch(oneTimeWatch, listener, objectEquality, prettyPrintExpression);
	
	      return unwatch;
	
	      function unwatchIfDone() {
	        if (isDone(lastValue)) {
	          unwatch();
	        }
	      }
	
	      function oneTimeWatch(scope, locals, assign, inputs) {
	        lastValue = useInputs && inputs ? inputs[0] : exp(scope, locals, assign, inputs);
	        if (isDone(lastValue)) {
	          scope.$$postDigest(unwatchIfDone);
	        }
	        return post(lastValue);
	      }
	    }
	
	    function isAllDefined(value) {
	      var allDefined = true;
	      forEach(value, function(val) {
	        if (!isDefined(val)) allDefined = false;
	      });
	      return allDefined;
	    }
	
	    function constantWatchDelegate(scope, listener, objectEquality, parsedExpression) {
	      var unwatch = scope.$watch(function constantWatch(scope) {
	        unwatch();
	        return parsedExpression(scope);
	      }, listener, objectEquality);
	      return unwatch;
	    }
	
	    function addWatchDelegate(parsedExpression) {
	      if (parsedExpression.constant) {
	        parsedExpression.$$watchDelegate = constantWatchDelegate;
	      } else if (parsedExpression.oneTime) {
	        parsedExpression.$$watchDelegate = oneTimeWatchDelegate;
	      } else if (parsedExpression.inputs) {
	        parsedExpression.$$watchDelegate = inputsWatchDelegate;
	      }
	
	      return parsedExpression;
	    }
	
	    function chainInterceptors(first, second) {
	      function chainedInterceptor(value) {
	        return second(first(value));
	      }
	      chainedInterceptor.$stateful = first.$stateful || second.$stateful;
	      chainedInterceptor.$$pure = first.$$pure && second.$$pure;
	
	      return chainedInterceptor;
	    }
	
	    function addInterceptor(parsedExpression, interceptorFn) {
	      if (!interceptorFn) return parsedExpression;
	
	      // Extract any existing interceptors out of the parsedExpression
	      // to ensure the original parsedExpression is always the $$intercepted
	      if (parsedExpression.$$interceptor) {
	        interceptorFn = chainInterceptors(parsedExpression.$$interceptor, interceptorFn);
	        parsedExpression = parsedExpression.$$intercepted;
	      }
	
	      var useInputs = false;
	
	      var fn = function interceptedExpression(scope, locals, assign, inputs) {
	        var value = useInputs && inputs ? inputs[0] : parsedExpression(scope, locals, assign, inputs);
	        return interceptorFn(value);
	      };
	
	      // Maintain references to the interceptor/intercepted
	      fn.$$intercepted = parsedExpression;
	      fn.$$interceptor = interceptorFn;
	
	      // Propagate the literal/oneTime/constant attributes
	      fn.literal = parsedExpression.literal;
	      fn.oneTime = parsedExpression.oneTime;
	      fn.constant = parsedExpression.constant;
	
	      // Treat the interceptor like filters.
	      // If it is not $stateful then only watch its inputs.
	      // If the expression itself has no inputs then use the full expression as an input.
	      if (!interceptorFn.$stateful) {
	        useInputs = !parsedExpression.inputs;
	        fn.inputs = parsedExpression.inputs ? parsedExpression.inputs : [parsedExpression];
	
	        if (!interceptorFn.$$pure) {
	          fn.inputs = fn.inputs.map(function(e) {
	              // Remove the isPure flag of inputs when it is not absolute because they are now wrapped in a
	              // non-pure interceptor function.
	              if (e.isPure === PURITY_RELATIVE) {
	                return function depurifier(s) { return e(s); };
	              }
	              return e;
	            });
	        }
	      }
	
	      return addWatchDelegate(fn);
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $q
	 * @requires $rootScope
	 *
	 * @description
	 * A service that helps you run functions asynchronously, and use their return values (or exceptions)
	 * when they are done processing.
	 *
	 * This is a [Promises/A+](https://promisesaplus.com/)-compliant implementation of promises/deferred
	 * objects inspired by [Kris Kowal's Q](https://github.com/kriskowal/q).
	 *
	 * $q can be used in two fashions --- one which is more similar to Kris Kowal's Q or jQuery's Deferred
	 * implementations, and the other which resembles ES6 (ES2015) promises to some degree.
	 *
	 * ## $q constructor
	 *
	 * The streamlined ES6 style promise is essentially just using $q as a constructor which takes a `resolver`
	 * function as the first argument. This is similar to the native Promise implementation from ES6,
	 * see [MDN](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise).
	 *
	 * While the constructor-style use is supported, not all of the supporting methods from ES6 promises are
	 * available yet.
	 *
	 * It can be used like so:
	 *
	 * ```js
	 *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
	 *   // are available in the current lexical scope (they could have been injected or passed in).
	 *
	 *   function asyncGreet(name) {
	 *     // perform some asynchronous operation, resolve or reject the promise when appropriate.
	 *     return $q(function(resolve, reject) {
	 *       setTimeout(function() {
	 *         if (okToGreet(name)) {
	 *           resolve('Hello, ' + name + '!');
	 *         } else {
	 *           reject('Greeting ' + name + ' is not allowed.');
	 *         }
	 *       }, 1000);
	 *     });
	 *   }
	 *
	 *   var promise = asyncGreet('Robin Hood');
	 *   promise.then(function(greeting) {
	 *     alert('Success: ' + greeting);
	 *   }, function(reason) {
	 *     alert('Failed: ' + reason);
	 *   });
	 * ```
	 *
	 * Note: progress/notify callbacks are not currently supported via the ES6-style interface.
	 *
	 * Note: unlike ES6 behavior, an exception thrown in the constructor function will NOT implicitly reject the promise.
	 *
	 * However, the more traditional CommonJS-style usage is still available, and documented below.
	 *
	 * [The CommonJS Promise proposal](http://wiki.commonjs.org/wiki/Promises) describes a promise as an
	 * interface for interacting with an object that represents the result of an action that is
	 * performed asynchronously, and may or may not be finished at any given point in time.
	 *
	 * From the perspective of dealing with error handling, deferred and promise APIs are to
	 * asynchronous programming what `try`, `catch` and `throw` keywords are to synchronous programming.
	 *
	 * ```js
	 *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
	 *   // are available in the current lexical scope (they could have been injected or passed in).
	 *
	 *   function asyncGreet(name) {
	 *     var deferred = $q.defer();
	 *
	 *     setTimeout(function() {
	 *       deferred.notify('About to greet ' + name + '.');
	 *
	 *       if (okToGreet(name)) {
	 *         deferred.resolve('Hello, ' + name + '!');
	 *       } else {
	 *         deferred.reject('Greeting ' + name + ' is not allowed.');
	 *       }
	 *     }, 1000);
	 *
	 *     return deferred.promise;
	 *   }
	 *
	 *   var promise = asyncGreet('Robin Hood');
	 *   promise.then(function(greeting) {
	 *     alert('Success: ' + greeting);
	 *   }, function(reason) {
	 *     alert('Failed: ' + reason);
	 *   }, function(update) {
	 *     alert('Got notification: ' + update);
	 *   });
	 * ```
	 *
	 * At first it might not be obvious why this extra complexity is worth the trouble. The payoff
	 * comes in the way of guarantees that promise and deferred APIs make, see
	 * https://github.com/kriskowal/uncommonjs/blob/master/promises/specification.md.
	 *
	 * Additionally the promise api allows for composition that is very hard to do with the
	 * traditional callback ([CPS](http://en.wikipedia.org/wiki/Continuation-passing_style)) approach.
	 * For more on this please see the [Q documentation](https://github.com/kriskowal/q) especially the
	 * section on serial or parallel joining of promises.
	 *
	 * ## The Deferred API
	 *
	 * A new instance of deferred is constructed by calling `$q.defer()`.
	 *
	 * The purpose of the deferred object is to expose the associated Promise instance as well as APIs
	 * that can be used for signaling the successful or unsuccessful completion, as well as the status
	 * of the task.
	 *
	 * **Methods**
	 *
	 * - `resolve(value)` – resolves the derived promise with the `value`. If the value is a rejection
	 *   constructed via `$q.reject`, the promise will be rejected instead.
	 * - `reject(reason)` – rejects the derived promise with the `reason`. This is equivalent to
	 *   resolving it with a rejection constructed via `$q.reject`.
	 * - `notify(value)` - provides updates on the status of the promise's execution. This may be called
	 *   multiple times before the promise is either resolved or rejected.
	 *
	 * **Properties**
	 *
	 * - promise – `{Promise}` – promise object associated with this deferred.
	 *
	 *
	 * ## The Promise API
	 *
	 * A new promise instance is created when a deferred instance is created and can be retrieved by
	 * calling `deferred.promise`.
	 *
	 * The purpose of the promise object is to allow for interested parties to get access to the result
	 * of the deferred task when it completes.
	 *
	 * **Methods**
	 *
	 * - `then(successCallback, [errorCallback], [notifyCallback])` – regardless of when the promise was or
	 *   will be resolved or rejected, `then` calls one of the success or error callbacks asynchronously
	 *   as soon as the result is available. The callbacks are called with a single argument: the result
	 *   or rejection reason. Additionally, the notify callback may be called zero or more times to
	 *   provide a progress indication, before the promise is resolved or rejected.
	 *
	 *   This method *returns a new promise* which is resolved or rejected via the return value of the
	 *   `successCallback`, `errorCallback` (unless that value is a promise, in which case it is resolved
	 *   with the value which is resolved in that promise using
	 *   [promise chaining](http://www.html5rocks.com/en/tutorials/es6/promises/#toc-promises-queues)).
	 *   It also notifies via the return value of the `notifyCallback` method. The promise cannot be
	 *   resolved or rejected from the notifyCallback method. The errorCallback and notifyCallback
	 *   arguments are optional.
	 *
	 * - `catch(errorCallback)` – shorthand for `promise.then(null, errorCallback)`
	 *
	 * - `finally(callback, notifyCallback)` – allows you to observe either the fulfillment or rejection of a promise,
	 *   but to do so without modifying the final value. This is useful to release resources or do some
	 *   clean-up that needs to be done whether the promise was rejected or resolved. See the [full
	 *   specification](https://github.com/kriskowal/q/wiki/API-Reference#promisefinallycallback) for
	 *   more information.
	 *
	 * ## Chaining promises
	 *
	 * Because calling the `then` method of a promise returns a new derived promise, it is easily
	 * possible to create a chain of promises:
	 *
	 * ```js
	 *   promiseB = promiseA.then(function(result) {
	 *     return result + 1;
	 *   });
	 *
	 *   // promiseB will be resolved immediately after promiseA is resolved and its value
	 *   // will be the result of promiseA incremented by 1
	 * ```
	 *
	 * It is possible to create chains of any length and since a promise can be resolved with another
	 * promise (which will defer its resolution further), it is possible to pause/defer resolution of
	 * the promises at any point in the chain. This makes it possible to implement powerful APIs like
	 * $http's response interceptors.
	 *
	 *
	 * ## Differences between Kris Kowal's Q and $q
	 *
	 *  There are two main differences:
	 *
	 * - $q is integrated with the {@link ng.$rootScope.Scope} Scope model observation
	 *   mechanism in AngularJS, which means faster propagation of resolution or rejection into your
	 *   models and avoiding unnecessary browser repaints, which would result in flickering UI.
	 * - Q has many more features than $q, but that comes at a cost of bytes. $q is tiny, but contains
	 *   all the important functionality needed for common async tasks.
	 *
	 * ## Testing
	 *
	 *  ```js
	 *    it('should simulate promise', inject(function($q, $rootScope) {
	 *      var deferred = $q.defer();
	 *      var promise = deferred.promise;
	 *      var resolvedValue;
	 *
	 *      promise.then(function(value) { resolvedValue = value; });
	 *      expect(resolvedValue).toBeUndefined();
	 *
	 *      // Simulate resolving of promise
	 *      deferred.resolve(123);
	 *      // Note that the 'then' function does not get called synchronously.
	 *      // This is because we want the promise API to always be async, whether or not
	 *      // it got called synchronously or asynchronously.
	 *      expect(resolvedValue).toBeUndefined();
	 *
	 *      // Propagate promise resolution to 'then' functions using $apply().
	 *      $rootScope.$apply();
	 *      expect(resolvedValue).toEqual(123);
	 *    }));
	 *  ```
	 *
	 * @param {function(function, function)} resolver Function which is responsible for resolving or
	 *   rejecting the newly created promise. The first parameter is a function which resolves the
	 *   promise, the second parameter is a function which rejects the promise.
	 *
	 * @returns {Promise} The newly created promise.
	 */
	/**
	 * @ngdoc provider
	 * @name $qProvider
	 * @this
	 *
	 * @description
	 */
	function $QProvider() {
	  var errorOnUnhandledRejections = true;
	  this.$get = ['$rootScope', '$exceptionHandler', function($rootScope, $exceptionHandler) {
	    return qFactory(function(callback) {
	      $rootScope.$evalAsync(callback);
	    }, $exceptionHandler, errorOnUnhandledRejections);
	  }];
	
	  /**
	   * @ngdoc method
	   * @name $qProvider#errorOnUnhandledRejections
	   * @kind function
	   *
	   * @description
	   * Retrieves or overrides whether to generate an error when a rejected promise is not handled.
	   * This feature is enabled by default.
	   *
	   * @param {boolean=} value Whether to generate an error when a rejected promise is not handled.
	   * @returns {boolean|ng.$qProvider} Current value when called without a new value or self for
	   *    chaining otherwise.
	   */
	  this.errorOnUnhandledRejections = function(value) {
	    if (isDefined(value)) {
	      errorOnUnhandledRejections = value;
	      return this;
	    } else {
	      return errorOnUnhandledRejections;
	    }
	  };
	}
	
	/** @this */
	function $$QProvider() {
	  var errorOnUnhandledRejections = true;
	  this.$get = ['$browser', '$exceptionHandler', function($browser, $exceptionHandler) {
	    return qFactory(function(callback) {
	      $browser.defer(callback);
	    }, $exceptionHandler, errorOnUnhandledRejections);
	  }];
	
	  this.errorOnUnhandledRejections = function(value) {
	    if (isDefined(value)) {
	      errorOnUnhandledRejections = value;
	      return this;
	    } else {
	      return errorOnUnhandledRejections;
	    }
	  };
	}
	
	/**
	 * Constructs a promise manager.
	 *
	 * @param {function(function)} nextTick Function for executing functions in the next turn.
	 * @param {function(...*)} exceptionHandler Function into which unexpected exceptions are passed for
	 *     debugging purposes.
	 * @param {boolean=} errorOnUnhandledRejections Whether an error should be generated on unhandled
	 *     promises rejections.
	 * @returns {object} Promise manager.
	 */
	function qFactory(nextTick, exceptionHandler, errorOnUnhandledRejections) {
	  var $qMinErr = minErr('$q', TypeError);
	  var queueSize = 0;
	  var checkQueue = [];
	
	  /**
	   * @ngdoc method
	   * @name ng.$q#defer
	   * @kind function
	   *
	   * @description
	   * Creates a `Deferred` object which represents a task which will finish in the future.
	   *
	   * @returns {Deferred} Returns a new instance of deferred.
	   */
	  function defer() {
	    return new Deferred();
	  }
	
	  function Deferred() {
	    var promise = this.promise = new Promise();
	    //Non prototype methods necessary to support unbound execution :/
	    this.resolve = function(val) { resolvePromise(promise, val); };
	    this.reject = function(reason) { rejectPromise(promise, reason); };
	    this.notify = function(progress) { notifyPromise(promise, progress); };
	  }
	
	
	  function Promise() {
	    this.$$state = { status: 0 };
	  }
	
	  extend(Promise.prototype, {
	    then: function(onFulfilled, onRejected, progressBack) {
	      if (isUndefined(onFulfilled) && isUndefined(onRejected) && isUndefined(progressBack)) {
	        return this;
	      }
	      var result = new Promise();
	
	      this.$$state.pending = this.$$state.pending || [];
	      this.$$state.pending.push([result, onFulfilled, onRejected, progressBack]);
	      if (this.$$state.status > 0) scheduleProcessQueue(this.$$state);
	
	      return result;
	    },
	
	    'catch': function(callback) {
	      return this.then(null, callback);
	    },
	
	    'finally': function(callback, progressBack) {
	      return this.then(function(value) {
	        return handleCallback(value, resolve, callback);
	      }, function(error) {
	        return handleCallback(error, reject, callback);
	      }, progressBack);
	    }
	  });
	
	  function processQueue(state) {
	    var fn, promise, pending;
	
	    pending = state.pending;
	    state.processScheduled = false;
	    state.pending = undefined;
	    try {
	      for (var i = 0, ii = pending.length; i < ii; ++i) {
	        markQStateExceptionHandled(state);
	        promise = pending[i][0];
	        fn = pending[i][state.status];
	        try {
	          if (isFunction(fn)) {
	            resolvePromise(promise, fn(state.value));
	          } else if (state.status === 1) {
	            resolvePromise(promise, state.value);
	          } else {
	            rejectPromise(promise, state.value);
	          }
	        } catch (e) {
	          rejectPromise(promise, e);
	          // This error is explicitly marked for being passed to the $exceptionHandler
	          if (e && e.$$passToExceptionHandler === true) {
	            exceptionHandler(e);
	          }
	        }
	      }
	    } finally {
	      --queueSize;
	      if (errorOnUnhandledRejections && queueSize === 0) {
	        nextTick(processChecks);
	      }
	    }
	  }
	
	  function processChecks() {
	    // eslint-disable-next-line no-unmodified-loop-condition
	    while (!queueSize && checkQueue.length) {
	      var toCheck = checkQueue.shift();
	      if (!isStateExceptionHandled(toCheck)) {
	        markQStateExceptionHandled(toCheck);
	        var errorMessage = 'Possibly unhandled rejection: ' + toDebugString(toCheck.value);
	        if (isError(toCheck.value)) {
	          exceptionHandler(toCheck.value, errorMessage);
	        } else {
	          exceptionHandler(errorMessage);
	        }
	      }
	    }
	  }
	
	  function scheduleProcessQueue(state) {
	    if (errorOnUnhandledRejections && !state.pending && state.status === 2 && !isStateExceptionHandled(state)) {
	      if (queueSize === 0 && checkQueue.length === 0) {
	        nextTick(processChecks);
	      }
	      checkQueue.push(state);
	    }
	    if (state.processScheduled || !state.pending) return;
	    state.processScheduled = true;
	    ++queueSize;
	    nextTick(function() { processQueue(state); });
	  }
	
	  function resolvePromise(promise, val) {
	    if (promise.$$state.status) return;
	    if (val === promise) {
	      $$reject(promise, $qMinErr(
	        'qcycle',
	        'Expected promise to be resolved with value other than itself \'{0}\'',
	        val));
	    } else {
	      $$resolve(promise, val);
	    }
	
	  }
	
	  function $$resolve(promise, val) {
	    var then;
	    var done = false;
	    try {
	      if (isObject(val) || isFunction(val)) then = val.then;
	      if (isFunction(then)) {
	        promise.$$state.status = -1;
	        then.call(val, doResolve, doReject, doNotify);
	      } else {
	        promise.$$state.value = val;
	        promise.$$state.status = 1;
	        scheduleProcessQueue(promise.$$state);
	      }
	    } catch (e) {
	      doReject(e);
	    }
	
	    function doResolve(val) {
	      if (done) return;
	      done = true;
	      $$resolve(promise, val);
	    }
	    function doReject(val) {
	      if (done) return;
	      done = true;
	      $$reject(promise, val);
	    }
	    function doNotify(progress) {
	      notifyPromise(promise, progress);
	    }
	  }
	
	  function rejectPromise(promise, reason) {
	    if (promise.$$state.status) return;
	    $$reject(promise, reason);
	  }
	
	  function $$reject(promise, reason) {
	    promise.$$state.value = reason;
	    promise.$$state.status = 2;
	    scheduleProcessQueue(promise.$$state);
	  }
	
	  function notifyPromise(promise, progress) {
	    var callbacks = promise.$$state.pending;
	
	    if ((promise.$$state.status <= 0) && callbacks && callbacks.length) {
	      nextTick(function() {
	        var callback, result;
	        for (var i = 0, ii = callbacks.length; i < ii; i++) {
	          result = callbacks[i][0];
	          callback = callbacks[i][3];
	          try {
	            notifyPromise(result, isFunction(callback) ? callback(progress) : progress);
	          } catch (e) {
	            exceptionHandler(e);
	          }
	        }
	      });
	    }
	  }
	
	  /**
	   * @ngdoc method
	   * @name $q#reject
	   * @kind function
	   *
	   * @description
	   * Creates a promise that is resolved as rejected with the specified `reason`. This api should be
	   * used to forward rejection in a chain of promises. If you are dealing with the last promise in
	   * a promise chain, you don't need to worry about it.
	   *
	   * When comparing deferreds/promises to the familiar behavior of try/catch/throw, think of
	   * `reject` as the `throw` keyword in JavaScript. This also means that if you "catch" an error via
	   * a promise error callback and you want to forward the error to the promise derived from the
	   * current promise, you have to "rethrow" the error by returning a rejection constructed via
	   * `reject`.
	   *
	   * ```js
	   *   promiseB = promiseA.then(function(result) {
	   *     // success: do something and resolve promiseB
	   *     //          with the old or a new result
	   *     return result;
	   *   }, function(reason) {
	   *     // error: handle the error if possible and
	   *     //        resolve promiseB with newPromiseOrValue,
	   *     //        otherwise forward the rejection to promiseB
	   *     if (canHandle(reason)) {
	   *      // handle the error and recover
	   *      return newPromiseOrValue;
	   *     }
	   *     return $q.reject(reason);
	   *   });
	   * ```
	   *
	   * @param {*} reason Constant, message, exception or an object representing the rejection reason.
	   * @returns {Promise} Returns a promise that was already resolved as rejected with the `reason`.
	   */
	  function reject(reason) {
	    var result = new Promise();
	    rejectPromise(result, reason);
	    return result;
	  }
	
	  function handleCallback(value, resolver, callback) {
	    var callbackOutput = null;
	    try {
	      if (isFunction(callback)) callbackOutput = callback();
	    } catch (e) {
	      return reject(e);
	    }
	    if (isPromiseLike(callbackOutput)) {
	      return callbackOutput.then(function() {
	        return resolver(value);
	      }, reject);
	    } else {
	      return resolver(value);
	    }
	  }
	
	  /**
	   * @ngdoc method
	   * @name $q#when
	   * @kind function
	   *
	   * @description
	   * Wraps an object that might be a value or a (3rd party) then-able promise into a $q promise.
	   * This is useful when you are dealing with an object that might or might not be a promise, or if
	   * the promise comes from a source that can't be trusted.
	   *
	   * @param {*} value Value or a promise
	   * @param {Function=} successCallback
	   * @param {Function=} errorCallback
	   * @param {Function=} progressCallback
	   * @returns {Promise} Returns a promise of the passed value or promise
	   */
	
	
	  function when(value, callback, errback, progressBack) {
	    var result = new Promise();
	    resolvePromise(result, value);
	    return result.then(callback, errback, progressBack);
	  }
	
	  /**
	   * @ngdoc method
	   * @name $q#resolve
	   * @kind function
	   *
	   * @description
	   * Alias of {@link ng.$q#when when} to maintain naming consistency with ES6.
	   *
	   * @param {*} value Value or a promise
	   * @param {Function=} successCallback
	   * @param {Function=} errorCallback
	   * @param {Function=} progressCallback
	   * @returns {Promise} Returns a promise of the passed value or promise
	   */
	  var resolve = when;
	
	  /**
	   * @ngdoc method
	   * @name $q#all
	   * @kind function
	   *
	   * @description
	   * Combines multiple promises into a single promise that is resolved when all of the input
	   * promises are resolved.
	   *
	   * @param {Array.<Promise>|Object.<Promise>} promises An array or hash of promises.
	   * @returns {Promise} Returns a single promise that will be resolved with an array/hash of values,
	   *   each value corresponding to the promise at the same index/key in the `promises` array/hash.
	   *   If any of the promises is resolved with a rejection, this resulting promise will be rejected
	   *   with the same rejection value.
	   */
	
	  function all(promises) {
	    var result = new Promise(),
	        counter = 0,
	        results = isArray(promises) ? [] : {};
	
	    forEach(promises, function(promise, key) {
	      counter++;
	      when(promise).then(function(value) {
	        results[key] = value;
	        if (!(--counter)) resolvePromise(result, results);
	      }, function(reason) {
	        rejectPromise(result, reason);
	      });
	    });
	
	    if (counter === 0) {
	      resolvePromise(result, results);
	    }
	
	    return result;
	  }
	
	  /**
	   * @ngdoc method
	   * @name $q#race
	   * @kind function
	   *
	   * @description
	   * Returns a promise that resolves or rejects as soon as one of those promises
	   * resolves or rejects, with the value or reason from that promise.
	   *
	   * @param {Array.<Promise>|Object.<Promise>} promises An array or hash of promises.
	   * @returns {Promise} a promise that resolves or rejects as soon as one of the `promises`
	   * resolves or rejects, with the value or reason from that promise.
	   */
	
	  function race(promises) {
	    var deferred = defer();
	
	    forEach(promises, function(promise) {
	      when(promise).then(deferred.resolve, deferred.reject);
	    });
	
	    return deferred.promise;
	  }
	
	  function $Q(resolver) {
	    if (!isFunction(resolver)) {
	      throw $qMinErr('norslvr', 'Expected resolverFn, got \'{0}\'', resolver);
	    }
	
	    var promise = new Promise();
	
	    function resolveFn(value) {
	      resolvePromise(promise, value);
	    }
	
	    function rejectFn(reason) {
	      rejectPromise(promise, reason);
	    }
	
	    resolver(resolveFn, rejectFn);
	
	    return promise;
	  }
	
	  // Let's make the instanceof operator work for promises, so that
	  // `new $q(fn) instanceof $q` would evaluate to true.
	  $Q.prototype = Promise.prototype;
	
	  $Q.defer = defer;
	  $Q.reject = reject;
	  $Q.when = when;
	  $Q.resolve = resolve;
	  $Q.all = all;
	  $Q.race = race;
	
	  return $Q;
	}
	
	function isStateExceptionHandled(state) {
	  return !!state.pur;
	}
	function markQStateExceptionHandled(state) {
	  state.pur = true;
	}
	function markQExceptionHandled(q) {
	  // Built-in `$q` promises will always have a `$$state` property. This check is to allow
	  // overwriting `$q` with a different promise library (e.g. Bluebird + angular-bluebird-promises).
	  // (Currently, this is the only method that might be called with a promise, even if it is not
	  // created by the built-in `$q`.)
	  if (q.$$state) {
	    markQStateExceptionHandled(q.$$state);
	  }
	}
	
	/** @this */
	function $$RAFProvider() { //rAF
	  this.$get = ['$window', '$timeout', function($window, $timeout) {
	    var requestAnimationFrame = $window.requestAnimationFrame ||
	                                $window.webkitRequestAnimationFrame;
	
	    var cancelAnimationFrame = $window.cancelAnimationFrame ||
	                               $window.webkitCancelAnimationFrame ||
	                               $window.webkitCancelRequestAnimationFrame;
	
	    var rafSupported = !!requestAnimationFrame;
	    var raf = rafSupported
	      ? function(fn) {
	          var id = requestAnimationFrame(fn);
	          return function() {
	            cancelAnimationFrame(id);
	          };
	        }
	      : function(fn) {
	          var timer = $timeout(fn, 16.66, false); // 1000 / 60 = 16.666
	          return function() {
	            $timeout.cancel(timer);
	          };
	        };
	
	    raf.supported = rafSupported;
	
	    return raf;
	  }];
	}
	
	/**
	 * DESIGN NOTES
	 *
	 * The design decisions behind the scope are heavily favored for speed and memory consumption.
	 *
	 * The typical use of scope is to watch the expressions, which most of the time return the same
	 * value as last time so we optimize the operation.
	 *
	 * Closures construction is expensive in terms of speed as well as memory:
	 *   - No closures, instead use prototypical inheritance for API
	 *   - Internal state needs to be stored on scope directly, which means that private state is
	 *     exposed as $$____ properties
	 *
	 * Loop operations are optimized by using while(count--) { ... }
	 *   - This means that in order to keep the same order of execution as addition we have to add
	 *     items to the array at the beginning (unshift) instead of at the end (push)
	 *
	 * Child scopes are created and removed often
	 *   - Using an array would be slow since inserts in the middle are expensive; so we use linked lists
	 *
	 * There are fewer watches than observers. This is why you don't want the observer to be implemented
	 * in the same way as watch. Watch requires return of the initialization function which is expensive
	 * to construct.
	 */
	
	
	/**
	 * @ngdoc provider
	 * @name $rootScopeProvider
	 * @description
	 *
	 * Provider for the $rootScope service.
	 */
	
	/**
	 * @ngdoc method
	 * @name $rootScopeProvider#digestTtl
	 * @description
	 *
	 * Sets the number of `$digest` iterations the scope should attempt to execute before giving up and
	 * assuming that the model is unstable.
	 *
	 * The current default is 10 iterations.
	 *
	 * In complex applications it's possible that the dependencies between `$watch`s will result in
	 * several digest iterations. However if an application needs more than the default 10 digest
	 * iterations for its model to stabilize then you should investigate what is causing the model to
	 * continuously change during the digest.
	 *
	 * Increasing the TTL could have performance implications, so you should not change it without
	 * proper justification.
	 *
	 * @param {number} limit The number of digest iterations.
	 */
	
	
	/**
	 * @ngdoc service
	 * @name $rootScope
	 * @this
	 *
	 * @description
	 *
	 * Every application has a single root {@link ng.$rootScope.Scope scope}.
	 * All other scopes are descendant scopes of the root scope. Scopes provide separation
	 * between the model and the view, via a mechanism for watching the model for changes.
	 * They also provide event emission/broadcast and subscription facility. See the
	 * {@link guide/scope developer guide on scopes}.
	 */
	function $RootScopeProvider() {
	  var TTL = 10;
	  var $rootScopeMinErr = minErr('$rootScope');
	  var lastDirtyWatch = null;
	  var applyAsyncId = null;
	
	  this.digestTtl = function(value) {
	    if (arguments.length) {
	      TTL = value;
	    }
	    return TTL;
	  };
	
	  function createChildScopeClass(parent) {
	    function ChildScope() {
	      this.$$watchers = this.$$nextSibling =
	          this.$$childHead = this.$$childTail = null;
	      this.$$listeners = {};
	      this.$$listenerCount = {};
	      this.$$watchersCount = 0;
	      this.$id = nextUid();
	      this.$$ChildScope = null;
	      this.$$suspended = false;
	    }
	    ChildScope.prototype = parent;
	    return ChildScope;
	  }
	
	  this.$get = ['$exceptionHandler', '$parse', '$browser',
	      function($exceptionHandler, $parse, $browser) {
	
	    function destroyChildScope($event) {
	        $event.currentScope.$$destroyed = true;
	    }
	
	    function cleanUpScope($scope) {
	
	      // Support: IE 9 only
	      if (msie === 9) {
	        // There is a memory leak in IE9 if all child scopes are not disconnected
	        // completely when a scope is destroyed. So this code will recurse up through
	        // all this scopes children
	        //
	        // See issue https://github.com/angular/angular.js/issues/10706
	        if ($scope.$$childHead) {
	          cleanUpScope($scope.$$childHead);
	        }
	        if ($scope.$$nextSibling) {
	          cleanUpScope($scope.$$nextSibling);
	        }
	      }
	
	      // The code below works around IE9 and V8's memory leaks
	      //
	      // See:
	      // - https://code.google.com/p/v8/issues/detail?id=2073#c26
	      // - https://github.com/angular/angular.js/issues/6794#issuecomment-38648909
	      // - https://github.com/angular/angular.js/issues/1313#issuecomment-10378451
	
	      $scope.$parent = $scope.$$nextSibling = $scope.$$prevSibling = $scope.$$childHead =
	          $scope.$$childTail = $scope.$root = $scope.$$watchers = null;
	    }
	
	    /**
	     * @ngdoc type
	     * @name $rootScope.Scope
	     *
	     * @description
	     * A root scope can be retrieved using the {@link ng.$rootScope $rootScope} key from the
	     * {@link auto.$injector $injector}. Child scopes are created using the
	     * {@link ng.$rootScope.Scope#$new $new()} method. (Most scopes are created automatically when
	     * compiled HTML template is executed.) See also the {@link guide/scope Scopes guide} for
	     * an in-depth introduction and usage examples.
	     *
	     *
	     * ## Inheritance
	     * A scope can inherit from a parent scope, as in this example:
	     * ```js
	         var parent = $rootScope;
	         var child = parent.$new();
	
	         parent.salutation = "Hello";
	         expect(child.salutation).toEqual('Hello');
	
	         child.salutation = "Welcome";
	         expect(child.salutation).toEqual('Welcome');
	         expect(parent.salutation).toEqual('Hello');
	     * ```
	     *
	     * When interacting with `Scope` in tests, additional helper methods are available on the
	     * instances of `Scope` type. See {@link ngMock.$rootScope.Scope ngMock Scope} for additional
	     * details.
	     *
	     *
	     * @param {Object.<string, function()>=} providers Map of service factory which need to be
	     *                                       provided for the current scope. Defaults to {@link ng}.
	     * @param {Object.<string, *>=} instanceCache Provides pre-instantiated services which should
	     *                              append/override services provided by `providers`. This is handy
	     *                              when unit-testing and having the need to override a default
	     *                              service.
	     * @returns {Object} Newly created scope.
	     *
	     */
	    function Scope() {
	      this.$id = nextUid();
	      this.$$phase = this.$parent = this.$$watchers =
	                     this.$$nextSibling = this.$$prevSibling =
	                     this.$$childHead = this.$$childTail = null;
	      this.$root = this;
	      this.$$destroyed = false;
	      this.$$suspended = false;
	      this.$$listeners = {};
	      this.$$listenerCount = {};
	      this.$$watchersCount = 0;
	      this.$$isolateBindings = null;
	    }
	
	    /**
	     * @ngdoc property
	     * @name $rootScope.Scope#$id
	     *
	     * @description
	     * Unique scope ID (monotonically increasing) useful for debugging.
	     */
	
	     /**
	      * @ngdoc property
	      * @name $rootScope.Scope#$parent
	      *
	      * @description
	      * Reference to the parent scope.
	      */
	
	      /**
	       * @ngdoc property
	       * @name $rootScope.Scope#$root
	       *
	       * @description
	       * Reference to the root scope.
	       */
	
	    Scope.prototype = {
	      constructor: Scope,
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$new
	       * @kind function
	       *
	       * @description
	       * Creates a new child {@link ng.$rootScope.Scope scope}.
	       *
	       * The parent scope will propagate the {@link ng.$rootScope.Scope#$digest $digest()} event.
	       * The scope can be removed from the scope hierarchy using {@link ng.$rootScope.Scope#$destroy $destroy()}.
	       *
	       * {@link ng.$rootScope.Scope#$destroy $destroy()} must be called on a scope when it is
	       * desired for the scope and its child scopes to be permanently detached from the parent and
	       * thus stop participating in model change detection and listener notification by invoking.
	       *
	       * @param {boolean} isolate If true, then the scope does not prototypically inherit from the
	       *         parent scope. The scope is isolated, as it can not see parent scope properties.
	       *         When creating widgets, it is useful for the widget to not accidentally read parent
	       *         state.
	       *
	       * @param {Scope} [parent=this] The {@link ng.$rootScope.Scope `Scope`} that will be the `$parent`
	       *                              of the newly created scope. Defaults to `this` scope if not provided.
	       *                              This is used when creating a transclude scope to correctly place it
	       *                              in the scope hierarchy while maintaining the correct prototypical
	       *                              inheritance.
	       *
	       * @returns {Object} The newly created child scope.
	       *
	       */
	      $new: function(isolate, parent) {
	        var child;
	
	        parent = parent || this;
	
	        if (isolate) {
	          child = new Scope();
	          child.$root = this.$root;
	        } else {
	          // Only create a child scope class if somebody asks for one,
	          // but cache it to allow the VM to optimize lookups.
	          if (!this.$$ChildScope) {
	            this.$$ChildScope = createChildScopeClass(this);
	          }
	          child = new this.$$ChildScope();
	        }
	        child.$parent = parent;
	        child.$$prevSibling = parent.$$childTail;
	        if (parent.$$childHead) {
	          parent.$$childTail.$$nextSibling = child;
	          parent.$$childTail = child;
	        } else {
	          parent.$$childHead = parent.$$childTail = child;
	        }
	
	        // When the new scope is not isolated or we inherit from `this`, and
	        // the parent scope is destroyed, the property `$$destroyed` is inherited
	        // prototypically. In all other cases, this property needs to be set
	        // when the parent scope is destroyed.
	        // The listener needs to be added after the parent is set
	        if (isolate || parent !== this) child.$on('$destroy', destroyChildScope);
	
	        return child;
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$watch
	       * @kind function
	       *
	       * @description
	       * Registers a `listener` callback to be executed whenever the `watchExpression` changes.
	       *
	       * - The `watchExpression` is called on every call to {@link ng.$rootScope.Scope#$digest
	       *   $digest()} and should return the value that will be watched. (`watchExpression` should not change
	       *   its value when executed multiple times with the same input because it may be executed multiple
	       *   times by {@link ng.$rootScope.Scope#$digest $digest()}. That is, `watchExpression` should be
	       *   [idempotent](http://en.wikipedia.org/wiki/Idempotence).)
	       * - The `listener` is called only when the value from the current `watchExpression` and the
	       *   previous call to `watchExpression` are not equal (with the exception of the initial run,
	       *   see below). Inequality is determined according to reference inequality,
	       *   [strict comparison](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Comparison_Operators)
	       *    via the `!==` Javascript operator, unless `objectEquality == true`
	       *   (see next point)
	       * - When `objectEquality == true`, inequality of the `watchExpression` is determined
	       *   according to the {@link angular.equals} function. To save the value of the object for
	       *   later comparison, the {@link angular.copy} function is used. This therefore means that
	       *   watching complex objects will have adverse memory and performance implications.
	       * - This should not be used to watch for changes in objects that are (or contain)
	       *   [File](https://developer.mozilla.org/docs/Web/API/File) objects due to limitations with {@link angular.copy `angular.copy`}.
	       * - The watch `listener` may change the model, which may trigger other `listener`s to fire.
	       *   This is achieved by rerunning the watchers until no changes are detected. The rerun
	       *   iteration limit is 10 to prevent an infinite loop deadlock.
	       *
	       *
	       * If you want to be notified whenever {@link ng.$rootScope.Scope#$digest $digest} is called,
	       * you can register a `watchExpression` function with no `listener`. (Be prepared for
	       * multiple calls to your `watchExpression` because it will execute multiple times in a
	       * single {@link ng.$rootScope.Scope#$digest $digest} cycle if a change is detected.)
	       *
	       * After a watcher is registered with the scope, the `listener` fn is called asynchronously
	       * (via {@link ng.$rootScope.Scope#$evalAsync $evalAsync}) to initialize the
	       * watcher. In rare cases, this is undesirable because the listener is called when the result
	       * of `watchExpression` didn't change. To detect this scenario within the `listener` fn, you
	       * can compare the `newVal` and `oldVal`. If these two values are identical (`===`) then the
	       * listener was called due to initialization.
	       *
	       *
	       *
	       * @example
	       * ```js
	           // let's assume that scope was dependency injected as the $rootScope
	           var scope = $rootScope;
	           scope.name = 'misko';
	           scope.counter = 0;
	
	           expect(scope.counter).toEqual(0);
	           scope.$watch('name', function(newValue, oldValue) {
	             scope.counter = scope.counter + 1;
	           });
	           expect(scope.counter).toEqual(0);
	
	           scope.$digest();
	           // the listener is always called during the first $digest loop after it was registered
	           expect(scope.counter).toEqual(1);
	
	           scope.$digest();
	           // but now it will not be called unless the value changes
	           expect(scope.counter).toEqual(1);
	
	           scope.name = 'adam';
	           scope.$digest();
	           expect(scope.counter).toEqual(2);
	
	
	
	           // Using a function as a watchExpression
	           var food;
	           scope.foodCounter = 0;
	           expect(scope.foodCounter).toEqual(0);
	           scope.$watch(
	             // This function returns the value being watched. It is called for each turn of the $digest loop
	             function() { return food; },
	             // This is the change listener, called when the value returned from the above function changes
	             function(newValue, oldValue) {
	               if ( newValue !== oldValue ) {
	                 // Only increment the counter if the value changed
	                 scope.foodCounter = scope.foodCounter + 1;
	               }
	             }
	           );
	           // No digest has been run so the counter will be zero
	           expect(scope.foodCounter).toEqual(0);
	
	           // Run the digest but since food has not changed count will still be zero
	           scope.$digest();
	           expect(scope.foodCounter).toEqual(0);
	
	           // Update food and run digest.  Now the counter will increment
	           food = 'cheeseburger';
	           scope.$digest();
	           expect(scope.foodCounter).toEqual(1);
	
	       * ```
	       *
	       *
	       *
	       * @param {(function()|string)} watchExpression Expression that is evaluated on each
	       *    {@link ng.$rootScope.Scope#$digest $digest} cycle. A change in the return value triggers
	       *    a call to the `listener`.
	       *
	       *    - `string`: Evaluated as {@link guide/expression expression}
	       *    - `function(scope)`: called with current `scope` as a parameter.
	       * @param {function(newVal, oldVal, scope)} listener Callback called whenever the value
	       *    of `watchExpression` changes.
	       *
	       *    - `newVal` contains the current value of the `watchExpression`
	       *    - `oldVal` contains the previous value of the `watchExpression`
	       *    - `scope` refers to the current scope
	       * @param {boolean=} [objectEquality=false] Compare for object equality using {@link angular.equals} instead of
	       *     comparing for reference equality.
	       * @returns {function()} Returns a deregistration function for this listener.
	       */
	      $watch: function(watchExp, listener, objectEquality, prettyPrintExpression) {
	        var get = $parse(watchExp);
	        var fn = isFunction(listener) ? listener : noop;
	
	        if (get.$$watchDelegate) {
	          return get.$$watchDelegate(this, fn, objectEquality, get, watchExp);
	        }
	        var scope = this,
	            array = scope.$$watchers,
	            watcher = {
	              fn: fn,
	              last: initWatchVal,
	              get: get,
	              exp: prettyPrintExpression || watchExp,
	              eq: !!objectEquality
	            };
	
	        lastDirtyWatch = null;
	
	        if (!array) {
	          array = scope.$$watchers = [];
	          array.$$digestWatchIndex = -1;
	        }
	        // we use unshift since we use a while loop in $digest for speed.
	        // the while loop reads in reverse order.
	        array.unshift(watcher);
	        array.$$digestWatchIndex++;
	        incrementWatchersCount(this, 1);
	
	        return function deregisterWatch() {
	          var index = arrayRemove(array, watcher);
	          if (index >= 0) {
	            incrementWatchersCount(scope, -1);
	            if (index < array.$$digestWatchIndex) {
	              array.$$digestWatchIndex--;
	            }
	          }
	          lastDirtyWatch = null;
	        };
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$watchGroup
	       * @kind function
	       *
	       * @description
	       * A variant of {@link ng.$rootScope.Scope#$watch $watch()} where it watches an array of `watchExpressions`.
	       * If any one expression in the collection changes the `listener` is executed.
	       *
	       * - The items in the `watchExpressions` array are observed via the standard `$watch` operation. Their return
	       *   values are examined for changes on every call to `$digest`.
	       * - The `listener` is called whenever any expression in the `watchExpressions` array changes.
	       *
	       * @param {Array.<string|Function(scope)>} watchExpressions Array of expressions that will be individually
	       * watched using {@link ng.$rootScope.Scope#$watch $watch()}
	       *
	       * @param {function(newValues, oldValues, scope)} listener Callback called whenever the return value of any
	       *    expression in `watchExpressions` changes
	       *    The `newValues` array contains the current values of the `watchExpressions`, with the indexes matching
	       *    those of `watchExpression`
	       *    and the `oldValues` array contains the previous values of the `watchExpressions`, with the indexes matching
	       *    those of `watchExpression`
	       *    The `scope` refers to the current scope.
	       * @returns {function()} Returns a de-registration function for all listeners.
	       */
	      $watchGroup: function(watchExpressions, listener) {
	        var oldValues = new Array(watchExpressions.length);
	        var newValues = new Array(watchExpressions.length);
	        var deregisterFns = [];
	        var self = this;
	        var changeReactionScheduled = false;
	        var firstRun = true;
	
	        if (!watchExpressions.length) {
	          // No expressions means we call the listener ASAP
	          var shouldCall = true;
	          self.$evalAsync(function() {
	            if (shouldCall) listener(newValues, newValues, self);
	          });
	          return function deregisterWatchGroup() {
	            shouldCall = false;
	          };
	        }
	
	        if (watchExpressions.length === 1) {
	          // Special case size of one
	          return this.$watch(watchExpressions[0], function watchGroupAction(value, oldValue, scope) {
	            newValues[0] = value;
	            oldValues[0] = oldValue;
	            listener(newValues, (value === oldValue) ? newValues : oldValues, scope);
	          });
	        }
	
	        forEach(watchExpressions, function(expr, i) {
	          var unwatchFn = self.$watch(expr, function watchGroupSubAction(value) {
	            newValues[i] = value;
	            if (!changeReactionScheduled) {
	              changeReactionScheduled = true;
	              self.$evalAsync(watchGroupAction);
	            }
	          });
	          deregisterFns.push(unwatchFn);
	        });
	
	        function watchGroupAction() {
	          changeReactionScheduled = false;
	
	          try {
	            if (firstRun) {
	              firstRun = false;
	              listener(newValues, newValues, self);
	            } else {
	              listener(newValues, oldValues, self);
	            }
	          } finally {
	            for (var i = 0; i < watchExpressions.length; i++) {
	              oldValues[i] = newValues[i];
	            }
	          }
	        }
	
	        return function deregisterWatchGroup() {
	          while (deregisterFns.length) {
	            deregisterFns.shift()();
	          }
	        };
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$watchCollection
	       * @kind function
	       *
	       * @description
	       * Shallow watches the properties of an object and fires whenever any of the properties change
	       * (for arrays, this implies watching the array items; for object maps, this implies watching
	       * the properties). If a change is detected, the `listener` callback is fired.
	       *
	       * - The `obj` collection is observed via standard $watch operation and is examined on every
	       *   call to $digest() to see if any items have been added, removed, or moved.
	       * - The `listener` is called whenever anything within the `obj` has changed. Examples include
	       *   adding, removing, and moving items belonging to an object or array.
	       *
	       *
	       * @example
	       * ```js
	          $scope.names = ['igor', 'matias', 'misko', 'james'];
	          $scope.dataCount = 4;
	
	          $scope.$watchCollection('names', function(newNames, oldNames) {
	            $scope.dataCount = newNames.length;
	          });
	
	          expect($scope.dataCount).toEqual(4);
	          $scope.$digest();
	
	          //still at 4 ... no changes
	          expect($scope.dataCount).toEqual(4);
	
	          $scope.names.pop();
	          $scope.$digest();
	
	          //now there's been a change
	          expect($scope.dataCount).toEqual(3);
	       * ```
	       *
	       *
	       * @param {string|function(scope)} obj Evaluated as {@link guide/expression expression}. The
	       *    expression value should evaluate to an object or an array which is observed on each
	       *    {@link ng.$rootScope.Scope#$digest $digest} cycle. Any shallow change within the
	       *    collection will trigger a call to the `listener`.
	       *
	       * @param {function(newCollection, oldCollection, scope)} listener a callback function called
	       *    when a change is detected.
	       *    - The `newCollection` object is the newly modified data obtained from the `obj` expression
	       *    - The `oldCollection` object is a copy of the former collection data.
	       *      Due to performance considerations, the`oldCollection` value is computed only if the
	       *      `listener` function declares two or more arguments.
	       *    - The `scope` argument refers to the current scope.
	       *
	       * @returns {function()} Returns a de-registration function for this listener. When the
	       *    de-registration function is executed, the internal watch operation is terminated.
	       */
	      $watchCollection: function(obj, listener) {
	        // Mark the interceptor as
	        // ... $$pure when literal since the instance will change when any input changes
	        $watchCollectionInterceptor.$$pure = $parse(obj).literal;
	        // ... $stateful when non-literal since we must read the state of the collection
	        $watchCollectionInterceptor.$stateful = !$watchCollectionInterceptor.$$pure;
	
	        var self = this;
	        // the current value, updated on each dirty-check run
	        var newValue;
	        // a shallow copy of the newValue from the last dirty-check run,
	        // updated to match newValue during dirty-check run
	        var oldValue;
	        // a shallow copy of the newValue from when the last change happened
	        var veryOldValue;
	        // only track veryOldValue if the listener is asking for it
	        var trackVeryOldValue = (listener.length > 1);
	        var changeDetected = 0;
	        var changeDetector = $parse(obj, $watchCollectionInterceptor);
	        var internalArray = [];
	        var internalObject = {};
	        var initRun = true;
	        var oldLength = 0;
	
	        function $watchCollectionInterceptor(_value) {
	          newValue = _value;
	          var newLength, key, bothNaN, newItem, oldItem;
	
	          // If the new value is undefined, then return undefined as the watch may be a one-time watch
	          if (isUndefined(newValue)) return;
	
	          if (!isObject(newValue)) { // if primitive
	            if (oldValue !== newValue) {
	              oldValue = newValue;
	              changeDetected++;
	            }
	          } else if (isArrayLike(newValue)) {
	            if (oldValue !== internalArray) {
	              // we are transitioning from something which was not an array into array.
	              oldValue = internalArray;
	              oldLength = oldValue.length = 0;
	              changeDetected++;
	            }
	
	            newLength = newValue.length;
	
	            if (oldLength !== newLength) {
	              // if lengths do not match we need to trigger change notification
	              changeDetected++;
	              oldValue.length = oldLength = newLength;
	            }
	            // copy the items to oldValue and look for changes.
	            for (var i = 0; i < newLength; i++) {
	              oldItem = oldValue[i];
	              newItem = newValue[i];
	
	              // eslint-disable-next-line no-self-compare
	              bothNaN = (oldItem !== oldItem) && (newItem !== newItem);
	              if (!bothNaN && (oldItem !== newItem)) {
	                changeDetected++;
	                oldValue[i] = newItem;
	              }
	            }
	          } else {
	            if (oldValue !== internalObject) {
	              // we are transitioning from something which was not an object into object.
	              oldValue = internalObject = {};
	              oldLength = 0;
	              changeDetected++;
	            }
	            // copy the items to oldValue and look for changes.
	            newLength = 0;
	            for (key in newValue) {
	              if (hasOwnProperty.call(newValue, key)) {
	                newLength++;
	                newItem = newValue[key];
	                oldItem = oldValue[key];
	
	                if (key in oldValue) {
	                  // eslint-disable-next-line no-self-compare
	                  bothNaN = (oldItem !== oldItem) && (newItem !== newItem);
	                  if (!bothNaN && (oldItem !== newItem)) {
	                    changeDetected++;
	                    oldValue[key] = newItem;
	                  }
	                } else {
	                  oldLength++;
	                  oldValue[key] = newItem;
	                  changeDetected++;
	                }
	              }
	            }
	            if (oldLength > newLength) {
	              // we used to have more keys, need to find them and destroy them.
	              changeDetected++;
	              for (key in oldValue) {
	                if (!hasOwnProperty.call(newValue, key)) {
	                  oldLength--;
	                  delete oldValue[key];
	                }
	              }
	            }
	          }
	          return changeDetected;
	        }
	
	        function $watchCollectionAction() {
	          if (initRun) {
	            initRun = false;
	            listener(newValue, newValue, self);
	          } else {
	            listener(newValue, veryOldValue, self);
	          }
	
	          // make a copy for the next time a collection is changed
	          if (trackVeryOldValue) {
	            if (!isObject(newValue)) {
	              //primitive
	              veryOldValue = newValue;
	            } else if (isArrayLike(newValue)) {
	              veryOldValue = new Array(newValue.length);
	              for (var i = 0; i < newValue.length; i++) {
	                veryOldValue[i] = newValue[i];
	              }
	            } else { // if object
	              veryOldValue = {};
	              for (var key in newValue) {
	                if (hasOwnProperty.call(newValue, key)) {
	                  veryOldValue[key] = newValue[key];
	                }
	              }
	            }
	          }
	        }
	
	        return this.$watch(changeDetector, $watchCollectionAction);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$digest
	       * @kind function
	       *
	       * @description
	       * Processes all of the {@link ng.$rootScope.Scope#$watch watchers} of the current scope and
	       * its children. Because a {@link ng.$rootScope.Scope#$watch watcher}'s listener can change
	       * the model, the `$digest()` keeps calling the {@link ng.$rootScope.Scope#$watch watchers}
	       * until no more listeners are firing. This means that it is possible to get into an infinite
	       * loop. This function will throw `'Maximum iteration limit exceeded.'` if the number of
	       * iterations exceeds 10.
	       *
	       * Usually, you don't call `$digest()` directly in
	       * {@link ng.directive:ngController controllers} or in
	       * {@link ng.$compileProvider#directive directives}.
	       * Instead, you should call {@link ng.$rootScope.Scope#$apply $apply()} (typically from within
	       * a {@link ng.$compileProvider#directive directive}), which will force a `$digest()`.
	       *
	       * If you want to be notified whenever `$digest()` is called,
	       * you can register a `watchExpression` function with
	       * {@link ng.$rootScope.Scope#$watch $watch()} with no `listener`.
	       *
	       * In unit tests, you may need to call `$digest()` to simulate the scope life cycle.
	       *
	       * @example
	       * ```js
	           var scope = ...;
	           scope.name = 'misko';
	           scope.counter = 0;
	
	           expect(scope.counter).toEqual(0);
	           scope.$watch('name', function(newValue, oldValue) {
	             scope.counter = scope.counter + 1;
	           });
	           expect(scope.counter).toEqual(0);
	
	           scope.$digest();
	           // the listener is always called during the first $digest loop after it was registered
	           expect(scope.counter).toEqual(1);
	
	           scope.$digest();
	           // but now it will not be called unless the value changes
	           expect(scope.counter).toEqual(1);
	
	           scope.name = 'adam';
	           scope.$digest();
	           expect(scope.counter).toEqual(2);
	       * ```
	       *
	       */
	      $digest: function() {
	        var watch, value, last, fn, get,
	            watchers,
	            dirty, ttl = TTL,
	            next, current, target = asyncQueue.length ? $rootScope : this,
	            watchLog = [],
	            logIdx, asyncTask;
	
	        beginPhase('$digest');
	        // Check for changes to browser url that happened in sync before the call to $digest
	        $browser.$$checkUrlChange();
	
	        if (this === $rootScope && applyAsyncId !== null) {
	          // If this is the root scope, and $applyAsync has scheduled a deferred $apply(), then
	          // cancel the scheduled $apply and flush the queue of expressions to be evaluated.
	          $browser.defer.cancel(applyAsyncId);
	          flushApplyAsync();
	        }
	
	        lastDirtyWatch = null;
	
	        do { // "while dirty" loop
	          dirty = false;
	          current = target;
	
	          // It's safe for asyncQueuePosition to be a local variable here because this loop can't
	          // be reentered recursively. Calling $digest from a function passed to $evalAsync would
	          // lead to a '$digest already in progress' error.
	          for (var asyncQueuePosition = 0; asyncQueuePosition < asyncQueue.length; asyncQueuePosition++) {
	            try {
	              asyncTask = asyncQueue[asyncQueuePosition];
	              fn = asyncTask.fn;
	              fn(asyncTask.scope, asyncTask.locals);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	            lastDirtyWatch = null;
	          }
	          asyncQueue.length = 0;
	
	          traverseScopesLoop:
	          do { // "traverse the scopes" loop
	            if ((watchers = !current.$$suspended && current.$$watchers)) {
	              // process our watches
	              watchers.$$digestWatchIndex = watchers.length;
	              while (watchers.$$digestWatchIndex--) {
	                try {
	                  watch = watchers[watchers.$$digestWatchIndex];
	                  // Most common watches are on primitives, in which case we can short
	                  // circuit it with === operator, only when === fails do we use .equals
	                  if (watch) {
	                    get = watch.get;
	                    if ((value = get(current)) !== (last = watch.last) &&
	                        !(watch.eq
	                            ? equals(value, last)
	                            : (isNumberNaN(value) && isNumberNaN(last)))) {
	                      dirty = true;
	                      lastDirtyWatch = watch;
	                      watch.last = watch.eq ? copy(value, null) : value;
	                      fn = watch.fn;
	                      fn(value, ((last === initWatchVal) ? value : last), current);
	                      if (ttl < 5) {
	                        logIdx = 4 - ttl;
	                        if (!watchLog[logIdx]) watchLog[logIdx] = [];
	                        watchLog[logIdx].push({
	                          msg: isFunction(watch.exp) ? 'fn: ' + (watch.exp.name || watch.exp.toString()) : watch.exp,
	                          newVal: value,
	                          oldVal: last
	                        });
	                      }
	                    } else if (watch === lastDirtyWatch) {
	                      // If the most recently dirty watcher is now clean, short circuit since the remaining watchers
	                      // have already been tested.
	                      dirty = false;
	                      break traverseScopesLoop;
	                    }
	                  }
	                } catch (e) {
	                  $exceptionHandler(e);
	                }
	              }
	            }
	
	            // Insanity Warning: scope depth-first traversal
	            // yes, this code is a bit crazy, but it works and we have tests to prove it!
	            // this piece should be kept in sync with the traversal in $broadcast
	            // (though it differs due to having the extra check for $$suspended and does not
	            // check $$listenerCount)
	            if (!(next = ((!current.$$suspended && current.$$watchersCount && current.$$childHead) ||
	                (current !== target && current.$$nextSibling)))) {
	              while (current !== target && !(next = current.$$nextSibling)) {
	                current = current.$parent;
	              }
	            }
	          } while ((current = next));
	
	          // `break traverseScopesLoop;` takes us to here
	
	          if ((dirty || asyncQueue.length) && !(ttl--)) {
	            clearPhase();
	            throw $rootScopeMinErr('infdig',
	                '{0} $digest() iterations reached. Aborting!\n' +
	                'Watchers fired in the last 5 iterations: {1}',
	                TTL, watchLog);
	          }
	
	        } while (dirty || asyncQueue.length);
	
	        clearPhase();
	
	        // postDigestQueuePosition isn't local here because this loop can be reentered recursively.
	        while (postDigestQueuePosition < postDigestQueue.length) {
	          try {
	            postDigestQueue[postDigestQueuePosition++]();
	          } catch (e) {
	            $exceptionHandler(e);
	          }
	        }
	        postDigestQueue.length = postDigestQueuePosition = 0;
	
	        // Check for changes to browser url that happened during the $digest
	        // (for which no event is fired; e.g. via `history.pushState()`)
	        $browser.$$checkUrlChange();
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$suspend
	       * @kind function
	       *
	       * @description
	       * Suspend watchers of this scope subtree so that they will not be invoked during digest.
	       *
	       * This can be used to optimize your application when you know that running those watchers
	       * is redundant.
	       *
	       * **Warning**
	       *
	       * Suspending scopes from the digest cycle can have unwanted and difficult to debug results.
	       * Only use this approach if you are confident that you know what you are doing and have
	       * ample tests to ensure that bindings get updated as you expect.
	       *
	       * Some of the things to consider are:
	       *
	       * * Any external event on a directive/component will not trigger a digest while the hosting
	       *   scope is suspended - even if the event handler calls `$apply()` or `$rootScope.$digest()`.
	       * * Transcluded content exists on a scope that inherits from outside a directive but exists
	       *   as a child of the directive's containing scope. If the containing scope is suspended the
	       *   transcluded scope will also be suspended, even if the scope from which the transcluded
	       *   scope inherits is not suspended.
	       * * Multiple directives trying to manage the suspended status of a scope can confuse each other:
	       *    * A call to `$suspend()` on an already suspended scope is a no-op.
	       *    * A call to `$resume()` on a non-suspended scope is a no-op.
	       *    * If two directives suspend a scope, then one of them resumes the scope, the scope will no
	       *      longer be suspended. This could result in the other directive believing a scope to be
	       *      suspended when it is not.
	       * * If a parent scope is suspended then all its descendants will be also excluded from future
	       *   digests whether or not they have been suspended themselves. Note that this also applies to
	       *   isolate child scopes.
	       * * Calling `$digest()` directly on a descendant of a suspended scope will still run the watchers
	       *   for that scope and its descendants. When digesting we only check whether the current scope is
	       *   locally suspended, rather than checking whether it has a suspended ancestor.
	       * * Calling `$resume()` on a scope that has a suspended ancestor will not cause the scope to be
	       *   included in future digests until all its ancestors have been resumed.
	       * * Resolved promises, e.g. from explicit `$q` deferreds and `$http` calls, trigger `$apply()`
	       *   against the `$rootScope` and so will still trigger a global digest even if the promise was
	       *   initiated by a component that lives on a suspended scope.
	       */
	      $suspend: function() {
	        this.$$suspended = true;
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$isSuspended
	       * @kind function
	       *
	       * @description
	       * Call this method to determine if this scope has been explicitly suspended. It will not
	       * tell you whether an ancestor has been suspended.
	       * To determine if this scope will be excluded from a digest triggered at the $rootScope,
	       * for example, you must check all its ancestors:
	       *
	       * ```
	       * function isExcludedFromDigest(scope) {
	       *   while(scope) {
	       *     if (scope.$isSuspended()) return true;
	       *     scope = scope.$parent;
	       *   }
	       *   return false;
	       * ```
	       *
	       * Be aware that a scope may not be included in digests if it has a suspended ancestor,
	       * even if `$isSuspended()` returns false.
	       *
	       * @returns true if the current scope has been suspended.
	       */
	      $isSuspended: function() {
	        return this.$$suspended;
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$resume
	       * @kind function
	       *
	       * @description
	       * Resume watchers of this scope subtree in case it was suspended.
	       *
	       * See {@link $rootScope.Scope#$suspend} for information about the dangers of using this approach.
	       */
	      $resume: function() {
	        this.$$suspended = false;
	      },
	
	      /**
	       * @ngdoc event
	       * @name $rootScope.Scope#$destroy
	       * @eventType broadcast on scope being destroyed
	       *
	       * @description
	       * Broadcasted when a scope and its children are being destroyed.
	       *
	       * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
	       * clean up DOM bindings before an element is removed from the DOM.
	       */
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$destroy
	       * @kind function
	       *
	       * @description
	       * Removes the current scope (and all of its children) from the parent scope. Removal implies
	       * that calls to {@link ng.$rootScope.Scope#$digest $digest()} will no longer
	       * propagate to the current scope and its children. Removal also implies that the current
	       * scope is eligible for garbage collection.
	       *
	       * The `$destroy()` is usually used by directives such as
	       * {@link ng.directive:ngRepeat ngRepeat} for managing the
	       * unrolling of the loop.
	       *
	       * Just before a scope is destroyed, a `$destroy` event is broadcasted on this scope.
	       * Application code can register a `$destroy` event handler that will give it a chance to
	       * perform any necessary cleanup.
	       *
	       * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
	       * clean up DOM bindings before an element is removed from the DOM.
	       */
	      $destroy: function() {
	        // We can't destroy a scope that has been already destroyed.
	        if (this.$$destroyed) return;
	        var parent = this.$parent;
	
	        this.$broadcast('$destroy');
	        this.$$destroyed = true;
	
	        if (this === $rootScope) {
	          //Remove handlers attached to window when $rootScope is removed
	          $browser.$$applicationDestroyed();
	        }
	
	        incrementWatchersCount(this, -this.$$watchersCount);
	        for (var eventName in this.$$listenerCount) {
	          decrementListenerCount(this, this.$$listenerCount[eventName], eventName);
	        }
	
	        // sever all the references to parent scopes (after this cleanup, the current scope should
	        // not be retained by any of our references and should be eligible for garbage collection)
	        if (parent && parent.$$childHead === this) parent.$$childHead = this.$$nextSibling;
	        if (parent && parent.$$childTail === this) parent.$$childTail = this.$$prevSibling;
	        if (this.$$prevSibling) this.$$prevSibling.$$nextSibling = this.$$nextSibling;
	        if (this.$$nextSibling) this.$$nextSibling.$$prevSibling = this.$$prevSibling;
	
	        // Disable listeners, watchers and apply/digest methods
	        this.$destroy = this.$digest = this.$apply = this.$evalAsync = this.$applyAsync = noop;
	        this.$on = this.$watch = this.$watchGroup = function() { return noop; };
	        this.$$listeners = {};
	
	        // Disconnect the next sibling to prevent `cleanUpScope` destroying those too
	        this.$$nextSibling = null;
	        cleanUpScope(this);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$eval
	       * @kind function
	       *
	       * @description
	       * Executes the `expression` on the current scope and returns the result. Any exceptions in
	       * the expression are propagated (uncaught). This is useful when evaluating AngularJS
	       * expressions.
	       *
	       * @example
	       * ```js
	           var scope = ng.$rootScope.Scope();
	           scope.a = 1;
	           scope.b = 2;
	
	           expect(scope.$eval('a+b')).toEqual(3);
	           expect(scope.$eval(function(scope){ return scope.a + scope.b; })).toEqual(3);
	       * ```
	       *
	       * @param {(string|function())=} expression An AngularJS expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in  {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with the current `scope` parameter.
	       *
	       * @param {(object)=} locals Local variables object, useful for overriding values in scope.
	       * @returns {*} The result of evaluating the expression.
	       */
	      $eval: function(expr, locals) {
	        return $parse(expr)(this, locals);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$evalAsync
	       * @kind function
	       *
	       * @description
	       * Executes the expression on the current scope at a later point in time.
	       *
	       * The `$evalAsync` makes no guarantees as to when the `expression` will be executed, only
	       * that:
	       *
	       *   - it will execute after the function that scheduled the evaluation (preferably before DOM
	       *     rendering).
	       *   - at least one {@link ng.$rootScope.Scope#$digest $digest cycle} will be performed after
	       *     `expression` execution.
	       *
	       * Any exceptions from the execution of the expression are forwarded to the
	       * {@link ng.$exceptionHandler $exceptionHandler} service.
	       *
	       * __Note:__ if this function is called outside of a `$digest` cycle, a new `$digest` cycle
	       * will be scheduled. However, it is encouraged to always call code that changes the model
	       * from within an `$apply` call. That includes code evaluated via `$evalAsync`.
	       *
	       * @param {(string|function())=} expression An AngularJS expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with the current `scope` parameter.
	       *
	       * @param {(object)=} locals Local variables object, useful for overriding values in scope.
	       */
	      $evalAsync: function(expr, locals) {
	        // if we are outside of an $digest loop and this is the first time we are scheduling async
	        // task also schedule async auto-flush
	        if (!$rootScope.$$phase && !asyncQueue.length) {
	          $browser.defer(function() {
	            if (asyncQueue.length) {
	              $rootScope.$digest();
	            }
	          }, null, '$evalAsync');
	        }
	
	        asyncQueue.push({scope: this, fn: $parse(expr), locals: locals});
	      },
	
	      $$postDigest: function(fn) {
	        postDigestQueue.push(fn);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$apply
	       * @kind function
	       *
	       * @description
	       * `$apply()` is used to execute an expression in AngularJS from outside of the AngularJS
	       * framework. (For example from browser DOM events, setTimeout, XHR or third party libraries).
	       * Because we are calling into the AngularJS framework we need to perform proper scope life
	       * cycle of {@link ng.$exceptionHandler exception handling},
	       * {@link ng.$rootScope.Scope#$digest executing watches}.
	       *
	       * **Life cycle: Pseudo-Code of `$apply()`**
	       *
	       * ```js
	           function $apply(expr) {
	             try {
	               return $eval(expr);
	             } catch (e) {
	               $exceptionHandler(e);
	             } finally {
	               $root.$digest();
	             }
	           }
	       * ```
	       *
	       *
	       * Scope's `$apply()` method transitions through the following stages:
	       *
	       * 1. The {@link guide/expression expression} is executed using the
	       *    {@link ng.$rootScope.Scope#$eval $eval()} method.
	       * 2. Any exceptions from the execution of the expression are forwarded to the
	       *    {@link ng.$exceptionHandler $exceptionHandler} service.
	       * 3. The {@link ng.$rootScope.Scope#$watch watch} listeners are fired immediately after the
	       *    expression was executed using the {@link ng.$rootScope.Scope#$digest $digest()} method.
	       *
	       *
	       * @param {(string|function())=} exp An AngularJS expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with current `scope` parameter.
	       *
	       * @returns {*} The result of evaluating the expression.
	       */
	      $apply: function(expr) {
	        try {
	          beginPhase('$apply');
	          try {
	            return this.$eval(expr);
	          } finally {
	            clearPhase();
	          }
	        } catch (e) {
	          $exceptionHandler(e);
	        } finally {
	          try {
	            $rootScope.$digest();
	          } catch (e) {
	            $exceptionHandler(e);
	            // eslint-disable-next-line no-unsafe-finally
	            throw e;
	          }
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$applyAsync
	       * @kind function
	       *
	       * @description
	       * Schedule the invocation of $apply to occur at a later time. The actual time difference
	       * varies across browsers, but is typically around ~10 milliseconds.
	       *
	       * This can be used to queue up multiple expressions which need to be evaluated in the same
	       * digest.
	       *
	       * @param {(string|function())=} exp An AngularJS expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with current `scope` parameter.
	       */
	      $applyAsync: function(expr) {
	        var scope = this;
	        if (expr) {
	          applyAsyncQueue.push($applyAsyncExpression);
	        }
	        expr = $parse(expr);
	        scheduleApplyAsync();
	
	        function $applyAsyncExpression() {
	          scope.$eval(expr);
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$on
	       * @kind function
	       *
	       * @description
	       * Listens on events of a given type. See {@link ng.$rootScope.Scope#$emit $emit} for
	       * discussion of event life cycle.
	       *
	       * The event listener function format is: `function(event, args...)`. The `event` object
	       * passed into the listener has the following attributes:
	       *
	       *   - `targetScope` - `{Scope}`: the scope on which the event was `$emit`-ed or
	       *     `$broadcast`-ed.
	       *   - `currentScope` - `{Scope}`: the scope that is currently handling the event. Once the
	       *     event propagates through the scope hierarchy, this property is set to null.
	       *   - `name` - `{string}`: name of the event.
	       *   - `stopPropagation` - `{function=}`: calling `stopPropagation` function will cancel
	       *     further event propagation (available only for events that were `$emit`-ed).
	       *   - `preventDefault` - `{function}`: calling `preventDefault` sets `defaultPrevented` flag
	       *     to true.
	       *   - `defaultPrevented` - `{boolean}`: true if `preventDefault` was called.
	       *
	       * @param {string} name Event name to listen on.
	       * @param {function(event, ...args)} listener Function to call when the event is emitted.
	       * @returns {function()} Returns a deregistration function for this listener.
	       */
	      $on: function(name, listener) {
	        var namedListeners = this.$$listeners[name];
	        if (!namedListeners) {
	          this.$$listeners[name] = namedListeners = [];
	        }
	        namedListeners.push(listener);
	
	        var current = this;
	        do {
	          if (!current.$$listenerCount[name]) {
	            current.$$listenerCount[name] = 0;
	          }
	          current.$$listenerCount[name]++;
	        } while ((current = current.$parent));
	
	        var self = this;
	        return function() {
	          var indexOfListener = namedListeners.indexOf(listener);
	          if (indexOfListener !== -1) {
	            // Use delete in the hope of the browser deallocating the memory for the array entry,
	            // while not shifting the array indexes of other listeners.
	            // See issue https://github.com/angular/angular.js/issues/16135
	            delete namedListeners[indexOfListener];
	            decrementListenerCount(self, 1, name);
	          }
	        };
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$emit
	       * @kind function
	       *
	       * @description
	       * Dispatches an event `name` upwards through the scope hierarchy notifying the
	       * registered {@link ng.$rootScope.Scope#$on} listeners.
	       *
	       * The event life cycle starts at the scope on which `$emit` was called. All
	       * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
	       * notified. Afterwards, the event traverses upwards toward the root scope and calls all
	       * registered listeners along the way. The event will stop propagating if one of the listeners
	       * cancels it.
	       *
	       * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
	       * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
	       *
	       * @param {string} name Event name to emit.
	       * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
	       * @return {Object} Event object (see {@link ng.$rootScope.Scope#$on}).
	       */
	      $emit: function(name, args) {
	        var empty = [],
	            namedListeners,
	            scope = this,
	            stopPropagation = false,
	            event = {
	              name: name,
	              targetScope: scope,
	              stopPropagation: function() {stopPropagation = true;},
	              preventDefault: function() {
	                event.defaultPrevented = true;
	              },
	              defaultPrevented: false
	            },
	            listenerArgs = concat([event], arguments, 1),
	            i, length;
	
	        do {
	          namedListeners = scope.$$listeners[name] || empty;
	          event.currentScope = scope;
	          for (i = 0, length = namedListeners.length; i < length; i++) {
	
	            // if listeners were deregistered, defragment the array
	            if (!namedListeners[i]) {
	              namedListeners.splice(i, 1);
	              i--;
	              length--;
	              continue;
	            }
	            try {
	              //allow all listeners attached to the current scope to run
	              namedListeners[i].apply(null, listenerArgs);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	          //if any listener on the current scope stops propagation, prevent bubbling
	          if (stopPropagation) {
	            break;
	          }
	          //traverse upwards
	          scope = scope.$parent;
	        } while (scope);
	
	        event.currentScope = null;
	
	        return event;
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$broadcast
	       * @kind function
	       *
	       * @description
	       * Dispatches an event `name` downwards to all child scopes (and their children) notifying the
	       * registered {@link ng.$rootScope.Scope#$on} listeners.
	       *
	       * The event life cycle starts at the scope on which `$broadcast` was called. All
	       * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
	       * notified. Afterwards, the event propagates to all direct and indirect scopes of the current
	       * scope and calls all registered listeners along the way. The event cannot be canceled.
	       *
	       * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
	       * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
	       *
	       * @param {string} name Event name to broadcast.
	       * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
	       * @return {Object} Event object, see {@link ng.$rootScope.Scope#$on}
	       */
	      $broadcast: function(name, args) {
	        var target = this,
	            current = target,
	            next = target,
	            event = {
	              name: name,
	              targetScope: target,
	              preventDefault: function() {
	                event.defaultPrevented = true;
	              },
	              defaultPrevented: false
	            };
	
	        if (!target.$$listenerCount[name]) return event;
	
	        var listenerArgs = concat([event], arguments, 1),
	            listeners, i, length;
	
	        //down while you can, then up and next sibling or up and next sibling until back at root
	        while ((current = next)) {
	          event.currentScope = current;
	          listeners = current.$$listeners[name] || [];
	          for (i = 0, length = listeners.length; i < length; i++) {
	            // if listeners were deregistered, defragment the array
	            if (!listeners[i]) {
	              listeners.splice(i, 1);
	              i--;
	              length--;
	              continue;
	            }
	
	            try {
	              listeners[i].apply(null, listenerArgs);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	
	          // Insanity Warning: scope depth-first traversal
	          // yes, this code is a bit crazy, but it works and we have tests to prove it!
	          // this piece should be kept in sync with the traversal in $digest
	          // (though it differs due to having the extra check for $$listenerCount and
	          // does not check $$suspended)
	          if (!(next = ((current.$$listenerCount[name] && current.$$childHead) ||
	              (current !== target && current.$$nextSibling)))) {
	            while (current !== target && !(next = current.$$nextSibling)) {
	              current = current.$parent;
	            }
	          }
	        }
	
	        event.currentScope = null;
	        return event;
	      }
	    };
	
	    var $rootScope = new Scope();
	
	    //The internal queues. Expose them on the $rootScope for debugging/testing purposes.
	    var asyncQueue = $rootScope.$$asyncQueue = [];
	    var postDigestQueue = $rootScope.$$postDigestQueue = [];
	    var applyAsyncQueue = $rootScope.$$applyAsyncQueue = [];
	
	    var postDigestQueuePosition = 0;
	
	    return $rootScope;
	
	
	    function beginPhase(phase) {
	      if ($rootScope.$$phase) {
	        throw $rootScopeMinErr('inprog', '{0} already in progress', $rootScope.$$phase);
	      }
	
	      $rootScope.$$phase = phase;
	    }
	
	    function clearPhase() {
	      $rootScope.$$phase = null;
	    }
	
	    function incrementWatchersCount(current, count) {
	      do {
	        current.$$watchersCount += count;
	      } while ((current = current.$parent));
	    }
	
	    function decrementListenerCount(current, count, name) {
	      do {
	        current.$$listenerCount[name] -= count;
	
	        if (current.$$listenerCount[name] === 0) {
	          delete current.$$listenerCount[name];
	        }
	      } while ((current = current.$parent));
	    }
	
	    /**
	     * function used as an initial value for watchers.
	     * because it's unique we can easily tell it apart from other values
	     */
	    function initWatchVal() {}
	
	    function flushApplyAsync() {
	      while (applyAsyncQueue.length) {
	        try {
	          applyAsyncQueue.shift()();
	        } catch (e) {
	          $exceptionHandler(e);
	        }
	      }
	      applyAsyncId = null;
	    }
	
	    function scheduleApplyAsync() {
	      if (applyAsyncId === null) {
	        applyAsyncId = $browser.defer(function() {
	          $rootScope.$apply(flushApplyAsync);
	        }, null, '$applyAsync');
	      }
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $rootElement
	 *
	 * @description
	 * The root element of AngularJS application. This is either the element where {@link
	 * ng.directive:ngApp ngApp} was declared or the element passed into
	 * {@link angular.bootstrap}. The element represents the root element of application. It is also the
	 * location where the application's {@link auto.$injector $injector} service gets
	 * published, and can be retrieved using `$rootElement.injector()`.
	 */
	
	
	// the implementation is in angular.bootstrap
	
	/**
	 * @this
	 * @description
	 * Private service to sanitize uris for links and images. Used by $compile and $sanitize.
	 */
	function $$SanitizeUriProvider() {
	
	  var aHrefSanitizationTrustedUrlList = /^\s*(https?|s?ftp|mailto|tel|file):/,
	    imgSrcSanitizationTrustedUrlList = /^\s*((https?|ftp|file|blob):|data:image\/)/;
	
	  /**
	   * @description
	   * Retrieves or overrides the default regular expression that is used for determining trusted safe
	   * urls during a[href] sanitization.
	   *
	   * The sanitization is a security measure aimed at prevent XSS attacks via HTML anchor links.
	   *
	   * Any url due to be assigned to an `a[href]` attribute via interpolation is marked as requiring
	   * the $sce.URL security context. When interpolation occurs a call is made to `$sce.trustAsUrl(url)`
	   * which in turn may call `$$sanitizeUri(url, isMedia)` to sanitize the potentially malicious URL.
	   *
	   * If the URL matches the `aHrefSanitizationTrustedUrlList` regular expression, it is returned unchanged.
	   *
	   * If there is no match the URL is returned prefixed with `'unsafe:'` to ensure that when it is written
	   * to the DOM it is inactive and potentially malicious code will not be executed.
	   *
	   * @param {RegExp=} regexp New regexp to trust urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.aHrefSanitizationTrustedUrlList = function(regexp) {
	    if (isDefined(regexp)) {
	      aHrefSanitizationTrustedUrlList = regexp;
	      return this;
	    }
	    return aHrefSanitizationTrustedUrlList;
	  };
	
	
	  /**
	   * @description
	   * Retrieves or overrides the default regular expression that is used for determining trusted safe
	   * urls during img[src] sanitization.
	   *
	   * The sanitization is a security measure aimed at prevent XSS attacks via HTML image src links.
	   *
	   * Any URL due to be assigned to an `img[src]` attribute via interpolation is marked as requiring
	   * the $sce.MEDIA_URL security context. When interpolation occurs a call is made to
	   * `$sce.trustAsMediaUrl(url)` which in turn may call `$$sanitizeUri(url, isMedia)` to sanitize
	   * the potentially malicious URL.
	   *
	   * If the URL matches the `imgSrcSanitizationTrustedUrlList` regular expression, it is returned
	   * unchanged.
	   *
	   * If there is no match the URL is returned prefixed with `'unsafe:'` to ensure that when it is written
	   * to the DOM it is inactive and potentially malicious code will not be executed.
	   *
	   * @param {RegExp=} regexp New regexp to trust urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.imgSrcSanitizationTrustedUrlList = function(regexp) {
	    if (isDefined(regexp)) {
	      imgSrcSanitizationTrustedUrlList = regexp;
	      return this;
	    }
	    return imgSrcSanitizationTrustedUrlList;
	  };
	
	  this.$get = function() {
	    return function sanitizeUri(uri, isMediaUrl) {
	      // if (!uri) return uri;
	      var regex = isMediaUrl ? imgSrcSanitizationTrustedUrlList : aHrefSanitizationTrustedUrlList;
	      var normalizedVal = urlResolve(uri && uri.trim()).href;
	      if (normalizedVal !== '' && !normalizedVal.match(regex)) {
	        return 'unsafe:' + normalizedVal;
	      }
	      return uri;
	    };
	  };
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	/* exported $SceProvider, $SceDelegateProvider */
	
	var $sceMinErr = minErr('$sce');
	
	var SCE_CONTEXTS = {
	  // HTML is used when there's HTML rendered (e.g. ng-bind-html, iframe srcdoc binding).
	  HTML: 'html',
	
	  // Style statements or stylesheets. Currently unused in AngularJS.
	  CSS: 'css',
	
	  // An URL used in a context where it refers to the source of media, which are not expected to be run
	  // as scripts, such as an image, audio, video, etc.
	  MEDIA_URL: 'mediaUrl',
	
	  // An URL used in a context where it does not refer to a resource that loads code.
	  // A value that can be trusted as a URL can also trusted as a MEDIA_URL.
	  URL: 'url',
	
	  // RESOURCE_URL is a subtype of URL used where the referred-to resource could be interpreted as
	  // code. (e.g. ng-include, script src binding, templateUrl)
	  // A value that can be trusted as a RESOURCE_URL, can also trusted as a URL and a MEDIA_URL.
	  RESOURCE_URL: 'resourceUrl',
	
	  // Script. Currently unused in AngularJS.
	  JS: 'js'
	};
	
	// Helper functions follow.
	
	var UNDERSCORE_LOWERCASE_REGEXP = /_([a-z])/g;
	
	function snakeToCamel(name) {
	  return name
	    .replace(UNDERSCORE_LOWERCASE_REGEXP, fnCamelCaseReplace);
	}
	
	function adjustMatcher(matcher) {
	  if (matcher === 'self') {
	    return matcher;
	  } else if (isString(matcher)) {
	    // Strings match exactly except for 2 wildcards - '*' and '**'.
	    // '*' matches any character except those from the set ':/.?&'.
	    // '**' matches any character (like .* in a RegExp).
	    // More than 2 *'s raises an error as it's ill defined.
	    if (matcher.indexOf('***') > -1) {
	      throw $sceMinErr('iwcard',
	          'Illegal sequence *** in string matcher.  String: {0}', matcher);
	    }
	    matcher = escapeForRegexp(matcher).
	                  replace(/\\\*\\\*/g, '.*').
	                  replace(/\\\*/g, '[^:/.?&;]*');
	    return new RegExp('^' + matcher + '$');
	  } else if (isRegExp(matcher)) {
	    // The only other type of matcher allowed is a Regexp.
	    // Match entire URL / disallow partial matches.
	    // Flags are reset (i.e. no global, ignoreCase or multiline)
	    return new RegExp('^' + matcher.source + '$');
	  } else {
	    throw $sceMinErr('imatcher',
	        'Matchers may only be "self", string patterns or RegExp objects');
	  }
	}
	
	
	function adjustMatchers(matchers) {
	  var adjustedMatchers = [];
	  if (isDefined(matchers)) {
	    forEach(matchers, function(matcher) {
	      adjustedMatchers.push(adjustMatcher(matcher));
	    });
	  }
	  return adjustedMatchers;
	}
	
	
	/**
	 * @ngdoc service
	 * @name $sceDelegate
	 * @kind function
	 *
	 * @description
	 *
	 * `$sceDelegate` is a service that is used by the `$sce` service to provide {@link ng.$sce Strict
	 * Contextual Escaping (SCE)} services to AngularJS.
	 *
	 * For an overview of this service and the functionnality it provides in AngularJS, see the main
	 * page for {@link ng.$sce SCE}. The current page is targeted for developers who need to alter how
	 * SCE works in their application, which shouldn't be needed in most cases.
	 *
	 * <div class="alert alert-danger">
	 * AngularJS strongly relies on contextual escaping for the security of bindings: disabling or
	 * modifying this might cause cross site scripting (XSS) vulnerabilities. For libraries owners,
	 * changes to this service will also influence users, so be extra careful and document your changes.
	 * </div>
	 *
	 * Typically, you would configure or override the {@link ng.$sceDelegate $sceDelegate} instead of
	 * the `$sce` service to customize the way Strict Contextual Escaping works in AngularJS.  This is
	 * because, while the `$sce` provides numerous shorthand methods, etc., you really only need to
	 * override 3 core functions (`trustAs`, `getTrusted` and `valueOf`) to replace the way things
	 * work because `$sce` delegates to `$sceDelegate` for these operations.
	 *
	 * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} to configure this service.
	 *
	 * The default instance of `$sceDelegate` should work out of the box with little pain.  While you
	 * can override it completely to change the behavior of `$sce`, the common case would
	 * involve configuring the {@link ng.$sceDelegateProvider $sceDelegateProvider} instead by setting
	 * your own trusted and banned resource lists for trusting URLs used for loading AngularJS resources
	 * such as templates.  Refer {@link ng.$sceDelegateProvider#trustedResourceUrlList
	 * $sceDelegateProvider.trustedResourceUrlList} and {@link
	 * ng.$sceDelegateProvider#bannedResourceUrlList $sceDelegateProvider.bannedResourceUrlList}
	 */
	
	/**
	 * @ngdoc provider
	 * @name $sceDelegateProvider
	 * @this
	 *
	 * @description
	 *
	 * The `$sceDelegateProvider` provider allows developers to configure the {@link ng.$sceDelegate
	 * $sceDelegate service}, used as a delegate for {@link ng.$sce Strict Contextual Escaping (SCE)}.
	 *
	 * The `$sceDelegateProvider` allows one to get/set the `trustedResourceUrlList` and
	 * `bannedResourceUrlList` used to ensure that the URLs used for sourcing AngularJS templates and
	 * other script-running URLs are safe (all places that use the `$sce.RESOURCE_URL` context). See
	 * {@link ng.$sceDelegateProvider#trustedResourceUrlList
	 * $sceDelegateProvider.trustedResourceUrlList} and
	 * {@link ng.$sceDelegateProvider#bannedResourceUrlList $sceDelegateProvider.bannedResourceUrlList},
	 *
	 * For the general details about this service in AngularJS, read the main page for {@link ng.$sce
	 * Strict Contextual Escaping (SCE)}.
	 *
	 * **Example**:  Consider the following case. <a name="example"></a>
	 *
	 * - your app is hosted at url `http://myapp.example.com/`
	 * - but some of your templates are hosted on other domains you control such as
	 *   `http://srv01.assets.example.com/`, `http://srv02.assets.example.com/`, etc.
	 * - and you have an open redirect at `http://myapp.example.com/clickThru?...`.
	 *
	 * Here is what a secure configuration for this scenario might look like:
	 *
	 * ```
	 *  angular.module('myApp', []).config(function($sceDelegateProvider) {
	 *    $sceDelegateProvider.trustedResourceUrlList([
	 *      // Allow same origin resource loads.
	 *      'self',
	 *      // Allow loading from our assets domain.  Notice the difference between * and **.
	 *      'http://srv*.assets.example.com/**'
	 *    ]);
	 *
	 *    // The banned resource URL list overrides the trusted resource URL list so the open redirect
	 *    // here is blocked.
	 *    $sceDelegateProvider.bannedResourceUrlList([
	 *      'http://myapp.example.com/clickThru**'
	 *    ]);
	 *  });
	 * ```
	 * Note that an empty trusted resource URL list will block every resource URL from being loaded, and will require
	 * you to manually mark each one as trusted with `$sce.trustAsResourceUrl`. However, templates
	 * requested by {@link ng.$templateRequest $templateRequest} that are present in
	 * {@link ng.$templateCache $templateCache} will not go through this check. If you have a mechanism
	 * to populate your templates in that cache at config time, then it is a good idea to remove 'self'
	 * from the trusted resource URL lsit. This helps to mitigate the security impact of certain types
	 * of issues, like for instance attacker-controlled `ng-includes`.
	 */
	
	function $SceDelegateProvider() {
	  this.SCE_CONTEXTS = SCE_CONTEXTS;
	
	  // Resource URLs can also be trusted by policy.
	  var trustedResourceUrlList = ['self'],
	      bannedResourceUrlList = [];
	
	  /**
	   * @ngdoc method
	   * @name $sceDelegateProvider#trustedResourceUrlList
	   * @kind function
	   *
	   * @param {Array=} trustedResourceUrlList When provided, replaces the trustedResourceUrlList with
	   *     the value provided.  This must be an array or null.  A snapshot of this array is used so
	   *     further changes to the array are ignored.
	   *     Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
	   *     allowed in this array.
	   *
	   * @return {Array} The currently set trusted resource URL array.
	   *
	   * @description
	   * Sets/Gets the list trusted of resource URLs.
	   *
	   * The **default value** when no `trustedResourceUrlList` has been explicitly set is `['self']`
	   * allowing only same origin resource requests.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** the default `trustedResourceUrlList` of 'self' is not recommended if your app shares
	   * its origin with other apps! It is a good idea to limit it to only your application's directory.
	   * </div>
	   */
	  this.trustedResourceUrlList = function(value) {
	    if (arguments.length) {
	      trustedResourceUrlList = adjustMatchers(value);
	    }
	    return trustedResourceUrlList;
	  };
	
	  /**
	   * @ngdoc method
	   * @name $sceDelegateProvider#resourceUrlWhitelist
	   * @kind function
	   *
	   * @deprecated
	   * sinceVersion="1.8.1"
	   *
	   * This method is deprecated. Use {@link $sceDelegateProvider#trustedResourceUrlList
	   * trustedResourceUrlList} instead.
	   */
	  Object.defineProperty(this, 'resourceUrlWhitelist', {
	    get: function() {
	      return this.trustedResourceUrlList;
	    },
	    set: function(value) {
	      this.trustedResourceUrlList = value;
	    }
	  });
	
	  /**
	   * @ngdoc method
	   * @name $sceDelegateProvider#bannedResourceUrlList
	   * @kind function
	   *
	   * @param {Array=} bannedResourceUrlList When provided, replaces the `bannedResourceUrlList` with
	   *     the value provided. This must be an array or null. A snapshot of this array is used so
	   *     further changes to the array are ignored.</p><p>
	   *     Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
	   *     allowed in this array.</p><p>
	   *     The typical usage for the `bannedResourceUrlList` is to **block
	   *     [open redirects](http://cwe.mitre.org/data/definitions/601.html)** served by your domain as
	   *     these would otherwise be trusted but actually return content from the redirected domain.
	   *     </p><p>
	   *     Finally, **the banned resource URL list overrides the trusted resource URL list** and has
	   *     the final say.
	   *
	   * @return {Array} The currently set `bannedResourceUrlList` array.
	   *
	   * @description
	   * Sets/Gets the `bannedResourceUrlList` of trusted resource URLs.
	   *
	   * The **default value** when no trusted resource URL list has been explicitly set is the empty
	   * array (i.e. there is no `bannedResourceUrlList`.)
	   */
	  this.bannedResourceUrlList = function(value) {
	    if (arguments.length) {
	      bannedResourceUrlList = adjustMatchers(value);
	    }
	    return bannedResourceUrlList;
	  };
	
	  /**
	   * @ngdoc method
	   * @name $sceDelegateProvider#resourceUrlBlacklist
	   * @kind function
	   *
	   * @deprecated
	   * sinceVersion="1.8.1"
	   *
	   * This method is deprecated. Use {@link $sceDelegateProvider#bannedResourceUrlList
	   * bannedResourceUrlList} instead.
	   */
	  Object.defineProperty(this, 'resourceUrlBlacklist', {
	    get: function() {
	      return this.bannedResourceUrlList;
	    },
	    set: function(value) {
	      this.bannedResourceUrlList = value;
	    }
	  });
	
	  this.$get = ['$injector', '$$sanitizeUri', function($injector, $$sanitizeUri) {
	
	    var htmlSanitizer = function htmlSanitizer(html) {
	      throw $sceMinErr('unsafe', 'Attempting to use an unsafe value in a safe context.');
	    };
	
	    if ($injector.has('$sanitize')) {
	      htmlSanitizer = $injector.get('$sanitize');
	    }
	
	
	    function matchUrl(matcher, parsedUrl) {
	      if (matcher === 'self') {
	        return urlIsSameOrigin(parsedUrl) || urlIsSameOriginAsBaseUrl(parsedUrl);
	      } else {
	        // definitely a regex.  See adjustMatchers()
	        return !!matcher.exec(parsedUrl.href);
	      }
	    }
	
	    function isResourceUrlAllowedByPolicy(url) {
	      var parsedUrl = urlResolve(url.toString());
	      var i, n, allowed = false;
	      // Ensure that at least one item from the trusted resource URL list allows this url.
	      for (i = 0, n = trustedResourceUrlList.length; i < n; i++) {
	        if (matchUrl(trustedResourceUrlList[i], parsedUrl)) {
	          allowed = true;
	          break;
	        }
	      }
	      if (allowed) {
	        // Ensure that no item from the banned resource URL list has blocked this url.
	        for (i = 0, n = bannedResourceUrlList.length; i < n; i++) {
	          if (matchUrl(bannedResourceUrlList[i], parsedUrl)) {
	            allowed = false;
	            break;
	          }
	        }
	      }
	      return allowed;
	    }
	
	    function generateHolderType(Base) {
	      var holderType = function TrustedValueHolderType(trustedValue) {
	        this.$$unwrapTrustedValue = function() {
	          return trustedValue;
	        };
	      };
	      if (Base) {
	        holderType.prototype = new Base();
	      }
	      holderType.prototype.valueOf = function sceValueOf() {
	        return this.$$unwrapTrustedValue();
	      };
	      holderType.prototype.toString = function sceToString() {
	        return this.$$unwrapTrustedValue().toString();
	      };
	      return holderType;
	    }
	
	    var trustedValueHolderBase = generateHolderType(),
	        byType = {};
	
	    byType[SCE_CONTEXTS.HTML] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.CSS] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.MEDIA_URL] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.URL] = generateHolderType(byType[SCE_CONTEXTS.MEDIA_URL]);
	    byType[SCE_CONTEXTS.JS] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.RESOURCE_URL] = generateHolderType(byType[SCE_CONTEXTS.URL]);
	
	    /**
	     * @ngdoc method
	     * @name $sceDelegate#trustAs
	     *
	     * @description
	     * Returns a trusted representation of the parameter for the specified context. This trusted
	     * object will later on be used as-is, without any security check, by bindings or directives
	     * that require this security context.
	     * For instance, marking a string as trusted for the `$sce.HTML` context will entirely bypass
	     * the potential `$sanitize` call in corresponding `$sce.HTML` bindings or directives, such as
	     * `ng-bind-html`. Note that in most cases you won't need to call this function: if you have the
	     * sanitizer loaded, passing the value itself will render all the HTML that does not pose a
	     * security risk.
	     *
	     * See {@link ng.$sceDelegate#getTrusted getTrusted} for the function that will consume those
	     * trusted values, and {@link ng.$sce $sce} for general documentation about strict contextual
	     * escaping.
	     *
	     * @param {string} type The context in which this value is safe for use, e.g. `$sce.URL`,
	     *     `$sce.RESOURCE_URL`, `$sce.HTML`, `$sce.JS` or `$sce.CSS`.
	     *
	     * @param {*} value The value that should be considered trusted.
	     * @return {*} A trusted representation of value, that can be used in the given context.
	     */
	    function trustAs(type, trustedValue) {
	      var Constructor = (byType.hasOwnProperty(type) ? byType[type] : null);
	      if (!Constructor) {
	        throw $sceMinErr('icontext',
	            'Attempted to trust a value in invalid context. Context: {0}; Value: {1}',
	            type, trustedValue);
	      }
	      if (trustedValue === null || isUndefined(trustedValue) || trustedValue === '') {
	        return trustedValue;
	      }
	      // All the current contexts in SCE_CONTEXTS happen to be strings.  In order to avoid trusting
	      // mutable objects, we ensure here that the value passed in is actually a string.
	      if (typeof trustedValue !== 'string') {
	        throw $sceMinErr('itype',
	            'Attempted to trust a non-string value in a content requiring a string: Context: {0}',
	            type);
	      }
	      return new Constructor(trustedValue);
	    }
	
	    /**
	     * @ngdoc method
	     * @name $sceDelegate#valueOf
	     *
	     * @description
	     * If the passed parameter had been returned by a prior call to {@link ng.$sceDelegate#trustAs
	     * `$sceDelegate.trustAs`}, returns the value that had been passed to {@link
	     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}.
	     *
	     * If the passed parameter is not a value that had been returned by {@link
	     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}, it must be returned as-is.
	     *
	     * @param {*} value The result of a prior {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}
	     *     call or anything else.
	     * @return {*} The `value` that was originally provided to {@link ng.$sceDelegate#trustAs
	     *     `$sceDelegate.trustAs`} if `value` is the result of such a call.  Otherwise, returns
	     *     `value` unchanged.
	     */
	    function valueOf(maybeTrusted) {
	      if (maybeTrusted instanceof trustedValueHolderBase) {
	        return maybeTrusted.$$unwrapTrustedValue();
	      } else {
	        return maybeTrusted;
	      }
	    }
	
	    /**
	     * @ngdoc method
	     * @name $sceDelegate#getTrusted
	     *
	     * @description
	     * Given an object and a security context in which to assign it, returns a value that's safe to
	     * use in this context, which was represented by the parameter. To do so, this function either
	     * unwraps the safe type it has been given (for instance, a {@link ng.$sceDelegate#trustAs
	     * `$sceDelegate.trustAs`} result), or it might try to sanitize the value given, depending on
	     * the context and sanitizer availablility.
	     *
	     * The contexts that can be sanitized are $sce.MEDIA_URL, $sce.URL and $sce.HTML. The first two are available
	     * by default, and the third one relies on the `$sanitize` service (which may be loaded through
	     * the `ngSanitize` module). Furthermore, for $sce.RESOURCE_URL context, a plain string may be
	     * accepted if the resource url policy defined by {@link ng.$sceDelegateProvider#trustedResourceUrlList
	     * `$sceDelegateProvider.trustedResourceUrlList`} and {@link ng.$sceDelegateProvider#bannedResourceUrlList
	     * `$sceDelegateProvider.bannedResourceUrlList`} accepts that resource.
	     *
	     * This function will throw if the safe type isn't appropriate for this context, or if the
	     * value given cannot be accepted in the context (which might be caused by sanitization not
	     * being available, or the value not being recognized as safe).
	     *
	     * <div class="alert alert-danger">
	     * Disabling auto-escaping is extremely dangerous, it usually creates a Cross Site Scripting
	     * (XSS) vulnerability in your application.
	     * </div>
	     *
	     * @param {string} type The context in which this value is to be used (such as `$sce.HTML`).
	     * @param {*} maybeTrusted The result of a prior {@link ng.$sceDelegate#trustAs
	     *     `$sceDelegate.trustAs`} call, or anything else (which will not be considered trusted.)
	     * @return {*} A version of the value that's safe to use in the given context, or throws an
	     *     exception if this is impossible.
	     */
	    function getTrusted(type, maybeTrusted) {
	      if (maybeTrusted === null || isUndefined(maybeTrusted) || maybeTrusted === '') {
	        return maybeTrusted;
	      }
	      var constructor = (byType.hasOwnProperty(type) ? byType[type] : null);
	      // If maybeTrusted is a trusted class instance or subclass instance, then unwrap and return
	      // as-is.
	      if (constructor && maybeTrusted instanceof constructor) {
	        return maybeTrusted.$$unwrapTrustedValue();
	      }
	
	      // If maybeTrusted is a trusted class instance but not of the correct trusted type
	      // then unwrap it and allow it to pass through to the rest of the checks
	      if (isFunction(maybeTrusted.$$unwrapTrustedValue)) {
	        maybeTrusted = maybeTrusted.$$unwrapTrustedValue();
	      }
	
	      // If we get here, then we will either sanitize the value or throw an exception.
	      if (type === SCE_CONTEXTS.MEDIA_URL || type === SCE_CONTEXTS.URL) {
	        // we attempt to sanitize non-resource URLs
	        return $$sanitizeUri(maybeTrusted.toString(), type === SCE_CONTEXTS.MEDIA_URL);
	      } else if (type === SCE_CONTEXTS.RESOURCE_URL) {
	        if (isResourceUrlAllowedByPolicy(maybeTrusted)) {
	          return maybeTrusted;
	        } else {
	          throw $sceMinErr('insecurl',
	              'Blocked loading resource from url not allowed by $sceDelegate policy.  URL: {0}',
	              maybeTrusted.toString());
	        }
	      } else if (type === SCE_CONTEXTS.HTML) {
	        // htmlSanitizer throws its own error when no sanitizer is available.
	        return htmlSanitizer(maybeTrusted);
	      }
	      // Default error when the $sce service has no way to make the input safe.
	      throw $sceMinErr('unsafe', 'Attempting to use an unsafe value in a safe context.');
	    }
	
	    return { trustAs: trustAs,
	             getTrusted: getTrusted,
	             valueOf: valueOf };
	  }];
	}
	
	
	/**
	 * @ngdoc provider
	 * @name $sceProvider
	 * @this
	 *
	 * @description
	 *
	 * The $sceProvider provider allows developers to configure the {@link ng.$sce $sce} service.
	 * -   enable/disable Strict Contextual Escaping (SCE) in a module
	 * -   override the default implementation with a custom delegate
	 *
	 * Read more about {@link ng.$sce Strict Contextual Escaping (SCE)}.
	 */
	
	/**
	 * @ngdoc service
	 * @name $sce
	 * @kind function
	 *
	 * @description
	 *
	 * `$sce` is a service that provides Strict Contextual Escaping services to AngularJS.
	 *
	 * ## Strict Contextual Escaping
	 *
	 * Strict Contextual Escaping (SCE) is a mode in which AngularJS constrains bindings to only render
	 * trusted values. Its goal is to assist in writing code in a way that (a) is secure by default, and
	 * (b) makes auditing for security vulnerabilities such as XSS, clickjacking, etc. a lot easier.
	 *
	 * ### Overview
	 *
	 * To systematically block XSS security bugs, AngularJS treats all values as untrusted by default in
	 * HTML or sensitive URL bindings. When binding untrusted values, AngularJS will automatically
	 * run security checks on them (sanitizations, trusted URL resource, depending on context), or throw
	 * when it cannot guarantee the security of the result. That behavior depends strongly on contexts:
	 * HTML can be sanitized, but template URLs cannot, for instance.
	 *
	 * To illustrate this, consider the `ng-bind-html` directive. It renders its value directly as HTML:
	 * we call that the *context*. When given an untrusted input, AngularJS will attempt to sanitize it
	 * before rendering if a sanitizer is available, and throw otherwise. To bypass sanitization and
	 * render the input as-is, you will need to mark it as trusted for that context before attempting
	 * to bind it.
	 *
	 * As of version 1.2, AngularJS ships with SCE enabled by default.
	 *
	 * ### In practice
	 *
	 * Here's an example of a binding in a privileged context:
	 *
	 * ```
	 * <input ng-model="userHtml" aria-label="User input">
	 * <div ng-bind-html="userHtml"></div>
	 * ```
	 *
	 * Notice that `ng-bind-html` is bound to `userHtml` controlled by the user.  With SCE
	 * disabled, this application allows the user to render arbitrary HTML into the DIV, which would
	 * be an XSS security bug. In a more realistic example, one may be rendering user comments, blog
	 * articles, etc. via bindings. (HTML is just one example of a context where rendering user
	 * controlled input creates security vulnerabilities.)
	 *
	 * For the case of HTML, you might use a library, either on the client side, or on the server side,
	 * to sanitize unsafe HTML before binding to the value and rendering it in the document.
	 *
	 * How would you ensure that every place that used these types of bindings was bound to a value that
	 * was sanitized by your library (or returned as safe for rendering by your server?)  How can you
	 * ensure that you didn't accidentally delete the line that sanitized the value, or renamed some
	 * properties/fields and forgot to update the binding to the sanitized value?
	 *
	 * To be secure by default, AngularJS makes sure bindings go through that sanitization, or
	 * any similar validation process, unless there's a good reason to trust the given value in this
	 * context.  That trust is formalized with a function call. This means that as a developer, you
	 * can assume all untrusted bindings are safe. Then, to audit your code for binding security issues,
	 * you just need to ensure the values you mark as trusted indeed are safe - because they were
	 * received from your server, sanitized by your library, etc. You can organize your codebase to
	 * help with this - perhaps allowing only the files in a specific directory to do this.
	 * Ensuring that the internal API exposed by that code doesn't markup arbitrary values as safe then
	 * becomes a more manageable task.
	 *
	 * In the case of AngularJS' SCE service, one uses {@link ng.$sce#trustAs $sce.trustAs}
	 * (and shorthand methods such as {@link ng.$sce#trustAsHtml $sce.trustAsHtml}, etc.) to
	 * build the trusted versions of your values.
	 *
	 * ### How does it work?
	 *
	 * In privileged contexts, directives and code will bind to the result of {@link ng.$sce#getTrusted
	 * $sce.getTrusted(context, value)} rather than to the value directly.  Think of this function as
	 * a way to enforce the required security context in your data sink. Directives use {@link
	 * ng.$sce#parseAs $sce.parseAs} rather than `$parse` to watch attribute bindings, which performs
	 * the {@link ng.$sce#getTrusted $sce.getTrusted} behind the scenes on non-constant literals. Also,
	 * when binding without directives, AngularJS will understand the context of your bindings
	 * automatically.
	 *
	 * As an example, {@link ng.directive:ngBindHtml ngBindHtml} uses {@link
	 * ng.$sce#parseAsHtml $sce.parseAsHtml(binding expression)}.  Here's the actual code (slightly
	 * simplified):
	 *
	 * ```
	 * var ngBindHtmlDirective = ['$sce', function($sce) {
	 *   return function(scope, element, attr) {
	 *     scope.$watch($sce.parseAsHtml(attr.ngBindHtml), function(value) {
	 *       element.html(value || '');
	 *     });
	 *   };
	 * }];
	 * ```
	 *
	 * ### Impact on loading templates
	 *
	 * This applies both to the {@link ng.directive:ngInclude `ng-include`} directive as well as
	 * `templateUrl`'s specified by {@link guide/directive directives}.
	 *
	 * By default, AngularJS only loads templates from the same domain and protocol as the application
	 * document.  This is done by calling {@link ng.$sce#getTrustedResourceUrl
	 * $sce.getTrustedResourceUrl} on the template URL.  To load templates from other domains and/or
	 * protocols, you may either add them to the {@link ng.$sceDelegateProvider#trustedResourceUrlList
	 * trustedResourceUrlList} or {@link ng.$sce#trustAsResourceUrl wrap them} into trusted values.
	 *
	 * *Please note*:
	 * The browser's
	 * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
	 * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
	 * policy apply in addition to this and may further restrict whether the template is successfully
	 * loaded.  This means that without the right CORS policy, loading templates from a different domain
	 * won't work on all browsers.  Also, loading templates from `file://` URL does not work on some
	 * browsers.
	 *
	 * ### This feels like too much overhead
	 *
	 * It's important to remember that SCE only applies to interpolation expressions.
	 *
	 * If your expressions are constant literals, they're automatically trusted and you don't need to
	 * call `$sce.trustAs` on them (e.g.
	 * `<div ng-bind-html="'<b>implicitly trusted</b>'"></div>`) just works (remember to include the
	 * `ngSanitize` module). The `$sceDelegate` will also use the `$sanitize` service if it is available
	 * when binding untrusted values to `$sce.HTML` context.
	 * AngularJS provides an implementation in `angular-sanitize.js`, and if you
	 * wish to use it, you will also need to depend on the {@link ngSanitize `ngSanitize`} module in
	 * your application.
	 *
	 * The included {@link ng.$sceDelegate $sceDelegate} comes with sane defaults to allow you to load
	 * templates in `ng-include` from your application's domain without having to even know about SCE.
	 * It blocks loading templates from other domains or loading templates over http from an https
	 * served document.  You can change these by setting your own custom {@link
	 * ng.$sceDelegateProvider#trustedResourceUrlList trusted resource URL list} and {@link
	 * ng.$sceDelegateProvider#bannedResourceUrlList banned resource URL list} for matching such URLs.
	 *
	 * This significantly reduces the overhead.  It is far easier to pay the small overhead and have an
	 * application that's secure and can be audited to verify that with much more ease than bolting
	 * security onto an application later.
	 *
	 * <a name="contexts"></a>
	 * ### What trusted context types are supported?
	 *
	 * | Context             | Notes          |
	 * |---------------------|----------------|
	 * | `$sce.HTML`         | For HTML that's safe to source into the application.  The {@link ng.directive:ngBindHtml ngBindHtml} directive uses this context for bindings. If an unsafe value is encountered and the {@link ngSanitize $sanitize} module is present this will sanitize the value instead of throwing an error. |
	 * | `$sce.CSS`          | For CSS that's safe to source into the application.  Currently unused.  Feel free to use it in your own directives. |
	 * | `$sce.MEDIA_URL`    | For URLs that are safe to render as media. Is automatically converted from string by sanitizing when needed. |
	 * | `$sce.URL`          | For URLs that are safe to follow as links. Is automatically converted from string by sanitizing when needed. Note that `$sce.URL` makes a stronger statement about the URL than `$sce.MEDIA_URL` does and therefore contexts requiring values trusted for `$sce.URL` can be used anywhere that values trusted for `$sce.MEDIA_URL` are required.|
	 * | `$sce.RESOURCE_URL` | For URLs that are not only safe to follow as links, but whose contents are also safe to include in your application.  Examples include `ng-include`, `src` / `ngSrc` bindings for tags other than `IMG` (e.g. `IFRAME`, `OBJECT`, etc.)  <br><br>Note that `$sce.RESOURCE_URL` makes a stronger statement about the URL than `$sce.URL` or `$sce.MEDIA_URL` do and therefore contexts requiring values trusted for `$sce.RESOURCE_URL` can be used anywhere that values trusted for `$sce.URL` or `$sce.MEDIA_URL` are required. <br><br> The {@link $sceDelegateProvider#trustedResourceUrlList $sceDelegateProvider#trustedResourceUrlList()} and {@link $sceDelegateProvider#bannedResourceUrlList $sceDelegateProvider#bannedResourceUrlList()} can be used to restrict trusted origins for `RESOURCE_URL` |
	 * | `$sce.JS`           | For JavaScript that is safe to execute in your application's context.  Currently unused.  Feel free to use it in your own directives. |
	 *
	 *
	 * <div class="alert alert-warning">
	 * Be aware that, before AngularJS 1.7.0, `a[href]` and `img[src]` used to sanitize their
	 * interpolated values directly rather than rely upon {@link ng.$sce#getTrusted `$sce.getTrusted`}.
	 *
	 * **As of 1.7.0, this is no longer the case.**
	 *
	 * Now such interpolations are marked as requiring `$sce.URL` (for `a[href]`) or `$sce.MEDIA_URL`
	 * (for `img[src]`), so that the sanitization happens (via `$sce.getTrusted...`) when the `$interpolate`
	 * service evaluates the expressions.
	 * </div>
	 *
	 * There are no CSS or JS context bindings in AngularJS currently, so their corresponding `$sce.trustAs`
	 * functions aren't useful yet. This might evolve.
	 *
	 * ### Format of items in {@link ng.$sceDelegateProvider#trustedResourceUrlList trustedResourceUrlList}/{@link ng.$sceDelegateProvider#bannedResourceUrlList bannedResourceUrlList} <a name="resourceUrlPatternItem"></a>
	 *
	 *  Each element in these arrays must be one of the following:
	 *
	 *  - **'self'**
	 *    - The special **string**, `'self'`, can be used to match against all URLs of the **same
	 *      domain** as the application document using the **same protocol**.
	 *  - **String** (except the special value `'self'`)
	 *    - The string is matched against the full *normalized / absolute URL* of the resource
	 *      being tested (substring matches are not good enough.)
	 *    - There are exactly **two wildcard sequences** - `*` and `**`.  All other characters
	 *      match themselves.
	 *    - `*`: matches zero or more occurrences of any character other than one of the following 6
	 *      characters: '`:`', '`/`', '`.`', '`?`', '`&`' and '`;`'.  It's a useful wildcard for use
	 *      for matching resource URL lists.
	 *    - `**`: matches zero or more occurrences of *any* character.  As such, it's not
	 *      appropriate for use in a scheme, domain, etc. as it would match too much.  (e.g.
	 *      http://**.example.com/ would match http://evil.com/?ignore=.example.com/ and that might
	 *      not have been the intention.)  Its usage at the very end of the path is ok.  (e.g.
	 *      http://foo.example.com/templates/**).
	 *  - **RegExp** (*see caveat below*)
	 *    - *Caveat*:  While regular expressions are powerful and offer great flexibility,  their syntax
	 *      (and all the inevitable escaping) makes them *harder to maintain*.  It's easy to
	 *      accidentally introduce a bug when one updates a complex expression (imho, all regexes should
	 *      have good test coverage).  For instance, the use of `.` in the regex is correct only in a
	 *      small number of cases.  A `.` character in the regex used when matching the scheme or a
	 *      subdomain could be matched against a `:` or literal `.` that was likely not intended.   It
	 *      is highly recommended to use the string patterns and only fall back to regular expressions
	 *      as a last resort.
	 *    - The regular expression must be an instance of RegExp (i.e. not a string.)  It is
	 *      matched against the **entire** *normalized / absolute URL* of the resource being tested
	 *      (even when the RegExp did not have the `^` and `$` codes.)  In addition, any flags
	 *      present on the RegExp (such as multiline, global, ignoreCase) are ignored.
	 *    - If you are generating your JavaScript from some other templating engine (not
	 *      recommended, e.g. in issue [#4006](https://github.com/angular/angular.js/issues/4006)),
	 *      remember to escape your regular expression (and be aware that you might need more than
	 *      one level of escaping depending on your templating engine and the way you interpolated
	 *      the value.)  Do make use of your platform's escaping mechanism as it might be good
	 *      enough before coding your own.  E.g. Ruby has
	 *      [Regexp.escape(str)](http://www.ruby-doc.org/core-2.0.0/Regexp.html#method-c-escape)
	 *      and Python has [re.escape](http://docs.python.org/library/re.html#re.escape).
	 *      Javascript lacks a similar built in function for escaping.  Take a look at Google
	 *      Closure library's [goog.string.regExpEscape(s)](
	 *      http://docs.closure-library.googlecode.com/git/closure_goog_string_string.js.source.html#line962).
	 *
	 * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} for an example.
	 *
	 * ### Show me an example using SCE.
	 *
	 * <example module="mySceApp" deps="angular-sanitize.js" name="sce-service">
	 * <file name="index.html">
	 *   <div ng-controller="AppController as myCtrl">
	 *     <i ng-bind-html="myCtrl.explicitlyTrustedHtml" id="explicitlyTrustedHtml"></i><br><br>
	 *     <b>User comments</b><br>
	 *     By default, HTML that isn't explicitly trusted (e.g. Alice's comment) is sanitized when
	 *     $sanitize is available.  If $sanitize isn't available, this results in an error instead of an
	 *     exploit.
	 *     <div class="well">
	 *       <div ng-repeat="userComment in myCtrl.userComments">
	 *         <b>{{userComment.name}}</b>:
	 *         <span ng-bind-html="userComment.htmlComment" class="htmlComment"></span>
	 *         <br>
	 *       </div>
	 *     </div>
	 *   </div>
	 * </file>
	 *
	 * <file name="script.js">
	 *   angular.module('mySceApp', ['ngSanitize'])
	 *     .controller('AppController', ['$http', '$templateCache', '$sce',
	 *       function AppController($http, $templateCache, $sce) {
	 *         var self = this;
	 *         $http.get('test_data.json', {cache: $templateCache}).then(function(response) {
	 *           self.userComments = response.data;
	 *         });
	 *         self.explicitlyTrustedHtml = $sce.trustAsHtml(
	 *             '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
	 *             'sanitization.&quot;">Hover over this text.</span>');
	 *       }]);
	 * </file>
	 *
	 * <file name="test_data.json">
	 * [
	 *   { "name": "Alice",
	 *     "htmlComment":
	 *         "<span onmouseover='this.textContent=\"PWN3D!\"'>Is <i>anyone</i> reading this?</span>"
	 *   },
	 *   { "name": "Bob",
	 *     "htmlComment": "<i>Yes!</i>  Am I the only other one?"
	 *   }
	 * ]
	 * </file>
	 *
	 * <file name="protractor.js" type="protractor">
	 *   describe('SCE doc demo', function() {
	 *     it('should sanitize untrusted values', function() {
	 *       expect(element.all(by.css('.htmlComment')).first().getAttribute('innerHTML'))
	 *           .toBe('<span>Is <i>anyone</i> reading this?</span>');
	 *     });
	 *
	 *     it('should NOT sanitize explicitly trusted values', function() {
	 *       expect(element(by.id('explicitlyTrustedHtml')).getAttribute('innerHTML')).toBe(
	 *           '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
	 *           'sanitization.&quot;">Hover over this text.</span>');
	 *     });
	 *   });
	 * </file>
	 * </example>
	 *
	 *
	 *
	 * ## Can I disable SCE completely?
	 *
	 * Yes, you can.  However, this is strongly discouraged.  SCE gives you a lot of security benefits
	 * for little coding overhead.  It will be much harder to take an SCE disabled application and
	 * either secure it on your own or enable SCE at a later stage.  It might make sense to disable SCE
	 * for cases where you have a lot of existing code that was written before SCE was introduced and
	 * you're migrating them a module at a time. Also do note that this is an app-wide setting, so if
	 * you are writing a library, you will cause security bugs applications using it.
	 *
	 * That said, here's how you can completely disable SCE:
	 *
	 * ```
	 * angular.module('myAppWithSceDisabledmyApp', []).config(function($sceProvider) {
	 *   // Completely disable SCE.  For demonstration purposes only!
	 *   // Do not use in new projects or libraries.
	 *   $sceProvider.enabled(false);
	 * });
	 * ```
	 *
	 */
	
	function $SceProvider() {
	  var enabled = true;
	
	  /**
	   * @ngdoc method
	   * @name $sceProvider#enabled
	   * @kind function
	   *
	   * @param {boolean=} value If provided, then enables/disables SCE application-wide.
	   * @return {boolean} True if SCE is enabled, false otherwise.
	   *
	   * @description
	   * Enables/disables SCE and returns the current value.
	   */
	  this.enabled = function(value) {
	    if (arguments.length) {
	      enabled = !!value;
	    }
	    return enabled;
	  };
	
	
	  /* Design notes on the default implementation for SCE.
	   *
	   * The API contract for the SCE delegate
	   * -------------------------------------
	   * The SCE delegate object must provide the following 3 methods:
	   *
	   * - trustAs(contextEnum, value)
	   *     This method is used to tell the SCE service that the provided value is OK to use in the
	   *     contexts specified by contextEnum.  It must return an object that will be accepted by
	   *     getTrusted() for a compatible contextEnum and return this value.
	   *
	   * - valueOf(value)
	   *     For values that were not produced by trustAs(), return them as is.  For values that were
	   *     produced by trustAs(), return the corresponding input value to trustAs.  Basically, if
	   *     trustAs is wrapping the given values into some type, this operation unwraps it when given
	   *     such a value.
	   *
	   * - getTrusted(contextEnum, value)
	   *     This function should return the value that is safe to use in the context specified by
	   *     contextEnum or throw and exception otherwise.
	   *
	   * NOTE: This contract deliberately does NOT state that values returned by trustAs() must be
	   * opaque or wrapped in some holder object.  That happens to be an implementation detail.  For
	   * instance, an implementation could maintain a registry of all trusted objects by context.  In
	   * such a case, trustAs() would return the same object that was passed in.  getTrusted() would
	   * return the same object passed in if it was found in the registry under a compatible context or
	   * throw an exception otherwise.  An implementation might only wrap values some of the time based
	   * on some criteria.  getTrusted() might return a value and not throw an exception for special
	   * constants or objects even if not wrapped.  All such implementations fulfill this contract.
	   *
	   *
	   * A note on the inheritance model for SCE contexts
	   * ------------------------------------------------
	   * I've used inheritance and made RESOURCE_URL wrapped types a subtype of URL wrapped types.  This
	   * is purely an implementation details.
	   *
	   * The contract is simply this:
	   *
	   *     getTrusted($sce.RESOURCE_URL, value) succeeding implies that getTrusted($sce.URL, value)
	   *     will also succeed.
	   *
	   * Inheritance happens to capture this in a natural way. In some future, we may not use
	   * inheritance anymore. That is OK because no code outside of sce.js and sceSpecs.js would need to
	   * be aware of this detail.
	   */
	
	  this.$get = ['$parse', '$sceDelegate', function(
	                $parse,   $sceDelegate) {
	    // Support: IE 9-11 only
	    // Prereq: Ensure that we're not running in IE<11 quirks mode.  In that mode, IE < 11 allow
	    // the "expression(javascript expression)" syntax which is insecure.
	    if (enabled && msie < 8) {
	      throw $sceMinErr('iequirks',
	        'Strict Contextual Escaping does not support Internet Explorer version < 11 in quirks ' +
	        'mode.  You can fix this by adding the text <!doctype html> to the top of your HTML ' +
	        'document.  See http://docs.angularjs.org/api/ng.$sce for more information.');
	    }
	
	    var sce = shallowCopy(SCE_CONTEXTS);
	
	    /**
	     * @ngdoc method
	     * @name $sce#isEnabled
	     * @kind function
	     *
	     * @return {Boolean} True if SCE is enabled, false otherwise.  If you want to set the value, you
	     *     have to do it at module config time on {@link ng.$sceProvider $sceProvider}.
	     *
	     * @description
	     * Returns a boolean indicating if SCE is enabled.
	     */
	    sce.isEnabled = function() {
	      return enabled;
	    };
	    sce.trustAs = $sceDelegate.trustAs;
	    sce.getTrusted = $sceDelegate.getTrusted;
	    sce.valueOf = $sceDelegate.valueOf;
	
	    if (!enabled) {
	      sce.trustAs = sce.getTrusted = function(type, value) { return value; };
	      sce.valueOf = identity;
	    }
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAs
	     *
	     * @description
	     * Converts AngularJS {@link guide/expression expression} into a function.  This is like {@link
	     * ng.$parse $parse} and is identical when the expression is a literal constant.  Otherwise, it
	     * wraps the expression in a call to {@link ng.$sce#getTrusted $sce.getTrusted(*type*,
	     * *result*)}
	     *
	     * @param {string} type The SCE context in which this result will be used.
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	    sce.parseAs = function sceParseAs(type, expr) {
	      var parsed = $parse(expr);
	      if (parsed.literal && parsed.constant) {
	        return parsed;
	      } else {
	        return $parse(expr, function(value) {
	          return sce.getTrusted(type, value);
	        });
	      }
	    };
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAs
	     *
	     * @description
	     * Delegates to {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}. As such, returns a
	     * wrapped object that represents your value, and the trust you have in its safety for the given
	     * context. AngularJS can then use that value as-is in bindings of the specified secure context.
	     * This is used in bindings for `ng-bind-html`, `ng-include`, and most `src` attribute
	     * interpolations. See {@link ng.$sce $sce} for strict contextual escaping.
	     *
	     * @param {string} type The context in which this value is safe for use, e.g. `$sce.URL`,
	     *     `$sce.RESOURCE_URL`, `$sce.HTML`, `$sce.JS` or `$sce.CSS`.
	     *
	     * @param {*} value The value that that should be considered trusted.
	     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
	     *     in the context you specified.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsHtml
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsHtml(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.HTML, value)`}
	     *
	     * @param {*} value The value to mark as trusted for `$sce.HTML` context.
	     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
	     *     in `$sce.HTML` context (like `ng-bind-html`).
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsCss
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsCss(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.CSS, value)`}
	     *
	     * @param {*} value The value to mark as trusted for `$sce.CSS` context.
	     * @return {*} A wrapped version of value that can be used as a trusted variant
	     *     of your `value` in `$sce.CSS` context. This context is currently unused, so there are
	     *     almost no reasons to use this function so far.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsUrl(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.URL, value)`}
	     *
	     * @param {*} value The value to mark as trusted for `$sce.URL` context.
	     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
	     *     in `$sce.URL` context. That context is currently unused, so there are almost no reasons
	     *     to use this function so far.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsResourceUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsResourceUrl(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.RESOURCE_URL, value)`}
	     *
	     * @param {*} value The value to mark as trusted for `$sce.RESOURCE_URL` context.
	     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
	     *     in `$sce.RESOURCE_URL` context (template URLs in `ng-include`, most `src` attribute
	     *     bindings, ...)
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsJs
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsJs(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.JS, value)`}
	     *
	     * @param {*} value The value to mark as trusted for `$sce.JS` context.
	     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
	     *     in `$sce.JS` context. That context is currently unused, so there are almost no reasons to
	     *     use this function so far.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrusted
	     *
	     * @description
	     * Delegates to {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted`}.  As such,
	     * takes any input, and either returns a value that's safe to use in the specified context,
	     * or throws an exception. This function is aware of trusted values created by the `trustAs`
	     * function and its shorthands, and when contexts are appropriate, returns the unwrapped value
	     * as-is. Finally, this function can also throw when there is no way to turn `maybeTrusted` in a
	     * safe value (e.g., no sanitization is available or possible.)
	     *
	     * @param {string} type The context in which this value is to be used.
	     * @param {*} maybeTrusted The result of a prior {@link ng.$sce#trustAs
	     *     `$sce.trustAs`} call, or anything else (which will not be considered trusted.)
	     * @return {*} A version of the value that's safe to use in the given context, or throws an
	     *     exception if this is impossible.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedHtml
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedHtml(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.HTML, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @return {*} The return value of `$sce.getTrusted($sce.HTML, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedCss
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedCss(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.CSS, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @return {*} The return value of `$sce.getTrusted($sce.CSS, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedUrl(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.URL, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @return {*} The return value of `$sce.getTrusted($sce.URL, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedResourceUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedResourceUrl(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.RESOURCE_URL, value)`}
	     *
	     * @param {*} value The value to pass to `$sceDelegate.getTrusted`.
	     * @return {*} The return value of `$sce.getTrusted($sce.RESOURCE_URL, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedJs
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedJs(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.JS, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @return {*} The return value of `$sce.getTrusted($sce.JS, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsHtml
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsHtml(expression string)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.HTML, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsCss
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsCss(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.CSS, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsUrl(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.URL, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsResourceUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsResourceUrl(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.RESOURCE_URL, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsJs
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsJs(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.JS, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	
	    // Shorthand delegations.
	    var parse = sce.parseAs,
	        getTrusted = sce.getTrusted,
	        trustAs = sce.trustAs;
	
	    forEach(SCE_CONTEXTS, function(enumValue, name) {
	      var lName = lowercase(name);
	      sce[snakeToCamel('parse_as_' + lName)] = function(expr) {
	        return parse(enumValue, expr);
	      };
	      sce[snakeToCamel('get_trusted_' + lName)] = function(value) {
	        return getTrusted(enumValue, value);
	      };
	      sce[snakeToCamel('trust_as_' + lName)] = function(value) {
	        return trustAs(enumValue, value);
	      };
	    });
	
	    return sce;
	  }];
	}
	
	/* exported $SnifferProvider */
	
	/**
	 * !!! This is an undocumented "private" service !!!
	 *
	 * @name $sniffer
	 * @requires $window
	 * @requires $document
	 * @this
	 *
	 * @property {boolean} history Does the browser support html5 history api ?
	 * @property {boolean} transitions Does the browser support CSS transition events ?
	 * @property {boolean} animations Does the browser support CSS animation events ?
	 *
	 * @description
	 * This is very simple implementation of testing browser's features.
	 */
	function $SnifferProvider() {
	  this.$get = ['$window', '$document', function($window, $document) {
	    var eventSupport = {},
	        // Chrome Packaged Apps are not allowed to access `history.pushState`.
	        // If not sandboxed, they can be detected by the presence of `chrome.app.runtime`
	        // (see https://developer.chrome.com/apps/api_index). If sandboxed, they can be detected by
	        // the presence of an extension runtime ID and the absence of other Chrome runtime APIs
	        // (see https://developer.chrome.com/apps/manifest/sandbox).
	        // (NW.js apps have access to Chrome APIs, but do support `history`.)
	        isNw = $window.nw && $window.nw.process,
	        isChromePackagedApp =
	            !isNw &&
	            $window.chrome &&
	            ($window.chrome.app && $window.chrome.app.runtime ||
	                !$window.chrome.app && $window.chrome.runtime && $window.chrome.runtime.id),
	        hasHistoryPushState = !isChromePackagedApp && $window.history && $window.history.pushState,
	        android =
	          toInt((/android (\d+)/.exec(lowercase(($window.navigator || {}).userAgent)) || [])[1]),
	        boxee = /Boxee/i.test(($window.navigator || {}).userAgent),
	        document = $document[0] || {},
	        bodyStyle = document.body && document.body.style,
	        transitions = false,
	        animations = false;
	
	    if (bodyStyle) {
	      // Support: Android <5, Blackberry Browser 10, default Chrome in Android 4.4.x
	      // Mentioned browsers need a -webkit- prefix for transitions & animations.
	      transitions = !!('transition' in bodyStyle || 'webkitTransition' in bodyStyle);
	      animations = !!('animation' in bodyStyle || 'webkitAnimation' in bodyStyle);
	    }
	
	
	    return {
	      // Android has history.pushState, but it does not update location correctly
	      // so let's not use the history API at all.
	      // http://code.google.com/p/android/issues/detail?id=17471
	      // https://github.com/angular/angular.js/issues/904
	
	      // older webkit browser (533.9) on Boxee box has exactly the same problem as Android has
	      // so let's not use the history API also
	      // We are purposefully using `!(android < 4)` to cover the case when `android` is undefined
	      history: !!(hasHistoryPushState && !(android < 4) && !boxee),
	      hasEvent: function(event) {
	        // Support: IE 9-11 only
	        // IE9 implements 'input' event it's so fubared that we rather pretend that it doesn't have
	        // it. In particular the event is not fired when backspace or delete key are pressed or
	        // when cut operation is performed.
	        // IE10+ implements 'input' event but it erroneously fires under various situations,
	        // e.g. when placeholder changes, or a form is focused.
	        if (event === 'input' && msie) return false;
	
	        if (isUndefined(eventSupport[event])) {
	          var divElm = document.createElement('div');
	          eventSupport[event] = 'on' + event in divElm;
	        }
	
	        return eventSupport[event];
	      },
	      csp: csp(),
	      transitions: transitions,
	      animations: animations,
	      android: android
	    };
	  }];
	}
	
	/**
	 * ! This is a private undocumented service !
	 *
	 * @name $$taskTrackerFactory
	 * @description
	 * A function to create `TaskTracker` instances.
	 *
	 * A `TaskTracker` can keep track of pending tasks (grouped by type) and can notify interested
	 * parties when all pending tasks (or tasks of a specific type) have been completed.
	 *
	 * @param {$log} log - A logger instance (such as `$log`). Used to log error during callback
	 *     execution.
	 *
	 * @this
	 */
	function $$TaskTrackerFactoryProvider() {
	  this.$get = valueFn(function(log) { return new TaskTracker(log); });
	}
	
	function TaskTracker(log) {
	  var self = this;
	  var taskCounts = {};
	  var taskCallbacks = [];
	
	  var ALL_TASKS_TYPE = self.ALL_TASKS_TYPE = '$$all$$';
	  var DEFAULT_TASK_TYPE = self.DEFAULT_TASK_TYPE = '$$default$$';
	
	  /**
	   * Execute the specified function and decrement the appropriate `taskCounts` counter.
	   * If the counter reaches 0, all corresponding `taskCallbacks` are executed.
	   *
	   * @param {Function} fn - The function to execute.
	   * @param {string=} [taskType=DEFAULT_TASK_TYPE] - The type of task that is being completed.
	   */
	  self.completeTask = completeTask;
	
	  /**
	   * Increase the task count for the specified task type (or the default task type if non is
	   * specified).
	   *
	   * @param {string=} [taskType=DEFAULT_TASK_TYPE] - The type of task whose count will be increased.
	   */
	  self.incTaskCount = incTaskCount;
	
	  /**
	   * Execute the specified callback when all pending tasks have been completed.
	   *
	   * If there are no pending tasks, the callback is executed immediately. You can optionally limit
	   * the tasks that will be waited for to a specific type, by passing a `taskType`.
	   *
	   * @param {function} callback - The function to call when there are no pending tasks.
	   * @param {string=} [taskType=ALL_TASKS_TYPE] - The type of tasks that will be waited for.
	   */
	  self.notifyWhenNoPendingTasks = notifyWhenNoPendingTasks;
	
	  function completeTask(fn, taskType) {
	    taskType = taskType || DEFAULT_TASK_TYPE;
	
	    try {
	      fn();
	    } finally {
	      decTaskCount(taskType);
	
	      var countForType = taskCounts[taskType];
	      var countForAll = taskCounts[ALL_TASKS_TYPE];
	
	      // If at least one of the queues (`ALL_TASKS_TYPE` or `taskType`) is empty, run callbacks.
	      if (!countForAll || !countForType) {
	        var getNextCallback = !countForAll ? getLastCallback : getLastCallbackForType;
	        var nextCb;
	
	        while ((nextCb = getNextCallback(taskType))) {
	          try {
	            nextCb();
	          } catch (e) {
	            log.error(e);
	          }
	        }
	      }
	    }
	  }
	
	  function decTaskCount(taskType) {
	    taskType = taskType || DEFAULT_TASK_TYPE;
	    if (taskCounts[taskType]) {
	      taskCounts[taskType]--;
	      taskCounts[ALL_TASKS_TYPE]--;
	    }
	  }
	
	  function getLastCallback() {
	    var cbInfo = taskCallbacks.pop();
	    return cbInfo && cbInfo.cb;
	  }
	
	  function getLastCallbackForType(taskType) {
	    for (var i = taskCallbacks.length - 1; i >= 0; --i) {
	      var cbInfo = taskCallbacks[i];
	      if (cbInfo.type === taskType) {
	        taskCallbacks.splice(i, 1);
	        return cbInfo.cb;
	      }
	    }
	  }
	
	  function incTaskCount(taskType) {
	    taskType = taskType || DEFAULT_TASK_TYPE;
	    taskCounts[taskType] = (taskCounts[taskType] || 0) + 1;
	    taskCounts[ALL_TASKS_TYPE] = (taskCounts[ALL_TASKS_TYPE] || 0) + 1;
	  }
	
	  function notifyWhenNoPendingTasks(callback, taskType) {
	    taskType = taskType || ALL_TASKS_TYPE;
	    if (!taskCounts[taskType]) {
	      callback();
	    } else {
	      taskCallbacks.push({type: taskType, cb: callback});
	    }
	  }
	}
	
	var $templateRequestMinErr = minErr('$templateRequest');
	
	/**
	 * @ngdoc provider
	 * @name $templateRequestProvider
	 * @this
	 *
	 * @description
	 * Used to configure the options passed to the {@link $http} service when making a template request.
	 *
	 * For example, it can be used for specifying the "Accept" header that is sent to the server, when
	 * requesting a template.
	 */
	function $TemplateRequestProvider() {
	
	  var httpOptions;
	
	  /**
	   * @ngdoc method
	   * @name $templateRequestProvider#httpOptions
	   * @description
	   * The options to be passed to the {@link $http} service when making the request.
	   * You can use this to override options such as the "Accept" header for template requests.
	   *
	   * The {@link $templateRequest} will set the `cache` and the `transformResponse` properties of the
	   * options if not overridden here.
	   *
	   * @param {string=} value new value for the {@link $http} options.
	   * @returns {string|self} Returns the {@link $http} options when used as getter and self if used as setter.
	   */
	  this.httpOptions = function(val) {
	    if (val) {
	      httpOptions = val;
	      return this;
	    }
	    return httpOptions;
	  };
	
	  /**
	   * @ngdoc service
	   * @name $templateRequest
	   *
	   * @description
	   * The `$templateRequest` service runs security checks then downloads the provided template using
	   * `$http` and, upon success, stores the contents inside of `$templateCache`. If the HTTP request
	   * fails or the response data of the HTTP request is empty, a `$compile` error will be thrown (the
	   * exception can be thwarted by setting the 2nd parameter of the function to true). Note that the
	   * contents of `$templateCache` are trusted, so the call to `$sce.getTrustedUrl(tpl)` is omitted
	   * when `tpl` is of type string and `$templateCache` has the matching entry.
	   *
	   * If you want to pass custom options to the `$http` service, such as setting the Accept header you
	   * can configure this via {@link $templateRequestProvider#httpOptions}.
	   *
	   * `$templateRequest` is used internally by {@link $compile}, {@link ngRoute.$route}, and directives such
	   * as {@link ngInclude} to download and cache templates.
	   *
	   * 3rd party modules should use `$templateRequest` if their services or directives are loading
	   * templates.
	   *
	   * @param {string|TrustedResourceUrl} tpl The HTTP request template URL
	   * @param {boolean=} ignoreRequestError Whether or not to ignore the exception when the request fails or the template is empty
	   *
	   * @return {Promise} a promise for the HTTP response data of the given URL.
	   *
	   * @property {number} totalPendingRequests total amount of pending template requests being downloaded.
	   */
	  this.$get = ['$exceptionHandler', '$templateCache', '$http', '$q', '$sce',
	    function($exceptionHandler, $templateCache, $http, $q, $sce) {
	
	      function handleRequestFn(tpl, ignoreRequestError) {
	        handleRequestFn.totalPendingRequests++;
	
	        // We consider the template cache holds only trusted templates, so
	        // there's no need to go through adding the template again to the trusted
	        // resources for keys that already are included in there. This also makes
	        // AngularJS accept any script directive, no matter its name. However, we
	        // still need to unwrap trusted types.
	        if (!isString(tpl) || isUndefined($templateCache.get(tpl))) {
	          tpl = $sce.getTrustedResourceUrl(tpl);
	        }
	
	        var transformResponse = $http.defaults && $http.defaults.transformResponse;
	
	        if (isArray(transformResponse)) {
	          transformResponse = transformResponse.filter(function(transformer) {
	            return transformer !== defaultHttpResponseTransform;
	          });
	        } else if (transformResponse === defaultHttpResponseTransform) {
	          transformResponse = null;
	        }
	
	        return $http.get(tpl, extend({
	            cache: $templateCache,
	            transformResponse: transformResponse
	          }, httpOptions))
	          .finally(function() {
	            handleRequestFn.totalPendingRequests--;
	          })
	          .then(function(response) {
	            return $templateCache.put(tpl, response.data);
	          }, handleError);
	
	        function handleError(resp) {
	          if (!ignoreRequestError) {
	            resp = $templateRequestMinErr('tpload',
	                'Failed to load template: {0} (HTTP status: {1} {2})',
	                tpl, resp.status, resp.statusText);
	
	            $exceptionHandler(resp);
	          }
	
	          return $q.reject(resp);
	        }
	      }
	
	      handleRequestFn.totalPendingRequests = 0;
	
	      return handleRequestFn;
	    }
	  ];
	}
	
	/** @this */
	function $$TestabilityProvider() {
	  this.$get = ['$rootScope', '$browser', '$location',
	       function($rootScope,   $browser,   $location) {
	
	    /**
	     * @name $testability
	     *
	     * @description
	     * The private $$testability service provides a collection of methods for use when debugging
	     * or by automated test and debugging tools.
	     */
	    var testability = {};
	
	    /**
	     * @name $$testability#findBindings
	     *
	     * @description
	     * Returns an array of elements that are bound (via ng-bind or {{}})
	     * to expressions matching the input.
	     *
	     * @param {Element} element The element root to search from.
	     * @param {string} expression The binding expression to match.
	     * @param {boolean} opt_exactMatch If true, only returns exact matches
	     *     for the expression. Filters and whitespace are ignored.
	     */
	    testability.findBindings = function(element, expression, opt_exactMatch) {
	      var bindings = element.getElementsByClassName('ng-binding');
	      var matches = [];
	      forEach(bindings, function(binding) {
	        var dataBinding = angular.element(binding).data('$binding');
	        if (dataBinding) {
	          forEach(dataBinding, function(bindingName) {
	            if (opt_exactMatch) {
	              var matcher = new RegExp('(^|\\s)' + escapeForRegexp(expression) + '(\\s|\\||$)');
	              if (matcher.test(bindingName)) {
	                matches.push(binding);
	              }
	            } else {
	              if (bindingName.indexOf(expression) !== -1) {
	                matches.push(binding);
	              }
	            }
	          });
	        }
	      });
	      return matches;
	    };
	
	    /**
	     * @name $$testability#findModels
	     *
	     * @description
	     * Returns an array of elements that are two-way found via ng-model to
	     * expressions matching the input.
	     *
	     * @param {Element} element The element root to search from.
	     * @param {string} expression The model expression to match.
	     * @param {boolean} opt_exactMatch If true, only returns exact matches
	     *     for the expression.
	     */
	    testability.findModels = function(element, expression, opt_exactMatch) {
	      var prefixes = ['ng-', 'data-ng-', 'ng\\:'];
	      for (var p = 0; p < prefixes.length; ++p) {
	        var attributeEquals = opt_exactMatch ? '=' : '*=';
	        var selector = '[' + prefixes[p] + 'model' + attributeEquals + '"' + expression + '"]';
	        var elements = element.querySelectorAll(selector);
	        if (elements.length) {
	          return elements;
	        }
	      }
	    };
	
	    /**
	     * @name $$testability#getLocation
	     *
	     * @description
	     * Shortcut for getting the location in a browser agnostic way. Returns
	     *     the path, search, and hash. (e.g. /path?a=b#hash)
	     */
	    testability.getLocation = function() {
	      return $location.url();
	    };
	
	    /**
	     * @name $$testability#setLocation
	     *
	     * @description
	     * Shortcut for navigating to a location without doing a full page reload.
	     *
	     * @param {string} url The location url (path, search and hash,
	     *     e.g. /path?a=b#hash) to go to.
	     */
	    testability.setLocation = function(url) {
	      if (url !== $location.url()) {
	        $location.url(url);
	        $rootScope.$digest();
	      }
	    };
	
	    /**
	     * @name $$testability#whenStable
	     *
	     * @description
	     * Calls the callback when all pending tasks are completed.
	     *
	     * Types of tasks waited for include:
	     * - Pending timeouts (via {@link $timeout}).
	     * - Pending HTTP requests (via {@link $http}).
	     * - In-progress route transitions (via {@link $route}).
	     * - Pending tasks scheduled via {@link $rootScope#$applyAsync}.
	     * - Pending tasks scheduled via {@link $rootScope#$evalAsync}.
	     *   These include tasks scheduled via `$evalAsync()` indirectly (such as {@link $q} promises).
	     *
	     * @param {function} callback
	     */
	    testability.whenStable = function(callback) {
	      $browser.notifyWhenNoOutstandingRequests(callback);
	    };
	
	    return testability;
	  }];
	}
	
	var $timeoutMinErr = minErr('$timeout');
	
	/** @this */
	function $TimeoutProvider() {
	  this.$get = ['$rootScope', '$browser', '$q', '$$q', '$exceptionHandler',
	       function($rootScope,   $browser,   $q,   $$q,   $exceptionHandler) {
	
	    var deferreds = {};
	
	
	    /**
	     * @ngdoc service
	     * @name $timeout
	     *
	     * @description
	     * AngularJS's wrapper for `window.setTimeout`. The `fn` function is wrapped into a try/catch
	     * block and delegates any exceptions to
	     * {@link ng.$exceptionHandler $exceptionHandler} service.
	     *
	     * The return value of calling `$timeout` is a promise, which will be resolved when
	     * the delay has passed and the timeout function, if provided, is executed.
	     *
	     * To cancel a timeout request, call `$timeout.cancel(promise)`.
	     *
	     * In tests you can use {@link ngMock.$timeout `$timeout.flush()`} to
	     * synchronously flush the queue of deferred functions.
	     *
	     * If you only want a promise that will be resolved after some specified delay
	     * then you can call `$timeout` without the `fn` function.
	     *
	     * @param {function()=} fn A function, whose execution should be delayed.
	     * @param {number=} [delay=0] Delay in milliseconds.
	     * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
	     *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
	     * @param {...*=} Pass additional parameters to the executed function.
	     * @returns {Promise} Promise that will be resolved when the timeout is reached. The promise
	     *   will be resolved with the return value of the `fn` function.
	     *
	     */
	    function timeout(fn, delay, invokeApply) {
	      if (!isFunction(fn)) {
	        invokeApply = delay;
	        delay = fn;
	        fn = noop;
	      }
	
	      var args = sliceArgs(arguments, 3),
	          skipApply = (isDefined(invokeApply) && !invokeApply),
	          deferred = (skipApply ? $$q : $q).defer(),
	          promise = deferred.promise,
	          timeoutId;
	
	      timeoutId = $browser.defer(function() {
	        try {
	          deferred.resolve(fn.apply(null, args));
	        } catch (e) {
	          deferred.reject(e);
	          $exceptionHandler(e);
	        } finally {
	          delete deferreds[promise.$$timeoutId];
	        }
	
	        if (!skipApply) $rootScope.$apply();
	      }, delay, '$timeout');
	
	      promise.$$timeoutId = timeoutId;
	      deferreds[timeoutId] = deferred;
	
	      return promise;
	    }
	
	
	    /**
	     * @ngdoc method
	     * @name $timeout#cancel
	     *
	     * @description
	     * Cancels a task associated with the `promise`. As a result of this, the promise will be
	     * resolved with a rejection.
	     *
	     * @param {Promise=} promise Promise returned by the `$timeout` function.
	     * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
	     *   canceled.
	     */
	    timeout.cancel = function(promise) {
	      if (!promise) return false;
	
	      if (!promise.hasOwnProperty('$$timeoutId')) {
	        throw $timeoutMinErr('badprom',
	            '`$timeout.cancel()` called with a promise that was not generated by `$timeout()`.');
	      }
	
	      if (!deferreds.hasOwnProperty(promise.$$timeoutId)) return false;
	
	      var id = promise.$$timeoutId;
	      var deferred = deferreds[id];
	
	      // Timeout cancels should not report an unhandled promise.
	      markQExceptionHandled(deferred.promise);
	      deferred.reject('canceled');
	      delete deferreds[id];
	
	      return $browser.defer.cancel(id);
	    };
	
	    return timeout;
	  }];
	}
	
	// NOTE:  The usage of window and document instead of $window and $document here is
	// deliberate.  This service depends on the specific behavior of anchor nodes created by the
	// browser (resolving and parsing URLs) that is unlikely to be provided by mock objects and
	// cause us to break tests.  In addition, when the browser resolves a URL for XHR, it
	// doesn't know about mocked locations and resolves URLs to the real document - which is
	// exactly the behavior needed here.  There is little value is mocking these out for this
	// service.
	var urlParsingNode = window.document.createElement('a');
	var originUrl = urlResolve(window.location.href);
	var baseUrlParsingNode;
	
	urlParsingNode.href = 'http://[::1]';
	
	// Support: IE 9-11 only, Edge 16-17 only (fixed in 18 Preview)
	// IE/Edge don't wrap IPv6 addresses' hostnames in square brackets
	// when parsed out of an anchor element.
	var ipv6InBrackets = urlParsingNode.hostname === '[::1]';
	
	/**
	 *
	 * Implementation Notes for non-IE browsers
	 * ----------------------------------------
	 * Assigning a URL to the href property of an anchor DOM node, even one attached to the DOM,
	 * results both in the normalizing and parsing of the URL.  Normalizing means that a relative
	 * URL will be resolved into an absolute URL in the context of the application document.
	 * Parsing means that the anchor node's host, hostname, protocol, port, pathname and related
	 * properties are all populated to reflect the normalized URL.  This approach has wide
	 * compatibility - Safari 1+, Mozilla 1+ etc.  See
	 * http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
	 *
	 * Implementation Notes for IE
	 * ---------------------------
	 * IE <= 10 normalizes the URL when assigned to the anchor node similar to the other
	 * browsers.  However, the parsed components will not be set if the URL assigned did not specify
	 * them.  (e.g. if you assign a.href = "foo", then a.protocol, a.host, etc. will be empty.)  We
	 * work around that by performing the parsing in a 2nd step by taking a previously normalized
	 * URL (e.g. by assigning to a.href) and assigning it a.href again.  This correctly populates the
	 * properties such as protocol, hostname, port, etc.
	 *
	 * References:
	 *   http://developer.mozilla.org/en-US/docs/Web/API/HTMLAnchorElement
	 *   http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
	 *   http://url.spec.whatwg.org/#urlutils
	 *   https://github.com/angular/angular.js/pull/2902
	 *   http://james.padolsey.com/javascript/parsing-urls-with-the-dom/
	 *
	 * @kind function
	 * @param {string|object} url The URL to be parsed. If `url` is not a string, it will be returned
	 *     unchanged.
	 * @description Normalizes and parses a URL.
	 * @returns {object} Returns the normalized URL as a dictionary.
	 *
	 *   | member name   | Description                                                            |
	 *   |---------------|------------------------------------------------------------------------|
	 *   | href          | A normalized version of the provided URL if it was not an absolute URL |
	 *   | protocol      | The protocol without the trailing colon                                |
	 *   | host          | The host and port (if the port is non-default) of the normalizedUrl    |
	 *   | search        | The search params, minus the question mark                             |
	 *   | hash          | The hash string, minus the hash symbol                                 |
	 *   | hostname      | The hostname                                                           |
	 *   | port          | The port, without ":"                                                  |
	 *   | pathname      | The pathname, beginning with "/"                                       |
	 *
	 */
	function urlResolve(url) {
	  if (!isString(url)) return url;
	
	  var href = url;
	
	  // Support: IE 9-11 only
	  if (msie) {
	    // Normalize before parse.  Refer Implementation Notes on why this is
	    // done in two steps on IE.
	    urlParsingNode.setAttribute('href', href);
	    href = urlParsingNode.href;
	  }
	
	  urlParsingNode.setAttribute('href', href);
	
	  var hostname = urlParsingNode.hostname;
	
	  if (!ipv6InBrackets && hostname.indexOf(':') > -1) {
	    hostname = '[' + hostname + ']';
	  }
	
	  return {
	    href: urlParsingNode.href,
	    protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	    host: urlParsingNode.host,
	    search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	    hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	    hostname: hostname,
	    port: urlParsingNode.port,
	    pathname: (urlParsingNode.pathname.charAt(0) === '/')
	      ? urlParsingNode.pathname
	      : '/' + urlParsingNode.pathname
	  };
	}
	
	/**
	 * Parse a request URL and determine whether this is a same-origin request as the application
	 * document.
	 *
	 * @param {string|object} requestUrl The url of the request as a string that will be resolved
	 * or a parsed URL object.
	 * @returns {boolean} Whether the request is for the same origin as the application document.
	 */
	function urlIsSameOrigin(requestUrl) {
	  return urlsAreSameOrigin(requestUrl, originUrl);
	}
	
	/**
	 * Parse a request URL and determine whether it is same-origin as the current document base URL.
	 *
	 * Note: The base URL is usually the same as the document location (`location.href`) but can
	 * be overriden by using the `<base>` tag.
	 *
	 * @param {string|object} requestUrl The url of the request as a string that will be resolved
	 * or a parsed URL object.
	 * @returns {boolean} Whether the URL is same-origin as the document base URL.
	 */
	function urlIsSameOriginAsBaseUrl(requestUrl) {
	  return urlsAreSameOrigin(requestUrl, getBaseUrl());
	}
	
	/**
	 * Create a function that can check a URL's origin against a list of allowed/trusted origins.
	 * The current location's origin is implicitly trusted.
	 *
	 * @param {string[]} trustedOriginUrls - A list of URLs (strings), whose origins are trusted.
	 *
	 * @returns {Function} - A function that receives a URL (string or parsed URL object) and returns
	 *     whether it is of an allowed origin.
	 */
	function urlIsAllowedOriginFactory(trustedOriginUrls) {
	  var parsedAllowedOriginUrls = [originUrl].concat(trustedOriginUrls.map(urlResolve));
	
	  /**
	   * Check whether the specified URL (string or parsed URL object) has an origin that is allowed
	   * based on a list of trusted-origin URLs. The current location's origin is implicitly
	   * trusted.
	   *
	   * @param {string|Object} requestUrl - The URL to be checked (provided as a string that will be
	   *     resolved or a parsed URL object).
	   *
	   * @returns {boolean} - Whether the specified URL is of an allowed origin.
	   */
	  return function urlIsAllowedOrigin(requestUrl) {
	    var parsedUrl = urlResolve(requestUrl);
	    return parsedAllowedOriginUrls.some(urlsAreSameOrigin.bind(null, parsedUrl));
	  };
	}
	
	/**
	 * Determine if two URLs share the same origin.
	 *
	 * @param {string|Object} url1 - First URL to compare as a string or a normalized URL in the form of
	 *     a dictionary object returned by `urlResolve()`.
	 * @param {string|object} url2 - Second URL to compare as a string or a normalized URL in the form
	 *     of a dictionary object returned by `urlResolve()`.
	 *
	 * @returns {boolean} - True if both URLs have the same origin, and false otherwise.
	 */
	function urlsAreSameOrigin(url1, url2) {
	  url1 = urlResolve(url1);
	  url2 = urlResolve(url2);
	
	  return (url1.protocol === url2.protocol &&
	          url1.host === url2.host);
	}
	
	/**
	 * Returns the current document base URL.
	 * @returns {string}
	 */
	function getBaseUrl() {
	  if (window.document.baseURI) {
	    return window.document.baseURI;
	  }
	
	  // `document.baseURI` is available everywhere except IE
	  if (!baseUrlParsingNode) {
	    baseUrlParsingNode = window.document.createElement('a');
	    baseUrlParsingNode.href = '.';
	
	    // Work-around for IE bug described in Implementation Notes. The fix in `urlResolve()` is not
	    // suitable here because we need to track changes to the base URL.
	    baseUrlParsingNode = baseUrlParsingNode.cloneNode(false);
	  }
	  return baseUrlParsingNode.href;
	}
	
	/**
	 * @ngdoc service
	 * @name $window
	 * @this
	 *
	 * @description
	 * A reference to the browser's `window` object. While `window`
	 * is globally available in JavaScript, it causes testability problems, because
	 * it is a global variable. In AngularJS we always refer to it through the
	 * `$window` service, so it may be overridden, removed or mocked for testing.
	 *
	 * Expressions, like the one defined for the `ngClick` directive in the example
	 * below, are evaluated with respect to the current scope.  Therefore, there is
	 * no risk of inadvertently coding in a dependency on a global value in such an
	 * expression.
	 *
	 * @example
	   <example module="windowExample" name="window-service">
	     <file name="index.html">
	       <script>
	         angular.module('windowExample', [])
	           .controller('ExampleController', ['$scope', '$window', function($scope, $window) {
	             $scope.greeting = 'Hello, World!';
	             $scope.doGreeting = function(greeting) {
	               $window.alert(greeting);
	             };
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <input type="text" ng-model="greeting" aria-label="greeting" />
	         <button ng-click="doGreeting(greeting)">ALERT</button>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	      it('should display the greeting in the input box', function() {
	       element(by.model('greeting')).sendKeys('Hello, E2E Tests');
	       // If we click the button it will block the test runner
	       // element(':button').click();
	      });
	     </file>
	   </example>
	 */
	function $WindowProvider() {
	  this.$get = valueFn(window);
	}
	
	/**
	 * @name $$cookieReader
	 * @requires $document
	 *
	 * @description
	 * This is a private service for reading cookies used by $http and ngCookies
	 *
	 * @return {Object} a key/value map of the current cookies
	 */
	function $$CookieReader($document) {
	  var rawDocument = $document[0] || {};
	  var lastCookies = {};
	  var lastCookieString = '';
	
	  function safeGetCookie(rawDocument) {
	    try {
	      return rawDocument.cookie || '';
	    } catch (e) {
	      return '';
	    }
	  }
	
	  function safeDecodeURIComponent(str) {
	    try {
	      return decodeURIComponent(str);
	    } catch (e) {
	      return str;
	    }
	  }
	
	  return function() {
	    var cookieArray, cookie, i, index, name;
	    var currentCookieString = safeGetCookie(rawDocument);
	
	    if (currentCookieString !== lastCookieString) {
	      lastCookieString = currentCookieString;
	      cookieArray = lastCookieString.split('; ');
	      lastCookies = {};
	
	      for (i = 0; i < cookieArray.length; i++) {
	        cookie = cookieArray[i];
	        index = cookie.indexOf('=');
	        if (index > 0) { //ignore nameless cookies
	          name = safeDecodeURIComponent(cookie.substring(0, index));
	          // the first value that is seen for a cookie is the most
	          // specific one.  values for the same cookie name that
	          // follow are for less specific paths.
	          if (isUndefined(lastCookies[name])) {
	            lastCookies[name] = safeDecodeURIComponent(cookie.substring(index + 1));
	          }
	        }
	      }
	    }
	    return lastCookies;
	  };
	}
	
	$$CookieReader.$inject = ['$document'];
	
	/** @this */
	function $$CookieReaderProvider() {
	  this.$get = $$CookieReader;
	}
	
	/* global currencyFilter: true,
	 dateFilter: true,
	 filterFilter: true,
	 jsonFilter: true,
	 limitToFilter: true,
	 lowercaseFilter: true,
	 numberFilter: true,
	 orderByFilter: true,
	 uppercaseFilter: true,
	 */
	
	/**
	 * @ngdoc provider
	 * @name $filterProvider
	 * @description
	 *
	 * Filters are just functions which transform input to an output. However filters need to be
	 * Dependency Injected. To achieve this a filter definition consists of a factory function which is
	 * annotated with dependencies and is responsible for creating a filter function.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Filter names must be valid AngularJS {@link expression} identifiers, such as `uppercase` or `orderBy`.
	 * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
	 * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
	 * (`myapp_subsection_filterx`).
	 * </div>
	 *
	 * ```js
	 *   // Filter registration
	 *   function MyModule($provide, $filterProvider) {
	 *     // create a service to demonstrate injection (not always needed)
	 *     $provide.value('greet', function(name){
	 *       return 'Hello ' + name + '!';
	 *     });
	 *
	 *     // register a filter factory which uses the
	 *     // greet service to demonstrate DI.
	 *     $filterProvider.register('greet', function(greet){
	 *       // return the filter function which uses the greet service
	 *       // to generate salutation
	 *       return function(text) {
	 *         // filters need to be forgiving so check input validity
	 *         return text && greet(text) || text;
	 *       };
	 *     });
	 *   }
	 * ```
	 *
	 * The filter function is registered with the `$injector` under the filter name suffix with
	 * `Filter`.
	 *
	 * ```js
	 *   it('should be the same instance', inject(
	 *     function($filterProvider) {
	 *       $filterProvider.register('reverse', function(){
	 *         return ...;
	 *       });
	 *     },
	 *     function($filter, reverseFilter) {
	 *       expect($filter('reverse')).toBe(reverseFilter);
	 *     });
	 * ```
	 *
	 *
	 * For more information about how AngularJS filters work, and how to create your own filters, see
	 * {@link guide/filter Filters} in the AngularJS Developer Guide.
	 */
	
	/**
	 * @ngdoc service
	 * @name $filter
	 * @kind function
	 * @description
	 * Filters are used for formatting data displayed to the user.
	 *
	 * They can be used in view templates, controllers or services. AngularJS comes
	 * with a collection of [built-in filters](api/ng/filter), but it is easy to
	 * define your own as well.
	 *
	 * The general syntax in templates is as follows:
	 *
	 * ```html
	 * {{ expression [| filter_name[:parameter_value] ... ] }}
	 * ```
	 *
	 * @param {String} name Name of the filter function to retrieve
	 * @return {Function} the filter function
	 * @example
	   <example name="$filter" module="filterExample">
	     <file name="index.html">
	       <div ng-controller="MainCtrl">
	        <h3>{{ originalText }}</h3>
	        <h3>{{ filteredText }}</h3>
	       </div>
	     </file>
	
	     <file name="script.js">
	      angular.module('filterExample', [])
	      .controller('MainCtrl', function($scope, $filter) {
	        $scope.originalText = 'hello';
	        $scope.filteredText = $filter('uppercase')($scope.originalText);
	      });
	     </file>
	   </example>
	  */
	$FilterProvider.$inject = ['$provide'];
	/** @this */
	function $FilterProvider($provide) {
	  var suffix = 'Filter';
	
	  /**
	   * @ngdoc method
	   * @name $filterProvider#register
	   * @param {string|Object} name Name of the filter function, or an object map of filters where
	   *    the keys are the filter names and the values are the filter factories.
	   *
	   *    <div class="alert alert-warning">
	   *    **Note:** Filter names must be valid AngularJS {@link expression} identifiers, such as `uppercase` or `orderBy`.
	   *    Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
	   *    your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
	   *    (`myapp_subsection_filterx`).
	   *    </div>
	    * @param {Function} factory If the first argument was a string, a factory function for the filter to be registered.
	   * @returns {Object} Registered filter instance, or if a map of filters was provided then a map
	   *    of the registered filter instances.
	   */
	  function register(name, factory) {
	    if (isObject(name)) {
	      var filters = {};
	      forEach(name, function(filter, key) {
	        filters[key] = register(key, filter);
	      });
	      return filters;
	    } else {
	      return $provide.factory(name + suffix, factory);
	    }
	  }
	  this.register = register;
	
	  this.$get = ['$injector', function($injector) {
	    return function(name) {
	      return $injector.get(name + suffix);
	    };
	  }];
	
	  ////////////////////////////////////////
	
	  /* global
	    currencyFilter: false,
	    dateFilter: false,
	    filterFilter: false,
	    jsonFilter: false,
	    limitToFilter: false,
	    lowercaseFilter: false,
	    numberFilter: false,
	    orderByFilter: false,
	    uppercaseFilter: false
	  */
	
	  register('currency', currencyFilter);
	  register('date', dateFilter);
	  register('filter', filterFilter);
	  register('json', jsonFilter);
	  register('limitTo', limitToFilter);
	  register('lowercase', lowercaseFilter);
	  register('number', numberFilter);
	  register('orderBy', orderByFilter);
	  register('uppercase', uppercaseFilter);
	}
	
	/**
	 * @ngdoc filter
	 * @name filter
	 * @kind function
	 *
	 * @description
	 * Selects a subset of items from `array` and returns it as a new array.
	 *
	 * @param {Array} array The source array.
	 * <div class="alert alert-info">
	 *   **Note**: If the array contains objects that reference themselves, filtering is not possible.
	 * </div>
	 * @param {string|Object|function()} expression The predicate to be used for selecting items from
	 *   `array`.
	 *
	 *   Can be one of:
	 *
	 *   - `string`: The string is used for matching against the contents of the `array`. All strings or
	 *     objects with string properties in `array` that match this string will be returned. This also
	 *     applies to nested object properties.
	 *     The predicate can be negated by prefixing the string with `!`.
	 *
	 *   - `Object`: A pattern object can be used to filter specific properties on objects contained
	 *     by `array`. For example `{name:"M", phone:"1"}` predicate will return an array of items
	 *     which have property `name` containing "M" and property `phone` containing "1". A special
	 *     property name (`$` by default) can be used (e.g. as in `{$: "text"}`) to accept a match
	 *     against any property of the object or its nested object properties. That's equivalent to the
	 *     simple substring match with a `string` as described above. The special property name can be
	 *     overwritten, using the `anyPropertyKey` parameter.
	 *     The predicate can be negated by prefixing the string with `!`.
	 *     For example `{name: "!M"}` predicate will return an array of items which have property `name`
	 *     not containing "M".
	 *
	 *     Note that a named property will match properties on the same level only, while the special
	 *     `$` property will match properties on the same level or deeper. E.g. an array item like
	 *     `{name: {first: 'John', last: 'Doe'}}` will **not** be matched by `{name: 'John'}`, but
	 *     **will** be matched by `{$: 'John'}`.
	 *
	 *   - `function(value, index, array)`: A predicate function can be used to write arbitrary filters.
	 *     The function is called for each element of the array, with the element, its index, and
	 *     the entire array itself as arguments.
	 *
	 *     The final result is an array of those elements that the predicate returned true for.
	 *
	 * @param {function(actual, expected)|true|false} [comparator] Comparator which is used in
	 *     determining if values retrieved using `expression` (when it is not a function) should be
	 *     considered a match based on the expected value (from the filter expression) and actual
	 *     value (from the object in the array).
	 *
	 *   Can be one of:
	 *
	 *   - `function(actual, expected)`:
	 *     The function will be given the object value and the predicate value to compare and
	 *     should return true if both values should be considered equal.
	 *
	 *   - `true`: A shorthand for `function(actual, expected) { return angular.equals(actual, expected)}`.
	 *     This is essentially strict comparison of expected and actual.
	 *
	 *   - `false`: A short hand for a function which will look for a substring match in a case
	 *     insensitive way. Primitive values are converted to strings. Objects are not compared against
	 *     primitives, unless they have a custom `toString` method (e.g. `Date` objects).
	 *
	 *
	 *   Defaults to `false`.
	 *
	 * @param {string} [anyPropertyKey] The special property name that matches against any property.
	 *     By default `$`.
	 *
	 * @example
	   <example name="filter-filter">
	     <file name="index.html">
	       <div ng-init="friends = [{name:'John', phone:'555-1276'},
	                                {name:'Mary', phone:'800-BIG-MARY'},
	                                {name:'Mike', phone:'555-4321'},
	                                {name:'Adam', phone:'555-5678'},
	                                {name:'Julie', phone:'555-8765'},
	                                {name:'Juliette', phone:'555-5678'}]"></div>
	
	       <label>Search: <input ng-model="searchText"></label>
	       <table id="searchTextResults">
	         <tr><th>Name</th><th>Phone</th></tr>
	         <tr ng-repeat="friend in friends | filter:searchText">
	           <td>{{friend.name}}</td>
	           <td>{{friend.phone}}</td>
	         </tr>
	       </table>
	       <hr>
	       <label>Any: <input ng-model="search.$"></label> <br>
	       <label>Name only <input ng-model="search.name"></label><br>
	       <label>Phone only <input ng-model="search.phone"></label><br>
	       <label>Equality <input type="checkbox" ng-model="strict"></label><br>
	       <table id="searchObjResults">
	         <tr><th>Name</th><th>Phone</th></tr>
	         <tr ng-repeat="friendObj in friends | filter:search:strict">
	           <td>{{friendObj.name}}</td>
	           <td>{{friendObj.phone}}</td>
	         </tr>
	       </table>
	     </file>
	     <file name="protractor.js" type="protractor">
	       var expectFriendNames = function(expectedNames, key) {
	         element.all(by.repeater(key + ' in friends').column(key + '.name')).then(function(arr) {
	           arr.forEach(function(wd, i) {
	             expect(wd.getText()).toMatch(expectedNames[i]);
	           });
	         });
	       };
	
	       it('should search across all fields when filtering with a string', function() {
	         var searchText = element(by.model('searchText'));
	         searchText.clear();
	         searchText.sendKeys('m');
	         expectFriendNames(['Mary', 'Mike', 'Adam'], 'friend');
	
	         searchText.clear();
	         searchText.sendKeys('76');
	         expectFriendNames(['John', 'Julie'], 'friend');
	       });
	
	       it('should search in specific fields when filtering with a predicate object', function() {
	         var searchAny = element(by.model('search.$'));
	         searchAny.clear();
	         searchAny.sendKeys('i');
	         expectFriendNames(['Mary', 'Mike', 'Julie', 'Juliette'], 'friendObj');
	       });
	       it('should use a equal comparison when comparator is true', function() {
	         var searchName = element(by.model('search.name'));
	         var strict = element(by.model('strict'));
	         searchName.clear();
	         searchName.sendKeys('Julie');
	         strict.click();
	         expectFriendNames(['Julie'], 'friendObj');
	       });
	     </file>
	   </example>
	 */
	
	function filterFilter() {
	  return function(array, expression, comparator, anyPropertyKey) {
	    if (!isArrayLike(array)) {
	      if (array == null) {
	        return array;
	      } else {
	        throw minErr('filter')('notarray', 'Expected array but received: {0}', array);
	      }
	    }
	
	    anyPropertyKey = anyPropertyKey || '$';
	    var expressionType = getTypeForFilter(expression);
	    var predicateFn;
	    var matchAgainstAnyProp;
	
	    switch (expressionType) {
	      case 'function':
	        predicateFn = expression;
	        break;
	      case 'boolean':
	      case 'null':
	      case 'number':
	      case 'string':
	        matchAgainstAnyProp = true;
	        // falls through
	      case 'object':
	        predicateFn = createPredicateFn(expression, comparator, anyPropertyKey, matchAgainstAnyProp);
	        break;
	      default:
	        return array;
	    }
	
	    return Array.prototype.filter.call(array, predicateFn);
	  };
	}
	
	// Helper functions for `filterFilter`
	function createPredicateFn(expression, comparator, anyPropertyKey, matchAgainstAnyProp) {
	  var shouldMatchPrimitives = isObject(expression) && (anyPropertyKey in expression);
	  var predicateFn;
	
	  if (comparator === true) {
	    comparator = equals;
	  } else if (!isFunction(comparator)) {
	    comparator = function(actual, expected) {
	      if (isUndefined(actual)) {
	        // No substring matching against `undefined`
	        return false;
	      }
	      if ((actual === null) || (expected === null)) {
	        // No substring matching against `null`; only match against `null`
	        return actual === expected;
	      }
	      if (isObject(expected) || (isObject(actual) && !hasCustomToString(actual))) {
	        // Should not compare primitives against objects, unless they have custom `toString` method
	        return false;
	      }
	
	      actual = lowercase('' + actual);
	      expected = lowercase('' + expected);
	      return actual.indexOf(expected) !== -1;
	    };
	  }
	
	  predicateFn = function(item) {
	    if (shouldMatchPrimitives && !isObject(item)) {
	      return deepCompare(item, expression[anyPropertyKey], comparator, anyPropertyKey, false);
	    }
	    return deepCompare(item, expression, comparator, anyPropertyKey, matchAgainstAnyProp);
	  };
	
	  return predicateFn;
	}
	
	function deepCompare(actual, expected, comparator, anyPropertyKey, matchAgainstAnyProp, dontMatchWholeObject) {
	  var actualType = getTypeForFilter(actual);
	  var expectedType = getTypeForFilter(expected);
	
	  if ((expectedType === 'string') && (expected.charAt(0) === '!')) {
	    return !deepCompare(actual, expected.substring(1), comparator, anyPropertyKey, matchAgainstAnyProp);
	  } else if (isArray(actual)) {
	    // In case `actual` is an array, consider it a match
	    // if ANY of it's items matches `expected`
	    return actual.some(function(item) {
	      return deepCompare(item, expected, comparator, anyPropertyKey, matchAgainstAnyProp);
	    });
	  }
	
	  switch (actualType) {
	    case 'object':
	      var key;
	      if (matchAgainstAnyProp) {
	        for (key in actual) {
	          // Under certain, rare, circumstances, key may not be a string and `charAt` will be undefined
	          // See: https://github.com/angular/angular.js/issues/15644
	          if (key.charAt && (key.charAt(0) !== '$') &&
	              deepCompare(actual[key], expected, comparator, anyPropertyKey, true)) {
	            return true;
	          }
	        }
	        return dontMatchWholeObject ? false : deepCompare(actual, expected, comparator, anyPropertyKey, false);
	      } else if (expectedType === 'object') {
	        for (key in expected) {
	          var expectedVal = expected[key];
	          if (isFunction(expectedVal) || isUndefined(expectedVal)) {
	            continue;
	          }
	
	          var matchAnyProperty = key === anyPropertyKey;
	          var actualVal = matchAnyProperty ? actual : actual[key];
	          if (!deepCompare(actualVal, expectedVal, comparator, anyPropertyKey, matchAnyProperty, matchAnyProperty)) {
	            return false;
	          }
	        }
	        return true;
	      } else {
	        return comparator(actual, expected);
	      }
	    case 'function':
	      return false;
	    default:
	      return comparator(actual, expected);
	  }
	}
	
	// Used for easily differentiating between `null` and actual `object`
	function getTypeForFilter(val) {
	  return (val === null) ? 'null' : typeof val;
	}
	
	var MAX_DIGITS = 22;
	var DECIMAL_SEP = '.';
	var ZERO_CHAR = '0';
	
	/**
	 * @ngdoc filter
	 * @name currency
	 * @kind function
	 *
	 * @description
	 * Formats a number as a currency (ie $1,234.56). When no currency symbol is provided, default
	 * symbol for current locale is used.
	 *
	 * @param {number} amount Input to filter.
	 * @param {string=} symbol Currency symbol or identifier to be displayed.
	 * @param {number=} fractionSize Number of decimal places to round the amount to, defaults to default max fraction size for current locale
	 * @returns {string} Formatted number.
	 *
	 *
	 * @example
	   <example module="currencyExample" name="currency-filter">
	     <file name="index.html">
	       <script>
	         angular.module('currencyExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.amount = 1234.56;
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <input type="number" ng-model="amount" aria-label="amount"> <br>
	         default currency symbol ($): <span id="currency-default">{{amount | currency}}</span><br>
	         custom currency identifier (USD$): <span id="currency-custom">{{amount | currency:"USD$"}}</span><br>
	         no fractions (0): <span id="currency-no-fractions">{{amount | currency:"USD$":0}}</span>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should init with 1234.56', function() {
	         expect(element(by.id('currency-default')).getText()).toBe('$1,234.56');
	         expect(element(by.id('currency-custom')).getText()).toBe('USD$1,234.56');
	         expect(element(by.id('currency-no-fractions')).getText()).toBe('USD$1,235');
	       });
	       it('should update', function() {
	         if (browser.params.browser === 'safari') {
	           // Safari does not understand the minus key. See
	           // https://github.com/angular/protractor/issues/481
	           return;
	         }
	         element(by.model('amount')).clear();
	         element(by.model('amount')).sendKeys('-1234');
	         expect(element(by.id('currency-default')).getText()).toBe('-$1,234.00');
	         expect(element(by.id('currency-custom')).getText()).toBe('-USD$1,234.00');
	         expect(element(by.id('currency-no-fractions')).getText()).toBe('-USD$1,234');
	       });
	     </file>
	   </example>
	 */
	currencyFilter.$inject = ['$locale'];
	function currencyFilter($locale) {
	  var formats = $locale.NUMBER_FORMATS;
	  return function(amount, currencySymbol, fractionSize) {
	    if (isUndefined(currencySymbol)) {
	      currencySymbol = formats.CURRENCY_SYM;
	    }
	
	    if (isUndefined(fractionSize)) {
	      fractionSize = formats.PATTERNS[1].maxFrac;
	    }
	
	    // If the currency symbol is empty, trim whitespace around the symbol
	    var currencySymbolRe = !currencySymbol ? /\s*\u00A4\s*/g : /\u00A4/g;
	
	    // if null or undefined pass it through
	    return (amount == null)
	        ? amount
	        : formatNumber(amount, formats.PATTERNS[1], formats.GROUP_SEP, formats.DECIMAL_SEP, fractionSize).
	            replace(currencySymbolRe, currencySymbol);
	  };
	}
	
	/**
	 * @ngdoc filter
	 * @name number
	 * @kind function
	 *
	 * @description
	 * Formats a number as text.
	 *
	 * If the input is null or undefined, it will just be returned.
	 * If the input is infinite (Infinity or -Infinity), the Infinity symbol '∞' or '-∞' is returned, respectively.
	 * If the input is not a number an empty string is returned.
	 *
	 *
	 * @param {number|string} number Number to format.
	 * @param {(number|string)=} fractionSize Number of decimal places to round the number to.
	 * If this is not provided then the fraction size is computed from the current locale's number
	 * formatting pattern. In the case of the default locale, it will be 3.
	 * @returns {string} Number rounded to `fractionSize` appropriately formatted based on the current
	 *                   locale (e.g., in the en_US locale it will have "." as the decimal separator and
	 *                   include "," group separators after each third digit).
	 *
	 * @example
	   <example module="numberFilterExample" name="number-filter">
	     <file name="index.html">
	       <script>
	         angular.module('numberFilterExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.val = 1234.56789;
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <label>Enter number: <input ng-model='val'></label><br>
	         Default formatting: <span id='number-default'>{{val | number}}</span><br>
	         No fractions: <span>{{val | number:0}}</span><br>
	         Negative number: <span>{{-val | number:4}}</span>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should format numbers', function() {
	         expect(element(by.id('number-default')).getText()).toBe('1,234.568');
	         expect(element(by.binding('val | number:0')).getText()).toBe('1,235');
	         expect(element(by.binding('-val | number:4')).getText()).toBe('-1,234.5679');
	       });
	
	       it('should update', function() {
	         element(by.model('val')).clear();
	         element(by.model('val')).sendKeys('3374.333');
	         expect(element(by.id('number-default')).getText()).toBe('3,374.333');
	         expect(element(by.binding('val | number:0')).getText()).toBe('3,374');
	         expect(element(by.binding('-val | number:4')).getText()).toBe('-3,374.3330');
	      });
	     </file>
	   </example>
	 */
	numberFilter.$inject = ['$locale'];
	function numberFilter($locale) {
	  var formats = $locale.NUMBER_FORMATS;
	  return function(number, fractionSize) {
	
	    // if null or undefined pass it through
	    return (number == null)
	        ? number
	        : formatNumber(number, formats.PATTERNS[0], formats.GROUP_SEP, formats.DECIMAL_SEP,
	                       fractionSize);
	  };
	}
	
	/**
	 * Parse a number (as a string) into three components that can be used
	 * for formatting the number.
	 *
	 * (Significant bits of this parse algorithm came from https://github.com/MikeMcl/big.js/)
	 *
	 * @param  {string} numStr The number to parse
	 * @return {object} An object describing this number, containing the following keys:
	 *  - d : an array of digits containing leading zeros as necessary
	 *  - i : the number of the digits in `d` that are to the left of the decimal point
	 *  - e : the exponent for numbers that would need more than `MAX_DIGITS` digits in `d`
	 *
	 */
	function parse(numStr) {
	  var exponent = 0, digits, numberOfIntegerDigits;
	  var i, j, zeros;
	
	  // Decimal point?
	  if ((numberOfIntegerDigits = numStr.indexOf(DECIMAL_SEP)) > -1) {
	    numStr = numStr.replace(DECIMAL_SEP, '');
	  }
	
	  // Exponential form?
	  if ((i = numStr.search(/e/i)) > 0) {
	    // Work out the exponent.
	    if (numberOfIntegerDigits < 0) numberOfIntegerDigits = i;
	    numberOfIntegerDigits += +numStr.slice(i + 1);
	    numStr = numStr.substring(0, i);
	  } else if (numberOfIntegerDigits < 0) {
	    // There was no decimal point or exponent so it is an integer.
	    numberOfIntegerDigits = numStr.length;
	  }
	
	  // Count the number of leading zeros.
	  for (i = 0; numStr.charAt(i) === ZERO_CHAR; i++) { /* empty */ }
	
	  if (i === (zeros = numStr.length)) {
	    // The digits are all zero.
	    digits = [0];
	    numberOfIntegerDigits = 1;
	  } else {
	    // Count the number of trailing zeros
	    zeros--;
	    while (numStr.charAt(zeros) === ZERO_CHAR) zeros--;
	
	    // Trailing zeros are insignificant so ignore them
	    numberOfIntegerDigits -= i;
	    digits = [];
	    // Convert string to array of digits without leading/trailing zeros.
	    for (j = 0; i <= zeros; i++, j++) {
	      digits[j] = +numStr.charAt(i);
	    }
	  }
	
	  // If the number overflows the maximum allowed digits then use an exponent.
	  if (numberOfIntegerDigits > MAX_DIGITS) {
	    digits = digits.splice(0, MAX_DIGITS - 1);
	    exponent = numberOfIntegerDigits - 1;
	    numberOfIntegerDigits = 1;
	  }
	
	  return { d: digits, e: exponent, i: numberOfIntegerDigits };
	}
	
	/**
	 * Round the parsed number to the specified number of decimal places
	 * This function changed the parsedNumber in-place
	 */
	function roundNumber(parsedNumber, fractionSize, minFrac, maxFrac) {
	    var digits = parsedNumber.d;
	    var fractionLen = digits.length - parsedNumber.i;
	
	    // determine fractionSize if it is not specified; `+fractionSize` converts it to a number
	    fractionSize = (isUndefined(fractionSize)) ? Math.min(Math.max(minFrac, fractionLen), maxFrac) : +fractionSize;
	
	    // The index of the digit to where rounding is to occur
	    var roundAt = fractionSize + parsedNumber.i;
	    var digit = digits[roundAt];
	
	    if (roundAt > 0) {
	      // Drop fractional digits beyond `roundAt`
	      digits.splice(Math.max(parsedNumber.i, roundAt));
	
	      // Set non-fractional digits beyond `roundAt` to 0
	      for (var j = roundAt; j < digits.length; j++) {
	        digits[j] = 0;
	      }
	    } else {
	      // We rounded to zero so reset the parsedNumber
	      fractionLen = Math.max(0, fractionLen);
	      parsedNumber.i = 1;
	      digits.length = Math.max(1, roundAt = fractionSize + 1);
	      digits[0] = 0;
	      for (var i = 1; i < roundAt; i++) digits[i] = 0;
	    }
	
	    if (digit >= 5) {
	      if (roundAt - 1 < 0) {
	        for (var k = 0; k > roundAt; k--) {
	          digits.unshift(0);
	          parsedNumber.i++;
	        }
	        digits.unshift(1);
	        parsedNumber.i++;
	      } else {
	        digits[roundAt - 1]++;
	      }
	    }
	
	    // Pad out with zeros to get the required fraction length
	    for (; fractionLen < Math.max(0, fractionSize); fractionLen++) digits.push(0);
	
	
	    // Do any carrying, e.g. a digit was rounded up to 10
	    var carry = digits.reduceRight(function(carry, d, i, digits) {
	      d = d + carry;
	      digits[i] = d % 10;
	      return Math.floor(d / 10);
	    }, 0);
	    if (carry) {
	      digits.unshift(carry);
	      parsedNumber.i++;
	    }
	}
	
	/**
	 * Format a number into a string
	 * @param  {number} number       The number to format
	 * @param  {{
	 *           minFrac, // the minimum number of digits required in the fraction part of the number
	 *           maxFrac, // the maximum number of digits required in the fraction part of the number
	 *           gSize,   // number of digits in each group of separated digits
	 *           lgSize,  // number of digits in the last group of digits before the decimal separator
	 *           negPre,  // the string to go in front of a negative number (e.g. `-` or `(`))
	 *           posPre,  // the string to go in front of a positive number
	 *           negSuf,  // the string to go after a negative number (e.g. `)`)
	 *           posSuf   // the string to go after a positive number
	 *         }} pattern
	 * @param  {string} groupSep     The string to separate groups of number (e.g. `,`)
	 * @param  {string} decimalSep   The string to act as the decimal separator (e.g. `.`)
	 * @param  {[type]} fractionSize The size of the fractional part of the number
	 * @return {string}              The number formatted as a string
	 */
	function formatNumber(number, pattern, groupSep, decimalSep, fractionSize) {
	
	  if (!(isString(number) || isNumber(number)) || isNaN(number)) return '';
	
	  var isInfinity = !isFinite(number);
	  var isZero = false;
	  var numStr = Math.abs(number) + '',
	      formattedText = '',
	      parsedNumber;
	
	  if (isInfinity) {
	    formattedText = '\u221e';
	  } else {
	    parsedNumber = parse(numStr);
	
	    roundNumber(parsedNumber, fractionSize, pattern.minFrac, pattern.maxFrac);
	
	    var digits = parsedNumber.d;
	    var integerLen = parsedNumber.i;
	    var exponent = parsedNumber.e;
	    var decimals = [];
	    isZero = digits.reduce(function(isZero, d) { return isZero && !d; }, true);
	
	    // pad zeros for small numbers
	    while (integerLen < 0) {
	      digits.unshift(0);
	      integerLen++;
	    }
	
	    // extract decimals digits
	    if (integerLen > 0) {
	      decimals = digits.splice(integerLen, digits.length);
	    } else {
	      decimals = digits;
	      digits = [0];
	    }
	
	    // format the integer digits with grouping separators
	    var groups = [];
	    if (digits.length >= pattern.lgSize) {
	      groups.unshift(digits.splice(-pattern.lgSize, digits.length).join(''));
	    }
	    while (digits.length > pattern.gSize) {
	      groups.unshift(digits.splice(-pattern.gSize, digits.length).join(''));
	    }
	    if (digits.length) {
	      groups.unshift(digits.join(''));
	    }
	    formattedText = groups.join(groupSep);
	
	    // append the decimal digits
	    if (decimals.length) {
	      formattedText += decimalSep + decimals.join('');
	    }
	
	    if (exponent) {
	      formattedText += 'e+' + exponent;
	    }
	  }
	  if (number < 0 && !isZero) {
	    return pattern.negPre + formattedText + pattern.negSuf;
	  } else {
	    return pattern.posPre + formattedText + pattern.posSuf;
	  }
	}
	
	function padNumber(num, digits, trim, negWrap) {
	  var neg = '';
	  if (num < 0 || (negWrap && num <= 0)) {
	    if (negWrap) {
	      num = -num + 1;
	    } else {
	      num = -num;
	      neg = '-';
	    }
	  }
	  num = '' + num;
	  while (num.length < digits) num = ZERO_CHAR + num;
	  if (trim) {
	    num = num.substr(num.length - digits);
	  }
	  return neg + num;
	}
	
	
	function dateGetter(name, size, offset, trim, negWrap) {
	  offset = offset || 0;
	  return function(date) {
	    var value = date['get' + name]();
	    if (offset > 0 || value > -offset) {
	      value += offset;
	    }
	    if (value === 0 && offset === -12) value = 12;
	    return padNumber(value, size, trim, negWrap);
	  };
	}
	
	function dateStrGetter(name, shortForm, standAlone) {
	  return function(date, formats) {
	    var value = date['get' + name]();
	    var propPrefix = (standAlone ? 'STANDALONE' : '') + (shortForm ? 'SHORT' : '');
	    var get = uppercase(propPrefix + name);
	
	    return formats[get][value];
	  };
	}
	
	function timeZoneGetter(date, formats, offset) {
	  var zone = -1 * offset;
	  var paddedZone = (zone >= 0) ? '+' : '';
	
	  paddedZone += padNumber(Math[zone > 0 ? 'floor' : 'ceil'](zone / 60), 2) +
	                padNumber(Math.abs(zone % 60), 2);
	
	  return paddedZone;
	}
	
	function getFirstThursdayOfYear(year) {
	    // 0 = index of January
	    var dayOfWeekOnFirst = (new Date(year, 0, 1)).getDay();
	    // 4 = index of Thursday (+1 to account for 1st = 5)
	    // 11 = index of *next* Thursday (+1 account for 1st = 12)
	    return new Date(year, 0, ((dayOfWeekOnFirst <= 4) ? 5 : 12) - dayOfWeekOnFirst);
	}
	
	function getThursdayThisWeek(datetime) {
	    return new Date(datetime.getFullYear(), datetime.getMonth(),
	      // 4 = index of Thursday
	      datetime.getDate() + (4 - datetime.getDay()));
	}
	
	function weekGetter(size) {
	   return function(date) {
	      var firstThurs = getFirstThursdayOfYear(date.getFullYear()),
	         thisThurs = getThursdayThisWeek(date);
	
	      var diff = +thisThurs - +firstThurs,
	         result = 1 + Math.round(diff / 6.048e8); // 6.048e8 ms per week
	
	      return padNumber(result, size);
	   };
	}
	
	function ampmGetter(date, formats) {
	  return date.getHours() < 12 ? formats.AMPMS[0] : formats.AMPMS[1];
	}
	
	function eraGetter(date, formats) {
	  return date.getFullYear() <= 0 ? formats.ERAS[0] : formats.ERAS[1];
	}
	
	function longEraGetter(date, formats) {
	  return date.getFullYear() <= 0 ? formats.ERANAMES[0] : formats.ERANAMES[1];
	}
	
	var DATE_FORMATS = {
	  yyyy: dateGetter('FullYear', 4, 0, false, true),
	    yy: dateGetter('FullYear', 2, 0, true, true),
	     y: dateGetter('FullYear', 1, 0, false, true),
	  MMMM: dateStrGetter('Month'),
	   MMM: dateStrGetter('Month', true),
	    MM: dateGetter('Month', 2, 1),
	     M: dateGetter('Month', 1, 1),
	  LLLL: dateStrGetter('Month', false, true),
	    dd: dateGetter('Date', 2),
	     d: dateGetter('Date', 1),
	    HH: dateGetter('Hours', 2),
	     H: dateGetter('Hours', 1),
	    hh: dateGetter('Hours', 2, -12),
	     h: dateGetter('Hours', 1, -12),
	    mm: dateGetter('Minutes', 2),
	     m: dateGetter('Minutes', 1),
	    ss: dateGetter('Seconds', 2),
	     s: dateGetter('Seconds', 1),
	     // while ISO 8601 requires fractions to be prefixed with `.` or `,`
	     // we can be just safely rely on using `sss` since we currently don't support single or two digit fractions
	   sss: dateGetter('Milliseconds', 3),
	  EEEE: dateStrGetter('Day'),
	   EEE: dateStrGetter('Day', true),
	     a: ampmGetter,
	     Z: timeZoneGetter,
	    ww: weekGetter(2),
	     w: weekGetter(1),
	     G: eraGetter,
	     GG: eraGetter,
	     GGG: eraGetter,
	     GGGG: longEraGetter
	};
	
	var DATE_FORMATS_SPLIT = /((?:[^yMLdHhmsaZEwG']+)|(?:'(?:[^']|'')*')|(?:E+|y+|M+|L+|d+|H+|h+|m+|s+|a|Z|G+|w+))([\s\S]*)/,
	    NUMBER_STRING = /^-?\d+$/;
	
	/**
	 * @ngdoc filter
	 * @name date
	 * @kind function
	 *
	 * @description
	 *   Formats `date` to a string based on the requested `format`.
	 *
	 *   `format` string can be composed of the following elements:
	 *
	 *   * `'yyyy'`: 4 digit representation of year (e.g. AD 1 => 0001, AD 2010 => 2010)
	 *   * `'yy'`: 2 digit representation of year, padded (00-99). (e.g. AD 2001 => 01, AD 2010 => 10)
	 *   * `'y'`: 1 digit representation of year, e.g. (AD 1 => 1, AD 199 => 199)
	 *   * `'MMMM'`: Month in year (January-December)
	 *   * `'MMM'`: Month in year (Jan-Dec)
	 *   * `'MM'`: Month in year, padded (01-12)
	 *   * `'M'`: Month in year (1-12)
	 *   * `'LLLL'`: Stand-alone month in year (January-December)
	 *   * `'dd'`: Day in month, padded (01-31)
	 *   * `'d'`: Day in month (1-31)
	 *   * `'EEEE'`: Day in Week,(Sunday-Saturday)
	 *   * `'EEE'`: Day in Week, (Sun-Sat)
	 *   * `'HH'`: Hour in day, padded (00-23)
	 *   * `'H'`: Hour in day (0-23)
	 *   * `'hh'`: Hour in AM/PM, padded (01-12)
	 *   * `'h'`: Hour in AM/PM, (1-12)
	 *   * `'mm'`: Minute in hour, padded (00-59)
	 *   * `'m'`: Minute in hour (0-59)
	 *   * `'ss'`: Second in minute, padded (00-59)
	 *   * `'s'`: Second in minute (0-59)
	 *   * `'sss'`: Millisecond in second, padded (000-999)
	 *   * `'a'`: AM/PM marker
	 *   * `'Z'`: 4 digit (+sign) representation of the timezone offset (-1200-+1200)
	 *   * `'ww'`: Week of year, padded (00-53). Week 01 is the week with the first Thursday of the year
	 *   * `'w'`: Week of year (0-53). Week 1 is the week with the first Thursday of the year
	 *   * `'G'`, `'GG'`, `'GGG'`: The abbreviated form of the era string (e.g. 'AD')
	 *   * `'GGGG'`: The long form of the era string (e.g. 'Anno Domini')
	 *
	 *   `format` string can also be one of the following predefined
	 *   {@link guide/i18n localizable formats}:
	 *
	 *   * `'medium'`: equivalent to `'MMM d, y h:mm:ss a'` for en_US locale
	 *     (e.g. Sep 3, 2010 12:05:08 PM)
	 *   * `'short'`: equivalent to `'M/d/yy h:mm a'` for en_US  locale (e.g. 9/3/10 12:05 PM)
	 *   * `'fullDate'`: equivalent to `'EEEE, MMMM d, y'` for en_US  locale
	 *     (e.g. Friday, September 3, 2010)
	 *   * `'longDate'`: equivalent to `'MMMM d, y'` for en_US  locale (e.g. September 3, 2010)
	 *   * `'mediumDate'`: equivalent to `'MMM d, y'` for en_US  locale (e.g. Sep 3, 2010)
	 *   * `'shortDate'`: equivalent to `'M/d/yy'` for en_US locale (e.g. 9/3/10)
	 *   * `'mediumTime'`: equivalent to `'h:mm:ss a'` for en_US locale (e.g. 12:05:08 PM)
	 *   * `'shortTime'`: equivalent to `'h:mm a'` for en_US locale (e.g. 12:05 PM)
	 *
	 *   `format` string can contain literal values. These need to be escaped by surrounding with single quotes (e.g.
	 *   `"h 'in the morning'"`). In order to output a single quote, escape it - i.e., two single quotes in a sequence
	 *   (e.g. `"h 'o''clock'"`).
	 *
	 *   Any other characters in the `format` string will be output as-is.
	 *
	 * @param {(Date|number|string)} date Date to format either as Date object, milliseconds (string or
	 *    number) or various ISO 8601 datetime string formats (e.g. yyyy-MM-ddTHH:mm:ss.sssZ and its
	 *    shorter versions like yyyy-MM-ddTHH:mmZ, yyyy-MM-dd or yyyyMMddTHHmmssZ). If no timezone is
	 *    specified in the string input, the time is considered to be in the local timezone.
	 * @param {string=} format Formatting rules (see Description). If not specified,
	 *    `mediumDate` is used.
	 * @param {string=} timezone Timezone to be used for formatting. It understands UTC/GMT and the
	 *    continental US time zone abbreviations, but for general use, use a time zone offset, for
	 *    example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
	 *    If not specified, the timezone of the browser will be used.
	 * @returns {string} Formatted string or the input if input is not recognized as date/millis.
	 *
	 * @example
	   <example name="filter-date">
	     <file name="index.html">
	       <span ng-non-bindable>{{1288323623006 | date:'medium'}}</span>:
	           <span>{{1288323623006 | date:'medium'}}</span><br>
	       <span ng-non-bindable>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span>:
	          <span>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span><br>
	       <span ng-non-bindable>{{1288323623006 | date:'MM/dd/yyyy @ h:mma'}}</span>:
	          <span>{{'1288323623006' | date:'MM/dd/yyyy @ h:mma'}}</span><br>
	       <span ng-non-bindable>{{1288323623006 | date:"MM/dd/yyyy 'at' h:mma"}}</span>:
	          <span>{{'1288323623006' | date:"MM/dd/yyyy 'at' h:mma"}}</span><br>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should format date', function() {
	         expect(element(by.binding("1288323623006 | date:'medium'")).getText()).
	            toMatch(/Oct 2\d, 2010 \d{1,2}:\d{2}:\d{2} (AM|PM)/);
	         expect(element(by.binding("1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'")).getText()).
	            toMatch(/2010-10-2\d \d{2}:\d{2}:\d{2} (-|\+)?\d{4}/);
	         expect(element(by.binding("'1288323623006' | date:'MM/dd/yyyy @ h:mma'")).getText()).
	            toMatch(/10\/2\d\/2010 @ \d{1,2}:\d{2}(AM|PM)/);
	         expect(element(by.binding("'1288323623006' | date:\"MM/dd/yyyy 'at' h:mma\"")).getText()).
	            toMatch(/10\/2\d\/2010 at \d{1,2}:\d{2}(AM|PM)/);
	       });
	     </file>
	   </example>
	 */
	dateFilter.$inject = ['$locale'];
	function dateFilter($locale) {
	
	
	  var R_ISO8601_STR = /^(\d{4})-?(\d\d)-?(\d\d)(?:T(\d\d)(?::?(\d\d)(?::?(\d\d)(?:\.(\d+))?)?)?(Z|([+-])(\d\d):?(\d\d))?)?$/;
	                     // 1        2       3         4          5          6          7          8  9     10      11
	  function jsonStringToDate(string) {
	    var match;
	    if ((match = string.match(R_ISO8601_STR))) {
	      var date = new Date(0),
	          tzHour = 0,
	          tzMin  = 0,
	          dateSetter = match[8] ? date.setUTCFullYear : date.setFullYear,
	          timeSetter = match[8] ? date.setUTCHours : date.setHours;
	
	      if (match[9]) {
	        tzHour = toInt(match[9] + match[10]);
	        tzMin = toInt(match[9] + match[11]);
	      }
	      dateSetter.call(date, toInt(match[1]), toInt(match[2]) - 1, toInt(match[3]));
	      var h = toInt(match[4] || 0) - tzHour;
	      var m = toInt(match[5] || 0) - tzMin;
	      var s = toInt(match[6] || 0);
	      var ms = Math.round(parseFloat('0.' + (match[7] || 0)) * 1000);
	      timeSetter.call(date, h, m, s, ms);
	      return date;
	    }
	    return string;
	  }
	
	
	  return function(date, format, timezone) {
	    var text = '',
	        parts = [],
	        fn, match;
	
	    format = format || 'mediumDate';
	    format = $locale.DATETIME_FORMATS[format] || format;
	    if (isString(date)) {
	      date = NUMBER_STRING.test(date) ? toInt(date) : jsonStringToDate(date);
	    }
	
	    if (isNumber(date)) {
	      date = new Date(date);
	    }
	
	    if (!isDate(date) || !isFinite(date.getTime())) {
	      return date;
	    }
	
	    while (format) {
	      match = DATE_FORMATS_SPLIT.exec(format);
	      if (match) {
	        parts = concat(parts, match, 1);
	        format = parts.pop();
	      } else {
	        parts.push(format);
	        format = null;
	      }
	    }
	
	    var dateTimezoneOffset = date.getTimezoneOffset();
	    if (timezone) {
	      dateTimezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
	      date = convertTimezoneToLocal(date, timezone, true);
	    }
	    forEach(parts, function(value) {
	      fn = DATE_FORMATS[value];
	      text += fn ? fn(date, $locale.DATETIME_FORMATS, dateTimezoneOffset)
	                 : value === '\'\'' ? '\'' : value.replace(/(^'|'$)/g, '').replace(/''/g, '\'');
	    });
	
	    return text;
	  };
	}
	
	
	/**
	 * @ngdoc filter
	 * @name json
	 * @kind function
	 *
	 * @description
	 *   Allows you to convert a JavaScript object into JSON string.
	 *
	 *   This filter is mostly useful for debugging. When using the double curly {{value}} notation
	 *   the binding is automatically converted to JSON.
	 *
	 * @param {*} object Any JavaScript object (including arrays and primitive types) to filter.
	 * @param {number=} spacing The number of spaces to use per indentation, defaults to 2.
	 * @returns {string} JSON string.
	 *
	 *
	 * @example
	   <example name="filter-json">
	     <file name="index.html">
	       <pre id="default-spacing">{{ {'name':'value'} | json }}</pre>
	       <pre id="custom-spacing">{{ {'name':'value'} | json:4 }}</pre>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should jsonify filtered objects', function() {
	         expect(element(by.id('default-spacing')).getText()).toMatch(/\{\n {2}"name": ?"value"\n}/);
	         expect(element(by.id('custom-spacing')).getText()).toMatch(/\{\n {4}"name": ?"value"\n}/);
	       });
	     </file>
	   </example>
	 *
	 */
	function jsonFilter() {
	  return function(object, spacing) {
	    if (isUndefined(spacing)) {
	        spacing = 2;
	    }
	    return toJson(object, spacing);
	  };
	}
	
	
	/**
	 * @ngdoc filter
	 * @name lowercase
	 * @kind function
	 * @description
	 * Converts string to lowercase.
	 *
	 * See the {@link ng.uppercase uppercase filter documentation} for a functionally identical example.
	 *
	 * @see angular.lowercase
	 */
	var lowercaseFilter = valueFn(lowercase);
	
	
	/**
	 * @ngdoc filter
	 * @name uppercase
	 * @kind function
	 * @description
	 * Converts string to uppercase.
	 * @example
	   <example module="uppercaseFilterExample" name="filter-uppercase">
	     <file name="index.html">
	       <script>
	         angular.module('uppercaseFilterExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.title = 'This is a title';
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <!-- This title should be formatted normally -->
	         <h1>{{title}}</h1>
	         <!-- This title should be capitalized -->
	         <h1>{{title | uppercase}}</h1>
	       </div>
	     </file>
	   </example>
	 */
	var uppercaseFilter = valueFn(uppercase);
	
	/**
	 * @ngdoc filter
	 * @name limitTo
	 * @kind function
	 *
	 * @description
	 * Creates a new array or string containing only a specified number of elements. The elements are
	 * taken from either the beginning or the end of the source array, string or number, as specified by
	 * the value and sign (positive or negative) of `limit`. Other array-like objects are also supported
	 * (e.g. array subclasses, NodeLists, jqLite/jQuery collections etc). If a number is used as input,
	 * it is converted to a string.
	 *
	 * @param {Array|ArrayLike|string|number} input - Array/array-like, string or number to be limited.
	 * @param {string|number} limit - The length of the returned array or string. If the `limit` number
	 *     is positive, `limit` number of items from the beginning of the source array/string are copied.
	 *     If the number is negative, `limit` number  of items from the end of the source array/string
	 *     are copied. The `limit` will be trimmed if it exceeds `array.length`. If `limit` is undefined,
	 *     the input will be returned unchanged.
	 * @param {(string|number)=} begin - Index at which to begin limitation. As a negative index,
	 *     `begin` indicates an offset from the end of `input`. Defaults to `0`.
	 * @returns {Array|string} A new sub-array or substring of length `limit` or less if the input had
	 *     less than `limit` elements.
	 *
	 * @example
	   <example module="limitToExample" name="limit-to-filter">
	     <file name="index.html">
	       <script>
	         angular.module('limitToExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.numbers = [1,2,3,4,5,6,7,8,9];
	             $scope.letters = "abcdefghi";
	             $scope.longNumber = 2345432342;
	             $scope.numLimit = 3;
	             $scope.letterLimit = 3;
	             $scope.longNumberLimit = 3;
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <label>
	            Limit {{numbers}} to:
	            <input type="number" step="1" ng-model="numLimit">
	         </label>
	         <p>Output numbers: {{ numbers | limitTo:numLimit }}</p>
	         <label>
	            Limit {{letters}} to:
	            <input type="number" step="1" ng-model="letterLimit">
	         </label>
	         <p>Output letters: {{ letters | limitTo:letterLimit }}</p>
	         <label>
	            Limit {{longNumber}} to:
	            <input type="number" step="1" ng-model="longNumberLimit">
	         </label>
	         <p>Output long number: {{ longNumber | limitTo:longNumberLimit }}</p>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       var numLimitInput = element(by.model('numLimit'));
	       var letterLimitInput = element(by.model('letterLimit'));
	       var longNumberLimitInput = element(by.model('longNumberLimit'));
	       var limitedNumbers = element(by.binding('numbers | limitTo:numLimit'));
	       var limitedLetters = element(by.binding('letters | limitTo:letterLimit'));
	       var limitedLongNumber = element(by.binding('longNumber | limitTo:longNumberLimit'));
	
	       it('should limit the number array to first three items', function() {
	         expect(numLimitInput.getAttribute('value')).toBe('3');
	         expect(letterLimitInput.getAttribute('value')).toBe('3');
	         expect(longNumberLimitInput.getAttribute('value')).toBe('3');
	         expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3]');
	         expect(limitedLetters.getText()).toEqual('Output letters: abc');
	         expect(limitedLongNumber.getText()).toEqual('Output long number: 234');
	       });
	
	       // There is a bug in safari and protractor that doesn't like the minus key
	       // it('should update the output when -3 is entered', function() {
	       //   numLimitInput.clear();
	       //   numLimitInput.sendKeys('-3');
	       //   letterLimitInput.clear();
	       //   letterLimitInput.sendKeys('-3');
	       //   longNumberLimitInput.clear();
	       //   longNumberLimitInput.sendKeys('-3');
	       //   expect(limitedNumbers.getText()).toEqual('Output numbers: [7,8,9]');
	       //   expect(limitedLetters.getText()).toEqual('Output letters: ghi');
	       //   expect(limitedLongNumber.getText()).toEqual('Output long number: 342');
	       // });
	
	       it('should not exceed the maximum size of input array', function() {
	         numLimitInput.clear();
	         numLimitInput.sendKeys('100');
	         letterLimitInput.clear();
	         letterLimitInput.sendKeys('100');
	         longNumberLimitInput.clear();
	         longNumberLimitInput.sendKeys('100');
	         expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3,4,5,6,7,8,9]');
	         expect(limitedLetters.getText()).toEqual('Output letters: abcdefghi');
	         expect(limitedLongNumber.getText()).toEqual('Output long number: 2345432342');
	       });
	     </file>
	   </example>
	*/
	function limitToFilter() {
	  return function(input, limit, begin) {
	    if (Math.abs(Number(limit)) === Infinity) {
	      limit = Number(limit);
	    } else {
	      limit = toInt(limit);
	    }
	    if (isNumberNaN(limit)) return input;
	
	    if (isNumber(input)) input = input.toString();
	    if (!isArrayLike(input)) return input;
	
	    begin = (!begin || isNaN(begin)) ? 0 : toInt(begin);
	    begin = (begin < 0) ? Math.max(0, input.length + begin) : begin;
	
	    if (limit >= 0) {
	      return sliceFn(input, begin, begin + limit);
	    } else {
	      if (begin === 0) {
	        return sliceFn(input, limit, input.length);
	      } else {
	        return sliceFn(input, Math.max(0, begin + limit), begin);
	      }
	    }
	  };
	}
	
	function sliceFn(input, begin, end) {
	  if (isString(input)) return input.slice(begin, end);
	
	  return slice.call(input, begin, end);
	}
	
	/**
	 * @ngdoc filter
	 * @name orderBy
	 * @kind function
	 *
	 * @description
	 * Returns an array containing the items from the specified `collection`, ordered by a `comparator`
	 * function based on the values computed using the `expression` predicate.
	 *
	 * For example, `[{id: 'foo'}, {id: 'bar'}] | orderBy:'id'` would result in
	 * `[{id: 'bar'}, {id: 'foo'}]`.
	 *
	 * The `collection` can be an Array or array-like object (e.g. NodeList, jQuery object, TypedArray,
	 * String, etc).
	 *
	 * The `expression` can be a single predicate, or a list of predicates each serving as a tie-breaker
	 * for the preceding one. The `expression` is evaluated against each item and the output is used
	 * for comparing with other items.
	 *
	 * You can change the sorting order by setting `reverse` to `true`. By default, items are sorted in
	 * ascending order.
	 *
	 * The comparison is done using the `comparator` function. If none is specified, a default, built-in
	 * comparator is used (see below for details - in a nutshell, it compares numbers numerically and
	 * strings alphabetically).
	 *
	 * ### Under the hood
	 *
	 * Ordering the specified `collection` happens in two phases:
	 *
	 * 1. All items are passed through the predicate (or predicates), and the returned values are saved
	 *    along with their type (`string`, `number` etc). For example, an item `{label: 'foo'}`, passed
	 *    through a predicate that extracts the value of the `label` property, would be transformed to:
	 *    ```
	 *    {
	 *      value: 'foo',
	 *      type: 'string',
	 *      index: ...
	 *    }
	 *    ```
	 *    **Note:** `null` values use `'null'` as their type.
	 * 2. The comparator function is used to sort the items, based on the derived values, types and
	 *    indices.
	 *
	 * If you use a custom comparator, it will be called with pairs of objects of the form
	 * `{value: ..., type: '...', index: ...}` and is expected to return `0` if the objects are equal
	 * (as far as the comparator is concerned), `-1` if the 1st one should be ranked higher than the
	 * second, or `1` otherwise.
	 *
	 * In order to ensure that the sorting will be deterministic across platforms, if none of the
	 * specified predicates can distinguish between two items, `orderBy` will automatically introduce a
	 * dummy predicate that returns the item's index as `value`.
	 * (If you are using a custom comparator, make sure it can handle this predicate as well.)
	 *
	 * If a custom comparator still can't distinguish between two items, then they will be sorted based
	 * on their index using the built-in comparator.
	 *
	 * Finally, in an attempt to simplify things, if a predicate returns an object as the extracted
	 * value for an item, `orderBy` will try to convert that object to a primitive value, before passing
	 * it to the comparator. The following rules govern the conversion:
	 *
	 * 1. If the object has a `valueOf()` method that returns a primitive, its return value will be
	 *    used instead.<br />
	 *    (If the object has a `valueOf()` method that returns another object, then the returned object
	 *    will be used in subsequent steps.)
	 * 2. If the object has a custom `toString()` method (i.e. not the one inherited from `Object`) that
	 *    returns a primitive, its return value will be used instead.<br />
	 *    (If the object has a `toString()` method that returns another object, then the returned object
	 *    will be used in subsequent steps.)
	 * 3. No conversion; the object itself is used.
	 *
	 * ### The default comparator
	 *
	 * The default, built-in comparator should be sufficient for most usecases. In short, it compares
	 * numbers numerically, strings alphabetically (and case-insensitively), for objects falls back to
	 * using their index in the original collection, sorts values of different types by type and puts
	 * `undefined` and `null` values at the end of the sorted list.
	 *
	 * More specifically, it follows these steps to determine the relative order of items:
	 *
	 * 1. If the compared values are of different types:
	 *    - If one of the values is undefined, consider it "greater than" the other.
	 *    - Else if one of the values is null, consider it "greater than" the other.
	 *    - Else compare the types themselves alphabetically.
	 * 2. If both values are of type `string`, compare them alphabetically in a case- and
	 *    locale-insensitive way.
	 * 3. If both values are objects, compare their indices instead.
	 * 4. Otherwise, return:
	 *    -  `0`, if the values are equal (by strict equality comparison, i.e. using `===`).
	 *    - `-1`, if the 1st value is "less than" the 2nd value (compared using the `<` operator).
	 *    -  `1`, otherwise.
	 *
	 * **Note:** If you notice numbers not being sorted as expected, make sure they are actually being
	 *           saved as numbers and not strings.
	 * **Note:** For the purpose of sorting, `null` and `undefined` are considered "greater than"
	 *           any other value (with undefined "greater than" null). This effectively means that `null`
	 *           and `undefined` values end up at the end of a list sorted in ascending order.
	 * **Note:** `null` values use `'null'` as their type to be able to distinguish them from objects.
	 *
	 * @param {Array|ArrayLike} collection - The collection (array or array-like object) to sort.
	 * @param {(Function|string|Array.<Function|string>)=} expression - A predicate (or list of
	 *    predicates) to be used by the comparator to determine the order of elements.
	 *
	 *    Can be one of:
	 *
	 *    - `Function`: A getter function. This function will be called with each item as argument and
	 *      the return value will be used for sorting.
	 *    - `string`: An AngularJS expression. This expression will be evaluated against each item and the
	 *      result will be used for sorting. For example, use `'label'` to sort by a property called
	 *      `label` or `'label.substring(0, 3)'` to sort by the first 3 characters of the `label`
	 *      property.<br />
	 *      (The result of a constant expression is interpreted as a property name to be used for
	 *      comparison. For example, use `'"special name"'` (note the extra pair of quotes) to sort by a
	 *      property called `special name`.)<br />
	 *      An expression can be optionally prefixed with `+` or `-` to control the sorting direction,
	 *      ascending or descending. For example, `'+label'` or `'-label'`. If no property is provided,
	 *      (e.g. `'+'` or `'-'`), the collection element itself is used in comparisons.
	 *    - `Array`: An array of function and/or string predicates. If a predicate cannot determine the
	 *      relative order of two items, the next predicate is used as a tie-breaker.
	 *
	 * **Note:** If the predicate is missing or empty then it defaults to `'+'`.
	 *
	 * @param {boolean=} reverse - If `true`, reverse the sorting order.
	 * @param {(Function)=} comparator - The comparator function used to determine the relative order of
	 *    value pairs. If omitted, the built-in comparator will be used.
	 *
	 * @returns {Array} - The sorted array.
	 *
	 *
	 * @example
	 * ### Ordering a table with `ngRepeat`
	 *
	 * The example below demonstrates a simple {@link ngRepeat ngRepeat}, where the data is sorted by
	 * age in descending order (expression is set to `'-age'`). The `comparator` is not set, which means
	 * it defaults to the built-in comparator.
	 *
	   <example name="orderBy-static" module="orderByExample1">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <table class="friends">
	           <tr>
	             <th>Name</th>
	             <th>Phone Number</th>
	             <th>Age</th>
	           </tr>
	           <tr ng-repeat="friend in friends | orderBy:'-age'">
	             <td>{{friend.name}}</td>
	             <td>{{friend.phone}}</td>
	             <td>{{friend.age}}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample1', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.friends = [
	             {name: 'John',   phone: '555-1212',  age: 10},
	             {name: 'Mary',   phone: '555-9876',  age: 19},
	             {name: 'Mike',   phone: '555-4321',  age: 21},
	             {name: 'Adam',   phone: '555-5678',  age: 35},
	             {name: 'Julie',  phone: '555-8765',  age: 29}
	           ];
	         }]);
	     </file>
	     <file name="style.css">
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var names = element.all(by.repeater('friends').column('friend.name'));
	
	       it('should sort friends by age in reverse order', function() {
	         expect(names.get(0).getText()).toBe('Adam');
	         expect(names.get(1).getText()).toBe('Julie');
	         expect(names.get(2).getText()).toBe('Mike');
	         expect(names.get(3).getText()).toBe('Mary');
	         expect(names.get(4).getText()).toBe('John');
	       });
	     </file>
	   </example>
	 * <hr />
	 *
	 * @example
	 * ### Changing parameters dynamically
	 *
	 * All parameters can be changed dynamically. The next example shows how you can make the columns of
	 * a table sortable, by binding the `expression` and `reverse` parameters to scope properties.
	 *
	   <example name="orderBy-dynamic" module="orderByExample2">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <pre>Sort by = {{propertyName}}; reverse = {{reverse}}</pre>
	         <hr/>
	         <button ng-click="propertyName = null; reverse = false">Set to unsorted</button>
	         <hr/>
	         <table class="friends">
	           <tr>
	             <th>
	               <button ng-click="sortBy('name')">Name</button>
	               <span class="sortorder" ng-show="propertyName === 'name'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('phone')">Phone Number</button>
	               <span class="sortorder" ng-show="propertyName === 'phone'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('age')">Age</button>
	               <span class="sortorder" ng-show="propertyName === 'age'" ng-class="{reverse: reverse}"></span>
	             </th>
	           </tr>
	           <tr ng-repeat="friend in friends | orderBy:propertyName:reverse">
	             <td>{{friend.name}}</td>
	             <td>{{friend.phone}}</td>
	             <td>{{friend.age}}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample2', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           var friends = [
	             {name: 'John',   phone: '555-1212',  age: 10},
	             {name: 'Mary',   phone: '555-9876',  age: 19},
	             {name: 'Mike',   phone: '555-4321',  age: 21},
	             {name: 'Adam',   phone: '555-5678',  age: 35},
	             {name: 'Julie',  phone: '555-8765',  age: 29}
	           ];
	
	           $scope.propertyName = 'age';
	           $scope.reverse = true;
	           $scope.friends = friends;
	
	           $scope.sortBy = function(propertyName) {
	             $scope.reverse = ($scope.propertyName === propertyName) ? !$scope.reverse : false;
	             $scope.propertyName = propertyName;
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	
	       .sortorder:after {
	         content: '\25b2';   // BLACK UP-POINTING TRIANGLE
	       }
	       .sortorder.reverse:after {
	         content: '\25bc';   // BLACK DOWN-POINTING TRIANGLE
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var unsortButton = element(by.partialButtonText('unsorted'));
	       var nameHeader = element(by.partialButtonText('Name'));
	       var phoneHeader = element(by.partialButtonText('Phone'));
	       var ageHeader = element(by.partialButtonText('Age'));
	       var firstName = element(by.repeater('friends').column('friend.name').row(0));
	       var lastName = element(by.repeater('friends').column('friend.name').row(4));
	
	       it('should sort friends by some property, when clicking on the column header', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         phoneHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Mary');
	
	         nameHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('Mike');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	       });
	
	       it('should sort friends in reverse order, when clicking on the same column', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	       });
	
	       it('should restore the original order, when clicking "Set to unsorted"', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         unsortButton.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Julie');
	       });
	     </file>
	   </example>
	 * <hr />
	 *
	 * @example
	 * ### Using `orderBy` inside a controller
	 *
	 * It is also possible to call the `orderBy` filter manually, by injecting `orderByFilter`, and
	 * calling it with the desired parameters. (Alternatively, you could inject the `$filter` factory
	 * and retrieve the `orderBy` filter with `$filter('orderBy')`.)
	 *
	   <example name="orderBy-call-manually" module="orderByExample3">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <pre>Sort by = {{propertyName}}; reverse = {{reverse}}</pre>
	         <hr/>
	         <button ng-click="sortBy(null)">Set to unsorted</button>
	         <hr/>
	         <table class="friends">
	           <tr>
	             <th>
	               <button ng-click="sortBy('name')">Name</button>
	               <span class="sortorder" ng-show="propertyName === 'name'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('phone')">Phone Number</button>
	               <span class="sortorder" ng-show="propertyName === 'phone'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('age')">Age</button>
	               <span class="sortorder" ng-show="propertyName === 'age'" ng-class="{reverse: reverse}"></span>
	             </th>
	           </tr>
	           <tr ng-repeat="friend in friends">
	             <td>{{friend.name}}</td>
	             <td>{{friend.phone}}</td>
	             <td>{{friend.age}}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample3', [])
	         .controller('ExampleController', ['$scope', 'orderByFilter', function($scope, orderBy) {
	           var friends = [
	             {name: 'John',   phone: '555-1212',  age: 10},
	             {name: 'Mary',   phone: '555-9876',  age: 19},
	             {name: 'Mike',   phone: '555-4321',  age: 21},
	             {name: 'Adam',   phone: '555-5678',  age: 35},
	             {name: 'Julie',  phone: '555-8765',  age: 29}
	           ];
	
	           $scope.propertyName = 'age';
	           $scope.reverse = true;
	           $scope.friends = orderBy(friends, $scope.propertyName, $scope.reverse);
	
	           $scope.sortBy = function(propertyName) {
	             $scope.reverse = (propertyName !== null && $scope.propertyName === propertyName)
	                 ? !$scope.reverse : false;
	             $scope.propertyName = propertyName;
	             $scope.friends = orderBy(friends, $scope.propertyName, $scope.reverse);
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	
	       .sortorder:after {
	         content: '\25b2';   // BLACK UP-POINTING TRIANGLE
	       }
	       .sortorder.reverse:after {
	         content: '\25bc';   // BLACK DOWN-POINTING TRIANGLE
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var unsortButton = element(by.partialButtonText('unsorted'));
	       var nameHeader = element(by.partialButtonText('Name'));
	       var phoneHeader = element(by.partialButtonText('Phone'));
	       var ageHeader = element(by.partialButtonText('Age'));
	       var firstName = element(by.repeater('friends').column('friend.name').row(0));
	       var lastName = element(by.repeater('friends').column('friend.name').row(4));
	
	       it('should sort friends by some property, when clicking on the column header', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         phoneHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Mary');
	
	         nameHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('Mike');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	       });
	
	       it('should sort friends in reverse order, when clicking on the same column', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	       });
	
	       it('should restore the original order, when clicking "Set to unsorted"', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         unsortButton.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Julie');
	       });
	     </file>
	   </example>
	 * <hr />
	 *
	 * @example
	 * ### Using a custom comparator
	 *
	 * If you have very specific requirements about the way items are sorted, you can pass your own
	 * comparator function. For example, you might need to compare some strings in a locale-sensitive
	 * way. (When specifying a custom comparator, you also need to pass a value for the `reverse`
	 * argument - passing `false` retains the default sorting order, i.e. ascending.)
	 *
	   <example name="orderBy-custom-comparator" module="orderByExample4">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <div class="friends-container custom-comparator">
	           <h3>Locale-sensitive Comparator</h3>
	           <table class="friends">
	             <tr>
	               <th>Name</th>
	               <th>Favorite Letter</th>
	             </tr>
	             <tr ng-repeat="friend in friends | orderBy:'favoriteLetter':false:localeSensitiveComparator">
	               <td>{{friend.name}}</td>
	               <td>{{friend.favoriteLetter}}</td>
	             </tr>
	           </table>
	         </div>
	         <div class="friends-container default-comparator">
	           <h3>Default Comparator</h3>
	           <table class="friends">
	             <tr>
	               <th>Name</th>
	               <th>Favorite Letter</th>
	             </tr>
	             <tr ng-repeat="friend in friends | orderBy:'favoriteLetter'">
	               <td>{{friend.name}}</td>
	               <td>{{friend.favoriteLetter}}</td>
	             </tr>
	           </table>
	         </div>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample4', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.friends = [
	             {name: 'John',   favoriteLetter: 'Ä'},
	             {name: 'Mary',   favoriteLetter: 'Ü'},
	             {name: 'Mike',   favoriteLetter: 'Ö'},
	             {name: 'Adam',   favoriteLetter: 'H'},
	             {name: 'Julie',  favoriteLetter: 'Z'}
	           ];
	
	           $scope.localeSensitiveComparator = function(v1, v2) {
	             // If we don't get strings, just compare by index
	             if (v1.type !== 'string' || v2.type !== 'string') {
	               return (v1.index < v2.index) ? -1 : 1;
	             }
	
	             // Compare strings alphabetically, taking locale into account
	             return v1.value.localeCompare(v2.value);
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       .friends-container {
	         display: inline-block;
	         margin: 0 30px;
	       }
	
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var container = element(by.css('.custom-comparator'));
	       var names = container.all(by.repeater('friends').column('friend.name'));
	
	       it('should sort friends by favorite letter (in correct alphabetical order)', function() {
	         expect(names.get(0).getText()).toBe('John');
	         expect(names.get(1).getText()).toBe('Adam');
	         expect(names.get(2).getText()).toBe('Mike');
	         expect(names.get(3).getText()).toBe('Mary');
	         expect(names.get(4).getText()).toBe('Julie');
	       });
	     </file>
	   </example>
	 *
	 */
	orderByFilter.$inject = ['$parse'];
	function orderByFilter($parse) {
	  return function(array, sortPredicate, reverseOrder, compareFn) {
	
	    if (array == null) return array;
	    if (!isArrayLike(array)) {
	      throw minErr('orderBy')('notarray', 'Expected array but received: {0}', array);
	    }
	
	    if (!isArray(sortPredicate)) { sortPredicate = [sortPredicate]; }
	    if (sortPredicate.length === 0) { sortPredicate = ['+']; }
	
	    var predicates = processPredicates(sortPredicate);
	
	    var descending = reverseOrder ? -1 : 1;
	
	    // Define the `compare()` function. Use a default comparator if none is specified.
	    var compare = isFunction(compareFn) ? compareFn : defaultCompare;
	
	    // The next three lines are a version of a Swartzian Transform idiom from Perl
	    // (sometimes called the Decorate-Sort-Undecorate idiom)
	    // See https://en.wikipedia.org/wiki/Schwartzian_transform
	    var compareValues = Array.prototype.map.call(array, getComparisonObject);
	    compareValues.sort(doComparison);
	    array = compareValues.map(function(item) { return item.value; });
	
	    return array;
	
	    function getComparisonObject(value, index) {
	      // NOTE: We are adding an extra `tieBreaker` value based on the element's index.
	      // This will be used to keep the sort stable when none of the input predicates can
	      // distinguish between two elements.
	      return {
	        value: value,
	        tieBreaker: {value: index, type: 'number', index: index},
	        predicateValues: predicates.map(function(predicate) {
	          return getPredicateValue(predicate.get(value), index);
	        })
	      };
	    }
	
	    function doComparison(v1, v2) {
	      for (var i = 0, ii = predicates.length; i < ii; i++) {
	        var result = compare(v1.predicateValues[i], v2.predicateValues[i]);
	        if (result) {
	          return result * predicates[i].descending * descending;
	        }
	      }
	
	      return (compare(v1.tieBreaker, v2.tieBreaker) || defaultCompare(v1.tieBreaker, v2.tieBreaker)) * descending;
	    }
	  };
	
	  function processPredicates(sortPredicates) {
	    return sortPredicates.map(function(predicate) {
	      var descending = 1, get = identity;
	
	      if (isFunction(predicate)) {
	        get = predicate;
	      } else if (isString(predicate)) {
	        if ((predicate.charAt(0) === '+' || predicate.charAt(0) === '-')) {
	          descending = predicate.charAt(0) === '-' ? -1 : 1;
	          predicate = predicate.substring(1);
	        }
	        if (predicate !== '') {
	          get = $parse(predicate);
	          if (get.constant) {
	            var key = get();
	            get = function(value) { return value[key]; };
	          }
	        }
	      }
	      return {get: get, descending: descending};
	    });
	  }
	
	  function isPrimitive(value) {
	    switch (typeof value) {
	      case 'number': /* falls through */
	      case 'boolean': /* falls through */
	      case 'string':
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function objectValue(value) {
	    // If `valueOf` is a valid function use that
	    if (isFunction(value.valueOf)) {
	      value = value.valueOf();
	      if (isPrimitive(value)) return value;
	    }
	    // If `toString` is a valid function and not the one from `Object.prototype` use that
	    if (hasCustomToString(value)) {
	      value = value.toString();
	      if (isPrimitive(value)) return value;
	    }
	
	    return value;
	  }
	
	  function getPredicateValue(value, index) {
	    var type = typeof value;
	    if (value === null) {
	      type = 'null';
	    } else if (type === 'object') {
	      value = objectValue(value);
	    }
	    return {value: value, type: type, index: index};
	  }
	
	  function defaultCompare(v1, v2) {
	    var result = 0;
	    var type1 = v1.type;
	    var type2 = v2.type;
	
	    if (type1 === type2) {
	      var value1 = v1.value;
	      var value2 = v2.value;
	
	      if (type1 === 'string') {
	        // Compare strings case-insensitively
	        value1 = value1.toLowerCase();
	        value2 = value2.toLowerCase();
	      } else if (type1 === 'object') {
	        // For basic objects, use the position of the object
	        // in the collection instead of the value
	        if (isObject(value1)) value1 = v1.index;
	        if (isObject(value2)) value2 = v2.index;
	      }
	
	      if (value1 !== value2) {
	        result = value1 < value2 ? -1 : 1;
	      }
	    } else {
	      result = (type1 === 'undefined') ? 1 :
	        (type2 === 'undefined') ? -1 :
	        (type1 === 'null') ? 1 :
	        (type2 === 'null') ? -1 :
	        (type1 < type2) ? -1 : 1;
	    }
	
	    return result;
	  }
	}
	
	function ngDirective(directive) {
	  if (isFunction(directive)) {
	    directive = {
	      link: directive
	    };
	  }
	  directive.restrict = directive.restrict || 'AC';
	  return valueFn(directive);
	}
	
	/**
	 * @ngdoc directive
	 * @name a
	 * @restrict E
	 *
	 * @description
	 * Modifies the default behavior of the html a tag so that the default action is prevented when
	 * the href attribute is empty.
	 *
	 * For dynamically creating `href` attributes for a tags, see the {@link ng.ngHref `ngHref`} directive.
	 */
	var htmlAnchorDirective = valueFn({
	  restrict: 'E',
	  compile: function(element, attr) {
	    if (!attr.href && !attr.xlinkHref) {
	      return function(scope, element) {
	        // If the linked element is not an anchor tag anymore, do nothing
	        if (element[0].nodeName.toLowerCase() !== 'a') return;
	
	        // SVGAElement does not use the href attribute, but rather the 'xlinkHref' attribute.
	        var href = toString.call(element.prop('href')) === '[object SVGAnimatedString]' ?
	                   'xlink:href' : 'href';
	        element.on('click', function(event) {
	          // if we have no href url, then don't navigate anywhere.
	          if (!element.attr(href)) {
	            event.preventDefault();
	          }
	        });
	      };
	    }
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngHref
	 * @restrict A
	 * @priority 99
	 *
	 * @description
	 * Using AngularJS markup like `{{hash}}` in an href attribute will
	 * make the link go to the wrong URL if the user clicks it before
	 * AngularJS has a chance to replace the `{{hash}}` markup with its
	 * value. Until AngularJS replaces the markup the link will be broken
	 * and will most likely return a 404 error. The `ngHref` directive
	 * solves this problem.
	 *
	 * The wrong way to write it:
	 * ```html
	 * <a href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
	 * ```
	 *
	 * The correct way to write it:
	 * ```html
	 * <a ng-href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
	 * ```
	 *
	 * @element A
	 * @param {template} ngHref any string which can contain `{{}}` markup.
	 *
	 * @example
	 * This example shows various combinations of `href`, `ng-href` and `ng-click` attributes
	 * in links and their different behaviors:
	    <example name="ng-href">
	      <file name="index.html">
	        <input ng-model="value" /><br />
	        <a id="link-1" href ng-click="value = 1">link 1</a> (link, don't reload)<br />
	        <a id="link-2" href="" ng-click="value = 2">link 2</a> (link, don't reload)<br />
	        <a id="link-3" ng-href="/{{'123'}}">link 3</a> (link, reload!)<br />
	        <a id="link-4" href="" name="xx" ng-click="value = 4">anchor</a> (link, don't reload)<br />
	        <a id="link-5" name="xxx" ng-click="value = 5">anchor</a> (no link)<br />
	        <a id="link-6" ng-href="{{value}}">link</a> (link, change location)
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should execute ng-click but not reload when href without value', function() {
	          element(by.id('link-1')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('1');
	          expect(element(by.id('link-1')).getAttribute('href')).toBe('');
	        });
	
	        it('should execute ng-click but not reload when href empty string', function() {
	          element(by.id('link-2')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('2');
	          expect(element(by.id('link-2')).getAttribute('href')).toBe('');
	        });
	
	        it('should execute ng-click and change url when ng-href specified', function() {
	          expect(element(by.id('link-3')).getAttribute('href')).toMatch(/\/123$/);
	
	          element(by.id('link-3')).click();
	
	          // At this point, we navigate away from an AngularJS page, so we need
	          // to use browser.driver to get the base webdriver.
	
	          browser.wait(function() {
	            return browser.driver.getCurrentUrl().then(function(url) {
	              return url.match(/\/123$/);
	            });
	          }, 5000, 'page should navigate to /123');
	        });
	
	        it('should execute ng-click but not reload when href empty string and name specified', function() {
	          element(by.id('link-4')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('4');
	          expect(element(by.id('link-4')).getAttribute('href')).toBe('');
	        });
	
	        it('should execute ng-click but not reload when no href but name specified', function() {
	          element(by.id('link-5')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('5');
	          expect(element(by.id('link-5')).getAttribute('href')).toBe(null);
	        });
	
	        it('should only change url when only ng-href', function() {
	          element(by.model('value')).clear();
	          element(by.model('value')).sendKeys('6');
	          expect(element(by.id('link-6')).getAttribute('href')).toMatch(/\/6$/);
	
	          element(by.id('link-6')).click();
	
	          // At this point, we navigate away from an AngularJS page, so we need
	          // to use browser.driver to get the base webdriver.
	          browser.wait(function() {
	            return browser.driver.getCurrentUrl().then(function(url) {
	              return url.match(/\/6$/);
	            });
	          }, 5000, 'page should navigate to /6');
	        });
	      </file>
	    </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngSrc
	 * @restrict A
	 * @priority 99
	 *
	 * @description
	 * Using AngularJS markup like `{{hash}}` in a `src` attribute doesn't
	 * work right: The browser will fetch from the URL with the literal
	 * text `{{hash}}` until AngularJS replaces the expression inside
	 * `{{hash}}`. The `ngSrc` directive solves this problem.
	 *
	 * The buggy way to write it:
	 * ```html
	 * <img src="http://www.gravatar.com/avatar/{{hash}}" alt="Description"/>
	 * ```
	 *
	 * The correct way to write it:
	 * ```html
	 * <img ng-src="http://www.gravatar.com/avatar/{{hash}}" alt="Description" />
	 * ```
	 *
	 * @element IMG
	 * @param {template} ngSrc any string which can contain `{{}}` markup.
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngSrcset
	 * @restrict A
	 * @priority 99
	 *
	 * @description
	 * Using AngularJS markup like `{{hash}}` in a `srcset` attribute doesn't
	 * work right: The browser will fetch from the URL with the literal
	 * text `{{hash}}` until AngularJS replaces the expression inside
	 * `{{hash}}`. The `ngSrcset` directive solves this problem.
	 *
	 * The buggy way to write it:
	 * ```html
	 * <img srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description"/>
	 * ```
	 *
	 * The correct way to write it:
	 * ```html
	 * <img ng-srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description" />
	 * ```
	 *
	 * @element IMG
	 * @param {template} ngSrcset any string which can contain `{{}}` markup.
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngDisabled
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * This directive sets the `disabled` attribute on the element (typically a form control,
	 * e.g. `input`, `button`, `select` etc.) if the
	 * {@link guide/expression expression} inside `ngDisabled` evaluates to truthy.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `disabled`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * @example
	    <example name="ng-disabled">
	      <file name="index.html">
	        <label>Click me to toggle: <input type="checkbox" ng-model="checked"></label><br/>
	        <button ng-model="button" ng-disabled="checked">Button</button>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should toggle button', function() {
	          expect(element(by.css('button')).getAttribute('disabled')).toBeFalsy();
	          element(by.model('checked')).click();
	          expect(element(by.css('button')).getAttribute('disabled')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @param {expression} ngDisabled If the {@link guide/expression expression} is truthy,
	 *     then the `disabled` attribute will be set on the element
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngChecked
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 * Sets the `checked` attribute on the element, if the expression inside `ngChecked` is truthy.
	 *
	 * Note that this directive should not be used together with {@link ngModel `ngModel`},
	 * as this can lead to unexpected behavior.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `checked`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * @example
	    <example name="ng-checked">
	      <file name="index.html">
	        <label>Check me to check both: <input type="checkbox" ng-model="leader"></label><br/>
	        <input id="checkFollower" type="checkbox" ng-checked="leader" aria-label="Follower input">
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should check both checkBoxes', function() {
	          expect(element(by.id('checkFollower')).getAttribute('checked')).toBeFalsy();
	          element(by.model('leader')).click();
	          expect(element(by.id('checkFollower')).getAttribute('checked')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element INPUT
	 * @param {expression} ngChecked If the {@link guide/expression expression} is truthy,
	 *     then the `checked` attribute will be set on the element
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngReadonly
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * Sets the `readonly` attribute on the element, if the expression inside `ngReadonly` is truthy.
	 * Note that `readonly` applies only to `input` elements with specific types. [See the input docs on
	 * MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#attr-readonly) for more information.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `readonly`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * @example
	    <example name="ng-readonly">
	      <file name="index.html">
	        <label>Check me to make text readonly: <input type="checkbox" ng-model="checked"></label><br/>
	        <input type="text" ng-readonly="checked" value="I'm AngularJS" aria-label="Readonly field" />
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should toggle readonly attr', function() {
	          expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeFalsy();
	          element(by.model('checked')).click();
	          expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element INPUT
	 * @param {expression} ngReadonly If the {@link guide/expression expression} is truthy,
	 *     then special attribute "readonly" will be set on the element
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngSelected
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * Sets the `selected` attribute on the element, if the expression inside `ngSelected` is truthy.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `selected`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * <div class="alert alert-warning">
	 *   **Note:** `ngSelected` does not interact with the `select` and `ngModel` directives, it only
	 *   sets the `selected` attribute on the element. If you are using `ngModel` on the select, you
	 *   should not use `ngSelected` on the options, as `ngModel` will set the select value and
	 *   selected options.
	 * </div>
	 *
	 * @example
	    <example name="ng-selected">
	      <file name="index.html">
	        <label>Check me to select: <input type="checkbox" ng-model="selected"></label><br/>
	        <select aria-label="ngSelected demo">
	          <option>Hello!</option>
	          <option id="greet" ng-selected="selected">Greetings!</option>
	        </select>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should select Greetings!', function() {
	          expect(element(by.id('greet')).getAttribute('selected')).toBeFalsy();
	          element(by.model('selected')).click();
	          expect(element(by.id('greet')).getAttribute('selected')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element OPTION
	 * @param {expression} ngSelected If the {@link guide/expression expression} is truthy,
	 *     then special attribute "selected" will be set on the element
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngOpen
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * Sets the `open` attribute on the element, if the expression inside `ngOpen` is truthy.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `open`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * ## A note about browser compatibility
	 *
	 * Internet Explorer and Edge do not support the `details` element, it is
	 * recommended to use {@link ng.ngShow} and {@link ng.ngHide} instead.
	 *
	 * @example
	     <example name="ng-open">
	       <file name="index.html">
	         <label>Toggle details: <input type="checkbox" ng-model="open"></label><br/>
	         <details id="details" ng-open="open">
	            <summary>List</summary>
	            <ul>
	              <li>Apple</li>
	              <li>Orange</li>
	              <li>Durian</li>
	            </ul>
	         </details>
	       </file>
	       <file name="protractor.js" type="protractor">
	         it('should toggle open', function() {
	           expect(element(by.id('details')).getAttribute('open')).toBeFalsy();
	           element(by.model('open')).click();
	           expect(element(by.id('details')).getAttribute('open')).toBeTruthy();
	         });
	       </file>
	     </example>
	 *
	 * @element DETAILS
	 * @param {expression} ngOpen If the {@link guide/expression expression} is truthy,
	 *     then special attribute "open" will be set on the element
	 */
	
	var ngAttributeAliasDirectives = {};
	
	// boolean attrs are evaluated
	forEach(BOOLEAN_ATTR, function(propName, attrName) {
	  // binding to multiple is not supported
	  if (propName === 'multiple') return;
	
	  function defaultLinkFn(scope, element, attr) {
	    scope.$watch(attr[normalized], function ngBooleanAttrWatchAction(value) {
	      attr.$set(attrName, !!value);
	    });
	  }
	
	  var normalized = directiveNormalize('ng-' + attrName);
	  var linkFn = defaultLinkFn;
	
	  if (propName === 'checked') {
	    linkFn = function(scope, element, attr) {
	      // ensuring ngChecked doesn't interfere with ngModel when both are set on the same input
	      if (attr.ngModel !== attr[normalized]) {
	        defaultLinkFn(scope, element, attr);
	      }
	    };
	  }
	
	  ngAttributeAliasDirectives[normalized] = function() {
	    return {
	      restrict: 'A',
	      priority: 100,
	      link: linkFn
	    };
	  };
	});
	
	// aliased input attrs are evaluated
	forEach(ALIASED_ATTR, function(htmlAttr, ngAttr) {
	  ngAttributeAliasDirectives[ngAttr] = function() {
	    return {
	      priority: 100,
	      link: function(scope, element, attr) {
	        //special case ngPattern when a literal regular expression value
	        //is used as the expression (this way we don't have to watch anything).
	        if (ngAttr === 'ngPattern' && attr.ngPattern.charAt(0) === '/') {
	          var match = attr.ngPattern.match(REGEX_STRING_REGEXP);
	          if (match) {
	            attr.$set('ngPattern', new RegExp(match[1], match[2]));
	            return;
	          }
	        }
	
	        scope.$watch(attr[ngAttr], function ngAttrAliasWatchAction(value) {
	          attr.$set(ngAttr, value);
	        });
	      }
	    };
	  };
	});
	
	// ng-src, ng-srcset, ng-href are interpolated
	forEach(['src', 'srcset', 'href'], function(attrName) {
	  var normalized = directiveNormalize('ng-' + attrName);
	  ngAttributeAliasDirectives[normalized] = ['$sce', function($sce) {
	    return {
	      priority: 99, // it needs to run after the attributes are interpolated
	      link: function(scope, element, attr) {
	        var propName = attrName,
	            name = attrName;
	
	        if (attrName === 'href' &&
	            toString.call(element.prop('href')) === '[object SVGAnimatedString]') {
	          name = 'xlinkHref';
	          attr.$attr[name] = 'xlink:href';
	          propName = null;
	        }
	
	        // We need to sanitize the url at least once, in case it is a constant
	        // non-interpolated attribute.
	        attr.$set(normalized, $sce.getTrustedMediaUrl(attr[normalized]));
	
	        attr.$observe(normalized, function(value) {
	          if (!value) {
	            if (attrName === 'href') {
	              attr.$set(name, null);
	            }
	            return;
	          }
	
	          attr.$set(name, value);
	
	          // Support: IE 9-11 only
	          // On IE, if "ng:src" directive declaration is used and "src" attribute doesn't exist
	          // then calling element.setAttribute('src', 'foo') doesn't do anything, so we need
	          // to set the property as well to achieve the desired effect.
	          // We use attr[attrName] value since $set might have sanitized the url.
	          if (msie && propName) element.prop(propName, attr[name]);
	        });
	      }
	    };
	  }];
	});
	
	/* global -nullFormCtrl, -PENDING_CLASS, -SUBMITTED_CLASS
	 */
	var nullFormCtrl = {
	  $addControl: noop,
	  $getControls: valueFn([]),
	  $$renameControl: nullFormRenameControl,
	  $removeControl: noop,
	  $setValidity: noop,
	  $setDirty: noop,
	  $setPristine: noop,
	  $setSubmitted: noop,
	  $$setSubmitted: noop
	},
	PENDING_CLASS = 'ng-pending',
	SUBMITTED_CLASS = 'ng-submitted';
	
	function nullFormRenameControl(control, name) {
	  control.$name = name;
	}
	
	/**
	 * @ngdoc type
	 * @name form.FormController
	 *
	 * @property {boolean} $pristine True if user has not interacted with the form yet.
	 * @property {boolean} $dirty True if user has already interacted with the form.
	 * @property {boolean} $valid True if all of the containing forms and controls are valid.
	 * @property {boolean} $invalid True if at least one containing control or form is invalid.
	 * @property {boolean} $submitted True if user has submitted the form even if its invalid.
	 *
	 * @property {Object} $pending An object hash, containing references to controls or forms with
	 *  pending validators, where:
	 *
	 *  - keys are validations tokens (error names).
	 *  - values are arrays of controls or forms that have a pending validator for the given error name.
	 *
	 * See {@link form.FormController#$error $error} for a list of built-in validation tokens.
	 *
	 * @property {Object} $error An object hash, containing references to controls or forms with failing
	 *  validators, where:
	 *
	 *  - keys are validation tokens (error names),
	 *  - values are arrays of controls or forms that have a failing validator for the given error name.
	 *
	 *  Built-in validation tokens:
	 *  - `email`
	 *  - `max`
	 *  - `maxlength`
	 *  - `min`
	 *  - `minlength`
	 *  - `number`
	 *  - `pattern`
	 *  - `required`
	 *  - `url`
	 *  - `date`
	 *  - `datetimelocal`
	 *  - `time`
	 *  - `week`
	 *  - `month`
	 *
	 * @description
	 * `FormController` keeps track of all its controls and nested forms as well as the state of them,
	 * such as being valid/invalid or dirty/pristine.
	 *
	 * Each {@link ng.directive:form form} directive creates an instance
	 * of `FormController`.
	 *
	 */
	//asks for $scope to fool the BC controller module
	FormController.$inject = ['$element', '$attrs', '$scope', '$animate', '$interpolate'];
	function FormController($element, $attrs, $scope, $animate, $interpolate) {
	  this.$$controls = [];
	
	  // init state
	  this.$error = {};
	  this.$$success = {};
	  this.$pending = undefined;
	  this.$name = $interpolate($attrs.name || $attrs.ngForm || '')($scope);
	  this.$dirty = false;
	  this.$pristine = true;
	  this.$valid = true;
	  this.$invalid = false;
	  this.$submitted = false;
	  this.$$parentForm = nullFormCtrl;
	
	  this.$$element = $element;
	  this.$$animate = $animate;
	
	  setupValidity(this);
	}
	
	FormController.prototype = {
	  /**
	   * @ngdoc method
	   * @name form.FormController#$rollbackViewValue
	   *
	   * @description
	   * Rollback all form controls pending updates to the `$modelValue`.
	   *
	   * Updates may be pending by a debounced event or because the input is waiting for a some future
	   * event defined in `ng-model-options`. This method is typically needed by the reset button of
	   * a form that uses `ng-model-options` to pend updates.
	   */
	  $rollbackViewValue: function() {
	    forEach(this.$$controls, function(control) {
	      control.$rollbackViewValue();
	    });
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$commitViewValue
	   *
	   * @description
	   * Commit all form controls pending updates to the `$modelValue`.
	   *
	   * Updates may be pending by a debounced event or because the input is waiting for a some future
	   * event defined in `ng-model-options`. This method is rarely needed as `NgModelController`
	   * usually handles calling this in response to input events.
	   */
	  $commitViewValue: function() {
	    forEach(this.$$controls, function(control) {
	      control.$commitViewValue();
	    });
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$addControl
	   * @param {object} control control object, either a {@link form.FormController} or an
	   * {@link ngModel.NgModelController}
	   *
	   * @description
	   * Register a control with the form. Input elements using ngModelController do this automatically
	   * when they are linked.
	   *
	   * Note that the current state of the control will not be reflected on the new parent form. This
	   * is not an issue with normal use, as freshly compiled and linked controls are in a `$pristine`
	   * state.
	   *
	   * However, if the method is used programmatically, for example by adding dynamically created controls,
	   * or controls that have been previously removed without destroying their corresponding DOM element,
	   * it's the developers responsibility to make sure the current state propagates to the parent form.
	   *
	   * For example, if an input control is added that is already `$dirty` and has `$error` properties,
	   * calling `$setDirty()` and `$validate()` afterwards will propagate the state to the parent form.
	   */
	  $addControl: function(control) {
	    // Breaking change - before, inputs whose name was "hasOwnProperty" were quietly ignored
	    // and not added to the scope.  Now we throw an error.
	    assertNotHasOwnProperty(control.$name, 'input');
	    this.$$controls.push(control);
	
	    if (control.$name) {
	      this[control.$name] = control;
	    }
	
	    control.$$parentForm = this;
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$getControls
	   * @returns {Array} the controls that are currently part of this form
	   *
	   * @description
	   * This method returns a **shallow copy** of the controls that are currently part of this form.
	   * The controls can be instances of {@link form.FormController `FormController`}
	   * ({@link ngForm "child-forms"}) and of {@link ngModel.NgModelController `NgModelController`}.
	   * If you need access to the controls of child-forms, you have to call `$getControls()`
	   * recursively on them.
	   * This can be used for example to iterate over all controls to validate them.
	   *
	   * The controls can be accessed normally, but adding to, or removing controls from the array has
	   * no effect on the form. Instead, use {@link form.FormController#$addControl `$addControl()`} and
	   * {@link form.FormController#$removeControl `$removeControl()`} for this use-case.
	   * Likewise, adding a control to, or removing a control from the form is not reflected
	   * in the shallow copy. That means you should get a fresh copy from `$getControls()` every time
	   * you need access to the controls.
	   */
	  $getControls: function() {
	    return shallowCopy(this.$$controls);
	  },
	
	  // Private API: rename a form control
	  $$renameControl: function(control, newName) {
	    var oldName = control.$name;
	
	    if (this[oldName] === control) {
	      delete this[oldName];
	    }
	    this[newName] = control;
	    control.$name = newName;
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$removeControl
	   * @param {object} control control object, either a {@link form.FormController} or an
	   * {@link ngModel.NgModelController}
	   *
	   * @description
	   * Deregister a control from the form.
	   *
	   * Input elements using ngModelController do this automatically when they are destroyed.
	   *
	   * Note that only the removed control's validation state (`$errors`etc.) will be removed from the
	   * form. `$dirty`, `$submitted` states will not be changed, because the expected behavior can be
	   * different from case to case. For example, removing the only `$dirty` control from a form may or
	   * may not mean that the form is still `$dirty`.
	   */
	  $removeControl: function(control) {
	    if (control.$name && this[control.$name] === control) {
	      delete this[control.$name];
	    }
	    forEach(this.$pending, function(value, name) {
	      // eslint-disable-next-line no-invalid-this
	      this.$setValidity(name, null, control);
	    }, this);
	    forEach(this.$error, function(value, name) {
	      // eslint-disable-next-line no-invalid-this
	      this.$setValidity(name, null, control);
	    }, this);
	    forEach(this.$$success, function(value, name) {
	      // eslint-disable-next-line no-invalid-this
	      this.$setValidity(name, null, control);
	    }, this);
	
	    arrayRemove(this.$$controls, control);
	    control.$$parentForm = nullFormCtrl;
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setDirty
	   *
	   * @description
	   * Sets the form to a dirty state.
	   *
	   * This method can be called to add the 'ng-dirty' class and set the form to a dirty
	   * state (ng-dirty class). This method will also propagate to parent forms.
	   */
	  $setDirty: function() {
	    this.$$animate.removeClass(this.$$element, PRISTINE_CLASS);
	    this.$$animate.addClass(this.$$element, DIRTY_CLASS);
	    this.$dirty = true;
	    this.$pristine = false;
	    this.$$parentForm.$setDirty();
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setPristine
	   *
	   * @description
	   * Sets the form to its pristine state.
	   *
	   * This method sets the form's `$pristine` state to true, the `$dirty` state to false, removes
	   * the `ng-dirty` class and adds the `ng-pristine` class. Additionally, it sets the `$submitted`
	   * state to false.
	   *
	   * This method will also propagate to all the controls contained in this form.
	   *
	   * Setting a form back to a pristine state is often useful when we want to 'reuse' a form after
	   * saving or resetting it.
	   */
	  $setPristine: function() {
	    this.$$animate.setClass(this.$$element, PRISTINE_CLASS, DIRTY_CLASS + ' ' + SUBMITTED_CLASS);
	    this.$dirty = false;
	    this.$pristine = true;
	    this.$submitted = false;
	    forEach(this.$$controls, function(control) {
	      control.$setPristine();
	    });
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setUntouched
	   *
	   * @description
	   * Sets the form to its untouched state.
	   *
	   * This method can be called to remove the 'ng-touched' class and set the form controls to their
	   * untouched state (ng-untouched class).
	   *
	   * Setting a form controls back to their untouched state is often useful when setting the form
	   * back to its pristine state.
	   */
	  $setUntouched: function() {
	    forEach(this.$$controls, function(control) {
	      control.$setUntouched();
	    });
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setSubmitted
	   *
	   * @description
	   * Sets the form to its `$submitted` state. This will also set `$submitted` on all child and
	   * parent forms of the form.
	   */
	  $setSubmitted: function() {
	    var rootForm = this;
	    while (rootForm.$$parentForm && (rootForm.$$parentForm !== nullFormCtrl)) {
	      rootForm = rootForm.$$parentForm;
	    }
	    rootForm.$$setSubmitted();
	  },
	
	  $$setSubmitted: function() {
	    this.$$animate.addClass(this.$$element, SUBMITTED_CLASS);
	    this.$submitted = true;
	    forEach(this.$$controls, function(control) {
	      if (control.$$setSubmitted) {
	        control.$$setSubmitted();
	      }
	    });
	  }
	};
	
	/**
	 * @ngdoc method
	 * @name form.FormController#$setValidity
	 *
	 * @description
	 * Change the validity state of the form, and notify the parent form (if any).
	 *
	 * Application developers will rarely need to call this method directly. It is used internally, by
	 * {@link ngModel.NgModelController#$setValidity NgModelController.$setValidity()}, to propagate a
	 * control's validity state to the parent `FormController`.
	 *
	 * @param {string} validationErrorKey Name of the validator. The `validationErrorKey` will be
	 *        assigned to either `$error[validationErrorKey]` or `$pending[validationErrorKey]` (for
	 *        unfulfilled `$asyncValidators`), so that it is available for data-binding. The
	 *        `validationErrorKey` should be in camelCase and will get converted into dash-case for
	 *        class name. Example: `myError` will result in `ng-valid-my-error` and
	 *        `ng-invalid-my-error` classes and can be bound to as `{{ someForm.$error.myError }}`.
	 * @param {boolean} isValid Whether the current state is valid (true), invalid (false), pending
	 *        (undefined),  or skipped (null). Pending is used for unfulfilled `$asyncValidators`.
	 *        Skipped is used by AngularJS when validators do not run because of parse errors and when
	 *        `$asyncValidators` do not run because any of the `$validators` failed.
	 * @param {NgModelController | FormController} controller - The controller whose validity state is
	 *        triggering the change.
	 */
	addSetValidityMethod({
	  clazz: FormController,
	  set: function(object, property, controller) {
	    var list = object[property];
	    if (!list) {
	      object[property] = [controller];
	    } else {
	      var index = list.indexOf(controller);
	      if (index === -1) {
	        list.push(controller);
	      }
	    }
	  },
	  unset: function(object, property, controller) {
	    var list = object[property];
	    if (!list) {
	      return;
	    }
	    arrayRemove(list, controller);
	    if (list.length === 0) {
	      delete object[property];
	    }
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngForm
	 * @restrict EAC
	 *
	 * @description
	 * Helper directive that makes it possible to create control groups inside a
	 * {@link ng.directive:form `form`} directive.
	 * These "child forms" can be used, for example, to determine the validity of a sub-group of
	 * controls.
	 *
	 * <div class="alert alert-danger">
	 * **Note**: `ngForm` cannot be used as a replacement for `<form>`, because it lacks its
	 * [built-in HTML functionality](https://html.spec.whatwg.org/#the-form-element).
	 * Specifically, you cannot submit `ngForm` like a `<form>` tag. That means,
	 * you cannot send data to the server with `ngForm`, or integrate it with
	 * {@link ng.directive:ngSubmit `ngSubmit`}.
	 * </div>
	 *
	 * @param {string=} ngForm|name Name of the form. If specified, the form controller will
	 *                              be published into the related scope, under this name.
	 *
	 */
	
	 /**
	 * @ngdoc directive
	 * @name form
	 * @restrict E
	 *
	 * @description
	 * Directive that instantiates
	 * {@link form.FormController FormController}.
	 *
	 * If the `name` attribute is specified, the form controller is published onto the current scope under
	 * this name.
	 *
	 * ## Alias: {@link ng.directive:ngForm `ngForm`}
	 *
	 * In AngularJS, forms can be nested. This means that the outer form is valid when all of the child
	 * forms are valid as well. However, browsers do not allow nesting of `<form>` elements, so
	 * AngularJS provides the {@link ng.directive:ngForm `ngForm`} directive, which behaves identically to
	 * `form` but can be nested. Nested forms can be useful, for example, if the validity of a sub-group
	 * of controls needs to be determined.
	 *
	 * ## CSS classes
	 *  - `ng-valid` is set if the form is valid.
	 *  - `ng-invalid` is set if the form is invalid.
	 *  - `ng-pending` is set if the form is pending.
	 *  - `ng-pristine` is set if the form is pristine.
	 *  - `ng-dirty` is set if the form is dirty.
	 *  - `ng-submitted` is set if the form was submitted.
	 *
	 * Keep in mind that ngAnimate can detect each of these classes when added and removed.
	 *
	 *
	 * ## Submitting a form and preventing the default action
	 *
	 * Since the role of forms in client-side AngularJS applications is different than in classical
	 * roundtrip apps, it is desirable for the browser not to translate the form submission into a full
	 * page reload that sends the data to the server. Instead some javascript logic should be triggered
	 * to handle the form submission in an application-specific way.
	 *
	 * For this reason, AngularJS prevents the default action (form submission to the server) unless the
	 * `<form>` element has an `action` attribute specified.
	 *
	 * You can use one of the following two ways to specify what javascript method should be called when
	 * a form is submitted:
	 *
	 * - {@link ng.directive:ngSubmit ngSubmit} directive on the form element
	 * - {@link ng.directive:ngClick ngClick} directive on the first
	  *  button or input field of type submit (input[type=submit])
	 *
	 * To prevent double execution of the handler, use only one of the {@link ng.directive:ngSubmit ngSubmit}
	 * or {@link ng.directive:ngClick ngClick} directives.
	 * This is because of the following form submission rules in the HTML specification:
	 *
	 * - If a form has only one input field then hitting enter in this field triggers form submit
	 * (`ngSubmit`)
	 * - if a form has 2+ input fields and no buttons or input[type=submit] then hitting enter
	 * doesn't trigger submit
	 * - if a form has one or more input fields and one or more buttons or input[type=submit] then
	 * hitting enter in any of the input fields will trigger the click handler on the *first* button or
	 * input[type=submit] (`ngClick`) *and* a submit handler on the enclosing form (`ngSubmit`)
	 *
	 * Any pending `ngModelOptions` changes will take place immediately when an enclosing form is
	 * submitted. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
	 * to have access to the updated model.
	 *
	 * @animations
	 * Animations in ngForm are triggered when any of the associated CSS classes are added and removed.
	 * These classes are: `.ng-pristine`, `.ng-dirty`, `.ng-invalid` and `.ng-valid` as well as any
	 * other validations that are performed within the form. Animations in ngForm are similar to how
	 * they work in ngClass and animations can be hooked into using CSS transitions, keyframes as well
	 * as JS animations.
	 *
	 * The following example shows a simple way to utilize CSS transitions to style a form element
	 * that has been rendered as invalid after it has been validated:
	 *
	 * <pre>
	 * //be sure to include ngAnimate as a module to hook into more
	 * //advanced animations
	 * .my-form {
	 *   transition:0.5s linear all;
	 *   background: white;
	 * }
	 * .my-form.ng-invalid {
	 *   background: red;
	 *   color:white;
	 * }
	 * </pre>
	 *
	 * @example
	    <example name="ng-form" deps="angular-animate.js" animations="true" fixBase="true" module="formExample">
	      <file name="index.html">
	       <script>
	         angular.module('formExample', [])
	           .controller('FormController', ['$scope', function($scope) {
	             $scope.userType = 'guest';
	           }]);
	       </script>
	       <style>
	        .my-form {
	          transition:all linear 0.5s;
	          background: transparent;
	        }
	        .my-form.ng-invalid {
	          background: red;
	        }
	       </style>
	       <form name="myForm" ng-controller="FormController" class="my-form">
	         userType: <input name="input" ng-model="userType" required>
	         <span class="error" ng-show="myForm.input.$error.required">Required!</span><br>
	         <code>userType = {{userType}}</code><br>
	         <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br>
	         <code>myForm.input.$error = {{myForm.input.$error}}</code><br>
	         <code>myForm.$valid = {{myForm.$valid}}</code><br>
	         <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br>
	        </form>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should initialize to model', function() {
	          var userType = element(by.binding('userType'));
	          var valid = element(by.binding('myForm.input.$valid'));
	
	          expect(userType.getText()).toContain('guest');
	          expect(valid.getText()).toContain('true');
	        });
	
	        it('should be invalid if empty', function() {
	          var userType = element(by.binding('userType'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var userInput = element(by.model('userType'));
	
	          userInput.clear();
	          userInput.sendKeys('');
	
	          expect(userType.getText()).toEqual('userType =');
	          expect(valid.getText()).toContain('false');
	        });
	      </file>
	    </example>
	 *
	 * @param {string=} name Name of the form. If specified, the form controller will be published into
	 *                       related scope, under this name.
	 */
	var formDirectiveFactory = function(isNgForm) {
	  return ['$timeout', '$parse', function($timeout, $parse) {
	    var formDirective = {
	      name: 'form',
	      restrict: isNgForm ? 'EAC' : 'E',
	      require: ['form', '^^?form'], //first is the form's own ctrl, second is an optional parent form
	      controller: FormController,
	      compile: function ngFormCompile(formElement, attr) {
	        // Setup initial state of the control
	        formElement.addClass(PRISTINE_CLASS).addClass(VALID_CLASS);
	
	        var nameAttr = attr.name ? 'name' : (isNgForm && attr.ngForm ? 'ngForm' : false);
	
	        return {
	          pre: function ngFormPreLink(scope, formElement, attr, ctrls) {
	            var controller = ctrls[0];
	
	            // if `action` attr is not present on the form, prevent the default action (submission)
	            if (!('action' in attr)) {
	              // we can't use jq events because if a form is destroyed during submission the default
	              // action is not prevented. see #1238
	              //
	              // IE 9 is not affected because it doesn't fire a submit event and try to do a full
	              // page reload if the form was destroyed by submission of the form via a click handler
	              // on a button in the form. Looks like an IE9 specific bug.
	              var handleFormSubmission = function(event) {
	                scope.$apply(function() {
	                  controller.$commitViewValue();
	                  controller.$setSubmitted();
	                });
	
	                event.preventDefault();
	              };
	
	              formElement[0].addEventListener('submit', handleFormSubmission);
	
	              // unregister the preventDefault listener so that we don't not leak memory but in a
	              // way that will achieve the prevention of the default action.
	              formElement.on('$destroy', function() {
	                $timeout(function() {
	                  formElement[0].removeEventListener('submit', handleFormSubmission);
	                }, 0, false);
	              });
	            }
	
	            var parentFormCtrl = ctrls[1] || controller.$$parentForm;
	            parentFormCtrl.$addControl(controller);
	
	            var setter = nameAttr ? getSetter(controller.$name) : noop;
	
	            if (nameAttr) {
	              setter(scope, controller);
	              attr.$observe(nameAttr, function(newValue) {
	                if (controller.$name === newValue) return;
	                setter(scope, undefined);
	                controller.$$parentForm.$$renameControl(controller, newValue);
	                setter = getSetter(controller.$name);
	                setter(scope, controller);
	              });
	            }
	            formElement.on('$destroy', function() {
	              controller.$$parentForm.$removeControl(controller);
	              setter(scope, undefined);
	              extend(controller, nullFormCtrl); //stop propagating child destruction handlers upwards
	            });
	          }
	        };
	      }
	    };
	
	    return formDirective;
	
	    function getSetter(expression) {
	      if (expression === '') {
	        //create an assignable expression, so forms with an empty name can be renamed later
	        return $parse('this[""]').assign;
	      }
	      return $parse(expression).assign || noop;
	    }
	  }];
	};
	
	var formDirective = formDirectiveFactory();
	var ngFormDirective = formDirectiveFactory(true);
	
	
	
	// helper methods
	function setupValidity(instance) {
	  instance.$$classCache = {};
	  instance.$$classCache[INVALID_CLASS] = !(instance.$$classCache[VALID_CLASS] = instance.$$element.hasClass(VALID_CLASS));
	}
	function addSetValidityMethod(context) {
	  var clazz = context.clazz,
	      set = context.set,
	      unset = context.unset;
	
	  clazz.prototype.$setValidity = function(validationErrorKey, state, controller) {
	    if (isUndefined(state)) {
	      createAndSet(this, '$pending', validationErrorKey, controller);
	    } else {
	      unsetAndCleanup(this, '$pending', validationErrorKey, controller);
	    }
	    if (!isBoolean(state)) {
	      unset(this.$error, validationErrorKey, controller);
	      unset(this.$$success, validationErrorKey, controller);
	    } else {
	      if (state) {
	        unset(this.$error, validationErrorKey, controller);
	        set(this.$$success, validationErrorKey, controller);
	      } else {
	        set(this.$error, validationErrorKey, controller);
	        unset(this.$$success, validationErrorKey, controller);
	      }
	    }
	    if (this.$pending) {
	      cachedToggleClass(this, PENDING_CLASS, true);
	      this.$valid = this.$invalid = undefined;
	      toggleValidationCss(this, '', null);
	    } else {
	      cachedToggleClass(this, PENDING_CLASS, false);
	      this.$valid = isObjectEmpty(this.$error);
	      this.$invalid = !this.$valid;
	      toggleValidationCss(this, '', this.$valid);
	    }
	
	    // re-read the state as the set/unset methods could have
	    // combined state in this.$error[validationError] (used for forms),
	    // where setting/unsetting only increments/decrements the value,
	    // and does not replace it.
	    var combinedState;
	    if (this.$pending && this.$pending[validationErrorKey]) {
	      combinedState = undefined;
	    } else if (this.$error[validationErrorKey]) {
	      combinedState = false;
	    } else if (this.$$success[validationErrorKey]) {
	      combinedState = true;
	    } else {
	      combinedState = null;
	    }
	
	    toggleValidationCss(this, validationErrorKey, combinedState);
	    this.$$parentForm.$setValidity(validationErrorKey, combinedState, this);
	  };
	
	  function createAndSet(ctrl, name, value, controller) {
	    if (!ctrl[name]) {
	      ctrl[name] = {};
	    }
	    set(ctrl[name], value, controller);
	  }
	
	  function unsetAndCleanup(ctrl, name, value, controller) {
	    if (ctrl[name]) {
	      unset(ctrl[name], value, controller);
	    }
	    if (isObjectEmpty(ctrl[name])) {
	      ctrl[name] = undefined;
	    }
	  }
	
	  function cachedToggleClass(ctrl, className, switchValue) {
	    if (switchValue && !ctrl.$$classCache[className]) {
	      ctrl.$$animate.addClass(ctrl.$$element, className);
	      ctrl.$$classCache[className] = true;
	    } else if (!switchValue && ctrl.$$classCache[className]) {
	      ctrl.$$animate.removeClass(ctrl.$$element, className);
	      ctrl.$$classCache[className] = false;
	    }
	  }
	
	  function toggleValidationCss(ctrl, validationErrorKey, isValid) {
	    validationErrorKey = validationErrorKey ? '-' + snake_case(validationErrorKey, '-') : '';
	
	    cachedToggleClass(ctrl, VALID_CLASS + validationErrorKey, isValid === true);
	    cachedToggleClass(ctrl, INVALID_CLASS + validationErrorKey, isValid === false);
	  }
	}
	
	function isObjectEmpty(obj) {
	  if (obj) {
	    for (var prop in obj) {
	      if (obj.hasOwnProperty(prop)) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	/* global
	  VALID_CLASS: false,
	  INVALID_CLASS: false,
	  PRISTINE_CLASS: false,
	  DIRTY_CLASS: false,
	  ngModelMinErr: false
	*/
	
	// Regex code was initially obtained from SO prior to modification: https://stackoverflow.com/questions/3143070/javascript-regex-iso-datetime#answer-3143231
	var ISO_DATE_REGEXP = /^\d{4,}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+(?:[+-][0-2]\d:[0-5]\d|Z)$/;
	// See valid URLs in RFC3987 (http://tools.ietf.org/html/rfc3987)
	// Note: We are being more lenient, because browsers are too.
	//   1. Scheme
	//   2. Slashes
	//   3. Username
	//   4. Password
	//   5. Hostname
	//   6. Port
	//   7. Path
	//   8. Query
	//   9. Fragment
	//                 1111111111111111 222   333333    44444        55555555555555555555555     666     77777777     8888888     999
	var URL_REGEXP = /^[a-z][a-z\d.+-]*:\/*(?:[^:@]+(?::[^@]+)?@)?(?:[^\s:/?#]+|\[[a-f\d:]+])(?::\d+)?(?:\/[^?#]*)?(?:\?[^#]*)?(?:#.*)?$/i;
	// eslint-disable-next-line max-len
	var EMAIL_REGEXP = /^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*$/;
	var NUMBER_REGEXP = /^\s*(-|\+)?(\d+|(\d*(\.\d*)))([eE][+-]?\d+)?\s*$/;
	var DATE_REGEXP = /^(\d{4,})-(\d{2})-(\d{2})$/;
	var DATETIMELOCAL_REGEXP = /^(\d{4,})-(\d\d)-(\d\d)T(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;
	var WEEK_REGEXP = /^(\d{4,})-W(\d\d)$/;
	var MONTH_REGEXP = /^(\d{4,})-(\d\d)$/;
	var TIME_REGEXP = /^(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;
	
	var PARTIAL_VALIDATION_EVENTS = 'keydown wheel mousedown';
	var PARTIAL_VALIDATION_TYPES = createMap();
	forEach('date,datetime-local,month,time,week'.split(','), function(type) {
	  PARTIAL_VALIDATION_TYPES[type] = true;
	});
	
	var inputType = {
	
	  /**
	   * @ngdoc input
	   * @name input[text]
	   *
	   * @description
	   * Standard HTML text input with AngularJS data binding, inherited by most of the `input` elements.
	   *
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} required Adds `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   * @param {boolean=} [ngTrim=true] If set to false AngularJS will not automatically trim the input.
	   *    This parameter is ignored for input[type=password] controls, which will never trim the
	   *    input.
	   *
	   * @example
	      <example name="text-input-directive" module="textInputExample">
	        <file name="index.html">
	         <script>
	           angular.module('textInputExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.example = {
	                 text: 'guest',
	                 word: /^\s*\w*\s*$/
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>Single word:
	             <input type="text" name="input" ng-model="example.text"
	                    ng-pattern="example.word" required ng-trim="false">
	           </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.input.$error.required">
	               Required!</span>
	             <span class="error" ng-show="myForm.input.$error.pattern">
	               Single word only!</span>
	           </div>
	           <code>text = {{example.text}}</code><br/>
	           <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br/>
	           <code>myForm.input.$error = {{myForm.input.$error}}</code><br/>
	           <code>myForm.$valid = {{myForm.$valid}}</code><br/>
	           <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          var text = element(by.binding('example.text'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('example.text'));
	
	          it('should initialize to model', function() {
	            expect(text.getText()).toContain('guest');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	
	            expect(text.getText()).toEqual('text =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if multi word', function() {
	            input.clear();
	            input.sendKeys('hello world');
	
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'text': textInputType,
	
	    /**
	     * @ngdoc input
	     * @name input[date]
	     *
	     * @description
	     * Input with date validation and transformation. In browsers that do not yet support
	     * the HTML5 date input, a text element will be used. In that case, text must be entered in a valid ISO-8601
	     * date format (yyyy-MM-dd), for example: `2009-01-06`. Since many
	     * modern browsers do not yet support this input type, it is important to provide cues to users on the
	     * expected input format via a placeholder or label.
	     *
	     * The model must always be a Date object, otherwise AngularJS will throw an error.
	     * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	     *
	     * The timezone to be used to read/write the `Date` instance in the model can be defined using
	     * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	     *
	     * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	     * @param {string=} name Property name of the form under which the control is published.
	     * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`. This must be a
	     *   valid ISO date string (yyyy-MM-dd). You can also use interpolation inside this attribute
	     *   (e.g. `min="{{minDate | date:'yyyy-MM-dd'}}"`). Note that `min` will also add native HTML5
	     *   constraint validation.
	     * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`. This must be
	     *   a valid ISO date string (yyyy-MM-dd). You can also use interpolation inside this attribute
	     *   (e.g. `max="{{maxDate | date:'yyyy-MM-dd'}}"`). Note that `max` will also add native HTML5
	     *   constraint validation.
	     * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO date string
	     *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	     * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO date string
	     *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	     * @param {string=} required Sets `required` validation error key if the value is not entered.
	     * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	     *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	     *    `required` when you want to data-bind to the `required` attribute.
	     * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	     *    interaction with the input element.
	     *
	     * @example
	     <example name="date-input-directive" module="dateInputExample">
	     <file name="index.html">
	       <script>
	          angular.module('dateInputExample', [])
	            .controller('DateController', ['$scope', function($scope) {
	              $scope.example = {
	                value: new Date(2013, 9, 22)
	              };
	            }]);
	       </script>
	       <form name="myForm" ng-controller="DateController as dateCtrl">
	          <label for="exampleInput">Pick a date in 2013:</label>
	          <input type="date" id="exampleInput" name="input" ng-model="example.value"
	              placeholder="yyyy-MM-dd" min="2013-01-01" max="2013-12-31" required />
	          <div role="alert">
	            <span class="error" ng-show="myForm.input.$error.required">
	                Required!</span>
	            <span class="error" ng-show="myForm.input.$error.date">
	                Not a valid date!</span>
	           </div>
	           <tt>value = {{example.value | date: "yyyy-MM-dd"}}</tt><br/>
	           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	       </form>
	     </file>
	     <file name="protractor.js" type="protractor">
	        var value = element(by.binding('example.value | date: "yyyy-MM-dd"'));
	        var valid = element(by.binding('myForm.input.$valid'));
	
	        // currently protractor/webdriver does not support
	        // sending keys to all known HTML5 input controls
	        // for various browsers (see https://github.com/angular/protractor/issues/562).
	        function setInput(val) {
	          // set the value of the element and force validation.
	          var scr = "var ipt = document.getElementById('exampleInput'); " +
	          "ipt.value = '" + val + "';" +
	          "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	          browser.executeScript(scr);
	        }
	
	        it('should initialize to model', function() {
	          expect(value.getText()).toContain('2013-10-22');
	          expect(valid.getText()).toContain('myForm.input.$valid = true');
	        });
	
	        it('should be invalid if empty', function() {
	          setInput('');
	          expect(value.getText()).toEqual('value =');
	          expect(valid.getText()).toContain('myForm.input.$valid = false');
	        });
	
	        it('should be invalid if over max', function() {
	          setInput('2015-01-01');
	          expect(value.getText()).toContain('');
	          expect(valid.getText()).toContain('myForm.input.$valid = false');
	        });
	     </file>
	     </example>
	     */
	  'date': createDateInputType('date', DATE_REGEXP,
	         createDateParser(DATE_REGEXP, ['yyyy', 'MM', 'dd']),
	         'yyyy-MM-dd'),
	
	   /**
	    * @ngdoc input
	    * @name input[datetime-local]
	    *
	    * @description
	    * Input with datetime validation and transformation. In browsers that do not yet support
	    * the HTML5 date input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	    * local datetime format (yyyy-MM-ddTHH:mm:ss), for example: `2010-12-28T14:57:00`.
	    *
	    * The model must always be a Date object, otherwise AngularJS will throw an error.
	    * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	    *
	    * The timezone to be used to read/write the `Date` instance in the model can be defined using
	    * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	    *
	    * The format of the displayed time can be adjusted with the
	    * {@link ng.directive:ngModelOptions#ngModelOptions-arguments ngModelOptions} `timeSecondsFormat`
	    * and `timeStripZeroSeconds`.
	    *
	    * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	    * @param {string=} name Property name of the form under which the control is published.
	    * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	    *   This must be a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss). You can also use interpolation
	    *   inside this attribute (e.g. `min="{{minDatetimeLocal | date:'yyyy-MM-ddTHH:mm:ss'}}"`).
	    *   Note that `min` will also add native HTML5 constraint validation.
	    * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	    *   This must be a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss). You can also use interpolation
	    *   inside this attribute (e.g. `max="{{maxDatetimeLocal | date:'yyyy-MM-ddTHH:mm:ss'}}"`).
	    *   Note that `max` will also add native HTML5 constraint validation.
	    * @param {(date|string)=} ngMin Sets the `min` validation error key to the Date / ISO datetime string
	    *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	    * @param {(date|string)=} ngMax Sets the `max` validation error key to the Date / ISO datetime string
	    *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	    * @param {string=} required Sets `required` validation error key if the value is not entered.
	    * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	    *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	    *    `required` when you want to data-bind to the `required` attribute.
	    * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	    *    interaction with the input element.
	    *
	    * @example
	    <example name="datetimelocal-input-directive" module="dateExample">
	    <file name="index.html">
	      <script>
	        angular.module('dateExample', [])
	          .controller('DateController', ['$scope', function($scope) {
	            $scope.example = {
	              value: new Date(2010, 11, 28, 14, 57)
	            };
	          }]);
	      </script>
	      <form name="myForm" ng-controller="DateController as dateCtrl">
	        <label for="exampleInput">Pick a date between in 2013:</label>
	        <input type="datetime-local" id="exampleInput" name="input" ng-model="example.value"
	            placeholder="yyyy-MM-ddTHH:mm:ss" min="2001-01-01T00:00:00" max="2013-12-31T00:00:00" required />
	        <div role="alert">
	          <span class="error" ng-show="myForm.input.$error.required">
	              Required!</span>
	          <span class="error" ng-show="myForm.input.$error.datetimelocal">
	              Not a valid date!</span>
	        </div>
	        <tt>value = {{example.value | date: "yyyy-MM-ddTHH:mm:ss"}}</tt><br/>
	        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	      </form>
	    </file>
	    <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "yyyy-MM-ddTHH:mm:ss"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('2010-12-28T14:57:00');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('2015-01-01T23:59:00');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	    </file>
	    </example>
	    */
	  'datetime-local': createDateInputType('datetimelocal', DATETIMELOCAL_REGEXP,
	      createDateParser(DATETIMELOCAL_REGEXP, ['yyyy', 'MM', 'dd', 'HH', 'mm', 'ss', 'sss']),
	      'yyyy-MM-ddTHH:mm:ss.sss'),
	
	  /**
	   * @ngdoc input
	   * @name input[time]
	   *
	   * @description
	   * Input with time validation and transformation. In browsers that do not yet support
	   * the HTML5 time input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	   * local time format (HH:mm:ss), for example: `14:57:00`. Model must be a Date object. This binding will always output a
	   * Date object to the model of January 1, 1970, or local date `new Date(1970, 0, 1, HH, mm, ss)`.
	   *
	   * The model must always be a Date object, otherwise AngularJS will throw an error.
	   * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	   *
	   * The timezone to be used to read/write the `Date` instance in the model can be defined using
	   * {@link ng.directive:ngModelOptions#ngModelOptions-arguments ngModelOptions}. By default,
	   * this is the timezone of the browser.
	   *
	   * The format of the displayed time can be adjusted with the
	   * {@link ng.directive:ngModelOptions#ngModelOptions-arguments ngModelOptions} `timeSecondsFormat`
	   * and `timeStripZeroSeconds`.
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	   *   This must be a valid ISO time format (HH:mm:ss). You can also use interpolation inside this
	   *   attribute (e.g. `min="{{minTime | date:'HH:mm:ss'}}"`). Note that `min` will also add
	   *   native HTML5 constraint validation.
	   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	   *   This must be a valid ISO time format (HH:mm:ss). You can also use interpolation inside this
	   *   attribute (e.g. `max="{{maxTime | date:'HH:mm:ss'}}"`). Note that `max` will also add
	   *   native HTML5 constraint validation.
	   * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO time string the
	   *   `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	   * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO time string the
	   *   `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	   <example name="time-input-directive" module="timeExample">
	   <file name="index.html">
	     <script>
	      angular.module('timeExample', [])
	        .controller('DateController', ['$scope', function($scope) {
	          $scope.example = {
	            value: new Date(1970, 0, 1, 14, 57, 0)
	          };
	        }]);
	     </script>
	     <form name="myForm" ng-controller="DateController as dateCtrl">
	        <label for="exampleInput">Pick a time between 8am and 5pm:</label>
	        <input type="time" id="exampleInput" name="input" ng-model="example.value"
	            placeholder="HH:mm:ss" min="08:00:00" max="17:00:00" required />
	        <div role="alert">
	          <span class="error" ng-show="myForm.input.$error.required">
	              Required!</span>
	          <span class="error" ng-show="myForm.input.$error.time">
	              Not a valid date!</span>
	        </div>
	        <tt>value = {{example.value | date: "HH:mm:ss"}}</tt><br/>
	        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	     </form>
	   </file>
	   <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "HH:mm:ss"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('14:57:00');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('23:59:00');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	   </file>
	   </example>
	   */
	  'time': createDateInputType('time', TIME_REGEXP,
	      createDateParser(TIME_REGEXP, ['HH', 'mm', 'ss', 'sss']),
	     'HH:mm:ss.sss'),
	
	   /**
	    * @ngdoc input
	    * @name input[week]
	    *
	    * @description
	    * Input with week-of-the-year validation and transformation to Date. In browsers that do not yet support
	    * the HTML5 week input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	    * week format (yyyy-W##), for example: `2013-W02`.
	    *
	    * The model must always be a Date object, otherwise AngularJS will throw an error.
	    * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	    *
	    * The value of the resulting Date object will be set to Thursday at 00:00:00 of the requested week,
	    * due to ISO-8601 week numbering standards. Information on ISO's system for numbering the weeks of the
	    * year can be found at: https://en.wikipedia.org/wiki/ISO_8601#Week_dates
	    *
	    * The timezone to be used to read/write the `Date` instance in the model can be defined using
	    * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	    *
	    * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	    * @param {string=} name Property name of the form under which the control is published.
	    * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	    *   This must be a valid ISO week format (yyyy-W##). You can also use interpolation inside this
	    *   attribute (e.g. `min="{{minWeek | date:'yyyy-Www'}}"`). Note that `min` will also add
	    *   native HTML5 constraint validation.
	    * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	    *   This must be a valid ISO week format (yyyy-W##). You can also use interpolation inside this
	    *   attribute (e.g. `max="{{maxWeek | date:'yyyy-Www'}}"`). Note that `max` will also add
	    *   native HTML5 constraint validation.
	    * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO week string
	    *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	    * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO week string
	    *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	    * @param {string=} required Sets `required` validation error key if the value is not entered.
	    * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	    *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	    *    `required` when you want to data-bind to the `required` attribute.
	    * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	    *    interaction with the input element.
	    *
	    * @example
	    <example name="week-input-directive" module="weekExample">
	    <file name="index.html">
	      <script>
	      angular.module('weekExample', [])
	        .controller('DateController', ['$scope', function($scope) {
	          $scope.example = {
	            value: new Date(2013, 0, 3)
	          };
	        }]);
	      </script>
	      <form name="myForm" ng-controller="DateController as dateCtrl">
	        <label>Pick a date between in 2013:
	          <input id="exampleInput" type="week" name="input" ng-model="example.value"
	                 placeholder="YYYY-W##" min="2012-W32"
	                 max="2013-W52" required />
	        </label>
	        <div role="alert">
	          <span class="error" ng-show="myForm.input.$error.required">
	              Required!</span>
	          <span class="error" ng-show="myForm.input.$error.week">
	              Not a valid date!</span>
	        </div>
	        <tt>value = {{example.value | date: "yyyy-Www"}}</tt><br/>
	        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	      </form>
	    </file>
	    <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "yyyy-Www"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('2013-W01');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('2015-W01');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	    </file>
	    </example>
	    */
	  'week': createDateInputType('week', WEEK_REGEXP, weekParser, 'yyyy-Www'),
	
	  /**
	   * @ngdoc input
	   * @name input[month]
	   *
	   * @description
	   * Input with month validation and transformation. In browsers that do not yet support
	   * the HTML5 month input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	   * month format (yyyy-MM), for example: `2009-01`.
	   *
	   * The model must always be a Date object, otherwise AngularJS will throw an error.
	   * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	   * If the model is not set to the first of the month, the next view to model update will set it
	   * to the first of the month.
	   *
	   * The timezone to be used to read/write the `Date` instance in the model can be defined using
	   * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	   *   This must be a valid ISO month format (yyyy-MM). You can also use interpolation inside this
	   *   attribute (e.g. `min="{{minMonth | date:'yyyy-MM'}}"`). Note that `min` will also add
	   *   native HTML5 constraint validation.
	   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	   *   This must be a valid ISO month format (yyyy-MM). You can also use interpolation inside this
	   *   attribute (e.g. `max="{{maxMonth | date:'yyyy-MM'}}"`). Note that `max` will also add
	   *   native HTML5 constraint validation.
	   * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO week string
	   *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	   * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO week string
	   *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	   <example name="month-input-directive" module="monthExample">
	   <file name="index.html">
	     <script>
	      angular.module('monthExample', [])
	        .controller('DateController', ['$scope', function($scope) {
	          $scope.example = {
	            value: new Date(2013, 9, 1)
	          };
	        }]);
	     </script>
	     <form name="myForm" ng-controller="DateController as dateCtrl">
	       <label for="exampleInput">Pick a month in 2013:</label>
	       <input id="exampleInput" type="month" name="input" ng-model="example.value"
	          placeholder="yyyy-MM" min="2013-01" max="2013-12" required />
	       <div role="alert">
	         <span class="error" ng-show="myForm.input.$error.required">
	            Required!</span>
	         <span class="error" ng-show="myForm.input.$error.month">
	            Not a valid month!</span>
	       </div>
	       <tt>value = {{example.value | date: "yyyy-MM"}}</tt><br/>
	       <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	       <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	       <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	       <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	     </form>
	   </file>
	   <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "yyyy-MM"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('2013-10');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('2015-01');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	   </file>
	   </example>
	   */
	  'month': createDateInputType('month', MONTH_REGEXP,
	     createDateParser(MONTH_REGEXP, ['yyyy', 'MM']),
	     'yyyy-MM'),
	
	  /**
	   * @ngdoc input
	   * @name input[number]
	   *
	   * @description
	   * Text input with number validation and transformation. Sets the `number` validation
	   * error if not a valid number.
	   *
	   * <div class="alert alert-warning">
	   * The model must always be of type `number` otherwise AngularJS will throw an error.
	   * Be aware that a string containing a number is not enough. See the {@link ngModel:numfmt}
	   * error docs for more information and an example of how to convert your model if necessary.
	   * </div>
	   *
	   *
	   *
	   * @knownIssue
	   *
	   * ### HTML5 constraint validation and `allowInvalid`
	   *
	   * In browsers that follow the
	   * [HTML5 specification](https://html.spec.whatwg.org/multipage/forms.html#number-state-%28type=number%29),
	   * `input[number]` does not work as expected with {@link ngModelOptions `ngModelOptions.allowInvalid`}.
	   * If a non-number is entered in the input, the browser will report the value as an empty string,
	   * which means the view / model values in `ngModel` and subsequently the scope value
	   * will also be an empty string.
	   *
	   * @knownIssue
	   *
	   * ### Large numbers and `step` validation
	   *
	   * The `step` validation will not work correctly for very large numbers (e.g. 9999999999) due to
	   * Javascript's arithmetic limitations. If you need to handle large numbers, purpose-built
	   * libraries (e.g. https://github.com/MikeMcl/big.js/), can be included into AngularJS by
	   * {@link guide/forms#modifying-built-in-validators overwriting the validators}
	   * for `number` and / or `step`, or by {@link guide/forms#custom-validation applying custom validators}
	   * to an `input[text]` element. The source for `input[number]` type can be used as a starting
	   * point for both implementations.
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	   *    Can be interpolated.
	   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	   *    Can be interpolated.
	   * @param {string=} ngMin Like `min`, sets the `min` validation error key if the value entered is less than `ngMin`,
	   *    but does not trigger HTML5 native validation. Takes an expression.
	   * @param {string=} ngMax Like `max`, sets the `max` validation error key if the value entered is greater than `ngMax`,
	   *    but does not trigger HTML5 native validation. Takes an expression.
	   * @param {string=} step Sets the `step` validation error key if the value entered does not fit the `step` constraint.
	   *    Can be interpolated.
	   * @param {string=} ngStep Like `step`, sets the `step` validation error key if the value entered does not fit the `ngStep` constraint,
	   *    but does not trigger HTML5 native validation. Takes an expression.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="number-input-directive" module="numberExample">
	        <file name="index.html">
	         <script>
	           angular.module('numberExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.example = {
	                 value: 12
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>Number:
	             <input type="number" name="input" ng-model="example.value"
	                    min="0" max="99" required>
	          </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.input.$error.required">
	               Required!</span>
	             <span class="error" ng-show="myForm.input.$error.number">
	               Not valid number!</span>
	           </div>
	           <tt>value = {{example.value}}</tt><br/>
	           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          var value = element(by.binding('example.value'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('example.value'));
	
	          it('should initialize to model', function() {
	            expect(value.getText()).toContain('12');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	            expect(value.getText()).toEqual('value =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if over max', function() {
	            input.clear();
	            input.sendKeys('123');
	            expect(value.getText()).toEqual('value =');
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'number': numberInputType,
	
	
	  /**
	   * @ngdoc input
	   * @name input[url]
	   *
	   * @description
	   * Text input with URL validation. Sets the `url` validation error key if the content is not a
	   * valid URL.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** `input[url]` uses a regex to validate urls that is derived from the regex
	   * used in Chromium. If you need stricter validation, you can use `ng-pattern` or modify
	   * the built-in validators (see the {@link guide/forms Forms guide})
	   * </div>
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="url-input-directive" module="urlExample">
	        <file name="index.html">
	         <script>
	           angular.module('urlExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.url = {
	                 text: 'http://google.com'
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>URL:
	             <input type="url" name="input" ng-model="url.text" required>
	           <label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.input.$error.required">
	               Required!</span>
	             <span class="error" ng-show="myForm.input.$error.url">
	               Not valid url!</span>
	           </div>
	           <tt>text = {{url.text}}</tt><br/>
	           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	           <tt>myForm.$error.url = {{!!myForm.$error.url}}</tt><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          var text = element(by.binding('url.text'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('url.text'));
	
	          it('should initialize to model', function() {
	            expect(text.getText()).toContain('http://google.com');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	
	            expect(text.getText()).toEqual('text =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if not url', function() {
	            input.clear();
	            input.sendKeys('box');
	
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'url': urlInputType,
	
	
	  /**
	   * @ngdoc input
	   * @name input[email]
	   *
	   * @description
	   * Text input with email validation. Sets the `email` validation error key if not a valid email
	   * address.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** `input[email]` uses a regex to validate email addresses that is derived from the regex
	   * used in Chromium, which may not fulfill your app's requirements.
	   * If you need stricter (e.g. requiring a top-level domain), or more relaxed validation
	   * (e.g. allowing IPv6 address literals) you can use `ng-pattern` or
	   * modify the built-in validators (see the {@link guide/forms Forms guide}).
	   * </div>
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="email-input-directive" module="emailExample">
	        <file name="index.html">
	         <script>
	           angular.module('emailExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.email = {
	                 text: 'me@example.com'
	               };
	             }]);
	         </script>
	           <form name="myForm" ng-controller="ExampleController">
	             <label>Email:
	               <input type="email" name="input" ng-model="email.text" required>
	             </label>
	             <div role="alert">
	               <span class="error" ng-show="myForm.input.$error.required">
	                 Required!</span>
	               <span class="error" ng-show="myForm.input.$error.email">
	                 Not valid email!</span>
	             </div>
	             <tt>text = {{email.text}}</tt><br/>
	             <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	             <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	             <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	             <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	             <tt>myForm.$error.email = {{!!myForm.$error.email}}</tt><br/>
	           </form>
	         </file>
	        <file name="protractor.js" type="protractor">
	          var text = element(by.binding('email.text'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('email.text'));
	
	          it('should initialize to model', function() {
	            expect(text.getText()).toContain('me@example.com');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	            expect(text.getText()).toEqual('text =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if not email', function() {
	            input.clear();
	            input.sendKeys('xxx');
	
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'email': emailInputType,
	
	
	  /**
	   * @ngdoc input
	   * @name input[radio]
	   *
	   * @description
	   * HTML radio button.
	   *
	   * **Note:**<br>
	   * All inputs controlled by {@link ngModel ngModel} (including those of type `radio`) will use the
	   * value of their `name` attribute to determine the property under which their
	   * {@link ngModel.NgModelController NgModelController} will be published on the parent
	   * {@link form.FormController FormController}. Thus, if you use the same `name` for multiple
	   * inputs of a form (e.g. a group of radio inputs), only _one_ `NgModelController` will be
	   * published on the parent `FormController` under that name. The rest of the controllers will
	   * continue to work as expected, but you won't be able to access them as properties on the parent
	   * `FormController`.
	   *
	   * <div class="alert alert-info">
	   *   <p>
	   *     In plain HTML forms, the `name` attribute is used to identify groups of radio inputs, so
	   *     that the browser can manage their state (checked/unchecked) based on the state of other
	   *     inputs in the same group.
	   *   </p>
	   *   <p>
	   *     In AngularJS forms, this is not necessary. The input's state will be updated based on the
	   *     value of the underlying model data.
	   *   </p>
	   * </div>
	   *
	   * <div class="alert alert-success">
	   *   If you omit the `name` attribute on a radio input, `ngModel` will automatically assign it a
	   *   unique name.
	   * </div>
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string} value The value to which the `ngModel` expression should be set when selected.
	   *    Note that `value` only supports `string` values, i.e. the scope model needs to be a string,
	   *    too. Use `ngValue` if you need complex models (`number`, `object`, ...).
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   * @param {string} ngValue AngularJS expression to which `ngModel` will be be set when the radio
	   *    is selected. Should be used instead of the `value` attribute if you need
	   *    a non-string `ngModel` (`boolean`, `array`, ...).
	   *
	   * @example
	      <example name="radio-input-directive" module="radioExample">
	        <file name="index.html">
	         <script>
	           angular.module('radioExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.color = {
	                 name: 'blue'
	               };
	               $scope.specialValue = {
	                 "id": "12345",
	                 "value": "green"
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>
	             <input type="radio" ng-model="color.name" value="red">
	             Red
	           </label><br/>
	           <label>
	             <input type="radio" ng-model="color.name" ng-value="specialValue">
	             Green
	           </label><br/>
	           <label>
	             <input type="radio" ng-model="color.name" value="blue">
	             Blue
	           </label><br/>
	           <tt>color = {{color.name | json}}</tt><br/>
	          </form>
	          Note that `ng-value="specialValue"` sets radio item's value to be the value of `$scope.specialValue`.
	        </file>
	        <file name="protractor.js" type="protractor">
	          it('should change state', function() {
	            var inputs = element.all(by.model('color.name'));
	            var color = element(by.binding('color.name'));
	
	            expect(color.getText()).toContain('blue');
	
	            inputs.get(0).click();
	            expect(color.getText()).toContain('red');
	
	            inputs.get(1).click();
	            expect(color.getText()).toContain('green');
	          });
	        </file>
	      </example>
	   */
	  'radio': radioInputType,
	
	  /**
	   * @ngdoc input
	   * @name input[range]
	   *
	   * @description
	   * Native range input with validation and transformation.
	   *
	   * The model for the range input must always be a `Number`.
	   *
	   * IE9 and other browsers that do not support the `range` type fall back
	   * to a text input without any default values for `min`, `max` and `step`. Model binding,
	   * validation and number parsing are nevertheless supported.
	   *
	   * Browsers that support range (latest Chrome, Safari, Firefox, Edge) treat `input[range]`
	   * in a way that never allows the input to hold an invalid value. That means:
	   * - any non-numerical value is set to `(max + min) / 2`.
	   * - any numerical value that is less than the current min val, or greater than the current max val
	   * is set to the min / max val respectively.
	   * - additionally, the current `step` is respected, so the nearest value that satisfies a step
	   * is used.
	   *
	   * See the [HTML Spec on input[type=range]](https://www.w3.org/TR/html5/forms.html#range-state-(type=range))
	   * for more info.
	   *
	   * This has the following consequences for AngularJS:
	   *
	   * Since the element value should always reflect the current model value, a range input
	   * will set the bound ngModel expression to the value that the browser has set for the
	   * input element. For example, in the following input `<input type="range" ng-model="model.value">`,
	   * if the application sets `model.value = null`, the browser will set the input to `'50'`.
	   * AngularJS will then set the model to `50`, to prevent input and model value being out of sync.
	   *
	   * That means the model for range will immediately be set to `50` after `ngModel` has been
	   * initialized. It also means a range input can never have the required error.
	   *
	   * This does not only affect changes to the model value, but also to the values of the `min`,
	   * `max`, and `step` attributes. When these change in a way that will cause the browser to modify
	   * the input value, AngularJS will also update the model value.
	   *
	   * Automatic value adjustment also means that a range input element can never have the `required`,
	   * `min`, or `max` errors.
	   *
	   * However, `step` is currently only fully implemented by Firefox. Other browsers have problems
	   * when the step value changes dynamically - they do not adjust the element value correctly, but
	   * instead may set the `stepMismatch` error. If that's the case, the AngularJS will set the `step`
	   * error on the input, and set the model to `undefined`.
	   *
	   * Note that `input[range]` is not compatible with`ngMax`, `ngMin`, and `ngStep`, because they do
	   * not set the `min` and `max` attributes, which means that the browser won't automatically adjust
	   * the input value based on their values, and will always assume min = 0, max = 100, and step = 1.
	   *
	   * @param {string}  ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation to ensure that the value entered is greater
	   *                  than `min`. Can be interpolated.
	   * @param {string=} max Sets the `max` validation to ensure that the value entered is less than `max`.
	   *                  Can be interpolated.
	   * @param {string=} step Sets the `step` validation to ensure that the value entered matches the `step`
	   *                  Can be interpolated.
	   * @param {expression=} ngChange AngularJS expression to be executed when the ngModel value changes due
	   *                      to user interaction with the input element.
	   * @param {expression=} ngChecked If the expression is truthy, then the `checked` attribute will be set on the
	   *                      element. **Note** : `ngChecked` should not be used alongside `ngModel`.
	   *                      Checkout {@link ng.directive:ngChecked ngChecked} for usage.
	   *
	   * @example
	      <example name="range-input-directive" module="rangeExample">
	        <file name="index.html">
	          <script>
	            angular.module('rangeExample', [])
	              .controller('ExampleController', ['$scope', function($scope) {
	                $scope.value = 75;
	                $scope.min = 10;
	                $scope.max = 90;
	              }]);
	          </script>
	          <form name="myForm" ng-controller="ExampleController">
	
	            Model as range: <input type="range" name="range" ng-model="value" min="{{min}}"  max="{{max}}">
	            <hr>
	            Model as number: <input type="number" ng-model="value"><br>
	            Min: <input type="number" ng-model="min"><br>
	            Max: <input type="number" ng-model="max"><br>
	            value = <code>{{value}}</code><br/>
	            myForm.range.$valid = <code>{{myForm.range.$valid}}</code><br/>
	            myForm.range.$error = <code>{{myForm.range.$error}}</code>
	          </form>
	        </file>
	      </example>
	
	   * ## Range Input with ngMin & ngMax attributes
	
	   * @example
	      <example name="range-input-directive-ng" module="rangeExample">
	        <file name="index.html">
	          <script>
	            angular.module('rangeExample', [])
	              .controller('ExampleController', ['$scope', function($scope) {
	                $scope.value = 75;
	                $scope.min = 10;
	                $scope.max = 90;
	              }]);
	          </script>
	          <form name="myForm" ng-controller="ExampleController">
	            Model as range: <input type="range" name="range" ng-model="value" ng-min="min" ng-max="max">
	            <hr>
	            Model as number: <input type="number" ng-model="value"><br>
	            Min: <input type="number" ng-model="min"><br>
	            Max: <input type="number" ng-model="max"><br>
	            value = <code>{{value}}</code><br/>
	            myForm.range.$valid = <code>{{myForm.range.$valid}}</code><br/>
	            myForm.range.$error = <code>{{myForm.range.$error}}</code>
	          </form>
	        </file>
	      </example>
	
	   */
	  'range': rangeInputType,
	
	  /**
	   * @ngdoc input
	   * @name input[checkbox]
	   *
	   * @description
	   * HTML checkbox.
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {expression=} ngTrueValue The value to which the expression should be set when selected.
	   * @param {expression=} ngFalseValue The value to which the expression should be set when not selected.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="checkbox-input-directive" module="checkboxExample">
	        <file name="index.html">
	         <script>
	           angular.module('checkboxExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.checkboxModel = {
	                value1 : true,
	                value2 : 'YES'
	              };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>Value1:
	             <input type="checkbox" ng-model="checkboxModel.value1">
	           </label><br/>
	           <label>Value2:
	             <input type="checkbox" ng-model="checkboxModel.value2"
	                    ng-true-value="'YES'" ng-false-value="'NO'">
	            </label><br/>
	           <tt>value1 = {{checkboxModel.value1}}</tt><br/>
	           <tt>value2 = {{checkboxModel.value2}}</tt><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          it('should change state', function() {
	            var value1 = element(by.binding('checkboxModel.value1'));
	            var value2 = element(by.binding('checkboxModel.value2'));
	
	            expect(value1.getText()).toContain('true');
	            expect(value2.getText()).toContain('YES');
	
	            element(by.model('checkboxModel.value1')).click();
	            element(by.model('checkboxModel.value2')).click();
	
	            expect(value1.getText()).toContain('false');
	            expect(value2.getText()).toContain('NO');
	          });
	        </file>
	      </example>
	   */
	  'checkbox': checkboxInputType,
	
	  'hidden': noop,
	  'button': noop,
	  'submit': noop,
	  'reset': noop,
	  'file': noop
	};
	
	function stringBasedInputType(ctrl) {
	  ctrl.$formatters.push(function(value) {
	    return ctrl.$isEmpty(value) ? value : value.toString();
	  });
	}
	
	function textInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	  stringBasedInputType(ctrl);
	}
	
	function baseInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  var type = lowercase(element[0].type);
	
	  // In composition mode, users are still inputting intermediate text buffer,
	  // hold the listener until composition is done.
	  // More about composition events: https://developer.mozilla.org/en-US/docs/Web/API/CompositionEvent
	  if (!$sniffer.android) {
	    var composing = false;
	
	    element.on('compositionstart', function() {
	      composing = true;
	    });
	
	    // Support: IE9+
	    element.on('compositionupdate', function(ev) {
	      // End composition when ev.data is empty string on 'compositionupdate' event.
	      // When the input de-focusses (e.g. by clicking away), IE triggers 'compositionupdate'
	      // instead of 'compositionend'.
	      if (isUndefined(ev.data) || ev.data === '') {
	        composing = false;
	      }
	    });
	
	    element.on('compositionend', function() {
	      composing = false;
	      listener();
	    });
	  }
	
	  var timeout;
	
	  var listener = function(ev) {
	    if (timeout) {
	      $browser.defer.cancel(timeout);
	      timeout = null;
	    }
	    if (composing) return;
	    var value = element.val(),
	        event = ev && ev.type;
	
	    // By default we will trim the value
	    // If the attribute ng-trim exists we will avoid trimming
	    // If input type is 'password', the value is never trimmed
	    if (type !== 'password' && (!attr.ngTrim || attr.ngTrim !== 'false')) {
	      value = trim(value);
	    }
	
	    // If a control is suffering from bad input (due to native validators), browsers discard its
	    // value, so it may be necessary to revalidate (by calling $setViewValue again) even if the
	    // control's value is the same empty value twice in a row.
	    if (ctrl.$viewValue !== value || (value === '' && ctrl.$$hasNativeValidators)) {
	      ctrl.$setViewValue(value, event);
	    }
	  };
	
	  // if the browser does support "input" event, we are fine - except on IE9 which doesn't fire the
	  // input event on backspace, delete or cut
	  if ($sniffer.hasEvent('input')) {
	    element.on('input', listener);
	  } else {
	    var deferListener = function(ev, input, origValue) {
	      if (!timeout) {
	        timeout = $browser.defer(function() {
	          timeout = null;
	          if (!input || input.value !== origValue) {
	            listener(ev);
	          }
	        });
	      }
	    };
	
	    element.on('keydown', /** @this */ function(event) {
	      var key = event.keyCode;
	
	      // ignore
	      //    command            modifiers                   arrows
	      if (key === 91 || (15 < key && key < 19) || (37 <= key && key <= 40)) return;
	
	      deferListener(event, this, this.value);
	    });
	
	    // if user modifies input value using context menu in IE, we need "paste", "cut" and "drop" events to catch it
	    if ($sniffer.hasEvent('paste')) {
	      element.on('paste cut drop', deferListener);
	    }
	  }
	
	  // if user paste into input using mouse on older browser
	  // or form autocomplete on newer browser, we need "change" event to catch it
	  element.on('change', listener);
	
	  // Some native input types (date-family) have the ability to change validity without
	  // firing any input/change events.
	  // For these event types, when native validators are present and the browser supports the type,
	  // check for validity changes on various DOM events.
	  if (PARTIAL_VALIDATION_TYPES[type] && ctrl.$$hasNativeValidators && type === attr.type) {
	    element.on(PARTIAL_VALIDATION_EVENTS, /** @this */ function(ev) {
	      if (!timeout) {
	        var validity = this[VALIDITY_STATE_PROPERTY];
	        var origBadInput = validity.badInput;
	        var origTypeMismatch = validity.typeMismatch;
	        timeout = $browser.defer(function() {
	          timeout = null;
	          if (validity.badInput !== origBadInput || validity.typeMismatch !== origTypeMismatch) {
	            listener(ev);
	          }
	        });
	      }
	    });
	  }
	
	  ctrl.$render = function() {
	    // Workaround for Firefox validation #12102.
	    var value = ctrl.$isEmpty(ctrl.$viewValue) ? '' : ctrl.$viewValue;
	    if (element.val() !== value) {
	      element.val(value);
	    }
	  };
	}
	
	function weekParser(isoWeek, existingDate) {
	  if (isDate(isoWeek)) {
	    return isoWeek;
	  }
	
	  if (isString(isoWeek)) {
	    WEEK_REGEXP.lastIndex = 0;
	    var parts = WEEK_REGEXP.exec(isoWeek);
	    if (parts) {
	      var year = +parts[1],
	          week = +parts[2],
	          hours = 0,
	          minutes = 0,
	          seconds = 0,
	          milliseconds = 0,
	          firstThurs = getFirstThursdayOfYear(year),
	          addDays = (week - 1) * 7;
	
	      if (existingDate) {
	        hours = existingDate.getHours();
	        minutes = existingDate.getMinutes();
	        seconds = existingDate.getSeconds();
	        milliseconds = existingDate.getMilliseconds();
	      }
	
	      return new Date(year, 0, firstThurs.getDate() + addDays, hours, minutes, seconds, milliseconds);
	    }
	  }
	
	  return NaN;
	}
	
	function createDateParser(regexp, mapping) {
	  return function(iso, previousDate) {
	    var parts, map;
	
	    if (isDate(iso)) {
	      return iso;
	    }
	
	    if (isString(iso)) {
	      // When a date is JSON'ified to wraps itself inside of an extra
	      // set of double quotes. This makes the date parsing code unable
	      // to match the date string and parse it as a date.
	      if (iso.charAt(0) === '"' && iso.charAt(iso.length - 1) === '"') {
	        iso = iso.substring(1, iso.length - 1);
	      }
	      if (ISO_DATE_REGEXP.test(iso)) {
	        return new Date(iso);
	      }
	      regexp.lastIndex = 0;
	      parts = regexp.exec(iso);
	
	      if (parts) {
	        parts.shift();
	        if (previousDate) {
	          map = {
	            yyyy: previousDate.getFullYear(),
	            MM: previousDate.getMonth() + 1,
	            dd: previousDate.getDate(),
	            HH: previousDate.getHours(),
	            mm: previousDate.getMinutes(),
	            ss: previousDate.getSeconds(),
	            sss: previousDate.getMilliseconds() / 1000
	          };
	        } else {
	          map = { yyyy: 1970, MM: 1, dd: 1, HH: 0, mm: 0, ss: 0, sss: 0 };
	        }
	
	        forEach(parts, function(part, index) {
	          if (index < mapping.length) {
	            map[mapping[index]] = +part;
	          }
	        });
	
	        var date = new Date(map.yyyy, map.MM - 1, map.dd, map.HH, map.mm, map.ss || 0, map.sss * 1000 || 0);
	        if (map.yyyy < 100) {
	          // In the constructor, 2-digit years map to 1900-1999.
	          // Use `setFullYear()` to set the correct year.
	          date.setFullYear(map.yyyy);
	        }
	
	        return date;
	      }
	    }
	
	    return NaN;
	  };
	}
	
	function createDateInputType(type, regexp, parseDate, format) {
	  return function dynamicDateInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter, $parse) {
	    badInputChecker(scope, element, attr, ctrl, type);
	    baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	
	    var isTimeType = type === 'time' || type === 'datetimelocal';
	    var previousDate;
	    var previousTimezone;
	
	    ctrl.$parsers.push(function(value) {
	      if (ctrl.$isEmpty(value)) return null;
	
	      if (regexp.test(value)) {
	        // Note: We cannot read ctrl.$modelValue, as there might be a different
	        // parser/formatter in the processing chain so that the model
	        // contains some different data format!
	        return parseDateAndConvertTimeZoneToLocal(value, previousDate);
	      }
	      ctrl.$$parserName = type;
	      return undefined;
	    });
	
	    ctrl.$formatters.push(function(value) {
	      if (value && !isDate(value)) {
	        throw ngModelMinErr('datefmt', 'Expected `{0}` to be a date', value);
	      }
	      if (isValidDate(value)) {
	        previousDate = value;
	        var timezone = ctrl.$options.getOption('timezone');
	
	        if (timezone) {
	          previousTimezone = timezone;
	          previousDate = convertTimezoneToLocal(previousDate, timezone, true);
	        }
	
	        return formatter(value, timezone);
	      } else {
	        previousDate = null;
	        previousTimezone = null;
	        return '';
	      }
	    });
	
	    if (isDefined(attr.min) || attr.ngMin) {
	      var minVal = attr.min || $parse(attr.ngMin)(scope);
	      var parsedMinVal = parseObservedDateValue(minVal);
	
	      ctrl.$validators.min = function(value) {
	        return !isValidDate(value) || isUndefined(parsedMinVal) || parseDate(value) >= parsedMinVal;
	      };
	      attr.$observe('min', function(val) {
	        if (val !== minVal) {
	          parsedMinVal = parseObservedDateValue(val);
	          minVal = val;
	          ctrl.$validate();
	        }
	      });
	    }
	
	    if (isDefined(attr.max) || attr.ngMax) {
	      var maxVal = attr.max || $parse(attr.ngMax)(scope);
	      var parsedMaxVal = parseObservedDateValue(maxVal);
	
	      ctrl.$validators.max = function(value) {
	        return !isValidDate(value) || isUndefined(parsedMaxVal) || parseDate(value) <= parsedMaxVal;
	      };
	      attr.$observe('max', function(val) {
	        if (val !== maxVal) {
	          parsedMaxVal = parseObservedDateValue(val);
	          maxVal = val;
	          ctrl.$validate();
	        }
	      });
	    }
	
	    function isValidDate(value) {
	      // Invalid Date: getTime() returns NaN
	      return value && !(value.getTime && value.getTime() !== value.getTime());
	    }
	
	    function parseObservedDateValue(val) {
	      return isDefined(val) && !isDate(val) ? parseDateAndConvertTimeZoneToLocal(val) || undefined : val;
	    }
	
	    function parseDateAndConvertTimeZoneToLocal(value, previousDate) {
	      var timezone = ctrl.$options.getOption('timezone');
	
	      if (previousTimezone && previousTimezone !== timezone) {
	        // If the timezone has changed, adjust the previousDate to the default timezone
	        // so that the new date is converted with the correct timezone offset
	        previousDate = addDateMinutes(previousDate, timezoneToOffset(previousTimezone));
	      }
	
	      var parsedDate = parseDate(value, previousDate);
	
	      if (!isNaN(parsedDate) && timezone) {
	        parsedDate = convertTimezoneToLocal(parsedDate, timezone);
	      }
	      return parsedDate;
	    }
	
	    function formatter(value, timezone) {
	      var targetFormat = format;
	
	      if (isTimeType && isString(ctrl.$options.getOption('timeSecondsFormat'))) {
	        targetFormat = format
	          .replace('ss.sss', ctrl.$options.getOption('timeSecondsFormat'))
	          .replace(/:$/, '');
	      }
	
	      var formatted =  $filter('date')(value, targetFormat, timezone);
	
	      if (isTimeType && ctrl.$options.getOption('timeStripZeroSeconds')) {
	        formatted = formatted.replace(/(?::00)?(?:\.000)?$/, '');
	      }
	
	      return formatted;
	    }
	  };
	}
	
	function badInputChecker(scope, element, attr, ctrl, parserName) {
	  var node = element[0];
	  var nativeValidation = ctrl.$$hasNativeValidators = isObject(node.validity);
	  if (nativeValidation) {
	    ctrl.$parsers.push(function(value) {
	      var validity = element.prop(VALIDITY_STATE_PROPERTY) || {};
	      if (validity.badInput || validity.typeMismatch) {
	        ctrl.$$parserName = parserName;
	        return undefined;
	      }
	
	      return value;
	    });
	  }
	}
	
	function numberFormatterParser(ctrl) {
	  ctrl.$parsers.push(function(value) {
	    if (ctrl.$isEmpty(value))      return null;
	    if (NUMBER_REGEXP.test(value)) return parseFloat(value);
	
	    ctrl.$$parserName = 'number';
	    return undefined;
	  });
	
	  ctrl.$formatters.push(function(value) {
	    if (!ctrl.$isEmpty(value)) {
	      if (!isNumber(value)) {
	        throw ngModelMinErr('numfmt', 'Expected `{0}` to be a number', value);
	      }
	      value = value.toString();
	    }
	    return value;
	  });
	}
	
	function parseNumberAttrVal(val) {
	  if (isDefined(val) && !isNumber(val)) {
	    val = parseFloat(val);
	  }
	  return !isNumberNaN(val) ? val : undefined;
	}
	
	function isNumberInteger(num) {
	  // See http://stackoverflow.com/questions/14636536/how-to-check-if-a-variable-is-an-integer-in-javascript#14794066
	  // (minus the assumption that `num` is a number)
	
	  // eslint-disable-next-line no-bitwise
	  return (num | 0) === num;
	}
	
	function countDecimals(num) {
	  var numString = num.toString();
	  var decimalSymbolIndex = numString.indexOf('.');
	
	  if (decimalSymbolIndex === -1) {
	    if (-1 < num && num < 1) {
	      // It may be in the exponential notation format (`1e-X`)
	      var match = /e-(\d+)$/.exec(numString);
	
	      if (match) {
	        return Number(match[1]);
	      }
	    }
	
	    return 0;
	  }
	
	  return numString.length - decimalSymbolIndex - 1;
	}
	
	function isValidForStep(viewValue, stepBase, step) {
	  // At this point `stepBase` and `step` are expected to be non-NaN values
	  // and `viewValue` is expected to be a valid stringified number.
	  var value = Number(viewValue);
	
	  var isNonIntegerValue = !isNumberInteger(value);
	  var isNonIntegerStepBase = !isNumberInteger(stepBase);
	  var isNonIntegerStep = !isNumberInteger(step);
	
	  // Due to limitations in Floating Point Arithmetic (e.g. `0.3 - 0.2 !== 0.1` or
	  // `0.5 % 0.1 !== 0`), we need to convert all numbers to integers.
	  if (isNonIntegerValue || isNonIntegerStepBase || isNonIntegerStep) {
	    var valueDecimals = isNonIntegerValue ? countDecimals(value) : 0;
	    var stepBaseDecimals = isNonIntegerStepBase ? countDecimals(stepBase) : 0;
	    var stepDecimals = isNonIntegerStep ? countDecimals(step) : 0;
	
	    var decimalCount = Math.max(valueDecimals, stepBaseDecimals, stepDecimals);
	    var multiplier = Math.pow(10, decimalCount);
	
	    value = value * multiplier;
	    stepBase = stepBase * multiplier;
	    step = step * multiplier;
	
	    if (isNonIntegerValue) value = Math.round(value);
	    if (isNonIntegerStepBase) stepBase = Math.round(stepBase);
	    if (isNonIntegerStep) step = Math.round(step);
	  }
	
	  return (value - stepBase) % step === 0;
	}
	
	function numberInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter, $parse) {
	  badInputChecker(scope, element, attr, ctrl, 'number');
	  numberFormatterParser(ctrl);
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	
	  var parsedMinVal;
	
	  if (isDefined(attr.min) || attr.ngMin) {
	    var minVal = attr.min || $parse(attr.ngMin)(scope);
	    parsedMinVal = parseNumberAttrVal(minVal);
	
	    ctrl.$validators.min = function(modelValue, viewValue) {
	      return ctrl.$isEmpty(viewValue) || isUndefined(parsedMinVal) || viewValue >= parsedMinVal;
	    };
	
	    attr.$observe('min', function(val) {
	      if (val !== minVal) {
	        parsedMinVal = parseNumberAttrVal(val);
	        minVal = val;
	        // TODO(matsko): implement validateLater to reduce number of validations
	        ctrl.$validate();
	      }
	    });
	  }
	
	  if (isDefined(attr.max) || attr.ngMax) {
	    var maxVal = attr.max || $parse(attr.ngMax)(scope);
	    var parsedMaxVal = parseNumberAttrVal(maxVal);
	
	    ctrl.$validators.max = function(modelValue, viewValue) {
	      return ctrl.$isEmpty(viewValue) || isUndefined(parsedMaxVal) || viewValue <= parsedMaxVal;
	    };
	
	    attr.$observe('max', function(val) {
	      if (val !== maxVal) {
	        parsedMaxVal = parseNumberAttrVal(val);
	        maxVal = val;
	        // TODO(matsko): implement validateLater to reduce number of validations
	        ctrl.$validate();
	      }
	    });
	  }
	
	  if (isDefined(attr.step) || attr.ngStep) {
	    var stepVal = attr.step || $parse(attr.ngStep)(scope);
	    var parsedStepVal = parseNumberAttrVal(stepVal);
	
	    ctrl.$validators.step = function(modelValue, viewValue) {
	      return ctrl.$isEmpty(viewValue) || isUndefined(parsedStepVal) ||
	        isValidForStep(viewValue, parsedMinVal || 0, parsedStepVal);
	    };
	
	    attr.$observe('step', function(val) {
	      // TODO(matsko): implement validateLater to reduce number of validations
	      if (val !== stepVal) {
	        parsedStepVal = parseNumberAttrVal(val);
	        stepVal = val;
	        ctrl.$validate();
	      }
	
	    });
	
	  }
	}
	
	function rangeInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  badInputChecker(scope, element, attr, ctrl, 'range');
	  numberFormatterParser(ctrl);
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	
	  var supportsRange = ctrl.$$hasNativeValidators && element[0].type === 'range',
	      minVal = supportsRange ? 0 : undefined,
	      maxVal = supportsRange ? 100 : undefined,
	      stepVal = supportsRange ? 1 : undefined,
	      validity = element[0].validity,
	      hasMinAttr = isDefined(attr.min),
	      hasMaxAttr = isDefined(attr.max),
	      hasStepAttr = isDefined(attr.step);
	
	  var originalRender = ctrl.$render;
	
	  ctrl.$render = supportsRange && isDefined(validity.rangeUnderflow) && isDefined(validity.rangeOverflow) ?
	    //Browsers that implement range will set these values automatically, but reading the adjusted values after
	    //$render would cause the min / max validators to be applied with the wrong value
	    function rangeRender() {
	      originalRender();
	      ctrl.$setViewValue(element.val());
	    } :
	    originalRender;
	
	  if (hasMinAttr) {
	    minVal = parseNumberAttrVal(attr.min);
	
	    ctrl.$validators.min = supportsRange ?
	      // Since all browsers set the input to a valid value, we don't need to check validity
	      function noopMinValidator() { return true; } :
	      // non-support browsers validate the min val
	      function minValidator(modelValue, viewValue) {
	        return ctrl.$isEmpty(viewValue) || isUndefined(minVal) || viewValue >= minVal;
	      };
	
	    setInitialValueAndObserver('min', minChange);
	  }
	
	  if (hasMaxAttr) {
	    maxVal = parseNumberAttrVal(attr.max);
	
	    ctrl.$validators.max = supportsRange ?
	      // Since all browsers set the input to a valid value, we don't need to check validity
	      function noopMaxValidator() { return true; } :
	      // non-support browsers validate the max val
	      function maxValidator(modelValue, viewValue) {
	        return ctrl.$isEmpty(viewValue) || isUndefined(maxVal) || viewValue <= maxVal;
	      };
	
	    setInitialValueAndObserver('max', maxChange);
	  }
	
	  if (hasStepAttr) {
	    stepVal = parseNumberAttrVal(attr.step);
	
	    ctrl.$validators.step = supportsRange ?
	      function nativeStepValidator() {
	        // Currently, only FF implements the spec on step change correctly (i.e. adjusting the
	        // input element value to a valid value). It's possible that other browsers set the stepMismatch
	        // validity error instead, so we can at least report an error in that case.
	        return !validity.stepMismatch;
	      } :
	      // ngStep doesn't set the setp attr, so the browser doesn't adjust the input value as setting step would
	      function stepValidator(modelValue, viewValue) {
	        return ctrl.$isEmpty(viewValue) || isUndefined(stepVal) ||
	               isValidForStep(viewValue, minVal || 0, stepVal);
	      };
	
	    setInitialValueAndObserver('step', stepChange);
	  }
	
	  function setInitialValueAndObserver(htmlAttrName, changeFn) {
	    // interpolated attributes set the attribute value only after a digest, but we need the
	    // attribute value when the input is first rendered, so that the browser can adjust the
	    // input value based on the min/max value
	    element.attr(htmlAttrName, attr[htmlAttrName]);
	    var oldVal = attr[htmlAttrName];
	    attr.$observe(htmlAttrName, function wrappedObserver(val) {
	      if (val !== oldVal) {
	        oldVal = val;
	        changeFn(val);
	      }
	    });
	  }
	
	  function minChange(val) {
	    minVal = parseNumberAttrVal(val);
	    // ignore changes before model is initialized
	    if (isNumberNaN(ctrl.$modelValue)) {
	      return;
	    }
	
	    if (supportsRange) {
	      var elVal = element.val();
	      // IE11 doesn't set the el val correctly if the minVal is greater than the element value
	      if (minVal > elVal) {
	        elVal = minVal;
	        element.val(elVal);
	      }
	      ctrl.$setViewValue(elVal);
	    } else {
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    }
	  }
	
	  function maxChange(val) {
	    maxVal = parseNumberAttrVal(val);
	    // ignore changes before model is initialized
	    if (isNumberNaN(ctrl.$modelValue)) {
	      return;
	    }
	
	    if (supportsRange) {
	      var elVal = element.val();
	      // IE11 doesn't set the el val correctly if the maxVal is less than the element value
	      if (maxVal < elVal) {
	        element.val(maxVal);
	        // IE11 and Chrome don't set the value to the minVal when max < min
	        elVal = maxVal < minVal ? minVal : maxVal;
	      }
	      ctrl.$setViewValue(elVal);
	    } else {
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    }
	  }
	
	  function stepChange(val) {
	    stepVal = parseNumberAttrVal(val);
	    // ignore changes before model is initialized
	    if (isNumberNaN(ctrl.$modelValue)) {
	      return;
	    }
	
	    // Some browsers don't adjust the input value correctly, but set the stepMismatch error
	    if (!supportsRange) {
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    } else if (ctrl.$viewValue !== element.val()) {
	      ctrl.$setViewValue(element.val());
	    }
	  }
	}
	
	function urlInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  // Note: no badInputChecker here by purpose as `url` is only a validation
	  // in browsers, i.e. we can always read out input.value even if it is not valid!
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	  stringBasedInputType(ctrl);
	
	  ctrl.$validators.url = function(modelValue, viewValue) {
	    var value = modelValue || viewValue;
	    return ctrl.$isEmpty(value) || URL_REGEXP.test(value);
	  };
	}
	
	function emailInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  // Note: no badInputChecker here by purpose as `url` is only a validation
	  // in browsers, i.e. we can always read out input.value even if it is not valid!
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	  stringBasedInputType(ctrl);
	
	  ctrl.$validators.email = function(modelValue, viewValue) {
	    var value = modelValue || viewValue;
	    return ctrl.$isEmpty(value) || EMAIL_REGEXP.test(value);
	  };
	}
	
	function radioInputType(scope, element, attr, ctrl) {
	  var doTrim = !attr.ngTrim || trim(attr.ngTrim) !== 'false';
	  // make the name unique, if not defined
	  if (isUndefined(attr.name)) {
	    element.attr('name', nextUid());
	  }
	
	  var listener = function(ev) {
	    var value;
	    if (element[0].checked) {
	      value = attr.value;
	      if (doTrim) {
	        value = trim(value);
	      }
	      ctrl.$setViewValue(value, ev && ev.type);
	    }
	  };
	
	  element.on('change', listener);
	
	  ctrl.$render = function() {
	    var value = attr.value;
	    if (doTrim) {
	      value = trim(value);
	    }
	    element[0].checked = (value === ctrl.$viewValue);
	  };
	
	  attr.$observe('value', ctrl.$render);
	}
	
	function parseConstantExpr($parse, context, name, expression, fallback) {
	  var parseFn;
	  if (isDefined(expression)) {
	    parseFn = $parse(expression);
	    if (!parseFn.constant) {
	      throw ngModelMinErr('constexpr', 'Expected constant expression for `{0}`, but saw ' +
	                                   '`{1}`.', name, expression);
	    }
	    return parseFn(context);
	  }
	  return fallback;
	}
	
	function checkboxInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter, $parse) {
	  var trueValue = parseConstantExpr($parse, scope, 'ngTrueValue', attr.ngTrueValue, true);
	  var falseValue = parseConstantExpr($parse, scope, 'ngFalseValue', attr.ngFalseValue, false);
	
	  var listener = function(ev) {
	    ctrl.$setViewValue(element[0].checked, ev && ev.type);
	  };
	
	  element.on('change', listener);
	
	  ctrl.$render = function() {
	    element[0].checked = ctrl.$viewValue;
	  };
	
	  // Override the standard `$isEmpty` because the $viewValue of an empty checkbox is always set to `false`
	  // This is because of the parser below, which compares the `$modelValue` with `trueValue` to convert
	  // it to a boolean.
	  ctrl.$isEmpty = function(value) {
	    return value === false;
	  };
	
	  ctrl.$formatters.push(function(value) {
	    return equals(value, trueValue);
	  });
	
	  ctrl.$parsers.push(function(value) {
	    return value ? trueValue : falseValue;
	  });
	}
	
	
	/**
	 * @ngdoc directive
	 * @name textarea
	 * @restrict E
	 *
	 * @description
	 * HTML textarea element control with AngularJS data-binding. The data-binding and validation
	 * properties of this element are exactly the same as those of the
	 * {@link ng.directive:input input element}.
	 *
	 * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} required Sets `required` validation error key if the value is not entered.
	 * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	 *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	 *    `required` when you want to data-bind to the `required` attribute.
	 * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	 *    minlength.
	 * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	 *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
	 *    length.
	 * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	 *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
	 *    If the expression evaluates to a RegExp object, then this is used directly.
	 *    If the expression evaluates to a string, then it will be converted to a RegExp
	 *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	 *    `new RegExp('^abc$')`.<br />
	 *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	 *    start at the index of the last search's match, thus not taking the whole input value into
	 *    account.
	 * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	 *    interaction with the input element.
	 * @param {boolean=} [ngTrim=true] If set to false AngularJS will not automatically trim the input.
	 *
	 * @knownIssue
	 *
	 * When specifying the `placeholder` attribute of `<textarea>`, Internet Explorer will temporarily
	 * insert the placeholder value as the textarea's content. If the placeholder value contains
	 * interpolation (`{{ ... }}`), an error will be logged in the console when AngularJS tries to update
	 * the value of the by-then-removed text node. This doesn't affect the functionality of the
	 * textarea, but can be undesirable.
	 *
	 * You can work around this Internet Explorer issue by using `ng-attr-placeholder` instead of
	 * `placeholder` on textareas, whenever you need interpolation in the placeholder value. You can
	 * find more details on `ngAttr` in the
	 * [Interpolation](guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes) section of the
	 * Developer Guide.
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name input
	 * @restrict E
	 *
	 * @description
	 * HTML input element control. When used together with {@link ngModel `ngModel`}, it provides data-binding,
	 * input state control, and validation.
	 * Input control follows HTML5 input types and polyfills the HTML5 validation behavior for older browsers.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Not every feature offered is available for all input types.
	 * Specifically, data binding and event handling via `ng-model` is unsupported for `input[file]`.
	 * </div>
	 *
	 * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} required Sets `required` validation error key if the value is not entered.
	 * @param {boolean=} ngRequired Sets `required` attribute if set to true
	 * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	 *    minlength.
	 * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	 *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
	 *    length.
	 * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	 *    value does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
	 *    If the expression evaluates to a RegExp object, then this is used directly.
	 *    If the expression evaluates to a string, then it will be converted to a RegExp
	 *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	 *    `new RegExp('^abc$')`.<br />
	 *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	 *    start at the index of the last search's match, thus not taking the whole input value into
	 *    account.
	 * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	 *    interaction with the input element.
	 * @param {boolean=} [ngTrim=true] If set to false AngularJS will not automatically trim the input.
	 *    This parameter is ignored for input[type=password] controls, which will never trim the
	 *    input.
	 *
	 * @example
	    <example name="input-directive" module="inputExample">
	      <file name="index.html">
	       <script>
	          angular.module('inputExample', [])
	            .controller('ExampleController', ['$scope', function($scope) {
	              $scope.user = {name: 'guest', last: 'visitor'};
	            }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <form name="myForm">
	           <label>
	              User name:
	              <input type="text" name="userName" ng-model="user.name" required>
	           </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.userName.$error.required">
	              Required!</span>
	           </div>
	           <label>
	              Last name:
	              <input type="text" name="lastName" ng-model="user.last"
	              ng-minlength="3" ng-maxlength="10">
	           </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.lastName.$error.minlength">
	               Too short!</span>
	             <span class="error" ng-show="myForm.lastName.$error.maxlength">
	               Too long!</span>
	           </div>
	         </form>
	         <hr>
	         <tt>user = {{user}}</tt><br/>
	         <tt>myForm.userName.$valid = {{myForm.userName.$valid}}</tt><br/>
	         <tt>myForm.userName.$error = {{myForm.userName.$error}}</tt><br/>
	         <tt>myForm.lastName.$valid = {{myForm.lastName.$valid}}</tt><br/>
	         <tt>myForm.lastName.$error = {{myForm.lastName.$error}}</tt><br/>
	         <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	         <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	         <tt>myForm.$error.minlength = {{!!myForm.$error.minlength}}</tt><br/>
	         <tt>myForm.$error.maxlength = {{!!myForm.$error.maxlength}}</tt><br/>
	       </div>
	      </file>
	      <file name="protractor.js" type="protractor">
	        var user = element(by.exactBinding('user'));
	        var userNameValid = element(by.binding('myForm.userName.$valid'));
	        var lastNameValid = element(by.binding('myForm.lastName.$valid'));
	        var lastNameError = element(by.binding('myForm.lastName.$error'));
	        var formValid = element(by.binding('myForm.$valid'));
	        var userNameInput = element(by.model('user.name'));
	        var userLastInput = element(by.model('user.last'));
	
	        it('should initialize to model', function() {
	          expect(user.getText()).toContain('{"name":"guest","last":"visitor"}');
	          expect(userNameValid.getText()).toContain('true');
	          expect(formValid.getText()).toContain('true');
	        });
	
	        it('should be invalid if empty when required', function() {
	          userNameInput.clear();
	          userNameInput.sendKeys('');
	
	          expect(user.getText()).toContain('{"last":"visitor"}');
	          expect(userNameValid.getText()).toContain('false');
	          expect(formValid.getText()).toContain('false');
	        });
	
	        it('should be valid if empty when min length is set', function() {
	          userLastInput.clear();
	          userLastInput.sendKeys('');
	
	          expect(user.getText()).toContain('{"name":"guest","last":""}');
	          expect(lastNameValid.getText()).toContain('true');
	          expect(formValid.getText()).toContain('true');
	        });
	
	        it('should be invalid if less than required min length', function() {
	          userLastInput.clear();
	          userLastInput.sendKeys('xx');
	
	          expect(user.getText()).toContain('{"name":"guest"}');
	          expect(lastNameValid.getText()).toContain('false');
	          expect(lastNameError.getText()).toContain('minlength');
	          expect(formValid.getText()).toContain('false');
	        });
	
	        it('should be invalid if longer than max length', function() {
	          userLastInput.clear();
	          userLastInput.sendKeys('some ridiculously long name');
	
	          expect(user.getText()).toContain('{"name":"guest"}');
	          expect(lastNameValid.getText()).toContain('false');
	          expect(lastNameError.getText()).toContain('maxlength');
	          expect(formValid.getText()).toContain('false');
	        });
	      </file>
	    </example>
	 */
	var inputDirective = ['$browser', '$sniffer', '$filter', '$parse',
	    function($browser, $sniffer, $filter, $parse) {
	  return {
	    restrict: 'E',
	    require: ['?ngModel'],
	    link: {
	      pre: function(scope, element, attr, ctrls) {
	        if (ctrls[0]) {
	          (inputType[lowercase(attr.type)] || inputType.text)(scope, element, attr, ctrls[0], $sniffer,
	                                                              $browser, $filter, $parse);
	        }
	      }
	    }
	  };
	}];
	
	
	var hiddenInputBrowserCacheDirective = function() {
	  var valueProperty = {
	    configurable: true,
	    enumerable: false,
	    get: function() {
	      return this.getAttribute('value') || '';
	    },
	    set: function(val) {
	      this.setAttribute('value', val);
	    }
	  };
	
	  return {
	    restrict: 'E',
	    priority: 200,
	    compile: function(_, attr) {
	      if (lowercase(attr.type) !== 'hidden') {
	        return;
	      }
	
	      return {
	        pre: function(scope, element, attr, ctrls) {
	          var node = element[0];
	
	          // Support: Edge
	          // Moving the DOM around prevents autofillling
	          if (node.parentNode) {
	            node.parentNode.insertBefore(node, node.nextSibling);
	          }
	
	          // Support: FF, IE
	          // Avoiding direct assignment to .value prevents autofillling
	          if (Object.defineProperty) {
	            Object.defineProperty(node, 'value', valueProperty);
	          }
	        }
	      };
	    }
	  };
	};
	
	
	
	var CONSTANT_VALUE_REGEXP = /^(true|false|\d+)$/;
	/**
	 * @ngdoc directive
	 * @name ngValue
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 * Binds the given expression to the value of the element.
	 *
	 * It is mainly used on {@link input[radio] `input[radio]`} and option elements,
	 * so that when the element is selected, the {@link ngModel `ngModel`} of that element (or its
	 * {@link select `select`} parent element) is set to the bound value. It is especially useful
	 * for dynamically generated lists using {@link ngRepeat `ngRepeat`}, as shown below.
	 *
	 * It can also be used to achieve one-way binding of a given expression to an input element
	 * such as an `input[text]` or a `textarea`, when that element does not use ngModel.
	 *
	 * @element ANY
	 * @param {string=} ngValue AngularJS expression, whose value will be bound to the `value` attribute
	 * and `value` property of the element.
	 *
	 * @example
	    <example name="ngValue-directive" module="valueExample">
	      <file name="index.html">
	       <script>
	          angular.module('valueExample', [])
	            .controller('ExampleController', ['$scope', function($scope) {
	              $scope.names = ['pizza', 'unicorns', 'robots'];
	              $scope.my = { favorite: 'unicorns' };
	            }]);
	       </script>
	        <form ng-controller="ExampleController">
	          <h2>Which is your favorite?</h2>
	            <label ng-repeat="name in names" for="{{name}}">
	              {{name}}
	              <input type="radio"
	                     ng-model="my.favorite"
	                     ng-value="name"
	                     id="{{name}}"
	                     name="favorite">
	            </label>
	          <div>You chose {{my.favorite}}</div>
	        </form>
	      </file>
	      <file name="protractor.js" type="protractor">
	        var favorite = element(by.binding('my.favorite'));
	
	        it('should initialize to model', function() {
	          expect(favorite.getText()).toContain('unicorns');
	        });
	        it('should bind the values to the inputs', function() {
	          element.all(by.model('my.favorite')).get(0).click();
	          expect(favorite.getText()).toContain('pizza');
	        });
	      </file>
	    </example>
	 */
	var ngValueDirective = function() {
	  /**
	   *  inputs use the value attribute as their default value if the value property is not set.
	   *  Once the value property has been set (by adding input), it will not react to changes to
	   *  the value attribute anymore. Setting both attribute and property fixes this behavior, and
	   *  makes it possible to use ngValue as a sort of one-way bind.
	   */
	  function updateElementValue(element, attr, value) {
	    // Support: IE9 only
	    // In IE9 values are converted to string (e.g. `input.value = null` results in `input.value === 'null'`).
	    var propValue = isDefined(value) ? value : (msie === 9) ? '' : null;
	    element.prop('value', propValue);
	    attr.$set('value', value);
	  }
	
	  return {
	    restrict: 'A',
	    priority: 100,
	    compile: function(tpl, tplAttr) {
	      if (CONSTANT_VALUE_REGEXP.test(tplAttr.ngValue)) {
	        return function ngValueConstantLink(scope, elm, attr) {
	          var value = scope.$eval(attr.ngValue);
	          updateElementValue(elm, attr, value);
	        };
	      } else {
	        return function ngValueLink(scope, elm, attr) {
	          scope.$watch(attr.ngValue, function valueWatchAction(value) {
	            updateElementValue(elm, attr, value);
	          });
	        };
	      }
	    }
	  };
	};
	
	/**
	 * @ngdoc directive
	 * @name ngBind
	 * @restrict AC
	 *
	 * @description
	 * The `ngBind` attribute tells AngularJS to replace the text content of the specified HTML element
	 * with the value of a given expression, and to update the text content when the value of that
	 * expression changes.
	 *
	 * Typically, you don't use `ngBind` directly, but instead you use the double curly markup like
	 * `{{ expression }}` which is similar but less verbose.
	 *
	 * It is preferable to use `ngBind` instead of `{{ expression }}` if a template is momentarily
	 * displayed by the browser in its raw state before AngularJS compiles it. Since `ngBind` is an
	 * element attribute, it makes the bindings invisible to the user while the page is loading.
	 *
	 * An alternative solution to this problem would be using the
	 * {@link ng.directive:ngCloak ngCloak} directive.
	 *
	 *
	 * @element ANY
	 * @param {expression} ngBind {@link guide/expression Expression} to evaluate.
	 *
	 * @example
	 * Enter a name in the Live Preview text box; the greeting below the text box changes instantly.
	   <example module="bindExample" name="ng-bind">
	     <file name="index.html">
	       <script>
	         angular.module('bindExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.name = 'Whirled';
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <label>Enter name: <input type="text" ng-model="name"></label><br>
	         Hello <span ng-bind="name"></span>!
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-bind', function() {
	         var nameInput = element(by.model('name'));
	
	         expect(element(by.binding('name')).getText()).toBe('Whirled');
	         nameInput.clear();
	         nameInput.sendKeys('world');
	         expect(element(by.binding('name')).getText()).toBe('world');
	       });
	     </file>
	   </example>
	 */
	var ngBindDirective = ['$compile', function($compile) {
	  return {
	    restrict: 'AC',
	    compile: function ngBindCompile(templateElement) {
	      $compile.$$addBindingClass(templateElement);
	      return function ngBindLink(scope, element, attr) {
	        $compile.$$addBindingInfo(element, attr.ngBind);
	        element = element[0];
	        scope.$watch(attr.ngBind, function ngBindWatchAction(value) {
	          element.textContent = stringify(value);
	        });
	      };
	    }
	  };
	}];
	
	
	/**
	 * @ngdoc directive
	 * @name ngBindTemplate
	 *
	 * @description
	 * The `ngBindTemplate` directive specifies that the element
	 * text content should be replaced with the interpolation of the template
	 * in the `ngBindTemplate` attribute.
	 * Unlike `ngBind`, the `ngBindTemplate` can contain multiple `{{` `}}`
	 * expressions. This directive is needed since some HTML elements
	 * (such as TITLE and OPTION) cannot contain SPAN elements.
	 *
	 * @element ANY
	 * @param {string} ngBindTemplate template of form
	 *   <tt>{{</tt> <tt>expression</tt> <tt>}}</tt> to eval.
	 *
	 * @example
	 * Try it here: enter text in text box and watch the greeting change.
	   <example module="bindExample" name="ng-bind-template">
	     <file name="index.html">
	       <script>
	         angular.module('bindExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.salutation = 'Hello';
	             $scope.name = 'World';
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	        <label>Salutation: <input type="text" ng-model="salutation"></label><br>
	        <label>Name: <input type="text" ng-model="name"></label><br>
	        <pre ng-bind-template="{{salutation}} {{name}}!"></pre>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-bind', function() {
	         var salutationElem = element(by.binding('salutation'));
	         var salutationInput = element(by.model('salutation'));
	         var nameInput = element(by.model('name'));
	
	         expect(salutationElem.getText()).toBe('Hello World!');
	
	         salutationInput.clear();
	         salutationInput.sendKeys('Greetings');
	         nameInput.clear();
	         nameInput.sendKeys('user');
	
	         expect(salutationElem.getText()).toBe('Greetings user!');
	       });
	     </file>
	   </example>
	 */
	var ngBindTemplateDirective = ['$interpolate', '$compile', function($interpolate, $compile) {
	  return {
	    compile: function ngBindTemplateCompile(templateElement) {
	      $compile.$$addBindingClass(templateElement);
	      return function ngBindTemplateLink(scope, element, attr) {
	        var interpolateFn = $interpolate(element.attr(attr.$attr.ngBindTemplate));
	        $compile.$$addBindingInfo(element, interpolateFn.expressions);
	        element = element[0];
	        attr.$observe('ngBindTemplate', function(value) {
	          element.textContent = isUndefined(value) ? '' : value;
	        });
	      };
	    }
	  };
	}];
	
	
	/**
	 * @ngdoc directive
	 * @name ngBindHtml
	 *
	 * @description
	 * Evaluates the expression and inserts the resulting HTML into the element in a secure way. By default,
	 * the resulting HTML content will be sanitized using the {@link ngSanitize.$sanitize $sanitize} service.
	 * To utilize this functionality, ensure that `$sanitize` is available, for example, by including {@link
	 * ngSanitize} in your module's dependencies (not in core AngularJS). In order to use {@link ngSanitize}
	 * in your module's dependencies, you need to include "angular-sanitize.js" in your application.
	 *
	 * You may also bypass sanitization for values you know are safe. To do so, bind to
	 * an explicitly trusted value via {@link ng.$sce#trustAsHtml $sce.trustAsHtml}.  See the example
	 * under {@link ng.$sce#show-me-an-example-using-sce- Strict Contextual Escaping (SCE)}.
	 *
	 * Note: If a `$sanitize` service is unavailable and the bound value isn't explicitly trusted, you
	 * will have an exception (instead of an exploit.)
	 *
	 * @element ANY
	 * @param {expression} ngBindHtml {@link guide/expression Expression} to evaluate.
	 *
	 * @example
	
	   <example module="bindHtmlExample" deps="angular-sanitize.js" name="ng-bind-html">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	        <p ng-bind-html="myHTML"></p>
	       </div>
	     </file>
	
	     <file name="script.js">
	       angular.module('bindHtmlExample', ['ngSanitize'])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.myHTML =
	              'I am an <code>HTML</code>string with ' +
	              '<a href="#">links!</a> and other <em>stuff</em>';
	         }]);
	     </file>
	
	     <file name="protractor.js" type="protractor">
	       it('should check ng-bind-html', function() {
	         expect(element(by.binding('myHTML')).getText()).toBe(
	             'I am an HTMLstring with links! and other stuff');
	       });
	     </file>
	   </example>
	 */
	var ngBindHtmlDirective = ['$sce', '$parse', '$compile', function($sce, $parse, $compile) {
	  return {
	    restrict: 'A',
	    compile: function ngBindHtmlCompile(tElement, tAttrs) {
	      var ngBindHtmlGetter = $parse(tAttrs.ngBindHtml);
	      var ngBindHtmlWatch = $parse(tAttrs.ngBindHtml, function sceValueOf(val) {
	        // Unwrap the value to compare the actual inner safe value, not the wrapper object.
	        return $sce.valueOf(val);
	      });
	      $compile.$$addBindingClass(tElement);
	
	      return function ngBindHtmlLink(scope, element, attr) {
	        $compile.$$addBindingInfo(element, attr.ngBindHtml);
	
	        scope.$watch(ngBindHtmlWatch, function ngBindHtmlWatchAction() {
	          // The watched value is the unwrapped value. To avoid re-escaping, use the direct getter.
	          var value = ngBindHtmlGetter(scope);
	          element.html($sce.getTrustedHtml(value) || '');
	        });
	      };
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngChange
	 * @restrict A
	 *
	 * @description
	 * Evaluate the given expression when the user changes the input.
	 * The expression is evaluated immediately, unlike the JavaScript onchange event
	 * which only triggers at the end of a change (usually, when the user leaves the
	 * form element or presses the return key).
	 *
	 * The `ngChange` expression is only evaluated when a change in the input value causes
	 * a new value to be committed to the model.
	 *
	 * It will not be evaluated:
	 * * if the value returned from the `$parsers` transformation pipeline has not changed
	 * * if the input has continued to be invalid since the model will stay `null`
	 * * if the model is changed programmatically and not by a change to the input value
	 *
	 *
	 * Note, this directive requires `ngModel` to be present.
	 *
	 * @element ANY
	 * @param {expression} ngChange {@link guide/expression Expression} to evaluate upon change
	 * in input value.
	 *
	 * @example
	 * <example name="ngChange-directive" module="changeExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('changeExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.counter = 0;
	 *           $scope.change = function() {
	 *             $scope.counter++;
	 *           };
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <input type="checkbox" ng-model="confirmed" ng-change="change()" id="ng-change-example1" />
	 *       <input type="checkbox" ng-model="confirmed" id="ng-change-example2" />
	 *       <label for="ng-change-example2">Confirmed</label><br />
	 *       <tt>debug = {{confirmed}}</tt><br/>
	 *       <tt>counter = {{counter}}</tt><br/>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     var counter = element(by.binding('counter'));
	 *     var debug = element(by.binding('confirmed'));
	 *
	 *     it('should evaluate the expression if changing from view', function() {
	 *       expect(counter.getText()).toContain('0');
	 *
	 *       element(by.id('ng-change-example1')).click();
	 *
	 *       expect(counter.getText()).toContain('1');
	 *       expect(debug.getText()).toContain('true');
	 *     });
	 *
	 *     it('should not evaluate the expression if changing from model', function() {
	 *       element(by.id('ng-change-example2')).click();
	
	 *       expect(counter.getText()).toContain('0');
	 *       expect(debug.getText()).toContain('true');
	 *     });
	 *   </file>
	 * </example>
	 */
	var ngChangeDirective = valueFn({
	  restrict: 'A',
	  require: 'ngModel',
	  link: function(scope, element, attr, ctrl) {
	    ctrl.$viewChangeListeners.push(function() {
	      scope.$eval(attr.ngChange);
	    });
	  }
	});
	
	/* exported
	  ngClassDirective,
	  ngClassEvenDirective,
	  ngClassOddDirective
	*/
	
	function classDirective(name, selector) {
	  name = 'ngClass' + name;
	  var indexWatchExpression;
	
	  return ['$parse', function($parse) {
	    return {
	      restrict: 'AC',
	      link: function(scope, element, attr) {
	        var classCounts = element.data('$classCounts');
	        var oldModulo = true;
	        var oldClassString;
	
	        if (!classCounts) {
	          // Use createMap() to prevent class assumptions involving property
	          // names in Object.prototype
	          classCounts = createMap();
	          element.data('$classCounts', classCounts);
	        }
	
	        if (name !== 'ngClass') {
	          if (!indexWatchExpression) {
	            indexWatchExpression = $parse('$index', function moduloTwo($index) {
	              // eslint-disable-next-line no-bitwise
	              return $index & 1;
	            });
	          }
	
	          scope.$watch(indexWatchExpression, ngClassIndexWatchAction);
	        }
	
	        scope.$watch($parse(attr[name], toClassString), ngClassWatchAction);
	
	        function addClasses(classString) {
	          classString = digestClassCounts(split(classString), 1);
	          attr.$addClass(classString);
	        }
	
	        function removeClasses(classString) {
	          classString = digestClassCounts(split(classString), -1);
	          attr.$removeClass(classString);
	        }
	
	        function updateClasses(oldClassString, newClassString) {
	          var oldClassArray = split(oldClassString);
	          var newClassArray = split(newClassString);
	
	          var toRemoveArray = arrayDifference(oldClassArray, newClassArray);
	          var toAddArray = arrayDifference(newClassArray, oldClassArray);
	
	          var toRemoveString = digestClassCounts(toRemoveArray, -1);
	          var toAddString = digestClassCounts(toAddArray, 1);
	
	          attr.$addClass(toAddString);
	          attr.$removeClass(toRemoveString);
	        }
	
	        function digestClassCounts(classArray, count) {
	          var classesToUpdate = [];
	
	          forEach(classArray, function(className) {
	            if (count > 0 || classCounts[className]) {
	              classCounts[className] = (classCounts[className] || 0) + count;
	              if (classCounts[className] === +(count > 0)) {
	                classesToUpdate.push(className);
	              }
	            }
	          });
	
	          return classesToUpdate.join(' ');
	        }
	
	        function ngClassIndexWatchAction(newModulo) {
	          // This watch-action should run before the `ngClassWatchAction()`, thus it
	          // adds/removes `oldClassString`. If the `ngClass` expression has changed as well, the
	          // `ngClassWatchAction()` will update the classes.
	          if (newModulo === selector) {
	            addClasses(oldClassString);
	          } else {
	            removeClasses(oldClassString);
	          }
	
	          oldModulo = newModulo;
	        }
	
	        function ngClassWatchAction(newClassString) {
	          if (oldModulo === selector) {
	            updateClasses(oldClassString, newClassString);
	          }
	
	          oldClassString = newClassString;
	        }
	      }
	    };
	  }];
	
	  // Helpers
	  function arrayDifference(tokens1, tokens2) {
	    if (!tokens1 || !tokens1.length) return [];
	    if (!tokens2 || !tokens2.length) return tokens1;
	
	    var values = [];
	
	    outer:
	    for (var i = 0; i < tokens1.length; i++) {
	      var token = tokens1[i];
	      for (var j = 0; j < tokens2.length; j++) {
	        if (token === tokens2[j]) continue outer;
	      }
	      values.push(token);
	    }
	
	    return values;
	  }
	
	  function split(classString) {
	    return classString && classString.split(' ');
	  }
	
	  function toClassString(classValue) {
	    if (!classValue) return classValue;
	
	    var classString = classValue;
	
	    if (isArray(classValue)) {
	      classString = classValue.map(toClassString).join(' ');
	    } else if (isObject(classValue)) {
	      classString = Object.keys(classValue).
	        filter(function(key) { return classValue[key]; }).
	        join(' ');
	    } else if (!isString(classValue)) {
	      classString = classValue + '';
	    }
	
	    return classString;
	  }
	}
	
	/**
	 * @ngdoc directive
	 * @name ngClass
	 * @restrict AC
	 * @element ANY
	 *
	 * @description
	 * The `ngClass` directive allows you to dynamically set CSS classes on an HTML element by databinding
	 * an expression that represents all classes to be added.
	 *
	 * The directive operates in three different ways, depending on which of three types the expression
	 * evaluates to:
	 *
	 * 1. If the expression evaluates to a string, the string should be one or more space-delimited class
	 * names.
	 *
	 * 2. If the expression evaluates to an object, then for each key-value pair of the
	 * object with a truthy value the corresponding key is used as a class name.
	 *
	 * 3. If the expression evaluates to an array, each element of the array should either be a string as in
	 * type 1 or an object as in type 2. This means that you can mix strings and objects together in an array
	 * to give you more control over what CSS classes appear. See the code below for an example of this.
	 *
	 *
	 * The directive won't add duplicate classes if a particular class was already set.
	 *
	 * When the expression changes, the previously added classes are removed and only then are the
	 * new classes added.
	 *
	 * @knownIssue
	 * You should not use {@link guide/interpolation interpolation} in the value of the `class`
	 * attribute, when using the `ngClass` directive on the same element.
	 * See {@link guide/interpolation#known-issues here} for more info.
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#addClass addClass}       | just before the class is applied to the element   |
	 * | {@link ng.$animate#removeClass removeClass} | just before the class is removed from the element |
	 * | {@link ng.$animate#setClass setClass} | just before classes are added and classes are removed from the element at the same time |
	 *
	 * ### ngClass and pre-existing CSS3 Transitions/Animations
	   The ngClass directive still supports CSS3 Transitions/Animations even if they do not follow the ngAnimate CSS naming structure.
	   Upon animation ngAnimate will apply supplementary CSS classes to track the start and end of an animation, but this will not hinder
	   any pre-existing CSS transitions already on the element. To get an idea of what happens during a class-based animation, be sure
	   to view the step by step details of {@link $animate#addClass $animate.addClass} and
	   {@link $animate#removeClass $animate.removeClass}.
	 *
	 * @param {expression} ngClass {@link guide/expression Expression} to eval. The result
	 *   of the evaluation can be a string representing space delimited class
	 *   names, an array, or a map of class names to boolean values. In the case of a map, the
	 *   names of the properties whose values are truthy will be added as css classes to the
	 *   element.
	 *
	 * @example
	 * ### Basic
	   <example name="ng-class">
	     <file name="index.html">
	       <p ng-class="{strike: deleted, bold: important, 'has-error': error}">Map Syntax Example</p>
	       <label>
	          <input type="checkbox" ng-model="deleted">
	          deleted (apply "strike" class)
	       </label><br>
	       <label>
	          <input type="checkbox" ng-model="important">
	          important (apply "bold" class)
	       </label><br>
	       <label>
	          <input type="checkbox" ng-model="error">
	          error (apply "has-error" class)
	       </label>
	       <hr>
	       <p ng-class="style">Using String Syntax</p>
	       <input type="text" ng-model="style"
	              placeholder="Type: bold strike red" aria-label="Type: bold strike red">
	       <hr>
	       <p ng-class="[style1, style2, style3]">Using Array Syntax</p>
	       <input ng-model="style1"
	              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red"><br>
	       <input ng-model="style2"
	              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 2"><br>
	       <input ng-model="style3"
	              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 3"><br>
	       <hr>
	       <p ng-class="[style4, {orange: warning}]">Using Array and Map Syntax</p>
	       <input ng-model="style4" placeholder="Type: bold, strike" aria-label="Type: bold, strike"><br>
	       <label><input type="checkbox" ng-model="warning"> warning (apply "orange" class)</label>
	     </file>
	     <file name="style.css">
	       .strike {
	           text-decoration: line-through;
	       }
	       .bold {
	           font-weight: bold;
	       }
	       .red {
	           color: red;
	       }
	       .has-error {
	           color: red;
	           background-color: yellow;
	       }
	       .orange {
	           color: orange;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       var ps = element.all(by.css('p'));
	
	       it('should let you toggle the class', function() {
	
	         expect(ps.first().getAttribute('class')).not.toMatch(/bold/);
	         expect(ps.first().getAttribute('class')).not.toMatch(/has-error/);
	
	         element(by.model('important')).click();
	         expect(ps.first().getAttribute('class')).toMatch(/bold/);
	
	         element(by.model('error')).click();
	         expect(ps.first().getAttribute('class')).toMatch(/has-error/);
	       });
	
	       it('should let you toggle string example', function() {
	         expect(ps.get(1).getAttribute('class')).toBe('');
	         element(by.model('style')).clear();
	         element(by.model('style')).sendKeys('red');
	         expect(ps.get(1).getAttribute('class')).toBe('red');
	       });
	
	       it('array example should have 3 classes', function() {
	         expect(ps.get(2).getAttribute('class')).toBe('');
	         element(by.model('style1')).sendKeys('bold');
	         element(by.model('style2')).sendKeys('strike');
	         element(by.model('style3')).sendKeys('red');
	         expect(ps.get(2).getAttribute('class')).toBe('bold strike red');
	       });
	
	       it('array with map example should have 2 classes', function() {
	         expect(ps.last().getAttribute('class')).toBe('');
	         element(by.model('style4')).sendKeys('bold');
	         element(by.model('warning')).click();
	         expect(ps.last().getAttribute('class')).toBe('bold orange');
	       });
	     </file>
	   </example>
	
	   @example
	   ### Animations
	
	   The example below demonstrates how to perform animations using ngClass.
	
	   <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-class">
	     <file name="index.html">
	      <input id="setbtn" type="button" value="set" ng-click="myVar='my-class'">
	      <input id="clearbtn" type="button" value="clear" ng-click="myVar=''">
	      <br>
	      <span class="base-class" ng-class="myVar">Sample Text</span>
	     </file>
	     <file name="style.css">
	       .base-class {
	         transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	       }
	
	       .base-class.my-class {
	         color: red;
	         font-size:3em;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-class', function() {
	         expect(element(by.css('.base-class')).getAttribute('class')).not.
	           toMatch(/my-class/);
	
	         element(by.id('setbtn')).click();
	
	         expect(element(by.css('.base-class')).getAttribute('class')).
	           toMatch(/my-class/);
	
	         element(by.id('clearbtn')).click();
	
	         expect(element(by.css('.base-class')).getAttribute('class')).not.
	           toMatch(/my-class/);
	       });
	     </file>
	   </example>
	 */
	var ngClassDirective = classDirective('', true);
	
	/**
	 * @ngdoc directive
	 * @name ngClassOdd
	 * @restrict AC
	 *
	 * @description
	 * The `ngClassOdd` and `ngClassEven` directives work exactly as
	 * {@link ng.directive:ngClass ngClass}, except they work in
	 * conjunction with `ngRepeat` and take effect only on odd (even) rows.
	 *
	 * This directive can be applied only within the scope of an
	 * {@link ng.directive:ngRepeat ngRepeat}.
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#addClass addClass}       | just before the class is applied to the element   |
	 * | {@link ng.$animate#removeClass removeClass} | just before the class is removed from the element |
	 *
	 * @element ANY
	 * @param {expression} ngClassOdd {@link guide/expression Expression} to eval. The result
	 *   of the evaluation can be a string representing space delimited class names or an array.
	 *
	 * @example
	   <example name="ng-class-odd">
	     <file name="index.html">
	        <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
	          <li ng-repeat="name in names">
	           <span ng-class-odd="'odd'" ng-class-even="'even'">
	             {{name}}
	           </span>
	          </li>
	        </ol>
	     </file>
	     <file name="style.css">
	       .odd {
	         color: red;
	       }
	       .even {
	         color: blue;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-class-odd and ng-class-even', function() {
	         expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
	           toMatch(/odd/);
	         expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
	           toMatch(/even/);
	       });
	     </file>
	   </example>
	 *
	 * <hr />
	 * @example
	 * An example on how to implement animations using `ngClassOdd`:
	 *
	   <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-class-odd-animate">
	     <file name="index.html">
	       <div ng-init="items=['Item 3', 'Item 2', 'Item 1', 'Item 0']">
	         <button ng-click="items.unshift('Item ' + items.length)">Add item</button>
	         <hr />
	         <table>
	           <tr ng-repeat="item in items" ng-class-odd="'odd'">
	             <td>{{ item }}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="style.css">
	       .odd {
	         background: rgba(255, 255, 0, 0.25);
	       }
	
	       .odd-add, .odd-remove {
	         transition: 1.5s;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should add new entries to the beginning of the list', function() {
	         var button = element(by.buttonText('Add item'));
	         var rows = element.all(by.repeater('item in items'));
	
	         expect(rows.count()).toBe(4);
	         expect(rows.get(0).getText()).toBe('Item 3');
	         expect(rows.get(1).getText()).toBe('Item 2');
	
	         button.click();
	
	         expect(rows.count()).toBe(5);
	         expect(rows.get(0).getText()).toBe('Item 4');
	         expect(rows.get(1).getText()).toBe('Item 3');
	       });
	
	       it('should add odd class to odd entries', function() {
	         var button = element(by.buttonText('Add item'));
	         var rows = element.all(by.repeater('item in items'));
	
	         expect(rows.get(0).getAttribute('class')).toMatch(/odd/);
	         expect(rows.get(1).getAttribute('class')).not.toMatch(/odd/);
	
	         button.click();
	
	         expect(rows.get(0).getAttribute('class')).toMatch(/odd/);
	         expect(rows.get(1).getAttribute('class')).not.toMatch(/odd/);
	       });
	     </file>
	   </example>
	 */
	var ngClassOddDirective = classDirective('Odd', 0);
	
	/**
	 * @ngdoc directive
	 * @name ngClassEven
	 * @restrict AC
	 *
	 * @description
	 * The `ngClassOdd` and `ngClassEven` directives work exactly as
	 * {@link ng.directive:ngClass ngClass}, except they work in
	 * conjunction with `ngRepeat` and take effect only on odd (even) rows.
	 *
	 * This directive can be applied only within the scope of an
	 * {@link ng.directive:ngRepeat ngRepeat}.
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#addClass addClass}       | just before the class is applied to the element   |
	 * | {@link ng.$animate#removeClass removeClass} | just before the class is removed from the element |
	 *
	 * @element ANY
	 * @param {expression} ngClassEven {@link guide/expression Expression} to eval. The
	 *   result of the evaluation can be a string representing space delimited class names or an array.
	 *
	 * @example
	   <example name="ng-class-even">
	     <file name="index.html">
	        <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
	          <li ng-repeat="name in names">
	           <span ng-class-odd="'odd'" ng-class-even="'even'">
	             {{name}} &nbsp; &nbsp; &nbsp;
	           </span>
	          </li>
	        </ol>
	     </file>
	     <file name="style.css">
	       .odd {
	         color: red;
	       }
	       .even {
	         color: blue;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-class-odd and ng-class-even', function() {
	         expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
	           toMatch(/odd/);
	         expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
	           toMatch(/even/);
	       });
	     </file>
	   </example>
	 *
	 * <hr />
	 * @example
	 * An example on how to implement animations using `ngClassEven`:
	 *
	   <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-class-even-animate">
	     <file name="index.html">
	       <div ng-init="items=['Item 3', 'Item 2', 'Item 1', 'Item 0']">
	         <button ng-click="items.unshift('Item ' + items.length)">Add item</button>
	         <hr />
	         <table>
	           <tr ng-repeat="item in items" ng-class-even="'even'">
	             <td>{{ item }}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="style.css">
	       .even {
	         background: rgba(255, 255, 0, 0.25);
	       }
	
	       .even-add, .even-remove {
	         transition: 1.5s;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should add new entries to the beginning of the list', function() {
	         var button = element(by.buttonText('Add item'));
	         var rows = element.all(by.repeater('item in items'));
	
	         expect(rows.count()).toBe(4);
	         expect(rows.get(0).getText()).toBe('Item 3');
	         expect(rows.get(1).getText()).toBe('Item 2');
	
	         button.click();
	
	         expect(rows.count()).toBe(5);
	         expect(rows.get(0).getText()).toBe('Item 4');
	         expect(rows.get(1).getText()).toBe('Item 3');
	       });
	
	       it('should add even class to even entries', function() {
	         var button = element(by.buttonText('Add item'));
	         var rows = element.all(by.repeater('item in items'));
	
	         expect(rows.get(0).getAttribute('class')).not.toMatch(/even/);
	         expect(rows.get(1).getAttribute('class')).toMatch(/even/);
	
	         button.click();
	
	         expect(rows.get(0).getAttribute('class')).not.toMatch(/even/);
	         expect(rows.get(1).getAttribute('class')).toMatch(/even/);
	       });
	     </file>
	   </example>
	 */
	var ngClassEvenDirective = classDirective('Even', 1);
	
	/**
	 * @ngdoc directive
	 * @name ngCloak
	 * @restrict AC
	 *
	 * @description
	 * The `ngCloak` directive is used to prevent the AngularJS html template from being briefly
	 * displayed by the browser in its raw (uncompiled) form while your application is loading. Use this
	 * directive to avoid the undesirable flicker effect caused by the html template display.
	 *
	 * The directive can be applied to the `<body>` element, but the preferred usage is to apply
	 * multiple `ngCloak` directives to small portions of the page to permit progressive rendering
	 * of the browser view.
	 *
	 * `ngCloak` works in cooperation with the following css rule embedded within `angular.js` and
	 * `angular.min.js`.
	 * For CSP mode please add `angular-csp.css` to your html file (see {@link ng.directive:ngCsp ngCsp}).
	 *
	 * ```css
	 * [ng\:cloak], [ng-cloak], [data-ng-cloak], [x-ng-cloak], .ng-cloak, .x-ng-cloak {
	 *   display: none !important;
	 * }
	 * ```
	 *
	 * When this css rule is loaded by the browser, all html elements (including their children) that
	 * are tagged with the `ngCloak` directive are hidden. When AngularJS encounters this directive
	 * during the compilation of the template it deletes the `ngCloak` element attribute, making
	 * the compiled element visible.
	 *
	 * For the best result, the `angular.js` script must be loaded in the head section of the html
	 * document; alternatively, the css rule above must be included in the external stylesheet of the
	 * application.
	 *
	 * @element ANY
	 *
	 * @example
	   <example name="ng-cloak">
	     <file name="index.html">
	        <div id="template1" ng-cloak>{{ 'hello' }}</div>
	        <div id="template2" class="ng-cloak">{{ 'world' }}</div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should remove the template directive and css class', function() {
	         expect($('#template1').getAttribute('ng-cloak')).
	           toBeNull();
	         expect($('#template2').getAttribute('ng-cloak')).
	           toBeNull();
	       });
	     </file>
	   </example>
	 *
	 */
	var ngCloakDirective = ngDirective({
	  compile: function(element, attr) {
	    attr.$set('ngCloak', undefined);
	    element.removeClass('ng-cloak');
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngController
	 *
	 * @description
	 * The `ngController` directive attaches a controller class to the view. This is a key aspect of how angular
	 * supports the principles behind the Model-View-Controller design pattern.
	 *
	 * MVC components in angular:
	 *
	 * * Model — Models are the properties of a scope; scopes are attached to the DOM where scope properties
	 *   are accessed through bindings.
	 * * View — The template (HTML with data bindings) that is rendered into the View.
	 * * Controller — The `ngController` directive specifies a Controller class; the class contains business
	 *   logic behind the application to decorate the scope with functions and values
	 *
	 * Note that you can also attach controllers to the DOM by declaring it in a route definition
	 * via the {@link ngRoute.$route $route} service. A common mistake is to declare the controller
	 * again using `ng-controller` in the template itself.  This will cause the controller to be attached
	 * and executed twice.
	 *
	 * @element ANY
	 * @scope
	 * @priority 500
	 * @param {expression} ngController Name of a constructor function registered with the current
	 * {@link ng.$controllerProvider $controllerProvider} or an {@link guide/expression expression}
	 * that on the current scope evaluates to a constructor function.
	 *
	 * The controller instance can be published into a scope property by specifying
	 * `ng-controller="as propertyName"`.
	 *
	 * @example
	 * Here is a simple form for editing user contact information. Adding, removing, clearing, and
	 * greeting are methods declared on the controller (see source tab). These methods can
	 * easily be called from the AngularJS markup. Any changes to the data are automatically reflected
	 * in the View without the need for a manual update.
	 *
	 * Two different declaration styles are included below:
	 *
	 * * one binds methods and properties directly onto the controller using `this`:
	 * `ng-controller="SettingsController1 as settings"`
	 * * one injects `$scope` into the controller:
	 * `ng-controller="SettingsController2"`
	 *
	 * The second option is more common in the AngularJS community, and is generally used in boilerplates
	 * and in this guide. However, there are advantages to binding properties directly to the controller
	 * and avoiding scope.
	 *
	 * * Using `controller as` makes it obvious which controller you are accessing in the template when
	 * multiple controllers apply to an element.
	 * * If you are writing your controllers as classes you have easier access to the properties and
	 * methods, which will appear on the scope, from inside the controller code.
	 * * Since there is always a `.` in the bindings, you don't have to worry about prototypal
	 * inheritance masking primitives.
	 *
	 * This example demonstrates the `controller as` syntax.
	 *
	 * <example name="ngControllerAs" module="controllerAsExample">
	 *   <file name="index.html">
	 *    <div id="ctrl-as-exmpl" ng-controller="SettingsController1 as settings">
	 *      <label>Name: <input type="text" ng-model="settings.name"/></label>
	 *      <button ng-click="settings.greet()">greet</button><br/>
	 *      Contact:
	 *      <ul>
	 *        <li ng-repeat="contact in settings.contacts">
	 *          <select ng-model="contact.type" aria-label="Contact method" id="select_{{$index}}">
	 *             <option>phone</option>
	 *             <option>email</option>
	 *          </select>
	 *          <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
	 *          <button ng-click="settings.clearContact(contact)">clear</button>
	 *          <button ng-click="settings.removeContact(contact)" aria-label="Remove">X</button>
	 *        </li>
	 *        <li><button ng-click="settings.addContact()">add</button></li>
	 *     </ul>
	 *    </div>
	 *   </file>
	 *   <file name="app.js">
	 *    angular.module('controllerAsExample', [])
	 *      .controller('SettingsController1', SettingsController1);
	 *
	 *    function SettingsController1() {
	 *      this.name = 'John Smith';
	 *      this.contacts = [
	 *        {type: 'phone', value: '408 555 1212'},
	 *        {type: 'email', value: 'john.smith@example.org'}
	 *      ];
	 *    }
	 *
	 *    SettingsController1.prototype.greet = function() {
	 *      alert(this.name);
	 *    };
	 *
	 *    SettingsController1.prototype.addContact = function() {
	 *      this.contacts.push({type: 'email', value: 'yourname@example.org'});
	 *    };
	 *
	 *    SettingsController1.prototype.removeContact = function(contactToRemove) {
	 *     var index = this.contacts.indexOf(contactToRemove);
	 *      this.contacts.splice(index, 1);
	 *    };
	 *
	 *    SettingsController1.prototype.clearContact = function(contact) {
	 *      contact.type = 'phone';
	 *      contact.value = '';
	 *    };
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     it('should check controller as', function() {
	 *       var container = element(by.id('ctrl-as-exmpl'));
	 *         expect(container.element(by.model('settings.name'))
	 *           .getAttribute('value')).toBe('John Smith');
	 *
	 *       var firstRepeat =
	 *           container.element(by.repeater('contact in settings.contacts').row(0));
	 *       var secondRepeat =
	 *           container.element(by.repeater('contact in settings.contacts').row(1));
	 *
	 *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *           .toBe('408 555 1212');
	 *
	 *       expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *           .toBe('john.smith@example.org');
	 *
	 *       firstRepeat.element(by.buttonText('clear')).click();
	 *
	 *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *           .toBe('');
	 *
	 *       container.element(by.buttonText('add')).click();
	 *
	 *       expect(container.element(by.repeater('contact in settings.contacts').row(2))
	 *           .element(by.model('contact.value'))
	 *           .getAttribute('value'))
	 *           .toBe('yourname@example.org');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * This example demonstrates the "attach to `$scope`" style of controller.
	 *
	 * <example name="ngController" module="controllerExample">
	 *  <file name="index.html">
	 *   <div id="ctrl-exmpl" ng-controller="SettingsController2">
	 *     <label>Name: <input type="text" ng-model="name"/></label>
	 *     <button ng-click="greet()">greet</button><br/>
	 *     Contact:
	 *     <ul>
	 *       <li ng-repeat="contact in contacts">
	 *         <select ng-model="contact.type" id="select_{{$index}}">
	 *            <option>phone</option>
	 *            <option>email</option>
	 *         </select>
	 *         <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
	 *         <button ng-click="clearContact(contact)">clear</button>
	 *         <button ng-click="removeContact(contact)">X</button>
	 *       </li>
	 *       <li>[ <button ng-click="addContact()">add</button> ]</li>
	 *    </ul>
	 *   </div>
	 *  </file>
	 *  <file name="app.js">
	 *   angular.module('controllerExample', [])
	 *     .controller('SettingsController2', ['$scope', SettingsController2]);
	 *
	 *   function SettingsController2($scope) {
	 *     $scope.name = 'John Smith';
	 *     $scope.contacts = [
	 *       {type:'phone', value:'408 555 1212'},
	 *       {type:'email', value:'john.smith@example.org'}
	 *     ];
	 *
	 *     $scope.greet = function() {
	 *       alert($scope.name);
	 *     };
	 *
	 *     $scope.addContact = function() {
	 *       $scope.contacts.push({type:'email', value:'yourname@example.org'});
	 *     };
	 *
	 *     $scope.removeContact = function(contactToRemove) {
	 *       var index = $scope.contacts.indexOf(contactToRemove);
	 *       $scope.contacts.splice(index, 1);
	 *     };
	 *
	 *     $scope.clearContact = function(contact) {
	 *       contact.type = 'phone';
	 *       contact.value = '';
	 *     };
	 *   }
	 *  </file>
	 *  <file name="protractor.js" type="protractor">
	 *    it('should check controller', function() {
	 *      var container = element(by.id('ctrl-exmpl'));
	 *
	 *      expect(container.element(by.model('name'))
	 *          .getAttribute('value')).toBe('John Smith');
	 *
	 *      var firstRepeat =
	 *          container.element(by.repeater('contact in contacts').row(0));
	 *      var secondRepeat =
	 *          container.element(by.repeater('contact in contacts').row(1));
	 *
	 *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *          .toBe('408 555 1212');
	 *      expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *          .toBe('john.smith@example.org');
	 *
	 *      firstRepeat.element(by.buttonText('clear')).click();
	 *
	 *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *          .toBe('');
	 *
	 *      container.element(by.buttonText('add')).click();
	 *
	 *      expect(container.element(by.repeater('contact in contacts').row(2))
	 *          .element(by.model('contact.value'))
	 *          .getAttribute('value'))
	 *          .toBe('yourname@example.org');
	 *    });
	 *  </file>
	 *</example>
	
	 */
	var ngControllerDirective = [function() {
	  return {
	    restrict: 'A',
	    scope: true,
	    controller: '@',
	    priority: 500
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngCsp
	 *
	 * @restrict A
	 * @element ANY
	 * @description
	 *
	 * AngularJS has some features that can conflict with certain restrictions that are applied when using
	 * [CSP (Content Security Policy)](https://developer.mozilla.org/en/Security/CSP) rules.
	 *
	 * If you intend to implement CSP with these rules then you must tell AngularJS not to use these
	 * features.
	 *
	 * This is necessary when developing things like Google Chrome Extensions or Universal Windows Apps.
	 *
	 *
	 * The following default rules in CSP affect AngularJS:
	 *
	 * * The use of `eval()`, `Function(string)` and similar functions to dynamically create and execute
	 * code from strings is forbidden. AngularJS makes use of this in the {@link $parse} service to
	 * provide a 30% increase in the speed of evaluating AngularJS expressions. (This CSP rule can be
	 * disabled with the CSP keyword `unsafe-eval`, but it is generally not recommended as it would
	 * weaken the protections offered by CSP.)
	 *
	 * * The use of inline resources, such as inline `<script>` and `<style>` elements, are forbidden.
	 * This prevents apps from injecting custom styles directly into the document. AngularJS makes use of
	 * this to include some CSS rules (e.g. {@link ngCloak} and {@link ngHide}). To make these
	 * directives work when a CSP rule is blocking inline styles, you must link to the `angular-csp.css`
	 * in your HTML manually. (This CSP rule can be disabled with the CSP keyword `unsafe-inline`, but
	 * it is generally not recommended as it would weaken the protections offered by CSP.)
	 *
	 * If you do not provide `ngCsp` then AngularJS tries to autodetect if CSP is blocking dynamic code
	 * creation from strings (e.g., `unsafe-eval` not specified in CSP header) and automatically
	 * deactivates this feature in the {@link $parse} service. This autodetection, however, triggers a
	 * CSP error to be logged in the console:
	 *
	 * ```
	 * Refused to evaluate a string as JavaScript because 'unsafe-eval' is not an allowed source of
	 * script in the following Content Security Policy directive: "default-src 'self'". Note that
	 * 'script-src' was not explicitly set, so 'default-src' is used as a fallback.
	 * ```
	 *
	 * This error is harmless but annoying. To prevent the error from showing up, put the `ngCsp`
	 * directive on an element of the HTML document that appears before the `<script>` tag that loads
	 * the `angular.js` file.
	 *
	 * *Note: This directive is only available in the `ng-csp` and `data-ng-csp` attribute form.*
	 *
	 * You can specify which of the CSP related AngularJS features should be deactivated by providing
	 * a value for the `ng-csp` attribute. The options are as follows:
	 *
	 * * no-inline-style: this stops AngularJS from injecting CSS styles into the DOM
	 *
	 * * no-unsafe-eval: this stops AngularJS from optimizing $parse with unsafe eval of strings
	 *
	 * You can use these values in the following combinations:
	 *
	 *
	 * * No declaration means that AngularJS will assume that you can do inline styles, but it will do
	 * a runtime check for unsafe-eval. E.g. `<body>`. This is backwardly compatible with previous
	 * versions of AngularJS.
	 *
	 * * A simple `ng-csp` (or `data-ng-csp`) attribute will tell AngularJS to deactivate both inline
	 * styles and unsafe eval. E.g. `<body ng-csp>`. This is backwardly compatible with previous
	 * versions of AngularJS.
	 *
	 * * Specifying only `no-unsafe-eval` tells AngularJS that we must not use eval, but that we can
	 * inject inline styles. E.g. `<body ng-csp="no-unsafe-eval">`.
	 *
	 * * Specifying only `no-inline-style` tells AngularJS that we must not inject styles, but that we can
	 * run eval - no automatic check for unsafe eval will occur. E.g. `<body ng-csp="no-inline-style">`
	 *
	 * * Specifying both `no-unsafe-eval` and `no-inline-style` tells AngularJS that we must not inject
	 * styles nor use eval, which is the same as an empty: ng-csp.
	 * E.g.`<body ng-csp="no-inline-style;no-unsafe-eval">`
	 *
	 * @example
	 *
	 * This example shows how to apply the `ngCsp` directive to the `html` tag.
	   ```html
	     <!doctype html>
	     <html ng-app ng-csp>
	     ...
	     ...
	     </html>
	   ```
	
	  <!-- Note: the `.csp` suffix in the example name triggers CSP mode in our http server! -->
	  <example name="example.csp" module="cspExample" ng-csp="true">
	    <file name="index.html">
	      <div ng-controller="MainController as ctrl">
	        <div>
	          <button ng-click="ctrl.inc()" id="inc">Increment</button>
	          <span id="counter">
	            {{ctrl.counter}}
	          </span>
	        </div>
	
	        <div>
	          <button ng-click="ctrl.evil()" id="evil">Evil</button>
	          <span id="evilError">
	            {{ctrl.evilError}}
	          </span>
	        </div>
	      </div>
	    </file>
	    <file name="script.js">
	       angular.module('cspExample', [])
	         .controller('MainController', function MainController() {
	            this.counter = 0;
	            this.inc = function() {
	              this.counter++;
	            };
	            this.evil = function() {
	              try {
	                eval('1+2'); // eslint-disable-line no-eval
	              } catch (e) {
	                this.evilError = e.message;
	              }
	            };
	          });
	    </file>
	    <file name="protractor.js" type="protractor">
	      var util, webdriver;
	
	      var incBtn = element(by.id('inc'));
	      var counter = element(by.id('counter'));
	      var evilBtn = element(by.id('evil'));
	      var evilError = element(by.id('evilError'));
	
	      function getAndClearSevereErrors() {
	        return browser.manage().logs().get('browser').then(function(browserLog) {
	          return browserLog.filter(function(logEntry) {
	            return logEntry.level.value > webdriver.logging.Level.WARNING.value;
	          });
	        });
	      }
	
	      function clearErrors() {
	        getAndClearSevereErrors();
	      }
	
	      function expectNoErrors() {
	        getAndClearSevereErrors().then(function(filteredLog) {
	          expect(filteredLog.length).toEqual(0);
	          if (filteredLog.length) {
	            console.log('browser console errors: ' + util.inspect(filteredLog));
	          }
	        });
	      }
	
	      function expectError(regex) {
	        getAndClearSevereErrors().then(function(filteredLog) {
	          var found = false;
	          filteredLog.forEach(function(log) {
	            if (log.message.match(regex)) {
	              found = true;
	            }
	          });
	          if (!found) {
	            throw new Error('expected an error that matches ' + regex);
	          }
	        });
	      }
	
	      beforeEach(function() {
	        util = require('util');
	        webdriver = require('selenium-webdriver');
	      });
	
	      // For now, we only test on Chrome,
	      // as Safari does not load the page with Protractor's injected scripts,
	      // and Firefox webdriver always disables content security policy (#6358)
	      if (browser.params.browser !== 'chrome') {
	        return;
	      }
	
	      it('should not report errors when the page is loaded', function() {
	        // clear errors so we are not dependent on previous tests
	        clearErrors();
	        // Need to reload the page as the page is already loaded when
	        // we come here
	        browser.driver.getCurrentUrl().then(function(url) {
	          browser.get(url);
	        });
	        expectNoErrors();
	      });
	
	      it('should evaluate expressions', function() {
	        expect(counter.getText()).toEqual('0');
	        incBtn.click();
	        expect(counter.getText()).toEqual('1');
	        expectNoErrors();
	      });
	
	      it('should throw and report an error when using "eval"', function() {
	        evilBtn.click();
	        expect(evilError.getText()).toMatch(/Content Security Policy/);
	        expectError(/Content Security Policy/);
	      });
	    </file>
	  </example>
	  */
	
	// `ngCsp` is not implemented as a proper directive any more, because we need it be processed while
	// we bootstrap the app (before `$parse` is instantiated). For this reason, we just have the `csp()`
	// fn that looks for the `ng-csp` attribute anywhere in the current doc.
	
	/**
	 * @ngdoc directive
	 * @name ngClick
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * The ngClick directive allows you to specify custom behavior when
	 * an element is clicked.
	 *
	 * @param {expression} ngClick {@link guide/expression Expression} to evaluate upon
	 * click. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-click">
	     <file name="index.html">
	      <button ng-click="count = count + 1" ng-init="count=0">
	        Increment
	      </button>
	      <span>
	        count: {{count}}
	      </span>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-click', function() {
	         expect(element(by.binding('count')).getText()).toMatch('0');
	         element(by.css('button')).click();
	         expect(element(by.binding('count')).getText()).toMatch('1');
	       });
	     </file>
	   </example>
	 */
	/*
	 * A collection of directives that allows creation of custom event handlers that are defined as
	 * AngularJS expressions and are compiled and executed within the current scope.
	 */
	var ngEventDirectives = {};
	
	// For events that might fire synchronously during DOM manipulation
	// we need to execute their event handlers asynchronously using $evalAsync,
	// so that they are not executed in an inconsistent state.
	var forceAsyncEvents = {
	  'blur': true,
	  'focus': true
	};
	forEach(
	  'click dblclick mousedown mouseup mouseover mouseout mousemove mouseenter mouseleave keydown keyup keypress submit focus blur copy cut paste'.split(' '),
	  function(eventName) {
	    var directiveName = directiveNormalize('ng-' + eventName);
	    ngEventDirectives[directiveName] = ['$parse', '$rootScope', '$exceptionHandler', function($parse, $rootScope, $exceptionHandler) {
	      return createEventDirective($parse, $rootScope, $exceptionHandler, directiveName, eventName, forceAsyncEvents[eventName]);
	    }];
	  }
	);
	
	function createEventDirective($parse, $rootScope, $exceptionHandler, directiveName, eventName, forceAsync) {
	  return {
	    restrict: 'A',
	    compile: function($element, attr) {
	      // NOTE:
	      // We expose the powerful `$event` object on the scope that provides access to the Window,
	      // etc. This is OK, because expressions are not sandboxed any more (and the expression
	      // sandbox was never meant to be a security feature anyway).
	      var fn = $parse(attr[directiveName]);
	      return function ngEventHandler(scope, element) {
	        element.on(eventName, function(event) {
	          var callback = function() {
	            fn(scope, {$event: event});
	          };
	
	          if (!$rootScope.$$phase) {
	            scope.$apply(callback);
	          } else if (forceAsync) {
	            scope.$evalAsync(callback);
	          } else {
	            try {
	              callback();
	            } catch (error) {
	              $exceptionHandler(error);
	            }
	          }
	        });
	      };
	    }
	  };
	}
	
	/**
	 * @ngdoc directive
	 * @name ngDblclick
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * The `ngDblclick` directive allows you to specify custom behavior on a dblclick event.
	 *
	 * @param {expression} ngDblclick {@link guide/expression Expression} to evaluate upon
	 * a dblclick. (The Event object is available as `$event`)
	 *
	 * @example
	   <example name="ng-dblclick">
	     <file name="index.html">
	      <button ng-dblclick="count = count + 1" ng-init="count=0">
	        Increment (on double click)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMousedown
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * The ngMousedown directive allows you to specify custom behavior on mousedown event.
	 *
	 * @param {expression} ngMousedown {@link guide/expression Expression} to evaluate upon
	 * mousedown. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mousedown">
	     <file name="index.html">
	      <button ng-mousedown="count = count + 1" ng-init="count=0">
	        Increment (on mouse down)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMouseup
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on mouseup event.
	 *
	 * @param {expression} ngMouseup {@link guide/expression Expression} to evaluate upon
	 * mouseup. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mouseup">
	     <file name="index.html">
	      <button ng-mouseup="count = count + 1" ng-init="count=0">
	        Increment (on mouse up)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngMouseover
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on mouseover event.
	 *
	 * @param {expression} ngMouseover {@link guide/expression Expression} to evaluate upon
	 * mouseover. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mouseover">
	     <file name="index.html">
	      <button ng-mouseover="count = count + 1" ng-init="count=0">
	        Increment (when mouse is over)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMouseenter
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on mouseenter event.
	 *
	 * @param {expression} ngMouseenter {@link guide/expression Expression} to evaluate upon
	 * mouseenter. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mouseenter">
	     <file name="index.html">
	      <button ng-mouseenter="count = count + 1" ng-init="count=0">
	        Increment (when mouse enters)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMouseleave
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on mouseleave event.
	 *
	 * @param {expression} ngMouseleave {@link guide/expression Expression} to evaluate upon
	 * mouseleave. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mouseleave">
	     <file name="index.html">
	      <button ng-mouseleave="count = count + 1" ng-init="count=0">
	        Increment (when mouse leaves)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMousemove
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on mousemove event.
	 *
	 * @param {expression} ngMousemove {@link guide/expression Expression} to evaluate upon
	 * mousemove. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mousemove">
	     <file name="index.html">
	      <button ng-mousemove="count = count + 1" ng-init="count=0">
	        Increment (when mouse moves)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngKeydown
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on keydown event.
	 *
	 * @param {expression} ngKeydown {@link guide/expression Expression} to evaluate upon
	 * keydown. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
	 *
	 * @example
	   <example name="ng-keydown">
	     <file name="index.html">
	      <input ng-keydown="count = count + 1" ng-init="count=0">
	      key down count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngKeyup
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on keyup event.
	 *
	 * @param {expression} ngKeyup {@link guide/expression Expression} to evaluate upon
	 * keyup. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
	 *
	 * @example
	   <example name="ng-keyup">
	     <file name="index.html">
	       <p>Typing in the input box below updates the key count</p>
	       <input ng-keyup="count = count + 1" ng-init="count=0"> key up count: {{count}}
	
	       <p>Typing in the input box below updates the keycode</p>
	       <input ng-keyup="event=$event">
	       <p>event keyCode: {{ event.keyCode }}</p>
	       <p>event altKey: {{ event.altKey }}</p>
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngKeypress
	 * @restrict A
	 * @element ANY
	 *
	 * @description
	 * Specify custom behavior on keypress event.
	 *
	 * @param {expression} ngKeypress {@link guide/expression Expression} to evaluate upon
	 * keypress. ({@link guide/expression#-event- Event object is available as `$event`}
	 * and can be interrogated for keyCode, altKey, etc.)
	 *
	 * @example
	   <example name="ng-keypress">
	     <file name="index.html">
	      <input ng-keypress="count = count + 1" ng-init="count=0">
	      key press count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngSubmit
	 * @restrict A
	 * @element form
	 * @priority 0
	 *
	 * @description
	 * Enables binding AngularJS expressions to onsubmit events.
	 *
	 * Additionally it prevents the default action (which for form means sending the request to the
	 * server and reloading the current page), but only if the form does not contain `action`,
	 * `data-action`, or `x-action` attributes.
	 *
	 * <div class="alert alert-warning">
	 * **Warning:** Be careful not to cause "double-submission" by using both the `ngClick` and
	 * `ngSubmit` handlers together. See the
	 * {@link form#submitting-a-form-and-preventing-the-default-action `form` directive documentation}
	 * for a detailed discussion of when `ngSubmit` may be triggered.
	 * </div>
	 *
	 * @param {expression} ngSubmit {@link guide/expression Expression} to eval.
	 * ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example module="submitExample" name="ng-submit">
	     <file name="index.html">
	      <script>
	        angular.module('submitExample', [])
	          .controller('ExampleController', ['$scope', function($scope) {
	            $scope.list = [];
	            $scope.text = 'hello';
	            $scope.submit = function() {
	              if ($scope.text) {
	                $scope.list.push(this.text);
	                $scope.text = '';
	              }
	            };
	          }]);
	      </script>
	      <form ng-submit="submit()" ng-controller="ExampleController">
	        Enter text and hit enter:
	        <input type="text" ng-model="text" name="text" />
	        <input type="submit" id="submit" value="Submit" />
	        <pre>list={{list}}</pre>
	      </form>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-submit', function() {
	         expect(element(by.binding('list')).getText()).toBe('list=[]');
	         element(by.css('#submit')).click();
	         expect(element(by.binding('list')).getText()).toContain('hello');
	         expect(element(by.model('text')).getAttribute('value')).toBe('');
	       });
	       it('should ignore empty strings', function() {
	         expect(element(by.binding('list')).getText()).toBe('list=[]');
	         element(by.css('#submit')).click();
	         element(by.css('#submit')).click();
	         expect(element(by.binding('list')).getText()).toContain('hello');
	        });
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngFocus
	 * @restrict A
	 * @element window, input, select, textarea, a
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on focus event.
	 *
	 * Note: As the `focus` event is executed synchronously when calling `input.focus()`
	 * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
	 * during an `$apply` to ensure a consistent state.
	 *
	 * @param {expression} ngFocus {@link guide/expression Expression} to evaluate upon
	 * focus. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	 * See {@link ng.directive:ngClick ngClick}
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngBlur
	 * @restrict A
	 * @element window, input, select, textarea, a
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on blur event.
	 *
	 * A [blur event](https://developer.mozilla.org/en-US/docs/Web/Events/blur) fires when
	 * an element has lost focus.
	 *
	 * Note: As the `blur` event is executed synchronously also during DOM manipulations
	 * (e.g. removing a focussed input),
	 * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
	 * during an `$apply` to ensure a consistent state.
	 *
	 * @param {expression} ngBlur {@link guide/expression Expression} to evaluate upon
	 * blur. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	 * See {@link ng.directive:ngClick ngClick}
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngCopy
	 * @restrict A
	 * @element window, input, select, textarea, a
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on copy event.
	 *
	 * @param {expression} ngCopy {@link guide/expression Expression} to evaluate upon
	 * copy. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-copy">
	     <file name="index.html">
	      <input ng-copy="copied=true" ng-init="copied=false; value='copy me'" ng-model="value">
	      copied: {{copied}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngCut
	 * @restrict A
	 * @element window, input, select, textarea, a
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on cut event.
	 *
	 * @param {expression} ngCut {@link guide/expression Expression} to evaluate upon
	 * cut. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-cut">
	     <file name="index.html">
	      <input ng-cut="cut=true" ng-init="cut=false; value='cut me'" ng-model="value">
	      cut: {{cut}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngPaste
	 * @restrict A
	 * @element window, input, select, textarea, a
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on paste event.
	 *
	 * @param {expression} ngPaste {@link guide/expression Expression} to evaluate upon
	 * paste. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-paste">
	     <file name="index.html">
	      <input ng-paste="paste=true" ng-init="paste=false" placeholder='paste here'>
	      pasted: {{paste}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngIf
	 * @restrict A
	 * @multiElement
	 *
	 * @description
	 * The `ngIf` directive removes or recreates a portion of the DOM tree based on an
	 * {expression}. If the expression assigned to `ngIf` evaluates to a false
	 * value then the element is removed from the DOM, otherwise a clone of the
	 * element is reinserted into the DOM.
	 *
	 * `ngIf` differs from `ngShow` and `ngHide` in that `ngIf` completely removes and recreates the
	 * element in the DOM rather than changing its visibility via the `display` css property.  A common
	 * case when this difference is significant is when using css selectors that rely on an element's
	 * position within the DOM, such as the `:first-child` or `:last-child` pseudo-classes.
	 *
	 * Note that when an element is removed using `ngIf` its scope is destroyed and a new scope
	 * is created when the element is restored.  The scope created within `ngIf` inherits from
	 * its parent scope using
	 * [prototypal inheritance](https://github.com/angular/angular.js/wiki/Understanding-Scopes#javascript-prototypal-inheritance).
	 * An important implication of this is if `ngModel` is used within `ngIf` to bind to
	 * a javascript primitive defined in the parent scope. In this case any modifications made to the
	 * variable within the child scope will override (hide) the value in the parent scope.
	 *
	 * Also, `ngIf` recreates elements using their compiled state. An example of this behavior
	 * is if an element's class attribute is directly modified after it's compiled, using something like
	 * jQuery's `.addClass()` method, and the element is later removed. When `ngIf` recreates the element
	 * the added class will be lost because the original compiled state is used to regenerate the element.
	 *
	 * Additionally, you can provide animations via the `ngAnimate` module to animate the `enter`
	 * and `leave` effects.
	 *
	 * @animations
	 * | Animation                        | Occurs                               |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter}  | just after the `ngIf` contents change and a new DOM element is created and injected into the `ngIf` container |
	 * | {@link ng.$animate#leave leave}  | just before the `ngIf` contents are removed from the DOM |
	 *
	 * @element ANY
	 * @scope
	 * @priority 600
	 * @param {expression} ngIf If the {@link guide/expression expression} is falsy then
	 *     the element is removed from the DOM tree. If it is truthy a copy of the compiled
	 *     element is added to the DOM tree.
	 *
	 * @example
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-if">
	    <file name="index.html">
	      <label>Click me: <input type="checkbox" ng-model="checked" ng-init="checked=true" /></label><br/>
	      Show when checked:
	      <span ng-if="checked" class="animate-if">
	        This is removed when the checkbox is unchecked.
	      </span>
	    </file>
	    <file name="animations.css">
	      .animate-if {
	        background:white;
	        border:1px solid black;
	        padding:10px;
	      }
	
	      .animate-if.ng-enter, .animate-if.ng-leave {
	        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	      }
	
	      .animate-if.ng-enter,
	      .animate-if.ng-leave.ng-leave-active {
	        opacity:0;
	      }
	
	      .animate-if.ng-leave,
	      .animate-if.ng-enter.ng-enter-active {
	        opacity:1;
	      }
	    </file>
	  </example>
	 */
	var ngIfDirective = ['$animate', '$compile', function($animate, $compile) {
	  return {
	    multiElement: true,
	    transclude: 'element',
	    priority: 600,
	    terminal: true,
	    restrict: 'A',
	    $$tlb: true,
	    link: function($scope, $element, $attr, ctrl, $transclude) {
	        var block, childScope, previousElements;
	        $scope.$watch($attr.ngIf, function ngIfWatchAction(value) {
	
	          if (value) {
	            if (!childScope) {
	              $transclude(function(clone, newScope) {
	                childScope = newScope;
	                clone[clone.length++] = $compile.$$createComment('end ngIf', $attr.ngIf);
	                // Note: We only need the first/last node of the cloned nodes.
	                // However, we need to keep the reference to the jqlite wrapper as it might be changed later
	                // by a directive with templateUrl when its template arrives.
	                block = {
	                  clone: clone
	                };
	                $animate.enter(clone, $element.parent(), $element);
	              });
	            }
	          } else {
	            if (previousElements) {
	              previousElements.remove();
	              previousElements = null;
	            }
	            if (childScope) {
	              childScope.$destroy();
	              childScope = null;
	            }
	            if (block) {
	              previousElements = getBlockNodes(block.clone);
	              $animate.leave(previousElements).done(function(response) {
	                if (response !== false) previousElements = null;
	              });
	              block = null;
	            }
	          }
	        });
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngInclude
	 * @restrict ECA
	 * @scope
	 * @priority -400
	 *
	 * @description
	 * Fetches, compiles and includes an external HTML fragment.
	 *
	 * By default, the template URL is restricted to the same domain and protocol as the
	 * application document. This is done by calling {@link $sce#getTrustedResourceUrl
	 * $sce.getTrustedResourceUrl} on it. To load templates from other domains or protocols
	 * you may either add them to your {@link ng.$sceDelegateProvider#trustedResourceUrlList trusted
	 * resource URL list} or {@link $sce#trustAsResourceUrl wrap them} as trusted values. Refer to
	 * AngularJS's {@link ng.$sce Strict Contextual Escaping}.
	 *
	 * In addition, the browser's
	 * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
	 * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
	 * policy may further restrict whether the template is successfully loaded.
	 * For example, `ngInclude` won't work for cross-domain requests on all browsers and for `file://`
	 * access on some browsers.
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter}  | when the expression changes, on the new include |
	 * | {@link ng.$animate#leave leave}  | when the expression changes, on the old include |
	 *
	 * The enter and leave animation occur concurrently.
	 *
	 * @param {string} ngInclude|src AngularJS expression evaluating to URL. If the source is a string constant,
	 *                 make sure you wrap it in **single** quotes, e.g. `src="'myPartialTemplate.html'"`.
	 * @param {string=} onload Expression to evaluate when a new partial is loaded.
	 *                  <div class="alert alert-warning">
	 *                  **Note:** When using onload on SVG elements in IE11, the browser will try to call
	 *                  a function with the name on the window element, which will usually throw a
	 *                  "function is undefined" error. To fix this, you can instead use `data-onload` or a
	 *                  different form that {@link guide/directive#normalization matches} `onload`.
	 *                  </div>
	   *
	 * @param {string=} autoscroll Whether `ngInclude` should call {@link ng.$anchorScroll
	 *                  $anchorScroll} to scroll the viewport after the content is loaded.
	 *
	 *                  - If the attribute is not set, disable scrolling.
	 *                  - If the attribute is set without value, enable scrolling.
	 *                  - Otherwise enable scrolling only if the expression evaluates to truthy value.
	 *
	 * @example
	  <example module="includeExample" deps="angular-animate.js" animations="true" name="ng-include">
	    <file name="index.html">
	     <div ng-controller="ExampleController">
	       <select ng-model="template" ng-options="t.name for t in templates">
	        <option value="">(blank)</option>
	       </select>
	       url of the template: <code>{{template.url}}</code>
	       <hr/>
	       <div class="slide-animate-container">
	         <div class="slide-animate" ng-include="template.url"></div>
	       </div>
	     </div>
	    </file>
	    <file name="script.js">
	      angular.module('includeExample', ['ngAnimate'])
	        .controller('ExampleController', ['$scope', function($scope) {
	          $scope.templates =
	            [{ name: 'template1.html', url: 'template1.html'},
	             { name: 'template2.html', url: 'template2.html'}];
	          $scope.template = $scope.templates[0];
	        }]);
	     </file>
	    <file name="template1.html">
	      Content of template1.html
	    </file>
	    <file name="template2.html">
	      Content of template2.html
	    </file>
	    <file name="animations.css">
	      .slide-animate-container {
	        position:relative;
	        background:white;
	        border:1px solid black;
	        height:40px;
	        overflow:hidden;
	      }
	
	      .slide-animate {
	        padding:10px;
	      }
	
	      .slide-animate.ng-enter, .slide-animate.ng-leave {
	        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	
	        position:absolute;
	        top:0;
	        left:0;
	        right:0;
	        bottom:0;
	        display:block;
	        padding:10px;
	      }
	
	      .slide-animate.ng-enter {
	        top:-50px;
	      }
	      .slide-animate.ng-enter.ng-enter-active {
	        top:0;
	      }
	
	      .slide-animate.ng-leave {
	        top:0;
	      }
	      .slide-animate.ng-leave.ng-leave-active {
	        top:50px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var templateSelect = element(by.model('template'));
	      var includeElem = element(by.css('[ng-include]'));
	
	      it('should load template1.html', function() {
	        expect(includeElem.getText()).toMatch(/Content of template1.html/);
	      });
	
	      it('should load template2.html', function() {
	        if (browser.params.browser === 'firefox') {
	          // Firefox can't handle using selects
	          // See https://github.com/angular/protractor/issues/480
	          return;
	        }
	        templateSelect.click();
	        templateSelect.all(by.css('option')).get(2).click();
	        expect(includeElem.getText()).toMatch(/Content of template2.html/);
	      });
	
	      it('should change to blank', function() {
	        if (browser.params.browser === 'firefox') {
	          // Firefox can't handle using selects
	          return;
	        }
	        templateSelect.click();
	        templateSelect.all(by.css('option')).get(0).click();
	        expect(includeElem.isPresent()).toBe(false);
	      });
	    </file>
	  </example>
	 */
	
	
	/**
	 * @ngdoc event
	 * @name ngInclude#$includeContentRequested
	 * @eventType emit on the scope ngInclude was declared in
	 * @description
	 * Emitted every time the ngInclude content is requested.
	 *
	 * @param {Object} angularEvent Synthetic event object.
	 * @param {String} src URL of content to load.
	 */
	
	
	/**
	 * @ngdoc event
	 * @name ngInclude#$includeContentLoaded
	 * @eventType emit on the current ngInclude scope
	 * @description
	 * Emitted every time the ngInclude content is reloaded.
	 *
	 * @param {Object} angularEvent Synthetic event object.
	 * @param {String} src URL of content to load.
	 */
	
	
	/**
	 * @ngdoc event
	 * @name ngInclude#$includeContentError
	 * @eventType emit on the scope ngInclude was declared in
	 * @description
	 * Emitted when a template HTTP request yields an erroneous response (status < 200 || status > 299)
	 *
	 * @param {Object} angularEvent Synthetic event object.
	 * @param {String} src URL of content to load.
	 */
	var ngIncludeDirective = ['$templateRequest', '$anchorScroll', '$animate',
	                  function($templateRequest,   $anchorScroll,   $animate) {
	  return {
	    restrict: 'ECA',
	    priority: 400,
	    terminal: true,
	    transclude: 'element',
	    controller: angular.noop,
	    compile: function(element, attr) {
	      var srcExp = attr.ngInclude || attr.src,
	          onloadExp = attr.onload || '',
	          autoScrollExp = attr.autoscroll;
	
	      return function(scope, $element, $attr, ctrl, $transclude) {
	        var changeCounter = 0,
	            currentScope,
	            previousElement,
	            currentElement;
	
	        var cleanupLastIncludeContent = function() {
	          if (previousElement) {
	            previousElement.remove();
	            previousElement = null;
	          }
	          if (currentScope) {
	            currentScope.$destroy();
	            currentScope = null;
	          }
	          if (currentElement) {
	            $animate.leave(currentElement).done(function(response) {
	              if (response !== false) previousElement = null;
	            });
	            previousElement = currentElement;
	            currentElement = null;
	          }
	        };
	
	        scope.$watch(srcExp, function ngIncludeWatchAction(src) {
	          var afterAnimation = function(response) {
	            if (response !== false && isDefined(autoScrollExp) &&
	              (!autoScrollExp || scope.$eval(autoScrollExp))) {
	                $anchorScroll();
	            }
	          };
	          var thisChangeId = ++changeCounter;
	
	          if (src) {
	            //set the 2nd param to true to ignore the template request error so that the inner
	            //contents and scope can be cleaned up.
	            $templateRequest(src, true).then(function(response) {
	              if (scope.$$destroyed) return;
	
	              if (thisChangeId !== changeCounter) return;
	              var newScope = scope.$new();
	              ctrl.template = response;
	
	              // Note: This will also link all children of ng-include that were contained in the original
	              // html. If that content contains controllers, ... they could pollute/change the scope.
	              // However, using ng-include on an element with additional content does not make sense...
	              // Note: We can't remove them in the cloneAttchFn of $transclude as that
	              // function is called before linking the content, which would apply child
	              // directives to non existing elements.
	              var clone = $transclude(newScope, function(clone) {
	                cleanupLastIncludeContent();
	                $animate.enter(clone, null, $element).done(afterAnimation);
	              });
	
	              currentScope = newScope;
	              currentElement = clone;
	
	              currentScope.$emit('$includeContentLoaded', src);
	              scope.$eval(onloadExp);
	            }, function() {
	              if (scope.$$destroyed) return;
	
	              if (thisChangeId === changeCounter) {
	                cleanupLastIncludeContent();
	                scope.$emit('$includeContentError', src);
	              }
	            });
	            scope.$emit('$includeContentRequested', src);
	          } else {
	            cleanupLastIncludeContent();
	            ctrl.template = null;
	          }
	        });
	      };
	    }
	  };
	}];
	
	// This directive is called during the $transclude call of the first `ngInclude` directive.
	// It will replace and compile the content of the element with the loaded template.
	// We need this directive so that the element content is already filled when
	// the link function of another directive on the same element as ngInclude
	// is called.
	var ngIncludeFillContentDirective = ['$compile',
	  function($compile) {
	    return {
	      restrict: 'ECA',
	      priority: -400,
	      require: 'ngInclude',
	      link: function(scope, $element, $attr, ctrl) {
	        if (toString.call($element[0]).match(/SVG/)) {
	          // WebKit: https://bugs.webkit.org/show_bug.cgi?id=135698 --- SVG elements do not
	          // support innerHTML, so detect this here and try to generate the contents
	          // specially.
	          $element.empty();
	          $compile(jqLiteBuildFragment(ctrl.template, window.document).childNodes)(scope,
	              function namespaceAdaptedClone(clone) {
	            $element.append(clone);
	          }, {futureParentElement: $element});
	          return;
	        }
	
	        $element.html(ctrl.template);
	        $compile($element.contents())(scope);
	      }
	    };
	  }];
	
	/**
	 * @ngdoc directive
	 * @name ngInit
	 * @restrict AC
	 * @priority 450
	 * @element ANY
	 *
	 * @param {expression} ngInit {@link guide/expression Expression} to eval.
	 *
	 * @description
	 * The `ngInit` directive allows you to evaluate an expression in the
	 * current scope.
	 *
	 * <div class="alert alert-danger">
	 * This directive can be abused to add unnecessary amounts of logic into your templates.
	 * There are only a few appropriate uses of `ngInit`:
	 * <ul>
	 *   <li>aliasing special properties of {@link ng.directive:ngRepeat `ngRepeat`},
	 *     as seen in the demo below.</li>
	 *   <li>initializing data during development, or for examples, as seen throughout these docs.</li>
	 *   <li>injecting data via server side scripting.</li>
	 * </ul>
	 *
	 * Besides these few cases, you should use {@link guide/component Components} or
	 * {@link guide/controller Controllers} rather than `ngInit` to initialize values on a scope.
	 * </div>
	 *
	 * <div class="alert alert-warning">
	 * **Note**: If you have assignment in `ngInit` along with a {@link ng.$filter `filter`}, make
	 * sure you have parentheses to ensure correct operator precedence:
	 * <pre class="prettyprint">
	 * `<div ng-init="test1 = ($index | toString)"></div>`
	 * </pre>
	 * </div>
	 *
	 * @example
	   <example module="initExample" name="ng-init">
	     <file name="index.html">
	   <script>
	     angular.module('initExample', [])
	       .controller('ExampleController', ['$scope', function($scope) {
	         $scope.list = [['a', 'b'], ['c', 'd']];
	       }]);
	   </script>
	   <div ng-controller="ExampleController">
	     <div ng-repeat="innerList in list" ng-init="outerIndex = $index">
	       <div ng-repeat="value in innerList" ng-init="innerIndex = $index">
	          <span class="example-init">list[ {{outerIndex}} ][ {{innerIndex}} ] = {{value}};</span>
	       </div>
	     </div>
	   </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should alias index positions', function() {
	         var elements = element.all(by.css('.example-init'));
	         expect(elements.get(0).getText()).toBe('list[ 0 ][ 0 ] = a;');
	         expect(elements.get(1).getText()).toBe('list[ 0 ][ 1 ] = b;');
	         expect(elements.get(2).getText()).toBe('list[ 1 ][ 0 ] = c;');
	         expect(elements.get(3).getText()).toBe('list[ 1 ][ 1 ] = d;');
	       });
	     </file>
	   </example>
	 */
	var ngInitDirective = ngDirective({
	  priority: 450,
	  compile: function() {
	    return {
	      pre: function(scope, element, attrs) {
	        scope.$eval(attrs.ngInit);
	      }
	    };
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngList
	 * @restrict A
	 * @priority 100
	 *
	 * @param {string=} ngList optional delimiter that should be used to split the value.
	 *
	 * @description
	 * Text input that converts between a delimited string and an array of strings. The default
	 * delimiter is a comma followed by a space - equivalent to `ng-list=", "`. You can specify a custom
	 * delimiter as the value of the `ngList` attribute - for example, `ng-list=" | "`.
	 *
	 * The behaviour of the directive is affected by the use of the `ngTrim` attribute.
	 * * If `ngTrim` is set to `"false"` then whitespace around both the separator and each
	 *   list item is respected. This implies that the user of the directive is responsible for
	 *   dealing with whitespace but also allows you to use whitespace as a delimiter, such as a
	 *   tab or newline character.
	 * * Otherwise whitespace around the delimiter is ignored when splitting (although it is respected
	 *   when joining the list items back together) and whitespace around each list item is stripped
	 *   before it is added to the model.
	 *
	 * @example
	 * ### Validation
	 *
	 * <example name="ngList-directive" module="listExample">
	 *   <file name="app.js">
	 *      angular.module('listExample', [])
	 *        .controller('ExampleController', ['$scope', function($scope) {
	 *          $scope.names = ['morpheus', 'neo', 'trinity'];
	 *        }]);
	 *   </file>
	 *   <file name="index.html">
	 *    <form name="myForm" ng-controller="ExampleController">
	 *      <label>List: <input name="namesInput" ng-model="names" ng-list required></label>
	 *      <span role="alert">
	 *        <span class="error" ng-show="myForm.namesInput.$error.required">
	 *        Required!</span>
	 *      </span>
	 *      <br>
	 *      <tt>names = {{names}}</tt><br/>
	 *      <tt>myForm.namesInput.$valid = {{myForm.namesInput.$valid}}</tt><br/>
	 *      <tt>myForm.namesInput.$error = {{myForm.namesInput.$error}}</tt><br/>
	 *      <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	 *      <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	 *     </form>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     var listInput = element(by.model('names'));
	 *     var names = element(by.exactBinding('names'));
	 *     var valid = element(by.binding('myForm.namesInput.$valid'));
	 *     var error = element(by.css('span.error'));
	 *
	 *     it('should initialize to model', function() {
	 *       expect(names.getText()).toContain('["morpheus","neo","trinity"]');
	 *       expect(valid.getText()).toContain('true');
	 *       expect(error.getCssValue('display')).toBe('none');
	 *     });
	 *
	 *     it('should be invalid if empty', function() {
	 *       listInput.clear();
	 *       listInput.sendKeys('');
	 *
	 *       expect(names.getText()).toContain('');
	 *       expect(valid.getText()).toContain('false');
	 *       expect(error.getCssValue('display')).not.toBe('none');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * @example
	 * ### Splitting on newline
	 *
	 * <example name="ngList-directive-newlines">
	 *   <file name="index.html">
	 *    <textarea ng-model="list" ng-list="&#10;" ng-trim="false"></textarea>
	 *    <pre>{{ list | json }}</pre>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     it("should split the text by newlines", function() {
	 *       var listInput = element(by.model('list'));
	 *       var output = element(by.binding('list | json'));
	 *       listInput.sendKeys('abc\ndef\nghi');
	 *       expect(output.getText()).toContain('[\n  "abc",\n  "def",\n  "ghi"\n]');
	 *     });
	 *   </file>
	 * </example>
	 *
	 */
	var ngListDirective = function() {
	  return {
	    restrict: 'A',
	    priority: 100,
	    require: 'ngModel',
	    link: function(scope, element, attr, ctrl) {
	      var ngList = attr.ngList || ', ';
	      var trimValues = attr.ngTrim !== 'false';
	      var separator = trimValues ? trim(ngList) : ngList;
	
	      var parse = function(viewValue) {
	        // If the viewValue is invalid (say required but empty) it will be `undefined`
	        if (isUndefined(viewValue)) return;
	
	        var list = [];
	
	        if (viewValue) {
	          forEach(viewValue.split(separator), function(value) {
	            if (value) list.push(trimValues ? trim(value) : value);
	          });
	        }
	
	        return list;
	      };
	
	      ctrl.$parsers.push(parse);
	      ctrl.$formatters.push(function(value) {
	        if (isArray(value)) {
	          return value.join(ngList);
	        }
	
	        return undefined;
	      });
	
	      // Override the standard $isEmpty because an empty array means the input is empty.
	      ctrl.$isEmpty = function(value) {
	        return !value || !value.length;
	      };
	    }
	  };
	};
	
	/* global VALID_CLASS: true,
	  INVALID_CLASS: true,
	  PRISTINE_CLASS: true,
	  DIRTY_CLASS: true,
	  UNTOUCHED_CLASS: true,
	  TOUCHED_CLASS: true,
	  PENDING_CLASS: true,
	  addSetValidityMethod: true,
	  setupValidity: true,
	  defaultModelOptions: false
	*/
	
	
	var VALID_CLASS = 'ng-valid',
	    INVALID_CLASS = 'ng-invalid',
	    PRISTINE_CLASS = 'ng-pristine',
	    DIRTY_CLASS = 'ng-dirty',
	    UNTOUCHED_CLASS = 'ng-untouched',
	    TOUCHED_CLASS = 'ng-touched',
	    EMPTY_CLASS = 'ng-empty',
	    NOT_EMPTY_CLASS = 'ng-not-empty';
	
	var ngModelMinErr = minErr('ngModel');
	
	/**
	 * @ngdoc type
	 * @name ngModel.NgModelController
	 * @property {*} $viewValue The actual value from the control's view. For `input` elements, this is a
	 * String. See {@link ngModel.NgModelController#$setViewValue} for information about when the $viewValue
	 * is set.
	 *
	 * @property {*} $modelValue The value in the model that the control is bound to.
	 *
	 * @property {Array.<Function>} $parsers Array of functions to execute, as a pipeline, whenever
	 *  the control updates the ngModelController with a new {@link ngModel.NgModelController#$viewValue
	    `$viewValue`} from the DOM, usually via user input.
	    See {@link ngModel.NgModelController#$setViewValue `$setViewValue()`} for a detailed lifecycle explanation.
	    Note that the `$parsers` are not called when the bound ngModel expression changes programmatically.
	
	  The functions are called in array order, each passing
	    its return value through to the next. The last return value is forwarded to the
	    {@link ngModel.NgModelController#$validators `$validators`} collection.
	
	  Parsers are used to sanitize / convert the {@link ngModel.NgModelController#$viewValue
	    `$viewValue`}.
	
	  Returning `undefined` from a parser means a parse error occurred. In that case,
	    no {@link ngModel.NgModelController#$validators `$validators`} will run and the `ngModel`
	    will be set to `undefined` unless {@link ngModelOptions `ngModelOptions.allowInvalid`}
	    is set to `true`. The parse error is stored in `ngModel.$error.parse`.
	
	  This simple example shows a parser that would convert text input value to lowercase:
	 * ```js
	 * function parse(value) {
	 *   if (value) {
	 *     return value.toLowerCase();
	 *   }
	 * }
	 * ngModelController.$parsers.push(parse);
	 * ```
	
	 *
	 * @property {Array.<Function>} $formatters Array of functions to execute, as a pipeline, whenever
	    the bound ngModel expression changes programmatically. The `$formatters` are not called when the
	    value of the control is changed by user interaction.
	
	  Formatters are used to format / convert the {@link ngModel.NgModelController#$modelValue
	    `$modelValue`} for display in the control.
	
	  The functions are called in reverse array order, each passing the value through to the
	    next. The last return value is used as the actual DOM value.
	
	  This simple example shows a formatter that would convert the model value to uppercase:
	
	 * ```js
	 * function format(value) {
	 *   if (value) {
	 *     return value.toUpperCase();
	 *   }
	 * }
	 * ngModel.$formatters.push(format);
	 * ```
	 *
	 * @property {Object.<string, function>} $validators A collection of validators that are applied
	 *      whenever the model value changes. The key value within the object refers to the name of the
	 *      validator while the function refers to the validation operation. The validation operation is
	 *      provided with the model value as an argument and must return a true or false value depending
	 *      on the response of that validation.
	 *
	 * ```js
	 * ngModel.$validators.validCharacters = function(modelValue, viewValue) {
	 *   var value = modelValue || viewValue;
	 *   return /[0-9]+/.test(value) &&
	 *          /[a-z]+/.test(value) &&
	 *          /[A-Z]+/.test(value) &&
	 *          /\W+/.test(value);
	 * };
	 * ```
	 *
	 * @property {Object.<string, function>} $asyncValidators A collection of validations that are expected to
	 *      perform an asynchronous validation (e.g. a HTTP request). The validation function that is provided
	 *      is expected to return a promise when it is run during the model validation process. Once the promise
	 *      is delivered then the validation status will be set to true when fulfilled and false when rejected.
	 *      When the asynchronous validators are triggered, each of the validators will run in parallel and the model
	 *      value will only be updated once all validators have been fulfilled. As long as an asynchronous validator
	 *      is unfulfilled, its key will be added to the controllers `$pending` property. Also, all asynchronous validators
	 *      will only run once all synchronous validators have passed.
	 *
	 * Please note that if $http is used then it is important that the server returns a success HTTP response code
	 * in order to fulfill the validation and a status level of `4xx` in order to reject the validation.
	 *
	 * ```js
	 * ngModel.$asyncValidators.uniqueUsername = function(modelValue, viewValue) {
	 *   var value = modelValue || viewValue;
	 *
	 *   // Lookup user by username
	 *   return $http.get('/api/users/' + value).
	 *      then(function resolved() {
	 *        //username exists, this means validation fails
	 *        return $q.reject('exists');
	 *      }, function rejected() {
	 *        //username does not exist, therefore this validation passes
	 *        return true;
	 *      });
	 * };
	 * ```
	 *
	 * @property {Array.<Function>} $viewChangeListeners Array of functions to execute whenever
	 *     a change to {@link ngModel.NgModelController#$viewValue `$viewValue`} has caused a change
	 *     to {@link ngModel.NgModelController#$modelValue `$modelValue`}.
	 *     It is called with no arguments, and its return value is ignored.
	 *     This can be used in place of additional $watches against the model value.
	 *
	 * @property {Object} $error An object hash with all failing validator ids as keys.
	 * @property {Object} $pending An object hash with all pending validator ids as keys.
	 *
	 * @property {boolean} $untouched True if control has not lost focus yet.
	 * @property {boolean} $touched True if control has lost focus.
	 * @property {boolean} $pristine True if user has not interacted with the control yet.
	 * @property {boolean} $dirty True if user has already interacted with the control.
	 * @property {boolean} $valid True if there is no error.
	 * @property {boolean} $invalid True if at least one error on the control.
	 * @property {string} $name The name attribute of the control.
	 *
	 * @description
	 *
	 * `NgModelController` provides API for the {@link ngModel `ngModel`} directive.
	 * The controller contains services for data-binding, validation, CSS updates, and value formatting
	 * and parsing. It purposefully does not contain any logic which deals with DOM rendering or
	 * listening to DOM events.
	 * Such DOM related logic should be provided by other directives which make use of
	 * `NgModelController` for data-binding to control elements.
	 * AngularJS provides this DOM logic for most {@link input `input`} elements.
	 * At the end of this page you can find a {@link ngModel.NgModelController#custom-control-example
	 * custom control example} that uses `ngModelController` to bind to `contenteditable` elements.
	 *
	 * @example
	 * ### Custom Control Example
	 * This example shows how to use `NgModelController` with a custom control to achieve
	 * data-binding. Notice how different directives (`contenteditable`, `ng-model`, and `required`)
	 * collaborate together to achieve the desired result.
	 *
	 * `contenteditable` is an HTML5 attribute, which tells the browser to let the element
	 * contents be edited in place by the user.
	 *
	 * We are using the {@link ng.service:$sce $sce} service here and include the {@link ngSanitize $sanitize}
	 * module to automatically remove "bad" content like inline event listener (e.g. `<span onclick="...">`).
	 * However, as we are using `$sce` the model can still decide to provide unsafe content if it marks
	 * that content using the `$sce` service.
	 *
	 * <example name="NgModelController" module="customControl" deps="angular-sanitize.js">
	    <file name="style.css">
	      [contenteditable] {
	        border: 1px solid black;
	        background-color: white;
	        min-height: 20px;
	      }
	
	      .ng-invalid {
	        border: 1px solid red;
	      }
	
	    </file>
	    <file name="script.js">
	      angular.module('customControl', ['ngSanitize']).
	        directive('contenteditable', ['$sce', function($sce) {
	          return {
	            restrict: 'A', // only activate on element attribute
	            require: '?ngModel', // get a hold of NgModelController
	            link: function(scope, element, attrs, ngModel) {
	              if (!ngModel) return; // do nothing if no ng-model
	
	              // Specify how UI should be updated
	              ngModel.$render = function() {
	                element.html($sce.getTrustedHtml(ngModel.$viewValue || ''));
	              };
	
	              // Listen for change events to enable binding
	              element.on('blur keyup change', function() {
	                scope.$evalAsync(read);
	              });
	              read(); // initialize
	
	              // Write data to the model
	              function read() {
	                var html = element.html();
	                // When we clear the content editable the browser leaves a <br> behind
	                // If strip-br attribute is provided then we strip this out
	                if (attrs.stripBr && html === '<br>') {
	                  html = '';
	                }
	                ngModel.$setViewValue(html);
	              }
	            }
	          };
	        }]);
	    </file>
	    <file name="index.html">
	      <form name="myForm">
	       <div contenteditable
	            name="myWidget" ng-model="userContent"
	            strip-br="true"
	            required>Change me!</div>
	        <span ng-show="myForm.myWidget.$error.required">Required!</span>
	       <hr>
	       <textarea ng-model="userContent" aria-label="Dynamic textarea"></textarea>
	      </form>
	    </file>
	    <file name="protractor.js" type="protractor">
	    it('should data-bind and become invalid', function() {
	      if (browser.params.browser === 'safari' || browser.params.browser === 'firefox') {
	        // SafariDriver can't handle contenteditable
	        // and Firefox driver can't clear contenteditables very well
	        return;
	      }
	      var contentEditable = element(by.css('[contenteditable]'));
	      var content = 'Change me!';
	
	      expect(contentEditable.getText()).toEqual(content);
	
	      contentEditable.clear();
	      contentEditable.sendKeys(protractor.Key.BACK_SPACE);
	      expect(contentEditable.getText()).toEqual('');
	      expect(contentEditable.getAttribute('class')).toMatch(/ng-invalid-required/);
	    });
	    </file>
	 * </example>
	 *
	 *
	 */
	NgModelController.$inject = ['$scope', '$exceptionHandler', '$attrs', '$element', '$parse', '$animate', '$timeout', '$q', '$interpolate'];
	function NgModelController($scope, $exceptionHandler, $attr, $element, $parse, $animate, $timeout, $q, $interpolate) {
	  this.$viewValue = Number.NaN;
	  this.$modelValue = Number.NaN;
	  this.$$rawModelValue = undefined; // stores the parsed modelValue / model set from scope regardless of validity.
	  this.$validators = {};
	  this.$asyncValidators = {};
	  this.$parsers = [];
	  this.$formatters = [];
	  this.$viewChangeListeners = [];
	  this.$untouched = true;
	  this.$touched = false;
	  this.$pristine = true;
	  this.$dirty = false;
	  this.$valid = true;
	  this.$invalid = false;
	  this.$error = {}; // keep invalid keys here
	  this.$$success = {}; // keep valid keys here
	  this.$pending = undefined; // keep pending keys here
	  this.$name = $interpolate($attr.name || '', false)($scope);
	  this.$$parentForm = nullFormCtrl;
	  this.$options = defaultModelOptions;
	  this.$$updateEvents = '';
	  // Attach the correct context to the event handler function for updateOn
	  this.$$updateEventHandler = this.$$updateEventHandler.bind(this);
	
	  this.$$parsedNgModel = $parse($attr.ngModel);
	  this.$$parsedNgModelAssign = this.$$parsedNgModel.assign;
	  this.$$ngModelGet = this.$$parsedNgModel;
	  this.$$ngModelSet = this.$$parsedNgModelAssign;
	  this.$$pendingDebounce = null;
	  this.$$parserValid = undefined;
	  this.$$parserName = 'parse';
	
	  this.$$currentValidationRunId = 0;
	
	  this.$$scope = $scope;
	  this.$$rootScope = $scope.$root;
	  this.$$attr = $attr;
	  this.$$element = $element;
	  this.$$animate = $animate;
	  this.$$timeout = $timeout;
	  this.$$parse = $parse;
	  this.$$q = $q;
	  this.$$exceptionHandler = $exceptionHandler;
	
	  setupValidity(this);
	  setupModelWatcher(this);
	}
	
	NgModelController.prototype = {
	  $$initGetterSetters: function() {
	    if (this.$options.getOption('getterSetter')) {
	      var invokeModelGetter = this.$$parse(this.$$attr.ngModel + '()'),
	          invokeModelSetter = this.$$parse(this.$$attr.ngModel + '($$$p)');
	
	      this.$$ngModelGet = function($scope) {
	        var modelValue = this.$$parsedNgModel($scope);
	        if (isFunction(modelValue)) {
	          modelValue = invokeModelGetter($scope);
	        }
	        return modelValue;
	      };
	      this.$$ngModelSet = function($scope, newValue) {
	        if (isFunction(this.$$parsedNgModel($scope))) {
	          invokeModelSetter($scope, {$$$p: newValue});
	        } else {
	          this.$$parsedNgModelAssign($scope, newValue);
	        }
	      };
	    } else if (!this.$$parsedNgModel.assign) {
	      throw ngModelMinErr('nonassign', 'Expression \'{0}\' is non-assignable. Element: {1}',
	          this.$$attr.ngModel, startingTag(this.$$element));
	    }
	  },
	
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$render
	   *
	   * @description
	   * Called when the view needs to be updated. It is expected that the user of the ng-model
	   * directive will implement this method.
	   *
	   * The `$render()` method is invoked in the following situations:
	   *
	   * * `$rollbackViewValue()` is called.  If we are rolling back the view value to the last
	   *   committed value then `$render()` is called to update the input control.
	   * * The value referenced by `ng-model` is changed programmatically and both the `$modelValue` and
	   *   the `$viewValue` are different from last time.
	   *
	   * Since `ng-model` does not do a deep watch, `$render()` is only invoked if the values of
	   * `$modelValue` and `$viewValue` are actually different from their previous values. If `$modelValue`
	   * or `$viewValue` are objects (rather than a string or number) then `$render()` will not be
	   * invoked if you only change a property on the objects.
	   */
	  $render: noop,
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$isEmpty
	   *
	   * @description
	   * This is called when we need to determine if the value of an input is empty.
	   *
	   * For instance, the required directive does this to work out if the input has data or not.
	   *
	   * The default `$isEmpty` function checks whether the value is `undefined`, `''`, `null` or `NaN`.
	   *
	   * You can override this for input directives whose concept of being empty is different from the
	   * default. The `checkboxInputType` directive does this because in its case a value of `false`
	   * implies empty.
	   *
	   * @param {*} value The value of the input to check for emptiness.
	   * @returns {boolean} True if `value` is "empty".
	   */
	  $isEmpty: function(value) {
	    // eslint-disable-next-line no-self-compare
	    return isUndefined(value) || value === '' || value === null || value !== value;
	  },
	
	  $$updateEmptyClasses: function(value) {
	    if (this.$isEmpty(value)) {
	      this.$$animate.removeClass(this.$$element, NOT_EMPTY_CLASS);
	      this.$$animate.addClass(this.$$element, EMPTY_CLASS);
	    } else {
	      this.$$animate.removeClass(this.$$element, EMPTY_CLASS);
	      this.$$animate.addClass(this.$$element, NOT_EMPTY_CLASS);
	    }
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setPristine
	   *
	   * @description
	   * Sets the control to its pristine state.
	   *
	   * This method can be called to remove the `ng-dirty` class and set the control to its pristine
	   * state (`ng-pristine` class). A model is considered to be pristine when the control
	   * has not been changed from when first compiled.
	   */
	  $setPristine: function() {
	    this.$dirty = false;
	    this.$pristine = true;
	    this.$$animate.removeClass(this.$$element, DIRTY_CLASS);
	    this.$$animate.addClass(this.$$element, PRISTINE_CLASS);
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setDirty
	   *
	   * @description
	   * Sets the control to its dirty state.
	   *
	   * This method can be called to remove the `ng-pristine` class and set the control to its dirty
	   * state (`ng-dirty` class). A model is considered to be dirty when the control has been changed
	   * from when first compiled.
	   */
	  $setDirty: function() {
	    this.$dirty = true;
	    this.$pristine = false;
	    this.$$animate.removeClass(this.$$element, PRISTINE_CLASS);
	    this.$$animate.addClass(this.$$element, DIRTY_CLASS);
	    this.$$parentForm.$setDirty();
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setUntouched
	   *
	   * @description
	   * Sets the control to its untouched state.
	   *
	   * This method can be called to remove the `ng-touched` class and set the control to its
	   * untouched state (`ng-untouched` class). Upon compilation, a model is set as untouched
	   * by default, however this function can be used to restore that state if the model has
	   * already been touched by the user.
	   */
	  $setUntouched: function() {
	    this.$touched = false;
	    this.$untouched = true;
	    this.$$animate.setClass(this.$$element, UNTOUCHED_CLASS, TOUCHED_CLASS);
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setTouched
	   *
	   * @description
	   * Sets the control to its touched state.
	   *
	   * This method can be called to remove the `ng-untouched` class and set the control to its
	   * touched state (`ng-touched` class). A model is considered to be touched when the user has
	   * first focused the control element and then shifted focus away from the control (blur event).
	   */
	  $setTouched: function() {
	    this.$touched = true;
	    this.$untouched = false;
	    this.$$animate.setClass(this.$$element, TOUCHED_CLASS, UNTOUCHED_CLASS);
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$rollbackViewValue
	   *
	   * @description
	   * Cancel an update and reset the input element's value to prevent an update to the `$modelValue`,
	   * which may be caused by a pending debounced event or because the input is waiting for some
	   * future event.
	   *
	   * If you have an input that uses `ng-model-options` to set up debounced updates or updates that
	   * depend on special events such as `blur`, there can be a period when the `$viewValue` is out of
	   * sync with the ngModel's `$modelValue`.
	   *
	   * In this case, you can use `$rollbackViewValue()` to manually cancel the debounced / future update
	   * and reset the input to the last committed view value.
	   *
	   * It is also possible that you run into difficulties if you try to update the ngModel's `$modelValue`
	   * programmatically before these debounced/future events have resolved/occurred, because AngularJS's
	   * dirty checking mechanism is not able to tell whether the model has actually changed or not.
	   *
	   * The `$rollbackViewValue()` method should be called before programmatically changing the model of an
	   * input which may have such events pending. This is important in order to make sure that the
	   * input field will be updated with the new model value and any pending operations are cancelled.
	   *
	   * @example
	   * <example name="ng-model-cancel-update" module="cancel-update-example">
	   *   <file name="app.js">
	   *     angular.module('cancel-update-example', [])
	   *
	   *     .controller('CancelUpdateController', ['$scope', function($scope) {
	   *       $scope.model = {value1: '', value2: ''};
	   *
	   *       $scope.setEmpty = function(e, value, rollback) {
	   *         if (e.keyCode === 27) {
	   *           e.preventDefault();
	   *           if (rollback) {
	   *             $scope.myForm[value].$rollbackViewValue();
	   *           }
	   *           $scope.model[value] = '';
	   *         }
	   *       };
	   *     }]);
	   *   </file>
	   *   <file name="index.html">
	   *     <div ng-controller="CancelUpdateController">
	   *       <p>Both of these inputs are only updated if they are blurred. Hitting escape should
	   *       empty them. Follow these steps and observe the difference:</p>
	   *       <ol>
	   *         <li>Type something in the input. You will see that the model is not yet updated</li>
	   *         <li>Press the Escape key.
	   *           <ol>
	   *             <li> In the first example, nothing happens, because the model is already '', and no
	   *             update is detected. If you blur the input, the model will be set to the current view.
	   *             </li>
	   *             <li> In the second example, the pending update is cancelled, and the input is set back
	   *             to the last committed view value (''). Blurring the input does nothing.
	   *             </li>
	   *           </ol>
	   *         </li>
	   *       </ol>
	   *
	   *       <form name="myForm" ng-model-options="{ updateOn: 'blur' }">
	   *         <div>
	   *           <p id="inputDescription1">Without $rollbackViewValue():</p>
	   *           <input name="value1" aria-describedby="inputDescription1" ng-model="model.value1"
	   *                  ng-keydown="setEmpty($event, 'value1')">
	   *           value1: "{{ model.value1 }}"
	   *         </div>
	   *
	   *         <div>
	   *           <p id="inputDescription2">With $rollbackViewValue():</p>
	   *           <input name="value2" aria-describedby="inputDescription2" ng-model="model.value2"
	   *                  ng-keydown="setEmpty($event, 'value2', true)">
	   *           value2: "{{ model.value2 }}"
	   *         </div>
	   *       </form>
	   *     </div>
	   *   </file>
	       <file name="style.css">
	          div {
	            display: table-cell;
	          }
	          div:nth-child(1) {
	            padding-right: 30px;
	          }
	
	        </file>
	   * </example>
	   */
	  $rollbackViewValue: function() {
	    this.$$timeout.cancel(this.$$pendingDebounce);
	    this.$viewValue = this.$$lastCommittedViewValue;
	    this.$render();
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$validate
	   *
	   * @description
	   * Runs each of the registered validators (first synchronous validators and then
	   * asynchronous validators).
	   * If the validity changes to invalid, the model will be set to `undefined`,
	   * unless {@link ngModelOptions `ngModelOptions.allowInvalid`} is `true`.
	   * If the validity changes to valid, it will set the model to the last available valid
	   * `$modelValue`, i.e. either the last parsed value or the last value set from the scope.
	   */
	  $validate: function() {
	
	    // ignore $validate before model is initialized
	    if (isNumberNaN(this.$modelValue)) {
	      return;
	    }
	
	    var viewValue = this.$$lastCommittedViewValue;
	    // Note: we use the $$rawModelValue as $modelValue might have been
	    // set to undefined during a view -> model update that found validation
	    // errors. We can't parse the view here, since that could change
	    // the model although neither viewValue nor the model on the scope changed
	    var modelValue = this.$$rawModelValue;
	
	    var prevValid = this.$valid;
	    var prevModelValue = this.$modelValue;
	
	    var allowInvalid = this.$options.getOption('allowInvalid');
	
	    var that = this;
	    this.$$runValidators(modelValue, viewValue, function(allValid) {
	      // If there was no change in validity, don't update the model
	      // This prevents changing an invalid modelValue to undefined
	      if (!allowInvalid && prevValid !== allValid) {
	        // Note: Don't check this.$valid here, as we could have
	        // external validators (e.g. calculated on the server),
	        // that just call $setValidity and need the model value
	        // to calculate their validity.
	        that.$modelValue = allValid ? modelValue : undefined;
	
	        if (that.$modelValue !== prevModelValue) {
	          that.$$writeModelToScope();
	        }
	      }
	    });
	  },
	
	  $$runValidators: function(modelValue, viewValue, doneCallback) {
	    this.$$currentValidationRunId++;
	    var localValidationRunId = this.$$currentValidationRunId;
	    var that = this;
	
	    // check parser error
	    if (!processParseErrors()) {
	      validationDone(false);
	      return;
	    }
	    if (!processSyncValidators()) {
	      validationDone(false);
	      return;
	    }
	    processAsyncValidators();
	
	    function processParseErrors() {
	      var errorKey = that.$$parserName;
	
	      if (isUndefined(that.$$parserValid)) {
	        setValidity(errorKey, null);
	      } else {
	        if (!that.$$parserValid) {
	          forEach(that.$validators, function(v, name) {
	            setValidity(name, null);
	          });
	          forEach(that.$asyncValidators, function(v, name) {
	            setValidity(name, null);
	          });
	        }
	
	        // Set the parse error last, to prevent unsetting it, should a $validators key == parserName
	        setValidity(errorKey, that.$$parserValid);
	        return that.$$parserValid;
	      }
	      return true;
	    }
	
	    function processSyncValidators() {
	      var syncValidatorsValid = true;
	      forEach(that.$validators, function(validator, name) {
	        var result = Boolean(validator(modelValue, viewValue));
	        syncValidatorsValid = syncValidatorsValid && result;
	        setValidity(name, result);
	      });
	      if (!syncValidatorsValid) {
	        forEach(that.$asyncValidators, function(v, name) {
	          setValidity(name, null);
	        });
	        return false;
	      }
	      return true;
	    }
	
	    function processAsyncValidators() {
	      var validatorPromises = [];
	      var allValid = true;
	      forEach(that.$asyncValidators, function(validator, name) {
	        var promise = validator(modelValue, viewValue);
	        if (!isPromiseLike(promise)) {
	          throw ngModelMinErr('nopromise',
	            'Expected asynchronous validator to return a promise but got \'{0}\' instead.', promise);
	        }
	        setValidity(name, undefined);
	        validatorPromises.push(promise.then(function() {
	          setValidity(name, true);
	        }, function() {
	          allValid = false;
	          setValidity(name, false);
	        }));
	      });
	      if (!validatorPromises.length) {
	        validationDone(true);
	      } else {
	        that.$$q.all(validatorPromises).then(function() {
	          validationDone(allValid);
	        }, noop);
	      }
	    }
	
	    function setValidity(name, isValid) {
	      if (localValidationRunId === that.$$currentValidationRunId) {
	        that.$setValidity(name, isValid);
	      }
	    }
	
	    function validationDone(allValid) {
	      if (localValidationRunId === that.$$currentValidationRunId) {
	
	        doneCallback(allValid);
	      }
	    }
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$commitViewValue
	   *
	   * @description
	   * Commit a pending update to the `$modelValue`.
	   *
	   * Updates may be pending by a debounced event or because the input is waiting for a some future
	   * event defined in `ng-model-options`. this method is rarely needed as `NgModelController`
	   * usually handles calling this in response to input events.
	   */
	  $commitViewValue: function() {
	    var viewValue = this.$viewValue;
	
	    this.$$timeout.cancel(this.$$pendingDebounce);
	
	    // If the view value has not changed then we should just exit, except in the case where there is
	    // a native validator on the element. In this case the validation state may have changed even though
	    // the viewValue has stayed empty.
	    if (this.$$lastCommittedViewValue === viewValue && (viewValue !== '' || !this.$$hasNativeValidators)) {
	      return;
	    }
	    this.$$updateEmptyClasses(viewValue);
	    this.$$lastCommittedViewValue = viewValue;
	
	    // change to dirty
	    if (this.$pristine) {
	      this.$setDirty();
	    }
	    this.$$parseAndValidate();
	  },
	
	  $$parseAndValidate: function() {
	    var viewValue = this.$$lastCommittedViewValue;
	    var modelValue = viewValue;
	    var that = this;
	
	    this.$$parserValid = isUndefined(modelValue) ? undefined : true;
	
	    // Reset any previous parse error
	    this.$setValidity(this.$$parserName, null);
	    this.$$parserName = 'parse';
	
	    if (this.$$parserValid) {
	      for (var i = 0; i < this.$parsers.length; i++) {
	        modelValue = this.$parsers[i](modelValue);
	        if (isUndefined(modelValue)) {
	          this.$$parserValid = false;
	          break;
	        }
	      }
	    }
	    if (isNumberNaN(this.$modelValue)) {
	      // this.$modelValue has not been touched yet...
	      this.$modelValue = this.$$ngModelGet(this.$$scope);
	    }
	    var prevModelValue = this.$modelValue;
	    var allowInvalid = this.$options.getOption('allowInvalid');
	    this.$$rawModelValue = modelValue;
	
	    if (allowInvalid) {
	      this.$modelValue = modelValue;
	      writeToModelIfNeeded();
	    }
	
	    // Pass the $$lastCommittedViewValue here, because the cached viewValue might be out of date.
	    // This can happen if e.g. $setViewValue is called from inside a parser
	    this.$$runValidators(modelValue, this.$$lastCommittedViewValue, function(allValid) {
	      if (!allowInvalid) {
	        // Note: Don't check this.$valid here, as we could have
	        // external validators (e.g. calculated on the server),
	        // that just call $setValidity and need the model value
	        // to calculate their validity.
	        that.$modelValue = allValid ? modelValue : undefined;
	        writeToModelIfNeeded();
	      }
	    });
	
	    function writeToModelIfNeeded() {
	      if (that.$modelValue !== prevModelValue) {
	        that.$$writeModelToScope();
	      }
	    }
	  },
	
	  $$writeModelToScope: function() {
	    this.$$ngModelSet(this.$$scope, this.$modelValue);
	    forEach(this.$viewChangeListeners, function(listener) {
	      try {
	        listener();
	      } catch (e) {
	        // eslint-disable-next-line no-invalid-this
	        this.$$exceptionHandler(e);
	      }
	    }, this);
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setViewValue
	   *
	   * @description
	   * Update the view value.
	   *
	   * This method should be called when a control wants to change the view value; typically,
	   * this is done from within a DOM event handler. For example, the {@link ng.directive:input input}
	   * directive calls it when the value of the input changes and {@link ng.directive:select select}
	   * calls it when an option is selected.
	   *
	   * When `$setViewValue` is called, the new `value` will be staged for committing through the `$parsers`
	   * and `$validators` pipelines. If there are no special {@link ngModelOptions} specified then the staged
	   * value is sent directly for processing through the `$parsers` pipeline. After this, the `$validators` and
	   * `$asyncValidators` are called and the value is applied to `$modelValue`.
	   * Finally, the value is set to the **expression** specified in the `ng-model` attribute and
	   * all the registered change listeners, in the `$viewChangeListeners` list are called.
	   *
	   * In case the {@link ng.directive:ngModelOptions ngModelOptions} directive is used with `updateOn`
	   * and the `default` trigger is not listed, all those actions will remain pending until one of the
	   * `updateOn` events is triggered on the DOM element.
	   * All these actions will be debounced if the {@link ng.directive:ngModelOptions ngModelOptions}
	   * directive is used with a custom debounce for this particular event.
	   * Note that a `$digest` is only triggered once the `updateOn` events are fired, or if `debounce`
	   * is specified, once the timer runs out.
	   *
	   * When used with standard inputs, the view value will always be a string (which is in some cases
	   * parsed into another type, such as a `Date` object for `input[date]`.)
	   * However, custom controls might also pass objects to this method. In this case, we should make
	   * a copy of the object before passing it to `$setViewValue`. This is because `ngModel` does not
	   * perform a deep watch of objects, it only looks for a change of identity. If you only change
	   * the property of the object then ngModel will not realize that the object has changed and
	   * will not invoke the `$parsers` and `$validators` pipelines. For this reason, you should
	   * not change properties of the copy once it has been passed to `$setViewValue`.
	   * Otherwise you may cause the model value on the scope to change incorrectly.
	   *
	   * <div class="alert alert-info">
	   * In any case, the value passed to the method should always reflect the current value
	   * of the control. For example, if you are calling `$setViewValue` for an input element,
	   * you should pass the input DOM value. Otherwise, the control and the scope model become
	   * out of sync. It's also important to note that `$setViewValue` does not call `$render` or change
	   * the control's DOM value in any way. If we want to change the control's DOM value
	   * programmatically, we should update the `ngModel` scope expression. Its new value will be
	   * picked up by the model controller, which will run it through the `$formatters`, `$render` it
	   * to update the DOM, and finally call `$validate` on it.
	   * </div>
	   *
	   * @param {*} value value from the view.
	   * @param {string} trigger Event that triggered the update.
	   */
	  $setViewValue: function(value, trigger) {
	    this.$viewValue = value;
	    if (this.$options.getOption('updateOnDefault')) {
	      this.$$debounceViewValueCommit(trigger);
	    }
	  },
	
	  $$debounceViewValueCommit: function(trigger) {
	    var debounceDelay = this.$options.getOption('debounce');
	
	    if (isNumber(debounceDelay[trigger])) {
	      debounceDelay = debounceDelay[trigger];
	    } else if (isNumber(debounceDelay['default']) &&
	      this.$options.getOption('updateOn').indexOf(trigger) === -1
	    ) {
	      debounceDelay = debounceDelay['default'];
	    } else if (isNumber(debounceDelay['*'])) {
	      debounceDelay = debounceDelay['*'];
	    }
	
	    this.$$timeout.cancel(this.$$pendingDebounce);
	    var that = this;
	    if (debounceDelay > 0) { // this fails if debounceDelay is an object
	      this.$$pendingDebounce = this.$$timeout(function() {
	        that.$commitViewValue();
	      }, debounceDelay);
	    } else if (this.$$rootScope.$$phase) {
	      this.$commitViewValue();
	    } else {
	      this.$$scope.$apply(function() {
	        that.$commitViewValue();
	      });
	    }
	  },
	
	  /**
	   * @ngdoc method
	   *
	   * @name ngModel.NgModelController#$overrideModelOptions
	   *
	   * @description
	   *
	   * Override the current model options settings programmatically.
	   *
	   * The previous `ModelOptions` value will not be modified. Instead, a
	   * new `ModelOptions` object will inherit from the previous one overriding
	   * or inheriting settings that are defined in the given parameter.
	   *
	   * See {@link ngModelOptions} for information about what options can be specified
	   * and how model option inheritance works.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** this function only affects the options set on the `ngModelController`,
	   * and not the options on the {@link ngModelOptions} directive from which they might have been
	   * obtained initially.
	   * </div>
	   *
	   * <div class="alert alert-danger">
	   * **Note:** it is not possible to override the `getterSetter` option.
	   * </div>
	   *
	   * @param {Object} options a hash of settings to override the previous options
	   *
	   */
	  $overrideModelOptions: function(options) {
	    this.$options = this.$options.createChild(options);
	    this.$$setUpdateOnEvents();
	  },
	
	  /**
	   * @ngdoc method
	   *
	   * @name  ngModel.NgModelController#$processModelValue
	
	   * @description
	   *
	   * Runs the model -> view pipeline on the current
	   * {@link ngModel.NgModelController#$modelValue $modelValue}.
	   *
	   * The following actions are performed by this method:
	   *
	   * - the `$modelValue` is run through the {@link ngModel.NgModelController#$formatters $formatters}
	   * and the result is set to the {@link ngModel.NgModelController#$viewValue $viewValue}
	   * - the `ng-empty` or `ng-not-empty` class is set on the element
	   * - if the `$viewValue` has changed:
	   *   - {@link ngModel.NgModelController#$render $render} is called on the control
	   *   - the {@link ngModel.NgModelController#$validators $validators} are run and
	   *   the validation status is set.
	   *
	   * This method is called by ngModel internally when the bound scope value changes.
	   * Application developers usually do not have to call this function themselves.
	   *
	   * This function can be used when the `$viewValue` or the rendered DOM value are not correctly
	   * formatted and the `$modelValue` must be run through the `$formatters` again.
	   *
	   * @example
	   * Consider a text input with an autocomplete list (for fruit), where the items are
	   * objects with a name and an id.
	   * A user enters `ap` and then selects `Apricot` from the list.
	   * Based on this, the autocomplete widget will call `$setViewValue({name: 'Apricot', id: 443})`,
	   * but the rendered value will still be `ap`.
	   * The widget can then call `ctrl.$processModelValue()` to run the model -> view
	   * pipeline again, which formats the object to the string `Apricot`,
	   * then updates the `$viewValue`, and finally renders it in the DOM.
	   *
	   * <example module="inputExample" name="ng-model-process">
	     <file name="index.html">
	      <div ng-controller="inputController" style="display: flex;">
	        <div style="margin-right: 30px;">
	          Search Fruit:
	          <basic-autocomplete items="items" on-select="selectedFruit = item"></basic-autocomplete>
	        </div>
	        <div>
	          Model:<br>
	          <pre>{{selectedFruit | json}}</pre>
	        </div>
	      </div>
	     </file>
	     <file name="app.js">
	      angular.module('inputExample', [])
	        .controller('inputController', function($scope) {
	          $scope.items = [
	            {name: 'Apricot', id: 443},
	            {name: 'Clementine', id: 972},
	            {name: 'Durian', id: 169},
	            {name: 'Jackfruit', id: 982},
	            {name: 'Strawberry', id: 863}
	          ];
	        })
	        .component('basicAutocomplete', {
	          bindings: {
	            items: '<',
	            onSelect: '&'
	          },
	          templateUrl: 'autocomplete.html',
	          controller: function($element, $scope) {
	            var that = this;
	            var ngModel;
	
	            that.$postLink = function() {
	              ngModel = $element.find('input').controller('ngModel');
	
	              ngModel.$formatters.push(function(value) {
	                return (value && value.name) || value;
	              });
	
	              ngModel.$parsers.push(function(value) {
	                var match = value;
	                for (var i = 0; i < that.items.length; i++) {
	                  if (that.items[i].name === value) {
	                    match = that.items[i];
	                    break;
	                  }
	                }
	
	                return match;
	              });
	            };
	
	            that.selectItem = function(item) {
	              ngModel.$setViewValue(item);
	              ngModel.$processModelValue();
	              that.onSelect({item: item});
	            };
	          }
	        });
	     </file>
	     <file name="autocomplete.html">
	       <div>
	         <input type="search" ng-model="$ctrl.searchTerm" />
	         <ul>
	           <li ng-repeat="item in $ctrl.items | filter:$ctrl.searchTerm">
	             <button ng-click="$ctrl.selectItem(item)">{{ item.name }}</button>
	           </li>
	         </ul>
	       </div>
	     </file>
	   * </example>
	   *
	   */
	  $processModelValue: function() {
	    var viewValue = this.$$format();
	
	    if (this.$viewValue !== viewValue) {
	      this.$$updateEmptyClasses(viewValue);
	      this.$viewValue = this.$$lastCommittedViewValue = viewValue;
	      this.$render();
	      // It is possible that model and view value have been updated during render
	      this.$$runValidators(this.$modelValue, this.$viewValue, noop);
	    }
	  },
	
	  /**
	   * This method is called internally to run the $formatters on the $modelValue
	   */
	  $$format: function() {
	    var formatters = this.$formatters,
	        idx = formatters.length;
	
	    var viewValue = this.$modelValue;
	    while (idx--) {
	      viewValue = formatters[idx](viewValue);
	    }
	
	    return viewValue;
	  },
	
	  /**
	   * This method is called internally when the bound scope value changes.
	   */
	  $$setModelValue: function(modelValue) {
	    this.$modelValue = this.$$rawModelValue = modelValue;
	    this.$$parserValid = undefined;
	    this.$processModelValue();
	  },
	
	  $$setUpdateOnEvents: function() {
	    if (this.$$updateEvents) {
	      this.$$element.off(this.$$updateEvents, this.$$updateEventHandler);
	    }
	
	    this.$$updateEvents = this.$options.getOption('updateOn');
	    if (this.$$updateEvents) {
	      this.$$element.on(this.$$updateEvents, this.$$updateEventHandler);
	    }
	  },
	
	  $$updateEventHandler: function(ev) {
	    this.$$debounceViewValueCommit(ev && ev.type);
	  }
	};
	
	function setupModelWatcher(ctrl) {
	  // model -> value
	  // Note: we cannot use a normal scope.$watch as we want to detect the following:
	  // 1. scope value is 'a'
	  // 2. user enters 'b'
	  // 3. ng-change kicks in and reverts scope value to 'a'
	  //    -> scope value did not change since the last digest as
	  //       ng-change executes in apply phase
	  // 4. view should be changed back to 'a'
	  ctrl.$$scope.$watch(function ngModelWatch(scope) {
	    var modelValue = ctrl.$$ngModelGet(scope);
	
	    // if scope model value and ngModel value are out of sync
	    // This cannot be moved to the action function, because it would not catch the
	    // case where the model is changed in the ngChange function or the model setter
	    if (modelValue !== ctrl.$modelValue &&
	      // checks for NaN is needed to allow setting the model to NaN when there's an asyncValidator
	      // eslint-disable-next-line no-self-compare
	      (ctrl.$modelValue === ctrl.$modelValue || modelValue === modelValue)
	    ) {
	      ctrl.$$setModelValue(modelValue);
	    }
	
	    return modelValue;
	  });
	}
	
	/**
	 * @ngdoc method
	 * @name ngModel.NgModelController#$setValidity
	 *
	 * @description
	 * Change the validity state, and notify the form.
	 *
	 * This method can be called within $parsers/$formatters or a custom validation implementation.
	 * However, in most cases it should be sufficient to use the `ngModel.$validators` and
	 * `ngModel.$asyncValidators` collections which will call `$setValidity` automatically.
	 *
	 * @param {string} validationErrorKey Name of the validator. The `validationErrorKey` will be assigned
	 *        to either `$error[validationErrorKey]` or `$pending[validationErrorKey]`
	 *        (for unfulfilled `$asyncValidators`), so that it is available for data-binding.
	 *        The `validationErrorKey` should be in camelCase and will get converted into dash-case
	 *        for class name. Example: `myError` will result in `ng-valid-my-error` and `ng-invalid-my-error`
	 *        classes and can be bound to as `{{ someForm.someControl.$error.myError }}`.
	 * @param {boolean} isValid Whether the current state is valid (true), invalid (false), pending (undefined),
	 *                          or skipped (null). Pending is used for unfulfilled `$asyncValidators`.
	 *                          Skipped is used by AngularJS when validators do not run because of parse errors and
	 *                          when `$asyncValidators` do not run because any of the `$validators` failed.
	 */
	addSetValidityMethod({
	  clazz: NgModelController,
	  set: function(object, property) {
	    object[property] = true;
	  },
	  unset: function(object, property) {
	    delete object[property];
	  }
	});
	
	
	/**
	 * @ngdoc directive
	 * @name ngModel
	 * @restrict A
	 * @priority 1
	 * @param {expression} ngModel assignable {@link guide/expression Expression} to bind to.
	 *
	 * @description
	 * The `ngModel` directive binds an `input`,`select`, `textarea` (or custom form control) to a
	 * property on the scope using {@link ngModel.NgModelController NgModelController},
	 * which is created and exposed by this directive.
	 *
	 * `ngModel` is responsible for:
	 *
	 * - Binding the view into the model, which other directives such as `input`, `textarea` or `select`
	 *   require.
	 * - Providing validation behavior (i.e. required, number, email, url).
	 * - Keeping the state of the control (valid/invalid, dirty/pristine, touched/untouched, validation errors).
	 * - Setting related css classes on the element (`ng-valid`, `ng-invalid`, `ng-dirty`, `ng-pristine`, `ng-touched`,
	 *   `ng-untouched`, `ng-empty`, `ng-not-empty`) including animations.
	 * - Registering the control with its parent {@link ng.directive:form form}.
	 *
	 * Note: `ngModel` will try to bind to the property given by evaluating the expression on the
	 * current scope. If the property doesn't already exist on this scope, it will be created
	 * implicitly and added to the scope.
	 *
	 * For best practices on using `ngModel`, see:
	 *
	 *  - [Understanding Scopes](https://github.com/angular/angular.js/wiki/Understanding-Scopes)
	 *
	 * For basic examples, how to use `ngModel`, see:
	 *
	 *  - {@link ng.directive:input input}
	 *    - {@link input[text] text}
	 *    - {@link input[checkbox] checkbox}
	 *    - {@link input[radio] radio}
	 *    - {@link input[number] number}
	 *    - {@link input[email] email}
	 *    - {@link input[url] url}
	 *    - {@link input[date] date}
	 *    - {@link input[datetime-local] datetime-local}
	 *    - {@link input[time] time}
	 *    - {@link input[month] month}
	 *    - {@link input[week] week}
	 *  - {@link ng.directive:select select}
	 *  - {@link ng.directive:textarea textarea}
	 *
	 * ## Complex Models (objects or collections)
	 *
	 * By default, `ngModel` watches the model by reference, not value. This is important to know when
	 * binding inputs to models that are objects (e.g. `Date`) or collections (e.g. arrays). If only properties of the
	 * object or collection change, `ngModel` will not be notified and so the input will not be  re-rendered.
	 *
	 * The model must be assigned an entirely new object or collection before a re-rendering will occur.
	 *
	 * Some directives have options that will cause them to use a custom `$watchCollection` on the model expression
	 * - for example, `ngOptions` will do so when a `track by` clause is included in the comprehension expression or
	 * if the select is given the `multiple` attribute.
	 *
	 * The `$watchCollection()` method only does a shallow comparison, meaning that changing properties deeper than the
	 * first level of the object (or only changing the properties of an item in the collection if it's an array) will still
	 * not trigger a re-rendering of the model.
	 *
	 * ## CSS classes
	 * The following CSS classes are added and removed on the associated input/select/textarea element
	 * depending on the validity of the model.
	 *
	 *  - `ng-valid`: the model is valid
	 *  - `ng-invalid`: the model is invalid
	 *  - `ng-valid-[key]`: for each valid key added by `$setValidity`
	 *  - `ng-invalid-[key]`: for each invalid key added by `$setValidity`
	 *  - `ng-pristine`: the control hasn't been interacted with yet
	 *  - `ng-dirty`: the control has been interacted with
	 *  - `ng-touched`: the control has been blurred
	 *  - `ng-untouched`: the control hasn't been blurred
	 *  - `ng-pending`: any `$asyncValidators` are unfulfilled
	 *  - `ng-empty`: the view does not contain a value or the value is deemed "empty", as defined
	 *     by the {@link ngModel.NgModelController#$isEmpty} method
	 *  - `ng-not-empty`: the view contains a non-empty value
	 *
	 * Keep in mind that ngAnimate can detect each of these classes when added and removed.
	 *
	 * @animations
	 * Animations within models are triggered when any of the associated CSS classes are added and removed
	 * on the input element which is attached to the model. These classes include: `.ng-pristine`, `.ng-dirty`,
	 * `.ng-invalid` and `.ng-valid` as well as any other validations that are performed on the model itself.
	 * The animations that are triggered within ngModel are similar to how they work in ngClass and
	 * animations can be hooked into using CSS transitions, keyframes as well as JS animations.
	 *
	 * The following example shows a simple way to utilize CSS transitions to style an input element
	 * that has been rendered as invalid after it has been validated:
	 *
	 * <pre>
	 * //be sure to include ngAnimate as a module to hook into more
	 * //advanced animations
	 * .my-input {
	 *   transition:0.5s linear all;
	 *   background: white;
	 * }
	 * .my-input.ng-invalid {
	 *   background: red;
	 *   color:white;
	 * }
	 * </pre>
	 *
	 * @example
	 * ### Basic Usage
	 * <example deps="angular-animate.js" animations="true" fixBase="true" module="inputExample" name="ng-model">
	     <file name="index.html">
	       <script>
	        angular.module('inputExample', [])
	          .controller('ExampleController', ['$scope', function($scope) {
	            $scope.val = '1';
	          }]);
	       </script>
	       <style>
	         .my-input {
	           transition:all linear 0.5s;
	           background: transparent;
	         }
	         .my-input.ng-invalid {
	           color:white;
	           background: red;
	         }
	       </style>
	       <p id="inputDescription">
	        Update input to see transitions when valid/invalid.
	        Integer is a valid value.
	       </p>
	       <form name="testForm" ng-controller="ExampleController">
	         <input ng-model="val" ng-pattern="/^\d+$/" name="anim" class="my-input"
	                aria-describedby="inputDescription" />
	       </form>
	     </file>
	 * </example>
	 *
	 * @example
	 * ### Binding to a getter/setter
	 *
	 * Sometimes it's helpful to bind `ngModel` to a getter/setter function.  A getter/setter is a
	 * function that returns a representation of the model when called with zero arguments, and sets
	 * the internal state of a model when called with an argument. It's sometimes useful to use this
	 * for models that have an internal representation that's different from what the model exposes
	 * to the view.
	 *
	 * <div class="alert alert-success">
	 * **Best Practice:** It's best to keep getters fast because AngularJS is likely to call them more
	 * frequently than other parts of your code.
	 * </div>
	 *
	 * You use this behavior by adding `ng-model-options="{ getterSetter: true }"` to an element that
	 * has `ng-model` attached to it. You can also add `ng-model-options="{ getterSetter: true }"` to
	 * a `<form>`, which will enable this behavior for all `<input>`s within it. See
	 * {@link ng.directive:ngModelOptions `ngModelOptions`} for more.
	 *
	 * The following example shows how to use `ngModel` with a getter/setter:
	 *
	 * @example
	 * <example name="ngModel-getter-setter" module="getterSetterExample">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <form name="userForm">
	           <label>Name:
	             <input type="text" name="userName"
	                    ng-model="user.name"
	                    ng-model-options="{ getterSetter: true }" />
	           </label>
	         </form>
	         <pre>user.name = <span ng-bind="user.name()"></span></pre>
	       </div>
	     </file>
	     <file name="app.js">
	       angular.module('getterSetterExample', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           var _name = 'Brian';
	           $scope.user = {
	             name: function(newName) {
	              // Note that newName can be undefined for two reasons:
	              // 1. Because it is called as a getter and thus called with no arguments
	              // 2. Because the property should actually be set to undefined. This happens e.g. if the
	              //    input is invalid
	              return arguments.length ? (_name = newName) : _name;
	             }
	           };
	         }]);
	     </file>
	 * </example>
	 */
	var ngModelDirective = ['$rootScope', function($rootScope) {
	  return {
	    restrict: 'A',
	    require: ['ngModel', '^?form', '^?ngModelOptions'],
	    controller: NgModelController,
	    // Prelink needs to run before any input directive
	    // so that we can set the NgModelOptions in NgModelController
	    // before anyone else uses it.
	    priority: 1,
	    compile: function ngModelCompile(element) {
	      // Setup initial state of the control
	      element.addClass(PRISTINE_CLASS).addClass(UNTOUCHED_CLASS).addClass(VALID_CLASS);
	
	      return {
	        pre: function ngModelPreLink(scope, element, attr, ctrls) {
	          var modelCtrl = ctrls[0],
	              formCtrl = ctrls[1] || modelCtrl.$$parentForm,
	              optionsCtrl = ctrls[2];
	
	          if (optionsCtrl) {
	            modelCtrl.$options = optionsCtrl.$options;
	          }
	
	          modelCtrl.$$initGetterSetters();
	
	          // notify others, especially parent forms
	          formCtrl.$addControl(modelCtrl);
	
	          attr.$observe('name', function(newValue) {
	            if (modelCtrl.$name !== newValue) {
	              modelCtrl.$$parentForm.$$renameControl(modelCtrl, newValue);
	            }
	          });
	
	          scope.$on('$destroy', function() {
	            modelCtrl.$$parentForm.$removeControl(modelCtrl);
	          });
	        },
	        post: function ngModelPostLink(scope, element, attr, ctrls) {
	          var modelCtrl = ctrls[0];
	          modelCtrl.$$setUpdateOnEvents();
	
	          function setTouched() {
	            modelCtrl.$setTouched();
	          }
	
	          element.on('blur', function() {
	            if (modelCtrl.$touched) return;
	
	            if ($rootScope.$$phase) {
	              scope.$evalAsync(setTouched);
	            } else {
	              scope.$apply(setTouched);
	            }
	          });
	        }
	      };
	    }
	  };
	}];
	
	/* exported defaultModelOptions */
	var defaultModelOptions;
	var DEFAULT_REGEXP = /(\s+|^)default(\s+|$)/;
	
	/**
	 * @ngdoc type
	 * @name ModelOptions
	 * @description
	 * A container for the options set by the {@link ngModelOptions} directive
	 */
	function ModelOptions(options) {
	  this.$$options = options;
	}
	
	ModelOptions.prototype = {
	
	  /**
	   * @ngdoc method
	   * @name ModelOptions#getOption
	   * @param {string} name the name of the option to retrieve
	   * @returns {*} the value of the option
	   * @description
	   * Returns the value of the given option
	   */
	  getOption: function(name) {
	    return this.$$options[name];
	  },
	
	  /**
	   * @ngdoc method
	   * @name ModelOptions#createChild
	   * @param {Object} options a hash of options for the new child that will override the parent's options
	   * @return {ModelOptions} a new `ModelOptions` object initialized with the given options.
	   */
	  createChild: function(options) {
	    var inheritAll = false;
	
	    // make a shallow copy
	    options = extend({}, options);
	
	    // Inherit options from the parent if specified by the value `"$inherit"`
	    forEach(options, /** @this */ function(option, key) {
	      if (option === '$inherit') {
	        if (key === '*') {
	          inheritAll = true;
	        } else {
	          options[key] = this.$$options[key];
	          // `updateOn` is special so we must also inherit the `updateOnDefault` option
	          if (key === 'updateOn') {
	            options.updateOnDefault = this.$$options.updateOnDefault;
	          }
	        }
	      } else {
	        if (key === 'updateOn') {
	          // If the `updateOn` property contains the `default` event then we have to remove
	          // it from the event list and set the `updateOnDefault` flag.
	          options.updateOnDefault = false;
	          options[key] = trim(option.replace(DEFAULT_REGEXP, function() {
	            options.updateOnDefault = true;
	            return ' ';
	          }));
	        }
	      }
	    }, this);
	
	    if (inheritAll) {
	      // We have a property of the form: `"*": "$inherit"`
	      delete options['*'];
	      defaults(options, this.$$options);
	    }
	
	    // Finally add in any missing defaults
	    defaults(options, defaultModelOptions.$$options);
	
	    return new ModelOptions(options);
	  }
	};
	
	
	defaultModelOptions = new ModelOptions({
	  updateOn: '',
	  updateOnDefault: true,
	  debounce: 0,
	  getterSetter: false,
	  allowInvalid: false,
	  timezone: null
	});
	
	
	/**
	 * @ngdoc directive
	 * @name ngModelOptions
	 * @restrict A
	 * @priority 10
	 *
	 * @description
	 * This directive allows you to modify the behaviour of {@link ngModel} directives within your
	 * application. You can specify an `ngModelOptions` directive on any element. All {@link ngModel}
	 * directives will use the options of their nearest `ngModelOptions` ancestor.
	 *
	 * The `ngModelOptions` settings are found by evaluating the value of the attribute directive as
	 * an AngularJS expression. This expression should evaluate to an object, whose properties contain
	 * the settings. For example: `<div ng-model-options="{ debounce: 100 }"`.
	 *
	 * ## Inheriting Options
	 *
	 * You can specify that an `ngModelOptions` setting should be inherited from a parent `ngModelOptions`
	 * directive by giving it the value of `"$inherit"`.
	 * Then it will inherit that setting from the first `ngModelOptions` directive found by traversing up the
	 * DOM tree. If there is no ancestor element containing an `ngModelOptions` directive then default settings
	 * will be used.
	 *
	 * For example given the following fragment of HTML
	 *
	 *
	 * ```html
	 * <div ng-model-options="{ allowInvalid: true, debounce: 200 }">
	 *   <form ng-model-options="{ updateOn: 'blur', allowInvalid: '$inherit' }">
	 *     <input ng-model-options="{ updateOn: 'default', allowInvalid: '$inherit' }" />
	 *   </form>
	 * </div>
	 * ```
	 *
	 * the `input` element will have the following settings
	 *
	 * ```js
	 * { allowInvalid: true, updateOn: 'default', debounce: 0 }
	 * ```
	 *
	 * Notice that the `debounce` setting was not inherited and used the default value instead.
	 *
	 * You can specify that all undefined settings are automatically inherited from an ancestor by
	 * including a property with key of `"*"` and value of `"$inherit"`.
	 *
	 * For example given the following fragment of HTML
	 *
	 *
	 * ```html
	 * <div ng-model-options="{ allowInvalid: true, debounce: 200 }">
	 *   <form ng-model-options="{ updateOn: 'blur', "*": '$inherit' }">
	 *     <input ng-model-options="{ updateOn: 'default', "*": '$inherit' }" />
	 *   </form>
	 * </div>
	 * ```
	 *
	 * the `input` element will have the following settings
	 *
	 * ```js
	 * { allowInvalid: true, updateOn: 'default', debounce: 200 }
	 * ```
	 *
	 * Notice that the `debounce` setting now inherits the value from the outer `<div>` element.
	 *
	 * If you are creating a reusable component then you should be careful when using `"*": "$inherit"`
	 * since you may inadvertently inherit a setting in the future that changes the behavior of your component.
	 *
	 *
	 * ## Triggering and debouncing model updates
	 *
	 * The `updateOn` and `debounce` properties allow you to specify a custom list of events that will
	 * trigger a model update and/or a debouncing delay so that the actual update only takes place when
	 * a timer expires; this timer will be reset after another change takes place.
	 *
	 * Given the nature of `ngModelOptions`, the value displayed inside input fields in the view might
	 * be different from the value in the actual model. This means that if you update the model you
	 * should also invoke {@link ngModel.NgModelController#$rollbackViewValue} on the relevant input field in
	 * order to make sure it is synchronized with the model and that any debounced action is canceled.
	 *
	 * The easiest way to reference the control's {@link ngModel.NgModelController#$rollbackViewValue}
	 * method is by making sure the input is placed inside a form that has a `name` attribute. This is
	 * important because `form` controllers are published to the related scope under the name in their
	 * `name` attribute.
	 *
	 * Any pending changes will take place immediately when an enclosing form is submitted via the
	 * `submit` event. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
	 * to have access to the updated model.
	 *
	 * ### Overriding immediate updates
	 *
	 * The following example shows how to override immediate updates. Changes on the inputs within the
	 * form will update the model only when the control loses focus (blur event). If `escape` key is
	 * pressed while the input field is focused, the value is reset to the value in the current model.
	 *
	 * <example name="ngModelOptions-directive-blur" module="optionsExample">
	 *   <file name="index.html">
	 *     <div ng-controller="ExampleController">
	 *       <form name="userForm">
	 *         <label>
	 *           Name:
	 *           <input type="text" name="userName"
	 *                  ng-model="user.name"
	 *                  ng-model-options="{ updateOn: 'blur' }"
	 *                  ng-keyup="cancel($event)" />
	 *         </label><br />
	 *         <label>
	 *           Other data:
	 *           <input type="text" ng-model="user.data" />
	 *         </label><br />
	 *       </form>
	 *       <pre>user.name = <span ng-bind="user.name"></span></pre>
	 *     </div>
	 *   </file>
	 *   <file name="app.js">
	 *     angular.module('optionsExample', [])
	 *       .controller('ExampleController', ['$scope', function($scope) {
	 *         $scope.user = { name: 'say', data: '' };
	 *
	 *         $scope.cancel = function(e) {
	 *           if (e.keyCode === 27) {
	 *             $scope.userForm.userName.$rollbackViewValue();
	 *           }
	 *         };
	 *       }]);
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     var model = element(by.binding('user.name'));
	 *     var input = element(by.model('user.name'));
	 *     var other = element(by.model('user.data'));
	 *
	 *     it('should allow custom events', function() {
	 *       input.sendKeys(' hello');
	 *       input.click();
	 *       expect(model.getText()).toEqual('say');
	 *       other.click();
	 *       expect(model.getText()).toEqual('say hello');
	 *     });
	 *
	 *     it('should $rollbackViewValue when model changes', function() {
	 *       input.sendKeys(' hello');
	 *       expect(input.getAttribute('value')).toEqual('say hello');
	 *       input.sendKeys(protractor.Key.ESCAPE);
	 *       expect(input.getAttribute('value')).toEqual('say');
	 *       other.click();
	 *       expect(model.getText()).toEqual('say');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * ### Debouncing updates
	 *
	 * The next example shows how to debounce model changes. Model will be updated only 1 sec after last change.
	 * If the `Clear` button is pressed, any debounced action is canceled and the value becomes empty.
	 *
	 * <example name="ngModelOptions-directive-debounce" module="optionsExample">
	 *   <file name="index.html">
	 *     <div ng-controller="ExampleController">
	 *       <form name="userForm">
	 *         Name:
	 *         <input type="text" name="userName"
	 *                ng-model="user.name"
	 *                ng-model-options="{ debounce: 1000 }" />
	 *         <button ng-click="userForm.userName.$rollbackViewValue(); user.name=''">Clear</button><br />
	 *       </form>
	 *       <pre>user.name = <span ng-bind="user.name"></span></pre>
	 *     </div>
	 *   </file>
	 *   <file name="app.js">
	 *     angular.module('optionsExample', [])
	 *       .controller('ExampleController', ['$scope', function($scope) {
	 *         $scope.user = { name: 'say' };
	 *       }]);
	 *   </file>
	 * </example>
	 *
	 * ### Default events, extra triggers, and catch-all debounce values
	 *
	 * This example shows the relationship between "default" update events and
	 * additional `updateOn` triggers.
	 *
	 * `default` events are those that are bound to the control, and when fired, update the `$viewValue`
	 * via {@link ngModel.NgModelController#$setViewValue $setViewValue}. Every event that is not listed
	 * in `updateOn` is considered a "default" event, since different control types have different
	 * default events.
	 *
	 * The control in this example updates by "default", "click", and "blur", with different `debounce`
	 * values. You can see that "click" doesn't have an individual `debounce` value -
	 * therefore it uses the `*` debounce value.
	 *
	 * There is also a button that calls {@link ngModel.NgModelController#$setViewValue $setViewValue}
	 * directly with a "custom" event. Since "custom" is not defined in the `updateOn` list,
	 * it is considered a "default" event and will update the
	 * control if "default" is defined in `updateOn`, and will receive the "default" debounce value.
	 * Note that this is just to illustrate how custom controls would possibly call `$setViewValue`.
	 *
	 * You can change the `updateOn` and `debounce` configuration to test different scenarios. This
	 * is done with {@link ngModel.NgModelController#$overrideModelOptions $overrideModelOptions}.
	 *
	  <example name="ngModelOptions-advanced" module="optionsExample">
	    <file name="index.html">
	       <model-update-demo></model-update-demo>
	    </file>
	    <file name="app.js">
	      angular.module('optionsExample', [])
	        .component('modelUpdateDemo', {
	          templateUrl: 'template.html',
	          controller: function() {
	            this.name = 'Chinua';
	
	            this.options = {
	              updateOn: 'default blur click',
	              debounce: {
	                default: 2000,
	                blur: 0,
	                '*': 1000
	              }
	            };
	
	            this.updateEvents = function() {
	              var eventList = this.options.updateOn.split(' ');
	              eventList.push('*');
	              var events = {};
	
	              for (var i = 0; i < eventList.length; i++) {
	                events[eventList[i]] = this.options.debounce[eventList[i]];
	              }
	
	              this.events = events;
	            };
	
	            this.updateOptions = function() {
	              var options = angular.extend(this.options, {
	                updateOn: Object.keys(this.events).join(' ').replace('*', ''),
	                debounce: this.events
	              });
	
	              this.form.input.$overrideModelOptions(options);
	            };
	
	            // Initialize the event form
	            this.updateEvents();
	          }
	        });
	    </file>
	    <file name="template.html">
	      <form name="$ctrl.form">
	        Input: <input type="text" name="input" ng-model="$ctrl.name" ng-model-options="$ctrl.options" />
	      </form>
	      Model: <tt>{{$ctrl.name}}</tt>
	      <hr>
	      <button ng-click="$ctrl.form.input.$setViewValue('some value', 'custom')">Trigger setViewValue with 'some value' and 'custom' event</button>
	
	      <hr>
	      <form ng-submit="$ctrl.updateOptions()">
	        <b>updateOn</b><br>
	        <input type="text" ng-model="$ctrl.options.updateOn" ng-change="$ctrl.updateEvents()" ng-model-options="{debounce: 500}">
	
	        <table>
	          <tr>
	            <th>Option</th>
	            <th>Debounce value</th>
	          </tr>
	          <tr ng-repeat="(key, value) in $ctrl.events">
	            <td>{{key}}</td>
	            <td><input type="number" ng-model="$ctrl.events[key]" /></td>
	          </tr>
	        </table>
	
	        <br>
	        <input type="submit" value="Update options">
	      </form>
	    </file>
	  </example>
	 *
	 *
	 * ## Model updates and validation
	 *
	 * The default behaviour in `ngModel` is that the model value is set to `undefined` when the
	 * validation determines that the value is invalid. By setting the `allowInvalid` property to true,
	 * the model will still be updated even if the value is invalid.
	 *
	 *
	 * ## Connecting to the scope
	 *
	 * By setting the `getterSetter` property to true you are telling ngModel that the `ngModel` expression
	 * on the scope refers to a "getter/setter" function rather than the value itself.
	 *
	 * The following example shows how to bind to getter/setters:
	 *
	 * <example name="ngModelOptions-directive-getter-setter" module="getterSetterExample">
	 *   <file name="index.html">
	 *     <div ng-controller="ExampleController">
	 *       <form name="userForm">
	 *         <label>
	 *           Name:
	 *           <input type="text" name="userName"
	 *                  ng-model="user.name"
	 *                  ng-model-options="{ getterSetter: true }" />
	 *         </label>
	 *       </form>
	 *       <pre>user.name = <span ng-bind="user.name()"></span></pre>
	 *     </div>
	 *   </file>
	 *   <file name="app.js">
	 *     angular.module('getterSetterExample', [])
	 *       .controller('ExampleController', ['$scope', function($scope) {
	 *         var _name = 'Brian';
	 *         $scope.user = {
	 *           name: function(newName) {
	 *             return angular.isDefined(newName) ? (_name = newName) : _name;
	 *           }
	 *         };
	 *       }]);
	 *   </file>
	 * </example>
	 *
	 *
	 * ## Programmatically changing options
	 *
	 * The `ngModelOptions` expression is only evaluated once when the directive is linked; it is not
	 * watched for changes. However, it is possible to override the options on a single
	 * {@link ngModel.NgModelController} instance with
	 * {@link ngModel.NgModelController#$overrideModelOptions `NgModelController#$overrideModelOptions()`}.
	 * See also the example for
	 * {@link ngModelOptions#default-events-extra-triggers-and-catch-all-debounce-values
	 * Default events, extra triggers, and catch-all debounce values}.
	 *
	 *
	 * ## Specifying timezones
	 *
	 * You can specify the timezone that date/time input directives expect by providing its name in the
	 * `timezone` property.
	 *
	 *
	 * ## Formatting the value of `time` and `datetime-local`
	 *
	 * With the options `timeSecondsFormat` and `timeStripZeroSeconds` it is possible to adjust the value
	 * that is displayed in the control. Note that browsers may apply their own formatting
	 * in the user interface.
	 *
	   <example name="ngModelOptions-time-format" module="timeExample">
	     <file name="index.html">
	       <time-example></time-example>
	     </file>
	     <file name="script.js">
	        angular.module('timeExample', [])
	          .component('timeExample', {
	            templateUrl: 'timeExample.html',
	            controller: function() {
	              this.time = new Date(1970, 0, 1, 14, 57, 0);
	
	              this.options = {
	                timeSecondsFormat: 'ss',
	                timeStripZeroSeconds: true
	              };
	
	              this.optionChange = function() {
	                this.timeForm.timeFormatted.$overrideModelOptions(this.options);
	                this.time = new Date(this.time);
	              };
	            }
	          });
	     </file>
	     <file name="timeExample.html">
	       <form name="$ctrl.timeForm">
	         <strong>Default</strong>:
	         <input type="time" ng-model="$ctrl.time" step="any" /><br>
	         <strong>With options</strong>:
	         <input type="time" name="timeFormatted" ng-model="$ctrl.time" step="any" ng-model-options="$ctrl.options" />
	         <br>
	
	         Options:<br>
	         <code>timeSecondsFormat</code>:
	         <input
	           type="text"
	           ng-model="$ctrl.options.timeSecondsFormat"
	           ng-change="$ctrl.optionChange()">
	         <br>
	         <code>timeStripZeroSeconds</code>:
	         <input
	           type="checkbox"
	           ng-model="$ctrl.options.timeStripZeroSeconds"
	           ng-change="$ctrl.optionChange()">
	        </form>
	      </file>
	 *  </example>
	 *
	 * @param {Object} ngModelOptions options to apply to {@link ngModel} directives on this element and
	 *   and its descendents.
	 *
	 * **General options**:
	 *
	 *   - `updateOn`: string specifying which event should the input be bound to. You can set several
	 *     events using an space delimited list. There is a special event called `default` that
	 *     matches the default events belonging to the control. These are the events that are bound to
	 *     the control, and when fired, update the `$viewValue` via `$setViewValue`.
	 *
	 *     `ngModelOptions` considers every event that is not listed in `updateOn` a "default" event,
	 *     since different control types use different default events.
	 *
	 *     See also the section {@link ngModelOptions#triggering-and-debouncing-model-updates
	 *     Triggering and debouncing model updates}.
	 *
	 *   - `debounce`: integer value which contains the debounce model update value in milliseconds. A
	 *     value of 0 triggers an immediate update. If an object is supplied instead, you can specify a
	 *     custom value for each event. For example:
	 *     ```
	 *     ng-model-options="{
	 *       updateOn: 'default blur',
	 *       debounce: { 'default': 500, 'blur': 0 }
	 *     }"
	 *     ```
	 *     You can use the `*` key to specify a debounce value that applies to all events that are not
	 *     specifically listed. In the following example, `mouseup` would have a debounce delay of 1000:
	 *     ```
	 *     ng-model-options="{
	 *       updateOn: 'default blur mouseup',
	 *       debounce: { 'default': 500, 'blur': 0, '*': 1000 }
	 *     }"
	 *     ```
	 *   - `allowInvalid`: boolean value which indicates that the model can be set with values that did
	 *     not validate correctly instead of the default behavior of setting the model to undefined.
	 *   - `getterSetter`: boolean value which determines whether or not to treat functions bound to
	 *     `ngModel` as getters/setters.
	 *
	 *
	 *  **Input-type specific options**:
	 *
	 *   - `timezone`: Defines the timezone to be used to read/write the `Date` instance in the model for
	 *     `<input type="date" />`, `<input type="time" />`, ... . It understands UTC/GMT and the
	 *     continental US time zone abbreviations, but for general use, use a time zone offset, for
	 *     example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
	 *     If not specified, the timezone of the browser will be used.
	 *     Note that changing the timezone will have no effect on the current date, and is only applied after
	 *     the next input / model change.
	 *
	 *   - `timeSecondsFormat`: Defines if the `time` and `datetime-local` types should show seconds and
	 *     milliseconds. The option follows the format string of {@link date date filter}.
	 *     By default, the options is `undefined` which is equal to `'ss.sss'` (seconds and milliseconds).
	 *     The other options are `'ss'` (strips milliseconds), and `''` (empty string), which strips both
	 *     seconds and milliseconds.
	 *     Note that browsers that support `time` and `datetime-local` require the hour and minutes
	 *     part of the time string, and may show the value differently in the user interface.
	 *     {@link ngModelOptions#formatting-the-value-of-time-and-datetime-local- See the example}.
	 *
	 *   - `timeStripZeroSeconds`: Defines if the `time` and `datetime-local` types should strip the
	 *     seconds and milliseconds from the formatted value if they are zero. This option is applied
	 *     after `timeSecondsFormat`.
	 *     This option can be used to make the formatting consistent over different browsers, as some
	 *     browsers with support for `time` will natively hide the milliseconds and
	 *     seconds if they are zero, but others won't, and browsers that don't implement these input
	 *     types will always show the full string.
	 *     {@link ngModelOptions#formatting-the-value-of-time-and-datetime-local- See the example}.
	 *
	 */
	var ngModelOptionsDirective = function() {
	  NgModelOptionsController.$inject = ['$attrs', '$scope'];
	  function NgModelOptionsController($attrs, $scope) {
	    this.$$attrs = $attrs;
	    this.$$scope = $scope;
	  }
	  NgModelOptionsController.prototype = {
	    $onInit: function() {
	      var parentOptions = this.parentCtrl ? this.parentCtrl.$options : defaultModelOptions;
	      var modelOptionsDefinition = this.$$scope.$eval(this.$$attrs.ngModelOptions);
	
	      this.$options = parentOptions.createChild(modelOptionsDefinition);
	    }
	  };
	
	  return {
	    restrict: 'A',
	    // ngModelOptions needs to run before ngModel and input directives
	    priority: 10,
	    require: {parentCtrl: '?^^ngModelOptions'},
	    bindToController: true,
	    controller: NgModelOptionsController
	  };
	};
	
	
	// shallow copy over values from `src` that are not already specified on `dst`
	function defaults(dst, src) {
	  forEach(src, function(value, key) {
	    if (!isDefined(dst[key])) {
	      dst[key] = value;
	    }
	  });
	}
	
	/**
	 * @ngdoc directive
	 * @name ngNonBindable
	 * @restrict AC
	 * @priority 1000
	 * @element ANY
	 *
	 * @description
	 * The `ngNonBindable` directive tells AngularJS not to compile or bind the contents of the current
	 * DOM element, including directives on the element itself that have a lower priority than
	 * `ngNonBindable`. This is useful if the element contains what appears to be AngularJS directives
	 * and bindings but which should be ignored by AngularJS. This could be the case if you have a site
	 * that displays snippets of code, for instance.
	 *
	 * @example
	 * In this example there are two locations where a simple interpolation binding (`{{}}`) is present,
	 * but the one wrapped in `ngNonBindable` is left alone.
	 *
	  <example name="ng-non-bindable">
	    <file name="index.html">
	      <div>Normal: {{1 + 2}}</div>
	      <div ng-non-bindable>Ignored: {{1 + 2}}</div>
	    </file>
	    <file name="protractor.js" type="protractor">
	     it('should check ng-non-bindable', function() {
	       expect(element(by.binding('1 + 2')).getText()).toContain('3');
	       expect(element.all(by.css('div')).last().getText()).toMatch(/1 \+ 2/);
	     });
	    </file>
	  </example>
	 */
	var ngNonBindableDirective = ngDirective({ terminal: true, priority: 1000 });
	
	/* exported ngOptionsDirective */
	
	/* global jqLiteRemove */
	
	var ngOptionsMinErr = minErr('ngOptions');
	
	/**
	 * @ngdoc directive
	 * @name ngOptions
	 * @restrict A
	 *
	 * @description
	 *
	 * The `ngOptions` attribute can be used to dynamically generate a list of `<option>`
	 * elements for the `<select>` element using the array or object obtained by evaluating the
	 * `ngOptions` comprehension expression.
	 *
	 * In many cases, {@link ng.directive:ngRepeat ngRepeat} can be used on `<option>` elements instead of
	 * `ngOptions` to achieve a similar result. However, `ngOptions` provides some benefits:
	 * - more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
	 * comprehension expression
	 * - reduced memory consumption by not creating a new scope for each repeated instance
	 * - increased render speed by creating the options in a documentFragment instead of individually
	 *
	 * When an item in the `<select>` menu is selected, the array element or object property
	 * represented by the selected option will be bound to the model identified by the `ngModel`
	 * directive.
	 *
	 * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
	 * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
	 * option. See example below for demonstration.
	 *
	 * ## Complex Models (objects or collections)
	 *
	 * By default, `ngModel` watches the model by reference, not value. This is important to know when
	 * binding the select to a model that is an object or a collection.
	 *
	 * One issue occurs if you want to preselect an option. For example, if you set
	 * the model to an object that is equal to an object in your collection, `ngOptions` won't be able to set the selection,
	 * because the objects are not identical. So by default, you should always reference the item in your collection
	 * for preselections, e.g.: `$scope.selected = $scope.collection[3]`.
	 *
	 * Another solution is to use a `track by` clause, because then `ngOptions` will track the identity
	 * of the item not by reference, but by the result of the `track by` expression. For example, if your
	 * collection items have an id property, you would `track by item.id`.
	 *
	 * A different issue with objects or collections is that ngModel won't detect if an object property or
	 * a collection item changes. For that reason, `ngOptions` additionally watches the model using
	 * `$watchCollection`, when the expression contains a `track by` clause or the the select has the `multiple` attribute.
	 * This allows ngOptions to trigger a re-rendering of the options even if the actual object/collection
	 * has not changed identity, but only a property on the object or an item in the collection changes.
	 *
	 * Note that `$watchCollection` does a shallow comparison of the properties of the object (or the items in the collection
	 * if the model is an array). This means that changing a property deeper than the first level inside the
	 * object/collection will not trigger a re-rendering.
	 *
	 * ## `select` **`as`**
	 *
	 * Using `select` **`as`** will bind the result of the `select` expression to the model, but
	 * the value of the `<select>` and `<option>` html elements will be either the index (for array data sources)
	 * or property name (for object data sources) of the value within the collection. If a **`track by`** expression
	 * is used, the result of that expression will be set as the value of the `option` and `select` elements.
	 *
	 *
	 * ### `select` **`as`** and **`track by`**
	 *
	 * <div class="alert alert-warning">
	 * Be careful when using `select` **`as`** and **`track by`** in the same expression.
	 * </div>
	 *
	 * Given this array of items on the $scope:
	 *
	 * ```js
	 * $scope.items = [{
	 *   id: 1,
	 *   label: 'aLabel',
	 *   subItem: { name: 'aSubItem' }
	 * }, {
	 *   id: 2,
	 *   label: 'bLabel',
	 *   subItem: { name: 'bSubItem' }
	 * }];
	 * ```
	 *
	 * This will work:
	 *
	 * ```html
	 * <select ng-options="item as item.label for item in items track by item.id" ng-model="selected"></select>
	 * ```
	 * ```js
	 * $scope.selected = $scope.items[0];
	 * ```
	 *
	 * but this will not work:
	 *
	 * ```html
	 * <select ng-options="item.subItem as item.label for item in items track by item.id" ng-model="selected"></select>
	 * ```
	 * ```js
	 * $scope.selected = $scope.items[0].subItem;
	 * ```
	 *
	 * In both examples, the **`track by`** expression is applied successfully to each `item` in the
	 * `items` array. Because the selected option has been set programmatically in the controller, the
	 * **`track by`** expression is also applied to the `ngModel` value. In the first example, the
	 * `ngModel` value is `items[0]` and the **`track by`** expression evaluates to `items[0].id` with
	 * no issue. In the second example, the `ngModel` value is `items[0].subItem` and the **`track by`**
	 * expression evaluates to `items[0].subItem.id` (which is undefined). As a result, the model value
	 * is not matched against any `<option>` and the `<select>` appears as having no selected value.
	 *
	 *
	 * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	 * @param {comprehension_expression} ngOptions in one of the following forms:
	 *
	 *   * for array data sources:
	 *     * `label` **`for`** `value` **`in`** `array`
	 *     * `select` **`as`** `label` **`for`** `value` **`in`** `array`
	 *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array`
	 *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array`
	 *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
	 *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
	 *     * `label` **`for`** `value` **`in`** `array` | orderBy:`orderexpr` **`track by`** `trackexpr`
	 *        (for including a filter with `track by`)
	 *   * for object data sources:
	 *     * `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
	 *     * `select` **`as`** `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
	 *     * `label` **`group by`** `group` **`for (`**`key`**`,`** `value`**`) in`** `object`
	 *     * `label` **`disable when`** `disable` **`for (`**`key`**`,`** `value`**`) in`** `object`
	 *     * `select` **`as`** `label` **`group by`** `group`
	 *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
	 *     * `select` **`as`** `label` **`disable when`** `disable`
	 *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
	 *
	 * Where:
	 *
	 *   * `array` / `object`: an expression which evaluates to an array / object to iterate over.
	 *   * `value`: local variable which will refer to each item in the `array` or each property value
	 *      of `object` during iteration.
	 *   * `key`: local variable which will refer to a property name in `object` during iteration.
	 *   * `label`: The result of this expression will be the label for `<option>` element. The
	 *     `expression` will most likely refer to the `value` variable (e.g. `value.propertyName`).
	 *   * `select`: The result of this expression will be bound to the model of the parent `<select>`
	 *      element. If not specified, `select` expression will default to `value`.
	 *   * `group`: The result of this expression will be used to group options using the `<optgroup>`
	 *      DOM element.
	 *   * `disable`: The result of this expression will be used to disable the rendered `<option>`
	 *      element. Return `true` to disable.
	 *   * `trackexpr`: Used when working with an array of objects. The result of this expression will be
	 *      used to identify the objects in the array. The `trackexpr` will most likely refer to the
	 *     `value` variable (e.g. `value.propertyName`). With this the selection is preserved
	 *      even when the options are recreated (e.g. reloaded from the server).
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} required The control is considered valid only if value is entered.
	 * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	 *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	 *    `required` when you want to data-bind to the `required` attribute.
	 * @param {string=} ngAttrSize sets the size of the select element dynamically. Uses the
	 * {@link guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes ngAttr} directive.
	 *
	 * @example
	    <example module="selectExample" name="select">
	      <file name="index.html">
	        <script>
	        angular.module('selectExample', [])
	          .controller('ExampleController', ['$scope', function($scope) {
	            $scope.colors = [
	              {name:'black', shade:'dark'},
	              {name:'white', shade:'light', notAnOption: true},
	              {name:'red', shade:'dark'},
	              {name:'blue', shade:'dark', notAnOption: true},
	              {name:'yellow', shade:'light', notAnOption: false}
	            ];
	            $scope.myColor = $scope.colors[2]; // red
	          }]);
	        </script>
	        <div ng-controller="ExampleController">
	          <ul>
	            <li ng-repeat="color in colors">
	              <label>Name: <input ng-model="color.name"></label>
	              <label><input type="checkbox" ng-model="color.notAnOption"> Disabled?</label>
	              <button ng-click="colors.splice($index, 1)" aria-label="Remove">X</button>
	            </li>
	            <li>
	              <button ng-click="colors.push({})">add</button>
	            </li>
	          </ul>
	          <hr/>
	          <label>Color (null not allowed):
	            <select ng-model="myColor" ng-options="color.name for color in colors"></select>
	          </label><br/>
	          <label>Color (null allowed):
	          <span  class="nullable">
	            <select ng-model="myColor" ng-options="color.name for color in colors">
	              <option value="">-- choose color --</option>
	            </select>
	          </span></label><br/>
	
	          <label>Color grouped by shade:
	            <select ng-model="myColor" ng-options="color.name group by color.shade for color in colors">
	            </select>
	          </label><br/>
	
	          <label>Color grouped by shade, with some disabled:
	            <select ng-model="myColor"
	                  ng-options="color.name group by color.shade disable when color.notAnOption for color in colors">
	            </select>
	          </label><br/>
	
	
	
	          Select <button ng-click="myColor = { name:'not in list', shade: 'other' }">bogus</button>.
	          <br/>
	          <hr/>
	          Currently selected: {{ {selected_color:myColor} }}
	          <div style="border:solid 1px black; height:20px"
	               ng-style="{'background-color':myColor.name}">
	          </div>
	        </div>
	      </file>
	      <file name="protractor.js" type="protractor">
	         it('should check ng-options', function() {
	           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('red');
	           element.all(by.model('myColor')).first().click();
	           element.all(by.css('select[ng-model="myColor"] option')).first().click();
	           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('black');
	           element(by.css('.nullable select[ng-model="myColor"]')).click();
	           element.all(by.css('.nullable select[ng-model="myColor"] option')).first().click();
	           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('null');
	         });
	      </file>
	    </example>
	 */
	
	/* eslint-disable max-len */
	//                     //00001111111111000000000002222222222000000000000000000000333333333300000000000000000000000004444444444400000000000005555555555555000000000666666666666600000007777777777777000000000000000888888888800000000000000000009999999999
	var NG_OPTIONS_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+group\s+by\s+([\s\S]+?))?(?:\s+disable\s+when\s+([\s\S]+?))?\s+for\s+(?:([$\w][$\w]*)|(?:\(\s*([$\w][$\w]*)\s*,\s*([$\w][$\w]*)\s*\)))\s+in\s+([\s\S]+?)(?:\s+track\s+by\s+([\s\S]+?))?$/;
	                        // 1: value expression (valueFn)
	                        // 2: label expression (displayFn)
	                        // 3: group by expression (groupByFn)
	                        // 4: disable when expression (disableWhenFn)
	                        // 5: array item variable name
	                        // 6: object item key variable name
	                        // 7: object item value variable name
	                        // 8: collection expression
	                        // 9: track by expression
	/* eslint-enable */
	
	
	var ngOptionsDirective = ['$compile', '$document', '$parse', function($compile, $document, $parse) {
	
	  function parseOptionsExpression(optionsExp, selectElement, scope) {
	
	    var match = optionsExp.match(NG_OPTIONS_REGEXP);
	    if (!(match)) {
	      throw ngOptionsMinErr('iexp',
	        'Expected expression in form of ' +
	        '\'_select_ (as _label_)? for (_key_,)?_value_ in _collection_\'' +
	        ' but got \'{0}\'. Element: {1}',
	        optionsExp, startingTag(selectElement));
	    }
	
	    // Extract the parts from the ngOptions expression
	
	    // The variable name for the value of the item in the collection
	    var valueName = match[5] || match[7];
	    // The variable name for the key of the item in the collection
	    var keyName = match[6];
	
	    // An expression that generates the viewValue for an option if there is a label expression
	    var selectAs = / as /.test(match[0]) && match[1];
	    // An expression that is used to track the id of each object in the options collection
	    var trackBy = match[9];
	    // An expression that generates the viewValue for an option if there is no label expression
	    var valueFn = $parse(match[2] ? match[1] : valueName);
	    var selectAsFn = selectAs && $parse(selectAs);
	    var viewValueFn = selectAsFn || valueFn;
	    var trackByFn = trackBy && $parse(trackBy);
	
	    // Get the value by which we are going to track the option
	    // if we have a trackFn then use that (passing scope and locals)
	    // otherwise just hash the given viewValue
	    var getTrackByValueFn = trackBy ?
	                              function(value, locals) { return trackByFn(scope, locals); } :
	                              function getHashOfValue(value) { return hashKey(value); };
	    var getTrackByValue = function(value, key) {
	      return getTrackByValueFn(value, getLocals(value, key));
	    };
	
	    var displayFn = $parse(match[2] || match[1]);
	    var groupByFn = $parse(match[3] || '');
	    var disableWhenFn = $parse(match[4] || '');
	    var valuesFn = $parse(match[8]);
	
	    var locals = {};
	    var getLocals = keyName ? function(value, key) {
	      locals[keyName] = key;
	      locals[valueName] = value;
	      return locals;
	    } : function(value) {
	      locals[valueName] = value;
	      return locals;
	    };
	
	
	    function Option(selectValue, viewValue, label, group, disabled) {
	      this.selectValue = selectValue;
	      this.viewValue = viewValue;
	      this.label = label;
	      this.group = group;
	      this.disabled = disabled;
	    }
	
	    function getOptionValuesKeys(optionValues) {
	      var optionValuesKeys;
	
	      if (!keyName && isArrayLike(optionValues)) {
	        optionValuesKeys = optionValues;
	      } else {
	        // if object, extract keys, in enumeration order, unsorted
	        optionValuesKeys = [];
	        for (var itemKey in optionValues) {
	          if (optionValues.hasOwnProperty(itemKey) && itemKey.charAt(0) !== '$') {
	            optionValuesKeys.push(itemKey);
	          }
	        }
	      }
	      return optionValuesKeys;
	    }
	
	    return {
	      trackBy: trackBy,
	      getTrackByValue: getTrackByValue,
	      getWatchables: $parse(valuesFn, function(optionValues) {
	        // Create a collection of things that we would like to watch (watchedArray)
	        // so that they can all be watched using a single $watchCollection
	        // that only runs the handler once if anything changes
	        var watchedArray = [];
	        optionValues = optionValues || [];
	
	        var optionValuesKeys = getOptionValuesKeys(optionValues);
	        var optionValuesLength = optionValuesKeys.length;
	        for (var index = 0; index < optionValuesLength; index++) {
	          var key = (optionValues === optionValuesKeys) ? index : optionValuesKeys[index];
	          var value = optionValues[key];
	
	          var locals = getLocals(value, key);
	          var selectValue = getTrackByValueFn(value, locals);
	          watchedArray.push(selectValue);
	
	          // Only need to watch the displayFn if there is a specific label expression
	          if (match[2] || match[1]) {
	            var label = displayFn(scope, locals);
	            watchedArray.push(label);
	          }
	
	          // Only need to watch the disableWhenFn if there is a specific disable expression
	          if (match[4]) {
	            var disableWhen = disableWhenFn(scope, locals);
	            watchedArray.push(disableWhen);
	          }
	        }
	        return watchedArray;
	      }),
	
	      getOptions: function() {
	
	        var optionItems = [];
	        var selectValueMap = {};
	
	        // The option values were already computed in the `getWatchables` fn,
	        // which must have been called to trigger `getOptions`
	        var optionValues = valuesFn(scope) || [];
	        var optionValuesKeys = getOptionValuesKeys(optionValues);
	        var optionValuesLength = optionValuesKeys.length;
	
	        for (var index = 0; index < optionValuesLength; index++) {
	          var key = (optionValues === optionValuesKeys) ? index : optionValuesKeys[index];
	          var value = optionValues[key];
	          var locals = getLocals(value, key);
	          var viewValue = viewValueFn(scope, locals);
	          var selectValue = getTrackByValueFn(viewValue, locals);
	          var label = displayFn(scope, locals);
	          var group = groupByFn(scope, locals);
	          var disabled = disableWhenFn(scope, locals);
	          var optionItem = new Option(selectValue, viewValue, label, group, disabled);
	
	          optionItems.push(optionItem);
	          selectValueMap[selectValue] = optionItem;
	        }
	
	        return {
	          items: optionItems,
	          selectValueMap: selectValueMap,
	          getOptionFromViewValue: function(value) {
	            return selectValueMap[getTrackByValue(value)];
	          },
	          getViewValueFromOption: function(option) {
	            // If the viewValue could be an object that may be mutated by the application,
	            // we need to make a copy and not return the reference to the value on the option.
	            return trackBy ? copy(option.viewValue) : option.viewValue;
	          }
	        };
	      }
	    };
	  }
	
	
	  // Support: IE 9 only
	  // We can't just jqLite('<option>') since jqLite is not smart enough
	  // to create it in <select> and IE barfs otherwise.
	  var optionTemplate = window.document.createElement('option'),
	      optGroupTemplate = window.document.createElement('optgroup');
	
	    function ngOptionsPostLink(scope, selectElement, attr, ctrls) {
	
	      var selectCtrl = ctrls[0];
	      var ngModelCtrl = ctrls[1];
	      var multiple = attr.multiple;
	
	      // The emptyOption allows the application developer to provide their own custom "empty"
	      // option when the viewValue does not match any of the option values.
	      for (var i = 0, children = selectElement.children(), ii = children.length; i < ii; i++) {
	        if (children[i].value === '') {
	          selectCtrl.hasEmptyOption = true;
	          selectCtrl.emptyOption = children.eq(i);
	          break;
	        }
	      }
	
	      // The empty option will be compiled and rendered before we first generate the options
	      selectElement.empty();
	
	      var providedEmptyOption = !!selectCtrl.emptyOption;
	
	      var unknownOption = jqLite(optionTemplate.cloneNode(false));
	      unknownOption.val('?');
	
	      var options;
	      var ngOptions = parseOptionsExpression(attr.ngOptions, selectElement, scope);
	      // This stores the newly created options before they are appended to the select.
	      // Since the contents are removed from the fragment when it is appended,
	      // we only need to create it once.
	      var listFragment = $document[0].createDocumentFragment();
	
	      // Overwrite the implementation. ngOptions doesn't use hashes
	      selectCtrl.generateUnknownOptionValue = function(val) {
	        return '?';
	      };
	
	      // Update the controller methods for multiple selectable options
	      if (!multiple) {
	
	        selectCtrl.writeValue = function writeNgOptionsValue(value) {
	          // The options might not be defined yet when ngModel tries to render
	          if (!options) return;
	
	          var selectedOption = selectElement[0].options[selectElement[0].selectedIndex];
	          var option = options.getOptionFromViewValue(value);
	
	          // Make sure to remove the selected attribute from the previously selected option
	          // Otherwise, screen readers might get confused
	          if (selectedOption) selectedOption.removeAttribute('selected');
	
	          if (option) {
	            // Don't update the option when it is already selected.
	            // For example, the browser will select the first option by default. In that case,
	            // most properties are set automatically - except the `selected` attribute, which we
	            // set always
	
	            if (selectElement[0].value !== option.selectValue) {
	              selectCtrl.removeUnknownOption();
	
	              selectElement[0].value = option.selectValue;
	              option.element.selected = true;
	            }
	
	            option.element.setAttribute('selected', 'selected');
	          } else {
	            selectCtrl.selectUnknownOrEmptyOption(value);
	          }
	        };
	
	        selectCtrl.readValue = function readNgOptionsValue() {
	
	          var selectedOption = options.selectValueMap[selectElement.val()];
	
	          if (selectedOption && !selectedOption.disabled) {
	            selectCtrl.unselectEmptyOption();
	            selectCtrl.removeUnknownOption();
	            return options.getViewValueFromOption(selectedOption);
	          }
	          return null;
	        };
	
	        // If we are using `track by` then we must watch the tracked value on the model
	        // since ngModel only watches for object identity change
	        // FIXME: When a user selects an option, this watch will fire needlessly
	        if (ngOptions.trackBy) {
	          scope.$watch(
	            function() { return ngOptions.getTrackByValue(ngModelCtrl.$viewValue); },
	            function() { ngModelCtrl.$render(); }
	          );
	        }
	
	      } else {
	
	        selectCtrl.writeValue = function writeNgOptionsMultiple(values) {
	          // The options might not be defined yet when ngModel tries to render
	          if (!options) return;
	
	          // Only set `<option>.selected` if necessary, in order to prevent some browsers from
	          // scrolling to `<option>` elements that are outside the `<select>` element's viewport.
	          var selectedOptions = values && values.map(getAndUpdateSelectedOption) || [];
	
	          options.items.forEach(function(option) {
	            if (option.element.selected && !includes(selectedOptions, option)) {
	              option.element.selected = false;
	            }
	          });
	        };
	
	
	        selectCtrl.readValue = function readNgOptionsMultiple() {
	          var selectedValues = selectElement.val() || [],
	              selections = [];
	
	          forEach(selectedValues, function(value) {
	            var option = options.selectValueMap[value];
	            if (option && !option.disabled) selections.push(options.getViewValueFromOption(option));
	          });
	
	          return selections;
	        };
	
	        // If we are using `track by` then we must watch these tracked values on the model
	        // since ngModel only watches for object identity change
	        if (ngOptions.trackBy) {
	
	          scope.$watchCollection(function() {
	            if (isArray(ngModelCtrl.$viewValue)) {
	              return ngModelCtrl.$viewValue.map(function(value) {
	                return ngOptions.getTrackByValue(value);
	              });
	            }
	          }, function() {
	            ngModelCtrl.$render();
	          });
	
	        }
	      }
	
	      if (providedEmptyOption) {
	
	        // compile the element since there might be bindings in it
	        $compile(selectCtrl.emptyOption)(scope);
	
	        selectElement.prepend(selectCtrl.emptyOption);
	
	        if (selectCtrl.emptyOption[0].nodeType === NODE_TYPE_COMMENT) {
	          // This means the empty option has currently no actual DOM node, probably because
	          // it has been modified by a transclusion directive.
	          selectCtrl.hasEmptyOption = false;
	
	          // Redefine the registerOption function, which will catch
	          // options that are added by ngIf etc. (rendering of the node is async because of
	          // lazy transclusion)
	          selectCtrl.registerOption = function(optionScope, optionEl) {
	            if (optionEl.val() === '') {
	              selectCtrl.hasEmptyOption = true;
	              selectCtrl.emptyOption = optionEl;
	              selectCtrl.emptyOption.removeClass('ng-scope');
	              // This ensures the new empty option is selected if previously no option was selected
	              ngModelCtrl.$render();
	
	              optionEl.on('$destroy', function() {
	                var needsRerender = selectCtrl.$isEmptyOptionSelected();
	
	                selectCtrl.hasEmptyOption = false;
	                selectCtrl.emptyOption = undefined;
	
	                if (needsRerender) ngModelCtrl.$render();
	              });
	            }
	          };
	
	        } else {
	          // remove the class, which is added automatically because we recompile the element and it
	          // becomes the compilation root
	          selectCtrl.emptyOption.removeClass('ng-scope');
	        }
	
	      }
	
	      // We will re-render the option elements if the option values or labels change
	      scope.$watchCollection(ngOptions.getWatchables, updateOptions);
	
	      // ------------------------------------------------------------------ //
	
	      function addOptionElement(option, parent) {
	        var optionElement = optionTemplate.cloneNode(false);
	        parent.appendChild(optionElement);
	        updateOptionElement(option, optionElement);
	      }
	
	      function getAndUpdateSelectedOption(viewValue) {
	        var option = options.getOptionFromViewValue(viewValue);
	        var element = option && option.element;
	
	        if (element && !element.selected) element.selected = true;
	
	        return option;
	      }
	
	      function updateOptionElement(option, element) {
	        option.element = element;
	        element.disabled = option.disabled;
	        // Support: IE 11 only, Edge 12-13 only
	        // NOTE: The label must be set before the value, otherwise IE 11 & Edge create unresponsive
	        // selects in certain circumstances when multiple selects are next to each other and display
	        // the option list in listbox style, i.e. the select is [multiple], or specifies a [size].
	        // See https://github.com/angular/angular.js/issues/11314 for more info.
	        // This is unfortunately untestable with unit / e2e tests
	        if (option.label !== element.label) {
	          element.label = option.label;
	          element.textContent = option.label;
	        }
	        element.value = option.selectValue;
	      }
	
	      function updateOptions() {
	        var previousValue = options && selectCtrl.readValue();
	
	        // We must remove all current options, but cannot simply set innerHTML = null
	        // since the providedEmptyOption might have an ngIf on it that inserts comments which we
	        // must preserve.
	        // Instead, iterate over the current option elements and remove them or their optgroup
	        // parents
	        if (options) {
	
	          for (var i = options.items.length - 1; i >= 0; i--) {
	            var option = options.items[i];
	            if (isDefined(option.group)) {
	              jqLiteRemove(option.element.parentNode);
	            } else {
	              jqLiteRemove(option.element);
	            }
	          }
	        }
	
	        options = ngOptions.getOptions();
	
	        var groupElementMap = {};
	
	        options.items.forEach(function addOption(option) {
	          var groupElement;
	
	          if (isDefined(option.group)) {
	
	            // This option is to live in a group
	            // See if we have already created this group
	            groupElement = groupElementMap[option.group];
	
	            if (!groupElement) {
	
	              groupElement = optGroupTemplate.cloneNode(false);
	              listFragment.appendChild(groupElement);
	
	              // Update the label on the group element
	              // "null" is special cased because of Safari
	              groupElement.label = option.group === null ? 'null' : option.group;
	
	              // Store it for use later
	              groupElementMap[option.group] = groupElement;
	            }
	
	            addOptionElement(option, groupElement);
	
	          } else {
	
	            // This option is not in a group
	            addOptionElement(option, listFragment);
	          }
	        });
	
	        selectElement[0].appendChild(listFragment);
	
	        ngModelCtrl.$render();
	
	        // Check to see if the value has changed due to the update to the options
	        if (!ngModelCtrl.$isEmpty(previousValue)) {
	          var nextValue = selectCtrl.readValue();
	          var isNotPrimitive = ngOptions.trackBy || multiple;
	          if (isNotPrimitive ? !equals(previousValue, nextValue) : previousValue !== nextValue) {
	            ngModelCtrl.$setViewValue(nextValue);
	            ngModelCtrl.$render();
	          }
	        }
	      }
	  }
	
	  return {
	    restrict: 'A',
	    terminal: true,
	    require: ['select', 'ngModel'],
	    link: {
	      pre: function ngOptionsPreLink(scope, selectElement, attr, ctrls) {
	        // Deactivate the SelectController.register method to prevent
	        // option directives from accidentally registering themselves
	        // (and unwanted $destroy handlers etc.)
	        ctrls[0].registerOption = noop;
	      },
	      post: ngOptionsPostLink
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngPluralize
	 * @restrict EA
	 *
	 * @description
	 * `ngPluralize` is a directive that displays messages according to en-US localization rules.
	 * These rules are bundled with angular.js, but can be overridden
	 * (see {@link guide/i18n AngularJS i18n} dev guide). You configure ngPluralize directive
	 * by specifying the mappings between
	 * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
	 * and the strings to be displayed.
	 *
	 * ## Plural categories and explicit number rules
	 * There are two
	 * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
	 * in AngularJS's default en-US locale: "one" and "other".
	 *
	 * While a plural category may match many numbers (for example, in en-US locale, "other" can match
	 * any number that is not 1), an explicit number rule can only match one number. For example, the
	 * explicit number rule for "3" matches the number 3. There are examples of plural categories
	 * and explicit number rules throughout the rest of this documentation.
	 *
	 * ## Configuring ngPluralize
	 * You configure ngPluralize by providing 2 attributes: `count` and `when`.
	 * You can also provide an optional attribute, `offset`.
	 *
	 * The value of the `count` attribute can be either a string or an {@link guide/expression
	 * AngularJS expression}; these are evaluated on the current scope for its bound value.
	 *
	 * The `when` attribute specifies the mappings between plural categories and the actual
	 * string to be displayed. The value of the attribute should be a JSON object.
	 *
	 * The following example shows how to configure ngPluralize:
	 *
	 * ```html
	 * <ng-pluralize count="personCount"
	                 when="{'0': 'Nobody is viewing.',
	 *                      'one': '1 person is viewing.',
	 *                      'other': '{} people are viewing.'}">
	 * </ng-pluralize>
	 *```
	 *
	 * In the example, `"0: Nobody is viewing."` is an explicit number rule. If you did not
	 * specify this rule, 0 would be matched to the "other" category and "0 people are viewing"
	 * would be shown instead of "Nobody is viewing". You can specify an explicit number rule for
	 * other numbers, for example 12, so that instead of showing "12 people are viewing", you can
	 * show "a dozen people are viewing".
	 *
	 * You can use a set of closed braces (`{}`) as a placeholder for the number that you want substituted
	 * into pluralized strings. In the previous example, AngularJS will replace `{}` with
	 * <span ng-non-bindable>`{{personCount}}`</span>. The closed braces `{}` is a placeholder
	 * for <span ng-non-bindable>{{numberExpression}}</span>.
	 *
	 * If no rule is defined for a category, then an empty string is displayed and a warning is generated.
	 * Note that some locales define more categories than `one` and `other`. For example, fr-fr defines `few` and `many`.
	 *
	 * ## Configuring ngPluralize with offset
	 * The `offset` attribute allows further customization of pluralized text, which can result in
	 * a better user experience. For example, instead of the message "4 people are viewing this document",
	 * you might display "John, Kate and 2 others are viewing this document".
	 * The offset attribute allows you to offset a number by any desired value.
	 * Let's take a look at an example:
	 *
	 * ```html
	 * <ng-pluralize count="personCount" offset=2
	 *               when="{'0': 'Nobody is viewing.',
	 *                      '1': '{{person1}} is viewing.',
	 *                      '2': '{{person1}} and {{person2}} are viewing.',
	 *                      'one': '{{person1}}, {{person2}} and one other person are viewing.',
	 *                      'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
	 * </ng-pluralize>
	 * ```
	 *
	 * Notice that we are still using two plural categories(one, other), but we added
	 * three explicit number rules 0, 1 and 2.
	 * When one person, perhaps John, views the document, "John is viewing" will be shown.
	 * When three people view the document, no explicit number rule is found, so
	 * an offset of 2 is taken off 3, and AngularJS uses 1 to decide the plural category.
	 * In this case, plural category 'one' is matched and "John, Mary and one other person are viewing"
	 * is shown.
	 *
	 * Note that when you specify offsets, you must provide explicit number rules for
	 * numbers from 0 up to and including the offset. If you use an offset of 3, for example,
	 * you must provide explicit number rules for 0, 1, 2 and 3. You must also provide plural strings for
	 * plural categories "one" and "other".
	 *
	 * @param {string|expression} count The variable to be bound to.
	 * @param {string} when The mapping between plural category to its corresponding strings.
	 * @param {number=} offset Offset to deduct from the total number.
	 *
	 * @example
	    <example module="pluralizeExample" name="ng-pluralize">
	      <file name="index.html">
	        <script>
	          angular.module('pluralizeExample', [])
	            .controller('ExampleController', ['$scope', function($scope) {
	              $scope.person1 = 'Igor';
	              $scope.person2 = 'Misko';
	              $scope.personCount = 1;
	            }]);
	        </script>
	        <div ng-controller="ExampleController">
	          <label>Person 1:<input type="text" ng-model="person1" value="Igor" /></label><br/>
	          <label>Person 2:<input type="text" ng-model="person2" value="Misko" /></label><br/>
	          <label>Number of People:<input type="text" ng-model="personCount" value="1" /></label><br/>
	
	          <!--- Example with simple pluralization rules for en locale --->
	          Without Offset:
	          <ng-pluralize count="personCount"
	                        when="{'0': 'Nobody is viewing.',
	                               'one': '1 person is viewing.',
	                               'other': '{} people are viewing.'}">
	          </ng-pluralize><br>
	
	          <!--- Example with offset --->
	          With Offset(2):
	          <ng-pluralize count="personCount" offset=2
	                        when="{'0': 'Nobody is viewing.',
	                               '1': '{{person1}} is viewing.',
	                               '2': '{{person1}} and {{person2}} are viewing.',
	                               'one': '{{person1}}, {{person2}} and one other person are viewing.',
	                               'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
	          </ng-pluralize>
	        </div>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should show correct pluralized string', function() {
	          var withoutOffset = element.all(by.css('ng-pluralize')).get(0);
	          var withOffset = element.all(by.css('ng-pluralize')).get(1);
	          var countInput = element(by.model('personCount'));
	
	          expect(withoutOffset.getText()).toEqual('1 person is viewing.');
	          expect(withOffset.getText()).toEqual('Igor is viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('0');
	
	          expect(withoutOffset.getText()).toEqual('Nobody is viewing.');
	          expect(withOffset.getText()).toEqual('Nobody is viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('2');
	
	          expect(withoutOffset.getText()).toEqual('2 people are viewing.');
	          expect(withOffset.getText()).toEqual('Igor and Misko are viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('3');
	
	          expect(withoutOffset.getText()).toEqual('3 people are viewing.');
	          expect(withOffset.getText()).toEqual('Igor, Misko and one other person are viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('4');
	
	          expect(withoutOffset.getText()).toEqual('4 people are viewing.');
	          expect(withOffset.getText()).toEqual('Igor, Misko and 2 other people are viewing.');
	        });
	        it('should show data-bound names', function() {
	          var withOffset = element.all(by.css('ng-pluralize')).get(1);
	          var personCount = element(by.model('personCount'));
	          var person1 = element(by.model('person1'));
	          var person2 = element(by.model('person2'));
	          personCount.clear();
	          personCount.sendKeys('4');
	          person1.clear();
	          person1.sendKeys('Di');
	          person2.clear();
	          person2.sendKeys('Vojta');
	          expect(withOffset.getText()).toEqual('Di, Vojta and 2 other people are viewing.');
	        });
	      </file>
	    </example>
	 */
	var ngPluralizeDirective = ['$locale', '$interpolate', '$log', function($locale, $interpolate, $log) {
	  var BRACE = /{}/g,
	      IS_WHEN = /^when(Minus)?(.+)$/;
	
	  return {
	    link: function(scope, element, attr) {
	      var numberExp = attr.count,
	          whenExp = attr.$attr.when && element.attr(attr.$attr.when), // we have {{}} in attrs
	          offset = attr.offset || 0,
	          whens = scope.$eval(whenExp) || {},
	          whensExpFns = {},
	          startSymbol = $interpolate.startSymbol(),
	          endSymbol = $interpolate.endSymbol(),
	          braceReplacement = startSymbol + numberExp + '-' + offset + endSymbol,
	          watchRemover = angular.noop,
	          lastCount;
	
	      forEach(attr, function(expression, attributeName) {
	        var tmpMatch = IS_WHEN.exec(attributeName);
	        if (tmpMatch) {
	          var whenKey = (tmpMatch[1] ? '-' : '') + lowercase(tmpMatch[2]);
	          whens[whenKey] = element.attr(attr.$attr[attributeName]);
	        }
	      });
	      forEach(whens, function(expression, key) {
	        whensExpFns[key] = $interpolate(expression.replace(BRACE, braceReplacement));
	
	      });
	
	      scope.$watch(numberExp, function ngPluralizeWatchAction(newVal) {
	        var count = parseFloat(newVal);
	        var countIsNaN = isNumberNaN(count);
	
	        if (!countIsNaN && !(count in whens)) {
	          // If an explicit number rule such as 1, 2, 3... is defined, just use it.
	          // Otherwise, check it against pluralization rules in $locale service.
	          count = $locale.pluralCat(count - offset);
	        }
	
	        // If both `count` and `lastCount` are NaN, we don't need to re-register a watch.
	        // In JS `NaN !== NaN`, so we have to explicitly check.
	        if ((count !== lastCount) && !(countIsNaN && isNumberNaN(lastCount))) {
	          watchRemover();
	          var whenExpFn = whensExpFns[count];
	          if (isUndefined(whenExpFn)) {
	            if (newVal != null) {
	              $log.debug('ngPluralize: no rule defined for \'' + count + '\' in ' + whenExp);
	            }
	            watchRemover = noop;
	            updateElementText();
	          } else {
	            watchRemover = scope.$watch(whenExpFn, updateElementText);
	          }
	          lastCount = count;
	        }
	      });
	
	      function updateElementText(newText) {
	        element.text(newText || '');
	      }
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngRef
	 * @restrict A
	 *
	 * @description
	 * The `ngRef` attribute tells AngularJS to assign the controller of a component (or a directive)
	 * to the given property in the current scope. It is also possible to add the jqlite-wrapped DOM
	 * element to the scope.
	 *
	 * If the element with `ngRef` is destroyed `null` is assigned to the property.
	 *
	 * Note that if you want to assign from a child into the parent scope, you must initialize the
	 * target property on the parent scope, otherwise `ngRef` will assign on the child scope.
	 * This commonly happens when assigning elements or components wrapped in {@link ngIf} or
	 * {@link ngRepeat}. See the second example below.
	 *
	 *
	 * @element ANY
	 * @param {string} ngRef property name - A valid AngularJS expression identifier to which the
	 *                       controller or jqlite-wrapped DOM element will be bound.
	 * @param {string=} ngRefRead read value - The name of a directive (or component) on this element,
	 *                            or the special string `$element`. If a name is provided, `ngRef` will
	 *                            assign the matching controller. If `$element` is provided, the element
	 *                            itself is assigned (even if a controller is available).
	 *
	 *
	 * @example
	 * ### Simple toggle
	 * This example shows how the controller of the component toggle
	 * is reused in the template through the scope to use its logic.
	 * <example name="ng-ref-component" module="myApp">
	 *   <file name="index.html">
	 *     <my-toggle ng-ref="myToggle"></my-toggle>
	 *     <button ng-click="myToggle.toggle()">Toggle</button>
	 *     <div ng-show="myToggle.isOpen()">
	 *       You are using a component in the same template to show it.
	 *     </div>
	 *   </file>
	 *   <file name="index.js">
	 *     angular.module('myApp', [])
	 *     .component('myToggle', {
	 *       controller: function ToggleController() {
	 *         var opened = false;
	 *         this.isOpen = function() { return opened; };
	 *         this.toggle = function() { opened = !opened; };
	 *       }
	 *     });
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *      it('should publish the toggle into the scope', function() {
	 *        var toggle = element(by.buttonText('Toggle'));
	 *        expect(toggle.evaluate('myToggle.isOpen()')).toEqual(false);
	 *        toggle.click();
	 *        expect(toggle.evaluate('myToggle.isOpen()')).toEqual(true);
	 *      });
	 *   </file>
	 * </example>
	 *
	 * @example
	 * ### ngRef inside scopes
	 * This example shows how `ngRef` works with child scopes. The `ngRepeat`-ed `myWrapper` components
	 * are assigned to the scope of `myRoot`, because the `toggles` property has been initialized.
	 * The repeated `myToggle` components are published to the child scopes created by `ngRepeat`.
	 * `ngIf` behaves similarly - the assignment of `myToggle` happens in the `ngIf` child scope,
	 * because the target property has not been initialized on the `myRoot` component controller.
	 *
	 * <example name="ng-ref-scopes" module="myApp">
	 *   <file name="index.html">
	 *     <my-root></my-root>
	 *   </file>
	 *   <file name="index.js">
	 *     angular.module('myApp', [])
	 *     .component('myRoot', {
	 *       templateUrl: 'root.html',
	 *       controller: function() {
	 *         this.wrappers = []; // initialize the array so that the wrappers are assigned into the parent scope
	 *       }
	 *     })
	 *     .component('myToggle', {
	 *       template: '<strong>myToggle</strong><button ng-click="$ctrl.toggle()" ng-transclude></button>',
	 *       transclude: true,
	 *       controller: function ToggleController() {
	 *         var opened = false;
	 *         this.isOpen = function() { return opened; };
	 *         this.toggle = function() { opened = !opened; };
	 *       }
	 *     })
	 *     .component('myWrapper', {
	 *       transclude: true,
	 *       template: '<strong>myWrapper</strong>' +
	 *         '<div>ngRepeatToggle.isOpen(): {{$ctrl.ngRepeatToggle.isOpen() | json}}</div>' +
	 *         '<my-toggle ng-ref="$ctrl.ngRepeatToggle"><ng-transclude></ng-transclude></my-toggle>'
	 *     });
	 *   </file>
	 *   <file name="root.html">
	 *     <strong>myRoot</strong>
	 *     <my-toggle ng-ref="$ctrl.outerToggle">Outer Toggle</my-toggle>
	 *     <div>outerToggle.isOpen(): {{$ctrl.outerToggle.isOpen() | json}}</div>
	 *     <div><em>wrappers assigned to root</em><br>
	 *     <div ng-repeat="wrapper in $ctrl.wrappers">
	 *       wrapper.ngRepeatToggle.isOpen(): {{wrapper.ngRepeatToggle.isOpen() | json}}
	 *     </div>
	 *
	 *     <ul>
	 *       <li ng-repeat="(index, value) in [1,2,3]">
	 *         <strong>ngRepeat</strong>
	 *         <div>outerToggle.isOpen(): {{$ctrl.outerToggle.isOpen() | json}}</div>
	 *         <my-wrapper ng-ref="$ctrl.wrappers[index]">ngRepeat Toggle {{$index + 1}}</my-wrapper>
	 *       </li>
	 *     </ul>
	 *
	 *     <div>ngIfToggle.isOpen(): {{ngIfToggle.isOpen()}} // This is always undefined because it's
	 *       assigned to the child scope created by ngIf.
	 *     </div>
	 *     <div ng-if="true">
	          <strong>ngIf</strong>
	 *        <my-toggle ng-ref="ngIfToggle">ngIf Toggle</my-toggle>
	 *        <div>ngIfToggle.isOpen(): {{ngIfToggle.isOpen() | json}}</div>
	 *        <div>outerToggle.isOpen(): {{$ctrl.outerToggle.isOpen() | json}}</div>
	 *     </div>
	 *   </file>
	 *   <file name="styles.css">
	 *     ul {
	 *       list-style: none;
	 *       padding-left: 0;
	 *     }
	 *
	 *     li[ng-repeat] {
	 *       background: lightgreen;
	 *       padding: 8px;
	 *       margin: 8px;
	 *     }
	 *
	 *     [ng-if] {
	 *       background: lightgrey;
	 *       padding: 8px;
	 *     }
	 *
	 *     my-root {
	 *       background: lightgoldenrodyellow;
	 *       padding: 8px;
	 *       display: block;
	 *     }
	 *
	 *     my-wrapper {
	 *       background: lightsalmon;
	 *       padding: 8px;
	 *       display: block;
	 *     }
	 *
	 *     my-toggle {
	 *       background: lightblue;
	 *       padding: 8px;
	 *       display: block;
	 *     }
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *      var OuterToggle = function() {
	 *        this.toggle = function() {
	 *          element(by.buttonText('Outer Toggle')).click();
	 *        };
	 *        this.isOpen = function() {
	 *          return element.all(by.binding('outerToggle.isOpen()')).first().getText();
	 *        };
	 *      };
	 *      var NgRepeatToggle = function(i) {
	 *        var parent = element.all(by.repeater('(index, value) in [1,2,3]')).get(i - 1);
	 *        this.toggle = function() {
	 *          element(by.buttonText('ngRepeat Toggle ' + i)).click();
	 *        };
	 *        this.isOpen = function() {
	 *          return parent.element(by.binding('ngRepeatToggle.isOpen() | json')).getText();
	 *        };
	 *        this.isOuterOpen = function() {
	 *          return parent.element(by.binding('outerToggle.isOpen() | json')).getText();
	 *        };
	 *      };
	 *      var NgRepeatToggles = function() {
	 *        var toggles = [1,2,3].map(function(i) { return new NgRepeatToggle(i); });
	 *        this.forEach = function(fn) {
	 *          toggles.forEach(fn);
	 *        };
	 *        this.isOuterOpen = function(i) {
	 *          return toggles[i - 1].isOuterOpen();
	 *        };
	 *      };
	 *      var NgIfToggle = function() {
	 *        var parent = element(by.css('[ng-if]'));
	 *        this.toggle = function() {
	 *          element(by.buttonText('ngIf Toggle')).click();
	 *        };
	 *        this.isOpen = function() {
	 *          return by.binding('ngIfToggle.isOpen() | json').getText();
	 *        };
	 *        this.isOuterOpen = function() {
	 *          return parent.element(by.binding('outerToggle.isOpen() | json')).getText();
	 *        };
	 *      };
	 *
	 *      it('should toggle the outer toggle', function() {
	 *        var outerToggle = new OuterToggle();
	 *        expect(outerToggle.isOpen()).toEqual('outerToggle.isOpen(): false');
	 *        outerToggle.toggle();
	 *        expect(outerToggle.isOpen()).toEqual('outerToggle.isOpen(): true');
	 *      });
	 *
	 *      it('should toggle all outer toggles', function() {
	 *        var outerToggle = new OuterToggle();
	 *        var repeatToggles = new NgRepeatToggles();
	 *        var ifToggle = new NgIfToggle();
	 *        expect(outerToggle.isOpen()).toEqual('outerToggle.isOpen(): false');
	 *        expect(repeatToggles.isOuterOpen(1)).toEqual('outerToggle.isOpen(): false');
	 *        expect(repeatToggles.isOuterOpen(2)).toEqual('outerToggle.isOpen(): false');
	 *        expect(repeatToggles.isOuterOpen(3)).toEqual('outerToggle.isOpen(): false');
	 *        expect(ifToggle.isOuterOpen()).toEqual('outerToggle.isOpen(): false');
	 *        outerToggle.toggle();
	 *        expect(outerToggle.isOpen()).toEqual('outerToggle.isOpen(): true');
	 *        expect(repeatToggles.isOuterOpen(1)).toEqual('outerToggle.isOpen(): true');
	 *        expect(repeatToggles.isOuterOpen(2)).toEqual('outerToggle.isOpen(): true');
	 *        expect(repeatToggles.isOuterOpen(3)).toEqual('outerToggle.isOpen(): true');
	 *        expect(ifToggle.isOuterOpen()).toEqual('outerToggle.isOpen(): true');
	 *      });
	 *
	 *      it('should toggle each repeat iteration separately', function() {
	 *        var repeatToggles = new NgRepeatToggles();
	 *
	 *        repeatToggles.forEach(function(repeatToggle) {
	 *          expect(repeatToggle.isOpen()).toEqual('ngRepeatToggle.isOpen(): false');
	 *          expect(repeatToggle.isOuterOpen()).toEqual('outerToggle.isOpen(): false');
	 *          repeatToggle.toggle();
	 *          expect(repeatToggle.isOpen()).toEqual('ngRepeatToggle.isOpen(): true');
	 *          expect(repeatToggle.isOuterOpen()).toEqual('outerToggle.isOpen(): false');
	 *        });
	 *      });
	 *   </file>
	 * </example>
	 *
	 */
	
	var ngRefMinErr = minErr('ngRef');
	
	var ngRefDirective = ['$parse', function($parse) {
	  return {
	    priority: -1, // Needed for compatibility with element transclusion on the same element
	    restrict: 'A',
	    compile: function(tElement, tAttrs) {
	      // Get the expected controller name, converts <data-some-thing> into "someThing"
	      var controllerName = directiveNormalize(nodeName_(tElement));
	
	      // Get the expression for value binding
	      var getter = $parse(tAttrs.ngRef);
	      var setter = getter.assign || function() {
	        throw ngRefMinErr('nonassign', 'Expression in ngRef="{0}" is non-assignable!', tAttrs.ngRef);
	      };
	
	      return function(scope, element, attrs) {
	        var refValue;
	
	        if (attrs.hasOwnProperty('ngRefRead')) {
	          if (attrs.ngRefRead === '$element') {
	            refValue = element;
	          } else {
	            refValue = element.data('$' + attrs.ngRefRead + 'Controller');
	
	            if (!refValue) {
	              throw ngRefMinErr(
	                'noctrl',
	                'The controller for ngRefRead="{0}" could not be found on ngRef="{1}"',
	                attrs.ngRefRead,
	                tAttrs.ngRef
	              );
	            }
	          }
	        } else {
	          refValue = element.data('$' + controllerName + 'Controller');
	        }
	
	        refValue = refValue || element;
	
	        setter(scope, refValue);
	
	        // when the element is removed, remove it (nullify it)
	        element.on('$destroy', function() {
	          // only remove it if value has not changed,
	          // because animations (and other procedures) may duplicate elements
	          if (getter(scope) === refValue) {
	            setter(scope, null);
	          }
	        });
	      };
	    }
	  };
	}];
	
	/* exported ngRepeatDirective */
	
	/**
	 * @ngdoc directive
	 * @name ngRepeat
	 * @multiElement
	 * @restrict A
	 *
	 * @description
	 * The `ngRepeat` directive instantiates a template once per item from a collection. Each template
	 * instance gets its own scope, where the given loop variable is set to the current collection item,
	 * and `$index` is set to the item index or key.
	 *
	 * Special properties are exposed on the local scope of each template instance, including:
	 *
	 * | Variable  | Type            | Details                                                                     |
	 * |-----------|-----------------|-----------------------------------------------------------------------------|
	 * | `$index`  | {@type number}  | iterator offset of the repeated element (0..length-1)                       |
	 * | `$first`  | {@type boolean} | true if the repeated element is first in the iterator.                      |
	 * | `$middle` | {@type boolean} | true if the repeated element is between the first and last in the iterator. |
	 * | `$last`   | {@type boolean} | true if the repeated element is last in the iterator.                       |
	 * | `$even`   | {@type boolean} | true if the iterator position `$index` is even (otherwise false).           |
	 * | `$odd`    | {@type boolean} | true if the iterator position `$index` is odd (otherwise false).            |
	 *
	 * <div class="alert alert-info">
	 *   Creating aliases for these properties is possible with {@link ng.directive:ngInit `ngInit`}.
	 *   This may be useful when, for instance, nesting ngRepeats.
	 * </div>
	 *
	 *
	 * ## Iterating over object properties
	 *
	 * It is possible to get `ngRepeat` to iterate over the properties of an object using the following
	 * syntax:
	 *
	 * ```js
	 * <div ng-repeat="(key, value) in myObj"> ... </div>
	 * ```
	 *
	 * However, there are a few limitations compared to array iteration:
	 *
	 * - The JavaScript specification does not define the order of keys
	 *   returned for an object, so AngularJS relies on the order returned by the browser
	 *   when running `for key in myObj`. Browsers generally follow the strategy of providing
	 *   keys in the order in which they were defined, although there are exceptions when keys are deleted
	 *   and reinstated. See the
	 *   [MDN page on `delete` for more info](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/delete#Cross-browser_notes).
	 *
	 * - `ngRepeat` will silently *ignore* object keys starting with `$`, because
	 *   it's a prefix used by AngularJS for public (`$`) and private (`$$`) properties.
	 *
	 * - The built-in filters {@link ng.orderBy orderBy} and {@link ng.filter filter} do not work with
	 *   objects, and will throw an error if used with one.
	 *
	 * If you are hitting any of these limitations, the recommended workaround is to convert your object into an array
	 * that is sorted into the order that you prefer before providing it to `ngRepeat`. You could
	 * do this with a filter such as [toArrayFilter](http://ngmodules.org/modules/angular-toArrayFilter)
	 * or implement a `$watch` on the object yourself.
	 *
	 *
	 * ## Tracking and Duplicates
	 *
	 * `ngRepeat` uses {@link $rootScope.Scope#$watchCollection $watchCollection} to detect changes in
	 * the collection. When a change happens, `ngRepeat` then makes the corresponding changes to the DOM:
	 *
	 * * When an item is added, a new instance of the template is added to the DOM.
	 * * When an item is removed, its template instance is removed from the DOM.
	 * * When items are reordered, their respective templates are reordered in the DOM.
	 *
	 * To minimize creation of DOM elements, `ngRepeat` uses a function
	 * to "keep track" of all items in the collection and their corresponding DOM elements.
	 * For example, if an item is added to the collection, `ngRepeat` will know that all other items
	 * already have DOM elements, and will not re-render them.
	 *
	 * All different types of tracking functions, their syntax, and their support for duplicate
	 * items in collections can be found in the
	 * {@link ngRepeat#ngRepeat-arguments ngRepeat expression description}.
	 *
	 * <div class="alert alert-success">
	 * **Best Practice:** If you are working with objects that have a unique identifier property, you
	 * should track by this identifier instead of the object instance,
	 * e.g. `item in items track by item.id`.
	 * Should you reload your data later, `ngRepeat` will not have to rebuild the DOM elements for items
	 * it has already rendered, even if the JavaScript objects in the collection have been substituted
	 * for new ones. For large collections, this significantly improves rendering performance.
	 * </div>
	 *
	 * ### Effects of DOM Element re-use
	 *
	 * When DOM elements are re-used, ngRepeat updates the scope for the element, which will
	 * automatically update any active bindings on the template. However, other
	 * functionality will not be updated, because the element is not re-created:
	 *
	 * - Directives are not re-compiled
	 * - {@link guide/expression#one-time-binding one-time expressions} on the repeated template are not
	 * updated if they have stabilized.
	 *
	 * The above affects all kinds of element re-use due to tracking, but may be especially visible
	 * when tracking by `$index` due to the way ngRepeat re-uses elements.
	 *
	 * The following example shows the effects of different actions with tracking:
	
	  <example module="ngRepeat" name="ngRepeat-tracking" deps="angular-animate.js" animations="true">
	    <file name="script.js">
	      angular.module('ngRepeat', ['ngAnimate']).controller('repeatController', function($scope) {
	        var friends = [
	          {name:'John', age:25},
	          {name:'Mary', age:40},
	          {name:'Peter', age:85}
	        ];
	
	        $scope.removeFirst = function() {
	          $scope.friends.shift();
	        };
	
	        $scope.updateAge = function() {
	          $scope.friends.forEach(function(el) {
	            el.age = el.age + 5;
	          });
	        };
	
	        $scope.copy = function() {
	          $scope.friends = angular.copy($scope.friends);
	        };
	
	        $scope.reset = function() {
	          $scope.friends = angular.copy(friends);
	        };
	
	        $scope.reset();
	      });
	    </file>
	    <file name="index.html">
	      <div ng-controller="repeatController">
	        <ol>
	          <li>When you click "Update Age", only the first list updates the age, because all others have
	          a one-time binding on the age property. If you then click "Copy", the current friend list
	          is copied, and now the second list updates the age, because the identity of the collection items
	          has changed and the list must be re-rendered. The 3rd and 4th list stay the same, because all the
	          items are already known according to their tracking functions.
	          </li>
	          <li>When you click "Remove First", the 4th list has the wrong age on both remaining items. This is
	          due to tracking by $index: when the first collection item is removed, ngRepeat reuses the first
	          DOM element for the new first collection item, and so on. Since the age property is one-time
	          bound, the value remains from the collection item which was previously at this index.
	          </li>
	        </ol>
	
	        <button ng-click="removeFirst()">Remove First</button>
	        <button ng-click="updateAge()">Update Age</button>
	        <button ng-click="copy()">Copy</button>
	        <br><button ng-click="reset()">Reset List</button>
	        <br>
	        <code>track by $id(friend)</code> (default):
	        <ul class="example-animate-container">
	          <li class="animate-repeat" ng-repeat="friend in friends">
	            {{friend.name}} is {{friend.age}} years old.
	          </li>
	        </ul>
	        <code>track by $id(friend)</code> (default), with age one-time binding:
	        <ul class="example-animate-container">
	          <li class="animate-repeat" ng-repeat="friend in friends">
	            {{friend.name}} is {{::friend.age}} years old.
	          </li>
	        </ul>
	        <code>track by friend.name</code>, with age one-time binding:
	        <ul class="example-animate-container">
	          <li class="animate-repeat" ng-repeat="friend in friends track by friend.name">
	            {{friend.name}}  is {{::friend.age}} years old.
	          </li>
	        </ul>
	        <code>track by $index</code>, with age one-time binding:
	        <ul class="example-animate-container">
	          <li class="animate-repeat" ng-repeat="friend in friends track by $index">
	            {{friend.name}} is {{::friend.age}} years old.
	          </li>
	        </ul>
	      </div>
	    </file>
	    <file name="animations.css">
	      .example-animate-container {
	        background:white;
	        border:1px solid black;
	        list-style:none;
	        margin:0;
	        padding:0 10px;
	      }
	
	      .animate-repeat {
	        line-height:30px;
	        list-style:none;
	        box-sizing:border-box;
	      }
	
	      .animate-repeat.ng-move,
	      .animate-repeat.ng-enter,
	      .animate-repeat.ng-leave {
	        transition:all linear 0.5s;
	      }
	
	      .animate-repeat.ng-leave.ng-leave-active,
	      .animate-repeat.ng-move,
	      .animate-repeat.ng-enter {
	        opacity:0;
	        max-height:0;
	      }
	
	      .animate-repeat.ng-leave,
	      .animate-repeat.ng-move.ng-move-active,
	      .animate-repeat.ng-enter.ng-enter-active {
	        opacity:1;
	        max-height:30px;
	      }
	    </file>
	  </example>
	
	 *
	 * ## Special repeat start and end points
	 * To repeat a series of elements instead of just one parent element, ngRepeat (as well as other ng directives) supports extending
	 * the range of the repeater by defining explicit start and end points by using **ng-repeat-start** and **ng-repeat-end** respectively.
	 * The **ng-repeat-start** directive works the same as **ng-repeat**, but will repeat all the HTML code (including the tag it's defined on)
	 * up to and including the ending HTML tag where **ng-repeat-end** is placed.
	 *
	 * The example below makes use of this feature:
	 * ```html
	 *   <header ng-repeat-start="item in items">
	 *     Header {{ item }}
	 *   </header>
	 *   <div class="body">
	 *     Body {{ item }}
	 *   </div>
	 *   <footer ng-repeat-end>
	 *     Footer {{ item }}
	 *   </footer>
	 * ```
	 *
	 * And with an input of {@type ['A','B']} for the items variable in the example above, the output will evaluate to:
	 * ```html
	 *   <header>
	 *     Header A
	 *   </header>
	 *   <div class="body">
	 *     Body A
	 *   </div>
	 *   <footer>
	 *     Footer A
	 *   </footer>
	 *   <header>
	 *     Header B
	 *   </header>
	 *   <div class="body">
	 *     Body B
	 *   </div>
	 *   <footer>
	 *     Footer B
	 *   </footer>
	 * ```
	 *
	 * The custom start and end points for ngRepeat also support all other HTML directive syntax flavors provided in AngularJS (such
	 * as **data-ng-repeat-start**, **x-ng-repeat-start** and **ng:repeat-start**).
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter} | when a new item is added to the list or when an item is revealed after a filter |
	 * | {@link ng.$animate#leave leave} | when an item is removed from the list or when an item is filtered out |
	 * | {@link ng.$animate#move move } | when an adjacent item is filtered out causing a reorder or when the item contents are reordered |
	 *
	 * See the example below for defining CSS animations with ngRepeat.
	 *
	 * @element ANY
	 * @scope
	 * @priority 1000
	 * @param {repeat_expression} ngRepeat The expression indicating how to enumerate a collection. These
	 *   formats are currently supported:
	 *
	 *   * `variable in expression` – where variable is the user defined loop variable and `expression`
	 *     is a scope expression giving the collection to enumerate.
	 *
	 *     For example: `album in artist.albums`.
	 *
	 *   * `(key, value) in expression` – where `key` and `value` can be any user defined identifiers,
	 *     and `expression` is the scope expression giving the collection to enumerate.
	 *
	 *     For example: `(name, age) in {'adam':10, 'amalie':12}`.
	 *
	 *   * `variable in expression track by tracking_expression` – You can also provide an optional tracking expression
	 *     which can be used to associate the objects in the collection with the DOM elements. If no tracking expression
	 *     is specified, ng-repeat associates elements by identity. It is an error to have
	 *     more than one tracking expression value resolve to the same key. (This would mean that two distinct objects are
	 *     mapped to the same DOM element, which is not possible.)
	 *
	 *     *Default tracking: $id()*: `item in items` is equivalent to `item in items track by $id(item)`.
	 *     This implies that the DOM elements will be associated by item identity in the collection.
	 *
	 *     The built-in `$id()` function can be used to assign a unique
	 *     `$$hashKey` property to each item in the collection. This property is then used as a key to associated DOM elements
	 *     with the corresponding item in the collection by identity. Moving the same object would move
	 *     the DOM element in the same way in the DOM.
	 *     Note that the default id function does not support duplicate primitive values (`number`, `string`),
	 *     but supports duplictae non-primitive values (`object`) that are *equal* in shape.
	 *
	 *     *Custom Expression*: It is possible to use any AngularJS expression to compute the tracking
	 *     id, for example with a function, or using a property on the collection items.
	 *     `item in items track by item.id` is a typical pattern when the items have a unique identifier,
	 *     e.g. database id. In this case the object identity does not matter. Two objects are considered
	 *     equivalent as long as their `id` property is same.
	 *     Tracking by unique identifier is the most performant way and should be used whenever possible.
	 *
	 *     *$index*: This special property tracks the collection items by their index, and
	 *     re-uses the DOM elements that match that index, e.g. `item in items track by $index`. This can
	 *     be used for a performance improvement if no unique identfier is available and the identity of
	 *     the collection items cannot be easily computed. It also allows duplicates.
	 *
	 *     <div class="alert alert-warning">
	 *       <strong>Note:</strong> Re-using DOM elements can have unforeseen effects. Read the
	 *       {@link ngRepeat#tracking-and-duplicates section on tracking and duplicates} for
	 *       more info.
	 *     </div>
	 *
	 *     <div class="alert alert-warning">
	 *       <strong>Note:</strong> the `track by` expression must come last - after any filters, and the alias expression:
	 *       `item in items | filter:searchText as results  track by item.id`
	 *     </div>
	 *
	 *   * `variable in expression as alias_expression` – You can also provide an optional alias expression which will then store the
	 *     intermediate results of the repeater after the filters have been applied. Typically this is used to render a special message
	 *     when a filter is active on the repeater, but the filtered result set is empty.
	 *
	 *     For example: `item in items | filter:x as results` will store the fragment of the repeated items as `results`, but only after
	 *     the items have been processed through the filter.
	 *
	 *     Please note that `as [variable name]` is not an operator but rather a part of ngRepeat
	 *     micro-syntax so it can be used only after all filters (and not as operator, inside an expression).
	 *
	 *     For example: `item in items | filter : x | orderBy : order | limitTo : limit as results track by item.id` .
	 *
	 * @example
	 * This example uses `ngRepeat` to display a list of people. A filter is used to restrict the displayed
	 * results by name or by age. New (entering) and removed (leaving) items are animated.
	  <example module="ngRepeat" name="ngRepeat" deps="angular-animate.js" animations="true">
	    <file name="index.html">
	      <div ng-controller="repeatController">
	        I have {{friends.length}} friends. They are:
	        <input type="search" ng-model="q" placeholder="filter friends..." aria-label="filter friends" />
	        <ul class="example-animate-container">
	          <li class="animate-repeat" ng-repeat="friend in friends | filter:q as results track by friend.name">
	            [{{$index + 1}}] {{friend.name}} who is {{friend.age}} years old.
	          </li>
	          <li class="animate-repeat" ng-if="results.length === 0">
	            <strong>No results found...</strong>
	          </li>
	        </ul>
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngRepeat', ['ngAnimate']).controller('repeatController', function($scope) {
	        $scope.friends = [
	          {name:'John', age:25, gender:'boy'},
	          {name:'Jessie', age:30, gender:'girl'},
	          {name:'Johanna', age:28, gender:'girl'},
	          {name:'Joy', age:15, gender:'girl'},
	          {name:'Mary', age:28, gender:'girl'},
	          {name:'Peter', age:95, gender:'boy'},
	          {name:'Sebastian', age:50, gender:'boy'},
	          {name:'Erika', age:27, gender:'girl'},
	          {name:'Patrick', age:40, gender:'boy'},
	          {name:'Samantha', age:60, gender:'girl'}
	        ];
	      });
	    </file>
	    <file name="animations.css">
	      .example-animate-container {
	        background:white;
	        border:1px solid black;
	        list-style:none;
	        margin:0;
	        padding:0 10px;
	      }
	
	      .animate-repeat {
	        line-height:30px;
	        list-style:none;
	        box-sizing:border-box;
	      }
	
	      .animate-repeat.ng-move,
	      .animate-repeat.ng-enter,
	      .animate-repeat.ng-leave {
	        transition:all linear 0.5s;
	      }
	
	      .animate-repeat.ng-leave.ng-leave-active,
	      .animate-repeat.ng-move,
	      .animate-repeat.ng-enter {
	        opacity:0;
	        max-height:0;
	      }
	
	      .animate-repeat.ng-leave,
	      .animate-repeat.ng-move.ng-move-active,
	      .animate-repeat.ng-enter.ng-enter-active {
	        opacity:1;
	        max-height:30px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var friends = element.all(by.repeater('friend in friends'));
	
	      it('should render initial data set', function() {
	        expect(friends.count()).toBe(10);
	        expect(friends.get(0).getText()).toEqual('[1] John who is 25 years old.');
	        expect(friends.get(1).getText()).toEqual('[2] Jessie who is 30 years old.');
	        expect(friends.last().getText()).toEqual('[10] Samantha who is 60 years old.');
	        expect(element(by.binding('friends.length')).getText())
	            .toMatch("I have 10 friends. They are:");
	      });
	
	       it('should update repeater when filter predicate changes', function() {
	         expect(friends.count()).toBe(10);
	
	         element(by.model('q')).sendKeys('ma');
	
	         expect(friends.count()).toBe(2);
	         expect(friends.get(0).getText()).toEqual('[1] Mary who is 28 years old.');
	         expect(friends.last().getText()).toEqual('[2] Samantha who is 60 years old.');
	       });
	      </file>
	    </example>
	 */
	var ngRepeatDirective = ['$parse', '$animate', '$compile', function($parse, $animate, $compile) {
	  var NG_REMOVED = '$$NG_REMOVED';
	  var ngRepeatMinErr = minErr('ngRepeat');
	
	  var updateScope = function(scope, index, valueIdentifier, value, keyIdentifier, key, arrayLength) {
	    // TODO(perf): generate setters to shave off ~40ms or 1-1.5%
	    scope[valueIdentifier] = value;
	    if (keyIdentifier) scope[keyIdentifier] = key;
	    scope.$index = index;
	    scope.$first = (index === 0);
	    scope.$last = (index === (arrayLength - 1));
	    scope.$middle = !(scope.$first || scope.$last);
	    // eslint-disable-next-line no-bitwise
	    scope.$odd = !(scope.$even = (index & 1) === 0);
	  };
	
	  var getBlockStart = function(block) {
	    return block.clone[0];
	  };
	
	  var getBlockEnd = function(block) {
	    return block.clone[block.clone.length - 1];
	  };
	
	  var trackByIdArrayFn = function($scope, key, value) {
	    return hashKey(value);
	  };
	
	  var trackByIdObjFn = function($scope, key) {
	    return key;
	  };
	
	  return {
	    restrict: 'A',
	    multiElement: true,
	    transclude: 'element',
	    priority: 1000,
	    terminal: true,
	    $$tlb: true,
	    compile: function ngRepeatCompile($element, $attr) {
	      var expression = $attr.ngRepeat;
	      var ngRepeatEndComment = $compile.$$createComment('end ngRepeat', expression);
	
	      var match = expression.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);
	
	      if (!match) {
	        throw ngRepeatMinErr('iexp', 'Expected expression in form of \'_item_ in _collection_[ track by _id_]\' but got \'{0}\'.',
	            expression);
	      }
	
	      var lhs = match[1];
	      var rhs = match[2];
	      var aliasAs = match[3];
	      var trackByExp = match[4];
	
	      match = lhs.match(/^(?:(\s*[$\w]+)|\(\s*([$\w]+)\s*,\s*([$\w]+)\s*\))$/);
	
	      if (!match) {
	        throw ngRepeatMinErr('iidexp', '\'_item_\' in \'_item_ in _collection_\' should be an identifier or \'(_key_, _value_)\' expression, but got \'{0}\'.',
	            lhs);
	      }
	      var valueIdentifier = match[3] || match[1];
	      var keyIdentifier = match[2];
	
	      if (aliasAs && (!/^[$a-zA-Z_][$a-zA-Z0-9_]*$/.test(aliasAs) ||
	          /^(null|undefined|this|\$index|\$first|\$middle|\$last|\$even|\$odd|\$parent|\$root|\$id)$/.test(aliasAs))) {
	        throw ngRepeatMinErr('badident', 'alias \'{0}\' is invalid --- must be a valid JS identifier which is not a reserved name.',
	          aliasAs);
	      }
	
	      var trackByIdExpFn;
	
	      if (trackByExp) {
	        var hashFnLocals = {$id: hashKey};
	        var trackByExpGetter = $parse(trackByExp);
	
	        trackByIdExpFn = function($scope, key, value, index) {
	          // assign key, value, and $index to the locals so that they can be used in hash functions
	          if (keyIdentifier) hashFnLocals[keyIdentifier] = key;
	          hashFnLocals[valueIdentifier] = value;
	          hashFnLocals.$index = index;
	          return trackByExpGetter($scope, hashFnLocals);
	        };
	      }
	
	      return function ngRepeatLink($scope, $element, $attr, ctrl, $transclude) {
	
	        // Store a list of elements from previous run. This is a hash where key is the item from the
	        // iterator, and the value is objects with following properties.
	        //   - scope: bound scope
	        //   - clone: previous element.
	        //   - index: position
	        //
	        // We are using no-proto object so that we don't need to guard against inherited props via
	        // hasOwnProperty.
	        var lastBlockMap = createMap();
	
	        //watch props
	        $scope.$watchCollection(rhs, function ngRepeatAction(collection) {
	          var index, length,
	              previousNode = $element[0],     // node that cloned nodes should be inserted after
	                                              // initialized to the comment node anchor
	              nextNode,
	              // Same as lastBlockMap but it has the current state. It will become the
	              // lastBlockMap on the next iteration.
	              nextBlockMap = createMap(),
	              collectionLength,
	              key, value, // key/value of iteration
	              trackById,
	              trackByIdFn,
	              collectionKeys,
	              block,       // last object information {scope, element, id}
	              nextBlockOrder,
	              elementsToRemove;
	
	          if (aliasAs) {
	            $scope[aliasAs] = collection;
	          }
	
	          if (isArrayLike(collection)) {
	            collectionKeys = collection;
	            trackByIdFn = trackByIdExpFn || trackByIdArrayFn;
	          } else {
	            trackByIdFn = trackByIdExpFn || trackByIdObjFn;
	            // if object, extract keys, in enumeration order, unsorted
	            collectionKeys = [];
	            for (var itemKey in collection) {
	              if (hasOwnProperty.call(collection, itemKey) && itemKey.charAt(0) !== '$') {
	                collectionKeys.push(itemKey);
	              }
	            }
	          }
	
	          collectionLength = collectionKeys.length;
	          nextBlockOrder = new Array(collectionLength);
	
	          // locate existing items
	          for (index = 0; index < collectionLength; index++) {
	            key = (collection === collectionKeys) ? index : collectionKeys[index];
	            value = collection[key];
	            trackById = trackByIdFn($scope, key, value, index);
	            if (lastBlockMap[trackById]) {
	              // found previously seen block
	              block = lastBlockMap[trackById];
	              delete lastBlockMap[trackById];
	              nextBlockMap[trackById] = block;
	              nextBlockOrder[index] = block;
	            } else if (nextBlockMap[trackById]) {
	              // if collision detected. restore lastBlockMap and throw an error
	              forEach(nextBlockOrder, function(block) {
	                if (block && block.scope) lastBlockMap[block.id] = block;
	              });
	              throw ngRepeatMinErr('dupes',
	                  'Duplicates in a repeater are not allowed. Use \'track by\' expression to specify unique keys. Repeater: {0}, Duplicate key: {1}, Duplicate value: {2}',
	                  expression, trackById, value);
	            } else {
	              // new never before seen block
	              nextBlockOrder[index] = {id: trackById, scope: undefined, clone: undefined};
	              nextBlockMap[trackById] = true;
	            }
	          }
	
	          // Clear the value property from the hashFnLocals object to prevent a reference to the last value
	          // being leaked into the ngRepeatCompile function scope
	          if (hashFnLocals) {
	            hashFnLocals[valueIdentifier] = undefined;
	          }
	
	          // remove leftover items
	          for (var blockKey in lastBlockMap) {
	            block = lastBlockMap[blockKey];
	            elementsToRemove = getBlockNodes(block.clone);
	            $animate.leave(elementsToRemove);
	            if (elementsToRemove[0].parentNode) {
	              // if the element was not removed yet because of pending animation, mark it as deleted
	              // so that we can ignore it later
	              for (index = 0, length = elementsToRemove.length; index < length; index++) {
	                elementsToRemove[index][NG_REMOVED] = true;
	              }
	            }
	            block.scope.$destroy();
	          }
	
	          // we are not using forEach for perf reasons (trying to avoid #call)
	          for (index = 0; index < collectionLength; index++) {
	            key = (collection === collectionKeys) ? index : collectionKeys[index];
	            value = collection[key];
	            block = nextBlockOrder[index];
	
	            if (block.scope) {
	              // if we have already seen this object, then we need to reuse the
	              // associated scope/element
	
	              nextNode = previousNode;
	
	              // skip nodes that are already pending removal via leave animation
	              do {
	                nextNode = nextNode.nextSibling;
	              } while (nextNode && nextNode[NG_REMOVED]);
	
	              if (getBlockStart(block) !== nextNode) {
	                // existing item which got moved
	                $animate.move(getBlockNodes(block.clone), null, previousNode);
	              }
	              previousNode = getBlockEnd(block);
	              updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
	            } else {
	              // new item which we don't know about
	              $transclude(function ngRepeatTransclude(clone, scope) {
	                block.scope = scope;
	                // http://jsperf.com/clone-vs-createcomment
	                var endNode = ngRepeatEndComment.cloneNode(false);
	                clone[clone.length++] = endNode;
	
	                $animate.enter(clone, null, previousNode);
	                previousNode = endNode;
	                // Note: We only need the first/last node of the cloned nodes.
	                // However, we need to keep the reference to the jqlite wrapper as it might be changed later
	                // by a directive with templateUrl when its template arrives.
	                block.clone = clone;
	                nextBlockMap[block.id] = block;
	                updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
	              });
	            }
	          }
	          lastBlockMap = nextBlockMap;
	        });
	      };
	    }
	  };
	}];
	
	var NG_HIDE_CLASS = 'ng-hide';
	var NG_HIDE_IN_PROGRESS_CLASS = 'ng-hide-animate';
	/**
	 * @ngdoc directive
	 * @name ngShow
	 * @multiElement
	 *
	 * @description
	 * The `ngShow` directive shows or hides the given HTML element based on the expression provided to
	 * the `ngShow` attribute.
	 *
	 * The element is shown or hidden by removing or adding the `.ng-hide` CSS class onto the element.
	 * The `.ng-hide` CSS class is predefined in AngularJS and sets the display style to none (using an
	 * `!important` flag). For CSP mode please add `angular-csp.css` to your HTML file (see
	 * {@link ng.directive:ngCsp ngCsp}).
	 *
	 * ```html
	 * <!-- when $scope.myValue is truthy (element is visible) -->
	 * <div ng-show="myValue"></div>
	 *
	 * <!-- when $scope.myValue is falsy (element is hidden) -->
	 * <div ng-show="myValue" class="ng-hide"></div>
	 * ```
	 *
	 * When the `ngShow` expression evaluates to a falsy value then the `.ng-hide` CSS class is added
	 * to the class attribute on the element causing it to become hidden. When truthy, the `.ng-hide`
	 * CSS class is removed from the element causing the element not to appear hidden.
	 *
	 * ## Why is `!important` used?
	 *
	 * You may be wondering why `!important` is used for the `.ng-hide` CSS class. This is because the
	 * `.ng-hide` selector can be easily overridden by heavier selectors. For example, something as
	 * simple as changing the display style on a HTML list item would make hidden elements appear
	 * visible. This also becomes a bigger issue when dealing with CSS frameworks.
	 *
	 * By using `!important`, the show and hide behavior will work as expected despite any clash between
	 * CSS selector specificity (when `!important` isn't used with any conflicting styles). If a
	 * developer chooses to override the styling to change how to hide an element then it is just a
	 * matter of using `!important` in their own CSS code.
	 *
	 * ### Overriding `.ng-hide`
	 *
	 * By default, the `.ng-hide` class will style the element with `display: none !important`. If you
	 * wish to change the hide behavior with `ngShow`/`ngHide`, you can simply overwrite the styles for
	 * the `.ng-hide` CSS class. Note that the selector that needs to be used is actually
	 * `.ng-hide:not(.ng-hide-animate)` to cope with extra animation classes that can be added.
	 *
	 * ```css
	 * .ng-hide:not(.ng-hide-animate) {
	 *   /&#42; These are just alternative ways of hiding an element &#42;/
	 *   display: block!important;
	 *   position: absolute;
	 *   top: -9999px;
	 *   left: -9999px;
	 * }
	 * ```
	 *
	 * By default you don't need to override anything in CSS and the animations will work around the
	 * display style.
	 *
	 * @animations
	 * | Animation                                           | Occurs                                                                                                        |
	 * |-----------------------------------------------------|---------------------------------------------------------------------------------------------------------------|
	 * | {@link $animate#addClass addClass} `.ng-hide`       | After the `ngShow` expression evaluates to a non truthy value and just before the contents are set to hidden. |
	 * | {@link $animate#removeClass removeClass} `.ng-hide` | After the `ngShow` expression evaluates to a truthy value and just before contents are set to visible.        |
	 *
	 * Animations in `ngShow`/`ngHide` work with the show and hide events that are triggered when the
	 * directive expression is true and false. This system works like the animation system present with
	 * `ngClass` except that you must also include the `!important` flag to override the display
	 * property so that the elements are not actually hidden during the animation.
	 *
	 * ```css
	 * /&#42; A working example can be found at the bottom of this page. &#42;/
	 * .my-element.ng-hide-add, .my-element.ng-hide-remove {
	 *   transition: all 0.5s linear;
	 * }
	 *
	 * .my-element.ng-hide-add { ... }
	 * .my-element.ng-hide-add.ng-hide-add-active { ... }
	 * .my-element.ng-hide-remove { ... }
	 * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
	 * ```
	 *
	 * Keep in mind that, as of AngularJS version 1.3, there is no need to change the display property
	 * to block during animation states - ngAnimate will automatically handle the style toggling for you.
	 *
	 * @element ANY
	 * @param {expression} ngShow If the {@link guide/expression expression} is truthy/falsy then the
	 *                            element is shown/hidden respectively.
	 *
	 * @example
	 * A simple example, animating the element's opacity:
	 *
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-show-simple">
	    <file name="index.html">
	      Show: <input type="checkbox" ng-model="checked" aria-label="Toggle ngShow"><br />
	      <div class="check-element animate-show-hide" ng-show="checked">
	        I show up when your checkbox is checked.
	      </div>
	    </file>
	    <file name="animations.css">
	      .animate-show-hide.ng-hide {
	        opacity: 0;
	      }
	
	      .animate-show-hide.ng-hide-add,
	      .animate-show-hide.ng-hide-remove {
	        transition: all linear 0.5s;
	      }
	
	      .check-element {
	        border: 1px solid black;
	        opacity: 1;
	        padding: 10px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should check ngShow', function() {
	        var checkbox = element(by.model('checked'));
	        var checkElem = element(by.css('.check-element'));
	
	        expect(checkElem.isDisplayed()).toBe(false);
	        checkbox.click();
	        expect(checkElem.isDisplayed()).toBe(true);
	      });
	    </file>
	  </example>
	 *
	 * <hr />
	 * @example
	 * A more complex example, featuring different show/hide animations:
	 *
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-show-complex">
	    <file name="index.html">
	      Show: <input type="checkbox" ng-model="checked" aria-label="Toggle ngShow"><br />
	      <div class="check-element funky-show-hide" ng-show="checked">
	        I show up when your checkbox is checked.
	      </div>
	    </file>
	    <file name="animations.css">
	      body {
	        overflow: hidden;
	        perspective: 1000px;
	      }
	
	      .funky-show-hide.ng-hide-add {
	        transform: rotateZ(0);
	        transform-origin: right;
	        transition: all 0.5s ease-in-out;
	      }
	
	      .funky-show-hide.ng-hide-add.ng-hide-add-active {
	        transform: rotateZ(-135deg);
	      }
	
	      .funky-show-hide.ng-hide-remove {
	        transform: rotateY(90deg);
	        transform-origin: left;
	        transition: all 0.5s ease;
	      }
	
	      .funky-show-hide.ng-hide-remove.ng-hide-remove-active {
	        transform: rotateY(0);
	      }
	
	      .check-element {
	        border: 1px solid black;
	        opacity: 1;
	        padding: 10px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should check ngShow', function() {
	        var checkbox = element(by.model('checked'));
	        var checkElem = element(by.css('.check-element'));
	
	        expect(checkElem.isDisplayed()).toBe(false);
	        checkbox.click();
	        expect(checkElem.isDisplayed()).toBe(true);
	      });
	    </file>
	  </example>
	 *
	 * @knownIssue
	 *
	 * ### Flickering when using ngShow to toggle between elements
	 *
	 * When using {@link ngShow} and / or {@link ngHide} to toggle between elements, it can
	 * happen that both the element to show and the element to hide are visible for a very short time.
	 *
	 * This usually happens when the {@link ngAnimate ngAnimate module} is included, but no actual animations
	 * are defined for {@link ngShow} / {@link ngHide}. Internet Explorer is affected more often than
	 * other browsers.
	 *
	 * There are several way to mitigate this problem:
	 *
	 * - {@link guide/animations#how-to-selectively-enable-disable-and-skip-animations Disable animations on the affected elements}.
	 * - Use {@link ngIf} or {@link ngSwitch} instead of {@link ngShow} / {@link ngHide}.
	 * - Use the special CSS selector `ng-hide.ng-hide-animate` to set `{display: none}` or similar on the affected elements.
	 * - Use `ng-class="{'ng-hide': expression}` instead of instead of {@link ngShow} / {@link ngHide}.
	 * - Define an animation on the affected elements.
	 */
	var ngShowDirective = ['$animate', function($animate) {
	  return {
	    restrict: 'A',
	    multiElement: true,
	    link: function(scope, element, attr) {
	      scope.$watch(attr.ngShow, function ngShowWatchAction(value) {
	        // we're adding a temporary, animation-specific class for ng-hide since this way
	        // we can control when the element is actually displayed on screen without having
	        // to have a global/greedy CSS selector that breaks when other animations are run.
	        // Read: https://github.com/angular/angular.js/issues/9103#issuecomment-58335845
	        $animate[value ? 'removeClass' : 'addClass'](element, NG_HIDE_CLASS, {
	          tempClasses: NG_HIDE_IN_PROGRESS_CLASS
	        });
	      });
	    }
	  };
	}];
	
	
	/**
	 * @ngdoc directive
	 * @name ngHide
	 * @multiElement
	 *
	 * @description
	 * The `ngHide` directive shows or hides the given HTML element based on the expression provided to
	 * the `ngHide` attribute.
	 *
	 * The element is shown or hidden by removing or adding the `.ng-hide` CSS class onto the element.
	 * The `.ng-hide` CSS class is predefined in AngularJS and sets the display style to none (using an
	 * `!important` flag). For CSP mode please add `angular-csp.css` to your HTML file (see
	 * {@link ng.directive:ngCsp ngCsp}).
	 *
	 * ```html
	 * <!-- when $scope.myValue is truthy (element is hidden) -->
	 * <div ng-hide="myValue" class="ng-hide"></div>
	 *
	 * <!-- when $scope.myValue is falsy (element is visible) -->
	 * <div ng-hide="myValue"></div>
	 * ```
	 *
	 * When the `ngHide` expression evaluates to a truthy value then the `.ng-hide` CSS class is added
	 * to the class attribute on the element causing it to become hidden. When falsy, the `.ng-hide`
	 * CSS class is removed from the element causing the element not to appear hidden.
	 *
	 * ## Why is `!important` used?
	 *
	 * You may be wondering why `!important` is used for the `.ng-hide` CSS class. This is because the
	 * `.ng-hide` selector can be easily overridden by heavier selectors. For example, something as
	 * simple as changing the display style on a HTML list item would make hidden elements appear
	 * visible. This also becomes a bigger issue when dealing with CSS frameworks.
	 *
	 * By using `!important`, the show and hide behavior will work as expected despite any clash between
	 * CSS selector specificity (when `!important` isn't used with any conflicting styles). If a
	 * developer chooses to override the styling to change how to hide an element then it is just a
	 * matter of using `!important` in their own CSS code.
	 *
	 * ### Overriding `.ng-hide`
	 *
	 * By default, the `.ng-hide` class will style the element with `display: none !important`. If you
	 * wish to change the hide behavior with `ngShow`/`ngHide`, you can simply overwrite the styles for
	 * the `.ng-hide` CSS class. Note that the selector that needs to be used is actually
	 * `.ng-hide:not(.ng-hide-animate)` to cope with extra animation classes that can be added.
	 *
	 * ```css
	 * .ng-hide:not(.ng-hide-animate) {
	 *   /&#42; These are just alternative ways of hiding an element &#42;/
	 *   display: block!important;
	 *   position: absolute;
	 *   top: -9999px;
	 *   left: -9999px;
	 * }
	 * ```
	 *
	 * By default you don't need to override in CSS anything and the animations will work around the
	 * display style.
	 *
	 * @animations
	 * | Animation                                           | Occurs                                                                                                     |
	 * |-----------------------------------------------------|------------------------------------------------------------------------------------------------------------|
	 * | {@link $animate#addClass addClass} `.ng-hide`       | After the `ngHide` expression evaluates to a truthy value and just before the contents are set to hidden.  |
	 * | {@link $animate#removeClass removeClass} `.ng-hide` | After the `ngHide` expression evaluates to a non truthy value and just before contents are set to visible. |
	 *
	 * Animations in `ngShow`/`ngHide` work with the show and hide events that are triggered when the
	 * directive expression is true and false. This system works like the animation system present with
	 * `ngClass` except that you must also include the `!important` flag to override the display
	 * property so that the elements are not actually hidden during the animation.
	 *
	 * ```css
	 * /&#42; A working example can be found at the bottom of this page. &#42;/
	 * .my-element.ng-hide-add, .my-element.ng-hide-remove {
	 *   transition: all 0.5s linear;
	 * }
	 *
	 * .my-element.ng-hide-add { ... }
	 * .my-element.ng-hide-add.ng-hide-add-active { ... }
	 * .my-element.ng-hide-remove { ... }
	 * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
	 * ```
	 *
	 * Keep in mind that, as of AngularJS version 1.3, there is no need to change the display property
	 * to block during animation states - ngAnimate will automatically handle the style toggling for you.
	 *
	 * @element ANY
	 * @param {expression} ngHide If the {@link guide/expression expression} is truthy/falsy then the
	 *                            element is hidden/shown respectively.
	 *
	 * @example
	 * A simple example, animating the element's opacity:
	 *
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-hide-simple">
	    <file name="index.html">
	      Hide: <input type="checkbox" ng-model="checked" aria-label="Toggle ngHide"><br />
	      <div class="check-element animate-show-hide" ng-hide="checked">
	        I hide when your checkbox is checked.
	      </div>
	    </file>
	    <file name="animations.css">
	      .animate-show-hide.ng-hide {
	        opacity: 0;
	      }
	
	      .animate-show-hide.ng-hide-add,
	      .animate-show-hide.ng-hide-remove {
	        transition: all linear 0.5s;
	      }
	
	      .check-element {
	        border: 1px solid black;
	        opacity: 1;
	        padding: 10px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should check ngHide', function() {
	        var checkbox = element(by.model('checked'));
	        var checkElem = element(by.css('.check-element'));
	
	        expect(checkElem.isDisplayed()).toBe(true);
	        checkbox.click();
	        expect(checkElem.isDisplayed()).toBe(false);
	      });
	    </file>
	  </example>
	 *
	 * <hr />
	 * @example
	 * A more complex example, featuring different show/hide animations:
	 *
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-hide-complex">
	    <file name="index.html">
	      Hide: <input type="checkbox" ng-model="checked" aria-label="Toggle ngHide"><br />
	      <div class="check-element funky-show-hide" ng-hide="checked">
	        I hide when your checkbox is checked.
	      </div>
	    </file>
	    <file name="animations.css">
	      body {
	        overflow: hidden;
	        perspective: 1000px;
	      }
	
	      .funky-show-hide.ng-hide-add {
	        transform: rotateZ(0);
	        transform-origin: right;
	        transition: all 0.5s ease-in-out;
	      }
	
	      .funky-show-hide.ng-hide-add.ng-hide-add-active {
	        transform: rotateZ(-135deg);
	      }
	
	      .funky-show-hide.ng-hide-remove {
	        transform: rotateY(90deg);
	        transform-origin: left;
	        transition: all 0.5s ease;
	      }
	
	      .funky-show-hide.ng-hide-remove.ng-hide-remove-active {
	        transform: rotateY(0);
	      }
	
	      .check-element {
	        border: 1px solid black;
	        opacity: 1;
	        padding: 10px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should check ngHide', function() {
	        var checkbox = element(by.model('checked'));
	        var checkElem = element(by.css('.check-element'));
	
	        expect(checkElem.isDisplayed()).toBe(true);
	        checkbox.click();
	        expect(checkElem.isDisplayed()).toBe(false);
	      });
	    </file>
	  </example>
	 *
	 * @knownIssue
	 *
	 * ### Flickering when using ngHide to toggle between elements
	 *
	 * When using {@link ngShow} and / or {@link ngHide} to toggle between elements, it can
	 * happen that both the element to show and the element to hide are visible for a very short time.
	 *
	 * This usually happens when the {@link ngAnimate ngAnimate module} is included, but no actual animations
	 * are defined for {@link ngShow} / {@link ngHide}. Internet Explorer is affected more often than
	 * other browsers.
	 *
	 * There are several way to mitigate this problem:
	 *
	 * - {@link guide/animations#how-to-selectively-enable-disable-and-skip-animations Disable animations on the affected elements}.
	 * - Use {@link ngIf} or {@link ngSwitch} instead of {@link ngShow} / {@link ngHide}.
	 * - Use the special CSS selector `ng-hide.ng-hide-animate` to set `{display: none}` or similar on the affected elements.
	 * - Use `ng-class="{'ng-hide': expression}` instead of instead of {@link ngShow} / {@link ngHide}.
	 * - Define an animation on the affected elements.
	 */
	var ngHideDirective = ['$animate', function($animate) {
	  return {
	    restrict: 'A',
	    multiElement: true,
	    link: function(scope, element, attr) {
	      scope.$watch(attr.ngHide, function ngHideWatchAction(value) {
	        // The comment inside of the ngShowDirective explains why we add and
	        // remove a temporary class for the show/hide animation
	        $animate[value ? 'addClass' : 'removeClass'](element,NG_HIDE_CLASS, {
	          tempClasses: NG_HIDE_IN_PROGRESS_CLASS
	        });
	      });
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngStyle
	 * @restrict AC
	 *
	 * @description
	 * The `ngStyle` directive allows you to set CSS style on an HTML element conditionally.
	 *
	 * @knownIssue
	 * You should not use {@link guide/interpolation interpolation} in the value of the `style`
	 * attribute, when using the `ngStyle` directive on the same element.
	 * See {@link guide/interpolation#known-issues here} for more info.
	 *
	 * @element ANY
	 * @param {expression} ngStyle
	 *
	 * {@link guide/expression Expression} which evals to an
	 * object whose keys are CSS style names and values are corresponding values for those CSS
	 * keys.
	 *
	 * Since some CSS style names are not valid keys for an object, they must be quoted.
	 * See the 'background-color' style in the example below.
	 *
	 * @example
	   <example name="ng-style">
	     <file name="index.html">
	        <input type="button" value="set color" ng-click="myStyle={color:'red'}">
	        <input type="button" value="set background" ng-click="myStyle={'background-color':'blue'}">
	        <input type="button" value="clear" ng-click="myStyle={}">
	        <br/>
	        <span ng-style="myStyle">Sample Text</span>
	        <pre>myStyle={{myStyle}}</pre>
	     </file>
	     <file name="style.css">
	       span {
	         color: black;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       var colorSpan = element(by.css('span'));
	
	       it('should check ng-style', function() {
	         expect(colorSpan.getCssValue('color')).toMatch(/rgba\(0, 0, 0, 1\)|rgb\(0, 0, 0\)/);
	         element(by.css('input[value=\'set color\']')).click();
	         expect(colorSpan.getCssValue('color')).toMatch(/rgba\(255, 0, 0, 1\)|rgb\(255, 0, 0\)/);
	         element(by.css('input[value=clear]')).click();
	         expect(colorSpan.getCssValue('color')).toMatch(/rgba\(0, 0, 0, 1\)|rgb\(0, 0, 0\)/);
	       });
	     </file>
	   </example>
	 */
	var ngStyleDirective = ngDirective(function(scope, element, attr) {
	  scope.$watchCollection(attr.ngStyle, function ngStyleWatchAction(newStyles, oldStyles) {
	    if (oldStyles && (newStyles !== oldStyles)) {
	      forEach(oldStyles, function(val, style) { element.css(style, ''); });
	    }
	    if (newStyles) element.css(newStyles);
	  });
	});
	
	/**
	 * @ngdoc directive
	 * @name ngSwitch
	 * @restrict EA
	 *
	 * @description
	 * The `ngSwitch` directive is used to conditionally swap DOM structure on your template based on a scope expression.
	 * Elements within `ngSwitch` but without `ngSwitchWhen` or `ngSwitchDefault` directives will be preserved at the location
	 * as specified in the template.
	 *
	 * The directive itself works similar to ngInclude, however, instead of downloading template code (or loading it
	 * from the template cache), `ngSwitch` simply chooses one of the nested elements and makes it visible based on which element
	 * matches the value obtained from the evaluated expression. In other words, you define a container element
	 * (where you place the directive), place an expression on the **`on="..."` attribute**
	 * (or the **`ng-switch="..."` attribute**), define any inner elements inside of the directive and place
	 * a when attribute per element. The when attribute is used to inform ngSwitch which element to display when the on
	 * expression is evaluated. If a matching expression is not found via a when attribute then an element with the default
	 * attribute is displayed.
	 *
	 * <div class="alert alert-info">
	 * Be aware that the attribute values to match against cannot be expressions. They are interpreted
	 * as literal string values to match against.
	 * For example, **`ng-switch-when="someVal"`** will match against the string `"someVal"` not against the
	 * value of the expression `$scope.someVal`.
	 * </div>
	
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter}  | after the ngSwitch contents change and the matched child element is placed inside the container |
	 * | {@link ng.$animate#leave leave}  | after the ngSwitch contents change and just before the former contents are removed from the DOM |
	 *
	 * @usage
	 *
	 * ```
	 * <ANY ng-switch="expression">
	 *   <ANY ng-switch-when="matchValue1">...</ANY>
	 *   <ANY ng-switch-when="matchValue2">...</ANY>
	 *   <ANY ng-switch-default>...</ANY>
	 * </ANY>
	 * ```
	 *
	 *
	 * @scope
	 * @priority 1200
	 * @param {*} ngSwitch|on expression to match against <code>ng-switch-when</code>.
	 * On child elements add:
	 *
	 * * `ngSwitchWhen`: the case statement to match against. If match then this
	 *   case will be displayed. If the same match appears multiple times, all the
	 *   elements will be displayed. It is possible to associate multiple values to
	 *   the same `ngSwitchWhen` by defining the optional attribute
	 *   `ngSwitchWhenSeparator`. The separator will be used to split the value of
	 *   the `ngSwitchWhen` attribute into multiple tokens, and the element will show
	 *   if any of the `ngSwitch` evaluates to any of these tokens.
	 * * `ngSwitchDefault`: the default case when no other case match. If there
	 *   are multiple default cases, all of them will be displayed when no other
	 *   case match.
	 *
	 *
	 * @example
	  <example module="switchExample" deps="angular-animate.js" animations="true" name="ng-switch">
	    <file name="index.html">
	      <div ng-controller="ExampleController">
	        <select ng-model="selection" ng-options="item for item in items">
	        </select>
	        <code>selection={{selection}}</code>
	        <hr/>
	        <div class="animate-switch-container"
	          ng-switch on="selection">
	            <div class="animate-switch" ng-switch-when="settings|options" ng-switch-when-separator="|">Settings Div</div>
	            <div class="animate-switch" ng-switch-when="home">Home Span</div>
	            <div class="animate-switch" ng-switch-default>default</div>
	        </div>
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('switchExample', ['ngAnimate'])
	        .controller('ExampleController', ['$scope', function($scope) {
	          $scope.items = ['settings', 'home', 'options', 'other'];
	          $scope.selection = $scope.items[0];
	        }]);
	    </file>
	    <file name="animations.css">
	      .animate-switch-container {
	        position:relative;
	        background:white;
	        border:1px solid black;
	        height:40px;
	        overflow:hidden;
	      }
	
	      .animate-switch {
	        padding:10px;
	      }
	
	      .animate-switch.ng-animate {
	        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	
	        position:absolute;
	        top:0;
	        left:0;
	        right:0;
	        bottom:0;
	      }
	
	      .animate-switch.ng-leave.ng-leave-active,
	      .animate-switch.ng-enter {
	        top:-50px;
	      }
	      .animate-switch.ng-leave,
	      .animate-switch.ng-enter.ng-enter-active {
	        top:0;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var switchElem = element(by.css('[ng-switch]'));
	      var select = element(by.model('selection'));
	
	      it('should start in settings', function() {
	        expect(switchElem.getText()).toMatch(/Settings Div/);
	      });
	      it('should change to home', function() {
	        select.all(by.css('option')).get(1).click();
	        expect(switchElem.getText()).toMatch(/Home Span/);
	      });
	      it('should change to settings via "options"', function() {
	        select.all(by.css('option')).get(2).click();
	        expect(switchElem.getText()).toMatch(/Settings Div/);
	      });
	      it('should select default', function() {
	        select.all(by.css('option')).get(3).click();
	        expect(switchElem.getText()).toMatch(/default/);
	      });
	    </file>
	  </example>
	 */
	var ngSwitchDirective = ['$animate', '$compile', function($animate, $compile) {
	  return {
	    require: 'ngSwitch',
	
	    // asks for $scope to fool the BC controller module
	    controller: ['$scope', function NgSwitchController() {
	     this.cases = {};
	    }],
	    link: function(scope, element, attr, ngSwitchController) {
	      var watchExpr = attr.ngSwitch || attr.on,
	          selectedTranscludes = [],
	          selectedElements = [],
	          previousLeaveAnimations = [],
	          selectedScopes = [];
	
	      var spliceFactory = function(array, index) {
	          return function(response) {
	            if (response !== false) array.splice(index, 1);
	          };
	      };
	
	      scope.$watch(watchExpr, function ngSwitchWatchAction(value) {
	        var i, ii;
	
	        // Start with the last, in case the array is modified during the loop
	        while (previousLeaveAnimations.length) {
	          $animate.cancel(previousLeaveAnimations.pop());
	        }
	
	        for (i = 0, ii = selectedScopes.length; i < ii; ++i) {
	          var selected = getBlockNodes(selectedElements[i].clone);
	          selectedScopes[i].$destroy();
	          var runner = previousLeaveAnimations[i] = $animate.leave(selected);
	          runner.done(spliceFactory(previousLeaveAnimations, i));
	        }
	
	        selectedElements.length = 0;
	        selectedScopes.length = 0;
	
	        if ((selectedTranscludes = ngSwitchController.cases['!' + value] || ngSwitchController.cases['?'])) {
	          forEach(selectedTranscludes, function(selectedTransclude) {
	            selectedTransclude.transclude(function(caseElement, selectedScope) {
	              selectedScopes.push(selectedScope);
	              var anchor = selectedTransclude.element;
	              caseElement[caseElement.length++] = $compile.$$createComment('end ngSwitchWhen');
	              var block = { clone: caseElement };
	
	              selectedElements.push(block);
	              $animate.enter(caseElement, anchor.parent(), anchor);
	            });
	          });
	        }
	      });
	    }
	  };
	}];
	
	var ngSwitchWhenDirective = ngDirective({
	  transclude: 'element',
	  priority: 1200,
	  require: '^ngSwitch',
	  multiElement: true,
	  link: function(scope, element, attrs, ctrl, $transclude) {
	
	    var cases = attrs.ngSwitchWhen.split(attrs.ngSwitchWhenSeparator).sort().filter(
	      // Filter duplicate cases
	      function(element, index, array) { return array[index - 1] !== element; }
	    );
	
	    forEach(cases, function(whenCase) {
	      ctrl.cases['!' + whenCase] = (ctrl.cases['!' + whenCase] || []);
	      ctrl.cases['!' + whenCase].push({ transclude: $transclude, element: element });
	    });
	  }
	});
	
	var ngSwitchDefaultDirective = ngDirective({
	  transclude: 'element',
	  priority: 1200,
	  require: '^ngSwitch',
	  multiElement: true,
	  link: function(scope, element, attr, ctrl, $transclude) {
	    ctrl.cases['?'] = (ctrl.cases['?'] || []);
	    ctrl.cases['?'].push({ transclude: $transclude, element: element });
	   }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngTransclude
	 * @restrict EAC
	 *
	 * @description
	 * Directive that marks the insertion point for the transcluded DOM of the nearest parent directive that uses transclusion.
	 *
	 * You can specify that you want to insert a named transclusion slot, instead of the default slot, by providing the slot name
	 * as the value of the `ng-transclude` or `ng-transclude-slot` attribute.
	 *
	 * If the transcluded content is not empty (i.e. contains one or more DOM nodes, including whitespace text nodes), any existing
	 * content of this element will be removed before the transcluded content is inserted.
	 * If the transcluded content is empty (or only whitespace), the existing content is left intact. This lets you provide fallback
	 * content in the case that no transcluded content is provided.
	 *
	 * @element ANY
	 *
	 * @param {string} ngTransclude|ngTranscludeSlot the name of the slot to insert at this point. If this is not provided, is empty
	 *                                               or its value is the same as the name of the attribute then the default slot is used.
	 *
	 * @example
	 * ### Basic transclusion
	 * This example demonstrates basic transclusion of content into a component directive.
	 * <example name="simpleTranscludeExample" module="transcludeExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('transcludeExample', [])
	 *        .directive('pane', function(){
	 *           return {
	 *             restrict: 'E',
	 *             transclude: true,
	 *             scope: { title:'@' },
	 *             template: '<div style="border: 1px solid black;">' +
	 *                         '<div style="background-color: gray">{{title}}</div>' +
	 *                         '<ng-transclude></ng-transclude>' +
	 *                       '</div>'
	 *           };
	 *       })
	 *       .controller('ExampleController', ['$scope', function($scope) {
	 *         $scope.title = 'Lorem Ipsum';
	 *         $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
	 *       }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <input ng-model="title" aria-label="title"> <br/>
	 *       <textarea ng-model="text" aria-label="text"></textarea> <br/>
	 *       <pane title="{{title}}"><span>{{text}}</span></pane>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *      it('should have transcluded', function() {
	 *        var titleElement = element(by.model('title'));
	 *        titleElement.clear();
	 *        titleElement.sendKeys('TITLE');
	 *        var textElement = element(by.model('text'));
	 *        textElement.clear();
	 *        textElement.sendKeys('TEXT');
	 *        expect(element(by.binding('title')).getText()).toEqual('TITLE');
	 *        expect(element(by.binding('text')).getText()).toEqual('TEXT');
	 *      });
	 *   </file>
	 * </example>
	 *
	 * @example
	 * ### Transclude fallback content
	 * This example shows how to use `NgTransclude` with fallback content, that
	 * is displayed if no transcluded content is provided.
	 *
	 * <example module="transcludeFallbackContentExample" name="ng-transclude">
	 * <file name="index.html">
	 * <script>
	 * angular.module('transcludeFallbackContentExample', [])
	 * .directive('myButton', function(){
	 *             return {
	 *               restrict: 'E',
	 *               transclude: true,
	 *               scope: true,
	 *               template: '<button style="cursor: pointer;">' +
	 *                           '<ng-transclude>' +
	 *                             '<b style="color: red;">Button1</b>' +
	 *                           '</ng-transclude>' +
	 *                         '</button>'
	 *             };
	 *         });
	 * </script>
	 * <!-- fallback button content -->
	 * <my-button id="fallback"></my-button>
	 * <!-- modified button content -->
	 * <my-button id="modified">
	 *   <i style="color: green;">Button2</i>
	 * </my-button>
	 * </file>
	 * <file name="protractor.js" type="protractor">
	 * it('should have different transclude element content', function() {
	 *          expect(element(by.id('fallback')).getText()).toBe('Button1');
	 *          expect(element(by.id('modified')).getText()).toBe('Button2');
	 *        });
	 * </file>
	 * </example>
	 *
	 * @example
	 * ### Multi-slot transclusion
	 * This example demonstrates using multi-slot transclusion in a component directive.
	 * <example name="multiSlotTranscludeExample" module="multiSlotTranscludeExample">
	 *   <file name="index.html">
	 *    <style>
	 *      .title, .footer {
	 *        background-color: gray
	 *      }
	 *    </style>
	 *    <div ng-controller="ExampleController">
	 *      <input ng-model="title" aria-label="title"> <br/>
	 *      <textarea ng-model="text" aria-label="text"></textarea> <br/>
	 *      <pane>
	 *        <pane-title><a ng-href="{{link}}">{{title}}</a></pane-title>
	 *        <pane-body><p>{{text}}</p></pane-body>
	 *      </pane>
	 *    </div>
	 *   </file>
	 *   <file name="app.js">
	 *    angular.module('multiSlotTranscludeExample', [])
	 *     .directive('pane', function() {
	 *        return {
	 *          restrict: 'E',
	 *          transclude: {
	 *            'title': '?paneTitle',
	 *            'body': 'paneBody',
	 *            'footer': '?paneFooter'
	 *          },
	 *          template: '<div style="border: 1px solid black;">' +
	 *                      '<div class="title" ng-transclude="title">Fallback Title</div>' +
	 *                      '<div ng-transclude="body"></div>' +
	 *                      '<div class="footer" ng-transclude="footer">Fallback Footer</div>' +
	 *                    '</div>'
	 *        };
	 *    })
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.title = 'Lorem Ipsum';
	 *      $scope.link = 'https://google.com';
	 *      $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
	 *    }]);
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *      it('should have transcluded the title and the body', function() {
	 *        var titleElement = element(by.model('title'));
	 *        titleElement.clear();
	 *        titleElement.sendKeys('TITLE');
	 *        var textElement = element(by.model('text'));
	 *        textElement.clear();
	 *        textElement.sendKeys('TEXT');
	 *        expect(element(by.css('.title')).getText()).toEqual('TITLE');
	 *        expect(element(by.binding('text')).getText()).toEqual('TEXT');
	 *        expect(element(by.css('.footer')).getText()).toEqual('Fallback Footer');
	 *      });
	 *   </file>
	 * </example>
	 */
	var ngTranscludeMinErr = minErr('ngTransclude');
	var ngTranscludeDirective = ['$compile', function($compile) {
	  return {
	    restrict: 'EAC',
	    compile: function ngTranscludeCompile(tElement) {
	
	      // Remove and cache any original content to act as a fallback
	      var fallbackLinkFn = $compile(tElement.contents());
	      tElement.empty();
	
	      return function ngTranscludePostLink($scope, $element, $attrs, controller, $transclude) {
	
	        if (!$transclude) {
	          throw ngTranscludeMinErr('orphan',
	          'Illegal use of ngTransclude directive in the template! ' +
	          'No parent directive that requires a transclusion found. ' +
	          'Element: {0}',
	          startingTag($element));
	        }
	
	
	        // If the attribute is of the form: `ng-transclude="ng-transclude"` then treat it like the default
	        if ($attrs.ngTransclude === $attrs.$attr.ngTransclude) {
	          $attrs.ngTransclude = '';
	        }
	        var slotName = $attrs.ngTransclude || $attrs.ngTranscludeSlot;
	
	        // If the slot is required and no transclusion content is provided then this call will throw an error
	        $transclude(ngTranscludeCloneAttachFn, null, slotName);
	
	        // If the slot is optional and no transclusion content is provided then use the fallback content
	        if (slotName && !$transclude.isSlotFilled(slotName)) {
	          useFallbackContent();
	        }
	
	        function ngTranscludeCloneAttachFn(clone, transcludedScope) {
	          if (clone.length && notWhitespace(clone)) {
	            $element.append(clone);
	          } else {
	            useFallbackContent();
	            // There is nothing linked against the transcluded scope since no content was available,
	            // so it should be safe to clean up the generated scope.
	            transcludedScope.$destroy();
	          }
	        }
	
	        function useFallbackContent() {
	          // Since this is the fallback content rather than the transcluded content,
	          // we link against the scope of this directive rather than the transcluded scope
	          fallbackLinkFn($scope, function(clone) {
	            $element.append(clone);
	          });
	        }
	
	        function notWhitespace(nodes) {
	          for (var i = 0, ii = nodes.length; i < ii; i++) {
	            var node = nodes[i];
	            if (node.nodeType !== NODE_TYPE_TEXT || node.nodeValue.trim()) {
	              return true;
	            }
	          }
	        }
	      };
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name script
	 * @restrict E
	 *
	 * @description
	 * Load the content of a `<script>` element into {@link ng.$templateCache `$templateCache`}, so that the
	 * template can be used by {@link ng.directive:ngInclude `ngInclude`},
	 * {@link ngRoute.directive:ngView `ngView`}, or {@link guide/directive directives}. The type of the
	 * `<script>` element must be specified as `text/ng-template`, and a cache name for the template must be
	 * assigned through the element's `id`, which can then be used as a directive's `templateUrl`.
	 *
	 * @param {string} type Must be set to `'text/ng-template'`.
	 * @param {string} id Cache name of the template.
	 *
	 * @example
	  <example  name="script-tag">
	    <file name="index.html">
	      <script type="text/ng-template" id="/tpl.html">
	        Content of the template.
	      </script>
	
	      <a ng-click="currentTpl='/tpl.html'" id="tpl-link">Load inlined template</a>
	      <div id="tpl-content" ng-include src="currentTpl"></div>
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should load template defined inside script tag', function() {
	        element(by.css('#tpl-link')).click();
	        expect(element(by.css('#tpl-content')).getText()).toMatch(/Content of the template/);
	      });
	    </file>
	  </example>
	 */
	var scriptDirective = ['$templateCache', function($templateCache) {
	  return {
	    restrict: 'E',
	    terminal: true,
	    compile: function(element, attr) {
	      if (attr.type === 'text/ng-template') {
	        var templateUrl = attr.id,
	            text = element[0].text;
	
	        $templateCache.put(templateUrl, text);
	      }
	    }
	  };
	}];
	
	/* exported selectDirective, optionDirective */
	
	var noopNgModelController = { $setViewValue: noop, $render: noop };
	
	function setOptionSelectedStatus(optionEl, value) {
	  optionEl.prop('selected', value);
	  /**
	   * When unselecting an option, setting the property to null / false should be enough
	   * However, screenreaders might react to the selected attribute instead, see
	   * https://github.com/angular/angular.js/issues/14419
	   * Note: "selected" is a boolean attr and will be removed when the "value" arg in attr() is false
	   * or null
	   */
	  optionEl.attr('selected', value);
	}
	
	/**
	 * @ngdoc type
	 * @name  select.SelectController
	 *
	 * @description
	 * The controller for the {@link ng.select select} directive. The controller exposes
	 * a few utility methods that can be used to augment the behavior of a regular or an
	 * {@link ng.ngOptions ngOptions} select element.
	 *
	 * @example
	 * ### Set a custom error when the unknown option is selected
	 *
	 * This example sets a custom error "unknownValue" on the ngModelController
	 * when the select element's unknown option is selected, i.e. when the model is set to a value
	 * that is not matched by any option.
	 *
	 * <example name="select-unknown-value-error" module="staticSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="testSelect"> Single select: </label><br>
	 *     <select name="testSelect" ng-model="selected" unknown-value-error>
	 *       <option value="option-1">Option 1</option>
	 *       <option value="option-2">Option 2</option>
	 *     </select><br>
	 *     <span class="error" ng-if="myForm.testSelect.$error.unknownValue">
	 *       Error: The current model doesn't match any option</span><br>
	 *
	 *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
	 *   </form>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('staticSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.selected = null;
	 *
	 *      $scope.forceUnknownOption = function() {
	 *        $scope.selected = 'nonsense';
	 *      };
	 *   }])
	 *   .directive('unknownValueError', function() {
	 *     return {
	 *       require: ['ngModel', 'select'],
	 *       link: function(scope, element, attrs, ctrls) {
	 *         var ngModelCtrl = ctrls[0];
	 *         var selectCtrl = ctrls[1];
	 *
	 *         ngModelCtrl.$validators.unknownValue = function(modelValue, viewValue) {
	 *           if (selectCtrl.$isUnknownOptionSelected()) {
	 *             return false;
	 *           }
	 *
	 *           return true;
	 *         };
	 *       }
	 *
	 *     };
	 *   });
	 * </file>
	 *</example>
	 *
	 *
	 * @example
	 * ### Set the "required" error when the unknown option is selected.
	 *
	 * By default, the "required" error on the ngModelController is only set on a required select
	 * when the empty option is selected. This example adds a custom directive that also sets the
	 * error when the unknown option is selected.
	 *
	 * <example name="select-unknown-value-required" module="staticSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="testSelect"> Select: </label><br>
	 *     <select name="testSelect" ng-model="selected" required unknown-value-required>
	 *       <option value="option-1">Option 1</option>
	 *       <option value="option-2">Option 2</option>
	 *     </select><br>
	 *     <span class="error" ng-if="myForm.testSelect.$error.required">Error: Please select a value</span><br>
	 *
	 *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
	 *   </form>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('staticSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.selected = null;
	 *
	 *      $scope.forceUnknownOption = function() {
	 *        $scope.selected = 'nonsense';
	 *      };
	 *   }])
	 *   .directive('unknownValueRequired', function() {
	 *     return {
	 *       priority: 1, // This directive must run after the required directive has added its validator
	 *       require: ['ngModel', 'select'],
	 *       link: function(scope, element, attrs, ctrls) {
	 *         var ngModelCtrl = ctrls[0];
	 *         var selectCtrl = ctrls[1];
	 *
	 *         var originalRequiredValidator = ngModelCtrl.$validators.required;
	 *
	 *         ngModelCtrl.$validators.required = function() {
	 *           if (attrs.required && selectCtrl.$isUnknownOptionSelected()) {
	 *             return false;
	 *           }
	 *
	 *           return originalRequiredValidator.apply(this, arguments);
	 *         };
	 *       }
	 *     };
	 *   });
	 * </file>
	 * <file name="protractor.js" type="protractor">
	 *  it('should show the error message when the unknown option is selected', function() {
	
	      var error = element(by.className('error'));
	
	      expect(error.getText()).toBe('Error: Please select a value');
	
	      element(by.cssContainingText('option', 'Option 1')).click();
	
	      expect(error.isPresent()).toBe(false);
	
	      element(by.tagName('button')).click();
	
	      expect(error.getText()).toBe('Error: Please select a value');
	    });
	 * </file>
	 *</example>
	 *
	 *
	 */
	var SelectController =
	        ['$element', '$scope', /** @this */ function($element, $scope) {
	
	  var self = this,
	      optionsMap = new NgMap();
	
	  self.selectValueMap = {}; // Keys are the hashed values, values the original values
	
	  // If the ngModel doesn't get provided then provide a dummy noop version to prevent errors
	  self.ngModelCtrl = noopNgModelController;
	  self.multiple = false;
	
	  // The "unknown" option is one that is prepended to the list if the viewValue
	  // does not match any of the options. When it is rendered the value of the unknown
	  // option is '? XXX ?' where XXX is the hashKey of the value that is not known.
	  //
	  // Support: IE 9 only
	  // We can't just jqLite('<option>') since jqLite is not smart enough
	  // to create it in <select> and IE barfs otherwise.
	  self.unknownOption = jqLite(window.document.createElement('option'));
	
	  // The empty option is an option with the value '' that the application developer can
	  // provide inside the select. It is always selectable and indicates that a "null" selection has
	  // been made by the user.
	  // If the select has an empty option, and the model of the select is set to "undefined" or "null",
	  // the empty option is selected.
	  // If the model is set to a different unmatched value, the unknown option is rendered and
	  // selected, i.e both are present, because a "null" selection and an unknown value are different.
	  self.hasEmptyOption = false;
	  self.emptyOption = undefined;
	
	  self.renderUnknownOption = function(val) {
	    var unknownVal = self.generateUnknownOptionValue(val);
	    self.unknownOption.val(unknownVal);
	    $element.prepend(self.unknownOption);
	    setOptionSelectedStatus(self.unknownOption, true);
	    $element.val(unknownVal);
	  };
	
	  self.updateUnknownOption = function(val) {
	    var unknownVal = self.generateUnknownOptionValue(val);
	    self.unknownOption.val(unknownVal);
	    setOptionSelectedStatus(self.unknownOption, true);
	    $element.val(unknownVal);
	  };
	
	  self.generateUnknownOptionValue = function(val) {
	    return '? ' + hashKey(val) + ' ?';
	  };
	
	  self.removeUnknownOption = function() {
	    if (self.unknownOption.parent()) self.unknownOption.remove();
	  };
	
	  self.selectEmptyOption = function() {
	    if (self.emptyOption) {
	      $element.val('');
	      setOptionSelectedStatus(self.emptyOption, true);
	    }
	  };
	
	  self.unselectEmptyOption = function() {
	    if (self.hasEmptyOption) {
	      setOptionSelectedStatus(self.emptyOption, false);
	    }
	  };
	
	  $scope.$on('$destroy', function() {
	    // disable unknown option so that we don't do work when the whole select is being destroyed
	    self.renderUnknownOption = noop;
	  });
	
	  // Read the value of the select control, the implementation of this changes depending
	  // upon whether the select can have multiple values and whether ngOptions is at work.
	  self.readValue = function readSingleValue() {
	    var val = $element.val();
	    // ngValue added option values are stored in the selectValueMap, normal interpolations are not
	    var realVal = val in self.selectValueMap ? self.selectValueMap[val] : val;
	
	    if (self.hasOption(realVal)) {
	      return realVal;
	    }
	
	    return null;
	  };
	
	
	  // Write the value to the select control, the implementation of this changes depending
	  // upon whether the select can have multiple values and whether ngOptions is at work.
	  self.writeValue = function writeSingleValue(value) {
	    // Make sure to remove the selected attribute from the previously selected option
	    // Otherwise, screen readers might get confused
	    var currentlySelectedOption = $element[0].options[$element[0].selectedIndex];
	    if (currentlySelectedOption) setOptionSelectedStatus(jqLite(currentlySelectedOption), false);
	
	    if (self.hasOption(value)) {
	      self.removeUnknownOption();
	
	      var hashedVal = hashKey(value);
	      $element.val(hashedVal in self.selectValueMap ? hashedVal : value);
	
	      // Set selected attribute and property on selected option for screen readers
	      var selectedOption = $element[0].options[$element[0].selectedIndex];
	      setOptionSelectedStatus(jqLite(selectedOption), true);
	    } else {
	      self.selectUnknownOrEmptyOption(value);
	    }
	  };
	
	
	  // Tell the select control that an option, with the given value, has been added
	  self.addOption = function(value, element) {
	    // Skip comment nodes, as they only pollute the `optionsMap`
	    if (element[0].nodeType === NODE_TYPE_COMMENT) return;
	
	    assertNotHasOwnProperty(value, '"option value"');
	    if (value === '') {
	      self.hasEmptyOption = true;
	      self.emptyOption = element;
	    }
	    var count = optionsMap.get(value) || 0;
	    optionsMap.set(value, count + 1);
	    // Only render at the end of a digest. This improves render performance when many options
	    // are added during a digest and ensures all relevant options are correctly marked as selected
	    scheduleRender();
	  };
	
	  // Tell the select control that an option, with the given value, has been removed
	  self.removeOption = function(value) {
	    var count = optionsMap.get(value);
	    if (count) {
	      if (count === 1) {
	        optionsMap.delete(value);
	        if (value === '') {
	          self.hasEmptyOption = false;
	          self.emptyOption = undefined;
	        }
	      } else {
	        optionsMap.set(value, count - 1);
	      }
	    }
	  };
	
	  // Check whether the select control has an option matching the given value
	  self.hasOption = function(value) {
	    return !!optionsMap.get(value);
	  };
	
	  /**
	   * @ngdoc method
	   * @name select.SelectController#$hasEmptyOption
	   *
	   * @description
	   *
	   * Returns `true` if the select element currently has an empty option
	   * element, i.e. an option that signifies that the select is empty / the selection is null.
	   *
	   */
	  self.$hasEmptyOption = function() {
	    return self.hasEmptyOption;
	  };
	
	  /**
	   * @ngdoc method
	   * @name select.SelectController#$isUnknownOptionSelected
	   *
	   * @description
	   *
	   * Returns `true` if the select element's unknown option is selected. The unknown option is added
	   * and automatically selected whenever the select model doesn't match any option.
	   *
	   */
	  self.$isUnknownOptionSelected = function() {
	    // Presence of the unknown option means it is selected
	    return $element[0].options[0] === self.unknownOption[0];
	  };
	
	  /**
	   * @ngdoc method
	   * @name select.SelectController#$isEmptyOptionSelected
	   *
	   * @description
	   *
	   * Returns `true` if the select element has an empty option and this empty option is currently
	   * selected. Returns `false` if the select element has no empty option or it is not selected.
	   *
	   */
	  self.$isEmptyOptionSelected = function() {
	    return self.hasEmptyOption && $element[0].options[$element[0].selectedIndex] === self.emptyOption[0];
	  };
	
	  self.selectUnknownOrEmptyOption = function(value) {
	    if (value == null && self.emptyOption) {
	      self.removeUnknownOption();
	      self.selectEmptyOption();
	    } else if (self.unknownOption.parent().length) {
	      self.updateUnknownOption(value);
	    } else {
	      self.renderUnknownOption(value);
	    }
	  };
	
	  var renderScheduled = false;
	  function scheduleRender() {
	    if (renderScheduled) return;
	    renderScheduled = true;
	    $scope.$$postDigest(function() {
	      renderScheduled = false;
	      self.ngModelCtrl.$render();
	    });
	  }
	
	  var updateScheduled = false;
	  function scheduleViewValueUpdate(renderAfter) {
	    if (updateScheduled) return;
	
	    updateScheduled = true;
	
	    $scope.$$postDigest(function() {
	      if ($scope.$$destroyed) return;
	
	      updateScheduled = false;
	      self.ngModelCtrl.$setViewValue(self.readValue());
	      if (renderAfter) self.ngModelCtrl.$render();
	    });
	  }
	
	
	  self.registerOption = function(optionScope, optionElement, optionAttrs, interpolateValueFn, interpolateTextFn) {
	
	    if (optionAttrs.$attr.ngValue) {
	      // The value attribute is set by ngValue
	      var oldVal, hashedVal;
	      optionAttrs.$observe('value', function valueAttributeObserveAction(newVal) {
	
	        var removal;
	        var previouslySelected = optionElement.prop('selected');
	
	        if (isDefined(hashedVal)) {
	          self.removeOption(oldVal);
	          delete self.selectValueMap[hashedVal];
	          removal = true;
	        }
	
	        hashedVal = hashKey(newVal);
	        oldVal = newVal;
	        self.selectValueMap[hashedVal] = newVal;
	        self.addOption(newVal, optionElement);
	        // Set the attribute directly instead of using optionAttrs.$set - this stops the observer
	        // from firing a second time. Other $observers on value will also get the result of the
	        // ngValue expression, not the hashed value
	        optionElement.attr('value', hashedVal);
	
	        if (removal && previouslySelected) {
	          scheduleViewValueUpdate();
	        }
	
	      });
	    } else if (interpolateValueFn) {
	      // The value attribute is interpolated
	      optionAttrs.$observe('value', function valueAttributeObserveAction(newVal) {
	        // This method is overwritten in ngOptions and has side-effects!
	        self.readValue();
	
	        var removal;
	        var previouslySelected = optionElement.prop('selected');
	
	        if (isDefined(oldVal)) {
	          self.removeOption(oldVal);
	          removal = true;
	        }
	        oldVal = newVal;
	        self.addOption(newVal, optionElement);
	
	        if (removal && previouslySelected) {
	          scheduleViewValueUpdate();
	        }
	      });
	    } else if (interpolateTextFn) {
	      // The text content is interpolated
	      optionScope.$watch(interpolateTextFn, function interpolateWatchAction(newVal, oldVal) {
	        optionAttrs.$set('value', newVal);
	        var previouslySelected = optionElement.prop('selected');
	        if (oldVal !== newVal) {
	          self.removeOption(oldVal);
	        }
	        self.addOption(newVal, optionElement);
	
	        if (oldVal && previouslySelected) {
	          scheduleViewValueUpdate();
	        }
	      });
	    } else {
	      // The value attribute is static
	      self.addOption(optionAttrs.value, optionElement);
	    }
	
	
	    optionAttrs.$observe('disabled', function(newVal) {
	
	      // Since model updates will also select disabled options (like ngOptions),
	      // we only have to handle options becoming disabled, not enabled
	
	      if (newVal === 'true' || newVal && optionElement.prop('selected')) {
	        if (self.multiple) {
	          scheduleViewValueUpdate(true);
	        } else {
	          self.ngModelCtrl.$setViewValue(null);
	          self.ngModelCtrl.$render();
	        }
	      }
	    });
	
	    optionElement.on('$destroy', function() {
	      var currentValue = self.readValue();
	      var removeValue = optionAttrs.value;
	
	      self.removeOption(removeValue);
	      scheduleRender();
	
	      if (self.multiple && currentValue && currentValue.indexOf(removeValue) !== -1 ||
	          currentValue === removeValue
	      ) {
	        // When multiple (selected) options are destroyed at the same time, we don't want
	        // to run a model update for each of them. Instead, run a single update in the $$postDigest
	        scheduleViewValueUpdate(true);
	      }
	    });
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name select
	 * @restrict E
	 *
	 * @description
	 * HTML `select` element with AngularJS data-binding.
	 *
	 * The `select` directive is used together with {@link ngModel `ngModel`} to provide data-binding
	 * between the scope and the `<select>` control (including setting default values).
	 * It also handles dynamic `<option>` elements, which can be added using the {@link ngRepeat `ngRepeat}` or
	 * {@link ngOptions `ngOptions`} directives.
	 *
	 * When an item in the `<select>` menu is selected, the value of the selected option will be bound
	 * to the model identified by the `ngModel` directive. With static or repeated options, this is
	 * the content of the `value` attribute or the textContent of the `<option>`, if the value attribute is missing.
	 * Value and textContent can be interpolated.
	 *
	 * The {@link select.SelectController select controller} exposes utility functions that can be used
	 * to manipulate the select's behavior.
	 *
	 * ## Matching model and option values
	 *
	 * In general, the match between the model and an option is evaluated by strictly comparing the model
	 * value against the value of the available options.
	 *
	 * If you are setting the option value with the option's `value` attribute, or textContent, the
	 * value will always be a `string` which means that the model value must also be a string.
	 * Otherwise the `select` directive cannot match them correctly.
	 *
	 * To bind the model to a non-string value, you can use one of the following strategies:
	 * - the {@link ng.ngOptions `ngOptions`} directive
	 *   ({@link ng.select#using-select-with-ngoptions-and-setting-a-default-value})
	 * - the {@link ng.ngValue `ngValue`} directive, which allows arbitrary expressions to be
	 *   option values ({@link ng.select#using-ngvalue-to-bind-the-model-to-an-array-of-objects Example})
	 * - model $parsers / $formatters to convert the string value
	 *   ({@link ng.select#binding-select-to-a-non-string-value-via-ngmodel-parsing-formatting Example})
	 *
	 * If the viewValue of `ngModel` does not match any of the options, then the control
	 * will automatically add an "unknown" option, which it then removes when the mismatch is resolved.
	 *
	 * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
	 * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
	 * option. See example below for demonstration.
	 *
	 * ## Choosing between `ngRepeat` and `ngOptions`
	 *
	 * In many cases, `ngRepeat` can be used on `<option>` elements instead of {@link ng.directive:ngOptions
	 * ngOptions} to achieve a similar result. However, `ngOptions` provides some benefits:
	 * - more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
	 * comprehension expression
	 * - reduced memory consumption by not creating a new scope for each repeated instance
	 * - increased render speed by creating the options in a documentFragment instead of individually
	 *
	 * Specifically, select with repeated options slows down significantly starting at 2000 options in
	 * Chrome and Internet Explorer / Edge.
	 *
	 *
	 * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} multiple Allows multiple options to be selected. The selected values will be
	 *     bound to the model as an array.
	 * @param {string=} required Sets `required` validation error key if the value is not entered.
	 * @param {string=} ngRequired Adds required attribute and required validation constraint to
	 * the element when the ngRequired expression evaluates to true. Use ngRequired instead of required
	 * when you want to data-bind to the required attribute.
	 * @param {string=} ngChange AngularJS expression to be executed when selected option(s) changes due to user
	 *    interaction with the select element.
	 * @param {string=} ngOptions sets the options that the select is populated with and defines what is
	 * set on the model on selection. See {@link ngOptions `ngOptions`}.
	 * @param {string=} ngAttrSize sets the size of the select element dynamically. Uses the
	 * {@link guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes ngAttr} directive.
	 *
	 *
	 * @example
	 * ### Simple `select` elements with static options
	 *
	 * <example name="static-select" module="staticSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="singleSelect"> Single select: </label><br>
	 *     <select name="singleSelect" ng-model="data.singleSelect">
	 *       <option value="option-1">Option 1</option>
	 *       <option value="option-2">Option 2</option>
	 *     </select><br>
	 *
	 *     <label for="singleSelect"> Single select with "not selected" option and dynamic option values: </label><br>
	 *     <select name="singleSelect" id="singleSelect" ng-model="data.singleSelect">
	 *       <option value="">---Please select---</option> <!-- not selected / blank option -->
	 *       <option value="{{data.option1}}">Option 1</option> <!-- interpolation -->
	 *       <option value="option-2">Option 2</option>
	 *     </select><br>
	 *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
	 *     <tt>singleSelect = {{data.singleSelect}}</tt>
	 *
	 *     <hr>
	 *     <label for="multipleSelect"> Multiple select: </label><br>
	 *     <select name="multipleSelect" id="multipleSelect" ng-model="data.multipleSelect" multiple>
	 *       <option value="option-1">Option 1</option>
	 *       <option value="option-2">Option 2</option>
	 *       <option value="option-3">Option 3</option>
	 *     </select><br>
	 *     <tt>multipleSelect = {{data.multipleSelect}}</tt><br/>
	 *   </form>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('staticSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       singleSelect: null,
	 *       multipleSelect: [],
	 *       option1: 'option-1'
	 *      };
	 *
	 *      $scope.forceUnknownOption = function() {
	 *        $scope.data.singleSelect = 'nonsense';
	 *      };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 * @example
	 * ### Using `ngRepeat` to generate `select` options
	 * <example name="select-ngrepeat" module="ngrepeatSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="repeatSelect"> Repeat select: </label>
	 *     <select name="repeatSelect" id="repeatSelect" ng-model="data.model">
	 *       <option ng-repeat="option in data.availableOptions" value="{{option.id}}">{{option.name}}</option>
	 *     </select>
	 *   </form>
	 *   <hr>
	 *   <tt>model = {{data.model}}</tt><br/>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('ngrepeatSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       model: null,
	 *       availableOptions: [
	 *         {id: '1', name: 'Option A'},
	 *         {id: '2', name: 'Option B'},
	 *         {id: '3', name: 'Option C'}
	 *       ]
	 *      };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 * @example
	 * ### Using `ngValue` to bind the model to an array of objects
	 * <example name="select-ngvalue" module="ngvalueSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="ngvalueselect"> ngvalue select: </label>
	 *     <select size="6" name="ngvalueselect" ng-model="data.model" multiple>
	 *       <option ng-repeat="option in data.availableOptions" ng-value="option.value">{{option.name}}</option>
	 *     </select>
	 *   </form>
	 *   <hr>
	 *   <pre>model = {{data.model | json}}</pre><br/>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('ngvalueSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       model: null,
	 *       availableOptions: [
	           {value: 'myString', name: 'string'},
	           {value: 1, name: 'integer'},
	           {value: true, name: 'boolean'},
	           {value: null, name: 'null'},
	           {value: {prop: 'value'}, name: 'object'},
	           {value: ['a'], name: 'array'}
	 *       ]
	 *      };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 * @example
	 * ### Using `select` with `ngOptions` and setting a default value
	 * See the {@link ngOptions ngOptions documentation} for more `ngOptions` usage examples.
	 *
	 * <example name="select-with-default-values" module="defaultValueSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="mySelect">Make a choice:</label>
	 *     <select name="mySelect" id="mySelect"
	 *       ng-options="option.name for option in data.availableOptions track by option.id"
	 *       ng-model="data.selectedOption"></select>
	 *   </form>
	 *   <hr>
	 *   <tt>option = {{data.selectedOption}}</tt><br/>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('defaultValueSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       availableOptions: [
	 *         {id: '1', name: 'Option A'},
	 *         {id: '2', name: 'Option B'},
	 *         {id: '3', name: 'Option C'}
	 *       ],
	 *       selectedOption: {id: '3', name: 'Option C'} //This sets the default value of the select in the ui
	 *       };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 * @example
	 * ### Binding `select` to a non-string value via `ngModel` parsing / formatting
	 *
	 * <example name="select-with-non-string-options" module="nonStringSelect">
	 *   <file name="index.html">
	 *     <select ng-model="model.id" convert-to-number>
	 *       <option value="0">Zero</option>
	 *       <option value="1">One</option>
	 *       <option value="2">Two</option>
	 *     </select>
	 *     {{ model }}
	 *   </file>
	 *   <file name="app.js">
	 *     angular.module('nonStringSelect', [])
	 *       .run(function($rootScope) {
	 *         $rootScope.model = { id: 2 };
	 *       })
	 *       .directive('convertToNumber', function() {
	 *         return {
	 *           require: 'ngModel',
	 *           link: function(scope, element, attrs, ngModel) {
	 *             ngModel.$parsers.push(function(val) {
	 *               return parseInt(val, 10);
	 *             });
	 *             ngModel.$formatters.push(function(val) {
	 *               return '' + val;
	 *             });
	 *           }
	 *         };
	 *       });
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     it('should initialize to model', function() {
	 *       expect(element(by.model('model.id')).$('option:checked').getText()).toEqual('Two');
	 *     });
	 *   </file>
	 * </example>
	 *
	 */
	var selectDirective = function() {
	
	  return {
	    restrict: 'E',
	    require: ['select', '?ngModel'],
	    controller: SelectController,
	    priority: 1,
	    link: {
	      pre: selectPreLink,
	      post: selectPostLink
	    }
	  };
	
	  function selectPreLink(scope, element, attr, ctrls) {
	
	      var selectCtrl = ctrls[0];
	      var ngModelCtrl = ctrls[1];
	
	      // if ngModel is not defined, we don't need to do anything but set the registerOption
	      // function to noop, so options don't get added internally
	      if (!ngModelCtrl) {
	        selectCtrl.registerOption = noop;
	        return;
	      }
	
	
	      selectCtrl.ngModelCtrl = ngModelCtrl;
	
	      // When the selected item(s) changes we delegate getting the value of the select control
	      // to the `readValue` method, which can be changed if the select can have multiple
	      // selected values or if the options are being generated by `ngOptions`
	      element.on('change', function() {
	        selectCtrl.removeUnknownOption();
	        scope.$apply(function() {
	          ngModelCtrl.$setViewValue(selectCtrl.readValue());
	        });
	      });
	
	      // If the select allows multiple values then we need to modify how we read and write
	      // values from and to the control; also what it means for the value to be empty and
	      // we have to add an extra watch since ngModel doesn't work well with arrays - it
	      // doesn't trigger rendering if only an item in the array changes.
	      if (attr.multiple) {
	        selectCtrl.multiple = true;
	
	        // Read value now needs to check each option to see if it is selected
	        selectCtrl.readValue = function readMultipleValue() {
	          var array = [];
	          forEach(element.find('option'), function(option) {
	            if (option.selected && !option.disabled) {
	              var val = option.value;
	              array.push(val in selectCtrl.selectValueMap ? selectCtrl.selectValueMap[val] : val);
	            }
	          });
	          return array;
	        };
	
	        // Write value now needs to set the selected property of each matching option
	        selectCtrl.writeValue = function writeMultipleValue(value) {
	          forEach(element.find('option'), function(option) {
	            var shouldBeSelected = !!value && (includes(value, option.value) ||
	                                               includes(value, selectCtrl.selectValueMap[option.value]));
	            var currentlySelected = option.selected;
	
	            // Support: IE 9-11 only, Edge 12-15+
	            // In IE and Edge adding options to the selection via shift+click/UP/DOWN
	            // will de-select already selected options if "selected" on those options was set
	            // more than once (i.e. when the options were already selected)
	            // So we only modify the selected property if necessary.
	            // Note: this behavior cannot be replicated via unit tests because it only shows in the
	            // actual user interface.
	            if (shouldBeSelected !== currentlySelected) {
	              setOptionSelectedStatus(jqLite(option), shouldBeSelected);
	            }
	
	          });
	        };
	
	        // we have to do it on each watch since ngModel watches reference, but
	        // we need to work of an array, so we need to see if anything was inserted/removed
	        var lastView, lastViewRef = NaN;
	        scope.$watch(function selectMultipleWatch() {
	          if (lastViewRef === ngModelCtrl.$viewValue && !equals(lastView, ngModelCtrl.$viewValue)) {
	            lastView = shallowCopy(ngModelCtrl.$viewValue);
	            ngModelCtrl.$render();
	          }
	          lastViewRef = ngModelCtrl.$viewValue;
	        });
	
	        // If we are a multiple select then value is now a collection
	        // so the meaning of $isEmpty changes
	        ngModelCtrl.$isEmpty = function(value) {
	          return !value || value.length === 0;
	        };
	
	      }
	    }
	
	    function selectPostLink(scope, element, attrs, ctrls) {
	      // if ngModel is not defined, we don't need to do anything
	      var ngModelCtrl = ctrls[1];
	      if (!ngModelCtrl) return;
	
	      var selectCtrl = ctrls[0];
	
	      // We delegate rendering to the `writeValue` method, which can be changed
	      // if the select can have multiple selected values or if the options are being
	      // generated by `ngOptions`.
	      // This must be done in the postLink fn to prevent $render to be called before
	      // all nodes have been linked correctly.
	      ngModelCtrl.$render = function() {
	        selectCtrl.writeValue(ngModelCtrl.$viewValue);
	      };
	    }
	};
	
	
	// The option directive is purely designed to communicate the existence (or lack of)
	// of dynamically created (and destroyed) option elements to their containing select
	// directive via its controller.
	var optionDirective = ['$interpolate', function($interpolate) {
	  return {
	    restrict: 'E',
	    priority: 100,
	    compile: function(element, attr) {
	      var interpolateValueFn, interpolateTextFn;
	
	      if (isDefined(attr.ngValue)) {
	        // Will be handled by registerOption
	      } else if (isDefined(attr.value)) {
	        // If the value attribute is defined, check if it contains an interpolation
	        interpolateValueFn = $interpolate(attr.value, true);
	      } else {
	        // If the value attribute is not defined then we fall back to the
	        // text content of the option element, which may be interpolated
	        interpolateTextFn = $interpolate(element.text(), true);
	        if (!interpolateTextFn) {
	          attr.$set('value', element.text());
	        }
	      }
	
	      return function(scope, element, attr) {
	        // This is an optimization over using ^^ since we don't want to have to search
	        // all the way to the root of the DOM for every single option element
	        var selectCtrlName = '$selectController',
	            parent = element.parent(),
	            selectCtrl = parent.data(selectCtrlName) ||
	              parent.parent().data(selectCtrlName); // in case we are in optgroup
	
	        if (selectCtrl) {
	          selectCtrl.registerOption(scope, element, attr, interpolateValueFn, interpolateTextFn);
	        }
	      };
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngRequired
	 * @restrict A
	 *
	 * @param {expression} ngRequired AngularJS expression. If it evaluates to `true`, it sets the
	 *                                `required` attribute to the element and adds the `required`
	 *                                {@link ngModel.NgModelController#$validators `validator`}.
	 *
	 * @description
	 *
	 * ngRequired adds the required {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for {@link input `input`} and {@link select `select`} controls, but can also be
	 * applied to custom controls.
	 *
	 * The directive sets the `required` attribute on the element if the AngularJS expression inside
	 * `ngRequired` evaluates to true. A special directive for setting `required` is necessary because we
	 * cannot use interpolation inside `required`. See the {@link guide/interpolation interpolation guide}
	 * for more info.
	 *
	 * The validator will set the `required` error key to true if the `required` attribute is set and
	 * calling {@link ngModel.NgModelController#$isEmpty `NgModelController.$isEmpty`} with the
	 * {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`} returns `true`. For example, the
	 * `$isEmpty()` implementation for `input[text]` checks the length of the `$viewValue`. When developing
	 * custom controls, `$isEmpty()` can be overwritten to account for a $viewValue that is not string-based.
	 *
	 * @example
	 * <example name="ngRequiredDirective" module="ngRequiredExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngRequiredExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.required = true;
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="required">Toggle required: </label>
	 *         <input type="checkbox" ng-model="required" id="required" />
	 *         <br>
	 *         <label for="input">This input must be filled if `required` is true: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-required="required" /><br>
	 *         <hr>
	 *         required error set? = <code>{{form.input.$error.required}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var required = element(by.binding('form.input.$error.required'));
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should set the required error', function() {
	         expect(required.getText()).toContain('true');
	
	         input.sendKeys('123');
	         expect(required.getText()).not.toContain('true');
	         expect(model.getText()).toContain('123');
	       });
	 *   </file>
	 * </example>
	 */
	var requiredDirective = ['$parse', function($parse) {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	      // For boolean attributes like required, presence means true
	      var value = attr.hasOwnProperty('required') || $parse(attr.ngRequired)(scope);
	
	      if (!attr.ngRequired) {
	        // force truthy in case we are on non input element
	        // (input elements do this automatically for boolean attributes like required)
	        attr.required = true;
	      }
	
	      ctrl.$validators.required = function(modelValue, viewValue) {
	        return !value || !ctrl.$isEmpty(viewValue);
	      };
	
	      attr.$observe('required', function(newVal) {
	
	        if (value !== newVal) {
	          value = newVal;
	          ctrl.$validate();
	        }
	      });
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngPattern
	 * @restrict A
	 *
	 * @param {expression|RegExp} ngPattern AngularJS expression that must evaluate to a `RegExp` or a `String`
	 *                                      parsable into a `RegExp`, or a `RegExp` literal. See above for
	 *                                      more details.
	 *
	 * @description
	 *
	 * ngPattern adds the pattern {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
	 *
	 * The validator sets the `pattern` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
	 * does not match a RegExp which is obtained from the `ngPattern` attribute value:
	 * - the value is an AngularJS expression:
	 *   - If the expression evaluates to a RegExp object, then this is used directly.
	 *   - If the expression evaluates to a string, then it will be converted to a RegExp after wrapping it
	 *     in `^` and `$` characters. For instance, `"abc"` will be converted to `new RegExp('^abc$')`.
	 * - If the value is a RegExp literal, e.g. `ngPattern="/^\d+$/"`, it is used directly.
	 *
	 * <div class="alert alert-info">
	 * **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	 * start at the index of the last search's match, thus not taking the whole input value into
	 * account.
	 * </div>
	 *
	 * <div class="alert alert-info">
	 * **Note:** This directive is also added when the plain `pattern` attribute is used, with two
	 * differences:
	 * <ol>
	 *   <li>
	 *     `ngPattern` does not set the `pattern` attribute and therefore HTML5 constraint validation is
	 *     not available.
	 *   </li>
	 *   <li>
	 *     The `ngPattern` attribute must be an expression, while the `pattern` value must be
	 *     interpolated.
	 *   </li>
	 * </ol>
	 * </div>
	 *
	 * @example
	 * <example name="ngPatternDirective" module="ngPatternExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngPatternExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.regex = '\\d+';
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="regex">Set a pattern (regex string): </label>
	 *         <input type="text" ng-model="regex" id="regex" />
	 *         <br>
	 *         <label for="input">This input is restricted by the current pattern: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-pattern="regex" /><br>
	 *         <hr>
	 *         input valid? = <code>{{form.input.$valid}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should validate the input with the default pattern', function() {
	         input.sendKeys('aaa');
	         expect(model.getText()).not.toContain('aaa');
	
	         input.clear().then(function() {
	           input.sendKeys('123');
	           expect(model.getText()).toContain('123');
	         });
	       });
	 *   </file>
	 * </example>
	 */
	var patternDirective = ['$parse', function($parse) {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    compile: function(tElm, tAttr) {
	      var patternExp;
	      var parseFn;
	
	      if (tAttr.ngPattern) {
	        patternExp = tAttr.ngPattern;
	
	        // ngPattern might be a scope expression, or an inlined regex, which is not parsable.
	        // We get value of the attribute here, so we can compare the old and the new value
	        // in the observer to avoid unnecessary validations
	        if (tAttr.ngPattern.charAt(0) === '/' && REGEX_STRING_REGEXP.test(tAttr.ngPattern)) {
	          parseFn = function() { return tAttr.ngPattern; };
	        } else {
	          parseFn = $parse(tAttr.ngPattern);
	        }
	      }
	
	      return function(scope, elm, attr, ctrl) {
	        if (!ctrl) return;
	
	        var attrVal = attr.pattern;
	
	        if (attr.ngPattern) {
	          attrVal = parseFn(scope);
	        } else {
	          patternExp = attr.pattern;
	        }
	
	        var regexp = parsePatternAttr(attrVal, patternExp, elm);
	
	        attr.$observe('pattern', function(newVal) {
	          var oldRegexp = regexp;
	
	          regexp = parsePatternAttr(newVal, patternExp, elm);
	
	          if ((oldRegexp && oldRegexp.toString()) !== (regexp && regexp.toString())) {
	            ctrl.$validate();
	          }
	        });
	
	        ctrl.$validators.pattern = function(modelValue, viewValue) {
	          // HTML5 pattern constraint validates the input value, so we validate the viewValue
	          return ctrl.$isEmpty(viewValue) || isUndefined(regexp) || regexp.test(viewValue);
	        };
	      };
	    }
	
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngMaxlength
	 * @restrict A
	 *
	 * @param {expression} ngMaxlength AngularJS expression that must evaluate to a `Number` or `String`
	 *                                 parsable into a `Number`. Used as value for the `maxlength`
	 *                                 {@link ngModel.NgModelController#$validators validator}.
	 *
	 * @description
	 *
	 * ngMaxlength adds the maxlength {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
	 *
	 * The validator sets the `maxlength` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
	 * is longer than the integer obtained by evaluating the AngularJS expression given in the
	 * `ngMaxlength` attribute value.
	 *
	 * <div class="alert alert-info">
	 * **Note:** This directive is also added when the plain `maxlength` attribute is used, with two
	 * differences:
	 * <ol>
	 *   <li>
	 *     `ngMaxlength` does not set the `maxlength` attribute and therefore HTML5 constraint
	 *     validation is not available.
	 *   </li>
	 *   <li>
	 *     The `ngMaxlength` attribute must be an expression, while the `maxlength` value must be
	 *     interpolated.
	 *   </li>
	 * </ol>
	 * </div>
	 *
	 * @example
	 * <example name="ngMaxlengthDirective" module="ngMaxlengthExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngMaxlengthExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.maxlength = 5;
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="maxlength">Set a maxlength: </label>
	 *         <input type="number" ng-model="maxlength" id="maxlength" />
	 *         <br>
	 *         <label for="input">This input is restricted by the current maxlength: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-maxlength="maxlength" /><br>
	 *         <hr>
	 *         input valid? = <code>{{form.input.$valid}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should validate the input with the default maxlength', function() {
	         input.sendKeys('abcdef');
	         expect(model.getText()).not.toContain('abcdef');
	
	         input.clear().then(function() {
	           input.sendKeys('abcde');
	           expect(model.getText()).toContain('abcde');
	         });
	       });
	 *   </file>
	 * </example>
	 */
	var maxlengthDirective = ['$parse', function($parse) {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	
	      var maxlength = attr.maxlength || $parse(attr.ngMaxlength)(scope);
	      var maxlengthParsed = parseLength(maxlength);
	
	      attr.$observe('maxlength', function(value) {
	        if (maxlength !== value) {
	          maxlengthParsed = parseLength(value);
	          maxlength = value;
	          ctrl.$validate();
	        }
	      });
	      ctrl.$validators.maxlength = function(modelValue, viewValue) {
	        return (maxlengthParsed < 0) || ctrl.$isEmpty(viewValue) || (viewValue.length <= maxlengthParsed);
	      };
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngMinlength
	 * @restrict A
	 *
	 * @param {expression} ngMinlength AngularJS expression that must evaluate to a `Number` or `String`
	 *                                 parsable into a `Number`. Used as value for the `minlength`
	 *                                 {@link ngModel.NgModelController#$validators validator}.
	 *
	 * @description
	 *
	 * ngMinlength adds the minlength {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
	 *
	 * The validator sets the `minlength` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
	 * is shorter than the integer obtained by evaluating the AngularJS expression given in the
	 * `ngMinlength` attribute value.
	 *
	 * <div class="alert alert-info">
	 * **Note:** This directive is also added when the plain `minlength` attribute is used, with two
	 * differences:
	 * <ol>
	 *   <li>
	 *     `ngMinlength` does not set the `minlength` attribute and therefore HTML5 constraint
	 *     validation is not available.
	 *   </li>
	 *   <li>
	 *     The `ngMinlength` value must be an expression, while the `minlength` value must be
	 *     interpolated.
	 *   </li>
	 * </ol>
	 * </div>
	 *
	 * @example
	 * <example name="ngMinlengthDirective" module="ngMinlengthExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngMinlengthExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.minlength = 3;
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="minlength">Set a minlength: </label>
	 *         <input type="number" ng-model="minlength" id="minlength" />
	 *         <br>
	 *         <label for="input">This input is restricted by the current minlength: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-minlength="minlength" /><br>
	 *         <hr>
	 *         input valid? = <code>{{form.input.$valid}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should validate the input with the default minlength', function() {
	         input.sendKeys('ab');
	         expect(model.getText()).not.toContain('ab');
	
	         input.sendKeys('abc');
	         expect(model.getText()).toContain('abc');
	       });
	 *   </file>
	 * </example>
	 */
	var minlengthDirective = ['$parse', function($parse) {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	
	      var minlength = attr.minlength || $parse(attr.ngMinlength)(scope);
	      var minlengthParsed = parseLength(minlength) || -1;
	
	      attr.$observe('minlength', function(value) {
	        if (minlength !== value) {
	          minlengthParsed = parseLength(value) || -1;
	          minlength = value;
	          ctrl.$validate();
	        }
	
	      });
	      ctrl.$validators.minlength = function(modelValue, viewValue) {
	        return ctrl.$isEmpty(viewValue) || viewValue.length >= minlengthParsed;
	      };
	    }
	  };
	}];
	
	
	function parsePatternAttr(regex, patternExp, elm) {
	  if (!regex) return undefined;
	
	  if (isString(regex)) {
	    regex = new RegExp('^' + regex + '$');
	  }
	
	  if (!regex.test) {
	    throw minErr('ngPattern')('noregexp',
	      'Expected {0} to be a RegExp but was {1}. Element: {2}', patternExp,
	      regex, startingTag(elm));
	  }
	
	  return regex;
	}
	
	function parseLength(val) {
	  var intVal = toInt(val);
	  return isNumberNaN(intVal) ? -1 : intVal;
	}
	
	if (window.angular.bootstrap) {
	  // AngularJS is already loaded, so we can return here...
	  if (window.console) {
	    console.log('WARNING: Tried to load AngularJS more than once.');
	  }
	  return;
	}
	
	// try to bind to jquery now so that one can write jqLite(fn)
	// but we will rebind on bootstrap again.
	bindJQuery();
	
	publishExternalAPI(angular);
	
	angular.module("ngLocale", [], ["$provide", function($provide) {
	var PLURAL_CATEGORY = {ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other"};
	function getDecimals(n) {
	  n = n + '';
	  var i = n.indexOf('.');
	  return (i == -1) ? 0 : n.length - i - 1;
	}
	
	function getVF(n, opt_precision) {
	  var v = opt_precision;
	
	  if (undefined === v) {
	    v = Math.min(getDecimals(n), 3);
	  }
	
	  var base = Math.pow(10, v);
	  var f = ((n * base) | 0) % base;
	  return {v: v, f: f};
	}
	
	$provide.value("$locale", {
	  "DATETIME_FORMATS": {
	    "AMPMS": [
	      "AM",
	      "PM"
	    ],
	    "DAY": [
	      "Sunday",
	      "Monday",
	      "Tuesday",
	      "Wednesday",
	      "Thursday",
	      "Friday",
	      "Saturday"
	    ],
	    "ERANAMES": [
	      "Before Christ",
	      "Anno Domini"
	    ],
	    "ERAS": [
	      "BC",
	      "AD"
	    ],
	    "FIRSTDAYOFWEEK": 6,
	    "MONTH": [
	      "January",
	      "February",
	      "March",
	      "April",
	      "May",
	      "June",
	      "July",
	      "August",
	      "September",
	      "October",
	      "November",
	      "December"
	    ],
	    "SHORTDAY": [
	      "Sun",
	      "Mon",
	      "Tue",
	      "Wed",
	      "Thu",
	      "Fri",
	      "Sat"
	    ],
	    "SHORTMONTH": [
	      "Jan",
	      "Feb",
	      "Mar",
	      "Apr",
	      "May",
	      "Jun",
	      "Jul",
	      "Aug",
	      "Sep",
	      "Oct",
	      "Nov",
	      "Dec"
	    ],
	    "STANDALONEMONTH": [
	      "January",
	      "February",
	      "March",
	      "April",
	      "May",
	      "June",
	      "July",
	      "August",
	      "September",
	      "October",
	      "November",
	      "December"
	    ],
	    "WEEKENDRANGE": [
	      5,
	      6
	    ],
	    "fullDate": "EEEE, MMMM d, y",
	    "longDate": "MMMM d, y",
	    "medium": "MMM d, y h:mm:ss a",
	    "mediumDate": "MMM d, y",
	    "mediumTime": "h:mm:ss a",
	    "short": "M/d/yy h:mm a",
	    "shortDate": "M/d/yy",
	    "shortTime": "h:mm a"
	  },
	  "NUMBER_FORMATS": {
	    "CURRENCY_SYM": "$",
	    "DECIMAL_SEP": ".",
	    "GROUP_SEP": ",",
	    "PATTERNS": [
	      {
	        "gSize": 3,
	        "lgSize": 3,
	        "maxFrac": 3,
	        "minFrac": 0,
	        "minInt": 1,
	        "negPre": "-",
	        "negSuf": "",
	        "posPre": "",
	        "posSuf": ""
	      },
	      {
	        "gSize": 3,
	        "lgSize": 3,
	        "maxFrac": 2,
	        "minFrac": 2,
	        "minInt": 1,
	        "negPre": "-\u00a4",
	        "negSuf": "",
	        "posPre": "\u00a4",
	        "posSuf": ""
	      }
	    ]
	  },
	  "id": "en-us",
	  "localeID": "en_US",
	  "pluralCat": function(n, opt_precision) {  var i = n | 0;  var vf = getVF(n, opt_precision);  if (i == 1 && vf.v == 0) {    return PLURAL_CATEGORY.ONE;  }  return PLURAL_CATEGORY.OTHER;}
	});
	}]);
	
	  jqLite(function() {
	    angularInit(window.document, bootstrap);
	  });
	
	})(window);
	
	!window.angular.$$csp().noInlineStyle && window.angular.element(document.head).prepend(window.angular.element('<style>').text('@charset "UTF-8";[ng\\:cloak],[ng-cloak],[data-ng-cloak],[x-ng-cloak],.ng-cloak,.x-ng-cloak,.ng-hide:not(.ng-hide-animate){display:none !important;}ng\\:form{display:block;}.ng-animate-shim{visibility:hidden;}.ng-anchor{position:absolute;}'));

/***/ }),
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*
	 *  big.js v5.2.2
	 *  A small, fast, easy-to-use library for arbitrary-precision decimal arithmetic.
	 *  Copyright (c) 2018 Michael Mclaughlin <M8ch88l@gmail.com>
	 *  https://github.com/MikeMcl/big.js/LICENCE
	 */
	;(function (GLOBAL) {
	  'use strict';
	  var Big,
	
	
	/************************************** EDITABLE DEFAULTS *****************************************/
	
	
	    // The default values below must be integers within the stated ranges.
	
	    /*
	     * The maximum number of decimal places (DP) of the results of operations involving division:
	     * div and sqrt, and pow with negative exponents.
	     */
	    DP = 20,          // 0 to MAX_DP
	
	    /*
	     * The rounding mode (RM) used when rounding to the above decimal places.
	     *
	     *  0  Towards zero (i.e. truncate, no rounding).       (ROUND_DOWN)
	     *  1  To nearest neighbour. If equidistant, round up.  (ROUND_HALF_UP)
	     *  2  To nearest neighbour. If equidistant, to even.   (ROUND_HALF_EVEN)
	     *  3  Away from zero.                                  (ROUND_UP)
	     */
	    RM = 1,             // 0, 1, 2 or 3
	
	    // The maximum value of DP and Big.DP.
	    MAX_DP = 1E6,       // 0 to 1000000
	
	    // The maximum magnitude of the exponent argument to the pow method.
	    MAX_POWER = 1E6,    // 1 to 1000000
	
	    /*
	     * The negative exponent (NE) at and beneath which toString returns exponential notation.
	     * (JavaScript numbers: -7)
	     * -1000000 is the minimum recommended exponent value of a Big.
	     */
	    NE = -7,            // 0 to -1000000
	
	    /*
	     * The positive exponent (PE) at and above which toString returns exponential notation.
	     * (JavaScript numbers: 21)
	     * 1000000 is the maximum recommended exponent value of a Big.
	     * (This limit is not enforced or checked.)
	     */
	    PE = 21,            // 0 to 1000000
	
	
	/**************************************************************************************************/
	
	
	    // Error messages.
	    NAME = '[big.js] ',
	    INVALID = NAME + 'Invalid ',
	    INVALID_DP = INVALID + 'decimal places',
	    INVALID_RM = INVALID + 'rounding mode',
	    DIV_BY_ZERO = NAME + 'Division by zero',
	
	    // The shared prototype object.
	    P = {},
	    UNDEFINED = void 0,
	    NUMERIC = /^-?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i;
	
	
	  /*
	   * Create and return a Big constructor.
	   *
	   */
	  function _Big_() {
	
	    /*
	     * The Big constructor and exported function.
	     * Create and return a new instance of a Big number object.
	     *
	     * n {number|string|Big} A numeric value.
	     */
	    function Big(n) {
	      var x = this;
	
	      // Enable constructor usage without new.
	      if (!(x instanceof Big)) return n === UNDEFINED ? _Big_() : new Big(n);
	
	      // Duplicate.
	      if (n instanceof Big) {
	        x.s = n.s;
	        x.e = n.e;
	        x.c = n.c.slice();
	      } else {
	        parse(x, n);
	      }
	
	      /*
	       * Retain a reference to this Big constructor, and shadow Big.prototype.constructor which
	       * points to Object.
	       */
	      x.constructor = Big;
	    }
	
	    Big.prototype = P;
	    Big.DP = DP;
	    Big.RM = RM;
	    Big.NE = NE;
	    Big.PE = PE;
	    Big.version = '5.2.2';
	
	    return Big;
	  }
	
	
	  /*
	   * Parse the number or string value passed to a Big constructor.
	   *
	   * x {Big} A Big number instance.
	   * n {number|string} A numeric value.
	   */
	  function parse(x, n) {
	    var e, i, nl;
	
	    // Minus zero?
	    if (n === 0 && 1 / n < 0) n = '-0';
	    else if (!NUMERIC.test(n += '')) throw Error(INVALID + 'number');
	
	    // Determine sign.
	    x.s = n.charAt(0) == '-' ? (n = n.slice(1), -1) : 1;
	
	    // Decimal point?
	    if ((e = n.indexOf('.')) > -1) n = n.replace('.', '');
	
	    // Exponential form?
	    if ((i = n.search(/e/i)) > 0) {
	
	      // Determine exponent.
	      if (e < 0) e = i;
	      e += +n.slice(i + 1);
	      n = n.substring(0, i);
	    } else if (e < 0) {
	
	      // Integer.
	      e = n.length;
	    }
	
	    nl = n.length;
	
	    // Determine leading zeros.
	    for (i = 0; i < nl && n.charAt(i) == '0';) ++i;
	
	    if (i == nl) {
	
	      // Zero.
	      x.c = [x.e = 0];
	    } else {
	
	      // Determine trailing zeros.
	      for (; nl > 0 && n.charAt(--nl) == '0';);
	      x.e = e - i - 1;
	      x.c = [];
	
	      // Convert string to array of digits without leading/trailing zeros.
	      for (e = 0; i <= nl;) x.c[e++] = +n.charAt(i++);
	    }
	
	    return x;
	  }
	
	
	  /*
	   * Round Big x to a maximum of dp decimal places using rounding mode rm.
	   * Called by stringify, P.div, P.round and P.sqrt.
	   *
	   * x {Big} The Big to round.
	   * dp {number} Integer, 0 to MAX_DP inclusive.
	   * rm {number} 0, 1, 2 or 3 (DOWN, HALF_UP, HALF_EVEN, UP)
	   * [more] {boolean} Whether the result of division was truncated.
	   */
	  function round(x, dp, rm, more) {
	    var xc = x.c,
	      i = x.e + dp + 1;
	
	    if (i < xc.length) {
	      if (rm === 1) {
	
	        // xc[i] is the digit after the digit that may be rounded up.
	        more = xc[i] >= 5;
	      } else if (rm === 2) {
	        more = xc[i] > 5 || xc[i] == 5 &&
	          (more || i < 0 || xc[i + 1] !== UNDEFINED || xc[i - 1] & 1);
	      } else if (rm === 3) {
	        more = more || !!xc[0];
	      } else {
	        more = false;
	        if (rm !== 0) throw Error(INVALID_RM);
	      }
	
	      if (i < 1) {
	        xc.length = 1;
	
	        if (more) {
	
	          // 1, 0.1, 0.01, 0.001, 0.0001 etc.
	          x.e = -dp;
	          xc[0] = 1;
	        } else {
	
	          // Zero.
	          xc[0] = x.e = 0;
	        }
	      } else {
	
	        // Remove any digits after the required decimal places.
	        xc.length = i--;
	
	        // Round up?
	        if (more) {
	
	          // Rounding up may mean the previous digit has to be rounded up.
	          for (; ++xc[i] > 9;) {
	            xc[i] = 0;
	            if (!i--) {
	              ++x.e;
	              xc.unshift(1);
	            }
	          }
	        }
	
	        // Remove trailing zeros.
	        for (i = xc.length; !xc[--i];) xc.pop();
	      }
	    } else if (rm < 0 || rm > 3 || rm !== ~~rm) {
	      throw Error(INVALID_RM);
	    }
	
	    return x;
	  }
	
	
	  /*
	   * Return a string representing the value of Big x in normal or exponential notation.
	   * Handles P.toExponential, P.toFixed, P.toJSON, P.toPrecision, P.toString and P.valueOf.
	   *
	   * x {Big}
	   * id? {number} Caller id.
	   *         1 toExponential
	   *         2 toFixed
	   *         3 toPrecision
	   *         4 valueOf
	   * n? {number|undefined} Caller's argument.
	   * k? {number|undefined}
	   */
	  function stringify(x, id, n, k) {
	    var e, s,
	      Big = x.constructor,
	      z = !x.c[0];
	
	    if (n !== UNDEFINED) {
	      if (n !== ~~n || n < (id == 3) || n > MAX_DP) {
	        throw Error(id == 3 ? INVALID + 'precision' : INVALID_DP);
	      }
	
	      x = new Big(x);
	
	      // The index of the digit that may be rounded up.
	      n = k - x.e;
	
	      // Round?
	      if (x.c.length > ++k) round(x, n, Big.RM);
	
	      // toFixed: recalculate k as x.e may have changed if value rounded up.
	      if (id == 2) k = x.e + n + 1;
	
	      // Append zeros?
	      for (; x.c.length < k;) x.c.push(0);
	    }
	
	    e = x.e;
	    s = x.c.join('');
	    n = s.length;
	
	    // Exponential notation?
	    if (id != 2 && (id == 1 || id == 3 && k <= e || e <= Big.NE || e >= Big.PE)) {
	      s = s.charAt(0) + (n > 1 ? '.' + s.slice(1) : '') + (e < 0 ? 'e' : 'e+') + e;
	
	    // Normal notation.
	    } else if (e < 0) {
	      for (; ++e;) s = '0' + s;
	      s = '0.' + s;
	    } else if (e > 0) {
	      if (++e > n) for (e -= n; e--;) s += '0';
	      else if (e < n) s = s.slice(0, e) + '.' + s.slice(e);
	    } else if (n > 1) {
	      s = s.charAt(0) + '.' + s.slice(1);
	    }
	
	    return x.s < 0 && (!z || id == 4) ? '-' + s : s;
	  }
	
	
	  // Prototype/instance methods
	
	
	  /*
	   * Return a new Big whose value is the absolute value of this Big.
	   */
	  P.abs = function () {
	    var x = new this.constructor(this);
	    x.s = 1;
	    return x;
	  };
	
	
	  /*
	   * Return 1 if the value of this Big is greater than the value of Big y,
	   *       -1 if the value of this Big is less than the value of Big y, or
	   *        0 if they have the same value.
	  */
	  P.cmp = function (y) {
	    var isneg,
	      x = this,
	      xc = x.c,
	      yc = (y = new x.constructor(y)).c,
	      i = x.s,
	      j = y.s,
	      k = x.e,
	      l = y.e;
	
	    // Either zero?
	    if (!xc[0] || !yc[0]) return !xc[0] ? !yc[0] ? 0 : -j : i;
	
	    // Signs differ?
	    if (i != j) return i;
	
	    isneg = i < 0;
	
	    // Compare exponents.
	    if (k != l) return k > l ^ isneg ? 1 : -1;
	
	    j = (k = xc.length) < (l = yc.length) ? k : l;
	
	    // Compare digit by digit.
	    for (i = -1; ++i < j;) {
	      if (xc[i] != yc[i]) return xc[i] > yc[i] ^ isneg ? 1 : -1;
	    }
	
	    // Compare lengths.
	    return k == l ? 0 : k > l ^ isneg ? 1 : -1;
	  };
	
	
	  /*
	   * Return a new Big whose value is the value of this Big divided by the value of Big y, rounded,
	   * if necessary, to a maximum of Big.DP decimal places using rounding mode Big.RM.
	   */
	  P.div = function (y) {
	    var x = this,
	      Big = x.constructor,
	      a = x.c,                  // dividend
	      b = (y = new Big(y)).c,   // divisor
	      k = x.s == y.s ? 1 : -1,
	      dp = Big.DP;
	
	    if (dp !== ~~dp || dp < 0 || dp > MAX_DP) throw Error(INVALID_DP);
	
	    // Divisor is zero?
	    if (!b[0]) throw Error(DIV_BY_ZERO);
	
	    // Dividend is 0? Return +-0.
	    if (!a[0]) return new Big(k * 0);
	
	    var bl, bt, n, cmp, ri,
	      bz = b.slice(),
	      ai = bl = b.length,
	      al = a.length,
	      r = a.slice(0, bl),   // remainder
	      rl = r.length,
	      q = y,                // quotient
	      qc = q.c = [],
	      qi = 0,
	      d = dp + (q.e = x.e - y.e) + 1;    // number of digits of the result
	
	    q.s = k;
	    k = d < 0 ? 0 : d;
	
	    // Create version of divisor with leading zero.
	    bz.unshift(0);
	
	    // Add zeros to make remainder as long as divisor.
	    for (; rl++ < bl;) r.push(0);
	
	    do {
	
	      // n is how many times the divisor goes into current remainder.
	      for (n = 0; n < 10; n++) {
	
	        // Compare divisor and remainder.
	        if (bl != (rl = r.length)) {
	          cmp = bl > rl ? 1 : -1;
	        } else {
	          for (ri = -1, cmp = 0; ++ri < bl;) {
	            if (b[ri] != r[ri]) {
	              cmp = b[ri] > r[ri] ? 1 : -1;
	              break;
	            }
	          }
	        }
	
	        // If divisor < remainder, subtract divisor from remainder.
	        if (cmp < 0) {
	
	          // Remainder can't be more than 1 digit longer than divisor.
	          // Equalise lengths using divisor with extra leading zero?
	          for (bt = rl == bl ? b : bz; rl;) {
	            if (r[--rl] < bt[rl]) {
	              ri = rl;
	              for (; ri && !r[--ri];) r[ri] = 9;
	              --r[ri];
	              r[rl] += 10;
	            }
	            r[rl] -= bt[rl];
	          }
	
	          for (; !r[0];) r.shift();
	        } else {
	          break;
	        }
	      }
	
	      // Add the digit n to the result array.
	      qc[qi++] = cmp ? n : ++n;
	
	      // Update the remainder.
	      if (r[0] && cmp) r[rl] = a[ai] || 0;
	      else r = [a[ai]];
	
	    } while ((ai++ < al || r[0] !== UNDEFINED) && k--);
	
	    // Leading zero? Do not remove if result is simply zero (qi == 1).
	    if (!qc[0] && qi != 1) {
	
	      // There can't be more than one zero.
	      qc.shift();
	      q.e--;
	    }
	
	    // Round?
	    if (qi > d) round(q, dp, Big.RM, r[0] !== UNDEFINED);
	
	    return q;
	  };
	
	
	  /*
	   * Return true if the value of this Big is equal to the value of Big y, otherwise return false.
	   */
	  P.eq = function (y) {
	    return !this.cmp(y);
	  };
	
	
	  /*
	   * Return true if the value of this Big is greater than the value of Big y, otherwise return
	   * false.
	   */
	  P.gt = function (y) {
	    return this.cmp(y) > 0;
	  };
	
	
	  /*
	   * Return true if the value of this Big is greater than or equal to the value of Big y, otherwise
	   * return false.
	   */
	  P.gte = function (y) {
	    return this.cmp(y) > -1;
	  };
	
	
	  /*
	   * Return true if the value of this Big is less than the value of Big y, otherwise return false.
	   */
	  P.lt = function (y) {
	    return this.cmp(y) < 0;
	  };
	
	
	  /*
	   * Return true if the value of this Big is less than or equal to the value of Big y, otherwise
	   * return false.
	   */
	  P.lte = function (y) {
	    return this.cmp(y) < 1;
	  };
	
	
	  /*
	   * Return a new Big whose value is the value of this Big minus the value of Big y.
	   */
	  P.minus = P.sub = function (y) {
	    var i, j, t, xlty,
	      x = this,
	      Big = x.constructor,
	      a = x.s,
	      b = (y = new Big(y)).s;
	
	    // Signs differ?
	    if (a != b) {
	      y.s = -b;
	      return x.plus(y);
	    }
	
	    var xc = x.c.slice(),
	      xe = x.e,
	      yc = y.c,
	      ye = y.e;
	
	    // Either zero?
	    if (!xc[0] || !yc[0]) {
	
	      // y is non-zero? x is non-zero? Or both are zero.
	      return yc[0] ? (y.s = -b, y) : new Big(xc[0] ? x : 0);
	    }
	
	    // Determine which is the bigger number. Prepend zeros to equalise exponents.
	    if (a = xe - ye) {
	
	      if (xlty = a < 0) {
	        a = -a;
	        t = xc;
	      } else {
	        ye = xe;
	        t = yc;
	      }
	
	      t.reverse();
	      for (b = a; b--;) t.push(0);
	      t.reverse();
	    } else {
	
	      // Exponents equal. Check digit by digit.
	      j = ((xlty = xc.length < yc.length) ? xc : yc).length;
	
	      for (a = b = 0; b < j; b++) {
	        if (xc[b] != yc[b]) {
	          xlty = xc[b] < yc[b];
	          break;
	        }
	      }
	    }
	
	    // x < y? Point xc to the array of the bigger number.
	    if (xlty) {
	      t = xc;
	      xc = yc;
	      yc = t;
	      y.s = -y.s;
	    }
	
	    /*
	     * Append zeros to xc if shorter. No need to add zeros to yc if shorter as subtraction only
	     * needs to start at yc.length.
	     */
	    if ((b = (j = yc.length) - (i = xc.length)) > 0) for (; b--;) xc[i++] = 0;
	
	    // Subtract yc from xc.
	    for (b = i; j > a;) {
	      if (xc[--j] < yc[j]) {
	        for (i = j; i && !xc[--i];) xc[i] = 9;
	        --xc[i];
	        xc[j] += 10;
	      }
	
	      xc[j] -= yc[j];
	    }
	
	    // Remove trailing zeros.
	    for (; xc[--b] === 0;) xc.pop();
	
	    // Remove leading zeros and adjust exponent accordingly.
	    for (; xc[0] === 0;) {
	      xc.shift();
	      --ye;
	    }
	
	    if (!xc[0]) {
	
	      // n - n = +0
	      y.s = 1;
	
	      // Result must be zero.
	      xc = [ye = 0];
	    }
	
	    y.c = xc;
	    y.e = ye;
	
	    return y;
	  };
	
	
	  /*
	   * Return a new Big whose value is the value of this Big modulo the value of Big y.
	   */
	  P.mod = function (y) {
	    var ygtx,
	      x = this,
	      Big = x.constructor,
	      a = x.s,
	      b = (y = new Big(y)).s;
	
	    if (!y.c[0]) throw Error(DIV_BY_ZERO);
	
	    x.s = y.s = 1;
	    ygtx = y.cmp(x) == 1;
	    x.s = a;
	    y.s = b;
	
	    if (ygtx) return new Big(x);
	
	    a = Big.DP;
	    b = Big.RM;
	    Big.DP = Big.RM = 0;
	    x = x.div(y);
	    Big.DP = a;
	    Big.RM = b;
	
	    return this.minus(x.times(y));
	  };
	
	
	  /*
	   * Return a new Big whose value is the value of this Big plus the value of Big y.
	   */
	  P.plus = P.add = function (y) {
	    var t,
	      x = this,
	      Big = x.constructor,
	      a = x.s,
	      b = (y = new Big(y)).s;
	
	    // Signs differ?
	    if (a != b) {
	      y.s = -b;
	      return x.minus(y);
	    }
	
	    var xe = x.e,
	      xc = x.c,
	      ye = y.e,
	      yc = y.c;
	
	    // Either zero? y is non-zero? x is non-zero? Or both are zero.
	    if (!xc[0] || !yc[0]) return yc[0] ? y : new Big(xc[0] ? x : a * 0);
	
	    xc = xc.slice();
	
	    // Prepend zeros to equalise exponents.
	    // Note: reverse faster than unshifts.
	    if (a = xe - ye) {
	      if (a > 0) {
	        ye = xe;
	        t = yc;
	      } else {
	        a = -a;
	        t = xc;
	      }
	
	      t.reverse();
	      for (; a--;) t.push(0);
	      t.reverse();
	    }
	
	    // Point xc to the longer array.
	    if (xc.length - yc.length < 0) {
	      t = yc;
	      yc = xc;
	      xc = t;
	    }
	
	    a = yc.length;
	
	    // Only start adding at yc.length - 1 as the further digits of xc can be left as they are.
	    for (b = 0; a; xc[a] %= 10) b = (xc[--a] = xc[a] + yc[a] + b) / 10 | 0;
	
	    // No need to check for zero, as +x + +y != 0 && -x + -y != 0
	
	    if (b) {
	      xc.unshift(b);
	      ++ye;
	    }
	
	    // Remove trailing zeros.
	    for (a = xc.length; xc[--a] === 0;) xc.pop();
	
	    y.c = xc;
	    y.e = ye;
	
	    return y;
	  };
	
	
	  /*
	   * Return a Big whose value is the value of this Big raised to the power n.
	   * If n is negative, round to a maximum of Big.DP decimal places using rounding
	   * mode Big.RM.
	   *
	   * n {number} Integer, -MAX_POWER to MAX_POWER inclusive.
	   */
	  P.pow = function (n) {
	    var x = this,
	      one = new x.constructor(1),
	      y = one,
	      isneg = n < 0;
	
	    if (n !== ~~n || n < -MAX_POWER || n > MAX_POWER) throw Error(INVALID + 'exponent');
	    if (isneg) n = -n;
	
	    for (;;) {
	      if (n & 1) y = y.times(x);
	      n >>= 1;
	      if (!n) break;
	      x = x.times(x);
	    }
	
	    return isneg ? one.div(y) : y;
	  };
	
	
	  /*
	   * Return a new Big whose value is the value of this Big rounded using rounding mode rm
	   * to a maximum of dp decimal places, or, if dp is negative, to an integer which is a
	   * multiple of 10**-dp.
	   * If dp is not specified, round to 0 decimal places.
	   * If rm is not specified, use Big.RM.
	   *
	   * dp? {number} Integer, -MAX_DP to MAX_DP inclusive.
	   * rm? 0, 1, 2 or 3 (ROUND_DOWN, ROUND_HALF_UP, ROUND_HALF_EVEN, ROUND_UP)
	   */
	  P.round = function (dp, rm) {
	    var Big = this.constructor;
	    if (dp === UNDEFINED) dp = 0;
	    else if (dp !== ~~dp || dp < -MAX_DP || dp > MAX_DP) throw Error(INVALID_DP);
	    return round(new Big(this), dp, rm === UNDEFINED ? Big.RM : rm);
	  };
	
	
	  /*
	   * Return a new Big whose value is the square root of the value of this Big, rounded, if
	   * necessary, to a maximum of Big.DP decimal places using rounding mode Big.RM.
	   */
	  P.sqrt = function () {
	    var r, c, t,
	      x = this,
	      Big = x.constructor,
	      s = x.s,
	      e = x.e,
	      half = new Big(0.5);
	
	    // Zero?
	    if (!x.c[0]) return new Big(x);
	
	    // Negative?
	    if (s < 0) throw Error(NAME + 'No square root');
	
	    // Estimate.
	    s = Math.sqrt(x + '');
	
	    // Math.sqrt underflow/overflow?
	    // Re-estimate: pass x coefficient to Math.sqrt as integer, then adjust the result exponent.
	    if (s === 0 || s === 1 / 0) {
	      c = x.c.join('');
	      if (!(c.length + e & 1)) c += '0';
	      s = Math.sqrt(c);
	      e = ((e + 1) / 2 | 0) - (e < 0 || e & 1);
	      r = new Big((s == 1 / 0 ? '1e' : (s = s.toExponential()).slice(0, s.indexOf('e') + 1)) + e);
	    } else {
	      r = new Big(s);
	    }
	
	    e = r.e + (Big.DP += 4);
	
	    // Newton-Raphson iteration.
	    do {
	      t = r;
	      r = half.times(t.plus(x.div(t)));
	    } while (t.c.slice(0, e).join('') !== r.c.slice(0, e).join(''));
	
	    return round(r, Big.DP -= 4, Big.RM);
	  };
	
	
	  /*
	   * Return a new Big whose value is the value of this Big times the value of Big y.
	   */
	  P.times = P.mul = function (y) {
	    var c,
	      x = this,
	      Big = x.constructor,
	      xc = x.c,
	      yc = (y = new Big(y)).c,
	      a = xc.length,
	      b = yc.length,
	      i = x.e,
	      j = y.e;
	
	    // Determine sign of result.
	    y.s = x.s == y.s ? 1 : -1;
	
	    // Return signed 0 if either 0.
	    if (!xc[0] || !yc[0]) return new Big(y.s * 0);
	
	    // Initialise exponent of result as x.e + y.e.
	    y.e = i + j;
	
	    // If array xc has fewer digits than yc, swap xc and yc, and lengths.
	    if (a < b) {
	      c = xc;
	      xc = yc;
	      yc = c;
	      j = a;
	      a = b;
	      b = j;
	    }
	
	    // Initialise coefficient array of result with zeros.
	    for (c = new Array(j = a + b); j--;) c[j] = 0;
	
	    // Multiply.
	
	    // i is initially xc.length.
	    for (i = b; i--;) {
	      b = 0;
	
	      // a is yc.length.
	      for (j = a + i; j > i;) {
	
	        // Current sum of products at this digit position, plus carry.
	        b = c[j] + yc[i] * xc[j - i - 1] + b;
	        c[j--] = b % 10;
	
	        // carry
	        b = b / 10 | 0;
	      }
	
	      c[j] = (c[j] + b) % 10;
	    }
	
	    // Increment result exponent if there is a final carry, otherwise remove leading zero.
	    if (b) ++y.e;
	    else c.shift();
	
	    // Remove trailing zeros.
	    for (i = c.length; !c[--i];) c.pop();
	    y.c = c;
	
	    return y;
	  };
	
	
	  /*
	   * Return a string representing the value of this Big in exponential notation to dp fixed decimal
	   * places and rounded using Big.RM.
	   *
	   * dp? {number} Integer, 0 to MAX_DP inclusive.
	   */
	  P.toExponential = function (dp) {
	    return stringify(this, 1, dp, dp);
	  };
	
	
	  /*
	   * Return a string representing the value of this Big in normal notation to dp fixed decimal
	   * places and rounded using Big.RM.
	   *
	   * dp? {number} Integer, 0 to MAX_DP inclusive.
	   *
	   * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
	   * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
	   */
	  P.toFixed = function (dp) {
	    return stringify(this, 2, dp, this.e + dp);
	  };
	
	
	  /*
	   * Return a string representing the value of this Big rounded to sd significant digits using
	   * Big.RM. Use exponential notation if sd is less than the number of digits necessary to represent
	   * the integer part of the value in normal notation.
	   *
	   * sd {number} Integer, 1 to MAX_DP inclusive.
	   */
	  P.toPrecision = function (sd) {
	    return stringify(this, 3, sd, sd - 1);
	  };
	
	
	  /*
	   * Return a string representing the value of this Big.
	   * Return exponential notation if this Big has a positive exponent equal to or greater than
	   * Big.PE, or a negative exponent equal to or less than Big.NE.
	   * Omit the sign for negative zero.
	   */
	  P.toString = function () {
	    return stringify(this);
	  };
	
	
	  /*
	   * Return a string representing the value of this Big.
	   * Return exponential notation if this Big has a positive exponent equal to or greater than
	   * Big.PE, or a negative exponent equal to or less than Big.NE.
	   * Include the sign for negative zero.
	   */
	  P.valueOf = P.toJSON = function () {
	    return stringify(this, 4);
	  };
	
	
	  // Export
	
	
	  Big = _Big_();
	
	  Big['default'] = Big.Big = Big;
	
	  //AMD.
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () { return Big; }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	  // Node and other CommonJS-like environments that support module.exports.
	  } else if (typeof module !== 'undefined' && module.exports) {
	    module.exports = Big;
	
	  //Browser.
	  } else {
	    GLOBAL.Big = Big;
	  }
	})(this);


/***/ }),
/* 144 */,
/* 145 */,
/* 146 */
25,
/* 147 */
25,
/* 148 */
25,
/* 149 */
25,
/* 150 */
25,
/* 151 */
25,
/* 152 */
25,
/* 153 */
25,
/* 154 */
25,
/* 155 */
25,
/* 156 */
25,
/* 157 */
25,
/* 158 */
25,
/* 159 */
25,
/* 160 */
25,
/* 161 */
25,
/* 162 */
25,
/* 163 */
25,
/* 164 */
25,
/* 165 */
25,
/* 166 */
25,
/* 167 */
25,
/* 168 */
25,
/* 169 */
25,
/* 170 */
25,
/* 171 */
25,
/* 172 */
25,
/* 173 */
25,
/* 174 */
25,
/* 175 */
25,
/* 176 */
25,
/* 177 */
25,
/* 178 */
25,
/* 179 */
25,
/* 180 */
25,
/* 181 */
25,
/* 182 */
25,
/* 183 */
25,
/* 184 */
25,
/* 185 */
25,
/* 186 */
25,
/* 187 */
25,
/* 188 */
25,
/* 189 */
25,
/* 190 */
25,
/* 191 */
25,
/* 192 */
25,
/* 193 */
25,
/* 194 */
25,
/* 195 */
25,
/* 196 */
/***/ (function(module, exports) {

	module.exports = {"server":"https://proyectos.upre.gob.bo/ws","serverAuth":"https://proyectos.upre.gob.bo/ws","serverSigaApi":"https://www.siga.upre.gob.bo/apisiga","timeSessionExpired":90,"debug":false,"onbeforeunload":true,"port":4003,"subDomain":"","portDev":8888}

/***/ }),
/* 197 */,
/* 198 */,
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * @license
	 * Lodash <https://lodash.com/>
	 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.17.21';
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Error message constants. */
	  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
	      FUNC_ERROR_TEXT = 'Expected a function',
	      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as the maximum memoize cache size. */
	  var MAX_MEMOIZE_SIZE = 500;
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** Used to compose bitmasks for cloning. */
	  var CLONE_DEEP_FLAG = 1,
	      CLONE_FLAT_FLAG = 2,
	      CLONE_SYMBOLS_FLAG = 4;
	
	  /** Used to compose bitmasks for value comparisons. */
	  var COMPARE_PARTIAL_FLAG = 1,
	      COMPARE_UNORDERED_FLAG = 2;
	
	  /** Used to compose bitmasks for function metadata. */
	  var WRAP_BIND_FLAG = 1,
	      WRAP_BIND_KEY_FLAG = 2,
	      WRAP_CURRY_BOUND_FLAG = 4,
	      WRAP_CURRY_FLAG = 8,
	      WRAP_CURRY_RIGHT_FLAG = 16,
	      WRAP_PARTIAL_FLAG = 32,
	      WRAP_PARTIAL_RIGHT_FLAG = 64,
	      WRAP_ARY_FLAG = 128,
	      WRAP_REARG_FLAG = 256,
	      WRAP_FLIP_FLAG = 512;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 800,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** Used to associate wrap methods with their bit flags. */
	  var wrapFlags = [
	    ['ary', WRAP_ARY_FLAG],
	    ['bind', WRAP_BIND_FLAG],
	    ['bindKey', WRAP_BIND_KEY_FLAG],
	    ['curry', WRAP_CURRY_FLAG],
	    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	    ['flip', WRAP_FLIP_FLAG],
	    ['partial', WRAP_PARTIAL_FLAG],
	    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	    ['rearg', WRAP_REARG_FLAG]
	  ];
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      asyncTag = '[object AsyncFunction]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      domExcTag = '[object DOMException]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      nullTag = '[object Null]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      proxyTag = '[object Proxy]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      undefinedTag = '[object Undefined]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
	      reUnescapedHtml = /[&<>"']/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading whitespace. */
	  var reTrimStart = /^\s+/;
	
	  /** Used to match a single whitespace character. */
	  var reWhitespace = /\s/;
	
	  /** Used to match wrap detail comments. */
	  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	      reSplitDetails = /,? & /;
	
	  /** Used to match words composed of alphanumeric characters. */
	  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	  /**
	   * Used to validate the `validate` option in `_.template` variable.
	   *
	   * Forbids characters which could potentially change the meaning of the function argument definition:
	   * - "()," (modification of function parameters)
	   * - "=" (default value)
	   * - "[]{}" (destructuring of function parameters)
	   * - "/" (beginning of a comment)
	   * - whitespace
	   */
	  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f',
	      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	      rsComboSymbolsRange = '\\u20d0-\\u20ff',
	      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
	      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to match complex or compound words. */
	  var reUnicodeWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	    rsUpper + '+' + rsOptContrUpper,
	    rsOrdUpper,
	    rsOrdLower,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 's'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'"
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();
	
	  /** Detect free variable `exports`. */
	  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;
	
	  /** Detect free variable `process` from Node.js. */
	  var freeProcess = moduleExports && freeGlobal.process;
	
	  /** Used to access faster Node.js helpers. */
	  var nodeUtil = (function() {
	    try {
	      // Use `util.types` for Node.js 10+.
	      var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	      if (types) {
	        return types;
	      }
	
	      // Legacy `process.binding('util')` for Node.js < 10.
	      return freeProcess && freeProcess.binding && freeProcess.binding('util');
	    } catch (e) {}
	  }());
	
	  /* Node.js helper references. */
	  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
	      nodeIsDate = nodeUtil && nodeUtil.isDate,
	      nodeIsMap = nodeUtil && nodeUtil.isMap,
	      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
	      nodeIsSet = nodeUtil && nodeUtil.isSet,
	      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    switch (args.length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array == null ? 0 : array.length;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array == null ? 0 : array.length;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  var asciiSize = baseProperty('length');
	
	  /**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function asciiToArray(string) {
	    return string.split('');
	  }
	
	  /**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function asciiWords(string) {
	    return string.match(reAsciiWord) || [];
	  }
	
	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    return value === value
	      ? strictIndexOf(array, value, fromIndex)
	      : baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	
	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */
	  function baseIsNaN(value) {
	    return value !== value;
	  }
	
	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }
	
	  /**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function basePropertyOf(object) {
	    return function(key) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.trim`.
	   *
	   * @private
	   * @param {string} string The string to trim.
	   * @returns {string} Returns the trimmed string.
	   */
	  function baseTrim(string) {
	    return string
	      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
	      : string;
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        ++result;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  var deburrLetter = basePropertyOf(deburredLetters);
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  var escapeHtmlChar = basePropertyOf(htmlEscapes);
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }
	
	  /**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */
	  function hasUnicode(string) {
	    return reHasUnicode.test(string);
	  }
	
	  /**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */
	  function hasUnicodeWord(string) {
	    return reHasUnicodeWord.test(string);
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function(arg) {
	      return func(transform(arg));
	    };
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictIndexOf(array, value, fromIndex) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictLastIndexOf(array, value, fromIndex) {
	    var index = fromIndex + 1;
	    while (index--) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return index;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    return hasUnicode(string)
	      ? unicodeSize(string)
	      : asciiSize(string);
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return hasUnicode(string)
	      ? unicodeToArray(string)
	      : asciiToArray(string);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
	   * character of `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the index of the last non-whitespace character.
	   */
	  function trimmedEndIndex(string) {
	    var index = string.length;
	
	    while (index-- && reWhitespace.test(string.charAt(index))) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
	
	  /**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  function unicodeSize(string) {
	    var result = reUnicode.lastIndex = 0;
	    while (reUnicode.test(string)) {
	      ++result;
	    }
	    return result;
	  }
	
	  /**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function unicodeToArray(string) {
	    return string.match(reUnicode) || [];
	  }
	
	  /**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function unicodeWords(string) {
	    return string.match(reUnicodeWord) || [];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  var runInContext = (function runInContext(context) {
	    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
	
	    /** Built-in constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype,
	        funcProto = Function.prototype,
	        objectProto = Object.prototype;
	
	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());
	
	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var nativeObjectToString = objectProto.toString;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	        getPrototype = overArg(Object.getPrototypeOf, Object),
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice,
	        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
	        symIterator = Symbol ? Symbol.iterator : undefined,
	        symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	    var defineProperty = (function() {
	      try {
	        var func = getNative(Object, 'defineProperty');
	        func({}, '', {});
	        return func;
	      } catch (e) {}
	    }());
	
	    /** Mocked built-ins. */
	    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
	        ctxNow = Date && Date.now !== root.Date.now && Date.now,
	        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetSymbols = Object.getOwnPropertySymbols,
	        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = overArg(Object.keys, Object),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = Date.now,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;
	
	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array and iteratees accept only
	     * one argument. The heuristic for whether a section qualifies for shortcut
	     * fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(proto) {
	        if (!isObject(proto)) {
	          return {};
	        }
	        if (objectCreate) {
	          return objectCreate(proto);
	        }
	        object.prototype = proto;
	        var result = new object;
	        object.prototype = undefined;
	        return result;
	      };
	    }());
	
	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
	     * following template settings to use alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      var result = this.has(key) && delete this.__data__[key];
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      this.size += this.has(key) ? 0 : 1;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }
	
	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      --this.size;
	      return true;
	    }
	
	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      return index < 0 ? undefined : data[index][1];
	    }
	
	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }
	
	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        ++this.size;
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }
	
	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.size = 0;
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      var result = getMapData(this, key)['delete'](key);
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      var data = getMapData(this, key),
	          size = data.size;
	
	      data.set(key, value);
	      this.size += data.size == size ? 0 : 1;
	      return this;
	    }
	
	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values == null ? 0 : values.length;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }
	
	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }
	
	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }
	
	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      var data = this.__data__ = new ListCache(entries);
	      this.size = data.size;
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          result = data['delete'](key);
	
	      this.size = data.size;
	      return result;
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__;
	      if (data instanceof ListCache) {
	        var pairs = data.__data__;
	        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	          pairs.push([key, value]);
	          this.size = ++data.size;
	          return this;
	        }
	        data = this.__data__ = new MapCache(pairs);
	      }
	      data.set(key, value);
	      this.size = data.size;
	      return this;
	    }
	
	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */
	    function arrayLikeKeys(value, inherited) {
	      var isArr = isArray(value),
	          isArg = !isArr && isArguments(value),
	          isBuff = !isArr && !isArg && isBuffer(value),
	          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	          skipIndexes = isArr || isArg || isBuff || isType,
	          result = skipIndexes ? baseTimes(value.length, String) : [],
	          length = result.length;
	
	      for (var key in value) {
	        if ((inherited || hasOwnProperty.call(value, key)) &&
	            !(skipIndexes && (
	               // Safari 9 has enumerable `arguments.length` in strict mode.
	               key == 'length' ||
	               // Node.js 0.10 has enumerable non-index properties on buffers.
	               (isBuff && (key == 'offset' || key == 'parent')) ||
	               // PhantomJS 2 has enumerable non-index properties on typed arrays.
	               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	               // Skip index properties.
	               isIndex(key, length)
	            ))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */
	    function arraySample(array) {
	      var length = array.length;
	      return length ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function arraySampleSize(array, n) {
	      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function arrayShuffle(array) {
	      return shuffleSelf(copyArray(array));
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.assignIn` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssignIn(object, source) {
	      return object && copyObject(source, keysIn(source), object);
	    }
	
	    /**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function baseAssignValue(object, key, value) {
	      if (key == '__proto__' && defineProperty) {
	        defineProperty(object, key, {
	          'configurable': true,
	          'enumerable': true,
	          'value': value,
	          'writable': true
	        });
	      } else {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          length = paths.length,
	          result = Array(length),
	          skip = object == null;
	
	      while (++index < length) {
	        result[index] = skip ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Deep clone
	     *  2 - Flatten inherited properties
	     *  4 - Clone symbols
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, bitmask, customizer, key, object, stack) {
	      var result,
	          isDeep = bitmask & CLONE_DEEP_FLAG,
	          isFlat = bitmask & CLONE_FLAT_FLAG,
	          isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = (isFlat || isFunc) ? {} : initCloneObject(value);
	          if (!isDeep) {
	            return isFlat
	              ? copySymbolsIn(value, baseAssignIn(result, value))
	              : copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      if (isSet(value)) {
	        value.forEach(function(subValue) {
	          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	        });
	      } else if (isMap(value)) {
	        value.forEach(function(subValue, key) {
	          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	        });
	      }
	
	      var keysFunc = isFull
	        ? (isFlat ? getAllKeysIn : getAllKeys)
	        : (isFlat ? keysIn : keys);
	
	      var props = isArr ? undefined : keysFunc(value);
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        // Recursively populate clone (susceptible to call stack limits).
	        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source);
	      return function(object) {
	        return baseConformsTo(object, source, props);
	      };
	    }
	
	    /**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */
	    function baseConformsTo(object, source, props) {
	      var length = props.length;
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (length--) {
	        var key = props[length],
	            predicate = source[key],
	            value = object[key];
	
	        if ((value === undefined && !(key in object)) || !predicate(value)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee == null ? value : iteratee(value);
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);
	
	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;
	
	      predicate || (predicate = isFlattenable);
	      result || (result = []);
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = castPath(path, object);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }
	
	    /**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      if (value == null) {
	        return value === undefined ? undefinedTag : nullTag;
	      }
	      return (symToStringTag && symToStringTag in Object(value))
	        ? getRawTag(value)
	        : objectToString(value);
	    }
	
	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      return object != null && hasOwnProperty.call(object, key);
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          seen = caches[0];
	
	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      var func = object == null ? object : object[toKey(last(path))];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */
	    function baseIsArguments(value) {
	      return isObjectLike(value) && baseGetTag(value) == argsTag;
	    }
	
	    /**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */
	    function baseIsArrayBuffer(value) {
	      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
	    }
	
	    /**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */
	    function baseIsDate(value) {
	      return isObjectLike(value) && baseGetTag(value) == dateTag;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Unordered comparison
	     *  2 - Partial comparison
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, bitmask, customizer, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = objIsArr ? arrayTag : getTag(object),
	          othTag = othIsArr ? arrayTag : getTag(other);
	
	      objTag = objTag == argsTag ? objectTag : objTag;
	      othTag = othTag == argsTag ? objectTag : othTag;
	
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && isBuffer(object)) {
	        if (!isBuffer(other)) {
	          return false;
	        }
	        objIsArr = true;
	        objIsObj = false;
	      }
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	      }
	      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;
	
	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */
	    function baseIsMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }
	
	    /**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */
	    function baseIsRegExp(value) {
	      return isObjectLike(value) && baseGetTag(value) == regexpTag;
	    }
	
	    /**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */
	    function baseIsSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */
	    function baseIsTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      if (!isPrototype(object)) {
	        return nativeKeys(object);
	      }
	      var result = [];
	      for (var key in Object(object)) {
	        if (hasOwnProperty.call(object, key) && key != 'constructor') {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      if (!isObject(object)) {
	        return nativeKeysIn(object);
	      }
	      var isProto = isPrototype(object),
	          result = [];
	
	      for (var key in object) {
	        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      baseFor(source, function(srcValue, key) {
	        stack || (stack = new Stack);
	        if (isObject(srcValue)) {
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      }, keysIn);
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = safeGet(object, key),
	          srcValue = safeGet(source, key),
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        var isArr = isArray(srcValue),
	            isBuff = !isArr && isBuffer(srcValue),
	            isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	        newValue = srcValue;
	        if (isArr || isBuff || isTyped) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else if (isBuff) {
	            isCommon = false;
	            newValue = cloneBuffer(srcValue, true);
	          }
	          else if (isTyped) {
	            isCommon = false;
	            newValue = cloneTypedArray(srcValue, true);
	          }
	          else {
	            newValue = [];
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          newValue = objValue;
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || isFunction(objValue)) {
	            newValue = initCloneObject(srcValue);
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, newValue);
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	        stack['delete'](srcValue);
	      }
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      if (iteratees.length) {
	        iteratees = arrayMap(iteratees, function(iteratee) {
	          if (isArray(iteratee)) {
	            return function(value) {
	              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
	            }
	          }
	          return iteratee;
	        });
	      } else {
	        iteratees = [identity];
	      }
	
	      var index = -1;
	      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, paths) {
	      return basePickBy(object, paths, function(value, path) {
	        return hasIn(object, path);
	      });
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, paths, predicate) {
	      var index = -1,
	          length = paths.length,
	          result = {};
	
	      while (++index < length) {
	        var path = paths[index],
	            value = baseGet(object, path);
	
	        if (predicate(value, path)) {
	          baseSet(result, castPath(path, object), value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;
	
	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          } else {
	            baseUnset(array, index);
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */
	    function baseRest(func, start) {
	      return setToString(overRest(func, start, identity), func + '');
	    }
	
	    /**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */
	    function baseSample(collection) {
	      return arraySample(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function baseSampleSize(collection, n) {
	      var array = values(collection);
	      return shuffleSelf(array, baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      if (!isObject(object)) {
	        return object;
	      }
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]),
	            newValue = value;
	
	        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
	          return object;
	        }
	
	        if (index != lastIndex) {
	          var objValue = nested[key];
	          newValue = customizer ? customizer(objValue, key, nested) : undefined;
	          if (newValue === undefined) {
	            newValue = isObject(objValue)
	              ? objValue
	              : (isIndex(path[index + 1]) ? [] : {});
	          }
	        }
	        assignValue(nested, key, newValue);
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetToString = !defineProperty ? identity : function(func, string) {
	      return defineProperty(func, 'toString', {
	        'configurable': true,
	        'enumerable': false,
	        'value': constant(string),
	        'writable': true
	      });
	    };
	
	    /**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function baseShuffle(collection) {
	      return shuffleSelf(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array == null ? low : array.length;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      var low = 0,
	          high = array == null ? 0 : array.length;
	      if (high === 0) {
	        return 0;
	      }
	
	      value = iteratee(value);
	      var valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);
	
	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }
	
	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isArray(value)) {
	        // Recursively convert values (susceptible to call stack limits).
	        return arrayMap(value, baseToString) + '';
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The property path to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      return object == null || delete object[toKey(last(path))];
	    }
	
	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var length = arrays.length;
	      if (length < 2) {
	        return length ? baseUniq(arrays[0]) : [];
	      }
	      var index = -1,
	          result = Array(length);
	
	      while (++index < length) {
	        var array = arrays[index],
	            othIndex = -1;
	
	        while (++othIndex < length) {
	          if (othIndex != index) {
	            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	          }
	        }
	      }
	      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value, object) {
	      if (isArray(value)) {
	        return value;
	      }
	      return isKey(value, object) ? [value] : stringToPath(toString(value));
	    }
	
	    /**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    var castRest = baseRest;
	
	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }
	
	    /**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */
	    var clearTimeout = ctxClearTimeout || function(id) {
	      return root.clearTimeout(id);
	    };
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var length = buffer.length,
	          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);
	
	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);
	
	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }
	
	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;
	
	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      var isNew = !object;
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : undefined;
	
	        if (newValue === undefined) {
	          newValue = source[key];
	        }
	        if (isNew) {
	          baseAssignValue(object, key, newValue);
	        } else {
	          assignValue(object, key, newValue);
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Copies own and inherited symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbolsIn(source, object) {
	      return copyObject(source, getSymbolsIn(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return baseRest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBind(func, bitmask, thisArg) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = hasUnicode(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);
	
	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtor(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurry(func, bitmask, arity) {
	      var Ctor = createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        if (!isArrayLike(collection)) {
	          var iteratee = getIteratee(predicate, 3);
	          collection = keys(collection);
	          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	        }
	        var index = findIndexFunc(collection, predicate, fromIndex);
	        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return flatRest(function(funcs) {
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value)) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & WRAP_ARY_FLAG,
	          isBind = bitmask & WRAP_BIND_FLAG,
	          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	          isFlip = bitmask & WRAP_FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtor(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator, defaultValue) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return defaultValue;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return flatRest(function(iteratees) {
	        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	        return baseRest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);
	
	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return hasUnicode(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartial(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toFinite(start);
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toFinite(end);
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & WRAP_CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return setWrapToString(result, func, bitmask);
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	        if (precision && nativeIsFinite(number)) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *    1 - `_.bind`
	     *    2 - `_.bindKey`
	     *    4 - `_.curry` or `_.curryRight` of a bound function
	     *    8 - `_.curry`
	     *   16 - `_.curryRight`
	     *   32 - `_.partial`
	     *   64 - `_.partialRight`
	     *  128 - `_.rearg`
	     *  256 - `_.ary`
	     *  512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] === undefined
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	        var result = createBind(func, bitmask, thisArg);
	      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	        result = createCurry(func, bitmask, arity);
	      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	        result = createPartial(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybrid.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setWrapToString(setter(result, newData), func, bitmask);
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	     * of source objects to the destination object for all destination properties
	     * that resolve to `undefined`.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsAssignIn(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	     * objects into destination objects that are passed thru.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, objValue);
	        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
	        stack['delete'](srcValue);
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	     * objects.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {string} key The key of the property to inspect.
	     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	     */
	    function customOmitClone(value) {
	      return isPlainObject(value) ? undefined : value;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Check that cyclic values are equal.
	      var arrStacked = stack.get(array);
	      var othStacked = stack.get(other);
	      if (arrStacked && othStacked) {
	        return arrStacked == other && othStacked == array;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	      stack.set(array, other);
	      stack.set(other, array);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!cacheHas(seen, othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	                  return seen.push(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, bitmask, customizer, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;
	
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	        case numberTag:
	          // Coerce booleans to `1` or `0` and dates to milliseconds.
	          // Invalid dates are coerced to `NaN`.
	          return eq(+object, +other);
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	          convert || (convert = setToArray);
	
	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= COMPARE_UNORDERED_FLAG;
	
	          // Recursively compare objects (susceptible to call stack limits).
	          stack.set(object, other);
	          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	          stack['delete'](object);
	          return result;
	
	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          objProps = getAllKeys(object),
	          objLength = objProps.length,
	          othProps = getAllKeys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      // Check that cyclic values are equal.
	      var objStacked = stack.get(object);
	      var othStacked = stack.get(other);
	      if (objStacked && othStacked) {
	        return objStacked == other && othStacked == object;
	      }
	      var result = true;
	      stack.set(object, other);
	      stack.set(other, object);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    function flatRest(func) {
	      return setToString(overRest(func, undefined, flatten), func + '');
	    }
	
	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;
	
	      while (length--) {
	        var key = result[length],
	            value = object[key];
	
	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }
	
	    /**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */
	    function getRawTag(value) {
	      var isOwn = hasOwnProperty.call(value, symToStringTag),
	          tag = value[symToStringTag];
	
	      try {
	        value[symToStringTag] = undefined;
	        var unmasked = true;
	      } catch (e) {}
	
	      var result = nativeObjectToString.call(value);
	      if (unmasked) {
	        if (isOwn) {
	          value[symToStringTag] = tag;
	        } else {
	          delete value[symToStringTag];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	      if (object == null) {
	        return [];
	      }
	      object = Object(object);
	      return arrayFilter(nativeGetSymbols(object), function(symbol) {
	        return propertyIsEnumerable.call(object, symbol);
	      });
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    var getTag = baseGetTag;
	
	    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = baseGetTag(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : '';
	
	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */
	    function getWrapDetails(source) {
	      var match = source.match(reWrapDetails);
	      return match ? match[1].split(reSplitDetails) : [];
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          result = false;
	
	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result || ++index != length) {
	        return result;
	      }
	      length = object == null ? 0 : object.length;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isArguments(object));
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = new array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case dataViewTag:
	          return cloneDataView(object, isDeep);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return new Ctor;
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return new Ctor;
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */
	    function insertWrapDetails(source, details) {
	      var length = details.length;
	      if (!length) {
	        return source;
	      }
	      var lastIndex = length - 1;
	      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	      details = details.join(length > 2 ? ', ' : ' ');
	      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	    }
	
	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value) ||
	        !!(spreadableSymbol && value && value[spreadableSymbol]);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      var type = typeof value;
	      length = length == null ? MAX_SAFE_INTEGER : length;
	
	      return !!length &&
	        (type == 'number' ||
	          (type != 'symbol' && reIsUint.test(value))) &&
	            (value > -1 && value % 1 == 0 && value < length);
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }
	
	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }
	
	    /**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */
	    function memoizeCapped(func) {
	      var result = memoize(func, function(key) {
	        if (cache.size === MAX_MEMOIZE_SIZE) {
	          cache.clear();
	        }
	        return key;
	      });
	
	      var cache = result.cache;
	      return result;
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & WRAP_BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & WRAP_ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function nativeKeysIn(object) {
	      var result = [];
	      if (object != null) {
	        for (var key in Object(object)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */
	    function objectToString(value) {
	      return nativeObjectToString.call(value);
	    }
	
	    /**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */
	    function overRest(func, start, transform) {
	      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        index = -1;
	        var otherArgs = Array(start + 1);
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = transform(array);
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the property to get.
	     * @returns {*} Returns the property value.
	     */
	    function safeGet(object, key) {
	      if (key === 'constructor' && typeof object[key] === 'function') {
	        return;
	      }
	
	      if (key == '__proto__') {
	        return;
	      }
	
	      return object[key];
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = shortOut(baseSetData);
	
	    /**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    var setTimeout = ctxSetTimeout || function(func, wait) {
	      return root.setTimeout(func, wait);
	    };
	
	    /**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var setToString = shortOut(baseSetToString);
	
	    /**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */
	    function setWrapToString(wrapper, reference, bitmask) {
	      var source = (reference + '');
	      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	    }
	
	    /**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */
	    function shortOut(func) {
	      var count = 0,
	          lastCalled = 0;
	
	      return function() {
	        var stamp = nativeNow(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return arguments[0];
	          }
	        } else {
	          count = 0;
	        }
	        return func.apply(undefined, arguments);
	      };
	    }
	
	    /**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */
	    function shuffleSelf(array, size) {
	      var index = -1,
	          length = array.length,
	          lastIndex = length - 1;
	
	      size = size === undefined ? length : size;
	      while (++index < size) {
	        var rand = baseRandom(index, lastIndex),
	            value = array[rand];
	
	        array[rand] = array[index];
	        array[index] = value;
	      }
	      array.length = size;
	      return array;
	    }
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoizeCapped(function(string) {
	      var result = [];
	      if (string.charCodeAt(0) === 46 /* . */) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, subString) {
	        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });
	
	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }
	
	    /**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */
	    function updateWrapDetails(details, bitmask) {
	      arrayEach(wrapFlags, function(pair) {
	        var value = '_.' + pair[0];
	        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	          details.push(value);
	        }
	      });
	      return details.sort();
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array == null ? 0 : array.length;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array == null ? 0 : array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length;
	      if (!length) {
	        return [];
	      }
	      var args = Array(length - 1),
	          array = arguments[0],
	          index = length;
	
	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
	    }
	
	    /**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = baseRest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = baseRest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs == null ? 0 : pairs.length,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 0, -1) : [];
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = baseRest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = baseRest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      if (comparator) {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array == null ? '' : nativeJoin.call(array, separator);
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
	      }
	      return value === value
	        ? strictLastIndexOf(array, value, index)
	        : baseFindIndex(array, baseIsNaN, index, true);
	    }
	
	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = baseRest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee, 2))
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = flatRest(function(array, indexes) {
	      var length = array == null ? 0 : array.length,
	          result = baseAt(array, indexes);
	
	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));
	
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array == null ? array : nativeReverse.call(array);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 1, length) : [];
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = baseRest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length) ? baseUniq(array) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = baseRest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */
	    var zip = baseRest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = baseRest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = flatRest(function(paths) {
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        ++result[key];
	      } else {
	        baseAssignValue(result, key, 1);
	      }
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     *
	     * // Combining several predicates using `_.overEvery` or `_.overSome`.
	     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
	     * // => objects for ['fred', 'barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);
	
	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }
	
	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        baseAssignValue(result, key, [value]);
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = baseRest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      baseAssignValue(result, key, value);
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, negate(getIteratee(predicate, 3)));
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var func = isArray(collection) ? arraySample : baseSample;
	      return func(collection);
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
	      return func(collection, n);
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      var func = isArray(collection) ? arrayShuffle : baseShuffle;
	      return func(collection);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        return isString(collection) ? stringSize(collection) : collection.length;
	      }
	      var tag = getTag(collection);
	      if (tag == mapTag || tag == setTag) {
	        return collection.size;
	      }
	      return baseKeys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 30 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
	     */
	    var sortBy = baseRest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = ctxNow || function() {
	      return root.Date.now();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = baseRest(function(func, thisArg, partials) {
	      var bitmask = WRAP_BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = baseRest(function(object, key, partials) {
	      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;
	
	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }
	
	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }
	
	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            timeWaiting = wait - timeSinceLastCall;
	
	        return maxing
	          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	          : timeWaiting;
	      }
	
	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;
	
	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }
	
	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }
	
	      function trailingEdge(time) {
	        timerId = undefined;
	
	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }
	
	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }
	
	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }
	
	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);
	
	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;
	
	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            clearTimeout(timerId);
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */
	    var defer = baseRest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = baseRest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrap(func, WRAP_FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result) || cache;
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }
	
	    // Expose `MapCache`.
	    memoize.Cache = MapCache;
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        var args = arguments;
	        switch (args.length) {
	          case 0: return !predicate.call(this);
	          case 1: return !predicate.call(this, args[0]);
	          case 2: return !predicate.call(this, args[0], args[1]);
	          case 3: return !predicate.call(this, args[0], args[1], args[2]);
	        }
	        return !predicate.apply(this, args);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = castRest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
	
	      var funcsLength = transforms.length;
	      return baseRest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = flatRest(function(func, indexes) {
	      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? start : toInteger(start);
	      return baseRest(func, start);
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start == null ? 0 : nativeMax(toInteger(start), 0);
	      return baseRest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      return partial(castFunction(wrapper), value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */
	    function conformsTo(object, source) {
	      return source == null || baseConformsTo(object, source, keys(source));
	    }
	
	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	        !propertyIsEnumerable.call(value, 'callee');
	    };
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(value.length) && !isFunction(value);
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && baseGetTag(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = nativeIsBuffer || stubFalse;
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) &&
	          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	        return !value.length;
	      }
	      var tag = getTag(value);
	      if (tag == mapTag || tag == setTag) {
	        return !value.size;
	      }
	      if (isPrototype(value)) {
	        return !baseKeys(value).length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are compared by strict equality, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      var tag = baseGetTag(value);
	      return tag == errorTag || tag == domExcTag ||
	        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      if (!isObject(value)) {
	        return false;
	      }
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 9 which returns 'object' for typed arrays and other constructors.
	      var tag = baseGetTag(value);
	      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return value != null && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return value != null && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error(CORE_ERROR_TEXT);
	      }
	      return baseIsNative(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && baseGetTag(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	        funcToString.call(Ctor) == objectCtorString;
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && baseGetTag(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (symIterator && value[symIterator]) {
	        return iteratorToArray(value[symIterator]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;
	
	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = baseTrim(value);
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return value
	        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
	        : (value === 0 ? value : 0);
	    }
	
	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      copyObject(source, keysIn(source), object);
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = flatRest(baseAt);
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties == null ? result : baseAssign(result, properties);
	    }
	
	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var defaults = baseRest(function(object, sources) {
	      object = Object(object);
	
	      var index = -1;
	      var length = sources.length;
	      var guard = length > 2 ? sources[2] : undefined;
	
	      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	        length = 1;
	      }
	
	      while (++index < length) {
	        var source = sources[index];
	        var props = keysIn(source);
	        var propsIndex = -1;
	        var propsLength = props.length;
	
	        while (++propsIndex < propsLength) {
	          var key = props[propsIndex];
	          var value = object[key];
	
	          if (value === undefined ||
	              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	            object[key] = source[key];
	          }
	        }
	      }
	
	      return object;
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */
	    var defaultsDeep = baseRest(function(args) {
	      args.push(undefined, customDefaultsMerge);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = baseRest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, iteratee(value, key, object), value);
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, key, iteratee(value, key, object));
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable property paths of `object` that are not omitted.
	     *
	     * **Note:** This method is considerably slower than `_.pick`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = flatRest(function(object, paths) {
	      var result = {};
	      if (object == null) {
	        return result;
	      }
	      var isDeep = false;
	      paths = arrayMap(paths, function(path) {
	        path = castPath(path, object);
	        isDeep || (isDeep = path.length > 1);
	        return path;
	      });
	      copyObject(object, getAllKeysIn(object), result);
	      if (isDeep) {
	        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	      }
	      var length = paths.length;
	      while (length--) {
	        baseUnset(result, paths[length]);
	      }
	      return result;
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      return pickBy(object, negate(getIteratee(predicate)));
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = flatRest(function(object, paths) {
	      return object == null ? {} : basePick(object, paths);
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      if (object == null) {
	        return {};
	      }
	      var props = arrayMap(getAllKeysIn(object), function(prop) {
	        return [prop];
	      });
	      predicate = getIteratee(predicate);
	      return basePickBy(object, props, function(value, path) {
	        return predicate(value, path[0]);
	      });
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length;
	
	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        length = 1;
	        object = undefined;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);
	
	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object),
	          isArrLike = isArr || isBuffer(object) || isTypedArray(object);
	
	      iteratee = getIteratee(iteratee, 4);
	      if (accumulator == null) {
	        var Ctor = object && object.constructor;
	        if (isArrLike) {
	          accumulator = isArr ? new Ctor : [];
	        }
	        else if (isObject(object)) {
	          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	        }
	        else {
	          accumulator = {};
	        }
	      }
	      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }
	
	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }
	
	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object == null ? [] : baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toFinite(start);
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toFinite(end);
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toFinite(lower);
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toFinite(upper);
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      var end = position;
	      position -= target.length;
	      return position >= 0 && string.slice(position, end) == target;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (!separator && hasUnicode(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return string.split(separator, limit);
	    }
	
	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = position == null
	        ? 0
	        : baseClamp(toInteger(position), 0, string.length);
	
	      target = baseToString(target);
	      return string.slice(position, position + target.length) == target;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, customDefaultsAssignIn);
	
	      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      // The sourceURL gets injected into the source that's eval-ed, so be careful
	      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
	      // and escape the comment, thus injecting code that gets evaled.
	      var sourceURL = '//# sourceURL=' +
	        (hasOwnProperty.call(options, 'sourceURL')
	          ? (options.sourceURL + '').replace(/\s/g, ' ')
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Throw an error if a forbidden character was found in `variable`, to prevent
	      // potential command injection attacks.
	      else if (reForbiddenIdentifierChars.test(variable)) {
	        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
	      }
	
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return baseTrim(string);
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	      return castSlice(strSymbols, start, end).join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.slice(0, trimmedEndIndex(string) + 1);
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
	
	      return castSlice(strSymbols, 0, end).join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));
	
	      return castSlice(strSymbols, start).join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (hasUnicode(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = baseRest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = flatRest(function(object, methodNames) {
	      arrayEach(methodNames, function(key) {
	        key = toKey(key);
	        baseAssignValue(object, key, bind(object[key], object));
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs == null ? 0 : pairs.length,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return baseRest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */
	    function defaultTo(value, defaultValue) {
	      return (value == null || value !== value) ? defaultValue : value;
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * **Note:** Multiple values can be checked by combining several matchers
	     * using `_.overSome`
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     *
	     * // Checking for several possible values
	     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
	     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * **Note:** Multiple values can be checked by combining several matchers
	     * using `_.overSome`
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     *
	     * // Checking for several possible values
	     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
	     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = baseRest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = baseRest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return baseRest(function(args) {
	        return baseNth(args, n);
	      });
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * Following shorthands are possible for providing predicates.
	     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
	     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * Following shorthands are possible for providing predicates.
	     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
	     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     *
	     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
	     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }
	
	    /**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }
	
	    /**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }
	
	    /**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }
	
	    /**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    }, 0);
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    }, 1);
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }
	
	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
	        : undefined;
	    }
	
	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    }, 1);
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    }, 0);
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee, 2))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.conformsTo = conformsTo;
	    lodash.deburr = deburr;
	    lodash.defaultTo = defaultTo;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = (this.__filtered__ && !index)
	          ? new LazyWrapper(this)
	          : this.clone();
	
	        if (result.__filtered__) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      return this.filter(negate(getIteratee(predicate)));
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });
	
	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = lodashFunc.name + '';
	        if (!hasOwnProperty.call(realNames, key)) {
	          realNames[key] = [];
	        }
	        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add lazy aliases.
	    lodash.prototype.first = lodash.prototype.head;
	
	    if (symIterator) {
	      lodash.prototype[symIterator] = wrapperToIterator;
	    }
	    return lodash;
	  });
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers, like r.js, check for condition patterns like:
	  if (true) {
	    // Expose Lodash on the global object to prevent errors when Lodash is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    // Use `_.noConflict` to remove Lodash from the global object.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds it.
	  else if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(31)(module)))

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _app = __webpack_require__(202);
	
	var _app2 = _interopRequireDefault(_app);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AppComponent = {
	  controller: _app2.default,
	  template: '\n    <app-sidenav ng-if="$root.auth" id="app-sidenav" ng-class="{ \'no-sidenav\' : !$ctrl.getSidenav() }"></app-sidenav>\n    <app-navbar ng-if="$root.auth"></app-navbar>\n    <div class="main" ng-class="{ \'no-login\' : !$root.auth }">\n      <app-breadcrumb ng-if="$root.auth"></app-breadcrumb>\n      <section class="main-section" ui-view></section>\n    </div>\n    <app-footer></app-footer>\n    <app-loading></app-loading>\n  '
	};
	
	exports.default = AppComponent;

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _config = __webpack_require__(196);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var server = _config2.default.server;
	
	var Config = angular.module('app.config', []).constant('appName', 'upre') // prefijo del sistema para el Storage y Sessiones
	.constant('systemName', 'Seguimiento de Proyectos').constant('timeSessionExpired', _config2.default.timeSessionExpired) //Tiempo en minutos para que la sesión se cierre automáticamente si existe i$
	.constant('onbeforeunload', _config2.default.onbeforeunload).constant('debug', _config2.default.debug).constant('PageNoLogin', ['login', 'restablecer-contrasenia']) // Rutas que no requieren autenticación
	.constant('authUrl', _config2.default.serverAuth + '/autenticar') // URL para autenticación
	.constant('authEmpresasUrl', _config2.default.serverAuth + '/autenticar/empresa') // URL para autenticación de empresas
	.constant('apiUrl', server + '/api/v1/') // Rest principal del sistema
	.constant('apiUrlSiga', _config2.default.serverSigaApi + '/') // Rest principal del sistema SIGA
	.constant('apiUrlPublic', server + '/public/') // URL publica del sistema
	.constant('baseUrl', server + '/') // Ruta base
	.constant('decimales', 2) // Número de decimales para campos numéricos
	.name;
	
	exports.default = Config;

/***/ }),
/* 202 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AppController = function () {
	  AppController.$inject = ["$rootScope", "$location", "Storage", "Auth", "PageNoLogin", "timeSessionExpired", "SidenavFactory"];
	  function AppController($rootScope, $location, Storage, Auth, PageNoLogin, timeSessionExpired, SidenavFactory) {
	    'ngInject';
	
	    _classCallCheck(this, AppController);
	
	    this.$rootScope = $rootScope;
	    this.$location = $location;
	    this.Auth = Auth;
	    this.Storage = Storage;
	    this.PageNoLogin = PageNoLogin;
	    this.timeSessionExpired = timeSessionExpired;
	    this.SidenavFactory = SidenavFactory;
	  }
	
	  _createClass(AppController, [{
	    key: '$onInit',
	    value: function $onInit() {
	
	      // this.$rootScope.auth = this.Auth.isAuthenticated(); // Descomentar cuando exista el backend
	      this.$rootScope.auth = this.Storage.existUser(); // Comentar cuando ya no se use el fake de autenticación
	
	      // Verificando si se está logueado
	      if (this.$rootScope.auth) {
	        this.Auth.timerSession();
	      } else {
	        var path = this.$location.path();
	
	        // Verificando si el path actual esa una página de excepción que no require autenticación
	        if (!this.exist(path)) {
	          if (path.length) {
	            this.Storage.set('path', path.replace('/', ''));
	          }
	          this.$location.path('login');
	        }
	      }
	    }
	  }, {
	    key: 'exist',
	    value: function exist(path) {
	      var paths = this.PageNoLogin;
	      for (var i in paths) {
	        if (path.indexOf('/' + paths[i]) === 0 || path.indexOf('/' + paths[i] + '/') === 0) {
	          return true;
	        }
	      }
	      return false;
	    }
	  }, {
	    key: 'getSidenav',
	    value: function getSidenav() {
	      return this.SidenavFactory.getSidenav();
	    }
	  }]);
	
	  return AppController;
	}();
	
	exports.default = AppController;

/***/ }),
/* 203 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var CommonConfig = function CommonConfig($httpProvider, $logProvider, $authProvider, authUrl, appName, DataServiceConfig, uibDatepickerPopupConfig, uibDatepickerConfig, formlyConfigProvider, debug, $compileProvider, cfpLoadingBarProvider) {
	  'ngInject';
	
	  // Habilitar los logs del sistema
	
	  $logProvider.debugEnabled(true);
	
	  // Configurando parametros para autenticación con Satellizer
	  // Config url auth
	  $authProvider.loginUrl = authUrl;
	  // $authProvider.signupUrl = "http://api.com/auth/signup";
	  $authProvider.tokenName = "token";
	  $authProvider.tokenPrefix = appName;
	  // $httpProvider.defaults.headers.get = { 'Access-Control-Allow-Origin': '*' };
	  // $authProvider.authToken = 'Bearer';
	
	  // Configurando salida de respuesta del rest backend para el DataService
	  // DataServiceConfig.filterResponse = function (response, Message) {
	  //     if (response.datos) {
	  //         response = response.datos;
	  //     } else {
	  //         if (!response.finalizado) {
	  //             Message.error(response.mensaje);
	  //             response = response.datos;
	  //         }
	  //     }
	  //     return response;
	  // };
	
	  // para que en la descarga de archivo quite el unsafe
	  $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|blob):/);
	
	  // Configurando datepicker
	  uibDatepickerPopupConfig.appendToBody = true;
	  uibDatepickerPopupConfig.clearText = 'Limpiar';
	  uibDatepickerPopupConfig.closeText = 'Cerrar';
	  uibDatepickerPopupConfig.currentText = 'Hoy';
	  uibDatepickerPopupConfig.onOpenFocus = false;
	  uibDatepickerPopupConfig.datepickerPopup = 'dd/MM/yyyy';
	  uibDatepickerConfig.showWeeks = false;
	
	  // Configurando formly
	  formlyConfigProvider.setWrapper({
	    name: 'validation',
	    types: ['input', 'select', 'datepicker', 'textarea'],
	    template: '\n      <formly-transclude></formly-transclude>\n      <div class="form-error" ng-messages="fc.$error" ng-if="form.$submitted || options.formControl.$touched">\n        <div ng-message="{{ ::name }}" ng-repeat="(name, message) in ::options.validation.messages" class="message">{{ message(fc.$viewValue, fc.$modelValue, this)}}</div>\n      </div>\n    '
	  });
	
	  // Config loading
	  cfpLoadingBarProvider.spinnerTemplate = '<div id="loading-bar-spinner"><div class="loading-container"><span class="loading-text"></span> <span class="spinner-icon"></span></div></div>';
	};
	CommonConfig.$inject = ["$httpProvider", "$logProvider", "$authProvider", "authUrl", "appName", "DataServiceConfig", "uibDatepickerPopupConfig", "uibDatepickerConfig", "formlyConfigProvider", "debug", "$compileProvider", "cfpLoadingBarProvider"];
	
	exports.default = CommonConfig;

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// Importando css de las librerías del sistema
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(150);
	
	__webpack_require__(151);
	
	__webpack_require__(146);
	
	__webpack_require__(148);
	
	__webpack_require__(153);
	
	__webpack_require__(152);
	
	__webpack_require__(149);
	
	__webpack_require__(147);
	
	__webpack_require__(173);
	
	__webpack_require__(184);
	
	__webpack_require__(183);
	
	var _angularjs = __webpack_require__(95);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _satellizer = __webpack_require__(674);
	
	var _satellizer2 = _interopRequireDefault(_satellizer);
	
	var _angularLoadingBar = __webpack_require__(123);
	
	var _angularLoadingBar2 = _interopRequireDefault(_angularLoadingBar);
	
	var _angularSanitize = __webpack_require__(129);
	
	var _angularSanitize2 = _interopRequireDefault(_angularSanitize);
	
	var _angularMessages = __webpack_require__(125);
	
	var _angularMessages2 = _interopRequireDefault(_angularMessages);
	
	var _angularResource = __webpack_require__(127);
	
	var _angularResource2 = _interopRequireDefault(_angularResource);
	
	var _uiSelect = __webpack_require__(678);
	
	var _uiSelect2 = _interopRequireDefault(_uiSelect);
	
	var _angularToastr = __webpack_require__(132);
	
	var _angularToastr2 = _interopRequireDefault(_angularToastr);
	
	var _angularUiValidate = __webpack_require__(136);
	
	var _angularUiValidate2 = _interopRequireDefault(_angularUiValidate);
	
	__webpack_require__(199);
	
	var _big = __webpack_require__(143);
	
	var _big2 = _interopRequireDefault(_big);
	
	__webpack_require__(75);
	
	__webpack_require__(121);
	
	__webpack_require__(120);
	
	__webpack_require__(552);
	
	__webpack_require__(137);
	
	__webpack_require__(130);
	
	var _common = __webpack_require__(203);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _common3 = __webpack_require__(205);
	
	var _common4 = _interopRequireDefault(_common3);
	
	var _lang = __webpack_require__(307);
	
	var _lang2 = _interopRequireDefault(_lang);
	
	var _core = __webpack_require__(206);
	
	var _core2 = _interopRequireDefault(_core);
	
	var _layout = __webpack_require__(314);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//import '../../../node_modules/leaflet/dist/leaflet'; //<-- agregado mediante webpack.config
	//import '../../../node_modules/angular-leaflet-directive/dist/angular-leaflet-directive';
	//import '../../../node_modules/leaflet-fullscreen/dist/Leaflet.fullscreen';
	
	
	// Importando dependencias
	var Common = angular.module('app.common', [_angularLoadingBar2.default, _angularSanitize2.default, _angularMessages2.default, _angularResource2.default, _satellizer2.default, 'angularFileUpload', 'formlyBootstrap', _angularToastr2.default, 'ngTable', _angularjs2.default, _uiSelect2.default, _lang2.default, _core2.default, _layout2.default, _angularUiValidate2.default, 'cfp.loadingBar', 'mgo-angular-wizard', 'angular-timeline']).config(_common2.default).run(_common4.default).constant('statePrevs', {}) // Controlar state(url) previos para cada state, si no se define en un state trabajara normal
	.constant('_', window._).constant('Big', _big2.default).name;
	//import '../../../node_modules/pdfjs-dist/build/pdf.combined'; //<-- agregado mediante webpack.config
	
	// import 'tether'; // Tether (required for Bootstrap 4.x)
	exports.default = Common;

/***/ }),
/* 205 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var runBlock = function runBlock(onbeforeunload, $transitions, statePrevs, formlyConfig, $anchorScroll) {
	  'ngInject';
	
	  //Fullscreen event and hack mozilla
	
	  function exitFullScreen() {
	    angular.element(document.body).removeClass('fullscreen');
	  }
	
	  angular.element(window.document).on('keyup', function (e) {
	    if (e.keyCode == 27) {
	      exitFullScreen();
	    }
	  });
	
	  document.addEventListener("mozfullscreenchange", function () {
	    if (!document.mozFullScreen) {
	      exitFullScreen();
	    }
	  }, false);
	
	  if (onbeforeunload) {
	    window.onbeforeunload = function () {
	      return '¿Está seguro de abandonar la página?.';
	    };
	  }
	
	  for (var name in statePrevs) {
	    var prevs = statePrevs[name];
	    statePrevs[name] = {};
	    prevs.forEach(function (namePrev) {
	      statePrevs[name][namePrev] = !0;
	    });
	  }
	
	  $transitions.onStart({}, function (transition) {
	    if (transition.from().name != '' && statePrevs[transition.to().name] && !statePrevs[transition.to().name][transition.from().name]) {
	      // $log.log('abort')
	      transition.abort();
	    }
	  });
	
	  formlyConfig.extras.errorExistsAndShouldBeVisibleExpression = 'fc.$touched || form.$submitted';
	
	  $anchorScroll.yOffset = 60;
	};
	runBlock.$inject = ["onbeforeunload", "$transitions", "statePrevs", "formlyConfig", "$anchorScroll"];
	
	exports.default = runBlock;

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _service = __webpack_require__(234);
	
	var _service2 = _interopRequireDefault(_service);
	
	var _filter = __webpack_require__(208);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	var _interceptor = __webpack_require__(213);
	
	var _interceptor2 = _interopRequireDefault(_interceptor);
	
	var _vendorModule = __webpack_require__(557);
	
	var _vendorModule2 = _interopRequireDefault(_vendorModule);
	
	var _util = __webpack_require__(304);
	
	var _util2 = _interopRequireDefault(_util);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Core = angular.module('app.core', [_vendorModule2.default, _interceptor2.default, _filter2.default, _service2.default, _util2.default]).name;
	
	exports.default = Core;

/***/ }),
/* 207 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var DatetimeFilter = function DatetimeFilter(Datetime) {
	    'ngInject';
	
	    return function (date, format) {
	
	        if (format) {
	            if (format == 'literal') {
	                return Datetime.dateLiteral(date);
	            }
	            if (format == 'year') {
	                return Datetime.now('YYYY');
	            }
	            if (format == 'timeLiteral') {
	                return Datetime.timeLiteral(date);
	            }
	            if (format == 'convert') {
	                return Datetime.toString(date);
	            }
	        }
	
	        return date;
	    };
	};
	DatetimeFilter.$inject = ["Datetime"];
	
	exports.default = DatetimeFilter;

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _datetime = __webpack_require__(207);
	
	var _datetime2 = _interopRequireDefault(_datetime);
	
	var _text = __webpack_require__(211);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _number = __webpack_require__(210);
	
	var _number2 = _interopRequireDefault(_number);
	
	var _nombreUnido = __webpack_require__(209);
	
	var _nombreUnido2 = _interopRequireDefault(_nombreUnido);
	
	var _typeof = __webpack_require__(212);
	
	var _typeof2 = _interopRequireDefault(_typeof);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Filter = angular.module('app.filters', []).filter('datetime', _datetime2.default).filter('characters', _text2.default.characters).filter('splitcharacters', _text2.default.splitcharacters).filter('words', _text2.default.words).filter('numberToLiteral', _number2.default.numberToLiteral).filter('formatDecimal', _number2.default.formatDecimal).filter('nombreUnido', _nombreUnido2.default).filter('typeof', _typeof2.default).name;
	
	exports.default = Filter;

/***/ }),
/* 209 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var NombreUnidoFilter = function NombreUnidoFilter(_, Util) {
	    'ngInject';
	
	    return function (objPersona) {
	
	        if (!_.isEmpty(objPersona)) {
	            return Util.getNombreUnido(objPersona);
	        }
	
	        return objPersona;
	    };
	};
	NombreUnidoFilter.$inject = ["_", "Util"];
	
	exports.default = NombreUnidoFilter;

/***/ }),
/* 210 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var NumberFilter = {
	  numberToLiteral: ["numToWord", function numberToLiteral(numToWord) {
	    'ngInject';
	
	    return function (valor) {
	      if (!valor || typeof valor !== 'number') {
	        return;
	      }
	      return numToWord.transformar(valor);
	    };
	  }],
	  formatDecimal: ["$locale", "Util", "decimales", function formatDecimal($locale, Util, decimales) {
	    'ngInject';
	
	    return function (valor, nDecimales) {
	      if (!valor) {
	        return;
	      }
	      if (typeof valor !== 'number') {
	        return valor;
	      }
	      nDecimales = nDecimales || decimales || 2;
	      var separadorDecimal = $locale.NUMBER_FORMATS.DECIMAL_SEP;
	      var separadordeMiles = $locale.NUMBER_FORMATS.GROUP_SEP;
	
	      var valorFormateado = Util.redondear(parseFloat(valor), nDecimales).toFixed(nDecimales);
	      valorFormateado = valorFormateado.replace('.', separadorDecimal);
	
	      var partes = ('' + valorFormateado).split(separadorDecimal);
	      partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, separadordeMiles);
	
	      return partes.join(separadorDecimal);
	    };
	  }]
	};
	
	exports.default = NumberFilter;

/***/ }),
/* 211 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var TextFilter = {
	    characters: function characters() {
	        return function (input, chars, breakOnWord) {
	            if (isNaN(chars)) return input;
	            if (chars <= 0) return '';
	            if (input && input.length > chars) {
	                input = input.substring(0, chars).replace(/(<([^>]+)>)/ig, "");
	
	                if (!breakOnWord) {
	                    var lastspace = input.lastIndexOf(' ');
	                    //get last space
	                    if (lastspace !== -1) {
	                        input = input.substr(0, lastspace);
	                    }
	                } else {
	                    while (input.charAt(input.length - 1) === ' ') {
	                        input = input.substr(0, input.length - 1);
	                    }
	                }
	                return input + '…';
	            }
	            return input;
	        };
	    },
	    splitcharacters: function splitcharacters() {
	        return function (input, chars) {
	            if (isNaN(chars)) return input;
	            if (chars <= 0) return '';
	            if (input && input.length > chars) {
	                input = input.replace(/(<([^>]+)>)/ig, "");
	                var prefix = input.substring(0, chars / 2);
	                var postfix = input.substring(input.length - chars / 2, input.length);
	                return prefix + '...' + postfix;
	            }
	            return input;
	        };
	    },
	    words: function words() {
	        return function (input, words) {
	            if (isNaN(words)) return input;
	            if (words <= 0) return '';
	            if (input) {
	                input = input.replace(/(<([^>]+)>)/ig, "");
	                var inputWords = input.split(/\s+/);
	                if (inputWords.length > words) {
	                    input = inputWords.slice(0, words).join(' ') + '…';
	                }
	            }
	            return input;
	        };
	    }
	};
	
	exports.default = TextFilter;

/***/ }),
/* 212 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var TypeofFilter = function TypeofFilter() {
	    'ngInject';
	
	    return function (object) {
	        return typeof object === 'undefined' ? 'undefined' : _typeof(object);
	    };
	};
	
	exports.default = TypeofFilter;

/***/ }),
/* 213 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var Interceptor = angular.module('app.interceptors', []).factory('AuthInterceptor', ["$q", "$injector", "timeSessionExpired", function ($q, $injector, timeSessionExpired) {
	    'ngInject';
	
	    return {
	        'request': function request(config) {
	
	            // Actualizando el tiempo de sesión de inactividad
	            if (angular.TIME) {
	                angular.TIME = timeSessionExpired * 60;
	            }
	
	            // Agregando cabecera para evitar ataque CSRF
	            // if(config.url.indexOf('http://test-routes.herokuapp.com') != -1) {
	            //     config.headers['x-csrf-token'] = 'lalalalala';
	            // }
	
	            return config;
	        },
	
	        'requestError': function requestError(rejection) {
	
	            return $q.reject(rejection);
	        },
	
	        'response': function response(_response) {
	
	            return _response;
	        },
	
	        'responseError': function responseError(rejection) {
	
	            // Cerrando sesión si no se tiene permisos de acceso
	            if (rejection.status === 403) {
	                var Auth = $injector.get('Auth');
	                Auth.logout();
	            }
	            return $q.reject(rejection);
	        }
	    };
	}]).config(["$httpProvider", function ($httpProvider) {
	    $httpProvider.interceptors.push('AuthInterceptor');
	}]).name;
	
	exports.default = Interceptor;

/***/ }),
/* 214 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ArrayService = function () {
	    function ArrayService() {
	        "ngInject";
	
	        _classCallCheck(this, ArrayService);
	    }
	
	    _createClass(ArrayService, [{
	        key: "replace",
	        value: function replace(text, find, _replace) {
	            for (var i = 0, l = find.length, regex; i < l; i++) {
	                regex = new RegExp(find[i], "g");
	                text = text.replace(regex, _replace[i]);
	            }
	            return text;
	        }
	    }, {
	        key: "insert",
	        value: function insert(arr, index, item) {
	            return arr.splice(index, 0, item);
	        }
	    }]);
	
	    return ArrayService;
	}();
	
	exports.default = ArrayService;

/***/ }),
/* 215 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DataTableService = function () {
	  DataTableService.$inject = ["NgTableParams", "DataService", "Util"];
	  function DataTableService(NgTableParams, DataService, Util) {
	    'ngInject';
	
	    _classCallCheck(this, DataTableService);
	
	    this.NgTableParams = NgTableParams;
	    this.DataService = DataService;
	    this.Util = Util;
	  }
	
	  _createClass(DataTableService, [{
	    key: 'getParams',
	    value: function getParams(url) {
	      var _this = this;
	
	      var queryExtra = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      return new this.NgTableParams({}, {
	        getData: function getData(params) {
	          var query = _this.getQuery(params.url());
	          return _this.DataService.list(url, angular.merge(query, queryExtra)).then(function (response) {
	            if (response && response.datos) {
	              params.total(response.datos.count);
	              _this.showEmptyTable(response.datos);
	              _this.renderLabels(_this.getLabels(query, response.datos));
	              return response.datos.rows;
	            }
	          });
	        }
	      });
	    }
	  }, {
	    key: 'getParamsList',
	    value: function getParamsList(data) {
	      if (this.Util.toType(data) !== 'array') {
	        return;
	      }
	      return new this.NgTableParams({}, {
	        dataset: data
	      });
	    }
	  }, {
	    key: 'getLabels',
	    value: function getLabels(query, data) {
	      return {
	        ini: (query.page - 1) * query.limit + 1,
	        end: query.page * query.limit < data.count ? query.page * query.limit : data.count,
	        total: data.count
	      };
	    }
	  }, {
	    key: 'renderLabels',
	    value: function renderLabels(params) {
	      setTimeout(function () {
	        if (document.querySelector('.ng-table-counts')) {
	          document.querySelector('.ng-table-counts').setAttribute('data-content', 'Filas: ');
	        }
	        if (document.querySelector('.ng-table-pagination')) {
	          document.querySelector('.ng-table-pagination').setAttribute('data-content', params.ini + ' al ' + params.end + ' de ' + params.total + ' Registros.');
	        }
	      }, 100);
	    }
	  }, {
	    key: 'showEmptyTable',
	    value: function showEmptyTable(data) {
	      var areaPagination = angular.element(document.querySelector('div[ng-table-pagination]'));
	      var sinRegistros = '<div class="alert alert-warning empty-table"><i class="fa fa-warning"></i> No existen registros.</div>';
	      if (data.count === 0) {
	        setTimeout(function () {
	          if (!angular.isUndefined(angular.element(document.querySelector(".empty-table"))[0])) {
	            angular.element(document.querySelector('.empty-table')).remove();
	          }
	          areaPagination.append(sinRegistros);
	        }, 100);
	      } else {
	        angular.element(document.querySelector('.empty-table')).remove();
	      }
	    }
	  }, {
	    key: 'getQuery',
	    value: function getQuery(data) {
	      var query = {
	        limit: data.count,
	        page: data.page
	      };
	      var sort = this.getSorting(data);
	      if (sort) {
	        query.order = sort;
	      }
	      var filters = this.getFilters(data);
	      if (filters.length) {
	        if (filters[0].crudtable_search_term) {
	          query.filter = filters[0].crudtable_search_term;
	        } else {
	          for (var i in filters) {
	            var key = Object.keys(filters[i])[0];
	            query[key] = filters[i][key];
	          }
	        }
	      }
	      return query;
	    }
	  }, {
	    key: 'getSorting',
	    value: function getSorting(params) {
	      for (var key in params) {
	        if (key.indexOf('sorting') != -1) {
	          return (params[key] == 'desc' ? "-" : "") + this.removeCorchete(key, 'sorting');
	        }
	      }
	      return null;
	    }
	  }, {
	    key: 'getFilters',
	    value: function getFilters(params) {
	      var filters = [];
	      for (var key in params) {
	        if (key.indexOf('filter') != -1) {
	          filters.push(_defineProperty({}, this.removeCorchete(key, 'filter'), params[key]));
	        }
	      }
	      return filters;
	    }
	  }, {
	    key: 'removeCorchete',
	    value: function removeCorchete(string, search) {
	      return string.replace(search + '[', '').replace(']', '');
	    }
	  }]);
	
	  return DataTableService;
	}();
	
	exports.default = DataTableService;

/***/ }),
/* 216 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var Config = function Config($httpProvider) {
	    'ngInject';
	
	    //initialize get if not there
	
	    if (!$httpProvider.defaults.headers.get) {
	        $httpProvider.defaults.headers.get = {};
	    }
	
	    // Answer edited to include suggestions from comments
	    // because previous version of code introduced browser-related errors
	
	    // //disable IE ajax request caching
	    // $httpProvider.defaults.headers.get['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
	    // extra
	    $httpProvider.defaults.headers.get['Cache-Control'] = 'private, no-cache, no-store, must-revalidate';
	    $httpProvider.defaults.headers.get.Pragma = 'no-cache';
	};
	Config.$inject = ["$httpProvider"];
	
	exports.default = Config;

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _httpCanceler = __webpack_require__(219);
	
	var _httpCanceler2 = _interopRequireDefault(_httpCanceler);
	
	var _data = __webpack_require__(218);
	
	var _data2 = _interopRequireDefault(_data);
	
	var _data3 = __webpack_require__(216);
	
	var _data4 = _interopRequireDefault(_data3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Data = angular.module('app.data', []).constant('DataServiceConfig', {
	    filterResponse: null
	}).service('HTTPCanceler', _httpCanceler2.default).service('DataService', _data2.default).config(_data4.default).name;
	
	exports.default = Data;

/***/ }),
/* 218 */
/***/ (function(module, exports) {

	/*eslint no-console: ["error", { allow: ["group", "dir", "groupEnd", "table"] }] */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DataService = function () {
	  DataService.$inject = ["$http", "$q", "$location", "$sce", "DataServiceConfig", "HTTPCanceler", "Message", "Util", "apiUrl", "appName", "errorsLang", "debug", "$log", "Storage", "Loading", "Auth", "apiUrlSiga"];
	  function DataService($http, $q, $location, $sce, DataServiceConfig, HTTPCanceler, Message, Util, apiUrl, appName, errorsLang, debug, $log, Storage, Loading, Auth, apiUrlSiga) {
	    'ngInject';
	
	    _classCallCheck(this, DataService);
	
	    this.$http = $http;
	    this.$sce = $sce;
	    this.defer = $q.defer();
	    this.Message = Message;
	    this.Util = Util;
	    this.debug = debug;
	    this.DataServiceConfig = DataServiceConfig;
	    this.HTTPCanceler = HTTPCanceler;
	    this.canceler = this.HTTPCanceler.get(this.defer, this.appName);
	    this.apiUrl = apiUrl;
	    this.apiUrlSiga = apiUrlSiga;
	    this.errorsLang = errorsLang;
	    this.appName = appName;
	    this.Storage = Storage;
	    this.Loading = Loading;
	    this.Auth = Auth;
	
	    this.PATERN_HOST = $location.protocol() == 'https' ? /(https:\/\/|www\.)\S+/i : /(http:\/\/|www\.)\S+/i;
	    this.$log = $log;
	  }
	
	  _createClass(DataService, [{
	    key: 'cancelRequest',
	    value: function cancelRequest() {
	      this.HTTPCanceler.cancel();
	      this.canceler = this.HTTPCanceler.get(this.defer, this.appName);
	      this.cancel = true;
	    }
	  }, {
	    key: 'getUrl',
	    value: function getUrl(url, id) {
	      id = typeof id == 'string' || typeof id == 'number' ? '' + id : (typeof id === 'undefined' ? 'undefined' : _typeof(id)) == 'object' && id.id ? '' + id.id : '';
	      if (url[url.length - 1] != '/' && id.length > 0) {
	        id = '/' + id;
	      }
	      return this.PATERN_HOST.test(url) ? url + id : this.apiUrl + url + id;
	    }
	  }, {
	    key: 'getUrlSiga',
	    value: function getUrlSiga(url, id) {
	      id = typeof id == 'string' || typeof id == 'number' ? '' + id : (typeof id === 'undefined' ? 'undefined' : _typeof(id)) == 'object' && id.id ? '' + id.id : '';
	      if (url[url.length - 1] != '/' && id.length > 0) {
	        id = '/' + id;
	      }
	      return this.PATERN_HOST.test(url) ? url + id : this.apiUrlSiga + url + id;
	    }
	  }, {
	    key: 'options',
	    value: function options(url) {
	      return this._http('options', url);
	    }
	  }, {
	    key: 'get',
	    value: function get(url, id) {
	      return this._http('get', url, id);
	    }
	  }, {
	    key: 'getSiga',
	    value: function getSiga(url, id) {
	      return this._httpSiga('get', url, id);
	    }
	  }, {
	    key: 'post',
	    value: function post(url, data) {
	      return this._http('post', url, data);
	    }
	  }, {
	    key: 'put',
	    value: function put(url, data) {
	      return this._http('put', url, data);
	    }
	  }, {
	    key: 'patch',
	    value: function patch(url, data) {
	      return this._http('patch', url, data);
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(url, id) {
	      return this._http('delete', url, id);
	    }
	  }, {
	    key: 'remove',
	    value: function remove(url, id) {
	      return this.delete(url, id);
	    }
	  }, {
	    key: 'list',
	    value: function list(url, query) {
	      query = query ? '?' + this.Util.serialize(query) : '';
	      return this._http('get', url + query);
	    }
	  }, {
	    key: 'listSiga',
	    value: function listSiga(url, query) {
	      query = query ? '?' + this.Util.serialize(query) : '';
	      return this._httpSiga('get', url + query);
	    }
	  }, {
	    key: 'save',
	    value: function save(url, data) {
	      return this._http(data.id ? 'put' : 'post', url, data);
	    }
	  }, {
	    key: '_http',
	    value: function _http(method, url, data) {
	      var _this = this;
	
	      url = this.getUrl(url, data);
	      if (this.debug) {
	        console.group('Petición con DataService:');
	        this.$log.info('URL:', method.toUpperCase(), url);
	        if (data) {
	          this.$log.info('Params:', data);
	        }
	      }
	
	      var setting = {
	        method: method,
	        url: url,
	        timeout: this.canceler.promise
	      };
	
	      if ((typeof data === 'undefined' ? 'undefined' : _typeof(data)) == 'object' && Object.keys(data).length) {
	        delete data.id;
	        setting.data = data;
	      }
	
	      return this.$http(setting).then(function (response) {
	        return _this.filterResponse(response.data);
	      }).catch(function (error) {
	        if (_this.Loading) {
	          _this.Loading.hide();
	        }
	        _this.msgError(error);
	        if (error.data && error.data.erroresValidacion) {
	          return _this.filterResponse(error.data);
	        }
	      });
	    }
	  }, {
	    key: '_httpSiga',
	    value: function _httpSiga(method, url, data) {
	      var _this2 = this;
	
	      url = this.getUrlSiga(url, data);
	      if (this.debug) {
	        console.group('Petición con DataService:');
	        this.$log.info('URL:', method.toUpperCase(), url);
	        if (data) {
	          this.$log.info('Params:', data);
	        }
	      }
	
	      var setting = {
	        method: method,
	        url: url,
	        timeout: this.canceler.promise
	      };
	
	      if ((typeof data === 'undefined' ? 'undefined' : _typeof(data)) == 'object' && Object.keys(data).length) {
	        delete data.id;
	        setting.data = data;
	      }
	
	      return this.$http(setting).then(function (response) {
	        return _this2.filterResponse(response.data);
	      }).catch(function (error) {
	        if (_this2.Loading) {
	          _this2.Loading.hide();
	        }
	        _this2.msgError(error);
	        if (error.data && error.data.erroresValidacion) {
	          return _this2.filterResponse(error.data);
	        }
	      });
	    }
	  }, {
	    key: 'file',
	    value: function file(url, type) {
	      var _this3 = this;
	
	      var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	      url = this.getUrl(url);
	      return this.$http.post(url, data, { responseType: 'arraybuffer' }).then(function (response) {
	        if (response.data) {
	          var file = new window.Blob([response.data], { type: type });
	          var fileURL = window.URL.createObjectURL(file);
	          return _this3.$sce.trustAsResourceUrl(fileURL);
	        }
	        return null;
	      }).catch(function (error) {
	        return _this3.msgError(error);
	      });
	    }
	  }, {
	    key: 'pdf',
	    value: function pdf(url) {
	      var _this4 = this;
	
	      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      var onlyUrl = arguments[2];
	
	      url = this.getUrl(url, data);
	      return this.$http.post(url, data, { responseType: 'arraybuffer' }).then(function (response) {
	        if (response.data) {
	          var file = new window.Blob([response.data], { type: 'application/pdf' });
	          var fileURL = window.URL.createObjectURL(file);
	          return onlyUrl ? fileURL : _this4.$sce.trustAsResourceUrl(fileURL);
	        }
	        return null;
	      }).catch(function (error) {
	        return _this4.msgError(error);
	      });
	    }
	  }, {
	    key: 'setFormly',
	    value: function setFormly(data) {
	      this.formly = data;
	    }
	  }, {
	    key: 'filterResponse',
	    value: function filterResponse(response) {
	      this.Storage.set('dateNow', response.fecha);
	      var data = response.datos || response;
	      if (this.debug) {
	        this.$log.info("Respuesta:");
	        console.dir(data);
	      }
	      if (this.Util.toType(data) == 'array') {
	        if (this.debug) {
	          this.$log.info("La respuesta es un Array:");
	        }
	        if (window.navigator.appName == 'Netscape') {
	          if (this.debug) {
	            console.table(data);
	          }
	        } else {
	          if (this.debug) {
	            console.table(data.map(function (item) {
	              return [item];
	            }));
	          }
	        }
	      }
	      if (this.debug) {
	        console.groupEnd();
	      }
	      if (typeof this.DataServiceConfig.filterResponse == 'function') {
	        return this.DataServiceConfig.filterResponse(response, this.Message);
	      }
	      return response;
	    }
	  }, {
	    key: 'msgError',
	    value: function msgError(error) {
	      if (this.debug) {
	        console.dir('Error:', error);
	        console.groupEnd();
	      }
	      var statusErrors = [500, 404, 409, 403, 401, 400, 502, 412];
	
	      if (error.status === 408 || error.status === 504) {
	        return error;
	      } else if (this.errorsLang[error.status]) {
	        this.Message[statusErrors.indexOf(error.status) != -1 ? 'error' : 'warning'](error.data.mensaje && typeof error.data.mensaje == 'string' ? error.data.mensaje && error.data.errores ? this.getMessageErrors(error.data) : error.data.mensaje : this.parseError(error.data) || this.errorsLang[error.status], error.data.errors ? this.errorsLang.validation : null);
	      } else if (this.cancel) {
	        this.Message.warning(this.errorsLang.cancelRequest);
	        this.cancel = false;
	      } else {
	        this.Message.error(this.parseError(error.data) || this.errorsLang.connection, error && error.data && error.data.mensaje ? error.data.mensaje : null);
	      }
	      if (error.status === 401 && error.data && error.data.mensaje && error.data.mensaje.indexOf('ha expirado') > 0) {
	        this.Auth.logout();
	      }
	
	      return null;
	    }
	  }, {
	    key: 'getMessageErrors',
	    value: function getMessageErrors(error) {
	      var message = [];
	      error = error.errores;
	      for (var i in error) {
	        if (typeof error[i].mensajes == 'string') message.push(error[i].mensajes);else message.push(error[i].mensajes.join(', '));
	      }
	      return message.join('<br>');
	    }
	  }, {
	    key: 'parseError',
	    value: function parseError(error) {
	      var message = [];
	      if (error) {
	        if (error.errors) {
	          if (error.detail || error.error) {
	            return error.detail || error.error;
	          }
	          if (Object.keys(error.errors).length === 0) {
	            return error;
	          }
	
	          error = error.errors;
	          for (var i in error) {
	            message.push('<strong>' + (error[i].label || i) + ':</strong> ' + (this.Util.toType(error[i].errors) == 'array' ? error[i].errors.join(', ') : error[i].errors));
	          }
	          return message.join('<br>');
	        } else if (error.errorType && error.errorType == 'ValidationError') {
	          error = error.property;
	          for (var _i in error) {
	            message.push('<strong>' + (error[_i].label || _i) + ':</strong> ' + (this.Util.toType(error[_i].errors) == 'array' ? error[_i].errors.join(', ') : error[_i].errors));
	          }
	          return message.join('<br>');
	        }
	      }
	      return null;
	    }
	  }]);
	
	  return DataService;
	}();
	
	exports.default = DataService;

/***/ }),
/* 219 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var HTTPCanceler = function () {
	    HTTPCanceler.$inject = ["$q"];
	    function HTTPCanceler($q) {
	        'ngInject';
	
	        _classCallCheck(this, HTTPCanceler);
	
	        this.$q = $q;
	        this.promisesToReject = {};
	        this.canceler = {};
	        this.inited = {};
	    }
	
	    _createClass(HTTPCanceler, [{
	        key: 'get',
	        value: function get(defer, namespace) {
	            namespace = namespace || 'default';
	            if (!this.promisesToReject[namespace]) {
	                this.promisesToReject[namespace] = [];
	                this.canceler[namespace] = null;
	                this.inited[namespace] = false;
	            }
	            if (defer) {
	                this.promisesToReject[namespace].push(defer);
	            }
	            //Create new defer in first time and when the promise was canceled before
	            if (!this.inited[namespace]) {
	                this.canceler[namespace] = this.$q.defer();
	                this.inited[namespace] = true;
	            }
	            return this.canceler[namespace];
	        }
	    }, {
	        key: 'cancel',
	        value: function cancel(namespace) {
	            namespace = namespace || 'default';
	            angular.forEach(this.promisesToReject, function (promises, promiseNamespace) {
	                if (!this.canceler[promiseNamespace]) return;
	                if ('default' !== namespace && namespace != promiseNamespace) return;
	                this.canceler[promiseNamespace].resolve();
	                this.inited[promiseNamespace] = false;
	                // Reject namespace promises
	                angular.forEach(promises, function (defer) {
	                    defer.reject();
	                });
	                this.promisesToReject[promiseNamespace] = [];
	            });
	        }
	    }]);
	
	    return HTTPCanceler;
	}();
	
	exports.default = HTTPCanceler;

/***/ }),
/* 220 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DatetimeService = function () {
	    DatetimeService.$inject = ["Util", "ArrayUtil"];
	    function DatetimeService(Util, ArrayUtil) {
	        "ngInject";
	
	        _classCallCheck(this, DatetimeService);
	
	        this.Util = Util;
	        this.ArrayUtil = ArrayUtil;
	
	        this.formatDate = 'dd/MM/YYYY';
	        this.months = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
	        this.days = ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"];
	        this.dayslong = ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"];
	    }
	
	    // TODO: Verificar si esto funciona
	
	
	    _createClass(DatetimeService, [{
	        key: 'date',
	        value: function date(_date, separator) {
	            _date = _date.split(separator || '-');
	            return new Date(_date[0], _date[1] - 1, _date[2]);
	        }
	    }, {
	        key: 'parse',
	        value: function parse(date, separator) {
	            return [date.getFullYear(), date.getMonth() + 1, date.getDate()].join(separator || '-');
	        }
	    }, {
	        key: 'dateMonth',
	        value: function dateMonth() {
	            var date = new Date();
	            return new Date(date.getFullYear(), date.getMonth(), 1);
	        }
	    }, {
	        key: 'getPrevDateMonth',
	        value: function getPrevDateMonth(data) {
	            data = data || 1;
	            var date = new Date();
	            var day = date.getDate();
	            var month = date.getMonth();
	            var year = date.getFullYear();
	
	            if (day < data) {
	                month--;
	                if (month < 0) {
	                    month = 11;
	                    year--;
	                }
	            }
	            return new Date(year, month, data);
	        }
	    }, {
	        key: 'toString',
	        value: function toString(date) {
	            if (this.Util.toType(date) == 'string') {
	                var pos = date.indexOf('T');
	                if (pos != -1 && pos <= 10 && pos >= 8) {
	                    var fecha = date.substring(0, pos);
	                    if (!/[a-zA-Z]+/g.test(fecha) && /^-?[0-9.]+\-?[0-9]+\-?[0-9]*$/g.test(fecha)) {
	                        fecha = fecha.split('-');
	                        return this.format(new Date(fecha[0], parseInt(fecha[1]) - 1, fecha[2]));
	                    }
	                }
	            } else {
	                if (this.Util.toType(date) == 'date') {
	                    return this.format(new Date(date));
	                }
	            }
	            return date;
	        }
	    }, {
	        key: 'toDate',
	        value: function toDate(string) {
	            if (this.Util.toType(string) == 'string') {
	                var pos = string.indexOf('T');
	                if (pos != -1 && pos <= 10 && pos >= 8) {
	                    var fecha = string.substring(0, pos);
	                    if (!/[a-zA-Z]+/g.test(fecha) && /^-?[0-9.]+\-?[0-9]+\-?[0-9]*$/g.test(fecha)) {
	                        fecha = fecha.split('-');
	                        return new Date(fecha[0], parseInt(fecha[1]) - 1, fecha[2]);
	                    }
	                }
	            }
	            return string;
	        }
	    }, {
	        key: 'isDate',
	        value: function isDate(date) {
	            if (this.Util.toType(date) == 'string') {
	                date = this.convert(date);
	            }
	            return this.isValid(date);
	        }
	    }, {
	        key: 'isValid',
	        value: function isValid(date) {
	            if (this.Util.toType(date) != 'date') return false;
	            return !isNaN(date.getTime());
	        }
	    }, {
	        key: 'isLessThan',
	        value: function isLessThan(date) {
	            return this.milliseconds(date) < new Date().getTime();
	        }
	    }, {
	        key: 'isLessThanDays',
	        value: function isLessThanDays(date, data) {
	            return this.milliseconds(date) > this.subtractDays(new Date(), data);
	        }
	    }, {
	        key: 'isGreaterThan',
	        value: function isGreaterThan(date) {
	            return this.milliseconds(date) > new Date().getTime();
	        }
	    }, {
	        key: 'isGreaterThanDays',
	        value: function isGreaterThanDays(date, data) {
	            return this.milliseconds(date) < this.addDays(new Date(), data);
	        }
	    }, {
	        key: 'addDays',
	        value: function addDays(date, days) {
	            return this.milliseconds(date) + (days || 0) * 24 * 60 * 60 * 1000;
	        }
	    }, {
	        key: 'subtractDays',
	        value: function subtractDays(date, days) {
	            return this.milliseconds(date) - (days || 0) * 24 * 60 * 60 * 1000;
	        }
	    }, {
	        key: 'diff',
	        value: function diff(date2, date1) {
	            return this.milliseconds(date2) - this.milliseconds(date1);
	        }
	    }, {
	        key: 'milliseconds',
	        value: function milliseconds(date) {
	            if (this.Util.toType(date) == 'string') {
	                date = this.convert(date);
	            }
	            return date.getTime();
	        }
	    }, {
	        key: 'convert',
	        value: function convert(date) {
	            date = date.split('/');
	            return this.formatDate == 'dd/MM/YYYY' ? new Date(date[2], date[1] - 1, date[0]) : this.formatDate == 'MM/dd/YYYY' ? new Date(date[2], date[0] - 1, date[1]) : new Date(date[0], date[1] - 1, date[2]);
	        }
	    }, {
	        key: 'setFormatDate',
	        value: function setFormatDate(format) {
	            this.formatDate = format;
	        }
	    }, {
	        key: 'now',
	        value: function now(format) {
	            return this.replace(new Date(), format || this.formatDate);
	        }
	    }, {
	        key: 'dateLiteral',
	        value: function dateLiteral(date) {
	            return this.format(date, 'dd de MMM del YYYY');
	        }
	    }, {
	        key: 'time',
	        value: function time(date) {
	            return this.format(date, 'HH:mm');
	        }
	    }, {
	        key: 'timeLiteral',
	        value: function timeLiteral(time, txt) {
	            var text = '';
	            if (typeof time == 'number') {
	                if (time === 0) {
	                    return '';
	                }
	                if (time < 60) {
	                    text = time + 's';
	                } else if (time < 3600) {
	                    text = Math.floor(time / 60) + 'm ' + (time % 60 > 0 ? time % 60 + 's' : '');
	                } else {
	                    text = Math.floor(time / 3600) + 'h ' + (time % 3600 > 0 ? Math.floor(time / 60) + 'm ' : '') + (time % 60 > 0 ? time % 60 + 's' : '');
	                }
	                return (txt || '') + text;
	            } else {
	                if (time.length === 0) {
	                    return '';
	                }
	                time = time.split(':');
	                var hours = time[0],
	                    minutes = time[1];
	
	                if (parseInt(hours) > 0) {
	                    text += parseInt(hours) + 'h ';
	                }
	                if (parseInt(minutes) > 0) {
	                    text += parseInt(minutes) + 'm ';
	                }
	                if (time.length == 3 && parseInt(time[2]) > 0) {
	                    text += parseInt(time[2]) + 's';
	                }
	
	                return (txt || '') + text;
	            }
	        }
	    }, {
	        key: 'getSeconds',
	        value: function getSeconds(time) {
	            time = time.split(':');
	            var hours = time[0],
	                minutes = time[1],
	                total = 0;
	
	            if (parseInt(hours) > 0) {
	                total += parseInt(hours) * 3600;
	            }
	            if (parseInt(minutes) > 0) {
	                total += parseInt(minutes) * 60;
	            }
	            if (time.length == 3 && parseInt(time[2]) > 0) {
	                total += parseInt(time[2]);
	            }
	
	            return total;
	        }
	    }, {
	        key: 'datetimeLiteral',
	        value: function datetimeLiteral(date) {
	            return this.format(date, 'dddd dd de MMM del YYYY a la(s) HH:mm');
	        }
	    }, {
	        key: 'format',
	        value: function format(date, _format) {
	            var d = new Date(date);
	            if (this.isDate(d)) {
	                return this.replace(d, _format || this.formatDate);
	            }
	            return date;
	        }
	    }, {
	        key: 'standar',
	        value: function standar(date, format) {
	            if (date) {
	                var type = this.Util.toType(date);
	                if (type == 'date') {
	                    return date;
	                }
	                var day, month, year;
	                if (type == 'string') {
	                    format = format || this.formatDate;
	                    var separator = date.indexOf('/') != -1 ? '/' : '-';
	                    date = date.split(separator);
	
	                    if (format == 'dd-MM-YYYY' || format == 'dd/MM/YYYY') {
	                        day = date[0];
	                        month = date[1] - 1;
	                        year = date[2];
	                    }
	
	                    if (format == 'MM-dd-YYYY' || format == 'MM/dd/YYYY') {
	                        day = date[1];
	                        month = date[0] - 1;
	                        year = date[2];
	                    }
	
	                    if (format == 'YYYY-MM-dd' || format == 'YYYY/MM/dd') {
	                        day = date[2];
	                        month = date[1] - 1;
	                        year = date[0];
	                    }
	
	                    if (format == 'YYYY-dd-MM' || format == 'YYYY/dd/MM') {
	                        day = date[1];
	                        month = date[2] - 1;
	                        year = date[0];
	                    }
	                }
	                return new Date(year, month, day);
	            }
	            return null;
	        }
	    }, {
	        key: 'replace',
	        value: function replace(date, format) {
	            format = format || this.formatDate;
	            date = this.standar(date, format);
	            var monthLiteral = format.indexOf('MMM') != -1;
	            return this.ArrayUtil.replace(format, ["dddd", "ddd", "dd", monthLiteral ? 'MMM' : 'MM', 'YYYY', 'HH', 'mm', 'ss'], [this.dayslong[date.getDay()], this.days[date.getDay()], (date.getDate() < 10 ? '0' : '') + date.getDate(), monthLiteral ? this.months[date.getMonth()] : (date.getMonth() + 1 < 10 ? '0' : '') + (date.getMonth() + 1), date.getFullYear(), (date.getHours() < 10 ? '0' : '') + date.getHours(), (date.getMinutes() < 10 ? '0' : '') + date.getMinutes(), (date.getSeconds() < 10 ? '0' : '') + date.getSeconds()]);
	        }
	    }, {
	        key: 'last',
	        value: function last(date) {
	            var now = new Date();
	            var days = this.daysBetweenTwoDates(date, now);
	            if (days > 31) {
	                return this.dateLiteral(date);
	            } else {
	                if (days > 7) {
	                    var weeks = parseInt(days / 7);
	                    return 'Hace ' + weeks + ' semana' + (weeks > 1 ? 's' : '');
	                } else {
	                    if (days >= 1) {
	                        return this.format(date, 'ddd a la(s) HH:mm');
	                    } else {
	                        var hours = this.hoursBetweenTwoDates(date, now);
	                        if (this.isYesterday(date, hours)) {
	                            return 'Ayer a la(s) ' + this.time(date);
	                        } else {
	                            if (hours >= 1) {
	                                return 'Hace ' + hours + ' hora' + (hours > 1 ? 's' : '');
	                            } else {
	                                var minutes = this.minutesBetweenTwoDates(date, now);
	                                if (minutes >= 1) {
	                                    return 'Hace ' + minutes + ' minuto' + (minutes > 1 ? 's' : '');
	                                } else {
	                                    var seconds = this.secondsBetweenTwoDates(date, now);
	                                    return 'Hace ' + seconds + ' segundo' + (seconds > 1 ? 's' : '');
	                                }
	                            }
	                        }
	                    }
	                }
	            }
	        }
	    }, {
	        key: 'secondsBetweenTwoDates',
	        value: function secondsBetweenTwoDates(date1, date2, absolute) {
	            return this.betweenTwoDates(date1, date2, "s", absolute);
	        }
	    }, {
	        key: 'minutesBetweenTwoDates',
	        value: function minutesBetweenTwoDates(date1, date2, absolute) {
	            return this.betweenTwoDates(date1, date2, "i", absolute);
	        }
	    }, {
	        key: 'hoursBetweenTwoDates',
	        value: function hoursBetweenTwoDates(date1, date2, absolute) {
	            return this.betweenTwoDates(date1, date2, "h", absolute);
	        }
	    }, {
	        key: 'daysBetweenTwoDates',
	        value: function daysBetweenTwoDates(date1, date2, absolute) {
	            return this.betweenTwoDates(date1, date2, "d", absolute);
	        }
	    }, {
	        key: 'betweenTwoDates',
	        value: function betweenTwoDates(date1, date2, type, absolute) {
	            var types = { s: 1000, i: 60 * 1000, h: 60 * 60 * 1000, d: 24 * 60 * 60 * 1000 };
	            var diff = parseInt((this.standar(date2).getTime() - this.standar(date1).getTime()) / types[type]);
	
	            if (typeof absolute !== 'undefined' && absolute !== false) {
	                return Math.abs(diff);
	            }
	            return diff;
	        }
	    }, {
	        key: 'isYesterday',
	        value: function isYesterday(date, hours) {
	            if (this.isDate(date)) {
	                date = date.split(' ');
	                var time = date[1].split(':');
	                return hours >= parseInt(time[0]);
	            }
	            return false;
	        }
	    }, {
	        key: 'parseDate',
	        value: function parseDate(date) {
	            var year = date.getFullYear();
	            var month = date.getMonth() + 1;
	            var day = date.getDate();
	            if (day < 10) {
	                day = '0' + day;
	            }
	            if (month < 10) {
	                month = '0' + month;
	            }
	
	            return [day, month, year].join('/');
	        }
	    }, {
	        key: 'parseDateDjango',
	        value: function parseDateDjango(date) {
	            return [date.getFullYear(), date.getMonth() + 1, date.getDate()].join('-');
	        }
	    }, {
	        key: 'lessYearsToDate',
	        value: function lessYearsToDate(nYears, date) {
	            if (!date) {
	                date = new Date();
	            }
	            var vDate = this.date(date.toISOString().slice(0, 10));
	            return new Date(vDate.setYear(vDate.getFullYear() - nYears));
	        }
	    }, {
	        key: 'getFormatDate',
	        value: function getFormatDate(data) {
	            if (data.length === 10) {
	                data = data.split('-').reverse().join('-');
	            }
	            data = data.substring(0, 10);
	            return this.date(data);
	        }
	    }, {
	        key: 'addDaysToDate',
	        value: function addDaysToDate(date, days) {
	            date.setDate(date.getDate() + days);
	            return date;
	        }
	    }]);
	
	    return DatetimeService;
	}();
	
	exports.default = DatetimeService;

/***/ }),
/* 221 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DownloadFile = function () {
	  function DownloadFile() {
	    _classCallCheck(this, DownloadFile);
	
	    this.restrict = 'A';
	    this.controller = DownloadFileController;
	  }
	
	  _createClass(DownloadFile, [{
	    key: 'link',
	    value: function link($scope, $element, $attrs, $ctrl) {
	      $element.bind('click', function () {
	        var url = $attrs.downloadFile;
	        var dType = 'application/pdf';
	        if ($attrs.downloadType === 'csv') {
	          dType = 'text/csv';
	        }
	        $ctrl.$http.get(url, {
	          responseType: 'arraybuffer',
	          headers: { 'Authorization': 'Bearer ' + $ctrl.Storage.get('token') }
	        }).then(function (response) {
	          var blob = new Blob([response.data], {
	            type: dType
	          });
	          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
	            window.navigator.msSaveOrOpenBlob(blob);
	          } else {
	            var url = URL.createObjectURL(blob);
	            var a = document.createElement('a');
	            var date = new Date();
	            a.href = url;
	            a.download = date.getTime() + '_' + $attrs.fileName + ($attrs.downloadType ? '.' + $attrs.downloadType : '');
	            a.target = '_self';
	            document.body.appendChild(a);
	            a.click();
	          }
	        });
	      });
	    }
	  }]);
	
	  return DownloadFile;
	}();
	
	var DownloadFileController = function DownloadFileController($http, Storage) {
	  'ngInject';
	
	  _classCallCheck(this, DownloadFileController);
	
	  this.$http = $http;
	  this.Storage = Storage;
	};
	DownloadFileController.$inject = ["$http", "Storage"];
	
	exports.default = DownloadFile;

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _filter = __webpack_require__(223);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	__webpack_require__(154);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function paste(obj, e) {
	    e.stopPropagation();
	    e.preventDefault();
	
	    var pastedData = void 0;
	    if (window.clipboardData && window.clipboardData.getData) {
	        // IE       
	        pastedData = window.clipboardData.getData('Text');
	    } else if (e.clipboardData && e.clipboardData.getData) {
	        pastedData = e.clipboardData.getData('text/plain');
	    }
	
	    if (typeof pastedData == 'string' && pastedData.length) {
	        pastedData = pastedData.trim();
	    }
	
	    if (obj.maxLength !== undefined) {
	        var maxLength = parseInt(obj.maxLength);
	        if (maxLength && maxLength > 0 && typeof maxLength == 'number') {
	            pastedData = pastedData.substring(0, maxLength);
	        }
	    }
	
	    return pastedData;
	}
	
	function setTextPaste(scope, ngModel, text) {
	    ngModel = ngModel.replace('$ctrl.', '');
	    var model = ngModel.split('.');
	    if (model.length > 1) {
	        if (model.length == 2) {
	            scope.$ctrl[model[0]][model[1]] = text;
	        } else if (model.length == 3) {
	            scope.$ctrl[model[0]][model[1]][model[2]] = text;
	        } else if (model.length == 4) {
	            scope.$ctrl[model[0]][model[1]][model[2]][model[3]] = text;
	        }
	    } else {
	        scope.$ctrl[ngModel] = text;
	    }
	}
	
	var Filter = angular.module('app.service.filter', []).service('Filter', _filter2.default).directive('integer', ["Filter", function (Filter) {
	    return function (scope, element, attr) {
	        element.bind("keydown", function (e) {
	            Filter.integer(e);
	        }).bind('paste', function (e) {
	            if (attr.trimPaste !== undefined) {
	                var text = paste(element[0], e);
	                scope.$apply(function () {
	                    text = Filter.isInteger(text) ? text : '';
	                    setTextPaste(scope, attr.ngModel, text);
	                });
	            } else {
	                setTimeout(function () {
	                    if (!Filter.isInteger(element[0].value)) {
	                        element[0].value = '';
	                    }
	                }, 1);
	            }
	        });
	    };
	}]).directive('decimal', ["Filter", function (Filter) {
	    return function (scope, element, attr) {
	        element.bind("keydown", function (e) {
	            Filter.decimal(e);
	        }).bind('paste', function (e) {
	            if (attr.trimPaste !== undefined) {
	                var text = paste(element[0], e);
	                scope.$apply(function () {
	                    text = Filter.isDecimal(text) ? text : '';
	                    setTextPaste(scope, attr.ngModel, text);
	                });
	            } else {
	                setTimeout(function () {
	                    if (!Filter.isDecimal(element[0].value)) {
	                        element[0].value = '';
	                    }
	                }, 1);
	            }
	        });
	    };
	}]).directive('decimalPositive', ["Filter", function (Filter) {
	    return function (scope, element, attr) {
	        element.bind("keydown", function (e) {
	            Filter.decimalPositive(e);
	        }).bind('paste', function (e) {
	            if (attr.trimPaste !== undefined) {
	                var text = paste(element[0], e);
	                scope.$apply(function () {
	                    text = Filter.isDecimalPositive(text) ? text : '';
	                    setTextPaste(scope, attr.ngModel, text);
	                });
	            } else {
	                setTimeout(function () {
	                    if (!Filter.isDecimalPositive(element[0].value)) {
	                        element[0].value = '';
	                    }
	                }, 1);
	            }
	        });
	    };
	}]).directive('decimalFormat', ["Filter", function (Filter) {
	    return function (scope, element, attr) {
	        element.bind("keydown", function (e) {
	            Filter.decimalFormat(e);
	        }).bind('paste', function (e) {
	            if (attr.trimPaste !== undefined) {
	                var text = paste(element[0], e);
	                scope.$apply(function () {
	                    text = Filter.isDecimalFormat(text) ? text : '';
	                    setTextPaste(scope, attr.ngModel, text);
	                });
	            } else {
	                setTimeout(function () {
	                    if (!Filter.isDecimalFormat(element[0].value)) {
	                        element[0].value = '';
	                    }
	                }, 1);
	            }
	        });
	    };
	}]).directive('numeric', ["Filter", function (Filter) {
	    return function (scope, element, attr) {
	        element.bind("keydown", function (e) {
	            Filter.numeric(e);
	        }).bind('paste', function (e) {
	            if (attr.trimPaste !== undefined) {
	                var text = paste(element[0], e);
	                scope.$apply(function () {
	                    text = Filter.isNumeric(text) ? text : '';
	                    setTextPaste(scope, attr.ngModel, text);
	                });
	            } else {
	                setTimeout(function () {
	                    if (!Filter.isNumeric(element[0].value)) {
	                        element[0].value = '';
	                    }
	                }, 1);
	            }
	        });
	    };
	}]).directive('alpha', ["Filter", function (Filter) {
	    return function (scope, element, attr) {
	        element.bind("keydown", function (e) {
	            Filter.alpha(e);
	        }).bind('paste', function (e) {
	            if (attr.trimPaste !== undefined) {
	                var text = paste(element[0], e);
	                scope.$apply(function () {
	                    text = Filter.isAlpha(text) ? text : '';
	                    setTextPaste(scope, attr.ngModel, text);
	                });
	            } else {
	                setTimeout(function () {
	                    if (!Filter.isAlpha(element[0].value)) {
	                        element[0].value = '';
	                    }
	                }, 1);
	            }
	        });
	    };
	}]).directive('alphaNumeric', ["Filter", function (Filter) {
	    return function (scope, element, attr) {
	        element.bind("keydown", function (e) {
	            Filter.alphaNumeric(e);
	        }).bind('paste', function (e) {
	            if (attr.trimPaste !== undefined) {
	                var text = paste(element[0], e);
	                scope.$apply(function () {
	                    text = Filter.isAlphaNumeric(text) ? text : '';
	                    setTextPaste(scope, attr.ngModel, text);
	                });
	            } else {
	                setTimeout(function () {
	                    if (!Filter.isAlphaNumeric(element[0].value)) {
	                        element[0].value = '';
	                    }
	                }, 1);
	            }
	        });
	    };
	}]).directive('alphaDash', ["Filter", function (Filter) {
	    return function (scope, element, attr) {
	        element.bind("keydown", function (e) {
	            Filter.alphaDash(e);
	        }).bind('paste', function (e) {
	            if (attr.trimPaste !== undefined) {
	                var text = paste(element[0], e);
	                scope.$apply(function () {
	                    text = Filter.isAlphaDash(text) ? text : '';
	                    setTextPaste(scope, attr.ngModel, text);
	                });
	            } else {
	                setTimeout(function () {
	                    if (!Filter.isAlphaDash(element[0].value)) {
	                        element[0].value = '';
	                    }
	                }, 1);
	            }
	        });
	    };
	}]).directive('passport', ["Filter", function (Filter) {
	    return function (scope, element, attr) {
	        element.bind("keydown", function (e) {
	            Filter.passport(e);
	        }).bind('paste', function (e) {
	            if (attr.trimPaste !== undefined) {
	                var text = paste(element[0], e);
	                scope.$apply(function () {
	                    text = Filter.isPassport(text) ? text : '';
	                    setTextPaste(scope, attr.ngModel, text);
	                });
	            } else {
	                setTimeout(function () {
	                    if (!Filter.isPassport(element[0].value)) {
	                        element[0].value = '';
	                    }
	                }, 1);
	            }
	        });
	    };
	}]).directive('phone', ["Filter", function (Filter) {
	    return function (scope, element, attr) {
	        element.bind("keydown", function (e) {
	            Filter.phone(e);
	        }).bind('paste', function (e) {
	            if (attr.trimPaste !== undefined) {
	                var text = paste(element[0], e);
	                scope.$apply(function () {
	                    text = Filter.isPhone(text) ? text : '';
	                    setTextPaste(scope, attr.ngModel, text);
	                });
	            } else {
	                setTimeout(function () {
	                    if (!Filter.isPhone(element[0].value)) {
	                        element[0].value = '';
	                    }
	                }, 1);
	            }
	        });
	    };
	}]).directive('uppercase', function () {
	    return {
	        require: 'ngModel',
	        link: function link(scope, element, attrs, ctrl) {
	            ctrl.$parsers.push(function (input) {
	                return input ? input.toUpperCase() : "";
	            });
	            element.css("text-transform", "uppercase");
	        }
	    };
	}).directive('nit', ["Filter", function (Filter) {
	    var $error = angular.element('<div class="md-error-nit">NIT inválido</div>');
	
	    return function (scope, element) {
	        element.bind("keydown", function (e) {
	            Filter.numeric(e);
	        }).bind("keyup", function () {
	            var isNit = Filter.isNit(element[0].value);
	            var $element = angular.element(element[0]).parent();
	            if (!isNit) {
	                $element.append($error);
	                $element.addClass('relative');
	            } else {
	                $error.remove();
	                $element.removeClass('relative');
	            }
	        }).bind('paste', function () {
	            setTimeout(function () {
	                if (!Filter.isNit(element[0].value)) {
	                    element[0].value = '';
	                }
	            }, 1);
	        });
	    };
	}]).directive('focusMe', ['$timeout', function ($timeout) {
	    return {
	        scope: { trigger: '@focusMe' },
	        link: function link(scope, element) {
	            scope.$watch('trigger', function (value) {
	                if (value === "true") {
	                    $timeout(function () {
	                        element[0].focus();
	                    });
	                }
	            });
	        }
	    };
	}]).directive('focusIf', ['$timeout', function ($timeout) {
	    function link($scope, $element, $attrs) {
	        var dom = $element[0];
	        if ($attrs.focusIf) {
	            $scope.$watch($attrs.focusIf, focus);
	        } else {
	            focus(true);
	        }
	        function focus(condition) {
	            if (condition) {
	                $timeout(function () {
	                    dom.focus();
	                }, $scope.$eval($attrs.focusDelay) || 0);
	            }
	        }
	    }
	    return {
	        restrict: 'A',
	        link: link
	    };
	}]).name;
	
	exports.default = Filter;

/***/ }),
/* 223 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FilterService = function () {
	  function FilterService() {
	    'ngInject';
	
	    var _this = this;
	
	    _classCallCheck(this, FilterService);
	
	    this.exceptions = {
	      "integer": [46, 8, 9, 27, 13, 110, 173, 189, 109],
	      "natural": [46, 8, 9, 27, 13, 110, 190],
	      "decimal": [46, 8, 9, 27, 13, 110, 190, 173, 189, 109],
	      "decimal_positive": [46, 8, 9, 27, 13, 110, 190],
	      "numeric": [46, 8, 9, 27, 13],
	      "alpha": [46, 8, 9, 27, 13, 32],
	      "alpha_dash": [46, 8, 9, 27, 13, 32, 173, 189, 109],
	      "passport": [46, 8, 9, 27, 13, 32, 173, 189, 109, 190, 0, 192]
	    };
	    this.exceptions.alpha_numeric = this.exceptions.alpha;
	    this.evaluate = {
	      numeric: function numeric(e) {
	        return (e.shiftKey || e.keyCode < 48 || e.keyCode > 57) && (e.keyCode < 96 || e.keyCode > 105);
	      },
	      alpha: function alpha(e) {
	        return e.keyCode < 65 || e.keyCode > 90;
	      }
	    };
	    this.evaluate.integer = this.evaluate.numeric;
	    this.evaluate.decimal = this.evaluate.numeric;
	    this.evaluate.natural = this.evaluate.numeric;
	    this.evaluate.decimal_positive = this.evaluate.numeric;
	    this.evaluate.alpha_numeric = function (e) {
	      return _this.evaluate.alpha(e) && _this.evaluate.numeric(e);
	    };
	    this.evaluate.alpha_dash = this.evaluate.alpha_numeric;
	    this.evaluate.alpha_dash = this.evaluate.alpha_numeric;
	    this.evaluate.passport = this.evaluate.alpha_numeric;
	  }
	
	  _createClass(FilterService, [{
	    key: '$onInit',
	    value: function $onInit() {}
	  }, {
	    key: 'nit',
	    value: function nit() {
	      var nit = {
	        verhoeff: function verhoeff(x, y) {
	          var m = ['0123456789', '1234067895', '2340178956', '3401289567', '4012395678', '5987604321', '6598710432', '7659821043', '8765932104', '9876543210'];
	          if (m[x] && m[x][y]) {
	            return parseInt(m[x][y]);
	          }
	          return -1;
	        },
	
	        permutations: function permutations(x, y) {
	          var m = ['0123456789', '1576283094', '5803796142', '8916043527', '9453126870', '4286573901', '2793806415', '7046913258'];
	          if (m[x] && m[x][y]) {
	            return parseInt(m[x][y]);
	          }
	          return -1;
	        },
	
	        evaluate: function evaluate(num) {
	          var check = 0,
	              x,
	              y,
	              z;
	
	          if (typeof num == 'string' && isNaN(num)) {
	            return false;
	          }
	          num = parseInt(num);
	          for (var i = 0, l = num.toString().length; i < l; i++) {
	            x = i % 8;
	            y = num % 10;
	            num = Math.floor(num / 10);
	            z = nit.permutations(x, y);
	            check = nit.verhoeff(check, z);
	          }
	
	          return check === 0;
	        }
	      };
	
	      return nit;
	    }
	  }, {
	    key: 'filterBase',
	    value: function filterBase(e, type) {
	      if (e.altKey === true && e.keyCode >= 96 && e.keyCode <= 105) {
	        e.preventDefault();
	      }
	      if (this.exceptions[type].indexOf(e.keyCode) !== -1 || e.keyCode == 86 && e.ctrlKey === true || e.keyCode == 65 && e.ctrlKey === true || e.keyCode >= 35 && e.keyCode <= 39) {
	        return;
	      }
	      if (this.evaluate[type](e)) {
	        if (type.indexOf('alpha') === 0) {
	          if (!(e.key == 'ñ' || e.key == 'Ñ')) {
	            e.preventDefault();
	          }
	        } else {
	          e.preventDefault();
	        }
	      }
	    }
	  }, {
	    key: 'isNumber',
	    value: function isNumber(o) {
	      return typeof o === 'number' && isFinite(o);
	    }
	  }, {
	    key: 'isFloat',
	    value: function isFloat(value) {
	      return value % 1 !== 0;
	    }
	  }, {
	    key: 'integer',
	    value: function integer(e) {
	      this.filterBase(e, 'integer');
	    }
	  }, {
	    key: 'isInteger',
	    value: function isInteger(value) {
	      if (/[a-zA-Z]+/g.test(value) || !/^-?[0-9.]*$/g.test(value)) {
	        return false;
	      }
	      value = this.convert(value);
	      if (value === 'NaN' || !this.isNumber(value)) {
	        return false;
	      }
	      return !this.isFloat(value);
	    }
	  }, {
	    key: 'decimal',
	    value: function decimal(e) {
	      this.filterBase(e, 'decimal');
	    }
	  }, {
	    key: 'isDecimal',
	    value: function isDecimal(value) {
	      if (/[a-zA-Z]+/g.test(value) || !/^-?[0-9.]+\,?[0-9]*$/g.test(value)) {
	        return false;
	      }
	      value = this.convert(value);
	      if (value === 'NaN') {
	        return false;
	      }
	      return this.isNumber(value);
	    }
	  }, {
	    key: 'decimalPositive',
	    value: function decimalPositive(e) {
	      this.filterBase(e, 'decimal_positive');
	    }
	  }, {
	    key: 'isDecimalPositive',
	    value: function isDecimalPositive(value) {
	      if (/[a-zA-Z]+/g.test(value) || !/^[0-9.]+\,?[0-9]*$/g.test(value)) {
	        return false;
	      }
	      value = this.convert(value);
	      if (value === 'NaN') {
	        return false;
	      }
	      return this.isNumber(value);
	    }
	  }, {
	    key: 'decimalFormat',
	    value: function decimalFormat(e) {
	
	      this.decimalPositive(e);
	
	      var valor = e.target.value;
	      var exceptions = [37, 39, 46, 8, 9];
	      var t = e.keyCode ? e.keyCode : e.which;
	      var target = e.target;
	
	      if (valor.match(/\./g)) {
	        if (t == 190 || t == 110) {
	          e.preventDefault();
	        }
	        var char = t >= 96 && t <= 105 ? t - 96 : String.fromCharCode(t);
	        var newValue = valor.substring(0, target.selectionStart) + char + valor.substring(target.selectionEnd);
	        if (!/^(\d+(?:\.?\d{0,2})?)?$/g.test(newValue) && exceptions.indexOf(t) == -1) {
	          e.preventDefault();
	        }
	      } else {
	        if (t == 190 || t == 110) {
	          var decimal = valor.substring(target.selectionEnd);
	          if (decimal.length > 2) {
	            decimal = decimal.substring(0, 2);
	            e.target.value = valor.substring(0, target.selectionStart) + '.' + decimal;
	            e.preventDefault();
	          }
	          if (valor.length === 0) {
	            e.target.value = '0';
	          }
	        }
	      }
	    }
	  }, {
	    key: 'isDecimalFormat',
	    value: function isDecimalFormat(value) {
	      return (/^(\d+(?:\.?\d{0,2})?)?$/g.test(value)
	      );
	    }
	  }, {
	    key: 'natural',
	    value: function natural(e) {
	      this.filterBase(e, 'natural');
	    }
	  }, {
	    key: 'isNatural',
	    value: function isNatural(value) {
	      if (/[a-zA-Z]+/g.test(value) || !/^[0-9]*$/g.test(value)) {
	        return false;
	      }
	      value = this.convert(value);
	      if (value === 'NaN' || !this.isNumber(value)) {
	        return false;
	      }
	      return !this.isFloat(value) && value >= 0;
	    }
	  }, {
	    key: 'numeric',
	    value: function numeric(e) {
	      this.filterBase(e, 'numeric');
	    }
	  }, {
	    key: 'isNumeric',
	    value: function isNumeric(value) {
	      return (/^([0-9])*$/.test(value)
	      );
	    }
	  }, {
	    key: 'alpha',
	    value: function alpha(e) {
	      this.filterBase(e, 'alpha');
	    }
	  }, {
	    key: 'isAlpha',
	    value: function isAlpha(value) {
	      return (/^[\u00D1\u00F1A-Z a-z]*$/.test(value)
	      );
	    }
	  }, {
	    key: 'alphaNumeric',
	    value: function alphaNumeric(e) {
	      this.filterBase(e, 'alpha_numeric');
	    }
	  }, {
	    key: 'isAlphaNumeric',
	    value: function isAlphaNumeric(value) {
	      return (/^[\u00D1\u00F1A-Z a-z0-9]*$/.test(value)
	      );
	    }
	  }, {
	    key: 'alphaDash',
	    value: function alphaDash(e) {
	      this.filterBase(e, 'alpha_dash');
	    }
	  }, {
	    key: 'isAlphaDash',
	    value: function isAlphaDash(value) {
	      return (/^[\u00D1\u00F1A-Z a-z-_0-9]*$/.test(value)
	      );
	    }
	  }, {
	    key: 'passport',
	    value: function passport(e) {
	      this.filterBase(e, 'passport');
	    }
	  }, {
	    key: 'isPassport',
	    value: function isPassport(value) {
	      return (/^[\u00D1\u00F1A-Z a-z-_0-9\.]*$/.test(value)
	      );
	    }
	  }, {
	    key: 'isPhone',
	    value: function isPhone(value) {
	      return (/^(?:(?:\(?(?:00|\+)([1-e]\d\d|[1-9]\d?)\)?)?[\-\.\ \\\/]?)?((?:\(?\d{1,}\)?[\-\.\ \\\/]?){0,})(?:[\-\.\ \\\/]?(?:#|ext\.?|extension|x)[\-\.\ \\\/]?(\d+))?$/i.test(value)
	      );
	      // return /[\d()*+\- ]+/.test(value);
	    }
	  }, {
	    key: 'removeTagHTML',
	    value: function removeTagHTML(text) {
	      return text.replace(/<([^ >]+)[^>]*>.*?<\/\1>|<[^\/]+\/>/gi, "");
	    }
	  }, {
	    key: 'empty',
	    value: function empty(value) {
	      return value === undefined || value === null || value.length === 0 || /^\s+$/.test(value);
	    }
	  }, {
	    key: 'isEmail',
	    value: function isEmail(value) {
	      return (/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value)
	      );
	    }
	  }, {
	    key: 'convert',
	    value: function convert(value) {
	      return parseFloat(isNaN(value) ? value.replace(/\./g, '').replace(',', '.') : value);
	    }
	  }, {
	    key: 'isNit',
	    value: function isNit(value) {
	      return this.nit().evaluate(value);
	    }
	  }]);
	
	  return FilterService;
	}();
	
	exports.default = FilterService;

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _flujos = __webpack_require__(225);
	
	var _flujos2 = _interopRequireDefault(_flujos);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Flujos = angular.module('app.service.flujos', []).service('Flujos', _flujos2.default).name;
	
	exports.default = Flujos;

/***/ }),
/* 225 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FlujosService = function () {
	  FlujosService.$inject = ["Storage", "_"];
	  function FlujosService(Storage, _) {
	    "ngInject";
	
	    _classCallCheck(this, FlujosService);
	
	    this._ = _;
	    this.Storage = Storage;
	  }
	
	  _createClass(FlujosService, [{
	    key: '$onInit',
	    value: function $onInit() {}
	  }, {
	    key: 'getAtributosPermitidos',
	    value: function getAtributosPermitidos(entidad) {
	      var estado = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'estado_actual';
	
	      this.usuario = this.Storage.getUser();
	      var atributos = entidad[estado].atributos;
	      if (!Array.isArray(entidad[estado].atributos)) {
	        atributos = atributos[this.usuario.rol.id_rol];
	        if (!atributos) {
	          atributos = [];
	        }
	      }
	      entidad[estado].atributos = this._.zipObject(atributos, Array.from(new Array(atributos.length), function () {
	        return true;
	      }));
	    }
	  }]);
	
	  return FlujosService;
	}();
	
	exports.default = FlujosService;

/***/ }),
/* 226 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Formly = function () {
	  function Formly() {
	    'ngInject';
	
	    _classCallCheck(this, Formly);
	  }
	
	  _createClass(Formly, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.cargarPlantillas();
	    }
	  }, {
	    key: 'nuevaPlantilla',
	    value: function nuevaPlantilla(tipo) {
	      return this.parse(this.templates[tipo].template);
	    }
	  }, {
	    key: 'init',
	    value: function init(formlyConfig) {
	      formlyConfig.setType({
	        name: 'texto',
	        templateUrl: 'app/common/util/formly/texto/texto.html'
	      });
	      formlyConfig.setType({
	        name: 'lista',
	        templateUrl: 'app/common/util/formly/listas/lista.html'
	      });
	    }
	  }, {
	    key: 'obtenerConfiguracionItem',
	    value: function obtenerConfiguracionItem(item) {
	      if (item.type === 'layout') return this.parse(item);
	      var obj = {
	        type: item.type,
	        key: item.key,
	        className: this.parse(item.className),
	        templateOptions: this.parse(item.templateOptions),
	        validation: this.parse(item.validation)
	      };
	      return obj;
	    }
	  }, {
	    key: 'parse',
	    value: function parse(data) {
	      return angular.fromJson(angular.toJson(data));
	    }
	  }, {
	    key: 'listaAFormulario',
	    value: function listaAFormulario(listaPlantillas, configForm) {
	      var nro_columnas = configForm.columnas || 1,
	          clase = 'flex-gt-sm-' + parseInt(100 / nro_columnas),
	          nro_filas = parseInt(listaPlantillas / nro_columnas),
	          formularios = [];
	
	      for (var i = 0; i < nro_filas; i++) {
	        formularios.push({
	          elementAttributes: {
	            'layout-gt-sm': 'row',
	            'layout': 'column',
	            'layout-align-gt-sm': 'start-end'
	          },
	          fieldGroup: []
	        });
	      }
	
	      var nro_form = 0,
	          contador = 0;
	
	      while (nro_form < listaPlantillas.length) {
	        // var nro_col = 0;
	        while (nro_form < listaPlantillas.length && nro_form < nro_columnas) {
	          listaPlantillas[nro_form].className = clase;
	          if (listaPlantillas[nro_form].templateOptions.label === '' || listaPlantillas[nro_form].templateOptions.label === null) {
	            listaPlantillas[nro_form].key = listaPlantillas[nro_form].templateOptions.placeholder;
	          } else {
	            listaPlantillas[nro_form] = listaPlantillas[nro_form].templateOptions.label;
	          }
	
	          if (listaPlantillas[nro_form].type === 'radio') {
	            listaPlantillas[nro_form].templateOptions.className = 'layout  layout-wrap';
	          }
	
	          if (configForm.deshabilitar || false) {
	            listaPlantillas[nro_form].templateOptions.disabled = true;
	          } else {
	            listaPlantillas[nro_form].templateOptions.disabled = false;
	          }
	
	          if (configForm.todoMayuscula || false) {
	            if (listaPlantillas[nro_form].type === 'input') {
	              var onKeyUp = 'model["' + listaPlantillas[nro_form].key + '"]= model["' + listaPlantillas[nro_form].key + '"].toUpperCase()';
	              listaPlantillas[nro_form].templateOptions.onKeyUp = onKeyUp;
	            }
	          }
	
	          if (configForm.validacion || false) {
	            if (listaPlantillas[nro_form].type === 'input' || listaPlantillas[nro_form].type === 'datepicker') {
	              listaPlantillas[nro_form].validation = {
	                messages: { required: '"Debe llenar este campo."' }
	              };
	            }
	          }
	
	          formularios[contador].fieldGroup.push(this.obtenerConfiguracionItem(listaPlantillas[nro_form]));
	          nro_form++;
	          // nro_col++;
	        }
	        contador++;
	      }
	      return formularios;
	    }
	  }, {
	    key: 'filtrarDatos',
	    value: function filtrarDatos(listaPlantillas, listaValores) {
	      for (var i = 0; i < listaPlantillas.length; i++) {
	        if (listaPlantillas[i].type === "datepicker") {
	          var nombre = listaPlantillas[i].templateOptions.label;
	          if (listaValores.hasOwnProperty(nombre)) {
	            listaValores[nombre] = new Date(listaValores[nombre]);
	          }
	        }
	      }
	    }
	  }, {
	    key: 'cargarPlantillas',
	    value: function cargarPlantillas() {
	      this.templates = {
	        input: {
	          template: {
	            type: 'input',
	            key: 'inputText',
	            templateOptions: {
	              type: 'text',
	              label: 'Campo de texto',
	              disabled: false
	            }
	          }
	        },
	        radio: {
	          template: {
	            type: 'radio',
	            key: 'inputRadio',
	            templateOptions: {
	              label: 'Selección simple',
	              labelProp: 'value',
	              valueProp: 'id',
	              vertical: false,
	              options: [{ value: 'Opción 1', id: 'op1' }, { value: 'Opción 2', id: 'op2' }]
	            }
	          }
	        },
	        select: {
	          template: {
	            type: 'select',
	            key: 'inputSelect',
	            templateOptions: {
	              label: 'Lista de selección',
	              multiple: false,
	              labelProp: 'value',
	              valueProp: 'id',
	              options: [{ value: 'Opción 1', id: 'op1' }, { value: 'Opción 2', id: 'op2' }]
	            }
	          }
	        },
	        select_multiple: {
	          template: {
	            type: 'select',
	            key: 'inputSelect',
	            templateOptions: {
	              label: 'Lista de selección multiple',
	              multiple: true,
	              labelProp: 'value',
	              valueProp: 'id',
	              options: [{ value: 'Opción 1', id: 'op1' }, { value: 'Opción 2', id: 'op2' }]
	            }
	          }
	        },
	        textarea: {
	          template: {
	            type: 'textarea',
	            key: 'inputTextArea',
	            templateOptions: {
	              label: 'Área de texto',
	              rows: 2,
	              grow: false
	            }
	          }
	        },
	        checkbox: {
	          template: {
	            type: 'checkbox',
	            key: 'inputCheckBox',
	            templateOptions: {
	              label: 'Casilla de verificación',
	              disabled: false
	            }
	          }
	        },
	        datepicker: {
	          template: {
	            type: 'datepicker',
	            key: 'inputDatePicker',
	            templateOptions: {
	              label: 'Calendario'
	            }
	          }
	        },
	        titulo: {
	          template: {
	            type: 'texto',
	            key: 'texto',
	            templateOptions: {
	              label: 'Título',
	              tipo: 'h2',
	              className: 'ap-text-left',
	              mTop: true,
	              mBot: true
	            }
	          }
	        },
	        subtitulo: {
	          template: {
	            type: 'texto',
	            key: 'texto',
	            templateOptions: {
	              label: 'Subtítulo',
	              tipo: 'h2',
	              className: 'ap-text-left',
	              mTop: true,
	              mBot: true
	            }
	          }
	        },
	        parrafo: {
	          template: {
	            type: 'texto',
	            key: 'parrafo',
	            templateOptions: {
	              label: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit,\n            sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.\n            Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris\n            nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in\n            reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla\n            pariatur. Excepteur sint occaecat cupidatat non proident, sunt in\n            culpa qui officia deserunt mollit anim id est laborum.',
	              tipo: 'p',
	              className: 'ap-text-justify',
	              mTop: true,
	              mBot: true
	            }
	          }
	        },
	        ccArchivo: {
	          template: {
	            type: 'ccArchivo',
	            key: 'ccArchivo',
	            templateOptions: {
	              labelw: 10,
	              label: 'CC/Archivo:'
	            }
	          }
	        },
	        cite: {
	          template: {
	            type: 'cite',
	            templateOptions: {
	              labelCite: 'CITE',
	              labelFecha: 'FECHA',
	              tipo: 'general',
	              numeracionPagina: 'false',
	              tipoHoja: 'Letter'
	            }
	          }
	        }
	      };
	    }
	  }, {
	    key: 'datosAVista',
	    value: function datosAVista(datos, modelo) {
	      var elem,
	          form = [],
	          llaves = [];
	
	      for (var i = 0; i < datos.length; i++) {
	        if (datos[i].type == "layout") {
	          var fg = this.parse(datos[i]);
	          var clase = " flex-" + parseInt(100 / fg.elementAttributes['num-cols']);
	          delete fg.type;
	          delete fg.elementAttributes['num-cols'];
	          fg.fieldGroup = [];
	          for (var j = 0; j < datos[j].fieldGroup.length; j++) {
	            elem = this.obtenerConfiguracionItem(datos[i].fieldGroup[j]);
	            elem.className += clase;
	            this.cambiarElemento(elem, llaves, modelo);
	            fg.fieldGroup.push(elem);
	          }
	          form.push(fg);
	        } else {
	          elem = this.obtenerConfiguracionItem(datos[i]);
	          this.cambiarElemento(elem, llaves, modelo);
	          form.push(elem);
	        }
	      }
	    }
	  }, {
	    key: 'tamanoObjeto',
	    value: function tamanoObjeto(objeto) {
	      return Object.keys(objeto).length;
	    }
	  }, {
	    key: 'mostrarErrorRecursivo',
	    value: function mostrarErrorRecursivo(errores) {
	      for (var error in errores) {
	        for (var i = 0; i < errores[error].length; i++) {
	          if (angular.isDefined(errores[error][i].$submitted)) {
	            errores[error][i].$submitted = true;
	            this.mostrarErrorRecursivo(errores[error][i].$error);
	          } else {
	            if (errores[error][i].$setTouched) errores[error][i].$setTouched(true);
	          }
	        }
	      }
	    }
	  }, {
	    key: 'desactivarFormulario',
	    value: function desactivarFormulario(datos, habilitar) {
	      angular.forEach(datos, function (campo) {
	        if (angular.isDefined(campo.fieldGroup)) {
	          for (var i = 0; i < campo.fieldGroup.length; i++) {
	            if (campo.fieldGroup[i].templateOptions) {
	              campo.fieldGroup[i].templateOptions.disabled = habilitar;
	            } else {
	              if (campo.templateOptions) {
	                campo.templateOptions.disabled = habilitar;
	              }
	            }
	          }
	        }
	      });
	    }
	  }, {
	    key: 'limpiarModelo',
	    value: function limpiarModelo(datos, modelo) {
	      var elem,
	          nuevoModelo = {},
	          llaves = {};
	
	      for (var i = 0; i < datos.length; i++) {
	        if (datos[i].type == "layout") {
	          for (var j = 0; j < datos[i].fieldGroup.length; j++) {
	            elem = this.obtenerConfiguracionItem(datos[i].fieldGroup[j]);
	            this.limpiarElemento(elem, llaves, modelo, nuevoModelo);
	          }
	        } else {
	          elem = this.obtenerConfiguracionItem(datos[i]);
	          this.limpiarElemento(elem, llaves, modelo, nuevoModelo);
	        }
	      }
	    }
	  }, {
	    key: 'limpiarElemento',
	    value: function limpiarElemento(elemento, llaves, modelo, nuevoModelo) {
	      if (angular.isUndefined(llaves[elemento.type])) {
	        llaves[elemento.type] = 1;
	        elemento.key = elemento.type + "-0";
	      } else {
	        elemento.key = elemento.type + "-" + llaves[elemento.type];
	        llaves[elemento.type]++;
	      }
	      if (angular.isDefined(modelo[elemento.key])) {
	        nuevoModelo[elemento.key] = angular.copy(modelo[elemento.key]);
	      }
	    }
	  }, {
	    key: 'cambiarElemento',
	    value: function cambiarElemento(elemento, llaves, modelos) {
	      if (angular.isUndefined(llaves[elemento.type])) {
	        llaves[elemento.type] = 1;
	        elemento.key = elemento.type + "-0";
	      } else {
	        elemento.key = elemento.type + "-" + llaves[elemento.type];
	        llaves[elemento.type]++;
	      }
	      if (elemento.type === "radio") {
	        elemento.templateOptions.className = "layout layout-wrap";
	      }
	      if (elemento.type === "datepicker" && angular.isDefined(modelos) && angular.isDefined(modelos[elemento.key])) {
	        modelos[elemento.key] = new Date(modelos[elemento.key]);
	      }
	      if (elemento.type === "textarea") {
	        elemento.templateOptions.grow = true;
	      }
	
	      if (elemento.templateOptions) {
	        var validation = { messages: {} };
	        if (elemento.templateOptions.required) {
	          validation.messages.required = '"Debe llenar este campo."';
	        }
	        if (elemento.type === "input") {
	          var idx = {
	            '([a-zA-Zñáéíóú]+ ?)+': '"El campo debe contener solo palabras separadas por un espacio."',
	            '\\d+': '"El campo debe contener solo números."',
	            '([a-zA-Z0-9ñáéíóú]+ ?)+': '"El campo debe contener palabras y números separadas por un espacio."',
	            '^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$': '"El campo debe ser un email válido."',
	            '^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$': '"El campo debe ser una hora en formato hh:mm (ej. 08:47)"'
	          };
	          if (elemento.templateOptions.pattern) validation.messages.pattern = idx[elemento.templateOptions.pattern];
	          //le da el efecto de slider al mensaje de error
	          validation.show = true;
	          elemento.validation = validation;
	        }
	      }
	    }
	  }]);
	
	  return Formly;
	}();
	
	exports.default = Formly;

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _message = __webpack_require__(228);
	
	var _message2 = _interopRequireDefault(_message);
	
	__webpack_require__(155);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Message = angular.module('app.message', []).service('Message', _message2.default).config(["toastrConfig", function (toastrConfig) {
	    angular.extend(toastrConfig, {
	        allowHtml: true,
	        closeButton: true,
	        extendedTimeOut: 1000,
	        progressBar: true,
	        tapToDismiss: false,
	        timeOut: 6000
	    });
	}]).name;
	
	exports.default = Message;

/***/ }),
/* 228 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MessageService = function () {
	    MessageService.$inject = ["toastr", "$log"];
	    function MessageService(toastr, $log) {
	        "ngInject";
	
	        _classCallCheck(this, MessageService);
	
	        this.toastr = toastr;
	        this.$log = $log;
	    }
	
	    _createClass(MessageService, [{
	        key: 'success',
	        value: function success(msg, title, timeout, callback) {
	            var data = {
	                message: msg || 'La operación se realizó correctamente.',
	                title: title || 'Correcto',
	                type: 'success',
	                timeout: timeout || 6000,
	                callback: callback
	            };
	
	            this._render(data);
	        }
	    }, {
	        key: 'info',
	        value: function info(msg, title, timeout, callback) {
	            var data = {
	
	                message: msg || 'Revise la documentación.',
	                title: title || 'Información',
	                type: 'info',
	                timeout: timeout || 6000,
	                callback: callback
	            };
	
	            this._render(data);
	        }
	    }, {
	        key: 'error',
	        value: function error(msg, title, timeout, callback) {
	            var data = {
	                message: msg || 'Ocurrió un error al procesar su operación.',
	                title: title || 'Error',
	                type: 'error',
	                timeout: timeout || 6000,
	                callback: callback
	            };
	
	            this._render(data);
	        }
	    }, {
	        key: 'warning',
	        value: function warning(msg, title, timeout, callback) {
	            var data = {
	                message: msg || 'Ocurrió algo inesperado al procesar su operación.',
	                title: title || 'Advertencia',
	                type: 'warning',
	                timeout: timeout || 6000,
	                callback: callback
	            };
	
	            this._render(data);
	        }
	    }, {
	        key: '_render',
	        value: function _render(data) {
	            this.toastr[data.type](data.message, data.title, {
	                timeOut: data.timeout
	            });
	        }
	    }]);
	
	    return MessageService;
	}();
	
	exports.default = MessageService;

/***/ }),
/* 229 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ImageviewerModalController = function () {
	  ImageviewerModalController.$inject = ["$uibModalInstance", "$timeout", "$window", "data"];
	  function ImageviewerModalController($uibModalInstance, $timeout, $window, data) {
	    'ngInject';
	
	    _classCallCheck(this, ImageviewerModalController);
	
	    this.$uibModalInstance = $uibModalInstance;
	    this.$timeout = $timeout;
	    this.$window = $window;
	
	    this.title = data.title ? data.title : '';
	    if (data.image) {
	      this.image = data.image;
	      if (data.image.nombre) {
	        this.title += this.title === '' ? data.image.nombre : ' - ' + data.image.nombre;
	      }
	    }
	  }
	
	  _createClass(ImageviewerModalController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.$ivScope = {}; // TODO Buscar otra forma de obtener el $scope de la directiva image-viewer
	      this.$timeout(function () {
	        if (_this.$window.innerWidth > 768) {
	          document.querySelector('.modal-dialog').style.maxWidth = '90%';
	        } else {
	          document.querySelector('.modal-dialog').style.maxWidth = '100%';
	        }
	        document.querySelector('.modal-dialog').style.maxHeight = _this.$window.innerHeight + 'px';
	      }, 100);
	    }
	  }, {
	    key: 'save',
	    value: function save() {
	      this.$uibModalInstance.close(this.informe);
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.$uibModalInstance.dismiss('cancel');
	    }
	  }, {
	    key: 'getBase64Image',
	    value: function getBase64Image() {
	      if (this.informe.base64.indexOf('base64,') > 0) {
	        return this.informe.base64;
	      }
	      return 'data:' + this.informe.tipo + ';base64,' + this.informe.base64;
	    }
	  }, {
	    key: 'getBlobImage',
	    value: function getBlobImage() {
	      var _this2 = this;
	
	      if (!this.descargando) {
	        this.descargando = true;
	        var file = void 0,
	            a = document.createElement('a');
	        a.innerHTML = '.';
	        document.body.appendChild(a);
	        file = this.$$b64toBlob(this.informe.base64.replace('data:' + this.informe.tipo + ';base64,' + this.informe.base64, ''), this.informe.tipo);
	        if (window.navigator.msSaveBlob) {
	          window.navigator.msSaveOrOpenBlob(file, this.informe.nombre || 'documento.pdf');
	          this.descargando = false;
	        } else {
	          a.href = window.URL.createObjectURL(file);
	          // let base64String = btoa(String.fromCharCode.apply(null, new window.Uint8Array(resp.data)));
	          // a.href = 'data:application/pdf;base64,' + base64String;
	          a.download = this.informe.nombre || 'documento.pdf';
	          a.target = '_blank';
	          this.$timeout(function () {
	            a.click();
	            _this2.descargando = false;
	            angular.element(a).remove();
	          }, 250);
	        }
	      }
	    }
	  }, {
	    key: 'descargarImg',
	    value: function descargarImg() {
	      if (this.$ivScope.imageDownload) this.$ivScope.imageDownload();
	    }
	  }, {
	    key: 'imprimirImg',
	    value: function imprimirImg() {
	      if (this.$ivScope.imagePrint) this.$ivScope.imagePrint();
	    }
	
	    /**
	     * b64toBlob - Convert base64 string to a Blob object
	     *
	     * @param  {string}  b64Data     Base64 string
	     * @param  {strig}   contentType Type of base64 file
	     * @param  {integer} sliceSize   Slice for performance
	     * @return {Blob}                Blob object
	     * @description https://stackoverflow.com/questions/16245767/creating-a-blob-from-a-base64-string-in-javascript
	     */
	
	  }, {
	    key: '$$b64toBlob',
	    value: function $$b64toBlob(b64Data, contentType, sliceSize) {
	      contentType = contentType || '';
	      sliceSize = sliceSize || 512;
	
	      var byteCharacters = void 0;
	      if (b64Data.split(',')[0].indexOf('base64') >= 0) {
	        byteCharacters = atob(b64Data.split(',')[1]);
	      } else {
	        byteCharacters = atob(b64Data);
	      }
	      var byteArrays = [];
	
	      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
	        var slice = byteCharacters.slice(offset, offset + sliceSize);
	
	        var byteNumbers = new Array(slice.length);
	        for (var i = 0; i < slice.length; i++) {
	          byteNumbers[i] = slice.charCodeAt(i);
	        }
	
	        var byteArray = new window.Uint8Array(byteNumbers);
	
	        byteArrays.push(byteArray);
	      }
	
	      var blob = new Blob(byteArrays, { type: contentType });
	      return blob;
	    }
	  }]);
	
	  return ImageviewerModalController;
	}();
	
	exports.default = ImageviewerModalController;

/***/ }),
/* 230 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ModalController = function () {
	    ModalController.$inject = ["$uibModalInstance", "data", "title", "icon", "message", "labelOk", "labelCancel", "cancel", "eventCancel", "eventOk", "btnClose"];
	    function ModalController($uibModalInstance, data, title, icon, message, labelOk, labelCancel, cancel, eventCancel, eventOk, btnClose) {
	        'ngInject';
	
	        _classCallCheck(this, ModalController);
	
	        this.data = data;
	        this.title = title;
	        this.icon = icon;
	        this.message = message;
	        this.labelOk = labelOk;
	        this.eventCancel = eventCancel;
	        this.eventOk = eventOk;
	        this.labelCancel = labelCancel;
	        this.cancel = typeof cancel == 'undefined' ? true : cancel === '' ? true : cancel;
	        this.$uibModalInstance = $uibModalInstance;
	        this.btnClose = typeof btnClose == 'undefined' ? true : btnClose;
	    }
	
	    _createClass(ModalController, [{
	        key: 'ok',
	        value: function ok() {
	            this.$uibModalInstance.close(this.data);
	
	            if (typeof this.eventOk == 'function') {
	                this.eventOk();
	            }
	        }
	    }, {
	        key: 'close',
	        value: function close() {
	            this.$uibModalInstance.dismiss('cancel');
	
	            if (typeof this.eventCancel == 'function') {
	                this.eventCancel();
	            }
	            // TODO Modal. Otra forma de quitar el mensaje: Possibly unhandled rejection: cancel
	            this.$uibModalInstance.result.then(function () {}, function () {});
	        }
	    }]);
	
	    return ModalController;
	}();
	
	exports.default = ModalController;

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _modal = __webpack_require__(232);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Modal = angular.module('app.modal', []).service('Modal', _modal2.default).name;
	
	exports.default = Modal;

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _modal = __webpack_require__(230);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _modal3 = __webpack_require__(574);
	
	var _modal4 = _interopRequireDefault(_modal3);
	
	var _pdfviewModal = __webpack_require__(233);
	
	var _pdfviewModal2 = _interopRequireDefault(_pdfviewModal);
	
	var _pdfviewModal3 = __webpack_require__(576);
	
	var _pdfviewModal4 = _interopRequireDefault(_pdfviewModal3);
	
	var _document_view_base64Modal = __webpack_require__(575);
	
	var _document_view_base64Modal2 = _interopRequireDefault(_document_view_base64Modal);
	
	var _imageviewer = __webpack_require__(573);
	
	var _imageviewer2 = _interopRequireDefault(_imageviewer);
	
	var _imageviewer3 = __webpack_require__(229);
	
	var _imageviewer4 = _interopRequireDefault(_imageviewer3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ModalService = function () {
	    ModalService.$inject = ["$uibModal"];
	    function ModalService($uibModal) {
	        "ngInject";
	
	        _classCallCheck(this, ModalService);
	
	        this.$uibModal = $uibModal;
	    }
	
	    _createClass(ModalService, [{
	        key: 'show',
	        value: function show(config) {
	            var setting = {
	                animation: true,
	                ariaLabelledBy: 'modal-title',
	                ariaDescribedBy: 'modal-body',
	                template: config.template || _modal4.default,
	                controller: config.controller || _modal2.default,
	                controllerAs: '$ctrl',
	                size: config.size,
	                keyboard: typeof config.keyboard == 'undefined' ? true : config.keyboard,
	                backdrop: 'static',
	                resolve: {}
	            };
	
	            setData(config, setting, 'data');
	            setData(config, setting, 'title');
	            setData(config, setting, 'icon');
	            setData(config, setting, 'message');
	            setData(config, setting, 'labelOk');
	            setData(config, setting, 'labelCancel');
	            setData(config, setting, 'cancel');
	            setData(config, setting, 'eventCancel');
	            setData(config, setting, 'eventOk');
	            setData(config, setting, 'btnClose');
	
	            return this.$uibModal.open(setting);
	        }
	    }, {
	        key: 'alert',
	        value: function alert(message, callbackOk, title, icon, size) {
	            this.show({
	                title: title || 'Alerta',
	                icon: icon || 'bell',
	                message: message,
	                size: size || 'sm',
	                cancel: false,
	                eventOk: callbackOk,
	                keyboard: false,
	                btnClose: false
	            });
	        }
	    }, {
	        key: 'confirm',
	        value: function confirm(message, callbackOk, callbackCancel, title, labelOk, labelCancel, icon, size) {
	            var config = {
	                title: title || 'Confirmar',
	                icon: icon || 'warning',
	                message: message,
	                eventOk: callbackOk,
	                eventCancel: callbackCancel,
	                labelOk: labelOk,
	                labelCancel: labelCancel,
	                btnClose: false
	            };
	            if (typeof size == 'string') {
	                config.size = size;
	            }
	            this.show(config);
	            // TODO Modal. Otra forma de quitar el mensaje: Possibly unhandled rejection: cancel
	            //this.show(config).result.then(()=>{},()=>{});
	        }
	    }, {
	        key: 'pdf',
	        value: function pdf(urlPdfFile, title) {
	            this.show({
	                template: _pdfviewModal4.default,
	                controller: _pdfviewModal2.default,
	                data: {
	                    urlPdf: urlPdfFile,
	                    title: title
	                },
	                size: 'lg'
	            });
	        }
	    }, {
	        key: 'showDocumentBase64',
	        value: function showDocumentBase64(urlPdfFile, title, type) {
	            this.show({
	                template: _document_view_base64Modal2.default,
	                controller: _pdfviewModal2.default,
	                data: {
	                    urlPdf: urlPdfFile,
	                    title: title,
	                    type: type ? type : 'base64'
	                },
	                size: 'lg'
	            }).result.then(function () {}, function () {});
	        }
	    }, {
	        key: 'showImageBase64',
	        value: function showImageBase64(urlImgFile, title, type) {
	            this.show({
	                template: _imageviewer2.default,
	                controller: _imageviewer4.default,
	                data: {
	                    image: urlImgFile,
	                    title: title,
	                    type: type ? type : 'base64'
	                },
	                size: 'lg'
	            }).result.then(function () {}, function () {});
	        }
	    }]);
	
	    return ModalService;
	}();
	
	function setData(config, setting, data) {
	    setting.resolve[data] = function () {
	        return typeof config[data] == 'undefined' ? '' : config[data];
	    };
	}
	
	exports.default = ModalService;

/***/ }),
/* 233 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PdfViewModalController = function () {
	  PdfViewModalController.$inject = ["$uibModalInstance", "data", "$sce", "DataService", "$log"];
	  function PdfViewModalController($uibModalInstance, data, $sce, DataService, $log) {
	    'ngInject';
	
	    _classCallCheck(this, PdfViewModalController);
	
	    this.item = data;
	    this.$uibModalInstance = $uibModalInstance;
	    this.$sce = $sce;
	    this.DataService = DataService;
	    this.$log = $log;
	  }
	
	  _createClass(PdfViewModalController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      if (this.item.type === 'base64') {
	        this.getFileBase64();
	      } else if (this.item.type === 'strBase64') {
	        // TODO solo se asume archivos PDFs
	        this.documento = {
	          base64: this.item.urlPdf.indexOf('base64') > 0 ? this.item.urlPdf : 'data:application/pdf;base64,' + this.item.urlPdf,
	          tipo: 'application/pdf'
	        };
	      } else {
	        this.getFile();
	      }
	    }
	  }, {
	    key: 'getFile',
	    value: function getFile() {
	      var _this = this;
	
	      this.DataService.pdf(this.item.urlPdf, {}).then(function (response) {
	        _this.$log.log('Documento PDF = ', response);
	        if (response) {
	          _this.urlPdf = response;
	        }
	      });
	    }
	  }, {
	    key: 'getFileBase64',
	    value: function getFileBase64() {
	      var _this2 = this;
	
	      this.DataService.get(this.item.urlPdf, {}).then(function (response) {
	        if (response) {
	          _this2.documento = {
	            base64: 'data:' + response.datos.tipo + ';base64,' + response.datos.base64,
	            tipo: response.datos.tipo
	          };
	        }
	      });
	    }
	  }, {
	    key: 'ok',
	    value: function ok() {
	      this.$uibModalInstance.close();
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.$uibModalInstance.dismiss('cancel');
	    }
	  }]);
	
	  return PdfViewModalController;
	}();
	
	exports.default = PdfViewModalController;

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * No se puede definir factories con las clases de EcmaScript 6, por lo cual se deben
	 * utilizar services para definir estos factories(factory), si se quieren factories
	 * se deben codificar de la manera tradicional con la estructura:
	 * function () { return {} };
	 */
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _filter = __webpack_require__(222);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	var _data = __webpack_require__(217);
	
	var _data2 = _interopRequireDefault(_data);
	
	var _flujos = __webpack_require__(224);
	
	var _flujos2 = _interopRequireDefault(_flujos);
	
	var _storage = __webpack_require__(235);
	
	var _storage2 = _interopRequireDefault(_storage);
	
	var _util = __webpack_require__(237);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _numeroaLetras = __webpack_require__(236);
	
	var _numeroaLetras2 = _interopRequireDefault(_numeroaLetras);
	
	var _array = __webpack_require__(214);
	
	var _array2 = _interopRequireDefault(_array);
	
	var _datetime = __webpack_require__(220);
	
	var _datetime2 = _interopRequireDefault(_datetime);
	
	var _message = __webpack_require__(227);
	
	var _message2 = _interopRequireDefault(_message);
	
	var _modal = __webpack_require__(231);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _formly = __webpack_require__(226);
	
	var _formly2 = _interopRequireDefault(_formly);
	
	var _dataTable = __webpack_require__(215);
	
	var _dataTable2 = _interopRequireDefault(_dataTable);
	
	var _downloadFile = __webpack_require__(221);
	
	var _downloadFile2 = _interopRequireDefault(_downloadFile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Core = angular.module('app.services', [_filter2.default, _data2.default, _message2.default, _modal2.default, _flujos2.default]).service('numToWord', _numeroaLetras2.default).service('Util', _util2.default).service('Storage', _storage2.default).service('ArrayUtil', _array2.default).service('Datetime', _datetime2.default).service('Formly', _formly2.default).service('DataTable', _dataTable2.default).directive('downloadFile', function () {
	    return new _downloadFile2.default();
	}).name;
	
	exports.default = Core;

/***/ }),
/* 235 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var StorageService = function () {
	    StorageService.$inject = ["$window", "appName"];
	    function StorageService($window, appName) {
	        'ngInject';
	
	        _classCallCheck(this, StorageService);
	
	        this.appName = appName || 'app';
	        this.$local = $window.localStorage;
	        this.$session = $window.sessionStorage;
	        this.$JSON = $window.JSON;
	    }
	
	    _createClass(StorageService, [{
	        key: 'setUser',
	        value: function setUser(user) {
	            this.set('user', user);
	        }
	    }, {
	        key: 'getUser',
	        value: function getUser() {
	            return this.get('user');
	        }
	    }, {
	        key: 'existUser',
	        value: function existUser() {
	            return this.exist('user');
	        }
	    }, {
	        key: 'removeUser',
	        value: function removeUser() {
	            this.remove('user');
	            this.removeSession('user');
	        }
	
	        // LocalStorage
	
	    }, {
	        key: 'set',
	        value: function set(key, value) {
	            this.$local.setItem(this.appName + '_' + key, this.$JSON.stringify(value));
	        }
	    }, {
	        key: 'get',
	        value: function get(key) {
	            var data = this.$local.getItem(this.appName + '_' + key);
	            try {
	                return this.$JSON.parse(data);
	            } catch (Exception) {
	                return data;
	            }
	        }
	    }, {
	        key: 'remove',
	        value: function remove(key) {
	            this.$local.removeItem(this.appName + '_' + key);
	        }
	    }, {
	        key: 'destroy',
	        value: function destroy(key) {
	            this.remove(key);
	        }
	    }, {
	        key: 'exist',
	        value: function exist(key) {
	            var value = this.$local.getItem(this.appName + '_' + key);
	            return typeof value != 'undefined' && value != 'undefined' && value != null && value != 'null' && value != '[]';
	        }
	
	        // SessionStorage
	
	    }, {
	        key: 'setSession',
	        value: function setSession(key, value) {
	            this.$session.setItem(this.appName + '_' + key, this.$JSON.stringify(value));
	        }
	    }, {
	        key: 'getSession',
	        value: function getSession(key) {
	            return this.$JSON.parse(this.$session.getItem(this.appName + '_' + key));
	        }
	    }, {
	        key: 'removeSession',
	        value: function removeSession(key) {
	            this.$session.removeItem(this.appName + '_' + key);
	        }
	    }, {
	        key: 'existSession',
	        value: function existSession(key) {
	            var value = this.$session.getItem(this.appName + '_' + key);
	            return typeof value != 'undefined' && value != 'undefined' && value !== null && value != 'null' && value != '[]';
	        }
	
	        // Flash Data
	
	    }, {
	        key: 'getFlash',
	        value: function getFlash(key) {
	            if (this.exist(key)) {
	                var value = this.get(key);
	                this.remove(key);
	                return value;
	            }
	            return false;
	        }
	    }, {
	        key: 'flash',
	        value: function flash(key) {
	            this.getFlash(key);
	        }
	    }]);
	
	    return StorageService;
	}();
	
	exports.default = StorageService;

/***/ }),
/* 236 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	// NumeroALetras
	// The MIT License (MIT)
	//
	// Copyright (c) 2015 Luis Alfredo Chee
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in all
	// copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	// SOFTWARE.
	//
	// @author Rodolfo Carmona
	// @contributor Jean (jpbadoino@gmail.com)
	/*************************************************************/
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var NumeroALetras = function () {
	  function NumeroALetras() {
	    _classCallCheck(this, NumeroALetras);
	  }
	
	  _createClass(NumeroALetras, [{
	    key: 'Unidades',
	    value: function Unidades(num) {
	
	      switch (num) {
	        case 1:
	          return 'UN';
	        case 2:
	          return 'DOS';
	        case 3:
	          return 'TRES';
	        case 4:
	          return 'CUATRO';
	        case 5:
	          return 'CINCO';
	        case 6:
	          return 'SEIS';
	        case 7:
	          return 'SIETE';
	        case 8:
	          return 'OCHO';
	        case 9:
	          return 'NUEVE';
	      }
	
	      return '';
	    } //Unidades()
	
	  }, {
	    key: 'Decenas',
	    value: function Decenas(num) {
	      var decena, unidad;
	      decena = Math.floor(num / 10);
	      unidad = num - decena * 10;
	
	      switch (decena) {
	        case 1:
	          switch (unidad) {
	            case 0:
	              return 'DIEZ';
	            case 1:
	              return 'ONCE';
	            case 2:
	              return 'DOCE';
	            case 3:
	              return 'TRECE';
	            case 4:
	              return 'CATORCE';
	            case 5:
	              return 'QUINCE';
	            default:
	              return 'DIECI' + this.Unidades(unidad);
	          }
	        case 2:
	          switch (unidad) {
	            case 0:
	              return 'VEINTE';
	            default:
	              return 'VEINTI' + this.Unidades(unidad);
	          }
	        case 3:
	          return this.DecenasY('TREINTA', unidad);
	        case 4:
	          return this.DecenasY('CUARENTA', unidad);
	        case 5:
	          return this.DecenasY('CINCUENTA', unidad);
	        case 6:
	          return this.DecenasY('SESENTA', unidad);
	        case 7:
	          return this.DecenasY('SETENTA', unidad);
	        case 8:
	          return this.DecenasY('OCHENTA', unidad);
	        case 9:
	          return this.DecenasY('NOVENTA', unidad);
	        case 0:
	          return this.Unidades(unidad);
	      }
	    } //Unidades()
	
	  }, {
	    key: 'DecenasY',
	    value: function DecenasY(strSin, numUnidades) {
	      if (numUnidades > 0) return strSin + ' Y ' + this.Unidades(numUnidades);
	
	      return strSin;
	    } //DecenasY()
	
	  }, {
	    key: 'Centenas',
	    value: function Centenas(num) {
	      var centenas, decenas;
	      centenas = Math.floor(num / 100);
	      decenas = num - centenas * 100;
	
	      switch (centenas) {
	        case 1:
	          if (decenas > 0) return 'CIENTO ' + this.Decenas(decenas);
	          return 'CIEN';
	        case 2:
	          return 'DOSCIENTOS ' + this.Decenas(decenas);
	        case 3:
	          return 'TRESCIENTOS ' + this.Decenas(decenas);
	        case 4:
	          return 'CUATROCIENTOS ' + this.Decenas(decenas);
	        case 5:
	          return 'QUINIENTOS ' + this.Decenas(decenas);
	        case 6:
	          return 'SEISCIENTOS ' + this.Decenas(decenas);
	        case 7:
	          return 'SETECIENTOS ' + this.Decenas(decenas);
	        case 8:
	          return 'OCHOCIENTOS ' + this.Decenas(decenas);
	        case 9:
	          return 'NOVECIENTOS ' + this.Decenas(decenas);
	      }
	
	      return this.Decenas(decenas);
	    } //Centenas()
	
	  }, {
	    key: 'Seccion',
	    value: function Seccion(num, divisor, strSingular, strPlural) {
	      var cientos, resto, letras;
	      cientos = Math.floor(num / divisor);
	      resto = num - cientos * divisor;
	
	      letras = '';
	
	      if (cientos > 0) if (cientos > 1) letras = this.Centenas(cientos) + ' ' + strPlural;else letras = strSingular;
	
	      if (resto > 0) letras += '';
	
	      return letras;
	    } //Seccion()
	
	  }, {
	    key: 'Miles',
	    value: function Miles(num) {
	      var divisor, cientos, resto, strMiles, strCentenas;
	      divisor = 1000;
	      cientos = Math.floor(num / divisor);
	      resto = num - cientos * divisor;
	
	      strMiles = this.Seccion(num, divisor, 'UN MIL', 'MIL');
	      strCentenas = this.Centenas(resto);
	
	      if (strMiles == '') return strCentenas;
	
	      return strMiles + ' ' + strCentenas;
	    } //Miles()
	
	  }, {
	    key: 'Millones',
	    value: function Millones(num) {
	      var divisor, cientos, resto, strMillones, strMiles;
	      divisor = 1000000;
	      cientos = Math.floor(num / divisor);
	      resto = num - cientos * divisor;
	
	      strMillones = this.Seccion(num, divisor, 'UN MILLON', 'MILLONES');
	      strMiles = this.Miles(resto);
	
	      if (strMillones == '') return strMiles;
	
	      return strMillones + ' ' + strMiles;
	    } //Millones()
	
	  }, {
	    key: 'Billones',
	    value: function Billones(num) {
	      var divisor, cientos, resto, strBillones, strMillones;
	      divisor = 1000000000;
	      cientos = Math.floor(num / divisor);
	      resto = num - cientos * divisor;
	
	      strBillones = this.Seccion(num, divisor, 'UN BILLON', 'BILLONES');
	      strMillones = this.Millones(resto);
	
	      if (strBillones == '') return strMillones;
	
	      return strBillones + ' ' + strMillones;
	    } //Millones()
	
	  }, {
	    key: 'transformar',
	    value: function transformar(num) {
	      var data = {
	        numero: num,
	        enteros: Math.floor(num),
	        centavos: Math.round(num * 100) - Math.floor(num) * 100,
	        letrasCentavos: '',
	        letrasMonedaPlural: 'Bs.', //'PESOS', 'Dólares', 'Bolívares', 'etcs'
	        letrasMonedaSingular: 'Bs.', //'PESO', 'Dólar', 'Bolivar', 'etc'
	        letrasMonedaCentavoPlural: 'Ctvs.',
	        letrasMonedaCentavoSingular: 'ctv.'
	      };
	
	      // if (data.centavos > 0) {
	      //   data.letrasCentavos = 'CON ' + (function (){
	      //     if (data.centavos == 1)
	      //       return this.Billones(data.centavos) + ' ' + data.letrasMonedaCentavoSingular;
	      //     else
	      //       return this.Billones(data.centavos) + ' ' + data.letrasMonedaCentavoPlural;
	      //   })();
	      // }
	
	      if (data.enteros == 0) return 'CERO CON ' + data.centavos + '/100 ' + data.letrasMonedaPlural;
	      if (data.enteros == 1) return this.Billones(data.enteros) + ' CON ' + data.centavos + '/100 ' + data.letrasMonedaSingular;else return this.Billones(data.enteros) + ' CON ' + data.centavos + '/100 ' + data.letrasMonedaPlural;
	    } //NumeroALetras()
	
	  }]);
	
	  return NumeroALetras;
	}();
	
	exports.default = NumeroALetras;

/***/ }),
/* 237 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var UtilService = function () {
	  UtilService.$inject = ["$injector", "$location", "$anchorScroll", "$log", "Message", "decimales", "Storage", "_", "Big"];
	  function UtilService($injector, $location, $anchorScroll, $log, Message, decimales, Storage, _, Big) {
	    "ngInject";
	
	    _classCallCheck(this, UtilService);
	
	    this.$injector = $injector;
	    this.$location = $location;
	    this.$anchorScroll = $anchorScroll;
	    this.$log = $log;
	    this.Message = Message;
	    this.decimales = decimales;
	    this.Storage = Storage;
	    this._ = _;
	    this.Big = Big;
	  }
	
	  _createClass(UtilService, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.tmpl_print = '\n    <!DOCTYPE html>\n    <html lang="en">\n    <head>\n    <meta charset="UTF-8"/>\n    <title>Document</title>\n    <style>{css}</style>\n    </head>\n    <body>{body}</body>\n    </html>';
	    }
	  }, {
	    key: 'toType',
	    value: function toType(obj) {
	      return {}.toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
	    }
	  }, {
	    key: 'isJson',
	    value: function isJson(text) {
	      return (/^[\],:{}\s]*$/.test(text.replace(/\\["\\\/bfnrtu]/g, '@').replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']').replace(/(?:^|:|,)(?:\s*\[)+/g, ''))
	      );
	    }
	  }, {
	    key: 'stripHTML',
	    value: function stripHTML(texto) {
	      return texto.replace(/(<([^>]+)>)/ig, "");
	    }
	  }, {
	    key: 'nano',
	    value: function nano(template, data) {
	      return template.replace(/\{([\w\.]*)\}/g, function (str, key) {
	        var keys = key.split("."),
	            v = data[keys.shift()];
	        for (var i = 0, l = keys.length; i < l; i++) {
	          v = v[keys[i]];
	        }return typeof v !== "undefined" && v !== null ? v : "";
	      });
	    }
	  }, {
	    key: 'print',
	    value: function print(html, css) {
	      var _this = this;
	
	      if (typeof css == 'string') {
	        angular.element.get(css, function (response) {
	          var popup = window.open('', 'print');
	          popup.document.write(_this.nano(_this.tmpl_print, { body: html, css: response }));
	          popup.document.close();
	          popup.focus();
	          popup.print();
	          popup.close();
	        });
	      } else {
	        var popup = window.open('', 'print');
	        popup.document.write(this.nano(this.tmpl_print, { body: html, css: css }));
	        popup.document.close();
	        popup.focus();
	        popup.print();
	        popup.close();
	      }
	
	      return true;
	    }
	
	    /**
	    * Función para crear una pausa para ejecutar una instrucción:
	    *  Ejemplo:
	    *
	    *  let funcionConDelay = this.Util.debounce(function() {
	    *      // ... lo que se quiere ejecutar con el retraso
	    *  }, 1000);
	    *
	    *  funcionConDelay(); // Ejecutando el retraso
	    */
	
	  }, {
	    key: 'debounce',
	    value: function debounce(func, wait, immediate) {
	      var timeout;
	      return function () {
	        var context = this,
	            args = arguments;
	        var later = function later() {
	          timeout = null;
	          if (!immediate) func.apply(context, args);
	        };
	        var callNow = immediate && !timeout;
	        clearTimeout(timeout);
	        timeout = setTimeout(later, wait);
	        if (callNow) func.apply(context, args);
	      };
	    }
	  }, {
	    key: 'popup',
	    value: function popup(url) {
	      window.open(url, 'print');
	    }
	  }, {
	    key: 'fullscreen',
	    value: function fullscreen() {
	      if (!document.fullscreenElement && // alternative standard method
	      !document.mozFullScreenElement && !document.webkitFullscreenElement && !document.msFullscreenElement) {
	        // current working methods
	        if (document.documentElement.requestFullscreen) {
	          document.documentElement.requestFullscreen();
	        } else if (document.documentElement.msRequestFullscreen) {
	          document.documentElement.msRequestFullscreen();
	        } else if (document.documentElement.mozRequestFullScreen) {
	          document.documentElement.mozRequestFullScreen();
	        } else if (document.documentElement.webkitRequestFullscreen) {
	          document.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
	        }
	      } else {
	        if (document.exitFullscreen) {
	          document.exitFullscreen();
	        } else if (document.msExitFullscreen) {
	          document.msExitFullscreen();
	        } else if (document.mozCancelFullScreen) {
	          document.mozCancelFullScreen();
	        } else if (document.webkitExitFullscreen) {
	          document.webkitExitFullscreen();
	        }
	      }
	    }
	  }, {
	    key: 'size',
	    value: function size(obj) {
	      return Object.keys(obj).length;
	    }
	  }, {
	    key: 'serialize',
	    value: function serialize(json) {
	      var string = [];
	      for (var i in json) {
	        string.push(i + '=' + json[i]);
	      }
	      return string.join('&');
	    }
	  }, {
	    key: 'getMenuOption',
	    value: function getMenuOption(menu, url) {
	      for (var i in menu) {
	        if (typeof menu[i].submenu != 'undefined') {
	          var pages = menu[i].submenu;
	          for (var j in pages) {
	            if (pages[j].url == url) {
	              return [menu[i].label, pages[j].label];
	            }
	          }
	        }
	      }
	      for (var k in menu) {
	        if (menu[k].url == url) {
	          return [menu[k].label, false];
	        }
	      }
	      return [false, false];
	    }
	  }, {
	    key: 'getKeys',
	    value: function getKeys(data) {
	      var types = {};
	
	      data.map(function (el) {
	        types[el.key] = el;
	      });
	
	      return types;
	    }
	
	    /**
	    * Public: funcion que retrasa la ejecucion de una funcion, y que al volverse a activar reinicia el timeout
	    * @param {Object} obj  objeto que guardara la referencia del intervalo
	    * @param {Integer} ms  tiempo en miliesgundos
	    * @param {Function} func funcion callback
	    * *
	    * Ejemplo
	    this.timer = {};
	    this.Util.funcDelay(this.timer, 1000, ()=> {
	    this.personalSave(form, per);
	    })
	    */
	
	  }, {
	    key: 'funcDelay',
	    value: function funcDelay(obj, ms, func) {
	      if (obj.timer_delay) clearTimeout(obj.timer_delay);
	
	      obj.timer_delay = setTimeout(function () {
	        obj.timer_delay = null;
	        func();
	      }, ms);
	    }
	  }, {
	    key: 'setTouchedForm',
	    value: function setTouchedForm(form, val, ignored, focusear) {
	      var focus, _funcRecursive;
	      // this.$log.log(form);
	      // this.$log.log(val, ignored);
	      if (ignored) {
	        focus = ignored.split(', ');
	        ignored = {};
	        focus.forEach(function (it) {
	          ignored[it] = true;
	        });
	      } else {
	        ignored = {};
	      }
	      if (angular.isUndefined(val)) val = true;
	      focus = val && angular.isDefined(focusear);
	      // var visits = {};
	      // this.$log.log(visits);
	      _funcRecursive = function funcRecursive(form, val, ignored) {
	        form.$$controls.forEach(function (field) {
	          // if (!visits[field.$name])
	          // visits[field.$name] = 0;
	          if (field.$name != '' && !ignored[field.$name]) {
	            // visits[field.$name]++;
	            if (field.$$controls) {
	              _funcRecursive(field, val, ignored);
	            } else {
	              if (focus && field.$invalid) {
	                // this.$log.log(field);
	                var node = field.$$element[0];
	                var x = node.contentEditable;
	                node.contentEditable = true;
	                if (node.disabled) {
	                  node.disabled = false;
	                  node.focus();
	                  node.disabled = true;
	                } else {
	                  node.focus();
	                }
	                node.contentEditable = x;
	                // this.$log.log(x, node);
	                node = field.$$element.closest(focusear);
	                if (node) {
	                  // this.gotoAnchor(null, node);
	                  node.classList.add('blink-container');
	                  setTimeout(function () {
	                    node.classList.remove('blink-container');
	                  }, 5000);
	                }
	
	                // field.$$element.closest('div.form-group').focus();
	                focus = !focus;
	              }
	              if (val) {
	                field.$setTouched();
	              } else {
	                field.$setUntouched();
	              }
	            }
	          }
	        });
	      };
	      _funcRecursive(form, val, ignored);
	    }
	  }, {
	    key: 'isValidForm',
	    value: function isValidForm(form, ignored) {
	      var resp, _funcRecursive2;
	      // this.$log.log(form);
	      // this.$log.log(val, ignored);
	      if (ignored) {
	        resp = ignored.split(', ');
	        ignored = {};
	        resp.forEach(function (it) {
	          ignored[it] = true;
	        });
	      } else {
	        ignored = {};
	      }
	      resp = true;
	      // var visits = {};
	      // this.$log.log(visits);
	      _funcRecursive2 = function funcRecursive(form, ignored) {
	        form.$$controls.forEach(function (field) {
	          // if (!visits[field.$name])
	          // visits[field.$name] = 0;
	          if (field.$name != '' && !ignored[field.$name]) {
	            // visits[field.$name]++;
	            if (field.$$controls) {
	              _funcRecursive2(field, ignored);
	            } else {
	              if (field.$invalid) resp = false;
	            }
	          }
	        });
	      };
	      _funcRecursive2(form, ignored);
	      return resp;
	    }
	
	    // Obtener nombres de los campos invalidos.
	
	  }, {
	    key: 'getInvalidForms',
	    value: function getInvalidForms(form, ignored) {
	      var resp, _funcRecursive3;
	      if (ignored) {
	        resp = ignored.split(', ');
	        ignored = {};
	        resp.forEach(function (it) {
	          ignored[it] = true;
	        });
	      } else {
	        ignored = {};
	      }
	      resp = [];
	      _funcRecursive3 = function funcRecursive(form, ignored) {
	        form.$$controls.forEach(function (field) {
	          if (field.$name != '' && !ignored[field.$name]) {
	            if (field.$$controls) {
	              _funcRecursive3(field, ignored);
	            } else {
	              if (field.$invalid) {
	                if (!resp.find(function (f) {
	                  return f == field.$name;
	                })) {
	                  resp.push(field.$name);
	                }
	              }
	            }
	          }
	        });
	      };
	      _funcRecursive3(form, ignored);
	      return resp;
	    }
	  }, {
	    key: 'id',
	    value: function id() {
	      var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;
	
	      var zero = '';
	      for (var i = 0, l = length; i < l; i++) {
	        zero += '0';
	      }
	      return (zero + (Math.random() * Math.pow(36, length) << 0).toString(36)).slice(-1 * length);
	    }
	  }, {
	    key: 'gotoAnchor',
	    value: function gotoAnchor(id) {
	      if (this.$location.hash() !== id) {
	        this.$location.hash(id);
	      } else {
	        this.$anchorScroll();
	      }
	      var el = document.querySelector('#' + id);
	      if (el) {
	        el.classList.add('blink-container');
	        setTimeout(function () {
	          el.classList.remove('blink-container');
	        }, 8000);
	      }
	    }
	  }, {
	    key: 'isEmpty',
	    value: function isEmpty(data) {
	      var hasOwnProperty = Object.prototype.hasOwnProperty;
	      if (data == null) return true;
	      if (data.length > 0) return false;
	      if (data.length === 0) return true;
	      if (typeof data === "number") return false;
	      if ((typeof data === 'undefined' ? 'undefined' : _typeof(data)) !== "object") return true;
	      for (var key in data) {
	        if (hasOwnProperty.call(data, key)) return false;
	      }
	      return true;
	    }
	  }, {
	    key: 'isIEoEdge',
	    value: function isIEoEdge() {
	      if (window.navigator.msSaveBlob) {
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'isMobile',
	    value: function isMobile() {
	      var device = this.isAndroid() || this.isBlackBerry() || this.isiOS() || this.isOpera() || this.isWindows();
	      return !this.isEmpty(device) ? true : false;
	    }
	  }, {
	    key: 'isAndroid',
	    value: function isAndroid() {
	      return navigator.userAgent.match(/Android/i);
	    }
	  }, {
	    key: 'isBlackBerry',
	    value: function isBlackBerry() {
	      return navigator.userAgent.match(/BlackBerry/i);
	    }
	  }, {
	    key: 'isiOS',
	    value: function isiOS() {
	      return navigator.userAgent.match(/iPhone|iPad|iPod/i);
	    }
	  }, {
	    key: 'isOpera',
	    value: function isOpera() {
	      return navigator.userAgent.match(/Opera Mini/i);
	    }
	  }, {
	    key: 'isWindows',
	    value: function isWindows() {
	      return navigator.userAgent.match(/IEMobile/i);
	    }
	  }, {
	    key: 'getFormatoRadioOptions',
	    value: function getFormatoRadioOptions(datos) {
	      return datos.map(function (item) {
	        return {
	          text: item.nombre,
	          field: item.codigo
	        };
	      });
	    }
	  }, {
	    key: 'limpiarEspaciosDobles',
	    value: function limpiarEspaciosDobles(texto) {
	      return texto.replace(/\s+/gi, ' ');
	    }
	  }, {
	    key: 'findArray',
	    value: function findArray(array, item) {
	      for (var i = 0; i < array.length; i++) {
	        if (array[i] === item) {
	          return true;
	        }
	      }
	      return false;
	    }
	  }, {
	    key: 'isValidFormFields',
	    value: function isValidFormFields(form, mensaje) {
	      var forms = this.getInvalidForms(form);
	      if (forms.length) {
	        this.setTouchedForm(form);
	        this.Message.warning(mensaje || "Verifique, corrija y/o llene los campos: <br>- " + forms.join('<br>'));
	        return false;
	      }
	      // if (!this.isValidForm(form)) {
	      //   this.setTouchedForm(form);
	      //   this.Message.warning(mensaje || "Verifique, corrija y/o llene los campos resaltados.");
	      //   return false;
	      // }
	      return true;
	    }
	  }, {
	    key: 'getNombreUnido',
	    value: function getNombreUnido(datos) {
	      var nombre = '';
	      nombre += datos.primer_apellido ? datos.primer_apellido + ' ' : '';
	      nombre += datos.segundo_apellido ? datos.segundo_apellido + ' ' : '';
	      nombre += datos.nombres;
	      return nombre;
	    }
	
	    // Redondear utilizando la libreria Big.js
	
	  }, {
	    key: 'redondear',
	    value: function redondear(numero, decimales) {
	      numero = parseFloat(numero);
	      if (isNaN(numero)) {
	        return;
	      }
	      decimales = parseInt(decimales || this.decimales || 2);
	      return parseFloat(this.Big(numero).toFixed(decimales));
	    }
	
	    // TODO redondeo Funcion utilizada para redondear. reemplazado por existir algunos casos
	
	  }, {
	    key: 'redondear2',
	    value: function redondear2(numero, decimales) {
	      if (typeof numero !== 'number') {
	        return;
	      }
	      decimales = decimales || this.decimales || 2;
	      var ES_NEGATIVO = numero < 0;
	      numero = ES_NEGATIVO ? numero * -1 : numero;
	      var FACTOR_CONVERSION = Math.pow(10, decimales);
	      numero = parseFloat((numero * FACTOR_CONVERSION).toFixed(11));
	      numero = Math.round(numero) / FACTOR_CONVERSION;
	      numero = ES_NEGATIVO ? numero * -1 : numero;
	      return numero;
	    }
	  }, {
	    key: '_operar',
	    value: function _operar(parametros) {
	      var conRedondeo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	      var decimales = arguments[2];
	      var opcion = arguments[3];
	
	      var resultado = opcion === 'add' || opcion === 'minus' ? 0 : 1;
	      for (var i = 0; i < parametros.length; i++) {
	        parametros[i] = typeof parametros[i] === 'number' ? parametros[i] : opcion === 'add' || opcion === 'minus' ? 0 : 1;
	        var valor = this.Big(parametros[i]);
	        resultado = valor[opcion](resultado);
	      }
	      resultado = parseFloat(resultado.valueOf());
	      return conRedondeo ? this.redondear(resultado, decimales) : resultado;
	    }
	  }, {
	    key: 'multiplicar',
	    value: function multiplicar(parametros, redondear, decimales) {
	      return this._operar(parametros, redondear, decimales, 'mul');
	    }
	  }, {
	    key: 'sumar',
	    value: function sumar(parametros, redondear, decimales) {
	      return this._operar(parametros, redondear, decimales, 'add');
	    }
	  }, {
	    key: 'restar',
	    value: function restar(parametro1, parametro2, redondear, decimales) {
	      return this._operar([parametro2, parametro1], redondear, decimales, 'minus');
	    }
	  }, {
	    key: 'dividir',
	    value: function dividir(parametro1, parametro2, redondear, decimales) {
	      if (parametro2 === 0) {
	        return;
	      }
	      return this._operar([parametro2, parametro1], redondear, decimales, 'div');
	    }
	  }, {
	    key: 'valorAbsoluto',
	    value: function valorAbsoluto(valor) {
	      valor = typeof valor === 'number' && !isNaN(valor) ? valor : 0;
	      valor = this.Big(valor);
	      return parseFloat(valor.abs().valueOf());
	    }
	  }, {
	    key: 'esEmpresa',
	    value: function esEmpresa(usuario) {
	      usuario = usuario ? usuario : this.Storage.getUser();
	      return usuario.rol && usuario.rol.nombre === 'EMPRESA';
	    }
	  }, {
	    key: 'getNumeroOrdinal',
	    value: function getNumeroOrdinal(i) {
	      if (i === 1 || i === 3) {
	        return i + 'er';
	      }
	      if (i === 2) {
	        return i + 'do';
	      }
	      if (i === 4 || i === 5 || i === 6) {
	        return i + 'to';
	      }
	      if (i === 7 || i === 10) {
	        return i + 'mo';
	      }
	      if (i === 8) {
	        return i + 'vo';
	      }
	      if (i === 9) {
	        return i + 'no';
	      }
	      return i + 'avo';
	    }
	  }, {
	    key: 'getPorcentaje',
	    value: function getPorcentaje(numero, porcentaje) {
	      // return this.redondear(this.redondear(numero * porcentaje)/100);
	      return parseFloat(this.Big(numero).mul(porcentaje).div(100).toFixed(this.decimales || 2));
	    }
	  }, {
	    key: 'arrayToObject',
	    value: function arrayToObject(array) {
	      return this._.zipObject(array, Array.from(new Array(array.length), function () {
	        return true;
	      }));
	    }
	  }]);
	
	  return UtilService;
	}();
	
	exports.default = UtilService;

/***/ }),
/* 238 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ButtonSpinner = function ButtonSpinner() {
	  _classCallCheck(this, ButtonSpinner);
	
	  this.restrict = 'A';
	  this.transclude = true;
	  this.scope = {
	    spinning: '=buttonSpinner',
	    spinningIcon: '@?',
	    buttonPrepend: '@?',
	    buttonAppend: '@?'
	  };
	  this.template = '<span ng-if="!!buttonPrepend" ng-hide="spinning"><i class="{{ buttonPrepend }}"></i>&nbsp;</span>\n                     <span ng-if="!!buttonPrepend" ng-show="spinning"><i class="{{ !!spinningIcon ? spinningIcon : \'fa fa-spinner fa-spin\' }}"></i>&nbsp;</span>\n                     <ng-transclude></ng-transclude>\n                     <span ng-if="!!buttonAppend" ng-hide="spinning">&nbsp;<i class="{{ buttonAppend }}"></i></span>\n                     <span ng-if="!buttonPrepend" ng-show="spinning">&nbsp;<i class="{{ !!spinningIcon ? spinningIcon : \'fa fa-spinner fa-spin\' }}"></i></span>';
	};
	
	exports.default = ButtonSpinner;

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cCheckbox = __webpack_require__(240);
	
	var _cCheckbox2 = _interopRequireDefault(_cCheckbox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CCheckboxComponent = {
	  bindings: {
	    name: '@',
	    label: '@',
	    ngModel: '=',
	    ngDisabled: '=',
	    ngRequired: '='
	  },
	  require: {
	    form: '^form'
	  },
	  template: '\n    <label class="custom-control custom-checkbox">\n      <input type="checkbox" class="custom-control-input" name="$ctrl.name" ng-model="$ctrl.ngModel" ng-required="$ctrl.ngRequired" ng-req ng-disabled="$ctrl.ngDisabled">\n      <span class="custom-control-indicator"></span>\n      <span class="custom-control-description">{{$ctrl.label}}</span>\n    </label>\n    <div ng-messages="$ctrl.form[$ctrl.name].$error" role="alert">\n      <div ng-message="required"  ng-if="$ctrl.form[$ctrl.name].$touched">\n        <small class="form-text text-muted text-danger font-weight-bold">\n           El campo es requerido.\n        </small>\n      </div>\n    </div>\n      ',
	  controller: _cCheckbox2.default
	};
	
	exports.default = CCheckboxComponent;

/***/ }),
/* 240 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CCheckboxController = function () {
	  function CCheckboxController() {
	    'ngInject';
	
	    _classCallCheck(this, CCheckboxController);
	  }
	
	  _createClass(CCheckboxController, [{
	    key: '$onInit',
	    value: function $onInit() {}
	  }]);
	
	  return CCheckboxController;
	}();
	
	exports.default = CCheckboxController;

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cInput = __webpack_require__(250);
	
	var _cInput2 = _interopRequireDefault(_cInput);
	
	var _cInputMoney = __webpack_require__(246);
	
	var _cInputMoney2 = _interopRequireDefault(_cInputMoney);
	
	var _cSelect = __webpack_require__(259);
	
	var _cSelect2 = _interopRequireDefault(_cSelect);
	
	var _maxlen = __webpack_require__(261);
	
	var _maxlen2 = _interopRequireDefault(_maxlen);
	
	var _allowClearClass = __webpack_require__(258);
	
	var _allowClearClass2 = _interopRequireDefault(_allowClearClass);
	
	var _cTextarea = __webpack_require__(264);
	
	var _cTextarea2 = _interopRequireDefault(_cTextarea);
	
	var _cCheckbox = __webpack_require__(239);
	
	var _cCheckbox2 = _interopRequireDefault(_cCheckbox);
	
	var _cRadiobutton = __webpack_require__(252);
	
	var _cRadiobutton2 = _interopRequireDefault(_cRadiobutton);
	
	var _cDate = __webpack_require__(242);
	
	var _cDate2 = _interopRequireDefault(_cDate);
	
	var _cInputChips = __webpack_require__(244);
	
	var _cInputChips2 = _interopRequireDefault(_cInputChips);
	
	var _cSelectDate = __webpack_require__(254);
	
	var _cSelectDate2 = _interopRequireDefault(_cSelectDate);
	
	var _cSelectDpa = __webpack_require__(256);
	
	var _cSelectDpa2 = _interopRequireDefault(_cSelectDpa);
	
	var _validacion = __webpack_require__(266);
	
	var _validacion2 = _interopRequireDefault(_validacion);
	
	var _buttonSpinner = __webpack_require__(238);
	
	var _buttonSpinner2 = _interopRequireDefault(_buttonSpinner);
	
	var _validarFormulario = __webpack_require__(267);
	
	var _validarFormulario2 = _interopRequireDefault(_validarFormulario);
	
	var _cInputNumeric = __webpack_require__(248);
	
	var _cInputNumeric2 = _interopRequireDefault(_cInputNumeric);
	
	var _cTable = __webpack_require__(262);
	
	var _cTable2 = _interopRequireDefault(_cTable);
	
	__webpack_require__(156);
	
	var _angularUiMask = __webpack_require__(134);
	
	var _angularUiMask2 = _interopRequireDefault(_angularUiMask);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UiComponentsModule = angular.module('app.ccomponents', [_angularUiMask2.default
	// CDataTable
	]).component('cInput', _cInput2.default).component('cInputMoney', _cInputMoney2.default).component('cSelect', _cSelect2.default).directive('maxlen', function () {
	  return new _maxlen2.default();
	}).directive('allowClearClass', function () {
	  return new _allowClearClass2.default();
	}).component('cCheckbox', _cCheckbox2.default).component('cRadiobutton', _cRadiobutton2.default).component('cTextarea', _cTextarea2.default).component('cDate', _cDate2.default).component('cInputChips', _cInputChips2.default).component('cSelectDate', _cSelectDate2.default).component('cSelectDpa', _cSelectDpa2.default).component('cTable', _cTable2.default).component('cInputNumeric', _cInputNumeric2.default).service('ValidacionForms', _validacion2.default).directive('buttonSpinner', function () {
	  return new _buttonSpinner2.default();
	}).directive('validarFormulario', function () {
	  return new _validarFormulario2.default();
	}).name;
	
	// libreria mascara para el date
	exports.default = UiComponentsModule;

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cDate = __webpack_require__(243);
	
	var _cDate2 = _interopRequireDefault(_cDate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CDateComponent = {
	  bindings: {
	    name: '@',
	    label: '@',
	    ngModel: '=',
	    ngDisabled: '=',
	    ngRequired: '=',
	    minDate: '=?',
	    mensajeMinDate: '@?',
	    maxDate: '=?',
	    mensajeMaxDate: '@?',
	    ngChange: '&',
	    initDate: '<',
	    minDateKey: '@',
	    maxDateKey: '@'
	  },
	  require: {
	    form: '^form'
	  },
	
	  template: '\n      <div class="md-form-group">\n        <label class="md-control-label" ng-class="{\'requerido\':$ctrl.ngRequired}" style="top:-1rem;font-size:11px;">{{$ctrl.label}}</label>\n        <div class="input-group">\n          <input type="text"\n                 id="{{$ctrl.name}}"\n                 name="{{$ctrl.name}}"\n                 class=""\n                 ui-mask="99/99/9999"\n                 maxlength="10"\n                 ng-disabled="$ctrl.ngDisabled"\n                 ng-required="$ctrl.ngRequired"\n                 model-view-value="true"\n                 ng-model="$ctrl.date"\n                 init-date="$ctrl.initDate"\n                 ng-model-options="{ getterSetter: true }"\n                 uib-datepicker-popup="dd/MM/yyyy"\n                 is-open="$ctrl.opened"\n                 datepicker-options="$ctrl.options"\n                 ng-click="$ctrl.open($event)"\n                 ng-change="$ctrl.actualizarValor(); $ctrl.ngChange({data:$ctrl.date})"\n                 ui-validate="{minDate: \'$ctrl.verifyMinDate($value)\', maxDate: \'$ctrl.verifyMaxDate($value)\'}"\n                 min-date="$ctrl.minDate"\n                 max-date="$ctrl.maxDate"\n                 >\n          <button type="button" class="btn btn-link p-0 m-0" ng-click="$ctrl.open($event)"><i class="fa fa-calendar"></i></button>\n        </div>\n        <i class="md-bar" ng-class="{\'error\':$ctrl.form[$ctrl.name].$invalid && $ctrl.form[$ctrl.name].$touched}"></i>\n        <div ng-messages="$ctrl.form[$ctrl.name].$error" role="alert" ap-error ng-if="$ctrl.form[$ctrl.name].$touched">\n          <div ng-message="required"> El campo es requerido. </div>\n          <div ng-message="date"> Introduzca una fecha v\xE1lida (dd/mm/aaaa). </div>\n          <div ng-message="minDate" ng-if="!$ctrl.mensajeMinDate"> La fecha debe ser mayor o igual a {{$ctrl.options.minDate | date:\'dd/MM/yyyy\' }}. </div>\n          <div ng-message="minDate" ng-if="$ctrl.mensajeMinDate"> {{$ctrl.mensajeMinDate}} </div>\n          <div ng-message="maxDate" ng-if="!$ctrl.mensajeMaxDate"> La fecha debe ser menor o igual a {{$ctrl.options.maxDate | date:\'dd/MM/yyyy\'}}. </div>\n          <div ng-message="maxDate" ng-if="$ctrl.mensajeMaxDate"> {{$ctrl.mensajeMaxDate}} </div>\n        </div>\n      </div>',
	  controller: _cDate2.default
	};
	
	exports.default = CDateComponent;

/***/ }),
/* 243 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CDateController = function () {
	  CDateController.$inject = ["Datetime", "$scope", "_"];
	  function CDateController(Datetime, $scope, _) {
	    'ngInject';
	
	    _classCallCheck(this, CDateController);
	
	    this.options = {};
	    this.Datetime = Datetime;
	    this._ = _;
	    this.$scope = $scope;
	  }
	
	  _createClass(CDateController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.options = {
	        maxDate: this.maxDate,
	        minDate: this.minDate,
	        formatYear: 'yyyy',
	        showWeeks: false
	      };
	    }
	  }, {
	    key: '$onChanges',
	    value: function $onChanges() {
	      var _this = this;
	
	      this.$scope.$watch('$ctrl.ngModel', function () {
	        if (_this._.isEmpty(_this.ngModel)) {
	          return;
	        }
	        _this.inicializarModel();
	      });
	    }
	  }, {
	    key: 'inicializarModel',
	    value: function inicializarModel() {
	      this.verificarFormatoModel();
	      this.date = this.Datetime.toDate(angular.copy(this.ngModel));
	      this.actualizarValor();
	    }
	  }, {
	    key: 'verificarFormatoModel',
	    value: function verificarFormatoModel() {
	      if (this.ngModel.length === 10) {
	        var valor = this.ngModel.split('-');
	        if (valor.length === 3 && valor[0].length === 2 && valor[1].length === 2 && valor[2].length === 4) {
	          this.ngModel = valor[2] + '-' + valor[1] + '-' + valor[0] + 'T04:00:00.000Z';
	        }
	      }
	    }
	  }, {
	    key: 'actualizarValor',
	    value: function actualizarValor() {
	      this.ngModel = this.formatearFecha(angular.copy(this.date));
	    }
	  }, {
	    key: 'formatearFecha',
	    value: function formatearFecha() {
	      return this.Datetime.format(this.date, 'dd-MM-YYYY');
	    }
	  }, {
	    key: 'open',
	    value: function open() {
	      if (!this.options.minDate && this.minDate) this.options.minDate = this.minDate;
	      if (!this.options.maxDate && this.maxDate) this.options.maxDate = this.maxDate;
	      this.opened = !this.opened;
	      if (this.options) {
	        if (this.maxDateKey) {
	          var MAX_DATE = angular.element(document.getElementById(this.maxDateKey)).val();
	          if (MAX_DATE) {
	            this.options.maxDate = this.Datetime.convert(MAX_DATE);
	          }
	        }
	        if (this.minDateKey) {
	          var MIN_DATE = angular.element(document.getElementById(this.minDateKey)).val();
	          if (MIN_DATE) {
	            this.options.minDate = this.Datetime.convert(MIN_DATE);
	          }
	        }
	      }
	    }
	  }, {
	    key: 'verifyMaxDate',
	    value: function verifyMaxDate(value) {
	      if (!angular.isUndefined(this.options.maxDate)) {
	        var dateSelected = new Date(value),
	            maxDate = new Date(this.options.maxDate.getFullYear(), this.options.maxDate.getMonth(), this.options.maxDate.getDate() + 1);
	        return dateSelected < maxDate;
	      }
	      return true;
	    }
	  }, {
	    key: 'verifyMinDate',
	    value: function verifyMinDate(value) {
	      if (!angular.isUndefined(this.options.minDate)) {
	        var dateSelected = new Date(value),
	            minDate = new Date(this.options.minDate.getFullYear(), this.options.minDate.getMonth(), this.options.minDate.getDate() - 1);
	        return dateSelected > minDate;
	      }
	      return true;
	    }
	  }]);
	
	  return CDateController;
	}();
	
	exports.default = CDateController;

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cInputChips = __webpack_require__(245);
	
	var _cInputChips2 = _interopRequireDefault(_cInputChips);
	
	__webpack_require__(157);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CInputChipsComponent = {
	  bindings: {
	    name: '@',
	    label: '@',
	    ngModel: '=',
	    ngRequired: '=',
	    ngDisabled: '=',
	    ngValidation: '@',
	    placeholder: '@',
	    maxTags: '@',
	    minLength: '@',
	    maxLength: '@'
	  },
	  require: {
	    form: '^form'
	  },
	  template: '\n     <div class="md-form-group">\n      <tag-me\n        name="{{$ctrl.name}}"\n        type="input"\n        selected="$ctrl.ngModel"\n        placeholder="{{$ctrl.placeholder}}"\n        display-field="name"\n        typehead="false"\n        allow-outside-data-set="true"\n        same-input="false"\n        max="$ctrl.maxTags"\n        max-length="{{maxLength}}"\n        min-length="{{minLength}}"\n        validation="$ctrl.validation"\n        required="$ctrl.ngRequired"\n        theme="material">\n      </tag-me>\n        <label class="md-control-label" ng-class="{\'requerido\':$ctrl.ngRequired}" style="top:-1rem;font-size:11px;">{{$ctrl.label}}</label>\n       <div class="row">\n        <div class="col-md-6">\n          <div ng-messages="$ctrl.form[$ctrl.name].$error" role="alert">\n        <div ng-message="required"  ng-if="$ctrl.form[$ctrl.name].$touched">\n          <small class="form-text text-muted text-danger font-weight-bold">\n             El campo es requerido.\n          </small>\n        </div>\n         <div ng-message="pattern">\n           <small class="form-text text-muted text-danger font-weight-bold font-weight-bold">\n             {{$ctrl.messageErrorPattern}}\n            </small>\n        </div>\n         <div ng-message="minlength">\n            <small class="form-text text-muted text-danger font-weight-bold font-weight-bold">\n             El contenido es muy corto.\n            </small>\n        </div>\n         <div ng-message="maxlength">\n            <small class="form-text text-muted text-danger font-weight-bold font-weight-bold">\n             El contenido es muy largo.\n            </small>\n        </div>\n      </div>\n        </div>\n        <div class="col-md-6">\n          <div>\n           <small class="form-text text-muted pull-right">\n            N\xFAmero m\xE1ximo de elementos: {{$ctrl.maxTags}}\n            </small>\n        </div>\n        </div>\n       </div>\n     </div>\n  ',
	  controller: _cInputChips2.default
	};
	
	exports.default = CInputChipsComponent;

/***/ }),
/* 245 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CInputChipsController = function () {
	  function CInputChipsController() {
	    'ngInject';
	
	    _classCallCheck(this, CInputChipsController);
	
	    this.mensajeMaximo = false;
	  }
	
	  _createClass(CInputChipsController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var tipoValidacion = this.ngValidation;
	      switch (tipoValidacion) {
	        case 'correo':
	          this.messageErrorPattern = 'Introduzca una dirección de correo válido.';
	          this.validation = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
	          break;
	        case 'celular':
	          this.validation = /(6[0-9]{7}|7[0-9]{7})/;
	          this.messageErrorPattern = 'Introduzca un número de celular válido';
	          break;
	        case 'telefono':
	          this.validation = /^([0-9 +()-]{5,15})$/;
	          this.messageErrorPattern = 'Introduzca un número de teléfono o celular válido';
	          break;
	        default:
	          this.validation = null;
	      }
	      this.maxTags = angular.isUndefined(this.maxTags) ? 0 : this.maxTags;
	    }
	  }]);
	
	  return CInputChipsController;
	}();
	
	exports.default = CInputChipsController;

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cInputMoney = __webpack_require__(247);
	
	var _cInputMoney2 = _interopRequireDefault(_cInputMoney);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CInputMoneyComponent = {
	  bindings: {
	    name: '@',
	    label: '@',
	    ngModel: '=',
	    ngDisabled: '=',
	    ngRequired: '=',
	    ngBlur: '&?',
	    ngChange: '&?',
	    placeholder: '@?',
	    ngValidation: '@',
	    ngMinvalue: '@',
	    ngMaxvalue: '@',
	    ngDecimals: '@'
	  },
	  require: {
	    form: '^form'
	  },
	  template: '\n     <div class="md-form-group">\n      <label class="md-control-label" ng-class="{\'requerido\':$ctrl.ngRequired}" style="top:-1rem;font-size:11px;">{{$ctrl.label}}</label>\n      <div class="input-group">\n        <input ng-required="$ctrl.ngRequired"\n               ng-disabled="$ctrl.ngDisabled"\n               ng-readonly="$ctrl.ngReadonly"\n               ng-model="$ctrl.ngModel"\n               ng-maxlength="$ctrl.ngMaxlength"\n               ng-placeholder="$ctrl.placeholder"\n               ng-blur="$ctrl.ngBlur()"\n               ng-change="$ctrl.ngChange()"\n               name="{{$ctrl.name}}"\n               type="text"\n               numerico\n               min="$ctrl.ngMinvalue"\n               max="$ctrl.ngMaxvalue"\n               decimals="$ctrl.ngDecimals"\n               >\n        <button type="button" class="btn btn-link p-0 m-0"><i class="fa fa-money" aria-hidden="true"></i></button>\n      </div>\n      <i class="md-bar" ng-class="{\'error\':$ctrl.form[$ctrl.name].$invalid && $ctrl.form[$ctrl.name].$touched}"></i>\n      <div ng-messages="$ctrl.form[$ctrl.name].$error" role="alert" ap-error ng-if="$ctrl.form[$ctrl.name].$touched">\n        <div ng-message="required"> El campo es requerido. </div>\n      </div>\n    </div>',
	  controller: _cInputMoney2.default
	
	};
	
	exports.default = CInputMoneyComponent;

/***/ }),
/* 247 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CInputMoneyController = function () {
	  function CInputMoneyController() {
	    'ngInject';
	
	    _classCallCheck(this, CInputMoneyController);
	  }
	
	  _createClass(CInputMoneyController, [{
	    key: '$onInit',
	    value: function $onInit() {}
	  }]);
	
	  return CInputMoneyController;
	}();
	
	exports.default = CInputMoneyController;

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cInputNumeric = __webpack_require__(249);
	
	var _cInputNumeric2 = _interopRequireDefault(_cInputNumeric);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CInputNumericComponent = {
	  bindings: {
	    name: '@',
	    label: '@',
	    ngModel: '=',
	    ngDisabled: '=?',
	    ngRequired: '=?',
	    ngBlur: '&?',
	    ngChange: '&?',
	    placeholder: '@?',
	    ngMinvalue: '@?',
	    ngMaxvalue: '@?',
	    ngDecimals: '@?',
	    ngFormatting: '<?',
	    class: '@?',
	    ngDirectives: '@?',
	    ngDecimalsDinamic: '<',
	    ngMaxDecimals: '@?',
	    ngNotNumber: '<?',
	    ngNumberDefault: '<?'
	  },
	  require: {
	    form: '^form'
	  },
	  template: '\n     <div class="md-form-group" md-event-label>\n      <input name="{{$ctrl.name}}"\n             id="{{$ctrl.name}}"\n             type="text"\n             ng-model="$ctrl.ngModel"\n             ng-required="$ctrl.ngRequired"\n             ng-disabled="$ctrl.ngDisabled"\n             ng-readonly="$ctrl.ngReadonly"\n             ng-maxlength="$ctrl.ngMaxlength"\n             ng-placeholder="$ctrl.placeholder"\n             ng-blur="$ctrl.ngBlur()"\n             ng-change="$ctrl.ngChange()"\n             numerico\n             min="$ctrl.ngMinvalue"\n             max="$ctrl.ngMaxvalue"\n             decimals="$ctrl.ngDecimals"\n             decimals-dinamic="$ctrl.ngDecimalsDinamic"\n             maxdecimals="$ctrl.ngMaxDecimals"\n             formatting="$ctrl.formatting"\n             class="{{$ctrl.class}}"\n             not-number="$ctrl.ngNotNumber"\n             number-default="$ctrl.ngNumberDefault"\n        >\n        <label for="{{$ctrl.name}}" title="{{$ctrl.title}}" class="md-control-label" ng-class="{\'requerido\':$ctrl.ngRequired}">{{ $ctrl.label }}</label>\n        <i class="md-bar" ng-class="{\'error\':$ctrl.form[$ctrl.name].$invalid && $ctrl.form[$ctrl.name].$touched}"></i>\n      <div ng-messages="$ctrl.form[$ctrl.name].$error" role="alert" ap-error ng-if="$ctrl.form[$ctrl.name].$touched">\n        <div ng-message="required"> El campo es requerido. </div>\n      </div>\n    </div>',
	  controller: _cInputNumeric2.default
	
	};
	
	exports.default = CInputNumericComponent;

/***/ }),
/* 249 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CInputNumericController = function () {
	  CInputNumericController.$inject = ["Util", "$scope", "$compile", "$element"];
	  function CInputNumericController(Util, $scope, $compile, $element) {
	    'ngInject';
	
	    _classCallCheck(this, CInputNumericController);
	
	    this.Util = Util;
	    this.$scope = $scope;
	    this.$compile = $compile;
	    this.$element = $element;
	  }
	
	  _createClass(CInputNumericController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.verificarAtributosAdicionales();
	      if (this.Util.isEmpty(this.ngModel)) {
	        this.ngModel = undefined;
	      }
	    }
	  }, {
	    key: 'verificarAtributosAdicionales',
	    value: function verificarAtributosAdicionales() {
	      if (this.ngDirectives) {
	        var directivas = this.Util.limpiarEspaciosDobles(this.ngDirectives).split(' ');
	        for (var i = 0; i < directivas.length; i++) {
	          this.$compile(this.$element.find('input').attr(directivas[i], ''))(this.$scope);
	        }
	      }
	    }
	  }]);
	
	  return CInputNumericController;
	}();
	
	exports.default = CInputNumericController;

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cInput = __webpack_require__(251);
	
	var _cInput2 = _interopRequireDefault(_cInput);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CInputComponent = {
	  bindings: {
	    name: '@',
	    label: '@',
	    title: '@?',
	    type: '@?',
	    ngModel: '=',
	    ngDisabled: '=',
	    ngRequired: '=',
	    ngValidation: '@',
	    cUiValidate: '@?',
	    cUiValidateWatch: '@?',
	    ngMinlength: '@?',
	    ngMaxlength: '@?',
	    maxlength: '@?',
	    class: '@?',
	    ngDirectives: '@?',
	    ngBlur: '&?'
	  },
	  require: {
	    form: '^form'
	  },
	  template: '\n     <div class="md-form-group" md-event-label>\n        <input name="{{$ctrl.name}}" id="{{$ctrl.name}}"\n               ng-required="$ctrl.ngRequired"\n               ng-disabled="$ctrl.ngDisabled"\n               ng-readonly="$ctrl.ngReadonly"\n               ng-model="$ctrl.ngModel"\n               ng-pattern="$ctrl.validation"\n               ng-minlength="$ctrl.ngMinlength"\n               ng-maxlength="$ctrl.ngMaxlength"\n               maxlength="{{$ctrl.maxlength}}"\n               ui-validate ="{{$ctrl.cUiValidate}}"\n               ui-validate-watch ="{{$ctrl.cUiValidateWatch}}"\n               type="{{ $ctrl.type || \'text\' }}"\n               class="{{$ctrl.class}}"\n               ng-blur="$ctrl.ngBlur()"\n               autocapitalize="off"\n               autocomplete="new-password"\n               >\n        <label for="{{$ctrl.name}}" title="{{$ctrl.title}}" class="md-control-label" ng-class="{\'requerido\':$ctrl.ngRequired}">{{ $ctrl.label }}</label>\n        <i class="md-bar" ng-class="{\'error\':$ctrl.form[$ctrl.name].$invalid && $ctrl.form[$ctrl.name].$touched}"></i>\n        <div ng-messages="$ctrl.form[$ctrl.name].$error" role="alert" ap-error ng-if="$ctrl.form[$ctrl.name].$touched">\n            <div ng-message="required"> El campo es requerido. </div>\n            <div ng-message="pattern"> {{$ctrl.messageErrorPattern}} </div>\n            <div ng-message="minlength"> El contenido es muy corto. </div>\n            <div ng-message="maxlength"> El contenido es muy largo. </div>\n            <div ng-message="parse"> {{$ctrl.messageErrorParse}} </div>\n            <div ng-message="contrasena"> Las contrase\xF1as son distintas. </div>\n        </div>\n    </div>',
	  controller: _cInput2.default
	};
	
	exports.default = CInputComponent;

/***/ }),
/* 251 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CInputController = function () {
	  CInputController.$inject = ["$scope", "$compile", "$element", "Util"];
	  function CInputController($scope, $compile, $element, Util) {
	    'ngInject';
	
	    _classCallCheck(this, CInputController);
	
	    this.$scope = $scope;
	    this.$compile = $compile;
	    this.$element = $element;
	    this.Util = Util;
	  }
	
	  _createClass(CInputController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.verificarAtributosAdicionales();
	      this.validation = '';
	      var tipoValidacion = this.ngValidation;
	
	      switch (tipoValidacion) {
	        case 'correo':
	          this.messageErrorPattern = 'Introduzca una dirección de correo válido.';
	          this.validation = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
	          this.mayuscula = '';
	          break;
	        case 'celular':
	          this.validation = /(6[0-9]{7}|7[0-9]{7})/;
	          this.messageErrorPattern = 'Introduzca un número de celular válido';
	          break;
	        case 'telefono':
	          this.validation = /^(\+((\d{3}|\d{2}))( |-)\d{5,15}|(\d{7})|(\d{8}))$/;
	          this.messageErrorPattern = 'Introduzca un número de teléfono válido';
	          break;
	        case 'url':
	          this.validation = /^(http\:\/\/|https\:\/\/)?([a-z0-9][a-z0-9\-]*\.)+[a-z0-9][a-z0-9\-]*$/i;
	          this.messageErrorPattern = 'Introduzca una dirección web válida.';
	          this.mayuscula = '';
	          break;
	        case 'numerico':
	          this.validation = /^[0-9]+$/;
	          this.messageErrorPattern = 'Introduzca sólo números';
	          break;
	        case 'monetario':
	          this.validation = /^[0-9]|[0-9]+(\.[0-9]{1,2})+$/;
	          this.messageErrorPattern = 'Introduzca sólo números';
	          break;
	        case 'texto':
	          this.validation = /^[a-záéíóúñA-ZÁÉÍÓÚÑ\s]+$/;
	          this.messageErrorPattern = 'Introduzca solo texto';
	          break;
	        case 'texto-numerico':
	          this.validation = /^[0-9a-záéíóúñA-ZÁÉÍÓÚÑ."'&@\-\s]+$/;
	          this.messageErrorPattern = 'Introduzca solo texto o numeros y caracteres permitidos';
	          break;
	        case 'texto-numerico-minusculas':
	          this.validation = /^[0-9a-záéíóúñA-ZÁÉÍÓÚÑ."'&@\-\s]+$/;
	          this.messageErrorPattern = 'Introduzca solo texto o numeros y caracteres permitidos';
	          this.mayuscula = '';
	          break;
	        case 'alfa-numerico':
	          this.validation = /^[a-zñA-ZÑ0-9-".'\s]/;
	          this.messageErrorPattern = 'Introduzca solo texto, números o caracteres.';
	          break;
	        default:
	          this.validation = null;
	      }
	    }
	  }, {
	    key: 'verificarAtributosAdicionales',
	    value: function verificarAtributosAdicionales() {
	      if (this.ngDirectives) {
	        var directivas = this.Util.limpiarEspaciosDobles(this.ngDirectives).split(' ');
	        for (var i = 0; i < directivas.length; i++) {
	          this.$compile(this.$element.find('input').attr(directivas[i], directivas[i]))(this.$scope);
	        }
	      }
	    }
	  }]);
	
	  return CInputController;
	}();
	
	exports.default = CInputController;

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cRadiobutton = __webpack_require__(253);
	
	var _cRadiobutton2 = _interopRequireDefault(_cRadiobutton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CRadioButtonComponent = {
	  bindings: {
	    name: '@',
	    label: '@',
	    ngModel: '=',
	    ngDisabled: '<',
	    ngRequired: '<',
	    options: '<',
	    horizontal: '<',
	    ngChange: '&?',
	    field: '@',
	    value: '@?'
	  },
	  require: {
	    form: '^form'
	  },
	  template: '\n  <div class="md-form-group">\n    <div ng-class="{\'row\':$ctrl.horizontal}">\n      <div ng-repeat="option in $ctrl.options" class="ml-3">\n        <label class="custom-control custom-radio">\n          <input type="radio" name="{{$ctrl.name}}" ng-model="$ctrl.ngModel"\n                 value="{{option[$ctrl.value] || option.codigo}}" class="custom-control-input"\n                 ng-change="$ctrl.controlCambioValor(option[$ctrl.value] || option.codigo)"\n                 ng-required="$ctrl.ngRequired" ng-disabled="$ctrl.ngDisabled">\n          <span class="custom-control-indicator"></span>\n          <span class="custom-control-description">{{option[$ctrl.field]}}</span>\n        </label>\n      </div>\n    </div>\n    <label for="{{$ctrl.name}}" title="{{$ctrl.title}}" class="md-label-radio" ng-class="{\'requerido\':$ctrl.ngRequired, \'{{$ctrl.classs}}\' : $ctrl.classs}">\n    {{$ctrl.label}}\n    </label>\n    <div ng-messages="$ctrl.form[$ctrl.name].$error" role="alert" ap-error ng-if="$ctrl.form[$ctrl.name].$touched">\n      <div ng-message="required"> El campo es requerido. </div>\n    </div>\n  </div>\n  ',
	  controller: _cRadiobutton2.default
	};
	
	exports.default = CRadioButtonComponent;

/***/ }),
/* 253 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CRadioButtonController = function () {
	  function CRadioButtonController() {
	    'ngInject';
	
	    _classCallCheck(this, CRadioButtonController);
	  }
	
	  _createClass(CRadioButtonController, [{
	    key: '$onInit',
	    value: function $onInit() {}
	  }, {
	    key: 'controlCambioValor',
	    value: function controlCambioValor(valor) {
	      if (this.ngChange && typeof this.ngChange === 'function') {
	        this.ngChange({ data: valor });
	      }
	    }
	  }]);
	
	  return CRadioButtonController;
	}();
	
	exports.default = CRadioButtonController;

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _cSelectDate = __webpack_require__(255);
	
	var _cSelectDate2 = _interopRequireDefault(_cSelectDate);
	
	var _cSelectDate3 = __webpack_require__(577);
	
	var _cSelectDate4 = _interopRequireDefault(_cSelectDate3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CSelectDateComponent = {
	    template: _cSelectDate4.default,
	    controller: _cSelectDate2.default,
	    bindings: {
	        model: '=',
	        name: '@',
	        label: '@',
	        title: '@?',
	        options: '=',
	        field: '@',
	        isDisabled: '=?',
	        ngRequired: '=?',
	        onChange: '&',
	        minDate: '=?',
	        maxDate: '=?',
	        abreviacion: '@'
	    },
	    require: {
	        form: '^form'
	    }
	};
	
	exports.default = CSelectDateComponent;

/***/ }),
/* 255 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CSelectDateController = function () {
	  CSelectDateController.$inject = ["$scope", "$timeout", "Util"];
	  function CSelectDateController($scope, $timeout, Util) {
	    'ngInject';
	
	    _classCallCheck(this, CSelectDateController);
	
	    if (angular.isUndefined(this.isDisabled)) {
	      this.isDisabled = false;
	    }
	    if (angular.isUndefined(this.ngRequired)) this.ngRequired = false;
	
	    this.date = new Date();
	    this.listMonths = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
	    this.numDays = { '1': 31, '2': 28, '3': 31, '4': 30, '5': 31, '6': 30, '7': 31, '8': 31, '9': 30, '10': 31, '11': 30, '12': 31 };
	    this.$scope = $scope;
	    this.$timeout = $timeout;
	    this.Util = Util;
	  }
	
	  _createClass(CSelectDateController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.$scope.$on('resetForm', function () {
	        _this.day = '';
	        _this.month = '';
	        _this.year = '';
	      });
	      if (angular.isUndefined(this.abreviacion)) this.abreviacion = this.label;
	      this.years = this.initYears();
	      this.months = this.initMonths();
	      this.days = this.initDays();
	      if (this.maxDate) {
	        this.$scope.$watch(function () {
	          return _this.maxDate;
	        }, function () {
	          if (_this.model) {
	            _this.years = _this.initYears();
	            if (_this.year && _this.maxDate && _this.year.value > _this.maxDate.getFullYear()) {
	              _this.year = _this.years[0];
	            }
	          }
	        });
	      }
	      if (this.minDate) {
	        this.$scope.$watch(function () {
	          return _this.minDate;
	        }, function () {
	          if (_this.model) {
	            _this.years = _this.initYears();
	            if (_this.year && _this.minDate && _this.year.value < _this.minDate.getFullYear()) {
	              _this.year = _this.years[_this.years.length - 1];
	            }
	          }
	        });
	      }
	    }
	  }, {
	    key: '_verifMinMonth',
	    value: function _verifMinMonth() {
	      if (!this.minDate) {
	        this.minDate = new Date();
	        this.minDate.setFullYear(this.minDate.getFullYear() - 100);
	      }
	      return this.minDate && this.year && this.minDate.getFullYear() == this.year.value && this.month && this.minDate.getMonth() + 1 == this.month.value;
	    }
	  }, {
	    key: '_verifMaxMonth',
	    value: function _verifMaxMonth() {
	      if (!this.maxDate) {
	        this.maxDate = new Date();
	      }
	      return this.maxDate && this.year && this.maxDate.getFullYear() == this.year.value && this.month && this.maxDate.getMonth() + 1 == this.month.value;
	    }
	  }, {
	    key: 'initDays',
	    value: function initDays(lastDay) {
	      var _this2 = this;
	
	      var days = [];
	      var last = lastDay || 31;
	      for (var i = 1; i <= last; i++) {
	        days.push({
	          disabled: this._verifMinMonth() && i < this.maxDate.getDate() || this._verifMaxMonth() && i > this.maxDate.getDate(),
	          text: i,
	          value: i
	        });
	      }
	      if (this.day) {
	        this.day = days.find(function (d) {
	          return d.value == _this2.day.value;
	        });
	      }
	      return days;
	    }
	  }, {
	    key: '_verifMinYear',
	    value: function _verifMinYear() {
	      if (!this.minDate) {
	        this.minDate = new Date();
	        this.minDate.setFullYear(this.minDate.getFullYear() - 100);
	      }
	      return this.minDate && this.year && this.minDate.getFullYear() == this.year.value;
	    }
	  }, {
	    key: '_verifMaxYear',
	    value: function _verifMaxYear() {
	      if (!this.maxDate) {
	        this.maxDate = new Date();
	      }
	      return this.maxDate && this.year && this.maxDate.getFullYear() == this.year.value;
	    }
	  }, {
	    key: 'initMonths',
	    value: function initMonths() {
	      var _this3 = this;
	
	      var months = [];
	      for (var i = 0; i < 12; i++) {
	        months.push({
	          disabled: this._verifMinYear() && i < this.minDate.getMonth() || this._verifMaxYear() && i > this.maxDate.getMonth(),
	          text: this.listMonths[i],
	          value: i + 1
	        });
	      }
	      if (this.month) {
	        this.month = months.find(function (m) {
	          return m.value == _this3.month.value;
	        });
	      }
	      return months;
	    }
	  }, {
	    key: 'initYears',
	    value: function initYears() {
	      var maxYear = this.date.getFullYear(),
	          minYear = this.date.getFullYear() - 100,
	          years = [];
	      if (this.maxDate && this.maxDate.getFullYear()) {
	        maxYear = this.maxDate.getFullYear();
	      }
	      if (this.minDate && this.minDate.getFullYear()) {
	        minYear = this.minDate.getFullYear();
	      }
	
	      for (var i = maxYear; i >= minYear; i--) {
	        years.push({
	          text: i,
	          value: i
	        });
	      }
	      return years;
	    }
	  }, {
	    key: 'setDate',
	    value: function setDate() {
	      var _this4 = this;
	
	      this.$timeout(function () {
	        if (_this4.onChange && angular.isFunction(_this4.onChange)) {
	          _this4.onChange();
	        }
	
	        var day = _this4.verificarValor(_this4.day),
	            month = _this4.verificarValor(_this4.month),
	            year = _this4.verificarValor(_this4.year);
	
	        if (_this4._verifMaxYear() && month > _this4.maxDate.getMonth() + 1) {
	          _this4.month = _this4.months[_this4.maxDate.getMonth()];
	          month = _this4.verificarValor(_this4.month);
	        }
	        if (_this4._verifMinYear() && month < _this4.minDate.getMonth() + 1) {
	          _this4.month = _this4.months[_this4.minDate.getMonth()];
	          month = _this4.verificarValor(_this4.month);
	        }
	
	        // Verificar año biciesto
	        var nDays;
	        nDays = _this4.numDays[month];
	
	        if (nDays == 28 && year % 4 == 0) {
	          ++nDays;
	        }
	        if (day > nDays) {
	          _this4.day = _this4.days[nDays - 1];
	          day = _this4.verificarValor(_this4.day);
	        }
	        if (_this4._verifMaxMonth() && day > _this4.maxDate.getDate()) {
	          _this4.day = _this4.days[_this4.maxDate.getDate() - 1];
	          day = _this4.verificarValor(_this4.day);
	        }
	        if (_this4._verifMinMonth() && day < _this4.minDate.getDate()) {
	          _this4.day = _this4.days[_this4.minDate.getDate() - 1];
	          day = _this4.verificarValor(_this4.day);
	        }
	        if (day !== '00' && month !== '00' && year !== '00') {
	          _this4.model = new Date(month + '/' + day + '/' + year);
	        } else {
	          _this4.model = null;
	        }
	
	        _this4.months = _this4.initMonths();
	        _this4.days = _this4.initDays(nDays);
	      }, 100);
	    }
	  }, {
	    key: 'verificarValor',
	    value: function verificarValor(item) {
	      if (!angular.isUndefined(item) && item !== null) {
	        return item.value;
	      } else {
	        return '00';
	      }
	    }
	  }, {
	    key: 'inputDate',
	    value: function inputDate(data, lista, model) {
	      if (!data) {
	        return;
	      }
	      for (var i = 0; i < lista.length; i++) {
	        if (String(lista[i].text).toLowerCase() === data.toLowerCase()) {
	          this[model] = lista[i];
	          this.setDate();
	          return;
	        }
	      }
	    }
	  }]);
	
	  return CSelectDateController;
	}();
	
	exports.default = CSelectDateController;

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cSelectDpa = __webpack_require__(257);
	
	var _cSelectDpa2 = _interopRequireDefault(_cSelectDpa);
	
	var _cSelectDpa3 = __webpack_require__(578);
	
	var _cSelectDpa4 = _interopRequireDefault(_cSelectDpa3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CSelectDPAComponent = {
	  bindings: {
	    ngModel: '=',
	    ngRequired: '<?',
	    ngDisabled: '<?',
	    departamentos: '=?',
	    provincias: '=?',
	    municipios: '=?',
	    selectMunicipio: '&?',
	    horizontal: '=?'
	  },
	  require: {
	    form: '^form'
	  },
	  template: _cSelectDpa4.default,
	  controller: _cSelectDpa2.default
	};
	
	exports.default = CSelectDPAComponent;

/***/ }),
/* 257 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CSelectDPAController = function () {
	  CSelectDPAController.$inject = ["DataService", "Util"];
	  function CSelectDPAController(DataService, Util) {
	    'ngInject';
	
	    _classCallCheck(this, CSelectDPAController);
	
	    this.DataService = DataService;
	    this.Util = Util;
	    this.departamentos = [];
	    this.provincias = [];
	    this.municipios = [];
	  }
	
	  _createClass(CSelectDPAController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.prepararListasDeVisualizacion();
	      this.getDatosDpa();
	    }
	  }, {
	    key: 'getDatosDpa',
	    value: function getDatosDpa() {
	      if (!this.ngDisabled) {
	        this.getDepartamentos();
	        if (!this.Util.isEmpty(this.ngModel)) {
	          this.getProvincias(this.ngModel.departamento, false);
	          this.getMunicipios(this.ngModel.provincia, false);
	        }
	      }
	    }
	
	    /**
	    * prepararListasDeVisualizacion - En caso de que se los datos solo serán visualizados,
	    * no se obtiene datos de provincias y municipios, entonces para los mobiles se prepara
	    * las listas que contienen los datos del modelo
	    */
	
	  }, {
	    key: 'prepararListasDeVisualizacion',
	    value: function prepararListasDeVisualizacion() {
	      if (!this.Util.isEmpty(this.ngModel) && this.ngDisabled) {
	        this.provincias.push(this.ngModel.provincia);
	        this.municipios.push(this.ngModel.municipio);
	      }
	    }
	  }, {
	    key: '$doCheck',
	    value: function $doCheck() {
	      if (this.ngModel) {
	        this.ngModel.departamento = this.getElementoDeLista(this.ngModel.departamento, this.departamentos);
	        this.ngModel.provincia = this.getElementoDeLista(this.ngModel.provincia, this.provincias);
	        this.ngModel.municipio = this.getElementoDeLista(this.ngModel.municipio, this.municipios);
	      }
	    }
	  }, {
	    key: 'getElementoDeLista',
	    value: function getElementoDeLista(elemento, lista) {
	      if (!elemento) {
	        return null;
	      }
	      for (var i = 0; i < lista.length; i++) {
	        if (lista[i].codigo === elemento.codigo) {
	          return lista[i];
	        }
	      }
	      return elemento;
	    }
	
	    /**
	    * getDepartamentos - Obtiene departamentos, si ngModel no es undefined significa que existe un valor ya asignado,
	    * entonces se envía en query el código del departamento ya cargado. Setea los departamentos como habilitados.
	    */
	
	  }, {
	    key: 'getDepartamentos',
	    value: function getDepartamentos() {
	      var _this = this;
	
	      var query = !this.Util.isEmpty(this.ngModel) && this.ngDisabled ? '?codigo=' + this.ngModel.departamento.codigo : '';
	      this.DataService.get('departamentos/' + query).then(function (response) {
	        _this.departamentos = response;
	        if (_this.Util.isEmpty(_this.ngModel)) {
	          _this.ngModel = {};
	          _this.establecerDatosPorDefecto(response, 'departamento');
	        }
	      });
	    }
	  }, {
	    key: 'getProvincias',
	    value: function getProvincias(departamento, reset) {
	      var _this2 = this;
	
	      if (reset) {
	        this.resetearValores();
	      }
	      this.DataService.get('provincias/' + departamento.codigo).then(function (response) {
	        _this2.provincias = response;
	        _this2.establecerDatosPorDefecto(response, 'provincia');
	      });
	    }
	  }, {
	    key: 'getMunicipios',
	    value: function getMunicipios(provincia, reset) {
	      var _this3 = this;
	
	      if (reset) {
	        this.ngModel.municipio = null;
	      }
	      this.DataService.get('municipios/' + provincia.codigo).then(function (response) {
	        _this3.municipios = response;
	        _this3.establecerDatosPorDefecto(response, 'municipio');
	      });
	    }
	  }, {
	    key: 'resetearValores',
	    value: function resetearValores() {
	      this.ngModel.provincia = null;
	      this.ngModel.municipio = null;
	      this.municipios = [];
	    }
	
	    /**
	    * establecerDatosPorDefecto - Si en la lista de opciones solo hay un elemento,éste es asignado
	    * a la variable que corresponde como dato por defecto. Además se asigna sólo si ngModel es indefinido.
	    *
	    * @param  {array} lista    Lista de opciones
	    * @param  {string} elemento elemento a asignar el valor
	    * @return {function}          Método que se ejecutará de acuerdo al elemento seleccionado
	    */
	
	  }, {
	    key: 'establecerDatosPorDefecto',
	    value: function establecerDatosPorDefecto(lista, elemento) {
	      if (lista.length !== 1) {
	        return;
	      }
	      this.ngModel[elemento] = lista[0];
	      switch (elemento) {
	        case 'departamento':
	          return this.getProvincias(lista[0]);
	        case 'provincia':
	          return this.getMunicipios(lista[0]);
	      }
	      return;
	    }
	  }]);
	
	  return CSelectDPAController;
	}();
	
	exports.default = CSelectDPAController;

/***/ }),
/* 258 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AllowClearClass = function () {
	  function AllowClearClass() {
	    'ngInject';
	
	    _classCallCheck(this, AllowClearClass);
	
	    this.restrict = 'A';
	  }
	
	  _createClass(AllowClearClass, [{
	    key: 'link',
	    value: function link($scope, $elem, $attr) {
	      if ($attr.allowClear) {
	        var find = angular.element($elem[0].querySelector('.glyphicon-remove'));
	        find.removeClass('glyphicon glyphicon-remove');
	        find.addClass('fa fa-remove');
	      }
	    }
	  }]);
	
	  return AllowClearClass;
	}();
	
	exports.default = AllowClearClass;

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cSelect = __webpack_require__(260);
	
	var _cSelect2 = _interopRequireDefault(_cSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//import './ui-select.scss';
	var CSelectComponent = {
	  bindings: {
	    name: '@',
	    label: '@',
	    title: '@',
	    placeholder: '@',
	    ngModel: '=',
	    ngChange: '&',
	    onSelect: '&',
	    ngDisabled: '=',
	    ngRequired: '=',
	    options: '<',
	    field: '@',
	    keyValue: '@'
	  },
	  require: {
	    form: '^form'
	  },
	  template: '\n      <div class="md-form-group md-select-group" md-event-label>\n        <ui-select ng-if="!$ctrl.Util.isMobile.any() && !$ctrl.keyValue" name="{{$ctrl.name}}" on-select="$ctrl.onSelect({item:$item})" ng-change="$ctrl.ngChange()" ng-model="$ctrl.ngModel" theme="bootstrap"\n        class="md-select" ng-required="$ctrl.ngRequired" ng-disabled="$ctrl.ngDisabled" maxlen="20">\n          <ui-select-match placeholder="{{$ctrl.placeholder}}" allow-clear="!$ctrl.ngRequired" allow-clear-class>\n            {{$select.selected[$ctrl.field]}}\n          </ui-select-match>\n          <ui-select-choices repeat="item in $ctrl.options | filter: $select.search">\n            <span ng-bind-html="item[$ctrl.field] | highlight: $select.search"></span>\n          </ui-select-choices>\n          <ui-select-no-choice>\n            <small> No se encontraron coincidencias </small>\n          </ui-select-no-choice>\n        </ui-select>\n\n        <ui-select ng-if="!$ctrl.Util.isMobile.any() && $ctrl.keyValue" name="{{$ctrl.name}}" on-select="$ctrl.onSelect({item:$item})" ng-change="$ctrl.ngChange()" ng-model="$ctrl.ngModel" theme="bootstrap"\n        class="md-select" ng-required="$ctrl.ngRequired" ng-disabled="$ctrl.ngDisabled" maxlen="20">\n          <ui-select-match placeholder="{{$ctrl.placeholder}}" allow-clear="!$ctrl.ngRequired" allow-clear-class>\n            {{$select.selected[$ctrl.field]}}\n          </ui-select-match>\n          <ui-select-choices repeat="item[$ctrl.keyValue] as item in $ctrl.options | filter: $select.search">\n            <span ng-bind-html="item[$ctrl.field] | highlight: $select.search"></span>\n          </ui-select-choices>\n          <ui-select-no-choice>\n            <small> No se encontraron coincidencias </small>\n          </ui-select-no-choice>\n        </ui-select>\n\n        <select class="select-mobile" ng-if="!!$ctrl.Util.isMobile.any()" name="{{$ctrl.name}}" ng-model="$ctrl.ngModel" ng-options="item[$ctrl.field] for item in $ctrl.options"\n        ng-change="$ctrl.ngChange()" ng-required="$ctrl.ngRequired" ng-disabled="$ctrl.ngDisabled"></select>\n\n        <label for="{{$ctrl.name}}" title="{{$ctrl.title}}" class="{{!!$ctrl.Util.isMobile.any()? \'label-mobile\' : \'md-control-label\'}}" ng-class="{\'requerido\':$ctrl.ngRequired, \'md-control-label\': $ctrl.ngModel}">{{$ctrl.label}}</label>\n\n        <i class="md-bar" ng-class="{\'error\':$ctrl.form[$ctrl.name].$invalid && $ctrl.form[$ctrl.name].$touched}"></i>\n        <div ng-messages="$ctrl.form[$ctrl.name].$error" ap-error ng-if="$ctrl.form[$ctrl.name].$touched" role="alert">\n          <div ng-message="required"> El campo es requerido. </div>\n        </div>\n      </div>\n    ',
	  controller: _cSelect2.default
	};
	
	exports.default = CSelectComponent;

/***/ }),
/* 260 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CSelectController = function () {
	  CSelectController.$inject = ["Util"];
	  function CSelectController(Util) {
	    'ngInject';
	
	    _classCallCheck(this, CSelectController);
	
	    this.Util = Util;
	  }
	
	  _createClass(CSelectController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.field = angular.isUndefined(this.field) ? 'nombre' : this.field;
	      this.placeholder = angular.isUndefined(this.placeholder) ? 'Seleccione ...' : this.placeholder;
	      this.establecerDatosPorDefecto();
	    }
	
	    /**
	     * establecerDatosPorDefecto - Si en la lista de opciones solo hay un elemento,éste es asignado
	     * a la variable que corresponde como dato por defecto. Además se asigna sólo si ngModel es indefinido.
	     */
	
	  }, {
	    key: 'establecerDatosPorDefecto',
	    value: function establecerDatosPorDefecto() {
	      if (this.options && this.options.length === 1 && angular.isUndefined(this.ngModel)) {
	        if (this.keyValue) {
	          this.ngModel = this.options[0][this.keyValue];
	        } else {
	          this.ngModel = this.options[0];
	        }
	      }
	    }
	  }]);
	
	  return CSelectController;
	}();
	
	exports.default = CSelectController;

/***/ }),
/* 261 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MaxLen = function () {
	  function MaxLen() {
	    _classCallCheck(this, MaxLen);
	
	    this.restrict = 'A';
	  }
	
	  _createClass(MaxLen, [{
	    key: 'link',
	    value: function link($scope, $elem, $attr) {
	      var uiSelectSearch = angular.element($elem[0].querySelector('.ui-select-search'));
	      uiSelectSearch.attr("maxlength", $attr.maxlen);
	    }
	  }]);
	
	  return MaxLen;
	}();
	
	exports.default = MaxLen;

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	        value: true
	});
	
	var _cTable = __webpack_require__(263);
	
	var _cTable2 = _interopRequireDefault(_cTable);
	
	var _cTable3 = __webpack_require__(579);
	
	var _cTable4 = _interopRequireDefault(_cTable3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CTableComponent = {
	        bindings: {
	                columns: '<',
	                dataset: '<'
	        },
	        template: _cTable4.default,
	        controller: _cTable2.default
	};
	
	exports.default = CTableComponent;

/***/ }),
/* 263 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CTableController = function () {
	  CTableController.$inject = ["NgTableParams", "$scope"];
	  function CTableController(NgTableParams, $scope) {
	    'ngInject';
	
	    _classCallCheck(this, CTableController);
	
	    this.NgTableParams = NgTableParams;
	    this.$scope = $scope;
	  }
	
	  _createClass(CTableController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.initTableParams();
	    }
	  }, {
	    key: '$onChanges',
	    value: function $onChanges() {
	      var _this = this;
	
	      this.$scope.$watch('$ctrl.dataset', function () {
	        _this.initTableParams();
	      }, true);
	    }
	  }, {
	    key: 'initTableParams',
	    value: function initTableParams() {
	      this.tableParams = new this.NgTableParams({
	        sorting: {}
	      }, {
	        dataset: this.dataset
	      });
	    }
	  }]);
	
	  return CTableController;
	}();
	
	exports.default = CTableController;

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cTextarea = __webpack_require__(265);
	
	var _cTextarea2 = _interopRequireDefault(_cTextarea);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CTextareaComponent = {
	  bindings: {
	    name: '@',
	    label: '@',
	    title: '@',
	    ngModel: '=',
	    ngDisabled: '=',
	    ngRequired: '=',
	    rows: '@?',
	    ngMinlength: '@?',
	    ngMaxlength: '@?',
	    maxlength: '@?',
	    ngBlur: '&?'
	  },
	  require: {
	    form: '^form'
	  },
	  template: '   <div class="md-form-group" md-event-label>\n        <textarea name="{{$ctrl.name}}"\n                  ng-required="$ctrl.ngRequired"\n                  ng-disabled="$ctrl.ngDisabled"\n                  ng-readonly="$ctrl.ngReadonly"\n                  ng-model="$ctrl.ngModel"\n                  ng-minlength="$ctrl.ngMinlength"\n                  ng-maxlength="$ctrl.ngMaxlength"\n                  maxlength="{{$ctrl.maxlength}}"\n                  ng-blur="$ctrl.ngBlur()"\n                  rows="{{$ctrl.rows}}">\n        </textarea>\n        <label for="{{$ctrl.name}}" title="{{$ctrl.title}}" class="md-control-label" ng-class="{\'requerido\':$ctrl.ngRequired}" for="textarea">{{ $ctrl.label }}</label>\n        <i class="md-bar" ng-class="{\'error\':$ctrl.form[$ctrl.name].$invalid && $ctrl.form[$ctrl.name].$touched}"></i>\n        <div ng-messages="$ctrl.form[$ctrl.name].$error" ap-error ng-if="$ctrl.form[$ctrl.name].$touched && !$ctrl.form[$ctrl.name].$valid" role="alert">\n            <div ng-message="required"> El campo es requerido. </div>\n            <div ng-message="minlength"> El contenido es muy corto. </div>\n            <div ng-message="maxlength"> El contenido es muy largo. </div>\n        </div>\n    </div>\n  ',
	  controller: _cTextarea2.default
	};
	
	exports.default = CTextareaComponent;

/***/ }),
/* 265 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CTextAreaController = function () {
	  function CTextAreaController() {
	    'ngInject';
	
	    _classCallCheck(this, CTextAreaController);
	  }
	
	  _createClass(CTextAreaController, [{
	    key: '$onInit',
	    value: function $onInit() {}
	  }]);
	
	  return CTextAreaController;
	}();
	
	exports.default = CTextAreaController;

/***/ }),
/* 266 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ValidacionFormsService = function () {
	  ValidacionFormsService.$inject = ["Modal"];
	  function ValidacionFormsService(Modal) {
	    'ngInject';
	
	    _classCallCheck(this, ValidacionFormsService);
	
	    this.Modal = Modal;
	  }
	
	  _createClass(ValidacionFormsService, [{
	    key: '$onInit',
	    value: function $onInit() {}
	  }, {
	    key: 'esFormularioValido',
	    value: function esFormularioValido(form) {
	      return form.$valid;
	    }
	  }, {
	    key: 'validarFormulario',
	    value: function validarFormulario(form, mostrarModal) {
	      var _this = this;
	
	      this.camposInvalidos = {};
	      if (this.esFormularioValido(form)) {
	        return;
	      } else {
	        angular.forEach(form.$error, function (campos) {
	          angular.forEach(campos, function (campo) {
	            if (campo.$name) {
	              var elemento = angular.element(document.querySelector('[name=' + campo.$name + ']'));
	              var label = _this.obtenerLabel(campo.$name, elemento);
	              if (angular.isUndefined(_this.camposInvalidos[campo.$name])) {
	                if (label) {
	                  _this.camposInvalidos[campo.$name] = label;
	                }
	              }
	            }
	            campo.$touched = true;
	          });
	        });
	      }
	      if (mostrarModal) {
	        this.mostrarCamposInvalidos(this.camposInvalidos);
	      } else {
	        return this.camposInvalidos;
	      }
	    }
	  }, {
	    key: 'obtenerLabel',
	    value: function obtenerLabel(nombreCampo, elemento) {
	      var elementoPadre = elemento.parent();
	      var i = 0;
	      while (i < 10) {
	        var elemPadre = elementoPadre.find('label');
	        if (elemPadre.length > 0) {
	          for (var j = 0; j < elemPadre.length; j++) {
	            if (elemPadre[j].htmlFor === nombreCampo) {
	              if (elemPadre[j].title !== '') {
	                return elemPadre[j].title;
	              }
	              return elemPadre[j].innerText;
	            }
	          }
	        }
	        elementoPadre = elementoPadre.parent();
	        i++;
	      }
	      return null;
	    }
	  }, {
	    key: 'mostrarCamposInvalidos',
	    value: function mostrarCamposInvalidos(camposInvalidos, titulo) {
	      this.Modal.alert(this.getMensajeCamposIncompletos(camposInvalidos), null, titulo || 'Campos incompletos', null, 'md');
	    }
	  }, {
	    key: 'getMensajeCamposIncompletos',
	    value: function getMensajeCamposIncompletos(camposInvalidos) {
	      var mensaje = '<p>Verifique, corrija y/o llene los siguientes campos:</p>';
	      mensaje += '<ul>';
	      angular.forEach(camposInvalidos || this.camposInvalidos, function (error) {
	        mensaje += '<li>' + error + '</li>';
	      });
	      return mensaje += '</ul>';
	    }
	  }]);
	
	  return ValidacionFormsService;
	}();
	
	exports.default = ValidacionFormsService;

/***/ }),
/* 267 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ValidarFormulario = function () {
	  function ValidarFormulario() {
	    'ngInject';
	
	    _classCallCheck(this, ValidarFormulario);
	
	    this.restrict = 'A';
	    this.controller = ValidarFormularioController;
	    this.scope = {
	      form: '=validarFormulario',
	      nombreForm: '@nombreFormulario',
	      method: '&ngClick',
	      methodValidation: '&validacionParalela'
	    };
	  }
	
	  _createClass(ValidarFormulario, [{
	    key: 'link',
	    value: function link($scope, $elem, $attr, $ctrl) {
	      var _this = this;
	
	      $elem.bind('click', function (event) {
	        if (!$scope.form && $scope.nombreForm) {
	          $scope.form = $scope.nombreForm;
	        }
	        if ($ctrl.Util.isEmpty($scope.form)) {
	          return;
	        }
	        event.stopImmediatePropagation();
	        if (_typeof($scope.form) === 'object') {
	          _this.validarFormulario($scope, $ctrl, $scope.form, event);
	        } else if (typeof $scope.form === 'string') {
	          var FORM = _this.buscarFormulario($scope);
	          if (!angular.isUndefined(FORM)) {
	            _this.validarFormulario($scope, $ctrl, FORM[$scope.form]);
	          }
	        }
	        $scope.$apply();
	      });
	    }
	  }, {
	    key: 'validarFormulario',
	    value: function validarFormulario($scope, $ctrl, form) {
	      if ($ctrl.Util.isValidFormFields(form)) {
	        $scope.method();
	      } else {
	        $scope.methodValidation();
	      }
	    }
	  }, {
	    key: 'buscarFormulario',
	    value: function buscarFormulario($scope) {
	      return angular.element(document.querySelector('[name=' + $scope.form + ']')).scope();
	    }
	  }]);
	
	  return ValidarFormulario;
	}();
	
	var ValidarFormularioController = function ValidarFormularioController(Util) {
	  'ngInject';
	
	  _classCallCheck(this, ValidarFormularioController);
	
	  this.Util = Util;
	};
	ValidarFormularioController.$inject = ["Util"];
	
	exports.default = ValidarFormulario;

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _crudTable = __webpack_require__(269);
	
	var _crudTable2 = _interopRequireDefault(_crudTable);
	
	var _crudTable3 = __webpack_require__(580);
	
	var _crudTable4 = _interopRequireDefault(_crudTable3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CrudTableComponent = {
	    bindings: {
	        url: '<',
	        title: '<',
	        fields: '<',
	        fieldsCreate: '<',
	        fieldsUpdate: '<',
	        fieldsSave: '<',
	        fks: '<',
	        buttonsTop: '<',
	        buttons: '<',
	        checks: '<',
	        clases: '<',
	        queryExtra: '<',
	        permission: '<',
	        modalController: '<',
	        modalTemplate: '<',
	        addModalTemplate: '<',
	        addModalController: '<',
	        editModalTemplate: '<',
	        editModalController: '<',
	        inline: '@',
	        editable: '@',
	        pagination: '@',
	        formly: '<',
	        data: '=',
	        callbackSave: '<',
	        hiddenFields: '<',
	        mergeFields: '<',
	        eventCreate: '<',
	        eventEdit: '<',
	        eventDelete: '<',
	        labels: '<',
	        delete: '<',
	        update: '<'
	    },
	    controller: _crudTable2.default,
	    template: _crudTable4.default
	};
	
	exports.default = CrudTableComponent;

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _crudTableModal = __webpack_require__(270);
	
	var _crudTableModal2 = _interopRequireDefault(_crudTableModal);
	
	var _crudTableModal3 = __webpack_require__(581);
	
	var _crudTableModal4 = _interopRequireDefault(_crudTableModal3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CrudTableController = function () {
	    CrudTableController.$inject = ["$scope", "DataService", "NgTableParams", "Modal", "CrudTable", "Util", "ArrayUtil", "Message", "Datetime", "$log"];
	    function CrudTableController($scope, DataService, NgTableParams, Modal, CrudTable, Util, ArrayUtil, Message, Datetime, $log) {
	        'ngInject';
	
	        _classCallCheck(this, CrudTableController);
	
	        this.$scope = $scope;
	        this.DataService = DataService;
	        this.NgTableParams = NgTableParams;
	        this.Modal = Modal;
	        this.Message = Message;
	        this.Util = Util;
	        this.CrudTable = CrudTable;
	        this.ArrayUtil = ArrayUtil;
	        this.Datetime = Datetime;
	        this.$log = $log;
	
	        this.formlyDefault = [{
	            key: '',
	            templateOptions: {
	                required: false
	            },
	            hideExpression: 'true'
	        }, {
	            key: 'updatedAt',
	            templateOptions: {
	                required: false
	            },
	            hideExpression: 'true'
	        }, {
	            key: 'createdAt',
	            templateOptions: {
	                required: false
	            },
	            hideExpression: 'true'
	        }];
	
	        this.permissions = {
	            create: true,
	            read: true,
	            update: true,
	            delete: true,
	            print: false,
	            filter: true
	        };
	
	        this.options = {};
	    }
	
	    _createClass(CrudTableController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            // this.$log.log(this);
	            this.getFields();
	
	            if (this.data && this.data.list && this.Util.toType(this.data.list) == 'array') {
	                this.showFilter = false;
	            } else {
	                this.showFilter = true;
	            }
	
	            // Obtener relaciones
	            if (this.data && this.data.formly) {
	                this.relations = {};
	                for (var i in this.data.formly) {
	                    if (this.data.formly[i].key.indexOf('.') > 0) {
	                        var relation = this.data.formly[i].key.split('.');
	                        if (!this.relations[relation[0]]) this.relations[relation[0]] = [];
	                        if (relation[2]) {
	                            // Profundidad 2
	                            if (!this.relations[relation[0]][relation[1]]) this.relations[relation[0]][relation[1]] = [];
	                            this.relations[relation[0]][relation[1]].push(relation[2]);
	                        } else {
	                            this.relations[relation[0]].push(relation[1]);
	                        }
	                    }
	                }
	            }
	
	            this.$scope.$on('refresh_crud_table', function (ev, url) {
	                if (url == _this.url) _this.refresh();
	            });
	        }
	    }, {
	        key: 'renderLabels',
	        value: function renderLabels(params) {
	            setTimeout(function () {
	                if (document.querySelector('.ng-table-counts')) {
	                    document.querySelector('.ng-table-counts').setAttribute('data-content', 'Filas: ');
	                }
	                if (document.querySelector('.ng-table-pagination')) {
	                    document.querySelector('.ng-table-pagination').setAttribute('data-content', params.ini + ' al ' + params.end + ' de ' + params.total + ' Registros.');
	                }
	            }, 100);
	        }
	    }, {
	        key: 'addOptionSelected',
	        value: function addOptionSelected(data, options) {
	            for (var i in data) {
	                if (data[i].type == 'select') {
	                    var item = this.CrudTable.searchField(options, data[i].key);
	                    if (item) {
	                        this.ArrayUtil.insert(data[i].templateOptions.options, 0, {
	                            name: item.text || 'Seleccione',
	                            value: item.value || ''
	                        });
	                    }
	                }
	            }
	        }
	    }, {
	        key: 'getFields',
	        value: function getFields() {
	            var _this2 = this;
	
	            if (this.data && this.data.formly && this.Util.toType(this.data.formly) == 'array') {
	                this.setDataFields(this.data.formly);
	            } else {
	                this.DataService.options(this.url).then(function (response) {
	                    response = response.datos;
	                    _this2.setDataFields(response);
	                });
	            }
	        }
	    }, {
	        key: 'setDataFields',
	        value: function setDataFields() {
	            var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	            this.fieldsData = this.CrudTable.filterFields(fields, this.fields);
	            this.idKey = this.CrudTable.getId(this.fieldsData);
	            this.formlyDefault[0].key = this.idKey;
	
	            if (this.formly && this.Util.toType(this.formly) == 'array') {
	                this.formly = this.CrudTable.addPropertiesFormly(this.formlyDefault, this.formly);
	            } else {
	                this.formly = this.formlyDefault;
	            }
	
	            // this.$log.log('formly:', this.formly);
	            this.fieldsData = this.CrudTable.addPropertiesFormly(this.fieldsData, this.formly);
	            this.addOptionSelected(this.fieldsData, this.optionSelected);
	            this.DataService.setFormly(this.fieldsData);
	
	            // this.$log.log('fields:', this.fieldsData);
	            this.setHeaders(this.fieldsData);
	            if (this.editable) {
	                this.types = this.CrudTable.getKeys(this.fieldsData);
	            }
	            this.getData();
	
	            /**
	             * Campos para el formulario de adición
	             */
	            if (this.Util.toType(this.fieldsCreate) == 'array') {
	                this.fieldsCreate = this.CrudTable.filterFields(fields, this.fieldsCreate);
	                this.fieldsCreate = this.CrudTable.addPropertiesFormly(this.fieldsCreate, this.formly);
	            }
	
	            /**
	             * Campos para el formulario de actualización
	             */
	            if (this.Util.toType(this.fieldsUpdate) == 'array') {
	                this.fieldsUpdate = this.CrudTable.filterFields(fields, this.fieldsUpdate);
	                this.fieldsUpdate = this.CrudTable.addPropertiesFormly(this.fieldsUpdate, this.formly);
	            }
	
	            /**
	             * Campos para el formulario de adición/actualización
	             */
	            if (this.Util.toType(this.fieldsSave) == 'array') {
	                this.fieldsSave = this.CrudTable.filterFields(fields, this.fieldsSave);
	                this.fieldsSave = this.CrudTable.addPropertiesFormly(this.fieldsSave, this.formly);
	            }
	
	            if (this.permission) {
	                this.permissions = angular.merge(this.permissions, this.permission);
	            }
	        }
	    }, {
	        key: 'setHeaders',
	        value: function setHeaders(fields) {
	            var headers = [{
	                field: "action",
	                title: "Acciones",
	                dataType: "command"
	            }];
	            var hiddenFields = this.Util.toType(this.hiddenFields) == 'array';
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = fields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var field = _step.value;
	
	                    var config = {
	                        field: field.key,
	                        title: field.templateOptions.label,
	                        headerTitle: field.templateOptions.label,
	                        sortable: field.key,
	                        show: hiddenFields ? this.hiddenFields.indexOf(field.key) === -1 && field.key != this.idKey : field.key != this.idKey
	                    };
	                    if (this.inline === undefined) {
	                        var filter = _defineProperty({}, field.key, field.templateOptions.type);
	                        // console.log('filter', filter);
	                        if (field.templateOptions.type == 'select' && field.templateOptions.options) {
	                            config.filterData = field.templateOptions.options;
	                        }
	                        config.filter = filter;
	                    }
	                    headers.push(config);
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	
	            this.headers = headers;
	        }
	    }, {
	        key: 'refresh',
	        value: function refresh() {
	            this.getData();
	        }
	    }, {
	        key: 'getData',
	        value: function getData() {
	            var _this3 = this;
	
	            if (this.data && this.data.list && this.Util.toType(this.data.list) == 'array') {
	                var data = { dataset: this.filterItems(this.data.list) };
	                var config = {};
	                if (this.pagination === false || this.pagination === 'false') {
	                    config.count = this.data.list.length;
	                    data.counts = [];
	                }
	
	                this.tableParams = new this.NgTableParams(config, data);
	            } else {
	                this.tableParams = new this.NgTableParams({}, {
	                    getData: function getData(params) {
	                        var data = params.url();
	                        var query = {
	                            limit: data.count,
	                            page: data.page
	                        };
	                        var sort = _this3.getSorting(data);
	                        if (sort) {
	                            query.order = sort;
	                        }
	                        var filters = _this3.getFilters(data);
	                        if (filters.length) {
	                            if (filters[0].crudtable_search_term) {
	                                query.filter = filters[0].crudtable_search_term;
	                            } else {
	                                for (var i in filters) {
	                                    var key = Object.keys(filters[i])[0];
	                                    if (filters[i][key] && filters[i][key] !== null && filters[i][key] != 'null') {
	                                        query[key] = filters[i][key];
	                                    }
	                                }
	                                // query.filter = JSON.stringify(filters);
	                            }
	                        }
	
	                        if (_this3.queryExtra) {
	                            angular.extend(query, _this3.queryExtra);
	                        }
	
	                        // this.$log.log('data:', data);
	                        return _this3.DataService.list(_this3.url, query).then(function (response) {
	                            response = response.datos;
	                            if (response && (response.results || response.rows)) {
	                                params.total(response.count);
	                                _this3.emptyTable = response.count === 0;
	                                var items = _this3.filterItems(response.results || response.rows);
	                                _this3.renderLabels({
	                                    ini: (query.page - 1) * query.limit + 1,
	                                    end: query.page * query.limit < response.count ? query.page * query.limit : response.count,
	                                    total: response.count
	                                });
	                                return items;
	                            }
	                        });
	                    }
	                });
	            }
	        }
	    }, {
	        key: 'getSorting',
	        value: function getSorting(params) {
	            for (var key in params) {
	                if (key.indexOf('sorting') != -1) {
	                    return (params[key] == 'desc' ? "-" : "") + this.removeCorchete(key, 'sorting');
	                }
	            }
	            return null;
	        }
	    }, {
	        key: 'getFilters',
	        value: function getFilters(params) {
	            var filters = [];
	            for (var key in params) {
	                if (key.indexOf('filter') != -1) {
	                    filters.push(_defineProperty({}, this.removeCorchete(key, 'filter'), params[key]));
	                }
	            }
	            return filters;
	        }
	    }, {
	        key: 'removeCorchete',
	        value: function removeCorchete(string, search) {
	            return string.replace(search + '[', '').replace(']', '');
	        }
	    }, {
	        key: 'filterItems',
	        value: function filterItems(data) {
	            data = angular.copy(data);
	            var fields = this.fields !== undefined;
	            var fks = this.fks !== undefined;
	            var relations = this.relations !== undefined;
	            var array = [];
	            for (var i in data) {
	                for (var j in data[i]) {
	                    if (fields && this.fields.indexOf(j) == -1) {
	                        delete data[i][j];
	                    } else {
	                        if (this.editable === undefined) {
	                            if (typeof data[i][j] == 'boolean') {
	                                data[i][j] = data[i][j] ? 'boolean_true' : 'boolean_false';
	                            } else if (relations && this.relations[j]) {
	                                data[i][j] = this.CrudTable.searchFieldData(this.relations[j], data[i][j]);
	                            } else if (fks && this.fks.indexOf(j) != -1) {
	                                if (this.Util.toType(data[i][j]) == 'array') {
	                                    var l = this.CrudTable.lengthOptions(this.fieldsData, j);
	                                    if (l > 1 && l == data[i][j].length) {
	                                        data[i][j] = 'Todos';
	                                    } else {
	                                        var text = [];
	                                        var _iteratorNormalCompletion2 = true;
	                                        var _didIteratorError2 = false;
	                                        var _iteratorError2 = undefined;
	
	                                        try {
	                                            for (var _iterator2 = data[i][j][Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                                                var e = _step2.value;
	
	                                                text.push(this.CrudTable.getFkData(this.fieldsData, j, e));
	                                            }
	                                        } catch (err) {
	                                            _didIteratorError2 = true;
	                                            _iteratorError2 = err;
	                                        } finally {
	                                            try {
	                                                if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                                                    _iterator2.return();
	                                                }
	                                            } finally {
	                                                if (_didIteratorError2) {
	                                                    throw _iteratorError2;
	                                                }
	                                            }
	                                        }
	
	                                        data[i][j] = text.join(', ');
	                                    }
	                                } else {
	                                    data[i][j + '_fk'] = data[i][j];
	                                    data[i][j] = this.CrudTable.getFkData(this.fieldsData, j, data[i][j]);
	                                }
	                            } else if (this.Util.toType(data[i][j]) == 'array') {
	                                data[i][j] = data[i][j][0];
	                            }
	                            if (this.mergeFields && typeof this.mergeFields[j] == 'function') {
	                                data[i][j] = this.mergeFields[j](data[i]);
	                            }
	                        }
	                    }
	                }
	                array.push(this.orderItem(data[i], this.fieldsData, i));
	            }
	            return array;
	        }
	    }, {
	        key: 'orderItem',
	        value: function orderItem(data, fields, pos) {
	            var _this4 = this;
	
	            if (fields === undefined || fields.length === 0) {
	                return data;
	            }
	
	            var relation = void 0,
	                item = {};
	
	            var _loop = function _loop(i) {
	                var field = fields[i].key;
	                if (data[field] !== undefined || data[field + '_fk'] !== undefined) {
	                    if (_this4.editable) {
	                        if (typeof data[field] == 'string' && !/[a-zA-Z]+/g.test(data[field]) && /^-?[0-9.]+\-?[0-9]+\-?[0-9]*$/g.test(data[field]) && data[field].length == 10) {
	                            var date = data[field].split('-');
	                            _this4.dataGrid[pos + '_' + field] = new Date(date[0], date[1] - 1, date[2]);
	                        } else {
	                            _this4.dataGrid[pos + '_' + field] = data[field];
	                        }
	                        item[field] = pos + '_' + field;
	                    } else {
	                        if (item[field + '_fk']) {
	                            item[field + '_fk'] = data[field];
	                        } else {
	                            item[field] = data[field];
	                        }
	                    }
	                }
	
	                // Si es una tabla relacionada
	                else if (_this4.relations) {
	                        for (var j in _this4.relations) {
	                            relation = _this4.relations[j].find(function (key) {
	                                return key == field.split('.')[1];
	                            });
	                            if (relation) {
	                                item[relation] = data[j][relation];
	                            }
	                            if (field.split('.')[2]) {
	                                relation = _this4.relations[j][field.split('.')[1]].find(function (key) {
	                                    return key == field.split('.')[2];
	                                });
	                                item[relation] = data[j][field.split('.')[1]][relation];
	                            }
	                        }
	                    }
	            };
	
	            for (var i in fields) {
	                _loop(i);
	            }
	            return item;
	        }
	    }, {
	        key: 'add',
	        value: function add(item, editModalController, editModalTemplate) {
	            var _this5 = this;
	
	            if (typeof this.eventCreate == 'function') {
	                this.eventCreate();
	            } else {
	                var fields = null;
	                if (item) {
	                    fields = this.fieldsSave || this.fieldsUpdate || this.fieldsData;
	                } else {
	                    fields = this.fieldsSave || this.fieldsCreate || this.fieldsData;
	                }
	
	                var modalInstance = this.Modal.show({
	                    template: editModalTemplate || this.addModalTemplate || this.modalTemplate || _crudTableModal4.default,
	                    controller: editModalController || this.addModalController || this.modalController || _crudTableModal2.default,
	                    data: {
	                        fields: fields,
	                        url: this.url,
	                        title: this.ngTitle,
	                        idKey: this.idKey,
	                        item: item
	                    }
	                });
	
	                modalInstance.result.then(function (data) {
	                    if (data && data[_this5.idKey]) {
	                        _this5.Message.success();
	                        _this5.refresh();
	                    }
	                }, function (error) {
	                    _this5.$log.info('Modal dismissed at: ' + new Date(), error);
	                });
	            }
	        }
	    }, {
	        key: 'edit',
	        value: function edit(item) {
	            var _this6 = this;
	
	            if (typeof this.eventEdit == 'function') {
	                this.eventEdit(item);
	            } else {
	                if (this.data && this.data.list) {
	                    this.editItem = true;
	                    this.modelInline = angular.copy(this.filterById(item[this.idKey], this.data.list));
	                } else {
	                    this.DataService.get(this.url, item[this.idKey]).then(function (response) {
	                        response = response.datos;
	                        if (response) {
	                            _this6.add(response, _this6.editModalController, _this6.editModalTemplate);
	                        }
	                    });
	                }
	            }
	        }
	    }, {
	        key: 'editCancel',
	        value: function editCancel() {
	            this.editItem = false;
	            this.modelInline = this.resetModel(this.modelInline);
	            this.data.list.map(function (e) {
	                delete e.edit;
	                return e;
	            });
	        }
	    }, {
	        key: 'deleteRow',
	        value: function deleteRow(item) {
	            var _this7 = this;
	
	            if (typeof this.eventDelete == 'function') {
	                this.eventDelete(item);
	            } else {
	                this.Modal.confirm('¿Desea eliminar este registro?', function () {
	                    if (_this7.data && _this7.data.list) {
	                        if (_this7.data.urlUpdate) {
	                            var list = angular.copy(_this7.data.list);
	                            list.map(function (e) {
	                                e = _this7.CrudTable.cleanData(e);
	                                return e;
	                            });
	
	                            var pos = _this7.getIdPosition(list, item);
	                            if (pos !== -1) {
	                                list.splice(pos, 1);
	                                _this7.DataService.put(_this7.data.urlUpdate, list).then(function (response) {
	                                    response = response.datos;
	                                    if (response) {
	                                        _this7.data.list = response;
	                                        _this7.refresh();
	                                        if (typeof _this7.callbackDelete == 'function') {
	                                            _this7.callbackDelete(_this7.data.list);
	                                        }
	                                    }
	                                });
	                            }
	                        } else {
	                            var _pos = _this7.getIdPosition(_this7.data.list, item);
	                            if (_pos !== -1) {
	                                _this7.data.list.splice(_pos, 1);
	                                _this7.refresh();
	                            }
	                        }
	                        _this7.inlineOptions = false;
	                        _this7.itemSelected = null;
	                    } else {
	                        _this7.DataService.delete(_this7.url, item[_this7.idKey]).then(function () {
	                            _this7.Message.success('Su registro fue eliminado correctamente.');
	                            _this7.refresh();
	                        });
	                    }
	                });
	            }
	        }
	    }, {
	        key: 'search',
	        value: function search() {
	            this.tableParams.filter({ 'crudtable_search_term': this.searchTerm });
	        }
	    }, {
	        key: 'cleanSearch',
	        value: function cleanSearch() {
	            this.searchTerm = '';
	            this.refresh();
	        }
	    }, {
	        key: 'getFieldClass',
	        value: function getFieldClass(row, col) {
	            if (this.clases && this.clases[col.field]) {
	                return this.clases[col.field](row, col);
	            } else {
	                return;
	            }
	        }
	    }, {
	        key: 'buttonEvent',
	        value: function buttonEvent(event, item, callback) {
	            if (typeof callback == 'function') {
	                callback(event, item);
	            }
	        }
	    }, {
	        key: 'buttonIf',
	        value: function buttonIf(event, item, callback) {
	            if (typeof callback == 'function') {
	                return callback(event, item);
	            } else {
	                return true;
	            }
	        }
	
	        // Form inline
	
	    }, {
	        key: 'saveFormInline',
	        value: function saveFormInline() {
	            var _this8 = this;
	
	            if (this.data && this.data.list && this.Util.toType(this.data.list) == 'array') {
	                if (this.formInline.$valid) {
	                    var data = this.modelInline;
	                    if (data[this.idKey] === undefined) {
	                        if (this.data.urlUpdate) {
	                            var list = angular.copy(this.data.list);
	                            list.map(function (e) {
	                                e = _this8.CrudTable.cleanData(e);
	                                return e;
	                            });
	                            list.push(data);
	                            this.DataService.put(this.data.urlUpdate, list).then(function (response) {
	                                response = response.datos;
	                                if (response) {
	                                    _this8.data.list = response;
	                                    _this8.modelInline = _this8.resetModel(_this8.modelInline);
	                                    _this8.formInline.$submitted = false;
	                                    _this8.Util.setTouchedForm(_this8.formInline, false);
	                                    _this8.refresh();
	                                    if (typeof _this8.callbackSave == 'function') {
	                                        _this8.callbackSave(_this8.data.list);
	                                    }
	                                }
	                            });
	                        } else {
	                            data[this.idKey] = this.Util.id();
	                            data.new = true;
	                            this.data.list.push(data);
	                            this.modelInline = this.resetModel(this.modelInline);
	                            this.formInline.$submitted = false;
	                            this.Util.setTouchedForm(this.formInline, false);
	                            this.refresh();
	                        }
	                    } else {
	                        delete data.edit;
	                        this.editItem = false;
	                        if (this.data.urlUpdate) {
	                            var _list = angular.copy(this.data.list);
	                            _list.map(function (e) {
	                                e = _this8.CrudTable.cleanData(e);
	                                return e;
	                            });
	                            this.setItem(_list, data);
	                            this.DataService.put(this.data.urlUpdate, _list).then(function (response) {
	                                response = response.datos;
	                                if (response) {
	                                    _this8.data.list = response;
	                                    _this8.modelInline = _this8.resetModel(_this8.modelInline);
	                                    _this8.formInline.$submitted = false;
	                                    _this8.Util.setTouchedForm(_this8.formInline, false);
	                                    _this8.refresh();
	                                    if (typeof _this8.callbackSave == 'function') {
	                                        _this8.callbackSave(_this8.data.list);
	                                    }
	                                }
	                            });
	                        } else {
	                            this.setItem(this.data.list, data);
	                            this.modelInline = this.resetModel(this.modelInline);
	                            this.formInline.$submitted = false;
	                            this.Util.setTouchedForm(this.formInline, false);
	                            this.refresh();
	                        }
	                        this.inlineOptions = false;
	                        this.itemSelected = null;
	                    }
	                    // this.$log.log('Lista:', this.data.list);
	                }
	            }
	        }
	    }, {
	        key: 'resetModel',
	        value: function resetModel(model) {
	            var obj = {};
	            for (var key in model) {
	                var formly = this.CrudTable.searchField(this.fieldsData, key);
	                if (formly && formly.defaultValue) {
	                    obj[key] = formly.defaultValue;
	                }
	            }
	            return obj;
	        }
	    }, {
	        key: 'getIdPosition',
	        value: function getIdPosition(list, item) {
	            for (var i in list) {
	                if (list[i][this.idKey] == item[this.idKey]) {
	                    return i;
	                }
	            }
	            return -1;
	        }
	    }, {
	        key: 'setItem',
	        value: function setItem(list, item) {
	            for (var i in list) {
	                if (list[i][this.idKey] == item[this.idKey]) {
	                    list[i] = item;
	                    break;
	                }
	            }
	        }
	    }, {
	        key: 'filterById',
	        value: function filterById(id, list) {
	            for (var i in list) {
	                if (list[i][this.idKey] == id) {
	                    return this.CrudTable.cleanData(list[i]);
	                }
	            }
	            return null;
	        }
	    }, {
	        key: 'selectRow',
	        value: function selectRow(row, list) {
	            var _this9 = this;
	
	            list.map(function (e, i) {
	                if (row[_this9.idKey] != list[i][_this9.idKey]) {
	                    delete list[i].edit;
	                }
	            });
	            if (row.edit) {
	                row.edit = false;
	                this.inlineOptions = false;
	                this.itemSelected = null;
	            } else {
	                row.edit = true;
	                this.inlineOptions = true;
	                this.itemSelected = row;
	            }
	        }
	    }, {
	        key: 'actionChecks',
	        value: function actionChecks() {
	            if (this.checks.cbButton) {
	                this.checks.cbButton(this.tableParams.data);
	            }
	        }
	    }, {
	        key: 'selectAllChecks',
	        value: function selectAllChecks() {
	            var _this10 = this;
	
	            this.tableParams.data.forEach(function (it) {
	                it.checked = _this10.modelSelectAllCheks;
	                if (_this10.checks.if && !_this10.checks.if(it)) {
	                    delete it.checked;
	                }
	            });
	            // this.$log.log(this.data)
	            // this.$log.log(this.data.list)
	        }
	    }, {
	        key: 'selectCheck',
	        value: function selectCheck(event, row) {
	            var _this11 = this;
	
	            var c = 0,
	                ct = 0;
	            this.tableParams.data.forEach(function (it) {
	                c += it.checked ? 1 : 0;
	                ct++;
	                if (_this11.checks.if && !_this11.checks.if(it)) {
	                    ct--;
	                }
	            });
	            this.modelSelectAllCheks = c == ct;
	
	            if (this.checks.cbCheck) {
	                this.checks.cbCheck(event, row);
	            }
	        }
	    }, {
	        key: 'checkIf',
	        value: function checkIf(row) {
	            if (this.checks.if) {
	                return this.checks.if(row);
	            } else {
	                return true;
	            }
	        }
	    }]);
	
	    return CrudTableController;
	}();
	
	exports.default = CrudTableController;

/***/ }),
/* 270 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CrudTableModalController = function () {
	    CrudTableModalController.$inject = ["$scope", "$uibModalInstance", "data", "DataService", "$log"];
	    function CrudTableModalController($scope, $uibModalInstance, data, DataService, $log) {
	        'ngInject';
	
	        _classCallCheck(this, CrudTableModalController);
	
	        this.fields = data.fields;
	        this.url = data.url;
	        this.title = data.title;
	        this.idKey = data.idKey;
	        this.DataService = DataService;
	        this.$uibModalInstance = $uibModalInstance;
	        this.$log = $log;
	
	        if (data.item) {
	            this.model = data.item;
	        }
	    }
	
	    _createClass(CrudTableModalController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.options = {
	                formState: {}
	            };
	        }
	    }, {
	        key: 'save',
	        value: function save() {
	            var _this = this;
	
	            if (this.model[this.idKey]) {
	                this.model.id = this.model[this.idKey];
	            }
	            this.DataService.save(this.url, this.model).then(function (response) {
	                if (response) {
	                    _this.$uibModalInstance.close(response);
	                }
	            });
	        }
	    }, {
	        key: 'cancel',
	        value: function cancel() {
	            this.$uibModalInstance.dismiss('cancel');
	        }
	    }]);
	
	    return CrudTableModalController;
	}();
	
	exports.default = CrudTableModalController;

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _crudTable = __webpack_require__(268);
	
	var _crudTable2 = _interopRequireDefault(_crudTable);
	
	var _crudTable3 = __webpack_require__(272);
	
	var _crudTable4 = _interopRequireDefault(_crudTable3);
	
	__webpack_require__(158);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CrudTableModule = angular.module('app.crud-table', []).service('CrudTable', _crudTable4.default).component('crudTable', _crudTable2.default).name;
	
	exports.default = CrudTableModule;

/***/ }),
/* 272 */
/***/ (function(module, exports) {

	'use strict';
	'use-strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CrudTableService = function () {
	    CrudTableService.$inject = ["Datetime"];
	    function CrudTableService(Datetime) {
	        'ngInject';
	
	        _classCallCheck(this, CrudTableService);
	
	        this.Datetime = Datetime;
	    }
	
	    _createClass(CrudTableService, [{
	        key: 'filterFields',
	        value: function filterFields(data, fields) {
	            if (typeof fields == 'undefined' || fields.length === 0) {
	                return data;
	            }
	            var filter = [];
	            for (var i in fields) {
	                var field = this.searchField(data, fields[i]);
	                if (field) {
	                    filter.push(field);
	                }
	            }
	            return filter;
	        }
	    }, {
	        key: 'searchField',
	        value: function searchField(fields, field) {
	            for (var i in fields) {
	                if (fields[i].key == field) {
	                    return fields[i];
	                }
	            }
	            return null;
	        }
	    }, {
	        key: 'searchFieldData',
	        value: function searchFieldData(fields, field) {
	            for (var i in fields) {
	                if (fields[i].key == field) {
	                    return fields[i].value;
	                }
	            }
	            return field;
	        }
	    }, {
	        key: 'addPropertiesFormly',
	        value: function addPropertiesFormly(data, formly) {
	            if (typeof formly == 'undefined' || formly.length === 0) {
	                return data;
	            }
	            for (var i in data) {
	                var field = this.searchField(formly, data[i].key);
	                if (field) {
	                    data[i] = angular.merge({}, data[i], field);
	                }
	            }
	            return data;
	        }
	    }, {
	        key: 'parseSave',
	        value: function parseSave(data, formly) {
	
	            var item = {};
	            for (var i in data) {
	                if (this.toType(data[i]) == 'date') {
	                    item[i] = this.Datetime.format(data[i], 'YYYY-MM-dd');
	                } else {
	                    if (typeof data[i] == 'string' && (data[i] == 'true' || data[i] == 'false')) {
	                        item[i] = item[i] == 'true';
	                    } else {
	                        item[i] = data[i];
	                    }
	                }
	            }
	            item.id = this.getId(item, formly);
	            return item;
	        }
	    }, {
	        key: 'getId',
	        value: function getId(formly, item) {
	            for (var i in formly) {
	                if (formly[i].templateOptions.label && formly[i].templateOptions.label == 'ID') {
	                    if (item) {
	                        return item[formly[i].key];
	                    } else {
	                        return formly[i].key;
	                    }
	                }
	            }
	            return null;
	        }
	    }, {
	        key: 'getFkData',
	        value: function getFkData(fieldsData, key, value) {
	            fieldsData.filter(function (e) {
	                if (e.key == key && e.templateOptions.options) {
	                    e.templateOptions.options.filter(function (elem) {
	                        if (elem.value == value) {
	                            value = elem.name;
	                        }
	                    });
	                }
	            });
	            return value;
	        }
	    }, {
	        key: 'filterItem',
	        value: function filterItem(data) {
	            for (var i in data) {
	                if (typeof data[i] == 'string') {
	                    if (this.Datetime.isDate(new Date(data[i]))) {
	                        data[i] = new Date(data[i]);
	                    } else if (!/[a-zA-Z]+/g.test(data[i]) && /^-?[0-9.]+\:?[0-9]+\:?[0-9]*$/g.test(data[i]) && data[i].length == 8) {
	                        // data[i] = formatTime(data[i]);
	                    }
	                }
	            }
	            return data;
	        }
	    }, {
	        key: 'lengthOptions',
	        value: function lengthOptions(data, key) {
	            for (var i in data) {
	                if (data[i].key == key && data[i].templateOptions && data[i].templateOptions.options) {
	                    return data[i].templateOptions.options.length;
	                }
	            }
	            return 0;
	        }
	    }, {
	        key: 'cleanData',
	        value: function cleanData(item) {
	            for (var key in item) {
	                if (item[key + '_fk']) {
	                    item[key] = item[key + '_fk'];
	                    delete item[key + '_fk'];
	                }
	                if (item[key] == 'boolean_true') {
	                    item[key] = true;
	                } else if (item[key] == 'boolean_false') {
	                    item[key] = false;
	                } else {
	                    item[key] = this.Datetime.toDate(item[key]);
	                }
	            }
	            return item;
	        }
	    }]);
	
	    return CrudTableService;
	}();
	
	exports.default = CrudTableService;

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _archivo = __webpack_require__(274);
	
	var _archivo2 = _interopRequireDefault(_archivo);
	
	var _archivo3 = __webpack_require__(582);
	
	var _archivo4 = _interopRequireDefault(_archivo3);
	
	__webpack_require__(159);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ArchivoComponent = {
	  bindings: {
	    name: '@',
	    label: '@',
	    ngModel: '=',
	    types: '@',
	    mimeTypes: '@',
	    maxsize: '@',
	    modoVista: '<?',
	    url: '@',
	    urlDescarga: '@',
	    apiUrl: '@',
	    ver: '<',
	    descargar: '<'
	  },
	  controller: _archivo2.default,
	  template: _archivo4.default
	};
	
	exports.default = ArchivoComponent;

/***/ }),
/* 274 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ArchivoController = function () {
	  ArchivoController.$inject = ["Modal", "apiUrl", "$scope"];
	  function ArchivoController(Modal, apiUrl, $scope) {
	    'ngInject';
	
	    _classCallCheck(this, ArchivoController);
	
	    this.Modal = Modal;
	    this.api = apiUrl;
	    this.$scope = $scope;
	  }
	
	  _createClass(ArchivoController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.ver = angular.isUndefined(this.ver) ? true : this.ver;
	      this.descargar = angular.isUndefined(this.descargar) ? true : this.descargar;
	    }
	  }, {
	    key: '$onChanges',
	    value: function $onChanges() {
	      var _this = this;
	
	      this.$scope.$watch('$ctrl.urlDescarga', function () {
	        if (_this.urlDescarga) {
	          _this.urlDescargaDocumento = angular.isUndefined(_this.apiUrl) ? '' + _this.api + _this.urlDescarga : '' + _this.apiUrl + _this.urlDescarga;
	        }
	      });
	    }
	  }, {
	    key: 'mostrarArchivo',
	    value: function mostrarArchivo() {
	      return !this.modoVista && _typeof(this.ngModel) !== 'object' && !angular.isUndefined(this.ngModel);
	    }
	  }, {
	    key: 'vistaPrevia',
	    value: function vistaPrevia() {
	      this.Modal.showDocumentBase64(this.url, this.label);
	    }
	  }]);
	
	  return ArchivoController;
	}();
	
	exports.default = ArchivoController;

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _documentoIdentidad = __webpack_require__(276);
	
	var _documentoIdentidad2 = _interopRequireDefault(_documentoIdentidad);
	
	var _documentoIdentidad3 = __webpack_require__(583);
	
	var _documentoIdentidad4 = _interopRequireDefault(_documentoIdentidad3);
	
	__webpack_require__(160);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var documentoIdentidadComponent = {
	    bindings: {
	        ngModel: '=',
	        onlyCi: '<?',
	        conf: '<',
	        url: '<',
	        callcackSearch: '<',
	        edadMaxima: '=?',
	        edadMinima: '=?',
	        modoVista: '<?'
	    },
	    controller: _documentoIdentidad2.default,
	    template: _documentoIdentidad4.default
	};
	
	exports.default = documentoIdentidadComponent;

/***/ }),
/* 276 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DocumentoIdentidadController = function () {
	  DocumentoIdentidadController.$inject = ["$scope", "DataService", "Datetime", "Message", "$log"];
	  function DocumentoIdentidadController($scope, DataService, Datetime, Message, $log) {
	    'ngInject';
	
	    _classCallCheck(this, DocumentoIdentidadController);
	
	    this.$scope = $scope;
	    this.DataService = DataService;
	    this.Datetime = Datetime;
	    this.Message = Message;
	    this.$log = $log;
	  }
	
	  _createClass(DocumentoIdentidadController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.establecerRangoValido();
	      this.initDefault('tipo_documento', 'TD_CI');
	    }
	  }, {
	    key: '$onChanges',
	    value: function $onChanges() {
	      var _this = this;
	
	      this.$scope.$watch('$ctrl.ngModel', function () {
	        if (_this.ngModel) {
	          _this.cargando_valores = true;
	          return;
	        }
	        if (!_this.ngModel) {
	          _this.ngModel = {};
	        }
	        _this.initDefault('tipo_documento', 'TD_CI');
	      }, true);
	    }
	  }, {
	    key: 'initDefault',
	    value: function initDefault(key, val) {
	      if (!this.ngModel[key]) {
	        this.ngModel[key] = val;
	      }
	    }
	  }, {
	    key: 'establecerRangoValido',
	    value: function establecerRangoValido() {
	      if (this.edadMinima) {
	        this.maxDate = this.Datetime.lessYearsToDate(this.edadMinima);
	      }
	      if (this.edadMaxima) {
	        this.minDate = this.Datetime.lessYearsToDate(this.edadMaxima);
	      }
	    }
	  }, {
	    key: 'isCI',
	    value: function isCI() {
	      if (angular.isUndefined(this.ngModel)) {
	        return;
	      }
	      if (angular.isUndefined(this.ngModel.tipo_documento)) {
	        return;
	      }
	      return this.ngModel.tipo_documento === 'TD_CI';
	    }
	  }, {
	    key: 'isFill',
	    value: function isFill() {
	      if (angular.isUndefined(this.ngModel)) {
	        return;
	      }
	      return this.ngModel.estado == 'ACTIVO';
	      // return this.ngModel.nombres && this.ngModel.primer_apellido && this.ngModel.tipo_documento==='TD_CI';
	    }
	  }, {
	    key: 'changeType',
	    value: function changeType() {
	      if (!this.cargando_valores) {
	        this.nombreDel();
	      }
	      this.cargando_valores = false;
	    }
	  }, {
	    key: 'nombreDel',
	    value: function nombreDel() {
	      delete this.ngModel.nombres;
	      delete this.ngModel.primer_apellido;
	      delete this.ngModel.segundo_apellido;
	      delete this.ngModel.id_persona;
	      delete this.ngModel.estado;
	    }
	  }, {
	    key: 'isDisabled',
	    value: function isDisabled() {
	      if (angular.isUndefined(this.ngModel)) {
	        return;
	      }
	      return angular.isUndefined(this.ngModel.numero_documento) || angular.isUndefined(this.ngModel.fecha_nacimiento);
	    }
	  }, {
	    key: 'search',
	    value: function search() {
	      var _this2 = this;
	
	      var ci = void 0,
	          datos = void 0;
	      if (this.ngModel.numero_documento.indexOf('-') !== -1) {
	        datos = this.ngModel.numero_documento.split('-');
	        ci = datos[0];
	      } else {
	        ci = this.ngModel.numero_documento;
	      }
	
	      var url = 'personas/' + ci + '/' + this.ngModel.fecha_nacimiento;
	      if (this.ngModel.complemento) {
	        url += '?complemento=' + this.ngModel.complemento;
	      }
	      this.DataService.get(url).then(function (response) {
	        _this2.$log.log(response);
	        _this2.nombreDel();
	        if (response) {
	          _this2.ngModel.primer_apellido = response.datos.primer_apellido;
	          _this2.ngModel.segundo_apellido = response.datos.segundo_apellido;
	          _this2.ngModel.nombres = response.datos.nombres;
	          _this2.ngModel.id_persona = response.datos.id_persona;
	          delete _this2.ngModel.telefono;if (response.datos.telefono) {
	            _this2.ngModel.telefono = response.datos.telefono;
	          }
	          _this2.ngModel.correo = response.datos.correo;
	
	          if (typeof _this2.callbackSearch == 'function') {
	            _this2.callbackSearch({ data: _this2.ngModel });
	          }
	          if (response.finalizado) {
	            _this2.ngModel.estado = 'ACTIVO';
	          }
	        }
	      });
	    }
	
	    // Funcion para contrastar datos de persona mediante interoperabilidad
	
	  }, {
	    key: 'contrastar',
	    value: function contrastar() {
	      var _this3 = this;
	
	      // Armar objeto de datos a enviar al backend
	      var ci = void 0,
	          datos = void 0,
	          campo = void 0;
	      if (this.ngModel.numero_documento.indexOf('-') !== -1) {
	        datos = this.ngModel.numero_documento.split('-');
	        ci = datos[0];
	      } else {
	        ci = this.ngModel.numero_documento;
	      }
	      campo = {
	        complemento: this.ngModel.complemento,
	        nombres: this.ngModel.nombres,
	        primer_apellido: this.ngModel.primer_apellido,
	        segundo_apellido: this.ngModel.segundo_apellido
	
	        // Enviar datos al backend
	      };this.DataService.get('personas/' + ci + '/' + this.ngModel.fecha_nacimiento + '?tipo=' + 1 + '&campo=' + JSON.stringify(campo)).then(function (response) {
	        _this3.$log.log(response);
	        if (response) {
	          // Si hay una respuesta correcta se acepta los datos
	          _this3.ngModel.primer_apellido = response.datos.primer_apellido;
	          _this3.ngModel.segundo_apellido = response.datos.segundo_apellido;
	          _this3.ngModel.nombres = response.datos.nombres;
	          _this3.ngModel.id_persona = response.datos.id_persona;
	          delete _this3.ngModel.telefono;if (response.datos.telefono) {
	            _this3.ngModel.telefono = response.datos.telefono;
	          }
	          _this3.ngModel.correo = response.datos.correo;
	
	          if (typeof _this3.callbackSearch == 'function') {
	            _this3.callbackSearch({ data: _this3.ngModel });
	          }
	          // Estado de datos activo (Verificado)
	          if (response.finalizado) {
	            _this3.ngModel.estado = 'ACTIVO';
	          }
	        }
	      });
	    }
	  }]);
	
	  return DocumentoIdentidadController;
	}();
	
	exports.default = DocumentoIdentidadController;

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _fileUpload = __webpack_require__(278);
	
	var _fileUpload2 = _interopRequireDefault(_fileUpload);
	
	var _fileUpload3 = __webpack_require__(584);
	
	var _fileUpload4 = _interopRequireDefault(_fileUpload3);
	
	__webpack_require__(161);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FileUploadComponent = {
	    bindings: {
	        onCompleteItem: '=',
	        onCompleteAll: '=',
	        onAfterAddingFile: '=',
	        onBeforeUploadItem: '=',
	        label: '@',
	        textUpload: '@',
	        multiple: '@',
	        types: '@',
	        name: '@',
	        url: '=',
	        form: '<',
	        data: '='
	    },
	    controller: _fileUpload2.default,
	    template: _fileUpload4.default
	};
	
	exports.default = FileUploadComponent;

/***/ }),
/* 278 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MdFileUploadController = function () {
	    MdFileUploadController.$inject = ["$scope", "FileUploader", "Message", "Util", "Loading", "Storage", "Auth", "baseUrl", "$log"];
	    function MdFileUploadController($scope, FileUploader, Message, Util, Loading, Storage, Auth, baseUrl, $log) {
	        'ngInject';
	
	        _classCallCheck(this, MdFileUploadController);
	
	        this.FileUploader = FileUploader;
	        this.Message = Message;
	        this.Util = Util;
	        this.baseUrl = baseUrl;
	        this.Loading = Loading;
	        this.Storage = Storage;
	        this.Auth = Auth;
	        this.$log = $log;
	        this.$scope = $scope;
	
	        this.charset = {
	            'xlsx': ['vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'vnd.openxmlformats'],
	            'xls': 'vnd.ms-excel',
	            'ods': 'x-vnd.oasis.opendocument.spreadsheet',
	            'rar': 'x-rar',
	            'pdf': 'pdf',
	            'csv': ['csv', 'vnd.ms-excel'],
	            'plain': 'plain',
	            'jpg': 'jpg',
	            'png': 'png',
	            'jpeg': 'jpeg',
	            'bmp': 'bmp',
	            'gif': 'gif'
	        };
	    }
	
	    _createClass(MdFileUploadController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            this.idFile = 'file-' + this.Util.id();
	            var log = this.$log;
	
	            var uploader = this.$scope.uploader = new this.FileUploader({
	                url: this.url,
	                alias: this.name || 'file',
	                formData: this.form || []
	            });
	
	            // FILTERS
	
	            uploader.filters.push({
	                name: 'customFilter',
	                fn: function fn() /*item, {File|FileLikeObject}, options*/{
	                    return this.queue.length < 10;
	                }
	            });
	
	            if (this.types) {
	                uploader.filters.push({
	                    name: 'typesFilter',
	                    fn: function fn(item) {
	                        var valid = _this.isType(item, _this.types);
	                        if (!valid) {
	                            _this.Message.warning('Los formatos permitidos son: <strong>' + _this.types.replace(/^\|+|\|+$/gm, '').replace(/\|/, ', ') + '</strong>.', 'Formato de archivo inválido');
	                        }
	                        return valid;
	                    }
	                });
	            }
	
	            this.$log.log('Token', this.Storage.get('token'));
	            uploader.headers.Authorization = 'Bearer ' + this.Storage.get('token');
	
	            // CALLBACKS
	
	            uploader.onWhenAddingFileFailed = function (item /*{File|FileLikeObject}*/, filter, options) {
	                log.info('onWhenAddingFileFailed', item, filter, options);
	            };
	            uploader.onAfterAddingFile = function (fileItem) {
	                if (typeof _this.multiple == 'undefined' && uploader.queue.length > 1) {
	                    uploader.queue = uploader.queue.splice(1);
	                }
	                if (_this.onAfterAddingFile) {
	                    _this.onAfterAddingFile(fileItem);
	                }
	                log.info('onAfterAddingFile', fileItem);
	            };
	            uploader.onAfterAddingAll = function (addedFileItems) {
	                log.info('onAfterAddingAll', addedFileItems);
	            };
	            uploader.onBeforeUploadItem = function (item) {
	                if (_this.onBeforeUploadItem) {
	                    _this.onBeforeUploadItem(item);
	                }
	                for (var i in _this.form) {
	                    if (isNaN(i)) {
	                        var data = {};
	                        data[i] = _this.form[i];
	                        item.formData.push(data);
	                    }
	                }
	                log.info('onBeforeUploadItem', item);
	            };
	            uploader.onProgressItem = function (fileItem, progress) {
	                log.info('onProgressItem', fileItem, progress);
	            };
	            uploader.onProgressAll = function (progress) {
	                log.info('onProgressAll', progress);
	            };
	            uploader.onSuccessItem = function (fileItem, response, status, headers) {
	                log.info('onSuccessItem', fileItem, response, status, headers);
	            };
	            uploader.onErrorItem = function (fileItem, response, status, headers) {
	                log.info('onErrorItem', fileItem, response, status, headers);
	            };
	            uploader.onCancelItem = function (fileItem, response, status, headers) {
	                log.info('onCancelItem', fileItem, response, status, headers);
	            };
	            uploader.onCompleteItem = function (fileItem, response, status, headers) {
	                if (_this.onCompleteItem) {
	                    _this.onCompleteItem(fileItem, response, status, headers, _this.reset);
	                }
	                log.info('onCompleteItem', fileItem, response, status, headers);
	            };
	            uploader.onCompleteAll = function () {
	                if (_this.onCompleteAll) {
	                    _this.onCompleteAll(_this.reset);
	                }
	                log.info('onCompleteAll');
	            };
	        }
	    }, {
	        key: 'isType',
	        value: function isType(item, types) {
	            var type = item.type.slice(item.type.lastIndexOf('/') + 1);
	            var extension = null;
	            if (item.name) {
	                extension = item.name.split('.');
	                extension = extension[extension.length - 1];
	
	                // Hack para firefox que carga un csv con charset text/plain
	                if ((type == 'plain' || type == 'download') && extension == 'csv') {
	                    return true;
	                }
	            }
	
	            for (var i in this.charset) {
	                if (this.Util.toType(this.charset[i]) == 'array') {
	                    var subtypes = this.charset[i];
	                    for (var j in subtypes) {
	                        if (types.indexOf(i) != -1 && type == subtypes[j]) {
	                            return true;
	                        }
	                    }
	                } else {
	                    if (types.indexOf(i) != -1 && type == this.charset[i]) {
	                        return true;
	                    }
	                }
	            }
	
	            return false;
	        }
	    }, {
	        key: 'isImage',
	        value: function isImage(item) {
	            var type = '|' + item.type.slice(item.type.lastIndexOf('/') + 1) + '|';
	            return '|jpg|png|jpeg|bmp|gif|'.indexOf(type) !== -1;
	        }
	    }]);
	
	    return MdFileUploadController;
	}();
	
	exports.default = MdFileUploadController;

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _fileUpload = __webpack_require__(277);
	
	var _fileUpload2 = _interopRequireDefault(_fileUpload);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Components = angular.module('app.fileUpload.component', []).component('uiFileUpload', _fileUpload2.default).directive('ngThumb', ['$window', function ($window) {
	    var helper = {
	        support: !!($window.FileReader && $window.CanvasRenderingContext2D),
	        isFile: function isFile(item) {
	            return angular.isObject(item) && item instanceof $window.File;
	        },
	        isImage: function isImage(file) {
	            var type = '|' + file.type.slice(file.type.lastIndexOf('/') + 1) + '|';
	            return '|jpg|png|jpeg|bmp|gif|'.indexOf(type) !== -1;
	        }
	    };
	
	    return {
	        restrict: 'A',
	        template: '<canvas/>',
	        link: function link(scope, element, attributes) {
	            if (!helper.support) return;
	
	            var params = scope.$eval(attributes.ngThumb);
	
	            if (!helper.isFile(params.file)) return;
	            if (!helper.isImage(params.file)) return;
	
	            var canvas = element.find('canvas');
	            var reader = new window.FileReader();
	
	            reader.onload = onLoadFile;
	            reader.readAsDataURL(params.file);
	
	            function onLoadFile(event) {
	                var img = new window.Image();
	                img.onload = onLoadImage;
	                img.src = event.target.result;
	            }
	
	            function onLoadImage() {
	                var width = params.width || this.width / this.height * params.height;
	                var height = params.height || this.height / this.width * params.width;
	                canvas.attr({ width: width, height: height });
	                canvas[0].getContext('2d').drawImage(this, 0, 0, width, height);
	            }
	        }
	    };
	}]).name;
	
	exports.default = Components;

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _selectDate = __webpack_require__(284);
	
	var _selectDate2 = _interopRequireDefault(_selectDate);
	
	var _selectMunicipio = __webpack_require__(286);
	
	var _selectMunicipio2 = _interopRequireDefault(_selectMunicipio);
	
	var _documentoIdentidad = __webpack_require__(275);
	
	var _documentoIdentidad2 = _interopRequireDefault(_documentoIdentidad);
	
	var _selectParametro = __webpack_require__(288);
	
	var _selectParametro2 = _interopRequireDefault(_selectParametro);
	
	var _uibSelect = __webpack_require__(290);
	
	var _uibSelect2 = _interopRequireDefault(_uibSelect);
	
	var _fileUpload = __webpack_require__(279);
	
	var _fileUpload2 = _interopRequireDefault(_fileUpload);
	
	var _inputFile = __webpack_require__(283);
	
	var _inputFile2 = _interopRequireDefault(_inputFile);
	
	var _archivo = __webpack_require__(273);
	
	var _archivo2 = _interopRequireDefault(_archivo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MaterialModule = angular.module('app.forms', [_fileUpload2.default, _inputFile2.default]).component('selectDate', _selectDate2.default).component('selectMunicipio', _selectMunicipio2.default).component('documentoIdentidad', _documentoIdentidad2.default).component('selectParametro', _selectParametro2.default).component('uibSelect', _uibSelect2.default).component('archivo', _archivo2.default)
	// .component
	.directive('apError', function () {
	  return {
	    restrict: 'A',
	    link: function link($scope, $element) {
	      $element.addClass('form-error');
	      var $parent = angular.element($element.closest('div.form-group'));
	      $scope.$watch(function () {
	        return $element[0].scrollHeight;
	      }, function (newValue) {
	        // $log.log(newValue);
	        $parent.removeClass('has-danger');
	        if (newValue) {
	          $parent.addClass('has-danger');
	        }
	      });
	      $scope.$on('$destroy', function () {
	        $parent.removeClass('has-danger');
	      });
	    }
	  };
	}).name;
	
	exports.default = MaterialModule;

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _inputFile = __webpack_require__(282);
	
	var _inputFile2 = _interopRequireDefault(_inputFile);
	
	var _inputFile3 = __webpack_require__(585);
	
	var _inputFile4 = _interopRequireDefault(_inputFile3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InputFileComponent = {
	    bindings: {
	        onCompleteItem: '=',
	        onCompleteAll: '=',
	        onAfterAddingFile: '=',
	        onBeforeUploadItem: '=',
	        label: '@',
	        labelSubir: '@',
	        textUpload: '@',
	        multiple: '@',
	        maxfiles: '@',
	        types: '@',
	        mimeTypes: '@',
	        name: '@',
	        url: '=',
	        uploadCallback: '<',
	        form: '<',
	        data: '=',
	        maxsize: '@',
	        fileBase64: '=',
	        fileSelect: '='
	    },
	    controller: _inputFile2.default,
	    template: _inputFile4.default
	};
	
	exports.default = InputFileComponent;

/***/ }),
/* 282 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MdFileUploadController = function () {
	    MdFileUploadController.$inject = ["$scope", "FileUploader", "Message", "Util", "Loading", "Storage", "Auth", "baseUrl"];
	    function MdFileUploadController($scope, FileUploader, Message, Util, Loading, Storage, Auth, baseUrl) {
	        'ngInject';
	
	        _classCallCheck(this, MdFileUploadController);
	
	        this.FileUploader = FileUploader;
	        this.Message = Message;
	        this.Util = Util;
	        this.baseUrl = baseUrl;
	        this.Loading = Loading;
	        this.Storage = Storage;
	        this.Auth = Auth;
	        this.$scope = $scope;
	
	        this.charset = {
	            'xlsx': ['vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'vnd.openxmlformats'],
	            'xls': 'vnd.ms-excel',
	            'ods': ['x-vnd.oasis.opendocument.spreadsheet', 'vnd.oasis.opendocument.spreadsheet'],
	            'rar': 'x-rar',
	            'pdf': 'pdf',
	            'csv': ['csv', 'vnd.ms-excel'],
	            'plain': 'plain',
	            'jpg': 'jpg',
	            'png': 'png',
	            'jpeg': 'jpeg',
	            'bmp': 'bmp',
	            'gif': 'gif'
	        };
	    }
	
	    _createClass(MdFileUploadController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            // Flag para verificar si se ha seleccionado o no algún archivo (útil para casos donde se adjunta un archivo)
	            if (!angular.isUndefined(this.fileSelect)) this.fileSelect = false;
	
	            this.idFile = 'file-' + this.Util.id();
	
	            var uploader = this.$scope.uploader = new this.FileUploader({
	                url: this.url,
	                alias: this.name || 'file',
	                formData: this.form || []
	            });
	
	            // FILTERS
	
	            uploader.filters.push({
	                name: 'customFilter',
	                fn: function fn() /*item, {File|FileLikeObject}, options*/{
	                    return this.queue.length < 10;
	                }
	            });
	
	            if (this.types) {
	                uploader.filters.push({
	                    name: 'typesFilter',
	                    fn: function fn(item) {
	                        var valid = _this.isType(item, _this.types);
	                        if (!valid) {
	                            _this.Message.warning(_this.getTypes().message, 'Formato de archivo inválido');
	                        }
	                        return valid;
	                    }
	                });
	            }
	
	            uploader.headers.Authorization = 'Bearer ' + this.Storage.get('token');
	
	            if (this.maxsize) {
	                if (this.maxsize.indexOf('MB') >= 0) {
	                    var s = parseFloat(this.maxsize.replace('MB'));
	                    this.$$maxsize = s ? s * 1024 * 1024 : 20971520;
	                } else if (this.maxsize.indexOf('KB') >= 0) {
	                    var _s = parseFloat(this.maxsize.replace('KB'));
	                    this.$$maxsize = _s ? _s * 1024 : 20971520;
	                }
	                // this.$$maxsize = parseFloat(this.$$maxsize)? parseFloat(this.$$maxsize): parseFloat(this.maxsize)? parseFloat(this.maxsize): 20971520;
	            }
	            // CALLBACKS
	            // uploader.onWhenAddingFileFailed = function(item /*{File|FileLikeObject}*/, filter, options) {
	            //     log.info('onWhenAddingFileFailed', item, filter, options);
	            // };
	            uploader.onAfterAddingFile = function (fileItem) {
	                if (_this.multiple) {
	                    _this.fileBase64 = [];
	                }
	                if (typeof _this.multiple == 'undefined' && uploader.queue.length > 1) {
	                    uploader.queue = uploader.queue.splice(1);
	                }
	                if (_this.onAfterAddingFile) {
	                    _this.onAfterAddingFile(fileItem);
	                }
	                if (_this.$$maxsize && fileItem._file.size > _this.$$maxsize) {
	                    fileItem.remove();
	                    _this.Message.warning('El tamaño del archivo excede al máximo permitido.');
	                    return;
	                }
	                if (!angular.isUndefined(_this.fileSelect)) _this.fileSelect = true;
	                // Convertir archivo a base64
	                var reader = new FileReader();
	                reader.onload = function (loadEvent) {
	                    if (_this.multiple && _this.fileBase64 && _this.fileBase64.length < _this.maxfiles || !_this.multiple) {
	                        // this.$log.log('After11111',this.fileBase64.length, this.maxfiles);
	                        var file = {
	                            nombre: fileItem._file.name,
	                            path: fileItem._file.name,
	                            size: fileItem._file.size,
	                            tipo: fileItem._file.type,
	                            base64: loadEvent.target.result.split(',')[1]
	                        };
	                        if (_this.multiple) {
	                            _this.fileBase64.push(file);
	                        } else {
	                            _this.fileBase64 = file;
	                        }
	                    } else {
	                        fileItem.remove();
	                    }
	                    _this.$scope.$apply();
	                };
	                reader.readAsDataURL(fileItem._file);
	                // log.info('onAfterAddingFile', fileItem);
	            };
	            // uploader.onAfterAddingAll = function(addedFileItems) {
	            //     log.info('onAfterAddingAll', addedFileItems);
	            // };
	            uploader.onBeforeUploadItem = function (item) {
	                if (_this.onBeforeUploadItem) {
	                    _this.onBeforeUploadItem(item);
	                }
	                for (var i in _this.form) {
	                    if (isNaN(i)) {
	                        var data = {};
	                        data[i] = _this.form[i];
	                        item.formData.push(data);
	                    }
	                }
	                // log.info('onBeforeUploadItem', item);
	            };
	            // uploader.onProgressItem = function(fileItem, progress) {
	            //     log.info('onProgressItem', fileItem, progress);
	            // };
	            // uploader.onProgressAll = function(progress) {
	            //     log.info('onProgressAll', progress);
	            // };
	            // uploader.onSuccessItem = function(fileItem, response, status, headers) {
	            //     log.info('onSuccessItem', fileItem, response, status, headers);
	            // };
	            // uploader.onErrorItem = function(fileItem, response, status, headers) {
	            //     log.info('onErrorItem', fileItem, response, status, headers);
	            // };
	            // uploader.onCancelItem = function(fileItem, response, status, headers) {
	            //     log.info('onCancelItem', fileItem, response, status, headers);
	            // };
	            uploader.onCompleteItem = function (fileItem, response, status, headers) {
	                if (_this.onCompleteItem) {
	                    _this.onCompleteItem(fileItem, response, status, headers, _this.reset);
	                }
	                // log.info('onCompleteItem', fileItem, response, status, headers);
	            };
	            uploader.onCompleteAll = function () {
	                if (_this.onCompleteAll) {
	                    _this.onCompleteAll(_this.reset);
	                }
	                // log.info('onCompleteAll');
	            };
	        }
	    }, {
	        key: 'getTypes',
	        value: function getTypes() {
	            var types = this.Util.limpiarEspaciosDobles(this.types).split('|');
	            return {
	                types: types,
	                message: types.length > 1 ? 'Los formatos permitidos son: <strong>' + types.join(', ') + '</strong>' : 'El formato permitido es: <strong>' + types.join(', ') + '</strong>'
	            };
	        }
	    }, {
	        key: 'isType',
	        value: function isType(item, types) {
	            var type = item.type.slice(item.type.lastIndexOf('/') + 1);
	            var extension = null;
	            if (item.name) {
	                extension = item.name.split('.');
	                extension = extension[extension.length - 1];
	
	                // Hack para firefox que carga un csv con charset text/plain
	                if ((type == 'plain' || type == 'download') && extension == 'csv') {
	                    return true;
	                }
	            }
	
	            for (var i in this.charset) {
	                if (this.Util.toType(this.charset[i]) == 'array') {
	                    var subtypes = this.charset[i];
	                    for (var j in subtypes) {
	                        if (types.indexOf(i) != -1 && type == subtypes[j]) {
	                            return true;
	                        }
	                    }
	                } else {
	                    if (types.indexOf(i) != -1 && type == this.charset[i]) {
	                        return true;
	                    }
	                }
	            }
	
	            return false;
	        }
	    }, {
	        key: 'isImage',
	        value: function isImage(item) {
	            var type = '|' + item.type.slice(item.type.lastIndexOf('/') + 1) + '|';
	            return '|jpg|png|jpeg|bmp|gif|'.indexOf(type) !== -1;
	        }
	
	        // Mis modificaciones
	
	    }, {
	        key: 'clearQueue',
	        value: function clearQueue(uploader) {
	            this.fileBase64 = this.multiple ? [] : null;
	            uploader.clearQueue();
	        }
	    }, {
	        key: 'remove',
	        value: function remove(item) {
	            if (!this.multiple) {
	                this.fileBase64 = null;
	                item.remove();
	                return;
	            }
	            var cant = this.fileBase64.length;
	            for (var i = 0; i < cant; i++) {
	                var file = this.fileBase64.shift();
	                if (file.size != item._file.size && file.name != item._file.name) {
	                    this.fileBase64.push(file);
	                }
	            }
	            if (!angular.isUndefined(this.fileSelect)) this.fileSelect = false;
	            item.remove();
	        }
	    }, {
	        key: 'upload',
	        value: function upload() {
	            if (!this.multiple) {
	                this.fileBase64.name = this.name;
	                this.uploadCallback(this.fileBase64);
	            }
	        }
	    }]);
	
	    return MdFileUploadController;
	}();
	
	exports.default = MdFileUploadController;

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _inputFile = __webpack_require__(281);
	
	var _inputFile2 = _interopRequireDefault(_inputFile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Components = angular.module('app.fileUploadInfo.component', []).component('uiInputFile', _inputFile2.default).directive('ngThumbInfo', ['$window', function ($window) {
	    var helper = {
	        support: !!($window.FileReader && $window.CanvasRenderingContext2D),
	        isFile: function isFile(item) {
	            return angular.isObject(item) && item instanceof $window.File;
	        },
	        isImage: function isImage(file) {
	            var type = '|' + file.type.slice(file.type.lastIndexOf('/') + 1) + '|';
	            return '|jpg|png|jpeg|bmp|gif|'.indexOf(type) !== -1;
	        }
	    };
	
	    return {
	        restrict: 'A',
	        template: '<canvas/>',
	        link: function link(scope, element, attributes) {
	            if (!helper.support) return;
	
	            var params = scope.$eval(attributes.ngThumb);
	
	            if (!helper.isFile(params.file)) return;
	            if (!helper.isImage(params.file)) return;
	
	            var canvas = element.find('canvas');
	            var reader = new window.FileReader();
	
	            reader.onload = onLoadFile;
	            reader.readAsDataURL(params.file);
	
	            function onLoadFile(event) {
	                var img = new window.Image();
	                img.onload = onLoadImage;
	                img.src = event.target.result;
	            }
	
	            function onLoadImage() {
	                var width = params.width || this.width / this.height * params.height;
	                var height = params.height || this.height / this.width * params.width;
	                canvas.attr({ width: width, height: height });
	                canvas[0].getContext('2d').drawImage(this, 0, 0, width, height);
	            }
	        }
	    };
	}]).name;
	
	exports.default = Components;

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _selectDate = __webpack_require__(285);
	
	var _selectDate2 = _interopRequireDefault(_selectDate);
	
	var _selectDate3 = __webpack_require__(586);
	
	var _selectDate4 = _interopRequireDefault(_selectDate3);
	
	__webpack_require__(162);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var selectDateComponent = {
	    bindings: {
	        ngModel: '=',
	        ngRequired: '<',
	        label: '@',
	        ngDisabled: '<'
	    },
	    controller: _selectDate2.default,
	    template: _selectDate4.default
	};
	
	exports.default = selectDateComponent;

/***/ }),
/* 285 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SelectDateController = function () {
	  SelectDateController.$inject = ["$scope", "$log", "Datetime"];
	  function SelectDateController($scope, $log, Datetime) {
	    'ngInject';
	
	    _classCallCheck(this, SelectDateController);
	
	    this.$scope = $scope;
	    this.$log = $log;
	    this.Datetime = Datetime;
	  }
	
	  _createClass(SelectDateController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      // this.$log.log('SelectDateController init');
	      // this.$log.log(this);
	      this.nowYear = new Date().getUTCFullYear();
	      this.$scope.$watch('$ctrl.ngModel', function () {
	        // this.$log.log('date', this.ngModel)
	        if (angular.isUndefined(_this.ngModel)) {
	          _this.day = null;
	          _this.month = null;
	          _this.year = null;
	        } else {
	          if (!_this.internal_change) {
	            var date = _this.ngModel;
	            if (typeof date == 'string') {
	              date = new Date(date);
	              _this.ngModel = new Date(_this.ngModel);
	            }
	            if (_this.Datetime.isDate(date)) {
	              _this.day = date.getUTCDate();
	              _this.month = date.getUTCMonth() + 1;
	              _this.year = date.getUTCFullYear();
	            }
	          }
	          delete _this.internal_change;
	        }
	      });
	      this.initMonths();
	    }
	  }, {
	    key: 'initMonths',
	    value: function initMonths() {
	      var months = [];
	      for (var i = 0; i < 12; i++) {
	        months.push({
	          val: i + 1,
	          name: this.Datetime.months[i]
	        });
	      }
	      this.months = months;
	    }
	  }, {
	    key: 'changeDate',
	    value: function changeDate(prop) {
	      if (prop == 'day') {
	        if (!(0 < this.day && this.day < 32)) {
	          this.day = null;
	        }
	      }
	      // if (prop=='month') {
	      //
	      // }
	      if (prop == 'year') {
	        // this.$log.log('year', angular.copy(this.year))
	        if (this.year < this.nowYear - 120) {
	          this.year = null;
	        }
	        if (this.year > this.nowYear) {
	          this.year = null;
	        }
	        // this.$log.log('year', angular.copy(this.year))
	      }
	      if (this.year && this.month && this.day) {
	        this.internal_change = true;
	        this.ngModel = new Date(this.year, this.month - 1, this.day);
	      }
	    }
	  }]);
	
	  return SelectDateController;
	}();
	
	exports.default = SelectDateController;

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _selectMunicipio = __webpack_require__(287);
	
	var _selectMunicipio2 = _interopRequireDefault(_selectMunicipio);
	
	var _selectMunicipio3 = __webpack_require__(587);
	
	var _selectMunicipio4 = _interopRequireDefault(_selectMunicipio3);
	
	__webpack_require__(163);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var selectMunicipioComponent = {
	    bindings: {
	        departamento: '=',
	        provincia: '=',
	        municipio: '=',
	        conf: '<'
	    },
	    controller: _selectMunicipio2.default,
	    template: _selectMunicipio4.default
	};
	
	exports.default = selectMunicipioComponent;

/***/ }),
/* 287 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SelectMunicipioController = function () {
	  SelectMunicipioController.$inject = ["$scope", "$log", "DataService"];
	  function SelectMunicipioController($scope, $log, DataService) {
	    'ngInject';
	
	    _classCallCheck(this, SelectMunicipioController);
	
	    this.$scope = $scope;
	    this.$log = $log;
	    this.DataService = DataService;
	  }
	
	  _createClass(SelectMunicipioController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      // this.$log.log(this);
	
	      this.departamentosLoad();
	      this.init_provincias = this.provincia;
	      this.init_municipios = this.municipio;
	      this.$scope.$watch('$ctrl.departamento', function () {
	        // this.$log.log('departamentoChange', this);
	        if (_this.departamento) {
	          _this.provinciasLoad();
	        }
	      });
	      this.$scope.$watch('$ctrl.provincia', function () {
	        if (_this.provincia) {
	          _this.municipiosLoad();
	        }
	      });
	    }
	  }, {
	    key: 'departamentosLoad',
	    value: function departamentosLoad() {
	      var _this2 = this;
	
	      this.departamentos = [];
	      this.provincias = [];
	      this.municipios = [];
	
	      this.DataService.get('departamento').then(function (response) {
	        if (response) {
	          _this2.departamentos = response;
	        }
	      });
	    }
	  }, {
	    key: 'provinciasLoad',
	    value: function provinciasLoad() {
	      var _this3 = this;
	
	      this.provincias = [];
	      this.municipios = [];
	      if (!this.init_provincias) {
	        delete this.provincia;
	        delete this.municipio;
	      }
	      this.init_provincias = !1;
	
	      this.DataService.get('provincia/departamento/' + this.departamento).then(function (response) {
	        if (response) {
	          _this3.provincias = response;
	        }
	      });
	    }
	  }, {
	    key: 'municipiosLoad',
	    value: function municipiosLoad() {
	      var _this4 = this;
	
	      this.municipios = [];
	      if (!this.init_municipios) {
	        delete this.municipio;
	      }
	      this.init_municipios = !1;
	      this.DataService.get('municipio/provincia/' + this.provincia).then(function (response) {
	        if (response) {
	          _this4.municipios = response;
	        }
	      });
	    }
	  }]);
	
	  return SelectMunicipioController;
	}();
	
	exports.default = SelectMunicipioController;

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _selectParametro = __webpack_require__(289);
	
	var _selectParametro2 = _interopRequireDefault(_selectParametro);
	
	var _selectParametro3 = __webpack_require__(588);
	
	var _selectParametro4 = _interopRequireDefault(_selectParametro3);
	
	__webpack_require__(164);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var selectParametroComponent = {
	    bindings: {
	        ngModel: '=',
	        name: '@',
	        ngRequired: '<',
	        ngDisabled: '<',
	        ngChange: '&',
	        parametro: '@',
	        query: '@',
	        selectModel: '=',
	        label: '@',
	        opcional: '@'
	    },
	    controller: _selectParametro2.default,
	    template: _selectParametro4.default
	};
	
	exports.default = selectParametroComponent;

/***/ }),
/* 289 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SelectParametroController = function () {
	  SelectParametroController.$inject = ["DataService", "$log", "$scope"];
	  function SelectParametroController(DataService, $log, $scope) {
	    'ngInject';
	
	    _classCallCheck(this, SelectParametroController);
	
	    this.DataService = DataService;
	    this.$log = $log;
	    this.$scope = $scope;
	  }
	
	  _createClass(SelectParametroController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      var url = 'parametricas/' + this.parametro;
	      if (this.query) url += this.query;
	      this.DataService.get(url).then(function (response) {
	        _this.items = response.datos.rows;
	
	        //si es opcional aniadimos un valor al combo que sera la bandera para no validar demas eventos
	        var isTrueSet = _this.opcional === 'true';
	        if (isTrueSet) {
	          _this.$log.log(' OPCIONAL***: ');
	          _this.items.unshift({
	            descripcion: 'Sin valor',
	            nombre: 'Ninguno',
	            codigo: 'NN'
	          });
	        }
	      });
	
	      this.$scope.$watch('$ctrl.ngModel', function (newValue, oldValue) {
	        if (angular.toJson(newValue) != angular.toJson(oldValue)) {
	          _this.ngChange();
	        }
	      });
	    }
	  }]);
	
	  return SelectParametroController;
	}();
	
	exports.default = SelectParametroController;

/***/ }),
/* 290 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var MdSelectComponent = {
	    bindings: {
	        label: '@',
	        required: '@',
	        disabled: '@',
	        ngRequired: '<',
	        ngDisabled: '<',
	        ngModel: '=',
	        ngModelOptions: '<',
	        items: '<',
	        groupBy: '@',
	        keyText: '@',
	        keyValue: '@',
	        ngTitle: '@',
	        placeholder: '@'
	    },
	    template: '\n    <div class="form-group" ng-if="!$ctrl.keyValue">\n        <label for="input" ng-if="$ctrl.label" ng-class="{\'ap-req\':$ctrl.required||$ctrl.ngRequired}">{{ $ctrl.label }}</label>\n        <ui-select\n            ng-model="$ctrl.ngModel"\n            theme="bootstrap"\n            ng-required="$ctrl.required || $ctrl.ngRequired"\n            ng-disabled="$ctrl.disabled || $ctrl.ngDisabled"\n            title="{{ $ctrl.ngTitle || \'Seleccione un item\' }}">\n            <ui-select-match placeholder="{{ $ctrl.placeholder || \'Seleccione o busque un item de la lista...\' }}">\n                {{$select.selected[$ctrl.keyText||\'text\']}}\n            </ui-select-match>\n            <ui-select-choices group-by="$ctrl.groupBy" repeat="item in $ctrl.items | filter: $select.search">\n                <span ng-bind-html="item[$ctrl.keyText||\'text\'] | highlight: $select.search"></span>\n                <small ng-bind-html="item.code | highlight: $select.search"></small>\n            </ui-select-choices>\n        </ui-select>\n    </div>\n    <div class="form-group" ng-if="$ctrl.keyValue">\n        <label for="input" ng-if="$ctrl.label" ng-class="{\'ap-req\':$ctrl.required||$ctrl.ngRequired}">{{ $ctrl.label }}</label>\n        <ui-select\n            ng-model="$ctrl.ngModel"\n            theme="bootstrap"\n            ng-required="$ctrl.required || $ctrl.ngRequired"\n            ng-disabled="$ctrl.disabled || $ctrl.ngDisabled"\n            title="{{ $ctrl.ngTitle || \'Seleccione un item\' }}">\n            <ui-select-match placeholder="{{ $ctrl.placeholder || \'Seleccione o busque un item de la lista...\' }}">\n                {{$select.selected[$ctrl.keyText||\'text\']}}\n            </ui-select-match>\n            <ui-select-choices group-by="$ctrl.groupBy" repeat="item[$ctrl.keyValue] as item in $ctrl.items | filter: $select.search">\n                <span ng-bind-html="item[$ctrl.keyText||\'text\'] | highlight: $select.search"></span>\n                <small ng-bind-html="item.code | highlight: $select.search"></small>\n            </ui-select-choices>\n        </ui-select>\n    </div>\n    '
	};
	
	exports.default = MdSelectComponent;

/***/ }),
/* 291 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var HelpService = function () {
	    HelpService.$inject = ["$window", "$document", "$compile"];
	    function HelpService($window, $document, $compile) {
	        'ngInject';
	
	        _classCallCheck(this, HelpService);
	
	        this.$window = $window;
	        this.$document = $document;
	        this.$compile = $compile;
	
	        this.template = '\n            <div class="ui-help-content">\n                <div class="ui-help-header">\n                    <i class="fa fa-question-circle"></i> <span class="ui-help-title"></span>\n                    <hr>\n                </div>\n                <div class="ui-help-body"><span class="ui-help-message"></span></div>\n            </div>';
	
	        this.fadeSleep = 500;
	    }
	
	    _createClass(HelpService, [{
	        key: '$onInit',
	        value: function $onInit() {}
	    }, {
	        key: 'renderSleep',
	        value: function renderSleep(el) {
	            setTimeout(function () {
	                el.remove();
	            }, this.fadeSleep);
	        }
	    }, {
	        key: 'fadeOut',
	        value: function fadeOut(el) {
	            el.style.opacity = 1;
	
	            (function fade() {
	                if ((el.style.opacity -= .1) < 0) {
	                    el.style.display = "none";
	                } else {
	                    window.requestAnimationFrame(fade);
	                }
	            })();
	        }
	    }, {
	        key: 'fadeIn',
	        value: function fadeIn(el, display) {
	            el.style.opacity = 0;
	            el.style.display = display || "block";
	
	            (function fade() {
	                var val = parseFloat(el.style.opacity);
	
	                if (!((val += .1) > 1)) {
	                    el.style.opacity = val;
	                    window.requestAnimationFrame(fade);
	                }
	            })();
	        }
	    }, {
	        key: 'render',
	        value: function render($scope, title, message, idHelp, positionIn, classNew, width, fade) {
	            var _this = this;
	
	            if (fade) {
	                var helps = document.querySelectorAll('.ui-help-content');
	                if (helps.length) {
	                    for (var i in helps) {
	                        if (helps[i].classList) {
	                            this.fadeOut(helps[i]);
	                            this.renderSleep(helps[i]);
	                        }
	                    }
	                }
	            } else {
	                angular.element(document.querySelectorAll('.ui-help-content')).remove();
	            }
	            var element = angular.element(this.template)[0];
	            if (classNew) {
	                element.classList.add(classNew);
	            }
	            angular.element(document.body).append(element);
	            if (fade) {
	                element.classList.add('fade');
	                this.fadeIn(element);
	            }
	
	            if (typeof title != 'boolean') {
	                element.querySelector('.ui-help-title').innerHTML = title || 'Ayuda';
	            }
	            var content = this.$compile('<div>' + (message || 'Texto de ayuda') + '</div>')($scope);
	            angular.element(element.querySelector('.ui-help-message')).append(content);
	            var height = element.clientHeight;
	            if (width) {
	                element.style.width = width + 'px';
	            } else {
	                width = element.clientWidth;
	            }
	
	            if (idHelp === undefined || idHelp === null) {
	                element.classList.add('ui-help-center');
	                element.style.marginTop = -1 * (height / 2) - 20 + 'px';
	                element.style.marginLeft = -1 * (width / 2) + 'px';
	            } else {
	
	                this.renderPosition(element, idHelp, positionIn, height, width);
	
	                window.addEventListener('resize', function () {
	                    _this.renderPosition(element, idHelp, positionIn, height, width);
	                });
	            }
	
	            return element;
	        }
	    }, {
	        key: 'renderPosition',
	        value: function renderPosition(element, idHelp, positionIn, height, width) {
	            var position = null;
	            if (typeof idHelp == 'string') {
	                var elem = document.getElementById(idHelp);
	                if (elem) {
	                    position = elem.getBoundingClientRect();
	                } else {
	                    return false;
	                }
	            } else {
	                position = idHelp.getBoundingClientRect();
	            }
	            var heightWindow = this.$window.innerHeight;
	            var widthWindow = this.$window.innerWidth;
	            var posInitial = position;
	            var className = '';
	            var direction = positionIn || 'right';
	
	            if (direction == 'top') {
	                position = this.top(posInitial, height, width);
	                if (position.top < 0) {
	                    direction = 'bottom';
	                }
	            }
	            if (direction == 'right') {
	                position = this.right(posInitial, height);
	                if (position.left + width > widthWindow) {
	                    direction = 'left';
	                }
	            }
	            if (direction == 'bottom') {
	                position = this.bottom(posInitial, width);
	                if (position.top + height > heightWindow) {
	                    direction = 'top';
	                    position = this.top(posInitial, height, width);
	                }
	            }
	            if (direction == 'left') {
	                position = this.left(posInitial, height, width);
	                if (position.left < 0) {
	                    direction = 'right';
	                    position = this.right(posInitial, height);
	                }
	            }
	
	            className = direction;
	
	            if (direction == 'top') {
	                if (position.left + width > widthWindow) {
	                    position = this.top_left(posInitial, height, width);
	                    className = 'top-left';
	                } else {
	                    if (position.left < 0) {
	                        position = this.top_right(posInitial, height, width);
	                        className = 'top-right';
	                    }
	                }
	            }
	
	            if (direction == 'right') {
	                if (position.top + height > heightWindow) {
	                    position = this.right_top(posInitial, height);
	                    className = 'right-top';
	                } else {
	                    if (position.top < 0) {
	                        position = this.right_bottom(posInitial, width);
	                        className = 'right-bottom';
	                    }
	                }
	            }
	
	            if (direction == 'bottom') {
	                if (position.left + width > widthWindow) {
	                    position = this.bottom_left(posInitial, width);
	                    className = 'bottom-left';
	                } else {
	                    if (position.left < 0) {
	                        position = this.bottom_right(posInitial);
	                        className = 'bottom-right';
	                    }
	                }
	            }
	
	            if (direction == 'left') {
	                if (position.top + height > heightWindow) {
	                    position = this.left_top(posInitial, height, width);
	                    className = 'left-top';
	                } else {
	                    if (position.top < 0) {
	                        position = this.left_bottom(posInitial, width);
	                        className = 'left-bottom';
	                    }
	                }
	            }
	
	            // console.log('H:', height, 'W:', width, 'HW', heightWindow, 'WW', widthWindow);
	            // console.log('INITIAL:', posInitial, 'END:', position, 'POSITION', className, 'ELEMENT', element);
	
	            element.classList.remove('top');
	            element.classList.remove('right');
	            element.classList.remove('bottom');
	            element.classList.remove('left');
	            element.classList.remove('top-left');
	            element.classList.remove('top-right');
	            element.classList.remove('right-top');
	            element.classList.remove('right-bottom');
	            element.classList.remove('bottom-left');
	            element.classList.remove('bottom-right');
	            element.classList.remove('left-top');
	            element.classList.remove('left-bottom');
	            element.classList.add(className);
	            element.style.top = position.top + 'px';
	            element.style.left = position.left + 'px';
	        }
	    }, {
	        key: 'destroy',
	        value: function destroy(element, fade) {
	            if (element) {
	                if (fade) {
	                    this.fadeOut(element);
	                    setTimeout(function () {
	                        element.remove();
	                    }, this.fadeSleep);
	                } else {
	                    element.remove();
	                }
	            }
	        }
	    }, {
	        key: 'top',
	        value: function top(position, height, width) {
	            return {
	                top: position.top - height - 12,
	                left: position.left - (width / 2 - position.width / 2)
	            };
	        }
	    }, {
	        key: 'top_right',
	        value: function top_right(position, height) {
	            return {
	                top: position.top - height - 12,
	                left: position.left + position.width / 2 - 20
	            };
	        }
	    }, {
	        key: 'top_left',
	        value: function top_left(position, height, width) {
	            return {
	                top: position.top - height - 12,
	                left: position.left + position.width / 2 + 20 - width
	            };
	        }
	    }, {
	        key: 'right',
	        value: function right(position, height) {
	            return {
	                top: position.top - (height / 2 - position.height / 2),
	                left: position.left + position.width + 12
	            };
	        }
	    }, {
	        key: 'right_top',
	        value: function right_top(position, height) {
	            return {
	                top: position.top + position.height / 2 - height + 20,
	                left: position.left + position.width + 12
	            };
	        }
	    }, {
	        key: 'right_bottom',
	        value: function right_bottom(position) {
	            return {
	                top: position.top + position.height / 2 - 20,
	                left: position.left + position.width + 12
	            };
	        }
	    }, {
	        key: 'bottom',
	        value: function bottom(position, width) {
	            return {
	                top: position.top + position.height + 12,
	                left: position.left - (width / 2 - position.width / 2)
	            };
	        }
	    }, {
	        key: 'bottom_right',
	        value: function bottom_right(position) {
	            return {
	                top: position.top + position.height + 12,
	                left: position.left + position.width / 2 - 20
	            };
	        }
	    }, {
	        key: 'bottom_left',
	        value: function bottom_left(position, width) {
	            return {
	                top: position.top + position.height + 12,
	                left: position.left + position.width / 2 + 20 - width
	            };
	        }
	    }, {
	        key: 'left',
	        value: function left(position, height, width) {
	            return {
	                top: position.top - (height / 2 - position.height / 2),
	                left: position.left - width - 12
	            };
	        }
	    }, {
	        key: 'left_top',
	        value: function left_top(position, height, width) {
	            return {
	                top: position.top + position.height / 2 - height + 20,
	                left: position.left - width - 12
	            };
	        }
	    }, {
	        key: 'left_bottom',
	        value: function left_bottom(position, width) {
	            return {
	                top: position.top + position.height / 2 - 20,
	                left: position.left - width - 12
	            };
	        }
	    }]);
	
	    return HelpService;
	}();
	
	exports.default = HelpService;

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _help = __webpack_require__(293);
	
	var _help2 = _interopRequireDefault(_help);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var help = {
	    bindings: {
	        message: '<',
	        title: '<',
	        position: '@',
	        direction: '@',
	        idHelp: '@'
	    },
	    template: '\n        <span class="ui-help" ng-if="$ctrl.message" id-help ng-mouseover="$ctrl.hoverIn()" ng-mouseleave="$ctrl.hoverOut()">\n            <i class="fa fa-question-circle"></i>\n        </span>\n    ',
	    controller: _help2.default
	};
	
	exports.default = help;

/***/ }),
/* 293 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var HelpComponent = function () {
	    HelpComponent.$inject = ["$scope", "$rootScope", "HelpPopup"];
	    function HelpComponent($scope, $rootScope, HelpPopup) {
	        'ngInject';
	
	        _classCallCheck(this, HelpComponent);
	
	        this.$rootScope = $rootScope;
	        this.HelpPopup = HelpPopup;
	        this.$scope = $scope;
	    }
	
	    _createClass(HelpComponent, [{
	        key: '$onInit',
	        value: function $onInit() {
	
	            this.$element = null;
	
	            this.idHelp = null;
	
	            this.$rootScope.$on('$stateChangeStart', function () /*event, toState, toParams, fromState, fromParams*/{
	                if (this.$element) {
	                    this.$element.remove();
	                }
	            });
	        }
	    }, {
	        key: 'hoverIn',
	        value: function hoverIn() {
	            this.$element = this.HelpPopup.render(this.$scope, this.title, this.message, this.idHelp, this.position || this.direction);
	        }
	    }, {
	        key: 'hoverOut',
	        value: function hoverOut() {
	            this.HelpPopup.destroy(this.$element);
	        }
	    }]);
	
	    return HelpComponent;
	}();
	
	exports.default = HelpComponent;

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _help = __webpack_require__(292);
	
	var _help2 = _interopRequireDefault(_help);
	
	var _helpPopup = __webpack_require__(291);
	
	var _helpPopup2 = _interopRequireDefault(_helpPopup);
	
	var _tourHelp = __webpack_require__(297);
	
	var _tourHelp2 = _interopRequireDefault(_tourHelp);
	
	__webpack_require__(165);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HelpModule = angular.module('angular-help', [_tourHelp2.default]).directive('idHelp', ['Util', function (Util) {
	    return {
	        link: function link(scope, element /*, attrs*/) {
	            var id = 'ui-help-' + Util.id();
	            element[0].setAttribute('id', id);
	            scope.$ctrl.idHelp = id;
	        }
	    };
	}]).service('HelpPopup', _helpPopup2.default).component('uiHelp', _help2.default).name;
	
	exports.default = HelpModule;

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _tourHelp = __webpack_require__(296);
	
	var _tourHelp2 = _interopRequireDefault(_tourHelp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Tourhelp = {
	    bindings: {
	        tour: '<',
	        tourEnd: '<',
	        tourLabel: '<'
	    },
	    template: '',
	    controller: _tourHelp2.default
	};
	
	exports.default = Tourhelp;

/***/ }),
/* 296 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TourHelpController = function () {
	    TourHelpController.$inject = ["$scope", "$rootScope", "$window", "$document", "HelpPopup"];
	    function TourHelpController($scope, $rootScope, $window, $document, HelpPopup) {
	        'ngInject';
	
	        _classCallCheck(this, TourHelpController);
	
	        this.$scope = $scope;
	        this.$rootScope = $rootScope;
	        this.$window = $window;
	        this.$document = $document;
	        this.HelpPopup = HelpPopup;
	    }
	
	    _createClass(TourHelpController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.$element = null;
	            this.position = 0;
	
	            this.tmplFinish = '<button class="btn btn-primary" ng-click="$ctrl.finish()"><i class="fa fa-check-circle"></i> ' + (this.tourLabel && this.tourLabel.end ? this.tourLabel.end : 'Terminar') + '</button>';
	
	            if (this.tour && this.tour.length) {
	                this.step();
	            }
	        }
	    }, {
	        key: 'renderButton',
	        value: function renderButton(setting) {
	            return ['<button type="button" class="btn ' + (setting.className || '') + '" ng-click="' + (setting.onClick || '') + '">', setting.icon && setting.icon.length ? '<i class="fa fa-' + setting.icon + '"></i>' : '', setting.label, '</button>'].join(' ');
	        }
	    }, {
	        key: 'step',
	        value: function step() {
	            var buttons = '<div class="tour-help-buttons">';
	            if (this.position > 0 && (this.tour[this.position].btnPrev === undefined || this.tour[this.position].btnPrev)) {
	                buttons += this.renderButton({
	                    label: this.tour[this.position].labelPrev || 'Anterior',
	                    icon: this.tour[this.position].iconPrev || 'angle-double-left',
	                    className: this.tour[this.position].classPrev || '',
	                    onClick: '$ctrl.prev()'
	                });
	            }
	            if (this.position < this.tour.length - 1 && (this.tour[this.position].btnNext === undefined || this.tour[this.position].btnNext)) {
	                buttons += this.renderButton({
	                    label: this.tour[this.position].labelNext || 'Siguiente',
	                    icon: this.tour[this.position].iconNext || 'angle-double-right',
	                    className: this.tour[this.position].classNext || '',
	                    onClick: '$ctrl.next()'
	                });
	            }
	            if (this.tour[this.position].btnFinish === undefined || this.tour[this.position].btnFinish) {
	                buttons += this.tmplFinish;
	            }
	            buttons += '</div>';
	            this.$element = this.HelpPopup.render(this.$scope, this.tour[this.position].title, this.tour[this.position].text + buttons, this.tour[this.position].id, this.tour[this.position].position || 'bottom', 'tour-popup', this.tour[this.position].width, true);
	            if (this.$element) {
	                this.drawBackdrop(this.tour[this.position].id, this.$element);
	            }
	        }
	    }, {
	        key: 'next',
	        value: function next() {
	            var _this = this;
	
	            if (typeof this.tour[this.position].next == 'function') {
	                this.tour[this.position].next();
	            }
	            this.position++;
	            setTimeout(function () {
	                _this.step();
	            }, this.tour[this.position].sleepShow || 0);
	        }
	    }, {
	        key: 'prev',
	        value: function prev() {
	            var _this2 = this;
	
	            if (typeof this.tour[this.position].prev == 'function') {
	                this.tour[this.position].prev();
	            }
	            this.position--;
	            setTimeout(function () {
	                _this2.step();
	            }, this.tour[this.position].sleepPrev || 0);
	        }
	    }, {
	        key: 'finish',
	        value: function finish() {
	            if (typeof this.tourEnd == 'function') {
	                this.tourEnd();
	            }
	            this.HelpPopup.destroy(this.$element, true);
	            this.destroyBackdrop();
	        }
	    }, {
	        key: 'destroyBackdrop',
	        value: function destroyBackdrop() {
	            angular.element(document.querySelectorAll('.tour-help-backdrop')).remove();
	        }
	    }, {
	        key: 'drawBackdrop',
	        value: function drawBackdrop(id, $help) {
	            var _this3 = this;
	
	            this.destroyBackdrop();
	
	            if (id) {
	                var pos = this.getPosition(id, $help);
	
	                this.createDiv(pos.top, 'top');
	                this.createDiv(pos.right, 'right');
	                this.createDiv(pos.bottom, 'bottom');
	                this.createDiv(pos.left, 'left');
	                this.createDiv({
	                    top: this.transform(pos.elem.top - pos.body.top),
	                    left: this.transform(pos.elem.left),
	                    height: this.transform(pos.elem.height),
	                    width: this.transform(pos.elem.width)
	                }, 'tour-transparent');
	
	                window.addEventListener('resize', function () {
	                    var pos = _this3.getPosition(id, $help);
	                    if (pos) {
	                        _this3.changePosition(pos.top, 'top');
	                        _this3.changePosition(pos.right, 'right');
	                        _this3.changePosition(pos.bottom, 'bottom');
	                        _this3.changePosition(pos.left, 'left');
	                        _this3.changePosition({
	                            top: _this3.transform(pos.elem.top - pos.body.top),
	                            left: _this3.transform(pos.elem.left),
	                            height: _this3.transform(pos.elem.height),
	                            width: _this3.transform(pos.elem.width)
	                        }, 'tour-transparent');
	                    }
	                });
	            } else {
	                var body = document.body.getBoundingClientRect();
	                this.createDiv({
	                    top: 0,
	                    left: 0,
	                    height: this.transform(body.height),
	                    width: this.transform(body.width)
	                }, 'tour-transparent-center');
	
	                window.addEventListener('resize', function () {
	                    var body = document.body.getBoundingClientRect();
	                    _this3.changePosition({
	                        top: 0,
	                        left: 0,
	                        height: _this3.transform(body.height),
	                        width: _this3.transform(body.width)
	                    }, 'tour-transparent-center');
	                });
	            }
	        }
	    }, {
	        key: 'getPosition',
	        value: function getPosition(id, $help) {
	            var body = document.body.getBoundingClientRect();
	            var elem = null;
	            if (typeof id == 'string' && id.length) {
	                elem = document.querySelector('#' + id);
	                if (elem) {
	                    elem = elem.getBoundingClientRect();
	                } else {
	                    return false;
	                }
	            } else {
	                elem = id.getBoundingClientRect();
	            }
	
	            var position = {
	                elem: elem,
	                body: body
	            };
	
	            position.top = {
	                top: 0,
	                left: 0,
	                height: this.transform(elem.top - body.top),
	                width: this.transform(body.width)
	            };
	            position.right = {
	                top: this.transform(elem.top - body.top),
	                left: this.transform(elem.right),
	                height: this.transform(elem.height),
	                width: this.transform(body.width - elem.right)
	            };
	            position.bottom = {
	                top: this.transform(elem.top + elem.height - body.top),
	                left: this.transform(0),
	                height: this.transform(body.height - (elem.top + elem.height - body.top)),
	                width: this.transform(body.width)
	            };
	            position.left = {
	                top: this.transform(elem.top - body.top),
	                left: this.transform(0),
	                height: this.transform(elem.height),
	                width: this.transform(elem.left)
	            };
	
	            if (elem.top + elem.height > body.height) {
	                var scrollY = elem.top + elem.height - body.height;
	                $help.css('top', parseInt($help.css('top')) - (scrollY + 30));
	                window.scrollTo(0, scrollY + 30 - body.top);
	                // bottom.height = this.transform(30);
	            }
	
	            return position;
	        }
	    }, {
	        key: 'transform',
	        value: function transform(number) {
	            return parseFloat(number).toFixed(2) + "px";
	        }
	    }, {
	        key: 'changePosition',
	        value: function changePosition(css, className) {
	            this.setCss(document.querySelector('.tour-help-backdrop.' + className), css);
	        }
	    }, {
	        key: 'createDiv',
	        value: function createDiv(css, className) {
	            var div = document.createElement('div');
	            div.className = "tour-help-backdrop";
	            if (className) {
	                div.classList.add(className);
	            }
	            this.setCss(div, css);
	            document.body.appendChild(div);
	        }
	    }, {
	        key: 'setCss',
	        value: function setCss(obj, data) {
	            if (obj) {
	                for (var i in data) {
	                    obj.style[i] = data[i];
	                }
	            }
	        }
	    }]);
	
	    return TourHelpController;
	}();
	
	exports.default = TourHelpController;

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _tourHelp = __webpack_require__(295);
	
	var _tourHelp2 = _interopRequireDefault(_tourHelp);
	
	__webpack_require__(166);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TourHelpModule = angular.module('angular-tour-help', []).component('uiTourHelp', _tourHelp2.default).name;
	
	exports.default = TourHelpModule;

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _mdInput = __webpack_require__(300);
	
	var _mdInput2 = _interopRequireDefault(_mdInput);
	
	var _mdTextarea = __webpack_require__(303);
	
	var _mdTextarea2 = _interopRequireDefault(_mdTextarea);
	
	var _mdSelect = __webpack_require__(302);
	
	var _mdSelect2 = _interopRequireDefault(_mdSelect);
	
	var _mdEventLabel = __webpack_require__(299);
	
	var _mdEventLabel2 = _interopRequireDefault(_mdEventLabel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MaterialModule = angular.module('app.material', []).component('mdInput', _mdInput2.default).component('mdTextarea', _mdTextarea2.default).component('mdSelect', _mdSelect2.default).directive('mdEventLabel', function () {
	    return new _mdEventLabel2.default();
	}).name;
	
	exports.default = MaterialModule;

/***/ }),
/* 299 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MdEventLabel = function () {
	    function MdEventLabel() {
	        _classCallCheck(this, MdEventLabel);
	
	        this.restrict = 'A';
	    }
	
	    _createClass(MdEventLabel, [{
	        key: 'link',
	        value: function link($scope, $elem) {
	            if ($scope.$ctrl.required === undefined || $scope.$ctrl.ngRequired === undefined) {
	                var $input = $elem.find('input');
	                if ($input.length === 0) {
	                    $input = $elem.find('textarea');
	                }
	                if ($input.length) {
	                    $input.addClass('not-required');
	                    $input.on('focus', function () {
	                        $input.removeClass('not-required');
	                    }).on('blur', function () {
	                        $input[$input.val().length ? 'removeClass' : 'addClass']('not-required');
	                    });
	                } else {
	                    setTimeout(function () {
	                        $input = $elem.find('input');
	                        $input.on('focus', function () {
	                            $input.parent().addClass('not-required-select').parent().addClass('md-focus');
	                        }).on('blur', function () {
	                            if (!$input.parent().hasClass('open')) {
	                                setTimeout(function () {
	                                    $input.parent()[$input.parent()[0].querySelector('.ui-select-match-text').innerHTML.length ? 'addClass' : 'removeClass']('not-required-select').parent().removeClass('md-focus');
	                                }, 1);
	                            }
	                        });
	                    }, 1000);
	                }
	            }
	        }
	    }]);
	
	    return MdEventLabel;
	}();
	
	exports.default = MdEventLabel;

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _mdInput = __webpack_require__(301);
	
	var _mdInput2 = _interopRequireDefault(_mdInput);
	
	__webpack_require__(167);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MdInputComponent = {
	    bindings: {
	        label: '@',
	        type: '@',
	        required: '@',
	        ngRequired: '@',
	        disabled: '@',
	        ngDisabled: '@',
	        readonly: '@',
	        ngReadonly: '@',
	        ngModel: '=',
	        ngClick: '<',
	        ngChange: '<',
	        ngModelOptions: '<',
	        value: '<',
	        ngValue: '<',
	        ngDefault: '<'
	    },
	    template: '\n    <div class="md-form-group" md-event-label>\n        <input ng-required="$ctrl.required || $ctrl.ngRequired"\n               ng-disabled="$ctrl.disabled || $ctrl.ngDisabled"\n               ng-readonly="$ctrl.readonly || $ctrl.ngReadonly"\n               ng-model="$ctrl.ngModel"\n               ng-click="$ctrl.ngClick"\n               ng-change="$ctrl.ngChange"\n               ng-model-options="$ctrl.ngModelOptions"\n               ng-placeholder="$ctrl.placeholder"\n               type="{{ $ctrl.type || \'text\' }}"\n               $ctrl.ngValue || $ctrl.ngDefault || $ctrl.value || \'\'\n               autocapitalize="off">\n        <label class="md-control-label" for="input">{{ $ctrl.label }}</label>\n        <i class="md-bar"></i>\n    </div>\n    ',
	    controller: _mdInput2.default
	};
	
	exports.default = MdInputComponent;

/***/ }),
/* 301 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MdInputController = function () {
	    function MdInputController() {
	        _classCallCheck(this, MdInputController);
	    }
	
	    _createClass(MdInputController, [{
	        key: '$onInit',
	        value: function $onInit() {}
	    }]);
	
	    return MdInputController;
	}();
	
	exports.default = MdInputController;

/***/ }),
/* 302 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var MdSelectComponent = {
	    bindings: {
	        label: '@',
	        required: '@',
	        ngRequired: '@',
	        disabled: '@',
	        ngDisabled: '@',
	        ngModel: '=',
	        ngChange: '<',
	        ngModelOptions: '<',
	        items: '<'
	    },
	    template: '\n    <div class="md-form-group">\n        <select ng-required="$ctrl.required || $ctrl.ngRequired" \n                ng-disabled="$ctrl.disabled || $ctrl.ngDisabled"  \n                ng-model="$ctrl.ngModel" \n                ng-change="$ctrl.ngChange" \n                ng-model-options="$ctrl.ngModelOptions">\n            <option value="{{ item.value }}" ng-if="item.value" ng-repeat="item in $ctrl.items">{{item.text}}</option>\n        </select>\n        <label class="md-control-label" for="select">{{ $ctrl.label }}</label>\n        <i class="md-bar"></i>\n    </div>\n    '
	};
	
	exports.default = MdSelectComponent;

/***/ }),
/* 303 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var MdTextareaComponent = {
	    bindings: {
	        label: '@',
	        required: '@',
	        ngRequired: '@',
	        disabled: '@',
	        ngDisabled: '@',
	        readonly: '@',
	        ngReadonly: '@',
	        ngModel: '=',
	        ngClick: '<',
	        ngChange: '<',
	        ngModelOptions: '<',
	        value: '<',
	        ngValue: '<',
	        ngDefault: '<'
	    },
	    template: '\n    <div class="md-form-group" md-event-label>\n        <textarea ng-required="$ctrl.required || $ctrl.ngRequired" \n                  ng-disabled="$ctrl.disabled || $ctrl.ngDisabled" \n                  ng-readonly="$ctrl.readonly || $ctrl.ngReadonly" \n                  ng-model="$ctrl.ngModel" \n                  ng-click="$ctrl.ngClick" \n                  ng-change="$ctrl.ngChange" \n                  ng-model-options="$ctrl.ngModelOptions"\n                  ng-placeholder="$ctrl.placeholder">{{ $ctrl.ngValue || $ctrl.ngDefault || $ctrl.value || \'\' }}</textarea>\n        <label class="md-control-label" for="textarea">{{ $ctrl.label }}</label>\n        <i class="md-bar"></i>\n    </div>\n    '
	};
	
	exports.default = MdTextareaComponent;

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _crudTable = __webpack_require__(271);
	
	var _crudTable2 = _interopRequireDefault(_crudTable);
	
	var _material = __webpack_require__(298);
	
	var _material2 = _interopRequireDefault(_material);
	
	var _forms = __webpack_require__(280);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _help = __webpack_require__(294);
	
	var _help2 = _interopRequireDefault(_help);
	
	var _cComponents = __webpack_require__(241);
	
	var _cComponents2 = _interopRequireDefault(_cComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Components = angular.module('app.util', [_crudTable2.default, _material2.default, _forms2.default, _help2.default, _cComponents2.default]).name;
	
	exports.default = Components;

/***/ }),
/* 305 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var Errors = {
	    '401': 'No se pudo realizar la operación.',
	    '412': 'No se pudo realizar la operación.',
	    '403': 'Su sesión ha caducado o no tiene los permisos necesarios.',
	    '404': 'No existe el recurso solicitado.',
	    '407': 'Necesita configurar su Proxy para poder usar el sistema.',
	    '408': 'El servidor no responde intente más tarde.',
	    '409': 'Los datos no son válidos',
	    '410': 'El recurso solicitado ya no está disponible y no lo estará de nuevo.',
	    '422': 'Error de validación, revise los datos.',
	    '500': 'Se produjo un error en el servidor, inténtelo más tarde.',
	    '502': 'El sistema no está disponible en estos momentos, inténtelo más tarde.',
	    '503': 'El sistema se encuentra en mantenimiento en estos momentos, vuelva a intentarlo más tarde por favor.',
	    // '504': 'Gateway timeout - Tiempo de espera agota.', // Esto debe ser implementado en el frontend para reintentar las peticiones
	    'connection': 'No se pudo establecer conexión con el servidor.',
	    'cancelRequest': 'Petición cancelada.',
	    'validation': 'Error de validación'
	};
	
	exports.default = Errors;

/***/ }),
/* 306 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var Help = {
	    'ejemplo': 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Impedit, minima!'
	};
	
	exports.default = Help;

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _errors = __webpack_require__(305);
	
	var _errors2 = _interopRequireDefault(_errors);
	
	var _help = __webpack_require__(306);
	
	var _help2 = _interopRequireDefault(_help);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Lang = angular.module('app.lang', []).constant('errorsLang', _errors2.default).constant('helpLang', _help2.default).run(["$rootScope", "errorsLang", "helpLang", function ($rootScope, errorsLang, helpLang) {
	    "ngInject";
	
	    $rootScope.lang = {
	        errorsLang: errorsLang,
	        helpLang: helpLang
	    };
	}]).name;
	
	exports.default = Lang;

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _breadcrumb = __webpack_require__(309);
	
	var _breadcrumb2 = _interopRequireDefault(_breadcrumb);
	
	__webpack_require__(177);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BreadcrumbComponent = {
	    template: '\n        <ol class="breadcrumb">\n            <li class="breadcrumb-item"><i class="fa fa-home"></i> <a href="/">Home</a></li>\n            <li class="breadcrumb-item" ng-if="$ctrl.getParent()">{{$ctrl.getParent()}}</li>\n            <li class="breadcrumb-item active" ng-if="$ctrl.getCurrent()">{{$ctrl.getCurrent()}}</li>\n        </ol>\n    ',
	    controller: _breadcrumb2.default
	};
	
	exports.default = BreadcrumbComponent;

/***/ }),
/* 309 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BreadcrumbController = function () {
	    BreadcrumbController.$inject = ["Storage", "$location", "BreadcrumbFactory", "Util"];
	    function BreadcrumbController(Storage, $location, BreadcrumbFactory, Util) {
	        'ngInject';
	
	        _classCallCheck(this, BreadcrumbController);
	
	        this.Storage = Storage;
	        this.$location = $location;
	        this.BreadcrumbFactory = BreadcrumbFactory;
	        this.Util = Util;
	    }
	
	    _createClass(BreadcrumbController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            if (this.Storage.exist('menu')) {
	                var page = this.Util.getMenuOption(this.Storage.get('menu'), this.$location.path().replace('/', ''));
	                this.BreadcrumbFactory.setParent(page[0]);
	                this.BreadcrumbFactory.setCurrent(page[1]);
	            }
	        }
	    }, {
	        key: 'getParent',
	        value: function getParent() {
	            return this.BreadcrumbFactory.getParent();
	        }
	    }, {
	        key: 'getCurrent',
	        value: function getCurrent() {
	            return this.BreadcrumbFactory.getCurrent();
	        }
	    }]);
	
	    return BreadcrumbController;
	}();
	
	exports.default = BreadcrumbController;

/***/ }),
/* 310 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var BreadcrumbFactory = function BreadcrumbFactory() {
	    var _this = this;
	
	    var factory = {
	        parent: '',
	        current: '',
	        setParent: function setParent(parent) {
	            _this.parent = parent;
	        },
	        setCurrent: function setCurrent(current) {
	            _this.current = current;
	        },
	        getParent: function getParent() {
	            return _this.parent;
	        },
	        getCurrent: function getCurrent() {
	            return _this.current;
	        }
	    };
	
	    return factory;
	};
	
	exports.default = BreadcrumbFactory;

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _breadcrumb = __webpack_require__(308);
	
	var _breadcrumb2 = _interopRequireDefault(_breadcrumb);
	
	var _breadcrumb3 = __webpack_require__(310);
	
	var _breadcrumb4 = _interopRequireDefault(_breadcrumb3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Breadcrumb = angular.module('app.breadcrumb', []).factory('BreadcrumbFactory', _breadcrumb4.default).component('appBreadcrumb', _breadcrumb2.default).name;
	
	exports.default = Breadcrumb;

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _footer = __webpack_require__(313);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	__webpack_require__(178);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FooterComponent = {
	    template: '\n        <footer class="footer text-info">\n            Agetic {{ $ctrl.year }}\n        </footer>\n    ',
	    controller: _footer2.default
	};
	
	exports.default = FooterComponent;

/***/ }),
/* 313 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FooterController = function () {
	    function FooterController() {
	        _classCallCheck(this, FooterController);
	    }
	
	    _createClass(FooterController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var date = new Date();
	            this.year = date.getFullYear();
	        }
	    }]);
	
	    return FooterController;
	}();
	
	exports.default = FooterController;

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(9);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _sidenav = __webpack_require__(325);
	
	var _sidenav2 = _interopRequireDefault(_sidenav);
	
	var _breadcrumb = __webpack_require__(311);
	
	var _breadcrumb2 = _interopRequireDefault(_breadcrumb);
	
	var _loading = __webpack_require__(317);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _navbar = __webpack_require__(320);
	
	var _navbar2 = _interopRequireDefault(_navbar);
	
	var _footer = __webpack_require__(312);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	__webpack_require__(179);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Layout = _angular2.default.module('app.layout', [_sidenav2.default, _breadcrumb2.default, _loading2.default]).component('appNavbar', _navbar2.default).component('appFooter', _footer2.default).name;
	
	exports.default = Layout;

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _loading = __webpack_require__(316);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	__webpack_require__(180);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoadingComponent = {
	    template: '\n        <div class="loading">Loading</div>\n    ',
	    controller: _loading2.default
	};
	
	exports.default = LoadingComponent;

/***/ }),
/* 316 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LoadingController = function () {
	    function LoadingController() {
	        // this.DataService = DataService;
	
	        _classCallCheck(this, LoadingController);
	    }
	
	    _createClass(LoadingController, [{
	        key: 'cancelRequest',
	        value: function cancelRequest() {
	            // this.DataService.cancelRequest();
	        }
	    }]);
	
	    return LoadingController;
	}();
	
	exports.default = LoadingController;

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _loading = __webpack_require__(315);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _loading3 = __webpack_require__(318);
	
	var _loading4 = _interopRequireDefault(_loading3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Loading = angular.module('app.loading', []).component('appLoading', _loading2.default).service('Loading', _loading4.default).name;
	
	exports.default = Loading;

/***/ }),
/* 318 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LoadingService = function () {
	    LoadingService.$inject = ["cfpLoadingBar"];
	    function LoadingService(cfpLoadingBar) {
	        'ngInject';
	
	        _classCallCheck(this, LoadingService);
	
	        this.cfpLoadingBar = cfpLoadingBar;
	    }
	
	    _createClass(LoadingService, [{
	        key: 'show',
	        value: function show(message, locked) {
	            this.cfpLoadingBar.start();
	            document.querySelector('#loading-bar-spinner .loading-text').innerHTML = message || 'Cargando';
	
	            if (locked) {
	                document.querySelector('#loading-bar-spinner').classList.add('screen-locked');
	            } else {
	                document.querySelector('#loading-bar-spinner').classList.remove('screen-locked');
	            }
	        }
	    }, {
	        key: 'hide',
	        value: function hide() {
	            this.cfpLoadingBar.complete();
	            if (document.querySelector('#loading-bar-spinner .loading-text')) {
	                document.querySelector('#loading-bar-spinner .loading-text').innerHTML = 'Cargando';
	                document.querySelector('#loading-bar-spinner').classList.remove('screen-locked');
	            }
	        }
	    }]);
	
	    return LoadingService;
	}();
	
	exports.default = LoadingService;

/***/ }),
/* 319 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PasswordModalController = function () {
	  PasswordModalController.$inject = ["$uibModalInstance", "data", "DataService", "apiUrl", "Message", "Storage", "Auth", "$location"];
	  function PasswordModalController($uibModalInstance, data, DataService, apiUrl, Message, Storage, Auth, $location) {
	    'ngInject';
	
	    _classCallCheck(this, PasswordModalController);
	
	    this.items = data;
	    this.DataService = DataService;
	    this.apiUrl = apiUrl;
	    this.Message = Message;
	    this.$uibModalInstance = $uibModalInstance;
	    this.Storage = Storage;
	    this.datos = {};
	    if (!Auth.$rootScope.auth) $location.path('/');$location.replace();
	  }
	
	  _createClass(PasswordModalController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.usuario = this.Storage.getUser();
	    }
	  }, {
	    key: 'ok',
	    value: function ok() {
	      var _this = this;
	
	      this.enviando = true;
	      if (this.datos.actual === this.datos.nueva) {
	        this.Message.warning("Las contraseñas son iguales, no se ha realizado ningúna modificación.", null, 0);
	        this.$uibModalInstance.dismiss('cancel');
	        return;
	      }
	      if (this.datos.actual && this.datos.nueva && this.datos.confirmado) {
	        this.DataService.put('contrasena/' + this.usuario.id_usuario + '/usuario', this.datos).then(function (response) {
	          _this.enviando = false;
	          if (response === null) return; //throw new Error("No se pudo realizar el cambio.");
	
	          _this.$uibModalInstance.close(_this.datos);
	          _this.Message.success(response.mensaje, null, 0);
	        }).catch(function (error) {
	          _this.enviando = false;
	          _this.Message.error(error, null, 0);
	        });
	      } else {
	        this.enviando = false;
	        this.Message.warning("Verifique los datos introducidos.", null, 0);
	      }
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.$uibModalInstance.dismiss('cancel');
	    }
	  }]);
	
	  return PasswordModalController;
	}();
	
	exports.default = PasswordModalController;

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _navbar = __webpack_require__(593);
	
	var _navbar2 = _interopRequireDefault(_navbar);
	
	var _navbarController = __webpack_require__(321);
	
	var _navbarController2 = _interopRequireDefault(_navbarController);
	
	__webpack_require__(181);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavbarComponent = {
	    bindings: {},
	    template: _navbar2.default,
	    controller: _navbarController2.default
	};
	
	exports.default = NavbarComponent;

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _cuenta = __webpack_require__(319);
	
	var _cuenta2 = _interopRequireDefault(_cuenta);
	
	var _cuenta3 = __webpack_require__(592);
	
	var _cuenta4 = _interopRequireDefault(_cuenta3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var NavbarController = function () {
	    NavbarController.$inject = ["$state", "$window", "Util", "Auth", "Storage", "SidenavFactory", "Modal", "$log"];
	    function NavbarController($state, $window, Util, Auth, Storage, SidenavFactory, Modal, $log) {
	        "ngInject";
	
	        _classCallCheck(this, NavbarController);
	
	        this.$state = $state;
	        this.$window = $window;
	        this.Util = Util;
	        this.Auth = Auth;
	        this.$log = $log;
	        this.Storage = Storage;
	        this.SidenavFactory = SidenavFactory;
	        this.Modal = Modal;
	    }
	
	    _createClass(NavbarController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            this.user = this.Storage.getUser();
	            window.setTimeout(function () {
	                if (_this.$window.innerWidth < 990) {
	                    document.querySelector('#app-sidenav').classList.toggle('sidenav-close');
	                }
	            }, 750);
	        }
	    }, {
	        key: 'toggleSidenav',
	        value: function toggleSidenav() {
	            document.querySelector('#app-sidenav').classList.toggle('sidenav-close');
	        }
	    }, {
	        key: 'fullscreen',
	        value: function fullscreen() {
	            document.querySelector('body').classList.toggle('fullscreen');
	            this.Util.fullscreen();
	        }
	    }, {
	        key: 'refresh',
	        value: function refresh() {
	            this.$state.reload();
	        }
	    }, {
	        key: 'toggled',
	        value: function toggled(open) {
	            this.$log.log('open', open);
	        }
	    }, {
	        key: 'logout',
	        value: function logout() {
	            this.Auth.logout();
	        }
	    }, {
	        key: 'account',
	        value: function account() {
	            var _this2 = this;
	
	            //this.Sidenav.path("account");
	            this.Modal.show({
	                template: _cuenta4.default,
	                controller: _cuenta2.default,
	                data: {},
	                size: ''
	            }).result.then(function () {
	                _this2.logout();
	            });
	        }
	    }, {
	        key: 'changeRol',
	        value: function changeRol(rol) {
	            this.user.rol = rol;
	            this.refresh();
	            // Set rol
	            this.SidenavFactory.setRol(rol);
	            this.Storage.set('rol', this.SidenavFactory.getRol());
	            this.Storage.setUser(this.user);
	        }
	    }]);
	
	    return NavbarController;
	}();
	
	exports.default = NavbarController;

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	__webpack_require__(182);
	
	var _sidenav = __webpack_require__(594);
	
	var _sidenav2 = _interopRequireDefault(_sidenav);
	
	var _sidenav3 = __webpack_require__(323);
	
	var _sidenav4 = _interopRequireDefault(_sidenav3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SidenavComponent = {
	    bindings: {},
	    template: _sidenav2.default,
	    controller: _sidenav4.default
	};
	
	exports.default = SidenavComponent;

/***/ }),
/* 323 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SidenavController = function () {
	    SidenavController.$inject = ["$location", "Storage", "Util", "BreadcrumbFactory", "SidenavFactory", "Auth", "systemName", "Filter", "$log"];
	    function SidenavController($location, Storage, Util, BreadcrumbFactory, SidenavFactory, Auth, systemName, Filter, $log) {
	        "ngInject";
	
	        _classCallCheck(this, SidenavController);
	
	        this.$location = $location;
	        this.Storage = Storage;
	        this.Util = Util;
	        this.BreadcrumbFactory = BreadcrumbFactory;
	        this.SidenavFactory = SidenavFactory;
	        this.Auth = Auth;
	        this.Filter = Filter;
	        this.systemName = systemName;
	        this.$log = $log;
	    }
	
	    _createClass(SidenavController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var color = ['info', 'success', 'danger', 'warning', 'primary'];
	
	            this.url = this.$location.path().replace('/', '');
	
	            if (this.Storage.existUser()) {
	                this.SidenavFactory.setUser(this.Storage.getUser());
	                this.SidenavFactory.setMenu(this.Storage.get('menu'));
	                this.SidenavFactory.setVisible(this.Storage.get('visible'));
	                this.SidenavFactory.setSidenav(this.Storage.get('sidenav'));
	            }
	            this.menu = this.SidenavFactory.getMenu();
	            this.Storage.set('menu', this.menu);
	
	            //Obteniendo el rol de conexion
	            this.dtsRol = JSON.parse(localStorage.getItem("upre_rol"));
	            this.$log.log('ROLES=======>', this.dtsRol['nombre']);
	
	            this.SidenavFactory.userColor = color[parseInt(Math.random() * color.length)];
	
	            window.setTimeout(function () {
	                var el = document.querySelector('#sidenav-menu .sidenav-submenu-item.active');
	                if (el) {
	                    el.parentNode.parentNode.previousElementSibling.dispatchEvent(new window.Event('click'));
	                }
	            }, 500);
	        }
	    }, {
	        key: 'send',
	        value: function send(url, submenu) {
	            if (typeof submenu == 'undefined') {
	                if (this.Storage.exist('menu')) {
	                    var page = this.Util.getMenuOption(this.Storage.get('menu'), url);
	                    this.BreadcrumbFactory.setParent(page[0]);
	                    this.BreadcrumbFactory.setCurrent(page[1]);
	                }
	                var el = document.querySelector('#sidenav-menu .sidenav-submenu-item.active');
	                if (el) {
	                    el.classList.remove('active');
	                }
	                if (!this.Filter.empty(url)) {
	                    el = document.querySelector('#sidenav-menu .sidenav-submenu-item[data-url=' + url + ']');
	                    if (el) {
	                        el.classList.add('active');
	                    }
	                }
	                this.$location.path(url);
	            }
	        }
	    }, {
	        key: 'getColor',
	        value: function getColor() {
	            return this.SidenavFactory.userColor;
	        }
	    }, {
	        key: 'getName',
	        value: function getName() {
	            var user = this.SidenavFactory.getUser();
	            if (user) {
	                user = user.usuario || user.username;
	                if (user && user.split('@').length > 1) {
	                    user = user.split('@')[0];
	                }
	                return user;
	            }
	            return "";
	        }
	    }, {
	        key: 'getEmail',
	        value: function getEmail() {
	            return this.SidenavFactory.getUser().email;
	        }
	    }, {
	        key: 'getInitial',
	        value: function getInitial() {
	            var firstName;
	            if (this.SidenavFactory.getUser().usuario) {
	                firstName = this.SidenavFactory.getUser().usuario;
	                return firstName.length ? firstName[0].toUpperCase() : '?';
	            } else if (this.SidenavFactory.getUser().username) {
	                firstName = this.SidenavFactory.getUser().username;
	                return firstName.length ? firstName[0].toUpperCase() : '?';
	            }
	            return '?';
	        }
	    }, {
	        key: 'getMenu',
	        value: function getMenu() {
	            return this.SidenavFactory.getMenu();
	        }
	    }, {
	        key: 'getVisible',
	        value: function getVisible() {
	            return this.SidenavFactory.getVisible();
	        }
	    }, {
	        key: 'getSidenav',
	        value: function getSidenav() {
	            return this.SidenavFactory.getSidenav();
	        }
	    }, {
	        key: 'setVisible',
	        value: function setVisible(visible) {
	            this.Storage.set('visible', visible);
	            this.SidenavFactory.setVisible(visible);
	        }
	    }, {
	        key: 'setSidenav',
	        value: function setSidenav(sidenav) {
	            this.Storage.set('sidenav', sidenav);
	            this.SidenavFactory.setSidenav(sidenav);
	        }
	    }]);
	
	    return SidenavController;
	}();
	
	exports.default = SidenavController;

/***/ }),
/* 324 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var SidenavFactory = function SidenavFactory() {
	
	    var factory = {
	        user: {
	            id: '',
	            first_name: '',
	            last_name: '',
	            cargo: '',
	            email: '',
	            photo: '',
	            nit: '',
	            user: ''
	        },
	        userColor: '',
	        menu: [],
	        rol: '',
	        visible: true,
	        sidenav: true,
	        getMenu: function getMenu() {
	            return this.menu;
	        },
	        setMenu: function setMenu(menu) {
	            this.menu = menu;
	        },
	        getUser: function getUser() {
	            return this.user;
	        },
	        setUser: function setUser(user) {
	            this.user = user;
	        },
	        getRol: function getRol() {
	            return this.rol;
	        },
	        setRol: function setRol(rol) {
	            this.rol = rol;
	        },
	        getVisible: function getVisible() {
	            return this.visible;
	        },
	        setVisible: function setVisible(visible) {
	            this.visible = visible;
	        },
	        getSidenav: function getSidenav() {
	            return this.sidenav;
	        },
	        setSidenav: function setSidenav(sidenav) {
	            this.sidenav = sidenav;
	        }
	    };
	
	    return factory;
	};
	
	exports.default = SidenavFactory;

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _sidenav = __webpack_require__(322);
	
	var _sidenav2 = _interopRequireDefault(_sidenav);
	
	var _sidenav3 = __webpack_require__(326);
	
	var _sidenav4 = _interopRequireDefault(_sidenav3);
	
	var _sidenav5 = __webpack_require__(324);
	
	var _sidenav6 = _interopRequireDefault(_sidenav5);
	
	var _toggleMenu = __webpack_require__(327);
	
	var _toggleMenu2 = _interopRequireDefault(_toggleMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Sidenav = angular.module('app.sidenav', []).service('Sidenav', _sidenav4.default).component('appSidenav', _sidenav2.default).directive('toggleMenu', function () {
	    return new _toggleMenu2.default();
	}).factory('SidenavFactory', _sidenav6.default).name;
	
	exports.default = Sidenav;

/***/ }),
/* 326 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SidenavService = function () {
	    SidenavService.$inject = ["$location", "Filter"];
	    function SidenavService($location, Filter) {
	        'ngInject';
	
	        _classCallCheck(this, SidenavService);
	
	        this.$location = $location;
	        this.Filter = Filter;
	    }
	
	    _createClass(SidenavService, [{
	        key: '$onInit',
	        value: function $onInit() {}
	    }, {
	        key: 'path',
	        value: function path(url) {
	            var _this = this;
	
	            this.$location.path(url);
	
	            setTimeout(function () {
	                var origin = null;
	                var el = document.querySelector('#sidenav-menu .sidenav-submenu-item.active');
	                if (el) {
	                    el.classList.remove('active');
	                    origin = el.parentNode.parentNode.previousElementSibling.getAttribute('data-url');
	                }
	
	                if (!_this.Filter.empty(url)) {
	                    el = document.querySelector('#sidenav-menu .sidenav-submenu-item[data-url=' + url + ']');
	                    if (el) {
	                        el.classList.add('active');
	                        el = el.parentNode.parentNode.previousElementSibling;
	                        if (el.getAttribute('data-url') != origin) {
	                            el.dispatchEvent(new window.Event('click'));
	                        }
	                    }
	                }
	            }, 100);
	        }
	    }]);
	
	    return SidenavService;
	}();
	
	exports.default = SidenavService;

/***/ }),
/* 327 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ToggleMenu = function () {
	    function ToggleMenu() {
	        _classCallCheck(this, ToggleMenu);
	
	        this.restrict = 'A';
	    }
	
	    _createClass(ToggleMenu, [{
	        key: 'link',
	        value: function link($scope, $elem) {
	            $elem.on('click', function (e) {
	                e.preventDefault();
	
	                var $submenu = $elem.next();
	                var $items = $submenu.find('a');
	
	                if ($items.length) {
	                    if ($elem.parent().hasClass('sidenav-open')) {
	                        $elem.next().css('height', 0);
	                        $elem.parent().removeClass('sidenav-open');
	                        $elem.removeClass('active');
	                    } else {
	                        angular.forEach(document.querySelectorAll('#sidenav-menu .sidenav-open'), function (el) {
	                            el.querySelector('ul').style.height = 0;
	                            el.classList.remove('sidenav-open');
	                            el.querySelector('.active').classList.remove('active');
	                        });
	                        $submenu.css('height', $items.length * $items[0].offsetHeight + 20 + 'px');
	                        $elem.parent().addClass('sidenav-open');
	                        $elem.addClass('active');
	                    }
	                }
	            });
	        }
	    }]);
	
	    return ToggleMenu;
	}();
	
	exports.default = ToggleMenu;

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _dashboard = __webpack_require__(332);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	var _login = __webpack_require__(336);
	
	var _login2 = _interopRequireDefault(_login);
	
	var _user = __webpack_require__(352);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _usuarios = __webpack_require__(360);
	
	var _usuarios2 = _interopRequireDefault(_usuarios);
	
	var _proyectos = __webpack_require__(342);
	
	var _proyectos2 = _interopRequireDefault(_proyectos);
	
	var _restablecer_contrasenia = __webpack_require__(345);
	
	var _restablecer_contrasenia2 = _interopRequireDefault(_restablecer_contrasenia);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Admin = angular.module('app.admin', [_dashboard2.default, _login2.default, _user2.default, _usuarios2.default, _proyectos2.default, _restablecer_contrasenia2.default]).name;
	
	exports.default = Admin;

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _dashboard = __webpack_require__(595);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	var _dashboard3 = __webpack_require__(330);
	
	var _dashboard4 = _interopRequireDefault(_dashboard3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DashboardComponent = {
	    template: _dashboard2.default,
	    controller: _dashboard4.default
	};
	
	exports.default = DashboardComponent;

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dashboardModalController = __webpack_require__(331);
	
	var _dashboardModalController2 = _interopRequireDefault(_dashboardModalController);
	
	var _dashboardModal = __webpack_require__(596);
	
	var _dashboardModal2 = _interopRequireDefault(_dashboardModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DashboardController = function () {
	  DashboardController.$inject = ["apiUrl", "Message", "Modal", "Loading", "$log", "helpLang"];
	  function DashboardController(apiUrl, Message, Modal, Loading, $log, helpLang) {
	    'ngInject';
	
	    _classCallCheck(this, DashboardController);
	
	    this.dt = new Date();
	    this.Message = Message;
	    this.Modal = Modal;
	    this.apiUrl = apiUrl;
	    this.Loading = Loading;
	    this.helpLang = helpLang;
	    this.$log = $log;
	  }
	
	  _createClass(DashboardController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.items = [{ value: 1, text: 'Item uno' }, { value: 2, text: 'Item dos' }, { value: 3, text: 'Item tres' }, { value: 4, text: 'Item cuatro' }, { value: 5, text: 'Item cinco' }];
	
	      // Configuración para el datepicker
	      this.dateOptions = {
	        maxDate: new Date(2020, 5, 22),
	        minDate: new Date(),
	        startingDay: 1,
	        showWeeks: false
	      };
	
	      // Configuración para el timepicker
	      this.mytime = new Date();
	
	      // Configuración para los tabs
	      this.tabs = [{ title: 'Título dinámico 1', content: 'Contenido dinámico 1' }, { title: 'Título dinámico 2', content: 'Contenido dinámico 2', disabled: true }];
	
	      // Configuraciones del file upload
	      this.upload = {
	        url: 'http://posttestserver.com/post.php', // Url donde se subirá el archivo
	        onCompleteItem: function onCompleteItem(fileItem, response, status, headers) {
	          // Acción con la que se indica que se hará después de subir el archivo
	          _this.$log('file upload', fileItem, response, status, headers);
	        },
	        onCompleteAll: function onCompleteAll() {
	          // Acción con la que se indica que se hará después de subir todos los archivos
	        },
	        onAfterAddingFile: function onAfterAddingFile(fileItem) {
	          _this.$log('fileItem', fileItem);
	          // Acción con la que se indica que se hará después de agregar el archivo a la lista de archivos por subir
	        },
	        onBeforeUploadItem: function onBeforeUploadItem(item) {
	          _this.$log('item', item);
	          // Acción con la que se indica que se hará antes de subir el archivo
	        }
	      };
	    }
	
	    // Modales de ejemplo
	
	  }, {
	    key: 'openModal',
	    value: function openModal() {
	      var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	      this.Modal.show({
	        template: _dashboardModal2.default,
	        controller: _dashboardModalController2.default,
	        data: this.items,
	        size: size
	      });
	    }
	  }, {
	    key: 'openMessage',
	    value: function openMessage(type) {
	      this.Message[type]();
	    }
	  }, {
	    key: 'openAlert',
	    value: function openAlert() {
	      this.Modal.alert('¡Hola mundo!');
	    }
	  }, {
	    key: 'openConfirm',
	    value: function openConfirm() {
	      var _this2 = this;
	
	      this.Modal.confirm('¿Está seguro de continuar?', function () {
	        _this2.Modal.alert("Hola!!!");
	      });
	    }
	
	    // Loading bar
	
	  }, {
	    key: 'loadingInit',
	    value: function loadingInit() {
	      this.Loading.show();
	    }
	  }, {
	    key: 'loadingInitText',
	    value: function loadingInitText() {
	      this.Loading.show('Mensaje personalizado de carga');
	    }
	  }, {
	    key: 'loadingInitLocked',
	    value: function loadingInitLocked() {
	      var _this3 = this;
	
	      this.Loading.show('Mensaje en pantalla completa', true);
	
	      // Forzamos a terminar el loading, por defecto se cierra automáticamente cuando termina la petición
	      setTimeout(function () {
	        return _this3.Loading.hide();
	      }, 3000);
	    }
	  }, {
	    key: 'loadingEnd',
	    value: function loadingEnd() {
	      this.Loading.hide();
	    }
	  }]);
	
	  return DashboardController;
	}();
	
	exports.default = DashboardController;

/***/ }),
/* 331 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DashboardModalController = function () {
	    DashboardModalController.$inject = ["$uibModalInstance", "data"];
	    function DashboardModalController($uibModalInstance, data) {
	        'ngInject';
	
	        _classCallCheck(this, DashboardModalController);
	
	        this.items = data;
	        this.$uibModalInstance = $uibModalInstance;
	    }
	
	    _createClass(DashboardModalController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            // this.selected es un dato de ejemplo
	            this.selected = {
	                item: this.items[0]
	            };
	        }
	    }, {
	        key: 'ok',
	        value: function ok() {
	            // si se quiere enviar información al contenedor padre que llamó el modal se lo hace de esta manera:
	            this.$uibModalInstance.close(this.selected.item); // this.selected.item se envía al contenedor padre que lo invocó
	        }
	    }, {
	        key: 'cancel',
	        value: function cancel() {
	            this.$uibModalInstance.dismiss('cancel');
	        }
	    }]);
	
	    return DashboardModalController;
	}();
	
	exports.default = DashboardModalController;

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _dashboard = __webpack_require__(329);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Dashboard = angular.module('app.admin.dashboard', []).component('appDashboard', _dashboard2.default).config(["$stateProvider", function ($stateProvider) {
	    $stateProvider.state('dashboard', {
	        url: '/',
	        component: 'appDashboard'
	    });
	}]).name;
	
	exports.default = Dashboard;

/***/ }),
/* 333 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AuthService = function () {
	    AuthService.$inject = ["$http", "$auth", "$location", "$rootScope", "Filter", "$uibModalStack", "Storage", "SidenavFactory", "BreadcrumbFactory", "Util", "timeSessionExpired", "Message", "$log"];
	    function AuthService($http, $auth, $location, $rootScope, Filter, $uibModalStack, Storage, SidenavFactory, BreadcrumbFactory, Util, timeSessionExpired, Message, $log) {
	        "ngInject";
	
	        _classCallCheck(this, AuthService);
	
	        this.$http = $http;
	        this.$auth = $auth;
	        this.$rootScope = $rootScope;
	        this.$uibModalStack = $uibModalStack;
	        this.$location = $location;
	        this.Storage = Storage;
	        this.Util = Util;
	        this.Message = Message;
	        this.Filter = Filter;
	        this.$log = $log;
	        this.SidenavFactory = SidenavFactory;
	        this.BreadcrumbFactory = BreadcrumbFactory;
	        this.timeSessionExpired = timeSessionExpired;
	    }
	
	    _createClass(AuthService, [{
	        key: 'signin',
	        value: function signin(data, url) {
	            var _this = this;
	
	            this.$auth.login(data, url).then(function (response) {
	                var user = response.data.datos.usuario;
	                var menu = response.data.datos.menu;
	                var rol = user.rol;
	                // data.path = data.path || 'dashboard';
	                var pathRedirect = data.path || response.data.datos.menuEntrar;
	                user.pathLogin = data.pathLogin || 'login';
	
	                _this.$rootScope.auth = true;
	
	                // Set user
	                user.pathInicio = pathRedirect;
	                _this.SidenavFactory.setUser(user);
	                _this.Storage.setUser(user);
	
	                // Set Menu
	                _this.SidenavFactory.setMenu(menu);
	                _this.Storage.set('menu', _this.SidenavFactory.getMenu());
	
	                // Set rol
	                _this.SidenavFactory.setRol(rol);
	                _this.Storage.set('rol', _this.SidenavFactory.getRol());
	
	                // Set Visible
	                _this.SidenavFactory.setVisible(data.menu === undefined ? true : data.menu);
	                _this.Storage.set('visible', _this.SidenavFactory.getVisible());
	
	                // Set Sidenav
	                _this.SidenavFactory.setSidenav(data.sidenav === undefined ? true : data.sidenav);
	                _this.Storage.set('sidenav', _this.SidenavFactory.getSidenav());
	
	                var path = pathRedirect || _this.Storage.get('path');
	
	                if (path) {
	                    var route = path.replace('/', '');
	
	                    // Set breadcrumb
	                    var page = _this.Util.getMenuOption(_this.Storage.get('menu'), route);
	                    _this.BreadcrumbFactory.setParent(page[0]);
	                    _this.BreadcrumbFactory.setCurrent(page[1]);
	                }
	
	                _this.timerSession();
	
	                // Redirect to dashboard
	                _this.$location.path(path && path.indexOf('login') == -1 ? path : data.path || '/');
	            }).catch(function (error) {
	                if (error.data && error.data.mensaje) {
	                    _this.Message.error(error.data.mensaje);
	                } else {
	                    _this.Message.error('No se pudo conectar con el servicio, por favor revise su conexión a internet o intente nuevamente más tarde.');
	                }
	            });
	        }
	    }, {
	        key: 'timerSession',
	        value: function timerSession() {
	            // Definiendo el tiempo que dura una sesión sin actividad
	            angular.TIME = this.timeSessionExpired * 60;
	            var ctrl = this;
	            angular.sessionInterval = window.setInterval(function () {
	                angular.TIME--;
	                if (angular.TIME <= 0) {
	                    angular.expired = true;
	                    ctrl.logout();
	                }
	            }, 1000);
	        }
	    }, {
	        key: 'logout',
	        value: function logout() {
	            var _this2 = this;
	
	            var pathLogin = 'login';
	            if (this.Storage.existUser() && this.Storage.getUser() && this.Storage.getUser().pathLogin) {
	                pathLogin = this.Storage.getUser().pathLogin;
	            }
	
	            this.$auth.logout().then(function () {
	
	                if (angular.sessionInterval) {
	                    window.clearInterval(angular.sessionInterval);
	                    angular.sessionInterval = null;
	                }
	
	                setTimeout(function () {
	                    _this2.$uibModalStack.dismissAll('Cerrando sesión');
	                }, 1000);
	
	                _this2.Storage.removeUser();
	                _this2.Storage.remove('menu');
	                _this2.Storage.remove('visible');
	                _this2.Storage.remove('rol');
	                _this2.Storage.remove('sidenav');
	                _this2.Storage.remove('dateNow');
	                // this.Storage.remove('path');
	
	                _this2.SidenavFactory.setUser({});
	                _this2.SidenavFactory.setMenu([]);
	                _this2.SidenavFactory.setVisible(false);
	
	                if (angular.expired) {
	                    _this2.Storage.set('expired', true);
	                    delete angular.expired;
	                }
	                _this2.$location.path(pathLogin);
	            });
	        }
	    }, {
	        key: 'isAuthenticated',
	        value: function isAuthenticated() {
	            return this.$auth.isAuthenticated();
	        }
	    }]);
	
	    return AuthService;
	}();
	
	exports.default = AuthService;

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _login = __webpack_require__(335);
	
	var _login2 = _interopRequireDefault(_login);
	
	var _login3 = __webpack_require__(597);
	
	var _login4 = _interopRequireDefault(_login3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoginComponent = {
	    bindings: {},
	    controller: _login2.default,
	    template: _login4.default
	};
	
	exports.default = LoginComponent;

/***/ }),
/* 335 */
/***/ (function(module, exports) {

	/*eslint no-console: ["error", { allow: ["log", "warn", "error"] }] */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LoginController = function () {
	  LoginController.$inject = ["$rootScope", "$location", "$scope", "Storage", "Message", "timeSessionExpired", "Auth", "authUrl", "authEmpresasUrl", "DataService", "apiUrlPublic"];
	  function LoginController($rootScope, $location, $scope, Storage, Message, timeSessionExpired, Auth, authUrl, authEmpresasUrl, DataService, apiUrlPublic) {
	    'ngInject';
	
	    _classCallCheck(this, LoginController);
	
	    this.$rootScope = $rootScope;
	    this.$location = $location;
	    this.Storage = Storage;
	    this.Message = Message;
	    this.Auth = Auth;
	    this.authUrl = authUrl;
	    this.authEmpresasUrl = authEmpresasUrl;
	    this.apiUrlPublic = apiUrlPublic;
	    this.timeSessionExpired = timeSessionExpired;
	    this.DataService = DataService;
	
	    this.$rootScope.auth = false;
	  }
	
	  _createClass(LoginController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.$rootScope.auth = false;
	
	      if (this.Storage.exist('expired')) {
	        this.Message.warning('Su sesión ha sido cerrada automáticamente después de ' + this.timeSessionExpired + ' minutos de inactividad.', null, 0);
	        this.Storage.destroy('expired');
	      }
	      if (this.Storage.exist('menu') && this.Storage.existUser() && this.Storage.exist('token') && this.Storage.getUser().estado == 'ACTIVO') {
	        this.$rootScope.auth = true;
	        this.$location.path(this.Storage.getUser().pathInicio);
	      }
	    }
	  }, {
	    key: 'signin',
	    value: function signin() {
	      this.Auth.signin({
	        username: this.username,
	        password: this.password,
	        // path: 'pendientes',
	        pathLogin: 'login',
	        menu: true,
	        sidenav: true
	      });
	    }
	  }, {
	    key: 'signinEmpresa',
	    value: function signinEmpresa() {
	      this.Auth.signin({
	        nit: this.nit,
	        usuario: this.username,
	        clave: this.password,
	        path: 'matriculas',
	        pathLogin: 'login',
	        menu: true,
	        sidenav: true
	      }, { url: this.authEmpresasUrl });
	    }
	  }, {
	    key: 'signinSupervisor',
	    value: function signinSupervisor() {
	      this.password = this.username.substring(this.username.length - 1);
	      this.username = this.username.substring(0, this.username.length - 1);
	      //this.password='2';
	      //this.username='19918002219918002';
	
	      this.Auth.signin({
	        nit: this.nit,
	        usuario: this.username,
	        clave: this.password,
	        path: 'matriculas',
	        pathLogin: 'login',
	        menu: true,
	        sidenav: true
	      }, { url: this.authEmpresasUrl });
	    }
	  }, {
	    key: 'recovery',
	    value: function recovery() {
	      this.flip = true;
	      this.username = '';
	      this.password = '';
	    }
	  }, {
	    key: 'goLogin',
	    value: function goLogin() {
	      this.flip = false;
	      this.correo = '';
	    }
	  }, {
	    key: 'iniciarSesion',
	    value: function iniciarSesion() {
	      if (!this.empresa && !this.conciliacion) {
	        this.signin();
	      } else {
	        if (this.empresa) {
	          this.signinEmpresa();
	        }
	        if (this.conciliacion) {
	          this.signinSupervisor();
	        }
	      }
	    }
	  }, {
	    key: 'recuperarContrasenia',
	    value: function recuperarContrasenia() {
	      var _this = this;
	
	      if (!this.correo) {
	        this.Message.warning('Debe escribir su dirección de correo electrónico', null, 0);
	      } else {
	        var datos = {
	          username: this.username,
	          email: this.correo
	        };
	        this.DataService.post(this.authUrl + '/restablecercontrasenia', datos).then(function (resp) {
	          if (resp && resp.finalizado) {
	            _this.Message.success(resp.mensaje, null, 0);
	          }
	        });
	      }
	    }
	  }]);
	
	  return LoginController;
	}();
	
	exports.default = LoginController;

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _login = __webpack_require__(334);
	
	var _login2 = _interopRequireDefault(_login);
	
	var _auth = __webpack_require__(333);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	__webpack_require__(185);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Login = angular.module('app.login', []).service('Auth', _auth2.default).component('appAdminLogin', _login2.default).config(["$stateProvider", function ($stateProvider) {
	    $stateProvider.state('login', {
	        url: '/login',
	        component: 'appAdminLogin'
	    }).state('logout', {
	        url: '/logout',
	        controller: ["Auth", function controller(Auth) {
	            Auth.logout();
	        }]
	    });
	}]).name;
	
	exports.default = Login;

/***/ }),
/* 337 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReasignarUsuarioController = function () {
	  ReasignarUsuarioController.$inject = ["$uibModalInstance", "data", "DataService", "Message"];
	  function ReasignarUsuarioController($uibModalInstance, data, DataService, Message) {
	    'ngInject';
	
	    _classCallCheck(this, ReasignarUsuarioController);
	
	    this.$uibModalInstance = $uibModalInstance;
	    this.transicion = data.transicion;
	    this.DataService = DataService;
	    this.Message = Message;
	  }
	
	  _createClass(ReasignarUsuarioController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.datos = {
	        nro_usuario: this.transicion.usuario_asignado.nro,
	        nro_rol: this.transicion.usuario_asignado_rol.nro
	      };
	      var roles = [];
	      roles.push(this.transicion.usuario_asignado_rol.nro);
	      this.DataService.get('proyectos/' + this.transicion.objeto + '/usuarios?roles=[' + roles.join(',') + ']').then(function (response) {
	        if (response) {
	          _this.usuariosParaAsignar = response.datos;
	        }
	      });
	    }
	  }, {
	    key: 'reasignarUsuario',
	    value: function reasignarUsuario() {
	      var _this2 = this;
	
	      var datos = angular.copy(this.datos);
	      if (datos.seleccionado) {
	        datos.nuevo_nro_rol = datos.seleccionado.id_rol || null;
	        datos.nuevo_nro_usuario = datos.seleccionado.id_usuario || null;
	        delete datos.seleccionado;
	      }
	      this.DataService.put('adminproyectos/' + this.transicion.objeto + '/usuarios', datos).then(function (resp) {
	        if (resp && resp.finalizado) {
	          _this2.Message.success(resp.mensaje);
	          _this2.$uibModalInstance.close(true);
	        }
	      });
	    }
	  }, {
	    key: 'cerrar',
	    value: function cerrar() {
	      this.$uibModalInstance.close(false);
	    }
	  }]);
	
	  return ReasignarUsuarioController;
	}();
	
	exports.default = ReasignarUsuarioController;

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	'usr strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _datos = __webpack_require__(339);
	
	var _datos2 = _interopRequireDefault(_datos);
	
	var _datos3 = __webpack_require__(599);
	
	var _datos4 = _interopRequireDefault(_datos3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProyectoComponent = {
	  bindings: {},
	  controller: _datos2.default,
	  template: _datos4.default
	};
	
	exports.default = ProyectoComponent;

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _reasignarusuario = __webpack_require__(337);
	
	var _reasignarusuario2 = _interopRequireDefault(_reasignarusuario);
	
	var _reasignarusuario3 = __webpack_require__(598);
	
	var _reasignarusuario4 = _interopRequireDefault(_reasignarusuario3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ProyectoController = function () {
	  ProyectoController.$inject = ["$state", "$stateParams", "DataService", "Modal", "$log"];
	  function ProyectoController($state, $stateParams, DataService, Modal, $log) {
	    'ngInject';
	
	    _classCallCheck(this, ProyectoController);
	
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.DataService = DataService;
	    this.Modal = Modal;
	    this.$log = $log;
	  }
	
	  _createClass(ProyectoController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.$$cargarDatos();
	    }
	  }, {
	    key: '$$cargarDatos',
	    value: function $$cargarDatos() {
	      var _this = this;
	
	      this.DataService.get('adminproyectos/' + this.$stateParams.codigo + '/usuarios').then(function (resp) {
	        if (resp && resp.finalizado) {
	          _this.proyecto = resp.datos;
	          _this.dtsRol = JSON.parse(localStorage.getItem("upre_rol"));
	          _this.$log.log('ROLES2=======>', _this.dtsRol['nombre']);
	
	          _this.$log.log('p1===>' + JSON.stringify(_this.proyecto));
	          _this.$log.log('p2===>' + JSON.stringify(_this.proyecto.usuario_rol.nombre));
	        }
	      });
	    }
	  }, {
	    key: 'reasignarUsuario',
	    value: function reasignarUsuario(transicion) {
	      var _this2 = this;
	
	      var REENVIO = this.Modal.show({
	        template: _reasignarusuario4.default,
	        controller: _reasignarusuario2.default,
	        data: {
	          transicion: transicion
	        }
	      });
	      REENVIO.result.then(function (result) {
	        if (result) {
	          _this2.$state.reload();
	        }
	      }).catch(function () {});
	    }
	  }, {
	    key: 'reasignarUsuarioProy',
	    value: function reasignarUsuarioProy(proyecto) {
	      var _this3 = this;
	
	      var transicion = {
	        objeto: proyecto.id_proyecto,
	        tipo: 'proyecto',
	        usuario_asignado: proyecto.usuario,
	        usuario_asignado_rol: proyecto.usuario_rol
	      };
	      var REENVIO = this.Modal.show({
	        template: _reasignarusuario4.default,
	        controller: _reasignarusuario2.default,
	        data: {
	          transicion: transicion
	        }
	      });
	      REENVIO.result.then(function (result) {
	        if (result) {
	          _this3.$state.reload();
	        }
	      }).catch(function () {});
	    }
	  }]);
	
	  return ProyectoController;
	}();
	
	exports.default = ProyectoController;

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	'usr strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _proyectos = __webpack_require__(341);
	
	var _proyectos2 = _interopRequireDefault(_proyectos);
	
	var _proyectos3 = __webpack_require__(600);
	
	var _proyectos4 = _interopRequireDefault(_proyectos3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProyectosComponent = {
	  bindings: {},
	  controller: _proyectos2.default,
	  template: _proyectos4.default
	};
	
	exports.default = ProyectosComponent;

/***/ }),
/* 341 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ProyectosController = function () {
	  ProyectosController.$inject = ["$state", "Message"];
	  function ProyectosController($state, Message) {
	    'ngInject';
	
	    _classCallCheck(this, ProyectosController);
	
	    this.$state = $state;
	    this.Message = Message;
	  }
	
	  _createClass(ProyectosController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      var colors = {
	        INACTIVO: 'warning',
	        ACTIVO: 'success'
	      };
	      this.proyectos = {
	        url: 'adminproyectos',
	        queryExtra: { fid_proyecto: this.idProyecto, origen: 'bandeja' },
	        data: {
	          formly: [{
	            key: 'id_proyecto',
	            type: 'input',
	            templateOptions: {
	              label: 'ID',
	              type: 'number'
	            }
	          },
	          // {
	          //   key: 'version',
	          //   type: 'input',
	          //   templateOptions: {
	          //     label: 'Versión',
	          //     type: 'text'
	          //   }
	          // },
	          {
	            key: 'municipio',
	            type: 'input',
	            templateOptions: {
	              label: 'Municipio',
	              type: 'text'
	            }
	          }, {
	            key: 'municipio.provincia.departamento.nombre',
	            type: 'input',
	            templateOptions: {
	              label: 'Departamento',
	              type: 'text'
	            }
	          }, {
	            key: 'codigo',
	            type: 'input',
	            templateOptions: {
	              label: 'Código',
	              type: 'text'
	            }
	          }, {
	            key: 'tipo',
	            type: 'input',
	            templateOptions: {
	              label: 'Tipo',
	              type: 'text'
	            }
	          }, {
	            key: 'nombre',
	            type: 'input',
	            templateOptions: {
	              label: 'Nombre',
	              type: 'text'
	            }
	          }, {
	            key: 'estado_proyecto',
	            type: 'input',
	            templateOptions: {
	              label: 'estado',
	              type: 'text'
	            }
	          }, {
	            key: 'estado',
	            type: 'select',
	            templateOptions: {
	              label: 'Estado',
	              type: 'select',
	              options: [{ value: 'ACTIVO', name: 'ACTIVO' }, { value: 'INACTIVO', name: 'INACTIVO' }]
	            }
	          }, {
	            key: '_fecha_modificacion',
	            type: 'datepicker',
	            templateOptions: {
	              label: 'Fecha de modificación',
	              type: 'hidden'
	            }
	          }]
	        },
	        fields: ['id_proyecto', 'municipio', 'municipio.provincia.departamento.nombre', 'version', 'codigo', 'tipo', 'nombre', 'estado_proyecto', 'estado', '_fecha_modificacion'],
	        hiddenFields: ['id_proyecto', 'municipio'],
	        // fks: ['fid_formulario'],
	        permission: {
	          create: false,
	          update: true,
	          delete: false,
	          filter: false
	        },
	        labels: { create: 'NUEVO USUARIO' },
	        eventCreate: function eventCreate() {
	          _this.$state.go('adminproyectos', { codigo: null });
	        },
	        eventEdit: function eventEdit(proyecto) {
	          _this.$state.go('adminproyecto', { codigo: proyecto.id_proyecto });
	        },
	        clases: {
	          'estado': function estado(item) {
	            // this.$log.log(item);
	            return ['badge', 'badge-' + colors[item.estado]];
	          }
	        }
	      };
	    }
	  }]);
	
	  return ProyectosController;
	}();
	
	exports.default = ProyectosController;

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _proyectos = __webpack_require__(340);
	
	var _proyectos2 = _interopRequireDefault(_proyectos);
	
	var _datos = __webpack_require__(338);
	
	var _datos2 = _interopRequireDefault(_datos);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import reconfirmacionUsuarioComponent from './reenviar-confirmacion/reconfirmacion.component';
	// import UsuariosService from './adminproyectos.service';
	
	var adminproyectos = angular.module('app.adminproyectos', []).component('adminproyectos', _proyectos2.default).component('adminproyecto', _datos2.default).config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('adminproyectos', {
	    url: '/admin-proyectos',
	    component: 'adminproyectos'
	  }).state('adminproyecto', {
	    url: '/admin-proyecto/{codigo:int}',
	    component: 'adminproyecto'
	  });
	}]).name;
	
	exports.default = adminproyectos;

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _restablecer_contrasenia = __webpack_require__(344);
	
	var _restablecer_contrasenia2 = _interopRequireDefault(_restablecer_contrasenia);
	
	var _restablecer_contrasenia3 = __webpack_require__(601);
	
	var _restablecer_contrasenia4 = _interopRequireDefault(_restablecer_contrasenia3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoginComponent = {
	    bindings: {},
	    controller: _restablecer_contrasenia2.default,
	    template: _restablecer_contrasenia4.default
	};
	
	exports.default = LoginComponent;

/***/ }),
/* 344 */
/***/ (function(module, exports) {

	/*eslint no-console: ["error", { allow: ["log", "warn", "error"] }] */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LoginController = function () {
	  LoginController.$inject = ["$rootScope", "$location", "$scope", "Storage", "Message", "timeSessionExpired", "Auth", "authUrl", "authEmpresasUrl", "DataService", "apiUrlPublic", "$stateParams", "$log"];
	  function LoginController($rootScope, $location, $scope, Storage, Message, timeSessionExpired, Auth, authUrl, authEmpresasUrl, DataService, apiUrlPublic, $stateParams, $log) {
	    'ngInject';
	
	    _classCallCheck(this, LoginController);
	
	    this.$rootScope = $rootScope;
	
	    this.$scope = $scope;
	    this.Storage = Storage;
	    this.Message = Message;
	    this.Auth = Auth;
	    this.authEmpresasUrl = authEmpresasUrl;
	    this.apiUrlPublic = apiUrlPublic;
	    this.timeSessionExpired = timeSessionExpired;
	    this.DataService = DataService;
	
	    this.$rootScope.auth = false;
	
	    this.$location = $location;
	    this.$stateParams = $stateParams;
	    this.authUrl = authUrl;
	    this.$log = $log;
	  }
	
	  _createClass(LoginController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.$rootScope.auth = false;
	      this.codigo = this.$stateParams.codigo == "" ? null : this.$stateParams.codigo;
	      this.pathLogin = 'login';
	
	      console.log('------------------------------------');
	      console.log('reached restablecer');
	      console.log('------------------------------------');
	      console.log(this.codigo);
	      console.log('------------------------------------');
	
	      if (!this.codigo) {
	        console.log('------------------------------------');
	        console.log('no se ha especificado un codigo');
	        console.log('------------------------------------');
	        this.$location.path(this.pathLogin);
	      }
	
	      this.verificarCodigo();
	
	      /*
	      if (this.Storage.exist('expired')) {
	          this.Message.warning('Su sesión ha sido cerrada automáticamente después de ' + this.timeSessionExpired + ' minutos de inactividad.', null, 0);
	          this.Storage.destroy('expired');
	      }
	      if (this.Storage.exist('menu') && this.Storage.existUser() && this.Storage.exist('token') && this.Storage.getUser().estado == 'ACTIVO') {
	          this.$rootScope.auth = true;
	          this.$location.path(this.Storage.getUser().pathInicio);
	      }
	      this.$scope.$watch('$ctrl.password', () => {
	        if (this.password) {
	          let el = document.getElementById('password');
	          if (el) {
	            angular.element(el).find('input').removeClass('not-required');
	          }
	        }
	      }, true);
	      this.$scope.$watch('$ctrl.username', () => {
	        if (this.username) {
	          let el = document.getElementById('username');
	          if (el) {
	            angular.element(el).find('input').removeClass('not-required');
	          }
	        }
	      }, true);
	      */
	    }
	  }, {
	    key: 'verificarCodigo',
	    value: function verificarCodigo() {
	      var _this = this;
	
	      var datos = {
	        codigo: this.codigo
	      };
	
	      this.DataService.post(this.authUrl + '/verificarcodigo', datos).then(function (resp) {
	        console.log('---------resp verificacion----------');
	        console.log(resp);
	        console.log('------------------------------------');
	        if (resp && resp.finalizado) {
	          console.log('------------------------------------');
	          console.log('codigo correcto');
	          console.log('------------------------------------');
	        } else {
	          console.log('------------------------------------');
	          console.log('el codigo no esta en DB');
	          console.log('------------------------------------');
	          _this.$location.path(_this.pathLogin);
	        }
	      }).catch(function (error) {
	        _this.$log.log(error);
	        _this.$location.path(_this.pathLogin);
	      });
	    }
	  }, {
	    key: 'inicioDeSesion',
	    value: function inicioDeSesion() {
	      this.$location.path(this.pathLogin);
	    }
	  }, {
	    key: 'cambiarContrasena',
	    value: function cambiarContrasena() {
	      var _this2 = this;
	
	      console.log('--------------------nueva-----------');
	      console.log(this.nueva);
	      console.log('--------confirmado------------------');
	      console.log(this.confirmada);
	      console.log('------------------------------------');
	      var datos = {
	        codigo: this.codigo,
	        nueva: this.nueva,
	        confirmada: this.confirmada
	      };
	      this.DataService.post(this.authUrl + '/cambiarcontrasenia', datos).then(function (resp) {
	        if (resp && resp.finalizado) {
	          _this2.Message.success(resp.mensaje, null, 0);
	          _this2.$location.path(_this2.pathLogin);
	        }
	      });
	    }
	
	    /*
	    signin() {
	        this.Auth.signin({
	            username: this.username,
	            password: this.password,
	            // path: 'pendientes',
	            pathLogin: 'login',
	            menu: true,
	            sidenav: true
	        });
	    }
	     signinEmpresa() {
	      this.Auth.signin({
	        nit: this.nit,
	        usuario: this.username,
	        clave: this.password,
	        path: 'matriculas',
	        pathLogin: 'login',
	        menu: true,
	        sidenav: true
	      }, {url: this.authEmpresasUrl});
	    }
	     recovery() {
	        this.flip = true;
	        this.username = '';
	        this.password = '';
	    }
	     goLogin() {
	        this.flip = false;
	        this.correo = '';
	    }
	     iniciarSesion() {
	      if (!this.empresa) {
	        this.signin();
	      } else {
	        this.signinEmpresa();
	      }
	    }
	     recuperarContrasenia() {
	      if (!this.correo) {
	        this.Message.warning('Debe escribir su dirección de correo electrónico', null, 0);
	      } else {
	        let datos = {
	          email: this.correo
	        }
	        this.DataService.post(`${this.authUrl}/restablecercontrasenia`, datos).then((resp) => {
	          if (resp && resp.finalizado) {
	            this.Message.success(resp.mensaje, null, 0);
	          }
	        });
	      }
	    }
	    */
	
	  }]);
	
	  return LoginController;
	}();
	
	exports.default = LoginController;

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _restablecer_contrasenia = __webpack_require__(343);
	
	var _restablecer_contrasenia2 = _interopRequireDefault(_restablecer_contrasenia);
	
	var _restablecer_contrasenia3 = __webpack_require__(346);
	
	var _restablecer_contrasenia4 = _interopRequireDefault(_restablecer_contrasenia3);
	
	__webpack_require__(186);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RestablecerContrasenia = angular.module('app.restablecerContrasenia', []).service('RestablecerContrasenia', _restablecer_contrasenia4.default).component('appAdminRestablecerContrasenia', _restablecer_contrasenia2.default).config(["$stateProvider", function ($stateProvider) {
	    $stateProvider.state('restablecerContrasenia', {
	        url: '/restablecer-contrasenia/:codigo',
	        component: 'appAdminRestablecerContrasenia'
	    });
	}]).name;
	
	exports.default = RestablecerContrasenia;

/***/ }),
/* 346 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AuthService = function AuthService($http, $auth, $location, $rootScope, Filter, $uibModalStack, Storage, SidenavFactory, BreadcrumbFactory, Util, timeSessionExpired, Message, $log) {
	    "ngInject";
	
	    _classCallCheck(this, AuthService);
	
	    this.$http = $http;
	    this.$auth = $auth;
	    this.$rootScope = $rootScope;
	    this.$uibModalStack = $uibModalStack;
	    this.$location = $location;
	    this.Storage = Storage;
	    this.Util = Util;
	    this.Message = Message;
	    this.Filter = Filter;
	    this.$log = $log;
	    this.SidenavFactory = SidenavFactory;
	    this.BreadcrumbFactory = BreadcrumbFactory;
	    this.timeSessionExpired = timeSessionExpired;
	}
	
	/*
	signin(data, url) {
	    this.$auth.login(data, url)
	    .then(response => {
	        let user = response.data.datos.usuario;
	        let menu = response.data.datos.menu;
	        let rol = user.rol;
	        // data.path = data.path || 'dashboard';
	        let pathRedirect = data.path || response.data.datos.menuEntrar;
	        user.pathLogin = data.pathLogin || 'login';
	         this.$rootScope.auth = true;
	         // Set user
	        user.pathInicio = pathRedirect;
	        this.SidenavFactory.setUser(user);
	        this.Storage.setUser(user);
	         // Set Menu
	        this.SidenavFactory.setMenu(menu);
	        this.Storage.set('menu', this.SidenavFactory.getMenu());
	         // Set rol
	        this.SidenavFactory.setRol(rol);
	        this.Storage.set('rol', this.SidenavFactory.getRol());
	         // Set Visible
	        this.SidenavFactory.setVisible(data.menu === undefined ? true : data.menu);
	        this.Storage.set('visible', this.SidenavFactory.getVisible());
	         // Set Sidenav
	        this.SidenavFactory.setSidenav(data.sidenav === undefined ? true : data.sidenav);
	        this.Storage.set('sidenav', this.SidenavFactory.getSidenav());
	         let path = pathRedirect || this.Storage.get('path');
	         if (path) {
	            let route = path.replace('/', '');
	             // Set breadcrumb
	            let page = this.Util.getMenuOption(this.Storage.get('menu'), route);
	            this.BreadcrumbFactory.setParent(page[0]);
	            this.BreadcrumbFactory.setCurrent(page[1]);
	        }
	         this.timerSession();
	         // Redirect to dashboard
	        this.$location.path(path && path.indexOf('login') == -1 ? path : (data.path || '/'));
	    }).catch(error => {
	        if (error.data && error.data.mensaje) {
	            this.Message.error(error.data.mensaje);
	        } else {
	            this.Message.error('No se pudo conectar con el servicio, por favor revise su conexión a internet o intente nuevamente más tarde.');
	        }
	    });
	}
	 timerSession() {
	    // Definiendo el tiempo que dura una sesión sin actividad
	    angular.TIME = this.timeSessionExpired * 60;
	    var ctrl = this;
	    angular.sessionInterval = window.setInterval(function () {
	        angular.TIME--;
	        if (angular.TIME <= 0) {
	            angular.expired = true;
	            ctrl.logout();
	        }
	    }, 1000);
	}
	 logout() {
	    let pathLogin = 'login';
	    if (this.Storage.existUser() && this.Storage.getUser() && this.Storage.getUser().pathLogin) {
	        pathLogin = this.Storage.getUser().pathLogin;
	    }
	     this.$auth.logout()
	    .then(() => {
	         if (angular.sessionInterval) {
	            window.clearInterval(angular.sessionInterval);
	            angular.sessionInterval = null;
	        }
	         setTimeout(() => {
	            this.$uibModalStack.dismissAll('Cerrando sesión');
	        }, 1000);
	         this.Storage.removeUser();
	        this.Storage.remove('menu');
	        this.Storage.remove('visible');
	        this.Storage.remove('rol');
	        this.Storage.remove('sidenav');
	        this.Storage.remove('dateNow');
	        // this.Storage.remove('path');
	         this.SidenavFactory.setUser({});
	        this.SidenavFactory.setMenu([]);
	        this.SidenavFactory.setVisible(false);
	         if (angular.expired) {
	            this.Storage.set('expired', true);
	            delete angular.expired;
	        }
	        this.$location.path(pathLogin);
	    });
	}
	 isAuthenticated () {
	    return this.$auth.isAuthenticated();
	}
	*/
	;
	AuthService.$inject = ["$http", "$auth", "$location", "$rootScope", "Filter", "$uibModalStack", "Storage", "SidenavFactory", "BreadcrumbFactory", "Util", "timeSessionExpired", "Message", "$log"];
	
	exports.default = AuthService;

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _button = __webpack_require__(348);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _button3 = __webpack_require__(602);
	
	var _button4 = _interopRequireDefault(_button3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ButtonTimelineComponent = {
	  bindings: {
	    proyecto: '<'
	  },
	  controller: _button2.default,
	  template: _button4.default
	};
	
	exports.default = ButtonTimelineComponent;

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _timeline = __webpack_require__(349);
	
	var _timeline2 = _interopRequireDefault(_timeline);
	
	var _timeline3 = __webpack_require__(603);
	
	var _timeline4 = _interopRequireDefault(_timeline3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ModalTimelineController = function () {
	  ModalTimelineController.$inject = ["Modal"];
	  function ModalTimelineController(Modal) {
	    'ngInject';
	
	    _classCallCheck(this, ModalTimelineController);
	
	    this.Modal = Modal;
	  }
	
	  _createClass(ModalTimelineController, [{
	    key: '$onInit',
	    value: function $onInit() {}
	  }, {
	    key: 'verRegistro',
	    value: function verRegistro() {
	      this.Modal.show({
	        template: _timeline4.default,
	        controller: _timeline2.default,
	        data: this.proyecto,
	        size: 'lg'
	      });
	    }
	  }]);
	
	  return ModalTimelineController;
	}();
	
	exports.default = ModalTimelineController;

/***/ }),
/* 349 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReasignarUsuarioController = function () {
	  ReasignarUsuarioController.$inject = ["$uibModalInstance", "data", "DataService", "Message"];
	  function ReasignarUsuarioController($uibModalInstance, data, DataService, Message) {
	    'ngInject';
	
	    _classCallCheck(this, ReasignarUsuarioController);
	
	    this.$uibModalInstance = $uibModalInstance;
	    this.DataService = DataService;
	    this.Message = Message;
	    this.proyecto = data;
	  }
	
	  _createClass(ReasignarUsuarioController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.eventos = [];
	
	      this.DataService.get('proyectos/' + this.proyecto.id_proyecto + '/logs').then(function (resp) {
	        if (resp && resp.finalizado) {
	          for (var i in resp.datos) {
	            var persona = resp.datos[i].usuario.persona;
	            _this.eventos.push({
	              side: 'right',
	              badgeClass: 'warning',
	              badgeIconClass: 'info-circle',
	              estado: resp.datos[i].estado.nombre,
	              fecha: resp.datos[i]._fecha_creacion
	            });
	            _this.eventos.push({
	              side: 'left',
	              badgeClass: 'info',
	              badgeIconClass: resp.datos[i].observacion ? 'eye' : resp.datos[i].objeto_tipo === 'proyecto' ? 'check-circle' : 'edit',
	              nombre: (persona.nombres || '') + ' ' + (persona.primer_apellido || '') + ' ' + (persona.segundo_apellido || ''),
	              rol: resp.datos[i].usuario_rol.descripcion,
	              contenido: resp.datos[i].observacion,
	              fecha: resp.datos[i]._fecha_creacion
	            });
	          }
	          _this.Message.success(resp.mensaje);
	        }
	      });
	    }
	  }, {
	    key: 'cerrar',
	    value: function cerrar() {
	      this.$uibModalInstance.close(false);
	    }
	  }]);
	
	  return ReasignarUsuarioController;
	}();
	
	exports.default = ReasignarUsuarioController;

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _user = __webpack_require__(351);
	
	var _user2 = _interopRequireDefault(_user);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UserComponent = {
	    bindings: {},
	    controller: _user2.default,
	    template: '\n        <div class="container">\n            <h2 class="page-title"><i class="fa fa-user"></i> Usuarios <small><strong>del sistema</strong></small></h2>\n            <div class="card">\n                <div class="card-body">\n                    <crud-table url="$ctrl.url"\n                                ng-title="$ctrl.title"\n                                fields="$ctrl.fields"\n                                fields-create="$ctrl.fieldsCreate"></crud-table>\n                </div>\n            </div>\n        </div>\n    '
	};
	
	exports.default = UserComponent;

/***/ }),
/* 351 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var UserController = function () {
	    function UserController() {
	        'ngInject';
	
	        _classCallCheck(this, UserController);
	    }
	
	    _createClass(UserController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.url = '/users/';
	            this.title = 'Usuario';
	
	            /**
	             * Campos para el listado de la tabla del crud-table
	             * @type {Array}
	             */
	            this.fields = ['id_user', 'username', 'first_name', 'last_name', 'email', 'ci', 'birthday', 'phone'];
	
	            /**
	             * Campos para el formulario de adición del crud-table
	             * @type {Array}
	             */
	            this.fieldsCreate = ['id_user', 'username', 'password', 'first_name', 'last_name', 'email', 'ci', 'birthday', 'phone'];
	        }
	    }]);
	
	    return UserController;
	}();
	
	exports.default = UserController;

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _user = __webpack_require__(350);
	
	var _user2 = _interopRequireDefault(_user);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var User = angular.module('app.user', []).component('appAdminUser', _user2.default).config(["$stateProvider", function ($stateProvider) {
	    $stateProvider.state('user', {
	        url: '/user',
	        component: 'appAdminUser'
	    });
	}]).name;
	
	exports.default = User;

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	'usr strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reconfirmacion = __webpack_require__(354);
	
	var _reconfirmacion2 = _interopRequireDefault(_reconfirmacion);
	
	var _reconfirmacion3 = __webpack_require__(604);
	
	var _reconfirmacion4 = _interopRequireDefault(_reconfirmacion3);
	
	var _integracion = __webpack_require__(19);
	
	var _integracion2 = _interopRequireDefault(_integracion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ReconfirmacionUsuariosComponent = {
	  bindings: {
	    usuario: '=',
	    api: '@?'
	  },
	  controller: _reconfirmacion2.default,
	  template: _reconfirmacion4.default,
	  service: _integracion2.default
	};
	
	exports.default = ReconfirmacionUsuariosComponent;

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _reconfirmacionModal = __webpack_require__(80);
	
	var _reconfirmacionModal2 = _interopRequireDefault(_reconfirmacionModal);
	
	var _reconfirmacionModal3 = __webpack_require__(88);
	
	var _reconfirmacionModal4 = _interopRequireDefault(_reconfirmacionModal3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReconfirmarUsuarioController = function () {
	  ReconfirmarUsuarioController.$inject = ["Modal", "DataService", "_"];
	  function ReconfirmarUsuarioController(Modal, DataService, _) {
	    'ngInject';
	
	    _classCallCheck(this, ReconfirmarUsuarioController);
	
	    this.Modal = Modal;
	    this.DataService = DataService;
	    this._ = _;
	  }
	
	  _createClass(ReconfirmarUsuarioController, [{
	    key: '$onInit',
	    value: function $onInit() {}
	  }, {
	    key: 'reenviarCorreo',
	    value: function reenviarCorreo() {
	      var _this = this;
	
	      var USUARIO = angular.copy(this.usuario);
	      var REENVIO = this.Modal.show({
	        template: _reconfirmacionModal4.default,
	        controller: _reconfirmacionModal2.default,
	        data: {
	          usuario: this.usuario,
	          apiExtra: this.api
	        }
	      });
	      REENVIO.result.then(function (correoReenviado) {
	        if (!correoReenviado) {
	          _this.usuario = USUARIO;
	        }
	      }).catch(function () {});
	    }
	  }]);
	
	  return ReconfirmarUsuarioController;
	}();
	
	exports.default = ReconfirmarUsuarioController;

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	'usr strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _usuario = __webpack_require__(356);
	
	var _usuario2 = _interopRequireDefault(_usuario);
	
	var _usuario3 = __webpack_require__(605);
	
	var _usuario4 = _interopRequireDefault(_usuario3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UsuarioComponent = {
	  bindings: {},
	  controller: _usuario2.default,
	  template: _usuario4.default
	};
	
	exports.default = UsuarioComponent;

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _reconfirmacionModal = __webpack_require__(80);
	
	var _reconfirmacionModal2 = _interopRequireDefault(_reconfirmacionModal);
	
	var _reconfirmacionModal3 = __webpack_require__(88);
	
	var _reconfirmacionModal4 = _interopRequireDefault(_reconfirmacionModal3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var UsuarioController = function () {
	  UsuarioController.$inject = ["DataService", "Storage", "Modal", "$state", "$stateParams", "DataTable", "Proyecto", "$log", "Util", "Message"];
	  function UsuarioController(DataService, Storage, Modal, $state, $stateParams, DataTable, Proyecto, $log, Util, Message) {
	    'ngInject';
	
	    _classCallCheck(this, UsuarioController);
	
	    this.DataService = DataService;
	    this.Storage = Storage;
	    this.Modal = Modal;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.DataTable = DataTable;
	    this.Proyecto = Proyecto;
	    this.$log = $log;
	    this.Util = Util;
	    this.Message = Message;
	  }
	
	  _createClass(UsuarioController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.idUsuario = this.$stateParams.idUsuario == "" ? null : this.$stateParams.idUsuario;
	      // this.$log.log(this);
	
	      this.usuario = {
	        estado: 'ACTIVO',
	        // tipo_departamento: 'UNICO',
	        persona: {
	          // tipo_documento: 'TD_CI',
	        },
	        roles: []
	      };
	      this.estados = [{ value: 'ACTIVO', text: 'ACTIVO' }, { value: 'INACTIVO', text: 'INACTIVO' }];
	
	      // this.tipos_departamento = [
	      //   { value: 'UNICO', text: 'Único' },
	      //   { value: 'REG_OCC', text: 'Regional occidental' },
	      //   { value: 'REG_CEN', text: 'Regional central' },
	      //   { value: 'REG_ORI', text: 'Regional oriental' },
	      //   { value: 'TODOS', text: 'Todos' },
	      // ];
	
	      this.departamentos = [];
	
	      this.roles = [];
	      this.getUsuario();
	    }
	  }, {
	    key: 'getUsuario',
	    value: function getUsuario() {
	      var _this = this;
	
	      this.DataService.get('departamentos').then(function (response) {
	        _this.departamentos = response;
	        _this.departamentos_obj = {};
	        _this.departamentos.forEach(function (dep) {
	          if (!_this.departamentos_obj[dep.codigo]) {
	            _this.departamentos_obj[dep.codigo] = dep;
	          }
	        });
	        return _this.DataService.get('rol');
	      }).then(function (response) {
	        _this.roles = response.datos.rows;
	        _this.roles_obj = {};
	        _this.roles.forEach(function (rol) {
	          if (!_this.roles_obj[rol.id_rol]) {
	            _this.roles_obj[rol.id_rol] = rol;
	          }
	        });
	        if (_this.idUsuario) {
	          return _this.DataService.get('usuario/' + _this.idUsuario);
	        }
	      }).then(function (response) {
	        if (response) {
	          _this.usuario = response.datos;
	          // angular.extend(this.usuario, response.datos);
	          _this.usuario.usuarios_roles.forEach(function (item) {
	            _this.roles_obj[item.fid_rol].valor = true;
	          });
	          _this.usuario.fcod_departamento.forEach(function (item) {
	            _this.departamentos_obj[item].valor = true;
	          });
	        }
	      });
	    }
	  }, {
	    key: 'guardarDatos',
	    value: function guardarDatos(form) {
	      var _this2 = this;
	
	      //this.$log.log(form);
	
	      if (this.usuario && this.usuario.persona) {
	        this.usuario.persona.primer_apellido = (this.usuario.persona.primer_apellido || '').toUpperCase();
	
	        this.usuario.persona.segundo_apellido = (this.usuario.persona.segundo_apellido || '').toUpperCase();
	
	        this.usuario.persona.nombres = (this.usuario.persona.nombres || '').toUpperCase();
	      }
	      this.$log.log(this.usuario);
	      if (form.$valid) {
	        this.usuario.roles = [];
	        this.roles.forEach(function (rol) {
	          if (rol.valor) {
	            _this2.usuario.roles.push(rol.id_rol);
	          }
	        });
	
	        this.usuario.fcod_departamento = [];
	        this.departamentos.forEach(function (dep) {
	          if (dep.valor) {
	            _this2.usuario.fcod_departamento.push(dep.codigo);
	          }
	        });
	
	        if (this.idUsuario) {
	          this.usuario.id = this.idUsuario;
	        }
	        // this.$log.log('form valido', angular.copy(this.usuario));
	
	        this.DataService.save('usuario', this.usuario).then(function (response) {
	          if (response) {
	            _this2.Message.warning(response.mensaje);
	            if (!_this2.idUsuario) {
	              _this2.$state.go('usuarios');
	            }
	            // this.$log.log('exacto', response);
	          }
	        });
	      } else {
	        this.Util.setTouchedForm(form);
	      }
	    }
	  }, {
	    key: 'reenviarContrasenia',
	    value: function reenviarContrasenia() {
	      var _this3 = this;
	
	      var USUARIO = angular.copy(this.usuario);
	      var REENVIO = this.Modal.show({
	        template: _reconfirmacionModal4.default,
	        controller: _reconfirmacionModal2.default,
	        data: {
	          usuario: this.usuario
	        }
	      });
	      REENVIO.result.then(function (correoReenviado) {
	        if (!correoReenviado) {
	          _this3.usuario = USUARIO;
	        }
	      }).catch(function () {});
	    }
	  }]);
	
	  return UsuarioController;
	}();
	
	exports.default = UsuarioController;

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _usuario = __webpack_require__(355);
	
	var _usuario2 = _interopRequireDefault(_usuario);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var usuario = angular.module('app.usuario', []).component('usuario', _usuario2.default).config(["$stateProvider", function ($stateProvider) {
	    $stateProvider.state('usuario', {
	        url: '/usuario/:idUsuario',
	        component: 'usuario'
	    });
	}]).name;
	
	exports.default = usuario;

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	'usr strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _usuarios = __webpack_require__(359);
	
	var _usuarios2 = _interopRequireDefault(_usuarios);
	
	var _usuarios3 = __webpack_require__(606);
	
	var _usuarios4 = _interopRequireDefault(_usuarios3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UsuariosComponent = {
	  bindings: {},
	  controller: _usuarios2.default,
	  template: _usuarios4.default
	};
	
	exports.default = UsuariosComponent;

/***/ }),
/* 359 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var UsuariosController = function () {
	  UsuariosController.$inject = ["$state", "$log", "DataService", "Modal", "Message"];
	  function UsuariosController($state, $log, DataService, Modal, Message) {
	    'ngInject';
	
	    _classCallCheck(this, UsuariosController);
	
	    this.$state = $state;
	    this.$log = $log;
	    this.DataService = DataService;
	    this.Modal = Modal;
	    this.Message = Message;
	  }
	
	  _createClass(UsuariosController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      // this.getProyecto();
	      this.cargarTabla();
	    }
	  }, {
	    key: 'cargarTabla',
	    value: function cargarTabla() {
	      var _this = this;
	
	      var colors = {
	        INACTIVO: 'warning',
	        // ENVIADO: 'primary',
	        ACTIVO: 'success'
	        // INACTIVO: 'warning',
	        // OBSERVADO: 'danger',
	      };
	      this.usuarios = {
	        url: 'usuario',
	        queryExtra: { fid_proyecto: this.idProyecto, origen: 'bandeja' },
	        data: {
	          formly: [{
	            key: 'id_usuario',
	            type: 'input',
	            templateOptions: {
	              label: 'ID',
	              type: 'number'
	            }
	          },
	          // {
	          //   key: 'fid_persona',
	          //   type: 'fid_persona',
	          //   templateOptions: {
	          //     label: 'ID proyecto',
	          //     type: 'number'
	          //   }
	          // },
	          {
	            key: 'numero_documento',
	            type: 'input',
	            templateOptions: {
	              label: 'Nro. de documento',
	              type: 'text'
	            }
	          }, {
	            key: 'nombres',
	            type: 'input',
	            templateOptions: {
	              label: 'Nombre(s)',
	              type: 'text'
	            }
	          }, {
	            key: 'primer_apellido',
	            type: 'input',
	            templateOptions: {
	              label: 'Ap. Paterno',
	              type: 'text'
	            }
	          }, {
	            key: 'segundo_apellido',
	            type: 'input',
	            templateOptions: {
	              label: 'Ap. Materno',
	              type: 'text'
	            }
	          }, {
	            key: 'correo',
	            type: 'input',
	            templateOptions: {
	              label: 'Email',
	              type: 'text'
	            }
	          }, {
	            key: 'roles',
	            type: 'extra',
	            templateOptions: {
	              label: 'Roles',
	              type: 'hidden'
	            }
	          }, {
	            key: 'departamentos',
	            type: 'extra',
	            templateOptions: {
	              label: 'Departamentos',
	              type: 'hidden'
	            }
	          }, {
	            key: 'estado',
	            type: 'select',
	            templateOptions: {
	              label: 'Estado',
	              type: 'select',
	              options: [{ value: 'ACTIVO', name: 'ACTIVO' }, { value: 'INACTIVO', name: 'INACTIVO' }, { value: 'ELIMINADO', name: 'ELIMINADO' }]
	            }
	          }]
	        },
	        fields: ['id_usuario', 'fid_persona', 'numero_documento', 'nombres', 'primer_apellido', 'segundo_apellido', 'correo', 'roles', 'departamentos', 'estado', '_fecha_modificación'],
	        hiddenFields: ['id_usuario', 'fid_persona'],
	        // fks: ['fid_formulario'],
	        permission: {
	          create: true,
	          update: true,
	          delete: false,
	          filter: false
	        },
	        labels: { create: 'NUEVO USUARIO' },
	        eventCreate: function eventCreate() {
	          _this.$state.go('usuario', { idUsuario: null });
	        },
	        eventEdit: function eventEdit(usuario) {
	          _this.$state.go('usuario', { idUsuario: usuario.id_usuario });
	        },
	        clases: {
	          'estado': function estado(item) {
	            // this.$log.log(item);
	            return ['badge', 'badge-' + colors[item.estado]];
	          }
	        }
	      };
	    }
	  }]);
	
	  return UsuariosController;
	}();
	
	exports.default = UsuariosController;

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _usuarios = __webpack_require__(358);
	
	var _usuarios2 = _interopRequireDefault(_usuarios);
	
	var _usuario = __webpack_require__(357);
	
	var _usuario2 = _interopRequireDefault(_usuario);
	
	var _reconfirmacion = __webpack_require__(353);
	
	var _reconfirmacion2 = _interopRequireDefault(_reconfirmacion);
	
	var _usuarios3 = __webpack_require__(361);
	
	var _usuarios4 = _interopRequireDefault(_usuarios3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var usuarios = angular.module('app.usuarios', [_usuario2.default]).component('usuarios', _usuarios2.default).component('reconfirmacionUsuario', _reconfirmacion2.default).service('Usuarios', _usuarios4.default).config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('usuarios', {
	    url: '/usuarios',
	    component: 'usuarios'
	  });
	}]).name;
	
	exports.default = usuarios;

/***/ }),
/* 361 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var UsuariosService = function () {
	  UsuariosService.$inject = ["Storage"];
	  function UsuariosService(Storage) {
	    'ngInject';
	
	    _classCallCheck(this, UsuariosService);
	
	    this.Storage = Storage;
	  }
	
	  _createClass(UsuariosService, [{
	    key: 'getRolesResponsable',
	    value: function getRolesResponsable() {
	      return ['RESP_DEPARTAMENTAL_UPRE', 'TECNICO_UPRE'];
	    }
	  }, {
	    key: 'esResponsableProyecto',
	    value: function esResponsableProyecto() {
	      this.usuario = this.Storage.getUser();
	      return this.getRolesResponsable().indexOf(this.usuario.rol.nombre) !== -1;
	    }
	  }]);
	
	  return UsuariosService;
	}();
	
	exports.default = UsuariosService;

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _admin = __webpack_require__(328);
	
	var _admin2 = _interopRequireDefault(_admin);
	
	var _proyectos = __webpack_require__(485);
	
	var _proyectos2 = _interopRequireDefault(_proyectos);
	
	var _empresas = __webpack_require__(404);
	
	var _empresas2 = _interopRequireDefault(_empresas);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Components = angular.module('app.components', [_admin2.default, _proyectos2.default, _empresas2.default]).name;
	
	exports.default = Components;

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	'usr strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _avanceProyecto = __webpack_require__(364);
	
	var _avanceProyecto2 = _interopRequireDefault(_avanceProyecto);
	
	var _avanceProyecto3 = __webpack_require__(607);
	
	var _avanceProyecto4 = _interopRequireDefault(_avanceProyecto3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvanceProyectoComponent = {
	  bindings: {},
	  controller: _avanceProyecto2.default,
	  template: _avanceProyecto4.default
	};
	
	exports.default = AvanceProyectoComponent;

/***/ }),
/* 364 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AvanceProyectoController = function () {
	  AvanceProyectoController.$inject = ["DataService", "Storage", "Modal", "$state", "$stateParams", "DataTable", "Proyecto"];
	  function AvanceProyectoController(DataService, Storage, Modal, $state, $stateParams, DataTable, Proyecto) {
	    'ngInject';
	
	    _classCallCheck(this, AvanceProyectoController);
	
	    this.DataService = DataService;
	    this.Storage = Storage;
	    this.Modal = Modal;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.DataTable = DataTable;
	    this.Proyecto = Proyecto;
	  }
	
	  _createClass(AvanceProyectoController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.idProyecto = this.$stateParams.idProyecto;
	      this.matricula = this.$stateParams.matricula;
	      this.getProyecto();
	      this.cargarTabla();
	    }
	  }, {
	    key: 'getProyecto',
	    value: function getProyecto() {
	      var _this = this;
	
	      this.DataService.get('proyectos/empresas/' + this.matricula + '/' + this.idProyecto).then(function (response) {
	        _this.proyecto = response.datos;
	        _this.Proyecto.setCopia(response.datos);
	      });
	    }
	  }, {
	    key: 'nuevaSupervision',
	    value: function nuevaSupervision() {
	      var _this2 = this;
	
	      var data = {
	        fid_proyecto: this.idProyecto,
	        computo_metrico: []
	      };
	      this.DataService.post('supervisiones', data).then(function (response) {
	        _this2.irPlanilla(_this2.matricula, _this2.idProyecto, response.datos.id_supervision);
	      });
	    }
	  }, {
	    key: 'irPlanilla',
	    value: function irPlanilla(matricula, idProyecto, idSupervision) {
	      this.$state.go('planilla-proyecto', { idSupervision: idSupervision });
	    }
	
	    // nuevaPlanilla() {
	    //   this.$state.go('planilla', {codigo: this.idProyecto});
	    //   // this.Modal.show({
	    //   //   template: modalPlanillasTemplate,
	    //   //   controller: modalAvanceProyectoController,
	    //   //   size: 'md'
	    //   // }).result.then( result => {
	    //   //   this.$state.go('documentacion-proyecto', {codigo: result.id_proyecto});
	    //   // });
	    // }
	
	
	  }, {
	    key: 'cargarTabla',
	    value: function cargarTabla() {
	      var _this3 = this;
	
	      var colors = {
	        NUEVO: 'default',
	        ENVIADO: 'primary',
	        APROBADO: 'success',
	        PENDIENTE_PAGO: 'warning',
	        OBSERVADO: 'danger'
	      };
	      this.planillas = {
	        url: 'supervisiones',
	        queryExtra: { fid_proyecto: this.idProyecto, origen: 'bandeja' },
	        data: {
	          formly: [{
	            key: 'id_supervision',
	            type: 'input',
	            templateOptions: {
	              label: 'ID',
	              type: 'number'
	            }
	          }, {
	            key: 'fid_proyecto',
	            type: 'fid_proyecto',
	            templateOptions: {
	              label: 'ID proyecto',
	              type: 'number'
	            }
	          }, {
	            key: 'nro_supervision',
	            type: 'input',
	            templateOptions: {
	              label: 'Nro',
	              type: 'number'
	            }
	          }, {
	            key: 'fecha_inicio',
	            type: 'datepicker',
	            templateOptions: {
	              label: 'Fecha de creación',
	              type: 'date'
	            }
	          }, {
	            key: 'fecha_fin',
	            type: 'datepicker',
	            templateOptions: {
	              label: 'Fecha de creación',
	              type: 'date'
	            }
	          }, {
	            key: 'data',
	            type: 'input',
	            templateOptions: {
	              label: 'Fid caeb',
	              type: 'number'
	            }
	          }, {
	            key: 'estado_supervision',
	            type: 'select',
	            templateOptions: {
	              label: 'Estado',
	              type: 'select',
	              options: [{ value: 'NUEVO', name: 'NUEVO' }, { value: 'ENVIADO', name: 'ENVIADO' }, { value: 'APROBADO', name: 'APROBADO' }, { value: 'OBSERVADO', name: 'OBSERVADO' }]
	            }
	          }]
	        },
	        fields: ['id_supervision', 'fid_proyecto', 'nro_supervision', 'fecha_inicio', 'fecha_fin', 'data', 'estado_supervision'],
	        hiddenFields: ['id_supervision', 'fid_proyecto', 'id_producto', 'extra'],
	        // fks: ['fid_formulario'],
	        permission: {
	          create: true,
	          update: false,
	          delete: false,
	          filter: false
	        },
	        labels: { create: 'NUEVA PLANILLA' },
	        eventCreate: function eventCreate() {
	          _this3.nuevaSupervision();
	        },
	        buttons: [{
	          icon: 'eye',
	          tooltip: 'Ver planilla',
	          // if: (ev, item) => { return item.estado==='APROBADO'; },
	          onclick: function onclick(ev, item) {
	
	            _this3.irPlanilla(_this3.matricula, _this3.idProyecto, item.id_supervision);
	            // this.$log.log(ev, item);
	            // this.Modal.pdf(`cert_sello_bolivia/productos_shb/ddjj_sello_bolivia/${item.id_sello_bolivia}`);
	          }
	        }],
	        clases: {
	          estado: function estado(item) {
	            // this.$log.log(item);
	            return ['badge', 'badge-' + colors[item.estado]];
	          }
	        }
	      };
	    }
	  }]);
	
	  return AvanceProyectoController;
	}();
	
	exports.default = AvanceProyectoController;

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _avanceProyecto = __webpack_require__(363);
	
	var _avanceProyecto2 = _interopRequireDefault(_avanceProyecto);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var avanceProyecto = angular.module('app.avanceProyecto', []).component('avanceProyecto', _avanceProyecto2.default).config(["$stateProvider", function ($stateProvider) {
	    $stateProvider.state('avance-proyecto', {
	        url: '/avance-proyecto/:matricula/:idProyecto',
	        component: 'avanceProyecto'
	    });
	}]).name;
	
	exports.default = avanceProyecto;

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _proyectoAdjudicado = __webpack_require__(388);
	
	var _proyectoAdjudicado2 = _interopRequireDefault(_proyectoAdjudicado);
	
	var _codigoContrato = __webpack_require__(367);
	
	var _codigoContrato2 = _interopRequireDefault(_codigoContrato);
	
	var _datosEmpresa = __webpack_require__(373);
	
	var _datosEmpresa2 = _interopRequireDefault(_datosEmpresa);
	
	var _datosAsociacion = __webpack_require__(371);
	
	var _datosAsociacion2 = _interopRequireDefault(_datosAsociacion);
	
	var _datosIntegrantes = __webpack_require__(375);
	
	var _datosIntegrantes2 = _interopRequireDefault(_datosIntegrantes);
	
	var _presupuestoItems = __webpack_require__(386);
	
	var _presupuestoItems2 = _interopRequireDefault(_presupuestoItems);
	
	var _experiencia = __webpack_require__(382);
	
	var _experiencia2 = _interopRequireDefault(_experiencia);
	
	var _empleados = __webpack_require__(377);
	
	var _empleados2 = _interopRequireDefault(_empleados);
	
	var _equipoMinimo = __webpack_require__(380);
	
	var _equipoMinimo2 = _interopRequireDefault(_equipoMinimo);
	
	var _cronogramas = __webpack_require__(369);
	
	var _cronogramas2 = _interopRequireDefault(_cronogramas);
	
	var _formularios = __webpack_require__(384);
	
	var _formularios2 = _interopRequireDefault(_formularios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CEmpresas = angular.module('app.cEmpresas', []).component('proyectoAdjudicado', _proyectoAdjudicado2.default).component('codigoContrato', _codigoContrato2.default).component('datosEmpresa', _datosEmpresa2.default).component('datosAsociacion', _datosAsociacion2.default).component('datosIntegrantes', _datosIntegrantes2.default).component('presupuestoItems', _presupuestoItems2.default).component('experienciaEmpresa', _experiencia2.default).component('empleados', _empleados2.default).component('equipoMinimo', _equipoMinimo2.default).component('cronogramas', _cronogramas2.default).component('formulariosGenerados', _formularios2.default).name;
	
	exports.default = CEmpresas;

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _codigoContrato = __webpack_require__(368);
	
	var _codigoContrato2 = _interopRequireDefault(_codigoContrato);
	
	var _codigoContrato3 = __webpack_require__(608);
	
	var _codigoContrato4 = _interopRequireDefault(_codigoContrato3);
	
	var _integracion = __webpack_require__(19);
	
	var _integracion2 = _interopRequireDefault(_integracion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CodigoContratoComponent = {
	  bindings: {
	    proyecto: '=',
	    modoVista: '<',
	    tieneDocumentacion: '=?',
	    codigoDocumentacion: '<?'
	  },
	  controller: _codigoContrato2.default,
	  template: _codigoContrato4.default,
	  service: _integracion2.default
	};
	
	exports.default = CodigoContratoComponent;

/***/ }),
/* 368 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CodigoContratoController = function () {
	  CodigoContratoController.$inject = ["Modal", "$log", "Integracion", "$state"];
	  function CodigoContratoController(Modal, $log, Integracion, $state) {
	    'ngInject';
	
	    _classCallCheck(this, CodigoContratoController);
	
	    this.Modal = Modal;
	    this.$log = $log;
	    this.Integracion = Integracion;
	    this.$state = $state;
	  }
	
	  _createClass(CodigoContratoController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.obtenerConexion();
	
	      if (this.proyecto.cod_documentacion_exp) {
	        this.tieneDocumentacion = true;
	      }
	      this.$log.log('LISTAPROYECTOS====>', this.proyecto);
	    }
	  }, {
	    key: 'cambiarDocumentacion',
	    value: function cambiarDocumentacion() {
	      var _this = this;
	
	      this.Modal.confirm('¿Está seguro/a de modificar la información registrada de la empresa?', function () {
	        _this.tieneDocumentacion = false;
	      });
	    }
	  }, {
	    key: 'cancelarCambio',
	    value: function cancelarCambio() {
	      this.proyecto.cod_documentacion_exp = this.codigoDocumentacion;
	      this.tieneDocumentacion = true;
	    }
	  }, {
	    key: 'procesoDocumentacionEmpresa',
	    value: function procesoDocumentacionEmpresa() {
	      var _this2 = this;
	
	      this.Modal.confirm('\xBFEst\xE1 seguro/a de modificar el c\xF3digo de formulario, de la propuesta registrada por la empresa?\n    <br><br><br><p> Nota: si acepta en la secci\xF3n de PENDIENTES, de click en el boton editar (imagen l\xE1piz) ahi encontrara su proyecto, para que pueda realizar el cambio del nuevo codigo de formulario generado en el sistema de <strong>Registro de Empresas</strong</p>\n    ', function () {
	        var dts = _this2.Integracion.cambioEstadoProyecto('REGISTRO_EMPRESA', _this2.proyecto.id_proyecto, _this2.dtsUsuario.id_usuario, _this2.dtsRol.id_rol);
	        dts.then(function successCallback(respuesta) {
	          return respuesta.data;
	          //console.log(respuesta.data);
	        }).then(function (dts) {
	          _this2.$log.log('valor devuelto', dts);
	
	          _this2.$state.go('pendientes');
	          //console.log(dts);
	        });
	      });
	    }
	  }, {
	    key: 'cancelarDocumentacionEmpresa',
	    value: function cancelarDocumentacionEmpresa() {}
	  }, {
	    key: 'obtenerConexion',
	    value: function obtenerConexion() {
	
	      this.dtsRol = JSON.parse(localStorage.getItem("upre_rol"));
	      this.dtsUsuario = JSON.parse(localStorage.getItem("upre_user"));
	      this.habilitacionBotonDocumentacionEmpresa();
	    }
	  }, {
	    key: 'habilitacionBotonDocumentacionEmpresa',
	    value: function habilitacionBotonDocumentacionEmpresa() {
	      if ((this.proyecto.estado_proyecto == 'REGISTRO_GARANTIAS_CIFE' || this.proyecto.estado_proyecto == 'REGISTRO_GARANTIAS_MAE' || this.proyecto.estado_proyecto == 'REGISTRO_GARANTIAS' || this.proyecto.estado_proyecto == 'APROBACION_TECNICO_CIF_MAE' || this.proyecto.estado_proyecto == 'APROBACION_TECNICO') && this.dtsRol.nombre == 'EMPRESA') {
	        this.estadoBoton = true;
	        this.$log.log('estado boton', this.estadoBoton);
	      } else {
	        this.estadoBoton = false;
	        this.$log.log('estado boton', this.estadoBoton);
	      }
	    }
	  }]);
	
	  return CodigoContratoController;
	}();
	
	exports.default = CodigoContratoController;

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cronogramas = __webpack_require__(370);
	
	var _cronogramas2 = _interopRequireDefault(_cronogramas);
	
	var _cronogramas3 = __webpack_require__(609);
	
	var _cronogramas4 = _interopRequireDefault(_cronogramas3);
	
	__webpack_require__(187);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cronogramasComponent = {
	  bindings: {
	    proyecto: '='
	  },
	  controller: _cronogramas2.default,
	  template: _cronogramas4.default
	};
	
	exports.default = cronogramasComponent;

/***/ }),
/* 370 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CronogramasController = function () {
	  CronogramasController.$inject = ["DataService", "_", "$log", "Modal", "apiUrl"];
	  function CronogramasController(DataService, _, $log, Modal, apiUrl) {
	    'ngInject';
	
	    _classCallCheck(this, CronogramasController);
	
	    this.DataService = DataService;
	    this._ = _;
	    this.$log = $log;
	    this.Modal = Modal;
	    this.apiUrl = apiUrl;
	  }
	
	  _createClass(CronogramasController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.documentos = this.getConfiguracion();
	      this.verificarArchivosCargados();
	    }
	  }, {
	    key: 'getConfiguracion',
	    value: function getConfiguracion() {
	      var _this = this;
	
	      return {
	        lista: [{
	          codigo: 'c_ejecucion',
	          nombre: 'Cronograma de ejecución',
	          nombre_formulario: 'Formulario A8',
	          tipo: 'A8',
	          urlDescarga: this.apiUrl + 'proyectos/' + this.proyecto.id_proyecto + '/doc/A8/descargar'
	        }, {
	          codigo: 'c_desembolsos',
	          nombre: 'Cronograma de Desembolsos',
	          nombre_formulario: 'Formulario B5',
	          tipo: 'B5',
	          urlDescarga: this.apiUrl + 'proyectos/' + this.proyecto.id_proyecto + '/doc/B5/descargar'
	        }, {
	          codigo: 'analisis_precios_unitarios',
	          nombre: 'Análisis de Precios Unitarios',
	          nombre_formulario: 'Formulario B2',
	          tipo: 'B2',
	          urlDescarga: this.apiUrl + 'proyectos/' + this.proyecto.id_proyecto + '/doc/B2/descargar'
	        }],
	        uploadCallback: function uploadCallback(file) {
	          var data = {
	            documento: angular.copy(file)
	          };
	          _this.DataService.put('proyectos/' + _this.proyecto.id_proyecto + '/doc/' + _this.getTipo(file) + '/subir', data).then(function (response) {
	            _this.$log.log('response------', response);
	            if (response && response.finalizado) {
	              _this.asignarDatos(file, response.datos.documento);
	            }
	          });
	        }
	      };
	    }
	  }, {
	    key: 'verificarArchivosCargados',
	    value: function verificarArchivosCargados() {
	      var _this2 = this;
	
	      this.documentos.lista.map(function (documento) {
	        var FORMULARIO = _this2.getFormularioRegistrado(documento);
	        if (FORMULARIO) {
	          documento.registrado = true;
	          documento.nombre_archivo = FORMULARIO.nombre_archivo;
	        }
	      });
	    }
	  }, {
	    key: 'asignarDatos',
	    value: function asignarDatos(archivo, docCreado) {
	      var index = this._.findIndex(this.documentos.lista, { codigo: archivo.name });
	      this.documentos.lista[index].base64 = archivo.base64;
	      this.documentos.lista[index].nombre_formulario = docCreado.nombre;
	      this.documentos.lista[index].nombre_archivo = docCreado.nombre_archivo;
	      this.documentos.lista[index].registrado = true;
	      var formulario = this.getFormularioRegistrado(docCreado);
	      if (!formulario) {
	        if (!this.proyecto.formularios) {
	          this.proyecto.formularios = [];
	        }
	        this.proyecto.formularios.push(docCreado);
	      } else {
	        formulario = docCreado;
	      }
	    }
	  }, {
	    key: 'getFormularioRegistrado',
	    value: function getFormularioRegistrado(documento) {
	      return this._.find(this.proyecto.formularios, { codigo_documento: documento.tipo });
	    }
	  }, {
	    key: 'cambiar',
	    value: function cambiar(documento) {
	      if (documento.registrado) {
	        this.Modal.confirm('\xBFEst\xE1 seguro/a de cambiar el ' + documento.nombre + '?', function () {
	          documento.registrado = false;
	        }, null, null, 'Si, estoy seguro', 'Cancelar');
	      }
	    }
	  }, {
	    key: 'verDocumento',
	    value: function verDocumento(documento) {
	      var URL = 'proyectos/' + this.proyecto.id_proyecto + '/doc/' + documento.tipo;
	      this.Modal.showDocumentBase64(URL, '' + documento.nombre);
	    }
	  }, {
	    key: 'getTipo',
	    value: function getTipo(archivo) {
	      return this._.find(this.documentos.lista, { codigo: archivo.name }).tipo;
	    }
	  }]);
	
	  return CronogramasController;
	}();
	
	exports.default = CronogramasController;

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _datosAsociacion = __webpack_require__(372);
	
	var _datosAsociacion2 = _interopRequireDefault(_datosAsociacion);
	
	var _datosAsociacion3 = __webpack_require__(610);
	
	var _datosAsociacion4 = _interopRequireDefault(_datosAsociacion3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DatosAsociacionComponent = {
	  bindings: {
	    empresa: '=',
	    asociacion: '='
	  },
	  controller: _datosAsociacion2.default,
	  template: _datosAsociacion4.default
	};
	
	exports.default = DatosAsociacionComponent;

/***/ }),
/* 372 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DatosAsociacionController = function DatosAsociacionController() {
	  _classCallCheck(this, DatosAsociacionController);
	};
	
	exports.default = DatosAsociacionController;

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _datosEmpresa = __webpack_require__(374);
	
	var _datosEmpresa2 = _interopRequireDefault(_datosEmpresa);
	
	var _datosEmpresa3 = __webpack_require__(611);
	
	var _datosEmpresa4 = _interopRequireDefault(_datosEmpresa3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DatosEmpresaComponent = {
	  bindings: {
	    empresa: '='
	  },
	  controller: _datosEmpresa2.default,
	  template: _datosEmpresa4.default
	};
	
	exports.default = DatosEmpresaComponent;

/***/ }),
/* 374 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DatosEmpresaController = function DatosEmpresaController() {
	  _classCallCheck(this, DatosEmpresaController);
	};
	
	exports.default = DatosEmpresaController;

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _datosIntegrantes = __webpack_require__(376);
	
	var _datosIntegrantes2 = _interopRequireDefault(_datosIntegrantes);
	
	var _datosIntegrantes3 = __webpack_require__(612);
	
	var _datosIntegrantes4 = _interopRequireDefault(_datosIntegrantes3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DatosIntegrantesComponent = {
	  bindings: {
	    integrantes: '='
	  },
	  controller: _datosIntegrantes2.default,
	  template: _datosIntegrantes4.default
	};
	
	exports.default = DatosIntegrantesComponent;

/***/ }),
/* 376 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DatosIntegrantesController = function DatosIntegrantesController() {
	  _classCallCheck(this, DatosIntegrantesController);
	};
	
	exports.default = DatosIntegrantesController;

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _empleados = __webpack_require__(378);
	
	var _empleados2 = _interopRequireDefault(_empleados);
	
	var _empleados3 = __webpack_require__(613);
	
	var _empleados4 = _interopRequireDefault(_empleados3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EmpleadosComponent = {
	  bindings: {
	    empleados: '='
	  },
	  controller: _empleados2.default,
	  template: _empleados4.default
	};
	
	exports.default = EmpleadosComponent;

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _experienciaEmpleadoModalController = __webpack_require__(379);
	
	var _experienciaEmpleadoModalController2 = _interopRequireDefault(_experienciaEmpleadoModalController);
	
	var _experienciaEmpleadoModal = __webpack_require__(614);
	
	var _experienciaEmpleadoModal2 = _interopRequireDefault(_experienciaEmpleadoModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EmpleadosController = function () {
	  EmpleadosController.$inject = ["DataTable", "Modal", "$scope"];
	  function EmpleadosController(DataTable, Modal, $scope) {
	    'ngInject';
	
	    _classCallCheck(this, EmpleadosController);
	
	    this.DataTable = DataTable;
	    this.Modal = Modal;
	    this.$scope = $scope;
	  }
	
	  _createClass(EmpleadosController, [{
	    key: '$onInit',
	    value: function $onInit() {}
	  }, {
	    key: '$onChanges',
	    value: function $onChanges() {
	      var _this = this;
	
	      this.$scope.$watch('$ctrl.empleados', function () {
	        _this.iniciarDatos();
	      }, true);
	    }
	  }, {
	    key: 'iniciarDatos',
	    value: function iniciarDatos() {
	      this.tableParams = this.DataTable.getParamsList(this.getFormatoLista());
	    }
	  }, {
	    key: 'getFormatoLista',
	    value: function getFormatoLista() {
	      var _this2 = this;
	
	      var lista = [];
	      this.empleados.map(function (empleado) {
	        lista.push(_this2.formatearEstructuraDatos(empleado));
	      });
	      return lista;
	    }
	  }, {
	    key: 'formatearEstructuraDatos',
	    value: function formatearEstructuraDatos(datos) {
	      return {
	        nombre: datos.nombre,
	        documento_identidad: datos.persona.documento_identidad,
	        nacionalidad: datos.persona.nacionalidad,
	        profesion: datos.profesion,
	        nro_registro_profesional: datos.nro_registro_profesional,
	        cargo_actual: datos.cargo_actual,
	        experiencias: datos.experiencias
	      };
	    }
	  }, {
	    key: 'verExperiencia',
	    value: function verExperiencia(empleado) {
	      this.Modal.show({
	        template: _experienciaEmpleadoModal2.default,
	        controller: _experienciaEmpleadoModalController2.default,
	        data: {
	          empleado: empleado
	        },
	        size: 'xlg'
	      });
	    }
	  }]);
	
	  return EmpleadosController;
	}();
	
	exports.default = EmpleadosController;

/***/ }),
/* 379 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FormExperienciaEmpleadoController = function () {
	  FormExperienciaEmpleadoController.$inject = ["$uibModalInstance", "data"];
	  function FormExperienciaEmpleadoController($uibModalInstance, data) {
	    'ngInject';
	
	    _classCallCheck(this, FormExperienciaEmpleadoController);
	
	    this.$uibModalInstance = $uibModalInstance;
	    this.data = data;
	    this.empleado = data.empleado;
	  }
	
	  _createClass(FormExperienciaEmpleadoController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.camposExperiencia = this.definirColumnasEmpleados();
	    }
	  }, {
	    key: 'definirColumnasEmpleados',
	    value: function definirColumnasEmpleados() {
	      return [{ title: 'Empresa/Entidad', field: 'nombre_empresa', filter: { nombre_empresa: "text" }, sortable: "nombre_empresa" }, { title: 'Objeto de la obra', field: 'objeto_obra', filter: { objeto_obra: "text" }, sortable: "objeto_obra" }, { title: 'Monto de la obra en Bs.', field: 'monto_obra', filter: { monto_obra: "text" }, sortable: "monto_obra" }, { title: 'Cargo', field: 'cargo', filter: { cargo: "text" }, sortable: "cargo" }, { title: 'Desde', field: 'fecha_inicio', filter: { fecha_inicio: "text" }, sortable: "fecha_inicio" }, { title: 'Hasta', field: 'fecha_fin', filter: { fecha_fin: "text" }, sortable: "fecha_fin" }];
	    }
	  }, {
	    key: 'aceptar',
	    value: function aceptar() {
	      this.$uibModalInstance.close(null);
	    }
	  }, {
	    key: 'cerrar',
	    value: function cerrar() {
	      this.$uibModalInstance.dismiss('cancel');
	    }
	  }]);
	
	  return FormExperienciaEmpleadoController;
	}();
	
	exports.default = FormExperienciaEmpleadoController;

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _equipoMinimo = __webpack_require__(381);
	
	var _equipoMinimo2 = _interopRequireDefault(_equipoMinimo);
	
	var _equipoMinimo3 = __webpack_require__(615);
	
	var _equipoMinimo4 = _interopRequireDefault(_equipoMinimo3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EquipoMinimoComponent = {
	  bindings: {
	    equipo: '='
	  },
	  controller: _equipoMinimo2.default,
	  template: _equipoMinimo4.default
	};
	
	exports.default = EquipoMinimoComponent;

/***/ }),
/* 381 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EquipoMinimoController = function () {
	  EquipoMinimoController.$inject = ["DataTable"];
	  function EquipoMinimoController(DataTable) {
	    'ngInject';
	
	    _classCallCheck(this, EquipoMinimoController);
	
	    this.DataTable = DataTable;
	  }
	
	  _createClass(EquipoMinimoController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.camposEquipo = this.definirColumnasEquipoTrabajo();
	    }
	  }, {
	    key: 'definirColumnasEquipoTrabajo',
	    value: function definirColumnasEquipoTrabajo() {
	      return [{ title: 'Descripción', field: 'descripcion', filter: { descripcion: "text" }, sortable: "descripcion" }, { title: 'Unidad', field: 'unidad', filter: { unidad: "text" }, sortable: "unidad" }, { title: 'Cantidad', field: 'cantidad', filter: { cantidad: "text" }, sortable: "cantidad" }, { title: 'Potencia', field: 'potencia', filter: { potencia: "text" }, sortable: "potencia" }, { title: 'Capacidad', field: 'capacidad', filter: { capacidad: "text" }, sortable: "capacidad" }, { title: 'Campo adicional', field: 'campo_adicional', filter: { campo_adicional: "text" }, sortable: "campo_adicional" }];
	    }
	  }]);
	
	  return EquipoMinimoController;
	}();
	
	exports.default = EquipoMinimoController;

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _experiencia = __webpack_require__(383);
	
	var _experiencia2 = _interopRequireDefault(_experiencia);
	
	var _experiencia3 = __webpack_require__(616);
	
	var _experiencia4 = _interopRequireDefault(_experiencia3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ExperienciaEmpresaComponent = {
	  bindings: {
	    experiencias: '='
	  },
	  controller: _experiencia2.default,
	  template: _experiencia4.default
	};
	
	exports.default = ExperienciaEmpresaComponent;

/***/ }),
/* 383 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ExperienciaEmpresaController = function () {
	  ExperienciaEmpresaController.$inject = ["DataTable", "_", "Util", "$scope"];
	  function ExperienciaEmpresaController(DataTable, _, Util, $scope) {
	    'ngInject';
	
	    _classCallCheck(this, ExperienciaEmpresaController);
	
	    this.DataTable = DataTable;
	    this._ = _;
	    this.Util = Util;
	    this.$scope = $scope;
	    this.totalDolares = 0;
	    this.totalBolivianos = 0;
	  }
	
	  _createClass(ExperienciaEmpresaController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.camposExperiencia = this.definirColumnasExperiencias();
	    }
	  }, {
	    key: '$onChanges',
	    value: function $onChanges() {
	      var _this = this;
	
	      this.$scope.$watch('$ctrl.experiencias', function () {
	        _this.calcularSumasDeMontos();
	      }, true);
	    }
	  }, {
	    key: 'calcularSumasDeMontos',
	    value: function calcularSumasDeMontos() {
	      this.totalesExpGeneral = this.calcularSumas(this.experiencias.generales);
	      this.totalesExpEspecifica = this.calcularSumas(this.experiencias.especificas);
	    }
	  }, {
	    key: 'calcularSumas',
	    value: function calcularSumas(experiencias) {
	      var total = {
	        dolares: null,
	        bolivianos: null
	      };
	      if (this.tieneMontosEnDolaresCompletos(experiencias)) {
	        total.dolares = this.calcularTotales(experiencias, 'monto_final_contrato_sus');
	      }
	      total.bolivianos = this.calcularTotales(experiencias, 'monto_final_contrato_bs');
	      return total;
	    }
	  }, {
	    key: 'tieneMontosEnDolaresCompletos',
	    value: function tieneMontosEnDolaresCompletos(experiencias) {
	      return this._.isEmpty(this._.find(experiencias, {
	        monto_final_contrato_sus: null
	      }));
	    }
	  }, {
	    key: 'calcularTotales',
	    value: function calcularTotales(experiencias, tipo) {
	      return this.Util.redondear(this._.sum(this._.map(experiencias, tipo)));
	    }
	  }, {
	    key: 'definirColumnasExperiencias',
	    value: function definirColumnasExperiencias() {
	      return [{ title: 'Nombre del Contratante', field: 'nombre_contratante', filter: { nombre_contratante: "text" }, visible: true, sortable: "nombre_contratante" }, { title: 'Dirección de Contacto', field: 'direccion_contacto', filter: { direccion_contacto: "text" }, visible: true, sortable: "direccion_contacto" }, { title: 'Objeto de Contrato', field: 'objeto_contratacion', filter: { objeto_contratacion: "text" }, visible: true, sortable: "objeto_contratacion" }, { title: 'Ubicación', field: 'ubicacion', filter: { ubicacion: "text" }, visible: true, sortable: "ubicacion" }, { title: 'Monto Final de Contrato Bs', field: 'monto_final_contrato_bs', filter: { monto_final_contrato_bs: "number" }, visible: true, sortable: "monto_final_contrato_bs" }, { title: 'Monto Final de Contrato $us', field: 'monto_final_contrato_sus', filter: { monto_final_contrato_sus: "number" }, visible: true, sortable: "monto_final_contrato_sus" }, { title: 'Inicio', field: 'fecha_inicio_ejecucion', filter: { fecha_inicio_ejecucion: "text" }, visible: true, sortable: "fecha_inicio_ejecucion" }, { title: 'Finalización', field: 'fecha_fin_ejecucion', filter: { fecha_fin_ejecucion: "text" }, visible: true, sortable: "fecha_fin_ejecucion" }, { title: '% de Participación', field: 'participacion', filter: { participacion: "text" }, visible: true, sortable: "participacion" }, { title: 'Nombre del Socio', field: 'socio', filter: { socio: "text" }, visible: true, sortable: "socio" }, { title: 'Profesional Responsable', field: 'profesional_responsable', filter: { profesional_responsable: "text" }, visible: true, sortable: "profesional_responsable" }];
	    }
	  }]);
	
	  return ExperienciaEmpresaController;
	}();
	
	exports.default = ExperienciaEmpresaController;

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _formularios = __webpack_require__(385);
	
	var _formularios2 = _interopRequireDefault(_formularios);
	
	var _formularios3 = __webpack_require__(617);
	
	var _formularios4 = _interopRequireDefault(_formularios3);
	
	__webpack_require__(188);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FormulariosGeneradosComponent = {
	  bindings: {
	    proyecto: '='
	  },
	  controller: _formularios2.default,
	  template: _formularios4.default
	};
	
	exports.default = FormulariosGeneradosComponent;

/***/ }),
/* 385 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FormulariosGeneradosController = function () {
	  FormulariosGeneradosController.$inject = ["DataService", "$stateParams", "Message", "_", "Modal", "apiUrl"];
	  function FormulariosGeneradosController(DataService, $stateParams, Message, _, Modal, apiUrl) {
	    'ngInject';
	
	    _classCallCheck(this, FormulariosGeneradosController);
	
	    this.DataService = DataService;
	    this.$stateParams = $stateParams;
	    this.Message = Message;
	    this._ = _;
	    this.Modal = Modal;
	    this.apiUrl = apiUrl;
	    this.url = '';
	  }
	
	  _createClass(FormulariosGeneradosController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.url = 'proyectos/' + this.proyecto.id_proyecto + '/doc';
	      this.prepararLista();
	    }
	  }, {
	    key: 'prepararLista',
	    value: function prepararLista() {
	      var _this = this;
	
	      if (this.proyecto.formularios) {
	        this.asignarPath();
	      } else {
	        this.DataService.get(this.url).then(function (result) {
	          if (result && result.finalizado) {
	            _this.proyecto.formularios = result.datos.formularios;
	            _this.asignarPath();
	          }
	        });
	      }
	    }
	  }, {
	    key: 'asignarPath',
	    value: function asignarPath() {
	      var _this2 = this;
	
	      this.proyecto.formularios.map(function (formulario) {
	        formulario.path = _this2.apiUrl + 'proyectos/' + _this2.proyecto.id_proyecto + '/doc/' + formulario.codigo_documento + '/descargar';
	      });
	    }
	  }, {
	    key: 'ver',
	    value: function ver(formulario) {
	      this.Modal.showDocumentBase64(this.url + '/' + formulario.codigo_documento, '' + formulario.nombre);
	    }
	  }]);
	
	  return FormulariosGeneradosController;
	}();
	
	exports.default = FormulariosGeneradosController;

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _presupuestoItems = __webpack_require__(387);
	
	var _presupuestoItems2 = _interopRequireDefault(_presupuestoItems);
	
	var _presupuestoItems3 = __webpack_require__(618);
	
	var _presupuestoItems4 = _interopRequireDefault(_presupuestoItems3);
	
	__webpack_require__(189);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PresupuestoItemsComponent = {
	  bindings: {
	    proyecto: '='
	  },
	  controller: _presupuestoItems2.default,
	  template: _presupuestoItems4.default
	};
	
	exports.default = PresupuestoItemsComponent;

/***/ }),
/* 387 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PresupuestoItemsController = function () {
	  PresupuestoItemsController.$inject = ["DataService", "$stateParams", "Message", "_", "Util", "Big", "decimales", "Storage"];
	  function PresupuestoItemsController(DataService, $stateParams, Message, _, Util, Big, decimales, Storage) {
	    'ngInject';
	
	    _classCallCheck(this, PresupuestoItemsController);
	
	    this.DataService = DataService;
	    this.$stateParams = $stateParams;
	    this.Message = Message;
	    this._ = _;
	    this.Util = Util;
	    this.Big = Big;
	    this.decimales = decimales;
	    this.precioTotal = 0;
	    this.usuario = Storage.getUser();
	  }
	
	  _createClass(PresupuestoItemsController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      // Monto fisico total avanzado hasta la rescision de contrato.
	      if (this.proyecto.monto_total_ejecutado) {
	        this.proyecto.monto_total_actual = this.proyecto.monto_total; // Monto total con modificaciones hasta la rescision de contrato.
	      }
	      this.proyecto.monto_total = null;
	      this.DataService.get('items/proyectos/' + this.$stateParams.codigo).then(function (response) {
	        if (response) {
	          _this.proyecto.items = response.datos.rows;
	          _this.copiarItems();
	          _this.calcularTotal();
	        }
	      });
	      this.esTecnico = ['TECNICO_UPRE', 'RESP_DEPARTAMENTAL_UPRE', 'ENCAR_REGIONAL_UPRE'].indexOf(this.usuario.rol.nombre) >= 0 && (this.proyecto.estado_actual.codigo == 'REGISTRO_EMPRESA' || this.proyecto.estado_actual.codigo == 'REGISTRO_EMPRESA_CORRECCION');
	    }
	  }, {
	    key: 'copiarItems',
	    value: function copiarItems() {
	      this.cItems = angular.copy(this.proyecto.items);
	    }
	  }, {
	    key: 'registrarPrecioItem',
	    value: function registrarPrecioItem(item) {
	      var _this2 = this;
	
	      if (!this.esPrecioActualizado(item) || angular.isUndefined(item.precio_unitario)) {
	        return;
	      }
	      this.DataService.put('items/' + item.id_item, { precio_unitario: item.precio_unitario }).then(function (result) {
	        if (result) {
	          _this2.actualizarCopiaItems(result.datos);
	          _this2.calcularTotal();
	        }
	      });
	    }
	  }, {
	    key: 'esPrecioActualizado',
	    value: function esPrecioActualizado(item) {
	      var cItem = this.cItems[this._.findIndex(this.cItems, { id_item: item.id_item })];
	      return cItem.precio_unitario !== item.precio_unitario;
	    }
	  }, {
	    key: 'actualizarCopiaItems',
	    value: function actualizarCopiaItems(item) {
	      this.cItems[this._.findIndex(this.cItems, { id_item: item.id_item })] = item;
	    }
	  }, {
	    key: 'calcularTotal',
	    value: function calcularTotal() {
	      var _this3 = this;
	
	      this.precioTotal = 0;
	      this.proyecto.items.map(function (item) {
	        if (item.cantidad && item.precio_unitario) {
	          _this3.precioTotal = _this3.Util.sumar([_this3.precioTotal, _this3.Util.multiplicar([item.cantidad, item.precio_unitario]), _this3.Util.redondear(item.cr_precio)]);
	        }
	      });
	      this.precioTotal = this.Util.redondear(this.precioTotal);
	      if (this.esPresupuestoValido()) {
	        this.proyecto.monto_total = this.precioTotal;
	      } else {
	        this.proyecto.monto_total = null;
	        if (this.proyecto.monto_total_rest) {
	          this.Message.error('El precio total no debe ser mayor al monto total restante del proyecto.');
	        } else {
	          this.Message.error('El precio total no debe ser mayor al monto total del convenio del proyecto.');
	        }
	      }
	    }
	  }, {
	    key: 'esPresupuestoValido',
	    value: function esPresupuestoValido() {
	      if (this.proyecto.monto_total_rest) {
	        return this.precioTotal <= this.proyecto.monto_total_actual - this.proyecto.monto_total_rest;
	      }
	      return this.precioTotal <= this.proyecto.monto_total_convenio;
	    }
	  }, {
	    key: 'cRegularizacion',
	    value: function cRegularizacion(item) {
	      var _this4 = this;
	
	      if (typeof item.cr_precio === 'undefined') {
	        item.cr_precio = '0';
	      }
	      var data = {
	        cRedondeo: item.cr_precio
	      };
	      this.DataService.put('proyectos/' + this.proyecto.id_proyecto + '/item/' + item.id_item + '/campo_regularizacion', data).then(function (resp) {
	        if (resp && resp.finalizado) {
	          _this4.calcularTotal();
	        } else {
	          item.cr_precio = '0';
	        }
	      });
	    }
	  }]);
	
	  return PresupuestoItemsController;
	}();
	
	exports.default = PresupuestoItemsController;

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _proyectoAdjudicado = __webpack_require__(389);
	
	var _proyectoAdjudicado2 = _interopRequireDefault(_proyectoAdjudicado);
	
	var _proyectoAdjudicado3 = __webpack_require__(619);
	
	var _proyectoAdjudicado4 = _interopRequireDefault(_proyectoAdjudicado3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProyectoAdjudicadoComponent = {
	  bindings: {
	    proyecto: '<'
	  },
	  controller: _proyectoAdjudicado2.default,
	  template: _proyectoAdjudicado4.default
	};
	
	exports.default = ProyectoAdjudicadoComponent;

/***/ }),
/* 389 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ProyectoAdjudicadoController = function ProyectoAdjudicadoController() {
	  _classCallCheck(this, ProyectoAdjudicadoController);
	};
	
	exports.default = ProyectoAdjudicadoController;

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	'usr strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _computoProyecto = __webpack_require__(391);
	
	var _computoProyecto2 = _interopRequireDefault(_computoProyecto);
	
	var _computoProyecto3 = __webpack_require__(620);
	
	var _computoProyecto4 = _interopRequireDefault(_computoProyecto3);
	
	__webpack_require__(190);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ComputoProyectoComponent = {
	  bindings: {
	    supervision: '<',
	    item: '<',
	    computos: '=',
	    modoVista: '<?',
	    modificados: '=',
	    existeCambios: '='
	  },
	  controller: _computoProyecto2.default,
	  template: _computoProyecto4.default
	};
	
	exports.default = ComputoProyectoComponent;

/***/ }),
/* 391 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ComputoProyectoController = function () {
	  ComputoProyectoController.$inject = ["$scope", "DataService", "Supervision", "Computo", "_", "Util", "Loading", "apiUrl", "$log"];
	  function ComputoProyectoController($scope, DataService, Supervision, Computo, _, Util, Loading, apiUrl, $log) {
	    'ngInject';
	
	    _classCallCheck(this, ComputoProyectoController);
	
	    this.$scope = $scope;
	    this.DataService = DataService;
	    this.Supervision = Supervision;
	    this.Computo = Computo;
	    this._ = _;
	    this.Util = Util;
	    this.Loading = Loading;
	    this.items = [];
	    this.esEditable = false;
	    this.supervisionHistorica = {};
	    this.computoFinalizado = true;
	    this.apiUrl = apiUrl;
	    this.$log = $log;
	  }
	
	  _createClass(ComputoProyectoController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.modificados = [];
	      this.idSupervision = this.supervision.id_supervision;
	      this.resumen = {
	        cant_ejecutada: 0,
	        cant_faltante: 0,
	        cant_anterior: 0 // cantidad total de las planillas anteriores
	      };
	
	      this.inicializarDatos();
	      this.items = this.Supervision.getItems();
	      this.$log.log('SUPERVISION===>' + JSON.stringify(this.supervision));
	      this.$log.log('ID SUPERVISION===>' + this.supervision.id_supervision);
	    }
	  }, {
	    key: 'inicializarDatos',
	    value: function inicializarDatos() {
	      this.getDatosItem();
	      this.supervisiones = [];
	      this.supervisionHistorica = {};
	      this.computoFinalizado = true;
	    }
	  }, {
	    key: 'getDatosItem',
	    value: function getDatosItem() {
	      var _this = this;
	
	      this.Loading.show('Cargando datos del item.', true);
	      this.DataService.get('items/' + this.item.id_item + '/resumen').then(function (response) {
	        _this.item = response.datos;
	        _this.getSupervisionesItem();
	        _this.getComputosItem(_this.supervision.id_supervision);
	        _this.$scope.$broadcast('recargarFotos');
	      });
	    }
	
	    /**
	     * getSupervisionesItem - Obteniendo las supervisiones en las que se han registrado cómputos métricos de un item
	     */
	
	  }, {
	    key: 'getSupervisionesItem',
	    value: function getSupervisionesItem() {
	      var _this2 = this;
	
	      this.DataService.get('items/' + this.item.id_item + '/supervisiones').then(function (response) {
	        _this2.prepararSupervisiones(response.datos);
	      });
	    }
	  }, {
	    key: 'getComputosItem',
	    value: function getComputosItem(idSupervision) {
	      var _this3 = this;
	
	      this.DataService.get('computos_metricos?item=' + this.item.id_item + '&supervision=' + idSupervision).then(function (response) {
	        _this3.resumen.cant_anterior = response.datos.cantidad_anterior;
	        _this3.computos = _this3.Computo.getListaOrdenadaComputos(response.datos.computos, _this3.item);
	        _this3.copiaComputos = angular.copy(_this3.computos);
	        _this3.procesarFotos(response.datos.fotos);
	        _this3.$scope.$broadcast('recargarDatosComputos');
	        _this3.actualizarResumen();
	        _this3.establecerEdicion();
	        _this3.Loading.hide();
	      });
	    }
	  }, {
	    key: 'procesarFotos',
	    value: function procesarFotos(fotos) {
	      var _this4 = this;
	
	      fotos.forEach(function (foto) {
	        foto.name = foto.nombre.substring(0, foto.nombre.indexOf('_'));
	        foto.nombre = foto.nombre.substring(foto.nombre.indexOf('_') + 1);
	        foto.show = true;
	        _this4.fotos[foto.name] = foto;
	        //guardamos backup para recuperar el id_foto_supervision
	        _this4.fotos.backups[foto.name] = angular.copy(_this4.fotos[foto.name]);
	      });
	    }
	  }, {
	    key: 'actualizarResumen',
	    value: function actualizarResumen() {
	      this.resumen = this.Computo.getResumen(this.item, this.computos, this.resumen);
	    }
	  }, {
	    key: 'establecerEdicion',
	    value: function establecerEdicion() {
	      this.esEditable = this.Supervision.esEditable('computos') && this.item.cantidad > 0 && this.Supervision.getSupervision().id_supervision === this.supervisionHistorica.id_supervision;
	    }
	  }, {
	    key: 'irItemPosicion',
	    value: function irItemPosicion(opcion) {
	      var _this5 = this;
	
	      if (!opcion) {
	        return;
	      }
	      if (this.existeCambios) {
	        this.$scope.$broadcast('guardarComputosMetricos', function () {
	          _this5.siguienteAnterior(opcion);
	        });
	      } else {
	        this.siguienteAnterior(opcion);
	      }
	    }
	  }, {
	    key: 'siguienteAnterior',
	    value: function siguienteAnterior(opcion) {
	      var POSICION = this._.findIndex(this.items, { id_item: parseInt(this.item.id_item) });
	      if (opcion === 'siguiente' && POSICION === this.items.length - 1 || opcion === 'anterior' && POSICION === 0) {
	        return;
	      } else {
	        var POSICION_SIGUIENTE = opcion === 'siguiente' ? POSICION + 1 : opcion === 'anterior' ? POSICION - 1 : POSICION;
	        this.item = this.items[POSICION_SIGUIENTE];
	        this.inicializarDatos();
	      }
	    }
	  }, {
	    key: 'esPrimerItem',
	    value: function esPrimerItem() {
	      return this._.findIndex(this.items, { id_item: this.item.id_item }) === 0;
	    }
	  }, {
	    key: 'esUltimoItem',
	    value: function esUltimoItem() {
	      return this._.findIndex(this.items, { id_item: this.item.id_item }) === this.items.length - 1;
	    }
	  }, {
	    key: 'prepararSupervisiones',
	    value: function prepararSupervisiones(supervisiones) {
	      var _this6 = this;
	
	      if (this.supervision.estado_supervision === 'REGISTRO_PLANILLA') {
	        var SUPERVISION_ACTUAL = { id_supervision: this.supervision.id_supervision, estado_supervision: this.supervision.estado_supervision };
	        if (supervisiones.length === 0) {
	          supervisiones = [SUPERVISION_ACTUAL];
	        } else {
	          var FINALIZADO = this._.find(supervisiones, { estado_supervision: 'EN_ARCHIVO' });
	          if (FINALIZADO && !this.item.completado) {
	            supervisiones.push(SUPERVISION_ACTUAL);
	          }
	        }
	      }
	
	      supervisiones.map(function (supervision) {
	        if (supervision.estado_supervision === 'REGISTRO_PLANILLA') {
	          Object.assign(supervision, { nombre: 'En proceso' });
	          _this6.asignarValorSupervHistorica(supervision);
	        } else {
	          if (supervision.nro_supervision) {
	            Object.assign(supervision, { nombre: 'Planilla ' + supervision.nro_supervision });
	          }
	        }
	      });
	      this.supervisiones = supervisiones;
	      if (!this.esEditable) {
	        var _SUPERVISION_ACTUAL = this._.find(this.supervisiones, { id_supervision: this.supervision.id_supervision });
	        if (_SUPERVISION_ACTUAL) {
	          this.asignarValorSupervHistorica(_SUPERVISION_ACTUAL);
	        }
	      }
	    }
	  }, {
	    key: 'asignarValorSupervHistorica',
	    value: function asignarValorSupervHistorica(supervision) {
	      this.supervisionHistorica = supervision;
	      this.verificarComputoFinalizado();
	    }
	  }, {
	    key: 'mostrarDatosSupervision',
	    value: function mostrarDatosSupervision() {
	      this.verificarComputoFinalizado();
	      this.getComputosItem(this.supervisionHistorica.id_supervision);
	      this.$scope.$broadcast('recargarFotos');
	    }
	  }, {
	    key: 'verificarComputoFinalizado',
	    value: function verificarComputoFinalizado() {
	      this.computoFinalizado = this.supervisionHistorica.estado_supervision === 'EN_ARCHIVO';
	    }
	  }, {
	    key: 'puedeVerComputos',
	    value: function puedeVerComputos() {
	      return true;
	      // TODO Revisar porque se añadio esta validacion
	      // return (this.supervision.estado_supervision === 'REGISTRO_PLANILLA' ? true : this.resumen.total_actual > 0 && this.item.estado !== 'CERRADO')
	      // || (this.supervisionHistorica.id_supervision && this.supervisionHistorica.id_supervision !== this.supervision.id_supervision);
	    }
	  }]);
	
	  return ComputoProyectoController;
	}();
	
	exports.default = ComputoProyectoController;

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _computoProyecto = __webpack_require__(390);
	
	var _computoProyecto2 = _interopRequireDefault(_computoProyecto);
	
	var _resumen = __webpack_require__(398);
	
	var _resumen2 = _interopRequireDefault(_resumen);
	
	var _fotos = __webpack_require__(396);
	
	var _fotos2 = _interopRequireDefault(_fotos);
	
	var _computosMetricos = __webpack_require__(394);
	
	var _computosMetricos2 = _interopRequireDefault(_computosMetricos);
	
	var _importacionComputos = __webpack_require__(431);
	
	var _importacionComputos2 = _interopRequireDefault(_importacionComputos);
	
	var _computo = __webpack_require__(393);
	
	var _computo2 = _interopRequireDefault(_computo);
	
	var _integracion = __webpack_require__(19);
	
	var _integracion2 = _interopRequireDefault(_integracion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var computoProyecto = angular.module('app.computoProyecto', []).component('computoProyecto', _computoProyecto2.default).component('resumenComputos', _resumen2.default).component('fotosComputos', _fotos2.default).component('computosMetricos', _computosMetricos2.default).component('importacionComputos', _importacionComputos2.default).service('Computo', _computo2.default).service('Integracion', _integracion2.default).name;
	
	exports.default = computoProyecto;

/***/ }),
/* 393 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ComputosService = function () {
	  ComputosService.$inject = ["DataService", "$q", "Datetime", "Util", "$window", "_", "Big", "decimales"];
	  function ComputosService(DataService, $q, Datetime, Util, $window, _, Big, decimales) {
	    'ngInject';
	
	    _classCallCheck(this, ComputosService);
	
	    this.DataService = DataService;
	    this.Datetime = Datetime;
	    this.estadoActual = null;
	    this.Util = Util;
	    this.$window = $window;
	    this.$q = $q;
	    this.proyectoOrigen = {};
	    this._ = _;
	    this.Big = Big;
	    this.decimales = decimales;
	  }
	
	  _createClass(ComputosService, [{
	    key: 'setCantParcial',
	    value: function setCantParcial(unidad, computo) {
	      unidad = unidad || '';
	      unidad = unidad.toUpperCase();
	      var cantidadParcial = 0;
	      var cc = this.Big(computo.cantidad ? computo.cantidad : 0);
	      var cff = this.Big(computo.factor_forma ? computo.factor_forma : 0);
	      var clargo = this.Big(computo.largo ? computo.largo : 0);
	      var calto = this.Big(computo.alto ? computo.alto : 0);
	      var cancho = this.Big(computo.ancho ? computo.ancho : 0);
	      switch (unidad) {
	        case 'UN_GLOBAL':
	        case 'UN_PIEZA':
	        case 'UN_PUNTO':
	        case 'UN_UNID':
	        case 'UN_KIT':
	        case 'UN_HOYO':
	        case 'UN_TUBO':
	        case 'UN_ROLLO':
	        case 'UN_EQUIPO':
	          cantidadParcial = computo.cantidad;
	          break;
	        case 'UN_LITRO':
	        case 'UN_KILOGRAMO':
	        case 'UN_TONELADA':
	        case 'UN_KILOMETRO':
	        case 'UN_METRO':
	        case 'UN_HORA*DIA':
	        case 'UN_METRO_CUAD*MES':
	        case 'UN_VEHICULO*MES':
	        case 'UN_TRAMO':
	        case 'UN_JUEGO':
	        case 'UN_HORA':
	          cantidadParcial = cc.mul(clargo).toString();
	          break;
	        case 'UN_METRO_CUAD':
	        case 'UN_PIE_CUAD':
	        case 'UN_HECTAREA':
	          // con redondeos intermedios
	          // computo.area = cff.mul(clargo.mul(calto).toFixed(this.decimales||2)).toFixed(this.decimales||2).toString();
	          // cantidadParcial = cc.mul(computo.area).toString();
	          // sin redondeos intermedios
	          computo.area = cff.mul(clargo.mul(calto)).toFixed(this.decimales || 2).toString();
	          cantidadParcial = cc.mul(cff).mul(clargo).mul(calto).toFixed(this.decimales || 2).toString();
	          break;
	        case 'UN_DECIMETRO_CUB':
	        case 'UN_METRO_CUB':
	        case 'UN_METRO_CUB*KM':
	          // con redondeos intermedios
	          // computo.area = cff.mul(clargo.mul(cancho).mul(calto).toFixed(this.decimales||2)).toFixed(this.decimales||2).toString();
	          // cantidadParcial = cc.mul(computo.area).toString();
	          // sin redondeos intermedios
	          computo.area = cff.mul(clargo).mul(cancho).mul(calto).toFixed(this.decimales || 2).toString();
	          cantidadParcial = cc.mul(cff).mul(clargo).mul(cancho).mul(calto).toFixed(this.decimales || 2).toString();
	          break;
	        default:
	          computo.area = cff.mul(clargo.mul(calto)).toFixed(this.decimales || 2).toString();
	          cantidadParcial = cc.mul(cff).mul(clargo).mul(calto).toFixed(this.decimales || 2).toString();
	          break;
	      }
	      computo.cantidad_parcial = cantidadParcial;
	    }
	  }, {
	    key: 'getConf',
	    value: function getConf(unidad) {
	      unidad = unidad || '';
	      unidad = unidad.toUpperCase();
	      var val = {}; // valor a retornar
	      switch (unidad) {
	        case 'UN_GLOBAL':
	          val = {
	            descripcion: { required: true, disabled: false },
	            cantidad: { required: true, disabled: false },
	            factor_forma: { required: false, disabled: true },
	            largo: { required: false, disabled: true },
	            ancho: { required: false, disabled: true },
	            alto: { required: false, disabled: true },
	            area: { required: false, disabled: true },
	            cantidad_parcial: { required: true, disabled: true, class: 'bg-white' }
	          };
	          break;
	        case 'UN_PIEZA':
	        case 'UN_PUNTO':
	          val = {
	            descripcion: { required: true, disabled: false },
	            cantidad: { required: true, disabled: false },
	            factor_forma: { required: false, disabled: true },
	            largo: { required: false, disabled: true },
	            ancho: { required: false, disabled: true },
	            alto: { required: false, disabled: true },
	            area: { required: false, disabled: true },
	            cantidad_parcial: { required: true, disabled: true, class: 'bg-white' }
	          };
	          break;
	        case 'UN_LITRO':
	        case 'UN_KILOGRAMO':
	        case 'UN_TONELADA':
	        case 'UN_KILOMETRO':
	        case 'UN_METRO':
	        case 'UN_HORA*DIA':
	        case 'UN_METRO_CUAD*MES':
	        case 'UN_VEHICULO*MES':
	        case 'UN_TRAMO':
	        case 'UN_JUEGO':
	        case 'UN_HORA':
	          val = {
	            descripcion: { required: true, disabled: false },
	            cantidad: { required: true, disabled: false },
	            factor_forma: { required: false, disabled: true },
	            largo: { required: true, disabled: false },
	            ancho: { required: false, disabled: true },
	            alto: { required: false, disabled: true },
	            area: { required: false, disabled: true },
	            cantidad_parcial: { required: true, disabled: true, class: 'bg-white' }
	          };
	          break;
	        case 'UN_METRO_CUAD':
	        case 'UN_PIE_CUAD':
	        case 'UN_HECTAREA':
	          val = {
	            descripcion: { required: true, disabled: false },
	            cantidad: { required: true, disabled: false },
	            factor_forma: { required: true, disabled: false },
	            largo: { required: true, disabled: false },
	            ancho: { required: false, disabled: true },
	            alto: { required: true, disabled: false },
	            area: { required: true, disabled: true, class: 'bg-white' },
	            cantidad_parcial: { required: true, disabled: true, class: 'bg-white' }
	          };
	          break;
	        case 'UN_DECIMETRO_CUB':
	        case 'UN_METRO_CUB':
	        case 'UN_METRO_CUB*KM':
	          val = {
	            descripcion: { required: true, disabled: false },
	            cantidad: { required: true, disabled: false },
	            factor_forma: { required: true, disabled: false },
	            largo: { required: true, disabled: false },
	            ancho: { required: true, disabled: false },
	            alto: { required: true, disabled: false },
	            area: { required: true, disabled: true, class: 'bg-white' },
	            cantidad_parcial: { required: true, disabled: true, class: 'bg-white' }
	          };
	          break;
	        case 'UN_HOYO':
	          val = {
	            descripcion: { required: true, disabled: false },
	            cantidad: { required: true, disabled: false },
	            factor_forma: { required: false, disabled: true },
	            largo: { required: false, disabled: true },
	            ancho: { required: false, disabled: true },
	            alto: { required: false, disabled: true },
	            area: { required: false, disabled: true },
	            cantidad_parcial: { required: true, disabled: true, class: 'bg-white' }
	          };
	          break;
	        case 'UN_TUBO':
	          val = {
	            descripcion: { required: true, disabled: false },
	            cantidad: { required: true, disabled: false },
	            factor_forma: { required: false, disabled: true },
	            largo: { required: false, disabled: true },
	            ancho: { required: false, disabled: true },
	            alto: { required: false, disabled: true },
	            area: { required: false, disabled: true },
	            cantidad_parcial: { required: true, disabled: true, class: 'bg-white' }
	          };
	          break;
	        case 'UN_EQUIPO':
	          val = {
	            descripcion: { required: true, disabled: false },
	            cantidad: { required: true, disabled: false },
	            factor_forma: { required: false, disabled: true },
	            largo: { required: false, disabled: true },
	            ancho: { required: false, disabled: true },
	            alto: { required: false, disabled: true },
	            area: { required: false, disabled: true },
	            cantidad_parcial: { required: true, disabled: true, class: 'bg-white' }
	          };
	          break;
	        case 'UN_ROLLO':
	          val = {
	            descripcion: { required: true, disabled: false },
	            cantidad: { required: true, disabled: false },
	            factor_forma: { required: false, disabled: true },
	            largo: { required: false, disabled: true },
	            ancho: { required: false, disabled: true },
	            alto: { required: false, disabled: true },
	            area: { required: false, disabled: true },
	            cantidad_parcial: { required: true, disabled: true, class: 'bg-white' }
	          };
	          break;
	        case 'UN_UNID':
	          val = {
	            descripcion: { required: true, disabled: false },
	            cantidad: { required: true, disabled: false },
	            factor_forma: { required: false, disabled: true },
	            largo: { required: false, disabled: true },
	            ancho: { required: false, disabled: true },
	            alto: { required: false, disabled: true },
	            area: { required: false, disabled: true },
	            cantidad_parcial: { required: true, disabled: true, class: 'bg-white' }
	          };
	          break;
	        case 'UN_KIT':
	          val = {
	            descripcion: { required: true, disabled: false },
	            cantidad: { required: true, disabled: false },
	            factor_forma: { required: false, disabled: true },
	            largo: { required: false, disabled: true },
	            ancho: { required: false, disabled: true },
	            alto: { required: false, disabled: true },
	            area: { required: false, disabled: true },
	            cantidad_parcial: { required: true, disabled: true, class: 'bg-white' }
	          };
	          break;
	        default:
	          val = {
	            descripcion: { required: true, disabled: false },
	            cantidad: { required: true, disabled: false },
	            factor_forma: { required: true, disabled: false },
	            largo: { required: true, disabled: false },
	            ancho: { required: false, disabled: true },
	            alto: { required: true, disabled: false },
	            area: { required: true, disabled: true, class: 'bg-white' },
	            cantidad_parcial: { required: true, disabled: true, class: 'bg-white' }
	          };
	          break;
	      }
	      return val;
	    }
	  }, {
	    key: 'getListaOrdenadaComputos',
	    value: function getListaOrdenadaComputos(computos, item) {
	      if (computos.length == 0) {
	        computos.push({});
	      } else {
	        // vamos a ordenar por subtitulo
	        var indexs_subtitulos = {}; // buscaremos todos los subtitulos y luego los añadiremos;
	        var computo_auxiliar = computos[0];
	        indexs_subtitulos[0] = computo_auxiliar.subtitulo;
	        computos.forEach(function (computo, i) {
	          if (computo.subtitulo != computo_auxiliar.subtitulo) {
	            indexs_subtitulos[i] = computo.subtitulo;
	            computo_auxiliar = computo;
	          }
	          if (['UN_METRO_CUB', 'UN_DECIMETRO_CUB', 'UN_METRO_CUB*KM'].indexOf(item.unidad_medida) >= 0) {
	            computo.area = computo.volumen;
	          }
	        });
	        var i = 0;
	        for (var k in indexs_subtitulos) {
	          if (indexs_subtitulos[k]) {
	            computos.splice(parseInt(k) + i, 0, { isSubtitulo: true, descripcion: indexs_subtitulos[k] });
	            i++;
	          }
	        }
	      }
	      return computos;
	    }
	  }, {
	    key: 'getResumen',
	    value: function getResumen(item, computos, resumen) {
	      var _this = this;
	
	      resumen.total_actual = 0;
	      computos.forEach(function (computo) {
	        if (!computo.isSubtitulo) {
	          resumen.total_actual = _this.Util.sumar([resumen.total_actual, parseFloat(computo.cantidad_parcial) || 0]);
	        }
	      });
	      resumen.cant_ejecutada = this.Util.sumar([resumen.total_actual, resumen.cant_anterior]);
	      resumen.cant_faltante = item.cantidad > 0 ? this.Util.restar(item.cantidad, resumen.cant_ejecutada) : 0;
	      return resumen;
	    }
	  }]);
	
	  return ComputosService;
	}();
	
	exports.default = ComputosService;

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	'usr strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _computosMetricos = __webpack_require__(395);
	
	var _computosMetricos2 = _interopRequireDefault(_computosMetricos);
	
	var _computosMetricos3 = __webpack_require__(621);
	
	var _computosMetricos4 = _interopRequireDefault(_computosMetricos3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ComputoProyectoComponent = {
	  bindings: {
	    supervision: '=',
	    item: '=',
	    computos: '=',
	    copiaComputos: '=',
	    resumen: '=',
	    fotos: '=',
	    modoVista: '<?',
	    existeCambios: '=',
	    modificados: '='
	  },
	  controller: _computosMetricos2.default,
	  template: _computosMetricos4.default
	};
	
	exports.default = ComputoProyectoComponent;

/***/ }),
/* 395 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ComputosMetricosController = function () {
	  ComputosMetricosController.$inject = ["$scope", "DataService", "Modal", "Message", "Computo", "Util", "Loading", "_", "apiUrl", "Integracion", "$log"];
	  function ComputosMetricosController($scope, DataService, Modal, Message, Computo, Util, Loading, _, apiUrl, Integracion, $log) {
	    'ngInject';
	
	    _classCallCheck(this, ComputosMetricosController);
	
	    this.$scope = $scope;
	    this.DataService = DataService;
	    this.Modal = Modal;
	    this.Message = Message;
	    this.Computo = Computo;
	    this.Util = Util;
	    this.Loading = Loading;
	    this._ = _;
	    this.apiUrl = apiUrl;
	    this.copiaComputos = {};
	    this.Integracion = Integracion;
	    this.$log = $log;
	  }
	
	  _createClass(ComputosMetricosController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.descargaEsp = {
	        url: this.apiUrl + 'proyectos/' + this.supervision.fid_proyecto + '/doc/ET_' + this.item.id_item + '/descargar',
	        nombre: 'Especificaciones item ' + this.item.nro_item
	      };
	      // `${this.apiUrl}proyectos/${this.supervision.fid_proyecto}/doc/ET/descargar`;
	      this.$scope.$on('recargarDatosComputos', function () {
	        _this.recargarDatos();
	      });
	      this.$scope.$on('guardarComputosMetricos', function (event, callback) {
	        _this.saveAllRow(callback);
	      });
	    }
	  }, {
	    key: 'recargarDatos',
	    value: function recargarDatos() {
	      this.sacarCopiaComputos();
	      this.configSegunUnidadMedida();
	    }
	  }, {
	    key: '$onChanges',
	    value: function $onChanges() {
	      var _this2 = this;
	
	      this.$scope.$watch('$ctrl.computos', function () {
	        if (!_this2.computos) {
	          return;
	        }
	        _this2.determinarCambiosEnComputos();
	      }, true);
	    }
	  }, {
	    key: 'determinarCambiosEnComputos',
	    value: function determinarCambiosEnComputos() {
	      this.existeCambios = !angular.equals(JSON.parse(angular.toJson(this.computos)), this.copiaComputos);
	      if (this.existeCambios) {
	        this.actualizarItemsModificados();
	      }
	    }
	  }, {
	    key: 'actualizarItemsModificados',
	    value: function actualizarItemsModificados() {
	      if (this.modificados.indexOf(this.item.id_item) === -1) {
	        this.modificados.push(this.item.id_item);
	      }
	    }
	  }, {
	    key: 'configSegunUnidadMedida',
	    value: function configSegunUnidadMedida() {
	      this.conf = this.Computo.getConf(this.item.unidad_medida);
	    }
	  }, {
	    key: 'changeComputo',
	    value: function changeComputo(computo) {
	      this.Computo.setCantParcial(this.item.unidad_medida, computo);
	      this.actualizarResumen();
	    }
	  }, {
	    key: 'addRow',
	    value: function addRow() {
	      if (this.item.unidad_medida === 'UN_GLOBAL' && this.computos.length == 1) {
	        this.Message.warning('Solo puede tener un computo para la unidad de medida GLOBAL');
	        return;
	      }
	      var subtitulo = null;
	      for (var i = this.computos.length - 1; i >= 0; i--) {
	        if (this.computos[i].isSubtitulo) {
	          subtitulo = this.computos[i].descripcion;
	          break;
	        }
	      }
	      this.computos.push({ subtitulo: subtitulo });
	    }
	  }, {
	    key: 'saveRow',
	    value: function saveRow(computo, i) {
	      var _this3 = this;
	
	      if (!this.sonDatosValidos(i)) {
	        return;
	      }
	      computo.id = computo.id_computo_metrico;
	      computo.fid_item = this.item.id_item;
	      computo.fid_supervision = this.supervision.id_supervision;
	      computo.orden = i;
	      computo = this.quitarCamposNulos(computo);
	      if (!computo.subtitulo) {
	        computo.subtitulo = null;
	      }
	      this.DataService.save('computos_metricos/', computo).then(function (response) {
	        if (response && response.finalizado) {
	          _this3.Message.success(response.mensaje);
	          angular.extend(computo, response.datos);
	          if (_this3.item.unidad_medida === 'UN_METRO_CUB') {
	            computo.area = response.datos.volumen;
	          }
	          _this3.sacarCopiaComputos(computo);
	        }
	      });
	    }
	  }, {
	    key: 'saveAllRow',
	    value: function saveAllRow(callback) {
	      var _this4 = this;
	
	      if (!this.sonDatosValidos()) {
	        return;
	      }
	      var datos = {
	        computos: []
	      };
	      if (this.computos.length) {
	        var fila = this.computos[0];
	        var subtitulo = fila.isSubtitulo ? fila.descripcion : null;
	        for (var i = 0; i < this.computos.length; i++) {
	          if (this.computos[i].isSubtitulo) {
	            subtitulo = this.computos[i].descripcion;
	          } else {
	            this.computos[i].subtitulo = subtitulo;
	            this.computos[i].fid_item = this.item.id_item;
	            this.computos[i].fid_supervision = this.supervision.id_supervision;
	            this.computos[i].orden = i;
	            datos.computos.push(this.quitarCamposNulos(this.computos[i]));
	          }
	        }
	
	        this.DataService.put('computos_metricos/items/' + this.item.id_item, datos).then(function (response) {
	          if (response && response.finalizado) {
	            _this4.Message.success(response.mensaje);
	            _this4.computos = _this4.Computo.getListaOrdenadaComputos(response.datos, _this4.item);
	            _this4.sacarCopiaComputos();
	            if (callback) {
	              callback();
	            }
	          }
	        });
	      }
	    }
	  }, {
	    key: 'deleteRow',
	    value: function deleteRow(computo, index) {
	      var _this5 = this;
	
	      if (computo.id_computo_metrico) {
	        this.Modal.confirm('¿Está seguro/a de eliminar el cómputo?', function () {
	          _this5.DataService.delete('computos_metricos/' + computo.id_computo_metrico, computo).then(function (response) {
	            if (response) {
	              _this5.Message.success(response.mensaje);
	              _this5.quitarComputoDeLista(index);
	              _this5.actualizarResumen();
	            }
	          });
	        }, null, null, 'Sí, estoy seguro/a', 'Cancelar');
	      } else {
	        this.quitarComputoDeLista(index);
	        this.actualizarResumen();
	      }
	    }
	  }, {
	    key: 'deleteAllRow',
	    value: function deleteAllRow() {
	      var _this6 = this;
	
	      if (!this.tieneDatos()) {
	        this.Message.warning('No tiene c\xF3mputos m\xE9tricos para eliminar.');
	        return;
	      }
	
	      this.Modal.confirm('¿Está seguro/a de eliminar todos los cómputos de este item?', function () {
	        var i = _this6.computos.length;
	        while (i--) {
	          if (!_this6.computos[i].id_computo_metrico) {
	            _this6.quitarComputoDeLista(i);
	          }
	        }
	        if (_this6.computos.length === 1 && _this6._.isEmpty(_this6.computos[0])) {
	          _this6.actualizarResumen();
	          return;
	        }
	
	        // this.DataService.delete(`computos_metricos/${this.supervision.id_supervision}/todos/${this.item.id_item}`).
	        // then( response => {
	        //   if (response) {
	        //     this.quitarComputoDeLista(null, true);
	        //     this.actualizarResumen();
	        //     this.Message.success(response.mensaje);
	        //   }
	        // });     
	        var dts = _this6.Integracion.eliminaComputosMetricos(_this6.supervision.id_supervision, _this6.item.id_item);
	        dts.then(function (data) {
	          _this6.$log.log(data.data);
	          _this6.quitarComputoDeLista(null, true);
	          _this6.actualizarResumen();
	        }, function (error) {
	          _this6.$log.log("Error de la peticiona" + JSON.stringify(error));
	        });
	        /*
	        .then((dts)=>{ 
	         this.$log.log('respuesta elimina computos'+ dts);
	          if(dts.length>0){
	           this.Message.warning(dts,`Eliminacion de Cómputos Metricos`,6000);
	          }
	          else {
	           this.Message.success(`Se eliminaron los cómputos metricos de forma correcta`,`Eliminacion de Cómputos Metricos`); 
	          }
	        })
	        */
	      }, null, null, 'Sí, estoy seguro/a', 'Cancelar');
	    }
	  }, {
	    key: 'actualizarResumen',
	    value: function actualizarResumen() {
	      this.resumen = this.Computo.getResumen(this.item, this.computos, this.resumen);
	    }
	  }, {
	    key: 'tieneDatos',
	    value: function tieneDatos() {
	      if (!this.computos || this.computos.length === 1 && !this.computos[0].cantidad) {
	        return false;
	      }
	      return true;
	    }
	  }, {
	    key: 'sonDatosValidos',
	    value: function sonDatosValidos(fila) {
	      if (this.resumen.cant_faltante < 0) {
	        this.Message.error('La cantidad faltante no puede ser negativa, reajuste los valores.');
	        return false;
	      }
	      var form = this.$scope.form_computo;
	      var sonCamposValidos = void 0;
	      if (fila) {
	        sonCamposValidos = this.verificarDatosComputo(form, fila);
	      } else {
	        for (var i = 0; i < this.computos.length; i++) {
	          if (!this.computos[i].isSubtitulo) {
	            sonCamposValidos = this.verificarDatosComputo(form, i);
	          }
	        }
	      }
	      if (!sonCamposValidos) {
	        this.Message.warning('Verifique, corrija y/o llene los campos resaltados.');
	        return false;
	      }
	      return true;
	    }
	  }, {
	    key: 'verificarDatosComputo',
	    value: function verificarDatosComputo(form, i) {
	      var esValido = form['descripcion_' + i].$valid && form['cantidad_' + i].$valid && form['factor_forma_' + i].$valid && form['largo_' + i].$valid && form['ancho_' + i].$valid && form['alto_' + i].$valid && form['area_' + i].$valid && form['cantidad_parcial_' + i].$valid;
	      if (!esValido) {
	        form['descripcion_' + i].$setTouched();
	        form['cantidad_' + i].$setTouched();
	        form['factor_forma_' + i].$setTouched();
	        form['largo_' + i].$setTouched();
	        form['ancho_' + i].$setTouched();
	        form['alto_' + i].$setTouched();
	        form['area_' + i].$setTouched();
	        form['cantidad_parcial_' + i].$setTouched();
	        form['area_' + i].$setDirty();
	        form['cantidad_parcial_' + i].$setDirty();
	      }
	      return esValido;
	    }
	  }, {
	    key: 'quitarCamposNulos',
	    value: function quitarCamposNulos(computo) {
	      for (var k in computo) {
	        if (computo[k] === null) {
	          delete computo[k];
	        }
	      }
	      return computo;
	    }
	  }, {
	    key: 'quitarComputoDeLista',
	    value: function quitarComputoDeLista(posicion, todos) {
	      if (this.computos.length === 1 || todos) {
	        this.computos = [{}];
	      } else {
	        this.computos.splice(posicion, 1);
	      }
	      this.sacarCopiaComputos();
	      this.actualizarItemsModificados();
	    }
	  }, {
	    key: 'addSubtitulo',
	    value: function addSubtitulo() {
	      if (angular.isUndefined(this.index_subtitulo)) {
	        this.Message.warning('Debe hacer click en una fila para añadir un subtítulo, y se añadirá sobre la misma.');
	      } else {
	        this.computos.splice(this.index_subtitulo, 0, { isSubtitulo: true });
	      }
	    }
	  }, {
	    key: 'setIndexSubtitulo',
	    value: function setIndexSubtitulo(index) {
	      this.index_subtitulo = index;
	    }
	  }, {
	    key: 'moveSubtitulo',
	    value: function moveSubtitulo(direccion, index) {
	      var computo_auxiliar = angular.copy(this.computos[index]);
	      if (direccion == 'up' && index > 0 && !this.computos[index - 1].isSubtitulo) {
	        this.computos.splice(index, 1);
	        this.computos.splice(index - 1, 0, computo_auxiliar);
	        this.computos[index].subtitulo = computo_auxiliar.descripcion;
	      } else if (direccion == 'down' && index + 1 < this.computos.length && !this.computos[index + 1].isSubtitulo) {
	        this.computos.splice(index, 1);
	        this.computos.splice(index + 1, 0, computo_auxiliar);
	        this.computos[index].subtitulo = null;
	        for (var i = index; i >= 0; i--) {
	          if (this.computos[i].isSubtitulo) {
	            this.computos[index].subtitulo = this.computos[i].descripcion;
	            break;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'saveSubtitulo',
	    value: function saveSubtitulo(subtitulo, index) {
	      var index_final = this.computos.length;
	      for (var i = index + 1; i < this.computos.length; i++) {
	        if (this.computos[i].isSubtitulo) {
	          index_final = i;
	          break;
	        } else {
	          this.computos[i].subtitulo = subtitulo.descripcion;
	        }
	      }
	      this.saveIniFinRow(index + 1, index_final);
	    }
	  }, {
	    key: 'saveIniFinRow',
	    value: function saveIniFinRow(inicio, fin, all) {
	      if (!fin) {
	        fin = this.computos.length;
	      }
	      for (var i = inicio; i < fin; i++) {
	        if (!this.computos[i].isSubtitulo && (this.computos[i].id_computo_metrico || all)) {
	          this.saveRow(this.computos[i], i);
	        }
	      }
	    }
	  }, {
	    key: 'deleteSubtitulo',
	    value: function deleteSubtitulo(subtitulo, index) {
	      var descripcion = null;
	      for (var i = index - 1; i >= 0; i--) {
	        if (this.computos[i].isSubtitulo) {
	          descripcion = this.computos[i].descripcion;
	          break;
	        }
	      }
	      this.saveSubtitulo({ descripcion: descripcion }, index);
	      this.computos.splice(index, 1);
	    }
	
	    /**
	     * sacarCopiaComputos - Copiar los computos en la variable auxiliar "this.copiaComputos", el parámetro computo es opcional,
	     * en caso de tener este parámetro se reemplaza o se adiciona a la variable auxiliar. Esto con el fin de determinar
	     * si hay modificaciones o no para guardar los cómputos cuando el usuario presione "Aceptar" o las opciones "Anterior/Siguiente"
	     * si no ha guardado los datos de algunos o todos sus cómputos métricos.
	     *
	     * @param  {type} computo Objeto con datos de un cómputo métrico
	     */
	
	  }, {
	    key: 'sacarCopiaComputos',
	    value: function sacarCopiaComputos(computo) {
	      if (computo) {
	        var INDEX = this._.findIndex(this.copiaComputos, { id_computo_metrico: computo.id_computo_metrico });
	        if (INDEX === -1) {
	          if (this.copiaComputos.length === 1 && this._.isEmpty(this.copiaComputos[0])) {
	            this.copiaComputos[0] = computo;
	          } else {
	            this.copiaComputos.push(computo);
	          }
	        } else {
	          this.copiaComputos[INDEX] = angular.copy(computo);
	        }
	      } else {
	        this.copiaComputos = angular.copy(this.computos);
	      }
	    }
	  }]);
	
	  return ComputosMetricosController;
	}();
	
	exports.default = ComputosMetricosController;

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	'usr strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _fotos = __webpack_require__(397);
	
	var _fotos2 = _interopRequireDefault(_fotos);
	
	var _fotos3 = __webpack_require__(622);
	
	var _fotos4 = _interopRequireDefault(_fotos3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FotosComputosComponent = {
	  bindings: {
	    item: '<',
	    supervision: '<',
	    fotos: '=',
	    modoVista: '<?',
	    archivado: '<'
	  },
	  controller: _fotos2.default,
	  template: _fotos4.default
	};
	
	exports.default = FotosComputosComponent;

/***/ }),
/* 397 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FotosComputosController = function () {
	  FotosComputosController.$inject = ["DataService", "Modal", "$scope", "$log"];
	  function FotosComputosController(DataService, Modal, $scope, $log) {
	    'ngInject';
	
	    _classCallCheck(this, FotosComputosController);
	
	    this.DataService = DataService;
	    this.Modal = Modal;
	    this.$scope = $scope;
	    this.$log = $log;
	  }
	
	  _createClass(FotosComputosController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.initConfiguracion();
	      this.$scope.$on('recargarFotos', function () {
	        _this.initConfiguracion();
	      });
	    }
	  }, {
	    key: 'initConfiguracion',
	    value: function initConfiguracion() {
	      var _this2 = this;
	
	      this.fotos = {
	        backups: {},
	        uploadCallback: function uploadCallback(file) {
	          var data = angular.copy(file);
	          data.fid_supervision = _this2.supervision.id_supervision;
	          data.fid_item = _this2.item.id_item;
	          data.tipo = 'TF_EMPRESA';
	          data.path_fotografia = data.name + '_' + data.nombre.replace(/\s/, '_');
	          if (_this2.fotos.backups[file.name]) {
	            data.id_foto_supervision = _this2.fotos.backups[file.name].id_foto_supervision;
	            data.id = data.id_foto_supervision;
	          }
	          _this2.$log.log('data============Foto>' + JSON.stringify(data));
	          _this2.DataService.save('fotos', data).then(function (response) {
	            if (response && response.finalizado) {
	              if (response.datos.path_fotografia.indexOf('.pdf') > 0) {
	                var cod = 'CMPDF_' + response.datos.path_fotografia,
	                    id = _this2.supervision ? _this2.supervision.fid_proyecto : 0;
	                _this2.urlViewBase64 = id ? 'proyectos/' + id + '/doc/' + cod : '';
	                _this2.urlDownloadBase64 = id ? 'proyectos/' + id + '/doc/' + cod + '/descargar' : '';
	              }
	            }
	            _this2.fotos[file.name] = {
	              id_foto_supervision: response.datos.id_foto_supervision,
	              base64: data.base64,
	              nombre: data.nombre.replace(/\s/, '_'),
	              show: true,
	              showImage: true
	              //guardamos backup para recuperar el id_foto_supervision
	            };_this2.fotos.backups[file.name] = angular.copy(_this2.fotos[file.name]);
	          });
	          _this2.$log.log('ENTRA AQUI===========>');
	        }
	      };
	    }
	  }, {
	    key: 'showImage',
	    value: function showImage(key) {
	      var foto = this.fotos[key];
	      if (foto.base64) {
	        foto.showImage = !foto.showImage;
	      } else {
	        if (foto.nombre.indexOf('.pdf') > 0) {
	          var cod = 'CMPDF_' + foto.codigo + '_plano_' + foto.nombre,
	              id = this.supervision ? this.supervision.fid_proyecto : 0;
	          this.urlViewBase64 = id ? 'proyectos/' + id + '/doc/' + cod : '';
	          this.urlDownloadBase64 = id ? 'proyectos/' + id + '/doc/' + cod + '/descargar' : '';
	          foto.showImage = true;
	          foto.show = true;
	        } else {
	          this.DataService.get('fotos/' + foto.id_foto_supervision).then(function (response) {
	            foto.base64 = response.datos;
	            foto.showImage = true;
	            foto.show = true;
	          });
	        }
	      }
	    }
	  }, {
	    key: 'changeImage',
	    value: function changeImage(key) {
	      var foto = this.fotos[key];
	      if (foto.show) {
	        this.Modal.confirm('¿Está seguro/a de cambiar la imagen?', function () {
	          foto.show = false;
	        }, null, null, 'Sí, estoy seguro/a', 'Cancelar');
	      } else {
	        foto.show = true;
	      }
	    }
	  }, {
	    key: 'vistaPrevia',
	    value: function vistaPrevia() {
	      if (this.fotos['plano'].base64) {
	        this.Modal.showDocumentBase64(this.fotos['plano'].base64, this.label, 'strBase64');
	      }
	    }
	  }, {
	    key: 'vistaImagen',
	    value: function vistaImagen(imgData) {
	      if (imgData.base64) {
	        this.Modal.showImageBase64(imgData, null);
	      }
	    }
	  }]);
	
	  return FotosComputosController;
	}();
	
	exports.default = FotosComputosController;

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	'usr strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _resumen = __webpack_require__(399);
	
	var _resumen2 = _interopRequireDefault(_resumen);
	
	var _resumen3 = __webpack_require__(623);
	
	var _resumen4 = _interopRequireDefault(_resumen3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ResumenComputosComponent = {
	  bindings: {
	    item: '<',
	    resumen: '<'
	  },
	  controller: _resumen2.default,
	  template: _resumen4.default
	};
	
	exports.default = ResumenComputosComponent;

/***/ }),
/* 399 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ResumenComputosController = function () {
	  function ResumenComputosController() {
	    'ngInject';
	
	    _classCallCheck(this, ResumenComputosController);
	  }
	
	  _createClass(ResumenComputosController, [{
	    key: '$onInit',
	    value: function $onInit() {}
	  }]);
	
	  return ResumenComputosController;
	}();
	
	exports.default = ResumenComputosController;

/***/ }),
/* 400 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ObservacionController = function () {
	    ObservacionController.$inject = ["$uibModalInstance", "data"];
	    function ObservacionController($uibModalInstance, data) {
	        'ngInject';
	
	        _classCallCheck(this, ObservacionController);
	
	        this.$uibModalInstance = $uibModalInstance;
	        this.proyecto = data;
	    }
	
	    _createClass(ObservacionController, [{
	        key: '$onInit',
	        value: function $onInit() {}
	    }, {
	        key: 'cerrar',
	        value: function cerrar() {
	            this.$uibModalInstance.dismiss('cancel');
	        }
	    }, {
	        key: 'aceptar',
	        value: function aceptar() {
	            this.$uibModalInstance.close(this.proyecto);
	        }
	    }]);
	
	    return ObservacionController;
	}();
	
	exports.default = ObservacionController;

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _documentacionProyecto = __webpack_require__(402);
	
	var _documentacionProyecto2 = _interopRequireDefault(_documentacionProyecto);
	
	var _documentacionProyecto3 = __webpack_require__(625);
	
	var _documentacionProyecto4 = _interopRequireDefault(_documentacionProyecto3);
	
	var _integracion = __webpack_require__(19);
	
	var _integracion2 = _interopRequireDefault(_integracion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DocumentacionProyectoComponent = {
	  bindings: {},
	  controller: _documentacionProyecto2.default,
	  template: _documentacionProyecto4.default,
	  service: _integracion2.default
	};
	
	exports.default = DocumentacionProyectoComponent;

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _confirmacionModalController = __webpack_require__(400);
	
	var _confirmacionModalController2 = _interopRequireDefault(_confirmacionModalController);
	
	var _confirmacionModal = __webpack_require__(624);
	
	var _confirmacionModal2 = _interopRequireDefault(_confirmacionModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DocumentacionProyectoController = function () {
	  DocumentacionProyectoController.$inject = ["$scope", "$stateParams", "Storage", "DataService", "Message", "WizardHandler", "Modal", "_", "$q", "$state", "Proyecto", "Loading", "$log", "Integracion"];
	  function DocumentacionProyectoController($scope, $stateParams, Storage, DataService, Message, WizardHandler, Modal, _, $q, $state, Proyecto, Loading, $log, Integracion) {
	    'ngInject';
	
	    _classCallCheck(this, DocumentacionProyectoController);
	
	    this.$scope = $scope;
	    this.$stateParams = $stateParams;
	    this.DataService = DataService;
	    this.Message = Message;
	    this.WizardHandler = WizardHandler;
	    this.Modal = Modal;
	    this._ = _;
	    this.$q = $q;
	    this.$state = $state;
	    this.Proyecto = Proyecto;
	    this.Loading = Loading;
	    this.idProyecto = this.$stateParams.codigo;
	    this.urlProyectos = 'proyectos/' + this.idProyecto;
	    this.usuario = Storage.getUser();
	    this.tieneDocumentacion = false;
	    this.estaCompleto = false;
	    this.$log = $log;
	    this.Integracion = Integracion;
	  }
	
	  _createClass(DocumentacionProyectoController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.getDatosProyectoAdjudicado();
	      this.$scope.$on('refrescar-documentacion-proyecto', function () {
	        _this.$state.reload();
	        _this.WizardHandler.wizard().goTo(1);
	      });
	    }
	  }, {
	    key: '$onChanges',
	    value: function $onChanges() {
	      var _this2 = this;
	
	      this.$scope.$watch('$ctrl.tieneDocumentacion', function () {
	        if (!_this2.tieneDocumentacion && _this2.WizardHandler.wizard()) {
	          _this2.WizardHandler.wizard().reset();
	        }
	      });
	    }
	  }, {
	    key: 'getDatosProyectoAdjudicado',
	    value: function getDatosProyectoAdjudicado() {
	      var _this3 = this;
	
	      this.DataService.get('proyectos/empresas/' + this.usuario.matricula + '/' + this.idProyecto).then(function (response) {
	        if (response) {
	          _this3.proyecto = response.datos;
	          _this3.esEmpresa = _this3.proyecto.documentacion_exp && _this3.proyecto.documentacion_exp.datos_asociacion && _this3.proyecto.documentacion_exp.datos_asociacion.id_asociacion_accidental ? false : true;
	          _this3.Proyecto.setEstadoActual(_this3.proyecto.estado_actual);
	          _this3.esModoEdicion = _this3.Proyecto.esEditable('plazo_ejecucion');
	          if (_this3.existeFormulario()) {
	            _this3.codigoDocumentoProy = angular.copy(_this3.proyecto.cod_documentacion_exp);
	          }
	        }
	      });
	    }
	  }, {
	    key: 'ejecutarAccionPaso',
	    value: function ejecutarAccionPaso() {
	      var paso = this.WizardHandler.wizard().currentStepNumber();
	      switch (paso) {
	        case 1:
	          this.verificarCodigoYContrato();
	          break;
	        default:
	          this.siguiente();
	      }
	    }
	  }, {
	    key: 'verificarCodigoYContrato',
	    value: function verificarCodigoYContrato() {
	      if (!this.proyecto.cod_documentacion_exp) {
	        this.Message.warning('Debe registrar el c\xF3digo y el n\xFAmero de invitaci\xF3n.');
	        return;
	      }
	      if (!this.tieneDocumentacion) {
	        return this.relacionarFormDocumentacionEmpresaAProyecto();
	      }
	      this.siguiente();
	    }
	  }, {
	    key: 'relacionarFormDocumentacionEmpresaAProyecto',
	    value: function relacionarFormDocumentacionEmpresaAProyecto() {
	      var _this4 = this;
	
	      if (this.existeFormulario() && this.codigoDocumentoProy === this.proyecto.cod_documentacion_exp) {
	        this.tieneDocumentacion = true;
	        this.siguiente();
	        return;
	      }
	      var data = {
	        cod_documentacion_exp: this.proyecto.cod_documentacion_exp,
	        nro_invitacion: this.proyecto.nro_invitacion
	      };
	      var ITEMS = this.proyecto.items ? this.proyecto.items : [];
	      var FORMULARIOS = this.proyecto.formularios ? this.proyecto.formularios : [];
	      var MONTO_TOTAL = this.proyecto.monto_total ? this.proyecto.monto_total : 0;
	      this.Loading.show('Obteniendo datos del formulario.', true);
	      this.DataService.put(this.urlProyectos, data).then(function (result) {
	        if (result) {
	          _this4.proyecto = result.datos;
	          _this4.proyecto.items = ITEMS;
	          _this4.proyecto.formularios = FORMULARIOS;
	          _this4.proyecto.monto_total = MONTO_TOTAL;
	          _this4.Message.success('Se obtuvo datos de la documentaci\xF3n de la empresa correctamente.');
	          _this4.tieneDocumentacion = true;
	          _this4.codigoDocumentoProy = angular.copy(_this4.proyecto.cod_documentacion_exp);
	          _this4.esEmpresa = _this4.proyecto.documentacion_exp && _this4.proyecto.documentacion_exp.datos_asociacion && _this4.proyecto.documentacion_exp.datos_asociacion.id_asociacion_accidental ? false : true;
	          _this4.siguiente();
	          _this4.Loading.hide();
	        }
	      });
	    }
	  }, {
	    key: 'validarPresupuesto',
	    value: function validarPresupuesto(contextObj) {
	      if (contextObj.step1Valid) {
	        return true;
	      } else {
	        return false;
	      }
	    }
	  }, {
	    key: 'confirmacionGeneracion',
	    value: function confirmacionGeneracion() {
	      var _this5 = this;
	
	      var dts = this.Integracion.registrarPlazoPropuesta(this.proyecto.id_proyecto);
	      dts.then(function (data) {
	        _this5.$log.log('RESPUESA DE SIGA', data.data);
	      }, function (error) {
	        _this5.$log.log("Error de la peticiona" + JSON.stringify(error));
	      });
	
	      var defer = this.$q.defer();
	      if (!this.puedeGenerarFormularios()) {
	        defer.reject();
	      } else {
	        var modalConfirmacion = this.Modal.show({
	          template: _confirmacionModal2.default,
	          controller: _confirmacionModalController2.default,
	          data: this.proyecto,
	          size: 'lg'
	        });
	        modalConfirmacion.result.then(function (proyecto) {
	          _this5.proyecto = proyecto;
	          defer.resolve();
	        }, function () {});
	        //this.$log.log('datos99====>',this.proyecto);
	      }
	      return defer.promise;
	    }
	  }, {
	    key: 'puedeGenerarFormularios',
	    value: function puedeGenerarFormularios() {
	      if (this.existeFormulario() && this.tienePresupuestoCompleto() && this.proyecto.monto_total && this.tieneCronogramas()) {
	        return true;
	      } else {
	        this.Modal.alert('Debe completar los precios de los items en Presupuesto y cargar los archivos en Cronogramas.');
	      }
	      return false;
	    }
	  }, {
	    key: 'esDocumentacionCompleta',
	    value: function esDocumentacionCompleta() {
	      if (this.existeFormulario() && this.tienePresupuestoCompleto() && this.proyecto.monto_total && this.tieneCronogramas()) {
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'tienePresupuestoCompleto',
	    value: function tienePresupuestoCompleto() {
	      var PRECIOS_ITEMS = this._.map(this.proyecto.items, 'precio_unitario');
	      return this._.indexOf(PRECIOS_ITEMS, undefined) === -1;
	    }
	  }, {
	    key: 'tieneCronogramas',
	    value: function tieneCronogramas() {
	      return this.proyecto.formularios &&
	      //  this.existeDocumento('DCONT') &&
	      this.existeDocumento('A8') && this.existeDocumento('B5') && this.existeDocumento('B2');
	    }
	  }, {
	    key: 'existeDocumento',
	    value: function existeDocumento(codigo) {
	      return !this._.isEmpty(this._.find(this.proyecto.formularios, { codigo_documento: codigo }));
	    }
	  }, {
	    key: 'verificarSiTieneForm',
	    value: function verificarSiTieneForm() {
	      if (this.WizardHandler.wizard() && this.existeFormulario()) {
	        this.WizardHandler.wizard().setEditMode();
	      }
	    }
	  }, {
	    key: 'siguiente',
	    value: function siguiente() {
	      this.WizardHandler.wizard().next();
	    }
	  }, {
	    key: 'anterior',
	    value: function anterior() {
	      this.WizardHandler.wizard().previous();
	    }
	  }, {
	    key: 'existeFormulario',
	    value: function existeFormulario() {
	      if (!this.proyecto) {
	        return false;
	      }
	      if (this.proyecto.cod_documentacion_exp && this.proyecto.documentacion_exp) {
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'getRolUsuario',
	    value: function getRolUsuario() {
	      var id_rol = null;
	      if (this.usuario.rol) {
	        id_rol = this.usuario.rol.id_rol;
	      } else {
	        id_rol = this.usuario.matricula ? 8 : 0;
	      }
	      return id_rol;
	    }
	
	    // esModoEdicion() {
	    //   if (!this.proyecto) {
	    //     return;
	    //   }
	    //   return this.Proyecto.esEditable('plazo_ejecucion');
	    // }
	
	  }]);
	
	  return DocumentacionProyectoController;
	}();
	
	exports.default = DocumentacionProyectoController;

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _documentacionProyecto = __webpack_require__(401);
	
	var _documentacionProyecto2 = _interopRequireDefault(_documentacionProyecto);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DocumentacionProyecto = angular.module('app.documentacionProyecto', []).component('documentacionProyecto', _documentacionProyecto2.default).config(["$stateProvider", function ($stateProvider) {
	    $stateProvider.state('documentacion-proyecto', {
	        url: '/documentacion-proyecto/{codigo:int}',
	        component: 'documentacionProyecto'
	    });
	}]).name;
	
	exports.default = DocumentacionProyecto;

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _matriculas = __webpack_require__(407);
	
	var _matriculas2 = _interopRequireDefault(_matriculas);
	
	var _documentacionProyecto = __webpack_require__(403);
	
	var _documentacionProyecto2 = _interopRequireDefault(_documentacionProyecto);
	
	var _avanceProyecto = __webpack_require__(365);
	
	var _avanceProyecto2 = _interopRequireDefault(_avanceProyecto);
	
	var _planillaProyecto = __webpack_require__(426);
	
	var _planillaProyecto2 = _interopRequireDefault(_planillaProyecto);
	
	var _computoProyecto = __webpack_require__(392);
	
	var _computoProyecto2 = _interopRequireDefault(_computoProyecto);
	
	var _supervision = __webpack_require__(429);
	
	var _supervision2 = _interopRequireDefault(_supervision);
	
	var _cEmpresas = __webpack_require__(366);
	
	var _cEmpresas2 = _interopRequireDefault(_cEmpresas);
	
	var _modificacion = __webpack_require__(411);
	
	var _modificacion2 = _interopRequireDefault(_modificacion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Empresas = angular.module('app.empresas', [_matriculas2.default, _documentacionProyecto2.default, _avanceProyecto2.default, _planillaProyecto2.default, _computoProyecto2.default, _cEmpresas2.default, _modificacion2.default]).service('Supervision', _supervision2.default).name;
	
	exports.default = Empresas;

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _matriculas = __webpack_require__(406);
	
	var _matriculas2 = _interopRequireDefault(_matriculas);
	
	var _matriculas3 = __webpack_require__(626);
	
	var _matriculas4 = _interopRequireDefault(_matriculas3);
	
	__webpack_require__(191);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MatriculasComponent = {
	  bindings: {},
	  controller: _matriculas2.default,
	  template: _matriculas4.default
	};
	
	exports.default = MatriculasComponent;

/***/ }),
/* 406 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MatriculasController = function () {
	  MatriculasController.$inject = ["$rootScope", "DataService", "Storage", "SidenavFactory", "$state", "Loading", "Message"];
	  function MatriculasController($rootScope, DataService, Storage, SidenavFactory, $state, Loading, Message) {
	    'ngInject';
	
	    _classCallCheck(this, MatriculasController);
	
	    this.DataService = DataService;
	    this.Storage = Storage;
	    this.SidenavFactory = SidenavFactory;
	    this.$state = $state;
	    this.Loading = Loading;
	    this.Message = Message;
	    this.$rootScope = $rootScope;
	    this.$rootScope.auth = false;
	  }
	
	  _createClass(MatriculasController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getMatriculas();
	    }
	  }, {
	    key: 'getMatriculas',
	    value: function getMatriculas() {
	      var _this = this;
	
	      this.Loading.show('Cargando datos.', true);
	      this.DataService.get('empresas/' + this.Storage.getUser().nit + '/matriculas').then(function (response) {
	        _this.Loading.hide();
	        if (response) {
	          if (response.datos.length === 1000) {
	            _this.cargarDatosMatricula(response.datos[0]);
	          } else {
	            _this.matriculas = response.datos;
	          }
	        }
	      });
	    }
	  }, {
	    key: 'cargarDatosMatricula',
	    value: function cargarDatosMatricula(matricula) {
	      var empresa = Object.assign(this.Storage.getUser(), {
	        matricula: matricula.IdMatricula,
	        username: matricula.RazonSocial
	      });
	      this.Storage.setUser(empresa);
	      this.SidenavFactory.setUser(empresa);
	      this.$rootScope.auth = true;
	      this.$state.go('pendientes');
	    }
	  }, {
	    key: 'actualizarMatriculas',
	    value: function actualizarMatriculas() {
	      var _this2 = this;
	
	      var user = this.Storage.getUser(user);
	      this.DataService.put('empresas/' + user.nit + '/matriculas', { nit: user.nit }).then(function (resp) {
	        if (resp && resp.finalizado) {
	          _this2.Message.success(resp.mensaje);
	          _this2.matriculas = resp.datos;
	        }
	      });
	      this.actualizado = true;
	    }
	  }]);
	
	  return MatriculasController;
	}();
	
	exports.default = MatriculasController;

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _matriculas = __webpack_require__(405);
	
	var _matriculas2 = _interopRequireDefault(_matriculas);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Matriculas = angular.module('app.matriculas', []).component('matriculas', _matriculas2.default).config(["$stateProvider", function ($stateProvider) {
	    $stateProvider.state('matriculas', {
	        url: '/matriculas',
	        component: 'matriculas'
	    });
	}]).name;
	
	exports.default = Matriculas;

/***/ }),
/* 408 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FechaModificacionController = function () {
	  FechaModificacionController.$inject = ["$uibModalInstance", "Storage", "data"];
	  function FechaModificacionController($uibModalInstance, Storage, data) {
	    'ngInject';
	
	    _classCallCheck(this, FechaModificacionController);
	
	    this.$uibModalInstance = $uibModalInstance;
	    this.proyecto = data;
	    this.user = Storage.getUser();
	  }
	
	  _createClass(FechaModificacionController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var isuper = this.user.rol.nombre === 'SUPERVISOR';
	      this.option = {
	        confirm_txt: isuper ? '¿Está seguro/a de finalizar y enviar las modificaciones?' : '¿Está seguro/a de aprobar las modificaciones?',
	        action: isuper ? 'Registrar' : 'Revisar',
	        disabled: !isuper
	      };
	      this.validacion = {
	        fecha_minima: new Date(this.proyecto.orden_proceder)
	      };
	      this.validacion.fecha_minima.setDate(this.validacion.fecha_minima.getDate() + 1);
	    }
	  }, {
	    key: 'cerrar',
	    value: function cerrar() {
	      this.$uibModalInstance.dismiss('cancel');
	    }
	  }, {
	    key: 'aceptar',
	    value: function aceptar() {
	      this.$uibModalInstance.close(this.proyecto);
	    }
	  }]);
	
	  return FechaModificacionController;
	}();
	
	exports.default = FechaModificacionController;

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	'usr strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _modificacion = __webpack_require__(410);
	
	var _modificacion2 = _interopRequireDefault(_modificacion);
	
	var _modificacion3 = __webpack_require__(628);
	
	var _modificacion4 = _interopRequireDefault(_modificacion3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ModificacionComponent = {
	  bindings: {},
	  controller: _modificacion2.default,
	  template: _modificacion4.default
	};
	
	exports.default = ModificacionComponent;

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _fechamodificacion = __webpack_require__(627);
	
	var _fechamodificacion2 = _interopRequireDefault(_fechamodificacion);
	
	var _fechamodificacionController = __webpack_require__(408);
	
	var _fechamodificacionController2 = _interopRequireDefault(_fechamodificacionController);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ModificacionController = function () {
	  ModificacionController.$inject = ["$scope", "$state", "$stateParams", "$q", "$window", "DataService", "Modal", "Storage", "Util", "Message", "Modificacion", "decimales", "$log"];
	  function ModificacionController($scope, $state, $stateParams, $q, $window, DataService, Modal, Storage, Util, Message, Modificacion, decimales, $log) {
	    'ngInject';
	
	    _classCallCheck(this, ModificacionController);
	
	    this.$scope = $scope;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$q = $q;
	    this.$window = $window;
	    this.DataService = DataService;
	    this.Modal = Modal;
	    this.Storage = Storage;
	    this.Util = Util;
	    this.Message = Message;
	    this.Modificacion = Modificacion;
	    this.decimales = decimales;
	    this.$log = $log;
	
	    this.usuario = this.Storage.getUser();
	    if (['RESPONSABLE_MAE', 'SUPERVISOR', 'FISCAL', 'TECNICO_UPRE', 'RESP_DEPARTAMENTAL_UPRE', 'EMPRESA', 'ENCAR_REGIONAL_UPRE'].indexOf(this.usuario.rol.nombre) < 0) {
	      Message.warning('No tiene permisos suficientes para ver la modificación');
	      this.$window.history.back();
	    }
	    this.filtroItems = 'TODOS';
	
	    this.tipoModificacion = $stateParams.tipoModificacion;
	    this.tabIndex = 1;
	  }
	
	  _createClass(ModificacionController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      if (this.$stateParams.crear) {
	        this.$stateParams.crear = false;
	        this.crearModificacion();
	      } else {
	        this.obtenerModificacion();
	      }
	
	      // TODO verificar la URL con el backend
	      this.url = 'proyectos/' + this.$stateParams.proyecto;
	      this.mensajeConfirmacion = {
	        "Finalizar": '\xBFEst\xE1 seguro de finalizar y enviar las modificaciones?<br>\n                    Se le informa que estas modificaciones, una vez aprobadas ser\xE1n incorporadas a la planilla de avance.',
	        "Cancelar": '\xBFEst\xE1 seguro/a de cancelar la modificaci\xF3n?<br>La cancelaci\xF3n revertir\xE1 los cambios realizados en la presente modificaci\xF3n.',
	        "Guardar": 'Se guardar\xE1n los cambios realizados.'
	      };
	
	      this.modificandoPlazo = this.modificandoItems = this.modoVista = !this.$stateParams.edicion;
	
	      this.$scope.$on('transicion_accion_ejecutada', function () {
	        _this.$state.go('mis-proyectos');
	      });
	
	      /* DOCUMENTO */
	      this.uploadCallback = function (file) {
	        var data = {
	          "doc_respaldo_modificacion": angular.copy(file)
	        };
	        _this.DataService.put('proyectos/' + _this.$stateParams.proyecto, data).then(function (response) {
	          if (response && response.finalizado) {
	            _this.informe_tecnico_registrado = true;
	            //this.asignarDatos(file, response.datos.documento);
	          }
	        });
	      };
	    }
	  }, {
	    key: '$onChanges',
	    value: function $onChanges() {
	      var _this2 = this;
	
	      this.$scope.$watch('$ctrl.filtroItems', function () {
	        if (!_this2.proyecto) {
	          return;
	        }
	        _this2.mostrarItems();
	      });
	    }
	  }, {
	    key: 'cancelar',
	    value: function cancelar() {
	      this.Modal.confirm('\xBFEst\xE1 seguro/a de cancelar la modificaci\xF3n?<br>La cancelaci\xF3n revertir\xE1 los cambios realizados en la presente modificaci\xF3n.', function () {}, null, 'Cancelación de modificación', 'Sí, estoy seguro/a');
	    }
	  }, {
	    key: 'finalizar',
	    value: function finalizar() {
	      this.Modal.confirm('\xBFEst\xE1 seguro de finalizar y enviar las modificaciones?<br>\n      Se le informa que estas modificaciones de fecha __/__/__ una vez aprobadas ser\xE1n incorporadas a la planilla de avance.', function () {}, null, 'Finalizar Modificación', 'Sí, estoy seguro/a');
	    }
	  }, {
	    key: 'crearModificacion',
	    value: function crearModificacion() {
	      var _this3 = this;
	
	      var tipo = this.tipoModificacion === 3 ? 'TM_CONTRATO_MODIFICATORIO' : this.tipoModificacion === 2 ? 'TM_ORDEN_CAMBIO' : this.tipoModificacion === 1 ? 'TM_ORDEN_TRABAJO' : 'TM';
	      this.DataService.put('proyectos/' + this.$stateParams.proyecto + '/modificaciones?tipo=' + tipo).then(function (result) {
	        if (result && result.finalizado) {
	          //this.proyecto = result.datos;
	          //this.agregarCamposModificar(result.datos);
	          _this3.$state.go('modificacion', {
	            proyecto: _this3.$stateParams.proyecto,
	            version: result.datos.version,
	            tipoModificacion: tipo,
	            edicion: true,
	            crear: false
	          });
	        } else {
	          //this.$state.go('mis-proyectos',null);
	          _this3.$window.history.back();
	        }
	      });
	    }
	  }, {
	    key: 'obtenerModificacion',
	    value: function obtenerModificacion() {
	      var _this4 = this;
	
	      // TODO enviar rol si el supervisor tiene mas de un rol
	      var query = {
	        rol: this.Storage.get('rol').id_rol
	      };
	      if (this.$stateParams.version) {
	        query.version = this.$stateParams.version;
	      }
	      var url = 'proyectos/' + this.$stateParams.proyecto + '/modificaciones?' + this.Util.serialize(query);
	      this.DataService.get(url).then(function (result) {
	        if (result && result.finalizado) {
	          _this4.$log.log('DATOS RESULTD====>' + JSON.stringify(result.datos));
	          if (!result.datos.modificaciones || !result.datos.modificaciones.nombre) {
	            if (_this4.tipoModificacion != 0) _this4.$state.go('mis-proyectos', null);
	          }
	          //this.proyecto = result.datos;
	          _this4.agregarCamposModificar(result.datos);
	          _this4.proyecto.idProyecto = _this4.$stateParams.proyecto;
	          if (_this4.proyecto.doc_respaldo_modificacion) {
	            var a = _this4.proyecto.doc_respaldo_modificacion.indexOf('[') + 1;
	            var b = _this4.proyecto.doc_respaldo_modificacion.indexOf(']');
	            var codigo = _this4.proyecto.doc_respaldo_modificacion.substring(a, b);
	            _this4.DataService.get('proyectos/' + _this4.$stateParams.proyecto + '/doc/' + codigo).then(function (doc) {
	              if (doc && doc.finalizado) {
	                _this4.informe_tecnico = doc.datos;
	                _this4.informe_tecnico_registrado = true;
	              }
	            });
	          }
	          if (!_this4.$stateParams.edicion && _this4.proyecto.estado_actual) {
	            _this4.$stateParams.edicion = _this4.proyecto.estado_actual.codigo === 'MODIFICADO' && _this4.usuario.rol.nombre === 'SUPERVISOR';
	            _this4.modoVista = !_this4.$stateParams.edicion;
	          }
	          _this4.esTecnico = ['TECNICO_UPRE', 'RESP_DEPARTAMENTAL_UPRE', 'ENCAR_REGIONAL_UPRE'].indexOf(_this4.usuario.rol.nombre) >= 0 && _this4.proyecto.estado_actual.codigo == 'MODIFICADO';
	        } else {
	          _this4.$state.go('mis-proyectos', null);
	        }
	      });
	    }
	  }, {
	    key: 'agregarCamposModificar',
	    value: function agregarCamposModificar(proyecto) {
	      if (proyecto) {
	        this.tipoModificacion = proyecto.tipo_modificacion == 'TM_ORDEN_TRABAJO' ? 1 : proyecto.tipo_modificacion == 'TM_ORDEN_CAMBIO' ? 2 : proyecto.tipo_modificacion == 'TM_CONTRATO_MODIFICATORIO' ? 3 : 0;
	        if (this.tipoModificacion == 0) {}
	        //this.Message.warning('No se ha especificado un tipo de modificación válido');
	        //this.irAtras();
	        //this.$state.go('pendientes',null);
	
	        // Historial
	        proyecto.modificaciones.total_variacion = 0;
	        proyecto.modificaciones.total_variacion_porcentaje = 0;
	        proyecto.plazo_ampliacion_total = 0;
	        for (var i in proyecto.modificaciones.historial) {
	          var version = proyecto.modificaciones.historial[i];
	          if (version.tipo_modificacion === proyecto.tipo_modificacion) {
	            //proyecto.modificaciones.total_variacion = version.variacion+proyecto.modificaciones.total_variacion;
	            proyecto.modificaciones.total_variacion = this.Util.sumar([version.variacion, proyecto.modificaciones.total_variacion]);
	            //version.variacion_porcentaje = version.variacion*100/proyecto.version_inicial.monto_total;
	            version.variacion_porcentaje = this.Util.multiplicar([version.variacion, this.Util.dividir(100, proyecto.version_inicial.monto_total)]);
	            //proyecto.modificaciones.total_variacion_porcentaje += version.variacion_porcentaje;
	            proyecto.modificaciones.total_variacion_porcentaje = this.Util.sumar([proyecto.modificaciones.total_variacion_porcentaje, version.variacion_porcentaje]);
	          }
	          version.plazo_ampliacion_total = proyecto.plazo_ampliacion_total += version.plazo_ampliacion ? version.plazo_ampliacion.por_volumenes + version.plazo_ampliacion.por_compensacion : 0;
	          version.nueva_fecha_provisional = new Date(proyecto.orden_proceder);
	          version.nueva_fecha_provisional.setDate(version.nueva_fecha_provisional.getDate() - 1 + version.plazo_ampliacion_total + proyecto.plazo_ejecucion);
	        }
	        // Modulos
	        this.nuevosmodulos = [];
	        this.cabecera = angular.copy(proyecto.modulos[0].items[0]);
	        if (!proyecto.version_anterior || !proyecto.version_anterior.tipo_modificacion_proyecto) {
	          this.cabecera.version_anterior = null;
	        }
	        //TODO verificar backend
	        if (proyecto.version == 2 && !this.cabecera.version_inicial) {
	          this.cabecera.version_anterior = {};
	        }
	        if (proyecto.version == 1) {
	          proyecto.modificaciones.nombre = "Contrato Original";
	        }
	        var modulos = [];
	        for (var _i in proyecto.modulos) {
	          if (proyecto.modulos[_i].nombre.indexOf(proyecto.modificaciones.nombre) >= 0) {
	            this.nuevosmodulos.push(proyecto.modulos[_i]);
	            this.modificandoItems = true;
	          } else {
	            var modulo = proyecto.modulos[_i];
	            modulo.isCollapsed = true && !this.modoVista;
	            for (var j in modulo.items) {
	              if (modulo.items[j].version_anterior && modulo.items[j].cantidad != modulo.items[j].version_anterior.cantidad) {
	                this.modificandoItems = true;
	                modulo.isCollapsed = false;
	              }
	              // Verificar avance
	              if (!modulo.items[j].avance_actual) {
	                modulo.items[j].avance_actual = 0;
	              }
	              if (modulo.items[j].estado === 'CERRADO') {
	                modulo.items[j].avance_actual = modulo.items[j].cantidad;
	              }
	              // Verificar cabeceras
	              if (!modulo.items[j].version_inicial && this.cabecera.version_inicial) {
	                modulo.items[j].version_inicial = {};
	              }
	              modulo.items[j].show = true;
	              // Para verificar si se modifico el valor
	              modulo.items[j].cantidad_ant = modulo.items[j].cantidad;
	            }
	            modulos.push(modulo);
	          }
	        }
	        proyecto.modulos = modulos;
	        this.proyecto = proyecto;
	        this.modificandoPlazo = this.proyecto.plazo_ampliacion && (this.proyecto.plazo_ampliacion.por_volumenes || this.proyecto.plazo_ampliacion.por_compensacion);
	        this.recalcularMontos();
	        this.recalcularFechas();
	        // Valores para verificar se se han cambiado los datos.
	        this.proyecto.plazo_ampliacion_ant = {};
	      }
	    }
	
	    // TODO obtener valores desde el backend
	
	  }, {
	    key: 'calcularFechaAmpliada',
	    value: function calcularFechaAmpliada(fecha) {
	      if (fecha && this.proyecto && this.proyecto.plazo_ampliacion) {
	        fecha = new Date(fecha);
	        fecha.setDate(fecha.getDate() + this.proyecto.plazo_ampliacion.por_volumenes + this.proyecto.plazo_ampliacion.por_compensacion);
	      }
	      return fecha;
	    }
	
	    /* MODIFICAR ITEMS */
	
	  }, {
	    key: 'modificarCantidadItem',
	    value: function modificarCantidadItem(item) {
	      var _this5 = this;
	
	      if (item && item.cantidad_ant != item.cantidad) {
	        this.DataService.put('items/' + item.id_item, { cantidad: item.cantidad }).then(function (result) {
	          if (result && result.finalizado) {
	            _this5.Message.success(result.mensaje);
	            item.error = false;
	          } else {
	            item.error = true;
	          }
	          item.cantidad_ant = item.cantidad;
	        });
	        this.recalcularMontos();
	      }
	    }
	  }, {
	    key: 'recalcularMontos',
	    value: function recalcularMontos(item) {
	      // TODO para optimizar solo sumar o restar el item modificado. (probar con item eliminado)
	      item;
	      //Recalcular monto total
	      this.cantItems = 0;
	      this.proyecto.monto_total_variacion_modificado = 0;
	      for (var i in this.proyecto.modulos) {
	        for (var j in this.proyecto.modulos[i].items) {
	          this.cantItems++;
	          // if(this.proyecto.modulos[i].items[j].version_anterior && this.proyecto.modulos[i].items[j].version_anterior.cantidad!=this.proyecto.modulos[i].items[j].cantidad) {
	          //   // this.proyecto.monto_total_variacion_modificado += this.Util.redondear(this.proyecto.modulos[i].items[j].precio_unitario * (this.proyecto.modulos[i].items[j].cantidad-this.proyecto.modulos[i].items[j].version_anterior.cantidad));
	          //   this.proyecto.monto_total_variacion_modificado = this.Util.sumar([this.proyecto.monto_total_variacion_modificado,
	          //     this.Util.multiplicar([this.proyecto.modulos[i].items[j].precio_unitario,
	          //       this.Util.restar(this.proyecto.modulos[i].items[j].cantidad,this.proyecto.modulos[i].items[j].version_anterior.cantidad)
	          //     ])
	          //   ]);
	          // }
	          this.proyecto.monto_total_variacion_modificado = this.Util.sumar([this.proyecto.monto_total_variacion_modificado, this.Util.multiplicar([this.proyecto.modulos[i].items[j].precio_unitario, this.proyecto.modulos[i].items[j].cantidad]), this.proyecto.modulos[i].items[j].cr_precio]);
	        }
	      }
	      for (var _i2 in this.nuevosmodulos) {
	        for (var _j in this.nuevosmodulos[_i2].items) {
	          this.nuevosmodulos[_i2].items[_j].nro_item = ++this.cantItems;
	          if (this.nuevosmodulos[_i2].items[_j].precio_unitario && this.nuevosmodulos[_i2].items[_j].cantidad) {
	            // this.proyecto.monto_total_variacion_modificado += this.Util.redondear(this.nuevosmodulos[i].items[j].precio_unitario * this.nuevosmodulos[i].items[j].cantidad);
	            this.proyecto.monto_total_variacion_modificado = this.Util.sumar([this.proyecto.monto_total_variacion_modificado, this.Util.multiplicar([this.nuevosmodulos[_i2].items[_j].precio_unitario, this.nuevosmodulos[_i2].items[_j].cantidad]), this.nuevosmodulos[_i2].items[_j].cr_precio]);
	          }
	        }
	      }
	      if (this.proyecto.version_anterior) {
	        this.proyecto.monto_total_variacion_modificado = this.Util.restar(this.proyecto.monto_total_variacion_modificado, this.proyecto.version_anterior.monto_total);
	      } else {
	        this.proyecto.monto_total_variacion_modificado = 0;
	      }
	      //this.proyecto.porcentaje_variacion = this.proyecto.monto_total_variacion_modificado*100/this.proyecto.version_inicial.monto_total;
	      this.proyecto.porcentaje_variacion = this.Util.dividir(this.Util.multiplicar([this.proyecto.monto_total_variacion_modificado, 100]), this.proyecto.version_inicial.monto_total);
	      this.porcentajeLimite = this.tipoModificacion === 3 ? 0.1 : this.tipoModificacion === 2 ? 0.05 : 0;
	      // TODO tambien debe sumarse con las anteriores modificaciones.
	      //let monto_variacion = this.Util.redondear(this.proyecto.monto_total_variacion_modificado+this.proyecto.modificaciones.total_variacion);
	      var monto_variacion = this.Util.sumar([this.proyecto.monto_total_variacion_modificado, this.proyecto.modificaciones.total_variacion]);
	      //let monto_limite = this.Util.redondear(this.proyecto.version_inicial.monto_total*this.porcentajeLimite);
	      var monto_limite = this.Util.multiplicar([this.proyecto.version_inicial.monto_total, this.porcentajeLimite]);
	      this.porcentajeExcedido = monto_variacion > monto_limite || this.Util.restar(0, monto_variacion) > monto_limite;
	    }
	  }, {
	    key: 'adicionarModulo',
	    value: function adicionarModulo() {
	      var _this6 = this;
	
	      if (!this.nuevosmodulos || !this.nuevosmodulos[0]) {
	        var datos = {
	          fid_proyecto: this.$stateParams.proyecto,
	          nombre: 'ITEMS NUEVOS (' + this.proyecto.modificaciones.nombre + ')'
	        };
	        this.DataService.post('modulos', datos).then(function (result) {
	          if (result && result.finalizado) {
	            if (!_this6.nuevosmodulos) {
	              _this6.nuevosmodulos = [];
	            }
	            _this6.Message.success(result.mensaje);
	            if (!result.datos.items) {
	              result.datos.items = [];
	            }
	            if (result.datos.items.length <= 0) {
	              result.datos.items.push({ edicion: true });
	            }
	            _this6.nuevosmodulos.push(result.datos);
	          }
	        });
	      }
	    }
	  }, {
	    key: 'modificarItems',
	    value: function modificarItems() {
	      this.modificandoItems = !this.modificandoItems;
	    }
	
	    /* MODIFICACION DEL PLAZO */
	
	  }, {
	    key: 'modificarPlazoAmpliacion',
	    value: function modificarPlazoAmpliacion(plazo_ampliacion) {
	      var _this7 = this;
	
	      if (plazo_ampliacion) {
	        plazo_ampliacion.por_compensacion = plazo_ampliacion.por_compensacion || 0;
	        plazo_ampliacion.por_volumenes = plazo_ampliacion.por_volumenes || 0;
	        var datos = {
	          plazo_ampliacion: {
	            por_compensacion: parseInt(plazo_ampliacion.por_compensacion || 0),
	            por_volumenes: parseInt(plazo_ampliacion.por_volumenes || 0)
	          }
	        };
	        if (this.proyecto.plazo_ampliacion_ant.por_volumenes != plazo_ampliacion.por_volumenes || this.proyecto.plazo_ampliacion_ant.por_compensacion != plazo_ampliacion.por_compensacion) {
	          delete this.proyecto.nueva_fecha_provisional;
	          delete this.proyecto.nueva_fecha_definitiva;
	          this.DataService.put('proyectos/' + this.$stateParams.proyecto, datos).then(function (result) {
	            if (result && result.finalizado) {
	              _this7.Message.success(result.mensaje);
	              _this7.proyecto.plazo_ampliacion_ant = angular.copy(plazo_ampliacion);
	              _this7.recalcularFechas();
	            }
	          });
	        }
	      }
	    }
	  }, {
	    key: 'recalcularFechas',
	    value: function recalcularFechas() {
	      var plazo_ampliacion = this.proyecto.plazo_ampliacion;
	      if (plazo_ampliacion && (parseInt(plazo_ampliacion.por_compensacion) || parseInt(plazo_ampliacion.por_volumenes))) {
	        this.proyecto.nueva_fecha_provisional = new Date(this.proyecto.orden_proceder);
	        this.proyecto.fecha_recepcion_provisional = this.proyecto.nueva_fecha_provisional.setDate(this.proyecto.nueva_fecha_provisional.getDate() + parseInt(plazo_ampliacion.por_volumenes) + parseInt(plazo_ampliacion.por_compensacion) - 1 + this.proyecto.plazo_ejecucion + this.proyecto.plazo_ampliacion_total);
	        this.proyecto.nueva_fecha_definitiva = new Date(this.proyecto.nueva_fecha_provisional);
	        this.proyecto.fecha_recepcion_definitiva = this.proyecto.nueva_fecha_definitiva.setDate(this.proyecto.nueva_fecha_provisional.getDate() + 90);
	      } else {
	        delete this.proyecto.nueva_fecha_provisional;
	        delete this.proyecto.nueva_fecha_definitiva;
	        this.proyecto.fecha_recepcion_provisional = new Date(this.proyecto.orden_proceder);
	        this.proyecto.fecha_recepcion_provisional.setDate(this.proyecto.fecha_recepcion_provisional.getDate() - 1 + this.proyecto.plazo_ejecucion + this.proyecto.plazo_ampliacion_total);
	        this.proyecto.fecha_recepcion_definitiva = new Date(this.proyecto.fecha_recepcion_provisional);
	        this.proyecto.fecha_recepcion_definitiva.setDate(this.proyecto.fecha_recepcion_definitiva.getDate() + 90);
	      }
	    }
	  }, {
	    key: 'fechaSumDias',
	    value: function fechaSumDias(fecha, dias) {
	      var fechaNueva = new Date(fecha);
	      if (!isNaN(fechaNueva.getTime()) && !isNaN(parseInt(dias))) {
	        fechaNueva.setDate(fechaNueva.getDate() + parseInt(dias));
	        return fechaNueva;
	      }
	      return fecha;
	    }
	  }, {
	    key: 'modificarPlazo',
	    value: function modificarPlazo() {
	      this.modificandoPlazo = !this.modificandoPlazo;
	    }
	
	    /* INFOMRE TECNICO*/
	
	  }, {
	    key: 'verInformeTecnico',
	    value: function verInformeTecnico() {
	      this.Modal.showDocumentBase64(this.informe_tecnico.base64, 'Informe', 'strBase64');
	    }
	  }, {
	    key: 'quitarInformeTecnico',
	    value: function quitarInformeTecnico() {
	      this.informe_tecnico_registrado = false;
	      delete this.informe_tecnico;
	    }
	
	    /* FUNCIONES UTILES */
	
	  }, {
	    key: 'mostrarItems',
	    value: function mostrarItems() {
	      switch (this.filtroItems) {
	        case 'COMPLETADOS':
	          this.filtrarItems(function (item) {
	            return item.avance_actual === item.cantidad;
	          });
	          break;
	        case 'INCOMPLETOS':
	          this.filtrarItems(function (item) {
	            return item.avance_actual !== item.cantidad;
	          });
	          break;
	        default:
	          this.filtrarItems();
	      }
	    }
	  }, {
	    key: 'getMgColor',
	    value: function getMgColor(item) {
	      if (item.avance_actual === item.cantidad || item.estado === 'CERRADO') {
	        return 'bl-success';
	      }
	      if (item.avance_actual === 0) {
	        return 'bl-primary';
	      }
	      if (item.avance_actual > 0) {
	        return 'bl-info';
	      }
	      return 'bl-warning';
	    }
	  }, {
	    key: 'getTitle',
	    value: function getTitle(item) {
	      if (item.avance_actual === item.cantidad || item.estado === 'CERRADO') {
	        return 'Completado';
	      }
	      if (item.avance_actual === 0) {
	        return 'Sin avance';
	      }
	      if (item.avance_actual > 0) {
	        return 'Con avance';
	      }
	      return 'Con avance';
	    }
	  }, {
	    key: 'filtrarItems',
	    value: function filtrarItems() {
	      var condicion = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {
	        return true;
	      };
	
	      this.proyecto.modulos.forEach(function (modulo) {
	        modulo.items.forEach(function (item) {
	          item.show = condicion(item);
	        });
	        //modulo.show = this._.some(modulo.items, { show: true });
	      });
	    }
	  }, {
	    key: 'irAtras',
	    value: function irAtras() {
	      window.history.back();
	    }
	  }, {
	    key: 'verificarInformeTecnico',
	    value: function verificarInformeTecnico() {
	      if (!this.informe_tecnico_registrado) {
	        this.Message.warning('Debe cargar el documento con la aprobaci\xF3n de la modificaci\xF3n.');
	      }
	      return this.informe_tecnico_registrado;
	    }
	  }, {
	    key: 'verificarNuevosItems',
	    value: function verificarNuevosItems() {
	      // Verificar documentos adjuntos
	      if (this.nuevosmodulos && this.nuevosmodulos[0]) {
	        for (var i in this.nuevosmodulos[0].items) {
	          var item = this.nuevosmodulos[0].items[i];
	          if (item.id_item && !item.especificaciones) {
	            this.Message.warning('Debe cargar el documento de especificaciones t\xE9cnicas del item<br>Nro. ' + item.nro_item + ' - <strong>' + item.nombre + '</strong>');
	            return false;
	          }
	          if (!this.nuevosmodulos[0].items[i].analisis_precios) {
	            this.Message.warning('Debe cargar el documento de an\xE1lisis de precios unitarios del item<br>Nro. ' + item.nro_item + ' - <strong>' + item.nombre + '</strong>');
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /* TRANSICION */
	
	  }, {
	    key: 'verificarModificacion',
	    value: function verificarModificacion(accion) {
	      var _this8 = this;
	
	      var defer = this.$q.defer();
	      // TODO Se debe verificar segun tipo modificacion
	      // ---
	      // Registrar la fecha de modificacion
	      if (accion.label === 'Cancelar') {
	        this.proyecto.fecha_modificacion = new Date();
	        defer.resolve({ confirmar: true });
	      } else {
	        // verificar campos requeridos
	        if (!this.verificarInformeTecnico()) {
	          defer.reject();
	          return defer.promise;
	        }
	        if (!this.verificarNuevosItems()) {
	          defer.reject();
	          return defer.promise;
	        }
	        // Modal para registrar fecha
	        var modalFechaModificacion = this.Modal.show({
	          template: _fechamodificacion2.default,
	          controller: _fechamodificacionController2.default,
	          data: this.proyecto,
	          size: 'md'
	        });
	        modalFechaModificacion.result.then(function (proyecto) {
	          _this8.proyecto = proyecto;
	          defer.resolve();
	        }, function () {});
	      }
	      //defer.resolve({confirmar: true});
	      return defer.promise;
	    }
	  }, {
	    key: 'cRegularizacion',
	    value: function cRegularizacion(item) {
	      var _this9 = this;
	
	      if (typeof item.cr_precio === 'undefined') {
	        item.cr_precio = '';
	      }
	      var data = {
	        cRedondeo: item.cr_precio
	      };
	      this.DataService.put('proyectos/' + this.proyecto.idProyecto + '/item/' + item.id_item + '/campo_regularizacion', data).then(function (resp) {
	        if (resp && resp.finalizado) {
	          // this.recalcularMontos(item);
	          _this9.$state.reload();
	        } else {
	          item.cr_precio = '';
	        }
	      });
	    }
	  }, {
	    key: 'agregarQuitarCampo',
	    value: function agregarQuitarCampo() {
	      var _this10 = this;
	
	      var data = {
	        cRedondeo: !this.proyecto.cr_precio
	      };
	      this.DataService.put('proyectos/' + this.proyecto.idProyecto + '/campo_regularizacion', data).then(function (resp) {
	        if (resp && resp.finalizado) {
	          _this10.proyecto.cr_precio = true;
	        } else {
	          _this10.proyecto.cr_precio = false;
	        }
	      });
	    }
	  }]);
	
	  return ModificacionController;
	}();
	
	exports.default = ModificacionController;

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _modificacion = __webpack_require__(409);
	
	var _modificacion2 = _interopRequireDefault(_modificacion);
	
	var _modulo = __webpack_require__(413);
	
	var _modulo2 = _interopRequireDefault(_modulo);
	
	var _modificacion3 = __webpack_require__(412);
	
	var _modificacion4 = _interopRequireDefault(_modificacion3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Modificacion = angular.module('app.modificacion', []).component('modificacion', _modificacion2.default).component('modulo', _modulo2.default).config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('modificacion', {
	    url: '/modificacion/{proyecto:int}/version/{version:int}',
	    component: 'modificacion',
	    params: {
	      tipoModificacion: 0,
	      version: 0,
	      edicion: false,
	      crear: false
	    }
	  });
	}]).service('Modificacion', _modificacion4.default).name;
	
	exports.default = Modificacion;

/***/ }),
/* 412 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ModificacionService = function () {
	  ModificacionService.$inject = ["Util", "_"];
	  function ModificacionService(Util, _) {
	    'ngInject';
	
	    _classCallCheck(this, ModificacionService);
	
	    this.Util = Util;
	    this._ = _;
	  }
	
	  _createClass(ModificacionService, [{
	    key: 'getDatosSegunEstado',
	    value: function getDatosSegunEstado(modificacion) {
	      var _this = this;
	
	      var nSupervision = {};
	      var atributos = Array.isArray(modificacion.estado_actual.atributos) ? modificacion.estado_actual.atributos : this._.keys(modificacion.estado_actual.atributos);
	      atributos.map(function (atributo) {
	        if (!_this.Util.isEmpty(modificacion[atributo])) {
	          nSupervision[atributo] = modificacion[atributo];
	        }
	      });
	      return nSupervision;
	    }
	  }]);
	
	  return ModificacionService;
	}();
	
	exports.default = ModificacionService;

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _modulo = __webpack_require__(414);
	
	var _modulo2 = _interopRequireDefault(_modulo);
	
	var _modulo3 = __webpack_require__(629);
	
	var _modulo4 = _interopRequireDefault(_modulo3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ModuloComponent = {
	  bindings: {
	    modulo: '=',
	    proyecto: '<',
	    modoVista: '<',
	    callback: '&',
	    options: '<'
	  },
	  controller: _modulo2.default,
	  template: _modulo4.default
	};
	
	exports.default = ModuloComponent;

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _archivoModal = __webpack_require__(46);
	
	var _archivoModal2 = _interopRequireDefault(_archivoModal);
	
	var _archivoModal3 = __webpack_require__(47);
	
	var _archivoModal4 = _interopRequireDefault(_archivoModal3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ModuloController = function () {
	  ModuloController.$inject = ["$state", "DataService", "Util", "Modal", "NgTableParams", "Message", "$log"];
	  function ModuloController($state, DataService, Util, Modal, NgTableParams, Message, $log) {
	    'ngInject';
	
	    _classCallCheck(this, ModuloController);
	
	    this.$state = $state;
	    this.DataService = DataService;
	    this.Util = Util;
	    this.Modal = Modal;
	    this.NgTableParams = NgTableParams;
	    this.Message = Message;
	    this.$log = $log;
	
	    if (!this.options) {
	      // Configuracion por defecto
	      this.options = {
	        guardar: true,
	        adicionar: true,
	        editar: true,
	        eliminar: true
	      };
	    }
	  }
	
	  _createClass(ModuloController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getTipoUnidades();
	    }
	  }, {
	    key: 'getTipoUnidades',
	    value: function getTipoUnidades() {
	      var _this = this;
	
	      this.DataService.get('parametricas/UNIDAD').then(function (response) {
	        if (response) {
	          _this.unidades = response.datos.rows;
	        }
	      });
	    }
	
	    /*
	    * MODULO
	    */
	
	  }, {
	    key: 'guardarDatosModulo',
	    value: function guardarDatosModulo() {}
	  }, {
	    key: 'adicionarItem',
	    value: function adicionarItem(modulo) {
	      this.$log.log('adicionarItem', modulo);
	      if (!modulo.items) {
	        modulo.items = [];
	      }
	      modulo.items.push({ edicion: true });
	    }
	  }, {
	    key: 'editarModulo',
	    value: function editarModulo() {}
	  }, {
	    key: 'eliminarModulo',
	    value: function eliminarModulo() {
	      var _this2 = this;
	
	      if (this.modulo) {
	        this.Modal.confirm('\xBFEst\xE1 seguro/a de eliminar el nuevo m\xF3dulo y los items adicionados?', function () {
	          _this2.DataService.delete('modulos/' + _this2.modulo.id_modulo).then(function (result) {
	            if (result && result.finalizado) {
	              _this2.Message.success(result.mensaje);
	              _this2.modulo = null;
	            }
	          });
	        }, null, 'Eliminar el nuevo módulo', 'Sí, estoy seguro/a');
	      }
	    }
	
	    /*
	    * ITEMS
	    */
	
	  }, {
	    key: 'guardarItem',
	    value: function guardarItem(item) {
	      var _this3 = this;
	
	      this.$log.log('guardarItem', item);
	      item.fid_modulo = this.modulo.id_modulo;
	      this.DataService.post('items', item).then(function (result) {
	        if (result && result.finalizado) {
	          _this3.Message.success(result.mensaje);
	          item.id_item = result.datos.id_item;
	          item.edicion = false;
	          _this3.callback({ data: item });
	        }
	      });
	    }
	  }, {
	    key: 'actualizarItem',
	    value: function actualizarItem(item) {
	      var _this4 = this;
	
	      this.$log.log('actualizarItem', item);
	      this.DataService.put('items/' + item.id_item, item).then(function (result) {
	        if (result && result.finalizado) {
	          _this4.Message.success(result.mensaje);
	          item.edicion = false;
	          _this4.callback({ data: item });
	        }
	      });
	    }
	  }, {
	    key: 'verPdfItem',
	    value: function verPdfItem(item, codigo) {
	      if (codigo && (codigo == 'ET' || codigo == 'APU' || codigo == 'ESQ')) {
	        var datos = {
	          codigo: codigo + '_' + item.id_item,
	          titulo: codigo === 'ET' ? 'Especificaciones T\xE9cnicas - "' + item.nombre + '"' : codigo === 'APU' ? 'Analisis de Precios Unitarios - "' + item.nombre + '"' : 'Esquema - "' + item.nombre + '"'
	        };
	        this.Modal.showDocumentBase64('proyectos/' + this.options.idProyecto + '/doc/' + datos.codigo, datos.titulo);
	      }
	    }
	  }, {
	    key: 'cargarPdfItem',
	    value: function cargarPdfItem(item, codigo) {
	      var _this5 = this;
	
	      if (codigo && (codigo == 'ET' || codigo == 'APU' || codigo == 'ESQ')) {
	        var titulo = codigo === 'ET' ? 'Especificaciones T\xE9cnicas - "' + item.nombre + '"' : codigo === 'APU' ? 'Analisis de Precios Unitarios - "' + item.nombre + '"' : 'Esquema - "' + item.nombre + '"';
	        var confArchivo = {
	          formatos: 'pdf',
	          tipos: '.pdf'
	        };
	        this.mostrarModal(titulo, 'fa-upload', confArchivo, _archivoModal4.default, _archivoModal2.default, 'Cargar documento').result.then(function (docEspecificaciones) {
	          if (angular.isUndefined(docEspecificaciones)) {
	            return;
	          }
	          var datos = {};
	          if (codigo === 'ET') datos.especificaciones = docEspecificaciones;
	          if (codigo === 'APU') datos.analisis_precios = docEspecificaciones;
	          if (codigo === 'ESQ') datos.doc_esquema = docEspecificaciones;
	          _this5.DataService.put('items/' + item.id_item, datos).then(function (result) {
	            if (result && result.finalizado) {
	              _this5.Message.success('Se registr\xF3 el documento del item "' + item.nombre + '" correctamente.');
	              // item.especificaciones = docEspecificaciones;
	              if (codigo === 'ET') item.especificaciones = docEspecificaciones;
	              if (codigo === 'APU') item.analisis_precios = docEspecificaciones;
	              if (codigo === 'ESQ') item.doc_esquema = docEspecificaciones;
	            }
	          });
	        });
	      }
	    }
	  }, {
	    key: 'eliminarItem',
	    value: function eliminarItem(item, $index) {
	      var _this6 = this;
	
	      if (!item.id_item) {
	        this.modulo.items.splice($index, 1);
	        this.callback({ data: item });
	        return;
	      }
	      this.Modal.confirm('\xBFEst\xE1 seguro/a de eliminar el item ' + item.nombre + '?', function () {
	        _this6.DataService.delete('items/' + item.id_item).then(function (result) {
	          if (result && result.finalizado) {
	            _this6.Message.success(result.mensaje);
	            _this6.modulo.items.splice($index, 1);
	            _this6.callback({ data: item });
	          }
	        });
	      }, null, 'Eliminar item', 'Sí, estoy seguro/a');
	    }
	
	    // Modal
	
	  }, {
	    key: 'mostrarModal',
	    value: function mostrarModal(titulo, icon, data, template, controller, labelOk, size) {
	      return this.Modal.show({
	        template: template,
	        controller: controller,
	        data: data || {},
	        title: titulo,
	        icon: icon,
	        size: size ? size : 'md',
	        labelOk: labelOk
	      });
	    }
	  }, {
	    key: 'cRecularizacion',
	    value: function cRecularizacion(item) {
	      var _this7 = this;
	
	      if (typeof item.cr_precio === 'undefined') {
	        item.cr_precio = '';
	      }
	      var data = {
	        cRedondeo: item.cr_precio
	      };
	      this.DataService.put('proyectos/' + this.proyecto.idProyecto + '/item/' + item.id_item + '/campo_regularizacion', data).then(function (resp) {
	        if (resp && resp.finalizado) {
	          // this.callback({data:item});
	          _this7.$state.reload();
	        } else {
	          item.cr_precio = '';
	        }
	      });
	    }
	  }]);
	
	  return ModuloController;
	}();
	
	exports.default = ModuloController;

/***/ }),
/* 415 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ComputoMetricosModalController = function () {
	  ComputoMetricosModalController.$inject = ["$uibModalInstance", "$scope", "DataService", "Message", "data", "_", "$http", "$log"];
	  function ComputoMetricosModalController($uibModalInstance, $scope, DataService, Message, data, _, $http, $log) {
	    'ngInject';
	
	    _classCallCheck(this, ComputoMetricosModalController);
	
	    this.$uibModalInstance = $uibModalInstance;
	    this.$scope = $scope;
	    this.DataService = DataService;
	    this.Message = Message;
	    this.data = data;
	    this._ = _;
	    this.supervision = data.supervision;
	    this.item = data.item;
	    this.modoVista = data.modoVista;
	    this.existeCambios = false;
	    this.$http = $http;
	    this.$log = $log;
	  }
	
	  _createClass(ComputoMetricosModalController, [{
	    key: '$onInit',
	    value: function $onInit() {}
	  }, {
	    key: 'cerrar',
	    value: function cerrar() {
	      if (this.modificados.length > 0) {
	        this.$uibModalInstance.close(this.modificados);
	      } else {
	        this.$uibModalInstance.dismiss('cancel');
	      }
	    }
	  }, {
	    key: 'guardar',
	    value: function guardar() {
	      var _this = this;
	
	      if (this.existeCambiosItem) {
	        this.$scope.$broadcast('guardarComputosMetricos', function () {
	          _this.$uibModalInstance.close(_this.modificados);
	        });
	      } else if (this.modificados.length > 0) {
	        this.$uibModalInstance.close(this.modificados);
	      } else {
	        this.$uibModalInstance.close(null);
	      }
	    }
	  }, {
	    key: 'tieneComputosMetricos',
	    value: function tieneComputosMetricos() {
	      return !this._.isEmpty(JSON.parse(angular.toJson(this.computos))[0]);
	    }
	  }]);
	
	  return ComputoMetricosModalController;
	}();
	
	exports.default = ComputoMetricosModalController;

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _datosForm = __webpack_require__(417);
	
	var _datosForm2 = _interopRequireDefault(_datosForm);
	
	var _datosForm3 = __webpack_require__(631);
	
	var _datosForm4 = _interopRequireDefault(_datosForm3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DatosFormComponent = {
	  bindings: {
	    supervision: '<'
	  },
	  controller: _datosForm2.default,
	  template: _datosForm4.default
	};
	
	exports.default = DatosFormComponent;

/***/ }),
/* 417 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DatosFormController = function () {
	  DatosFormController.$inject = ["DataService", "Message", "Storage"];
	  function DatosFormController(DataService, Message, Storage) {
	    'ngInject';
	
	    _classCallCheck(this, DatosFormController);
	
	    this.DataService = DataService;
	    this.Message = Message;
	    this.Storage = Storage;
	    this.user = Storage.getUser();
	  }
	
	  _createClass(DatosFormController, [{
	    key: '$onInit',
	    value: function $onInit() {}
	  }, {
	    key: '$onChanges',
	    value: function $onChanges(changes) {
	      if (changes.supervision && changes.supervision.currentValue) {
	        this.fiscal = this.supervision.proyecto.equipo_tecnico.find(function (u) {
	          return u.cargo === 'CG_FISCAL' && u.estado === 'ACTIVO';
	        });
	        this.fiscal.usuario.persona.telefono_ant = this.fiscal.usuario.persona.telefono;
	        this.supervisor = this.supervision.proyecto.equipo_tecnico.find(function (u) {
	          return u.cargo === 'CG_SUPERVISOR' && u.estado === 'ACTIVO';
	        });
	        this.supervisor.usuario.persona.telefono_ant = this.supervisor.usuario.persona.telefono;
	        this.empleados = this.supervision.proyecto.documentacion_exp.empleados;
	        for (var i in this.empleados) {
	          this.empleados[i].persona.telefono_ant = this.empleados[i].persona.telefono;
	        }
	        if (this.supervision.proyecto.documentacion_exp.datos_empresa.representante_legal) {
	          this.repLegal = this.supervision.proyecto.documentacion_exp.datos_empresa.representante_legal;
	          this.repLegal.cargo_actual_ant = this.repLegal.cargo_actual;
	          this.repLegal.persona.telefono_ant = this.repLegal.persona.telefono;
	        }
	        /**************************************************************************************************************
	         * Se adiciono el codigo 24/07/2024 para que se visualize el nombre del representante legal de una asocicion
	         ***************************************************************************************************************/
	        if (this.supervision.proyecto.documentacion_exp.datos_asociacion && this.supervision.proyecto.documentacion_exp.datos_asociacion.nombre_asociacion && this.supervision.proyecto.documentacion_exp.datos_asociacion.asociado.representante_legal) {
	          this.repLegal.nombreCompleto = this.supervision.proyecto.documentacion_exp.datos_asociacion.asociado.representante_legal.nombreCompleto;
	        }
	        /*************************************************************************************************************/
	        this.modoVista = this.supervision.estado_actual.atributos['computos'] || this.supervision.estado_actual.atributos['informe'] ? false : true;
	        this.descuento = this.supervision.estado_actual.atributos['informe'] ? true : false;
	      }
	    }
	
	    // Representante legal
	
	  }, {
	    key: 'updateCargoRep',
	    value: function updateCargoRep() {
	      var _this = this;
	
	      if (this.repLegal.cargo_actual_ant !== this.repLegal.cargo_actual || this.repLegal.persona.telefono_ant !== this.repLegal.persona.telefono) {
	        this.DataService.put('proyectos/' + this.supervision.fid_proyecto + '/empresa-representante', this.repLegal).then(function (resp) {
	          if (resp && resp.finalizado) {
	            _this.repLegal.cargo_actual_ant = _this.repLegal.cargo_actual;
	            _this.repLegal.persona.telefono_ant = _this.repLegal.persona.telefono;
	            _this.Message.success(resp.mensaje);
	          } else {
	            _this.Message.warning(resp.mensaje);
	          }
	        });
	      }
	    }
	
	    // Empleados
	
	  }, {
	    key: 'updatePhone',
	    value: function updatePhone(empleado) {
	      var _this2 = this;
	
	      if (empleado.persona.telefono_ant !== empleado.persona.telefono) {
	        if (empleado.id_empleado) {
	          empleado.persona.id_empleado = empleado.id_empleado;
	          empleado.persona.cargo_actual = empleado.cargo_actual;
	          this.DataService.put('proyectos/' + this.supervision.fid_proyecto + '/empresa-empleados/' + empleado.id_empleado + '/telefono', empleado.persona).then(function (resp) {
	            if (resp && resp.finalizado) {
	              empleado.persona.telefono_ant = empleado.persona.telefono;
	              _this2.Message.success(resp.mensaje);
	            } else {
	              empleado.persona.telefono = empleado.persona.telefono_ant;
	              _this2.Message.warning(resp.mensaje);
	            }
	          });
	        } else {
	          this.DataService.put('personas/' + empleado.persona.id_persona + '/telefono', empleado.persona).then(function (resp) {
	            if (resp && resp.finalizado) {
	              empleado.persona.telefono_ant = empleado.persona.telefono;
	              _this2.Message.success(resp.mensaje);
	            } else {
	              empleado.persona.telefono = empleado.persona.telefono_ant;
	              _this2.Message.warning(resp.mensaje);
	            }
	          });
	        }
	      }
	    }
	  }, {
	    key: 'updateText',
	    value: function updateText(form) {
	      var _this3 = this;
	
	      var datos = {
	        form: form.$name
	      };
	      if (form.$name === 'form2') {
	        datos.campo = 'dias_retraso';
	        datos.texto = this.supervision.formulario.form2.dias_retraso;
	      }
	      if (form.$name === 'form4') {
	        datos.campo = 'descripcion';
	        datos.texto = this.supervision.formulario.form4.descripcion;
	      }
	      if (form.$name === 'form6') {
	        datos.campo = 'resumen';
	        datos.texto = this.supervision.formulario.form6.resumen;
	      }
	      if (datos.texto) {
	        this.DataService.put('supervisiones/' + this.supervision.id_supervision + '/formulario', datos).then(function (resp) {
	          if (resp && resp.finalizado) {
	            _this3.Message.success(resp.mensaje);
	          }
	        });
	      }
	    }
	  }, {
	    key: 'updateForm',
	    value: function updateForm(field) {
	      var _this4 = this;
	
	      var datos = {
	        form: field.$$parentForm.$name,
	        campo: field.$name,
	        valor: field.$modelValue
	      };
	      this.DataService.put('supervisiones/' + this.supervision.id_supervision + '/formulario', datos).then(function (resp) {
	        if (resp && resp.finalizado) {
	          _this4.Message.success(resp.mensaje);
	        }
	      });
	    }
	  }]);
	
	  return DatosFormController;
	}();
	
	exports.default = DatosFormController;

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _empresaAnterior = __webpack_require__(419);
	
	var _empresaAnterior2 = _interopRequireDefault(_empresaAnterior);
	
	var _empresaAnterior3 = __webpack_require__(632);
	
	var _empresaAnterior4 = _interopRequireDefault(_empresaAnterior3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EmpresaAnteriorComponent = {
	  bindings: {
	    supervision: '<'
	  },
	  controller: _empresaAnterior2.default,
	  template: _empresaAnterior4.default
	};
	
	exports.default = EmpresaAnteriorComponent;

/***/ }),
/* 419 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EmpresaAnteriorController = function () {
	  EmpresaAnteriorController.$inject = ["$state", "DataService", "Storage"];
	  function EmpresaAnteriorController($state, DataService, Storage) {
	    'ngInject';
	
	    _classCallCheck(this, EmpresaAnteriorController);
	
	    this.$state = $state;
	    this.DataService = DataService;
	    this.Storage = Storage;
	    this.user = Storage.getUser();
	    this.historialEmpresas = false;
	  }
	
	  _createClass(EmpresaAnteriorController, [{
	    key: '$onInit',
	    value: function $onInit() {}
	  }, {
	    key: '$onChanges',
	    value: function $onChanges() {
	      var _this = this;
	
	      if (this.supervision.fid_proyecto && !this.historico) {
	        var idProyecto = this.supervision.fid_proyecto;
	        this.DataService.get('proyectos/' + idProyecto + '/empresas/avance').then(function (resp) {
	          if (resp && resp.finalizado) {
	            _this.historico = resp.datos;
	            if (resp.datos && resp.datos.proyectos && resp.datos.proyectos.length > 0) {
	              _this.historialEmpresas = true;
	            }
	          }
	        });
	      }
	    }
	  }, {
	    key: 'verSupervision',
	    value: function verSupervision(avance) {
	      this.$state.go('planilla-proyecto', { idSupervision: avance.supervisiones[0].id_supervision });
	    }
	  }]);
	
	  return EmpresaAnteriorController;
	}();
	
	exports.default = EmpresaAnteriorController;

/***/ }),
/* 420 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FotoSupervisionController = function () {
	  FotoSupervisionController.$inject = ["$uibModalInstance", "DataService", "$stateParams", "data", "_"];
	  function FotoSupervisionController($uibModalInstance, DataService, $stateParams, data, _) {
	    'ngInject';
	
	    _classCallCheck(this, FotoSupervisionController);
	
	    this.DataService = DataService;
	    this.$stateParams = $stateParams;
	    this.data = data;
	    this.$uibModalInstance = $uibModalInstance;
	    this._ = _;
	    this.foto = data.foto;
	    this.fotos = data.fotos;
	  }
	
	  _createClass(FotoSupervisionController, [{
	    key: '$onInit',
	    value: function $onInit() {}
	  }, {
	    key: 'irAPosicion',
	    value: function irAPosicion(tipo) {
	      var POSICION = tipo === 'anterior' ? this.foto.nro - 1 : tipo === 'siguiente' ? this.foto.nro + 1 : this.foto.nro;
	      this.foto = this._.find(this.fotos, { nro: POSICION });
	    }
	  }, {
	    key: 'cerrar',
	    value: function cerrar() {
	      this.$uibModalInstance.close(false);
	    }
	  }]);
	
	  return FotoSupervisionController;
	}();
	
	exports.default = FotoSupervisionController;

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _fotosSupervision = __webpack_require__(422);
	
	var _fotosSupervision2 = _interopRequireDefault(_fotosSupervision);
	
	var _fotosSupervision3 = __webpack_require__(634);
	
	var _fotosSupervision4 = _interopRequireDefault(_fotosSupervision3);
	
	__webpack_require__(192);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FotosSupervisionComponent = {
	  bindings: {
	    supervision: '=',
	    fotos: '<'
	  },
	  controller: _fotosSupervision2.default,
	  template: _fotosSupervision4.default
	};
	
	exports.default = FotosSupervisionComponent;

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _fotoSupervisionModal = __webpack_require__(420);
	
	var _fotoSupervisionModal2 = _interopRequireDefault(_fotoSupervisionModal);
	
	var _fotoSupervisionModal3 = __webpack_require__(633);
	
	var _fotoSupervisionModal4 = _interopRequireDefault(_fotoSupervisionModal3);
	
	var _modal = __webpack_require__(428);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _modal3 = __webpack_require__(638);
	
	var _modal4 = _interopRequireDefault(_modal3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FotosSupervisionController = function () {
	  FotosSupervisionController.$inject = ["DataService", "Storage", "SidenavFactory", "$state", "Modal", "Message", "$window"];
	  function FotosSupervisionController(DataService, Storage, SidenavFactory, $state, Modal, Message, $window) {
	    'ngInject';
	
	    _classCallCheck(this, FotosSupervisionController);
	
	    this.DataService = DataService;
	    this.Storage = Storage;
	    this.SidenavFactory = SidenavFactory;
	    this.$state = $state;
	    this.$window = $window;
	    this.Modal = Modal;
	    this.Message = Message;
	
	    this.user = Storage.getUser();
	  }
	
	  _createClass(FotosSupervisionController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      for (var i = 0; i < this.fotos.length; i++) {
	        this.fotos[i].nro = i + 1;
	        this.getFoto(this.fotos[i]);
	      }
	      this.puedeEliminar = this.user.rol.nombre === 'SUPERVISOR' && this.supervision && this.supervision.estado_actual && this.supervision.estado_actual.codigo === 'EN_SUPERVISOR';
	    }
	  }, {
	    key: 'getFoto',
	    value: function getFoto(foto) {
	      this.DataService.get('fotos/' + foto.id_foto_supervision).then(function (response) {
	        foto.base64 = response.datos;
	        foto.coordenadas = response.coordenadas;
	        foto.mostrar = true;
	      });
	    }
	  }, {
	    key: 'mostrarPopup2',
	    value: function mostrarPopup2(foto) {
	      if (foto.base64) {
	        this.Modal.showImageBase64(foto, 'Foto Supervision ' + foto.nro);
	      }
	    }
	  }, {
	    key: 'mostrarPopup',
	    value: function mostrarPopup(foto) {
	      this.Modal.show({
	        template: _fotoSupervisionModal4.default,
	        controller: _fotoSupervisionModal2.default,
	        data: {
	          foto: foto,
	          fotos: this.fotos
	        },
	        size: 'lg'
	      });
	    }
	  }, {
	    key: 'mostrarUbicacion',
	    value: function mostrarUbicacion(foto) {
	      //this.$window.open(`https://www.openstreetmap.org/?mlat=${foto.coordenadas.coordinates[1]}&mlon=${foto.coordenadas.coordinates[0]}#map=18/${foto.coordenadas.coordinates[1]}/${foto.coordenadas.coordinates[0]}`,'_blank');
	      this.Modal.show({
	        template: _modal4.default,
	        controller: _modal2.default,
	        data: {
	          foto: foto,
	          fotos: this.fotos
	        },
	        size: 'lg'
	      });
	    }
	  }, {
	    key: 'eliminarFoto',
	    value: function eliminarFoto(foto) {
	      var _this = this;
	
	      var datos = angular.copy(foto);
	      datos.path_fotografia = foto.path_fotografia.substring(foto.path_fotografia.indexOf('_') + 1);
	      datos.fid_supervision = foto.fid_supervision || this.supervision.id_supervision;
	      this.Modal.confirm('\xBFEst\xE1 seguro/a de eliminar la Foto supervisi\xF3n ' + foto.nro + '?', function () {
	        _this.DataService.delete('fotos/' + foto.id_foto_supervision + '?supervision=' + datos.fid_supervision, datos).then(function (result) {
	          if (result && result.finalizado) {
	            _this.Message.success(result.mensaje);
	            _this.$state.reload();
	          }
	        });
	      });
	    }
	  }]);
	
	  return FotosSupervisionController;
	}();
	
	exports.default = FotosSupervisionController;

/***/ }),
/* 423 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ItemsNoCerradosModalController = function () {
	  ItemsNoCerradosModalController.$inject = ["$uibModalInstance", "$scope", "DataService", "Message", "data", "_"];
	  function ItemsNoCerradosModalController($uibModalInstance, $scope, DataService, Message, data, _) {
	    'ngInject';
	
	    _classCallCheck(this, ItemsNoCerradosModalController);
	
	    this.$uibModalInstance = $uibModalInstance;
	    this.$scope = $scope;
	    this.DataService = DataService;
	    this.Message = Message;
	    this.data = data;
	    this._ = _;
	    this.items = data.items;
	  }
	
	  _createClass(ItemsNoCerradosModalController, [{
	    key: '$onInit',
	    value: function $onInit() {}
	  }, {
	    key: 'cerrar',
	    value: function cerrar() {
	      this.$uibModalInstance.close(false);
	    }
	  }, {
	    key: 'aprobar',
	    value: function aprobar() {
	      this.$uibModalInstance.close(true);
	    }
	  }]);
	
	  return ItemsNoCerradosModalController;
	}();
	
	exports.default = ItemsNoCerradosModalController;

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	'usr strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _planillaProyecto = __webpack_require__(425);
	
	var _planillaProyecto2 = _interopRequireDefault(_planillaProyecto);
	
	var _planillaProyecto3 = __webpack_require__(636);
	
	var _planillaProyecto4 = _interopRequireDefault(_planillaProyecto3);
	
	__webpack_require__(193);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlanillaProyectoComponent = {
	  bindings: {},
	  controller: _planillaProyecto2.default,
	  template: _planillaProyecto4.default
	};
	
	exports.default = PlanillaProyectoComponent;

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _computoMetricoModal = __webpack_require__(630);
	
	var _computoMetricoModal2 = _interopRequireDefault(_computoMetricoModal);
	
	var _computoMetricoModal3 = __webpack_require__(415);
	
	var _computoMetricoModal4 = _interopRequireDefault(_computoMetricoModal3);
	
	var _verificacionAnticipoModal = __webpack_require__(637);
	
	var _verificacionAnticipoModal2 = _interopRequireDefault(_verificacionAnticipoModal);
	
	var _verificacionAnticipoModal3 = __webpack_require__(427);
	
	var _verificacionAnticipoModal4 = _interopRequireDefault(_verificacionAnticipoModal3);
	
	var _itemsNoCerradosModal = __webpack_require__(635);
	
	var _itemsNoCerradosModal2 = _interopRequireDefault(_itemsNoCerradosModal);
	
	var _itemsNoCerradosModal3 = __webpack_require__(423);
	
	var _itemsNoCerradosModal4 = _interopRequireDefault(_itemsNoCerradosModal3);
	
	var _archivoModal = __webpack_require__(46);
	
	var _archivoModal2 = _interopRequireDefault(_archivoModal);
	
	var _archivoModal3 = __webpack_require__(47);
	
	var _archivoModal4 = _interopRequireDefault(_archivoModal3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PlanillaProyectoController = function () {
	  PlanillaProyectoController.$inject = ["$scope", "DataService", "Modal", "$state", "$stateParams", "Supervision", "_", "Storage", "Util", "$q", "Flujos", "apiUrl", "Message", "$log"];
	  function PlanillaProyectoController($scope, DataService, Modal, $state, $stateParams, Supervision, _, Storage, Util, $q, Flujos, apiUrl, Message, $log) {
	    'ngInject';
	
	    _classCallCheck(this, PlanillaProyectoController);
	
	    this.$scope = $scope;
	    this.DataService = DataService;
	    this.Modal = Modal;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.Supervision = Supervision;
	    this._ = _;
	    this.Storage = Storage;
	    this.Util = Util;
	    this.$q = $q;
	    this.Flujos = Flujos;
	    this.apiUrl = apiUrl;
	    this.Message = Message;
	    this.items_modulo = [];
	    this.items_x = [];
	    this.filtroItems = 'TODOS';
	    this.$log = $log;
	  }
	
	  _createClass(PlanillaProyectoController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.usuario = this.Storage.getUser();
	      this.idSupervision = this.$stateParams.idSupervision;
	      this.getTipoUnidades();
	      this.getSupervision();
	      // TODO enviar rol si el usuario tiene mas de un rol
	      this.url = 'supervisiones/' + this.idSupervision + '?rol=' + this.Storage.get('rol').id_rol;
	
	      this.$scope.$on('transicion_accion_ejecutada', function () {
	        _this.$state.go('mis-proyectos');
	      });
	
	      this.datosPrevios = {};
	    }
	  }, {
	    key: '$onChanges',
	    value: function $onChanges() {
	      var _this2 = this;
	
	      this.$scope.$watch('$ctrl.filtroItems', function () {
	        if (!_this2.supervision) {
	          return;
	        }
	        _this2.mostrarItems();
	      });
	    }
	  }, {
	    key: 'mostrarItems',
	    value: function mostrarItems() {
	      switch (this.filtroItems) {
	        case 'COMPLETADOS':
	          this.filtrarItems(function (item) {
	            return item.completado;
	          });
	          break;
	        case 'INCOMPLETOS':
	          this.filtrarItems(function (item) {
	            return !item.completado;
	          });
	          break;
	        case 'PARA_ENVIAR':
	          this.filtrarItems(function (item) {
	            return item.cantidad_actual_fis !== 0;
	          });
	          break;
	        default:
	          this.filtrarItems();
	      }
	    }
	  }, {
	    key: 'getSupervision',
	    value: function getSupervision() {
	      var _this3 = this;
	
	      this.DataService.get('supervisiones/' + this.idSupervision).then(function (response) {
	        if (response) {
	          _this3.supervision = _this3.verificarModificaciones(response.datos);
	          _this3.$log.log('DATOS DE LA SUPERVISION====>' + JSON.stringify(_this3.supervision));
	          if (_this3.supervision.proyecto.proyecto_historico) {
	            _this3.supervision.proyecto.plazo_ampliacion_total = 0;
	            for (var i in _this3.supervision.proyecto.proyecto_historico) {
	              var version = _this3.supervision.proyecto.proyecto_historico[i];
	              if (version.plazo_ampliacion) {
	                _this3.supervision.proyecto.plazo_ampliacion_total += version.plazo_ampliacion.por_volumenes + version.plazo_ampliacion.por_compensacion;
	              }
	            }
	          }
	          _this3.asignarDatosProyecto();
	          _this3.mostrarItems();
	          _this3.Flujos.getAtributosPermitidos(_this3.supervision);
	          _this3.Supervision.setUsuario(_this3.usuario);
	          _this3.Supervision.setSupervision(_this3.supervision);
	
	          _this3.esEditable = _this3.Supervision.esEditable('computos');
	          _this3.esEtapaEdicion = _this3.supervision.estado_supervision === 'REGISTRO_PLANILLA';
	          if (!_this3.esEtapaEdicion) {
	            _this3.filtroItems = 'PARA_ENVIAR';
	          }
	          _this3.prepararBoletas();
	          _this3.supervision.supervisiones_anteriores.map(function (supervision) {
	            supervision.numero = _this3.Util.getNumeroOrdinal(supervision.nro_supervision);
	          });
	          var DESEMBOLSOS = _this3._.map(_this3.supervision.supervisiones_anteriores, 'desembolso');
	          _this3.supervision.monto_desembolso_total = _this3.Util.sumar(DESEMBOLSOS);
	          // Restar ultimo desembolso si es vista planilla actual
	          if (_this3.supervision.supervisiones_anteriores && _this3.supervision.supervisiones_anteriores.length && _this3.supervision.supervisiones_anteriores.length == _this3.supervision.nro_supervision) {
	            _this3.supervision.monto_desembolso_total = _this3.Util.restar(_this3.supervision.monto_desembolso_total, _this3.supervision.supervisiones_anteriores[_this3.supervision.supervisiones_anteriores.length - 1].desembolso);
	          }
	          // sumar anticipo
	          if (_this3.proyecto && _this3.proyecto.anticipo) {
	            _this3.supervision.monto_desembolso_total = _this3.Util.sumar([_this3.supervision.monto_desembolso_total, _this3.proyecto.anticipo]);
	          }
	          // sumar porcentaje anticipo al avance financiero
	          if (_this3.proyecto.porcentaje_anticipo) {
	            _this3.supervision.porcentaje_avance_fin = _this3.Util.sumar([_this3.supervision.porcentaje_avance_fin, _this3.Util.dividir(_this3.Util.multiplicar([_this3.proyecto.anticipo, 100]), _this3.proyecto.monto_total)]);
	          }
	          // Diferencia del monto contrato original o monto con modificacion
	          if (_this3.supervision.proyecto.monto_contractual != _this3.supervision.monto_total_contractual && _this3.supervision.monto_total_contractual) {
	            _this3.supervision.monto_total_por_ejecutar = _this3.Util.restar(_this3.supervision.monto_total_contractual, _this3.supervision.monto_total_acumulado);
	          } else {
	            _this3.supervision.monto_total_por_ejecutar = _this3.Util.restar(_this3.supervision.proyecto.monto_contractual, _this3.supervision.monto_total_acumulado);
	          }
	
	          _this3.verificarDeudas();
	          _this3.verificarItemsNoCerrados();
	          _this3.esTecnico = ['TECNICO_UPRE', 'RESP_DEPARTAMENTAL_UPRE', 'ENCAR_REGIONAL_UPRE'].indexOf(_this3.usuario.rol.nombre) >= 0 && _this3.supervision.estado_actual.codigo == 'REGISTRO_PLANILLA';
	
	          _this3.validacion = {
	            fecha_fin_min: new Date(_this3.supervision.fecha_inicio),
	            fecha_creacion_min: new Date(_this3.supervision.fecha_inicio),
	            fecha_max: new Date(_this3.supervision.proyecto.fecha_recepcion_definitiva)
	          };
	
	          if (_this3.supervision.porcentaje_avance_fis == 100) {
	            _this3.errorRedondeo = _this3.Util.restar(_this3.supervision.proyecto.monto_total, _this3.Util.sumar([_this3.supervision.monto_desembolso_total, _this3.supervision.monto_total_actual_ejecutado]));
	            if (_this3.proyecto && _this3.proyecto.anticipo && _this3.desembolso) {
	              _this3.errorRedondeo = _this3.Util.sumar([_this3.errorRedondeo, _this3.desembolso.descuento]);
	            }
	            if (_this3.errorRedondeo < -1 || 1 < _this3.errorRedondeo) {
	              _this3.errorRedondeo = 0;
	            }
	          }
	          _this3.datosPrevios.plazo_ejecucion_definitivo = _this3.proyecto.plazo_ejecucion_definitivo;
	        }
	      });
	    }
	  }, {
	    key: 'verificarModificaciones',
	    value: function verificarModificaciones(datos) {
	      // TODO optimizar
	      var cabecera = datos.modulos[0].items[0].item_historico;
	      for (var i in datos.modulos) {
	        var items = datos.modulos[i].items;
	        for (var j in items) {
	          var ij = items[j].item_historico.length;
	          for (var k = cabecera.length; k > ij; k--) {
	            items[j].item_historico.unshift({
	              version: cabecera[k - 1].version - ij
	            });
	          }
	        }
	      }
	
	      if (datos.proyecto.proyecto_historico[0] && !datos.proyecto.proyecto_historico[0].tipo_modificacion_proyecto) {
	        datos.proyecto.proyecto_historico[0].tipo_modificacion_proyecto = {
	          nombre: 'Contrato Original'
	        };
	      }
	      return datos;
	    }
	  }, {
	    key: 'asignarDatosProyecto',
	    value: function asignarDatosProyecto() {
	      this.proyecto = this.supervision.proyecto;
	      if (this.proyecto.doc_especificaciones_tecnicas) {
	        this.urlDescEspTecnicas = this.apiUrl + 'proyectos/' + this.supervision.fid_proyecto + '/doc/ET/descargar';
	      }
	      if (this.supervision.version_proyecto) {
	        this.urlDescPlanilla = this.apiUrl + 'proyectos/' + this.supervision.fid_proyecto + '/doc/PA_' + this.supervision.nro_supervision + '/descargar';
	        this.urlDescComputosResumen = this.apiUrl + 'proyectos/' + this.supervision.fid_proyecto + '/doc/CMR_' + this.supervision.nro_supervision + '/descargar';
	        this.urlDescComputosItem = this.apiUrl + 'proyectos/' + this.supervision.fid_proyecto + '/doc/CM_';
	      }
	    }
	  }, {
	    key: 'irComputo',
	    value: function irComputo(item) {
	      this.$state.go('computo-proyecto', { idSupervision: this.idSupervision, idItem: item.id_item });
	    }
	  }, {
	    key: 'mostrarComputo',
	    value: function mostrarComputo(item) {
	      var _this4 = this;
	
	      this.Modal.show({
	        template: _computoMetricoModal2.default,
	        controller: _computoMetricoModal4.default,
	        size: 'xlg',
	        data: {
	          supervision: this.supervision,
	          item: item,
	          modoVista: this.supervision.estado_actual.atributos['computos'] ? false : true
	        }
	      }).result.then(function (modificados) {
	        if (!modificados) {
	          return;
	        }
	        if (_this4.Supervision.esEditable('computos') && modificados.length > 0) {
	          _this4.getSupervision();
	        }
	      }).catch(function () {});
	    }
	  }, {
	    key: 'getTipoUnidades',
	    value: function getTipoUnidades() {
	      var _this5 = this;
	
	      this.DataService.get('parametricas/UNIDAD').then(function (response) {
	        if (response) {
	          _this5.unidades = response.datos.rows;
	          _this5.unidades_obj = {};
	          _this5.unidades.forEach(function (uni) {
	            _this5.unidades_obj[uni.codigo] = uni;
	          });
	        }
	      });
	    }
	  }, {
	    key: 'getMgColor',
	    value: function getMgColor(item) {
	      if (item.total_acumulado_fis === item.cantidad) {
	        return 'bl-success';
	      }
	      if (item.total_acumulado_fis === 0) {
	        return 'bl-primary';
	      }
	      if (item.cantidad_actual_fis > 0) {
	        return 'bl-info';
	      }
	      return 'bl-warning';
	    }
	  }, {
	    key: 'getTitle',
	    value: function getTitle(item) {
	      if (item.total_acumulado_fis === item.cantidad) {
	        return 'Completado';
	      }
	      if (item.total_acumulado_fis === 0) {
	        return 'Sin avance';
	      }
	      if (item.cantidad_actual_fis > 0) {
	        return 'Con avance';
	      }
	      return 'Con avance en anterior(es) planilla(s)';
	    }
	
	    // TODO obtener valores desde el backend
	
	  }, {
	    key: 'calcularFechaAmpliada',
	    value: function calcularFechaAmpliada(fecha) {
	      if (fecha && this.proyecto && this.proyecto.plazo_ampliacion) {
	        fecha = new Date(fecha);
	        fecha.setDate(fecha.getDate() + this.proyecto.plazo_ampliacion.por_volumenes + this.proyecto.plazo_ampliacion.por_compensacion);
	      }
	      return fecha;
	    }
	  }, {
	    key: 'filtrarItems',
	    value: function filtrarItems() {
	      var _this6 = this;
	
	      var condicion = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {
	        return true;
	      };
	
	      this.supervision.modulos.forEach(function (modulo) {
	        modulo.items.forEach(function (item) {
	          item.show = condicion(item);
	        });
	        modulo.show = _this6._.some(modulo.items, { show: true });
	      });
	      this.Supervision.setSupervision(this.supervision);
	    }
	  }, {
	    key: 'volverSupervisiones',
	    value: function volverSupervisiones() {
	      this.$state.go('avance-proyecto', { idProyecto: this.supervision.fid_proyecto, matricula: this.Storage.get('user').matricula });
	    }
	  }, {
	    key: 'verificarDeudas',
	    value: function verificarDeudas() {
	      if (this.proyecto.anticipo === 0) {
	        return;
	      }
	      var DESCUENTOS = this._.map(this.supervision.supervisiones_anteriores, 'descuento_anticipo');
	      var TOTAL_DESCUENTOS = this.Util.sumar(DESCUENTOS);
	      this.deudaAnticipo = this.Util.restar(this.proyecto.anticipo, TOTAL_DESCUENTOS);
	      if (this.deudaAnticipo === 0) {
	        return;
	      }
	      this.tieneDeudas = true;
	      this.desembolso = this.Supervision.calcularDescuento(this.supervision.tipo_descuento_anticipo, this.supervision.monto_total_actual_ejecutado, this.deudaAnticipo, this.proyecto.porcentaje_anticipo);
	    }
	  }, {
	    key: 'verificarItemsNoCerrados',
	    value: function verificarItemsNoCerrados() {
	      var ITEMS = this.Supervision.getItems();
	      this.itemsNoCerrados = this._.filter(ITEMS, function (item) {
	        return (item.falta_ejecutar_fis === 0 && item.falta_ejecutar_fin !== 0 || item.ejecutar_porcentaje_fis === 0 && item.falta_ejecutar_fis > 0) && item.estado !== 'CERRADO';
	      });
	    }
	  }, {
	    key: 'verificarPlanilla',
	    value: function verificarPlanilla() {
	      var defer = this.$q.defer();
	      if (this.Supervision.esEditable('tipo_descuento_anticipo')) {
	        return this.verificarAnticipo(defer);
	      }
	      if (this.estaEnTecnico(defer)) {
	        return this.verificarDatosParaTecnico(defer);
	      }
	      defer.resolve({ confirmar: true });
	      return defer.promise;
	    }
	  }, {
	    key: 'verificarAnticipo',
	    value: function verificarAnticipo(defer) {
	      this.$log.log('Veririca Avance en 0 ====');
	      // if (!this.tieneAvances()) {
	      //   this.Message.warning(`No tiene avances para enviar.`);
	      //   return defer.promise;
	      // }
	
	      if (this.tieneAnticipo() && this.deudaAnticipo > 0) {
	        var modalConfirmacion = this.Modal.show({
	          template: _verificacionAnticipoModal2.default,
	          controller: _verificacionAnticipoModal4.default,
	          data: {
	            supervision: this.supervision,
	            deudaAnticipo: this.deudaAnticipo,
	            errorRedondeo: this.errorRedondeo,
	            esPlanillaCierre: this.supervision.porcentaje_avance_fis == 100
	          },
	          size: 'lg'
	        });
	        modalConfirmacion.result.then(function () {
	          defer.resolve();
	        }, function () {});
	      } else {
	        defer.resolve();
	      }
	      return defer.promise;
	    }
	  }, {
	    key: 'verificarDatosParaTecnico',
	    value: function verificarDatosParaTecnico(defer) {
	      if (this.itemsNoCerrados.length > 0) {
	        var modalConfirmacion = this.Modal.show({
	          template: _itemsNoCerradosModal2.default,
	          controller: _itemsNoCerradosModal4.default,
	          data: {
	            items: this.itemsNoCerrados,
	            supervision: this.supervision
	          },
	          size: 'lg'
	        });
	        modalConfirmacion.result.then(function (aprobar) {
	          if (aprobar) {
	            defer.resolve();
	          }
	        }, function () {});
	      } else if (this.supervision.porcentaje_avance_fis === 100) {
	        this.Modal.confirm('Se le recuerda que \xE9sta es la <strong>Planilla de Cierre</strong>.\n        <p>\xBFEst\xE1 seguro/a de aprobar la presente planilla, tomando en cuenta que con ella finalizar\xE1 el registro de los avances del proyecto?</p>\n        <p>En caso de estar seguro/a seleccione la opci\xF3n <b>APROBAR</b>.</p>', function () {
	          defer.resolve();
	        }, null, 'Confirmaci\xF3n previa al cierre del proyecto', 'APROBAR');
	      } else {
	        defer.resolve({ confirmar: true });
	      }
	      return defer.promise;
	    }
	  }, {
	    key: 'tieneAnticipo',
	    value: function tieneAnticipo() {
	      return this.supervision.proyecto.porcentaje_anticipo > 0;
	    }
	  }, {
	    key: 'tieneAvances',
	    value: function tieneAvances() {
	      return this.supervision.monto_total_actual_ejecutado > 0;
	    }
	  }, {
	    key: 'estaEnTecnico',
	    value: function estaEnTecnico() {
	      return this.supervision.estado_supervision === 'EN_TECNICO';
	    }
	  }, {
	    key: 'irAtras',
	    value: function irAtras() {
	      window.history.back();
	    }
	  }, {
	    key: 'prepararBoletas',
	    value: function prepararBoletas() {
	      this.boletasAnticipo = this.getBoletaPorTipo('TB_CORRECTA_INVERSION');
	      this.boletasCcontrato = this.getBoletaPorTipo('TB_CUMPLIMIENTO_CONTRATO');
	    }
	  }, {
	    key: 'getBoletaPorTipo',
	    value: function getBoletaPorTipo(tipo) {
	      var fecha = this.supervision.fecha_fin ? new Date(this.supervision.fecha_fin) : new Date();
	      return this._.filter(this.supervision.proyecto.boletas, function (boleta) {
	        var f2 = new Date(boleta.fecha_fin_validez);
	        if (f2 < fecha) {
	          boleta.class = boleta.estado == 'ACTIVO' ? 'bg-warning' : 'text-warning';
	        }
	        return boleta.tipo_boleta === tipo; // && boleta.estado==='ACTIVO';
	      });
	    }
	  }, {
	    key: 'getTipoClass',
	    value: function getTipoClass(tipo_modificacion) {
	      if (tipo_modificacion == 'TM_CONTRATO_MODIFICATORIO') return 'cmodificatorio';
	      if (tipo_modificacion == 'TM_ORDEN_CAMBIO') return 'orden-cambio';
	      if (tipo_modificacion == 'TM_ORDEN_TRABAJO') return 'orden-trabajo';
	      return '';
	    }
	  }, {
	    key: 'verPdfInforme',
	    value: function verPdfInforme(codigo) {
	      if (codigo && (codigo == 'ITCS' || codigo == 'ITCF')) {
	        var datos = {
	          codigo: codigo + '_' + this.supervision.nro_supervision,
	          titulo: 'Documento Informe T\xE9cnico'
	        };
	        this.Modal.showDocumentBase64('proyectos/' + this.supervision.fid_proyecto + '/doc/' + codigo + '_' + this.supervision.nro_supervision, datos.titulo);
	      }
	    }
	  }, {
	    key: 'cargarPdfInforme',
	    value: function cargarPdfInforme(codigo) {
	      var _this7 = this;
	
	      if (codigo && (codigo == 'ITCS' || codigo == 'ITCF')) {
	        var titulo = 'Documento Informe T\xE9cnico';
	        var confArchivo = {
	          formatos: 'pdf',
	          tipos: '.pdf'
	        };
	        this.mostrarModal(titulo, 'fa-upload', confArchivo, _archivoModal4.default, _archivoModal2.default, 'Cargar documento').result.then(function (docEspecificaciones) {
	          if (angular.isUndefined(docEspecificaciones)) {
	            return;
	          }
	          var datos = {};
	          datos.documento = docEspecificaciones;
	          _this7.DataService.put('proyectos/' + _this7.supervision.fid_proyecto + '/doc/' + codigo + '_' + _this7.supervision.nro_supervision + '/subir', datos).then(function (result) {
	            if (result && result.finalizado) {
	              _this7.Message.success('Se registr\xF3 el documento correctamente.');
	              if (codigo === 'ITCS') _this7.supervision.informe_doc = true;
	              if (codigo === 'ITCF') _this7.supervision.informe_fiscal_doc = true;
	            }
	          });
	        });
	      }
	    }
	    // Modal
	
	  }, {
	    key: 'mostrarModal',
	    value: function mostrarModal(titulo, icon, data, template, controller, labelOk, size) {
	      return this.Modal.show({
	        template: template,
	        controller: controller,
	        data: data || {},
	        title: titulo,
	        icon: icon,
	        size: size ? size : 'md',
	        labelOk: labelOk
	      });
	    }
	  }, {
	    key: 'cRedondeo',
	    value: function cRedondeo(obj) {
	      var _this8 = this;
	
	      if (typeof obj.c_redondeo === 'undefined') {
	        obj.c_redondeo = '';
	      }
	      var data = {
	        cRedondeo: obj.c_redondeo
	      };
	      this.DataService.put('computos_metricos/items/' + obj.id_item, data).then(function (resp) {
	        if (resp && resp.finalizado) {
	          if (_this8.Supervision.esEditable('computos')) {
	            _this8.getSupervision();
	          }
	        } else {
	          obj.c_redondeo = '';
	        }
	      });
	    }
	  }, {
	    key: 'agregarQuitarCampo',
	    value: function agregarQuitarCampo() {
	      var _this9 = this;
	
	      var data = {
	        c_redondeo: !this.supervision.c_redondeo
	      };
	      this.DataService.put('supervisiones/' + this.supervision.id_supervision + '/campo_regularizacion', data).then(function (resp) {
	        if (resp && resp.finalizado) {
	          _this9.supervision.c_redondeo = true;
	        } else {
	          _this9.supervision.c_redondeo = false;
	        }
	      });
	    }
	  }, {
	    key: 'guardarPlazoDefinitivo',
	    value: function guardarPlazoDefinitivo() {
	      var _this10 = this;
	
	      if (this.proyecto.plazo_ejecucion_definitivo == this.datosPrevios.plazo_ejecucion_definitivo) {
	        return;
	      }
	      var datos = {
	        estado_proyecto: 'APROBADO',
	        plazo_ejecucion_definitivo: this.proyecto.plazo_ejecucion_definitivo
	      };
	      this.DataService.put('proyectos/' + this.supervision.fid_proyecto + '/plazo-definitivo/' + this.supervision.id_supervision, datos).then(function (resp) {
	        if (resp && resp.finalizado) {
	          var f = new Date(_this10.proyecto.fecha_recepcion_definitiva);
	          f.setDate(f.getDate() + (_this10.proyecto.plazo_ejecucion_definitivo - _this10.datosPrevios.plazo_ejecucion_definitivo));
	          _this10.proyecto.fecha_recepcion_definitiva = f;
	          _this10.datosPrevios.plazo_ejecucion_definitivo = _this10.proyecto.plazo_ejecucion_definitivo;
	          _this10.Message.success(resp.mensaje);
	        } else {
	          _this10.proyecto.plazo_ejecucion_definitivo = _this10.datosPrevios.plazo_ejecucion_definitivo;
	        }
	      });
	    }
	  }]);
	
	  return PlanillaProyectoController;
	}();
	
	exports.default = PlanillaProyectoController;

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _planillaProyecto = __webpack_require__(424);
	
	var _planillaProyecto2 = _interopRequireDefault(_planillaProyecto);
	
	var _fotosSupervision = __webpack_require__(421);
	
	var _fotosSupervision2 = _interopRequireDefault(_fotosSupervision);
	
	var _empresaAnterior = __webpack_require__(418);
	
	var _empresaAnterior2 = _interopRequireDefault(_empresaAnterior);
	
	var _datosForm = __webpack_require__(416);
	
	var _datosForm2 = _interopRequireDefault(_datosForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var planillaProyecto = angular.module('app.planillaProyecto', []).component('planillaProyecto', _planillaProyecto2.default).component('fotosSupervision', _fotosSupervision2.default).component('empresaAnterior', _empresaAnterior2.default).component('datosForm246', _datosForm2.default).config(["$stateProvider", function ($stateProvider) {
	    $stateProvider.state('planilla-proyecto', {
	        url: '/planilla-proyecto/:idSupervision',
	        component: 'planillaProyecto'
	    });
	}]).name;
	
	exports.default = planillaProyecto;

/***/ }),
/* 427 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var VerificacionAnticipoModalController = function () {
	  VerificacionAnticipoModalController.$inject = ["$uibModalInstance", "$scope", "DataService", "Message", "data", "_", "Util", "Supervision", "Big", "decimales", "$log"];
	  function VerificacionAnticipoModalController($uibModalInstance, $scope, DataService, Message, data, _, Util, Supervision, Big, decimales, $log) {
	    'ngInject';
	
	    _classCallCheck(this, VerificacionAnticipoModalController);
	
	    this.$uibModalInstance = $uibModalInstance;
	    this.$scope = $scope;
	    this.DataService = DataService;
	    this.Message = Message;
	    this._ = _;
	    this.Util = Util;
	    this.Supervision = Supervision;
	    this.Big = Big;
	    this.decimales = decimales;
	    this.supervision = data.supervision;
	    this.deudaAnticipo = data.deudaAnticipo;
	    this.totalDescuentos = data.totalDescuentos;
	    this.esPlanillaCierre = data.esPlanillaCierre;
	    this.errorRedondeo = data.errorRedondeo;
	    this.$log = $log;
	  }
	
	  _createClass(VerificacionAnticipoModalController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.tiposDescuento = [{ codigo: 'TOTAL', nombre: 'Por la totalidad del anticipo ' + (this.supervision.supervisiones_anteriores.length > 0 ? 'pendiente' : '') + ' (*)' }, { codigo: 'PROGRESIVO', nombre: 'Progresivo (**)' }];
	      this.verificarSiPuedeDescuentoTotal();
	      this.verSiPuedeDescuentoProgresivo();
	      if (this.esPlanillaCierre) {
	        this.calcularDescuento('TOTAL');
	      }
	    }
	  }, {
	    key: 'verificarSiPuedeDescuentoTotal',
	    value: function verificarSiPuedeDescuentoTotal() {
	      if (this.supervision.monto_total_actual_ejecutado < this.deudaAnticipo) {
	        this.$log.log('verificarSiPuedeDescuentoTotal');
	        this.puedeDescuentoTotal = false;
	        this.supervision.tipo_descuento_anticipo = 'PROGRESIVO';
	        this.calcularDescuento('PROGRESIVO');
	      } else {
	        this.supervision.tipo_descuento_anticipo = null;
	        this.puedeDescuentoTotal = true;
	      }
	    }
	  }, {
	    key: 'verSiPuedeDescuentoProgresivo',
	    value: function verSiPuedeDescuentoProgresivo() {
	      this.$log.log('verSiPuedeDescuentoProgresivo');
	      this.puedeDescuentoProgresivo = this.esValidoDescuentoProgresivo();
	      if (!this.puedeDescuentoProgresivo) {
	        this.supervision.tipo_descuento_anticipo = 'TOTAL';
	        this.calcularDescuento('TOTAL');
	      }
	    }
	  }, {
	    key: 'esValidoDescuentoProgresivo',
	    value: function esValidoDescuentoProgresivo() {
	      this.$log.log('esValidoDescuentoProgresivo');
	      this.calcularDescuento('PROGRESIVO');
	      if (this.desembolso.descuento > this.deudaAnticipo || this.esPlanillaCierre) {
	        return false;
	      }
	      this.desembolso = null;
	      return true;
	    }
	  }, {
	    key: 'calcularDescuento',
	    value: function calcularDescuento(tipo) {
	      this.$log.log('calcularDescuento');
	      this.$log.log('tipo', tipo);
	      this.$log.log('monto actual', this.supervision.monto_total_actual_ejecutado);
	      this.$log.log('deuda anticipo', this.deudaAnticipo);
	      this.$log.log('porcentaje anticipo', this.supervision.proyecto.porcentaje_anticipo);
	      this.desembolso = this.Supervision.calcularDescuento(tipo, this.supervision.monto_total_actual_ejecutado, this.deudaAnticipo, this.supervision.proyecto.porcentaje_anticipo);
	      if (this.supervision.monto_total_actual_ejecutado == 0) {
	        this.supervision.porcentaje_descuento = 0;
	        this.supervision.tipo_descuento_anticipo = 0;
	      } else {
	        if (['TOTAL', 'PROGRESIVO'].indexOf(tipo) >= 0) {
	          this.supervision.porcentaje_descuento = this.Big(this.desembolso.descuento).div(this.supervision.monto_total_actual_ejecutado).mul(100).toFixed(2);
	        } else {
	          this.supervision.tipo_descuento_anticipo = tipo;
	        }
	      }
	    }
	  }, {
	    key: 'getPorcentaje',
	    value: function getPorcentaje(numero, porcentaje) {
	      //return this.Util.redondear(this.Util.redondear(numero * porcentaje)/100);
	      return parseFloat(this.Big(numero).mul(porcentaje).div(100).toFixed(this.decimales || 2));
	    }
	  }, {
	    key: 'cerrar',
	    value: function cerrar() {
	      this.$uibModalInstance.dismiss('cancel');
	    }
	  }, {
	    key: 'registrar',
	    value: function registrar() {
	      this.$uibModalInstance.close(this.supervision);
	    }
	  }, {
	    key: 'tieneComputosMetricos',
	    value: function tieneComputosMetricos() {
	      return !this._.isEmpty(JSON.parse(angular.toJson(this.computos))[0]);
	    }
	  }]);
	
	  return VerificacionAnticipoModalController;
	}();
	
	exports.default = VerificacionAnticipoModalController;

/***/ }),
/* 428 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var UbicacionModalController = function () {
	  UbicacionModalController.$inject = ["$uibModalInstance", "$stateParams", "data"];
	  function UbicacionModalController($uibModalInstance, $stateParams, data) {
	    'ngInject';
	
	    _classCallCheck(this, UbicacionModalController);
	
	    this.$uibModalInstance = $uibModalInstance;
	    this.$stateParams = $stateParams;
	    this.foto = data.foto;
	    this.fotos = data.fotos;
	  }
	
	  _createClass(UbicacionModalController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.$$iniciarLeaflet();
	      if (this.foto && this.foto.coordenadas && this.foto.coordenadas.coordinates && this.foto.coordenadas.coordinates[0] && this.foto.coordenadas.coordinates[1]) {
	        this.mapa.centro = {
	          lat: this.foto.coordenadas.coordinates[1],
	          lng: this.foto.coordenadas.coordinates[0],
	          zoom: 15
	        };
	      } else {
	        this.mapa.centro = {
	          lat: -16.5286043,
	          lng: -68.1798767,
	          zoom: 15
	        };
	      }
	
	      var icon = {
	        iconUrl: 'images/marker-sm-green.png',
	        iconSize: [38, 40]
	      };
	      var icon2 = {
	        iconUrl: 'images/marker-sm-red.png',
	        iconSize: [38, 40]
	      };
	      for (var i in this.fotos) {
	        if (this.fotos[i].coordenadas && this.fotos[i].coordenadas.coordinates && this.fotos[i].coordenadas.coordinates[0] && this.fotos[i].coordenadas.coordinates[1]) {
	          this.mapa.marcadores.push({
	            lat: this.fotos[i].coordenadas.coordinates[1],
	            lng: this.fotos[i].coordenadas.coordinates[0],
	            focus: this.fotos[i].nro == this.foto.nro,
	            draggable: false,
	            message: 'Foto ' + this.fotos[i].nro,
	            icon: this.fotos[i].nro == this.foto.nro ? icon : icon2
	          });
	        }
	      }
	    }
	  }, {
	    key: 'cerrar',
	    value: function cerrar() {
	      this.$uibModalInstance.close(false);
	    }
	  }, {
	    key: '$$iniciarLeaflet',
	    value: function $$iniciarLeaflet() {
	      this.mapa = {
	        marcadores: [],
	        defaults: {
	          minZoom: 5
	        },
	        maxbounds: {
	          northEast: {
	            lat: -8.433237,
	            lng: -71.367187
	          },
	          southWest: {
	            lat: -23.596439,
	            lng: -56.118164
	          }
	        }
	      };
	      var layers = {
	        geobolivia_topo: {
	          name: 'GeoBolivia Topográfico',
	          url: 'https://test.geo.gob.bo/raster/service/wmts?',
	          type: 'wms',
	          visible: true,
	          layerParams: {
	            layers: 'mapbox_terrain',
	            format: "image/png",
	            transparent: true
	            //crs: L.CRS.EPSG4326,
	            //version: '1.1.1',
	          },
	          layerOptions: {
	            attribution: '<a href="https://geo.gob.bo" target="_blank">GeoBolivia</a>',
	            continuousWorld: false
	          }
	        },
	        geobolivia_sat: {
	          name: 'GeoBolivia Satelital',
	          url: 'https://test.geo.gob.bo/raster/service/wms?',
	          type: 'wms',
	          visible: true,
	          layerParams: {
	            layers: 'mapbox_bolivia',
	            format: "image/png",
	            transparent: true
	            //crs: L.CRS.EPSG4326,
	            //version: '1.1.1',
	          },
	          layerOptions: {
	            attribution: '<a href="https://geo.gob.bo" target="_blank">GeoBolivia</a>',
	            continuousWorld: false
	          }
	        },
	        openstreetmap: {
	          name: 'OpenStreetMap',
	          type: 'xyz',
	          url: 'http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
	          layerOptions: {
	            subdomains: ['a', 'b', 'c'],
	            attribution: '&copy; <a href="http://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a> contributors',
	            continuousWorld: false
	          }
	        },
	        arcgis: {
	          name: 'Topográfico',
	          url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}',
	          type: 'xyz',
	          layerOptions: {
	            attribution: '<a href="http://www.arcgis.com/home/webmap/viewer.html" target="_blank">ArcGIS</a>',
	            continuousWorld: false
	          }
	        },
	        arcgisimage: {
	          name: 'Imágenes',
	          url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
	          type: 'xyz',
	          layerOptions: {
	            attribution: '<a href="http://www.arcgis.com/home/webmap/viewer.html" target="_blank">ArcGIS</a>',
	            continuousWorld: false
	          }
	        },
	        mapbox_api: {
	          name: 'Escala de grises',
	          url: 'https://api.mapbox.com/v4/{mapid}/{z}/{x}/{y}.png?access_token={apikey}',
	          type: 'xyz',
	          layerOptions: {
	            apikey: 'pk.eyJ1IjoiY2hlbG9hbGVqb2MiLCJhIjoiY2lod2lkZHdrMDJueHUxbTFqMXRodGUzdyJ9.Vs-56Km_o5AXT9N5QrcLsw',
	            mapid: 'landplanner.map-dsn5dtki',
	            attribution: '<a href="https://www.mapbox.com/about/maps/" target="_blank">Mapbox</a>'
	          }
	        }
	      };
	
	      this.mapa.layers = {
	        baselayers: layers
	      };
	    }
	  }]);
	
	  return UbicacionModalController;
	}();
	
	exports.default = UbicacionModalController;

/***/ }),
/* 429 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SupervisionService = function () {
	  SupervisionService.$inject = ["DataService", "$q", "Datetime", "Util", "$window", "_"];
	  function SupervisionService(DataService, $q, Datetime, Util, $window, _) {
	    'ngInject';
	
	    _classCallCheck(this, SupervisionService);
	
	    this.DataService = DataService;
	    this.Datetime = Datetime;
	    this.estadoActual = null;
	    this.Util = Util;
	    this.$window = $window;
	    this.$q = $q;
	    this.proyectoOrigen = {};
	    this._ = _;
	  }
	
	  _createClass(SupervisionService, [{
	    key: 'setSupervision',
	    value: function setSupervision(pSupervision) {
	      this.supervision = angular.copy(pSupervision);
	      this.supervision.estado_actual.areas = this._.zipObject(this.supervision.estado_actual.areas, Array.from(new Array(this.supervision.estado_actual.areas.length), function () {
	        return true;
	      }));
	    }
	  }, {
	    key: 'getSupervision',
	    value: function getSupervision() {
	      return this.supervision || null;
	    }
	  }, {
	    key: 'isSetSupervision',
	    value: function isSetSupervision() {
	      return angular.isDefined(this.supervision);
	    }
	  }, {
	    key: 'setUsuario',
	    value: function setUsuario(pUsuario) {
	      this.usuario = angular.copy(pUsuario);
	      this.id_rol = null;
	      if (this.usuario.rol) {
	        this.id_rol = this.usuario.rol.id_rol;
	      } else {
	        this.id_rol = this.usuario.matricula ? 8 : 0;
	      }
	    }
	  }, {
	    key: 'esRolPermitido',
	    value: function esRolPermitido() {
	      return this.supervision.estado_actual.roles.indexOf(this.id_rol) !== -1;
	    }
	  }, {
	    key: 'esRolEstadoSupervisor',
	    value: function esRolEstadoSupervisor() {
	      return this.supervision.estado_supervision === 'EN_SUPERVISOR' && this.id_rol == 9;
	    }
	
	    /**
	     * getItems - Prepara y envía una lista de items que tienen el atributo show = true (que se va asignando de acuerdo a los filtros de la planilla)
	     *
	     * @return {array}  Lista de items filtrados por el atributo show = true
	     */
	
	  }, {
	    key: 'getItems',
	    value: function getItems() {
	      var _this = this;
	
	      if (!this.supervision) {
	        return null;
	      }
	      var items = [];
	      this.supervision.modulos.map(function (modulo) {
	        if (modulo.show) {
	          items = _this._.unionWith(items, _this._.reject(modulo.items, { 'show': false }));
	        }
	      });
	      return this._.orderBy(items, 'nro_item', 'asc');
	    }
	  }, {
	    key: 'getDatosSegunEstado',
	    value: function getDatosSegunEstado(supervision) {
	      var _this2 = this;
	
	      var nSupervision = {};
	      var atributos = Array.isArray(supervision.estado_actual.atributos) ? supervision.estado_actual.atributos : this._.keys(supervision.estado_actual.atributos);
	      atributos.map(function (atributo) {
	        if (!_this2.Util.isEmpty(supervision[atributo])) {
	          nSupervision[atributo] = supervision[atributo];
	        }
	      });
	      return nSupervision;
	    }
	  }, {
	    key: 'esAreaPermitida',
	    value: function esAreaPermitida(area) {
	      if (this.Util.isEmpty(this.supervision)) {
	        return;
	      }
	      return this.supervision.estado_actual.areas[area] ? true : false;
	    }
	  }, {
	    key: 'esEditable',
	    value: function esEditable(atributo) {
	      if (!this.supervision) return false;
	      return this.supervision.estado_actual.atributos[atributo] ? true : false;
	    }
	  }, {
	    key: 'calcularDescuento',
	    value: function calcularDescuento(tipo, montoEjecutado, deudaAnticipo, porcentajeAnticipo) {
	      var DESCUENTO = {};
	      switch (tipo) {
	        case 'TOTAL':
	          DESCUENTO.descuento = deudaAnticipo;
	          DESCUENTO.total = this.Util.restar(montoEjecutado, deudaAnticipo);
	          break;
	        case 'PROGRESIVO':
	          DESCUENTO.descuento = this.Util.getPorcentaje(montoEjecutado, porcentajeAnticipo);
	          DESCUENTO.total = this.Util.restar(montoEjecutado, DESCUENTO.descuento);
	          break;
	        case '0':
	          DESCUENTO.descuento = 0;
	          DESCUENTO.total = this.Util.restar(montoEjecutado, DESCUENTO.descuento);
	          break;
	        default:
	          {
	            DESCUENTO.descuento = deudaAnticipo;
	            DESCUENTO.total = this.Util.restar(montoEjecutado, deudaAnticipo);
	            var monto = this.Util.redondear(tipo);
	            if (monto) {
	              DESCUENTO.descuento = monto;
	              DESCUENTO.total = this.Util.restar(montoEjecutado, DESCUENTO.descuento);
	            }
	          }
	      }
	      return DESCUENTO;
	    }
	  }]);
	
	  return SupervisionService;
	}();
	
	exports.default = SupervisionService;

/***/ }),
/* 430 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ArchivoModalController = function () {
	  ArchivoModalController.$inject = ["$uibModalInstance", "data", "title", "icon", "DataService", "Message", "labelOk", "apiUrl"];
	  function ArchivoModalController($uibModalInstance, data, title, icon, DataService, Message, labelOk, apiUrl) {
	    'ngInject';
	
	    _classCallCheck(this, ArchivoModalController);
	
	    this.$uibModalInstance = $uibModalInstance;
	    this.data = data;
	    this.title = title;
	    this.icon = icon;
	    this.DataService = DataService;
	    this.Message = Message;
	    this.labelOk = labelOk;
	    this.apiUrl = apiUrl;
	  }
	
	  _createClass(ArchivoModalController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.descargas = {
	        manual: {
	          ruta: this.apiUrl + 'items/csv/manuales?archivo=ManualImportacionComputosMetricos2022',
	          nombre: 'Manual ods'
	        },
	        modelo: {
	          ruta: this.apiUrl + 'items/csv/manuales?archivo=computos&tipo=ods',
	          nombre: 'Modelo Computos'
	        }
	      };
	    }
	  }, {
	    key: 'registrar',
	    value: function registrar() {
	      this.$uibModalInstance.close(this.archivo);
	    }
	  }, {
	    key: 'cerrar',
	    value: function cerrar() {
	      this.$uibModalInstance.dismiss('cancel');
	    }
	  }]);
	
	  return ArchivoModalController;
	}();
	
	exports.default = ArchivoModalController;

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _importacionComputos = __webpack_require__(432);
	
	var _importacionComputos2 = _interopRequireDefault(_importacionComputos);
	
	var _importacionComputos3 = __webpack_require__(640);
	
	var _importacionComputos4 = _interopRequireDefault(_importacionComputos3);
	
	var _integracion = __webpack_require__(19);
	
	var _integracion2 = _interopRequireDefault(_integracion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImportacionComputosComponent = {
	    bindings: {
	        item: '<',
	        idsupervision: '<',
	        computos: '=',
	        resumen: '='
	    },
	    controller: _importacionComputos2.default,
	    template: _importacionComputos4.default,
	    service: _integracion2.default
	
	};
	
	exports.default = ImportacionComputosComponent;

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

	/*eslint no-console: ["error", { allow: ["log", "warn", "error"] }] */
	/*eslint no-undef: 0*/
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _archivoModal = __webpack_require__(430);
	
	var _archivoModal2 = _interopRequireDefault(_archivoModal);
	
	var _archivoModal3 = __webpack_require__(639);
	
	var _archivoModal4 = _interopRequireDefault(_archivoModal3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ImportarComputosController = function () {
	  ImportarComputosController.$inject = ["DataService", "Util", "Modal", "NgTableParams", "_", "Message", "Proyecto", "Storage", "apiUrlSiga", "$http", "Integracion", "Computo"];
	  function ImportarComputosController(DataService, Util, Modal, NgTableParams, _, Message, Proyecto, Storage, apiUrlSiga, $http, Integracion, Computo) {
	    "ngInject";
	
	    _classCallCheck(this, ImportarComputosController);
	
	    this.DataService = DataService;
	    this.Util = Util;
	    this.Modal = Modal;
	    this.NgTableParams = NgTableParams;
	    this._ = _;
	    this.Message = Message;
	    this.Proyecto = Proyecto;
	    this.apiUrlSiga = apiUrlSiga;
	    this.$http = $http;
	    this.user = Storage.getUser();
	    this.Integracion = Integracion;
	    this.Computo = Computo;
	  }
	
	  _createClass(ImportarComputosController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      this.titulo = "PRUEBA COMPONENTE";
	      this.archivo = "computos";
	      this.tipo = "ods";
	      this.i_nombre_file = "NOMBRE DEL ARCHIVO";
	      this.rutaArchivoComputo = this.apiUrl + ("items/csv/manuales?archivo=" + this.archivo + "&tipo=" + this.tipo);
	      //console.log('prueba console log',this.titulo);
	      console.log("------------------------------------");
	      console.log(this.titulo);
	      console.log(this.apiUrl);
	      console.log(this.rutaArchivoComputo);
	      console.log("VALOR DE ITEM ==>" + JSON.stringify(this.item));
	      console.log("SUPERVISION ==>" + this.idsupervision);
	      console.log("USUARIO ==>" + JSON.stringify(this.user));
	      console.log("ID_USUARIO ==>" + JSON.stringify(this.user.id_usuario));
	      //console.log("USUARIO ==>" + Object.values(this.user));
	
	    }
	  }, {
	    key: "subirArchivo",
	    value: function subirArchivo() {
	      console.log("---------------SUBIR ARCHIVO-----------------");
	      console.log(this.inputArchivo);
	      console.log(this.inputTexto);
	    }
	  }, {
	    key: "importarComputos",
	    value: function importarComputos() {
	      var _this = this;
	
	      var confArchivo = {
	        //formatos: 'csv, xlsx, ods', //types
	        formatos: "ods", //types
	        // tipos: '.csv,.xlsx,.ods', //mime-types
	        tipos: ".ods", //mime-types
	        cargarItems: true,
	        mensajeInformacion: "Puede importar computos desde un <strong>archivo en formato .ods</strong>."
	      };
	      this.mostrarModal("Importar Computos", "fa-upload", confArchivo, _archivoModal4.default, _archivoModal2.default, "Importar").result.then(function (documento) {
	        var computos = {
	          tipo: 'importaComputos',
	          data: _this.item,
	          base64: documento.base64,
	          idsupervision: _this.idsupervision,
	          usuarioregistro: _this.user.id_usuario
	        };
	
	        var dts = _this.Integracion.importacionComputosMetricos(computos);
	        dts.then(function successCallback(respuesta) {
	          return respuesta.data;
	          //console.log(respuesta.data);
	        }).then(function (dts) {
	          console.log(dts);
	          if (dts.length > 0) {
	            _this.Message.warning(dts, "Importacion C\xF3mputos Metricos", 12000);
	          } else {
	            _this.Message.success("Se importo el archivo de forma correcta", "Importacion C\xF3mputos Metricos");
	          }
	        }).then(function () {
	          //console.log(this.item.id_item);
	          return _this.getComputosItem(_this.item.id_item, _this.idsupervision);
	          //this.getComputosItem(this.item.id_item,this.idsupervision);
	        }).then(function (dts) {
	          console.log('datos=====>' + dts);
	          _this.computos = dts;
	          _this.actualizarResumen(_this.item.id_item, dts, _this.resumen);
	        });
	
	        //NO BORRARRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRR
	        // const dts=this.Integracion.listaProyectos();
	        // dts.then((data)=>{
	        //   console.log(data.data);
	        // },
	        // (error)=>{
	        //   console.log("Error de la peticiona" + error);
	        // }      
	        // );
	      });
	    }
	  }, {
	    key: "mostrarModal",
	    value: function mostrarModal(titulo, icon, data, template, controller, labelOk, size) {
	      return this.Modal.show({
	        template: template,
	        controller: controller,
	        data: data || {},
	        title: titulo,
	        icon: icon,
	        size: size ? size : "md",
	        labelOk: labelOk
	      });
	    }
	  }, {
	    key: "getComputosItem",
	    value: function getComputosItem(item, idsupervision) {
	      var _this2 = this;
	
	      console.log('ID_ITEM==>' + item);
	      console.log('ID SUPERVISION==>' + idsupervision);
	      return this.DataService.get("computos_metricos?item=" + item + "&supervision=" + idsupervision).then(function (response) {
	        //this.computos = this.Computo.getListaOrdenadaComputos(response.datos.computos, this.item);
	        return _this2.computos = response.datos.computos;
	        //return response.datos.computos;
	      });
	    }
	  }, {
	    key: "actualizarResumen",
	    value: function actualizarResumen(item, computos, resumen) {
	      this.resumen = this.Computo.getResumen(item, computos, resumen);
	    }
	  }]);
	
	  return ImportarComputosController;
	}();
	
	exports.default = ImportarComputosController;

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _pendientes = __webpack_require__(440);
	
	var _pendientes2 = _interopRequireDefault(_pendientes);
	
	var _procesados = __webpack_require__(444);
	
	var _procesados2 = _interopRequireDefault(_procesados);
	
	var _supervisiones = __webpack_require__(446);
	
	var _supervisiones2 = _interopRequireDefault(_supervisiones);
	
	var _button = __webpack_require__(434);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _button3 = __webpack_require__(347);
	
	var _button4 = _interopRequireDefault(_button3);
	
	var _button5 = __webpack_require__(437);
	
	var _button6 = _interopRequireDefault(_button5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Bandeja = angular.module('app.bandeja', []).component('bandejaPendientes', _pendientes2.default).component('bandejaProcesados', _procesados2.default).component('listaSupervisiones', _supervisiones2.default).component('listaModificaciones', _button2.default).component('buttonTimeline', _button4.default).component('buttonParalizar', _button6.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	    $stateProvider.state('pendientes', {
	        url: '/pendientes',
	        component: 'bandejaPendientes'
	    }).state('mis-proyectos', {
	        url: '/mis-proyectos',
	        component: 'bandejaProcesados'
	    });
	    $urlRouterProvider.otherwise('/mis-proyectos');
	}]).name;
	
	exports.default = Bandeja;

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _button = __webpack_require__(435);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _button3 = __webpack_require__(641);
	
	var _button4 = _interopRequireDefault(_button3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ListaModificacionesComponent = {
	  bindings: {
	    proyecto: '<'
	  },
	  controller: _button2.default,
	  template: _button4.default
	};
	
	exports.default = ListaModificacionesComponent;

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _modal = __webpack_require__(436);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _modal3 = __webpack_require__(642);
	
	var _modal4 = _interopRequireDefault(_modal3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ListaModificacionesController = function () {
	  ListaModificacionesController.$inject = ["Modal"];
	  function ListaModificacionesController(Modal) {
	    'ngInject';
	
	    _classCallCheck(this, ListaModificacionesController);
	
	    this.Modal = Modal;
	  }
	
	  _createClass(ListaModificacionesController, [{
	    key: '$onInit',
	    value: function $onInit() {}
	  }, {
	    key: 'verModificaciones',
	    value: function verModificaciones() {
	      this.Modal.show({
	        template: _modal4.default,
	        controller: _modal2.default,
	        data: this.proyecto,
	        size: 'lg'
	      });
	    }
	  }]);
	
	  return ListaModificacionesController;
	}();
	
	exports.default = ListaModificacionesController;

/***/ }),
/* 436 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var NuevaAdjudicacionModalController = function () {
	  NuevaAdjudicacionModalController.$inject = ["$uibModalInstance", "$state", "data", "Modal", "DataService", "Storage", "$log", "_"];
	  function NuevaAdjudicacionModalController($uibModalInstance, $state, data, Modal, DataService, Storage, $log, _) {
	    'ngInject';
	
	    _classCallCheck(this, NuevaAdjudicacionModalController);
	
	    this.$uibModalInstance = $uibModalInstance;
	    this.$state = $state;
	    this.proyecto = data;
	    this.Modal = Modal;
	    this.DataService = DataService;
	    this._ = _;
	    this.modificando = true;
	    this.user = Storage.getUser();
	    this.$log = $log;
	  }
	
	  _createClass(NuevaAdjudicacionModalController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.DataService.get('proyectos/' + this.proyecto.id_proyecto + '/modificaciones/historial').then(function (result) {
	        if (result && result.finalizado) {
	          _this.modificaciones = result.datos;
	          _this.$log.log('DATOS DE MODIFICACIONES====>' + JSON.stringify(_this.modificaciones));
	          _this.existeSupervisionesEnCurso = _this.tieneSupervisionesEnCurso();
	          _this.puedeModificar = !result.datos.find(function (version) {
	            return version.estado_proyecto != 'APROBADO';
	          }) && _this.user.rol.nombre == 'SUPERVISOR' && !_this.existeSupervisionesEnCurso && _this.proyecto.estado_proyecto !== 'CERRADO';
	          _this.modificando = ['RESPONSABLE_MAE', 'SUPERVISOR', 'FISCAL', 'TECNICO_UPRE', 'RESP_DEPARTAMENTAL_UPRE', 'ENCAR_REGIONAL_UPRE', 'EMPRESA'].indexOf(_this.user.rol.nombre) >= 0 ? true : false;
	          var cant = _this.modificaciones.length - 1;
	          if (cant >= 0 && _this.modificaciones[cant] && !_this.modificaciones[cant].nombre) {
	            _this.modificaciones[cant].nombre = 'Contrato Original';
	          }
	        }
	      });
	    }
	  }, {
	    key: 'tieneSupervisionesEnCurso',
	    value: function tieneSupervisionesEnCurso() {
	      return this._.some(this.proyecto.supervisiones, function (supervision) {
	        return supervision.estado_supervision !== 'EN_ARCHIVO' && supervision.estado_supervision !== 'REGISTRO_PLANILLA';
	      });
	    }
	  }, {
	    key: 'abrirModificacion',
	    value: function abrirModificacion(tipoModificacion) {
	      var _this2 = this;
	
	      var html = '\n      1. Para realizar una modificaci\xF3n deber\xE1 contar con el respectivo documento de respaldo debidamente aprobado por las instancias pertinentes (Libro de Ordenes e Informes T\xE9cnicos para la Orden de Trabajo y Orden de Cambio y el respectivo contrato para el Contrato Modificatorio).\n      <br/><br/>2. Una vez que este registrando modificaciones la empresa no podr\xE1 procesar una planilla de avance hasta que se finalice y apruebe la solicitud de modificaci\xF3n.\n    ';
	      this.Modal.confirm(html, function () {
	        _this2.$uibModalInstance.close(false);
	        _this2.$state.go('modificacion', {
	          proyecto: _this2.proyecto.id_proyecto,
	          tipoModificacion: tipoModificacion,
	          edicion: true,
	          crear: true
	        });
	      }, null, 'Confirmar inicio de modificación', 'Confirmar');
	    }
	  }, {
	    key: 'irAModificacion',
	    value: function irAModificacion(modificacion, edicion) {
	      this.$log.log('MODIFICACION====>' + JSON.stringify(modificacion));
	      this.$log.log('EDICION====>' + edicion);
	      var tipoModificacion = modificacion.tipo_modificacion == 'TM_ORDEN_TRABAJO' ? 1 : modificacion.tipo_modificacion == 'TM_ORDEN_CAMBIO' ? 2 : modificacion.tipo_modificacion == 'TM_CONTRATO_MODIFICATORIO' ? 3 : 0;
	      this.$uibModalInstance.close(false);
	      this.$state.go('modificacion', {
	        proyecto: this.proyecto.id_proyecto,
	        version: modificacion.version,
	        tipoModificacion: tipoModificacion,
	        edicion: edicion,
	        crear: false
	      });
	    }
	  }, {
	    key: 'cerrar',
	    value: function cerrar() {
	      this.$uibModalInstance.close(false);
	    }
	  }, {
	    key: 'verModificar',
	    value: function verModificar(modificacion) {
	      return modificacion.estado_proyecto == 'MODIFICADO' && this.user.rol.nombre == 'SUPERVISOR';
	    }
	  }, {
	    key: 'verUltimaModificacion',
	    value: function verUltimaModificacion(modificacion) {
	      return ['REVISION_MODIFICACION', 'REVISION_MODIFICACION_FISCAL', 'MODIFICADO', 'CERRADO'].indexOf(modificacion.estado_proyecto) >= 0 && ['RESPONSABLE_MAE', 'SUPERVISOR', 'FISCAL', 'TECNICO_UPRE', 'RESP_DEPARTAMENTAL_UPRE', 'ENCAR_REGIONAL_UPRE', 'EMPRESA'].indexOf(this.user.rol.nombre) >= 0 && !this.verModificar(modificacion);
	    }
	  }]);
	
	  return NuevaAdjudicacionModalController;
	}();
	
	exports.default = NuevaAdjudicacionModalController;

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _button = __webpack_require__(438);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _button3 = __webpack_require__(643);
	
	var _button4 = _interopRequireDefault(_button3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ButtonParalizarComponent = {
	  bindings: {
	    proyecto: '<'
	  },
	  controller: _button2.default,
	  template: _button4.default
	};
	
	exports.default = ButtonParalizarComponent;

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _modal = __webpack_require__(439);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _modal3 = __webpack_require__(644);
	
	var _modal4 = _interopRequireDefault(_modal3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ButtonParalizarController = function () {
	  ButtonParalizarController.$inject = ["Modal"];
	  function ButtonParalizarController(Modal) {
	    'ngInject';
	
	    _classCallCheck(this, ButtonParalizarController);
	
	    this.Modal = Modal;
	  }
	
	  _createClass(ButtonParalizarController, [{
	    key: '$onInit',
	    value: function $onInit() {}
	  }, {
	    key: 'verMensaje',
	    value: function verMensaje() {
	      this.Modal.show({
	        template: _modal4.default,
	        controller: _modal2.default,
	        data: this.proyecto,
	        size: 'lg'
	      });
	    }
	  }]);
	
	  return ButtonParalizarController;
	}();
	
	exports.default = ButtonParalizarController;

/***/ }),
/* 439 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ParalizarModalController = function () {
	  ParalizarModalController.$inject = ["$uibModalInstance", "$state", "data", "Modal", "DataService", "Storage", "_"];
	  function ParalizarModalController($uibModalInstance, $state, data, Modal, DataService, Storage, _) {
	    'ngInject';
	
	    _classCallCheck(this, ParalizarModalController);
	
	    this.$uibModalInstance = $uibModalInstance;
	    this.$state = $state;
	    this.proyecto = data;
	    this.DataService = DataService;
	    this._ = _;
	    this.user = Storage.getUser();
	  }
	
	  _createClass(ParalizarModalController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.existeSupervisionesEnCurso = this.tieneSupervisionesEnCurso();
	    }
	  }, {
	    key: 'tieneSupervisionesEnCurso',
	    value: function tieneSupervisionesEnCurso() {
	      return this._.some(this.proyecto.supervisiones, function (supervision) {
	        return supervision.estado_supervision !== 'EN_ARCHIVO' && supervision.estado_supervision !== 'REGISTRO_PLANILLA';
	      });
	    }
	  }, {
	    key: 'paralizarProyecto',
	    value: function paralizarProyecto() {
	      var _this = this;
	
	      this.DataService.put('proyectos/' + this.proyecto.id_proyecto + '/empresas/paralizar').then(function (resp) {
	        if (resp && resp.finalizado) {
	          //this.$state.go('mis-proyectos', {});
	          _this.$uibModalInstance.close(true);
	          _this.$state.reload();
	        }
	      });
	    }
	  }, {
	    key: 'cerrar',
	    value: function cerrar() {
	      this.$uibModalInstance.close(false);
	    }
	  }]);
	
	  return ParalizarModalController;
	}();
	
	exports.default = ParalizarModalController;

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _pendientes = __webpack_require__(441);
	
	var _pendientes2 = _interopRequireDefault(_pendientes);
	
	var _pendientes3 = __webpack_require__(645);
	
	var _pendientes4 = _interopRequireDefault(_pendientes3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BandejaPendientesComponent = {
	  bindings: {},
	  controller: _pendientes2.default,
	  template: _pendientes4.default
	};
	
	exports.default = BandejaPendientesComponent;

/***/ }),
/* 441 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BandejaPendientesController = function () {
	  BandejaPendientesController.$inject = ["Storage", "DataService", "DataTable", "$state", "_", "Modal", "$log"];
	  function BandejaPendientesController(Storage, DataService, DataTable, $state, _, Modal, $log) {
	    'ngInject';
	
	    _classCallCheck(this, BandejaPendientesController);
	
	    this.Storage = Storage;
	    this.DataService = DataService;
	    this.DataTable = DataTable;
	    this.$state = $state;
	    this._ = _;
	    this.Modal = Modal;
	    this.$log = $log;
	  }
	
	  _createClass(BandejaPendientesController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.usuario = angular.fromJson(this.Storage.getUser());
	      this.$log.log('usuario====>' + JSON.stringify(this.usuario));
	      this.$log.log('rol negado====>' + !this.usuario.rol);
	      this.$log.log('rol====>' + this.usuario.rol);
	
	      this.config = this.getConfiguracion();
	      this.$log.log('config==>' + JSON.stringify(this.config));
	      this.configSupervisiones = this.getConfiguracionSupervisiones();
	      this.$log.log('configSupervisones==>' + JSON.stringify(this.configSupervisiones));
	      var QUERY = this.esEmpresa() ? { matricula: this.usuario.matricula } : { rol: this.Storage.get('rol').id_rol };
	      this.tableParams = this.DataTable.getParams('proyectos', QUERY);
	      this.verModificacion = this.puedeVerModificacion();
	    }
	  }, {
	    key: 'getConfiguracion',
	    value: function getConfiguracion() {
	      if (!this.usuario.rol) {
	
	        return;
	      }
	      var configuracion = {
	        acciones: [{ icon: 'edit', tooltip: 'Procesar proyecto', md: 'primary', metodo: this.procesarProyecto.bind(this) }]
	      };
	      return configuracion;
	    }
	  }, {
	    key: 'getConfiguracionSupervisiones',
	    value: function getConfiguracionSupervisiones() {
	      var configuracion = {};
	      if (!this.usuario.rol) {
	        this.$log.log('ENTRA getConfiguracionSupervisiones');
	        return;
	      }
	      switch (this.usuario.rol.nombre) {
	        default:
	          configuracion = {
	            acciones: [{ icon: 'edit', tooltip: 'Procesar planilla', md: 'primary', metodo: this.procesarPlanilla.bind(this) }]
	          };
	      }
	      return configuracion;
	    }
	  }, {
	    key: 'procesarProyecto',
	    value: function procesarProyecto(proyecto) {
	      if (this.esEmpresa() && proyecto.estado_proyecto === 'REGISTRO_EMPRESA') {
	        return this.documentarProyecto(proyecto);
	      }
	      if (this.esEmpresa() && proyecto.estado_proyecto === 'REGISTRO_EMPRESA_CORRECCION') {
	        return this.documentarProyecto(proyecto);
	      }
	      if (this.usuario.rol.nombre === 'SUPERVISOR' && proyecto.estado_proyecto === 'MODIFICADO' || this.usuario.rol.nombre === 'FISCAL' && proyecto.estado_proyecto === 'REVISION_MODIFICACION_FISCAL' || (this.usuario.rol.nombre === 'TECNICO_UPRE' || this.usuario.rol.nombre === 'RESP_DEPARTAMENTAL_UPRE') && proyecto.estado_proyecto === 'REVISION_MODIFICACION') {
	        return this.procesarModificacion(proyecto);
	      }
	      this.$state.go('proyecto', { codigo: proyecto.id_proyecto });
	    }
	  }, {
	    key: 'documentarProyecto',
	    value: function documentarProyecto(proyecto) {
	      this.$state.go('documentacion-proyecto', { codigo: proyecto.id_proyecto });
	    }
	  }, {
	    key: 'procesarPlanilla',
	    value: function procesarPlanilla(proyecto) {
	      this.$log.log('Procesar Planilla===>' + JSON.stringify(proyecto));
	      this.$state.go('planilla-proyecto', { idSupervision: proyecto.supervisiones[0].id_supervision });
	    }
	  }, {
	    key: 'procesarModificacion',
	    value: function procesarModificacion(proyecto) {
	      var _this = this;
	
	      this.DataService.get('proyectos/' + proyecto.id_proyecto + '/modificaciones/historial').then(function (result) {
	        if (result && result.finalizado) {
	          var modificacion = result.datos[0];
	          var tipoModificacion = modificacion.tipo_modificacion == 'TM_ORDEN_TRABAJO' ? 1 : modificacion.tipo_modificacion == 'TM_ORDEN_CAMBIO' ? 2 : modificacion.tipo_modificacion == 'TM_CONTRATO_MODIFICATORIO' ? 3 : 0;
	          if (modificacion && ['MODIFICADO', 'REVISION_MODIFICACION_FISCAL', 'REVISION_MODIFICACION'].indexOf(modificacion.estado_proyecto) >= 0) {
	            _this.$state.go('modificacion', {
	              proyecto: proyecto.id_proyecto,
	              version: modificacion.version,
	              tipoModificacion: tipoModificacion,
	              edicion: _this.usuario.rol.nombre === 'SUPERVISOR'
	            });
	          }
	        }
	      });
	    }
	  }, {
	    key: 'esEmpresa',
	    value: function esEmpresa() {
	      return !angular.isUndefined(this.usuario.nit);
	    }
	  }, {
	    key: 'puedeVerSupervision',
	    value: function puedeVerSupervision(proyecto) {
	      if (proyecto) {
	        return ['APROBADO', 'CONCILIACION', 'MODIFICADO'].indexOf(proyecto.estado_proyecto) >= 0 && proyecto.supervisiones && proyecto.supervisiones.length > 0;
	      }
	      return false;
	    }
	  }, {
	    key: 'puedeVerModificacion',
	    value: function puedeVerModificacion(proyecto) {
	      if (proyecto) {
	        // TODO Se deberia obtener desde una configuracion del proyecto Base de DAtos
	        return ['SUPERVISOR', 'TECNICO_UPRE', 'RESP_DEPARTAMENTAL_UPRE', 'EMPRESA'].indexOf(this.usuario.rol.nombre) >= 0 && ['REVISION_MODIFICACION', 'MODIFICADO'].indexOf(proyecto.estado_actual.codigo) >= 0;
	      }
	      return false;
	    }
	  }]);
	
	  return BandejaPendientesController;
	}();
	
	exports.default = BandejaPendientesController;

/***/ }),
/* 442 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var NuevaAdjudicacionModalController = function () {
	  NuevaAdjudicacionModalController.$inject = ["$uibModalInstance", "Storage", "DataService", "Message"];
	  function NuevaAdjudicacionModalController($uibModalInstance, Storage, DataService, Message) {
	    'ngInject';
	
	    _classCallCheck(this, NuevaAdjudicacionModalController);
	
	    this.$uibModalInstance = $uibModalInstance;
	    this.Storage = Storage;
	    this.DataService = DataService;
	    this.Message = Message;
	  }
	
	  _createClass(NuevaAdjudicacionModalController, [{
	    key: '$onInit',
	    value: function $onInit() {}
	  }, {
	    key: 'adjudicarProyecto',
	    value: function adjudicarProyecto() {
	      var _this = this;
	
	      var datos = {
	        matricula: this.Storage.getUser().matricula,
	        codigo_acceso: this.codigo_acceso
	      };
	      this.DataService.post('adjudicar', datos).then(function (result) {
	        if (result) {
	          _this.Message.success(result.mensaje);
	          _this.$uibModalInstance.close(result.datos);
	        }
	      });
	    }
	  }, {
	    key: 'cerrar',
	    value: function cerrar() {
	      this.$uibModalInstance.dismiss('cancel');
	    }
	  }]);
	
	  return NuevaAdjudicacionModalController;
	}();
	
	exports.default = NuevaAdjudicacionModalController;

/***/ }),
/* 443 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ConvenioModalController = function () {
	  ConvenioModalController.$inject = ["$state", "$uibModalInstance", "DataService", "Storage", "data", "Util", "$filter", "$timeout", "Message", "Proyecto", "Loading"];
	  function ConvenioModalController($state, $uibModalInstance, DataService, Storage, data, Util, $filter, $timeout, Message, Proyecto, Loading) {
	    'ngInject';
	
	    _classCallCheck(this, ConvenioModalController);
	
	    this.$state = $state;
	    this.$uibModalInstance = $uibModalInstance;
	    this.DataService = DataService;
	    this.Util = Util;
	    this.$filter = $filter;
	    this.data = data;
	    this.$timeout = $timeout;
	    this.Message = Message;
	    this.Proyecto = Proyecto;
	    this.Loading = Loading;
	    this.conEstados = false;
	    this.user = Storage.getUser();
	  }
	
	  _createClass(ConvenioModalController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.opciones = {};
	      this.modoVistaConvenio = false;
	      this.getDatosEstadoInicial();
	    }
	  }, {
	    key: 'getDatosEstadoInicial',
	    value: function getDatosEstadoInicial() {
	      var _this = this;
	
	      this.DataService.get('estados/PROYECTO').then(function (response) {
	        if (response) {
	          _this.Proyecto.setEstadoActual(response.datos);
	          _this.conEstados = true;
	        }
	      });
	    }
	  }, {
	    key: 'cerrar',
	    value: function cerrar() {
	      this.$uibModalInstance.close(false);
	    }
	  }, {
	    key: 'guardarDatos',
	    value: function guardarDatos() {
	      var _this2 = this;
	
	      this.Loading.show('Registrando proyecto', true);
	      this.DataService.post('proyectos', this.formatoDatosConvenio()).then(function (response) {
	        if (response) {
	          _this2.Message.success("Proyecto creado correctamente.");
	          _this2.cerrar();
	          _this2.Loading.hide();
	          _this2.$state.reload();
	        }
	      });
	    }
	  }, {
	    key: 'formatoDatosConvenio',
	    value: function formatoDatosConvenio() {
	      var convenio = angular.copy(this.proyecto);
	      convenio.fcod_municipio = convenio.dpa.municipio.codigo;
	      convenio.rol = this.user.rol.id_rol;
	      delete convenio.dpa;
	
	      return convenio;
	    }
	  }]);
	
	  return ConvenioModalController;
	}();
	
	exports.default = ConvenioModalController;

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _procesados = __webpack_require__(445);
	
	var _procesados2 = _interopRequireDefault(_procesados);
	
	var _procesados3 = __webpack_require__(648);
	
	var _procesados4 = _interopRequireDefault(_procesados3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BandejaProcesadosComponent = {
	  bindings: {},
	  controller: _procesados2.default,
	  template: _procesados4.default
	};
	
	exports.default = BandejaProcesadosComponent;

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _crearProyectoModal = __webpack_require__(443);
	
	var _crearProyectoModal2 = _interopRequireDefault(_crearProyectoModal);
	
	var _crearProyectoModal3 = __webpack_require__(647);
	
	var _crearProyectoModal4 = _interopRequireDefault(_crearProyectoModal3);
	
	var _adjudicacionModal = __webpack_require__(646);
	
	var _adjudicacionModal2 = _interopRequireDefault(_adjudicacionModal);
	
	var _adjudicacionModal3 = __webpack_require__(442);
	
	var _adjudicacionModal4 = _interopRequireDefault(_adjudicacionModal3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BandejaProcesadosController = function () {
	  BandejaProcesadosController.$inject = ["Storage", "DataService", "apiUrl", "$location", "Modal", "$log", "$state", "DataTable", "$filter"];
	  function BandejaProcesadosController(Storage, DataService, apiUrl, $location, Modal, $log, $state, DataTable, $filter) {
	    'ngInject';
	
	    _classCallCheck(this, BandejaProcesadosController);
	
	    this.Storage = Storage;
	    this.DataService = DataService;
	    this.apiUrl = apiUrl;
	    this.$location = $location;
	    this.$log = $log;
	    this.Modal = Modal;
	    this.$state = $state;
	    this.DataTable = DataTable;
	    this.$filter = $filter;
	  }
	
	  _createClass(BandejaProcesadosController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.datos = {};
	      this.usuario = angular.fromJson(this.Storage.getUser());
	      this.config = this.obtenerConfiguracion();
	      this.esEmpresa = this.esUsuarioEmpresa();
	      this.verModificacion = this.puedeVerModificacion();
	      var QUERY = this.esUsuarioEmpresa() ? { matricula: this.usuario.matricula } : { rol: this.Storage.get('rol').id_rol };
	      this.tableParams = this.DataTable.getParams('proyectos/procesados', QUERY);
	      // this.$log.log(this.tableParams);
	    }
	  }, {
	    key: 'obtenerConfiguracion',
	    value: function obtenerConfiguracion() {
	      var configuracion = {};
	      if (this.usuario.rol) {
	        switch (this.usuario.rol.nombre) {
	          case 'LEGAL_UPRE':
	            configuracion = {
	              opciones: [{ icon: 'plus', tooltip: 'Nuevo proyecto', md: 'success', metodo: this.crearProyecto.bind(this) }]
	            };
	            break;
	          case 'EMPRESA':
	            configuracion = {
	              opciones: [{ icon: 'plus', tooltip: 'Adjudicar', md: 'success', metodo: this.nuevaAdjudicacion.bind(this) }]
	            };
	            break;
	          default:
	        }
	        configuracion.acciones = [{ icon: 'eye', tooltip: 'Ver', md: 'primary', metodo: this.observarProy.bind(this) }];
	        if (['ENCAR_REGIONAL_UPRE', 'RESP_DEPARTAMENTAL_UPRE', 'JEFE_TECNICO_UPRE', 'TECNICO_UPRE'].indexOf(this.usuario.rol.nombre) >= 0) {
	          configuracion.acciones.push({ icon: 'user', tooltip: 'Usuarios', md: 'primary', metodo: this.cambiarUsuario.bind(this) });
	        }
	      }
	      return configuracion;
	    }
	  }, {
	    key: 'eventoOpcion',
	    value: function eventoOpcion(event, item, data) {
	      if (typeof item.metodo === 'function') {
	        item.metodo(event, data);
	      }
	    }
	  }, {
	    key: 'crearProyecto',
	    value: function crearProyecto() {
	      this.Modal.show({
	        template: _crearProyectoModal4.default,
	        controller: _crearProyectoModal2.default,
	        data: {},
	        size: 'xlg'
	      });
	    }
	  }, {
	    key: 'nuevaAdjudicacion',
	    value: function nuevaAdjudicacion() {
	      var _this = this;
	
	      this.Modal.show({
	        template: _adjudicacionModal2.default,
	        controller: _adjudicacionModal4.default,
	        size: 'md'
	      }).result.then(function (result) {
	        _this.$state.go('documentacion-proyecto', { codigo: result.id_proyecto });
	      }).catch(function () {});
	    }
	  }, {
	    key: 'observarProy',
	    value: function observarProy(event, proyecto) {
	      // if (this.esEmpresa() && proyecto.estado_proyecto === 'REGISTRO_EMPRESA') {
	      //   return this.documentarProyecto(proyecto);
	      // }
	      this.$state.go('proyecto', { codigo: proyecto.id_proyecto, urlProcesado: 'procesados' });
	    }
	  }, {
	    key: 'cambiarUsuario',
	    value: function cambiarUsuario(event, proyecto) {
	      this.$state.go('adminproyecto', { codigo: proyecto.id_proyecto });
	    }
	  }, {
	    key: 'documentar',
	    value: function documentar() {}
	  }, {
	    key: 'nuevaPlanilla',
	    value: function nuevaPlanilla(proyecto) {
	      var _this2 = this;
	
	      var data = {
	        fid_proyecto: proyecto.id_proyecto,
	        computo_metrico: []
	      };
	      this.DataService.post('supervisiones', data).then(function (response) {
	        if (response) {
	          _this2.irPlanilla(response.datos.id_supervision);
	        }
	      });
	    }
	  }, {
	    key: 'irPlanilla',
	    value: function irPlanilla(idSupervision) {
	      this.$state.go('planilla-proyecto', { idSupervision: idSupervision });
	    }
	  }, {
	    key: 'esUsuarioEmpresa',
	    value: function esUsuarioEmpresa() {
	      return !angular.isUndefined(this.usuario.nit);
	    }
	  }, {
	    key: 'puedeCrearPlanilla',
	    value: function puedeCrearPlanilla(proyecto) {
	      if (proyecto.supervisiones.length > 0) {
	        return proyecto.supervisiones[0].estado_supervision === 'EN_ARCHIVO';
	      }
	      return true;
	    }
	  }, {
	    key: 'puedeVerSupervision',
	    value: function puedeVerSupervision(proyecto) {
	      if (proyecto) {
	        return ['APROBADO', 'CONCILIACION', 'CERRADO', 'MODIFICADO', 'REVISION_MODIFICACION_FISCAL', 'REVISION_MODIFICACION', 'PARALIZADO'].indexOf(proyecto.estado_proyecto) >= 0 && proyecto.supervisiones && proyecto.supervisiones.length > 0;
	      }
	      return false;
	    }
	  }, {
	    key: 'puedeVerModificacion',
	    value: function puedeVerModificacion(proyecto) {
	      var enSupervision = false;
	      if (proyecto) {
	        if (proyecto.supervisiones) {
	          //enSupervision = proyecto.supervisiones.find((sup)=>{ return sup.estado_supervision=='EN_FISCAL'; });
	        }
	        return ['SUPERVISOR', 'TECNICO_UPRE', 'RESP_DEPARTAMENTAL_UPRE', 'ENCAR_REGIONAL_UPRE', 'EMPRESA', 'FISCAL', 'RESPONSABLE_MAE'].indexOf(this.usuario.rol.nombre) >= 0 && !enSupervision && ['APROBADO', 'CONCILIACION', 'REVISION_MODIFICACION', 'REVISION_MODIFICACION_FISCAL', 'MODIFICADO', 'CERRADO', 'PARALIZADO'].indexOf(proyecto.estado_actual.codigo) >= 0;
	      }
	      return false;
	    }
	  }, {
	    key: 'puedeParalizar',
	    value: function puedeParalizar(proyecto) {
	      if (proyecto) {
	        return ['TECNICO_UPRE', 'RESP_DEPARTAMENTAL_UPRE'].indexOf(this.usuario.rol.nombre) >= 0 && ['APROBADO', 'CONCILIACION'].indexOf(proyecto.estado_actual.codigo) >= 0;
	      }
	      return false;
	    }
	  }, {
	    key: 'colorDate',
	    value: function colorDate(date) {
	      var delta = Math.round((+new Date() - new Date(date)) / 1000);
	      if (Math.floor(delta / 604800) > 3) return 'bg-warning'; // 60 * 60 * 24 * 7
	      return '';
	    }
	    // Fechas relativas
	
	  }, {
	    key: 'relativeDate',
	    value: function relativeDate(date) {
	      var delta = Math.round((+new Date() - new Date(date)) / 1000);
	      var minute = 60,
	          hour = minute * 60,
	          day = hour * 24,
	          week = day * 7;
	
	      var fuzzy = void 0;
	      if (delta < 0) {
	        return this.$filter('date')(date, 'dd/MM/yyyy');
	      }
	      if (delta < 30) {
	        fuzzy = 'ahora.';
	      } else if (delta < 2 * minute) {
	        fuzzy = 'hace un minuto.';
	      } else if (delta < hour) {
	        fuzzy = 'hace ' + Math.floor(delta / minute) + ' minutos.';
	      } else if (Math.floor(delta / hour) == 1) {
	        fuzzy = 'hace una hora.';
	      } else if (delta < day) {
	        fuzzy = 'hace ' + Math.floor(delta / hour) + ' horas.';
	      } else if (delta < day * 2) {
	        fuzzy = 'Ayer';
	      } else if (delta < week) {
	        fuzzy = 'hace ' + Math.floor(delta / day) + ' d\xEDas.';
	      } else if (delta < week * 2) {
	        fuzzy = 'hace una semana.';
	      } else {
	        fuzzy = 'hace ' + Math.floor(delta / week) + ' semanas.';
	      }
	      return fuzzy;
	    }
	  }]);
	
	  return BandejaProcesadosController;
	}();
	
	exports.default = BandejaProcesadosController;

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _supervisiones = __webpack_require__(447);
	
	var _supervisiones2 = _interopRequireDefault(_supervisiones);
	
	var _supervisiones3 = __webpack_require__(649);
	
	var _supervisiones4 = _interopRequireDefault(_supervisiones3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ListaSupervisionesComponent = {
	  bindings: {
	    proyecto: '<'
	  },
	  controller: _supervisiones2.default,
	  template: _supervisiones4.default
	};
	
	exports.default = ListaSupervisionesComponent;

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _supervisionesModal = __webpack_require__(448);
	
	var _supervisionesModal2 = _interopRequireDefault(_supervisionesModal);
	
	var _supervisionesModal3 = __webpack_require__(650);
	
	var _supervisionesModal4 = _interopRequireDefault(_supervisionesModal3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ListaSupervisionesController = function () {
	  ListaSupervisionesController.$inject = ["Storage", "DataService", "DataTable", "$state", "_", "Modal"];
	  function ListaSupervisionesController(Storage, DataService, DataTable, $state, _, Modal) {
	    'ngInject';
	
	    _classCallCheck(this, ListaSupervisionesController);
	
	    this.Storage = Storage;
	    this.DataService = DataService;
	    this.DataTable = DataTable;
	    this.$state = $state;
	    this._ = _;
	    this.Modal = Modal;
	  }
	
	  _createClass(ListaSupervisionesController, [{
	    key: '$onInit',
	    value: function $onInit() {}
	  }, {
	    key: 'verSupervisiones',
	    value: function verSupervisiones() {
	      this.Modal.show({
	        template: _supervisionesModal4.default,
	        controller: _supervisionesModal2.default,
	        data: this.proyecto,
	        size: 'lg'
	      });
	    }
	  }]);
	
	  return ListaSupervisionesController;
	}();
	
	exports.default = ListaSupervisionesController;

/***/ }),
/* 448 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var NuevaAdjudicacionModalController = function () {
	  NuevaAdjudicacionModalController.$inject = ["$uibModalInstance", "Storage", "data", "apiUrl", "$state"];
	  function NuevaAdjudicacionModalController($uibModalInstance, Storage, data, apiUrl, $state) {
	    'ngInject';
	
	    _classCallCheck(this, NuevaAdjudicacionModalController);
	
	    this.$uibModalInstance = $uibModalInstance;
	    this.Storage = Storage;
	    this.apiUrl = apiUrl;
	    this.$state = $state;
	    this.proyecto = data;
	  }
	
	  _createClass(NuevaAdjudicacionModalController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.asignarDatosDescarga();
	    }
	  }, {
	    key: 'asignarDatosDescarga',
	    value: function asignarDatosDescarga() {
	      var _this = this;
	
	      this.proyecto.supervisiones.map(function (supervision) {
	        supervision.urlPlanillaDescarga = _this.apiUrl + 'proyectos/' + _this.proyecto.id_proyecto + '/doc/PA_' + supervision.nro_supervision + '/descargar';
	        supervision.nombrePlanillaDescarga = 'Planilla de avance nro ' + supervision.nro_supervision;
	        supervision.urlComputosDescarga = _this.apiUrl + 'proyectos/' + _this.proyecto.id_proyecto + '/doc/CMR_' + supervision.nro_supervision + '/descargar';
	        supervision.nombreComputosDescarga = 'Resumen de computos metricos planilla_' + supervision.nro_supervision;
	        supervision.urlFormulario2 = _this.apiUrl + 'proyectos/' + _this.proyecto.id_proyecto + '/doc/F2_' + supervision.nro_supervision + '/descargar';
	        supervision.nombreFormulario2 = 'Formulario 2 - Nro ' + supervision.nro_supervision;
	        supervision.urlFormulario4 = _this.apiUrl + 'proyectos/' + _this.proyecto.id_proyecto + '/doc/F4_' + supervision.nro_supervision + '/descargar';
	        supervision.nombreFormulario4 = 'Formulario 4 - Nro ' + supervision.nro_supervision;
	        supervision.urlFormulario6 = _this.apiUrl + 'proyectos/' + _this.proyecto.id_proyecto + '/doc/F6_' + supervision.nro_supervision + '/descargar';
	        supervision.nombreFormulario6 = 'Formulario 6 - Nro ' + supervision.nro_supervision;
	      });
	    }
	  }, {
	    key: 'irAPlanilla',
	    value: function irAPlanilla(supervision) {
	      this.$state.go('planilla-proyecto', { idSupervision: supervision.id_supervision });
	      this.$uibModalInstance.close(false);
	    }
	  }, {
	    key: 'cerrar',
	    value: function cerrar() {
	      this.$uibModalInstance.close(false);
	    }
	  }]);
	
	  return NuevaAdjudicacionModalController;
	}();
	
	exports.default = NuevaAdjudicacionModalController;

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _asignacionResponsable = __webpack_require__(450);
	
	var _asignacionResponsable2 = _interopRequireDefault(_asignacionResponsable);
	
	var _asignacionResponsable3 = __webpack_require__(651);
	
	var _asignacionResponsable4 = _interopRequireDefault(_asignacionResponsable3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AsignacionResponsable = {
	  bindings: {
	    proyecto: '=',
	    modoVista: '<'
	  },
	  controller: _asignacionResponsable2.default,
	  template: _asignacionResponsable4.default
	};
	
	exports.default = AsignacionResponsable;

/***/ }),
/* 450 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AsignacionResponsable = function () {
	  AsignacionResponsable.$inject = ["DataService", "Util", "Proyecto"];
	  function AsignacionResponsable(DataService, Util, Proyecto) {
	    'ngInject';
	
	    _classCallCheck(this, AsignacionResponsable);
	
	    this.DataService = DataService;
	    this.Util = Util;
	    this.Proyecto = Proyecto;
	  }
	
	  _createClass(AsignacionResponsable, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.DataService.get('proyectos/' + this.proyecto.id_proyecto + '/usuarios').then(function (response) {
	        if (response) {
	          _this.usuariosParaAsignar = [];
	          for (var i in response.datos) {
	            response.datos[i].nombre = response.datos[i].nombre + ' (' + response.datos[i].rol_nombre + ')';
	            _this.usuariosParaAsignar.push(response.datos[i]);
	          }
	        }
	      });
	    }
	  }, {
	    key: 'seleccionado',
	    value: function seleccionado() {
	      this.proyecto.fid_usuario_asignado = this.usuario_asignado.id_usuario || null;
	      this.proyecto.fid_usuario_asignado_rol = this.usuario_asignado.id_rol || null;
	    }
	  }]);
	
	  return AsignacionResponsable;
	}();
	
	exports.default = AsignacionResponsable;

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _autoridadBeneficiaria = __webpack_require__(452);
	
	var _autoridadBeneficiaria2 = _interopRequireDefault(_autoridadBeneficiaria);
	
	var _autoridadBeneficiaria3 = __webpack_require__(652);
	
	var _autoridadBeneficiaria4 = _interopRequireDefault(_autoridadBeneficiaria3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AutoridadBeneficiariaComponent = {
	  bindings: {
	    proyecto: '=',
	    modoVista: '<'
	  },
	  controller: _autoridadBeneficiaria2.default,
	  template: _autoridadBeneficiaria4.default
	};
	
	exports.default = AutoridadBeneficiariaComponent;

/***/ }),
/* 452 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AutoridadBeneficiariaController = function () {
	  AutoridadBeneficiariaController.$inject = ["DataService", "Util", "Proyecto", "Message"];
	  function AutoridadBeneficiariaController(DataService, Util, Proyecto, Message) {
	    'ngInject';
	
	    _classCallCheck(this, AutoridadBeneficiariaController);
	
	    this.DataService = DataService;
	    this.Util = Util;
	    this.Proyecto = Proyecto;
	    this.Message = Message;
	  }
	
	  _createClass(AutoridadBeneficiariaController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.config = {
	        autoridad: false,
	        modificar: false
	      };
	
	      if (this.Util.isEmpty(this.proyecto.autoridad_beneficiaria)) {
	        this.proyecto.autoridad_beneficiaria = {};
	      }
	    }
	  }, {
	    key: '$doCheck',
	    value: function $doCheck() {
	      if (this.proyecto) {
	        if (!this.config.autoridad && this.proyecto.autoridad_beneficiaria && this.proyecto.autoridad_beneficiaria.numero_documento) {
	          this.proyecto.autoridad_beneficiaria.cargo = this.proyecto.cargo_autoridad_beneficiaria;
	          this.proyecto.autoridad_beneficiaria.fax = this.proyecto.fax_autoridad_beneficiaria;
	          this.config.autoridad = angular.copy(this.proyecto.autoridad_beneficiaria);
	          this.config.autoridad.id_persona = this.proyecto.fid_autoridad_beneficiaria;
	        }
	      }
	    }
	  }, {
	    key: 'modificarUsuarioGAM',
	    value: function modificarUsuarioGAM() {
	      this.modoVista = false;
	      this.config.modificar = true;
	    }
	  }, {
	    key: 'modificarCancelado',
	    value: function modificarCancelado() {
	      this.modoVista = true;
	      this.config.modificar = false;
	      this.proyecto.autoridad_beneficiaria = angular.copy(this.config.autoridad);
	      this.proyecto.cargo_autoridad_beneficiaria = this.config.autoridad.cargo;
	      this.proyecto.fax_autoridad_beneficiaria = this.config.autoridad.fax;
	    }
	  }, {
	    key: 'GuardarUsuarioGAM',
	    value: function GuardarUsuarioGAM() {
	      var _this = this;
	
	      var datos = angular.copy(this.proyecto.autoridad_beneficiaria);
	      datos.cargo = this.proyecto.cargo_autoridad_beneficiaria;
	      datos.fax = this.proyecto.fax_autoridad_beneficiaria;
	      datos.anterior = this.config.autoridad;
	      this.DataService.put('proyectos/' + this.proyecto.id_proyecto + '/autoridad_beneficiaria', datos).then(function (resp) {
	        if (resp && resp.finalizado) {
	          _this.Message.success(resp.mensaje);
	          _this.modoVista = true;
	          _this.config.modificar = false;
	        }
	      });
	    }
	  }]);
	
	  return AutoridadBeneficiariaController;
	}();
	
	exports.default = AutoridadBeneficiariaController;

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _boletaGarantia = __webpack_require__(454);
	
	var _boletaGarantia2 = _interopRequireDefault(_boletaGarantia);
	
	var _boletaGarantia3 = __webpack_require__(653);
	
	var _boletaGarantia4 = _interopRequireDefault(_boletaGarantia3);
	
	__webpack_require__(194);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BoletaGarantiaComponent = {
	  bindings: {
	    proyecto: '=',
	    datos: '=',
	    porcentaje: '=',
	    monto: '=',
	    montoDeuda: '=',
	    tipo: '@',
	    boletas: '=',
	    modoVista: '<'
	  },
	  controller: _boletaGarantia2.default,
	  template: _boletaGarantia4.default
	};
	
	exports.default = BoletaGarantiaComponent;

/***/ }),
/* 454 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BoletaGarantiaController = function () {
	  BoletaGarantiaController.$inject = ["$state", "$scope", "Storage", "Proyecto", "Modal", "Message", "DataService", "Util", "_", "Datetime", "Big"];
	  function BoletaGarantiaController($state, $scope, Storage, Proyecto, Modal, Message, DataService, Util, _, Datetime, Big) {
	    'ngInject';
	
	    _classCallCheck(this, BoletaGarantiaController);
	
	    this.$scope = $scope;
	    this.$state = $state;
	    this.Proyecto = Proyecto;
	    this.Modal = Modal;
	    this.Message = Message;
	    this.DataService = DataService;
	    this.Util = Util;
	    this._ = _;
	    this.Datetime = Datetime;
	    this.mostrarBoletas = false;
	    this.auxBoleta = {};
	    this.completado = false;
	    this.Big = Big;
	
	    this.user = Storage.getUser();
	    this.pModificar = false;
	  }
	
	  _createClass(BoletaGarantiaController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      if (!this.boletas) {
	        this.boletas = [];
	      }
	      if (!this.boletasEx) {
	        this.boletasEx = [];
	      }
	      if (this.proyecto.tipo === 'TP_CIF') {
	        var fechaDesembolso = this.Datetime.getFormatDate(angular.copy(this.proyecto.fecha_desembolso));
	        this.validaciones = {
	          fec_ini_minima: this.Datetime.addDaysToDate(angular.copy(fechaDesembolso), 1),
	          mensaje_fecminima: 'La fecha debe ser mayor a la fecha del desembolso (' + this.Datetime.parseDate(fechaDesembolso, '/') + ')'
	        };
	        this.pModificar = 'RESPONSABLE_MAE' === this.user.rol.nombre && this.modoVista;
	      } else {
	        var fechaConvenio = this.Datetime.getFormatDate(angular.copy(this.proyecto.fecha_suscripcion_convenio));
	        this.validaciones = {
	          fec_ini_minima: this.Datetime.addDaysToDate(angular.copy(fechaConvenio), 1),
	          mensaje_fecminima: 'La fecha debe ser mayor a la fecha del convenio (' + this.Datetime.parseDate(fechaConvenio, '/') + ')'
	        };
	        this.pModificar = 'FINANCIERO_UPRE' === this.user.rol.nombre && this.modoVista;
	      }
	
	      // validaciones para modificar boletas
	      this.validacionesEx = {
	        fec_ini_minima: this.validaciones.fec_ini_minima,
	        mensaje_fecminima: this.validaciones.mensaje_fecminima
	      };
	      if (this.boletas.length == 1) {
	        this.validacionesEx.fec_ini_minima = new Date(this.boletas[0].fecha_fin_validez);
	        this.validacionesEx.mensaje_fecminima = 'La fecha debe ser mayor o igual a la boleta anterior (' + this.Datetime.parseDate(this.validacionesEx.fec_ini_minima, '/') + ')';
	      }
	      if (this.porcentaje) {
	        if (this.Big(this.proyecto.monto_total).mul(this.porcentaje).div(100).toFixed(2) == this.monto) {
	          this.porcentajeCheck = true;
	        } else {
	          if (this.tipo == 'TB_CORRECTA_INVERSION') {
	            this.montoCheck = true;
	          }
	        }
	      }
	      if (!this.montoDeuda) {
	        this.montoDeuda = this.monto;
	      }
	      this.mostrarBoletas = this.monto > 0;
	    }
	  }, {
	    key: '$onChanges',
	    value: function $onChanges() {
	      var _this = this;
	
	      if (this.tipo == 'TB_CUMPLIMIENTO_CONTRATO') {
	        this.$scope.$watch('$ctrl.porcentaje', function () {
	          if (!_this.porcentaje) {
	            _this.monto = null;
	          }
	          _this.verificarValor();
	        });
	      }
	      this.$scope.$watch('$ctrl.boletas', function () {
	        _this.$scope.$emit('actualizarBoletas');
	        _this.verificarMontoTotalAnticipo();
	      }, true);
	      this.$scope.$watch('$ctrl.boletasEx', function () {
	        _this.verificarMontoTotalAnticipo();
	      }, true);
	    }
	  }, {
	    key: 'verificarValor',
	    value: function verificarValor() {
	      this.calcularAnticipo();
	      if (this.porcentaje === 0) {
	        this.boletas = [];
	      }
	      this.mostrarBoletas = this.porcentaje > 0;
	    }
	  }, {
	    key: 'calcularAnticipo',
	    value: function calcularAnticipo() {
	      if (typeof this.porcentaje === 'number' && this.porcentaje <= 20) {
	        this.monto = this.Util.getPorcentaje(this.proyecto.monto_total, this.porcentaje);
	      }
	    }
	  }, {
	    key: 'adicionarBoleta',
	    value: function adicionarBoleta() {
	      this.boletas.push({ tipo_boleta: this.tipo, estado: 'ACTIVO' });
	    }
	  }, {
	    key: 'quitarBoleta',
	    value: function quitarBoleta(indice) {
	      this.boletas.splice(indice, 1);
	    }
	  }, {
	    key: 'invalidarBoleta',
	    value: function invalidarBoleta(indice) {
	      var _this2 = this;
	
	      this.Modal.confirm('\xBFEsta seguro/a de renovar esta boleta?<br>- Esta boleta quedara como parte del historial.<br>- Deber\xE1 agregar una nueva boleta.', function () {
	        var datos = {
	          id_boleta: _this2.boletas[indice].id_boleta,
	          estado: 'INACTIVO'
	        };
	        _this2.DataService.put('proyectos/' + _this2.proyecto.id_proyecto + '/boletas/' + datos.id_boleta + '?rol=' + _this2.user.rol.id_rol, datos).then(function (resp) {
	          if (resp && resp.finalizado) {
	            _this2.Message.success('La boleta fue invalidada correctamente.');
	            _this2.boletas[indice].estado = 'INACTIVO';
	            _this2.boletas[indice].vencida = true;
	            // this.boletas.splice(indice, 1);
	          }
	        });
	      });
	    }
	  }, {
	    key: 'verificarMontoTotalAnticipo',
	    value: function verificarMontoTotalAnticipo() {
	      //this.sumaMontoBoletas = this.boletas.length > 0 ? this._.sum(this._.map(this.boletas, 'monto')) : 0;
	      this.sumaMontoBoletas = 0;
	      for (var i in this.boletas) {
	        if (this.boletas[i].estado == 'ACTIVO') {
	          this.sumaMontoBoletas += parseFloat(this.boletas[i].monto);
	        }
	      }
	      for (var _i in this.boletasEx) {
	        if (parseFloat(this.boletasEx[_i].monto)) {
	          this.sumaMontoBoletas += parseFloat(this.boletasEx[_i].monto);
	        }
	      }
	      this.completado = this.monto ? this.sumaMontoBoletas >= (this.montoDeuda || this.monto) : false;
	      this.incompleto = this.sumaMontoBoletas < (this.montoDeuda || this.monto);
	      if (this.monto) {
	        this.mensaje = {
	          class: this.completado ? 'success' : this.incompleto ? 'warning' : '',
	          mensaje: this.completado ? 'Se completó el monto' : this.incompleto ? 'Debe completar el monto' : '',
	          icono: this.completado ? 'check' : this.incompleto ? 'warning' : ''
	        };
	      }
	    }
	
	    // Boletas extras
	
	  }, {
	    key: 'adicionarBoletaEx',
	    value: function adicionarBoletaEx() {
	      this.boletasEx.push({ tipo_boleta: this.tipo, estado: 'ACTIVO' });
	    }
	  }, {
	    key: 'quitarBoletaEx',
	    value: function quitarBoletaEx(indice) {
	      this.boletasEx.splice(indice, 1);
	    }
	  }, {
	    key: 'enviarBoletaEx',
	    value: function enviarBoletaEx() {
	      var _this3 = this;
	
	      if (this.sumaMontoBoletas < (this.montoDeuda || this.monto)) {
	        this.Message.warning('La suma de los montos de las boletas debe ser mayor o igual al monto de cumplimiento de contrato y/o anticipo.');
	        return;
	      }
	      this.Modal.confirm('\xBFEsta seguro/a de agregar las boletas?', function () {
	        _this3.DataService.post('boletas/proyecto/' + _this3.proyecto.id_proyecto + '?rol=' + _this3.user.rol.id_rol, { boletas: _this3.boletasEx, montoDeuda: _this3.montoDeuda }).then(function (resp) {
	          if (resp && resp.finalizado) {
	            _this3.Message.success('Boleta(s) agregadas correctamente.');
	            _this3.$state.reload();
	          }
	        });
	      });
	    }
	  }, {
	    key: 'editarPorcentaje',
	    value: function editarPorcentaje() {
	      // this.porcentajeCheck = true;
	      if (this.porcentajeCheck) this.montoCheck = !this.porcentajeCheck;
	    }
	  }, {
	    key: 'cambiarPorcentaje',
	    value: function cambiarPorcentaje() {
	      var _this4 = this;
	
	      if (this.tipo == 'TB_CORRECTA_INVERSION') {
	        if (typeof this.porcentaje === 'number' && this.porcentaje <= 20) {
	          this.monto = this.Util.getPorcentaje(this.proyecto.monto_total, this.porcentaje);
	        } else {
	          this.Message.warning('El porcentaje no puede ser mayor a 20%');
	          return;
	        }
	        var datos = {
	          porcentaje_anticipo: this.porcentaje,
	          anticipo: this.monto
	        };
	        // this.porcentajeCheck = false;
	        this.DataService.put('proyectos/' + this.proyecto.id_proyecto + '?rol=' + this.user.rol.id_rol, datos).then(function (resp) {
	          resp;
	          _this4.montoDeuda = _this4.monto;
	          _this4.mostrarBoletas = _this4.porcentaje > 0;
	        });
	      }
	    }
	  }, {
	    key: 'editarMonto',
	    value: function editarMonto() {
	      // this.montoCheck = true;
	      if (this.montoCheck) this.porcentajeCheck = !this.montoCheck;
	    }
	  }, {
	    key: 'cambiarMonto',
	    value: function cambiarMonto() {
	      var _this5 = this;
	
	      if (this.tipo == 'TB_CORRECTA_INVERSION') {
	        if (typeof this.monto === 'number' && this.monto <= this.Big(this.proyecto.monto_total).mul(0.2).toFixed(2)) {
	          this.porcentaje = this.Big(this.monto).div(this.proyecto.monto_total).mul(100).toFixed(2);
	        } else {
	          this.Message.warning('El monto no puede ser mayor a 20%');
	          this.porcentaje = this.Big(this.monto).div(this.proyecto.monto_total).mul(100).toFixed(2);
	          this.monto = this.proyecto.anticipo;
	          return;
	        }
	        var datos = {
	          porcentaje_anticipo: this.porcentaje,
	          anticipo: this.monto
	        };
	        // this.montoCheck = false;
	        this.DataService.put('proyectos/' + this.proyecto.id_proyecto + '?rol=' + this.user.rol.id_rol, datos).then(function (resp) {
	          resp;
	          _this5.montoDeuda = _this5.monto;
	          _this5.mostrarBoletas = _this5.monto > 0;
	        });
	      }
	    }
	  }, {
	    key: 'cambiarMontoDeuda',
	    value: function cambiarMontoDeuda(monto) {
	      var _this6 = this;
	
	      if (!monto) monto = null;
	      if (this.tipo) {
	        var datos = {
	          tipo_boleta: this.tipo,
	          montoDeuda: monto
	        };
	        this.DataService.post('boletas/proyecto/' + this.proyecto.id_proyecto + '?rol=' + this.user.rol.id_rol, datos).then(function (resp) {
	          if (resp && resp.finalizado) {
	            _this6.verificarMontoTotalAnticipo();
	            _this6.Message.success('Monto modificado.');
	          }
	        });
	      }
	    }
	  }]);
	
	  return BoletaGarantiaController;
	}();
	
	exports.default = BoletaGarantiaController;

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _boleta = __webpack_require__(456);
	
	var _boleta2 = _interopRequireDefault(_boleta);
	
	var _boleta3 = __webpack_require__(654);
	
	var _boleta4 = _interopRequireDefault(_boleta3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BoletaComponent = {
	  bindings: {
	    model: '=',
	    indice: '<',
	    validaciones: '<',
	    tipoBoleta: '<',
	    modoVista: '<',
	    bid: '<'
	  },
	  controller: _boleta2.default,
	  template: _boleta4.default
	};
	
	exports.default = BoletaComponent;

/***/ }),
/* 456 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BoletaController = function () {
	  BoletaController.$inject = ["$scope", "Proyecto", "Modal", "Util"];
	  function BoletaController($scope, Proyecto, Modal, Util) {
	    'ngInject';
	
	    _classCallCheck(this, BoletaController);
	
	    this.$scope = $scope;
	    this.Proyecto = Proyecto;
	    this.Modal = Modal;
	    this.Util = Util;
	    this.mostrarBoletas = false;
	  }
	
	  _createClass(BoletaController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.tiposDocumento = [{ codigo: 'BOLETA', nombre: 'Boleta' }, { codigo: 'POLIZA', nombre: 'Póliza' }, { codigo: 'RETENCION', nombre: 'Retención' }];
	
	      this.opcionesFechaInicio = {
	        maxDateKey: 'fecha_fin_validez'
	      };
	
	      this.opcionesFechaFin = {
	        minDateKey: 'fecha_inicio_validez'
	      };
	      if (this.model.doc_boleta && this.Proyecto && this.Proyecto.proyectoOrigen) {
	        var id = this.Proyecto.proyectoOrigen.id_proyecto;
	        var cod = this.model.doc_boleta.substr(1, this.model.doc_boleta.indexOf(']') - 1);
	        this.model.urlDocBoleta = id ? 'proyectos/' + id + '/doc/' + cod : '';
	        this.model.urlDocBoletaDescarga = id ? 'proyectos/' + id + '/doc/' + cod + '/descargar' : '';
	      }
	    }
	  }]);
	
	  return BoletaController;
	}();
	
	exports.default = BoletaController;

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _datosGenerales = __webpack_require__(462);
	
	var _datosGenerales2 = _interopRequireDefault(_datosGenerales);
	
	var _convenio = __webpack_require__(460);
	
	var _convenio2 = _interopRequireDefault(_convenio);
	
	var _asignacionResponsable = __webpack_require__(449);
	
	var _asignacionResponsable2 = _interopRequireDefault(_asignacionResponsable);
	
	var _desembolso = __webpack_require__(466);
	
	var _desembolso2 = _interopRequireDefault(_desembolso);
	
	var _autoridadBeneficiaria = __webpack_require__(451);
	
	var _autoridadBeneficiaria2 = _interopRequireDefault(_autoridadBeneficiaria);
	
	var _items = __webpack_require__(476);
	
	var _items2 = _interopRequireDefault(_items);
	
	var _ejecutarTransicion = __webpack_require__(468);
	
	var _ejecutarTransicion2 = _interopRequireDefault(_ejecutarTransicion);
	
	var _dbc = __webpack_require__(464);
	
	var _dbc2 = _interopRequireDefault(_dbc);
	
	var _garantia = __webpack_require__(474);
	
	var _garantia2 = _interopRequireDefault(_garantia);
	
	var _contrato = __webpack_require__(458);
	
	var _contrato2 = _interopRequireDefault(_contrato);
	
	var _boletaGarantia = __webpack_require__(453);
	
	var _boletaGarantia2 = _interopRequireDefault(_boletaGarantia);
	
	var _boleta = __webpack_require__(455);
	
	var _boleta2 = _interopRequireDefault(_boleta);
	
	var _equipoTecnico = __webpack_require__(471);
	
	var _equipoTecnico2 = _interopRequireDefault(_equipoTecnico);
	
	var _ordenProceder = __webpack_require__(480);
	
	var _ordenProceder2 = _interopRequireDefault(_ordenProceder);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ComponentsProyectos = angular.module('app.cforms', []).component('datosGenerales', _datosGenerales2.default).component('convenio', _convenio2.default).component('asignacionResponsable', _asignacionResponsable2.default).component('desembolso', _desembolso2.default).component('autoridadBeneficiaria', _autoridadBeneficiaria2.default).component('items', _items2.default).component('ejecutarTransicion', _ejecutarTransicion2.default).component('dbc', _dbc2.default).component('contrato', _contrato2.default).component('garantia', _garantia2.default).component('boletaGarantia', _boletaGarantia2.default).component('boleta', _boleta2.default).component('equipoTecnico', _equipoTecnico2.default).component('ordenProceder', _ordenProceder2.default).name;
	
	exports.default = ComponentsProyectos;

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _contrato = __webpack_require__(459);
	
	var _contrato2 = _interopRequireDefault(_contrato);
	
	var _contrato3 = __webpack_require__(655);
	
	var _contrato4 = _interopRequireDefault(_contrato3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContratoComponent = {
	  bindings: {
	    proyecto: '=',
	    modoVista: '<'
	  },
	  controller: _contrato2.default,
	  template: _contrato4.default
	};
	
	exports.default = ContratoComponent;

/***/ }),
/* 459 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ContratoController = function () {
	  ContratoController.$inject = ["DataService", "_", "$log", "Modal", "apiUrl", "Proyecto"];
	  function ContratoController(DataService, _, $log, Modal, apiUrl, Proyecto) {
	    'ngInject';
	
	    _classCallCheck(this, ContratoController);
	
	    this.DataService = DataService;
	    this._ = _;
	    this.$log = $log;
	    this.Modal = Modal;
	    this.apiUrl = apiUrl;
	    this.Proyecto = Proyecto;
	  }
	
	  _createClass(ContratoController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.prepararLista();
	      this.documentos = this.getConfiguracion();
	    }
	  }, {
	    key: 'getConfiguracion',
	    value: function getConfiguracion() {
	      var _this = this;
	
	      return {
	        lista: [{
	          codigo: 'doc_contrato',
	          nombre: 'Contrato',
	          nombre_formulario: 'Contrato',
	          tipo: 'DCONT',
	          urlDescarga: this.apiUrl + 'proyectos/' + this.proyecto.id_proyecto + '/doc/DCONT/descargar'
	        }],
	        uploadCallback: function uploadCallback(file) {
	          var data = {
	            documento: angular.copy(file)
	          };
	          _this.DataService.put('proyectos/' + _this.proyecto.id_proyecto + '/doc/' + _this.getTipo(file) + '/subir', data).then(function (response) {
	            if (response && response.finalizado) {
	              _this.asignarDatos(file, response.datos.documento);
	            }
	          });
	        }
	      };
	    }
	  }, {
	    key: 'verificarArchivosCargados',
	    value: function verificarArchivosCargados() {
	      var _this2 = this;
	
	      this.documentos.lista.map(function (documento) {
	        var FORMULARIO = _this2.getFormularioRegistrado(documento);
	        if (FORMULARIO) {
	          documento.registrado = true;
	          documento.nombre_archivo = FORMULARIO.nombre_archivo;
	        }
	      });
	    }
	  }, {
	    key: 'prepararLista',
	    value: function prepararLista() {
	      var _this3 = this;
	
	      if (this.proyecto.formularios) {
	        this.asignarPath();
	      } else {
	        this.DataService.get('proyectos/' + this.proyecto.id_proyecto + '/doc').then(function (result) {
	          if (result && result.finalizado) {
	            _this3.proyecto.formularios = result.datos.formularios;
	            _this3.asignarPath();
	            _this3.verificarArchivosCargados();
	          }
	        });
	      }
	    }
	  }, {
	    key: 'asignarPath',
	    value: function asignarPath() {
	      var _this4 = this;
	
	      this.proyecto.formularios.map(function (formulario) {
	        formulario.path = _this4.apiUrl + 'proyectos/' + _this4.proyecto.id_proyecto + '/doc/' + formulario.codigo_documento + '/descargar';
	      });
	    }
	  }, {
	    key: 'asignarDatos',
	    value: function asignarDatos(archivo, docCreado) {
	      var index = this._.findIndex(this.documentos.lista, { codigo: archivo.name });
	      this.documentos.lista[index].base64 = archivo.base64;
	      this.documentos.lista[index].nombre_formulario = docCreado.nombre;
	      this.documentos.lista[index].nombre_archivo = docCreado.nombre_archivo;
	      this.documentos.lista[index].registrado = true;
	      var formulario = this.getFormularioRegistrado(docCreado);
	      if (!formulario) {
	        if (!this.proyecto.formularios) {
	          this.proyecto.formularios = [];
	        }
	        this.proyecto.formularios.push(docCreado);
	      } else {
	        formulario = docCreado;
	      }
	    }
	  }, {
	    key: 'getFormularioRegistrado',
	    value: function getFormularioRegistrado(documento) {
	      return this._.find(this.proyecto.formularios, { codigo_documento: documento.tipo });
	    }
	  }, {
	    key: 'cambiar',
	    value: function cambiar(documento) {
	      if (documento.registrado) {
	        this.Modal.confirm('\xBFEst\xE1 seguro/a de cambiar el ' + documento.nombre + '?', function () {
	          documento.registrado = false;
	        }, null, null, 'Si, estoy seguro', 'Cancelar');
	      }
	    }
	  }, {
	    key: 'verDocumento',
	    value: function verDocumento(documento) {
	      var URL = 'proyectos/' + this.proyecto.id_proyecto + '/doc/' + documento.tipo;
	      this.Modal.showDocumentBase64(URL, '' + documento.nombre);
	    }
	  }, {
	    key: 'getTipo',
	    value: function getTipo(archivo) {
	      return this._.find(this.documentos.lista, { codigo: archivo.name }).tipo;
	    }
	  }]);
	
	  return ContratoController;
	}();
	
	exports.default = ContratoController;

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _convenio = __webpack_require__(461);
	
	var _convenio2 = _interopRequireDefault(_convenio);
	
	var _convenio3 = __webpack_require__(656);
	
	var _convenio4 = _interopRequireDefault(_convenio3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ConvenioComponent = {
	  bindings: {
	    proyecto: '=',
	    modoVista: '<'
	  },
	  controller: _convenio2.default,
	  template: _convenio4.default
	};
	
	exports.default = ConvenioComponent;

/***/ }),
/* 461 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DatosGenerales = function () {
	  DatosGenerales.$inject = ["$scope", "Util", "Proyecto", "Modal", "_"];
	  function DatosGenerales($scope, Util, Proyecto, Modal, _) {
	    'ngInject';
	
	    _classCallCheck(this, DatosGenerales);
	
	    this.$scope = $scope;
	    this.Util = Util;
	    this.Proyecto = Proyecto;
	    this.Modal = Modal;
	    this._ = _;
	    this.archivos = null;
	  }
	
	  _createClass(DatosGenerales, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.archivos = {
	        urlDocConvenio: this.proyecto ? 'proyectos/' + this.proyecto.id_proyecto + '/doc/C' : '',
	        urlDocConvenioDescarga: this.proyecto ? 'proyectos/' + this.proyecto.id_proyecto + '/doc/C/descargar' : '',
	        urlDocResolucion: this.proyecto ? 'proyectos/' + this.proyecto.id_proyecto + '/doc/RM' : '',
	        urlDocResolucionDescarga: this.proyecto ? 'proyectos/' + this.proyecto.id_proyecto + '/doc/RM/descargar' : ''
	      };
	      this.mostrar = true;
	    }
	  }, {
	    key: '$onChanges',
	    value: function $onChanges() {
	      var _this = this;
	
	      this.$scope.$watch('$ctrl.proyecto.monto_upre', function () {
	        if (!_this.proyecto) {
	          return;
	        }
	        _this.calcularMontoConvenio();
	      });
	      this.$scope.$watch('$ctrl.proyecto.monto_contraparte', function () {
	        if (!_this.proyecto) {
	          return;
	        }
	        _this.calcularMontoConvenio();
	      });
	    }
	  }, {
	    key: 'calcularMontoConvenio',
	    value: function calcularMontoConvenio() {
	      this.proyecto.monto_total_convenio = this.Util.redondear((this.proyecto.monto_upre ? this.proyecto.monto_upre : 0) + (this.proyecto.monto_contraparte ? this.proyecto.monto_contraparte : 0));
	    }
	  }]);
	
	  return DatosGenerales;
	}();
	
	exports.default = DatosGenerales;

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _datosGenerales = __webpack_require__(463);
	
	var _datosGenerales2 = _interopRequireDefault(_datosGenerales);
	
	var _datosGenerales3 = __webpack_require__(657);
	
	var _datosGenerales4 = _interopRequireDefault(_datosGenerales3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DatosGenerales = {
	  bindings: {
	    proyecto: '=',
	    modoVista: '<'
	  },
	  controller: _datosGenerales2.default,
	  template: _datosGenerales4.default
	};
	
	exports.default = DatosGenerales;

/***/ }),
/* 463 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DatosGenerales = function () {
	  DatosGenerales.$inject = ["DataService", "Util", "Proyecto", "Modal", "_"];
	  function DatosGenerales(DataService, Util, Proyecto, Modal, _) {
	    'ngInject';
	
	    _classCallCheck(this, DatosGenerales);
	
	    this.DataService = DataService;
	    this.Util = Util;
	    this.Proyecto = Proyecto;
	    this.Modal = Modal;
	    this._ = _;
	  }
	
	  _createClass(DatosGenerales, [{
	    key: '$onInit',
	    value: function $onInit() {}
	  }, {
	    key: 'verDocumento',
	    value: function verDocumento(tipo, nombreDocumento) {
	      this.Modal.showDocumentBase64('proyectos/' + this.proyecto.id_proyecto + '/documentos/' + tipo, nombreDocumento);
	    }
	  }]);
	
	  return DatosGenerales;
	}();
	
	exports.default = DatosGenerales;

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _dbc = __webpack_require__(465);
	
	var _dbc2 = _interopRequireDefault(_dbc);
	
	var _dbc3 = __webpack_require__(658);
	
	var _dbc4 = _interopRequireDefault(_dbc3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dbcComponent = {
	  bindings: {
	    proyecto: '=',
	    modoVista: '<'
	  },
	  controller: _dbc2.default,
	  template: _dbc4.default
	};
	
	exports.default = dbcComponent;

/***/ }),
/* 465 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DbcController = function () {
	  DbcController.$inject = ["Util", "Proyecto", "Modal"];
	  function DbcController(Util, Proyecto, Modal) {
	    'ngInject';
	
	    _classCallCheck(this, DbcController);
	
	    this.Util = Util;
	    this.Proyecto = Proyecto;
	    this.Modal = Modal;
	  }
	
	  _createClass(DbcController, [{
	    key: '$onInit',
	    value: function $onInit() {}
	  }, {
	    key: 'verDocumento',
	    value: function verDocumento() {
	      this.Modal.showDocumentBase64('proyectos/' + this.proyecto.id_proyecto + '/doc/DBC', 'Especificaci\xF3n T\xE9cnica de Contrataci\xF3n');
	    }
	  }, {
	    key: 'estaRegistrado',
	    value: function estaRegistrado() {
	      return typeof this.proyecto.doc_base_contratacion === 'string';
	    }
	  }]);
	
	  return DbcController;
	}();
	
	exports.default = DbcController;

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _desembolso = __webpack_require__(467);
	
	var _desembolso2 = _interopRequireDefault(_desembolso);
	
	var _desembolso3 = __webpack_require__(659);
	
	var _desembolso4 = _interopRequireDefault(_desembolso3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DesembolsoComponent = {
	  bindings: {
	    proyecto: '=',
	    modoVista: '<'
	  },
	  controller: _desembolso2.default,
	  template: _desembolso4.default
	};
	
	exports.default = DesembolsoComponent;

/***/ }),
/* 467 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DesembolsoController = function () {
	  DesembolsoController.$inject = ["Proyecto", "Modal", "Util", "Datetime"];
	  function DesembolsoController(Proyecto, Modal, Util, Datetime) {
	    'ngInject';
	
	    _classCallCheck(this, DesembolsoController);
	
	    this.Proyecto = Proyecto;
	    this.Modal = Modal;
	    this.Util = Util;
	    this.Datetime = Datetime;
	  }
	
	  _createClass(DesembolsoController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.archivo = {
	        urlDocCertificacion: this.proyecto ? 'proyectos/' + this.proyecto.id_proyecto + '/doc/CIP' : '',
	        urlDocCertificacionDescarga: this.proyecto ? 'proyectos/' + this.proyecto.id_proyecto + '/doc/CIP/descargar' : ''
	      };
	      var fechaConvenio = this.Datetime.getFormatDate(this.proyecto.fecha_suscripcion_convenio);
	      this.validacion = {
	        fecha_minima: this.Datetime.addDaysToDate(angular.copy(fechaConvenio), 1),
	        mensaje_fecminima: 'La fecha debe ser mayor a la fecha del convenio (' + this.Datetime.parseDate(fechaConvenio, '/') + ')'
	      };
	    }
	  }]);
	
	  return DesembolsoController;
	}();
	
	exports.default = DesembolsoController;

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ejecutarTransicion = __webpack_require__(469);
	
	var _ejecutarTransicion2 = _interopRequireDefault(_ejecutarTransicion);
	
	var _ejecutarTransicion3 = __webpack_require__(660);
	
	var _ejecutarTransicion4 = _interopRequireDefault(_ejecutarTransicion3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EjecutarTransicion = {
	  bindings: {
	    proyecto: '=',
	    supervision: '=',
	    elemento: '=',
	    servicio: '<', // servicio del elemento (Proyecto/Computo)
	    form: '<',
	    atributoEstado: '@',
	    url: '<',
	    opcionCancelar: '<?',
	    confirmar: '<?',
	    mensajeConfirmacion: '@?',
	    mensajeButton: '<?', // objeto de mensajes segun label del boton.
	    metodoPrevio: '&?',
	    metodoPosterior: '@?', // debe ser un string ya que se usará $emit
	    validacionParalela: '&?' // metodo que permite realizar una validacion paralela en el componente origen conjuntamente la directiva "validarFormulario"
	  },
	  controller: _ejecutarTransicion2.default,
	  template: _ejecutarTransicion4.default
	};
	
	exports.default = EjecutarTransicion;

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _observacionModalController = __webpack_require__(470);
	
	var _observacionModalController2 = _interopRequireDefault(_observacionModalController);
	
	var _observacionModal = __webpack_require__(661);
	
	var _observacionModal2 = _interopRequireDefault(_observacionModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EjecutarTransicion = function () {
	  EjecutarTransicion.$inject = ["DataService", "Util", "Proyecto", "$state", "Modal", "Loading", "Message", "$scope", "_", "Storage", "$q", "$log", "Computo"];
	  function EjecutarTransicion(DataService, Util, Proyecto, $state, Modal, Loading, Message, $scope, _, Storage, $q, $log, Computo) {
	    'ngInject';
	
	    _classCallCheck(this, EjecutarTransicion);
	
	    this.DataService = DataService;
	    this.Util = Util;
	    this.Proyecto = Proyecto;
	    this.$state = $state;
	    this.Modal = Modal;
	    this.Loading = Loading;
	    this.Message = Message;
	    this.$scope = $scope;
	    this._ = _;
	    this.Storage = Storage;
	    this.$q = $q;
	    this.$log = $log;
	    this.Computo = Computo;
	    this.usuario = this.Storage.getUser();
	  }
	
	  _createClass(EjecutarTransicion, [{
	    key: '$onInit',
	    value: function $onInit() {}
	  }, {
	    key: 'getRolUsuario',
	    value: function getRolUsuario() {
	      return this.usuario.rol.id_rol;
	    }
	  }, {
	    key: 'puedeAcceder',
	    value: function puedeAcceder() {
	      if (!this.elemento || !this.elemento.estado_actual || !this.elemento.estado_actual.roles) {
	        return;
	      }
	      return this.elemento.estado_actual.roles.indexOf(this.getRolUsuario()) !== -1;
	    }
	
	    /**
	     * ejecutarAccion - Ejecuta la transición para un elemento, verifica si previa a la ejecución
	     * se debe registrar una observación o simplemente realizar un guardado (sin pasar a un siguiente estado)
	     * o en todo caso si existe un método previo a ejeutar (obtenido del controlador de donde se llama a este componente)
	     * se ejecuta el mismo para luego proceder a ejecutar la transición
	     *
	     * @param  {object} accion Objeto donde se tiene los detalles de la acción a ejecutar
	     * @return {function}        Devuelve el método a ejecutar
	     */
	
	  }, {
	    key: 'ejecutarAccion',
	    value: function ejecutarAccion(accion) {
	      var _this = this;
	
	      this.$log.log('ACCION====>', accion);
	      this.$log.log('METODO PREVIO====>', this.metodoPrevio);
	      if (accion.observacion) {
	        return this.registrarObservacion(accion);
	      }
	      if (accion.guardar) {
	        return this.guardarDatos();
	      }
	      if (!this.metodoPrevio) {
	        return this.ejecutarTransicion(accion);
	      } else {
	        this.metodoPrevio({ accion: accion }).then(function (result) {
	          _this.confirmar = result && result.confirmar ? result.confirmar : false;
	          return _this.ejecutarTransicion(accion);
	        }).catch(function () {});
	      }
	    }
	  }, {
	    key: 'registrarObservacion',
	    value: function registrarObservacion(accion) {
	      var _this2 = this;
	
	      var modalObservacion = this.Modal.show({
	        template: _observacionModal2.default,
	        controller: _observacionModalController2.default,
	        data: this.elemento,
	        size: 'md'
	      });
	
	      modalObservacion.result.then(function (elementoActualizado) {
	        _this2.elemento = elementoActualizado;
	        return _this2.ejecutarTransicion(accion);
	      }).catch(function () {});
	    }
	  }, {
	    key: 'ejecutarTransicion',
	    value: function ejecutarTransicion(accion) {
	      var DATOS = {};
	      DATOS[this.atributoEstado] = accion.estado;
	      var registrar = this.registrarTransicion.bind(this, DATOS, null, null, this.volverABandeja.bind(this));
	      if (this.confirmar && !accion.observacion) {
	        return this.confirmacionPrevia(registrar, accion);
	      }
	      return registrar();
	    }
	  }, {
	    key: 'confirmacionPrevia',
	    value: function confirmacionPrevia(callback, accion) {
	      var mensaje = this.mensajeConfirmacion || '\xBFEst\xE1 seguro/a de derivar el proceso a la siguiente instancia?';
	      if (this.mensajeButton && this.mensajeButton[accion.label]) {
	        mensaje = this.mensajeButton[accion.label];
	      }
	      this.Modal.confirm(mensaje, function () {
	        return callback();
	      }, null, 'Confirmar envío', 'Si, estoy seguro/a', 'Cancelar');
	    }
	  }, {
	    key: 'registrarTransicion',
	    value: function registrarTransicion(data, mensajeLoading, mensajeExito, metodoPosterior) {
	      var _this3 = this;
	
	      this.Loading.show(mensajeLoading || 'Derivando', true);
	      var DATOS = angular.merge(this.servicio.getDatosSegunEstado(this.elemento, this.form), data || {});
	      DATOS.rol = this.usuario.rol.id_rol;
	      this.DataService.put('' + this.url, DATOS).then(function (response) {
	        _this3.Loading.hide();
	        if (response) {
	          _this3.Message.success(mensajeExito || response.mensaje || 'Se envió el proceso a la siguiente instancia correctamente.');
	          if (_this3.metodoPosterior) {
	            _this3.$scope.$emit(_this3.metodoPosterior);
	          } else if (metodoPosterior) {
	            return metodoPosterior(response.datos);
	          }
	        }
	      });
	    }
	  }, {
	    key: 'guardarDatos',
	    value: function guardarDatos() {
	      var _this4 = this;
	
	      delete this.elemento[this.atributoEstado];
	      return this.registrarTransicion(null, 'Guardando datos', 'Se guardó los datos', function () {
	        _this4.actualizarDatosElemento.bind(_this4);
	        _this4.$state.reload();
	      });
	    }
	
	    /**
	     * actualizarDatosElemento - Actualizando datos de un elemento, de acuerdo a los atributos modificados
	     *
	     * @param  {Object} aElemento Datos del elemento actualizado mediante servicio
	     */
	
	  }, {
	    key: 'actualizarDatosElemento',
	    value: function actualizarDatosElemento(aElemento) {
	      var _this5 = this;
	
	      this._.keys(this.servicio.getDatosSegunEstado(this.elemento, this.form)).map(function (item) {
	        if (aElemento[item]) {
	          _this5.elemento[item] = aElemento[item];
	        }
	      });
	      this.servicio.setCopia(this.elemento);
	    }
	  }, {
	    key: 'cancelar',
	    value: function cancelar() {
	      this.volverABandeja();
	    }
	  }, {
	    key: 'volverABandeja',
	    value: function volverABandeja() {
	      this.$state.go('pendientes');
	    }
	  }]);
	
	  return EjecutarTransicion;
	}();
	
	exports.default = EjecutarTransicion;

/***/ }),
/* 470 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ObservacionController = function () {
	  ObservacionController.$inject = ["$uibModalInstance", "data"];
	  function ObservacionController($uibModalInstance, data) {
	    'ngInject';
	
	    _classCallCheck(this, ObservacionController);
	
	    this.$uibModalInstance = $uibModalInstance;
	    this.data = data;
	  }
	
	  _createClass(ObservacionController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.data.observacion = null;
	    }
	  }, {
	    key: 'cerrar',
	    value: function cerrar() {
	      this.$uibModalInstance.dismiss('cancel');
	    }
	  }, {
	    key: 'observar',
	    value: function observar() {
	      this.$uibModalInstance.close(this.data);
	    }
	  }]);
	
	  return ObservacionController;
	}();
	
	exports.default = ObservacionController;

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _equipoTecnico = __webpack_require__(472);
	
	var _equipoTecnico2 = _interopRequireDefault(_equipoTecnico);
	
	var _equipoTecnico3 = __webpack_require__(662);
	
	var _equipoTecnico4 = _interopRequireDefault(_equipoTecnico3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EquipoTecnicoComponent = {
	  bindings: {
	    proyecto: '=',
	    modoVista: '<'
	  },
	  controller: _equipoTecnico2.default,
	  template: _equipoTecnico4.default
	};
	
	exports.default = EquipoTecnicoComponent;

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _registroModal = __webpack_require__(473);
	
	var _registroModal2 = _interopRequireDefault(_registroModal);
	
	var _registroModal3 = __webpack_require__(663);
	
	var _registroModal4 = _interopRequireDefault(_registroModal3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EquipoTecnicoController = function () {
	  EquipoTecnicoController.$inject = ["Modal", "DataService", "_", "Usuarios", "Message", "Storage"];
	  function EquipoTecnicoController(Modal, DataService, _, Usuarios, Message, Storage) {
	    'ngInject';
	
	    _classCallCheck(this, EquipoTecnicoController);
	
	    this.Modal = Modal;
	    this.Message = Message;
	    this.DataService = DataService;
	    this.user = Storage.getUser();
	    this._ = _;
	    this.Usuarios = Usuarios;
	    this.url = '';
	    this.esEquipoCompleto = true;
	  }
	
	  _createClass(EquipoTecnicoController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.url = 'proyectos/' + this.proyecto.id_proyecto + '/equipos_tecnicos';
	      this.cargos = [];
	      this.listaEquipo = [];
	      this.getCargos();
	      this.getListaEquipo();
	      this.urlReconfirmacion = 'proyectos/' + this.proyecto.id_proyecto + '/equipos_tecnicos/';
	      this.esResponsableProy = this.Usuarios.esResponsableProyecto();
	      this.esResponsableProy = this.esResponsableProy || this.user.rol.nombre === 'RESPONSABLE_MAE' && this.proyecto.tipo === 'TP_CIF';
	      //console.log('Usuario Actual',this.user);
	      this.$log.log('Usuario Actual', this.user);
	    }
	  }, {
	    key: 'getListaEquipo',
	    value: function getListaEquipo() {
	      var _this = this;
	
	      this.DataService.get(this.url + '?rol=' + this.user.rol.id_rol).then(function (result) {
	        if (result && result.finalizado) {
	          _this.listaEquipo = result.datos.rows;
	          _this.verificarEquipoCompleto();
	          _this.esEquipo = _this.listaEquipo.find(function (e) {
	            return e.fid_rol === _this.user.rol.id_rol && e.fid_usuario === _this.user.id_usuario;
	          });
	          _this.proyecto.equipo_tecnico = _this.listaEquipo;
	        }
	      });
	    }
	  }, {
	    key: 'getCargos',
	    value: function getCargos() {
	      var _this2 = this;
	
	      this.DataService.get('parametricas/CARGO').then(function (response) {
	        if (response) {
	          _this2.cargos = response.datos.rows;
	          _this2.cargos = _this2.cargos.filter(function (e) {
	            return e.codigo != 'CG_RESPONSABLE_MAE' || _this2.proyecto.tipo === 'TP_CIF';
	          }); // Quitar Responsable en caso CIFE
	          _this2.verificarEquipoCompleto();
	        }
	      });
	    }
	  }, {
	    key: 'adicionar',
	    value: function adicionar(callbackOk, callbackCancel) {
	      var _this3 = this;
	
	      var adicionMiembro = this.Modal.show({
	        template: _registroModal4.default,
	        controller: _registroModal2.default,
	        data: { equipo: this.listaEquipo, cargos: this.cargos, registrar: !callbackOk },
	        size: 'lg'
	      });
	      adicionMiembro.result.then(function (result) {
	        if (result) {
	          if (typeof callbackOk === 'function') {
	            callbackOk(result);
	          }
	          _this3.getListaEquipo();
	        } else {
	          if (typeof callbackCancel === 'function') {
	            callbackCancel();
	          }
	        }
	      });
	    }
	  }, {
	    key: 'verificarEquipoCompleto',
	    value: function verificarEquipoCompleto() {
	      var _this4 = this;
	
	      var nroMiembros = 0;
	      this.cargos.map(function (cargo) {
	        var MIEMBRO = _this4._.find(_this4.listaEquipo, function (miembro) {
	          return miembro.cargo === cargo.codigo;
	        });
	        if (MIEMBRO) {
	          nroMiembros++;
	        }
	      });
	      this.esEquipoCompleto = this.cargos.length === nroMiembros;
	    }
	  }, {
	    key: 'esSupervisorOFiscal',
	    value: function esSupervisorOFiscal(usuario) {
	      return usuario.estado == 'ACTIVO' && ['CG_SUPERVISOR', 'CG_FISCAL'].indexOf(usuario.cargo) >= 0;
	    }
	  }, {
	    key: 'esResponsableEncargadoOTecnico',
	    value: function esResponsableEncargadoOTecnico(usuario) {
	      return this.user.estado == 'ACTIVO' && ['RESP_DEPARTAMENTAL_UPRE', 'ENCAR_REGIONAL_UPRE', 'TECNICO_UPRE'].indexOf(this.user.rol.nombre) >= 0 && ['CG_RESPONSABLE_MAE'].indexOf(usuario.cargo) >= 0;
	    }
	  }, {
	    key: 'verDatos',
	    value: function verDatos(miembro) {
	      var _this5 = this;
	
	      var EDICION = this.Modal.show({
	        template: _registroModal4.default,
	        controller: _registroModal2.default,
	        data: { equipo: this.listaEquipo, cargos: this.cargos, miembro: miembro, modoVista: this.modoVista },
	        size: 'lg'
	      });
	
	      EDICION.result.then(function (result) {
	        if (result) {
	          _this5.getListaEquipo();
	        }
	      });
	    }
	  }, {
	    key: 'inactivarUsuario',
	    value: function inactivarUsuario(usuario) {
	      var _this6 = this;
	
	      this.Modal.confirm('Esta seguro/a de inhabilitar al ' + usuario.cargo_usuario.nombre + '?<br><br>Este usuario ya no podra ser habilitado nuevamente con el mismo cargo.<br><br>* Deber\xE1 agregar un nuevo usuario.', function () {
	        usuario.estado = 'INACTIVO';
	        _this6.adicionar(function (persona) {
	          _this6.DataService.put(_this6.url + '/' + usuario.id_equipo_tecnico + '/reemplazar', persona).then(function (resp) {
	            if (resp && resp.finalizado) {
	              _this6.getListaEquipo();
	            } else {
	              _this6.Message.warning('No se pudo realizar la inhabilitación.');
	            }
	          });
	        }, function () {
	          usuario.estado = 'ACTIVO';
	        });
	      }, null, 'Inhabilitar', 'Si estoy seguro/a', null, 'ban');
	    }
	  }]);
	
	  return EquipoTecnicoController;
	}();
	
	exports.default = EquipoTecnicoController;

/***/ }),
/* 473 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var RegistroFiscalSupervisorController = function () {
	  RegistroFiscalSupervisorController.$inject = ["$uibModalInstance", "DataService", "$stateParams", "data", "_", "Message"];
	  function RegistroFiscalSupervisorController($uibModalInstance, DataService, $stateParams, data, _, Message) {
	    'ngInject';
	
	    _classCallCheck(this, RegistroFiscalSupervisorController);
	
	    this.DataService = DataService;
	    this.$stateParams = $stateParams;
	    this.data = data;
	    this.$uibModalInstance = $uibModalInstance;
	    this._ = _;
	    this.Message = Message;
	    this.miembro = null;
	    this.equipo = this.data.equipo;
	    this.cargos = angular.copy(this.data.cargos);
	    this.miembro = this.data.miembro || {};
	    this.modoEdicion = false;
	    this.modoVista = this.data.modoVista;
	  }
	
	  _createClass(RegistroFiscalSupervisorController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.miembro.tipo_equipo = 'TE_BENEFICIARIO';
	      if (this.miembro.id_equipo_tecnico) {
	        this.getDatosMiembroEquipo();
	      } else {
	        this.quitarCargosOcupados();
	        this.modoEdicion = true;
	      }
	    }
	  }, {
	    key: 'quitarCargosOcupados',
	    value: function quitarCargosOcupados(cargoIgnorado) {
	      var _this = this;
	
	      this._.remove(this.cargos, function (cargo) {
	        var CARGO_EXISTENTE = _this._.find(_this.equipo, { cargo: cargo.codigo, estado: 'ACTIVO' });
	        if (CARGO_EXISTENTE && CARGO_EXISTENTE.cargo === cargoIgnorado) {
	          return false;
	        }
	        return CARGO_EXISTENTE && CARGO_EXISTENTE.estado === 'ACTIVO';
	      });
	    }
	  }, {
	    key: 'getDatosMiembroEquipo',
	    value: function getDatosMiembroEquipo() {
	      var _this2 = this;
	
	      this.DataService.get('proyectos/' + this.miembro.fid_proyecto + '/equipos_tecnicos/' + this.miembro.id_equipo_tecnico).then(function (result) {
	        _this2.miembro = result.datos;
	        angular.extend(_this2.miembro, result.datos.usuario.persona);
	        delete _this2.miembro.usuario;
	        _this2.datosIniciales = angular.copy(_this2.miembro);
	        _this2.quitarCargosOcupados(_this2.miembro.cargo);
	        if (_this2.miembro.tipo_equipo !== 'TE_UPRE') {
	          _this2.archivo = {
	            url: 'proyectos/' + _this2.miembro.fid_proyecto + '/doc/' + _this2.miembro.doc_designacion.substring(1, _this2.miembro.doc_designacion.indexOf(']')),
	            urlDescarga: 'proyectos/' + _this2.miembro.fid_proyecto + '/doc/' + _this2.miembro.doc_designacion.substring(1, _this2.miembro.doc_designacion.indexOf(']')) + '/descargar'
	          };
	        }
	      });
	    }
	  }, {
	    key: 'registrar',
	    value: function registrar() {
	      var _this3 = this;
	
	      if (!this.miembro.doc_designacion) {
	        this.Message.warning('Debe seleccionar el archivo de designación.');
	        return;
	      }
	      if (!this.data.registrar) {
	        return this.$uibModalInstance.close(this.miembro);
	      }
	      var url = 'proyectos/' + this.$stateParams.codigo + '/equipos_tecnicos';
	      var servicio = 'post';
	      var miembroEquipo = angular.copy(this.miembro);
	      if (this.miembro.id_equipo_tecnico) {
	        url += '/' + this.miembro.id_equipo_tecnico;
	        servicio = 'put';
	        if (typeof this.miembro.doc_designacion === 'string') {
	          delete miembroEquipo.doc_designacion;
	        }
	      }
	      this.DataService[servicio](url, miembroEquipo).then(function (result) {
	        if (result) {
	          _this3.Message.success(result.mensaje);
	          _this3.$uibModalInstance.close(_this3.miembro);
	        }
	      });
	    }
	  }, {
	    key: 'esSupervisor',
	    value: function esSupervisor() {
	      return this.miembro.cargo === 'CG_SUPERVISOR';
	    }
	  }, {
	    key: 'cerrar',
	    value: function cerrar() {
	      this.$uibModalInstance.close(false);
	    }
	  }]);
	
	  return RegistroFiscalSupervisorController;
	}();
	
	exports.default = RegistroFiscalSupervisorController;

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _garantia = __webpack_require__(475);
	
	var _garantia2 = _interopRequireDefault(_garantia);
	
	var _garantia3 = __webpack_require__(664);
	
	var _garantia4 = _interopRequireDefault(_garantia3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GarantiaComponent = {
	  bindings: {
	    proyecto: '=',
	    modoVista: '<'
	  },
	  controller: _garantia2.default,
	  template: _garantia4.default
	};
	
	exports.default = GarantiaComponent;

/***/ }),
/* 475 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var GarantiaController = function () {
	  GarantiaController.$inject = ["$scope", "Proyecto", "_"];
	  function GarantiaController($scope, Proyecto, _) {
	    'ngInject';
	
	    _classCallCheck(this, GarantiaController);
	
	    this.$scope = $scope;
	    this.Proyecto = Proyecto;
	    this._ = _;
	  }
	
	  _createClass(GarantiaController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.cContrato = {
	        porcentajeFijo: true,
	        porcentaje: 7,
	        monto: 0,
	        nombrePorcentaje: 'porcentaje_ccontrato',
	        nombreMonto: 'monto_ccontrato',
	        tipo: 'TB_CUMPLIMIENTO_CONTRATO'
	      };
	      this.anticipo = {
	        porcentajeFijo: false,
	        porcentaje: this.proyecto.porcentaje_anticipo,
	        monto: this.proyecto.anticipo,
	        nombrePorcentaje: 'porcentaje_anticipo',
	        nombreMonto: 'monto_anticipo',
	        tipo: 'TB_CORRECTA_INVERSION'
	      };
	
	      this.prepararBoletas();
	      this.$scope.$on('actualizarBoletas', function () {
	        _this.actualizarBoletas();
	      });
	    }
	  }, {
	    key: 'prepararBoletas',
	    value: function prepararBoletas() {
	      this.boletasCcontrato = this.getBoletasPorTipo('TB_CUMPLIMIENTO_CONTRATO');
	      this.boletasAnticipo = this.getBoletasPorTipo('TB_CORRECTA_INVERSION');
	    }
	  }, {
	    key: 'getBoletasPorTipo',
	    value: function getBoletasPorTipo(tipo) {
	      var BOLETAS = angular.copy(this.proyecto.boletas);
	      return this._.filter(BOLETAS, function (boleta) {
	        return boleta.tipo_boleta === tipo;
	      });
	    }
	  }, {
	    key: 'actualizarBoletas',
	    value: function actualizarBoletas() {
	      this.proyecto.boletas = this.boletasAnticipo.concat(this.boletasCcontrato);
	    }
	  }]);
	
	  return GarantiaController;
	}();
	
	exports.default = GarantiaController;

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _items = __webpack_require__(477);
	
	var _items2 = _interopRequireDefault(_items);
	
	var _items3 = __webpack_require__(665);
	
	var _items4 = _interopRequireDefault(_items3);
	
	__webpack_require__(195);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ItemsComponent = {
	  bindings: {
	    proyecto: '=',
	    modulos: '=',
	    modoVista: '<'
	  },
	  controller: _items2.default,
	  template: _items4.default
	};
	
	exports.default = ItemsComponent;

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _moduloModal = __webpack_require__(479);
	
	var _moduloModal2 = _interopRequireDefault(_moduloModal);
	
	var _moduloModal3 = __webpack_require__(667);
	
	var _moduloModal4 = _interopRequireDefault(_moduloModal3);
	
	var _archivoModal = __webpack_require__(46);
	
	var _archivoModal2 = _interopRequireDefault(_archivoModal);
	
	var _archivoModal3 = __webpack_require__(47);
	
	var _archivoModal4 = _interopRequireDefault(_archivoModal3);
	
	var _validacion = __webpack_require__(478);
	
	var _validacion2 = _interopRequireDefault(_validacion);
	
	var _validacion3 = __webpack_require__(666);
	
	var _validacion4 = _interopRequireDefault(_validacion3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ItemsController = function () {
	  ItemsController.$inject = ["DataService", "Util", "Modal", "NgTableParams", "_", "Message", "Proyecto", "Storage"];
	  function ItemsController(DataService, Util, Modal, NgTableParams, _, Message, Proyecto, Storage) {
	    'ngInject';
	
	    _classCallCheck(this, ItemsController);
	
	    this.DataService = DataService;
	    this.Util = Util;
	    this.Modal = Modal;
	    this.NgTableParams = NgTableParams;
	    this._ = _;
	    this.Message = Message;
	    this.Proyecto = Proyecto;
	    this.user = Storage.getUser();
	  }
	
	  _createClass(ItemsController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.modulos = [];
	      this.getListaModulos();
	      this.getTipoUnidades();
	      this.esTecnico = ['TECNICO_UPRE', 'RESP_DEPARTAMENTAL_UPRE', 'ENCAR_REGIONAL_UPRE'].indexOf(this.user.rol.nombre) >= 0 && (this.proyecto.estado_actual.codigo == 'REGISTRO_EMPRESA' || this.proyecto.estado_actual.codigo == 'REGISTRO_EMPRESA_CORRECCION');
	    }
	  }, {
	    key: 'getListaModulos',
	    value: function getListaModulos(modulo) {
	      var _this = this;
	
	      this.DataService.get('modulos/proyectos/' + this.proyecto.id_proyecto).then(function (response) {
	        if (response && response.finalizado) {
	          _this.modulos = response.datos.rows;
	          if (modulo && _this.modulos.length) {
	            for (var i in _this.modulos) {
	              if (_this.modulos[i].id_modulo == modulo.id_modulo) {
	                _this.modulos[i].show = true;
	              }
	            }
	          }
	        }
	      });
	    }
	  }, {
	    key: 'getTipoUnidades',
	    value: function getTipoUnidades() {
	      var _this2 = this;
	
	      this.DataService.get('parametricas/UNIDAD').then(function (response) {
	        if (response) {
	          _this2.unidades = response.datos.rows;
	        }
	      });
	    }
	  }, {
	    key: 'adicionarModulo',
	    value: function adicionarModulo() {
	      var _this3 = this;
	
	      var modulo = {
	        fid_proyecto: this.proyecto.id_proyecto,
	        estado_actual: this.proyecto.estado_actual
	      };
	      var modalModulo = this.mostrarModal('Nuevo Módulo', 'fa-plus', modulo, _moduloModal4.default, _moduloModal2.default);
	      modalModulo.result.then(function (result) {
	        if (result && result.datos) {
	          _this3.modulos.push(result.datos);
	        }
	      });
	    }
	  }, {
	    key: 'editarModulo',
	    value: function editarModulo(modulo) {
	      this.mostrarModal('Editando Módulo', 'fa-edit', modulo, _moduloModal4.default, _moduloModal2.default);
	    }
	  }, {
	    key: 'eliminarModulo',
	    value: function eliminarModulo(modulo) {
	      var _this4 = this;
	
	      var msg = modulo && modulo.items && modulo.items.length ? '\xBFEst\xE1 seguro/a de eliminar el m\xF3dulo ' + modulo.nombre + ' y los ' + modulo.items.length + ' items?' : '\xBFEst\xE1 seguro/a de eliminar el m\xF3dulo ' + modulo.nombre + '?';
	      this.Modal.confirm(msg, function () {
	        _this4.DataService.delete('modulos/' + modulo.id_modulo).then(function (result) {
	          if (result) {
	            _this4.modulos = _this4.eliminarElementoDeLista(_this4.modulos, modulo, 'id_modulo');
	            _this4.Message.success('Se elimin\xF3 el m\xF3dulo "' + modulo.nombre + '" correctamente.');
	            _this4.refrescarLista();
	          }
	        });
	      }, null, null, 'Si, estoy seguro/a');
	    }
	  }, {
	    key: 'adicionarItem',
	    value: function adicionarItem(modulo) {
	      if (!modulo.items) {
	        modulo.items = [];
	      }
	      for (var i in this.modulos) {
	        for (var j in this.modulos[i].items) {
	          if (!this.modulos[i].items[j].id_item || this.modulos[i].items[j].edicion) {
	            this.Message.warning('Debe guardar el item "' + (this.modulos[i].items[j].nombre || 'Sin nombre') + '"');
	            return;
	          }
	        }
	      }
	      modulo.items.push({ edicion: true });
	    }
	  }, {
	    key: 'guardarItem',
	    value: function guardarItem(item, index, indexModulo, modulo) {
	      var _this5 = this;
	
	      if (!this.sonDatosValidosItem(modulo, index)) {
	        return;
	      }
	      item.fid_modulo = modulo.id_modulo;
	      this.DataService.post('items', item).then(function (response) {
	        if (response) {
	          _this5.Message.success('Se registr\xF3 el item "' + item.nombre + '" correctamente.');
	          _this5.modulos[indexModulo].items[index] = response.datos;
	          _this5.refrescarLista(modulo);
	        }
	      });
	    }
	  }, {
	    key: 'actualizarItem',
	    value: function actualizarItem(item, index, modulo) {
	      var _this6 = this;
	
	      if (!this.sonDatosValidosItem(modulo, index)) {
	        return;
	      }
	      this.DataService.put('items/' + item.id_item, item).then(function (response) {
	        if (response) {
	          _this6.Message.success('Se actualizó los datos del item correctamente.');
	          item.edicion = false;
	        }
	      });
	    }
	  }, {
	    key: 'eliminarItem',
	    value: function eliminarItem(item, $index, modulo) {
	      var _this7 = this;
	
	      if (!item.id_item) {
	        modulo.items.splice($index, 1);
	        return;
	      }
	      this.DataService.delete('items/' + item.id_item).then(function (result) {
	        if (result) {
	          _this7.Message.success('Se elimin\xF3 el item "' + item.nombre + '" correctamente.');
	          modulo.items = _this7.eliminarElementoDeLista(modulo.items, item, 'id_item');
	          _this7.refrescarLista(modulo);
	        }
	      });
	    }
	  }, {
	    key: 'eliminarElementoDeLista',
	    value: function eliminarElementoDeLista(lista, elemento, atributo) {
	      return this._.reject(lista, function (item) {
	        return item[atributo] === elemento[atributo];
	      });
	    }
	  }, {
	    key: 'mostrarModal',
	    value: function mostrarModal(titulo, icon, data, template, controller, labelOk, size) {
	      return this.Modal.show({
	        template: template,
	        controller: controller,
	        data: data || {},
	        title: titulo,
	        icon: icon,
	        size: size ? size : 'md',
	        labelOk: labelOk
	      });
	    }
	  }, {
	    key: 'guardarDatosModulo',
	    value: function guardarDatosModulo(modulo) {
	      var _this8 = this;
	
	      this.DataService.put('modulos/' + modulo.id_modulo, modulo).then(function (response) {
	        if (response) {
	          //modulo.items = response.datos.items;
	          _this8.Message.success('Se guard\xF3 correctamente los datos del m\xF3dulo "' + modulo.nombre + '".');
	          _this8.refrescarLista(modulo);
	        }
	      });
	    }
	  }, {
	    key: 'sonDatosValidosItem',
	    value: function sonDatosValidosItem(modulo, posicion) {
	      var nombreForm = 'form_' + modulo.id_modulo;
	      var FORM = angular.element(document.querySelector('[name=' + nombreForm + ']')).scope()[nombreForm];
	      var esValido = FORM['item_nombre_' + posicion].$valid && FORM['item_unidad_' + posicion].$valid && FORM['item_cantidad_' + posicion].$valid;
	
	      if (!esValido) {
	        FORM['item_nombre_' + posicion].$setTouched();
	        FORM['item_unidad_' + posicion].$setTouched();
	        FORM['item_cantidad_' + posicion].$setTouched();
	      }
	      if (!esValido) {
	        this.Message.warning('Verifique, corrija y/o llene los campos resaltados.');
	        return false;
	      }
	      return true;
	    }
	  }, {
	    key: 'importarItems',
	    value: function importarItems() {
	      var _this9 = this;
	
	      var confArchivo = {
	        //formatos: 'csv, xlsx, ods', //types
	        formatos: 'ods', //types
	        // tipos: '.csv,.xlsx,.ods', //mime-types
	        tipos: '.ods', //mime-types
	        cargarItems: true,
	        mensajeInformacion: 'Puede importar items desde un <strong>archivo en formato .ods</strong>.'
	      };
	      this.mostrarModal('Importar Items', 'fa-upload', confArchivo, _archivoModal4.default, _archivoModal2.default, 'Importar').result.then(function (documento) {
	        var items = {
	          id_proyecto: _this9.proyecto.id_proyecto,
	          base64: documento.base64
	        };
	        _this9.DataService.post('items/file', items).then(function (result) {
	          if (result.finalizado) {
	            _this9.Message.success('Se importó correctamente los items.');
	            _this9.modulos = result.datos;
	          }
	          if (result.erroresValidacion) {
	            var modalModulo = _this9.mostrarModal('Observaciones en el archivo', 'fa-check', result.erroresValidacion, _validacion4.default, _validacion2.default, null, 'lg');
	            modalModulo.result.then(function (result) {
	              result;
	            });
	          }
	        });
	      });
	    }
	
	    /* Especificaciones técnicas */
	
	  }, {
	    key: 'cargarEspecificacionesTecnicas',
	    value: function cargarEspecificacionesTecnicas() {
	      var _this10 = this;
	
	      var confArchivo = {
	        formatos: 'pdf',
	        tipos: '.pdf',
	        mensajeInformacion: 'El archivo representará a las especificaciones técnicas de los items en general.'
	      };
	      this.mostrarModal('Especificaciones T\xE9cnicas', 'fa-upload', confArchivo, _archivoModal4.default, _archivoModal2.default, 'Cargar documento').result.then(function (docEspecificaciones) {
	        if (angular.isUndefined(docEspecificaciones)) {
	          return;
	        }
	        _this10.DataService.put('proyectos/' + _this10.proyecto.id_proyecto, { doc_especificaciones_tecnicas: docEspecificaciones, rol: _this10.user.rol.id_rol }).then(function (result) {
	          if (result) {
	            _this10.Message.success('Se registr\xF3 el documento de especificaciones t\xE9cnicas correctamente.');
	            _this10.proyecto.doc_especificaciones_tecnicas = result.datos.doc_especificaciones_tecnicas;
	          }
	        });
	      });
	    }
	  }, {
	    key: 'verEspecificacionesTecnicas',
	    value: function verEspecificacionesTecnicas() {
	      this.Modal.showDocumentBase64('proyectos/' + this.proyecto.id_proyecto + '/doc/ET', 'Especificaciones T\xE9cnicas');
	    }
	
	    /* Plano proyecto */
	
	  }, {
	    key: 'cargarPlanosProyecto',
	    value: function cargarPlanosProyecto() {
	      var _this11 = this;
	
	      var confArchivo = {
	        formatos: 'pdf',
	        tipos: '.pdf',
	        mensajeInformacion: 'El archivo representará los planos del proyecto.'
	      };
	      this.mostrarModal('Planos del proyecto', 'fa-upload', confArchivo, _archivoModal4.default, _archivoModal2.default, 'Cargar documento').result.then(function (docPlanos) {
	        if (angular.isUndefined(docPlanos)) {
	          return;
	        }
	        _this11.DataService.put('proyectos/' + _this11.proyecto.id_proyecto, { doc_planos_proyecto: docPlanos, rol: _this11.user.rol.id_rol }).then(function (result) {
	          if (result) {
	            _this11.Message.success('Se registr\xF3 el documento de planos del proyecto correctamente.');
	            _this11.proyecto.doc_planos_proyecto = result.datos.doc_planos_proyecto;
	          }
	        });
	      });
	    }
	  }, {
	    key: 'verPlanosProyecto',
	    value: function verPlanosProyecto() {
	      this.Modal.showDocumentBase64('proyectos/' + this.proyecto.id_proyecto + '/doc/PP', 'Planos del Proyecto');
	    }
	
	    /* Cargar especificacione por items */
	
	  }, {
	    key: 'cargarEspecificacionesItem',
	    value: function cargarEspecificacionesItem(item) {
	      var _this12 = this;
	
	      var confArchivo = {
	        formatos: 'pdf',
	        tipos: '.pdf'
	      };
	      this.mostrarModal('Especificaciones T\xE9cnicas - "' + item.nombre + '"', 'fa-upload', confArchivo, _archivoModal4.default, _archivoModal2.default, 'Cargar documento').result.then(function (docEspecificaciones) {
	        if (angular.isUndefined(docEspecificaciones)) {
	          return;
	        }
	        _this12.DataService.put('items/' + item.id_item, { especificaciones: docEspecificaciones }).then(function (result) {
	          if (result && result.finalizado) {
	            _this12.Message.success('Se registr\xF3 el documento de especificaciones t\xE9cnicas del item "' + item.nombre + '" correctamente.');
	            item.especificaciones = docEspecificaciones;
	          }
	        });
	      });
	    }
	  }, {
	    key: 'verEspecificacionesItem',
	    value: function verEspecificacionesItem(item) {
	      this.Modal.showDocumentBase64('proyectos/' + this.proyecto.id_proyecto + '/doc/ET_' + item.id_item, 'Especificaciones T\xE9cnicas - "' + item.nombre + '"');
	    }
	  }, {
	    key: 'refrescarLista',
	    value: function refrescarLista(modulo) {
	      this.getListaModulos(modulo);
	    }
	  }, {
	    key: 'agregarQuitarCampo',
	    value: function agregarQuitarCampo() {
	      var _this13 = this;
	
	      var data = {
	        cRedondeo: !this.proyecto.cr_precio
	      };
	      this.DataService.put('proyectos/' + this.proyecto.id_proyecto + '/campo_regularizacion', data).then(function (resp) {
	        if (resp && resp.finalizado) {
	          _this13.proyecto.cr_precio = true;
	        } else {
	          _this13.proyecto.cr_precio = false;
	        }
	      });
	    }
	  }]);
	
	  return ItemsController;
	}();
	
	exports.default = ItemsController;

/***/ }),
/* 478 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ModuloController = function () {
	  ModuloController.$inject = ["$uibModalInstance", "data", "title", "icon", "DataService", "Message"];
	  function ModuloController($uibModalInstance, data, title, icon, DataService, Message) {
	    'ngInject';
	
	    _classCallCheck(this, ModuloController);
	
	    this.$uibModalInstance = $uibModalInstance;
	    this.data = data;
	    this.title = title;
	    this.icon = icon;
	    this.DataService = DataService;
	    this.Message = Message;
	  }
	
	  _createClass(ModuloController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.modulos = [];
	      this.mensajes = this.data;
	    }
	  }, {
	    key: 'guardar',
	    value: function guardar() {
	      var _this = this;
	
	      this.DataService.post('modulos', this.modulo).then(function (resp) {
	        if (resp) {
	          _this.Message.success("Se registró el módulo correctamente.");
	          _this.$uibModalInstance.close(resp);
	        }
	      });
	    }
	  }, {
	    key: 'actualizar',
	    value: function actualizar() {
	      var _this2 = this;
	
	      this.DataService.put('modulos/' + this.modulo.id_modulo, this.modulo).then(function (resp) {
	        if (resp) {
	          _this2.Message.success("Se actualizó el módulo correctamente.");
	          _this2.$uibModalInstance.close(resp);
	        }
	      });
	    }
	  }, {
	    key: 'cerrar',
	    value: function cerrar() {
	      this.$uibModalInstance.dismiss('cancel');
	    }
	  }]);
	
	  return ModuloController;
	}();
	
	exports.default = ModuloController;

/***/ }),
/* 479 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ModuloController = function () {
	  ModuloController.$inject = ["$uibModalInstance", "data", "title", "icon", "DataService", "Message"];
	  function ModuloController($uibModalInstance, data, title, icon, DataService, Message) {
	    'ngInject';
	
	    _classCallCheck(this, ModuloController);
	
	    this.$uibModalInstance = $uibModalInstance;
	    this.data = data;
	    this.title = title;
	    this.icon = icon;
	    this.DataService = DataService;
	    this.Message = Message;
	  }
	
	  _createClass(ModuloController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.modulos = [];
	      this.modulo = this.data;
	      if (this.data && this.data.estado_actual && this.data.estado_actual.codigo) {
	        this.modulo.nombre = '';
	      }
	    }
	  }, {
	    key: 'guardar',
	    value: function guardar() {
	      var _this = this;
	
	      delete this.modulo.estado_actual;
	      this.DataService.post('modulos', this.modulo).then(function (resp) {
	        if (resp) {
	          _this.Message.success("Se registró el módulo correctamente.");
	          _this.$uibModalInstance.close(resp);
	        }
	      });
	    }
	  }, {
	    key: 'actualizar',
	    value: function actualizar() {
	      var _this2 = this;
	
	      this.DataService.put('modulos/' + this.modulo.id_modulo, this.modulo).then(function (resp) {
	        if (resp) {
	          _this2.Message.success("Se actualizó el módulo correctamente.");
	          _this2.$uibModalInstance.close(resp);
	        }
	      });
	    }
	  }, {
	    key: 'cerrar',
	    value: function cerrar() {
	      this.$uibModalInstance.dismiss('cancel');
	    }
	  }]);
	
	  return ModuloController;
	}();
	
	exports.default = ModuloController;

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ordenProceder = __webpack_require__(481);
	
	var _ordenProceder2 = _interopRequireDefault(_ordenProceder);
	
	var _ordenProceder3 = __webpack_require__(668);
	
	var _ordenProceder4 = _interopRequireDefault(_ordenProceder3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OrdenProcederComponent = {
	  bindings: {
	    proyecto: '=',
	    modoVista: '<'
	  },
	  controller: _ordenProceder2.default,
	  template: _ordenProceder4.default
	};
	
	exports.default = OrdenProcederComponent;

/***/ }),
/* 481 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DesembolsoController = function () {
	  DesembolsoController.$inject = ["Proyecto", "_", "Datetime"];
	  function DesembolsoController(Proyecto, _, Datetime) {
	    'ngInject';
	
	    _classCallCheck(this, DesembolsoController);
	
	    this.Proyecto = Proyecto;
	    this._ = _;
	    this.Datetime = Datetime;
	  }
	
	  _createClass(DesembolsoController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.prepararValidacionesFecha();
	      this.archivos = {
	        urlDocOrden: this.proyecto ? 'proyectos/' + this.proyecto.id_proyecto + '/doc/OP' : '',
	        urlDocOrdenDescarga: this.proyecto ? 'proyectos/' + this.proyecto.id_proyecto + '/doc/OP/descargar' : ''
	      };
	    }
	  }, {
	    key: 'prepararValidacionesFecha',
	    value: function prepararValidacionesFecha() {
	      var fechaDesde = void 0,
	          mensajeError = 'La fecha debe ser mayor a la fecha';
	      if (this.tieneBoletas()) {
	        //fechaDesde = this.fechaMasAntiguaDeBoletas();
	        fechaDesde = this.proyecto.fecha_suscripcion_convenio;
	        mensajeError = mensajeError + ' de inicio de la boleta de anticipo m\xE1s antigua';
	      } else if (this.proyecto.tipo === 'TP_CIF') {
	        //fechaDesde = this.proyecto.fecha_desembolso;
	        fechaDesde = this.proyecto.fecha_suscripcion_convenio;
	        mensajeError = mensajeError + ' del desembolso';
	      } else {
	        fechaDesde = this.proyecto.fecha_suscripcion_convenio;
	        mensajeError = mensajeError + ' del convenio';
	      }
	      fechaDesde = this.Datetime.getFormatDate(fechaDesde);
	      this.validacion = {
	        fecha_minima: this.Datetime.addDaysToDate(angular.copy(fechaDesde), 1),
	        mensaje_fecminima: mensajeError + ' (' + this.Datetime.parseDate(fechaDesde, '/') + ')'
	      };
	    }
	  }, {
	    key: 'tieneBoletas',
	    value: function tieneBoletas() {
	      return this.proyecto.boletas.length > 0;
	    }
	  }, {
	    key: 'fechaMasAntiguaDeBoletas',
	    value: function fechaMasAntiguaDeBoletas() {
	      return this._.sortBy(this.proyecto.boletas, function (boleta) {
	        return boleta.fecha_inicio_validez;
	      })[0].fecha_inicio_validez;
	    }
	  }]);
	
	  return DesembolsoController;
	}();
	
	exports.default = DesembolsoController;

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _proyecto = __webpack_require__(483);
	
	var _proyecto2 = _interopRequireDefault(_proyecto);
	
	var _proyecto3 = __webpack_require__(669);
	
	var _proyecto4 = _interopRequireDefault(_proyecto3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProyectoComponent = {
	  bindings: {},
	  controller: _proyecto2.default,
	  template: _proyecto4.default
	};
	
	exports.default = ProyectoComponent;

/***/ }),
/* 483 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ProyectoController = function () {
	  ProyectoController.$inject = ["$stateParams", "Storage", "Proyecto", "$state", "$q", "Message", "_", "Modal", "$log"];
	  function ProyectoController($stateParams, Storage, Proyecto, $state, $q, Message, _, Modal, $log) {
	    'ngInject';
	
	    _classCallCheck(this, ProyectoController);
	
	    this.$stateParams = $stateParams;
	    this.Proyecto = Proyecto;
	    this.Storage = Storage;
	    this.$q = $q;
	    this.$state = $state;
	    this.Message = Message;
	    this._ = _;
	    this.Modal = Modal;
	    this.$log = $log;
	  }
	
	  _createClass(ProyectoController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.idProyecto = this.$stateParams.codigo;
	      this.Proyecto.setEstadoActual(null);
	      this.getProyecto();
	      this.url = 'proyectos/' + this.idProyecto + '?rol=' + this.Storage.get('rol').id_rol;
	    }
	  }, {
	    key: 'getProyecto',
	    value: function getProyecto() {
	      var _this = this;
	
	      this.Proyecto.get(this.idProyecto, this.$stateParams.urlProcesado).then(function (response) {
	        if (response) {
	          _this.Proyecto.setEstadoActual(response.datos.estado_actual);
	          _this.proyecto = response.datos;
	          _this.$log.log('Datos Proyecto', _this.proyecto);
	          _this.estadoActual = response.datos.estado_actual;
	        } else {
	          _this.$state.go('pendientes');
	        }
	      });
	    }
	  }, {
	    key: 'verificarSegunEstado',
	    value: function verificarSegunEstado() {
	      var defer = this.$q.defer();
	      if (this.Proyecto.esEditable('boletas')) {
	        if (!this.sonDatosCompletosBoletas()) {
	          defer.reject();
	        }
	      }
	
	      if (this.Proyecto.esEditable('autoridad_beneficiaria')) {
	        if (!this.sonDatosCompletosAutoridad()) {
	          defer.reject();
	        }
	      }
	      if (this.Proyecto.esEditable('equipo_tecnico')) {
	        if (!this.tieneEquipoTecnico()) {
	          this.Modal.alert('Debe registrar al Supervisor y Fiscal del proyecto, en el apartado Equipo T\xE9cnico...', null, 'Información incompleta', null, 'md');
	        } else {
	          defer.resolve({ confirmar: true });
	          return defer.promise;
	        }
	      } else {
	        defer.resolve({ confirmar: true });
	      }
	      return defer.promise;
	    }
	  }, {
	    key: 'tieneEquipoTecnico',
	    value: function tieneEquipoTecnico() {
	      this.$log.log('equipo_tecnico', this.proyecto.equipo_tecnico);
	      var TIENE_SUPERVISOR = this._.find(this.proyecto.equipo_tecnico, { cargo: 'CG_SUPERVISOR' });
	      var TIENE_FISCAL = this._.find(this.proyecto.equipo_tecnico, { cargo: 'CG_FISCAL' });
	      return TIENE_SUPERVISOR && TIENE_FISCAL ? true : false;
	    }
	  }, {
	    key: 'sonDatosCompletosAutoridad',
	    value: function sonDatosCompletosAutoridad() {
	      var mensaje = [];
	      if (!this.proyecto.sector) {
	        mensaje.push({ area: 'Datos Generales', mensaje: 'Debe registrar el sector correspondiente al proyecto' });
	      }
	      if (!this.proyecto.autoridad_beneficiaria.nombres || !this.proyecto.autoridad_beneficiaria.telefono || !this.proyecto.cargo_autoridad_beneficiaria) {
	        mensaje.push({ area: 'MAE Benerifiarios/as', mensaje: 'Datos del contacto de los/las beneficiarios/as' });
	      }
	      if (!this.modulos || this.modulos.length < 1) {
	        mensaje.push({ area: 'Módulos/Items', mensaje: 'Registre al menos un módulo' });
	      } else {
	        var INCOMPLETOS = this.getModulosIncompletos();
	        if (INCOMPLETOS > 0) {
	          mensaje.push({ area: 'Módulos/Items', mensaje: INCOMPLETOS > 1 ? 'Algunos m\xF3dulos no tienen items registrados, o no fueron guardados.' : 'El m\xF3dulo no tiene items registrados, o no fue guardado.' });
	        }
	      }
	      if (this.proyecto.tipo === 'TP_CIFE' && !this.proyecto.doc_especificaciones_tecnicas) {
	        mensaje.push({ area: 'Módulos/Items', mensaje: 'Registre el documento de especificaciones técnicas' });
	      }
	      // if (this.Proyecto.esEditable('doc_base_contratacion') && !this.proyecto.doc_base_contratacion) {
	      //   mensaje.push({area: 'DBC', mensaje: 'Registre la Especificación Técnica de Contratación'});
	      // }
	      if (mensaje.length > 0) {
	        var texto = '<p>Debe completar la información de los siguientes apartados:</p><ul>';
	        mensaje.map(function (obs) {
	          texto += '<li><strong>' + obs.area + '</strong>: ' + obs.mensaje + '</li>';
	        });
	        texto += '</ul>';
	        this.Modal.alert(texto, function () {
	          return false;
	        }, 'Información incompleta', null, 'md');
	      } else {
	        return true;
	      }
	    }
	  }, {
	    key: 'sonDatosCompletosBoletas',
	    value: function sonDatosCompletosBoletas() {
	      var mensaje = [];
	      if (this.proyecto) {
	        // if(this.proyecto.tipo==='TP_CIF'&&this.proyecto.formularios&&!this.proyecto.formularios.find((f)=>{ return f.codigo_documento==='DCONT'; })) {
	        //   mensaje.push({area: 'Contrato', mensaje: 'Debe registrar el contrato'});
	        // }
	        if (this.proyecto.boletas && !this.proyecto.boletas.length) {
	          mensaje.push({ area: 'Garantías', mensaje: 'Debe registrar las boletas de garantía' });
	        }
	      }
	      if (mensaje.length > 0) {
	        var texto = '<p>Debe completar la información de los siguientes apartados:</p><ul>';
	        mensaje.map(function (obs) {
	          texto += '<li><strong>' + obs.area + '</strong>: ' + obs.mensaje + '</li>';
	        });
	        texto += '</ul>';
	        this.Modal.alert(texto, function () {
	          return false;
	        }, 'Información incompleta', null, 'md');
	      } else {
	        return true;
	      }
	    }
	  }, {
	    key: 'getModulosIncompletos',
	    value: function getModulosIncompletos() {
	      var incompletos = 0;
	      this.modulos.map(function (modulo) {
	        if (!modulo.items || modulo.items.length < 1) {
	          incompletos++;
	        }
	        for (var i in modulo.items) {
	          if (!modulo.items[i].id_item || modulo.items[i].edicion) {
	            incompletos++;
	          }
	        }
	      });
	      return incompletos;
	    }
	  }, {
	    key: 'verificarEnParalelo',
	    value: function verificarEnParalelo() {
	      if (this.Proyecto.esEditable('autoridad_beneficiaria')) {
	        return this.sonDatosCompletosAutoridad();
	      }
	      return false;
	    }
	  }]);
	
	  return ProyectoController;
	}();
	
	exports.default = ProyectoController;

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _proyecto = __webpack_require__(482);
	
	var _proyecto2 = _interopRequireDefault(_proyecto);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Proyecto = angular.module('app.proyecto', []).component('proyecto', _proyecto2.default).config(["$stateProvider", function ($stateProvider) {
	    $stateProvider.state('proyecto', {
	        url: '/proyecto/{codigo: int}',
	        component: 'proyecto',
	        params: {
	            urlProcesado: ''
	        }
	    });
	}]).name;
	
	exports.default = Proyecto;

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _bandeja = __webpack_require__(433);
	
	var _bandeja2 = _interopRequireDefault(_bandeja);
	
	var _proyecto = __webpack_require__(484);
	
	var _proyecto2 = _interopRequireDefault(_proyecto);
	
	var _proyectos = __webpack_require__(486);
	
	var _proyectos2 = _interopRequireDefault(_proyectos);
	
	var _cProyectos = __webpack_require__(457);
	
	var _cProyectos2 = _interopRequireDefault(_cProyectos);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Proyectos = angular.module('app.proyectos', [_bandeja2.default, _proyecto2.default, _cProyectos2.default]).service('Proyecto', _proyectos2.default).name;
	
	exports.default = Proyectos;

/***/ }),
/* 486 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ProyectoService = function () {
	  ProyectoService.$inject = ["Storage", "DataService", "$q", "Datetime", "Util", "$window", "$log", "_"];
	  function ProyectoService(Storage, DataService, $q, Datetime, Util, $window, $log, _) {
	    'ngInject';
	
	    _classCallCheck(this, ProyectoService);
	
	    this.Storage = Storage;
	    this.DataService = DataService;
	    this.Datetime = Datetime;
	    this.estadoActual = null;
	    this.Util = Util;
	    this.$window = $window;
	    this.$q = $q;
	    this.proyectoOrigen = {};
	    this._ = _;
	    this.$log = $log;
	  }
	
	  _createClass(ProyectoService, [{
	    key: 'setCopia',
	    value: function setCopia(proyecto) {
	      this.proyectoOrigen = angular.copy(proyecto);
	    }
	  }, {
	    key: 'setEstadoActual',
	    value: function setEstadoActual(estado) {
	      this.estadoActual = estado;
	      this.prepararDatosEstado(this.estadoActual);
	    }
	  }, {
	    key: 'getEstadoActual',
	    value: function getEstadoActual() {
	      return this.estadoActual;
	    }
	  }, {
	    key: 'get',
	    value: function get(idProyecto, procesado) {
	      var _this = this;
	
	      if (!procesado) procesado = '';
	      var url = 'proyectos/' + idProyecto + '/' + procesado;
	      url += '?rol=' + this.Storage.get('rol').id_rol;
	      var defer = this.$q.defer();
	      this.DataService.get(url).then(function (resp) {
	        if (resp) {
	          _this.setCopia(resp.datos);
	        }
	        defer.resolve(resp);
	      });
	      return defer.promise;
	    }
	
	    /**
	     * prepararDatosEstado - Convierte el array a objetos (de atributos, requeridos y áreas) para hacer más simple la búsqueda por atributos o campos
	     *
	     * @param  {type} estado Estado actual del proyecto
	     */
	
	  }, {
	    key: 'prepararDatosEstado',
	    value: function prepararDatosEstado(estado) {
	      if (this._.isEmpty(estado)) {
	        return;
	      }
	      if (estado.atributos) estado.atributos = this.Util.arrayToObject(estado.atributos);
	      if (estado.requeridos) estado.requeridos = this.Util.arrayToObject(estado.requeridos);
	      if (estado.areas) estado.areas = this.Util.arrayToObject(estado.areas);
	    }
	
	    /**
	     * esEditable - Verifica si el campo es editable de acuerdo a los datos del estado actual del proyecto
	     *
	     * @param  {string} nombreCampo nombre del campo a verificar
	     * @return {boolean}             true si el campo se encuentra en la lista permitida de acuerdo a la etapa actual
	     */
	
	  }, {
	    key: 'esEditable',
	    value: function esEditable(nombreCampo) {
	
	      if (this.Util.isEmpty(this.estadoActual) || this.Util.isEmpty(this.estadoActual.atributos)) {
	        return;
	      }
	      return this.estadoActual.atributos[nombreCampo] ? true : false;
	    }
	
	    /**
	     * esRequerido - Verifica si el campo es requerido de acuerdo a los datos del estado actual del proyecto
	     *
	     * @param  {string} nombreCampo nombre del campo a verificar
	     * @return {boolean}             true si el campo se encuentra en la lista permitida de acuerdo a la etapa actual
	     */
	
	  }, {
	    key: 'esRequerido',
	    value: function esRequerido(nombreCampo) {
	      //this.$log.log('Es requerdido',nombreCampo);
	      if (this.Util.isEmpty(this.estadoActual) || this.Util.isEmpty(this.estadoActual.requeridos)) {
	        return;
	      }
	      return this.estadoActual.requeridos[nombreCampo] ? true : false;
	    }
	
	    /**
	     * getDatosSegunEstado - Preparando datos para enviar, de acuerdo a los atributos que se registran
	     * según el estado del proyecto
	     *
	     * @param  {object} proyecto objeto con datos del proyecto, entre ellos el estado_actual
	     * @return {object}          objeto con los atributosa enviar según el estado actual del proyecto
	     */
	
	  }, {
	    key: 'getDatosSegunEstado',
	    value: function getDatosSegunEstado(proyecto) {
	      var _this2 = this;
	
	      var nProyecto = {};
	      var ATRIBUTOS = Array.isArray(proyecto.estado_actual.atributos) ? proyecto.estado_actual.atributos : this._.keys(proyecto.estado_actual.atributos);
	      ATRIBUTOS.map(function (atributo) {
	        if (atributo === 'fcod_municipio' && proyecto.dpa && proyecto[atributo] !== proyecto.dpa.municipio.codigo) {
	          nProyecto[atributo] = proyecto.dpa.municipio.codigo;
	        }
	        if (!_this2.esAtributoModificado(atributo, proyecto)) {
	          return;
	        }
	        if (!_this2.Util.isEmpty(proyecto[atributo])) {
	          nProyecto[atributo] = proyecto[atributo];
	        }
	      });
	      return nProyecto;
	    }
	
	    /**
	     * esAtributoModificado - Verificando si el atributo fue modificado, la comparación
	     * se realiza entre los datos del proyecto en edición y los datos antes de su edición
	     *
	     * @param  {string} atributo nombre del atributo a verificar
	     * @param  {object} proyecto objeto con datos del proyecto en edición
	     * @return {boolean}          true si el atributo fue modificado y false en caso contrario
	     */
	
	  }, {
	    key: 'esAtributoModificado',
	    value: function esAtributoModificado(atributo, proyecto) {
	      return !angular.equals(this.proyectoOrigen[atributo], proyecto[atributo]);
	    }
	
	    /**
	     * esAreaPermitida - Verifica si un área determinada es permitida para su visualización
	     * de acuerdo al estado del proyecto (datos obtenidos en el servicio)
	     *
	     * @param  {String} area Nombre del área a verificar
	     * @return {Boolean}      true si el area se encuentra en la lista de áreas habilitadas
	     * y false en caso contrario
	     */
	
	  }, {
	    key: 'esAreaPermitida',
	    value: function esAreaPermitida(area) {
	      if (this.Util.isEmpty(this.estadoActual) || this.Util.isEmpty(this.estadoActual.areas)) {
	        return;
	      }
	      return this.estadoActual.areas[area] ? true : false;
	    }
	  }]);
	
	  return ProyectoService;
	}();
	
	exports.default = ProyectoService;

/***/ }),
/* 487 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Created on 7/16/2016.
	 * Theophilus Omoregbee <theo4u@ymail.com>
	 */
	
	/**
	 * Tag input allows input from client and this input objects must contain the
	 * 'text' field or use the data-field='field_in_ur_array_or_object' to specify which field you want us to use
	 * i.e data set =[ {text:'View', value:'value1'[,..:...]}, {text:'View', value:'value2'[,..:...]}, ....]
	 * where the text is used in displaying the content to users and checking if the text matches any data set
	 * field to add to our selected tag as return array of objects
	 *
	 *
	 * it generates a default view for the entered input when the allow outside data set is used , if it exist on our
	 * data set use the object in the data set and add it to our selected data set
	 * else if  not in our data set then use the $scope.default_input={text:input}
	 *
	 * required is only triggered when the required field is true and the selected tag is empty throw required on the input
	 * name is specified so as to alert the form that the input with the name is needed
	 *
	 * Ability to style it , but comes with two styled themes
	 *          1. Material
	 *          2. Default
	 *
	 * The directive calls some few events
	 *          1. tag-added calls the onTagAdded with the added item to the parent method as parameter which is the a child in the event
	 *          2. tag-removed calls the onTagRemoved with the removed item to the parent method as parameter which is the a child in the event
	 *          3. tag-active same happens it notifies the user via the onTagActive function with the event containing the item
	 *          4. tag-maximum same as above this is calls onTagMaximum when the selected tags count hits its maximum specified in the $scope.max
	 *
	 * Delimiter can be array of delimiters[default=','] or enter key which is default for the system to use despite the delimiters
	 * Max helps in monitoring how many tag is added or selected
	 *
	 * You can delete tag by Either
	 *          1. Backspace
	 *          2. Delete
	 *
	 *  Type Head features
	 *         1. normal type head which is based on the data set , as user types it opens the type head for assistance
	 *             it is triggered by default, users can decide to off it , by turning it to false
	 *        2. For type head animation just inject ngAnimate
	 */
	
	(function () {
	
	    /**
	    * This method takes in a variable to determine if the variable was initialized or null then use the default specified
	    * @param variable
	    * @param default_value
	    * @returns {*}
	    */
	    var data_init = function data_init(variable, default_value) {
	
	        if (variable === undefined || variable === null) return default_value;else return variable;
	    };
	
	    /**
	     * Our Controller for the tags-input
	     * @param $scope
	     * @param $filter
	     */
	    var controllerFunction = function controllerFunction($scope, $filter, $log, $timeout) {
	        $scope.hasError = false; //when there is error while entrying record
	        $scope.delimiter = data_init($scope.delimiter, [',']); //used in specifying which separator to use or use default ,
	        $scope.data = data_init($scope.data, []);
	        $scope.selected = data_init($scope.selected, []);
	        $scope.allowOutsideDataSet = data_init($scope.allowOutsideDataSet, false);
	        $scope.sameInput = data_init($scope.sameInput, false);
	        $scope.default_input = {}; //default view when a new object is added i.e when
	        $scope.theme = data_init($scope.theme, 'default');
	        $scope.typehead = data_init($scope.typehead, true); //used in displaying type head or not
	        $scope.displayField = data_init($scope.displayField, 'text'); //used in displaying which field inside the data set we need
	        $scope.placeholder = data_init($scope.placeholder, 'Enter Text with , separated'); //this is helps for custom placeholder
	        $scope.max = data_init($scope.max, undefined); //this is helps to allow infinity value of input tag by default
	        $scope.required = data_init($scope.required, false);
	        $scope.name = data_init($scope.name, 'tagMe'); //used in getting the name of our input field
	
	        $scope.active_index = -1; //this hold the active selected tag index
	        $scope.typeheadOpened = false; //notify and holds the true or false , depending when the typehead options is showed for selection
	
	
	        /**
	         * This method checks if an item(input) exist inside an array
	         * @param array
	         * @param input
	         * @returns {*}
	         */
	        $scope.check_data = function (array, input) {
	            return $filter('filter')(array, function (value, index) {
	                return value[$scope.displayField] == input;
	            })[0];
	        };
	
	        /**
	         * This method strips off any delimiter in our input and return a refined input with no delimiter
	         * @param input the input to strip delimiter of
	         * @returns {*}
	         */
	        $scope.strip_delimiters = function (input) {
	            var n = $scope.delimiter.length;
	            for (var i = 0; i < n; i++) {
	                input = input.replace($scope.delimiter[i], '');
	            }return input; //stripped input with no delimiter
	        };
	
	        /**
	         * This method checks if there exist a delimiter in our input
	         * @param input to work on
	         * @returns {boolean} returns either true or false , if found true else false
	         */
	        $scope.check_delimiter = function (input) {
	            var n = $scope.delimiter.length;
	            //$log.log("Size:"+n+"--"+$scope.delimiter);
	            for (var i = 0; i < n; i++) {
	                if (input.indexOf($scope.delimiter[i]) > -1) return true;
	            }return false;
	        };
	
	        /**
	         * on key up call this function to help process our tag input
	         */
	        $scope.on_input_keyup = function (event) {
	            var input = '';
	            if ($scope.input !== undefined) input = $scope.strip_delimiters($scope.input);
	            //$log.log("striped input:"+input);
	            //if user just type and uses our defined delimiter do this function
	            if ($scope.input !== undefined && $scope.check_delimiter($scope.input) === true) {
	                if (input !== "") $scope.processor(input);
	                return 0;
	            }
	
	            //if user types and presses enter key (keyCode 13 ASCII)
	            if (event.keyCode === 13 && input !== "") {
	                $scope.processor(input);
	                return 0;
	            }
	            if (event.keyCode === 32 && input !== "") {
	                $scope.processor(input);
	                return 0;
	            }
	
	            //let's check if the user pressed the backspace button so we know when to enter the tag after the input i.e activate the tag as active
	            //and check if the backspace is pressed and nothing to backspace then move to our last added tag
	            if (event.keyCode === 8 && input.slice(0, $scope.getCursorPosition(event.target)) === "") {
	                // $log.info("backspace activated");
	                var last_index = $scope.selected.length - 1;
	                //if backspace is clicked twice with input empty delete
	                if (last_index === $scope.active_index) {}
	                /* $scope.remove($scope.selected[$scope.active_index]);
	                 last_index = -1;*/
	
	
	                //  $scope.moveToTag(event,last_index);//-1 means move the tag to the last tag
	                return 0;
	            }
	
	            //when the user clicked on the delete button removed the active one and if the input field delete action is dummant i.e
	            //when user press it no text to remove from behind again
	            if (event.keyCode === 46 && input.slice($scope.getCursorPosition(event.target), input.length) === "") {
	                // $scope.remove($scope.selected[$scope.active_index]);
	                return 0;
	            }
	        };
	
	        /**
	         * This method is to help navigate between or added tags when the key arrow left,down,up and right is pressed
	         * and this works with only the keypress down event
	         * @param event
	         */
	        $scope.on_input_keydown = function (event) {
	            var input = '';
	            if ($scope.input !== undefined) input = $scope.input.replace($scope.delimiter, '');
	
	            //when user press the directional key left check if the cursor position is at the extreme left of the input field
	            if (event.keyCode === 37 && $scope.getCursorPosition(event.target) === 0) {
	                var last_index = $scope.active_index === -1 || $scope.active_index === 0 ? $scope.selected.length - 1 : $scope.active_index - 1;
	                $scope.moveToTag(event, last_index);
	                return;
	            }
	
	            //when user press the directional key right check if the cursor position is at the extreme right of the input field
	            if (event.keyCode === 39 && $scope.getCursorPosition(event.target) === input.length) {
	                var first_index = $scope.active_index === -1 || $scope.active_index === $scope.selected.length - 1 ? 0 : $scope.active_index + 1;
	                $scope.moveToTag(event, first_index);
	                return 0;
	            }
	
	            // when the user press the down button and typehead is true activate our type head to show and move down the list
	            if (event.keyCode === 40 && $scope.typehead === true) {
	                $scope.typeheadOpened = true; //open the typehead
	                var active = $scope.getActiveTypeHead(event);
	                var first_index = active === -1 || active === $scope.data.length - 1 ? 0 : active + 1;
	                $scope.moveToTagTypeHead(event, first_index);
	                return 0;
	            }
	
	            // when the user press the up button and typehead is true activate our type head to show
	            if (event.keyCode === 38 && $scope.typehead === true) {
	                $scope.typeheadOpened = true; //open the typehead
	                return 0;
	            }
	        };
	
	        /**
	         * This function is fired to help handle on blur on our input which should only occur when the user loses focus on the input
	         * this helps handle when the user loses focus just wait small and close it and when user click on it dont hide it on time wait for
	         * specified time
	         */
	        $scope.onblur = function () {
	            $timeout(function () {
	                $scope.typeheadOpened = false;
	                $scope.isFocus = false;
	            }, 300);
	        };
	
	        /**
	         * Thanks to Dasari Srinivas http://blog.sodhanalibrary.com/2015/02/get-cursor-position-in-text-input-field.html#.V5Ly47grK00
	         *  This method helps in getting the cursor position in our text field so we can check if there was something
	         * @param oField which is the html field our text field in this case
	         * @returns {number}
	         */
	        $scope.getCursorPosition = function (oField) {
	
	            // Initialize
	            var iCaretPos = 0;
	
	            // IE Support
	            if (document.selection) {
	
	                // Set focus on the element
	                oField.focus();
	
	                // To get cursor position, get empty selection range
	                var oSel = document.selection.createRange();
	
	                // Move selection start to 0 position
	                oSel.moveStart('character', -oField.value.length);
	
	                // The caret position is selection length
	                iCaretPos = oSel.text.length;
	            }
	
	            // Firefox support
	            else if (oField.selectionStart || oField.selectionStart === '0') iCaretPos = oField.selectionStart;
	
	            // Return results
	            return iCaretPos;
	        };
	
	        /**
	         * this method updates our tag view with the input parameter, and pass an event to the parent that an object is gotten
	         * and it checks if the max is specified i.e if the maximum tags is reached or if not specified it should allow tags till infinity
	         *
	         * it sends two event when the a tag is added and when the selected tags hits maximum allowed
	         * @param input
	         */
	        $scope.update = function (input) {
	            if ($scope.selected.length < $scope.max || $scope.max === undefined) {
	                $scope.selected.push(angular.copy(input));
	                $scope.input = "";
	                $scope.typeheadOpened = false;
	                $scope.hasError = false;
	                var event_temp = { action: 'added', item: input };
	                $scope.onTagAdded({ event: event_temp });
	            } else {
	                $scope.hasError = true;
	                var event = { action: 'maximum', item: input };
	                $scope.onTagMaximum({ event: event });
	            }
	        };
	
	        /**
	         * This method removes the item from our selected tags, and it broadcast an event that an element has been removed to its parent
	         * @param item
	         */
	        $scope.remove = function (item) {
	            $scope.selected = $filter('filter')($scope.selected, function (value, index) {
	                return value !== item;
	            });
	            $scope.active_index = -1;
	            var event = { action: 'removed', item: item };
	            $scope.onTagRemoved({ event: event });
	        };
	
	        /**
	         * This method check if data check is defined , if it is defined , so we know if the entered item is in our data_set or not
	         * @param data_check
	         * @param input
	         * @returns {*}
	         */
	        $scope.return_value = function (data_check, input) {
	            if (data_check === undefined) {
	                $scope.default_input["" + $scope.displayField] = input;
	                return $scope.default_input;
	            } else return data_check; //means is on our data set , so pick the item from there
	        };
	
	        /**
	         * This method moves the cursor to the tag in a particular index  of our event which holds the parent and set it to be active
	         * @param event
	         * @param index
	         */
	        $scope.moveToTag = function (event, index) {
	            var lis = angular.element(event.target.parentNode.parentNode).find('li');
	            var size = lis.length;
	            for (var i = 0; i < size - 1; i++) {
	                if (i === index) {
	                    //check if it contains active before then toggle
	                    if ($scope.active_index !== index) {
	                        $scope.active_index = index;
	                        angular.element(lis[i]).addClass('active');
	                        var event_temp = { action: 'active', item: $scope.selected[$scope.active_index] };
	                        $scope.onTagActive({ event: event_temp });
	                    } else {
	                        $scope.active_index = -1;
	                        angular.element(lis[i]).removeClass('active');
	                    }
	                } else angular.element(lis[i]).removeClass('active');
	            }
	        };
	
	        /**
	         * This method moves the cursor to the tag typehead in a particular index  of our event which holds the parent and set its class to be active
	         * @param event
	         * @param index
	         */
	        $scope.moveToTagTypeHead = function (event, index) {
	            var main_tag = angular.element(event.target.parentNode.parentNode.parentNode.parentNode).find('ul')[1]; //get the parent (div.main-tag ul)[1]
	            var lis = angular.element(main_tag).find('a');
	            var size = lis.length;
	            for (var i = 0; i < size; i++) {
	                if (i === index) {
	                    //check if it contains active before then toggle
	                    angular.element(lis[i]).addClass('active');
	                } else angular.element(lis[i]).removeClass('active');
	            }
	        };
	
	        /**
	         *  This method helps in going through our type head to get the active index and return the index of it or return -1 for not found
	         * @param event
	         * @return {number} -1 for not found >-1 for found index
	         */
	        $scope.getActiveTypeHead = function (event) {
	            var main_tag = angular.element(event.target.parentNode.parentNode.parentNode.parentNode).find('ul')[1]; //get the parent (div.main-tag ul)[1]
	            var lis = angular.element(main_tag).find('a');
	            var size = lis.length;
	            for (var i = 0; i < size - 1; i++) {
	                if (angular.element(lis[i]).hasClass('active')) return i;
	            } // is the active one
	
	            return -1; //no active
	        };
	
	        /**
	         * when the user type in the field it should call this function for checking
	         *
	         * which would check if the following instructions
	         *  1. allowOutsideDataSet
	         *  2. sameInput
	         *  3. hasError
	         */
	        $scope.processor = function (input) {
	
	            //lets check if it is inside our main data
	            var data_set_check = $scope.check_data($scope.data, input);
	
	            //lets check if it is inside our selected data set
	            var selected_set_check = $scope.check_data($scope.selected, input);
	
	            //scenarios: when allowed outside data set and same input should be allowed
	            if ($scope.allowOutsideDataSet && $scope.sameInput) {
	                $scope.update($scope.return_value(data_set_check, input));
	                return;
	            }
	
	            //scenarios: when allowed outside data set and same input is not set
	            if ($scope.allowOutsideDataSet && !$scope.sameInput) {
	
	                //then check for match in our selected data set
	                if (selected_set_check === undefined) $scope.update($scope.return_value(data_set_check, input));else $scope.hasError = true;
	
	                return;
	            }
	
	            //scenarios: when allowed outside data set is not set and not allowing same input
	            if (!$scope.allowOutsideDataSet && !$scope.sameInput) {
	                //then check for match in our selected data set and our main data set
	                if (data_set_check !== undefined && selected_set_check === undefined) $scope.update(data_set_check);else $scope.hasError = true;
	
	                return;
	            }
	
	            //scenarios: when allowed outside data set is not set and allowing same input
	            if (!$scope.allowOutsideDataSet && $scope.sameInput) {
	                //then check for match in our selected data set and our main data set
	                if (data_set_check !== undefined) $scope.update(data_set_check);else $scope.hasError = true;
	
	                return;
	            }
	
	            $scope.hasError = true;
	            $log.error("Error, Existing before in our output , or not among data set");
	        };
	    };
	
	    //inject into our controller required dependencies
	    controllerFunction.$inject = ['$scope', '$filter', '$log', '$timeout'];
	
	    var directive = function directive() {
	        return {
	            restrict: 'E',
	            require: '?^^form', //optoinal form incase the user wants required checking
	            scope: {
	                type: '@',
	                theme: '@', //help to get theme to use in manipulating tag via
	                data: '=?', //if set , is where we use in our data set to check if the entered item match any of the fields/items in it
	                selected: '=', //return the selected item(s)/tags here
	                sameInput: '=?', //to allow same input , that is a selected item can appear more than once in our tagging system
	                allowOutsideDataSet: '=?', //if the allowed input should be outside the data set specified
	                typehead: '=?', //used in turning type head to assist users when typing or not
	                displayField: '@', //field to display to the user in the data set to the tag view
	                placeholder: '@', //assist users so they can use their place holders , if not placed it wud use the default
	                delimiter: '=?', //delimiter to separate the text entered which is an array of delimiters
	                onTagAdded: '&', //event is passed via to the function to the directive to be called anytime u add a tag
	                onTagRemoved: '&', //event is passed via to the function to the directive to be called anytime we remove from the tag
	                onTagActive: '&', //event is passed via to the function to the directive to be called anytime a tag is active
	                max: '=?', //max tag that can be allowed
	                onTagMaximum: '&', //event called when the tag hits its maximum number of allowable input
	                required: '=?', //default false.if the input is required or not , and this is used when the input is empty and the selected is empty
	                name: '@', //is needed when the required is set true
	                minLength: '@', //minima longitud del contenido del tag
	                maxLength: '@', //maxima longitud del contenido del tag
	                validation: '<?' //validacion pattern para contenido de tags
	            },
	            templateUrl: function templateUrl(elem, attr) {
	                return 'angular-tag/templates/' + attr.type + '.html';
	            },
	            controller: controllerFunction, //Embed a custom controller in the directive
	            link: function link($scope, element, attrs, form) {
	                var our_input = angular.element(element.find("input")[0]);
	                $scope.form = data_init(form, undefined); //keep our parent form here if it is specified
	
	                our_input.bind('keyup', function ($event) {
	                    //check our input as they type for validity
	                    //here we bind form validity  if required is true
	                    if ($scope.required && $scope.selected.length === 0) //the form is invalid here
	                        if ($scope.form) {
	                            //if the form
	                            $scope.form[our_input.attr("name")].$setValidity('required', false);
	                        }
	                });
	            } //DOM manipulation
	        };
	    };
	
	    /**
	     * This directive helps to manipulate the text input to make it focusable
	     * @returns {{restrict: string, link: link}}
	     */
	    var directive_focus = function directive_focus() {
	        return {
	            restrict: 'A',
	            link: function link(scope, element, attrs) {
	                scope.$watch(attrs.focusMe, function (value) {
	                    if (value === true) element[0].focus();
	                });
	            } //DOM manipulation
	        };
	    };
	
	    var module = angular.module('angular-tag', ['angular-tag/templates']);
	    module.directive('tagMe', directive).directive('focusMe', directive_focus);
	})();
	
	angular.module('angular-tag/templates', []).run(['$templateCache', function ($templateCache) {
	    $templateCache.put('angular-tag/templates/input.html', '<div id="main-tag">\n\n                                                                <div class="tag-container">\n\n                                                                  <ul ng-class="[\'tag\',{focus:isFocus},theme ]" ng-click="isFocus=true" ng-keydown="direction_keys($event)">\n\n                                                                    <li ng-repeat="select in selected" ng-click="(moveToTag($event,$index)) "  data-drop="true" data-drag="true" ng-model="selected" jqyoui-droppable="{index: {{$index}}}" jqyoui-draggable="{index: {{$index}}, insertInline: true, direction:\'jqyouiDirection\'}" data-jqyoui-options="{revert: \'invalid\'}" data-direction="{{item.jqyouiDirection}}">\n      {{select[displayField]}}\n                                                                      <a href="javascript:void(0)" ng-click="remove(select)">&times;</a>\n\n                                                                       </li>\n<li>\n\n                                                                         <input ng-pattern="validation" ng-minlength="{{minLength}}" ng-maxlength="{{maxLength}}" name="{{name}}" ng-model="input" ng-keyup="on_input_keyup($event)" ng-keydown="on_input_keydown($event)" ng-focus="isFocus=true" ng-blur="onblur();" focus-me="isFocus"\n type="input" placeholder="{{placeholder}}" ng-required="required && (!selected.length || selected.length==0)" >\n\n                                                                       </li>\n\n                                                                  </ul>\n\n                                                                </div>\n\n\n                                                                <ul class="tag-typehead" ng-show="(isFocus && input.length && typehead && results.length) || (typehead && typeheadOpened) " >\n\n                                                                  <li class="animate-repeat" ng-repeat="item in data | filter:input as results">\n\n                                                                    <a href="javascript:void(0)" ng-click="processor(item[displayField])">{{item[displayField]}}</a>\n\n                                                                  </li>\n\n                                                                  <!--<li class="animate-repeat" ng-if="results.length == 0">\n\n                                                                  <strong>No results found...</strong>\n\n                                                                  </li>-->\n\n                                                                </ul>\n\n                                                              </div>');
	}]);

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(487);
	__webpack_require__(168);
	var MODULE_NAME = 'angular-chips';
	
	angular.module(MODULE_NAME, ['angular-tag']);
	
	module.exports = MODULE_NAME;

/***/ }),
/* 489 */
/***/ (function(module, exports) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**!
	 * The MIT License
	 *
	 * Copyright (c) 2013 the angular-leaflet-directive Team, http://tombatossals.github.io/angular-leaflet-directive
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in
	 * all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	 * THE SOFTWARE.
	 *
	 * angular-leaflet-directive
	 * https://github.com/tombatossals/angular-leaflet-directive
	 *
	 * @authors https://github.com/tombatossals/angular-leaflet-directive/graphs/contributors
	 */
	
	/*!
	*  angular-leaflet-directive  2015-11-06
	*  angular-leaflet-directive - An AngularJS directive to easily interact with Leaflet maps
	*  git: https://github.com/tombatossals/angular-leaflet-directive
	*/
	(function (angular) {
	  'use strict';
	
	  angular.module('leaflet-directive', []).directive('leaflet', ["$q", "leafletData", "leafletMapDefaults", "leafletHelpers", "leafletMapEvents", function ($q, leafletData, leafletMapDefaults, leafletHelpers, leafletMapEvents) {
	    return {
	      restrict: 'EA',
	      replace: true,
	      scope: {
	        center: '=',
	        lfCenter: '=',
	        defaults: '=',
	        maxbounds: '=',
	        bounds: '=',
	        markers: '=',
	        legend: '=',
	        geojson: '=',
	        paths: '=',
	        tiles: '=',
	        layers: '=',
	        controls: '=',
	        decorations: '=',
	        eventBroadcast: '=',
	        markersWatchOptions: '=',
	        geojsonWatchOptions: '='
	      },
	      transclude: true,
	      template: '<div class="angular-leaflet-map"><div ng-transclude></div></div>',
	      controller: ["$scope", function ($scope) {
	        this._leafletMap = $q.defer();
	        this.getMap = function () {
	          return this._leafletMap.promise;
	        };
	
	        this.getLeafletScope = function () {
	          return $scope;
	        };
	      }],
	
	      link: function link(scope, element, attrs, ctrl) {
	        var isDefined = leafletHelpers.isDefined;
	        var defaults = leafletMapDefaults.setDefaults(scope.defaults, attrs.id);
	        var mapEvents = leafletMapEvents.getAvailableMapEvents();
	        var addEvents = leafletMapEvents.addEvents;
	
	        scope.mapId = attrs.id;
	        leafletData.setDirectiveControls({}, attrs.id);
	
	        // Set width and height utility functions
	        function updateWidth() {
	          if (isNaN(attrs.width)) {
	            element.css('width', attrs.width);
	          } else {
	            element.css('width', attrs.width + 'px');
	          }
	        }
	
	        function updateHeight() {
	          if (isNaN(attrs.height)) {
	            element.css('height', attrs.height);
	          } else {
	            element.css('height', attrs.height + 'px');
	          }
	        }
	
	        // If the width attribute defined update css
	        // Then watch if bound property changes and update css
	        if (isDefined(attrs.width)) {
	          updateWidth();
	
	          scope.$watch(function () {
	            return element[0].getAttribute('width');
	          }, function () {
	            updateWidth();
	            setTimeout(function () {
	              map.invalidateSize();
	            }, 400);
	          });
	        }
	
	        // If the height attribute defined update css
	        // Then watch if bound property changes and update css
	        if (isDefined(attrs.height)) {
	          updateHeight();
	
	          scope.$watch(function () {
	            return element[0].getAttribute('height');
	          }, function () {
	            updateHeight();
	            setTimeout(function () {
	              map.invalidateSize();
	            }, 400);
	          });
	        }
	
	        // Create the Leaflet Map Object with the options
	        var map = new L.Map(element[0], leafletMapDefaults.getMapCreationDefaults(attrs.id));
	        ctrl._leafletMap.resolve(map);
	
	        if (!isDefined(attrs.center) && !isDefined(attrs.lfCenter)) {
	          map.setView([defaults.center.lat, defaults.center.lng], defaults.center.zoom);
	        }
	
	        // If no layers nor tiles defined, set the default tileLayer
	        if (!isDefined(attrs.tiles) && !isDefined(attrs.layers)) {
	          var tileLayerObj = L.tileLayer(defaults.tileLayer, defaults.tileLayerOptions);
	          tileLayerObj.addTo(map);
	          leafletData.setTiles(tileLayerObj, attrs.id);
	        }
	
	        // Set zoom control configuration
	        if (isDefined(map.zoomControl) && isDefined(defaults.zoomControlPosition)) {
	          map.zoomControl.setPosition(defaults.zoomControlPosition);
	        }
	
	        if (isDefined(map.zoomControl) && defaults.zoomControl === false) {
	          map.zoomControl.removeFrom(map);
	        }
	
	        if (isDefined(map.zoomsliderControl) && isDefined(defaults.zoomsliderControl) && defaults.zoomsliderControl === false) {
	          map.zoomsliderControl.removeFrom(map);
	        }
	
	        // if no event-broadcast attribute, all events are broadcasted
	        if (!isDefined(attrs.eventBroadcast)) {
	          var logic = 'broadcast';
	          addEvents(map, mapEvents, 'eventName', scope, logic);
	        }
	
	        // Resolve the map object to the promises
	        map.whenReady(function () {
	          leafletData.setMap(map, attrs.id);
	        });
	
	        scope.$on('$destroy', function () {
	          leafletMapDefaults.reset();
	          map.remove();
	          leafletData.unresolveMap(attrs.id);
	        });
	
	        //Handle request to invalidate the map size
	        //Up scope using $scope.$emit('invalidateSize')
	        //Down scope using $scope.$broadcast('invalidateSize')
	        scope.$on('invalidateSize', function () {
	          map.invalidateSize();
	        });
	      }
	    };
	  }]);
	
	  angular.module('leaflet-directive').factory('leafletBoundsHelpers', ["$log", "leafletHelpers", function ($log, leafletHelpers) {
	
	    var isArray = leafletHelpers.isArray;
	    var isNumber = leafletHelpers.isNumber;
	    var isFunction = leafletHelpers.isFunction;
	    var isDefined = leafletHelpers.isDefined;
	
	    function _isValidBounds(bounds) {
	      return angular.isDefined(bounds) && angular.isDefined(bounds.southWest) && angular.isDefined(bounds.northEast) && angular.isNumber(bounds.southWest.lat) && angular.isNumber(bounds.southWest.lng) && angular.isNumber(bounds.northEast.lat) && angular.isNumber(bounds.northEast.lng);
	    }
	
	    return {
	      createLeafletBounds: function createLeafletBounds(bounds) {
	        if (_isValidBounds(bounds)) {
	          return L.latLngBounds([bounds.southWest.lat, bounds.southWest.lng], [bounds.northEast.lat, bounds.northEast.lng]);
	        }
	      },
	
	      isValidBounds: _isValidBounds,
	
	      createBoundsFromArray: function createBoundsFromArray(boundsArray) {
	        if (!(isArray(boundsArray) && boundsArray.length === 2 && isArray(boundsArray[0]) && isArray(boundsArray[1]) && boundsArray[0].length === 2 && boundsArray[1].length === 2 && isNumber(boundsArray[0][0]) && isNumber(boundsArray[0][1]) && isNumber(boundsArray[1][0]) && isNumber(boundsArray[1][1]))) {
	          $log.error('[AngularJS - Leaflet] The bounds array is not valid.');
	          return;
	        }
	
	        return {
	          northEast: {
	            lat: boundsArray[0][0],
	            lng: boundsArray[0][1]
	          },
	          southWest: {
	            lat: boundsArray[1][0],
	            lng: boundsArray[1][1]
	          }
	        };
	      },
	
	      createBoundsFromLeaflet: function createBoundsFromLeaflet(lfBounds) {
	        if (!(isDefined(lfBounds) && isFunction(lfBounds.getNorthEast) && isFunction(lfBounds.getSouthWest))) {
	          $log.error('[AngularJS - Leaflet] The leaflet bounds is not valid object.');
	          return;
	        }
	
	        var northEast = lfBounds.getNorthEast();
	        var southWest = lfBounds.getSouthWest();
	
	        return {
	          northEast: {
	            lat: northEast.lat,
	            lng: northEast.lng
	          },
	          southWest: {
	            lat: southWest.lat,
	            lng: southWest.lng
	          }
	        };
	      }
	    };
	  }]);
	
	  angular.module('leaflet-directive').factory('leafletControlHelpers', ["$rootScope", "$log", "leafletHelpers", "leafletLayerHelpers", "leafletMapDefaults", function ($rootScope, $log, leafletHelpers, leafletLayerHelpers, leafletMapDefaults) {
	    var isDefined = leafletHelpers.isDefined;
	    var isObject = leafletHelpers.isObject;
	    var createLayer = leafletLayerHelpers.createLayer;
	    var _controls = {};
	    var errorHeader = leafletHelpers.errorHeader + ' [Controls] ';
	
	    var _controlLayersMustBeVisible = function _controlLayersMustBeVisible(baselayers, overlays, mapId) {
	      var defaults = leafletMapDefaults.getDefaults(mapId);
	      if (!defaults.controls.layers.visible) {
	        return false;
	      }
	
	      var atLeastOneControlItemMustBeShown = false;
	
	      if (isObject(baselayers)) {
	        Object.keys(baselayers).forEach(function (key) {
	          var layer = baselayers[key];
	          if (!isDefined(layer.layerOptions) || layer.layerOptions.showOnSelector !== false) {
	            atLeastOneControlItemMustBeShown = true;
	          }
	        });
	      }
	
	      if (isObject(overlays)) {
	        Object.keys(overlays).forEach(function (key) {
	          var layer = overlays[key];
	          if (!isDefined(layer.layerParams) || layer.layerParams.showOnSelector !== false) {
	            atLeastOneControlItemMustBeShown = true;
	          }
	        });
	      }
	
	      return atLeastOneControlItemMustBeShown;
	    };
	
	    var _createLayersControl = function _createLayersControl(mapId) {
	      var defaults = leafletMapDefaults.getDefaults(mapId);
	      var controlOptions = {
	        collapsed: defaults.controls.layers.collapsed,
	        position: defaults.controls.layers.position,
	        autoZIndex: false
	      };
	
	      angular.extend(controlOptions, defaults.controls.layers.options);
	
	      var control;
	      if (defaults.controls.layers && isDefined(defaults.controls.layers.control)) {
	        control = defaults.controls.layers.control.apply(this, [[], [], controlOptions]);
	      } else {
	        control = new L.control.layers([], [], controlOptions);
	      }
	
	      return control;
	    };
	
	    var controlTypes = {
	      draw: {
	        isPluginLoaded: function isPluginLoaded() {
	          if (!angular.isDefined(L.Control.Draw)) {
	            $log.error(errorHeader + ' Draw plugin is not loaded.');
	            return false;
	          }
	
	          return true;
	        },
	
	        checkValidParams: function checkValidParams() /* params */{
	          return true;
	        },
	
	        createControl: function createControl(params) {
	          return new L.Control.Draw(params);
	        }
	      },
	      scale: {
	        isPluginLoaded: function isPluginLoaded() {
	          return true;
	        },
	
	        checkValidParams: function checkValidParams() /* params */{
	          return true;
	        },
	
	        createControl: function createControl(params) {
	          return new L.control.scale(params);
	        }
	      },
	      fullscreen: {
	        isPluginLoaded: function isPluginLoaded() {
	          if (!angular.isDefined(L.Control.Fullscreen)) {
	            $log.error(errorHeader + ' Fullscreen plugin is not loaded.');
	            return false;
	          }
	
	          return true;
	        },
	
	        checkValidParams: function checkValidParams() /* params */{
	          return true;
	        },
	
	        createControl: function createControl(params) {
	          return new L.Control.Fullscreen(params);
	        }
	      },
	      search: {
	        isPluginLoaded: function isPluginLoaded() {
	          if (!angular.isDefined(L.Control.Search)) {
	            $log.error(errorHeader + ' Search plugin is not loaded.');
	            return false;
	          }
	
	          return true;
	        },
	
	        checkValidParams: function checkValidParams() /* params */{
	          return true;
	        },
	
	        createControl: function createControl(params) {
	          return new L.Control.Search(params);
	        }
	      },
	      custom: {},
	      minimap: {
	        isPluginLoaded: function isPluginLoaded() {
	          if (!angular.isDefined(L.Control.MiniMap)) {
	            $log.error(errorHeader + ' Minimap plugin is not loaded.');
	            return false;
	          }
	
	          return true;
	        },
	
	        checkValidParams: function checkValidParams(params) {
	          if (!isDefined(params.layer)) {
	            $log.warn(errorHeader + ' minimap "layer" option should be defined.');
	            return false;
	          }
	
	          return true;
	        },
	
	        createControl: function createControl(params) {
	          var layer = createLayer(params.layer);
	
	          if (!isDefined(layer)) {
	            $log.warn(errorHeader + ' minimap control "layer" could not be created.');
	            return;
	          }
	
	          return new L.Control.MiniMap(layer, params);
	        }
	      }
	    };
	
	    return {
	      layersControlMustBeVisible: _controlLayersMustBeVisible,
	
	      isValidControlType: function isValidControlType(type) {
	        return Object.keys(controlTypes).indexOf(type) !== -1;
	      },
	
	      createControl: function createControl(type, params) {
	        if (!controlTypes[type].checkValidParams(params)) {
	          return;
	        }
	
	        return controlTypes[type].createControl(params);
	      },
	
	      updateLayersControl: function updateLayersControl(map, mapId, loaded, baselayers, overlays, leafletLayers) {
	        var i;
	        var _layersControl = _controls[mapId];
	        var mustBeLoaded = _controlLayersMustBeVisible(baselayers, overlays, mapId);
	
	        if (isDefined(_layersControl) && loaded) {
	          for (i in leafletLayers.baselayers) {
	            _layersControl.removeLayer(leafletLayers.baselayers[i]);
	          }
	
	          for (i in leafletLayers.overlays) {
	            _layersControl.removeLayer(leafletLayers.overlays[i]);
	          }
	
	          map.removeControl(_layersControl);
	          delete _controls[mapId];
	        }
	
	        if (mustBeLoaded) {
	          _layersControl = _createLayersControl(mapId);
	          _controls[mapId] = _layersControl;
	          for (i in baselayers) {
	            var hideOnSelector = isDefined(baselayers[i].layerOptions) && baselayers[i].layerOptions.showOnSelector === false;
	            if (!hideOnSelector && isDefined(leafletLayers.baselayers[i])) {
	              _layersControl.addBaseLayer(leafletLayers.baselayers[i], baselayers[i].name);
	            }
	          }
	
	          for (i in overlays) {
	            var hideOverlayOnSelector = isDefined(overlays[i].layerParams) && overlays[i].layerParams.showOnSelector === false;
	            if (!hideOverlayOnSelector && isDefined(leafletLayers.overlays[i])) {
	              _layersControl.addOverlay(leafletLayers.overlays[i], overlays[i].name);
	            }
	          }
	
	          map.addControl(_layersControl);
	        }
	
	        return mustBeLoaded;
	      }
	    };
	  }]);
	
	  angular.module('leaflet-directive').service('leafletData', ["$log", "$q", "leafletHelpers", function ($log, $q, leafletHelpers) {
	    var getDefer = leafletHelpers.getDefer,
	        getUnresolvedDefer = leafletHelpers.getUnresolvedDefer,
	        setResolvedDefer = leafletHelpers.setResolvedDefer;
	
	    var _private = {};
	    var self = this;
	
	    var upperFirst = function upperFirst(string) {
	      return string.charAt(0).toUpperCase() + string.slice(1);
	    };
	
	    var _privateItems = ['map', 'tiles', 'layers', 'paths', 'markers', 'geoJSON', 'UTFGrid', //odd ball on naming convention keeping to not break
	    'decorations', 'directiveControls'];
	
	    //init
	    _privateItems.forEach(function (itemName) {
	      _private[itemName] = {};
	    });
	
	    this.unresolveMap = function (scopeId) {
	      var id = leafletHelpers.obtainEffectiveMapId(_private.map, scopeId);
	      _privateItems.forEach(function (itemName) {
	        _private[itemName][id] = undefined;
	      });
	    };
	
	    //int repetitive stuff (get and sets)
	    _privateItems.forEach(function (itemName) {
	      var name = upperFirst(itemName);
	      self['set' + name] = function (lObject, scopeId) {
	        var defer = getUnresolvedDefer(_private[itemName], scopeId);
	        defer.resolve(lObject);
	        setResolvedDefer(_private[itemName], scopeId);
	      };
	
	      self['get' + name] = function (scopeId) {
	        var defer = getDefer(_private[itemName], scopeId);
	        return defer.promise;
	      };
	    });
	  }]);
	
	  angular.module('leaflet-directive').service('leafletDirectiveControlsHelpers', ["$log", "leafletData", "leafletHelpers", function ($log, leafletData, leafletHelpers) {
	    var _isDefined = leafletHelpers.isDefined;
	    var _isString = leafletHelpers.isString;
	    var _isObject = leafletHelpers.isObject;
	    var _mainErrorHeader = leafletHelpers.errorHeader;
	
	    var _errorHeader = _mainErrorHeader + '[leafletDirectiveControlsHelpers';
	
	    var _extend = function _extend(id, thingToAddName, createFn, cleanFn) {
	      var _fnHeader = _errorHeader + '.extend] ';
	      var extender = {};
	      if (!_isDefined(thingToAddName)) {
	        $log.error(_fnHeader + 'thingToAddName cannot be undefined');
	        return;
	      }
	
	      if (_isString(thingToAddName) && _isDefined(createFn) && _isDefined(cleanFn)) {
	        extender[thingToAddName] = {
	          create: createFn,
	          clean: cleanFn
	        };
	      } else if (_isObject(thingToAddName) && !_isDefined(createFn) && !_isDefined(cleanFn)) {
	        extender = thingToAddName;
	      } else {
	        $log.error(_fnHeader + 'incorrect arguments');
	        return;
	      }
	
	      //add external control to create / destroy markers without a watch
	      leafletData.getDirectiveControls().then(function (controls) {
	        angular.extend(controls, extender);
	        leafletData.setDirectiveControls(controls, id);
	      });
	    };
	
	    return {
	      extend: _extend
	    };
	  }]);
	
	  angular.module('leaflet-directive').service('leafletGeoJsonHelpers', ["leafletHelpers", "leafletIterators", function (leafletHelpers, leafletIterators) {
	    var lHlp = leafletHelpers;
	    var lIt = leafletIterators;
	    var Point = function Point(lat, lng) {
	      this.lat = lat;
	      this.lng = lng;
	      return this;
	    };
	
	    var _getLat = function _getLat(value) {
	      if (Array.isArray(value) && value.length === 2) {
	        return value[1];
	      } else if (lHlp.isDefined(value.type) && value.type === 'Point') {
	        return +value.coordinates[1];
	      } else {
	        return +value.lat;
	      }
	    };
	
	    var _getLng = function _getLng(value) {
	      if (Array.isArray(value) && value.length === 2) {
	        return value[0];
	      } else if (lHlp.isDefined(value.type) && value.type === 'Point') {
	        return +value.coordinates[0];
	      } else {
	        return +value.lng;
	      }
	    };
	
	    var _validateCoords = function _validateCoords(coords) {
	      if (lHlp.isUndefined(coords)) {
	        return false;
	      }
	
	      if (lHlp.isArray(coords)) {
	        if (coords.length === 2 && lHlp.isNumber(coords[0]) && lHlp.isNumber(coords[1])) {
	          return true;
	        }
	      } else if (lHlp.isDefined(coords.type)) {
	        if (coords.type === 'Point' && lHlp.isArray(coords.coordinates) && coords.coordinates.length === 2 && lHlp.isNumber(coords.coordinates[0]) && lHlp.isNumber(coords.coordinates[1])) {
	          return true;
	        }
	      }
	
	      var ret = lIt.all(['lat', 'lng'], function (pos) {
	        return lHlp.isDefined(coords[pos]) && lHlp.isNumber(coords[pos]);
	      });
	
	      return ret;
	    };
	
	    var _getCoords = function _getCoords(value) {
	      if (!value || !_validateCoords(value)) {
	        return;
	      }
	
	      var p = null;
	      if (Array.isArray(value) && value.length === 2) {
	        p = new Point(value[1], value[0]);
	      } else if (lHlp.isDefined(value.type) && value.type === 'Point') {
	        p = new Point(value.coordinates[1], value.coordinates[0]);
	      } else {
	        return value;
	      }
	
	      //note angular.merge is avail in angular 1.4.X we might want to fill it here
	      return angular.extend(value, p); //tap on lat, lng if it doesnt exist
	    };
	
	    return {
	      getLat: _getLat,
	      getLng: _getLng,
	      validateCoords: _validateCoords,
	      getCoords: _getCoords
	    };
	  }]);
	
	  angular.module('leaflet-directive').service('leafletHelpers', ["$q", "$log", function ($q, $log) {
	    var _errorHeader = '[AngularJS - Leaflet] ';
	    var _copy = angular.copy;
	    var _clone = _copy;
	    /*
	    For parsing paths to a field in an object
	     Example:
	    var obj = {
	        bike:{
	         1: 'hi'
	         2: 'foo'
	        }
	    };
	    _getObjectValue(obj,"bike.1") returns 'hi'
	    this is getPath in ui-gmap
	     */
	    var _getObjectValue = function _getObjectValue(object, pathStr) {
	      var obj;
	      if (!object || !angular.isObject(object)) return;
	
	      //if the key is not a sting then we already have the value
	      if (pathStr === null || !angular.isString(pathStr)) {
	        return pathStr;
	      }
	
	      obj = object;
	      pathStr.split('.').forEach(function (value) {
	        if (obj) {
	          obj = obj[value];
	        }
	      });
	
	      return obj;
	    };
	
	    /*
	     Object Array Notation
	     _getObjectArrayPath("bike.one.two")
	     returns:
	     'bike["one"]["two"]'
	     */
	    var _getObjectArrayPath = function _getObjectArrayPath(pathStr) {
	      return pathStr.split('.').reduce(function (previous, current) {
	        return previous + '["' + current + '"]';
	      });
	    };
	
	    /* Object Dot Notation
	     _getObjectPath(["bike","one","two"])
	     returns:
	     "bike.one.two"
	     */
	    var _getObjectDotPath = function _getObjectDotPath(arrayOfStrings) {
	      return arrayOfStrings.reduce(function (previous, current) {
	        return previous + '.' + current;
	      });
	    };
	
	    function _obtainEffectiveMapId(d, mapId) {
	      var id;
	      var i;
	      if (!angular.isDefined(mapId)) {
	        if (Object.keys(d).length === 0) {
	          id = 'main';
	        } else if (Object.keys(d).length >= 1) {
	          for (i in d) {
	            if (d.hasOwnProperty(i)) {
	              id = i;
	            }
	          }
	        } else {
	          $log.error(_errorHeader + '- You have more than 1 map on the DOM, you must provide the map ID to the leafletData.getXXX call');
	        }
	      } else {
	        id = mapId;
	      }
	
	      return id;
	    }
	
	    function _getUnresolvedDefer(d, mapId) {
	      var id = _obtainEffectiveMapId(d, mapId);
	      var defer;
	
	      if (!angular.isDefined(d[id]) || d[id].resolvedDefer === true) {
	        defer = $q.defer();
	        d[id] = {
	          defer: defer,
	          resolvedDefer: false
	        };
	      } else {
	        defer = d[id].defer;
	      }
	
	      return defer;
	    }
	
	    var _isDefined = function _isDefined(value) {
	      return angular.isDefined(value) && value !== null;
	    };
	
	    var _isUndefined = function _isUndefined(value) {
	      return !_isDefined(value);
	    };
	
	    // BEGIN DIRECT PORT FROM AngularJS code base
	
	    var SPECIAL_CHARS_REGEXP = /([\:\-\_]+(.))/g;
	
	    var MOZ_HACK_REGEXP = /^moz([A-Z])/;
	
	    var PREFIX_REGEXP = /^((?:x|data)[\:\-_])/i;
	
	    /**
	    Converts snake_case to camelCase.
	    Also there is special case for Moz prefix starting with upper case letter.
	    @param name Name to normalize
	     */
	
	    var camelCase = function camelCase(name) {
	      return name.replace(SPECIAL_CHARS_REGEXP, function (_, separator, letter, offset) {
	        if (offset) {
	          return letter.toUpperCase();
	        } else {
	          return letter;
	        }
	      }).replace(MOZ_HACK_REGEXP, 'Moz$1');
	    };
	
	    /**
	    Converts all accepted directives format into proper directive name.
	    @param name Name to normalize
	     */
	
	    var directiveNormalize = function directiveNormalize(name) {
	      return camelCase(name.replace(PREFIX_REGEXP, ''));
	    };
	
	    // END AngularJS port
	
	    return {
	      camelCase: camelCase,
	      directiveNormalize: directiveNormalize,
	      copy: _copy,
	      clone: _clone,
	      errorHeader: _errorHeader,
	      getObjectValue: _getObjectValue,
	      getObjectArrayPath: _getObjectArrayPath,
	      getObjectDotPath: _getObjectDotPath,
	      defaultTo: function defaultTo(val, _default) {
	        return _isDefined(val) ? val : _default;
	      },
	
	      //mainly for checking attributes of directives lets keep this minimal (on what we accept)
	      isTruthy: function isTruthy(val) {
	        return val === 'true' || val === true;
	      },
	
	      //Determine if a reference is {}
	      isEmpty: function isEmpty(value) {
	        return Object.keys(value).length === 0;
	      },
	
	      //Determine if a reference is undefined or {}
	      isUndefinedOrEmpty: function isUndefinedOrEmpty(value) {
	        return angular.isUndefined(value) || value === null || Object.keys(value).length === 0;
	      },
	
	      // Determine if a reference is defined
	      isDefined: _isDefined,
	      isUndefined: _isUndefined,
	      isNumber: angular.isNumber,
	      isString: angular.isString,
	      isArray: angular.isArray,
	      isObject: angular.isObject,
	      isFunction: angular.isFunction,
	      equals: angular.equals,
	
	      isValidCenter: function isValidCenter(center) {
	        return angular.isDefined(center) && angular.isNumber(center.lat) && angular.isNumber(center.lng) && angular.isNumber(center.zoom);
	      },
	
	      isValidPoint: function isValidPoint(point) {
	        if (!angular.isDefined(point)) {
	          return false;
	        }
	
	        if (angular.isArray(point)) {
	          return point.length === 2 && angular.isNumber(point[0]) && angular.isNumber(point[1]);
	        }
	
	        return angular.isNumber(point.lat) && angular.isNumber(point.lng);
	      },
	
	      isSameCenterOnMap: function isSameCenterOnMap(centerModel, map) {
	        var mapCenter = map.getCenter();
	        var zoom = map.getZoom();
	        if (centerModel.lat && centerModel.lng && mapCenter.lat.toFixed(4) === centerModel.lat.toFixed(4) && mapCenter.lng.toFixed(4) === centerModel.lng.toFixed(4) && zoom === centerModel.zoom) {
	          return true;
	        }
	
	        return false;
	      },
	
	      safeApply: function safeApply($scope, fn) {
	        var phase = $scope.$root.$$phase;
	        if (phase === '$apply' || phase === '$digest') {
	          $scope.$eval(fn);
	        } else {
	          $scope.$evalAsync(fn);
	        }
	      },
	
	      obtainEffectiveMapId: _obtainEffectiveMapId,
	
	      getDefer: function getDefer(d, mapId) {
	        var id = _obtainEffectiveMapId(d, mapId);
	        var defer;
	        if (!angular.isDefined(d[id]) || d[id].resolvedDefer === false) {
	          defer = _getUnresolvedDefer(d, mapId);
	        } else {
	          defer = d[id].defer;
	        }
	
	        return defer;
	      },
	
	      getUnresolvedDefer: _getUnresolvedDefer,
	
	      setResolvedDefer: function setResolvedDefer(d, mapId) {
	        var id = _obtainEffectiveMapId(d, mapId);
	        d[id].resolvedDefer = true;
	      },
	
	      rangeIsSupported: function rangeIsSupported() {
	        var testrange = document.createElement('input');
	        testrange.setAttribute('type', 'range');
	        return testrange.type === 'range';
	      },
	
	      FullScreenControlPlugin: {
	        isLoaded: function isLoaded() {
	          return angular.isDefined(L.Control.Fullscreen);
	        }
	      },
	
	      MiniMapControlPlugin: {
	        isLoaded: function isLoaded() {
	          return angular.isDefined(L.Control.MiniMap);
	        }
	      },
	
	      AwesomeMarkersPlugin: {
	        isLoaded: function isLoaded() {
	          return angular.isDefined(L.AwesomeMarkers) && angular.isDefined(L.AwesomeMarkers.Icon);
	        },
	
	        is: function is(icon) {
	          if (this.isLoaded()) {
	            return icon instanceof L.AwesomeMarkers.Icon;
	          } else {
	            return false;
	          }
	        },
	
	        equal: function equal(iconA, iconB) {
	          if (!this.isLoaded()) {
	            return false;
	          }
	
	          if (this.is(iconA)) {
	            return angular.equals(iconA, iconB);
	          } else {
	            return false;
	          }
	        }
	      },
	
	      VectorMarkersPlugin: {
	        isLoaded: function isLoaded() {
	          return angular.isDefined(L.VectorMarkers) && angular.isDefined(L.VectorMarkers.Icon);
	        },
	
	        is: function is(icon) {
	          if (this.isLoaded()) {
	            return icon instanceof L.VectorMarkers.Icon;
	          } else {
	            return false;
	          }
	        },
	
	        equal: function equal(iconA, iconB) {
	          if (!this.isLoaded()) {
	            return false;
	          }
	
	          if (this.is(iconA)) {
	            return angular.equals(iconA, iconB);
	          } else {
	            return false;
	          }
	        }
	      },
	
	      DomMarkersPlugin: {
	        isLoaded: function isLoaded() {
	          if (angular.isDefined(L.DomMarkers) && angular.isDefined(L.DomMarkers.Icon)) {
	            return true;
	          } else {
	            return false;
	          }
	        },
	
	        is: function is(icon) {
	          if (this.isLoaded()) {
	            return icon instanceof L.DomMarkers.Icon;
	          } else {
	            return false;
	          }
	        },
	
	        equal: function equal(iconA, iconB) {
	          if (!this.isLoaded()) {
	            return false;
	          }
	
	          if (this.is(iconA)) {
	            return angular.equals(iconA, iconB);
	          } else {
	            return false;
	          }
	        }
	      },
	
	      PolylineDecoratorPlugin: {
	        isLoaded: function isLoaded() {
	          if (angular.isDefined(L.PolylineDecorator)) {
	            return true;
	          } else {
	            return false;
	          }
	        },
	
	        is: function is(decoration) {
	          if (this.isLoaded()) {
	            return decoration instanceof L.PolylineDecorator;
	          } else {
	            return false;
	          }
	        },
	
	        equal: function equal(decorationA, decorationB) {
	          if (!this.isLoaded()) {
	            return false;
	          }
	
	          if (this.is(decorationA)) {
	            return angular.equals(decorationA, decorationB);
	          } else {
	            return false;
	          }
	        }
	      },
	
	      MakiMarkersPlugin: {
	        isLoaded: function isLoaded() {
	          if (angular.isDefined(L.MakiMarkers) && angular.isDefined(L.MakiMarkers.Icon)) {
	            return true;
	          } else {
	            return false;
	          }
	        },
	
	        is: function is(icon) {
	          if (this.isLoaded()) {
	            return icon instanceof L.MakiMarkers.Icon;
	          } else {
	            return false;
	          }
	        },
	
	        equal: function equal(iconA, iconB) {
	          if (!this.isLoaded()) {
	            return false;
	          }
	
	          if (this.is(iconA)) {
	            return angular.equals(iconA, iconB);
	          } else {
	            return false;
	          }
	        }
	      },
	      ExtraMarkersPlugin: {
	        isLoaded: function isLoaded() {
	          if (angular.isDefined(L.ExtraMarkers) && angular.isDefined(L.ExtraMarkers.Icon)) {
	            return true;
	          } else {
	            return false;
	          }
	        },
	
	        is: function is(icon) {
	          if (this.isLoaded()) {
	            return icon instanceof L.ExtraMarkers.Icon;
	          } else {
	            return false;
	          }
	        },
	
	        equal: function equal(iconA, iconB) {
	          if (!this.isLoaded()) {
	            return false;
	          }
	
	          if (this.is(iconA)) {
	            return angular.equals(iconA, iconB);
	          } else {
	            return false;
	          }
	        }
	      },
	      LabelPlugin: {
	        isLoaded: function isLoaded() {
	          return angular.isDefined(L.Label);
	        },
	
	        is: function is(layer) {
	          if (this.isLoaded()) {
	            return layer instanceof L.MarkerClusterGroup;
	          } else {
	            return false;
	          }
	        }
	      },
	      MarkerClusterPlugin: {
	        isLoaded: function isLoaded() {
	          return angular.isDefined(L.MarkerClusterGroup);
	        },
	
	        is: function is(layer) {
	          if (this.isLoaded()) {
	            return layer instanceof L.MarkerClusterGroup;
	          } else {
	            return false;
	          }
	        }
	      },
	      GoogleLayerPlugin: {
	        isLoaded: function isLoaded() {
	          return angular.isDefined(L.Google);
	        },
	
	        is: function is(layer) {
	          if (this.isLoaded()) {
	            return layer instanceof L.Google;
	          } else {
	            return false;
	          }
	        }
	      },
	      LeafletProviderPlugin: {
	        isLoaded: function isLoaded() {
	          return angular.isDefined(L.TileLayer.Provider);
	        },
	
	        is: function is(layer) {
	          if (this.isLoaded()) {
	            return layer instanceof L.TileLayer.Provider;
	          } else {
	            return false;
	          }
	        }
	      },
	      ChinaLayerPlugin: {
	        isLoaded: function isLoaded() {
	          return angular.isDefined(L.tileLayer.chinaProvider);
	        }
	      },
	      HeatLayerPlugin: {
	        isLoaded: function isLoaded() {
	          return angular.isDefined(L.heatLayer);
	        }
	      },
	      WebGLHeatMapLayerPlugin: {
	        isLoaded: function isLoaded() {
	          return angular.isDefined(L.TileLayer.WebGLHeatMap);
	        }
	      },
	      BingLayerPlugin: {
	        isLoaded: function isLoaded() {
	          return angular.isDefined(L.BingLayer);
	        },
	
	        is: function is(layer) {
	          if (this.isLoaded()) {
	            return layer instanceof L.BingLayer;
	          } else {
	            return false;
	          }
	        }
	      },
	      WFSLayerPlugin: {
	        isLoaded: function isLoaded() {
	          return L.GeoJSON.WFS !== undefined;
	        },
	
	        is: function is(layer) {
	          if (this.isLoaded()) {
	            return layer instanceof L.GeoJSON.WFS;
	          } else {
	            return false;
	          }
	        }
	      },
	      AGSBaseLayerPlugin: {
	        isLoaded: function isLoaded() {
	          return L.esri !== undefined && L.esri.basemapLayer !== undefined;
	        },
	
	        is: function is(layer) {
	          if (this.isLoaded()) {
	            return layer instanceof L.esri.basemapLayer;
	          } else {
	            return false;
	          }
	        }
	      },
	      AGSLayerPlugin: {
	        isLoaded: function isLoaded() {
	          return lvector !== undefined && lvector.AGS !== undefined;
	        },
	
	        is: function is(layer) {
	          if (this.isLoaded()) {
	            return layer instanceof lvector.AGS;
	          } else {
	            return false;
	          }
	        }
	      },
	      AGSFeatureLayerPlugin: {
	        isLoaded: function isLoaded() {
	          return L.esri !== undefined && L.esri.featureLayer !== undefined;
	        },
	
	        is: function is(layer) {
	          if (this.isLoaded()) {
	            return layer instanceof L.esri.featureLayer;
	          } else {
	            return false;
	          }
	        }
	      },
	      AGSTiledMapLayerPlugin: {
	        isLoaded: function isLoaded() {
	          return L.esri !== undefined && L.esri.tiledMapLayer !== undefined;
	        },
	
	        is: function is(layer) {
	          if (this.isLoaded()) {
	            return layer instanceof L.esri.tiledMapLayer;
	          } else {
	            return false;
	          }
	        }
	      },
	      AGSDynamicMapLayerPlugin: {
	        isLoaded: function isLoaded() {
	          return L.esri !== undefined && L.esri.dynamicMapLayer !== undefined;
	        },
	
	        is: function is(layer) {
	          if (this.isLoaded()) {
	            return layer instanceof L.esri.dynamicMapLayer;
	          } else {
	            return false;
	          }
	        }
	      },
	      AGSImageMapLayerPlugin: {
	        isLoaded: function isLoaded() {
	          return L.esri !== undefined && L.esri.imageMapLayer !== undefined;
	        },
	
	        is: function is(layer) {
	          if (this.isLoaded()) {
	            return layer instanceof L.esri.imageMapLayer;
	          } else {
	            return false;
	          }
	        }
	      },
	      AGSClusteredLayerPlugin: {
	        isLoaded: function isLoaded() {
	          return L.esri !== undefined && L.esri.clusteredFeatureLayer !== undefined;
	        },
	
	        is: function is(layer) {
	          if (this.isLoaded()) {
	            return layer instanceof L.esri.clusteredFeatureLayer;
	          } else {
	            return false;
	          }
	        }
	      },
	      AGSHeatmapLayerPlugin: {
	        isLoaded: function isLoaded() {
	          return L.esri !== undefined && L.esri.heatmapFeatureLayer !== undefined;
	        },
	
	        is: function is(layer) {
	          if (this.isLoaded()) {
	            return layer instanceof L.esri.heatmapFeatureLayer;
	          } else {
	            return false;
	          }
	        }
	      },
	      YandexLayerPlugin: {
	        isLoaded: function isLoaded() {
	          return angular.isDefined(L.Yandex);
	        },
	
	        is: function is(layer) {
	          if (this.isLoaded()) {
	            return layer instanceof L.Yandex;
	          } else {
	            return false;
	          }
	        }
	      },
	      GeoJSONPlugin: {
	        isLoaded: function isLoaded() {
	          return angular.isDefined(L.TileLayer.GeoJSON);
	        },
	
	        is: function is(layer) {
	          if (this.isLoaded()) {
	            return layer instanceof L.TileLayer.GeoJSON;
	          } else {
	            return false;
	          }
	        }
	      },
	      UTFGridPlugin: {
	        isLoaded: function isLoaded() {
	          return angular.isDefined(L.UtfGrid);
	        },
	
	        is: function is(layer) {
	          if (this.isLoaded()) {
	            return layer instanceof L.UtfGrid;
	          } else {
	            $log.error('[AngularJS - Leaflet] No UtfGrid plugin found.');
	            return false;
	          }
	        }
	      },
	      CartoDB: {
	        isLoaded: function isLoaded() {
	          return cartodb;
	        },
	
	        is: function is() /*layer*/{
	          return true;
	          /*
	          if (this.isLoaded()) {
	              return layer instanceof L.TileLayer.GeoJSON;
	          } else {
	              return false;
	          }*/
	        }
	      },
	      Leaflet: {
	        DivIcon: {
	          is: function is(icon) {
	            return icon instanceof L.DivIcon;
	          },
	
	          equal: function equal(iconA, iconB) {
	            if (this.is(iconA)) {
	              return angular.equals(iconA, iconB);
	            } else {
	              return false;
	            }
	          }
	        },
	        Icon: {
	          is: function is(icon) {
	            return icon instanceof L.Icon;
	          },
	
	          equal: function equal(iconA, iconB) {
	            if (this.is(iconA)) {
	              return angular.equals(iconA, iconB);
	            } else {
	              return false;
	            }
	          }
	        }
	      },
	      /*
	       watchOptions - object to set deep nested watches and turn off watches all together
	       (rely on control / functional updates)
	       watchOptions - Object
	           doWatch:boolean
	           isDeep:boolean (sets $watch(function,isDeep))
	           individual
	               doWatch:boolean
	               isDeep:boolean
	       */
	
	      //legacy defaults
	      watchOptions: {
	        doWatch: true,
	        isDeep: true,
	        individual: {
	          doWatch: true,
	          isDeep: true
	        }
	      }
	    };
	  }]);
	
	  angular.module('leaflet-directive').service('leafletIterators', ["$log", "leafletHelpers", function ($log, leafletHelpers) {
	
	    var lHlp = leafletHelpers;
	    var errorHeader = leafletHelpers.errorHeader + 'leafletIterators: ';
	
	    //BEGIN COPY from underscore
	    var _keys = Object.keys;
	    var _isFunction = lHlp.isFunction;
	    var _isObject = lHlp.isObject;
	
	    // Helper for collection methods to determine whether a collection
	    // should be iterated as an array or as an object
	    // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
	    var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
	
	    var _isArrayLike = function _isArrayLike(collection) {
	      var length = collection !== null && collection.length;
	      return lHlp.isNumber(length) && length >= 0 && length <= MAX_ARRAY_INDEX;
	    };
	
	    // Keep the identity function around for default iteratees.
	    var _identity = function _identity(value) {
	      return value;
	    };
	
	    var _property = function _property(key) {
	      return function (obj) {
	        return obj === null ? void 0 : obj[key];
	      };
	    };
	
	    // Internal function that returns an efficient (for current engines) version
	    // of the passed-in callback, to be repeatedly applied in other Underscore
	    // functions.
	    var optimizeCb = function optimizeCb(func, context, argCount) {
	      if (context === void 0) return func;
	      switch (argCount === null ? 3 : argCount) {
	        case 1:
	          return function (value) {
	            return func.call(context, value);
	          };
	
	        case 2:
	          return function (value, other) {
	            return func.call(context, value, other);
	          };
	
	        case 3:
	          return function (value, index, collection) {
	            return func.call(context, value, index, collection);
	          };
	
	        case 4:
	          return function (accumulator, value, index, collection) {
	            return func.call(context, accumulator, value, index, collection);
	          };
	      }
	      return function () {
	        return func.apply(context, arguments);
	      };
	    };
	
	    // An internal function for creating assigner functions.
	    var createAssigner = function createAssigner(keysFunc, undefinedOnly) {
	      return function (obj) {
	        var length = arguments.length;
	        if (length < 2 || obj === null) return obj;
	        for (var index = 1; index < length; index++) {
	          var source = arguments[index];
	          var keys = keysFunc(source);
	          var l = keys.length;
	
	          for (var i = 0; i < l; i++) {
	            var key = keys[i];
	            if (!undefinedOnly || obj[key] === void 0) obj[key] = source[key];
	          }
	        }
	
	        return obj;
	      };
	    };
	
	    // Assigns a given object with all the own properties in the passed-in object(s)
	    // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
	    var _extendOwn;
	    var _assign = null;
	    _extendOwn = _assign = createAssigner(_keys);
	
	    // Returns whether an object has a given set of `key:value` pairs.
	    var _isMatch = function _isMatch(object, attrs) {
	      var keys = _keys(attrs);
	      var length = keys.length;
	      if (object === null) return !length;
	      var obj = Object(object);
	      for (var i = 0; i < length; i++) {
	        var key = keys[i];
	        if (attrs[key] !== obj[key] || !(key in obj)) return false;
	      }
	
	      return true;
	    };
	
	    // Returns a predicate for checking whether an object has a given set of
	    // `key:value` pairs.
	    var _matcher;
	    var _matches = null;
	    _matcher = _matches = function _matches(attrs) {
	      attrs = _extendOwn({}, attrs);
	      return function (obj) {
	        return _isMatch(obj, attrs);
	      };
	    };
	
	    // A mostly-internal function to generate callbacks that can be applied
	    // to each element in a collection, returning the desired result — either
	    // identity, an arbitrary callback, a property matcher, or a property accessor.
	    var cb = function cb(value, context, argCount) {
	      if (value === null) return _identity;
	      if (_isFunction(value)) return optimizeCb(value, context, argCount);
	      if (_isObject(value)) return _matcher(value);
	      return _property(value);
	    };
	
	    var _every;
	    var _all = null;
	    _every = _all = function _all(obj, predicate, context) {
	      predicate = cb(predicate, context);
	      var keys = !_isArrayLike(obj) && _keys(obj);
	      var length = (keys || obj).length;
	      for (var index = 0; index < length; index++) {
	        var currentKey = keys ? keys[index] : index;
	        if (!predicate(obj[currentKey], currentKey, obj)) return false;
	      }
	
	      return true;
	    };
	
	    //END COPY fron underscore
	
	    var _hasErrors = function _hasErrors(collection, cb, ignoreCollection, cbName) {
	      if (!ignoreCollection) {
	        if (!lHlp.isDefined(collection) || !lHlp.isDefined(cb)) {
	          return true;
	        }
	      }
	
	      if (!lHlp.isFunction(cb)) {
	        cbName = lHlp.defaultTo(cb, 'cb');
	        $log.error(errorHeader + cbName + ' is not a function');
	        return true;
	      }
	
	      return false;
	    };
	
	    var _iterate = function _iterate(collection, externalCb, internalCb) {
	      if (_hasErrors(undefined, internalCb, true, 'internalCb')) {
	        return;
	      }
	
	      if (!_hasErrors(collection, externalCb)) {
	        for (var key in collection) {
	          if (collection.hasOwnProperty(key)) {
	            internalCb(collection[key], key);
	          }
	        }
	      }
	    };
	
	    //see http://jsperf.com/iterators/3
	    //utilizing for in is way faster
	    var _each = function _each(collection, cb) {
	      _iterate(collection, cb, function (val, key) {
	        cb(val, key);
	      });
	    };
	
	    return {
	      each: _each,
	      forEach: _each,
	      every: _every,
	      all: _all
	    };
	  }]);
	
	  angular.module('leaflet-directive').factory('leafletLayerHelpers', ["$rootScope", "$log", "$q", "leafletHelpers", "leafletIterators", function ($rootScope, $log, $q, leafletHelpers, leafletIterators) {
	    var Helpers = leafletHelpers;
	    var isString = leafletHelpers.isString;
	    var isObject = leafletHelpers.isObject;
	    var isArray = leafletHelpers.isArray;
	    var isDefined = leafletHelpers.isDefined;
	    var errorHeader = leafletHelpers.errorHeader;
	    var $it = leafletIterators;
	
	    var utfGridCreateLayer = function utfGridCreateLayer(params) {
	      if (!Helpers.UTFGridPlugin.isLoaded()) {
	        $log.error('[AngularJS - Leaflet] The UTFGrid plugin is not loaded.');
	        return;
	      }
	
	      var utfgrid = new L.UtfGrid(params.url, params.pluginOptions);
	
	      utfgrid.on('mouseover', function (e) {
	        $rootScope.$broadcast('leafletDirectiveMap.utfgridMouseover', e);
	      });
	
	      utfgrid.on('mouseout', function (e) {
	        $rootScope.$broadcast('leafletDirectiveMap.utfgridMouseout', e);
	      });
	
	      utfgrid.on('click', function (e) {
	        $rootScope.$broadcast('leafletDirectiveMap.utfgridClick', e);
	      });
	
	      utfgrid.on('mousemove', function (e) {
	        $rootScope.$broadcast('leafletDirectiveMap.utfgridMousemove', e);
	      });
	
	      return utfgrid;
	    };
	
	    var layerTypes = {
	      xyz: {
	        mustHaveUrl: true,
	        createLayer: function createLayer(params) {
	          return L.tileLayer(params.url, params.options);
	        }
	      },
	      mapbox: {
	        mustHaveKey: true,
	        createLayer: function createLayer(params) {
	          var version = 3;
	          if (isDefined(params.options.version) && params.options.version === 4) {
	            version = params.options.version;
	          }
	
	          var url = version === 3 ? '//{s}.tiles.mapbox.com/v3/' + params.key + '/{z}/{x}/{y}.png' : '//api.tiles.mapbox.com/v4/' + params.key + '/{z}/{x}/{y}.png?access_token=' + params.apiKey;
	          return L.tileLayer(url, params.options);
	        }
	      },
	      geoJSON: {
	        mustHaveUrl: true,
	        createLayer: function createLayer(params) {
	          if (!Helpers.GeoJSONPlugin.isLoaded()) {
	            return;
	          }
	
	          return new L.TileLayer.GeoJSON(params.url, params.pluginOptions, params.options);
	        }
	      },
	      geoJSONShape: {
	        mustHaveUrl: false,
	        createLayer: function createLayer(params) {
	          return new L.GeoJSON(params.data, params.options);
	        }
	      },
	      geoJSONAwesomeMarker: {
	        mustHaveUrl: false,
	        createLayer: function createLayer(params) {
	          return new L.geoJson(params.data, {
	            pointToLayer: function pointToLayer(feature, latlng) {
	              return L.marker(latlng, { icon: L.AwesomeMarkers.icon(params.icon) });
	            }
	          });
	        }
	      },
	      geoJSONVectorMarker: {
	        mustHaveUrl: false,
	        createLayer: function createLayer(params) {
	          return new L.geoJson(params.data, {
	            pointToLayer: function pointToLayer(feature, latlng) {
	              return L.marker(latlng, { icon: L.VectorMarkers.icon(params.icon) });
	            }
	          });
	        }
	      },
	      utfGrid: {
	        mustHaveUrl: true,
	        createLayer: utfGridCreateLayer
	      },
	      cartodbTiles: {
	        mustHaveKey: true,
	        createLayer: function createLayer(params) {
	          var url = '//' + params.user + '.cartodb.com/api/v1/map/' + params.key + '/{z}/{x}/{y}.png';
	          return L.tileLayer(url, params.options);
	        }
	      },
	      cartodbUTFGrid: {
	        mustHaveKey: true,
	        mustHaveLayer: true,
	        createLayer: function createLayer(params) {
	          params.url = '//' + params.user + '.cartodb.com/api/v1/map/' + params.key + '/' + params.layer + '/{z}/{x}/{y}.grid.json';
	          return utfGridCreateLayer(params);
	        }
	      },
	      cartodbInteractive: {
	        mustHaveKey: true,
	        mustHaveLayer: true,
	        createLayer: function createLayer(params) {
	          var tilesURL = '//' + params.user + '.cartodb.com/api/v1/map/' + params.key + '/{z}/{x}/{y}.png';
	          var tileLayer = L.tileLayer(tilesURL, params.options);
	          params.url = '//' + params.user + '.cartodb.com/api/v1/map/' + params.key + '/' + params.layer + '/{z}/{x}/{y}.grid.json';
	          var utfLayer = utfGridCreateLayer(params);
	          return L.layerGroup([tileLayer, utfLayer]);
	        }
	      },
	      wms: {
	        mustHaveUrl: true,
	        createLayer: function createLayer(params) {
	          return L.tileLayer.wms(params.url, params.options);
	        }
	      },
	      wmts: {
	        mustHaveUrl: true,
	        createLayer: function createLayer(params) {
	          return L.tileLayer.wmts(params.url, params.options);
	        }
	      },
	      wfs: {
	        mustHaveUrl: true,
	        mustHaveLayer: true,
	        createLayer: function createLayer(params) {
	          if (!Helpers.WFSLayerPlugin.isLoaded()) {
	            return;
	          }
	
	          var options = angular.copy(params.options);
	          if (options.crs && typeof options.crs === 'string') {
	            /*jshint -W061 */
	            options.crs = eval(options.crs);
	          }
	
	          return new L.GeoJSON.WFS(params.url, params.layer, options);
	        }
	      },
	      group: {
	        mustHaveUrl: false,
	        createLayer: function createLayer(params) {
	          var lyrs = [];
	          $it.each(params.options.layers, function (l) {
	            lyrs.push(_createLayer(l));
	          });
	
	          params.options.loadedDefer = function () {
	            var defers = [];
	            if (isDefined(params.options.layers)) {
	              for (var i = 0; i < params.options.layers.length; i++) {
	                var d = params.options.layers[i].layerOptions.loadedDefer;
	                if (isDefined(d)) {
	                  defers.push(d);
	                }
	              }
	            }
	
	            return defers;
	          };
	
	          return L.layerGroup(lyrs);
	        }
	      },
	      featureGroup: {
	        mustHaveUrl: false,
	        createLayer: function createLayer() {
	          return L.featureGroup();
	        }
	      },
	      google: {
	        mustHaveUrl: false,
	        createLayer: function createLayer(params) {
	          var type = params.type || 'SATELLITE';
	          if (!Helpers.GoogleLayerPlugin.isLoaded()) {
	            return;
	          }
	
	          return new L.Google(type, params.options);
	        }
	      },
	      here: {
	        mustHaveUrl: false,
	        createLayer: function createLayer(params) {
	          var provider = params.provider || 'HERE.terrainDay';
	          if (!Helpers.LeafletProviderPlugin.isLoaded()) {
	            return;
	          }
	
	          return new L.TileLayer.Provider(provider, params.options);
	        }
	      },
	      china: {
	        mustHaveUrl: false,
	        createLayer: function createLayer(params) {
	          var type = params.type || '';
	          if (!Helpers.ChinaLayerPlugin.isLoaded()) {
	            return;
	          }
	
	          return L.tileLayer.chinaProvider(type, params.options);
	        }
	      },
	      agsBase: {
	        mustHaveLayer: true,
	        createLayer: function createLayer(params) {
	          if (!Helpers.AGSBaseLayerPlugin.isLoaded()) {
	            return;
	          }
	
	          return L.esri.basemapLayer(params.layer, params.options);
	        }
	      },
	      ags: {
	        mustHaveUrl: true,
	        createLayer: function createLayer(params) {
	          if (!Helpers.AGSLayerPlugin.isLoaded()) {
	            return;
	          }
	
	          var options = angular.copy(params.options);
	          angular.extend(options, {
	            url: params.url
	          });
	          var layer = new lvector.AGS(options);
	          layer.onAdd = function (map) {
	            this.setMap(map);
	          };
	
	          layer.onRemove = function () {
	            this.setMap(null);
	          };
	
	          return layer;
	        }
	      },
	      agsFeature: {
	        mustHaveUrl: true,
	        createLayer: function createLayer(params) {
	          if (!Helpers.AGSFeatureLayerPlugin.isLoaded()) {
	            $log.warn(errorHeader + ' The esri plugin is not loaded.');
	            return;
	          }
	
	          params.options.url = params.url;
	
	          var layer = L.esri.featureLayer(params.options);
	          var load = function load() {
	            if (isDefined(params.options.loadedDefer)) {
	              params.options.loadedDefer.resolve();
	            }
	          };
	
	          layer.on('loading', function () {
	            params.options.loadedDefer = $q.defer();
	            layer.off('load', load);
	            layer.on('load', load);
	          });
	
	          return layer;
	        }
	      },
	      agsTiled: {
	        mustHaveUrl: true,
	        createLayer: function createLayer(params) {
	          if (!Helpers.AGSTiledMapLayerPlugin.isLoaded()) {
	            $log.warn(errorHeader + ' The esri plugin is not loaded.');
	            return;
	          }
	
	          params.options.url = params.url;
	
	          return L.esri.tiledMapLayer(params.options);
	        }
	      },
	      agsDynamic: {
	        mustHaveUrl: true,
	        createLayer: function createLayer(params) {
	          if (!Helpers.AGSDynamicMapLayerPlugin.isLoaded()) {
	            $log.warn(errorHeader + ' The esri plugin is not loaded.');
	            return;
	          }
	
	          params.options.url = params.url;
	
	          return L.esri.dynamicMapLayer(params.options);
	        }
	      },
	      agsImage: {
	        mustHaveUrl: true,
	        createLayer: function createLayer(params) {
	          if (!Helpers.AGSImageMapLayerPlugin.isLoaded()) {
	            $log.warn(errorHeader + ' The esri plugin is not loaded.');
	            return;
	          }
	
	          params.options.url = params.url;
	
	          return L.esri.imageMapLayer(params.options);
	        }
	      },
	      agsClustered: {
	        mustHaveUrl: true,
	        createLayer: function createLayer(params) {
	          if (!Helpers.AGSClusteredLayerPlugin.isLoaded()) {
	            $log.warn(errorHeader + ' The esri clustered layer plugin is not loaded.');
	            return;
	          }
	
	          if (!Helpers.MarkerClusterPlugin.isLoaded()) {
	            $log.warn(errorHeader + ' The markercluster plugin is not loaded.');
	            return;
	          }
	
	          return L.esri.clusteredFeatureLayer(params.url, params.options);
	        }
	      },
	      agsHeatmap: {
	        mustHaveUrl: true,
	        createLayer: function createLayer(params) {
	          if (!Helpers.AGSHeatmapLayerPlugin.isLoaded()) {
	            $log.warn(errorHeader + ' The esri heatmap layer plugin is not loaded.');
	            return;
	          }
	
	          if (!Helpers.HeatLayerPlugin.isLoaded()) {
	            $log.warn(errorHeader + ' The heatlayer plugin is not loaded.');
	            return;
	          }
	
	          return L.esri.heatmapFeatureLayer(params.url, params.options);
	        }
	      },
	      markercluster: {
	        mustHaveUrl: false,
	        createLayer: function createLayer(params) {
	          if (!Helpers.MarkerClusterPlugin.isLoaded()) {
	            $log.warn(errorHeader + ' The markercluster plugin is not loaded.');
	            return;
	          }
	
	          return new L.MarkerClusterGroup(params.options);
	        }
	      },
	      bing: {
	        mustHaveUrl: false,
	        createLayer: function createLayer(params) {
	          if (!Helpers.BingLayerPlugin.isLoaded()) {
	            return;
	          }
	
	          return new L.BingLayer(params.key, params.options);
	        }
	      },
	      webGLHeatmap: {
	        mustHaveUrl: false,
	        mustHaveData: true,
	        createLayer: function createLayer(params) {
	          if (!Helpers.WebGLHeatMapLayerPlugin.isLoaded()) {
	            return;
	          }
	
	          var layer = new L.TileLayer.WebGLHeatMap(params.options);
	          if (isDefined(params.data)) {
	            layer.setData(params.data);
	          }
	
	          return layer;
	        }
	      },
	      heat: {
	        mustHaveUrl: false,
	        mustHaveData: true,
	        createLayer: function createLayer(params) {
	          if (!Helpers.HeatLayerPlugin.isLoaded()) {
	            return;
	          }
	
	          var layer = new L.heatLayer();
	
	          if (isArray(params.data)) {
	            layer.setLatLngs(params.data);
	          }
	
	          if (isObject(params.options)) {
	            layer.setOptions(params.options);
	          }
	
	          return layer;
	        }
	      },
	      yandex: {
	        mustHaveUrl: false,
	        createLayer: function createLayer(params) {
	          var type = params.type || 'map';
	          if (!Helpers.YandexLayerPlugin.isLoaded()) {
	            return;
	          }
	
	          return new L.Yandex(type, params.options);
	        }
	      },
	      imageOverlay: {
	        mustHaveUrl: true,
	        mustHaveBounds: true,
	        createLayer: function createLayer(params) {
	          return L.imageOverlay(params.url, params.bounds, params.options);
	        }
	      },
	      iip: {
	        mustHaveUrl: true,
	        createLayer: function createLayer(params) {
	          return L.tileLayer.iip(params.url, params.options);
	        }
	      },
	
	      // This "custom" type is used to accept every layer that user want to define himself.
	      // We can wrap these custom layers like heatmap or yandex, but it means a lot of work/code to wrap the world,
	      // so we let user to define their own layer outside the directive,
	      // and pass it on "createLayer" result for next processes
	      custom: {
	        createLayer: function createLayer(params) {
	          if (params.layer instanceof L.Class) {
	            return angular.copy(params.layer);
	          } else {
	            $log.error('[AngularJS - Leaflet] A custom layer must be a leaflet Class');
	          }
	        }
	      },
	      cartodb: {
	        mustHaveUrl: true,
	        createLayer: function createLayer(params) {
	          return cartodb.createLayer(params.map, params.url);
	        }
	      }
	    };
	
	    function isValidLayerType(layerDefinition) {
	      // Check if the baselayer has a valid type
	      if (!isString(layerDefinition.type)) {
	        $log.error('[AngularJS - Leaflet] A layer must have a valid type defined.');
	        return false;
	      }
	
	      if (Object.keys(layerTypes).indexOf(layerDefinition.type) === -1) {
	        $log.error('[AngularJS - Leaflet] A layer must have a valid type: ' + Object.keys(layerTypes));
	        return false;
	      }
	
	      // Check if the layer must have an URL
	      if (layerTypes[layerDefinition.type].mustHaveUrl && !isString(layerDefinition.url)) {
	        $log.error('[AngularJS - Leaflet] A base layer must have an url');
	        return false;
	      }
	
	      if (layerTypes[layerDefinition.type].mustHaveData && !isDefined(layerDefinition.data)) {
	        $log.error('[AngularJS - Leaflet] The base layer must have a "data" array attribute');
	        return false;
	      }
	
	      if (layerTypes[layerDefinition.type].mustHaveLayer && !isDefined(layerDefinition.layer)) {
	        $log.error('[AngularJS - Leaflet] The type of layer ' + layerDefinition.type + ' must have an layer defined');
	        return false;
	      }
	
	      if (layerTypes[layerDefinition.type].mustHaveBounds && !isDefined(layerDefinition.bounds)) {
	        $log.error('[AngularJS - Leaflet] The type of layer ' + layerDefinition.type + ' must have bounds defined');
	        return false;
	      }
	
	      if (layerTypes[layerDefinition.type].mustHaveKey && !isDefined(layerDefinition.key)) {
	        $log.error('[AngularJS - Leaflet] The type of layer ' + layerDefinition.type + ' must have key defined');
	        return false;
	      }
	
	      return true;
	    }
	
	    function _createLayer(layerDefinition) {
	      if (!isValidLayerType(layerDefinition)) {
	        return;
	      }
	
	      if (!isString(layerDefinition.name)) {
	        $log.error('[AngularJS - Leaflet] A base layer must have a name');
	        return;
	      }
	
	      if (!isObject(layerDefinition.layerParams)) {
	        layerDefinition.layerParams = {};
	      }
	
	      if (!isObject(layerDefinition.layerOptions)) {
	        layerDefinition.layerOptions = {};
	      }
	
	      // Mix the layer specific parameters with the general Leaflet options. Although this is an overhead
	      // the definition of a base layers is more 'clean' if the two types of parameters are differentiated
	      for (var attrname in layerDefinition.layerParams) {
	        layerDefinition.layerOptions[attrname] = layerDefinition.layerParams[attrname];
	      }
	
	      var params = {
	        url: layerDefinition.url,
	        data: layerDefinition.data,
	        options: layerDefinition.layerOptions,
	        layer: layerDefinition.layer,
	        icon: layerDefinition.icon,
	        type: layerDefinition.layerType,
	        bounds: layerDefinition.bounds,
	        key: layerDefinition.key,
	        apiKey: layerDefinition.apiKey,
	        pluginOptions: layerDefinition.pluginOptions,
	        user: layerDefinition.user
	      };
	
	      //TODO Add $watch to the layer properties
	      return layerTypes[layerDefinition.type].createLayer(params);
	    }
	
	    function safeAddLayer(map, layer) {
	      if (layer && typeof layer.addTo === 'function') {
	        layer.addTo(map);
	      } else {
	        map.addLayer(layer);
	      }
	    }
	
	    function safeRemoveLayer(map, layer, layerOptions) {
	      if (isDefined(layerOptions) && isDefined(layerOptions.loadedDefer)) {
	        if (angular.isFunction(layerOptions.loadedDefer)) {
	          var defers = layerOptions.loadedDefer();
	          $log.debug('Loaded Deferred', defers);
	          var count = defers.length;
	          if (count > 0) {
	            var resolve = function resolve() {
	              count--;
	              if (count === 0) {
	                map.removeLayer(layer);
	              }
	            };
	
	            for (var i = 0; i < defers.length; i++) {
	              defers[i].promise.then(resolve);
	            }
	          } else {
	            map.removeLayer(layer);
	          }
	        } else {
	          layerOptions.loadedDefer.promise.then(function () {
	            map.removeLayer(layer);
	          });
	        }
	      } else {
	        map.removeLayer(layer);
	      }
	    }
	
	    return {
	      createLayer: _createLayer,
	      safeAddLayer: safeAddLayer,
	      safeRemoveLayer: safeRemoveLayer
	    };
	  }]);
	
	  angular.module('leaflet-directive').factory('leafletLegendHelpers', function () {
	    var _updateLegend = function _updateLegend(div, legendData, type, url) {
	      div.innerHTML = '';
	      if (legendData.error) {
	        div.innerHTML += '<div class="info-title alert alert-danger">' + legendData.error.message + '</div>';
	      } else {
	        if (type === 'arcgis') {
	          for (var i = 0; i < legendData.layers.length; i++) {
	            var layer = legendData.layers[i];
	            div.innerHTML += '<div class="info-title" data-layerid="' + layer.layerId + '">' + layer.layerName + '</div>';
	            for (var j = 0; j < layer.legend.length; j++) {
	              var leg = layer.legend[j];
	              div.innerHTML += '<div class="inline" data-layerid="' + layer.layerId + '"><img src="data:' + leg.contentType + ';base64,' + leg.imageData + '" /></div>' + '<div class="info-label" data-layerid="' + layer.layerId + '">' + leg.label + '</div>';
	            }
	          }
	        } else if (type === 'image') {
	          div.innerHTML = '<img src="' + url + '"/>';
	        }
	      }
	    };
	
	    var _getOnAddLegend = function _getOnAddLegend(legendData, legendClass, type, url) {
	      return function () /*map*/{
	        var div = L.DomUtil.create('div', legendClass);
	
	        if (!L.Browser.touch) {
	          L.DomEvent.disableClickPropagation(div);
	          L.DomEvent.on(div, 'mousewheel', L.DomEvent.stopPropagation);
	        } else {
	          L.DomEvent.on(div, 'click', L.DomEvent.stopPropagation);
	        }
	
	        _updateLegend(div, legendData, type, url);
	        return div;
	      };
	    };
	
	    var _getOnAddArrayLegend = function _getOnAddArrayLegend(legend, legendClass) {
	      return function () /*map*/{
	        var div = L.DomUtil.create('div', legendClass);
	        for (var i = 0; i < legend.colors.length; i++) {
	          div.innerHTML += '<div class="outline"><i style="background:' + legend.colors[i] + '"></i></div>' + '<div class="info-label">' + legend.labels[i] + '</div>';
	        }
	
	        if (!L.Browser.touch) {
	          L.DomEvent.disableClickPropagation(div);
	          L.DomEvent.on(div, 'mousewheel', L.DomEvent.stopPropagation);
	        } else {
	          L.DomEvent.on(div, 'click', L.DomEvent.stopPropagation);
	        }
	
	        return div;
	      };
	    };
	
	    return {
	      getOnAddLegend: _getOnAddLegend,
	      getOnAddArrayLegend: _getOnAddArrayLegend,
	      updateLegend: _updateLegend
	    };
	  });
	
	  angular.module('leaflet-directive').factory('leafletMapDefaults', ["$q", "leafletHelpers", function ($q, leafletHelpers) {
	    function _getDefaults() {
	      return {
	        keyboard: true,
	        dragging: true,
	        worldCopyJump: false,
	        doubleClickZoom: true,
	        scrollWheelZoom: true,
	        tap: true,
	        touchZoom: true,
	        zoomControl: true,
	        zoomsliderControl: false,
	        zoomControlPosition: 'topleft',
	        attributionControl: true,
	        controls: {
	          layers: {
	            visible: true,
	            position: 'topright',
	            collapsed: true
	          }
	        },
	        nominatim: {
	          server: ' http://nominatim.openstreetmap.org/search'
	        },
	        crs: L.CRS.EPSG3857,
	        tileLayer: '//{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
	        tileLayerOptions: {
	          attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
	        },
	        path: {
	          weight: 10,
	          opacity: 1,
	          color: '#0000ff'
	        },
	        center: {
	          lat: 0,
	          lng: 0,
	          zoom: 1
	        }
	      };
	    }
	
	    var isDefined = leafletHelpers.isDefined;
	    var isObject = leafletHelpers.isObject;
	    var obtainEffectiveMapId = leafletHelpers.obtainEffectiveMapId;
	    var defaults = {};
	
	    // Get the _defaults dictionary, and override the properties defined by the user
	    return {
	      reset: function reset() {
	        defaults = {};
	      },
	
	      getDefaults: function getDefaults(scopeId) {
	        var mapId = obtainEffectiveMapId(defaults, scopeId);
	        return defaults[mapId];
	      },
	
	      getMapCreationDefaults: function getMapCreationDefaults(scopeId) {
	        var mapId = obtainEffectiveMapId(defaults, scopeId);
	        var d = defaults[mapId];
	
	        var mapDefaults = {
	          maxZoom: d.maxZoom,
	          keyboard: d.keyboard,
	          dragging: d.dragging,
	          zoomControl: d.zoomControl,
	          doubleClickZoom: d.doubleClickZoom,
	          scrollWheelZoom: d.scrollWheelZoom,
	          tap: d.tap,
	          touchZoom: d.touchZoom,
	          attributionControl: d.attributionControl,
	          worldCopyJump: d.worldCopyJump,
	          crs: d.crs
	        };
	
	        if (isDefined(d.minZoom)) {
	          mapDefaults.minZoom = d.minZoom;
	        }
	
	        if (isDefined(d.zoomAnimation)) {
	          mapDefaults.zoomAnimation = d.zoomAnimation;
	        }
	
	        if (isDefined(d.fadeAnimation)) {
	          mapDefaults.fadeAnimation = d.fadeAnimation;
	        }
	
	        if (isDefined(d.markerZoomAnimation)) {
	          mapDefaults.markerZoomAnimation = d.markerZoomAnimation;
	        }
	
	        if (d.map) {
	          for (var option in d.map) {
	            mapDefaults[option] = d.map[option];
	          }
	        }
	
	        return mapDefaults;
	      },
	
	      setDefaults: function setDefaults(userDefaults, scopeId) {
	        var newDefaults = _getDefaults();
	
	        if (isDefined(userDefaults)) {
	          newDefaults.doubleClickZoom = isDefined(userDefaults.doubleClickZoom) ? userDefaults.doubleClickZoom : newDefaults.doubleClickZoom;
	          newDefaults.scrollWheelZoom = isDefined(userDefaults.scrollWheelZoom) ? userDefaults.scrollWheelZoom : newDefaults.doubleClickZoom;
	          newDefaults.tap = isDefined(userDefaults.tap) ? userDefaults.tap : newDefaults.tap;
	          newDefaults.touchZoom = isDefined(userDefaults.touchZoom) ? userDefaults.touchZoom : newDefaults.doubleClickZoom;
	          newDefaults.zoomControl = isDefined(userDefaults.zoomControl) ? userDefaults.zoomControl : newDefaults.zoomControl;
	          newDefaults.zoomsliderControl = isDefined(userDefaults.zoomsliderControl) ? userDefaults.zoomsliderControl : newDefaults.zoomsliderControl;
	          newDefaults.attributionControl = isDefined(userDefaults.attributionControl) ? userDefaults.attributionControl : newDefaults.attributionControl;
	          newDefaults.tileLayer = isDefined(userDefaults.tileLayer) ? userDefaults.tileLayer : newDefaults.tileLayer;
	          newDefaults.zoomControlPosition = isDefined(userDefaults.zoomControlPosition) ? userDefaults.zoomControlPosition : newDefaults.zoomControlPosition;
	          newDefaults.keyboard = isDefined(userDefaults.keyboard) ? userDefaults.keyboard : newDefaults.keyboard;
	          newDefaults.dragging = isDefined(userDefaults.dragging) ? userDefaults.dragging : newDefaults.dragging;
	
	          if (isDefined(userDefaults.controls)) {
	            angular.extend(newDefaults.controls, userDefaults.controls);
	          }
	
	          if (isObject(userDefaults.crs)) {
	            newDefaults.crs = userDefaults.crs;
	          } else if (isDefined(L.CRS[userDefaults.crs])) {
	            newDefaults.crs = L.CRS[userDefaults.crs];
	          }
	
	          if (isDefined(userDefaults.center)) {
	            angular.copy(userDefaults.center, newDefaults.center);
	          }
	
	          if (isDefined(userDefaults.tileLayerOptions)) {
	            angular.copy(userDefaults.tileLayerOptions, newDefaults.tileLayerOptions);
	          }
	
	          if (isDefined(userDefaults.maxZoom)) {
	            newDefaults.maxZoom = userDefaults.maxZoom;
	          }
	
	          if (isDefined(userDefaults.minZoom)) {
	            newDefaults.minZoom = userDefaults.minZoom;
	          }
	
	          if (isDefined(userDefaults.zoomAnimation)) {
	            newDefaults.zoomAnimation = userDefaults.zoomAnimation;
	          }
	
	          if (isDefined(userDefaults.fadeAnimation)) {
	            newDefaults.fadeAnimation = userDefaults.fadeAnimation;
	          }
	
	          if (isDefined(userDefaults.markerZoomAnimation)) {
	            newDefaults.markerZoomAnimation = userDefaults.markerZoomAnimation;
	          }
	
	          if (isDefined(userDefaults.worldCopyJump)) {
	            newDefaults.worldCopyJump = userDefaults.worldCopyJump;
	          }
	
	          if (isDefined(userDefaults.map)) {
	            newDefaults.map = userDefaults.map;
	          }
	
	          if (isDefined(userDefaults.path)) {
	            newDefaults.path = userDefaults.path;
	          }
	        }
	
	        var mapId = obtainEffectiveMapId(defaults, scopeId);
	        defaults[mapId] = newDefaults;
	        return newDefaults;
	      }
	    };
	  }]);
	
	  angular.module('leaflet-directive').service('leafletMarkersHelpers', ["$rootScope", "$timeout", "leafletHelpers", "$log", "$compile", "leafletGeoJsonHelpers", function ($rootScope, $timeout, leafletHelpers, $log, $compile, leafletGeoJsonHelpers) {
	    var isDefined = leafletHelpers.isDefined;
	    var defaultTo = leafletHelpers.defaultTo;
	    var MarkerClusterPlugin = leafletHelpers.MarkerClusterPlugin;
	    var AwesomeMarkersPlugin = leafletHelpers.AwesomeMarkersPlugin;
	    var VectorMarkersPlugin = leafletHelpers.VectorMarkersPlugin;
	    var MakiMarkersPlugin = leafletHelpers.MakiMarkersPlugin;
	    var ExtraMarkersPlugin = leafletHelpers.ExtraMarkersPlugin;
	    var DomMarkersPlugin = leafletHelpers.DomMarkersPlugin;
	    var safeApply = leafletHelpers.safeApply;
	    var Helpers = leafletHelpers;
	    var isString = leafletHelpers.isString;
	    var isNumber = leafletHelpers.isNumber;
	    var isObject = leafletHelpers.isObject;
	    var groups = {};
	    var geoHlp = leafletGeoJsonHelpers;
	    var errorHeader = leafletHelpers.errorHeader;
	
	    var _string = function _string(marker) {
	      //this exists since JSON.stringify barfs on cyclic
	      var retStr = '';
	      ['_icon', '_latlng', '_leaflet_id', '_map', '_shadow'].forEach(function (prop) {
	        retStr += prop + ': ' + defaultTo(marker[prop], 'undefined') + ' \n';
	      });
	
	      return '[leafletMarker] : \n' + retStr;
	    };
	
	    var _log = function _log(marker, useConsole) {
	      var logger = useConsole ? console : $log;
	      logger.debug(_string(marker));
	    };
	
	    var createLeafletIcon = function createLeafletIcon(iconData) {
	      if (isDefined(iconData) && isDefined(iconData.type) && iconData.type === 'awesomeMarker') {
	        if (!AwesomeMarkersPlugin.isLoaded()) {
	          $log.error(errorHeader + ' The AwesomeMarkers Plugin is not loaded.');
	        }
	
	        return new L.AwesomeMarkers.icon(iconData);
	      }
	
	      if (isDefined(iconData) && isDefined(iconData.type) && iconData.type === 'vectorMarker') {
	        if (!VectorMarkersPlugin.isLoaded()) {
	          $log.error(errorHeader + ' The VectorMarkers Plugin is not loaded.');
	        }
	
	        return new L.VectorMarkers.icon(iconData);
	      }
	
	      if (isDefined(iconData) && isDefined(iconData.type) && iconData.type === 'makiMarker') {
	        if (!MakiMarkersPlugin.isLoaded()) {
	          $log.error(errorHeader + 'The MakiMarkers Plugin is not loaded.');
	        }
	
	        return new L.MakiMarkers.icon(iconData);
	      }
	
	      if (isDefined(iconData) && isDefined(iconData.type) && iconData.type === 'extraMarker') {
	        if (!ExtraMarkersPlugin.isLoaded()) {
	          $log.error(errorHeader + 'The ExtraMarkers Plugin is not loaded.');
	        }
	
	        return new L.ExtraMarkers.icon(iconData);
	      }
	
	      if (isDefined(iconData) && isDefined(iconData.type) && iconData.type === 'div') {
	        return new L.divIcon(iconData);
	      }
	
	      if (isDefined(iconData) && isDefined(iconData.type) && iconData.type === 'dom') {
	        if (!DomMarkersPlugin.isLoaded()) {
	          $log.error(errorHeader + 'The DomMarkers Plugin is not loaded.');
	        }
	
	        var markerScope = angular.isFunction(iconData.getMarkerScope) ? iconData.getMarkerScope() : $rootScope;
	        var template = $compile(iconData.template)(markerScope);
	        var iconDataCopy = angular.copy(iconData);
	        iconDataCopy.element = template[0];
	        return new L.DomMarkers.icon(iconDataCopy);
	      }
	
	      // allow for any custom icon to be used... assumes the icon has already been initialized
	      if (isDefined(iconData) && isDefined(iconData.type) && iconData.type === 'icon') {
	        return iconData.icon;
	      }
	
	      var base64icon = 'data:image/png;base64,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';
	      var base64shadow = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAApCAYAAACoYAD2AAAC5ElEQVRYw+2YW4/TMBCF45S0S1luXZCABy5CgLQgwf//S4BYBLTdJLax0fFqmB07nnQfEGqkIydpVH85M+NLjPe++dcPc4Q8Qh4hj5D/AaQJx6H/4TMwB0PeBNwU7EGQAmAtsNfAzoZkgIa0ZgLMa4Aj6CxIAsjhjOCoL5z7Glg1JAOkaicgvQBXuncwJAWjksLtBTWZe04CnYRktUGdilALppZBOgHGZcBzL6OClABvMSVIzyBjazOgrvACf1ydC5mguqAVg6RhdkSWQFj2uxfaq/BrIZOLEWgZdALIDvcMcZLD8ZbLC9de4yR1sYMi4G20S4Q/PWeJYxTOZn5zJXANZHIxAd4JWhPIloTJZhzMQduM89WQ3MUVAE/RnhAXpTycqys3NZALOBbB7kFrgLesQl2h45Fcj8L1tTSohUwuxhy8H/Qg6K7gIs+3kkaigQCOcyEXCHN07wyQazhrmIulvKMQAwMcmLNqyCVyMAI+BuxSMeTk3OPikLY2J1uE+VHQk6ANrhds+tNARqBeaGc72cK550FP4WhXmFmcMGhTwAR1ifOe3EvPqIegFmF+C8gVy0OfAaWQPMR7gF1OQKqGoBjq90HPMP01BUjPOqGFksC4emE48tWQAH0YmvOgF3DST6xieJgHAWxPAHMuNhrImIdvoNOKNWIOcE+UXE0pYAnkX6uhWsgVXDxHdTfCmrEEmMB2zMFimLVOtiiajxiGWrbU52EeCdyOwPEQD8LqyPH9Ti2kgYMf4OhSKB7qYILbBv3CuVTJ11Y80oaseiMWOONc/Y7kJYe0xL2f0BaiFTxknHO5HaMGMublKwxFGzYdWsBF174H/QDknhTHmHHN39iWFnkZx8lPyM8WHfYELmlLKtgWNmFNzQcC1b47gJ4hL19i7o65dhH0Negbca8vONZoP7doIeOC9zXm8RjuL0Gf4d4OYaU5ljo3GYiqzrWQHfJxA6ALhDpVKv9qYeZA8eM3EhfPSCmpuD0AAAAASUVORK5CYII=';
	
	      if (!isDefined(iconData) || !isDefined(iconData.iconUrl)) {
	        return new L.Icon.Default({
	          iconUrl: base64icon,
	          shadowUrl: base64shadow,
	          iconSize: [25, 41],
	          iconAnchor: [12, 41],
	          popupAnchor: [1, -34],
	          shadowSize: [41, 41]
	        });
	      }
	
	      return new L.Icon(iconData);
	    };
	
	    var _resetMarkerGroup = function _resetMarkerGroup(groupName) {
	      if (isDefined(groups[groupName])) {
	        groups.splice(groupName, 1);
	      }
	    };
	
	    var _resetMarkerGroups = function _resetMarkerGroups() {
	      groups = {};
	    };
	
	    var _deleteMarker = function _deleteMarker(marker, map, layers) {
	      marker.closePopup();
	
	      // There is no easy way to know if a marker is added to a layer, so we search for it
	      // if there are overlays
	      if (isDefined(layers) && isDefined(layers.overlays)) {
	        for (var key in layers.overlays) {
	          if (layers.overlays[key] instanceof L.LayerGroup || layers.overlays[key] instanceof L.FeatureGroup) {
	            if (layers.overlays[key].hasLayer(marker)) {
	              layers.overlays[key].removeLayer(marker);
	              return;
	            }
	          }
	        }
	      }
	
	      if (isDefined(groups)) {
	        for (var groupKey in groups) {
	          if (groups[groupKey].hasLayer(marker)) {
	            groups[groupKey].removeLayer(marker);
	          }
	        }
	      }
	
	      if (map.hasLayer(marker)) {
	        map.removeLayer(marker);
	      }
	    };
	
	    var adjustPopupPan = function adjustPopupPan(marker, map) {
	      var containerHeight = marker._popup._container.offsetHeight;
	      var layerPos = new L.Point(marker._popup._containerLeft, -containerHeight - marker._popup._containerBottom);
	      var containerPos = map.layerPointToContainerPoint(layerPos);
	      if (containerPos !== null) {
	        marker._popup._adjustPan();
	      }
	    };
	
	    var compilePopup = function compilePopup(marker, markerScope) {
	      $compile(marker._popup._contentNode)(markerScope);
	    };
	
	    var updatePopup = function updatePopup(marker, markerScope, map) {
	      //The innerText should be more than 1 once angular has compiled.
	      //We need to keep trying until angular has compiled before we _updateLayout and _updatePosition
	      //This should take care of any scenario , eg ngincludes, whatever.
	      //Is there a better way to check for this?
	      var innerText = marker._popup._contentNode.innerText || marker._popup._contentNode.textContent;
	      if (innerText.length < 1) {
	        $timeout(function () {
	          updatePopup(marker, markerScope, map);
	        });
	      }
	
	      //cause a reflow - this is also very important - if we don't do this then the widths are from before $compile
	      var reflow = marker._popup._contentNode.offsetWidth;
	
	      marker._popup._updateLayout();
	      marker._popup._updatePosition();
	
	      if (marker._popup.options.autoPan) {
	        adjustPopupPan(marker, map);
	      }
	
	      //using / returning reflow so jshint doesn't moan
	      return reflow;
	    };
	
	    var _manageOpenPopup = function _manageOpenPopup(marker, markerData, map) {
	      // The marker may provide a scope returning function used to compile the message
	      // default to $rootScope otherwise
	      var markerScope = angular.isFunction(markerData.getMessageScope) ? markerData.getMessageScope() : $rootScope;
	      var compileMessage = isDefined(markerData.compileMessage) ? markerData.compileMessage : true;
	
	      if (compileMessage) {
	        if (!isDefined(marker._popup) || !isDefined(marker._popup._contentNode)) {
	          $log.error(errorHeader + 'Popup is invalid or does not have any content.');
	          return false;
	        }
	
	        compilePopup(marker, markerScope);
	        updatePopup(marker, markerData, map);
	      }
	    };
	
	    var _manageOpenLabel = function _manageOpenLabel(marker, markerData) {
	      var markerScope = angular.isFunction(markerData.getMessageScope) ? markerData.getMessageScope() : $rootScope;
	      var labelScope = angular.isFunction(markerData.getLabelScope) ? markerData.getLabelScope() : markerScope;
	      var compileMessage = isDefined(markerData.compileMessage) ? markerData.compileMessage : true;
	
	      if (Helpers.LabelPlugin.isLoaded() && isDefined(markerData.label)) {
	        if (isDefined(markerData.label.options) && markerData.label.options.noHide === true) {
	          marker.showLabel();
	        }
	
	        if (compileMessage && isDefined(marker.label)) {
	          $compile(marker.label._container)(labelScope);
	        }
	      }
	    };
	
	    var _updateMarker = function _updateMarker(markerData, oldMarkerData, marker, name, leafletScope, layers, map) {
	      if (!isDefined(oldMarkerData)) {
	        return;
	      }
	
	      // Update the lat-lng property (always present in marker properties)
	      if (!geoHlp.validateCoords(markerData)) {
	        $log.warn('There are problems with lat-lng data, please verify your marker model');
	        _deleteMarker(marker, map, layers);
	        return;
	      }
	
	      // watch is being initialized if old and new object is the same
	      var isInitializing = markerData === oldMarkerData;
	
	      // Update marker rotation
	      if (isDefined(markerData.iconAngle) && oldMarkerData.iconAngle !== markerData.iconAngle) {
	        marker.setIconAngle(markerData.iconAngle);
	      }
	
	      // It is possible that the layer has been removed or the layer marker does not exist
	      // Update the layer group if present or move it to the map if not
	      if (!isString(markerData.layer)) {
	        // There is no layer information, we move the marker to the map if it was in a layer group
	        if (isString(oldMarkerData.layer)) {
	          // Remove from the layer group that is supposed to be
	          if (isDefined(layers.overlays[oldMarkerData.layer]) && layers.overlays[oldMarkerData.layer].hasLayer(marker)) {
	            layers.overlays[oldMarkerData.layer].removeLayer(marker);
	            marker.closePopup();
	          }
	
	          // Test if it is not on the map and add it
	          if (!map.hasLayer(marker)) {
	            map.addLayer(marker);
	          }
	        }
	      }
	
	      if ((isNumber(markerData.opacity) || isNumber(parseFloat(markerData.opacity))) && markerData.opacity !== oldMarkerData.opacity) {
	        // There was a different opacity so we update it
	        marker.setOpacity(markerData.opacity);
	      }
	
	      if (isString(markerData.layer) && oldMarkerData.layer !== markerData.layer) {
	        // If it was on a layer group we have to remove it
	        if (isString(oldMarkerData.layer) && isDefined(layers.overlays[oldMarkerData.layer]) && layers.overlays[oldMarkerData.layer].hasLayer(marker)) {
	          layers.overlays[oldMarkerData.layer].removeLayer(marker);
	        }
	
	        marker.closePopup();
	
	        // Remove it from the map in case the new layer is hidden or there is an error in the new layer
	        if (map.hasLayer(marker)) {
	          map.removeLayer(marker);
	        }
	
	        // The markerData.layer is defined so we add the marker to the layer if it is different from the old data
	        if (!isDefined(layers.overlays[markerData.layer])) {
	          $log.error(errorHeader + 'You must use a name of an existing layer');
	          return;
	        }
	
	        // Is a group layer?
	        var layerGroup = layers.overlays[markerData.layer];
	        if (!(layerGroup instanceof L.LayerGroup || layerGroup instanceof L.FeatureGroup)) {
	          $log.error(errorHeader + 'A marker can only be added to a layer of type "group" or "featureGroup"');
	          return;
	        }
	
	        // The marker goes to a correct layer group, so first of all we add it
	        layerGroup.addLayer(marker);
	
	        // The marker is automatically added to the map depending on the visibility
	        // of the layer, so we only have to open the popup if the marker is in the map
	        if (map.hasLayer(marker) && markerData.focus === true) {
	          marker.openPopup();
	        }
	      }
	
	      // Update the draggable property
	      if (markerData.draggable !== true && oldMarkerData.draggable === true && isDefined(marker.dragging)) {
	        marker.dragging.disable();
	      }
	
	      if (markerData.draggable === true && oldMarkerData.draggable !== true) {
	        // The markerData.draggable property must be true so we update if there wasn't a previous value or it wasn't true
	        if (marker.dragging) {
	          marker.dragging.enable();
	        } else {
	          if (L.Handler.MarkerDrag) {
	            marker.dragging = new L.Handler.MarkerDrag(marker);
	            marker.options.draggable = true;
	            marker.dragging.enable();
	          }
	        }
	      }
	
	      // Update the icon property
	      if (!isObject(markerData.icon)) {
	        // If there is no icon property or it's not an object
	        if (isObject(oldMarkerData.icon)) {
	          // If there was an icon before restore to the default
	          marker.setIcon(createLeafletIcon());
	          marker.closePopup();
	          marker.unbindPopup();
	          if (isString(markerData.message)) {
	            marker.bindPopup(markerData.message, markerData.popupOptions);
	          }
	        }
	      }
	
	      if (isObject(markerData.icon) && isObject(oldMarkerData.icon) && !angular.equals(markerData.icon, oldMarkerData.icon)) {
	        var dragG = false;
	        if (marker.dragging) {
	          dragG = marker.dragging.enabled();
	        }
	
	        marker.setIcon(createLeafletIcon(markerData.icon));
	        if (dragG) {
	          marker.dragging.enable();
	        }
	
	        marker.closePopup();
	        marker.unbindPopup();
	        if (isString(markerData.message)) {
	          marker.bindPopup(markerData.message, markerData.popupOptions);
	
	          // if marker has been already focused, reopen popup
	          if (map.hasLayer(marker) && markerData.focus === true) {
	            marker.openPopup();
	          }
	        }
	      }
	
	      // Update the Popup message property
	      if (!isString(markerData.message) && isString(oldMarkerData.message)) {
	        marker.closePopup();
	        marker.unbindPopup();
	      }
	
	      // Update the label content or bind a new label if the old one has been removed.
	      if (Helpers.LabelPlugin.isLoaded()) {
	        if (isDefined(markerData.label) && isDefined(markerData.label.message)) {
	          if ('label' in oldMarkerData && 'message' in oldMarkerData.label && !angular.equals(markerData.label.message, oldMarkerData.label.message)) {
	            marker.updateLabelContent(markerData.label.message);
	          } else if (!angular.isFunction(marker.getLabel) || angular.isFunction(marker.getLabel) && !isDefined(marker.getLabel())) {
	            marker.bindLabel(markerData.label.message, markerData.label.options);
	            _manageOpenLabel(marker, markerData);
	          } else {
	            _manageOpenLabel(marker, markerData);
	          }
	        } else if (!('label' in markerData && !('message' in markerData.label))) {
	          if (angular.isFunction(marker.unbindLabel)) {
	            marker.unbindLabel();
	          }
	        }
	      }
	
	      // There is some text in the popup, so we must show the text or update existing
	      if (isString(markerData.message) && !isString(oldMarkerData.message)) {
	        // There was no message before so we create it
	        marker.bindPopup(markerData.message, markerData.popupOptions);
	      }
	
	      if (isString(markerData.message) && isString(oldMarkerData.message) && markerData.message !== oldMarkerData.message) {
	        // There was a different previous message so we update it
	        marker.setPopupContent(markerData.message);
	      }
	
	      // Update the focus property
	      var updatedFocus = false;
	      if (markerData.focus !== true && oldMarkerData.focus === true) {
	        // If there was a focus property and was true we turn it off
	        marker.closePopup();
	        updatedFocus = true;
	      }
	
	      // The markerData.focus property must be true so we update if there wasn't a previous value or it wasn't true
	      if (markerData.focus === true && (!isDefined(oldMarkerData.focus) || oldMarkerData.focus === false) || isInitializing && markerData.focus === true) {
	        // Reopen the popup when focus is still true
	        marker.openPopup();
	        updatedFocus = true;
	      }
	
	      // zIndexOffset adjustment
	      if (oldMarkerData.zIndexOffset !== markerData.zIndexOffset) {
	        marker.setZIndexOffset(markerData.zIndexOffset);
	      }
	
	      var markerLatLng = marker.getLatLng();
	      var isCluster = isString(markerData.layer) && Helpers.MarkerClusterPlugin.is(layers.overlays[markerData.layer]);
	
	      // If the marker is in a cluster it has to be removed and added to the layer when the location is changed
	      if (isCluster) {
	        // The focus has changed even by a user click or programatically
	        if (updatedFocus) {
	          // We only have to update the location if it was changed programatically, because it was
	          // changed by a user drag the marker data has already been updated by the internal event
	          // listened by the directive
	          if (markerData.lat !== oldMarkerData.lat || markerData.lng !== oldMarkerData.lng) {
	            layers.overlays[markerData.layer].removeLayer(marker);
	            marker.setLatLng([markerData.lat, markerData.lng]);
	            layers.overlays[markerData.layer].addLayer(marker);
	          }
	        } else {
	          // The marker has possibly moved. It can be moved by a user drag (marker location and data are equal but old
	          // data is diferent) or programatically (marker location and data are diferent)
	          if (markerLatLng.lat !== markerData.lat || markerLatLng.lng !== markerData.lng) {
	            // The marker was moved by a user drag
	            layers.overlays[markerData.layer].removeLayer(marker);
	            marker.setLatLng([markerData.lat, markerData.lng]);
	            layers.overlays[markerData.layer].addLayer(marker);
	          } else if (markerData.lat !== oldMarkerData.lat || markerData.lng !== oldMarkerData.lng) {
	            // The marker was moved programatically
	            layers.overlays[markerData.layer].removeLayer(marker);
	            marker.setLatLng([markerData.lat, markerData.lng]);
	            layers.overlays[markerData.layer].addLayer(marker);
	          } else if (isObject(markerData.icon) && isObject(oldMarkerData.icon) && !angular.equals(markerData.icon, oldMarkerData.icon)) {
	            layers.overlays[markerData.layer].removeLayer(marker);
	            layers.overlays[markerData.layer].addLayer(marker);
	          }
	        }
	      } else if (markerLatLng.lat !== markerData.lat || markerLatLng.lng !== markerData.lng) {
	        marker.setLatLng([markerData.lat, markerData.lng]);
	      }
	    };
	
	    return {
	      resetMarkerGroup: _resetMarkerGroup,
	
	      resetMarkerGroups: _resetMarkerGroups,
	
	      deleteMarker: _deleteMarker,
	
	      manageOpenPopup: _manageOpenPopup,
	
	      manageOpenLabel: _manageOpenLabel,
	
	      createMarker: function createMarker(markerData) {
	        if (!isDefined(markerData) || !geoHlp.validateCoords(markerData)) {
	          $log.error(errorHeader + 'The marker definition is not valid.');
	          return;
	        }
	
	        var coords = geoHlp.getCoords(markerData);
	
	        if (!isDefined(coords)) {
	          $log.error(errorHeader + 'Unable to get coordinates from markerData.');
	          return;
	        }
	
	        var markerOptions = {
	          icon: createLeafletIcon(markerData.icon),
	          title: isDefined(markerData.title) ? markerData.title : '',
	          draggable: isDefined(markerData.draggable) ? markerData.draggable : false,
	          clickable: isDefined(markerData.clickable) ? markerData.clickable : true,
	          riseOnHover: isDefined(markerData.riseOnHover) ? markerData.riseOnHover : false,
	          zIndexOffset: isDefined(markerData.zIndexOffset) ? markerData.zIndexOffset : 0,
	          iconAngle: isDefined(markerData.iconAngle) ? markerData.iconAngle : 0
	        };
	
	        // Add any other options not added above to markerOptions
	        for (var markerDatum in markerData) {
	          if (markerData.hasOwnProperty(markerDatum) && !markerOptions.hasOwnProperty(markerDatum)) {
	            markerOptions[markerDatum] = markerData[markerDatum];
	          }
	        }
	
	        var marker = new L.marker(coords, markerOptions);
	
	        if (!isString(markerData.message)) {
	          marker.unbindPopup();
	        }
	
	        return marker;
	      },
	
	      addMarkerToGroup: function addMarkerToGroup(marker, groupName, groupOptions, map) {
	        if (!isString(groupName)) {
	          $log.error(errorHeader + 'The marker group you have specified is invalid.');
	          return;
	        }
	
	        if (!MarkerClusterPlugin.isLoaded()) {
	          $log.error(errorHeader + 'The MarkerCluster plugin is not loaded.');
	          return;
	        }
	
	        if (!isDefined(groups[groupName])) {
	          groups[groupName] = new L.MarkerClusterGroup(groupOptions);
	          map.addLayer(groups[groupName]);
	        }
	
	        groups[groupName].addLayer(marker);
	      },
	
	      listenMarkerEvents: function listenMarkerEvents(marker, markerData, leafletScope, doWatch, map) {
	        marker.on('popupopen', function () /* event */{
	          safeApply(leafletScope, function () {
	            if (isDefined(marker._popup) || isDefined(marker._popup._contentNode)) {
	              markerData.focus = true;
	              _manageOpenPopup(marker, markerData, map); //needed since markerData is now a copy
	            }
	          });
	        });
	
	        marker.on('popupclose', function () /* event */{
	          safeApply(leafletScope, function () {
	            markerData.focus = false;
	          });
	        });
	
	        marker.on('add', function () /* event */{
	          safeApply(leafletScope, function () {
	            if ('label' in markerData) _manageOpenLabel(marker, markerData);
	          });
	        });
	      },
	
	      updateMarker: _updateMarker,
	
	      addMarkerWatcher: function addMarkerWatcher(marker, name, leafletScope, layers, map, isDeepWatch) {
	        var markerWatchPath = Helpers.getObjectArrayPath('markers.' + name);
	        isDeepWatch = defaultTo(isDeepWatch, true);
	
	        var clearWatch = leafletScope.$watch(markerWatchPath, function (markerData, oldMarkerData) {
	          if (!isDefined(markerData)) {
	            _deleteMarker(marker, map, layers);
	            clearWatch();
	            return;
	          }
	
	          _updateMarker(markerData, oldMarkerData, marker, name, leafletScope, layers, map);
	        }, isDeepWatch);
	      },
	
	      string: _string,
	      log: _log
	    };
	  }]);
	
	  angular.module('leaflet-directive').factory('leafletPathsHelpers', ["$rootScope", "$log", "leafletHelpers", function ($rootScope, $log, leafletHelpers) {
	    var isDefined = leafletHelpers.isDefined;
	    var isArray = leafletHelpers.isArray;
	    var isNumber = leafletHelpers.isNumber;
	    var isValidPoint = leafletHelpers.isValidPoint;
	
	    var availableOptions = [
	
	    // Path options
	    'stroke', 'weight', 'color', 'opacity', 'fill', 'fillColor', 'fillOpacity', 'dashArray', 'lineCap', 'lineJoin', 'clickable', 'pointerEvents', 'className',
	
	    // Polyline options
	    'smoothFactor', 'noClip'];
	    function _convertToLeafletLatLngs(latlngs) {
	      return latlngs.filter(function (latlng) {
	        return isValidPoint(latlng);
	      }).map(function (latlng) {
	        return _convertToLeafletLatLng(latlng);
	      });
	    }
	
	    function _convertToLeafletLatLng(latlng) {
	      if (isArray(latlng)) {
	        return new L.LatLng(latlng[0], latlng[1]);
	      } else {
	        return new L.LatLng(latlng.lat, latlng.lng);
	      }
	    }
	
	    function _convertToLeafletMultiLatLngs(paths) {
	      return paths.map(function (latlngs) {
	        return _convertToLeafletLatLngs(latlngs);
	      });
	    }
	
	    function _getOptions(path, defaults) {
	      var options = {};
	      for (var i = 0; i < availableOptions.length; i++) {
	        var optionName = availableOptions[i];
	
	        if (isDefined(path[optionName])) {
	          options[optionName] = path[optionName];
	        } else if (isDefined(defaults.path[optionName])) {
	          options[optionName] = defaults.path[optionName];
	        }
	      }
	
	      return options;
	    }
	
	    var _updatePathOptions = function _updatePathOptions(path, data) {
	      var updatedStyle = {};
	      for (var i = 0; i < availableOptions.length; i++) {
	        var optionName = availableOptions[i];
	        if (isDefined(data[optionName])) {
	          updatedStyle[optionName] = data[optionName];
	        }
	      }
	
	      path.setStyle(data);
	    };
	
	    var _isValidPolyline = function _isValidPolyline(latlngs) {
	      if (!isArray(latlngs)) {
	        return false;
	      }
	
	      for (var i = 0; i < latlngs.length; i++) {
	        var point = latlngs[i];
	        if (!isValidPoint(point)) {
	          return false;
	        }
	      }
	
	      return true;
	    };
	
	    var pathTypes = {
	      polyline: {
	        isValid: function isValid(pathData) {
	          var latlngs = pathData.latlngs;
	          return _isValidPolyline(latlngs);
	        },
	
	        createPath: function createPath(options) {
	          return new L.Polyline([], options);
	        },
	
	        setPath: function setPath(path, data) {
	          path.setLatLngs(_convertToLeafletLatLngs(data.latlngs));
	          _updatePathOptions(path, data);
	          return;
	        }
	      },
	      multiPolyline: {
	        isValid: function isValid(pathData) {
	          var latlngs = pathData.latlngs;
	          if (!isArray(latlngs)) {
	            return false;
	          }
	
	          for (var i in latlngs) {
	            var polyline = latlngs[i];
	            if (!_isValidPolyline(polyline)) {
	              return false;
	            }
	          }
	
	          return true;
	        },
	
	        createPath: function createPath(options) {
	          return new L.multiPolyline([[[0, 0], [1, 1]]], options);
	        },
	
	        setPath: function setPath(path, data) {
	          path.setLatLngs(_convertToLeafletMultiLatLngs(data.latlngs));
	          _updatePathOptions(path, data);
	          return;
	        }
	      },
	      polygon: {
	        isValid: function isValid(pathData) {
	          var latlngs = pathData.latlngs;
	          return _isValidPolyline(latlngs);
	        },
	
	        createPath: function createPath(options) {
	          return new L.Polygon([], options);
	        },
	
	        setPath: function setPath(path, data) {
	          path.setLatLngs(_convertToLeafletLatLngs(data.latlngs));
	          _updatePathOptions(path, data);
	          return;
	        }
	      },
	      multiPolygon: {
	        isValid: function isValid(pathData) {
	          var latlngs = pathData.latlngs;
	
	          if (!isArray(latlngs)) {
	            return false;
	          }
	
	          for (var i in latlngs) {
	            var polyline = latlngs[i];
	            if (!_isValidPolyline(polyline)) {
	              return false;
	            }
	          }
	
	          return true;
	        },
	
	        createPath: function createPath(options) {
	          return new L.MultiPolygon([[[0, 0], [1, 1], [0, 1]]], options);
	        },
	
	        setPath: function setPath(path, data) {
	          path.setLatLngs(_convertToLeafletMultiLatLngs(data.latlngs));
	          _updatePathOptions(path, data);
	          return;
	        }
	      },
	      rectangle: {
	        isValid: function isValid(pathData) {
	          var latlngs = pathData.latlngs;
	
	          if (!isArray(latlngs) || latlngs.length !== 2) {
	            return false;
	          }
	
	          for (var i in latlngs) {
	            var point = latlngs[i];
	            if (!isValidPoint(point)) {
	              return false;
	            }
	          }
	
	          return true;
	        },
	
	        createPath: function createPath(options) {
	          return new L.Rectangle([[0, 0], [1, 1]], options);
	        },
	
	        setPath: function setPath(path, data) {
	          path.setBounds(new L.LatLngBounds(_convertToLeafletLatLngs(data.latlngs)));
	          _updatePathOptions(path, data);
	        }
	      },
	      circle: {
	        isValid: function isValid(pathData) {
	          var point = pathData.latlngs;
	          return isValidPoint(point) && isNumber(pathData.radius);
	        },
	
	        createPath: function createPath(options) {
	          return new L.Circle([0, 0], 1, options);
	        },
	
	        setPath: function setPath(path, data) {
	          path.setLatLng(_convertToLeafletLatLng(data.latlngs));
	          if (isDefined(data.radius)) {
	            path.setRadius(data.radius);
	          }
	
	          _updatePathOptions(path, data);
	        }
	      },
	      circleMarker: {
	        isValid: function isValid(pathData) {
	          var point = pathData.latlngs;
	          return isValidPoint(point) && isNumber(pathData.radius);
	        },
	
	        createPath: function createPath(options) {
	          return new L.CircleMarker([0, 0], options);
	        },
	
	        setPath: function setPath(path, data) {
	          path.setLatLng(_convertToLeafletLatLng(data.latlngs));
	          if (isDefined(data.radius)) {
	            path.setRadius(data.radius);
	          }
	
	          _updatePathOptions(path, data);
	        }
	      }
	    };
	
	    var _getPathData = function _getPathData(path) {
	      var pathData = {};
	      if (path.latlngs) {
	        pathData.latlngs = path.latlngs;
	      }
	
	      if (path.radius) {
	        pathData.radius = path.radius;
	      }
	
	      return pathData;
	    };
	
	    return {
	      setPathOptions: function setPathOptions(leafletPath, pathType, data) {
	        if (!isDefined(pathType)) {
	          pathType = 'polyline';
	        }
	
	        pathTypes[pathType].setPath(leafletPath, data);
	      },
	
	      createPath: function createPath(name, path, defaults) {
	        if (!isDefined(path.type)) {
	          path.type = 'polyline';
	        }
	
	        var options = _getOptions(path, defaults);
	        var pathData = _getPathData(path);
	
	        if (!pathTypes[path.type].isValid(pathData)) {
	          $log.error('[AngularJS - Leaflet] Invalid data passed to the ' + path.type + ' path');
	          return;
	        }
	
	        return pathTypes[path.type].createPath(options);
	      }
	    };
	  }]);
	
	  angular.module('leaflet-directive').service('leafletWatchHelpers', function () {
	
	    var _maybe = function _maybe(scope, watchFunctionName, thingToWatchStr, watchOptions, initCb) {
	      //watchOptions.isDeep is/should be ignored in $watchCollection
	      var unWatch = scope[watchFunctionName](thingToWatchStr, function (newValue, oldValue) {
	        initCb(newValue, oldValue);
	        if (!watchOptions.doWatch) unWatch();
	      }, watchOptions.isDeep);
	
	      return unWatch;
	    };
	
	    /*
	    @name: maybeWatch
	    @description: Utility to watch something once or forever.
	    @returns unWatch function
	    @param watchOptions - see markersWatchOptions and or derrivatives. This object is used
	    to set watching to once and its watch depth.
	    */
	    var _maybeWatch = function _maybeWatch(scope, thingToWatchStr, watchOptions, initCb) {
	      return _maybe(scope, '$watch', thingToWatchStr, watchOptions, initCb);
	    };
	
	    /*
	    @name: _maybeWatchCollection
	    @description: Utility to watch something once or forever.
	    @returns unWatch function
	    @param watchOptions - see markersWatchOptions and or derrivatives. This object is used
	    to set watching to once and its watch depth.
	    */
	    var _maybeWatchCollection = function _maybeWatchCollection(scope, thingToWatchStr, watchOptions, initCb) {
	      return _maybe(scope, '$watchCollection', thingToWatchStr, watchOptions, initCb);
	    };
	
	    return {
	      maybeWatch: _maybeWatch,
	      maybeWatchCollection: _maybeWatchCollection
	    };
	  });
	
	  angular.module('leaflet-directive').factory('nominatimService', ["$q", "$http", "leafletHelpers", "leafletMapDefaults", function ($q, $http, leafletHelpers, leafletMapDefaults) {
	    var isDefined = leafletHelpers.isDefined;
	
	    return {
	      query: function query(address, mapId) {
	        var defaults = leafletMapDefaults.getDefaults(mapId);
	        var url = defaults.nominatim.server;
	        var df = $q.defer();
	
	        $http.get(url, { params: { format: 'json', limit: 1, q: address } }).success(function (data) {
	          if (data.length > 0 && isDefined(data[0].boundingbox)) {
	            df.resolve(data[0]);
	          } else {
	            df.reject('[Nominatim] Invalid address');
	          }
	        });
	
	        return df.promise;
	      }
	    };
	  }]);
	
	  angular.module('leaflet-directive').directive('bounds', ["$log", "$timeout", "$http", "leafletHelpers", "nominatimService", "leafletBoundsHelpers", function ($log, $timeout, $http, leafletHelpers, nominatimService, leafletBoundsHelpers) {
	
	    return {
	      restrict: 'A',
	      scope: false,
	      replace: false,
	      require: ['leaflet'],
	
	      link: function link(scope, element, attrs, controller) {
	        var isDefined = leafletHelpers.isDefined;
	        var createLeafletBounds = leafletBoundsHelpers.createLeafletBounds;
	        var leafletScope = controller[0].getLeafletScope();
	        var mapController = controller[0];
	        var errorHeader = leafletHelpers.errorHeader + ' [Bounds] ';
	
	        var emptyBounds = function emptyBounds(bounds) {
	          return bounds._southWest.lat === 0 && bounds._southWest.lng === 0 && bounds._northEast.lat === 0 && bounds._northEast.lng === 0;
	        };
	
	        mapController.getMap().then(function (map) {
	          leafletScope.$on('boundsChanged', function (event) {
	            var scope = event.currentScope;
	            var bounds = map.getBounds();
	
	            if (emptyBounds(bounds) || scope.settingBoundsFromScope) {
	              return;
	            }
	
	            scope.settingBoundsFromLeaflet = true;
	            var newScopeBounds = {
	              northEast: {
	                lat: bounds._northEast.lat,
	                lng: bounds._northEast.lng
	              },
	              southWest: {
	                lat: bounds._southWest.lat,
	                lng: bounds._southWest.lng
	              },
	              options: bounds.options
	            };
	            if (!angular.equals(scope.bounds, newScopeBounds)) {
	              scope.bounds = newScopeBounds;
	            }
	
	            $timeout(function () {
	              scope.settingBoundsFromLeaflet = false;
	            });
	          });
	
	          var lastNominatimQuery;
	          leafletScope.$watch('bounds', function (bounds) {
	            if (scope.settingBoundsFromLeaflet) return;
	            if (isDefined(bounds.address) && bounds.address !== lastNominatimQuery) {
	              scope.settingBoundsFromScope = true;
	              nominatimService.query(bounds.address, attrs.id).then(function (data) {
	                var b = data.boundingbox;
	                var newBounds = [[b[0], b[2]], [b[1], b[3]]];
	                map.fitBounds(newBounds);
	              }, function (errMsg) {
	
	                $log.error(errorHeader + ' ' + errMsg + '.');
	              });
	
	              lastNominatimQuery = bounds.address;
	              $timeout(function () {
	                scope.settingBoundsFromScope = false;
	              });
	
	              return;
	            }
	
	            var leafletBounds = createLeafletBounds(bounds);
	            if (leafletBounds && !map.getBounds().equals(leafletBounds)) {
	              scope.settingBoundsFromScope = true;
	              map.fitBounds(leafletBounds, bounds.options);
	              $timeout(function () {
	                scope.settingBoundsFromScope = false;
	              });
	            }
	          }, true);
	        });
	      }
	    };
	  }]);
	
	  var centerDirectiveTypes = ['center', 'lfCenter'];
	  var centerDirectives = {};
	
	  centerDirectiveTypes.forEach(function (directiveName) {
	    centerDirectives[directiveName] = ['$log', '$q', '$location', '$timeout', 'leafletMapDefaults', 'leafletHelpers', 'leafletBoundsHelpers', 'leafletMapEvents', function ($log, $q, $location, $timeout, leafletMapDefaults, leafletHelpers, leafletBoundsHelpers, leafletMapEvents) {
	
	      var isDefined = leafletHelpers.isDefined;
	      var isNumber = leafletHelpers.isNumber;
	      var isSameCenterOnMap = leafletHelpers.isSameCenterOnMap;
	      var safeApply = leafletHelpers.safeApply;
	      var isValidCenter = leafletHelpers.isValidCenter;
	      var isValidBounds = leafletBoundsHelpers.isValidBounds;
	      var isUndefinedOrEmpty = leafletHelpers.isUndefinedOrEmpty;
	      var errorHeader = leafletHelpers.errorHeader;
	
	      var shouldInitializeMapWithBounds = function shouldInitializeMapWithBounds(bounds, center) {
	        return isDefined(bounds) && isValidBounds(bounds) && isUndefinedOrEmpty(center);
	      };
	
	      var _leafletCenter;
	      return {
	        restrict: 'A',
	        scope: false,
	        replace: false,
	        require: 'leaflet',
	        controller: function controller() {
	          _leafletCenter = $q.defer();
	          this.getCenter = function () {
	            return _leafletCenter.promise;
	          };
	        },
	
	        link: function link(scope, element, attrs, controller) {
	          var leafletScope = controller.getLeafletScope();
	          var centerModel = leafletScope[directiveName];
	
	          controller.getMap().then(function (map) {
	            var defaults = leafletMapDefaults.getDefaults(attrs.id);
	
	            if (attrs[directiveName].search('-') !== -1) {
	              $log.error(errorHeader + ' The "center" variable can\'t use a "-" on its key name: "' + attrs[directiveName] + '".');
	              map.setView([defaults.center.lat, defaults.center.lng], defaults.center.zoom);
	              return;
	            } else if (shouldInitializeMapWithBounds(leafletScope.bounds, centerModel)) {
	              map.fitBounds(leafletBoundsHelpers.createLeafletBounds(leafletScope.bounds), leafletScope.bounds.options);
	              centerModel = map.getCenter();
	              safeApply(leafletScope, function (scope) {
	                angular.extend(scope[directiveName], {
	                  lat: map.getCenter().lat,
	                  lng: map.getCenter().lng,
	                  zoom: map.getZoom(),
	                  autoDiscover: false
	                });
	              });
	
	              safeApply(leafletScope, function (scope) {
	                var mapBounds = map.getBounds();
	                scope.bounds = {
	                  northEast: {
	                    lat: mapBounds._northEast.lat,
	                    lng: mapBounds._northEast.lng
	                  },
	                  southWest: {
	                    lat: mapBounds._southWest.lat,
	                    lng: mapBounds._southWest.lng
	                  }
	                };
	              });
	            } else if (!isDefined(centerModel)) {
	              $log.error(errorHeader + ' The "center" property is not defined in the main scope');
	              map.setView([defaults.center.lat, defaults.center.lng], defaults.center.zoom);
	              return;
	            } else if (!(isDefined(centerModel.lat) && isDefined(centerModel.lng)) && !isDefined(centerModel.autoDiscover)) {
	              angular.copy(defaults.center, centerModel);
	            }
	
	            var urlCenterHash;
	            var mapReady;
	            if (attrs.urlHashCenter === 'yes') {
	              var extractCenterFromUrl = function extractCenterFromUrl() {
	                var search = $location.search();
	                var centerParam;
	                if (isDefined(search.c)) {
	                  var cParam = search.c.split(':');
	                  if (cParam.length === 3) {
	                    centerParam = {
	                      lat: parseFloat(cParam[0]),
	                      lng: parseFloat(cParam[1]),
	                      zoom: parseInt(cParam[2], 10)
	                    };
	                  }
	                }
	
	                return centerParam;
	              };
	
	              urlCenterHash = extractCenterFromUrl();
	
	              leafletScope.$on('$locationChangeSuccess', function (event) {
	                var scope = event.currentScope;
	
	                //$log.debug("updated location...");
	                var urlCenter = extractCenterFromUrl();
	                if (isDefined(urlCenter) && !isSameCenterOnMap(urlCenter, map)) {
	                  //$log.debug("updating center model...", urlCenter);
	                  angular.extend(scope[directiveName], {
	                    lat: urlCenter.lat,
	                    lng: urlCenter.lng,
	                    zoom: urlCenter.zoom
	                  });
	                }
	              });
	            }
	
	            leafletScope.$watch(directiveName, function (center) {
	              if (leafletScope.settingCenterFromLeaflet) return;
	
	              //$log.debug("updated center model...");
	              // The center from the URL has priority
	              if (isDefined(urlCenterHash)) {
	                angular.copy(urlCenterHash, center);
	                urlCenterHash = undefined;
	              }
	
	              if (!isValidCenter(center) && center.autoDiscover !== true) {
	                $log.warn(errorHeader + ' invalid \'center\'');
	
	                //map.setView([defaults.center.lat, defaults.center.lng], defaults.center.zoom);
	                return;
	              }
	
	              if (center.autoDiscover === true) {
	                if (!isNumber(center.zoom)) {
	                  map.setView([defaults.center.lat, defaults.center.lng], defaults.center.zoom);
	                }
	
	                if (isNumber(center.zoom) && center.zoom > defaults.center.zoom) {
	                  map.locate({
	                    setView: true,
	                    maxZoom: center.zoom
	                  });
	                } else if (isDefined(defaults.maxZoom)) {
	                  map.locate({
	                    setView: true,
	                    maxZoom: defaults.maxZoom
	                  });
	                } else {
	                  map.locate({
	                    setView: true
	                  });
	                }
	
	                return;
	              }
	
	              if (mapReady && isSameCenterOnMap(center, map)) {
	                //$log.debug("no need to update map again.");
	                return;
	              }
	
	              //$log.debug("updating map center...", center);
	              leafletScope.settingCenterFromScope = true;
	              map.setView([center.lat, center.lng], center.zoom);
	              leafletMapEvents.notifyCenterChangedToBounds(leafletScope, map);
	              $timeout(function () {
	                leafletScope.settingCenterFromScope = false;
	
	                //$log.debug("allow center scope updates");
	              });
	            }, true);
	
	            map.whenReady(function () {
	              mapReady = true;
	            });
	
	            map.on('moveend', function () /* event */{
	              // Resolve the center after the first map position
	              _leafletCenter.resolve();
	              leafletMapEvents.notifyCenterUrlHashChanged(leafletScope, map, attrs, $location.search());
	
	              //$log.debug("updated center on map...");
	              if (isSameCenterOnMap(centerModel, map) || leafletScope.settingCenterFromScope) {
	                //$log.debug("same center in model, no need to update again.");
	                return;
	              }
	
	              leafletScope.settingCenterFromLeaflet = true;
	              safeApply(leafletScope, function (scope) {
	                if (!leafletScope.settingCenterFromScope) {
	                  //$log.debug("updating center model...", map.getCenter(), map.getZoom());
	                  angular.extend(scope[directiveName], {
	                    lat: map.getCenter().lat,
	                    lng: map.getCenter().lng,
	                    zoom: map.getZoom(),
	                    autoDiscover: false
	                  });
	                }
	
	                leafletMapEvents.notifyCenterChangedToBounds(leafletScope, map);
	                $timeout(function () {
	                  leafletScope.settingCenterFromLeaflet = false;
	                });
	              });
	            });
	
	            if (centerModel.autoDiscover === true) {
	              map.on('locationerror', function () {
	                $log.warn(errorHeader + ' The Geolocation API is unauthorized on this page.');
	                if (isValidCenter(centerModel)) {
	                  map.setView([centerModel.lat, centerModel.lng], centerModel.zoom);
	                  leafletMapEvents.notifyCenterChangedToBounds(leafletScope, map);
	                } else {
	                  map.setView([defaults.center.lat, defaults.center.lng], defaults.center.zoom);
	                  leafletMapEvents.notifyCenterChangedToBounds(leafletScope, map);
	                }
	              });
	            }
	          });
	        }
	      };
	    }];
	  });
	
	  centerDirectiveTypes.forEach(function (dirType) {
	    angular.module('leaflet-directive').directive(dirType, centerDirectives[dirType]);
	  });
	
	  angular.module('leaflet-directive').directive('controls', ["$log", "leafletHelpers", "leafletControlHelpers", function ($log, leafletHelpers, leafletControlHelpers) {
	
	    return {
	      restrict: 'A',
	      scope: false,
	      replace: false,
	      require: '?^leaflet',
	
	      link: function link(scope, element, attrs, controller) {
	        if (!controller) {
	          return;
	        }
	
	        var createControl = leafletControlHelpers.createControl;
	        var isValidControlType = leafletControlHelpers.isValidControlType;
	        var leafletScope = controller.getLeafletScope();
	        var isDefined = leafletHelpers.isDefined;
	        var isArray = leafletHelpers.isArray;
	        var leafletControls = {};
	        var errorHeader = leafletHelpers.errorHeader + ' [Controls] ';
	
	        controller.getMap().then(function (map) {
	
	          leafletScope.$watchCollection('controls', function (newControls) {
	
	            // Delete controls from the array
	            for (var name in leafletControls) {
	              if (!isDefined(newControls[name])) {
	                if (map.hasControl(leafletControls[name])) {
	                  map.removeControl(leafletControls[name]);
	                }
	
	                delete leafletControls[name];
	              }
	            }
	
	            for (var newName in newControls) {
	              var control;
	
	              var controlType = isDefined(newControls[newName].type) ? newControls[newName].type : newName;
	
	              if (!isValidControlType(controlType)) {
	                $log.error(errorHeader + ' Invalid control type: ' + controlType + '.');
	                return;
	              }
	
	              if (controlType !== 'custom') {
	                control = createControl(controlType, newControls[newName]);
	                map.addControl(control);
	                leafletControls[newName] = control;
	              } else {
	                var customControlValue = newControls[newName];
	                if (isArray(customControlValue)) {
	                  for (var i in customControlValue) {
	                    var customControl = customControlValue[i];
	                    map.addControl(customControl);
	                    leafletControls[newName] = !isDefined(leafletControls[newName]) ? [customControl] : leafletControls[newName].concat([customControl]);
	                  }
	                } else {
	                  map.addControl(customControlValue);
	                  leafletControls[newName] = customControlValue;
	                }
	              }
	            }
	          });
	        });
	      }
	    };
	  }]);
	
	  angular.module('leaflet-directive').directive('decorations', ["$log", "leafletHelpers", function ($log, leafletHelpers) {
	
	    return {
	      restrict: 'A',
	      scope: false,
	      replace: false,
	      require: 'leaflet',
	
	      link: function link(scope, element, attrs, controller) {
	        var leafletScope = controller.getLeafletScope();
	        var PolylineDecoratorPlugin = leafletHelpers.PolylineDecoratorPlugin;
	        var isDefined = leafletHelpers.isDefined;
	        var leafletDecorations = {};
	
	        /* Creates an "empty" decoration with a set of coordinates, but no pattern. */
	        function createDecoration(options) {
	          if (isDefined(options) && isDefined(options.coordinates)) {
	            if (!PolylineDecoratorPlugin.isLoaded()) {
	              $log.error('[AngularJS - Leaflet] The PolylineDecorator Plugin is not loaded.');
	            }
	          }
	
	          return L.polylineDecorator(options.coordinates);
	        }
	
	        /* Updates the path and the patterns for the provided decoration, and returns the decoration. */
	        function setDecorationOptions(decoration, options) {
	          if (isDefined(decoration) && isDefined(options)) {
	            if (isDefined(options.coordinates) && isDefined(options.patterns)) {
	              decoration.setPaths(options.coordinates);
	              decoration.setPatterns(options.patterns);
	              return decoration;
	            }
	          }
	        }
	
	        controller.getMap().then(function (map) {
	          leafletScope.$watch('decorations', function (newDecorations) {
	            for (var name in leafletDecorations) {
	              if (!isDefined(newDecorations[name]) || !angular.equals(newDecorations[name], leafletDecorations)) {
	                map.removeLayer(leafletDecorations[name]);
	                delete leafletDecorations[name];
	              }
	            }
	
	            for (var newName in newDecorations) {
	              var decorationData = newDecorations[newName];
	              var newDecoration = createDecoration(decorationData);
	
	              if (isDefined(newDecoration)) {
	                leafletDecorations[newName] = newDecoration;
	                map.addLayer(newDecoration);
	                setDecorationOptions(newDecoration, decorationData);
	              }
	            }
	          }, true);
	        });
	      }
	    };
	  }]);
	
	  angular.module('leaflet-directive').directive('eventBroadcast', ["$log", "$rootScope", "leafletHelpers", "leafletMapEvents", "leafletIterators", function ($log, $rootScope, leafletHelpers, leafletMapEvents, leafletIterators) {
	
	    return {
	      restrict: 'A',
	      scope: false,
	      replace: false,
	      require: 'leaflet',
	
	      link: function link(scope, element, attrs, controller) {
	        var isObject = leafletHelpers.isObject;
	        var isDefined = leafletHelpers.isDefined;
	        var leafletScope = controller.getLeafletScope();
	        var eventBroadcast = leafletScope.eventBroadcast;
	        var availableMapEvents = leafletMapEvents.getAvailableMapEvents();
	        var addEvents = leafletMapEvents.addEvents;
	
	        controller.getMap().then(function (map) {
	
	          var mapEvents = [];
	          var logic = 'broadcast';
	
	          // We have a possible valid object
	          if (!isDefined(eventBroadcast.map)) {
	            // We do not have events enable/disable do we do nothing (all enabled by default)
	            mapEvents = availableMapEvents;
	          } else if (!isObject(eventBroadcast.map)) {
	            // Not a valid object
	            $log.warn('[AngularJS - Leaflet] event-broadcast.map must be an object check your model.');
	          } else {
	            // We have a possible valid map object
	            // Event propadation logic
	            if (eventBroadcast.map.logic !== 'emit' && eventBroadcast.map.logic !== 'broadcast') {
	              // This is an error
	              $log.warn('[AngularJS - Leaflet] Available event propagation logic are: \'emit\' or \'broadcast\'.');
	            } else {
	              logic = eventBroadcast.map.logic;
	            }
	
	            if (!(isObject(eventBroadcast.map.enable) && eventBroadcast.map.enable.length >= 0)) {
	              $log.warn('[AngularJS - Leaflet] event-broadcast.map.enable must be an object check your model.');
	            } else {
	              // Enable events
	              leafletIterators.each(eventBroadcast.map.enable, function (eventName) {
	                // Do we have already the event enabled?
	                if (mapEvents.indexOf(eventName) === -1 && availableMapEvents.indexOf(eventName) !== -1) {
	                  mapEvents.push(eventName);
	                }
	              });
	            }
	          }
	
	          // as long as the map is removed in the root leaflet directive we
	          // do not need ot clean up the events as leaflet does it itself
	          addEvents(map, mapEvents, 'eventName', leafletScope, logic);
	        });
	      }
	    };
	  }]);
	
	  angular.module('leaflet-directive').directive('geojson', ["$log", "$rootScope", "leafletData", "leafletHelpers", "leafletWatchHelpers", "leafletDirectiveControlsHelpers", "leafletIterators", "leafletGeoJsonEvents", function ($log, $rootScope, leafletData, leafletHelpers, leafletWatchHelpers, leafletDirectiveControlsHelpers, leafletIterators, leafletGeoJsonEvents) {
	    var _maybeWatch = leafletWatchHelpers.maybeWatch;
	    var _watchOptions = leafletHelpers.watchOptions;
	    var _extendDirectiveControls = leafletDirectiveControlsHelpers.extend;
	    var hlp = leafletHelpers;
	    var $it = leafletIterators;
	
	    return {
	      restrict: 'A',
	      scope: false,
	      replace: false,
	      require: 'leaflet',
	
	      link: function link(scope, element, attrs, controller) {
	        var isDefined = leafletHelpers.isDefined;
	        var leafletScope = controller.getLeafletScope();
	        var leafletGeoJSON = {};
	        var _hasSetLeafletData = false;
	
	        controller.getMap().then(function (map) {
	          var watchOptions = leafletScope.geojsonWatchOptions || _watchOptions;
	
	          var _hookUpEvents = function _hookUpEvents(geojson, maybeName) {
	            var onEachFeature;
	
	            if (angular.isFunction(geojson.onEachFeature)) {
	              onEachFeature = geojson.onEachFeature;
	            } else {
	              onEachFeature = function onEachFeature(feature, layer) {
	                if (leafletHelpers.LabelPlugin.isLoaded() && isDefined(feature.properties.description)) {
	                  layer.bindLabel(feature.properties.description);
	                }
	
	                leafletGeoJsonEvents.bindEvents(attrs.id, layer, null, feature, leafletScope, maybeName, { resetStyleOnMouseout: geojson.resetStyleOnMouseout,
	                  mapId: attrs.id });
	              };
	            }
	
	            return onEachFeature;
	          };
	
	          var isNested = hlp.isDefined(attrs.geojsonNested) && hlp.isTruthy(attrs.geojsonNested);
	
	          var _clean = function _clean() {
	            if (!leafletGeoJSON) return;
	            var _remove = function _remove(lObject) {
	              if (isDefined(lObject) && map.hasLayer(lObject)) {
	                map.removeLayer(lObject);
	              }
	            };
	
	            if (isNested) {
	              $it.each(leafletGeoJSON, function (lObject) {
	                _remove(lObject);
	              });
	
	              return;
	            }
	
	            _remove(leafletGeoJSON);
	          };
	
	          var _addGeojson = function _addGeojson(model, maybeName) {
	            var geojson = angular.copy(model);
	            if (!(isDefined(geojson) && isDefined(geojson.data))) {
	              return;
	            }
	
	            var onEachFeature = _hookUpEvents(geojson, maybeName);
	
	            if (!isDefined(geojson.options)) {
	              //right here is why we use a clone / copy (we modify and thus)
	              //would kick of a watcher.. we need to be more careful everywhere
	              //for stuff like this
	              geojson.options = {
	                style: geojson.style,
	                filter: geojson.filter,
	                onEachFeature: onEachFeature,
	                pointToLayer: geojson.pointToLayer
	              };
	            }
	
	            var lObject = L.geoJson(geojson.data, geojson.options);
	
	            if (maybeName && hlp.isString(maybeName)) {
	              leafletGeoJSON[maybeName] = lObject;
	            } else {
	              leafletGeoJSON = lObject;
	            }
	
	            lObject.addTo(map);
	
	            if (!_hasSetLeafletData) {
	              //only do this once and play with the same ref forever
	              _hasSetLeafletData = true;
	              leafletData.setGeoJSON(leafletGeoJSON, attrs.id);
	            }
	          };
	
	          var _create = function _create(model) {
	            _clean();
	            if (isNested) {
	              if (!model || !Object.keys(model).length) return;
	              $it.each(model, function (m, name) {
	                //name could be layerName and or groupName
	                //for now it is not tied to a layer
	                _addGeojson(m, name);
	              });
	
	              return;
	            }
	
	            _addGeojson(model);
	          };
	
	          _extendDirectiveControls(attrs.id, 'geojson', _create, _clean);
	
	          _maybeWatch(leafletScope, 'geojson', watchOptions, function (geojson) {
	            _create(geojson);
	          });
	        });
	      }
	    };
	  }]);
	
	  angular.module('leaflet-directive').directive('layercontrol', ["$filter", "$log", "leafletData", "leafletHelpers", function ($filter, $log, leafletData, leafletHelpers) {
	
	    return {
	      restrict: 'E',
	      scope: {
	        icons: '=?',
	        autoHideOpacity: '=?', // Hide other opacity controls when one is activated.
	        showGroups: '=?', // Hide other opacity controls when one is activated.
	        title: '@',
	        baseTitle: '@',
	        overlaysTitle: '@'
	      },
	      replace: true,
	      transclude: false,
	      require: '^leaflet',
	      controller: ["$scope", "$element", "$sce", function ($scope, $element, $sce) {
	        $log.debug('[Angular Directive - Layers] layers', $scope, $element);
	        var safeApply = leafletHelpers.safeApply;
	        var isDefined = leafletHelpers.isDefined;
	        angular.extend($scope, {
	          baselayer: '',
	          oldGroup: '',
	          layerProperties: {},
	          groupProperties: {},
	          rangeIsSupported: leafletHelpers.rangeIsSupported(),
	          changeBaseLayer: function changeBaseLayer(key, e) {
	            leafletHelpers.safeApply($scope, function (scp) {
	              scp.baselayer = key;
	              leafletData.getMap().then(function (map) {
	                leafletData.getLayers().then(function (leafletLayers) {
	                  if (map.hasLayer(leafletLayers.baselayers[key])) {
	                    return;
	                  }
	
	                  for (var i in scp.layers.baselayers) {
	                    scp.layers.baselayers[i].icon = scp.icons.unradio;
	                    if (map.hasLayer(leafletLayers.baselayers[i])) {
	                      map.removeLayer(leafletLayers.baselayers[i]);
	                    }
	                  }
	
	                  map.addLayer(leafletLayers.baselayers[key]);
	                  scp.layers.baselayers[key].icon = $scope.icons.radio;
	                });
	              });
	            });
	
	            e.preventDefault();
	          },
	
	          moveLayer: function moveLayer(ly, newIndex, e) {
	            var delta = Object.keys($scope.layers.baselayers).length;
	            if (newIndex >= 1 + delta && newIndex <= $scope.overlaysArray.length + delta) {
	              var oldLy;
	              for (var key in $scope.layers.overlays) {
	                if ($scope.layers.overlays[key].index === newIndex) {
	                  oldLy = $scope.layers.overlays[key];
	                  break;
	                }
	              }
	
	              if (oldLy) {
	                safeApply($scope, function () {
	                  oldLy.index = ly.index;
	                  ly.index = newIndex;
	                });
	              }
	            }
	
	            e.stopPropagation();
	            e.preventDefault();
	          },
	
	          initIndex: function initIndex(layer, idx) {
	            var delta = Object.keys($scope.layers.baselayers).length;
	            layer.index = isDefined(layer.index) ? layer.index : idx + delta + 1;
	          },
	
	          initGroup: function initGroup(groupName) {
	            $scope.groupProperties[groupName] = $scope.groupProperties[groupName] ? $scope.groupProperties[groupName] : {};
	          },
	
	          toggleOpacity: function toggleOpacity(e, layer) {
	            if (layer.visible) {
	              if ($scope.autoHideOpacity && !$scope.layerProperties[layer.name].opacityControl) {
	                for (var k in $scope.layerProperties) {
	                  $scope.layerProperties[k].opacityControl = false;
	                }
	              }
	
	              $scope.layerProperties[layer.name].opacityControl = !$scope.layerProperties[layer.name].opacityControl;
	            }
	
	            e.stopPropagation();
	            e.preventDefault();
	          },
	
	          toggleLegend: function toggleLegend(layer) {
	            $scope.layerProperties[layer.name].showLegend = !$scope.layerProperties[layer.name].showLegend;
	          },
	
	          showLegend: function showLegend(layer) {
	            return layer.legend && $scope.layerProperties[layer.name].showLegend;
	          },
	
	          unsafeHTML: function unsafeHTML(html) {
	            return $sce.trustAsHtml(html);
	          },
	
	          getOpacityIcon: function getOpacityIcon(layer) {
	            return layer.visible && $scope.layerProperties[layer.name].opacityControl ? $scope.icons.close : $scope.icons.open;
	          },
	
	          getGroupIcon: function getGroupIcon(group) {
	            return group.visible ? $scope.icons.check : $scope.icons.uncheck;
	          },
	
	          changeOpacity: function changeOpacity(layer) {
	            var op = $scope.layerProperties[layer.name].opacity;
	            leafletData.getMap().then(function (map) {
	              leafletData.getLayers().then(function (leafletLayers) {
	                var ly;
	                for (var k in $scope.layers.overlays) {
	                  if ($scope.layers.overlays[k] === layer) {
	                    ly = leafletLayers.overlays[k];
	                    break;
	                  }
	                }
	
	                if (map.hasLayer(ly)) {
	                  if (ly.setOpacity) {
	                    ly.setOpacity(op / 100);
	                  }
	
	                  if (ly.getLayers && ly.eachLayer) {
	                    ly.eachLayer(function (lay) {
	                      if (lay.setOpacity) {
	                        lay.setOpacity(op / 100);
	                      }
	                    });
	                  }
	                }
	              });
	            });
	          },
	
	          changeGroupVisibility: function changeGroupVisibility(groupName) {
	            if (!isDefined($scope.groupProperties[groupName])) {
	              return;
	            }
	
	            var visible = $scope.groupProperties[groupName].visible;
	            for (var k in $scope.layers.overlays) {
	              var layer = $scope.layers.overlays[k];
	              if (layer.group === groupName) {
	                layer.visible = visible;
	              }
	            }
	          }
	        });
	
	        var div = $element.get(0);
	        if (!L.Browser.touch) {
	          L.DomEvent.disableClickPropagation(div);
	          L.DomEvent.on(div, 'mousewheel', L.DomEvent.stopPropagation);
	        } else {
	          L.DomEvent.on(div, 'click', L.DomEvent.stopPropagation);
	        }
	      }],
	
	      template: '<div class="angular-leaflet-control-layers" ng-show="overlaysArray.length">' + '<h4 ng-if="title">{{ title }}</h4>' + '<div class="lf-baselayers">' + '<h5 class="lf-title" ng-if="baseTitle">{{ baseTitle }}</h5>' + '<div class="lf-row" ng-repeat="(key, layer) in baselayersArray">' + '<label class="lf-icon-bl" ng-click="changeBaseLayer(key, $event)">' + '<input class="leaflet-control-layers-selector" type="radio" name="lf-radio" ' + 'ng-show="false" ng-checked="baselayer === key" ng-value="key" /> ' + '<i class="lf-icon lf-icon-radio" ng-class="layer.icon"></i>' + '<div class="lf-text">{{layer.name}}</div>' + '</label>' + '</div>' + '</div>' + '<div class="lf-overlays">' + '<h5 class="lf-title" ng-if="overlaysTitle">{{ overlaysTitle }}</h5>' + '<div class="lf-container">' + '<div class="lf-row" ng-repeat="layer in (o = (overlaysArray | orderBy:\'index\':order))" ng-init="initIndex(layer, $index)">' + '<label class="lf-icon-ol-group" ng-if="showGroups &amp;&amp; layer.group &amp;&amp; layer.group != o[$index-1].group">' + '<input class="lf-control-layers-selector" type="checkbox" ng-show="false" ' + 'ng-change="changeGroupVisibility(layer.group)" ng-model="groupProperties[layer.group].visible"/> ' + '<i class="lf-icon lf-icon-check" ng-class="getGroupIcon(groupProperties[layer.group])"></i>' + '<div class="lf-text">{{ layer.group }}</div>' + '</label>' + '<label class="lf-icon-ol">' + '<input class="lf-control-layers-selector" type="checkbox" ng-show="false" ng-model="layer.visible"/> ' + '<i class="lf-icon lf-icon-check" ng-class="layer.icon"></i>' + '<div class="lf-text">{{layer.name}}</div>' + '</label>' + '<div class="lf-icons">' + '<i class="lf-icon lf-up" ng-class="icons.up" ng-click="moveLayer(layer, layer.index - orderNumber, $event)"></i> ' + '<i class="lf-icon lf-down" ng-class="icons.down" ng-click="moveLayer(layer, layer.index + orderNumber, $event)"></i> ' + '<i class="lf-icon lf-toggle-legend" ng-class="icons.toggleLegend" ng-if="layer.legend" ng-click="toggleLegend(layer)"></i> ' + '<i class="lf-icon lf-open" ng-class="getOpacityIcon(layer)" ng-click="toggleOpacity($event, layer)"></i>' + '</div>' + '<div class="lf-legend" ng-if="showLegend(layer)" ng-bind-html="unsafeHTML(layer.legend)"></div>' + '<div class="lf-opacity clearfix" ng-if="layer.visible &amp;&amp; layerProperties[layer.name].opacityControl">' + '<label ng-if="rangeIsSupported" class="pull-left" style="width: 50%">0</label>' + '<label ng-if="rangeIsSupported" class="pull-left text-right" style="width: 50%">100</label>' + '<input ng-if="rangeIsSupported" class="clearfix" type="range" min="0" max="100" class="lf-opacity-control" ' + 'ng-model="layerProperties[layer.name].opacity" ng-change="changeOpacity(layer)"/>' + '<h6 ng-if="!rangeIsSupported">Range is not supported in this browser</h6>' + '</div>' + '</div>' + '</div>' + '</div>' + '</div>',
	      link: function link(scope, element, attrs, controller) {
	        var isDefined = leafletHelpers.isDefined;
	        var leafletScope = controller.getLeafletScope();
	        var layers = leafletScope.layers;
	
	        scope.$watch('icons', function () {
	          var defaultIcons = {
	            uncheck: 'fa fa-square-o',
	            check: 'fa fa-check-square-o',
	            radio: 'fa fa-dot-circle-o',
	            unradio: 'fa fa-circle-o',
	            up: 'fa fa-angle-up',
	            down: 'fa fa-angle-down',
	            open: 'fa fa-angle-double-down',
	            close: 'fa fa-angle-double-up',
	            toggleLegend: 'fa fa-pencil-square-o'
	          };
	          if (isDefined(scope.icons)) {
	            angular.extend(defaultIcons, scope.icons);
	            angular.extend(scope.icons, defaultIcons);
	          } else {
	            scope.icons = defaultIcons;
	          }
	        });
	
	        // Setting layer stack order.
	        attrs.order = isDefined(attrs.order) && (attrs.order === 'normal' || attrs.order === 'reverse') ? attrs.order : 'normal';
	        scope.order = attrs.order === 'normal';
	        scope.orderNumber = attrs.order === 'normal' ? -1 : 1;
	
	        scope.layers = layers;
	        controller.getMap().then(function (map) {
	          leafletScope.$watch('layers.baselayers', function (newBaseLayers) {
	            var baselayersArray = {};
	            leafletData.getLayers().then(function (leafletLayers) {
	              var key;
	              for (key in newBaseLayers) {
	                var layer = newBaseLayers[key];
	                layer.icon = scope.icons[map.hasLayer(leafletLayers.baselayers[key]) ? 'radio' : 'unradio'];
	                baselayersArray[key] = layer;
	              }
	
	              scope.baselayersArray = baselayersArray;
	            });
	          });
	
	          leafletScope.$watch('layers.overlays', function (newOverlayLayers) {
	            var overlaysArray = [];
	            var groupVisibleCount = {};
	            leafletData.getLayers().then(function (leafletLayers) {
	              var key;
	              for (key in newOverlayLayers) {
	                var layer = newOverlayLayers[key];
	                layer.icon = scope.icons[layer.visible ? 'check' : 'uncheck'];
	                overlaysArray.push(layer);
	                if (!isDefined(scope.layerProperties[layer.name])) {
	                  scope.layerProperties[layer.name] = {
	                    opacity: isDefined(layer.layerOptions.opacity) ? layer.layerOptions.opacity * 100 : 100,
	                    opacityControl: false,
	                    showLegend: true
	                  };
	                }
	
	                if (isDefined(layer.group)) {
	                  if (!isDefined(scope.groupProperties[layer.group])) {
	                    scope.groupProperties[layer.group] = {
	                      visible: false
	                    };
	                  }
	
	                  groupVisibleCount[layer.group] = isDefined(groupVisibleCount[layer.group]) ? groupVisibleCount[layer.group] : {
	                    count: 0,
	                    visibles: 0
	                  };
	                  groupVisibleCount[layer.group].count++;
	                  if (layer.visible) {
	                    groupVisibleCount[layer.group].visibles++;
	                  }
	                }
	
	                if (isDefined(layer.index) && leafletLayers.overlays[key].setZIndex) {
	                  leafletLayers.overlays[key].setZIndex(newOverlayLayers[key].index);
	                }
	              }
	
	              for (key in groupVisibleCount) {
	                scope.groupProperties[key].visible = groupVisibleCount[key].visibles === groupVisibleCount[key].count;
	              }
	
	              scope.overlaysArray = overlaysArray;
	            });
	          }, true);
	        });
	      }
	    };
	  }]);
	
	  angular.module('leaflet-directive').directive('layers', ["$log", "$q", "leafletData", "leafletHelpers", "leafletLayerHelpers", "leafletControlHelpers", function ($log, $q, leafletData, leafletHelpers, leafletLayerHelpers, leafletControlHelpers) {
	
	    return {
	      restrict: 'A',
	      scope: false,
	      replace: false,
	      require: 'leaflet',
	      controller: ["$scope", function ($scope) {
	        $scope._leafletLayers = $q.defer();
	        this.getLayers = function () {
	          return $scope._leafletLayers.promise;
	        };
	      }],
	
	      link: function link(scope, element, attrs, controller) {
	        var isDefined = leafletHelpers.isDefined;
	        var leafletLayers = {};
	        var leafletScope = controller.getLeafletScope();
	        var layers = leafletScope.layers;
	        var createLayer = leafletLayerHelpers.createLayer;
	        var safeAddLayer = leafletLayerHelpers.safeAddLayer;
	        var safeRemoveLayer = leafletLayerHelpers.safeRemoveLayer;
	        var updateLayersControl = leafletControlHelpers.updateLayersControl;
	        var isLayersControlVisible = false;
	
	        controller.getMap().then(function (map) {
	
	          // We have baselayers to add to the map
	          scope._leafletLayers.resolve(leafletLayers);
	          leafletData.setLayers(leafletLayers, attrs.id);
	
	          leafletLayers.baselayers = {};
	          leafletLayers.overlays = {};
	
	          var mapId = attrs.id;
	
	          // Setup all baselayers definitions
	          var oneVisibleLayer = false;
	          for (var layerName in layers.baselayers) {
	            var newBaseLayer = createLayer(layers.baselayers[layerName]);
	            if (!isDefined(newBaseLayer)) {
	              delete layers.baselayers[layerName];
	              continue;
	            }
	
	            leafletLayers.baselayers[layerName] = newBaseLayer;
	
	            // Only add the visible layer to the map, layer control manages the addition to the map
	            // of layers in its control
	            if (layers.baselayers[layerName].top === true) {
	              safeAddLayer(map, leafletLayers.baselayers[layerName]);
	              oneVisibleLayer = true;
	            }
	          }
	
	          // If there is no visible layer add first to the map
	          if (!oneVisibleLayer && Object.keys(leafletLayers.baselayers).length > 0) {
	            safeAddLayer(map, leafletLayers.baselayers[Object.keys(layers.baselayers)[0]]);
	          }
	
	          // Setup the Overlays
	          for (layerName in layers.overlays) {
	            //if (layers.overlays[layerName].type === 'cartodb') {
	            //
	            //}
	
	            var newOverlayLayer = createLayer(layers.overlays[layerName]);
	            if (!isDefined(newOverlayLayer)) {
	              delete layers.overlays[layerName];
	              continue;
	            }
	
	            leafletLayers.overlays[layerName] = newOverlayLayer;
	
	            // Only add the visible overlays to the map
	            if (layers.overlays[layerName].visible === true) {
	              safeAddLayer(map, leafletLayers.overlays[layerName]);
	            }
	          }
	
	          // Watch for the base layers
	          leafletScope.$watch('layers.baselayers', function (newBaseLayers, oldBaseLayers) {
	            if (angular.equals(newBaseLayers, oldBaseLayers)) {
	              isLayersControlVisible = updateLayersControl(map, mapId, isLayersControlVisible, newBaseLayers, layers.overlays, leafletLayers);
	              return true;
	            }
	
	            // Delete layers from the array
	            for (var name in leafletLayers.baselayers) {
	              if (!isDefined(newBaseLayers[name]) || newBaseLayers[name].doRefresh) {
	                // Remove from the map if it's on it
	                if (map.hasLayer(leafletLayers.baselayers[name])) {
	                  map.removeLayer(leafletLayers.baselayers[name]);
	                }
	
	                delete leafletLayers.baselayers[name];
	
	                if (newBaseLayers[name] && newBaseLayers[name].doRefresh) {
	                  newBaseLayers[name].doRefresh = false;
	                }
	              }
	            }
	
	            // add new layers
	            for (var newName in newBaseLayers) {
	              if (!isDefined(leafletLayers.baselayers[newName])) {
	                var testBaseLayer = createLayer(newBaseLayers[newName]);
	                if (isDefined(testBaseLayer)) {
	                  leafletLayers.baselayers[newName] = testBaseLayer;
	
	                  // Only add the visible layer to the map
	                  if (newBaseLayers[newName].top === true) {
	                    safeAddLayer(map, leafletLayers.baselayers[newName]);
	                  }
	                }
	              } else {
	                if (newBaseLayers[newName].top === true && !map.hasLayer(leafletLayers.baselayers[newName])) {
	                  safeAddLayer(map, leafletLayers.baselayers[newName]);
	                } else if (newBaseLayers[newName].top === false && map.hasLayer(leafletLayers.baselayers[newName])) {
	                  map.removeLayer(leafletLayers.baselayers[newName]);
	                }
	              }
	            }
	
	            //we have layers, so we need to make, at least, one active
	            var found = false;
	
	            // search for an active layer
	            for (var key in leafletLayers.baselayers) {
	              if (map.hasLayer(leafletLayers.baselayers[key])) {
	                found = true;
	                break;
	              }
	            }
	
	            // If there is no active layer make one active
	            if (!found && Object.keys(leafletLayers.baselayers).length > 0) {
	              safeAddLayer(map, leafletLayers.baselayers[Object.keys(leafletLayers.baselayers)[0]]);
	            }
	
	            // Only show the layers switch selector control if we have more than one baselayer + overlay
	            isLayersControlVisible = updateLayersControl(map, mapId, isLayersControlVisible, newBaseLayers, layers.overlays, leafletLayers);
	          }, true);
	
	          // Watch for the overlay layers
	          leafletScope.$watch('layers.overlays', function (newOverlayLayers, oldOverlayLayers) {
	            if (angular.equals(newOverlayLayers, oldOverlayLayers)) {
	              isLayersControlVisible = updateLayersControl(map, mapId, isLayersControlVisible, layers.baselayers, newOverlayLayers, leafletLayers);
	              return true;
	            }
	
	            // Delete layers from the array
	            for (var name in leafletLayers.overlays) {
	              if (!isDefined(newOverlayLayers[name]) || newOverlayLayers[name].doRefresh) {
	                // Remove from the map if it's on it
	                if (map.hasLayer(leafletLayers.overlays[name])) {
	                  // Safe remove when ArcGIS layers is loading.
	                  var options = isDefined(newOverlayLayers[name]) ? newOverlayLayers[name].layerOptions : null;
	                  safeRemoveLayer(map, leafletLayers.overlays[name], options);
	                }
	
	                // TODO: Depending on the layer type we will have to delete what's included on it
	                delete leafletLayers.overlays[name];
	
	                if (newOverlayLayers[name] && newOverlayLayers[name].doRefresh) {
	                  newOverlayLayers[name].doRefresh = false;
	                }
	              }
	            }
	
	            // add new overlays
	            for (var newName in newOverlayLayers) {
	              if (!isDefined(leafletLayers.overlays[newName])) {
	                var testOverlayLayer = createLayer(newOverlayLayers[newName]);
	                if (!isDefined(testOverlayLayer)) {
	                  // If the layer creation fails, continue to the next overlay
	                  continue;
	                }
	
	                leafletLayers.overlays[newName] = testOverlayLayer;
	                if (newOverlayLayers[newName].visible === true) {
	                  safeAddLayer(map, leafletLayers.overlays[newName]);
	                }
	              } else {
	                // check for the .visible property to hide/show overLayers
	                if (newOverlayLayers[newName].visible && !map.hasLayer(leafletLayers.overlays[newName])) {
	                  safeAddLayer(map, leafletLayers.overlays[newName]);
	                } else if (newOverlayLayers[newName].visible === false && map.hasLayer(leafletLayers.overlays[newName])) {
	                  // Safe remove when ArcGIS layers is loading.
	                  safeRemoveLayer(map, leafletLayers.overlays[newName], newOverlayLayers[newName].layerOptions);
	                }
	              }
	
	              //refresh heatmap data if present
	              if (newOverlayLayers[newName].visible && map._loaded && newOverlayLayers[newName].data && newOverlayLayers[newName].type === 'heatmap') {
	                leafletLayers.overlays[newName].setData(newOverlayLayers[newName].data);
	                leafletLayers.overlays[newName].update();
	              }
	            }
	
	            // Only add the layers switch selector control if we have more than one baselayer + overlay
	            isLayersControlVisible = updateLayersControl(map, mapId, isLayersControlVisible, layers.baselayers, newOverlayLayers, leafletLayers);
	          }, true);
	        });
	      }
	    };
	  }]);
	
	  angular.module('leaflet-directive').directive('legend', ["$log", "$http", "leafletHelpers", "leafletLegendHelpers", function ($log, $http, leafletHelpers, leafletLegendHelpers) {
	
	    return {
	      restrict: 'A',
	      scope: false,
	      replace: false,
	      require: 'leaflet',
	
	      link: function link(scope, element, attrs, controller) {
	
	        var isArray = leafletHelpers.isArray;
	        var isDefined = leafletHelpers.isDefined;
	        var isFunction = leafletHelpers.isFunction;
	        var leafletScope = controller.getLeafletScope();
	        var legend = leafletScope.legend;
	
	        var legendClass;
	        var position;
	        var leafletLegend;
	        var type;
	
	        leafletScope.$watch('legend', function (newLegend) {
	
	          if (isDefined(newLegend)) {
	
	            legendClass = newLegend.legendClass ? newLegend.legendClass : 'legend';
	
	            position = newLegend.position || 'bottomright';
	
	            // default to arcgis
	            type = newLegend.type || 'arcgis';
	          }
	        }, true);
	
	        controller.getMap().then(function (map) {
	
	          leafletScope.$watch('legend', function (newLegend) {
	
	            if (!isDefined(newLegend)) {
	
	              if (isDefined(leafletLegend)) {
	                leafletLegend.removeFrom(map);
	                leafletLegend = null;
	              }
	
	              return;
	            }
	
	            if (!isDefined(newLegend.url) && type === 'arcgis' && (!isArray(newLegend.colors) || !isArray(newLegend.labels) || newLegend.colors.length !== newLegend.labels.length)) {
	
	              $log.warn('[AngularJS - Leaflet] legend.colors and legend.labels must be set.');
	
	              return;
	            }
	
	            if (isDefined(newLegend.url)) {
	
	              $log.info('[AngularJS - Leaflet] loading legend service.');
	
	              return;
	            }
	
	            if (isDefined(leafletLegend)) {
	              leafletLegend.removeFrom(map);
	              leafletLegend = null;
	            }
	
	            leafletLegend = L.control({
	              position: position
	            });
	            if (type === 'arcgis') {
	              leafletLegend.onAdd = leafletLegendHelpers.getOnAddArrayLegend(newLegend, legendClass);
	            }
	
	            leafletLegend.addTo(map);
	          });
	
	          leafletScope.$watch('legend.url', function (newURL) {
	
	            if (!isDefined(newURL)) {
	              return;
	            }
	
	            $http.get(newURL).success(function (legendData) {
	
	              if (isDefined(leafletLegend)) {
	
	                leafletLegendHelpers.updateLegend(leafletLegend.getContainer(), legendData, type, newURL);
	              } else {
	
	                leafletLegend = L.control({
	                  position: position
	                });
	                leafletLegend.onAdd = leafletLegendHelpers.getOnAddLegend(legendData, legendClass, type, newURL);
	                leafletLegend.addTo(map);
	              }
	
	              if (isDefined(legend.loadedData) && isFunction(legend.loadedData)) {
	                legend.loadedData();
	              }
	            }).error(function () {
	              $log.warn('[AngularJS - Leaflet] legend.url not loaded.');
	            });
	          });
	        });
	      }
	    };
	  }]);
	
	  angular.module('leaflet-directive').directive('markers', ["$log", "$rootScope", "$q", "leafletData", "leafletHelpers", "leafletMapDefaults", "leafletMarkersHelpers", "leafletMarkerEvents", "leafletIterators", "leafletWatchHelpers", "leafletDirectiveControlsHelpers", function ($log, $rootScope, $q, leafletData, leafletHelpers, leafletMapDefaults, leafletMarkersHelpers, leafletMarkerEvents, leafletIterators, leafletWatchHelpers, leafletDirectiveControlsHelpers) {
	    //less terse vars to helpers
	    var isDefined = leafletHelpers.isDefined;
	    var errorHeader = leafletHelpers.errorHeader;
	    var Helpers = leafletHelpers;
	    var isString = leafletHelpers.isString;
	    var addMarkerWatcher = leafletMarkersHelpers.addMarkerWatcher;
	    var updateMarker = leafletMarkersHelpers.updateMarker;
	    var listenMarkerEvents = leafletMarkersHelpers.listenMarkerEvents;
	    var addMarkerToGroup = leafletMarkersHelpers.addMarkerToGroup;
	    var createMarker = leafletMarkersHelpers.createMarker;
	    var deleteMarker = leafletMarkersHelpers.deleteMarker;
	    var $it = leafletIterators;
	    var _markersWatchOptions = leafletHelpers.watchOptions;
	    var maybeWatch = leafletWatchHelpers.maybeWatch;
	    var extendDirectiveControls = leafletDirectiveControlsHelpers.extend;
	
	    var _getLMarker = function _getLMarker(leafletMarkers, name, maybeLayerName) {
	      if (!Object.keys(leafletMarkers).length) return;
	      if (maybeLayerName && isString(maybeLayerName)) {
	        if (!leafletMarkers[maybeLayerName] || !Object.keys(leafletMarkers[maybeLayerName]).length) return;
	        return leafletMarkers[maybeLayerName][name];
	      }
	
	      return leafletMarkers[name];
	    };
	
	    var _setLMarker = function _setLMarker(lObject, leafletMarkers, name, maybeLayerName) {
	      if (maybeLayerName && isString(maybeLayerName)) {
	        if (!isDefined(leafletMarkers[maybeLayerName])) leafletMarkers[maybeLayerName] = {};
	        leafletMarkers[maybeLayerName][name] = lObject;
	      } else leafletMarkers[name] = lObject;
	      return lObject;
	    };
	
	    var _maybeAddMarkerToLayer = function _maybeAddMarkerToLayer(layerName, layers, model, marker, doIndividualWatch, map) {
	
	      if (!isString(layerName)) {
	        $log.error(errorHeader + ' A layername must be a string');
	        return false;
	      }
	
	      if (!isDefined(layers)) {
	        $log.error(errorHeader + ' You must add layers to the directive if the markers are going to use this functionality.');
	        return false;
	      }
	
	      if (!isDefined(layers.overlays) || !isDefined(layers.overlays[layerName])) {
	        $log.error(errorHeader + ' A marker can only be added to a layer of type "group"');
	        return false;
	      }
	
	      var layerGroup = layers.overlays[layerName];
	      if (!(layerGroup instanceof L.LayerGroup || layerGroup instanceof L.FeatureGroup)) {
	        $log.error(errorHeader + ' Adding a marker to an overlay needs a overlay of the type "group" or "featureGroup"');
	        return false;
	      }
	
	      // The marker goes to a correct layer group, so first of all we add it
	      layerGroup.addLayer(marker);
	
	      // The marker is automatically added to the map depending on the visibility
	      // of the layer, so we only have to open the popup if the marker is in the map
	      if (!doIndividualWatch && map.hasLayer(marker) && model.focus === true) {
	        marker.openPopup();
	      }
	
	      return true;
	    };
	
	    //TODO: move to leafletMarkersHelpers??? or make a new class/function file (leafletMarkersHelpers is large already)
	    var _addMarkers = function _addMarkers(mapId, markersToRender, oldModels, map, layers, leafletMarkers, leafletScope, watchOptions, maybeLayerName, skips) {
	      for (var newName in markersToRender) {
	        if (skips[newName]) continue;
	
	        if (newName.search('-') !== -1) {
	          $log.error('The marker can\'t use a "-" on his key name: "' + newName + '".');
	          continue;
	        }
	
	        var model = Helpers.copy(markersToRender[newName]);
	        var pathToMarker = Helpers.getObjectDotPath(maybeLayerName ? [maybeLayerName, newName] : [newName]);
	        var maybeLMarker = _getLMarker(leafletMarkers, newName, maybeLayerName);
	        if (!isDefined(maybeLMarker)) {
	          //(nmccready) very important to not have model changes when lObject is changed
	          //this might be desirable in some cases but it causes two-way binding to lObject which is not ideal
	          //if it is left as the reference then all changes from oldModel vs newModel are ignored
	          //see _destroy (where modelDiff becomes meaningless if we do not copy here)
	          var marker = createMarker(model);
	          var layerName = (model ? model.layer : undefined) || maybeLayerName; //original way takes pref
	          if (!isDefined(marker)) {
	            $log.error(errorHeader + ' Received invalid data on the marker ' + newName + '.');
	            continue;
	          }
	
	          _setLMarker(marker, leafletMarkers, newName, maybeLayerName);
	
	          // Bind message
	          if (isDefined(model.message)) {
	            marker.bindPopup(model.message, model.popupOptions);
	          }
	
	          // Add the marker to a cluster group if needed
	          if (isDefined(model.group)) {
	            var groupOptions = isDefined(model.groupOption) ? model.groupOption : null;
	            addMarkerToGroup(marker, model.group, groupOptions, map);
	          }
	
	          // Show label if defined
	          if (Helpers.LabelPlugin.isLoaded() && isDefined(model.label) && isDefined(model.label.message)) {
	            marker.bindLabel(model.label.message, model.label.options);
	          }
	
	          // Check if the marker should be added to a layer
	          if (isDefined(model) && (isDefined(model.layer) || isDefined(maybeLayerName))) {
	
	            var pass = _maybeAddMarkerToLayer(layerName, layers, model, marker, watchOptions.individual.doWatch, map);
	            if (!pass) continue; //something went wrong move on in the loop
	          } else if (!isDefined(model.group)) {
	            // We do not have a layer attr, so the marker goes to the map layer
	            map.addLayer(marker);
	            if (!watchOptions.individual.doWatch && model.focus === true) {
	              marker.openPopup();
	            }
	          }
	
	          if (watchOptions.individual.doWatch) {
	            addMarkerWatcher(marker, pathToMarker, leafletScope, layers, map, watchOptions.individual.isDeep);
	          }
	
	          listenMarkerEvents(marker, model, leafletScope, watchOptions.individual.doWatch, map);
	          leafletMarkerEvents.bindEvents(mapId, marker, pathToMarker, model, leafletScope, layerName);
	        } else {
	          var oldModel = isDefined(oldModel) ? oldModels[newName] : undefined;
	          updateMarker(model, oldModel, maybeLMarker, pathToMarker, leafletScope, layers, map);
	        }
	      }
	    };
	
	    var _seeWhatWeAlreadyHave = function _seeWhatWeAlreadyHave(markerModels, oldMarkerModels, lMarkers, isEqual, cb) {
	      var hasLogged = false;
	      var equals = false;
	      var oldMarker;
	      var newMarker;
	
	      var doCheckOldModel = isDefined(oldMarkerModels);
	      for (var name in lMarkers) {
	        if (!hasLogged) {
	          $log.debug(errorHeader + '[markers] destroy: ');
	          hasLogged = true;
	        }
	
	        if (doCheckOldModel) {
	          //might want to make the option (in watch options) to disable deep checking
	          //ie the options to only check !== (reference check) instead of angular.equals (slow)
	          newMarker = markerModels[name];
	          oldMarker = oldMarkerModels[name];
	          equals = angular.equals(newMarker, oldMarker) && isEqual;
	        }
	
	        if (!isDefined(markerModels) || !Object.keys(markerModels).length || !isDefined(markerModels[name]) || !Object.keys(markerModels[name]).length || equals) {
	          if (cb && Helpers.isFunction(cb)) cb(newMarker, oldMarker, name);
	        }
	      }
	    };
	
	    var _destroy = function _destroy(markerModels, oldMarkerModels, lMarkers, map, layers) {
	      _seeWhatWeAlreadyHave(markerModels, oldMarkerModels, lMarkers, false, function (newMarker, oldMarker, lMarkerName) {
	        $log.debug(errorHeader + '[marker] is deleting marker: ' + lMarkerName);
	        deleteMarker(lMarkers[lMarkerName], map, layers);
	        delete lMarkers[lMarkerName];
	      });
	    };
	
	    var _getNewModelsToSkipp = function _getNewModelsToSkipp(newModels, oldModels, lMarkers) {
	      var skips = {};
	      _seeWhatWeAlreadyHave(newModels, oldModels, lMarkers, true, function (newMarker, oldMarker, lMarkerName) {
	        $log.debug(errorHeader + '[marker] is already rendered, marker: ' + lMarkerName);
	        skips[lMarkerName] = newMarker;
	      });
	
	      return skips;
	    };
	
	    return {
	      restrict: 'A',
	      scope: false,
	      replace: false,
	      require: ['leaflet', '?layers'],
	
	      link: function link(scope, element, attrs, controller) {
	        var mapController = controller[0];
	        var leafletScope = mapController.getLeafletScope();
	
	        mapController.getMap().then(function (map) {
	          var leafletMarkers = {};
	          var getLayers;
	
	          // If the layers attribute is used, we must wait until the layers are created
	          if (isDefined(controller[1])) {
	            getLayers = controller[1].getLayers;
	          } else {
	            getLayers = function getLayers() {
	              var deferred = $q.defer();
	              deferred.resolve();
	              return deferred.promise;
	            };
	          }
	
	          var watchOptions = leafletScope.markersWatchOptions || _markersWatchOptions;
	
	          // backwards compat
	          if (isDefined(attrs.watchMarkers)) watchOptions.doWatch = watchOptions.individual.doWatch = !isDefined(attrs.watchMarkers) || Helpers.isTruthy(attrs.watchMarkers);
	
	          var isNested = isDefined(attrs.markersNested) && Helpers.isTruthy(attrs.markersNested);
	
	          getLayers().then(function (layers) {
	            var _clean = function _clean(models, oldModels) {
	              if (isNested) {
	                $it.each(models, function (markerToMaybeDel, layerName) {
	                  var oldModel = isDefined(oldModel) ? oldModels[layerName] : undefined;
	                  _destroy(markerToMaybeDel, oldModel, leafletMarkers[layerName], map, layers);
	                });
	
	                return;
	              }
	
	              _destroy(models, oldModels, leafletMarkers, map, layers);
	            };
	
	            var _create = function _create(models, oldModels) {
	              _clean(models, oldModels);
	              var skips = null;
	              if (isNested) {
	                $it.each(models, function (markersToAdd, layerName) {
	                  var oldModel = isDefined(oldModel) ? oldModels[layerName] : undefined;
	                  skips = _getNewModelsToSkipp(models[layerName], oldModel, leafletMarkers[layerName]);
	                  _addMarkers(attrs.id, markersToAdd, oldModels, map, layers, leafletMarkers, leafletScope, watchOptions, layerName, skips);
	                });
	
	                return;
	              }
	
	              skips = _getNewModelsToSkipp(models, oldModels, leafletMarkers);
	              _addMarkers(attrs.id, models, oldModels, map, layers, leafletMarkers, leafletScope, watchOptions, undefined, skips);
	            };
	
	            extendDirectiveControls(attrs.id, 'markers', _create, _clean);
	            leafletData.setMarkers(leafletMarkers, attrs.id);
	
	            maybeWatch(leafletScope, 'markers', watchOptions, function (newMarkers, oldMarkers) {
	              _create(newMarkers, oldMarkers);
	            });
	          });
	        });
	      }
	    };
	  }]);
	
	  angular.module('leaflet-directive').directive('maxbounds', ["$log", "leafletMapDefaults", "leafletBoundsHelpers", "leafletHelpers", function ($log, leafletMapDefaults, leafletBoundsHelpers, leafletHelpers) {
	
	    return {
	      restrict: 'A',
	      scope: false,
	      replace: false,
	      require: 'leaflet',
	
	      link: function link(scope, element, attrs, controller) {
	        var leafletScope = controller.getLeafletScope();
	        var isValidBounds = leafletBoundsHelpers.isValidBounds;
	        var isNumber = leafletHelpers.isNumber;
	
	        controller.getMap().then(function (map) {
	          leafletScope.$watch('maxbounds', function (maxbounds) {
	            if (!isValidBounds(maxbounds)) {
	              // Unset any previous maxbounds
	              map.setMaxBounds();
	              return;
	            }
	
	            var leafletBounds = leafletBoundsHelpers.createLeafletBounds(maxbounds);
	            if (isNumber(maxbounds.pad)) {
	              leafletBounds = leafletBounds.pad(maxbounds.pad);
	            }
	
	            map.setMaxBounds(leafletBounds);
	            if (!attrs.center && !attrs.lfCenter) {
	              map.fitBounds(leafletBounds);
	            }
	          });
	        });
	      }
	    };
	  }]);
	
	  angular.module('leaflet-directive').directive('paths', ["$log", "$q", "leafletData", "leafletMapDefaults", "leafletHelpers", "leafletPathsHelpers", "leafletPathEvents", function ($log, $q, leafletData, leafletMapDefaults, leafletHelpers, leafletPathsHelpers, leafletPathEvents) {
	
	    return {
	      restrict: 'A',
	      scope: false,
	      replace: false,
	      require: ['leaflet', '?layers'],
	
	      link: function link(scope, element, attrs, controller) {
	        var mapController = controller[0];
	        var isDefined = leafletHelpers.isDefined;
	        var isString = leafletHelpers.isString;
	        var leafletScope = mapController.getLeafletScope();
	        var paths = leafletScope.paths;
	        var createPath = leafletPathsHelpers.createPath;
	        var bindPathEvents = leafletPathEvents.bindPathEvents;
	        var setPathOptions = leafletPathsHelpers.setPathOptions;
	
	        mapController.getMap().then(function (map) {
	          var defaults = leafletMapDefaults.getDefaults(attrs.id);
	          var getLayers;
	
	          // If the layers attribute is used, we must wait until the layers are created
	          if (isDefined(controller[1])) {
	            getLayers = controller[1].getLayers;
	          } else {
	            getLayers = function getLayers() {
	              var deferred = $q.defer();
	              deferred.resolve();
	              return deferred.promise;
	            };
	          }
	
	          if (!isDefined(paths)) {
	            return;
	          }
	
	          getLayers().then(function (layers) {
	
	            var leafletPaths = {};
	            leafletData.setPaths(leafletPaths, attrs.id);
	
	            // Should we watch for every specific marker on the map?
	            var shouldWatch = !isDefined(attrs.watchPaths) || attrs.watchPaths === 'true';
	
	            // Function for listening every single path once created
	            var watchPathFn = function watchPathFn(leafletPath, name) {
	              var clearWatch = leafletScope.$watch('paths["' + name + '"]', function (pathData, old) {
	                if (!isDefined(pathData)) {
	                  if (isDefined(old.layer)) {
	                    for (var i in layers.overlays) {
	                      var overlay = layers.overlays[i];
	                      overlay.removeLayer(leafletPath);
	                    }
	                  }
	
	                  map.removeLayer(leafletPath);
	                  clearWatch();
	                  return;
	                }
	
	                setPathOptions(leafletPath, pathData.type, pathData);
	              }, true);
	            };
	
	            leafletScope.$watchCollection('paths', function (newPaths) {
	
	              // Delete paths (by name) from the array
	              for (var name in leafletPaths) {
	                if (!isDefined(newPaths[name])) {
	                  map.removeLayer(leafletPaths[name]);
	                  delete leafletPaths[name];
	                }
	              }
	
	              // Create the new paths
	              for (var newName in newPaths) {
	                if (newName.search('\\$') === 0) {
	                  continue;
	                }
	
	                if (newName.search('-') !== -1) {
	                  $log.error('[AngularJS - Leaflet] The path name "' + newName + '" is not valid. It must not include "-" and a number.');
	                  continue;
	                }
	
	                if (!isDefined(leafletPaths[newName])) {
	                  var pathData = newPaths[newName];
	                  var newPath = createPath(newName, newPaths[newName], defaults);
	
	                  // bind popup if defined
	                  if (isDefined(newPath) && isDefined(pathData.message)) {
	                    newPath.bindPopup(pathData.message, pathData.popupOptions);
	                  }
	
	                  // Show label if defined
	                  if (leafletHelpers.LabelPlugin.isLoaded() && isDefined(pathData.label) && isDefined(pathData.label.message)) {
	                    newPath.bindLabel(pathData.label.message, pathData.label.options);
	                  }
	
	                  // Check if the marker should be added to a layer
	                  if (isDefined(pathData) && isDefined(pathData.layer)) {
	
	                    if (!isString(pathData.layer)) {
	                      $log.error('[AngularJS - Leaflet] A layername must be a string');
	                      continue;
	                    }
	
	                    if (!isDefined(layers)) {
	                      $log.error('[AngularJS - Leaflet] You must add layers to the directive if the markers are going to use this functionality.');
	                      continue;
	                    }
	
	                    if (!isDefined(layers.overlays) || !isDefined(layers.overlays[pathData.layer])) {
	                      $log.error('[AngularJS - Leaflet] A path can only be added to a layer of type "group"');
	                      continue;
	                    }
	
	                    var layerGroup = layers.overlays[pathData.layer];
	                    if (!(layerGroup instanceof L.LayerGroup || layerGroup instanceof L.FeatureGroup)) {
	                      $log.error('[AngularJS - Leaflet] Adding a path to an overlay needs a overlay of the type "group" or "featureGroup"');
	                      continue;
	                    }
	
	                    // Listen for changes on the new path
	                    leafletPaths[newName] = newPath;
	
	                    // The path goes to a correct layer group, so first of all we add it
	                    layerGroup.addLayer(newPath);
	
	                    if (shouldWatch) {
	                      watchPathFn(newPath, newName);
	                    } else {
	                      setPathOptions(newPath, pathData.type, pathData);
	                    }
	                  } else if (isDefined(newPath)) {
	                    // Listen for changes on the new path
	                    leafletPaths[newName] = newPath;
	                    map.addLayer(newPath);
	
	                    if (shouldWatch) {
	                      watchPathFn(newPath, newName);
	                    } else {
	                      setPathOptions(newPath, pathData.type, pathData);
	                    }
	                  }
	
	                  bindPathEvents(attrs.id, newPath, newName, pathData, leafletScope);
	                }
	              }
	            });
	          });
	        });
	      }
	    };
	  }]);
	
	  angular.module('leaflet-directive').directive('tiles', ["$log", "leafletData", "leafletMapDefaults", "leafletHelpers", function ($log, leafletData, leafletMapDefaults, leafletHelpers) {
	
	    return {
	      restrict: 'A',
	      scope: false,
	      replace: false,
	      require: 'leaflet',
	
	      link: function link(scope, element, attrs, controller) {
	        var isDefined = leafletHelpers.isDefined;
	        var leafletScope = controller.getLeafletScope();
	        var tiles = leafletScope.tiles;
	
	        if (!isDefined(tiles) || !isDefined(tiles.url)) {
	          $log.warn('[AngularJS - Leaflet] The \'tiles\' definition doesn\'t have the \'url\' property.');
	          return;
	        }
	
	        controller.getMap().then(function (map) {
	          var defaults = leafletMapDefaults.getDefaults(attrs.id);
	          var tileLayerObj;
	          leafletScope.$watch('tiles', function (tiles, oldtiles) {
	            var tileLayerOptions = defaults.tileLayerOptions;
	            var tileLayerUrl = defaults.tileLayer;
	
	            // If no valid tiles are in the scope, remove the last layer
	            if (!isDefined(tiles.url) && isDefined(tileLayerObj)) {
	              map.removeLayer(tileLayerObj);
	              return;
	            }
	
	            // No leafletTiles object defined yet
	            if (!isDefined(tileLayerObj)) {
	              if (isDefined(tiles.options)) {
	                angular.copy(tiles.options, tileLayerOptions);
	              }
	
	              if (isDefined(tiles.url)) {
	                tileLayerUrl = tiles.url;
	              }
	
	              if (tiles.type === 'wms') {
	                tileLayerObj = L.tileLayer.wms(tileLayerUrl, tileLayerOptions);
	              } else {
	                tileLayerObj = L.tileLayer(tileLayerUrl, tileLayerOptions);
	              }
	
	              tileLayerObj.addTo(map);
	              leafletData.setTiles(tileLayerObj, attrs.id);
	              return;
	            }
	
	            // If the options of the tilelayer is changed, we need to redraw the layer
	            if (isDefined(tiles.url) && isDefined(tiles.options) && (tiles.type !== oldtiles.type || !angular.equals(tiles.options, tileLayerOptions))) {
	              map.removeLayer(tileLayerObj);
	              tileLayerOptions = defaults.tileLayerOptions;
	              angular.copy(tiles.options, tileLayerOptions);
	              tileLayerUrl = tiles.url;
	
	              if (tiles.type === 'wms') {
	                tileLayerObj = L.tileLayer.wms(tileLayerUrl, tileLayerOptions);
	              } else {
	                tileLayerObj = L.tileLayer(tileLayerUrl, tileLayerOptions);
	              }
	
	              tileLayerObj.addTo(map);
	              leafletData.setTiles(tileLayerObj, attrs.id);
	              return;
	            }
	
	            // Only the URL of the layer is changed, update the tiles object
	            if (isDefined(tiles.url)) {
	              tileLayerObj.setUrl(tiles.url);
	            }
	          }, true);
	        });
	      }
	    };
	  }]);
	
	  /*
	      Create multiple similar directives for watchOptions to support directiveControl
	      instead. (when watches are disabled)
	      NgAnnotate does not work here due to the functional creation
	  */
	  ['markers', 'geojson'].forEach(function (name) {
	    angular.module('leaflet-directive').directive(name + 'WatchOptions', ['$log', '$rootScope', '$q', 'leafletData', 'leafletHelpers', function ($log, $rootScope, $q, leafletData, leafletHelpers) {
	
	      var isDefined = leafletHelpers.isDefined,
	          errorHeader = leafletHelpers.errorHeader,
	          isObject = leafletHelpers.isObject,
	          _watchOptions = leafletHelpers.watchOptions;
	
	      return {
	        restrict: 'A',
	        scope: false,
	        replace: false,
	        require: ['leaflet'],
	
	        link: function link(scope, element, attrs, controller) {
	          var mapController = controller[0],
	              leafletScope = mapController.getLeafletScope();
	
	          mapController.getMap().then(function () {
	            if (isDefined(scope[name + 'WatchOptions'])) {
	              if (isObject(scope[name + 'WatchOptions'])) angular.extend(_watchOptions, scope[name + 'WatchOptions']);else $log.error(errorHeader + '[' + name + 'WatchOptions] is not an object');
	              leafletScope[name + 'WatchOptions'] = _watchOptions;
	            }
	          });
	        }
	      };
	    }]);
	  });
	
	  angular.module('leaflet-directive').factory('LeafletEventsHelpersFactory', ["$rootScope", "$q", "$log", "leafletHelpers", function ($rootScope, $q, $log, leafletHelpers) {
	    var safeApply = leafletHelpers.safeApply;
	    var isDefined = leafletHelpers.isDefined;
	    var isObject = leafletHelpers.isObject;
	    var isArray = leafletHelpers.isArray;
	    var errorHeader = leafletHelpers.errorHeader;
	
	    var EventsHelper = function EventsHelper(rootBroadcastName, lObjectType) {
	      this.rootBroadcastName = rootBroadcastName;
	      $log.debug('LeafletEventsHelpersFactory: lObjectType: ' + lObjectType + 'rootBroadcastName: ' + rootBroadcastName);
	
	      //used to path/key out certain properties based on the type , "markers", "geojson"
	      this.lObjectType = lObjectType;
	    };
	
	    EventsHelper.prototype.getAvailableEvents = function () {
	      return [];
	    };
	
	    /*
	     argument: name: Note this can be a single string or dot notation
	     Example:
	     markerModel : {
	     m1: { lat:_, lon: _}
	     }
	     //would yield name of
	     name = "m1"
	      If nested:
	     markerModel : {
	     cars: {
	     m1: { lat:_, lon: _}
	     }
	     }
	     //would yield name of
	     name = "cars.m1"
	     */
	    EventsHelper.prototype.genDispatchEvent = function (maybeMapId, eventName, logic, leafletScope, lObject, name, model, layerName, extra) {
	      var _this = this;
	
	      maybeMapId = maybeMapId || '';
	      if (maybeMapId) maybeMapId = '.' + maybeMapId;
	
	      return function (e) {
	        var broadcastName = _this.rootBroadcastName + maybeMapId + '.' + eventName;
	        $log.debug(broadcastName);
	        _this.fire(leafletScope, broadcastName, logic, e, e.target || lObject, model, name, layerName, extra);
	      };
	    };
	
	    EventsHelper.prototype.fire = function (scope, broadcastName, logic, event, lObject, model, modelName, layerName) {
	      // Safely broadcast the event
	      safeApply(scope, function () {
	        var toSend = {
	          leafletEvent: event,
	          leafletObject: lObject,
	          modelName: modelName,
	          model: model
	        };
	        if (isDefined(layerName)) angular.extend(toSend, { layerName: layerName });
	
	        if (logic === 'emit') {
	          scope.$emit(broadcastName, toSend);
	        } else {
	          $rootScope.$broadcast(broadcastName, toSend);
	        }
	      });
	    };
	
	    EventsHelper.prototype.bindEvents = function (maybeMapId, lObject, name, model, leafletScope, layerName, extra) {
	      var events = [];
	      var logic = 'emit';
	      var _this = this;
	
	      if (!isDefined(leafletScope.eventBroadcast)) {
	        // Backward compatibility, if no event-broadcast attribute, all events are broadcasted
	        events = this.getAvailableEvents();
	      } else if (!isObject(leafletScope.eventBroadcast)) {
	        // Not a valid object
	        $log.error(errorHeader + 'event-broadcast must be an object check your model.');
	      } else {
	        // We have a possible valid object
	        if (!isDefined(leafletScope.eventBroadcast[_this.lObjectType])) {
	          // We do not have events enable/disable do we do nothing (all enabled by default)
	          events = this.getAvailableEvents();
	        } else if (!isObject(leafletScope.eventBroadcast[_this.lObjectType])) {
	          // Not a valid object
	          $log.warn(errorHeader + 'event-broadcast.' + [_this.lObjectType] + ' must be an object check your model.');
	        } else {
	          // We have a possible valid map object
	          // Event propadation logic
	          if (isDefined(leafletScope.eventBroadcast[this.lObjectType].logic)) {
	            // We take care of possible propagation logic
	            if (leafletScope.eventBroadcast[_this.lObjectType].logic !== 'emit' && leafletScope.eventBroadcast[_this.lObjectType].logic !== 'broadcast') $log.warn(errorHeader + 'Available event propagation logic are: \'emit\' or \'broadcast\'.');
	          }
	
	          // Enable / Disable
	          var eventsEnable = false;
	          var eventsDisable = false;
	          if (isDefined(leafletScope.eventBroadcast[_this.lObjectType].enable) && isArray(leafletScope.eventBroadcast[_this.lObjectType].enable)) eventsEnable = true;
	          if (isDefined(leafletScope.eventBroadcast[_this.lObjectType].disable) && isArray(leafletScope.eventBroadcast[_this.lObjectType].disable)) eventsDisable = true;
	
	          if (eventsEnable && eventsDisable) {
	            // Both are active, this is an error
	            $log.warn(errorHeader + 'can not enable and disable events at the same time');
	          } else if (!eventsEnable && !eventsDisable) {
	            // Both are inactive, this is an error
	            $log.warn(errorHeader + 'must enable or disable events');
	          } else {
	            // At this point the object is OK, lets enable or disable events
	            if (eventsEnable) {
	              // Enable events
	              leafletScope.eventBroadcast[this.lObjectType].enable.forEach(function (eventName) {
	                // Do we have already the event enabled?
	                if (events.indexOf(eventName) !== -1) {
	                  // Repeated event, this is an error
	                  $log.warn(errorHeader + 'This event ' + eventName + ' is already enabled');
	                } else {
	                  // Does the event exists?
	                  if (_this.getAvailableEvents().indexOf(eventName) === -1) {
	                    // The event does not exists, this is an error
	                    $log.warn(errorHeader + 'This event ' + eventName + ' does not exist');
	                  } else {
	                    // All ok enable the event
	                    events.push(eventName);
	                  }
	                }
	              });
	            } else {
	              // Disable events
	              events = this.getAvailableEvents();
	              leafletScope.eventBroadcast[_this.lObjectType].disable.forEach(function (eventName) {
	                var index = events.indexOf(eventName);
	                if (index === -1) {
	                  // The event does not exist
	                  $log.warn(errorHeader + 'This event ' + eventName + ' does not exist or has been already disabled');
	                } else {
	                  events.splice(index, 1);
	                }
	              });
	            }
	          }
	        }
	      }
	
	      events.forEach(function (eventName) {
	        lObject.on(eventName, _this.genDispatchEvent(maybeMapId, eventName, logic, leafletScope, lObject, name, model, layerName, extra));
	      });
	
	      return logic;
	    };
	
	    return EventsHelper;
	  }]).service('leafletEventsHelpers', ["LeafletEventsHelpersFactory", function (LeafletEventsHelpersFactory) {
	    return new LeafletEventsHelpersFactory();
	  }]);
	
	  angular.module('leaflet-directive').factory('leafletGeoJsonEvents', ["$rootScope", "$q", "$log", "leafletHelpers", "LeafletEventsHelpersFactory", "leafletData", function ($rootScope, $q, $log, leafletHelpers, LeafletEventsHelpersFactory, leafletData) {
	    var safeApply = leafletHelpers.safeApply;
	    var EventsHelper = LeafletEventsHelpersFactory;
	
	    var GeoJsonEvents = function GeoJsonEvents() {
	      EventsHelper.call(this, 'leafletDirectiveGeoJson', 'geojson');
	    };
	
	    GeoJsonEvents.prototype = new EventsHelper();
	
	    GeoJsonEvents.prototype.genDispatchEvent = function (maybeMapId, eventName, logic, leafletScope, lObject, name, model, layerName, extra) {
	      var base = EventsHelper.prototype.genDispatchEvent.call(this, maybeMapId, eventName, logic, leafletScope, lObject, name, model, layerName);
	      var _this = this;
	
	      return function (e) {
	        if (eventName === 'mouseout') {
	          if (extra.resetStyleOnMouseout) {
	            leafletData.getGeoJSON(extra.mapId).then(function (leafletGeoJSON) {
	              //this is broken on nested needs to traverse or user layerName (nested)
	              var lobj = layerName ? leafletGeoJSON[layerName] : leafletGeoJSON;
	              lobj.resetStyle(e.target);
	            });
	          }
	
	          safeApply(leafletScope, function () {
	            $rootScope.$broadcast(_this.rootBroadcastName + '.mouseout', e);
	          });
	        }
	
	        base(e); //common
	      };
	    };
	
	    GeoJsonEvents.prototype.getAvailableEvents = function () {
	      return ['click', 'dblclick', 'mouseover', 'mouseout'];
	    };
	
	    return new GeoJsonEvents();
	  }]);
	
	  angular.module('leaflet-directive').factory('leafletLabelEvents', ["$rootScope", "$q", "$log", "leafletHelpers", "LeafletEventsHelpersFactory", function ($rootScope, $q, $log, leafletHelpers, LeafletEventsHelpersFactory) {
	    var Helpers = leafletHelpers;
	    var EventsHelper = LeafletEventsHelpersFactory;
	
	    var LabelEvents = function LabelEvents() {
	      EventsHelper.call(this, 'leafletDirectiveLabel', 'markers');
	    };
	
	    LabelEvents.prototype = new EventsHelper();
	
	    LabelEvents.prototype.genDispatchEvent = function (maybeMapId, eventName, logic, leafletScope, lObject, name, model, layerName) {
	      var markerName = name.replace('markers.', '');
	      return EventsHelper.prototype.genDispatchEvent.call(this, maybeMapId, eventName, logic, leafletScope, lObject, markerName, model, layerName);
	    };
	
	    LabelEvents.prototype.getAvailableEvents = function () {
	      return ['click', 'dblclick', 'mousedown', 'mouseover', 'mouseout', 'contextmenu'];
	    };
	
	    LabelEvents.prototype.genEvents = function (maybeMapId, eventName, logic, leafletScope, lObject, name, model, layerName) {
	      var _this = this;
	      var labelEvents = this.getAvailableEvents();
	      var scopeWatchName = Helpers.getObjectArrayPath('markers.' + name);
	      labelEvents.forEach(function (eventName) {
	        lObject.label.on(eventName, _this.genDispatchEvent(maybeMapId, eventName, logic, leafletScope, lObject.label, scopeWatchName, model, layerName));
	      });
	    };
	
	    LabelEvents.prototype.bindEvents = function () {};
	
	    return new LabelEvents();
	  }]);
	
	  angular.module('leaflet-directive').factory('leafletMapEvents', ["$rootScope", "$q", "$log", "leafletHelpers", "leafletEventsHelpers", "leafletIterators", function ($rootScope, $q, $log, leafletHelpers, leafletEventsHelpers, leafletIterators) {
	    var isDefined = leafletHelpers.isDefined;
	    var fire = leafletEventsHelpers.fire;
	
	    var _getAvailableMapEvents = function _getAvailableMapEvents() {
	      return ['click', 'dblclick', 'mousedown', 'mouseup', 'mouseover', 'mouseout', 'mousemove', 'contextmenu', 'focus', 'blur', 'preclick', 'load', 'unload', 'viewreset', 'movestart', 'move', 'moveend', 'dragstart', 'drag', 'dragend', 'zoomstart', 'zoomanim', 'zoomend', 'zoomlevelschange', 'resize', 'autopanstart', 'layeradd', 'layerremove', 'baselayerchange', 'overlayadd', 'overlayremove', 'locationfound', 'locationerror', 'popupopen', 'popupclose', 'draw:created', 'draw:edited', 'draw:deleted', 'draw:drawstart', 'draw:drawstop', 'draw:editstart', 'draw:editstop', 'draw:deletestart', 'draw:deletestop'];
	    };
	
	    var _genDispatchMapEvent = function _genDispatchMapEvent(scope, eventName, logic, maybeMapId) {
	      if (maybeMapId) maybeMapId = maybeMapId + '.';
	      return function (e) {
	        // Put together broadcast name
	        var broadcastName = 'leafletDirectiveMap.' + maybeMapId + eventName;
	        $log.debug(broadcastName);
	
	        // Safely broadcast the event
	        fire(scope, broadcastName, logic, e, e.target, scope);
	      };
	    };
	
	    var _notifyCenterChangedToBounds = function _notifyCenterChangedToBounds(scope) {
	      scope.$broadcast('boundsChanged');
	    };
	
	    var _notifyCenterUrlHashChanged = function _notifyCenterUrlHashChanged(scope, map, attrs, search) {
	      if (!isDefined(attrs.urlHashCenter)) {
	        return;
	      }
	
	      var center = map.getCenter();
	      var centerUrlHash = center.lat.toFixed(4) + ':' + center.lng.toFixed(4) + ':' + map.getZoom();
	      if (!isDefined(search.c) || search.c !== centerUrlHash) {
	        //$log.debug("notified new center...");
	        scope.$emit('centerUrlHash', centerUrlHash);
	      }
	    };
	
	    var _addEvents = function _addEvents(map, mapEvents, contextName, scope, logic) {
	      leafletIterators.each(mapEvents, function (eventName) {
	        var context = {};
	        context[contextName] = eventName;
	        map.on(eventName, _genDispatchMapEvent(scope, eventName, logic, map._container.id || ''), context);
	      });
	    };
	
	    return {
	      getAvailableMapEvents: _getAvailableMapEvents,
	      genDispatchMapEvent: _genDispatchMapEvent,
	      notifyCenterChangedToBounds: _notifyCenterChangedToBounds,
	      notifyCenterUrlHashChanged: _notifyCenterUrlHashChanged,
	      addEvents: _addEvents
	    };
	  }]);
	
	  angular.module('leaflet-directive').factory('leafletMarkerEvents', ["$rootScope", "$q", "$log", "leafletHelpers", "LeafletEventsHelpersFactory", "leafletLabelEvents", function ($rootScope, $q, $log, leafletHelpers, LeafletEventsHelpersFactory, leafletLabelEvents) {
	    var safeApply = leafletHelpers.safeApply;
	    var isDefined = leafletHelpers.isDefined;
	    var Helpers = leafletHelpers;
	    var lblHelp = leafletLabelEvents;
	    var EventsHelper = LeafletEventsHelpersFactory;
	
	    var MarkerEvents = function MarkerEvents() {
	      EventsHelper.call(this, 'leafletDirectiveMarker', 'markers');
	    };
	
	    MarkerEvents.prototype = new EventsHelper();
	
	    MarkerEvents.prototype.genDispatchEvent = function (maybeMapId, eventName, logic, leafletScope, lObject, name, model, layerName) {
	      var handle = EventsHelper.prototype.genDispatchEvent.call(this, maybeMapId, eventName, logic, leafletScope, lObject, name, model, layerName);
	      return function (e) {
	        // Broadcast old marker click name for backwards compatibility
	        if (eventName === 'click') {
	          safeApply(leafletScope, function () {
	            $rootScope.$broadcast('leafletDirectiveMarkersClick', name);
	          });
	        } else if (eventName === 'dragend') {
	          safeApply(leafletScope, function () {
	            model.lat = lObject.getLatLng().lat;
	            model.lng = lObject.getLatLng().lng;
	          });
	
	          if (model.message && model.focus === true) {
	            lObject.openPopup();
	          }
	        }
	
	        handle(e); //common
	      };
	    };
	
	    MarkerEvents.prototype.getAvailableEvents = function () {
	      return ['click', 'dblclick', 'mousedown', 'mouseover', 'mouseout', 'contextmenu', 'dragstart', 'drag', 'dragend', 'move', 'remove', 'popupopen', 'popupclose', 'touchend', 'touchstart', 'touchmove', 'touchcancel', 'touchleave'];
	    };
	
	    MarkerEvents.prototype.bindEvents = function (maybeMapId, lObject, name, model, leafletScope, layerName) {
	      var logic = EventsHelper.prototype.bindEvents.call(this, maybeMapId, lObject, name, model, leafletScope, layerName);
	
	      if (Helpers.LabelPlugin.isLoaded() && isDefined(lObject.label)) {
	        lblHelp.genEvents(maybeMapId, name, logic, leafletScope, lObject, model, layerName);
	      }
	    };
	
	    return new MarkerEvents();
	  }]);
	
	  angular.module('leaflet-directive').factory('leafletPathEvents', ["$rootScope", "$q", "$log", "leafletHelpers", "leafletLabelEvents", "leafletEventsHelpers", function ($rootScope, $q, $log, leafletHelpers, leafletLabelEvents, leafletEventsHelpers) {
	    var isDefined = leafletHelpers.isDefined;
	    var isObject = leafletHelpers.isObject;
	    var Helpers = leafletHelpers;
	    var errorHeader = leafletHelpers.errorHeader;
	    var lblHelp = leafletLabelEvents;
	    var fire = leafletEventsHelpers.fire;
	
	    /*
	    TODO (nmccready) This EventsHelper needs to be derrived from leafletEventsHelpers to elminate copy and paste code.
	    */
	
	    var _genDispatchPathEvent = function _genDispatchPathEvent(maybeMapId, eventName, logic, leafletScope, lObject, name, model, layerName) {
	      maybeMapId = maybeMapId || '';
	
	      if (maybeMapId) maybeMapId = '.' + maybeMapId;
	
	      return function (e) {
	        var broadcastName = 'leafletDirectivePath' + maybeMapId + '.' + eventName;
	        $log.debug(broadcastName);
	        fire(leafletScope, broadcastName, logic, e, e.target || lObject, model, name, layerName);
	      };
	    };
	
	    var _bindPathEvents = function _bindPathEvents(maybeMapId, lObject, name, model, leafletScope) {
	      var pathEvents = [];
	      var i;
	      var eventName;
	      var logic = 'broadcast';
	
	      if (!isDefined(leafletScope.eventBroadcast)) {
	        // Backward compatibility, if no event-broadcast attribute, all events are broadcasted
	        pathEvents = _getAvailablePathEvents();
	      } else if (!isObject(leafletScope.eventBroadcast)) {
	        // Not a valid object
	        $log.error(errorHeader + 'event-broadcast must be an object check your model.');
	      } else {
	        // We have a possible valid object
	        if (!isDefined(leafletScope.eventBroadcast.path)) {
	          // We do not have events enable/disable do we do nothing (all enabled by default)
	          pathEvents = _getAvailablePathEvents();
	        } else if (isObject(leafletScope.eventBroadcast.paths)) {
	          // Not a valid object
	          $log.warn(errorHeader + 'event-broadcast.path must be an object check your model.');
	        } else {
	          // We have a possible valid map object
	          // Event propadation logic
	          if (leafletScope.eventBroadcast.path.logic !== undefined && leafletScope.eventBroadcast.path.logic !== null) {
	            // We take care of possible propagation logic
	            if (leafletScope.eventBroadcast.path.logic !== 'emit' && leafletScope.eventBroadcast.path.logic !== 'broadcast') {
	              // This is an error
	              $log.warn(errorHeader + 'Available event propagation logic are: \'emit\' or \'broadcast\'.');
	            } else if (leafletScope.eventBroadcast.path.logic === 'emit') {
	              logic = 'emit';
	            }
	          }
	
	          // Enable / Disable
	          var pathEventsEnable = false;
	          var pathEventsDisable = false;
	          if (leafletScope.eventBroadcast.path.enable !== undefined && leafletScope.eventBroadcast.path.enable !== null) {
	            if (_typeof(leafletScope.eventBroadcast.path.enable) === 'object') {
	              pathEventsEnable = true;
	            }
	          }
	
	          if (leafletScope.eventBroadcast.path.disable !== undefined && leafletScope.eventBroadcast.path.disable !== null) {
	            if (_typeof(leafletScope.eventBroadcast.path.disable) === 'object') {
	              pathEventsDisable = true;
	            }
	          }
	
	          if (pathEventsEnable && pathEventsDisable) {
	            // Both are active, this is an error
	            $log.warn(errorHeader + 'can not enable and disable events at the same time');
	          } else if (!pathEventsEnable && !pathEventsDisable) {
	            // Both are inactive, this is an error
	            $log.warn(errorHeader + 'must enable or disable events');
	          } else {
	            // At this point the path object is OK, lets enable or disable events
	            if (pathEventsEnable) {
	              // Enable events
	              for (i = 0; i < leafletScope.eventBroadcast.path.enable.length; i++) {
	                eventName = leafletScope.eventBroadcast.path.enable[i];
	
	                // Do we have already the event enabled?
	                if (pathEvents.indexOf(eventName) !== -1) {
	                  // Repeated event, this is an error
	                  $log.warn(errorHeader + 'This event ' + eventName + ' is already enabled');
	                } else {
	                  // Does the event exists?
	                  if (_getAvailablePathEvents().indexOf(eventName) === -1) {
	                    // The event does not exists, this is an error
	                    $log.warn(errorHeader + 'This event ' + eventName + ' does not exist');
	                  } else {
	                    // All ok enable the event
	                    pathEvents.push(eventName);
	                  }
	                }
	              }
	            } else {
	              // Disable events
	              pathEvents = _getAvailablePathEvents();
	              for (i = 0; i < leafletScope.eventBroadcast.path.disable.length; i++) {
	                eventName = leafletScope.eventBroadcast.path.disable[i];
	                var index = pathEvents.indexOf(eventName);
	                if (index === -1) {
	                  // The event does not exist
	                  $log.warn(errorHeader + 'This event ' + eventName + ' does not exist or has been already disabled');
	                } else {
	                  pathEvents.splice(index, 1);
	                }
	              }
	            }
	          }
	        }
	      }
	
	      for (i = 0; i < pathEvents.length; i++) {
	        eventName = pathEvents[i];
	        lObject.on(eventName, _genDispatchPathEvent(maybeMapId, eventName, logic, leafletScope, pathEvents, name));
	      }
	
	      if (Helpers.LabelPlugin.isLoaded() && isDefined(lObject.label)) {
	        lblHelp.genEvents(maybeMapId, name, logic, leafletScope, lObject, model);
	      }
	    };
	
	    var _getAvailablePathEvents = function _getAvailablePathEvents() {
	      return ['click', 'dblclick', 'mousedown', 'mouseover', 'mouseout', 'contextmenu', 'add', 'remove', 'popupopen', 'popupclose'];
	    };
	
	    return {
	      getAvailablePathEvents: _getAvailablePathEvents,
	      bindPathEvents: _bindPathEvents
	    };
	  }]);
	})(angular);

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	//require('../../../../../../node_modules/leaflet/dist/leaflet');
	//require('../../../../../../node_modules/leaflet/dist/leaflet.css');
	//require('../../../../../../node_modules/leaflet-fullscreen/dist/Leaflet.fullscreen.min');
	//require('../../../../../../node_modules/leaflet-fullscreen/dist/leaflet.fullscreen.css');
	__webpack_require__(169);
	__webpack_require__(489);
	
	var MODULE_NAME = 'angular-leaflet';
	
	angular.module(MODULE_NAME, ['leaflet-directive']);
	
	module.exports = MODULE_NAME;

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Numeric directive.
	 * Version: 1.0.0
	 *
	 * Numeric only input. Limits input to:
	 * - max value: maximum input value. Default undefined (no max).
	 * - min value: minimum input value. Default undefined (no min).
	 * - decimals: number of decimals. Default 2.
	 * - formatting: apply thousand separator formatting. Default true.
	 */
	(function () {
	    'use strict';
	
	    if (true) {
	        module.exports = 'purplefox.numeric';
	    }
	
	    /* global angular */
	    angular.module('purplefox.numeric', []).directive('numerico', numeric);
	
	    numeric.$inject = ['$locale', 'Big', 'decimales'];
	
	    function numeric($locale, Big, decimales) {
	        // Usage:
	        //     <input type="text" decimals="3" min="-20" max="40" formatting="false" ></input>
	        // Creates:
	        //
	        var directive = {
	            link: link,
	            require: 'ngModel',
	            restrict: 'A'
	        };
	        return directive;
	
	        function link(scope, el, attrs, ngModelCtrl) {
	            var decimalSeparator = $locale.NUMBER_FORMATS.DECIMAL_SEP;
	            var groupSeparator = $locale.NUMBER_FORMATS.GROUP_SEP;
	
	            // Create new regular expression with current decimal separator.
	            var NUMBER_REGEXP = "^\\s*(\\-|\\+)?(\\d+|(\\d*(\\.\\d*)))\\s*$";
	            var regex = new RegExp(NUMBER_REGEXP);
	
	            var formatting = true;
	            var maxInputLength = 16; // Maximum input length. Default max ECMA script.
	            var max; // Maximum value. Default undefined.
	            var min; // Minimum value. Default undefined.
	            var limitMax = true; // Limit input to max value (value is capped). Default true.
	            var limitMin = true; // Limit input to min value (value is capped). Default true.
	            var decimals = 2; // Number of decimals. Default 2.
	            var lastValidValue; // Last valid value.
	            var decimalsDinamic = false; // If dinamics decimals
	            var maxdecimals = null; // Number to max decimals in case of decimals dinamic
	            var notNumber = null; // Exclude number
	            var numberDefault = 0; // Default number in case of excluding number
	
	            // Create parsers and formatters.
	            ngModelCtrl.$parsers.push(parseViewValue);
	            ngModelCtrl.$parsers.push(minValidator);
	            ngModelCtrl.$parsers.push(maxValidator);
	            ngModelCtrl.$formatters.push(formatViewValue);
	
	            el.bind('blur', onBlur); // Event handler for the leave event.
	            el.bind('focus', onFocus); // Event handler for the focus event.
	
	            // Put a watch on the min, max and decimal value changes in the attribute.
	            scope.$watch(attrs.min, onMinChanged);
	            scope.$watch(attrs.max, onMaxChanged);
	            scope.$watch(attrs.limitMax, onLimitMaxChanged);
	            scope.$watch(attrs.limitMin, onLimitMinChanged);
	            scope.$watch(attrs.decimals, onDecimalsChanged);
	            scope.$watch(attrs.formatting, onFormattingChanged);
	            scope.$watch(attrs.decimalsDinamic, onDecimalsDinamicChanged);
	            scope.$watch(attrs.maxdecimals, onMaxDecimalsChanged);
	            scope.$watch(attrs.notNumber, onNotNumberChanged);
	            scope.$watch(attrs.numberDefault, onNumberDefaultChanged);
	
	            // Setup decimal formatting.
	            init();
	
	            function init() {
	                if (decimals > -1) {
	                    ngModelCtrl.$parsers.push(function (value) {
	                        return value ? round(value) : value;
	                    });
	                    ngModelCtrl.$formatters.push(function (value) {
	                        return value ? formatPrecision(value) : value;
	                    });
	                }
	            }
	
	            function onMinChanged(value) {
	                if (!angular.isUndefined(value)) {
	                    min = parseFloat(value);
	                    lastValidValue = minValidator(ngModelCtrl.$modelValue);
	                    ngModelCtrl.$setViewValue(formatPrecision(lastValidValue));
	                    ngModelCtrl.$render();
	                }
	            }
	
	            function onMaxChanged(value) {
	                if (!angular.isUndefined(value)) {
	                    max = parseFloat(value);
	                    maxInputLength = calculateMaxLength(max);
	                    lastValidValue = maxValidator(ngModelCtrl.$modelValue);
	                    ngModelCtrl.$setViewValue(formatPrecision(lastValidValue));
	                    ngModelCtrl.$render();
	                }
	            }
	
	            function onDecimalsChanged(value) {
	                if (!angular.isUndefined(value)) {
	                    decimals = parseFloat(value);
	                    lastValidValue = maxValidator(ngModelCtrl.$modelValue);
	                    ngModelCtrl.$setViewValue(formatPrecision(lastValidValue));
	                    ngModelCtrl.$render();
	                }
	            }
	            function onDecimalsDinamicChanged(value) {
	                if (!angular.isUndefined(value)) {
	                    decimalsDinamic = value;
	                }
	            }
	
	            function onNotNumberChanged(value) {
	                if (!angular.isUndefined(value)) {
	                    notNumber = value;
	                }
	            }
	            function onNumberDefaultChanged(value) {
	                if (!angular.isUndefined(value)) {
	                    numberDefault = value;
	                }
	            }
	
	            function onMaxDecimalsChanged(value) {
	                if (!angular.isUndefined(value)) {
	                    maxdecimals = value;
	                    lastValidValue = maxValidator(ngModelCtrl.$modelValue);
	                    ngModelCtrl.$setViewValue(formatPrecision(lastValidValue));
	                    ngModelCtrl.$render();
	                }
	            }
	
	            function onFormattingChanged(value) {
	                if (!angular.isUndefined(value)) {
	                    formatting = value !== false;
	                    ngModelCtrl.$setViewValue(formatPrecision(lastValidValue));
	                    ngModelCtrl.$render();
	                }
	            }
	
	            function onLimitMinChanged(value) {
	                if (!angular.isUndefined(value)) {
	                    limitMin = value == "true";
	                }
	            }
	
	            function onLimitMaxChanged(value) {
	                if (!angular.isUndefined(value)) {
	                    limitMax = value == "true";
	                }
	            }
	
	            /**
	             * Round the value to the closest decimal.
	             */
	            function round2(value) {
	                if (typeof value !== 'number') {
	                    return;
	                }
	                var IS_NEGATIVE = value < 0;
	                value = IS_NEGATIVE ? value * -1 : value;
	                var CONVERSION_FACTOR = Math.pow(10, getDecimals(value));
	                value = parseFloat((value * CONVERSION_FACTOR).toFixed(11));
	                value = Math.round(value) / CONVERSION_FACTOR;
	                value = IS_NEGATIVE ? value * -1 : value;
	                return value;
	            }
	            // Round using Big.js library
	            function round(value) {
	                if (typeof value !== 'number') {
	                    return;
	                }
	                var numDecimals = parseInt(maxdecimals || decimales || 2);
	                return parseFloat(Big(value).toFixed(numDecimals));
	            }
	
	            function getDecimals(value) {
	                if (!decimalsDinamic) {
	                    return decimals;
	                }
	                value = value.toString();
	                if (!value.split('.')[1]) {
	                    return 2;
	                }
	                var N_DECIMALS = value.split('.')[1].length === 1 ? 2 : value.split('.')[1].length;
	                if (N_DECIMALS <= maxdecimals) {
	                    return N_DECIMALS;
	                }
	                return maxdecimals;
	            }
	
	            /**
	             * Format a number with the thousand group separator.
	             */
	            function numberWithCommas(value) {
	                if (formatting) {
	                    var parts = ("" + value).split(decimalSeparator);
	                    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, groupSeparator);
	                    return parts.join(decimalSeparator);
	                } else {
	                    // No formatting applies.
	                    return value;
	                }
	            }
	
	            /**
	             * Format a value with thousand group separator and correct decimal char.
	             */
	            function formatPrecision(value) {
	                if (!(value || value === 0)) {
	                    return '';
	                }
	                var formattedValue = round(parseFloat(value)).toFixed(getDecimals(value));
	                formattedValue = formattedValue.replace('.', decimalSeparator);
	                return numberWithCommas(formattedValue);
	            }
	
	            function formatViewValue(value) {
	                return ngModelCtrl.$isEmpty(value) ? '' : '' + value;
	            }
	
	            /**
	             * Parse the view value.
	             */
	            function parseViewValue(value) {
	                if (angular.isUndefined(value)) {
	                    value = '';
	                }
	                if (decimals === 0) {
	                    value = ("" + value).split(groupSeparator).join('');
	                }
	                value = ("" + value).replace(decimalSeparator, '.');
	
	                // Handle leading decimal point, like ".5"
	                if (value.indexOf('.') === 0) {
	                    value = '0' + value;
	                }
	
	                // Allow "-" inputs only when min < 0
	                if (value.indexOf('-') === 0) {
	                    if (min >= 0) {
	                        value = null;
	                        ngModelCtrl.$setViewValue(formatViewValue(lastValidValue));
	                        ngModelCtrl.$render();
	                    } else if (value === '-') {
	                        value = '';
	                    }
	                }
	
	                var empty = ngModelCtrl.$isEmpty(value);
	                if (empty) {
	                    lastValidValue = '';
	                    //ngModelCtrl.$modelValue = undefined;
	                } else {
	                    if (regex.test(value) && value.length <= maxInputLength) {
	                        if (typeof notNumber === 'number' && parseFloat(value) === notNumber) {
	                            value = numberDefault ? numberDefault : 0;
	                        }
	                        if (value > max && limitMax) {
	                            lastValidValue = max;
	                        } else if (value < min && limitMin) {
	                            lastValidValue = min;
	                        } else {
	                            lastValidValue = value === '' ? null : parseFloat(value);
	                        }
	                    } else {
	                        // Render the last valid input in the field
	                        ngModelCtrl.$setViewValue(formatPrecision(formatViewValue(lastValidValue)));
	                        ngModelCtrl.$render();
	                    }
	                }
	
	                return lastValidValue;
	            }
	
	            /**
	             * Calculate the maximum input length in characters.
	             * If no maximum the input will be limited to 16; the maximum ECMA script int.
	             */
	            function calculateMaxLength(value) {
	                var length = 16;
	                if (!angular.isUndefined(value)) {
	                    length = Math.floor(value).toString().length;
	                }
	                if (decimals > 0) {
	                    // Add extra length for the decimals plus one for the decimal separator.
	                    length += decimals + 1;
	                }
	                if (min < 0) {
	                    // Add extra length for the - sign.
	                    length++;
	                }
	                return length;
	            }
	
	            /**
	             * Minimum value validator.
	             */
	            function minValidator(value) {
	                if (!angular.isUndefined(min) && limitMin) {
	                    if (!ngModelCtrl.$isEmpty(value) && value < min) {
	                        return min;
	                    } else {
	                        return value;
	                    }
	                } else {
	                    if (!limitMin) {
	                        ngModelCtrl.$setValidity('min', !(value < min));
	                    }
	                    return value;
	                }
	            }
	
	            /**
	             * Maximum value validator.
	             */
	            function maxValidator(value) {
	                if (!angular.isUndefined(max) && limitMax) {
	                    if (!ngModelCtrl.$isEmpty(value) && value > max) {
	                        return max;
	                    } else {
	                        return value;
	                    }
	                } else {
	                    if (!limitMax) {
	                        ngModelCtrl.$setValidity('max', !(value > max));
	                    }
	                    return value;
	                }
	            }
	
	            /**
	             * Function for handeling the blur (leave) event on the control.
	             */
	            function onBlur() {
	                var value = ngModelCtrl.$modelValue;
	                if (!angular.isUndefined(value)) {
	                    // Format the model value.
	                    ngModelCtrl.$viewValue = formatPrecision(value);
	                    ngModelCtrl.$render();
	                }
	            }
	
	            /**
	             * Function for handeling the focus (enter) event on the control.
	             * On focus show the value without the group separators.
	             */
	            function onFocus() {
	                var value = ngModelCtrl.$modelValue;
	                if (!angular.isUndefined(value)) {
	                    ngModelCtrl.$viewValue = ("" + value).replace(".", decimalSeparator);
	                    ngModelCtrl.$render();
	                }
	            }
	        }
	    }
	})();

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(491);
	
	var MODULE_NAME = 'numeric-directive';
	
	angular.module(MODULE_NAME, ['purplefox.numeric']);
	
	module.exports = MODULE_NAME;

/***/ }),
/* 493 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('ui.bootstrap.accordion', ['ui.bootstrap.collapse', 'ui.bootstrap.tabindex']).constant('uibAccordionConfig', {
	  closeOthers: true
	}).controller('UibAccordionController', ['$scope', '$attrs', 'uibAccordionConfig', function ($scope, $attrs, accordionConfig) {
	  // This array keeps track of the accordion groups
	  this.groups = [];
	
	  // Ensure that all the groups in this accordion are closed, unless close-others explicitly says not to
	  this.closeOthers = function (openGroup) {
	    var closeOthers = angular.isDefined($attrs.closeOthers) ? $scope.$eval($attrs.closeOthers) : accordionConfig.closeOthers;
	    if (closeOthers) {
	      angular.forEach(this.groups, function (group) {
	        if (group !== openGroup) {
	          group.isOpen = false;
	        }
	      });
	    }
	  };
	
	  // This is called from the accordion-group directive to add itself to the accordion
	  this.addGroup = function (groupScope) {
	    var that = this;
	    this.groups.push(groupScope);
	
	    groupScope.$on('$destroy', function (event) {
	      that.removeGroup(groupScope);
	    });
	  };
	
	  // This is called from the accordion-group directive when to remove itself
	  this.removeGroup = function (group) {
	    var index = this.groups.indexOf(group);
	    if (index !== -1) {
	      this.groups.splice(index, 1);
	    }
	  };
	}])
	
	// The accordion directive simply sets up the directive controller
	// and adds an accordion CSS class to itself element.
	.directive('uibAccordion', function () {
	  return {
	    controller: 'UibAccordionController',
	    controllerAs: 'accordion',
	    transclude: true,
	    templateUrl: function templateUrl(element, attrs) {
	      return attrs.templateUrl || 'uib/template/accordion/accordion.html';
	    }
	  };
	})
	
	// The accordion-group directive indicates a block of html that will expand and collapse in an accordion
	.directive('uibAccordionGroup', function () {
	  return {
	    require: '^uibAccordion', // We need this directive to be inside an accordion
	    transclude: true, // It transcludes the contents of the directive into the template
	    restrict: 'A',
	    templateUrl: function templateUrl(element, attrs) {
	      return attrs.templateUrl || 'uib/template/accordion/accordion-group.html';
	    },
	    scope: {
	      heading: '@', // Interpolate the heading attribute onto this scope
	      panelClass: '@?', // Ditto with panelClass
	      isOpen: '=?',
	      isDisabled: '=?'
	    },
	    controller: function controller() {
	      this.setHeading = function (element) {
	        this.heading = element;
	      };
	    },
	    link: function link(scope, element, attrs, accordionCtrl) {
	      element.addClass('panel');
	      accordionCtrl.addGroup(scope);
	
	      scope.openClass = attrs.openClass || 'panel-open';
	      scope.panelClass = attrs.panelClass || 'panel-default';
	      scope.$watch('isOpen', function (value) {
	        element.toggleClass(scope.openClass, !!value);
	        if (value) {
	          accordionCtrl.closeOthers(scope);
	        }
	      });
	
	      scope.toggleOpen = function ($event) {
	        if (!scope.isDisabled) {
	          if (!$event || $event.which === 32) {
	            scope.isOpen = !scope.isOpen;
	          }
	        }
	      };
	
	      var id = 'accordiongroup-' + scope.$id + '-' + Math.floor(Math.random() * 10000);
	      scope.headingId = id + '-tab';
	      scope.panelId = id + '-panel';
	    }
	  };
	})
	
	// Use accordion-heading below an accordion-group to provide a heading containing HTML
	.directive('uibAccordionHeading', function () {
	  return {
	    transclude: true, // Grab the contents to be used as the heading
	    template: '', // In effect remove this element!
	    replace: true,
	    require: '^uibAccordionGroup',
	    link: function link(scope, element, attrs, accordionGroupCtrl, transclude) {
	      // Pass the heading to the accordion-group controller
	      // so that it can be transcluded into the right place in the template
	      // [The second parameter to transclude causes the elements to be cloned so that they work in ng-repeat]
	      accordionGroupCtrl.setHeading(transclude(scope, angular.noop));
	    }
	  };
	})
	
	// Use in the accordion-group template to indicate where you want the heading to be transcluded
	// You must provide the property on the accordion-group controller that will hold the transcluded element
	.directive('uibAccordionTransclude', function () {
	  return {
	    require: '^uibAccordionGroup',
	    link: function link(scope, element, attrs, controller) {
	      scope.$watch(function () {
	        return controller[attrs.uibAccordionTransclude];
	      }, function (heading) {
	        if (heading) {
	          var elem = angular.element(element[0].querySelector(getHeaderSelectors()));
	          elem.html('');
	          elem.append(heading);
	        }
	      });
	    }
	  };
	
	  function getHeaderSelectors() {
	    return 'uib-accordion-header,' + 'data-uib-accordion-header,' + 'x-uib-accordion-header,' + 'uib\\:accordion-header,' + '[uib-accordion-header],' + '[data-uib-accordion-header],' + '[x-uib-accordion-header]';
	  }
	});

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(500);
	__webpack_require__(522);
	__webpack_require__(531);
	__webpack_require__(532);
	__webpack_require__(493);
	
	var MODULE_NAME = 'ui.bootstrap.module.accordion';
	
	angular.module(MODULE_NAME, ['ui.bootstrap.accordion', 'uib/template/accordion/accordion.html', 'uib/template/accordion/accordion-group.html']);
	
	module.exports = MODULE_NAME;

/***/ }),
/* 495 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('ui.bootstrap.alert', []).controller('UibAlertController', ['$scope', '$element', '$attrs', '$interpolate', '$timeout', function ($scope, $element, $attrs, $interpolate, $timeout) {
	  $scope.closeable = !!$attrs.close;
	  $element.addClass('alert');
	  $attrs.$set('role', 'alert');
	  if ($scope.closeable) {
	    $element.addClass('alert-dismissible');
	  }
	
	  var dismissOnTimeout = angular.isDefined($attrs.dismissOnTimeout) ? $interpolate($attrs.dismissOnTimeout)($scope.$parent) : null;
	
	  if (dismissOnTimeout) {
	    $timeout(function () {
	      $scope.close();
	    }, parseInt(dismissOnTimeout, 10));
	  }
	}]).directive('uibAlert', function () {
	  return {
	    controller: 'UibAlertController',
	    controllerAs: 'alert',
	    restrict: 'A',
	    templateUrl: function templateUrl(element, attrs) {
	      return attrs.templateUrl || 'uib/template/alert/alert.html';
	    },
	    transclude: true,
	    scope: {
	      close: '&'
	    }
	  };
	});

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(533);
	__webpack_require__(495);
	
	var MODULE_NAME = 'ui.bootstrap.module.alert';
	
	angular.module(MODULE_NAME, ['ui.bootstrap.alert', 'uib/template/alert/alert.html']);
	
	module.exports = MODULE_NAME;

/***/ }),
/* 497 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('ui.bootstrap.buttons', []).constant('uibButtonConfig', {
	  activeClass: 'active',
	  toggleEvent: 'click'
	}).controller('UibButtonsController', ['uibButtonConfig', function (buttonConfig) {
	  this.activeClass = buttonConfig.activeClass || 'active';
	  this.toggleEvent = buttonConfig.toggleEvent || 'click';
	}]).directive('uibBtnRadio', ['$parse', function ($parse) {
	  return {
	    require: ['uibBtnRadio', 'ngModel'],
	    controller: 'UibButtonsController',
	    controllerAs: 'buttons',
	    link: function link(scope, element, attrs, ctrls) {
	      var buttonsCtrl = ctrls[0],
	          ngModelCtrl = ctrls[1];
	      var uncheckableExpr = $parse(attrs.uibUncheckable);
	
	      element.find('input').css({ display: 'none' });
	
	      //model -> UI
	      ngModelCtrl.$render = function () {
	        element.toggleClass(buttonsCtrl.activeClass, angular.equals(ngModelCtrl.$modelValue, scope.$eval(attrs.uibBtnRadio)));
	      };
	
	      //ui->model
	      element.on(buttonsCtrl.toggleEvent, function () {
	        if (attrs.disabled) {
	          return;
	        }
	
	        var isActive = element.hasClass(buttonsCtrl.activeClass);
	
	        if (!isActive || angular.isDefined(attrs.uncheckable)) {
	          scope.$apply(function () {
	            ngModelCtrl.$setViewValue(isActive ? null : scope.$eval(attrs.uibBtnRadio));
	            ngModelCtrl.$render();
	          });
	        }
	      });
	
	      if (attrs.uibUncheckable) {
	        scope.$watch(uncheckableExpr, function (uncheckable) {
	          attrs.$set('uncheckable', uncheckable ? '' : undefined);
	        });
	      }
	    }
	  };
	}]).directive('uibBtnCheckbox', function () {
	  return {
	    require: ['uibBtnCheckbox', 'ngModel'],
	    controller: 'UibButtonsController',
	    controllerAs: 'button',
	    link: function link(scope, element, attrs, ctrls) {
	      var buttonsCtrl = ctrls[0],
	          ngModelCtrl = ctrls[1];
	
	      element.find('input').css({ display: 'none' });
	
	      function getTrueValue() {
	        return getCheckboxValue(attrs.btnCheckboxTrue, true);
	      }
	
	      function getFalseValue() {
	        return getCheckboxValue(attrs.btnCheckboxFalse, false);
	      }
	
	      function getCheckboxValue(attribute, defaultValue) {
	        return angular.isDefined(attribute) ? scope.$eval(attribute) : defaultValue;
	      }
	
	      //model -> UI
	      ngModelCtrl.$render = function () {
	        element.toggleClass(buttonsCtrl.activeClass, angular.equals(ngModelCtrl.$modelValue, getTrueValue()));
	      };
	
	      //ui->model
	      element.on(buttonsCtrl.toggleEvent, function () {
	        if (attrs.disabled) {
	          return;
	        }
	
	        scope.$apply(function () {
	          ngModelCtrl.$setViewValue(element.hasClass(buttonsCtrl.activeClass) ? getFalseValue() : getTrueValue());
	          ngModelCtrl.$render();
	        });
	      });
	    }
	  };
	});

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(497);
	
	var MODULE_NAME = 'ui.bootstrap.module.buttons';
	
	angular.module(MODULE_NAME, ['ui.bootstrap.buttons']);
	
	module.exports = MODULE_NAME;

/***/ }),
/* 499 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('ui.bootstrap.collapse', []).directive('uibCollapse', ['$animate', '$q', '$parse', '$injector', function ($animate, $q, $parse, $injector) {
	  var $animateCss = $injector.has('$animateCss') ? $injector.get('$animateCss') : null;
	  return {
	    link: function link(scope, element, attrs) {
	      var expandingExpr = $parse(attrs.expanding),
	          expandedExpr = $parse(attrs.expanded),
	          collapsingExpr = $parse(attrs.collapsing),
	          collapsedExpr = $parse(attrs.collapsed),
	          horizontal = false,
	          css = {},
	          cssTo = {};
	
	      init();
	
	      function init() {
	        horizontal = !!('horizontal' in attrs);
	        if (horizontal) {
	          css = {
	            width: ''
	          };
	          cssTo = { width: '0' };
	        } else {
	          css = {
	            height: ''
	          };
	          cssTo = { height: '0' };
	        }
	        if (!scope.$eval(attrs.uibCollapse)) {
	          element.addClass('in').addClass('collapse').attr('aria-expanded', true).attr('aria-hidden', false).css(css);
	        }
	      }
	
	      function getScrollFromElement(element) {
	        if (horizontal) {
	          return { width: element.scrollWidth + 'px' };
	        }
	        return { height: element.scrollHeight + 'px' };
	      }
	
	      function expand() {
	        if (element.hasClass('collapse') && element.hasClass('in')) {
	          return;
	        }
	
	        $q.resolve(expandingExpr(scope)).then(function () {
	          element.removeClass('collapse').addClass('collapsing').attr('aria-expanded', true).attr('aria-hidden', false);
	
	          if ($animateCss) {
	            $animateCss(element, {
	              addClass: 'in',
	              easing: 'ease',
	              css: {
	                overflow: 'hidden'
	              },
	              to: getScrollFromElement(element[0])
	            }).start()['finally'](expandDone);
	          } else {
	            $animate.addClass(element, 'in', {
	              css: {
	                overflow: 'hidden'
	              },
	              to: getScrollFromElement(element[0])
	            }).then(expandDone);
	          }
	        }, angular.noop);
	      }
	
	      function expandDone() {
	        element.removeClass('collapsing').addClass('collapse').css(css);
	        expandedExpr(scope);
	      }
	
	      function collapse() {
	        if (!element.hasClass('collapse') && !element.hasClass('in')) {
	          return collapseDone();
	        }
	
	        $q.resolve(collapsingExpr(scope)).then(function () {
	          element
	          // IMPORTANT: The width must be set before adding "collapsing" class.
	          // Otherwise, the browser attempts to animate from width 0 (in
	          // collapsing class) to the given width here.
	          .css(getScrollFromElement(element[0]))
	          // initially all panel collapse have the collapse class, this removal
	          // prevents the animation from jumping to collapsed state
	          .removeClass('collapse').addClass('collapsing').attr('aria-expanded', false).attr('aria-hidden', true);
	
	          if ($animateCss) {
	            $animateCss(element, {
	              removeClass: 'in',
	              to: cssTo
	            }).start()['finally'](collapseDone);
	          } else {
	            $animate.removeClass(element, 'in', {
	              to: cssTo
	            }).then(collapseDone);
	          }
	        }, angular.noop);
	      }
	
	      function collapseDone() {
	        element.css(cssTo); // Required so that collapse works when animation is disabled
	        element.removeClass('collapsing').addClass('collapse');
	        collapsedExpr(scope);
	      }
	
	      scope.$watch(attrs.uibCollapse, function (shouldCollapse) {
	        if (shouldCollapse) {
	          collapse();
	        } else {
	          expand();
	        }
	      });
	    }
	  };
	}]);

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(499);
	
	var MODULE_NAME = 'ui.bootstrap.module.collapse';
	
	angular.module(MODULE_NAME, ['ui.bootstrap.collapse']);
	
	module.exports = MODULE_NAME;

/***/ }),
/* 501 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('ui.bootstrap.dateparser', []).service('uibDateParser', ['$log', '$locale', 'dateFilter', 'orderByFilter', 'filterFilter', function ($log, $locale, dateFilter, orderByFilter, filterFilter) {
	  // Pulled from https://github.com/mbostock/d3/blob/master/src/format/requote.js
	  var SPECIAL_CHARACTERS_REGEXP = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;
	
	  var localeId;
	  var formatCodeToRegex;
	
	  this.init = function () {
	    localeId = $locale.id;
	
	    this.parsers = {};
	    this.formatters = {};
	
	    formatCodeToRegex = [{
	      key: 'yyyy',
	      regex: '\\d{4}',
	      apply: function apply(value) {
	        this.year = +value;
	      },
	      formatter: function formatter(date) {
	        var _date = new Date();
	        _date.setFullYear(Math.abs(date.getFullYear()));
	        return dateFilter(_date, 'yyyy');
	      }
	    }, {
	      key: 'yy',
	      regex: '\\d{2}',
	      apply: function apply(value) {
	        value = +value;this.year = value < 69 ? value + 2000 : value + 1900;
	      },
	      formatter: function formatter(date) {
	        var _date = new Date();
	        _date.setFullYear(Math.abs(date.getFullYear()));
	        return dateFilter(_date, 'yy');
	      }
	    }, {
	      key: 'y',
	      regex: '\\d{1,4}',
	      apply: function apply(value) {
	        this.year = +value;
	      },
	      formatter: function formatter(date) {
	        var _date = new Date();
	        _date.setFullYear(Math.abs(date.getFullYear()));
	        return dateFilter(_date, 'y');
	      }
	    }, {
	      key: 'M!',
	      regex: '0?[1-9]|1[0-2]',
	      apply: function apply(value) {
	        this.month = value - 1;
	      },
	      formatter: function formatter(date) {
	        var value = date.getMonth();
	        if (/^[0-9]$/.test(value)) {
	          return dateFilter(date, 'MM');
	        }
	
	        return dateFilter(date, 'M');
	      }
	    }, {
	      key: 'MMMM',
	      regex: $locale.DATETIME_FORMATS.MONTH.join('|'),
	      apply: function apply(value) {
	        this.month = $locale.DATETIME_FORMATS.MONTH.indexOf(value);
	      },
	      formatter: function formatter(date) {
	        return dateFilter(date, 'MMMM');
	      }
	    }, {
	      key: 'MMM',
	      regex: $locale.DATETIME_FORMATS.SHORTMONTH.join('|'),
	      apply: function apply(value) {
	        this.month = $locale.DATETIME_FORMATS.SHORTMONTH.indexOf(value);
	      },
	      formatter: function formatter(date) {
	        return dateFilter(date, 'MMM');
	      }
	    }, {
	      key: 'MM',
	      regex: '0[1-9]|1[0-2]',
	      apply: function apply(value) {
	        this.month = value - 1;
	      },
	      formatter: function formatter(date) {
	        return dateFilter(date, 'MM');
	      }
	    }, {
	      key: 'M',
	      regex: '[1-9]|1[0-2]',
	      apply: function apply(value) {
	        this.month = value - 1;
	      },
	      formatter: function formatter(date) {
	        return dateFilter(date, 'M');
	      }
	    }, {
	      key: 'd!',
	      regex: '[0-2]?[0-9]{1}|3[0-1]{1}',
	      apply: function apply(value) {
	        this.date = +value;
	      },
	      formatter: function formatter(date) {
	        var value = date.getDate();
	        if (/^[1-9]$/.test(value)) {
	          return dateFilter(date, 'dd');
	        }
	
	        return dateFilter(date, 'd');
	      }
	    }, {
	      key: 'dd',
	      regex: '[0-2][0-9]{1}|3[0-1]{1}',
	      apply: function apply(value) {
	        this.date = +value;
	      },
	      formatter: function formatter(date) {
	        return dateFilter(date, 'dd');
	      }
	    }, {
	      key: 'd',
	      regex: '[1-2]?[0-9]{1}|3[0-1]{1}',
	      apply: function apply(value) {
	        this.date = +value;
	      },
	      formatter: function formatter(date) {
	        return dateFilter(date, 'd');
	      }
	    }, {
	      key: 'EEEE',
	      regex: $locale.DATETIME_FORMATS.DAY.join('|'),
	      formatter: function formatter(date) {
	        return dateFilter(date, 'EEEE');
	      }
	    }, {
	      key: 'EEE',
	      regex: $locale.DATETIME_FORMATS.SHORTDAY.join('|'),
	      formatter: function formatter(date) {
	        return dateFilter(date, 'EEE');
	      }
	    }, {
	      key: 'HH',
	      regex: '(?:0|1)[0-9]|2[0-3]',
	      apply: function apply(value) {
	        this.hours = +value;
	      },
	      formatter: function formatter(date) {
	        return dateFilter(date, 'HH');
	      }
	    }, {
	      key: 'hh',
	      regex: '0[0-9]|1[0-2]',
	      apply: function apply(value) {
	        this.hours = +value;
	      },
	      formatter: function formatter(date) {
	        return dateFilter(date, 'hh');
	      }
	    }, {
	      key: 'H',
	      regex: '1?[0-9]|2[0-3]',
	      apply: function apply(value) {
	        this.hours = +value;
	      },
	      formatter: function formatter(date) {
	        return dateFilter(date, 'H');
	      }
	    }, {
	      key: 'h',
	      regex: '[0-9]|1[0-2]',
	      apply: function apply(value) {
	        this.hours = +value;
	      },
	      formatter: function formatter(date) {
	        return dateFilter(date, 'h');
	      }
	    }, {
	      key: 'mm',
	      regex: '[0-5][0-9]',
	      apply: function apply(value) {
	        this.minutes = +value;
	      },
	      formatter: function formatter(date) {
	        return dateFilter(date, 'mm');
	      }
	    }, {
	      key: 'm',
	      regex: '[0-9]|[1-5][0-9]',
	      apply: function apply(value) {
	        this.minutes = +value;
	      },
	      formatter: function formatter(date) {
	        return dateFilter(date, 'm');
	      }
	    }, {
	      key: 'sss',
	      regex: '[0-9][0-9][0-9]',
	      apply: function apply(value) {
	        this.milliseconds = +value;
	      },
	      formatter: function formatter(date) {
	        return dateFilter(date, 'sss');
	      }
	    }, {
	      key: 'ss',
	      regex: '[0-5][0-9]',
	      apply: function apply(value) {
	        this.seconds = +value;
	      },
	      formatter: function formatter(date) {
	        return dateFilter(date, 'ss');
	      }
	    }, {
	      key: 's',
	      regex: '[0-9]|[1-5][0-9]',
	      apply: function apply(value) {
	        this.seconds = +value;
	      },
	      formatter: function formatter(date) {
	        return dateFilter(date, 's');
	      }
	    }, {
	      key: 'a',
	      regex: $locale.DATETIME_FORMATS.AMPMS.join('|'),
	      apply: function apply(value) {
	        if (this.hours === 12) {
	          this.hours = 0;
	        }
	
	        if (value === 'PM') {
	          this.hours += 12;
	        }
	      },
	      formatter: function formatter(date) {
	        return dateFilter(date, 'a');
	      }
	    }, {
	      key: 'Z',
	      regex: '[+-]\\d{4}',
	      apply: function apply(value) {
	        var matches = value.match(/([+-])(\d{2})(\d{2})/),
	            sign = matches[1],
	            hours = matches[2],
	            minutes = matches[3];
	        this.hours += toInt(sign + hours);
	        this.minutes += toInt(sign + minutes);
	      },
	      formatter: function formatter(date) {
	        return dateFilter(date, 'Z');
	      }
	    }, {
	      key: 'ww',
	      regex: '[0-4][0-9]|5[0-3]',
	      formatter: function formatter(date) {
	        return dateFilter(date, 'ww');
	      }
	    }, {
	      key: 'w',
	      regex: '[0-9]|[1-4][0-9]|5[0-3]',
	      formatter: function formatter(date) {
	        return dateFilter(date, 'w');
	      }
	    }, {
	      key: 'GGGG',
	      regex: $locale.DATETIME_FORMATS.ERANAMES.join('|').replace(/\s/g, '\\s'),
	      formatter: function formatter(date) {
	        return dateFilter(date, 'GGGG');
	      }
	    }, {
	      key: 'GGG',
	      regex: $locale.DATETIME_FORMATS.ERAS.join('|'),
	      formatter: function formatter(date) {
	        return dateFilter(date, 'GGG');
	      }
	    }, {
	      key: 'GG',
	      regex: $locale.DATETIME_FORMATS.ERAS.join('|'),
	      formatter: function formatter(date) {
	        return dateFilter(date, 'GG');
	      }
	    }, {
	      key: 'G',
	      regex: $locale.DATETIME_FORMATS.ERAS.join('|'),
	      formatter: function formatter(date) {
	        return dateFilter(date, 'G');
	      }
	    }];
	
	    if (angular.version.major >= 1 && angular.version.minor > 4) {
	      formatCodeToRegex.push({
	        key: 'LLLL',
	        regex: $locale.DATETIME_FORMATS.STANDALONEMONTH.join('|'),
	        apply: function apply(value) {
	          this.month = $locale.DATETIME_FORMATS.STANDALONEMONTH.indexOf(value);
	        },
	        formatter: function formatter(date) {
	          return dateFilter(date, 'LLLL');
	        }
	      });
	    }
	  };
	
	  this.init();
	
	  function getFormatCodeToRegex(key) {
	    return filterFilter(formatCodeToRegex, { key: key }, true)[0];
	  }
	
	  this.getParser = function (key) {
	    var f = getFormatCodeToRegex(key);
	    return f && f.apply || null;
	  };
	
	  this.overrideParser = function (key, parser) {
	    var f = getFormatCodeToRegex(key);
	    if (f && angular.isFunction(parser)) {
	      this.parsers = {};
	      f.apply = parser;
	    }
	  }.bind(this);
	
	  function createParser(format) {
	    var map = [],
	        regex = format.split('');
	
	    // check for literal values
	    var quoteIndex = format.indexOf('\'');
	    if (quoteIndex > -1) {
	      var inLiteral = false;
	      format = format.split('');
	      for (var i = quoteIndex; i < format.length; i++) {
	        if (inLiteral) {
	          if (format[i] === '\'') {
	            if (i + 1 < format.length && format[i + 1] === '\'') {
	              // escaped single quote
	              format[i + 1] = '$';
	              regex[i + 1] = '';
	            } else {
	              // end of literal
	              regex[i] = '';
	              inLiteral = false;
	            }
	          }
	          format[i] = '$';
	        } else {
	          if (format[i] === '\'') {
	            // start of literal
	            format[i] = '$';
	            regex[i] = '';
	            inLiteral = true;
	          }
	        }
	      }
	
	      format = format.join('');
	    }
	
	    angular.forEach(formatCodeToRegex, function (data) {
	      var index = format.indexOf(data.key);
	
	      if (index > -1) {
	        format = format.split('');
	
	        regex[index] = '(' + data.regex + ')';
	        format[index] = '$'; // Custom symbol to define consumed part of format
	        for (var i = index + 1, n = index + data.key.length; i < n; i++) {
	          regex[i] = '';
	          format[i] = '$';
	        }
	        format = format.join('');
	
	        map.push({
	          index: index,
	          key: data.key,
	          apply: data.apply,
	          matcher: data.regex
	        });
	      }
	    });
	
	    return {
	      regex: new RegExp('^' + regex.join('') + '$'),
	      map: orderByFilter(map, 'index')
	    };
	  }
	
	  function createFormatter(format) {
	    var formatters = [];
	    var i = 0;
	    var formatter, literalIdx;
	    while (i < format.length) {
	      if (angular.isNumber(literalIdx)) {
	        if (format.charAt(i) === '\'') {
	          if (i + 1 >= format.length || format.charAt(i + 1) !== '\'') {
	            formatters.push(constructLiteralFormatter(format, literalIdx, i));
	            literalIdx = null;
	          }
	        } else if (i === format.length) {
	          while (literalIdx < format.length) {
	            formatter = constructFormatterFromIdx(format, literalIdx);
	            formatters.push(formatter);
	            literalIdx = formatter.endIdx;
	          }
	        }
	
	        i++;
	        continue;
	      }
	
	      if (format.charAt(i) === '\'') {
	        literalIdx = i;
	        i++;
	        continue;
	      }
	
	      formatter = constructFormatterFromIdx(format, i);
	
	      formatters.push(formatter.parser);
	      i = formatter.endIdx;
	    }
	
	    return formatters;
	  }
	
	  function constructLiteralFormatter(format, literalIdx, endIdx) {
	    return function () {
	      return format.substr(literalIdx + 1, endIdx - literalIdx - 1);
	    };
	  }
	
	  function constructFormatterFromIdx(format, i) {
	    var currentPosStr = format.substr(i);
	    for (var j = 0; j < formatCodeToRegex.length; j++) {
	      if (new RegExp('^' + formatCodeToRegex[j].key).test(currentPosStr)) {
	        var data = formatCodeToRegex[j];
	        return {
	          endIdx: i + data.key.length,
	          parser: data.formatter
	        };
	      }
	    }
	
	    return {
	      endIdx: i + 1,
	      parser: function parser() {
	        return currentPosStr.charAt(0);
	      }
	    };
	  }
	
	  this.filter = function (date, format) {
	    if (!angular.isDate(date) || isNaN(date) || !format) {
	      return '';
	    }
	
	    format = $locale.DATETIME_FORMATS[format] || format;
	
	    if ($locale.id !== localeId) {
	      this.init();
	    }
	
	    if (!this.formatters[format]) {
	      this.formatters[format] = createFormatter(format);
	    }
	
	    var formatters = this.formatters[format];
	
	    return formatters.reduce(function (str, formatter) {
	      return str + formatter(date);
	    }, '');
	  };
	
	  this.parse = function (input, format, baseDate) {
	    if (!angular.isString(input) || !format) {
	      return input;
	    }
	
	    format = $locale.DATETIME_FORMATS[format] || format;
	    format = format.replace(SPECIAL_CHARACTERS_REGEXP, '\\$&');
	
	    if ($locale.id !== localeId) {
	      this.init();
	    }
	
	    if (!this.parsers[format]) {
	      this.parsers[format] = createParser(format, 'apply');
	    }
	
	    var parser = this.parsers[format],
	        regex = parser.regex,
	        map = parser.map,
	        results = input.match(regex),
	        tzOffset = false;
	    if (results && results.length) {
	      var fields, dt;
	      if (angular.isDate(baseDate) && !isNaN(baseDate.getTime())) {
	        fields = {
	          year: baseDate.getFullYear(),
	          month: baseDate.getMonth(),
	          date: baseDate.getDate(),
	          hours: baseDate.getHours(),
	          minutes: baseDate.getMinutes(),
	          seconds: baseDate.getSeconds(),
	          milliseconds: baseDate.getMilliseconds()
	        };
	      } else {
	        if (baseDate) {
	          $log.warn('dateparser:', 'baseDate is not a valid date');
	        }
	        fields = { year: 1900, month: 0, date: 1, hours: 0, minutes: 0, seconds: 0, milliseconds: 0 };
	      }
	
	      for (var i = 1, n = results.length; i < n; i++) {
	        var mapper = map[i - 1];
	        if (mapper.matcher === 'Z') {
	          tzOffset = true;
	        }
	
	        if (mapper.apply) {
	          mapper.apply.call(fields, results[i]);
	        }
	      }
	
	      var datesetter = tzOffset ? Date.prototype.setUTCFullYear : Date.prototype.setFullYear;
	      var timesetter = tzOffset ? Date.prototype.setUTCHours : Date.prototype.setHours;
	
	      if (isValid(fields.year, fields.month, fields.date)) {
	        if (angular.isDate(baseDate) && !isNaN(baseDate.getTime()) && !tzOffset) {
	          dt = new Date(baseDate);
	          datesetter.call(dt, fields.year, fields.month, fields.date);
	          timesetter.call(dt, fields.hours, fields.minutes, fields.seconds, fields.milliseconds);
	        } else {
	          dt = new Date(0);
	          datesetter.call(dt, fields.year, fields.month, fields.date);
	          timesetter.call(dt, fields.hours || 0, fields.minutes || 0, fields.seconds || 0, fields.milliseconds || 0);
	        }
	      }
	
	      return dt;
	    }
	  };
	
	  // Check if date is valid for specific month (and year for February).
	  // Month: 0 = Jan, 1 = Feb, etc
	  function isValid(year, month, date) {
	    if (date < 1) {
	      return false;
	    }
	
	    if (month === 1 && date > 28) {
	      return date === 29 && (year % 4 === 0 && year % 100 !== 0 || year % 400 === 0);
	    }
	
	    if (month === 3 || month === 5 || month === 8 || month === 10) {
	      return date < 31;
	    }
	
	    return true;
	  }
	
	  function toInt(str) {
	    return parseInt(str, 10);
	  }
	
	  this.toTimezone = toTimezone;
	  this.fromTimezone = fromTimezone;
	  this.timezoneToOffset = timezoneToOffset;
	  this.addDateMinutes = addDateMinutes;
	  this.convertTimezoneToLocal = convertTimezoneToLocal;
	
	  function toTimezone(date, timezone) {
	    return date && timezone ? convertTimezoneToLocal(date, timezone) : date;
	  }
	
	  function fromTimezone(date, timezone) {
	    return date && timezone ? convertTimezoneToLocal(date, timezone, true) : date;
	  }
	
	  //https://github.com/angular/angular.js/blob/622c42169699ec07fc6daaa19fe6d224e5d2f70e/src/Angular.js#L1207
	  function timezoneToOffset(timezone, fallback) {
	    timezone = timezone.replace(/:/g, '');
	    var requestedTimezoneOffset = Date.parse('Jan 01, 1970 00:00:00 ' + timezone) / 60000;
	    return isNaN(requestedTimezoneOffset) ? fallback : requestedTimezoneOffset;
	  }
	
	  function addDateMinutes(date, minutes) {
	    date = new Date(date.getTime());
	    date.setMinutes(date.getMinutes() + minutes);
	    return date;
	  }
	
	  function convertTimezoneToLocal(date, timezone, reverse) {
	    reverse = reverse ? -1 : 1;
	    var dateTimezoneOffset = date.getTimezoneOffset();
	    var timezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
	    return addDateMinutes(date, reverse * (timezoneOffset - dateTimezoneOffset));
	  }
	}]);

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(501);
	
	var MODULE_NAME = 'ui.bootstrap.module.dateparser';
	
	angular.module(MODULE_NAME, ['ui.bootstrap.dateparser']);
	
	module.exports = MODULE_NAME;

/***/ }),
/* 503 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module("ngLocale", [], ["$provide", function ($provide) {
	  var PLURAL_CATEGORY = { ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other" };
	  $provide.value("$locale", {
	    "DATETIME_FORMATS": {
	      "AMPMS": ["a. m.", "p. m."],
	      "DAY": ["domingo", "lunes", "martes", "mi\xE9rcoles", "jueves", "viernes", "s\xE1bado"],
	      "ERANAMES": ["antes de Cristo", "despu\xE9s de Cristo"],
	      "ERAS": ["a. C.", "d. C."],
	      "FIRSTDAYOFWEEK": 0,
	      "MONTH": ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"],
	      "SHORTDAY": ["dom.", "lun.", "mar.", "mi\xE9.", "jue.", "vie.", "s\xE1b."],
	      "SHORTMONTH": ["ene.", "feb.", "mar.", "abr.", "may.", "jun.", "jul.", "ago.", "sept.", "oct.", "nov.", "dic."],
	      "STANDALONEMONTH": ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"],
	      "WEEKENDRANGE": [5, 6],
	      "fullDate": "EEEE, d 'de' MMMM 'de' y",
	      "longDate": "d 'de' MMMM 'de' y",
	      "medium": "d MMM y H:mm:ss",
	      "mediumDate": "d MMM y",
	      "mediumTime": "H:mm:ss",
	      "short": "d/M/yy H:mm",
	      "shortDate": "d/M/yy",
	      "shortTime": "H:mm"
	    },
	    "NUMBER_FORMATS": {
	      "CURRENCY_SYM": "\u20AC",
	      "DECIMAL_SEP": ",",
	      "GROUP_SEP": ".",
	      "PATTERNS": [{
	        "gSize": 3,
	        "lgSize": 3,
	        "maxFrac": 3,
	        "minFrac": 0,
	        "minInt": 1,
	        "negPre": "-",
	        "negSuf": "",
	        "posPre": "",
	        "posSuf": ""
	      }, {
	        "gSize": 3,
	        "lgSize": 3,
	        "maxFrac": 2,
	        "minFrac": 2,
	        "minInt": 1,
	        "negPre": "-",
	        "negSuf": "\xA0\xA4",
	        "posPre": "",
	        "posSuf": "\xA0\xA4"
	      }]
	    },
	    "id": "es-es",
	    "localeID": "es_ES",
	    "pluralCat": function pluralCat(n, opt_precision) {
	      if (n == 1) {
	        return PLURAL_CATEGORY.ONE;
	      }return PLURAL_CATEGORY.OTHER;
	    }
	  });
	}]);
	
	angular.module('ui.bootstrap.datepicker', ['ui.bootstrap.dateparser', 'ui.bootstrap.isClass']).value('$datepickerSuppressError', false).value('$datepickerLiteralWarning', true).constant('uibDatepickerConfig', {
	  datepickerMode: 'day',
	  formatDay: 'dd',
	  formatMonth: 'MMMM',
	  formatYear: 'yyyy',
	  formatDayHeader: 'EEE',
	  formatDayTitle: 'MMMM yyyy',
	  formatMonthTitle: 'yyyy',
	  maxDate: null,
	  maxMode: 'year',
	  minDate: null,
	  minMode: 'day',
	  monthColumns: 3,
	  ngModelOptions: {},
	  shortcutPropagation: false,
	  showWeeks: true,
	  yearColumns: 5,
	  yearRows: 4
	}).controller('UibDatepickerController', ['$scope', '$element', '$attrs', '$parse', '$interpolate', '$locale', '$log', 'dateFilter', 'uibDatepickerConfig', '$datepickerLiteralWarning', '$datepickerSuppressError', 'uibDateParser', function ($scope, $element, $attrs, $parse, $interpolate, $locale, $log, dateFilter, datepickerConfig, $datepickerLiteralWarning, $datepickerSuppressError, dateParser) {
	  var self = this,
	      ngModelCtrl = { $setViewValue: angular.noop },
	      // nullModelCtrl;
	  ngModelOptions = {},
	      watchListeners = [];
	
	  $element.addClass('uib-datepicker');
	  $attrs.$set('role', 'application');
	
	  if (!$scope.datepickerOptions) {
	    $scope.datepickerOptions = {};
	  }
	
	  // Modes chain
	  this.modes = ['day', 'month', 'year'];
	
	  ['customClass', 'dateDisabled', 'datepickerMode', 'formatDay', 'formatDayHeader', 'formatDayTitle', 'formatMonth', 'formatMonthTitle', 'formatYear', 'maxDate', 'maxMode', 'minDate', 'minMode', 'monthColumns', 'showWeeks', 'shortcutPropagation', 'startingDay', 'yearColumns', 'yearRows'].forEach(function (key) {
	    switch (key) {
	      case 'customClass':
	      case 'dateDisabled':
	        $scope[key] = $scope.datepickerOptions[key] || angular.noop;
	        break;
	      case 'datepickerMode':
	        $scope.datepickerMode = angular.isDefined($scope.datepickerOptions.datepickerMode) ? $scope.datepickerOptions.datepickerMode : datepickerConfig.datepickerMode;
	        break;
	      case 'formatDay':
	      case 'formatDayHeader':
	      case 'formatDayTitle':
	      case 'formatMonth':
	      case 'formatMonthTitle':
	      case 'formatYear':
	        self[key] = angular.isDefined($scope.datepickerOptions[key]) ? $interpolate($scope.datepickerOptions[key])($scope.$parent) : datepickerConfig[key];
	        break;
	      case 'monthColumns':
	      case 'showWeeks':
	      case 'shortcutPropagation':
	      case 'yearColumns':
	      case 'yearRows':
	        self[key] = angular.isDefined($scope.datepickerOptions[key]) ? $scope.datepickerOptions[key] : datepickerConfig[key];
	        break;
	      case 'startingDay':
	        if (angular.isDefined($scope.datepickerOptions.startingDay)) {
	          self.startingDay = $scope.datepickerOptions.startingDay;
	        } else if (angular.isNumber(datepickerConfig.startingDay)) {
	          self.startingDay = datepickerConfig.startingDay;
	        } else {
	          self.startingDay = ($locale.DATETIME_FORMATS.FIRSTDAYOFWEEK + 8) % 7;
	        }
	
	        break;
	      case 'maxDate':
	      case 'minDate':
	        $scope.$watch('datepickerOptions.' + key, function (value) {
	          if (value) {
	            if (angular.isDate(value)) {
	              self[key] = dateParser.fromTimezone(new Date(value), ngModelOptions.getOption('timezone'));
	            } else {
	              if ($datepickerLiteralWarning) {
	                $log.warn('Literal date support has been deprecated, please switch to date object usage');
	              }
	
	              self[key] = new Date(dateFilter(value, 'medium'));
	            }
	          } else {
	            self[key] = datepickerConfig[key] ? dateParser.fromTimezone(new Date(datepickerConfig[key]), ngModelOptions.getOption('timezone')) : null;
	          }
	
	          self.refreshView();
	        });
	
	        break;
	      case 'maxMode':
	      case 'minMode':
	        if ($scope.datepickerOptions[key]) {
	          $scope.$watch(function () {
	            return $scope.datepickerOptions[key];
	          }, function (value) {
	            self[key] = $scope[key] = angular.isDefined(value) ? value : $scope.datepickerOptions[key];
	            if (key === 'minMode' && self.modes.indexOf($scope.datepickerOptions.datepickerMode) < self.modes.indexOf(self[key]) || key === 'maxMode' && self.modes.indexOf($scope.datepickerOptions.datepickerMode) > self.modes.indexOf(self[key])) {
	              $scope.datepickerMode = self[key];
	              $scope.datepickerOptions.datepickerMode = self[key];
	            }
	          });
	        } else {
	          self[key] = $scope[key] = datepickerConfig[key] || null;
	        }
	
	        break;
	    }
	  });
	
	  $scope.uniqueId = 'datepicker-' + $scope.$id + '-' + Math.floor(Math.random() * 10000);
	
	  $scope.disabled = angular.isDefined($attrs.disabled) || false;
	  if (angular.isDefined($attrs.ngDisabled)) {
	    watchListeners.push($scope.$parent.$watch($attrs.ngDisabled, function (disabled) {
	      $scope.disabled = disabled;
	      self.refreshView();
	    }));
	  }
	
	  $scope.isActive = function (dateObject) {
	    if (self.compare(dateObject.date, self.activeDate) === 0) {
	      $scope.activeDateId = dateObject.uid;
	      return true;
	    }
	    return false;
	  };
	
	  this.init = function (ngModelCtrl_) {
	    ngModelCtrl = ngModelCtrl_;
	    ngModelOptions = extractOptions(ngModelCtrl);
	
	    if ($scope.datepickerOptions.initDate) {
	      self.activeDate = dateParser.fromTimezone($scope.datepickerOptions.initDate, ngModelOptions.getOption('timezone')) || new Date();
	      $scope.$watch('datepickerOptions.initDate', function (initDate) {
	        if (initDate && (ngModelCtrl.$isEmpty(ngModelCtrl.$modelValue) || ngModelCtrl.$invalid)) {
	          self.activeDate = dateParser.fromTimezone(initDate, ngModelOptions.getOption('timezone'));
	          self.refreshView();
	        }
	      });
	    } else {
	      self.activeDate = new Date();
	    }
	
	    var date = ngModelCtrl.$modelValue ? new Date(ngModelCtrl.$modelValue) : new Date();
	    this.activeDate = !isNaN(date) ? dateParser.fromTimezone(date, ngModelOptions.getOption('timezone')) : dateParser.fromTimezone(new Date(), ngModelOptions.getOption('timezone'));
	
	    ngModelCtrl.$render = function () {
	      self.render();
	    };
	  };
	
	  this.render = function () {
	    if (ngModelCtrl.$viewValue) {
	      var date = new Date(ngModelCtrl.$viewValue),
	          isValid = !isNaN(date);
	
	      if (isValid) {
	        this.activeDate = dateParser.fromTimezone(date, ngModelOptions.getOption('timezone'));
	      } else if (!$datepickerSuppressError) {
	        $log.error('Datepicker directive: "ng-model" value must be a Date object');
	      }
	    }
	    this.refreshView();
	  };
	
	  this.refreshView = function () {
	    if (this.element) {
	      $scope.selectedDt = null;
	      this._refreshView();
	      if ($scope.activeDt) {
	        $scope.activeDateId = $scope.activeDt.uid;
	      }
	
	      var date = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : null;
	      date = dateParser.fromTimezone(date, ngModelOptions.getOption('timezone'));
	      ngModelCtrl.$setValidity('dateDisabled', !date || this.element && !this.isDisabled(date));
	    }
	  };
	
	  this.createDateObject = function (date, format) {
	    var model = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : null;
	    model = dateParser.fromTimezone(model, ngModelOptions.getOption('timezone'));
	    var today = new Date();
	    today = dateParser.fromTimezone(today, ngModelOptions.getOption('timezone'));
	    var time = this.compare(date, today);
	    var dt = {
	      date: date,
	      label: dateParser.filter(date, format),
	      selected: model && this.compare(date, model) === 0,
	      disabled: this.isDisabled(date),
	      past: time < 0,
	      current: time === 0,
	      future: time > 0,
	      customClass: this.customClass(date) || null
	    };
	
	    if (model && this.compare(date, model) === 0) {
	      $scope.selectedDt = dt;
	    }
	
	    if (self.activeDate && this.compare(dt.date, self.activeDate) === 0) {
	      $scope.activeDt = dt;
	    }
	
	    return dt;
	  };
	
	  this.isDisabled = function (date) {
	    return $scope.disabled || this.minDate && this.compare(date, this.minDate) < 0 || this.maxDate && this.compare(date, this.maxDate) > 0 || $scope.dateDisabled && $scope.dateDisabled({ date: date, mode: $scope.datepickerMode });
	  };
	
	  this.customClass = function (date) {
	    return $scope.customClass({ date: date, mode: $scope.datepickerMode });
	  };
	
	  // Split array into smaller arrays
	  this.split = function (arr, size) {
	    var arrays = [];
	    while (arr.length > 0) {
	      arrays.push(arr.splice(0, size));
	    }
	    return arrays;
	  };
	
	  $scope.select = function (date) {
	    if ($scope.datepickerMode === self.minMode) {
	      var dt = ngModelCtrl.$viewValue ? dateParser.fromTimezone(new Date(ngModelCtrl.$viewValue), ngModelOptions.getOption('timezone')) : new Date(0, 0, 0, 0, 0, 0, 0);
	      dt.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
	      dt = dateParser.toTimezone(dt, ngModelOptions.getOption('timezone'));
	      ngModelCtrl.$setViewValue(dt);
	      ngModelCtrl.$render();
	    } else {
	      self.activeDate = date;
	      setMode(self.modes[self.modes.indexOf($scope.datepickerMode) - 1]);
	
	      $scope.$emit('uib:datepicker.mode');
	    }
	
	    $scope.$broadcast('uib:datepicker.focus');
	  };
	
	  $scope.move = function (direction) {
	    var year = self.activeDate.getFullYear() + direction * (self.step.years || 0),
	        month = self.activeDate.getMonth() + direction * (self.step.months || 0);
	    self.activeDate.setFullYear(year, month, 1);
	    self.refreshView();
	  };
	
	  $scope.toggleMode = function (direction) {
	    direction = direction || 1;
	
	    if ($scope.datepickerMode === self.maxMode && direction === 1 || $scope.datepickerMode === self.minMode && direction === -1) {
	      return;
	    }
	
	    setMode(self.modes[self.modes.indexOf($scope.datepickerMode) + direction]);
	
	    $scope.$emit('uib:datepicker.mode');
	  };
	
	  // Key event mapper
	  $scope.keys = { 13: 'enter', 32: 'space', 33: 'pageup', 34: 'pagedown', 35: 'end', 36: 'home', 37: 'left', 38: 'up', 39: 'right', 40: 'down' };
	
	  var focusElement = function focusElement() {
	    self.element[0].focus();
	  };
	
	  // Listen for focus requests from popup directive
	  $scope.$on('uib:datepicker.focus', focusElement);
	
	  $scope.keydown = function (evt) {
	    var key = $scope.keys[evt.which];
	
	    if (!key || evt.shiftKey || evt.altKey || $scope.disabled) {
	      return;
	    }
	
	    evt.preventDefault();
	    if (!self.shortcutPropagation) {
	      evt.stopPropagation();
	    }
	
	    if (key === 'enter' || key === 'space') {
	      if (self.isDisabled(self.activeDate)) {
	        return; // do nothing
	      }
	      $scope.select(self.activeDate);
	    } else if (evt.ctrlKey && (key === 'up' || key === 'down')) {
	      $scope.toggleMode(key === 'up' ? 1 : -1);
	    } else {
	      self.handleKeyDown(key, evt);
	      self.refreshView();
	    }
	  };
	
	  $element.on('keydown', function (evt) {
	    $scope.$apply(function () {
	      $scope.keydown(evt);
	    });
	  });
	
	  $scope.$on('$destroy', function () {
	    //Clear all watch listeners on destroy
	    while (watchListeners.length) {
	      watchListeners.shift()();
	    }
	  });
	
	  function setMode(mode) {
	    $scope.datepickerMode = mode;
	    $scope.datepickerOptions.datepickerMode = mode;
	  }
	
	  function extractOptions(ngModelCtrl) {
	    var ngModelOptions;
	
	    if (angular.version.minor < 6) {
	      // in angular < 1.6 $options could be missing
	      // guarantee a value
	      ngModelOptions = ngModelCtrl.$options || $scope.datepickerOptions.ngModelOptions || datepickerConfig.ngModelOptions || {};
	
	      // mimic 1.6+ api
	      ngModelOptions.getOption = function (key) {
	        return ngModelOptions[key];
	      };
	    } else {
	      // in angular >=1.6 $options is always present
	      // ng-model-options defaults timezone to null; don't let its precedence squash a non-null value
	      var timezone = ngModelCtrl.$options.getOption('timezone') || ($scope.datepickerOptions.ngModelOptions ? $scope.datepickerOptions.ngModelOptions.timezone : null) || (datepickerConfig.ngModelOptions ? datepickerConfig.ngModelOptions.timezone : null);
	
	      // values passed to createChild override existing values
	      ngModelOptions = ngModelCtrl.$options // start with a ModelOptions instance
	      .createChild(datepickerConfig.ngModelOptions) // lowest precedence
	      .createChild($scope.datepickerOptions.ngModelOptions).createChild(ngModelCtrl.$options) // highest precedence
	      .createChild({ timezone: timezone }); // to keep from squashing a non-null value
	    }
	
	    return ngModelOptions;
	  }
	}]).controller('UibDaypickerController', ['$scope', '$element', 'dateFilter', function (scope, $element, dateFilter) {
	  var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
	
	  this.step = { months: 1 };
	  this.element = $element;
	  function getDaysInMonth(year, month) {
	    return month === 1 && year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0) ? 29 : DAYS_IN_MONTH[month];
	  }
	
	  this.init = function (ctrl) {
	    angular.extend(ctrl, this);
	    scope.showWeeks = ctrl.showWeeks;
	    ctrl.refreshView();
	  };
	
	  this.getDates = function (startDate, n) {
	    var dates = new Array(n),
	        current = new Date(startDate),
	        i = 0,
	        date;
	    while (i < n) {
	      date = new Date(current);
	      dates[i++] = date;
	      current.setDate(current.getDate() + 1);
	    }
	    return dates;
	  };
	
	  this._refreshView = function () {
	    var year = this.activeDate.getFullYear(),
	        month = this.activeDate.getMonth(),
	        firstDayOfMonth = new Date(this.activeDate);
	
	    firstDayOfMonth.setFullYear(year, month, 1);
	
	    var difference = this.startingDay - firstDayOfMonth.getDay(),
	        numDisplayedFromPreviousMonth = difference > 0 ? 7 - difference : -difference,
	        firstDate = new Date(firstDayOfMonth);
	
	    if (numDisplayedFromPreviousMonth > 0) {
	      firstDate.setDate(-numDisplayedFromPreviousMonth + 1);
	    }
	
	    // 42 is the number of days on a six-week calendar
	    var days = this.getDates(firstDate, 42);
	    for (var i = 0; i < 42; i++) {
	      days[i] = angular.extend(this.createDateObject(days[i], this.formatDay), {
	        secondary: days[i].getMonth() !== month,
	        uid: scope.uniqueId + '-' + i
	      });
	    }
	
	    scope.labels = new Array(7);
	    for (var j = 0; j < 7; j++) {
	      scope.labels[j] = {
	        abbr: dateFilter(days[j].date, this.formatDayHeader),
	        full: dateFilter(days[j].date, 'EEEE')
	      };
	    }
	
	    scope.title = dateFilter(this.activeDate, this.formatDayTitle);
	    scope.rows = this.split(days, 7);
	
	    if (scope.showWeeks) {
	      scope.weekNumbers = [];
	      var thursdayIndex = (4 + 7 - this.startingDay) % 7,
	          numWeeks = scope.rows.length;
	      for (var curWeek = 0; curWeek < numWeeks; curWeek++) {
	        scope.weekNumbers.push(getISO8601WeekNumber(scope.rows[curWeek][thursdayIndex].date));
	      }
	    }
	  };
	
	  this.compare = function (date1, date2) {
	    var _date1 = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
	    var _date2 = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
	    _date1.setFullYear(date1.getFullYear());
	    _date2.setFullYear(date2.getFullYear());
	    return _date1 - _date2;
	  };
	
	  function getISO8601WeekNumber(date) {
	    var checkDate = new Date(date);
	    checkDate.setDate(checkDate.getDate() + 4 - (checkDate.getDay() || 7)); // Thursday
	    var time = checkDate.getTime();
	    checkDate.setMonth(0); // Compare with Jan 1
	    checkDate.setDate(1);
	    return Math.floor(Math.round((time - checkDate) / 86400000) / 7) + 1;
	  }
	
	  this.handleKeyDown = function (key, evt) {
	    var date = this.activeDate.getDate();
	
	    if (key === 'left') {
	      date = date - 1;
	    } else if (key === 'up') {
	      date = date - 7;
	    } else if (key === 'right') {
	      date = date + 1;
	    } else if (key === 'down') {
	      date = date + 7;
	    } else if (key === 'pageup' || key === 'pagedown') {
	      var month = this.activeDate.getMonth() + (key === 'pageup' ? -1 : 1);
	      this.activeDate.setMonth(month, 1);
	      date = Math.min(getDaysInMonth(this.activeDate.getFullYear(), this.activeDate.getMonth()), date);
	    } else if (key === 'home') {
	      date = 1;
	    } else if (key === 'end') {
	      date = getDaysInMonth(this.activeDate.getFullYear(), this.activeDate.getMonth());
	    }
	    this.activeDate.setDate(date);
	  };
	}]).controller('UibMonthpickerController', ['$scope', '$element', 'dateFilter', function (scope, $element, dateFilter) {
	  this.step = { years: 1 };
	  this.element = $element;
	
	  this.init = function (ctrl) {
	    angular.extend(ctrl, this);
	    ctrl.refreshView();
	  };
	
	  this._refreshView = function () {
	    var months = new Array(12),
	        year = this.activeDate.getFullYear(),
	        date;
	
	    for (var i = 0; i < 12; i++) {
	      date = new Date(this.activeDate);
	      date.setFullYear(year, i, 1);
	      months[i] = angular.extend(this.createDateObject(date, this.formatMonth), {
	        uid: scope.uniqueId + '-' + i
	      });
	    }
	
	    scope.title = dateFilter(this.activeDate, this.formatMonthTitle);
	    scope.rows = this.split(months, this.monthColumns);
	    scope.yearHeaderColspan = this.monthColumns > 3 ? this.monthColumns - 2 : 1;
	  };
	
	  this.compare = function (date1, date2) {
	    var _date1 = new Date(date1.getFullYear(), date1.getMonth());
	    var _date2 = new Date(date2.getFullYear(), date2.getMonth());
	    _date1.setFullYear(date1.getFullYear());
	    _date2.setFullYear(date2.getFullYear());
	    return _date1 - _date2;
	  };
	
	  this.handleKeyDown = function (key, evt) {
	    var date = this.activeDate.getMonth();
	
	    if (key === 'left') {
	      date = date - 1;
	    } else if (key === 'up') {
	      date = date - this.monthColumns;
	    } else if (key === 'right') {
	      date = date + 1;
	    } else if (key === 'down') {
	      date = date + this.monthColumns;
	    } else if (key === 'pageup' || key === 'pagedown') {
	      var year = this.activeDate.getFullYear() + (key === 'pageup' ? -1 : 1);
	      this.activeDate.setFullYear(year);
	    } else if (key === 'home') {
	      date = 0;
	    } else if (key === 'end') {
	      date = 11;
	    }
	    this.activeDate.setMonth(date);
	  };
	}]).controller('UibYearpickerController', ['$scope', '$element', 'dateFilter', function (scope, $element, dateFilter) {
	  var columns, range;
	  this.element = $element;
	
	  function getStartingYear(year) {
	    return parseInt((year - 1) / range, 10) * range + 1;
	  }
	
	  this.yearpickerInit = function () {
	    columns = this.yearColumns;
	    range = this.yearRows * columns;
	    this.step = { years: range };
	  };
	
	  this._refreshView = function () {
	    var years = new Array(range),
	        date;
	
	    for (var i = 0, start = getStartingYear(this.activeDate.getFullYear()); i < range; i++) {
	      date = new Date(this.activeDate);
	      date.setFullYear(start + i, 0, 1);
	      years[i] = angular.extend(this.createDateObject(date, this.formatYear), {
	        uid: scope.uniqueId + '-' + i
	      });
	    }
	
	    scope.title = [years[0].label, years[range - 1].label].join(' - ');
	    scope.rows = this.split(years, columns);
	    scope.columns = columns;
	  };
	
	  this.compare = function (date1, date2) {
	    return date1.getFullYear() - date2.getFullYear();
	  };
	
	  this.handleKeyDown = function (key, evt) {
	    var date = this.activeDate.getFullYear();
	
	    if (key === 'left') {
	      date = date - 1;
	    } else if (key === 'up') {
	      date = date - columns;
	    } else if (key === 'right') {
	      date = date + 1;
	    } else if (key === 'down') {
	      date = date + columns;
	    } else if (key === 'pageup' || key === 'pagedown') {
	      date += (key === 'pageup' ? -1 : 1) * range;
	    } else if (key === 'home') {
	      date = getStartingYear(this.activeDate.getFullYear());
	    } else if (key === 'end') {
	      date = getStartingYear(this.activeDate.getFullYear()) + range - 1;
	    }
	    this.activeDate.setFullYear(date);
	  };
	}]).directive('uibDatepicker', function () {
	  return {
	    templateUrl: function templateUrl(element, attrs) {
	      return attrs.templateUrl || 'uib/template/datepicker/datepicker.html';
	    },
	    scope: {
	      datepickerOptions: '=?'
	    },
	    require: ['uibDatepicker', '^ngModel'],
	    restrict: 'A',
	    controller: 'UibDatepickerController',
	    controllerAs: 'datepicker',
	    link: function link(scope, element, attrs, ctrls) {
	      var datepickerCtrl = ctrls[0],
	          ngModelCtrl = ctrls[1];
	
	      datepickerCtrl.init(ngModelCtrl);
	    }
	  };
	}).directive('uibDaypicker', function () {
	  return {
	    templateUrl: function templateUrl(element, attrs) {
	      return attrs.templateUrl || 'uib/template/datepicker/day.html';
	    },
	    require: ['^uibDatepicker', 'uibDaypicker'],
	    restrict: 'A',
	    controller: 'UibDaypickerController',
	    link: function link(scope, element, attrs, ctrls) {
	      var datepickerCtrl = ctrls[0],
	          daypickerCtrl = ctrls[1];
	
	      daypickerCtrl.init(datepickerCtrl);
	    }
	  };
	}).directive('uibMonthpicker', function () {
	  return {
	    templateUrl: function templateUrl(element, attrs) {
	      return attrs.templateUrl || 'uib/template/datepicker/month.html';
	    },
	    require: ['^uibDatepicker', 'uibMonthpicker'],
	    restrict: 'A',
	    controller: 'UibMonthpickerController',
	    link: function link(scope, element, attrs, ctrls) {
	      var datepickerCtrl = ctrls[0],
	          monthpickerCtrl = ctrls[1];
	
	      monthpickerCtrl.init(datepickerCtrl);
	    }
	  };
	}).directive('uibYearpicker', function () {
	  return {
	    templateUrl: function templateUrl(element, attrs) {
	      return attrs.templateUrl || 'uib/template/datepicker/year.html';
	    },
	    require: ['^uibDatepicker', 'uibYearpicker'],
	    restrict: 'A',
	    controller: 'UibYearpickerController',
	    link: function link(scope, element, attrs, ctrls) {
	      var ctrl = ctrls[0];
	      angular.extend(ctrl, ctrls[1]);
	      ctrl.yearpickerInit();
	
	      ctrl.refreshView();
	    }
	  };
	});

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(78);
	module.exports = __webpack_require__(81);

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(81);
	__webpack_require__(27);
	__webpack_require__(538);
	__webpack_require__(507);
	
	var MODULE_NAME = 'ui.bootstrap.module.datepickerPopup';
	
	angular.module(MODULE_NAME, ['ui.bootstrap.datepickerPopup', 'uib/template/datepickerPopup/popup.html', 'ui.bootstrap.module.datepicker']);
	
	module.exports = MODULE_NAME;

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(78);
	__webpack_require__(25);
	__webpack_require__(170);
	module.exports = __webpack_require__(505);

/***/ }),
/* 507 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('ui.bootstrap.datepickerPopup', ['ui.bootstrap.datepicker', 'ui.bootstrap.position']).value('$datepickerPopupLiteralWarning', true).constant('uibDatepickerPopupConfig', {
	  altInputFormats: [],
	  appendToBody: false,
	  clearText: 'Clear',
	  closeOnDateSelection: true,
	  closeText: 'Done',
	  currentText: 'Today',
	  datepickerPopup: 'yyyy-MM-dd',
	  datepickerPopupTemplateUrl: 'uib/template/datepickerPopup/popup.html',
	  datepickerTemplateUrl: 'uib/template/datepicker/datepicker.html',
	  html5Types: {
	    date: 'yyyy-MM-dd',
	    'datetime-local': 'yyyy-MM-ddTHH:mm:ss.sss',
	    'month': 'yyyy-MM'
	  },
	  onOpenFocus: true,
	  showButtonBar: true,
	  placement: 'auto bottom-left'
	}).controller('UibDatepickerPopupController', ['$scope', '$element', '$attrs', '$compile', '$log', '$parse', '$window', '$document', '$rootScope', '$uibPosition', 'dateFilter', 'uibDateParser', 'uibDatepickerPopupConfig', '$timeout', 'uibDatepickerConfig', '$datepickerPopupLiteralWarning', function ($scope, $element, $attrs, $compile, $log, $parse, $window, $document, $rootScope, $position, dateFilter, dateParser, datepickerPopupConfig, $timeout, datepickerConfig, $datepickerPopupLiteralWarning) {
	  var cache = {},
	      isHtml5DateInput = false;
	  var dateFormat,
	      closeOnDateSelection,
	      appendToBody,
	      onOpenFocus,
	      datepickerPopupTemplateUrl,
	      datepickerTemplateUrl,
	      popupEl,
	      datepickerEl,
	      scrollParentEl,
	      ngModel,
	      ngModelOptions,
	      $popup,
	      altInputFormats,
	      watchListeners = [];
	
	  this.init = function (_ngModel_) {
	    ngModel = _ngModel_;
	    ngModelOptions = extractOptions(ngModel);
	    closeOnDateSelection = angular.isDefined($attrs.closeOnDateSelection) ? $scope.$parent.$eval($attrs.closeOnDateSelection) : datepickerPopupConfig.closeOnDateSelection;
	    appendToBody = angular.isDefined($attrs.datepickerAppendToBody) ? $scope.$parent.$eval($attrs.datepickerAppendToBody) : datepickerPopupConfig.appendToBody;
	    onOpenFocus = angular.isDefined($attrs.onOpenFocus) ? $scope.$parent.$eval($attrs.onOpenFocus) : datepickerPopupConfig.onOpenFocus;
	    datepickerPopupTemplateUrl = angular.isDefined($attrs.datepickerPopupTemplateUrl) ? $attrs.datepickerPopupTemplateUrl : datepickerPopupConfig.datepickerPopupTemplateUrl;
	    datepickerTemplateUrl = angular.isDefined($attrs.datepickerTemplateUrl) ? $attrs.datepickerTemplateUrl : datepickerPopupConfig.datepickerTemplateUrl;
	    altInputFormats = angular.isDefined($attrs.altInputFormats) ? $scope.$parent.$eval($attrs.altInputFormats) : datepickerPopupConfig.altInputFormats;
	
	    $scope.showButtonBar = angular.isDefined($attrs.showButtonBar) ? $scope.$parent.$eval($attrs.showButtonBar) : datepickerPopupConfig.showButtonBar;
	
	    if (datepickerPopupConfig.html5Types[$attrs.type]) {
	      dateFormat = datepickerPopupConfig.html5Types[$attrs.type];
	      isHtml5DateInput = true;
	    } else {
	      dateFormat = $attrs.uibDatepickerPopup || datepickerPopupConfig.datepickerPopup;
	      $attrs.$observe('uibDatepickerPopup', function (value, oldValue) {
	        var newDateFormat = value || datepickerPopupConfig.datepickerPopup;
	        // Invalidate the $modelValue to ensure that formatters re-run
	        // FIXME: Refactor when PR is merged: https://github.com/angular/angular.js/pull/10764
	        if (newDateFormat !== dateFormat) {
	          dateFormat = newDateFormat;
	          ngModel.$modelValue = null;
	
	          if (!dateFormat) {
	            throw new Error('uibDatepickerPopup must have a date format specified.');
	          }
	        }
	      });
	    }
	
	    if (!dateFormat) {
	      throw new Error('uibDatepickerPopup must have a date format specified.');
	    }
	
	    if (isHtml5DateInput && $attrs.uibDatepickerPopup) {
	      throw new Error('HTML5 date input types do not support custom formats.');
	    }
	
	    // popup element used to display calendar
	    popupEl = angular.element('<div uib-datepicker-popup-wrap><div uib-datepicker></div></div>');
	
	    popupEl.attr({
	      'ng-model': 'date',
	      'ng-change': 'dateSelection(date)',
	      'template-url': datepickerPopupTemplateUrl
	    });
	
	    // datepicker element
	    datepickerEl = angular.element(popupEl.children()[0]);
	    datepickerEl.attr('template-url', datepickerTemplateUrl);
	
	    if (!$scope.datepickerOptions) {
	      $scope.datepickerOptions = {};
	    }
	
	    if (isHtml5DateInput) {
	      if ($attrs.type === 'month') {
	        $scope.datepickerOptions.datepickerMode = 'month';
	        $scope.datepickerOptions.minMode = 'month';
	      }
	    }
	
	    datepickerEl.attr('datepicker-options', 'datepickerOptions');
	
	    if (!isHtml5DateInput) {
	      // Internal API to maintain the correct ng-invalid-[key] class
	      ngModel.$$parserName = 'date';
	      ngModel.$validators.date = validator;
	      ngModel.$parsers.unshift(parseDate);
	      ngModel.$formatters.push(function (value) {
	        if (ngModel.$isEmpty(value)) {
	          $scope.date = value;
	          return value;
	        }
	
	        if (angular.isNumber(value)) {
	          value = new Date(value);
	        }
	
	        $scope.date = dateParser.fromTimezone(value, ngModelOptions.getOption('timezone'));
	
	        return dateParser.filter($scope.date, dateFormat);
	      });
	    } else {
	      ngModel.$formatters.push(function (value) {
	        $scope.date = dateParser.fromTimezone(value, ngModelOptions.getOption('timezone'));
	        return value;
	      });
	    }
	
	    // Detect changes in the view from the text box
	    ngModel.$viewChangeListeners.push(function () {
	      $scope.date = parseDateString(ngModel.$viewValue);
	    });
	
	    $element.on('keydown', inputKeydownBind);
	
	    $popup = $compile(popupEl)($scope);
	    // Prevent jQuery cache memory leak (template is now redundant after linking)
	    popupEl.remove();
	
	    if (appendToBody) {
	      $document.find('body').append($popup);
	    } else {
	      $element.after($popup);
	    }
	
	    $scope.$on('$destroy', function () {
	      if ($scope.isOpen === true) {
	        if (!$rootScope.$$phase) {
	          $scope.$apply(function () {
	            $scope.isOpen = false;
	          });
	        }
	      }
	
	      $popup.remove();
	      $element.off('keydown', inputKeydownBind);
	      $document.off('click', documentClickBind);
	      if (scrollParentEl) {
	        scrollParentEl.off('scroll', positionPopup);
	      }
	      angular.element($window).off('resize', positionPopup);
	
	      //Clear all watch listeners on destroy
	      while (watchListeners.length) {
	        watchListeners.shift()();
	      }
	    });
	  };
	
	  $scope.getText = function (key) {
	    return $scope[key + 'Text'] || datepickerPopupConfig[key + 'Text'];
	  };
	
	  $scope.isDisabled = function (date) {
	    if (date === 'today') {
	      date = dateParser.fromTimezone(new Date(), ngModelOptions.getOption('timezone'));
	    }
	
	    var dates = {};
	    angular.forEach(['minDate', 'maxDate'], function (key) {
	      if (!$scope.datepickerOptions[key]) {
	        dates[key] = null;
	      } else if (angular.isDate($scope.datepickerOptions[key])) {
	        dates[key] = new Date($scope.datepickerOptions[key]);
	      } else {
	        if ($datepickerPopupLiteralWarning) {
	          $log.warn('Literal date support has been deprecated, please switch to date object usage');
	        }
	
	        dates[key] = new Date(dateFilter($scope.datepickerOptions[key], 'medium'));
	      }
	    });
	
	    return $scope.datepickerOptions && dates.minDate && $scope.compare(date, dates.minDate) < 0 || dates.maxDate && $scope.compare(date, dates.maxDate) > 0;
	  };
	
	  $scope.compare = function (date1, date2) {
	    return new Date(date1.getFullYear(), date1.getMonth(), date1.getDate()) - new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
	  };
	
	  // Inner change
	  $scope.dateSelection = function (dt) {
	    $scope.date = dt;
	    var date = $scope.date ? dateParser.filter($scope.date, dateFormat) : null; // Setting to NULL is necessary for form validators to function
	    $element.val(date);
	    ngModel.$setViewValue(date);
	
	    if (closeOnDateSelection) {
	      $scope.isOpen = false;
	      $element[0].focus();
	    }
	  };
	
	  $scope.keydown = function (evt) {
	    if (evt.which === 27) {
	      evt.stopPropagation();
	      $scope.isOpen = false;
	      $element[0].focus();
	    }
	  };
	
	  $scope.select = function (date, evt) {
	    evt.stopPropagation();
	
	    if (date === 'today') {
	      var today = new Date();
	      if (angular.isDate($scope.date)) {
	        date = new Date($scope.date);
	        date.setFullYear(today.getFullYear(), today.getMonth(), today.getDate());
	      } else {
	        date = dateParser.fromTimezone(today, ngModelOptions.getOption('timezone'));
	        date.setHours(0, 0, 0, 0);
	      }
	    }
	    $scope.dateSelection(date);
	  };
	
	  $scope.close = function (evt) {
	    evt.stopPropagation();
	
	    $scope.isOpen = false;
	    $element[0].focus();
	  };
	
	  $scope.disabled = angular.isDefined($attrs.disabled) || false;
	  if ($attrs.ngDisabled) {
	    watchListeners.push($scope.$parent.$watch($parse($attrs.ngDisabled), function (disabled) {
	      $scope.disabled = disabled;
	    }));
	  }
	
	  $scope.$watch('isOpen', function (value) {
	    if (value) {
	      if (!$scope.disabled) {
	        $timeout(function () {
	          positionPopup();
	
	          if (onOpenFocus) {
	            $scope.$broadcast('uib:datepicker.focus');
	          }
	
	          $document.on('click', documentClickBind);
	
	          var placement = $attrs.popupPlacement ? $attrs.popupPlacement : datepickerPopupConfig.placement;
	          if (appendToBody || $position.parsePlacement(placement)[2]) {
	            scrollParentEl = scrollParentEl || angular.element($position.scrollParent($element));
	            if (scrollParentEl) {
	              scrollParentEl.on('scroll', positionPopup);
	            }
	          } else {
	            scrollParentEl = null;
	          }
	
	          angular.element($window).on('resize', positionPopup);
	        }, 0, false);
	      } else {
	        $scope.isOpen = false;
	      }
	    } else {
	      $document.off('click', documentClickBind);
	      if (scrollParentEl) {
	        scrollParentEl.off('scroll', positionPopup);
	      }
	      angular.element($window).off('resize', positionPopup);
	    }
	  });
	
	  function cameltoDash(string) {
	    return string.replace(/([A-Z])/g, function ($1) {
	      return '-' + $1.toLowerCase();
	    });
	  }
	
	  function parseDateString(viewValue) {
	    var date = dateParser.parse(viewValue, dateFormat, $scope.date);
	    if (isNaN(date)) {
	      for (var i = 0; i < altInputFormats.length; i++) {
	        date = dateParser.parse(viewValue, altInputFormats[i], $scope.date);
	        if (!isNaN(date)) {
	          return date;
	        }
	      }
	    }
	    return date;
	  }
	
	  function parseDate(viewValue) {
	    if (angular.isNumber(viewValue)) {
	      // presumably timestamp to date object
	      viewValue = new Date(viewValue);
	    }
	
	    if (!viewValue) {
	      return null;
	    }
	
	    if (angular.isDate(viewValue) && !isNaN(viewValue)) {
	      return viewValue;
	    }
	
	    if (angular.isString(viewValue)) {
	      var date = parseDateString(viewValue);
	      if (!isNaN(date)) {
	        return dateParser.toTimezone(date, ngModelOptions.getOption('timezone'));
	      }
	    }
	
	    return ngModelOptions.getOption('allowInvalid') ? viewValue : undefined;
	  }
	
	  function validator(modelValue, viewValue) {
	    var value = modelValue || viewValue;
	
	    if (!$attrs.ngRequired && !value) {
	      return true;
	    }
	
	    if (angular.isNumber(value)) {
	      value = new Date(value);
	    }
	
	    if (!value) {
	      return true;
	    }
	
	    if (angular.isDate(value) && !isNaN(value)) {
	      return true;
	    }
	
	    if (angular.isString(value)) {
	      return !isNaN(parseDateString(value));
	    }
	
	    return false;
	  }
	
	  function documentClickBind(event) {
	    if (!$scope.isOpen && $scope.disabled) {
	      return;
	    }
	
	    var popup = $popup[0];
	    var dpContainsTarget = $element[0].contains(event.target);
	    // The popup node may not be an element node
	    // In some browsers (IE) only element nodes have the 'contains' function
	    var popupContainsTarget = popup.contains !== undefined && popup.contains(event.target);
	    if ($scope.isOpen && !(dpContainsTarget || popupContainsTarget)) {
	      $scope.$apply(function () {
	        $scope.isOpen = false;
	      });
	    }
	  }
	
	  function inputKeydownBind(evt) {
	    if (evt.which === 27 && $scope.isOpen) {
	      evt.preventDefault();
	      evt.stopPropagation();
	      $scope.$apply(function () {
	        $scope.isOpen = false;
	      });
	      $element[0].focus();
	    } else if (evt.which === 40 && !$scope.isOpen) {
	      evt.preventDefault();
	      evt.stopPropagation();
	      $scope.$apply(function () {
	        $scope.isOpen = true;
	      });
	    }
	  }
	
	  function positionPopup() {
	    if ($scope.isOpen) {
	      var dpElement = angular.element($popup[0].querySelector('.uib-datepicker-popup'));
	      var placement = $attrs.popupPlacement ? $attrs.popupPlacement : datepickerPopupConfig.placement;
	      var position = $position.positionElements($element, dpElement, placement, appendToBody);
	      dpElement.css({ top: position.top + 'px', left: position.left + 'px' });
	      if (dpElement.hasClass('uib-position-measure')) {
	        dpElement.removeClass('uib-position-measure');
	      }
	    }
	  }
	
	  function extractOptions(ngModelCtrl) {
	    var ngModelOptions;
	
	    if (angular.version.minor < 6) {
	      // in angular < 1.6 $options could be missing
	      // guarantee a value
	      ngModelOptions = angular.isObject(ngModelCtrl.$options) ? ngModelCtrl.$options : {
	        timezone: null
	      };
	
	      // mimic 1.6+ api
	      ngModelOptions.getOption = function (key) {
	        return ngModelOptions[key];
	      };
	    } else {
	      // in angular >=1.6 $options is always present
	      ngModelOptions = ngModelCtrl.$options;
	    }
	
	    return ngModelOptions;
	  }
	
	  $scope.$on('uib:datepicker.mode', function () {
	    $timeout(positionPopup, 0, false);
	  });
	}]).directive('uibDatepickerPopup', function () {
	  return {
	    require: ['ngModel', 'uibDatepickerPopup'],
	    controller: 'UibDatepickerPopupController',
	    scope: {
	      datepickerOptions: '=?',
	      isOpen: '=?',
	      currentText: '@',
	      clearText: '@',
	      closeText: '@'
	    },
	    link: function link(scope, element, attrs, ctrls) {
	      var ngModel = ctrls[0],
	          ctrl = ctrls[1];
	
	      ctrl.init(ngModel);
	    }
	  };
	}).directive('uibDatepickerPopupWrap', function () {
	  return {
	    restrict: 'A',
	    transclude: true,
	    templateUrl: function templateUrl(element, attrs) {
	      return attrs.templateUrl || 'uib/template/datepickerPopup/popup.html';
	    }
	  };
	});

/***/ }),
/* 508 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('ui.bootstrap.dropdown', ['ui.bootstrap.multiMap', 'ui.bootstrap.position']).constant('uibDropdownConfig', {
	  appendToOpenClass: 'uib-dropdown-open',
	  openClass: 'open'
	}).service('uibDropdownService', ['$document', '$rootScope', '$$multiMap', function ($document, $rootScope, $$multiMap) {
	  var openScope = null;
	  var openedContainers = $$multiMap.createNew();
	
	  this.isOnlyOpen = function (dropdownScope, appendTo) {
	    var openedDropdowns = openedContainers.get(appendTo);
	    if (openedDropdowns) {
	      var openDropdown = openedDropdowns.reduce(function (toClose, dropdown) {
	        if (dropdown.scope === dropdownScope) {
	          return dropdown;
	        }
	
	        return toClose;
	      }, {});
	      if (openDropdown) {
	        return openedDropdowns.length === 1;
	      }
	    }
	
	    return false;
	  };
	
	  this.open = function (dropdownScope, element, appendTo) {
	    if (!openScope) {
	      $document.on('click', closeDropdown);
	    }
	
	    if (openScope && openScope !== dropdownScope) {
	      openScope.isOpen = false;
	    }
	
	    openScope = dropdownScope;
	
	    if (!appendTo) {
	      return;
	    }
	
	    var openedDropdowns = openedContainers.get(appendTo);
	    if (openedDropdowns) {
	      var openedScopes = openedDropdowns.map(function (dropdown) {
	        return dropdown.scope;
	      });
	      if (openedScopes.indexOf(dropdownScope) === -1) {
	        openedContainers.put(appendTo, {
	          scope: dropdownScope
	        });
	      }
	    } else {
	      openedContainers.put(appendTo, {
	        scope: dropdownScope
	      });
	    }
	  };
	
	  this.close = function (dropdownScope, element, appendTo) {
	    if (openScope === dropdownScope) {
	      $document.off('click', closeDropdown);
	      $document.off('keydown', this.keybindFilter);
	      openScope = null;
	    }
	
	    if (!appendTo) {
	      return;
	    }
	
	    var openedDropdowns = openedContainers.get(appendTo);
	    if (openedDropdowns) {
	      var dropdownToClose = openedDropdowns.reduce(function (toClose, dropdown) {
	        if (dropdown.scope === dropdownScope) {
	          return dropdown;
	        }
	
	        return toClose;
	      }, {});
	      if (dropdownToClose) {
	        openedContainers.remove(appendTo, dropdownToClose);
	      }
	    }
	  };
	
	  var closeDropdown = function closeDropdown(evt) {
	    // This method may still be called during the same mouse event that
	    // unbound this event handler. So check openScope before proceeding.
	    if (!openScope || !openScope.isOpen) {
	      return;
	    }
	
	    if (evt && openScope.getAutoClose() === 'disabled') {
	      return;
	    }
	
	    if (evt && evt.which === 3) {
	      return;
	    }
	
	    var toggleElement = openScope.getToggleElement();
	    if (evt && toggleElement && toggleElement[0].contains(evt.target)) {
	      return;
	    }
	
	    var dropdownElement = openScope.getDropdownElement();
	    if (evt && openScope.getAutoClose() === 'outsideClick' && dropdownElement && dropdownElement[0].contains(evt.target)) {
	      return;
	    }
	
	    openScope.focusToggleElement();
	    openScope.isOpen = false;
	
	    if (!$rootScope.$$phase) {
	      openScope.$apply();
	    }
	  };
	
	  this.keybindFilter = function (evt) {
	    if (!openScope) {
	      // see this.close as ESC could have been pressed which kills the scope so we can not proceed
	      return;
	    }
	
	    var dropdownElement = openScope.getDropdownElement();
	    var toggleElement = openScope.getToggleElement();
	    var dropdownElementTargeted = dropdownElement && dropdownElement[0].contains(evt.target);
	    var toggleElementTargeted = toggleElement && toggleElement[0].contains(evt.target);
	    if (evt.which === 27) {
	      evt.stopPropagation();
	      openScope.focusToggleElement();
	      closeDropdown();
	    } else if (openScope.isKeynavEnabled() && [38, 40].indexOf(evt.which) !== -1 && openScope.isOpen && (dropdownElementTargeted || toggleElementTargeted)) {
	      evt.preventDefault();
	      evt.stopPropagation();
	      openScope.focusDropdownEntry(evt.which);
	    }
	  };
	}]).controller('UibDropdownController', ['$scope', '$element', '$attrs', '$parse', 'uibDropdownConfig', 'uibDropdownService', '$animate', '$uibPosition', '$document', '$compile', '$templateRequest', function ($scope, $element, $attrs, $parse, dropdownConfig, uibDropdownService, $animate, $position, $document, $compile, $templateRequest) {
	  var self = this,
	      scope = $scope.$new(),
	      // create a child scope so we are not polluting original one
	  templateScope,
	      appendToOpenClass = dropdownConfig.appendToOpenClass,
	      openClass = dropdownConfig.openClass,
	      getIsOpen,
	      setIsOpen = angular.noop,
	      toggleInvoker = $attrs.onToggle ? $parse($attrs.onToggle) : angular.noop,
	      keynavEnabled = false,
	      selectedOption = null,
	      body = $document.find('body');
	
	  $element.addClass('dropdown');
	
	  this.init = function () {
	    if ($attrs.isOpen) {
	      getIsOpen = $parse($attrs.isOpen);
	      setIsOpen = getIsOpen.assign;
	
	      $scope.$watch(getIsOpen, function (value) {
	        scope.isOpen = !!value;
	      });
	    }
	
	    keynavEnabled = angular.isDefined($attrs.keyboardNav);
	  };
	
	  this.toggle = function (open) {
	    scope.isOpen = arguments.length ? !!open : !scope.isOpen;
	    if (angular.isFunction(setIsOpen)) {
	      setIsOpen(scope, scope.isOpen);
	    }
	
	    return scope.isOpen;
	  };
	
	  // Allow other directives to watch status
	  this.isOpen = function () {
	    return scope.isOpen;
	  };
	
	  scope.getToggleElement = function () {
	    return self.toggleElement;
	  };
	
	  scope.getAutoClose = function () {
	    return $attrs.autoClose || 'always'; //or 'outsideClick' or 'disabled'
	  };
	
	  scope.getElement = function () {
	    return $element;
	  };
	
	  scope.isKeynavEnabled = function () {
	    return keynavEnabled;
	  };
	
	  scope.focusDropdownEntry = function (keyCode) {
	    var elems = self.dropdownMenu ? //If append to body is used.
	    angular.element(self.dropdownMenu).find('a') : $element.find('ul').eq(0).find('a');
	
	    switch (keyCode) {
	      case 40:
	        {
	          if (!angular.isNumber(self.selectedOption)) {
	            self.selectedOption = 0;
	          } else {
	            self.selectedOption = self.selectedOption === elems.length - 1 ? self.selectedOption : self.selectedOption + 1;
	          }
	          break;
	        }
	      case 38:
	        {
	          if (!angular.isNumber(self.selectedOption)) {
	            self.selectedOption = elems.length - 1;
	          } else {
	            self.selectedOption = self.selectedOption === 0 ? 0 : self.selectedOption - 1;
	          }
	          break;
	        }
	    }
	    elems[self.selectedOption].focus();
	  };
	
	  scope.getDropdownElement = function () {
	    return self.dropdownMenu;
	  };
	
	  scope.focusToggleElement = function () {
	    if (self.toggleElement) {
	      self.toggleElement[0].focus();
	    }
	  };
	
	  function removeDropdownMenu() {
	    $element.append(self.dropdownMenu);
	  }
	
	  scope.$watch('isOpen', function (isOpen, wasOpen) {
	    var appendTo = null,
	        appendToBody = false;
	
	    if (angular.isDefined($attrs.dropdownAppendTo)) {
	      var appendToEl = $parse($attrs.dropdownAppendTo)(scope);
	      if (appendToEl) {
	        appendTo = angular.element(appendToEl);
	      }
	    }
	
	    if (angular.isDefined($attrs.dropdownAppendToBody)) {
	      var appendToBodyValue = $parse($attrs.dropdownAppendToBody)(scope);
	      if (appendToBodyValue !== false) {
	        appendToBody = true;
	      }
	    }
	
	    if (appendToBody && !appendTo) {
	      appendTo = body;
	    }
	
	    if (appendTo && self.dropdownMenu) {
	      if (isOpen) {
	        appendTo.append(self.dropdownMenu);
	        $element.on('$destroy', removeDropdownMenu);
	      } else {
	        $element.off('$destroy', removeDropdownMenu);
	        removeDropdownMenu();
	      }
	    }
	
	    if (appendTo && self.dropdownMenu) {
	      var pos = $position.positionElements($element, self.dropdownMenu, 'bottom-left', true),
	          css,
	          rightalign,
	          scrollbarPadding,
	          scrollbarWidth = 0;
	
	      css = {
	        top: pos.top + 'px',
	        display: isOpen ? 'block' : 'none'
	      };
	
	      rightalign = self.dropdownMenu.hasClass('dropdown-menu-right');
	      if (!rightalign) {
	        css.left = pos.left + 'px';
	        css.right = 'auto';
	      } else {
	        css.left = 'auto';
	        scrollbarPadding = $position.scrollbarPadding(appendTo);
	
	        if (scrollbarPadding.heightOverflow && scrollbarPadding.scrollbarWidth) {
	          scrollbarWidth = scrollbarPadding.scrollbarWidth;
	        }
	
	        css.right = window.innerWidth - scrollbarWidth - (pos.left + $element.prop('offsetWidth')) + 'px';
	      }
	
	      // Need to adjust our positioning to be relative to the appendTo container
	      // if it's not the body element
	      if (!appendToBody) {
	        var appendOffset = $position.offset(appendTo);
	
	        css.top = pos.top - appendOffset.top + 'px';
	
	        if (!rightalign) {
	          css.left = pos.left - appendOffset.left + 'px';
	        } else {
	          css.right = window.innerWidth - (pos.left - appendOffset.left + $element.prop('offsetWidth')) + 'px';
	        }
	      }
	
	      self.dropdownMenu.css(css);
	    }
	
	    var openContainer = appendTo ? appendTo : $element;
	    var dropdownOpenClass = appendTo ? appendToOpenClass : openClass;
	    var hasOpenClass = openContainer.hasClass(dropdownOpenClass);
	    var isOnlyOpen = uibDropdownService.isOnlyOpen($scope, appendTo);
	
	    if (hasOpenClass === !isOpen) {
	      var toggleClass;
	      if (appendTo) {
	        toggleClass = !isOnlyOpen ? 'addClass' : 'removeClass';
	      } else {
	        toggleClass = isOpen ? 'addClass' : 'removeClass';
	      }
	      $animate[toggleClass](openContainer, dropdownOpenClass).then(function () {
	        if (angular.isDefined(isOpen) && isOpen !== wasOpen) {
	          toggleInvoker($scope, { open: !!isOpen });
	        }
	      });
	    }
	
	    if (isOpen) {
	      if (self.dropdownMenuTemplateUrl) {
	        $templateRequest(self.dropdownMenuTemplateUrl).then(function (tplContent) {
	          templateScope = scope.$new();
	          $compile(tplContent.trim())(templateScope, function (dropdownElement) {
	            var newEl = dropdownElement;
	            self.dropdownMenu.replaceWith(newEl);
	            self.dropdownMenu = newEl;
	            $document.on('keydown', uibDropdownService.keybindFilter);
	          });
	        });
	      } else {
	        $document.on('keydown', uibDropdownService.keybindFilter);
	      }
	
	      scope.focusToggleElement();
	      uibDropdownService.open(scope, $element, appendTo);
	    } else {
	      uibDropdownService.close(scope, $element, appendTo);
	      if (self.dropdownMenuTemplateUrl) {
	        if (templateScope) {
	          templateScope.$destroy();
	        }
	        var newEl = angular.element('<ul class="dropdown-menu"></ul>');
	        self.dropdownMenu.replaceWith(newEl);
	        self.dropdownMenu = newEl;
	      }
	
	      self.selectedOption = null;
	    }
	
	    if (angular.isFunction(setIsOpen)) {
	      setIsOpen($scope, isOpen);
	    }
	  });
	}]).directive('uibDropdown', function () {
	  return {
	    controller: 'UibDropdownController',
	    link: function link(scope, element, attrs, dropdownCtrl) {
	      dropdownCtrl.init();
	    }
	  };
	}).directive('uibDropdownMenu', function () {
	  return {
	    restrict: 'A',
	    require: '?^uibDropdown',
	    link: function link(scope, element, attrs, dropdownCtrl) {
	      if (!dropdownCtrl || angular.isDefined(attrs.dropdownNested)) {
	        return;
	      }
	
	      element.addClass('dropdown-menu');
	
	      var tplUrl = attrs.templateUrl;
	      if (tplUrl) {
	        dropdownCtrl.dropdownMenuTemplateUrl = tplUrl;
	      }
	
	      if (!dropdownCtrl.dropdownMenu) {
	        dropdownCtrl.dropdownMenu = element;
	      }
	    }
	  };
	}).directive('uibDropdownToggle', function () {
	  return {
	    require: '?^uibDropdown',
	    link: function link(scope, element, attrs, dropdownCtrl) {
	      if (!dropdownCtrl) {
	        return;
	      }
	
	      element.addClass('dropdown-toggle');
	
	      dropdownCtrl.toggleElement = element;
	
	      var toggleDropdown = function toggleDropdown(event) {
	        event.preventDefault();
	
	        if (!element.hasClass('disabled') && !attrs.disabled) {
	          scope.$apply(function () {
	            dropdownCtrl.toggle();
	          });
	        }
	      };
	
	      element.on('click', toggleDropdown);
	
	      // WAI-ARIA
	      element.attr({ 'aria-haspopup': true, 'aria-expanded': false });
	      scope.$watch(dropdownCtrl.isOpen, function (isOpen) {
	        element.attr('aria-expanded', !!isOpen);
	      });
	
	      scope.$on('$destroy', function () {
	        element.off('click', toggleDropdown);
	      });
	    }
	  };
	});

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(82);
	__webpack_require__(27);
	__webpack_require__(508);
	
	var MODULE_NAME = 'ui.bootstrap.module.dropdown';
	
	angular.module(MODULE_NAME, ['ui.bootstrap.dropdown']);
	
	module.exports = MODULE_NAME;

/***/ }),
/* 510 */
[692, 509],
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(512);
	
	var MODULE_NAME = 'ui.bootstrap.module.isClass';
	
	angular.module(MODULE_NAME, ['ui.bootstrap.isClass']);
	
	module.exports = MODULE_NAME;

/***/ }),
/* 512 */
/***/ (function(module, exports) {

	'use strict';
	
	// Avoiding use of ng-class as it creates a lot of watchers when a class is to be applied to
	// at most one element.
	angular.module('ui.bootstrap.isClass', []).directive('uibIsClass', ['$animate', function ($animate) {
	  //                    11111111          22222222
	  var ON_REGEXP = /^\s*([\s\S]+?)\s+on\s+([\s\S]+?)\s*$/;
	  //                    11111111           22222222
	  var IS_REGEXP = /^\s*([\s\S]+?)\s+for\s+([\s\S]+?)\s*$/;
	
	  var dataPerTracked = {};
	
	  return {
	    restrict: 'A',
	    compile: function compile(tElement, tAttrs) {
	      var linkedScopes = [];
	      var instances = [];
	      var expToData = {};
	      var lastActivated = null;
	      var onExpMatches = tAttrs.uibIsClass.match(ON_REGEXP);
	      var onExp = onExpMatches[2];
	      var expsStr = onExpMatches[1];
	      var exps = expsStr.split(',');
	
	      return linkFn;
	
	      function linkFn(scope, element, attrs) {
	        linkedScopes.push(scope);
	        instances.push({
	          scope: scope,
	          element: element
	        });
	
	        exps.forEach(function (exp, k) {
	          addForExp(exp, scope);
	        });
	
	        scope.$on('$destroy', removeScope);
	      }
	
	      function addForExp(exp, scope) {
	        var matches = exp.match(IS_REGEXP);
	        var clazz = scope.$eval(matches[1]);
	        var compareWithExp = matches[2];
	        var data = expToData[exp];
	        if (!data) {
	          var watchFn = function watchFn(compareWithVal) {
	            var newActivated = null;
	            instances.some(function (instance) {
	              var thisVal = instance.scope.$eval(onExp);
	              if (thisVal === compareWithVal) {
	                newActivated = instance;
	                return true;
	              }
	            });
	            if (data.lastActivated !== newActivated) {
	              if (data.lastActivated) {
	                $animate.removeClass(data.lastActivated.element, clazz);
	              }
	              if (newActivated) {
	                $animate.addClass(newActivated.element, clazz);
	              }
	              data.lastActivated = newActivated;
	            }
	          };
	          expToData[exp] = data = {
	            lastActivated: null,
	            scope: scope,
	            watchFn: watchFn,
	            compareWithExp: compareWithExp,
	            watcher: scope.$watch(compareWithExp, watchFn)
	          };
	        }
	        data.watchFn(scope.$eval(compareWithExp));
	      }
	
	      function removeScope(e) {
	        var removedScope = e.targetScope;
	        var index = linkedScopes.indexOf(removedScope);
	        linkedScopes.splice(index, 1);
	        instances.splice(index, 1);
	        if (linkedScopes.length) {
	          var newWatchScope = linkedScopes[0];
	          angular.forEach(expToData, function (data) {
	            if (data.scope === removedScope) {
	              data.watcher = newWatchScope.$watch(data.compareWithExp, data.watchFn);
	              data.scope = newWatchScope;
	            }
	          });
	        } else {
	          expToData = {};
	        }
	      }
	    }
	  };
	}]);

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(82);
	__webpack_require__(27);
	__webpack_require__(83);
	__webpack_require__(539);
	__webpack_require__(515);
	
	var MODULE_NAME = 'ui.bootstrap.module.modal';
	
	angular.module(MODULE_NAME, ['ui.bootstrap.modal', 'uib/template/modal/window.html']);
	
	module.exports = MODULE_NAME;

/***/ }),
/* 514 */
[692, 513],
/* 515 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('ui.bootstrap.modal', ['ui.bootstrap.multiMap', 'ui.bootstrap.stackedMap', 'ui.bootstrap.position'])
	/**
	 * Pluggable resolve mechanism for the modal resolve resolution
	 * Supports UI Router's $resolve service
	 */
	.provider('$uibResolve', function () {
	  var resolve = this;
	  this.resolver = null;
	
	  this.setResolver = function (resolver) {
	    this.resolver = resolver;
	  };
	
	  this.$get = ['$injector', '$q', function ($injector, $q) {
	    var resolver = resolve.resolver ? $injector.get(resolve.resolver) : null;
	    return {
	      resolve: function resolve(invocables, locals, parent, self) {
	        if (resolver) {
	          return resolver.resolve(invocables, locals, parent, self);
	        }
	
	        var promises = [];
	
	        angular.forEach(invocables, function (value) {
	          if (angular.isFunction(value) || angular.isArray(value)) {
	            promises.push($q.resolve($injector.invoke(value)));
	          } else if (angular.isString(value)) {
	            promises.push($q.resolve($injector.get(value)));
	          } else {
	            promises.push($q.resolve(value));
	          }
	        });
	
	        return $q.all(promises).then(function (resolves) {
	          var resolveObj = {};
	          var resolveIter = 0;
	          angular.forEach(invocables, function (value, key) {
	            resolveObj[key] = resolves[resolveIter++];
	          });
	
	          return resolveObj;
	        });
	      }
	    };
	  }];
	})
	
	/**
	 * A helper directive for the $modal service. It creates a backdrop element.
	 */
	.directive('uibModalBackdrop', ['$animate', '$injector', '$uibModalStack', function ($animate, $injector, $modalStack) {
	  return {
	    restrict: 'A',
	    compile: function compile(tElement, tAttrs) {
	      tElement.addClass(tAttrs.backdropClass);
	      return linkFn;
	    }
	  };
	
	  function linkFn(scope, element, attrs) {
	    if (attrs.modalInClass) {
	      $animate.addClass(element, attrs.modalInClass);
	
	      scope.$on($modalStack.NOW_CLOSING_EVENT, function (e, setIsAsync) {
	        var done = setIsAsync();
	        if (scope.modalOptions.animation) {
	          $animate.removeClass(element, attrs.modalInClass).then(done);
	        } else {
	          done();
	        }
	      });
	    }
	  }
	}]).directive('uibModalWindow', ['$uibModalStack', '$q', '$animateCss', '$document', function ($modalStack, $q, $animateCss, $document) {
	  return {
	    scope: {
	      index: '@'
	    },
	    restrict: 'A',
	    transclude: true,
	    templateUrl: function templateUrl(tElement, tAttrs) {
	      return tAttrs.templateUrl || 'uib/template/modal/window.html';
	    },
	    link: function link(scope, element, attrs) {
	      element.addClass(attrs.windowTopClass || '');
	      scope.size = attrs.size;
	
	      scope.close = function (evt) {
	        var modal = $modalStack.getTop();
	        if (modal && modal.value.backdrop && modal.value.backdrop !== 'static' && evt.target === evt.currentTarget) {
	          evt.preventDefault();
	          evt.stopPropagation();
	          $modalStack.dismiss(modal.key, 'backdrop click');
	        }
	      };
	
	      // moved from template to fix issue #2280
	      element.on('click', scope.close);
	
	      // This property is only added to the scope for the purpose of detecting when this directive is rendered.
	      // We can detect that by using this property in the template associated with this directive and then use
	      // {@link Attribute#$observe} on it. For more details please see {@link TableColumnResize}.
	      scope.$isRendered = true;
	
	      // Deferred object that will be resolved when this modal is rendered.
	      var modalRenderDeferObj = $q.defer();
	      // Resolve render promise post-digest
	      scope.$$postDigest(function () {
	        modalRenderDeferObj.resolve();
	      });
	
	      modalRenderDeferObj.promise.then(function () {
	        var animationPromise = null;
	
	        if (attrs.modalInClass) {
	          animationPromise = $animateCss(element, {
	            addClass: attrs.modalInClass
	          }).start();
	
	          scope.$on($modalStack.NOW_CLOSING_EVENT, function (e, setIsAsync) {
	            var done = setIsAsync();
	            $animateCss(element, {
	              removeClass: attrs.modalInClass
	            }).start().then(done);
	          });
	        }
	
	        $q.when(animationPromise).then(function () {
	          // Notify {@link $modalStack} that modal is rendered.
	          var modal = $modalStack.getTop();
	          if (modal) {
	            $modalStack.modalRendered(modal.key);
	          }
	
	          /**
	           * If something within the freshly-opened modal already has focus (perhaps via a
	           * directive that causes focus) then there's no need to try to focus anything.
	           */
	          if (!($document[0].activeElement && element[0].contains($document[0].activeElement))) {
	            var inputWithAutofocus = element[0].querySelector('[autofocus]');
	            /**
	             * Auto-focusing of a freshly-opened modal element causes any child elements
	             * with the autofocus attribute to lose focus. This is an issue on touch
	             * based devices which will show and then hide the onscreen keyboard.
	             * Attempts to refocus the autofocus element via JavaScript will not reopen
	             * the onscreen keyboard. Fixed by updated the focusing logic to only autofocus
	             * the modal element if the modal does not contain an autofocus element.
	             */
	            if (inputWithAutofocus) {
	              inputWithAutofocus.focus();
	            } else {
	              element[0].focus();
	            }
	          }
	        });
	      });
	    }
	  };
	}]).directive('uibModalAnimationClass', function () {
	  return {
	    compile: function compile(tElement, tAttrs) {
	      if (tAttrs.modalAnimation) {
	        tElement.addClass(tAttrs.uibModalAnimationClass);
	      }
	    }
	  };
	}).directive('uibModalTransclude', ['$animate', function ($animate) {
	  return {
	    link: function link(scope, element, attrs, controller, transclude) {
	      transclude(scope.$parent, function (clone) {
	        element.empty();
	        $animate.enter(clone, element);
	      });
	    }
	  };
	}]).factory('$uibModalStack', ['$animate', '$animateCss', '$document', '$compile', '$rootScope', '$q', '$$multiMap', '$$stackedMap', '$uibPosition', function ($animate, $animateCss, $document, $compile, $rootScope, $q, $$multiMap, $$stackedMap, $uibPosition) {
	  var OPENED_MODAL_CLASS = 'modal-open';
	
	  var backdropDomEl, backdropScope;
	  var openedWindows = $$stackedMap.createNew();
	  var openedClasses = $$multiMap.createNew();
	  var $modalStack = {
	    NOW_CLOSING_EVENT: 'modal.stack.now-closing'
	  };
	  var topModalIndex = 0;
	  var previousTopOpenedModal = null;
	  var ARIA_HIDDEN_ATTRIBUTE_NAME = 'data-bootstrap-modal-aria-hidden-count';
	
	  //Modal focus behavior
	  var tabbableSelector = 'a[href], area[href], input:not([disabled]):not([tabindex=\'-1\']), ' + 'button:not([disabled]):not([tabindex=\'-1\']),select:not([disabled]):not([tabindex=\'-1\']), textarea:not([disabled]):not([tabindex=\'-1\']), ' + 'iframe, object, embed, *[tabindex]:not([tabindex=\'-1\']), *[contenteditable=true]';
	  var scrollbarPadding;
	  var SNAKE_CASE_REGEXP = /[A-Z]/g;
	
	  // TODO: extract into common dependency with tooltip
	  function snake_case(name) {
	    var separator = '-';
	    return name.replace(SNAKE_CASE_REGEXP, function (letter, pos) {
	      return (pos ? separator : '') + letter.toLowerCase();
	    });
	  }
	
	  function isVisible(element) {
	    return !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
	  }
	
	  function backdropIndex() {
	    var topBackdropIndex = -1;
	    var opened = openedWindows.keys();
	    for (var i = 0; i < opened.length; i++) {
	      if (openedWindows.get(opened[i]).value.backdrop) {
	        topBackdropIndex = i;
	      }
	    }
	
	    // If any backdrop exist, ensure that it's index is always
	    // right below the top modal
	    if (topBackdropIndex > -1 && topBackdropIndex < topModalIndex) {
	      topBackdropIndex = topModalIndex;
	    }
	    return topBackdropIndex;
	  }
	
	  $rootScope.$watch(backdropIndex, function (newBackdropIndex) {
	    if (backdropScope) {
	      backdropScope.index = newBackdropIndex;
	    }
	  });
	
	  function removeModalWindow(modalInstance, elementToReceiveFocus) {
	    var modalWindow = openedWindows.get(modalInstance).value;
	    var appendToElement = modalWindow.appendTo;
	
	    //clean up the stack
	    openedWindows.remove(modalInstance);
	    previousTopOpenedModal = openedWindows.top();
	    if (previousTopOpenedModal) {
	      topModalIndex = parseInt(previousTopOpenedModal.value.modalDomEl.attr('index'), 10);
	    }
	
	    removeAfterAnimate(modalWindow.modalDomEl, modalWindow.modalScope, function () {
	      var modalBodyClass = modalWindow.openedClass || OPENED_MODAL_CLASS;
	      openedClasses.remove(modalBodyClass, modalInstance);
	      var areAnyOpen = openedClasses.hasKey(modalBodyClass);
	      appendToElement.toggleClass(modalBodyClass, areAnyOpen);
	      if (!areAnyOpen && scrollbarPadding && scrollbarPadding.heightOverflow && scrollbarPadding.scrollbarWidth) {
	        if (scrollbarPadding.originalRight) {
	          appendToElement.css({ paddingRight: scrollbarPadding.originalRight + 'px' });
	        } else {
	          appendToElement.css({ paddingRight: '' });
	        }
	        scrollbarPadding = null;
	      }
	      toggleTopWindowClass(true);
	    }, modalWindow.closedDeferred);
	    checkRemoveBackdrop();
	
	    //move focus to specified element if available, or else to body
	    if (elementToReceiveFocus && elementToReceiveFocus.focus) {
	      elementToReceiveFocus.focus();
	    } else if (appendToElement.focus) {
	      appendToElement.focus();
	    }
	  }
	
	  // Add or remove "windowTopClass" from the top window in the stack
	  function toggleTopWindowClass(toggleSwitch) {
	    var modalWindow;
	
	    if (openedWindows.length() > 0) {
	      modalWindow = openedWindows.top().value;
	      modalWindow.modalDomEl.toggleClass(modalWindow.windowTopClass || '', toggleSwitch);
	    }
	  }
	
	  function checkRemoveBackdrop() {
	    //remove backdrop if no longer needed
	    if (backdropDomEl && backdropIndex() === -1) {
	      var backdropScopeRef = backdropScope;
	      removeAfterAnimate(backdropDomEl, backdropScope, function () {
	        backdropScopeRef = null;
	      });
	      backdropDomEl = undefined;
	      backdropScope = undefined;
	    }
	  }
	
	  function removeAfterAnimate(domEl, scope, done, closedDeferred) {
	    var asyncDeferred;
	    var asyncPromise = null;
	    var setIsAsync = function setIsAsync() {
	      if (!asyncDeferred) {
	        asyncDeferred = $q.defer();
	        asyncPromise = asyncDeferred.promise;
	      }
	
	      return function asyncDone() {
	        asyncDeferred.resolve();
	      };
	    };
	    scope.$broadcast($modalStack.NOW_CLOSING_EVENT, setIsAsync);
	
	    // Note that it's intentional that asyncPromise might be null.
	    // That's when setIsAsync has not been called during the
	    // NOW_CLOSING_EVENT broadcast.
	    return $q.when(asyncPromise).then(afterAnimating);
	
	    function afterAnimating() {
	      if (afterAnimating.done) {
	        return;
	      }
	      afterAnimating.done = true;
	
	      $animate.leave(domEl).then(function () {
	        if (done) {
	          done();
	        }
	
	        domEl.remove();
	        if (closedDeferred) {
	          closedDeferred.resolve();
	        }
	      });
	
	      scope.$destroy();
	    }
	  }
	
	  $document.on('keydown', keydownListener);
	
	  $rootScope.$on('$destroy', function () {
	    $document.off('keydown', keydownListener);
	  });
	
	  function keydownListener(evt) {
	    if (evt.isDefaultPrevented()) {
	      return evt;
	    }
	
	    var modal = openedWindows.top();
	    if (modal) {
	      switch (evt.which) {
	        case 27:
	          {
	            if (modal.value.keyboard) {
	              evt.preventDefault();
	              $rootScope.$apply(function () {
	                $modalStack.dismiss(modal.key, 'escape key press');
	              });
	            }
	            break;
	          }
	        case 9:
	          {
	            var list = $modalStack.loadFocusElementList(modal);
	            var focusChanged = false;
	            if (evt.shiftKey) {
	              if ($modalStack.isFocusInFirstItem(evt, list) || $modalStack.isModalFocused(evt, modal)) {
	                focusChanged = $modalStack.focusLastFocusableElement(list);
	              }
	            } else {
	              if ($modalStack.isFocusInLastItem(evt, list)) {
	                focusChanged = $modalStack.focusFirstFocusableElement(list);
	              }
	            }
	
	            if (focusChanged) {
	              evt.preventDefault();
	              evt.stopPropagation();
	            }
	
	            break;
	          }
	      }
	    }
	  }
	
	  $modalStack.open = function (modalInstance, modal) {
	    var modalOpener = $document[0].activeElement,
	        modalBodyClass = modal.openedClass || OPENED_MODAL_CLASS;
	
	    toggleTopWindowClass(false);
	
	    // Store the current top first, to determine what index we ought to use
	    // for the current top modal
	    previousTopOpenedModal = openedWindows.top();
	
	    openedWindows.add(modalInstance, {
	      deferred: modal.deferred,
	      renderDeferred: modal.renderDeferred,
	      closedDeferred: modal.closedDeferred,
	      modalScope: modal.scope,
	      backdrop: modal.backdrop,
	      keyboard: modal.keyboard,
	      openedClass: modal.openedClass,
	      windowTopClass: modal.windowTopClass,
	      animation: modal.animation,
	      appendTo: modal.appendTo
	    });
	
	    openedClasses.put(modalBodyClass, modalInstance);
	
	    var appendToElement = modal.appendTo,
	        currBackdropIndex = backdropIndex();
	
	    if (currBackdropIndex >= 0 && !backdropDomEl) {
	      backdropScope = $rootScope.$new(true);
	      backdropScope.modalOptions = modal;
	      backdropScope.index = currBackdropIndex;
	      backdropDomEl = angular.element('<div uib-modal-backdrop="modal-backdrop"></div>');
	      backdropDomEl.attr({
	        'class': 'modal-backdrop',
	        'ng-style': '{\'z-index\': 1040 + (index && 1 || 0) + index*10}',
	        'uib-modal-animation-class': 'fade',
	        'modal-in-class': 'in'
	      });
	      if (modal.backdropClass) {
	        backdropDomEl.addClass(modal.backdropClass);
	      }
	
	      if (modal.animation) {
	        backdropDomEl.attr('modal-animation', 'true');
	      }
	      $compile(backdropDomEl)(backdropScope);
	      $animate.enter(backdropDomEl, appendToElement);
	      if ($uibPosition.isScrollable(appendToElement)) {
	        scrollbarPadding = $uibPosition.scrollbarPadding(appendToElement);
	        if (scrollbarPadding.heightOverflow && scrollbarPadding.scrollbarWidth) {
	          appendToElement.css({ paddingRight: scrollbarPadding.right + 'px' });
	        }
	      }
	    }
	
	    var content;
	    if (modal.component) {
	      content = document.createElement(snake_case(modal.component.name));
	      content = angular.element(content);
	      content.attr({
	        resolve: '$resolve',
	        'modal-instance': '$uibModalInstance',
	        close: '$close($value)',
	        dismiss: '$dismiss($value)'
	      });
	    } else {
	      content = modal.content;
	    }
	
	    // Set the top modal index based on the index of the previous top modal
	    topModalIndex = previousTopOpenedModal ? parseInt(previousTopOpenedModal.value.modalDomEl.attr('index'), 10) + 1 : 0;
	    var angularDomEl = angular.element('<div uib-modal-window="modal-window"></div>');
	    angularDomEl.attr({
	      'class': 'modal',
	      'template-url': modal.windowTemplateUrl,
	      'window-top-class': modal.windowTopClass,
	      'role': 'dialog',
	      'aria-labelledby': modal.ariaLabelledBy,
	      'aria-describedby': modal.ariaDescribedBy,
	      'size': modal.size,
	      'index': topModalIndex,
	      'animate': 'animate',
	      'ng-style': '{\'z-index\': 1050 + $$topModalIndex*10, display: \'block\'}',
	      'tabindex': -1,
	      'uib-modal-animation-class': 'fade',
	      'modal-in-class': 'in'
	    }).append(content);
	    if (modal.windowClass) {
	      angularDomEl.addClass(modal.windowClass);
	    }
	
	    if (modal.animation) {
	      angularDomEl.attr('modal-animation', 'true');
	    }
	
	    appendToElement.addClass(modalBodyClass);
	    if (modal.scope) {
	      // we need to explicitly add the modal index to the modal scope
	      // because it is needed by ngStyle to compute the zIndex property.
	      modal.scope.$$topModalIndex = topModalIndex;
	    }
	    $animate.enter($compile(angularDomEl)(modal.scope), appendToElement);
	
	    openedWindows.top().value.modalDomEl = angularDomEl;
	    openedWindows.top().value.modalOpener = modalOpener;
	
	    applyAriaHidden(angularDomEl);
	
	    function applyAriaHidden(el) {
	      if (!el || el[0].tagName === 'BODY') {
	        return;
	      }
	
	      getSiblings(el).forEach(function (sibling) {
	        var elemIsAlreadyHidden = sibling.getAttribute('aria-hidden') === 'true',
	            ariaHiddenCount = parseInt(sibling.getAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME), 10);
	
	        if (!ariaHiddenCount) {
	          ariaHiddenCount = elemIsAlreadyHidden ? 1 : 0;
	        }
	
	        sibling.setAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME, ariaHiddenCount + 1);
	        sibling.setAttribute('aria-hidden', 'true');
	      });
	
	      return applyAriaHidden(el.parent());
	
	      function getSiblings(el) {
	        var children = el.parent() ? el.parent().children() : [];
	
	        return Array.prototype.filter.call(children, function (child) {
	          return child !== el[0];
	        });
	      }
	    }
	  };
	
	  function broadcastClosing(modalWindow, resultOrReason, closing) {
	    return !modalWindow.value.modalScope.$broadcast('modal.closing', resultOrReason, closing).defaultPrevented;
	  }
	
	  function unhideBackgroundElements() {
	    Array.prototype.forEach.call(document.querySelectorAll('[' + ARIA_HIDDEN_ATTRIBUTE_NAME + ']'), function (hiddenEl) {
	      var ariaHiddenCount = parseInt(hiddenEl.getAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME), 10),
	          newHiddenCount = ariaHiddenCount - 1;
	      hiddenEl.setAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME, newHiddenCount);
	
	      if (!newHiddenCount) {
	        hiddenEl.removeAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME);
	        hiddenEl.removeAttribute('aria-hidden');
	      }
	    });
	  }
	
	  $modalStack.close = function (modalInstance, result) {
	    var modalWindow = openedWindows.get(modalInstance);
	    unhideBackgroundElements();
	    if (modalWindow && broadcastClosing(modalWindow, result, true)) {
	      modalWindow.value.modalScope.$$uibDestructionScheduled = true;
	      modalWindow.value.deferred.resolve(result);
	      removeModalWindow(modalInstance, modalWindow.value.modalOpener);
	      return true;
	    }
	
	    return !modalWindow;
	  };
	
	  $modalStack.dismiss = function (modalInstance, reason) {
	    var modalWindow = openedWindows.get(modalInstance);
	    unhideBackgroundElements();
	    if (modalWindow && broadcastClosing(modalWindow, reason, false)) {
	      modalWindow.value.modalScope.$$uibDestructionScheduled = true;
	      modalWindow.value.deferred.reject(reason);
	      removeModalWindow(modalInstance, modalWindow.value.modalOpener);
	      return true;
	    }
	    return !modalWindow;
	  };
	
	  $modalStack.dismissAll = function (reason) {
	    var topModal = this.getTop();
	    while (topModal && this.dismiss(topModal.key, reason)) {
	      topModal = this.getTop();
	    }
	  };
	
	  $modalStack.getTop = function () {
	    return openedWindows.top();
	  };
	
	  $modalStack.modalRendered = function (modalInstance) {
	    var modalWindow = openedWindows.get(modalInstance);
	    if (modalWindow) {
	      modalWindow.value.renderDeferred.resolve();
	    }
	  };
	
	  $modalStack.focusFirstFocusableElement = function (list) {
	    if (list.length > 0) {
	      list[0].focus();
	      return true;
	    }
	    return false;
	  };
	
	  $modalStack.focusLastFocusableElement = function (list) {
	    if (list.length > 0) {
	      list[list.length - 1].focus();
	      return true;
	    }
	    return false;
	  };
	
	  $modalStack.isModalFocused = function (evt, modalWindow) {
	    if (evt && modalWindow) {
	      var modalDomEl = modalWindow.value.modalDomEl;
	      if (modalDomEl && modalDomEl.length) {
	        return (evt.target || evt.srcElement) === modalDomEl[0];
	      }
	    }
	    return false;
	  };
	
	  $modalStack.isFocusInFirstItem = function (evt, list) {
	    if (list.length > 0) {
	      return (evt.target || evt.srcElement) === list[0];
	    }
	    return false;
	  };
	
	  $modalStack.isFocusInLastItem = function (evt, list) {
	    if (list.length > 0) {
	      return (evt.target || evt.srcElement) === list[list.length - 1];
	    }
	    return false;
	  };
	
	  $modalStack.loadFocusElementList = function (modalWindow) {
	    if (modalWindow) {
	      var modalDomE1 = modalWindow.value.modalDomEl;
	      if (modalDomE1 && modalDomE1.length) {
	        var elements = modalDomE1[0].querySelectorAll(tabbableSelector);
	        return elements ? Array.prototype.filter.call(elements, function (element) {
	          return isVisible(element);
	        }) : elements;
	      }
	    }
	  };
	
	  return $modalStack;
	}]).provider('$uibModal', function () {
	  var $modalProvider = {
	    options: {
	      animation: true,
	      backdrop: true, //can also be false or 'static'
	      keyboard: true
	    },
	    $get: ['$rootScope', '$q', '$document', '$templateRequest', '$controller', '$uibResolve', '$uibModalStack', function ($rootScope, $q, $document, $templateRequest, $controller, $uibResolve, $modalStack) {
	      var $modal = {};
	
	      function getTemplatePromise(options) {
	        return options.template ? $q.when(options.template) : $templateRequest(angular.isFunction(options.templateUrl) ? options.templateUrl() : options.templateUrl);
	      }
	
	      var promiseChain = null;
	      $modal.getPromiseChain = function () {
	        return promiseChain;
	      };
	
	      $modal.open = function (modalOptions) {
	        var modalResultDeferred = $q.defer();
	        var modalOpenedDeferred = $q.defer();
	        var modalClosedDeferred = $q.defer();
	        var modalRenderDeferred = $q.defer();
	
	        //prepare an instance of a modal to be injected into controllers and returned to a caller
	        var modalInstance = {
	          result: modalResultDeferred.promise,
	          opened: modalOpenedDeferred.promise,
	          closed: modalClosedDeferred.promise,
	          rendered: modalRenderDeferred.promise,
	          close: function close(result) {
	            return $modalStack.close(modalInstance, result);
	          },
	          dismiss: function dismiss(reason) {
	            return $modalStack.dismiss(modalInstance, reason);
	          }
	        };
	
	        //merge and clean up options
	        modalOptions = angular.extend({}, $modalProvider.options, modalOptions);
	        modalOptions.resolve = modalOptions.resolve || {};
	        modalOptions.appendTo = modalOptions.appendTo || $document.find('body').eq(0);
	
	        if (!modalOptions.appendTo.length) {
	          throw new Error('appendTo element not found. Make sure that the element passed is in DOM.');
	        }
	
	        //verify options
	        if (!modalOptions.component && !modalOptions.template && !modalOptions.templateUrl) {
	          throw new Error('One of component or template or templateUrl options is required.');
	        }
	
	        var templateAndResolvePromise;
	        if (modalOptions.component) {
	          templateAndResolvePromise = $q.when($uibResolve.resolve(modalOptions.resolve, {}, null, null));
	        } else {
	          templateAndResolvePromise = $q.all([getTemplatePromise(modalOptions), $uibResolve.resolve(modalOptions.resolve, {}, null, null)]);
	        }
	
	        function resolveWithTemplate() {
	          return templateAndResolvePromise;
	        }
	
	        // Wait for the resolution of the existing promise chain.
	        // Then switch to our own combined promise dependency (regardless of how the previous modal fared).
	        // Then add to $modalStack and resolve opened.
	        // Finally clean up the chain variable if no subsequent modal has overwritten it.
	        var samePromise;
	        samePromise = promiseChain = $q.all([promiseChain]).then(resolveWithTemplate, resolveWithTemplate).then(function resolveSuccess(tplAndVars) {
	          var providedScope = modalOptions.scope || $rootScope;
	
	          var modalScope = providedScope.$new();
	          modalScope.$close = modalInstance.close;
	          modalScope.$dismiss = modalInstance.dismiss;
	
	          modalScope.$on('$destroy', function () {
	            if (!modalScope.$$uibDestructionScheduled) {
	              modalScope.$dismiss('$uibUnscheduledDestruction');
	            }
	          });
	
	          var modal = {
	            scope: modalScope,
	            deferred: modalResultDeferred,
	            renderDeferred: modalRenderDeferred,
	            closedDeferred: modalClosedDeferred,
	            animation: modalOptions.animation,
	            backdrop: modalOptions.backdrop,
	            keyboard: modalOptions.keyboard,
	            backdropClass: modalOptions.backdropClass,
	            windowTopClass: modalOptions.windowTopClass,
	            windowClass: modalOptions.windowClass,
	            windowTemplateUrl: modalOptions.windowTemplateUrl,
	            ariaLabelledBy: modalOptions.ariaLabelledBy,
	            ariaDescribedBy: modalOptions.ariaDescribedBy,
	            size: modalOptions.size,
	            openedClass: modalOptions.openedClass,
	            appendTo: modalOptions.appendTo
	          };
	
	          var component = {};
	          var ctrlInstance,
	              ctrlInstantiate,
	              ctrlLocals = {};
	
	          if (modalOptions.component) {
	            constructLocals(component, false, true, false);
	            component.name = modalOptions.component;
	            modal.component = component;
	          } else if (modalOptions.controller) {
	            constructLocals(ctrlLocals, true, false, true);
	
	            // the third param will make the controller instantiate later,private api
	            // @see https://github.com/angular/angular.js/blob/master/src/ng/controller.js#L126
	            ctrlInstantiate = $controller(modalOptions.controller, ctrlLocals, true, modalOptions.controllerAs);
	            if (modalOptions.controllerAs && modalOptions.bindToController) {
	              ctrlInstance = ctrlInstantiate.instance;
	              ctrlInstance.$close = modalScope.$close;
	              ctrlInstance.$dismiss = modalScope.$dismiss;
	              angular.extend(ctrlInstance, {
	                $resolve: ctrlLocals.$scope.$resolve
	              }, providedScope);
	            }
	
	            ctrlInstance = ctrlInstantiate();
	
	            if (angular.isFunction(ctrlInstance.$onInit)) {
	              ctrlInstance.$onInit();
	            }
	          }
	
	          if (!modalOptions.component) {
	            modal.content = tplAndVars[0];
	          }
	
	          $modalStack.open(modalInstance, modal);
	          modalOpenedDeferred.resolve(true);
	
	          function constructLocals(obj, template, instanceOnScope, injectable) {
	            obj.$scope = modalScope;
	            obj.$scope.$resolve = {};
	            if (instanceOnScope) {
	              obj.$scope.$uibModalInstance = modalInstance;
	            } else {
	              obj.$uibModalInstance = modalInstance;
	            }
	
	            var resolves = template ? tplAndVars[1] : tplAndVars;
	            angular.forEach(resolves, function (value, key) {
	              if (injectable) {
	                obj[key] = value;
	              }
	
	              obj.$scope.$resolve[key] = value;
	            });
	          }
	        }, function resolveError(reason) {
	          modalOpenedDeferred.reject(reason);
	          modalResultDeferred.reject(reason);
	        })['finally'](function () {
	          if (promiseChain === samePromise) {
	            promiseChain = null;
	          }
	        });
	
	        return modalInstance;
	      };
	
	      return $modal;
	    }]
	  };
	
	  return $modalProvider;
	});

/***/ }),
/* 516 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('ui.bootstrap.multiMap', [])
	/**
	 * A helper, internal data structure that stores all references attached to key
	 */
	.factory('$$multiMap', function () {
	  return {
	    createNew: function createNew() {
	      var map = {};
	
	      return {
	        entries: function entries() {
	          return Object.keys(map).map(function (key) {
	            return {
	              key: key,
	              value: map[key]
	            };
	          });
	        },
	        get: function get(key) {
	          return map[key];
	        },
	        hasKey: function hasKey(key) {
	          return !!map[key];
	        },
	        keys: function keys() {
	          return Object.keys(map);
	        },
	        put: function put(key, value) {
	          if (!map[key]) {
	            map[key] = [];
	          }
	
	          map[key].push(value);
	        },
	        remove: function remove(key, value) {
	          var values = map[key];
	
	          if (!values) {
	            return;
	          }
	
	          var idx = values.indexOf(value);
	
	          if (idx !== -1) {
	            values.splice(idx, 1);
	          }
	
	          if (!values.length) {
	            delete map[key];
	          }
	        }
	      };
	    }
	  };
	});

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(84);
	__webpack_require__(542);
	__webpack_require__(540);
	__webpack_require__(541);
	__webpack_require__(519);
	
	var MODULE_NAME = 'ui.bootstrap.module.popover';
	
	angular.module(MODULE_NAME, ['ui.bootstrap.popover', 'uib/template/popover/popover.html', 'uib/template/popover/popover-html.html', 'uib/template/popover/popover-template.html']);
	
	module.exports = MODULE_NAME;

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(79);
	module.exports = __webpack_require__(517);

/***/ }),
/* 519 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * The following features are still outstanding: popup delay, animation as a
	 * function, placement as a function, inside, support for more triggers than
	 * just mouse enter/leave, and selector delegatation.
	 */
	angular.module('ui.bootstrap.popover', ['ui.bootstrap.tooltip']).directive('uibPopoverTemplatePopup', function () {
	  return {
	    restrict: 'A',
	    scope: { uibTitle: '@', contentExp: '&', originScope: '&' },
	    templateUrl: 'uib/template/popover/popover-template.html'
	  };
	}).directive('uibPopoverTemplate', ['$uibTooltip', function ($uibTooltip) {
	  return $uibTooltip('uibPopoverTemplate', 'popover', 'click', {
	    useContentExp: true
	  });
	}]).directive('uibPopoverHtmlPopup', function () {
	  return {
	    restrict: 'A',
	    scope: { contentExp: '&', uibTitle: '@' },
	    templateUrl: 'uib/template/popover/popover-html.html'
	  };
	}).directive('uibPopoverHtml', ['$uibTooltip', function ($uibTooltip) {
	  return $uibTooltip('uibPopoverHtml', 'popover', 'click', {
	    useContentExp: true
	  });
	}]).directive('uibPopoverPopup', function () {
	  return {
	    restrict: 'A',
	    scope: { uibTitle: '@', content: '@' },
	    templateUrl: 'uib/template/popover/popover.html'
	  };
	}).directive('uibPopover', ['$uibTooltip', function ($uibTooltip) {
	  return $uibTooltip('uibPopover', 'popover', 'click');
	}]);

/***/ }),
/* 520 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('ui.bootstrap.position', [])
	
	/**
	 * A set of utility methods for working with the DOM.
	 * It is meant to be used where we need to absolute-position elements in
	 * relation to another element (this is the case for tooltips, popovers,
	 * typeahead suggestions etc.).
	 */
	.factory('$uibPosition', ['$document', '$window', function ($document, $window) {
	  /**
	   * Used by scrollbarWidth() function to cache scrollbar's width.
	   * Do not access this variable directly, use scrollbarWidth() instead.
	   */
	  var SCROLLBAR_WIDTH;
	  /**
	   * scrollbar on body and html element in IE and Edge overlay
	   * content and should be considered 0 width.
	   */
	  var BODY_SCROLLBAR_WIDTH;
	  var OVERFLOW_REGEX = {
	    normal: /(auto|scroll)/,
	    hidden: /(auto|scroll|hidden)/
	  };
	  var PLACEMENT_REGEX = {
	    auto: /\s?auto?\s?/i,
	    primary: /^(top|bottom|left|right)$/,
	    secondary: /^(top|bottom|left|right|center)$/,
	    vertical: /^(top|bottom)$/
	  };
	  var BODY_REGEX = /(HTML|BODY)/;
	
	  return {
	
	    /**
	     * Provides a raw DOM element from a jQuery/jQLite element.
	     *
	     * @param {element} elem - The element to convert.
	     *
	     * @returns {element} A HTML element.
	     */
	    getRawNode: function getRawNode(elem) {
	      return elem.nodeName ? elem : elem[0] || elem;
	    },
	
	    /**
	     * Provides a parsed number for a style property.  Strips
	     * units and casts invalid numbers to 0.
	     *
	     * @param {string} value - The style value to parse.
	     *
	     * @returns {number} A valid number.
	     */
	    parseStyle: function parseStyle(value) {
	      value = parseFloat(value);
	      return isFinite(value) ? value : 0;
	    },
	
	    /**
	     * Provides the closest positioned ancestor.
	     *
	     * @param {element} element - The element to get the offest parent for.
	     *
	     * @returns {element} The closest positioned ancestor.
	     */
	    offsetParent: function offsetParent(elem) {
	      elem = this.getRawNode(elem);
	
	      var offsetParent = elem.offsetParent || $document[0].documentElement;
	
	      function isStaticPositioned(el) {
	        return ($window.getComputedStyle(el).position || 'static') === 'static';
	      }
	
	      while (offsetParent && offsetParent !== $document[0].documentElement && isStaticPositioned(offsetParent)) {
	        offsetParent = offsetParent.offsetParent;
	      }
	
	      return offsetParent || $document[0].documentElement;
	    },
	
	    /**
	     * Provides the scrollbar width, concept from TWBS measureScrollbar()
	     * function in https://github.com/twbs/bootstrap/blob/master/js/modal.js
	     * In IE and Edge, scollbar on body and html element overlay and should
	     * return a width of 0.
	     *
	     * @returns {number} The width of the browser scollbar.
	     */
	    scrollbarWidth: function scrollbarWidth(isBody) {
	      if (isBody) {
	        if (angular.isUndefined(BODY_SCROLLBAR_WIDTH)) {
	          var bodyElem = $document.find('body');
	          bodyElem.addClass('uib-position-body-scrollbar-measure');
	          BODY_SCROLLBAR_WIDTH = $window.innerWidth - bodyElem[0].clientWidth;
	          BODY_SCROLLBAR_WIDTH = isFinite(BODY_SCROLLBAR_WIDTH) ? BODY_SCROLLBAR_WIDTH : 0;
	          bodyElem.removeClass('uib-position-body-scrollbar-measure');
	        }
	        return BODY_SCROLLBAR_WIDTH;
	      }
	
	      if (angular.isUndefined(SCROLLBAR_WIDTH)) {
	        var scrollElem = angular.element('<div class="uib-position-scrollbar-measure"></div>');
	        $document.find('body').append(scrollElem);
	        SCROLLBAR_WIDTH = scrollElem[0].offsetWidth - scrollElem[0].clientWidth;
	        SCROLLBAR_WIDTH = isFinite(SCROLLBAR_WIDTH) ? SCROLLBAR_WIDTH : 0;
	        scrollElem.remove();
	      }
	
	      return SCROLLBAR_WIDTH;
	    },
	
	    /**
	     * Provides the padding required on an element to replace the scrollbar.
	     *
	     * @returns {object} An object with the following properties:
	     *   <ul>
	     *     <li>**scrollbarWidth**: the width of the scrollbar</li>
	     *     <li>**widthOverflow**: whether the the width is overflowing</li>
	     *     <li>**right**: the amount of right padding on the element needed to replace the scrollbar</li>
	     *     <li>**rightOriginal**: the amount of right padding currently on the element</li>
	     *     <li>**heightOverflow**: whether the the height is overflowing</li>
	     *     <li>**bottom**: the amount of bottom padding on the element needed to replace the scrollbar</li>
	     *     <li>**bottomOriginal**: the amount of bottom padding currently on the element</li>
	     *   </ul>
	     */
	    scrollbarPadding: function scrollbarPadding(elem) {
	      elem = this.getRawNode(elem);
	
	      var elemStyle = $window.getComputedStyle(elem);
	      var paddingRight = this.parseStyle(elemStyle.paddingRight);
	      var paddingBottom = this.parseStyle(elemStyle.paddingBottom);
	      var scrollParent = this.scrollParent(elem, false, true);
	      var scrollbarWidth = this.scrollbarWidth(BODY_REGEX.test(scrollParent.tagName));
	
	      return {
	        scrollbarWidth: scrollbarWidth,
	        widthOverflow: scrollParent.scrollWidth > scrollParent.clientWidth,
	        right: paddingRight + scrollbarWidth,
	        originalRight: paddingRight,
	        heightOverflow: scrollParent.scrollHeight > scrollParent.clientHeight,
	        bottom: paddingBottom + scrollbarWidth,
	        originalBottom: paddingBottom
	      };
	    },
	
	    /**
	     * Checks to see if the element is scrollable.
	     *
	     * @param {element} elem - The element to check.
	     * @param {boolean=} [includeHidden=false] - Should scroll style of 'hidden' be considered,
	     *   default is false.
	     *
	     * @returns {boolean} Whether the element is scrollable.
	     */
	    isScrollable: function isScrollable(elem, includeHidden) {
	      elem = this.getRawNode(elem);
	
	      var overflowRegex = includeHidden ? OVERFLOW_REGEX.hidden : OVERFLOW_REGEX.normal;
	      var elemStyle = $window.getComputedStyle(elem);
	      return overflowRegex.test(elemStyle.overflow + elemStyle.overflowY + elemStyle.overflowX);
	    },
	
	    /**
	     * Provides the closest scrollable ancestor.
	     * A port of the jQuery UI scrollParent method:
	     * https://github.com/jquery/jquery-ui/blob/master/ui/scroll-parent.js
	     *
	     * @param {element} elem - The element to find the scroll parent of.
	     * @param {boolean=} [includeHidden=false] - Should scroll style of 'hidden' be considered,
	     *   default is false.
	     * @param {boolean=} [includeSelf=false] - Should the element being passed be
	     * included in the scrollable llokup.
	     *
	     * @returns {element} A HTML element.
	     */
	    scrollParent: function scrollParent(elem, includeHidden, includeSelf) {
	      elem = this.getRawNode(elem);
	
	      var overflowRegex = includeHidden ? OVERFLOW_REGEX.hidden : OVERFLOW_REGEX.normal;
	      var documentEl = $document[0].documentElement;
	      var elemStyle = $window.getComputedStyle(elem);
	      if (includeSelf && overflowRegex.test(elemStyle.overflow + elemStyle.overflowY + elemStyle.overflowX)) {
	        return elem;
	      }
	      var excludeStatic = elemStyle.position === 'absolute';
	      var scrollParent = elem.parentElement || documentEl;
	
	      if (scrollParent === documentEl || elemStyle.position === 'fixed') {
	        return documentEl;
	      }
	
	      while (scrollParent.parentElement && scrollParent !== documentEl) {
	        var spStyle = $window.getComputedStyle(scrollParent);
	        if (excludeStatic && spStyle.position !== 'static') {
	          excludeStatic = false;
	        }
	
	        if (!excludeStatic && overflowRegex.test(spStyle.overflow + spStyle.overflowY + spStyle.overflowX)) {
	          break;
	        }
	        scrollParent = scrollParent.parentElement;
	      }
	
	      return scrollParent;
	    },
	
	    /**
	     * Provides read-only equivalent of jQuery's position function:
	     * http://api.jquery.com/position/ - distance to closest positioned
	     * ancestor.  Does not account for margins by default like jQuery position.
	     *
	     * @param {element} elem - The element to caclulate the position on.
	     * @param {boolean=} [includeMargins=false] - Should margins be accounted
	     * for, default is false.
	     *
	     * @returns {object} An object with the following properties:
	     *   <ul>
	     *     <li>**width**: the width of the element</li>
	     *     <li>**height**: the height of the element</li>
	     *     <li>**top**: distance to top edge of offset parent</li>
	     *     <li>**left**: distance to left edge of offset parent</li>
	     *   </ul>
	     */
	    position: function position(elem, includeMagins) {
	      elem = this.getRawNode(elem);
	
	      var elemOffset = this.offset(elem);
	      if (includeMagins) {
	        var elemStyle = $window.getComputedStyle(elem);
	        elemOffset.top -= this.parseStyle(elemStyle.marginTop);
	        elemOffset.left -= this.parseStyle(elemStyle.marginLeft);
	      }
	      var parent = this.offsetParent(elem);
	      var parentOffset = { top: 0, left: 0 };
	
	      if (parent !== $document[0].documentElement) {
	        parentOffset = this.offset(parent);
	        parentOffset.top += parent.clientTop - parent.scrollTop;
	        parentOffset.left += parent.clientLeft - parent.scrollLeft;
	      }
	
	      return {
	        width: Math.round(angular.isNumber(elemOffset.width) ? elemOffset.width : elem.offsetWidth),
	        height: Math.round(angular.isNumber(elemOffset.height) ? elemOffset.height : elem.offsetHeight),
	        top: Math.round(elemOffset.top - parentOffset.top),
	        left: Math.round(elemOffset.left - parentOffset.left)
	      };
	    },
	
	    /**
	     * Provides read-only equivalent of jQuery's offset function:
	     * http://api.jquery.com/offset/ - distance to viewport.  Does
	     * not account for borders, margins, or padding on the body
	     * element.
	     *
	     * @param {element} elem - The element to calculate the offset on.
	     *
	     * @returns {object} An object with the following properties:
	     *   <ul>
	     *     <li>**width**: the width of the element</li>
	     *     <li>**height**: the height of the element</li>
	     *     <li>**top**: distance to top edge of viewport</li>
	     *     <li>**right**: distance to bottom edge of viewport</li>
	     *   </ul>
	     */
	    offset: function offset(elem) {
	      elem = this.getRawNode(elem);
	
	      var elemBCR = elem.getBoundingClientRect();
	      return {
	        width: Math.round(angular.isNumber(elemBCR.width) ? elemBCR.width : elem.offsetWidth),
	        height: Math.round(angular.isNumber(elemBCR.height) ? elemBCR.height : elem.offsetHeight),
	        top: Math.round(elemBCR.top + ($window.pageYOffset || $document[0].documentElement.scrollTop)),
	        left: Math.round(elemBCR.left + ($window.pageXOffset || $document[0].documentElement.scrollLeft))
	      };
	    },
	
	    /**
	     * Provides offset distance to the closest scrollable ancestor
	     * or viewport.  Accounts for border and scrollbar width.
	     *
	     * Right and bottom dimensions represent the distance to the
	     * respective edge of the viewport element.  If the element
	     * edge extends beyond the viewport, a negative value will be
	     * reported.
	     *
	     * @param {element} elem - The element to get the viewport offset for.
	     * @param {boolean=} [useDocument=false] - Should the viewport be the document element instead
	     * of the first scrollable element, default is false.
	     * @param {boolean=} [includePadding=true] - Should the padding on the offset parent element
	     * be accounted for, default is true.
	     *
	     * @returns {object} An object with the following properties:
	     *   <ul>
	     *     <li>**top**: distance to the top content edge of viewport element</li>
	     *     <li>**bottom**: distance to the bottom content edge of viewport element</li>
	     *     <li>**left**: distance to the left content edge of viewport element</li>
	     *     <li>**right**: distance to the right content edge of viewport element</li>
	     *   </ul>
	     */
	    viewportOffset: function viewportOffset(elem, useDocument, includePadding) {
	      elem = this.getRawNode(elem);
	      includePadding = includePadding !== false ? true : false;
	
	      var elemBCR = elem.getBoundingClientRect();
	      var offsetBCR = { top: 0, left: 0, bottom: 0, right: 0 };
	
	      var offsetParent = useDocument ? $document[0].documentElement : this.scrollParent(elem);
	      var offsetParentBCR = offsetParent.getBoundingClientRect();
	
	      offsetBCR.top = offsetParentBCR.top + offsetParent.clientTop;
	      offsetBCR.left = offsetParentBCR.left + offsetParent.clientLeft;
	      if (offsetParent === $document[0].documentElement) {
	        offsetBCR.top += $window.pageYOffset;
	        offsetBCR.left += $window.pageXOffset;
	      }
	      offsetBCR.bottom = offsetBCR.top + offsetParent.clientHeight;
	      offsetBCR.right = offsetBCR.left + offsetParent.clientWidth;
	
	      if (includePadding) {
	        var offsetParentStyle = $window.getComputedStyle(offsetParent);
	        offsetBCR.top += this.parseStyle(offsetParentStyle.paddingTop);
	        offsetBCR.bottom -= this.parseStyle(offsetParentStyle.paddingBottom);
	        offsetBCR.left += this.parseStyle(offsetParentStyle.paddingLeft);
	        offsetBCR.right -= this.parseStyle(offsetParentStyle.paddingRight);
	      }
	
	      return {
	        top: Math.round(elemBCR.top - offsetBCR.top),
	        bottom: Math.round(offsetBCR.bottom - elemBCR.bottom),
	        left: Math.round(elemBCR.left - offsetBCR.left),
	        right: Math.round(offsetBCR.right - elemBCR.right)
	      };
	    },
	
	    /**
	     * Provides an array of placement values parsed from a placement string.
	     * Along with the 'auto' indicator, supported placement strings are:
	     *   <ul>
	     *     <li>top: element on top, horizontally centered on host element.</li>
	     *     <li>top-left: element on top, left edge aligned with host element left edge.</li>
	     *     <li>top-right: element on top, lerightft edge aligned with host element right edge.</li>
	     *     <li>bottom: element on bottom, horizontally centered on host element.</li>
	     *     <li>bottom-left: element on bottom, left edge aligned with host element left edge.</li>
	     *     <li>bottom-right: element on bottom, right edge aligned with host element right edge.</li>
	     *     <li>left: element on left, vertically centered on host element.</li>
	     *     <li>left-top: element on left, top edge aligned with host element top edge.</li>
	     *     <li>left-bottom: element on left, bottom edge aligned with host element bottom edge.</li>
	     *     <li>right: element on right, vertically centered on host element.</li>
	     *     <li>right-top: element on right, top edge aligned with host element top edge.</li>
	     *     <li>right-bottom: element on right, bottom edge aligned with host element bottom edge.</li>
	     *   </ul>
	     * A placement string with an 'auto' indicator is expected to be
	     * space separated from the placement, i.e: 'auto bottom-left'  If
	     * the primary and secondary placement values do not match 'top,
	     * bottom, left, right' then 'top' will be the primary placement and
	     * 'center' will be the secondary placement.  If 'auto' is passed, true
	     * will be returned as the 3rd value of the array.
	     *
	     * @param {string} placement - The placement string to parse.
	     *
	     * @returns {array} An array with the following values
	     * <ul>
	     *   <li>**[0]**: The primary placement.</li>
	     *   <li>**[1]**: The secondary placement.</li>
	     *   <li>**[2]**: If auto is passed: true, else undefined.</li>
	     * </ul>
	     */
	    parsePlacement: function parsePlacement(placement) {
	      var autoPlace = PLACEMENT_REGEX.auto.test(placement);
	      if (autoPlace) {
	        placement = placement.replace(PLACEMENT_REGEX.auto, '');
	      }
	
	      placement = placement.split('-');
	
	      placement[0] = placement[0] || 'top';
	      if (!PLACEMENT_REGEX.primary.test(placement[0])) {
	        placement[0] = 'top';
	      }
	
	      placement[1] = placement[1] || 'center';
	      if (!PLACEMENT_REGEX.secondary.test(placement[1])) {
	        placement[1] = 'center';
	      }
	
	      if (autoPlace) {
	        placement[2] = true;
	      } else {
	        placement[2] = false;
	      }
	
	      return placement;
	    },
	
	    /**
	     * Provides coordinates for an element to be positioned relative to
	     * another element.  Passing 'auto' as part of the placement parameter
	     * will enable smart placement - where the element fits. i.e:
	     * 'auto left-top' will check to see if there is enough space to the left
	     * of the hostElem to fit the targetElem, if not place right (same for secondary
	     * top placement).  Available space is calculated using the viewportOffset
	     * function.
	     *
	     * @param {element} hostElem - The element to position against.
	     * @param {element} targetElem - The element to position.
	     * @param {string=} [placement=top] - The placement for the targetElem,
	     *   default is 'top'. 'center' is assumed as secondary placement for
	     *   'top', 'left', 'right', and 'bottom' placements.  Available placements are:
	     *   <ul>
	     *     <li>top</li>
	     *     <li>top-right</li>
	     *     <li>top-left</li>
	     *     <li>bottom</li>
	     *     <li>bottom-left</li>
	     *     <li>bottom-right</li>
	     *     <li>left</li>
	     *     <li>left-top</li>
	     *     <li>left-bottom</li>
	     *     <li>right</li>
	     *     <li>right-top</li>
	     *     <li>right-bottom</li>
	     *   </ul>
	     * @param {boolean=} [appendToBody=false] - Should the top and left values returned
	     *   be calculated from the body element, default is false.
	     *
	     * @returns {object} An object with the following properties:
	     *   <ul>
	     *     <li>**top**: Value for targetElem top.</li>
	     *     <li>**left**: Value for targetElem left.</li>
	     *     <li>**placement**: The resolved placement.</li>
	     *   </ul>
	     */
	    positionElements: function positionElements(hostElem, targetElem, placement, appendToBody) {
	      hostElem = this.getRawNode(hostElem);
	      targetElem = this.getRawNode(targetElem);
	
	      // need to read from prop to support tests.
	      var targetWidth = angular.isDefined(targetElem.offsetWidth) ? targetElem.offsetWidth : targetElem.prop('offsetWidth');
	      var targetHeight = angular.isDefined(targetElem.offsetHeight) ? targetElem.offsetHeight : targetElem.prop('offsetHeight');
	
	      placement = this.parsePlacement(placement);
	
	      var hostElemPos = appendToBody ? this.offset(hostElem) : this.position(hostElem);
	      var targetElemPos = { top: 0, left: 0, placement: '' };
	
	      if (placement[2]) {
	        var viewportOffset = this.viewportOffset(hostElem, appendToBody);
	
	        var targetElemStyle = $window.getComputedStyle(targetElem);
	        var adjustedSize = {
	          width: targetWidth + Math.round(Math.abs(this.parseStyle(targetElemStyle.marginLeft) + this.parseStyle(targetElemStyle.marginRight))),
	          height: targetHeight + Math.round(Math.abs(this.parseStyle(targetElemStyle.marginTop) + this.parseStyle(targetElemStyle.marginBottom)))
	        };
	
	        placement[0] = placement[0] === 'top' && adjustedSize.height > viewportOffset.top && adjustedSize.height <= viewportOffset.bottom ? 'bottom' : placement[0] === 'bottom' && adjustedSize.height > viewportOffset.bottom && adjustedSize.height <= viewportOffset.top ? 'top' : placement[0] === 'left' && adjustedSize.width > viewportOffset.left && adjustedSize.width <= viewportOffset.right ? 'right' : placement[0] === 'right' && adjustedSize.width > viewportOffset.right && adjustedSize.width <= viewportOffset.left ? 'left' : placement[0];
	
	        placement[1] = placement[1] === 'top' && adjustedSize.height - hostElemPos.height > viewportOffset.bottom && adjustedSize.height - hostElemPos.height <= viewportOffset.top ? 'bottom' : placement[1] === 'bottom' && adjustedSize.height - hostElemPos.height > viewportOffset.top && adjustedSize.height - hostElemPos.height <= viewportOffset.bottom ? 'top' : placement[1] === 'left' && adjustedSize.width - hostElemPos.width > viewportOffset.right && adjustedSize.width - hostElemPos.width <= viewportOffset.left ? 'right' : placement[1] === 'right' && adjustedSize.width - hostElemPos.width > viewportOffset.left && adjustedSize.width - hostElemPos.width <= viewportOffset.right ? 'left' : placement[1];
	
	        if (placement[1] === 'center') {
	          if (PLACEMENT_REGEX.vertical.test(placement[0])) {
	            var xOverflow = hostElemPos.width / 2 - targetWidth / 2;
	            if (viewportOffset.left + xOverflow < 0 && adjustedSize.width - hostElemPos.width <= viewportOffset.right) {
	              placement[1] = 'left';
	            } else if (viewportOffset.right + xOverflow < 0 && adjustedSize.width - hostElemPos.width <= viewportOffset.left) {
	              placement[1] = 'right';
	            }
	          } else {
	            var yOverflow = hostElemPos.height / 2 - adjustedSize.height / 2;
	            if (viewportOffset.top + yOverflow < 0 && adjustedSize.height - hostElemPos.height <= viewportOffset.bottom) {
	              placement[1] = 'top';
	            } else if (viewportOffset.bottom + yOverflow < 0 && adjustedSize.height - hostElemPos.height <= viewportOffset.top) {
	              placement[1] = 'bottom';
	            }
	          }
	        }
	      }
	
	      switch (placement[0]) {
	        case 'top':
	          targetElemPos.top = hostElemPos.top - targetHeight;
	          break;
	        case 'bottom':
	          targetElemPos.top = hostElemPos.top + hostElemPos.height;
	          break;
	        case 'left':
	          targetElemPos.left = hostElemPos.left - targetWidth;
	          break;
	        case 'right':
	          targetElemPos.left = hostElemPos.left + hostElemPos.width;
	          break;
	      }
	
	      switch (placement[1]) {
	        case 'top':
	          targetElemPos.top = hostElemPos.top;
	          break;
	        case 'bottom':
	          targetElemPos.top = hostElemPos.top + hostElemPos.height - targetHeight;
	          break;
	        case 'left':
	          targetElemPos.left = hostElemPos.left;
	          break;
	        case 'right':
	          targetElemPos.left = hostElemPos.left + hostElemPos.width - targetWidth;
	          break;
	        case 'center':
	          if (PLACEMENT_REGEX.vertical.test(placement[0])) {
	            targetElemPos.left = hostElemPos.left + hostElemPos.width / 2 - targetWidth / 2;
	          } else {
	            targetElemPos.top = hostElemPos.top + hostElemPos.height / 2 - targetHeight / 2;
	          }
	          break;
	      }
	
	      targetElemPos.top = Math.round(targetElemPos.top);
	      targetElemPos.left = Math.round(targetElemPos.left);
	      targetElemPos.placement = placement[1] === 'center' ? placement[0] : placement[0] + '-' + placement[1];
	
	      return targetElemPos;
	    },
	
	    /**
	     * Provides a way to adjust the top positioning after first
	     * render to correctly align element to top after content
	     * rendering causes resized element height
	     *
	     * @param {array} placementClasses - The array of strings of classes
	     * element should have.
	     * @param {object} containerPosition - The object with container
	     * position information
	     * @param {number} initialHeight - The initial height for the elem.
	     * @param {number} currentHeight - The current height for the elem.
	     */
	    adjustTop: function adjustTop(placementClasses, containerPosition, initialHeight, currentHeight) {
	      if (placementClasses.indexOf('top') !== -1 && initialHeight !== currentHeight) {
	        return {
	          top: containerPosition.top - currentHeight + 'px'
	        };
	      }
	    },
	
	    /**
	     * Provides a way for positioning tooltip & dropdown
	     * arrows when using placement options beyond the standard
	     * left, right, top, or bottom.
	     *
	     * @param {element} elem - The tooltip/dropdown element.
	     * @param {string} placement - The placement for the elem.
	     */
	    positionArrow: function positionArrow(elem, placement) {
	      elem = this.getRawNode(elem);
	
	      var innerElem = elem.querySelector('.tooltip-inner, .popover-inner');
	      if (!innerElem) {
	        return;
	      }
	
	      var isTooltip = angular.element(innerElem).hasClass('tooltip-inner');
	
	      var arrowElem = isTooltip ? elem.querySelector('.tooltip-arrow') : elem.querySelector('.arrow');
	      if (!arrowElem) {
	        return;
	      }
	
	      var arrowCss = {
	        top: '',
	        bottom: '',
	        left: '',
	        right: ''
	      };
	
	      placement = this.parsePlacement(placement);
	      if (placement[1] === 'center') {
	        // no adjustment necessary - just reset styles
	        angular.element(arrowElem).css(arrowCss);
	        return;
	      }
	
	      var borderProp = 'border-' + placement[0] + '-width';
	      var borderWidth = $window.getComputedStyle(arrowElem)[borderProp];
	
	      var borderRadiusProp = 'border-';
	      if (PLACEMENT_REGEX.vertical.test(placement[0])) {
	        borderRadiusProp += placement[0] + '-' + placement[1];
	      } else {
	        borderRadiusProp += placement[1] + '-' + placement[0];
	      }
	      borderRadiusProp += '-radius';
	      var borderRadius = $window.getComputedStyle(isTooltip ? innerElem : elem)[borderRadiusProp];
	
	      switch (placement[0]) {
	        case 'top':
	          arrowCss.bottom = isTooltip ? '0' : '-' + borderWidth;
	          break;
	        case 'bottom':
	          arrowCss.top = isTooltip ? '0' : '-' + borderWidth;
	          break;
	        case 'left':
	          arrowCss.right = isTooltip ? '0' : '-' + borderWidth;
	          break;
	        case 'right':
	          arrowCss.left = isTooltip ? '0' : '-' + borderWidth;
	          break;
	      }
	
	      arrowCss[placement[1]] = borderRadius;
	
	      angular.element(arrowElem).css(arrowCss);
	    }
	  };
	}]);

/***/ }),
/* 521 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('ui.bootstrap.stackedMap', [])
	/**
	 * A helper, internal data structure that acts as a map but also allows getting / removing
	 * elements in the LIFO order
	 */
	.factory('$$stackedMap', function () {
	  return {
	    createNew: function createNew() {
	      var stack = [];
	
	      return {
	        add: function add(key, value) {
	          stack.push({
	            key: key,
	            value: value
	          });
	        },
	        get: function get(key) {
	          for (var i = 0; i < stack.length; i++) {
	            if (key === stack[i].key) {
	              return stack[i];
	            }
	          }
	        },
	        keys: function keys() {
	          var keys = [];
	          for (var i = 0; i < stack.length; i++) {
	            keys.push(stack[i].key);
	          }
	          return keys;
	        },
	        top: function top() {
	          return stack[stack.length - 1];
	        },
	        remove: function remove(key) {
	          var idx = -1;
	          for (var i = 0; i < stack.length; i++) {
	            if (key === stack[i].key) {
	              idx = i;
	              break;
	            }
	          }
	          return stack.splice(idx, 1)[0];
	        },
	        removeTop: function removeTop() {
	          return stack.pop();
	        },
	        length: function length() {
	          return stack.length;
	        }
	      };
	    }
	  };
	});

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(523);
	
	var MODULE_NAME = 'ui.bootstrap.module.tabindex';
	
	angular.module(MODULE_NAME, ['ui.bootstrap.tabindex']);
	
	module.exports = MODULE_NAME;

/***/ }),
/* 523 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('ui.bootstrap.tabindex', []).directive('uibTabindexToggle', function () {
	  return {
	    restrict: 'A',
	    link: function link(scope, elem, attrs) {
	      attrs.$observe('disabled', function (disabled) {
	        attrs.$set('tabindex', disabled ? -1 : null);
	      });
	    }
	  };
	});

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(543);
	__webpack_require__(544);
	__webpack_require__(525);
	
	var MODULE_NAME = 'ui.bootstrap.module.tabs';
	
	angular.module(MODULE_NAME, ['ui.bootstrap.tabs', 'uib/template/tabs/tab.html', 'uib/template/tabs/tabset.html']);
	
	module.exports = MODULE_NAME;

/***/ }),
/* 525 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('ui.bootstrap.tabs', []).controller('UibTabsetController', ['$scope', function ($scope) {
	  var ctrl = this,
	      oldIndex;
	  ctrl.tabs = [];
	
	  ctrl.select = function (index, evt) {
	    if (!destroyed) {
	      var previousIndex = findTabIndex(oldIndex);
	      var previousSelected = ctrl.tabs[previousIndex];
	      if (previousSelected) {
	        previousSelected.tab.onDeselect({
	          $event: evt,
	          $selectedIndex: index
	        });
	        if (evt && evt.isDefaultPrevented()) {
	          return;
	        }
	        previousSelected.tab.active = false;
	      }
	
	      var selected = ctrl.tabs[index];
	      if (selected) {
	        selected.tab.onSelect({
	          $event: evt
	        });
	        selected.tab.active = true;
	        ctrl.active = selected.index;
	        oldIndex = selected.index;
	      } else if (!selected && angular.isDefined(oldIndex)) {
	        ctrl.active = null;
	        oldIndex = null;
	      }
	    }
	  };
	
	  ctrl.addTab = function addTab(tab) {
	    ctrl.tabs.push({
	      tab: tab,
	      index: tab.index
	    });
	    ctrl.tabs.sort(function (t1, t2) {
	      if (t1.index > t2.index) {
	        return 1;
	      }
	
	      if (t1.index < t2.index) {
	        return -1;
	      }
	
	      return 0;
	    });
	
	    if (tab.index === ctrl.active || !angular.isDefined(ctrl.active) && ctrl.tabs.length === 1) {
	      var newActiveIndex = findTabIndex(tab.index);
	      ctrl.select(newActiveIndex);
	    }
	  };
	
	  ctrl.removeTab = function removeTab(tab) {
	    var index;
	    for (var i = 0; i < ctrl.tabs.length; i++) {
	      if (ctrl.tabs[i].tab === tab) {
	        index = i;
	        break;
	      }
	    }
	
	    if (ctrl.tabs[index].index === ctrl.active) {
	      var newActiveTabIndex = index === ctrl.tabs.length - 1 ? index - 1 : index + 1 % ctrl.tabs.length;
	      ctrl.select(newActiveTabIndex);
	    }
	
	    ctrl.tabs.splice(index, 1);
	  };
	
	  $scope.$watch('tabset.active', function (val) {
	    if (angular.isDefined(val) && val !== oldIndex) {
	      ctrl.select(findTabIndex(val));
	    }
	  });
	
	  var destroyed;
	  $scope.$on('$destroy', function () {
	    destroyed = true;
	  });
	
	  function findTabIndex(index) {
	    for (var i = 0; i < ctrl.tabs.length; i++) {
	      if (ctrl.tabs[i].index === index) {
	        return i;
	      }
	    }
	  }
	}]).directive('uibTabset', function () {
	  return {
	    transclude: true,
	    replace: true,
	    scope: {},
	    bindToController: {
	      active: '=?',
	      type: '@'
	    },
	    controller: 'UibTabsetController',
	    controllerAs: 'tabset',
	    templateUrl: function templateUrl(element, attrs) {
	      return attrs.templateUrl || 'uib/template/tabs/tabset.html';
	    },
	    link: function link(scope, element, attrs) {
	      scope.vertical = angular.isDefined(attrs.vertical) ? scope.$parent.$eval(attrs.vertical) : false;
	      scope.justified = angular.isDefined(attrs.justified) ? scope.$parent.$eval(attrs.justified) : false;
	    }
	  };
	}).directive('uibTab', ['$parse', function ($parse) {
	  return {
	    require: '^uibTabset',
	    replace: true,
	    templateUrl: function templateUrl(element, attrs) {
	      return attrs.templateUrl || 'uib/template/tabs/tab.html';
	    },
	    transclude: true,
	    scope: {
	      heading: '@',
	      index: '=?',
	      classes: '@?',
	      onSelect: '&select', //This callback is called in contentHeadingTransclude
	      //once it inserts the tab's content into the dom
	      onDeselect: '&deselect'
	    },
	    controller: function controller() {
	      //Empty controller so other directives can require being 'under' a tab
	    },
	    controllerAs: 'tab',
	    link: function link(scope, elm, attrs, tabsetCtrl, transclude) {
	      scope.disabled = false;
	      if (attrs.disable) {
	        scope.$parent.$watch($parse(attrs.disable), function (value) {
	          scope.disabled = !!value;
	        });
	      }
	
	      if (angular.isUndefined(attrs.index)) {
	        if (tabsetCtrl.tabs && tabsetCtrl.tabs.length) {
	          scope.index = Math.max.apply(null, tabsetCtrl.tabs.map(function (t) {
	            return t.index;
	          })) + 1;
	        } else {
	          scope.index = 0;
	        }
	      }
	
	      if (angular.isUndefined(attrs.classes)) {
	        scope.classes = '';
	      }
	
	      scope.select = function (evt) {
	        if (!scope.disabled) {
	          var index;
	          for (var i = 0; i < tabsetCtrl.tabs.length; i++) {
	            if (tabsetCtrl.tabs[i].tab === scope) {
	              index = i;
	              break;
	            }
	          }
	
	          tabsetCtrl.select(index, evt);
	        }
	      };
	
	      tabsetCtrl.addTab(scope);
	      scope.$on('$destroy', function () {
	        tabsetCtrl.removeTab(scope);
	      });
	
	      //We need to transclude later, once the content container is ready.
	      //when this link happens, we're inside a tab heading.
	      scope.$transcludeFn = transclude;
	    }
	  };
	}]).directive('uibTabHeadingTransclude', function () {
	  return {
	    restrict: 'A',
	    require: '^uibTab',
	    link: function link(scope, elm) {
	      scope.$watch('headingElement', function updateHeadingElement(heading) {
	        if (heading) {
	          elm.html('');
	          elm.append(heading);
	        }
	      });
	    }
	  };
	}).directive('uibTabContentTransclude', function () {
	  return {
	    restrict: 'A',
	    require: '^uibTabset',
	    link: function link(scope, elm, attrs) {
	      var tab = scope.$eval(attrs.uibTabContentTransclude).tab;
	
	      //Now our tab is ready to be transcluded: both the tab heading area
	      //and the tab content area are loaded.  Transclude 'em both.
	      tab.$transcludeFn(tab.$parent, function (contents) {
	        angular.forEach(contents, function (node) {
	          if (isTabHeading(node)) {
	            //Let tabHeadingTransclude know.
	            tab.headingElement = node;
	          } else {
	            elm.append(node);
	          }
	        });
	      });
	    }
	  };
	
	  function isTabHeading(node) {
	    return node.tagName && (node.hasAttribute('uib-tab-heading') || node.hasAttribute('data-uib-tab-heading') || node.hasAttribute('x-uib-tab-heading') || node.tagName.toLowerCase() === 'uib-tab-heading' || node.tagName.toLowerCase() === 'data-uib-tab-heading' || node.tagName.toLowerCase() === 'x-uib-tab-heading' || node.tagName.toLowerCase() === 'uib:tab-heading');
	  }
	});

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(545);
	__webpack_require__(528);
	
	var MODULE_NAME = 'ui.bootstrap.module.timepicker';
	
	angular.module(MODULE_NAME, ['ui.bootstrap.timepicker', 'uib/template/timepicker/timepicker.html']);
	
	module.exports = MODULE_NAME;

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(171);
	module.exports = __webpack_require__(526);

/***/ }),
/* 528 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('ui.bootstrap.timepicker', []).constant('uibTimepickerConfig', {
	  hourStep: 1,
	  minuteStep: 1,
	  secondStep: 1,
	  showMeridian: true,
	  showSeconds: false,
	  meridians: null,
	  readonlyInput: false,
	  mousewheel: true,
	  arrowkeys: true,
	  showSpinners: true,
	  templateUrl: 'uib/template/timepicker/timepicker.html'
	}).controller('UibTimepickerController', ['$scope', '$element', '$attrs', '$parse', '$log', '$locale', 'uibTimepickerConfig', function ($scope, $element, $attrs, $parse, $log, $locale, timepickerConfig) {
	  var hoursModelCtrl, minutesModelCtrl, secondsModelCtrl;
	  var selected = new Date(),
	      watchers = [],
	      ngModelCtrl = { $setViewValue: angular.noop },
	      // nullModelCtrl
	  meridians = angular.isDefined($attrs.meridians) ? $scope.$parent.$eval($attrs.meridians) : timepickerConfig.meridians || $locale.DATETIME_FORMATS.AMPMS,
	      padHours = angular.isDefined($attrs.padHours) ? $scope.$parent.$eval($attrs.padHours) : true;
	
	  $scope.tabindex = angular.isDefined($attrs.tabindex) ? $attrs.tabindex : 0;
	  $element.removeAttr('tabindex');
	
	  this.init = function (ngModelCtrl_, inputs) {
	    ngModelCtrl = ngModelCtrl_;
	    ngModelCtrl.$render = this.render;
	
	    ngModelCtrl.$formatters.unshift(function (modelValue) {
	      return modelValue ? new Date(modelValue) : null;
	    });
	
	    var hoursInputEl = inputs.eq(0),
	        minutesInputEl = inputs.eq(1),
	        secondsInputEl = inputs.eq(2);
	
	    hoursModelCtrl = hoursInputEl.controller('ngModel');
	    minutesModelCtrl = minutesInputEl.controller('ngModel');
	    secondsModelCtrl = secondsInputEl.controller('ngModel');
	
	    var mousewheel = angular.isDefined($attrs.mousewheel) ? $scope.$parent.$eval($attrs.mousewheel) : timepickerConfig.mousewheel;
	
	    if (mousewheel) {
	      this.setupMousewheelEvents(hoursInputEl, minutesInputEl, secondsInputEl);
	    }
	
	    var arrowkeys = angular.isDefined($attrs.arrowkeys) ? $scope.$parent.$eval($attrs.arrowkeys) : timepickerConfig.arrowkeys;
	    if (arrowkeys) {
	      this.setupArrowkeyEvents(hoursInputEl, minutesInputEl, secondsInputEl);
	    }
	
	    $scope.readonlyInput = angular.isDefined($attrs.readonlyInput) ? $scope.$parent.$eval($attrs.readonlyInput) : timepickerConfig.readonlyInput;
	    this.setupInputEvents(hoursInputEl, minutesInputEl, secondsInputEl);
	  };
	
	  var hourStep = timepickerConfig.hourStep;
	  if ($attrs.hourStep) {
	    watchers.push($scope.$parent.$watch($parse($attrs.hourStep), function (value) {
	      hourStep = +value;
	    }));
	  }
	
	  var minuteStep = timepickerConfig.minuteStep;
	  if ($attrs.minuteStep) {
	    watchers.push($scope.$parent.$watch($parse($attrs.minuteStep), function (value) {
	      minuteStep = +value;
	    }));
	  }
	
	  var min;
	  watchers.push($scope.$parent.$watch($parse($attrs.min), function (value) {
	    var dt = new Date(value);
	    min = isNaN(dt) ? undefined : dt;
	  }));
	
	  var max;
	  watchers.push($scope.$parent.$watch($parse($attrs.max), function (value) {
	    var dt = new Date(value);
	    max = isNaN(dt) ? undefined : dt;
	  }));
	
	  var disabled = false;
	  if ($attrs.ngDisabled) {
	    watchers.push($scope.$parent.$watch($parse($attrs.ngDisabled), function (value) {
	      disabled = value;
	    }));
	  }
	
	  $scope.noIncrementHours = function () {
	    var incrementedSelected = addMinutes(selected, hourStep * 60);
	    return disabled || incrementedSelected > max || incrementedSelected < selected && incrementedSelected < min;
	  };
	
	  $scope.noDecrementHours = function () {
	    var decrementedSelected = addMinutes(selected, -hourStep * 60);
	    return disabled || decrementedSelected < min || decrementedSelected > selected && decrementedSelected > max;
	  };
	
	  $scope.noIncrementMinutes = function () {
	    var incrementedSelected = addMinutes(selected, minuteStep);
	    return disabled || incrementedSelected > max || incrementedSelected < selected && incrementedSelected < min;
	  };
	
	  $scope.noDecrementMinutes = function () {
	    var decrementedSelected = addMinutes(selected, -minuteStep);
	    return disabled || decrementedSelected < min || decrementedSelected > selected && decrementedSelected > max;
	  };
	
	  $scope.noIncrementSeconds = function () {
	    var incrementedSelected = addSeconds(selected, secondStep);
	    return disabled || incrementedSelected > max || incrementedSelected < selected && incrementedSelected < min;
	  };
	
	  $scope.noDecrementSeconds = function () {
	    var decrementedSelected = addSeconds(selected, -secondStep);
	    return disabled || decrementedSelected < min || decrementedSelected > selected && decrementedSelected > max;
	  };
	
	  $scope.noToggleMeridian = function () {
	    if (selected.getHours() < 12) {
	      return disabled || addMinutes(selected, 12 * 60) > max;
	    }
	
	    return disabled || addMinutes(selected, -12 * 60) < min;
	  };
	
	  var secondStep = timepickerConfig.secondStep;
	  if ($attrs.secondStep) {
	    watchers.push($scope.$parent.$watch($parse($attrs.secondStep), function (value) {
	      secondStep = +value;
	    }));
	  }
	
	  $scope.showSeconds = timepickerConfig.showSeconds;
	  if ($attrs.showSeconds) {
	    watchers.push($scope.$parent.$watch($parse($attrs.showSeconds), function (value) {
	      $scope.showSeconds = !!value;
	    }));
	  }
	
	  // 12H / 24H mode
	  $scope.showMeridian = timepickerConfig.showMeridian;
	  if ($attrs.showMeridian) {
	    watchers.push($scope.$parent.$watch($parse($attrs.showMeridian), function (value) {
	      $scope.showMeridian = !!value;
	
	      if (ngModelCtrl.$error.time) {
	        // Evaluate from template
	        var hours = getHoursFromTemplate(),
	            minutes = getMinutesFromTemplate();
	        if (angular.isDefined(hours) && angular.isDefined(minutes)) {
	          selected.setHours(hours);
	          refresh();
	        }
	      } else {
	        updateTemplate();
	      }
	    }));
	  }
	
	  // Get $scope.hours in 24H mode if valid
	  function getHoursFromTemplate() {
	    var hours = +$scope.hours;
	    var valid = $scope.showMeridian ? hours > 0 && hours < 13 : hours >= 0 && hours < 24;
	    if (!valid || $scope.hours === '') {
	      return undefined;
	    }
	
	    if ($scope.showMeridian) {
	      if (hours === 12) {
	        hours = 0;
	      }
	      if ($scope.meridian === meridians[1]) {
	        hours = hours + 12;
	      }
	    }
	    return hours;
	  }
	
	  function getMinutesFromTemplate() {
	    var minutes = +$scope.minutes;
	    var valid = minutes >= 0 && minutes < 60;
	    if (!valid || $scope.minutes === '') {
	      return undefined;
	    }
	    return minutes;
	  }
	
	  function getSecondsFromTemplate() {
	    var seconds = +$scope.seconds;
	    return seconds >= 0 && seconds < 60 ? seconds : undefined;
	  }
	
	  function pad(value, noPad) {
	    if (value === null) {
	      return '';
	    }
	
	    return angular.isDefined(value) && value.toString().length < 2 && !noPad ? '0' + value : value.toString();
	  }
	
	  // Respond on mousewheel spin
	  this.setupMousewheelEvents = function (hoursInputEl, minutesInputEl, secondsInputEl) {
	    var isScrollingUp = function isScrollingUp(e) {
	      if (e.originalEvent) {
	        e = e.originalEvent;
	      }
	      //pick correct delta variable depending on event
	      var delta = e.wheelDelta ? e.wheelDelta : -e.deltaY;
	      return e.detail || delta > 0;
	    };
	
	    hoursInputEl.on('mousewheel wheel', function (e) {
	      if (!disabled) {
	        $scope.$apply(isScrollingUp(e) ? $scope.incrementHours() : $scope.decrementHours());
	      }
	      e.preventDefault();
	    });
	
	    minutesInputEl.on('mousewheel wheel', function (e) {
	      if (!disabled) {
	        $scope.$apply(isScrollingUp(e) ? $scope.incrementMinutes() : $scope.decrementMinutes());
	      }
	      e.preventDefault();
	    });
	
	    secondsInputEl.on('mousewheel wheel', function (e) {
	      if (!disabled) {
	        $scope.$apply(isScrollingUp(e) ? $scope.incrementSeconds() : $scope.decrementSeconds());
	      }
	      e.preventDefault();
	    });
	  };
	
	  // Respond on up/down arrowkeys
	  this.setupArrowkeyEvents = function (hoursInputEl, minutesInputEl, secondsInputEl) {
	    hoursInputEl.on('keydown', function (e) {
	      if (!disabled) {
	        if (e.which === 38) {
	          // up
	          e.preventDefault();
	          $scope.incrementHours();
	          $scope.$apply();
	        } else if (e.which === 40) {
	          // down
	          e.preventDefault();
	          $scope.decrementHours();
	          $scope.$apply();
	        }
	      }
	    });
	
	    minutesInputEl.on('keydown', function (e) {
	      if (!disabled) {
	        if (e.which === 38) {
	          // up
	          e.preventDefault();
	          $scope.incrementMinutes();
	          $scope.$apply();
	        } else if (e.which === 40) {
	          // down
	          e.preventDefault();
	          $scope.decrementMinutes();
	          $scope.$apply();
	        }
	      }
	    });
	
	    secondsInputEl.on('keydown', function (e) {
	      if (!disabled) {
	        if (e.which === 38) {
	          // up
	          e.preventDefault();
	          $scope.incrementSeconds();
	          $scope.$apply();
	        } else if (e.which === 40) {
	          // down
	          e.preventDefault();
	          $scope.decrementSeconds();
	          $scope.$apply();
	        }
	      }
	    });
	  };
	
	  this.setupInputEvents = function (hoursInputEl, minutesInputEl, secondsInputEl) {
	    if ($scope.readonlyInput) {
	      $scope.updateHours = angular.noop;
	      $scope.updateMinutes = angular.noop;
	      $scope.updateSeconds = angular.noop;
	      return;
	    }
	
	    var invalidate = function invalidate(invalidHours, invalidMinutes, invalidSeconds) {
	      ngModelCtrl.$setViewValue(null);
	      ngModelCtrl.$setValidity('time', false);
	      if (angular.isDefined(invalidHours)) {
	        $scope.invalidHours = invalidHours;
	        if (hoursModelCtrl) {
	          hoursModelCtrl.$setValidity('hours', false);
	        }
	      }
	
	      if (angular.isDefined(invalidMinutes)) {
	        $scope.invalidMinutes = invalidMinutes;
	        if (minutesModelCtrl) {
	          minutesModelCtrl.$setValidity('minutes', false);
	        }
	      }
	
	      if (angular.isDefined(invalidSeconds)) {
	        $scope.invalidSeconds = invalidSeconds;
	        if (secondsModelCtrl) {
	          secondsModelCtrl.$setValidity('seconds', false);
	        }
	      }
	    };
	
	    $scope.updateHours = function () {
	      var hours = getHoursFromTemplate(),
	          minutes = getMinutesFromTemplate();
	
	      ngModelCtrl.$setDirty();
	
	      if (angular.isDefined(hours) && angular.isDefined(minutes)) {
	        selected.setHours(hours);
	        selected.setMinutes(minutes);
	        if (selected < min || selected > max) {
	          invalidate(true);
	        } else {
	          refresh('h');
	        }
	      } else {
	        invalidate(true);
	      }
	    };
	
	    hoursInputEl.on('blur', function (e) {
	      ngModelCtrl.$setTouched();
	      if (modelIsEmpty()) {
	        makeValid();
	      } else if ($scope.hours === null || $scope.hours === '') {
	        invalidate(true);
	      } else if (!$scope.invalidHours && $scope.hours < 10) {
	        $scope.$apply(function () {
	          $scope.hours = pad($scope.hours, !padHours);
	        });
	      }
	    });
	
	    $scope.updateMinutes = function () {
	      var minutes = getMinutesFromTemplate(),
	          hours = getHoursFromTemplate();
	
	      ngModelCtrl.$setDirty();
	
	      if (angular.isDefined(minutes) && angular.isDefined(hours)) {
	        selected.setHours(hours);
	        selected.setMinutes(minutes);
	        if (selected < min || selected > max) {
	          invalidate(undefined, true);
	        } else {
	          refresh('m');
	        }
	      } else {
	        invalidate(undefined, true);
	      }
	    };
	
	    minutesInputEl.on('blur', function (e) {
	      ngModelCtrl.$setTouched();
	      if (modelIsEmpty()) {
	        makeValid();
	      } else if ($scope.minutes === null) {
	        invalidate(undefined, true);
	      } else if (!$scope.invalidMinutes && $scope.minutes < 10) {
	        $scope.$apply(function () {
	          $scope.minutes = pad($scope.minutes);
	        });
	      }
	    });
	
	    $scope.updateSeconds = function () {
	      var seconds = getSecondsFromTemplate();
	
	      ngModelCtrl.$setDirty();
	
	      if (angular.isDefined(seconds)) {
	        selected.setSeconds(seconds);
	        refresh('s');
	      } else {
	        invalidate(undefined, undefined, true);
	      }
	    };
	
	    secondsInputEl.on('blur', function (e) {
	      if (modelIsEmpty()) {
	        makeValid();
	      } else if (!$scope.invalidSeconds && $scope.seconds < 10) {
	        $scope.$apply(function () {
	          $scope.seconds = pad($scope.seconds);
	        });
	      }
	    });
	  };
	
	  this.render = function () {
	    var date = ngModelCtrl.$viewValue;
	
	    if (isNaN(date)) {
	      ngModelCtrl.$setValidity('time', false);
	      $log.error('Timepicker directive: "ng-model" value must be a Date object, a number of milliseconds since 01.01.1970 or a string representing an RFC2822 or ISO 8601 date.');
	    } else {
	      if (date) {
	        selected = date;
	      }
	
	      if (selected < min || selected > max) {
	        ngModelCtrl.$setValidity('time', false);
	        $scope.invalidHours = true;
	        $scope.invalidMinutes = true;
	      } else {
	        makeValid();
	      }
	      updateTemplate();
	    }
	  };
	
	  // Call internally when we know that model is valid.
	  function refresh(keyboardChange) {
	    makeValid();
	    ngModelCtrl.$setViewValue(new Date(selected));
	    updateTemplate(keyboardChange);
	  }
	
	  function makeValid() {
	    if (hoursModelCtrl) {
	      hoursModelCtrl.$setValidity('hours', true);
	    }
	
	    if (minutesModelCtrl) {
	      minutesModelCtrl.$setValidity('minutes', true);
	    }
	
	    if (secondsModelCtrl) {
	      secondsModelCtrl.$setValidity('seconds', true);
	    }
	
	    ngModelCtrl.$setValidity('time', true);
	    $scope.invalidHours = false;
	    $scope.invalidMinutes = false;
	    $scope.invalidSeconds = false;
	  }
	
	  function updateTemplate(keyboardChange) {
	    if (!ngModelCtrl.$modelValue) {
	      $scope.hours = null;
	      $scope.minutes = null;
	      $scope.seconds = null;
	      $scope.meridian = meridians[0];
	    } else {
	      var hours = selected.getHours(),
	          minutes = selected.getMinutes(),
	          seconds = selected.getSeconds();
	
	      if ($scope.showMeridian) {
	        hours = hours === 0 || hours === 12 ? 12 : hours % 12; // Convert 24 to 12 hour system
	      }
	
	      $scope.hours = keyboardChange === 'h' ? hours : pad(hours, !padHours);
	      if (keyboardChange !== 'm') {
	        $scope.minutes = pad(minutes);
	      }
	      $scope.meridian = selected.getHours() < 12 ? meridians[0] : meridians[1];
	
	      if (keyboardChange !== 's') {
	        $scope.seconds = pad(seconds);
	      }
	      $scope.meridian = selected.getHours() < 12 ? meridians[0] : meridians[1];
	    }
	  }
	
	  function addSecondsToSelected(seconds) {
	    selected = addSeconds(selected, seconds);
	    refresh();
	  }
	
	  function addMinutes(selected, minutes) {
	    return addSeconds(selected, minutes * 60);
	  }
	
	  function addSeconds(date, seconds) {
	    var dt = new Date(date.getTime() + seconds * 1000);
	    var newDate = new Date(date);
	    newDate.setHours(dt.getHours(), dt.getMinutes(), dt.getSeconds());
	    return newDate;
	  }
	
	  function modelIsEmpty() {
	    return ($scope.hours === null || $scope.hours === '') && ($scope.minutes === null || $scope.minutes === '') && (!$scope.showSeconds || $scope.showSeconds && ($scope.seconds === null || $scope.seconds === ''));
	  }
	
	  $scope.showSpinners = angular.isDefined($attrs.showSpinners) ? $scope.$parent.$eval($attrs.showSpinners) : timepickerConfig.showSpinners;
	
	  $scope.incrementHours = function () {
	    if (!$scope.noIncrementHours()) {
	      addSecondsToSelected(hourStep * 60 * 60);
	    }
	  };
	
	  $scope.decrementHours = function () {
	    if (!$scope.noDecrementHours()) {
	      addSecondsToSelected(-hourStep * 60 * 60);
	    }
	  };
	
	  $scope.incrementMinutes = function () {
	    if (!$scope.noIncrementMinutes()) {
	      addSecondsToSelected(minuteStep * 60);
	    }
	  };
	
	  $scope.decrementMinutes = function () {
	    if (!$scope.noDecrementMinutes()) {
	      addSecondsToSelected(-minuteStep * 60);
	    }
	  };
	
	  $scope.incrementSeconds = function () {
	    if (!$scope.noIncrementSeconds()) {
	      addSecondsToSelected(secondStep);
	    }
	  };
	
	  $scope.decrementSeconds = function () {
	    if (!$scope.noDecrementSeconds()) {
	      addSecondsToSelected(-secondStep);
	    }
	  };
	
	  $scope.toggleMeridian = function () {
	    var minutes = getMinutesFromTemplate(),
	        hours = getHoursFromTemplate();
	
	    if (!$scope.noToggleMeridian()) {
	      if (angular.isDefined(minutes) && angular.isDefined(hours)) {
	        addSecondsToSelected(12 * 60 * (selected.getHours() < 12 ? 60 : -60));
	      } else {
	        $scope.meridian = $scope.meridian === meridians[0] ? meridians[1] : meridians[0];
	      }
	    }
	  };
	
	  $scope.blur = function () {
	    ngModelCtrl.$setTouched();
	  };
	
	  $scope.$on('$destroy', function () {
	    while (watchers.length) {
	      watchers.shift()();
	    }
	  });
	}]).directive('uibTimepicker', ['uibTimepickerConfig', function (uibTimepickerConfig) {
	  return {
	    require: ['uibTimepicker', '?^ngModel'],
	    restrict: 'A',
	    controller: 'UibTimepickerController',
	    controllerAs: 'timepicker',
	    scope: {},
	    templateUrl: function templateUrl(element, attrs) {
	      return attrs.templateUrl || uibTimepickerConfig.templateUrl;
	    },
	    link: function link(scope, element, attrs, ctrls) {
	      var timepickerCtrl = ctrls[0],
	          ngModelCtrl = ctrls[1];
	
	      if (ngModelCtrl) {
	        timepickerCtrl.init(ngModelCtrl, element.find('input'));
	      }
	    }
	  };
	}]);

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(25);
	__webpack_require__(79);
	module.exports = __webpack_require__(84);

/***/ }),
/* 530 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * The following features are still outstanding: animation as a
	 * function, placement as a function, inside, support for more triggers than
	 * just mouse enter/leave, html tooltips, and selector delegation.
	 */
	angular.module('ui.bootstrap.tooltip', ['ui.bootstrap.position', 'ui.bootstrap.stackedMap'])
	
	/**
	 * The $tooltip service creates tooltip- and popover-like directives as well as
	 * houses global options for them.
	 */
	.provider('$uibTooltip', function () {
	  // The default options tooltip and popover.
	  var defaultOptions = {
	    placement: 'top',
	    placementClassPrefix: '',
	    animation: true,
	    popupDelay: 0,
	    popupCloseDelay: 0,
	    useContentExp: false
	  };
	
	  // Default hide triggers for each show trigger
	  var triggerMap = {
	    'mouseenter': 'mouseleave',
	    'click': 'click',
	    'outsideClick': 'outsideClick',
	    'focus': 'blur',
	    'none': ''
	  };
	
	  // The options specified to the provider globally.
	  var globalOptions = {};
	
	  /**
	   * `options({})` allows global configuration of all tooltips in the
	   * application.
	   *
	   *   var app = angular.module( 'App', ['ui.bootstrap.tooltip'], function( $tooltipProvider ) {
	   *     // place tooltips left instead of top by default
	   *     $tooltipProvider.options( { placement: 'left' } );
	   *   });
	   */
	  this.options = function (value) {
	    angular.extend(globalOptions, value);
	  };
	
	  /**
	   * This allows you to extend the set of trigger mappings available. E.g.:
	   *
	   *   $tooltipProvider.setTriggers( { 'openTrigger': 'closeTrigger' } );
	   */
	  this.setTriggers = function setTriggers(triggers) {
	    angular.extend(triggerMap, triggers);
	  };
	
	  /**
	   * This is a helper function for translating camel-case to snake_case.
	   */
	  function snake_case(name) {
	    var regexp = /[A-Z]/g;
	    var separator = '-';
	    return name.replace(regexp, function (letter, pos) {
	      return (pos ? separator : '') + letter.toLowerCase();
	    });
	  }
	
	  /**
	   * Returns the actual instance of the $tooltip service.
	   * TODO support multiple triggers
	   */
	  this.$get = ['$window', '$compile', '$timeout', '$document', '$uibPosition', '$interpolate', '$rootScope', '$parse', '$$stackedMap', function ($window, $compile, $timeout, $document, $position, $interpolate, $rootScope, $parse, $$stackedMap) {
	    var openedTooltips = $$stackedMap.createNew();
	    $document.on('keyup', keypressListener);
	
	    $rootScope.$on('$destroy', function () {
	      $document.off('keyup', keypressListener);
	    });
	
	    function keypressListener(e) {
	      if (e.which === 27) {
	        var last = openedTooltips.top();
	        if (last) {
	          last.value.close();
	          last = null;
	        }
	      }
	    }
	
	    return function $tooltip(ttType, prefix, defaultTriggerShow, options) {
	      options = angular.extend({}, defaultOptions, globalOptions, options);
	
	      /**
	       * Returns an object of show and hide triggers.
	       *
	       * If a trigger is supplied,
	       * it is used to show the tooltip; otherwise, it will use the `trigger`
	       * option passed to the `$tooltipProvider.options` method; else it will
	       * default to the trigger supplied to this directive factory.
	       *
	       * The hide trigger is based on the show trigger. If the `trigger` option
	       * was passed to the `$tooltipProvider.options` method, it will use the
	       * mapped trigger from `triggerMap` or the passed trigger if the map is
	       * undefined; otherwise, it uses the `triggerMap` value of the show
	       * trigger; else it will just use the show trigger.
	       */
	      function getTriggers(trigger) {
	        var show = (trigger || options.trigger || defaultTriggerShow).split(' ');
	        var hide = show.map(function (trigger) {
	          return triggerMap[trigger] || trigger;
	        });
	        return {
	          show: show,
	          hide: hide
	        };
	      }
	
	      var directiveName = snake_case(ttType);
	
	      var startSym = $interpolate.startSymbol();
	      var endSym = $interpolate.endSymbol();
	      var template = '<div ' + directiveName + '-popup ' + 'uib-title="' + startSym + 'title' + endSym + '" ' + (options.useContentExp ? 'content-exp="contentExp()" ' : 'content="' + startSym + 'content' + endSym + '" ') + 'origin-scope="origScope" ' + 'class="uib-position-measure ' + prefix + '" ' + 'tooltip-animation-class="fade"' + 'uib-tooltip-classes ' + 'ng-class="{ in: isOpen }" ' + '>' + '</div>';
	
	      return {
	        compile: function compile(tElem, tAttrs) {
	          var tooltipLinker = $compile(template);
	
	          return function link(scope, element, attrs, tooltipCtrl) {
	            var tooltip;
	            var tooltipLinkedScope;
	            var transitionTimeout;
	            var showTimeout;
	            var hideTimeout;
	            var positionTimeout;
	            var adjustmentTimeout;
	            var appendToBody = angular.isDefined(options.appendToBody) ? options.appendToBody : false;
	            var triggers = getTriggers(undefined);
	            var hasEnableExp = angular.isDefined(attrs[prefix + 'Enable']);
	            var ttScope = scope.$new(true);
	            var repositionScheduled = false;
	            var isOpenParse = angular.isDefined(attrs[prefix + 'IsOpen']) ? $parse(attrs[prefix + 'IsOpen']) : false;
	            var contentParse = options.useContentExp ? $parse(attrs[ttType]) : false;
	            var observers = [];
	            var lastPlacement;
	
	            var positionTooltip = function positionTooltip() {
	              // check if tooltip exists and is not empty
	              if (!tooltip || !tooltip.html()) {
	                return;
	              }
	
	              if (!positionTimeout) {
	                positionTimeout = $timeout(function () {
	                  var ttPosition = $position.positionElements(element, tooltip, ttScope.placement, appendToBody);
	                  var initialHeight = angular.isDefined(tooltip.offsetHeight) ? tooltip.offsetHeight : tooltip.prop('offsetHeight');
	                  var elementPos = appendToBody ? $position.offset(element) : $position.position(element);
	                  tooltip.css({ top: ttPosition.top + 'px', left: ttPosition.left + 'px' });
	                  var placementClasses = ttPosition.placement.split('-');
	
	                  if (!tooltip.hasClass(placementClasses[0])) {
	                    tooltip.removeClass(lastPlacement.split('-')[0]);
	                    tooltip.addClass(placementClasses[0]);
	                  }
	
	                  if (!tooltip.hasClass(options.placementClassPrefix + ttPosition.placement)) {
	                    tooltip.removeClass(options.placementClassPrefix + lastPlacement);
	                    tooltip.addClass(options.placementClassPrefix + ttPosition.placement);
	                  }
	
	                  adjustmentTimeout = $timeout(function () {
	                    var currentHeight = angular.isDefined(tooltip.offsetHeight) ? tooltip.offsetHeight : tooltip.prop('offsetHeight');
	                    var adjustment = $position.adjustTop(placementClasses, elementPos, initialHeight, currentHeight);
	                    if (adjustment) {
	                      tooltip.css(adjustment);
	                    }
	                    adjustmentTimeout = null;
	                  }, 0, false);
	
	                  // first time through tt element will have the
	                  // uib-position-measure class or if the placement
	                  // has changed we need to position the arrow.
	                  if (tooltip.hasClass('uib-position-measure')) {
	                    $position.positionArrow(tooltip, ttPosition.placement);
	                    tooltip.removeClass('uib-position-measure');
	                  } else if (lastPlacement !== ttPosition.placement) {
	                    $position.positionArrow(tooltip, ttPosition.placement);
	                  }
	                  lastPlacement = ttPosition.placement;
	
	                  positionTimeout = null;
	                }, 0, false);
	              }
	            };
	
	            // Set up the correct scope to allow transclusion later
	            ttScope.origScope = scope;
	
	            // By default, the tooltip is not open.
	            // TODO add ability to start tooltip opened
	            ttScope.isOpen = false;
	
	            function toggleTooltipBind() {
	              if (!ttScope.isOpen) {
	                showTooltipBind();
	              } else {
	                hideTooltipBind();
	              }
	            }
	
	            // Show the tooltip with delay if specified, otherwise show it immediately
	            function showTooltipBind() {
	              if (hasEnableExp && !scope.$eval(attrs[prefix + 'Enable'])) {
	                return;
	              }
	
	              cancelHide();
	              prepareTooltip();
	
	              if (ttScope.popupDelay) {
	                // Do nothing if the tooltip was already scheduled to pop-up.
	                // This happens if show is triggered multiple times before any hide is triggered.
	                if (!showTimeout) {
	                  showTimeout = $timeout(show, ttScope.popupDelay, false);
	                }
	              } else {
	                show();
	              }
	            }
	
	            function hideTooltipBind() {
	              cancelShow();
	
	              if (ttScope.popupCloseDelay) {
	                if (!hideTimeout) {
	                  hideTimeout = $timeout(hide, ttScope.popupCloseDelay, false);
	                }
	              } else {
	                hide();
	              }
	            }
	
	            // Show the tooltip popup element.
	            function show() {
	              cancelShow();
	              cancelHide();
	
	              // Don't show empty tooltips.
	              if (!ttScope.content) {
	                return angular.noop;
	              }
	
	              createTooltip();
	
	              // And show the tooltip.
	              ttScope.$evalAsync(function () {
	                ttScope.isOpen = true;
	                assignIsOpen(true);
	                positionTooltip();
	              });
	            }
	
	            function cancelShow() {
	              if (showTimeout) {
	                $timeout.cancel(showTimeout);
	                showTimeout = null;
	              }
	
	              if (positionTimeout) {
	                $timeout.cancel(positionTimeout);
	                positionTimeout = null;
	              }
	            }
	
	            // Hide the tooltip popup element.
	            function hide() {
	              if (!ttScope) {
	                return;
	              }
	
	              // First things first: we don't show it anymore.
	              ttScope.$evalAsync(function () {
	                if (ttScope) {
	                  ttScope.isOpen = false;
	                  assignIsOpen(false);
	                  // And now we remove it from the DOM. However, if we have animation, we
	                  // need to wait for it to expire beforehand.
	                  // FIXME: this is a placeholder for a port of the transitions library.
	                  // The fade transition in TWBS is 150ms.
	                  if (ttScope.animation) {
	                    if (!transitionTimeout) {
	                      transitionTimeout = $timeout(removeTooltip, 150, false);
	                    }
	                  } else {
	                    removeTooltip();
	                  }
	                }
	              });
	            }
	
	            function cancelHide() {
	              if (hideTimeout) {
	                $timeout.cancel(hideTimeout);
	                hideTimeout = null;
	              }
	
	              if (transitionTimeout) {
	                $timeout.cancel(transitionTimeout);
	                transitionTimeout = null;
	              }
	            }
	
	            function createTooltip() {
	              // There can only be one tooltip element per directive shown at once.
	              if (tooltip) {
	                return;
	              }
	
	              tooltipLinkedScope = ttScope.$new();
	              tooltip = tooltipLinker(tooltipLinkedScope, function (tooltip) {
	                if (appendToBody) {
	                  $document.find('body').append(tooltip);
	                } else {
	                  element.after(tooltip);
	                }
	              });
	
	              openedTooltips.add(ttScope, {
	                close: hide
	              });
	
	              prepObservers();
	            }
	
	            function removeTooltip() {
	              cancelShow();
	              cancelHide();
	              unregisterObservers();
	
	              if (tooltip) {
	                tooltip.remove();
	
	                tooltip = null;
	                if (adjustmentTimeout) {
	                  $timeout.cancel(adjustmentTimeout);
	                }
	              }
	
	              openedTooltips.remove(ttScope);
	
	              if (tooltipLinkedScope) {
	                tooltipLinkedScope.$destroy();
	                tooltipLinkedScope = null;
	              }
	            }
	
	            /**
	             * Set the initial scope values. Once
	             * the tooltip is created, the observers
	             * will be added to keep things in sync.
	             */
	            function prepareTooltip() {
	              ttScope.title = attrs[prefix + 'Title'];
	              if (contentParse) {
	                ttScope.content = contentParse(scope);
	              } else {
	                ttScope.content = attrs[ttType];
	              }
	
	              ttScope.popupClass = attrs[prefix + 'Class'];
	              ttScope.placement = angular.isDefined(attrs[prefix + 'Placement']) ? attrs[prefix + 'Placement'] : options.placement;
	              var placement = $position.parsePlacement(ttScope.placement);
	              lastPlacement = placement[1] ? placement[0] + '-' + placement[1] : placement[0];
	
	              var delay = parseInt(attrs[prefix + 'PopupDelay'], 10);
	              var closeDelay = parseInt(attrs[prefix + 'PopupCloseDelay'], 10);
	              ttScope.popupDelay = !isNaN(delay) ? delay : options.popupDelay;
	              ttScope.popupCloseDelay = !isNaN(closeDelay) ? closeDelay : options.popupCloseDelay;
	            }
	
	            function assignIsOpen(isOpen) {
	              if (isOpenParse && angular.isFunction(isOpenParse.assign)) {
	                isOpenParse.assign(scope, isOpen);
	              }
	            }
	
	            ttScope.contentExp = function () {
	              return ttScope.content;
	            };
	
	            /**
	             * Observe the relevant attributes.
	             */
	            attrs.$observe('disabled', function (val) {
	              if (val) {
	                cancelShow();
	              }
	
	              if (val && ttScope.isOpen) {
	                hide();
	              }
	            });
	
	            if (isOpenParse) {
	              scope.$watch(isOpenParse, function (val) {
	                if (ttScope && !val === ttScope.isOpen) {
	                  toggleTooltipBind();
	                }
	              });
	            }
	
	            function prepObservers() {
	              observers.length = 0;
	
	              if (contentParse) {
	                observers.push(scope.$watch(contentParse, function (val) {
	                  ttScope.content = val;
	                  if (!val && ttScope.isOpen) {
	                    hide();
	                  }
	                }));
	
	                observers.push(tooltipLinkedScope.$watch(function () {
	                  if (!repositionScheduled) {
	                    repositionScheduled = true;
	                    tooltipLinkedScope.$$postDigest(function () {
	                      repositionScheduled = false;
	                      if (ttScope && ttScope.isOpen) {
	                        positionTooltip();
	                      }
	                    });
	                  }
	                }));
	              } else {
	                observers.push(attrs.$observe(ttType, function (val) {
	                  ttScope.content = val;
	                  if (!val && ttScope.isOpen) {
	                    hide();
	                  } else {
	                    positionTooltip();
	                  }
	                }));
	              }
	
	              observers.push(attrs.$observe(prefix + 'Title', function (val) {
	                ttScope.title = val;
	                if (ttScope.isOpen) {
	                  positionTooltip();
	                }
	              }));
	
	              observers.push(attrs.$observe(prefix + 'Placement', function (val) {
	                ttScope.placement = val ? val : options.placement;
	                if (ttScope.isOpen) {
	                  positionTooltip();
	                }
	              }));
	            }
	
	            function unregisterObservers() {
	              if (observers.length) {
	                angular.forEach(observers, function (observer) {
	                  observer();
	                });
	                observers.length = 0;
	              }
	            }
	
	            // hide tooltips/popovers for outsideClick trigger
	            function bodyHideTooltipBind(e) {
	              if (!ttScope || !ttScope.isOpen || !tooltip) {
	                return;
	              }
	              // make sure the tooltip/popover link or tool tooltip/popover itself were not clicked
	              if (!element[0].contains(e.target) && !tooltip[0].contains(e.target)) {
	                hideTooltipBind();
	              }
	            }
	
	            // KeyboardEvent handler to hide the tooltip on Escape key press
	            function hideOnEscapeKey(e) {
	              if (e.which === 27) {
	                hideTooltipBind();
	              }
	            }
	
	            var unregisterTriggers = function unregisterTriggers() {
	              triggers.show.forEach(function (trigger) {
	                if (trigger === 'outsideClick') {
	                  element.off('click', toggleTooltipBind);
	                } else {
	                  element.off(trigger, showTooltipBind);
	                  element.off(trigger, toggleTooltipBind);
	                }
	                element.off('keypress', hideOnEscapeKey);
	              });
	              triggers.hide.forEach(function (trigger) {
	                if (trigger === 'outsideClick') {
	                  $document.off('click', bodyHideTooltipBind);
	                } else {
	                  element.off(trigger, hideTooltipBind);
	                }
	              });
	            };
	
	            function prepTriggers() {
	              var showTriggers = [],
	                  hideTriggers = [];
	              var val = scope.$eval(attrs[prefix + 'Trigger']);
	              unregisterTriggers();
	
	              if (angular.isObject(val)) {
	                Object.keys(val).forEach(function (key) {
	                  showTriggers.push(key);
	                  hideTriggers.push(val[key]);
	                });
	                triggers = {
	                  show: showTriggers,
	                  hide: hideTriggers
	                };
	              } else {
	                triggers = getTriggers(val);
	              }
	
	              if (triggers.show !== 'none') {
	                triggers.show.forEach(function (trigger, idx) {
	                  if (trigger === 'outsideClick') {
	                    element.on('click', toggleTooltipBind);
	                    $document.on('click', bodyHideTooltipBind);
	                  } else if (trigger === triggers.hide[idx]) {
	                    element.on(trigger, toggleTooltipBind);
	                  } else if (trigger) {
	                    element.on(trigger, showTooltipBind);
	                    element.on(triggers.hide[idx], hideTooltipBind);
	                  }
	                  element.on('keypress', hideOnEscapeKey);
	                });
	              }
	            }
	
	            prepTriggers();
	
	            var animation = scope.$eval(attrs[prefix + 'Animation']);
	            ttScope.animation = angular.isDefined(animation) ? !!animation : options.animation;
	
	            var appendToBodyVal;
	            var appendKey = prefix + 'AppendToBody';
	            if (appendKey in attrs && attrs[appendKey] === undefined) {
	              appendToBodyVal = true;
	            } else {
	              appendToBodyVal = scope.$eval(attrs[appendKey]);
	            }
	
	            appendToBody = angular.isDefined(appendToBodyVal) ? appendToBodyVal : appendToBody;
	
	            // Make sure tooltip is destroyed and removed.
	            scope.$on('$destroy', function onDestroyTooltip() {
	              unregisterTriggers();
	              removeTooltip();
	              ttScope = null;
	            });
	          };
	        }
	      };
	    };
	  }];
	})
	
	// This is mostly ngInclude code but with a custom scope
	.directive('uibTooltipTemplateTransclude', ['$animate', '$sce', '$compile', '$templateRequest', function ($animate, $sce, $compile, $templateRequest) {
	  return {
	    link: function link(scope, elem, attrs) {
	      var origScope = scope.$eval(attrs.tooltipTemplateTranscludeScope);
	
	      var changeCounter = 0,
	          currentScope,
	          previousElement,
	          currentElement;
	
	      var cleanupLastIncludeContent = function cleanupLastIncludeContent() {
	        if (previousElement) {
	          previousElement.remove();
	          previousElement = null;
	        }
	
	        if (currentScope) {
	          currentScope.$destroy();
	          currentScope = null;
	        }
	
	        if (currentElement) {
	          $animate.leave(currentElement).then(function () {
	            previousElement = null;
	          });
	          previousElement = currentElement;
	          currentElement = null;
	        }
	      };
	
	      scope.$watch($sce.parseAsResourceUrl(attrs.uibTooltipTemplateTransclude), function (src) {
	        var thisChangeId = ++changeCounter;
	
	        if (src) {
	          //set the 2nd param to true to ignore the template request error so that the inner
	          //contents and scope can be cleaned up.
	          $templateRequest(src, true).then(function (response) {
	            if (thisChangeId !== changeCounter) {
	              return;
	            }
	            var newScope = origScope.$new();
	            var template = response;
	
	            var clone = $compile(template)(newScope, function (clone) {
	              cleanupLastIncludeContent();
	              $animate.enter(clone, elem);
	            });
	
	            currentScope = newScope;
	            currentElement = clone;
	
	            currentScope.$emit('$includeContentLoaded', src);
	          }, function () {
	            if (thisChangeId === changeCounter) {
	              cleanupLastIncludeContent();
	              scope.$emit('$includeContentError', src);
	            }
	          });
	          scope.$emit('$includeContentRequested', src);
	        } else {
	          cleanupLastIncludeContent();
	        }
	      });
	
	      scope.$on('$destroy', cleanupLastIncludeContent);
	    }
	  };
	}])
	
	/**
	 * Note that it's intentional that these classes are *not* applied through $animate.
	 * They must not be animated as they're expected to be present on the tooltip on
	 * initialization.
	 */
	.directive('uibTooltipClasses', ['$uibPosition', function ($uibPosition) {
	  return {
	    restrict: 'A',
	    link: function link(scope, element, attrs) {
	      // need to set the primary position so the
	      // arrow has space during position measure.
	      // tooltip.positionTooltip()
	      if (scope.placement) {
	        // // There are no top-left etc... classes
	        // // in TWBS, so we need the primary position.
	        var position = $uibPosition.parsePlacement(scope.placement);
	        element.addClass(position[0]);
	      }
	
	      if (scope.popupClass) {
	        element.addClass(scope.popupClass);
	      }
	
	      if (scope.animation) {
	        element.addClass(attrs.tooltipAnimationClass);
	      }
	    }
	  };
	}]).directive('uibTooltipPopup', function () {
	  return {
	    restrict: 'A',
	    scope: { content: '@' },
	    templateUrl: 'uib/template/tooltip/tooltip-popup.html'
	  };
	}).directive('uibTooltip', ['$uibTooltip', function ($uibTooltip) {
	  return $uibTooltip('uibTooltip', 'tooltip', 'mouseenter');
	}]).directive('uibTooltipTemplatePopup', function () {
	  return {
	    restrict: 'A',
	    scope: { contentExp: '&', originScope: '&' },
	    templateUrl: 'uib/template/tooltip/tooltip-template-popup.html'
	  };
	}).directive('uibTooltipTemplate', ['$uibTooltip', function ($uibTooltip) {
	  return $uibTooltip('uibTooltipTemplate', 'tooltip', 'mouseenter', {
	    useContentExp: true
	  });
	}]).directive('uibTooltipHtmlPopup', function () {
	  return {
	    restrict: 'A',
	    scope: { contentExp: '&' },
	    templateUrl: 'uib/template/tooltip/tooltip-html-popup.html'
	  };
	}).directive('uibTooltipHtml', ['$uibTooltip', function ($uibTooltip) {
	  return $uibTooltip('uibTooltipHtml', 'tooltip', 'mouseenter', {
	    useContentExp: true
	  });
	}]);

/***/ }),
/* 531 */
/***/ (function(module, exports) {

	"use strict";
	
	angular.module("uib/template/accordion/accordion-group.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/accordion/accordion-group.html", "<div role=\"tab\" id=\"{{::headingId}}\" aria-selected=\"{{isOpen}}\" class=\"panel-heading\" ng-keypress=\"toggleOpen($event)\">\n" + "  <h4 class=\"panel-title\">\n" + "    <a role=\"button\" data-toggle=\"collapse\" href aria-expanded=\"{{isOpen}}\" aria-controls=\"{{::panelId}}\" tabindex=\"0\" class=\"accordion-toggle\" ng-click=\"toggleOpen()\" uib-accordion-transclude=\"heading\" ng-disabled=\"isDisabled\" uib-tabindex-toggle><span uib-accordion-header ng-class=\"{'text-muted': isDisabled}\">{{heading}}</span></a>\n" + "  </h4>\n" + "</div>\n" + "<div id=\"{{::panelId}}\" aria-labelledby=\"{{::headingId}}\" aria-hidden=\"{{!isOpen}}\" role=\"tabpanel\" class=\"panel-collapse collapse\" uib-collapse=\"!isOpen\">\n" + "  <div class=\"panel-body\" ng-transclude></div>\n" + "</div>\n" + "");
	}]);

/***/ }),
/* 532 */
/***/ (function(module, exports) {

	"use strict";
	
	angular.module("uib/template/accordion/accordion.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/accordion/accordion.html", "<div role=\"tablist\" class=\"panel-group\" ng-transclude></div>");
	}]);

/***/ }),
/* 533 */
/***/ (function(module, exports) {

	"use strict";
	
	angular.module("uib/template/alert/alert.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/alert/alert.html", "<button ng-show=\"closeable\" type=\"button\" class=\"close\" ng-click=\"close({$event: $event})\">\n" + "  <span aria-hidden=\"true\">&times;</span>\n" + "  <span class=\"sr-only\">Close</span>\n" + "</button>\n" + "<div ng-transclude></div>\n" + "");
	}]);

/***/ }),
/* 534 */
/***/ (function(module, exports) {

	"use strict";
	
	angular.module("uib/template/datepicker/datepicker.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/datepicker/datepicker.html", "<div ng-switch=\"datepickerMode\">\n" + "  <div uib-daypicker ng-switch-when=\"day\" tabindex=\"0\" class=\"uib-daypicker\"></div>\n" + "  <div uib-monthpicker ng-switch-when=\"month\" tabindex=\"0\" class=\"uib-monthpicker\"></div>\n" + "  <div uib-yearpicker ng-switch-when=\"year\" tabindex=\"0\" class=\"uib-yearpicker\"></div>\n" + "</div>\n" + "");
	}]);

/***/ }),
/* 535 */
/***/ (function(module, exports) {

	"use strict";
	
	angular.module("uib/template/datepicker/day.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/datepicker/day.html", "<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" + "  <thead>\n" + "    <tr>\n" + "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left uib-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"fa fa-angle-double-left\"></i><span class=\"sr-only\">previous</span></button></th>\n" + "      <th colspan=\"{{::5 + showWeeks}}\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm uib-title\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\"><strong>{{title}}</strong></button></th>\n" + "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right uib-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"fa fa-angle-double-right\"></i><span class=\"sr-only\">next</span></button></th>\n" + "    </tr>\n" + "    <tr>\n" + "      <th ng-if=\"showWeeks\" class=\"text-center\"></th>\n" + "      <th ng-repeat=\"label in ::labels track by $index\" class=\"text-center\"><small aria-label=\"{{::label.full}}\">{{::label.abbr}}</small></th>\n" + "    </tr>\n" + "  </thead>\n" + "  <tbody>\n" + "    <tr class=\"uib-weeks\" ng-repeat=\"row in rows track by $index\" role=\"row\">\n" + "      <td ng-if=\"showWeeks\" class=\"text-center h6\"><em>{{ weekNumbers[$index] }}</em></td>\n" + "      <td ng-repeat=\"dt in row\" class=\"uib-day text-center\" role=\"gridcell\"\n" + "        id=\"{{::dt.uid}}\"\n" + "        ng-class=\"::dt.customClass\">\n" + "        <button type=\"button\" class=\"btn btn-default btn-sm\"\n" + "          uib-is-class=\"\n" + "            'btn-info' for selectedDt,\n" + "            'active' for activeDt\n" + "            on dt\"\n" + "          ng-click=\"select(dt.date)\"\n" + "          ng-disabled=\"::dt.disabled\"\n" + "          tabindex=\"-1\"><span ng-class=\"::{'text-muted': dt.secondary, 'text-info': dt.current}\">{{::dt.label}}</span></button>\n" + "      </td>\n" + "    </tr>\n" + "  </tbody>\n" + "</table>\n" + "");
	}]);

/***/ }),
/* 536 */
/***/ (function(module, exports) {

	"use strict";
	
	angular.module("uib/template/datepicker/month.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/datepicker/month.html", "<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" + "  <thead>\n" + "    <tr>\n" + "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left uib-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"fa fa-angle-double-left\"></i><span class=\"sr-only\">previous</span></button></th>\n" + "      <th colspan=\"{{::yearHeaderColspan}}\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm uib-title\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\"><strong>{{title}}</strong></button></th>\n" + "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right uib-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"fa fa-angle-double-right\"></i><span class=\"sr-only\">next</span></i></button></th>\n" + "    </tr>\n" + "  </thead>\n" + "  <tbody>\n" + "    <tr class=\"uib-months\" ng-repeat=\"row in rows track by $index\" role=\"row\">\n" + "      <td ng-repeat=\"dt in row\" class=\"uib-month text-center\" role=\"gridcell\"\n" + "        id=\"{{::dt.uid}}\"\n" + "        ng-class=\"::dt.customClass\">\n" + "        <button type=\"button\" class=\"btn btn-default\"\n" + "          uib-is-class=\"\n" + "            'btn-info' for selectedDt,\n" + "            'active' for activeDt\n" + "            on dt\"\n" + "          ng-click=\"select(dt.date)\"\n" + "          ng-disabled=\"::dt.disabled\"\n" + "          tabindex=\"-1\"><span ng-class=\"::{'text-info': dt.current}\">{{::dt.label}}</span></button>\n" + "      </td>\n" + "    </tr>\n" + "  </tbody>\n" + "</table>\n" + "");
	}]);

/***/ }),
/* 537 */
/***/ (function(module, exports) {

	"use strict";
	
	angular.module("uib/template/datepicker/year.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/datepicker/year.html", "<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" + "  <thead>\n" + "    <tr>\n" + "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left uib-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"fa fa-angle-double-left\"></i><span class=\"sr-only\">previous</span></button></th>\n" + "      <th colspan=\"{{::columns - 2}}\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm uib-title\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\"><strong>{{title}}</strong></button></th>\n" + "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right uib-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"fa fa-angle-double-right\"></i><span class=\"sr-only\">next</span></button></th>\n" + "    </tr>\n" + "  </thead>\n" + "  <tbody>\n" + "    <tr class=\"uib-years\" ng-repeat=\"row in rows track by $index\" role=\"row\">\n" + "      <td ng-repeat=\"dt in row\" class=\"uib-year text-center\" role=\"gridcell\"\n" + "        id=\"{{::dt.uid}}\"\n" + "        ng-class=\"::dt.customClass\">\n" + "        <button type=\"button\" class=\"btn btn-default\"\n" + "          uib-is-class=\"\n" + "            'btn-info' for selectedDt,\n" + "            'active' for activeDt\n" + "            on dt\"\n" + "          ng-click=\"select(dt.date)\"\n" + "          ng-disabled=\"::dt.disabled\"\n" + "          tabindex=\"-1\"><span ng-class=\"::{'text-info': dt.current}\">{{::dt.label}}</span></button>\n" + "      </td>\n" + "    </tr>\n" + "  </tbody>\n" + "</table>\n" + "");
	}]);

/***/ }),
/* 538 */
/***/ (function(module, exports) {

	"use strict";
	
	angular.module("uib/template/datepickerPopup/popup.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/datepickerPopup/popup.html", "<ul role=\"presentation\" class=\"uib-datepicker-popup dropdown-menu uib-position-measure\" dropdown-nested ng-if=\"isOpen\" ng-keydown=\"keydown($event)\" ng-click=\"$event.stopPropagation()\">\n" + "  <li ng-transclude></li>\n" + "  <li ng-if=\"showButtonBar\" class=\"uib-button-bar\">\n" + "    <span class=\"btn-group pull-left\">\n" + "      <button type=\"button\" md-effect class=\"btn btn-sm btn-primary uib-datepicker-current\" ng-click=\"select('today', $event)\" ng-disabled=\"isDisabled('today')\">{{ getText('current') }}</button>\n" + "      <button type=\"button\" md-effect class=\"btn btn-sm btn-default uib-clear\" ng-click=\"select(null, $event)\">{{ getText('clear') }}</button>\n" + "    </span>\n" + "    <button type=\"button\" md-effect class=\"btn btn-sm btn-default pull-right uib-close\" ng-click=\"close($event)\">{{ getText('close') }}</button>\n" + "  </li>\n" + "</ul>\n" + "");
	}]);

/***/ }),
/* 539 */
/***/ (function(module, exports) {

	"use strict";
	
	angular.module("uib/template/modal/window.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/modal/window.html", "<div class=\"modal-dialog {{size ? 'modal-' + size : ''}}\"><div class=\"modal-content\" uib-modal-transclude></div></div>\n" + "");
	}]);

/***/ }),
/* 540 */
/***/ (function(module, exports) {

	"use strict";
	
	angular.module("uib/template/popover/popover-html.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/popover/popover-html.html", "<div class=\"arrow\"></div>\n" + "\n" + "<div class=\"popover-inner\">\n" + "    <h3 class=\"popover-title\" ng-bind=\"uibTitle\" ng-if=\"uibTitle\"></h3>\n" + "    <div class=\"popover-content\" ng-bind-html=\"contentExp()\"></div>\n" + "</div>\n" + "");
	}]);

/***/ }),
/* 541 */
/***/ (function(module, exports) {

	"use strict";
	
	angular.module("uib/template/popover/popover-template.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/popover/popover-template.html", "<div class=\"arrow\"></div>\n" + "\n" + "<div class=\"popover-inner\">\n" + "    <h3 class=\"popover-title\" ng-bind=\"uibTitle\" ng-if=\"uibTitle\"></h3>\n" + "    <div class=\"popover-content\"\n" + "      uib-tooltip-template-transclude=\"contentExp()\"\n" + "      tooltip-template-transclude-scope=\"originScope()\"></div>\n" + "</div>\n" + "");
	}]);

/***/ }),
/* 542 */
/***/ (function(module, exports) {

	"use strict";
	
	angular.module("uib/template/popover/popover.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/popover/popover.html", "<div class=\"arrow\"></div>\n" + "\n" + "<div class=\"popover-inner\">\n" + "    <h3 class=\"popover-title\" ng-bind=\"uibTitle\" ng-if=\"uibTitle\"></h3>\n" + "    <div class=\"popover-content\" ng-bind=\"content\"></div>\n" + "</div>\n" + "");
	}]);

/***/ }),
/* 543 */
/***/ (function(module, exports) {

	"use strict";
	
	angular.module("uib/template/tabs/tab.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/tabs/tab.html", "<li ng-class=\"[{active: active, disabled: disabled}, classes]\" class=\"uib-tab nav-item\">\n" + "  <a href ng-click=\"select($event)\" class=\"nav-link\" uib-tab-heading-transclude>{{heading}}</a>\n" + "</li>\n" + "");
	}]);

/***/ }),
/* 544 */
/***/ (function(module, exports) {

	"use strict";
	
	angular.module("uib/template/tabs/tabset.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/tabs/tabset.html", "<div>\n" + "  <ul class=\"nav nav-{{tabset.type || 'tabs'}}\" ng-class=\"{'nav-stacked': vertical, 'nav-justified': justified}\" ng-transclude></ul>\n" + "  <div class=\"tab-content\">\n" + "    <div class=\"tab-pane\"\n" + "         ng-repeat=\"tab in tabset.tabs\"\n" + "         ng-class=\"{active: tabset.active === tab.index}\"\n" + "         uib-tab-content-transclude=\"tab\">\n" + "    </div>\n" + "  </div>\n" + "</div>\n" + "");
	}]);

/***/ }),
/* 545 */
/***/ (function(module, exports) {

	"use strict";
	
	angular.module("uib/template/timepicker/timepicker.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/timepicker/timepicker.html", "<table class=\"uib-timepicker\">\n" + "  <tbody>\n" + "    <tr class=\"text-center\" ng-show=\"::showSpinners\">\n" + "      <td class=\"uib-increment hours\"><a ng-click=\"incrementHours()\" ng-class=\"{disabled: noIncrementHours()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementHours()\" tabindex=\"-1\"><span class=\"fa fa-angle-up\"></span></a></td>\n" + "      <td>&nbsp;</td>\n" + "      <td class=\"uib-increment minutes\"><a ng-click=\"incrementMinutes()\" ng-class=\"{disabled: noIncrementMinutes()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementMinutes()\" tabindex=\"-1\"><span class=\"fa fa-angle-up\"></span></a></td>\n" + "      <td ng-show=\"showSeconds\">&nbsp;</td>\n" + "      <td ng-show=\"showSeconds\" class=\"uib-increment seconds\"><a ng-click=\"incrementSeconds()\" ng-class=\"{disabled: noIncrementSeconds()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementSeconds()\" tabindex=\"-1\"><span class=\"fa fa-angle-up\"></span></a></td>\n" + "      <td ng-show=\"showMeridian\"></td>\n" + "    </tr>\n" + "    <tr>\n" + "      <td class=\"form-group uib-time hours\" ng-class=\"{'has-error': invalidHours}\">\n" + "        <input type=\"text\" placeholder=\"HH\" ng-model=\"hours\" ng-change=\"updateHours()\" class=\"form-control text-center\" ng-readonly=\"::readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementHours()\" ng-blur=\"blur()\">\n" + "      </td>\n" + "      <td class=\"uib-separator\">:</td>\n" + "      <td class=\"form-group uib-time minutes\" ng-class=\"{'has-error': invalidMinutes}\">\n" + "        <input type=\"text\" placeholder=\"MM\" ng-model=\"minutes\" ng-change=\"updateMinutes()\" class=\"form-control text-center\" ng-readonly=\"::readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementMinutes()\" ng-blur=\"blur()\">\n" + "      </td>\n" + "      <td ng-show=\"showSeconds\" class=\"uib-separator\">:</td>\n" + "      <td class=\"form-group uib-time seconds\" ng-class=\"{'has-error': invalidSeconds}\" ng-show=\"showSeconds\">\n" + "        <input type=\"text\" placeholder=\"SS\" ng-model=\"seconds\" ng-change=\"updateSeconds()\" class=\"form-control text-center\" ng-readonly=\"readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementSeconds()\" ng-blur=\"blur()\">\n" + "      </td>\n" + "      <td ng-show=\"showMeridian\" class=\"uib-time am-pm\"><button type=\"button\" ng-class=\"{disabled: noToggleMeridian()}\" class=\"btn btn-default text-center\" ng-click=\"toggleMeridian()\" ng-disabled=\"noToggleMeridian()\" tabindex=\"{{::tabindex}}\">{{meridian}}</button></td>\n" + "    </tr>\n" + "    <tr class=\"text-center\" ng-show=\"::showSpinners\">\n" + "      <td class=\"uib-decrement hours\"><a ng-click=\"decrementHours()\" ng-class=\"{disabled: noDecrementHours()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementHours()\" tabindex=\"-1\"><span class=\"fa fa-angle-down\"></span></a></td>\n" + "      <td>&nbsp;</td>\n" + "      <td class=\"uib-decrement minutes\"><a ng-click=\"decrementMinutes()\" ng-class=\"{disabled: noDecrementMinutes()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementMinutes()\" tabindex=\"-1\"><span class=\"fa fa-angle-down\"></span></a></td>\n" + "      <td ng-show=\"showSeconds\">&nbsp;</td>\n" + "      <td ng-show=\"showSeconds\" class=\"uib-decrement seconds\"><a ng-click=\"decrementSeconds()\" ng-class=\"{disabled: noDecrementSeconds()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementSeconds()\" tabindex=\"-1\"><span class=\"fa fa-angle-down\"></span></a></td>\n" + "      <td ng-show=\"showMeridian\"></td>\n" + "    </tr>\n" + "  </tbody>\n" + "</table>\n" + "");
	}]);

/***/ }),
/* 546 */
/***/ (function(module, exports) {

	"use strict";
	
	angular.module("uib/template/tooltip/tooltip-html-popup.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/tooltip/tooltip-html-popup.html", "<div class=\"tooltip-arrow\"></div>\n" + "<div class=\"tooltip-inner\" ng-bind-html=\"contentExp()\"></div>\n" + "");
	}]);

/***/ }),
/* 547 */
/***/ (function(module, exports) {

	"use strict";
	
	angular.module("uib/template/tooltip/tooltip-popup.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/tooltip/tooltip-popup.html", "<div class=\"tooltip-arrow\"></div>\n" + "<div class=\"tooltip-inner\" ng-bind=\"content\"></div>\n" + "");
	}]);

/***/ }),
/* 548 */
/***/ (function(module, exports) {

	"use strict";
	
	angular.module("uib/template/tooltip/tooltip-template-popup.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/tooltip/tooltip-template-popup.html", "<div class=\"tooltip-arrow\"></div>\n" + "<div class=\"tooltip-inner\"\n" + "  uib-tooltip-template-transclude=\"contentExp()\"\n" + "  tooltip-template-transclude-scope=\"originScope()\"></div>\n" + "");
	}]);

/***/ }),
/* 549 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var Formly = angular.module('vendor.formly', []).run(["formlyConfig", "formlyValidationMessages", function (formlyConfig, formlyValidationMessages) {
	    'ngInject';
	    /* Datepicker */
	
	    var attributes = ['date-disabled', 'custom-class', 'show-weeks', 'starting-day', 'init-date', 'min-mode', 'max-mode', 'format-day', 'format-month', 'format-year', 'format-day-header', 'format-day-title', 'format-month-title', 'year-range', 'shortcut-propagation', 'datepicker-popup', 'show-button-bar', 'current-text', 'clear-text', 'close-text', 'close-on-date-selection', 'datepicker-append-to-body'];
	
	    var bindings = ['datepicker-mode', 'min-date', 'max-date'];
	
	    var ngModelAttrs = {};
	
	    angular.forEach(attributes, function (attr) {
	        ngModelAttrs[camelize(attr)] = { attribute: attr };
	    });
	
	    angular.forEach(bindings, function (binding) {
	        ngModelAttrs[camelize(binding)] = { bound: binding };
	    });
	
	    formlyConfig.setType({
	        name: 'datepicker',
	        template: '\n                <p class="input-group">\n                    <input  type="text"\n                            id="{{::id}}"\n                            name="{{::id}}"\n                            ng-model="model[options.key]"\n                            class="form-control"\n                            ng-click="datepicker.open($event)"\n                            uib-datepicker-popup="{{to.datepickerOptions.format}}"\n                            is-open="datepicker.opened"\n                            datepicker-options="to.datepickerOptions" />\n                    <span class="input-group-btn">\n                        <button type="button" class="btn btn-default" ng-click="datepicker.open($event)" ng-disabled="to.disabled"><i class="fa fa-calendar"></i></button>\n                    </span>\n                </p>\n            ',
	        wrapper: ['bootstrapLabel', 'bootstrapHasError'],
	        defaultOptions: {
	            ngModelAttrs: ngModelAttrs,
	            templateOptions: {
	                datepickerOptions: {
	                    format: 'dd/MM/yyyy',
	                    initDate: new Date()
	                }
	            }
	        },
	        controller: ['$scope', function ($scope) {
	            $scope.datepicker = {};
	            $scope.datepicker.opened = false;
	
	            $scope.datepicker.open = function ($event) {
	                $scope.datepicker.opened = !$scope.datepicker.opened;
	            };
	        }]
	    });
	
	    /* timepicker */
	
	    ngModelAttrs = {};
	
	    angular.forEach(['meridians', 'readonly-input', 'mousewheel', 'arrowkeys'], function (attr) {
	        ngModelAttrs[camelize(attr)] = { attribute: attr };
	    });
	
	    angular.forEach(['hour-step', 'minute-step', 'show-meridian'], function (binding) {
	        ngModelAttrs[camelize(binding)] = { bound: binding };
	    });
	
	    formlyConfig.setType({
	        name: 'timepicker',
	        template: '<timepicker ng-model="model[options.key]"></timepicker>',
	        wrapper: ['bootstrapLabel', 'bootstrapHasError'],
	        defaultOptions: {
	            ngModelAttrs: ngModelAttrs,
	            templateOptions: {
	                datepickerOptions: {}
	            }
	        }
	    });
	
	    function camelize(string) {
	        string = string.replace(/[\-_\s]+(.)?/g, function (match, chr) {
	            return chr ? chr.toUpperCase() : '';
	        });
	
	        return string.replace(/^([A-Z])/, function (match, chr) {
	            return chr ? chr.toLowerCase() : '';
	        });
	    }
	
	    formlyConfig.extras.errorExistsAndShouldBeVisibleExpression = 'fc.$touched || form.$submitted';
	
	    formlyValidationMessages.addStringMessage('required', 'El campo es obligatorio');
	}]).name;
	
	exports.default = Formly;

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ImageViewer = undefined;
	
	var _imageViewer = __webpack_require__(589);
	
	var _imageViewer2 = _interopRequireDefault(_imageViewer);
	
	__webpack_require__(172);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Marcelo Alejo Calle
	 */
	var ImageViewer = exports.ImageViewer = ["$window", "$document", "$timeout", "$compile", function ImageViewer($window, $document, $timeout, $compile) {
	  'ngInject';
	
	  /**
	   * b64toBlob - Convert base64 string to a Blob object
	   *
	   * @param  {string}  b64Data     Base64 string
	   * @param  {strig}   contentType Type of base64 file
	   * @param  {integer} sliceSize   Slice for performance
	   * @return {Blob}                Blob object
	   * @description https://stackoverflow.com/questions/16245767/creating-a-blob-from-a-base64-string-in-javascript
	   */
	
	  var b64toBlob = function b64toBlob(b64Data, contentType, sliceSize) {
	    contentType = contentType || '';
	    sliceSize = sliceSize || 512;
	
	    var byteCharacters = void 0;
	    if (b64Data.split(',')[0].indexOf('base64') >= 0) {
	      byteCharacters = atob(b64Data.split(',')[1]);
	    } else {
	      byteCharacters = atob(b64Data);
	    }
	    var byteArrays = [];
	
	    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
	      var slice = byteCharacters.slice(offset, offset + sliceSize);
	
	      var byteNumbers = new Array(slice.length);
	      for (var i = 0; i < slice.length; i++) {
	        byteNumbers[i] = slice.charCodeAt(i);
	      }
	
	      var byteArray = new window.Uint8Array(byteNumbers);
	
	      byteArrays.push(byteArray);
	    }
	
	    var blob = new Blob(byteArrays, { type: contentType });
	    return blob;
	  };
	
	  var imageSize = function imageSize(img) {
	    var image = {};
	    if (img && img.src) {
	      image.size = Math.round((img.src.length - 22) * 3 / 4);
	    } else {
	      image.size = img;
	    }
	    image.unit = 'B';
	    if (image.size >= 1000) {
	      image.size = image.size / 1000;
	      image.unit = 'KB';
	    }
	    if (image.size >= 1000) {
	      image.size = image.size / 1000;
	      image.unit = 'MB';
	    }
	    if (image.size.toFixed) {
	      image.size = image.size.toFixed(1);
	    }
	    return image;
	  };
	
	  return {
	    restrict: 'E',
	    template: _imageViewer2.default,
	    scope: {
	      base64: '=',
	      vm: '=?'
	    },
	
	    link: function link($scope, $element, $attrs) {
	      var image = $element.find('img')[0];
	      var canvas = $element.find('canvas')[0];
	      var ctx = canvas.getContext('2d');
	      var scale = 100;
	      var rotate = 0;
	      var objImage = new Image();
	
	      if ($scope.vm) {
	        $scope.vm = $scope;
	      }
	      if (!$scope.tipo) {
	        $scope.tipo = 'image/jpeg';
	      }
	      // Objeto para restaurar los cambios
	      // if($scope.base64.indexOf('base64')>0) {
	      //   image.src = $scope.base64;
	      // } else {
	      //   image.src = 'data:'+$scope.tipo+';base64,'+$scope.base64;
	      // }
	      if ($scope.base64.indexOf('base64') > 0) {
	        objImage.src = $scope.base64;
	      } else {
	        objImage.src = 'data:' + $scope.tipo + ';base64,' + $scope.base64;
	      }
	      objImage.id = 'image-viewer-print';
	      objImage.onload = function () {
	        canvas.width = objImage.width;
	        canvas.height = objImage.height;
	        ctx.drawImage(objImage, 0, 0);
	        $scope.imageDet = imageSize(objImage);
	        $scope.imageWidth = objImage.width;
	        $scope.imageHeight = objImage.height;
	      };
	
	      // funciones
	      $scope.imageZoom = function (zoom) {
	        if (zoom > 0) {
	          if (scale + zoom < 300) {
	            scale += zoom;
	            canvas.style.width = scale + '%';
	          }
	        } else if (zoom < 0) {
	          if (scale + zoom >= 10) {
	            scale += zoom;
	            canvas.style.width = scale + '%';
	          }
	        }
	      };
	
	      $scope.imageInvert = function () {
	        var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
	        var data = imageData.data;
	        for (var i = 0; i < data.length; i += 4) {
	          data[i] = 255 - data[i]; // red
	          data[i + 1] = 255 - data[i + 1]; // green
	          data[i + 2] = 255 - data[i + 2]; // blue
	        }
	        ctx.putImageData(imageData, 0, 0);
	        $scope.modificado = true;
	      };
	
	      $scope.imageGrayscale = function () {
	        var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
	        var data = imageData.data;
	        for (var i = 0; i < data.length; i += 4) {
	          var avg = (data[i] + data[i + 1] + data[i + 2]) / 3;
	          data[i] = avg; // red
	          data[i + 1] = avg; // green
	          data[i + 2] = avg; // blue
	        }
	        ctx.putImageData(imageData, 0, 0);
	        $scope.modificado = true;
	      };
	
	      $scope.imageRotate = function () {
	        rotate += 90;
	        if (function (rotate) {
	          return 360;
	        }) {
	          rotate = rotate % 360;
	        }
	        if (rotate % 180 == 0) {
	          canvas.width = objImage.width;
	          canvas.height = objImage.height;
	        } else {
	          canvas.width = objImage.height;
	          canvas.height = objImage.width;
	        }
	        ctx.clearRect(0, 0, canvas.width, canvas.height);
	        ctx.save();
	        ctx.translate(canvas.width / 2, canvas.height / 2);
	        ctx.rotate(rotate * Math.PI / 180);
	        ctx.drawImage(objImage, -objImage.width / 2, -objImage.height / 2);
	        ctx.restore();
	        // image.src = canvas.toDataURL('image/png');
	        $scope.imageDet = imageSize(Math.round((canvas.toDataURL('image/jpeg', 1).length - 23) * 3 / 4));
	        $scope.modificado = true;
	      };
	
	      $scope.imageDownload1 = function () {
	        $window.location.href = canvas.toDataURL('image/jpeg', 1).replace('image/jpeg', 'image/octet-stream');
	      };
	
	      $scope.imageDownload = function () {
	        if (!$scope.descargando) {
	          $scope.descargando = true;
	          var image64 = canvas.toDataURL('image/jpeg', 1);
	          var file = void 0,
	              a = document.createElement('a');
	          a.innerHTML = '.';
	          document.body.appendChild(a);
	          // $compile(a)(scope);
	          file = b64toBlob(image64, 'image/jpeg');
	          $scope.imageDet = imageSize(file.size);
	          if (window.navigator.msSaveBlob) {
	            window.navigator.msSaveOrOpenBlob(file, $scope.nombre || 'documento.jpg');
	            $scope.descargando = false;
	          } else {
	            a.href = window.URL.createObjectURL(file);
	            a.download = $scope.nombre || 'documento.jpg';
	            //a.target = '_blank';
	            $timeout(function () {
	              a.click();
	              $scope.descargando = false;
	              angular.element(a).remove();
	            }, 250);
	          }
	        }
	      };
	
	      $scope.imagePrint = function () {
	        if (!$scope.imprimiendo) {
	          $scope.imprimiendo = true;
	          var imagePrint = new Image();
	          imagePrint.src = canvas.toDataURL('image/jpeg', 1);
	          imagePrint.onload = function () {
	            if (imagePrint.height / imagePrint.width < 1.294118) {
	              // Relacion de aspecto tamaño carta y/x => 11/8.5
	              imagePrint.style = "width:100%;";
	            } else {
	              imagePrint.style = "height:100%;";
	            }
	            document.body.appendChild(imagePrint);
	            $window.print();
	            imagePrint.parentNode.removeChild(imagePrint);
	            $scope.imprimiendo = false;
	          };
	        }
	      };
	
	      $scope.imageSave = function () {
	        if ($scope.modificado) {
	          $scope.modificado = false;
	          $scope.base64 = canvas.toDataURL('image/jpeg', 1);
	          $scope.imageDet = imageSize(Math.round((canvas.toDataURL('image/jpeg', 1).length - 23) * 3 / 4));
	        }
	      };
	    }
	  };
	}];

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _imageViewer = __webpack_require__(550);
	
	var ImageViewerModule = angular.module('app.image-viewer', []).directive('imageViewer', _imageViewer.ImageViewer).name;
	
	exports.default = ImageViewerModule;

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	(function webpackUniversalModuleDefinition(root, factory) {
	    if (( false ? 'undefined' : _typeof(exports)) === 'object' && ( false ? 'undefined' : _typeof(module)) === 'object') module.exports = factory(__webpack_require__(9));else if (true) !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(9)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else if ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object') exports["ng-table"] = factory(require("angular"));else root["ng-table"] = factory(root["angular"]);
	})(undefined, function (__WEBPACK_EXTERNAL_MODULE_0__) {
	    return (/******/function (modules) {
	            // webpackBootstrap
	            /******/ // The module cache
	            /******/var installedModules = {};
	            /******/
	            /******/ // The require function
	            /******/function __webpack_require__(moduleId) {
	                /******/
	                /******/ // Check if module is in cache
	                /******/if (installedModules[moduleId])
	                    /******/return installedModules[moduleId].exports;
	                /******/
	                /******/ // Create a new module (and put it into the cache)
	                /******/var module = installedModules[moduleId] = {
	                    /******/i: moduleId,
	                    /******/l: false,
	                    /******/exports: {}
	                    /******/ };
	                /******/
	                /******/ // Execute the module function
	                /******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	                /******/
	                /******/ // Flag the module as loaded
	                /******/module.l = true;
	                /******/
	                /******/ // Return the exports of the module
	                /******/return module.exports;
	                /******/
	            }
	            /******/
	            /******/
	            /******/ // expose the modules object (__webpack_modules__)
	            /******/__webpack_require__.m = modules;
	            /******/
	            /******/ // expose the module cache
	            /******/__webpack_require__.c = installedModules;
	            /******/
	            /******/ // identity function for calling harmory imports with the correct context
	            /******/__webpack_require__.i = function (value) {
	                return value;
	            };
	            /******/
	            /******/ // define getter function for harmory exports
	            /******/__webpack_require__.d = function (exports, name, getter) {
	                /******/if (!__webpack_require__.o(exports, name)) {
	                    /******/Object.defineProperty(exports, name, {
	                        /******/configurable: false,
	                        /******/enumerable: true,
	                        /******/get: getter
	                        /******/ });
	                    /******/
	                }
	                /******/
	            };
	            /******/
	            /******/ // getDefaultExport function for compatibility with non-harmony modules
	            /******/__webpack_require__.n = function (module) {
	                /******/var getter = module && module.__esModule ?
	                /******/function getDefault() {
	                    return module['default'];
	                } :
	                /******/function getModuleExports() {
	                    return module;
	                };
	                /******/__webpack_require__.d(getter, 'a', getter);
	                /******/return getter;
	                /******/
	            };
	            /******/
	            /******/ // Object.prototype.hasOwnProperty.call
	            /******/__webpack_require__.o = function (object, property) {
	                return Object.prototype.hasOwnProperty.call(object, property);
	            };
	            /******/
	            /******/ // __webpack_public_path__
	            /******/__webpack_require__.p = "";
	            /******/
	            /******/ // Load entry module and return exports
	            /******/return __webpack_require__(__webpack_require__.s = 51);
	            /******/
	        }(
	        /************************************************************************/
	        /******/[
	        /* 0 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!**************************!*\
	          !*** external "angular" ***!
	          \**************************/
	        /***/function (module, exports) {
	
	            module.exports = __WEBPACK_EXTERNAL_MODULE_0__;
	
	            /***/
	        },
	        /* 1 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!***************************!*\
	          !*** ./src/core/index.ts ***!
	          \***************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            "use strict";
	            "use strict";
	
	            function __export(m) {
	                for (var p in m) {
	                    if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	                }
	            }
	            var angular = __webpack_require__( /*! angular */0);
	            var data_1 = __webpack_require__( /*! ./data */3);
	            var grouping_1 = __webpack_require__( /*! ./grouping */37);
	            var ngTableDefaults_1 = __webpack_require__( /*! ./ngTableDefaults */7);
	            var ngTableSettings_1 = __webpack_require__( /*! ./ngTableSettings */10);
	            var ngTableParams_1 = __webpack_require__( /*! ./ngTableParams */9);
	            var ngTableEventsChannel_1 = __webpack_require__( /*! ./ngTableEventsChannel */8);
	            var ngTableCoreModule = angular.module('ngTable-core', []).provider('ngTableDefaultGetData', data_1.NgTableDefaultGetDataProvider).factory('ngTableDefaultGetGroups', grouping_1.ngTableDefaultGetGroups).value('ngTableDefaults', ngTableDefaults_1.ngTableDefaults).service('ngTableEventsChannel', ngTableEventsChannel_1.NgTableEventsChannel).service('ngTableSettings', ngTableSettings_1.NgTableSettings).run(ngTableParams_1.NgTableParams.init);
	            exports.ngTableCoreModule = ngTableCoreModule;
	            // note: if you are using ES6 or typescript prefer:
	            // import { NgTableParams } from 'ng-table';
	            ngTableCoreModule.value('NgTableParams', ngTableParams_1.NgTableParams);
	            var ngTableDefaults_2 = __webpack_require__( /*! ./ngTableDefaults */7);
	            exports.IDefaults = ngTableDefaults_2.IDefaults;
	            __export(__webpack_require__( /*! ./ngTableEventsChannel */8));
	            var ngTableSettings_2 = __webpack_require__( /*! ./ngTableSettings */10);
	            exports.ISettings = ngTableSettings_2.ISettings;
	            __export(__webpack_require__( /*! ./ngTableParams */9));
	            __export(__webpack_require__( /*! ./data */3));
	            __export(__webpack_require__( /*! ./filtering */36));
	            __export(__webpack_require__( /*! ./grouping/publicExports */39));
	            __export(__webpack_require__( /*! ./paging */40));
	            __export(__webpack_require__( /*! ./sorting */41));
	
	            /***/
	        },
	        /* 2 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!******************************!*\
	          !*** ./src/browser/index.ts ***!
	          \******************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            "use strict";
	            "use strict";
	
	            function __export(m) {
	                for (var p in m) {
	                    if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	                }
	            }
	            var angular = __webpack_require__( /*! angular */0);
	            var ngTable_directive_1 = __webpack_require__( /*! ./ngTable.directive */13);
	            var ngTableColumn_1 = __webpack_require__( /*! ./ngTableColumn */14);
	            var ngTableColumnsBinding_directive_1 = __webpack_require__( /*! ./ngTableColumnsBinding.directive */15);
	            var ngTableController_1 = __webpack_require__( /*! ./ngTableController */16);
	            exports.NgTableController = ngTableController_1.NgTableController;
	            var ngTableDynamic_directive_1 = __webpack_require__( /*! ./ngTableDynamic.directive */17);
	            var ngTableFilterConfig_1 = __webpack_require__( /*! ./ngTableFilterConfig */18);
	            exports.NgTableFilterConfigProvider = ngTableFilterConfig_1.NgTableFilterConfigProvider;
	            exports.NgTableFilterConfig = ngTableFilterConfig_1.NgTableFilterConfig;
	            var ngTableFilterRow_directive_1 = __webpack_require__( /*! ./ngTableFilterRow.directive */19);
	            var ngTableFilterRowController_1 = __webpack_require__( /*! ./ngTableFilterRowController */20);
	            var ngTableGroupRow_directive_1 = __webpack_require__( /*! ./ngTableGroupRow.directive */21);
	            var ngTableGroupRowController_1 = __webpack_require__( /*! ./ngTableGroupRowController */22);
	            var ngTablePagination_directive_1 = __webpack_require__( /*! ./ngTablePagination.directive */23);
	            var ngTableSelectFilterDs_directive_1 = __webpack_require__( /*! ./ngTableSelectFilterDs.directive */24);
	            var ngTableSorterRow_directive_1 = __webpack_require__( /*! ./ngTableSorterRow.directive */25);
	            var ngTableSorterRowController_1 = __webpack_require__( /*! ./ngTableSorterRowController */26);
	            __webpack_require__( /*! ./filters/number.html */43);
	            __webpack_require__( /*! ./filters/select.html */45);
	            __webpack_require__( /*! ./filters/select-multiple.html */44);
	            __webpack_require__( /*! ./filters/text.html */46);
	            __webpack_require__( /*! ./filters/hidden.html */52);
	            __webpack_require__( /*! ./pager.html */49);
	            __webpack_require__( /*! ./header.html */48);
	            var ngTableBrowserModule = angular.module('ngTable-browser', []).directive('ngTable', ngTable_directive_1.ngTable).service('ngTableColumn', ngTableColumn_1.NgTableColumn).directive('ngTableColumnsBinding', ngTableColumnsBinding_directive_1.ngTableColumnsBinding).controller('ngTableController', ngTableController_1.NgTableController).directive('ngTableDynamic', ngTableDynamic_directive_1.ngTableDynamic).provider('ngTableFilterConfig', ngTableFilterConfig_1.NgTableFilterConfigProvider).directive('ngTableFilterRow', ngTableFilterRow_directive_1.ngTableFilterRow).controller('ngTableFilterRowController', ngTableFilterRowController_1.NgTableFilterRowController).directive('ngTableGroupRow', ngTableGroupRow_directive_1.ngTableGroupRow).controller('ngTableGroupRowController', ngTableGroupRowController_1.NgTableGroupRowController).directive('ngTablePagination', ngTablePagination_directive_1.ngTablePagination).directive('ngTableSelectFilterDs', ngTableSelectFilterDs_directive_1.ngTableSelectFilterDs).directive('ngTableSorterRow', ngTableSorterRow_directive_1.ngTableSorterRow).controller('ngTableSorterRowController', ngTableSorterRowController_1.NgTableSorterRowController);
	            exports.ngTableBrowserModule = ngTableBrowserModule;
	            __export(__webpack_require__( /*! ./public-interfaces */27));
	
	            /***/
	        },
	        /* 3 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!********************************!*\
	          !*** ./src/core/data/index.ts ***!
	          \********************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            "use strict";
	            "use strict";
	
	            function __export(m) {
	                for (var p in m) {
	                    if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	                }
	            }
	            __export(__webpack_require__( /*! ./dataSettings */28));
	            __export(__webpack_require__( /*! ./getData */29));
	            __export(__webpack_require__( /*! ./interceptor */30));
	            __export(__webpack_require__( /*! ./ngTableDefaultGetData */31));
	            __export(__webpack_require__( /*! ./results */32));
	
	            /***/
	        },
	        /* 4 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!***************************************!*\
	          !*** ./src/core/grouping/getGroup.ts ***!
	          \***************************************/
	        /***/function (module, exports) {
	
	            "use strict";
	            "use strict";
	
	            /***/
	        },
	        /* 5 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!********************************************!*\
	          !*** ./src/core/grouping/groupSettings.ts ***!
	          \********************************************/
	        /***/function (module, exports) {
	
	            "use strict";
	            "use strict";
	
	            /***/
	        },
	        /* 6 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!*******************************************!*\
	          !*** ./src/core/grouping/groupingFunc.ts ***!
	          \*******************************************/
	        /***/function (module, exports) {
	
	            "use strict";
	            "use strict";
	
	            /***/
	        },
	        /* 7 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!*************************************!*\
	          !*** ./src/core/ngTableDefaults.ts ***!
	          \*************************************/
	        /***/function (module, exports) {
	
	            "use strict";
	            /**
	             * ngTable: Table + Angular JS
	             *
	             * @author Vitalii Savchuk <esvit666@gmail.com>
	             * @url https://github.com/esvit/ng-table/
	             * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	             */
	            "use strict";
	            /**
	             * Default values for ngTable
	             */
	
	            exports.ngTableDefaults = {
	                params: {},
	                settings: {}
	            };
	
	            /***/
	        },
	        /* 8 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!******************************************!*\
	          !*** ./src/core/ngTableEventsChannel.ts ***!
	          \******************************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            "use strict";
	            /**
	             * ngTable: Table + Angular JS
	             *
	             * @author Vitalii Savchuk <esvit666@gmail.com>
	             * @url https://github.com/esvit/ng-table/
	             * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	             */
	            "use strict";
	
	            var ng1 = __webpack_require__( /*! angular */0);
	            var NgTableEventsChannel = function () {
	                function NgTableEventsChannel($rootScope) {
	                    this.$rootScope = $rootScope;
	                    var events = this;
	                    events = this.addTableParamsEvent('afterCreated', events);
	                    events = this.addTableParamsEvent('afterReloadData', events);
	                    events = this.addTableParamsEvent('datasetChanged', events);
	                    events = this.addTableParamsEvent('pagesChanged', events);
	                    events = this.addTableParamsEvent('afterDataFiltered', events);
	                    events = this.addTableParamsEvent('afterDataSorted', events);
	                }
	                NgTableEventsChannel.prototype.addTableParamsEvent = function (eventName, target) {
	                    var fnName = eventName.charAt(0).toUpperCase() + eventName.substring(1);
	                    var event = (_a = {}, _a['on' + fnName] = this.createEventSubscriptionFn(eventName), _a['publish' + fnName] = this.createPublishEventFn(eventName), _a);
	                    return ng1.extend(target, event);
	                    var _a;
	                };
	                NgTableEventsChannel.prototype.createPublishEventFn = function (eventName) {
	                    var _this = this;
	                    return function () {
	                        var args = [];
	                        for (var _i = 0; _i < arguments.length; _i++) {
	                            args[_i - 0] = arguments[_i];
	                        }
	                        (_a = _this.$rootScope).$broadcast.apply(_a, ['ngTable:' + eventName].concat(args));
	                        var _a;
	                    };
	                };
	                NgTableEventsChannel.prototype.createEventSubscriptionFn = function (eventName) {
	                    var _this = this;
	                    return function (handler, eventSelectorOrScope, eventSelector) {
	                        var actualEvtSelector;
	                        var scope = _this.$rootScope;
	                        if (isScopeLike(eventSelectorOrScope)) {
	                            scope = eventSelectorOrScope;
	                            actualEvtSelector = createEventSelectorFn(eventSelector);
	                        } else {
	                            actualEvtSelector = createEventSelectorFn(eventSelectorOrScope);
	                        }
	                        return scope.$on('ngTable:' + eventName, function (event, params) {
	                            var eventArgs = [];
	                            for (var _i = 2; _i < arguments.length; _i++) {
	                                eventArgs[_i - 2] = arguments[_i];
	                            }
	                            // don't send events published by the internal NgTableParams created by ngTableController
	                            if (params.isNullInstance) return;
	                            var fnArgs = [params].concat(eventArgs);
	                            if (actualEvtSelector.apply(this, fnArgs)) {
	                                handler.apply(this, fnArgs);
	                            }
	                        });
	                    };
	                    function createEventSelectorFn(eventSelector) {
	                        if (!eventSelector) {
	                            return function (publisher) {
	                                return true;
	                            };
	                        } else if (isEventSelectorFunc(eventSelector)) {
	                            return eventSelector;
	                        } else {
	                            // shorthand for subscriber to only receive events from a specific publisher instance
	                            return function (publisher) {
	                                return publisher === eventSelector;
	                            };
	                        }
	                    }
	                    function isEventSelectorFunc(val) {
	                        return typeof val === 'function';
	                    }
	                    function isScopeLike(val) {
	                        return val && typeof val.$new === 'function';
	                    }
	                };
	                NgTableEventsChannel.$inject = ['$rootScope'];
	                return NgTableEventsChannel;
	            }();
	            exports.NgTableEventsChannel = NgTableEventsChannel;
	
	            /***/
	        },
	        /* 9 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!***********************************!*\
	          !*** ./src/core/ngTableParams.ts ***!
	          \***********************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            "use strict";
	            /**
	             * ngTable: Table + Angular JS
	             *
	             * @author Vitalii Savchuk <esvit666@gmail.com>
	             * @url https://github.com/esvit/ng-table/
	             * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	             */
	            "use strict";
	
	            var ng1 = __webpack_require__( /*! angular */0);
	            var util_1 = __webpack_require__( /*! ./util */11);
	            /**
	             * @private
	             */
	            function isNumber(n) {
	                return !isNaN(parseFloat(n)) && isFinite(n);
	            }
	            /**
	             * Parameters manager for an ngTable directive
	             */
	            var NgTableParams = function () {
	                function NgTableParams(baseParameters, baseSettings) {
	                    var _this = this;
	                    /**
	                     * The page of data rows currently being displayed in the table
	                     */
	                    this.data = [];
	                    this.defaultSettings = NgTableParams.ngTableSettings.createDefaults();
	                    this.isCommittedDataset = false;
	                    this.initialEvents = [];
	                    this._params = {
	                        page: 1,
	                        count: 10,
	                        filter: {},
	                        sorting: {},
	                        group: {}
	                    };
	                    this._settings = this.defaultSettings;
	                    // the ngTableController "needs" to create a dummy/null instance and it's important to know whether an instance
	                    // is one of these
	                    if (typeof baseParameters === "boolean") {
	                        this.isNullInstance = true;
	                    }
	                    this.reloadPages = function () {
	                        var currentPages;
	                        return function () {
	                            var oldPages = currentPages;
	                            var newPages = _this.generatePagesArray(_this.page(), _this.total(), _this.count());
	                            if (!ng1.equals(oldPages, newPages)) {
	                                currentPages = newPages;
	                                NgTableParams.ngTableEventsChannel.publishPagesChanged(_this, newPages, oldPages);
	                            }
	                        };
	                    }();
	                    ng1.extend(this._params, NgTableParams.ngTableDefaults.params);
	                    this.settings(baseSettings);
	                    this.parameters(baseParameters, true);
	                    NgTableParams.ngTableEventsChannel.publishAfterCreated(this);
	                    // run events during construction after the initial create event. That way a consumer
	                    // can subscribe to all events for a table without "dropping" an event
	                    ng1.forEach(this.initialEvents, function (event) {
	                        event();
	                    });
	                    this.initialEvents = null;
	                }
	                NgTableParams.prototype.count = function (count) {
	                    // reset to first page because can be blank page
	                    return count !== undefined ? this.parameters({
	                        'count': count,
	                        'page': 1
	                    }) : this._params.count;
	                };
	                NgTableParams.prototype.filter = function (filter) {
	                    if (filter != null && (typeof filter === 'undefined' ? 'undefined' : _typeof(filter)) === 'object') {
	                        return this.parameters({
	                            'filter': filter,
	                            'page': 1
	                        });
	                    } else if (filter === true) {
	                        var keys = Object.keys(this._params.filter);
	                        var significantFilter = {};
	                        for (var i = 0; i < keys.length; i++) {
	                            var filterValue = this._params.filter[keys[i]];
	                            if (filterValue != null && filterValue !== '') {
	                                significantFilter[keys[i]] = filterValue;
	                            }
	                        }
	                        return significantFilter;
	                    } else {
	                        return this._params.filter;
	                    }
	                };
	                /**
	                 * Generate array of pages.
	                 * When no arguments supplied, the current parameter state of this `NgTableParams` instance will be used
	                 * @param currentPage Which page must be active
	                 * @param totalItems  Total quantity of items
	                 * @param pageSize    Quantity of items on page
	                 * @param maxBlocks   Quantity of blocks for pagination
	                 * @returns Array of pages
	                 */
	                NgTableParams.prototype.generatePagesArray = function (currentPage, totalItems, pageSize, maxBlocks) {
	                    if (!arguments.length) {
	                        currentPage = this.page();
	                        totalItems = this.total();
	                        pageSize = this.count();
	                    }
	                    var maxPage, maxPivotPages, minPage, numPages;
	                    maxBlocks = maxBlocks && maxBlocks < 6 ? 6 : maxBlocks;
	                    var pages = [];
	                    numPages = Math.ceil(totalItems / pageSize);
	                    if (numPages > 1) {
	                        pages.push({
	                            type: 'prev',
	                            number: Math.max(1, currentPage - 1),
	                            active: currentPage > 1
	                        });
	                        pages.push({
	                            type: 'first',
	                            number: 1,
	                            active: currentPage > 1,
	                            current: currentPage === 1
	                        });
	                        maxPivotPages = Math.round((this._settings.paginationMaxBlocks - this._settings.paginationMinBlocks) / 2);
	                        minPage = Math.max(2, currentPage - maxPivotPages);
	                        maxPage = Math.min(numPages - 1, currentPage + maxPivotPages * 2 - (currentPage - minPage));
	                        minPage = Math.max(2, minPage - (maxPivotPages * 2 - (maxPage - minPage)));
	                        var i = minPage;
	                        while (i <= maxPage) {
	                            if (i === minPage && i !== 2 || i === maxPage && i !== numPages - 1) {
	                                pages.push({
	                                    type: 'more',
	                                    active: false
	                                });
	                            } else {
	                                pages.push({
	                                    type: 'page',
	                                    number: i,
	                                    active: currentPage !== i,
	                                    current: currentPage === i
	                                });
	                            }
	                            i++;
	                        }
	                        pages.push({
	                            type: 'last',
	                            number: numPages,
	                            active: currentPage !== numPages,
	                            current: currentPage === numPages
	                        });
	                        pages.push({
	                            type: 'next',
	                            number: Math.min(numPages, currentPage + 1),
	                            active: currentPage < numPages
	                        });
	                    }
	                    return pages;
	                };
	                NgTableParams.prototype.group = function (group, sortDirection) {
	                    if (group === undefined) {
	                        return this._params.group;
	                    }
	                    var newParameters = {
	                        page: 1
	                    };
	                    if (util_1.isGroupingFun(group) && sortDirection !== undefined) {
	                        group.sortDirection = sortDirection;
	                        newParameters.group = group;
	                    } else if (typeof group === 'string' && sortDirection !== undefined) {
	                        newParameters.group = (_a = {}, _a[group] = sortDirection, _a);
	                    } else {
	                        newParameters.group = group;
	                    }
	                    this.parameters(newParameters);
	                    return this;
	                    var _a;
	                };
	                /**
	                 * Returns true when an attempt to `reload` the current `parameter` values have resulted in a failure.
	                 * This method will continue to return true until the `reload` is successfully called or when the
	                 * `parameter` values have changed
	                 */
	                NgTableParams.prototype.hasErrorState = function () {
	                    return !!(this.errParamsMemento && ng1.equals(this.errParamsMemento, this.createComparableParams()));
	                };
	                /**
	                 * Returns true if `filter` has significant filter value(s) (any value except null, undefined, or empty string),
	                 * otherwise false
	                 */
	                NgTableParams.prototype.hasFilter = function () {
	                    return Object.keys(this.filter(true)).length > 0;
	                };
	                /**
	                 * Return true when a change to `filters` require the `reload` method
	                 * to be run so as to ensure the data presented to the user reflects these filters
	                 */
	                NgTableParams.prototype.hasFilterChanges = function () {
	                    var previousFilter = this.prevParamsMemento && this.prevParamsMemento.params.filter;
	                    return !ng1.equals(this._params.filter, previousFilter) || this.hasGlobalSearchFieldChanges();
	                };
	                NgTableParams.prototype.hasGroup = function (group, sortDirection) {
	                    if (group == null) {
	                        return util_1.isGroupingFun(this._params.group) || Object.keys(this._params.group).length > 0;
	                    }
	                    if (util_1.isGroupingFun(group)) {
	                        if (sortDirection == null) {
	                            return this._params.group === group;
	                        } else {
	                            return this._params.group === group && group.sortDirection === sortDirection;
	                        }
	                    } else {
	                        if (sortDirection == null) {
	                            return Object.keys(this._params.group).indexOf(group) !== -1;
	                        } else {
	                            return this._params.group[group] === sortDirection;
	                        }
	                    }
	                };
	                /**
	                 * Return true when a change to this instance should require the `reload` method
	                 * to be run so as to ensure the data rows presented to the user reflects the current state.
	                 *
	                 * Note that this method will return false when the `reload` method has run but fails. In this case
	                 * `hasErrorState` will return true.
	                 *
	                 * The built-in `ngTable` directives will watch for when this function returns true and will then call
	                 * the `reload` method to load its data rows
	                 */
	                NgTableParams.prototype.isDataReloadRequired = function () {
	                    // note: using != as want to treat null and undefined the same
	                    return !this.isCommittedDataset || !ng1.equals(this.createComparableParams(), this.prevParamsMemento) || this.hasGlobalSearchFieldChanges();
	                };
	                /**
	                 * Returns true if sorting by the field supplied. Where direction supplied
	                 * the field must also be sorted by that direction to return true
	                 */
	                NgTableParams.prototype.isSortBy = function (field, direction) {
	                    if (direction !== undefined) {
	                        return this._params.sorting[field] !== undefined && this._params.sorting[field] == direction;
	                    } else {
	                        return this._params.sorting[field] !== undefined;
	                    }
	                };
	                /**
	                 * Returns sorting values in a format that can be consumed by the angular `$orderBy` filter service
	                 */
	                NgTableParams.prototype.orderBy = function () {
	                    return util_1.convertSortToOrderBy(this._params.sorting);
	                };
	                NgTableParams.prototype.page = function (page) {
	                    return page !== undefined ? this.parameters({
	                        'page': page
	                    }) : this._params.page;
	                };
	                NgTableParams.prototype.parameters = function (newParameters, parseParamsFromUrl) {
	                    parseParamsFromUrl = parseParamsFromUrl || false;
	                    if ((typeof newParameters === 'undefined' ? 'undefined' : _typeof(newParameters)) !== undefined) {
	                        for (var key in newParameters) {
	                            var value = newParameters[key];
	                            if (parseParamsFromUrl && key.indexOf('[') >= 0) {
	                                var keys = key.split(/\[(.*)\]/).reverse();
	                                var lastKey = '';
	                                for (var i = 0, len = keys.length; i < len; i++) {
	                                    var name = keys[i];
	                                    if (name !== '') {
	                                        var v = value;
	                                        value = {};
	                                        value[lastKey = name] = isNumber(v) ? parseFloat(v) : v;
	                                    }
	                                }
	                                if (lastKey === 'sorting') {
	                                    this._params[lastKey] = {};
	                                }
	                                this._params[lastKey] = ng1.extend(this._params[lastKey] || {}, value[lastKey]);
	                            } else {
	                                if (key === 'group') {
	                                    this._params[key] = this.parseGroup(newParameters[key]);
	                                } else {
	                                    this._params[key] = isNumber(newParameters[key]) ? parseFloat(newParameters[key]) : newParameters[key];
	                                }
	                            }
	                        }
	                        this.log('ngTable: set parameters', this._params);
	                        return this;
	                    }
	                    return this._params;
	                };
	                /**
	                 * Trigger a reload of the data rows
	                 */
	                NgTableParams.prototype.reload = function () {
	                    var _this = this;
	                    var pData = null;
	                    this._settings.$loading = true;
	                    this.prevParamsMemento = ng1.copy(this.createComparableParams());
	                    this.isCommittedDataset = true;
	                    if (this.hasGroup()) {
	                        pData = this.runInterceptorPipeline(NgTableParams.$q.when(this._settings.getGroups(this)));
	                    } else {
	                        var fn = this._settings.getData;
	                        pData = this.runInterceptorPipeline(NgTableParams.$q.when(fn(this)));
	                    }
	                    this.log('ngTable: reload data');
	                    var oldData = this.data;
	                    return pData.then(function (data) {
	                        _this._settings.$loading = false;
	                        _this.errParamsMemento = null;
	                        _this.data = data;
	                        // note: I think it makes sense to publish this event even when data === oldData
	                        // subscribers can always set a filter to only receive the event when data !== oldData
	                        NgTableParams.ngTableEventsChannel.publishAfterReloadData(_this, data, oldData);
	                        _this.reloadPages();
	                        return data;
	                    }).catch(function (reason) {
	                        _this.errParamsMemento = _this.prevParamsMemento;
	                        // "rethrow"
	                        return NgTableParams.$q.reject(reason);
	                    });
	                };
	                NgTableParams.prototype.settings = function (newSettings) {
	                    var _this = this;
	                    if (ng1.isDefined(newSettings)) {
	                        var settings = NgTableParams.ngTableSettings.merge(this._settings, newSettings);
	                        var originalDataset_1 = this._settings.dataset;
	                        this._settings = settings;
	                        // note: using != as want null and undefined to be treated the same
	                        var hasDatasetChanged = newSettings.hasOwnProperty('dataset') && newSettings.dataset != originalDataset_1;
	                        if (hasDatasetChanged) {
	                            if (this.isCommittedDataset) {
	                                this.page(1); // reset page as a new dataset has been supplied
	                            }
	                            this.isCommittedDataset = false;
	                            var fireEvent = function fireEvent() {
	                                NgTableParams.ngTableEventsChannel.publishDatasetChanged(_this, newSettings.dataset, originalDataset_1);
	                            };
	                            if (this.initialEvents) {
	                                this.initialEvents.push(fireEvent);
	                            } else {
	                                fireEvent();
	                            }
	                        }
	                        this.log('ngTable: set settings', this._settings);
	                        return this;
	                    }
	                    return this._settings;
	                };
	                NgTableParams.prototype.sorting = function (sorting, direction) {
	                    if (typeof sorting === 'string') {
	                        this.parameters({
	                            'sorting': (_a = {}, _a[sorting] = direction, _a)
	                        });
	                        return this;
	                    }
	                    return sorting !== undefined ? this.parameters({
	                        'sorting': sorting
	                    }) : this._params.sorting;
	                    var _a;
	                };
	                NgTableParams.prototype.total = function (total) {
	                    return total !== undefined ? this.settings({
	                        'total': total
	                    }) : this._settings.total;
	                };
	                /**
	                 * Returns the current parameter values uri-encoded. Set `asString` to
	                 * true for the parameters to be returned as an array of strings of the form 'paramName=value'
	                 * otherwise parameters returned as a key-value object
	                 */
	                NgTableParams.prototype.url = function (asString) {
	                    // this function is an example of Typescript gone bad!!
	                    asString = asString || false;
	                    var pairs = asString ? [] : {};
	                    for (var key in this._params) {
	                        if (this._params.hasOwnProperty(key)) {
	                            var item = this._params[key],
	                                name = encodeURIComponent(key);
	                            if ((typeof item === 'undefined' ? 'undefined' : _typeof(item)) === "object") {
	                                for (var subkey in item) {
	                                    if (isSignificantValue(item[subkey], key)) {
	                                        var pname = name + "[" + encodeURIComponent(subkey) + "]";
	                                        collectValue(item[subkey], pname);
	                                    }
	                                }
	                            } else if (!ng1.isFunction(item) && isSignificantValue(item, key)) {
	                                collectValue(item, name);
	                            }
	                        }
	                    }
	                    return pairs;
	                    function collectValue(value, key) {
	                        if (isArray(pairs)) {
	                            pairs.push(key + "=" + encodeURIComponent(value));
	                        } else {
	                            pairs[key] = encodeURIComponent(value);
	                        }
	                    }
	                    function isArray(pairs) {
	                        return asString;
	                    }
	                    function isSignificantValue(value, key) {
	                        return key === "group" ? true : (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== undefined && value !== "";
	                    }
	                };
	                NgTableParams.prototype.createComparableParams = function () {
	                    var group = this._params.group;
	                    return {
	                        params: this._params,
	                        groupSortDirection: util_1.isGroupingFun(group) ? group.sortDirection : undefined
	                    };
	                };
	                NgTableParams.prototype.hasGlobalSearchFieldChanges = function () {
	                    var currentVal = this._params.filter && this._params.filter['$'];
	                    var previousVal = this.prevParamsMemento && this.prevParamsMemento.params.filter && this.prevParamsMemento.params.filter['$'];
	                    return !ng1.equals(currentVal, previousVal);
	                };
	                NgTableParams.prototype.log = function () {
	                    var args = [];
	                    for (var _i = 0; _i < arguments.length; _i++) {
	                        args[_i - 0] = arguments[_i];
	                    }
	                    if (this._settings.debugMode && NgTableParams.$log.debug) {
	                        (_a = NgTableParams.$log).debug.apply(_a, args);
	                    }
	                    var _a;
	                };
	                NgTableParams.prototype.parseGroup = function (group) {
	                    var defaultSort = this._settings.groupOptions && this._settings.groupOptions.defaultSort;
	                    if (!group) {
	                        return group;
	                    } else if (util_1.isGroupingFun(group)) {
	                        if (group.sortDirection == null) {
	                            group.sortDirection = defaultSort;
	                        }
	                        return group;
	                    } else if ((typeof group === 'undefined' ? 'undefined' : _typeof(group)) === 'object') {
	                        for (var key in group) {
	                            if (group[key] == null) {
	                                group[key] = defaultSort;
	                            }
	                        }
	                        return group;
	                    } else {
	                        return _a = {}, _a[group] = defaultSort, _a;
	                    }
	                    var _a;
	                };
	                NgTableParams.prototype.runInterceptorPipeline = function (fetchedData) {
	                    var _this = this;
	                    var interceptors = this._settings.interceptors || [];
	                    return interceptors.reduce(function (result, interceptor) {
	                        var thenFn = interceptor.response && interceptor.response.bind(interceptor) || NgTableParams.$q.when;
	                        var rejectFn = interceptor.responseError && interceptor.responseError.bind(interceptor) || NgTableParams.$q.reject;
	                        return result.then(function (data) {
	                            return thenFn(data, _this);
	                        }, function (reason) {
	                            return rejectFn(reason, _this);
	                        });
	                    }, fetchedData);
	                };
	                NgTableParams.init = function ($q, $log, ngTableDefaults, ngTableEventsChannel, ngTableSettings) {
	                    NgTableParams.$q = $q;
	                    NgTableParams.$log = $log;
	                    NgTableParams.ngTableDefaults = ngTableDefaults;
	                    NgTableParams.ngTableEventsChannel = ngTableEventsChannel;
	                    NgTableParams.ngTableSettings = ngTableSettings;
	                };
	                return NgTableParams;
	            }();
	            exports.NgTableParams = NgTableParams;
	            NgTableParams.init.$inject = ['$q', '$log', 'ngTableDefaults', 'ngTableEventsChannel', 'ngTableSettings'];
	
	            /***/
	        },
	        /* 10 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!*************************************!*\
	          !*** ./src/core/ngTableSettings.ts ***!
	          \*************************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            "use strict";
	            "use strict";
	
	            var ng1 = __webpack_require__( /*! angular */0);
	            /**
	             * @private
	             */
	            var NgTableSettings = function () {
	                function NgTableSettings(ngTableDefaults, ngTableDefaultGetData, ngTableDefaultGetGroups) {
	                    var _this = this;
	                    this.ngTableDefaults = ngTableDefaults;
	                    this.ngTableDefaultGetData = ngTableDefaultGetData;
	                    this.ngTableDefaultGetGroups = ngTableDefaultGetGroups;
	                    this.defaults = {
	                        $loading: false,
	                        dataset: null,
	                        total: 0,
	                        defaultSort: 'desc',
	                        counts: [10, 25, 50, 100],
	                        filterOptions: {
	                            filterComparator: undefined,
	                            filterDelay: 500,
	                            filterDelayThreshold: 10000,
	                            filterFilterName: undefined,
	                            filterFn: undefined,
	                            filterLayout: 'stack'
	                        },
	                        getData: function getData(params) {
	                            return _this.ngTableDefaultGetData(params.settings().dataset, params);
	                        },
	                        getGroups: this.ngTableDefaultGetGroups,
	                        groupOptions: {
	                            defaultSort: 'asc',
	                            isExpanded: true
	                        },
	                        interceptors: [],
	                        paginationMaxBlocks: 11,
	                        paginationMinBlocks: 5,
	                        sortingIndicator: 'span'
	                    };
	                }
	                NgTableSettings.prototype.createDefaults = function () {
	                    return this.merge(this.defaults, this.ngTableDefaults.settings);
	                };
	                NgTableSettings.prototype.merge = function (existing, newSettings) {
	                    newSettings = ng1.extend({}, newSettings);
	                    if (newSettings.filterOptions) {
	                        newSettings.filterOptions = ng1.extend({}, existing.filterOptions || {}, newSettings.filterOptions);
	                    }
	                    if (newSettings.groupOptions) {
	                        newSettings.groupOptions = ng1.extend({}, existing.groupOptions || {}, newSettings.groupOptions);
	                    }
	                    if (ng1.isArray(newSettings.dataset)) {
	                        //auto-set the total from passed in dataset
	                        newSettings.total = newSettings.dataset.length;
	                    }
	                    var results = ng1.extend({}, existing, newSettings);
	                    if (ng1.isArray(newSettings.dataset)) {
	                        this.optimizeFilterDelay(results);
	                    }
	                    return ng1.extend({}, existing, newSettings);
	                };
	                NgTableSettings.prototype.optimizeFilterDelay = function (settings) {
	                    // don't debounce by default filter input when working with small synchronous datasets
	                    if (settings.filterOptions.filterDelay === this.defaults.filterOptions.filterDelay && settings.total <= settings.filterOptions.filterDelayThreshold && settings.getData === this.defaults.getData) {
	                        settings.filterOptions.filterDelay = 0;
	                    }
	                };
	                NgTableSettings.$inject = ['ngTableDefaults', 'ngTableDefaultGetData', 'ngTableDefaultGetGroups'];
	                return NgTableSettings;
	            }();
	            exports.NgTableSettings = NgTableSettings;
	
	            /***/
	        },
	        /* 11 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!**************************!*\
	          !*** ./src/core/util.ts ***!
	          \**************************/
	        /***/function (module, exports) {
	
	            "use strict";
	            "use strict";
	            /**
	             * @private
	             */
	
	            function convertSortToOrderBy(sorting) {
	                var result = [];
	                for (var column in sorting) {
	                    result.push((sorting[column] === "asc" ? "+" : "-") + column);
	                }
	                return result;
	            }
	            exports.convertSortToOrderBy = convertSortToOrderBy;
	            /**
	             * @private
	             */
	            function isGroupingFun(val) {
	                return typeof val === 'function';
	            }
	            exports.isGroupingFun = isGroupingFun;
	
	            /***/
	        },,
	        /* 12 */
	        /* 13 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!******************************************!*\
	          !*** ./src/browser/ngTable.directive.ts ***!
	          \******************************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            "use strict";
	            "use strict";
	
	            var ng1 = __webpack_require__( /*! angular */0);
	            ngTable.$inject = ['$q', '$parse'];
	            /**
	             * Directive that instantiates {@link NgTableController NgTableController}.
	             * @ngdoc directive
	             * @name ngTable
	             * @example
	             *
	             * ```html
	             * <table ng-table="$ctrl.tableParams" show-filter="true" class="table table-bordered">
	             *  <tr ng-repeat="user in $data">
	             *      <td data-title="'Name'" sortable="'name'" filter="{ 'name': 'text' }">
	             *          {{user.name}}
	             *      </td>
	             *      <td data-title="'Age'" sortable="'age'" filter="{ 'age': 'text' }">
	             *          {{user.age}}
	             *      </td>
	             *  </tr>
	             * </table>
	             * ```
	             */
	            function ngTable($q, $parse) {
	                return {
	                    restrict: 'A',
	                    priority: 1001,
	                    scope: true,
	                    controller: 'ngTableController',
	                    compile: function compile(element) {
	                        var columns = [],
	                            i = 0,
	                            dataRow,
	                            groupRow;
	                        var rows = [];
	                        ng1.forEach(element.find('tr'), function (tr) {
	                            rows.push(ng1.element(tr));
	                        });
	                        dataRow = rows.filter(function (tr) {
	                            return !tr.hasClass('ng-table-group');
	                        })[0];
	                        groupRow = rows.filter(function (tr) {
	                            return tr.hasClass('ng-table-group');
	                        })[0];
	                        if (!dataRow) {
	                            return undefined;
	                        }
	                        ng1.forEach(dataRow.find('td'), function (item) {
	                            var el = ng1.element(item);
	                            if (el.attr('ignore-cell') && 'true' === el.attr('ignore-cell')) {
	                                return;
	                            }
	                            var getAttrValue = function getAttrValue(attr) {
	                                return el.attr('x-data-' + attr) || el.attr('data-' + attr) || el.attr(attr);
	                            };
	                            var setAttrValue = function setAttrValue(attr, value) {
	                                if (el.attr('x-data-' + attr)) {
	                                    el.attr('x-data-' + attr, value);
	                                } else if (el.attr('data' + attr)) {
	                                    el.attr('data' + attr, value);
	                                } else {
	                                    el.attr(attr, value);
	                                }
	                            };
	                            var parsedAttribute = function parsedAttribute(attr) {
	                                var expr = getAttrValue(attr);
	                                if (!expr) {
	                                    return undefined;
	                                }
	                                var localValue;
	                                var getter = function getter(context) {
	                                    if (localValue !== undefined) {
	                                        return localValue;
	                                    }
	                                    return $parse(expr)(context);
	                                };
	                                getter.assign = function ($scope, value) {
	                                    var parsedExpr = $parse(expr);
	                                    if (parsedExpr.assign) {
	                                        // we should be writing back to the parent scope as this is where the expression
	                                        // came from
	                                        parsedExpr.assign($scope.$parent, value);
	                                    } else {
	                                        localValue = value;
	                                    }
	                                };
	                                return getter;
	                            };
	                            var titleExpr = getAttrValue('title-alt') || getAttrValue('title');
	                            if (titleExpr) {
	                                el.attr('data-title-text', '{{' + titleExpr + '}}'); // this used in responsive table
	                            }
	                            // NOTE TO MAINTAINERS: if you add extra fields to a $column be sure to extend ngTableColumn with
	                            // a corresponding "safe" default
	                            columns.push({
	                                id: i++,
	                                title: parsedAttribute('title'),
	                                titleAlt: parsedAttribute('title-alt'),
	                                headerTitle: parsedAttribute('header-title'),
	                                sortable: parsedAttribute('sortable'),
	                                'class': parsedAttribute('header-class'),
	                                filter: parsedAttribute('filter'),
	                                groupable: parsedAttribute('groupable'),
	                                headerTemplateURL: parsedAttribute('header'),
	                                filterData: parsedAttribute('filter-data'),
	                                show: el.attr("ng-if") ? parsedAttribute('ng-if') : undefined
	                            });
	                            if (groupRow || el.attr("ng-if")) {
	                                // change ng-if to bind to our column definition which we know will be writable
	                                // because this will potentially increase the $watch count, only do so if we already have an
	                                // ng-if or when we definitely need to change visibility of the columns.
	                                // currently only ngTableGroupRow directive needs to change visibility
	                                setAttrValue('ng-if', '$columns[' + (columns.length - 1) + '].show(this)');
	                            }
	                        });
	                        return function (scope, element, attrs, controller) {
	                            scope.$columns = columns = controller.buildColumns(columns);
	                            controller.setupBindingsToInternalScope(attrs.ngTable);
	                            controller.loadFilterData(columns);
	                            controller.compileDirectiveTemplates();
	                        };
	                    }
	                };
	            }
	            exports.ngTable = ngTable;
	
	            /***/
	        },
	        /* 14 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!**************************************!*\
	          !*** ./src/browser/ngTableColumn.ts ***!
	          \**************************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            "use strict";
	            /**
	             * ngTable: Table + Angular JS
	             *
	             * @author Vitalii Savchuk <esvit666@gmail.com>
	             * @url https://github.com/esvit/ng-table/
	             * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	             */
	            "use strict";
	
	            var ng1 = __webpack_require__( /*! angular */0);
	            /**
	             * @private
	             */
	            function isScopeLike(object) {
	                return object != null && ng1.isFunction(object.$new);
	            }
	            /**
	             * @private
	             * Service to construct a $column definition used by {@link ngTable ngTable} directive
	             */
	            var NgTableColumn = function () {
	                function NgTableColumn() {}
	                /**
	                 * Creates a $column for use within a header template
	                 *
	                 * @param column the initial definition for $column to build
	                 * @param defaultScope the $scope to supply to the $column getter methods when not supplied by caller
	                 * @param columns a reference to the $columns array to make available on the context supplied to the
	                 * $column getter methods
	                 */
	                NgTableColumn.prototype.buildColumn = function (column, defaultScope, columns) {
	                    // note: we're not modifying the original column object. This helps to avoid unintended side affects
	                    var extendedCol = Object.create(column);
	                    var defaults = this.createDefaults();
	                    var _loop_1 = function _loop_1(prop) {
	                        if (extendedCol[prop] === undefined) {
	                            extendedCol[prop] = defaults[prop];
	                        }
	                        if (!ng1.isFunction(extendedCol[prop])) {
	                            // wrap raw field values with "getter" functions
	                            // - this is to ensure consistency with how ngTable.compile builds columns
	                            // - note that the original column object is being "proxied"; this is important
	                            //   as it ensure that any changes to the original object will be returned by the "getter"
	                            var getterSetter = function getterSetter() {
	                                if (arguments.length === 1 && !isScopeLike(arguments[0])) {
	                                    getterSetter.assign(null, arguments[0]);
	                                } else {
	                                    return column[prop];
	                                }
	                            };
	                            getterSetter.assign = function ($scope, value) {
	                                column[prop] = value;
	                            };
	                            extendedCol[prop] = getterSetter;
	                        }
	                        // satisfy the arguments expected by the function returned by parsedAttribute in the ngTable directive
	                        var getterFn = extendedCol[prop];
	                        extendedCol[prop] = function () {
	                            if (arguments.length === 1 && !isScopeLike(arguments[0])) {
	                                getterFn.assign(defaultScope, arguments[0]);
	                            } else {
	                                var scope = arguments[0] || defaultScope;
	                                var context = Object.create(scope);
	                                ng1.extend(context, {
	                                    $column: extendedCol,
	                                    $columns: columns
	                                });
	                                return getterFn.call(column, context);
	                            }
	                        };
	                        if (getterFn.assign) {
	                            extendedCol[prop].assign = getterFn.assign;
	                        } else {
	                            var wrappedGetterFn_1 = extendedCol[prop];
	                            var localValue_1;
	                            var getterSetter = function getterSetter() {
	                                if (arguments.length === 1 && !isScopeLike(arguments[0])) {
	                                    getterSetter.assign(null, arguments[0]);
	                                } else {
	                                    return localValue_1 != undefined ? localValue_1 : wrappedGetterFn_1.apply(extendedCol, arguments);
	                                }
	                            };
	                            getterSetter.assign = function ($scope, value) {
	                                localValue_1 = value;
	                            };
	                            extendedCol[prop] = getterSetter;
	                        }
	                    };
	                    for (var prop in defaults) {
	                        _loop_1(prop);
	                    }
	                    return extendedCol;
	                };
	                NgTableColumn.prototype.createDefaults = function () {
	                    return {
	                        'class': this.createGetterSetter(''),
	                        filter: this.createGetterSetter(false),
	                        groupable: this.createGetterSetter(false),
	                        filterData: ng1.noop,
	                        headerTemplateURL: this.createGetterSetter(false),
	                        headerTitle: this.createGetterSetter(''),
	                        sortable: this.createGetterSetter(false),
	                        show: this.createGetterSetter(true),
	                        title: this.createGetterSetter(''),
	                        titleAlt: this.createGetterSetter('')
	                    };
	                };
	                NgTableColumn.prototype.createGetterSetter = function (initialValue) {
	                    var value = initialValue;
	                    var getterSetter = function getterSetter() {
	                        if (arguments.length === 1 && !isScopeLike(arguments[0])) {
	                            getterSetter.assign(null, arguments[0]);
	                        } else {
	                            return value;
	                        }
	                    };
	                    getterSetter.assign = function ($scope, newValue) {
	                        value = newValue;
	                    };
	                    return getterSetter;
	                };
	                NgTableColumn.$inject = [];
	                return NgTableColumn;
	            }();
	            exports.NgTableColumn = NgTableColumn;
	
	            /***/
	        },
	        /* 15 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!********************************************************!*\
	          !*** ./src/browser/ngTableColumnsBinding.directive.ts ***!
	          \********************************************************/
	        /***/function (module, exports) {
	
	            "use strict";
	            /**
	             * ngTable: Table + Angular JS
	             *
	             * @author Vitalii Savchuk <esvit666@gmail.com>
	             * @url https://github.com/esvit/ng-table/
	             * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	             */
	            "use strict";
	
	            ngTableColumnsBinding.$inject = ["$parse"];
	            /**
	             * One-way data binds the $columns array generated by ngTable/ngTableDynamic to the specified
	             * expression.
	             * This allows the $columns array created for the table to be accessed outside of the html table
	             * markup.
	             *
	             * @ngdoc directive
	             *
	             * @example
	             * ```html
	             * <table ng-table="$ctrl.tableParams" class="table" ng-table-columns-binding="$ctlr.tableColumns">
	             * ```
	             */
	            function ngTableColumnsBinding($parse) {
	                var directive = {
	                    restrict: 'A',
	                    link: linkFn
	                };
	                return directive;
	                function linkFn($scope, $element, $attrs) {
	                    var setter = $parse($attrs.ngTableColumnsBinding).assign;
	                    if (setter) {
	                        $scope.$watch('$columns', function (newColumns) {
	                            var shallowClone = (newColumns || []).slice(0);
	                            setter($scope, shallowClone);
	                        });
	                    }
	                }
	            }
	            exports.ngTableColumnsBinding = ngTableColumnsBinding;
	
	            /***/
	        },
	        /* 16 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!******************************************!*\
	          !*** ./src/browser/ngTableController.ts ***!
	          \******************************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            "use strict";
	            /**
	             * ngTable: Table + Angular JS
	             *
	             * @author Vitalii Savchuk <esvit666@gmail.com>
	             * @url https://github.com/esvit/ng-table/
	             * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	             */
	            "use strict";
	
	            var ng1 = __webpack_require__( /*! angular */0);
	            var core_1 = __webpack_require__( /*! ../core */1);
	            /**
	             * The controller for the {@link ngTable ngTable} and {@link ngTableDynamic ngTableDynamic} directives
	             */
	            var NgTableController = function () {
	                function NgTableController($scope, $timeout, $parse, $compile, $attrs, $element, $document, ngTableColumn, ngTableEventsChannel) {
	                    this.$scope = $scope;
	                    this.$parse = $parse;
	                    this.$compile = $compile;
	                    this.$attrs = $attrs;
	                    this.$element = $element;
	                    this.$document = $document;
	                    this.ngTableColumn = ngTableColumn;
	                    this.ngTableEventsChannel = ngTableEventsChannel;
	                    var isFirstTimeLoad = true;
	                    $scope.$filterRow = { disabled: false };
	                    $scope.$loading = false;
	                    // until such times as the directive uses an isolated scope, we need to ensure that the check for
	                    // the params field only consults the "own properties" of the $scope. This is to avoid seeing the params
	                    // field on a $scope higher up in the prototype chain
	                    if (!$scope.hasOwnProperty("params")) {
	                        $scope.params = new core_1.NgTableParams(true);
	                    }
	                    this.delayFilter = function () {
	                        var timer;
	                        return function (callback, ms) {
	                            $timeout.cancel(timer);
	                            timer = $timeout(callback, ms);
	                        };
	                    }();
	                    // watch for when a new NgTableParams is bound to the scope
	                    // CRITICAL: the watch must be for reference and NOT value equality; this is because NgTableParams maintains
	                    // the current data page as a field. Checking this for value equality would be terrible for performance
	                    // and potentially cause an error if the items in that array has circular references
	                    this.$scope.$watch('params', function (newParams, oldParams) {
	                        if (newParams === oldParams || !newParams) {
	                            return;
	                        }
	                        newParams.reload();
	                    }, false);
	                    this.subscribeToTableEvents();
	                }
	                Object.defineProperty(NgTableController.prototype, "hasVisibleFilterColumn", {
	                    get: function get() {
	                        var _this = this;
	                        if (!this.$scope.$columns) return false;
	                        return this.some(this.$scope.$columns, function ($column) {
	                            return $column.show(_this.$scope) && !!$column.filter(_this.$scope);
	                        });
	                    },
	                    enumerable: true,
	                    configurable: true
	                });
	                NgTableController.prototype.onDataReloadStatusChange = function (newStatus /*, oldStatus*/) {
	                    if (!newStatus || this.$scope.params.hasErrorState()) {
	                        return;
	                    }
	                    var currentParams = this.$scope.params;
	                    var filterOptions = currentParams.settings().filterOptions;
	                    if (currentParams.hasFilterChanges()) {
	                        var applyFilter = function applyFilter() {
	                            currentParams.page(1);
	                            currentParams.reload();
	                        };
	                        if (filterOptions.filterDelay) {
	                            this.delayFilter(applyFilter, filterOptions.filterDelay);
	                        } else {
	                            applyFilter();
	                        }
	                    } else {
	                        currentParams.reload();
	                    }
	                };
	                NgTableController.prototype.compileDirectiveTemplates = function () {
	                    if (!this.$element.hasClass('ng-table')) {
	                        this.$scope.templates = {
	                            header: this.$attrs.templateHeader ? this.$attrs.templateHeader : 'ng-table/header.html',
	                            pagination: this.$attrs.templatePagination ? this.$attrs.templatePagination : 'ng-table/pager.html'
	                        };
	                        this.$element.addClass('ng-table');
	                        var headerTemplate = null;
	                        // $element.find('> thead').length === 0 doesn't work on jqlite
	                        var theadFound_1 = false;
	                        ng1.forEach(this.$element.children(), function (e) {
	                            if (e.tagName === 'THEAD') {
	                                theadFound_1 = true;
	                            }
	                        });
	                        if (!theadFound_1) {
	                            headerTemplate = ng1.element('<thead ng-include="templates.header"></thead>', this.$document);
	                            if (this.$element.find('table').length) {
	                                this.$element.find('table').prepend(headerTemplate);
	                            } else {
	                                this.$element.prepend(headerTemplate);
	                            }
	                        }
	                        var paginationTemplate = ng1.element('<div ng-table-pagination="params" template-url="templates.pagination"></div>', this.$document);
	                        this.$element.after(paginationTemplate);
	                        if (headerTemplate) {
	                            this.$compile(headerTemplate)(this.$scope);
	                        }
	                        this.$compile(paginationTemplate)(this.$scope);
	                    }
	                };
	                NgTableController.prototype.loadFilterData = function ($columns) {
	                    var _this = this;
	                    ng1.forEach($columns, function ($column) {
	                        var result = $column.filterData(_this.$scope);
	                        if (!result) {
	                            delete $column.filterData;
	                            return undefined;
	                        }
	                        if (isPromiseLike(result)) {
	                            delete $column.filterData;
	                            return result.then(function (data) {
	                                // our deferred can eventually return arrays, functions and objects
	                                if (!ng1.isArray(data) && !ng1.isFunction(data) && !ng1.isObject(data)) {
	                                    // if none of the above was found - we just want an empty array
	                                    data = [];
	                                }
	                                $column.data = data;
	                            });
	                        } else {
	                            return $column.data = result;
	                        }
	                    });
	                    function isPromiseLike(val) {
	                        return val && (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object' && typeof val.then === 'function';
	                    }
	                };
	                NgTableController.prototype.buildColumns = function (columns) {
	                    var _this = this;
	                    // todo: use strictNullChecks and remove guard clause
	                    var result = [];
	                    (columns || []).forEach(function (col) {
	                        result.push(_this.ngTableColumn.buildColumn(col, _this.$scope, result));
	                    });
	                    return result;
	                };
	                NgTableController.prototype.parseNgTableDynamicExpr = function (attr) {
	                    if (!attr || attr.indexOf(" with ") > -1) {
	                        var parts = attr.split(/\s+with\s+/);
	                        return {
	                            tableParams: parts[0],
	                            columns: parts[1]
	                        };
	                    } else {
	                        throw new Error('Parse error (expected example: ng-table-dynamic=\'tableParams with cols\')');
	                    }
	                };
	                NgTableController.prototype.setupBindingsToInternalScope = function (tableParamsExpr) {
	                    // note: this we're setting up watches to simulate angular's isolated scope bindings
	                    var _this = this;
	                    // note: is REALLY important to watch for a change to the ngTableParams *reference* rather than
	                    // $watch for value equivalence. This is because ngTableParams references the current page of data as
	                    // a field and it's important not to watch this
	                    this.$scope.$watch(tableParamsExpr, function (params) {
	                        if (params === undefined) {
	                            return;
	                        }
	                        _this.$scope.params = params;
	                    }, false);
	                    this.setupFilterRowBindingsToInternalScope();
	                    this.setupGroupRowBindingsToInternalScope();
	                };
	                NgTableController.prototype.setupFilterRowBindingsToInternalScope = function () {
	                    var _this = this;
	                    if (this.$attrs.showFilter) {
	                        this.$scope.$parent.$watch(this.$attrs.showFilter, function (value) {
	                            _this.$scope.show_filter = value;
	                        });
	                    } else {
	                        this.$scope.$watch(function () {
	                            return _this.hasVisibleFilterColumn;
	                        }, function (value) {
	                            _this.$scope.show_filter = value;
	                        });
	                    }
	                    if (this.$attrs.disableFilter) {
	                        this.$scope.$parent.$watch(this.$attrs.disableFilter, function (value) {
	                            _this.$scope.$filterRow.disabled = value;
	                        });
	                    }
	                };
	                NgTableController.prototype.setupGroupRowBindingsToInternalScope = function () {
	                    var _this = this;
	                    this.$scope.$groupRow = { show: false };
	                    if (this.$attrs.showGroup) {
	                        var showGroupGetter_1 = this.$parse(this.$attrs.showGroup);
	                        this.$scope.$parent.$watch(showGroupGetter_1, function (value) {
	                            _this.$scope.$groupRow.show = value;
	                        });
	                        if (showGroupGetter_1.assign) {
	                            // setup two-way databinding thus allowing ngTableGrowRow to assign to the showGroup expression
	                            this.$scope.$watch('$groupRow.show', function (value) {
	                                showGroupGetter_1.assign(_this.$scope.$parent, value);
	                            });
	                        }
	                    } else {
	                        this.$scope.$watch('params.hasGroup()', function (newValue) {
	                            _this.$scope.$groupRow.show = newValue;
	                        });
	                    }
	                };
	                NgTableController.prototype.getVisibleColumns = function () {
	                    var _this = this;
	                    return (this.$scope.$columns || []).filter(function (c) {
	                        return c.show(_this.$scope);
	                    });
	                };
	                NgTableController.prototype.subscribeToTableEvents = function () {
	                    var _this = this;
	                    this.$scope.$watch('params.isDataReloadRequired()', function (newStatus /*, oldStatus*/) {
	                        _this.onDataReloadStatusChange(newStatus);
	                    });
	                    this.ngTableEventsChannel.onAfterReloadData(function (params, newDatapage) {
	                        var visibleColumns = _this.getVisibleColumns();
	                        if (params.hasGroup()) {
	                            _this.$scope.$groups = newDatapage || [];
	                            _this.$scope.$groups.visibleColumnCount = visibleColumns.length;
	                        } else {
	                            _this.$scope.$data = newDatapage || [];
	                            _this.$scope.$data.visibleColumnCount = visibleColumns.length;
	                        }
	                    }, this.$scope, function (publisher) {
	                        return _this.$scope.params === publisher;
	                    });
	                    this.ngTableEventsChannel.onPagesChanged(function (params, newPages) {
	                        _this.$scope.pages = newPages;
	                    }, this.$scope, function (publisher) {
	                        return _this.$scope.params === publisher;
	                    });
	                };
	                NgTableController.prototype.some = function (array, predicate) {
	                    var found = false;
	                    for (var i = 0; i < array.length; i++) {
	                        var obj = array[i];
	                        if (predicate(obj)) {
	                            found = true;
	                            break;
	                        }
	                    }
	                    return found;
	                };
	                NgTableController.$inject = ['$scope', '$timeout', '$parse', '$compile', '$attrs', '$element', '$document', 'ngTableColumn', 'ngTableEventsChannel'];
	                return NgTableController;
	            }();
	            exports.NgTableController = NgTableController;
	
	            /***/
	        },
	        /* 17 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!*************************************************!*\
	          !*** ./src/browser/ngTableDynamic.directive.ts ***!
	          \*************************************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            "use strict";
	            /**
	             * ngTable: Table + Angular JS
	             *
	             * @author Vitalii Savchuk <esvit666@gmail.com>
	             * @url https://github.com/esvit/ng-table/
	             * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	             */
	            "use strict";
	
	            var ng1 = __webpack_require__( /*! angular */0);
	            ngTableDynamic.$inject = [];
	            /**
	             * A dynamic version of the {@link ngTable ngTable} directive that accepts a dynamic list of columns
	             * definitions to render
	             * @ngdoc directive
	             *
	             * @example
	             * ```html
	             * <table ng-table-dynamic="$ctrl.tableParams with $ctrl.cols" class="table">
	             *  <tr ng-repeat="row in $data">
	             *    <td ng-repeat="col in $columns">{{row[col.field]}}</td>
	             *  </tr>
	             * </table>
	             * ```
	             */
	            function ngTableDynamic() {
	                return {
	                    restrict: 'A',
	                    priority: 1001,
	                    scope: true,
	                    controller: 'ngTableController',
	                    compile: function compile(tElement) {
	                        var row;
	                        // IE 8 fix :not(.ng-table-group) selector
	                        ng1.forEach(tElement.find('tr'), function (tr) {
	                            tr = ng1.element(tr);
	                            if (!tr.hasClass('ng-table-group') && !row) {
	                                row = tr;
	                            }
	                        });
	                        if (!row) {
	                            return undefined;
	                        }
	                        ng1.forEach(row.find('td'), function (item) {
	                            var el = ng1.element(item);
	                            var getAttrValue = function getAttrValue(attr) {
	                                return el.attr('x-data-' + attr) || el.attr('data-' + attr) || el.attr(attr);
	                            };
	                            // this used in responsive table
	                            var titleExpr = getAttrValue('title');
	                            if (!titleExpr) {
	                                el.attr('data-title-text', '{{$columns[$index].titleAlt(this) || $columns[$index].title(this)}}');
	                            }
	                            var showExpr = el.attr('ng-if');
	                            if (!showExpr) {
	                                el.attr('ng-if', '$columns[$index].show(this)');
	                            }
	                        });
	                        return function (scope, element, attrs, controller) {
	                            var expr = controller.parseNgTableDynamicExpr(attrs.ngTableDynamic);
	                            controller.setupBindingsToInternalScope(expr.tableParams);
	                            controller.compileDirectiveTemplates();
	                            scope.$watchCollection(expr.columns, function (newCols /*, oldCols*/) {
	                                scope.$columns = controller.buildColumns(newCols);
	                                controller.loadFilterData(scope.$columns);
	                            });
	                        };
	                    }
	                };
	            }
	            exports.ngTableDynamic = ngTableDynamic;
	
	            /***/
	        },
	        /* 18 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!********************************************!*\
	          !*** ./src/browser/ngTableFilterConfig.ts ***!
	          \********************************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            "use strict";
	            /**
	             * ngTable: Table + Angular JS
	             *
	             * @author Vitalii Savchuk <esvit666@gmail.com>
	             * @url https://github.com/esvit/ng-table/
	             * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	             */
	            "use strict";
	
	            var ng1 = __webpack_require__( /*! angular */0);
	            /**
	             * The angular provider used to configure the behaviour of the `NgTableFilterConfig` service.
	             */
	            var NgTableFilterConfigProvider = function () {
	                function NgTableFilterConfigProvider($injector) {
	                    var _this = this;
	                    this.defaultConfig = {
	                        defaultBaseUrl: 'ng-table/filters/',
	                        defaultExt: '.html',
	                        aliasUrls: {}
	                    };
	                    this.$get = function () {
	                        return $injector.instantiate(NgTableFilterConfig, { config: ng1.copy(_this.config) });
	                    };
	                    this.$get.$inject = [];
	                    this.resetConfigs();
	                }
	                /**
	                 * Reset back to factory defaults the config values that `NgTableFilterConfig` service will use
	                 */
	                NgTableFilterConfigProvider.prototype.resetConfigs = function () {
	                    this.config = this.defaultConfig;
	                };
	                /**
	                 * Set the config values used by `NgTableFilterConfig` service
	                 */
	                NgTableFilterConfigProvider.prototype.setConfig = function (customConfig) {
	                    var mergeConfig = ng1.extend({}, this.config, customConfig);
	                    mergeConfig.aliasUrls = ng1.extend({}, this.config.aliasUrls, customConfig.aliasUrls);
	                    this.config = mergeConfig;
	                };
	                NgTableFilterConfigProvider.$inject = ['$injector'];
	                return NgTableFilterConfigProvider;
	            }();
	            exports.NgTableFilterConfigProvider = NgTableFilterConfigProvider;
	            /**
	             * Exposes configuration values and methods used to return the location of the html
	             * templates used to render the filter row of an ng-table directive
	             */
	            var NgTableFilterConfig = function () {
	                function NgTableFilterConfig(
	                /**
	                 * Readonly copy of the final values used to configure the service.
	                 */
	                config) {
	                    this.config = config;
	                }
	                /**
	                 * Return the url of the html filter template registered with the alias supplied
	                 */
	                NgTableFilterConfig.prototype.getUrlForAlias = function (aliasName, filterKey) {
	                    return this.config.aliasUrls[aliasName] || this.config.defaultBaseUrl + aliasName + this.config.defaultExt;
	                };
	                /**
	                 * Return the url of the html filter template for the supplied definition and key.
	                 * For more information see the documentation for {@link IFilterTemplateMap}
	                 */
	                NgTableFilterConfig.prototype.getTemplateUrl = function (filterDef, filterKey) {
	                    var filterName;
	                    if (typeof filterDef !== 'string') {
	                        filterName = filterDef.id;
	                    } else {
	                        filterName = filterDef;
	                    }
	                    if (filterName.indexOf('/') !== -1) {
	                        return filterName;
	                    }
	                    return this.getUrlForAlias(filterName, filterKey);
	                };
	                NgTableFilterConfig.$inject = ['config'];
	                return NgTableFilterConfig;
	            }();
	            exports.NgTableFilterConfig = NgTableFilterConfig;
	
	            /***/
	        },
	        /* 19 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!***************************************************!*\
	          !*** ./src/browser/ngTableFilterRow.directive.ts ***!
	          \***************************************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            "use strict";
	            /**
	             * ngTable: Table + Angular JS
	             *
	             * @author Vitalii Savchuk <esvit666@gmail.com>
	             * @url https://github.com/esvit/ng-table/
	             * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	             */
	            "use strict";
	
	            var templateUrl = __webpack_require__( /*! ./filterRow.html */42);
	            ngTableFilterRow.$inject = [];
	            /**
	             * directive that renders the filter header row for a table
	             * @ngdoc directive
	             * @example
	             * ```html
	             * <ng-table-filter-row></ng-table-filter-row>
	             * ```
	             */
	            function ngTableFilterRow() {
	                var directive = {
	                    restrict: 'E',
	                    replace: true,
	                    templateUrl: templateUrl,
	                    scope: true,
	                    controller: 'ngTableFilterRowController',
	                    controllerAs: '$ctrl'
	                };
	                return directive;
	            }
	            exports.ngTableFilterRow = ngTableFilterRow;
	
	            /***/
	        },
	        /* 20 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!***************************************************!*\
	          !*** ./src/browser/ngTableFilterRowController.ts ***!
	          \***************************************************/
	        /***/function (module, exports) {
	
	            "use strict";
	            /**
	             * ngTable: Table + Angular JS
	             *
	             * @author Vitalii Savchuk <esvit666@gmail.com>
	             * @url https://github.com/esvit/ng-table/
	             * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	             */
	            "use strict";
	            /**
	             * Controller for the {@link ngTableFilterRow ngTableFilterRow} directive
	             */
	
	            var NgTableFilterRowController = function () {
	                function NgTableFilterRowController($scope, ngTableFilterConfig) {
	                    this.config = ngTableFilterConfig;
	                    // todo: stop doing this. Why?
	                    // * scope inheritance makes it hard to know how supplies functions
	                    // * scope is not a concept in angular 2
	                    // make function available to filter templates
	                    $scope.getFilterPlaceholderValue = this.getFilterPlaceholderValue.bind(this);
	                }
	                NgTableFilterRowController.prototype.getFilterCellCss = function (filter, layout) {
	                    if (layout !== 'horizontal') {
	                        return 's12';
	                    }
	                    var size = Object.keys(filter).length;
	                    var width = parseInt((12 / size).toString(), 10);
	                    return 's' + width;
	                };
	                NgTableFilterRowController.prototype.getFilterPlaceholderValue = function (filterDef, filterKey) {
	                    if (typeof filterDef === 'string') {
	                        return '';
	                    } else {
	                        return filterDef.placeholder;
	                    }
	                };
	                NgTableFilterRowController.$inject = ['$scope', 'ngTableFilterConfig'];
	                return NgTableFilterRowController;
	            }();
	            exports.NgTableFilterRowController = NgTableFilterRowController;
	
	            /***/
	        },
	        /* 21 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!**************************************************!*\
	          !*** ./src/browser/ngTableGroupRow.directive.ts ***!
	          \**************************************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            "use strict";
	            /**
	             * ngTable: Table + Angular JS
	             *
	             * @author Vitalii Savchuk <esvit666@gmail.com>
	             * @url https://github.com/esvit/ng-table/
	             * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	             */
	            "use strict";
	
	            var templateUrl = __webpack_require__( /*! ./groupRow.html */47);
	            ngTableGroupRow.$inject = [];
	            /**
	             * directive that renders the group header row for a table
	             * @ngdoc directive
	             * @example
	             * ```html
	             * <ng-table-group-row></ng-table-group-row>
	             * ```
	             */
	            function ngTableGroupRow() {
	                var directive = {
	                    restrict: 'E',
	                    replace: true,
	                    templateUrl: templateUrl,
	                    scope: true,
	                    controller: 'ngTableGroupRowController',
	                    controllerAs: '$ctrl'
	                };
	                return directive;
	            }
	            exports.ngTableGroupRow = ngTableGroupRow;
	
	            /***/
	        },
	        /* 22 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!**************************************************!*\
	          !*** ./src/browser/ngTableGroupRowController.ts ***!
	          \**************************************************/
	        /***/function (module, exports) {
	
	            "use strict";
	            /**
	             * ngTable: Table + Angular JS
	             *
	             * @author Vitalii Savchuk <esvit666@gmail.com>
	             * @url https://github.com/esvit/ng-table/
	             * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	             */
	            "use strict";
	            /**
	             * Controller for the {@link ngTableGroupRow ngTableGroupRow} directive
	             */
	
	            var NgTableGroupRowController = function () {
	                function NgTableGroupRowController($scope) {
	                    var _this = this;
	                    this.$scope = $scope;
	                    this.groupFns = [];
	                    $scope.$watch('params.group()', function (newGrouping) {
	                        _this.setGroup(newGrouping);
	                    }, true);
	                }
	                NgTableGroupRowController.prototype.getGroupables = function () {
	                    var _this = this;
	                    var groupableCols = this.$scope.$columns.filter(function ($column) {
	                        return !!$column.groupable(_this.$scope);
	                    });
	                    return this.groupFns.concat(groupableCols);
	                };
	                NgTableGroupRowController.prototype.getGroupTitle = function (group) {
	                    return this.isGroupingFunc(group) ? group.title : group.title(this.$scope);
	                };
	                NgTableGroupRowController.prototype.getVisibleColumns = function () {
	                    var _this = this;
	                    return this.$scope.$columns.filter(function ($column) {
	                        return $column.show(_this.$scope);
	                    });
	                };
	                NgTableGroupRowController.prototype.groupBy = function (group) {
	                    if (this.isSelectedGroup(group)) {
	                        this.changeSortDirection();
	                    } else {
	                        if (this.isGroupingFunc(group)) {
	                            this.$scope.params.group(group);
	                        } else {
	                            // it's OK, we know that groupable will return a string
	                            // this is guaranteed by getGroupables returning only
	                            // columns that return (truthy) strings
	                            this.$scope.params.group(group.groupable(this.$scope));
	                        }
	                    }
	                };
	                NgTableGroupRowController.prototype.isSelectedGroup = function (group) {
	                    if (this.isGroupingFunc(group)) {
	                        return group === this.$scope.$selGroup;
	                    } else {
	                        return group.groupable(this.$scope) === this.$scope.$selGroup;
	                    }
	                };
	                NgTableGroupRowController.prototype.toggleDetail = function () {
	                    this.$scope.params.settings().groupOptions.isExpanded = !this.$scope.params.settings().groupOptions.isExpanded;
	                    return this.$scope.params.reload();
	                };
	                NgTableGroupRowController.prototype.changeSortDirection = function () {
	                    var newDirection;
	                    if (this.$scope.params.hasGroup(this.$scope.$selGroup, 'asc')) {
	                        newDirection = 'desc';
	                    } else if (this.$scope.params.hasGroup(this.$scope.$selGroup, 'desc')) {
	                        newDirection = '';
	                    } else {
	                        newDirection = 'asc';
	                    }
	                    this.$scope.params.group(this.$scope.$selGroup, newDirection);
	                };
	                NgTableGroupRowController.prototype.findGroupColumn = function (groupKey) {
	                    var _this = this;
	                    return this.$scope.$columns.filter(function ($column) {
	                        return $column.groupable(_this.$scope) === groupKey;
	                    })[0];
	                };
	                NgTableGroupRowController.prototype.isGroupingFunc = function (val) {
	                    return typeof val === 'function';
	                };
	                NgTableGroupRowController.prototype.setGroup = function (grouping) {
	                    var existingGroupCol = this.findGroupColumn(this.$scope.$selGroup);
	                    if (existingGroupCol && existingGroupCol.show.assign) {
	                        existingGroupCol.show.assign(this.$scope, true);
	                    }
	                    if (this.isGroupingFunc(grouping)) {
	                        this.groupFns = [grouping];
	                        this.$scope.$selGroup = grouping;
	                        this.$scope.$selGroupTitle = grouping.title;
	                    } else {
	                        // note: currently only one group is implemented
	                        var groupKey = Object.keys(grouping || {})[0];
	                        var groupedColumn = this.findGroupColumn(groupKey);
	                        if (groupedColumn) {
	                            this.$scope.$selGroupTitle = groupedColumn.title(this.$scope);
	                            this.$scope.$selGroup = groupKey;
	                            if (groupedColumn.show.assign) {
	                                groupedColumn.show.assign(this.$scope, false);
	                            }
	                        }
	                    }
	                };
	                NgTableGroupRowController.$inject = ['$scope'];
	                return NgTableGroupRowController;
	            }();
	            exports.NgTableGroupRowController = NgTableGroupRowController;
	
	            /***/
	        },
	        /* 23 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!****************************************************!*\
	          !*** ./src/browser/ngTablePagination.directive.ts ***!
	          \****************************************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            "use strict";
	            /**
	             * ngTable: Table + Angular JS
	             *
	             * @author Vitalii Savchuk <esvit666@gmail.com>
	             * @url https://github.com/esvit/ng-table/
	             * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	             */
	            "use strict";
	
	            var ng1 = __webpack_require__( /*! angular */0);
	            ngTablePagination.$inject = ['$compile', '$document', 'ngTableEventsChannel'];
	            /**
	             * Directive that renders the table pagination controls
	             * @ngdoc directive
	             */
	            function ngTablePagination($compile, $document, ngTableEventsChannel) {
	                return {
	                    restrict: 'A',
	                    scope: {
	                        'params': '=ngTablePagination',
	                        'templateUrl': '='
	                    },
	                    replace: false,
	                    link: function link(scope, element /*, attrs*/) {
	                        ngTableEventsChannel.onAfterReloadData(function (pubParams) {
	                            scope.pages = pubParams.generatePagesArray();
	                        }, scope, function (pubParams) {
	                            return pubParams === scope.params;
	                        });
	                        scope.$watch('templateUrl', function (templateUrl) {
	                            if (templateUrl === undefined) {
	                                return;
	                            }
	                            var template = ng1.element('<div ng-include="templateUrl"></div>', $document);
	                            element.append(template);
	                            $compile(template)(scope);
	                        });
	                    }
	                };
	            }
	            exports.ngTablePagination = ngTablePagination;
	
	            /***/
	        },
	        /* 24 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!********************************************************!*\
	          !*** ./src/browser/ngTableSelectFilterDs.directive.ts ***!
	          \********************************************************/
	        /***/function (module, exports) {
	
	            "use strict";
	            /**
	             * ngTable: Table + Angular JS
	             *
	             * @author Vitalii Savchuk <esvit666@gmail.com>
	             * @url https://github.com/esvit/ng-table/
	             * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	             */
	            "use strict";
	
	            ngTableSelectFilterDs.$inject = [];
	            /**
	             * Takes the array returned by $column.filterData and makes it available as `$selectData` on the `$scope`.
	             *
	             * The resulting `$selectData` array will contain an extra item that is suitable to represent the user
	             * "deselecting" an item from a `<select>` tag
	             *
	             * This directive is is focused on providing a datasource to an `ngOptions` directive
	             */
	            function ngTableSelectFilterDs() {
	                // note: not using isolated or child scope "by design"
	                // this is to allow this directive to be combined with other directives that do
	                var directive = {
	                    restrict: 'A',
	                    controller: NgTableSelectFilterDsController
	                };
	                return directive;
	            }
	            exports.ngTableSelectFilterDs = ngTableSelectFilterDs;
	            /**
	             * @private
	             */
	            var NgTableSelectFilterDsController = function () {
	                function NgTableSelectFilterDsController($scope, $parse, $attrs, $q) {
	                    var _this = this;
	                    this.$scope = $scope;
	                    this.$attrs = $attrs;
	                    this.$q = $q;
	                    this.$column = $parse($attrs.ngTableSelectFilterDs)($scope);
	                    $scope.$watch(function () {
	                        return _this.$column && _this.$column.data;
	                    }, function () {
	                        _this.bindDataSource();
	                    });
	                }
	                NgTableSelectFilterDsController.prototype.bindDataSource = function () {
	                    var _this = this;
	                    this.getSelectListData(this.$column).then(function (data) {
	                        if (data && !_this.hasEmptyOption(data)) {
	                            // data.unshift({ value: '', name: 'Seleccione' });
	                        }
	                        data = data || [];
	                        _this.$scope.$selectData = data;
	                    });
	                };
	                NgTableSelectFilterDsController.prototype.hasEmptyOption = function (data) {
	                    var isMatch;
	                    for (var i = 0; i < data.length; i++) {
	                        var item = data[i];
	                        if (item && item.id === '') {
	                            isMatch = true;
	                            break;
	                        }
	                    }
	                    return isMatch;
	                };
	                NgTableSelectFilterDsController.prototype.getSelectListData = function ($column) {
	                    var dataInput = $column.data;
	                    if (dataInput instanceof Array) {
	                        return this.$q.when(dataInput);
	                    } else {
	                        return this.$q.when(dataInput && dataInput());
	                    }
	                };
	                NgTableSelectFilterDsController.$inject = ['$scope', '$parse', '$attrs', '$q'];
	                return NgTableSelectFilterDsController;
	            }();
	            exports.NgTableSelectFilterDsController = NgTableSelectFilterDsController;
	
	            /***/
	        },
	        /* 25 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!***************************************************!*\
	          !*** ./src/browser/ngTableSorterRow.directive.ts ***!
	          \***************************************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            "use strict";
	            /**
	             * ngTable: Table + Angular JS
	             *
	             * @author Vitalii Savchuk <esvit666@gmail.com>
	             * @url https://github.com/esvit/ng-table/
	             * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	             */
	            "use strict";
	
	            var templateUrl = __webpack_require__( /*! ./sorterRow.html */50);
	            ngTableSorterRow.$inject = [];
	            /**
	             * directive that renders the sorting header row for a table
	             * @ngdoc directive
	             * @example
	             * ```html
	             * <ng-table-sorter-row></ng-table-sorter-row>
	             * ```
	             */
	            function ngTableSorterRow() {
	                var directive = {
	                    restrict: 'E',
	                    replace: true,
	                    templateUrl: templateUrl,
	                    scope: true,
	                    controller: 'ngTableSorterRowController',
	                    controllerAs: '$ctrl'
	                };
	                return directive;
	            }
	            exports.ngTableSorterRow = ngTableSorterRow;
	
	            /***/
	        },
	        /* 26 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!***************************************************!*\
	          !*** ./src/browser/ngTableSorterRowController.ts ***!
	          \***************************************************/
	        /***/function (module, exports) {
	
	            "use strict";
	            "use strict";
	            /**
	             * Controller for the {@link ngTableSorterRow ngTableSorterRow} directive
	             */
	
	            var NgTableSorterRowController = function () {
	                function NgTableSorterRowController($scope) {
	                    this.$scope = $scope;
	                }
	                NgTableSorterRowController.prototype.sortBy = function ($column, event) {
	                    var parsedSortable = $column.sortable && $column.sortable();
	                    if (!parsedSortable || typeof parsedSortable !== 'string') {
	                        return;
	                    } else {
	                        var defaultSort = this.$scope.params.settings().defaultSort;
	                        var inverseSort = defaultSort === 'asc' ? 'desc' : 'asc';
	                        var sorting = this.$scope.params.sorting() && this.$scope.params.sorting()[parsedSortable] && this.$scope.params.sorting()[parsedSortable] === defaultSort;
	                        var sortingParams = event.ctrlKey || event.metaKey ? this.$scope.params.sorting() : {};
	                        sortingParams[parsedSortable] = sorting ? inverseSort : defaultSort;
	                        this.$scope.params.parameters({
	                            sorting: sortingParams
	                        });
	                    }
	                };
	                NgTableSorterRowController.$inject = ['$scope'];
	                return NgTableSorterRowController;
	            }();
	            exports.NgTableSorterRowController = NgTableSorterRowController;
	
	            /***/
	        },
	        /* 27 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!******************************************!*\
	          !*** ./src/browser/public-interfaces.ts ***!
	          \******************************************/
	        /***/function (module, exports) {
	
	            "use strict";
	            "use strict";
	
	            /***/
	        },
	        /* 28 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!***************************************!*\
	          !*** ./src/core/data/dataSettings.ts ***!
	          \***************************************/
	        /***/function (module, exports) {
	
	            "use strict";
	            "use strict";
	
	            /***/
	        },
	        /* 29 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!**********************************!*\
	          !*** ./src/core/data/getData.ts ***!
	          \**********************************/
	        /***/function (module, exports) {
	
	            "use strict";
	            "use strict";
	
	            /***/
	        },
	        /* 30 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!**************************************!*\
	          !*** ./src/core/data/interceptor.ts ***!
	          \**************************************/
	        /***/function (module, exports) {
	
	            "use strict";
	            "use strict";
	
	            /***/
	        },
	        /* 31 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!************************************************!*\
	          !*** ./src/core/data/ngTableDefaultGetData.ts ***!
	          \************************************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            "use strict";
	            /**
	             * ngTable: Table + Angular JS
	             *
	             * @author Vitalii Savchuk <esvit666@gmail.com>
	             * @url https://github.com/esvit/ng-table/
	             * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	             */
	            "use strict";
	
	            var ng1 = __webpack_require__( /*! angular */0);
	            /**
	             * Implementation of the {@link IDefaultGetDataProvider} interface
	             */
	            var NgTableDefaultGetDataProvider = function () {
	                function NgTableDefaultGetDataProvider() {
	                    /**
	                     * The name of a angular filter that knows how to apply the values returned by
	                     * `NgTableParams.filter()` to restrict an array of data.
	                     * (defaults to the angular `filter` filter service)
	                     */
	                    this.filterFilterName = 'filter';
	                    /**
	                     * The name of a angular filter that knows how to apply the values returned by
	                    * `NgTableParams.orderBy()` to sort an array of data.
	                    * (defaults to the angular `orderBy` filter service)
	                    */
	                    this.sortingFilterName = 'orderBy';
	                    var provider = this;
	                    this.$get = ngTableDefaultGetData;
	                    ngTableDefaultGetData.$inject = ['$filter', 'ngTableEventsChannel'];
	                    function ngTableDefaultGetData($filter, ngTableEventsChannel) {
	                        var defaultDataOptions = { applyFilter: true, applySort: true, applyPaging: true };
	                        getData.applyPaging = applyPaging;
	                        getData.getFilterFn = getFilterFn;
	                        getData.getOrderByFn = getOrderByFn;
	                        return getData;
	                        function getFilterFn(params) {
	                            var filterOptions = params.settings().filterOptions;
	                            if (ng1.isFunction(filterOptions.filterFn)) {
	                                return filterOptions.filterFn;
	                            } else {
	                                return $filter(filterOptions.filterFilterName || provider.filterFilterName);
	                            }
	                        }
	                        function getOrderByFn(params) {
	                            return $filter(provider.sortingFilterName);
	                        }
	                        function applyFilter(data, params) {
	                            if (!params.hasFilter()) {
	                                return data;
	                            }
	                            var filter = params.filter(true);
	                            var filterKeys = Object.keys(filter);
	                            var parsedFilter = filterKeys.reduce(function (result, key) {
	                                result = setPath(result, filter[key], key);
	                                return result;
	                            }, {});
	                            var filterFn = getFilterFn(params);
	                            return filterFn.call(params, data, parsedFilter, params.settings().filterOptions.filterComparator);
	                        }
	                        function applyPaging(data, params) {
	                            var pagedData = data.slice((params.page() - 1) * params.count(), params.page() * params.count());
	                            params.total(data.length); // set total for recalc pagination
	                            return pagedData;
	                        }
	                        function applySort(data, params) {
	                            var orderBy = params.orderBy();
	                            var orderByFn = getOrderByFn(params);
	                            return orderBy.length ? orderByFn(data, orderBy) : data;
	                        }
	                        function getData(data, params) {
	                            if (data == null) {
	                                return [];
	                            }
	                            var options = ng1.extend({}, defaultDataOptions, params.settings().dataOptions);
	                            var fData = options.applyFilter ? applyFilter(data, params) : data;
	                            ngTableEventsChannel.publishAfterDataFiltered(params, fData);
	                            var orderedData = options.applySort ? applySort(fData, params) : fData;
	                            ngTableEventsChannel.publishAfterDataSorted(params, orderedData);
	                            return options.applyPaging ? applyPaging(orderedData, params) : orderedData;
	                        }
	                        // Sets the value at any depth in a nested object based on the path
	                        // note: adapted from: underscore-contrib#setPath
	                        function setPath(obj, value, path) {
	                            var keys = path.split('.');
	                            var ret = obj;
	                            var lastKey = keys[keys.length - 1];
	                            var target = ret;
	                            var parentPathKeys = keys.slice(0, keys.length - 1);
	                            parentPathKeys.forEach(function (key) {
	                                if (!target.hasOwnProperty(key)) {
	                                    target[key] = {};
	                                }
	                                target = target[key];
	                            });
	                            target[lastKey] = value;
	                            return ret;
	                        }
	                    }
	                }
	                return NgTableDefaultGetDataProvider;
	            }();
	            exports.NgTableDefaultGetDataProvider = NgTableDefaultGetDataProvider;
	
	            /***/
	        },
	        /* 32 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!**********************************!*\
	          !*** ./src/core/data/results.ts ***!
	          \**********************************/
	        /***/function (module, exports) {
	
	            "use strict";
	            "use strict";
	
	            /***/
	        },
	        /* 33 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!************************************************!*\
	          !*** ./src/core/filtering/filterComparator.ts ***!
	          \************************************************/
	        /***/function (module, exports) {
	
	            "use strict";
	            "use strict";
	
	            /***/
	        },
	        /* 34 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!******************************************!*\
	          !*** ./src/core/filtering/filterFunc.ts ***!
	          \******************************************/
	        /***/function (module, exports) {
	
	            "use strict";
	            "use strict";
	
	            /***/
	        },
	        /* 35 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!**********************************************!*\
	          !*** ./src/core/filtering/filterSettings.ts ***!
	          \**********************************************/
	        /***/function (module, exports) {
	
	            "use strict";
	            "use strict";
	
	            /***/
	        },
	        /* 36 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!*************************************!*\
	          !*** ./src/core/filtering/index.ts ***!
	          \*************************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            "use strict";
	            "use strict";
	
	            function __export(m) {
	                for (var p in m) {
	                    if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	                }
	            }
	            __export(__webpack_require__( /*! ./filterComparator */33));
	            __export(__webpack_require__( /*! ./filterFunc */34));
	            __export(__webpack_require__( /*! ./filterSettings */35));
	
	            /***/
	        },
	        /* 37 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!************************************!*\
	          !*** ./src/core/grouping/index.ts ***!
	          \************************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            "use strict";
	            "use strict";
	
	            function __export(m) {
	                for (var p in m) {
	                    if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	                }
	            }
	            __export(__webpack_require__( /*! ./getGroup */4));
	            __export(__webpack_require__( /*! ./groupingFunc */6));
	            __export(__webpack_require__( /*! ./groupSettings */5));
	            __export(__webpack_require__( /*! ./ngTableDefaultGetGroups */38));
	
	            /***/
	        },
	        /* 38 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!******************************************************!*\
	          !*** ./src/core/grouping/ngTableDefaultGetGroups.ts ***!
	          \******************************************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            "use strict";
	            "use strict";
	
	            var ng1 = __webpack_require__( /*! angular */0);
	            var util_1 = __webpack_require__( /*! ../util */11);
	            ngTableDefaultGetGroups.$inject = ['$q', 'ngTableDefaultGetData'];
	            /**
	             * Implementation of the {@link IDefaultGetData IDefaultGetData} interface
	             *
	             * @ngdoc service
	             */
	            function ngTableDefaultGetGroups($q, ngTableDefaultGetData) {
	                return getGroups;
	                function getGroups(params) {
	                    var group = params.group();
	                    var groupFn;
	                    var sortDirection = undefined;
	                    if (util_1.isGroupingFun(group)) {
	                        groupFn = group;
	                        sortDirection = group.sortDirection;
	                    } else {
	                        // currently support for only one group implemented
	                        var groupField_1 = Object.keys(group)[0];
	                        sortDirection = group[groupField_1];
	                        groupFn = function groupFn(item) {
	                            return getPath(item, groupField_1);
	                        };
	                    }
	                    var settings = params.settings();
	                    var originalDataOptions = settings.dataOptions;
	                    settings.dataOptions = { applyPaging: false };
	                    var getData = settings.getData;
	                    var gotData = $q.when(getData(params));
	                    return gotData.then(function (data) {
	                        var groups = {};
	                        ng1.forEach(data, function (item) {
	                            var groupName = groupFn(item);
	                            groups[groupName] = groups[groupName] || {
	                                data: [],
	                                $hideRows: !settings.groupOptions.isExpanded,
	                                value: groupName
	                            };
	                            groups[groupName].data.push(item);
	                        });
	                        var result = [];
	                        for (var i in groups) {
	                            result.push(groups[i]);
	                        }
	                        if (sortDirection) {
	                            var orderByFn = ngTableDefaultGetData.getOrderByFn();
	                            var orderBy = util_1.convertSortToOrderBy({
	                                value: sortDirection
	                            });
	                            result = orderByFn(result, orderBy);
	                        }
	                        return ngTableDefaultGetData.applyPaging(result, params);
	                    }).finally(function () {
	                        // restore the real options
	                        settings.dataOptions = originalDataOptions;
	                    });
	                }
	            }
	            exports.ngTableDefaultGetGroups = ngTableDefaultGetGroups;
	            /**
	             * @private
	             */
	            function getPath(obj, ks) {
	                // origianl source https://github.com/documentcloud/underscore-contrib
	                var keys;
	                if (typeof ks === "string") {
	                    keys = ks.split(".");
	                } else {
	                    keys = ks;
	                }
	                // If we have reached an undefined property
	                // then stop executing and return undefined
	                if (obj === undefined) return void 0;
	                // If the path array has no more elements, we've reached
	                // the intended property and return its value
	                if (keys.length === 0) return obj;
	                // If we still have elements in the path array and the current
	                // value is null, stop executing and return undefined
	                if (obj === null) return void 0;
	                return getPath(obj[keys[0]], keys.slice(1));
	            }
	
	            /***/
	        },
	        /* 39 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!********************************************!*\
	          !*** ./src/core/grouping/publicExports.ts ***!
	          \********************************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            "use strict";
	            "use strict";
	
	            function __export(m) {
	                for (var p in m) {
	                    if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	                }
	            }
	            __export(__webpack_require__( /*! ./getGroup */4));
	            __export(__webpack_require__( /*! ./groupingFunc */6));
	            __export(__webpack_require__( /*! ./groupSettings */5));
	
	            /***/
	        },
	        /* 40 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!**********************************!*\
	          !*** ./src/core/paging/index.ts ***!
	          \**********************************/
	        /***/function (module, exports) {
	
	            "use strict";
	            "use strict";
	
	            /***/
	        },
	        /* 41 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!***********************************!*\
	          !*** ./src/core/sorting/index.ts ***!
	          \***********************************/
	        /***/function (module, exports) {
	
	            "use strict";
	            "use strict";
	
	            /***/
	        },
	        /* 42 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!************************************!*\
	          !*** ./src/browser/filterRow.html ***!
	          \************************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            var path = 'ng-table/filterRow.html';
	            var html = "<tr ng-show=\"show_filter\" class=\"ng-table-filters\">\n    <th data-title-text=\"{{$column.titleAlt(this) || $column.title(this)}}\" ng-repeat=\"$column in $columns\" ng-if=\"$column.show(this)\" class=\"filter {{$column.class(this)}}\"\n        ng-class=\"params.settings().filterOptions.filterLayout === 'horizontal' ? 'filter-horizontal' : ''\">\n        <div ng-repeat=\"(name, filter) in $column.filter(this)\" ng-include=\"$ctrl.config.getTemplateUrl(filter)\" class=\"filter-cell\"\n             ng-class=\"[$ctrl.getFilterCellCss($column.filter(this), params.settings().filterOptions.filterLayout), $last ? 'last' : '']\">\n        </div>\n    </th>\n</tr>\n";
	            var angular = __webpack_require__( /*! angular */0);
	            angular.module('ng').run(['$templateCache', function (c) {
	                c.put(path, html);
	            }]);
	            module.exports = path;
	
	            /***/
	        },
	        /* 43 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!*****************************************!*\
	          !*** ./src/browser/filters/number.html ***!
	          \*****************************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            var path = 'ng-table/filters/number.html';
	            var html = "<input type=\"number\" name=\"{{name}}\" ng-disabled=\"$filterRow.disabled\" ng-model=\"params.filter()[name]\" class=\"input-filter form-control\"\n       placeholder=\"{{getFilterPlaceholderValue(filter, name)}}\"/>\n";
	            var angular = __webpack_require__( /*! angular */0);
	            angular.module('ng').run(['$templateCache', function (c) {
	                c.put(path, html);
	            }]);
	            module.exports = path;
	
	            /***/
	        },
	        /* 44 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!**************************************************!*\
	          !*** ./src/browser/filters/select-multiple.html ***!
	          \**************************************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            var path = 'ng-table/filters/select-multiple.html';
	            var html = "<select ng-options=\"data.value as data.name for data in $column.data\"\n        ng-disabled=\"$filterRow.disabled\"\n        multiple ng-multiple=\"true\"\n        ng-model=\"params.filter()[name]\"\n        class=\"filter filter-select-multiple form-control\" name=\"{{name}}\">\n</select>\n";
	            var angular = __webpack_require__( /*! angular */0);
	            angular.module('ng').run(['$templateCache', function (c) {
	                c.put(path, html);
	            }]);
	            module.exports = path;
	
	            /***/
	        },
	        /* 45 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!*****************************************!*\
	          !*** ./src/browser/filters/select.html ***!
	          \*****************************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            var path = 'ng-table/filters/select.html';
	            var html = "<select ng-options=\"data.value as data.name for data in $selectData\"\n        ng-table-select-filter-ds=\"$column\"\n        ng-disabled=\"$filterRow.disabled\"\n        ng-model=\"params.filter()[name]\"\n        class=\"filter filter-select form-control\" name=\"{{name}}\">\n    <option value=\"\">TODOS</option>\n</select>\n";
	            var angular = __webpack_require__( /*! angular */0);
	            angular.module('ng').run(['$templateCache', function (c) {
	                c.put(path, html);
	            }]);
	            module.exports = path;
	
	            /***/
	        },
	        /* 46 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!***************************************!*\
	          !*** ./src/browser/filters/text.html ***!
	          \***************************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            var path = 'ng-table/filters/text.html';
	            var html = "<input type=\"text\" name=\"{{name}}\" ng-disabled=\"$filterRow.disabled\" ng-model=\"params.filter()[name]\" class=\"input-filter form-control\"\n       placeholder=\"{{getFilterPlaceholderValue(filter, name)}}\"/>\n";
	            var angular = __webpack_require__( /*! angular */0);
	            angular.module('ng').run(['$templateCache', function (c) {
	                c.put(path, html);
	            }]);
	            module.exports = path;
	
	            /***/
	        },
	        /* 47 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!***********************************!*\
	          !*** ./src/browser/groupRow.html ***!
	          \***********************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            var path = 'ng-table/groupRow.html';
	            var html = "<tr ng-if=\"params.hasGroup()\" ng-show=\"$groupRow.show\" class=\"ng-table-group-header\">\n    <th colspan=\"{{$ctrl.getVisibleColumns().length}}\" class=\"sortable\" ng-class=\"{\n                    'sort-asc': params.hasGroup($selGroup, 'asc'),\n                    'sort-desc':params.hasGroup($selGroup, 'desc')\n                  }\">\n        <a href=\"\" ng-click=\"isSelectorOpen = !isSelectorOpen\" class=\"ng-table-group-selector\">\n            <strong class=\"sort-indicator\">{{$selGroupTitle}}</strong>\n            <button class=\"btn btn-default btn-xs ng-table-group-close\"\n                    ng-click=\"$groupRow.show = false; $event.preventDefault(); $event.stopPropagation();\">\n                <span class=\"glyphicon glyphicon-remove\"></span>\n            </button>\n            <button class=\"btn btn-default btn-xs ng-table-group-toggle\"\n                    ng-click=\"$ctrl.toggleDetail(); $event.preventDefault(); $event.stopPropagation();\">\n                <span class=\"glyphicon\" ng-class=\"{\n                    'glyphicon-resize-small': params.settings().groupOptions.isExpanded,\n                    'glyphicon-resize-full': !params.settings().groupOptions.isExpanded\n                }\"></span>\n            </button>\n        </a>\n        <div class=\"list-group\" ng-if=\"isSelectorOpen\">\n            <a href=\"\" class=\"list-group-item\" ng-repeat=\"group in $ctrl.getGroupables()\" ng-click=\"$ctrl.groupBy(group)\">\n                <strong>{{ $ctrl.getGroupTitle(group)}}</strong>\n                <strong ng-class=\"$ctrl.isSelectedGroup(group) && 'sort-indicator'\"></strong>\n            </a>\n        </div>\n    </th>\n</tr>\n";
	            var angular = __webpack_require__( /*! angular */0);
	            angular.module('ng').run(['$templateCache', function (c) {
	                c.put(path, html);
	            }]);
	            module.exports = path;
	
	            /***/
	        },
	        /* 48 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!*********************************!*\
	          !*** ./src/browser/header.html ***!
	          \*********************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            var path = 'ng-table/header.html';
	            var html = "<ng-table-group-row></ng-table-group-row>\n<ng-table-sorter-row></ng-table-sorter-row>\n<ng-table-filter-row></ng-table-filter-row>\n";
	            var angular = __webpack_require__( /*! angular */0);
	            angular.module('ng').run(['$templateCache', function (c) {
	                c.put(path, html);
	            }]);
	            module.exports = path;
	
	            /***/
	        },
	        /* 49 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!********************************!*\
	          !*** ./src/browser/pager.html ***!
	          \********************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            var path = 'ng-table/pager.html';
	            var html = "<div class=\"ng-cloak ng-table-pager\" ng-if=\"params.data.length\">\n    <div ng-if=\"params.settings().counts.length\" class=\"ng-table-counts btn-group pull-right\">\n        <button ng-repeat=\"count in params.settings().counts\" type=\"button\"\n                ng-class=\"{'active':params.count() == count}\"\n                ng-click=\"params.count(count)\" class=\"btn btn-default\">\n            <span ng-bind=\"count\"></span>\n        </button>\n    </div>\n    <ul ng-if=\"pages.length\" class=\"pagination ng-table-pagination\">\n        <li class=\"page-item\" ng-class=\"{'disabled': !page.active && !page.current, 'active': page.current}\" ng-repeat=\"page in pages\" ng-switch=\"page.type\">\n            <a class=\"page-link\" ng-switch-when=\"prev\" ng-click=\"params.page(page.number)\" href=\"\">&laquo;</a>\n            <a class=\"page-link\" ng-switch-when=\"first\" ng-click=\"params.page(page.number)\" href=\"\"><span ng-bind=\"page.number\"></span></a>\n            <a class=\"page-link\" ng-switch-when=\"page\" ng-click=\"params.page(page.number)\" href=\"\"><span ng-bind=\"page.number\"></span></a>\n            <a class=\"page-link\" ng-switch-when=\"more\" ng-click=\"params.page(page.number)\" href=\"\">&#8230;</a>\n            <a class=\"page-link\" ng-switch-when=\"last\" ng-click=\"params.page(page.number)\" href=\"\"><span ng-bind=\"page.number\"></span></a>\n            <a class=\"page-link\" ng-switch-when=\"next\" ng-click=\"params.page(page.number)\" href=\"\">&raquo;</a>\n        </li>\n    </ul>\n</div>\n";
	            var angular = __webpack_require__( /*! angular */0);
	            angular.module('ng').run(['$templateCache', function (c) {
	                c.put(path, html);
	            }]);
	            module.exports = path;
	
	            /***/
	        },
	        /* 50 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!************************************!*\
	          !*** ./src/browser/sorterRow.html ***!
	          \************************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            var path = 'ng-table/sorterRow.html';
	            var html = "<tr class=\"ng-table-sort-header\">\n    <th title=\"{{$column.headerTitle(this)}}\"\n        ng-repeat=\"$column in $columns\"\n        ng-class=\"{\n                    'sortable': $column.sortable(this),\n                    'sort-asc': params.sorting()[$column.sortable(this)]=='asc',\n                    'sort-desc': params.sorting()[$column.sortable(this)]=='desc'\n                  }\"\n        ng-click=\"$ctrl.sortBy($column, $event)\"\n        ng-if=\"$column.show(this)\"\n        ng-init=\"template = $column.headerTemplateURL(this)\"\n        class=\"header {{$column.class(this)}}\">\n        <div ng-if=\"!template\" class=\"ng-table-header\" ng-class=\"{'sort-indicator': params.settings().sortingIndicator == 'div'}\">\n            <span ng-bind=\"$column.title(this)\" ng-class=\"{'sort-indicator': params.settings().sortingIndicator == 'span'}\"></span>\n        </div>\n        <div ng-if=\"template\" ng-include=\"template\"></div>\n    </th>\n</tr>\n";
	            var angular = __webpack_require__( /*! angular */0);
	            angular.module('ng').run(['$templateCache', function (c) {
	                c.put(path, html);
	            }]);
	            module.exports = path;
	
	            /***/
	        },
	        /* 51 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!******************!*\
	          !*** ./index.ts ***!
	          \******************/
	        /***/function (module, exports, __webpack_require__) {
	
	            "use strict";
	            "use strict";
	
	            function __export(m) {
	                for (var p in m) {
	                    if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	                }
	            }
	            var ng1 = __webpack_require__( /*! angular */0);
	            var core_1 = __webpack_require__( /*! ./src/core */1);
	            var browser_1 = __webpack_require__( /*! ./src/browser */2);
	            var ngTableModule = ng1.module('ngTable', [core_1.ngTableCoreModule.name, browser_1.ngTableBrowserModule.name]);
	            exports.ngTableModule = ngTableModule;
	            __export(__webpack_require__( /*! ./src/core */1));
	            __export(__webpack_require__( /*! ./src/browser */2));
	
	            /***/
	        },
	        /* 52 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!***************************************!*\
	          !*** ./src/browser/filters/hidden.html ***!
	          \***************************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            var path = 'ng-table/filters/hidden.html';
	            var html = "<input type=\"hidden\" name=\"{{name}}\" ng-disabled=\"$filterRow.disabled\" ng-model=\"params.filter()[name]\" class=\"input-filter form-control\"\n  placeholder=\"{{getFilterPlaceholderValue(filter, name)}}\"/>\n";
	            var angular = __webpack_require__( /*! angular */0);
	            angular.module('ng').run(['$templateCache', function (c) {
	                c.put(path, html);
	            }]);
	            module.exports = path;
	
	            /***/
	        }]
	        /******/)
	    );
	});
	//# sourceMappingURL=ng-table.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)(module)))

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _pdfViewer = __webpack_require__(554);
	
	var _pdfViewer2 = _interopRequireDefault(_pdfViewer);
	
	var _pdfViewer3 = __webpack_require__(590);
	
	var _pdfViewer4 = _interopRequireDefault(_pdfViewer3);
	
	__webpack_require__(174);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PdfViewerComponent = {
	  bindings: {
	    scale: '@',
	    page: '@',
	    height: '@',
	    download: '@',
	    print: '@',
	    open: '@',
	    name: '@',
	    base64: '<',
	    data: '<',
	    url: '@'
	  },
	  controller: _pdfViewer2.default,
	  template: _pdfViewer4.default
	};
	
	exports.default = PdfViewerComponent;

/***/ }),
/* 554 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PdfViewerController = function () {
	  PdfViewerController.$inject = ["$q", "$scope", "$http", "Storage"];
	  function PdfViewerController($q, $scope, $http, Storage) {
	    'ngInject';
	
	    _classCallCheck(this, PdfViewerController);
	
	    this.defer = $q.defer();
	    this.$scope = $scope;
	    this.$http = $http;
	    this.Storage = Storage;
	  }
	
	  _createClass(PdfViewerController, [{
	    key: '$onInit',
	    value: function $onInit() {
	
	      // atob() is used to convert base64 encoded PDF to binary-like data.
	      // (See also https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/
	      // Base64_encoding_and_decoding.)}
	
	
	      this.base64Data = 'JVBERi0xLjcKCjEgMCBvYmogICUgZW50cnkgcG9pbnQKPDwKICAvVHlwZSAvQ2F0YWxvZwog' + 'IC9QYWdlcyAyIDAgUgo+PgplbmRvYmoKCjIgMCBvYmoKPDwKICAvVHlwZSAvUGFnZXMKICAv' + 'TWVkaWFCb3ggWyAwIDAgMjAwIDIwMCBdCiAgL0NvdW50IDEKICAvS2lkcyBbIDMgMCBSIF0K' + 'Pj4KZW5kb2JqCgozIDAgb2JqCjw8CiAgL1R5cGUgL1BhZ2UKICAvUGFyZW50IDIgMCBSCiAg' + 'L1Jlc291cmNlcyA8PAogICAgL0ZvbnQgPDwKICAgICAgL0YxIDQgMCBSIAogICAgPj4KICA+' + 'PgogIC9Db250ZW50cyA1IDAgUgo+PgplbmRvYmoKCjQgMCBvYmoKPDwKICAvVHlwZSAvRm9u' + 'dAogIC9TdWJ0eXBlIC9UeXBlMQogIC9CYXNlRm9udCAvVGltZXMtUm9tYW4KPj4KZW5kb2Jq' + 'Cgo1IDAgb2JqICAlIHBhZ2UgY29udGVudAo8PAogIC9MZW5ndGggNDQKPj4Kc3RyZWFtCkJU' + 'CjcwIDUwIFRECi9GMSAxMiBUZgooSGVsbG8sIHdvcmxkISkgVGoKRVQKZW5kc3RyZWFtCmVu' + 'ZG9iagoKeHJlZgowIDYKMDAwMDAwMDAwMCA2NTUzNSBmIAowMDAwMDAwMDEwIDAwMDAwIG4g' + 'CjAwMDAwMDAwNzkgMDAwMDAgbiAKMDAwMDAwMDE3MyAwMDAwMCBuIAowMDAwMDAwMzAxIDAw' + 'MDAwIG4gCjAwMDAwMDAzODAgMDAwMDAgbiAKdHJhaWxlcgo8PAogIC9TaXplIDYKICAvUm9v' + 'dCAxIDAgUgo+PgpzdGFydHhyZWYKNDkyCiUlRU9G';
	
	      // For Base64 files
	      // this.pdfUrl = {
	      //   data: atob(this.base64Data)
	      // };
	
	      // TODO Falta implementar print y download
	      // Url files
	      // this.pdfUrl = '//cdn.mozilla.net/pdfjs/tracemonkey.pdf';
	
	      // TODO Opciones todavia no probadas. Falta implementar print y download
	      // withCredentials
	      // this.pdfUrl = {
	      //   'url': '//cdn.mozilla.net/pdfjs/tracemonkey.pdf',
	      //   'method': 'POST',
	      //   'withCredentials': false,
	      //   'httpHeaders': { 'Authorization': 'Bearer some-aleatory-token' }
	      // };
	      // this.base64 = this.base64Data;
	      // if(this.pdfUrl) {
	      //   this.pdfUrl = '//cdn.mozilla.net/pdfjs/tracemonkey.pdf';
	      // }
	      if (this.base64) {
	        this.pdfBase64 = this.base64;
	      }
	    }
	  }, {
	    key: '$onChanges',
	    value: function $onChanges() {
	      var _this = this;
	
	      // if(this.base64) {
	      //   this.pdfBase64 = this.base64;
	      // }
	      if (this.data) {
	        if (this.data.method == 'POST') {
	          var config = {
	            responseType: 'arraybuffer'
	          };
	          if (this.Storage.get('token')) {
	            config.headers = {
	              'Authorization': this.Storage.get('token')
	            };
	          }
	          this.data.urlDownload = this.data.url;
	          this.$http.post(this.data.urlDownload, {}, config).then(function (resp) {
	            if (resp && resp.data) {
	              var file = new window.Blob([resp.data], { type: 'application/pdf' });
	              _this.data.url = window.URL.createObjectURL(file);
	              _this.pdfUrl = _this.data;
	            }
	          }).catch(function (error) {});
	        } else {
	          this.pdfUrl = this.data;
	        }
	      }
	      this.$scope.$watch(function () {
	        _this.heightPdfContainer = parseInt(_this.height, 10) - 32 + 'px';
	        angular.element(document.querySelectorAll('.ng-pdf-container')).css('max-height', _this.heightPdfContainer);
	      });
	    }
	  }, {
	    key: '$onDestroy',
	    value: function $onDestroy() {
	      var ngPrintFile = document.getElementById('print-ng-pdf-container');
	      ngPrintFile.parentNode.removeChild(ngPrintFile);
	    }
	  }]);
	
	  return PdfViewerController;
	}();
	
	exports.default = PdfViewerController;

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _pdfViewer = __webpack_require__(553);
	
	var _pdfViewer2 = _interopRequireDefault(_pdfViewer);
	
	var _angularPdf = __webpack_require__(556);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PdfViewerModule = angular.module('app.pdf-viewer', []).component('pdfViewer', _pdfViewer2.default).directive('ngPdf', _angularPdf.NgPdf).name;
	
	exports.default = PdfViewerModule;

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.NgPdf = undefined;
	
	var _viewer = __webpack_require__(591);
	
	var _viewer2 = _interopRequireDefault(_viewer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NgPdf = exports.NgPdf = ["$window", "$document", "$http", "$log", "$sce", "$timeout", "$compile", function NgPdf($window, $document, $http, $log, $sce, $timeout, $compile) {
	  'ngInject';
	
	  var backingScale = function backingScale(canvas) {
	    var ctx = canvas.getContext('2d');
	    var dpr = $window.devicePixelRatio || 1;
	    var bsr = ctx.webkitBackingStorePixelRatio || ctx.mozBackingStorePixelRatio || ctx.msBackingStorePixelRatio || ctx.oBackingStorePixelRatio || ctx.backingStorePixelRatio || 1;
	
	    return dpr / bsr;
	  };
	
	  var setCanvasDimensions = function setCanvasDimensions(canvas, w, h) {
	    var ratio = backingScale(canvas);
	    canvas.width = Math.floor(w * ratio);
	    canvas.height = Math.floor(h * ratio);
	    canvas.style.width = Math.floor(w) + 'px';
	    canvas.style.height = Math.floor(h) + 'px';
	    canvas.getContext('2d').setTransform(ratio, 0, 0, ratio, 0, 0);
	    return canvas;
	  };
	
	  var initCanvas = function initCanvas(element, canvas, printCanvas) {
	    var divCanvas = $document[0].querySelector('.ng-pdf-container') ? $document[0].querySelector('.ng-pdf-container') : $document[0].createElement('div');
	    angular.element(divCanvas).addClass('ng-pdf-container');
	    angular.element(canvas).addClass('rotate0');
	    angular.element(divCanvas).append(canvas);
	    element.append(divCanvas);
	
	    var divCanvasPrint = document.querySelector('#print-ng-pdf-container') ? document.querySelector('#print-ng-pdf-container') : document.createElement('div');
	    divCanvasPrint.innerHTML = '';
	    angular.element(printCanvas).addClass('rotate0');
	    angular.element(divCanvasPrint).attr('id', 'print-ng-pdf-container').addClass('print-ng-pdf-container').append(printCanvas);
	    document.body.appendChild(divCanvasPrint);
	  };
	
	  return {
	    restrict: 'E',
	    template: _viewer2.default,
	    scope: {
	      data: '<',
	      data64: '<'
	    },
	    // templateUrl(element, attr) {
	    //   return attr.templateUrl ? attr.templateUrl : 'partials/viewer.html';
	    // },
	    link: function link(scope, element, attrs) {
	      var renderTask = null;
	      var pdfLoaderTask = null;
	      var debug = false;
	      var url = scope.pdfUrl;
	      var httpHeaders = scope.httpHeaders;
	      var pdfDoc = null;
	      var pageToDisplay = isFinite(attrs.page) ? parseInt(attrs.page) : 1;
	      var pageFit = attrs.scale === 'page-fit';
	      var limitHeight = attrs.limitcanvasheight === '1';
	      var scale = attrs.scale > 0 ? attrs.scale : 1;
	      var canvas = []; //$document[0].createElement('canvas');
	      var printCanvas = [];
	      var printCtx = [];
	      //let canvas = $document[0].createElement('canvas');
	      //initCanvas(element, canvas);
	      var creds = attrs.usecredentials;
	      debug = attrs.hasOwnProperty('debug') ? attrs.debug : false;
	
	      var ctx = [];
	      // let ctx = canvas.getContext('2d');
	      var windowEl = angular.element($window);
	
	      scope.download = attrs.download == 'true' ? true : false;
	      scope.print = attrs.print == 'true' ? true : false;
	      scope.name = attrs.name ? attrs.name : 'documento.pdf';
	      scope.pageLimit = 5; // Limite paginas para modo paginado.
	
	      element.css('display', 'block');
	
	      windowEl.on('scroll', function () {
	        scope.$apply(function () {
	          scope.scroll = windowEl[0].scrollY;
	        });
	      });
	
	      PDFJS.disableWorker = true;
	      scope.pageNum = pageToDisplay;
	
	      var printRenderPage = function printRenderPage(num) {
	        if (renderTask) {
	          renderTask._internalRenderTask.cancel();
	        }
	
	        pdfDoc.getPage(num).then(function (page) {
	          var pageWidthScale = void 0;
	          var printRenderContext = void 0;
	
	          //for print pages
	          var printViewport = page.getViewport(1);
	          printViewport = page.getViewport(2);
	          if (scope.pageLimit >= scope.pageCount) {
	            setCanvasDimensions(printCanvas[num - 1], printViewport.width, printViewport.height);
	            printRenderContext = {
	              canvasContext: printCtx[num - 1],
	              viewport: printViewport
	            };
	          } else {
	            setCanvasDimensions(printCanvas[0], printViewport.width, printViewport.height);
	            printRenderContext = {
	              canvasContext: printCtx[0],
	              viewport: printViewport
	            };
	          }
	          renderTask = page.render(printRenderContext);
	          renderTask.promise.then(function () {
	            if (angular.isFunction(scope.onPageRender)) {
	              scope.onPageRender();
	            }
	          }).catch(function (reason) {
	            $log.log(reason);
	          });
	        });
	      };
	
	      scope.renderPage = function (num) {
	        if (renderTask) {
	          renderTask._internalRenderTask.cancel();
	        }
	
	        pdfDoc.getPage(num).then(function (page) {
	          var viewport = void 0;
	          var pageWidthScale = void 0;
	          var renderContext = void 0;
	
	          if (pageFit) {
	            viewport = page.getViewport(1);
	            var clientRect = element[0].getBoundingClientRect();
	            pageWidthScale = clientRect.width / viewport.width - 0.1;
	            if (limitHeight) {
	              pageWidthScale = Math.min(pageWidthScale, clientRect.height / viewport.height);
	            }
	            scale = pageWidthScale;
	          }
	          viewport = page.getViewport(scale);
	
	          if (scope.pageLimit >= scope.pageCount) {
	            setCanvasDimensions(canvas[num - 1], viewport.width, viewport.height);
	            renderContext = {
	              canvasContext: ctx[num - 1],
	              viewport: viewport
	            };
	          } else {
	            setCanvasDimensions(canvas[0], viewport.width, viewport.height);
	            renderContext = {
	              canvasContext: ctx[0],
	              viewport: viewport
	            };
	          }
	
	          renderTask = page.render(renderContext);
	          renderTask.promise.then(function () {
	            if (angular.isFunction(scope.onPageRender)) {
	              scope.onPageRender();
	            }
	          }).catch(function (reason) {
	            $log.log(reason);
	          });
	        });
	      };
	
	      scope.goPrevious = function () {
	        if (scope.pageToDisplay <= 1) {
	          return;
	        }
	        scope.pageToDisplay = parseInt(scope.pageToDisplay) - 1;
	        scope.pageNum = scope.pageToDisplay;
	      };
	
	      scope.goNext = function () {
	        if (scope.pageToDisplay >= parseInt(pdfDoc.numPages)) {
	          return;
	        }
	        scope.pageToDisplay = parseInt(scope.pageToDisplay) + 1;
	        scope.pageNum = scope.pageToDisplay;
	      };
	
	      scope.zoomIn = function () {
	        pageFit = false;
	        if (parseFloat(scale) + 0.2 > 2.2) return scale;
	        scale = parseFloat(scale) + 0.2;
	        // scope.renderPage(scope.pageToDisplay);
	        var aux = void 0;
	        for (var i = 0; i < canvas.length; i++) {
	          scope.renderPage(i + 1);
	          if (canvas[i].getAttribute('class') === 'rotate90') {
	            aux = parseInt(canvas[i].style.width.replace('px', '')) - parseInt(canvas[i].style.height.replace('px', ''));
	            canvas[i].style.marginBottom = 48 + aux + 'px';
	          } else {
	            canvas[i].style.marginBottom = 8 + 'px';
	          }
	        }
	        return scale;
	      };
	
	      scope.zoomOut = function () {
	        pageFit = false;
	        if (parseFloat(scale) - 0.2 < 0.2) return scale;
	        scale = parseFloat(scale) - 0.2;
	        // scope.renderPage(scope.pageToDisplay);
	        var aux = void 0;
	        for (var i = 0; i < canvas.length; i++) {
	          scope.renderPage(i + 1);
	          if (canvas[i].getAttribute('class') === 'rotate90') {
	            aux = parseInt(canvas[i].style.width.replace('px', '')) - parseInt(canvas[i].style.height.replace('px', ''));
	            canvas[i].style.marginBottom = aux + 'px';
	          } else {
	            canvas[i].style.marginBottom = 16 + 'px';
	          }
	        }
	        return scale;
	      };
	
	      scope.fit = function () {
	        pageFit = true;
	        // scope.renderPage(scope.pageToDisplay);
	        for (var i = 0; i < canvas.length; i++) {
	          scope.renderPage(i + 1);
	        }
	      };
	
	      scope.changePage = function () {
	        scope.renderPage(scope.pageToDisplay);
	      };
	
	      scope.rotate = function () {
	        var aux = void 0;
	        for (var i = 0; i < canvas.length; i++) {
	          aux = parseInt(canvas[i].style.width.replace('px', '')) - parseInt(canvas[i].style.height.replace('px', ''));
	          if (canvas[i].getAttribute('class') === 'rotate0') {
	            canvas[i].setAttribute('class', 'rotate90');
	            canvas[i].style.marginBottom = 16 + aux + 'px';
	          } else if (canvas[i].getAttribute('class') === 'rotate90') {
	            canvas[i].setAttribute('class', 'rotate180');
	            canvas[i].style.marginBottom = 16 + 'px';
	          } else if (canvas[i].getAttribute('class') === 'rotate180') {
	            canvas[i].setAttribute('class', 'rotate270');
	            canvas[i].style.marginBottom = 16 + aux + 'px';
	          } else {
	            canvas[i].setAttribute('class', 'rotate0');
	            canvas[i].style.marginBottom = 16 + 'px';
	          }
	        }
	      };
	
	      scope.downloadFile = function () {
	        if (!scope.descargando) {
	          scope.descargando = true;
	          var a = document.createElement('a');
	          a.innerHTML = '.';
	          element.append(a);
	          $compile(a)(scope);
	          // Si se utiliza una dirección URL del archivo PDF
	          if (scope.data && scope.data.url) {
	            // a = document.getElementById('download_'+scope.name);
	            // Si es InternetExplorer PDF
	            if (window.navigator.msSaveBlob && scope.data.urlDownload) {
	              // // IE hack; see http://msdn.microsoft.com/en-us/library/ie/hh779016.aspx
	              $http.post(scope.data.urlDownload, {}, { responseType: 'arraybuffer' }).then(function (resp) {
	                if (resp.data) {
	                  var file = new window.Blob([resp.data], { type: 'application/pdf' });
	                  window.navigator.msSaveOrOpenBlob(file, scope.name || 'documento.pdf');
	                  scope.descargando = false;
	                }
	              }).catch(function (error) {
	                $log.log(error);
	              });
	              return;
	            }
	            if (scope.data.method != 'POST') {
	              // // IE hack; see http://msdn.microsoft.com/en-us/library/ie/hh779016.aspx
	              $http.get(scope.data.url, { responseType: 'arraybuffer' }).then(function (resp) {
	                if (resp) {
	                  var file = new window.Blob([new Uint8Array(resp.data)], { type: 'application/pdf' });
	                  if (window.navigator.msSaveBlob) {
	                    window.navigator.msSaveOrOpenBlob(file, scope.name || 'documento.pdf');
	                    scope.descargando = false;
	                  } else {
	                    // a.href = window.URL.createObjectURL(file);
	                    var base64String = btoa(String.fromCharCode.apply(null, new Uint8Array(resp.data)));
	                    a.href = 'data:application/pdf;base64,' + base64String;
	                    a.download = scope.name || 'documento.pdf';
	                    a.target = '_blank';
	                    $timeout(function () {
	                      a.click();
	                      scope.descargando = false;
	                      angular.element(a).remove();
	                    }, 250);
	                  }
	                }
	              }).catch(function (error) {
	                $log.log(error);
	              });
	              return;
	            }
	            a.href = scope.data.url;
	            a.download = scope.name || 'documento.pdf';
	            a.target = '_blank';
	            $timeout(function () {
	              a.click();
	              scope.descargando = false;
	              angular.element(a).remove();
	            }, 250);
	            return;
	          }
	          // Para archivos en base 64.
	          var blob = b64toBlob(scope.data64.replace('data:application/pdf;base64,', ''), 'application/pdf');
	          if (window.navigator.msSaveBlob) {
	            // // IE hack; see http://msdn.microsoft.com/en-us/library/ie/hh779016.aspx
	            window.navigator.msSaveOrOpenBlob(blob, 'documento.pdf');
	            scope.descargando = false;
	          } else {
	            a.href = window.URL.createObjectURL(blob);
	            // a.href = 'data:application/pdf;base64,' + scope.data64;
	            a.download = scope.name || 'documento.pdf';
	            a.target = '_blank';
	            $timeout(function () {
	              a.click();
	              scope.descargando = false;
	            }, 250);
	          }
	        }
	      };
	
	      scope.printFile = function () {
	        window.print();
	      };
	
	      scope.printFileUrl = function () {
	        var documento = void 0;
	        // let blob = new Blob([scope.data.data], { type: 'application/pdf' });
	        // let objectURL = window.URL.createObjectURL(blob, { type: "application/pdf" });
	        if (scope.data && scope.data.url) {
	          documento = window.open(scope.data.url);
	          documento.onload = function () {
	            documento.print();
	          };
	        } else {
	          var blob = b64toBlob(scope.data64.replace('data:application/pdf;base64,', ''), 'application/pdf');
	          documento = $window.open(window.URL.createObjectURL(blob));
	          documento.onload = function () {
	            documento.print();
	          };
	        }
	        // var documento = $window.open( $sce.trustAsResourceUrl(objectURL) );
	      };
	
	      scope.detectIE = function () {
	        var ua = window.navigator.userAgent;
	        // Test values; Uncomment to check result …
	        // IE 10
	        // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';
	        // IE 11
	        // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';
	        // Edge 12 (Spartan)
	        // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';
	        // Edge 13
	        // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';
	        var msie = ua.indexOf('MSIE ');
	        if (msie > 0) {
	          // IE 10 or older => return version number
	          return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
	        }
	        var trident = ua.indexOf('Trident/');
	        if (trident > 0) {
	          // IE 11 => return version number
	          var rv = ua.indexOf('rv:');
	          return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
	        }
	        var edge = ua.indexOf('Edge/');
	        if (edge > 0) {
	          // Edge (IE 12+) => return version number
	          return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
	        }
	        // other browser
	        return false;
	      };
	      /**
	       * Determine the mobile operating system.
	       * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
	       *
	       * @returns {String}
	       */
	      scope.getMobileOS = function () {
	        var userAgent = navigator.userAgent || navigator.vendor || window.opera;
	        // Windows Phone must come first because its UA also contains "Android"
	        if (/windows phone/i.test(userAgent)) {
	          return 'Windows Phone';
	        }
	        if (/android/i.test(userAgent)) {
	          return 'Android';
	        }
	        // iOS detection from: http://stackoverflow.com/a/9039885/177710
	        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
	          return 'iOS';
	        }
	        return false;
	      };
	
	      /**
	       * b64toBlob - Convert base64 string to a Blob object
	       *
	       * @param  {string}  b64Data     Base64 string
	       * @param  {strig}   contentType Type of base64 file
	       * @param  {integer} sliceSize   Slice for performance
	       * @return {Blob}                Blob object
	       * @description https://stackoverflow.com/questions/16245767/creating-a-blob-from-a-base64-string-in-javascript
	       */
	      function b64toBlob(b64Data, contentType, sliceSize) {
	        contentType = contentType || '';
	        sliceSize = sliceSize || 512;
	
	        var byteCharacters = atob(b64Data);
	        var byteArrays = [];
	
	        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
	          var slice = byteCharacters.slice(offset, offset + sliceSize);
	
	          var byteNumbers = new Array(slice.length);
	          for (var i = 0; i < slice.length; i++) {
	            byteNumbers[i] = slice.charCodeAt(i);
	          }
	
	          var byteArray = new Uint8Array(byteNumbers);
	
	          byteArrays.push(byteArray);
	        }
	
	        var blob = new Blob(byteArrays, { type: contentType });
	        return blob;
	      }
	
	      function clearCanvas() {
	        for (var i = 0; i < ctx.length; i++) {
	          ctx[i].clearRect(0, 0, canvas[i].width, canvas[i].height);
	        }
	      }
	
	      function renderPDF() {
	        clearCanvas();
	
	        var params = void 0;
	        // let params = {
	        //   'url': url,
	        //   'withCredentials': creds
	        // };
	
	        if (httpHeaders) {
	          params.httpHeaders = httpHeaders;
	        }
	
	        if (scope.data) {
	          params = scope.data;
	        }
	
	        if (scope.data64) {
	          params = {
	            data: atob(scope.data64.replace('data:application/pdf;base64,', ''))
	          };
	        }
	
	        //if (url && url.length) {
	        if (params) {
	          $timeout(function () {
	            pdfLoaderTask = PDFJS.getDocument(params);
	            pdfLoaderTask.onProgress = scope.onProgress;
	            pdfLoaderTask.onPassword = scope.onPassword;
	            pdfLoaderTask.then(function (_pdfDoc) {
	              if (angular.isFunction(scope.onLoad)) {
	                scope.onLoad();
	              }
	
	              pdfDoc = _pdfDoc;
	              // scope.renderPage(scope.pageToDisplay);
	              //
	              var num = void 0,
	                  cant = void 0;
	              if (scope.pageLimit >= pdfDoc.numPages) {
	                num = 1;
	                cant = pdfDoc.numPages;
	              } else {
	                num = scope.pageToDisplay;
	                cant = parseInt(scope.pageToDisplay) || pdfDoc.numPages;
	              }
	              //for(var num = 1; num <= pdfDoc.numPages; num++) {
	              for (; num <= cant; num++) {
	                canvas.push($document[0].createElement('canvas'));
	                ctx[num - 1] = canvas[num - 1].getContext('2d');
	
	                printCanvas.push(document.createElement('canvas'));
	                printCtx[num - 1] = printCanvas[num - 1].getContext('2d');
	                initCanvas(element, canvas[num - 1], printCanvas);
	                scope.renderPage(num);
	                printRenderPage(num);
	              }
	
	              scope.$apply(function () {
	                scope.pageCount = _pdfDoc.numPages;
	              });
	            }, function (error) {
	              if (error) {
	                if (angular.isFunction(scope.onError)) {
	                  scope.onError(error);
	                }
	              }
	            });
	          }, 500);
	        }
	      }
	
	      scope.$watch('pageNum', function (newVal) {
	        if (pdfDoc && newVal > parseInt(pdfDoc.numPages)) {
	          newVal = pdfDoc.numPages;
	          scope.pageNum = pdfDoc.numPages;
	        }
	        if (newVal < 1) {
	          newVal = 1;
	          scope.pageNum = 1;
	        }
	        scope.pageToDisplay = parseInt(newVal);
	        if (pdfDoc !== null) {
	          scope.renderPage(scope.pageToDisplay);
	          printRenderPage(scope.pageToDisplay);
	        }
	      });
	
	      scope.$watch('data', function (newVal) {
	        if (newVal && newVal !== '') {
	          if (debug) {
	            $log.log('data change detected: ', scope.data);
	          }
	          url = newVal;
	          scope.pageNum = scope.pageToDisplay = pageToDisplay;
	          if (pdfLoaderTask) {
	            pdfLoaderTask.destroy().then(function () {
	              renderPDF();
	            });
	          } else {
	            renderPDF();
	          }
	        }
	      });
	
	      scope.$watch('data64', function (newVal) {
	        if (newVal && newVal !== '') {
	          if (debug) {
	            $log.log('data64 change detected: ', scope.data64);
	          }
	          url = newVal;
	          scope.pageNum = scope.pageToDisplay = pageToDisplay;
	          if (pdfLoaderTask) {
	            pdfLoaderTask.destroy().then(function () {
	              renderPDF();
	            });
	          } else {
	            renderPDF();
	          }
	        }
	      });
	
	      scope.$on('downloadFile', function () {
	        scope.downloadFile();
	      });
	
	      scope.$on('printFile', function () {
	        scope.printFile();
	      });
	    }
	  };
	}];
	/**
	 * Thanks to:
	 * https://github.com/sayanee/angularjs-pdf
	 */

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// Cargando elementos de bootstrap que se usarán en el sistema
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _datepicker = __webpack_require__(504);
	
	var _datepicker2 = _interopRequireDefault(_datepicker);
	
	var _datepickerPopup = __webpack_require__(506);
	
	var _datepickerPopup2 = _interopRequireDefault(_datepickerPopup);
	
	var _dropdown = __webpack_require__(510);
	
	var _dropdown2 = _interopRequireDefault(_dropdown);
	
	var _accordion = __webpack_require__(494);
	
	var _accordion2 = _interopRequireDefault(_accordion);
	
	var _alert = __webpack_require__(496);
	
	var _alert2 = _interopRequireDefault(_alert);
	
	var _buttons = __webpack_require__(498);
	
	var _buttons2 = _interopRequireDefault(_buttons);
	
	var _modal = __webpack_require__(514);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _popover = __webpack_require__(518);
	
	var _popover2 = _interopRequireDefault(_popover);
	
	var _tabs = __webpack_require__(524);
	
	var _tabs2 = _interopRequireDefault(_tabs);
	
	var _timepicker = __webpack_require__(527);
	
	var _timepicker2 = _interopRequireDefault(_timepicker);
	
	var _tooltip = __webpack_require__(529);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	var _pdfViewer = __webpack_require__(555);
	
	var _pdfViewer2 = _interopRequireDefault(_pdfViewer);
	
	var _imageViewer = __webpack_require__(551);
	
	var _imageViewer2 = _interopRequireDefault(_imageViewer);
	
	var _waves = __webpack_require__(560);
	
	var _waves2 = _interopRequireDefault(_waves);
	
	var _formly = __webpack_require__(549);
	
	var _formly2 = _interopRequireDefault(_formly);
	
	var _angularChips = __webpack_require__(488);
	
	var _angularChips2 = _interopRequireDefault(_angularChips);
	
	var _angularNumericDirective = __webpack_require__(492);
	
	var _angularNumericDirective2 = _interopRequireDefault(_angularNumericDirective);
	
	var _angularLeaflet = __webpack_require__(490);
	
	var _angularLeaflet2 = _interopRequireDefault(_angularLeaflet);
	
	__webpack_require__(175);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Vendor = angular.module('app.vendor', [_datepicker2.default, _datepickerPopup2.default, _dropdown2.default, _accordion2.default, _alert2.default, _buttons2.default, _modal2.default, _popover2.default, _tabs2.default, _timepicker2.default, _tooltip2.default, _waves2.default, _formly2.default, _angularChips2.default, _angularNumericDirective2.default, _angularLeaflet2.default, _imageViewer2.default, _pdfViewer2.default]).name;exports.default = Vendor;

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _waves = __webpack_require__(559);
	
	var _waves2 = _interopRequireDefault(_waves);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MdEffect = function () {
	    function MdEffect() {
	        _classCallCheck(this, MdEffect);
	
	        this.restrict = 'A';
	    }
	
	    _createClass(MdEffect, [{
	        key: 'link',
	        value: function link($scope, $elem, $attr) {
	            var className = ['waves-light'];
	            if ($attr.mdEffect.length) {
	                var array = $attr.mdEffect.split(' ');
	                if (array.length > 1) {
	                    className = array;
	                } else {
	                    className = [$attr.mdEffect];
	                }
	            }
	            if ($attr.class.indexOf('btn-secondary') != -1 || $attr.class.indexOf('btn-default') != -1) {
	                className = [];
	            }
	            _waves2.default.attach($elem, className);
	            _waves2.default.init();
	        }
	    }]);
	
	    return MdEffect;
	}();
	
	exports.default = MdEffect;

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*!
	 * Waves v0.7.5
	 * http://fian.my.id/Waves
	 *
	 * Copyright 2014-2016 Alfiana E. Sibuea and other contributors
	 * Released under the MIT license
	 * https://github.com/fians/Waves/blob/master/LICENSE
	 */
	
	;(function (window, factory) {
	    'use strict';
	
	    // AMD. Register as an anonymous module.  Wrap in function so we have access
	    // to root via `this`.
	
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	            return factory.apply(window);
	        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	
	    // Node. Does not work with strict CommonJS, but only CommonJS-like
	    // environments that support module.exports, like Node.
	    else if ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object') {
	            module.exports = factory.call(window);
	        }
	
	        // Browser globals.
	        else {
	                window.Waves = factory.call(window);
	            }
	})((typeof global === 'undefined' ? 'undefined' : _typeof(global)) === 'object' ? global : undefined, function () {
	    'use strict';
	
	    var Waves = Waves || {};
	    var $$ = document.querySelectorAll.bind(document);
	    var toString = Object.prototype.toString;
	    var isTouchAvailable = 'ontouchstart' in window;
	
	    // Find exact position of element
	    function isWindow(obj) {
	        return obj !== null && obj === obj.window;
	    }
	
	    function getWindow(elem) {
	        return isWindow(elem) ? elem : elem.nodeType === 9 && elem.defaultView;
	    }
	
	    function isObject(value) {
	        var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
	        return type === 'function' || type === 'object' && !!value;
	    }
	
	    function isDOMNode(obj) {
	        return isObject(obj) && obj.nodeType > 0;
	    }
	
	    function getWavesElements(nodes) {
	        var stringRepr = toString.call(nodes);
	
	        if (stringRepr === '[object String]') {
	            return $$(nodes);
	        } else if (isObject(nodes) && /^\[object (Array|HTMLCollection|NodeList|Object)\]$/.test(stringRepr) && nodes.hasOwnProperty('length')) {
	            return nodes;
	        } else if (isDOMNode(nodes)) {
	            return [nodes];
	        }
	
	        return [];
	    }
	
	    function offset(elem) {
	        var docElem,
	            win,
	            box = { top: 0, left: 0 },
	            doc = elem && elem.ownerDocument;
	
	        docElem = doc.documentElement;
	
	        if (_typeof(elem.getBoundingClientRect) !== ( true ? 'undefined' : _typeof(undefined))) {
	            box = elem.getBoundingClientRect();
	        }
	        win = getWindow(doc);
	        return {
	            top: box.top + win.pageYOffset - docElem.clientTop,
	            left: box.left + win.pageXOffset - docElem.clientLeft
	        };
	    }
	
	    function convertStyle(styleObj) {
	        var style = '';
	
	        for (var prop in styleObj) {
	            if (styleObj.hasOwnProperty(prop)) {
	                style += prop + ':' + styleObj[prop] + ';';
	            }
	        }
	
	        return style;
	    }
	
	    var Effect = {
	
	        // Effect duration
	        duration: 750,
	
	        // Effect delay (check for scroll before showing effect)
	        delay: 200,
	
	        show: function show(e, element, velocity) {
	
	            // Disable right click
	            if (e.button === 2) {
	                return false;
	            }
	
	            element = element || this;
	
	            // Create ripple
	            var ripple = document.createElement('div');
	            ripple.className = 'waves-ripple waves-rippling';
	            element.appendChild(ripple);
	
	            // Get click coordinate and element width
	            var pos = offset(element);
	            var relativeY = 0;
	            var relativeX = 0;
	            // Support for touch devices
	            if ('touches' in e && e.touches.length) {
	                relativeY = e.touches[0].pageY - pos.top;
	                relativeX = e.touches[0].pageX - pos.left;
	            }
	            //Normal case
	            else {
	                    relativeY = e.pageY - pos.top;
	                    relativeX = e.pageX - pos.left;
	                }
	            // Support for synthetic events
	            relativeX = relativeX >= 0 ? relativeX : 0;
	            relativeY = relativeY >= 0 ? relativeY : 0;
	
	            var scale = 'scale(' + element.clientWidth / 100 * 3 + ')';
	            var translate = 'translate(0,0)';
	
	            if (velocity) {
	                translate = 'translate(' + velocity.x + 'px, ' + velocity.y + 'px)';
	            }
	
	            // Attach data to element
	            ripple.setAttribute('data-hold', Date.now());
	            ripple.setAttribute('data-x', relativeX);
	            ripple.setAttribute('data-y', relativeY);
	            ripple.setAttribute('data-scale', scale);
	            ripple.setAttribute('data-translate', translate);
	
	            // Set ripple position
	            var rippleStyle = {
	                top: relativeY + 'px',
	                left: relativeX + 'px'
	            };
	
	            ripple.classList.add('waves-notransition');
	            ripple.setAttribute('style', convertStyle(rippleStyle));
	            ripple.classList.remove('waves-notransition');
	
	            // Scale the ripple
	            rippleStyle['-webkit-transform'] = scale + ' ' + translate;
	            rippleStyle['-moz-transform'] = scale + ' ' + translate;
	            rippleStyle['-ms-transform'] = scale + ' ' + translate;
	            rippleStyle['-o-transform'] = scale + ' ' + translate;
	            rippleStyle.transform = scale + ' ' + translate;
	            rippleStyle.opacity = '1';
	
	            var duration = e.type === 'mousemove' ? 2500 : Effect.duration;
	            rippleStyle['-webkit-transition-duration'] = duration + 'ms';
	            rippleStyle['-moz-transition-duration'] = duration + 'ms';
	            rippleStyle['-o-transition-duration'] = duration + 'ms';
	            rippleStyle['transition-duration'] = duration + 'ms';
	
	            ripple.setAttribute('style', convertStyle(rippleStyle));
	        },
	
	        hide: function hide(e, element) {
	            element = element || this;
	
	            var ripples = element.getElementsByClassName('waves-rippling');
	
	            for (var i = 0, len = ripples.length; i < len; i++) {
	                removeRipple(e, element, ripples[i]);
	            }
	        }
	    };
	
	    /**
	     * Collection of wrapper for HTML element that only have single tag
	     * like <input> and <img>
	     */
	    var TagWrapper = {
	
	        // Wrap <input> tag so it can perform the effect
	        input: function input(element) {
	
	            var parent = element.parentNode;
	
	            // If input already have parent just pass through
	            if (parent.tagName.toLowerCase() === 'i' && parent.classList.contains('waves-effect')) {
	                return;
	            }
	
	            // Put element class and style to the specified parent
	            var wrapper = document.createElement('i');
	            wrapper.className = element.className + ' waves-input-wrapper';
	            element.className = 'waves-button-input';
	
	            // Put element as child
	            parent.replaceChild(wrapper, element);
	            wrapper.appendChild(element);
	
	            // Apply element color and background color to wrapper
	            var elementStyle = window.getComputedStyle(element, null);
	            var color = elementStyle.color;
	            var backgroundColor = elementStyle.backgroundColor;
	
	            wrapper.setAttribute('style', 'color:' + color + ';background:' + backgroundColor);
	            element.setAttribute('style', 'background-color:rgba(0,0,0,0);');
	        },
	
	        // Wrap <img> tag so it can perform the effect
	        img: function img(element) {
	
	            var parent = element.parentNode;
	
	            // If input already have parent just pass through
	            if (parent.tagName.toLowerCase() === 'i' && parent.classList.contains('waves-effect')) {
	                return;
	            }
	
	            // Put element as child
	            var wrapper = document.createElement('i');
	            parent.replaceChild(wrapper, element);
	            wrapper.appendChild(element);
	        }
	    };
	
	    /**
	     * Hide the effect and remove the ripple. Must be
	     * a separate function to pass the JSLint...
	     */
	    function removeRipple(e, el, ripple) {
	
	        // Check if the ripple still exist
	        if (!ripple) {
	            return;
	        }
	
	        ripple.classList.remove('waves-rippling');
	
	        var relativeX = ripple.getAttribute('data-x');
	        var relativeY = ripple.getAttribute('data-y');
	        var scale = ripple.getAttribute('data-scale');
	        var translate = ripple.getAttribute('data-translate');
	
	        // Get delay beetween mousedown and mouse leave
	        var diff = Date.now() - Number(ripple.getAttribute('data-hold'));
	        var delay = 350 - diff;
	
	        if (delay < 0) {
	            delay = 0;
	        }
	
	        if (e.type === 'mousemove') {
	            delay = 150;
	        }
	
	        // Fade out ripple after delay
	        var duration = e.type === 'mousemove' ? 2500 : Effect.duration;
	
	        setTimeout(function () {
	
	            var style = {
	                top: relativeY + 'px',
	                left: relativeX + 'px',
	                opacity: '0',
	
	                // Duration
	                '-webkit-transition-duration': duration + 'ms',
	                '-moz-transition-duration': duration + 'ms',
	                '-o-transition-duration': duration + 'ms',
	                'transition-duration': duration + 'ms',
	                '-webkit-transform': scale + ' ' + translate,
	                '-moz-transform': scale + ' ' + translate,
	                '-ms-transform': scale + ' ' + translate,
	                '-o-transform': scale + ' ' + translate,
	                'transform': scale + ' ' + translate
	            };
	
	            ripple.setAttribute('style', convertStyle(style));
	
	            setTimeout(function () {
	                try {
	                    el.removeChild(ripple);
	                } catch (e) {
	                    return false;
	                }
	            }, duration);
	        }, delay);
	    }
	
	    /**
	     * Disable mousedown event for 500ms during and after touch
	     */
	    var TouchHandler = {
	
	        /* uses an integer rather than bool so there's no issues with
	         * needing to clear timeouts if another touch event occurred
	         * within the 500ms. Cannot mouseup between touchstart and
	         * touchend, nor in the 500ms after touchend. */
	        touches: 0,
	
	        allowEvent: function allowEvent(e) {
	
	            var allow = true;
	
	            if (/^(mousedown|mousemove)$/.test(e.type) && TouchHandler.touches) {
	                allow = false;
	            }
	
	            return allow;
	        },
	        registerEvent: function registerEvent(e) {
	            var eType = e.type;
	
	            if (eType === 'touchstart') {
	
	                TouchHandler.touches += 1; // push
	            } else if (/^(touchend|touchcancel)$/.test(eType)) {
	
	                setTimeout(function () {
	                    if (TouchHandler.touches) {
	                        TouchHandler.touches -= 1; // pop after 500ms
	                    }
	                }, 500);
	            }
	        }
	    };
	
	    /**
	     * Delegated click handler for .waves-effect element.
	     * returns null when .waves-effect element not in "click tree"
	     */
	    function getWavesEffectElement(e) {
	
	        if (TouchHandler.allowEvent(e) === false) {
	            return null;
	        }
	
	        var element = null;
	        var target = e.target || e.srcElement;
	
	        while (target.parentElement) {
	            if (!(target instanceof SVGElement) && target.classList.contains('waves-effect')) {
	                element = target;
	                break;
	            }
	            target = target.parentElement;
	        }
	
	        return element;
	    }
	
	    /**
	     * Bubble the click and show effect if .waves-effect elem was found
	     */
	    function showEffect(e) {
	
	        // Disable effect if element has "disabled" property on it
	        // In some cases, the event is not triggered by the current element
	        // if (e.target.getAttribute('disabled') !== null) {
	        //     return;
	        // }
	
	        var element = getWavesEffectElement(e);
	
	        if (element !== null) {
	
	            // Make it sure the element has either disabled property, disabled attribute or 'disabled' class
	            if (element.disabled || element.getAttribute('disabled') || element.classList.contains('disabled')) {
	                return;
	            }
	
	            TouchHandler.registerEvent(e);
	
	            if (e.type === 'touchstart' && Effect.delay) {
	
	                var hidden = false;
	
	                var timer = setTimeout(function () {
	                    timer = null;
	                    Effect.show(e, element);
	                }, Effect.delay);
	
	                var hideEffect = function hideEffect(hideEvent) {
	
	                    // if touch hasn't moved, and effect not yet started: start effect now
	                    if (timer) {
	                        clearTimeout(timer);
	                        timer = null;
	                        Effect.show(e, element);
	                    }
	                    if (!hidden) {
	                        hidden = true;
	                        Effect.hide(hideEvent, element);
	                    }
	                };
	
	                var touchMove = function touchMove(moveEvent) {
	                    if (timer) {
	                        clearTimeout(timer);
	                        timer = null;
	                    }
	                    hideEffect(moveEvent);
	                };
	
	                element.addEventListener('touchmove', touchMove, false);
	                element.addEventListener('touchend', hideEffect, false);
	                element.addEventListener('touchcancel', hideEffect, false);
	            } else {
	
	                Effect.show(e, element);
	
	                if (isTouchAvailable) {
	                    element.addEventListener('touchend', Effect.hide, false);
	                    element.addEventListener('touchcancel', Effect.hide, false);
	                }
	
	                element.addEventListener('mouseup', Effect.hide, false);
	                element.addEventListener('mouseleave', Effect.hide, false);
	            }
	        }
	    }
	
	    Waves.init = function (options) {
	        var body = document.body;
	
	        options = options || {};
	
	        if ('duration' in options) {
	            Effect.duration = options.duration;
	        }
	
	        if ('delay' in options) {
	            Effect.delay = options.delay;
	        }
	
	        if (isTouchAvailable) {
	            body.addEventListener('touchstart', showEffect, false);
	            body.addEventListener('touchcancel', TouchHandler.registerEvent, false);
	            body.addEventListener('touchend', TouchHandler.registerEvent, false);
	        }
	
	        body.addEventListener('mousedown', showEffect, false);
	    };
	
	    /**
	     * Attach Waves to dynamically loaded inputs, or add .waves-effect and other
	     * waves classes to a set of elements. Set drag to true if the ripple mouseover
	     * or skimming effect should be applied to the elements.
	     */
	    Waves.attach = function (elements, classes) {
	
	        elements = getWavesElements(elements);
	
	        if (toString.call(classes) === '[object Array]') {
	            classes = classes.join(' ');
	        }
	
	        classes = classes ? ' ' + classes : '';
	
	        var element, tagName;
	
	        for (var i = 0, len = elements.length; i < len; i++) {
	
	            element = elements[i];
	            tagName = element.tagName.toLowerCase();
	
	            if (['input', 'img'].indexOf(tagName) !== -1) {
	                TagWrapper[tagName](element);
	                element = element.parentElement;
	            }
	
	            if (element.className.indexOf('waves-effect') === -1) {
	                element.className += ' waves-effect' + classes;
	            }
	        }
	    };
	
	    /**
	     * Cause a ripple to appear in an element via code.
	     */
	    Waves.ripple = function (elements, options) {
	        elements = getWavesElements(elements);
	        var elementsLen = elements.length;
	
	        options = options || {};
	        options.wait = options.wait || 0;
	        options.position = options.position || null; // default = centre of element
	
	
	        if (elementsLen) {
	            var element,
	                pos,
	                off,
	                centre = {},
	                i = 0;
	            var mousedown = {
	                type: 'mousedown',
	                button: 1
	            };
	            var hideRipple = function hideRipple(mouseup, element) {
	                return function () {
	                    Effect.hide(mouseup, element);
	                };
	            };
	
	            for (; i < elementsLen; i++) {
	                element = elements[i];
	                pos = options.position || {
	                    x: element.clientWidth / 2,
	                    y: element.clientHeight / 2
	                };
	
	                off = offset(element);
	                centre.x = off.left + pos.x;
	                centre.y = off.top + pos.y;
	
	                mousedown.pageX = centre.x;
	                mousedown.pageY = centre.y;
	
	                Effect.show(mousedown, element);
	
	                if (options.wait >= 0 && options.wait !== null) {
	                    var mouseup = {
	                        type: 'mouseup',
	                        button: 1
	                    };
	
	                    setTimeout(hideRipple(mouseup, element), options.wait);
	                }
	            }
	        }
	    };
	
	    /**
	     * Remove all ripples from an element.
	     */
	    Waves.calm = function (elements) {
	        elements = getWavesElements(elements);
	        var mouseup = {
	            type: 'mouseup',
	            button: 1
	        };
	
	        for (var i = 0, len = elements.length; i < len; i++) {
	            Effect.hide(mouseup, elements[i]);
	        }
	    };
	
	    /**
	     * Deprecated API fallback
	     */
	    Waves.displayEffect = function (options) {
	        console.error('Waves.displayEffect() has been deprecated and will be removed in future version. Please use Waves.init() to initialize Waves effect');
	        Waves.init(options);
	    };
	
	    return Waves;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _waves = __webpack_require__(558);
	
	var _waves2 = _interopRequireDefault(_waves);
	
	__webpack_require__(176);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Waves = angular.module('vendor.waves', []).directive('mdEffect', function () {
	    return new _waves2.default();
	}).name;
	
	exports.default = Waves;

/***/ }),
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n    <h5 class=\"modal-title\" style=\"word-break:break-all;word-wrap:break-word;\"><i class=\"fa fa-paperclip\"></i>\n      {{$ctrl.title}}\n    </h5>\n    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cancel()\">\n        <span aria-hidden=\"true\">&times;</span>\n    </button>\n</div>\n<div class=\"modal-body\">\n  <div class=\"row\" ng-if=\"true\">\n    <div class=\"col\">\n      <image-viewer id=\"1\" base64=\"$ctrl.image.base64\" height=\"300\" vm=\"$ctrl.$ivScope\"></image-viewer>\n      <!-- <hr>\n      <img id=\"preview_imagen\" ng-if=\"$ctrl.informe.tipo!='application/pdf'\" ng-src=\"{{$ctrl.getBase64Image()}}\" width=\"100%\" alt=\"Fotografía del informe\"/> -->\n    </div>\n  </div>\n</div>\n<div class=\"modal-footer\">\n    <button md-effect type=\"button\" class=\"btn btn-warning\" ng-click=\"$ctrl.descargarImg()\">\n      <i class=\"fa fa-download\"></i> Descargar\n    </button>\n    <button md-effect type=\"button\" class=\"btn btn-success\" ng-click=\"$ctrl.imprimirImg()\"\n    ng-if=\"!$ctrl.Util.isMobile.any() && !$ctrl.Util.isIEoEdge()\">\n      <i class=\"fa fa-print\"></i> Imprimir\n    </button>\n    <button md-effect type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.save()\">\n        <i class=\"fa fa-check\"></i> Aceptar\n    </button>\n</div>\n"

/***/ }),
/* 574 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n    <h5 class=\"modal-title\"><i class=\"fa fa-{{ $ctrl.icon }}\" ng-if=\"$ctrl.icon\"></i> {{ $ctrl.title }}</h5>\n    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-if=\"$ctrl.btnClose\" ng-click=\"$ctrl.close()\">\n        <span aria-hidden=\"true\">&times;</span>\n    </button>\n</div>\n<div class=\"modal-body\">\n    <div ng-bind-html=\"$ctrl.message\" ng-if=\"$ctrl.message\"></div>\n</div>\n<div class=\"modal-footer\">\n    <button md-effect type=\"button\" class=\"btn btn-secondary\" ng-click=\"$ctrl.close()\" ng-if=\"$ctrl.cancel\">\n        <i class=\"fa fa-close\"></i> {{ $ctrl.labelCancel || 'Cancelar'}}\n    </button>\n    <button md-effect type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.ok()\">\n        <i class=\"fa fa-check\"></i> {{ $ctrl.labelOk || 'Aceptar' }}\n    </button>\n</div>"

/***/ }),
/* 575 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\"><i class=\"fa fa-file-pdf-o\"></i> {{$ctrl.item.title || 'PDF'}}</h5>\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cancel()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<div class=\"modal-body\">\n\n  <pdf-viewer ng-if=\"$ctrl.documento.tipo === 'application/pdf'\"\n  base64=\"$ctrl.documento.base64\" height=\"400px\" scale=\"page-fit\" page=\"1\" download=\"true\" print=\"true\"></pdf-viewer>\n\n</div>\n<div class=\"modal-footer\">\n  <button md-effect type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.ok()\">\n    <i class=\"fa fa-check\"></i> Aceptar\n  </button>\n</div>\n"

/***/ }),
/* 576 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\"><i class=\"fa fa-file-pdf-o\"></i> Declaración Jurada</h5>\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cancel()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<div class=\"modal-body\">\n  <iframe ng-src=\"{{$ctrl.urlPdf}}\" style=\"width:100%; height:550px;\" frameborder=\"0\">\n    <p>Su navegador no soporta iframe</p>\n  </iframe>\n</div>\n<div class=\"modal-footer\">\n  <button md-effect type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.ok()\">\n    <i class=\"fa fa-check\"></i> Aceptar\n  </button>\n</div>"

/***/ }),
/* 577 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\n  <div class=\"col-sm-12\">\n    <label for=\"{{$ctrl.name}}\" title=\"{{$ctrl.title}}\" class=\"title\" ng-class=\"{'requerido':$ctrl.ngRequired}\">{{$ctrl.label}}</label>\n    <input type=\"hidden\" name=\"{{$ctrl.name}}\" ng-required=\"$ctrl.ngRequired\" ng-model=\"$ctrl.model\">\n  </div>\n  <div class=\"col-sm-4\">\n    <div class=\"md-form-group md-select-group\">\n      <ui-select ng-if=\"!$ctrl.Util.isMobile.any()\" name=\"dia\" ng-change=\"$ctrl.setDate()\" ng-model=\"$ctrl.day\" theme=\"bootstrap\" class=\"md-select\"\n      ng-required=\"$ctrl.ngRequired || ($ctrl.month || $ctrl.year)\" ng-disabled=\"$ctrl.ngDisabled\" maxlen=\"2\">\n        <ui-select-match placeholder=\"DÍA\" allow-clear=\"true\" allow-clear-class>{{$select.selected.text}}</ui-select-match>\n        <ui-select-choices repeat=\"item in $ctrl.days | filter: $select.search\"\n          refresh=\"$ctrl.inputDate($select.search, $ctrl.days | filter: $select.search, 'day')\" refresh-delay=\"0\" >\n          <span ng-bind-html=\"item.text | highlight: $select.search\"></span>\n        </ui-select-choices>\n        <ui-select-no-choice>\n          <small> Seleccione un día válido. </small>\n        </ui-select-no-choice>\n      </ui-select>\n\n      <select ng-if=\"!!$ctrl.Util.isMobile.any()\" name=\"dia\" ng-model=\"$ctrl.day\" ng-options=\"item.value for item in $ctrl.days\"\n      class=\"select-mobile\" ng-change=\"$ctrl.setDate()\" ng-required=\"$ctrl.ngRequired || ($ctrl.month || $ctrl.year)\"></select>\n\n      <label class=\"{{!!$ctrl.Util.isMobile.any()? 'label-mobile' : 'md-control-label no-float-label'}}\" ng-class=\"{'requerido':$ctrl.ngRequired, 'hasvalue': $ctrl.day}\">DÍA</label>\n      <i class=\"md-bar\" ng-class=\"{'error':$ctrl.form.dia.$invalid && $ctrl.form.dia.$touched,'sin-error':!$ctrl.form.dia.$invalid}\"></i>\n      <div ng-messages=\"$ctrl.form.dia.$error\" class=\"error-select-date\" ng-if=\"$ctrl.form.dia.$touched || $ctrl.form.mes.$touched || $ctrl.form.anio.$touched\" role=\"alert\">\n        <div ng-message=\"required\"> El campo es requerido. </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"col-sm-4\">\n    <div class=\"md-form-group md-select-group\">\n      <ui-select ng-if=\"!$ctrl.Util.isMobile.any()\" name=\"mes\" ng-change=\"$ctrl.setDate()\" ng-model=\"$ctrl.month\" theme=\"bootstrap\" class=\"md-select\"\n      ng-required=\"$ctrl.ngRequired || ($ctrl.day || $ctrl.year)\" ng-disabled=\"$ctrl.ngDisabled\" maxlen=\"10\">\n        <ui-select-match placeholder=\"MES\" allow-clear=\"true\" allow-clear-class>{{$select.selected.text}}</ui-select-match>\n        <ui-select-choices repeat=\"item in $ctrl.months | filter: $select.search\"\n          refresh=\"$ctrl.inputDate($select.search, $ctrl.months | filter: $select.search, 'month')\" refresh-delay=\"0\" >\n          <span ng-bind-html=\"item.text | highlight: $select.search\"></span>\n        </ui-select-choices>\n        <ui-select-no-choice>\n          <small> Seleccione un mes válido. </small>\n        </ui-select-no-choice>\n      </ui-select>\n\n      <select class=\"select-mobile\" ng-if=\"!!$ctrl.Util.isMobile.any()\" name=\"mes\" ng-model=\"$ctrl.month\" ng-options=\"item.text for item in $ctrl.months\" ng-change=\"$ctrl.setDate()\" ng-required=\"$ctrl.ngRequired || ($ctrl.day || $ctrl.year)\"></select>\n\n      <label class=\"{{!!$ctrl.Util.isMobile.any()? 'label-mobile' : 'md-control-label no-float-label'}}\" ng-class=\"{'requerido':$ctrl.ngRequired, 'hasvalue': $ctrl.month}\">MES</label>\n      <i class=\"md-bar\" ng-class=\"{'error':$ctrl.form.mes.$invalid && $ctrl.form.mes.$touched,'sin-error':!$ctrl.form.mes.$invalid}\"></i>\n      <div ng-messages=\"$ctrl.form.mes.$error\" class=\"error-select-date\" ng-if=\"$ctrl.form.mes.$touched || $ctrl.form.dia.$touched || $ctrl.form.anio.$touched\" role=\"alert\">\n        <div ng-message=\"required\"> El campo es requerido. </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"col-sm-4\">\n    <div class=\"md-form-group md-select-group\">\n      <ui-select ng-if=\"!$ctrl.Util.isMobile.any()\" name=\"anio\" ng-change=\"$ctrl.setDate()\" ng-model=\"$ctrl.year\" theme=\"bootstrap\" class=\"md-select\"\n      ng-required=\"$ctrl.ngRequired || ($ctrl.day || $ctrl.month)\" ng-disabled=\"$ctrl.ngDisabled\" maxlen=\"4\">\n        <ui-select-match placeholder=\"AÑO\" allow-clear=\"true\" allow-clear-class>{{$select.selected.text}}</ui-select-match>\n        <ui-select-choices repeat=\"item in $ctrl.years | filter: $select.search\"\n          refresh=\"$ctrl.inputDate($select.search, $ctrl.years | filter: $select.search, 'year')\" refresh-delay=\"0\" >\n          <span ng-bind-html=\"item.text | highlight: $select.search\"></span>\n        </ui-select-choices>\n        <ui-select-no-choice>\n          <small> Seleccione un año válido. </small>\n        </ui-select-no-choice>\n      </ui-select>\n\n      <select class=\"select-mobile\"  ng-if=\"!!$ctrl.Util.isMobile.any()\" name=\"anio\" ng-model=\"$ctrl.year\" ng-options=\"item.value for item in $ctrl.years\" ng-change=\"$ctrl.setDate()\" ng-required=\"$ctrl.ngRequired || ($ctrl.day || $ctrl.month)\"></select>\n\n      <label class=\"{{!!$ctrl.Util.isMobile.any()? 'label-mobile' : 'md-control-label no-float-label'}}\" ng-class=\"{'requerido':$ctrl.ngRequired, 'hasvalue': $ctrl.year}\">AÑO</label>\n      <i class=\"md-bar\" ng-class=\"{'error':$ctrl.form.anio.$invalid && $ctrl.form.anio.$touched,'sin-error':!$ctrl.form.anio.$invalid}\"></i>\n      <div ng-messages=\"$ctrl.form.anio.$error\" class=\"error-select-date\" ng-if=\"$ctrl.form.anio.$touched || $ctrl.form.dia.$touched || $ctrl.form.mes.$touched\" role=\"alert\">\n        <div ng-message=\"required\"> El campo es requerido. </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 578 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\n  <div ng-class=\"$ctrl.horizontal? 'col-md-4' : 'col-md-12'\">\n    <div class=\"md-form-group md-select-group\" md-event-label>\n      <ui-select ng-if=\"!$ctrl.Util.isMobile.any()\" name=\"departamento\" ng-model=\"$ctrl.ngModel.departamento\"\n                 theme=\"bootstrap\" class=\"md-select\" spinner-enabled=\"true\" ng-required=\"$ctrl.ngRequired\"\n                 ng-disabled=\"$ctrl.ngDisabled\" ng-change=\"$ctrl.getProvincias({{$select.selected}}, true)\" maxlen=\"10\">\n        <ui-select-match placeholder=\"Seleccione Departamento\" allow-clear=\"!$ctrl.ngRequired\" allow-clear-class>{{$select.selected.nombre}}</ui-select-match>\n        <ui-select-choices repeat=\"item in $ctrl.departamentos | orderBy : 'nombre' | filter: $select.search\">\n          <span ng-bind-html=\"item.nombre | highlight: $select.search\"></span>\n        </ui-select-choices>\n        <ui-select-no-choice>\n          <small> Departamento no encontrado. </small>\n        </ui-select-no-choice>\n      </ui-select>\n\n      <select ng-if=\"!!$ctrl.Util.isMobile.any()\" name=\"departamento\" ng-model=\"$ctrl.ngModel.departamento\" ng-options=\"item.nombre for item in $ctrl.departamentos\"\n      class=\"select-mobile\" ng-change=\"$ctrl.getProvincias($ctrl.ngModel.departamento, true)\" ng-required=\"$ctrl.ngRequired\" ng-disabled=\"$ctrl.ngDisabled || $ctrl.disabledDepto\"></select>\n\n      <label for=\"departamento\" class=\"{{!!$ctrl.Util.isMobile.any()? 'label-mobile' : 'md-control-label'}}\"\n      ng-class=\"{'requerido':$ctrl.ngRequired, 'md-control-label': $ctrl.ngModel.departamento && !!$ctrl.Util.isMobile.any()}\">Departamento</label>\n\n      <i class=\"md-bar\" ng-class=\"{'error':$ctrl.form.departamento.$invalid && $ctrl.form.departamento.$touched}\"></i>\n      <div ng-messages=\"$ctrl.form.departamento.$error\" ap-error ng-if=\"$ctrl.form.departamento.$touched\" role=\"alert\">\n        <div ng-message=\"required\" ng-if=\"$ctrl.ngRequired\"> El campo es requerido. </div>\n      </div>\n    </div>\n  </div>\n\n  <div ng-class=\"$ctrl.horizontal? 'col-md-4' : 'col-md-12'\">\n    <div class=\"md-form-group md-select-group\" md-event-label>\n      <ui-select ng-if=\"!$ctrl.Util.isMobile.any()\" name=\"provincia\" ng-model=\"$ctrl.ngModel.provincia\" theme=\"bootstrap\" class=\"md-select\" ng-required=\"$ctrl.ngRequired\"\n      ng-disabled=\"$ctrl.ngDisabled\" ng-change=\"$ctrl.getMunicipios({{$select.selected}}, true)\" maxlen=\"20\">\n        <ui-select-match placeholder=\"Seleccione Provincia\" allow-clear=\"!$ctrl.ngRequired\" allow-clear-class>{{$select.selected.nombre}}</ui-select-match>\n        <ui-select-choices repeat=\"item in $ctrl.provincias | orderBy : 'nombre' | filter: $select.search\">\n          <span ng-bind-html=\"item.nombre | highlight: $select.search\"></span>\n        </ui-select-choices>\n        <ui-select-no-choice>\n          <small> {{!$ctrl.ngModel.departamento? 'Seleccione un departamento' : 'Provincia no encontrada'}} </small>\n        </ui-select-no-choice>\n      </ui-select>\n\n      <select ng-if=\"!!$ctrl.Util.isMobile.any()\" name=\"provincia\" ng-model=\"$ctrl.ngModel.provincia\" ng-options=\"item.nombre for item in $ctrl.provincias\"\n      class=\"select-mobile\" ng-change=\"$ctrl.getMunicipios($ctrl.ngModel.provincia, true)\" ng-required=\"$ctrl.ngRequired\" ng-disabled=\"$ctrl.ngDisabled\"></select>\n\n      <label for=\"provincia\" class=\"{{!!$ctrl.Util.isMobile.any()? 'label-mobile' : 'md-control-label'}}\"\n      ng-class=\"{'requerido':$ctrl.ngRequired, 'md-control-label': $ctrl.ngModel.provincia && !!$ctrl.Util.isMobile.any()}\">Provincia</label>\n\n      <i class=\"md-bar\" ng-class=\"{'error':$ctrl.form.provincia.$invalid && $ctrl.form.provincia.$touched}\"></i>\n      <div ng-messages=\"$ctrl.form.provincia.$error\" ap-error ng-if=\"$ctrl.form.provincia.$touched\" role=\"alert\">\n        <div ng-message=\"required\" ng-if=\"$ctrl.ngRequired && !$ctrl.ngModel.departamento\"> El campo es requerido. </div>\n        <div ng-if=\"$ctrl.ngModel.departamento && !$ctrl.ngModel.provincia\"> Debe seleccionar la Provincia. </div>\n      </div>\n    </div>\n  </div>\n\n  <div ng-class=\"$ctrl.horizontal? 'col-md-4' : 'col-md-12'\">\n    <div class=\"md-form-group md-select-group\" md-event-label>\n      <ui-select ng-if=\"!$ctrl.Util.isMobile.any()\" name=\"municipio\" on-select=\"$ctrl.onSelectMunicipio({item:$item})\" ng-model=\"$ctrl.ngModel.municipio\" theme=\"bootstrap\" class=\"md-select\"\n      ng-required=\"$ctrl.ngRequired\" ng-disabled=\"$ctrl.ngDisabled\" ng-change=\"$ctrl.selectMunicipio({item: $select.selected}, true)\" maxlen=\"20\">\n        <ui-select-match placeholder=\"Seleccione Municipio\" allow-clear=\"!$ctrl.ngRequired\" allow-clear-class>{{$select.selected.nombre}}</ui-select-match>\n        <ui-select-choices repeat=\"item in $ctrl.municipios | orderBy : 'nombre' | filter: $select.search\">\n          <span ng-bind-html=\"item.nombre | highlight: $select.search\"></span>\n        </ui-select-choices>\n        <ui-select-no-choice>\n          <small> {{!$ctrl.ngModel.provincia? 'Seleccione una provincia' : 'Provincia no encontrada'}} </small>\n        </ui-select-no-choice>\n      </ui-select>\n\n      <select ng-if=\"!!$ctrl.Util.isMobile.any()\" name=\"municipio\" ng-model=\"$ctrl.ngModel.municipio\" ng-options=\"item.nombre for item in $ctrl.municipios\"\n      class=\"select-mobile\" ng-change=\"$ctrl.selectMunicipio({item: $ctrl.ngModel.municipio}, true)\" ng-required=\"$ctrl.ngRequired\" ng-disabled=\"$ctrl.ngDisabled\"></select>\n\n      <label for=\"municipio\" class=\"{{!!$ctrl.Util.isMobile.any()? 'label-mobile' : 'md-control-label'}}\"\n      ng-class=\"{'requerido':$ctrl.ngRequired, 'md-control-label': $ctrl.ngModel.municipio && !!$ctrl.Util.isMobile.any()}\">Municipio</label>\n\n      <i class=\"md-bar\" ng-class=\"{'error':$ctrl.form.municipio.$invalid && $ctrl.form.municipio.$touched}\"></i>\n      <div ng-messages=\"$ctrl.form.municipio.$error\" ap-error ng-if=\"$ctrl.form.municipio.$touched\" role=\"alert\">\n        <div ng-message=\"required\" ng-if=\"$ctrl.ngRequired && !$ctrl.ngModel.provincia\"> El campo es requerido. </div>\n        <div ng-if=\"$ctrl.ngModel.provincia && !$ctrl.ngModel.municipio\"> Debe seleccionar el Municipio. </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 579 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"crud-table\">\n  <table ng-table-dynamic=\"$ctrl.tableParams with $ctrl.columns\" class=\"table table-striped table-hover table-responsive\">\n    <tr ng-repeat=\"row in $data\">\n      <td ng-repeat=\"col in $columns\">\n        <span class=\"{{(row[col.field] | typeof) == 'number' ? 'pull-right' : ''}}\">\n          {{ (row[col.field][col.subfield] || row[col.field]) | formatDecimal:2 | datetime:'convert' }}\n        </span>\n      </td>\n    </tr>\n  </table>\n</div>\n"

/***/ }),
/* 580 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"crud-table\">\n    <div class=\"d-flex justify-content-between\" ng-if=\"!$ctrl.inline\">\n        <div class=\"btn-container p-2\">\n            <label class=\"custom-control custom-checkbox\" ng-if=\"$ctrl.checks\" uib-tooltip=\"Seleccionar todos\">\n                <input type=\"checkbox\" class=\"custom-control-input\" ng-change=\"$ctrl.selectAllChecks()\" ng-model=\"$ctrl.modelSelectAllCheks\">\n                <span class=\"custom-control-indicator\"></span>\n            </label>\n            <button class=\"btn btn-primary\" md-effect type=\"button\" ng-click=\"$ctrl.actionChecks()\" ng-if=\"$ctrl.checks\">\n                <i class=\"fa fa-{{$ctrl.checks.icon}}\" ng-if=\"$ctrl.checks.icon\"></i> {{$ctrl.checks.label || 'Checks.label'}}\n            </button>\n            <button class=\"btn btn-primary\" md-effect ng-click=\"$ctrl.add()\" type=\"button\" uib-tooltip=\"Agregar nuevo registro\" ng-if=\"$ctrl.permissions.create\">\n                <i class=\"fa fa-plus\"></i> {{ $ctrl.labels.create || 'Agregar' }}\n            </button>\n            <button class=\"btn btn-default\" md-effect type=\"button\" ng-click=\"$ctrl.refresh()\" uib-tooltip=\"Actualizar tabla\">\n                <i class=\"fa fa-refresh\"></i>\n            </button>\n            <button md-effect class=\"btn\" ng-class=\"button.class || 'btn-default'\" type=\"button\" ng-repeat=\"button in $ctrl.buttonsTop\" uib-tooltip=\"{{button.tooltip}}\" ng-click=\"button.onclick? button.onclick($event):true\" ng-if=\"button.if? button.if() : true\">\n                <i class=\"fa fa-{{button.icon}}\"></i> {{button.label}}\n            </button>\n        </div>\n        <form name=\"$ctrl.searchForm\" class=\"form-search p-2\" novalidate ng-submit=\"$ctrl.search()\" ng-if=\"$ctrl.permissions.filter\">\n            <div class=\"input-group\">\n                <span class=\"input-group-btn\" ng-if=\"$ctrl.searchTerm.length\">\n                    <button class=\"btn btn-default\" type=\"button\" ng-click=\"$ctrl.cleanSearch()\" uib-tooltip=\"Limpiar búsqueda\">\n                        <i class=\"fa fa-trash\"></i>\n                    </button>\n                </span>\n                <input type=\"text\" class=\"form-control\" placeholder=\"Escriba su búsqueda aquí\" name=\"searchTerm\" ng-model=\"$ctrl.searchTerm\" required />\n                <span class=\"input-group-btn\">\n                    <button class=\"btn btn-default\" type=\"submit\" ng-disabled=\"$ctrl.searchForm.$invalid\" uib-tooltip=\"Buscar en la tabla\">\n                        <i class=\"fa fa-search\"></i>\n                    </button>\n                </span>\n            </div>\n        </form>\n    </div>\n    <!-- <div ng-if=\"$ctrl.inlineOptions\" class=\"alert alert-info\">\n        <div ng-if=\"!$ctrl.editItem\">\n            <strong>Opciones: </strong>\n            <button md-effect class=\"btn btn-default btn-sm\" type=\"button\" ng-click=\"$ctrl.edit()\" ng-if=\"$ctrl.permissions.update\" uib-tooltip=\"Editar la fila seleccionada\">\n                <i class=\"fa fa-edit\"></i> Editar\n            </button>\n            <button md-effect class=\"btn btn-danger btn-sm\" type=\"button\" ng-click=\"$ctrl.delete()\" ng-if=\"$ctrl.permissions.delete\" uib-tooltip=\"Eliminar la fila seleccionada\">\n                <i class=\"fa fa-trash\"></i> Eliminar\n            </button>\n        </div>\n        <div ng-if=\"$ctrl.editItem\">\n            <button md-effect class=\"btn btn-default btn-sm\" type=\"button\" ng-click=\"$ctrl.editCancel()\" ng-if=\"$ctrl.permissions.update\" uib-tooltip=\"Editar la fila seleccionada\">\n                <i class=\"fa fa-edit\"></i> Cancelar edición\n            </button>\n        </div>\n    </div> -->\n    <form ng-if=\"$ctrl.inline\" name=\"$ctrl.formInline\" ng-submit=\"$ctrl.saveFormInline()\" novalidate class=\"crud-table-form-inline\" ng-class=\"{'alert-info' : $ctrl.editItem }\">\n        <formly-form model=\"$ctrl.modelInline\" fields=\"$ctrl.fieldsData\" options=\"$ctrl.options\" form=\"$ctrl.formInline\">\n            <button md-effect type=\"submit\"  class=\"btn btn-primary submit-button\" uib-tooltip=\"Agregar a la lista\">\n                 <i class=\"fa fa-check\"></i>\n            </button>\n        </formly-form>\n    </form>\n    <div ng-class=\"{'edit-item-block' : $ctrl.editItem, 'crud-table-table-inline' : $ctrl.formInline }\" ng-hide=\"$ctrl.data.list && $ctrl.data.list.length == 0\">\n        <div ng-click=\"$ctrl.editCancel()\" class=\"edit-item-block-backdrop\"></div>\n        <div ng-table-dynamic=\"$ctrl.tableParams with $ctrl.headers\" show-filter=\"$ctrl.showFilter\" class=\"table-responsive\">\n            <table class=\"table table-striped table-hover ng-table\">\n                <tr ng-repeat=\"row in $data\" ng-class=\"{ 'edit-item' : row.edit }\" ng-click=\"$ctrl.selectRow(row, $data)\">\n                    <td ng-repeat=\"col in $columns\" ng-hide=\"\">\n                        <div ng-switch on=\"row[col.field]\" ng-if=\"col.dataType !== 'command'\">\n                            <div ng-switch-when=\"boolean_true\" class=\"text-center\">\n                                <i class=\"fa fa-check-circle text-success\"></i>\n                            </div>\n                            <div ng-switch-when=\"boolean_false\" class=\"text-center\">\n                                <!-- <i class=\"fa fa-check-circle text-success\"></i> -->\n                            </div>\n                            <div ng-switch-default ng-class=\"$ctrl.getFieldClass(row, col)\" ng-if=\"($ctrl.fieldsData[$index-1].type=='archive' && $ctrl.fieldsData[$index-1].templateOptions.type=='img')\">\n                                 <img ng-src=\"{{row[col.field]}}\" ng-if=\"row[col.field]\" width=\"100\" alt=\"{{col.field}}\" style:\"width: 100px; height: 90px; object-fit: contain;\"/>\n                                 <span ng-if=\"!row[col.field]\">Sin imagen</span>\n                            </div>\n                            <div ng-switch-default ng-class=\"$ctrl.getFieldClass(row, col)\" ng-if=\"!($ctrl.fieldsData[$index-1].type=='archive' && $ctrl.fieldsData[$index-1].templateOptions.type=='img')\">\n                                {{( col.field.split('.')[1]?\n                                    ( col.field.split('.')[2]?\n                                      ( col.field.split('.')[3]? row[col.field.split('.')[0]][col.field.split('.')[1]][col.field.split('.')[2]][col.field.split('.')[3]]\n                                        : row[col.field.split('.')[0]][col.field.split('.')[1]][col.field.split('.')[2]]\n                                      ) : row[col.field.split('.')[0]][col.field.split('.')[1]]\n                                    ) : row[col.field]) | formatDecimal:2 | datetime:'convert' }}\n                            </div>\n                        </div>\n\n                        <div ng-if=\"col.dataType === 'command'\" class=\"btn-actions\">\n                            <label class=\"custom-control custom-checkbox\" ng-if=\"$ctrl.checks && $ctrl.checkIf(row)\">\n                                <input type=\"checkbox\" class=\"custom-control-input\" ng-change=\"$ctrl.selectCheck(row)\" ng-model=\"row.checked\">\n                                <span class=\"custom-control-indicator\"></span>\n                            </label>\n                            <button md-effect class=\"btn btn-default btn-sm\" type=\"button\" ng-click=\"$ctrl.edit(row)\" ng-if=\"($ctrl.permissions.update && $ctrl.update === undefined) || $ctrl.update.states[row[$ctrl.update.key]]\" uib-tooltip=\"Editar\">\n                                <i class=\"fa fa-edit\"></i>\n                            </button>\n                            <button md-effect class=\"btn btn-danger btn-sm\" type=\"button\" ng-click=\"$ctrl.deleteRow(row)\" ng-if=\"($ctrl.permissions.delete && $ctrl.delete === undefined) || $ctrl.delete.states[row[$ctrl.delete.key]]\" uib-tooltip=\"Eliminar\">\n                                <i class=\"fa fa-trash\"></i>\n                            </button>\n                            <button md-effect class=\"btn btn-default btn-sm\" type=\"button\" ng-click=\"$ctrl.print($event, row)\" ng-if=\"$ctrl.permissions.print\" uib-tooltip=\"Imprimir\">\n                                <i class=\"fa fa-trash\"></i>\n                            </button>\n                            <button md-effect class=\"btn btn-sm\" ng-class=\"button.class || ['btn-default']\" type=\"button\" ng-repeat=\"button in $ctrl.buttons\" uib-tooltip=\"{{button.tooltip}}\" ng-click=\"$ctrl.buttonEvent($event, row, button.onclick)\" ng-if=\"$ctrl.buttonIf($event, row, button.if)\">\n                                <i class=\"fa fa-{{button.icon}}\"></i>\n                            </button>\n                        </div>\n                    </td>\n                </tr>\n            </table>\n        </div>\n        <div ng-if=\"$ctrl.emptyTable\" class=\"alert alert-warning\">\n            <i class=\"fa fa-warning\"></i> {{ $ctrl.labels.emptyTable || 'No existen registros' }}\n        </div>\n    </div>\n</div>"

/***/ }),
/* 581 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n    <h5 class=\"modal-title\"><i class=\"fa fa-user\"></i> Agregar/Editar {{ $ctrl.title }}</h5>\n    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cancel()\">\n        <span aria-hidden=\"true\">&times;</span>\n    </button>\n</div>\n<div class=\"modal-body\">\n    <formly-form model=\"$ctrl.model\" fields=\"$ctrl.fields\" options=\"$ctrl.options\" form=\"$ctrl.form\"></formly-form>\n</div>\n<div class=\"modal-footer\">\n    <button md-effect type=\"button\" class=\"btn btn-secondary\" ng-click=\"$ctrl.cancel()\">\n        <i class=\"fa fa-close\"></i> Cerrar\n    </button>\n    <button md-effect type=\"button\" class=\"btn btn-primary\" ng-disabled=\"$ctrl.form.$invalid\" ng-click=\"$ctrl.save()\">\n        <i class=\"fa fa-check\"></i> Guardar\n    </button>\n</div>"

/***/ }),
/* 582 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"documento\" ng-if=\"$ctrl.modoVista || ($ctrl.mostrarArchivo() && !$ctrl.cargarArchivo)\">\n  <div class=\"opciones\">\n    <button md-effect type=\"button\" class=\"btn btn-success btn-sm\" uib-tooltip=\"Ver documento\" ng-click=\"$ctrl.vistaPrevia()\" ng-if=\"$ctrl.ver&&$ctrl.ngModel\">\n      <i class=\"fa fa-eye\"></i>\n    </button>\n\n    <button md-effect type=\"button\" class=\"btn btn-primary btn-sm\" uib-tooltip=\"Descargar\"\n            download-file=\"{{$ctrl.urlDescargaDocumento}}\" file-name=\"{{$ctrl.label}}\" ng-if=\"$ctrl.descargar&&$ctrl.ngModel\">\n      <i class=\"fa fa-download\"></i>\n    </button>\n\n    <button md-effect type=\"button\" class=\"btn btn-info btn-sm\" uib-tooltip=\"Cambiar\" ng-if=\"!$ctrl.modoVista\" ng-click=\"$ctrl.cargarArchivo = true\">\n      <i class=\"fa fa-exchange\"></i>\n    </button>\n  </div>\n  <img ng-if=\"$ctrl.ngModel\" src=\"./images/documento.jpg\" alt=\"Documento\">\n  <img ng-if=\"!$ctrl.ngModel\" src=\"./images/documento-no-disponible.jpg\" alt=\"Documento no disponible\" title=\"El documento todavía se encuentra pendiente, notifique al encargado del documento.\">\n  <div class=\"detalles\" ng-class=\"{'btn-danger':!$ctrl.ngModel}\">\n    <div class=\"nombre\">{{$ctrl.label}}</div>\n  </div>\n</div>\n\n<ui-input-file name=\"{{$ctrl.name}}\" label=\"{{$ctrl.label}}\" file-base64=\"$ctrl.ngModel\"\n               types=\"{{$ctrl.types}}\" mime-types=\"{{$ctrl.mimeTypes}}\" maxfiles=\"1\" maxsize=\"{{$ctrl.maxsize}}\"\n               ng-if=\"!$ctrl.modoVista && (!$ctrl.mostrarArchivo() || $ctrl.cargarArchivo)\">\n</ui-input-file>\n"

/***/ }),
/* 583 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"documento-indentidad\">\r\n  <ng-form name=\"doc_identidad_form\">\r\n    <div class=\"row\">\r\n      <div class=\"col-md-6\" ng-if=\"!$ctrl.onlyCi\">\r\n        <select-parametro\r\n          name=\"tipo_documento\"\r\n          label=\"Tipo de verificación\"\r\n          ng-model=\"$ctrl.ngModel.tipo_documento\"\r\n          parametro=\"TIPO_DOCUMENTO\"\r\n          ng-change=\"$ctrl.changeType()\"\r\n          ng-required=\"!$ctrl.modoVista && true\"\r\n          ng-disabled=\"$ctrl.ngDisabled || ($ctrl.ngModel.tipo_documento == 'TD_CI' && $ctrl.fill) || $ctrl.modoVista\"\r\n        ></select-parametro>\r\n      </div>\r\n\r\n      <div class=\"col\" ng-if=\"!$ctrl.modoVista\">\r\n        <div\r\n          class=\"alert alert-info\"\r\n          ng-if=\"$ctrl.ngModel.tipo_documento == 'TD_CI' && !$ctrl.ngDisabled\"\r\n        >\r\n          <i class=\"fa fa-info-circle\"></i>\r\n          <span\r\n            >Ingrese el número de documento y la fecha de nacimiento para\r\n            realizar la búsqueda.</span\r\n          >\r\n        </div>\r\n        <div\r\n          class=\"alert alert-warning\"\r\n          ng-if=\"$ctrl.ngModel.tipo_documento != 'TD_CI' && !$ctrl.ngDisabled\"\r\n        >\r\n          <i class=\"fa fa-info-circle\"></i>\r\n          <span\r\n            >Ingrese el número de documento, fecha de nacimiento, primer\r\n            apellido, segundo apellido y nombres para realizar la contrastación\r\n            con segip.</span\r\n          >\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"row\">\r\n      <div class=\"col-md-4\">\r\n        <c-input\r\n          name=\"documento_identidad\"\r\n          label=\"Número de documento\"\r\n          ng-model=\"$ctrl.ngModel.numero_documento\"\r\n          maxlength=\"10\"\r\n          ng-directives=\"uppercase numeric\"\r\n          ng-required=\"!$ctrl.modoVista\"\r\n          ng-disabled=\"$ctrl.ngDisabled || $ctrl.isFill() || $ctrl.modoVista\"\r\n          ng-if=\"$ctrl.ngModel.tipo_documento == 'TD_CI'\"\r\n        ></c-input>\r\n\r\n        <c-input\r\n          name=\"documento_identidad\"\r\n          label=\"Número de documento\"\r\n          ng-model=\"$ctrl.ngModel.numero_documento\"\r\n          maxlength=\"15\"\r\n          ng-directives=\"uppercase passport\"\r\n          ng-required=\"!$ctrl.modoVista\"\r\n          ng-disabled=\"$ctrl.ngDisabled || $ctrl.isFill() || $ctrl.modoVista\"\r\n          ng-if=\"$ctrl.ngModel.tipo_documento == 'TD_PASS'\"\r\n        ></c-input>\r\n      </div>\r\n      <div class=\"col-md-4\">\r\n        <c-input\r\n          name=\"complemento\"\r\n          label=\"Complemento\"\r\n          ng-model=\"$ctrl.ngModel.complemento\"\r\n          maxlength=\"2\"\r\n          ng-directives=\"uppercase passport\"\r\n          ng-disabled=\"$ctrl.ngDisabled || $ctrl.isFill() || $ctrl.modoVista\"\r\n        ></c-input>\r\n      </div>\r\n\r\n      <div class=\"col-md-4\">\r\n        <c-date\r\n          name=\"fecha_nacimiento\"\r\n          label=\"Fecha de nacimiento\"\r\n          ng-model=\"$ctrl.ngModel.fecha_nacimiento\"\r\n          min-date=\"$ctrl.minDate\"\r\n          max-date=\"$ctrl.maxDate\"\r\n          ng-required=\"!$ctrl.modoVista\"\r\n          ng-disabled=\"$ctrl.ngDisabled || $ctrl.isFill() || $ctrl.modoVista\"\r\n        ></c-date>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"row\">\r\n      <div class=\"col-md-4\">\r\n        <c-input\r\n          name=\"primer_apellido\"\r\n          label=\"Primer Apellido\"\r\n          ng-model=\"$ctrl.ngModel.primer_apellido\"\r\n          ng-directives=\"alpha uppercase\"\r\n          maxlength=\"100\"\r\n        ></c-input>\r\n      </div>\r\n\r\n      <div class=\"col-md-4\">\r\n        <c-input\r\n          name=\"segundo_apellido\"\r\n          label=\"Segundo Apellido\"\r\n          ng-model=\"$ctrl.ngModel.segundo_apellido\"\r\n          ng-directives=\"alpha uppercase\"\r\n          maxlength=\"100\"\r\n        ></c-input>\r\n      </div>\r\n\r\n      <div class=\"col-md-4\">\r\n        <c-input\r\n          name=\"nombres\"\r\n          label=\"Nombre(s)\"\r\n          ng-model=\"$ctrl.ngModel.nombres\"\r\n          ng-required=\"!$ctrl.modoVista\"\r\n          ng-directives=\"alpha uppercase\"\r\n          maxlength=\"100\"\r\n        ></c-input>\r\n      </div>\r\n    </div>\r\n\r\n    <!-- <div class=\"row\">\r\n      <div class=\"col-md-12\" ng-if=\"!$ctrl.modoVista\">\r\n        <button md-effect type=\"button\" class=\"btn btn-warning\" ng-click=\"$ctrl.contrastar()\" ng-disabled=\"$ctrl.isDisabled()\" ng-if=\"!$ctrl.isCI() && !$ctrl.ngModel.noVerificar && !$ctrl.isFill()\">\r\n          <i class=\"fa fa-search\"></i>Verificar\r\n        </button>\r\n        <span ng-if=\"!$ctrl.isCI() && !$ctrl.isFill()\"> &nbsp; <input type=\"checkbox\" name=\"no_verificar\" ng-model=\"$ctrl.ngModel.noVerificar\"></input> Verificar después</span>\r\n        <div class=\"alert alert-warning\" ng-if=\"$ctrl.ngModel.noVerificar\">\r\n          <i class=\"fa fa-info-circle\"></i>\r\n          <span>Al marcar la casilla Ud. asegura que los datos son correctos, ya que el número de documento es el respectivo usuario y este sera relacionado a los datos de la persona registrada.</span>\r\n        </div>\r\n        <button md-effect type=\"button\" class=\"btn btn-warning\" ng-click=\"$ctrl.search()\" ng-disabled=\"$ctrl.isDisabled()\" ng-if=\"!$ctrl.isFill() && $ctrl.isCI()\">\r\n          <i class=\"fa fa-search\"></i>Buscar\r\n        </button>\r\n        <button md-effect type=\"button\" class=\"btn\" ng-click=\"$ctrl.nombreDel()\" ng-if=\"$ctrl.isFill()\">\r\n          <i class=\"fa fa-edit\"></i>Cambiar\r\n        </button>\r\n      </div>\r\n    </div> -->\r\n  </ng-form>\r\n</div>\r\n"

/***/ }),
/* 584 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"ui-file-upload\">\n    <!-- 3. nv-file-over uploader=\"link\" over-class=\"className\" -->\n    <div ng-show=\"uploader.isHTML5\">\n        <!-- Example: ng-file-drop | ng-file-drop=\"options\" -->\n        <label for=\"{{ $ctrl.idFile }}\" nv-file-drop=\"\" nv-file-over=\"\" uploader=\"uploader\" over-class=\"other-over-zone\" class=\"other-drop-zone zone\">\n            <span ng-if=\"!$ctrl.textUpload\">Arrastre su{{ $ctrl.multiple ? 's' : ''}} archivo{{ $ctrl.multiple ? 's' : ''}} aquí <br> o <br> haga click aquí</span>\n            <span ng-if=\"$ctrl.textUpload\" ng-bind-html=\"$ctrl.textUpload\"></span>\n        </label>\n    </div>\n    <!-- Example: nv-file-select=\"\" uploader=\"{Object}\" options=\"{Object}\" filters=\"{String}\" -->\n    <!-- <label for=\"{{ $ctrl.idFile }}\" md-effect class=\"btn btn-outline-default\">\n        <i class=\"fa fa-paperclip\"></i> Seleccionar archivo{{ $ctrl.multiple ? 's' : ''}}\n    </label> -->\n    <input type=\"file\" nv-file-select=\"\" ng-if=\"$ctrl.multiple === undefined\" uploader=\"uploader\" id=\"{{ $ctrl.idFile }}\" class=\"ng-hide\"/>\n    <input type=\"file\" nv-file-select=\"\" ng-if=\"$ctrl.multiple\" uploader=\"uploader\" id=\"{{ $ctrl.idFile }}\" multiple class=\"ng-hide\"/>\n    <ul>\n        <li ng-repeat=\"item in uploader.queue\" class=\"ui-file-container\">\n            <div ng-show=\"uploader.isHTML5\">\n                <div class=\"progress\">\n                    <div class=\"progress-bar\" role=\"progressbar\" ng-style=\"{ 'width': item.progress + '%' }\"></div>\n                </div>\n            </div>\n            <div class=\"row\">\n                <div class=\"col-md-4\" ng-if=\"$ctrl.isImage(item._file)\">\n                    <div class=\"ui-file-img\">\n                        <!-- Image preview -->\n                        <!--auto height-->\n                        <!--<div ng-thumb=\"{ file: item.file, width: 100 }\"></div>-->\n                        <!--auto width-->\n                        <div ng-thumb=\"{ file: item._file, height: 100 }\"></div>\n                        <!--fixed width and height -->\n                        <!--<div ng-thumb=\"{ file: item.file, width: 100, height: 100 }\"></div>-->\n                    </div>\n                </div>\n                <div class=\"col-md-{{ $ctrl.isImage(item._file) ? '8' : '12' }}\">\n                    <p><strong>Nombre del archivo:</strong> {{ item.file.name }}</p>\n                    <p><strong>Tamaño:</strong> {{ item.file.size/1024/1024|number:2 }} Mb</p>\n                    <div class=\"ui-file-buttons\">\n                        <button type=\"button\" class=\"btn btn-primary btn-sm\" md-effect ng-click=\"item.upload()\" ng-disabled=\"item.isReady || item.isUploading || item.isSuccess\" ng-hide=\"item.isUploading\">\n                            <i class=\"fa fa-upload\"></i>{{ $ctrl.label || 'Subir' }}\n                        </button>\n                        <button type=\"button\" class=\"btn btn-outline-default btn-sm\" md-effect ng-click=\"item.cancel()\" ng-disabled=\"!item.isUploading\" ng-hide=\"!item.isUploading\">\n                            <i class=\"fa fa-ban\"></i> Cancelar\n                        </button>\n                        <button type=\"button\" class=\"btn btn-danger btn-sm\" md-effect ng-click=\"item.remove()\" uib-tooltip=\"Eliminar archivo\">\n                            <i class=\"fa fa-trash\"></i>\n                        </button>\n                    </div>\n                </div>\n            </div>\n        </li>\n    </ul>\n    <div ng-if=\"$ctrl.multiple\">\n        <div>\n            <div class=\"progress\">\n                <div class=\"progress-bar\" role=\"progressbar\" ng-style=\"{ 'width': uploader.progress + '%' }\"></div>\n            </div>\n        </div>\n        <button type=\"button\" class=\"btn btn-primary btn-sm\" md-effect ng-click=\"uploader.uploadAll()\" ng-disabled=\"!uploader.getNotUploadedItems().length\">\n            <i class=\"fa fa-upload\"></i> Subir todo\n        </button>\n        <button type=\"button\" class=\"btn btn-outline-default btn-sm\" md-effect ng-click=\"uploader.cancelAll()\" ng-disabled=\"!uploader.isUploading\">\n            <i class=\"fa fa-ban\"></i> Cancelar todo\n        </button>\n        <button type=\"button\" class=\"btn btn-danger btn-sm\" md-effect ng-click=\"uploader.clearQueue()\" ng-disabled=\"!uploader.queue.length\">\n            <i class=\"fa fa-trash\"></i> Eliminar todo\n        </button>\n    </div>\n</div>"

/***/ }),
/* 585 */
/***/ (function(module, exports) {

	module.exports = "<label class=\"label-form\">{{$ctrl.label}}</label>\n\n<div class=\"ui-file-upload\">\n  <input type=\"file\" nv-file-select=\"\" ng-if=\"$ctrl.multiple === undefined\" uploader=\"uploader\" id=\"{{ $ctrl.idFile }}\" class=\"ng-hide\" accept=\"{{$ctrl.mimeTypes}}\" />\n  <input type=\"file\" nv-file-select=\"\" ng-if=\"$ctrl.multiple\" uploader=\"uploader\" id=\"{{ $ctrl.idFile }}\" multiple class=\"ng-hide\" accept=\"{{$ctrl.mimeTypes}}\" />\n\n  <div ng-show=\"uploader.isHTML5\">\n    <label for=\"{{ $ctrl.idFile }}\" nv-file-drop=\"\" nv-file-over=\"\" uploader=\"uploader\" over-class=\"other-over-zone\" class=\"other-drop-zone zone noselect\" uuib-tooltip=\"Seleccione archivo\">\n      <span ng-if=\"!$ctrl.textUpload\">Seleccione {{ $ctrl.multiple ? 'los' : 'un' }} archivo {{ $ctrl.multiple ? 's' : '' }}</span><span ng-if=\"!$ctrl.Util.isMobile()\">o arrástrelo {{ $ctrl.multiple ? 's' : ''}} aquí</span>\n      <br><span ng-if=\"$ctrl.$$maxsize\">Debe pesar hasta <strong>{{$ctrl.maxsize}}</strong></span>\n      <br><span ng-if=\"$ctrl.$$maxsize\" ng-bind-html=\"$ctrl.getTypes().message\"></span>\n      <span ng-if=\"$ctrl.textUpload\" ng-bind-html=\"$ctrl.textUpload\"></span>\n    </label>\n  </div>\n\n  <ul>\n    <li ng-repeat=\"item in uploader.queue\" class=\"ui-file-container\">\n      <div ng-show=\"uploader.isHTML5\">\n        <div class=\"progress\">\n          <div class=\"progress-bar\" role=\"progressbar\" ng-style=\"{ 'width': item.progress + '%' }\"></div>\n        </div>\n      </div>\n      <div class=\"row\">\n        <div class=\"col-md-12\">\n          <p><strong>Nombre del archivo:</strong> {{ item.file.name }}</p>\n          <p><strong>Tamaño:</strong> {{ item.file.size/1024/1024|number:2 }} Mb</p>\n          <div class=\"ui-file-buttons\">\n            <button type=\"button\" class=\"btn btn-primary btn-sm\" md-effect ng-click=\"$ctrl.upload()\" ng-disabled=\"item.isReady || item.isUploading || item.isSuccess\" ng-hide=\"item.isUploading\" ng-if=\"$ctrl.uploadCallback\">\n              <i class=\"fa fa-upload\"></i> {{ $ctrl.labelSubir || 'Subir' }}\n            </button>\n            <button type=\"button\" class=\"btn btn-outline-default btn-sm\" md-effect ng-click=\"item.cancel()\" ng-disabled=\"!item.isUploading\" ng-hide=\"!item.isUploading\">\n              <i class=\"fa fa-ban\"></i> Cancelar\n            </button>\n            <button type=\"button\" class=\"btn btn-danger btn-sm\" md-effect ng-click=\"$ctrl.remove(item)\" uib-tooltip=\"Eliminar archivo\">\n              <i class=\"fa fa-trash\"></i>\n            </button>\n          </div>\n        </div>\n      </div>\n    </li>\n  </ul>\n  <div ng-if=\"$ctrl.multiple\">\n    <div>\n      <div class=\"progress\">\n        <div class=\"progress-bar\" role=\"progressbar\" ng-style=\"{ 'width': uploader.progress + '%' }\"></div>\n      </div>\n    </div>\n    <div class=\"row\">\n      <div class=\"col-md-6 col-sm-12 text-center\">\n        <button type=\"button\" class=\"btn btn-primary btn-md btn-width\" md-effect ng-click=\"uploader.uploadAll()\" ng-disabled=\"!uploader.getNotUploadedItems().length\" ng-if=\"false\">\n          <i class=\"fa fa-upload\"></i> Subir todo\n        </button>\n      </div>\n      <div class=\"col-md-6 col-sm-12 text-center\">\n        <button type=\"button\" class=\"btn btn-outline-default btn-md btn-width\" md-effect ng-click=\"uploader.cancelAll()\" ng-disabled=\"!uploader.isUploading\" ng-if=\"false\">\n          <i class=\"fa fa-ban\"></i> Cancelar todo\n        </button>\n      </div>\n      <div class=\"col-md-6 col-sm-12 text-center\">\n        <button type=\"button\" class=\"btn btn-danger btn-md btn-width\" md-effect ng-click=\"$ctrl.clearQueue(uploader)\" ng-disabled=\"!uploader.queue.length\">\n          <i class=\"fa fa-trash\"></i> Eliminar todo\n        </button>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 586 */
/***/ (function(module, exports) {

	module.exports = "<ng-form name=\"select_date_form\">\r\n<div class=\"select-date form-group\">\r\n  <label ng-class=\"{'ap-req':$ctrl.ngRequired}\">{{$ctrl.label}}</label>\r\n  <div class=\"row mx-0\">\r\n    <input name=\"fecha\" numeric  maxlength=\"2\" minlength=\"1\" class=\"col-md-2 form-control day\" ng-model=\"$ctrl.day\" ng-change=\"$ctrl.changeDate('day')\" ng-required=\"$ctrl.ngRequired\" ng-disabled=\"$ctrl.ngDisabled\" placeholder=\"Día\">\r\n    <select name=\"fecha\" class=\"col-md-5 form-control month\" ng-model=\"$ctrl.month\" ng-change=\"$ctrl.changeDate('month')\" size ng-required=\"$ctrl.ngRequired\"  ng-disabled=\"$ctrl.ngDisabled\">\r\n      <option selected value=\"\" ng-if=\"!$ctrl.month\">Mes</option>\r\n      <option ng-repeat=\"item in $ctrl.months\" ng-value=\"{{item.val}}\">{{item.name}}</option>\r\n    </select>\r\n    <input name=\"fecha\" numeric maxlength=\"4\" minlength=\"4\" class=\"col-md-2 form-control year\" ng-model=\"$ctrl.year\" ng-change=\"$ctrl.changeDate('year')\" ng-required=\"$ctrl.ngRequired\" ng-disabled=\"$ctrl.ngDisabled\"  placeholder=\"Año\" >\r\n  </div>\r\n  <div ap-error ng-messages=\"select_date_form.fecha.$error\" role=\"alert\" ng-if=\"select_date_form.fecha.$touched\">\r\n    <div ng-message=\"required\">La fecha es requerida</div>\r\n    <div ng-message=\"minlength\">La fecha es requerida</div>\r\n    <div ng-message=\"maxlength\">La fecha es requerida</div>\r\n  </div>\r\n  <!-- <pre>{{select_date_form.fecha |json}}</pre> -->\r\n</div>\r\n</ng-form>\r\n"

/***/ }),
/* 587 */
/***/ (function(module, exports) {

	module.exports = "<ng-form name=\"dep_pro_mun_form\">\n  <div class=\"row\">\n    <div class=\"form-group col-md-4\">\n      <uib-select name=\"departamento\" label=\"Departamento:\" ng-model=\"$ctrl.departamento\" items=\"$ctrl.departamentos\" key-value=\"id\" key-text=\"descripcion\" placeholder=\"Seleccione...\" ng-required=\"$ctrl.conf.fid_departamento.requerido\" ng-disabled=\"$ctrl.conf.fid_departamento.disabled\"></uib-select>\n      <div ap-error ng-messages=\"dep_pro_mun_form.departamento.$error\" role=\"alert\" ng-if=\"dep_pro_mun_form.departamento.$touched\">\n        <div ng-message=\"required\">El campo es requerido</div>\n      </div>\n    </div>\n\n    <div class=\"form-group col-md-4\">\n      <uib-select name=\"provincia\" label=\"Provincia:\" ng-model=\"$ctrl.provincia\" items=\"$ctrl.provincias\" key-value=\"id\" key-text=\"nombre\" placeholder=\"Seleccione...\" ng-required=\"$ctrl.conf.fid_provincia.requerido\" ng-disabled=\"$ctrl.conf.fid_provincia.disabled\"></uib-select>\n      <div ap-error ng-messages=\"dep_pro_mun_form.provincia.$error\" role=\"alert\" ng-if=\"dep_pro_mun_form.provincia.$touched\">\n        <div ng-message=\"required\">El campo es requerido</div>\n      </div>\n    </div>\n\n    <div class=\"form-group col-md-4\">\n      <uib-select name=\"municipio\" label=\"Municipio:\" ng-model=\"$ctrl.municipio\" items=\"$ctrl.municipios\" key-value=\"id\" key-text=\"nombre\" placeholder=\"Seleccione...\" ng-required=\"$ctrl.conf.fid_municipio.requerido\" ng-disabled=\"$ctrl.conf.fid_municipio.disabled\"></uib-select>\n      <div ap-error ng-messages=\"dep_pro_mun_form.municipio.$error\" role=\"alert\" ng-if=\"dep_pro_mun_form.municipio.$touched\">\n        <div ng-message=\"required\">El campo es requerido</div>\n      </div>\n    </div>\n  </div>\n</ng-form>\n"

/***/ }),
/* 588 */
/***/ (function(module, exports) {

	module.exports = "<c-select name=\"{{$ctrl.name}}\"\n  label=\"{{$ctrl.label}}\"\n  ng-model=\"$ctrl.ngModel\"\n  options=\"$ctrl.items\"\n  key-value=\"{{ !$ctrl.selectModel? 'codigo' : '' }}\"\n  ng-disabled=\"$ctrl.ngDisabled\"\n  ng-required=\"$ctrl.ngRequired\">\n</c-select>\n"

/***/ }),
/* 589 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"image-viewer\" ng-attr-style=\"height:{{$ctrl.height?$ctrl.height+'px':'600px'}}\">\n  <div class=\"controls\">\n    <button type=\"button\" class=\"btn-flat\" ng-click=\"imageZoom(-20)\" title=\"Alejar\"><i class=\"fa fa-minus\"></i></button>\n    <button type=\"button\" class=\"btn-flat\" ng-click=\"imageZoom(20)\" title=\"Acercar\"><i class=\"fa fa-plus\"></i></button>\n    <button type=\"button\" class=\"btn-flat\" ng-click=\"imageRotate()\" title=\"Rotar\"><i class=\"fa fa-rotate-right\"></i></button>\n    <button type=\"button\" class=\"btn-flat\" ng-click=\"imageDownload()\" title=\"Descargar\"><i class=\"fa fa-download\"></i></button>\n    <button type=\"button\" class=\"btn-flat\" ng-click=\"imagePrint()\" title=\"Imprimir\"><i class=\"fa fa-print\"></i></button>\n    <button type=\"button\" class=\"btn-flat\" ng-click=\"imageInvert()\" title=\"Invertir color\"><i class=\"fa fa-exchange\"></i></button>\n    <!-- <button type=\"button\" class=\"btn-flat\" ng-click=\"imageSave()\" title=\"Guardar cambios\" ng-disabled=\"!modificado\"><i class=\"fa fa-save\"></i></button> -->\n    <span>{{imageDet.size}} {{imageDet.unit}}</span>\n    <span>{{imageWidth}}x{{imageHeight}}</span>\n  </div>\n  <div class=\"image-container\" ng-attr-style=\"height:{{$ctrl.height?($ctrl.height-550)+'px':'550px'}}\">\n    <canvas></canvas>\n    <img ng-attr-id=\"image-viewer{{$ctrl.id?('-'+$ctrl.id):''}}\" style=\"display:none;\"/>\n  </div>\n</div>\n"

/***/ }),
/* 590 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"document-area\" ng-if=\"!$ctrl.base64 && !$ctrl.pdfUrl\">\n  <div class=\"loading\">\n    <h3>Cargando documento, por favor espere ...</h3>\n  </div>\n</div>\n<div class=\"pdfviewer\" ng-if=\"$ctrl.base64 || $ctrl.pdfUrl\">\n  <ng-pdf class=\"ng-pdf\" data=\"$ctrl.pdfUrl\" data64=\"$ctrl.base64\" style=\"height:100%\"\n  name=\"{{$ctrl.name}}\" scale=\"{{$ctrl.scale}}\" page=\"{{$ctrl.page}}\"\n  download=\"{{$ctrl.download}}\" print=\"{{$ctrl.print}}\" open=\"{{$ctrl.open}}\"></ng-pdf>\n</div>\n"

/***/ }),
/* 591 */
/***/ (function(module, exports) {

	module.exports = "<nav ng-class=\"getNavStyle(scroll)\">\n  <div class=\"pdfviewer-control pageUp\" ng-if=\"pageLimit<pageCount\">\n    <button type=\"button\" ng-click=\"goPrevious()\"><span>&lt;</span></button>\n  </div>\n  <div class=\"pdfviewer-control pageDown\" ng-if=\"pageLimit<pageCount\">\n    <button type=\"button\" ng-click=\"goNext()\"><span>&gt;</span></button>\n  </div>\n  <div class=\"pdfviewer-control zoomOut\">\n    <button type=\"button\" ng-click=\"zoomOut()\"><span>-</span></button>\n  </div>\n  <div class=\"pdfviewer-button\">\n    <button type=\"button\" ng-click=\"fit()\"><span>100%</span></button>\n  </div>\n  <div class=\"pdfviewer-control zoomIn\">\n    <button type=\"button\" ng-click=\"zoomIn()\"><span>+</span></button>\n  </div>\n  <div class=\"pdfviewer-button\">\n    <!-- <button type=\"button\" ng-click=\"rotate()\"><span>Rotar</span></button> -->\n  </div>\n\n  <div class=\"pdfviewer-control page-num\" ng-hide=\"pageLimit>=pageCount\">\n    <span>Página:</span>\n    <input type=\"text\" min=1 ng-model=\"pageNum\" size=\"1\"> de\n    <span> {{pageCount}}</span>\n  </div>\n  <div class=\"pdfviewer-control page-num\" ng-hide=\"pageLimit<pageCount\">\n    <span>Páginas: </span>\n    <span> {{pageCount}}</span>\n  </div>\n\n  <!-- <div class=\"pdfviewer-control presentationMode\">\n    <button type=\"button\" ng-click=\"fullscreen()\"><span>-</span></button>\n  </div> -->\n  <div class=\"pdfviewer-control print\" ng-if=\"!detectIE() && getMobileOS()==false && print\">\n    <button type=\"button\" ng-click=\"printFile()\"><span>-</span></button>\n  </div>\n  <div class=\"pdfviewer-control download\" ng-if=\"download\">\n    <button type=\"button\" ng-click=\"downloadFile()\"><span>-</span></button>\n  </div>\n</nav>\n\n<hr class=\"separator\">\n\n{{loading}}"

/***/ }),
/* 592 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\"><i class=\"fa fa-user\"></i> Cambiar contrase&ntilde;a</h5>\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cancel()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<div class=\"modal-body\">\n    <form name=\"form\">\n      <div class=\"row\">\n        <div class=\"col-12 alert alert-info\">\n          <i class=\"fa fa-info-circle\"></i> <strong>IMPORTANTE:</strong>\n          <ul class=\"btm-0\">\n            <li>Debe escribir su contraseña actual (se distingue entre mayúsculas y minúsculas).</li>\n            <!-- <li>Su contraseña nueva debe tener hasta 16 caracteres.</li> -->\n            <li>Luego de modificar su contraseña, se cerrará su sesión y se le redirigirá a la página de inicio automáticamente.</li>\n          </ul>\n        </div>\n        <div class=\"col-sm-12\">\n          <c-input type=\"password\" name=\"actual\" label=\"Contraseña actual\" ng-model=\"$ctrl.datos.actual\" ng-minlength=\"3\" ng-maxlength=\"16\" maxlength=\"16\" ng-required=\"true\" uib-tooltip=\"Escriba la contraseña actual.\" ng-validation=\"alfa-numerico\"></c-input>\n        </div>\n        <!-- div class=\"col-sm-6\">\n          <c-input type=\"text\" name=\"nombre\" label=\"Usuario\" ng-model=\"$ctrl.datos.usuario\" ng-minlength=\"3\" ng-maxlength=\"32\" maxlength=\"32\" ng-required=\"true\" uib-tooltip=\"Escriba su nombre de usuario.\" ng-validation=\"alfa-numerico\"></c-input>\n        </div -->\n        <div class=\"col-sm-12\">\n          <c-input type=\"password\" name=\"nueva\" label=\"Nueva contraseña\" ng-model=\"$ctrl.datos.nueva\" ng-minlength=\"3\" ng-maxlength=\"16\" maxlength=\"16\" ng-required=\"true\" uib-tooltip=\"Escriba la nueva contraseña.\" ng-validation=\"alfa-numerico\" ></c-input>\n        </div>\n        <div class=\"col-sm-12\">\n          <c-input type=\"password\" name=\"confirmado\" label=\"Repita la nueva contraseña\" ng-model=\"$ctrl.datos.confirmado\" ng-minlength=\"3\" ng-maxlength=\"16\" maxlength=\"16\" ng-required=\"true\" uib-tooltip=\"Vuelva a escribir la nueva contraseña.\" c-ui-validate=\"{contrasena:'$ctrl.form.confirmado.$viewValue==$ctrl.form.nueva.$modelValue'}\" c-ui-validate-watch=\"'$ctrl.form.nueva.$modelValue'\" message-error-password=\"Las nuevas contraseñas no son iguales. Revise por favor.\"></c-input>\n        </div>\n      </div>\n    </form>\n</div>\n<div class=\"modal-footer\">\n  <button md-effect type=\"button\" class=\"btn btn-secondary\" ng-click=\"$ctrl.cancel()\">\n    <i class=\"fa fa-close\"></i> Cerrar\n  </button>\n  <button md-effect type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.ok()\" ng-disabled=\"$ctrl.enviando || form.$invalid\">\n    <i class=\"fa fa-check\"></i> Modificar\n  </button>\n</div>\n"

/***/ }),
/* 593 */
/***/ (function(module, exports) {

	module.exports = "<nav class=\"navbar navbar-expand\">\n    <div class=\"collapse navbar-collapse\" id=\"navbarSupportedContent\">\n        <ul class=\"navbar-nav mr-auto\">\n            <li class=\"nav-item\">\n                <button type=\"button\" class=\"btn btn-link\" ng-click=\"$ctrl.toggleSidenav()\">\n                    <i class=\"fa fa-bars\"></i>\n                </button>\n            </li>\n            <li class=\"nav-item\">\n                <button type=\"button\" class=\"btn btn-link\" ng-click=\"$ctrl.refresh()\">\n                    <i class=\"fa fa-refresh\"></i>\n                </button>\n            </li>\n            <li class=\"nav-item\">\n                <button type=\"button\" class=\"btn btn-link\" ng-click=\"$ctrl.fullscreen()\">\n                    <i class=\"fa fa-arrows-alt\"></i>\n                </button>\n            </li>\n            <!-- <li class=\"nav-item\">\n                <button type=\"button\" class=\"btn btn-link\">\n                    <i class=\"fa fa-bell-o\"></i>\n                </button>\n            </li> -->\n        </ul>\n        <div class=\"navbar-nav navbar-buttons my-2 my-lg-0\">\n            <div class=\"nav-item dropdown\" uib-dropdown is-open=\"status.isopen1\">\n                <a id=\"single-button\" href=\"\" class=\"nav-link\" uib-dropdown-toggle>\n                    {{$ctrl.user.rol.descripcion}}\n                </a>\n                <div class=\"dropdown-menu dropdown-menu-right\" aria-labelledby=\"navbarDropdownMenuLink\" style=\"margin-top: -40px;\" ng-if=\"$ctrl.user.roles.length>1\">\n                    <a class=\"dropdown-item\" href=\"\" ng-repeat=\"rol in $ctrl.user.roles\" ng-click=\"$ctrl.changeRol(rol)\"><i class=\"fa fa-user-circle-o\"></i> {{rol.nombre}}</a>\n                </div>\n            </div>\n        </div>\n        <div class=\"navbar-nav navbar-buttons my-2 my-lg-0\">\n            <div class=\"nav-item dropdown\" uib-dropdown is-open=\"status.isopen\">\n                <a id=\"single-button\" href=\"\" class=\"nav-link\" uib-dropdown-toggle>\n                    <i class=\"fa fa-ellipsis-v\"></i>\n                </a>\n                <div class=\"dropdown-menu dropdown-menu-right\" aria-labelledby=\"navbarDropdownMenuLink\" style=\"margin-top: -40px;\">\n                    <a class=\"dropdown-item\" href=\"\" ng-if=\"$ctrl.user.rol.nombre!='EMPRESA'\" ng-click=\"$ctrl.account()\"><i class=\"fa fa-user\"></i> Cambiar contraseña</a>\n                    <!-- <a class=\"dropdown-item\" href=\"\"><i class=\"fa fa-cog\"></i> Configuraciones</a> -->\n                    <hr>\n                    <a class=\"dropdown-item\" href=\"\" ng-click=\"$ctrl.logout()\"><i class=\"fa fa-sign-out\"></i> Cerrar sesión</a>\n                </div>\n            </div>\n        </div>\n    </div>\n</nav>\n"

/***/ }),
/* 594 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"sidenav\">\n    <div class=\"sidenav-app\">\n        <div class=\"sidenav-logo text-primary\">\n            <span class=\"sidenav-logo-sistema\"></span>\n        </div>\n        <h1 class=\"sidenav-title\">{{ $ctrl.systemName }}</h1>\n    </div>\n    <div class=\"sidenav-user\" ng-if=\"$ctrl.getSidenav()\">\n        <figure class=\"sidenav-user-photo rounded-circle bg-{{ $ctrl.getColor() }}\">{{ $ctrl.getInitial() }}</figure>\n        <div class=\"sidenav-user-info\">\n            <label class=\"sidenav-user-name\" uib-tooltip=\"{{ $ctrl.getName() }}\" tooltip-placement=\"right\" tooltip-append-to-body=\"true\">{{ $ctrl.getName() }}</label>\n            <label class=\"sidenav-user-mail\" uib-tooltip=\"{{ $ctrl.getEmail() }}\" tooltip-placement=\"right\" tooltip-append-to-body=\"true\"><i class=\"fa fa-envelope-o\"></i> {{ $ctrl.getEmail() }}</label>\n        </div>\n    </div>\n    <div class=\"sidenav-container\" id=\"sidenav-menu\" ng-if=\"$ctrl.getVisible()\">\n        <ul class=\"sidenav-menu\">\n            <li ng-repeat=\"option in $ctrl.getMenu()\">\n                <a md-effect class=\"sidenav-item\" href=\"\" ng-click=\"$ctrl.send(option.url, option.submenu.length)\" toggle-menu data-url=\"{{option.url || option.label }}\">\n                    <span class=\"sidenav-icon rounded-circle bg-{{option.color}}\"><i class=\"fa fa-{{option.icon}}\"></i></span>\n                    <label class=\"sidenav-item-text\">{{ option.label }}</label>\n                    <span class=\"sidenav-item-arrow\" ng-if=\"option.submenu.length\"><i class=\"fa fa-angle-right\"></i></span>\n                </a>\n                <ul class=\"sidenav-submenu\" ng-if=\"option.submenu.length\">\n                    <li ng-repeat=\"sub in option.submenu\">\n                        <a md-effect class=\"sidenav-submenu-item btn-default\" href=\"\" data-url=\"{{sub.url}}\" ng-class=\"{ 'active' : $ctrl.url == sub.url }\" ng-click=\"$ctrl.send(sub.url)\">\n                          <span class=\"sidenav-icon bg-{{option.color}}\"><i class=\"fa fa-{{sub.icon}}\"></i></span>\n                          {{ sub.label }}\n                        </a>\n                    </li>\n                    <li >\n                        <a md-effect class=\"sidenav-submenu-item btn-default\"  ng-if=\"$ctrl.dtsRol['nombre']=='EMPRESA'\" href=\"\" data-url=\"matriculas\"  ng-click=\"$ctrl.send('matriculas')\">\n                          <span class=\"sidenav-icon bg-{{option.color}}\"><i class=\"fa fa-list-alt\"></i></span>\n                          MATRICULA(s)\n                        </a>\n                    </li>\n                </ul>\n            </li>\n        </ul>\n    </div>\n</div>"

/***/ }),
/* 595 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <h2 class=\"page-title\"><i class=\"fa fa-cogs\"></i> Ejemplos de <strong>Componentes</strong></h2>\n  <div class=\"card\">\n    <div class=\"card-body\">\n      <h3>Botones</h3>\n      <div>\n        <button uib-tooltip=\"Botón default tooltip\" md-effect class=\"btn btn-default\">\n          <i class=\"fa fa-home\"></i> Botón default\n        </button>\n        <button uib-tooltip=\"Botón primary tooltip\" tooltip-placement=\"top\" md-effect class=\"btn btn-primary\">\n          <i class=\"fa fa-check\"></i> Botón primary\n        </button>\n        <button uib-tooltip=\"Botón success tooltip\" tooltip-placement=\"right\" md-effect class=\"btn btn-success\">\n          <i class=\"fa fa-book\"></i> Botón success\n        </button>\n        <button uib-tooltip=\"Botón info tooltip\" tooltip-placement=\"bottom\" md-effect class=\"btn btn-info\">\n          <i class=\"fa fa-cog\"></i> Botón info\n        </button>\n        <button uib-tooltip=\"Botón warning tooltip\" tooltip-placement=\"left\" md-effect class=\"btn btn-warning\">\n          <i class=\"fa fa-user-o\"></i> Botón warning\n        </button>\n        <button uib-tooltip=\"Botón danger tooltip\" md-effect class=\"btn btn-danger\">\n          <i class=\"fa fa-automobile\"></i> Botón danger\n        </button>\n      </div>\n      <hr>\n\n      <h3>Botones outline</h3>\n      <div>\n        <button md-effect class=\"btn btn-outline-default\"><i class=\"fa fa-home\"></i> Botón default</button>\n        <button md-effect class=\"btn btn-outline-primary\"><i class=\"fa fa-check\"></i> Botón primary</button>\n        <button md-effect class=\"btn btn-outline-success\"><i class=\"fa fa-book\"></i> Botón success</button>\n        <button md-effect class=\"btn btn-outline-info\"><i class=\"fa fa-cog\"></i> Botón info</button>\n        <button md-effect class=\"btn btn-outline-warning\"><i class=\"fa fa-user-o\"></i> Botón warning</button>\n        <button md-effect class=\"btn btn-outline-danger\"><i class=\"fa fa-automobile\"></i> Botón danger</button>\n      </div>\n      <hr>\n\n      <h3>Dropdown</h3>\n      <div class=\"btn-group\" uib-dropdown is-open=\"status.isopen\">\n        <button type=\"button\" class=\"btn btn-primary\" uib-dropdown-toggle>\n          Button dropdown <span class=\"caret\"></span>\n        </button>\n        <div class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"single-button\">\n          <h6 class=\"dropdown-header\">Dropdown header</h6>\n          <a class=\"dropdown-item\" href=\"\">Action</a>\n          <a class=\"dropdown-item\" href=\"\">Another action</a>\n          <a class=\"dropdown-item\" href=\"\">Something else here</a>\n          <div class=\"dropdown-divider\"></div>\n          <a class=\"dropdown-item\" href=\"\">Separated link</a>\n        </div>\n      </div>\n      <div class=\"btn-group\" uib-dropdown is-open=\"status.isopen2\">\n        <button type=\"button\" class=\"btn btn-outline-success\" uib-dropdown-toggle>\n          Button dropdown <span class=\"caret\"></span>\n        </button>\n        <div class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"single-button\">\n          <h6 class=\"dropdown-header\">Dropdown header</h6>\n          <a class=\"dropdown-item\" href=\"\">Action</a>\n          <a class=\"dropdown-item\" href=\"\">Another action</a>\n          <a class=\"dropdown-item\" href=\"\">Something else here</a>\n          <div class=\"dropdown-divider\"></div>\n          <a class=\"dropdown-item\" href=\"\">Separated link</a>\n        </div>\n      </div>\n      <div class=\"btn-group\" uib-dropdown is-open=\"status.isopen3\">\n        <button type=\"button\" class=\"btn btn-secondary\">Action</button>\n        <button type=\"button\" class=\"btn btn-secondary dropdown-toggle dropdown-toggle-split\" data-toggle=\"dropdown\" aria-haspopup=\"true\"\n          aria-expanded=\"false\" uib-dropdown-toggle>\n          <span class=\"sr-only\">Toggle Dropdown</span>\n        </button>\n        <div class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"single-button\">\n          <h6 class=\"dropdown-header\">Dropdown header</h6>\n          <a class=\"dropdown-item\" href=\"\">Action</a>\n          <a class=\"dropdown-item\" href=\"\">Another action</a>\n          <a class=\"dropdown-item\" href=\"\">Something else here</a>\n          <div class=\"dropdown-divider\"></div>\n          <a class=\"dropdown-item\" href=\"\">Separated link</a>\n        </div>\n      </div>\n      <hr>\n\n      <h3>Popup</h3>\n      <button uib-popover=\"Contenido del popover\" popover-title=\"Título del popover\" type=\"button\" class=\"btn btn-default\">Popover default</button>\n      <button uib-popover=\"Contenido del popover\" popover-title=\"Título del popover\" popover-placement=\"top\" type=\"button\" class=\"btn btn-primary\">Popover top</button>\n      <button uib-popover=\"Contenido del popover\" popover-title=\"Título del popover\" popover-placement=\"right\" type=\"button\" class=\"btn btn-success\">Popover right</button>\n      <button uib-popover=\"Contenido del popover\" popover-title=\"Título del popover\" popover-placement=\"bottom\" type=\"button\" class=\"btn btn-danger\">Popover bottom</button>\n      <button uib-popover=\"Contenido del popover\" popover-title=\"Título del popover\" popover-placement=\"left\" type=\"button\" class=\"btn btn-info\">Popover left</button>\n      <hr>\n\n      <h3>Tabs</h3>\n      <uib-tabset active=\"active\">\n        <uib-tab index=\"0\" heading=\"Static title\">Static content</uib-tab>\n        <uib-tab index=\"$index + 1\" ng-repeat=\"tab in $ctrl.tabs\" heading=\"{{tab.title}}\" disable=\"tab.disabled\">\n          {{tab.content}}\n        </uib-tab>\n        <uib-tab index=\"3\">\n          <uib-tab-heading>\n            <i class=\"fa fa-bell\"></i> Alert!\n          </uib-tab-heading>\n          I've got an HTML heading, and a select callback. Pretty cool!\n        </uib-tab>\n      </uib-tabset>\n      <hr>\n\n      <h3>Modal</h3>\n      <!-- Button trigger modal -->\n      <button md-effect type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.openModal()\">\n        <i class=\"fa fa-plus\"></i> Abrir modal\n      </button>\n      <button md-effect type=\"button\" class=\"btn btn-success\" ng-click=\"$ctrl.openModal('lg')\">\n        <i class=\"fa fa-plus\"></i> Abrir modal <strong>lg</strong>\n      </button>\n      <button md-effect type=\"button\" class=\"btn btn-secondary\" ng-click=\"$ctrl.openModal('sm')\">\n        <i class=\"fa fa-plus\"></i> Abrir modal <strong>sm</strong>\n      </button>\n      <hr>\n      <button md-effect type=\"button\" class=\"btn btn-secondary\" ng-click=\"$ctrl.openAlert()\">\n        <i class=\"fa fa-bell\"></i> Abrir Alert\n      </button>\n      <button md-effect type=\"button\" class=\"btn btn-secondary\" ng-click=\"$ctrl.openConfirm()\">\n        <i class=\"fa fa-warning\"></i> Abrir Confirm\n      </button>\n      <hr>\n\n      <h3>Mensajes</h3>\n      <button md-effect type=\"button\" ng-click=\"$ctrl.openMessage('success')\" class=\"btn btn-secondary\">Abrir Success</button>\n      <button md-effect type=\"button\" ng-click=\"$ctrl.openMessage('info')\" class=\"btn btn-secondary\">Abrir Info</button>\n      <button md-effect type=\"button\" ng-click=\"$ctrl.openMessage('error')\" class=\"btn btn-secondary\">Abrir Error</button>\n      <button md-effect type=\"button\" ng-click=\"$ctrl.openMessage('warning')\" class=\"btn btn-secondary\">Abrir Warning</button>\n      <hr>\n\n      <h3>Alertas</h3>\n      <div class=\"alert alert-primary\" role=\"alert\">\n        <strong>Well done!</strong> You successfully read this important alert message.\n      </div>\n      <div class=\"alert alert-success\" role=\"alert\">\n        <strong>Well done!</strong> You successfully read this important alert message.\n      </div>\n      <div class=\"alert alert-info\" role=\"alert\">\n        <strong>Heads up!</strong> This alert needs your attention, but it's not super important.\n      </div>\n      <div class=\"alert alert-warning\" role=\"alert\">\n        <strong>Warning!</strong> Better check yourself, you're not looking too good.\n      </div>\n      <div class=\"alert alert-danger\" role=\"alert\">\n        <strong>Oh snap!</strong> Change a few things up and try submitting again.\n      </div>\n\n      <hr>\n      <h3>Badge</h3>\n      <span class=\"badge badge-default\">Default</span>\n      <span class=\"badge badge-primary\">Primary</span>\n      <span class=\"badge badge-success\">Success</span>\n      <span class=\"badge badge-info\">Info</span>\n      <span class=\"badge badge-warning\">Warning</span>\n      <span class=\"badge badge-danger\">Danger</span>\n      <hr>\n\n      <h3>Texto</h3>\n      <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sapiente, modi, eaque adipisci quia quas accusantium beatae\n        quisquam laudantium ullam laboriosam fuga omnis nesciunt illum quasi maiores? Assumenda consectetur veritatis quod\n        veniam iure aliquid dolorem vitae dolores sit pariatur explicabo ut cumque a eveniet voluptatum reiciendis, fugit\n        ad neque, perspiciatis tempora.</p>\n      <p>Recusandae, est. Vitae asperiores labore ratione aut voluptatum! Recusandae quisquam velit dolorum itaque asperiores\n        eius amet possimus mollitia quos eum ipsum doloremque id explicabo temporibus nihil, commodi soluta sit aut fugit\n        labore voluptatum excepturi iure. Perspiciatis obcaecati minus dicta quod, fugiat illo eligendi sequi, nesciunt ullam,\n        accusantium veritatis praesentium fuga!</p>\n\n      <h3 class=\"card-title\">Formulario</h3>\n      <form>\n        <div class=\"form-group\">\n          <label for=\"exampleInputEmail1\">Email address</label>\n          <input type=\"email\" class=\"form-control\" id=\"exampleInputEmail1\" aria-describedby=\"emailHelp\" placeholder=\"Enter email\">\n          <small id=\"emailHelp\" class=\"form-text text-muted\">We'll never share your email with anyone else.</small>\n        </div>\n        <div class=\"form-group\">\n          <label for=\"exampleInputPassword1\">Password</label>\n          <input type=\"password\" class=\"form-control\" id=\"exampleInputPassword1\" placeholder=\"Password\">\n        </div>\n        <div class=\"form-group\">\n          <label for=\"exampleSelect1\">Example select</label>\n          <select class=\"form-control\" id=\"exampleSelect1\">\n            <option ng-repeat=\"item in $ctrl.items\">{{ item.text }}</option>\n          </select>\n        </div>\n        <div class=\"form-group\">\n          <label for=\"input\">Example ui-select</label>\n          <ui-select ng-model=\"$ctrl.item.selected\" theme=\"bootstrap\" ng-disabled=\"$ctrl.disabled\" title=\"Seleccione un item\">\n            <ui-select-match placeholder=\"Seleccione o busque un item de la lista...\">{{$select.selected.text}}</ui-select-match>\n            <ui-select-choices repeat=\"item in $ctrl.items | filter: $select.search\">\n              <span ng-bind-html=\"item.text | highlight: $select.search\"></span>\n              <small ng-bind-html=\"item.code | highlight: $select.search\"></small>\n            </ui-select-choices>\n          </ui-select>\n        </div>\n        <div class=\"form-group\">\n          <label for=\"exampleSelect2\">Example multiple select</label>\n          <select multiple class=\"form-control\" id=\"exampleSelect2\">\n            <option ng-repeat=\"item in $ctrl.items\">{{ item.text }}</option>\n          </select>\n        </div>\n        <div class=\"form-group\">\n          <label for=\"exampleTextarea\">Example textarea</label>\n          <textarea class=\"form-control\" id=\"exampleTextarea\" rows=\"3\"></textarea>\n        </div>\n        <div class=\"form-group\">\n          <label for=\"exampleInputFile\">File input</label>\n          <input type=\"file\" class=\"form-control-file\" id=\"exampleInputFile\" aria-describedby=\"fileHelp\">\n          <small id=\"fileHelp\" class=\"form-text text-muted\">This is some placeholder block-level help text for the above input. It's a bit lighter and easily wraps to a new line.</small>\n        </div>\n        <fieldset class=\"form-group\">\n          <legend>Radio buttons</legend>\n          <div class=\"form-check\">\n            <label class=\"form-check-label\">\n              <input type=\"radio\" class=\"form-check-input\" name=\"optionsRadios\" id=\"optionsRadios1\" value=\"option1\" checked>\n              Option one is this and that&mdash;be sure to include why it's great\n            </label>\n          </div>\n          <div class=\"form-check\">\n            <label class=\"form-check-label\">\n              <input type=\"radio\" class=\"form-check-input\" name=\"optionsRadios\" id=\"optionsRadios2\" value=\"option2\">\n              Option two can be something else and selecting it will deselect option one\n            </label>\n          </div>\n          <div class=\"form-check disabled\">\n            <label class=\"form-check-label\">\n              <input type=\"radio\" class=\"form-check-input\" name=\"optionsRadios\" id=\"optionsRadios3\" value=\"option3\" disabled>\n              Option three is disabled\n            </label>\n          </div>\n        </fieldset>\n        <div class=\"form-check\">\n          <label class=\"form-check-label\">\n            <input type=\"checkbox\" class=\"form-check-input\">\n            Check me out\n          </label>\n        </div>\n        <button type=\"submit\" class=\"btn btn-primary\">Submit</button>\n      </form>\n      <hr>\n\n      <h3>Material Design Form</h3>\n      <form>\n        <md-input label=\"Nombre\" ng-model=\"$ctrl.field1\"></md-input>\n        <md-input label=\"Apellido\" ng-model=\"$ctrl.field2\" required></md-input>\n        <md-textarea label=\"Descripción\" ng-model=\"$ctrl.field3\"></md-textarea>\n\n        <div class=\"md-form-group md-select-group\" md-event-label>\n          <ui-select ng-model=\"$ctrl.item2.selected\" class=\"md-select\" theme=\"bootstrap\" ng-disabled=\"$ctrl.disabled\" title=\"Seleccione un item\">\n            <ui-select-match placeholder=\"Seleccione o busque un item de la lista...\">{{$select.selected.text}}</ui-select-match>\n            <ui-select-choices repeat=\"item in $ctrl.items | filter: $select.search\">\n              <span ng-bind-html=\"item.text | highlight: $select.search\"></span>\n              <small ng-bind-html=\"item.code | highlight: $select.search\"></small>\n            </ui-select-choices>\n          </ui-select>\n          <label class=\"md-control-label\" for=\"input\">Select material</label>\n          <i class=\"md-bar\"></i>\n        </div>\n        <!-- <md-select items=\"$ctrl.items\" ng-model=\"$ctrl.field4\" label=\"Lista\"></md-select> -->\n        <label class=\"custom-control custom-checkbox\">\n          <input type=\"checkbox\" class=\"custom-control-input\">\n          <span class=\"custom-control-indicator\"></span>\n          <span class=\"custom-control-description\">Check this custom checkbox</span>\n        </label>\n        <br>\n        <label class=\"custom-control custom-radio\">\n          <input id=\"radio1\" name=\"radio\" type=\"radio\" class=\"custom-control-input\">\n          <span class=\"custom-control-indicator\"></span>\n          <span class=\"custom-control-description\">Toggle this custom radio</span>\n        </label>\n        <label class=\"custom-control custom-radio\">\n          <input id=\"radio2\" name=\"radio\" type=\"radio\" class=\"custom-control-input\">\n          <span class=\"custom-control-indicator\"></span>\n          <span class=\"custom-control-description\">Or toggle this other custom radio</span>\n        </label>\n      </form>\n      <hr>\n\n      <h3>Datepicker</h3>\n      <div uib-datepicker ng-model=\"$ctrl.fecha\" datepicker-options=\"$ctrl.dateOptions\" class=\"well well-sm\"></div>\n      <hr>\n\n      <h3>Datepicker Popup</h3>\n      <div class=\"form-group\">\n        <label>Fecha</label>\n        <div class=\"input-group\">\n          <input type=\"text\" class=\"form-control\" uib-datepicker-popup ng-model=\"$ctrl.dt\" is-open=\"$ctrl.opened\" datepicker-options=\"$ctrl.dateOptions\"\n            ng-required=\"true\" />\n          <span class=\"input-group-btn\">\n            <button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.opened = true\"><i class=\"fa fa-calendar\"></i></button>\n          </span>\n        </div>\n      </div>\n      <hr>\n\n      <h3>Timepicker</h3>\n      <div uib-timepicker ng-model=\"$ctrl.mytime\"></div>\n      <hr>\n\n      <h3>Loading bar</h3>\n      <div>\n        <p><strong class=\"text-danger\">Nota.-</strong> Por defecto para cada petición se muestra el loading bar automáticamente, pero si se quiere un control manual usar estas opciones:</p>\n        <button class=\"btn btn-primary\" type=\"button\" ng-click=\"$ctrl.loadingInit()\">Iniciar loading</button>\n        <button class=\"btn btn-primary\" type=\"button\" ng-click=\"$ctrl.loadingInitText()\">Iniciar loading con texto</button>\n        <button class=\"btn btn-primary\" type=\"button\" ng-click=\"$ctrl.loadingInitLocked()\">Iniciar loading con texto en pantalla completa</button>\n        <button class=\"btn btn-danger\" type=\"button\" ng-click=\"$ctrl.loadingEnd()\">Terminar loading</button>\n      </div>\n      <hr>\n\n      <h3>Ayudas</h3>\n      <div>\n        <p>Debe pasar el puntero del mouse sobre el ícono <ui-help message=\"$ctrl.helpLang.ejemplo\"></ui-help></p>\n        <p>Texto de ayuda (top) <ui-help message=\"$ctrl.helpLang.ejemplo\" direction=\"top\"></ui-help></p>\n        <p>Texto de ayuda (right) <ui-help message=\"$ctrl.helpLang.ejemplo\" direction=\"right\"></ui-help></p>\n        <p>Texto de ayuda (bottom) <ui-help message=\"$ctrl.helpLang.ejemplo\" direction=\"bottom\"></ui-help></p>\n        <p>Texto de ayuda (left) <ui-help message=\"$ctrl.helpLang.ejemplo\" direction=\"left\"></ui-help></p>\n      </div>\n      <hr>\n\n      <h3>File upload</h3>\n      <div class=\"row\">\n        <div class=\"col\">\n          <label> File upload</label>\n          <ui-file-upload url=\"$ctrl.upload.url\"\n                          name=\"file\"></ui-file-upload>\n        </div>\n        <div class=\"col\">\n          <label> File upload (multiple)</label>\n          <ui-file-upload url=\"$ctrl.upload.url\"\n                          label=\"Subir al servidor\"\n                          textUpload=\"Subir archivos, arrastre acá\"\n                          multiple=\"true\"\n                          types=\"|png|jpg|pdf|xls|csv|\"\n                          name=\"file\"></ui-file-upload>\n        </div>\n      </div>\n      <hr>\n\n      <h3>Componentes Material</h3>\n      <form name=\"FormEjemplo\" novalidate>\n        <c-input name=\"input_nombre\" label=\"Input\" ng-model=\"$ctrl.inputNombre\" ng-required=\"true\"></c-input>\n        <c-input name=\"input_correo\" label=\"Input Correo\" ng-model=\"$ctrl.inputCorreo\" ng-required=\"true\" ng-disabled=\"false\" ng-validation=\"correo\"></c-input>\n        <c-input-money name=\"input_money\" label=\"Input Money\" ng-model=\"$ctrl.inputMoney\" ng-required=\"true\" ng-disabled=\"false\"></c-input-money>\n        <c-textarea name=\"textarea\" label=\"Textarea\" ng-model=\"$ctrl.textarea\" ng-required=\"true\" ng-disabled=\"false\"></c-textarea>\n        <c-select name=\"select\" label=\"Select\" placeholder=\"Seleccione Item\" ng-model=\"$ctrl.select\" ng-required=\"true\" ng-disabled=\"false\" options=\"$ctrl.items\" field=\"text\"></c-select>\n        <c-date name=\"date\" label=\"Date\" ng-model=\"$ctrl.date\" ng-required=\"true\" ng-disabled=\"false\"></c-date>\n        <c-checkbox name=\"checkbox\" label=\"Checkbox\" ng-model=\"$ctrl.checkbox\"></c-checkbox>\n        <c-radiobutton name=\"radiobutton\" label=\"RadioButton\" ng-model=\"$ctrl.radiobutton\" options=\"$ctrl.items\" field=\"text\"></c-radiobutton>\n        <c-input-chips name=\"inpuchips\" label=\"Input Chips\" placeholder=\"Adicionar Items\" ng-model=\"$ctrl.inputchips\" ng-required=\"true\" max-tags=\"3\"></c-input-chips>\n      </form>\n    </div>\n  </div>\n</div>"

/***/ }),
/* 596 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n    <h5 class=\"modal-title\"><i class=\"fa fa-user\"></i> Modal title</h5>\n    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cancel()\">\n        <span aria-hidden=\"true\">&times;</span>\n    </button>\n</div>\n<div class=\"modal-body\">\n    <ul>\n        <li ng-repeat=\"item in $ctrl.items\">\n            <a href=\"#\" ng-click=\"$event.preventDefault(); $ctrl.selected.item = item\">{{ item.text }}</a>\n        </li>\n    </ul>\n    Selected: <strong>{{ $ctrl.selected.item.text }}</strong>\n</div>\n<div class=\"modal-footer\">\n    <button md-effect type=\"button\" class=\"btn btn-secondary\" ng-click=\"$ctrl.cancel()\">\n        <i class=\"fa fa-close\"></i> Cerrar\n    </button>\n    <button md-effect type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.ok()\">\n        <i class=\"fa fa-check\"></i> Guardar\n    </button>\n</div>"

/***/ }),
/* 597 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"login-container\">\n  <div class=\"login-logo\">PROYECTOS</div>\n  <div class=\"login-header\">\n    {{ $ctrl.flip ? 'Recuperar contraseña' : 'Ingresar al sistema' }}\n  </div>\n  <div class=\"card-container\">\n    <div\n      class=\"card-flip-container\"\n      ng-class=\"{ 'recovery' : $ctrl.flip, 'empresa' : $ctrl.empresa }\"\n    >\n      <div class=\"card-flip\">\n        <div\n          class=\"side front login-block\"\n          ng-class=\"{'side':$ctrl.flip}\"\n          ng-if=\"!$ctrl.flip\"\n        >\n          <form name=\"form\" ng-submit=\"$ctrl.iniciarSesion()\">\n            <div class=\"md-input-group\">\n              <br />\n              <label class=\"custom-control custom-checkbox checkbox-condition\">\n                <input\n                  type=\"checkbox\"\n                  class=\"custom-control-input\"\n                  ng-model=\"$ctrl.empresa\"\n                />\n                <span class=\"custom-control-indicator\"></span>\n                <span class=\"custom-control-description\">Soy empresa</span>\n              </label>\n              <label class=\"custom-control custom-checkbox checkbox-condition\">\n                <input\n                  type=\"checkbox\"\n                  class=\"custom-control-input\"\n                  ng-model=\"$ctrl.conciliacion\"\n                />\n                <span class=\"custom-control-indicator\"></span>\n                <span class=\"custom-control-description\">Conciliacion</span>\n              </label>\n            </div>\n            <!-- CAMPO DE NIT PARA EMPRESA -->\n            <div class=\"md-input-group icon\" ng-if=\"$ctrl.empresa\">\n              <span class=\"md-input-group-addon\">\n                <span\n                  class=\"icon-nit\"\n                  uib-tooltip=\"Su NIT en Impuestos Nacionales\"\n                  tooltip-placement=\"left\"\n                ></span>\n              </span>\n              <div class=\"md-form-group\" md-event-label>\n                <input\n                  name=\"nit\"\n                  ng-model=\"$ctrl.nit\"\n                  nit\n                  required\n                  type=\"text\"\n                  focus-if=\"true\"\n                  autocapitalize=\"off\"\n                />\n                <label class=\"md-control-label\" for=\"input\">NIT</label>\n                <i class=\"md-bar\"></i>\n                <div\n                  ng-messages=\"form.nit.$error\"\n                  class=\"form-error\"\n                  ng-if=\"form.nit.$touched\"\n                >\n                  <div ng-message=\"required\">El nit es obligatorio</div>\n                </div>\n              </div>\n            </div>\n            <!-- FIN CAMPO DE NIT PARA EMPRESA -->\n            <!-- CAMPO DE NIT PARA SUPERVISOR -->\n            <div class=\"md-input-group icon\" ng-if=\"$ctrl.conciliacion\">\n              <span class=\"md-input-group-addon\">\n                <span\n                  uib-tooltip=\"Su USUARIO de conciliación\"\n                  tooltip-placement=\"left\"\n                  ><i class=\"fa fa-user\"></i>\n                </span>\n              </span>\n              <div class=\"md-form-group\" md-event-label>\n                <input\n                  name=\"nit\"\n                  ng-model=\"$ctrl.nit\"\n                  required\n                  type=\"text\"\n                  focus-if=\"true\"\n                  autocapitalize=\"off\"\n                />\n                <label class=\"md-control-label\" for=\"input\">USUARIO</label>\n                <!-- <i class=\"md-bar\"></i> -->\n                <div\n                  ng-messages=\"form.nit.$error\"\n                  class=\"form-error\"\n                  ng-if=\"form.nit.$touched\"\n                >\n                  <div ng-message=\"required\">\n                    El usuario de conciliacion es obligatorio\n                  </div>\n                </div>\n              </div>\n            </div>\n            <!-- FIN CAMPO DE NIT PARA SUPERVISOR -->\n            <div class=\"md-input-group icon\" ng-if=\"!$ctrl.conciliacion\">\n              <span class=\"md-input-group-addon\"\n                ><i class=\"fa fa-user\"></i\n              ></span>\n              <md-input\n                label=\"Usuario\"\n                ng-model=\"$ctrl.username\"\n                name=\"username\"\n                required\n                id=\"username\"\n              ></md-input>\n              <div\n                ng-messages=\"form.username.$error\"\n                class=\"form-error\"\n                ng-if=\"form.username.$touched\"\n              >\n                <div ng-message=\"required\">El usuario es obligatorio</div>\n              </div>\n            </div>\n            <div class=\"md-input-group icon\" ng-if=\"!$ctrl.conciliacion\">\n              <span class=\"md-input-group-addon\"\n                ><i class=\"fa fa-lock\"></i\n              ></span>\n              <md-input\n                label=\"Contraseña\"\n                ng-model=\"$ctrl.password\"\n                name=\"password\"\n                type=\"password\"\n                required\n              ></md-input>\n              <div\n                ng-messages=\"form.password.$error\"\n                class=\"form-error\"\n                ng-if=\"form.password.$touched\"\n              >\n                <div ng-message=\"required\">La contraseña es obligatoria</div>\n              </div>\n            </div>\n            <div class=\"md-input-group icon\" ng-if=\"$ctrl.conciliacion\">\n              <span class=\"md-input-group-addon\"\n                ><i class=\"fa fa-lock\"></i\n              ></span>\n              <md-input\n                label=\"Contraseña\"\n                ng-model=\"$ctrl.username\"\n                name=\"username\"\n                required\n                id=\"username\"\n              ></md-input>\n              <div\n                ng-messages=\"form.username.$error\"\n                class=\"form-error\"\n                ng-if=\"form.username.$touched\"\n              >\n                <div ng-message=\"required\">La contraseña es obligatoria</div>\n              </div>\n            </div>\n            <div class=\"d-flex justify-content-between\">\n              <div class=\"p-5\">\n                <!--\n                                <label class=\"custom-control custom-checkbox\">\n                                    <input type=\"checkbox\" class=\"custom-control-input\">\n                                    <span class=\"custom-control-indicator\"></span>\n                                    <span class=\"custom-control-description\">Recordar sesión</span>\n                                </label>\n                                -->\n                <br />\n                <!-- <a href=\"\" ng-click=\"$ctrl.recovery()\" ng-if=\"!$ctrl.empresa\"\n                  >¿Se te olvidó tu contraseña?</a\n                > -->\n              </div>\n              <div class=\"p-3 text-right\">\n                <button\n                  md-effect\n                  class=\"btn btn-primary btn-lg\"\n                  type=\"submit\"\n                  validar-formulario=\"form\"\n                >\n                  <i class=\"fa fa-sign-in\"></i> Iniciar sesión\n                </button>\n                <small style=\"font-size: 7px\"><br />r1412</small>\n              </div>\n            </div>\n          </form>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n<div>\n  <table\n    style=\"\n      border-collapse: collapse;\n      width: 100%;\n      margin: 0 auto;\n      align-content: center;\n    \"\n    border=\"0\"\n  >\n    <tbody>\n      <tr>\n        <td align=\"center\">\n          <img\n            src=\"https://www.upre.gob.bo/images/comunicados2020/comunicado_seguimiento.png\"\n          />\n        </td>\n      </tr>\n    </tbody>\n  </table>\n</div>\n<div\n  class=\"side back login-block\"\n  ng-class=\"{'side':!$ctrl.flip}\"\n  ng-if=\"$ctrl.flip\"\n>\n  <form ng-submit=\"$ctrl.recuperarContrasenia()\">\n    <div class=\"md-input-group icon\">\n      <span class=\"md-input-group-addon\"><i class=\"fa fa-user\"></i></span>\n      <md-input\n        label=\"Usuario\"\n        ng-model=\"$ctrl.username\"\n        name=\"username\"\n        required\n        id=\"username\"\n      ></md-input>\n      <div\n        ng-messages=\"form.username.$error\"\n        class=\"form-error\"\n        ng-if=\"form.username.$touched\"\n      >\n        <div ng-message=\"required\">El usuario es obligatorio</div>\n      </div>\n    </div>\n    <div class=\"md-input-group icon\">\n      <span class=\"md-input-group-addon\"><i class=\"fa fa-envelope\"></i></span>\n      <md-input\n        label=\"Correo electrónico\"\n        ng-model=\"$ctrl.correo\"\n        name=\"correo\"\n      ></md-input>\n    </div>\n    <div class=\"d-flex justify-content-between\">\n      <div class=\"p-5\">\n        <br />\n        <a href=\"\" ng-click=\"$ctrl.goLogin()\" class=\"login-link\"\n          >Iniciar sesión</a\n        >\n      </div>\n      <div class=\"p-3 text-right\">\n        <button md-effect class=\"btn btn-primary btn-lg\">\n          <i class=\"fa fa-repeat\"></i> Recuperar contraseña\n        </button>\n      </div>\n    </div>\n  </form>\n</div>\n"

/***/ }),
/* 598 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\"><i class=\"fa fa-plus-circle\"></i> Reasignación</h5>\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cerrar()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<div class=\"modal-body\">\n  <p>\n    Usuario/a actual:\n  </p>\n  <div class=\"row\">\n    <div class=\"md-input-group col-12\">\n      {{$ctrl.transicion.usuario_asignado.persona.nombres}}\n      {{$ctrl.transicion.usuario_asignado.persona.primer_apellido}}\n      {{$ctrl.transicion.usuario_asignado.persona.segundo_apellido}}\n      <br><strong>{{$ctrl.transicion.usuario_asignado_rol.descripcion}}</strong>\n    </div>\n  </div>\n\n  <br><br>\n  <ng-form name=\"formUsuario\">\n    <div class=\"row\">\n      <div class=\"md-input-group col-md-12\">\n        <c-select name=\"nuevo_usuario_asignado\"\n        label=\"Nuevo usuario/a asignado\"\n        ng-model=\"$ctrl.datos.seleccionado\"\n        options=\"$ctrl.usuariosParaAsignar\"\n        field=\"nombre\"\n        ng-required=\"true\"></c-select>\n      </div>\n    </div>\n  </ng-form>\n  <div class=\"alert alert-info\">\n    <i class=\"fa fa-info-circle\"></i> Tome en cuenta que al reasignar al usuario ya no podrá acceder a los datos del proyecto. Transfiriendo todos los permisos y responsabilidades al nuevo usuario.\n  </div>\n</div>\n\n<div class=\"modal-footer\">\n  <button type=\"button\" md-effect class=\"btn btn-secondary\" ng-click=\"$ctrl.cerrar()\">\n    <i class=\"fa fa-close\"></i> Cancelar\n  </button>\n  <button type=\"submit\" md-effect class=\"btn btn-primary\" ng-click=\"$ctrl.reasignarUsuario()\" validar-formulario=\"formUsuario\">\n    <i class=\"fa fa-send\"></i> Enviar cambio\n  </button>\n</div>\n"

/***/ }),
/* 599 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <h2 class=\"page-title\">\n    <i class=\"fa fa-bars\"></i> Proyecto\n  </h2>\n  <div class=\"card\">\n    <div class=\"card-header\">\n      DATOS\n    </div>\n    <div class=\"card-body table-responsive\">\n      <div class=\"row\">\n        <div class=\"col-md-6\">\n          <table class=\"table table-striped\">\n            <tr>\n              <th>Nombre:</th>\n              <td>{{$ctrl.proyecto.nombre}}</td>\n            </tr>\n            <tr>\n              <th>Tipo:</th>\n              <td>{{$ctrl.proyecto.tipo}}</td>\n            </tr>\n            <tr>\n              <th>Departamento:</th>\n              <td>{{$ctrl.proyecto.municipio.provincia.departamento.nombre}}</td>\n            </tr>\n            <tr>\n              <th>Estado:</th>\n              <td>{{$ctrl.proyecto.estado_proyecto}}</td>\n            </tr>\n            <tr>\n              <th>Registro de cambios</th>\n              <td><button-timeline proyecto=\"$ctrl.proyecto\"></button-timeline></td>\n            </tr>\n          </table>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"card\" ng-if=\"$ctrl.dtsRol['nombre']=='ENCAR_REGIONAL_UPRE' || $ctrl.dtsRol['nombre']=='RESP_DEPARTAMENTAL_UPRE'|| $ctrl.dtsRol['nombre']=='TECNICO_UPRE'\" >\n    <div class=\"card-header\">\n      USUARIOS ASIGNADOS\n    </div>\n    <div class=\"card-body table-responsive\">\n      <table class=\"table table-striped\">\n        <tr>\n          <th>Observación</th>\n          <th>Usuario Asignado</th>\n          <th>Opciones</th>\n        </tr>\n        <tr ng-repeat=\"transicion in $ctrl.proyecto.transicion\">\n          <td>{{transicion.tipo}}\n            <br>{{transicion.observacion}}\n          </td>\n          <td>{{transicion.usuario_asignado.persona.nombres}}\n            {{transicion.usuario_asignado.persona.primer_apellido}}\n            {{transicion.usuario_asignado.persona.segundo_apellido}}\n            <br><strong>{{transicion.usuario_asignado_rol.descripcion}}</strong>\n          </td>\n          <td>\n            <button \n              ng-if=\"\n              (($ctrl.dtsRol['nombre']=='ENCAR_REGIONAL_UPRE' || $ctrl.dtsRol['nombre']=='RESP_DEPARTAMENTAL_UPRE') \n                && (transicion.usuario_asignado_rol.nro == 11 || transicion.usuario_asignado_rol.nro == 5 || transicion.usuario_asignado_rol.nro == 4))\n              || ($ctrl.dtsRol['nombre']=='TECNICO_UPRE' && transicion.usuario_asignado_rol.nro == 11)\n              \"\n            type=\"button\" uib-tooltip=\"Reasignar usuario\" class=\"btn btn-sm\" ng-click=\"$ctrl.reasignarUsuario(transicion)\"><i class=\"fa fa-user\"></i></button>\n          </td>\n        </tr>\n        <tr ng-if=\"$ctrl.proyecto.usuario.persona\">\n          <td>proyecto</td>\n          <td>{{$ctrl.proyecto.usuario.persona.nombres}}\n            {{$ctrl.proyecto.usuario.persona.primer_apellido}}\n            {{$ctrl.proyecto.usuario.persona.segundo_apellido}}\n            <br><strong>{{$ctrl.proyecto.usuario_rol.descripcion}}\n          </td>\n          <td>\n            <button \n              ng-if=\"$ctrl.dtsRol['nombre']=='ENCAR_REGIONAL_UPRE' || $ctrl.dtsRol['nombre']=='RESP_DEPARTAMENTAL_UPRE'\"\n            type=\"button\" uib-tooltip=\"Reasignar usuario\" class=\"btn btn-sm\" ng-click=\"$ctrl.reasignarUsuarioProy($ctrl.proyecto)\"><i class=\"fa fa-user\"></i></button>\n          </td>\n        </tr>\n      </table>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 600 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <h2 class=\"page-title\">\n    <i class=\"fa fa-bars\"></i> Proyectos\n  </h2>\n  <div class=\"card\">\n    <div class=\"card-body\">\n\n      <crud-table url=\"$ctrl.proyectos.url\"\n                data=\"$ctrl.proyectos.data\"\n                fields=\"$ctrl.proyectos.fields\"\n                permission=\"$ctrl.proyectos.permission\"\n                event-create=\"$ctrl.proyectos.eventCreate\"\n                event-edit=\"$ctrl.proyectos.eventEdit\"\n                event-delete=\"$ctrl.proyectos.eventDelete\"\n                buttons=\"$ctrl.proyectos.buttons\"\n                labels=\"$ctrl.proyectos.labels\"\n                fks=\"$ctrl.proyectos.fks\"\n                update=\"$ctrl.proyectos.update\"\n                clases=\"$ctrl.proyectos.clases\"\n                ng-if=\"$ctrl.proyectos\"\n                hidden-fields=\"$ctrl.proyectos.hiddenFields\">\n      </crud-table>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 601 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"login-container\">\n    <div class=\"login-logo\"> PROYECTOS </div>\n    <div class=\"login-header\">\n        {{ 'Cambiar contraseña' }}\n    </div>\n    <div class=\"card-container\">\n        <div class=\"card-flip-container\" ng-class=\"{ 'recovery' : $ctrl.flip, 'empresa' : $ctrl.empresa }\">\n            <div class=\"card-flip\">\n                <div class=\"side front login-block\" ng-class=\"{'side':$ctrl.flip}\" ng-if=\"!$ctrl.flip\">\n                    <form name=\"form\" ng-submit=\"$ctrl.cambiarContrasena()\">\n\n                        <div class=\"row\">\n                            <div class=\"col-12 alert alert-info\">\n                                <i class=\"fa fa-info-circle\"></i> <strong>IMPORTANTE:</strong>\n                                <ul class=\"btm-0\">\n                                    <li>Escriba una nueva contraseña (se distingue entre mayúsculas y minúsculas).</li>\n                                    <!-- <li>Su contraseña nueva debe tener hasta 16 caracteres.</li> -->\n                                    <li>Luego de modificar su contraseña, intente iniciar sesión nuevamente.</li>\n                                </ul>\n                            </div>\n                            \n                            <div class=\"col-sm-12\">\n                                <c-input type=\"password\" name=\"nueva\" label=\"Nueva contraseña\" ng-model=\"$ctrl.nueva\" ng-minlength=\"3\" ng-maxlength=\"16\" \n                                maxlength=\"16\" ng-required=\"true\" uib-tooltip=\"Escriba la nueva contraseña.\" ng-validation=\"alfa-numerico\" ></c-input>\n                            </div>\n\n                            <div class=\"col-sm-12\">\n                                <c-input type=\"password\" name=\"confirmada\" label=\"Repita la contraseña\" ng-model=\"$ctrl.confirmada\" ng-minlength=\"3\"\n                                ng-maxlength=\"16\" maxlength=\"16\" ng-required=\"true\" uib-tooltip=\"Vuelva a escribir la nueva contraseña.\" \n                                c-ui-validate=\"{contrasena:'$ctrl.form.confirmada.$viewValue==$ctrl.form.nueva.$modelValue'}\" \n                                c-ui-validate-watch=\"'$ctrl.form.nueva.$modelValue'\" \n                                message-error-password=\"Las nuevas contraseñas no son iguales. Revise por favor.\"></c-input>\n                            </div>\n                        </div>\n\n                        <div class=\"d-flex justify-content-between\">\n                            <div class=\"p-5\">\n                                <br>\n                                <a href=\"\" ng-click=\"$ctrl.inicioDeSesion()\">Ir a inicio de sesión</a>\n                            </div>\n                            <div class=\"p-3 text-right\">\n                                <button md-effect class=\"btn btn-primary btn-lg\" type=\"submit\" validar-formulario=\"form\" ng-disabled=\"false\">\n                                    <i class=\"fa fa-refresh\"></i> Cambiar contraseña\n                                </button>\n                            </div>\n                        </div>\n                    </form>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 602 */
/***/ (function(module, exports) {

	module.exports = "<button md-effect type=\"button\" class=\"btn btn-info btn-sm mt-1\"\n  uib-tooltip=\"Progreso del proyecto\" ng-click=\"$ctrl.verRegistro()\">\n  <i class=\"fa fa-stack-overflow\"></i>\n</button>\n"

/***/ }),
/* 603 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\"><i class=\"fa fa-plus-circle\"></i> Linea de Tiempo</h5>\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cerrar()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<div class=\"modal-body\">\n  <!-- <p>\n    <h5>Proyecto:</h5>\n  </p> -->\n  <div class=\"row\">\n    <div class=\"md-input-group col-12\">\n      {{$ctrl.transicion.usuario_asignado.persona.nombres}}\n      {{$ctrl.transicion.usuario_asignado.persona.primer_apellido}}\n      {{$ctrl.transicion.usuario_asignado.persona.segundo_apellido}}\n      <br><strong>{{$ctrl.transicion.usuario_asignado_rol.descripcion}}</strong>\n    </div>\n  </div>\n\n  <br><br>\n  <section style=\"max-height:400px;overflow:auto\">\n    <timeline>\n      <timeline-event ng-repeat=\"evento in $ctrl.eventos\" side=\"{{evento.side}}\">\n        <timeline-badge class=\"{{evento.badgeClass}}\">\n          <i class=\"fa fa-{{evento.badgeIconClass}}\"></i>\n        </timeline-badge>\n        <timeline-panel class=\"{{evento.badgeClass}}\">\n          <timeline-heading ng-if=\"evento.nombre\">\n            <h5>{{evento.nombre}}<br><small><strong>{{evento.rol}}</strong></small></h5>\n          </timeline-heading>\n          <p ng-if=\"evento.contenido\">{{evento.contenido}}</p>\n          <p style=\"margin:0\">\n            <small><strong>{{evento.estado}}</strong></p>\n            <small class=\"pull-right\"><i class=\"fa fa-clock\"></i>{{evento.fecha | date : 'dd/MM/yyyy HH:mm'}}</small></p>\n        </timeline-panel>\n      </timeline-event>\n    </timeline>\n  </section>\n</div>\n\n<div class=\"modal-footer\">\n  <button type=\"button\" md-effect class=\"btn btn-primary\" ng-click=\"$ctrl.cerrar()\">\n    <i class=\"fa fa-close\"></i> Aceptar\n  </button>\n</div>\n"

/***/ }),
/* 604 */
/***/ (function(module, exports) {

	module.exports = "<button\n  md-effect\n  type=\"button\"\n  class=\"btn btn-sm btn-info\"\n  uib-tooltip=\"Enviar Credenciales al Correo\"\n  ng-click=\"$ctrl.reenviarCorreo()\"\n>\n  <i class=\"fa fa-share-square-o\"></i>\n</button>\n"

/***/ }),
/* 605 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <h2 class=\"page-title\">\n    <!-- <i class=\"fa fa-bars\"></i> -->\n    <i class=\"fa fa-reply\" ui-sref=\"usuarios\"></i>\n    <!-- <small>Bandeja de planillas</small> -->\n  </h2>\n  <div class=\"card\">\n    <ng-form name=\"usuarioForm\">\n      <div class=\"card-body\">\n        <h4>Datos de Usuario</h4>\n        <documento-identidad\n          ng-model=\"$ctrl.usuario.persona\"\n        ></documento-identidad>\n        <!-- <div class=\"row\">\n          <div class=\"col-sm-6\">\n            <c-input name=\"usuario\" label=\"Usuario\" ng-model=\"$ctrl.usuario.usuario\"\n              ng-minlength=\"3\" maxlength=\"100\" ng-required=\"true\" ng-disabled=\"false\">\n            </c-input>\n          </div>\n          <div class=\"col-sm-6\">\n\n          </div>\n        </div> -->\n        <div class=\"row\">\n          <div class=\"col-sm-12 col-md-6\">\n            <c-input\n              name=\"correo\"\n              label=\"Correo electrónico\"\n              ng-model=\"$ctrl.usuario.persona.correo\"\n              ng-minlength=\"3\"\n              maxlength=\"100\"\n              ng-required=\"true\"\n              ng-disabled=\"false\"\n            >\n            </c-input>\n            <c-input\n              name=\"telefono\"\n              label=\"Celular/Teléfono\"\n              ng-model=\"$ctrl.usuario.persona.telefono\"\n              ng-minlength=\"7\"\n              maxlength=\"100\"\n              ng-required=\"true\"\n              ng-disabled=\"false\"\n            >\n            </c-input>\n            <h5>Roles</h5>\n            <c-checkbox\n              name=\"{{'rol_'+rol.id_rol}}\"\n              label=\"{{rol.nombre}}\"\n              ng-model=\"rol.valor\"\n              ng-repeat=\"rol in $ctrl.roles\"\n            ></c-checkbox>\n          </div>\n          <div class=\"col-sm-12 col-md-6\">\n            <c-select\n              name=\"estado\"\n              label=\"Estado\"\n              placeholder=\"\"\n              ng-model=\"$ctrl.usuario.estado\"\n              key-value=\"value\"\n              ng-required=\"true\"\n              ng-disabled=\"false\"\n              options=\"$ctrl.estados\"\n              field=\"text\"\n            >\n            </c-select>\n            <c-input\n              name=\"direccion\"\n              label=\"Dirección\"\n              ng-model=\"$ctrl.usuario.persona.direccion\"\n              ng-minlength=\"7\"\n              maxlength=\"100\"\n              ng-required=\"true\"\n              ng-disabled=\"false\"\n            >\n            </c-input>\n            <!-- <c-select name=\"tipo_departamento\" label=\"Tipo de departamento\" placeholder=\"\" ng-model=\"$ctrl.usuario.tipo_departamento\"\n              ng-required=\"true\" ng-disabled=\"false\" options=\"$ctrl.tipos_departamento\" field=\"text\">\n            </c-select> -->\n            <h5>Departamento(s)</h5>\n            <div class=\"row\">\n              <div\n                class=\"col-sm-12 col-lg-6\"\n                ng-repeat=\"dep in $ctrl.departamentos\"\n              >\n                <c-checkbox\n                  name=\"{{'departamento_'+dep.nombre}}\"\n                  label=\"{{dep.nombre}}\"\n                  ng-model=\"dep.valor\"\n                ></c-checkbox>\n              </div>\n            </div>\n\n            <!-- <button md-effect type=\"button\" class=\"btn\" ng-click=\"$ctrl.nombreDel()\" ng-if=\"$ctrl.isFill()\">\n              <i class=\"fa fa-edit\"></i>Cambiar\n            </button> -->\n          </div>\n        </div>\n        <div class=\"row mx-0 mt-4\">\n          <div class=\"col\"></div>\n          <button\n            md-effect\n            type=\"button\"\n            class=\"btn btn-success\"\n            ng-click=\"$ctrl.guardarDatos(usuarioForm)\"\n          >\n            <i class=\"fa fa-save\"></i> Guardar datos\n          </button>\n        </div>\n      </div>\n    </ng-form>\n  </div>\n  <div class=\"card\">\n    <div class=\"card-body\">\n      <div class=\"row\">\n        <div class=\"col\">\n          <button\n            md-effect\n            type=\"button\"\n            class=\"btn btn-info\"\n            uib-tooltip=\"Enviar Credenciales al Correo\"\n            ng-click=\"$ctrl.reenviarContrasenia()\"\n          >\n            <i class=\"fa fa-share-square-o\"></i> Regenerar y enviar contraseña\n          </button>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 606 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <h2 class=\"page-title\">\n    <i class=\"fa fa-bars\"></i> {{$ctrl.proyecto.nombre}}<br>\n    <small>Bandeja de planillas</small>\n  </h2>\n  <div class=\"card\">\n    <div class=\"card-body\">\n      <crud-table url=\"$ctrl.usuarios.url\"\n                data=\"$ctrl.usuarios.data\"\n                fields=\"$ctrl.usuarios.fields\"\n                permission=\"$ctrl.usuarios.permission\"\n                event-create=\"$ctrl.usuarios.eventCreate\"\n                event-edit=\"$ctrl.usuarios.eventEdit\"\n                event-delete=\"$ctrl.usuarios.eventDelete\"\n                buttons=\"$ctrl.usuarios.buttons\"\n                labels=\"$ctrl.usuarios.labels\"\n                fks=\"$ctrl.usuarios.fks\"\n                update=\"$ctrl.usuarios.update\"\n                clases=\"$ctrl.usuarios.clases\"\n                ng-if=\"$ctrl.usuarios\" \n                hidden-fields=\"$ctrl.usuarios.hiddenFields\">\n      </crud-table>\n\n\n    </div>\n</div>\n"

/***/ }),
/* 607 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <h2 class=\"page-title\">\n    <i class=\"fa fa-bars\"></i> {{$ctrl.proyecto.nombre}}<br>\n    <small>Bandeja de planillas</small>\n  </h2>\n  <div class=\"card\">\n    <div class=\"card-body\">\n      <crud-table url=\"$ctrl.planillas.url\"\n                query-extra=\"$ctrl.planillas.queryExtra\"\n                data=\"$ctrl.planillas.data\"\n                fields=\"$ctrl.planillas.fields\"\n                permission=\"$ctrl.planillas.permission\"\n                event-create=\"$ctrl.planillas.eventCreate\"\n                buttons=\"$ctrl.planillas.buttons\"\n                labels=\"$ctrl.planillas.labels\"\n                fks=\"$ctrl.planillas.fks\"\n                update=\"$ctrl.planillas.update\"\n                clases=\"$ctrl.planillas.clases\"\n                ng-if=\"$ctrl.planillas\" \n                hidden-fields=\"$ctrl.planillas.hiddenFields\">\n      </crud-table>\n\n\n    </div>\n</div>\n"

/***/ }),
/* 608 */
/***/ (function(module, exports) {

	module.exports = "<section>\n  <h6 class=\"title-section m-top\"><i class=\"fa fa-hand-o-right\"></i> Datos Adicionales</h6>\n  <div class=\"row\">\n    <div class=\"col-md-12\" ng-if=\"!$ctrl.modoVista\">\n      <div class=\"alert alert-info\">\n        <i class=\"fa fa-info-circle\"></i> Introduzca el <strong>código del formulario</strong> registrado en el sistema de empresas a efectos de obtener su información.\n      </div>\n    </div>\n    <div class=\"col-md-6\">\n      <div class=\"row\">\n        <div class=\"md-input-group col\">\n          <c-input name=\"codigo_reporte\" label=\"Código de Formulario\" ng-model=\"$ctrl.proyecto.cod_documentacion_exp\"\n            ng-required=\"true\" ng-disabled=\"$ctrl.modoVista || $ctrl.tieneDocumentacion\">\n          </c-input>\n        </div>\n        <div class=\"col-md-4\" ng-if=\"!$ctrl.modoVista && $ctrl.proyecto.cod_documentacion_exp && $ctrl.proyecto.documentacion_exp\">        \n          <button md-effect class=\"btn btn-{{$ctrl.tieneDocumentacion? 'primary':''}}\" ng-click=\"$ctrl.tieneDocumentacion? $ctrl.cambiarDocumentacion() : $ctrl.cancelarCambio()\">\n            <i class=\"fa fa-{{$ctrl.tieneDocumentacion? 'exchange' : 'close'}}\"></i>\n            {{$ctrl.tieneDocumentacion? 'Cambiar' : 'Cancelar'}}\n          </button>\n        </div>\n        <!-- VOLVER AL PROCEDO DE DOCUMENTACION DE LA EMPRESA -->\n        <div class=\"col-md-8\" ng-if=\"$ctrl.estadoBoton==true\">\n          <button md-effect class=\"btn btn-warning\" ng-click=\"$ctrl.tieneDocumentacion? $ctrl.procesoDocumentacionEmpresa() : $ctrl.cancelarDocumentacionEmpresa()\">\n            <i class=\"fa fa-{{$ctrl.tieneDocumentacion? 'exchange' : 'close'}}\"></i>\n            {{$ctrl.tieneDocumentacion? 'Cambiar la Documentacion de la Empresa' : 'Cancelar'}}\n          </button>\n        </div>\n\n      </div>\n    </div>    \n    <div class=\"md-input-group col-md-6\">\n      <div class=\"row\">\n      <c-input name=\"contrato\" label=\"Nro. de invitación directa\" ng-model=\"$ctrl.proyecto.nro_invitacion\"\n               ng-required=\"true\" ng-disabled=\"$ctrl.modoVista\">\n      </c-input>\n    </div>\n    </div>\n  </div>\n</section>\n"

/***/ }),
/* 609 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"cronogramas\" class=\"row\">\n  <div class=\"col-md-6 col-lg-4\" ng-repeat=\"documento in $ctrl.documentos.lista\">\n    <ui-input-file name=\"{{documento.codigo}}\" label=\"{{documento.nombre}}\"\n      file-base64=\"$ctrl.empresa[documento.codigo]\"\n      upload-callback=\"$ctrl.documentos.uploadCallback\"\n      types=\"pdf\" mime-types=\".pdf\" maxfiles=\"1\" maxsize=\"20MB\"\n      ng-if=\"!documento.registrado\">\n    </ui-input-file>\n\n    <div id=\"documento\" ng-if=\"documento.registrado\">\n      <div class=\"opciones\">\n        <button md-effect type=\"button\" class=\"btn btn-success btn-sm\" uib-tooltip=\"Ver documento\" ng-click=\"$ctrl.verDocumento(documento)\">\n          <i class=\"fa fa-eye\"></i>\n        </button>\n        <button md-effect type=\"button\" class=\"btn btn-primary btn-sm\" uib-tooltip=\"Descargar\"\n                download-file=\"{{documento.urlDescarga}}\" file-name=\"{{documento.nombre}}\">\n          <i class=\"fa fa-download\"></i>\n        </button>\n        <button md-effect type=\"button\" class=\"btn btn-info btn-sm\" uib-tooltip=\"Cambiar\" ng-click=\"$ctrl.cambiar(documento)\">\n          <i class=\"fa fa-exchange\"></i>\n        </button>\n      </div>\n      <img src=\"./images/formulario.jpg\" alt=\"Documento\">\n      <div class=\"detalles\">\n        <div class=\"nombre\">{{documento.nombre}}</div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 610 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\n  <section class=\"col-md-12\">\n    <h6 class=\"title-section m-top\">\n      <i class=\"fa fa-user-o\"></i> Datos de la Asociacion Accidental\n    </h6>\n  </section>\n  <div class=\"col-md-12\">\n    <c-input\n      label=\"Denominación de la Asociación Accidental\"\n      name=\"nombre\"\n      ng-model=\"$ctrl.asociacion.nombre_asociacion\"\n      ng-disabled=\"true\"\n    ></c-input>\n  </div>\n  <div class=\"col-md-12\">\n    <div class=\"row\">\n      <div class=\"col-md-3\">Asociados</div>\n      <div class=\"col-md-9\">\n        <table class=\"table table-striped\">\n          <tr>\n            <th>#</th>\n            <th>Nombre del Asociado</th>\n            <th>% de Participación</th>\n          </tr>\n          <tr ng-repeat=\"asociado in $ctrl.asociacion.asociados\">\n            <td>{{1+$index}}</td>\n            <td>{{asociado.razon_social}}</td>\n            <td>{{asociado.participacion}} %</td>\n          </tr>\n        </table>\n      </div>\n    </div>\n  </div>\n  <div class=\"col-md-6 col-lg-4\">\n    <c-input\n      label=\"N° de testimonio\"\n      name=\"testimonio\"\n      ng-model=\"$ctrl.asociacion.nro_testimonio\"\n      ng-required=\"true\"\n      ng-disabled=\"true\"\n    >\n    </c-input>\n  </div>\n  <div class=\"col-md-6 col-lg-4\">\n    <c-input\n      label=\"Lugar\"\n      name=\"lugar\"\n      ng-model=\"$ctrl.asociacion.lugar_testimonio\"\n      ng-required=\"true\"\n      ng-disabled=\"true\"\n    >\n    </c-input>\n  </div>\n  <div class=\"col-md-6 col-lg-4\">\n    <c-date\n      label=\"Fecha de Expedición\"\n      id=\"fecha_expedicion\"\n      name=\"fecha_expedicion\"\n      ng-model=\"$ctrl.asociacion.fecha_expedicion\"\n      ng-required=\"true\"\n      ng-disabled=\"true\"\n    >\n    </c-date>\n  </div>\n  <div class=\"md-input-group col-md-12\">\n    <c-input\n      name=\"razon_social\"\n      label=\"Nombre de la Empresa Líder\"\n      ng-model=\"$ctrl.empresa.razon_social\"\n      ng-disabled=\"true\"\n    ></c-input>\n  </div>\n  <section class=\"col-md-12\">\n    <h6 class=\"title-section m-top\">\n      <i class=\"fa fa-user-o\"></i> Datos de Contacto de la Empresa Líder\n    </h6>\n  </section>\n  <div class=\"md-input-group col-md-6\">\n    <c-input\n      name=\"pais_empresa\"\n      label=\"País\"\n      ng-model=\"$ctrl.empresa.pais\"\n      ng-disabled=\"true\"\n    ></c-input>\n  </div>\n  <div class=\"md-input-group col-md-6\">\n    <c-input\n      name=\"ciudad_empresa\"\n      label=\"Ciudad\"\n      ng-model=\"$ctrl.empresa.ciudad\"\n      ng-disabled=\"true\"\n    ></c-input>\n  </div>\n  <div class=\"md-input-group col-md-12\">\n    <c-input\n      name=\"direccion_empresa\"\n      label=\"Dirección\"\n      ng-model=\"$ctrl.empresa.direccion\"\n      ng-disabled=\"true\"\n    ></c-input>\n  </div>\n  <div class=\"md-input-group col-md-4\">\n    <c-input\n      name=\"telefonos_empresa\"\n      label=\"Teléfonos\"\n      ng-model=\"$ctrl.empresa.telefono\"\n      ng-disabled=\"true\"\n    ></c-input>\n  </div>\n  <div class=\"md-input-group col-md-4\">\n    <c-input\n      name=\"fax_empresa\"\n      label=\"Fax\"\n      ng-model=\"$ctrl.empresa.fax\"\n      ng-disabled=\"true\"\n    ></c-input>\n  </div>\n  <div class=\"md-input-group col-md-4\">\n    <c-input\n      name=\"correo_empresa\"\n      label=\"Correo electrónico\"\n      ng-model=\"$ctrl.empresa.correo\"\n      ng-disabled=\"true\"\n    ></c-input>\n  </div>\n\n  <section class=\"col-md-12\">\n    <h6 class=\"title-section m-top\">\n      <i class=\"fa fa-user-o\"></i> Datos del Representante Legal de la\n      Asociacion Accidental\n    </h6>\n  </section>\n  <div class=\"md-input-group col-md-8\">\n    <!-- <c-input name=\"representante_legal\" label=\"Nombre\" ng-model=\"$ctrl.empresa.representante_legal.persona.nombre\"\n    ng-disabled=\"true\"></c-input> -->\n    <c-input\n      name=\"representante_legal\"\n      label=\"Nombre\"\n      ng-model=\"$ctrl.asociacion.asociado.representante_legal.persona.nombre\"\n      ng-disabled=\"true\"\n    ></c-input>\n  </div>\n  <div class=\"md-input-group col-md-4\">\n    <c-input\n      name=\"ci_representante_legal\"\n      label=\"Nro Cédula de Identidad\"\n      ng-model=\"$ctrl.asociacion.asociado.representante_legal.persona.documento_identidad\"\n      ng-disabled=\"true\"\n    ></c-input>\n  </div>\n  <div class=\"md-input-group col-md-4\">\n    <c-input\n      name=\"nro_testimonio\"\n      label=\"Nro. de testimonio\"\n      ng-model=\"$ctrl.asociacion.asociado.representante_legal.poder.nro_testimonio\"\n      ng-disabled=\"true\"\n    ></c-input>\n  </div>\n  <div class=\"md-input-group col-md-4\">\n    <c-input\n      name=\"lugar_emision\"\n      label=\"Lugar de emisión\"\n      ng-model=\"$ctrl.asociacion.asociado.representante_legal.poder.lugar_emision\"\n      ng-disabled=\"true\"\n    ></c-input>\n  </div>\n  <div class=\"md-input-group col-md-4\">\n    <c-date\n      name=\"fecha_expedicion\"\n      label=\"Fecha de expedición\"\n      ng-model=\"$ctrl.asociacion.asociado.representante_legal.poder.fecha_expedicion\"\n      ng-disabled=\"true\"\n    ></c-date>\n  </div>\n  <!-- <section class=\"col-md-12\">\n    <h6  class=\"title-section m-top\"><i class=\"fa fa-bell-o\"></i> Margen de preferencia</h6>\n  </section>\n  <div class=\"md-input-group col\"><br>\n    <c-checkbox name=\"margen_preferencia\" label=\"Asociación accidental de empresas constructoras cuyos asociados bolivianos tengan una participación igual o mayor al cincuenta y uno por ciento (51%)\"\n    ng-model=\"$ctrl.asociacion.margen_preferencia\"\n    ng-disabled=\"true\"></c-checkbox>\n  </div> -->\n\n  <section class=\"col-md-12\">\n    <h6 class=\"title-section m-top\">\n      <i class=\"fa fa-bell-o\"></i> Información para notificaciones\n    </h6>\n  </section>\n  <div class=\"md-input-group col-md-1\">\n    <br />\n    <c-checkbox\n      name=\"correo_empresa_check\"\n      label=\"a)\"\n      ng-model=\"$ctrl.empresa.notificacion_correo_check\"\n      ng-disabled=\"true\"\n    ></c-checkbox>\n  </div>\n  <div class=\"md-input-group col-md-5\">\n    <c-input\n      name=\"correo_empresa\"\n      label=\"Correo electrónico\"\n      ng-model=\"$ctrl.empresa.notificacion_correo\"\n      ng-disabled=\"true\"\n    ></c-input>\n  </div>\n  <div class=\"md-input-group col-md-1\">\n    <br />\n    <c-checkbox\n      name=\"fax_empresa_check\"\n      label=\"b)\"\n      ng-model=\"$ctrl.empresa.notificacion_fax_check\"\n      ng-disabled=\"true\"\n    ></c-checkbox>\n  </div>\n  <div class=\"md-input-group col-md-5\">\n    <c-input\n      name=\"fax_empresa\"\n      label=\"Fax\"\n      ng-model=\"$ctrl.empresa.notificacion_fax\"\n      ng-disabled=\"true\"\n    ></c-input>\n  </div>\n</div>\n"

/***/ }),
/* 611 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\n  <div class=\"md-input-group col-md-12\">\n    <c-input name=\"razon_social\" label=\"Nombre del proponente o razón social\" ng-model=\"$ctrl.empresa.razon_social\"\n    ng-disabled=\"true\"></c-input>\n  </div>\n  <div class=\"md-input-group col-md-12\">\n    <c-input name=\"tipo_empresa\" label=\"Tipo\" ng-model=\"$ctrl.empresa.tipo\"\n    ng-disabled=\"true\"></c-input>\n  </div>\n  <div class=\"md-input-group col-md-6\">\n    <c-input name=\"pais_empresa\" label=\"País\" ng-model=\"$ctrl.empresa.pais\"\n    ng-disabled=\"true\"></c-input>\n  </div>\n  <div class=\"md-input-group col-md-6\">\n    <c-input name=\"ciudad_empresa\" label=\"Ciudad\" ng-model=\"$ctrl.empresa.ciudad\"\n    ng-disabled=\"true\"></c-input>\n  </div>\n  <div class=\"md-input-group col-md-12\">\n    <c-input name=\"direccion_empresa\" label=\"Dirección\" ng-model=\"$ctrl.empresa.direccion\"\n    ng-disabled=\"true\"></c-input>\n  </div>\n  <div class=\"md-input-group col-md-12\">\n    <c-input name=\"telefonos_empresa\" label=\"Teléfonos\" ng-model=\"$ctrl.empresa.telefono\"\n    ng-disabled=\"true\"></c-input>\n  </div>\n  <div class=\"md-input-group col-md-4\">\n    <c-input name=\"nit\" label=\"NIT\" ng-model=\"$ctrl.empresa.nit\"\n    ng-disabled=\"true\"></c-input>\n  </div>\n  <div class=\"md-input-group col-md-4\">\n    <c-input name=\"matricula_comercio\" label=\"Nro. Matrícula de Comercio\" ng-model=\"$ctrl.empresa.nro_matricula\"\n    ng-disabled=\"true\"></c-input>\n  </div>\n  <div class=\"md-input-group col-md-4\">\n    <c-date name=\"fecha_inscripcion_empresa\" label=\"Fecha de inscripción\" ng-model=\"$ctrl.empresa.fecha_inscripcion\"\n    ng-disabled=\"true\"></c-date>\n  </div>\n  <section class=\"col-md-12\">\n    <h6 class=\"title-section m-top\"><i class=\"fa fa-user-o\"></i> Datos del Representante Legal</h6>\n  </section>\n  <div class=\"md-input-group col-md-8\">\n    <c-input name=\"representante_legal\" label=\"Nombre\" ng-model=\"$ctrl.empresa.representante_legal.persona.nombre\"\n    ng-disabled=\"true\"></c-input>\n  </div>\n  <div class=\"md-input-group col-md-4\">\n    <c-input name=\"ci_representante_legal\" label=\"Nro Cédula de Identidad\" ng-model=\"$ctrl.empresa.representante_legal.persona.documento_identidad\"\n    ng-disabled=\"true\"></c-input>\n  </div>\n  <div class=\"md-input-group col-md-4\">\n    <c-input name=\"nro_testimonio\" label=\"Nro. de testimonio\" ng-model=\"$ctrl.empresa.representante_legal.poder.nro_testimonio\"\n    ng-disabled=\"true\"></c-input>\n  </div>\n  <div class=\"md-input-group col-md-4\">\n    <c-input name=\"lugar_emision\" label=\"Lugar de emisión\" ng-model=\"$ctrl.empresa.representante_legal.poder.lugar_emision\"\n    ng-disabled=\"true\"></c-input>\n  </div>\n  <div class=\"md-input-group col-md-4\">\n    <c-date name=\"fecha_expedicion\" label=\"Fecha de expedición\" ng-model=\"$ctrl.empresa.representante_legal.poder.fecha_expedicion\"\n    ng-disabled=\"true\"></c-date>\n  </div>\n\n  <section class=\"col-md-12\">\n    <h6 class=\"title-section m-top\"><i class=\"fa fa-bell-o\"></i> Información para notificaciones</h6>\n  </section>\n\n  <div class=\"md-input-group col-md-1\"><br>\n    <c-checkbox name=\"correo_empresa_check\" label=\"a)\" ng-model=\"$ctrl.empresa.notificacion_correo_check\"\n    ng-disabled=\"true\"></c-checkbox>\n  </div>\n  <div class=\"md-input-group col-md-5\">\n    <c-input name=\"correo_empresa\" label=\"Correo electrónico\" ng-model=\"$ctrl.empresa.notificacion_correo\"\n    ng-disabled=\"true\"></c-input>\n  </div>\n  <div class=\"md-input-group col-md-1\"><br>\n    <c-checkbox name=\"fax_empresa_check\" label=\"b)\" ng-model=\"$ctrl.empresa.notificacion_fax_check\"\n    ng-disabled=\"true\"></c-checkbox>\n  </div>\n  <div class=\"md-input-group col-md-5\">\n    <c-input name=\"fax_empresa\" label=\"Fax\" ng-model=\"$ctrl.empresa.notificacion_fax\"\n    ng-disabled=\"true\"></c-input>\n  </div>\n</div>\n"

/***/ }),
/* 612 */
/***/ (function(module, exports) {

	module.exports = "<div ng-repeat=\"asociado in $ctrl.integrantes.asociados\">\n  <div class=\"row\">\n    <section class=\"col-md-12\">\n      <h6 class=\"title-section m-top\"><i class=\"fa fa-user-o\"></i> Datos del Asociado #{{$index+1}}</h6>\n    </section>\n    <div class=\"md-input-group col-md-12\">\n      <c-input name=\"razon_social\" label=\"Nombre del proponente o razón social\" ng-model=\"asociado.razon_social\"\n      ng-disabled=\"true\"></c-input>\n    </div>\n    <div class=\"md-input-group col-md-4\">\n      <c-input name=\"nit\" label=\"NIT\" ng-model=\"asociado.nit\"\n      ng-disabled=\"true\"></c-input>\n    </div>\n    <div class=\"md-input-group col-md-4\">\n      <c-input name=\"matricula_comercio\" label=\"Nro. Matrícula de Comercio\" ng-model=\"asociado.nro_matricula\"\n      ng-disabled=\"true\"></c-input>\n    </div>\n    <div class=\"md-input-group col-md-4\">\n      <c-date name=\"fecha_inscripcion_empresa\" label=\"Fecha de inscripción\" ng-model=\"asociado.fecha_inscripcion\"\n      ng-disabled=\"true\"></c-date>\n    </div>\n  </div>\n  <div class=\"row\" ng-if=\"!asociado.representante_legal || !asociado.representante_legal.persona\">\n    <div class=\"col-md-12\">\n      <div class=\"alert alert-info\">\n        <i class=\"fa fa-info-circle\"></i> El asociado es una <strong>Empresa Unipersonal</strong> y éste no acredita un Representante Legal.\n      </div>\n    </div>\n  </div>\n  <div class=\"row\" ng-if=\"asociado.representante_legal && asociado.representante_legal.persona\">\n    <section class=\"col-md-12\">\n      <h6 class=\"m-top\"><i class=\"fa fa-user-o\"></i> Representante Legal</h6>\n    </section>\n    <div class=\"md-input-group col-md-8\">\n      <c-input name=\"representante_legal\" label=\"Nombre\" ng-model=\"asociado.representante_legal.persona.nombre\"\n      ng-disabled=\"true\"></c-input>\n    </div>\n    <div class=\"md-input-group col-md-4\">\n      <c-input name=\"ci_representante_legal\" label=\"Nro Cédula de Identidad\" ng-model=\"asociado.representante_legal.persona.documento_identidad\"\n      ng-disabled=\"true\"></c-input>\n    </div>\n    <div class=\"md-input-group col-md-4\">\n      <c-input name=\"nro_testimonio\" label=\"Nro. de testimonio\" ng-model=\"asociado.representante_legal.poder.nro_testimonio\"\n      ng-disabled=\"true\"></c-input>\n    </div>\n    <div class=\"md-input-group col-md-4\">\n      <c-input name=\"lugar_emision\" label=\"Lugar de emisión\" ng-model=\"asociado.representante_legal.poder.lugar_emision\"\n      ng-disabled=\"true\"></c-input>\n    </div>\n    <div class=\"md-input-group col-md-4\">\n      <c-date name=\"fecha_expedicion\" label=\"Fecha de expedición\" ng-model=\"asociado.representante_legal.poder.fecha_expedicion\"\n      ng-disabled=\"true\"></c-date>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 613 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"crud-table table-responsive\" ng-table=\"$ctrl.tableParams\">\n  <table class=\"table table-striped table-hover ng-table\">\n    <tr ng-repeat=\"empleado in $data\">\n      <td data-title=\"'Acción'\">\n        <!-- <button md-effect type=\"button\" class=\"btn btn-success btn-noborder btn-sm\"\n                uib-tooltip=\"Ver experiencia\" ng-click=\"$ctrl.verExperiencia(empleado)\">\n          <i class=\"fa fa-eye\"></i>\n        </button> -->\n      </td>\n      <td\n        data-title=\"'Cargo'\"\n        filter=\"{cargo_actual: 'text'}\"\n        sortable=\"'cargo_actual'\"\n      >\n        {{empleado.cargo_actual}}\n      </td>\n      <td data-title=\"'Nombre'\" filter=\"{nombre: 'text'}\" sortable=\"'nombre'\">\n        {{empleado.nombre}}\n      </td>\n      <td\n        data-title=\"'Cédula de Identidad'\"\n        filter=\"{documento_identidad: 'text'}\"\n        sortable=\"'documento_identidad'\"\n      >\n        {{empleado.documento_identidad}}\n      </td>\n      <td\n        data-title=\"'Nacionalidad'\"\n        filter=\"{nacionalidad: 'text'}\"\n        sortable=\"'nacionalidad'\"\n      >\n        {{empleado.nacionalidad}}\n      </td>\n      <td\n        data-title=\"'Profesion'\"\n        filter=\"{profesion: 'text'}\"\n        sortable=\"'profesion'\"\n      >\n        {{empleado.profesion}}\n      </td>\n      <td\n        data-title=\"'Nro. Registro Profesional'\"\n        filter=\"{nro_registro_profesional: 'text'}\"\n        sortable=\"'nro_registro_profesional'\"\n      >\n        {{empleado.nro_registro_profesional}}\n      </td>\n    </tr>\n  </table>\n</div>\n"

/***/ }),
/* 614 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header pb-0\">\n  <h5 class=\"modal-title\"><i class=\"fa fa-user\"></i> {{$ctrl.empleado.nombre}}</h5>\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cerrar()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<div class=\"modal-body pt-0\">\n  <uib-tabset active=\"active\">\n    <uib-tab index=\"0\" heading=\"Experiencia General\">\n      <c-table dataset=\"$ctrl.empleado.experiencias.generales\" columns=\"$ctrl.camposExperiencia\"></c-table>\n    </uib-tab>\n\n    <uib-tab index=\"1\" heading=\"Experiencia Específica\" disable=\"tab.disabled\">\n      <c-table dataset=\"$ctrl.empleado.experiencias.especificas\" columns=\"$ctrl.camposExperiencia\"></c-table>\n    </uib-tab>\n  </uib-tabset>\n</div>\n\n<div class=\"modal-footer\">\n  <button type=\"button\" md-effect class=\"btn btn-primary\" ng-click=\"$ctrl.cerrar()\">\n    <i class=\"fa fa-check\"></i> Aceptar\n  </button>\n</div>\n"

/***/ }),
/* 615 */
/***/ (function(module, exports) {

	module.exports = "<uib-tabset active=\"active\">\n  <uib-tab index=\"0\" heading=\"Permanente\">\n    <c-table columns=\"$ctrl.camposEquipo\" dataset=\"$ctrl.equipo.permanente\"></c-table>\n  </uib-tab>\n  <uib-tab index=\"1\" heading=\"A requerimiento\">\n    <c-table columns=\"$ctrl.camposEquipo\" dataset=\"$ctrl.equipo.requerido\"></c-table>\n  </uib-tab>\n</uib-tabset>\n"

/***/ }),
/* 616 */
/***/ (function(module, exports) {

	module.exports = "<uib-tabset active=\"active\">\n  <uib-tab heading=\"General\">\n    <c-table columns=\"$ctrl.camposExperiencia\" dataset=\"$ctrl.experiencias.generales\"></c-table>\n  </uib-tab>\n  <uib-tab heading=\"Específica\">\n    <c-table columns=\"$ctrl.camposExperiencia\" dataset=\"$ctrl.experiencias.especificas\"></c-table>\n  </uib-tab>\n</uib-tabset>\n\n<div class=\"totales col-md-12\" style=\"clear:both;\">\n  <div class=\"row\">\n    <div class=\"col-md-6\">\n      TOTAL FACTURADO EN DÓLARES AMERICANOS (alternativo)\n    </div>\n    <div class=\"col-md-6\">\n      <strong>{{ active === 0 ? $ctrl.totalesExpGeneral.dolares : $ctrl.totalesExpEspecifica.dolares | formatDecimal }}</strong>\n    </div>\n    <div class=\"col-md-6\">\n      TOTAL FACTURADO EN BOLIVIANOS\n    </div>\n    <div class=\"col-md-6\">\n      <strong>{{ active === 0 ? $ctrl.totalesExpGeneral.bolivianos : $ctrl.totalesExpEspecifica.bolivianos | formatDecimal }}</strong>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 617 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"formularios\">\n  <div id=\"documento\" ng-repeat=\"formulario in $ctrl.proyecto.formularios\">\n    <div class=\"opciones\">\n      <button md-effect type=\"button\" class=\"btn btn-success btn-sm\" uib-tooltip=\"Ver documento\" ng-click=\"$ctrl.ver(formulario)\">\n        <i class=\"fa fa-eye\"></i>\n      </button>\n\n        <button md-effect type=\"button\" class=\"btn btn-primary btn-sm\" uib-tooltip=\"Descargar\"\n                download-file=\"{{formulario.path}}\" file-name=\"{{formulario.nombre_archivo}}\">\n        <i class=\"fa fa-download\"></i>\n      </button>\n    </div>\n    <img src=\"./images/formulario.jpg\" alt=\"Documento\">\n    <div class=\"detalles\">\n      <div class=\"nombre\">{{formulario.nombre}}</div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 618 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"alert alert-info\">\n  <i class=\"fa fa-info-circle\"></i>\n  <span ng-if=\"!$ctrl.proyecto.monto_total_ejecutado\">El monto total no debe sobrepasar al monto definido en el convenio <strong>{{$ctrl.proyecto.monto_total_convenio | formatDecimal}}</strong>\n  (<strong><em>{{$ctrl.proyecto.monto_total_convenio | numberToLiteral}}</em></strong>)</span>\n  <span ng-if=\"$ctrl.proyecto.monto_total_ejecutado\">El monto total no debe sobrepasar al monto total restante <strong>{{$ctrl.proyecto.monto_total_actual-$ctrl.proyecto.monto_total_ejecutado | formatDecimal}}</strong>\n  (<strong><em>{{$ctrl.proyecto.monto_total_actual-$ctrl.proyecto.monto_total_ejecutado | numberToLiteral}}</em></strong>)</span>\n</div>\n<div class=\"crud-table table-responsive\" id=\"presupuesto-items\">\n  <table class=\"table table-striped table-hover ng-table\">\n    <thead>\n      <tr>\n        <td>Nro</td>\n        <td>Desripción</td>\n        <td>Unidad</td>\n        <td>Cantidad</td>\n        <td>Precios Unitarios</td>\n        <td>Literal</td>\n        <td>Total</td>\n        <td ng-if=\"$ctrl.proyecto.cr_precio\">Regul.</td>\n      </tr>\n    </thead>\n    <tbody>\n      <tr ng-repeat=\"item in $ctrl.proyecto.items | orderBy : 'nro_item'\" ng-if=\"item.estado!='CERRADO'&&item.cantidad>0\" ng-class=\"{'observado':item.estado=='CERRADO'||item.cantidad==0}\">\n        <td>{{item.nro_item}}</td>\n        <td>{{item.nombre}}</td>\n        <td>{{item.unidad.nombre}}</td>\n        <td class=\"monto\">{{item.cantidad}}</td>\n        <td class=\"warning\">\n          <ng-form name=\"itemPrecio\">\n            <c-input-numeric name=\"precio\" ng-model=\"item.precio_unitario\" class=\"input-precio monto\"\n                             ng-minvalue=\"0.10\" ng-disabled=\"item.estado=='CERRADO'\"\n                             ng-blur=\"$ctrl.registrarPrecioItem(item)\">\n          </c-input-numeric>\n          <ng-form>\n        </td>\n        <td>{{item.precio_unitario | numberToLiteral}}</td>\n        <td class=\"monto\">{{item.precio_unitario? item.cantidad * item.precio_unitario : '' | formatDecimal}}</td>\n        <td ng-if=\"$ctrl.proyecto.cr_precio\">\n          <span ng-if=\"item.cantidad!=item.version_anterior.cantidad\"><input ng-disabled=\"$ctrl.modoVista\" name=\"e_redondeo{{$index}}\" required=\"false\" pattern=\"(^[-]{0,1}0.\\d[\\d]{0,1}$)|^0$\" placeholder=\"0.00\" size=\"2\" ng-model=\"item.cr_precio\" ng-blur=\"$ctrl.cRegularizacion(item)\"></span>\n        </td>\n      </tr>\n    </tbody>\n  </table>\n\n  <div class=\"alert alert-danger\" ng-if=\"!$ctrl.esPresupuestoValido()\">\n    <i class=\"fa fa-times-circle\"></i>\n    <span ng-if=\"!$ctrl.proyecto.monto_total_ejecutado\">El precio total sobrepasa al monto total de convenio del proyecto (<strong>{{$ctrl.proyecto.monto_total_convenio | formatDecimal}}</strong>).</span>\n    <span ng-if=\"$ctrl.proyecto.monto_total_ejecutado\">El precio total sobrepasa al monto total restante del proyecto (<strong>{{$ctrl.proyecto.monto_total_actual-$ctrl.proyecto.monto_total_ejecutado | formatDecimal}}</strong>).</span>\n  </div>\n\n  <div class=\"row\">\n    <div class=\"col-md-3\">\n      Precio Total de Convenio\n    </div>\n    <div class=\"col-md-9\">\n      <strong>{{$ctrl.proyecto.monto_total_convenio | formatDecimal}}</strong>\n    </div>\n    <div class=\"col-md-3\" ng-if=\"$ctrl.proyecto.monto_total_actual && $ctrl.proyecto.monto_total_actual!=$ctrl.proyecto.monto_total_convenio\">\n      Precio Total Modificado\n    </div>\n    <div class=\"col-md-9\" ng-if=\"$ctrl.proyecto.monto_total_actual && $ctrl.proyecto.monto_total_actual!=$ctrl.proyecto.monto_total_convenio\">\n      <strong>{{$ctrl.proyecto.monto_total_actual | formatDecimal}}</strong>\n    </div>\n    <div class=\"col-md-3\" ng-if=\"$ctrl.proyecto.monto_total_ejecutado\">\n      Precio Total Restante\n    </div>\n    <div class=\"col-md-9\" ng-if=\"$ctrl.proyecto.monto_total_ejecutado\">\n      <strong>{{$ctrl.proyecto.monto_total_actual-$ctrl.proyecto.monto_total_ejecutado | formatDecimal}}</strong>\n    </div>\n    <div class=\"col-md-3\">\n      Precio Total (numeral)\n    </div>\n    <div class=\"col-md-9\">\n      <strong>{{$ctrl.precioTotal | formatDecimal}}</strong>\n    </div>\n    <div class=\"col-md-3\">\n      Precio Total (literal)\n    </div>\n    <div class=\"col-md-9\">\n      <strong>{{$ctrl.precioTotal | numberToLiteral}}</strong>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 619 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\n  <div class=\"md-input-group col-md-12\">\n    <c-input name=\"proyecto\" label=\"Poyecto\" ng-model=\"$ctrl.proyecto.nombre\" ng-disabled=\"true\"></c-input>\n  </div>\n  <div class=\"md-input-group col-md-6\">\n    <c-input name=\"codigo\" label=\"Código\" ng-model=\"$ctrl.proyecto.codigo\" ng-disabled=\"true\"></c-input>\n  </div>\n  <div class=\"md-input-group col-md-6\">\n    <c-input name=\"tipo\" label=\"Tipo\" ng-model=\"$ctrl.proyecto.tipo\" ng-disabled=\"true\"></c-input>\n  </div>\n  <div class=\"md-input-group col-md-6\">\n    <c-input name=\"nro_convenio\" label=\"Número de Convenio\" ng-model=\"$ctrl.proyecto.nro_convenio\" ng-disabled=\"true\"></c-input>\n  </div>\n  <div class=\"md-input-group col-md-6\">\n    <c-date name=\"fecha_convenio\" label=\"Fecha del Convenio\" ng-model=\"$ctrl.proyecto.fecha_suscripcion_convenio\" ng-disabled=\"true\"></c-date>\n  </div>\n  <div class=\"md-input-group col-md-6\" ng-if=\"$ctrl.proyecto.estado_proyecto === 'REGISTRO_EMPRESA' || $ctrl.proyecto.estado_proyecto === 'REGISTRO_EMPRESA_CORRECCION'\">\n    <c-input-numeric name=\"monto_total_convenio\" label=\"Monto total de convenio\" ng-model=\"$ctrl.proyecto.monto_total_convenio\" ng-disabled=\"true\"></c-input-numeric>\n  </div>\n  <div class=\"md-input-group col-md-6\" ng-if=\"$ctrl.proyecto.estado_proyecto === 'REGISTRO_EMPRESA' || $ctrl.proyecto.estado_proyecto === 'REGISTRO_EMPRESA_CORRECCION'\">\n    <c-input name=\"plazo_ejecucion_convenio\" label=\"Plazo de ejecución de convenio (días calendario)\" ng-model=\"$ctrl.proyecto.plazo_ejecucion_convenio\" ng-disabled=\"true\"></c-input>\n  </div>\n  <div class=\"md-input-group col-md-6\" ng-if=\"$ctrl.proyecto.estado_proyecto !== 'REGISTRO_EMPRESA' || $ctrl.proyecto.estado_proyecto !== 'REGISTRO_EMPRESA_CORRECCION'\">\n    <c-input-money name=\"monto_total_contrato\" label=\"Monto total\" ng-model=\"$ctrl.proyecto.monto_total\"\n    ng-disabled=\"true\"></c-input-money>\n  </div>\n  <div class=\"md-input-group col-md-6\" ng-if=\"$ctrl.proyecto.estado_proyecto !== 'REGISTRO_EMPRESA' || $ctrl.proyecto.estado_proyecto !== 'REGISTRO_EMPRESA_CORRECCION'\">\n    <c-input-numeric name=\"plazo_ejecucion_contrato\" label=\"Plazo de ejecución (días calendario)\" ng-model=\"$ctrl.proyecto.plazo_ejecucion\"\n    ng-disabled=\"true\"></c-input-numeric>\n  </div>\n\n</div>\n"

/***/ }),
/* 620 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container px-3 computo-proy\">\n\n  <div class=\"row\">\n    <div class=\"col\">\n      <button md-effect type=\"button\" class=\"btn btn-info\" ng-click=\"$ctrl.irItemPosicion('anterior')\" ng-disabled=\"$ctrl.esPrimerItem()\">\n        <i class=\"fa fa-angle-double-left\" aria-hidden=\"true\"></i> Anterior\n      </button>\n      <button md-effect type=\"button\" class=\"btn btn-info\" ng-click=\"$ctrl.irItemPosicion('siguiente')\" ng-disabled=\"$ctrl.esUltimoItem()\">\n        Siguiente <i class=\"fa fa-angle-double-right\" aria-hidden=\"true\"></i>\n      </button>\n    </div>\n    <div class=\"col-md-3 seleccion-planilla mt-2 mb-2\">\n      <ng-form name=\"seleccion\">\n        <c-select name=\"supervisiones\" label=\"Histórico\"\n                  ng-model=\"$ctrl.supervisionHistorica\"\n                  options=\"$ctrl.supervisiones\"\n                  field=\"nombre\"\n                  placeholder=\"Seleccione\"\n                  on-select=\"$ctrl.mostrarDatosSupervision()\">\n        </c-select>\n      </ng-form>\n    </div>\n  </div>\n  <importacion-computos \n    ng-if=\"$ctrl.esEditable\"\n    item=\"$ctrl.item\" \n    idsupervision=\"$ctrl.supervision.id_supervision\" \n    computos=\"$ctrl.computos\" \n    resumen=\"$ctrl.resumen\"\n    \n  ></importacion-computos>\n\n  <h5 class=\"text-center mt-2\">MOD: <strong>{{$ctrl.item.modulo.nombre}}</strong></h5>\n  <h5 class=\"text-center\">Item {{$ctrl.item.nro_item}}: <strong>{{$ctrl.item.nombre}}</strong></h5>\n\n  <h6 class=\"text-right\"> Unidad de medida: <span class=\"unidad-medida\">{{$ctrl.item.unidad.descripcion}}</span></h6>\n\n  <resumen-computos item=\"$ctrl.item\" resumen=\"$ctrl.resumen\"></resumen-computos>\n\n  <computos-metricos item=\"$ctrl.item\"\n                     computos=\"$ctrl.computos\"\n                     copia-computos=\"$ctrl.copiaComputos\"\n                     supervision=\"$ctrl.supervision\"\n                     resumen=\"$ctrl.resumen\"\n                     fotos=\"$ctrl.fotos\"\n                     modo-vista=\"!$ctrl.esEditable\"\n                     ng-if=\"$ctrl.supervisionHistorica.id_supervision\"\n                     existe-cambios=\"$ctrl.existeCambios\"\n                     modificados=\"$ctrl.modificados\"\n                     ng-show=\"$ctrl.puedeVerComputos()\">\n  </computos-metricos>\n\n  <fotos-computos item=\"$ctrl.item\"\n                  supervision=\"$ctrl.supervision\"\n                  fotos=\"$ctrl.fotos\"\n                  modo-vista=\"!$ctrl.esEditable\"\n                  archivado=\"$ctrl.computoFinalizado\"\n                  ng-show=\"$ctrl.puedeVerComputos()\">\n  </fotos-computos>\n\n  <div ng-if=\"!$ctrl.puedeVerComputos()\" class=\"alert alert-warning\">\n    El item no tiene avances para la presente planilla.\n  </div>\n\n  <div class=\"alert alert-success mt-3\" ng-if=\"$ctrl.resumen.cant_faltante == 0\">\n    <i class=\"fa fa-check\"></i>\n    <span>Item completado!</span>\n  </div>\n</div>\n"

/***/ }),
/* 621 */
/***/ (function(module, exports) {

	module.exports = "<ng-form name=\"form_computo\" >\n  <div class=\"form-computo\" style=\"font-size:0.9em;\">\n    <div class=\"table-responsive\">\n      <table class=\"table table-striped mod-t text-right\">\n        <thead>\n          <tr>\n            <th class=\"text-left bb-0\">\n              <button type=\"button\" md-effect class=\"btn btn-primary btn-sm\" ng-click=\"$ctrl.addRow()\" uib-tooltip=\"Agregar fila\" ng-if=\"!$ctrl.modoVista && $ctrl.item.unidad_medida !== 'UN_GLOBAL'\">\n                <i class=\"fa fa-plus\"></i>\n              </button>\n              <button type=\"button\" md-effect class=\"btn btn-info btn-sm\" ng-click=\"$ctrl.addSubtitulo()\" uib-tooltip=\"Agregar subtítulo\" ng-if=\"!$ctrl.modoVista && $ctrl.item.unidad_medida !== 'UN_GLOBAL'\">\n                <i class=\"fa fa-list\"></i>\n              </button>\n            </th>\n            <th rowspan=\"2\" ng-class=\"{'th-req':$ctrl.conf.cantidad.required}\">Nro. de veces</th>\n            <th rowspan=\"2\" ng-class=\"{'th-req':$ctrl.conf.factor_forma.required}\" title=\"Factor de forma\">Factor de Forma</th>\n            <th colspan=\"4\" class=\"text-center\">DIMENSIONES</th>\n            <th colspan=\"2\" class=\"bb-0\">\n              <button type=\"button\" md-effect class=\"btn btn-success btn-sm\" ng-click=\"$ctrl.saveAllRow()\" uib-tooltip=\"Guardar todo\" ng-if=\"!$ctrl.modoVista\">\n                <i class=\"fa fa-save\"></i>\n              </button>\n              <button type=\"button\" md-effect class=\"btn btn-danger btn-sm\" ng-click=\"$ctrl.deleteAllRow()\" uib-tooltip=\"Eliminar todo\" ng-if=\"!$ctrl.modoVista\">\n                <i class=\"fa fa-trash\"></i>\n              </button>\n              <button type=\"button\" md-effect class=\"btn btn-info btn-sm\" uib-tooltip=\"Descargar especificaciones técnicas del item\"\n              download-file=\"{{$ctrl.descargaEsp.url}}\" file-name=\"{{$ctrl.descargaEsp.nombre}}\" ng-if=\"$ctrl.item.especificaciones\">\n                <i class=\"fa fa-download\"></i>\n              </button>\n            </th>\n          </tr>\n          <tr>\n            <th ng-class=\"{'th-req':$ctrl.conf.descripcion.required}\" class=\"text-left\">Descripción</th>\n            <th ng-class=\"{'th-req':$ctrl.conf.largo.required}\">{{ ['UN_HORA','UN_JUEGO','UN_LITRO','UN_KILOGRAMO','UN_TONELADA','UN_TRAMO','UN_HORA*DIA','UN_METRO_CUAD*MES','UN_VEHICULO*MES'].indexOf($ctrl.item.unidad_medida)>=0? 'Cantidad':'Largo [ml]'}}</th>\n            <th ng-class=\"{'th-req':$ctrl.conf.ancho.required}\">Ancho [ml]</th>\n            <th ng-class=\"{'th-req':$ctrl.conf.alto.required}\">Alto [ml]</th>\n            <th ng-class=\"{'th-req':$ctrl.conf.area.required}\">{{ ['UN_METRO_CUB','UN_DECIMETRO_CUB','UN_METRO_CUB*KM'].indexOf($ctrl.item.unidad_medida)>=0? 'Volumen [m3]':'Área [m2]'}} </th>\n            <th ng-class=\"{'th-req':$ctrl.conf.cantidad_parcial.required}\" title=\"Cantidad Parcial\">C.P.</th>\n            <th ng-if=\"!$ctrl.modoVista\"></th>\n          </tr>\n        </thead>\n        <tbody>\n          <tr ng-repeat=\"com in $ctrl.computos\" ng-click=\"$ctrl.setIndexSubtitulo($index)\">\n            <td class=\"subtitulo\" ng-if=\"com.isSubtitulo\" colspan=\"15\">\n              <div class=\"row mx-0\">\n                <div class=\"col subtitulo\">\n                  <c-input name=\"descripcion_{{$index}}\"\n                      ng-model=\"com.descripcion\"\n                      title=\"{{com.descripcion}}\"\n                      ng-disabled=\"!!$ctrl.modoVista\">\n                  </c-input>\n                </div>\n                <div class=\"actions\" ng-if=\"!$ctrl.modoVista\">\n                  <i class=\"fa fa-arrow-up\" ng-click=\"$ctrl.moveSubtitulo('up',$index)\" uib-tooltip=\"Mover fila arriba\"></i>\n                  <i class=\"fa fa-arrow-down\" ng-click=\"$ctrl.moveSubtitulo('down',$index)\" uib-tooltip=\"Mover fila abajo\"></i>\n                  <i class=\"fa fa-save text-success\" ng-click=\"$ctrl.saveSubtitulo(com, $index)\" uib-tooltip=\"Guardar subtítulo\"></i>\n                  <i class=\"fa fa-trash text-danger\" ng-click=\"$ctrl.deleteSubtitulo(com, $index)\" uib-tooltip=\"Eliminar subtítulo\"></i>\n                </div>\n              </div>\n            </td>\n            <td ng-if=\"!com.isSubtitulo\" class=\"text-left\">\n              <c-input name=\"descripcion_{{$index}}\"\n                  ng-model=\"com.descripcion\"\n                  ng-disabled=\"$ctrl.conf.descripcion.disabled || $ctrl.modoVista\"\n                  ng-required=\"$ctrl.conf.descripcion.required\"\n                  title=\"{{com.descripcion}}\"\n                  >\n              </c-input>\n            </td>\n            <td ng-if=\"!com.isSubtitulo\" ng-disabled=\"$ctrl.conf.cantidad.disabled\" >\n              <c-input-numeric name=\"cantidad_{{$index}}\"\n                        ng-model=\"com.cantidad\"\n                        ng-disabled=\"$ctrl.conf.cantidad.disabled || $ctrl.modoVista\"\n                        ng-required=\"$ctrl.conf.cantidad.required\"\n                        ng-decimals=\"0\"\n                        ng-not-number=\"0\"\n                        ng-number-default=\"1\"\n                        ng-blur=\"$ctrl.changeComputo(com)\"\n                        >\n              </c-input-numeric>\n            </td>\n            <td ng-if=\"!com.isSubtitulo\" ng-disabled=\"$ctrl.conf.factor_forma.disabled\" >\n              <c-input-numeric name=\"factor_forma_{{$index}}\"\n                        ng-model=\"com.factor_forma\"\n                        ng-disabled=\"$ctrl.conf.factor_forma.disabled || $ctrl.modoVista\"\n                        ng-required=\"$ctrl.conf.factor_forma.required\"\n                        ng-blur=\"$ctrl.changeComputo(com)\"\n                        ng-decimals-dinamic=\"true\"\n                        ng-max-decimals=\"6\"\n                        ng-not-number=\"0\"\n                        ng-number-default=\"1\"\n                        >\n              </c-input-numeric>\n            </td>\n            <td ng-if=\"!com.isSubtitulo\" ng-disabled=\"$ctrl.conf.largo.disabled\" >\n              <c-input-numeric name=\"largo_{{$index}}\"\n                        ng-model=\"com.largo\"\n                        ng-disabled=\"$ctrl.conf.largo.disabled || $ctrl.modoVista\"\n                        ng-required=\"$ctrl.conf.largo.required\"\n                        ng-decimals=\"2\"\n                        ng-minvalue=\"0.01\"\n                        ng-not-number=\"0\"\n                        ng-number-default=\"1\"\n                        ng-blur=\"$ctrl.changeComputo(com)\"\n                        >\n              </c-input-numeric>\n            </td>\n            <td ng-if=\"!com.isSubtitulo\" ng-disabled=\"$ctrl.conf.ancho.disabled\" >\n              <c-input-numeric name=\"ancho_{{$index}}\"\n                        ng-model=\"com.ancho\"\n                        ng-disabled=\"$ctrl.conf.ancho.disabled || $ctrl.modoVista\"\n                        ng-required=\"$ctrl.conf.ancho.required\"\n                        ng-decimals=\"2\"\n                        ng-minvalue=\"0.01\"\n                        ng-not-number=\"0\"\n                        ng-number-default=\"1\"\n                        ng-blur=\"$ctrl.changeComputo(com)\"\n                        >\n              </c-input-numeric>\n            </td>\n            <td ng-if=\"!com.isSubtitulo\" ng-disabled=\"$ctrl.conf.alto.disabled\" >\n              <c-input-numeric name=\"alto_{{$index}}\"\n                        ng-model=\"com.alto\"\n                        ng-disabled=\"$ctrl.conf.alto.disabled || $ctrl.modoVista\"\n                        ng-required=\"$ctrl.conf.alto.required\"\n                        ng-decimals=\"2\"\n                        ng-minvalue=\"0.01\"\n                        ng-not-number=\"0\"\n                        ng-number-default=\"1\"\n                        ng-blur=\"$ctrl.changeComputo(com)\"\n                        >\n              </c-input-numeric>\n            </td>\n            <td ng-if=\"!com.isSubtitulo\" ng-disabled=\"$ctrl.conf.area.disabled\" ng-class=\"$ctrl.conf.area.class\">\n              <c-input-numeric name=\"area_{{$index}}\"\n                        ng-model=\"com.area\"\n                        ng-disabled=\"$ctrl.conf.area.disabled\"\n                        ng-required=\"$ctrl.conf.area.required\"\n                        ng-decimals=\"2\"\n                        ng-class=\"$ctrl.conf.area.class\"\n                        >\n              </c-input-numeric>\n            </td>\n            <td ng-if=\"!com.isSubtitulo\" ng-disabled=\"$ctrl.conf.cantidad_parcial.disabled\" ng-class=\"$ctrl.conf.cantidad_parcial.class\">\n              <c-input-numeric name=\"cantidad_parcial_{{$index}}\"\n                        ng-model=\"com.cantidad_parcial\"\n                        ng-disabled=\"$ctrl.conf.cantidad_parcial.disabled\"\n                        ng-required=\"$ctrl.conf.cantidad_parcial.required\"\n                        ng-decimals=\"2\"\n                        ng-class=\"$ctrl.conf.cantidad_parcial.class\">\n              </c-input-numeric>\n            </td>\n            <td ng-if=\"!com.isSubtitulo && !$ctrl.modoVista\" class=\"text-center\">\n              <div class=\"actions\">\n                <i class=\"fa fa-save text-success\" ng-click=\"$ctrl.saveRow(com, $index)\" uib-tooltip=\"Guardar fila\"></i>\n                <i class=\"fa fa-trash text-danger\" ng-click=\"$ctrl.deleteRow(com, $index)\" uib-tooltip=\"Eliminar fila\"></i>\n              </div>\n            </td>\n          </tr>\n        </tbody>\n        <tfoot>\n          <tr ng-if=\"$ctrl.computos.length>10\">\n            <th ng-class=\"{'th-req':$ctrl.conf.descripcion.required}\" class=\"text-left\">Descripción</th>\n            <th ng-class=\"{'th-req':$ctrl.conf.cantidad.required}\">Nro. de veces</th>\n            <th ng-class=\"{'th-req':$ctrl.conf.factor_forma.required}\" title=\"Factor de forma\">Factor de Forma</th>\n            <th ng-class=\"{'th-req':$ctrl.conf.largo.required}\">{{ ['UN_LITRO','UN_KILOGRAMO','UN_TONELADA','UN_TRAMO','UN_HORA*DIA','UN_METRO_CUAD*MES','UN_VEHICULO*MES'].indexOf($ctrl.item.unidad_medida)>=0? 'Cantidad':'Largo [ml]'}}</th>\n            <th ng-class=\"{'th-req':$ctrl.conf.ancho.required}\">Ancho [ml]</th>\n            <th ng-class=\"{'th-req':$ctrl.conf.alto.required}\">Alto [ml]</th>\n            <th ng-class=\"{'th-req':$ctrl.conf.area.required}\">{{ ['UN_METRO_CUB','UN_DECIMETRO_CUB','UN_METRO_CUB*KM'].indexOf($ctrl.item.unidad_medida)>=0? 'Volumen [m3]':'Área [m2]'}} </th>\n            <th ng-class=\"{'th-req':$ctrl.conf.cantidad_parcial.required}\" title=\"Cantidad Parcial\">C.P.</th>\n            <th ng-if=\"!$ctrl.modoVista\"></th>\n          </tr>\n          <tr ng-if=\"$ctrl.computos.length>10\">\n            <th class=\"text-left bb-0\">\n              <button type=\"button\" md-effect class=\"btn btn-primary btn-sm\" ng-click=\"$ctrl.addRow()\" uib-tooltip=\"Agregar fila\" ng-if=\"!$ctrl.modoVista && $ctrl.item.unidad_medida !== 'UN_GLOBAL'\">\n                <i class=\"fa fa-plus\"></i>\n              </button>\n              <button type=\"button\" md-effect class=\"btn btn-info btn-sm\" ng-click=\"$ctrl.addSubtitulo()\" uib-tooltip=\"Agregar subtítulo\" ng-if=\"!$ctrl.modoVista && $ctrl.item.unidad_medida !== 'UN_GLOBAL'\">\n                <i class=\"fa fa-list\"></i>\n              </button>\n            </th>\n            <th colspan=\"2\">&nbsp;</th>\n            <th colspan=\"4\" class=\"text-center\">DIMENSIONES</th>\n            <th colspan=\"2\" class=\"bb-0\">\n              <button type=\"button\" md-effect class=\"btn btn-success btn-sm\" ng-click=\"$ctrl.saveAllRow()\" uib-tooltip=\"Guardar todo\" ng-if=\"!$ctrl.modoVista\">\n                <i class=\"fa fa-save\"></i>\n              </button>\n              <button type=\"button\" md-effect class=\"btn btn-danger btn-sm\" ng-click=\"$ctrl.deleteAllRow()\" uib-tooltip=\"Eliminar todo\" ng-if=\"!$ctrl.modoVista\">\n                <i class=\"fa fa-trash\"></i>\n              </button>\n              <button type=\"button\" md-effect class=\"btn btn-info btn-sm\" uib-tooltip=\"Descargar especificaciones técnicas del item\"\n              download-file=\"{{$ctrl.descargaEsp.url}}\" file-name=\"{{$ctrl.descargaEsp.nombre}}\" ng-if=\"$ctrl.item.especificaciones\">\n                <i class=\"fa fa-download\"></i>\n              </button>\n            </th>\n          </tr>\n          <tr ng-class=\"{'error' : $ctrl.resumen.total_actual < 0 || $ctrl.resumen.total_actual > $ctrl.item.cantidad}\">\n            <th colspan=\"7\">Total</th>\n            <td class=\"align-middle\">{{$ctrl.resumen.total_actual | number:2}}</td>\n          </tr>\n        </tfoot>\n      </table>\n\n      <div class=\"alert alert-danger\" ng-if=\"$ctrl.resumen.total_actual < 0 || $ctrl.resumen.total_actual > $ctrl.item.cantidad\">\n        <i class=\"fa fa-times-circle\"></i>\n        <span ng-if=\"$ctrl.resumen.total_actual < 0\">La cantidad ejecutada no puede ser negativa.</span>\n        <span ng-if=\"$ctrl.resumen.total_actual > $ctrl.item.cantidad\">La cantidad ejecutada no puede ser mayor a la cantidad contractual.</span>\n      </div>\n    </div>\n  </div>\n\n</ng-form>\n"

/***/ }),
/* 622 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row images\">\n  <div class=\"col-md-4\">\n    <section class=\"image\">\n        <figure ng-if=\"$ctrl.fotos.foto1.show\">\n            <div class=\"row mx-0\">\n              <div class=\"col-md\">Foto 1: {{$ctrl.fotos.foto1.nombre}}</div>\n              <div class=\"actions\">\n                <i class=\"fa fa-eye text-success\" ng-click=\"$ctrl.showImage('foto1')\" uib-tooltip=\"Ver/Ocultar imagen\"></i>\n                <i class=\"fa fa-exchange\" ng-click=\"$ctrl.changeImage('foto1')\" uib-tooltip=\"Cambiar imagen\" ng-if=\"!$ctrl.modoVista\"></i>\n              </div>\n            </div>\n            <div ng-show=\"$ctrl.fotos.foto1.showImage\">\n              <img ng-src=\"data:image/jpg;base64, {{ $ctrl.fotos.foto1.base64 }}\" alt=\"Foto 1\" ng-click=\"$ctrl.vistaImagen($ctrl.fotos.foto1)\">\n            </div>\n        </figure>\n        <div ng-if=\"!$ctrl.fotos.foto1.show && !$ctrl.archivado && !$ctrl.modoVista\">\n            <ui-input-file name=\"foto1\" label=\"Foto 1\" file-base64=\"$ctrl.fotos.foto1\" upload-callback=\"$ctrl.fotos.uploadCallback\"\n                  types=\"jpg, png, jpeg\" mime-types=\"image/*\" maxfiles=\"1\" maxsize=\"20MB\"></ui-input-file>\n        </div>\n    </section>\n  </div>\n  <div class=\"col-md-4\">\n    <section class=\"image\">\n        <figure ng-if=\"$ctrl.fotos.foto2.show\">\n            <div class=\"row mx-0\">\n              <div class=\"col-md\">Foto 2: {{$ctrl.fotos.foto2.nombre}}</div>\n              <div class=\"actions\">\n                <i class=\"fa fa-eye text-success\" ng-click=\"$ctrl.showImage('foto2')\" uib-tooltip=\"Ver/Ocultar imagen\"></i>\n                <i class=\"fa fa-exchange\" ng-click=\"$ctrl.changeImage('foto2')\" uib-tooltip=\"Cambiar imagen\" ng-if=\"!$ctrl.modoVista\"></i>\n              </div>\n            </div>\n            <div ng-show=\"$ctrl.fotos.foto2.showImage\">\n              <img ng-src=\"data:image/jpg;base64, {{ $ctrl.fotos.foto2.base64 }}\" alt=\"Foto 2\" ng-click=\"$ctrl.vistaImagen($ctrl.fotos.foto2)\">\n            </div>\n        </figure>\n        <div ng-if=\"!$ctrl.fotos.foto2.show && !$ctrl.archivado && !$ctrl.modoVista\">\n            <ui-input-file name=\"foto2\" label=\"Foto 2\" file-base64=\"$ctrl.fotos.foto2\" upload-callback=\"$ctrl.fotos.uploadCallback\"\n                  types=\"jpg, png, jpeg\" mime-types=\"image/*\" maxfiles=\"1\" maxsize=\"20MB\"></ui-input-file>\n        </div>\n    </section>\n  </div>\n  <div class=\"col-md-4\">\n    <section class=\"image\">\n        <figure ng-if=\"$ctrl.fotos.foto3.show\">\n            <div class=\"row mx-0\">\n              <div class=\"col-md\">Foto 3: {{$ctrl.fotos.foto3.nombre}}</div>\n              <div class=\"actions\">\n                <i class=\"fa fa-eye text-success\" ng-click=\"$ctrl.showImage('foto3')\" uib-tooltip=\"Ver/Ocultar imagen\"></i>\n                <i class=\"fa fa-exchange\" ng-click=\"$ctrl.changeImage('foto3')\" uib-tooltip=\"Cambiar imagen\" ng-if=\"!$ctrl.modoVista\"></i>\n              </div>\n            </div>\n            <div ng-show=\"$ctrl.fotos.foto3.showImage\">\n              <img ng-src=\"data:image/jpg;base64, {{ $ctrl.fotos.foto3.base64 }}\" alt=\"Foto 3\" ng-click=\"$ctrl.vistaImagen($ctrl.fotos.foto3)\">\n            </div>\n        </figure>\n        <div ng-if=\"!$ctrl.fotos.foto3.show && !$ctrl.archivado && !$ctrl.modoVista\">\n            <ui-input-file name=\"foto3\" label=\"Foto 3\" file-base64=\"$ctrl.fotos.foto3\" upload-callback=\"$ctrl.fotos.uploadCallback\"\n                  types=\"jpg, png, jpeg\" mime-types=\"image/*\" maxfiles=\"1\" maxsize=\"20MB\"></ui-input-file>\n        </div>\n    </section>\n  </div>\n</div>\n<div class=\"row images\">\n  <div class=\"col\">\n    <section class=\"image\">\n        <figure ng-if=\"$ctrl.fotos.plano.show\">\n            <div class=\"row mx-0\">\n              <div class=\"col-md\">Plano/Factor de forma: {{$ctrl.fotos.plano.nombre}}</div>\n              <div class=\"actions\">\n                <i class=\"fa fa-eye text-success\" ng-click=\"$ctrl.showImage('plano')\" uib-tooltip=\"Ver/Ocultar imagen\"></i>\n                <i class=\"fa fa-exchange\" ng-click=\"$ctrl.changeImage('plano')\" uib-tooltip=\"Cambiar imagen\" ng-if=\"!$ctrl.modoVista\"></i>\n              </div>\n            </div>\n            <div ng-show=\"$ctrl.fotos.plano.showImage\">\n              <div id=\"documento\" ng-if=\"$ctrl.fotos.plano.showImage && $ctrl.fotos.plano.nombre.indexOf('.pdf')>0\">\n                <archivo name=\"plano\" label=\"Plano/Factor de Forma\" ng-model=\"$ctrl.fotos.plano\"\n                        types=\"pdf\" mime-types=\".pdf\" maxsize=\"20MB\"\n                        url=\"{{$ctrl.urlViewBase64}}\"\n                        url-descarga=\"{{$ctrl.urlDownloadBase64}}\"\n                        modo-vista=\"true\">\n                </archivo>\n                <!-- <div class=\"opciones\">\n                  <button md-effect type=\"button\" class=\"btn btn-success btn-sm\" uib-tooltip=\"Ver documento\" ng-click=\"$ctrl.vistaPrevia()\" ng-if=\"true\">\n                    <i class=\"fa fa-eye\"></i>\n                  </button>\n                  <button md-effect type=\"button\" class=\"btn btn-primary btn-sm\" uib-tooltip=\"Descargar\"\n                          download-file=\"{{$ctrl.urlDownloadBase64}}\" file-name=\"{{$ctrl.fotos.plano.nombre}}\" ng-if=\"true\">\n                    <i class=\"fa fa-download\"></i>\n                  </button>\n                  <button md-effect type=\"button\" class=\"btn btn-info btn-sm\" uib-tooltip=\"Cambiar\" ng-if=\"false\" ng-click=\"$ctrl.cargarArchivo = true\">\n                    <i class=\"fa fa-exchange\"></i>\n                  </button>\n                </div>\n                <img src=\"./images/documento.jpg\" alt=\"Documento\">\n                <div class=\"detalles\">\n                  <div class=\"nombre\">Plano/Factor de forma: {{$ctrl.fotos.plano.nombre}}</div>\n                </div> -->\n              </div>\n              <img ng-if=\"$ctrl.fotos.plano.nombre.indexOf('.pdf')<0\" ng-src=\"data:image/jpg;base64, {{ $ctrl.fotos.plano.base64 }}\" alt=\"Plano\" ng-click=\"$ctrl.vistaImagen($ctrl.fotos.plano)\">\n            </div>\n        </figure>\n        <div ng-if=\"!$ctrl.fotos.plano.show && !$ctrl.archivado && !$ctrl.modoVista\">\n            <ui-input-file name=\"plano\" label=\"Plano/Factor de Forma\" file-base64=\"$ctrl.fotos.plano\" upload-callback=\"$ctrl.fotos.uploadCallback\"\n                  types=\"pdf, jpg, png, jpeg\" mime-types=\"image/*,.pdf\" maxfiles=\"1\" maxsize=\"20MB\"></ui-input-file>\n        </div>\n    </section>\n  </div>\n</div>\n"

/***/ }),
/* 623 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\" style=\"font-size: 0.9em\">\n  <div class=\"col-md-6\">\n    <div class=\"ayuda-form-computo\">\n      <ul\n        class=\"pl-0\"\n        ng-show=\"['UN_UNID','UN_KIT','UN_ROLLO','UN_TUBO','UN_EQUIPO','UN_HOYO','UN_GLOBAL','UN_PIEZA','UN_PUNTO'].indexOf($ctrl.item.unidad_medida)>=0\"\n      >\n        <li>Los campos con <span class=\"th-req\">(</span>) son requeridos</li>\n        <li>\n          La cantidad parcial para item\n          <strong>{{$ctrl.item.unidad.nombre | uppercase}}</strong> será:\n          <strong>C.P. = Nro_de_veces </strong>\n        </li>\n      </ul>\n      <ul\n        class=\"pl-0\"\n        ng-show=\"['UN_HORA','UN_JUEGO','UN_LITRO','UN_KILOGRAMO','UN_TONELADA','UN_HORA*DIA','UN_METRO_CUAD*MES','UN_VEHICULO*MES','TRAMO'].indexOf($ctrl.item.unidad_medida)>=0\"\n      >\n        <li>Los campos con <span class=\"th-req\">(</span>) son requeridos</li>\n        <li>\n          La cantidad parcial para item\n          <strong>{{$ctrl.item.unidad.nombre | uppercase}}</strong> será:\n          <strong>C.P. = Nro_de_veces * cantidad</strong>\n        </li>\n      </ul>\n      <ul\n        class=\"pl-0\"\n        ng-show=\"['UN_METRO','UN_KILOMETRO'].indexOf($ctrl.item.unidad_medida)>=0\"\n      >\n        <li>Los campos con <span class=\"th-req\">(</span>) son requeridos</li>\n        <li>\n          La cantidad parcial para item\n          <strong>{{$ctrl.item.unidad.nombre | uppercase}}</strong> será:\n          <strong>C.P. = Nro_de_veces * largo </strong>\n        </li>\n      </ul>\n      <ul\n        class=\"pl-0\"\n        ng-show=\"['UN_METRO_CUAD','UN_PIE_CUAD','UN_HECTAREA'].indexOf($ctrl.item.unidad_medida)>=0\"\n      >\n        <li>Los campos con <span class=\"th-req\">(</span>) son requeridos</li>\n        <li>\n          El área será: <strong>Area = factor_forma * largo * alto</strong>\n        </li>\n        <li>\n          La cantidad parcial para item\n          <strong>{{$ctrl.item.unidad.nombre | uppercase}}</strong> será:\n          <strong>C.P. = Nro_de_veces * factor_forma * largo * alto </strong>\n        </li>\n      </ul>\n      <ul\n        class=\"pl-0\"\n        ng-show=\"['UN_METRO_CUB','UN_DECIMETRO_CUB','UN_METRO_CUB*KM'].indexOf($ctrl.item.unidad_medida)>=0\"\n      >\n        <li>Los campos con <span class=\"th-req\">(</span>) son requeridos</li>\n        <li>\n          El volumen será:\n          <strong> Volumen = factor_forma * largo * ancho * alto</strong>\n        </li>\n        <li>\n          La cantidad parcial para item\n          <strong>{{$ctrl.item.unidad.nombre | uppercase}}</strong> será:\n          <strong\n            >C.P. = Nro_de_veces * factor_forma * largo * ancho * alto\n          </strong>\n        </li>\n      </ul>\n    </div>\n  </div>\n  <div class=\"col-md-6\">\n    <table class=\"table table-striped mod-t table-responsive\">\n      <tbody>\n        <tr>\n          <th rowspan=\"2\" class=\"text-center\">RESUMEN</th>\n          <td class=\"text-right\">Cantidad Contractual</td>\n          <td class=\"text-right\">Cantidad Ejecutada</td>\n          <td class=\"text-right\">Cantidad Faltante</td>\n        </tr>\n        <tr>\n          <td class=\"text-right\">{{$ctrl.item.cantidad | number:2}}</td>\n          <td\n            class=\"text-right\"\n            ng-class=\"{'error' : $ctrl.resumen.cant_ejecutada < 0 || $ctrl.resumen.cant_ejecutada > $ctrl.item.cantidad}\"\n          >\n            <span\n              uib-tooltip=\"{{$ctrl.resumen.cant_ejecutada < 0? 'La cantidad ejecutada no puede ser negativa' : $ctrl.resumen.cant_ejecutada > $ctrl.item.cantidad? 'La cantidad ejecutada no puede ser mayor a la cantidad contractual.' : ''}}\"\n              tooltip-is-open=\"$ctrl.resumen.cant_ejecutada < 0 || $ctrl.resumen.cant_ejecutada > $ctrl.item.cantidad\"\n              tooltip-enable=\"$ctrl.resumen.cant_ejecutada < 0 || $ctrl.resumen.cant_ejecutada > $ctrl.item.cantidad\"\n              >{{$ctrl.resumen.cant_ejecutada | number:2}}</span\n            >\n          </td>\n          <td class=\"text-right\">{{$ctrl.resumen.cant_faltante | number:2}}</td>\n        </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n"

/***/ }),
/* 624 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\">\n    <i class=\"fa fa-bell\"></i> Confirmación previa a la generación de\n    formularios\n  </h5>\n  <button\n    type=\"button\"\n    class=\"close\"\n    data-dismiss=\"modal\"\n    ng-click=\"$ctrl.cerrar()\"\n  >\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<div class=\"modal-body\">\n  <p>\n    ¿Está seguro/a de proceder con la generación de los formularios?. Este\n    procedimiento se realiza por única vez, sin opción a modificaciones\n    posteriores.\n  </p>\n\n  <p>\n    Se le recuerda que el monto total del proyecto (definido en su presupuesto)\n    es <strong>{{$ctrl.proyecto.monto_total | formatDecimal}}</strong> (<strong\n      ><em>{{$ctrl.proyecto.monto_total | numberToLiteral}}</em></strong\n    >)\n  </p>\n\n  <!-- <div class=\"alert alert-info\">\n    <i class=\"fa fa-info-circle\"></i>\n    <span>Ingrese el <strong>número de días de la propuesta</strong>, tome en cuenta que <strong>no debe sobrepasar</strong> al plazo de ejecución definido en el convenio que son\n      <strong>{{$ctrl.proyecto.plazo_ejecucion_convenio}} días</strong>.</span>\n  </div> -->\n  <div class=\"alert alert-info\">\n    <i class=\"fa fa-info-circle\"></i>\n    <span\n      >Ingrese el\n      <strong\n        >número de días de la ejecución del proyecto establecido en la\n        propuesta</strong\n      >, tome en cuenta que <strong>no debe sobrepasar</strong> al plazo de\n      ejecución definido en el convenio .</span\n    >\n  </div>\n\n  <ng-form name=\"formPlazo\">\n    <div class=\"row\">\n      <div class=\"col-md-12\">\n        <c-input-numeric\n          name=\"plazo_ejecucion\"\n          label=\"Plazo de Ejecución\"\n          ng-model=\"$ctrl.proyecto.plazo_ejecucion\"\n          ng-decimals=\"0\"\n          ng-minvalue=\"1\"\n          ng-maxvalue=\"{{$ctrl.proyecto.plazo_ejecucion_convenio}}\"\n          ng-required=\"true\"\n        >\n        </c-input-numeric>\n      </div>\n    </div>\n  </ng-form>\n\n  <small\n    ><em\n      >NOTA.- El plazo de ejecución define el tiempo de duración del\n      proyecto.</em\n    ></small\n  >\n</div>\n<div class=\"modal-footer\">\n  <button\n    type=\"button\"\n    md-effect\n    class=\"btn btn-secondary\"\n    ng-click=\"$ctrl.cerrar()\"\n  >\n    <i class=\"fa fa-close\"></i> Cancelar\n  </button>\n  <button\n    type=\"submit\"\n    md-effect\n    class=\"btn btn-primary\"\n    validar-formulario=\"formPlazo\"\n    ng-click=\"$ctrl.aceptar()\"\n  >\n    <i class=\"fa fa-check\"></i> Si, estoy seguro/a\n  </button>\n</div>\n"

/***/ }),
/* 625 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <h2 class=\"page-title\"><i class=\"fa fa-bars\"></i> Proyecto Adjudicado</h2>\n  <div class=\"card\">\n    <div class=\"card-body\">\n      <button\n        md-effect\n        type=\"button\"\n        class=\"btn btn-info\"\n        ng-click=\"$ctrl.anterior()\"\n        ng-disabled=\"$ctrl.WizardHandler.wizard().currentStepNumber() === 1\"\n      >\n        <i class=\"fa fa-angle-double-left\" aria-hidden=\"true\"></i> Anterior\n      </button>\n\n      <button\n        md-effect\n        type=\"button\"\n        class=\"btn btn-info\"\n        ng-click=\"$ctrl.ejecutarAccionPaso()\"\n        ng-disabled=\"$ctrl.WizardHandler.wizard().currentStepNumber() === $ctrl.WizardHandler.wizard().totalStepCount()\"\n        validar-formulario=\"formDatosEmpresa\"\n      >\n        Siguiente <i class=\"fa fa-angle-double-right\" aria-hidden=\"true\"></i>\n      </button>\n\n      <ejecutar-transicion\n        elemento=\"$ctrl.proyecto\"\n        servicio=\"$ctrl.Proyecto\"\n        atributo-estado=\"estado_proyecto\"\n        metodo-previo=\"$ctrl.confirmacionGeneracion()\"\n        metodo-posterior=\"refrescar-documentacion-proyecto\"\n        url=\"$ctrl.urlProyectos\"\n        ng-if=\"$ctrl.existeFormulario() && $ctrl.esModoEdicion\"\n      >\n      </ejecutar-transicion>\n      <ng-form name=\"formDatosEmpresa\">\n        <wizard\n          indicators-position=\"top\"\n          edit-mode=\"$ctrl.esDocumentacionCompleta()\"\n          ng-if=\"$ctrl.proyecto\"\n        >\n          <wz-step wz-title=\"Proyecto\">\n            <proyecto-adjudicado\n              proyecto=\"$ctrl.proyecto\"\n            ></proyecto-adjudicado>\n            <codigo-contrato\n              proyecto=\"$ctrl.proyecto\"\n              modo-vista=\"!$ctrl.esModoEdicion\"\n              tiene-documentacion=\"$ctrl.tieneDocumentacion\"\n              codigo-documentacion=\"$ctrl.codigoDocumentoProy\"\n            >\n            </codigo-contrato>\n          </wz-step>\n\n          <wz-step\n            wz-title=\"{{$ctrl.esEmpresa?'Empresa':'Asociación'}}\"\n            ng-if=\"$ctrl.esModoEdicion\"\n            wz-disabled=\"{{!$ctrl.esModoEdicion}}\"\n          >\n            <datos-empresa\n              empresa=\"$ctrl.proyecto.documentacion_exp.datos_empresa\"\n              ng-if=\"$ctrl.proyecto.documentacion_exp && $ctrl.esEmpresa\"\n            ></datos-empresa>\n            <datos-asociacion\n              empresa=\"$ctrl.proyecto.documentacion_exp.datos_empresa\"\n              asociacion=\"$ctrl.proyecto.documentacion_exp.datos_asociacion\"\n              ng-if=\"$ctrl.proyecto.documentacion_exp && !$ctrl.esEmpresa\"\n            ></datos-asociacion>\n          </wz-step>\n\n          <wz-step\n            wz-title=\"Integrantes\"\n            wz-disabled=\"{{($ctrl.esEmpresa || !$ctrl.esModoEdicion)}}\"\n          >\n            <datos-integrantes\n              integrantes=\"$ctrl.proyecto.documentacion_exp.datos_asociacion\"\n            ></datos-integrantes>\n          </wz-step>\n\n          <!-- <wz-step wz-title=\"Experiencia\" ng-if=\"$ctrl.esModoEdicion\" wz-disabled=\"{{!$ctrl.esModoEdicion}}\">\n          <experiencia-empresa experiencias=\"$ctrl.proyecto.documentacion_exp.experiencias\" ng-if=\"$ctrl.proyecto.documentacion_exp\"></experiencia-empresa>\n        </wz-step> -->\n\n          <!-- <wz-step wz-title=\"Empleados\" ng-if=\"$ctrl.esModoEdicion\" wz-disabled=\"{{!$ctrl.esModoEdicion}}\">\n          <empleados empleados=\"$ctrl.proyecto.documentacion_exp.empleados\" ng-if=\"$ctrl.proyecto.documentacion_exp\"></empleados>\n        </wz-step> -->\n\n          <!-- <wz-step wz-title=\"Equipo\" ng-if=\"$ctrl.esModoEdicion\" wz-disabled=\"{{!$ctrl.esModoEdicion}}\">\n          <equipo-minimo equipo=\"$ctrl.proyecto.documentacion_exp.equipos_trabajo\" ng-if=\"$ctrl.proyecto.documentacion_exp\"></equipo-minimo>\n        </wz-step> -->\n\n          <wz-step\n            wz-title=\"Presupuesto\"\n            ng-if=\"$ctrl.esModoEdicion\"\n            wz-disabled=\"{{!$ctrl.esModoEdicion}}\"\n          >\n            <presupuesto-items\n              proyecto=\"$ctrl.proyecto\"\n              ng-if=\"$ctrl.proyecto.documentacion_exp\"\n            ></presupuesto-items>\n          </wz-step>\n\n          <wz-step\n            wz-title=\"Cronogramas\"\n            ng-if=\"$ctrl.esModoEdicion\"\n            wz-disabled=\"{{!$ctrl.esModoEdicion}}\"\n          >\n            <cronogramas\n              proyecto=\"$ctrl.proyecto\"\n              ng-if=\"$ctrl.proyecto.documentacion_exp\"\n            ></cronogramas>\n          </wz-step>\n\n          <wz-step\n            wz-title=\"Formularios\"\n            ng-if=\"!$ctrl.esModoEdicion\"\n            wz-disabled=\"{{$ctrl.esModoEdicion}}\"\n          >\n            <formularios-generados\n              proyecto=\"$ctrl.proyecto\"\n              ng-if=\"$ctrl.proyecto.documentacion_exp\"\n            ></formularios-generados>\n          </wz-step>\n        </wizard>\n      </ng-form>\n\n      <div class=\"row both\">\n        <section ng-if=\"$ctrl.proyecto.observacion.mensaje\" class=\"col\">\n          <h6 class=\"title-section error m-top\">\n            <i class=\"fa fa-exclamation-triangle\"></i> Observación\n          </h6>\n          Mensaje: <strong>{{ $ctrl.proyecto.observacion.mensaje }}</strong\n          ><br />\n          Observado por:\n          <strong\n            >{{ $ctrl.proyecto.observacion.usuario.persona | nombreUnido\n            }}</strong\n          >\n        </section>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 626 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container matriculas\">\n  <div class=\"card\">\n    <div class=\"card-body\">\n      <div class=\"row\">\n        <div class=\"card card-matricula\" ng-repeat=\"matricula in $ctrl.matriculas\">\n          <img src=\"./images/matricula.jpg\" class=\"card-image\" alt=\"Matrícula de comercio\">\n          <div class=\"card-body\">\n            <h4><strong>{{matricula.IdMatricula}}</strong></h4>\n            <span class=\"\">{{matricula.RazonSocial}}</span>\n          </div>\n          <div class=\"card-footer pull-rigth\">\n            <div class=\"text-center\">\n              <button md-effect type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.cargarDatosMatricula(matricula)\">\n                <i class=\"fa fa-check\"></i> Seleccionar\n              </button>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"card-body\" ng-if=\"!$ctrl.actualizado\">\n      <div class=\"row\">\n        <div class=\"card card-matricula\">\n          <div class=\"card-body\">\n            <button md-effect type=\"button\" class=\"btn btn-warning\" ng-click=\"$ctrl.actualizarMatriculas()\">\n              <i class=\"fa fa-refresh\"></i> Actualizar matrículas\n            </button>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 627 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\"><i class=\"fa fa-info-circle\"></i> Fecha de modificación</h5>\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cerrar()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<div class=\"modal-body\">\n  <p>{{$ctrl.option.confirm_txt}}</p>\n\n  <p>\n    Se le informa que estas modificaciones, una vez aprobadas serán incorporadas a la planilla de avance.\n  </p>\n\n  <div class=\"alert alert-warning\">\n    <i class=\"fa fa-info-circle\"></i>\n    <span>{{$ctrl.option.action}} la <strong>fecha de la modificación</strong>.</span>\n  </div>\n\n  <ng-form name=\"formPlazo\">\n    <div class=\"row\">\n      <div class=\"offset-md-3 col-md-6\">\n        <c-date name=\"fecha_modificacion\" label=\"Fecha de modificació\"\n                ng-model=\"$ctrl.proyecto.fecha_modificacion\"\n                ng-required=\"true\"\n                min-date=\"$ctrl.validacion.fecha_minima\"\n                ng-disabled=\"$ctrl.option.disabled\"\n                mensaje-max-date=\"La fecha no puede ser mayor a la fecha actual\">\n        </c-date>\n      </div>\n    </div>\n  </ng-form>\n\n  <small>Nota.- La fecha de la modificación deberá ser la misma que se ha establecido en los documentos aprobados (libro de ordenes, informes técnicos, contrato modificatorio)</small>\n</div>\n<div class=\"modal-footer\">\n  <button type=\"button\" md-effect class=\"btn btn-secondary\" ng-click=\"$ctrl.cerrar()\">\n    <i class=\"fa fa-close\"></i> Cancelar\n  </button>\n  <button type=\"submit\" md-effect class=\"btn btn-primary\" validar-formulario=\"formPlazo\" ng-click=\"$ctrl.aceptar()\">\n    <i class=\"fa fa-check\"></i> Si, estoy seguro/a\n  </button>\n</div>\n"

/***/ }),
/* 628 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container px-3 planilla-proy\">\n  <h2 class=\"page-title\">\n    <i class=\"fa fa-bars\"></i> Proyecto\n    <small><strong>{{$ctrl.proyecto.nombre}}</strong></small>\n  </h2>\n  <div class=\"card\">\n    <div class=\"card-body\">\n      <div class=\"row mx-0\">\n        <div\n          style=\"font-size: 20px\"\n          uib-tooltip=\"Volver atrás\"\n          ng-click=\"$ctrl.irAtras()\"\n        >\n          <i class=\"fa fa-reply\"></i>\n        </div>\n      </div>\n      <h4 class=\"text-center\">\n        <strong\n          >{{$ctrl.proyecto.documentacion_exp.datos_asociacion.nombre_asociacion\n          || $ctrl.proyecto.empresa.nombre}}</strong\n        >\n      </h4>\n      <h3 class=\"text-center\">\n        Modificación - {{$ctrl.proyecto.modificaciones.nombre}}\n      </h3>\n      <div class=\"texto\">\n        <h4 class=\"text-center\">\n          Fecha:\n          <strong\n            >{{$ctrl.proyecto.fecha_modificacion | date : 'dd/MM/yyyy'}}</strong\n          >\n        </h4>\n        <section>\n          <a href=\"\">\n            <h6\n              class=\"title-section m-top\"\n              ng-click=\"$ctrl.datosProyectoIsCollapsed = !$ctrl.datosProyectoIsCollapsed\"\n            >\n              <i class=\"fa fa-hand-o-right\"></i> Datos del proyecto\n            </h6>\n          </a>\n          <div uib-collapse=\"$ctrl.datosProyectoIsCollapsed\">\n            <div class=\"row\">\n              <div class=\"col-lg-4 text-left\">\n                <table class=\"table mod-t mod-t-b mb-0\">\n                  <tbody>\n                    <tr>\n                      <th class=\"text-right\">Nombre:</th>\n                      <td>{{$ctrl.proyecto.nombre}}</td>\n                    </tr>\n                    <tr>\n                      <th class=\"text-right\">Departamento:</th>\n                      <td>{{$ctrl.proyecto.dpa.departamento.nombre}}</td>\n                    </tr>\n                    <tr>\n                      <th class=\"text-right\">Provincia:</th>\n                      <td>{{$ctrl.proyecto.dpa.provincia.nombre}}</td>\n                    </tr>\n                    <tr>\n                      <th class=\"text-right\">Municipio:</th>\n                      <td>{{$ctrl.proyecto.dpa.municipio.nombre}}</td>\n                    </tr>\n                    <tr>\n                      <th class=\"text-right\">Beneficiario:</th>\n                      <td>{{$ctrl.proyecto.entidad_beneficiaria}}</td>\n                    </tr>\n                  </tbody>\n                </table>\n              </div>\n              <div class=\"col-lg-4\">\n                <table class=\"table mod-t mod-t-b mb-0\">\n                  <tbody>\n                    <tr>\n                      <th class=\"text-right\">Monto convenio:</th>\n                      <td class=\"text-right\">\n                        {{$ctrl.proyecto.monto_total_convenio |\n                        number:$ctrl.decimales}}\n                      </td>\n                    </tr>\n                    <tr>\n                      <th class=\"text-right\">Monto contrato:</th>\n                      <td class=\"text-right\">\n                        {{($ctrl.proyecto.monto_contractual||$ctrl.proyecto.monto_total)\n                        | number:$ctrl.decimales}}\n                      </td>\n                    </tr>\n                    <tr\n                      ng-if=\"$ctrl.proyecto.monto_contractual && $ctrl.proyecto.monto_total!=$ctrl.proyecto.monto_contractual\"\n                    >\n                      <th class=\"text-right\">Monto total con modificación:</th>\n                      <td class=\"text-right\">\n                        {{$ctrl.proyecto.monto_total | number:$ctrl.decimales}}\n                      </td>\n                    </tr>\n                    <tr>\n                      <th class=\"text-right\">\n                        Anticipo {{$ctrl.proyecto.porcentaje_anticipo |\n                        number:2}}%:\n                      </th>\n                      <td class=\"text-right\">\n                        {{$ctrl.proyecto.anticipo | number:$ctrl.decimales}}\n                      </td>\n                    </tr>\n                    <!-- <tr> <th class=\"text-right\">TOTAL DESEMBOLSADO:</th> <td class=\"text-right\"><strong>{{$ctrl.proyecto.desembolso | number:$ctrl.decimales}}</strong></td> </tr> -->\n                  </tbody>\n                </table>\n              </div>\n              <div class=\"col-lg-4\">\n                <table class=\"table mod-t mod-t-b mb-0\">\n                  <tbody>\n                    <tr>\n                      <th class=\"text-right\">\n                        Fecha inicio de obras/<br />\n                        Libro de ordenes:\n                      </th>\n                      <td>\n                        {{$ctrl.proyecto.orden_proceder | date : 'dd/MM/yyyy'}}\n                      </td>\n                    </tr>\n                    <tr>\n                      <th class=\"text-right\">Plazo de Ejecución</th>\n                      <td>{{$ctrl.proyecto.plazo_ejecucion}}</td>\n                    </tr>\n                    <tr>\n                      <th class=\"text-right\">Ampliación de Plazo</th>\n                      <td>\n                        {{$ctrl.proyecto.plazo_ampliacion_total+$ctrl.proyecto.plazo_ampliacion.por_volumenes+$ctrl.proyecto.plazo_ampliacion.por_compensacion\n                        || 0}}\n                      </td>\n                    </tr>\n                    <tr>\n                      <th class=\"text-right\">\n                        Fecha prevista p/Recepción Provisional\n                      </th>\n                      <td>\n                        {{($ctrl.proyecto.fecha_recepcion_provisional) | date :\n                        'dd/MM/yyyy'}}\n                      </td>\n                    </tr>\n                    <tr>\n                      <th class=\"text-right\">\n                        Fecha prevista p/Recepción definitiva\n                      </th>\n                      <td>\n                        {{($ctrl.proyecto.fecha_recepcion_definitiva) | date :\n                        'dd/MM/yyyy'}}\n                      </td>\n                    </tr>\n                  </tbody>\n                </table>\n              </div>\n            </div>\n          </div>\n        </section>\n      </div>\n\n      <section>\n        <h6 class=\"title-section m-top\">\n          <i class=\"fa fa-list\"></i> {{$ctrl.tabIndex==1?'Items':'Plazo'}} del\n          proyecto\n        </h6>\n        <!--\n        <div class=\"row\">\n          <div class=\"col-md-6\">\n            <div class=\"alert alert-info text-white\">\n              <i class=\"fa fa-info-circle\"></i>\n              <span>Puede hacer doble click a un item para <strong>{{$ctrl.esEditable? 'realizar' : 'revisar'}} su cómputo métrico</strong>.</span>\n            </div>\n          </div>\n          <div class=\"col-md-6\" ng-if=\"$ctrl.proyecto.doc_especificaciones_tecnicas\">\n            <button md-effect type=\"button\" class=\"btn btn-info\" download-file=\"{{$ctrl.urlDescEspTecnicas}}\" file-name=\"Especificaciones técnicas\">\n              <i class=\"fa fa-download\"></i> Especificaciones técnicas\n            </button>\n          </div>\n        </div>\n        -->\n\n        <div class=\"row mb-2\">\n          <div class=\"col-lg-6 col-md-12 mb-2\">\n            <div class=\"btn-group opciones\">\n              <label\n                class=\"btn btn-info\"\n                btn-checkbox\n                ng-model=\"$ctrl.filtroItems\"\n                uib-btn-radio=\"'TODOS'\"\n                >Todos</label\n              >\n              <label\n                class=\"btn btn-info\"\n                ng-model=\"$ctrl.filtroItems\"\n                uib-btn-radio=\"'COMPLETADOS'\"\n                >Completados</label\n              >\n              <label\n                class=\"btn btn-info\"\n                ng-model=\"$ctrl.filtroItems\"\n                uib-btn-radio=\"'INCOMPLETOS'\"\n                >Por completar</label\n              >\n            </div>\n          </div>\n          <div class=\"col-lg-6 col-md-12 mt-2\">\n            <label class=\"custom-control custom-checkbox\">\n              <span class=\"custom-control-indicator success\"></span\n              ><span>Completado</span>\n            </label>\n            <label class=\"custom-control custom-checkbox\">\n              <span class=\"custom-control-indicator info\"></span\n              ><span>Con avance</span>\n            </label>\n            <label\n              class=\"custom-control custom-checkbox\"\n              ng-if=\"$ctrl.esEtapaEdicion\"\n            >\n              <span class=\"custom-control-indicator primary\"></span\n              ><span>Sin avance</span>\n            </label>\n            <label\n              class=\"custom-control custom-checkbox\"\n              ng-if=\"$ctrl.supervision.nro_supervision !== 1 && $ctrl.esEtapaEdicion\"\n            >\n              <span class=\"custom-control-indicator warning\"></span\n              ><span>Con avance en anterior(es) planilla(s)</span>\n            </label>\n          </div>\n        </div>\n        <!-- <div class=\"text-right\">\n          <button\n            md-effect\n            type=\"button\"\n            class=\"btn\"\n            ng-class=\"{'btn-success':$ctrl.proyecto.cr_precio}\"\n            uib-tooltip=\"\"\n            tooltip-placement=\"bottom\"\n            ng-if=\"$ctrl.esTecnico\"\n            ng-click=\"$ctrl.agregarQuitarCampo()\"\n          >\n            <i class=\"fa fa-table\"></i> Agregar campo para regularizaciones\n          </button>\n        </div> -->\n        <form name=\"formModificacion\">\n          <uib-tabset active=\"$ctrl.tabIndex\">\n            <uib-tab index=\"1\" heading=\"ITEMS\">\n              <div class=\"row\">\n                <div class=\"col\">\n                  <button\n                    md-effect\n                    type=\"button\"\n                    class=\"btn mr-3 pull-right\"\n                    ng-class=\"{'btn-success':$ctrl.modificandoItems}\"\n                    ng-click=\"$ctrl.modificarItems()\"\n                    ng-if=\"!$ctrl.modoVista\"\n                  >\n                    <i class=\"fa fa-edit\"></i> Modificar\n                  </button>\n                </div>\n              </div>\n              <div ng-repeat=\"modulo in $ctrl.proyecto.modulos\" class=\"texto\">\n                <div\n                  class=\"my-1 mod-h\"\n                  ng-click=\"modulo.isCollapsed = !modulo.isCollapsed\"\n                  style=\"background-color: rgba(0, 0, 0, 0.05)\"\n                >\n                  <span\n                    uib-tooltip=\"Click para ocultar/mostrar sus items\"\n                    tooltip-placement=\"right\"\n                  >\n                    <strong>Módulo:</strong> {{modulo.nombre}}\n                  </span>\n                </div>\n                <hr class=\"mt-2 mb-1\" />\n                <div\n                  class=\"table-responsive\"\n                  ng-class=\"{'col-md-6':!$ctrl.modificandoItems}\"\n                >\n                  <div uib-collapse=\"modulo.isCollapsed\">\n                    <table\n                      class=\"table table-striped mod-t text-right\"\n                      style=\"width: auto\"\n                      ng-init=\"version_ant=$ctrl.proyecto.version_anterior\"\n                    >\n                      <thead>\n                        <tr>\n                          <th\n                            rowspan=\"2\"\n                            title=\"Nro de item\"\n                            style=\"width: 50px\"\n                          >\n                            Nro.\n                          </th>\n                          <th\n                            rowspan=\"2\"\n                            class=\"text-left\"\n                            style=\"width: 350px\"\n                          >\n                            Descripción\n                          </th>\n                          <th rowspan=\"2\" title=\"Unidad\" style=\"width: 100px\">\n                            Unid.\n                          </th>\n                          <!-- <th rowspan=\"2\" title=\"Cantidad\" style=\"width:100px\">Cant.</th> -->\n                          <th\n                            rowspan=\"2\"\n                            title=\"Precio Unitario\"\n                            style=\"width: 100px\"\n                          >\n                            P.U.\n                          </th>\n                          <!-- <th rowspan=\"2\" style=\"width:100px\">Total (Bs)</th> -->\n                          <th\n                            colspan=\"2\"\n                            class=\"text-center\"\n                            style=\"width: 200px\"\n                            ng-if=\"$ctrl.cabecera.version_inicial\"\n                          >\n                            Contrato Original\n                          </th>\n                          <th\n                            colspan=\"2\"\n                            class=\"text-center\"\n                            style=\"width: 200px\"\n                            ng-if=\"$ctrl.cabecera.version_anterior\"\n                          >\n                            {{version_ant.tipo_modificacion_proyecto.nombre?\n                            version_ant.tipo_modificacion_proyecto.nombre+' N°\n                            '+version_ant.tipo_modificacion_proyecto.numero:'Contrato\n                            Original'}}\n                          </th>\n                          <th\n                            colspan=\"2\"\n                            class=\"text-center\"\n                            ng-if=\"$ctrl.modificandoItems && !$ctrl.proyecto.cr_precio\"\n                            style=\"width: 200px\"\n                          >\n                            {{$ctrl.proyecto.modificaciones.nombre}}\n                          </th>\n                          <th\n                            colspan=\"3\"\n                            class=\"text-center\"\n                            ng-if=\"$ctrl.modificandoItems && $ctrl.proyecto.cr_precio\"\n                            style=\"width: 200px\"\n                          >\n                            {{$ctrl.proyecto.modificaciones.nombre}}\n                          </th>\n                          <th\n                            colspan=\"2\"\n                            class=\"text-center\"\n                            ng-if=\"$ctrl.modificandoItems\"\n                            style=\"width: 200px\"\n                          >\n                            Avance\n                          </th>\n                        </tr>\n                        <tr ng-if=\"$ctrl.modificandoItems\">\n                          <th\n                            title=\"Cantidad\"\n                            style=\"width: 100px\"\n                            ng-if=\"$ctrl.cabecera.version_inicial\"\n                          >\n                            Cant.\n                          </th>\n                          <th\n                            style=\"width: 100px\"\n                            ng-if=\"$ctrl.cabecera.version_inicial\"\n                          >\n                            Total (Bs)\n                          </th>\n                          <th\n                            title=\"Cantidad\"\n                            style=\"width: 100px\"\n                            ng-if=\"$ctrl.cabecera.version_anterior\"\n                          >\n                            Cant.\n                          </th>\n                          <th\n                            style=\"width: 100px\"\n                            ng-if=\"$ctrl.cabecera.version_anterior\"\n                          >\n                            Total (Bs)\n                          </th>\n                          <th title=\"Cantidad\" style=\"width: 100px\">Cant.</th>\n                          <th style=\"width: 100px\">Total (Bs)</th>\n                          <th\n                            style=\"width: 100px\"\n                            ng-if=\"$ctrl.proyecto.cr_precio\"\n                          >\n                            Regu.\n                          </th>\n                          <!-- <th style=\"width:100px\">Anterior</th> -->\n                          <th style=\"width: 100px\">Actual</th>\n                          <th title=\"Falta ejecutar\" style=\"width: 100px\">\n                            F.E.\n                          </th>\n                        </tr>\n                      </thead>\n                      <tbody>\n                        <tr\n                          ng-repeat=\"item in modulo.items\"\n                          ng-show=\"item.show\"\n                          ng-class=\"(item.cantidad==item.avance_actual || item.estado=='CERRADO')? 'completado' : ''\"\n                        >\n                          <td\n                            ng-class=\"$ctrl.getMgColor(item)\"\n                            title=\"{{$ctrl.getTitle(item)}}\"\n                          >\n                            {{item.nro_item}}\n                          </td>\n                          <td class=\"text-left\">{{item.nombre}}</td>\n                          <td title=\"{{item.unidad.descripcion}}\">\n                            {{item.unidad.nombre}}\n                          </td>\n                          <!-- <td>{{item.version_inicial.cantidad | number:$ctrl.decimales}}</td> -->\n                          <td>\n                            {{item.precio_unitario | number:$ctrl.decimales}}\n                          </td>\n                          <!-- <td>{{(item.version_inicial.cantidad*item.precio_unitario) | number:$ctrl.decimales}}</td> -->\n                          <td ng-if=\"$ctrl.cabecera.version_inicial\">\n                            {{item.version_inicial.cantidad |\n                            number:$ctrl.decimales}}\n                          </td>\n                          <td ng-if=\"$ctrl.cabecera.version_inicial\">\n                            {{$ctrl.Util.sumar([$ctrl.Util.multiplicar([item.version_inicial.cantidad,\n                            item.precio_unitario]),\n                            item.version_inicial.cr_precio]) |\n                            number:$ctrl.decimales}}\n                          </td>\n                          <td\n                            ng-class=\"{'text-info font-weight-bold':item.version_anterior.cantidad!=item.version_inicial.cantidad}\"\n                            ng-if=\"$ctrl.cabecera.version_anterior\"\n                          >\n                            {{item.version_anterior.cantidad |\n                            number:$ctrl.decimales}}\n                          </td>\n                          <td\n                            ng-class=\"{'text-info font-weight-bold':item.version_anterior.cantidad!=item.version_inicial.cantidad}\"\n                            ng-if=\"$ctrl.cabecera.version_anterior\"\n                          >\n                            {{$ctrl.Util.sumar([$ctrl.Util.multiplicar([item.version_anterior.cantidad,\n                            item.precio_unitario]),\n                            item.version_anterior.cr_precio]) |\n                            number:$ctrl.decimales}}\n                          </td>\n                          <td\n                            class=\"modificacion-input\"\n                            ng-class=\"{'warning':(item.cantidad!=item.version_anterior.cantidad),'danger':item.error}\"\n                            ng-if=\"$ctrl.modificandoItems\"\n                          >\n                            <c-input-numeric\n                              name=\"cantidad\"\n                              ng-model=\"item.cantidad\"\n                              ng-blur=\"$ctrl.modificarCantidadItem(item)\"\n                              ng-disabled=\"$ctrl.modoVista || item.estado=='CERRADO'\"\n                              ng-minvalue=\"{{item.avance_actual}}\"\n                              ng-maxvalue=\"999999\"\n                              ng-decimals=\"{{$ctrl.decimales}}\"\n                            ></c-input-numeric>\n                          </td>\n                          <td\n                            ng-class=\"{'font-weight-bold warning':(item.cantidad!=item.version_anterior.cantidad),'danger':item.error, 'success':item.version_inicial.cr_precio, 'success':item.version_anterior.cr_precio}\"\n                            ng-if=\"$ctrl.modificandoItems\"\n                          >\n                            {{$ctrl.Util.multiplicar([item.cantidad,item.precio_unitario])\n                            | number:$ctrl.decimales}}\n                          </td>\n                          <td ng-if=\"$ctrl.proyecto.cr_precio\">\n                            <span\n                              ng-if=\"item.cantidad!=item.version_anterior.cantidad || item.version_anterior.cr_precio\"\n                              ><input\n                                ng-disabled=\"$ctrl.modoVista\"\n                                name=\"e_redondeo{{item.nro_item}}\"\n                                pattern=\"(^[-]{0,1}0.\\d[\\d]{0,1}$)|^0$|^$\"\n                                placeholder=\"0.00\"\n                                size=\"2\"\n                                ng-model=\"item.cr_precio\"\n                                ng-blur=\"$ctrl.cRegularizacion(item)\"\n                            /></span>\n                          </td>\n                          <!-- <td ng-if=\"$ctrl.modificandoItems\">{{item.cantidad_anterior_fis | number:$ctrl.decimales}}</td> -->\n                          <td ng-if=\"$ctrl.modificandoItems\">\n                            {{item.avance_actual | number:$ctrl.decimales}}\n                          </td>\n                          <td ng-if=\"$ctrl.modificandoItems\">\n                            {{(item.cantidad-item.avance_actual) |\n                            number:$ctrl.decimales}}\n                          </td>\n                        </tr>\n                      </tbody>\n                    </table>\n                  </div>\n                </div>\n              </div>\n              <section\n                ng-repeat=\"nuevomodulo in $ctrl.nuevosmodulos\"\n                ng-if=\"$ctrl.modificandoItems && $ctrl.tipoModificacion==3\"\n              >\n                <modulo\n                  modulo=\"nuevomodulo\"\n                  callback=\"$ctrl.recalcularMontos(data)\"\n                  options=\"{adicionar:true, idProyecto:$ctrl.proyecto.idProyecto, cabecera:$ctrl.cabecera}\"\n                  modo-vista=\"$ctrl.modoVista\"\n                  proyecto=\"$ctrl.proyecto\"\n                ></modulo>\n              </section>\n              <button\n                class=\"btn btn-link text-success\"\n                ng-click=\"$ctrl.adicionarModulo()\"\n                uib-tooltip=\"Adicionar nuevo módulo para los items nuevos\"\n                ng-if=\"!$ctrl.modoVista && $ctrl.modificandoItems && $ctrl.tipoModificacion==3 && $ctrl.nuevosmodulos.length===0\"\n              >\n                <i class=\"fa fa-plus-square-o\"></i> Adicionar Items\n              </button>\n              <hr />\n              <br />\n              <div\n                class=\"alert alert-danger\"\n                ng-if=\"$ctrl.modificandoItems && $ctrl.porcentajeExcedido \"\n              >\n                <i class=\"fa fa-danger\"></i>\n                <span>\n                  <span ng-if=\"$ctrl.tipoModificacion==1\"\n                    >Se ha modificado el...</span\n                  >\n                  <span ng-if=\"$ctrl.tipoModificacion!=1\"\n                    >El monto total con modificación supera el\n                    {{$ctrl.porcentajeLimite*100}} % del</span\n                  >\n                  monto contractual en Bs. {{\n                  $ctrl.Util.restar($ctrl.Util.sumar([$ctrl.proyecto.monto_total_variacion_modificado,\n                  $ctrl.proyecto.modificaciones.total_variacion]),\n                  $ctrl.Util.multiplicar([$ctrl.proyecto.version_inicial.monto_total,\n                  $ctrl.porcentajeLimite])) }}. Usted debe revisar sus\n                  cantidades modificadas.</span\n                >\n              </div>\n              <div\n                class=\"alert alert-warning\"\n                ng-if=\"$ctrl.itemsNoCerrados.length > 0\"\n              >\n                <i class=\"fa fa-warning\"></i>\n                <span ng-if=\"$ctrl.itemsNoCerrados.length === 1\"\n                  ><strong>El item resaltado</strong> tiene</span\n                >\n                <span ng-if=\"$ctrl.itemsNoCerrados.length > 1\"\n                  ><strong>Los items resaltados</strong> tienen</span\n                >\n                <span\n                  >concluido el avance físico, sin embargo la parte financiera\n                  no ha cerrado. Este detalle será revisado por personal de la\n                  UPRE.</span\n                >\n              </div>\n\n              <div class=\"fs-sm\" ng-if=\"$ctrl.modificandoItems\">\n                <div class=\"row\">\n                  <div class=\"col-md-6 text-left\">\n                    <table class=\"table mod-t mod-t-b mb-0\">\n                      <tbody>\n                        <tr>\n                          <th>Monto total anterior:</th>\n                          <td>\n                            {{$ctrl.proyecto.version_anterior.monto_total |\n                            number:$ctrl.decimales}}\n                          </td>\n                        </tr>\n                        <!-- <tr>\n                          <th>Monto total de variación:</th>\n                          <td>{{$ctrl.proyecto.monto_total_variacion_modificado | number:$ctrl.decimales}}</td>\n                        </tr> -->\n                        <tr>\n                          <th>Monto total con modificación:</th>\n                          <td>\n                            {{$ctrl.proyecto.version_anterior.monto_total--$ctrl.proyecto.monto_total_variacion_modificado\n                            | number:$ctrl.decimales}}\n                          </td>\n                        </tr>\n                      </tbody>\n                    </table>\n                  </div>\n                  <div class=\"col-md-6 text-left\">\n                    <table class=\"table mod-t mod-t-b mb-0\">\n                      <tbody>\n                        <tr>\n                          <th>Monto contractual inicial:</th>\n                          <td>\n                            {{($ctrl.proyecto.monto_contractual||$ctrl.proyecto.monto_total)\n                            | number:$ctrl.decimales}}\n                          </td>\n                        </tr>\n                        <tr>\n                          <th>Monto total de variación:</th>\n                          <td>\n                            {{$ctrl.proyecto.monto_total_variacion_modificado |\n                            number:$ctrl.decimales}}\n                          </td>\n                        </tr>\n                        <tr>\n                          <th>Porcentaje de variación:</th>\n                          <td>\n                            {{$ctrl.proyecto.porcentaje_variacion |\n                            number:$ctrl.decimales}}%\n                          </td>\n                        </tr>\n                      </tbody>\n                    </table>\n                  </div>\n                </div>\n              </div>\n            </uib-tab>\n            <uib-tab\n              index=\"2\"\n              heading=\"PLAZOS\"\n              ng-if=\"$ctrl.tipoModificacion>1\"\n            >\n              <div class=\"row\">\n                <div class=\"col\">\n                  <button\n                    md-effect\n                    type=\"button\"\n                    class=\"btn mr-3 pull-right\"\n                    ng-class=\"{'btn-success':$ctrl.modificandoPlazo}\"\n                    ng-click=\"$ctrl.modificarPlazo()\"\n                    ng-if=\"!$ctrl.modoVista\"\n                  >\n                    <i class=\"fa fa-edit\"></i> Modificar\n                  </button>\n                </div>\n              </div>\n              <div class=\"row\">\n                <div class=\"col-lg-6 text-left\">\n                  <div style=\"overflow: auto\">\n                    <br />\n                    <h5>Fechas establecidas al inicio de obras:</h5>\n                    <table class=\"table mod-t mod-t-b mb-0\">\n                      <tbody>\n                        <tr>\n                          <th class=\"text-center\">Fecha de inicio de obras</th>\n                          <th class=\"text-center\">Plazo de ejecución (dias)</th>\n                          <th class=\"text-center\">\n                            Fecha de entrega provisional\n                          </th>\n                          <th class=\"text-center\">\n                            Fecha de recepción definitiva\n                          </th>\n                        </tr>\n                        <tr>\n                          <td class=\"text-center\">\n                            {{$ctrl.proyecto.orden_proceder | date :\n                            'dd/MM/yyyy'}}\n                          </td>\n                          <td class=\"text-center\">\n                            {{$ctrl.proyecto.plazo_ejecucion}}\n                          </td>\n                          <td class=\"text-center\">\n                            {{$ctrl.fechaSumDias($ctrl.proyecto.orden_proceder,$ctrl.proyecto.plazo_ejecucion-1)\n                            | date : 'dd/MM/yyyy'}}\n                          </td>\n                          <td class=\"text-center\">\n                            {{$ctrl.fechaSumDias($ctrl.proyecto.orden_proceder,$ctrl.proyecto.plazo_ejecucion+89)\n                            | date : 'dd/MM/yyyy'}}\n                          </td>\n                        </tr>\n                      </tbody>\n                    </table>\n                  </div>\n                </div>\n                <div class=\"col-lg-6 text-left\" ng-if=\"$ctrl.modificandoPlazo\">\n                  <div style=\"overflow: auto\">\n                    <br />\n                    <h5>Modificación Actual:</h5>\n                    <table class=\"table mod-t mod-t-b mb-0\">\n                      <tbody>\n                        <tr>\n                          <th class=\"text-center\">\n                            Ampliación de plazo por volúmenes (días)\n                          </th>\n                          <th class=\"text-center\">\n                            Ampliación de plazo por compensación (dias)\n                          </th>\n                          <th class=\"text-center\">\n                            Ampliación de plazo (días)\n                          </th>\n                        </tr>\n                        <tr>\n                          <td class=\"td-cinput-center\">\n                            <!-- <c-input name=\"cantidad\" ng-model=\"$ctrl.proyecto.plazo_ampliacion.por_volumenes\" ng-blur=\"$ctrl.modificarPlazoAmpliacion($ctrl.proyecto.plazo_ampliacion)\" ng-disabled=\"$ctrl.modoVista\"></c-input> -->\n                            <c-input-numeric\n                              name=\"por_volumenes\"\n                              ng-model=\"$ctrl.proyecto.plazo_ampliacion.por_volumenes\"\n                              ng-disabled=\"$ctrl.modoVista\"\n                              ng-required=\"false\"\n                              ng-decimals=\"0\"\n                              ng-not-number=\"0\"\n                              ng-number-default=\"0\"\n                              ng-minvalue=\"-999\"\n                              ng-maxvalue=\"9999\"\n                              ng-blur=\"$ctrl.modificarPlazoAmpliacion($ctrl.proyecto.plazo_ampliacion)\"\n                            >\n                            </c-input-numeric>\n                          </td>\n                          <td class=\"td-cinput-center\">\n                            <!-- <c-input name=\"cantidad\" ng-model=\"$ctrl.proyecto.plazo_ampliacion.por_compensacion\" ng-blur=\"$ctrl.modificarPlazoAmpliacion($ctrl.proyecto.plazo_ampliacion)\" ng-disabled=\"$ctrl.modoVista\"></c-input> -->\n                            <c-input-numeric\n                              name=\"por_compensacion\"\n                              ng-model=\"$ctrl.proyecto.plazo_ampliacion.por_compensacion\"\n                              ng-disabled=\"$ctrl.modoVista\"\n                              ng-required=\"false\"\n                              ng-decimals=\"0\"\n                              ng-not-number=\"0\"\n                              ng-number-default=\"0\"\n                              ng-minvalue=\"-999\"\n                              ng-maxvalue=\"9999\"\n                              ng-blur=\"$ctrl.modificarPlazoAmpliacion($ctrl.proyecto.plazo_ampliacion)\"\n                            >\n                            </c-input-numeric>\n                          </td>\n                          <td class=\"text-center\">\n                            {{\n                            ($ctrl.proyecto.plazo_ampliacion.por_volumenes--$ctrl.proyecto.plazo_ampliacion.por_compensacion)\n                            }}\n                          </td>\n                        </tr>\n                      </tbody>\n                    </table>\n                  </div>\n                </div>\n              </div>\n              <div class=\"row\">\n                <div class=\"col-lg-6 text-left\" ng-if=\"$ctrl.modificandoPlazo\">\n                  <div style=\"overflow: auto\">\n                    <br />\n                    <h5>Modificaciones de plazo:</h5>\n                    <table\n                      class=\"table mod-t mod-t-b mb-0\"\n                      ng-repeat=\"modificacion in $ctrl.proyecto.modificaciones.historial\"\n                    >\n                      <tbody>\n                        <tr>\n                          <th class=\"text-center\" colspan=\"3\">\n                            {{modificacion.tipo_modificacion_proyecto.nombre}}\n                          </th>\n                        </tr>\n                        <tr>\n                          <th class=\"text-center\">\n                            Ampliación de plazo (días)\n                          </th>\n                          <th class=\"text-center\">\n                            Plazo de ejecución ampliada (dias)\n                          </th>\n                          <th class=\"text-center\">\n                            Fecha de entrega provisional ampliada\n                          </th>\n                        </tr>\n                        <tr\n                          ng-init=\"plazo = (modificacion.plazo_ampliacion.por_volumenes--modificacion.plazo_ampliacion.por_compensacion)\"\n                        >\n                          <td class=\"text-center\">\n                            {{\n                            (modificacion.plazo_ampliacion.por_volumenes--modificacion.plazo_ampliacion.por_compensacion)\n                            }}\n                          </td>\n                          <td class=\"text-center\">\n                            {{\n                            modificacion.plazo_ampliacion_total+$ctrl.proyecto.plazo_ejecucion\n                            }}\n                          </td>\n                          <td class=\"text-center\">\n                            {{ modificacion.nueva_fecha_provisional | date :\n                            'dd/MM/yyyy' }}\n                          </td>\n                        </tr>\n                      </tbody>\n                    </table>\n                  </div>\n                </div>\n                <div class=\"col-lg-6 text-left\" ng-if=\"$ctrl.modificandoPlazo\">\n                  <div style=\"overflow: auto\">\n                    <br />\n                    <h5>Nuevas fechas modificadas:</h5>\n                    <table class=\"table mod-t mod-t-b mb-0\">\n                      <tbody>\n                        <tr>\n                          <th class=\"text-center\">Fecha de inicio de obras</th>\n                          <th class=\"text-center\">\n                            Plazo de ejecución ampliada (dias)\n                          </th>\n                          <th class=\"text-center\">\n                            Fecha de entrega provisional ampliada\n                          </th>\n                          <th class=\"text-center\">\n                            Fecha de recepción definitiva ampliada\n                          </th>\n                        </tr>\n                        <tr>\n                          <td class=\"text-center\">\n                            {{$ctrl.proyecto.orden_proceder | date :\n                            'dd/MM/yyyy'}}\n                          </td>\n                          <td class=\"text-center\">\n                            {{$ctrl.proyecto.plazo_ejecucion+$ctrl.proyecto.plazo_ampliacion_total--$ctrl.proyecto.plazo_ampliacion.por_volumenes--$ctrl.proyecto.plazo_ampliacion.por_compensacion}}\n                          </td>\n                          <td class=\"text-center\">\n                            {{$ctrl.proyecto.nueva_fecha_provisional | date :\n                            'dd/MM/yyyy'}}\n                          </td>\n                          <td class=\"text-center\">\n                            {{$ctrl.proyecto.nueva_fecha_definitiva | date :\n                            'dd/MM/yyyy'}}\n                          </td>\n                        </tr>\n                      </tbody>\n                    </table>\n                  </div>\n                </div>\n              </div>\n            </uib-tab>\n          </uib-tabset>\n        </form>\n      </section>\n\n      <section>\n        <h6 class=\"title-section m-top\">\n          <i class=\"fa fa-list\"></i> Resumen de la Modificación\n        </h6>\n\n        <div class=\"row\">\n          <div class=\"col-lg-6 text-left\">\n            <!-- <p>Monto contractual inicial <strong>{{$ctrl.proyecto.version_inicial.monto_total | number:$ctrl.decimales}}</strong></p> -->\n            <table class=\"table mod-t mod-t-b mb-0 table-responsive\">\n              <tbody>\n                <tr>\n                  <th colspan=\"6\" class=\"text-center\">Historial</th>\n                </tr>\n                <tr>\n                  <th>Modificación</th>\n                  <th>Monto total</th>\n                  <th>Variación</th>\n                  <th>%</th>\n                  <th>Estado</th>\n                  <th>Fecha</th>\n                </tr>\n                <tr\n                  ng-repeat=\"modificacion in $ctrl.proyecto.modificaciones.historial\"\n                  ng-if=\"$ctrl.proyecto.tipo_modificacion==modificacion.tipo_modificacion\"\n                >\n                  <td>{{modificacion.tipo_modificacion_proyecto.nombre}}</td>\n                  <td class=\"text-right\">\n                    {{modificacion.monto_total | number:$ctrl.decimales}}\n                  </td>\n                  <td class=\"text-right\">\n                    {{modificacion.variacion | number:$ctrl.decimales}}\n                  </td>\n                  <td>\n                    {{modificacion.variacion_porcentaje |\n                    number:$ctrl.decimales}}\n                  </td>\n                  <td>{{modificacion.estado_actual.nombre}}</td>\n                  <td>\n                    {{modificacion.fecha_modificacion | date : 'dd/MM/yyyy'}}\n                  </td>\n                </tr>\n                <tr>\n                  <td class=\"text-right\" colspan=\"2\"><strong>Total</strong></td>\n                  <td class=\"text-right\">\n                    {{$ctrl.proyecto.modificaciones.total_variacion |\n                    number:$ctrl.decimales}}\n                  </td>\n                  <td>\n                    {{$ctrl.proyecto.modificaciones.total_variacion_porcentaje |\n                    number:$ctrl.decimales}}\n                  </td>\n                  <td colspan=\"2\">&nbsp;</td>\n                </tr>\n              </tbody>\n            </table>\n            <div\n              class=\"alert alert-danger\"\n              ng-if=\"$ctrl.modificandoItems && $ctrl.porcentajeExcedido \"\n            >\n              <i class=\"fa fa-danger\"></i>\n              <span>\n                <span ng-if=\"$ctrl.tipoModificacion==1\"\n                  >Se ha modificado el</span\n                >\n                <span ng-if=\"$ctrl.tipoModificacion!=1\"\n                  >El monto total con modificación supera el\n                  {{$ctrl.porcentajeLimite*100}} % del</span\n                >\n                monto contractual en Bs. {{\n                $ctrl.Util.restar($ctrl.Util.sumar([$ctrl.proyecto.monto_total_variacion_modificado,\n                $ctrl.proyecto.modificaciones.total_variacion]),\n                $ctrl.Util.multiplicar([$ctrl.proyecto.version_inicial.monto_total,\n                $ctrl.porcentajeLimite])) }}. Usted debe revisar sus cantidades\n                modificadas.</span\n              >\n            </div>\n          </div>\n\n          <div class=\"col-lg-6 text-left\">\n            <ui-input-file\n              name=\"doc_informe_tecnico\"\n              label=\"Informe técnico o respaldo de la modificación\"\n              file-base64=\"$ctrl.informe_tecnico\"\n              upload-callback=\"$ctrl.uploadCallback\"\n              types=\"pdf\"\n              mime-types=\".pdf\"\n              maxfiles=\"1\"\n              maxsize=\"20MB\"\n              ng-if=\"!$ctrl.informe_tecnico_registrado && !$ctrl.modoVista\"\n            >\n            </ui-input-file>\n            <div id=\"documento\" ng-if=\"$ctrl.informe_tecnico_registrado\">\n              <div class=\"opciones\">\n                <button\n                  md-effect\n                  type=\"button\"\n                  class=\"btn btn-success btn-sm\"\n                  uib-tooltip=\"Ver documento\"\n                  ng-click=\"$ctrl.verInformeTecnico()\"\n                >\n                  <i class=\"fa fa-eye\"></i>\n                </button>\n                <!-- <button md-effect type=\"button\" class=\"btn btn-primary btn-sm\" uib-tooltip=\"Descargar\"\n                        download-file=\"{{documento.urlDescarga}}\" file-name=\"{{documento.nombre}}\">\n                  <i class=\"fa fa-download\"></i>\n                </button> -->\n                <button\n                  md-effect\n                  type=\"button\"\n                  class=\"btn btn-info btn-sm\"\n                  uib-tooltip=\"Cambiar\"\n                  ng-click=\"$ctrl.quitarInformeTecnico()\"\n                  ng-if=\"!$ctrl.modoVista\"\n                >\n                  <i class=\"fa fa-exchange\"></i>\n                </button>\n              </div>\n              <img src=\"./images/documento.jpg\" alt=\"Documento\" />\n              <div class=\"detalles\">\n                <div class=\"nombre\">\n                  Documentos aprobados (libro de ordenes, informes técnicos,\n                  contrato modificatorio)\n                </div>\n              </div>\n            </div>\n            <div\n              class=\"alert alert-danger\"\n              ng-if=\"!$ctrl.informe_tecnico_registrado && $ctrl.modoVista && $ctrl.proyecto.version>1\"\n            >\n              <i class=\"fa fa-danger\"></i\n              ><span\n                >No existe los documentos aprobados (libro de ordenes, informes\n                técnicos, contrato modificatorio)</span\n              >\n            </div>\n          </div>\n        </div>\n      </section>\n\n      <div class=\"mt-4 texto\">\n        <!-- <div class=\"mt-3\">\n          <small class=\"resaltado\"><strong><em>La presente planilla tiene valor de declaración Jurada, por lo que si se identifica cualquier falsedad, se realizarán las acciones legales respectivas en contra de la empresa constructora infractora.</em></strong></small>\n        </div> -->\n\n        <div class=\"row my-3 pr-3 justify-content-end\">\n          <button\n            md-effect\n            type=\"button\"\n            class=\"btn mr-3\"\n            ng-click=\"$ctrl.filtroItems === 'PARA_ENVIAR' ? $ctrl.filtroItems = 'TODOS' : $ctrl.filtroItems = 'PARA_ENVIAR'\"\n            ng-if=\"$ctrl.esEtapaEdicion\"\n          >\n            <i class=\"fa fa-eye\"></i> {{ $ctrl.filtroItems === 'PARA_ENVIAR' ?\n            'Ver todos' : 'Ver Planilla a enviar'}}\n          </button>\n          <ejecutar-transicion\n            elemento=\"$ctrl.proyecto\"\n            servicio=\"$ctrl.Modificacion\"\n            form=\"formModificacion\"\n            atributo-estado=\"estado_proyecto\"\n            url=\"$ctrl.url\"\n            mensaje-button=\"$ctrl.mensajeConfirmacion\"\n            confirmar=\"true\"\n            metodo-previo=\"$ctrl.verificarModificacion(accion)\"\n          >\n          </ejecutar-transicion>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n<style>\n  .modificacion-input2 .md-form-group {\n    margin-top: 0rem;\n    margin-bottom: 0;\n  }\n  .modificacion-input .md-form-group {\n    margin-top: 0rem;\n    margin-bottom: 0;\n    width: 90px;\n    float: right;\n  }\n  .modificacion-input .md-form-group input {\n    text-align: right;\n  }\n  .td-cinput-center .md-form-group {\n    margin: 0 auto;\n    width: 90px;\n  }\n  .td-cinput-center .md-form-group input {\n    text-align: center;\n  }\n</style>\n"

/***/ }),
/* 629 */
/***/ (function(module, exports) {

	module.exports = "<ng-form name=\"form_{{$ctrl.modulo.id_modulo}}\">\n  <span class=\"text-primary\"\n    ><strong>Módulo:</strong> {{$ctrl.modulo.nombre}}</span\n  >\n  <button\n    class=\"btn btn-link text-danger\"\n    ng-click=\"$ctrl.eliminarModulo()\"\n    uib-tooltip=\"Eliminar el módulo y los items adicionados\"\n    ng-if=\"false\"\n  >\n    <i class=\"fa fa-trash-o\"></i> Eliminar Items\n  </button>\n  <div class=\"float-right\" ng-if=\"!$ctrl.modoVista\">\n    <button\n      class=\"btn btn-link text-success ml-1 pl-1 pr-1\"\n      ng-click=\"$ctrl.guardarDatosModulo($ctrl.modulo)\"\n      ng-if=\"$ctrl.options.guardar===true\"\n      uib-tooltip=\"Guardar datos módulo\"\n      validar-formulario\n      nombre-formulario=\"form_{{$ctrl.modulo.id_modulo}}\"\n    >\n      <i class=\"fa fa-save\"></i>\n    </button>\n    <button\n      class=\"btn btn-link text-primary ml-1 pl-1 pr-1\"\n      ng-click=\"$ctrl.editarModulo($ctrl.modulo)\"\n      ng-if=\"$ctrl.options.editar===true\"\n      uib-tooltip=\"Editar\"\n    >\n      <i class=\"fa fa-edit\"></i>\n    </button>\n  </div>\n  <hr class=\"mt-2 mb-1\" />\n\n  <div style=\"overflow: auto\">\n    <table\n      class=\"table table-striped mod-t text-right\"\n      style=\"width: auto; margin-bottom: 170px\"\n    >\n      <thead>\n        <tr>\n          <th rowspan=\"2\" title=\"Nro de item\" style=\"width: 50px\">Nro.</th>\n          <th rowspan=\"2\" class=\"text-left\" style=\"width: 350px\">\n            Descripción\n          </th>\n          <th rowspan=\"2\" title=\"Unidad\" style=\"width: 100px\">Unid.</th>\n          <th rowspan=\"2\" title=\"Precio Unitario\" style=\"width: 100px\">P.U.</th>\n          <th\n            rowspan=\"2\"\n            style=\"width: 100px\"\n            ng-if=\"$ctrl.options.cabecera.version_inicial\"\n          >\n            &nbsp;\n          </th>\n          <th\n            rowspan=\"2\"\n            style=\"width: 100px\"\n            ng-if=\"$ctrl.options.cabecera.version_inicial\"\n          >\n            &nbsp;\n          </th>\n          <th\n            rowspan=\"2\"\n            style=\"width: 100px\"\n            ng-if=\"$ctrl.options.cabecera.version_anterior\"\n          >\n            &nbsp;\n          </th>\n          <th\n            rowspan=\"2\"\n            style=\"width: 100px\"\n            ng-if=\"$ctrl.options.cabecera.version_anterior\"\n          >\n            &nbsp;\n          </th>\n          <th\n            colspan=\"2\"\n            class=\"text-center\"\n            style=\"width: 200px\"\n            ng-if=\"!$ctrl.proyecto.cr_precio\"\n          >\n            Contrato Modificatorio\n          </th>\n          <th\n            colspan=\"3\"\n            class=\"text-center\"\n            style=\"width: 200px\"\n            ng-if=\"$ctrl.proyecto.cr_precio\"\n          >\n            Contrato Modificatorio\n          </th>\n          <th rowspan=\"2\" colspan=\"2\" class=\"text-center\" style=\"width: 200px\">\n            <button\n              class=\"btn btn-link text-success ml-1 pl-1 pr-1\"\n              ng-click=\"$ctrl.adicionarItem($ctrl.modulo)\"\n              ng-if=\"!$ctrl.modoVista && $ctrl.options.adicionar===true\"\n              uib-tooltip=\"Nuevo Item\"\n            >\n              <i class=\"fa fa-plus-square-o\"></i> Adicionar Item\n            </button>\n            <br />Acciones\n          </th>\n        </tr>\n        <tr>\n          <th title=\"Cantidad\" style=\"width: 100px\">Cant.</th>\n          <th style=\"width: 100px\">Total (Bs)</th>\n          <th style=\"width: 100px\" ng-if=\"$ctrl.proyecto.cr_precio\">Regu.</th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr\n          ng-repeat=\"item in $ctrl.modulo.items | orderBy:'nro_item'\"\n          ng-class=\"item.falta_ejecutar_fis === 0 && item.falta_ejecutar_fin !== 0 ? 'observado' : ''\"\n        >\n          <td\n            ng-class=\"$ctrl.getMgColor(item)\"\n            title=\"{{$ctrl.getTitle(item)}}\"\n          >\n            {{item.nro_item}}\n          </td>\n          <td class=\"modificacion-input2\">\n            <c-input\n              name=\"item_nombre_{{$index}}\"\n              ng-model=\"item.nombre\"\n              maxlength=\"150\"\n              ng-disabled=\"!item.edicion\"\n            ></c-input>\n          </td>\n          <td class=\"modificacion-input\" title=\"{{item.unidad.descripcion}}\">\n            <c-select\n              name=\"item_unidad_{{$index}}\"\n              ng-model=\"item.unidad_medida\"\n              options=\"$ctrl.unidades\"\n              key-value=\"codigo\"\n              ng-disabled=\"!item.edicion\"\n            ></c-select>\n          </td>\n          <td class=\"modificacion-input\">\n            <c-input-numeric\n              name=\"item_precio_{{$index}}\"\n              ng-model=\"item.precio_unitario\"\n              ng-minvalue=\"0\"\n              ng-maxvalue=\"999999\"\n              ng-decimals=\"2\"\n              ng-disabled=\"!item.edicion\"\n            >\n            </c-input-numeric>\n          </td>\n          <td ng-if=\"$ctrl.options.cabecera.version_inicial\">&nbsp;</td>\n          <td ng-if=\"$ctrl.options.cabecera.version_inicial\">&nbsp;</td>\n          <td ng-if=\"$ctrl.options.cabecera.version_anterior\">&nbsp;</td>\n          <td ng-if=\"$ctrl.options.cabecera.version_anterior\">&nbsp;</td>\n          <td\n            class=\"modificacion-input\"\n            ng-class=\"{'warning':(item.cantidad!=item.version_anterior.cantidad),'danger':item.error}\"\n          >\n            <c-input-numeric\n              name=\"item_cantidad_{{$index}}\"\n              ng-model=\"item.cantidad\"\n              ng-minvalue=\"1\"\n              ng-maxvalue=\"3\"\n              ng-decimals=\"2\"\n              ng-disabled=\"!item.edicion\"\n              ng-if=\"item.unidad_medida === 'UN_GLOBAL'\"\n            >\n            </c-input-numeric>\n            <c-input-numeric\n              name=\"item_cantidad_{{$index}}\"\n              ng-model=\"item.cantidad\"\n              ng-minvalue=\"1\"\n              ng-maxvalue=\"999999\"\n              ng-decimals=\"2\"\n              ng-disabled=\"!item.edicion\"\n              ng-if=\"item.unidad_medida === 'UN_PIEZA' || item.unidad_medida === 'UN_PUNTO'\"\n            >\n            </c-input-numeric>\n            <c-input-numeric\n              name=\"item_cantidad_{{$index}}\"\n              ng-model=\"item.cantidad\"\n              ng-minvalue=\"0\"\n              ng-maxvalue=\"999999\"\n              ng-decimals=\"2\"\n              ng-disabled=\"!item.edicion\"\n              ng-if=\"item.unidad_medida !== 'UN_GLOBAL' && item.unidad_medida !== 'UN_PIEZA' && item.unidad_medida !== 'UN_PUNTO'\"\n            >\n            </c-input-numeric>\n            <!-- <c-input name=\"cantidad\" ng-model=\"item.cantidad\" ng-blur=\"$ctrl.modificarCantidadItem(item)\"></c-input> -->\n          </td>\n          <td\n            ng-class=\"{'warning':(item.cantidad!=item.version_anterior.cantidad),'danger':item.error}\"\n          >\n            <strong>{{(item.cantidad*item.precio_unitario) | number:2}}</strong>\n          </td>\n          <td ng-if=\"$ctrl.proyecto.cr_precio\">\n            <span ng-if=\"item.cantidad!=item.version_anterior.cantidad\"\n              ><input\n                ng-disabled=\"$ctrl.modoVista\"\n                name=\"e_redondeo\"\n                pattern=\"(^[-]{0,1}0.\\d[\\d]{0,1}$)|^0$\"\n                placeholder=\"0.00\"\n                size=\"2\"\n                ng-model=\"item.cr_precio\"\n                ng-blur=\"$ctrl.cRecularizacion(item)\"\n            /></span>\n          </td>\n          <td style=\"width: 100px\">\n            <button\n              class=\"btn btn-link text-success ml-1 pl-1 pr-1\"\n              ng-click=\"$ctrl.verPdfItem(item,'APU')\"\n              ng-disabled=\"!item.analisis_precios\"\n              ng-if=\"item.analisis_precios\"\n              uib-tooltip=\"{{item.analisis_precios?'Ver analisis de precios unitarios':'Sin documento'}}\"\n            >\n              <i\n                class=\"fa\"\n                ng-class=\"item.analisis_precios?'fa-file-text':'fa-file-text-o'\"\n              ></i>\n            </button>\n            <button\n              class=\"btn btn-link text-success ml-1 pl-1 pr-1\"\n              ng-click=\"$ctrl.cargarPdfItem(item,'APU')\"\n              ng-if=\"!item.edicion && !$ctrl.modoVista\"\n              uib-tooltip=\"Cargar analisis de precios unitarios\"\n            >\n              <i class=\"fa fa-arrow-circle-up\"></i>\n            </button>\n            <br />\n            <button\n              class=\"btn btn-link text-success ml-1 pl-1 pr-1\"\n              ng-click=\"$ctrl.verPdfItem(item,'ESQ')\"\n              ng-disabled=\"!item.doc_esquema\"\n              ng-if=\"item.doc_esquema\"\n              uib-tooltip=\"{{item.doc_esquema?'Ver esquema':'Sin documento'}}\"\n            >\n              <i\n                class=\"fa\"\n                ng-class=\"item.doc_esquema?'fa-file-text':'fa-file-text-o'\"\n              ></i>\n            </button>\n            <button\n              class=\"btn btn-link text-success ml-1 pl-1 pr-1\"\n              ng-click=\"$ctrl.cargarPdfItem(item,'ESQ')\"\n              ng-if=\"!item.edicion && !$ctrl.modoVista\"\n              uib-tooltip=\"Cargar esquema\"\n            >\n              <i class=\"fa fa-upload\"></i>\n            </button>\n          </td>\n          <td style=\"width: 100px\">\n            <button\n              class=\"btn btn-link text-info ml-1 pl-1 pr-1\"\n              ng-click=\"$ctrl.verPdfItem(item,'ET')\"\n              ng-disabled=\"!item.especificaciones\"\n              ng-if=\"item.especificaciones\"\n              uib-tooltip=\"{{item.especificaciones?'Ver especificaciones técnicas':'Sin documento'}}\"\n            >\n              <i\n                class=\"fa\"\n                ng-class=\"item.especificaciones?'fa-file-text':'fa-file-text-o'\"\n              ></i>\n            </button>\n            <button\n              class=\"btn btn-link text-info ml-1 pl-1 pr-1\"\n              ng-click=\"$ctrl.cargarPdfItem(item,'ET')\"\n              ng-if=\"!item.edicion && !$ctrl.modoVista\"\n              uib-tooltip=\"Cargar especificaciones\"\n            >\n              <i class=\"fa fa-upload\"></i>\n            </button>\n            <br />\n            <button\n              class=\"btn btn-link text-primary ml-1 pl-1 pr-1\"\n              ng-click=\"item.edicion = true\"\n              ng-if=\"!item.edicion && !$ctrl.modoVista\"\n              uib-tooltip=\"Editar\"\n            >\n              <i class=\"fa fa-edit\"></i>\n            </button>\n            <button\n              class=\"btn btn-link text-success ml-1 pl-1 pr-1\"\n              ng-click=\"!item.id_item? $ctrl.guardarItem(item, $index, $parent.$parent.$index, modulo) : $ctrl.actualizarItem(item, $index, modulo)\"\n              ng-if=\"item.edicion && !$ctrl.modoVista\"\n              uib-tooltip=\"Guardar\"\n            >\n              <i class=\"fa fa-save\"></i>\n            </button>\n            <button\n              class=\"btn btn-link text-danger ml-1 pl-1 pr-1\"\n              ng-click=\"$ctrl.eliminarItem(item, $index, modulo)\"\n              ng-if=\"!$ctrl.modoVista\"\n              uib-tooltip=\"Eliminar\"\n            >\n              <i class=\"fa fa-trash-o\"></i>\n            </button>\n          </td>\n        </tr>\n      </tbody>\n    </table>\n  </div>\n</ng-form>\n"

/***/ }),
/* 630 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\"><i class=\"fa fa-table\"></i> Cómputos Métricos - {{$ctrl.supervision.proyecto.nombre}}</h5>\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cerrar()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<div class=\"modal-body\">\n\n  <computo-proyecto supervision=\"$ctrl.supervision\"\n                    item=\"$ctrl.item\"                    \n                    computos=\"$ctrl.computos\"\n                    modo-vista=\"$ctrl.modoVista\"\n                    existe-cambios=$ctrl.existeCambiosItem\n                    modificados=\"$ctrl.modificados\">\n  </computo-proyecto>\n\n</div>\n\n<div class=\"modal-footer\">\n  <button type=\"button\" md-effect class=\"btn btn-secondary\" ng-click=\"$ctrl.cerrar()\" ng-if=\"!$ctrl.modoVista\">\n    <i class=\"fa fa-close\"></i> Cancelar\n  </button>\n  <button type=\"submit\" md-effect class=\"btn btn-primary\" validar-formulario=\"formAdjudicacion\" ng-click=\"$ctrl.modoVista? $ctrl.cerrar() : $ctrl.guardar()\">\n    <i class=\"fa fa-check\"></i> Aceptar\n  </button>\n</div>\n"

/***/ }),
/* 631 */
/***/ (function(module, exports) {

	module.exports = "<section\n  class=\"fs-sm\"\n  nng-if=\"$ctrl.supervision.monto_total_por_ejecutar === 0\"\n>\n  <form name=\"form2\">\n    <h6 class=\"title-section m-top\"><i class=\"fa fa-list\"></i> Formulario 2</h6>\n    <div class=\"row\">\n      <div class=\"col-md-12 text-left\">\n        <h5 class=\"text-left\">Detalle de Multas</h5>\n\n        <div class=\"col-md-12 text-left\">\n          <c-textarea\n            label=\"\"\n            name=\"dias_retraso\"\n            label=\"Cantidad\"\n            ng-model=\"$ctrl.supervision.formulario.form2.dias_retraso\"\n            rows=\"7\"\n            ng-minlength=\"5\"\n            maxlength=\"3000\"\n            ng-required=\"true\"\n            ng-blur=\"$ctrl.updateText(form2)\"\n            ng-disabled=\"!$ctrl.descuento\"\n          >\n          </c-textarea>\n        </div>\n        <table class=\"mod-t mod-t-b mb-0 table-responsive\">\n          <tbody>\n            <!-- <tr>\n              <th>Detalle Multas</th>\n              <td>\n                 <c-input-numeric name=\"dias_retraso\" label=\"Cantidad\" \n                ng-model=\"$ctrl.supervision.formulario.form2.dias_retraso\" ng-blur=\"$ctrl.updateForm(form2.dias_retraso)\"\n                    ng-minvalue=\"0\" ng-maxvalue=\"99999\" ng-decimals=\"0\" ng-required=\"true\" ng-disabled=\"!$ctrl.descuento\">\n                  </c-input-numeric> \n                 \n              </td>\n            </tr> -->\n            <tr>\n              <th>Monto Total Descuento por Multas</th>\n              <td>\n                <c-input-numeric\n                  name=\"descuento_x_multas\"\n                  label=\"Bs\"\n                  ng-model=\"$ctrl.supervision.formulario.form2.descuento_x_multas\"\n                  ng-blur=\"$ctrl.updateForm(form2.descuento_x_multas)\"\n                  ng-minvalue=\"0\"\n                  ng-maxvalue=\"9999999\"\n                  ng-decimals=\"2\"\n                  ng-required=\"true\"\n                  ng-disabled=\"!$ctrl.descuento\"\n                ></c-input-numeric>\n              </td>\n            </tr>\n          </tbody>\n        </table>\n      </div>\n    </div>\n  </form>\n</section>\n<section class=\"fs-sm\">\n  <form name=\"form4\">\n    <h6 class=\"title-section m-top\"><i class=\"fa fa-list\"></i> Formulario 4</h6>\n    <div\n      class=\"alert alert-info\"\n      ng-click=\"$ctrl.info=1\"\n      style=\"cursor: pointer\"\n    >\n      <i class=\"fa fa-info-circle\"></i>\n      <span>Datos necesarios para el Formulario</span>\n    </div>\n    <h4 class=\"text-left\">Representante legal</h4>\n    <div class=\"row\">\n      <div class=\"col-md-12 text-left\">\n        <table class=\"mod-t mod-t-b mb-0 table-responsive\">\n          <tbody>\n            <tr>\n              <th>\n                {{$ctrl.repLegal.nombreCompleto||($ctrl.repLegal.persona.nombre)}}\n              </th>\n              <td>\n                <c-input\n                  name=\"cargo\"\n                  label=\"Cargo actual\"\n                  ng-model=\"$ctrl.repLegal.cargo_actual\"\n                  maxlength=\"150\"\n                  ng-disabled=\"$ctrl.modoVista\"\n                  ng-required=\"true\"\n                  ng-blur=\"$ctrl.updateCargoRep()\"\n                ></c-input>\n              </td>\n              <td>\n                <c-input\n                  name=\"telefonor\"\n                  label=\"Teléfono\"\n                  ng-model=\"$ctrl.repLegal.persona.telefono\"\n                  maxlength=\"20\"\n                  ng-disabled=\"$ctrl.modoVista\"\n                  ng-required=\"true\"\n                  ng-blur=\"$ctrl.updateCargoRep()\"\n                ></c-input>\n              </td>\n            </tr>\n          </tbody>\n        </table>\n      </div>\n    </div>\n    <h4 class=\"text-left\">\n      Equipo técnico encargado de la ejecución y seguimiento de la obra\n    </h4>\n    <div class=\"row\">\n      <div class=\"col-md-12 text-left\">\n        <table class=\"mod-t mod-t-b mb-0 table-responsive\">\n          <tbody>\n            <tr ng-repeat=\"empleado in $ctrl.empleados\">\n              <th>{{empleado.cargo_actual}}</th>\n              <td>\n                {{empleado.persona.nombres}}\n                {{empleado.persona.primer_apellido}}\n                {{empleado.persona.segundo_apellido}}\n              </td>\n              <th>Teléfono</th>\n              <td class=\"modificacion-input\">\n                <c-input\n                  name=\"telefono{{$index}}\"\n                  ng-model=\"empleado.persona.telefono\"\n                  maxlength=\"20\"\n                  ng-disabled=\"$ctrl.modoVista\"\n                  ng-required=\"true\"\n                  ng-blur=\"$ctrl.updatePhone(empleado)\"\n                ></c-input>\n              </td>\n            </tr>\n            <tr>\n              <th>FISCAL DE OBRA</th>\n              <td>\n                {{$ctrl.fiscal.usuario.persona.nombres}}\n                {{$ctrl.fiscal.usuario.persona.primer_apellido}}\n                {{$ctrl.fiscal.usuario.persona.segundo_apellido}}\n              </td>\n              <th>Teléfono</th>\n              <td class=\"modificacion-input\">\n                <c-input\n                  name=\"telefonofiscal\"\n                  ng-model=\"$ctrl.fiscal.usuario.persona.telefono\"\n                  maxlength=\"20\"\n                  ng-disabled=\"$ctrl.modoVista\"\n                  ng-required=\"true\"\n                  ng-blur=\"$ctrl.updatePhone($ctrl.fiscal.usuario)\"\n                ></c-input>\n              </td>\n            </tr>\n            <tr>\n              <th>SUPERVISOR DE OBRA</th>\n              <td>\n                {{$ctrl.supervisor.usuario.persona.nombres}}\n                {{$ctrl.supervisor.usuario.persona.primer_apellido}}\n                {{$ctrl.supervisor.usuario.persona.segundo_apellido}}\n              </td>\n              <th>Teléfono</th>\n              <td class=\"modificacion-input\">\n                <c-input\n                  name=\"telefonosupervisor\"\n                  ng-model=\"$ctrl.supervisor.usuario.persona.telefono\"\n                  maxlength=\"20\"\n                  ng-disabled=\"$ctrl.modoVista\"\n                  ng-required=\"true\"\n                  ng-blur=\"$ctrl.updatePhone($ctrl.supervisor.usuario)\"\n                ></c-input>\n              </td>\n            </tr>\n          </tbody>\n        </table>\n      </div>\n    </div>\n    <hr />\n    <h5 class=\"text-left\">\n      Descripción de los trabajos realizados en el periodo\n    </h5>\n    <div class=\"row\">\n      <div class=\"col-md-12 text-left\">\n        <c-textarea\n          label=\"\"\n          name=\"descripcion\"\n          ng-model=\"$ctrl.supervision.formulario.form4.descripcion\"\n          rows=\"7\"\n          ng-minlength=\"20\"\n          maxlength=\"3000\"\n          ng-required=\"true\"\n          ng-blur=\"$ctrl.updateText(form4)\"\n          ng-if=\"!$ctrl.modoVista\"\n        >\n        </c-textarea>\n        <p\n          ng-if=\"$ctrl.modoVista\"\n          style=\"white-space: pre-wrap; background-color: #eee\"\n          class=\"text-justify\"\n        >\n          {{$ctrl.supervision.formulario.form4.descripcion}}\n        </p>\n      </div>\n    </div>\n  </form>\n</section>\n<section class=\"fs-sm\">\n  <h6 class=\"title-section m-top\"><i class=\"fa fa-list\"></i> Formulario 6</h6>\n  <div class=\"alert alert-info\" ng-click=\"$ctrl.info=1\" style=\"cursor: pointer\">\n    <i class=\"fa fa-info-circle\"></i>\n    <span>Datos necesarios para el Formulario</span>\n  </div>\n  <h5 class=\"text-left\">Resumen ejecutivo</h5>\n  <form name=\"form6\">\n    <div class=\"row\">\n      <div class=\"col-md-12 text-left\">\n        <c-textarea\n          label=\"\"\n          name=\"resumen\"\n          ng-model=\"$ctrl.supervision.formulario.form6.resumen\"\n          rows=\"7\"\n          ng-minlength=\"20\"\n          maxlength=\"3000\"\n          ng-required=\"true\"\n          ng-blur=\"$ctrl.updateText(form6)\"\n          ng-if=\"!$ctrl.modoVista\"\n        >\n        </c-textarea>\n        <p\n          ng-if=\"$ctrl.modoVista\"\n          style=\"white-space: pre-wrap; background-color: #eee\"\n          class=\"text-justify\"\n        >\n          {{$ctrl.supervision.formulario.form6.resumen}}\n        </p>\n      </div>\n    </div>\n  </form>\n</section>\n<style>\n  table th {\n    padding: 4px 6px;\n  }\n  .modificacion-input2 .md-form-group {\n    margin-top: 0rem;\n    margin-bottom: 0;\n  }\n  .modificacion-input .md-form-group {\n    margin-top: 0rem;\n    margin-bottom: 0;\n    width: 150px;\n    float: right;\n  }\n  .modificacion-input .md-form-group input {\n    text-align: right;\n  }\n  .td-cinput-center .md-form-group {\n    margin: 0 auto;\n    width: 90px;\n  }\n  .td-cinput-center .md-form-group input {\n    text-align: center;\n  }\n</style>\n"

/***/ }),
/* 632 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"fs-sm\" ng-if=\"$ctrl.historialEmpresas\">\n  <h3 class=\"text-center\">\n    Historial de Empresas\n  </h3>\n  <div class=\"row\">\n    <div class=\"col-md-6 text-left\">\n      <table class=\"table mod-t mod-t-b mb-0\">\n        <tbody>\n          <tr ng-repeat=\"avance in $ctrl.historico.proyectos\">\n            <th ng-dblclick=\"$ctrl.verSupervision(avance)\" title=\"{{avance.empresa}}\">Avance Físico ({{$index+1}}° Empresa)</th>\n            <td>{{ avance.total_acumulado_fis/$ctrl.historico.monto_total_proyecto*100 | number:2 }}%</td>\n          </tr>\n          <tr>\n            <th>Total avance físico:</th>\n            <td>{{ $ctrl.historico.porcentaje_total_fis | number:2}}%</td>\n          </tr>\n        </tbody>\n      </table>\n    </div>\n    <div class=\"col-md-6\">\n      <table class=\"table mod-t mod-t-b mb-0\">\n        <tbody>\n          <tr ng-repeat=\"avance in $ctrl.historico.proyectos\">\n            <th ng-dblclick=\"$ctrl.verSupervision(avance)\" title=\"{{avance.empresa}}\">Avance Financiero ({{$index+1}}° Empresa)</th>\n            <td>{{ avance.monto_avance/$ctrl.historico.monto_total_proyecto*100 | number:2 }}%</td>\n          </tr>\n          <tr>\n            <th>Total avance financiero:</th>\n            <td>{{ $ctrl.historico.porcentaje_total_fin | number:2 }}%</td>\n          </tr>\n        </tbody>\n      </table>\n    </div>\n  </div>\n</section>"

/***/ }),
/* 633 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\"><i class=\"fa fa-plus-circle\"></i> Foto de la supervisión número {{$ctrl.foto.nro}}</h5>\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cerrar()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<div class=\"modal-body\">\n  <div class=\"row mb-3\">\n    <div class=\"col\">\n      <button md-effect type=\"button\" class=\"btn btn-info\" ng-click=\"$ctrl.irAPosicion('anterior')\" ng-disabled=\"$ctrl.foto.nro <= 1\">\n        <i class=\"fa fa-angle-double-left\" aria-hidden=\"true\"></i> Anterior\n      </button>\n      <button md-effect type=\"button\" class=\"btn btn-info\" ng-click=\"$ctrl.irAPosicion('siguiente')\" ng-disabled=\"$ctrl.foto.nro >= $ctrl.fotos.length\">\n        Siguiente <i class=\"fa fa-angle-double-right\" aria-hidden=\"true\"></i>\n      </button>\n    </div>\n  </div>\n\n  <figure class=\"text-center\">\n    <image-viewer id=\"fotosMovil\" base64=\"$ctrl.fotos[0].base64\" height=\"300\" ng-if=\"$ctrl.foto.nro === 1\"></image-viewer>\n    <image-viewer id=\"fotosMovil\" base64=\"$ctrl.fotos[1].base64\" height=\"300\" ng-if=\"$ctrl.foto.nro === 2\"></image-viewer>\n    <image-viewer id=\"fotosMovil\" base64=\"$ctrl.fotos[2].base64\" height=\"300\" ng-if=\"$ctrl.foto.nro === 3\"></image-viewer>\n    <!-- <img ng-src=\"data:image/jpg;base64, {{ $ctrl.foto.base64 }}\" alt=\"Foto 1\" width=\"100%\"> -->\n  </figure>\n</div>\n\n<div class=\"modal-footer\">\n  <button type=\"submit\" md-effect class=\"btn btn-primary\" ng-click=\"$ctrl.cerrar()\">\n    <i class=\"fa fa-check\"></i> Aceptar\n  </button>\n</div>\n"

/***/ }),
/* 634 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\n  <div class=\"col-lg-4 col-md-6 col-sm-12\" ng-repeat=\"foto in $ctrl.fotos\">\n    <figure ng-dblclick=\"$ctrl.mostrarPopup(foto)\">\n      <span ng-if=\"!foto.mostrar\">Cargando ...</span>\n      <div ng-if=\"foto.mostrar\" class=\"foto\">\n        <img ng-src=\"data:image/jpg;base64, {{ foto.base64 }}\" alt=\"Foto {{foto.nro}}\" height=\"300\" width=\"100%\">\n        <div class=\"detalles\">\n          <span class=\"titulo\">Foto supervisión {{foto.nro}}</span>\n          <button md-effect type=\"button\" class=\"btn btn-sm btn-success pull-right\" ng-click=\"$ctrl.mostrarPopup(foto)\" uib-tooltip=\"Ver foto\">\n            <i class=\"fa fa-eye\"></i>\n          </button>\n          <button md-effect type=\"button\" class=\"btn btn-sm btn-primary pull-right\" ng-click=\"$ctrl.mostrarUbicacion(foto)\" uib-tooltip=\"Ver ubicación\">\n            <i class=\"fa fa-map-marker\"></i>\n          </button>\n          <button md-effect type=\"button\" class=\"btn btn-sm btn-danger pull-right\" ng-click=\"$ctrl.eliminarFoto(foto)\" uib-tooltip=\"Recargar datos de la fotografia\" ng-if=\"$ctrl.puedeEliminar\">\n            <i class=\"fa fa-trash\"></i>\n          </button>\n        </div>\n      </div>\n    </figure>\n  </div>\n</div>\n"

/***/ }),
/* 635 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\"><i class=\"fa fa-table\"></i> Confirmación previa a la aprobación de la planilla de avance</h5>\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cerrar()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<div class=\"modal-body\">\n  <p>\n    El avance físico {{$ctrl.items.length > 1 ? 'de los items listados' : 'del item listado'}} a continuación está concluído, sin embargo el avance financiero aún no está cerrado.\n  </p>\n\n  <div class=\"crud-table\">\n    <table class=\"table table-hover table-striped table-responsive fs-sm\">\n      <thead>\n        <tr>\n          <th rowspan=\"2\" title=\"Nro de item\">Nro</th>\n          <th rowspan=\"2\" class=\"text-left\">Descripción</th>\n          <th rowspan=\"2\" title=\"Unidad\">Unid.</th>\n          <th rowspan=\"2\" title=\"Cantidad\">Cant.</th>\n          <th rowspan=\"2\" title=\"Precio Unitario\">P.U.</th>\n          <th rowspan=\"2\">Total(Bs)</th>\n          <th colspan=\"2\" class=\"text-center\">Volumenes de avance</th>\n          <th colspan=\"2\" class=\"text-center\">Avance financiero</th>\n        </tr>\n        <tr>\n          <th title=\"Total Acumulado\">T.A.</th>\n          <th title=\"Falta ejecutar\">F.E.</th>\n          <th title=\"Total Acumulado\">T.A.</th>\n          <th title=\"Falta ejecutar\">F.E.</th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr ng-repeat=\"item in $ctrl.items\">\n          <td>{{item.nro_item}}</td>\n          <td>{{item.nombre}}</td>\n          <td>{{item.unidad.nombre}}</td>\n          <td>{{item.cantidad | number:2}}</td>\n          <td>{{item.precio_unitario | number:2}}</td>\n          <td>{{item.total | number:2}}</td>\n          <td>{{item.total_acumulado_fis | number:2}}</td>\n          <td>{{item.falta_ejecutar_fis}}</td>\n          <td>{{item.total_acumulado_fin | number:2}}</td>\n          <td>{{item.falta_ejecutar_fin}}</td>\n        </tr>\n      </tbody>\n    </table>\n  </div>\n  <p>\n    Al aprobar la planilla de avance se procederá a cerrar el avance financiero {{$ctrl.items.length > 1 ? 'de los items mencionados' : 'del item mencionado'}}.\n  </p>\n\n  <p class=\"resaltado\" ng-if=\"$ctrl.data.supervision.c_redondeo\">\n    La planilla de avance esta marcada como regularización, por lo que se generará los archivos tal cual se muestra actualmente.\n  </p>\n  <p class=\"resaltado\">\n    Si está seguro/a de aprobar la planilla de avance presione la opción \"<strong>APROBAR</strong>\" en caso contrario \"<strong>CANCELAR</strong>\".\n  </p>\n</div>\n\n<div class=\"modal-footer\">\n  <button type=\"button\" md-effect class=\"btn btn-secondary\" ng-click=\"$ctrl.cerrar()\" ng-if=\"!$ctrl.modoVista\">\n    <i class=\"fa fa-close\"></i> Cancelar\n  </button>\n  <button type=\"submit\" md-effect class=\"btn btn-primary\" ng-click=\"$ctrl.aprobar()\">\n    <i class=\"fa fa-check\"></i> Aprobar\n  </button>\n</div>\n"

/***/ }),
/* 636 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container px-3 planilla-proy\">\n  <h2 class=\"page-title\">\n    <i class=\"fa fa-bars\"></i> Proyecto\n    <small><strong>{{$ctrl.proyecto.nombre}}</strong></small>\n  </h2>\n  <div class=\"card\">\n    <div class=\"card-body\">\n      <div class=\"row mx-0\">\n        <div\n          style=\"font-size: 20px\"\n          uib-tooltip=\"Volver atrás\"\n          ng-click=\"$ctrl.irAtras()\"\n        >\n          <i class=\"fa fa-reply\"></i>\n        </div>\n      </div>\n      <h4 class=\"text-center\">\n        <strong\n          >{{$ctrl.proyecto.documentacion_exp.datos_asociacion.nombre_asociacion\n          || $ctrl.proyecto.empresa.nombre}}</strong\n        >\n      </h4>\n      <h3 class=\"text-center\">\n        Planilla de avance de obra Nro. {{$ctrl.supervision.nro_supervision}}\n      </h3>\n      <div class=\"texto\">\n        <form name=\"fecha_fin\">\n          <table align=\"center\">\n            <tr>\n              <td>\n                Del {{$ctrl.supervision.fecha_inicio | date : 'dd/MM/yyyy'}} al\n                <!--{{!$ctrl.supervision.fecha_fin ? '-' : $ctrl.supervision.fecha_fin | date : 'dd/MM/yyyy'}} <br>-->\n              </td>\n              <td style=\"width: 100px\">\n                <c-date\n                  name=\"fecha_fin\"\n                  label=\"Fecha de fin\"\n                  ng-model=\"$ctrl.supervision.fecha_fin\"\n                  ng-required=\"true\"\n                  max-date=\"$ctrl.validacion.fecha_max\"\n                  min-date=\"$ctrl.validacion.fecha_fin_min\"\n                  ng-disabled=\"!$ctrl.Supervision.esEditable('fecha_fin')\"\n                  mensaje-max-date=\"La fecha no puede ser mayor a la fecha recepción\"\n                  mensaje-min-date=\"La fecha no puede ser menor a la fecha inicio\"\n                >\n                </c-date>\n              </td>\n            </tr>\n          </table>\n        </form>\n        <p class=\"text-center\">\n          <span\n            class=\"resaltado\"\n            ng-if=\"$ctrl.supervision.monto_total_por_ejecutar === 0\"\n            >Planilla de cierre</span\n          >\n        </p>\n        <section>\n          <a href=\"\">\n            <h6\n              class=\"title-section m-top\"\n              ng-click=\"$ctrl.datosProyectoIsCollapsed = !$ctrl.datosProyectoIsCollapsed\"\n            >\n              <i class=\"fa fa-hand-o-right\"></i> Datos del proyecto\n            </h6>\n          </a>\n          <div uib-collapse=\"$ctrl.datosProyectoIsCollapsed\">\n            <div class=\"row\">\n              <div class=\"col-md-4 text-left\">\n                <table class=\"table mod-t mod-t-b mb-0\">\n                  <tbody>\n                    <tr>\n                      <th class=\"text-right\">Nombre:</th>\n                      <td>{{$ctrl.proyecto.nombre}}</td>\n                    </tr>\n                    <tr>\n                      <th class=\"text-right\">Departamento:</th>\n                      <td>{{$ctrl.proyecto.dpa.departamento.nombre}}</td>\n                    </tr>\n                    <tr>\n                      <th class=\"text-right\">Provincia:</th>\n                      <td>{{$ctrl.proyecto.dpa.provincia.nombre}}</td>\n                    </tr>\n                    <tr>\n                      <th class=\"text-right\">Municipio:</th>\n                      <td>{{$ctrl.proyecto.dpa.municipio.nombre}}</td>\n                    </tr>\n                    <tr>\n                      <th class=\"text-right\">Beneficiario:</th>\n                      <td>{{$ctrl.proyecto.entidad_beneficiaria}}</td>\n                    </tr>\n                  </tbody>\n                </table>\n              </div>\n              <div class=\"col-md-4\">\n                <table class=\"table mod-t mod-t-b mb-0\">\n                  <tbody>\n                    <tr>\n                      <th class=\"text-right\">Monto convenio:</th>\n                      <td class=\"text-right\">\n                        {{$ctrl.proyecto.monto_total_convenio | number:2}}\n                      </td>\n                    </tr>\n                    <tr>\n                      <th class=\"text-right\">Monto contrato:</th>\n                      <td class=\"text-right\">\n                        {{$ctrl.proyecto.monto_contractual | number:2}}\n                      </td>\n                    </tr>\n                    <tr\n                      ng-if=\"$ctrl.supervision.proyecto.monto_total!=$ctrl.proyecto.monto_contractual && $ctrl.proyecto.monto_contractual\"\n                    >\n                      <th class=\"text-right\">Monto total con modificación:</th>\n                      <td class=\"text-right\">\n                        {{$ctrl.supervision.proyecto.monto_total | number:2}}\n                      </td>\n                    </tr>\n                    <tr>\n                      <th class=\"text-right\">\n                        Anticipo {{$ctrl.proyecto.porcentaje_anticipo |\n                        number:2}}%:\n                      </th>\n                      <td class=\"text-right\">\n                        {{$ctrl.proyecto.anticipo | number:2}}\n                      </td>\n                    </tr>\n                    <tr\n                      ng-repeat=\"supervision in $ctrl.supervision.supervisiones_anteriores\"\n                      ng-if=\"($index+1)!==$ctrl.supervision.nro_supervision\"\n                    >\n                      <th class=\"text-right\">\n                        Monto {{supervision.numero}} desembolso:\n                      </th>\n                      <td class=\"text-right\">\n                        {{supervision.desembolso | number:2}}\n                      </td>\n                    </tr>\n                    <tr>\n                      <th class=\"text-right\">TOTAL DESEMBOLSADO:</th>\n                      <td class=\"text-right\">\n                        <strong\n                          >{{$ctrl.supervision.monto_desembolso_total |\n                          number:2}}</strong\n                        >\n                      </td>\n                    </tr>\n                  </tbody>\n                </table>\n              </div>\n              <div class=\"col-md-4\">\n                <table class=\"table mod-t mod-t-b mb-0\">\n                  <tbody>\n                    <tr>\n                      <th class=\"text-right\">\n                        Fecha inicio de obras/<br />\n                        Libro de ordenes:\n                      </th>\n                      <td>\n                        {{$ctrl.proyecto.orden_proceder | date : 'dd/MM/yyyy'}}\n                      </td>\n                    </tr>\n                    <tr>\n                      <th class=\"text-right\">Plazo de Ejecución</th>\n                      <td>{{$ctrl.proyecto.plazo_ejecucion}}</td>\n                    </tr>\n                    <tr>\n                      <th class=\"text-right\">Ampliación de Plazo</th>\n                      <td>\n                        {{$ctrl.proyecto.plazo_ampliacion_total+$ctrl.proyecto.plazo_ampliacion.por_volumenes+$ctrl.proyecto.plazo_ampliacion.por_compensacion\n                        || 0}}\n                      </td>\n                    </tr>\n                    <tr>\n                      <th class=\"text-right\">\n                        Fecha prevista p/Recepción Provisional\n                      </th>\n                      <td>\n                        {{($ctrl.proyecto.fecha_recepcion_provisional) | date :\n                        'dd/MM/yyyy'}}\n                      </td>\n                    </tr>\n                    <tr>\n                      <th class=\"text-right\">\n                        Fecha prevista p/Recepción definitiva\n                      </th>\n                      <td>\n                        {{($ctrl.proyecto.fecha_recepcion_definitiva) | date :\n                        'dd/MM/yyyy'}}\n                        <div\n                          ng-if=\"$ctrl.supervision.estado_supervision=='EN_SUPERVISOR' && $ctrl.supervision.monto_total_por_ejecutar === 0\"\n                        >\n                          <input\n                            type=\"number\"\n                            ng-model=\"$ctrl.proyecto.plazo_ejecucion_definitivo\"\n                            ng-blur=\"$ctrl.guardarPlazoDefinitivo()\"\n                            maxlength=\"3\"\n                            size=\"3\"\n                            style=\"\n                              width: 43px;\n                              border: none;\n                              border-bottom: 1px dotted #bbb;\n                            \"\n                          />Días\n                        </div>\n                      </td>\n                    </tr>\n                  </tbody>\n                </table>\n              </div>\n            </div>\n          </div>\n        </section>\n      </div>\n\n      <section>\n        <h6 class=\"title-section m-top\">\n          <i class=\"fa fa-list\"></i> Items del proyecto\n        </h6>\n        <div class=\"row\">\n          <div class=\"col-md-6\">\n            <div class=\"alert alert-info text-white\">\n              <i class=\"fa fa-info-circle\"></i>\n              <span\n                >Puede hacer doble click a un item para\n                <strong\n                  >{{$ctrl.esEditable? 'realizar' : 'revisar'}} su cómputo\n                  métrico</strong\n                >.</span\n              >\n            </div>\n          </div>\n          <div\n            class=\"col-md-6\"\n            ng-if=\"$ctrl.proyecto.doc_especificaciones_tecnicas\"\n          >\n            <button\n              md-effect\n              type=\"button\"\n              class=\"btn btn-info\"\n              download-file=\"{{$ctrl.urlDescEspTecnicas}}\"\n              file-name=\"Especificaciones técnicas\"\n              uib-tooltip=\"Especificaciones técnicas\"\n              tooltip-placement=\"bottom\"\n            >\n              <i class=\"fa fa-file-text-o\"></i> E. Técnicas\n            </button>\n            <button\n              md-effect\n              type=\"button\"\n              class=\"btn btn-info\"\n              download-file=\"{{$ctrl.urlDescPlanilla}}\"\n              file-name=\"Planilla de avance nro {{$ctrl.supervision.nro_supervision}}\"\n              uib-tooltip=\"Planilla de avance nro {{$ctrl.supervision.nro_supervision}}\"\n              tooltip-placement=\"bottom\"\n              ng-if=\"$ctrl.supervision.version_proyecto\"\n            >\n              <i class=\"fa fa-file-text-o\"></i> Planilla\n            </button>\n            <button\n              md-effect\n              type=\"button\"\n              class=\"btn btn-info\"\n              download-file=\"{{$ctrl.urlDescComputosResumen}}\"\n              file-name=\"Resúmen de cómputos métricos de la planilla\"\n              uib-tooltip=\"Resúmen de cómputos métricos de la planilla\"\n              tooltip-placement=\"bottom\"\n              ng-if=\"$ctrl.supervision.version_proyecto\"\n            >\n              <i class=\"fa fa-table\"></i> Cómputos\n            </button>\n          </div>\n        </div>\n\n        <div class=\"row mt-2 mb-2\">\n          <div class=\"col-lg-6 col-md-12 mb-2\">\n            <div class=\"btn-group opciones\">\n              <label\n                md-effect\n                class=\"btn btn-primary\"\n                btn-checkbox\n                ng-model=\"$ctrl.filtroItems\"\n                uib-btn-radio=\"'TODOS'\"\n                >Todos</label\n              >\n              <label\n                md-effect\n                class=\"btn btn-primary\"\n                ng-model=\"$ctrl.filtroItems\"\n                uib-btn-radio=\"'COMPLETADOS'\"\n                >Completados</label\n              >\n              <label\n                md-effect\n                class=\"btn btn-primary\"\n                ng-model=\"$ctrl.filtroItems\"\n                uib-btn-radio=\"'INCOMPLETOS'\"\n                >Por completar</label\n              >\n              <label\n                md-effect\n                class=\"btn btn-primary\"\n                ng-model=\"$ctrl.filtroItems\"\n                uib-btn-radio=\"'PARA_ENVIAR'\"\n                >Planilla</label\n              >\n            </div>\n          </div>\n          <div class=\"col-lg-6 col-md-12 mt-2\">\n            <label class=\"custom-control custom-checkbox\">\n              <span class=\"custom-control-indicator success\"></span\n              ><span>Completado</span>\n            </label>\n            <label class=\"custom-control custom-checkbox\">\n              <span class=\"custom-control-indicator info\"></span\n              ><span>Con avance</span>\n            </label>\n            <label class=\"custom-control custom-checkbox\">\n              <span class=\"custom-control-indicator primary\"></span\n              ><span>Sin avance</span>\n            </label>\n            <label class=\"custom-control custom-checkbox\">\n              <span class=\"custom-control-indicator warning\"></span\n              ><span>Con avance en anterior(es) planilla(s)</span>\n            </label>\n          </div>\n        </div>\n\n        <div class=\"text-right\">\n          <button\n            md-effect\n            type=\"button\"\n            class=\"btn\"\n            ng-class=\"{'btn-success':$ctrl.supervision.c_redondeo}\"\n            uib-tooltip=\"\"\n            tooltip-placement=\"bottom\"\n            ng-if=\"$ctrl.esTecnico\"\n            ng-click=\"$ctrl.agregarQuitarCampo()\"\n          >\n            <i class=\"fa fa-table\"></i> Agregar campo para regularizaciones\n          </button>\n        </div>\n\n        <div\n          ng-repeat=\"modulo in $ctrl.supervision.modulos\"\n          ng-show=\"modulo.show\"\n          class=\"texto\"\n        >\n          <div\n            class=\"my-1 mod-h\"\n            ng-click=\"modulo.isCollapsed = !modulo.isCollapsed\"\n          >\n            <span\n              uib-tooltip=\"Click para ocultar/mostrar sus items\"\n              tooltip-placement=\"right\"\n            >\n              <strong>Módulo:</strong> {{modulo.nombre}}\n            </span>\n          </div>\n          <hr class=\"mt-2 mb-1\" />\n          <div class=\"table-responsive\">\n            <div uib-collapse=\"modulo.isCollapsed\">\n              <table\n                class=\"table table-striped mod-t text-right\"\n                style=\"width:{{1820+$ctrl.supervision.proyecto.proyecto_historico.length*270}}px;max-width:none\"\n              >\n                <thead>\n                  <tr>\n                    <th rowspan=\"2\" title=\"Nro de item\" style=\"width: 50px\">\n                      Nro\n                    </th>\n                    <th rowspan=\"2\" class=\"text-left\" style=\"width: 350px\">\n                      Descripción\n                    </th>\n                    <th rowspan=\"2\" title=\"Unidad\" style=\"width: 70px\">\n                      Unid.\n                    </th>\n                    <th\n                      colspan=\"3\"\n                      class=\"text-center\"\n                      style=\"width: 270px\"\n                      ng-if=\"$ctrl.supervision.version_proyecto===null || version.version<=$ctrl.supervision.version_proyecto\"\n                      ng-repeat=\"version in $ctrl.supervision.proyecto.proyecto_historico\"\n                    >\n                      {{version.tipo_modificacion_proyecto.nombre}}\n                      {{version.tipo_modificacion_proyecto.numero}}\n                    </th>\n                    <th\n                      colspan=\"3\"\n                      class=\"text-center\"\n                      style=\"width: 270px\"\n                      ng-if=\"$ctrl.supervision.version_proyecto===null || $ctrl.supervision.proyecto.version<=$ctrl.supervision.version_proyecto\"\n                    >\n                      {{$ctrl.supervision.version_proyecto==1 ||\n                      $ctrl.supervision.proyecto.version === 1 ? 'Contrato\n                      Original':\n                      $ctrl.proyecto.tipo_modificacion_proyecto.nombre+'\n                      '+$ctrl.proyecto.tipo_modificacion_proyecto.numero}}\n                    </th>\n                    <th colspan=\"4\" class=\"text-center\" style=\"width: 360px\">\n                      Volumenes de avance\n                    </th>\n                    <th\n                      colspan=\"4\"\n                      class=\"text-center\"\n                      style=\"width: 360px\"\n                      ng-if=\"!$ctrl.supervision.c_redondeo\"\n                    >\n                      Avance financiero\n                    </th>\n                    <th\n                      colspan=\"5\"\n                      class=\"text-center\"\n                      style=\"width: 360px\"\n                      ng-if=\"$ctrl.supervision.c_redondeo\"\n                    >\n                      Avance financiero\n                    </th>\n                    <th\n                      rowspan=\"2\"\n                      title=\"% Ejecutado Físico\"\n                      style=\"width: 90px\"\n                    >\n                      % E.Fis.\n                    </th>\n                    <th rowspan=\"2\" title=\"% Ejecutar\" style=\"width: 90px\">\n                      % E.\n                    </th>\n                    <th\n                      rowspan=\"2\"\n                      title=\"% Ejecutado Financiero\"\n                      style=\"width: 90px\"\n                    >\n                      % E.Fin.\n                    </th>\n                    <th rowspan=\"2\" title=\"% Ejecutar\" style=\"width: 90px\">\n                      % E.\n                    </th>\n                  </tr>\n                  <tr>\n                    <th\n                      ng-repeat-start=\"version in modulo.items[0].item_historico\"\n                      style=\"width: 90px\"\n                      ng-if=\"$ctrl.supervision.version_proyecto===null || version.version<$ctrl.supervision.version_proyecto\"\n                    >\n                      Cant.\n                    </th>\n                    <th\n                      style=\"width: 90px\"\n                      ng-if=\"$ctrl.supervision.version_proyecto===null || version.version<$ctrl.supervision.version_proyecto\"\n                    >\n                      P.U.\n                    </th>\n                    <th\n                      ng-repeat-end\n                      style=\"width: 90px\"\n                      ng-if=\"$ctrl.supervision.version_proyecto===null || version.version<$ctrl.supervision.version_proyecto\"\n                    >\n                      Total\n                    </th>\n                    <th title=\"Cantidad\" style=\"width: 90px\">Cant.</th>\n                    <th title=\"Precio Unitario\" style=\"width: 90px\">P.U.</th>\n                    <th style=\"width: 90px\">Total(Bs)</th>\n                    <th style=\"width: 90px\">Anterior</th>\n                    <th style=\"width: 90px\">Actual</th>\n                    <th title=\"Total Acumulado\" style=\"width: 90px\">T.A.</th>\n                    <th title=\"Falta ejecutar\" style=\"width: 90px\">F.E.</th>\n                    <th style=\"width: 90px\">Anterior</th>\n                    <th style=\"width: 90px\">Actual</th>\n                    <th\n                      style=\"width: 90px\"\n                      ng-if=\"$ctrl.supervision.c_redondeo\"\n                    >\n                      Regu.\n                    </th>\n                    <th title=\"Total Acumulado\" style=\"width: 90px\">T.A.</th>\n                    <th title=\"Falta ejecutar\" style=\"width: 90px\">F.E.</th>\n                  </tr>\n                </thead>\n                <tbody>\n                  <tr\n                    ng-dblclick=\"$ctrl.mostrarComputo(item)\"\n                    ng-repeat=\"item in modulo.items\"\n                    ng-show=\"item.show\"\n                    ng-class=\"[{'observado': (item.falta_ejecutar_fis === 0 && item.falta_ejecutar_fin !== 0) || (item.ejecutar_porcentaje_fis === 0  && item.falta_ejecutar_fis > 0)}]\"\n                  >\n                    <td\n                      ng-class=\"$ctrl.getMgColor(item)\"\n                      title=\"{{$ctrl.getTitle(item)}}\"\n                    >\n                      {{item.nro_item}}\n                    </td>\n                    <td class=\"text-left\">\n                      {{item.nombre}}\n                      <button\n                        md-effect\n                        class=\"btn btn-info btn-sm right\"\n                        uib-tooltip=\"Reporte de Cómputos métricos\"\n                        ng-if=\"$ctrl.supervision.version_proyecto && item.cantidad_actual_fis!==0\"\n                        download-file=\"{{$ctrl.urlDescComputosItem + item.nro_item + '_' + $ctrl.supervision.nro_supervision + '/descargar'}}\"\n                        file-name=\"Computos metricos item nro {{item.nro_item}}\"\n                      >\n                        <i class=\"fa fa-table\"></i>\n                      </button>\n                    </td>\n                    <td>{{$ctrl.unidades_obj[item.unidad_medida].nombre}}</td>\n                    <td\n                      ng-repeat-start=\"version in item.item_historico\"\n                      ng-if=\"$ctrl.supervision.version_proyecto===null || version.version<$ctrl.supervision.version_proyecto\"\n                      ng-class=\"[{'text-info font-weight-bold modificado':version.modificado}, $ctrl.getTipoClass(version.modificacion)]\"\n                    >\n                      {{version.cantidad |number:2}}\n                    </td>\n                    <td\n                      ng-class=\"$ctrl.getTipoClass(version.modificacion)\"\n                      ng-if=\"$ctrl.supervision.version_proyecto===null || version.version<$ctrl.supervision.version_proyecto\"\n                    >\n                      {{version.precio_unitario |number:2}}\n                    </td>\n                    <td\n                      ng-repeat-end\n                      ng-class=\"[{'text-info font-weight-bold':version.modificado, 'font-weight-bold':version.cr_precio}, $ctrl.getTipoClass(version.modificacion)]\"\n                      ng-if=\"$ctrl.supervision.version_proyecto===null || version.version<$ctrl.supervision.version_proyecto\"\n                    >\n                      {{$ctrl.Util.sumar([version.total, version.cr_precio])}}\n                    </td>\n                    <td\n                      ng-class=\"[{'text-info font-weight-bold modificado':item.modificado},$ctrl.getTipoClass($ctrl.proyecto.tipo_modificacion)]\"\n                    >\n                      {{item.cantidad | number:2}}\n                    </td>\n                    <td\n                      ng-class=\"$ctrl.getTipoClass($ctrl.proyecto.tipo_modificacion)\"\n                    >\n                      {{item.precio_unitario | number:2}}\n                    </td>\n                    <td\n                      ng-class=\"[{'text-info font-weight-bold':item.modificado, 'text-danger':item.cr_precio}, $ctrl.getTipoClass($ctrl.proyecto.tipo_modificacion)]\"\n                    >\n                      {{$ctrl.Util.sumar([item.total, item.cr_precio])}}\n                    </td>\n                    <td>{{item.cantidad_anterior_fis | number:2}}</td>\n                    <td>{{item.cantidad_actual_fis | number:2}}</td>\n                    <td>{{item.total_acumulado_fis | number:2}}</td>\n                    <td ng-class=\"{'danger' : item.falta_ejecutar_fis < 0}\">\n                      {{item.falta_ejecutar_fis | number:2}}\n                    </td>\n                    <td>{{item.cantidad_anterior_fin | number:2}}</td>\n                    <td>{{item.cantidad_actual_fin | number:2}}</td>\n                    <td ng-if=\"$ctrl.supervision.c_redondeo\">\n                      <span ng-if=\"item.cantidad_actual_fin\"\n                        ><input\n                          ng-disabled=\"!$ctrl.Supervision.esEditable('computos')\"\n                          name=\"e_redondeo\"\n                          pattern=\"(^[-]{0,1}0.\\d[\\d]{0,1}$)|^0$\"\n                          placeholder=\"0.00\"\n                          size=\"2\"\n                          ng-model=\"item.c_redondeo\"\n                          ng-blur=\"$ctrl.cRedondeo(item)\"\n                      /></span>\n                    </td>\n                    <td>{{item.total_acumulado_fin | number:2}}</td>\n                    <td ng-class=\"{'info' : item.falta_ejecutar_fin < 0}\">\n                      {{item.falta_ejecutar_fin | number:2}}\n                    </td>\n                    <td>{{item.ejecutado_porcentaje_fis | number:2}}</td>\n                    <td>{{item.ejecutar_porcentaje_fis | number:2}}</td>\n                    <td>{{item.ejecutado_porcentaje_fin | number:2}}</td>\n                    <td>{{item.ejecutar_porcentaje_fin | number:2}}</td>\n                  </tr>\n                </tbody>\n              </table>\n            </div>\n          </div>\n        </div>\n      </section>\n      <div class=\"alert alert-info\" ng-if=\"$ctrl.itemsNoCerrados.length > 0\">\n        <i class=\"fa fa-info\"></i>\n        <span ng-if=\"$ctrl.itemsNoCerrados.length === 1\"\n          ><strong>El item resaltado</strong> tiene</span\n        >\n        <span ng-if=\"$ctrl.itemsNoCerrados.length > 1\"\n          ><strong>Los items resaltados</strong> tienen</span\n        >\n        <span\n          >concluido el avance físico, sin embargo la parte financiera no ha\n          cerrado porque existe una diferencia causado por el error de redondeo.\n          Puede enviar la planillla para que este detalle sea revisado por\n          personal de la UPRE.</span\n        >\n        <!-- <span>concluido el avance físico, sin embargo la parte financiera no ha cerrado o {{$ctrl.itemsNoCerrados.length > 1? 'tienen' : 'tiene'}}\n          concluído el porcentaje de avance físico, sin embargo aún hay una cantidad faltante por ejecutar. Este detalle será revisado por personal de la UPRE.</span> -->\n      </div>\n\n      <div class=\"fs-sm\">\n        <div class=\"row\">\n          <div class=\"col-md-6 text-left\">\n            <table class=\"table mod-t mod-t-b mb-0\">\n              <tbody>\n                <tr>\n                  <th>Monto actual ejecutado:</th>\n                  <td>\n                    {{$ctrl.supervision.monto_total_actual_ejecutado |\n                    number:2}}\n                  </td>\n                </tr>\n                <tr ng-if=\"$ctrl.errorRedondeo\">\n                  <th>Reajuste por error de redondeo</th>\n                  <td>{{$ctrl.errorRedondeo}}</td>\n                </tr>\n                <tr ng-if=\"$ctrl.errorRedondeo\">\n                  <th>MONTO ACTUAL EJECUTADO</th>\n                  <td>\n                    {{$ctrl.Util.sumar([$ctrl.supervision.monto_total_actual_ejecutado,$ctrl.errorRedondeo])|number}}\n                  </td>\n                </tr>\n                <tr>\n                  <th>Porcentaje total ejecutado:</th>\n                  <td>\n                    {{$ctrl.supervision.porcentaje_avance_fis | number:2}}%\n                  </td>\n                </tr>\n              </tbody>\n            </table>\n          </div>\n          <div class=\"col-md-6\">\n            <table class=\"table mod-t mod-t-b mb-0\">\n              <tbody>\n                <tr>\n                  <th>Monto actual acumulado a la fecha:</th>\n                  <td>\n                    {{$ctrl.supervision.monto_total_acumulado | number:2}}\n                  </td>\n                </tr>\n                <tr>\n                  <th>Monto total por ejecutar:</th>\n                  <td>\n                    {{$ctrl.supervision.monto_total_por_ejecutar | number:2}}\n                  </td>\n                </tr>\n              </tbody>\n            </table>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"mt-4 texto\">\n        <div class=\"row\">\n          <div class=\"col-md-6 text-left\">\n            <table class=\"table mod-t mod-t-b mb-0\">\n              <tbody>\n                <tr>\n                  <th class=\"mot-t-sin-b\" colspan=\"3\">\n                    II. VERIFICACIÓN DE BOLETAS DE GARANTÍA\n                  </th>\n                </tr>\n                <tr>\n                  <th>Descripción</th>\n                  <th>Tipo</th>\n                  <th>Fecha de vencimiento</th>\n                  <th>Estado</th>\n                </tr>\n                <tr ng-repeat=\"boleta in $ctrl.boletasAnticipo\">\n                  <td\n                    rowspan=\"{{$ctrl.boletasAnticipo.length}}\"\n                    ng-hide=\"$index>0\"\n                  >\n                    Buena inversión del Anticipo\n                  </td>\n                  <td>\n                    {{ boleta.tipo_documento == 'POLIZA' ? 'Póliza' :'Boleta' }}\n                  </td>\n                  <td ng-class=\"[boleta.class]\">\n                    {{ boleta.fecha_fin_validez | date : 'dd/MM/yyyy' }}\n                  </td>\n                  <td ng-class=\"[boleta.class]\">{{ boleta.estado }}</td>\n                </tr>\n                <tr ng-repeat=\"boleta in $ctrl.boletasCcontrato\">\n                  <td\n                    rowspan=\"{{$ctrl.boletasCcontrato.length}}\"\n                    ng-hide=\"$index>0\"\n                  >\n                    Cumplimiento de Contrato\n                  </td>\n                  <td ng-if=\"boleta.tipo_documento=='POLIZA'\">\n                    <!-- {{ boleta.tipo_documento == 'POLIZA' ? 'Póliza' :'Boleta' }} -->\n                    Póliza\n                  </td>\n                  <td ng-if=\"boleta.tipo_documento=='BOLETA'\">Boleta</td>\n                  <td ng-if=\"boleta.tipo_documento=='RETENCION'\">Retención</td>\n                  <td ng-class=\"[boleta.class]\">\n                    {{ boleta.tipo_documento == 'RETENCION' ? ' ' :\n                    boleta.fecha_fin_validez | date : 'dd/MM/yyyy' }}\n                  </td>\n                  <td ng-class=\"[boleta.class]\">\n                    {{ boleta.tipo_documento == 'RETENCION' ? ' ' :boleta.estado\n                    }}\n                  </td>\n                </tr>\n              </tbody>\n            </table>\n          </div>\n          <div class=\"col-md-6\">\n            <table class=\"table mod-t mod-t-b mb-0\">\n              <tbody>\n                <tr>\n                  <th class=\"mot-t-sin-b\" colspan=\"3\">\n                    III. INFORME TÉCNICO DE CONCLUSIONES\n                  </th>\n                </tr>\n                <tr>\n                  <th>Avance Físico</th>\n                  <td>\n                    {{$ctrl.supervision.porcentaje_avance_fis | number:2}}%\n                  </td>\n                </tr>\n                <tr>\n                  <th>Avance Financiero</th>\n                  <td>\n                    {{$ctrl.supervision.porcentaje_avance_fin | number:2}}%\n                  </td>\n                </tr>\n              </tbody>\n            </table>\n          </div>\n        </div>\n\n        <section\n          ng-if=\"$ctrl.Supervision.esAreaPermitida('DEUDA_ANTICIPO') && $ctrl.tieneDeudas\"\n        >\n          <h6 class=\"title-section m-top\">\n            <i class=\"fa fa-money\"></i> Descuento por anticipo\n          </h6>\n          <p>\n            La empresa solicitó un anticipo de\n            <strong>{{$ctrl.proyecto.anticipo | number : 2}} Bs.</strong>\n            equivalente al {{$ctrl.proyecto.porcentaje_anticipo}}% del monto del\n            contrato ({{$ctrl.proyecto.monto_contractual | number : 2}} Bs.).\n          </p>\n\n          <p ng-if=\"$ctrl.supervision.supervisiones_anteriores.length > 0\">\n            A la fecha la empresa adeuda\n            <strong>{{$ctrl.deudaAnticipo | number :2}} Bs.</strong> por\n            concepto de anticipo pendiente.\n          </p>\n\n          <p>\n            La empresa solicitó el descuento\n            <strong>{{$ctrl.supervision.tipo_descuento_anticipo}}</strong> por\n            concepto de anticipo, mismo que es equivalente a\n            {{$ctrl.desembolso.descuento | number : 2}} Bs. y el monto a\n            desembolsar será\n            <strong ng-if=\"!$ctrl.errorRedondeo\"\n              >{{$ctrl.desembolso.total | number : 2}} Bs.</strong\n            ><strong ng-if=\"$ctrl.errorRedondeo\"\n              >{{$ctrl.Util.sumar([$ctrl.desembolso.total,$ctrl.errorRedondeo])|number:2}}\n              Bs.,</strong\n            >\n            para la actual planilla.\n          </p>\n          <div\n            class=\"alert alert-danger\"\n            ng-if=\"$ctrl.supervision.porcentaje_avance_fis == 100 && $ctrl.deudaAnticipo!=$ctrl.desembolso.descuento\"\n          >\n            <i class=\"fa fa-warning\"></i\n            ><span\n              >La empresa debe solicitar obligatoriamente el descuento TOTAL, ya\n              que el avance físico es del 100%.</span\n            >\n          </div>\n        </section>\n        <!-- SECCION FOTOGRAFIAS SUBIDAS POR EL APK MOVIL -->\n        <section ng-if=\"$ctrl.Supervision.esAreaPermitida('FOTOGRAFIAS')\">\n          <h6 class=\"title-section m-top\">\n            <i class=\"fa fa-photo\"></i> Fotografías de la supervisión\n          </h6>\n          <div\n            class=\"alert alert-info\"\n            ng-if=\"$ctrl.supervision.fotos_supervision.length === 0\"\n          >\n            <i class=\"fa fa-info-circle\"></i>\n            <span\n              >Debe sacar fotografías a la obra con la aplicación móvil.</span\n            >\n          </div>\n          <fotos-supervision\n            fotos=\"$ctrl.supervision.fotos_supervision\"\n            supervision=\"$ctrl.supervision\"\n            ng-if=\"$ctrl.supervision.fotos_supervision.length > 0\"\n          ></fotos-supervision>\n          <div\n            class=\"alert alert-info\"\n            ng-if=\"$ctrl.supervision.nro_supervision===1\"\n          >\n            <i class=\"fa fa-exclamation-circle\"></i>\n            <strong>¡ADVERTENCIA!</strong><br />\n            <span\n              >* Deberá tomar en cuenta que las primeras 3 fotos tomadas y\n              aprobadas en la 1ra. planilla de avance establecerán la\n              Georreferenciación del proyecto, siendo que para el envio de las\n              siguientes planillas de avance la aplicación móvil no permitirá\n              tomar las 3 fotos de una ubicación diferente o que no se encuentre\n              dentro del radio permitido.</span\n            >\n            <br /><span\n              >* Puede verificar la ubicación haciendo click en el boton\n              <i class=\"fa fa-map-marker\"></i> de cada foto.</span\n            >\n          </div>\n        </section>\n        <!--FIN  SECCION FOTOGRAFIAS SUBIDAS POR EL APK MOVIL -->\n        <!-- SECCION QUE CORRESPONDE AL SUPERVISOR -->\n        <section ng-dblclick=\"$ctrl.info=0\">\n          <ng-form name=\"formSupervision\">\n            <section ng-if=\"$ctrl.Supervision.esAreaPermitida('INFORME')\">\n              <h6 class=\"title-section m-top\">\n                <i class=\"fa fa-file-text\"></i> Informe técnico de conclusiones\n                (Supervisor)\n              </h6>\n              <div\n                class=\"alert alert-info\"\n                ng-click=\"$ctrl.info=1\"\n                style=\"cursor: pointer\"\n              >\n                <i class=\"fa fa-info-circle\"></i>\n                <span\n                  >El informe deberá contener mínimamente los siguientes\n                  puntos:</span\n                >\n                <ol style=\"list-style: none\" ng-if=\"$ctrl.info\">\n                  <li>1. Datos generales</li>\n                  <li>2. Descripción del proyecto</li>\n                  <li>3. Detalle de distribución del área del proyecto</li>\n                  <li>\n                    4. Modificaciones a la obra (si corresponde)\n                    <ol style=\"list-style: none\">\n                      <li>\n                        4.1. Descripción del proyecto modificado (si\n                        corresponde)\n                      </li>\n                    </ol>\n                  </li>\n                  <li>\n                    5. Avance de la obra en el periodo y actividades\n                    ejecutadas<br />\n                    Estado físico<br />\n                    Estado financiero<br />\n                  </li>\n                  <ol style=\"list-style: none\">\n                    <li>5.1. Detalle de certificados de avance de obra</li>\n                    <li>\n                      5.2. Actividades ejecutadas en el periodo del certificado\n                    </li>\n                    <li>\n                      5.3. Actividades concluidas (información acumulativa)\n                    </li>\n                    <li>5.4. Curva de control de infraestructura</li>\n                  </ol>\n                  <li>6. Detalle de boletas de garantía</li>\n                  <li>7. Desempeño de la empresa constructora</li>\n                  <ol style=\"list-style: none\">\n                    <li>7.1. Director de obra</li>\n                    <li>7.2. Mano de obra calificada</li>\n                    <li>7.3. Mano de obra no calificada</li>\n                    <li>7.4. Equipo y herramientas</li>\n                    <li>7.5. Seguridad industrial</li>\n                  </ol>\n                  <li>8. Provisión y calidad de materiales</li>\n                  <ol style=\"list-style: none\">\n                    <li>8.1. Certificación de la calidad de los materiales</li>\n                    <li>\n                      8.1. Interpretación de las certificaciones de calidad\n                    </li>\n                    <li>8.2. Calidad de los trabajos realizados</li>\n                  </ol>\n                  <li>\n                    9. Anexo fotográfico (las imágenes deberán ser descargadas e\n                    impresas de los cómputos métricos registrados en el sistema\n                    y ser adjuntadas al documento físico a entregar).\n                  </li>\n                  <li>10. Conclusiones.</li>\n                </ol>\n              </div>\n              <c-textarea\n                label=\"\"\n                name=\"informe_tecnico_supervisor\"\n                ng-model=\"$ctrl.supervision.informe\"\n                rows=\"7\"\n                ng-minlength=\"20\"\n                maxlength=\"3000\"\n                ng-required=\"true\"\n                ng-if=\"$ctrl.Supervision.esEditable('informe')\"\n              >\n              </c-textarea>\n              <p\n                ng-if=\"!$ctrl.Supervision.esEditable('informe')\"\n                style=\"white-space: pre-wrap\"\n                class=\"text-justify\"\n              >\n                {{$ctrl.supervision.informe}}\n              </p>\n              <div class=\"\">\n                DOCUMENTO PDF:\n                <button\n                  class=\"btn btn-success\"\n                  md-effect\n                  ng-click=\"$ctrl.verPdfInforme('ITCS')\"\n                  ng-disabled=\"!$ctrl.supervision.informe_doc\"\n                  uib-tooltip=\"Ver documento\"\n                >\n                  <i class=\"fa fa-file-text\"></i> VER\n                </button>\n                <button\n                  class=\"btn btn-primary\"\n                  md-effect\n                  ng-click=\"$ctrl.cargarPdfInforme('ITCS')\"\n                  ng-if=\"$ctrl.Supervision.esEditable('informe')\"\n                  uib-tooltip=\"Cargar Informe Técnico\"\n                >\n                  <i class=\"fa fa-arrow-circle-up\"></i> SUBIR\n                </button>\n              </div>\n            </section>\n          </ng-form>\n        </section>\n        <!-- FIN SECCION QUE CORRESPONDE AL SUPERVISOR -->\n        <!-- SECCION QUE CORRESPONDE AL FISCAL -->\n        <section>\n          <ng-form name=\"formSupervision\">\n            <section\n              ng-if=\"$ctrl.Supervision.esAreaPermitida('INFORME_FISCAL')\"\n            >\n              <h6 class=\"title-section m-top\">\n                <i class=\"fa fa-file-text\"></i> Informe técnico de conclusiones\n                (Fiscal)\n              </h6>\n              <c-textarea\n                label=\"\"\n                name=\"informe_tecnico_fiscal\"\n                ng-model=\"$ctrl.supervision.informe_fiscal\"\n                rows=\"7\"\n                ng-minlength=\"20\"\n                maxlength=\"3000\"\n                ng-required=\"true\"\n                ng-if=\"$ctrl.Supervision.esEditable('informe_fiscal')\"\n              >\n              </c-textarea>\n              <p\n                ng-if=\"!$ctrl.Supervision.esEditable('informe_fiscal')\"\n                style=\"white-space: pre-wrap\"\n                class=\"text-justify\"\n              >\n                {{$ctrl.supervision.informe_fiscal}}\n              </p>\n              <div class=\"\">\n                DOCUMENTO PDF:\n                <button\n                  class=\"btn btn-success\"\n                  md-effect\n                  ng-click=\"$ctrl.verPdfInforme('ITCF')\"\n                  ng-disabled=\"!$ctrl.supervision.informe_fiscal_doc\"\n                  uib-tooltip=\"Ver documento\"\n                >\n                  <i class=\"fa fa-file-text\"></i> VER\n                </button>\n                <button\n                  class=\"btn btn-primary\"\n                  md-effect\n                  ng-click=\"$ctrl.cargarPdfInforme('ITCF')\"\n                  ng-if=\"$ctrl.Supervision.esEditable('informe_fiscal')\"\n                  uib-tooltip=\"Cargar Informe Técnico\"\n                >\n                  <i class=\"fa fa-arrow-circle-up\"></i> SUBIR\n                </button>\n              </div>\n            </section>\n          </ng-form>\n        </section>\n        <!-- FIN SECCION QUE CORRESPONDE AL FISCAL -->\n        <div class=\"mt-3\">\n          <small class=\"resaltado\"\n            ><strong\n              ><em\n                >La presente planilla tiene valor de declaración Jurada, por lo\n                que si se identifica cualquier falsedad, se realizarán las\n                acciones legales respectivas en contra de la empresa\n                constructora infractora.</em\n              ></strong\n            ></small\n          >\n        </div>\n        <!-- SECCION OBSERVACION POR PARTE DEL TECNICO UPRE -->\n        <section ng-if=\"$ctrl.supervision.observacion_proceso.mensaje\">\n          <h6 class=\"title-section error m-top\">\n            <i class=\"fa fa-exclamation-triangle\"></i> Observación\n          </h6>\n          Mensaje:\n          <div style=\"white-space: pre-wrap\">\n            <strong>{{ $ctrl.supervision.observacion_proceso.mensaje }}</strong>\n          </div>\n          Observado por:\n          <strong\n            >{{ $ctrl.supervision.observacion_proceso.usuario.persona |\n            nombreUnido }}</strong\n          >\n        </section>\n        <!-- FIN SECCION OBSERVACION POR PARTE DEL TECNICO UPRE -->\n        <!-- FECHA DE LA PLANILLA LLENADA POR LA EMPRESA -->\n        <form\n          name=\"fecha_creacion\"\n          nng-if=\"$ctrl.supervision.estado_actual.codigo==='EN_TECNICO'\"\n        >\n          <table align=\"left\">\n            <tr>\n              <td style=\"width: 150px\">\n                <c-date\n                  name=\"fecha_creacion\"\n                  label=\"Fecha de la Planilla\"\n                  ng-model=\"$ctrl.supervision.fecha_creacion\"\n                  max-date=\"$ctrl.validacion.fecha_max\"\n                  min-date=\"$ctrl.validacion.fecha_creacion_min\"\n                  ng-disabled=\"!$ctrl.Supervision.esEditable('fecha_creacion')\"\n                  mensaje-max-date=\"La fecha no puede ser mayor a la fecha de recepción\"\n                  mensaje-min-date=\"La fecha no puede ser menor a la fecha de inicio\"\n                >\n                </c-date>\n              </td>\n            </tr>\n          </table>\n        </form>\n        <!-- FIN FECHA DE LA PLANILLA LLENADA POR LA EMPRESA -->\n        <!-- PARA EJECUTAR LA TRANSICION -->\n        <div class=\"row my-3 pr-3 justify-content-end\">\n          <button\n            md-effect\n            type=\"button\"\n            class=\"btn mr-3\"\n            ng-click=\"$ctrl.filtroItems === 'PARA_ENVIAR' ? $ctrl.filtroItems = 'TODOS' : $ctrl.filtroItems = 'PARA_ENVIAR'\"\n            ng-if=\"$ctrl.esEtapaEdicion\"\n          >\n            <i class=\"fa fa-eye\"></i> {{ $ctrl.filtroItems === 'PARA_ENVIAR' ?\n            'Ver todos' : 'Ver Planilla a enviar'}}\n          </button>\n          <ejecutar-transicion\n            elemento=\"$ctrl.supervision\"\n            servicio=\"$ctrl.Supervision\"\n            form=\"formSupervision\"\n            atributo-estado=\"estado_supervision\"\n            url=\"$ctrl.url\"\n            confirmar=\"true\"\n            metodo-previo=\"$ctrl.verificarPlanilla()\"\n          >\n          </ejecutar-transicion>\n        </div>\n        <!-- FIN PARA EJECUTAR LA TRANSICION -->\n      </div>\n    </div>\n  </div>\n  <br />\n  <!-- FORMULARIO 2-4-6 -->\n  <div class=\"card\">\n    <div class=\"card-body\">\n      <datos-form-246 supervision=\"$ctrl.supervision\"></datos-form-246>\n    </div>\n  </div>\n  <br />\n  <div class=\"card\" ng-if=\"$ctrl.supervision\">\n    <div class=\"card-body\">\n      <empresa-anterior supervision=\"$ctrl.supervision\"></empresa-anterior>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 637 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\"><i class=\"fa fa-search\"></i> Verificación de anticipo</h5>\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cerrar()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<div class=\"modal-body\">\n  <p>Para este proyecto \"<strong>{{$ctrl.supervision.proyecto.nombre}}</strong>\", la empresa ha solicitado un\n    <strong>anticipo del {{$ctrl.supervision.proyecto.porcentaje_anticipo}}% equivalente a {{$ctrl.supervision.proyecto.anticipo | number}} Bs.</strong> del monto del contrato. </p>\n  <p>Para el pago de esta planilla requiere que se realice el descuento, elija el tipo de descuento que desea. </p>\n\n  <p ng-if=\"$ctrl.supervision.supervisiones_anteriores.length > 0\">\n    La empresa aún adeuda <strong>{{$ctrl.deudaAnticipo | number : 2}} Bs.</strong> por concepto de anticipo.\n  </p>\n\n  <div class=\"alert alert-warning\" ng-if=\"!$ctrl.puedeDescuentoTotal\">\n    <span>El monto total ejecutado es menor al monto del anticipo{{$ctrl.supervision.supervisiones_anteriores.length > 0 ? ' pendiente' : ''}}, por lo que el descuento será <strong>PROGRESIVO.</strong></span>\n  </div>\n\n  <div class=\"alert alert-warning\" ng-if=\"!$ctrl.puedeDescuentoProgresivo && !$ctrl.esPlanillaCierre\">\n    <span>El monto calculado para el descuento <strong>progresivo</strong> supera la cantidad que adeuda la empresa, por lo que el descuento será por el <strong>TOTAL</strong>.</span>\n  </div>\n\n  <div class=\"alert alert-warning\" ng-if=\"$ctrl.esPlanillaCierre\">\n    <span>La planilla actual corresponde a la <strong>planilla de cierre</strong>, por lo que el descuento debe ser por el <strong>TOTAL</strong>.</span>\n  </div>\n  <ng-form name=\"formDescuento\">\n    <div class=\"row\">\n      <div class=\"col-lg-6\">\n        <c-radiobutton name=\"tipo_descuento\" label=\"Tipo de descuento\"\n                       ng-model=\"$ctrl.supervision.tipo_descuento_anticipo\"\n                       options=\"$ctrl.tiposDescuento\"\n                       field=\"nombre\"\n                       ng-change=\"$ctrl.calcularDescuento(data)\"\n                       ng-required=\"true\"\n                       ng-disabled=\"!$ctrl.puedeDescuentoTotal || !$ctrl.puedeDescuentoProgresivo\">\n        </c-radiobutton>\n      </div>\n      <div class=\"col-lg-6\">\n        <c-input-numeric label=\"Monto retención descuento por anticipo.\" name=\"descuento\" ng-model=\"$ctrl.supervision.porcentaje_descuento\" ng-blur=\"$ctrl.calcularDescuento($ctrl.supervision.porcentaje_descuento)\" ng-disabled=\"$ctrl.supervision.tipo_descuento_anticipo!=='PROGRESIVO'\" ng-minvalue=\"{{$ctrl.supervision.proyecto.porcentaje_anticipo * $ctrl.supervision.monto_total_actual_ejecutado / 100}}\" ng-maxvalue=\"{{$ctrl.supervision.monto_total_actual_ejecutado}}\" ng-decimals=\"2\"></c-input-numeric>\n      </div>\n    </div>\n  </ng-form>\n\n  <p> El monto actual ejecutado es <strong>{{$ctrl.supervision.monto_total_actual_ejecutado | number : 2}} Bs.</strong> <br>\n    <span ng-if=\"$ctrl.desembolso\">El monto a descontar es <strong>{{$ctrl.desembolso.descuento | number : 2}} Bs.</strong> y el monto a desembolsar será <strong ng-if=\"!$ctrl.errorRedondeo\">{{$ctrl.desembolso.total | number : 2}} Bs.</strong><strong ng-if=\"$ctrl.errorRedondeo\">{{$ctrl.Util.sumar([$ctrl.desembolso.total,$ctrl.errorRedondeo]) | number : 2}} Bs</strong></span>\n  </p>\n  <div class=\"alert alert-info\">\n    <span class=\"text-message\"><strong>*</strong>&nbspDescuento de la totalidad del anticipo {{$ctrl.supervision.supervisiones_anteriores.length > 0 ? 'pendiente' : '' }} al monto total ejecutado de la planilla de avance.</span><br>\n    <span class=\"text-message\"><strong>**</strong>Descuento del porcentaje del anticipo respecto al monto total ejecutado de la planilla de avance.</span>\n  </div>\n</div>\n\n<div class=\"modal-footer\">\n  <button type=\"button\" md-effect class=\"btn btn-secondary\" ng-click=\"$ctrl.cerrar()\">\n    <i class=\"fa fa-close\"></i> Cancelar\n  </button>\n  <button type=\"submit\" md-effect class=\"btn btn-primary\" validar-formulario=\"formDescuento\" ng-click=\"$ctrl.registrar()\">\n    <i class=\"fa fa-check\"></i> Aceptar\n  </button>\n</div>\n"

/***/ }),
/* 638 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\"><i class=\"fa fa-plus-circle\"></i> Ubicaciones</h5>\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cerrar()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<div class=\"modal-body\">\n  <div class=\"row mb-3\">\n    <div class=\"col\">\n      <leaflet lf-center=\"$ctrl.mapa.centro\" controles=\"$ctrl.mapa.controls\"\n        defaults=\"$ctrl.mapa.defaults\" maxbounds=\"$ctrl.mapa.maxbounds\" layers=\"$ctrl.mapa.layers\"\n        height=\"400px\" width=\"100%\" markers=\"$ctrl.mapa.marcadores\"></leaflet>\n    </div>\n  </div>\n</div>\n\n<div class=\"modal-footer\">\n  <button type=\"submit\" md-effect class=\"btn btn-primary\" ng-click=\"$ctrl.cerrar()\">\n    <i class=\"fa fa-check\"></i> Aceptar\n  </button>\n</div>\n"

/***/ }),
/* 639 */
47,
/* 640 */
/***/ (function(module, exports) {

	module.exports = "<!-- <div class=\"row\">\n    <div class=\"upload_file\">\n        <div class=\"detalles\">\n            <div class=\"nombre\">{{$ctrl.i_nombre_file}}</div>\n        </div>\n        <div id=\"documento\">\n            \n            <img src=\"images/formulario.jpg\" alt=\"Documento\">\n\n            <div class=\"row\"></div>\n            <label for=\"\">Formatos Permitidos (xlsx, xls, doc, docx, jpeg, jpg, png,pdf)</label>\n            <input type=\"file\" class=\"form-control\" id=\"inputArchivo\" name=\"inputArchivo\" ng-model=\"$ctrl.inputArchivo\">\n            <input type=\"text\" class=\"form-control\" id=\"inputTexto\" name=\"inputTexto\" ng-model=\"$ctrl.inputTexto\">\n            <button type=\"button\" class=\"btn btn-success btn-block\" ng-click=\"$ctrl.subirArchivo()\">\n                <i class=\"fa fa-save\"></i> Guardar</button>\n        </div>\n    </div>\n</div> -->\n<button md-effect type=\"button\" class=\"btn btn-warning\" ng-click=\"$ctrl.importarComputos()\">\n  <i class=\"fa fa-upload\"></i> Importar Computos\n</button>"

/***/ }),
/* 641 */
/***/ (function(module, exports) {

	module.exports = "<button md-effect type=\"button\" class=\"btn btn-info btn-sm mt-1\"\n  uib-tooltip=\"Modificaciones\" ng-click=\"$ctrl.verModificaciones()\">\n  <i class=\"fa fa-medium\"></i>\n</button>\n"

/***/ }),
/* 642 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\"><i class=\"fa fa-list\"></i> {{$ctrl.proyecto.nombre}}</h5>\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cerrar()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<div class=\"modal-body\">\n\n  <div class=\"alert alert-info\" ng-if=\"$ctrl.existeSupervisionesEnCurso\">\n    <i class=\"fa fa-info-circle\"></i>\n    <span>Existe supervisiones en curso de aprobación, por lo que no se puede realizar modificaciones.</span>\n  </div>\n  <div class=\"alert alert-info\" ng-if=\"$ctrl.proyecto.estado_proyecto === 'CERRADO'\">\n    <i class=\"fa fa-info-circle\"></i>\n    <span>El proyecto ha sido concluído.</span>\n  </div>\n  <section ng-if=\"$ctrl.puedeModificar\">\n    <div class=\"alert alert-secondary\">\n      <i class=\"fa fa-info-circle\"></i>\n      <span>Seleccione el tipo de modificación que desea realizar al proyecto.</span>\n    </div>\n    <div class=\"row\">\n      <div class=\"col-sm-4\">\n        <div class=\"card card-modificacion\" ng-mouseover=\"$ctrl.tipo=1\">\n          <div class=\"card-header text-center\">\n            <h6><strong>ORDEN<br>DE TRABAJO</strong></h6>\n          </div>\n          <div class=\"card-body text-center\">\n            <button md-effect type=\"button\" class=\"btn btn-success\" ng-click=\"$ctrl.abrirModificacion(1)\">\n              <i class=\"fa fa-check\"></i> Seleccionar\n            </button>\n          </div>\n          <div class=\"card-footer\">\n          </div>\n        </div>\n      </div>\n      <div class=\"col-sm-4\">\n        <div class=\"card card-modificacion\" ng-mouseover=\"$ctrl.tipo=2\">\n          <div class=\"card-header text-center\">\n            <h6><strong>ORDEN<br>DE CAMBIO</strong></h6>\n          </div>\n          <div class=\"card-body text-center\">\n            <button md-effect type=\"button\" class=\"btn btn-success\" ng-click=\"$ctrl.abrirModificacion(2)\">\n              <i class=\"fa fa-check\"></i> Seleccionar\n            </button>\n          </div>\n          <div class=\"card-footer\">\n          </div>\n        </div>\n      </div>\n      <div class=\"col-sm-4\">\n        <div class=\"card card-modificacion\" ng-mouseover=\"$ctrl.tipo=3\">\n          <div class=\"card-header text-center\">\n            <h6><strong>CONTRATO<br>MODIFICATORIO</strong></h6>\n          </div>\n          <div class=\"card-body text-center\">\n            <button md-effect type=\"button\" class=\"btn btn-success\" ng-click=\"$ctrl.abrirModificacion(3)\">\n              <i class=\"fa fa-check\"></i> Seleccionar\n            </button>\n          </div>\n          <div class=\"card-footer\">\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"alert alert-primary\">\n      <div ng-click=\"$ctrl.tipo=1\">\n        <i class=\"fa fa-info-circle\"></i>\n        <strong>Orden de trabajo</strong>\n        <ul ng-if=\"$ctrl.tipo==1\">\n          <li>Modificación de cantidades (volúmenes) de los ítems.</li>\n          <li>Las modificaciones realizadas no deberán incrementar o disminuir el monto contractual del proyecto.</li>\n          <li>No afectará a los plazos de ejecución.</li>\n        </ul>\n      </div>\n      <div ng-click=\"$ctrl.tipo=2\">\n        <i class=\"fa fa-info-circle\"></i>\n        <strong>Orden de cambio</strong>\n        <ul ng-if=\"$ctrl.tipo==2\">\n          <li>Modificación de cantidades (volúmenes) de los ítems, misma que podrá incrementar o disminuir el monto contractual del proyecto hasta un 5%.</li>\n          <li>Modificación del plazo de ejecución del proyecto (por volumen o compensación).</li>\n          <li>El total de las modificaciones no deberá superar el 15% del monto contractual del proyecto.</li>\n        </ul>\n      </div>\n      <div ng-click=\"$ctrl.tipo=3\">\n        <i class=\"fa fa-info-circle\"></i>\n        <strong>Contrato modificatorio</strong>\n        <ul ng-if=\"$ctrl.tipo==3\">\n          <li>Modificación de cantidades (volúmenes) de los ítems, misma que podrá incrementar o disminuir el monto contractual del proyecto hasta un 10%.</li>\n          <li>Modificación del plazo de ejecución del proyecto (por volumen o compensación).</li>\n          <li>Adición de ítems.</li>\n          <li>El total de las modificaciones no deberá superar el 15% del monto contractual del proyecto.</li>\n        </ul>\n      </div>\n    </div>\n\n    <div class=\"alert alert-success\">\n      <i class=\"fa fa-info-circle\"></i>\n      <span>* Las modificaciones solo se las podrá realizar sobre las cantidades no ejecutadas de los ítems, y no así sobre ítems cerrados físicamente.</span>\n    </div>\n  </section>\n\n  <hr>\n  <section ng-if=\"$ctrl.modificando\">\n    <p class=\"text-center\"><strong>Modificaciones</strong></p>\n    <div class=\"crud-table mt-3 table-responsive\">\n      <table class=\"table table-striped table-hover ng-table\">\n        <thead>\n          <tr>\n            <td><strong></strong></td>\n            <td><strong>Tipo</strong></td>\n            <td><strong>Estado</strong></td>\n            <td><strong>Fecha</strong></td>\n          </tr>\n        </thead>\n        <tbody>\n          <tr ng-repeat=\"modificacion in $ctrl.modificaciones\">\n            <td data-title=\"'Acción'\">\n              <button md-effect type=\"button\" class=\"btn btn-primary btn-noborder btn-sm mb-1\" ng-if=\"$ctrl.verUltimaModificacion(modificacion)\"\n                uib-tooltip=\"Ver Modificacion {{modificacion.version}}\" ng-click=\"$ctrl.irAModificacion(modificacion)\">\n                <i class=\"fa fa-eye\"></i>\n              </button>\n              <button md-effect type=\"button\" class=\"btn btn-success btn-noborder btn-sm mb-1\" ng-if=\"modificacion.estado_proyecto == 'APROBADO' || modificacion.estado_proyecto == 'PARALIZADO'\"\n                uib-tooltip=\"Ver Modificacion {{modificacion.version}}\" ng-click=\"$ctrl.irAModificacion(modificacion)\">\n                <i class=\"fa fa-eye\"></i>\n              </button>\n              <button md-effect type=\"button\" class=\"btn btn-primary btn-noborder btn-sm mb-1\" ng-if=\"$ctrl.verModificar(modificacion)\"\n                uib-tooltip=\"Ver Modificacion {{modificacion.version}}\" ng-click=\"$ctrl.irAModificacion(modificacion,true)\">\n                <i class=\"fa fa-edit\"></i>\n              </button>\n            </td>\n            <td>{{modificacion.nombre}}</td>\n            <td>{{modificacion.estado_actual.nombre}}</td>\n            <td>{{modificacion.fecha_modificacion | date : 'dd/MM/yyyy'}}</td>\n          </tr>\n        </tbody>\n      </table>\n    </div>\n  </section>\n\n</div>\n\n<div class=\"modal-footer\">\n  <button type=\"button\" md-effect class=\"btn btn-primary\" ng-click=\"$ctrl.cerrar()\">\n    <i class=\"fa fa-check\"></i> Cerrar\n  </button>\n</div>\n"

/***/ }),
/* 643 */
/***/ (function(module, exports) {

	module.exports = "<button md-effect type=\"button\" class=\"btn btn-info btn-sm mt-1\"\n  uib-tooltip=\"Paralizar Proyecto\" ng-click=\"$ctrl.verMensaje()\">\n  <i class=\"fa fa-ban\"></i>\n</button>\n"

/***/ }),
/* 644 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\"><i class=\"fa fa-ban\"></i> {{$ctrl.proyecto.nombre}}</h5>\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cerrar()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<div class=\"modal-body\">\n\n  <div class=\"alert alert-info\" ng-if=\"$ctrl.existeSupervisionesEnCurso\">\n    <i class=\"fa fa-info-circle\"></i>\n    <span>Existe supervisiones en curso de aprobación, por lo que no se puede realizar modificaciones.</span>\n  </div>\n  <div class=\"alert alert-info\" ng-if=\"$ctrl.proyecto.estado_proyecto === 'CERRADO'\">\n    <i class=\"fa fa-info-circle\"></i>\n    <span>El proyecto ha sido concluído.</span>\n  </div>\n  <section ng-if=\"true\">\n    <div class=\"alert alert-primary\">\n      <div>\n        <i class=\"fa fa-exclamation-triangle\"></i>\n        <strong>¿Está seguro/a de paralizar el proyecto?</strong>\n        <ul>\n          <li>Se generará un nuevo código de acceso del proyecto, para la adjudicación de la nueva empresa.</li>\n          <li>Se le informa que una vez paralizado el proyecto, el mismo estará en estado de adjudicación hasta que se estipule la nueva fecha de Orden de Proceder del proyecto.</li>\n        </ul>\n      </div>\n    </div>\n\n  </section>\n\n</div>\n\n<div class=\"modal-footer\">\n  <button type=\"button\" md-effect class=\"btn btn-secondary\" ng-click=\"$ctrl.cerrar()\">\n    <i class=\"fa fa-check\"></i> Cancelar\n  </button>\n  <button type=\"button\" md-effect class=\"btn btn-primary\" ng-click=\"$ctrl.paralizarProyecto()\">\n    <i class=\"fa fa-check\"></i> Si, estoy seguro/a\n  </button>\n</div>\n"

/***/ }),
/* 645 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <h2 class=\"page-title\"><i class=\"fa fa-bars\"></i> Proyectos pendientes</h2>\n  <div class=\"card\">\n    <div class=\"card-body\">\n      <div\n        class=\"crud-table\"\n        ng-table=\"$ctrl.tableParams\"\n        ng-table-columns-binding=\"columnas\"\n      >\n        <table\n          class=\"table table-striped table-hover ng-table table-responsive\"\n        >\n          <tr ng-repeat=\"proyecto in $data track by proyecto.id_proyecto\">\n            <td data-title=\"'Acciones'\">\n              <button\n                md-effect\n                type=\"button\"\n                class=\"btn btn-{{acciones.md}} btn-sm\"\n                ng-repeat=\"acciones in $ctrl.config.acciones\"\n                uib-tooltip=\"{{acciones.tooltip}}\"\n                ng-click=\"acciones.metodo(proyecto)\"\n                ng-if=\"proyecto.estado_proyecto !== 'APROBADO' && proyecto.estado_proyecto !== 'CONCILIACION'\"\n              >\n                <i class=\"fa fa-{{acciones.icon}}\"></i>\n              </button>\n              <button\n                md-effect\n                type=\"button\"\n                class=\"btn btn-{{acciones.md}} btn-sm mt-1\"\n                ng-repeat=\"acciones in $ctrl.configSupervisiones.acciones\"\n                uib-tooltip=\"{{acciones.tooltip}}\"\n                ng-click=\"acciones.metodo(proyecto)\"\n                ng-if=\"(proyecto.estado_proyecto === 'APROBADO' || proyecto.estado_proyecto === 'CONCILIACION') && proyecto.supervisiones && (acciones.condicion? acciones.condicion(proyecto) : true)\"\n              >\n                <i class=\"fa fa-{{acciones.icon}}\"></i>\n              </button>\n              <lista-supervisiones\n                proyecto=\"proyecto\"\n                ng-if=\"$ctrl.puedeVerSupervision(proyecto)\"\n              ></lista-supervisiones>\n              <lista-modificaciones\n                proyecto=\"proyecto\"\n                ng-if=\"$ctrl.puedeVerModificacion(proyecto)\"\n              ></lista-modificaciones>\n            </td>\n            <!-- <td data-title=\"'Código'\" filter=\"{codigo: 'text'}\" sortable=\"'codigo'\">{{proyecto.codigo}}</td> -->\n            <td\n              data-title=\"'Nro Convenio'\"\n              filter=\"{nro_convenio: 'text'}\"\n              sortable=\"'nro_convenio'\"\n            >\n              {{proyecto.nro_convenio}}\n            </td>\n            <td\n              data-title=\"'Nombre'\"\n              filter=\"{nombre: 'text'}\"\n              sortable=\"'nombre'\"\n            >\n              {{proyecto.nombre}}\n              <div ng-if=\"proyecto.supervisiones.length > 0\">\n                <small\n                  ><strong class=\"resaltado\"\n                    >Planilla:\n                    {{proyecto.supervisiones[0].nro_supervision}}</strong\n                  ></small\n                >\n              </div>\n              <div ng-if=\"proyecto.documentacion_exp\">\n                <small\n                  ng-if=\"proyecto.documentacion_exp.datos_asociacion.nombre_asociacion\"\n                  title=\"Asociación\"\n                  ><strong\n                    >{{proyecto.documentacion_exp.datos_asociacion.nombre_asociacion}}</strong\n                  ></small\n                >\n                <small\n                  ng-if=\"proyecto.documentacion_exp.datos_empresa.razon_social&&!proyecto.documentacion_exp.datos_asociacion.nombre_asociacion\"\n                  title=\"Empresa\"\n                  ><strong\n                    >{{proyecto.documentacion_exp.datos_empresa.razon_social}}</strong\n                  ></small\n                >\n              </div>\n            </td>\n            <td data-title=\"'Tipo'\" filter=\"{tipo: 'text'}\" sortable=\"'tipo'\">\n              {{proyecto.tipo_proyecto.nombre}}\n            </td>\n            <td\n              data-title=\"'Monto total'\"\n              filter=\"{monto_total: 'text'}\"\n              sortable=\"'monto_total'\"\n            >\n              {{proyecto.monto_total | formatDecimal}}\n            </td>\n            <td\n              data-title=\"'Plazo ejecución'\"\n              filter=\"{plazo_ejecucion: 'text'}\"\n              sortable=\"'plazo_ejecucion'\"\n            >\n              {{proyecto.plazo_ejecucion | formatDecimal}}\n            </td>\n            <td\n              data-title=\"'Estado Proyecto'\"\n              filter=\"{estado_proyecto: 'text'}\"\n              sortable=\"'estado_proyecto'\"\n            >\n              {{proyecto.estado_actual.nombre}} <br />\n              <span ng-if=\"proyecto.observacion.mensaje\" class=\"text-danger\">\n                {{ proyecto.observacion.mensaje }}\n              </span>\n            </td>\n            <td\n              data-title=\"'Estado Supervisión'\"\n              filter=\"{'supervisiones.estado_actual.nombre': 'hidden'}\"\n              sortable=\"false\"\n            >\n              {{proyecto.supervisiones[0].estado_actual.nombre}} <br />\n              <span\n                ng-if=\"proyecto.supervisiones[0].observacion_proceso.mensaje\"\n                class=\"text-danger\"\n              >\n                {{ proyecto.supervisiones[0].observacion_proceso.mensaje }}\n              </span>\n            </td>\n          </tr>\n        </table>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 646 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\"><i class=\"fa fa-plus-circle\"></i> Nueva Adjudicación</h5>\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cerrar()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<div class=\"modal-body\">\n  <p>Introduzca el código de acceso para adjudicarse a un proyecto.</p>\n  <ng-form name=\"formAdjudicacion\">\n    <div class=\"row\">\n      <div class=\"md-input-group col-md-12\">\n        <c-input name=\"codigo\" label=\"Código\" ng-model=\"$ctrl.codigo_acceso\"\n        ng-required=\"true\"></c-input>\n      </div>\n    </div>\n  </ng-form>\n</div>\n\n<div class=\"modal-footer\">\n  <button type=\"button\" md-effect class=\"btn btn-secondary\" ng-click=\"$ctrl.cerrar()\">\n    <i class=\"fa fa-close\"></i> Cancelar\n  </button>\n  <button type=\"submit\" md-effect class=\"btn btn-primary\" validar-formulario=\"formAdjudicacion\" ng-click=\"$ctrl.adjudicarProyecto()\">\n    <i class=\"fa fa-check\"></i> Adjudicar\n  </button>\n</div>\n"

/***/ }),
/* 647 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\"><i class=\"fa fa-plus-circle\"></i> Nuevo Proyecto</h5>\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cerrar()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<div class=\"modal-body\">\n  <ng-form name=\"formProyecto\">\n    <datos-generales proyecto=\"$ctrl.proyecto\" ng-if=\"$ctrl.conEstados\"></datos-generales>\n    <convenio proyecto=\"$ctrl.proyecto\" ng-if=\"$ctrl.conEstados\"></convenio>\n  </ng-form>\n</div>\n\n<div class=\"modal-footer\">\n  <button type=\"button\" md-effect class=\"btn btn-secondary\" ng-click=\"$ctrl.cerrar()\">\n    <i class=\"fa fa-close\"></i> Cancelar\n  </button>\n  <button type=\"submit\" md-effect class=\"btn btn-primary\" validar-formulario=\"formProyecto\" ng-click=\"$ctrl.guardarDatos()\">\n    <i class=\"fa fa-check\"></i> Guardar y enviar\n  </button>\n</div>\n"

/***/ }),
/* 648 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <h2 class=\"page-title\"><i class=\"fa fa-bars\"></i> Mis proyectos</h2>\n  <div class=\"card\">\n    <div class=\"card-body\">\n      <div class=\"btn-container d-flex flex-row\">\n        <button\n          class=\"btn btn-{{boton.md}} boton-circular-mediano p-2\"\n          md-effect\n          type=\"button\"\n          ng-click=\"$ctrl.eventoOpcion($event, boton)\"\n          uib-tooltip=\"{{boton.tooltip}}\"\n          ng-if=\"$ctrl.config.opciones\"\n          ng-repeat=\"boton in $ctrl.config.opciones\"\n        >\n          <i class=\"fa fa-{{boton.icon}}\"></i>\n        </button>\n      </div>\n\n      <div class=\"crud-table\" ng-table=\"$ctrl.tableParams\">\n        <table\n          class=\"table table-striped table-hover ng-table table-responsive\"\n        >\n          <tr ng-repeat=\"proyecto in $data track by proyecto.id_proyecto\">\n            <td data-title=\"''\">\n              <button\n                md-effect\n                type=\"button\"\n                class=\"btn btn-{{boton.md}} btn-sm mt-1\"\n                ng-click=\"$ctrl.eventoOpcion($event, boton, proyecto)\"\n                uib-tooltip=\"t{{boton.tooltip}}\"\n                ng-if=\"$ctrl.config.acciones\"\n                ng-repeat=\"boton in $ctrl.config.acciones\"\n              >\n                <i class=\"fa fa-{{boton.icon}}\"></i>\n              </button>\n              <button\n                md-effect\n                type=\"button\"\n                class=\"btn btn-success btn-sm mt-1\"\n                ng-click=\"$ctrl.nuevaPlanilla(proyecto)\"\n                uib-tooltip=\"Crear Planilla\"\n                ng-if=\"proyecto.estado_proyecto === 'APROBADO' && $ctrl.esEmpresa && $ctrl.puedeCrearPlanilla(proyecto)\"\n              >\n                <i class=\"fa fa-plus\"></i>\n              </button>\n              <lista-supervisiones\n                proyecto=\"proyecto\"\n                ng-if=\"$ctrl.puedeVerSupervision(proyecto)\"\n              >\n              </lista-supervisiones>\n              <lista-modificaciones\n                proyecto=\"proyecto\"\n                ng-if=\"$ctrl.puedeVerModificacion(proyecto)\"\n              ></lista-modificaciones>\n              <button-paralizar\n                proyecto=\"proyecto\"\n                ng-if=\"$ctrl.puedeParalizar(proyecto)\"\n              ></button-paralizar>\n            </td>\n            <td\n              data-title=\"'Departamento'\"\n              filter=\"{'municipio.provincia.departamento.nombre': 'text'}\"\n              sortable=\"'municipio.provincia.departamento.nombre'\"\n            >\n              {{proyecto.municipio.provincia.departamento.nombre}}\n            </td>\n            <!--<td data-title=\"'Código'\" filter=\"{codigo: 'text'}\" sortable=\"'codigo'\">{{proyecto.codigo}}</td>-->\n            <td\n              data-title=\"'Nro Convenio'\"\n              filter=\"{nro_convenio: 'text'}\"\n              sortable=\"'nro_convenio'\"\n            >\n              {{proyecto.nro_convenio}}\n            </td>\n            <td\n              data-title=\"'Nombre'\"\n              filter=\"{nombre: 'text'}\"\n              sortable=\"'nombre'\"\n            >\n              {{proyecto.nombre}}\n              <div ng-if=\"proyecto.supervisiones.length > 0\">\n                <strong class=\"resaltado\"\n                  >Planilla:\n                  {{proyecto.supervisiones[0].nro_supervision}}</strong\n                >\n              </div>\n              <div ng-if=\"proyecto.documentacion_exp\">\n                <small\n                  ng-if=\"proyecto.documentacion_exp.datos_asociacion.nombre_asociacion\"\n                  title=\"Asociación\"\n                  ><strong\n                    >{{proyecto.documentacion_exp.datos_asociacion.nombre_asociacion}}</strong\n                  ></small\n                >\n                <small\n                  ng-if=\"proyecto.documentacion_exp.datos_empresa.razon_social&&!proyecto.documentacion_exp.datos_asociacion.nombre_asociacion\"\n                  title=\"Empresa\"\n                  ><strong\n                    >{{proyecto.documentacion_exp.datos_empresa.razon_social}}</strong\n                  ></small\n                >\n              </div>\n            </td>\n            <td data-title=\"'Tipo'\" filter=\"{tipo: 'text'}\" sortable=\"'tipo'\">\n              {{proyecto.tipo_proyecto.nombre}}\n            </td>\n            <td\n              data-title=\"'Monto total'\"\n              filter=\"{monto_total: 'text'}\"\n              sortable=\"'monto_total'\"\n            >\n              {{proyecto.monto_total | formatDecimal}}\n            </td>\n            <td\n              data-title=\"'Plazo ejecución'\"\n              filter=\"{plazo_ejecucion: 'text'}\"\n              sortable=\"'plazo_ejecucion'\"\n            >\n              {{proyecto.plazo_ejecucion | formatDecimal}}\n            </td>\n            <td\n              data-title=\"'Código de acceso'\"\n              filter=\"{codigo_acceso: 'text'}\"\n              sortable=\"'codigo_acceso'\"\n            >\n              {{proyecto.codigo_acceso}}\n            </td>\n            <td\n              data-title=\"'Técnico - (Nombres'\"\n              filter=\"{'usuario.persona.nombres': 'text'}\"\n              sortable=\"'usuario.persona.nombres'\"\n            >\n              {{proyecto.usuario.persona.nombres}}\n            </td>\n            <td\n              data-title=\"'Apellido)'\"\n              filter=\"{'usuario.persona.primer_apellido': 'text'}\"\n              sortable=\"'usuario.persona.primer_apellido'\"\n            >\n              {{proyecto.usuario.persona.primer_apellido}}\n            </td>\n            <td\n              data-title=\"'Estado Proyecto'\"\n              filter=\"{estado_proyecto: 'text'}\"\n              sortable=\"'estado_proyecto'\"\n            >\n              {{proyecto.estado_actual.nombre}}\n            </td>\n            <td\n              data-title=\"'Estado Supervisión'\"\n              filter=\"{'supervisiones.estado_actual.nombre': 'text'}\"\n              sortable=\"'supervisiones.estado_actual.nombre'\"\n            >\n              {{proyecto.supervisiones[0].estado_actual.nombre}}\n            </td>\n            <td\n              data-title=\"'Modificado'\"\n              filter=\"{_fecha_modificacion: 'text'}\"\n              sortable=\"'_fecha_modificacion'\"\n              ng-class=\"$ctrl.colorDate(proyecto._fecha_modificacion)\"\n            >\n              {{$ctrl.relativeDate(proyecto._fecha_modificacion)}}\n            </td>\n          </tr>\n        </table>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 649 */
/***/ (function(module, exports) {

	module.exports = "<button md-effect type=\"button\" class=\"btn btn-info btn-sm mt-1\"\n  uib-tooltip=\"Ver planillas\" ng-click=\"$ctrl.verSupervisiones()\">\n  <i class=\"fa fa-list\"></i>\n</button>\n"

/***/ }),
/* 650 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\"><i class=\"fa fa-list\"></i> {{$ctrl.proyecto.nombre}}</h5>\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cerrar()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<div class=\"modal-body\">\n  <p class=\"text-center\"><strong>PLANILLAS DE AVANCE</strong></p>\n  <div class=\"crud-table mt-3\">\n    <table class=\"table table-striped table-hover ng-table\">\n      <thead>\n        <tr>\n          <td><strong></strong></td>\n          <td><strong>Nombre</strong></td>\n          <td><strong>Estado</strong></td>\n        </tr>\n      </thead>\n      <tbody>\n        <tr ng-repeat=\"supervision in $ctrl.proyecto.supervisiones\">\n          <td data-title=\"'Acción'\">\n            <button md-effect type=\"button\" class=\"btn btn-success btn-noborder btn-sm mb-1\"\n            uib-tooltip=\"Ver planilla {{supervision.nro_supervision}}\" ng-click=\"$ctrl.irAPlanilla(supervision)\">\n            <i class=\"fa fa-eye\"></i>\n          </button>\n          <button md-effect type=\"button\" class=\"btn btn-info btn-noborder btn-sm mb-1\"\n                  uib-tooltip=\"Descargar planilla\" ng-if=\"supervision.estado_supervision === 'EN_ARCHIVO'\"\n                  download-file=\"{{supervision.urlPlanillaDescarga}}\" file-name=\"{{supervision.nombrePlanillaDescarga}}\">\n            <i class=\"fa fa-file-text\"></i>\n          </button>\n          <button md-effect type=\"button\" class=\"btn btn-info btn-noborder btn-sm mb-1\"\n                  uib-tooltip=\"Descargar resumen de cómputos métricos\" ng-if=\"supervision.estado_supervision === 'EN_ARCHIVO'\"\n                  download-file=\"{{supervision.urlComputosDescarga}}\" file-name=\"{{supervision.nombreComputosDescarga}}\">\n            <i class=\"fa fa-table\"></i>\n          </button>\n          <button md-effect type=\"button\" class=\"btn btn-default btn-noborder btn-sm mb-1\"\n                  uib-tooltip=\"Formulario 2\" ng-if=\"supervision.estado_supervision === 'EN_ARCHIVO'\"\n                  download-file=\"{{supervision.urlFormulario2}}\" file-name=\"{{supervision.nombreFormulario2}}\">\n            <i class=\"fa fa-file-text\"></i>\n          </button>\n          <button md-effect type=\"button\" class=\"btn btn-default btn-noborder btn-sm mb-1\"\n                  uib-tooltip=\"Formulario 4\" ng-if=\"supervision.estado_supervision === 'EN_ARCHIVO'\"\n                  download-file=\"{{supervision.urlFormulario4}}\" file-name=\"{{supervision.nombreFormulario4}}\">\n            <i class=\"fa fa-file-text\"></i>\n          </button>\n          <button md-effect type=\"button\" class=\"btn btn-default btn-noborder btn-sm mb-1\"\n                  uib-tooltip=\"Formulario 6\" ng-if=\"supervision.estado_supervision === 'EN_ARCHIVO'\"\n                  download-file=\"{{supervision.urlFormulario6}}\" file-name=\"{{supervision.nombreFormulario6}}\">\n            <i class=\"fa fa-file-text\"></i>\n          </button>\n\n        </td>\n        <td>Planilla {{supervision.nro_supervision}}</td>\n        <td>{{supervision.estado_actual.nombre}}</td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n\n</div>\n\n<div class=\"modal-footer\">\n  <button type=\"button\" md-effect class=\"btn btn-primary\" ng-click=\"$ctrl.cerrar()\">\n    <i class=\"fa fa-check\"></i> Aceptar\n  </button>\n</div>\n"

/***/ }),
/* 651 */
/***/ (function(module, exports) {

	module.exports = "<section>\n  <h6 class=\"title-section m-top\"><i class=\"fa fa-user\"></i> Asignación de Responsable</h6>\n  <div class=\"row\">\n    <div class=\"col-md-12\">\n      <c-select name=\"usuario_asignado\"\n      label=\"Responsable de Proyecto\"\n      ng-model=\"$ctrl.usuario_asignado\"\n      on-select=\"$ctrl.seleccionado()\"\n      options=\"$ctrl.usuariosParaAsignar\"\n      field=\"nombre\"\n      ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('fid_usuario_asignado')\"\n      ng-disabled=\"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('fid_usuario_asignado')\"></c-select>\n    </div>\n  </div>\n</section>\n"

/***/ }),
/* 652 */
/***/ (function(module, exports) {

	module.exports = "<documento-identidad\n  ng-model=\"$ctrl.proyecto.autoridad_beneficiaria\"\n  modo-vista=\"$ctrl.modoVista\"\n></documento-identidad>\n\n<div class=\"row\">\n  <div class=\"md-input-group col-md-12\">\n    <c-input\n      name=\"cargo\"\n      label=\"Cargo\"\n      ng-model=\"$ctrl.proyecto.cargo_autoridad_beneficiaria\"\n      maxlength=\"150\"\n      ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('cargo_autoridad_beneficiaria')\"\n      ng-disabled=\"($ctrl.modoVista || !$ctrl.Proyecto.esEditable('cargo_autoridad_beneficiaria'))&& !$ctrl.config.modificar\"\n    >\n    </c-input>\n  </div>\n\n  <div class=\"md-input-group col-md-4\">\n    <c-input\n      name=\"celular\"\n      label=\"Celular\"\n      ng-model=\"$ctrl.proyecto.autoridad_beneficiaria.telefono\"\n      ng-directives=\"numeric\"\n      maxlength=\"8\"\n      ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('autoridad_beneficiaria')\"\n      ng-disabled=\"($ctrl.modoVista || !$ctrl.Proyecto.esEditable('autoridad_beneficiaria'))&& !$ctrl.config.modificar\"\n    >\n    </c-input>\n  </div>\n\n  <div class=\"md-input-group col-md-4\">\n    <c-input\n      name=\"correo\"\n      label=\"Correo Electrónico\"\n      ng-model=\"$ctrl.proyecto.autoridad_beneficiaria.correo\"\n      maxlength=\"150\"\n      ng-validation=\"correo\"\n      ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('autoridad_beneficiaria')\"\n      ng-disabled=\"($ctrl.modoVista || !$ctrl.Proyecto.esEditable('autoridad_beneficiaria'))&& !$ctrl.config.modificar\"\n    >\n    </c-input>\n  </div>\n\n  <div class=\"md-input-group col-md-4\">\n    <c-input\n      name=\"fax\"\n      label=\"Fax\"\n      ng-model=\"$ctrl.proyecto.fax_autoridad_beneficiaria\"\n      ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('fax_autoridad_beneficiaria')\"\n      ng-disabled=\"($ctrl.modoVista || !$ctrl.Proyecto.esEditable('fax_autoridad_beneficiaria'))&& !$ctrl.config.modificar\"\n    >\n    </c-input>\n  </div>\n</div>\n<div nng-if=\"$ctrl.puedeReenviarConfirmacion()\">\n  <!-- <button\n    ng-if=\"$ctrl.config.autoridad\"\n    ng-disabled=\"$ctrl.config.modificar\"\n    md-effect\n    type=\"button\"\n    class=\"btn btn-sm btn-danger\"\n    uib-tooltip=\"Modificar usuario\"\n    ng-click=\"$ctrl.modificarUsuarioGAM()\"\n  >\n    <i class=\"fa fa-edit\"></i>\n  </button> -->\n  <button\n    ng-if=\"$ctrl.config.modificar\"\n    md-effect\n    type=\"button\"\n    class=\"btn btn-sm btn-primary\"\n    uib-tooltip=\"Guardar cambios\"\n    ng-click=\"$ctrl.GuardarUsuarioGAM()\"\n  >\n    <i class=\"fa fa-save\"></i>\n  </button>\n  <button\n    ng-if=\"$ctrl.config.modificar\"\n    md-effect\n    type=\"button\"\n    class=\"btn btn-sm btn-warning\"\n    uib-tooltip=\"Cancelar cambios\"\n    ng-click=\"$ctrl.modificarCancelado()\"\n  >\n    <i class=\"fa fa-ban\"></i>\n  </button>\n</div>\n"

/***/ }),
/* 653 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\n  <div class=\"md-input-group col-md-5\">\n    <c-input-numeric name=\"{{$ctrl.datos.nombrePorcentaje}}\" label=\"Porcentaje\"\n      ng-model=\"$ctrl.porcentaje\"\n      ng-minvalue=\"0\" ng-maxvalue=\"20\" ng-formatting=\"false\" ng-decimals=\"2\"\n      ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('porcentaje_anticipo')\"\n      ng-blur=\"$ctrl.cambiarPorcentaje($ctrl.porcentaje)\"\n      ng-disabled=\"$ctrl.modoVista || (!$ctrl.porcentajeCheck)\">\n    </c-input-numeric>\n  </div>\n  <div class=\"md-input-group col-md-1\">\n    <input name=\"{{$ctrl.datos.nombreMonto}}_i\" ng-model=\"$ctrl.porcentajeCheck\" style=\"margin-top:24px;\"\n      type=\"checkbox\" ng-click=\"$ctrl.editarPorcentaje()\" ng-if=\"$ctrl.tipo=='TB_CORRECTA_INVERSION'\" ng-disabled=\"$ctrl.modoVista\"></input>\n  </div>\n\n  <div class=\"md-input-group col-md-5\">\n    <c-input-money name=\"{{$ctrl.datos.nombreMonto}}\" label=\"Monto\" ng-model=\"$ctrl.monto\"\n      ng-minvalue=\"0\"\n      ng-blur=\"$ctrl.cambiarMonto($ctrl.monto)\"\n      ng-disabled=\"$ctrl.modoVista || !$ctrl.montoCheck\"></c-input-money>\n  </div>\n  <div class=\"md-input-group col-md-1\">\n    <input name=\"{{$ctrl.datos.nombreMonto}}_i\" ng-model=\"$ctrl.montoCheck\" style=\"margin-top:24px;\"\n      type=\"checkbox\" ng-click=\"$ctrl.editarMonto()\" ng-if=\"$ctrl.tipo=='TB_CORRECTA_INVERSION'\" ng-disabled=\"$ctrl.modoVista\"></input>\n  </div>\n  <div class=\"md-input-group col-md-6\"></div>\n  <div class=\"md-input-group col-md-5\" ng-if=\"($ctrl.monto||$ctrl.montoDeuda)&& $ctrl.tipo=='TB_CORRECTA_INVERSION'\">\n    <c-input-money name=\"{{$ctrl.datos.nombreMonto}}1\" label=\"Monto para boletas renovadas\" ng-model=\"$ctrl.montoDeuda\"\n      ng-disabled=\"!$ctrl.pModificar\"\n      ng-minvalue=\"0\" ng-blur=\"$ctrl.cambiarMontoDeuda($ctrl.montoDeuda)\"></c-input-money>\n  </div>\n</div>\n\n<div class=\"row\">\n  <div class=\"col\" ng-if=\"$ctrl.mostrarBoletas && !$ctrl.completado && !$ctrl.modoVista\">\n    <button md-effect class=\"btn btn-success text-right\" type=\"submit\"\n      ng-click=\"$ctrl.adicionarBoleta()\">\n      <i class=\"fa fa-plus\"></i> Agregar boleta\n    </button>\n  </div>\n  <div class=\"col-md-9\" ng-if=\"$ctrl.mostrarBoletas && $ctrl.mensaje.mensaje\">\n    <div class=\"alert alert-{{$ctrl.mensaje.class}}\">\n      <i class=\"fa fa-{{$ctrl.mensaje.icono}}\"></i>\n      {{$ctrl.mensaje.mensaje}}, la suma de las boletas es <strong>{{$ctrl.sumaMontoBoletas | formatDecimal}}</strong>\n    </div>\n  </div>\n</div>\n\n<div class=\"row\">\n  <div class=\"col-md-6 warning\" ng-repeat=\"boleta in $ctrl.boletas\" ng-if=\"($ctrl.mostrarBoletas || $ctrl.modoVista) && boleta.estado=='ACTIVO'\" style=\"border:1px dotted #bbb;\">\n    <boleta model=\"$ctrl.boletas[$index]\" indice=\"$index\"\n            validaciones=\"$ctrl.validaciones\"\n            tipo-boleta=\"$ctrl.tipo\"\n            bid=\"1\"\n            modo-vista=\"$ctrl.modoVista\">\n    </boleta>\n    <button md-effect class=\"btn btn-danger float-right\" type=\"submit\"\n            ng-click=\"$ctrl.quitarBoleta($index)\"\n            ng-if=\"!$ctrl.modoVista && !boleta.id_boleta\">\n      <i class=\"fa fa-trash-o\"></i> Quitar boleta\n    </button>\n    <button md-effect class=\"btn btn-danger float-right\" type=\"submit\"\n            ng-click=\"$ctrl.invalidarBoleta($index)\"\n            ng-if=\"boleta.id_boleta && boleta.estado=='ACTIVO' && boleta.vencida && $ctrl.pModificar\">\n            <!-- ng-if=\"$ctrl.modoVista && $ctrl.pModificar\"> -->\n      <i class=\"fa fa-close\"></i> Renovar boleta\n    </button>\n  </div>\n</div>\n\n<hr>\n<div class=\"row\" ng-if=\"$ctrl.pModificar\">\n  <div class=\"col\">\n    <button md-effect class=\"btn btn-success text-right\" type=\"submit\"\n      ng-click=\"$ctrl.adicionarBoletaEx()\">\n      <i class=\"fa fa-plus\"></i> Agregar nueva boleta\n    </button>\n  </div>\n</div>\n\n<div class=\"row\" ng-if=\"$ctrl.pModificar\">\n  <div class=\"col-md-6\" ng-repeat=\"boleta in $ctrl.boletasEx\">\n    <boleta model=\"$ctrl.boletasEx[$index]\" indice=\"$index\"\n            validaciones=\"$ctrl.validacionesEx\"\n            bid=\"2\"\n            tipo-boleta=\"$ctrl.tipo\">\n    </boleta>\n    <button md-effect class=\"btn btn-danger float-right\" type=\"submit\"\n            ng-click=\"$ctrl.quitarBoletaEx($index)\">\n      <i class=\"fa fa-trash-o\"></i> Quitar boleta\n    </button>\n  </div>\n  <div class=\"col-12\" ng-if=\"$ctrl.boletasEx.length\">\n    <button md-effect class=\"btn btn-primary text-right\" type=\"submit\"\n      ng-click=\"$ctrl.enviarBoletaEx()\">\n      <i class=\"fa fa-plus\"></i> Guardar boletas agregadas\n    </button>\n  </div>\n</div>\n\n<hr>\n<div class=\"row\">\n  <div class=\"md-input-group col-12\">\n    <button md-effect class=\"btn text-right pull-right\" ng-class=\"{'btn-success':$ctrl.historial,'btn-primary':!$ctrl.historial}\" type=\"button\"\n      ng-click=\"$ctrl.historial=!$ctrl.historial\">\n      <i class=\"fa\" ng-class=\"{'fa-eye':$ctrl.historial,'fa-eye-slash':!$ctrl.historial}\"></i> Boletas anteriores\n    </button>\n  </div>\n\n  <div class=\"col-md-6 warning\" ng-repeat=\"boleta in $ctrl.boletas\" ng-if=\"(boleta.estado!=='ACTIVO' && $ctrl.historial)\" style=\"border:1px dotted #bbb;\">\n    <boleta model=\"$ctrl.boletas[$index]\" indice=\"$index\"\n            validaciones=\"$ctrl.validaciones\"\n            tipo-boleta=\"$ctrl.tipo\"\n            bid=\"1\"\n            modo-vista=\"$ctrl.modoVista\">\n    </boleta>\n    <button md-effect class=\"btn btn-danger float-right\" type=\"submit\"\n            ng-click=\"$ctrl.quitarBoleta($index)\"\n            ng-if=\"!$ctrl.modoVista && !boleta.id_boleta\">\n      <i class=\"fa fa-trash-o\"></i> Quitar boleta\n    </button>\n    <button md-effect class=\"btn btn-danger float-right\" type=\"submit\"\n            ng-click=\"$ctrl.invalidarBoleta($index)\"\n            ng-if=\"boleta.id_boleta && boleta.estado=='ACTIVO' && boleta.vencida && $ctrl.pModificar\">\n            <!-- ng-if=\"$ctrl.modoVista && $ctrl.pModificar\"> -->\n      <i class=\"fa fa-close\"></i> Renovar boleta\n    </button>\n  </div>\n</div>\n"

/***/ }),
/* 654 */
/***/ (function(module, exports) {

	module.exports = "<section>\n  <h6\n    class=\"title-section m-top\"\n    ng-class=\"{'bg-success':!$ctrl.model.vencida && $ctrl.model.estado=='ACTIVO','bg-warning':$ctrl.model.vencida && $ctrl.model.estado=='ACTIVO','bg-secondary':$ctrl.model.estado!='ACTIVO'}\"\n  >\n    <i class=\"fa fa-file-text-o\"></i> Boleta {{$ctrl.indice + 1}} {{\n    $ctrl.model.estado=='ACTIVO'? ($ctrl.model.vencida?' (Verificar\n    validez)':'') : ' (Inactivo)'}}\n  </h6>\n  <div class=\"row\">\n    <div class=\"col-md-12\">\n      <c-radiobutton\n        name=\"tipo_documento_{{$ctrl.tipoBoleta}}_{{$ctrl.indice}}_{{$ctrl.bid}}\"\n        label=\"Tipo\"\n        ng-model=\"$ctrl.model.tipo_documento\"\n        options=\"$ctrl.tiposDocumento\"\n        field=\"nombre\"\n        horizontal=\"true\"\n        ng-required=\"true && !$ctrl.modoVista\"\n        ng-disabled=\"$ctrl.modoVista\"\n      >\n      </c-radiobutton>\n    </div>\n    <div class=\"md-input-group col-md-6\">\n      <c-input\n        name=\"numero_boleta_{{$ctrl.tipoBoleta}}_{{$ctrl.indice}}_{{$ctrl.bid}}\"\n        label=\"Número\"\n        ng-model=\"$ctrl.model.numero\"\n        ng-required=\"true && !$ctrl.modoVista\"\n        ng-disabled=\"$ctrl.modoVista\"\n      >\n      </c-input>\n    </div>\n\n    <div class=\"md-input-group col-md-6\">\n      <c-input-numeric\n        name=\"monto_boleta_{{$ctrl.tipoBoleta}}_{{$ctrl.indice}}_{{$ctrl.bid}}\"\n        label=\"Monto en (Bs)\"\n        ng-model=\"$ctrl.model.monto\"\n        ng-minvalue=\"0\"\n        ng-formatting=\"false\"\n        ng-decimals=\"2\"\n        ng-required=\"true && !$ctrl.modoVista\"\n        ng-disabled=\"$ctrl.modoVista\"\n      >\n      </c-input-numeric>\n    </div>\n\n    <div class=\"md-input-group col-md-6\">\n      <c-date\n        name=\"fecha_inicio_validez_{{$ctrl.tipoBoleta}}_{{$ctrl.indice}}_{{$ctrl.bid}}\"\n        label=\"Fecha inicio de validez\"\n        ng-model=\"$ctrl.model.fecha_inicio_validez\"\n        ng-required=\"true && !$ctrl.modoVista\"\n        ng-disabled=\"$ctrl.modoVista\"\n        max-date-key=\"fecha_fin_validez_{{$ctrl.tipoBoleta}}_{{$ctrl.indice}}_{{$ctrl.bid}}\"\n      >\n      </c-date>\n    </div>\n\n    <div class=\"md-input-group col-md-6\">\n      <c-date\n        name=\"fecha_fin_validez_{{$ctrl.tipoBoleta}}_{{$ctrl.indice}}_{{$ctrl.bid}}\"\n        label=\"Fecha fin de validez\"\n        ng-model=\"$ctrl.model.fecha_fin_validez\"\n        ng-required=\"true && !$ctrl.modoVista\"\n        ng-disabled=\"$ctrl.modoVista\"\n        min-date-key=\"fecha_inicio_validez_{{$ctrl.tipoBoleta}}_{{$ctrl.indice}}_{{$ctrl.bid}}\"\n      >\n      </c-date>\n    </div>\n    <div class=\"col-12\">\n      <archivo\n        name=\"doc_boleta\"\n        label=\"Boleta\"\n        ng-model=\"$ctrl.model.doc_boleta\"\n        types=\"pdf\"\n        mime-types=\".pdf\"\n        maxsize=\"3MB\"\n        url=\"{{$ctrl.model.urlDocBoleta}}\"\n        url-descarga=\"{{$ctrl.model.urlDocBoletaDescarga}}\"\n        modo-vista=\"$ctrl.modoVista\"\n      >\n      </archivo>\n    </div>\n  </div>\n</section>\n"

/***/ }),
/* 655 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"cronogramas\" class=\"row\">\n  <div class=\"col-md-6 col-lg-4\" ng-repeat=\"documento in $ctrl.documentos.lista\">\n    <ui-input-file name=\"{{documento.codigo}}\" label=\"{{documento.nombre}}\"\n      file-base64=\"$ctrl.empresa[documento.codigo]\"\n      upload-callback=\"$ctrl.documentos.uploadCallback\"\n      types=\"pdf\" mime-types=\".pdf\" maxfiles=\"1\" maxsize=\"30MB\"\n      ng-if=\"!documento.registrado\">\n    </ui-input-file>\n\n    <div id=\"documento\" ng-if=\"documento.registrado\">\n      <div class=\"opciones\">\n        <button md-effect type=\"button\" class=\"btn btn-success btn-sm\" uib-tooltip=\"Ver documento\" ng-click=\"$ctrl.verDocumento(documento)\">\n          <i class=\"fa fa-eye\"></i>\n        </button>\n        <button md-effect type=\"button\" class=\"btn btn-primary btn-sm\" uib-tooltip=\"Descargar\"\n                download-file=\"{{documento.urlDescarga}}\" file-name=\"{{documento.nombre}}\">\n          <i class=\"fa fa-download\"></i>\n        </button>\n        <button md-effect type=\"button\" class=\"btn btn-info btn-sm\" uib-tooltip=\"Cambiar\" ng-if=\"$ctrl.Proyecto.esEditable('boletas')\" ng-click=\"$ctrl.cambiar(documento)\">\n          <i class=\"fa fa-exchange\"></i>\n        </button>\n      </div>\n      <img src=\"./images/formulario.jpg\" alt=\"Documento\">\n      <div class=\"detalles\">\n        <div class=\"nombre\">{{documento.nombre}}</div>\n      </div>\n    </div>\n  </div>\n</div>"

/***/ }),
/* 656 */
/***/ (function(module, exports) {

	module.exports = "<section>\n  <h6 class=\"title-section m-top\">\n    <i class=\"fa fa-hand-o-right\"></i> Datos del Convenio\n  </h6>\n  <div class=\"row\">\n    <div class=\"md-input-group col-md-4\">\n      <c-input name=\"nro_convenio\" label=\"Número\" ng-model=\"$ctrl.proyecto.nro_convenio\"\n      ng-minlength=\"3\" maxlength=\"100\"\n      ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('nro_convenio')\"\n      ng-disabled=\"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('nro_convenio')\"></c-input>\n    </div>\n\n    <div class=\"md-input-group col-md-4\">\n      <c-date name=\"fecha_suscripcion\" label=\"Fecha de suscripción\" ng-model=\"$ctrl.proyecto.fecha_suscripcion_convenio\"\n      ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('fecha_suscripcion_convenio')\"\n      ng-disabled=\"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('fecha_suscripcion_convenio')\"></c-date>\n    </div>\n\n    <div class=\"md-input-group col-md-4\">\n      <c-input-numeric name=\"plazo_ejecucion_convenio\" label=\"Plazo de ejecución (días calendario)\" ng-model=\"$ctrl.proyecto.plazo_ejecucion_convenio\"\n      ng-minvalue=\"0\" ng-maxvalue=\"999999\" ng-formatting=\"false\" ng-decimals=\"0\"\n      ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('plazo_ejecucion_convenio')\"\n      ng-disabled=\"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('plazo_ejecucion_convenio')\"></c-input-numeric>\n    </div>\n\n    <div class=\"md-input-group col-md-4\">\n      <c-input-money name=\"monto_upre\" label=\"Monto financiado UPRE\" ng-model=\"$ctrl.proyecto.monto_upre\"\n      ng-minvalue=\"0\"\n      ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('monto_upre')\"\n      ng-disabled=\"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('monto_upre')\"></c-input-money>\n    </div>\n    <div class=\"md-input-group col-md-4\">\n      <c-input-money name=\"monto_contraparte\" label=\"Monto financiado contraparte\" ng-model=\"$ctrl.proyecto.monto_contraparte\"\n      ng-minvalue=\"0\"\n      ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('monto_contraparte')\"\n      ng-disabled=\"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('monto_contraparte')\"></c-input-money>\n    </div>\n    <div class=\"md-input-group col-md-4\">\n      <c-input-money name=\"monto_total_convenio\" label=\"Monto total de convenio\" ng-model=\"$ctrl.proyecto.monto_total_convenio\"\n      ng-minvalue=\"0\"\n      ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('monto_total_convenio')\"\n      ng-disabled=\"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('monto_total_convenio')\"></c-input-money>\n    </div>\n\n    <div class=\"col-lg-6 col-md-12\" ng-if=\"$ctrl.proyecto.tipo == 'TP_CIFE'\">\n      <archivo name=\"doc_resmin_cife\" label=\"Resolución Ministerial\" ng-model=\"$ctrl.proyecto.doc_resmin_cife\"\n              types=\"pdf\" mime-types=\".pdf\" maxsize=\"20MB\"\n              url=\"{{$ctrl.archivos.urlDocResolucion}}\"\n              url-descarga=\"{{$ctrl.archivos.urlDocResolucionDescarga}}\"\n              cambiar=\"$ctrl.Proyecto.esEditable('doc_resmin_cife')\"\n              modo-vista=\"!$ctrl.Proyecto.esEditable('doc_resmin_cife')\">\n      </archivo>\n    </div>\n\n    <div class=\"col-md-12 col-lg-6\">\n      <archivo name=\"doc_convenio\" label=\"Convenio\" ng-model=\"$ctrl.proyecto.doc_convenio\"\n              types=\"pdf\" mime-types=\".pdf\" maxsize=\"20MB\"\n              url=\"{{$ctrl.archivos.urlDocConvenio}}\"\n              url-descarga=\"{{$ctrl.archivos.urlDocConvenioDescarga}}\"\n              cambiar=\"$ctrl.Proyecto.esEditable('doc_convenio')\"\n              modo-vista=\"!$ctrl.Proyecto.esEditable('doc_convenio')\">\n      </archivo>\n    </div>\n  </div>\n</section>\n"

/***/ }),
/* 657 */
/***/ (function(module, exports) {

	module.exports = "<section>\n  <h6 class=\"title-section m-top\">\n    <i class=\"fa fa-file-text-o\"></i> Datos generales\n  </h6>\n  <div class=\"row\">\n    <div class=\"md-input-group col-md-6\">\n      <select-parametro name=\"tipo_proyecto\" label=\"Tipo de proyecto\" ng-model=\"$ctrl.proyecto.tipo\"\n      parametro=\"TIPO_PROYECTO\" ng-change=\"$ctrl.callbacks.tipoProyecto($ctrl.proyecto.tipo)\"\n      ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('tipo')\"\n      ng-disabled=\"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('tipo')\"></select-parametro>\n    </div>\n\n    <div class=\"md-input-group col-md-6\" ng-if=\"$ctrl.proyecto.codigo\">\n      <c-input name=\"codigo\" label=\"Código\" ng-model=\"$ctrl.proyecto.codigo\"\n      ng-disabled=\"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('codigo')\"></c-input>\n    </div>\n\n    <div class=\"md-input-group col-md-12\">\n      <c-input name=\"nombre_proyecto\" label=\"Nombre\" ng-model=\"$ctrl.proyecto.nombre\"\n      ng-directives=\"uppercase\" ng-minlength=\"3\" maxlength=\"255\"\n      ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('nombre')\"\n      ng-disabled=\"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('nombre')\"></c-input>\n    </div>\n\n    <div class=\"md-input-group col-md-12\">\n      <c-input name=\"entidad_beneficiaria\" label=\"Entidad beneficiaria\" ng-model=\"$ctrl.proyecto.entidad_beneficiaria\"\n      ng-minlength=\"3\" maxlength=\"255\" ng-directives=\"uppercase\"\n      ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('entidad_beneficiaria')\"\n      ng-disabled=\"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('entidad_beneficiaria')\"></c-input>\n    </div>\n\n    <div class=\"col-md-12\">\n      <c-select-dpa ng-model=\"$ctrl.proyecto.dpa\" horizontal=\"true\"\n      ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('fcod_municipio')\"\n      ng-disabled=\"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('fcod_municipio')\"></c-select-dpa>\n    </div>\n\n    <div class=\"col-md-12\" ng-if=\"$ctrl.proyecto.sector || $ctrl.Proyecto.esEditable('sector')\">\n      <select-parametro name=\"sector\" label=\"Sector\" ng-model=\"$ctrl.proyecto.sector\" parametro=\"SECTOR\"\n      ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('sector')\"\n      ng-disabled=\"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('sector')\"></select-parametro>\n    </div>\n\n    <div class=\"md-input-group col-md-6\" ng-if=\"$ctrl.proyecto.plazo_ejecucion\">\n      <c-input-numeric name=\"plazo_ejecucion_contrato\" label=\"Plazo de ejecución (días calendario)\" ng-model=\"$ctrl.proyecto.plazo_ejecucion\"\n      ng-disabled=\"true\"></c-input-numeric>\n    </div>\n\n    <div class=\"md-input-group col-md-6\" ng-if=\"$ctrl.proyecto.monto_total\">\n      <c-input-money name=\"monto_total_contrato\" label=\"Monto total\" ng-model=\"$ctrl.proyecto.monto_total\"\n      ng-disabled=\"true\"></c-input-money>\n    </div>\n\n  </div>\n</section>\n"

/***/ }),
/* 658 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\n  <div class=\"col-md-12 col-lg-6\">\n    <ui-input-file name=\"doc_convenio\" label=\"Especificación técnica de contratación\"\n    file-base64=\"$ctrl.proyecto.doc_base_contratacion\"\n    types=\"pdf\" mime-types=\".pdf\" maxfiles=\"1\" maxsize=\"20MB\"\n    ng-if=\"$ctrl.Proyecto.esEditable('doc_base_contratacion')\"></ui-input-file>\n\n    <button md-effect class=\"btn btn-info\" type=\"submit\" ng-click=\"$ctrl.verDocumento()\"\n    ng-if=\"$ctrl.modoVista || $ctrl.estaRegistrado()\">\n      <i class=\"fa fa-file-pdf-o\"></i> Ver Especificación Técnica de Contratación\n    </button>\n\n  </div>\n</div>\n"

/***/ }),
/* 659 */
/***/ (function(module, exports) {

	module.exports = "<section>\n  <h6 class=\"title-section m-top\" ng-if=\"$ctrl.proyecto.tipo === 'TP_CIF'\">\n    <!-- <i class=\"fa fa-hand-o-right\"></i> {{$ctrl.proyecto.tipo === 'TP_CIF'? 'Desembolso del 20%' : 'Certificación Presupuestaria'}} -->\n    <i class=\"fa fa-hand-o-right\"></i> Desembolso del 20%\n  </h6>\n  <div class=\"row\">\n    <div class=\"md-input-group col-md-6\" ng-if=\"$ctrl.proyecto.tipo === 'TP_CIF'\">    \n      <c-input-numeric name=\"porcentaje_desembolso\" label=\"Porcentaje Desembolso\"\n                       ng-model=\"$ctrl.proyecto.porcentaje_desembolso\"\n                       ng-minvalue=\"0\" ng-maxvalue=\"20\" ng-formatting=\"false\" ng-decimals=\"2\"\n                       ng-disabled=\"true\">\n      </c-input-numeric>\n    </div>\n\n    <div class=\"md-input-group col-md-6\" ng-if=\"$ctrl.proyecto.tipo === 'TP_CIF'\">    \n      <c-input-money name=\"desembolso\" label=\"Desembolso\"\n                     ng-model=\"$ctrl.proyecto.desembolso\"\n                     ng-minvalue=\"0\"\n                     ng-disabled=\"true\">\n      </c-input-money>\n    </div>\n\n    \n\n  </div>\n  <h6 class=\"title-section m-top\">    \n    <i class=\"fa fa-hand-o-right\"></i> Certificación Presupuestaria\n  </h6>\n  <div class=\"row\">\n    <!-- <div class=\"md-input-group col-md-6\" ng-if=\"$ctrl.proyecto.fecha_desembolso || $ctrl.Proyecto.esEditable('fecha_desembolso')\"> -->\n    <div class=\"md-input-group col-md-6\">\n      <c-date name=\"fecha_desembolso\" label=\"Fecha Inscripción Presupuestaria\"\n              ng-model=\"$ctrl.proyecto.fecha_desembolso\"\n              ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('fecha_desembolso')\"\n              ng-disabled=\"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('fecha_desembolso')\"\n              min-date=\"$ctrl.validacion.fecha_minima\" mensaje-min-date=\"{{$ctrl.validacion.mensaje_fecminima}}\">\n      </c-date>\n    </div>\n\n    <div class=\"col-md-6\" ng-if=\"$ctrl.proyecto.doc_cert_presupuestaria || $ctrl.Proyecto.esEditable('doc_cert_presupuestaria')\">\n      <archivo name=\"doc_cert_presupuestaria\" label=\"Certificado de Inscripción Presupuestaria\" ng-model=\"$ctrl.proyecto.doc_cert_presupuestaria\"\n              types=\"pdf\" mime-types=\".pdf\" maxsize=\"20MB\"\n              url=\"{{$ctrl.archivo.urlDocCertificacion}}\"\n              url-descarga=\"{{$ctrl.archivo.urlDocCertificacionDescarga}}\"\n              cambiar=\"$ctrl.Proyecto.esEditable('doc_cert_presupuestaria')\"\n              modo-vista=\"!$ctrl.Proyecto.esEditable('doc_cert_presupuestaria')\">\n      </archivo>\n    </div>\n  </div>\n\n</section>\n"

/***/ }),
/* 660 */
/***/ (function(module, exports) {

	module.exports = "<span ng-if=\"$ctrl.puedeAcceder()\">\n  <button md-effect type=\"button\" class=\"btn btn-secondary btn-actions\" ng-click=\"$ctrl.cancelar()\" ng-if=\"$ctrl.opcionCancelar\">\n    <i class=\"fa fa-close\"></i> Cancelar\n  </button>\n  <span ng-repeat=\"accion in $ctrl.elemento.estado_actual.acciones\" ng-if=\"accion.tipo === 'boton'\">\n    <button md-effect type=\"button\"\n      class=\"btn btn-actions c-pointer {{accion.class}}\"\n      validar-formulario=\"accion.observacion? false : $ctrl.form\"\n      validacion-paralela=\"$ctrl.validacionParalela()\"\n      ng-click=\"$ctrl.ejecutarAccion(accion)\">\n      <i class=\"fa {{accion.icon}}\"></i> {{accion.label}}\n    </button>\n  </span>\n</span>\n\n<button mf-effect type=\"button\"\n  class=\"btn btn-actions c-pointer btn-primary\"\n  ui-sref=\"mis-proyectos\"\n  ng-if=\"!$ctrl.elemento.estado_actual.acciones || $ctrl.elemento.estado_actual.acciones.length === 0\">\n  <i class=\"fa fa-check\"></i> Aceptar\n</button>\n"

/***/ }),
/* 661 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\"><i class=\"fa fa-rotate-left\"></i> Observando</h5>\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cerrar()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<div class=\"modal-body\">\n  <p>¿Está seguro/a de observar el proceso y devolverlo al estado anterior?</p>\n\n  <ng-form name=\"formObservacion\">\n    <div class=\"row\">\n      <div class=\"col-md-12\">\n        <c-textarea name=\"observacion\" label=\"Detalle de la observación\"\n          ng-model=\"$ctrl.data.observacion\"\n          ng-minlength=\"10\" maxlength=\"3190\" rows=\"5\"\n          ng-required=\"true\"></c-textarea>\n      </div>\n    </div>\n  </ng-form>\n\n  <small><em>NOTA.- Debe registrar el detalle de la observación.</em></small>\n</div>\n<div class=\"modal-footer\">\n  <button type=\"button\" md-effect class=\"btn btn-secondary\" ng-click=\"$ctrl.cerrar()\">\n    <i class=\"fa fa-close\"></i> Cancelar\n  </button>\n  <button type=\"submit\" md-effect class=\"btn btn-primary\" validar-formulario=\"formObservacion\" ng-click=\"$ctrl.observar()\">\n    <i class=\"fa fa-check\"></i> Observar\n  </button>\n</div>\n"

/***/ }),
/* 662 */
/***/ (function(module, exports) {

	module.exports = "<button\n  md-effect\n  type=\"button\"\n  class=\"btn btn-success\"\n  ng-click=\"$ctrl.adicionar()\"\n  ng-if=\"!$ctrl.esEquipoCompleto && !$ctrl.modoVista\"\n>\n  <i class=\"fa fa-plus\"></i> Agregar\n</button>\n<div class=\"crud-table\">\n  <table class=\"table table-striped table-hover table-responsive\">\n    <thead>\n      <tr>\n        <td>Acciones</td>\n        <td>Nombre</td>\n        <td>Cargo</td>\n        <td>Celular</td>\n        <td>Correo electrónico</td>\n        <td>Estado</td>\n      </tr>\n    </thead>\n    <tbody>\n      <tr\n        ng-repeat=\"miembro in $ctrl.listaEquipo\"\n        ng-class=\"{'inactivo':miembro.estado!='ACTIVO'}\"\n      >\n        <td>\n          <button\n            md-effect\n            type=\"button\"\n            class=\"btn btn-sm btn-primary\"\n            uib-tooltip=\"Ver datos\"\n            ng-click=\"$ctrl.verDatos(miembro)\"\n          >\n            <i class=\"fa fa-eye\"></i>\n          </button>\n          <reconfirmacion-usuario\n            usuario=\"miembro.usuario\"\n            ng-if=\"($ctrl.esSupervisorOFiscal(miembro) && $ctrl.esResponsableProy) || ($ctrl.esResponsableEncargadoOTecnico(miembro))\"\n            api=\"{{$ctrl.urlReconfirmacion + miembro.id_equipo_tecnico + '/notificar'}}\"\n          >\n          </reconfirmacion-usuario>\n          <button\n            md-effect\n            type=\"button\"\n            class=\"btn btn-sm btn-danger\"\n            uib-tooltip=\"Inhabilitar usuario\"\n            ng-click=\"$ctrl.inactivarUsuario(miembro)\"\n            ng-if=\"$ctrl.esSupervisorOFiscal(miembro) && $ctrl.esResponsableProy\"\n          >\n            <i class=\"fa fa-ban\"></i>\n          </button>\n        </td>\n        <td>{{miembro.usuario.persona | nombreUnido}}</td>\n        <td>{{miembro.cargo_usuario.nombre}}</td>\n        <td>{{miembro.usuario.persona.telefono}}</td>\n        <td>{{miembro.usuario.persona.correo}}</td>\n        <td>{{miembro.estado}}</td>\n      </tr>\n    </tbody>\n  </table>\n</div>\n"

/***/ }),
/* 663 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\"><i class=\"fa fa-plus-circle\"></i>\n    {{$ctrl.miembro.tipo_equipo != 'TE_UPRE' && !$ctrl.miembro.id_equipo_tecnico ? 'Registro' : $ctrl.modoEdicion ? 'Edición del' : ''}} Integrante del Equipo Técnico\n  </h5>\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cerrar()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<div class=\"modal-body\">\n  <ng-form name=\"formMiembro\">\n    <documento-identidad ng-model=\"$ctrl.miembro\" modo-vista=\"$ctrl.miembro.tipo_equipo == 'TE_UPRE' || !$ctrl.modoEdicion\"></documento-identidad>\n\n    <div class=\"row\">\n      <div class=\"md-input-group col-md-6\">\n        <c-input name=\"celular_miembro\" label=\"Celular\" ng-model=\"$ctrl.miembro.telefono\"\n        ng-validation=\"celular\" ng-directives=\"numeric\" maxlength=\"8\"\n        ng-required=\"true\" ng-disabled=\"$ctrl.miembro.tipo_equipo == 'TE_UPRE' || !$ctrl.modoEdicion\"></c-input>\n      </div>\n\n      <div class=\"md-input-group col-md-6\">\n        <c-input name=\"correo_miembro\" label=\"Correo Electrónico\" ng-model=\"$ctrl.miembro.correo\"\n        ng-validation=\"correo\" ng-required=\"true\" ng-disabled=\"$ctrl.miembro.tipo_equipo == 'TE_UPRE' || !$ctrl.modoEdicion\"></c-input>\n      </div>\n\n      <div class=\"col-md-6\">\n        <c-select name=\"cargo\" label=\"Cargo\" ng-model=\"$ctrl.miembro.cargo\"\n        options=\"$ctrl.cargos\" key-value=\"codigo\" ng-required=\"true\"\n        on-select=\"$ctrl.verificarSiEsSupervisor()\" ng-disabled=\"$ctrl.miembro.tipo_equipo == 'TE_UPRE' || !$ctrl.modoEdicion\"></c-select>\n      </div>\n\n      <div class=\"col-md-6\" ng-if=\"$ctrl.miembro.tipo_equipo != 'TE_UPRE'\">\n        <archivo name=\"doc_designacion\" label=\"Documento de Designación\"\n                ng-model=\"$ctrl.miembro.doc_designacion\"\n                types=\"pdf\" mime-types=\".pdf\" maxsize=\"20MB\"\n                url=\"{{$ctrl.archivo.url}}\"\n                url-descarga=\"{{$ctrl.archivo.urlDescarga}}\"\n                ver=\"false\"\n                modo-vista=\"!$ctrl.modoEdicion\">\n        </archivo>\n      </div>\n    </div>\n  </ng-form>\n</div>\n\n<div class=\"modal-footer\">\n  <button type=\"button\" md-effect class=\"btn btn-primary\" ng-click=\"$ctrl.cerrar()\" ng-if=\"$ctrl.miembro.tipo_equipo == 'TE_UPRE' || $ctrl.modoVista\">\n    <i class=\"fa fa-check\"></i> Aceptar\n  </button>\n  <button type=\"button\" md-effect class=\"btn btn-secondary\" ng-click=\"$ctrl.cerrar()\" ng-if=\"$ctrl.miembro.tipo_equipo != 'TE_UPRE' && !$ctrl.modoVista\">\n    <i class=\"fa fa-close\"></i> Cancelar\n  </button>\n  <button type=\"submit\" md-effect class=\"btn btn-primary\" ng-click=\"$ctrl.registrar()\" validar-formulario=\"formMiembro\"\n  ng-if=\"$ctrl.modoEdicion && $ctrl.miembro.tipo_equipo != 'TE_UPRE' && !$ctrl.modoVista\">\n    <i class=\"fa fa-check\"></i> {{$ctrl.miembro.id_equipo_tecnico ? 'Actualizar' : 'Registrar'}}\n  </button>\n  <button type=\"submit\" md-effect class=\"btn btn-primary\" ng-click=\"$ctrl.modoEdicion=true\"\n  ng-if=\"$ctrl.miembro.id_equipo_tecnico && !$ctrl.modoEdicion && $ctrl.miembro.tipo_equipo != 'TE_UPRE' && !$ctrl.modoVista\">\n    <i class=\"fa fa-edit\"></i> Editar\n  </button>\n</div>\n"

/***/ }),
/* 664 */
/***/ (function(module, exports) {

	module.exports = "<uib-tabset active=\"active\">\n  <uib-tab heading=\"Cumplimiento de contrato\">\n    <div class=\"alert alert-info\" ng-if=\"!$ctrl.modoVista\">\n      <i class=\"fa fa-info-circle\"></i>\n      <span>El registro de las boletas por concepto de garantías de Cumplimiento de Contrato es obligatorio.\n        El monto es calculado de acuerdo al 7% del monto del contrato (<strong>{{$ctrl.proyecto.monto_total | formatDecimal}}</strong>)</span>\n    </div>\n    <boleta-garantia proyecto=\"$ctrl.proyecto\"\n              datos=\"$ctrl.cContrato\"\n              porcentaje=\"7\"\n              monto=\"$ctrl.monto_ccontrato\"\n              monto_deuda=\"$ctrl.proyecto.ccontrato_deuda\"\n              boletas=\"$ctrl.boletasCcontrato\"\n              tipo=\"TB_CUMPLIMIENTO_CONTRATO\"\n              modo-vista=\"!$ctrl.Proyecto.esEditable('boletas')\">\n    </boleta-garantia>\n  </uib-tab>\n  <uib-tab heading=\"Anticipo\">\n    <div class=\"alert alert-info\" ng-if=\"!$ctrl.modoVista\">\n      <i class=\"fa fa-info-circle\"></i>\n      <span>Si la empresa solicita anticipo registrar el porcentaje respecto al monto del contrato (<strong>{{$ctrl.proyecto.monto_total | formatDecimal}}</strong>),\n        en caso contrario registrar el porcentaje en cero \"0\".</span>\n    </div>\n    <boleta-garantia proyecto=\"$ctrl.proyecto\"\n              datos=\"$ctrl.anticipo\"\n              porcentaje=\"$ctrl.proyecto.porcentaje_anticipo\"\n              monto=\"$ctrl.proyecto.anticipo\"\n              monto_deuda=\"$ctrl.proyecto.anticipo_deuda\"\n              boletas=\"$ctrl.boletasAnticipo\"\n              tipo=\"TB_CORRECTA_INVERSION\"\n              modo-vista=\"!$ctrl.Proyecto.esEditable('boletas')\">\n    </boleta-garantia>\n  </uib-tab>\n</uib-tabset>\n"

/***/ }),
/* 665 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"items\">\n  <!-- <button md-effect type=\"button\" class=\"btn btn-warning\" ng-click=\"$ctrl.cargarEspecificacionesTecnicas()\"\n        ng-if=\"!$ctrl.modoVista\">\n  <i class=\"fa fa-upload\"></i> Cargar Especificaciones Técnicas\n</button> -->\n  <button\n    md-effect\n    type=\"button\"\n    class=\"btn btn-info\"\n    ng-click=\"$ctrl.verEspecificacionesTecnicas()\"\n    ng-if=\"$ctrl.proyecto.doc_especificaciones_tecnicas\"\n  >\n    <i class=\"fa fa-file-text-o\"></i> Ver Especificaciones Técnicas\n  </button>\n  <hr />\n  <!-- <button md-effect type=\"button\" class=\"btn btn-warning\" ng-click=\"$ctrl.cargarPlanosProyecto()\"\n        ng-if=\"!$ctrl.modoVista\">\n  <i class=\"fa fa-upload\"></i> Cargar Planos del Proyecto\n</button> -->\n  <button\n    md-effect\n    type=\"button\"\n    class=\"btn btn-info\"\n    ng-click=\"$ctrl.verPlanosProyecto()\"\n    ng-if=\"$ctrl.proyecto.doc_planos_proyecto\"\n  >\n    <i class=\"fa fa-file-text-o\"></i> Ver Planos del Proyecto\n  </button>\n  <hr />\n  <!-- <div class=\"text-right\">\n    <button\n      md-effect\n      type=\"button\"\n      class=\"btn\"\n      ng-class=\"{'btn-success':$ctrl.proyecto.cr_precio}\"\n      uib-tooltip=\"\"\n      tooltip-placement=\"bottom\"\n      ng-if=\"$ctrl.esTecnico\"\n      ng-click=\"$ctrl.agregarQuitarCampo()\"\n    >\n      <i class=\"fa fa-table\"></i> Agregar campo para regularizaciones\n    </button>\n  </div> -->\n\n  <!-- <button md-effect type=\"button\" class=\"btn btn-success\" ng-click=\"$ctrl.adicionarModulo()\"\n        ng-if=\"!$ctrl.modoVista\">\n  <i class=\"fa fa-plus\"></i> Adicionar Módulo\n</button>\n<button md-effect type=\"button\" class=\"btn btn-warning\" ng-click=\"$ctrl.importarItems()\"\n        ng-if=\"!$ctrl.modoVista\">\n  <i class=\"fa fa-upload\"></i> Importar Items\n</button> -->\n  <br /><br />\n  <ng-form\n    name=\"form_{{modulo.id_modulo}}\"\n    ng-repeat=\"(keyModulo,modulo) in $ctrl.modulos | orderBy : 'id_modulo'\"\n  >\n    <span md-effect class=\"text-primary\" ng-click=\"modulo.show=!modulo.show\"\n      ><i class=\"fa fa-plus\" ng-if=\"!modulo.show\"></i\n      ><i class=\"fa fa-minus\" ng-if=\"modulo.show\"></i> {{modulo.nombre}}</span\n    >\n    <!-- <div class=\"float-right\" ng-if=\"!$ctrl.modoVista\">\n    <button class=\"btn btn-link text-success ml-1  pl-1 pr-1\" ng-click=\"$ctrl.guardarDatosModulo(modulo)\"\n    uib-tooltip=\"Guardar datos módulo\" validar-formulario nombre-formulario=\"form_{{modulo.id_modulo}}\">\n      <i class=\"fa fa-save\"></i>\n    </button>\n    <button class=\"btn btn-link text-success ml-1  pl-1 pr-1\" ng-click=\"$ctrl.adicionarItem(modulo);modulo.show=true\" uib-tooltip=\"Nuevo Item\">\n      <i class=\"fa fa-plus-square-o\"></i>\n    </button>\n    <button class=\"btn btn-link text-primary ml-1 pl-1 pr-1\" ng-click=\"$ctrl.editarModulo(modulo)\" uib-tooltip=\"Editar\">\n      <i class=\"fa fa-edit\"></i>\n    </button>\n    <button class=\"btn btn-link text-danger ml-1 pl-1 pr-1\" ng-click=\"$ctrl.eliminarModulo(modulo)\" uib-tooltip=\"Eliminar\">\n      <i class=\"fa fa-trash-o\"></i>\n    </button>\n  </div> -->\n    <hr />\n\n    <div\n      class=\"items\"\n      ng-repeat=\"(keyItem,item) in modulo.items | orderBy : 'nro_item' \"\n      ng-if=\"modulo.show\"\n    >\n      <div class=\"row\">\n        <div class=\"col-md-1 nro-item text-info\">\n          <strong class=\"mt-3\"> {{item.nro_item}} </strong>\n        </div>\n        <div class=\"md-input-group col-md-4\">\n          <c-input\n            name=\"item_nombre_{{keyItem}}\"\n            label=\"Nombre\"\n            ng-model=\"item.nombre\"\n            maxlength=\"150\"\n            ng-required=\"true\"\n            ng-disabled=\"!item.edicion\"\n          >\n          </c-input>\n        </div>\n\n        <div class=\"md-input-group col-md-2\">\n          <c-select\n            name=\"item_unidad_{{keyItem}}\"\n            label=\"Unidad\"\n            ng-model=\"item.unidad_medida\"\n            options=\"$ctrl.unidades\"\n            key-value=\"codigo\"\n            ng-required=\"true\"\n            ng-disabled=\"!item.edicion\"\n          >\n          </c-select>\n        </div>\n\n        <div class=\"md-input-group col-md-3\">\n          <c-input-numeric\n            name=\"item_cantidad_{{keyItem}}\"\n            label=\"Cantidad\"\n            ng-model=\"item.cantidad\"\n            ng-minvalue=\"0\"\n            ng-maxvalue=\"999999\"\n            ng-decimals=\"2\"\n            ng-required=\"true\"\n            ng-disabled=\"!item.edicion\"\n            ng-if=\"item.unidad_medida === 'UN_PIEZA' || item.unidad_medida === 'UN_GLOBAL'\"\n          >\n          </c-input-numeric>\n          <c-input-numeric\n            name=\"item_cantidad_{{keyItem}}\"\n            label=\"Cantidad\"\n            ng-model=\"item.cantidad\"\n            ng-minvalue=\"1\"\n            ng-maxvalue=\"999999\"\n            ng-decimals=\"0\"\n            ng-required=\"true\"\n            ng-disabled=\"!item.edicion\"\n            ng-if=\" item.unidad_medida === 'UN_PUNTO'\"\n          >\n          </c-input-numeric>\n          <c-input-numeric\n            name=\"item_cantidad_{{keyItem}}\"\n            label=\"Cantidad\"\n            ng-model=\"item.cantidad\"\n            ng-minvalue=\"0\"\n            ng-maxvalue=\"999999\"\n            ng-decimals=\"2\"\n            ng-required=\"true\"\n            ng-disabled=\"!item.edicion\"\n            ng-if=\"item.unidad_medida !== 'UN_GLOBAL' && item.unidad_medida !== 'UN_PIEZA' && item.unidad_medida !== 'UN_PUNTO'\"\n          >\n          </c-input-numeric>\n        </div>\n\n        <!-- <div class=\"float-right\">\n            <button class=\"btn btn-link text-success ml-1 pl-1 pr-1\"\n              ng-click=\"!item.id_item? $ctrl.guardarItem(item, keyItem, keyModulo, modulo) : $ctrl.actualizarItem(item, keyItem, modulo)\"\n              ng-if=\"item.edicion && (!$ctrl.modoVista || modulo.nombre=='REGULARIZACIONES')\" uib-tooltip=\"Guardar\">\n              <i class=\"fa fa-save\"></i>\n            </button>\n\n            <button class=\"btn btn-link text-primary ml-1 pl-1 pr-1\" ng-click=\"item.edicion = true\"\n              ng-if=\"!item.edicion && !$ctrl.modoVista\" uib-tooltip=\"Editar\">\n              <i class=\"fa fa-edit\"></i>\n            </button>\n\n            <button class=\"btn btn-link text-primary ml-1 pl-1 pr-1\" ng-click=\"$ctrl.verEspecificacionesItem(item)\"\n              ng-if=\"!item.edicion && item.especificaciones\" uib-tooltip=\"Ver especificaciones\">\n              <i class=\"fa fa-file-text-o\"></i>\n            </button>\n\n            <button class=\"btn btn-link text-info ml-1 pl-1 pr-1\" ng-click=\"$ctrl.cargarEspecificacionesItem(item)\"\n              ng-if=\"!item.edicion && !$ctrl.modoVista\" uib-tooltip=\"Cargar especificaciones\">\n              <i class=\"fa fa-upload\"></i>\n            </button>\n\n            <button class=\"btn btn-link text-danger ml-1 pl-1 pr-1\" ng-click=\"$ctrl.eliminarItem(item, keyItem, modulo)\"\n              ng-if=\"!$ctrl.modoVista\" uib-tooltip=\"Eliminar\">\n              <i class=\"fa fa-trash-o\"></i>\n            </button>\n          </div> -->\n      </div>\n    </div>\n  </ng-form>\n</div>\n"

/***/ }),
/* 666 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\"><i class=\"fa {{$ctrl.icon}}\"></i> {{$ctrl.title}}</h5>\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cerrar()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<div class=\"modal-body\" style=\"max-height:400px;overflow:auto;\">\n  <div class=\"row\">\n    <div class=\"col-md-12\">\n      <ul ng-repeat=\"mensaje in $ctrl.mensajes\">\n        <li>{{mensaje.mensaje}}\n          <ul ng-repeat=\"item in mensaje.items\">\n            <li>Item: <strong>{{item.item}}</strong> debe verificar el valor <strong>{{item.texto}}</strong></li>\n          </ul>\n        </li>\n      </ul>\n    </div>\n  </div>\n</div>\n<div class=\"modal-footer\">\n  <button type=\"button\" md-effect class=\"btn btn-primary\" ng-click=\"$ctrl.cerrar()\">\n    <i class=\"fa fa-check\"></i> Aceptar\n  </button>\n</div>\n"

/***/ }),
/* 667 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\"><i class=\"fa {{$ctrl.icon}}\"></i> {{$ctrl.title}}</h5>\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cerrar()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<div class=\"modal-body\">\n  <ng-form name=\"formItem\">\n    <div class=\"row\">\n\n      <div class=\"md-input-group col-md-12\">\n        <c-input name=\"modulo_nombre\" label=\"Nombre\" ng-model=\"$ctrl.modulo.nombre\"\n          ng-directives=\"uppercase\"\n          ng-required=\"true\" maxlength=\"150\">\n        </c-input>\n      </div>\n\n    </div>\n  </ng-form>\n</div>\n<div class=\"modal-footer\">\n  <button type=\"button\" md-effect class=\"btn btn-secondary\" ng-click=\"$ctrl.cerrar()\">\n    <i class=\"fa fa-close\"></i> Cancelar\n  </button>\n  <button type=\"button\" md-effect class=\"btn btn-primary\" validar-formulario=\"formItem\"\n    ng-click=\"!$ctrl.modulo.id_modulo? $ctrl.guardar() : $ctrl.actualizar()\">\n    <i class=\"fa\" ng-class=\"!$ctrl.modulo.id_modulo? 'fa-check' : 'fa-save'\"></i>\n    {{!$ctrl.modulo.id_modulo? 'Adicionar' : 'Guardar'}}\n  </button>\n</div>\n"

/***/ }),
/* 668 */
/***/ (function(module, exports) {

	module.exports = "<section>\n  <h6 class=\"title-section m-top\">\n    <i class=\"fa fa-hand-o-right\"></i> Orden de Proceder\n  </h6>\n\n  <div class=\"alert alert-info\" ng-if=\"$ctrl.Proyecto.esEditable('orden_proceder')\">\n    <i class=\"fa fa-info-circle\"></i><span> Al introducir la fecha de orden de proceder se inicia el tiempo de ejecución del proyecto.</span>\n  </div>\n\n  <div class=\"row\">\n    <div class=\"md-input-group col-md-6\">\n      <c-date name=\"orden_proceder\" label=\"Fecha de orden de proceder\"\n              ng-model=\"$ctrl.proyecto.orden_proceder\"\n              ng-required=\"!$ctrl.modoVista && $ctrl.Proyecto.esRequerido('orden_proceder')\"\n              ng-disabled=\"$ctrl.modoVista || !$ctrl.Proyecto.esEditable('orden_proceder')\"\n              min-date=\"$ctrl.validacion.fecha_minima\"\n              mensaje-min-date=\"{{$ctrl.validacion.mensaje_fecminima}}\">\n      </c-date>\n    </div>\n    <div class=\"col-lg-6 col-md-12\">\n      <archivo name=\"doc_resmin_cife\" label=\"Acta Orden de Proceder\" ng-model=\"$ctrl.proyecto.doc_orden_proceder\"\n              types=\"pdf\" mime-types=\".pdf\" maxsize=\"5MB\"\n              url=\"{{$ctrl.archivos.urlDocOrden}}\"\n              url-descarga=\"{{$ctrl.archivos.urlDocOrdenDescarga}}\"\n              cambiar=\"$ctrl.Proyecto.esEditable('doc_orden_proceder')\"\n              ng-required=\"$ctrl.Proyecto.esEditable('doc_orden_proceder') && $ctrl.Proyecto.esRequerido('doc_orden_proceder')\"\n              modo-vista=\"!$ctrl.Proyecto.esEditable('doc_orden_proceder')\">\n      </archivo>\n    </div>\n\n\n  </div>\n</section>\n"

/***/ }),
/* 669 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <h2 class=\"page-title\">\n    <i class=\"fa fa-bars\"></i> Proyecto <small><strong>{{$ctrl.proyecto.nombre}}</strong></small>\n  </h2>\n  <div class=\"card\">\n    <div class=\"card-body\">\n      <ng-form name=\"formProyecto\">\n        <uib-tabset active=\"active\">\n          <uib-tab index=\"0\" heading=\"Datos Generales\">\n            <datos-generales proyecto=\"$ctrl.proyecto\" ng-if=\"$ctrl.Proyecto.esAreaPermitida('DATOS_GENERALES')\"></datos-generales>\n            <proyecto-adjudicado proyecto=\"$ctrl.proyecto\" ng-if=\"$ctrl.Proyecto.esAreaPermitida('PROYECTO_ADJUDICADO')\"></proyecto-adjudicado>\n            <codigo-contrato proyecto=\"$ctrl.proyecto\" modo-vista=\"true\" ng-if=\"$ctrl.Proyecto.esAreaPermitida('PROYECTO_ADJUDICADO')\"></codigo-contrato>\n            <convenio proyecto=\"$ctrl.proyecto\" ng-if=\"$ctrl.Proyecto.esAreaPermitida('CONVENIO')\"></convenio>\n            <asignacion-responsable proyecto=\"$ctrl.proyecto\" ng-if=\"$ctrl.Proyecto.esAreaPermitida('ASIGNACION_RESPONSABLE')\"></asignacion-responsable>\n            <desembolso proyecto=\"$ctrl.proyecto\" ng-if=\"$ctrl.Proyecto.esAreaPermitida('DESEMBOLSO')\"></desembolso>\n            <orden-proceder proyecto=\"$ctrl.proyecto\" ng-if=\"$ctrl.Proyecto.esAreaPermitida('ORDEN_PROCEDER')\"></orden-proceder>\n          </uib-tab>\n\n          <uib-tab index=\"1\" heading=\"MAE Benerifiarios/as\" ng-if=\"$ctrl.Proyecto.esAreaPermitida('AUTORIDAD_BENEFICIARIA')\">\n            <autoridad-beneficiaria proyecto=\"$ctrl.proyecto\" modo-vista=\"!$ctrl.Proyecto.esEditable('autoridad_beneficiaria')\"></autoridad-beneficiaria>\n          </uib-tab>\n\n          <uib-tab index=\"2\" heading=\"Módulos/Items\" ng-if=\"$ctrl.Proyecto.esAreaPermitida('MODULOS_ITEMS')\">\n            <items proyecto=\"$ctrl.proyecto\" modulos=\"$ctrl.modulos\" modo-vista=\"!$ctrl.Proyecto.esEditable('modulos')\"></items>\n          </uib-tab>\n\n          <uib-tab index=\"3\" heading=\"Especificación Técnica de Contratación\" ng-if=\"$ctrl.Proyecto.esAreaPermitida('DOCUMENTO_BASE_CONTRATACION')\">\n            <dbc proyecto=\"$ctrl.proyecto\"></dbc>\n          </uib-tab>\n\n          <uib-tab index=\"4\" heading=\"Formularios\" ng-if=\"$ctrl.Proyecto.esAreaPermitida('FORMULARIOS')\">\n            <formularios-generados proyecto=\"$ctrl.proyecto\"></formularios-generados>\n          </uib-tab>\n\n          <!-- <uib-tab index=\"5\" heading=\"Contrato\" ng-if=\"$ctrl.Proyecto.esAreaPermitida('GARANTIAS')\">\n            <contrato proyecto=\"$ctrl.proyecto\" modo-vista=\"!$ctrl.Proyecto.esEditable('boletas')\"></contrato>\n          </uib-tab> -->\n\n          <uib-tab index=\"6\" heading=\"Garantías\" ng-if=\"$ctrl.Proyecto.esAreaPermitida('GARANTIAS')\">\n            <garantia proyecto=\"$ctrl.proyecto\" modo-vista=\"!$ctrl.Proyecto.esEditable('boletas')\"></garantia>\n          </uib-tab>\n\n          <uib-tab index=\"7\" heading=\"Equipo Técnico\" ng-if=\"$ctrl.Proyecto.esAreaPermitida('EQUIPO_TECNICO')\">\n            <equipo-tecnico proyecto=\"$ctrl.proyecto\" modo-vista=\"!$ctrl.Proyecto.esEditable('equipo_tecnico')\"></equipo-tecnico>\n          </uib-tab>\n\n        </uib-tabset>\n      </ng-form>\n\n      <section ng-if=\"$ctrl.proyecto.observacion.mensaje\">\n        <h6 class=\"title-section error m-top\">\n          <i class=\"fa fa-exclamation-triangle\"></i> Observación\n        </h6>\n        Mensaje: <strong>{{ $ctrl.proyecto.observacion.mensaje }}</strong><br>\n        Observado por: <strong>{{ $ctrl.proyecto.observacion.usuario.persona | nombreUnido }}</strong>\n      </section>\n    </div>\n    <div class=\"card-footer text-right\">\n      <ejecutar-transicion elemento=\"$ctrl.proyecto\"\n                           servicio=\"$ctrl.Proyecto\"\n                           form=\"formProyecto\"\n                           opcion-cancelar=\"true\"\n                           atributo-estado=\"estado_proyecto\"\n                           url=\"$ctrl.url\"\n                           confirmar=\"true\"\n                           metodo-previo=\"$ctrl.verificarSegunEstado()\"\n                           validacion-paralela=$ctrl.verificarEnParalelo()>\n      </ejecutar-transicion>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Satellizer 0.15.5
	 * (c) 2016 Sahat Yalkabov 
	 * License: MIT 
	 */
	
	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.satellizer = factory());
	}(this, function () { 'use strict';
	
	    var Config = (function () {
	        function Config() {
	            this.baseUrl = '/';
	            this.loginUrl = '/auth/login';
	            this.signupUrl = '/auth/signup';
	            this.unlinkUrl = '/auth/unlink/';
	            this.tokenName = 'token';
	            this.tokenPrefix = 'satellizer';
	            this.tokenHeader = 'Authorization';
	            this.tokenType = 'Bearer';
	            this.storageType = 'localStorage';
	            this.tokenRoot = null;
	            this.withCredentials = false;
	            this.providers = {
	                facebook: {
	                    name: 'facebook',
	                    url: '/auth/facebook',
	                    authorizationEndpoint: 'https://www.facebook.com/v2.5/dialog/oauth',
	                    redirectUri: window.location.origin + '/',
	                    requiredUrlParams: ['display', 'scope'],
	                    scope: ['email'],
	                    scopeDelimiter: ',',
	                    display: 'popup',
	                    oauthType: '2.0',
	                    popupOptions: { width: 580, height: 400 }
	                },
	                google: {
	                    name: 'google',
	                    url: '/auth/google',
	                    authorizationEndpoint: 'https://accounts.google.com/o/oauth2/auth',
	                    redirectUri: window.location.origin,
	                    requiredUrlParams: ['scope'],
	                    optionalUrlParams: ['display', 'state'],
	                    scope: ['profile', 'email'],
	                    scopePrefix: 'openid',
	                    scopeDelimiter: ' ',
	                    display: 'popup',
	                    oauthType: '2.0',
	                    popupOptions: { width: 452, height: 633 },
	                    state: function () { return encodeURIComponent(Math.random().toString(36).substr(2)); }
	                },
	                github: {
	                    name: 'github',
	                    url: '/auth/github',
	                    authorizationEndpoint: 'https://github.com/login/oauth/authorize',
	                    redirectUri: window.location.origin,
	                    optionalUrlParams: ['scope'],
	                    scope: ['user:email'],
	                    scopeDelimiter: ' ',
	                    oauthType: '2.0',
	                    popupOptions: { width: 1020, height: 618 }
	                },
	                instagram: {
	                    name: 'instagram',
	                    url: '/auth/instagram',
	                    authorizationEndpoint: 'https://api.instagram.com/oauth/authorize',
	                    redirectUri: window.location.origin,
	                    requiredUrlParams: ['scope'],
	                    scope: ['basic'],
	                    scopeDelimiter: '+',
	                    oauthType: '2.0'
	                },
	                linkedin: {
	                    name: 'linkedin',
	                    url: '/auth/linkedin',
	                    authorizationEndpoint: 'https://www.linkedin.com/uas/oauth2/authorization',
	                    redirectUri: window.location.origin,
	                    requiredUrlParams: ['state'],
	                    scope: ['r_emailaddress'],
	                    scopeDelimiter: ' ',
	                    state: 'STATE',
	                    oauthType: '2.0',
	                    popupOptions: { width: 527, height: 582 }
	                },
	                twitter: {
	                    name: 'twitter',
	                    url: '/auth/twitter',
	                    authorizationEndpoint: 'https://api.twitter.com/oauth/authenticate',
	                    redirectUri: window.location.origin,
	                    oauthType: '1.0',
	                    popupOptions: { width: 495, height: 645 }
	                },
	                twitch: {
	                    name: 'twitch',
	                    url: '/auth/twitch',
	                    authorizationEndpoint: 'https://api.twitch.tv/kraken/oauth2/authorize',
	                    redirectUri: window.location.origin,
	                    requiredUrlParams: ['scope'],
	                    scope: ['user_read'],
	                    scopeDelimiter: ' ',
	                    display: 'popup',
	                    oauthType: '2.0',
	                    popupOptions: { width: 500, height: 560 }
	                },
	                live: {
	                    name: 'live',
	                    url: '/auth/live',
	                    authorizationEndpoint: 'https://login.live.com/oauth20_authorize.srf',
	                    redirectUri: window.location.origin,
	                    requiredUrlParams: ['display', 'scope'],
	                    scope: ['wl.emails'],
	                    scopeDelimiter: ' ',
	                    display: 'popup',
	                    oauthType: '2.0',
	                    popupOptions: { width: 500, height: 560 }
	                },
	                yahoo: {
	                    name: 'yahoo',
	                    url: '/auth/yahoo',
	                    authorizationEndpoint: 'https://api.login.yahoo.com/oauth2/request_auth',
	                    redirectUri: window.location.origin,
	                    scope: [],
	                    scopeDelimiter: ',',
	                    oauthType: '2.0',
	                    popupOptions: { width: 559, height: 519 }
	                },
	                bitbucket: {
	                    name: 'bitbucket',
	                    url: '/auth/bitbucket',
	                    authorizationEndpoint: 'https://bitbucket.org/site/oauth2/authorize',
	                    redirectUri: window.location.origin + '/',
	                    requiredUrlParams: ['scope'],
	                    scope: ['email'],
	                    scopeDelimiter: ' ',
	                    oauthType: '2.0',
	                    popupOptions: { width: 1028, height: 529 }
	                },
	                spotify: {
	                    name: 'spotify',
	                    url: '/auth/spotify',
	                    authorizationEndpoint: 'https://accounts.spotify.com/authorize',
	                    redirectUri: window.location.origin,
	                    optionalUrlParams: ['state'],
	                    requiredUrlParams: ['scope'],
	                    scope: ['user-read-email'],
	                    scopePrefix: '',
	                    scopeDelimiter: ',',
	                    oauthType: '2.0',
	                    popupOptions: { width: 500, height: 530 },
	                    state: function () { return encodeURIComponent(Math.random().toString(36).substr(2)); }
	                }
	            };
	            this.httpInterceptor = function () { return true; };
	        }
	        Object.defineProperty(Config, "getConstant", {
	            get: function () {
	                return new Config();
	            },
	            enumerable: true,
	            configurable: true
	        });
	        return Config;
	    }());
	    ;
	
	    var AuthProvider = (function () {
	        function AuthProvider(SatellizerConfig) {
	            this.SatellizerConfig = SatellizerConfig;
	        }
	        Object.defineProperty(AuthProvider.prototype, "baseUrl", {
	            get: function () { return this.SatellizerConfig.baseUrl; },
	            set: function (value) { this.SatellizerConfig.baseUrl = value; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AuthProvider.prototype, "loginUrl", {
	            get: function () { return this.SatellizerConfig.loginUrl; },
	            set: function (value) { this.SatellizerConfig.loginUrl = value; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AuthProvider.prototype, "signupUrl", {
	            get: function () { return this.SatellizerConfig.signupUrl; },
	            set: function (value) { this.SatellizerConfig.signupUrl = value; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AuthProvider.prototype, "unlinkUrl", {
	            get: function () { return this.SatellizerConfig.unlinkUrl; },
	            set: function (value) { this.SatellizerConfig.unlinkUrl = value; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AuthProvider.prototype, "tokenRoot", {
	            get: function () { return this.SatellizerConfig.tokenRoot; },
	            set: function (value) { this.SatellizerConfig.tokenRoot = value; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AuthProvider.prototype, "tokenName", {
	            get: function () { return this.SatellizerConfig.tokenName; },
	            set: function (value) { this.SatellizerConfig.tokenName = value; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AuthProvider.prototype, "tokenPrefix", {
	            get: function () { return this.SatellizerConfig.tokenPrefix; },
	            set: function (value) { this.SatellizerConfig.tokenPrefix = value; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AuthProvider.prototype, "tokenHeader", {
	            get: function () { return this.SatellizerConfig.tokenHeader; },
	            set: function (value) { this.SatellizerConfig.tokenHeader = value; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AuthProvider.prototype, "tokenType", {
	            get: function () { return this.SatellizerConfig.tokenType; },
	            set: function (value) { this.SatellizerConfig.tokenType = value; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AuthProvider.prototype, "withCredentials", {
	            get: function () { return this.SatellizerConfig.withCredentials; },
	            set: function (value) { this.SatellizerConfig.withCredentials = value; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AuthProvider.prototype, "storageType", {
	            get: function () { return this.SatellizerConfig.storageType; },
	            set: function (value) { this.SatellizerConfig.storageType = value; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AuthProvider.prototype, "httpInterceptor", {
	            get: function () { return this.SatellizerConfig.httpInterceptor; },
	            set: function (value) {
	                if (typeof value === 'function') {
	                    this.SatellizerConfig.httpInterceptor = value;
	                }
	                else {
	                    this.SatellizerConfig.httpInterceptor = function () { return value; };
	                }
	            },
	            enumerable: true,
	            configurable: true
	        });
	        AuthProvider.prototype.facebook = function (options) {
	            angular.extend(this.SatellizerConfig.providers.facebook, options);
	        };
	        AuthProvider.prototype.google = function (options) {
	            angular.extend(this.SatellizerConfig.providers.google, options);
	        };
	        AuthProvider.prototype.github = function (options) {
	            angular.extend(this.SatellizerConfig.providers.github, options);
	        };
	        AuthProvider.prototype.instagram = function (options) {
	            angular.extend(this.SatellizerConfig.providers.instagram, options);
	        };
	        AuthProvider.prototype.linkedin = function (options) {
	            angular.extend(this.SatellizerConfig.providers.linkedin, options);
	        };
	        AuthProvider.prototype.twitter = function (options) {
	            angular.extend(this.SatellizerConfig.providers.twitter, options);
	        };
	        AuthProvider.prototype.twitch = function (options) {
	            angular.extend(this.SatellizerConfig.providers.twitch, options);
	        };
	        AuthProvider.prototype.live = function (options) {
	            angular.extend(this.SatellizerConfig.providers.live, options);
	        };
	        AuthProvider.prototype.yahoo = function (options) {
	            angular.extend(this.SatellizerConfig.providers.yahoo, options);
	        };
	        AuthProvider.prototype.bitbucket = function (options) {
	            angular.extend(this.SatellizerConfig.providers.bitbucket, options);
	        };
	        AuthProvider.prototype.spotify = function (options) {
	            angular.extend(this.SatellizerConfig.providers.spotify, options);
	        };
	        AuthProvider.prototype.oauth1 = function (options) {
	            this.SatellizerConfig.providers[options.name] = angular.extend(options, {
	                oauthType: '1.0'
	            });
	        };
	        AuthProvider.prototype.oauth2 = function (options) {
	            this.SatellizerConfig.providers[options.name] = angular.extend(options, {
	                oauthType: '2.0'
	            });
	        };
	        AuthProvider.prototype.$get = function (SatellizerShared, SatellizerLocal, SatellizerOAuth) {
	            return {
	                login: function (user, options) { return SatellizerLocal.login(user, options); },
	                signup: function (user, options) { return SatellizerLocal.signup(user, options); },
	                logout: function () { return SatellizerShared.logout(); },
	                authenticate: function (name, data) { return SatellizerOAuth.authenticate(name, data); },
	                link: function (name, data) { return SatellizerOAuth.authenticate(name, data); },
	                unlink: function (name, options) { return SatellizerOAuth.unlink(name, options); },
	                isAuthenticated: function () { return SatellizerShared.isAuthenticated(); },
	                getPayload: function () { return SatellizerShared.getPayload(); },
	                getToken: function () { return SatellizerShared.getToken(); },
	                setToken: function (token) { return SatellizerShared.setToken({ access_token: token }); },
	                removeToken: function () { return SatellizerShared.removeToken(); },
	                setStorageType: function (type) { return SatellizerShared.setStorageType(type); }
	            };
	        };
	        AuthProvider.$inject = ['SatellizerConfig'];
	        return AuthProvider;
	    }());
	    AuthProvider.prototype.$get.$inject = ['SatellizerShared', 'SatellizerLocal', 'SatellizerOAuth'];
	
	    function joinUrl(baseUrl, url) {
	        if (/^(?:[a-z]+:)?\/\//i.test(url)) {
	            return url;
	        }
	        var joined = [baseUrl, url].join('/');
	        var normalize = function (str) {
	            return str
	                .replace(/[\/]+/g, '/')
	                .replace(/\/\?/g, '?')
	                .replace(/\/\#/g, '#')
	                .replace(/\:\//g, '://');
	        };
	        return normalize(joined);
	    }
	    function getFullUrlPath(location) {
	        var isHttps = location.protocol === 'https:';
	        return location.protocol + '//' + location.hostname +
	            ':' + (location.port || (isHttps ? '443' : '80')) +
	            (/^\//.test(location.pathname) ? location.pathname : '/' + location.pathname);
	    }
	    function parseQueryString(str) {
	        var obj = {};
	        var key;
	        var value;
	        angular.forEach((str || '').split('&'), function (keyValue) {
	            if (keyValue) {
	                value = keyValue.split('=');
	                key = decodeURIComponent(value[0]);
	                obj[key] = angular.isDefined(value[1]) ? decodeURIComponent(value[1]) : true;
	            }
	        });
	        return obj;
	    }
	    function decodeBase64(str) {
	        var buffer;
	        if (typeof module !== 'undefined' && module.exports) {
	            try {
	                buffer = __webpack_require__(10).Buffer;
	            }
	            catch (err) {
	            }
	        }
	        var fromCharCode = String.fromCharCode;
	        var re_btou = new RegExp([
	            '[\xC0-\xDF][\x80-\xBF]',
	            '[\xE0-\xEF][\x80-\xBF]{2}',
	            '[\xF0-\xF7][\x80-\xBF]{3}'
	        ].join('|'), 'g');
	        var cb_btou = function (cccc) {
	            switch (cccc.length) {
	                case 4:
	                    var cp = ((0x07 & cccc.charCodeAt(0)) << 18)
	                        | ((0x3f & cccc.charCodeAt(1)) << 12)
	                        | ((0x3f & cccc.charCodeAt(2)) << 6)
	                        | (0x3f & cccc.charCodeAt(3));
	                    var offset = cp - 0x10000;
	                    return (fromCharCode((offset >>> 10) + 0xD800)
	                        + fromCharCode((offset & 0x3FF) + 0xDC00));
	                case 3:
	                    return fromCharCode(((0x0f & cccc.charCodeAt(0)) << 12)
	                        | ((0x3f & cccc.charCodeAt(1)) << 6)
	                        | (0x3f & cccc.charCodeAt(2)));
	                default:
	                    return fromCharCode(((0x1f & cccc.charCodeAt(0)) << 6)
	                        | (0x3f & cccc.charCodeAt(1)));
	            }
	        };
	        var btou = function (b) {
	            return b.replace(re_btou, cb_btou);
	        };
	        var _decode = buffer ? function (a) {
	            return (a.constructor === buffer.constructor
	                ? a : new buffer(a, 'base64')).toString();
	        }
	            : function (a) {
	                return btou(atob(a));
	            };
	        return _decode(String(str).replace(/[-_]/g, function (m0) {
	            return m0 === '-' ? '+' : '/';
	        })
	            .replace(/[^A-Za-z0-9\+\/]/g, ''));
	    }
	
	    var Shared = (function () {
	        function Shared($q, $window, SatellizerConfig, SatellizerStorage) {
	            this.$q = $q;
	            this.$window = $window;
	            this.SatellizerConfig = SatellizerConfig;
	            this.SatellizerStorage = SatellizerStorage;
	            var _a = this.SatellizerConfig, tokenName = _a.tokenName, tokenPrefix = _a.tokenPrefix;
	            this.prefixedTokenName = tokenPrefix ? [tokenPrefix, tokenName].join('_') : tokenName;
	        }
	        Shared.prototype.getToken = function () {
	            return this.SatellizerStorage.get(this.prefixedTokenName);
	        };
	        Shared.prototype.getPayload = function () {
	            var token = this.SatellizerStorage.get(this.prefixedTokenName);
	            if (token && token.split('.').length === 3) {
	                try {
	                    var base64Url = token.split('.')[1];
	                    var base64 = base64Url.replace('-', '+').replace('_', '/');
	                    return JSON.parse(decodeBase64(base64));
	                }
	                catch (e) {
	                }
	            }
	        };
	        Shared.prototype.setToken = function (response) {
	            var tokenRoot = this.SatellizerConfig.tokenRoot;
	            var tokenName = this.SatellizerConfig.tokenName;
	            var accessToken = response && response.access_token;
	            var token;
	            if (accessToken) {
	                if (angular.isObject(accessToken) && angular.isObject(accessToken.data)) {
	                    response = accessToken;
	                }
	                else if (angular.isString(accessToken)) {
	                    token = accessToken;
	                }
	            }
	            if (!token && response) {
	                var tokenRootData = tokenRoot && tokenRoot.split('.').reduce(function (o, x) { return o[x]; }, response.data);
	                token = tokenRootData ? tokenRootData[tokenName] : response.data && response.data[tokenName];
	            }
	            if (token) {
	                this.SatellizerStorage.set(this.prefixedTokenName, token);
	            }
	        };
	        Shared.prototype.removeToken = function () {
	            this.SatellizerStorage.remove(this.prefixedTokenName);
	        };
	        Shared.prototype.isAuthenticated = function () {
	            var token = this.SatellizerStorage.get(this.prefixedTokenName);
	            if (token) {
	                if (token.split('.').length === 3) {
	                    try {
	                        var base64Url = token.split('.')[1];
	                        var base64 = base64Url.replace('-', '+').replace('_', '/');
	                        var exp = JSON.parse(this.$window.atob(base64)).exp;
	                        if (typeof exp === 'number') {
	                            return Math.round(new Date().getTime() / 1000) < exp;
	                        }
	                    }
	                    catch (e) {
	                        return true; // Pass: Non-JWT token that looks like JWT
	                    }
	                }
	                return true; // Pass: All other tokens
	            }
	            return false; // Fail: No token at all
	        };
	        Shared.prototype.logout = function () {
	            this.SatellizerStorage.remove(this.prefixedTokenName);
	            return this.$q.when();
	        };
	        Shared.prototype.setStorageType = function (type) {
	            this.SatellizerConfig.storageType = type;
	        };
	        Shared.$inject = ['$q', '$window', 'SatellizerConfig', 'SatellizerStorage'];
	        return Shared;
	    }());
	
	    var Local = (function () {
	        function Local($http, SatellizerConfig, SatellizerShared) {
	            this.$http = $http;
	            this.SatellizerConfig = SatellizerConfig;
	            this.SatellizerShared = SatellizerShared;
	        }
	        Local.prototype.login = function (user, options) {
	            var _this = this;
	            if (options === void 0) { options = {}; }
	            options.url = options.url ? options.url : joinUrl(this.SatellizerConfig.baseUrl, this.SatellizerConfig.loginUrl);
	            options.data = user || options.data;
	            options.method = options.method || 'POST';
	            options.withCredentials = options.withCredentials || this.SatellizerConfig.withCredentials;
	            return this.$http(options).then(function (response) {
	                _this.SatellizerShared.setToken(response);
	                return response;
	            });
	        };
	        Local.prototype.signup = function (user, options) {
	            if (options === void 0) { options = {}; }
	            options.url = options.url ? options.url : joinUrl(this.SatellizerConfig.baseUrl, this.SatellizerConfig.signupUrl);
	            options.data = user || options.data;
	            options.method = options.method || 'POST';
	            options.withCredentials = options.withCredentials || this.SatellizerConfig.withCredentials;
	            return this.$http(options);
	        };
	        Local.$inject = ['$http', 'SatellizerConfig', 'SatellizerShared'];
	        return Local;
	    }());
	
	    var Popup = (function () {
	        function Popup($interval, $window, $q) {
	            this.$interval = $interval;
	            this.$window = $window;
	            this.$q = $q;
	            this.popup = null;
	            this.defaults = {
	                redirectUri: null
	            };
	        }
	        Popup.prototype.stringifyOptions = function (options) {
	            var parts = [];
	            angular.forEach(options, function (value, key) {
	                parts.push(key + '=' + value);
	            });
	            return parts.join(',');
	        };
	        Popup.prototype.open = function (url, name, popupOptions, redirectUri, dontPoll) {
	            var width = popupOptions.width || 500;
	            var height = popupOptions.height || 500;
	            var options = this.stringifyOptions({
	                width: width,
	                height: height,
	                top: this.$window.screenY + ((this.$window.outerHeight - height) / 2.5),
	                left: this.$window.screenX + ((this.$window.outerWidth - width) / 2)
	            });
	            var popupName = this.$window['cordova'] || this.$window.navigator.userAgent.indexOf('CriOS') > -1 ? '_blank' : name;
	            this.popup = this.$window.open(url, popupName, options);
	            if (this.popup && this.popup.focus) {
	                this.popup.focus();
	            }
	            if (dontPoll) {
	                return;
	            }
	            if (this.$window['cordova']) {
	                return this.eventListener(redirectUri);
	            }
	            else {
	                if (url === 'about:blank') {
	                    this.popup.location = url;
	                }
	                return this.polling(redirectUri);
	            }
	        };
	        Popup.prototype.polling = function (redirectUri) {
	            var _this = this;
	            return this.$q(function (resolve, reject) {
	                var redirectUriParser = document.createElement('a');
	                redirectUriParser.href = redirectUri;
	                var redirectUriPath = getFullUrlPath(redirectUriParser);
	                var polling = _this.$interval(function () {
	                    if (!_this.popup || _this.popup.closed || _this.popup.closed === undefined) {
	                        _this.$interval.cancel(polling);
	                        reject(new Error('The popup window was closed'));
	                    }
	                    try {
	                        var popupWindowPath = getFullUrlPath(_this.popup.location);
	                        if (popupWindowPath === redirectUriPath) {
	                            if (_this.popup.location.search || _this.popup.location.hash) {
	                                var query = parseQueryString(_this.popup.location.search.substring(1).replace(/\/$/, ''));
	                                var hash = parseQueryString(_this.popup.location.hash.substring(1).replace(/[\/$]/, ''));
	                                var params = angular.extend({}, query, hash);
	                                if (params.error) {
	                                    reject(new Error(params.error));
	                                }
	                                else {
	                                    resolve(params);
	                                }
	                            }
	                            else {
	                                reject(new Error('OAuth redirect has occurred but no query or hash parameters were found. ' +
	                                    'They were either not set during the redirect, or were removed—typically by a ' +
	                                    'routing library—before Satellizer could read it.'));
	                            }
	                            _this.$interval.cancel(polling);
	                            _this.popup.close();
	                        }
	                    }
	                    catch (error) {
	                    }
	                }, 500);
	            });
	        };
	        Popup.prototype.eventListener = function (redirectUri) {
	            var _this = this;
	            return this.$q(function (resolve, reject) {
	                _this.popup.addEventListener('loadstart', function (event) {
	                    if (event.url.indexOf(redirectUri) !== 0) {
	                        return;
	                    }
	                    var parser = document.createElement('a');
	                    parser.href = event.url;
	                    if (parser.search || parser.hash) {
	                        var query = parseQueryString(parser.search.substring(1).replace(/\/$/, ''));
	                        var hash = parseQueryString(parser.hash.substring(1).replace(/[\/$]/, ''));
	                        var params = angular.extend({}, query, hash);
	                        if (params.error) {
	                            reject(new Error(params.error));
	                        }
	                        else {
	                            resolve(params);
	                        }
	                        _this.popup.close();
	                    }
	                });
	                _this.popup.addEventListener('loaderror', function () {
	                    reject(new Error('Authorization failed'));
	                });
	                _this.popup.addEventListener('exit', function () {
	                    reject(new Error('The popup window was closed'));
	                });
	            });
	        };
	        Popup.$inject = ['$interval', '$window', '$q'];
	        return Popup;
	    }());
	
	    var OAuth1 = (function () {
	        function OAuth1($http, $window, SatellizerConfig, SatellizerPopup) {
	            this.$http = $http;
	            this.$window = $window;
	            this.SatellizerConfig = SatellizerConfig;
	            this.SatellizerPopup = SatellizerPopup;
	            this.defaults = {
	                name: null,
	                url: null,
	                authorizationEndpoint: null,
	                scope: null,
	                scopePrefix: null,
	                scopeDelimiter: null,
	                redirectUri: null,
	                requiredUrlParams: null,
	                defaultUrlParams: null,
	                oauthType: '1.0',
	                popupOptions: { width: null, height: null }
	            };
	        }
	        ;
	        OAuth1.prototype.init = function (options, userData) {
	            var _this = this;
	            angular.extend(this.defaults, options);
	            var name = options.name, popupOptions = options.popupOptions;
	            var redirectUri = this.defaults.redirectUri;
	            // Should open an empty popup and wait until request token is received
	            if (!this.$window['cordova']) {
	                this.SatellizerPopup.open('about:blank', name, popupOptions, redirectUri, true);
	            }
	            return this.getRequestToken().then(function (response) {
	                return _this.openPopup(options, response).then(function (popupResponse) {
	                    return _this.exchangeForToken(popupResponse, userData);
	                });
	            });
	        };
	        OAuth1.prototype.openPopup = function (options, response) {
	            var url = [options.authorizationEndpoint, this.buildQueryString(response.data)].join('?');
	            var redirectUri = this.defaults.redirectUri;
	            if (this.$window['cordova']) {
	                return this.SatellizerPopup.open(url, options.name, options.popupOptions, redirectUri);
	            }
	            else {
	                this.SatellizerPopup.popup.location = url;
	                return this.SatellizerPopup.polling(redirectUri);
	            }
	        };
	        OAuth1.prototype.getRequestToken = function () {
	            var url = this.SatellizerConfig.baseUrl ? joinUrl(this.SatellizerConfig.baseUrl, this.defaults.url) : this.defaults.url;
	            return this.$http.post(url, this.defaults);
	        };
	        OAuth1.prototype.exchangeForToken = function (oauthData, userData) {
	            var payload = angular.extend({}, userData, oauthData);
	            var exchangeForTokenUrl = this.SatellizerConfig.baseUrl ? joinUrl(this.SatellizerConfig.baseUrl, this.defaults.url) : this.defaults.url;
	            return this.$http.post(exchangeForTokenUrl, payload, { withCredentials: this.SatellizerConfig.withCredentials });
	        };
	        OAuth1.prototype.buildQueryString = function (obj) {
	            var str = [];
	            angular.forEach(obj, function (value, key) {
	                str.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
	            });
	            return str.join('&');
	        };
	        OAuth1.$inject = ['$http', '$window', 'SatellizerConfig', 'SatellizerPopup'];
	        return OAuth1;
	    }());
	
	    var OAuth2 = (function () {
	        function OAuth2($http, $window, $timeout, $q, SatellizerConfig, SatellizerPopup, SatellizerStorage) {
	            this.$http = $http;
	            this.$window = $window;
	            this.$timeout = $timeout;
	            this.$q = $q;
	            this.SatellizerConfig = SatellizerConfig;
	            this.SatellizerPopup = SatellizerPopup;
	            this.SatellizerStorage = SatellizerStorage;
	            this.defaults = {
	                name: null,
	                url: null,
	                clientId: null,
	                authorizationEndpoint: null,
	                redirectUri: null,
	                scope: null,
	                scopePrefix: null,
	                scopeDelimiter: null,
	                state: null,
	                requiredUrlParams: null,
	                defaultUrlParams: ['response_type', 'client_id', 'redirect_uri'],
	                responseType: 'code',
	                responseParams: {
	                    code: 'code',
	                    clientId: 'clientId',
	                    redirectUri: 'redirectUri'
	                },
	                oauthType: '2.0',
	                popupOptions: { width: null, height: null }
	            };
	        }
	        OAuth2.camelCase = function (name) {
	            return name.replace(/([\:\-\_]+(.))/g, function (_, separator, letter, offset) {
	                return offset ? letter.toUpperCase() : letter;
	            });
	        };
	        OAuth2.prototype.init = function (options, userData) {
	            var _this = this;
	            return this.$q(function (resolve, reject) {
	                angular.extend(_this.defaults, options);
	                var stateName = _this.defaults.name + '_state';
	                var _a = _this.defaults, name = _a.name, state = _a.state, popupOptions = _a.popupOptions, redirectUri = _a.redirectUri, responseType = _a.responseType;
	                if (typeof state === 'function') {
	                    _this.SatellizerStorage.set(stateName, state());
	                }
	                else if (typeof state === 'string') {
	                    _this.SatellizerStorage.set(stateName, state);
	                }
	                var url = [_this.defaults.authorizationEndpoint, _this.buildQueryString()].join('?');
	                _this.SatellizerPopup.open(url, name, popupOptions, redirectUri).then(function (oauth) {
	                    if (responseType === 'token' || !url) {
	                        return resolve(oauth);
	                    }
	                    if (oauth.state && oauth.state !== _this.SatellizerStorage.get(stateName)) {
	                        return reject(new Error('The value returned in the state parameter does not match the state value from your original ' +
	                            'authorization code request.'));
	                    }
	                    resolve(_this.exchangeForToken(oauth, userData));
	                }).catch(function (error) { return reject(error); });
	            });
	        };
	        OAuth2.prototype.exchangeForToken = function (oauthData, userData) {
	            var _this = this;
	            var payload = angular.extend({}, userData);
	            angular.forEach(this.defaults.responseParams, function (value, key) {
	                switch (key) {
	                    case 'code':
	                        payload[value] = oauthData.code;
	                        break;
	                    case 'clientId':
	                        payload[value] = _this.defaults.clientId;
	                        break;
	                    case 'redirectUri':
	                        payload[value] = _this.defaults.redirectUri;
	                        break;
	                    default:
	                        payload[value] = oauthData[key];
	                }
	            });
	            if (oauthData.state) {
	                payload.state = oauthData.state;
	            }
	            var exchangeForTokenUrl = this.SatellizerConfig.baseUrl ?
	                joinUrl(this.SatellizerConfig.baseUrl, this.defaults.url) :
	                this.defaults.url;
	            return this.$http.post(exchangeForTokenUrl, payload, { withCredentials: this.SatellizerConfig.withCredentials });
	        };
	        OAuth2.prototype.buildQueryString = function () {
	            var _this = this;
	            var keyValuePairs = [];
	            var urlParamsCategories = ['defaultUrlParams', 'requiredUrlParams', 'optionalUrlParams'];
	            angular.forEach(urlParamsCategories, function (paramsCategory) {
	                angular.forEach(_this.defaults[paramsCategory], function (paramName) {
	                    var camelizedName = OAuth2.camelCase(paramName);
	                    var paramValue = angular.isFunction(_this.defaults[paramName]) ? _this.defaults[paramName]() : _this.defaults[camelizedName];
	                    if (paramName === 'redirect_uri' && !paramValue) {
	                        return;
	                    }
	                    if (paramName === 'state') {
	                        var stateName = _this.defaults.name + '_state';
	                        paramValue = encodeURIComponent(_this.SatellizerStorage.get(stateName));
	                    }
	                    if (paramName === 'scope' && Array.isArray(paramValue)) {
	                        paramValue = paramValue.join(_this.defaults.scopeDelimiter);
	                        if (_this.defaults.scopePrefix) {
	                            paramValue = [_this.defaults.scopePrefix, paramValue].join(_this.defaults.scopeDelimiter);
	                        }
	                    }
	                    keyValuePairs.push([paramName, paramValue]);
	                });
	            });
	            return keyValuePairs.map(function (pair) { return pair.join('='); }).join('&');
	        };
	        OAuth2.$inject = ['$http', '$window', '$timeout', '$q', 'SatellizerConfig', 'SatellizerPopup', 'SatellizerStorage'];
	        return OAuth2;
	    }());
	
	    var OAuth = (function () {
	        function OAuth($http, $window, $timeout, $q, SatellizerConfig, SatellizerPopup, SatellizerStorage, SatellizerShared, SatellizerOAuth1, SatellizerOAuth2) {
	            this.$http = $http;
	            this.$window = $window;
	            this.$timeout = $timeout;
	            this.$q = $q;
	            this.SatellizerConfig = SatellizerConfig;
	            this.SatellizerPopup = SatellizerPopup;
	            this.SatellizerStorage = SatellizerStorage;
	            this.SatellizerShared = SatellizerShared;
	            this.SatellizerOAuth1 = SatellizerOAuth1;
	            this.SatellizerOAuth2 = SatellizerOAuth2;
	        }
	        OAuth.prototype.authenticate = function (name, userData) {
	            var _this = this;
	            return this.$q(function (resolve, reject) {
	                var provider = _this.SatellizerConfig.providers[name];
	                var oauth = null;
	                switch (provider.oauthType) {
	                    case '1.0':
	                        oauth = new OAuth1(_this.$http, _this.$window, _this.SatellizerConfig, _this.SatellizerPopup);
	                        break;
	                    case '2.0':
	                        oauth = new OAuth2(_this.$http, _this.$window, _this.$timeout, _this.$q, _this.SatellizerConfig, _this.SatellizerPopup, _this.SatellizerStorage);
	                        break;
	                    default:
	                        return reject(new Error('Invalid OAuth Type'));
	                }
	                return oauth.init(provider, userData).then(function (response) {
	                    if (provider.url) {
	                        _this.SatellizerShared.setToken(response);
	                    }
	                    resolve(response);
	                }).catch(function (error) {
	                    reject(error);
	                });
	            });
	        };
	        OAuth.prototype.unlink = function (provider, httpOptions) {
	            if (httpOptions === void 0) { httpOptions = {}; }
	            httpOptions.url = httpOptions.url ? httpOptions.url : joinUrl(this.SatellizerConfig.baseUrl, this.SatellizerConfig.unlinkUrl);
	            httpOptions.data = { provider: provider } || httpOptions.data;
	            httpOptions.method = httpOptions.method || 'POST';
	            httpOptions.withCredentials = httpOptions.withCredentials || this.SatellizerConfig.withCredentials;
	            return this.$http(httpOptions);
	        };
	        OAuth.$inject = [
	            '$http',
	            '$window',
	            '$timeout',
	            '$q',
	            'SatellizerConfig',
	            'SatellizerPopup',
	            'SatellizerStorage',
	            'SatellizerShared',
	            'SatellizerOAuth1',
	            'SatellizerOAuth2'
	        ];
	        return OAuth;
	    }());
	
	    var Storage = (function () {
	        function Storage($window, SatellizerConfig) {
	            this.$window = $window;
	            this.SatellizerConfig = SatellizerConfig;
	            this.memoryStore = {};
	        }
	        Storage.prototype.get = function (key) {
	            try {
	                return this.$window[this.SatellizerConfig.storageType].getItem(key);
	            }
	            catch (e) {
	                return this.memoryStore[key];
	            }
	        };
	        Storage.prototype.set = function (key, value) {
	            try {
	                this.$window[this.SatellizerConfig.storageType].setItem(key, value);
	            }
	            catch (e) {
	                this.memoryStore[key] = value;
	            }
	        };
	        Storage.prototype.remove = function (key) {
	            try {
	                this.$window[this.SatellizerConfig.storageType].removeItem(key);
	            }
	            catch (e) {
	                delete this.memoryStore[key];
	            }
	        };
	        Storage.$inject = ['$window', 'SatellizerConfig'];
	        return Storage;
	    }());
	
	    var Interceptor = (function () {
	        function Interceptor(SatellizerConfig, SatellizerShared, SatellizerStorage) {
	            var _this = this;
	            this.SatellizerConfig = SatellizerConfig;
	            this.SatellizerShared = SatellizerShared;
	            this.SatellizerStorage = SatellizerStorage;
	            this.request = function (config) {
	                if (config['skipAuthorization']) {
	                    return config;
	                }
	                if (_this.SatellizerShared.isAuthenticated() && _this.SatellizerConfig.httpInterceptor()) {
	                    var tokenName = _this.SatellizerConfig.tokenPrefix ?
	                        [_this.SatellizerConfig.tokenPrefix, _this.SatellizerConfig.tokenName].join('_') : _this.SatellizerConfig.tokenName;
	                    var token = _this.SatellizerStorage.get(tokenName);
	                    if (_this.SatellizerConfig.tokenHeader && _this.SatellizerConfig.tokenType) {
	                        token = _this.SatellizerConfig.tokenType + ' ' + token;
	                    }
	                    config.headers[_this.SatellizerConfig.tokenHeader] = token;
	                }
	                return config;
	            };
	        }
	        Interceptor.Factory = function (SatellizerConfig, SatellizerShared, SatellizerStorage) {
	            return new Interceptor(SatellizerConfig, SatellizerShared, SatellizerStorage);
	        };
	        Interceptor.$inject = ['SatellizerConfig', 'SatellizerShared', 'SatellizerStorage'];
	        return Interceptor;
	    }());
	    Interceptor.Factory.$inject = ['SatellizerConfig', 'SatellizerShared', 'SatellizerStorage'];
	
	    var HttpProviderConfig = (function () {
	        function HttpProviderConfig($httpProvider) {
	            this.$httpProvider = $httpProvider;
	            $httpProvider.interceptors.push(Interceptor.Factory);
	        }
	        HttpProviderConfig.$inject = ['$httpProvider'];
	        return HttpProviderConfig;
	    }());
	
	    angular.module('satellizer', [])
	        .provider('$auth', ['SatellizerConfig', function (SatellizerConfig) { return new AuthProvider(SatellizerConfig); }])
	        .constant('SatellizerConfig', Config.getConstant)
	        .service('SatellizerShared', Shared)
	        .service('SatellizerLocal', Local)
	        .service('SatellizerPopup', Popup)
	        .service('SatellizerOAuth', OAuth)
	        .service('SatellizerOAuth2', OAuth2)
	        .service('SatellizerOAuth1', OAuth1)
	        .service('SatellizerStorage', Storage)
	        .service('SatellizerInterceptor', Interceptor)
	        .config(['$httpProvider', function ($httpProvider) { return new HttpProviderConfig($httpProvider); }]);
	    var ng1 = 'satellizer';
	
	    return ng1;
	
	}));
	//# sourceMappingURL=satellizer.js.map


/***/ }),
/* 675 */,
/* 676 */,
/* 677 */
/***/ (function(module, exports) {

	/*!
	 * ui-select
	 * http://github.com/angular-ui/ui-select
	 * Version: 0.19.8 - 2017-04-18T05:43:43.673Z
	 * License: MIT
	 */
	
	
	(function () { 
	"use strict";
	var KEY = {
	    TAB: 9,
	    ENTER: 13,
	    ESC: 27,
	    SPACE: 32,
	    LEFT: 37,
	    UP: 38,
	    RIGHT: 39,
	    DOWN: 40,
	    SHIFT: 16,
	    CTRL: 17,
	    ALT: 18,
	    PAGE_UP: 33,
	    PAGE_DOWN: 34,
	    HOME: 36,
	    END: 35,
	    BACKSPACE: 8,
	    DELETE: 46,
	    COMMAND: 91,
	
	    MAP: { 91 : "COMMAND", 8 : "BACKSPACE" , 9 : "TAB" , 13 : "ENTER" , 16 : "SHIFT" , 17 : "CTRL" , 18 : "ALT" , 19 : "PAUSEBREAK" , 20 : "CAPSLOCK" , 27 : "ESC" , 32 : "SPACE" , 33 : "PAGE_UP", 34 : "PAGE_DOWN" , 35 : "END" , 36 : "HOME" , 37 : "LEFT" , 38 : "UP" , 39 : "RIGHT" , 40 : "DOWN" , 43 : "+" , 44 : "PRINTSCREEN" , 45 : "INSERT" , 46 : "DELETE", 48 : "0" , 49 : "1" , 50 : "2" , 51 : "3" , 52 : "4" , 53 : "5" , 54 : "6" , 55 : "7" , 56 : "8" , 57 : "9" , 59 : ";", 61 : "=" , 65 : "A" , 66 : "B" , 67 : "C" , 68 : "D" , 69 : "E" , 70 : "F" , 71 : "G" , 72 : "H" , 73 : "I" , 74 : "J" , 75 : "K" , 76 : "L", 77 : "M" , 78 : "N" , 79 : "O" , 80 : "P" , 81 : "Q" , 82 : "R" , 83 : "S" , 84 : "T" , 85 : "U" , 86 : "V" , 87 : "W" , 88 : "X" , 89 : "Y" , 90 : "Z", 96 : "0" , 97 : "1" , 98 : "2" , 99 : "3" , 100 : "4" , 101 : "5" , 102 : "6" , 103 : "7" , 104 : "8" , 105 : "9", 106 : "*" , 107 : "+" , 109 : "-" , 110 : "." , 111 : "/", 112 : "F1" , 113 : "F2" , 114 : "F3" , 115 : "F4" , 116 : "F5" , 117 : "F6" , 118 : "F7" , 119 : "F8" , 120 : "F9" , 121 : "F10" , 122 : "F11" , 123 : "F12", 144 : "NUMLOCK" , 145 : "SCROLLLOCK" , 186 : ";" , 187 : "=" , 188 : "," , 189 : "-" , 190 : "." , 191 : "/" , 192 : "`" , 219 : "[" , 220 : "\\" , 221 : "]" , 222 : "'"
	    },
	
	    isControl: function (e) {
	        var k = e.which;
	        switch (k) {
	        case KEY.COMMAND:
	        case KEY.SHIFT:
	        case KEY.CTRL:
	        case KEY.ALT:
	            return true;
	        }
	
	        if (e.metaKey || e.ctrlKey || e.altKey) return true;
	
	        return false;
	    },
	    isFunctionKey: function (k) {
	        k = k.which ? k.which : k;
	        return k >= 112 && k <= 123;
	    },
	    isVerticalMovement: function (k){
	      return ~[KEY.UP, KEY.DOWN].indexOf(k);
	    },
	    isHorizontalMovement: function (k){
	      return ~[KEY.LEFT,KEY.RIGHT,KEY.BACKSPACE,KEY.DELETE].indexOf(k);
	    },
	    toSeparator: function (k) {
	      var sep = {ENTER:"\n",TAB:"\t",SPACE:" "}[k];
	      if (sep) return sep;
	      // return undefined for special keys other than enter, tab or space.
	      // no way to use them to cut strings.
	      return KEY[k] ? undefined : k;
	    }
	  };
	
	function isNil(value) {
	  return angular.isUndefined(value) || value === null;
	}
	
	/**
	 * Add querySelectorAll() to jqLite.
	 *
	 * jqLite find() is limited to lookups by tag name.
	 * TODO This will change with future versions of AngularJS, to be removed when this happens
	 *
	 * See jqLite.find - why not use querySelectorAll? https://github.com/angular/angular.js/issues/3586
	 * See feat(jqLite): use querySelectorAll instead of getElementsByTagName in jqLite.find https://github.com/angular/angular.js/pull/3598
	 */
	if (angular.element.prototype.querySelectorAll === undefined) {
	  angular.element.prototype.querySelectorAll = function(selector) {
	    return angular.element(this[0].querySelectorAll(selector));
	  };
	}
	
	/**
	 * Add closest() to jqLite.
	 */
	if (angular.element.prototype.closest === undefined) {
	  angular.element.prototype.closest = function( selector) {
	    var elem = this[0];
	    var matchesSelector = elem.matches || elem.webkitMatchesSelector || elem.mozMatchesSelector || elem.msMatchesSelector;
	
	    while (elem) {
	      if (matchesSelector.bind(elem)(selector)) {
	        return elem;
	      } else {
	        elem = elem.parentElement;
	      }
	    }
	    return false;
	  };
	}
	
	var latestId = 0;
	
	var uis = angular.module('ui.select', [])
	
	.constant('uiSelectConfig', {
	  theme: 'bootstrap',
	  searchEnabled: true,
	  sortable: false,
	  placeholder: '', // Empty by default, like HTML tag <select>
	  refreshDelay: 1000, // In milliseconds
	  closeOnSelect: true,
	  skipFocusser: false,
	  dropdownPosition: 'auto',
	  removeSelected: true,
	  resetSearchInput: true,
	  generateId: function() {
	    return latestId++;
	  },
	  appendToBody: false,
	  spinnerEnabled: false,
	  spinnerClass: 'glyphicon glyphicon-refresh ui-select-spin',
	  backspaceReset: true
	})
	
	// See Rename minErr and make it accessible from outside https://github.com/angular/angular.js/issues/6913
	.service('uiSelectMinErr', function() {
	  var minErr = angular.$$minErr('ui.select');
	  return function() {
	    var error = minErr.apply(this, arguments);
	    var message = error.message.replace(new RegExp('\nhttp://errors.angularjs.org/.*'), '');
	    return new Error(message);
	  };
	})
	
	// Recreates old behavior of ng-transclude. Used internally.
	.directive('uisTranscludeAppend', function () {
	  return {
	    link: function (scope, element, attrs, ctrl, transclude) {
	        transclude(scope, function (clone) {
	          element.append(clone);
	        });
	      }
	    };
	})
	
	/**
	 * Highlights text that matches $select.search.
	 *
	 * Taken from AngularUI Bootstrap Typeahead
	 * See https://github.com/angular-ui/bootstrap/blob/0.10.0/src/typeahead/typeahead.js#L340
	 */
	.filter('highlight', function() {
	  function escapeRegexp(queryToEscape) {
	    return ('' + queryToEscape).replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
	  }
	
	  return function(matchItem, query) {
	    return query && matchItem ? ('' + matchItem).replace(new RegExp(escapeRegexp(query), 'gi'), '<span class="ui-select-highlight">$&</span>') : matchItem;
	  };
	})
	
	/**
	 * A read-only equivalent of jQuery's offset function: http://api.jquery.com/offset/
	 *
	 * Taken from AngularUI Bootstrap Position:
	 * See https://github.com/angular-ui/bootstrap/blob/master/src/position/position.js#L70
	 */
	.factory('uisOffset',
	  ['$document', '$window',
	  function ($document, $window) {
	
	  return function(element) {
	    var boundingClientRect = element[0].getBoundingClientRect();
	    return {
	      width: boundingClientRect.width || element.prop('offsetWidth'),
	      height: boundingClientRect.height || element.prop('offsetHeight'),
	      top: boundingClientRect.top + ($window.pageYOffset || $document[0].documentElement.scrollTop),
	      left: boundingClientRect.left + ($window.pageXOffset || $document[0].documentElement.scrollLeft)
	    };
	  };
	}]);
	
	uis.directive('uiSelectChoices',
	  ['uiSelectConfig', 'uisRepeatParser', 'uiSelectMinErr', '$compile', '$window',
	  function(uiSelectConfig, RepeatParser, uiSelectMinErr, $compile, $window) {
	
	  return {
	    restrict: 'EA',
	    require: '^uiSelect',
	    replace: true,
	    transclude: true,
	    templateUrl: function(tElement) {
	      // Needed so the uiSelect can detect the transcluded content
	      tElement.addClass('ui-select-choices');
	
	      // Gets theme attribute from parent (ui-select)
	      var theme = tElement.parent().attr('theme') || uiSelectConfig.theme;
	      return theme + '/choices.tpl.html';
	    },
	
	    compile: function(tElement, tAttrs) {
	
	      if (!tAttrs.repeat) throw uiSelectMinErr('repeat', "Expected 'repeat' expression.");
	
	      // var repeat = RepeatParser.parse(attrs.repeat);
	      var groupByExp = tAttrs.groupBy;
	      var groupFilterExp = tAttrs.groupFilter;
	
	      if (groupByExp) {
	        var groups = tElement.querySelectorAll('.ui-select-choices-group');
	        if (groups.length !== 1) throw uiSelectMinErr('rows', "Expected 1 .ui-select-choices-group but got '{0}'.", groups.length);
	        groups.attr('ng-repeat', RepeatParser.getGroupNgRepeatExpression());
	      }
	
	      var parserResult = RepeatParser.parse(tAttrs.repeat);
	
	      var choices = tElement.querySelectorAll('.ui-select-choices-row');
	      if (choices.length !== 1) {
	        throw uiSelectMinErr('rows', "Expected 1 .ui-select-choices-row but got '{0}'.", choices.length);
	      }
	
	      choices.attr('ng-repeat', parserResult.repeatExpression(groupByExp))
	             .attr('ng-if', '$select.open'); //Prevent unnecessary watches when dropdown is closed
	
	
	      var rowsInner = tElement.querySelectorAll('.ui-select-choices-row-inner');
	      if (rowsInner.length !== 1) {
	        throw uiSelectMinErr('rows', "Expected 1 .ui-select-choices-row-inner but got '{0}'.", rowsInner.length);
	      }
	      rowsInner.attr('uis-transclude-append', ''); //Adding uisTranscludeAppend directive to row element after choices element has ngRepeat
	
	      // If IE8 then need to target rowsInner to apply the ng-click attr as choices will not capture the event.
	      var clickTarget = $window.document.addEventListener ? choices : rowsInner;
	      clickTarget.attr('ng-click', '$select.select(' + parserResult.itemName + ',$select.skipFocusser,$event)');
	
	      return function link(scope, element, attrs, $select) {
	
	
	        $select.parseRepeatAttr(attrs.repeat, groupByExp, groupFilterExp); //Result ready at $select.parserResult
	        $select.disableChoiceExpression = attrs.uiDisableChoice;
	        $select.onHighlightCallback = attrs.onHighlight;
	        $select.minimumInputLength = parseInt(attrs.minimumInputLength) || 0;
	        $select.dropdownPosition = attrs.position ? attrs.position.toLowerCase() : uiSelectConfig.dropdownPosition;
	
	        scope.$watch('$select.search', function(newValue) {
	          if(newValue && !$select.open && $select.multiple) $select.activate(false, true);
	          $select.activeIndex = $select.tagging.isActivated ? -1 : 0;
	          if (!attrs.minimumInputLength || $select.search.length >= attrs.minimumInputLength) {
	            $select.refresh(attrs.refresh);
	          } else {
	            $select.items = [];
	          }
	        });
	
	        attrs.$observe('refreshDelay', function() {
	          // $eval() is needed otherwise we get a string instead of a number
	          var refreshDelay = scope.$eval(attrs.refreshDelay);
	          $select.refreshDelay = refreshDelay !== undefined ? refreshDelay : uiSelectConfig.refreshDelay;
	        });
	
	        scope.$watch('$select.open', function(open) {
	          if (open) {
	            tElement.attr('role', 'listbox');
	            $select.refresh(attrs.refresh);
	          } else {
	            element.removeAttr('role');
	          }
	        });
	      };
	    }
	  };
	}]);
	
	/**
	 * Contains ui-select "intelligence".
	 *
	 * The goal is to limit dependency on the DOM whenever possible and
	 * put as much logic in the controller (instead of the link functions) as possible so it can be easily tested.
	 */
	uis.controller('uiSelectCtrl',
	  ['$scope', '$element', '$timeout', '$filter', '$$uisDebounce', 'uisRepeatParser', 'uiSelectMinErr', 'uiSelectConfig', '$parse', '$injector', '$window',
	  function($scope, $element, $timeout, $filter, $$uisDebounce, RepeatParser, uiSelectMinErr, uiSelectConfig, $parse, $injector, $window) {
	
	  var ctrl = this;
	
	  var EMPTY_SEARCH = '';
	
	  ctrl.placeholder = uiSelectConfig.placeholder;
	  ctrl.searchEnabled = uiSelectConfig.searchEnabled;
	  ctrl.sortable = uiSelectConfig.sortable;
	  ctrl.refreshDelay = uiSelectConfig.refreshDelay;
	  ctrl.paste = uiSelectConfig.paste;
	  ctrl.resetSearchInput = uiSelectConfig.resetSearchInput;
	  ctrl.refreshing = false;
	  ctrl.spinnerEnabled = uiSelectConfig.spinnerEnabled;
	  ctrl.spinnerClass = uiSelectConfig.spinnerClass;
	  ctrl.removeSelected = uiSelectConfig.removeSelected; //If selected item(s) should be removed from dropdown list
	  ctrl.closeOnSelect = true; //Initialized inside uiSelect directive link function
	  ctrl.skipFocusser = false; //Set to true to avoid returning focus to ctrl when item is selected
	  ctrl.search = EMPTY_SEARCH;
	
	  ctrl.activeIndex = 0; //Dropdown of choices
	  ctrl.items = []; //All available choices
	
	  ctrl.open = false;
	  ctrl.focus = false;
	  ctrl.disabled = false;
	  ctrl.selected = undefined;
	
	  ctrl.dropdownPosition = 'auto';
	
	  ctrl.focusser = undefined; //Reference to input element used to handle focus events
	  ctrl.multiple = undefined; // Initialized inside uiSelect directive link function
	  ctrl.disableChoiceExpression = undefined; // Initialized inside uiSelectChoices directive link function
	  ctrl.tagging = {isActivated: false, fct: undefined};
	  ctrl.taggingTokens = {isActivated: false, tokens: undefined};
	  ctrl.lockChoiceExpression = undefined; // Initialized inside uiSelectMatch directive link function
	  ctrl.clickTriggeredSelect = false;
	  ctrl.$filter = $filter;
	  ctrl.$element = $element;
	
	  // Use $injector to check for $animate and store a reference to it
	  ctrl.$animate = (function () {
	    try {
	      return $injector.get('$animate');
	    } catch (err) {
	      // $animate does not exist
	      return null;
	    }
	  })();
	
	  ctrl.searchInput = $element.querySelectorAll('input.ui-select-search');
	  if (ctrl.searchInput.length !== 1) {
	    throw uiSelectMinErr('searchInput', "Expected 1 input.ui-select-search but got '{0}'.", ctrl.searchInput.length);
	  }
	
	  ctrl.isEmpty = function() {
	    return isNil(ctrl.selected) || ctrl.selected === '' || (ctrl.multiple && ctrl.selected.length === 0);
	  };
	
	  function _findIndex(collection, predicate, thisArg){
	    if (collection.findIndex){
	      return collection.findIndex(predicate, thisArg);
	    } else {
	      var list = Object(collection);
	      var length = list.length >>> 0;
	      var value;
	
	      for (var i = 0; i < length; i++) {
	        value = list[i];
	        if (predicate.call(thisArg, value, i, list)) {
	          return i;
	        }
	      }
	      return -1;
	    }
	  }
	
	  // Most of the time the user does not want to empty the search input when in typeahead mode
	  function _resetSearchInput() {
	    if (ctrl.resetSearchInput) {
	      ctrl.search = EMPTY_SEARCH;
	      //reset activeIndex
	      if (ctrl.selected && ctrl.items.length && !ctrl.multiple) {
	        ctrl.activeIndex = _findIndex(ctrl.items, function(item){
	          return angular.equals(this, item);
	        }, ctrl.selected);
	      }
	    }
	  }
	
	    function _groupsFilter(groups, groupNames) {
	      var i, j, result = [];
	      for(i = 0; i < groupNames.length ;i++){
	        for(j = 0; j < groups.length ;j++){
	          if(groups[j].name == [groupNames[i]]){
	            result.push(groups[j]);
	          }
	        }
	      }
	      return result;
	    }
	
	  // When the user clicks on ui-select, displays the dropdown list
	  ctrl.activate = function(initSearchValue, avoidReset) {
	    if (!ctrl.disabled  && !ctrl.open) {
	      if(!avoidReset) _resetSearchInput();
	
	      $scope.$broadcast('uis:activate');
	      ctrl.open = true;
	      ctrl.activeIndex = ctrl.activeIndex >= ctrl.items.length ? 0 : ctrl.activeIndex;
	      // ensure that the index is set to zero for tagging variants
	      // that where first option is auto-selected
	      if ( ctrl.activeIndex === -1 && ctrl.taggingLabel !== false ) {
	        ctrl.activeIndex = 0;
	      }
	
	      var container = $element.querySelectorAll('.ui-select-choices-content');
	      var searchInput = $element.querySelectorAll('.ui-select-search');
	      if (ctrl.$animate && ctrl.$animate.on && ctrl.$animate.enabled(container[0])) {
	        var animateHandler = function(elem, phase) {
	          if (phase === 'start' && ctrl.items.length === 0) {
	            // Only focus input after the animation has finished
	            ctrl.$animate.off('removeClass', searchInput[0], animateHandler);
	            $timeout(function () {
	              ctrl.focusSearchInput(initSearchValue);
	            });
	          } else if (phase === 'close') {
	            // Only focus input after the animation has finished
	            ctrl.$animate.off('enter', container[0], animateHandler);
	            $timeout(function () {
	              ctrl.focusSearchInput(initSearchValue);
	            });
	          }
	        };
	
	        if (ctrl.items.length > 0) {
	          ctrl.$animate.on('enter', container[0], animateHandler);
	        } else {
	          ctrl.$animate.on('removeClass', searchInput[0], animateHandler);
	        }
	      } else {
	        $timeout(function () {
	          ctrl.focusSearchInput(initSearchValue);
	          if(!ctrl.tagging.isActivated && ctrl.items.length > 1) {
	            _ensureHighlightVisible();
	          }
	        });
	      }
	    }
	    else if (ctrl.open && !ctrl.searchEnabled) {
	      // Close the selection if we don't have search enabled, and we click on the select again
	      ctrl.close();
	    }
	  };
	
	  ctrl.focusSearchInput = function (initSearchValue) {
	    ctrl.search = initSearchValue || ctrl.search;
	    ctrl.searchInput[0].focus();
	  };
	
	  ctrl.findGroupByName = function(name) {
	    return ctrl.groups && ctrl.groups.filter(function(group) {
	      return group.name === name;
	    })[0];
	  };
	
	  ctrl.parseRepeatAttr = function(repeatAttr, groupByExp, groupFilterExp) {
	    function updateGroups(items) {
	      var groupFn = $scope.$eval(groupByExp);
	      ctrl.groups = [];
	      angular.forEach(items, function(item) {
	        var groupName = angular.isFunction(groupFn) ? groupFn(item) : item[groupFn];
	        var group = ctrl.findGroupByName(groupName);
	        if(group) {
	          group.items.push(item);
	        }
	        else {
	          ctrl.groups.push({name: groupName, items: [item]});
	        }
	      });
	      if(groupFilterExp){
	        var groupFilterFn = $scope.$eval(groupFilterExp);
	        if( angular.isFunction(groupFilterFn)){
	          ctrl.groups = groupFilterFn(ctrl.groups);
	        } else if(angular.isArray(groupFilterFn)){
	          ctrl.groups = _groupsFilter(ctrl.groups, groupFilterFn);
	        }
	      }
	      ctrl.items = [];
	      ctrl.groups.forEach(function(group) {
	        ctrl.items = ctrl.items.concat(group.items);
	      });
	    }
	
	    function setPlainItems(items) {
	      ctrl.items = items || [];
	    }
	
	    ctrl.setItemsFn = groupByExp ? updateGroups : setPlainItems;
	
	    ctrl.parserResult = RepeatParser.parse(repeatAttr);
	
	    ctrl.isGrouped = !!groupByExp;
	    ctrl.itemProperty = ctrl.parserResult.itemName;
	
	    //If collection is an Object, convert it to Array
	
	    var originalSource = ctrl.parserResult.source;
	
	    //When an object is used as source, we better create an array and use it as 'source'
	    var createArrayFromObject = function(){
	      var origSrc = originalSource($scope);
	      $scope.$uisSource = Object.keys(origSrc).map(function(v){
	        var result = {};
	        result[ctrl.parserResult.keyName] = v;
	        result.value = origSrc[v];
	        return result;
	      });
	    };
	
	    if (ctrl.parserResult.keyName){ // Check for (key,value) syntax
	      createArrayFromObject();
	      ctrl.parserResult.source = $parse('$uisSource' + ctrl.parserResult.filters);
	      $scope.$watch(originalSource, function(newVal, oldVal){
	        if (newVal !== oldVal) createArrayFromObject();
	      }, true);
	    }
	
	    ctrl.refreshItems = function (data){
	      data = data || ctrl.parserResult.source($scope);
	      var selectedItems = ctrl.selected;
	      //TODO should implement for single mode removeSelected
	      if (ctrl.isEmpty() || (angular.isArray(selectedItems) && !selectedItems.length) || !ctrl.multiple || !ctrl.removeSelected) {
	        ctrl.setItemsFn(data);
	      }else{
	        if ( data !== undefined && data !== null ) {
	          var filteredItems = data.filter(function(i) {
	            return angular.isArray(selectedItems) ? selectedItems.every(function(selectedItem) {
	              return !angular.equals(i, selectedItem);
	            }) : !angular.equals(i, selectedItems);
	          });
	          ctrl.setItemsFn(filteredItems);
	        }
	      }
	      if (ctrl.dropdownPosition === 'auto' || ctrl.dropdownPosition === 'up'){
	        $scope.calculateDropdownPos();
	      }
	      $scope.$broadcast('uis:refresh');
	    };
	
	    // See https://github.com/angular/angular.js/blob/v1.2.15/src/ng/directive/ngRepeat.js#L259
	    $scope.$watchCollection(ctrl.parserResult.source, function(items) {
	      if (items === undefined || items === null) {
	        // If the user specifies undefined or null => reset the collection
	        // Special case: items can be undefined if the user did not initialized the collection on the scope
	        // i.e $scope.addresses = [] is missing
	        ctrl.items = [];
	      } else {
	        if (!angular.isArray(items)) {
	          throw uiSelectMinErr('items', "Expected an array but got '{0}'.", items);
	        } else {
	          //Remove already selected items (ex: while searching)
	          //TODO Should add a test
	          ctrl.refreshItems(items);
	
	          //update the view value with fresh data from items, if there is a valid model value
	          if(angular.isDefined(ctrl.ngModel.$modelValue)) {
	            ctrl.ngModel.$modelValue = null; //Force scope model value and ngModel value to be out of sync to re-run formatters
	          }
	        }
	      }
	    });
	
	  };
	
	  var _refreshDelayPromise;
	
	  /**
	   * Typeahead mode: lets the user refresh the collection using his own function.
	   *
	   * See Expose $select.search for external / remote filtering https://github.com/angular-ui/ui-select/pull/31
	   */
	  ctrl.refresh = function(refreshAttr) {
	    if (refreshAttr !== undefined) {
	      // Debounce
	      // See https://github.com/angular-ui/bootstrap/blob/0.10.0/src/typeahead/typeahead.js#L155
	      // FYI AngularStrap typeahead does not have debouncing: https://github.com/mgcrea/angular-strap/blob/v2.0.0-rc.4/src/typeahead/typeahead.js#L177
	      if (_refreshDelayPromise) {
	        $timeout.cancel(_refreshDelayPromise);
	      }
	      _refreshDelayPromise = $timeout(function() {
	        if ($scope.$select.search.length >= $scope.$select.minimumInputLength) {
	          var refreshPromise = $scope.$eval(refreshAttr);
	          if (refreshPromise && angular.isFunction(refreshPromise.then) && !ctrl.refreshing) {
	            ctrl.refreshing = true;
	            refreshPromise.finally(function() {
	              ctrl.refreshing = false;
	            });
	          }
	        }
	      }, ctrl.refreshDelay);
	    }
	  };
	
	  ctrl.isActive = function(itemScope) {
	    if ( !ctrl.open ) {
	      return false;
	    }
	    var itemIndex = ctrl.items.indexOf(itemScope[ctrl.itemProperty]);
	    var isActive =  itemIndex == ctrl.activeIndex;
	
	    if ( !isActive || itemIndex < 0 ) {
	      return false;
	    }
	
	    if (isActive && !angular.isUndefined(ctrl.onHighlightCallback)) {
	      itemScope.$eval(ctrl.onHighlightCallback);
	    }
	
	    return isActive;
	  };
	
	  var _isItemSelected = function (item) {
	    return (ctrl.selected && angular.isArray(ctrl.selected) &&
	        ctrl.selected.filter(function (selection) { return angular.equals(selection, item); }).length > 0);
	  };
	
	  var disabledItems = [];
	
	  function _updateItemDisabled(item, isDisabled) {
	    var disabledItemIndex = disabledItems.indexOf(item);
	    if (isDisabled && disabledItemIndex === -1) {
	      disabledItems.push(item);
	    }
	
	    if (!isDisabled && disabledItemIndex > -1) {
	      disabledItems.splice(disabledItemIndex, 1);
	    }
	  }
	
	  function _isItemDisabled(item) {
	    return disabledItems.indexOf(item) > -1;
	  }
	
	  ctrl.isDisabled = function(itemScope) {
	
	    if (!ctrl.open) return;
	
	    var item = itemScope[ctrl.itemProperty];
	    var itemIndex = ctrl.items.indexOf(item);
	    var isDisabled = false;
	
	    if (itemIndex >= 0 && (angular.isDefined(ctrl.disableChoiceExpression) || ctrl.multiple)) {
	
	      if (item.isTag) return false;
	
	      if (ctrl.multiple) {
	        isDisabled = _isItemSelected(item);
	      }
	
	      if (!isDisabled && angular.isDefined(ctrl.disableChoiceExpression)) {
	        isDisabled = !!(itemScope.$eval(ctrl.disableChoiceExpression));
	      }
	
	      _updateItemDisabled(item, isDisabled);
	    }
	
	    return isDisabled;
	  };
	
	
	  // When the user selects an item with ENTER or clicks the dropdown
	  ctrl.select = function(item, skipFocusser, $event) {
	    if (isNil(item) || !_isItemDisabled(item)) {
	
	      if ( ! ctrl.items && ! ctrl.search && ! ctrl.tagging.isActivated) return;
	
	      if (!item || !_isItemDisabled(item)) {
	        // if click is made on existing item, prevent from tagging, ctrl.search does not matter
	        ctrl.clickTriggeredSelect = false;
	        if($event && ($event.type === 'click' || $event.type === 'touchend') && item)
	          ctrl.clickTriggeredSelect = true;
	
	        if(ctrl.tagging.isActivated && ctrl.clickTriggeredSelect === false) {
	          // if taggingLabel is disabled and item is undefined we pull from ctrl.search
	          if ( ctrl.taggingLabel === false ) {
	            if ( ctrl.activeIndex < 0 ) {
	              if (item === undefined) {
	                item = ctrl.tagging.fct !== undefined ? ctrl.tagging.fct(ctrl.search) : ctrl.search;
	              }
	              if (!item || angular.equals( ctrl.items[0], item ) ) {
	                return;
	              }
	            } else {
	              // keyboard nav happened first, user selected from dropdown
	              item = ctrl.items[ctrl.activeIndex];
	            }
	          } else {
	            // tagging always operates at index zero, taggingLabel === false pushes
	            // the ctrl.search value without having it injected
	            if ( ctrl.activeIndex === 0 ) {
	              // ctrl.tagging pushes items to ctrl.items, so we only have empty val
	              // for `item` if it is a detected duplicate
	              if ( item === undefined ) return;
	
	              // create new item on the fly if we don't already have one;
	              // use tagging function if we have one
	              if ( ctrl.tagging.fct !== undefined && typeof item === 'string' ) {
	                item = ctrl.tagging.fct(item);
	                if (!item) return;
	              // if item type is 'string', apply the tagging label
	              } else if ( typeof item === 'string' ) {
	                // trim the trailing space
	                item = item.replace(ctrl.taggingLabel,'').trim();
	              }
	            }
	          }
	          // search ctrl.selected for dupes potentially caused by tagging and return early if found
	          if (_isItemSelected(item)) {
	            ctrl.close(skipFocusser);
	            return;
	          }
	        }
	        _resetSearchInput();
	        $scope.$broadcast('uis:select', item);
	
	        if (ctrl.closeOnSelect) {
	          ctrl.close(skipFocusser);
	        }
	      }
	    }
	  };
	
	  // Closes the dropdown
	  ctrl.close = function(skipFocusser) {
	    if (!ctrl.open) return;
	    if (ctrl.ngModel && ctrl.ngModel.$setTouched) ctrl.ngModel.$setTouched();
	    ctrl.open = false;
	    _resetSearchInput();
	    $scope.$broadcast('uis:close', skipFocusser);
	
	  };
	
	  ctrl.setFocus = function(){
	    if (!ctrl.focus) ctrl.focusInput[0].focus();
	  };
	
	  ctrl.clear = function($event) {
	    ctrl.select(null);
	    $event.stopPropagation();
	    $timeout(function() {
	      ctrl.focusser[0].focus();
	    }, 0, false);
	  };
	
	  // Toggle dropdown
	  ctrl.toggle = function(e) {
	    if (ctrl.open) {
	      ctrl.close();
	      e.preventDefault();
	      e.stopPropagation();
	    } else {
	      ctrl.activate();
	    }
	  };
	
	  // Set default function for locked choices - avoids unnecessary
	  // logic if functionality is not being used
	  ctrl.isLocked = function () {
	    return false;
	  };
	
	  $scope.$watch(function () {
	    return angular.isDefined(ctrl.lockChoiceExpression) && ctrl.lockChoiceExpression !== "";
	  }, _initaliseLockedChoices);
	
	  function _initaliseLockedChoices(doInitalise) {
	    if(!doInitalise) return;
	
	    var lockedItems = [];
	
	    function _updateItemLocked(item, isLocked) {
	      var lockedItemIndex = lockedItems.indexOf(item);
	      if (isLocked && lockedItemIndex === -1) {
	        lockedItems.push(item);
	        }
	
	      if (!isLocked && lockedItemIndex > -1) {
	        lockedItems.splice(lockedItemIndex, 1);
	      }
	    }
	
	    function _isItemlocked(item) {
	      return lockedItems.indexOf(item) > -1;
	    }
	
	    ctrl.isLocked = function (itemScope, itemIndex) {
	      var isLocked = false,
	          item = ctrl.selected[itemIndex];
	
	      if(item) {
	        if (itemScope) {
	          isLocked = !!(itemScope.$eval(ctrl.lockChoiceExpression));
	          _updateItemLocked(item, isLocked);
	        } else {
	          isLocked = _isItemlocked(item);
	        }
	      }
	
	      return isLocked;
	    };
	  }
	
	
	  var sizeWatch = null;
	  var updaterScheduled = false;
	  ctrl.sizeSearchInput = function() {
	
	    var input = ctrl.searchInput[0],
	        container = ctrl.$element[0],
	        calculateContainerWidth = function() {
	          // Return the container width only if the search input is visible
	          return container.clientWidth * !!input.offsetParent;
	        },
	        updateIfVisible = function(containerWidth) {
	          if (containerWidth === 0) {
	            return false;
	          }
	          var inputWidth = containerWidth - input.offsetLeft;
	          if (inputWidth < 50) inputWidth = containerWidth;
	          ctrl.searchInput.css('width', inputWidth+'px');
	          return true;
	        };
	
	    ctrl.searchInput.css('width', '10px');
	    $timeout(function() { //Give tags time to render correctly
	      if (sizeWatch === null && !updateIfVisible(calculateContainerWidth())) {
	        sizeWatch = $scope.$watch(function() {
	          if (!updaterScheduled) {
	            updaterScheduled = true;
	            $scope.$$postDigest(function() {
	              updaterScheduled = false;
	              if (updateIfVisible(calculateContainerWidth())) {
	                sizeWatch();
	                sizeWatch = null;
	              }
	            });
	          }
	        }, angular.noop);
	      }
	    });
	  };
	
	  function _handleDropDownSelection(key) {
	    var processed = true;
	    switch (key) {
	      case KEY.DOWN:
	        if (!ctrl.open && ctrl.multiple) ctrl.activate(false, true); //In case its the search input in 'multiple' mode
	        else if (ctrl.activeIndex < ctrl.items.length - 1) {
	          var idx = ++ctrl.activeIndex;
	          while(_isItemDisabled(ctrl.items[idx]) && idx < ctrl.items.length) {
	            ctrl.activeIndex = ++idx;
	          }
	        }
	        break;
	      case KEY.UP:
	        var minActiveIndex = (ctrl.search.length === 0 && ctrl.tagging.isActivated) ? -1 : 0;
	        if (!ctrl.open && ctrl.multiple) ctrl.activate(false, true); //In case its the search input in 'multiple' mode
	        else if (ctrl.activeIndex > minActiveIndex) {
	          var idxmin = --ctrl.activeIndex;
	          while(_isItemDisabled(ctrl.items[idxmin]) && idxmin > minActiveIndex) {
	            ctrl.activeIndex = --idxmin;
	          }
	        }
	        break;
	      case KEY.TAB:
	        if (!ctrl.multiple || ctrl.open) ctrl.select(ctrl.items[ctrl.activeIndex], true);
	        break;
	      case KEY.ENTER:
	        if(ctrl.open && (ctrl.tagging.isActivated || ctrl.activeIndex >= 0)){
	          ctrl.select(ctrl.items[ctrl.activeIndex], ctrl.skipFocusser); // Make sure at least one dropdown item is highlighted before adding if not in tagging mode
	        } else {
	          ctrl.activate(false, true); //In case its the search input in 'multiple' mode
	        }
	        break;
	      case KEY.ESC:
	        ctrl.close();
	        break;
	      default:
	        processed = false;
	    }
	    return processed;
	  }
	
	  // Bind to keyboard shortcuts
	  ctrl.searchInput.on('keydown', function(e) {
	
	    var key = e.which;
	
	    if (~[KEY.ENTER,KEY.ESC].indexOf(key)){
	      e.preventDefault();
	      e.stopPropagation();
	    }
	
	    $scope.$apply(function() {
	
	      var tagged = false;
	
	      if (ctrl.items.length > 0 || ctrl.tagging.isActivated) {
	        if(!_handleDropDownSelection(key) && !ctrl.searchEnabled) {
	          e.preventDefault();
	          e.stopPropagation();
	        }
	        if ( ctrl.taggingTokens.isActivated ) {
	          for (var i = 0; i < ctrl.taggingTokens.tokens.length; i++) {
	            if ( ctrl.taggingTokens.tokens[i] === KEY.MAP[e.keyCode] ) {
	              // make sure there is a new value to push via tagging
	              if ( ctrl.search.length > 0 ) {
	                tagged = true;
	              }
	            }
	          }
	          if ( tagged ) {
	            $timeout(function() {
	              ctrl.searchInput.triggerHandler('tagged');
	              var newItem = ctrl.search.replace(KEY.MAP[e.keyCode],'').trim();
	              if ( ctrl.tagging.fct ) {
	                newItem = ctrl.tagging.fct( newItem );
	              }
	              if (newItem) ctrl.select(newItem, true);
	            });
	          }
	        }
	      }
	
	    });
	
	    if(KEY.isVerticalMovement(key) && ctrl.items.length > 0){
	      _ensureHighlightVisible();
	    }
	
	    if (key === KEY.ENTER || key === KEY.ESC) {
	      e.preventDefault();
	      e.stopPropagation();
	    }
	
	  });
	
	  ctrl.searchInput.on('paste', function (e) {
	    var data;
	
	    if (window.clipboardData && window.clipboardData.getData) { // IE
	      data = window.clipboardData.getData('Text');
	    } else {
	      data = (e.originalEvent || e).clipboardData.getData('text/plain');
	    }
	
	    // Prepend the current input field text to the paste buffer.
	    data = ctrl.search + data;
	
	    if (data && data.length > 0) {
	      // If tagging try to split by tokens and add items
	      if (ctrl.taggingTokens.isActivated) {
	        var items = [];
	        for (var i = 0; i < ctrl.taggingTokens.tokens.length; i++) {  // split by first token that is contained in data
	          var separator = KEY.toSeparator(ctrl.taggingTokens.tokens[i]) || ctrl.taggingTokens.tokens[i];
	          if (data.indexOf(separator) > -1) {
	            items = data.split(separator);
	            break;  // only split by one token
	          }
	        }
	        if (items.length === 0) {
	          items = [data];
	        }
	        var oldsearch = ctrl.search;
	        angular.forEach(items, function (item) {
	          var newItem = ctrl.tagging.fct ? ctrl.tagging.fct(item) : item;
	          if (newItem) {
	            ctrl.select(newItem, true);
	          }
	        });
	        ctrl.search = oldsearch || EMPTY_SEARCH;
	        e.preventDefault();
	        e.stopPropagation();
	      } else if (ctrl.paste) {
	        ctrl.paste(data);
	        ctrl.search = EMPTY_SEARCH;
	        e.preventDefault();
	        e.stopPropagation();
	      }
	    }
	  });
	
	  ctrl.searchInput.on('tagged', function() {
	    $timeout(function() {
	      _resetSearchInput();
	    });
	  });
	
	  // See https://github.com/ivaynberg/select2/blob/3.4.6/select2.js#L1431
	  function _ensureHighlightVisible() {
	    var container = $element.querySelectorAll('.ui-select-choices-content');
	    var choices = container.querySelectorAll('.ui-select-choices-row');
	    if (choices.length < 1) {
	      throw uiSelectMinErr('choices', "Expected multiple .ui-select-choices-row but got '{0}'.", choices.length);
	    }
	
	    if (ctrl.activeIndex < 0) {
	      return;
	    }
	
	    var highlighted = choices[ctrl.activeIndex];
	    var posY = highlighted.offsetTop + highlighted.clientHeight - container[0].scrollTop;
	    var height = container[0].offsetHeight;
	
	    if (posY > height) {
	      container[0].scrollTop += posY - height;
	    } else if (posY < highlighted.clientHeight) {
	      if (ctrl.isGrouped && ctrl.activeIndex === 0)
	        container[0].scrollTop = 0; //To make group header visible when going all the way up
	      else
	        container[0].scrollTop -= highlighted.clientHeight - posY;
	    }
	  }
	
	  var onResize = $$uisDebounce(function() {
	    ctrl.sizeSearchInput();
	  }, 50);
	
	  angular.element($window).bind('resize', onResize);
	
	  $scope.$on('$destroy', function() {
	    ctrl.searchInput.off('keyup keydown tagged blur paste');
	    angular.element($window).off('resize', onResize);
	  });
	
	  $scope.$watch('$select.activeIndex', function(activeIndex) {
	    if (activeIndex)
	      $element.find('input').attr(
	        'aria-activedescendant',
	        'ui-select-choices-row-' + ctrl.generatedId + '-' + activeIndex);
	  });
	
	  $scope.$watch('$select.open', function(open) {
	    if (!open)
	      $element.find('input').removeAttr('aria-activedescendant');
	  });
	}]);
	
	uis.directive('uiSelect',
	  ['$document', 'uiSelectConfig', 'uiSelectMinErr', 'uisOffset', '$compile', '$parse', '$timeout',
	  function($document, uiSelectConfig, uiSelectMinErr, uisOffset, $compile, $parse, $timeout) {
	
	  return {
	    restrict: 'EA',
	    templateUrl: function(tElement, tAttrs) {
	      var theme = tAttrs.theme || uiSelectConfig.theme;
	      return theme + (angular.isDefined(tAttrs.multiple) ? '/select-multiple.tpl.html' : '/select.tpl.html');
	    },
	    replace: true,
	    transclude: true,
	    require: ['uiSelect', '^ngModel'],
	    scope: true,
	
	    controller: 'uiSelectCtrl',
	    controllerAs: '$select',
	    compile: function(tElement, tAttrs) {
	
	      // Allow setting ngClass on uiSelect
	      var match = /{(.*)}\s*{(.*)}/.exec(tAttrs.ngClass);
	      if(match) {
	        var combined = '{'+ match[1] +', '+ match[2] +'}';
	        tAttrs.ngClass = combined;
	        tElement.attr('ng-class', combined);
	      }
	
	      //Multiple or Single depending if multiple attribute presence
	      if (angular.isDefined(tAttrs.multiple))
	        tElement.append('<ui-select-multiple/>').removeAttr('multiple');
	      else
	        tElement.append('<ui-select-single/>');
	
	      if (tAttrs.inputId)
	        tElement.querySelectorAll('input.ui-select-search')[0].id = tAttrs.inputId;
	
	      return function(scope, element, attrs, ctrls, transcludeFn) {
	
	        var $select = ctrls[0];
	        var ngModel = ctrls[1];
	
	        $select.generatedId = uiSelectConfig.generateId();
	        $select.baseTitle = attrs.title || 'Select box';
	        $select.focusserTitle = $select.baseTitle + ' focus';
	        $select.focusserId = 'focusser-' + $select.generatedId;
	
	        $select.closeOnSelect = function() {
	          if (angular.isDefined(attrs.closeOnSelect)) {
	            return $parse(attrs.closeOnSelect)();
	          } else {
	            return uiSelectConfig.closeOnSelect;
	          }
	        }();
	
	        scope.$watch('skipFocusser', function() {
	            var skipFocusser = scope.$eval(attrs.skipFocusser);
	            $select.skipFocusser = skipFocusser !== undefined ? skipFocusser : uiSelectConfig.skipFocusser;
	        });
	
	        $select.onSelectCallback = $parse(attrs.onSelect);
	        $select.onRemoveCallback = $parse(attrs.onRemove);
	
	        //Set reference to ngModel from uiSelectCtrl
	        $select.ngModel = ngModel;
	
	        $select.choiceGrouped = function(group){
	          return $select.isGrouped && group && group.name;
	        };
	
	        if(attrs.tabindex){
	          attrs.$observe('tabindex', function(value) {
	            $select.focusInput.attr('tabindex', value);
	            element.removeAttr('tabindex');
	          });
	        }
	
	        scope.$watch(function () { return scope.$eval(attrs.searchEnabled); }, function(newVal) {
	          $select.searchEnabled = newVal !== undefined ? newVal : uiSelectConfig.searchEnabled;
	        });
	
	        scope.$watch('sortable', function() {
	            var sortable = scope.$eval(attrs.sortable);
	            $select.sortable = sortable !== undefined ? sortable : uiSelectConfig.sortable;
	        });
	
	        attrs.$observe('backspaceReset', function() {
	          // $eval() is needed otherwise we get a string instead of a boolean
	          var backspaceReset = scope.$eval(attrs.backspaceReset);
	          $select.backspaceReset = backspaceReset !== undefined ? backspaceReset : true;
	        });
	
	        attrs.$observe('limit', function() {
	          //Limit the number of selections allowed
	          $select.limit = (angular.isDefined(attrs.limit)) ? parseInt(attrs.limit, 10) : undefined;
	        });
	
	        scope.$watch('removeSelected', function() {
	            var removeSelected = scope.$eval(attrs.removeSelected);
	            $select.removeSelected = removeSelected !== undefined ? removeSelected : uiSelectConfig.removeSelected;
	        });
	
	        attrs.$observe('disabled', function() {
	          // No need to use $eval() (thanks to ng-disabled) since we already get a boolean instead of a string
	          $select.disabled = attrs.disabled !== undefined ? attrs.disabled : false;
	        });
	
	        attrs.$observe('resetSearchInput', function() {
	          // $eval() is needed otherwise we get a string instead of a boolean
	          var resetSearchInput = scope.$eval(attrs.resetSearchInput);
	          $select.resetSearchInput = resetSearchInput !== undefined ? resetSearchInput : true;
	        });
	
	        attrs.$observe('paste', function() {
	          $select.paste = scope.$eval(attrs.paste);
	        });
	
	        attrs.$observe('tagging', function() {
	          if(attrs.tagging !== undefined)
	          {
	            // $eval() is needed otherwise we get a string instead of a boolean
	            var taggingEval = scope.$eval(attrs.tagging);
	            $select.tagging = {isActivated: true, fct: taggingEval !== true ? taggingEval : undefined};
	          }
	          else
	          {
	            $select.tagging = {isActivated: false, fct: undefined};
	          }
	        });
	
	        attrs.$observe('taggingLabel', function() {
	          if(attrs.tagging !== undefined )
	          {
	            // check eval for FALSE, in this case, we disable the labels
	            // associated with tagging
	            if ( attrs.taggingLabel === 'false' ) {
	              $select.taggingLabel = false;
	            }
	            else
	            {
	              $select.taggingLabel = attrs.taggingLabel !== undefined ? attrs.taggingLabel : '(new)';
	            }
	          }
	        });
	
	        attrs.$observe('taggingTokens', function() {
	          if (attrs.tagging !== undefined) {
	            var tokens = attrs.taggingTokens !== undefined ? attrs.taggingTokens.split('|') : [',','ENTER'];
	            $select.taggingTokens = {isActivated: true, tokens: tokens };
	          }
	        });
	
	        attrs.$observe('spinnerEnabled', function() {
	          // $eval() is needed otherwise we get a string instead of a boolean
	          var spinnerEnabled = scope.$eval(attrs.spinnerEnabled);
	          $select.spinnerEnabled = spinnerEnabled !== undefined ? spinnerEnabled : uiSelectConfig.spinnerEnabled;
	        });
	
	        attrs.$observe('spinnerClass', function() {
	          var spinnerClass = attrs.spinnerClass;
	          $select.spinnerClass = spinnerClass !== undefined ? attrs.spinnerClass : uiSelectConfig.spinnerClass;
	        });
	
	        //Automatically gets focus when loaded
	        if (angular.isDefined(attrs.autofocus)){
	          $timeout(function(){
	            $select.setFocus();
	          });
	        }
	
	        //Gets focus based on scope event name (e.g. focus-on='SomeEventName')
	        if (angular.isDefined(attrs.focusOn)){
	          scope.$on(attrs.focusOn, function() {
	              $timeout(function(){
	                $select.setFocus();
	              });
	          });
	        }
	
	        function onDocumentClick(e) {
	          if (!$select.open) return; //Skip it if dropdown is close
	
	          var contains = false;
	
	          if (window.jQuery) {
	            // Firefox 3.6 does not support element.contains()
	            // See Node.contains https://developer.mozilla.org/en-US/docs/Web/API/Node.contains
	            contains = window.jQuery.contains(element[0], e.target);
	          } else {
	            contains = element[0].contains(e.target);
	          }
	
	          if (!contains && !$select.clickTriggeredSelect) {
	            var skipFocusser;
	            if (!$select.skipFocusser) {
	              //Will lose focus only with certain targets
	              var focusableControls = ['input','button','textarea','select'];
	              var targetController = angular.element(e.target).controller('uiSelect'); //To check if target is other ui-select
	              skipFocusser = targetController && targetController !== $select; //To check if target is other ui-select
	              if (!skipFocusser) skipFocusser =  ~focusableControls.indexOf(e.target.tagName.toLowerCase()); //Check if target is input, button or textarea
	            } else {
	              skipFocusser = true;
	            }
	            $select.close(skipFocusser);
	            scope.$digest();
	          }
	          $select.clickTriggeredSelect = false;
	        }
	
	        // See Click everywhere but here event http://stackoverflow.com/questions/12931369
	        $document.on('click', onDocumentClick);
	
	        scope.$on('$destroy', function() {
	          $document.off('click', onDocumentClick);
	        });
	
	        // Move transcluded elements to their correct position in main template
	        transcludeFn(scope, function(clone) {
	          // See Transclude in AngularJS http://blog.omkarpatil.com/2012/11/transclude-in-angularjs.html
	
	          // One day jqLite will be replaced by jQuery and we will be able to write:
	          // var transcludedElement = clone.filter('.my-class')
	          // instead of creating a hackish DOM element:
	          var transcluded = angular.element('<div>').append(clone);
	
	          var transcludedMatch = transcluded.querySelectorAll('.ui-select-match');
	          transcludedMatch.removeAttr('ui-select-match'); //To avoid loop in case directive as attr
	          transcludedMatch.removeAttr('data-ui-select-match'); // Properly handle HTML5 data-attributes
	          if (transcludedMatch.length !== 1) {
	            throw uiSelectMinErr('transcluded', "Expected 1 .ui-select-match but got '{0}'.", transcludedMatch.length);
	          }
	          element.querySelectorAll('.ui-select-match').replaceWith(transcludedMatch);
	
	          var transcludedChoices = transcluded.querySelectorAll('.ui-select-choices');
	          transcludedChoices.removeAttr('ui-select-choices'); //To avoid loop in case directive as attr
	          transcludedChoices.removeAttr('data-ui-select-choices'); // Properly handle HTML5 data-attributes
	          if (transcludedChoices.length !== 1) {
	            throw uiSelectMinErr('transcluded', "Expected 1 .ui-select-choices but got '{0}'.", transcludedChoices.length);
	          }
	          element.querySelectorAll('.ui-select-choices').replaceWith(transcludedChoices);
	
	          var transcludedNoChoice = transcluded.querySelectorAll('.ui-select-no-choice');
	          transcludedNoChoice.removeAttr('ui-select-no-choice'); //To avoid loop in case directive as attr
	          transcludedNoChoice.removeAttr('data-ui-select-no-choice'); // Properly handle HTML5 data-attributes
	          if (transcludedNoChoice.length == 1) {
	            element.querySelectorAll('.ui-select-no-choice').replaceWith(transcludedNoChoice);
	          }
	        });
	
	        // Support for appending the select field to the body when its open
	        var appendToBody = scope.$eval(attrs.appendToBody);
	        if (appendToBody !== undefined ? appendToBody : uiSelectConfig.appendToBody) {
	          scope.$watch('$select.open', function(isOpen) {
	            if (isOpen) {
	              positionDropdown();
	            } else {
	              resetDropdown();
	            }
	          });
	
	          // Move the dropdown back to its original location when the scope is destroyed. Otherwise
	          // it might stick around when the user routes away or the select field is otherwise removed
	          scope.$on('$destroy', function() {
	            resetDropdown();
	          });
	        }
	
	        // Hold on to a reference to the .ui-select-container element for appendToBody support
	        var placeholder = null,
	            originalWidth = '';
	
	        function positionDropdown() {
	          // Remember the absolute position of the element
	          var offset = uisOffset(element);
	
	          // Clone the element into a placeholder element to take its original place in the DOM
	          placeholder = angular.element('<div class="ui-select-placeholder"></div>');
	          placeholder[0].style.width = offset.width + 'px';
	          placeholder[0].style.height = offset.height + 'px';
	          element.after(placeholder);
	
	          // Remember the original value of the element width inline style, so it can be restored
	          // when the dropdown is closed
	          originalWidth = element[0].style.width;
	
	          // Now move the actual dropdown element to the end of the body
	          $document.find('body').append(element);
	
	          element[0].style.position = 'absolute';
	          element[0].style.left = offset.left + 'px';
	          element[0].style.top = offset.top + 'px';
	          element[0].style.width = offset.width + 'px';
	        }
	
	        function resetDropdown() {
	          if (placeholder === null) {
	            // The dropdown has not actually been display yet, so there's nothing to reset
	            return;
	          }
	
	          // Move the dropdown element back to its original location in the DOM
	          placeholder.replaceWith(element);
	          placeholder = null;
	
	          element[0].style.position = '';
	          element[0].style.left = '';
	          element[0].style.top = '';
	          element[0].style.width = originalWidth;
	
	          // Set focus back on to the moved element
	          $select.setFocus();
	        }
	
	        // Hold on to a reference to the .ui-select-dropdown element for direction support.
	        var dropdown = null,
	            directionUpClassName = 'direction-up';
	
	        // Support changing the direction of the dropdown if there isn't enough space to render it.
	        scope.$watch('$select.open', function() {
	
	          if ($select.dropdownPosition === 'auto' || $select.dropdownPosition === 'up'){
	            scope.calculateDropdownPos();
	          }
	
	        });
	
	        var setDropdownPosUp = function(offset, offsetDropdown){
	
	          offset = offset || uisOffset(element);
	          offsetDropdown = offsetDropdown || uisOffset(dropdown);
	
	          dropdown[0].style.position = 'absolute';
	          dropdown[0].style.top = (offsetDropdown.height * -1) + 'px';
	          element.addClass(directionUpClassName);
	
	        };
	
	        var setDropdownPosDown = function(offset, offsetDropdown){
	
	          element.removeClass(directionUpClassName);
	
	          offset = offset || uisOffset(element);
	          offsetDropdown = offsetDropdown || uisOffset(dropdown);
	
	          dropdown[0].style.position = '';
	          dropdown[0].style.top = '';
	
	        };
	
	        var calculateDropdownPosAfterAnimation = function() {
	          // Delay positioning the dropdown until all choices have been added so its height is correct.
	          $timeout(function() {
	            if ($select.dropdownPosition === 'up') {
	              //Go UP
	              setDropdownPosUp();
	            } else {
	              //AUTO
	              element.removeClass(directionUpClassName);
	
	              var offset = uisOffset(element);
	              var offsetDropdown = uisOffset(dropdown);
	
	              //https://code.google.com/p/chromium/issues/detail?id=342307#c4
	              var scrollTop = $document[0].documentElement.scrollTop || $document[0].body.scrollTop; //To make it cross browser (blink, webkit, IE, Firefox).
	
	              // Determine if the direction of the dropdown needs to be changed.
	              if (offset.top + offset.height + offsetDropdown.height > scrollTop + $document[0].documentElement.clientHeight) {
	                //Go UP
	                setDropdownPosUp(offset, offsetDropdown);
	              }else{
	                //Go DOWN
	                setDropdownPosDown(offset, offsetDropdown);
	              }
	            }
	
	            // Display the dropdown once it has been positioned.
	            dropdown[0].style.opacity = 1;
	          });
	        };
	
	        var opened = false;
	        
	        scope.calculateDropdownPos = function() {
	          if ($select.open) {
	            dropdown = angular.element(element).querySelectorAll('.ui-select-dropdown');
	
	            if (dropdown.length === 0) {
	              return;
	            }
	
	           // Hide the dropdown so there is no flicker until $timeout is done executing.
	           if ($select.search === '' && !opened) {
	              dropdown[0].style.opacity = 0;
	              opened = true;
	           }
	
	            if (!uisOffset(dropdown).height && $select.$animate && $select.$animate.on && $select.$animate.enabled(dropdown)) {
	              var needsCalculated = true;
	
	              $select.$animate.on('enter', dropdown, function (elem, phase) {
	                if (phase === 'close' && needsCalculated) {
	                  calculateDropdownPosAfterAnimation();
	                  needsCalculated = false;
	                }
	              });
	            } else {
	              calculateDropdownPosAfterAnimation();
	            }
	          } else {
	            if (dropdown === null || dropdown.length === 0) {
	              return;
	            }
	
	            // Reset the position of the dropdown.
	            dropdown[0].style.opacity = 0;
	            dropdown[0].style.position = '';
	            dropdown[0].style.top = '';
	            element.removeClass(directionUpClassName);
	          }
	        };
	      };
	    }
	  };
	}]);
	
	uis.directive('uiSelectMatch', ['uiSelectConfig', function(uiSelectConfig) {
	  return {
	    restrict: 'EA',
	    require: '^uiSelect',
	    replace: true,
	    transclude: true,
	    templateUrl: function(tElement) {
	      // Needed so the uiSelect can detect the transcluded content
	      tElement.addClass('ui-select-match');
	
	      var parent = tElement.parent();
	      // Gets theme attribute from parent (ui-select)
	      var theme = getAttribute(parent, 'theme') || uiSelectConfig.theme;
	      var multi = angular.isDefined(getAttribute(parent, 'multiple'));
	
	      return theme + (multi ? '/match-multiple.tpl.html' : '/match.tpl.html');      
	    },
	    link: function(scope, element, attrs, $select) {
	      $select.lockChoiceExpression = attrs.uiLockChoice;
	      attrs.$observe('placeholder', function(placeholder) {
	        $select.placeholder = placeholder !== undefined ? placeholder : uiSelectConfig.placeholder;
	      });
	
	      function setAllowClear(allow) {
	        $select.allowClear = (angular.isDefined(allow)) ? (allow === '') ? true : (allow.toLowerCase() === 'true') : false;
	      }
	
	      attrs.$observe('allowClear', setAllowClear);
	      setAllowClear(attrs.allowClear);
	
	      if($select.multiple){
	        $select.sizeSearchInput();
	      }
	
	    }
	  };
	
	  function getAttribute(elem, attribute) {
	    if (elem[0].hasAttribute(attribute))
	      return elem.attr(attribute);
	
	    if (elem[0].hasAttribute('data-' + attribute))
	      return elem.attr('data-' + attribute);
	
	    if (elem[0].hasAttribute('x-' + attribute))
	      return elem.attr('x-' + attribute);
	  }
	}]);
	
	uis.directive('uiSelectMultiple', ['uiSelectMinErr','$timeout', function(uiSelectMinErr, $timeout) {
	  return {
	    restrict: 'EA',
	    require: ['^uiSelect', '^ngModel'],
	
	    controller: ['$scope','$timeout', function($scope, $timeout){
	
	      var ctrl = this,
	          $select = $scope.$select,
	          ngModel;
	
	      if (angular.isUndefined($select.selected))
	        $select.selected = [];
	
	      //Wait for link fn to inject it
	      $scope.$evalAsync(function(){ ngModel = $scope.ngModel; });
	
	      ctrl.activeMatchIndex = -1;
	
	      ctrl.updateModel = function(){
	        ngModel.$setViewValue(Date.now()); //Set timestamp as a unique string to force changes
	        ctrl.refreshComponent();
	      };
	
	      ctrl.refreshComponent = function(){
	        //Remove already selected items
	        //e.g. When user clicks on a selection, the selected array changes and
	        //the dropdown should remove that item
	        if($select.refreshItems){
	          $select.refreshItems();
	        }
	        if($select.sizeSearchInput){
	          $select.sizeSearchInput();
	        }
	      };
	
	      // Remove item from multiple select
	      ctrl.removeChoice = function(index){
	
	        // if the choice is locked, don't remove it
	        if($select.isLocked(null, index)) return false;
	
	        var removedChoice = $select.selected[index];
	
	        var locals = {};
	        locals[$select.parserResult.itemName] = removedChoice;
	
	        $select.selected.splice(index, 1);
	        ctrl.activeMatchIndex = -1;
	        $select.sizeSearchInput();
	
	        // Give some time for scope propagation.
	        $timeout(function(){
	          $select.onRemoveCallback($scope, {
	            $item: removedChoice,
	            $model: $select.parserResult.modelMapper($scope, locals)
	          });
	        });
	
	        ctrl.updateModel();
	
	        return true;
	      };
	
	      ctrl.getPlaceholder = function(){
	        //Refactor single?
	        if($select.selected && $select.selected.length) return;
	        return $select.placeholder;
	      };
	
	
	    }],
	    controllerAs: '$selectMultiple',
	
	    link: function(scope, element, attrs, ctrls) {
	
	      var $select = ctrls[0];
	      var ngModel = scope.ngModel = ctrls[1];
	      var $selectMultiple = scope.$selectMultiple;
	
	      //$select.selected = raw selected objects (ignoring any property binding)
	
	      $select.multiple = true;
	
	      //Input that will handle focus
	      $select.focusInput = $select.searchInput;
	
	      //Properly check for empty if set to multiple
	      ngModel.$isEmpty = function(value) {
	        return !value || value.length === 0;
	      };
	
	      //From view --> model
	      ngModel.$parsers.unshift(function () {
	        var locals = {},
	            result,
	            resultMultiple = [];
	        for (var j = $select.selected.length - 1; j >= 0; j--) {
	          locals = {};
	          locals[$select.parserResult.itemName] = $select.selected[j];
	          result = $select.parserResult.modelMapper(scope, locals);
	          resultMultiple.unshift(result);
	        }
	        return resultMultiple;
	      });
	
	      // From model --> view
	      ngModel.$formatters.unshift(function (inputValue) {
	        var data = $select.parserResult && $select.parserResult.source (scope, { $select : {search:''}}), //Overwrite $search
	            locals = {},
	            result;
	        if (!data) return inputValue;
	        var resultMultiple = [];
	        var checkFnMultiple = function(list, value){
	          if (!list || !list.length) return;
	          for (var p = list.length - 1; p >= 0; p--) {
	            locals[$select.parserResult.itemName] = list[p];
	            result = $select.parserResult.modelMapper(scope, locals);
	            if($select.parserResult.trackByExp){
	                var propsItemNameMatches = /(\w*)\./.exec($select.parserResult.trackByExp);
	                var matches = /\.([^\s]+)/.exec($select.parserResult.trackByExp);
	                if(propsItemNameMatches && propsItemNameMatches.length > 0 && propsItemNameMatches[1] == $select.parserResult.itemName){
	                  if(matches && matches.length>0 && result[matches[1]] == value[matches[1]]){
	                      resultMultiple.unshift(list[p]);
	                      return true;
	                  }
	                }
	            }
	            if (angular.equals(result,value)){
	              resultMultiple.unshift(list[p]);
	              return true;
	            }
	          }
	          return false;
	        };
	        if (!inputValue) return resultMultiple; //If ngModel was undefined
	        for (var k = inputValue.length - 1; k >= 0; k--) {
	          //Check model array of currently selected items
	          if (!checkFnMultiple($select.selected, inputValue[k])){
	            //Check model array of all items available
	            if (!checkFnMultiple(data, inputValue[k])){
	              //If not found on previous lists, just add it directly to resultMultiple
	              resultMultiple.unshift(inputValue[k]);
	            }
	          }
	        }
	        return resultMultiple;
	      });
	
	      //Watch for external model changes
	      scope.$watchCollection(function(){ return ngModel.$modelValue; }, function(newValue, oldValue) {
	        if (oldValue != newValue){
	          //update the view value with fresh data from items, if there is a valid model value
	          if(angular.isDefined(ngModel.$modelValue)) {
	            ngModel.$modelValue = null; //Force scope model value and ngModel value to be out of sync to re-run formatters
	          }
	          $selectMultiple.refreshComponent();
	        }
	      });
	
	      ngModel.$render = function() {
	        // Make sure that model value is array
	        if(!angular.isArray(ngModel.$viewValue)){
	          // Have tolerance for null or undefined values
	          if (isNil(ngModel.$viewValue)){
	            ngModel.$viewValue = [];
	          } else {
	            throw uiSelectMinErr('multiarr', "Expected model value to be array but got '{0}'", ngModel.$viewValue);
	          }
	        }
	        $select.selected = ngModel.$viewValue;
	        $selectMultiple.refreshComponent();
	        scope.$evalAsync(); //To force $digest
	      };
	
	      scope.$on('uis:select', function (event, item) {
	        if($select.selected.length >= $select.limit) {
	          return;
	        }
	        $select.selected.push(item);
	        var locals = {};
	        locals[$select.parserResult.itemName] = item;
	
	        $timeout(function(){
	          $select.onSelectCallback(scope, {
	            $item: item,
	            $model: $select.parserResult.modelMapper(scope, locals)
	          });
	        });
	        $selectMultiple.updateModel();
	      });
	
	      scope.$on('uis:activate', function () {
	        $selectMultiple.activeMatchIndex = -1;
	      });
	
	      scope.$watch('$select.disabled', function(newValue, oldValue) {
	        // As the search input field may now become visible, it may be necessary to recompute its size
	        if (oldValue && !newValue) $select.sizeSearchInput();
	      });
	
	      $select.searchInput.on('keydown', function(e) {
	        var key = e.which;
	        scope.$apply(function() {
	          var processed = false;
	          // var tagged = false; //Checkme
	          if(KEY.isHorizontalMovement(key)){
	            processed = _handleMatchSelection(key);
	          }
	          if (processed  && key != KEY.TAB) {
	            //TODO Check si el tab selecciona aun correctamente
	            //Crear test
	            e.preventDefault();
	            e.stopPropagation();
	          }
	        });
	      });
	      function _getCaretPosition(el) {
	        if(angular.isNumber(el.selectionStart)) return el.selectionStart;
	        // selectionStart is not supported in IE8 and we don't want hacky workarounds so we compromise
	        else return el.value.length;
	      }
	      // Handles selected options in "multiple" mode
	      function _handleMatchSelection(key){
	        var caretPosition = _getCaretPosition($select.searchInput[0]),
	            length = $select.selected.length,
	            // none  = -1,
	            first = 0,
	            last  = length-1,
	            curr  = $selectMultiple.activeMatchIndex,
	            next  = $selectMultiple.activeMatchIndex+1,
	            prev  = $selectMultiple.activeMatchIndex-1,
	            newIndex = curr;
	
	        if(caretPosition > 0 || ($select.search.length && key == KEY.RIGHT)) return false;
	
	        $select.close();
	
	        function getNewActiveMatchIndex(){
	          switch(key){
	            case KEY.LEFT:
	              // Select previous/first item
	              if(~$selectMultiple.activeMatchIndex) return prev;
	              // Select last item
	              else return last;
	              break;
	            case KEY.RIGHT:
	              // Open drop-down
	              if(!~$selectMultiple.activeMatchIndex || curr === last){
	                $select.activate();
	                return false;
	              }
	              // Select next/last item
	              else return next;
	              break;
	            case KEY.BACKSPACE:
	              // Remove selected item and select previous/first
	              if(~$selectMultiple.activeMatchIndex){
	                if($selectMultiple.removeChoice(curr)) {
	                  return prev;
	                } else {
	                  return curr;
	                }
	
	              } else {
	                // If nothing yet selected, select last item
	                return last;
	              }
	              break;
	            case KEY.DELETE:
	              // Remove selected item and select next item
	              if(~$selectMultiple.activeMatchIndex){
	                $selectMultiple.removeChoice($selectMultiple.activeMatchIndex);
	                return curr;
	              }
	              else return false;
	          }
	        }
	
	        newIndex = getNewActiveMatchIndex();
	
	        if(!$select.selected.length || newIndex === false) $selectMultiple.activeMatchIndex = -1;
	        else $selectMultiple.activeMatchIndex = Math.min(last,Math.max(first,newIndex));
	
	        return true;
	      }
	
	      $select.searchInput.on('keyup', function(e) {
	
	        if ( ! KEY.isVerticalMovement(e.which) ) {
	          scope.$evalAsync( function () {
	            $select.activeIndex = $select.taggingLabel === false ? -1 : 0;
	          });
	        }
	        // Push a "create new" item into array if there is a search string
	        if ( $select.tagging.isActivated && $select.search.length > 0 ) {
	
	          // return early with these keys
	          if (e.which === KEY.TAB || KEY.isControl(e) || KEY.isFunctionKey(e) || e.which === KEY.ESC || KEY.isVerticalMovement(e.which) ) {
	            return;
	          }
	          // always reset the activeIndex to the first item when tagging
	          $select.activeIndex = $select.taggingLabel === false ? -1 : 0;
	          // taggingLabel === false bypasses all of this
	          if ($select.taggingLabel === false) return;
	
	          var items = angular.copy( $select.items );
	          var stashArr = angular.copy( $select.items );
	          var newItem;
	          var item;
	          var hasTag = false;
	          var dupeIndex = -1;
	          var tagItems;
	          var tagItem;
	
	          // case for object tagging via transform `$select.tagging.fct` function
	          if ( $select.tagging.fct !== undefined) {
	            tagItems = $select.$filter('filter')(items,{'isTag': true});
	            if ( tagItems.length > 0 ) {
	              tagItem = tagItems[0];
	            }
	            // remove the first element, if it has the `isTag` prop we generate a new one with each keyup, shaving the previous
	            if ( items.length > 0 && tagItem ) {
	              hasTag = true;
	              items = items.slice(1,items.length);
	              stashArr = stashArr.slice(1,stashArr.length);
	            }
	            newItem = $select.tagging.fct($select.search);
	            // verify the new tag doesn't match the value of a possible selection choice or an already selected item.
	            if (
	              stashArr.some(function (origItem) {
	                 return angular.equals(origItem, newItem);
	              }) ||
	              $select.selected.some(function (origItem) {
	                return angular.equals(origItem, newItem);
	              })
	            ) {
	              scope.$evalAsync(function () {
	                $select.activeIndex = 0;
	                $select.items = items;
	              });
	              return;
	            }
	            if (newItem) newItem.isTag = true;
	          // handle newItem string and stripping dupes in tagging string context
	          } else {
	            // find any tagging items already in the $select.items array and store them
	            tagItems = $select.$filter('filter')(items,function (item) {
	              return item.match($select.taggingLabel);
	            });
	            if ( tagItems.length > 0 ) {
	              tagItem = tagItems[0];
	            }
	            item = items[0];
	            // remove existing tag item if found (should only ever be one tag item)
	            if ( item !== undefined && items.length > 0 && tagItem ) {
	              hasTag = true;
	              items = items.slice(1,items.length);
	              stashArr = stashArr.slice(1,stashArr.length);
	            }
	            newItem = $select.search+' '+$select.taggingLabel;
	            if ( _findApproxDupe($select.selected, $select.search) > -1 ) {
	              return;
	            }
	            // verify the the tag doesn't match the value of an existing item from
	            // the searched data set or the items already selected
	            if ( _findCaseInsensitiveDupe(stashArr.concat($select.selected)) ) {
	              // if there is a tag from prev iteration, strip it / queue the change
	              // and return early
	              if ( hasTag ) {
	                items = stashArr;
	                scope.$evalAsync( function () {
	                  $select.activeIndex = 0;
	                  $select.items = items;
	                });
	              }
	              return;
	            }
	            if ( _findCaseInsensitiveDupe(stashArr) ) {
	              // if there is a tag from prev iteration, strip it
	              if ( hasTag ) {
	                $select.items = stashArr.slice(1,stashArr.length);
	              }
	              return;
	            }
	          }
	          if ( hasTag ) dupeIndex = _findApproxDupe($select.selected, newItem);
	          // dupe found, shave the first item
	          if ( dupeIndex > -1 ) {
	            items = items.slice(dupeIndex+1,items.length-1);
	          } else {
	            items = [];
	            if (newItem) items.push(newItem);
	            items = items.concat(stashArr);
	          }
	          scope.$evalAsync( function () {
	            $select.activeIndex = 0;
	            $select.items = items;
	
	            if ($select.isGrouped) {
	              // update item references in groups, so that indexOf will work after angular.copy
	              var itemsWithoutTag = newItem ? items.slice(1) : items;
	              $select.setItemsFn(itemsWithoutTag);
	              if (newItem) {
	                // add tag item as a new group
	                $select.items.unshift(newItem);
	                $select.groups.unshift({name: '', items: [newItem], tagging: true});
	              }
	            }
	          });
	        }
	      });
	      function _findCaseInsensitiveDupe(arr) {
	        if ( arr === undefined || $select.search === undefined ) {
	          return false;
	        }
	        var hasDupe = arr.filter( function (origItem) {
	          if ( $select.search.toUpperCase() === undefined || origItem === undefined ) {
	            return false;
	          }
	          return origItem.toUpperCase() === $select.search.toUpperCase();
	        }).length > 0;
	
	        return hasDupe;
	      }
	      function _findApproxDupe(haystack, needle) {
	        var dupeIndex = -1;
	        if(angular.isArray(haystack)) {
	          var tempArr = angular.copy(haystack);
	          for (var i = 0; i <tempArr.length; i++) {
	            // handle the simple string version of tagging
	            if ( $select.tagging.fct === undefined ) {
	              // search the array for the match
	              if ( tempArr[i]+' '+$select.taggingLabel === needle ) {
	              dupeIndex = i;
	              }
	            // handle the object tagging implementation
	            } else {
	              var mockObj = tempArr[i];
	              if (angular.isObject(mockObj)) {
	                mockObj.isTag = true;
	              }
	              if ( angular.equals(mockObj, needle) ) {
	                dupeIndex = i;
	              }
	            }
	          }
	        }
	        return dupeIndex;
	      }
	
	      $select.searchInput.on('blur', function() {
	        $timeout(function() {
	          $selectMultiple.activeMatchIndex = -1;
	        });
	      });
	
	    }
	  };
	}]);
	
	uis.directive('uiSelectNoChoice',
	    ['uiSelectConfig', function (uiSelectConfig) {
	        return {
	            restrict: 'EA',
	            require: '^uiSelect',
	            replace: true,
	            transclude: true,
	            templateUrl: function (tElement) {
	                // Needed so the uiSelect can detect the transcluded content
	                tElement.addClass('ui-select-no-choice');
	      
	                // Gets theme attribute from parent (ui-select)
	                var theme = tElement.parent().attr('theme') || uiSelectConfig.theme;
	                return theme + '/no-choice.tpl.html';
	            }
	        };
	    }]);
	
	uis.directive('uiSelectSingle', ['$timeout','$compile', function($timeout, $compile) {
	  return {
	    restrict: 'EA',
	    require: ['^uiSelect', '^ngModel'],
	    link: function(scope, element, attrs, ctrls) {
	
	      var $select = ctrls[0];
	      var ngModel = ctrls[1];
	
	      //From view --> model
	      ngModel.$parsers.unshift(function (inputValue) {
	        // Keep original value for undefined and null
	        if (isNil(inputValue)) {
	          return inputValue;
	        }
	
	        var locals = {},
	            result;
	        locals[$select.parserResult.itemName] = inputValue;
	        result = $select.parserResult.modelMapper(scope, locals);
	        return result;
	      });
	
	      //From model --> view
	      ngModel.$formatters.unshift(function (inputValue) {
	        // Keep original value for undefined and null
	        if (isNil(inputValue)) {
	          return inputValue;
	        }
	
	        var data = $select.parserResult && $select.parserResult.source (scope, { $select : {search:''}}), //Overwrite $search
	            locals = {},
	            result;
	        if (data){
	          var checkFnSingle = function(d){
	            locals[$select.parserResult.itemName] = d;
	            result = $select.parserResult.modelMapper(scope, locals);
	            return result === inputValue;
	          };
	          //If possible pass same object stored in $select.selected
	          if ($select.selected && checkFnSingle($select.selected)) {
	            return $select.selected;
	          }
	          for (var i = data.length - 1; i >= 0; i--) {
	            if (checkFnSingle(data[i])) return data[i];
	          }
	        }
	        return inputValue;
	      });
	
	      //Update viewValue if model change
	      scope.$watch('$select.selected', function(newValue) {
	        if (ngModel.$viewValue !== newValue) {
	          ngModel.$setViewValue(newValue);
	        }
	      });
	
	      ngModel.$render = function() {
	        $select.selected = ngModel.$viewValue;
	      };
	
	      scope.$on('uis:select', function (event, item) {
	        $select.selected = item;
	        var locals = {};
	        locals[$select.parserResult.itemName] = item;
	
	        $timeout(function() {
	          $select.onSelectCallback(scope, {
	            $item: item,
	            $model: isNil(item) ? item : $select.parserResult.modelMapper(scope, locals)
	          });
	        });
	      });
	
	      scope.$on('uis:close', function (event, skipFocusser) {
	        $timeout(function(){
	          $select.focusser.prop('disabled', false);
	          if (!skipFocusser) $select.focusser[0].focus();
	        },0,false);
	      });
	
	      scope.$on('uis:activate', function () {
	        focusser.prop('disabled', true); //Will reactivate it on .close()
	      });
	
	      //Idea from: https://github.com/ivaynberg/select2/blob/79b5bf6db918d7560bdd959109b7bcfb47edaf43/select2.js#L1954
	      var focusser = angular.element("<input ng-disabled='$select.disabled' class='ui-select-focusser ui-select-offscreen' type='text' id='{{ $select.focusserId }}' aria-label='{{ $select.focusserTitle }}' aria-haspopup='true' role='button' />");
	      $compile(focusser)(scope);
	      $select.focusser = focusser;
	
	      //Input that will handle focus
	      $select.focusInput = focusser;
	
	      element.parent().append(focusser);
	      focusser.bind("focus", function(){
	        scope.$evalAsync(function(){
	          $select.focus = true;
	        });
	      });
	      focusser.bind("blur", function(){
	        scope.$evalAsync(function(){
	          $select.focus = false;
	        });
	      });
	      focusser.bind("keydown", function(e){
	
	        if (e.which === KEY.BACKSPACE && $select.backspaceReset !== false) {
	          e.preventDefault();
	          e.stopPropagation();
	          $select.select(undefined);
	          scope.$apply();
	          return;
	        }
	
	        if (e.which === KEY.TAB || KEY.isControl(e) || KEY.isFunctionKey(e) || e.which === KEY.ESC) {
	          return;
	        }
	
	        if (e.which == KEY.DOWN  || e.which == KEY.UP || e.which == KEY.ENTER || e.which == KEY.SPACE){
	          e.preventDefault();
	          e.stopPropagation();
	          $select.activate();
	        }
	
	        scope.$digest();
	      });
	
	      focusser.bind("keyup input", function(e){
	
	        if (e.which === KEY.TAB || KEY.isControl(e) || KEY.isFunctionKey(e) || e.which === KEY.ESC || e.which == KEY.ENTER || e.which === KEY.BACKSPACE) {
	          return;
	        }
	
	        $select.activate(focusser.val()); //User pressed some regular key, so we pass it to the search input
	        focusser.val('');
	        scope.$digest();
	
	      });
	
	
	    }
	  };
	}]);
	
	// Make multiple matches sortable
	uis.directive('uiSelectSort', ['$timeout', 'uiSelectConfig', 'uiSelectMinErr', function($timeout, uiSelectConfig, uiSelectMinErr) {
	  return {
	    require: ['^^uiSelect', '^ngModel'],
	    link: function(scope, element, attrs, ctrls) {
	      if (scope[attrs.uiSelectSort] === null) {
	        throw uiSelectMinErr('sort', 'Expected a list to sort');
	      }
	
	      var $select = ctrls[0];
	      var $ngModel = ctrls[1];
	
	      var options = angular.extend({
	          axis: 'horizontal'
	        },
	        scope.$eval(attrs.uiSelectSortOptions));
	
	      var axis = options.axis;
	      var draggingClassName = 'dragging';
	      var droppingClassName = 'dropping';
	      var droppingBeforeClassName = 'dropping-before';
	      var droppingAfterClassName = 'dropping-after';
	
	      scope.$watch(function(){
	        return $select.sortable;
	      }, function(newValue){
	        if (newValue) {
	          element.attr('draggable', true);
	        } else {
	          element.removeAttr('draggable');
	        }
	      });
	
	      element.on('dragstart', function(event) {
	        element.addClass(draggingClassName);
	
	        (event.dataTransfer || event.originalEvent.dataTransfer).setData('text', scope.$index.toString());
	      });
	
	      element.on('dragend', function() {
	        removeClass(draggingClassName);
	      });
	
	      var move = function(from, to) {
	        /*jshint validthis: true */
	        this.splice(to, 0, this.splice(from, 1)[0]);
	      };
	
	      var removeClass = function(className) {
	        angular.forEach($select.$element.querySelectorAll('.' + className), function(el){
	          angular.element(el).removeClass(className);
	        });
	      };
	
	      var dragOverHandler = function(event) {
	        event.preventDefault();
	
	        var offset = axis === 'vertical' ? event.offsetY || event.layerY || (event.originalEvent ? event.originalEvent.offsetY : 0) : event.offsetX || event.layerX || (event.originalEvent ? event.originalEvent.offsetX : 0);
	
	        if (offset < (this[axis === 'vertical' ? 'offsetHeight' : 'offsetWidth'] / 2)) {
	          removeClass(droppingAfterClassName);
	          element.addClass(droppingBeforeClassName);
	
	        } else {
	          removeClass(droppingBeforeClassName);
	          element.addClass(droppingAfterClassName);
	        }
	      };
	
	      var dropTimeout;
	
	      var dropHandler = function(event) {
	        event.preventDefault();
	
	        var droppedItemIndex = parseInt((event.dataTransfer || event.originalEvent.dataTransfer).getData('text'), 10);
	
	        // prevent event firing multiple times in firefox
	        $timeout.cancel(dropTimeout);
	        dropTimeout = $timeout(function() {
	          _dropHandler(droppedItemIndex);
	        }, 20);
	      };
	
	      var _dropHandler = function(droppedItemIndex) {
	        var theList = scope.$eval(attrs.uiSelectSort);
	        var itemToMove = theList[droppedItemIndex];
	        var newIndex = null;
	
	        if (element.hasClass(droppingBeforeClassName)) {
	          if (droppedItemIndex < scope.$index) {
	            newIndex = scope.$index - 1;
	          } else {
	            newIndex = scope.$index;
	          }
	        } else {
	          if (droppedItemIndex < scope.$index) {
	            newIndex = scope.$index;
	          } else {
	            newIndex = scope.$index + 1;
	          }
	        }
	
	        move.apply(theList, [droppedItemIndex, newIndex]);
	
	        $ngModel.$setViewValue(Date.now());
	
	        scope.$apply(function() {
	          scope.$emit('uiSelectSort:change', {
	            array: theList,
	            item: itemToMove,
	            from: droppedItemIndex,
	            to: newIndex
	          });
	        });
	
	        removeClass(droppingClassName);
	        removeClass(droppingBeforeClassName);
	        removeClass(droppingAfterClassName);
	
	        element.off('drop', dropHandler);
	      };
	
	      element.on('dragenter', function() {
	        if (element.hasClass(draggingClassName)) {
	          return;
	        }
	
	        element.addClass(droppingClassName);
	
	        element.on('dragover', dragOverHandler);
	        element.on('drop', dropHandler);
	      });
	
	      element.on('dragleave', function(event) {
	        if (event.target != element) {
	          return;
	        }
	
	        removeClass(droppingClassName);
	        removeClass(droppingBeforeClassName);
	        removeClass(droppingAfterClassName);
	
	        element.off('dragover', dragOverHandler);
	        element.off('drop', dropHandler);
	      });
	    }
	  };
	}]);
	
	/**
	 * Debounces functions
	 *
	 * Taken from UI Bootstrap $$debounce source code
	 * See https://github.com/angular-ui/bootstrap/blob/master/src/debounce/debounce.js
	 *
	 */
	uis.factory('$$uisDebounce', ['$timeout', function($timeout) {
	  return function(callback, debounceTime) {
	    var timeoutPromise;
	
	    return function() {
	      var self = this;
	      var args = Array.prototype.slice.call(arguments);
	      if (timeoutPromise) {
	        $timeout.cancel(timeoutPromise);
	      }
	
	      timeoutPromise = $timeout(function() {
	        callback.apply(self, args);
	      }, debounceTime);
	    };
	  };
	}]);
	
	uis.directive('uisOpenClose', ['$parse', '$timeout', function ($parse, $timeout) {
	  return {
	    restrict: 'A',
	    require: 'uiSelect',
	    link: function (scope, element, attrs, $select) {
	      $select.onOpenCloseCallback = $parse(attrs.uisOpenClose);
	
	      scope.$watch('$select.open', function (isOpen, previousState) {
	        if (isOpen !== previousState) {
	          $timeout(function () {
	            $select.onOpenCloseCallback(scope, {
	              isOpen: isOpen
	            });
	          });
	        }
	      });
	    }
	  };
	}]);
	
	/**
	 * Parses "repeat" attribute.
	 *
	 * Taken from AngularJS ngRepeat source code
	 * See https://github.com/angular/angular.js/blob/v1.2.15/src/ng/directive/ngRepeat.js#L211
	 *
	 * Original discussion about parsing "repeat" attribute instead of fully relying on ng-repeat:
	 * https://github.com/angular-ui/ui-select/commit/5dd63ad#commitcomment-5504697
	 */
	
	uis.service('uisRepeatParser', ['uiSelectMinErr','$parse', function(uiSelectMinErr, $parse) {
	  var self = this;
	
	  /**
	   * Example:
	   * expression = "address in addresses | filter: {street: $select.search} track by $index"
	   * itemName = "address",
	   * source = "addresses | filter: {street: $select.search}",
	   * trackByExp = "$index",
	   */
	  self.parse = function(expression) {
	
	
	    var match;
	    //var isObjectCollection = /\(\s*([\$\w][\$\w]*)\s*,\s*([\$\w][\$\w]*)\s*\)/.test(expression);
	    // If an array is used as collection
	
	    // if (isObjectCollection){
	    // 000000000000000000000000000000111111111000000000000000222222222222220033333333333333333333330000444444444444444444000000000000000055555555555000000000000000000000066666666600000000
	    match = expression.match(/^\s*(?:([\s\S]+?)\s+as\s+)?(?:([\$\w][\$\w]*)|(?:\(\s*([\$\w][\$\w]*)\s*,\s*([\$\w][\$\w]*)\s*\)))\s+in\s+(\s*[\s\S]+?)?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);
	
	    // 1 Alias
	    // 2 Item
	    // 3 Key on (key,value)
	    // 4 Value on (key,value)
	    // 5 Source expression (including filters)
	    // 6 Track by
	
	    if (!match) {
	      throw uiSelectMinErr('iexp', "Expected expression in form of '_item_ in _collection_[ track by _id_]' but got '{0}'.",
	              expression);
	    }
	    
	    var source = match[5], 
	        filters = '';
	
	    // When using (key,value) ui-select requires filters to be extracted, since the object
	    // is converted to an array for $select.items 
	    // (in which case the filters need to be reapplied)
	    if (match[3]) {
	      // Remove any enclosing parenthesis
	      source = match[5].replace(/(^\()|(\)$)/g, '');
	      // match all after | but not after ||
	      var filterMatch = match[5].match(/^\s*(?:[\s\S]+?)(?:[^\|]|\|\|)+([\s\S]*)\s*$/);
	      if(filterMatch && filterMatch[1].trim()) {
	        filters = filterMatch[1];
	        source = source.replace(filters, '');
	      }      
	    }
	
	    return {
	      itemName: match[4] || match[2], // (lhs) Left-hand side,
	      keyName: match[3], //for (key, value) syntax
	      source: $parse(source),
	      filters: filters,
	      trackByExp: match[6],
	      modelMapper: $parse(match[1] || match[4] || match[2]),
	      repeatExpression: function (grouped) {
	        var expression = this.itemName + ' in ' + (grouped ? '$group.items' : '$select.items');
	        if (this.trackByExp) {
	          expression += ' track by ' + this.trackByExp;
	        }
	        return expression;
	      } 
	    };
	
	  };
	
	  self.getGroupNgRepeatExpression = function() {
	    return '$group in $select.groups track by $group.name';
	  };
	
	}]);
	
	}());
	angular.module("ui.select").run(["$templateCache", function($templateCache) {$templateCache.put("bootstrap/choices.tpl.html","<ul class=\"ui-select-choices ui-select-choices-content ui-select-dropdown dropdown-menu\" ng-show=\"$select.open && $select.items.length > 0\"><li class=\"ui-select-choices-group\" id=\"ui-select-choices-{{ $select.generatedId }}\"><div class=\"divider\" ng-show=\"$select.isGrouped && $index > 0\"></div><div ng-show=\"$select.isGrouped\" class=\"ui-select-choices-group-label dropdown-header\" ng-bind=\"$group.name\"></div><div ng-attr-id=\"ui-select-choices-row-{{ $select.generatedId }}-{{$index}}\" class=\"ui-select-choices-row\" ng-class=\"{active: $select.isActive(this), disabled: $select.isDisabled(this)}\" role=\"option\"><span class=\"ui-select-choices-row-inner\"></span></div></li></ul>");
	$templateCache.put("bootstrap/match-multiple.tpl.html","<span class=\"ui-select-match\"><span ng-repeat=\"$item in $select.selected track by $index\"><span class=\"ui-select-match-item btn btn-default btn-xs\" tabindex=\"-1\" type=\"button\" ng-disabled=\"$select.disabled\" ng-click=\"$selectMultiple.activeMatchIndex = $index;\" ng-class=\"{\'btn-primary\':$selectMultiple.activeMatchIndex === $index, \'select-locked\':$select.isLocked(this, $index)}\" ui-select-sort=\"$select.selected\"><span class=\"close ui-select-match-close\" ng-hide=\"$select.disabled\" ng-click=\"$selectMultiple.removeChoice($index)\">&nbsp;&times;</span> <span uis-transclude-append=\"\"></span></span></span></span>");
	$templateCache.put("bootstrap/match.tpl.html","<div class=\"ui-select-match\" ng-hide=\"$select.open && $select.searchEnabled\" ng-disabled=\"$select.disabled\" ng-class=\"{\'btn-default-focus\':$select.focus}\"><span tabindex=\"-1\" class=\"btn btn-default form-control ui-select-toggle\" aria-label=\"{{ $select.baseTitle }} activate\" ng-disabled=\"$select.disabled\" ng-click=\"$select.activate()\" style=\"outline: 0;\"><span ng-show=\"$select.isEmpty()\" class=\"ui-select-placeholder text-muted\">{{$select.placeholder}}</span> <span ng-hide=\"$select.isEmpty()\" class=\"ui-select-match-text pull-left\" ng-class=\"{\'ui-select-allow-clear\': $select.allowClear && !$select.isEmpty()}\" ng-transclude=\"\"></span> <i class=\"caret pull-right\" ng-click=\"$select.toggle($event)\"></i> <a ng-show=\"$select.allowClear && !$select.isEmpty() && ($select.disabled !== true)\" aria-label=\"{{ $select.baseTitle }} clear\" style=\"margin-right: 10px\" ng-click=\"$select.clear($event)\" class=\"btn btn-xs btn-link pull-right\"><i class=\"glyphicon glyphicon-remove\" aria-hidden=\"true\"></i></a></span></div>");
	$templateCache.put("bootstrap/no-choice.tpl.html","<ul class=\"ui-select-no-choice dropdown-menu\" ng-show=\"$select.items.length == 0\"><li ng-transclude=\"\"></li></ul>");
	$templateCache.put("bootstrap/select-multiple.tpl.html","<div class=\"ui-select-container ui-select-multiple ui-select-bootstrap dropdown form-control\" ng-class=\"{open: $select.open}\"><div><div class=\"ui-select-match\"></div><input type=\"search\" autocomplete=\"off\" autocorrect=\"off\" autocapitalize=\"off\" spellcheck=\"false\" class=\"ui-select-search input-xs\" placeholder=\"{{$selectMultiple.getPlaceholder()}}\" ng-disabled=\"$select.disabled\" ng-click=\"$select.activate()\" ng-model=\"$select.search\" role=\"combobox\" aria-expanded=\"{{$select.open}}\" aria-label=\"{{$select.baseTitle}}\" ng-class=\"{\'spinner\': $select.refreshing}\" ondrop=\"return false;\"></div><div class=\"ui-select-choices\"></div><div class=\"ui-select-no-choice\"></div></div>");
	$templateCache.put("bootstrap/select.tpl.html","<div class=\"ui-select-container ui-select-bootstrap dropdown\" ng-class=\"{open: $select.open}\"><div class=\"ui-select-match\"></div><span ng-show=\"$select.open && $select.refreshing && $select.spinnerEnabled\" class=\"ui-select-refreshing {{$select.spinnerClass}}\"></span> <input type=\"search\" autocomplete=\"off\" tabindex=\"-1\" aria-expanded=\"true\" aria-label=\"{{ $select.baseTitle }}\" aria-owns=\"ui-select-choices-{{ $select.generatedId }}\" class=\"form-control ui-select-search\" ng-class=\"{ \'ui-select-search-hidden\' : !$select.searchEnabled }\" placeholder=\"{{$select.placeholder}}\" ng-model=\"$select.search\" ng-show=\"$select.open\"><div class=\"ui-select-choices\"></div><div class=\"ui-select-no-choice\"></div></div>");
	$templateCache.put("select2/choices.tpl.html","<ul tabindex=\"-1\" class=\"ui-select-choices ui-select-choices-content select2-results\"><li class=\"ui-select-choices-group\" ng-class=\"{\'select2-result-with-children\': $select.choiceGrouped($group) }\"><div ng-show=\"$select.choiceGrouped($group)\" class=\"ui-select-choices-group-label select2-result-label\" ng-bind=\"$group.name\"></div><ul id=\"ui-select-choices-{{ $select.generatedId }}\" ng-class=\"{\'select2-result-sub\': $select.choiceGrouped($group), \'select2-result-single\': !$select.choiceGrouped($group) }\"><li role=\"option\" ng-attr-id=\"ui-select-choices-row-{{ $select.generatedId }}-{{$index}}\" class=\"ui-select-choices-row\" ng-class=\"{\'select2-highlighted\': $select.isActive(this), \'select2-disabled\': $select.isDisabled(this)}\"><div class=\"select2-result-label ui-select-choices-row-inner\"></div></li></ul></li></ul>");
	$templateCache.put("select2/match-multiple.tpl.html","<span class=\"ui-select-match\"><li class=\"ui-select-match-item select2-search-choice\" ng-repeat=\"$item in $select.selected track by $index\" ng-class=\"{\'select2-search-choice-focus\':$selectMultiple.activeMatchIndex === $index, \'select2-locked\':$select.isLocked(this, $index)}\" ui-select-sort=\"$select.selected\"><span uis-transclude-append=\"\"></span> <a href=\"javascript:;\" class=\"ui-select-match-close select2-search-choice-close\" ng-click=\"$selectMultiple.removeChoice($index)\" tabindex=\"-1\"></a></li></span>");
	$templateCache.put("select2/match.tpl.html","<a class=\"select2-choice ui-select-match\" ng-class=\"{\'select2-default\': $select.isEmpty()}\" ng-click=\"$select.toggle($event)\" aria-label=\"{{ $select.baseTitle }} select\"><span ng-show=\"$select.isEmpty()\" class=\"select2-chosen\">{{$select.placeholder}}</span> <span ng-hide=\"$select.isEmpty()\" class=\"select2-chosen\" ng-transclude=\"\"></span> <abbr ng-if=\"$select.allowClear && !$select.isEmpty()\" class=\"select2-search-choice-close\" ng-click=\"$select.clear($event)\"></abbr> <span class=\"select2-arrow ui-select-toggle\"><b></b></span></a>");
	$templateCache.put("select2/no-choice.tpl.html","<div class=\"ui-select-no-choice dropdown\" ng-show=\"$select.items.length == 0\"><div class=\"dropdown-content\"><div data-selectable=\"\" ng-transclude=\"\"></div></div></div>");
	$templateCache.put("select2/select-multiple.tpl.html","<div class=\"ui-select-container ui-select-multiple select2 select2-container select2-container-multi\" ng-class=\"{\'select2-container-active select2-dropdown-open open\': $select.open, \'select2-container-disabled\': $select.disabled}\"><ul class=\"select2-choices\"><span class=\"ui-select-match\"></span><li class=\"select2-search-field\"><input type=\"search\" autocomplete=\"off\" autocorrect=\"off\" autocapitalize=\"off\" spellcheck=\"false\" role=\"combobox\" aria-expanded=\"true\" aria-owns=\"ui-select-choices-{{ $select.generatedId }}\" aria-label=\"{{ $select.baseTitle }}\" aria-activedescendant=\"ui-select-choices-row-{{ $select.generatedId }}-{{ $select.activeIndex }}\" class=\"select2-input ui-select-search\" placeholder=\"{{$selectMultiple.getPlaceholder()}}\" ng-disabled=\"$select.disabled\" ng-hide=\"$select.disabled\" ng-model=\"$select.search\" ng-click=\"$select.activate()\" style=\"width: 34px;\" ondrop=\"return false;\"></li></ul><div class=\"ui-select-dropdown select2-drop select2-with-searchbox select2-drop-active\" ng-class=\"{\'select2-display-none\': !$select.open || $select.items.length === 0}\"><div class=\"ui-select-choices\"></div></div></div>");
	$templateCache.put("select2/select.tpl.html","<div class=\"ui-select-container select2 select2-container\" ng-class=\"{\'select2-container-active select2-dropdown-open open\': $select.open, \'select2-container-disabled\': $select.disabled, \'select2-container-active\': $select.focus, \'select2-allowclear\': $select.allowClear && !$select.isEmpty()}\"><div class=\"ui-select-match\"></div><div class=\"ui-select-dropdown select2-drop select2-with-searchbox select2-drop-active\" ng-class=\"{\'select2-display-none\': !$select.open}\"><div class=\"search-container\" ng-class=\"{\'ui-select-search-hidden\':!$select.searchEnabled, \'select2-search\':$select.searchEnabled}\"><input type=\"search\" autocomplete=\"off\" autocorrect=\"off\" autocapitalize=\"off\" spellcheck=\"false\" ng-class=\"{\'select2-active\': $select.refreshing}\" role=\"combobox\" aria-expanded=\"true\" aria-owns=\"ui-select-choices-{{ $select.generatedId }}\" aria-label=\"{{ $select.baseTitle }}\" class=\"ui-select-search select2-input\" ng-model=\"$select.search\"></div><div class=\"ui-select-choices\"></div><div class=\"ui-select-no-choice\"></div></div></div>");
	$templateCache.put("selectize/choices.tpl.html","<div ng-show=\"$select.open\" class=\"ui-select-choices ui-select-dropdown selectize-dropdown\" ng-class=\"{\'single\': !$select.multiple, \'multi\': $select.multiple}\"><div class=\"ui-select-choices-content selectize-dropdown-content\"><div class=\"ui-select-choices-group optgroup\"><div ng-show=\"$select.isGrouped\" class=\"ui-select-choices-group-label optgroup-header\" ng-bind=\"$group.name\"></div><div role=\"option\" class=\"ui-select-choices-row\" ng-class=\"{active: $select.isActive(this), disabled: $select.isDisabled(this)}\"><div class=\"option ui-select-choices-row-inner\" data-selectable=\"\"></div></div></div></div></div>");
	$templateCache.put("selectize/match-multiple.tpl.html","<div class=\"ui-select-match\" data-value=\"\" ng-repeat=\"$item in $select.selected track by $index\" ng-click=\"$selectMultiple.activeMatchIndex = $index;\" ng-class=\"{\'active\':$selectMultiple.activeMatchIndex === $index}\" ui-select-sort=\"$select.selected\"><span class=\"ui-select-match-item\" ng-class=\"{\'select-locked\':$select.isLocked(this, $index)}\"><span uis-transclude-append=\"\"></span> <span class=\"remove ui-select-match-close\" ng-hide=\"$select.disabled\" ng-click=\"$selectMultiple.removeChoice($index)\">&times;</span></span></div>");
	$templateCache.put("selectize/match.tpl.html","<div ng-hide=\"$select.searchEnabled && ($select.open || $select.isEmpty())\" class=\"ui-select-match\"><span ng-show=\"!$select.searchEnabled && ($select.isEmpty() || $select.open)\" class=\"ui-select-placeholder text-muted\">{{$select.placeholder}}</span> <span ng-hide=\"$select.isEmpty() || $select.open\" ng-transclude=\"\"></span></div>");
	$templateCache.put("selectize/no-choice.tpl.html","<div class=\"ui-select-no-choice selectize-dropdown\" ng-show=\"$select.items.length == 0\"><div class=\"selectize-dropdown-content\"><div data-selectable=\"\" ng-transclude=\"\"></div></div></div>");
	$templateCache.put("selectize/select-multiple.tpl.html","<div class=\"ui-select-container selectize-control multi plugin-remove_button\" ng-class=\"{\'open\': $select.open}\"><div class=\"selectize-input\" ng-class=\"{\'focus\': $select.open, \'disabled\': $select.disabled, \'selectize-focus\' : $select.focus}\" ng-click=\"$select.open && !$select.searchEnabled ? $select.toggle($event) : $select.activate()\"><div class=\"ui-select-match\"></div><input type=\"search\" autocomplete=\"off\" tabindex=\"-1\" class=\"ui-select-search\" ng-class=\"{\'ui-select-search-hidden\':!$select.searchEnabled}\" placeholder=\"{{$selectMultiple.getPlaceholder()}}\" ng-model=\"$select.search\" ng-disabled=\"$select.disabled\" aria-expanded=\"{{$select.open}}\" aria-label=\"{{ $select.baseTitle }}\" ondrop=\"return false;\"></div><div class=\"ui-select-choices\"></div><div class=\"ui-select-no-choice\"></div></div>");
	$templateCache.put("selectize/select.tpl.html","<div class=\"ui-select-container selectize-control single\" ng-class=\"{\'open\': $select.open}\"><div class=\"selectize-input\" ng-class=\"{\'focus\': $select.open, \'disabled\': $select.disabled, \'selectize-focus\' : $select.focus}\" ng-click=\"$select.open && !$select.searchEnabled ? $select.toggle($event) : $select.activate()\"><div class=\"ui-select-match\"></div><input type=\"search\" autocomplete=\"off\" tabindex=\"-1\" class=\"ui-select-search ui-select-toggle\" ng-class=\"{\'ui-select-search-hidden\':!$select.searchEnabled}\" ng-click=\"$select.toggle($event)\" placeholder=\"{{$select.placeholder}}\" ng-model=\"$select.search\" ng-hide=\"!$select.isEmpty() && !$select.open\" ng-disabled=\"$select.disabled\" aria-label=\"{{ $select.baseTitle }}\"></div><div class=\"ui-select-choices\"></div><div class=\"ui-select-no-choice\"></div></div>");}]);

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(677);
	module.exports = 'ui.select';


/***/ }),
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	__webpack_require__(25);
	module.exports = __webpack_require__(__webpack_module_template_argument_0__);

/***/ })
/******/ ])));


// WEBPACK FOOTER //
// app.451f0127094d5782fb0b.js